/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1996);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeComponent;
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  scriptExports = scriptExports || {}

  // ES6 modules interop
  var type = typeof scriptExports.default
  if (type === 'object' || type === 'function') {
    scriptExports = scriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(646);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addStylesClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listToStyles__ = __webpack_require__(1982);
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__listToStyles__["a" /* default */])(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__listToStyles__["a" /* default */])(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select2_vue__ = __webpack_require__(440);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8426be_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select2_vue__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1934)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a8426be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8426be_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select2_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a8426be_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select2_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "sit" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "sit" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (true) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if ("sit" !== 'production' && !config.async) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if ("sit" !== 'production' && customSetter) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if ("sit" !== 'production' &&
    (isUndef(target) || isPrimitive(target))
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "sit" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if ("sit" !== 'production' &&
    (isUndef(target) || isPrimitive(target))
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "sit" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (true) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "sit" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "sit" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (true) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "sit" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (true) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (true) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (true) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (true) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if ("sit" !== 'production' && warnMissing && !res) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    true
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if ("sit" !== 'production' && isObject(def)) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (true) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (true) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (true) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "sit" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (true) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (true) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (true) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if ("sit" !== 'production' && !isObject(bindObject)) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "sit" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "sit" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if ("sit" !== 'production' && key !== '' && key !== null) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (true) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (true) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "sit" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if ("sit" !== 'production' &&
    isDef(data) && isDef(data.key) && !isPrimitive(data.key)
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (true) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if ("sit" !== 'production' && vm.$options.renderError) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if ("sit" !== 'production' && Array.isArray(vnode)) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "sit" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 true
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (true) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (true) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if ("sit" !== 'production' && config.performance && mark) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (true) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (true) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (true) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if ("sit" !== 'production' && has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if ("sit" !== 'production' && !config.async) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  true
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "sit" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (true) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "sit" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (true) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "sit" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if ("sit" !== 'production' && getter == null) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (true) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if ("sit" !== 'production' &&
      sharedPropertyDefinition.set === noop) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (true) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (true) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if ("sit" !== 'production' && config.performance && mark) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (true) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if ("sit" !== 'production' && config.performance && mark) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if ("sit" !== 'production' &&
    !(this instanceof Vue)
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if ("sit" !== 'production' && name) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if ("sit" !== 'production' && type === 'component') {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (true) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "sit" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (true) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if ("sit" !== 'production' && data && data.pre) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (true) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (true) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (true) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (true) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if ("sit" !== 'production' &&
                typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if ("sit" !== 'production' &&
                typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (true) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    "sit" !== 'production' && warn &&
    modifiers.prevent && modifiers.passive
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (true) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (true) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (true) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if ("sit" !== 'production' && explicitEnterDuration != null) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if ("sit" !== 'production' && isDef(explicitLeaveDuration)) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "sit" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if ("sit" !== 'production' && children.length > 1) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if ("sit" !== 'production' &&
      mode && mode !== 'in-out' && mode !== 'out-in'
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (true) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        true
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if ("sit" !== 'production' &&
      "sit" !== 'test' &&
      config.productionTip !== false &&
      typeof console !== 'undefined'
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if ("sit" !== 'production' && staticClass) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (true) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if ("sit" !== 'production' && !stack.length && options.warn) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if ("sit" !== 'production' && options.outputSourceRange) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if ("sit" !== 'production' &&
          (i > pos || !tagName) &&
          options.warn
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (true) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (true) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (true) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "sit" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (true) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if ("sit" !== 'production' && options.outputSourceRange) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (true) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if ("sit" !== 'production' && options.outputSourceRange) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if ("sit" !== 'production' && options.outputSourceRange) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (true) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (true) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (true) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if ("sit" !== 'production' && children[i].text !== ' ') {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if ("sit" !== 'production' && slotScope) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if ("sit" !== 'production' && el.attrsMap['v-for']) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (true) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (true) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (true) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if ("sit" !== 'production' && el.key) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          "sit" !== 'production' &&
          value.trim().length === 0
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if ("sit" !== 'production' && name === 'model') {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (true) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      "sit" !== 'production' &&
      map[attrs[i].name] && !isIE && !isEdge
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if ("sit" !== 'production' && dir.modifiers) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "sit" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if ("sit" !== 'production' &&
    state.maybeComponent(el) &&
    el.tag !== 'slot' &&
    el.tag !== 'template' &&
    !el.key
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if ("sit" !== 'production' && (
    el.children.length !== 1 || ast.type !== 1
  )) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (true) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (true) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (true) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if ("sit" !== 'production' && options.outputSourceRange) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (true) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "sit" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if ("sit" !== 'production' && !template) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (true) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if ("sit" !== 'production' && config.performance && mark) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "sit" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if ("sit" !== 'production' && config.performance && mark) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(80), __webpack_require__(1154).setImmediate))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-treeselect v0.4.0 | (c) 2017-2019 Riophae Lee
 * Released under the MIT License.
 * https://vue-treeselect.js.org/
 */
module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 16);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(643);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(644);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(638);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1131);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1145);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1140);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1995);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1133);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1147);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1141);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1139);

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(645);

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1144);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(661);

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(5);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "@babel/runtime/helpers/slicedToArray"
var slicedToArray_ = __webpack_require__(0);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/toConsumableArray"
var toConsumableArray_ = __webpack_require__(1);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(2);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "fuzzysearch"
var external_fuzzysearch_ = __webpack_require__(3);
var external_fuzzysearch_default = /*#__PURE__*/__webpack_require__.n(external_fuzzysearch_);

// EXTERNAL MODULE: external "lodash/noop"
var noop_ = __webpack_require__(4);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop_);

// CONCATENATED MODULE: ./src/utils/noop.js

// CONCATENATED MODULE: ./src/utils/warning.js


var warning_warning =  false ? noop_default.a : function warning(checker, complainer) {
  if (!checker()) {
    var _console;

    var message = ['[Vue-Treeselect Warning]'].concat(complainer());

    (_console = console).error.apply(_console, toConsumableArray_default()(message));
  }
};
// CONCATENATED MODULE: ./src/utils/onLeftClick.js
function onLeftClick(mouseDownHandler) {
  return function onMouseDown(evt) {
    if (evt.type === 'mousedown' && evt.button === 0) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      mouseDownHandler.call.apply(mouseDownHandler, [this, evt].concat(args));
    }
  };
}
// CONCATENATED MODULE: ./src/utils/scrollIntoView.js
function scrollIntoView($scrollingEl, $focusedEl) {
  var scrollingReact = $scrollingEl.getBoundingClientRect();
  var focusedRect = $focusedEl.getBoundingClientRect();
  var overScroll = $focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > scrollingReact.bottom) {
    $scrollingEl.scrollTop = Math.min($focusedEl.offsetTop + $focusedEl.clientHeight - $scrollingEl.offsetHeight + overScroll, $scrollingEl.scrollHeight);
  } else if (focusedRect.top - overScroll < scrollingReact.top) {
    $scrollingEl.scrollTop = Math.max($focusedEl.offsetTop - overScroll, 0);
  }
}
// EXTERNAL MODULE: external "lodash/debounce"
var debounce_ = __webpack_require__(5);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

// CONCATENATED MODULE: ./src/utils/debounce.js

// EXTERNAL MODULE: external "watch-size"
var external_watch_size_ = __webpack_require__(6);
var external_watch_size_default = /*#__PURE__*/__webpack_require__.n(external_watch_size_);

// CONCATENATED MODULE: ./src/utils/removeFromArray.js
function removeFromArray(arr, elem) {
  var idx = arr.indexOf(elem);
  if (idx !== -1) arr.splice(idx, 1);
}
// CONCATENATED MODULE: ./src/utils/watchSize.js


var intervalId;
var registered = [];
var INTERVAL_DURATION = 100;

function run() {
  intervalId = setInterval(function () {
    registered.forEach(test);
  }, INTERVAL_DURATION);
}

function stop() {
  clearInterval(intervalId);
  intervalId = null;
}

function test(item) {
  var $el = item.$el,
      listener = item.listener,
      lastWidth = item.lastWidth,
      lastHeight = item.lastHeight;
  var width = $el.offsetWidth;
  var height = $el.offsetHeight;

  if (lastWidth !== width || lastHeight !== height) {
    item.lastWidth = width;
    item.lastHeight = height;
    listener({
      width: width,
      height: height
    });
  }
}

function watchSizeForIE9($el, listener) {
  var item = {
    $el: $el,
    listener: listener,
    lastWidth: null,
    lastHeight: null
  };

  var unwatch = function unwatch() {
    removeFromArray(registered, item);
    if (!registered.length) stop();
  };

  registered.push(item);
  test(item);
  run();
  return unwatch;
}

function watchSize($el, listener) {
  var isIE9 = document.documentMode === 9;
  var locked = true;

  var wrappedListener = function wrappedListener() {
    return locked || listener.apply(void 0, arguments);
  };

  var implementation = isIE9 ? watchSizeForIE9 : external_watch_size_default.a;
  var removeSizeWatcher = implementation($el, wrappedListener);
  locked = false;
  return removeSizeWatcher;
}
// CONCATENATED MODULE: ./src/utils/setupResizeAndScrollEventListeners.js
function findScrollParents($el) {
  var $scrollParents = [];
  var $parent = $el.parentNode;

  while ($parent && $parent.nodeName !== 'BODY' && $parent.nodeType === document.ELEMENT_NODE) {
    if (isScrollElment($parent)) $scrollParents.push($parent);
    $parent = $parent.parentNode;
  }

  $scrollParents.push(window);
  return $scrollParents;
}

function isScrollElment($el) {
  var _getComputedStyle = getComputedStyle($el),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /(auto|scroll|overlay)/.test(overflow + overflowY + overflowX);
}

function setupResizeAndScrollEventListeners($el, listener) {
  var $scrollParents = findScrollParents($el);
  window.addEventListener('resize', listener, {
    passive: true
  });
  $scrollParents.forEach(function (scrollParent) {
    scrollParent.addEventListener('scroll', listener, {
      passive: true
    });
  });
  return function removeEventListeners() {
    window.removeEventListener('resize', listener, {
      passive: true
    });
    $scrollParents.forEach(function ($scrollParent) {
      $scrollParent.removeEventListener('scroll', listener, {
        passive: true
      });
    });
  };
}
// CONCATENATED MODULE: ./src/utils/isNaN.js
function isNaN_isNaN(x) {
  return x !== x;
}
// EXTERNAL MODULE: external "is-promise"
var external_is_promise_ = __webpack_require__(7);
var external_is_promise_default = /*#__PURE__*/__webpack_require__.n(external_is_promise_);

// CONCATENATED MODULE: ./src/utils/isPromise.js

// EXTERNAL MODULE: external "lodash/once"
var once_ = __webpack_require__(8);
var once_default = /*#__PURE__*/__webpack_require__.n(once_);

// CONCATENATED MODULE: ./src/utils/once.js

// EXTERNAL MODULE: external "lodash/identity"
var identity_ = __webpack_require__(9);
var identity_default = /*#__PURE__*/__webpack_require__.n(identity_);

// CONCATENATED MODULE: ./src/utils/identity.js

// EXTERNAL MODULE: external "lodash/constant"
var constant_ = __webpack_require__(10);
var constant_default = /*#__PURE__*/__webpack_require__.n(constant_);

// CONCATENATED MODULE: ./src/utils/constant.js

// CONCATENATED MODULE: ./src/utils/createMap.js
var createMap = function createMap() {
  return Object.create(null);
};
// EXTERNAL MODULE: external "@babel/runtime/helpers/typeof"
var typeof_ = __webpack_require__(11);
var typeof_default = /*#__PURE__*/__webpack_require__.n(typeof_);

// CONCATENATED MODULE: ./src/utils/deepExtend.js


function isPlainObject(value) {
  if (value == null || typeof_default()(value) !== 'object') return false;
  return Object.getPrototypeOf(value) === Object.prototype;
}

function copy(obj, key, value) {
  if (isPlainObject(value)) {
    obj[key] || (obj[key] = {});
    deepExtend(obj[key], value);
  } else {
    obj[key] = value;
  }
}

function deepExtend(target, source) {
  if (isPlainObject(source)) {
    var keys = Object.keys(source);

    for (var i = 0, len = keys.length; i < len; i++) {
      copy(target, keys[i], source[keys[i]]);
    }
  }

  return target;
}
// EXTERNAL MODULE: external "lodash/last"
var last_ = __webpack_require__(12);
var last_default = /*#__PURE__*/__webpack_require__.n(last_);

// CONCATENATED MODULE: ./src/utils/last.js

// CONCATENATED MODULE: ./src/utils/includes.js
function includes(arrOrStr, elem) {
  return arrOrStr.indexOf(elem) !== -1;
}
// CONCATENATED MODULE: ./src/utils/find.js
function find(arr, predicate, ctx) {
  for (var i = 0, len = arr.length; i < len; i++) {
    if (predicate.call(ctx, arr[i], i, arr)) return arr[i];
  }

  return undefined;
}
// CONCATENATED MODULE: ./src/utils/quickDiff.js
function quickDiff(arrA, arrB) {
  if (arrA.length !== arrB.length) return true;

  for (var i = 0; i < arrA.length; i++) {
    if (arrA[i] !== arrB[i]) return true;
  }

  return false;
}
// CONCATENATED MODULE: ./src/utils/index.js



















// CONCATENATED MODULE: ./src/constants.js
var NO_PARENT_NODE = null;
var UNCHECKED = 0;
var INDETERMINATE = 1;
var CHECKED = 2;
var ALL_CHILDREN = 'ALL_CHILDREN';
var ALL_DESCENDANTS = 'ALL_DESCENDANTS';
var LEAF_CHILDREN = 'LEAF_CHILDREN';
var LEAF_DESCENDANTS = 'LEAF_DESCENDANTS';
var LOAD_ROOT_OPTIONS = 'LOAD_ROOT_OPTIONS';
var LOAD_CHILDREN_OPTIONS = 'LOAD_CHILDREN_OPTIONS';
var ASYNC_SEARCH = 'ASYNC_SEARCH';
var ALL = 'ALL';
var BRANCH_PRIORITY = 'BRANCH_PRIORITY';
var LEAF_PRIORITY = 'LEAF_PRIORITY';
var ALL_WITH_INDETERMINATE = 'ALL_WITH_INDETERMINATE';
var ORDER_SELECTED = 'ORDER_SELECTED';
var LEVEL = 'LEVEL';
var INDEX = 'INDEX';
var KEY_CODES = {
  BACKSPACE: 8,
  ENTER: 13,
  ESCAPE: 27,
  END: 35,
  HOME: 36,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  DELETE: 46
};
var INPUT_DEBOUNCE_DELAY =  false ? 10 : 200;
var MIN_INPUT_WIDTH = 5;
var MENU_BUFFER = 40;
// CONCATENATED MODULE: ./src/mixins/treeselectMixin.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function sortValueByIndex(a, b) {
  var i = 0;

  do {
    if (a.level < i) return -1;
    if (b.level < i) return 1;
    if (a.index[i] !== b.index[i]) return a.index[i] - b.index[i];
    i++;
  } while (true);
}

function sortValueByLevel(a, b) {
  return a.level === b.level ? sortValueByIndex(a, b) : a.level - b.level;
}

function createAsyncOptionsStates() {
  return {
    isLoaded: false,
    isLoading: false,
    loadingError: ''
  };
}

function stringifyOptionPropValue(value) {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' && !isNaN_isNaN(value)) return value + '';
  return '';
}

function match(enableFuzzyMatch, needle, haystack) {
  return enableFuzzyMatch ? external_fuzzysearch_default()(needle, haystack) : includes(haystack, needle);
}

function getErrorMessage(err) {
  return err.message || String(err);
}

var instanceId = 0;
/* harmony default export */ var treeselectMixin = ({
  provide: function provide() {
    return {
      instance: this
    };
  },
  props: {
    allowClearingDisabled: {
      type: Boolean,
      default: false
    },
    allowSelectingDisabledDescendants: {
      type: Boolean,
      default: false
    },
    alwaysOpen: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    async: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    autoLoadRootOptions: {
      type: Boolean,
      default: true
    },
    autoDeselectAncestors: {
      type: Boolean,
      default: false
    },
    autoDeselectDescendants: {
      type: Boolean,
      default: false
    },
    autoSelectAncestors: {
      type: Boolean,
      default: false
    },
    autoSelectDescendants: {
      type: Boolean,
      default: false
    },
    backspaceRemoves: {
      type: Boolean,
      default: true
    },
    beforeClearAll: {
      type: Function,
      default: constant_default()(true)
    },
    branchNodesFirst: {
      type: Boolean,
      default: false
    },
    cacheOptions: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    clearAllText: {
      type: String,
      default: 'Clear all'
    },
    clearOnSelect: {
      type: Boolean,
      default: false
    },
    clearValueText: {
      type: String,
      default: 'Clear value'
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    defaultExpandLevel: {
      type: Number,
      default: 0
    },
    defaultOptions: {
      default: false
    },
    deleteRemoves: {
      type: Boolean,
      default: true
    },
    delimiter: {
      type: String,
      default: ','
    },
    flattenSearchResults: {
      type: Boolean,
      default: false
    },
    disableBranchNodes: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableFuzzyMatching: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    instanceId: {
      default: function _default() {
        return "".concat(instanceId++, "$$");
      },
      type: [String, Number]
    },
    joinValues: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: Infinity
    },
    limitText: {
      type: Function,
      default: function limitTextDefault(count) {
        return "and ".concat(count, " more");
      }
    },
    loadingText: {
      type: String,
      default: 'Loading...'
    },
    loadOptions: {
      type: Function
    },
    matchKeys: {
      type: Array,
      default: constant_default()(['label'])
    },
    maxHeight: {
      type: Number,
      default: 300
    },
    multiple: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    noChildrenText: {
      type: String,
      default: 'No sub-options.'
    },
    noOptionsText: {
      type: String,
      default: 'No options available.'
    },
    noResultsText: {
      type: String,
      default: 'No results found...'
    },
    normalizer: {
      type: Function,
      default: identity_default.a
    },
    openDirection: {
      type: String,
      default: 'auto',
      validator: function validator(value) {
        var acceptableValues = ['auto', 'top', 'bottom', 'above', 'below'];
        return includes(acceptableValues, value);
      }
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnFocus: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array
    },
    placeholder: {
      type: String,
      default: 'Select...'
    },
    required: {
      type: Boolean,
      default: false
    },
    retryText: {
      type: String,
      default: 'Retry?'
    },
    retryTitle: {
      type: String,
      default: 'Click to retry'
    },
    searchable: {
      type: Boolean,
      default: true
    },
    searchNested: {
      type: Boolean,
      default: false
    },
    searchPromptText: {
      type: String,
      default: 'Type to search...'
    },
    showCount: {
      type: Boolean,
      default: false
    },
    showCountOf: {
      type: String,
      default: ALL_CHILDREN,
      validator: function validator(value) {
        var acceptableValues = [ALL_CHILDREN, ALL_DESCENDANTS, LEAF_CHILDREN, LEAF_DESCENDANTS];
        return includes(acceptableValues, value);
      }
    },
    showCountOnSearch: null,
    sortValueBy: {
      type: String,
      default: ORDER_SELECTED,
      validator: function validator(value) {
        var acceptableValues = [ORDER_SELECTED, LEVEL, INDEX];
        return includes(acceptableValues, value);
      }
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    value: null,
    valueConsistsOf: {
      type: String,
      default: BRANCH_PRIORITY,
      validator: function validator(value) {
        var acceptableValues = [ALL, BRANCH_PRIORITY, LEAF_PRIORITY, ALL_WITH_INDETERMINATE];
        return includes(acceptableValues, value);
      }
    },
    valueFormat: {
      type: String,
      default: 'id'
    },
    zIndex: {
      type: [Number, String],
      default: 999
    }
  },
  data: function data() {
    return {
      trigger: {
        isFocused: false,
        searchQuery: ''
      },
      menu: {
        isOpen: false,
        current: null,
        lastScrollPosition: 0,
        placement: 'bottom'
      },
      forest: {
        normalizedOptions: [],
        nodeMap: createMap(),
        checkedStateMap: createMap(),
        selectedNodeIds: this.extractCheckedNodeIdsFromValue(),
        selectedNodeMap: createMap()
      },
      rootOptionsStates: createAsyncOptionsStates(),
      localSearch: {
        active: false,
        noResults: true,
        countMap: createMap()
      },
      remoteSearch: createMap()
    };
  },
  computed: {
    selectedNodes: function selectedNodes() {
      return this.forest.selectedNodeIds.map(this.getNode);
    },
    internalValue: function internalValue() {
      var _this = this;

      var internalValue;

      if (this.single || this.flat || this.disableBranchNodes || this.valueConsistsOf === ALL) {
        internalValue = this.forest.selectedNodeIds.slice();
      } else if (this.valueConsistsOf === BRANCH_PRIORITY) {
        internalValue = this.forest.selectedNodeIds.filter(function (id) {
          var node = _this.getNode(id);

          if (node.isRootNode) return true;
          return !_this.isSelected(node.parentNode);
        });
      } else if (this.valueConsistsOf === LEAF_PRIORITY) {
        internalValue = this.forest.selectedNodeIds.filter(function (id) {
          var node = _this.getNode(id);

          if (node.isLeaf) return true;
          return node.children.length === 0;
        });
      } else if (this.valueConsistsOf === ALL_WITH_INDETERMINATE) {
        var _internalValue;

        var indeterminateNodeIds = [];
        internalValue = this.forest.selectedNodeIds.slice();
        this.selectedNodes.forEach(function (selectedNode) {
          selectedNode.ancestors.forEach(function (ancestor) {
            if (includes(indeterminateNodeIds, ancestor.id)) return;
            if (includes(internalValue, ancestor.id)) return;
            indeterminateNodeIds.push(ancestor.id);
          });
        });

        (_internalValue = internalValue).push.apply(_internalValue, indeterminateNodeIds);
      }

      if (this.sortValueBy === LEVEL) {
        internalValue.sort(function (a, b) {
          return sortValueByLevel(_this.getNode(a), _this.getNode(b));
        });
      } else if (this.sortValueBy === INDEX) {
        internalValue.sort(function (a, b) {
          return sortValueByIndex(_this.getNode(a), _this.getNode(b));
        });
      }

      return internalValue;
    },
    hasValue: function hasValue() {
      return this.internalValue.length > 0;
    },
    single: function single() {
      return !this.multiple;
    },
    visibleOptionIds: function visibleOptionIds() {
      var _this2 = this;

      var visibleOptionIds = [];
      this.traverseAllNodesByIndex(function (node) {
        if (!_this2.localSearch.active || _this2.shouldOptionBeIncludedInSearchResult(node)) {
          visibleOptionIds.push(node.id);
        }

        if (node.isBranch && !_this2.shouldExpand(node)) {
          return false;
        }
      });
      return visibleOptionIds;
    },
    hasVisibleOptions: function hasVisibleOptions() {
      return this.visibleOptionIds.length !== 0;
    },
    showCountOnSearchComputed: function showCountOnSearchComputed() {
      return typeof this.showCountOnSearch === 'boolean' ? this.showCountOnSearch : this.showCount;
    },
    hasBranchNodes: function hasBranchNodes() {
      return this.forest.normalizedOptions.some(function (rootNode) {
        return rootNode.isBranch;
      });
    },
    shouldFlattenOptions: function shouldFlattenOptions() {
      return this.localSearch.active && this.flattenSearchResults;
    }
  },
  watch: {
    alwaysOpen: function alwaysOpen(newValue) {
      if (newValue) this.openMenu();else this.closeMenu();
    },
    branchNodesFirst: function branchNodesFirst() {
      this.initialize();
    },
    disabled: function disabled(newValue) {
      if (newValue && this.menu.isOpen) this.closeMenu();else if (!newValue && !this.menu.isOpen && this.alwaysOpen) this.openMenu();
    },
    flat: function flat() {
      this.initialize();
    },
    internalValue: function internalValue(newValue, oldValue) {
      var hasChanged = quickDiff(newValue, oldValue);
      if (hasChanged) this.$emit('input', this.getValue(), this.getInstanceId());
    },
    matchKeys: function matchKeys() {
      this.initialize();
    },
    multiple: function multiple(newValue) {
      if (newValue) this.buildForestState();
    },
    options: {
      handler: function handler() {
        if (this.async) return;
        this.initialize();
        this.rootOptionsStates.isLoaded = Array.isArray(this.options);
      },
      deep: true,
      immediate: true
    },
    'trigger.searchQuery': function triggerSearchQuery() {
      if (this.async) {
        this.handleRemoteSearch();
      } else {
        this.handleLocalSearch();
      }

      this.$emit('search-change', this.trigger.searchQuery, this.getInstanceId());
    },
    value: function value() {
      var nodeIdsFromValue = this.extractCheckedNodeIdsFromValue();
      var hasChanged = quickDiff(nodeIdsFromValue, this.internalValue);
      if (hasChanged) this.fixSelectedNodeIds(nodeIdsFromValue);
    }
  },
  methods: {
    verifyProps: function verifyProps() {
      var _this3 = this;

      warning_warning(function () {
        return _this3.async ? _this3.searchable : true;
      }, function () {
        return 'For async search mode, the value of "searchable" prop must be true.';
      });

      if (this.options == null && !this.loadOptions) {
        warning_warning(function () {
          return false;
        }, function () {
          return 'Are you meant to dynamically load options? You need to use "loadOptions" prop.';
        });
      }

      if (this.flat) {
        warning_warning(function () {
          return _this3.multiple;
        }, function () {
          return 'You are using flat mode. But you forgot to add "multiple=true"?';
        });
      }

      if (!this.flat) {
        var propNames = ['autoSelectAncestors', 'autoSelectDescendants', 'autoDeselectAncestors', 'autoDeselectDescendants'];
        propNames.forEach(function (propName) {
          warning_warning(function () {
            return !_this3[propName];
          }, function () {
            return "\"".concat(propName, "\" only applies to flat mode.");
          });
        });
      }
    },
    resetFlags: function resetFlags() {
      this._blurOnSelect = false;
    },
    initialize: function initialize() {
      var options = this.async ? this.getRemoteSearchEntry().options : this.options;

      if (Array.isArray(options)) {
        var prevNodeMap = this.forest.nodeMap;
        this.forest.nodeMap = createMap();
        this.keepDataOfSelectedNodes(prevNodeMap);
        this.forest.normalizedOptions = this.normalize(NO_PARENT_NODE, options, prevNodeMap);
        this.fixSelectedNodeIds(this.internalValue);
      } else {
        this.forest.normalizedOptions = [];
      }
    },
    getInstanceId: function getInstanceId() {
      return this.instanceId == null ? this.id : this.instanceId;
    },
    getValue: function getValue() {
      var _this4 = this;

      if (this.valueFormat === 'id') {
        return this.multiple ? this.internalValue.slice() : this.internalValue[0];
      }

      var rawNodes = this.internalValue.map(function (id) {
        return _this4.getNode(id).raw;
      });
      return this.multiple ? rawNodes : rawNodes[0];
    },
    getNode: function getNode(nodeId) {
      warning_warning(function () {
        return nodeId != null;
      }, function () {
        return "Invalid node id: ".concat(nodeId);
      });
      if (nodeId == null) return null;
      return nodeId in this.forest.nodeMap ? this.forest.nodeMap[nodeId] : this.createFallbackNode(nodeId);
    },
    createFallbackNode: function createFallbackNode(id) {
      var raw = this.extractNodeFromValue(id);
      var label = this.enhancedNormalizer(raw).label || "".concat(id, " (unknown)");
      var fallbackNode = {
        id: id,
        label: label,
        ancestors: [],
        parentNode: NO_PARENT_NODE,
        isFallbackNode: true,
        isRootNode: true,
        isLeaf: true,
        isBranch: false,
        isDisabled: false,
        isNew: false,
        index: [-1],
        level: 0,
        raw: raw
      };
      return this.$set(this.forest.nodeMap, id, fallbackNode);
    },
    extractCheckedNodeIdsFromValue: function extractCheckedNodeIdsFromValue() {
      var _this5 = this;

      if (this.value == null) return [];

      if (this.valueFormat === 'id') {
        return this.multiple ? this.value.slice() : [this.value];
      }

      return (this.multiple ? this.value : [this.value]).map(function (node) {
        return _this5.enhancedNormalizer(node);
      }).map(function (node) {
        return node.id;
      });
    },
    extractNodeFromValue: function extractNodeFromValue(id) {
      var _this6 = this;

      var defaultNode = {
        id: id
      };

      if (this.valueFormat === 'id') {
        return defaultNode;
      }

      var valueArray = this.multiple ? Array.isArray(this.value) ? this.value : [] : this.value ? [this.value] : [];
      var matched = find(valueArray, function (node) {
        return node && _this6.enhancedNormalizer(node).id === id;
      });
      return matched || defaultNode;
    },
    fixSelectedNodeIds: function fixSelectedNodeIds(nodeIdListOfPrevValue) {
      var _this7 = this;

      var nextSelectedNodeIds = [];

      if (this.single || this.flat || this.disableBranchNodes || this.valueConsistsOf === ALL) {
        nextSelectedNodeIds = nodeIdListOfPrevValue;
      } else if (this.valueConsistsOf === BRANCH_PRIORITY) {
        nodeIdListOfPrevValue.forEach(function (nodeId) {
          nextSelectedNodeIds.push(nodeId);

          var node = _this7.getNode(nodeId);

          if (node.isBranch) _this7.traverseDescendantsBFS(node, function (descendant) {
            nextSelectedNodeIds.push(descendant.id);
          });
        });
      } else if (this.valueConsistsOf === LEAF_PRIORITY) {
        var map = createMap();
        var queue = nodeIdListOfPrevValue.slice();

        while (queue.length) {
          var nodeId = queue.shift();
          var node = this.getNode(nodeId);
          nextSelectedNodeIds.push(nodeId);
          if (node.isRootNode) continue;
          if (!(node.parentNode.id in map)) map[node.parentNode.id] = node.parentNode.children.length;
          if (--map[node.parentNode.id] === 0) queue.push(node.parentNode.id);
        }
      } else if (this.valueConsistsOf === ALL_WITH_INDETERMINATE) {
        var _map = createMap();

        var _queue = nodeIdListOfPrevValue.filter(function (nodeId) {
          var node = _this7.getNode(nodeId);

          return node.isLeaf || node.children.length === 0;
        });

        while (_queue.length) {
          var _nodeId = _queue.shift();

          var _node = this.getNode(_nodeId);

          nextSelectedNodeIds.push(_nodeId);
          if (_node.isRootNode) continue;
          if (!(_node.parentNode.id in _map)) _map[_node.parentNode.id] = _node.parentNode.children.length;
          if (--_map[_node.parentNode.id] === 0) _queue.push(_node.parentNode.id);
        }
      }

      var hasChanged = quickDiff(this.forest.selectedNodeIds, nextSelectedNodeIds);
      if (hasChanged) this.forest.selectedNodeIds = nextSelectedNodeIds;
      this.buildForestState();
    },
    keepDataOfSelectedNodes: function keepDataOfSelectedNodes(prevNodeMap) {
      var _this8 = this;

      this.forest.selectedNodeIds.forEach(function (id) {
        if (!prevNodeMap[id]) return;

        var node = _objectSpread({}, prevNodeMap[id], {
          isFallbackNode: true
        });

        _this8.$set(_this8.forest.nodeMap, id, node);
      });
    },
    isSelected: function isSelected(node) {
      return this.forest.selectedNodeMap[node.id] === true;
    },
    traverseDescendantsBFS: function traverseDescendantsBFS(parentNode, callback) {
      if (!parentNode.isBranch) return;
      var queue = parentNode.children.slice();

      while (queue.length) {
        var currNode = queue[0];
        if (currNode.isBranch) queue.push.apply(queue, toConsumableArray_default()(currNode.children));
        callback(currNode);
        queue.shift();
      }
    },
    traverseDescendantsDFS: function traverseDescendantsDFS(parentNode, callback) {
      var _this9 = this;

      if (!parentNode.isBranch) return;
      parentNode.children.forEach(function (child) {
        _this9.traverseDescendantsDFS(child, callback);

        callback(child);
      });
    },
    traverseAllNodesDFS: function traverseAllNodesDFS(callback) {
      var _this10 = this;

      this.forest.normalizedOptions.forEach(function (rootNode) {
        _this10.traverseDescendantsDFS(rootNode, callback);

        callback(rootNode);
      });
    },
    traverseAllNodesByIndex: function traverseAllNodesByIndex(callback) {
      var walk = function walk(parentNode) {
        parentNode.children.forEach(function (child) {
          if (callback(child) !== false && child.isBranch) {
            walk(child);
          }
        });
      };

      walk({
        children: this.forest.normalizedOptions
      });
    },
    toggleClickOutsideEvent: function toggleClickOutsideEvent(enabled) {
      if (enabled) {
        document.addEventListener('mousedown', this.handleClickOutside, false);
      } else {
        document.removeEventListener('mousedown', this.handleClickOutside, false);
      }
    },
    getValueContainer: function getValueContainer() {
      return this.$refs.control.$refs['value-container'];
    },
    getInput: function getInput() {
      return this.getValueContainer().$refs.input;
    },
    focusInput: function focusInput() {
      this.getInput().focus();
    },
    blurInput: function blurInput() {
      this.getInput().blur();
    },
    handleMouseDown: onLeftClick(function handleMouseDown(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (this.disabled) return;
      var isClickedOnValueContainer = this.getValueContainer().$el.contains(evt.target);

      if (isClickedOnValueContainer && !this.menu.isOpen && (this.openOnClick || this.trigger.isFocused)) {
        this.openMenu();
      }

      if (this._blurOnSelect) {
        this.blurInput();
      } else {
        this.focusInput();
      }

      this.resetFlags();
    }),
    handleClickOutside: function handleClickOutside(evt) {
      if (this.$refs.wrapper && !this.$refs.wrapper.contains(evt.target)) {
        this.blurInput();
        this.closeMenu();
      }
    },
    handleLocalSearch: function handleLocalSearch() {
      var _this11 = this;

      var searchQuery = this.trigger.searchQuery;

      var done = function done() {
        return _this11.resetHighlightedOptionWhenNecessary(true);
      };

      if (!searchQuery) {
        this.localSearch.active = false;
        return done();
      }

      this.localSearch.active = true;
      this.localSearch.noResults = true;
      this.traverseAllNodesDFS(function (node) {
        if (node.isBranch) {
          var _this11$$set;

          node.isExpandedOnSearch = false;
          node.showAllChildrenOnSearch = false;
          node.isMatched = false;
          node.hasMatchedDescendants = false;

          _this11.$set(_this11.localSearch.countMap, node.id, (_this11$$set = {}, defineProperty_default()(_this11$$set, ALL_CHILDREN, 0), defineProperty_default()(_this11$$set, ALL_DESCENDANTS, 0), defineProperty_default()(_this11$$set, LEAF_CHILDREN, 0), defineProperty_default()(_this11$$set, LEAF_DESCENDANTS, 0), _this11$$set));
        }
      });
      var lowerCasedSearchQuery = searchQuery.trim().toLocaleLowerCase();
      var splitSearchQuery = lowerCasedSearchQuery.replace(/\s+/g, ' ').split(' ');
      this.traverseAllNodesDFS(function (node) {
        if (_this11.searchNested && splitSearchQuery.length > 1) {
          node.isMatched = splitSearchQuery.every(function (filterValue) {
            return match(false, filterValue, node.nestedSearchLabel);
          });
        } else {
          node.isMatched = _this11.matchKeys.some(function (matchKey) {
            return match(!_this11.disableFuzzyMatching, lowerCasedSearchQuery, node.lowerCased[matchKey]);
          });
        }

        if (node.isMatched) {
          _this11.localSearch.noResults = false;
          node.ancestors.forEach(function (ancestor) {
            return _this11.localSearch.countMap[ancestor.id][ALL_DESCENDANTS]++;
          });
          if (node.isLeaf) node.ancestors.forEach(function (ancestor) {
            return _this11.localSearch.countMap[ancestor.id][LEAF_DESCENDANTS]++;
          });

          if (node.parentNode !== NO_PARENT_NODE) {
            _this11.localSearch.countMap[node.parentNode.id][ALL_CHILDREN] += 1;
            if (node.isLeaf) _this11.localSearch.countMap[node.parentNode.id][LEAF_CHILDREN] += 1;
          }
        }

        if ((node.isMatched || node.isBranch && node.isExpandedOnSearch) && node.parentNode !== NO_PARENT_NODE) {
          node.parentNode.isExpandedOnSearch = true;
          node.parentNode.hasMatchedDescendants = true;
        }
      });
      done();
    },
    handleRemoteSearch: function handleRemoteSearch() {
      var _this12 = this;

      var searchQuery = this.trigger.searchQuery;
      var entry = this.getRemoteSearchEntry();

      var done = function done() {
        _this12.initialize();

        _this12.resetHighlightedOptionWhenNecessary(true);
      };

      if ((searchQuery === '' || this.cacheOptions) && entry.isLoaded) {
        return done();
      }

      this.callLoadOptionsProp({
        action: ASYNC_SEARCH,
        args: {
          searchQuery: searchQuery
        },
        isPending: function isPending() {
          return entry.isLoading;
        },
        start: function start() {
          entry.isLoading = true;
          entry.isLoaded = false;
          entry.loadingError = '';
        },
        succeed: function succeed(options) {
          entry.isLoaded = true;
          entry.options = options;
          if (_this12.trigger.searchQuery === searchQuery) done();
        },
        fail: function fail(err) {
          entry.loadingError = getErrorMessage(err);
        },
        end: function end() {
          entry.isLoading = false;
        }
      });
    },
    getRemoteSearchEntry: function getRemoteSearchEntry() {
      var _this13 = this;

      var searchQuery = this.trigger.searchQuery;

      var entry = this.remoteSearch[searchQuery] || _objectSpread({}, createAsyncOptionsStates(), {
        options: []
      });

      this.$watch(function () {
        return entry.options;
      }, function () {
        if (_this13.trigger.searchQuery === searchQuery) _this13.initialize();
      }, {
        deep: true
      });

      if (searchQuery === '') {
        if (Array.isArray(this.defaultOptions)) {
          entry.options = this.defaultOptions;
          entry.isLoaded = true;
          return entry;
        } else if (this.defaultOptions !== true) {
          entry.isLoaded = true;
          return entry;
        }
      }

      if (!this.remoteSearch[searchQuery]) {
        this.$set(this.remoteSearch, searchQuery, entry);
      }

      return entry;
    },
    shouldExpand: function shouldExpand(node) {
      return this.localSearch.active ? node.isExpandedOnSearch : node.isExpanded;
    },
    shouldOptionBeIncludedInSearchResult: function shouldOptionBeIncludedInSearchResult(node) {
      if (node.isMatched) return true;
      if (node.isBranch && node.hasMatchedDescendants && !this.flattenSearchResults) return true;
      if (!node.isRootNode && node.parentNode.showAllChildrenOnSearch) return true;
      return false;
    },
    shouldShowOptionInMenu: function shouldShowOptionInMenu(node) {
      if (this.localSearch.active && !this.shouldOptionBeIncludedInSearchResult(node)) {
        return false;
      }

      return true;
    },
    getControl: function getControl() {
      return this.$refs.control.$el;
    },
    getMenu: function getMenu() {
      var ref = this.appendToBody ? this.$refs.portal.portalTarget : this;
      var $menu = ref.$refs.menu.$refs.menu;
      return $menu && $menu.nodeName !== '#comment' ? $menu : null;
    },
    setCurrentHighlightedOption: function setCurrentHighlightedOption(node) {
      var _this14 = this;

      var scroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var prev = this.menu.current;

      if (prev != null && prev in this.forest.nodeMap) {
        this.forest.nodeMap[prev].isHighlighted = false;
      }

      this.menu.current = node.id;
      node.isHighlighted = true;

      if (this.menu.isOpen && scroll) {
        var scrollToOption = function scrollToOption() {
          var $menu = _this14.getMenu();

          var $option = $menu.querySelector(".vue-treeselect__option[data-id=\"".concat(node.id, "\"]"));
          if ($option) scrollIntoView($menu, $option);
        };

        if (this.getMenu()) {
          scrollToOption();
        } else {
          this.$nextTick(scrollToOption);
        }
      }
    },
    resetHighlightedOptionWhenNecessary: function resetHighlightedOptionWhenNecessary() {
      var forceReset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var current = this.menu.current;

      if (forceReset || current == null || !(current in this.forest.nodeMap) || !this.shouldShowOptionInMenu(this.getNode(current))) {
        this.highlightFirstOption();
      }
    },
    highlightFirstOption: function highlightFirstOption() {
      if (!this.hasVisibleOptions) return;
      var first = this.visibleOptionIds[0];
      this.setCurrentHighlightedOption(this.getNode(first));
    },
    highlightPrevOption: function highlightPrevOption() {
      if (!this.hasVisibleOptions) return;
      var prev = this.visibleOptionIds.indexOf(this.menu.current) - 1;
      if (prev === -1) return this.highlightLastOption();
      this.setCurrentHighlightedOption(this.getNode(this.visibleOptionIds[prev]));
    },
    highlightNextOption: function highlightNextOption() {
      if (!this.hasVisibleOptions) return;
      var next = this.visibleOptionIds.indexOf(this.menu.current) + 1;
      if (next === this.visibleOptionIds.length) return this.highlightFirstOption();
      this.setCurrentHighlightedOption(this.getNode(this.visibleOptionIds[next]));
    },
    highlightLastOption: function highlightLastOption() {
      if (!this.hasVisibleOptions) return;
      var last = last_default()(this.visibleOptionIds);
      this.setCurrentHighlightedOption(this.getNode(last));
    },
    resetSearchQuery: function resetSearchQuery() {
      this.trigger.searchQuery = '';
    },
    closeMenu: function closeMenu() {
      if (!this.menu.isOpen || !this.disabled && this.alwaysOpen) return;
      this.saveMenuScrollPosition();
      this.menu.isOpen = false;
      this.toggleClickOutsideEvent(false);
      this.resetSearchQuery();
      this.$emit('close', this.getValue(), this.getInstanceId());
    },
    openMenu: function openMenu() {
      if (this.disabled || this.menu.isOpen) return;
      this.menu.isOpen = true;
      this.$nextTick(this.resetHighlightedOptionWhenNecessary);
      this.$nextTick(this.restoreMenuScrollPosition);
      if (!this.options && !this.async) this.loadRootOptions();
      this.toggleClickOutsideEvent(true);
      this.$emit('open', this.getInstanceId());
    },
    toggleMenu: function toggleMenu() {
      if (this.menu.isOpen) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    },
    toggleExpanded: function toggleExpanded(node) {
      var nextState;

      if (this.localSearch.active) {
        nextState = node.isExpandedOnSearch = !node.isExpandedOnSearch;
        if (nextState) node.showAllChildrenOnSearch = true;
      } else {
        nextState = node.isExpanded = !node.isExpanded;
      }

      if (nextState && !node.childrenStates.isLoaded) {
        this.loadChildrenOptions(node);
      }
    },
    buildForestState: function buildForestState() {
      var _this15 = this;

      var selectedNodeMap = createMap();
      this.forest.selectedNodeIds.forEach(function (selectedNodeId) {
        selectedNodeMap[selectedNodeId] = true;
      });
      this.forest.selectedNodeMap = selectedNodeMap;
      var checkedStateMap = createMap();

      if (this.multiple) {
        this.traverseAllNodesByIndex(function (node) {
          checkedStateMap[node.id] = UNCHECKED;
        });
        this.selectedNodes.forEach(function (selectedNode) {
          checkedStateMap[selectedNode.id] = CHECKED;

          if (!_this15.flat && !_this15.disableBranchNodes) {
            selectedNode.ancestors.forEach(function (ancestorNode) {
              if (!_this15.isSelected(ancestorNode)) {
                checkedStateMap[ancestorNode.id] = INDETERMINATE;
              }
            });
          }
        });
      }

      this.forest.checkedStateMap = checkedStateMap;
    },
    enhancedNormalizer: function enhancedNormalizer(raw) {
      return _objectSpread({}, raw, {}, this.normalizer(raw, this.getInstanceId()));
    },
    normalize: function normalize(parentNode, nodes, prevNodeMap) {
      var _this16 = this;

      var normalizedOptions = nodes.map(function (node) {
        return [_this16.enhancedNormalizer(node), node];
      }).map(function (_ref, index) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            node = _ref2[0],
            raw = _ref2[1];

        _this16.checkDuplication(node);

        _this16.verifyNodeShape(node);

        var id = node.id,
            label = node.label,
            children = node.children,
            isDefaultExpanded = node.isDefaultExpanded;
        var isRootNode = parentNode === NO_PARENT_NODE;
        var level = isRootNode ? 0 : parentNode.level + 1;
        var isBranch = Array.isArray(children) || children === null;
        var isLeaf = !isBranch;
        var isDisabled = !!node.isDisabled || !_this16.flat && !isRootNode && parentNode.isDisabled;
        var isNew = !!node.isNew;

        var lowerCased = _this16.matchKeys.reduce(function (prev, key) {
          return _objectSpread({}, prev, defineProperty_default()({}, key, stringifyOptionPropValue(node[key]).toLocaleLowerCase()));
        }, {});

        var nestedSearchLabel = isRootNode ? lowerCased.label : parentNode.nestedSearchLabel + ' ' + lowerCased.label;

        var normalized = _this16.$set(_this16.forest.nodeMap, id, createMap());

        _this16.$set(normalized, 'id', id);

        _this16.$set(normalized, 'label', label);

        _this16.$set(normalized, 'level', level);

        _this16.$set(normalized, 'ancestors', isRootNode ? [] : [parentNode].concat(parentNode.ancestors));

        _this16.$set(normalized, 'index', (isRootNode ? [] : parentNode.index).concat(index));

        _this16.$set(normalized, 'parentNode', parentNode);

        _this16.$set(normalized, 'lowerCased', lowerCased);

        _this16.$set(normalized, 'nestedSearchLabel', nestedSearchLabel);

        _this16.$set(normalized, 'isDisabled', isDisabled);

        _this16.$set(normalized, 'isNew', isNew);

        _this16.$set(normalized, 'isMatched', false);

        _this16.$set(normalized, 'isHighlighted', false);

        _this16.$set(normalized, 'isBranch', isBranch);

        _this16.$set(normalized, 'isLeaf', isLeaf);

        _this16.$set(normalized, 'isRootNode', isRootNode);

        _this16.$set(normalized, 'raw', raw);

        if (isBranch) {
          var _this16$$set;

          var isLoaded = Array.isArray(children);

          _this16.$set(normalized, 'childrenStates', _objectSpread({}, createAsyncOptionsStates(), {
            isLoaded: isLoaded
          }));

          _this16.$set(normalized, 'isExpanded', typeof isDefaultExpanded === 'boolean' ? isDefaultExpanded : level < _this16.defaultExpandLevel);

          _this16.$set(normalized, 'hasMatchedDescendants', false);

          _this16.$set(normalized, 'hasDisabledDescendants', false);

          _this16.$set(normalized, 'isExpandedOnSearch', false);

          _this16.$set(normalized, 'showAllChildrenOnSearch', false);

          _this16.$set(normalized, 'count', (_this16$$set = {}, defineProperty_default()(_this16$$set, ALL_CHILDREN, 0), defineProperty_default()(_this16$$set, ALL_DESCENDANTS, 0), defineProperty_default()(_this16$$set, LEAF_CHILDREN, 0), defineProperty_default()(_this16$$set, LEAF_DESCENDANTS, 0), _this16$$set));

          _this16.$set(normalized, 'children', isLoaded ? _this16.normalize(normalized, children, prevNodeMap) : []);

          if (isDefaultExpanded === true) normalized.ancestors.forEach(function (ancestor) {
            ancestor.isExpanded = true;
          });

          if (!isLoaded && typeof _this16.loadOptions !== 'function') {
            warning_warning(function () {
              return false;
            }, function () {
              return 'Unloaded branch node detected. "loadOptions" prop is required to load its children.';
            });
          } else if (!isLoaded && normalized.isExpanded) {
            _this16.loadChildrenOptions(normalized);
          }
        }

        normalized.ancestors.forEach(function (ancestor) {
          return ancestor.count[ALL_DESCENDANTS]++;
        });
        if (isLeaf) normalized.ancestors.forEach(function (ancestor) {
          return ancestor.count[LEAF_DESCENDANTS]++;
        });

        if (!isRootNode) {
          parentNode.count[ALL_CHILDREN] += 1;
          if (isLeaf) parentNode.count[LEAF_CHILDREN] += 1;
          if (isDisabled) parentNode.hasDisabledDescendants = true;
        }

        if (prevNodeMap && prevNodeMap[id]) {
          var prev = prevNodeMap[id];
          normalized.isMatched = prev.isMatched;
          normalized.showAllChildrenOnSearch = prev.showAllChildrenOnSearch;
          normalized.isHighlighted = prev.isHighlighted;

          if (prev.isBranch && normalized.isBranch) {
            normalized.isExpanded = prev.isExpanded;
            normalized.isExpandedOnSearch = prev.isExpandedOnSearch;

            if (prev.childrenStates.isLoaded && !normalized.childrenStates.isLoaded) {
              normalized.isExpanded = false;
            } else {
              normalized.childrenStates = _objectSpread({}, prev.childrenStates);
            }
          }
        }

        return normalized;
      });

      if (this.branchNodesFirst) {
        var branchNodes = normalizedOptions.filter(function (option) {
          return option.isBranch;
        });
        var leafNodes = normalizedOptions.filter(function (option) {
          return option.isLeaf;
        });
        normalizedOptions = branchNodes.concat(leafNodes);
      }

      return normalizedOptions;
    },
    loadRootOptions: function loadRootOptions() {
      var _this17 = this;

      this.callLoadOptionsProp({
        action: LOAD_ROOT_OPTIONS,
        isPending: function isPending() {
          return _this17.rootOptionsStates.isLoading;
        },
        start: function start() {
          _this17.rootOptionsStates.isLoading = true;
          _this17.rootOptionsStates.loadingError = '';
        },
        succeed: function succeed() {
          _this17.rootOptionsStates.isLoaded = true;

          _this17.$nextTick(function () {
            _this17.resetHighlightedOptionWhenNecessary(true);
          });
        },
        fail: function fail(err) {
          _this17.rootOptionsStates.loadingError = getErrorMessage(err);
        },
        end: function end() {
          _this17.rootOptionsStates.isLoading = false;
        }
      });
    },
    loadChildrenOptions: function loadChildrenOptions(parentNode) {
      var _this18 = this;

      var id = parentNode.id,
          raw = parentNode.raw;
      this.callLoadOptionsProp({
        action: LOAD_CHILDREN_OPTIONS,
        args: {
          parentNode: raw
        },
        isPending: function isPending() {
          return _this18.getNode(id).childrenStates.isLoading;
        },
        start: function start() {
          _this18.getNode(id).childrenStates.isLoading = true;
          _this18.getNode(id).childrenStates.loadingError = '';
        },
        succeed: function succeed() {
          _this18.getNode(id).childrenStates.isLoaded = true;
        },
        fail: function fail(err) {
          _this18.getNode(id).childrenStates.loadingError = getErrorMessage(err);
        },
        end: function end() {
          _this18.getNode(id).childrenStates.isLoading = false;
        }
      });
    },
    callLoadOptionsProp: function callLoadOptionsProp(_ref3) {
      var action = _ref3.action,
          args = _ref3.args,
          isPending = _ref3.isPending,
          start = _ref3.start,
          succeed = _ref3.succeed,
          fail = _ref3.fail,
          end = _ref3.end;

      if (!this.loadOptions || isPending()) {
        return;
      }

      start();
      var callback = once_default()(function (err, result) {
        if (err) {
          fail(err);
        } else {
          succeed(result);
        }

        end();
      });
      var result = this.loadOptions(_objectSpread({
        id: this.getInstanceId(),
        instanceId: this.getInstanceId(),
        action: action
      }, args, {
        callback: callback
      }));

      if (external_is_promise_default()(result)) {
        result.then(function () {
          callback();
        }, function (err) {
          callback(err);
        }).catch(function (err) {
          console.error(err);
        });
      }
    },
    checkDuplication: function checkDuplication(node) {
      var _this19 = this;

      warning_warning(function () {
        return !(node.id in _this19.forest.nodeMap && !_this19.forest.nodeMap[node.id].isFallbackNode);
      }, function () {
        return "Detected duplicate presence of node id ".concat(JSON.stringify(node.id), ". ") + "Their labels are \"".concat(_this19.forest.nodeMap[node.id].label, "\" and \"").concat(node.label, "\" respectively.");
      });
    },
    verifyNodeShape: function verifyNodeShape(node) {
      warning_warning(function () {
        return !(node.children === undefined && node.isBranch === true);
      }, function () {
        return 'Are you meant to declare an unloaded branch node? ' + '`isBranch: true` is no longer supported, please use `children: null` instead.';
      });
    },
    select: function select(node) {
      if (this.disabled || node.isDisabled) {
        return;
      }

      if (this.single) {
        this.clear();
      }

      var nextState = this.multiple && !this.flat ? this.forest.checkedStateMap[node.id] === UNCHECKED : !this.isSelected(node);

      if (nextState) {
        this._selectNode(node);
      } else {
        this._deselectNode(node);
      }

      this.buildForestState();

      if (nextState) {
        this.$emit('select', node.raw, this.getInstanceId());
      } else {
        this.$emit('deselect', node.raw, this.getInstanceId());
      }

      if (this.localSearch.active && nextState && (this.single || this.clearOnSelect)) {
        this.resetSearchQuery();
      }

      if (this.single && this.closeOnSelect) {
        this.closeMenu();

        if (this.searchable) {
          this._blurOnSelect = true;
        }
      }
    },
    clear: function clear() {
      var _this20 = this;

      if (this.hasValue) {
        if (this.single || this.allowClearingDisabled) {
          this.forest.selectedNodeIds = [];
        } else {
            this.forest.selectedNodeIds = this.forest.selectedNodeIds.filter(function (nodeId) {
              return _this20.getNode(nodeId).isDisabled;
            });
          }

        this.buildForestState();
      }
    },
    _selectNode: function _selectNode(node) {
      var _this21 = this;

      if (this.single || this.disableBranchNodes) {
        return this.addValue(node);
      }

      if (this.flat) {
        this.addValue(node);

        if (this.autoSelectAncestors) {
          node.ancestors.forEach(function (ancestor) {
            if (!_this21.isSelected(ancestor) && !ancestor.isDisabled) _this21.addValue(ancestor);
          });
        } else if (this.autoSelectDescendants) {
          this.traverseDescendantsBFS(node, function (descendant) {
            if (!_this21.isSelected(descendant) && !descendant.isDisabled) _this21.addValue(descendant);
          });
        }

        return;
      }

      var isFullyChecked = node.isLeaf || !node.hasDisabledDescendants || this.allowSelectingDisabledDescendants;

      if (isFullyChecked) {
        this.addValue(node);
      }

      if (node.isBranch) {
        this.traverseDescendantsBFS(node, function (descendant) {
          if (!descendant.isDisabled || _this21.allowSelectingDisabledDescendants) {
            _this21.addValue(descendant);
          }
        });
      }

      if (isFullyChecked) {
        var curr = node;

        while ((curr = curr.parentNode) !== NO_PARENT_NODE) {
          if (curr.children.every(this.isSelected)) this.addValue(curr);else break;
        }
      }
    },
    _deselectNode: function _deselectNode(node) {
      var _this22 = this;

      if (this.disableBranchNodes) {
        return this.removeValue(node);
      }

      if (this.flat) {
        this.removeValue(node);

        if (this.autoDeselectAncestors) {
          node.ancestors.forEach(function (ancestor) {
            if (_this22.isSelected(ancestor) && !ancestor.isDisabled) _this22.removeValue(ancestor);
          });
        } else if (this.autoDeselectDescendants) {
          this.traverseDescendantsBFS(node, function (descendant) {
            if (_this22.isSelected(descendant) && !descendant.isDisabled) _this22.removeValue(descendant);
          });
        }

        return;
      }

      var hasUncheckedSomeDescendants = false;

      if (node.isBranch) {
        this.traverseDescendantsDFS(node, function (descendant) {
          if (!descendant.isDisabled || _this22.allowSelectingDisabledDescendants) {
            _this22.removeValue(descendant);

            hasUncheckedSomeDescendants = true;
          }
        });
      }

      if (node.isLeaf || hasUncheckedSomeDescendants || node.children.length === 0) {
        this.removeValue(node);
        var curr = node;

        while ((curr = curr.parentNode) !== NO_PARENT_NODE) {
          if (this.isSelected(curr)) this.removeValue(curr);else break;
        }
      }
    },
    addValue: function addValue(node) {
      this.forest.selectedNodeIds.push(node.id);
      this.forest.selectedNodeMap[node.id] = true;
    },
    removeValue: function removeValue(node) {
      removeFromArray(this.forest.selectedNodeIds, node.id);
      delete this.forest.selectedNodeMap[node.id];
    },
    removeLastValue: function removeLastValue() {
      if (!this.hasValue) return;
      if (this.single) return this.clear();
      var lastValue = last_default()(this.internalValue);
      var lastSelectedNode = this.getNode(lastValue);
      this.select(lastSelectedNode);
    },
    saveMenuScrollPosition: function saveMenuScrollPosition() {
      var $menu = this.getMenu();
      if ($menu) this.menu.lastScrollPosition = $menu.scrollTop;
    },
    restoreMenuScrollPosition: function restoreMenuScrollPosition() {
      var $menu = this.getMenu();
      if ($menu) $menu.scrollTop = this.menu.lastScrollPosition;
    }
  },
  created: function created() {
    this.verifyProps();
    this.resetFlags();
  },
  mounted: function mounted() {
    if (this.autoFocus) this.focusInput();
    if (!this.options && !this.async && this.autoLoadRootOptions) this.loadRootOptions();
    if (this.alwaysOpen) this.openMenu();
    if (this.async && this.defaultOptions) this.handleRemoteSearch();
  },
  destroyed: function destroyed() {
    this.toggleClickOutsideEvent(false);
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/HiddenFields.vue?vue&type=script&lang=js&


function stringifyValue(value) {
  if (typeof value === 'string') return value;
  if (value != null && !isNaN_isNaN(value)) return JSON.stringify(value);
  return '';
}

/* harmony default export */ var HiddenFieldsvue_type_script_lang_js_ = ({
  name: 'vue-treeselect--hidden-fields',
  inject: ['instance'],
  functional: true,
  render: function render(_, context) {
    var h = arguments[0];
    var instance = context.injections.instance;
    if (!instance.name || instance.disabled || !instance.hasValue) return null;
    var stringifiedValues = instance.internalValue.map(stringifyValue);
    if (instance.multiple && instance.joinValues) stringifiedValues = [stringifiedValues.join(instance.delimiter)];
    return stringifiedValues.map(function (stringifiedValue, i) {
      return h("input", {
        attrs: {
          type: "hidden",
          name: instance.name
        },
        domProps: {
          "value": stringifiedValue
        },
        key: 'hidden-field-' + i
      });
    });
  }
});
// CONCATENATED MODULE: ./src/components/HiddenFields.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_HiddenFieldsvue_type_script_lang_js_ = (HiddenFieldsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/HiddenFields.vue
var HiddenFields_render, staticRenderFns




/* normalize component */

var component = normalizeComponent(
  components_HiddenFieldsvue_type_script_lang_js_,
  HiddenFields_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/HiddenFields.vue"
/* harmony default export */ var HiddenFields = (component.exports);
// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(13);
var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Input.vue?vue&type=script&lang=js&



var keysThatRequireMenuBeingOpen = [KEY_CODES.ENTER, KEY_CODES.END, KEY_CODES.HOME, KEY_CODES.ARROW_LEFT, KEY_CODES.ARROW_UP, KEY_CODES.ARROW_RIGHT, KEY_CODES.ARROW_DOWN];
/* harmony default export */ var Inputvue_type_script_lang_js_ = ({
  name: 'vue-treeselect--input',
  inject: ['instance'],
  data: function data() {
    return {
      inputWidth: MIN_INPUT_WIDTH,
      value: ''
    };
  },
  computed: {
    needAutoSize: function needAutoSize() {
      var instance = this.instance;
      return instance.searchable && !instance.disabled && instance.multiple;
    },
    inputStyle: function inputStyle() {
      return {
        width: this.needAutoSize ? "".concat(this.inputWidth, "px") : null
      };
    }
  },
  watch: {
    'instance.trigger.searchQuery': function instanceTriggerSearchQuery(newValue) {
      this.value = newValue;
    },
    value: function value() {
      if (this.needAutoSize) this.$nextTick(this.updateInputWidth);
    }
  },
  created: function created() {
    this.debouncedCallback = debounce_default()(this.updateSearchQuery, INPUT_DEBOUNCE_DELAY, {
      leading: true,
      trailing: true
    });
  },
  methods: {
    clear: function clear() {
      this.onInput({
        target: {
          value: ''
        }
      });
    },
    focus: function focus() {
      var instance = this.instance;

      if (!instance.disabled) {
        this.$refs.input && this.$refs.input.focus();
      }
    },
    blur: function blur() {
      this.$refs.input && this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      var instance = this.instance;
      instance.trigger.isFocused = true;
      if (instance.openOnFocus) instance.openMenu();
    },
    onBlur: function onBlur() {
      var instance = this.instance;
      var menu = instance.getMenu();

      if (menu && document.activeElement === menu) {
        return this.focus();
      }

      instance.trigger.isFocused = false;
      instance.closeMenu();
    },
    onInput: function onInput(evt) {
      var value = evt.target.value;
      this.value = value;

      if (value) {
        this.debouncedCallback();
      } else {
        this.debouncedCallback.cancel();
        this.updateSearchQuery();
      }
    },
    onKeyDown: function onKeyDown(evt) {
      var instance = this.instance;
      var key = 'which' in evt ? evt.which : evt.keyCode;
      if (evt.ctrlKey || evt.shiftKey || evt.altKey || evt.metaKey) return;

      if (!instance.menu.isOpen && includes(keysThatRequireMenuBeingOpen, key)) {
        evt.preventDefault();
        return instance.openMenu();
      }

      switch (key) {
        case KEY_CODES.BACKSPACE:
          {
            if (instance.backspaceRemoves && !this.value.length) {
              instance.removeLastValue();
            }

            break;
          }

        case KEY_CODES.ENTER:
          {
            evt.preventDefault();
            if (instance.menu.current === null) return;
            var current = instance.getNode(instance.menu.current);
            if (current.isBranch && instance.disableBranchNodes) return;
            instance.select(current);
            break;
          }

        case KEY_CODES.ESCAPE:
          {
            if (this.value.length) {
              this.clear();
            } else if (instance.menu.isOpen) {
              instance.closeMenu();
            }

            break;
          }

        case KEY_CODES.END:
          {
            evt.preventDefault();
            instance.highlightLastOption();
            break;
          }

        case KEY_CODES.HOME:
          {
            evt.preventDefault();
            instance.highlightFirstOption();
            break;
          }

        case KEY_CODES.ARROW_LEFT:
          {
            var _current = instance.getNode(instance.menu.current);

            if (_current.isBranch && instance.shouldExpand(_current)) {
              evt.preventDefault();
              instance.toggleExpanded(_current);
            } else if (!_current.isRootNode && (_current.isLeaf || _current.isBranch && !instance.shouldExpand(_current))) {
              evt.preventDefault();
              instance.setCurrentHighlightedOption(_current.parentNode);
            }

            break;
          }

        case KEY_CODES.ARROW_UP:
          {
            evt.preventDefault();
            instance.highlightPrevOption();
            break;
          }

        case KEY_CODES.ARROW_RIGHT:
          {
            var _current2 = instance.getNode(instance.menu.current);

            if (_current2.isBranch && !instance.shouldExpand(_current2)) {
              evt.preventDefault();
              instance.toggleExpanded(_current2);
            }

            break;
          }

        case KEY_CODES.ARROW_DOWN:
          {
            evt.preventDefault();
            instance.highlightNextOption();
            break;
          }

        case KEY_CODES.DELETE:
          {
            if (instance.deleteRemoves && !this.value.length) {
              instance.removeLastValue();
            }

            break;
          }

        default:
          {
            instance.openMenu();
          }
      }
    },
    onMouseDown: function onMouseDown(evt) {
      if (this.value.length) {
        evt.stopPropagation();
      }
    },
    renderInputContainer: function renderInputContainer() {
      var h = this.$createElement;
      var instance = this.instance;
      var props = {};
      var children = [];

      if (instance.searchable && !instance.disabled) {
        children.push(this.renderInput());
        if (this.needAutoSize) children.push(this.renderSizer());
      }

      if (!instance.searchable) {
        deepExtend(props, {
          on: {
            focus: this.onFocus,
            blur: this.onBlur,
            keydown: this.onKeyDown
          },
          ref: 'input'
        });
      }

      if (!instance.searchable && !instance.disabled) {
        deepExtend(props, {
          attrs: {
            tabIndex: instance.tabIndex
          }
        });
      }

      return h("div", external_babel_helper_vue_jsx_merge_props_default()([{
        "class": "vue-treeselect__input-container"
      }, props]), [children]);
    },
    renderInput: function renderInput() {
      var h = this.$createElement;
      var instance = this.instance;
      return h("input", {
        ref: "input",
        "class": "vue-treeselect__input",
        attrs: {
          type: "text",
          autocomplete: "off",
          tabIndex: instance.tabIndex,
          required: instance.required && !instance.hasValue
        },
        domProps: {
          "value": this.value
        },
        style: this.inputStyle,
        on: {
          "focus": this.onFocus,
          "input": this.onInput,
          "blur": this.onBlur,
          "keydown": this.onKeyDown,
          "mousedown": this.onMouseDown
        }
      });
    },
    renderSizer: function renderSizer() {
      var h = this.$createElement;
      return h("div", {
        ref: "sizer",
        "class": "vue-treeselect__sizer"
      }, [this.value]);
    },
    updateInputWidth: function updateInputWidth() {
      this.inputWidth = Math.max(MIN_INPUT_WIDTH, this.$refs.sizer.scrollWidth + 15);
    },
    updateSearchQuery: function updateSearchQuery() {
      var instance = this.instance;
      instance.trigger.searchQuery = this.value;
    }
  },
  render: function render() {
    return this.renderInputContainer();
  }
});
// CONCATENATED MODULE: ./src/components/Input.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Inputvue_type_script_lang_js_ = (Inputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/Input.vue
var Input_render, Input_staticRenderFns




/* normalize component */

var Input_component = normalizeComponent(
  components_Inputvue_type_script_lang_js_,
  Input_render,
  Input_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Input_api; }
Input_component.options.__file = "src/components/Input.vue"
/* harmony default export */ var Input = (Input_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Placeholder.vue?vue&type=script&lang=js&
/* harmony default export */ var Placeholdervue_type_script_lang_js_ = ({
  name: 'vue-treeselect--placeholder',
  inject: ['instance'],
  render: function render() {
    var h = arguments[0];
    var instance = this.instance;
    var placeholderClass = {
      'vue-treeselect__placeholder': true,
      'vue-treeselect-helper-zoom-effect-off': true,
      'vue-treeselect-helper-hide': instance.hasValue || instance.trigger.searchQuery
    };
    return h("div", {
      "class": placeholderClass
    }, [instance.placeholder]);
  }
});
// CONCATENATED MODULE: ./src/components/Placeholder.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Placeholdervue_type_script_lang_js_ = (Placeholdervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/Placeholder.vue
var Placeholder_render, Placeholder_staticRenderFns




/* normalize component */

var Placeholder_component = normalizeComponent(
  components_Placeholdervue_type_script_lang_js_,
  Placeholder_render,
  Placeholder_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Placeholder_api; }
Placeholder_component.options.__file = "src/components/Placeholder.vue"
/* harmony default export */ var Placeholder = (Placeholder_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/SingleValue.vue?vue&type=script&lang=js&


/* harmony default export */ var SingleValuevue_type_script_lang_js_ = ({
  name: 'vue-treeselect--single-value',
  inject: ['instance'],
  methods: {
    renderSingleValueLabel: function renderSingleValueLabel() {
      var instance = this.instance;
      var node = instance.selectedNodes[0];
      var customValueLabelRenderer = instance.$scopedSlots['value-label'];
      return customValueLabelRenderer ? customValueLabelRenderer({
        node: node
      }) : node.label;
    }
  },
  render: function render() {
    var h = arguments[0];
    var instance = this.instance,
        renderValueContainer = this.$parent.renderValueContainer;
    var shouldShowValue = instance.hasValue && !instance.trigger.searchQuery;
    return renderValueContainer([shouldShowValue && h("div", {
      "class": "vue-treeselect__single-value"
    }, [this.renderSingleValueLabel()]), h(Placeholder), h(Input, {
      ref: "input"
    })]);
  }
});
// CONCATENATED MODULE: ./src/components/SingleValue.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SingleValuevue_type_script_lang_js_ = (SingleValuevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/SingleValue.vue
var SingleValue_render, SingleValue_staticRenderFns




/* normalize component */

var SingleValue_component = normalizeComponent(
  components_SingleValuevue_type_script_lang_js_,
  SingleValue_render,
  SingleValue_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var SingleValue_api; }
SingleValue_component.options.__file = "src/components/SingleValue.vue"
/* harmony default export */ var SingleValue = (SingleValue_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/icons/Delete.vue?vue&type=template&id=364b6320&
var Deletevue_type_template_id_364b6320_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 348.333 348.333"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M336.559 68.611L231.016 174.165l105.543 105.549c15.699 15.705 15.699 41.145 0 56.85-7.844 7.844-18.128 11.769-28.407 11.769-10.296 0-20.581-3.919-28.419-11.769L174.167 231.003 68.609 336.563c-7.843 7.844-18.128 11.769-28.416 11.769-10.285 0-20.563-3.919-28.413-11.769-15.699-15.698-15.699-41.139 0-56.85l105.54-105.549L11.774 68.611c-15.699-15.699-15.699-41.145 0-56.844 15.696-15.687 41.127-15.687 56.829 0l105.563 105.554L279.721 11.767c15.705-15.687 41.139-15.687 56.832 0 15.705 15.699 15.705 41.145.006 56.844z"
        }
      })
    ]
  )
}
var Deletevue_type_template_id_364b6320_staticRenderFns = []
Deletevue_type_template_id_364b6320_render._withStripped = true


// CONCATENATED MODULE: ./src/components/icons/Delete.vue?vue&type=template&id=364b6320&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/icons/Delete.vue?vue&type=script&lang=js&
/* harmony default export */ var Deletevue_type_script_lang_js_ = ({
  name: 'vue-treeselect--x'
});
// CONCATENATED MODULE: ./src/components/icons/Delete.vue?vue&type=script&lang=js&
 /* harmony default export */ var icons_Deletevue_type_script_lang_js_ = (Deletevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/icons/Delete.vue





/* normalize component */

var Delete_component = normalizeComponent(
  icons_Deletevue_type_script_lang_js_,
  Deletevue_type_template_id_364b6320_render,
  Deletevue_type_template_id_364b6320_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Delete_api; }
Delete_component.options.__file = "src/components/icons/Delete.vue"
/* harmony default export */ var Delete = (Delete_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MultiValueItem.vue?vue&type=script&lang=js&


/* harmony default export */ var MultiValueItemvue_type_script_lang_js_ = ({
  name: 'vue-treeselect--multi-value-item',
  inject: ['instance'],
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleMouseDown: onLeftClick(function handleMouseDown() {
      var instance = this.instance,
          node = this.node;
      instance.select(node);
    })
  },
  render: function render() {
    var h = arguments[0];
    var instance = this.instance,
        node = this.node;
    var itemClass = {
      'vue-treeselect__multi-value-item': true,
      'vue-treeselect__multi-value-item-disabled': node.isDisabled,
      'vue-treeselect__multi-value-item-new': node.isNew
    };
    var customValueLabelRenderer = instance.$scopedSlots['value-label'];
    var labelRenderer = customValueLabelRenderer ? customValueLabelRenderer({
      node: node
    }) : node.label;
    return h("div", {
      "class": "vue-treeselect__multi-value-item-container"
    }, [h("div", {
      "class": itemClass,
      on: {
        "mousedown": this.handleMouseDown
      }
    }, [h("span", {
      "class": "vue-treeselect__multi-value-label"
    }, [labelRenderer]), h("span", {
      "class": "vue-treeselect__icon vue-treeselect__value-remove"
    }, [h(Delete)])])]);
  }
});
// CONCATENATED MODULE: ./src/components/MultiValueItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_MultiValueItemvue_type_script_lang_js_ = (MultiValueItemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/MultiValueItem.vue
var MultiValueItem_render, MultiValueItem_staticRenderFns




/* normalize component */

var MultiValueItem_component = normalizeComponent(
  components_MultiValueItemvue_type_script_lang_js_,
  MultiValueItem_render,
  MultiValueItem_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var MultiValueItem_api; }
MultiValueItem_component.options.__file = "src/components/MultiValueItem.vue"
/* harmony default export */ var MultiValueItem = (MultiValueItem_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MultiValue.vue?vue&type=script&lang=js&




/* harmony default export */ var MultiValuevue_type_script_lang_js_ = ({
  name: 'vue-treeselect--multi-value',
  inject: ['instance'],
  methods: {
    renderMultiValueItems: function renderMultiValueItems() {
      var h = this.$createElement;
      var instance = this.instance;
      return instance.internalValue.slice(0, instance.limit).map(instance.getNode).map(function (node) {
        return h(MultiValueItem, {
          key: "multi-value-item-".concat(node.id),
          attrs: {
            node: node
          }
        });
      });
    },
    renderExceedLimitTip: function renderExceedLimitTip() {
      var h = this.$createElement;
      var instance = this.instance;
      var count = instance.internalValue.length - instance.limit;
      if (count <= 0) return null;
      return h("div", {
        "class": "vue-treeselect__limit-tip vue-treeselect-helper-zoom-effect-off",
        key: "exceed-limit-tip"
      }, [h("span", {
        "class": "vue-treeselect__limit-tip-text"
      }, [instance.limitText(count)])]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var renderValueContainer = this.$parent.renderValueContainer;
    var transitionGroupProps = {
      props: {
        tag: 'div',
        name: 'vue-treeselect__multi-value-item--transition',
        appear: true
      }
    };
    return renderValueContainer(h("transition-group", external_babel_helper_vue_jsx_merge_props_default()([{
      "class": "vue-treeselect__multi-value"
    }, transitionGroupProps]), [this.renderMultiValueItems(), this.renderExceedLimitTip(), h(Placeholder, {
      key: "placeholder"
    }), h(Input, {
      ref: "input",
      key: "input"
    })]));
  }
});
// CONCATENATED MODULE: ./src/components/MultiValue.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_MultiValuevue_type_script_lang_js_ = (MultiValuevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/MultiValue.vue
var MultiValue_render, MultiValue_staticRenderFns




/* normalize component */

var MultiValue_component = normalizeComponent(
  components_MultiValuevue_type_script_lang_js_,
  MultiValue_render,
  MultiValue_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var MultiValue_api; }
MultiValue_component.options.__file = "src/components/MultiValue.vue"
/* harmony default export */ var MultiValue = (MultiValue_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/icons/Arrow.vue?vue&type=template&id=11186cd4&
var Arrowvue_type_template_id_11186cd4_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 292.362 292.362"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M286.935 69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952 0-9.233 1.807-12.85 5.424C1.807 72.998 0 77.279 0 82.228c0 4.948 1.807 9.229 5.424 12.847l127.907 127.907c3.621 3.617 7.902 5.428 12.85 5.428s9.233-1.811 12.847-5.428L286.935 95.074c3.613-3.617 5.427-7.898 5.427-12.847 0-4.948-1.814-9.229-5.427-12.85z"
        }
      })
    ]
  )
}
var Arrowvue_type_template_id_11186cd4_staticRenderFns = []
Arrowvue_type_template_id_11186cd4_render._withStripped = true


// CONCATENATED MODULE: ./src/components/icons/Arrow.vue?vue&type=template&id=11186cd4&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/icons/Arrow.vue?vue&type=script&lang=js&
/* harmony default export */ var Arrowvue_type_script_lang_js_ = ({
  name: 'vue-treeselect--arrow'
});
// CONCATENATED MODULE: ./src/components/icons/Arrow.vue?vue&type=script&lang=js&
 /* harmony default export */ var icons_Arrowvue_type_script_lang_js_ = (Arrowvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/icons/Arrow.vue





/* normalize component */

var Arrow_component = normalizeComponent(
  icons_Arrowvue_type_script_lang_js_,
  Arrowvue_type_template_id_11186cd4_render,
  Arrowvue_type_template_id_11186cd4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Arrow_api; }
Arrow_component.options.__file = "src/components/icons/Arrow.vue"
/* harmony default export */ var Arrow = (Arrow_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Control.vue?vue&type=script&lang=js&





/* harmony default export */ var Controlvue_type_script_lang_js_ = ({
  name: 'vue-treeselect--control',
  inject: ['instance'],
  computed: {
    shouldShowX: function shouldShowX() {
      var instance = this.instance;
      return instance.clearable && !instance.disabled && instance.hasValue && (this.hasUndisabledValue || instance.allowClearingDisabled);
    },
    shouldShowArrow: function shouldShowArrow() {
      var instance = this.instance;
      if (!instance.alwaysOpen) return true;
      return !instance.menu.isOpen;
    },
    hasUndisabledValue: function hasUndisabledValue() {
      var instance = this.instance;
      return instance.hasValue && instance.internalValue.some(function (id) {
        return !instance.getNode(id).isDisabled;
      });
    }
  },
  methods: {
    renderX: function renderX() {
      var h = this.$createElement;
      var instance = this.instance;
      var title = instance.multiple ? instance.clearAllText : instance.clearValueText;
      if (!this.shouldShowX) return null;
      return h("div", {
        "class": "vue-treeselect__x-container",
        attrs: {
          title: title
        },
        on: {
          "mousedown": this.handleMouseDownOnX
        }
      }, [h(Delete, {
        "class": "vue-treeselect__x"
      })]);
    },
    renderArrow: function renderArrow() {
      var h = this.$createElement;
      var instance = this.instance;
      var arrowClass = {
        'vue-treeselect__control-arrow': true,
        'vue-treeselect__control-arrow--rotated': instance.menu.isOpen
      };
      if (!this.shouldShowArrow) return null;
      return h("div", {
        "class": "vue-treeselect__control-arrow-container",
        on: {
          "mousedown": this.handleMouseDownOnArrow
        }
      }, [h(Arrow, {
        "class": arrowClass
      })]);
    },
    handleMouseDownOnX: onLeftClick(function handleMouseDownOnX(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      var instance = this.instance;
      var result = instance.beforeClearAll();

      var handler = function handler(shouldClear) {
        if (shouldClear) instance.clear();
      };

      if (external_is_promise_default()(result)) {
        result.then(handler);
      } else {
        setTimeout(function () {
          return handler(result);
        }, 0);
      }
    }),
    handleMouseDownOnArrow: onLeftClick(function handleMouseDownOnArrow(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var instance = this.instance;
      instance.focusInput();
      instance.toggleMenu();
    }),
    renderValueContainer: function renderValueContainer(children) {
      var h = this.$createElement;
      return h("div", {
        "class": "vue-treeselect__value-container"
      }, [children]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var instance = this.instance;
    var ValueContainer = instance.single ? SingleValue : MultiValue;
    return h("div", {
      "class": "vue-treeselect__control",
      on: {
        "mousedown": instance.handleMouseDown
      }
    }, [h(ValueContainer, {
      ref: "value-container"
    }), this.renderX(), this.renderArrow()]);
  }
});
// CONCATENATED MODULE: ./src/components/Control.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Controlvue_type_script_lang_js_ = (Controlvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/Control.vue
var Control_render, Control_staticRenderFns




/* normalize component */

var Control_component = normalizeComponent(
  components_Controlvue_type_script_lang_js_,
  Control_render,
  Control_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Control_api; }
Control_component.options.__file = "src/components/Control.vue"
/* harmony default export */ var Control = (Control_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Tip.vue?vue&type=script&lang=js&
/* harmony default export */ var Tipvue_type_script_lang_js_ = ({
  name: 'vue-treeselect--tip',
  functional: true,
  props: {
    type: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  render: function render(_, context) {
    var h = arguments[0];
    var props = context.props,
        children = context.children;
    return h("div", {
      "class": "vue-treeselect__tip vue-treeselect__".concat(props.type, "-tip")
    }, [h("div", {
      "class": "vue-treeselect__icon-container"
    }, [h("span", {
      "class": "vue-treeselect__icon-".concat(props.icon)
    })]), h("span", {
      "class": "vue-treeselect__tip-text vue-treeselect__".concat(props.type, "-tip-text")
    }, [children])]);
  }
});
// CONCATENATED MODULE: ./src/components/Tip.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Tipvue_type_script_lang_js_ = (Tipvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/Tip.vue
var Tip_render, Tip_staticRenderFns




/* normalize component */

var Tip_component = normalizeComponent(
  components_Tipvue_type_script_lang_js_,
  Tip_render,
  Tip_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Tip_api; }
Tip_component.options.__file = "src/components/Tip.vue"
/* harmony default export */ var Tip = (Tip_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Option.vue?vue&type=script&lang=js&





var arrowPlaceholder, checkMark, minusMark;
var Option = {
  name: 'vue-treeselect--option',
  inject: ['instance'],
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {
    shouldExpand: function shouldExpand() {
      var instance = this.instance,
          node = this.node;
      return node.isBranch && instance.shouldExpand(node);
    },
    shouldShow: function shouldShow() {
      var instance = this.instance,
          node = this.node;
      return instance.shouldShowOptionInMenu(node);
    }
  },
  methods: {
    renderOption: function renderOption() {
      var h = this.$createElement;
      var instance = this.instance,
          node = this.node;
      var optionClass = {
        'vue-treeselect__option': true,
        'vue-treeselect__option--disabled': node.isDisabled,
        'vue-treeselect__option--selected': instance.isSelected(node),
        'vue-treeselect__option--highlight': node.isHighlighted,
        'vue-treeselect__option--matched': instance.localSearch.active && node.isMatched,
        'vue-treeselect__option--hide': !this.shouldShow
      };
      return h("div", {
        "class": optionClass,
        on: {
          "mouseenter": this.handleMouseEnterOption
        },
        attrs: {
          "data-id": node.id
        }
      }, [this.renderArrow(), this.renderLabelContainer([this.renderCheckboxContainer([this.renderCheckbox()]), this.renderLabel()])]);
    },
    renderSubOptionsList: function renderSubOptionsList() {
      var h = this.$createElement;
      if (!this.shouldExpand) return null;
      return h("div", {
        "class": "vue-treeselect__list"
      }, [this.renderSubOptions(), this.renderNoChildrenTip(), this.renderLoadingChildrenTip(), this.renderLoadingChildrenErrorTip()]);
    },
    renderArrow: function renderArrow() {
      var h = this.$createElement;
      var instance = this.instance,
          node = this.node;
      if (instance.shouldFlattenOptions && this.shouldShow) return null;

      if (node.isBranch) {
        var transitionProps = {
          props: {
            name: 'vue-treeselect__option-arrow--prepare',
            appear: true
          }
        };
        var arrowClass = {
          'vue-treeselect__option-arrow': true,
          'vue-treeselect__option-arrow--rotated': this.shouldExpand
        };
        return h("div", {
          "class": "vue-treeselect__option-arrow-container",
          on: {
            "mousedown": this.handleMouseDownOnArrow
          }
        }, [h("transition", transitionProps, [h(Arrow, {
          "class": arrowClass
        })])]);
      }

      if (instance.hasBranchNodes) {
        if (!arrowPlaceholder) arrowPlaceholder = h("div", {
          "class": "vue-treeselect__option-arrow-placeholder"
        }, ["\xA0"]);
        return arrowPlaceholder;
      }

      return null;
    },
    renderLabelContainer: function renderLabelContainer(children) {
      var h = this.$createElement;
      return h("div", {
        "class": "vue-treeselect__label-container",
        on: {
          "mousedown": this.handleMouseDownOnLabelContainer
        }
      }, [children]);
    },
    renderCheckboxContainer: function renderCheckboxContainer(children) {
      var h = this.$createElement;
      var instance = this.instance,
          node = this.node;
      if (instance.single) return null;
      if (instance.disableBranchNodes && node.isBranch) return null;
      return h("div", {
        "class": "vue-treeselect__checkbox-container"
      }, [children]);
    },
    renderCheckbox: function renderCheckbox() {
      var h = this.$createElement;
      var instance = this.instance,
          node = this.node;
      var checkedState = instance.forest.checkedStateMap[node.id];
      var checkboxClass = {
        'vue-treeselect__checkbox': true,
        'vue-treeselect__checkbox--checked': checkedState === CHECKED,
        'vue-treeselect__checkbox--indeterminate': checkedState === INDETERMINATE,
        'vue-treeselect__checkbox--unchecked': checkedState === UNCHECKED,
        'vue-treeselect__checkbox--disabled': node.isDisabled
      };
      if (!checkMark) checkMark = h("span", {
        "class": "vue-treeselect__check-mark"
      });
      if (!minusMark) minusMark = h("span", {
        "class": "vue-treeselect__minus-mark"
      });
      return h("span", {
        "class": checkboxClass
      }, [checkMark, minusMark]);
    },
    renderLabel: function renderLabel() {
      var h = this.$createElement;
      var instance = this.instance,
          node = this.node;
      var shouldShowCount = node.isBranch && (instance.localSearch.active ? instance.showCountOnSearchComputed : instance.showCount);
      var count = shouldShowCount ? instance.localSearch.active ? instance.localSearch.countMap[node.id][instance.showCountOf] : node.count[instance.showCountOf] : NaN;
      var labelClassName = 'vue-treeselect__label';
      var countClassName = 'vue-treeselect__count';
      var customLabelRenderer = instance.$scopedSlots['option-label'];
      if (customLabelRenderer) return customLabelRenderer({
        node: node,
        shouldShowCount: shouldShowCount,
        count: count,
        labelClassName: labelClassName,
        countClassName: countClassName
      });
      return h("label", {
        "class": labelClassName
      }, [node.label, shouldShowCount && h("span", {
        "class": countClassName
      }, ["(", count, ")"])]);
    },
    renderSubOptions: function renderSubOptions() {
      var h = this.$createElement;
      var node = this.node;
      if (!node.childrenStates.isLoaded) return null;
      return node.children.map(function (childNode) {
        return h(Option, {
          attrs: {
            node: childNode
          },
          key: childNode.id
        });
      });
    },
    renderNoChildrenTip: function renderNoChildrenTip() {
      var h = this.$createElement;
      var instance = this.instance,
          node = this.node;
      if (!node.childrenStates.isLoaded || node.children.length) return null;
      return h(Tip, {
        attrs: {
          type: "no-children",
          icon: "warning"
        }
      }, [instance.noChildrenText]);
    },
    renderLoadingChildrenTip: function renderLoadingChildrenTip() {
      var h = this.$createElement;
      var instance = this.instance,
          node = this.node;
      if (!node.childrenStates.isLoading) return null;
      return h(Tip, {
        attrs: {
          type: "loading",
          icon: "loader"
        }
      }, [instance.loadingText]);
    },
    renderLoadingChildrenErrorTip: function renderLoadingChildrenErrorTip() {
      var h = this.$createElement;
      var instance = this.instance,
          node = this.node;
      if (!node.childrenStates.loadingError) return null;
      return h(Tip, {
        attrs: {
          type: "error",
          icon: "error"
        }
      }, [node.childrenStates.loadingError, h("a", {
        "class": "vue-treeselect__retry",
        attrs: {
          title: instance.retryTitle
        },
        on: {
          "mousedown": this.handleMouseDownOnRetry
        }
      }, [instance.retryText])]);
    },
    handleMouseEnterOption: function handleMouseEnterOption(evt) {
      var instance = this.instance,
          node = this.node;
      if (evt.target !== evt.currentTarget) return;
      instance.setCurrentHighlightedOption(node, false);
    },
    handleMouseDownOnArrow: onLeftClick(function handleMouseDownOnOptionArrow() {
      var instance = this.instance,
          node = this.node;
      instance.toggleExpanded(node);
    }),
    handleMouseDownOnLabelContainer: onLeftClick(function handleMouseDownOnLabelContainer() {
      var instance = this.instance,
          node = this.node;

      if (node.isBranch && instance.disableBranchNodes) {
        instance.toggleExpanded(node);
      } else {
        instance.select(node);
      }
    }),
    handleMouseDownOnRetry: onLeftClick(function handleMouseDownOnRetry() {
      var instance = this.instance,
          node = this.node;
      instance.loadChildrenOptions(node);
    })
  },
  render: function render() {
    var h = arguments[0];
    var node = this.node;
    var indentLevel = this.instance.shouldFlattenOptions ? 0 : node.level;

    var listItemClass = defineProperty_default()({
      'vue-treeselect__list-item': true
    }, "vue-treeselect__indent-level-".concat(indentLevel), true);

    var transitionProps = {
      props: {
        name: 'vue-treeselect__list--transition'
      }
    };
    return h("div", {
      "class": listItemClass
    }, [this.renderOption(), node.isBranch && h("transition", transitionProps, [this.renderSubOptionsList()])]);
  }
};
/* harmony default export */ var Optionvue_type_script_lang_js_ = (Option);
// CONCATENATED MODULE: ./src/components/Option.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Optionvue_type_script_lang_js_ = (Optionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/Option.vue
var Option_render, Option_staticRenderFns




/* normalize component */

var Option_component = normalizeComponent(
  components_Optionvue_type_script_lang_js_,
  Option_render,
  Option_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Option_api; }
Option_component.options.__file = "src/components/Option.vue"
/* harmony default export */ var components_Option = (Option_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Menu.vue?vue&type=script&lang=js&




var directionMap = {
  top: 'top',
  bottom: 'bottom',
  above: 'top',
  below: 'bottom'
};
/* harmony default export */ var Menuvue_type_script_lang_js_ = ({
  name: 'vue-treeselect--menu',
  inject: ['instance'],
  computed: {
    menuStyle: function menuStyle() {
      var instance = this.instance;
      return {
        maxHeight: instance.maxHeight + 'px'
      };
    },
    menuContainerStyle: function menuContainerStyle() {
      var instance = this.instance;
      return {
        zIndex: instance.appendToBody ? null : instance.zIndex
      };
    }
  },
  watch: {
    'instance.menu.isOpen': function instanceMenuIsOpen(newValue) {
      if (newValue) {
        this.$nextTick(this.onMenuOpen);
      } else {
        this.onMenuClose();
      }
    }
  },
  created: function created() {
    this.menuSizeWatcher = null;
    this.menuResizeAndScrollEventListeners = null;
  },
  mounted: function mounted() {
    var instance = this.instance;
    if (instance.menu.isOpen) this.$nextTick(this.onMenuOpen);
  },
  destroyed: function destroyed() {
    this.onMenuClose();
  },
  methods: {
    renderMenu: function renderMenu() {
      var h = this.$createElement;
      var instance = this.instance;
      if (!instance.menu.isOpen) return null;
      return h("div", {
        ref: "menu",
        "class": "vue-treeselect__menu",
        on: {
          "mousedown": instance.handleMouseDown
        },
        style: this.menuStyle
      }, [this.renderBeforeList(), instance.async ? this.renderAsyncSearchMenuInner() : instance.localSearch.active ? this.renderLocalSearchMenuInner() : this.renderNormalMenuInner(), this.renderAfterList()]);
    },
    renderBeforeList: function renderBeforeList() {
      var instance = this.instance;
      var beforeListRenderer = instance.$scopedSlots['before-list'];
      return beforeListRenderer ? beforeListRenderer() : null;
    },
    renderAfterList: function renderAfterList() {
      var instance = this.instance;
      var afterListRenderer = instance.$scopedSlots['after-list'];
      return afterListRenderer ? afterListRenderer() : null;
    },
    renderNormalMenuInner: function renderNormalMenuInner() {
      var instance = this.instance;

      if (instance.rootOptionsStates.isLoading) {
        return this.renderLoadingOptionsTip();
      } else if (instance.rootOptionsStates.loadingError) {
        return this.renderLoadingRootOptionsErrorTip();
      } else if (instance.rootOptionsStates.isLoaded && instance.forest.normalizedOptions.length === 0) {
        return this.renderNoAvailableOptionsTip();
      } else {
        return this.renderOptionList();
      }
    },
    renderLocalSearchMenuInner: function renderLocalSearchMenuInner() {
      var instance = this.instance;

      if (instance.rootOptionsStates.isLoading) {
        return this.renderLoadingOptionsTip();
      } else if (instance.rootOptionsStates.loadingError) {
        return this.renderLoadingRootOptionsErrorTip();
      } else if (instance.rootOptionsStates.isLoaded && instance.forest.normalizedOptions.length === 0) {
        return this.renderNoAvailableOptionsTip();
      } else if (instance.localSearch.noResults) {
        return this.renderNoResultsTip();
      } else {
        return this.renderOptionList();
      }
    },
    renderAsyncSearchMenuInner: function renderAsyncSearchMenuInner() {
      var instance = this.instance;
      var entry = instance.getRemoteSearchEntry();
      var shouldShowSearchPromptTip = instance.trigger.searchQuery === '' && !instance.defaultOptions;
      var shouldShowNoResultsTip = shouldShowSearchPromptTip ? false : entry.isLoaded && entry.options.length === 0;

      if (shouldShowSearchPromptTip) {
        return this.renderSearchPromptTip();
      } else if (entry.isLoading) {
        return this.renderLoadingOptionsTip();
      } else if (entry.loadingError) {
        return this.renderAsyncSearchLoadingErrorTip();
      } else if (shouldShowNoResultsTip) {
        return this.renderNoResultsTip();
      } else {
        return this.renderOptionList();
      }
    },
    renderOptionList: function renderOptionList() {
      var h = this.$createElement;
      var instance = this.instance;
      return h("div", {
        "class": "vue-treeselect__list"
      }, [instance.forest.normalizedOptions.map(function (rootNode) {
        return h(components_Option, {
          attrs: {
            node: rootNode
          },
          key: rootNode.id
        });
      })]);
    },
    renderSearchPromptTip: function renderSearchPromptTip() {
      var h = this.$createElement;
      var instance = this.instance;
      return h(Tip, {
        attrs: {
          type: "search-prompt",
          icon: "warning"
        }
      }, [instance.searchPromptText]);
    },
    renderLoadingOptionsTip: function renderLoadingOptionsTip() {
      var h = this.$createElement;
      var instance = this.instance;
      return h(Tip, {
        attrs: {
          type: "loading",
          icon: "loader"
        }
      }, [instance.loadingText]);
    },
    renderLoadingRootOptionsErrorTip: function renderLoadingRootOptionsErrorTip() {
      var h = this.$createElement;
      var instance = this.instance;
      return h(Tip, {
        attrs: {
          type: "error",
          icon: "error"
        }
      }, [instance.rootOptionsStates.loadingError, h("a", {
        "class": "vue-treeselect__retry",
        on: {
          "click": instance.loadRootOptions
        },
        attrs: {
          title: instance.retryTitle
        }
      }, [instance.retryText])]);
    },
    renderAsyncSearchLoadingErrorTip: function renderAsyncSearchLoadingErrorTip() {
      var h = this.$createElement;
      var instance = this.instance;
      var entry = instance.getRemoteSearchEntry();
      return h(Tip, {
        attrs: {
          type: "error",
          icon: "error"
        }
      }, [entry.loadingError, h("a", {
        "class": "vue-treeselect__retry",
        on: {
          "click": instance.handleRemoteSearch
        },
        attrs: {
          title: instance.retryTitle
        }
      }, [instance.retryText])]);
    },
    renderNoAvailableOptionsTip: function renderNoAvailableOptionsTip() {
      var h = this.$createElement;
      var instance = this.instance;
      return h(Tip, {
        attrs: {
          type: "no-options",
          icon: "warning"
        }
      }, [instance.noOptionsText]);
    },
    renderNoResultsTip: function renderNoResultsTip() {
      var h = this.$createElement;
      var instance = this.instance;
      return h(Tip, {
        attrs: {
          type: "no-results",
          icon: "warning"
        }
      }, [instance.noResultsText]);
    },
    onMenuOpen: function onMenuOpen() {
      this.adjustMenuOpenDirection();
      this.setupMenuSizeWatcher();
      this.setupMenuResizeAndScrollEventListeners();
    },
    onMenuClose: function onMenuClose() {
      this.removeMenuSizeWatcher();
      this.removeMenuResizeAndScrollEventListeners();
    },
    adjustMenuOpenDirection: function adjustMenuOpenDirection() {
      var instance = this.instance;
      if (!instance.menu.isOpen) return;
      var $menu = instance.getMenu();
      var $control = instance.getControl();
      var menuRect = $menu.getBoundingClientRect();
      var controlRect = $control.getBoundingClientRect();
      var menuHeight = menuRect.height;
      var viewportHeight = window.innerHeight;
      var spaceAbove = controlRect.top;
      var spaceBelow = window.innerHeight - controlRect.bottom;
      var isControlInViewport = controlRect.top >= 0 && controlRect.top <= viewportHeight || controlRect.top < 0 && controlRect.bottom > 0;
      var hasEnoughSpaceBelow = spaceBelow > menuHeight + MENU_BUFFER;
      var hasEnoughSpaceAbove = spaceAbove > menuHeight + MENU_BUFFER;

      if (!isControlInViewport) {
        instance.closeMenu();
      } else if (instance.openDirection !== 'auto') {
        instance.menu.placement = directionMap[instance.openDirection];
      } else if (hasEnoughSpaceBelow || !hasEnoughSpaceAbove) {
        instance.menu.placement = 'bottom';
      } else {
        instance.menu.placement = 'top';
      }
    },
    setupMenuSizeWatcher: function setupMenuSizeWatcher() {
      var instance = this.instance;
      var $menu = instance.getMenu();
      if (this.menuSizeWatcher) return;
      this.menuSizeWatcher = {
        remove: watchSize($menu, this.adjustMenuOpenDirection)
      };
    },
    setupMenuResizeAndScrollEventListeners: function setupMenuResizeAndScrollEventListeners() {
      var instance = this.instance;
      var $control = instance.getControl();
      if (this.menuResizeAndScrollEventListeners) return;
      this.menuResizeAndScrollEventListeners = {
        remove: setupResizeAndScrollEventListeners($control, this.adjustMenuOpenDirection)
      };
    },
    removeMenuSizeWatcher: function removeMenuSizeWatcher() {
      if (!this.menuSizeWatcher) return;
      this.menuSizeWatcher.remove();
      this.menuSizeWatcher = null;
    },
    removeMenuResizeAndScrollEventListeners: function removeMenuResizeAndScrollEventListeners() {
      if (!this.menuResizeAndScrollEventListeners) return;
      this.menuResizeAndScrollEventListeners.remove();
      this.menuResizeAndScrollEventListeners = null;
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      ref: "menu-container",
      "class": "vue-treeselect__menu-container",
      style: this.menuContainerStyle
    }, [h("transition", {
      attrs: {
        name: "vue-treeselect__menu--transition"
      }
    }, [this.renderMenu()])]);
  }
});
// CONCATENATED MODULE: ./src/components/Menu.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Menuvue_type_script_lang_js_ = (Menuvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/Menu.vue
var Menu_render, Menu_staticRenderFns




/* normalize component */

var Menu_component = normalizeComponent(
  components_Menuvue_type_script_lang_js_,
  Menu_render,
  Menu_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Menu_api; }
Menu_component.options.__file = "src/components/Menu.vue"
/* harmony default export */ var Menu = (Menu_component.exports);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(14);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MenuPortal.vue?vue&type=script&lang=js&


function MenuPortalvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MenuPortalvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MenuPortalvue_type_script_lang_js_ownKeys(source, true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MenuPortalvue_type_script_lang_js_ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var PortalTarget = {
  name: 'vue-treeselect--portal-target',
  inject: ['instance'],
  watch: {
    'instance.menu.isOpen': function instanceMenuIsOpen(newValue) {
      if (newValue) {
        this.setupHandlers();
      } else {
        this.removeHandlers();
      }
    },
    'instance.menu.placement': function instanceMenuPlacement() {
      this.updateMenuContainerOffset();
    }
  },
  created: function created() {
    this.controlResizeAndScrollEventListeners = null;
    this.controlSizeWatcher = null;
  },
  mounted: function mounted() {
    var instance = this.instance;
    if (instance.menu.isOpen) this.setupHandlers();
  },
  methods: {
    setupHandlers: function setupHandlers() {
      this.updateWidth();
      this.updateMenuContainerOffset();
      this.setupControlResizeAndScrollEventListeners();
      this.setupControlSizeWatcher();
    },
    removeHandlers: function removeHandlers() {
      this.removeControlResizeAndScrollEventListeners();
      this.removeControlSizeWatcher();
    },
    setupControlResizeAndScrollEventListeners: function setupControlResizeAndScrollEventListeners() {
      var instance = this.instance;
      var $control = instance.getControl();
      if (this.controlResizeAndScrollEventListeners) return;
      this.controlResizeAndScrollEventListeners = {
        remove: setupResizeAndScrollEventListeners($control, this.updateMenuContainerOffset)
      };
    },
    setupControlSizeWatcher: function setupControlSizeWatcher() {
      var _this = this;

      var instance = this.instance;
      var $control = instance.getControl();
      if (this.controlSizeWatcher) return;
      this.controlSizeWatcher = {
        remove: watchSize($control, function () {
          _this.updateWidth();

          _this.updateMenuContainerOffset();
        })
      };
    },
    removeControlResizeAndScrollEventListeners: function removeControlResizeAndScrollEventListeners() {
      if (!this.controlResizeAndScrollEventListeners) return;
      this.controlResizeAndScrollEventListeners.remove();
      this.controlResizeAndScrollEventListeners = null;
    },
    removeControlSizeWatcher: function removeControlSizeWatcher() {
      if (!this.controlSizeWatcher) return;
      this.controlSizeWatcher.remove();
      this.controlSizeWatcher = null;
    },
    updateWidth: function updateWidth() {
      var instance = this.instance;
      var $portalTarget = this.$el;
      var $control = instance.getControl();
      var controlRect = $control.getBoundingClientRect();
      $portalTarget.style.width = controlRect.width + 'px';
    },
    updateMenuContainerOffset: function updateMenuContainerOffset() {
      var instance = this.instance;
      var $control = instance.getControl();
      var $portalTarget = this.$el;
      var controlRect = $control.getBoundingClientRect();
      var portalTargetRect = $portalTarget.getBoundingClientRect();
      var offsetY = instance.menu.placement === 'bottom' ? controlRect.height : 0;
      var left = Math.round(controlRect.left - portalTargetRect.left) + 'px';
      var top = Math.round(controlRect.top - portalTargetRect.top + offsetY) + 'px';
      var menuContainerStyle = this.$refs.menu.$refs['menu-container'].style;
      var transformVariations = ['transform', 'webkitTransform', 'MozTransform', 'msTransform'];
      var transform = find(transformVariations, function (t) {
        return t in document.body.style;
      });
      menuContainerStyle[transform] = "translate(".concat(left, ", ").concat(top, ")");
    }
  },
  render: function render() {
    var h = arguments[0];
    var instance = this.instance;
    var portalTargetClass = ['vue-treeselect__portal-target', instance.wrapperClass];
    var portalTargetStyle = {
      zIndex: instance.zIndex
    };
    return h("div", {
      "class": portalTargetClass,
      style: portalTargetStyle,
      attrs: {
        "data-instance-id": instance.getInstanceId()
      }
    }, [h(Menu, {
      ref: "menu"
    })]);
  },
  destroyed: function destroyed() {
    this.removeHandlers();
  }
};
var placeholder;
/* harmony default export */ var MenuPortalvue_type_script_lang_js_ = ({
  name: 'vue-treeselect--menu-portal',
  created: function created() {
    this.portalTarget = null;
  },
  mounted: function mounted() {
    this.setup();
  },
  destroyed: function destroyed() {
    this.teardown();
  },
  methods: {
    setup: function setup() {
      var el = document.createElement('div');
      document.body.appendChild(el);
      this.portalTarget = new external_vue_default.a(MenuPortalvue_type_script_lang_js_objectSpread({
        el: el,
        parent: this
      }, PortalTarget));
    },
    teardown: function teardown() {
      document.body.removeChild(this.portalTarget.$el);
      this.portalTarget.$el.innerHTML = '';
      this.portalTarget.$destroy();
      this.portalTarget = null;
    }
  },
  render: function render() {
    var h = arguments[0];
    if (!placeholder) placeholder = h("div", {
      "class": "vue-treeselect__menu-placeholder"
    });
    return placeholder;
  }
});
// CONCATENATED MODULE: ./src/components/MenuPortal.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_MenuPortalvue_type_script_lang_js_ = (MenuPortalvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/MenuPortal.vue
var MenuPortal_render, MenuPortal_staticRenderFns




/* normalize component */

var MenuPortal_component = normalizeComponent(
  components_MenuPortalvue_type_script_lang_js_,
  MenuPortal_render,
  MenuPortal_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var MenuPortal_api; }
MenuPortal_component.options.__file = "src/components/MenuPortal.vue"
/* harmony default export */ var MenuPortal = (MenuPortal_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Treeselect.vue?vue&type=script&lang=js&





/* harmony default export */ var Treeselectvue_type_script_lang_js_ = ({
  name: 'vue-treeselect',
  mixins: [treeselectMixin],
  computed: {
    wrapperClass: function wrapperClass() {
      return {
        'vue-treeselect': true,
        'vue-treeselect--single': this.single,
        'vue-treeselect--multi': this.multiple,
        'vue-treeselect--searchable': this.searchable,
        'vue-treeselect--disabled': this.disabled,
        'vue-treeselect--focused': this.trigger.isFocused,
        'vue-treeselect--has-value': this.hasValue,
        'vue-treeselect--open': this.menu.isOpen,
        'vue-treeselect--open-above': this.menu.placement === 'top',
        'vue-treeselect--open-below': this.menu.placement === 'bottom',
        'vue-treeselect--branch-nodes-disabled': this.disableBranchNodes,
        'vue-treeselect--append-to-body': this.appendToBody
      };
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      ref: "wrapper",
      "class": this.wrapperClass
    }, [h(HiddenFields), h(Control, {
      ref: "control"
    }), this.appendToBody ? h(MenuPortal, {
      ref: "portal"
    }) : h(Menu, {
      ref: "menu"
    })]);
  }
});
// CONCATENATED MODULE: ./src/components/Treeselect.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Treeselectvue_type_script_lang_js_ = (Treeselectvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/Treeselect.vue
var Treeselect_render, Treeselect_staticRenderFns




/* normalize component */

var Treeselect_component = normalizeComponent(
  components_Treeselectvue_type_script_lang_js_,
  Treeselect_render,
  Treeselect_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Treeselect_api; }
Treeselect_component.options.__file = "src/components/Treeselect.vue"
/* harmony default export */ var Treeselect = (Treeselect_component.exports);
// EXTERNAL MODULE: ./src/style.less
var style = __webpack_require__(15);

// CONCATENATED MODULE: ./src/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* concated harmony reexport Treeselect */__webpack_require__.d(__webpack_exports__, "Treeselect", function() { return Treeselect; });
/* concated harmony reexport treeselectMixin */__webpack_require__.d(__webpack_exports__, "treeselectMixin", function() { return treeselectMixin; });
/* concated harmony reexport LOAD_ROOT_OPTIONS */__webpack_require__.d(__webpack_exports__, "LOAD_ROOT_OPTIONS", function() { return LOAD_ROOT_OPTIONS; });
/* concated harmony reexport LOAD_CHILDREN_OPTIONS */__webpack_require__.d(__webpack_exports__, "LOAD_CHILDREN_OPTIONS", function() { return LOAD_CHILDREN_OPTIONS; });
/* concated harmony reexport ASYNC_SEARCH */__webpack_require__.d(__webpack_exports__, "ASYNC_SEARCH", function() { return ASYNC_SEARCH; });



/* harmony default export */ var src = __webpack_exports__["default"] = (Treeselect);


var VERSION = "0.4.0";

/***/ })
/******/ ]);
//# sourceMappingURL=vue-treeselect.cjs.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(1150)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(633)(module)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var core = __webpack_require__(50);
var hide = __webpack_require__(39);
var redefine = __webpack_require__(40);
var ctx = __webpack_require__(51);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/*!
* sweetalert2 v8.13.3
* Released under the MIT License.
*/
(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Sweetalert2 = factory());
}(this, (function () { 'use strict';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

var consolePrefix = 'SweetAlert2:';
/**
 * Filter the unique values into a new array
 * @param arr
 */

var uniqueArray = function uniqueArray(arr) {
  var result = [];

  for (var i = 0; i < arr.length; i++) {
    if (result.indexOf(arr[i]) === -1) {
      result.push(arr[i]);
    }
  }

  return result;
};
/**
 * Returns the array ob object values (Object.values isn't supported in IE11)
 * @param obj
 */

var objectValues = function objectValues(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
};
/**
 * Convert NodeList to Array
 * @param nodeList
 */

var toArray = function toArray(nodeList) {
  return Array.prototype.slice.call(nodeList);
};
/**
 * Standardise console warnings
 * @param message
 */

var warn = function warn(message) {
  console.warn("".concat(consolePrefix, " ").concat(message));
};
/**
 * Standardise console errors
 * @param message
 */

var error = function error(message) {
  console.error("".concat(consolePrefix, " ").concat(message));
};
/**
 * Private global state for `warnOnce`
 * @type {Array}
 * @private
 */

var previousWarnOnceMessages = [];
/**
 * Show a console warning, but only if it hasn't already been shown
 * @param message
 */

var warnOnce = function warnOnce(message) {
  if (!(previousWarnOnceMessages.indexOf(message) !== -1)) {
    previousWarnOnceMessages.push(message);
    warn(message);
  }
};
/**
 * Show a one-time console warning about deprecated params/methods
 */

var warnAboutDepreation = function warnAboutDepreation(deprecatedParam, useInstead) {
  warnOnce("\"".concat(deprecatedParam, "\" is deprecated and will be removed in the next major release. Please use \"").concat(useInstead, "\" instead."));
};
/**
 * If `arg` is a function, call it (with no arguments or context) and return the result.
 * Otherwise, just pass the value through
 * @param arg
 */

var callIfFunction = function callIfFunction(arg) {
  return typeof arg === 'function' ? arg() : arg;
};
var isPromise = function isPromise(arg) {
  return arg && Promise.resolve(arg) === arg;
};

var DismissReason = Object.freeze({
  cancel: 'cancel',
  backdrop: 'backdrop',
  close: 'close',
  esc: 'esc',
  timer: 'timer'
});

var argsToParams = function argsToParams(args) {
  var params = {};

  switch (_typeof(args[0])) {
    case 'object':
      _extends(params, args[0]);

      break;

    default:
      ['title', 'html', 'type'].forEach(function (name, index) {
        switch (_typeof(args[index])) {
          case 'string':
            params[name] = args[index];
            break;

          case 'undefined':
            break;

          default:
            error("Unexpected type of ".concat(name, "! Expected \"string\", got ").concat(_typeof(args[index])));
        }
      });
  }

  return params;
};

var swalPrefix = 'swal2-';
var prefix = function prefix(items) {
  var result = {};

  for (var i in items) {
    result[items[i]] = swalPrefix + items[i];
  }

  return result;
};
var swalClasses = prefix(['container', 'shown', 'height-auto', 'iosfix', 'popup', 'modal', 'no-backdrop', 'toast', 'toast-shown', 'toast-column', 'fade', 'show', 'hide', 'noanimation', 'close', 'title', 'header', 'content', 'actions', 'confirm', 'cancel', 'footer', 'icon', 'image', 'input', 'file', 'range', 'select', 'radio', 'checkbox', 'label', 'textarea', 'inputerror', 'validation-message', 'progress-steps', 'active-progress-step', 'progress-step', 'progress-step-line', 'loading', 'styled', 'top', 'top-start', 'top-end', 'top-left', 'top-right', 'center', 'center-start', 'center-end', 'center-left', 'center-right', 'bottom', 'bottom-start', 'bottom-end', 'bottom-left', 'bottom-right', 'grow-row', 'grow-column', 'grow-fullscreen', 'rtl']);
var iconTypes = prefix(['success', 'warning', 'info', 'question', 'error']);

var states = {
  previousBodyPadding: null
};
var hasClass = function hasClass(elem, className) {
  return elem.classList.contains(className);
};
var applyCustomClass = function applyCustomClass(elem, customClass, className) {
  // Clean up previous custom classes
  toArray(elem.classList).forEach(function (className) {
    if (!(objectValues(swalClasses).indexOf(className) !== -1) && !(objectValues(iconTypes).indexOf(className) !== -1)) {
      elem.classList.remove(className);
    }
  });

  if (customClass && customClass[className]) {
    addClass(elem, customClass[className]);
  }
};
function getInput(content, inputType) {
  if (!inputType) {
    return null;
  }

  switch (inputType) {
    case 'select':
    case 'textarea':
    case 'file':
      return getChildByClass(content, swalClasses[inputType]);

    case 'checkbox':
      return content.querySelector(".".concat(swalClasses.checkbox, " input"));

    case 'radio':
      return content.querySelector(".".concat(swalClasses.radio, " input:checked")) || content.querySelector(".".concat(swalClasses.radio, " input:first-child"));

    case 'range':
      return content.querySelector(".".concat(swalClasses.range, " input"));

    default:
      return getChildByClass(content, swalClasses.input);
  }
}
var focusInput = function focusInput(input) {
  input.focus(); // place cursor at end of text in text input

  if (input.type !== 'file') {
    // http://stackoverflow.com/a/2345915
    var val = input.value;
    input.value = '';
    input.value = val;
  }
};
var toggleClass = function toggleClass(target, classList, condition) {
  if (!target || !classList) {
    return;
  }

  if (typeof classList === 'string') {
    classList = classList.split(/\s+/).filter(Boolean);
  }

  classList.forEach(function (className) {
    if (target.forEach) {
      target.forEach(function (elem) {
        condition ? elem.classList.add(className) : elem.classList.remove(className);
      });
    } else {
      condition ? target.classList.add(className) : target.classList.remove(className);
    }
  });
};
var addClass = function addClass(target, classList) {
  toggleClass(target, classList, true);
};
var removeClass = function removeClass(target, classList) {
  toggleClass(target, classList, false);
};
var getChildByClass = function getChildByClass(elem, className) {
  for (var i = 0; i < elem.childNodes.length; i++) {
    if (hasClass(elem.childNodes[i], className)) {
      return elem.childNodes[i];
    }
  }
};
var applyNumericalStyle = function applyNumericalStyle(elem, property, value) {
  if (value || parseInt(value) === 0) {
    elem.style[property] = typeof value === 'number' ? value + 'px' : value;
  } else {
    elem.style.removeProperty(property);
  }
};
var show = function show(elem) {
  var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
  elem.style.opacity = '';
  elem.style.display = display;
};
var hide = function hide(elem) {
  elem.style.opacity = '';
  elem.style.display = 'none';
};
var toggle = function toggle(elem, condition, display) {
  condition ? show(elem, display) : hide(elem);
}; // borrowed from jquery $(elem).is(':visible') implementation

var isVisible = function isVisible(elem) {
  return !!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
};
var isScrollable = function isScrollable(elem) {
  return !!(elem.scrollHeight > elem.clientHeight);
}; // borrowed from https://stackoverflow.com/a/46352119

var hasCssAnimation = function hasCssAnimation(elem) {
  var style = window.getComputedStyle(elem);
  var animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
  var transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
  return animDuration > 0 || transDuration > 0;
};
var contains = function contains(haystack, needle) {
  if (typeof haystack.contains === 'function') {
    return haystack.contains(needle);
  }
};

var getContainer = function getContainer() {
  return document.body.querySelector('.' + swalClasses.container);
};
var elementBySelector = function elementBySelector(selectorString) {
  var container = getContainer();
  return container ? container.querySelector(selectorString) : null;
};

var elementByClass = function elementByClass(className) {
  return elementBySelector('.' + className);
};

var getPopup = function getPopup() {
  return elementByClass(swalClasses.popup);
};
var getIcons = function getIcons() {
  var popup = getPopup();
  return toArray(popup.querySelectorAll('.' + swalClasses.icon));
};
var getIcon = function getIcon() {
  var visibleIcon = getIcons().filter(function (icon) {
    return isVisible(icon);
  });
  return visibleIcon.length ? visibleIcon[0] : null;
};
var getTitle = function getTitle() {
  return elementByClass(swalClasses.title);
};
var getContent = function getContent() {
  return elementByClass(swalClasses.content);
};
var getImage = function getImage() {
  return elementByClass(swalClasses.image);
};
var getProgressSteps = function getProgressSteps() {
  return elementByClass(swalClasses['progress-steps']);
};
var getValidationMessage = function getValidationMessage() {
  return elementByClass(swalClasses['validation-message']);
};
var getConfirmButton = function getConfirmButton() {
  return elementBySelector('.' + swalClasses.actions + ' .' + swalClasses.confirm);
};
var getCancelButton = function getCancelButton() {
  return elementBySelector('.' + swalClasses.actions + ' .' + swalClasses.cancel);
};
var getActions = function getActions() {
  return elementByClass(swalClasses.actions);
};
var getHeader = function getHeader() {
  return elementByClass(swalClasses.header);
};
var getFooter = function getFooter() {
  return elementByClass(swalClasses.footer);
};
var getCloseButton = function getCloseButton() {
  return elementByClass(swalClasses.close);
};
var getFocusableElements = function getFocusableElements() {
  var focusableElementsWithTabindex = toArray(getPopup().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])')) // sort according to tabindex
  .sort(function (a, b) {
    a = parseInt(a.getAttribute('tabindex'));
    b = parseInt(b.getAttribute('tabindex'));

    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    }

    return 0;
  }); // https://github.com/jkup/focusable/blob/master/index.js

  var otherFocusableElements = toArray(getPopup().querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls]')).filter(function (el) {
    return el.getAttribute('tabindex') !== '-1';
  });
  return uniqueArray(focusableElementsWithTabindex.concat(otherFocusableElements)).filter(function (el) {
    return isVisible(el);
  });
};
var isModal = function isModal() {
  return !isToast() && !document.body.classList.contains(swalClasses['no-backdrop']);
};
var isToast = function isToast() {
  return document.body.classList.contains(swalClasses['toast-shown']);
};
var isLoading = function isLoading() {
  return getPopup().hasAttribute('data-loading');
};

// Detect Node env
var isNodeEnv = function isNodeEnv() {
  return typeof window === 'undefined' || typeof document === 'undefined';
};

var sweetHTML = "\n <div aria-labelledby=\"".concat(swalClasses.title, "\" aria-describedby=\"").concat(swalClasses.content, "\" class=\"").concat(swalClasses.popup, "\" tabindex=\"-1\">\n   <div class=\"").concat(swalClasses.header, "\">\n     <ul class=\"").concat(swalClasses['progress-steps'], "\"></ul>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.error, "\">\n       <span class=\"swal2-x-mark\"><span class=\"swal2-x-mark-line-left\"></span><span class=\"swal2-x-mark-line-right\"></span></span>\n     </div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.question, "\"></div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.warning, "\"></div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.info, "\"></div>\n     <div class=\"").concat(swalClasses.icon, " ").concat(iconTypes.success, "\">\n       <div class=\"swal2-success-circular-line-left\"></div>\n       <span class=\"swal2-success-line-tip\"></span> <span class=\"swal2-success-line-long\"></span>\n       <div class=\"swal2-success-ring\"></div> <div class=\"swal2-success-fix\"></div>\n       <div class=\"swal2-success-circular-line-right\"></div>\n     </div>\n     <img class=\"").concat(swalClasses.image, "\" />\n     <h2 class=\"").concat(swalClasses.title, "\" id=\"").concat(swalClasses.title, "\"></h2>\n     <button type=\"button\" class=\"").concat(swalClasses.close, "\">&times;</button>\n   </div>\n   <div class=\"").concat(swalClasses.content, "\">\n     <div id=\"").concat(swalClasses.content, "\"></div>\n     <input class=\"").concat(swalClasses.input, "\" />\n     <input type=\"file\" class=\"").concat(swalClasses.file, "\" />\n     <div class=\"").concat(swalClasses.range, "\">\n       <input type=\"range\" />\n       <output></output>\n     </div>\n     <select class=\"").concat(swalClasses.select, "\"></select>\n     <div class=\"").concat(swalClasses.radio, "\"></div>\n     <label for=\"").concat(swalClasses.checkbox, "\" class=\"").concat(swalClasses.checkbox, "\">\n       <input type=\"checkbox\" />\n       <span class=\"").concat(swalClasses.label, "\"></span>\n     </label>\n     <textarea class=\"").concat(swalClasses.textarea, "\"></textarea>\n     <div class=\"").concat(swalClasses['validation-message'], "\" id=\"").concat(swalClasses['validation-message'], "\"></div>\n   </div>\n   <div class=\"").concat(swalClasses.actions, "\">\n     <button type=\"button\" class=\"").concat(swalClasses.confirm, "\">OK</button>\n     <button type=\"button\" class=\"").concat(swalClasses.cancel, "\">Cancel</button>\n   </div>\n   <div class=\"").concat(swalClasses.footer, "\">\n   </div>\n </div>\n").replace(/(^|\n)\s*/g, '');

var resetOldContainer = function resetOldContainer() {
  var oldContainer = getContainer();

  if (!oldContainer) {
    return;
  }

  oldContainer.parentNode.removeChild(oldContainer);
  removeClass([document.documentElement, document.body], [swalClasses['no-backdrop'], swalClasses['toast-shown'], swalClasses['has-column']]);
};

var oldInputVal; // IE11 workaround, see #1109 for details

var resetValidationMessage = function resetValidationMessage(e) {
  if (Swal.isVisible() && oldInputVal !== e.target.value) {
    Swal.resetValidationMessage();
  }

  oldInputVal = e.target.value;
};

var addInputChangeListeners = function addInputChangeListeners() {
  var content = getContent();
  var input = getChildByClass(content, swalClasses.input);
  var file = getChildByClass(content, swalClasses.file);
  var range = content.querySelector(".".concat(swalClasses.range, " input"));
  var rangeOutput = content.querySelector(".".concat(swalClasses.range, " output"));
  var select = getChildByClass(content, swalClasses.select);
  var checkbox = content.querySelector(".".concat(swalClasses.checkbox, " input"));
  var textarea = getChildByClass(content, swalClasses.textarea);
  input.oninput = resetValidationMessage;
  file.onchange = resetValidationMessage;
  select.onchange = resetValidationMessage;
  checkbox.onchange = resetValidationMessage;
  textarea.oninput = resetValidationMessage;

  range.oninput = function (e) {
    resetValidationMessage(e);
    rangeOutput.value = range.value;
  };

  range.onchange = function (e) {
    resetValidationMessage(e);
    range.nextSibling.value = range.value;
  };
};

var getTarget = function getTarget(target) {
  return typeof target === 'string' ? document.querySelector(target) : target;
};

var setupAccessibility = function setupAccessibility(params) {
  var popup = getPopup();
  popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
  popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');

  if (!params.toast) {
    popup.setAttribute('aria-modal', 'true');
  }
};

var setupRTL = function setupRTL(targetElement) {
  if (window.getComputedStyle(targetElement).direction === 'rtl') {
    addClass(getContainer(), swalClasses.rtl);
  }
};
/*
 * Add modal + backdrop to DOM
 */


var init = function init(params) {
  // Clean up the old popup container if it exists
  resetOldContainer();
  /* istanbul ignore if */

  if (isNodeEnv()) {
    error('SweetAlert2 requires document to initialize');
    return;
  }

  var container = document.createElement('div');
  container.className = swalClasses.container;
  container.innerHTML = sweetHTML;
  var targetElement = getTarget(params.target);
  targetElement.appendChild(container);
  setupAccessibility(params);
  setupRTL(targetElement);
  addInputChangeListeners();
};

var parseHtmlToContainer = function parseHtmlToContainer(param, target) {
  // DOM element
  if (param instanceof HTMLElement) {
    target.appendChild(param); // JQuery element(s)
  } else if (_typeof(param) === 'object') {
    handleJqueryElem(target, param); // Plain string
  } else if (param) {
    target.innerHTML = param;
  }
};

var handleJqueryElem = function handleJqueryElem(target, elem) {
  target.innerHTML = '';

  if (0 in elem) {
    for (var i = 0; i in elem; i++) {
      target.appendChild(elem[i].cloneNode(true));
    }
  } else {
    target.appendChild(elem.cloneNode(true));
  }
};

var animationEndEvent = function () {
  // Prevent run in Node env

  /* istanbul ignore if */
  if (isNodeEnv()) {
    return false;
  }

  var testEl = document.createElement('div');
  var transEndEventNames = {
    'WebkitAnimation': 'webkitAnimationEnd',
    'OAnimation': 'oAnimationEnd oanimationend',
    'animation': 'animationend'
  };

  for (var i in transEndEventNames) {
    if (Object.prototype.hasOwnProperty.call(transEndEventNames, i) && typeof testEl.style[i] !== 'undefined') {
      return transEndEventNames[i];
    }
  }

  return false;
}();

// Measure width of scrollbar
// https://github.com/twbs/bootstrap/blob/master/js/modal.js#L279-L286
var measureScrollbar = function measureScrollbar() {
  var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

  if (supportsTouch) {
    return 0;
  }

  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};

function handleButtonsStyling(confirmButton, cancelButton, params) {
  addClass([confirmButton, cancelButton], swalClasses.styled); // Buttons background colors

  if (params.confirmButtonColor) {
    confirmButton.style.backgroundColor = params.confirmButtonColor;
  }

  if (params.cancelButtonColor) {
    cancelButton.style.backgroundColor = params.cancelButtonColor;
  } // Loading state


  var confirmButtonBackgroundColor = window.getComputedStyle(confirmButton).getPropertyValue('background-color');
  confirmButton.style.borderLeftColor = confirmButtonBackgroundColor;
  confirmButton.style.borderRightColor = confirmButtonBackgroundColor;
}

function renderButton(button, buttonType, params) {
  toggle(button, params['showC' + buttonType.substring(1) + 'Button'], 'inline-block');
  button.innerHTML = params[buttonType + 'ButtonText']; // Set caption text

  button.setAttribute('aria-label', params[buttonType + 'ButtonAriaLabel']); // ARIA label
  // Add buttons custom classes

  button.className = swalClasses[buttonType];
  applyCustomClass(button, params.customClass, buttonType + 'Button');
  addClass(button, params[buttonType + 'ButtonClass']);
}

var renderActions = function renderActions(instance, params) {
  var actions = getActions();
  var confirmButton = getConfirmButton();
  var cancelButton = getCancelButton(); // Actions (buttons) wrapper

  if (!params.showConfirmButton && !params.showCancelButton) {
    hide(actions);
  } else {
    show(actions);
  } // Custom class


  applyCustomClass(actions, params.customClass, 'actions'); // Render confirm button

  renderButton(confirmButton, 'confirm', params); // render Cancel Button

  renderButton(cancelButton, 'cancel', params);

  if (params.buttonsStyling) {
    handleButtonsStyling(confirmButton, cancelButton, params);
  } else {
    removeClass([confirmButton, cancelButton], swalClasses.styled);
    confirmButton.style.backgroundColor = confirmButton.style.borderLeftColor = confirmButton.style.borderRightColor = '';
    cancelButton.style.backgroundColor = cancelButton.style.borderLeftColor = cancelButton.style.borderRightColor = '';
  }
};

function handleBackdropParam(container, backdrop) {
  if (typeof backdrop === 'string') {
    container.style.background = backdrop;
  } else if (!backdrop) {
    addClass([document.documentElement, document.body], swalClasses['no-backdrop']);
  }
}

function handlePositionParam(container, position) {
  if (position in swalClasses) {
    addClass(container, swalClasses[position]);
  } else {
    warn('The "position" parameter is not valid, defaulting to "center"');
    addClass(container, swalClasses.center);
  }
}

function handleGrowParam(container, grow) {
  if (grow && typeof grow === 'string') {
    var growClass = 'grow-' + grow;

    if (growClass in swalClasses) {
      addClass(container, swalClasses[growClass]);
    }
  }
}

var renderContainer = function renderContainer(instance, params) {
  var container = getContainer();

  if (!container) {
    return;
  }

  handleBackdropParam(container, params.backdrop);

  if (!params.backdrop && params.allowOutsideClick) {
    warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
  }

  handlePositionParam(container, params.position);
  handleGrowParam(container, params.grow); // Custom class

  applyCustomClass(container, params.customClass, 'container');

  if (params.customContainerClass) {
    // @deprecated
    addClass(container, params.customContainerClass);
  }
};

/**
 * This module containts `WeakMap`s for each effectively-"private  property" that a `Swal` has.
 * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
 * This is the approach that Babel will probably take to implement private methods/fields
 *   https://github.com/tc39/proposal-private-methods
 *   https://github.com/babel/babel/pull/7555
 * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
 *   then we can use that language feature.
 */
var privateProps = {
  promise: new WeakMap(),
  innerParams: new WeakMap(),
  domCache: new WeakMap()
};

var inputTypes = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea'];
var renderInput = function renderInput(instance, params) {
  var content = getContent();
  var innerParams = privateProps.innerParams.get(instance);
  var rerender = !innerParams || params.input !== innerParams.input;
  inputTypes.forEach(function (inputType) {
    var inputClass = swalClasses[inputType];
    var inputContainer = getChildByClass(content, inputClass); // set attributes

    setAttributes(inputType, params.inputAttributes); // set class

    setClass(inputContainer, inputClass, params);

    if (rerender) {
      hide(inputContainer);
    }
  });

  if (params.input && rerender) {
    showInput(params);
  }
};

var showInput = function showInput(params) {
  if (!renderInputType[params.input]) {
    return error("Unexpected type of input! Expected \"text\", \"email\", \"password\", \"number\", \"tel\", \"select\", \"radio\", \"checkbox\", \"textarea\", \"file\" or \"url\", got \"".concat(params.input, "\""));
  }

  var input = renderInputType[params.input](params);
  show(input);
};

var removeAttributes = function removeAttributes(input) {
  for (var i = 0; i < input.attributes.length; i++) {
    var attrName = input.attributes[i].name;

    if (!(['type', 'value', 'style'].indexOf(attrName) !== -1)) {
      input.removeAttribute(attrName);
    }
  }
};

var setAttributes = function setAttributes(inputType, inputAttributes) {
  var input = getInput(getContent(), inputType);

  if (!input) {
    return;
  }

  removeAttributes(input);

  for (var attr in inputAttributes) {
    // Do not set a placeholder for <input type="range">
    // it'll crash Edge, #1298
    if (inputType === 'range' && attr === 'placeholder') {
      continue;
    }

    input.setAttribute(attr, inputAttributes[attr]);
  }
};

var setClass = function setClass(inputContainer, inputClass, params) {
  inputContainer.className = inputClass;

  if (params.inputClass) {
    addClass(inputContainer, params.inputClass);
  }

  if (params.customClass) {
    addClass(inputContainer, params.customClass.input);
  }
};

var setInputPlaceholder = function setInputPlaceholder(input, params) {
  if (!input.placeholder || params.inputPlaceholder) {
    input.placeholder = params.inputPlaceholder;
  }
};

var renderInputType = {};

renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = function (params) {
  var input = getChildByClass(getContent(), swalClasses.input);

  if (typeof params.inputValue === 'string' || typeof params.inputValue === 'number') {
    input.value = params.inputValue;
  } else if (!isPromise(params.inputValue)) {
    warn("Unexpected type of inputValue! Expected \"string\", \"number\" or \"Promise\", got \"".concat(_typeof(params.inputValue), "\""));
  }

  setInputPlaceholder(input, params);
  input.type = params.input;
  return input;
};

renderInputType.file = function (params) {
  var input = getChildByClass(getContent(), swalClasses.file);
  setInputPlaceholder(input, params);
  input.type = params.input;
  return input;
};

renderInputType.range = function (params) {
  var range = getChildByClass(getContent(), swalClasses.range);
  var rangeInput = range.querySelector('input');
  var rangeOutput = range.querySelector('output');
  rangeInput.value = params.inputValue;
  rangeInput.type = params.input;
  rangeOutput.value = params.inputValue;
  return range;
};

renderInputType.select = function (params) {
  var select = getChildByClass(getContent(), swalClasses.select);
  select.innerHTML = '';

  if (params.inputPlaceholder) {
    var placeholder = document.createElement('option');
    placeholder.innerHTML = params.inputPlaceholder;
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);
  }

  return select;
};

renderInputType.radio = function () {
  var radio = getChildByClass(getContent(), swalClasses.radio);
  radio.innerHTML = '';
  return radio;
};

renderInputType.checkbox = function (params) {
  var checkbox = getChildByClass(getContent(), swalClasses.checkbox);
  var checkboxInput = getInput(getContent(), 'checkbox');
  checkboxInput.type = 'checkbox';
  checkboxInput.value = 1;
  checkboxInput.id = swalClasses.checkbox;
  checkboxInput.checked = Boolean(params.inputValue);
  var label = checkbox.querySelector('span');
  label.innerHTML = params.inputPlaceholder;
  return checkbox;
};

renderInputType.textarea = function (params) {
  var textarea = getChildByClass(getContent(), swalClasses.textarea);
  textarea.value = params.inputValue;
  setInputPlaceholder(textarea, params);
  return textarea;
};

var renderContent = function renderContent(instance, params) {
  var content = getContent().querySelector('#' + swalClasses.content); // Content as HTML

  if (params.html) {
    parseHtmlToContainer(params.html, content);
    show(content, 'block'); // Content as plain text
  } else if (params.text) {
    content.textContent = params.text;
    show(content, 'block'); // No content
  } else {
    hide(content);
  }

  renderInput(instance, params); // Custom class

  applyCustomClass(getContent(), params.customClass, 'content');
};

var renderFooter = function renderFooter(instance, params) {
  var footer = getFooter();
  toggle(footer, params.footer);

  if (params.footer) {
    parseHtmlToContainer(params.footer, footer);
  } // Custom class


  applyCustomClass(footer, params.customClass, 'footer');
};

var renderCloseButton = function renderCloseButton(instance, params) {
  var closeButton = getCloseButton(); // Custom class

  applyCustomClass(closeButton, params.customClass, 'closeButton');
  toggle(closeButton, params.showCloseButton);
  closeButton.setAttribute('aria-label', params.closeButtonAriaLabel);
};

var renderIcon = function renderIcon(instance, params) {
  var innerParams = privateProps.innerParams.get(instance); // if the icon with the given type already rendered,
  // apply the custom class without re-rendering the icon

  if (innerParams && params.type === innerParams.type && getIcon()) {
    applyCustomClass(getIcon(), params.customClass, 'icon');
    return;
  }

  hideAllIcons();

  if (!params.type) {
    return;
  }

  adjustSuccessIconBackgoundColor();

  if (Object.keys(iconTypes).indexOf(params.type) !== -1) {
    var icon = elementBySelector(".".concat(swalClasses.icon, ".").concat(iconTypes[params.type]));
    show(icon); // Custom class

    applyCustomClass(icon, params.customClass, 'icon'); // Animate icon

    toggleClass(icon, "swal2-animate-".concat(params.type, "-icon"), params.animation);
  } else {
    error("Unknown type! Expected \"success\", \"error\", \"warning\", \"info\" or \"question\", got \"".concat(params.type, "\""));
  }
};

var hideAllIcons = function hideAllIcons() {
  var icons = getIcons();

  for (var i = 0; i < icons.length; i++) {
    hide(icons[i]);
  }
}; // Adjust success icon background color to match the popup background color


var adjustSuccessIconBackgoundColor = function adjustSuccessIconBackgoundColor() {
  var popup = getPopup();
  var popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
  var successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');

  for (var i = 0; i < successIconParts.length; i++) {
    successIconParts[i].style.backgroundColor = popupBackgroundColor;
  }
};

var renderImage = function renderImage(instance, params) {
  var image = getImage();

  if (!params.imageUrl) {
    return hide(image);
  }

  show(image); // Src, alt

  image.setAttribute('src', params.imageUrl);
  image.setAttribute('alt', params.imageAlt); // Width, height

  applyNumericalStyle(image, 'width', params.imageWidth);
  applyNumericalStyle(image, 'height', params.imageHeight); // Class

  image.className = swalClasses.image;
  applyCustomClass(image, params.customClass, 'image');

  if (params.imageClass) {
    addClass(image, params.imageClass);
  }
};

var createStepElement = function createStepElement(step) {
  var stepEl = document.createElement('li');
  addClass(stepEl, swalClasses['progress-step']);
  stepEl.innerHTML = step;
  return stepEl;
};

var createLineElement = function createLineElement(params) {
  var lineEl = document.createElement('li');
  addClass(lineEl, swalClasses['progress-step-line']);

  if (params.progressStepsDistance) {
    lineEl.style.width = params.progressStepsDistance;
  }

  return lineEl;
};

var renderProgressSteps = function renderProgressSteps(instance, params) {
  var progressStepsContainer = getProgressSteps();

  if (!params.progressSteps || params.progressSteps.length === 0) {
    return hide(progressStepsContainer);
  }

  show(progressStepsContainer);
  progressStepsContainer.innerHTML = '';
  var currentProgressStep = parseInt(params.currentProgressStep === null ? Swal.getQueueStep() : params.currentProgressStep);

  if (currentProgressStep >= params.progressSteps.length) {
    warn('Invalid currentProgressStep parameter, it should be less than progressSteps.length ' + '(currentProgressStep like JS arrays starts from 0)');
  }

  params.progressSteps.forEach(function (step, index) {
    var stepEl = createStepElement(step);
    progressStepsContainer.appendChild(stepEl);

    if (index === currentProgressStep) {
      addClass(stepEl, swalClasses['active-progress-step']);
    }

    if (index !== params.progressSteps.length - 1) {
      var lineEl = createLineElement(step);
      progressStepsContainer.appendChild(lineEl);
    }
  });
};

var renderTitle = function renderTitle(instance, params) {
  var title = getTitle();
  toggle(title, params.title || params.titleText);

  if (params.title) {
    parseHtmlToContainer(params.title, title);
  }

  if (params.titleText) {
    title.innerText = params.titleText;
  } // Custom class


  applyCustomClass(title, params.customClass, 'title');
};

var renderHeader = function renderHeader(instance, params) {
  var header = getHeader(); // Custom class

  applyCustomClass(header, params.customClass, 'header'); // Progress steps

  renderProgressSteps(instance, params); // Icon

  renderIcon(instance, params); // Image

  renderImage(instance, params); // Title

  renderTitle(instance, params); // Close button

  renderCloseButton(instance, params);
};

var renderPopup = function renderPopup(instance, params) {
  var popup = getPopup(); // Width

  applyNumericalStyle(popup, 'width', params.width); // Padding

  applyNumericalStyle(popup, 'padding', params.padding); // Background

  if (params.background) {
    popup.style.background = params.background;
  } // Default Class


  popup.className = swalClasses.popup;

  if (params.toast) {
    addClass([document.documentElement, document.body], swalClasses['toast-shown']);
    addClass(popup, swalClasses.toast);
  } else {
    addClass(popup, swalClasses.modal);
  } // Custom class


  applyCustomClass(popup, params.customClass, 'popup');

  if (typeof params.customClass === 'string') {
    addClass(popup, params.customClass);
  } // CSS animation


  toggleClass(popup, swalClasses.noanimation, !params.animation);
};

var render = function render(instance, params) {
  renderPopup(instance, params);
  renderContainer(instance, params);
  renderHeader(instance, params);
  renderContent(instance, params);
  renderActions(instance, params);
  renderFooter(instance, params);
};

/*
 * Global function to determine if SweetAlert2 popup is shown
 */

var isVisible$1 = function isVisible$$1() {
  return isVisible(getPopup());
};
/*
 * Global function to click 'Confirm' button
 */

var clickConfirm = function clickConfirm() {
  return getConfirmButton() && getConfirmButton().click();
};
/*
 * Global function to click 'Cancel' button
 */

var clickCancel = function clickCancel() {
  return getCancelButton() && getCancelButton().click();
};

function fire() {
  var Swal = this;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _construct(Swal, args);
}

/**
 * Returns an extended version of `Swal` containing `params` as defaults.
 * Useful for reusing Swal configuration.
 *
 * For example:
 *
 * Before:
 * const textPromptOptions = { input: 'text', showCancelButton: true }
 * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
 * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
 *
 * After:
 * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
 * const {value: firstName} = await TextPrompt('What is your first name?')
 * const {value: lastName} = await TextPrompt('What is your last name?')
 *
 * @param mixinParams
 */
function mixin(mixinParams) {
  var MixinSwal =
  /*#__PURE__*/
  function (_this) {
    _inherits(MixinSwal, _this);

    function MixinSwal() {
      _classCallCheck(this, MixinSwal);

      return _possibleConstructorReturn(this, _getPrototypeOf(MixinSwal).apply(this, arguments));
    }

    _createClass(MixinSwal, [{
      key: "_main",
      value: function _main(params) {
        return _get(_getPrototypeOf(MixinSwal.prototype), "_main", this).call(this, _extends({}, mixinParams, params));
      }
    }]);

    return MixinSwal;
  }(this);

  return MixinSwal;
}

// private global state for the queue feature
var currentSteps = [];
/*
 * Global function for chaining sweetAlert popups
 */

var queue = function queue(steps) {
  var Swal = this;
  currentSteps = steps;

  var resetAndResolve = function resetAndResolve(resolve, value) {
    currentSteps = [];
    document.body.removeAttribute('data-swal2-queue-step');
    resolve(value);
  };

  var queueResult = [];
  return new Promise(function (resolve) {
    (function step(i, callback) {
      if (i < currentSteps.length) {
        document.body.setAttribute('data-swal2-queue-step', i);
        Swal.fire(currentSteps[i]).then(function (result) {
          if (typeof result.value !== 'undefined') {
            queueResult.push(result.value);
            step(i + 1, callback);
          } else {
            resetAndResolve(resolve, {
              dismiss: result.dismiss
            });
          }
        });
      } else {
        resetAndResolve(resolve, {
          value: queueResult
        });
      }
    })(0);
  });
};
/*
 * Global function for getting the index of current popup in queue
 */

var getQueueStep = function getQueueStep() {
  return document.body.getAttribute('data-swal2-queue-step');
};
/*
 * Global function for inserting a popup to the queue
 */

var insertQueueStep = function insertQueueStep(step, index) {
  if (index && index < currentSteps.length) {
    return currentSteps.splice(index, 0, step);
  }

  return currentSteps.push(step);
};
/*
 * Global function for deleting a popup from the queue
 */

var deleteQueueStep = function deleteQueueStep(index) {
  if (typeof currentSteps[index] !== 'undefined') {
    currentSteps.splice(index, 1);
  }
};

/**
 * Show spinner instead of Confirm button and disable Cancel button
 */

var showLoading = function showLoading() {
  var popup = getPopup();

  if (!popup) {
    Swal.fire('');
  }

  popup = getPopup();
  var actions = getActions();
  var confirmButton = getConfirmButton();
  var cancelButton = getCancelButton();
  show(actions);
  show(confirmButton);
  addClass([popup, actions], swalClasses.loading);
  confirmButton.disabled = true;
  cancelButton.disabled = true;
  popup.setAttribute('data-loading', true);
  popup.setAttribute('aria-busy', true);
  popup.focus();
};

var RESTORE_FOCUS_TIMEOUT = 100;
var DISPOSE_SWAL_TIMEOUT = 36000;

var globalState = {};
var focusPreviousActiveElement = function focusPreviousActiveElement() {
  if (globalState.previousActiveElement && globalState.previousActiveElement.focus) {
    globalState.previousActiveElement.focus();
    globalState.previousActiveElement = null;
  } else if (document.body) {
    document.body.focus();
  }
}; // Restore previous active (focused) element


var restoreActiveElement = function restoreActiveElement() {
  return new Promise(function (resolve) {
    var x = window.scrollX;
    var y = window.scrollY;
    globalState.restoreFocusTimeout = setTimeout(function () {
      focusPreviousActiveElement();
      resolve();
    }, RESTORE_FOCUS_TIMEOUT); // issues/900

    if (typeof x !== 'undefined' && typeof y !== 'undefined') {
      // IE doesn't have scrollX/scrollY support
      window.scrollTo(x, y);
    }
  });
};

/**
 * If `timer` parameter is set, returns number of milliseconds of timer remained.
 * Otherwise, returns undefined.
 */

var getTimerLeft = function getTimerLeft() {
  return globalState.timeout && globalState.timeout.getTimerLeft();
};
/**
 * Stop timer. Returns number of milliseconds of timer remained.
 * If `timer` parameter isn't set, returns undefined.
 */

var stopTimer = function stopTimer() {
  return globalState.timeout && globalState.timeout.stop();
};
/**
 * Resume timer. Returns number of milliseconds of timer remained.
 * If `timer` parameter isn't set, returns undefined.
 */

var resumeTimer = function resumeTimer() {
  return globalState.timeout && globalState.timeout.start();
};
/**
 * Resume timer. Returns number of milliseconds of timer remained.
 * If `timer` parameter isn't set, returns undefined.
 */

var toggleTimer = function toggleTimer() {
  var timer = globalState.timeout;
  return timer && (timer.running ? timer.stop() : timer.start());
};
/**
 * Increase timer. Returns number of milliseconds of an updated timer.
 * If `timer` parameter isn't set, returns undefined.
 */

var increaseTimer = function increaseTimer(n) {
  return globalState.timeout && globalState.timeout.increase(n);
};
/**
 * Check if timer is running. Returns true if timer is running
 * or false if timer is paused or stopped.
 * If `timer` parameter isn't set, returns undefined
 */

var isTimerRunning = function isTimerRunning() {
  return globalState.timeout && globalState.timeout.isRunning();
};

var defaultParams = {
  title: '',
  titleText: '',
  text: '',
  html: '',
  footer: '',
  type: null,
  toast: false,
  customClass: '',
  customContainerClass: '',
  target: 'body',
  backdrop: true,
  animation: true,
  heightAuto: true,
  allowOutsideClick: true,
  allowEscapeKey: true,
  allowEnterKey: true,
  stopKeydownPropagation: true,
  keydownListenerCapture: false,
  showConfirmButton: true,
  showCancelButton: false,
  preConfirm: null,
  confirmButtonText: 'OK',
  confirmButtonAriaLabel: '',
  confirmButtonColor: null,
  confirmButtonClass: '',
  cancelButtonText: 'Cancel',
  cancelButtonAriaLabel: '',
  cancelButtonColor: null,
  cancelButtonClass: '',
  buttonsStyling: true,
  reverseButtons: false,
  focusConfirm: true,
  focusCancel: false,
  showCloseButton: false,
  closeButtonAriaLabel: 'Close this dialog',
  showLoaderOnConfirm: false,
  imageUrl: null,
  imageWidth: null,
  imageHeight: null,
  imageAlt: '',
  imageClass: '',
  timer: null,
  width: null,
  padding: null,
  background: null,
  input: null,
  inputPlaceholder: '',
  inputValue: '',
  inputOptions: {},
  inputAutoTrim: true,
  inputClass: '',
  inputAttributes: {},
  inputValidator: null,
  validationMessage: null,
  grow: false,
  position: 'center',
  progressSteps: [],
  currentProgressStep: null,
  progressStepsDistance: null,
  onBeforeOpen: null,
  onAfterClose: null,
  onOpen: null,
  onClose: null,
  scrollbarPadding: true
};
var updatableParams = ['title', 'titleText', 'text', 'html', 'type', 'customClass', 'showConfirmButton', 'showCancelButton', 'confirmButtonText', 'confirmButtonAriaLabel', 'confirmButtonColor', 'confirmButtonClass', 'cancelButtonText', 'cancelButtonAriaLabel', 'cancelButtonColor', 'cancelButtonClass', 'buttonsStyling', 'reverseButtons', 'imageUrl', 'imageWidth', 'imageHeigth', 'imageAlt', 'imageClass', 'progressSteps', 'currentProgressStep'];
var deprecatedParams = {
  customContainerClass: 'customClass',
  confirmButtonClass: 'customClass',
  cancelButtonClass: 'customClass',
  imageClass: 'customClass',
  inputClass: 'customClass'
};
var toastIncompatibleParams = ['allowOutsideClick', 'allowEnterKey', 'backdrop', 'focusConfirm', 'focusCancel', 'heightAuto', 'keydownListenerCapture'];
/**
 * Is valid parameter
 * @param {String} paramName
 */

var isValidParameter = function isValidParameter(paramName) {
  return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
};
/**
 * Is valid parameter for Swal.update() method
 * @param {String} paramName
 */

var isUpdatableParameter = function isUpdatableParameter(paramName) {
  return updatableParams.indexOf(paramName) !== -1;
};
/**
 * Is deprecated parameter
 * @param {String} paramName
 */

var isDeprecatedParameter = function isDeprecatedParameter(paramName) {
  return deprecatedParams[paramName];
};

var checkIfParamIsValid = function checkIfParamIsValid(param) {
  if (!isValidParameter(param)) {
    warn("Unknown parameter \"".concat(param, "\""));
  }
};

var checkIfToastParamIsValid = function checkIfToastParamIsValid(param) {
  if (toastIncompatibleParams.indexOf(param) !== -1) {
    warn("The parameter \"".concat(param, "\" is incompatible with toasts"));
  }
};

var checkIfParamIsDeprecated = function checkIfParamIsDeprecated(param) {
  if (isDeprecatedParameter(param)) {
    warnAboutDepreation(param, isDeprecatedParameter(param));
  }
};
/**
 * Show relevant warnings for given params
 *
 * @param params
 */


var showWarningsForParams = function showWarningsForParams(params) {
  for (var param in params) {
    checkIfParamIsValid(param);

    if (params.toast) {
      checkIfToastParamIsValid(param);
    }

    checkIfParamIsDeprecated();
  }
};



var staticMethods = Object.freeze({
	isValidParameter: isValidParameter,
	isUpdatableParameter: isUpdatableParameter,
	isDeprecatedParameter: isDeprecatedParameter,
	argsToParams: argsToParams,
	isVisible: isVisible$1,
	clickConfirm: clickConfirm,
	clickCancel: clickCancel,
	getContainer: getContainer,
	getPopup: getPopup,
	getTitle: getTitle,
	getContent: getContent,
	getImage: getImage,
	getIcon: getIcon,
	getIcons: getIcons,
	getCloseButton: getCloseButton,
	getActions: getActions,
	getConfirmButton: getConfirmButton,
	getCancelButton: getCancelButton,
	getHeader: getHeader,
	getFooter: getFooter,
	getFocusableElements: getFocusableElements,
	getValidationMessage: getValidationMessage,
	isLoading: isLoading,
	fire: fire,
	mixin: mixin,
	queue: queue,
	getQueueStep: getQueueStep,
	insertQueueStep: insertQueueStep,
	deleteQueueStep: deleteQueueStep,
	showLoading: showLoading,
	enableLoading: showLoading,
	getTimerLeft: getTimerLeft,
	stopTimer: stopTimer,
	resumeTimer: resumeTimer,
	toggleTimer: toggleTimer,
	increaseTimer: increaseTimer,
	isTimerRunning: isTimerRunning
});

/**
 * Enables buttons and hide loader.
 */

function hideLoading() {
  var innerParams = privateProps.innerParams.get(this);
  var domCache = privateProps.domCache.get(this);

  if (!innerParams.showConfirmButton) {
    hide(domCache.confirmButton);

    if (!innerParams.showCancelButton) {
      hide(domCache.actions);
    }
  }

  removeClass([domCache.popup, domCache.actions], swalClasses.loading);
  domCache.popup.removeAttribute('aria-busy');
  domCache.popup.removeAttribute('data-loading');
  domCache.confirmButton.disabled = false;
  domCache.cancelButton.disabled = false;
}

function getInput$1(instance) {
  var innerParams = privateProps.innerParams.get(instance || this);
  var domCache = privateProps.domCache.get(instance || this);
  return getInput(domCache.content, innerParams.input);
}

var fixScrollbar = function fixScrollbar() {
  // for queues, do not do this more than once
  if (states.previousBodyPadding !== null) {
    return;
  } // if the body has overflow


  if (document.body.scrollHeight > window.innerHeight) {
    // add padding so the content doesn't shift after removal of scrollbar
    states.previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
    document.body.style.paddingRight = states.previousBodyPadding + measureScrollbar() + 'px';
  }
};
var undoScrollbar = function undoScrollbar() {
  if (states.previousBodyPadding !== null) {
    document.body.style.paddingRight = states.previousBodyPadding + 'px';
    states.previousBodyPadding = null;
  }
};

/* istanbul ignore next */

var iOSfix = function iOSfix() {
  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (iOS && !hasClass(document.body, swalClasses.iosfix)) {
    var offset = document.body.scrollTop;
    document.body.style.top = offset * -1 + 'px';
    addClass(document.body, swalClasses.iosfix);
    lockBodyScroll();
  }
};

var lockBodyScroll = function lockBodyScroll() {
  // #1246
  var container = getContainer();
  var preventTouchMove;

  container.ontouchstart = function (e) {
    preventTouchMove = e.target === container || !isScrollable(container) && e.target.tagName !== 'INPUT' // #1603
    ;
  };

  container.ontouchmove = function (e) {
    if (preventTouchMove) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
};
/* istanbul ignore next */


var undoIOSfix = function undoIOSfix() {
  if (hasClass(document.body, swalClasses.iosfix)) {
    var offset = parseInt(document.body.style.top, 10);
    removeClass(document.body, swalClasses.iosfix);
    document.body.style.top = '';
    document.body.scrollTop = offset * -1;
  }
};

var isIE11 = function isIE11() {
  return !!window.MSInputMethodContext && !!document.documentMode;
}; // Fix IE11 centering sweetalert2/issues/933

/* istanbul ignore next */


var fixVerticalPositionIE = function fixVerticalPositionIE() {
  var container = getContainer();
  var popup = getPopup();
  container.style.removeProperty('align-items');

  if (popup.offsetTop < 0) {
    container.style.alignItems = 'flex-start';
  }
};
/* istanbul ignore next */


var IEfix = function IEfix() {
  if (typeof window !== 'undefined' && isIE11()) {
    fixVerticalPositionIE();
    window.addEventListener('resize', fixVerticalPositionIE);
  }
};
/* istanbul ignore next */

var undoIEfix = function undoIEfix() {
  if (typeof window !== 'undefined' && isIE11()) {
    window.removeEventListener('resize', fixVerticalPositionIE);
  }
};

// Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
// elements not within the active modal dialog will not be surfaced if a user opens a screen
// reader’s list of elements (headings, form controls, landmarks, etc.) in the document.

var setAriaHidden = function setAriaHidden() {
  var bodyChildren = toArray(document.body.children);
  bodyChildren.forEach(function (el) {
    if (el === getContainer() || contains(el, getContainer())) {
      return;
    }

    if (el.hasAttribute('aria-hidden')) {
      el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden'));
    }

    el.setAttribute('aria-hidden', 'true');
  });
};
var unsetAriaHidden = function unsetAriaHidden() {
  var bodyChildren = toArray(document.body.children);
  bodyChildren.forEach(function (el) {
    if (el.hasAttribute('data-previous-aria-hidden')) {
      el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden'));
      el.removeAttribute('data-previous-aria-hidden');
    } else {
      el.removeAttribute('aria-hidden');
    }
  });
};

/**
 * This module containts `WeakMap`s for each effectively-"private  property" that a `Swal` has.
 * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
 * This is the approach that Babel will probably take to implement private methods/fields
 *   https://github.com/tc39/proposal-private-methods
 *   https://github.com/babel/babel/pull/7555
 * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
 *   then we can use that language feature.
 */
var privateMethods = {
  swalPromiseResolve: new WeakMap()
};

/*
 * Instance method to close sweetAlert
 */

function removePopupAndResetState(container, isToast, onAfterClose) {
  if (isToast) {
    triggerOnAfterClose(onAfterClose);
  } else {
    restoreActiveElement().then(function () {
      return triggerOnAfterClose(onAfterClose);
    });
    globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
      capture: globalState.keydownListenerCapture
    });
    globalState.keydownHandlerAdded = false;
  }

  if (container.parentNode) {
    container.parentNode.removeChild(container);
  }

  removeBodyClasses();

  if (isModal()) {
    undoScrollbar();
    undoIOSfix();
    undoIEfix();
    unsetAriaHidden();
  }
}

function removeBodyClasses() {
  removeClass([document.documentElement, document.body], [swalClasses.shown, swalClasses['height-auto'], swalClasses['no-backdrop'], swalClasses['toast-shown'], swalClasses['toast-column']]);
}

function disposeSwal() {
  // Unset this.params so GC will dispose it (#1569)
  delete this.params; // Unset globalState props so GC will dispose globalState (#1569)

  delete globalState.keydownHandler;
  delete globalState.keydownTarget; // Unset WeakMaps so GC will be able to dispose them (#1569)

  unsetWeakMaps(privateProps);
  unsetWeakMaps(privateMethods);
}

function close(resolveValue) {
  var popup = getPopup();

  if (!popup || hasClass(popup, swalClasses.hide)) {
    return;
  }

  var innerParams = privateProps.innerParams.get(this);
  var swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
  var onClose = innerParams.onClose,
      onAfterClose = innerParams.onAfterClose;
  removeClass(popup, swalClasses.show);
  addClass(popup, swalClasses.hide);
  handlePopupAnimation(popup, onAfterClose);

  if (onClose !== null && typeof onClose === 'function') {
    onClose(popup);
  } // Resolve Swal promise


  swalPromiseResolve(resolveValue || {});
  globalState.deferDisposalTimer = setTimeout(disposeSwal.bind(this), DISPOSE_SWAL_TIMEOUT);
}

var handlePopupAnimation = function handlePopupAnimation(popup, onAfterClose) {
  var container = getContainer(); // If animation is supported, animate

  var animationIsSupported = animationEndEvent && hasCssAnimation(popup);

  if (animationIsSupported) {
    animatePopup(popup, container, onAfterClose);
  } else {
    // Otherwise, remove immediately
    removePopupAndResetState(container, isToast(), onAfterClose);
  }
};

var animatePopup = function animatePopup(popup, container, onAfterClose) {
  globalState.swalClosing = true;
  globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, container, isToast(), onAfterClose);
  popup.addEventListener(animationEndEvent, function (e) {
    if (e.target === popup && globalState.swalClosing) {
      delete globalState.swalClosing;
      globalState.swalCloseEventFinishedCallback();
      delete globalState.swalCloseEventFinishedCallback;
    }
  });
};

var unsetWeakMaps = function unsetWeakMaps(obj) {
  for (var i in obj) {
    obj[i] = new WeakMap();
  }
};

var triggerOnAfterClose = function triggerOnAfterClose(onAfterClose) {
  if (onAfterClose !== null && typeof onAfterClose === 'function') {
    setTimeout(function () {
      onAfterClose();
    });
  }
};

function setButtonsDisabled(instance, buttons, disabled) {
  var domCache = privateProps.domCache.get(instance);
  buttons.forEach(function (button) {
    domCache[button].disabled = disabled;
  });
}

function setInputDisabled(input, disabled) {
  if (!input) {
    return false;
  }

  if (input.type === 'radio') {
    var radiosContainer = input.parentNode.parentNode;
    var radios = radiosContainer.querySelectorAll('input');

    for (var i = 0; i < radios.length; i++) {
      radios[i].disabled = disabled;
    }
  } else {
    input.disabled = disabled;
  }
}

function enableButtons() {
  setButtonsDisabled(this, ['confirmButton', 'cancelButton'], false);
}
function disableButtons() {
  setButtonsDisabled(this, ['confirmButton', 'cancelButton'], true);
} // @deprecated

function enableConfirmButton() {
  warnAboutDepreation('Swal.disableConfirmButton()', "Swal.getConfirmButton().removeAttribute('disabled')");
  setButtonsDisabled(this, ['confirmButton'], false);
} // @deprecated

function disableConfirmButton() {
  warnAboutDepreation('Swal.enableConfirmButton()', "Swal.getConfirmButton().setAttribute('disabled', '')");
  setButtonsDisabled(this, ['confirmButton'], true);
}
function enableInput() {
  return setInputDisabled(this.getInput(), false);
}
function disableInput() {
  return setInputDisabled(this.getInput(), true);
}

function showValidationMessage(error) {
  var domCache = privateProps.domCache.get(this);
  domCache.validationMessage.innerHTML = error;
  var popupComputedStyle = window.getComputedStyle(domCache.popup);
  domCache.validationMessage.style.marginLeft = "-".concat(popupComputedStyle.getPropertyValue('padding-left'));
  domCache.validationMessage.style.marginRight = "-".concat(popupComputedStyle.getPropertyValue('padding-right'));
  show(domCache.validationMessage);
  var input = this.getInput();

  if (input) {
    input.setAttribute('aria-invalid', true);
    input.setAttribute('aria-describedBy', swalClasses['validation-message']);
    focusInput(input);
    addClass(input, swalClasses.inputerror);
  }
} // Hide block with validation message

function resetValidationMessage$1() {
  var domCache = privateProps.domCache.get(this);

  if (domCache.validationMessage) {
    hide(domCache.validationMessage);
  }

  var input = this.getInput();

  if (input) {
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedBy');
    removeClass(input, swalClasses.inputerror);
  }
}

function getProgressSteps$1() {
  warnAboutDepreation('Swal.getProgressSteps()', "const swalInstance = Swal.fire({progressSteps: ['1', '2', '3']}); const progressSteps = swalInstance.params.progressSteps");
  var innerParams = privateProps.innerParams.get(this);
  return innerParams.progressSteps;
}
function setProgressSteps(progressSteps) {
  warnAboutDepreation('Swal.setProgressSteps()', 'Swal.update()');
  var innerParams = privateProps.innerParams.get(this);

  var updatedParams = _extends({}, innerParams, {
    progressSteps: progressSteps
  });

  renderProgressSteps(this, updatedParams);
  privateProps.innerParams.set(this, updatedParams);
}
function showProgressSteps() {
  var domCache = privateProps.domCache.get(this);
  show(domCache.progressSteps);
}
function hideProgressSteps() {
  var domCache = privateProps.domCache.get(this);
  hide(domCache.progressSteps);
}

var Timer =
/*#__PURE__*/
function () {
  function Timer(callback, delay) {
    _classCallCheck(this, Timer);

    this.callback = callback;
    this.remaining = delay;
    this.running = false;
    this.start();
  }

  _createClass(Timer, [{
    key: "start",
    value: function start() {
      if (!this.running) {
        this.running = true;
        this.started = new Date();
        this.id = setTimeout(this.callback, this.remaining);
      }

      return this.remaining;
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.running) {
        this.running = false;
        clearTimeout(this.id);
        this.remaining -= new Date() - this.started;
      }

      return this.remaining;
    }
  }, {
    key: "increase",
    value: function increase(n) {
      var running = this.running;

      if (running) {
        this.stop();
      }

      this.remaining += n;

      if (running) {
        this.start();
      }

      return this.remaining;
    }
  }, {
    key: "getTimerLeft",
    value: function getTimerLeft() {
      if (this.running) {
        this.stop();
        this.start();
      }

      return this.remaining;
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return this.running;
    }
  }]);

  return Timer;
}();

var defaultInputValidators = {
  email: function email(string, validationMessage) {
    return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
  },
  url: function url(string, validationMessage) {
    // taken from https://stackoverflow.com/a/3809435 with a small change from #1306
    return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
  }
};

function setDefaultInputValidators(params) {
  // Use default `inputValidator` for supported input types if not provided
  if (!params.inputValidator) {
    Object.keys(defaultInputValidators).forEach(function (key) {
      if (params.input === key) {
        params.inputValidator = defaultInputValidators[key];
      }
    });
  }
}

function validateCustomTargetElement(params) {
  // Determine if the custom target element is valid
  if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
    warn('Target parameter is not valid, defaulting to "body"');
    params.target = 'body';
  }
}
/**
 * Set type, text and actions on popup
 *
 * @param params
 * @returns {boolean}
 */


function setParameters(params) {
  setDefaultInputValidators(params); // showLoaderOnConfirm && preConfirm

  if (params.showLoaderOnConfirm && !params.preConfirm) {
    warn('showLoaderOnConfirm is set to true, but preConfirm is not defined.\n' + 'showLoaderOnConfirm should be used together with preConfirm, see usage example:\n' + 'https://sweetalert2.github.io/#ajax-request');
  } // params.animation will be actually used in renderPopup.js
  // but in case when params.animation is a function, we need to call that function
  // before popup (re)initialization, so it'll be possible to check Swal.isVisible()
  // inside the params.animation function


  params.animation = callIfFunction(params.animation);
  validateCustomTargetElement(params); // Replace newlines with <br> in title

  if (typeof params.title === 'string') {
    params.title = params.title.split('\n').join('<br />');
  }

  init(params);
}

function swalOpenAnimationFinished(popup, container) {
  popup.removeEventListener(animationEndEvent, swalOpenAnimationFinished);
  container.style.overflowY = 'auto';
}
/**
 * Open popup, add necessary classes and styles, fix scrollbar
 *
 * @param {Array} params
 */


var openPopup = function openPopup(params) {
  var container = getContainer();
  var popup = getPopup();

  if (params.onBeforeOpen !== null && typeof params.onBeforeOpen === 'function') {
    params.onBeforeOpen(popup);
  }

  if (params.animation) {
    addClass(popup, swalClasses.show);
    addClass(container, swalClasses.fade);
  }

  show(popup); // scrolling is 'hidden' until animation is done, after that 'auto'

  if (animationEndEvent && hasCssAnimation(popup)) {
    container.style.overflowY = 'hidden';
    popup.addEventListener(animationEndEvent, swalOpenAnimationFinished.bind(null, popup, container));
  } else {
    container.style.overflowY = 'auto';
  }

  addClass([document.documentElement, document.body, container], swalClasses.shown);

  if (params.heightAuto && params.backdrop && !params.toast) {
    addClass([document.documentElement, document.body], swalClasses['height-auto']);
  }

  if (isModal()) {
    if (params.scrollbarPadding) {
      fixScrollbar();
    }

    iOSfix();
    IEfix();
    setAriaHidden(); // sweetalert2/issues/1247

    setTimeout(function () {
      container.scrollTop = 0;
    });
  }

  if (!isToast() && !globalState.previousActiveElement) {
    globalState.previousActiveElement = document.activeElement;
  }

  if (params.onOpen !== null && typeof params.onOpen === 'function') {
    setTimeout(function () {
      params.onOpen(popup);
    });
  }
};

var handleInputOptions = function handleInputOptions(instance, params) {
  var content = getContent();

  var processInputOptions = function processInputOptions(inputOptions) {
    return populateInputOptions[params.input](content, formatInputOptions(inputOptions), params);
  };

  if (isPromise(params.inputOptions)) {
    showLoading();
    params.inputOptions.then(function (inputOptions) {
      instance.hideLoading();
      processInputOptions(inputOptions);
    });
  } else if (_typeof(params.inputOptions) === 'object') {
    processInputOptions(params.inputOptions);
  } else {
    error("Unexpected type of inputOptions! Expected object, Map or Promise, got ".concat(_typeof(params.inputOptions)));
  }
};
var handleInputValue = function handleInputValue(instance, params) {
  var input = instance.getInput();
  hide(input);
  params.inputValue.then(function (inputValue) {
    input.value = params.input === 'number' ? parseFloat(inputValue) || 0 : inputValue + '';
    show(input);
    input.focus();
    instance.hideLoading();
  })["catch"](function (err) {
    error('Error in inputValue promise: ' + err);
    input.value = '';
    show(input);
    input.focus();
    instance.hideLoading();
  });
};
var populateInputOptions = {
  select: function select(content, inputOptions, params) {
    var select = getChildByClass(content, swalClasses.select);
    inputOptions.forEach(function (inputOption) {
      var optionValue = inputOption[0];
      var optionLabel = inputOption[1];
      var option = document.createElement('option');
      option.value = optionValue;
      option.innerHTML = optionLabel;

      if (params.inputValue.toString() === optionValue.toString()) {
        option.selected = true;
      }

      select.appendChild(option);
    });
    select.focus();
  },
  radio: function radio(content, inputOptions, params) {
    var radio = getChildByClass(content, swalClasses.radio);
    inputOptions.forEach(function (inputOption) {
      var radioValue = inputOption[0];
      var radioLabel = inputOption[1];
      var radioInput = document.createElement('input');
      var radioLabelElement = document.createElement('label');
      radioInput.type = 'radio';
      radioInput.name = swalClasses.radio;
      radioInput.value = radioValue;

      if (params.inputValue.toString() === radioValue.toString()) {
        radioInput.checked = true;
      }

      var label = document.createElement('span');
      label.innerHTML = radioLabel;
      label.className = swalClasses.label;
      radioLabelElement.appendChild(radioInput);
      radioLabelElement.appendChild(label);
      radio.appendChild(radioLabelElement);
    });
    var radios = radio.querySelectorAll('input');

    if (radios.length) {
      radios[0].focus();
    }
  }
  /**
   * Converts `inputOptions` into an array of `[value, label]`s
   * @param inputOptions
   */

};

var formatInputOptions = function formatInputOptions(inputOptions) {
  var result = [];

  if (typeof Map !== 'undefined' && inputOptions instanceof Map) {
    inputOptions.forEach(function (value, key) {
      result.push([key, value]);
    });
  } else {
    Object.keys(inputOptions).forEach(function (key) {
      result.push([key, inputOptions[key]]);
    });
  }

  return result;
};

function _main(userParams) {
  var _this = this;

  showWarningsForParams(userParams); // Check if there is another Swal closing

  if (globalState.swalClosing) {
    delete globalState.swalClosing;
    globalState.swalCloseEventFinishedCallback();
    delete globalState.swalCloseEventFinishedCallback;
  } // Check if there is a swal disposal defer timer


  if (globalState.deferDisposalTimer) {
    clearTimeout(globalState.deferDisposalTimer);
    delete globalState.deferDisposalTimer;
  }

  var innerParams = _extends({}, defaultParams, userParams);

  setParameters(innerParams);
  Object.freeze(innerParams); // clear the previous timer

  if (globalState.timeout) {
    globalState.timeout.stop();
    delete globalState.timeout;
  } // clear the restore focus timeout


  clearTimeout(globalState.restoreFocusTimeout);
  var domCache = {
    popup: getPopup(),
    container: getContainer(),
    content: getContent(),
    actions: getActions(),
    confirmButton: getConfirmButton(),
    cancelButton: getCancelButton(),
    closeButton: getCloseButton(),
    validationMessage: getValidationMessage(),
    progressSteps: getProgressSteps()
  };
  privateProps.domCache.set(this, domCache);
  render(this, innerParams);
  privateProps.innerParams.set(this, innerParams);
  var constructor = this.constructor;
  return new Promise(function (resolve) {
    // functions to handle all closings/dismissals
    var succeedWith = function succeedWith(value) {
      _this.closePopup({
        value: value
      });
    };

    var dismissWith = function dismissWith(dismiss) {
      _this.closePopup({
        dismiss: dismiss
      });
    };

    privateMethods.swalPromiseResolve.set(_this, resolve); // Close on timer

    if (innerParams.timer) {
      globalState.timeout = new Timer(function () {
        dismissWith('timer');
        delete globalState.timeout;
      }, innerParams.timer);
    } // Get the value of the popup input


    var getInputValue = function getInputValue() {
      var input = _this.getInput();

      if (!input) {
        return null;
      }

      switch (innerParams.input) {
        case 'checkbox':
          return input.checked ? 1 : 0;

        case 'radio':
          return input.checked ? input.value : null;

        case 'file':
          return input.files.length ? input.files[0] : null;

        default:
          return innerParams.inputAutoTrim ? input.value.trim() : input.value;
      }
    }; // input autofocus


    if (innerParams.input) {
      setTimeout(function () {
        var input = _this.getInput();

        if (input) {
          focusInput(input);
        }
      }, 0);
    }

    var confirm = function confirm(value) {
      if (innerParams.showLoaderOnConfirm) {
        constructor.showLoading(); // TODO: make showLoading an *instance* method
      }

      if (innerParams.preConfirm) {
        _this.resetValidationMessage();

        var preConfirmPromise = Promise.resolve().then(function () {
          return innerParams.preConfirm(value, innerParams.validationMessage);
        });
        preConfirmPromise.then(function (preConfirmValue) {
          if (isVisible(domCache.validationMessage) || preConfirmValue === false) {
            _this.hideLoading();
          } else {
            succeedWith(typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
          }
        });
      } else {
        succeedWith(value);
      }
    }; // Mouse interactions


    var onButtonEvent = function onButtonEvent(e) {
      var target = e.target;
      var confirmButton = domCache.confirmButton,
          cancelButton = domCache.cancelButton;
      var targetedConfirm = confirmButton && (confirmButton === target || confirmButton.contains(target));
      var targetedCancel = cancelButton && (cancelButton === target || cancelButton.contains(target));

      switch (e.type) {
        case 'click':
          // Clicked 'confirm'
          if (targetedConfirm) {
            _this.disableButtons();

            if (innerParams.input) {
              var inputValue = getInputValue();

              if (innerParams.inputValidator) {
                _this.disableInput();

                var validationPromise = Promise.resolve().then(function () {
                  return innerParams.inputValidator(inputValue, innerParams.validationMessage);
                });
                validationPromise.then(function (validationMessage) {
                  _this.enableButtons();

                  _this.enableInput();

                  if (validationMessage) {
                    _this.showValidationMessage(validationMessage);
                  } else {
                    confirm(inputValue);
                  }
                });
              } else if (!_this.getInput().checkValidity()) {
                _this.enableButtons();

                _this.showValidationMessage(innerParams.validationMessage);
              } else {
                confirm(inputValue);
              }
            } else {
              confirm(true);
            } // Clicked 'cancel'

          } else if (targetedCancel) {
            _this.disableButtons();

            dismissWith(constructor.DismissReason.cancel);
          }

          break;

        default:
      }
    };

    var buttons = domCache.popup.querySelectorAll('button');

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].onclick = onButtonEvent;
      buttons[i].onmouseover = onButtonEvent;
      buttons[i].onmouseout = onButtonEvent;
      buttons[i].onmousedown = onButtonEvent;
    } // Closing popup by close button


    domCache.closeButton.onclick = function () {
      dismissWith(constructor.DismissReason.close);
    };

    if (innerParams.toast) {
      // Closing popup by internal click
      domCache.popup.onclick = function () {
        if (innerParams.showConfirmButton || innerParams.showCancelButton || innerParams.showCloseButton || innerParams.input) {
          return;
        }

        dismissWith(constructor.DismissReason.close);
      };
    } else {
      var ignoreOutsideClick = false; // Ignore click events that had mousedown on the popup but mouseup on the container
      // This can happen when the user drags a slider

      domCache.popup.onmousedown = function () {
        domCache.container.onmouseup = function (e) {
          domCache.container.onmouseup = undefined; // We only check if the mouseup target is the container because usually it doesn't
          // have any other direct children aside of the popup

          if (e.target === domCache.container) {
            ignoreOutsideClick = true;
          }
        };
      }; // Ignore click events that had mousedown on the container but mouseup on the popup


      domCache.container.onmousedown = function () {
        domCache.popup.onmouseup = function (e) {
          domCache.popup.onmouseup = undefined; // We also need to check if the mouseup target is a child of the popup

          if (e.target === domCache.popup || domCache.popup.contains(e.target)) {
            ignoreOutsideClick = true;
          }
        };
      };

      domCache.container.onclick = function (e) {
        if (ignoreOutsideClick) {
          ignoreOutsideClick = false;
          return;
        }

        if (e.target !== domCache.container) {
          return;
        }

        if (callIfFunction(innerParams.allowOutsideClick)) {
          dismissWith(constructor.DismissReason.backdrop);
        }
      };
    } // Reverse buttons (Confirm on the right side)


    if (innerParams.reverseButtons) {
      domCache.confirmButton.parentNode.insertBefore(domCache.cancelButton, domCache.confirmButton);
    } else {
      domCache.confirmButton.parentNode.insertBefore(domCache.confirmButton, domCache.cancelButton);
    } // Focus handling


    var setFocus = function setFocus(index, increment) {
      var focusableElements = getFocusableElements(innerParams.focusCancel); // search for visible elements and select the next possible match

      for (var _i = 0; _i < focusableElements.length; _i++) {
        index = index + increment; // rollover to first item

        if (index === focusableElements.length) {
          index = 0; // go to last item
        } else if (index === -1) {
          index = focusableElements.length - 1;
        }

        return focusableElements[index].focus();
      } // no visible focusable elements, focus the popup


      domCache.popup.focus();
    };

    var keydownHandler = function keydownHandler(e, innerParams) {
      if (innerParams.stopKeydownPropagation) {
        e.stopPropagation();
      }

      var arrowKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Left', 'Right', 'Up', 'Down' // IE11
      ];

      if (e.key === 'Enter' && !e.isComposing) {
        if (e.target && _this.getInput() && e.target.outerHTML === _this.getInput().outerHTML) {
          if (['textarea', 'file'].indexOf(innerParams.input) !== -1) {
            return; // do not submit
          }

          constructor.clickConfirm();
          e.preventDefault();
        } // TAB

      } else if (e.key === 'Tab') {
        var targetElement = e.target;
        var focusableElements = getFocusableElements(innerParams.focusCancel);
        var btnIndex = -1;

        for (var _i2 = 0; _i2 < focusableElements.length; _i2++) {
          if (targetElement === focusableElements[_i2]) {
            btnIndex = _i2;
            break;
          }
        }

        if (!e.shiftKey) {
          // Cycle to the next button
          setFocus(btnIndex, 1);
        } else {
          // Cycle to the prev button
          setFocus(btnIndex, -1);
        }

        e.stopPropagation();
        e.preventDefault(); // ARROWS - switch focus between buttons
      } else if (arrowKeys.indexOf(e.key) !== -1) {
        // focus Cancel button if Confirm button is currently focused
        if (document.activeElement === domCache.confirmButton && isVisible(domCache.cancelButton)) {
          domCache.cancelButton.focus(); // and vice versa
        } else if (document.activeElement === domCache.cancelButton && isVisible(domCache.confirmButton)) {
          domCache.confirmButton.focus();
        } // ESC

      } else if ((e.key === 'Escape' || e.key === 'Esc') && callIfFunction(innerParams.allowEscapeKey) === true) {
        e.preventDefault();
        dismissWith(constructor.DismissReason.esc);
      }
    };

    if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
      globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = false;
    }

    if (!innerParams.toast) {
      globalState.keydownHandler = function (e) {
        return keydownHandler(e, innerParams);
      };

      globalState.keydownTarget = innerParams.keydownListenerCapture ? window : domCache.popup;
      globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
      globalState.keydownTarget.addEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = true;
    }

    _this.enableButtons();

    _this.hideLoading();

    _this.resetValidationMessage();

    if (innerParams.toast && (innerParams.input || innerParams.footer || innerParams.showCloseButton)) {
      addClass(document.body, swalClasses['toast-column']);
    } else {
      removeClass(document.body, swalClasses['toast-column']);
    } // inputOptions, inputValue


    if (innerParams.input === 'select' || innerParams.input === 'radio') {
      handleInputOptions(_this, innerParams);
    } else if (['text', 'email', 'number', 'tel', 'textarea'].indexOf(innerParams.input) !== -1 && isPromise(innerParams.inputValue)) {
      handleInputValue(_this, innerParams);
    }

    openPopup(innerParams);

    if (!innerParams.toast) {
      if (!callIfFunction(innerParams.allowEnterKey)) {
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
      } else if (innerParams.focusCancel && isVisible(domCache.cancelButton)) {
        domCache.cancelButton.focus();
      } else if (innerParams.focusConfirm && isVisible(domCache.confirmButton)) {
        domCache.confirmButton.focus();
      } else {
        setFocus(-1, 1);
      }
    } // fix scroll


    domCache.container.scrollTop = 0;
  });
}

/**
 * Updates popup parameters.
 */

function update(params) {
  var validUpdatableParams = {}; // assign valid params from `params` to `defaults`

  Object.keys(params).forEach(function (param) {
    if (Swal.isUpdatableParameter(param)) {
      validUpdatableParams[param] = params[param];
    } else {
      warn("Invalid parameter to update: \"".concat(param, "\". Updatable params are listed here: https://github.com/sweetalert2/sweetalert2/blob/master/src/utils/params.js"));
    }
  });
  var innerParams = privateProps.innerParams.get(this);

  var updatedParams = _extends({}, innerParams, validUpdatableParams);

  render(this, updatedParams);
  privateProps.innerParams.set(this, updatedParams);
  Object.defineProperties(this, {
    params: {
      value: _extends({}, this.params, params),
      writable: false,
      enumerable: true
    }
  });
}



var instanceMethods = Object.freeze({
	hideLoading: hideLoading,
	disableLoading: hideLoading,
	getInput: getInput$1,
	close: close,
	closePopup: close,
	closeModal: close,
	closeToast: close,
	enableButtons: enableButtons,
	disableButtons: disableButtons,
	enableConfirmButton: enableConfirmButton,
	disableConfirmButton: disableConfirmButton,
	enableInput: enableInput,
	disableInput: disableInput,
	showValidationMessage: showValidationMessage,
	resetValidationMessage: resetValidationMessage$1,
	getProgressSteps: getProgressSteps$1,
	setProgressSteps: setProgressSteps,
	showProgressSteps: showProgressSteps,
	hideProgressSteps: hideProgressSteps,
	_main: _main,
	update: update
});

var currentInstance; // SweetAlert constructor

function SweetAlert() {
  // Prevent run in Node env

  /* istanbul ignore if */
  if (typeof window === 'undefined') {
    return;
  } // Check for the existence of Promise

  /* istanbul ignore if */


  if (typeof Promise === 'undefined') {
    error('This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/sweetalert2/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)');
  }

  currentInstance = this;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var outerParams = Object.freeze(this.constructor.argsToParams(args));
  Object.defineProperties(this, {
    params: {
      value: outerParams,
      writable: false,
      enumerable: true,
      configurable: true
    }
  });

  var promise = this._main(this.params);

  privateProps.promise.set(this, promise);
} // `catch` cannot be the name of a module export, so we define our thenable methods here instead


SweetAlert.prototype.then = function (onFulfilled) {
  var promise = privateProps.promise.get(this);
  return promise.then(onFulfilled);
};

SweetAlert.prototype["finally"] = function (onFinally) {
  var promise = privateProps.promise.get(this);
  return promise["finally"](onFinally);
}; // Assign instance methods from src/instanceMethods/*.js to prototype


_extends(SweetAlert.prototype, instanceMethods); // Assign static methods from src/staticMethods/*.js to constructor


_extends(SweetAlert, staticMethods); // Proxy to instance methods to constructor, for now, for backwards compatibility


Object.keys(instanceMethods).forEach(function (key) {
  SweetAlert[key] = function () {
    if (currentInstance) {
      var _currentInstance;

      return (_currentInstance = currentInstance)[key].apply(_currentInstance, arguments);
    }
  };
});
SweetAlert.DismissReason = DismissReason;
SweetAlert.version = '8.13.3';

var Swal = SweetAlert;
Swal["default"] = Swal;

return Swal;

})));
if (typeof this !== 'undefined' && this.Sweetalert2){  this.swal = this.sweetAlert = this.Swal = this.SweetAlert = this.Sweetalert2}

"undefined"!=typeof document&&function(e,t){var n=e.createElement("style");if(e.getElementsByTagName("head")[0].appendChild(n),n.styleSheet)n.styleSheet.disabled||(n.styleSheet.cssText=t);else try{n.innerHTML=t}catch(e){n.innerText=t}}(document,"@charset \"UTF-8\";@-webkit-keyframes swal2-show{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}100%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes swal2-show{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}100%{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes swal2-hide{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}100%{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}@keyframes swal2-hide{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}100%{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}@-webkit-keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.875em;width:1.5625em}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.875em;width:1.5625em}}@-webkit-keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@-webkit-keyframes swal2-rotate-success-circular-line{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}100%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes swal2-rotate-success-circular-line{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}100%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}50%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}80%{margin-top:-.375em;-webkit-transform:scale(1.15);transform:scale(1.15)}100%{margin-top:0;-webkit-transform:scale(1);transform:scale(1);opacity:1}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}50%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}80%{margin-top:-.375em;-webkit-transform:scale(1.15);transform:scale(1.15)}100%{margin-top:0;-webkit-transform:scale(1);transform:scale(1);opacity:1}}@-webkit-keyframes swal2-animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}100%{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}}@keyframes swal2-animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}100%{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}}body.swal2-toast-shown .swal2-container{background-color:transparent}body.swal2-toast-shown .swal2-container.swal2-shown{background-color:transparent}body.swal2-toast-shown .swal2-container.swal2-top{top:0;right:auto;bottom:auto;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{top:0;right:0;bottom:auto;left:auto}body.swal2-toast-shown .swal2-container.swal2-top-left,body.swal2-toast-shown .swal2-container.swal2-top-start{top:0;right:auto;bottom:auto;left:0}body.swal2-toast-shown .swal2-container.swal2-center-left,body.swal2-toast-shown .swal2-container.swal2-center-start{top:50%;right:auto;bottom:auto;left:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{top:50%;right:auto;bottom:auto;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{top:50%;right:0;bottom:auto;left:auto;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-left,body.swal2-toast-shown .swal2-container.swal2-bottom-start{top:auto;right:auto;bottom:0;left:0}body.swal2-toast-shown .swal2-container.swal2-bottom{top:auto;right:auto;bottom:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{top:auto;right:0;bottom:0;left:auto}body.swal2-toast-column .swal2-toast{-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:stretch;align-items:stretch}body.swal2-toast-column .swal2-toast .swal2-actions{-webkit-box-flex:1;flex:1;align-self:stretch;height:2.2em;margin-top:.3125em}body.swal2-toast-column .swal2-toast .swal2-loading{-webkit-box-pack:center;justify-content:center}body.swal2-toast-column .swal2-toast .swal2-input{height:2em;margin:.3125em auto;font-size:1em}body.swal2-toast-column .swal2-toast .swal2-validation-message{font-size:1em}.swal2-popup.swal2-toast{-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-align:center;align-items:center;width:auto;padding:.625em;overflow-y:hidden;box-shadow:0 0 .625em #d9d9d9}.swal2-popup.swal2-toast .swal2-header{-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}.swal2-popup.swal2-toast .swal2-title{-webkit-box-flex:1;flex-grow:1;-webkit-box-pack:start;justify-content:flex-start;margin:0 .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{position:static;width:.8em;height:.8em;line-height:.8}.swal2-popup.swal2-toast .swal2-content{-webkit-box-pack:start;justify-content:flex-start;font-size:1em}.swal2-popup.swal2-toast .swal2-icon{width:2em;min-width:2em;height:2em;margin:0}.swal2-popup.swal2-toast .swal2-icon::before{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;font-size:2em;font-weight:700}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-popup.swal2-toast .swal2-icon::before{font-size:.25em}}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{flex-basis:auto!important;height:auto;margin:0 .3125em}.swal2-popup.swal2-toast .swal2-styled{margin:0 .3125em;padding:.3125em .625em;font-size:1em}.swal2-popup.swal2-toast .swal2-styled:focus{box-shadow:0 0 0 .0625em #fff,0 0 0 .125em rgba(50,100,150,.4)}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.8em;left:-.5em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:2em 2em;transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.25em;left:.9375em;-webkit-transform-origin:0 1.5em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast.swal2-show{-webkit-animation:swal2-toast-show .5s;animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{-webkit-animation:swal2-toast-hide .1s forwards;animation:swal2-toast-hide .1s forwards}.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-tip{-webkit-animation:swal2-toast-animate-success-line-tip .75s;animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-long{-webkit-animation:swal2-toast-animate-success-line-long .75s;animation:swal2-toast-animate-success-line-long .75s}@-webkit-keyframes swal2-toast-show{0%{-webkit-transform:translateY(-.625em) rotateZ(2deg);transform:translateY(-.625em) rotateZ(2deg)}33%{-webkit-transform:translateY(0) rotateZ(-2deg);transform:translateY(0) rotateZ(-2deg)}66%{-webkit-transform:translateY(.3125em) rotateZ(2deg);transform:translateY(.3125em) rotateZ(2deg)}100%{-webkit-transform:translateY(0) rotateZ(0);transform:translateY(0) rotateZ(0)}}@keyframes swal2-toast-show{0%{-webkit-transform:translateY(-.625em) rotateZ(2deg);transform:translateY(-.625em) rotateZ(2deg)}33%{-webkit-transform:translateY(0) rotateZ(-2deg);transform:translateY(0) rotateZ(-2deg)}66%{-webkit-transform:translateY(.3125em) rotateZ(2deg);transform:translateY(.3125em) rotateZ(2deg)}100%{-webkit-transform:translateY(0) rotateZ(0);transform:translateY(0) rotateZ(0)}}@-webkit-keyframes swal2-toast-hide{100%{-webkit-transform:rotateZ(1deg);transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-hide{100%{-webkit-transform:rotateZ(1deg);transform:rotateZ(1deg);opacity:0}}@-webkit-keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@-webkit-keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto!important}body.swal2-no-backdrop .swal2-shown{top:auto;right:auto;bottom:auto;left:auto;max-width:calc(100% - .625em * 2);background-color:transparent}body.swal2-no-backdrop .swal2-shown>.swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}body.swal2-no-backdrop .swal2-shown.swal2-top{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-top-left,body.swal2-no-backdrop .swal2-shown.swal2-top-start{top:0;left:0}body.swal2-no-backdrop .swal2-shown.swal2-top-end,body.swal2-no-backdrop .swal2-shown.swal2-top-right{top:0;right:0}body.swal2-no-backdrop .swal2-shown.swal2-center{top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}body.swal2-no-backdrop .swal2-shown.swal2-center-left,body.swal2-no-backdrop .swal2-shown.swal2-center-start{top:50%;left:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-center-end,body.swal2-no-backdrop .swal2-shown.swal2-center-right{top:50%;right:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-bottom{bottom:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-bottom-left,body.swal2-no-backdrop .swal2-shown.swal2-bottom-start{bottom:0;left:0}body.swal2-no-backdrop .swal2-shown.swal2-bottom-end,body.swal2-no-backdrop .swal2-shown.swal2-bottom-right{right:0;bottom:0}.swal2-container{display:-webkit-box;display:flex;position:fixed;z-index:1060;top:0;right:0;bottom:0;left:0;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;padding:.625em;overflow-x:hidden;background-color:transparent;-webkit-overflow-scrolling:touch}.swal2-container.swal2-top{-webkit-box-align:start;align-items:flex-start}.swal2-container.swal2-top-left,.swal2-container.swal2-top-start{-webkit-box-align:start;align-items:flex-start;-webkit-box-pack:start;justify-content:flex-start}.swal2-container.swal2-top-end,.swal2-container.swal2-top-right{-webkit-box-align:start;align-items:flex-start;-webkit-box-pack:end;justify-content:flex-end}.swal2-container.swal2-center{-webkit-box-align:center;align-items:center}.swal2-container.swal2-center-left,.swal2-container.swal2-center-start{-webkit-box-align:center;align-items:center;-webkit-box-pack:start;justify-content:flex-start}.swal2-container.swal2-center-end,.swal2-container.swal2-center-right{-webkit-box-align:center;align-items:center;-webkit-box-pack:end;justify-content:flex-end}.swal2-container.swal2-bottom{-webkit-box-align:end;align-items:flex-end}.swal2-container.swal2-bottom-left,.swal2-container.swal2-bottom-start{-webkit-box-align:end;align-items:flex-end;-webkit-box-pack:start;justify-content:flex-start}.swal2-container.swal2-bottom-end,.swal2-container.swal2-bottom-right{-webkit-box-align:end;align-items:flex-end;-webkit-box-pack:end;justify-content:flex-end}.swal2-container.swal2-bottom-end>:first-child,.swal2-container.swal2-bottom-left>:first-child,.swal2-container.swal2-bottom-right>:first-child,.swal2-container.swal2-bottom-start>:first-child,.swal2-container.swal2-bottom>:first-child{margin-top:auto}.swal2-container.swal2-grow-fullscreen>.swal2-modal{display:-webkit-box!important;display:flex!important;-webkit-box-flex:1;flex:1;align-self:stretch;-webkit-box-pack:center;justify-content:center}.swal2-container.swal2-grow-row>.swal2-modal{display:-webkit-box!important;display:flex!important;-webkit-box-flex:1;flex:1;align-content:center;-webkit-box-pack:center;justify-content:center}.swal2-container.swal2-grow-column{-webkit-box-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.swal2-container.swal2-grow-column.swal2-bottom,.swal2-container.swal2-grow-column.swal2-center,.swal2-container.swal2-grow-column.swal2-top{-webkit-box-align:center;align-items:center}.swal2-container.swal2-grow-column.swal2-bottom-left,.swal2-container.swal2-grow-column.swal2-bottom-start,.swal2-container.swal2-grow-column.swal2-center-left,.swal2-container.swal2-grow-column.swal2-center-start,.swal2-container.swal2-grow-column.swal2-top-left,.swal2-container.swal2-grow-column.swal2-top-start{-webkit-box-align:start;align-items:flex-start}.swal2-container.swal2-grow-column.swal2-bottom-end,.swal2-container.swal2-grow-column.swal2-bottom-right,.swal2-container.swal2-grow-column.swal2-center-end,.swal2-container.swal2-grow-column.swal2-center-right,.swal2-container.swal2-grow-column.swal2-top-end,.swal2-container.swal2-grow-column.swal2-top-right{-webkit-box-align:end;align-items:flex-end}.swal2-container.swal2-grow-column>.swal2-modal{display:-webkit-box!important;display:flex!important;-webkit-box-flex:1;flex:1;align-content:center;-webkit-box-pack:center;justify-content:center}.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen)>.swal2-modal{margin:auto}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-container .swal2-modal{margin:0!important}}.swal2-container.swal2-fade{-webkit-transition:background-color .1s;transition:background-color .1s}.swal2-container.swal2-shown{background-color:rgba(0,0,0,.4)}.swal2-popup{display:none;position:relative;box-sizing:border-box;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;width:32em;max-width:100%;padding:1.25em;border:none;border-radius:.3125em;background:#fff;font-family:inherit;font-size:1rem}.swal2-popup:focus{outline:0}.swal2-popup.swal2-loading{overflow-y:hidden}.swal2-header{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center}.swal2-title{position:relative;max-width:100%;margin:0 0 .4em;padding:0;color:#595959;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}.swal2-actions{z-index:1;flex-wrap:wrap;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;width:100%;margin:1.25em auto 0}.swal2-actions:not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}.swal2-actions:not(.swal2-loading) .swal2-styled:hover{background-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.1)),to(rgba(0,0,0,.1)));background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}.swal2-actions:not(.swal2-loading) .swal2-styled:active{background-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.2)),to(rgba(0,0,0,.2)));background-image:linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,.2))}.swal2-actions.swal2-loading .swal2-styled.swal2-confirm{box-sizing:border-box;width:2.5em;height:2.5em;margin:.46875em;padding:0;-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border:.25em solid transparent;border-radius:100%;border-color:transparent;background-color:transparent!important;color:transparent;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-actions.swal2-loading .swal2-styled.swal2-cancel{margin-right:30px;margin-left:30px}.swal2-actions.swal2-loading :not(.swal2-styled).swal2-confirm::after{content:\"\";display:inline-block;width:15px;height:15px;margin-left:5px;-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border:3px solid #999;border-radius:50%;border-right-color:transparent;box-shadow:1px 1px 1px #fff}.swal2-styled{margin:.3125em;padding:.625em 2em;box-shadow:none;font-weight:500}.swal2-styled:not([disabled]){cursor:pointer}.swal2-styled.swal2-confirm{border:0;border-radius:.25em;background:initial;background-color:#3085d6;color:#fff;font-size:1.0625em}.swal2-styled.swal2-cancel{border:0;border-radius:.25em;background:initial;background-color:#aaa;color:#fff;font-size:1.0625em}.swal2-styled:focus{outline:0;box-shadow:0 0 0 2px #fff,0 0 0 4px rgba(50,100,150,.4)}.swal2-styled::-moz-focus-inner{border:0}.swal2-footer{-webkit-box-pack:center;justify-content:center;margin:1.25em 0 0;padding:1em 0 0;border-top:1px solid #eee;color:#545454;font-size:1em}.swal2-image{max-width:100%;margin:1.25em auto}.swal2-close{position:absolute;z-index:2;top:0;right:0;-webkit-box-pack:center;justify-content:center;width:1.2em;height:1.2em;padding:0;overflow:hidden;-webkit-transition:color .1s ease-out;transition:color .1s ease-out;border:none;border-radius:0;outline:initial;background:0 0;color:#ccc;font-family:serif;font-size:2.5em;line-height:1.2;cursor:pointer}.swal2-close:hover{-webkit-transform:none;transform:none;background:0 0;color:#f27474}.swal2-content{z-index:1;-webkit-box-pack:center;justify-content:center;margin:0;padding:0;color:#545454;font-size:1.125em;font-weight:300;line-height:normal;text-align:center;word-wrap:break-word}.swal2-checkbox,.swal2-file,.swal2-input,.swal2-radio,.swal2-select,.swal2-textarea{margin:1em auto}.swal2-file,.swal2-input,.swal2-textarea{box-sizing:border-box;width:100%;-webkit-transition:border-color .3s,box-shadow .3s;transition:border-color .3s,box-shadow .3s;border:1px solid #d9d9d9;border-radius:.1875em;background:inherit;box-shadow:inset 0 1px 1px rgba(0,0,0,.06);color:inherit;font-size:1.125em}.swal2-file.swal2-inputerror,.swal2-input.swal2-inputerror,.swal2-textarea.swal2-inputerror{border-color:#f27474!important;box-shadow:0 0 2px #f27474!important}.swal2-file:focus,.swal2-input:focus,.swal2-textarea:focus{border:1px solid #b4dbed;outline:0;box-shadow:0 0 3px #c4e6f5}.swal2-file::-webkit-input-placeholder,.swal2-input::-webkit-input-placeholder,.swal2-textarea::-webkit-input-placeholder{color:#ccc}.swal2-file::-moz-placeholder,.swal2-input::-moz-placeholder,.swal2-textarea::-moz-placeholder{color:#ccc}.swal2-file:-ms-input-placeholder,.swal2-input:-ms-input-placeholder,.swal2-textarea:-ms-input-placeholder{color:#ccc}.swal2-file::-ms-input-placeholder,.swal2-input::-ms-input-placeholder,.swal2-textarea::-ms-input-placeholder{color:#ccc}.swal2-file::placeholder,.swal2-input::placeholder,.swal2-textarea::placeholder{color:#ccc}.swal2-range{margin:1em auto;background:inherit}.swal2-range input{width:80%}.swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}.swal2-range input,.swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}.swal2-input{height:2.625em;padding:0 .75em}.swal2-input[type=number]{max-width:10em}.swal2-file{background:inherit;font-size:1.125em}.swal2-textarea{height:6.75em;padding:.75em}.swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:inherit;color:inherit;font-size:1.125em}.swal2-checkbox,.swal2-radio{-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;background:inherit;color:inherit}.swal2-checkbox label,.swal2-radio label{margin:0 .6em;font-size:1.125em}.swal2-checkbox input,.swal2-radio input{margin:0 .4em}.swal2-validation-message{display:none;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}.swal2-validation-message::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;zoom:normal;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}@supports (-ms-accelerator:true){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@-moz-document url-prefix(){.swal2-close:focus{outline:2px solid rgba(50,100,150,.4)}}.swal2-icon{position:relative;box-sizing:content-box;-webkit-box-pack:center;justify-content:center;width:5em;height:5em;margin:1.25em auto 1.875em;zoom:normal;border:.25em solid transparent;border-radius:50%;font-family:inherit;line-height:5em;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-icon::before{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;height:92%;font-size:3.75em}.swal2-icon.swal2-error{border-color:#f27474}.swal2-icon.swal2-error .swal2-x-mark{position:relative;-webkit-box-flex:1;flex-grow:1}.swal2-icon.swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-icon.swal2-warning{border-color:#facea8;color:#f8bb86}.swal2-icon.swal2-warning::before{content:\"!\"}.swal2-icon.swal2-info{border-color:#9de0f6;color:#3fc3ee}.swal2-icon.swal2-info::before{content:\"i\"}.swal2-icon.swal2-question{border-color:#c9dae1;color:#87adbd}.swal2-icon.swal2-question::before{content:\"?\"}.swal2-icon.swal2-question.swal2-arabic-question-mark::before{content:\"؟\"}.swal2-icon.swal2-success{border-color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-radius:50%}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.4375em;left:-2.0635em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:3.75em 3.75em;transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.6875em;left:1.875em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 3.75em;transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}.swal2-icon.swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-.25em;left:-.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}.swal2-icon.swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-icon.swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.875em;width:1.5625em;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-progress-steps{-webkit-box-align:center;align-items:center;margin:0 0 1.25em;padding:0;background:inherit;font-weight:600}.swal2-progress-steps li{display:inline-block;position:relative}.swal2-progress-steps .swal2-progress-step{z-index:20;width:2em;height:2em;border-radius:2em;background:#3085d6;color:#fff;line-height:2em;text-align:center}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#3085d6}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}.swal2-progress-steps .swal2-progress-step-line{z-index:10;width:2.5em;height:.4em;margin:0 -1px;background:#3085d6}[class^=swal2]{-webkit-tap-highlight-color:transparent}.swal2-show{-webkit-animation:swal2-show .3s;animation:swal2-show .3s}.swal2-show.swal2-noanimation{-webkit-animation:none;animation:none}.swal2-hide{-webkit-animation:swal2-hide .15s forwards;animation:swal2-hide .15s forwards}.swal2-hide.swal2-noanimation{-webkit-animation:none;animation:none}.swal2-rtl .swal2-close{right:auto;left:0}.swal2-animate-success-icon .swal2-success-line-tip{-webkit-animation:swal2-animate-success-line-tip .75s;animation:swal2-animate-success-line-tip .75s}.swal2-animate-success-icon .swal2-success-line-long{-webkit-animation:swal2-animate-success-line-long .75s;animation:swal2-animate-success-line-long .75s}.swal2-animate-success-icon .swal2-success-circular-line-right{-webkit-animation:swal2-rotate-success-circular-line 4.25s ease-in;animation:swal2-rotate-success-circular-line 4.25s ease-in}.swal2-animate-error-icon{-webkit-animation:swal2-animate-error-icon .5s;animation:swal2-animate-error-icon .5s}.swal2-animate-error-icon .swal2-x-mark{-webkit-animation:swal2-animate-error-x-mark .5s;animation:swal2-animate-error-x-mark .5s}@-webkit-keyframes swal2-rotate-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes swal2-rotate-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll!important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static!important}}");

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_breadcrumbs__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_breadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_breadcrumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Callback__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_vue__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Dashboard_Dashboard_vue__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_Dashboard_AgentScoreDashboard_vue__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Components_Error_Unauthorized_vue__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Components_Master_User_UserList_vue__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Components_Master_User_UserCreate_vue__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Components_Master_User_UserUpdate_vue__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Components_Master_User_UserChangePassword_vue__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Components_Master_User_AgentUserList_vue__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Components_Master_User_AgentUserCreate_vue__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Components_Master_User_AgentUserUpdate_vue__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Components_Master_Role_RoleList_vue__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Components_Master_Role_RoleForm_vue__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Components_Master_Holding_HoldingList_vue__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Components_Master_Holding_HoldingCreate_vue__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Components_Master_Holding_HoldingUpdate_vue__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Components_Master_Holding_HoldingImportModal_vue__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Components_Master_Holding_HoldingExportModal_vue__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Components_Master_Transport_ManageTransport_vue__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Components_Master_Transport_CreateTransport_vue__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Components_Master_Transport_EditTransport_vue__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Components_Master_Plant_PlantList_vue__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Components_Master_Plant_PlantCreate_vue__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Components_Master_Plant_PlantUpdate_vue__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Components_Master_Shop_ManageShop_vue__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Components_Master_Shop_CreateShop_vue__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Components_Master_Shop_EditShop_vue__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Components_AgentScore_AgentScoreList_vue__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Components_Report_JobAgentAuditStock_vue__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Components_Report_KegRotationScore_vue__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Components_Report_KegRotationScoreAgent_vue__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Components_Report_AgentStockOverdue_vue__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Components_Master_ShopChangeRequest_ManageShopChangeRequest_vue__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Components_Master_ShopChangeRequest_DetailShopChangeRequest_vue__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Components_Master_ShopSupAgent_ManageShopSubAgent_vue__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Components_Master_ShopSupAgent_CreateShopSubAgent_vue__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Components_Master_ShopSupAgent_EditShopSubAgent_vue__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Components_Master_Agent_AgentList_vue__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Components_Master_Agent_AgentCreate_vue__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Components_Master_Agent_AgentCreateExcel_vue__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Components_Master_Agent_AgentUpdate_vue__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Components_Master_Product_ProductList_vue__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Components_Master_Product_CreateProduct_vue__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Components_Master_Product_ProductDetail_vue__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Components_Master_Product_ProductUpdate_vue__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Components_Master_Brand_BrandList_vue__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Components_Master_Brand_BrandCreate_vue__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Components_Master_Brand_BrandUpdate_vue__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Components_Master_Brand_BrandExportModal_vue__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Components_Master_Supplier_SupplierList_vue__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Components_Master_Supplier_SupplierUpdate_vue__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Components_Master_Contact_ContactList_vue__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Components_Master_Contact_ContactCreate_vue__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Components_Master_Contact_ContactUpdate_vue__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Components_Borrow_ManageBorrowProducts_vue__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Components_Borrow_CreateBorrowProduct_vue__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Components_Borrow_PictureModal_vue__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Components_Borrow_UpdateBorrowProduct_vue__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Components_Borrow_DetialBorrowProduct_vue__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Components_Borrow_JobBorrowProduct_vue__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Components_Borrow_JobBorrowProductReturn_vue__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Components_Master_Barcode_ManageBarcode_vue__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Components_Master_Barcode_CreateBarcode_vue__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Components_Master_Barcode_UpdateBarcode_vue__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Components_Master_Barcode_DetailBarcode_vue__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Components_Master_Barcode_TemplateBarcode_vue__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Components_Master_Barcode_ImportBarcode_vue__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Components_Master_Barcode_DownloadBarcode_vue__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Components_Master_Barcode_EditBarcode_vue__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Components_Job_JobList_vue__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Components_Job_JobCNForm_vue__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Components_WriteOffStockJob_WriteOffStockJobForm_vue__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Components_Master_Order_OrderList_vue__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__Components_Master_Order_OrderCreate_vue__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Components_Master_Order_OrderDetail_vue__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Components_Master_Order_OrderUpdate_vue__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__Components_Master_Approver_ApproverList_vue__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__Components_Master_Approver_CreateApprover_vue__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__Components_Master_Approver_ApproverAgentInfo_vue__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__Components_Master_Approver_ApproverEmployeeInfo_vue__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__Components_Master_Approver_ApproverUserInfo_vue__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__Components_Master_Approver_UpdateApprover_vue__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__Components_Master_CompanyProfile_CompanyProfileList_vue__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Components_Master_CompanyProfile_CompanyProfileCreate_vue__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Components_Master_CompanyProfile_CompanyProfileUpdate_vue__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Components_Report_JobAgentScore_vue__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__Components_Report_AgentScoreEvaluationReport_vue__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__Components_Report_JobRetrieve_vue__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__Components_Report_AssetProducts_vue__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__Components_Report_Movement_vue__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__Components_Report_FixedProducts_vue__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__Components_Report_ProduceProducts_vue__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__Components_Report_BrandCount_vue__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__Components_Report_AgentAssets_vue__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Components_Report_ShopAssets_vue__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Components_Report_TransferBarcode_vue__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__Components_Report_TransferBarcodeMultiple_vue__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__Components_Report_TransferBarcodeSubAgent_vue__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__Components_Report_Barcodes_vue__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__Components_Report_AverageBarcode_vue__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__Components_Report_StockBarcodeSnapshot_vue__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__Components_Report_BarcodeStatus_vue__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__Components_Report_BrandCountBarcodeModal_vue__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__Components_Report_ProductStocks_vue__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__Components_Report_TransferBarcodeSupplier_vue__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__Components_Report_Borrow_vue__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__Components_Report_QIGroupByAgent_vue__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__Components_Report_QIGroupByOfficer_vue__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__Components_Report_NewShopOnOffPremise_vue__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__Components_Report_TransactionView5S_vue__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__Components_Report_EvaluateView5S_vue__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__Components_Report_WarehouseScore_vue__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__Components_Report_NotificationKPI_vue__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__Components_Report_EventAndFood_vue__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__Components_Report_SurveyOnOffPremise_vue__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__Components_Report_StatusBeerClaimMonthly_vue__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__Components_Report_Invoice_vue__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__Components_Report_AmountBeerClaim_vue__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__Components_Report_CostBeerClaim_vue__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__Components_Report_LeaseMachine_vue__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__Components_Report_MachineDetail_vue__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__Components_Report_PMMonthly_vue__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__Components_Report_MTMonthly_vue__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__Components_Report_PMRoutePlan_vue__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__Components_Report_PMSpare_vue__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__Components_Report_PMAlertSummary_vue__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__Components_Report_PM_vue__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__Components_Report_PMSurvey_vue__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__Components_Report_MasterShopOnOff_vue__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__Components_Report_BarButlerByBrand_vue__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__Components_Report_PaymentProduct_vue__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__Components_Report_ReturnProduct_vue__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__Components_Report_BarcodeMappingReport_vue__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__Components_Report_PMOperationReport_vue__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__Components_ReportAlert_OverdueAll_vue__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__Components_ReportAlert_BeforeDue_vue__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__Components_Master_AlertPMConfig_PMList_vue__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__Components_Master_AlertPMConfig_Create_vue__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__Components_Master_AlertPMConfig_Edit_vue__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__Components_AdminReport_MasterShopByBrand_vue__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__Components_AdminReport_JobIssue_vue__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__Components_AdminReport_AlertPM_vue__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__Components_AdminReport_Survey_vue__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__Components_Master_Setting_ManageSetting_vue__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__Components_QICheckIn_CheckInList_vue__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__Components_QICheckIn_CheckInDetail_vue__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__Components_QICheckIn_PictureModal_vue__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__Components_QIJob_QIJobList_vue__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__Components_QIJob_QIJobDetail_vue__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__Components_QIJob_QIJobEditDrawback_vue__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__Components_QIJob_QIJobEditRepair_vue__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__Components_QIJob_QIRecvList_vue__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__Components_QIJob_QIRecvDetail_vue__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__Components_QIJob_QIRecvBorrow_vue__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__Components_QIJob_QIStockList_vue__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__Components_QIJob_ReportStockPending_vue__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__Components_QIJob_ReportChecker_vue__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__Components_QIJob_ReportSparePartsUsed_vue__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__Components_QIJob_ReportSparePartsStock_vue__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__Components_QIJob_ReportDrawback_vue__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__Components_QIJob_ReportRepairSum_vue__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__Components_QIJob_ReportRepairUsage_vue__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__Components_QIJob_ReportQISummary_vue__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__Components_Master_ProductBrand_ProductBrandList_vue__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__Components_Master_ProductBrand_ProductBrandCreate_vue__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__Components_Master_ProductBrand_ProductBrandUpdate_vue__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__Components_Marketing_MarketingList_vue__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__Components_Marketing_MarketingDetail_vue__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__Components_Marketing_MarketingApproveDetail_vue__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__Components_KPI_Products_ProductSlow_vue__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__Components_KPI_Products_ProductExpire_vue__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__Components_KPI_Products_ProductLost_vue__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__Components_KPI_Products_ProductDilapidated_vue__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__Components_KPI_Products_AccessoriesDilapidated_vue__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__Components_KPI_Products_AccessoriesLost_vue__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__Components_KPI_Products_ProductCycle_vue__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__Components_KPI_Products_DamageMach_vue__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__Components_KPI_Products_LostMach_vue__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__Components_KPI_Products_LostTank_vue__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__Components_5S_ManageELearning_vue__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__Components_5S_FolderELearningModal_vue__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__Components_5S_CreateSubFolderELearningModal_vue__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__Components_5S_DetialsELearning_vue__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__Components_5S_UpdateELearning_vue__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__Components_PM_SearchPMRoutePlan_vue__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__Components_PM_AddPMRoutePlan_vue__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__Components_PM_EditPMRoutePlan_vue__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__Components_PM_SearchCheckIn_vue__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__Components_PM_BarcodeMappingDetail_vue__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__Components_PM_PMDetail_vue__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__Components_PM_MTDetail_vue__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__Components_PM_PictureModal_vue__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__Components_PM_SearchSurveyCheckIn_vue__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__Components_PM_PMSurveyBarcodeMappingDetail_vue__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__Components_PM_PMSurveyDetail_vue__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__Components_PM_SurveyPictureModal_vue__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__Components_BeerClaim_SearchBeerClaim_vue__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__Components_BeerClaim_AddBeerClaim_vue__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__Components_BeerClaim_AddBeerClaimItem_vue__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__Components_BeerClaim_EditBeerClaim_vue__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__Components_BeerClaim_CommitBeerClaim_vue__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__Components_BeerClaim_ResultBeerClaim_vue__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__Components_BeerClaim_ApproveBeerClaim_vue__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__Components_BeerClaim_ConcludeApproveBeerClaim_vue__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__Components_BeerClaim_BeerClaimDetail_vue__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__Components_BeerClaim_BeerClaimItemDetail_vue__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__Components_Master_Phase_ManagePhase_vue__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__Components_Master_Phase_ImportPhase_vue__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__Components_Master_Phase_DownloadPhase_vue__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__Components_Master_MachineTransaction_ManageMachineTransaction_vue__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__Components_Master_MachineTransaction_ImportMachineTransaction_vue__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__Components_Master_MachineTransaction_DownloadMachineTransaction_vue__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__Components_Machine_SaveBillingMachinePayment_vue__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__Components_Machine_PaymentMachinePayment_vue__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__Components_Machine_ListMachine_vue__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__Components_Master_SalesArea_SalesAreaList_vue__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__Components_Master_SalesArea_SalesAreaCreate_vue__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__Components_Master_SalesArea_SalesAreaUpdate_vue__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__Components_Master_OverdueSetting_OverdueSettingList_vue__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__Components_Master_OverdueSetting_OverdueSettingCreate_vue__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__Components_Master_OverdueSetting_OverdueSettingUpdate_vue__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__Components_Master_MasterProductUnitPrice_MasterProductUnitPriceList_vue__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__Components_Master_MasterProductUnitPrice_MasterProductUnitPriceCreate_vue__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__Components_Master_MasterProductUnitPrice_MasterProductUnitPriceUpdate_vue__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__Components_BudgetPlan_BudgetPlanList_vue__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__Components_BudgetPlan_BudgetJob_vue__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__Components_BudgetPlan_BudgetPlanDetail_vue__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__Components_BudgetPlan_BudgetPlanCreate_vue__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__Components_BudgetPlan_BudgetPlanJobList_vue__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__Components_BudgetPlan_BudgetPlanJobCreate_vue__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__Components_BudgetPlan_ApproveGroupList_vue__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__Components_BudgetPlan_ApproveGroupForm_vue__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__Components_BudgetPlan_BudgetPlanGroupApprove_vue__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__Components_BudgetPlan_BudgetPlanMonitoring_vue__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__Components_BudgetPlan_VendorUsageReport_vue__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__Components_BudgetPlan_BudgetPlanMonitoringSendApprovalGroup_vue__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__Components_BudgetPlan_BudgetPlanMonitoringBiSnapData_vue__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__Components_StockCoverDays_StockCoverDaysList_vue__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__Components_StockCoverDays_StockCoverDaysCreate_vue__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__Components_StockCoverDays_StockCoverDaysDetail_vue__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__Components_StockCoverDays_StockCoverDaysReportAnalysis_vue__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__Components_StockCoverDays_StockCoverDaysDashboard_vue__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__Components_StockCoverDays_StockCoverDaysReport_vue__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__Components_Monitoring_MonitoringScheduledJobs_vue__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__Components_Monitoring_MonitoringSendEmailReportAgent_vue__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__Components_Monitoring_MonitoringClearImage_vue__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__Components_Monitoring_MonitoringHub_vue__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__Components_Monitoring_MonitoringScvd_vue__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__Components_PrintSummary_FormSummaryStockList_vue__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__Components_PrintSummary_FormSummaryStockCreate_vue__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__Components_PrintSummary_FormSummaryStockPreview_vue__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__Components_PrintSummary_FormSummaryStockGroupPreview_vue__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__Components_PrintSummary_FormSummaryStockDetail_vue__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__Components_PrintSummary_FormSummaryStockGroupResult_vue__ = __webpack_require__(1345);









// Error

// User







// Role


// Holding





// Search
// import SearchBeer from "./Components/Master/SearchBeer/SearchBeer.vue";
// import SearchDetail from "./Components/Master/SearchBeer/Detail.vue";
// Transport



// Stock



// Shop





//AgentScore 






// ShopChangeRequest



// ShopProfile
// import ManageShopProfile from "./Components/Master/ShopProfile/ManageShopProfile.vue";
// import CreateShopProfile from "./Components/Master/ShopProfile/CreateShopProfile.vue";
// import EditShopProfile from "./Components/Master/ShopProfile/EditShopProfile.vue";
// import DetailShopProfile from "./Components/Master/ShopProfile/DetailShopProfile.vue";

// ShopSubAgent



//Agent




// import Test from "./Components/Master/Agent/TestPlUpload.vue";


// Product




// Brand




//Stock Product
// import ManageStockProduct from "./Components/Master/StockProduct/ManageStockProduct.vue";
// import UpdateStockProduct from "./Components/Master/StockProduct/StockProductUpdate.vue";
//Supplier



//Upload stock beand
// import UploadStockBrand from "./Components/Master/ImportStockProduct/ImportStockProduct.vue";
//Test create table
// import TestCreate from "./Components/Master/ImportStockProduct/Test.vue";
//Contact



//BorrowProduct
 //"./Components/Borrow/ManageBorrowProducts.vue";






//CheckHoldProduct
// import ManageCheckHoldProduct from "./Components/Master/CheckHoldProduct/ListCheckHoldProduct.vue";
// import UpdateCheckHoldProduct from "./Components/Master/CheckHoldProduct/UpdateCheckHoldProduct.vue";
//Barcode








// Job



// CR-Job-Stock — ใบงานตัดยอดคงค้าง (Write-off Outstanding Stock)

// Order




//Approver






//CustomerProfile




//Report



















































// ReportAlert

//BeforeDue


// Aler PM Config 




//AdminReport
// import PMReport from "./Components/AdminReport/PM.vue";
// import MasterShopOnOffReport from "./Components/AdminReport/MasterShopOnOff.vue";

// import BarButlerByBrandReport from "./Components/AdminReport/BarButlerByBrand.vue";




//Setting


//QICheckIn




//QIJob









//QIJob Report









//ProductBrand




//Marketing




//KPI











//E-Learning






//PM









//PM Survey CheckIn



// import MTDetail from "./Components/PM/MTDetail.vue";


//BeerClaim











//Phase

//import TemplatePhase from "./Components/Master/Barcode/TemplateBarcode.vue";



//Phase

//import TemplatePhase from "./Components/Master/Barcode/TemplateBarcode.vue";



//MachinPayment




//MachinPayment




// Alert ถัง



// ราคาค่าถัง




// Budget Plan
























// CR-FormSummaryStock — เอกสารสรุปสินค้าคงค้าง







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__, {
  load: {
    key: "REPLACE-THIS-WITH-YOUR-KEY-FROM-ABOVE",
    libraries: "places" // necessary for places input
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_breadcrumbs___default.a, {
  template: '<div class="kt-subheader__breadcrumbs"><router-link to="/" class="kt-subheader__breadcrumbs-home"><i class="flaticon2-shelter"></i></router-link>' + '<template v-for="(crumb, key) in $breadcrumbs"><span class="kt-subheader__breadcrumbs-separator"></span><router-link class="kt-subheader__breadcrumbs-link" :to="linkProp(crumb)" :key="key">{{ crumb | crumbText }}</router-link></template>' + "</div>"
});

var routes = [{
  path: "/",
  component: __WEBPACK_IMPORTED_MODULE_4__App_vue__["a" /* default */],
  meta: {
    requiredAuth: true,
    requiredRoles: []
  },
  children: [{
    path: "",
    component: __WEBPACK_IMPORTED_MODULE_7__Components_Dashboard_Dashboard_vue__["a" /* default */],
    meta: {
      breadcrumb: "แดชบอร์ด",
      requiredAuth: true,
      requiredRoles: ["DASHBOARD"]
    }
  }, {
    path: "/AgentScoreDashboard",
    component: __WEBPACK_IMPORTED_MODULE_8__Components_Dashboard_AgentScoreDashboard_vue__["a" /* default */],
    meta: {
      breadcrumb: "คะแนนตัวแทนจำหน่าย",
      requiredAuth: true,
      requiredRoles: ["AGENT_REPORT", "BR_REPORT", "AGENT_SCORE_ADMIN"],
      excludedProfileTypes: ["COMPANY_PROFILE_TYPE_BR"]
    }
  }, {
    path: "/AgentStockOverdue",
    component: __WEBPACK_IMPORTED_MODULE_37__Components_Report_AgentStockOverdue_vue__["a" /* default */],
    meta: {
      breadcrumb: "รายงาน STOCK ระบบเบียร์สด",
      requiredAuth: true,
      requiredRoles: ["AGENT_REPORT", "BR_REPORT", "AGENT_SCORE_ADMIN", "BR_DASHBOARD_AUDIT_STOCK"],
      excludedProfileTypes: ["COMPANY_PROFILE_TYPE_BR"]
    }
  }, {
    path: "/Error",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "ข้อผิดพลาด",
      requiredAuth: false,
      defaultChild: "Unauthorized"
    },
    children: [{
      path: "Unauthorized",
      component: __WEBPACK_IMPORTED_MODULE_9__Components_Error_Unauthorized_vue__["a" /* default */],
      meta: {
        breadcrumb: "ไม่มีสิทธิ์เข้าใช้งาน",
        requiredAuth: false
      }
    }]
  }, {
    path: "/Master",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "ข้อมูลพื้นฐาน",
      requiredAuth: true,
      defaultChild: "Users"
    },
    children: [{
      path: "Users",
      component: __WEBPACK_IMPORTED_MODULE_10__Components_Master_User_UserList_vue__["a" /* default */],
      meta: {
        breadcrumb: "สมาชิก",
        requiredAuth: true,
        requiredRoles: ["MASTER_USER"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_11__Components_Master_User_UserCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลสมาชิก",
          requiredAuth: true,
          requiredRoles: ["MASTER_USER"]
        }
      }, {
        path: "Edit/:userId",
        component: __WEBPACK_IMPORTED_MODULE_12__Components_Master_User_UserUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลสมาชิก",
          requiredAuth: true,
          requiredRoles: ["MASTER_USER"]
        }
      }, {
        path: "ChangePassword/:userId",
        component: __WEBPACK_IMPORTED_MODULE_13__Components_Master_User_UserChangePassword_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขรหัสผ่านสมาชิก",
          requiredAuth: true,
          requiredRoles: ["MASTER_USER"]
        }
      }]
    }, {
      path: "AgentUsers",
      component: __WEBPACK_IMPORTED_MODULE_14__Components_Master_User_AgentUserList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลสมาชิกตัวแทน/ตัวแทนจำหน่ายย่อย",
        requiredAuth: true,
        requiredRoles: ["MANAGE_SUB_AGENT_USER"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_15__Components_Master_User_AgentUserCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลสมาชิก",
          requiredAuth: true,
          requiredRoles: ["MANAGE_SUB_AGENT_USER"]
        }
      }, {
        path: "Edit/:userId",
        component: __WEBPACK_IMPORTED_MODULE_16__Components_Master_User_AgentUserUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลสมาชิก",
          requiredAuth: true,
          requiredRoles: ["MANAGE_SUB_AGENT_USER"]
        }
      }]
    }, {
      path: "Roles",
      component: __WEBPACK_IMPORTED_MODULE_17__Components_Master_Role_RoleList_vue__["a" /* default */],
      meta: {
        breadcrumb: "บทบาท",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MASTER_ROLE"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_18__Components_Master_Role_RoleForm_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลบทบาท",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MASTER_ROLE"]
        }
      }, {
        path: "Edit/:roleName",
        component: __WEBPACK_IMPORTED_MODULE_18__Components_Master_Role_RoleForm_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลบทบาท",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MASTER_ROLE"]
        }
      }]
    }, {
      path: "Holding",
      component: __WEBPACK_IMPORTED_MODULE_19__Components_Master_Holding_HoldingList_vue__["a" /* default */],
      meta: {
        breadcrumb: "ระยะเวลาถือครองสินค้า",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MASTER_HOLDING"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_20__Components_Master_Holding_HoldingCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลการถือครอง",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MASTER_HOLDING"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_21__Components_Master_Holding_HoldingUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลการถือครอง",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MASTER_HOLDING"]
        }
      }, {
        path: "Import",
        component: __WEBPACK_IMPORTED_MODULE_22__Components_Master_Holding_HoldingImportModal_vue__["a" /* default */],
        meta: {
          breadcrumb: "Import ข้อมูลการถือครอง",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MASTER_HOLDING"]
        }
      }, {
        path: "Export",
        component: __WEBPACK_IMPORTED_MODULE_23__Components_Master_Holding_HoldingExportModal_vue__["a" /* default */],
        meta: {
          breadcrumb: "Export ข้อมูลการถือครอง",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MASTER_HOLDING"]
        }
      }]
    }, {
      path: "ManageTransport",
      component: __WEBPACK_IMPORTED_MODULE_24__Components_Master_Transport_ManageTransport_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลขนส่ง",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_TRANSPORT"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_25__Components_Master_Transport_CreateTransport_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลขนส่ง",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_TRANSPORT"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_26__Components_Master_Transport_EditTransport_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลขนส่ง",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_TRANSPORT"]
        }
      }]
    }, {
      path: "Plant",
      component: __WEBPACK_IMPORTED_MODULE_27__Components_Master_Plant_PlantList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลคลังสินค้า",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_PLANT"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_28__Components_Master_Plant_PlantCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลคลังสินค้า",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_PLANT"]
        }
      }, {
        path: "Edit/:Plantid",
        component: __WEBPACK_IMPORTED_MODULE_29__Components_Master_Plant_PlantUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลคลังสินค้า",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_PLANT"]
        }
      }]
    }, {
      path: "ManageShop",
      component: __WEBPACK_IMPORTED_MODULE_30__Components_Master_Shop_ManageShop_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลร้านค้า",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_31__Components_Master_Shop_CreateShop_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลร้านค้า",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_32__Components_Master_Shop_EditShop_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลร้านค้า",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"]
        }
      }, {
        path: "ExportShop",
        component: __WEBPACK_IMPORTED_MODULE_30__Components_Master_Shop_ManageShop_vue__["a" /* default */],
        meta: {
          breadcrumb: "Export ข้อมูลร้านค้า",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"]
        }
      }, {
        path: "ExportAgent",
        component: __WEBPACK_IMPORTED_MODULE_43__Components_Master_Agent_AgentList_vue__["a" /* default */],
        meta: {
          breadcrumb: "Export ข้อมูลตัวแทนจำหน่าย",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"]
        }
      }, {
        path: "ExportSuplier",
        component: __WEBPACK_IMPORTED_MODULE_55__Components_Master_Supplier_SupplierList_vue__["a" /* default */],
        meta: {
          breadcrumb: "Export ข้อมูลSuplier",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"]
        }
      }]
    }, {
      path: "ManageShopChangeRequest",
      component: __WEBPACK_IMPORTED_MODULE_38__Components_Master_ShopChangeRequest_ManageShopChangeRequest_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการขอแก้ไขข้อมูลร้านค้า",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP_CHANGE_REQUEST", "ADMIN_MKT", "ADMIN_PM", "ADMIN_QI", "MANAGER_MKT", "MANAGER_QI", "USER_QI", "USER_MKT"]
      },
      children: [{
        path: "Detail/:id",
        component: __WEBPACK_IMPORTED_MODULE_39__Components_Master_ShopChangeRequest_DetailShopChangeRequest_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดขอแก้ไขข้อมูลร้านค้า",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP_CHANGE_REQUEST", "ADMIN_MKT", "ADMIN_PM", "ADMIN_QI", "MANAGER_MKT", "MANAGER_QI", "USER_QI"]
        }
      }]
    },
    // {
    //   path: "ManageShopProfile",
    //   component: ManageShopProfile,
    //   meta: {
    //     breadcrumb: "จัดการข้อมูลโปรไฟล์ร้านค้า",
    //     requiredAuth: true,
    //     requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOPPROFILE"],
    //   },
    //   children: [
    //     {
    //       path: "Add",
    //       component: CreateShopProfile,
    //       meta: {
    //         breadcrumb: "เพิ่มข้อมูลโปรไฟล์ร้านค้า",
    //         requiredAuth: true,
    //         requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOPPROFILE"],
    //       },
    //     },
    //     {
    //       path: "Edit/:id",
    //       component: EditShopProfile,
    //       meta: {
    //         breadcrumb: "แก้ไขข้อมูลโปรไฟล์ร้านค้า",
    //         requiredAuth: true,
    //         requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOPPROFILE"],
    //       },
    //     },
    //     {
    //       path: "Detail/:id",
    //       component: DetailShopProfile,
    //       meta: {
    //         breadcrumb: "รายละเอียดข้อมูลโปรไฟล์ร้านค้า",
    //         requiredAuth: true,
    //         requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOPPROFILE"],
    //       },
    //     },
    //   ],
    // },
    {
      path: "ManageShopSubAgent",
      component: __WEBPACK_IMPORTED_MODULE_40__Components_Master_ShopSupAgent_ManageShopSubAgent_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลร้านค้าตัวแทนจำหน่ายย่อย",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP_SUB_AGENT"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_41__Components_Master_ShopSupAgent_CreateShopSubAgent_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลร้านค้าตัวแทนจำหน่ายย่อย",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP_SUB_AGENT"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_42__Components_Master_ShopSupAgent_EditShopSubAgent_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลร้านค้าตัวแทนจำหน่ายย่อย",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP_SUB_AGENT"]
        }
      }]
    }, {
      path: "Agents",
      component: __WEBPACK_IMPORTED_MODULE_43__Components_Master_Agent_AgentList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลตัวแทนจำหน่าย",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MASTER_AGENT"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_44__Components_Master_Agent_AgentCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลตัวแทนจำหน่าย",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MASTER_AGENT"]
        }
      }, {
        path: "AddExcel",
        component: __WEBPACK_IMPORTED_MODULE_45__Components_Master_Agent_AgentCreateExcel_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลตัวแทนจำหน่าย(Excel)",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MASTER_AGENT"]
        }
      }, {
        path: "Edit/:AgentID",
        // component: Test,
        component: __WEBPACK_IMPORTED_MODULE_46__Components_Master_Agent_AgentUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลตัวแทนจำหน่าย",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MASTER_AGENT"]
        }
      }]
    }, {
      path: "Product",
      component: __WEBPACK_IMPORTED_MODULE_47__Components_Master_Product_ProductList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลสินค้า",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCT"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_48__Components_Master_Product_CreateProduct_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลสินค้า",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCT"]
        }
      }, {
        path: "Detail/:id",
        component: __WEBPACK_IMPORTED_MODULE_49__Components_Master_Product_ProductDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดข้อมูลสินค้า",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCT"]
        }
      }, {
        path: "Update/:id",
        component: __WEBPACK_IMPORTED_MODULE_50__Components_Master_Product_ProductUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลสินค้า",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCT"]
        }
      }]
    }, {
      path: "ManageBrand",
      component: __WEBPACK_IMPORTED_MODULE_51__Components_Master_Brand_BrandList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการงบประมาณ",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_BRAND"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_52__Components_Master_Brand_BrandCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลงบประมาณแบรนด์",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_BRAND"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_53__Components_Master_Brand_BrandUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลงบประมาณแบรนด์",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_BRAND"]
        }
      }, {
        path: "Export",
        component: __WEBPACK_IMPORTED_MODULE_54__Components_Master_Brand_BrandExportModal_vue__["a" /* default */],
        meta: {
          breadcrumb: "ข้อมูลงบประมาณแบรนด์",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_BRAND"]
        }
      }]
    }, {
      path: "Supplier",
      component: __WEBPACK_IMPORTED_MODULE_55__Components_Master_Supplier_SupplierList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูล Supplier",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_SUPPLIER"]
      },
      children: [{
        path: "Update/:id",
        component: __WEBPACK_IMPORTED_MODULE_56__Components_Master_Supplier_SupplierUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูล Supplier",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SUPPLIER"]
        }
      }]
    }, {
      path: "Contact",
      component: __WEBPACK_IMPORTED_MODULE_57__Components_Master_Contact_ContactList_vue__["a" /* default */],
      meta: {
        breadcrumb: "ข้อมูลผู้ติดต่อ",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_CONTACT"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_58__Components_Master_Contact_ContactCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลผู้ติดต่อ",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_CONTACT"]
        }
      }, {
        path: "Update/:id",
        component: __WEBPACK_IMPORTED_MODULE_59__Components_Master_Contact_ContactUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลผู้ติดต่อ",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_CONTACT"]
        }
      }]
    }, {
      path: "AlertPMConfig",
      component: __WEBPACK_IMPORTED_MODULE_143__Components_Master_AlertPMConfig_PMList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลวัน Alert PM",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_144__Components_Master_AlertPMConfig_Create_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่ม จัดการข้อมูลวัน Alert PM",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_145__Components_Master_AlertPMConfig_Edit_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไข จัดการข้อมูลวัน Alert PM",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"]
        }
      }]
    }, {
      path: "ManageBarcode",
      component: __WEBPACK_IMPORTED_MODULE_67__Components_Master_Barcode_ManageBarcode_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูล BARCODE",
        requiredAuth: true
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_68__Components_Master_Barcode_CreateBarcode_vue__["a" /* default */],
        meta: { breadcrumb: "เพิ่มข้อมูล BARCODE", requiredRoles: ["MANAGE_MASTER"] }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_69__Components_Master_Barcode_UpdateBarcode_vue__["a" /* default */],
        meta: { breadcrumb: "แก้ไขข้อมูล BARCODE", requiredRoles: ["MANAGE_MASTER"] }
      }, {
        path: "Detail/:id",
        component: __WEBPACK_IMPORTED_MODULE_70__Components_Master_Barcode_DetailBarcode_vue__["a" /* default */],
        meta: { breadcrumb: "รายละเอียด BARCODE", requiredRoles: ["MANAGE_MASTER"] }
      }, {
        path: "TemplateBarcode",
        component: __WEBPACK_IMPORTED_MODULE_71__Components_Master_Barcode_TemplateBarcode_vue__["a" /* default */],
        meta: { breadcrumb: "Template Barcode", requiredRoles: ["MANAGE_MASTER"] }
      }, {
        path: "Import",
        component: __WEBPACK_IMPORTED_MODULE_72__Components_Master_Barcode_ImportBarcode_vue__["a" /* default */],
        meta: { breadcrumb: "Import Barcode", requiredRoles: ["MANAGE_MASTER"] }
      }, {
        path: "DownloadBarcode",
        component: __WEBPACK_IMPORTED_MODULE_73__Components_Master_Barcode_DownloadBarcode_vue__["a" /* default */],
        meta: { breadcrumb: "Download Barcode", requiredRoles: ["MANAGE_MASTER"] }
      }, {
        path: "EditBarcode/:id",
        component: __WEBPACK_IMPORTED_MODULE_74__Components_Master_Barcode_EditBarcode_vue__["a" /* default */],
        meta: { breadcrumb: "แก้ไขบาร์โค้ด", requiredRoles: ["MANAGE_MASTER"] }
      }, {
        path: "Detail/:id",
        component: __WEBPACK_IMPORTED_MODULE_70__Components_Master_Barcode_DetailBarcode_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียด BARCODE",
          requiredRoles: ["MANAGE_MASTER", "MANAGE_BARCODE_AGENT", "MANAGE_BARCODE_SUB_AGENT"]
        }
      }]
    }, {
      path: "Order",
      name: "Order",
      component: __WEBPACK_IMPORTED_MODULE_79__Components_Master_Order_OrderList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลการสั่งซื้อ (Order)",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_ORDER"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_80__Components_Master_Order_OrderCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลการสั่งซื้อ",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_ORDER"]
        }
      }, {
        path: "Detail/:id",
        component: __WEBPACK_IMPORTED_MODULE_81__Components_Master_Order_OrderDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดการสั่งซื้อ",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_ORDER"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_82__Components_Master_Order_OrderUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลการสั่งซื้อ",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_ORDER"]
        }
      }]
    }, {
      path: "Approver",
      name: "Approver",
      component: __WEBPACK_IMPORTED_MODULE_83__Components_Master_Approver_ApproverList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการผู้อนุมัติการเบิกยืมสินค้า",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_84__Components_Master_Approver_CreateApprover_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลกลุ่มอนุมัติ",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"]
        },
        children: [{
          path: "Agent/:id",
          component: __WEBPACK_IMPORTED_MODULE_85__Components_Master_Approver_ApproverAgentInfo_vue__["a" /* default */],
          meta: {
            breadcrumb: "ข้อมูลตัวแทนจำหน่าย",
            requiredAuth: true,
            requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"]
          }
        }, {
          path: "Employee/:id",
          component: __WEBPACK_IMPORTED_MODULE_86__Components_Master_Approver_ApproverEmployeeInfo_vue__["a" /* default */],
          meta: {
            breadcrumb: "ข้อมูลพนักงาน",
            requiredAuth: true,
            requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"]
          }
        }, {
          path: "User/:id",
          component: __WEBPACK_IMPORTED_MODULE_87__Components_Master_Approver_ApproverUserInfo_vue__["a" /* default */],
          meta: {
            breadcrumb: "ข้อมูลผู้อนุมัติ",
            requiredAuth: true,
            requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"]
          }
        }]
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_88__Components_Master_Approver_UpdateApprover_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลกลุ่มอนุมัติ",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"]
        },
        children: [{
          path: "Agent/:id",
          component: __WEBPACK_IMPORTED_MODULE_85__Components_Master_Approver_ApproverAgentInfo_vue__["a" /* default */],
          meta: {
            breadcrumb: "ข้อมูลตัวแทนจำหน่าย",
            requiredAuth: true,
            requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"]
          }
        }, {
          path: "Employee/:id",
          component: __WEBPACK_IMPORTED_MODULE_86__Components_Master_Approver_ApproverEmployeeInfo_vue__["a" /* default */],
          meta: {
            breadcrumb: "ข้อมูลพนักงาน",
            requiredAuth: true,
            requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"]
          }
        }, {
          path: "User/:id",
          component: __WEBPACK_IMPORTED_MODULE_87__Components_Master_Approver_ApproverUserInfo_vue__["a" /* default */],
          meta: {
            breadcrumb: "ข้อมูลผู้อนุมัติ",
            requiredAuth: true,
            requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"]
          }
        }]
      }]
    }, {
      path: "CompanyProfile",
      component: __WEBPACK_IMPORTED_MODULE_89__Components_Master_CompanyProfile_CompanyProfileList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการโปรไฟล์บริษัท",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_COMPANY_PROFILE"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_90__Components_Master_CompanyProfile_CompanyProfileCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลโปรไฟล์บริษัท",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_COMPANY_PROFILE"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_91__Components_Master_CompanyProfile_CompanyProfileUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลโปรไฟล์บริษัท",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_COMPANY_PROFILE"]
        }
      }]
    }, {
      path: "Setting",
      component: __WEBPACK_IMPORTED_MODULE_150__Components_Master_Setting_ManageSetting_vue__["a" /* default */],
      meta: {
        breadcrumb: "ตั้งค่าพื้นฐาน",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"]
      }
    }, {
      path: "ProductBrand",
      component: __WEBPACK_IMPORTED_MODULE_170__Components_Master_ProductBrand_ProductBrandList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลแบรนด์",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_171__Components_Master_ProductBrand_ProductBrandCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มแบรนด์",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_172__Components_Master_ProductBrand_ProductBrandUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลแบรนด์",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]
        }
      }]
    }, {
      path: "SalesArea",
      component: __WEBPACK_IMPORTED_MODULE_222__Components_Master_SalesArea_SalesAreaList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลเขตการขาย",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_SALESAREA"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_223__Components_Master_SalesArea_SalesAreaCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลเขตการขาย",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SALESAREA"]
        }
      }, {
        path: "Edit/:SalesAreaid",
        component: __WEBPACK_IMPORTED_MODULE_224__Components_Master_SalesArea_SalesAreaUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลเขตการขาย",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SALESAREA"]
        }
      }]
    },
    //start ตั้งค่า Alert ถัง-
    {
      path: "OverdueSetting",
      component: __WEBPACK_IMPORTED_MODULE_225__Components_Master_OverdueSetting_OverdueSettingList_vue__["a" /* default */],
      meta: {
        breadcrumb: "ตั้งค่าการแจ้งเตือนคงค้างเกินกำหนดเวลา",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_226__Components_Master_OverdueSetting_OverdueSettingCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มตั้งค่าการแจ้งเตือนคงค้างเกินกำหนดเวลา",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_227__Components_Master_OverdueSetting_OverdueSettingUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลตั้งค่าการแจ้งเตือนคงค้างเกินกำหนดเวลา",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"]
        }
      }]
    },
    //end ตั้งค่า Alert ถัง-
    //start ตั้งค่า ราคา ถัง-
    {
      path: "MasterProductUnitPrice",
      component: __WEBPACK_IMPORTED_MODULE_228__Components_Master_MasterProductUnitPrice_MasterProductUnitPriceList_vue__["a" /* default */],
      meta: {
        breadcrumb: "ตั้งค่าราคาค่าถัง",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_229__Components_Master_MasterProductUnitPrice_MasterProductUnitPriceCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มตั้งค่าราคาค่าถัง",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_230__Components_Master_MasterProductUnitPrice_MasterProductUnitPriceUpdate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลตั้งค่าราคาค่าถัง",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"]
        }
      }]
    }]
  }, {
    path: "/Jobs",
    name: "JobSearch",
    component: __WEBPACK_IMPORTED_MODULE_75__Components_Job_JobList_vue__["a" /* default */],
    meta: {
      breadcrumb: "ใบงาน (Job)",
      requiredAuth: true
      // requiredRoles: [
      //     "JOB_ADMIN_IMPORT_NEW_ASSETS",
      //     "JOB_ADMIN_PRODUCE",
      //     "JOB_ADMIN_DESTROY",
      //     "JOB_ADMIN_TRANSFER_TO_AGENT",
      //     "JOB_ADMIN_REPAIR_SUPPLIER",
      //     "JOB_ADMIN_TRANSFER_TO_SHOP"
      // ]
    },
    children: [{
      path: "Create/RETRIEVE_NEW_ITEM",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "รับทรัพย์สินใหม่",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_IMPORT_NEW_ASSETS"],
        jobType: "RETRIEVE_NEW_ITEM"
      }
    }, {
      path: "Create/PRODUCE",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "ผลิตเบียร์สด",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_PRODUCE"],
        jobType: "PRODUCE"
      }
    }, {
      path: "Create/DESTROY",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "ทำลายทรัพย์สิน",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_DESTROY"],
        jobType: "DESTROY"
      }
    }, {
      path: "Create/TRANSFER_TO_AGENT",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "ส่งสินค้าไปยังตัวแทน ฯ",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_TRANSFER_TO_AGENT"],
        jobType: "TRANSFER_TO_AGENT"
      }
    }, {
      path: "Create/REPAIR_SUPPLIER",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "ส่งซ่อมซัพพลายเออร์",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_REPAIR_SUPPLIER"],
        jobType: "REPAIR_SUPPLIER"
      }
    }, {
      path: "Create/RETURN_SUPPLIER",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "รับคืนจากซัพพลายเออร์",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_RETURN_SUPPLIER"],
        jobType: "RETURN_SUPPLIER"
      }
    }, {
      path: "Create/TRANSFER_TO_SHOP",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_TRANSFER_TO_SHOP"],
        jobType: "TRANSFER_TO_SHOP"
      }
    }, {
      path: "Create/TRANSFER_TO_MULTI_SHOP",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า(หลายร้านค้า)",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_TRANSFER_TO_SHOP"],
        jobType: "TRANSFER_TO_MULTI_SHOP"
      }
    }, {
      path: "Create/PICKUP",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "หยิบสินค้าขึ้นรถ (เร่ขาย)",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_PICKUP"],
        jobType: "PICKUP"
      }
    }, {
      path: "Create/RETURN",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "ส่งสินค้า/ทรัพย์สินคืนต้นทาง",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_RETURN"],
        jobType: "RETURN"
      }
    }, {
      path: "Create/EXCHANGE",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "โอนทรัพย์สิน",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_EXCHANGE"],
        jobType: "EXCHANGE"
      }
    }, {
      path: "Create/BORROW",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "เบิก/ยืมทรัพย์สินเบียร์สด",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_BORROW", "JOB_ADMIN_BORROW_PLANT"],
        jobType: "BORROW"
      }
    }, {
      path: "Create/RETURN_ADHOC",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "รับคืนสินค้า/ทรัพย์สินจากลูกค้า",
        requiredAuth: true,
        requiredRoles: ["JOB_ADMIN_RETURN"],
        jobType: "RETURN_ADHOC"
      }
    }, {
      path: "Create/AUDIT_STOCK",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "ตรวจสอบ STOCK",
        requiredAuth: true,
        requiredRoles: ["super_admin", "BR_MANAGE_AUDIT_STOCK", "MANAGE_AUDIT_STOCK"],
        jobType: "AUDIT_STOCK"
      }
    },
    // CR-Job-Stock §6.1 Phase 1 — ใบงานตัดยอดคงค้าง (Write-off Outstanding Stock)
    {
      path: "Create/WRITE_OFF_STOCK",
      component: __WEBPACK_IMPORTED_MODULE_78__Components_WriteOffStockJob_WriteOffStockJobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "ตัดยอดคงค้าง",
        requiredAuth: true,
        requiredRoles: ["super_admin", "JOB_ADMIN_WRITE_OFF_STOCK_PLANT"],
        jobType: "WRITE_OFF_STOCK"
      }
    }, {
      path: "WriteOffStock/Edit/:id",
      component: __WEBPACK_IMPORTED_MODULE_78__Components_WriteOffStockJob_WriteOffStockJobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "แก้ไขใบงานตัดยอดคงค้าง",
        requiredAuth: true,
        requiredRoles: ["super_admin", "JOB_ADMIN_WRITE_OFF_STOCK_PLANT"],
        jobType: "WRITE_OFF_STOCK"
      }
    }, {
      path: "WriteOffStock/View/:id",
      component: __WEBPACK_IMPORTED_MODULE_78__Components_WriteOffStockJob_WriteOffStockJobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "ดูใบงานตัดยอดคงค้าง",
        requiredAuth: true,
        jobType: "WRITE_OFF_STOCK"
      }
    },
    // {
    //   path: "Create/INVALID_CHECK",
    //   component: JobForm,
    //   meta: {
    //     breadcrumb: "ตรวจสอบข้อมูลทรัพย์สินไม่ถูกต้อง",
    //     requiredAuth: true,
    //     requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI"],
    //     jobType: "INVALID_CHECK",
    //   },
    // },
    {
      name: "JobEdit",
      path: "Edit/:id",
      component: __WEBPACK_IMPORTED_MODULE_76__Components_Job_JobForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "แก้ไขใบงาน",
        requiredAuth: true
        // ไม่ต้องตรวจสอบสิทธิ์ เพราะหากไม่มีสิทธิ์ Server จะไม่ส่งข้อมูลให้
      }
    }, {
      path: "EditCN/:id",
      component: __WEBPACK_IMPORTED_MODULE_77__Components_Job_JobCNForm_vue__["a" /* default */],
      meta: {
        breadcrumb: "ตรวจสอบแก้ไขข้อมูล CN",
        requiredAuth: true,
        requiredRoles: []
      }
    }]
  }, {
    path: "/Borrow",
    name: "ManageBorrowProduct",
    component: __WEBPACK_IMPORTED_MODULE_60__Components_Borrow_ManageBorrowProducts_vue__["a" /* default */],
    meta: {
      breadcrumb: "เบิก/ยืม ทรัพย์สิน",
      requiredAuth: true,
      requiredRoles: ["MANAGE_MASTER", "JOB_ADMIN_BORROW", "JOB_ADMIN_BORROW_PLANT", "JOB_ADMIN_BORROW_APPROVE"]
    },
    children: [{
      path: "Add",
      component: __WEBPACK_IMPORTED_MODULE_61__Components_Borrow_CreateBorrowProduct_vue__["a" /* default */],
      meta: {
        breadcrumb: "เพิ่มข้อมูลเบิก/ยืม ทรัพย์สิน",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "JOB_ADMIN_BORROW", "JOB_ADMIN_BORROW_PLANT"]
      },
      children: [{
        path: "Picture/:url",
        component: __WEBPACK_IMPORTED_MODULE_62__Components_Borrow_PictureModal_vue__["a" /* default */],
        meta: {
          breadcrumb: "รูปภาพ",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "JOB_ADMIN_BORROW", "JOB_ADMIN_BORROW_PLANT"]
        }
      }]
    }, {
      path: "Edit/:id",
      component: __WEBPACK_IMPORTED_MODULE_63__Components_Borrow_UpdateBorrowProduct_vue__["a" /* default */],
      meta: {
        breadcrumb: "แก้ไขข้อมูลเบิก/ยืม ทรัพย์สิน",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "JOB_ADMIN_BORROW", "JOB_ADMIN_BORROW_PLANT", "JOB_ADMIN_BORROW_APPROVE"]
      },
      children: [{
        path: "Picture/:url",
        component: __WEBPACK_IMPORTED_MODULE_62__Components_Borrow_PictureModal_vue__["a" /* default */],
        meta: {
          breadcrumb: "รูปภาพ",
          requiredAuth: true,
          requiredRoles: ["MANAGE_MASTER", "JOB_ADMIN_BORROW", "JOB_ADMIN_BORROW_PLANT"]
        }
      }]
    }, {
      path: "Approve/:id",
      component: __WEBPACK_IMPORTED_MODULE_64__Components_Borrow_DetialBorrowProduct_vue__["a" /* default */],
      meta: {
        breadcrumb: "อนุมัติข้อมูลเบิก/ยืม ทรัพย์สิน",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "JOB_ADMIN_BORROW_APPROVE"]
      }
    }, {
      path: "OpenJop/:id",
      component: __WEBPACK_IMPORTED_MODULE_65__Components_Borrow_JobBorrowProduct_vue__["a" /* default */],
      meta: {
        breadcrumb: "เปิดใบงานเบิก/ยืม ทรัพย์สิน",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "JOB_ADMIN_BORROW_OPENJOB"]
      }
    }, {
      path: "OpenJopReturn/:id",
      component: __WEBPACK_IMPORTED_MODULE_66__Components_Borrow_JobBorrowProductReturn_vue__["a" /* default */],
      meta: {
        breadcrumb: "ใบงานรับคืนสินค้าจากการเบิก/ยืม ทรัพย์สิน",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "JOB_ADMIN_BORROW_OPENJOB"]
      }
    }]
  }, {
    path: "/Report",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    exact: true,
    meta: {
      breadcrumb: "รายงาน (Report)",
      requiredAuth: true,
      requiredRoles: []
    },

    children: [{
      path: "JobAgentScore",
      component: __WEBPACK_IMPORTED_MODULE_92__Components_Report_JobAgentScore_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานคะแนนการทำระบบเบียร์สด",
        requiredAuth: true,
        requiredRoles: ["AGENT_SCORE_ADMIN"],
        requiredProfileTypes: ["COMPANY_PROFILE_TYPE_AGENT"],
        excludeSuperAdmin: true
      }
    }, {
      path: "AgentScoreEvaluation",
      component: __WEBPACK_IMPORTED_MODULE_93__Components_Report_AgentScoreEvaluationReport_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานประเมินตัวแทนจำหน่ายเบียร์สด",
        requiredAuth: true,
        requiredRoles: ["AGENT_SCORE_ADMIN"],
        requiredProfileTypes: ["COMPANY_PROFILE_TYPE_AGENT"],
        excludeSuperAdmin: true
      }
    }, {
      path: "JobAgentAuditStock",
      component: __WEBPACK_IMPORTED_MODULE_34__Components_Report_JobAgentAuditStock_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานตรวจสอบ STOCK ตัวแทนจำหน่าย",
        requiredAuth: true,
        requiredRoles: ["MANAGE_AUDIT_STOCK", "BR_MANAGE_AUDIT_STOCK", "AGENT_REPORT", "super_admin"]
      }
    }, {
      path: "KegRotationScore",
      component: __WEBPACK_IMPORTED_MODULE_35__Components_Report_KegRotationScore_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานคะแนนถังคงค้าง(ผู้ดูแลระบบ)",
        requiredAuth: true,
        requiredRoles: ["AGENT_SCORE_ADMIN"],
        excludeSuperAdmin: true
      }
    }, {
      path: "KegRotationScoreAgent",
      component: __WEBPACK_IMPORTED_MODULE_36__Components_Report_KegRotationScoreAgent_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานคะแนนถังคงค้าง(ตัวแทนจำหน่าย)",
        requiredAuth: true,
        requiredRoles: ["AGENT_SCORE_ADMIN"],
        requiredProfileTypes: ["COMPANY_PROFILE_TYPE_AGENT"],
        excludeSuperAdmin: true
      }
    },
    // {
    //   path: "AgentStockOverdue",
    //   component: AgentStockOverdueReport,
    //   meta: {
    //     breadcrumb: "รายงาน STOCK ระบบเบียร์สด",
    //     requiredAuth: true,
    //     requiredRoles: ["AGENT_REPORT", "super_admin"],
    //   },
    // }, 
    {
      path: "JobRetrieve",
      component: __WEBPACK_IMPORTED_MODULE_94__Components_Report_JobRetrieve_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานการรับคืนจากตัวแทนจำหน่าย",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "BR_REPORT", "SUB_AGENT_REPORT"]
      }
    }, {
      path: "AssetProducts",
      component: __WEBPACK_IMPORTED_MODULE_95__Components_Report_AssetProducts_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานมูลค่าทรัพย์สิน",
        requiredAuth: true,
        requiredRoles: ["BR_REPORT"]
      }
    }, {
      path: "Movement",
      component: __WEBPACK_IMPORTED_MODULE_96__Components_Report_Movement_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานความเคลื่อนไหว",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"]
      }
    }, {
      path: "FixedProducts",
      component: __WEBPACK_IMPORTED_MODULE_97__Components_Report_FixedProducts_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานประวัติการซ่อมรายบาร์โค้ด",
        requiredAuth: true,
        requiredRoles: ["BR_REPORT"]
      }
    }, {
      path: "ProduceProducts",
      component: __WEBPACK_IMPORTED_MODULE_98__Components_Report_ProduceProducts_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานประวัติการผลิตรายบาร์โค้ด",
        requiredAuth: true,
        requiredRoles: ["BR_REPORT"]
      }
    }, {
      path: "BrandCount",
      component: __WEBPACK_IMPORTED_MODULE_99__Components_Report_BrandCount_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานการปิดใบงานระหว่างตัวแทนจำหน่ายและโรงงาน",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"]
      },
      children: [{
        path: "BarCode/:id",
        component: __WEBPACK_IMPORTED_MODULE_109__Components_Report_BrandCountBarcodeModal_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายการบาร์โค้ด",
          requiredAuth: true,
          requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"]
        }
      }]
    }, {
      path: "AgentAssets",
      component: __WEBPACK_IMPORTED_MODULE_100__Components_Report_AgentAssets_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน Stock สินค้า รายตัวแทนจำหน่าย",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"]
      }
    }, {
      path: "ShopAssets",
      component: __WEBPACK_IMPORTED_MODULE_101__Components_Report_ShopAssets_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน Stock สินค้า รายร้านค้า",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT"]
      }
    }, {
      path: "TransferBarcode",
      component: __WEBPACK_IMPORTED_MODULE_102__Components_Report_TransferBarcode_vue__["a" /* default */],
      meta: {
        breadcrumb: "Stock Card ระหว่างตัวแทนจำหน่ายกับร้านค้า",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT"]
      }
    }, {
      path: "TransferBarcodeMultiple",
      component: __WEBPACK_IMPORTED_MODULE_103__Components_Report_TransferBarcodeMultiple_vue__["a" /* default */],
      meta: {
        breadcrumb: "Stock Card ระหว่างตัวแทนจำหน่ายกับร้านค้า(หลายร้านค้า)",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT"]
      }
    }, {
      path: "TransferBarcodeSubAgent",
      component: __WEBPACK_IMPORTED_MODULE_104__Components_Report_TransferBarcodeSubAgent_vue__["a" /* default */],
      meta: {
        breadcrumb: "Stock Card ระหว่างตัวแทนจำหน่ายย่อยกับร้านค้า",
        requiredAuth: true,
        requiredRoles: ["SUB_AGENT_REPORT"]
      }
    }, {
      path: "TransferBarcodeSupplier",
      component: __WEBPACK_IMPORTED_MODULE_111__Components_Report_TransferBarcodeSupplier_vue__["a" /* default */],
      meta: {
        breadcrumb: "ประวัติส่งซ่อม Supplier",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT", "OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN"]
      }
    }, {
      path: "Barcodes",
      component: __WEBPACK_IMPORTED_MODULE_105__Components_Report_Barcodes_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน Stock รายบาร์โค้ด",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"]
      }
    }, {
      path: "AverageBarcode",
      component: __WEBPACK_IMPORTED_MODULE_106__Components_Report_AverageBarcode_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานค่าเฉลี่ยกระบวนการภายในโรงงาน/คลังสินค้า",
        requiredAuth: true,
        requiredRoles: ["BR_REPORT"]
      }
    }, {
      path: "StockBarcodeSnapshot",
      component: __WEBPACK_IMPORTED_MODULE_107__Components_Report_StockBarcodeSnapshot_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน Stock Barcode Snapshot",
        requiredAuth: true,
        requiredRoles: ["BR_REPORT"]
      }
    }, {
      path: "BarcodeStatus",
      component: __WEBPACK_IMPORTED_MODULE_108__Components_Report_BarcodeStatus_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานสถานะ",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"]
      }
    }, {
      path: "ProductStocks",
      component: __WEBPACK_IMPORTED_MODULE_110__Components_Report_ProductStocks_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน Stock เบิกยืมรายโควตา",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"]
      }
    }, {
      path: "Borrow",
      component: __WEBPACK_IMPORTED_MODULE_112__Components_Report_Borrow_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน การเบิกยืมและยอดคงค้าง Excel",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"]
      }
    }, {
      path: "PaymentProduct",
      component: __WEBPACK_IMPORTED_MODULE_137__Components_Report_PaymentProduct_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานการจ่ายสินค้า",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"]
      }
    }, {
      path: "ReturnProduct",
      component: __WEBPACK_IMPORTED_MODULE_138__Components_Report_ReturnProduct_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานการรับคืน",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "BR_REPORT"]
      }
    }]
  }, {
    path: "/AlertReport",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    exact: true,
    meta: {
      breadcrumb: "รายงานการแจ้งเตือน",
      requiredAuth: true,
      requiredRoles: []
    },
    children: [{
      path: "BeforeDue",
      component: __WEBPACK_IMPORTED_MODULE_142__Components_ReportAlert_BeforeDue_vue__["a" /* default */],
      meta: {
        breadcrumb: "คงค้างก่อนครบกำหนดการคืน",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "BR_REPORT", "SUB_AGENT_REPORT"]
      }
    }, {
      path: "OverdueAll",
      component: __WEBPACK_IMPORTED_MODULE_141__Components_ReportAlert_OverdueAll_vue__["a" /* default */],
      meta: {
        breadcrumb: "คงค้างเลยกำหนดการคืน",
        requiredAuth: true,
        requiredRoles: ["AGENT_REPORT", "BR_REPORT", "SUB_AGENT_REPORT"]
      }
    }]
  }, {
    path: "/AdminReport",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "รายงานแอดมิน (Report)",
      requiredAuth: true,
      requiredRoles: []
    },
    children: [{
      path: "MasterShopByBrand",
      component: __WEBPACK_IMPORTED_MODULE_146__Components_AdminReport_MasterShopByBrand_vue__["a" /* default */],
      meta: {
        breadcrumb: "จำนวนร้านค้าแยกตามแบรนด์",
        requiredAuth: true,
        requiredRoles: []
      }
    },
    // {
    //   path: "PM",
    //   component: PMReport,
    //   meta: {
    //     // breadcrumb: "การล้างเครืองเบียร์สด",
    //     breadcrumb: "ข้อมูลการล้างเครื่องเบียร์สด (PM)",
    //     requiredAuth: true,
    //     requiredRoles: [],
    //   },
    // },
    // {
    //   path: "BarButlerByBrand",
    //   component: BarButlerByBrandReport,
    //   meta: {
    //     // breadcrumb: "ข้อมูลหัวจ่ายแยกตามแบรนด์",
    //     breadcrumb: "ข้อมูลหัวจ่าย",
    //     requiredAuth: true,
    //     requiredRoles: [],
    //   },
    // },
    {
      path: "JobIssue",
      component: __WEBPACK_IMPORTED_MODULE_147__Components_AdminReport_JobIssue_vue__["a" /* default */],
      meta: {
        breadcrumb: "การแจ้งปัญหา",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "Survey",
      component: __WEBPACK_IMPORTED_MODULE_149__Components_AdminReport_Survey_vue__["a" /* default */],
      meta: {
        breadcrumb: "Survey PM/MT/QI/MKT(ร้านค้า On/Off premise)",
        requiredAuth: true,
        requiredRoles: []
      }
    }]
  }, {
    path: "/QCReport",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "รายงาน QC",
      requiredAuth: true,
      requiredRoles: []
    },
    children: [{
      path: "QCGroupByAgent",
      component: __WEBPACK_IMPORTED_MODULE_113__Components_Report_QIGroupByAgent_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานคะแนน QC Group by Agent",
        requiredAuth: true,
        requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI", "AGENT_REPORT", "SUB_AGENT_REPORT"]
      }
    }, {
      path: "QCGroupByOfficer",
      component: __WEBPACK_IMPORTED_MODULE_114__Components_Report_QIGroupByOfficer_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานสรุปการเข้าทำ QC Group by เจ้าหน้าที่",
        requiredAuth: true,
        requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI"]
      }
    }]
  }, {
    path: "/PMReport",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "รายงาน PM",
      requiredAuth: true,
      requiredRoles: []
    },
    children: [{
      path: "AlertPM",
      component: __WEBPACK_IMPORTED_MODULE_148__Components_AdminReport_AlertPM_vue__["a" /* default */],
      meta: {
        breadcrumb: "Alert PM (เกินกำหนดการล้างเครื่อง)",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }, {
      path: "MasterShopOnOff",
      component: __WEBPACK_IMPORTED_MODULE_135__Components_Report_MasterShopOnOff_vue__["a" /* default */],
      meta: {
        breadcrumb: "ข้อมูลร้านค้า",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }, {
      path: "BarButlerByBrand",
      component: __WEBPACK_IMPORTED_MODULE_136__Components_Report_BarButlerByBrand_vue__["a" /* default */],
      meta: {
        // breadcrumb: "ข้อมูลหัวจ่ายแยกตามแบรนด์",
        breadcrumb: "ข้อมูลหัวจ่าย",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }, {
      path: "PM",
      component: __WEBPACK_IMPORTED_MODULE_133__Components_Report_PM_vue__["a" /* default */],
      meta: {
        // breadcrumb: "การล้างเครืองเบียร์สด",
        breadcrumb: "ข้อมูลการล้างเครื่องเบียร์สด (PM)",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }, {
      path: "PMOperationReport",
      component: __WEBPACK_IMPORTED_MODULE_140__Components_Report_PMOperationReport_vue__["a" /* default */],
      meta: {
        // breadcrumb: "การล้างเครืองเบียร์สด",
        breadcrumb: "รายงาน ปฏิทินบันทึกงาน PM",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }, {
      path: "BarcodeMapping",
      component: __WEBPACK_IMPORTED_MODULE_139__Components_Report_BarcodeMappingReport_vue__["a" /* default */],
      meta: {
        // breadcrumb: "การล้างเครืองเบียร์สด",
        breadcrumb: "รายงานจำนวนชุดอุปกรณ์",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }, {
      path: "PMSurvey",
      component: __WEBPACK_IMPORTED_MODULE_134__Components_Report_PMSurvey_vue__["a" /* default */],
      meta: {
        // breadcrumb: "การล้างเครืองเบียร์สด",
        breadcrumb: "ข้อมูลการ Survey PM",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }, {
      path: "PMMonthly",
      component: __WEBPACK_IMPORTED_MODULE_128__Components_Report_PMMonthly_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานผลสรุปการบำรุงรักษาเครื่อง (PM) ประจำเดือน",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }, {
      path: "MTMonthly",
      component: __WEBPACK_IMPORTED_MODULE_129__Components_Report_MTMonthly_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานผลสรุปการซ่อมเครื่อง (MT) ประจำเดือน",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }, {
      path: "PMSpare",
      component: __WEBPACK_IMPORTED_MODULE_131__Components_Report_PMSpare_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานผลสรุปการใช้อะไหล่ในการบำรุงรักษาและการซ่อมเครื่อง",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }, {
      path: "PMRoutePlan",
      component: __WEBPACK_IMPORTED_MODULE_130__Components_Report_PMRoutePlan_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานผลสรุปการบำรุงรักษาเครื่องตามแผนงาน",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }, {
      path: "PMAlertSummary",
      component: __WEBPACK_IMPORTED_MODULE_132__Components_Report_PMAlertSummary_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานผลสรุปการแจ้งเตือน",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]
      }
    }]
  }, {
    path: "/MKTReport",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "รายงานการตลาด",
      requiredAuth: true,
      requiredRoles: ["super_admin", "ADMIN_MKT", "MANAGER_MKT", "USER_MKT"]
    },
    children: [{
      path: "EventAndFood",
      component: __WEBPACK_IMPORTED_MODULE_120__Components_Report_EventAndFood_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานEvent/มหกรรมอาหาร",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_MKT", "MANAGER_MKT", "USER_MKT"]
      }
    }, {
      path: "SurveyOnOffPremise",
      component: __WEBPACK_IMPORTED_MODULE_121__Components_Report_SurveyOnOffPremise_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานตรวจเยี่ยมร้าน On/Off-premise",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_MKT", "MANAGER_MKT", "USER_MKT"]
      }
    }, {
      path: "NewShopOnOffPremise",
      component: __WEBPACK_IMPORTED_MODULE_115__Components_Report_NewShopOnOffPremise_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานเปิดร้านค้าใหม่ On/Off-premise",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_MKT", "MANAGER_MKT", "USER_MKT"]
      }
    }]
  }, {
    path: "/5SReport",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "รายงาน S+",
      requiredAuth: true,
      requiredRoles: ["super_admin", "ADMIN_5S", "AGENT_REPORT", "ADVISOR_5S", "TEAM_5S"]
    },
    children: [{
      path: "TransactionView5S",
      component: __WEBPACK_IMPORTED_MODULE_116__Components_Report_TransactionView5S_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานจำนวนครั้งในการเข้าดูข้อมูลใน S+(E-Learning)",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "TEAM_5S"]
      }
    }, {
      path: "EvaluateView5S",
      component: __WEBPACK_IMPORTED_MODULE_117__Components_Report_EvaluateView5S_vue__["a" /* default */],
      meta: {
        breadcrumb: "จำนวนการประเมินคะแนนประจำเดือน S+",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "AGENT_REPORT", "ADVISOR_5S", "TEAM_5S"]
      }
    }, {
      path: "WarehouseScore",
      component: __WEBPACK_IMPORTED_MODULE_118__Components_Report_WarehouseScore_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานคะแนนโครงการบริหารคลังสินค้าประจำเดือน",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "AGENT_REPORT", "ADVISOR_5S", "TEAM_5S"]
      }
    }, {
      path: "NotificationKPI",
      component: __WEBPACK_IMPORTED_MODULE_119__Components_Report_NotificationKPI_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงานผลสรุปการแจ้งเตือนไม่ลงข้อมูล KPIs",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "AGENT_REPORT", "ADVISOR_5S", "TEAM_5S"]
      }
    }]
  }, {
    path: "/BeerClaimReport",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "รายงานเบียร์เคลม",
      requiredAuth: true,
      requiredRoles: []
    },
    children: [{
      path: "AmountBeerClaim",
      component: __WEBPACK_IMPORTED_MODULE_124__Components_Report_AmountBeerClaim_vue__["a" /* default */],
      meta: {
        breadcrumb: "จำนวนการเคลมเบียร์ประจำเดือน",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "CostBeerClaim",
      component: __WEBPACK_IMPORTED_MODULE_125__Components_Report_CostBeerClaim_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายจ่ายในการเคลมเบียร์ (รายปี)",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "StatusBeerClaimMonthly",
      component: __WEBPACK_IMPORTED_MODULE_122__Components_Report_StatusBeerClaimMonthly_vue__["a" /* default */],
      meta: {
        breadcrumb: "สถานะการเคลมคงค้างในกระบวนการประจำเดือน",
        requiredAuth: true,
        requiredRoles: []
      }
    }]
  }, {
    path: "/MaintainReport",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "รายงานช่างซ่อมบำรุง",
      requiredAuth: true,
      requiredRoles: []
    },
    children: [{
      path: "StockPending",
      component: __WEBPACK_IMPORTED_MODULE_162__Components_QIJob_ReportStockPending_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน Stock รอซ่อม/รอบำรุงรักษา/รอทำลาย/ส่งซ่อมซัพพลายเออร์",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "Checker",
      component: __WEBPACK_IMPORTED_MODULE_163__Components_QIJob_ReportChecker_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน ส่งมอบหลังซ่อม",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "SparePartsUsed",
      component: __WEBPACK_IMPORTED_MODULE_164__Components_QIJob_ReportSparePartsUsed_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน ข้อมูลการใช้อะไหล่เครื่อง/อุปกรณ์",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "StockSpareParts",
      component: __WEBPACK_IMPORTED_MODULE_165__Components_QIJob_ReportSparePartsStock_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน Stock อะไหล่ทีมช่างซ่อมบำรุง",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "Drawback",
      component: __WEBPACK_IMPORTED_MODULE_166__Components_QIJob_ReportDrawback_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน รายละเอียด Stock คลังช่าง",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "RepairSum",
      component: __WEBPACK_IMPORTED_MODULE_167__Components_QIJob_ReportRepairSum_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน มูลค่าซ่อม",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "RepairUsage",
      component: __WEBPACK_IMPORTED_MODULE_168__Components_QIJob_ReportRepairUsage_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน จำนวนการซ่อมเครื่อง/อุปกรณ์",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "QISummary",
      component: __WEBPACK_IMPORTED_MODULE_169__Components_QIJob_ReportQISummary_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายงาน Summary",
        requiredAuth: true,
        requiredRoles: []
      }
    }]
  }, {
    path: "/MachineReport",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "รายงานเครื่องเช่า",
      requiredAuth: true,
      requiredRoles: []
    },
    children: [{
      path: "Invoice",
      component: __WEBPACK_IMPORTED_MODULE_123__Components_Report_Invoice_vue__["a" /* default */],
      meta: {
        breadcrumb: "การวางบิล / การจ่ายเงิน",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "LeaseMachine",
      component: __WEBPACK_IMPORTED_MODULE_126__Components_Report_LeaseMachine_vue__["a" /* default */],
      meta: {
        breadcrumb: "สรุปจำนวนเครื่องเช่า",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "MachineDetail",
      component: __WEBPACK_IMPORTED_MODULE_127__Components_Report_MachineDetail_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายละเอียดเครื่องเช่า",
        requiredAuth: true,
        requiredRoles: []
      }
    }]
  }, {
    path: "/Marketing",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "การตลาด (Marketing)",
      requiredAuth: true,
      requiredRoles: []
    },
    children: [{
      path: "MarketingList",
      component: __WEBPACK_IMPORTED_MODULE_173__Components_Marketing_MarketingList_vue__["a" /* default */],
      meta: {
        breadcrumb: "ข้อมูลการตลาด",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_MKT", "MANAGER_MKT", "USER_MKT"]
      },
      children: [{
        path: "Detail/:id",
        component: __WEBPACK_IMPORTED_MODULE_174__Components_Marketing_MarketingDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดข้อมูลการตลาด",
          requiredAuth: true,
          requiredRoles: ["super_admin", "ADMIN_MKT", "MANAGER_MKT", "USER_MKT"]
        }
      }]
    }, {
      path: "ApproveDetail/:id",
      component: __WEBPACK_IMPORTED_MODULE_175__Components_Marketing_MarketingApproveDetail_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายละเอียดขอแก้ไขพื้นที่",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_MKT", "MANAGER_MKT"]
      }
    }]
  }, {
    path: "/Kpi",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "ข้อมูล KPI",
      requiredAuth: true,
      requiredRoles: ["super_admin", "ADMIN_5S", "JOB_AGENT_KPI", "ADVISOR_5S", "TEAM_5S"]
    },
    children: [{
      path: "ProductSlow",
      component: __WEBPACK_IMPORTED_MODULE_176__Components_KPI_Products_ProductSlow_vue__["a" /* default */],
      meta: {
        breadcrumb: "สินค้าเคลื่อนไหวช้า",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "JOB_AGENT_KPI", "ADVISOR_5S", "TEAM_5S"]
      }
    }, {
      path: "ProductExpire",
      component: __WEBPACK_IMPORTED_MODULE_177__Components_KPI_Products_ProductExpire_vue__["a" /* default */],
      meta: {
        breadcrumb: "สินค้าหมดอายุ",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "JOB_AGENT_KPI", "ADVISOR_5S", "TEAM_5S"]
      }
    }, {
      path: "ProductLost",
      component: __WEBPACK_IMPORTED_MODULE_178__Components_KPI_Products_ProductLost_vue__["a" /* default */],
      meta: {
        breadcrumb: "สินค้าสูญหาย",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "JOB_AGENT_KPI", "ADVISOR_5S", "TEAM_5S"]
      }
    }, {
      path: "ProductDilapidated",
      component: __WEBPACK_IMPORTED_MODULE_179__Components_KPI_Products_ProductDilapidated_vue__["a" /* default */],
      meta: {
        breadcrumb: "สินค้าที่ชำรุดเสียหาย",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "JOB_AGENT_KPI", "ADVISOR_5S", "TEAM_5S"]
      }
    }, {
      path: "AccessoriesLost",
      component: __WEBPACK_IMPORTED_MODULE_181__Components_KPI_Products_AccessoriesLost_vue__["a" /* default */],
      meta: {
        breadcrumb: "อุปกรณ์ส่งเสริมสูญหาย",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "JOB_AGENT_KPI", "ADVISOR_5S", "TEAM_5S"]
      }
    }, {
      path: "ProductCycle",
      component: __WEBPACK_IMPORTED_MODULE_182__Components_KPI_Products_ProductCycle_vue__["a" /* default */],
      meta: {
        breadcrumb: "ถังเปล่าหมุนเวียน",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "JOB_AGENT_KPI", "ADVISOR_5S", "TEAM_5S"]
      }
    }, {
      path: "DamageMach",
      component: __WEBPACK_IMPORTED_MODULE_183__Components_KPI_Products_DamageMach_vue__["a" /* default */],
      meta: {
        breadcrumb: "เครื่องเบียร์สดชำรุด",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "JOB_AGENT_KPI", "ADVISOR_5S", "TEAM_5S"]
      }
    }, {
      path: "LostMach",
      component: __WEBPACK_IMPORTED_MODULE_184__Components_KPI_Products_LostMach_vue__["a" /* default */],
      meta: {
        breadcrumb: "เครื่องเบียร์สดสูญหาย",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "JOB_AGENT_KPI", "ADVISOR_5S", "TEAM_5S"]
      }
    }, {
      path: "AccessoriesDilapidated",
      component: __WEBPACK_IMPORTED_MODULE_180__Components_KPI_Products_AccessoriesDilapidated_vue__["a" /* default */],
      meta: {
        breadcrumb: "อุปกรณ์เบียร์สดสูญหาย",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "JOB_AGENT_KPI", "ADVISOR_5S", "TEAM_5S"]
      }
    }, {
      path: "LostTank",
      component: __WEBPACK_IMPORTED_MODULE_185__Components_KPI_Products_LostTank_vue__["a" /* default */],
      meta: {
        breadcrumb: "ถังเปล่า/Co2 สูญหาย",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "JOB_AGENT_KPI", "ADVISOR_5S", "TEAM_5S"]
      }
    }]
  }, {
    path: "/5S",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "การบริหารคลังสินค้า งาน S+",
      requiredAuth: true,
      requiredRoles: ["super_admin", "ADMIN_5S", "AGENT_E-Learning", "ADVISOR_5S", "TEAM_5S"]
    },
    children: [{
      path: "E-Learning",
      component: __WEBPACK_IMPORTED_MODULE_186__Components_5S_ManageELearning_vue__["a" /* default */],
      meta: {
        breadcrumb: "ข้อมูลการเรียนรู้ (E-Learning)",
        requiredAuth: true,
        requiredRoles: ["super_admin", "ADMIN_5S", "AGENT_E-Learning", "ADVISOR_5S", "TEAM_5S"]
      },
      children: [{
        path: "AddFolder",
        component: __WEBPACK_IMPORTED_MODULE_187__Components_5S_FolderELearningModal_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มหมวดหมู่ข้อมูลการเรียนรู้ (E-Learning)",
          requiredAuth: true,
          requiredRoles: ["super_admin", "ADMIN_5S"]
        }
      }, {
        path: "RenameFolder/:id",
        component: __WEBPACK_IMPORTED_MODULE_187__Components_5S_FolderELearningModal_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขชื่อหมวดหมู่ข้อมูลการเรียนรู้ (E-Learning)",
          requiredAuth: true,
          requiredRoles: ["super_admin", "ADMIN_5S"]
        }
      }, {
        path: "AddFolder",
        component: __WEBPACK_IMPORTED_MODULE_190__Components_5S_UpdateELearning_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขหมวดหมู่ข้อมูลการเรียนรู้ (E-Learning)",
          requiredAuth: true,
          requiredRoles: ["super_admin", "ADMIN_5S"]
        }
      }, {
        path: "Detials/:id",
        component: __WEBPACK_IMPORTED_MODULE_189__Components_5S_DetialsELearning_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดข้อมูลการเรียนรู้ (E-Learning)",
          requiredAuth: true,
          requiredRoles: ["super_admin", "ADMIN_5S", "AGENT_E-Learning", "ADVISOR_5S", "TEAM_5S"]
        },
        children: [{
          path: "AddSubFolder",
          component: __WEBPACK_IMPORTED_MODULE_188__Components_5S_CreateSubFolderELearningModal_vue__["a" /* default */],
          meta: {
            breadcrumb: "เพิ่มหมวดหมู่ย่อย",
            requiredAuth: true,
            requiredRoles: ["super_admin", "ADMIN_5S"]
          }
        }]
      }]
    }]
  }, {
    path: "/PM",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "งานล้างเครื่องเบียร์สด (PM)",
      requiredAuth: true,
      requiredRoles: [],
      defaultChild: "PMRoutePlan"
    },
    children: [{
      path: "PMRoutePlan",
      component: __WEBPACK_IMPORTED_MODULE_191__Components_PM_SearchPMRoutePlan_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการ Route Plan/Adhoc",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_192__Components_PM_AddPMRoutePlan_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่ม Route Plan/Adhoc",
          requiredAuth: true,
          requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_193__Components_PM_EditPMRoutePlan_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไข Route Plan/Adhoc",
          requiredAuth: true,
          requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
        }
      }]
    }, {
      path: "PMCheckIn",
      component: __WEBPACK_IMPORTED_MODULE_194__Components_PM_SearchCheckIn_vue__["a" /* default */],
      meta: {
        breadcrumb: "ข้อมูล Check-in/out PM",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
      },
      children: [{
        path: ":id/BarcodeMappingDetail/:id2/:id3",
        component: __WEBPACK_IMPORTED_MODULE_195__Components_PM_BarcodeMappingDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดการจับชุดอุปกรณ์",
          requiredAuth: true,
          requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
        },
        children: [{
          path: "Picture/:url",
          component: __WEBPACK_IMPORTED_MODULE_198__Components_PM_PictureModal_vue__["a" /* default */],
          meta: {
            breadcrumb: "รูปภาพ",
            requiredAuth: true,
            requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
          }
        }]
      }, {
        path: ":id/PMDetail/:id2",
        component: __WEBPACK_IMPORTED_MODULE_196__Components_PM_PMDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดการทำ PM",
          requiredAuth: true,
          requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
        },
        children: [{
          path: "Picture/:url",
          component: __WEBPACK_IMPORTED_MODULE_198__Components_PM_PictureModal_vue__["a" /* default */],
          meta: {
            breadcrumb: "รูปภาพ",
            requiredAuth: true,
            requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
          }
        }]
      }, {
        path: ":id/MTDetail/:id2",
        component: __WEBPACK_IMPORTED_MODULE_197__Components_PM_MTDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดการทำ MT",
          requiredAuth: true,
          requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
        },
        children: [{
          path: "Picture/:url",
          component: __WEBPACK_IMPORTED_MODULE_198__Components_PM_PictureModal_vue__["a" /* default */],
          meta: {
            breadcrumb: "รูปภาพ",
            requiredAuth: true,
            requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
          }
        }]
      }]
    }, {
      path: "PMSurveyCheckIn",
      component: __WEBPACK_IMPORTED_MODULE_199__Components_PM_SearchSurveyCheckIn_vue__["a" /* default */],
      meta: {
        breadcrumb: "ข้อมูล Survey PM",
        requiredAuth: true,
        requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
      },
      children: [{
        path: ":id/PMSurveyBarcodeMappingDetail/:id2/:id3",
        component: __WEBPACK_IMPORTED_MODULE_200__Components_PM_PMSurveyBarcodeMappingDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดการจับชุดอุปกรณ์",
          requiredAuth: true,
          requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
        },
        children: [{
          path: "Picture/:url",
          component: __WEBPACK_IMPORTED_MODULE_198__Components_PM_PictureModal_vue__["a" /* default */],
          meta: {
            breadcrumb: "รูปภาพ",
            requiredAuth: true,
            requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
          }
        }]
      }, {
        path: ":id/PMSurveyDetail/:id2",
        component: __WEBPACK_IMPORTED_MODULE_201__Components_PM_PMSurveyDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดการทำ Survey PM",
          requiredAuth: true,
          requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
        },
        children: [{
          path: "Picture/:url",
          component: __WEBPACK_IMPORTED_MODULE_202__Components_PM_SurveyPictureModal_vue__["a" /* default */],
          meta: {
            breadcrumb: "รูปภาพ",
            requiredAuth: true,
            requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM", "SUB_AGENT_ADMIN_PM"]
          }
        }]
      }]
    }]
  }, {
    path: "/BeerClaim",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "เบียร์เคลม (BeerClaim)",
      requiredAuth: true,
      requiredRoles: [],
      defaultChild: "Claim"
    },
    children: [{
      path: "Claim",
      component: __WEBPACK_IMPORTED_MODULE_203__Components_BeerClaim_SearchBeerClaim_vue__["a" /* default */],
      meta: {
        breadcrumb: "แจ้งเคลมเบียร์",
        requiredAuth: true,
        requiredRoles: ["ADMIN_BEER_CLAIM", "MANAGER_BEER_CLAIM", "QI_OFFICER_BEER_CLAIM", "PLANT_ACCOUNTANT_BEER_CLAIM", "LAB_BEER_CLAIM", "AGENT_ADMIN_BEER_CLAIM", "ADMIN_PLANT_BEER_CLAIM"]
      },
      children: [{
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_204__Components_BeerClaim_AddBeerClaim_vue__["a" /* default */],
        meta: {
          breadcrumb: "ใบคำร้องขอ Claim เบียร์สด",
          requiredAuth: true,
          requiredRoles: ["ADMIN_BEER_CLAIM", "AGENT_ADMIN_BEER_CLAIM"]
        },
        children: [{
          path: "AddItem/:id",
          component: __WEBPACK_IMPORTED_MODULE_205__Components_BeerClaim_AddBeerClaimItem_vue__["a" /* default */],
          meta: {
            breadcrumb: "เพิ่ม Claim Item",
            requiredAuth: true,
            requiredRoles: ["ADMIN_BEER_CLAIM", "AGENT_ADMIN_BEER_CLAIM"]
          }
        }]
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_206__Components_BeerClaim_EditBeerClaim_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขใบคำร้องขอ Claim เบียร์สด",
          requiredAuth: true,
          requiredRoles: ["ADMIN_BEER_CLAIM", "AGENT_ADMIN_BEER_CLAIM"]
        },
        children: [{
          path: "AddItem/:id",
          component: __WEBPACK_IMPORTED_MODULE_205__Components_BeerClaim_AddBeerClaimItem_vue__["a" /* default */],
          meta: {
            breadcrumb: "เพิ่ม Claim Item",
            requiredAuth: true,
            requiredRoles: ["ADMIN_BEER_CLAIM", "AGENT_ADMIN_BEER_CLAIM"]
          }
        }, {
          path: "EditItem/:id",
          component: __WEBPACK_IMPORTED_MODULE_205__Components_BeerClaim_AddBeerClaimItem_vue__["a" /* default */],
          meta: {
            breadcrumb: "แก้ไข Claim Item",
            requiredAuth: true,
            requiredRoles: ["ADMIN_BEER_CLAIM", "AGENT_ADMIN_BEER_CLAIM"]
          }
        }]
      }, {
        path: "Detail/:id",
        component: __WEBPACK_IMPORTED_MODULE_211__Components_BeerClaim_BeerClaimDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดใบคำร้องขอ Claim เบียร์สด",
          requiredAuth: true,
          requiredRoles: ["AGENT_ADMIN_BEER_CLAIM", "QI_OFFICER_BEER_CLAIM", "PLANT_ACCOUNTANT_BEER_CLAIM", "LAB_BEER_CLAIM", "MANAGER_BEER_CLAIM", "ADMIN_BEER_CLAIM"]
        },
        children: [{
          path: "ClaimItem/:id",
          component: __WEBPACK_IMPORTED_MODULE_212__Components_BeerClaim_BeerClaimItemDetail_vue__["a" /* default */],
          meta: {
            breadcrumb: "รายละเอียด Claim Item",
            requiredAuth: true,
            requiredRoles: ["AGENT_ADMIN_BEER_CLAIM", "QI_OFFICER_BEER_CLAIM", "PLANT_ACCOUNTANT_BEER_CLAIM", "LAB_BEER_CLAIM", "MANAGER_BEER_CLAIM", "ADMIN_BEER_CLAIM", "ADMIN_PLANT_BEER_CLAIM"]
          }
        }]
      }, {
        path: "Commit/:id",
        component: __WEBPACK_IMPORTED_MODULE_207__Components_BeerClaim_CommitBeerClaim_vue__["a" /* default */],
        meta: {
          breadcrumb: "สามารถส่งเคลมได้",
          requiredAuth: true,
          requiredRoles: ["ADMIN_BEER_CLAIM", "QI_OFFICER_BEER_CLAIM"]
        }
      }, {
        path: "Approve/:id",
        component: __WEBPACK_IMPORTED_MODULE_209__Components_BeerClaim_ApproveBeerClaim_vue__["a" /* default */],
        meta: {
          breadcrumb: "อนุมัติการเคลม/ไม่อนุมัติการเคลม",
          requiredAuth: true,
          requiredRoles: ["ADMIN_BEER_CLAIM", "MANAGER_BEER_CLAIM"]
        }
      }, {
        path: "Conclude/:id",
        component: __WEBPACK_IMPORTED_MODULE_210__Components_BeerClaim_ConcludeApproveBeerClaim_vue__["a" /* default */],
        meta: {
          breadcrumb: "สรุปผลการอนุมัติและชดเชย/สรุปผลไม่อนุมัติการเคลม",
          requiredAuth: true,
          requiredRoles: ["ADMIN_BEER_CLAIM", "MANAGER_BEER_CLAIM"]
        }
      }, {
        path: "Result/:id",
        component: __WEBPACK_IMPORTED_MODULE_208__Components_BeerClaim_ResultBeerClaim_vue__["a" /* default */],
        meta: {
          breadcrumb: "ผลอนุมัติการเคลม",
          requiredAuth: true,
          requiredRoles: ["ADMIN_BEER_CLAIM", "MANAGER_BEER_CLAIM", "AGENT_ADMIN_BEER_CLAIM"]
        }
      }]
    }]
  }, {
    path: "/Machine",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "เครื่องเช่า",
      requiredAuth: true,
      requiredRoles: [],
      defaultChild: "machine"
    },
    children: [{
      path: "ManagePhase",
      component: __WEBPACK_IMPORTED_MODULE_213__Components_Master_Phase_ManagePhase_vue__["a" /* default */],
      meta: {
        breadcrumb: "ข้อมูล Phase",
        requiredAuth: true,
        requiredRoles: ["ADMIN_EQUIPMENT_LEASING", "USER_EQUIPMENT_LEASING"]
      },
      children: [{
        path: "Import",
        component: __WEBPACK_IMPORTED_MODULE_214__Components_Master_Phase_ImportPhase_vue__["a" /* default */],
        meta: {
          breadcrumb: "Import Phase",
          requiredAuth: true,
          requiredRoles: ["ADMIN_EQUIPMENT_LEASING", "USER_EQUIPMENT_LEASING"]
        }
      }, {
        path: "DownloadPhase",
        component: __WEBPACK_IMPORTED_MODULE_215__Components_Master_Phase_DownloadPhase_vue__["a" /* default */],
        meta: {
          breadcrumb: "Download Phase",
          requiredAuth: true,
          requiredRoles: ["ADMIN_EQUIPMENT_LEASING", "USER_EQUIPMENT_LEASING"]
        }
      }]
    },
    // {
    //   path: "ImportPhase",
    //   component: ImportPhase,
    //   meta: {
    //     breadcrumb: "Import Phase",
    //     requiredAuth: true,
    //     requiredRoles: [
    //       "ADMIN_EQUIPMENT_LEASING",
    //       "USER_EQUIPMENT_LEASING",
    //     ],
    //   },
    // },
    {
      path: "ManageMachineTransaction",
      component: __WEBPACK_IMPORTED_MODULE_216__Components_Master_MachineTransaction_ManageMachineTransaction_vue__["a" /* default */],
      meta: {
        breadcrumb: "ข้อมูล เครื่องเช่า",
        requiredAuth: true,
        requiredRoles: ["ADMIN_EQUIPMENT_LEASING", "USER_EQUIPMENT_LEASING"]
      },
      children: [{
        path: "ImportMachine",
        component: __WEBPACK_IMPORTED_MODULE_217__Components_Master_MachineTransaction_ImportMachineTransaction_vue__["a" /* default */],
        meta: {
          breadcrumb: "Import เครื่องเช่า",
          requiredAuth: true,
          requiredRoles: ["ADMIN_EQUIPMENT_LEASING", "USER_EQUIPMENT_LEASING"]
        }
      }, {
        path: "Download",
        component: __WEBPACK_IMPORTED_MODULE_218__Components_Master_MachineTransaction_DownloadMachineTransaction_vue__["a" /* default */],
        meta: {
          breadcrumb: "Download Machine Transaction",
          requiredAuth: true,
          requiredRoles: ["ADMIN_EQUIPMENT_LEASING", "USER_EQUIPMENT_LEASING"]
        }
      }]
    },
    // {
    //   path: "ImportMachine",
    //   component: ImportMachineTransaction,
    //   meta: {
    //     breadcrumb: "Import เครื่องเช่า",
    //     requiredAuth: true,
    //     requiredRoles: [
    //       "ADMIN_EQUIPMENT_LEASING",
    //       "USER_EQUIPMENT_LEASING",
    //     ],
    //   },
    // },
    {
      path: "SaveBillingMachinePayment",
      component: __WEBPACK_IMPORTED_MODULE_219__Components_Machine_SaveBillingMachinePayment_vue__["a" /* default */],
      meta: {
        breadcrumb: "บันทึกข้อมูลการวางบิล",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_MACHINE_TRANSACTION", "ADMIN_EQUIPMENT_LEASING", "USER_EQUIPMENT_LEASING"]
      }
    }, {
      path: "PaymentMachinePayment",
      component: __WEBPACK_IMPORTED_MODULE_220__Components_Machine_PaymentMachinePayment_vue__["a" /* default */],
      meta: {
        breadcrumb: "บันทึกชำระเงินเครื่องเช่า",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_MACHINE_TRANSACTION", "ADMIN_EQUIPMENT_LEASING", "USER_EQUIPMENT_LEASING"]
      }
    }, {
      path: "ListMachine",
      component: __WEBPACK_IMPORTED_MODULE_221__Components_Machine_ListMachine_vue__["a" /* default */],
      meta: {
        breadcrumb: "ข้อมูลเครื่องเช่า",
        requiredAuth: true,
        requiredRoles: ["MANAGE_MASTER", "MANAGE_MACHINE_TRANSACTION", "ADMIN_EQUIPMENT_LEASING", "USER_EQUIPMENT_LEASING"]
      }
    }]
  }, {
    path: "/QC",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "QC",
      requiredAuth: true,
      requiredRoles: [],
      defaultChild: "QC"
    },
    children: [{
      path: "QCCheckIn",
      component: __WEBPACK_IMPORTED_MODULE_151__Components_QICheckIn_CheckInList_vue__["a" /* default */],
      meta: {
        breadcrumb: "เช็คอินร้านค้า",
        requiredAuth: true,
        requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI"]
      },
      children: [{
        path: "Detail/:id",
        component: __WEBPACK_IMPORTED_MODULE_152__Components_QICheckIn_CheckInDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดการเช็คอินร้านค้า",
          requiredAuth: true,
          requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI"]
        },
        children: [{
          path: "Picture/:url",
          component: __WEBPACK_IMPORTED_MODULE_153__Components_QICheckIn_PictureModal_vue__["a" /* default */],
          meta: {
            breadcrumb: "รูปภาพ",
            requiredAuth: true,
            requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI"]
          }
        }]
      }]
    }]
  }, {
    path: "/Maintain",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "งานช่างซ่อมบำรุง",
      requiredAuth: true,
      requiredRoles: [],
      defaultChild: "Maintain"
    },
    children: [{
      path: "QIJob",
      component: __WEBPACK_IMPORTED_MODULE_154__Components_QIJob_QIJobList_vue__["a" /* default */],
      meta: {
        breadcrumb: "ใบงานช่างซ่อม",
        requiredAuth: true,
        requiredRoles: ["OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN"]
      },
      children: [{
        path: "Detail/:id",
        component: __WEBPACK_IMPORTED_MODULE_155__Components_QIJob_QIJobDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดใบงานช่างซ่อม",
          requiredAuth: true,
          requiredRoles: ["OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN"]
        }
      }, {
        path: "EditDrawback/:id",
        component: __WEBPACK_IMPORTED_MODULE_156__Components_QIJob_QIJobEditDrawback_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูล เบิก/คืน อุปกรณ์เบียร์สด",
          requiredAuth: true,
          requiredRoles: ["OFFICER_QIMAINTAIN"]
        }
      }, {
        path: "EditRepair/:id",
        component: __WEBPACK_IMPORTED_MODULE_157__Components_QIJob_QIJobEditRepair_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขข้อมูลการซ่อมอุปกรณ์เบียร์สด",
          requiredAuth: true,
          requiredRoles: ["OFFICER_QIMAINTAIN"]
        }
      }]
    }, {
      path: "Recv",
      component: __WEBPACK_IMPORTED_MODULE_158__Components_QIJob_QIRecvList_vue__["a" /* default */],
      meta: {
        breadcrumb: "รับเข้าอะไหล่",
        requiredAuth: true,
        requiredRoles: ["OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN"]
      },
      children: [{
        path: "Detail/:id",
        component: __WEBPACK_IMPORTED_MODULE_159__Components_QIJob_QIRecvDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดข้อมูลรับเข้าอะไหล่",
          requiredAuth: true,
          requiredRoles: ["OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN"]
        }
      }, {
        path: "Add",
        component: __WEBPACK_IMPORTED_MODULE_160__Components_QIJob_QIRecvBorrow_vue__["a" /* default */],
        meta: {
          breadcrumb: "เพิ่มข้อมูลรับเข้าอะไหล่",
          requiredAuth: true,
          requiredRoles: ["OFFICER_QIMAINTAIN"]
        }
      }]
    }, {
      path: "Stock",
      component: __WEBPACK_IMPORTED_MODULE_161__Components_QIJob_QIStockList_vue__["a" /* default */],
      meta: {
        breadcrumb: "อะไหล่คงเหลือรายช่างซ่อม",
        requiredAuth: true,
        requiredRoles: ["OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN", "QI_QIMAINTAIN"]
      }
    }]
  }, {
    path: "/AgentScore",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "บันทึกคะแนน",
      requiredAuth: true,
      requiredRoles: [],
      defaultChild: "JobAgentScore"
    },
    children: [{
      path: "JobAgentScore",
      component: __WEBPACK_IMPORTED_MODULE_33__Components_AgentScore_AgentScoreList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการคะแนนตัวแทนจำหน่าย ",
        requiredAuth: true,
        requiredRoles: ["AGENT_SCORE_ADMIN"],
        excludeSuperAdmin: true
      }
      // children: [
      //   {
      //     path: "Detail/:id",
      //     component: BudgetPlanDetail,
      //     meta: {
      //       breadcrumb: "รายละเอียดงบประมาณ",
      //       requiredAuth: true,
      //       requiredRoles: ["super_admin"],
      //       excludeSuperAdmin: true,
      //     },
      //   },
      // ],
    }]
  }, {
    path: "/Monitoring",
    component: __WEBPACK_IMPORTED_MODULE_253__Components_Monitoring_MonitoringHub_vue__["a" /* default */],
    meta: {
      breadcrumb: "Monitoring",
      requiredAuth: true,
      requiredRoles: [],
      requiredMonitorEmail: true
    },
    children: [{
      path: "ScheduledJobs",
      component: __WEBPACK_IMPORTED_MODULE_250__Components_Monitoring_MonitoringScheduledJobs_vue__["a" /* default */],
      meta: {
        breadcrumb: "Scheduled Jobs",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "SendEmailReportAgent",
      component: __WEBPACK_IMPORTED_MODULE_251__Components_Monitoring_MonitoringSendEmailReportAgent_vue__["a" /* default */],
      meta: {
        breadcrumb: "SendEmailReportAgent — Manage",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      path: "SCVD",
      component: __WEBPACK_IMPORTED_MODULE_254__Components_Monitoring_MonitoringScvd_vue__["a" /* default */],
      meta: {
        breadcrumb: "Stock Cover Days — Manual Ops",
        requiredAuth: true,
        requiredRoles: []
      }
    }, {
      // CR-PM-Clear-Image — จำลอง cronjob ลบรูปล้างเครื่อง PM บน GCS
      path: "ClearImage",
      component: __WEBPACK_IMPORTED_MODULE_252__Components_Monitoring_MonitoringClearImage_vue__["a" /* default */],
      meta: {
        breadcrumb: "Clear PM Image — Manual Trigger",
        requiredAuth: true,
        requiredRoles: []
      }
    }]
  }, {
    path: "/BudgetPlan",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "งบประมาณ",
      requiredAuth: true,
      defaultChild: "List",
      excludeSuperAdmin: true
    },
    children: [{
      path: "List",
      component: __WEBPACK_IMPORTED_MODULE_231__Components_BudgetPlan_BudgetPlanList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูล CCTR/IO/GL",
        requiredAuth: true,
        requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
        excludeSuperAdmin: true
      },
      children: [{
        path: "Detail/:id",
        component: __WEBPACK_IMPORTED_MODULE_233__Components_BudgetPlan_BudgetPlanDetail_vue__["a" /* default */],
        meta: {
          breadcrumb: "รายละเอียดงบประมาณ",
          requiredAuth: true,
          requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
          excludeSuperAdmin: true
        }
      }]
    }, {
      path: "Detail/:id",
      component: __WEBPACK_IMPORTED_MODULE_233__Components_BudgetPlan_BudgetPlanDetail_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายละเอียดงบประมาณ",
        requiredAuth: true,
        requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
        excludeSuperAdmin: true
      }
    }, {
      path: "Create",
      component: __WEBPACK_IMPORTED_MODULE_234__Components_BudgetPlan_BudgetPlanCreate_vue__["a" /* default */],
      meta: {
        breadcrumb: "เพิ่มแผนงบประมาณ",
        requiredAuth: true,
        requiredRoles: ["BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
        excludeSuperAdmin: true
      }
    }, {
      path: "Edit/:year/:cctrCode",
      component: __WEBPACK_IMPORTED_MODULE_234__Components_BudgetPlan_BudgetPlanCreate_vue__["a" /* default */],
      meta: {
        breadcrumb: "แก้ไขแผนงบประมาณ",
        requiredAuth: true,
        requiredRoles: ["BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
        excludeSuperAdmin: true
      }
    }, {
      path: "View/:year/:cctrCode",
      component: __WEBPACK_IMPORTED_MODULE_234__Components_BudgetPlan_BudgetPlanCreate_vue__["a" /* default */],
      meta: {
        breadcrumb: "ดูรายละเอียดแผนงบประมาณ",
        requiredAuth: true,
        requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
        excludeSuperAdmin: true,
        isViewMode: true
      }
    }, {
      // CR-BudgetReport ข้อ 4: Budget Approval > รายละเอียดใช้งบประมาณตาม Vendor (Q-D1)
      // ISS-31 (7 ต.ค. 2026): breadcrumb คือหัวเรื่องที่โชว์บนหน้าจอด้วย
      //   จึงต้องตัดคำ "รายงาน" นำหน้าออกให้ตรงกับชื่อรายงานในสเปกและ label เมนู
      path: "Report/Vendor",
      component: __WEBPACK_IMPORTED_MODULE_241__Components_BudgetPlan_VendorUsageReport_vue__["a" /* default */],
      meta: {
        breadcrumb: "รายละเอียดใช้งบประมาณตาม Vendor",
        requiredAuth: true,
        requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
        excludeSuperAdmin: true
      }
    }, {
      path: "Job",
      component: __WEBPACK_IMPORTED_MODULE_235__Components_BudgetPlan_BudgetPlanJobList_vue__["a" /* default */],
      meta: {
        breadcrumb: "ใบงาน Budget",
        requiredAuth: true,
        requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
        excludeSuperAdmin: true
      },
      children: [{
        path: "GroupApprove",
        component: __WEBPACK_IMPORTED_MODULE_239__Components_BudgetPlan_BudgetPlanGroupApprove_vue__["a" /* default */],
        meta: {
          breadcrumb: "ตรวจสอบใบงานที่ต้องอนุมัติ",
          requiredAuth: true,
          requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
          excludeSuperAdmin: true
        }
      }, {
        path: "Create",
        component: __WEBPACK_IMPORTED_MODULE_236__Components_BudgetPlan_BudgetPlanJobCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "สร้างใบงานงบประมาณ",
          requiredAuth: true,
          requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
          excludeSuperAdmin: true
        }
      }, {
        path: "View/:id",
        component: __WEBPACK_IMPORTED_MODULE_236__Components_BudgetPlan_BudgetPlanJobCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "ดูรายละเอียดใบงาน",
          requiredAuth: true,
          requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
          excludeSuperAdmin: true
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_236__Components_BudgetPlan_BudgetPlanJobCreate_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขใบงานงบประมาณ",
          requiredAuth: true,
          requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
          excludeSuperAdmin: true
        }
      }]
    }, {
      path: "Monitoring",
      component: __WEBPACK_IMPORTED_MODULE_240__Components_BudgetPlan_BudgetPlanMonitoring_vue__["a" /* default */],
      meta: {
        breadcrumb: "Monitoring",
        requiredAuth: true,
        requiredRoles: []
      },
      children: [{
        path: "SendApprovalGroup",
        component: __WEBPACK_IMPORTED_MODULE_242__Components_BudgetPlan_BudgetPlanMonitoringSendApprovalGroup_vue__["a" /* default */],
        meta: {
          breadcrumb: "Email Monitoring",
          requiredAuth: true,
          requiredRoles: []
        }
      }, {
        path: "BiSnapData",
        component: __WEBPACK_IMPORTED_MODULE_243__Components_BudgetPlan_BudgetPlanMonitoringBiSnapData_vue__["a" /* default */],
        meta: {
          breadcrumb: "BI SnapData",
          requiredAuth: true,
          requiredRoles: []
        }
      }]
    }, {
      path: "ApproveGroup",
      component: __WEBPACK_IMPORTED_MODULE_237__Components_BudgetPlan_ApproveGroupList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูลผู้อนุมัติ",
        requiredAuth: true,
        requiredRoles: ["BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
        excludeSuperAdmin: true
      },
      children: [{
        path: "Create",
        component: __WEBPACK_IMPORTED_MODULE_238__Components_BudgetPlan_ApproveGroupForm_vue__["a" /* default */],
        meta: {
          breadcrumb: "สร้างกลุ่มอนุมัติใหม่",
          requiredAuth: true,
          requiredRoles: ["BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
          excludeSuperAdmin: true
        }
      }, {
        path: "Edit/:id",
        component: __WEBPACK_IMPORTED_MODULE_238__Components_BudgetPlan_ApproveGroupForm_vue__["a" /* default */],
        meta: {
          breadcrumb: "แก้ไขกลุ่มอนุมัติ",
          requiredAuth: true,
          requiredRoles: ["BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
          excludeSuperAdmin: true
        }
      }]
    }]
  },
  // CR-StockCoverDays — จัดการข้อมูล Stock Cover Days (Master)
  {
    path: "/StockCoverDays",
    component: __WEBPACK_IMPORTED_MODULE_5__Components_EmptyRouteView_vue__["a" /* default */],
    meta: {
      breadcrumb: "Stock Cover Days",
      requiredAuth: true,
      defaultChild: "List"
    },
    children: [{
      path: "List",
      component: __WEBPACK_IMPORTED_MODULE_244__Components_StockCoverDays_StockCoverDaysList_vue__["a" /* default */],
      meta: {
        breadcrumb: "จัดการข้อมูล Stock Cover Days",
        requiredAuth: true,
        requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"]
      }
    }, {
      path: "Create",
      component: __WEBPACK_IMPORTED_MODULE_245__Components_StockCoverDays_StockCoverDaysCreate_vue__["a" /* default */],
      meta: {
        breadcrumb: "เพิ่มข้อมูล Stock Cover Days",
        requiredAuth: true,
        requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"]
      }
    }, {
      path: "Edit/:plantCode/:year",
      component: __WEBPACK_IMPORTED_MODULE_246__Components_StockCoverDays_StockCoverDaysDetail_vue__["a" /* default */],
      meta: {
        breadcrumb: "แก้ไขข้อมูล Stock Cover Days",
        requiredAuth: true,
        requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"]
      }
    }, {
      path: "View/:plantCode/:year",
      component: __WEBPACK_IMPORTED_MODULE_246__Components_StockCoverDays_StockCoverDaysDetail_vue__["a" /* default */],
      meta: {
        breadcrumb: "ดูข้อมูล Stock Cover Days",
        requiredAuth: true,
        requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"],
        isViewMode: true
      }
    }, {
      // CR-StockCoverDays Feature 2 — Report Analysis (super_admin sees it, like the Master; no excludeSuperAdmin)
      path: "ReportAnalysis",
      component: __WEBPACK_IMPORTED_MODULE_247__Components_StockCoverDays_StockCoverDaysReportAnalysis_vue__["a" /* default */],
      meta: {
        breadcrumb: "Report Analysis",
        requiredAuth: true,
        requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"]
      }
    }, {
      // CR-StockCoverDays Feature 3 — Dashboard (แดชบอร์ดผู้บริหาร 6 widgets)
      // gating เดียวกับ Master/Report Analysis (super_admin เห็นด้วย; no excludeSuperAdmin)
      path: "Dashboard",
      component: __WEBPACK_IMPORTED_MODULE_248__Components_StockCoverDays_StockCoverDaysDashboard_vue__["a" /* default */],
      meta: {
        breadcrumb: "Dashboard",
        requiredAuth: true,
        requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"]
      }
    }, {
      // CR-StockCoverDays Feature 4 — Stock Cover Days Report (Action Plan) · Q-R1 = เมนูแยกที่ 4
      // gating เดียวกับ Master/Report Analysis (super_admin เห็นด้วย; no excludeSuperAdmin)
      path: "Report",
      component: __WEBPACK_IMPORTED_MODULE_249__Components_StockCoverDays_StockCoverDaysReport_vue__["a" /* default */],
      meta: {
        breadcrumb: "Stock Cover Days Report",
        requiredAuth: true,
        requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"]
      }
    }]
  },
  // CR-FormSummaryStock — พิมพ์เอกสารสรุปข้อมูล > เอกสารสรุปสินค้าคงค้าง
  // NOTE: route "New" ต้องมาก่อน ":documentNo" ไม่งั้น "New" จะถูกจับเป็น param
  {
    path: "/PrintSummary/Barcodes",
    component: __WEBPACK_IMPORTED_MODULE_255__Components_PrintSummary_FormSummaryStockList_vue__["a" /* default */],
    meta: {
      breadcrumb: "เอกสารสรุปสินค้าคงค้าง",
      requiredAuth: true,
      requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"]
    },
    children: [
    // 1) "New" ต้องมาก่อน ":documentNo" ไม่งั้นคำว่า New จะถูกจับเป็น param
    {
      path: "New",
      component: __WEBPACK_IMPORTED_MODULE_256__Components_PrintSummary_FormSummaryStockCreate_vue__["a" /* default */],
      meta: {
        breadcrumb: "เพิ่มสรุปสินค้าคงค้าง",
        requiredAuth: true,
        requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"]
      },
      children: [
      // 2) Preview ต้องเป็นลูกของ New — หน้า Preview อ่าน state ผ่าน $parent
      //    ถ้าย้ายไปเป็น sibling ของ New แล้ว $parent จะกลายเป็นหน้ารายการ หน้าจะว่าง
      {
        path: "Preview",
        component: __WEBPACK_IMPORTED_MODULE_257__Components_PrintSummary_FormSummaryStockPreview_vue__["a" /* default */],
        meta: {
          breadcrumb: "ตรวจสอบข้อมูล",
          requiredAuth: true,
          requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"]
        }
      },
      // ขั้นที่ 3B — ตรวจสอบก่อนสร้างเอกสารรวม (เลือกตัวแทนหลายราย)
      // ต้องเป็นลูกของ New เหมือน Preview เพราะอ่าน state ผ่าน $parent
      {
        path: "GroupPreview",
        component: __WEBPACK_IMPORTED_MODULE_258__Components_PrintSummary_FormSummaryStockGroupPreview_vue__["a" /* default */],
        meta: {
          breadcrumb: "ตรวจสอบข้อมูล (สร้างเอกสารรวม)",
          requiredAuth: true,
          requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"]
        }
      }]
    },
    // ขั้นที่ 6 — สรุปผลการสร้างเอกสารรวม (F13)
    //   ต้องมาก่อน ":documentNo" ไม่งั้นคำว่า GroupResult จะถูกจับเป็นเลขที่เอกสาร
    //
    //   รับ batchId ทาง route params ของ named route (ไม่ใช่ query string)
    //   params ที่ส่งแบบ programmatic อยู่แค่ในหน่วยความจำ — refresh หรือเปิด URL ตรงแล้วหาย
    //   ตรงกับ spec ฉบับเซ็น 16/09/2026: "หน้าชั่วคราว แสดงเพียงครั้งเดียว
    //   หากปิดหน้าจอไปแล้ว จะไม่สามารถเปิดหน้าสรุปเดียวกันขึ้นมาดูซ้ำได้"
    //
    //   ⚠ ใช้ $parent ไม่ได้ เพราะ route นี้เป็น sibling ของ "New" ไม่ใช่ลูก
    //     ($parent จึงเป็นหน้ารายการ ไม่ใช่หน้าเลือก Filter)
    {
      path: "GroupResult",
      name: "FormSummaryStockGroupResult",
      component: __WEBPACK_IMPORTED_MODULE_260__Components_PrintSummary_FormSummaryStockGroupResult_vue__["a" /* default */],
      meta: {
        breadcrumb: "สรุปผลการสร้างเอกสารรวม",
        requiredAuth: true,
        requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"]
      }
    },
    // 3) route param ต้องอยู่ท้ายสุดเสมอ
    {
      path: ":documentNo",
      component: __WEBPACK_IMPORTED_MODULE_259__Components_PrintSummary_FormSummaryStockDetail_vue__["a" /* default */],
      meta: {
        breadcrumb: "เอกสารสรุปสินค้าคงค้าง",
        requiredAuth: true,
        requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"]
      }
    }]
  }]
}, {
  path: "/Callback",
  name: "Callback",
  component: __WEBPACK_IMPORTED_MODULE_3__Components_Callback__["a" /* default */]
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: routes,
  linkActiveClass: "kt-menu__item--active",
  linkExactActiveClass: "kt-menu__item--open"
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! DataTables Bootstrap 4 integration
 * ©2011-2017 SpryMedia Ltd - datatables.net/license
 */

/**
 * DataTables integration for Bootstrap 4. This requires Bootstrap 4 and
 * DataTables 1.10 or newer.
 *
 * This file sets the defaults and adds options to DataTables to style its
 * controls using Bootstrap. See http://datatables.net/manual/styling/bootstrap
 * for further information.
 */
(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				// Require DataTables, which attaches to jQuery, including
				// jQuery if needed and have a $ property so we can access the
				// jQuery object that is used
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


/* Set the defaults for DataTables initialisation */
$.extend( true, DataTable.defaults, {
	dom:
		"<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
		"<'row'<'col-sm-12'tr>>" +
		"<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
	renderer: 'bootstrap'
} );


/* Default class modification */
$.extend( DataTable.ext.classes, {
	sWrapper:      "dataTables_wrapper dt-bootstrap4",
	sFilterInput:  "form-control form-control-sm",
	sLengthSelect: "custom-select custom-select-sm form-control form-control-sm",
	sProcessing:   "dataTables_processing card",
	sPageButton:   "paginate_button page-item"
} );


/* Bootstrap paging button renderer */
DataTable.ext.renderer.pageButton.bootstrap = function ( settings, host, idx, buttons, page, pages ) {
	var api     = new DataTable.Api( settings );
	var classes = settings.oClasses;
	var lang    = settings.oLanguage.oPaginate;
	var aria = settings.oLanguage.oAria.paginate || {};
	var btnDisplay, btnClass, counter=0;

	var attach = function( container, buttons ) {
		var i, ien, node, button;
		var clickHandler = function ( e ) {
			e.preventDefault();
			if ( !$(e.currentTarget).hasClass('disabled') && api.page() != e.data.action ) {
				api.page( e.data.action ).draw( 'page' );
			}
		};

		for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
			button = buttons[i];

			if ( $.isArray( button ) ) {
				attach( container, button );
			}
			else {
				btnDisplay = '';
				btnClass = '';

				switch ( button ) {
					case 'ellipsis':
						btnDisplay = '&#x2026;';
						btnClass = 'disabled';
						break;

					case 'first':
						btnDisplay = lang.sFirst;
						btnClass = button + (page > 0 ?
							'' : ' disabled');
						break;

					case 'previous':
						btnDisplay = lang.sPrevious;
						btnClass = button + (page > 0 ?
							'' : ' disabled');
						break;

					case 'next':
						btnDisplay = lang.sNext;
						btnClass = button + (page < pages-1 ?
							'' : ' disabled');
						break;

					case 'last':
						btnDisplay = lang.sLast;
						btnClass = button + (page < pages-1 ?
							'' : ' disabled');
						break;

					default:
						btnDisplay = button + 1;
						btnClass = page === button ?
							'active' : '';
						break;
				}

				if ( btnDisplay ) {
					node = $('<li>', {
							'class': classes.sPageButton+' '+btnClass,
							'id': idx === 0 && typeof button === 'string' ?
								settings.sTableId +'_'+ button :
								null
						} )
						.append( $('<a>', {
								'href': '#',
								'aria-controls': settings.sTableId,
								'aria-label': aria[ button ],
								'data-dt-idx': counter,
								'tabindex': settings.iTabIndex,
								'class': 'page-link'
							} )
							.html( btnDisplay )
						)
						.appendTo( container );

					settings.oApi._fnBindAction(
						node, {action: button}, clickHandler
					);

					counter++;
				}
			}
		}
	};

	// IE9 throws an 'unknown error' if document.activeElement is used
	// inside an iframe or frame. 
	var activeEl;

	try {
		// Because this approach is destroying and recreating the paging
		// elements, focus is lost on the select button which is bad for
		// accessibility. So we want to restore focus once the draw has
		// completed
		activeEl = $(host).find(document.activeElement).data('dt-idx');
	}
	catch (e) {}

	attach(
		$(host).empty().html('<ul class="pagination"/>').children('ul'),
		buttons
	);

	if ( activeEl !== undefined ) {
		$(host).find( '[data-dt-idx='+activeEl+']' ).focus();
	}
};


return DataTable;
}));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(867);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0f77addb", content, true, {});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Bootstrap 4 integration for DataTables' Responsive
 * ©2016 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(11), __webpack_require__(1126)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net-bs4')(root, $).$;
			}

			if ( ! $.fn.dataTable.Responsive ) {
				require('datatables.net-responsive')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


var _display = DataTable.Responsive.display;
var _original = _display.modal;
var _modal = $(
	'<div class="modal fade dtr-bs-modal" role="dialog">'+
		'<div class="modal-dialog" role="document">'+
			'<div class="modal-content">'+
				'<div class="modal-header">'+
					'<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>'+
				'</div>'+
				'<div class="modal-body"/>'+
			'</div>'+
		'</div>'+
	'</div>'
);

_display.modal = function ( options ) {
	return function ( row, update, render ) {
		if ( ! $.fn.modal ) {
			_original( row, update, render );
		}
		else {
			if ( ! update ) {
				if ( options && options.header ) {
					var header = _modal.find('div.modal-header');
					var button = header.find('button').detach();
					
					header
						.empty()
						.append( '<h4 class="modal-title">'+options.header( row )+'</h4>' )
						.append( button );
				}

				_modal.find( 'div.modal-body' )
					.empty()
					.append( render() );

				_modal
					.appendTo( 'body' )
					.modal();
			}
		}
	};
};


return DataTable.Responsive;
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Bootstrap 4 styling wrapper for RowGroup
 * ©2018 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(11), __webpack_require__(1127)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net-bs4')(root, $).$;
			}

			if ( ! $.fn.dataTable.RowGroup ) {
				require('datatables.net-rowgroup')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {

return $.fn.dataTable;

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Bootstrap integration for DataTables' AutoFill
 * ©2015 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(11), __webpack_require__(1120)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net-bs4')(root, $).$;
			}

			if ( ! $.fn.dataTable.AutoFill ) {
				require('datatables.net-autofill')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


DataTable.AutoFill.classes.btn = 'btn btn-primary';


return DataTable;
}));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Bootstrap integration for DataTables' Buttons
 * ©2016 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(11), __webpack_require__(1121)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net-bs4')(root, $).$;
			}

			if ( ! $.fn.dataTable.Buttons ) {
				require('datatables.net-buttons')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;

$.extend( true, DataTable.Buttons.defaults, {
	dom: {
		container: {
			className: 'dt-buttons btn-group'
		},
		button: {
			className: 'btn btn-secondary'
		},
		collection: {
			tag: 'div',
			className: 'dt-button-collection dropdown-menu',
			button: {
				tag: 'a',
				className: 'dt-button dropdown-item',
				active: 'active',
				disabled: 'disabled'
			}
		}
	},
	buttonCreated: function ( config, button ) {
		return config.buttons ?
			$('<div class="btn-group"/>').append(button) :
			button;
	}
} );

DataTable.ext.buttons.collection.className += ' dropdown-toggle';
DataTable.ext.buttons.collection.rightAlignClassName = 'dropdown-menu-right';

return DataTable.Buttons;
}));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Bootstrap 4 styling wrapper for ColReorder
 * ©2018 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(11), __webpack_require__(1122)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net-bs4')(root, $).$;
			}

			if ( ! $.fn.dataTable.ColReorder ) {
				require('datatables.net-colreorder')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {

return $.fn.dataTable;

}));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Bootstrap 4 styling wrapper for FixedColumns
 * ©2018 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(11), __webpack_require__(1123)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net-bs4')(root, $).$;
			}

			if ( ! $.fn.dataTable.FixedColumns ) {
				require('datatables.net-fixedcolumns')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {

return $.fn.dataTable;

}));

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Bootstrap 4 styling wrapper for FixedHeader
 * ©2018 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(11), __webpack_require__(1124)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net-bs4')(root, $).$;
			}

			if ( ! $.fn.dataTable.FixedHeader ) {
				require('datatables.net-fixedheader')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {

return $.fn.dataTable;

}));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Bootstrap 4 styling wrapper for KeyTable
 * ©2018 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(11), __webpack_require__(1125)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net-bs4')(root, $).$;
			}

			if ( ! $.fn.dataTable.KeyTable ) {
				require('datatables.net-keytable')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {

return $.fn.dataTable;

}));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Bootstrap 4 styling wrapper for RowReorder
 * ©2018 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(11), __webpack_require__(1128)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net-bs4')(root, $).$;
			}

			if ( ! $.fn.dataTable.RowReorder ) {
				require('datatables.net-rowreorder')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {

return $.fn.dataTable;

}));

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Bootstrap 4 styling wrapper for Scroller
 * ©2018 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(11), __webpack_require__(1129)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net-bs4')(root, $).$;
			}

			if ( ! $.fn.dataTable.Scroller ) {
				require('datatables.net-scroller')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {

return $.fn.dataTable;

}));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Bootstrap 4 styling wrapper for Select
 * ©2018 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(11), __webpack_require__(1130)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net-bs4')(root, $).$;
			}

			if ( ! $.fn.dataTable.select ) {
				require('datatables.net-select')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {

return $.fn.dataTable;

}));

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatatableWarning_vue__ = __webpack_require__(438);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatatableWarning_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datepicker_vue__ = __webpack_require__(439);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c5cd73_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1943)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58c5cd73"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c5cd73_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c5cd73_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(88)('wks');
var uid = __webpack_require__(77);
var Symbol = __webpack_require__(27).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(53);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(28)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(26);
var IE8_DOM_DEFINE = __webpack_require__(455);
var toPrimitive = __webpack_require__(58);
var dP = Object.defineProperty;

exports.f = __webpack_require__(33) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_LOCAL_MODULE_0__;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * mOxie - multi-runtime File API & XMLHttpRequest L2 Polyfill
 * v1.5.7
 *
 * Copyright 2013, Moxiecode Systems AB
 * Released under GPL License.
 *
 * License: http://www.plupload.com/license
 * Contributing: http://www.plupload.com/contributing
 *
 * Date: 2017-11-03
 */
!function(e,t){var i=function(){var e={};return t.apply(e,arguments),e.moxie}; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (i),
				__WEBPACK_LOCAL_MODULE_0__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__)):"object"==typeof module&&module.exports?module.exports=i():e.moxie=i()}(this||window,function(){!function(e,t){"use strict";function i(e,t){for(var i,n=[],r=0;r<e.length;++r){if(i=s[e[r]]||o(e[r]),!i)throw"module definition dependecy not found: "+e[r];n.push(i)}t.apply(null,n)}function n(e,n,r){if("string"!=typeof e)throw"invalid module definition, module id must be defined and be a string";if(n===t)throw"invalid module definition, dependencies must be specified";if(r===t)throw"invalid module definition, definition function must be specified";i(n,function(){s[e]=r.apply(null,arguments)})}function r(e){return!!s[e]}function o(t){for(var i=e,n=t.split(/[.\/]/),r=0;r<n.length;++r){if(!i[n[r]])return;i=i[n[r]]}return i}function a(i){for(var n=0;n<i.length;n++){for(var r=e,o=i[n],a=o.split(/[.\/]/),u=0;u<a.length-1;++u)r[a[u]]===t&&(r[a[u]]={}),r=r[a[u]];r[a[a.length-1]]=s[o]}}var s={};n("moxie/core/utils/Basic",[],function(){function e(e){var t;return e===t?"undefined":null===e?"null":e.nodeType?"node":{}.toString.call(e).match(/\s([a-z|A-Z]+)/)[1].toLowerCase()}function t(){return s(!1,!1,arguments)}function i(){return s(!0,!1,arguments)}function n(){return s(!1,!0,arguments)}function r(){return s(!0,!0,arguments)}function o(t){switch(e(t)){case"array":return s(!1,!0,[[],t]);case"object":return s(!1,!0,[{},t]);default:return t}}function a(i){switch(e(i)){case"array":return Array.prototype.slice.call(i);case"object":return t({},i)}return i}function s(t,i,n){var r,o=n[0];return c(n,function(n,u){u>0&&c(n,function(n,u){var c=-1!==h(e(n),["array","object"]);return n===r||t&&o[u]===r?!0:(c&&i&&(n=a(n)),e(o[u])===e(n)&&c?s(t,i,[o[u],n]):o[u]=n,void 0)})}),o}function u(e,t){function i(){this.constructor=e}for(var n in t)({}).hasOwnProperty.call(t,n)&&(e[n]=t[n]);return i.prototype=t.prototype,e.prototype=new i,e.parent=t.prototype,e}function c(e,t){var i,n,r,o;if(e){try{i=e.length}catch(a){i=o}if(i===o||"number"!=typeof i){for(n in e)if(e.hasOwnProperty(n)&&t(e[n],n)===!1)return}else for(r=0;i>r;r++)if(t(e[r],r)===!1)return}}function l(t){var i;if(!t||"object"!==e(t))return!0;for(i in t)return!1;return!0}function d(t,i){function n(r){"function"===e(t[r])&&t[r](function(e){++r<o&&!e?n(r):i(e)})}var r=0,o=t.length;"function"!==e(i)&&(i=function(){}),t&&t.length||i(),n(r)}function m(e,t){var i=0,n=e.length,r=new Array(n);c(e,function(e,o){e(function(e){if(e)return t(e);var a=[].slice.call(arguments);a.shift(),r[o]=a,i++,i===n&&(r.unshift(null),t.apply(this,r))})})}function h(e,t){if(t){if(Array.prototype.indexOf)return Array.prototype.indexOf.call(t,e);for(var i=0,n=t.length;n>i;i++)if(t[i]===e)return i}return-1}function f(t,i){var n=[];"array"!==e(t)&&(t=[t]),"array"!==e(i)&&(i=[i]);for(var r in t)-1===h(t[r],i)&&n.push(t[r]);return n.length?n:!1}function p(e,t){var i=[];return c(e,function(e){-1!==h(e,t)&&i.push(e)}),i.length?i:null}function g(e){var t,i=[];for(t=0;t<e.length;t++)i[t]=e[t];return i}function x(e){return e?String.prototype.trim?String.prototype.trim.call(e):e.toString().replace(/^\s*/,"").replace(/\s*$/,""):e}function v(e){if("string"!=typeof e)return e;var t,i={t:1099511627776,g:1073741824,m:1048576,k:1024};return e=/^([0-9\.]+)([tmgk]?)$/.exec(e.toLowerCase().replace(/[^0-9\.tmkg]/g,"")),t=e[2],e=+e[1],i.hasOwnProperty(t)&&(e*=i[t]),Math.floor(e)}function w(e){var t=[].slice.call(arguments,1);return e.replace(/%([a-z])/g,function(e,i){var n=t.shift();switch(i){case"s":return n+"";case"d":return parseInt(n,10);case"f":return parseFloat(n);case"c":return"";default:return n}})}function y(e,t){var i=this;setTimeout(function(){e.call(i)},t||1)}var E=function(){var e=0;return function(t){var i,n=(new Date).getTime().toString(32);for(i=0;5>i;i++)n+=Math.floor(65535*Math.random()).toString(32);return(t||"o_")+n+(e++).toString(32)}}();return{guid:E,typeOf:e,extend:t,extendIf:i,extendImmutable:n,extendImmutableIf:r,clone:o,inherit:u,each:c,isEmptyObj:l,inSeries:d,inParallel:m,inArray:h,arrayDiff:f,arrayIntersect:p,toArray:g,trim:x,sprintf:w,parseSizeStr:v,delay:y}}),n("moxie/core/utils/Encode",[],function(){var e=function(e){return unescape(encodeURIComponent(e))},t=function(e){return decodeURIComponent(escape(e))},i=function(e,i){if("function"==typeof window.atob)return i?t(window.atob(e)):window.atob(e);var n,r,o,a,s,u,c,l,d="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",m=0,h=0,f="",p=[];if(!e)return e;e+="";do a=d.indexOf(e.charAt(m++)),s=d.indexOf(e.charAt(m++)),u=d.indexOf(e.charAt(m++)),c=d.indexOf(e.charAt(m++)),l=a<<18|s<<12|u<<6|c,n=255&l>>16,r=255&l>>8,o=255&l,p[h++]=64==u?String.fromCharCode(n):64==c?String.fromCharCode(n,r):String.fromCharCode(n,r,o);while(m<e.length);return f=p.join(""),i?t(f):f},n=function(t,i){if(i&&(t=e(t)),"function"==typeof window.btoa)return window.btoa(t);var n,r,o,a,s,u,c,l,d="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",m=0,h=0,f="",p=[];if(!t)return t;do n=t.charCodeAt(m++),r=t.charCodeAt(m++),o=t.charCodeAt(m++),l=n<<16|r<<8|o,a=63&l>>18,s=63&l>>12,u=63&l>>6,c=63&l,p[h++]=d.charAt(a)+d.charAt(s)+d.charAt(u)+d.charAt(c);while(m<t.length);f=p.join("");var g=t.length%3;return(g?f.slice(0,g-3):f)+"===".slice(g||3)};return{utf8_encode:e,utf8_decode:t,atob:i,btoa:n}}),n("moxie/core/utils/Env",["moxie/core/utils/Basic"],function(e){function i(e,t,i){var n=0,r=0,o=0,a={dev:-6,alpha:-5,a:-5,beta:-4,b:-4,RC:-3,rc:-3,"#":-2,p:1,pl:1},s=function(e){return e=(""+e).replace(/[_\-+]/g,"."),e=e.replace(/([^.\d]+)/g,".$1.").replace(/\.{2,}/g,"."),e.length?e.split("."):[-8]},u=function(e){return e?isNaN(e)?a[e]||-7:parseInt(e,10):0};for(e=s(e),t=s(t),r=Math.max(e.length,t.length),n=0;r>n;n++)if(e[n]!=t[n]){if(e[n]=u(e[n]),t[n]=u(t[n]),e[n]<t[n]){o=-1;break}if(e[n]>t[n]){o=1;break}}if(!i)return o;switch(i){case">":case"gt":return o>0;case">=":case"ge":return o>=0;case"<=":case"le":return 0>=o;case"==":case"=":case"eq":return 0===o;case"<>":case"!=":case"ne":return 0!==o;case"":case"<":case"lt":return 0>o;default:return null}}var n=function(e){var t="",i="?",n="function",r="undefined",o="object",a="name",s="version",u={has:function(e,t){return-1!==t.toLowerCase().indexOf(e.toLowerCase())},lowerize:function(e){return e.toLowerCase()}},c={rgx:function(){for(var t,i,a,s,u,c,l,d=0,m=arguments;d<m.length;d+=2){var h=m[d],f=m[d+1];if(typeof t===r){t={};for(s in f)u=f[s],typeof u===o?t[u[0]]=e:t[u]=e}for(i=a=0;i<h.length;i++)if(c=h[i].exec(this.getUA())){for(s=0;s<f.length;s++)l=c[++a],u=f[s],typeof u===o&&u.length>0?2==u.length?t[u[0]]=typeof u[1]==n?u[1].call(this,l):u[1]:3==u.length?t[u[0]]=typeof u[1]!==n||u[1].exec&&u[1].test?l?l.replace(u[1],u[2]):e:l?u[1].call(this,l,u[2]):e:4==u.length&&(t[u[0]]=l?u[3].call(this,l.replace(u[1],u[2])):e):t[u]=l?l:e;break}if(c)break}return t},str:function(t,n){for(var r in n)if(typeof n[r]===o&&n[r].length>0){for(var a=0;a<n[r].length;a++)if(u.has(n[r][a],t))return r===i?e:r}else if(u.has(n[r],t))return r===i?e:r;return t}},l={browser:{oldsafari:{major:{1:["/8","/1","/3"],2:"/4","?":"/"},version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",RT:"ARM"}}}},d={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[a,s],[/\s(opr)\/([\w\.]+)/i],[[a,"Opera"],s],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]+)*/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi)\/([\w\.-]+)/i],[a,s],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[a,"IE"],s],[/(edge)\/((\d+)?[\w\.]+)/i],[a,s],[/(yabrowser)\/([\w\.]+)/i],[[a,"Yandex"],s],[/(comodo_dragon)\/([\w\.]+)/i],[[a,/_/g," "],s],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i,/(uc\s?browser|qqbrowser)[\/\s]?([\w\.]+)/i],[a,s],[/(dolfin)\/([\w\.]+)/i],[[a,"Dolphin"],s],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[a,"Chrome"],s],[/XiaoMi\/MiuiBrowser\/([\w\.]+)/i],[s,[a,"MIUI Browser"]],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)/i],[s,[a,"Android Browser"]],[/FBAV\/([\w\.]+);/i],[s,[a,"Facebook"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[s,[a,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[s,a],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[a,[s,c.str,l.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[a,s],[/(navigator|netscape)\/([\w\.-]+)/i],[[a,"Netscape"],s],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]+)*/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[a,s]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[s,[a,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[a,s],[/rv\:([\w\.]+).*(gecko)/i],[s,a]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[a,s],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*|windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[a,[s,c.str,l.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[a,"Windows"],[s,c.str,l.os.windows.version]],[/\((bb)(10);/i],[[a,"BlackBerry"],s],[/(blackberry)\w*\/?([\w\.]+)*/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\os|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,/linux;.+(sailfish);/i],[a,s],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i],[[a,"Symbian"],s],[/\((series40);/i],[a],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[a,"Firefox OS"],s],[/(nintendo|playstation)\s([wids3portablevu]+)/i,/(mint)[\/\s\(]?(\w+)*/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?([\w\.-]+)*/i,/(hurd|linux)\s?([\w\.]+)*/i,/(gnu)\s?([\w\.]+)*/i],[a,s],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[a,"Chromium OS"],s],[/(sunos)\s?([\w\.]+\d)*/i],[[a,"Solaris"],s],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i],[a,s],[/(ip[honead]+)(?:.*os\s*([\w]+)*\slike\smac|;\sopera)/i],[[a,"iOS"],[s,/_/g,"."]],[/(mac\sos\sx)\s?([\w\s\.]+\w)*/i,/(macintosh|mac(?=_powerpc)\s)/i],[[a,"Mac OS"],[s,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,/(haiku)\s(\w+)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]+)*/i],[a,s]]},m=function(e){var i=e||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:t);this.getBrowser=function(){return c.rgx.apply(this,d.browser)},this.getEngine=function(){return c.rgx.apply(this,d.engine)},this.getOS=function(){return c.rgx.apply(this,d.os)},this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS()}},this.getUA=function(){return i},this.setUA=function(e){return i=e,this},this.setUA(i)};return m}(),r=function(){var i={access_global_ns:function(){return!!window.moxie},define_property:function(){return!1}(),create_canvas:function(){var e=document.createElement("canvas"),t=!(!e.getContext||!e.getContext("2d"));return i.create_canvas=t,t},return_response_type:function(t){try{if(-1!==e.inArray(t,["","text","document"]))return!0;if(window.XMLHttpRequest){var i=new XMLHttpRequest;if(i.open("get","/"),"responseType"in i)return i.responseType=t,i.responseType!==t?!1:!0}}catch(n){}return!1},use_blob_uri:function(){var e=window.URL;return i.use_blob_uri=e&&"createObjectURL"in e&&"revokeObjectURL"in e&&("IE"!==a.browser||a.verComp(a.version,"11.0.46",">=")),i.use_blob_uri},use_data_uri:function(){var e=new Image;return e.onload=function(){i.use_data_uri=1===e.width&&1===e.height},setTimeout(function(){e.src="data:image/gif;base64,R0lGODlhAQABAIAAAP8AAAAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="},1),!1}(),use_data_uri_over32kb:function(){return i.use_data_uri&&("IE"!==a.browser||a.version>=9)},use_data_uri_of:function(e){return i.use_data_uri&&33e3>e||i.use_data_uri_over32kb()},use_fileinput:function(){if(navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/))return!1;var e=document.createElement("input");return e.setAttribute("type","file"),i.use_fileinput=!e.disabled},use_webgl:function(){var e,n=document.createElement("canvas"),r=null;try{r=n.getContext("webgl")||n.getContext("experimental-webgl")}catch(o){}return r||(r=null),e=!!r,i.use_webgl=e,n=t,e}};return function(t){var n=[].slice.call(arguments);return n.shift(),"function"===e.typeOf(i[t])?i[t].apply(this,n):!!i[t]}}(),o=(new n).getResult(),a={can:r,uaParser:n,browser:o.browser.name,version:o.browser.version,os:o.os.name,osVersion:o.os.version,verComp:i,swf_url:"../flash/Moxie.swf",xap_url:"../silverlight/Moxie.xap",global_event_dispatcher:"moxie.core.EventTarget.instance.dispatchEvent"};return a.OS=a.os,a}),n("moxie/core/Exceptions",["moxie/core/utils/Basic"],function(e){function t(e,t){var i;for(i in e)if(e[i]===t)return i;return null}return{RuntimeError:function(){function i(e,i){this.code=e,this.name=t(n,e),this.message=this.name+(i||": RuntimeError "+this.code)}var n={NOT_INIT_ERR:1,EXCEPTION_ERR:3,NOT_SUPPORTED_ERR:9,JS_ERR:4};return e.extend(i,n),i.prototype=Error.prototype,i}(),OperationNotAllowedException:function(){function t(e){this.code=e,this.name="OperationNotAllowedException"}return e.extend(t,{NOT_ALLOWED_ERR:1}),t.prototype=Error.prototype,t}(),ImageError:function(){function i(e){this.code=e,this.name=t(n,e),this.message=this.name+": ImageError "+this.code}var n={WRONG_FORMAT:1,MAX_RESOLUTION_ERR:2,INVALID_META_ERR:3};return e.extend(i,n),i.prototype=Error.prototype,i}(),FileException:function(){function i(e){this.code=e,this.name=t(n,e),this.message=this.name+": FileException "+this.code}var n={NOT_FOUND_ERR:1,SECURITY_ERR:2,ABORT_ERR:3,NOT_READABLE_ERR:4,ENCODING_ERR:5,NO_MODIFICATION_ALLOWED_ERR:6,INVALID_STATE_ERR:7,SYNTAX_ERR:8};return e.extend(i,n),i.prototype=Error.prototype,i}(),DOMException:function(){function i(e){this.code=e,this.name=t(n,e),this.message=this.name+": DOMException "+this.code}var n={INDEX_SIZE_ERR:1,DOMSTRING_SIZE_ERR:2,HIERARCHY_REQUEST_ERR:3,WRONG_DOCUMENT_ERR:4,INVALID_CHARACTER_ERR:5,NO_DATA_ALLOWED_ERR:6,NO_MODIFICATION_ALLOWED_ERR:7,NOT_FOUND_ERR:8,NOT_SUPPORTED_ERR:9,INUSE_ATTRIBUTE_ERR:10,INVALID_STATE_ERR:11,SYNTAX_ERR:12,INVALID_MODIFICATION_ERR:13,NAMESPACE_ERR:14,INVALID_ACCESS_ERR:15,VALIDATION_ERR:16,TYPE_MISMATCH_ERR:17,SECURITY_ERR:18,NETWORK_ERR:19,ABORT_ERR:20,URL_MISMATCH_ERR:21,QUOTA_EXCEEDED_ERR:22,TIMEOUT_ERR:23,INVALID_NODE_TYPE_ERR:24,DATA_CLONE_ERR:25};return e.extend(i,n),i.prototype=Error.prototype,i}(),EventException:function(){function t(e){this.code=e,this.name="EventException"}return e.extend(t,{UNSPECIFIED_EVENT_TYPE_ERR:0}),t.prototype=Error.prototype,t}()}}),n("moxie/core/utils/Dom",["moxie/core/utils/Env"],function(e){var t=function(e){return"string"!=typeof e?e:document.getElementById(e)},i=function(e,t){if(!e.className)return!1;var i=new RegExp("(^|\\s+)"+t+"(\\s+|$)");return i.test(e.className)},n=function(e,t){i(e,t)||(e.className=e.className?e.className.replace(/\s+$/,"")+" "+t:t)},r=function(e,t){if(e.className){var i=new RegExp("(^|\\s+)"+t+"(\\s+|$)");e.className=e.className.replace(i,function(e,t,i){return" "===t&&" "===i?" ":""})}},o=function(e,t){return e.currentStyle?e.currentStyle[t]:window.getComputedStyle?window.getComputedStyle(e,null)[t]:void 0},a=function(t,i){function n(e){var t,i,n=0,r=0;return e&&(i=e.getBoundingClientRect(),t="CSS1Compat"===c.compatMode?c.documentElement:c.body,n=i.left+t.scrollLeft,r=i.top+t.scrollTop),{x:n,y:r}}var r,o,a,s=0,u=0,c=document;if(t=t,i=i||c.body,t&&t.getBoundingClientRect&&"IE"===e.browser&&(!c.documentMode||c.documentMode<8))return o=n(t),a=n(i),{x:o.x-a.x,y:o.y-a.y};for(r=t;r&&r!=i&&r.nodeType;)s+=r.offsetLeft||0,u+=r.offsetTop||0,r=r.offsetParent;for(r=t.parentNode;r&&r!=i&&r.nodeType;)s-=r.scrollLeft||0,u-=r.scrollTop||0,r=r.parentNode;return{x:s,y:u}},s=function(e){return{w:e.offsetWidth||e.clientWidth,h:e.offsetHeight||e.clientHeight}};return{get:t,hasClass:i,addClass:n,removeClass:r,getStyle:o,getPos:a,getSize:s}}),n("moxie/core/EventTarget",["moxie/core/utils/Env","moxie/core/Exceptions","moxie/core/utils/Basic"],function(e,t,i){function n(){this.uid=i.guid()}var r={};return i.extend(n.prototype,{init:function(){this.uid||(this.uid=i.guid("uid_"))},addEventListener:function(e,t,n,o){var a,s=this;return this.hasOwnProperty("uid")||(this.uid=i.guid("uid_")),e=i.trim(e),/\s/.test(e)?(i.each(e.split(/\s+/),function(e){s.addEventListener(e,t,n,o)}),void 0):(e=e.toLowerCase(),n=parseInt(n,10)||0,a=r[this.uid]&&r[this.uid][e]||[],a.push({fn:t,priority:n,scope:o||this}),r[this.uid]||(r[this.uid]={}),r[this.uid][e]=a,void 0)},hasEventListener:function(e){var t;return e?(e=e.toLowerCase(),t=r[this.uid]&&r[this.uid][e]):t=r[this.uid],t?t:!1},removeEventListener:function(e,t){var n,o,a=this;if(e=e.toLowerCase(),/\s/.test(e))return i.each(e.split(/\s+/),function(e){a.removeEventListener(e,t)}),void 0;if(n=r[this.uid]&&r[this.uid][e]){if(t){for(o=n.length-1;o>=0;o--)if(n[o].fn===t){n.splice(o,1);break}}else n=[];n.length||(delete r[this.uid][e],i.isEmptyObj(r[this.uid])&&delete r[this.uid])}},removeAllEventListeners:function(){r[this.uid]&&delete r[this.uid]},dispatchEvent:function(e){var n,o,a,s,u,c={},l=!0;if("string"!==i.typeOf(e)){if(s=e,"string"!==i.typeOf(s.type))throw new t.EventException(t.EventException.UNSPECIFIED_EVENT_TYPE_ERR);e=s.type,s.total!==u&&s.loaded!==u&&(c.total=s.total,c.loaded=s.loaded),c.async=s.async||!1}if(-1!==e.indexOf("::")?function(t){n=t[0],e=t[1]}(e.split("::")):n=this.uid,e=e.toLowerCase(),o=r[n]&&r[n][e]){o.sort(function(e,t){return t.priority-e.priority}),a=[].slice.call(arguments),a.shift(),c.type=e,a.unshift(c);var d=[];i.each(o,function(e){a[0].target=e.scope,c.async?d.push(function(t){setTimeout(function(){t(e.fn.apply(e.scope,a)===!1)},1)}):d.push(function(t){t(e.fn.apply(e.scope,a)===!1)})}),d.length&&i.inSeries(d,function(e){l=!e})}return l},bindOnce:function(e,t,i,n){var r=this;r.bind.call(this,e,function o(){return r.unbind(e,o),t.apply(this,arguments)},i,n)},bind:function(){this.addEventListener.apply(this,arguments)},unbind:function(){this.removeEventListener.apply(this,arguments)},unbindAll:function(){this.removeAllEventListeners.apply(this,arguments)},trigger:function(){return this.dispatchEvent.apply(this,arguments)},handleEventProps:function(e){var t=this;this.bind(e.join(" "),function(e){var t="on"+e.type.toLowerCase();"function"===i.typeOf(this[t])&&this[t].apply(this,arguments)}),i.each(e,function(e){e="on"+e.toLowerCase(e),"undefined"===i.typeOf(t[e])&&(t[e]=null)})}}),n.instance=new n,n}),n("moxie/runtime/Runtime",["moxie/core/utils/Env","moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/EventTarget"],function(e,t,i,n){function r(e,n,o,s,u){var c,l=this,d=t.guid(n+"_"),m=u||"browser";e=e||{},a[d]=this,o=t.extend({access_binary:!1,access_image_binary:!1,display_media:!1,do_cors:!1,drag_and_drop:!1,filter_by_extension:!0,resize_image:!1,report_upload_progress:!1,return_response_headers:!1,return_response_type:!1,return_status_code:!0,send_custom_headers:!1,select_file:!1,select_folder:!1,select_multiple:!0,send_binary_string:!1,send_browser_cookies:!0,send_multipart:!0,slice_blob:!1,stream_upload:!1,summon_file_dialog:!1,upload_filesize:!0,use_http_method:!0},o),e.preferred_caps&&(m=r.getMode(s,e.preferred_caps,m)),c=function(){var e={};return{exec:function(t,i,n,r){return c[i]&&(e[t]||(e[t]={context:this,instance:new c[i]}),e[t].instance[n])?e[t].instance[n].apply(this,r):void 0},removeInstance:function(t){delete e[t]},removeAllInstances:function(){var i=this;t.each(e,function(e,n){"function"===t.typeOf(e.instance.destroy)&&e.instance.destroy.call(e.context),i.removeInstance(n)})}}}(),t.extend(this,{initialized:!1,uid:d,type:n,mode:r.getMode(s,e.required_caps,m),shimid:d+"_container",clients:0,options:e,can:function(e,i){var n=arguments[2]||o;if("string"===t.typeOf(e)&&"undefined"===t.typeOf(i)&&(e=r.parseCaps(e)),"object"===t.typeOf(e)){for(var a in e)if(!this.can(a,e[a],n))return!1;return!0}return"function"===t.typeOf(n[e])?n[e].call(this,i):i===n[e]},getShimContainer:function(){var e,n=i.get(this.shimid);return n||(e=i.get(this.options.container)||document.body,n=document.createElement("div"),n.id=this.shimid,n.className="moxie-shim moxie-shim-"+this.type,t.extend(n.style,{position:"absolute",top:"0px",left:"0px",width:"1px",height:"1px",overflow:"hidden"}),e.appendChild(n),e=null),n},getShim:function(){return c},shimExec:function(e,t){var i=[].slice.call(arguments,2);return l.getShim().exec.call(this,this.uid,e,t,i)},exec:function(e,t){var i=[].slice.call(arguments,2);return l[e]&&l[e][t]?l[e][t].apply(this,i):l.shimExec.apply(this,arguments)},destroy:function(){if(l){var e=i.get(this.shimid);e&&e.parentNode.removeChild(e),c&&c.removeAllInstances(),this.unbindAll(),delete a[this.uid],this.uid=null,d=l=c=e=null}}}),this.mode&&e.required_caps&&!this.can(e.required_caps)&&(this.mode=!1)}var o={},a={};return r.order="html5,flash,silverlight,html4",r.getRuntime=function(e){return a[e]?a[e]:!1},r.addConstructor=function(e,t){t.prototype=n.instance,o[e]=t},r.getConstructor=function(e){return o[e]||null},r.getInfo=function(e){var t=r.getRuntime(e);return t?{uid:t.uid,type:t.type,mode:t.mode,can:function(){return t.can.apply(t,arguments)}}:null},r.parseCaps=function(e){var i={};return"string"!==t.typeOf(e)?e||{}:(t.each(e.split(","),function(e){i[e]=!0}),i)},r.can=function(e,t){var i,n,o=r.getConstructor(e);return o?(i=new o({required_caps:t}),n=i.mode,i.destroy(),!!n):!1},r.thatCan=function(e,t){var i=(t||r.order).split(/\s*,\s*/);for(var n in i)if(r.can(i[n],e))return i[n];return null},r.getMode=function(e,i,n){var r=null;if("undefined"===t.typeOf(n)&&(n="browser"),i&&!t.isEmptyObj(e)){if(t.each(i,function(i,n){if(e.hasOwnProperty(n)){var o=e[n](i);if("string"==typeof o&&(o=[o]),r){if(!(r=t.arrayIntersect(r,o)))return r=!1}else r=o}}),r)return-1!==t.inArray(n,r)?n:r[0];if(r===!1)return!1}return n},r.getGlobalEventTarget=function(){if(/^moxie\./.test(e.global_event_dispatcher)&&!e.can("access_global_ns")){var i=t.guid("moxie_event_target_");window[i]=function(e,t){n.instance.dispatchEvent(e,t)},e.global_event_dispatcher=i}return e.global_event_dispatcher},r.capTrue=function(){return!0},r.capFalse=function(){return!1},r.capTest=function(e){return function(){return!!e}},r}),n("moxie/runtime/RuntimeClient",["moxie/core/utils/Env","moxie/core/Exceptions","moxie/core/utils/Basic","moxie/runtime/Runtime"],function(e,t,i,n){return function(){var e;i.extend(this,{connectRuntime:function(r){function o(i){var a,u;return i.length?(a=i.shift().toLowerCase(),(u=n.getConstructor(a))?(e=new u(r),e.bind("Init",function(){e.initialized=!0,setTimeout(function(){e.clients++,s.ruid=e.uid,s.trigger("RuntimeInit",e)},1)}),e.bind("Error",function(){e.destroy(),o(i)}),e.bind("Exception",function(e,i){var n=i.name+"(#"+i.code+")"+(i.message?", from: "+i.message:"");s.trigger("RuntimeError",new t.RuntimeError(t.RuntimeError.EXCEPTION_ERR,n))}),e.mode?(e.init(),void 0):(e.trigger("Error"),void 0)):(o(i),void 0)):(s.trigger("RuntimeError",new t.RuntimeError(t.RuntimeError.NOT_INIT_ERR)),e=null,void 0)}var a,s=this;if("string"===i.typeOf(r)?a=r:"string"===i.typeOf(r.ruid)&&(a=r.ruid),a){if(e=n.getRuntime(a))return s.ruid=a,e.clients++,e;throw new t.RuntimeError(t.RuntimeError.NOT_INIT_ERR)}o((r.runtime_order||n.order).split(/\s*,\s*/))},disconnectRuntime:function(){e&&--e.clients<=0&&e.destroy(),e=null},getRuntime:function(){return e&&e.uid?e:e=null},exec:function(){return e?e.exec.apply(this,arguments):null},can:function(t){return e?e.can(t):!1}})}}),n("moxie/file/Blob",["moxie/core/utils/Basic","moxie/core/utils/Encode","moxie/runtime/RuntimeClient"],function(e,t,i){function n(o,a){function s(t,i,o){var a,s=r[this.uid];return"string"===e.typeOf(s)&&s.length?(a=new n(null,{type:o,size:i-t}),a.detach(s.substr(t,a.size)),a):null}i.call(this),o&&this.connectRuntime(o),a?"string"===e.typeOf(a)&&(a={data:a}):a={},e.extend(this,{uid:a.uid||e.guid("uid_"),ruid:o,size:a.size||0,type:a.type||"",slice:function(e,t,i){return this.isDetached()?s.apply(this,arguments):this.getRuntime().exec.call(this,"Blob","slice",this.getSource(),e,t,i)},getSource:function(){return r[this.uid]?r[this.uid]:null},detach:function(e){if(this.ruid&&(this.getRuntime().exec.call(this,"Blob","destroy"),this.disconnectRuntime(),this.ruid=null),e=e||"","data:"==e.substr(0,5)){var i=e.indexOf(";base64,");this.type=e.substring(5,i),e=t.atob(e.substring(i+8))}this.size=e.length,r[this.uid]=e},isDetached:function(){return!this.ruid&&"string"===e.typeOf(r[this.uid])},destroy:function(){this.detach(),delete r[this.uid]}}),a.data?this.detach(a.data):r[this.uid]=a}var r={};return n}),n("moxie/core/I18n",["moxie/core/utils/Basic"],function(e){var t={};return{addI18n:function(i){return e.extend(t,i)},translate:function(e){return t[e]||e},_:function(e){return this.translate(e)},sprintf:function(t){var i=[].slice.call(arguments,1);return t.replace(/%[a-z]/g,function(){var t=i.shift();return"undefined"!==e.typeOf(t)?t:""})}}}),n("moxie/core/utils/Mime",["moxie/core/utils/Basic","moxie/core/I18n"],function(e,t){var i="application/msword,doc dot,application/pdf,pdf,application/pgp-signature,pgp,application/postscript,ps ai eps,application/rtf,rtf,application/vnd.ms-excel,xls xlb xlt xla,application/vnd.ms-powerpoint,ppt pps pot ppa,application/zip,zip,application/x-shockwave-flash,swf swfl,application/vnd.openxmlformats-officedocument.wordprocessingml.document,docx,application/vnd.openxmlformats-officedocument.wordprocessingml.template,dotx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,xlsx,application/vnd.openxmlformats-officedocument.presentationml.presentation,pptx,application/vnd.openxmlformats-officedocument.presentationml.template,potx,application/vnd.openxmlformats-officedocument.presentationml.slideshow,ppsx,application/x-javascript,js,application/json,json,audio/mpeg,mp3 mpga mpega mp2,audio/x-wav,wav,audio/x-m4a,m4a,audio/ogg,oga ogg,audio/aiff,aiff aif,audio/flac,flac,audio/aac,aac,audio/ac3,ac3,audio/x-ms-wma,wma,image/bmp,bmp,image/gif,gif,image/jpeg,jpg jpeg jpe,image/photoshop,psd,image/png,png,image/svg+xml,svg svgz,image/tiff,tiff tif,text/plain,asc txt text diff log,text/html,htm html xhtml,text/css,css,text/csv,csv,text/rtf,rtf,video/mpeg,mpeg mpg mpe m2v,video/quicktime,qt mov,video/mp4,mp4,video/x-m4v,m4v,video/x-flv,flv,video/x-ms-wmv,wmv,video/avi,avi,video/webm,webm,video/3gpp,3gpp 3gp,video/3gpp2,3g2,video/vnd.rn-realvideo,rv,video/ogg,ogv,video/x-matroska,mkv,application/vnd.oasis.opendocument.formula-template,otf,application/octet-stream,exe",n={},r={},o=function(e){var t,i,o,a=e.split(/,/);for(t=0;t<a.length;t+=2){for(o=a[t+1].split(/ /),i=0;i<o.length;i++)n[o[i]]=a[t];r[a[t]]=o}},a=function(t,i){var n,r,o,a,s=[];for(r=0;r<t.length;r++)for(n=t[r].extensions.toLowerCase().split(/\s*,\s*/),o=0;o<n.length;o++){if("*"===n[o])return[];if(a=s[n[o]],i&&/^\w+$/.test(n[o]))s.push("."+n[o]);else if(a&&-1===e.inArray(a,s))s.push(a);else if(!a)return[]}return s},s=function(t){var i=[];return e.each(t,function(t){if(t=t.toLowerCase(),"*"===t)return i=[],!1;var n=t.match(/^(\w+)\/(\*|\w+)$/);n&&("*"===n[2]?e.each(r,function(e,t){new RegExp("^"+n[1]+"/").test(t)&&[].push.apply(i,r[t])}):r[t]&&[].push.apply(i,r[t]))}),i},u=function(i){var n=[],r=[];return"string"===e.typeOf(i)&&(i=e.trim(i).split(/\s*,\s*/)),r=s(i),n.push({title:t.translate("Files"),extensions:r.length?r.join(","):"*"}),n},c=function(e){var t=e&&e.match(/\.([^.]+)$/);return t?t[1].toLowerCase():""},l=function(e){return n[c(e)]||""};return o(i),{mimes:n,extensions:r,addMimeType:o,extList2mimes:a,mimes2exts:s,mimes2extList:u,getFileExtension:c,getFileMime:l}}),n("moxie/file/FileInput",["moxie/core/utils/Basic","moxie/core/utils/Env","moxie/core/utils/Mime","moxie/core/utils/Dom","moxie/core/Exceptions","moxie/core/EventTarget","moxie/core/I18n","moxie/runtime/Runtime","moxie/runtime/RuntimeClient"],function(e,t,i,n,r,o,a,s,u){function c(t){var o,c,d;if(-1!==e.inArray(e.typeOf(t),["string","node"])&&(t={browse_button:t}),c=n.get(t.browse_button),!c)throw new r.DOMException(r.DOMException.NOT_FOUND_ERR);d={accept:[{title:a.translate("All Files"),extensions:"*"}],multiple:!1,required_caps:!1,container:c.parentNode||document.body},t=e.extend({},d,t),"string"==typeof t.required_caps&&(t.required_caps=s.parseCaps(t.required_caps)),"string"==typeof t.accept&&(t.accept=i.mimes2extList(t.accept)),o=n.get(t.container),o||(o=document.body),"static"===n.getStyle(o,"position")&&(o.style.position="relative"),o=c=null,u.call(this),e.extend(this,{uid:e.guid("uid_"),ruid:null,shimid:null,files:null,init:function(){var i=this;i.bind("RuntimeInit",function(r,o){i.ruid=o.uid,i.shimid=o.shimid,i.bind("Ready",function(){i.trigger("Refresh")},999),i.bind("Refresh",function(){var i,r,a,s,u;a=n.get(t.browse_button),s=n.get(o.shimid),a&&(i=n.getPos(a,n.get(t.container)),r=n.getSize(a),u=parseInt(n.getStyle(a,"z-index"),10)||0,s&&e.extend(s.style,{top:i.y+"px",left:i.x+"px",width:r.w+"px",height:r.h+"px",zIndex:u+1})),s=a=null}),o.exec.call(i,"FileInput","init",t)}),i.connectRuntime(e.extend({},t,{required_caps:{select_file:!0}}))},getOption:function(e){return t[e]},setOption:function(e,n){if(t.hasOwnProperty(e)){var o=t[e];switch(e){case"accept":"string"==typeof n&&(n=i.mimes2extList(n));break;case"container":case"required_caps":throw new r.FileException(r.FileException.NO_MODIFICATION_ALLOWED_ERR)}t[e]=n,this.exec("FileInput","setOption",e,n),this.trigger("OptionChanged",e,n,o)}},disable:function(t){var i=this.getRuntime();i&&this.exec("FileInput","disable","undefined"===e.typeOf(t)?!0:t)},refresh:function(){this.trigger("Refresh")},destroy:function(){var t=this.getRuntime();t&&(t.exec.call(this,"FileInput","destroy"),this.disconnectRuntime()),"array"===e.typeOf(this.files)&&e.each(this.files,function(e){e.destroy()}),this.files=null,this.unbindAll()}}),this.handleEventProps(l)}var l=["ready","change","cancel","mouseenter","mouseleave","mousedown","mouseup"];return c.prototype=o.instance,c}),n("moxie/file/File",["moxie/core/utils/Basic","moxie/core/utils/Mime","moxie/file/Blob"],function(e,t,i){function n(n,r){r||(r={}),i.apply(this,arguments),this.type||(this.type=t.getFileMime(r.name));var o;if(r.name)o=r.name.replace(/\\/g,"/"),o=o.substr(o.lastIndexOf("/")+1);else if(this.type){var a=this.type.split("/")[0];o=e.guid((""!==a?a:"file")+"_"),t.extensions[this.type]&&(o+="."+t.extensions[this.type][0])}e.extend(this,{name:o||e.guid("file_"),relativePath:"",lastModifiedDate:r.lastModifiedDate||(new Date).toLocaleString()})}return n.prototype=i.prototype,n}),n("moxie/file/FileDrop",["moxie/core/I18n","moxie/core/utils/Dom","moxie/core/Exceptions","moxie/core/utils/Basic","moxie/core/utils/Env","moxie/file/File","moxie/runtime/RuntimeClient","moxie/core/EventTarget","moxie/core/utils/Mime"],function(e,t,i,n,r,o,a,s,u){function c(i){var r,o=this;"string"==typeof i&&(i={drop_zone:i}),r={accept:[{title:e.translate("All Files"),extensions:"*"}],required_caps:{drag_and_drop:!0}},i="object"==typeof i?n.extend({},r,i):r,i.container=t.get(i.drop_zone)||document.body,"static"===t.getStyle(i.container,"position")&&(i.container.style.position="relative"),"string"==typeof i.accept&&(i.accept=u.mimes2extList(i.accept)),a.call(o),n.extend(o,{uid:n.guid("uid_"),ruid:null,files:null,init:function(){o.bind("RuntimeInit",function(e,t){o.ruid=t.uid,t.exec.call(o,"FileDrop","init",i),o.dispatchEvent("ready")
}),o.connectRuntime(i)},destroy:function(){var e=this.getRuntime();e&&(e.exec.call(this,"FileDrop","destroy"),this.disconnectRuntime()),this.files=null,this.unbindAll()}}),this.handleEventProps(l)}var l=["ready","dragenter","dragleave","drop","error"];return c.prototype=s.instance,c}),n("moxie/file/FileReader",["moxie/core/utils/Basic","moxie/core/utils/Encode","moxie/core/Exceptions","moxie/core/EventTarget","moxie/file/Blob","moxie/runtime/RuntimeClient"],function(e,t,i,n,r,o){function a(){function n(e,n){if(this.trigger("loadstart"),this.readyState===a.LOADING)return this.trigger("error",new i.DOMException(i.DOMException.INVALID_STATE_ERR)),this.trigger("loadend"),void 0;if(!(n instanceof r))return this.trigger("error",new i.DOMException(i.DOMException.NOT_FOUND_ERR)),this.trigger("loadend"),void 0;if(this.result=null,this.readyState=a.LOADING,n.isDetached()){var o=n.getSource();switch(e){case"readAsText":case"readAsBinaryString":this.result=o;break;case"readAsDataURL":this.result="data:"+n.type+";base64,"+t.btoa(o)}this.readyState=a.DONE,this.trigger("load"),this.trigger("loadend")}else this.connectRuntime(n.ruid),this.exec("FileReader","read",e,n)}o.call(this),e.extend(this,{uid:e.guid("uid_"),readyState:a.EMPTY,result:null,error:null,readAsBinaryString:function(e){n.call(this,"readAsBinaryString",e)},readAsDataURL:function(e){n.call(this,"readAsDataURL",e)},readAsText:function(e){n.call(this,"readAsText",e)},abort:function(){this.result=null,-1===e.inArray(this.readyState,[a.EMPTY,a.DONE])&&(this.readyState===a.LOADING&&(this.readyState=a.DONE),this.exec("FileReader","abort"),this.trigger("abort"),this.trigger("loadend"))},destroy:function(){this.abort(),this.exec("FileReader","destroy"),this.disconnectRuntime(),this.unbindAll()}}),this.handleEventProps(s),this.bind("Error",function(e,t){this.readyState=a.DONE,this.error=t},999),this.bind("Load",function(){this.readyState=a.DONE},999)}var s=["loadstart","progress","load","abort","error","loadend"];return a.EMPTY=0,a.LOADING=1,a.DONE=2,a.prototype=n.instance,a}),n("moxie/core/utils/Url",["moxie/core/utils/Basic"],function(e){var t=function(i,n){var r,o=["source","scheme","authority","userInfo","user","pass","host","port","relative","path","directory","file","query","fragment"],a=o.length,s={http:80,https:443},u={},c=/^(?:([^:\/?#]+):)?(?:\/\/()(?:(?:()(?:([^:@\/]*):?([^:@\/]*))?@)?(\[[\da-fA-F:]+\]|[^:\/?#]*)(?::(\d*))?))?()(?:(()(?:(?:[^?#\/]*\/)*)()(?:[^?#]*))(?:\\?([^#]*))?(?:#(.*))?)/,l=c.exec(i||""),d=/^\/\/\w/.test(i);switch(e.typeOf(n)){case"undefined":n=t(document.location.href,!1);break;case"string":n=t(n,!1)}for(;a--;)l[a]&&(u[o[a]]=l[a]);if(r=!d&&!u.scheme,(d||r)&&(u.scheme=n.scheme),r){u.host=n.host,u.port=n.port;var m="";/^[^\/]/.test(u.path)&&(m=n.path,m=/\/[^\/]*\.[^\/]*$/.test(m)?m.replace(/\/[^\/]+$/,"/"):m.replace(/\/?$/,"/")),u.path=m+(u.path||"")}return u.port||(u.port=s[u.scheme]||80),u.port=parseInt(u.port,10),u.path||(u.path="/"),delete u.source,u},i=function(e){var i={http:80,https:443},n="object"==typeof e?e:t(e);return n.scheme+"://"+n.host+(n.port!==i[n.scheme]?":"+n.port:"")+n.path+(n.query?n.query:"")},n=function(e){function i(e){return[e.scheme,e.host,e.port].join("/")}return"string"==typeof e&&(e=t(e)),i(t())===i(e)};return{parseUrl:t,resolveUrl:i,hasSameOrigin:n}}),n("moxie/runtime/RuntimeTarget",["moxie/core/utils/Basic","moxie/runtime/RuntimeClient","moxie/core/EventTarget"],function(e,t,i){function n(){this.uid=e.guid("uid_"),t.call(this),this.destroy=function(){this.disconnectRuntime(),this.unbindAll()}}return n.prototype=i.instance,n}),n("moxie/file/FileReaderSync",["moxie/core/utils/Basic","moxie/runtime/RuntimeClient","moxie/core/utils/Encode"],function(e,t,i){return function(){function n(e,t){if(!t.isDetached()){var n=this.connectRuntime(t.ruid).exec.call(this,"FileReaderSync","read",e,t);return this.disconnectRuntime(),n}var r=t.getSource();switch(e){case"readAsBinaryString":return r;case"readAsDataURL":return"data:"+t.type+";base64,"+i.btoa(r);case"readAsText":for(var o="",a=0,s=r.length;s>a;a++)o+=String.fromCharCode(r[a]);return o}}t.call(this),e.extend(this,{uid:e.guid("uid_"),readAsBinaryString:function(e){return n.call(this,"readAsBinaryString",e)},readAsDataURL:function(e){return n.call(this,"readAsDataURL",e)},readAsText:function(e){return n.call(this,"readAsText",e)}})}}),n("moxie/xhr/FormData",["moxie/core/Exceptions","moxie/core/utils/Basic","moxie/file/Blob"],function(e,t,i){function n(){var e,n=[];t.extend(this,{append:function(r,o){var a=this,s=t.typeOf(o);o instanceof i?e={name:r,value:o}:"array"===s?(r+="[]",t.each(o,function(e){a.append(r,e)})):"object"===s?t.each(o,function(e,t){a.append(r+"["+t+"]",e)}):"null"===s||"undefined"===s||"number"===s&&isNaN(o)?a.append(r,"false"):n.push({name:r,value:o.toString()})},hasBlob:function(){return!!this.getBlob()},getBlob:function(){return e&&e.value||null},getBlobName:function(){return e&&e.name||null},each:function(i){t.each(n,function(e){i(e.value,e.name)}),e&&i(e.value,e.name)},destroy:function(){e=null,n=[]}})}return n}),n("moxie/xhr/XMLHttpRequest",["moxie/core/utils/Basic","moxie/core/Exceptions","moxie/core/EventTarget","moxie/core/utils/Encode","moxie/core/utils/Url","moxie/runtime/Runtime","moxie/runtime/RuntimeTarget","moxie/file/Blob","moxie/file/FileReaderSync","moxie/xhr/FormData","moxie/core/utils/Env","moxie/core/utils/Mime"],function(e,t,i,n,r,o,a,s,u,c,l,d){function m(){this.uid=e.guid("uid_")}function h(){function i(e,t){return I.hasOwnProperty(e)?1===arguments.length?l.can("define_property")?I[e]:A[e]:(l.can("define_property")?I[e]=t:A[e]=t,void 0):void 0}function u(t){function n(){_&&(_.destroy(),_=null),s.dispatchEvent("loadend"),s=null}function r(r){_.bind("LoadStart",function(e){i("readyState",h.LOADING),s.dispatchEvent("readystatechange"),s.dispatchEvent(e),L&&s.upload.dispatchEvent(e)}),_.bind("Progress",function(e){i("readyState")!==h.LOADING&&(i("readyState",h.LOADING),s.dispatchEvent("readystatechange")),s.dispatchEvent(e)}),_.bind("UploadProgress",function(e){L&&s.upload.dispatchEvent({type:"progress",lengthComputable:!1,total:e.total,loaded:e.loaded})}),_.bind("Load",function(t){i("readyState",h.DONE),i("status",Number(r.exec.call(_,"XMLHttpRequest","getStatus")||0)),i("statusText",f[i("status")]||""),i("response",r.exec.call(_,"XMLHttpRequest","getResponse",i("responseType"))),~e.inArray(i("responseType"),["text",""])?i("responseText",i("response")):"document"===i("responseType")&&i("responseXML",i("response")),U=r.exec.call(_,"XMLHttpRequest","getAllResponseHeaders"),s.dispatchEvent("readystatechange"),i("status")>0?(L&&s.upload.dispatchEvent(t),s.dispatchEvent(t)):(F=!0,s.dispatchEvent("error")),n()}),_.bind("Abort",function(e){s.dispatchEvent(e),n()}),_.bind("Error",function(e){F=!0,i("readyState",h.DONE),s.dispatchEvent("readystatechange"),M=!0,s.dispatchEvent(e),n()}),r.exec.call(_,"XMLHttpRequest","send",{url:x,method:v,async:T,user:w,password:y,headers:S,mimeType:D,encoding:O,responseType:s.responseType,withCredentials:s.withCredentials,options:k},t)}var s=this;E=(new Date).getTime(),_=new a,"string"==typeof k.required_caps&&(k.required_caps=o.parseCaps(k.required_caps)),k.required_caps=e.extend({},k.required_caps,{return_response_type:s.responseType}),t instanceof c&&(k.required_caps.send_multipart=!0),e.isEmptyObj(S)||(k.required_caps.send_custom_headers=!0),B||(k.required_caps.do_cors=!0),k.ruid?r(_.connectRuntime(k)):(_.bind("RuntimeInit",function(e,t){r(t)}),_.bind("RuntimeError",function(e,t){s.dispatchEvent("RuntimeError",t)}),_.connectRuntime(k))}function g(){i("responseText",""),i("responseXML",null),i("response",null),i("status",0),i("statusText",""),E=b=null}var x,v,w,y,E,b,_,R,A=this,I={timeout:0,readyState:h.UNSENT,withCredentials:!1,status:0,statusText:"",responseType:"",responseXML:null,responseText:null,response:null},T=!0,S={},O=null,D=null,N=!1,C=!1,L=!1,M=!1,F=!1,B=!1,P=null,H=null,k={},U="";e.extend(this,I,{uid:e.guid("uid_"),upload:new m,open:function(o,a,s,u,c){var l;if(!o||!a)throw new t.DOMException(t.DOMException.SYNTAX_ERR);if(/[\u0100-\uffff]/.test(o)||n.utf8_encode(o)!==o)throw new t.DOMException(t.DOMException.SYNTAX_ERR);if(~e.inArray(o.toUpperCase(),["CONNECT","DELETE","GET","HEAD","OPTIONS","POST","PUT","TRACE","TRACK"])&&(v=o.toUpperCase()),~e.inArray(v,["CONNECT","TRACE","TRACK"]))throw new t.DOMException(t.DOMException.SECURITY_ERR);if(a=n.utf8_encode(a),l=r.parseUrl(a),B=r.hasSameOrigin(l),x=r.resolveUrl(a),(u||c)&&!B)throw new t.DOMException(t.DOMException.INVALID_ACCESS_ERR);if(w=u||l.user,y=c||l.pass,T=s||!0,T===!1&&(i("timeout")||i("withCredentials")||""!==i("responseType")))throw new t.DOMException(t.DOMException.INVALID_ACCESS_ERR);N=!T,C=!1,S={},g.call(this),i("readyState",h.OPENED),this.dispatchEvent("readystatechange")},setRequestHeader:function(r,o){var a=["accept-charset","accept-encoding","access-control-request-headers","access-control-request-method","connection","content-length","cookie","cookie2","content-transfer-encoding","date","expect","host","keep-alive","origin","referer","te","trailer","transfer-encoding","upgrade","user-agent","via"];if(i("readyState")!==h.OPENED||C)throw new t.DOMException(t.DOMException.INVALID_STATE_ERR);if(/[\u0100-\uffff]/.test(r)||n.utf8_encode(r)!==r)throw new t.DOMException(t.DOMException.SYNTAX_ERR);return r=e.trim(r).toLowerCase(),~e.inArray(r,a)||/^(proxy\-|sec\-)/.test(r)?!1:(S[r]?S[r]+=", "+o:S[r]=o,!0)},hasRequestHeader:function(e){return e&&S[e.toLowerCase()]||!1},getAllResponseHeaders:function(){return U||""},getResponseHeader:function(t){return t=t.toLowerCase(),F||~e.inArray(t,["set-cookie","set-cookie2"])?null:U&&""!==U&&(R||(R={},e.each(U.split(/\r\n/),function(t){var i=t.split(/:\s+/);2===i.length&&(i[0]=e.trim(i[0]),R[i[0].toLowerCase()]={header:i[0],value:e.trim(i[1])})})),R.hasOwnProperty(t))?R[t].header+": "+R[t].value:null},overrideMimeType:function(n){var r,o;if(~e.inArray(i("readyState"),[h.LOADING,h.DONE]))throw new t.DOMException(t.DOMException.INVALID_STATE_ERR);if(n=e.trim(n.toLowerCase()),/;/.test(n)&&(r=n.match(/^([^;]+)(?:;\scharset\=)?(.*)$/))&&(n=r[1],r[2]&&(o=r[2])),!d.mimes[n])throw new t.DOMException(t.DOMException.SYNTAX_ERR);P=n,H=o},send:function(i,r){if(k="string"===e.typeOf(r)?{ruid:r}:r?r:{},this.readyState!==h.OPENED||C)throw new t.DOMException(t.DOMException.INVALID_STATE_ERR);if(i instanceof s)k.ruid=i.ruid,D=i.type||"application/octet-stream";else if(i instanceof c){if(i.hasBlob()){var o=i.getBlob();k.ruid=o.ruid,D=o.type||"application/octet-stream"}}else"string"==typeof i&&(O="UTF-8",D="text/plain;charset=UTF-8",i=n.utf8_encode(i));this.withCredentials||(this.withCredentials=k.required_caps&&k.required_caps.send_browser_cookies&&!B),L=!N&&this.upload.hasEventListener(),F=!1,M=!i,N||(C=!0),u.call(this,i)},abort:function(){if(F=!0,N=!1,~e.inArray(i("readyState"),[h.UNSENT,h.OPENED,h.DONE]))i("readyState",h.UNSENT);else{if(i("readyState",h.DONE),C=!1,!_)throw new t.DOMException(t.DOMException.INVALID_STATE_ERR);_.getRuntime().exec.call(_,"XMLHttpRequest","abort",M),M=!0}},destroy:function(){_&&("function"===e.typeOf(_.destroy)&&_.destroy(),_=null),this.unbindAll(),this.upload&&(this.upload.unbindAll(),this.upload=null)}}),this.handleEventProps(p.concat(["readystatechange"])),this.upload.handleEventProps(p)}var f={100:"Continue",101:"Switching Protocols",102:"Processing",200:"OK",201:"Created",202:"Accepted",203:"Non-Authoritative Information",204:"No Content",205:"Reset Content",206:"Partial Content",207:"Multi-Status",226:"IM Used",300:"Multiple Choices",301:"Moved Permanently",302:"Found",303:"See Other",304:"Not Modified",305:"Use Proxy",306:"Reserved",307:"Temporary Redirect",400:"Bad Request",401:"Unauthorized",402:"Payment Required",403:"Forbidden",404:"Not Found",405:"Method Not Allowed",406:"Not Acceptable",407:"Proxy Authentication Required",408:"Request Timeout",409:"Conflict",410:"Gone",411:"Length Required",412:"Precondition Failed",413:"Request Entity Too Large",414:"Request-URI Too Long",415:"Unsupported Media Type",416:"Requested Range Not Satisfiable",417:"Expectation Failed",422:"Unprocessable Entity",423:"Locked",424:"Failed Dependency",426:"Upgrade Required",500:"Internal Server Error",501:"Not Implemented",502:"Bad Gateway",503:"Service Unavailable",504:"Gateway Timeout",505:"HTTP Version Not Supported",506:"Variant Also Negotiates",507:"Insufficient Storage",510:"Not Extended"};m.prototype=i.instance;var p=["loadstart","progress","abort","error","load","timeout","loadend"];return h.UNSENT=0,h.OPENED=1,h.HEADERS_RECEIVED=2,h.LOADING=3,h.DONE=4,h.prototype=i.instance,h}),n("moxie/runtime/Transporter",["moxie/core/utils/Basic","moxie/core/utils/Encode","moxie/runtime/RuntimeClient","moxie/core/EventTarget"],function(e,t,i,n){function r(){function n(){l=d=0,c=this.result=null}function o(t,i){var n=this;u=i,n.bind("TransportingProgress",function(t){d=t.loaded,l>d&&-1===e.inArray(n.state,[r.IDLE,r.DONE])&&a.call(n)},999),n.bind("TransportingComplete",function(){d=l,n.state=r.DONE,c=null,n.result=u.exec.call(n,"Transporter","getAsBlob",t||"")},999),n.state=r.BUSY,n.trigger("TransportingStarted"),a.call(n)}function a(){var e,i=this,n=l-d;m>n&&(m=n),e=t.btoa(c.substr(d,m)),u.exec.call(i,"Transporter","receive",e,l)}var s,u,c,l,d,m;i.call(this),e.extend(this,{uid:e.guid("uid_"),state:r.IDLE,result:null,transport:function(t,i,r){var a=this;if(r=e.extend({chunk_size:204798},r),(s=r.chunk_size%3)&&(r.chunk_size+=3-s),m=r.chunk_size,n.call(this),c=t,l=t.length,"string"===e.typeOf(r)||r.ruid)o.call(a,i,this.connectRuntime(r));else{var u=function(e,t){a.unbind("RuntimeInit",u),o.call(a,i,t)};this.bind("RuntimeInit",u),this.connectRuntime(r)}},abort:function(){var e=this;e.state=r.IDLE,u&&(u.exec.call(e,"Transporter","clear"),e.trigger("TransportingAborted")),n.call(e)},destroy:function(){this.unbindAll(),u=null,this.disconnectRuntime(),n.call(this)}})}return r.IDLE=0,r.BUSY=1,r.DONE=2,r.prototype=n.instance,r}),n("moxie/image/Image",["moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/Exceptions","moxie/file/FileReaderSync","moxie/xhr/XMLHttpRequest","moxie/runtime/Runtime","moxie/runtime/RuntimeClient","moxie/runtime/Transporter","moxie/core/utils/Env","moxie/core/EventTarget","moxie/file/Blob","moxie/file/File","moxie/core/utils/Encode"],function(e,t,i,n,r,o,a,s,u,c,l,d,m){function h(){function n(e){try{return e||(e=this.exec("Image","getInfo")),this.size=e.size,this.width=e.width,this.height=e.height,this.type=e.type,this.meta=e.meta,""===this.name&&(this.name=e.name),!0}catch(t){return this.trigger("error",t.code),!1}}function c(t){var n=e.typeOf(t);try{if(t instanceof h){if(!t.size)throw new i.DOMException(i.DOMException.INVALID_STATE_ERR);p.apply(this,arguments)}else if(t instanceof l){if(!~e.inArray(t.type,["image/jpeg","image/png"]))throw new i.ImageError(i.ImageError.WRONG_FORMAT);g.apply(this,arguments)}else if(-1!==e.inArray(n,["blob","file"]))c.call(this,new d(null,t),arguments[1]);else if("string"===n)"data:"===t.substr(0,5)?c.call(this,new l(null,{data:t}),arguments[1]):x.apply(this,arguments);else{if("node"!==n||"img"!==t.nodeName.toLowerCase())throw new i.DOMException(i.DOMException.TYPE_MISMATCH_ERR);c.call(this,t.src,arguments[1])}}catch(r){this.trigger("error",r.code)}}function p(t,i){var n=this.connectRuntime(t.ruid);this.ruid=n.uid,n.exec.call(this,"Image","loadFromImage",t,"undefined"===e.typeOf(i)?!0:i)}function g(t,i){function n(e){r.ruid=e.uid,e.exec.call(r,"Image","loadFromBlob",t)}var r=this;r.name=t.name||"",t.isDetached()?(this.bind("RuntimeInit",function(e,t){n(t)}),i&&"string"==typeof i.required_caps&&(i.required_caps=o.parseCaps(i.required_caps)),this.connectRuntime(e.extend({required_caps:{access_image_binary:!0,resize_image:!0}},i))):n(this.connectRuntime(t.ruid))}function x(e,t){var i,n=this;i=new r,i.open("get",e),i.responseType="blob",i.onprogress=function(e){n.trigger(e)},i.onload=function(){g.call(n,i.response,!0)},i.onerror=function(e){n.trigger(e)},i.onloadend=function(){i.destroy()},i.bind("RuntimeError",function(e,t){n.trigger("RuntimeError",t)}),i.send(null,t)}a.call(this),e.extend(this,{uid:e.guid("uid_"),ruid:null,name:"",size:0,width:0,height:0,type:"",meta:{},clone:function(){this.load.apply(this,arguments)},load:function(){c.apply(this,arguments)},resize:function(t){var n,r,o=this,a={x:0,y:0,width:o.width,height:o.height},s=e.extendIf({width:o.width,height:o.height,type:o.type||"image/jpeg",quality:90,crop:!1,fit:!0,preserveHeaders:!0,resample:"default",multipass:!0},t);try{if(!o.size)throw new i.DOMException(i.DOMException.INVALID_STATE_ERR);if(o.width>h.MAX_RESIZE_WIDTH||o.height>h.MAX_RESIZE_HEIGHT)throw new i.ImageError(i.ImageError.MAX_RESOLUTION_ERR);if(n=o.meta&&o.meta.tiff&&o.meta.tiff.Orientation||1,-1!==e.inArray(n,[5,6,7,8])){var u=s.width;s.width=s.height,s.height=u}if(s.crop){switch(r=Math.max(s.width/o.width,s.height/o.height),t.fit?(a.width=Math.min(Math.ceil(s.width/r),o.width),a.height=Math.min(Math.ceil(s.height/r),o.height),r=s.width/a.width):(a.width=Math.min(s.width,o.width),a.height=Math.min(s.height,o.height),r=1),"boolean"==typeof s.crop&&(s.crop="cc"),s.crop.toLowerCase().replace(/_/,"-")){case"rb":case"right-bottom":a.x=o.width-a.width,a.y=o.height-a.height;break;case"cb":case"center-bottom":a.x=Math.floor((o.width-a.width)/2),a.y=o.height-a.height;break;case"lb":case"left-bottom":a.x=0,a.y=o.height-a.height;break;case"lt":case"left-top":a.x=0,a.y=0;break;case"ct":case"center-top":a.x=Math.floor((o.width-a.width)/2),a.y=0;break;case"rt":case"right-top":a.x=o.width-a.width,a.y=0;break;case"rc":case"right-center":case"right-middle":a.x=o.width-a.width,a.y=Math.floor((o.height-a.height)/2);break;case"lc":case"left-center":case"left-middle":a.x=0,a.y=Math.floor((o.height-a.height)/2);break;case"cc":case"center-center":case"center-middle":default:a.x=Math.floor((o.width-a.width)/2),a.y=Math.floor((o.height-a.height)/2)}a.x=Math.max(a.x,0),a.y=Math.max(a.y,0)}else r=Math.min(s.width/o.width,s.height/o.height),r>1&&!s.fit&&(r=1);this.exec("Image","resize",a,r,s)}catch(c){o.trigger("error",c.code)}},downsize:function(t){var i,n={width:this.width,height:this.height,type:this.type||"image/jpeg",quality:90,crop:!1,fit:!1,preserveHeaders:!0,resample:"default"};i="object"==typeof t?e.extend(n,t):e.extend(n,{width:arguments[0],height:arguments[1],crop:arguments[2],preserveHeaders:arguments[3]}),this.resize(i)},crop:function(e,t,i){this.downsize(e,t,!0,i)},getAsCanvas:function(){if(!u.can("create_canvas"))throw new i.RuntimeError(i.RuntimeError.NOT_SUPPORTED_ERR);return this.exec("Image","getAsCanvas")},getAsBlob:function(e,t){if(!this.size)throw new i.DOMException(i.DOMException.INVALID_STATE_ERR);return this.exec("Image","getAsBlob",e||"image/jpeg",t||90)},getAsDataURL:function(e,t){if(!this.size)throw new i.DOMException(i.DOMException.INVALID_STATE_ERR);return this.exec("Image","getAsDataURL",e||"image/jpeg",t||90)},getAsBinaryString:function(e,t){var i=this.getAsDataURL(e,t);return m.atob(i.substring(i.indexOf("base64,")+7))},embed:function(n,r){function o(t,r){var o=this;if(u.can("create_canvas")){var l=o.getAsCanvas();if(l)return n.appendChild(l),l=null,o.destroy(),c.trigger("embedded"),void 0}var d=o.getAsDataURL(t,r);if(!d)throw new i.ImageError(i.ImageError.WRONG_FORMAT);if(u.can("use_data_uri_of",d.length))n.innerHTML='<img src="'+d+'" width="'+o.width+'" height="'+o.height+'" alt="" />',o.destroy(),c.trigger("embedded");else{var h=new s;h.bind("TransportingComplete",function(){a=c.connectRuntime(this.result.ruid),c.bind("Embedded",function(){e.extend(a.getShimContainer().style,{top:"0px",left:"0px",width:o.width+"px",height:o.height+"px"}),a=null},999),a.exec.call(c,"ImageView","display",this.result.uid,width,height),o.destroy()}),h.transport(m.atob(d.substring(d.indexOf("base64,")+7)),t,{required_caps:{display_media:!0},runtime_order:"flash,silverlight",container:n})}}var a,c=this,l=e.extend({width:this.width,height:this.height,type:this.type||"image/jpeg",quality:90,fit:!0,resample:"nearest"},r);try{if(!(n=t.get(n)))throw new i.DOMException(i.DOMException.INVALID_NODE_TYPE_ERR);if(!this.size)throw new i.DOMException(i.DOMException.INVALID_STATE_ERR);this.width>h.MAX_RESIZE_WIDTH||this.height>h.MAX_RESIZE_HEIGHT;var d=new h;return d.bind("Resize",function(){o.call(this,l.type,l.quality)}),d.bind("Load",function(){this.downsize(l)}),this.meta.thumb&&this.meta.thumb.width>=l.width&&this.meta.thumb.height>=l.height?d.load(this.meta.thumb.data):d.clone(this,!1),d}catch(f){this.trigger("error",f.code)}},destroy:function(){this.ruid&&(this.getRuntime().exec.call(this,"Image","destroy"),this.disconnectRuntime()),this.meta&&this.meta.thumb&&this.meta.thumb.data.destroy(),this.unbindAll()}}),this.handleEventProps(f),this.bind("Load Resize",function(){return n.call(this)},999)}var f=["progress","load","error","resize","embedded"];return h.MAX_RESIZE_WIDTH=8192,h.MAX_RESIZE_HEIGHT=8192,h.prototype=c.instance,h}),n("moxie/runtime/html5/Runtime",["moxie/core/utils/Basic","moxie/core/Exceptions","moxie/runtime/Runtime","moxie/core/utils/Env"],function(e,t,i,n){function o(t){var o=this,u=i.capTest,c=i.capTrue,l=e.extend({access_binary:u(window.FileReader||window.File&&window.File.getAsDataURL),access_image_binary:function(){return o.can("access_binary")&&!!s.Image},display_media:u((n.can("create_canvas")||n.can("use_data_uri_over32kb"))&&r("moxie/image/Image")),do_cors:u(window.XMLHttpRequest&&"withCredentials"in new XMLHttpRequest),drag_and_drop:u(function(){var e=document.createElement("div");return("draggable"in e||"ondragstart"in e&&"ondrop"in e)&&("IE"!==n.browser||n.verComp(n.version,9,">"))}()),filter_by_extension:u(function(){return!("Chrome"===n.browser&&n.verComp(n.version,28,"<")||"IE"===n.browser&&n.verComp(n.version,10,"<")||"Safari"===n.browser&&n.verComp(n.version,7,"<")||"Firefox"===n.browser&&n.verComp(n.version,37,"<"))}()),return_response_headers:c,return_response_type:function(e){return"json"===e&&window.JSON?!0:n.can("return_response_type",e)},return_status_code:c,report_upload_progress:u(window.XMLHttpRequest&&(new XMLHttpRequest).upload),resize_image:function(){return o.can("access_binary")&&n.can("create_canvas")},select_file:function(){return n.can("use_fileinput")&&window.File},select_folder:function(){return o.can("select_file")&&("Chrome"===n.browser&&n.verComp(n.version,21,">=")||"Firefox"===n.browser&&n.verComp(n.version,42,">="))},select_multiple:function(){return!(!o.can("select_file")||"Safari"===n.browser&&"Windows"===n.os||"iOS"===n.os&&n.verComp(n.osVersion,"7.0.0",">")&&n.verComp(n.osVersion,"8.0.0","<"))},send_binary_string:u(window.XMLHttpRequest&&((new XMLHttpRequest).sendAsBinary||window.Uint8Array&&window.ArrayBuffer)),send_custom_headers:u(window.XMLHttpRequest),send_multipart:function(){return!!(window.XMLHttpRequest&&(new XMLHttpRequest).upload&&window.FormData)||o.can("send_binary_string")},slice_blob:u(window.File&&(File.prototype.mozSlice||File.prototype.webkitSlice||File.prototype.slice)),stream_upload:function(){return o.can("slice_blob")&&o.can("send_multipart")},summon_file_dialog:function(){return o.can("select_file")&&!("Firefox"===n.browser&&n.verComp(n.version,4,"<")||"Opera"===n.browser&&n.verComp(n.version,12,"<")||"IE"===n.browser&&n.verComp(n.version,10,"<"))},upload_filesize:c,use_http_method:c},arguments[2]);i.call(this,t,arguments[1]||a,l),e.extend(this,{init:function(){this.trigger("Init")},destroy:function(e){return function(){e.call(o),e=o=null}}(this.destroy)}),e.extend(this.getShim(),s)}var a="html5",s={};return i.addConstructor(a,o),s}),n("moxie/runtime/html5/file/Blob",["moxie/runtime/html5/Runtime","moxie/file/Blob"],function(e,t){function i(){function e(e,t,i){var n;if(!window.File.prototype.slice)return(n=window.File.prototype.webkitSlice||window.File.prototype.mozSlice)?n.call(e,t,i):null;try{return e.slice(),e.slice(t,i)}catch(r){return e.slice(t,i-t)}}this.slice=function(){return new t(this.getRuntime().uid,e.apply(this,arguments))},this.destroy=function(){this.getRuntime().getShim().removeInstance(this.uid)}}return e.Blob=i}),n("moxie/core/utils/Events",["moxie/core/utils/Basic"],function(e){function t(){this.returnValue=!1}function i(){this.cancelBubble=!0}var n={},r="moxie_"+e.guid(),o=function(o,a,s,u){var c,l;a=a.toLowerCase(),o.addEventListener?(c=s,o.addEventListener(a,c,!1)):o.attachEvent&&(c=function(){var e=window.event;e.target||(e.target=e.srcElement),e.preventDefault=t,e.stopPropagation=i,s(e)},o.attachEvent("on"+a,c)),o[r]||(o[r]=e.guid()),n.hasOwnProperty(o[r])||(n[o[r]]={}),l=n[o[r]],l.hasOwnProperty(a)||(l[a]=[]),l[a].push({func:c,orig:s,key:u})},a=function(t,i,o){var a,s;if(i=i.toLowerCase(),t[r]&&n[t[r]]&&n[t[r]][i]){a=n[t[r]][i];for(var u=a.length-1;u>=0&&(a[u].orig!==o&&a[u].key!==o||(t.removeEventListener?t.removeEventListener(i,a[u].func,!1):t.detachEvent&&t.detachEvent("on"+i,a[u].func),a[u].orig=null,a[u].func=null,a.splice(u,1),o===s));u--);if(a.length||delete n[t[r]][i],e.isEmptyObj(n[t[r]])){delete n[t[r]];try{delete t[r]}catch(c){t[r]=s}}}},s=function(t,i){t&&t[r]&&e.each(n[t[r]],function(e,n){a(t,n,i)})};return{addEvent:o,removeEvent:a,removeAllEvents:s}}),n("moxie/runtime/html5/file/FileInput",["moxie/runtime/html5/Runtime","moxie/file/File","moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/utils/Events","moxie/core/utils/Mime","moxie/core/utils/Env"],function(e,t,i,n,r,o,a){function s(){var e,s;i.extend(this,{init:function(u){var c,l,d,m,h,f,p=this,g=p.getRuntime();e=u,d=o.extList2mimes(e.accept,g.can("filter_by_extension")),l=g.getShimContainer(),l.innerHTML='<input id="'+g.uid+'" type="file" style="font-size:999px;opacity:0;"'+(e.multiple&&g.can("select_multiple")?"multiple":"")+(e.directory&&g.can("select_folder")?"webkitdirectory directory":"")+(d?' accept="'+d.join(",")+'"':"")+" />",c=n.get(g.uid),i.extend(c.style,{position:"absolute",top:0,left:0,width:"100%",height:"100%"}),m=n.get(e.browse_button),s=n.getStyle(m,"z-index")||"auto",g.can("summon_file_dialog")&&("static"===n.getStyle(m,"position")&&(m.style.position="relative"),r.addEvent(m,"click",function(e){var t=n.get(g.uid);t&&!t.disabled&&t.click(),e.preventDefault()},p.uid),p.bind("Refresh",function(){h=parseInt(s,10)||1,n.get(e.browse_button).style.zIndex=h,this.getRuntime().getShimContainer().style.zIndex=h-1})),f=g.can("summon_file_dialog")?m:l,r.addEvent(f,"mouseover",function(){p.trigger("mouseenter")},p.uid),r.addEvent(f,"mouseout",function(){p.trigger("mouseleave")},p.uid),r.addEvent(f,"mousedown",function(){p.trigger("mousedown")},p.uid),r.addEvent(n.get(e.container),"mouseup",function(){p.trigger("mouseup")},p.uid),(g.can("summon_file_dialog")?c:m).setAttribute("tabindex",-1),c.onchange=function x(){if(p.files=[],i.each(this.files,function(i){var n="";return e.directory&&"."==i.name?!0:(i.webkitRelativePath&&(n="/"+i.webkitRelativePath.replace(/^\//,"")),i=new t(g.uid,i),i.relativePath=n,p.files.push(i),void 0)}),"IE"!==a.browser&&"IEMobile"!==a.browser)this.value="";else{var n=this.cloneNode(!0);this.parentNode.replaceChild(n,this),n.onchange=x}p.files.length&&p.trigger("change")},p.trigger({type:"ready",async:!0}),l=null},setOption:function(e,t){var i=this.getRuntime(),r=n.get(i.uid);switch(e){case"accept":if(t){var a=t.mimes||o.extList2mimes(t,i.can("filter_by_extension"));r.setAttribute("accept",a.join(","))}else r.removeAttribute("accept");break;case"directory":t&&i.can("select_folder")?(r.setAttribute("directory",""),r.setAttribute("webkitdirectory","")):(r.removeAttribute("directory"),r.removeAttribute("webkitdirectory"));break;case"multiple":t&&i.can("select_multiple")?r.setAttribute("multiple",""):r.removeAttribute("multiple")}},disable:function(e){var t,i=this.getRuntime();(t=n.get(i.uid))&&(t.disabled=!!e)},destroy:function(){var t=this.getRuntime(),i=t.getShim(),o=t.getShimContainer(),a=e&&n.get(e.container),u=e&&n.get(e.browse_button);a&&r.removeAllEvents(a,this.uid),u&&(r.removeAllEvents(u,this.uid),u.style.zIndex=s),o&&(r.removeAllEvents(o,this.uid),o.innerHTML=""),i.removeInstance(this.uid),e=o=a=u=i=null}})}return e.FileInput=s}),n("moxie/runtime/html5/file/FileDrop",["moxie/runtime/html5/Runtime","moxie/file/File","moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/utils/Events","moxie/core/utils/Mime"],function(e,t,i,n,r,o){function a(){function e(e){if(!e.dataTransfer||!e.dataTransfer.types)return!1;var t=i.toArray(e.dataTransfer.types||[]);return-1!==i.inArray("Files",t)||-1!==i.inArray("public.file-url",t)||-1!==i.inArray("application/x-moz-file",t)}function a(e,i){if(u(e)){var n=new t(f,e);n.relativePath=i||"",p.push(n)}}function s(e){for(var t=[],n=0;n<e.length;n++)[].push.apply(t,e[n].extensions.split(/\s*,\s*/));return-1===i.inArray("*",t)?t:[]}function u(e){if(!g.length)return!0;var t=o.getFileExtension(e.name);return!t||-1!==i.inArray(t,g)}function c(e,t){var n=[];i.each(e,function(e){var t=e.webkitGetAsEntry();t&&(t.isFile?a(e.getAsFile(),t.fullPath):n.push(t))}),n.length?l(n,t):t()}function l(e,t){var n=[];i.each(e,function(e){n.push(function(t){d(e,t)})}),i.inSeries(n,function(){t()})}function d(e,t){e.isFile?e.file(function(i){a(i,e.fullPath),t()},function(){t()}):e.isDirectory?m(e,t):t()}function m(e,t){function i(e){r.readEntries(function(t){t.length?([].push.apply(n,t),i(e)):e()},e)}var n=[],r=e.createReader();i(function(){l(n,t)})}var h,f,p=[],g=[];i.extend(this,{init:function(t){var n,o=this;h=t,f=o.ruid,g=s(h.accept),n=h.container,r.addEvent(n,"dragover",function(t){e(t)&&(t.preventDefault(),t.dataTransfer.dropEffect="copy")},o.uid),r.addEvent(n,"drop",function(t){e(t)&&(t.preventDefault(),p=[],t.dataTransfer.items&&t.dataTransfer.items[0].webkitGetAsEntry?c(t.dataTransfer.items,function(){o.files=p,o.trigger("drop")}):(i.each(t.dataTransfer.files,function(e){a(e)}),o.files=p,o.trigger("drop")))},o.uid),r.addEvent(n,"dragenter",function(){o.trigger("dragenter")},o.uid),r.addEvent(n,"dragleave",function(){o.trigger("dragleave")},o.uid)},destroy:function(){r.removeAllEvents(h&&n.get(h.container),this.uid),f=p=g=h=null,this.getRuntime().getShim().removeInstance(this.uid)}})}return e.FileDrop=a}),n("moxie/runtime/html5/file/FileReader",["moxie/runtime/html5/Runtime","moxie/core/utils/Encode","moxie/core/utils/Basic"],function(e,t,i){function n(){function e(e){return t.atob(e.substring(e.indexOf("base64,")+7))}var n,r=!1;i.extend(this,{read:function(t,o){var a=this;a.result="",n=new window.FileReader,n.addEventListener("progress",function(e){a.trigger(e)}),n.addEventListener("load",function(t){a.result=r?e(n.result):n.result,a.trigger(t)}),n.addEventListener("error",function(e){a.trigger(e,n.error)}),n.addEventListener("loadend",function(e){n=null,a.trigger(e)}),"function"===i.typeOf(n[t])?(r=!1,n[t](o.getSource())):"readAsBinaryString"===t&&(r=!0,n.readAsDataURL(o.getSource()))},abort:function(){n&&n.abort()},destroy:function(){n=null,this.getRuntime().getShim().removeInstance(this.uid)}})}return e.FileReader=n}),n("moxie/runtime/html5/xhr/XMLHttpRequest",["moxie/runtime/html5/Runtime","moxie/core/utils/Basic","moxie/core/utils/Mime","moxie/core/utils/Url","moxie/file/File","moxie/file/Blob","moxie/xhr/FormData","moxie/core/Exceptions","moxie/core/utils/Env"],function(e,t,i,n,r,o,a,s,u){function c(){function e(e,t){var i,n,r=this;i=t.getBlob().getSource(),n=new window.FileReader,n.onload=function(){t.append(t.getBlobName(),new o(null,{type:i.type,data:n.result})),f.send.call(r,e,t)},n.readAsBinaryString(i)}function c(){return!window.XMLHttpRequest||"IE"===u.browser&&u.verComp(u.version,8,"<")?function(){for(var e=["Msxml2.XMLHTTP.6.0","Microsoft.XMLHTTP"],t=0;t<e.length;t++)try{return new ActiveXObject(e[t])}catch(i){}}():new window.XMLHttpRequest}function l(e){var t=e.responseXML,i=e.responseText;return"IE"===u.browser&&i&&t&&!t.documentElement&&/[^\/]+\/[^\+]+\+xml/.test(e.getResponseHeader("Content-Type"))&&(t=new window.ActiveXObject("Microsoft.XMLDOM"),t.async=!1,t.validateOnParse=!1,t.loadXML(i)),t&&("IE"===u.browser&&0!==t.parseError||!t.documentElement||"parsererror"===t.documentElement.tagName)?null:t
}function d(e){var t="----moxieboundary"+(new Date).getTime(),i="--",n="\r\n",r="",a=this.getRuntime();if(!a.can("send_binary_string"))throw new s.RuntimeError(s.RuntimeError.NOT_SUPPORTED_ERR);return m.setRequestHeader("Content-Type","multipart/form-data; boundary="+t),e.each(function(e,a){r+=e instanceof o?i+t+n+'Content-Disposition: form-data; name="'+a+'"; filename="'+unescape(encodeURIComponent(e.name||"blob"))+'"'+n+"Content-Type: "+(e.type||"application/octet-stream")+n+n+e.getSource()+n:i+t+n+'Content-Disposition: form-data; name="'+a+'"'+n+n+unescape(encodeURIComponent(e))+n}),r+=i+t+i+n}var m,h,f=this;t.extend(this,{send:function(i,r){var s=this,l="Mozilla"===u.browser&&u.verComp(u.version,4,">=")&&u.verComp(u.version,7,"<"),f="Android Browser"===u.browser,p=!1;if(h=i.url.replace(/^.+?\/([\w\-\.]+)$/,"$1").toLowerCase(),m=c(),m.open(i.method,i.url,i.async,i.user,i.password),r instanceof o)r.isDetached()&&(p=!0),r=r.getSource();else if(r instanceof a){if(r.hasBlob())if(r.getBlob().isDetached())r=d.call(s,r),p=!0;else if((l||f)&&"blob"===t.typeOf(r.getBlob().getSource())&&window.FileReader)return e.call(s,i,r),void 0;if(r instanceof a){var g=new window.FormData;r.each(function(e,t){e instanceof o?g.append(t,e.getSource()):g.append(t,e)}),r=g}}m.upload?(i.withCredentials&&(m.withCredentials=!0),m.addEventListener("load",function(e){s.trigger(e)}),m.addEventListener("error",function(e){s.trigger(e)}),m.addEventListener("progress",function(e){s.trigger(e)}),m.upload.addEventListener("progress",function(e){s.trigger({type:"UploadProgress",loaded:e.loaded,total:e.total})})):m.onreadystatechange=function(){switch(m.readyState){case 1:break;case 2:break;case 3:var e,t;try{n.hasSameOrigin(i.url)&&(e=m.getResponseHeader("Content-Length")||0),m.responseText&&(t=m.responseText.length)}catch(r){e=t=0}s.trigger({type:"progress",lengthComputable:!!e,total:parseInt(e,10),loaded:t});break;case 4:m.onreadystatechange=function(){};try{if(m.status>=200&&m.status<400){s.trigger("load");break}}catch(r){}s.trigger("error")}},t.isEmptyObj(i.headers)||t.each(i.headers,function(e,t){m.setRequestHeader(t,e)}),""!==i.responseType&&"responseType"in m&&(m.responseType="json"!==i.responseType||u.can("return_response_type","json")?i.responseType:"text"),p?m.sendAsBinary?m.sendAsBinary(r):function(){for(var e=new Uint8Array(r.length),t=0;t<r.length;t++)e[t]=255&r.charCodeAt(t);m.send(e.buffer)}():m.send(r),s.trigger("loadstart")},getStatus:function(){try{if(m)return m.status}catch(e){}return 0},getResponse:function(e){var t=this.getRuntime();try{switch(e){case"blob":var n=new r(t.uid,m.response),o=m.getResponseHeader("Content-Disposition");if(o){var a=o.match(/filename=([\'\"'])([^\1]+)\1/);a&&(h=a[2])}return n.name=h,n.type||(n.type=i.getFileMime(h)),n;case"json":return u.can("return_response_type","json")?m.response:200===m.status&&window.JSON?JSON.parse(m.responseText):null;case"document":return l(m);default:return""!==m.responseText?m.responseText:null}}catch(s){return null}},getAllResponseHeaders:function(){try{return m.getAllResponseHeaders()}catch(e){}return""},abort:function(){m&&m.abort()},destroy:function(){f=h=null,this.getRuntime().getShim().removeInstance(this.uid)}})}return e.XMLHttpRequest=c}),n("moxie/runtime/html5/utils/BinaryReader",["moxie/core/utils/Basic"],function(e){function t(e){e instanceof ArrayBuffer?i.apply(this,arguments):n.apply(this,arguments)}function i(t){var i=new DataView(t);e.extend(this,{readByteAt:function(e){return i.getUint8(e)},writeByteAt:function(e,t){i.setUint8(e,t)},SEGMENT:function(e,n,r){switch(arguments.length){case 2:return t.slice(e,e+n);case 1:return t.slice(e);case 3:if(null===r&&(r=new ArrayBuffer),r instanceof ArrayBuffer){var o=new Uint8Array(this.length()-n+r.byteLength);e>0&&o.set(new Uint8Array(t.slice(0,e)),0),o.set(new Uint8Array(r),e),o.set(new Uint8Array(t.slice(e+n)),e+r.byteLength),this.clear(),t=o.buffer,i=new DataView(t);break}default:return t}},length:function(){return t?t.byteLength:0},clear:function(){i=t=null}})}function n(t){function i(e,i,n){n=3===arguments.length?n:t.length-i-1,t=t.substr(0,i)+e+t.substr(n+i)}e.extend(this,{readByteAt:function(e){return t.charCodeAt(e)},writeByteAt:function(e,t){i(String.fromCharCode(t),e,1)},SEGMENT:function(e,n,r){switch(arguments.length){case 1:return t.substr(e);case 2:return t.substr(e,n);case 3:i(null!==r?r:"",e,n);break;default:return t}},length:function(){return t?t.length:0},clear:function(){t=null}})}return e.extend(t.prototype,{littleEndian:!1,read:function(e,t){var i,n,r;if(e+t>this.length())throw new Error("You are trying to read outside the source boundaries.");for(n=this.littleEndian?0:-8*(t-1),r=0,i=0;t>r;r++)i|=this.readByteAt(e+r)<<Math.abs(n+8*r);return i},write:function(e,t,i){var n,r;if(e>this.length())throw new Error("You are trying to write outside the source boundaries.");for(n=this.littleEndian?0:-8*(i-1),r=0;i>r;r++)this.writeByteAt(e+r,255&t>>Math.abs(n+8*r))},BYTE:function(e){return this.read(e,1)},SHORT:function(e){return this.read(e,2)},LONG:function(e){return this.read(e,4)},SLONG:function(e){var t=this.read(e,4);return t>2147483647?t-4294967296:t},CHAR:function(e){return String.fromCharCode(this.read(e,1))},STRING:function(e,t){return this.asArray("CHAR",e,t).join("")},asArray:function(e,t,i){for(var n=[],r=0;i>r;r++)n[r]=this[e](t+r);return n}}),t}),n("moxie/runtime/html5/image/JPEGHeaders",["moxie/runtime/html5/utils/BinaryReader","moxie/core/Exceptions"],function(e,t){return function i(n){var r,o,a,s=[],u=0;if(r=new e(n),65496!==r.SHORT(0))throw r.clear(),new t.ImageError(t.ImageError.WRONG_FORMAT);for(o=2;o<=r.length();)if(a=r.SHORT(o),a>=65488&&65495>=a)o+=2;else{if(65498===a||65497===a)break;u=r.SHORT(o+2)+2,a>=65505&&65519>=a&&s.push({hex:a,name:"APP"+(15&a),start:o,length:u,segment:r.SEGMENT(o,u)}),o+=u}return r.clear(),{headers:s,restore:function(t){var i,n,r;for(r=new e(t),o=65504==r.SHORT(2)?4+r.SHORT(4):2,n=0,i=s.length;i>n;n++)r.SEGMENT(o,0,s[n].segment),o+=s[n].length;return t=r.SEGMENT(),r.clear(),t},strip:function(t){var n,r,o,a;for(o=new i(t),r=o.headers,o.purge(),n=new e(t),a=r.length;a--;)n.SEGMENT(r[a].start,r[a].length,"");return t=n.SEGMENT(),n.clear(),t},get:function(e){for(var t=[],i=0,n=s.length;n>i;i++)s[i].name===e.toUpperCase()&&t.push(s[i].segment);return t},set:function(e,t){var i,n,r,o=[];for("string"==typeof t?o.push(t):o=t,i=n=0,r=s.length;r>i&&(s[i].name===e.toUpperCase()&&(s[i].segment=o[n],s[i].length=o[n].length,n++),!(n>=o.length));i++);},purge:function(){this.headers=s=[]}}}}),n("moxie/runtime/html5/image/ExifParser",["moxie/core/utils/Basic","moxie/runtime/html5/utils/BinaryReader","moxie/core/Exceptions"],function(e,i,n){function r(o){function a(i,r){var o,a,s,u,c,m,h,f,p=this,g=[],x={},v={1:"BYTE",7:"UNDEFINED",2:"ASCII",3:"SHORT",4:"LONG",5:"RATIONAL",9:"SLONG",10:"SRATIONAL"},w={BYTE:1,UNDEFINED:1,ASCII:1,SHORT:2,LONG:4,RATIONAL:8,SLONG:4,SRATIONAL:8};for(o=p.SHORT(i),a=0;o>a;a++)if(g=[],h=i+2+12*a,s=r[p.SHORT(h)],s!==t){if(u=v[p.SHORT(h+=2)],c=p.LONG(h+=2),m=w[u],!m)throw new n.ImageError(n.ImageError.INVALID_META_ERR);if(h+=4,m*c>4&&(h=p.LONG(h)+d.tiffHeader),h+m*c>=this.length())throw new n.ImageError(n.ImageError.INVALID_META_ERR);"ASCII"!==u?(g=p.asArray(u,h,c),f=1==c?g[0]:g,x[s]=l.hasOwnProperty(s)&&"object"!=typeof f?l[s][f]:f):x[s]=e.trim(p.STRING(h,c).replace(/\0$/,""))}return x}function s(e,t,i){var n,r,o,a=0;if("string"==typeof t){var s=c[e.toLowerCase()];for(var u in s)if(s[u]===t){t=u;break}}n=d[e.toLowerCase()+"IFD"],r=this.SHORT(n);for(var l=0;r>l;l++)if(o=n+12*l+2,this.SHORT(o)==t){a=o+8;break}if(!a)return!1;try{this.write(a,i,4)}catch(m){return!1}return!0}var u,c,l,d,m,h;if(i.call(this,o),c={tiff:{274:"Orientation",270:"ImageDescription",271:"Make",272:"Model",305:"Software",34665:"ExifIFDPointer",34853:"GPSInfoIFDPointer"},exif:{36864:"ExifVersion",40961:"ColorSpace",40962:"PixelXDimension",40963:"PixelYDimension",36867:"DateTimeOriginal",33434:"ExposureTime",33437:"FNumber",34855:"ISOSpeedRatings",37377:"ShutterSpeedValue",37378:"ApertureValue",37383:"MeteringMode",37384:"LightSource",37385:"Flash",37386:"FocalLength",41986:"ExposureMode",41987:"WhiteBalance",41990:"SceneCaptureType",41988:"DigitalZoomRatio",41992:"Contrast",41993:"Saturation",41994:"Sharpness"},gps:{0:"GPSVersionID",1:"GPSLatitudeRef",2:"GPSLatitude",3:"GPSLongitudeRef",4:"GPSLongitude"},thumb:{513:"JPEGInterchangeFormat",514:"JPEGInterchangeFormatLength"}},l={ColorSpace:{1:"sRGB",0:"Uncalibrated"},MeteringMode:{0:"Unknown",1:"Average",2:"CenterWeightedAverage",3:"Spot",4:"MultiSpot",5:"Pattern",6:"Partial",255:"Other"},LightSource:{1:"Daylight",2:"Fliorescent",3:"Tungsten",4:"Flash",9:"Fine weather",10:"Cloudy weather",11:"Shade",12:"Daylight fluorescent (D 5700 - 7100K)",13:"Day white fluorescent (N 4600 -5400K)",14:"Cool white fluorescent (W 3900 - 4500K)",15:"White fluorescent (WW 3200 - 3700K)",17:"Standard light A",18:"Standard light B",19:"Standard light C",20:"D55",21:"D65",22:"D75",23:"D50",24:"ISO studio tungsten",255:"Other"},Flash:{0:"Flash did not fire",1:"Flash fired",5:"Strobe return light not detected",7:"Strobe return light detected",9:"Flash fired, compulsory flash mode",13:"Flash fired, compulsory flash mode, return light not detected",15:"Flash fired, compulsory flash mode, return light detected",16:"Flash did not fire, compulsory flash mode",24:"Flash did not fire, auto mode",25:"Flash fired, auto mode",29:"Flash fired, auto mode, return light not detected",31:"Flash fired, auto mode, return light detected",32:"No flash function",65:"Flash fired, red-eye reduction mode",69:"Flash fired, red-eye reduction mode, return light not detected",71:"Flash fired, red-eye reduction mode, return light detected",73:"Flash fired, compulsory flash mode, red-eye reduction mode",77:"Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",79:"Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",89:"Flash fired, auto mode, red-eye reduction mode",93:"Flash fired, auto mode, return light not detected, red-eye reduction mode",95:"Flash fired, auto mode, return light detected, red-eye reduction mode"},ExposureMode:{0:"Auto exposure",1:"Manual exposure",2:"Auto bracket"},WhiteBalance:{0:"Auto white balance",1:"Manual white balance"},SceneCaptureType:{0:"Standard",1:"Landscape",2:"Portrait",3:"Night scene"},Contrast:{0:"Normal",1:"Soft",2:"Hard"},Saturation:{0:"Normal",1:"Low saturation",2:"High saturation"},Sharpness:{0:"Normal",1:"Soft",2:"Hard"},GPSLatitudeRef:{N:"North latitude",S:"South latitude"},GPSLongitudeRef:{E:"East longitude",W:"West longitude"}},d={tiffHeader:10},m=d.tiffHeader,u={clear:this.clear},e.extend(this,{read:function(){try{return r.prototype.read.apply(this,arguments)}catch(e){throw new n.ImageError(n.ImageError.INVALID_META_ERR)}},write:function(){try{return r.prototype.write.apply(this,arguments)}catch(e){throw new n.ImageError(n.ImageError.INVALID_META_ERR)}},UNDEFINED:function(){return this.BYTE.apply(this,arguments)},RATIONAL:function(e){return this.LONG(e)/this.LONG(e+4)},SRATIONAL:function(e){return this.SLONG(e)/this.SLONG(e+4)},ASCII:function(e){return this.CHAR(e)},TIFF:function(){return h||null},EXIF:function(){var t=null;if(d.exifIFD){try{t=a.call(this,d.exifIFD,c.exif)}catch(i){return null}if(t.ExifVersion&&"array"===e.typeOf(t.ExifVersion)){for(var n=0,r="";n<t.ExifVersion.length;n++)r+=String.fromCharCode(t.ExifVersion[n]);t.ExifVersion=r}}return t},GPS:function(){var t=null;if(d.gpsIFD){try{t=a.call(this,d.gpsIFD,c.gps)}catch(i){return null}t.GPSVersionID&&"array"===e.typeOf(t.GPSVersionID)&&(t.GPSVersionID=t.GPSVersionID.join("."))}return t},thumb:function(){if(d.IFD1)try{var e=a.call(this,d.IFD1,c.thumb);if("JPEGInterchangeFormat"in e)return this.SEGMENT(d.tiffHeader+e.JPEGInterchangeFormat,e.JPEGInterchangeFormatLength)}catch(t){}return null},setExif:function(e,t){return"PixelXDimension"!==e&&"PixelYDimension"!==e?!1:s.call(this,"exif",e,t)},clear:function(){u.clear(),o=c=l=h=d=u=null}}),65505!==this.SHORT(0)||"EXIF\0"!==this.STRING(4,5).toUpperCase())throw new n.ImageError(n.ImageError.INVALID_META_ERR);if(this.littleEndian=18761==this.SHORT(m),42!==this.SHORT(m+=2))throw new n.ImageError(n.ImageError.INVALID_META_ERR);d.IFD0=d.tiffHeader+this.LONG(m+=2),h=a.call(this,d.IFD0,c.tiff),"ExifIFDPointer"in h&&(d.exifIFD=d.tiffHeader+h.ExifIFDPointer,delete h.ExifIFDPointer),"GPSInfoIFDPointer"in h&&(d.gpsIFD=d.tiffHeader+h.GPSInfoIFDPointer,delete h.GPSInfoIFDPointer),e.isEmptyObj(h)&&(h=null);var f=this.LONG(d.IFD0+12*this.SHORT(d.IFD0)+2);f&&(d.IFD1=d.tiffHeader+f)}return r.prototype=i.prototype,r}),n("moxie/runtime/html5/image/JPEG",["moxie/core/utils/Basic","moxie/core/Exceptions","moxie/runtime/html5/image/JPEGHeaders","moxie/runtime/html5/utils/BinaryReader","moxie/runtime/html5/image/ExifParser"],function(e,t,i,n,r){function o(o){function a(e){var t,i,n=0;for(e||(e=c);n<=e.length();){if(t=e.SHORT(n+=2),t>=65472&&65475>=t)return n+=5,{height:e.SHORT(n),width:e.SHORT(n+=2)};i=e.SHORT(n+=2),n+=i-2}return null}function s(){var e,t,i=d.thumb();return i&&(e=new n(i),t=a(e),e.clear(),t)?(t.data=i,t):null}function u(){d&&l&&c&&(d.clear(),l.purge(),c.clear(),m=l=d=c=null)}var c,l,d,m;if(c=new n(o),65496!==c.SHORT(0))throw new t.ImageError(t.ImageError.WRONG_FORMAT);l=new i(o);try{d=new r(l.get("app1")[0])}catch(h){}m=a.call(this),e.extend(this,{type:"image/jpeg",size:c.length(),width:m&&m.width||0,height:m&&m.height||0,setExif:function(t,i){return d?("object"===e.typeOf(t)?e.each(t,function(e,t){d.setExif(t,e)}):d.setExif(t,i),l.set("app1",d.SEGMENT()),void 0):!1},writeHeaders:function(){return arguments.length?l.restore(arguments[0]):l.restore(o)},stripHeaders:function(e){return l.strip(e)},purge:function(){u.call(this)}}),d&&(this.meta={tiff:d.TIFF(),exif:d.EXIF(),gps:d.GPS(),thumb:s()})}return o}),n("moxie/runtime/html5/image/PNG",["moxie/core/Exceptions","moxie/core/utils/Basic","moxie/runtime/html5/utils/BinaryReader"],function(e,t,i){function n(n){function r(){var e,t;return e=a.call(this,8),"IHDR"==e.type?(t=e.start,{width:s.LONG(t),height:s.LONG(t+=4)}):null}function o(){s&&(s.clear(),n=l=u=c=s=null)}function a(e){var t,i,n,r;return t=s.LONG(e),i=s.STRING(e+=4,4),n=e+=4,r=s.LONG(e+t),{length:t,type:i,start:n,CRC:r}}var s,u,c,l;s=new i(n),function(){var t=0,i=0,n=[35152,20039,3338,6666];for(i=0;i<n.length;i++,t+=2)if(n[i]!=s.SHORT(t))throw new e.ImageError(e.ImageError.WRONG_FORMAT)}(),l=r.call(this),t.extend(this,{type:"image/png",size:s.length(),width:l.width,height:l.height,purge:function(){o.call(this)}}),o.call(this)}return n}),n("moxie/runtime/html5/image/ImageInfo",["moxie/core/utils/Basic","moxie/core/Exceptions","moxie/runtime/html5/image/JPEG","moxie/runtime/html5/image/PNG"],function(e,t,i,n){return function(r){var o,a=[i,n];o=function(){for(var e=0;e<a.length;e++)try{return new a[e](r)}catch(i){}throw new t.ImageError(t.ImageError.WRONG_FORMAT)}(),e.extend(this,{type:"",size:0,width:0,height:0,setExif:function(){},writeHeaders:function(e){return e},stripHeaders:function(e){return e},purge:function(){r=null}}),e.extend(this,o),this.purge=function(){o.purge(),o=null}}}),n("moxie/runtime/html5/image/ResizerCanvas",[],function(){function e(i,n,r){var o=i.width>i.height?"width":"height",a=Math.round(i[o]*n),s=!1;"nearest"!==r&&(.5>n||n>2)&&(n=.5>n?.5:2,s=!0);var u=t(i,n);return s?e(u,a/u[o],r):u}function t(e,t){var i=e.width,n=e.height,r=Math.round(i*t),o=Math.round(n*t),a=document.createElement("canvas");return a.width=r,a.height=o,a.getContext("2d").drawImage(e,0,0,i,n,0,0,r,o),e=null,a}return{scale:e}}),n("moxie/runtime/html5/image/Image",["moxie/runtime/html5/Runtime","moxie/core/utils/Basic","moxie/core/Exceptions","moxie/core/utils/Encode","moxie/file/Blob","moxie/file/File","moxie/runtime/html5/image/ImageInfo","moxie/runtime/html5/image/ResizerCanvas","moxie/core/utils/Mime","moxie/core/utils/Env"],function(e,t,i,n,r,o,a,s,u){function c(){function e(){if(!v&&!g)throw new i.ImageError(i.DOMException.INVALID_STATE_ERR);return v||g}function c(){var t=e();return"canvas"==t.nodeName.toLowerCase()?t:(v=document.createElement("canvas"),v.width=t.width,v.height=t.height,v.getContext("2d").drawImage(t,0,0),v)}function l(e){return n.atob(e.substring(e.indexOf("base64,")+7))}function d(e,t){return"data:"+(t||"")+";base64,"+n.btoa(e)}function m(e){var t=this;g=new Image,g.onerror=function(){p.call(this),t.trigger("error",i.ImageError.WRONG_FORMAT)},g.onload=function(){t.trigger("load")},g.src="data:"==e.substr(0,5)?e:d(e,y.type)}function h(e,t){var n,r=this;return window.FileReader?(n=new FileReader,n.onload=function(){t.call(r,this.result)},n.onerror=function(){r.trigger("error",i.ImageError.WRONG_FORMAT)},n.readAsDataURL(e),void 0):t.call(this,e.getAsDataURL())}function f(e,i){var n=Math.PI/180,r=document.createElement("canvas"),o=r.getContext("2d"),a=e.width,s=e.height;switch(t.inArray(i,[5,6,7,8])>-1?(r.width=s,r.height=a):(r.width=a,r.height=s),i){case 2:o.translate(a,0),o.scale(-1,1);break;case 3:o.translate(a,s),o.rotate(180*n);break;case 4:o.translate(0,s),o.scale(1,-1);break;case 5:o.rotate(90*n),o.scale(1,-1);break;case 6:o.rotate(90*n),o.translate(0,-s);break;case 7:o.rotate(90*n),o.translate(a,-s),o.scale(-1,1);break;case 8:o.rotate(-90*n),o.translate(-a,0)}return o.drawImage(e,0,0,a,s),r}function p(){x&&(x.purge(),x=null),w=g=v=y=null,b=!1}var g,x,v,w,y,E=this,b=!1,_=!0;t.extend(this,{loadFromBlob:function(e){var t=this.getRuntime(),n=arguments.length>1?arguments[1]:!0;if(!t.can("access_binary"))throw new i.RuntimeError(i.RuntimeError.NOT_SUPPORTED_ERR);return y=e,e.isDetached()?(w=e.getSource(),m.call(this,w),void 0):(h.call(this,e.getSource(),function(e){n&&(w=l(e)),m.call(this,e)}),void 0)},loadFromImage:function(e,t){this.meta=e.meta,y=new o(null,{name:e.name,size:e.size,type:e.type}),m.call(this,t?w=e.getAsBinaryString():e.getAsDataURL())},getInfo:function(){var t,i=this.getRuntime();return!x&&w&&i.can("access_image_binary")&&(x=new a(w)),t={width:e().width||0,height:e().height||0,type:y.type||u.getFileMime(y.name),size:w&&w.length||y.size||0,name:y.name||"",meta:null},_&&(t.meta=x&&x.meta||this.meta||{},!t.meta||!t.meta.thumb||t.meta.thumb.data instanceof r||(t.meta.thumb.data=new r(null,{type:"image/jpeg",data:t.meta.thumb.data}))),t},resize:function(t,i,n){var r=document.createElement("canvas");if(r.width=t.width,r.height=t.height,r.getContext("2d").drawImage(e(),t.x,t.y,t.width,t.height,0,0,r.width,r.height),v=s.scale(r,i),_=n.preserveHeaders,!_){var o=this.meta&&this.meta.tiff&&this.meta.tiff.Orientation||1;v=f(v,o)}this.width=v.width,this.height=v.height,b=!0,this.trigger("Resize")},getAsCanvas:function(){return v||(v=c()),v.id=this.uid+"_canvas",v},getAsBlob:function(e,t){return e!==this.type?(b=!0,new o(null,{name:y.name||"",type:e,data:E.getAsDataURL(e,t)})):new o(null,{name:y.name||"",type:e,data:E.getAsBinaryString(e,t)})},getAsDataURL:function(e){var t=arguments[1]||90;if(!b)return g.src;if(c(),"image/jpeg"!==e)return v.toDataURL("image/png");try{return v.toDataURL("image/jpeg",t/100)}catch(i){return v.toDataURL("image/jpeg")}},getAsBinaryString:function(e,t){if(!b)return w||(w=l(E.getAsDataURL(e,t))),w;if("image/jpeg"!==e)w=l(E.getAsDataURL(e,t));else{var i;t||(t=90),c();try{i=v.toDataURL("image/jpeg",t/100)}catch(n){i=v.toDataURL("image/jpeg")}w=l(i),x&&(w=x.stripHeaders(w),_&&(x.meta&&x.meta.exif&&x.setExif({PixelXDimension:this.width,PixelYDimension:this.height}),w=x.writeHeaders(w)),x.purge(),x=null)}return b=!1,w},destroy:function(){E=null,p.call(this),this.getRuntime().getShim().removeInstance(this.uid)}})}return e.Image=c}),n("moxie/runtime/flash/Runtime",["moxie/core/utils/Basic","moxie/core/utils/Env","moxie/core/utils/Dom","moxie/core/Exceptions","moxie/runtime/Runtime"],function(e,t,i,n,o){function a(){var e;try{e=navigator.plugins["Shockwave Flash"],e=e.description}catch(t){try{e=new ActiveXObject("ShockwaveFlash.ShockwaveFlash").GetVariable("$version")}catch(i){e="0.0"}}return e=e.match(/\d+/g),parseFloat(e[0]+"."+e[1])}function s(e){var n=i.get(e);n&&"OBJECT"==n.nodeName&&("IE"===t.browser?(n.style.display="none",function r(){4==n.readyState?u(e):setTimeout(r,10)}()):n.parentNode.removeChild(n))}function u(e){var t=i.get(e);if(t){for(var n in t)"function"==typeof t[n]&&(t[n]=null);t.parentNode.removeChild(t)}}function c(u){var c,m=this;u=e.extend({swf_url:t.swf_url},u),o.call(this,u,l,{access_binary:function(e){return e&&"browser"===m.mode},access_image_binary:function(e){return e&&"browser"===m.mode},display_media:o.capTest(r("moxie/image/Image")),do_cors:o.capTrue,drag_and_drop:!1,report_upload_progress:function(){return"client"===m.mode},resize_image:o.capTrue,return_response_headers:!1,return_response_type:function(t){return"json"===t&&window.JSON?!0:!e.arrayDiff(t,["","text","document"])||"browser"===m.mode},return_status_code:function(t){return"browser"===m.mode||!e.arrayDiff(t,[200,404])},select_file:o.capTrue,select_multiple:o.capTrue,send_binary_string:function(e){return e&&"browser"===m.mode},send_browser_cookies:function(e){return e&&"browser"===m.mode},send_custom_headers:function(e){return e&&"browser"===m.mode},send_multipart:o.capTrue,slice_blob:function(e){return e&&"browser"===m.mode},stream_upload:function(e){return e&&"browser"===m.mode},summon_file_dialog:!1,upload_filesize:function(t){return e.parseSizeStr(t)<=2097152||"client"===m.mode},use_http_method:function(t){return!e.arrayDiff(t,["GET","POST"])}},{access_binary:function(e){return e?"browser":"client"},access_image_binary:function(e){return e?"browser":"client"},report_upload_progress:function(e){return e?"browser":"client"},return_response_type:function(t){return e.arrayDiff(t,["","text","json","document"])?"browser":["client","browser"]},return_status_code:function(t){return e.arrayDiff(t,[200,404])?"browser":["client","browser"]},send_binary_string:function(e){return e?"browser":"client"},send_browser_cookies:function(e){return e?"browser":"client"},send_custom_headers:function(e){return e?"browser":"client"},slice_blob:function(e){return e?"browser":"client"},stream_upload:function(e){return e?"client":"browser"},upload_filesize:function(t){return e.parseSizeStr(t)>=2097152?"client":"browser"}},"client"),a()<11.3&&(this.mode=!1),e.extend(this,{getShim:function(){return i.get(this.uid)},shimExec:function(e,t){var i=[].slice.call(arguments,2);return m.getShim().exec(this.uid,e,t,i)},init:function(){var i,r,a;a=this.getShimContainer(),e.extend(a.style,{position:"absolute",top:"-8px",left:"-8px",width:"9px",height:"9px",overflow:"hidden"}),i='<object id="'+this.uid+'" type="application/x-shockwave-flash" data="'+u.swf_url+'" ',"IE"===t.browser&&(i+='classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" '),i+='width="100%" height="100%" style="outline:0"><param name="movie" value="'+u.swf_url+'" />'+'<param name="flashvars" value="uid='+escape(this.uid)+"&target="+o.getGlobalEventTarget()+'" />'+'<param name="wmode" value="transparent" />'+'<param name="allowscriptaccess" value="always" />'+"</object>","IE"===t.browser?(r=document.createElement("div"),a.appendChild(r),r.outerHTML=i,r=a=null):a.innerHTML=i,c=setTimeout(function(){m&&!m.initialized&&m.trigger("Error",new n.RuntimeError(n.RuntimeError.NOT_INIT_ERR))},5e3)},destroy:function(e){return function(){s(m.uid),e.call(m),clearTimeout(c),u=c=e=m=null}}(this.destroy)},d)}var l="flash",d={};return o.addConstructor(l,c),d}),n("moxie/runtime/flash/file/Blob",["moxie/runtime/flash/Runtime","moxie/file/Blob"],function(e,t){var i={slice:function(e,i,n,r){var o=this.getRuntime();return 0>i?i=Math.max(e.size+i,0):i>0&&(i=Math.min(i,e.size)),0>n?n=Math.max(e.size+n,0):n>0&&(n=Math.min(n,e.size)),e=o.shimExec.call(this,"Blob","slice",i,n,r||""),e&&(e=new t(o.uid,e)),e}};return e.Blob=i}),n("moxie/runtime/flash/file/FileInput",["moxie/runtime/flash/Runtime","moxie/file/File","moxie/core/utils/Dom","moxie/core/utils/Basic"],function(e,t,i,n){var r={init:function(e){var r=this,o=this.getRuntime(),a=i.get(e.browse_button);a&&(a.setAttribute("tabindex",-1),a=null),this.bind("Change",function(){var e=o.shimExec.call(r,"FileInput","getFiles");r.files=[],n.each(e,function(e){r.files.push(new t(o.uid,e))})},999),this.getRuntime().shimExec.call(this,"FileInput","init",{accept:e.accept,multiple:e.multiple}),this.trigger("ready")}};return e.FileInput=r}),n("moxie/runtime/flash/file/FileReader",["moxie/runtime/flash/Runtime","moxie/core/utils/Encode"],function(e,t){function i(e,i){switch(i){case"readAsText":return t.atob(e,"utf8");case"readAsBinaryString":return t.atob(e);case"readAsDataURL":return e}return null}var n={read:function(e,t){var n=this;return n.result="","readAsDataURL"===e&&(n.result="data:"+(t.type||"")+";base64,"),n.bind("Progress",function(t,r){r&&(n.result+=i(r,e))},999),n.getRuntime().shimExec.call(this,"FileReader","readAsBase64",t.uid)}};return e.FileReader=n}),n("moxie/runtime/flash/file/FileReaderSync",["moxie/runtime/flash/Runtime","moxie/core/utils/Encode"],function(e,t){function i(e,i){switch(i){case"readAsText":return t.atob(e,"utf8");case"readAsBinaryString":return t.atob(e);case"readAsDataURL":return e}return null}var n={read:function(e,t){var n,r=this.getRuntime();return(n=r.shimExec.call(this,"FileReaderSync","readAsBase64",t.uid))?("readAsDataURL"===e&&(n="data:"+(t.type||"")+";base64,"+n),i(n,e,t.type)):null}};return e.FileReaderSync=n}),n("moxie/runtime/flash/runtime/Transporter",["moxie/runtime/flash/Runtime","moxie/file/Blob"],function(e,t){var i={getAsBlob:function(e){var i=this.getRuntime(),n=i.shimExec.call(this,"Transporter","getAsBlob",e);return n?new t(i.uid,n):null}};return e.Transporter=i}),n("moxie/runtime/flash/xhr/XMLHttpRequest",["moxie/runtime/flash/Runtime","moxie/core/utils/Basic","moxie/file/Blob","moxie/file/File","moxie/file/FileReaderSync","moxie/runtime/flash/file/FileReaderSync","moxie/xhr/FormData","moxie/runtime/Transporter","moxie/runtime/flash/runtime/Transporter"],function(e,t,i,n,r,o,a,s){var u={send:function(e,n){function r(){e.transport=l.mode,l.shimExec.call(c,"XMLHttpRequest","send",e,n)}function o(e,t){l.shimExec.call(c,"XMLHttpRequest","appendBlob",e,t.uid),n=null,r()}function u(e,t){var i=new s;i.bind("TransportingComplete",function(){t(this.result)}),i.transport(e.getSource(),e.type,{ruid:l.uid})}var c=this,l=c.getRuntime();if(t.isEmptyObj(e.headers)||t.each(e.headers,function(e,t){l.shimExec.call(c,"XMLHttpRequest","setRequestHeader",t,e.toString())}),n instanceof a){var d;if(n.each(function(e,t){e instanceof i?d=t:l.shimExec.call(c,"XMLHttpRequest","append",t,e)}),n.hasBlob()){var m=n.getBlob();m.isDetached()?u(m,function(e){m.destroy(),o(d,e)}):o(d,m)}else n=null,r()}else n instanceof i?n.isDetached()?u(n,function(e){n.destroy(),n=e.uid,r()}):(n=n.uid,r()):r()},getResponse:function(e){var i,o,a=this.getRuntime();if(o=a.shimExec.call(this,"XMLHttpRequest","getResponseAsBlob")){if(o=new n(a.uid,o),"blob"===e)return o;try{if(i=new r,~t.inArray(e,["","text"]))return i.readAsText(o);if("json"===e&&window.JSON)return JSON.parse(i.readAsText(o))}finally{o.destroy()}}return null},abort:function(){var e=this.getRuntime();e.shimExec.call(this,"XMLHttpRequest","abort"),this.dispatchEvent("readystatechange"),this.dispatchEvent("abort")}};return e.XMLHttpRequest=u}),n("moxie/runtime/flash/image/Image",["moxie/runtime/flash/Runtime","moxie/core/utils/Basic","moxie/runtime/Transporter","moxie/file/Blob","moxie/file/FileReaderSync"],function(e,t,i,n,r){var o={loadFromBlob:function(e){function t(e){r.shimExec.call(n,"Image","loadFromBlob",e.uid),n=r=null}var n=this,r=n.getRuntime();if(e.isDetached()){var o=new i;o.bind("TransportingComplete",function(){t(o.result.getSource())}),o.transport(e.getSource(),e.type,{ruid:r.uid})}else t(e.getSource())},loadFromImage:function(e){var t=this.getRuntime();return t.shimExec.call(this,"Image","loadFromImage",e.uid)},getInfo:function(){var e=this.getRuntime(),t=e.shimExec.call(this,"Image","getInfo");return t.meta&&t.meta.thumb&&t.meta.thumb.data&&!(e.meta.thumb.data instanceof n)&&(t.meta.thumb.data=new n(e.uid,t.meta.thumb.data)),t},getAsBlob:function(e,t){var i=this.getRuntime(),r=i.shimExec.call(this,"Image","getAsBlob",e,t);return r?new n(i.uid,r):null},getAsDataURL:function(){var e,t=this.getRuntime(),i=t.Image.getAsBlob.apply(this,arguments);return i?(e=new r,e.readAsDataURL(i)):null}};return e.Image=o}),n("moxie/runtime/silverlight/Runtime",["moxie/core/utils/Basic","moxie/core/utils/Env","moxie/core/utils/Dom","moxie/core/Exceptions","moxie/runtime/Runtime"],function(e,t,i,n,o){function a(e){var t,i,n,r,o,a=!1,s=null,u=0;try{try{s=new ActiveXObject("AgControl.AgControl"),s.IsVersionSupported(e)&&(a=!0),s=null}catch(c){var l=navigator.plugins["Silverlight Plug-In"];if(l){for(t=l.description,"1.0.30226.2"===t&&(t="2.0.30226.2"),i=t.split(".");i.length>3;)i.pop();for(;i.length<4;)i.push(0);for(n=e.split(".");n.length>4;)n.pop();do r=parseInt(n[u],10),o=parseInt(i[u],10),u++;while(u<n.length&&r===o);o>=r&&!isNaN(r)&&(a=!0)}}}catch(d){a=!1}return a}function s(s){var l,d=this;s=e.extend({xap_url:t.xap_url},s),o.call(this,s,u,{access_binary:o.capTrue,access_image_binary:o.capTrue,display_media:o.capTest(r("moxie/image/Image")),do_cors:o.capTrue,drag_and_drop:!1,report_upload_progress:o.capTrue,resize_image:o.capTrue,return_response_headers:function(e){return e&&"client"===d.mode},return_response_type:function(e){return"json"!==e?!0:!!window.JSON},return_status_code:function(t){return"client"===d.mode||!e.arrayDiff(t,[200,404])},select_file:o.capTrue,select_multiple:o.capTrue,send_binary_string:o.capTrue,send_browser_cookies:function(e){return e&&"browser"===d.mode},send_custom_headers:function(e){return e&&"client"===d.mode},send_multipart:o.capTrue,slice_blob:o.capTrue,stream_upload:!0,summon_file_dialog:!1,upload_filesize:o.capTrue,use_http_method:function(t){return"client"===d.mode||!e.arrayDiff(t,["GET","POST"])}},{return_response_headers:function(e){return e?"client":"browser"},return_status_code:function(t){return e.arrayDiff(t,[200,404])?"client":["client","browser"]},send_browser_cookies:function(e){return e?"browser":"client"},send_custom_headers:function(e){return e?"client":"browser"},use_http_method:function(t){return e.arrayDiff(t,["GET","POST"])?"client":["client","browser"]}}),a("2.0.31005.0")&&"Opera"!==t.browser||(this.mode=!1),e.extend(this,{getShim:function(){return i.get(this.uid).content.Moxie},shimExec:function(e,t){var i=[].slice.call(arguments,2);return d.getShim().exec(this.uid,e,t,i)},init:function(){var e;e=this.getShimContainer(),e.innerHTML='<object id="'+this.uid+'" data="data:application/x-silverlight," type="application/x-silverlight-2" width="100%" height="100%" style="outline:none;">'+'<param name="source" value="'+s.xap_url+'"/>'+'<param name="background" value="Transparent"/>'+'<param name="windowless" value="true"/>'+'<param name="enablehtmlaccess" value="true"/>'+'<param name="initParams" value="uid='+this.uid+",target="+o.getGlobalEventTarget()+'"/>'+"</object>",l=setTimeout(function(){d&&!d.initialized&&d.trigger("Error",new n.RuntimeError(n.RuntimeError.NOT_INIT_ERR))},"Windows"!==t.OS?1e4:5e3)},destroy:function(e){return function(){e.call(d),clearTimeout(l),s=l=e=d=null}}(this.destroy)},c)}var u="silverlight",c={};return o.addConstructor(u,s),c}),n("moxie/runtime/silverlight/file/Blob",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/runtime/flash/file/Blob"],function(e,t,i){return e.Blob=t.extend({},i)}),n("moxie/runtime/silverlight/file/FileInput",["moxie/runtime/silverlight/Runtime","moxie/file/File","moxie/core/utils/Dom","moxie/core/utils/Basic"],function(e,t,i,n){function r(e){for(var t="",i=0;i<e.length;i++)t+=(""!==t?"|":"")+e[i].title+" | *."+e[i].extensions.replace(/,/g,";*.");return t}var o={init:function(e){var o=this,a=this.getRuntime(),s=i.get(e.browse_button);s&&(s.setAttribute("tabindex",-1),s=null),this.bind("Change",function(){var e=a.shimExec.call(o,"FileInput","getFiles");
o.files=[],n.each(e,function(e){o.files.push(new t(a.uid,e))})},999),a.shimExec.call(this,"FileInput","init",r(e.accept),e.multiple),this.trigger("ready")},setOption:function(e,t){"accept"==e&&(t=r(t)),this.getRuntime().shimExec.call(this,"FileInput","setOption",e,t)}};return e.FileInput=o}),n("moxie/runtime/silverlight/file/FileDrop",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Dom","moxie/core/utils/Events"],function(e,t,i){var n={init:function(){var e,n=this,r=n.getRuntime();return e=r.getShimContainer(),i.addEvent(e,"dragover",function(e){e.preventDefault(),e.stopPropagation(),e.dataTransfer.dropEffect="copy"},n.uid),i.addEvent(e,"dragenter",function(e){e.preventDefault();var i=t.get(r.uid).dragEnter(e);i&&e.stopPropagation()},n.uid),i.addEvent(e,"drop",function(e){e.preventDefault();var i=t.get(r.uid).dragDrop(e);i&&e.stopPropagation()},n.uid),r.shimExec.call(this,"FileDrop","init")}};return e.FileDrop=n}),n("moxie/runtime/silverlight/file/FileReader",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/runtime/flash/file/FileReader"],function(e,t,i){return e.FileReader=t.extend({},i)}),n("moxie/runtime/silverlight/file/FileReaderSync",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/runtime/flash/file/FileReaderSync"],function(e,t,i){return e.FileReaderSync=t.extend({},i)}),n("moxie/runtime/silverlight/runtime/Transporter",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/runtime/flash/runtime/Transporter"],function(e,t,i){return e.Transporter=t.extend({},i)}),n("moxie/runtime/silverlight/xhr/XMLHttpRequest",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/runtime/flash/xhr/XMLHttpRequest","moxie/runtime/silverlight/file/FileReaderSync","moxie/runtime/silverlight/runtime/Transporter"],function(e,t,i){return e.XMLHttpRequest=t.extend({},i)}),n("moxie/runtime/silverlight/image/Image",["moxie/runtime/silverlight/Runtime","moxie/core/utils/Basic","moxie/file/Blob","moxie/runtime/flash/image/Image"],function(e,t,i,n){return e.Image=t.extend({},n,{getInfo:function(){var e=this.getRuntime(),n=["tiff","exif","gps","thumb"],r={meta:{}},o=e.shimExec.call(this,"Image","getInfo");return o.meta&&(t.each(n,function(e){var t,i,n,a,s=o.meta[e];if(s&&s.keys)for(r.meta[e]={},i=0,n=s.keys.length;n>i;i++)t=s.keys[i],a=s[t],a&&(/^(\d|[1-9]\d+)$/.test(a)?a=parseInt(a,10):/^\d*\.\d+$/.test(a)&&(a=parseFloat(a)),r.meta[e][t]=a)}),r.meta&&r.meta.thumb&&r.meta.thumb.data&&!(e.meta.thumb.data instanceof i)&&(r.meta.thumb.data=new i(e.uid,r.meta.thumb.data))),r.width=parseInt(o.width,10),r.height=parseInt(o.height,10),r.size=parseInt(o.size,10),r.type=o.type,r.name=o.name,r},resize:function(e,t,i){this.getRuntime().shimExec.call(this,"Image","resize",e.x,e.y,e.width,e.height,t,i.preserveHeaders,i.resample)}})}),n("moxie/runtime/html4/Runtime",["moxie/core/utils/Basic","moxie/core/Exceptions","moxie/runtime/Runtime","moxie/core/utils/Env"],function(e,t,i,n){function o(t){var o=this,u=i.capTest,c=i.capTrue;i.call(this,t,a,{access_binary:u(window.FileReader||window.File&&File.getAsDataURL),access_image_binary:!1,display_media:u((n.can("create_canvas")||n.can("use_data_uri_over32kb"))&&r("moxie/image/Image")),do_cors:!1,drag_and_drop:!1,filter_by_extension:u(function(){return!("Chrome"===n.browser&&n.verComp(n.version,28,"<")||"IE"===n.browser&&n.verComp(n.version,10,"<")||"Safari"===n.browser&&n.verComp(n.version,7,"<")||"Firefox"===n.browser&&n.verComp(n.version,37,"<"))}()),resize_image:function(){return s.Image&&o.can("access_binary")&&n.can("create_canvas")},report_upload_progress:!1,return_response_headers:!1,return_response_type:function(t){return"json"===t&&window.JSON?!0:!!~e.inArray(t,["text","document",""])},return_status_code:function(t){return!e.arrayDiff(t,[200,404])},select_file:function(){return n.can("use_fileinput")},select_multiple:!1,send_binary_string:!1,send_custom_headers:!1,send_multipart:!0,slice_blob:!1,stream_upload:function(){return o.can("select_file")},summon_file_dialog:function(){return o.can("select_file")&&!("Firefox"===n.browser&&n.verComp(n.version,4,"<")||"Opera"===n.browser&&n.verComp(n.version,12,"<")||"IE"===n.browser&&n.verComp(n.version,10,"<"))},upload_filesize:c,use_http_method:function(t){return!e.arrayDiff(t,["GET","POST"])}}),e.extend(this,{init:function(){this.trigger("Init")},destroy:function(e){return function(){e.call(o),e=o=null}}(this.destroy)}),e.extend(this.getShim(),s)}var a="html4",s={};return i.addConstructor(a,o),s}),n("moxie/runtime/html4/file/FileInput",["moxie/runtime/html4/Runtime","moxie/file/File","moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/utils/Events","moxie/core/utils/Mime","moxie/core/utils/Env"],function(e,t,i,n,r,o,a){function s(){function e(){var o,c,d,m,h,f,p=this,g=p.getRuntime();f=i.guid("uid_"),o=g.getShimContainer(),s&&(d=n.get(s+"_form"),d&&(i.extend(d.style,{top:"100%"}),d.firstChild.setAttribute("tabindex",-1))),m=document.createElement("form"),m.setAttribute("id",f+"_form"),m.setAttribute("method","post"),m.setAttribute("enctype","multipart/form-data"),m.setAttribute("encoding","multipart/form-data"),i.extend(m.style,{overflow:"hidden",position:"absolute",top:0,left:0,width:"100%",height:"100%"}),h=document.createElement("input"),h.setAttribute("id",f),h.setAttribute("type","file"),h.setAttribute("accept",l.join(",")),g.can("summon_file_dialog")&&h.setAttribute("tabindex",-1),i.extend(h.style,{fontSize:"999px",opacity:0}),m.appendChild(h),o.appendChild(m),i.extend(h.style,{position:"absolute",top:0,left:0,width:"100%",height:"100%"}),"IE"===a.browser&&a.verComp(a.version,10,"<")&&i.extend(h.style,{filter:"progid:DXImageTransform.Microsoft.Alpha(opacity=0)"}),h.onchange=function(){var i;this.value&&(i=this.files?this.files[0]:{name:this.value},i=new t(g.uid,i),this.onchange=function(){},e.call(p),p.files=[i],h.setAttribute("id",i.uid),m.setAttribute("id",i.uid+"_form"),p.trigger("change"),h=m=null)},g.can("summon_file_dialog")&&(c=n.get(u.browse_button),r.removeEvent(c,"click",p.uid),r.addEvent(c,"click",function(e){h&&!h.disabled&&h.click(),e.preventDefault()},p.uid)),s=f,o=d=c=null}var s,u,c,l=[];i.extend(this,{init:function(t){var i,a=this,s=a.getRuntime();u=t,l=o.extList2mimes(t.accept,s.can("filter_by_extension")),i=s.getShimContainer(),function(){var e,o,l;e=n.get(t.browse_button),c=n.getStyle(e,"z-index")||"auto",s.can("summon_file_dialog")?("static"===n.getStyle(e,"position")&&(e.style.position="relative"),a.bind("Refresh",function(){o=parseInt(c,10)||1,n.get(u.browse_button).style.zIndex=o,this.getRuntime().getShimContainer().style.zIndex=o-1})):e.setAttribute("tabindex",-1),l=s.can("summon_file_dialog")?e:i,r.addEvent(l,"mouseover",function(){a.trigger("mouseenter")},a.uid),r.addEvent(l,"mouseout",function(){a.trigger("mouseleave")},a.uid),r.addEvent(l,"mousedown",function(){a.trigger("mousedown")},a.uid),r.addEvent(n.get(t.container),"mouseup",function(){a.trigger("mouseup")},a.uid),e=null}(),e.call(this),i=null,a.trigger({type:"ready",async:!0})},setOption:function(e,t){var i,r=this.getRuntime();"accept"==e&&(l=t.mimes||o.extList2mimes(t,r.can("filter_by_extension"))),i=n.get(s),i&&i.setAttribute("accept",l.join(","))},disable:function(e){var t;(t=n.get(s))&&(t.disabled=!!e)},destroy:function(){var e=this.getRuntime(),t=e.getShim(),i=e.getShimContainer(),o=u&&n.get(u.container),a=u&&n.get(u.browse_button);o&&r.removeAllEvents(o,this.uid),a&&(r.removeAllEvents(a,this.uid),a.style.zIndex=c),i&&(r.removeAllEvents(i,this.uid),i.innerHTML=""),t.removeInstance(this.uid),s=l=u=i=o=a=t=null}})}return e.FileInput=s}),n("moxie/runtime/html4/file/FileReader",["moxie/runtime/html4/Runtime","moxie/runtime/html5/file/FileReader"],function(e,t){return e.FileReader=t}),n("moxie/runtime/html4/xhr/XMLHttpRequest",["moxie/runtime/html4/Runtime","moxie/core/utils/Basic","moxie/core/utils/Dom","moxie/core/utils/Url","moxie/core/Exceptions","moxie/core/utils/Events","moxie/file/Blob","moxie/xhr/FormData"],function(e,t,i,n,r,o,a,s){function u(){function e(e){var t,n,r,a,s=this,u=!1;if(l){if(t=l.id.replace(/_iframe$/,""),n=i.get(t+"_form")){for(r=n.getElementsByTagName("input"),a=r.length;a--;)switch(r[a].getAttribute("type")){case"hidden":r[a].parentNode.removeChild(r[a]);break;case"file":u=!0}r=[],u||n.parentNode.removeChild(n),n=null}setTimeout(function(){o.removeEvent(l,"load",s.uid),l.parentNode&&l.parentNode.removeChild(l);var t=s.getRuntime().getShimContainer();t.children.length||t.parentNode.removeChild(t),t=l=null,e()},1)}}var u,c,l;t.extend(this,{send:function(d,m){function h(){var i=w.getShimContainer()||document.body,r=document.createElement("div");r.innerHTML='<iframe id="'+f+'_iframe" name="'+f+'_iframe" src="javascript:&quot;&quot;" style="display:none"></iframe>',l=r.firstChild,i.appendChild(l),o.addEvent(l,"load",function(){var i;try{i=l.contentWindow.document||l.contentDocument||window.frames[l.id].document,/^4(0[0-9]|1[0-7]|2[2346])\s/.test(i.title)?u=i.title.replace(/^(\d+).*$/,"$1"):(u=200,c=t.trim(i.body.innerHTML),v.trigger({type:"progress",loaded:c.length,total:c.length}),x&&v.trigger({type:"uploadprogress",loaded:x.size||1025,total:x.size||1025}))}catch(r){if(!n.hasSameOrigin(d.url))return e.call(v,function(){v.trigger("error")}),void 0;u=404}e.call(v,function(){v.trigger("load")})},v.uid)}var f,p,g,x,v=this,w=v.getRuntime();if(u=c=null,m instanceof s&&m.hasBlob()){if(x=m.getBlob(),f=x.uid,g=i.get(f),p=i.get(f+"_form"),!p)throw new r.DOMException(r.DOMException.NOT_FOUND_ERR)}else f=t.guid("uid_"),p=document.createElement("form"),p.setAttribute("id",f+"_form"),p.setAttribute("method",d.method),p.setAttribute("enctype","multipart/form-data"),p.setAttribute("encoding","multipart/form-data"),w.getShimContainer().appendChild(p);p.setAttribute("target",f+"_iframe"),m instanceof s&&m.each(function(e,i){if(e instanceof a)g&&g.setAttribute("name",i);else{var n=document.createElement("input");t.extend(n,{type:"hidden",name:i,value:e}),g?p.insertBefore(n,g):p.appendChild(n)}}),p.setAttribute("action",d.url),h(),p.submit(),v.trigger("loadstart")},getStatus:function(){return u},getResponse:function(e){if("json"===e&&"string"===t.typeOf(c)&&window.JSON)try{return JSON.parse(c.replace(/^\s*<pre[^>]*>/,"").replace(/<\/pre>\s*$/,""))}catch(i){return null}return c},abort:function(){var t=this;l&&l.contentWindow&&(l.contentWindow.stop?l.contentWindow.stop():l.contentWindow.document.execCommand?l.contentWindow.document.execCommand("Stop"):l.src="about:blank"),e.call(this,function(){t.dispatchEvent("abort")})},destroy:function(){this.getRuntime().getShim().removeInstance(this.uid)}})}return e.XMLHttpRequest=u}),n("moxie/runtime/html4/image/Image",["moxie/runtime/html4/Runtime","moxie/runtime/html5/image/Image"],function(e,t){return e.Image=t}),a(["moxie/core/utils/Basic","moxie/core/utils/Encode","moxie/core/utils/Env","moxie/core/Exceptions","moxie/core/utils/Dom","moxie/core/EventTarget","moxie/runtime/Runtime","moxie/runtime/RuntimeClient","moxie/file/Blob","moxie/core/I18n","moxie/core/utils/Mime","moxie/file/FileInput","moxie/file/File","moxie/file/FileDrop","moxie/file/FileReader","moxie/core/utils/Url","moxie/runtime/RuntimeTarget","moxie/xhr/FormData","moxie/xhr/XMLHttpRequest","moxie/image/Image","moxie/core/utils/Events","moxie/runtime/html5/image/ResizerCanvas"])}(this)});
/**
 * Plupload - multi-runtime File Uploader
 * v2.3.6
 *
 * Copyright 2013, Moxiecode Systems AB
 * Released under GPL License.
 *
 * License: http://www.plupload.com/license
 * Contributing: http://www.plupload.com/contributing
 *
 * Date: 2017-11-03
 */
!function(e,t){var i=function(){var e={};return t.apply(e,arguments),e.plupload}; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__WEBPACK_LOCAL_MODULE_0__], __WEBPACK_AMD_DEFINE_FACTORY__ = (i),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=i(require("./moxie")):e.plupload=i(e.moxie)}(this||window,function(e){!function(e,t,i){function n(e){function t(e,t,i){var r={chunks:"slice_blob",jpgresize:"send_binary_string",pngresize:"send_binary_string",progress:"report_upload_progress",multi_selection:"select_multiple",dragdrop:"drag_and_drop",drop_element:"drag_and_drop",headers:"send_custom_headers",urlstream_upload:"send_binary_string",canSendBinary:"send_binary",triggerDialog:"summon_file_dialog"};r[e]?n[r[e]]=t:i||(n[e]=t)}var i=e.required_features,n={};return"string"==typeof i?l.each(i.split(/\s*,\s*/),function(e){t(e,!0)}):"object"==typeof i?l.each(i,function(e,i){t(i,e)}):i===!0&&(e.chunk_size&&e.chunk_size>0&&(n.slice_blob=!0),l.isEmptyObj(e.resize)&&e.multipart!==!1||(n.send_binary_string=!0),e.http_method&&(n.use_http_method=e.http_method),l.each(e,function(e,i){t(i,!!e,!0)})),n}var r=window.setTimeout,s={},a=t.core.utils,o=t.runtime.Runtime,l={VERSION:"2.3.6",STOPPED:1,STARTED:2,QUEUED:1,UPLOADING:2,FAILED:4,DONE:5,GENERIC_ERROR:-100,HTTP_ERROR:-200,IO_ERROR:-300,SECURITY_ERROR:-400,INIT_ERROR:-500,FILE_SIZE_ERROR:-600,FILE_EXTENSION_ERROR:-601,FILE_DUPLICATE_ERROR:-602,IMAGE_FORMAT_ERROR:-700,MEMORY_ERROR:-701,IMAGE_DIMENSIONS_ERROR:-702,moxie:t,mimeTypes:a.Mime.mimes,ua:a.Env,typeOf:a.Basic.typeOf,extend:a.Basic.extend,guid:a.Basic.guid,getAll:function(e){var t,i=[];"array"!==l.typeOf(e)&&(e=[e]);for(var n=e.length;n--;)t=l.get(e[n]),t&&i.push(t);return i.length?i:null},get:a.Dom.get,each:a.Basic.each,getPos:a.Dom.getPos,getSize:a.Dom.getSize,xmlEncode:function(e){var t={"<":"lt",">":"gt","&":"amp",'"':"quot","'":"#39"},i=/[<>&\"\']/g;return e?(""+e).replace(i,function(e){return t[e]?"&"+t[e]+";":e}):e},toArray:a.Basic.toArray,inArray:a.Basic.inArray,inSeries:a.Basic.inSeries,addI18n:t.core.I18n.addI18n,translate:t.core.I18n.translate,sprintf:a.Basic.sprintf,isEmptyObj:a.Basic.isEmptyObj,hasClass:a.Dom.hasClass,addClass:a.Dom.addClass,removeClass:a.Dom.removeClass,getStyle:a.Dom.getStyle,addEvent:a.Events.addEvent,removeEvent:a.Events.removeEvent,removeAllEvents:a.Events.removeAllEvents,cleanName:function(e){var t,i;for(i=[/[\300-\306]/g,"A",/[\340-\346]/g,"a",/\307/g,"C",/\347/g,"c",/[\310-\313]/g,"E",/[\350-\353]/g,"e",/[\314-\317]/g,"I",/[\354-\357]/g,"i",/\321/g,"N",/\361/g,"n",/[\322-\330]/g,"O",/[\362-\370]/g,"o",/[\331-\334]/g,"U",/[\371-\374]/g,"u"],t=0;t<i.length;t+=2)e=e.replace(i[t],i[t+1]);return e=e.replace(/\s+/g,"_"),e=e.replace(/[^a-z0-9_\-\.]+/gi,"")},buildUrl:function(e,t){var i="";return l.each(t,function(e,t){i+=(i?"&":"")+encodeURIComponent(t)+"="+encodeURIComponent(e)}),i&&(e+=(e.indexOf("?")>0?"&":"?")+i),e},formatSize:function(e){function t(e,t){return Math.round(e*Math.pow(10,t))/Math.pow(10,t)}if(e===i||/\D/.test(e))return l.translate("N/A");var n=Math.pow(1024,4);return e>n?t(e/n,1)+" "+l.translate("tb"):e>(n/=1024)?t(e/n,1)+" "+l.translate("gb"):e>(n/=1024)?t(e/n,1)+" "+l.translate("mb"):e>1024?Math.round(e/1024)+" "+l.translate("kb"):e+" "+l.translate("b")},parseSize:a.Basic.parseSizeStr,predictRuntime:function(e,t){var i,n;return i=new l.Uploader(e),n=o.thatCan(i.getOption().required_features,t||e.runtimes),i.destroy(),n},addFileFilter:function(e,t){s[e]=t}};l.addFileFilter("mime_types",function(e,t,i){e.length&&!e.regexp.test(t.name)?(this.trigger("Error",{code:l.FILE_EXTENSION_ERROR,message:l.translate("File extension error."),file:t}),i(!1)):i(!0)}),l.addFileFilter("max_file_size",function(e,t,i){var n;e=l.parseSize(e),t.size!==n&&e&&t.size>e?(this.trigger("Error",{code:l.FILE_SIZE_ERROR,message:l.translate("File size error."),file:t}),i(!1)):i(!0)}),l.addFileFilter("prevent_duplicates",function(e,t,i){if(e)for(var n=this.files.length;n--;)if(t.name===this.files[n].name&&t.size===this.files[n].size)return this.trigger("Error",{code:l.FILE_DUPLICATE_ERROR,message:l.translate("Duplicate file error."),file:t}),i(!1),void 0;i(!0)}),l.addFileFilter("prevent_empty",function(e,t,n){e&&!t.size&&t.size!==i?(this.trigger("Error",{code:l.FILE_SIZE_ERROR,message:l.translate("File size error."),file:t}),n(!1)):n(!0)}),l.Uploader=function(e){function a(){var e,t,i=0;if(this.state==l.STARTED){for(t=0;t<D.length;t++)e||D[t].status!=l.QUEUED?i++:(e=D[t],this.trigger("BeforeUpload",e)&&(e.status=l.UPLOADING,this.trigger("UploadFile",e)));i==D.length&&(this.state!==l.STOPPED&&(this.state=l.STOPPED,this.trigger("StateChanged")),this.trigger("UploadComplete",D))}}function u(e){e.percent=e.size>0?Math.ceil(100*(e.loaded/e.size)):100,d()}function d(){var e,t,n,r=0;for(I.reset(),e=0;e<D.length;e++)t=D[e],t.size!==i?(I.size+=t.origSize,n=t.loaded*t.origSize/t.size,(!t.completeTimestamp||t.completeTimestamp>S)&&(r+=n),I.loaded+=n):I.size=i,t.status==l.DONE?I.uploaded++:t.status==l.FAILED?I.failed++:I.queued++;I.size===i?I.percent=D.length>0?Math.ceil(100*(I.uploaded/D.length)):0:(I.bytesPerSec=Math.ceil(r/((+new Date-S||1)/1e3)),I.percent=I.size>0?Math.ceil(100*(I.loaded/I.size)):0)}function c(){var e=F[0]||P[0];return e?e.getRuntime().uid:!1}function f(){this.bind("FilesAdded FilesRemoved",function(e){e.trigger("QueueChanged"),e.refresh()}),this.bind("CancelUpload",b),this.bind("BeforeUpload",m),this.bind("UploadFile",_),this.bind("UploadProgress",E),this.bind("StateChanged",v),this.bind("QueueChanged",d),this.bind("Error",R),this.bind("FileUploaded",y),this.bind("Destroy",z)}function p(e,i){var n=this,r=0,s=[],a={runtime_order:e.runtimes,required_caps:e.required_features,preferred_caps:x,swf_url:e.flash_swf_url,xap_url:e.silverlight_xap_url};l.each(e.runtimes.split(/\s*,\s*/),function(t){e[t]&&(a[t]=e[t])}),e.browse_button&&l.each(e.browse_button,function(i){s.push(function(s){var u=new t.file.FileInput(l.extend({},a,{accept:e.filters.mime_types,name:e.file_data_name,multiple:e.multi_selection,container:e.container,browse_button:i}));u.onready=function(){var e=o.getInfo(this.ruid);l.extend(n.features,{chunks:e.can("slice_blob"),multipart:e.can("send_multipart"),multi_selection:e.can("select_multiple")}),r++,F.push(this),s()},u.onchange=function(){n.addFile(this.files)},u.bind("mouseenter mouseleave mousedown mouseup",function(t){U||(e.browse_button_hover&&("mouseenter"===t.type?l.addClass(i,e.browse_button_hover):"mouseleave"===t.type&&l.removeClass(i,e.browse_button_hover)),e.browse_button_active&&("mousedown"===t.type?l.addClass(i,e.browse_button_active):"mouseup"===t.type&&l.removeClass(i,e.browse_button_active)))}),u.bind("mousedown",function(){n.trigger("Browse")}),u.bind("error runtimeerror",function(){u=null,s()}),u.init()})}),e.drop_element&&l.each(e.drop_element,function(e){s.push(function(i){var s=new t.file.FileDrop(l.extend({},a,{drop_zone:e}));s.onready=function(){var e=o.getInfo(this.ruid);l.extend(n.features,{chunks:e.can("slice_blob"),multipart:e.can("send_multipart"),dragdrop:e.can("drag_and_drop")}),r++,P.push(this),i()},s.ondrop=function(){n.addFile(this.files)},s.bind("error runtimeerror",function(){s=null,i()}),s.init()})}),l.inSeries(s,function(){"function"==typeof i&&i(r)})}function g(e,n,r,s){var a=new t.image.Image;try{a.onload=function(){n.width>this.width&&n.height>this.height&&n.quality===i&&n.preserve_headers&&!n.crop?(this.destroy(),s(e)):a.downsize(n.width,n.height,n.crop,n.preserve_headers)},a.onresize=function(){var t=this.getAsBlob(e.type,n.quality);this.destroy(),s(t)},a.bind("error runtimeerror",function(){this.destroy(),s(e)}),a.load(e,r)}catch(o){s(e)}}function h(e,i,r){function s(e,i,n){var r=O[e];switch(e){case"max_file_size":"max_file_size"===e&&(O.max_file_size=O.filters.max_file_size=i);break;case"chunk_size":(i=l.parseSize(i))&&(O[e]=i,O.send_file_name=!0);break;case"multipart":O[e]=i,i||(O.send_file_name=!0);break;case"http_method":O[e]="PUT"===i.toUpperCase()?"PUT":"POST";break;case"unique_names":O[e]=i,i&&(O.send_file_name=!0);break;case"filters":"array"===l.typeOf(i)&&(i={mime_types:i}),n?l.extend(O.filters,i):O.filters=i,i.mime_types&&("string"===l.typeOf(i.mime_types)&&(i.mime_types=t.core.utils.Mime.mimes2extList(i.mime_types)),i.mime_types.regexp=function(e){var t=[];return l.each(e,function(e){l.each(e.extensions.split(/,/),function(e){/^\s*\*\s*$/.test(e)?t.push("\\.*"):t.push("\\."+e.replace(new RegExp("["+"/^$.*+?|()[]{}\\".replace(/./g,"\\$&")+"]","g"),"\\$&"))})}),new RegExp("("+t.join("|")+")$","i")}(i.mime_types),O.filters.mime_types=i.mime_types);break;case"resize":O.resize=i?l.extend({preserve_headers:!0,crop:!1},i):!1;break;case"prevent_duplicates":O.prevent_duplicates=O.filters.prevent_duplicates=!!i;break;case"container":case"browse_button":case"drop_element":i="container"===e?l.get(i):l.getAll(i);case"runtimes":case"multi_selection":case"flash_swf_url":case"silverlight_xap_url":O[e]=i,n||(u=!0);break;default:O[e]=i}n||a.trigger("OptionChanged",e,i,r)}var a=this,u=!1;"object"==typeof e?l.each(e,function(e,t){s(t,e,r)}):s(e,i,r),r?(O.required_features=n(l.extend({},O)),x=n(l.extend({},O,{required_features:!0}))):u&&(a.trigger("Destroy"),p.call(a,O,function(e){e?(a.runtime=o.getInfo(c()).type,a.trigger("Init",{runtime:a.runtime}),a.trigger("PostInit")):a.trigger("Error",{code:l.INIT_ERROR,message:l.translate("Init error.")})}))}function m(e,t){if(e.settings.unique_names){var i=t.name.match(/\.([^.]+)$/),n="part";i&&(n=i[1]),t.target_name=t.id+"."+n}}function _(e,i){function n(){c-->0?r(s,1e3):(i.loaded=p,e.trigger("Error",{code:l.HTTP_ERROR,message:l.translate("HTTP Error."),file:i,response:T.responseText,status:T.status,responseHeaders:T.getAllResponseHeaders()}))}function s(){var t,n,r={};i.status===l.UPLOADING&&e.state!==l.STOPPED&&(e.settings.send_file_name&&(r.name=i.target_name||i.name),d&&f.chunks&&o.size>d?(n=Math.min(d,o.size-p),t=o.slice(p,p+n)):(n=o.size,t=o),d&&f.chunks&&(e.settings.send_chunk_number?(r.chunk=Math.ceil(p/d),r.chunks=Math.ceil(o.size/d)):(r.offset=p,r.total=o.size)),e.trigger("BeforeChunkUpload",i,r,t,p)&&a(r,t,n))}function a(a,d,g){var m;T=new t.xhr.XMLHttpRequest,T.upload&&(T.upload.onprogress=function(t){i.loaded=Math.min(i.size,p+t.loaded),e.trigger("UploadProgress",i)}),T.onload=function(){return T.status<200||T.status>=400?(n(),void 0):(c=e.settings.max_retries,g<o.size?(d.destroy(),p+=g,i.loaded=Math.min(p,o.size),e.trigger("ChunkUploaded",i,{offset:i.loaded,total:o.size,response:T.responseText,status:T.status,responseHeaders:T.getAllResponseHeaders()}),"Android Browser"===l.ua.browser&&e.trigger("UploadProgress",i)):i.loaded=i.size,d=m=null,!p||p>=o.size?(i.size!=i.origSize&&(o.destroy(),o=null),e.trigger("UploadProgress",i),i.status=l.DONE,i.completeTimestamp=+new Date,e.trigger("FileUploaded",i,{response:T.responseText,status:T.status,responseHeaders:T.getAllResponseHeaders()})):r(s,1),void 0)},T.onerror=function(){n()},T.onloadend=function(){this.destroy()},e.settings.multipart&&f.multipart?(T.open(e.settings.http_method,u,!0),l.each(e.settings.headers,function(e,t){T.setRequestHeader(t,e)}),m=new t.xhr.FormData,l.each(l.extend(a,e.settings.multipart_params),function(e,t){m.append(t,e)}),m.append(e.settings.file_data_name,d),T.send(m,h)):(u=l.buildUrl(e.settings.url,l.extend(a,e.settings.multipart_params)),T.open(e.settings.http_method,u,!0),l.each(e.settings.headers,function(e,t){T.setRequestHeader(t,e)}),T.hasRequestHeader("Content-Type")||T.setRequestHeader("Content-Type","application/octet-stream"),T.send(d,h))}var o,u=e.settings.url,d=e.settings.chunk_size,c=e.settings.max_retries,f=e.features,p=0,h={runtime_order:e.settings.runtimes,required_caps:e.settings.required_features,preferred_caps:x,swf_url:e.settings.flash_swf_url,xap_url:e.settings.silverlight_xap_url};i.loaded&&(p=i.loaded=d?d*Math.floor(i.loaded/d):0),o=i.getSource(),l.isEmptyObj(e.settings.resize)||-1===l.inArray(o.type,["image/jpeg","image/png"])?s():g(o,e.settings.resize,h,function(e){o=e,i.size=e.size,s()})}function E(e,t){u(t)}function v(e){if(e.state==l.STARTED)S=+new Date;else if(e.state==l.STOPPED)for(var t=e.files.length-1;t>=0;t--)e.files[t].status==l.UPLOADING&&(e.files[t].status=l.QUEUED,d())}function b(){T&&T.abort()}function y(e){d(),r(function(){a.call(e)},1)}function R(e,t){t.code===l.INIT_ERROR?e.destroy():t.code===l.HTTP_ERROR&&(t.file.status=l.FAILED,t.file.completeTimestamp=+new Date,u(t.file),e.state==l.STARTED&&(e.trigger("CancelUpload"),r(function(){a.call(e)},1)))}function z(e){e.stop(),l.each(D,function(e){e.destroy()}),D=[],F.length&&(l.each(F,function(e){e.destroy()}),F=[]),P.length&&(l.each(P,function(e){e.destroy()}),P=[]),x={},U=!1,S=T=null,I.reset()}var O,S,I,T,w=l.guid(),D=[],x={},F=[],P=[],U=!1;O={chunk_size:0,file_data_name:"file",filters:{mime_types:[],max_file_size:0,prevent_duplicates:!1,prevent_empty:!0},flash_swf_url:"js/Moxie.swf",http_method:"POST",max_retries:0,multipart:!0,multi_selection:!0,resize:!1,runtimes:o.order,send_file_name:!0,send_chunk_number:!0,silverlight_xap_url:"js/Moxie.xap"},h.call(this,e,null,!0),I=new l.QueueProgress,l.extend(this,{id:w,uid:w,state:l.STOPPED,features:{},runtime:null,files:D,settings:O,total:I,init:function(){var e,t,i=this;return e=i.getOption("preinit"),"function"==typeof e?e(i):l.each(e,function(e,t){i.bind(t,e)}),f.call(i),l.each(["container","browse_button","drop_element"],function(e){return null===i.getOption(e)?(t={code:l.INIT_ERROR,message:l.sprintf(l.translate("%s specified, but cannot be found."),e)},!1):void 0}),t?i.trigger("Error",t):O.browse_button||O.drop_element?(p.call(i,O,function(e){var t=i.getOption("init");"function"==typeof t?t(i):l.each(t,function(e,t){i.bind(t,e)}),e?(i.runtime=o.getInfo(c()).type,i.trigger("Init",{runtime:i.runtime}),i.trigger("PostInit")):i.trigger("Error",{code:l.INIT_ERROR,message:l.translate("Init error.")})}),void 0):i.trigger("Error",{code:l.INIT_ERROR,message:l.translate("You must specify either browse_button or drop_element.")})},setOption:function(e,t){h.call(this,e,t,!this.runtime)},getOption:function(e){return e?O[e]:O},refresh:function(){F.length&&l.each(F,function(e){e.trigger("Refresh")}),this.trigger("Refresh")},start:function(){this.state!=l.STARTED&&(this.state=l.STARTED,this.trigger("StateChanged"),a.call(this))},stop:function(){this.state!=l.STOPPED&&(this.state=l.STOPPED,this.trigger("StateChanged"),this.trigger("CancelUpload"))},disableBrowse:function(){U=arguments[0]!==i?arguments[0]:!0,F.length&&l.each(F,function(e){e.disable(U)}),this.trigger("DisableBrowse",U)},getFile:function(e){var t;for(t=D.length-1;t>=0;t--)if(D[t].id===e)return D[t]},addFile:function(e,i){function n(e,t){var i=[];l.each(u.settings.filters,function(t,n){s[n]&&i.push(function(i){s[n].call(u,t,e,function(e){i(!e)})})}),l.inSeries(i,t)}function a(e){var s=l.typeOf(e);if(e instanceof t.file.File){if(!e.ruid&&!e.isDetached()){if(!o)return!1;e.ruid=o,e.connectRuntime(o)}a(new l.File(e))}else e instanceof t.file.Blob?(a(e.getSource()),e.destroy()):e instanceof l.File?(i&&(e.name=i),d.push(function(t){n(e,function(i){i||(D.push(e),f.push(e),u.trigger("FileFiltered",e)),r(t,1)})})):-1!==l.inArray(s,["file","blob"])?a(new t.file.File(null,e)):"node"===s&&"filelist"===l.typeOf(e.files)?l.each(e.files,a):"array"===s&&(i=null,l.each(e,a))}var o,u=this,d=[],f=[];o=c(),a(e),d.length&&l.inSeries(d,function(){f.length&&u.trigger("FilesAdded",f)})},removeFile:function(e){for(var t="string"==typeof e?e:e.id,i=D.length-1;i>=0;i--)if(D[i].id===t)return this.splice(i,1)[0]},splice:function(e,t){var n=D.splice(e===i?0:e,t===i?D.length:t),r=!1;return this.state==l.STARTED&&(l.each(n,function(e){return e.status===l.UPLOADING?(r=!0,!1):void 0}),r&&this.stop()),this.trigger("FilesRemoved",n),l.each(n,function(e){e.destroy()}),r&&this.start(),n},dispatchEvent:function(e){var t,i;if(e=e.toLowerCase(),t=this.hasEventListener(e)){t.sort(function(e,t){return t.priority-e.priority}),i=[].slice.call(arguments),i.shift(),i.unshift(this);for(var n=0;n<t.length;n++)if(t[n].fn.apply(t[n].scope,i)===!1)return!1}return!0},bind:function(e,t,i,n){l.Uploader.prototype.bind.call(this,e,t,n,i)},destroy:function(){this.trigger("Destroy"),O=I=null,this.unbindAll()}})},l.Uploader.prototype=t.core.EventTarget.instance,l.File=function(){function e(e){l.extend(this,{id:l.guid(),name:e.name||e.fileName,type:e.type||"",relativePath:e.relativePath||"",size:e.fileSize||e.size,origSize:e.fileSize||e.size,loaded:0,percent:0,status:l.QUEUED,lastModifiedDate:e.lastModifiedDate||(new Date).toLocaleString(),completeTimestamp:0,getNative:function(){var e=this.getSource().getSource();return-1!==l.inArray(l.typeOf(e),["blob","file"])?e:null},getSource:function(){return t[this.id]?t[this.id]:null},destroy:function(){var e=this.getSource();e&&(e.destroy(),delete t[this.id])}}),t[this.id]=e}var t={};return e}(),l.QueueProgress=function(){var e=this;e.size=0,e.loaded=0,e.uploaded=0,e.failed=0,e.queued=0,e.percent=0,e.bytesPerSec=0,e.reset=function(){e.size=e.loaded=e.uploaded=e.failed=e.queued=e.percent=e.bytesPerSec=0}},e.plupload=l}(this,e)});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(56);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(150);
var isBuffer = __webpack_require__(1132);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(34);
var createDesc = __webpack_require__(73);
module.exports = __webpack_require__(33) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var hide = __webpack_require__(39);
var has = __webpack_require__(43);
var SRC = __webpack_require__(77)('src');
var $toString = __webpack_require__(671);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(50).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var fails = __webpack_require__(28);
var defined = __webpack_require__(56);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreetViewPanorama = exports.MountableMixin = exports.Autocomplete = exports.MapElementFactory = exports.MapElementMixin = exports.PlaceInput = exports.Map = exports.InfoWindow = exports.Rectangle = exports.Cluster = exports.Circle = exports.Polygon = exports.Polyline = exports.Marker = exports.loadGmapApi = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Vue component imports


exports.install = install;
exports.gmapApi = gmapApi;

var _lazyValue = __webpack_require__(1994);

var _lazyValue2 = _interopRequireDefault(_lazyValue);

var _manager = __webpack_require__(1993);

var _marker = __webpack_require__(1988);

var _marker2 = _interopRequireDefault(_marker);

var _polyline = __webpack_require__(1990);

var _polyline2 = _interopRequireDefault(_polyline);

var _polygon = __webpack_require__(1989);

var _polygon2 = _interopRequireDefault(_polygon);

var _circle = __webpack_require__(1985);

var _circle2 = _interopRequireDefault(_circle);

var _rectangle = __webpack_require__(1991);

var _rectangle2 = _interopRequireDefault(_rectangle);

var _infoWindow = __webpack_require__(1431);

var _infoWindow2 = _interopRequireDefault(_infoWindow);

var _map = __webpack_require__(1432);

var _map2 = _interopRequireDefault(_map);

var _streetViewPanorama = __webpack_require__(1434);

var _streetViewPanorama2 = _interopRequireDefault(_streetViewPanorama);

var _placeInput = __webpack_require__(1433);

var _placeInput2 = _interopRequireDefault(_placeInput);

var _autocomplete = __webpack_require__(1430);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _mapElementMixin = __webpack_require__(629);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _mapElementFactory = __webpack_require__(59);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

var _mountableMixin = __webpack_require__(140);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// HACK: Cluster should be loaded conditionally
// However in the web version, it's not possible to write
// `import 'vue2-google-maps/src/components/cluster'`, so we need to
// import it anyway (but we don't have to register it)
// Therefore we use babel-plugin-transform-inline-environment-variables to
// set BUILD_DEV to truthy / falsy
var Cluster = undefined;

var GmapApi = null;

// export everything
exports.loadGmapApi = _manager.loadGmapApi;
exports.Marker = _marker2.default;
exports.Polyline = _polyline2.default;
exports.Polygon = _polygon2.default;
exports.Circle = _circle2.default;
exports.Cluster = Cluster;
exports.Rectangle = _rectangle2.default;
exports.InfoWindow = _infoWindow2.default;
exports.Map = _map2.default;
exports.PlaceInput = _placeInput2.default;
exports.MapElementMixin = _mapElementMixin2.default;
exports.MapElementFactory = _mapElementFactory2.default;
exports.Autocomplete = _autocomplete2.default;
exports.MountableMixin = _mountableMixin2.default;
exports.StreetViewPanorama = _streetViewPanorama2.default;
function install(Vue, options) {
  // Set defaults
  options = _extends({
    installComponents: true,
    autobindAllEvents: false
  }, options);

  // Update the global `GmapApi`. This will allow
  // components to use the `google` global reactively
  // via:
  //   import {gmapApi} from 'vue2-google-maps'
  //   export default {  computed: { google: gmapApi }  }
  GmapApi = new Vue({ data: { gmapApi: null } });

  var defaultResizeBus = new Vue();

  // Use a lazy to only load the API when
  // a VGM component is loaded
  var gmapApiPromiseLazy = makeGmapApiPromiseLazy(options);

  Vue.mixin({
    created: function created() {
      this.$gmapDefaultResizeBus = defaultResizeBus;
      this.$gmapOptions = options;
      this.$gmapApiPromiseLazy = gmapApiPromiseLazy;
    }
  });
  Vue.$gmapDefaultResizeBus = defaultResizeBus;
  Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy;

  if (options.installComponents) {
    Vue.component('GmapMap', _map2.default);
    Vue.component('GmapMarker', _marker2.default);
    Vue.component('GmapInfoWindow', _infoWindow2.default);
    Vue.component('GmapPolyline', _polyline2.default);
    Vue.component('GmapPolygon', _polygon2.default);
    Vue.component('GmapCircle', _circle2.default);
    Vue.component('GmapRectangle', _rectangle2.default);
    Vue.component('GmapAutocomplete', _autocomplete2.default);
    Vue.component('GmapPlaceInput', _placeInput2.default);
    Vue.component('GmapStreetViewPanorama', _streetViewPanorama2.default);
  }
}

function makeGmapApiPromiseLazy(options) {
  // Things to do once the API is loaded
  function onApiLoaded() {
    GmapApi.gmapApi = {};
    return window.google;
  }

  if (options.load) {
    // If library should load the API
    return (0, _lazyValue2.default)(function () {
      // Load the
      // This will only be evaluated once
      if (typeof window === 'undefined') {
        // server side -- never resolve this promise
        return new Promise(function () {}).then(onApiLoaded);
      } else {
        return new Promise(function (resolve, reject) {
          try {
            window['vueGoogleMapsInit'] = resolve;
            (0, _manager.loadGmapApi)(options.load, options.loadCn);
          } catch (err) {
            reject(err);
          }
        }).then(onApiLoaded);
      }
    });
  } else {
    // If library should not handle API, provide
    // end-users with the global `vueGoogleMapsInit: () => undefined`
    // when the Google Maps API has been loaded
    var promise = new Promise(function (resolve) {
      if (typeof window === 'undefined') {
        // Do nothing if run from server-side
        return;
      }
      window['vueGoogleMapsInit'] = resolve;
    }).then(onApiLoaded);

    return (0, _lazyValue2.default)(function () {
      return promise;
    });
  }
}

function gmapApi() {
  return GmapApi.gmapApi && window.google;
}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(87);
var createDesc = __webpack_require__(73);
var toIObject = __webpack_require__(46);
var toPrimitive = __webpack_require__(58);
var has = __webpack_require__(43);
var IE8_DOM_DEFINE = __webpack_require__(455);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(33) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(43);
var toObject = __webpack_require__(36);
var IE_PROTO = __webpack_require__(125)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(86);
var defined = __webpack_require__(56);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! DataTables 1.10.19
 * ©2008-2018 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     DataTables
 * @description Paginate, search and order HTML tables
 * @version     1.10.19
 * @file        jquery.dataTables.js
 * @author      SpryMedia Ltd
 * @contact     www.datatables.net
 * @copyright   Copyright 2008-2018 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */

/*jslint evil: true, undef: true, browser: true */
/*globals $,require,jQuery,define,_selector_run,_selector_opts,_selector_first,_selector_row_indexes,_ext,_Api,_api_register,_api_registerPlural,_re_new_lines,_re_html,_re_formatted_numeric,_re_escape_regex,_empty,_intVal,_numToDecimal,_isNumber,_isHtml,_htmlNumeric,_pluck,_pluck_order,_range,_stripHtml,_unique,_fnBuildAjax,_fnAjaxUpdate,_fnAjaxParameters,_fnAjaxUpdateDraw,_fnAjaxDataSrc,_fnAddColumn,_fnColumnOptions,_fnAdjustColumnSizing,_fnVisibleToColumnIndex,_fnColumnIndexToVisible,_fnVisbleColumns,_fnGetColumns,_fnColumnTypes,_fnApplyColumnDefs,_fnHungarianMap,_fnCamelToHungarian,_fnLanguageCompat,_fnBrowserDetect,_fnAddData,_fnAddTr,_fnNodeToDataIndex,_fnNodeToColumnIndex,_fnGetCellData,_fnSetCellData,_fnSplitObjNotation,_fnGetObjectDataFn,_fnSetObjectDataFn,_fnGetDataMaster,_fnClearTable,_fnDeleteIndex,_fnInvalidate,_fnGetRowElements,_fnCreateTr,_fnBuildHead,_fnDrawHead,_fnDraw,_fnReDraw,_fnAddOptionsHtml,_fnDetectHeader,_fnGetUniqueThs,_fnFeatureHtmlFilter,_fnFilterComplete,_fnFilterCustom,_fnFilterColumn,_fnFilter,_fnFilterCreateSearch,_fnEscapeRegex,_fnFilterData,_fnFeatureHtmlInfo,_fnUpdateInfo,_fnInfoMacros,_fnInitialise,_fnInitComplete,_fnLengthChange,_fnFeatureHtmlLength,_fnFeatureHtmlPaginate,_fnPageChange,_fnFeatureHtmlProcessing,_fnProcessingDisplay,_fnFeatureHtmlTable,_fnScrollDraw,_fnApplyToChildren,_fnCalculateColumnWidths,_fnThrottle,_fnConvertToWidth,_fnGetWidestNode,_fnGetMaxLenString,_fnStringToCss,_fnSortFlatten,_fnSort,_fnSortAria,_fnSortListener,_fnSortAttachListener,_fnSortingClasses,_fnSortData,_fnSaveState,_fnLoadState,_fnSettingsFromNode,_fnLog,_fnMap,_fnBindAction,_fnCallbackReg,_fnCallbackFire,_fnLengthOverflow,_fnRenderer,_fnDataSource,_fnRowAttributes*/

(function( factory ) {
	"use strict";

	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				// CommonJS environments without a window global must pass a
				// root. This will give an error otherwise
				root = window;
			}

			if ( ! $ ) {
				$ = typeof window !== 'undefined' ? // jQuery's factory checks for a global window
					require('jquery') :
					require('jquery')( root );
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}
(function( $, window, document, undefined ) {
	"use strict";

	/**
	 * DataTables is a plug-in for the jQuery Javascript library. It is a highly
	 * flexible tool, based upon the foundations of progressive enhancement,
	 * which will add advanced interaction controls to any HTML table. For a
	 * full list of features please refer to
	 * [DataTables.net](href="http://datatables.net).
	 *
	 * Note that the `DataTable` object is not a global variable but is aliased
	 * to `jQuery.fn.DataTable` and `jQuery.fn.dataTable` through which it may
	 * be  accessed.
	 *
	 *  @class
	 *  @param {object} [init={}] Configuration object for DataTables. Options
	 *    are defined by {@link DataTable.defaults}
	 *  @requires jQuery 1.7+
	 *
	 *  @example
	 *    // Basic initialisation
	 *    $(document).ready( function {
	 *      $('#example').dataTable();
	 *    } );
	 *
	 *  @example
	 *    // Initialisation with configuration options - in this case, disable
	 *    // pagination and sorting.
	 *    $(document).ready( function {
	 *      $('#example').dataTable( {
	 *        "paginate": false,
	 *        "sort": false
	 *      } );
	 *    } );
	 */
	var DataTable = function ( options )
	{
		/**
		 * Perform a jQuery selector action on the table's TR elements (from the tbody) and
		 * return the resulting jQuery object.
		 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
		 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
		 *  @param {string} [oOpts.filter=none] Select TR elements that meet the current filter
		 *    criterion ("applied") or all TR elements (i.e. no filter).
		 *  @param {string} [oOpts.order=current] Order of the TR elements in the processed array.
		 *    Can be either 'current', whereby the current sorting of the table is used, or
		 *    'original' whereby the original order the data was read into the table is used.
		 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
		 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
		 *    'current' and filter is 'applied', regardless of what they might be given as.
		 *  @returns {object} jQuery object, filtered by the given selector.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Highlight every second row
		 *      oTable.$('tr:odd').css('backgroundColor', 'blue');
		 *    } );
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Filter to rows with 'Webkit' in them, add a background colour and then
		 *      // remove the filter, thus highlighting the 'Webkit' rows only.
		 *      oTable.fnFilter('Webkit');
		 *      oTable.$('tr', {"search": "applied"}).css('backgroundColor', 'blue');
		 *      oTable.fnFilter('');
		 *    } );
		 */
		this.$ = function ( sSelector, oOpts )
		{
			return this.api(true).$( sSelector, oOpts );
		};
		
		
		/**
		 * Almost identical to $ in operation, but in this case returns the data for the matched
		 * rows - as such, the jQuery selector used should match TR row nodes or TD/TH cell nodes
		 * rather than any descendants, so the data can be obtained for the row/cell. If matching
		 * rows are found, the data returned is the original data array/object that was used to
		 * create the row (or a generated array if from a DOM source).
		 *
		 * This method is often useful in-combination with $ where both functions are given the
		 * same parameters and the array indexes will match identically.
		 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
		 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
		 *  @param {string} [oOpts.filter=none] Select elements that meet the current filter
		 *    criterion ("applied") or all elements (i.e. no filter).
		 *  @param {string} [oOpts.order=current] Order of the data in the processed array.
		 *    Can be either 'current', whereby the current sorting of the table is used, or
		 *    'original' whereby the original order the data was read into the table is used.
		 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
		 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
		 *    'current' and filter is 'applied', regardless of what they might be given as.
		 *  @returns {array} Data for the matched elements. If any elements, as a result of the
		 *    selector, were not TR, TD or TH elements in the DataTable, they will have a null
		 *    entry in the array.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Get the data from the first row in the table
		 *      var data = oTable._('tr:first');
		 *
		 *      // Do something useful with the data
		 *      alert( "First cell is: "+data[0] );
		 *    } );
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Filter to 'Webkit' and get all data for
		 *      oTable.fnFilter('Webkit');
		 *      var data = oTable._('tr', {"search": "applied"});
		 *
		 *      // Do something with the data
		 *      alert( data.length+" rows matched the search" );
		 *    } );
		 */
		this._ = function ( sSelector, oOpts )
		{
			return this.api(true).rows( sSelector, oOpts ).data();
		};
		
		
		/**
		 * Create a DataTables Api instance, with the currently selected tables for
		 * the Api's context.
		 * @param {boolean} [traditional=false] Set the API instance's context to be
		 *   only the table referred to by the `DataTable.ext.iApiIndex` option, as was
		 *   used in the API presented by DataTables 1.9- (i.e. the traditional mode),
		 *   or if all tables captured in the jQuery object should be used.
		 * @return {DataTables.Api}
		 */
		this.api = function ( traditional )
		{
			return traditional ?
				new _Api(
					_fnSettingsFromNode( this[ _ext.iApiIndex ] )
				) :
				new _Api( this );
		};
		
		
		/**
		 * Add a single new row or multiple rows of data to the table. Please note
		 * that this is suitable for client-side processing only - if you are using
		 * server-side processing (i.e. "bServerSide": true), then to add data, you
		 * must add it to the data source, i.e. the server-side, through an Ajax call.
		 *  @param {array|object} data The data to be added to the table. This can be:
		 *    <ul>
		 *      <li>1D array of data - add a single row with the data provided</li>
		 *      <li>2D array of arrays - add multiple rows in a single call</li>
		 *      <li>object - data object when using <i>mData</i></li>
		 *      <li>array of objects - multiple data objects when using <i>mData</i></li>
		 *    </ul>
		 *  @param {bool} [redraw=true] redraw the table or not
		 *  @returns {array} An array of integers, representing the list of indexes in
		 *    <i>aoData</i> ({@link DataTable.models.oSettings}) that have been added to
		 *    the table.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    // Global var for counter
		 *    var giCount = 2;
		 *
		 *    $(document).ready(function() {
		 *      $('#example').dataTable();
		 *    } );
		 *
		 *    function fnClickAddRow() {
		 *      $('#example').dataTable().fnAddData( [
		 *        giCount+".1",
		 *        giCount+".2",
		 *        giCount+".3",
		 *        giCount+".4" ]
		 *      );
		 *
		 *      giCount++;
		 *    }
		 */
		this.fnAddData = function( data, redraw )
		{
			var api = this.api( true );
		
			/* Check if we want to add multiple rows or not */
			var rows = $.isArray(data) && ( $.isArray(data[0]) || $.isPlainObject(data[0]) ) ?
				api.rows.add( data ) :
				api.row.add( data );
		
			if ( redraw === undefined || redraw ) {
				api.draw();
			}
		
			return rows.flatten().toArray();
		};
		
		
		/**
		 * This function will make DataTables recalculate the column sizes, based on the data
		 * contained in the table and the sizes applied to the columns (in the DOM, CSS or
		 * through the sWidth parameter). This can be useful when the width of the table's
		 * parent element changes (for example a window resize).
		 *  @param {boolean} [bRedraw=true] Redraw the table or not, you will typically want to
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable( {
		 *        "sScrollY": "200px",
		 *        "bPaginate": false
		 *      } );
		 *
		 *      $(window).on('resize', function () {
		 *        oTable.fnAdjustColumnSizing();
		 *      } );
		 *    } );
		 */
		this.fnAdjustColumnSizing = function ( bRedraw )
		{
			var api = this.api( true ).columns.adjust();
			var settings = api.settings()[0];
			var scroll = settings.oScroll;
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw( false );
			}
			else if ( scroll.sX !== "" || scroll.sY !== "" ) {
				/* If not redrawing, but scrolling, we want to apply the new column sizes anyway */
				_fnScrollDraw( settings );
			}
		};
		
		
		/**
		 * Quickly and simply clear a table
		 *  @param {bool} [bRedraw=true] redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Immediately 'nuke' the current rows (perhaps waiting for an Ajax callback...)
		 *      oTable.fnClearTable();
		 *    } );
		 */
		this.fnClearTable = function( bRedraw )
		{
			var api = this.api( true ).clear();
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw();
			}
		};
		
		
		/**
		 * The exact opposite of 'opening' a row, this function will close any rows which
		 * are currently 'open'.
		 *  @param {node} nTr the table row to 'close'
		 *  @returns {int} 0 on success, or 1 if failed (can't find the row)
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnClose = function( nTr )
		{
			this.api( true ).row( nTr ).child.hide();
		};
		
		
		/**
		 * Remove a row for the table
		 *  @param {mixed} target The index of the row from aoData to be deleted, or
		 *    the TR element you want to delete
		 *  @param {function|null} [callBack] Callback function
		 *  @param {bool} [redraw=true] Redraw the table or not
		 *  @returns {array} The row that was deleted
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Immediately remove the first row
		 *      oTable.fnDeleteRow( 0 );
		 *    } );
		 */
		this.fnDeleteRow = function( target, callback, redraw )
		{
			var api = this.api( true );
			var rows = api.rows( target );
			var settings = rows.settings()[0];
			var data = settings.aoData[ rows[0][0] ];
		
			rows.remove();
		
			if ( callback ) {
				callback.call( this, settings, data );
			}
		
			if ( redraw === undefined || redraw ) {
				api.draw();
			}
		
			return data;
		};
		
		
		/**
		 * Restore the table to it's original state in the DOM by removing all of DataTables
		 * enhancements, alterations to the DOM structure of the table and event listeners.
		 *  @param {boolean} [remove=false] Completely remove the table from the DOM
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      // This example is fairly pointless in reality, but shows how fnDestroy can be used
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnDestroy();
		 *    } );
		 */
		this.fnDestroy = function ( remove )
		{
			this.api( true ).destroy( remove );
		};
		
		
		/**
		 * Redraw the table
		 *  @param {bool} [complete=true] Re-filter and resort (if enabled) the table before the draw.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Re-draw the table - you wouldn't want to do it here, but it's an example :-)
		 *      oTable.fnDraw();
		 *    } );
		 */
		this.fnDraw = function( complete )
		{
			// Note that this isn't an exact match to the old call to _fnDraw - it takes
			// into account the new data, but can hold position.
			this.api( true ).draw( complete );
		};
		
		
		/**
		 * Filter the input based on data
		 *  @param {string} sInput String to filter the table on
		 *  @param {int|null} [iColumn] Column to limit filtering to
		 *  @param {bool} [bRegex=false] Treat as regular expression or not
		 *  @param {bool} [bSmart=true] Perform smart filtering or not
		 *  @param {bool} [bShowGlobal=true] Show the input global filter in it's input box(es)
		 *  @param {bool} [bCaseInsensitive=true] Do case-insensitive matching (true) or not (false)
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sometime later - filter...
		 *      oTable.fnFilter( 'test string' );
		 *    } );
		 */
		this.fnFilter = function( sInput, iColumn, bRegex, bSmart, bShowGlobal, bCaseInsensitive )
		{
			var api = this.api( true );
		
			if ( iColumn === null || iColumn === undefined ) {
				api.search( sInput, bRegex, bSmart, bCaseInsensitive );
			}
			else {
				api.column( iColumn ).search( sInput, bRegex, bSmart, bCaseInsensitive );
			}
		
			api.draw();
		};
		
		
		/**
		 * Get the data for the whole table, an individual row or an individual cell based on the
		 * provided parameters.
		 *  @param {int|node} [src] A TR row node, TD/TH cell node or an integer. If given as
		 *    a TR node then the data source for the whole row will be returned. If given as a
		 *    TD/TH cell node then iCol will be automatically calculated and the data for the
		 *    cell returned. If given as an integer, then this is treated as the aoData internal
		 *    data index for the row (see fnGetPosition) and the data for that row used.
		 *  @param {int} [col] Optional column index that you want the data of.
		 *  @returns {array|object|string} If mRow is undefined, then the data for all rows is
		 *    returned. If mRow is defined, just data for that row, and is iCol is
		 *    defined, only data for the designated cell is returned.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    // Row data
		 *    $(document).ready(function() {
		 *      oTable = $('#example').dataTable();
		 *
		 *      oTable.$('tr').click( function () {
		 *        var data = oTable.fnGetData( this );
		 *        // ... do something with the array / object of data for the row
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Individual cell data
		 *    $(document).ready(function() {
		 *      oTable = $('#example').dataTable();
		 *
		 *      oTable.$('td').click( function () {
		 *        var sData = oTable.fnGetData( this );
		 *        alert( 'The cell clicked on had the value of '+sData );
		 *      } );
		 *    } );
		 */
		this.fnGetData = function( src, col )
		{
			var api = this.api( true );
		
			if ( src !== undefined ) {
				var type = src.nodeName ? src.nodeName.toLowerCase() : '';
		
				return col !== undefined || type == 'td' || type == 'th' ?
					api.cell( src, col ).data() :
					api.row( src ).data() || null;
			}
		
			return api.data().toArray();
		};
		
		
		/**
		 * Get an array of the TR nodes that are used in the table's body. Note that you will
		 * typically want to use the '$' API method in preference to this as it is more
		 * flexible.
		 *  @param {int} [iRow] Optional row index for the TR element you want
		 *  @returns {array|node} If iRow is undefined, returns an array of all TR elements
		 *    in the table's body, or iRow is defined, just the TR element requested.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Get the nodes from the table
		 *      var nNodes = oTable.fnGetNodes( );
		 *    } );
		 */
		this.fnGetNodes = function( iRow )
		{
			var api = this.api( true );
		
			return iRow !== undefined ?
				api.row( iRow ).node() :
				api.rows().nodes().flatten().toArray();
		};
		
		
		/**
		 * Get the array indexes of a particular cell from it's DOM element
		 * and column index including hidden columns
		 *  @param {node} node this can either be a TR, TD or TH in the table's body
		 *  @returns {int} If nNode is given as a TR, then a single index is returned, or
		 *    if given as a cell, an array of [row index, column index (visible),
		 *    column index (all)] is given.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      $('#example tbody td').click( function () {
		 *        // Get the position of the current data from the node
		 *        var aPos = oTable.fnGetPosition( this );
		 *
		 *        // Get the data array for this row
		 *        var aData = oTable.fnGetData( aPos[0] );
		 *
		 *        // Update the data array and return the value
		 *        aData[ aPos[1] ] = 'clicked';
		 *        this.innerHTML = 'clicked';
		 *      } );
		 *
		 *      // Init DataTables
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnGetPosition = function( node )
		{
			var api = this.api( true );
			var nodeName = node.nodeName.toUpperCase();
		
			if ( nodeName == 'TR' ) {
				return api.row( node ).index();
			}
			else if ( nodeName == 'TD' || nodeName == 'TH' ) {
				var cell = api.cell( node ).index();
		
				return [
					cell.row,
					cell.columnVisible,
					cell.column
				];
			}
			return null;
		};
		
		
		/**
		 * Check to see if a row is 'open' or not.
		 *  @param {node} nTr the table row to check
		 *  @returns {boolean} true if the row is currently open, false otherwise
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnIsOpen = function( nTr )
		{
			return this.api( true ).row( nTr ).child.isShown();
		};
		
		
		/**
		 * This function will place a new row directly after a row which is currently
		 * on display on the page, with the HTML contents that is passed into the
		 * function. This can be used, for example, to ask for confirmation that a
		 * particular record should be deleted.
		 *  @param {node} nTr The table row to 'open'
		 *  @param {string|node|jQuery} mHtml The HTML to put into the row
		 *  @param {string} sClass Class to give the new TD cell
		 *  @returns {node} The row opened. Note that if the table row passed in as the
		 *    first parameter, is not found in the table, this method will silently
		 *    return.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnOpen = function( nTr, mHtml, sClass )
		{
			return this.api( true )
				.row( nTr )
				.child( mHtml, sClass )
				.show()
				.child()[0];
		};
		
		
		/**
		 * Change the pagination - provides the internal logic for pagination in a simple API
		 * function. With this function you can have a DataTables table go to the next,
		 * previous, first or last pages.
		 *  @param {string|int} mAction Paging action to take: "first", "previous", "next" or "last"
		 *    or page number to jump to (integer), note that page 0 is the first page.
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnPageChange( 'next' );
		 *    } );
		 */
		this.fnPageChange = function ( mAction, bRedraw )
		{
			var api = this.api( true ).page( mAction );
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw(false);
			}
		};
		
		
		/**
		 * Show a particular column
		 *  @param {int} iCol The column whose display should be changed
		 *  @param {bool} bShow Show (true) or hide (false) the column
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Hide the second column after initialisation
		 *      oTable.fnSetColumnVis( 1, false );
		 *    } );
		 */
		this.fnSetColumnVis = function ( iCol, bShow, bRedraw )
		{
			var api = this.api( true ).column( iCol ).visible( bShow );
		
			if ( bRedraw === undefined || bRedraw ) {
				api.columns.adjust().draw();
			}
		};
		
		
		/**
		 * Get the settings for a particular table for external manipulation
		 *  @returns {object} DataTables settings object. See
		 *    {@link DataTable.models.oSettings}
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      var oSettings = oTable.fnSettings();
		 *
		 *      // Show an example parameter from the settings
		 *      alert( oSettings._iDisplayStart );
		 *    } );
		 */
		this.fnSettings = function()
		{
			return _fnSettingsFromNode( this[_ext.iApiIndex] );
		};
		
		
		/**
		 * Sort the table by a particular column
		 *  @param {int} iCol the data index to sort on. Note that this will not match the
		 *    'display index' if you have hidden data entries
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sort immediately with columns 0 and 1
		 *      oTable.fnSort( [ [0,'asc'], [1,'asc'] ] );
		 *    } );
		 */
		this.fnSort = function( aaSort )
		{
			this.api( true ).order( aaSort ).draw();
		};
		
		
		/**
		 * Attach a sort listener to an element for a given column
		 *  @param {node} nNode the element to attach the sort listener to
		 *  @param {int} iColumn the column that a click on this node will sort on
		 *  @param {function} [fnCallback] callback function when sort is run
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sort on column 1, when 'sorter' is clicked on
		 *      oTable.fnSortListener( document.getElementById('sorter'), 1 );
		 *    } );
		 */
		this.fnSortListener = function( nNode, iColumn, fnCallback )
		{
			this.api( true ).order.listener( nNode, iColumn, fnCallback );
		};
		
		
		/**
		 * Update a table cell or row - this method will accept either a single value to
		 * update the cell with, an array of values with one element for each column or
		 * an object in the same format as the original data source. The function is
		 * self-referencing in order to make the multi column updates easier.
		 *  @param {object|array|string} mData Data to update the cell/row with
		 *  @param {node|int} mRow TR element you want to update or the aoData index
		 *  @param {int} [iColumn] The column to update, give as null or undefined to
		 *    update a whole row.
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @param {bool} [bAction=true] Perform pre-draw actions or not
		 *  @returns {int} 0 on success, 1 on error
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnUpdate( 'Example update', 0, 0 ); // Single cell
		 *      oTable.fnUpdate( ['a', 'b', 'c', 'd', 'e'], $('tbody tr')[0] ); // Row
		 *    } );
		 */
		this.fnUpdate = function( mData, mRow, iColumn, bRedraw, bAction )
		{
			var api = this.api( true );
		
			if ( iColumn === undefined || iColumn === null ) {
				api.row( mRow ).data( mData );
			}
			else {
				api.cell( mRow, iColumn ).data( mData );
			}
		
			if ( bAction === undefined || bAction ) {
				api.columns.adjust();
			}
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw();
			}
			return 0;
		};
		
		
		/**
		 * Provide a common method for plug-ins to check the version of DataTables being used, in order
		 * to ensure compatibility.
		 *  @param {string} sVersion Version string to check for, in the format "X.Y.Z". Note that the
		 *    formats "X" and "X.Y" are also acceptable.
		 *  @returns {boolean} true if this version of DataTables is greater or equal to the required
		 *    version, or false if this version of DataTales is not suitable
		 *  @method
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      alert( oTable.fnVersionCheck( '1.9.0' ) );
		 *    } );
		 */
		this.fnVersionCheck = _ext.fnVersionCheck;
		

		var _that = this;
		var emptyInit = options === undefined;
		var len = this.length;

		if ( emptyInit ) {
			options = {};
		}

		this.oApi = this.internal = _ext.internal;

		// Extend with old style plug-in API methods
		for ( var fn in DataTable.ext.internal ) {
			if ( fn ) {
				this[fn] = _fnExternApiFunc(fn);
			}
		}

		this.each(function() {
			// For each initialisation we want to give it a clean initialisation
			// object that can be bashed around
			var o = {};
			var oInit = len > 1 ? // optimisation for single table case
				_fnExtend( o, options, true ) :
				options;

			/*global oInit,_that,emptyInit*/
			var i=0, iLen, j, jLen, k, kLen;
			var sId = this.getAttribute( 'id' );
			var bInitHandedOff = false;
			var defaults = DataTable.defaults;
			var $this = $(this);
			
			
			/* Sanity check */
			if ( this.nodeName.toLowerCase() != 'table' )
			{
				_fnLog( null, 0, 'Non-table node initialisation ('+this.nodeName+')', 2 );
				return;
			}
			
			/* Backwards compatibility for the defaults */
			_fnCompatOpts( defaults );
			_fnCompatCols( defaults.column );
			
			/* Convert the camel-case defaults to Hungarian */
			_fnCamelToHungarian( defaults, defaults, true );
			_fnCamelToHungarian( defaults.column, defaults.column, true );
			
			/* Setting up the initialisation object */
			_fnCamelToHungarian( defaults, $.extend( oInit, $this.data() ) );
			
			
			
			/* Check to see if we are re-initialising a table */
			var allSettings = DataTable.settings;
			for ( i=0, iLen=allSettings.length ; i<iLen ; i++ )
			{
				var s = allSettings[i];
			
				/* Base check on table node */
				if (
					s.nTable == this ||
					(s.nTHead && s.nTHead.parentNode == this) ||
					(s.nTFoot && s.nTFoot.parentNode == this)
				) {
					var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
					var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
			
					if ( emptyInit || bRetrieve )
					{
						return s.oInstance;
					}
					else if ( bDestroy )
					{
						s.oInstance.fnDestroy();
						break;
					}
					else
					{
						_fnLog( s, 0, 'Cannot reinitialise DataTable', 3 );
						return;
					}
				}
			
				/* If the element we are initialising has the same ID as a table which was previously
				 * initialised, but the table nodes don't match (from before) then we destroy the old
				 * instance by simply deleting it. This is under the assumption that the table has been
				 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
				 */
				if ( s.sTableId == this.id )
				{
					allSettings.splice( i, 1 );
					break;
				}
			}
			
			/* Ensure the table has an ID - required for accessibility */
			if ( sId === null || sId === "" )
			{
				sId = "DataTables_Table_"+(DataTable.ext._unique++);
				this.id = sId;
			}
			
			/* Create the settings object for this table and set some of the default parameters */
			var oSettings = $.extend( true, {}, DataTable.models.oSettings, {
				"sDestroyWidth": $this[0].style.width,
				"sInstance":     sId,
				"sTableId":      sId
			} );
			oSettings.nTable = this;
			oSettings.oApi   = _that.internal;
			oSettings.oInit  = oInit;
			
			allSettings.push( oSettings );
			
			// Need to add the instance after the instance after the settings object has been added
			// to the settings array, so we can self reference the table instance if more than one
			oSettings.oInstance = (_that.length===1) ? _that : $this.dataTable();
			
			// Backwards compatibility, before we apply all the defaults
			_fnCompatOpts( oInit );
			_fnLanguageCompat( oInit.oLanguage );
			
			// If the length menu is given, but the init display length is not, use the length menu
			if ( oInit.aLengthMenu && ! oInit.iDisplayLength )
			{
				oInit.iDisplayLength = $.isArray( oInit.aLengthMenu[0] ) ?
					oInit.aLengthMenu[0][0] : oInit.aLengthMenu[0];
			}
			
			// Apply the defaults and init options to make a single init object will all
			// options defined from defaults and instance options.
			oInit = _fnExtend( $.extend( true, {}, defaults ), oInit );
			
			
			// Map the initialisation options onto the settings object
			_fnMap( oSettings.oFeatures, oInit, [
				"bPaginate",
				"bLengthChange",
				"bFilter",
				"bSort",
				"bSortMulti",
				"bInfo",
				"bProcessing",
				"bAutoWidth",
				"bSortClasses",
				"bServerSide",
				"bDeferRender"
			] );
			_fnMap( oSettings, oInit, [
				"asStripeClasses",
				"ajax",
				"fnServerData",
				"fnFormatNumber",
				"sServerMethod",
				"aaSorting",
				"aaSortingFixed",
				"aLengthMenu",
				"sPaginationType",
				"sAjaxSource",
				"sAjaxDataProp",
				"iStateDuration",
				"sDom",
				"bSortCellsTop",
				"iTabIndex",
				"fnStateLoadCallback",
				"fnStateSaveCallback",
				"renderer",
				"searchDelay",
				"rowId",
				[ "iCookieDuration", "iStateDuration" ], // backwards compat
				[ "oSearch", "oPreviousSearch" ],
				[ "aoSearchCols", "aoPreSearchCols" ],
				[ "iDisplayLength", "_iDisplayLength" ]
			] );
			_fnMap( oSettings.oScroll, oInit, [
				[ "sScrollX", "sX" ],
				[ "sScrollXInner", "sXInner" ],
				[ "sScrollY", "sY" ],
				[ "bScrollCollapse", "bCollapse" ]
			] );
			_fnMap( oSettings.oLanguage, oInit, "fnInfoCallback" );
			
			/* Callback functions which are array driven */
			_fnCallbackReg( oSettings, 'aoDrawCallback',       oInit.fnDrawCallback,      'user' );
			_fnCallbackReg( oSettings, 'aoServerParams',       oInit.fnServerParams,      'user' );
			_fnCallbackReg( oSettings, 'aoStateSaveParams',    oInit.fnStateSaveParams,   'user' );
			_fnCallbackReg( oSettings, 'aoStateLoadParams',    oInit.fnStateLoadParams,   'user' );
			_fnCallbackReg( oSettings, 'aoStateLoaded',        oInit.fnStateLoaded,       'user' );
			_fnCallbackReg( oSettings, 'aoRowCallback',        oInit.fnRowCallback,       'user' );
			_fnCallbackReg( oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow,        'user' );
			_fnCallbackReg( oSettings, 'aoHeaderCallback',     oInit.fnHeaderCallback,    'user' );
			_fnCallbackReg( oSettings, 'aoFooterCallback',     oInit.fnFooterCallback,    'user' );
			_fnCallbackReg( oSettings, 'aoInitComplete',       oInit.fnInitComplete,      'user' );
			_fnCallbackReg( oSettings, 'aoPreDrawCallback',    oInit.fnPreDrawCallback,   'user' );
			
			oSettings.rowIdFn = _fnGetObjectDataFn( oInit.rowId );
			
			/* Browser support detection */
			_fnBrowserDetect( oSettings );
			
			var oClasses = oSettings.oClasses;
			
			$.extend( oClasses, DataTable.ext.classes, oInit.oClasses );
			$this.addClass( oClasses.sTable );
			
			
			if ( oSettings.iInitDisplayStart === undefined )
			{
				/* Display start point, taking into account the save saving */
				oSettings.iInitDisplayStart = oInit.iDisplayStart;
				oSettings._iDisplayStart = oInit.iDisplayStart;
			}
			
			if ( oInit.iDeferLoading !== null )
			{
				oSettings.bDeferLoading = true;
				var tmp = $.isArray( oInit.iDeferLoading );
				oSettings._iRecordsDisplay = tmp ? oInit.iDeferLoading[0] : oInit.iDeferLoading;
				oSettings._iRecordsTotal = tmp ? oInit.iDeferLoading[1] : oInit.iDeferLoading;
			}
			
			/* Language definitions */
			var oLanguage = oSettings.oLanguage;
			$.extend( true, oLanguage, oInit.oLanguage );
			
			if ( oLanguage.sUrl )
			{
				/* Get the language definitions from a file - because this Ajax call makes the language
				 * get async to the remainder of this function we use bInitHandedOff to indicate that
				 * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
				 */
				$.ajax( {
					dataType: 'json',
					url: oLanguage.sUrl,
					success: function ( json ) {
						_fnLanguageCompat( json );
						_fnCamelToHungarian( defaults.oLanguage, json );
						$.extend( true, oLanguage, json );
						_fnInitialise( oSettings );
					},
					error: function () {
						// Error occurred loading language file, continue on as best we can
						_fnInitialise( oSettings );
					}
				} );
				bInitHandedOff = true;
			}
			
			/*
			 * Stripes
			 */
			if ( oInit.asStripeClasses === null )
			{
				oSettings.asStripeClasses =[
					oClasses.sStripeOdd,
					oClasses.sStripeEven
				];
			}
			
			/* Remove row stripe classes if they are already on the table row */
			var stripeClasses = oSettings.asStripeClasses;
			var rowOne = $this.children('tbody').find('tr').eq(0);
			if ( $.inArray( true, $.map( stripeClasses, function(el, i) {
				return rowOne.hasClass(el);
			} ) ) !== -1 ) {
				$('tbody tr', this).removeClass( stripeClasses.join(' ') );
				oSettings.asDestroyStripes = stripeClasses.slice();
			}
			
			/*
			 * Columns
			 * See if we should load columns automatically or use defined ones
			 */
			var anThs = [];
			var aoColumnsInit;
			var nThead = this.getElementsByTagName('thead');
			if ( nThead.length !== 0 )
			{
				_fnDetectHeader( oSettings.aoHeader, nThead[0] );
				anThs = _fnGetUniqueThs( oSettings );
			}
			
			/* If not given a column array, generate one with nulls */
			if ( oInit.aoColumns === null )
			{
				aoColumnsInit = [];
				for ( i=0, iLen=anThs.length ; i<iLen ; i++ )
				{
					aoColumnsInit.push( null );
				}
			}
			else
			{
				aoColumnsInit = oInit.aoColumns;
			}
			
			/* Add the columns */
			for ( i=0, iLen=aoColumnsInit.length ; i<iLen ; i++ )
			{
				_fnAddColumn( oSettings, anThs ? anThs[i] : null );
			}
			
			/* Apply the column definitions */
			_fnApplyColumnDefs( oSettings, oInit.aoColumnDefs, aoColumnsInit, function (iCol, oDef) {
				_fnColumnOptions( oSettings, iCol, oDef );
			} );
			
			/* HTML5 attribute detection - build an mData object automatically if the
			 * attributes are found
			 */
			if ( rowOne.length ) {
				var a = function ( cell, name ) {
					return cell.getAttribute( 'data-'+name ) !== null ? name : null;
				};
			
				$( rowOne[0] ).children('th, td').each( function (i, cell) {
					var col = oSettings.aoColumns[i];
			
					if ( col.mData === i ) {
						var sort = a( cell, 'sort' ) || a( cell, 'order' );
						var filter = a( cell, 'filter' ) || a( cell, 'search' );
			
						if ( sort !== null || filter !== null ) {
							col.mData = {
								_:      i+'.display',
								sort:   sort !== null   ? i+'.@data-'+sort   : undefined,
								type:   sort !== null   ? i+'.@data-'+sort   : undefined,
								filter: filter !== null ? i+'.@data-'+filter : undefined
							};
			
							_fnColumnOptions( oSettings, i );
						}
					}
				} );
			}
			
			var features = oSettings.oFeatures;
			var loadedInit = function () {
				/*
				 * Sorting
				 * @todo For modularisation (1.11) this needs to do into a sort start up handler
				 */
			
				// If aaSorting is not defined, then we use the first indicator in asSorting
				// in case that has been altered, so the default sort reflects that option
				if ( oInit.aaSorting === undefined ) {
					var sorting = oSettings.aaSorting;
					for ( i=0, iLen=sorting.length ; i<iLen ; i++ ) {
						sorting[i][1] = oSettings.aoColumns[ i ].asSorting[0];
					}
				}
			
				/* Do a first pass on the sorting classes (allows any size changes to be taken into
				 * account, and also will apply sorting disabled classes if disabled
				 */
				_fnSortingClasses( oSettings );
			
				if ( features.bSort ) {
					_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
						if ( oSettings.bSorted ) {
							var aSort = _fnSortFlatten( oSettings );
							var sortedColumns = {};
			
							$.each( aSort, function (i, val) {
								sortedColumns[ val.src ] = val.dir;
							} );
			
							_fnCallbackFire( oSettings, null, 'order', [oSettings, aSort, sortedColumns] );
							_fnSortAria( oSettings );
						}
					} );
				}
			
				_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
					if ( oSettings.bSorted || _fnDataSource( oSettings ) === 'ssp' || features.bDeferRender ) {
						_fnSortingClasses( oSettings );
					}
				}, 'sc' );
			
			
				/*
				 * Final init
				 * Cache the header, body and footer as required, creating them if needed
				 */
			
				// Work around for Webkit bug 83867 - store the caption-side before removing from doc
				var captions = $this.children('caption').each( function () {
					this._captionSide = $(this).css('caption-side');
				} );
			
				var thead = $this.children('thead');
				if ( thead.length === 0 ) {
					thead = $('<thead/>').appendTo($this);
				}
				oSettings.nTHead = thead[0];
			
				var tbody = $this.children('tbody');
				if ( tbody.length === 0 ) {
					tbody = $('<tbody/>').appendTo($this);
				}
				oSettings.nTBody = tbody[0];
			
				var tfoot = $this.children('tfoot');
				if ( tfoot.length === 0 && captions.length > 0 && (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "") ) {
					// If we are a scrolling table, and no footer has been given, then we need to create
					// a tfoot element for the caption element to be appended to
					tfoot = $('<tfoot/>').appendTo($this);
				}
			
				if ( tfoot.length === 0 || tfoot.children().length === 0 ) {
					$this.addClass( oClasses.sNoFooter );
				}
				else if ( tfoot.length > 0 ) {
					oSettings.nTFoot = tfoot[0];
					_fnDetectHeader( oSettings.aoFooter, oSettings.nTFoot );
				}
			
				/* Check if there is data passing into the constructor */
				if ( oInit.aaData ) {
					for ( i=0 ; i<oInit.aaData.length ; i++ ) {
						_fnAddData( oSettings, oInit.aaData[ i ] );
					}
				}
				else if ( oSettings.bDeferLoading || _fnDataSource( oSettings ) == 'dom' ) {
					/* Grab the data from the page - only do this when deferred loading or no Ajax
					 * source since there is no point in reading the DOM data if we are then going
					 * to replace it with Ajax data
					 */
					_fnAddTr( oSettings, $(oSettings.nTBody).children('tr') );
				}
			
				/* Copy the data index array */
				oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
			
				/* Initialisation complete - table can be drawn */
				oSettings.bInitialised = true;
			
				/* Check if we need to initialise the table (it might not have been handed off to the
				 * language processor)
				 */
				if ( bInitHandedOff === false ) {
					_fnInitialise( oSettings );
				}
			};
			
			/* Must be done after everything which can be overridden by the state saving! */
			if ( oInit.bStateSave )
			{
				features.bStateSave = true;
				_fnCallbackReg( oSettings, 'aoDrawCallback', _fnSaveState, 'state_save' );
				_fnLoadState( oSettings, oInit, loadedInit );
			}
			else {
				loadedInit();
			}
			
		} );
		_that = null;
		return this;
	};

	
	/*
	 * It is useful to have variables which are scoped locally so only the
	 * DataTables functions can access them and they don't leak into global space.
	 * At the same time these functions are often useful over multiple files in the
	 * core and API, so we list, or at least document, all variables which are used
	 * by DataTables as private variables here. This also ensures that there is no
	 * clashing of variable names and that they can easily referenced for reuse.
	 */
	
	
	// Defined else where
	//  _selector_run
	//  _selector_opts
	//  _selector_first
	//  _selector_row_indexes
	
	var _ext; // DataTable.ext
	var _Api; // DataTable.Api
	var _api_register; // DataTable.Api.register
	var _api_registerPlural; // DataTable.Api.registerPlural
	
	var _re_dic = {};
	var _re_new_lines = /[\r\n]/g;
	var _re_html = /<.*?>/g;
	
	// This is not strict ISO8601 - Date.parse() is quite lax, although
	// implementations differ between browsers.
	var _re_date = /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/;
	
	// Escape regular expression special characters
	var _re_escape_regex = new RegExp( '(\\' + [ '/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\', '$', '^', '-' ].join('|\\') + ')', 'g' );
	
	// http://en.wikipedia.org/wiki/Foreign_exchange_market
	// - \u20BD - Russian ruble.
	// - \u20a9 - South Korean Won
	// - \u20BA - Turkish Lira
	// - \u20B9 - Indian Rupee
	// - R - Brazil (R$) and South Africa
	// - fr - Swiss Franc
	// - kr - Swedish krona, Norwegian krone and Danish krone
	// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
	// - Ƀ - Bitcoin
	// - Ξ - Ethereum
	//   standards as thousands separators.
	var _re_formatted_numeric = /[',$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;
	
	
	var _empty = function ( d ) {
		return !d || d === true || d === '-' ? true : false;
	};
	
	
	var _intVal = function ( s ) {
		var integer = parseInt( s, 10 );
		return !isNaN(integer) && isFinite(s) ? integer : null;
	};
	
	// Convert from a formatted number with characters other than `.` as the
	// decimal place, to a Javascript number
	var _numToDecimal = function ( num, decimalPoint ) {
		// Cache created regular expressions for speed as this function is called often
		if ( ! _re_dic[ decimalPoint ] ) {
			_re_dic[ decimalPoint ] = new RegExp( _fnEscapeRegex( decimalPoint ), 'g' );
		}
		return typeof num === 'string' && decimalPoint !== '.' ?
			num.replace( /\./g, '' ).replace( _re_dic[ decimalPoint ], '.' ) :
			num;
	};
	
	
	var _isNumber = function ( d, decimalPoint, formatted ) {
		var strType = typeof d === 'string';
	
		// If empty return immediately so there must be a number if it is a
		// formatted string (this stops the string "k", or "kr", etc being detected
		// as a formatted number for currency
		if ( _empty( d ) ) {
			return true;
		}
	
		if ( decimalPoint && strType ) {
			d = _numToDecimal( d, decimalPoint );
		}
	
		if ( formatted && strType ) {
			d = d.replace( _re_formatted_numeric, '' );
		}
	
		return !isNaN( parseFloat(d) ) && isFinite( d );
	};
	
	
	// A string without HTML in it can be considered to be HTML still
	var _isHtml = function ( d ) {
		return _empty( d ) || typeof d === 'string';
	};
	
	
	var _htmlNumeric = function ( d, decimalPoint, formatted ) {
		if ( _empty( d ) ) {
			return true;
		}
	
		var html = _isHtml( d );
		return ! html ?
			null :
			_isNumber( _stripHtml( d ), decimalPoint, formatted ) ?
				true :
				null;
	};
	
	
	var _pluck = function ( a, prop, prop2 ) {
		var out = [];
		var i=0, ien=a.length;
	
		// Could have the test in the loop for slightly smaller code, but speed
		// is essential here
		if ( prop2 !== undefined ) {
			for ( ; i<ien ; i++ ) {
				if ( a[i] && a[i][ prop ] ) {
					out.push( a[i][ prop ][ prop2 ] );
				}
			}
		}
		else {
			for ( ; i<ien ; i++ ) {
				if ( a[i] ) {
					out.push( a[i][ prop ] );
				}
			}
		}
	
		return out;
	};
	
	
	// Basically the same as _pluck, but rather than looping over `a` we use `order`
	// as the indexes to pick from `a`
	var _pluck_order = function ( a, order, prop, prop2 )
	{
		var out = [];
		var i=0, ien=order.length;
	
		// Could have the test in the loop for slightly smaller code, but speed
		// is essential here
		if ( prop2 !== undefined ) {
			for ( ; i<ien ; i++ ) {
				if ( a[ order[i] ][ prop ] ) {
					out.push( a[ order[i] ][ prop ][ prop2 ] );
				}
			}
		}
		else {
			for ( ; i<ien ; i++ ) {
				out.push( a[ order[i] ][ prop ] );
			}
		}
	
		return out;
	};
	
	
	var _range = function ( len, start )
	{
		var out = [];
		var end;
	
		if ( start === undefined ) {
			start = 0;
			end = len;
		}
		else {
			end = start;
			start = len;
		}
	
		for ( var i=start ; i<end ; i++ ) {
			out.push( i );
		}
	
		return out;
	};
	
	
	var _removeEmpty = function ( a )
	{
		var out = [];
	
		for ( var i=0, ien=a.length ; i<ien ; i++ ) {
			if ( a[i] ) { // careful - will remove all falsy values!
				out.push( a[i] );
			}
		}
	
		return out;
	};
	
	
	var _stripHtml = function ( d ) {
		return d.replace( _re_html, '' );
	};
	
	
	/**
	 * Determine if all values in the array are unique. This means we can short
	 * cut the _unique method at the cost of a single loop. A sorted array is used
	 * to easily check the values.
	 *
	 * @param  {array} src Source array
	 * @return {boolean} true if all unique, false otherwise
	 * @ignore
	 */
	var _areAllUnique = function ( src ) {
		if ( src.length < 2 ) {
			return true;
		}
	
		var sorted = src.slice().sort();
		var last = sorted[0];
	
		for ( var i=1, ien=sorted.length ; i<ien ; i++ ) {
			if ( sorted[i] === last ) {
				return false;
			}
	
			last = sorted[i];
		}
	
		return true;
	};
	
	
	/**
	 * Find the unique elements in a source array.
	 *
	 * @param  {array} src Source array
	 * @return {array} Array of unique items
	 * @ignore
	 */
	var _unique = function ( src )
	{
		if ( _areAllUnique( src ) ) {
			return src.slice();
		}
	
		// A faster unique method is to use object keys to identify used values,
		// but this doesn't work with arrays or objects, which we must also
		// consider. See jsperf.com/compare-array-unique-versions/4 for more
		// information.
		var
			out = [],
			val,
			i, ien=src.length,
			j, k=0;
	
		again: for ( i=0 ; i<ien ; i++ ) {
			val = src[i];
	
			for ( j=0 ; j<k ; j++ ) {
				if ( out[j] === val ) {
					continue again;
				}
			}
	
			out.push( val );
			k++;
		}
	
		return out;
	};
	
	
	/**
	 * DataTables utility methods
	 * 
	 * This namespace provides helper methods that DataTables uses internally to
	 * create a DataTable, but which are not exclusively used only for DataTables.
	 * These methods can be used by extension authors to save the duplication of
	 * code.
	 *
	 *  @namespace
	 */
	DataTable.util = {
		/**
		 * Throttle the calls to a function. Arguments and context are maintained
		 * for the throttled function.
		 *
		 * @param {function} fn Function to be called
		 * @param {integer} freq Call frequency in mS
		 * @return {function} Wrapped function
		 */
		throttle: function ( fn, freq ) {
			var
				frequency = freq !== undefined ? freq : 200,
				last,
				timer;
	
			return function () {
				var
					that = this,
					now  = +new Date(),
					args = arguments;
	
				if ( last && now < last + frequency ) {
					clearTimeout( timer );
	
					timer = setTimeout( function () {
						last = undefined;
						fn.apply( that, args );
					}, frequency );
				}
				else {
					last = now;
					fn.apply( that, args );
				}
			};
		},
	
	
		/**
		 * Escape a string such that it can be used in a regular expression
		 *
		 *  @param {string} val string to escape
		 *  @returns {string} escaped string
		 */
		escapeRegex: function ( val ) {
			return val.replace( _re_escape_regex, '\\$1' );
		}
	};
	
	
	
	/**
	 * Create a mapping object that allows camel case parameters to be looked up
	 * for their Hungarian counterparts. The mapping is stored in a private
	 * parameter called `_hungarianMap` which can be accessed on the source object.
	 *  @param {object} o
	 *  @memberof DataTable#oApi
	 */
	function _fnHungarianMap ( o )
	{
		var
			hungarian = 'a aa ai ao as b fn i m o s ',
			match,
			newKey,
			map = {};
	
		$.each( o, function (key, val) {
			match = key.match(/^([^A-Z]+?)([A-Z])/);
	
			if ( match && hungarian.indexOf(match[1]+' ') !== -1 )
			{
				newKey = key.replace( match[0], match[2].toLowerCase() );
				map[ newKey ] = key;
	
				if ( match[1] === 'o' )
				{
					_fnHungarianMap( o[key] );
				}
			}
		} );
	
		o._hungarianMap = map;
	}
	
	
	/**
	 * Convert from camel case parameters to Hungarian, based on a Hungarian map
	 * created by _fnHungarianMap.
	 *  @param {object} src The model object which holds all parameters that can be
	 *    mapped.
	 *  @param {object} user The object to convert from camel case to Hungarian.
	 *  @param {boolean} force When set to `true`, properties which already have a
	 *    Hungarian value in the `user` object will be overwritten. Otherwise they
	 *    won't be.
	 *  @memberof DataTable#oApi
	 */
	function _fnCamelToHungarian ( src, user, force )
	{
		if ( ! src._hungarianMap ) {
			_fnHungarianMap( src );
		}
	
		var hungarianKey;
	
		$.each( user, function (key, val) {
			hungarianKey = src._hungarianMap[ key ];
	
			if ( hungarianKey !== undefined && (force || user[hungarianKey] === undefined) )
			{
				// For objects, we need to buzz down into the object to copy parameters
				if ( hungarianKey.charAt(0) === 'o' )
				{
					// Copy the camelCase options over to the hungarian
					if ( ! user[ hungarianKey ] ) {
						user[ hungarianKey ] = {};
					}
					$.extend( true, user[hungarianKey], user[key] );
	
					_fnCamelToHungarian( src[hungarianKey], user[hungarianKey], force );
				}
				else {
					user[hungarianKey] = user[ key ];
				}
			}
		} );
	}
	
	
	/**
	 * Language compatibility - when certain options are given, and others aren't, we
	 * need to duplicate the values over, in order to provide backwards compatibility
	 * with older language files.
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnLanguageCompat( lang )
	{
		// Note the use of the Hungarian notation for the parameters in this method as
		// this is called after the mapping of camelCase to Hungarian
		var defaults = DataTable.defaults.oLanguage;
	
		// Default mapping
		var defaultDecimal = defaults.sDecimal;
		if ( defaultDecimal ) {
			_addNumericSort( defaultDecimal );
		}
	
		if ( lang ) {
			var zeroRecords = lang.sZeroRecords;
	
			// Backwards compatibility - if there is no sEmptyTable given, then use the same as
			// sZeroRecords - assuming that is given.
			if ( ! lang.sEmptyTable && zeroRecords &&
				defaults.sEmptyTable === "No data available in table" )
			{
				_fnMap( lang, lang, 'sZeroRecords', 'sEmptyTable' );
			}
	
			// Likewise with loading records
			if ( ! lang.sLoadingRecords && zeroRecords &&
				defaults.sLoadingRecords === "Loading..." )
			{
				_fnMap( lang, lang, 'sZeroRecords', 'sLoadingRecords' );
			}
	
			// Old parameter name of the thousands separator mapped onto the new
			if ( lang.sInfoThousands ) {
				lang.sThousands = lang.sInfoThousands;
			}
	
			var decimal = lang.sDecimal;
			if ( decimal && defaultDecimal !== decimal ) {
				_addNumericSort( decimal );
			}
		}
	}
	
	
	/**
	 * Map one parameter onto another
	 *  @param {object} o Object to map
	 *  @param {*} knew The new parameter name
	 *  @param {*} old The old parameter name
	 */
	var _fnCompatMap = function ( o, knew, old ) {
		if ( o[ knew ] !== undefined ) {
			o[ old ] = o[ knew ];
		}
	};
	
	
	/**
	 * Provide backwards compatibility for the main DT options. Note that the new
	 * options are mapped onto the old parameters, so this is an external interface
	 * change only.
	 *  @param {object} init Object to map
	 */
	function _fnCompatOpts ( init )
	{
		_fnCompatMap( init, 'ordering',      'bSort' );
		_fnCompatMap( init, 'orderMulti',    'bSortMulti' );
		_fnCompatMap( init, 'orderClasses',  'bSortClasses' );
		_fnCompatMap( init, 'orderCellsTop', 'bSortCellsTop' );
		_fnCompatMap( init, 'order',         'aaSorting' );
		_fnCompatMap( init, 'orderFixed',    'aaSortingFixed' );
		_fnCompatMap( init, 'paging',        'bPaginate' );
		_fnCompatMap( init, 'pagingType',    'sPaginationType' );
		_fnCompatMap( init, 'pageLength',    'iDisplayLength' );
		_fnCompatMap( init, 'searching',     'bFilter' );
	
		// Boolean initialisation of x-scrolling
		if ( typeof init.sScrollX === 'boolean' ) {
			init.sScrollX = init.sScrollX ? '100%' : '';
		}
		if ( typeof init.scrollX === 'boolean' ) {
			init.scrollX = init.scrollX ? '100%' : '';
		}
	
		// Column search objects are in an array, so it needs to be converted
		// element by element
		var searchCols = init.aoSearchCols;
	
		if ( searchCols ) {
			for ( var i=0, ien=searchCols.length ; i<ien ; i++ ) {
				if ( searchCols[i] ) {
					_fnCamelToHungarian( DataTable.models.oSearch, searchCols[i] );
				}
			}
		}
	}
	
	
	/**
	 * Provide backwards compatibility for column options. Note that the new options
	 * are mapped onto the old parameters, so this is an external interface change
	 * only.
	 *  @param {object} init Object to map
	 */
	function _fnCompatCols ( init )
	{
		_fnCompatMap( init, 'orderable',     'bSortable' );
		_fnCompatMap( init, 'orderData',     'aDataSort' );
		_fnCompatMap( init, 'orderSequence', 'asSorting' );
		_fnCompatMap( init, 'orderDataType', 'sortDataType' );
	
		// orderData can be given as an integer
		var dataSort = init.aDataSort;
		if ( typeof dataSort === 'number' && ! $.isArray( dataSort ) ) {
			init.aDataSort = [ dataSort ];
		}
	}
	
	
	/**
	 * Browser feature detection for capabilities, quirks
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnBrowserDetect( settings )
	{
		// We don't need to do this every time DataTables is constructed, the values
		// calculated are specific to the browser and OS configuration which we
		// don't expect to change between initialisations
		if ( ! DataTable.__browser ) {
			var browser = {};
			DataTable.__browser = browser;
	
			// Scrolling feature / quirks detection
			var n = $('<div/>')
				.css( {
					position: 'fixed',
					top: 0,
					left: $(window).scrollLeft()*-1, // allow for scrolling
					height: 1,
					width: 1,
					overflow: 'hidden'
				} )
				.append(
					$('<div/>')
						.css( {
							position: 'absolute',
							top: 1,
							left: 1,
							width: 100,
							overflow: 'scroll'
						} )
						.append(
							$('<div/>')
								.css( {
									width: '100%',
									height: 10
								} )
						)
				)
				.appendTo( 'body' );
	
			var outer = n.children();
			var inner = outer.children();
	
			// Numbers below, in order, are:
			// inner.offsetWidth, inner.clientWidth, outer.offsetWidth, outer.clientWidth
			//
			// IE6 XP:                           100 100 100  83
			// IE7 Vista:                        100 100 100  83
			// IE 8+ Windows:                     83  83 100  83
			// Evergreen Windows:                 83  83 100  83
			// Evergreen Mac with scrollbars:     85  85 100  85
			// Evergreen Mac without scrollbars: 100 100 100 100
	
			// Get scrollbar width
			browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;
	
			// IE6/7 will oversize a width 100% element inside a scrolling element, to
			// include the width of the scrollbar, while other browsers ensure the inner
			// element is contained without forcing scrolling
			browser.bScrollOversize = inner[0].offsetWidth === 100 && outer[0].clientWidth !== 100;
	
			// In rtl text layout, some browsers (most, but not all) will place the
			// scrollbar on the left, rather than the right.
			browser.bScrollbarLeft = Math.round( inner.offset().left ) !== 1;
	
			// IE8- don't provide height and width for getBoundingClientRect
			browser.bBounding = n[0].getBoundingClientRect().width ? true : false;
	
			n.remove();
		}
	
		$.extend( settings.oBrowser, DataTable.__browser );
		settings.oScroll.iBarWidth = DataTable.__browser.barWidth;
	}
	
	
	/**
	 * Array.prototype reduce[Right] method, used for browsers which don't support
	 * JS 1.6. Done this way to reduce code size, since we iterate either way
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnReduce ( that, fn, init, start, end, inc )
	{
		var
			i = start,
			value,
			isSet = false;
	
		if ( init !== undefined ) {
			value = init;
			isSet = true;
		}
	
		while ( i !== end ) {
			if ( ! that.hasOwnProperty(i) ) {
				continue;
			}
	
			value = isSet ?
				fn( value, that[i], i, that ) :
				that[i];
	
			isSet = true;
			i += inc;
		}
	
		return value;
	}
	
	/**
	 * Add a column to the list used for the table with default values
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} nTh The th element for this column
	 *  @memberof DataTable#oApi
	 */
	function _fnAddColumn( oSettings, nTh )
	{
		// Add column to aoColumns array
		var oDefaults = DataTable.defaults.column;
		var iCol = oSettings.aoColumns.length;
		var oCol = $.extend( {}, DataTable.models.oColumn, oDefaults, {
			"nTh": nTh ? nTh : document.createElement('th'),
			"sTitle":    oDefaults.sTitle    ? oDefaults.sTitle    : nTh ? nTh.innerHTML : '',
			"aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [iCol],
			"mData": oDefaults.mData ? oDefaults.mData : iCol,
			idx: iCol
		} );
		oSettings.aoColumns.push( oCol );
	
		// Add search object for column specific search. Note that the `searchCols[ iCol ]`
		// passed into extend can be undefined. This allows the user to give a default
		// with only some of the parameters defined, and also not give a default
		var searchCols = oSettings.aoPreSearchCols;
		searchCols[ iCol ] = $.extend( {}, DataTable.models.oSearch, searchCols[ iCol ] );
	
		// Use the default column options function to initialise classes etc
		_fnColumnOptions( oSettings, iCol, $(nTh).data() );
	}
	
	
	/**
	 * Apply options for a column
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iCol column index to consider
	 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
	 *  @memberof DataTable#oApi
	 */
	function _fnColumnOptions( oSettings, iCol, oOptions )
	{
		var oCol = oSettings.aoColumns[ iCol ];
		var oClasses = oSettings.oClasses;
		var th = $(oCol.nTh);
	
		// Try to get width information from the DOM. We can't get it from CSS
		// as we'd need to parse the CSS stylesheet. `width` option can override
		if ( ! oCol.sWidthOrig ) {
			// Width attribute
			oCol.sWidthOrig = th.attr('width') || null;
	
			// Style attribute
			var t = (th.attr('style') || '').match(/width:\s*(\d+[pxem%]+)/);
			if ( t ) {
				oCol.sWidthOrig = t[1];
			}
		}
	
		/* User specified column options */
		if ( oOptions !== undefined && oOptions !== null )
		{
			// Backwards compatibility
			_fnCompatCols( oOptions );
	
			// Map camel case parameters to their Hungarian counterparts
			_fnCamelToHungarian( DataTable.defaults.column, oOptions );
	
			/* Backwards compatibility for mDataProp */
			if ( oOptions.mDataProp !== undefined && !oOptions.mData )
			{
				oOptions.mData = oOptions.mDataProp;
			}
	
			if ( oOptions.sType )
			{
				oCol._sManualType = oOptions.sType;
			}
	
			// `class` is a reserved word in Javascript, so we need to provide
			// the ability to use a valid name for the camel case input
			if ( oOptions.className && ! oOptions.sClass )
			{
				oOptions.sClass = oOptions.className;
			}
			if ( oOptions.sClass ) {
				th.addClass( oOptions.sClass );
			}
	
			$.extend( oCol, oOptions );
			_fnMap( oCol, oOptions, "sWidth", "sWidthOrig" );
	
			/* iDataSort to be applied (backwards compatibility), but aDataSort will take
			 * priority if defined
			 */
			if ( oOptions.iDataSort !== undefined )
			{
				oCol.aDataSort = [ oOptions.iDataSort ];
			}
			_fnMap( oCol, oOptions, "aDataSort" );
		}
	
		/* Cache the data get and set functions for speed */
		var mDataSrc = oCol.mData;
		var mData = _fnGetObjectDataFn( mDataSrc );
		var mRender = oCol.mRender ? _fnGetObjectDataFn( oCol.mRender ) : null;
	
		var attrTest = function( src ) {
			return typeof src === 'string' && src.indexOf('@') !== -1;
		};
		oCol._bAttrSrc = $.isPlainObject( mDataSrc ) && (
			attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter)
		);
		oCol._setter = null;
	
		oCol.fnGetData = function (rowData, type, meta) {
			var innerData = mData( rowData, type, undefined, meta );
	
			return mRender && type ?
				mRender( innerData, type, rowData, meta ) :
				innerData;
		};
		oCol.fnSetData = function ( rowData, val, meta ) {
			return _fnSetObjectDataFn( mDataSrc )( rowData, val, meta );
		};
	
		// Indicate if DataTables should read DOM data as an object or array
		// Used in _fnGetRowElements
		if ( typeof mDataSrc !== 'number' ) {
			oSettings._rowReadObject = true;
		}
	
		/* Feature sorting overrides column specific when off */
		if ( !oSettings.oFeatures.bSort )
		{
			oCol.bSortable = false;
			th.addClass( oClasses.sSortableNone ); // Have to add class here as order event isn't called
		}
	
		/* Check that the class assignment is correct for sorting */
		var bAsc = $.inArray('asc', oCol.asSorting) !== -1;
		var bDesc = $.inArray('desc', oCol.asSorting) !== -1;
		if ( !oCol.bSortable || (!bAsc && !bDesc) )
		{
			oCol.sSortingClass = oClasses.sSortableNone;
			oCol.sSortingClassJUI = "";
		}
		else if ( bAsc && !bDesc )
		{
			oCol.sSortingClass = oClasses.sSortableAsc;
			oCol.sSortingClassJUI = oClasses.sSortJUIAscAllowed;
		}
		else if ( !bAsc && bDesc )
		{
			oCol.sSortingClass = oClasses.sSortableDesc;
			oCol.sSortingClassJUI = oClasses.sSortJUIDescAllowed;
		}
		else
		{
			oCol.sSortingClass = oClasses.sSortable;
			oCol.sSortingClassJUI = oClasses.sSortJUI;
		}
	}
	
	
	/**
	 * Adjust the table column widths for new data. Note: you would probably want to
	 * do a redraw after calling this function!
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnAdjustColumnSizing ( settings )
	{
		/* Not interested in doing column width calculation if auto-width is disabled */
		if ( settings.oFeatures.bAutoWidth !== false )
		{
			var columns = settings.aoColumns;
	
			_fnCalculateColumnWidths( settings );
			for ( var i=0 , iLen=columns.length ; i<iLen ; i++ )
			{
				columns[i].nTh.style.width = columns[i].sWidth;
			}
		}
	
		var scroll = settings.oScroll;
		if ( scroll.sY !== '' || scroll.sX !== '')
		{
			_fnScrollDraw( settings );
		}
	
		_fnCallbackFire( settings, null, 'column-sizing', [settings] );
	}
	
	
	/**
	 * Covert the index of a visible column to the index in the data array (take account
	 * of hidden columns)
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iMatch Visible column index to lookup
	 *  @returns {int} i the data index
	 *  @memberof DataTable#oApi
	 */
	function _fnVisibleToColumnIndex( oSettings, iMatch )
	{
		var aiVis = _fnGetColumns( oSettings, 'bVisible' );
	
		return typeof aiVis[iMatch] === 'number' ?
			aiVis[iMatch] :
			null;
	}
	
	
	/**
	 * Covert the index of an index in the data array and convert it to the visible
	 *   column index (take account of hidden columns)
	 *  @param {int} iMatch Column index to lookup
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {int} i the data index
	 *  @memberof DataTable#oApi
	 */
	function _fnColumnIndexToVisible( oSettings, iMatch )
	{
		var aiVis = _fnGetColumns( oSettings, 'bVisible' );
		var iPos = $.inArray( iMatch, aiVis );
	
		return iPos !== -1 ? iPos : null;
	}
	
	
	/**
	 * Get the number of visible columns
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {int} i the number of visible columns
	 *  @memberof DataTable#oApi
	 */
	function _fnVisbleColumns( oSettings )
	{
		var vis = 0;
	
		// No reduce in IE8, use a loop for now
		$.each( oSettings.aoColumns, function ( i, col ) {
			if ( col.bVisible && $(col.nTh).css('display') !== 'none' ) {
				vis++;
			}
		} );
	
		return vis;
	}
	
	
	/**
	 * Get an array of column indexes that match a given property
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sParam Parameter in aoColumns to look for - typically
	 *    bVisible or bSearchable
	 *  @returns {array} Array of indexes with matched properties
	 *  @memberof DataTable#oApi
	 */
	function _fnGetColumns( oSettings, sParam )
	{
		var a = [];
	
		$.map( oSettings.aoColumns, function(val, i) {
			if ( val[sParam] ) {
				a.push( i );
			}
		} );
	
		return a;
	}
	
	
	/**
	 * Calculate the 'type' of a column
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnColumnTypes ( settings )
	{
		var columns = settings.aoColumns;
		var data = settings.aoData;
		var types = DataTable.ext.type.detect;
		var i, ien, j, jen, k, ken;
		var col, cell, detectedType, cache;
	
		// For each column, spin over the 
		for ( i=0, ien=columns.length ; i<ien ; i++ ) {
			col = columns[i];
			cache = [];
	
			if ( ! col.sType && col._sManualType ) {
				col.sType = col._sManualType;
			}
			else if ( ! col.sType ) {
				for ( j=0, jen=types.length ; j<jen ; j++ ) {
					for ( k=0, ken=data.length ; k<ken ; k++ ) {
						// Use a cache array so we only need to get the type data
						// from the formatter once (when using multiple detectors)
						if ( cache[k] === undefined ) {
							cache[k] = _fnGetCellData( settings, k, i, 'type' );
						}
	
						detectedType = types[j]( cache[k], settings );
	
						// If null, then this type can't apply to this column, so
						// rather than testing all cells, break out. There is an
						// exception for the last type which is `html`. We need to
						// scan all rows since it is possible to mix string and HTML
						// types
						if ( ! detectedType && j !== types.length-1 ) {
							break;
						}
	
						// Only a single match is needed for html type since it is
						// bottom of the pile and very similar to string
						if ( detectedType === 'html' ) {
							break;
						}
					}
	
					// Type is valid for all data points in the column - use this
					// type
					if ( detectedType ) {
						col.sType = detectedType;
						break;
					}
				}
	
				// Fall back - if no type was detected, always use string
				if ( ! col.sType ) {
					col.sType = 'string';
				}
			}
		}
	}
	
	
	/**
	 * Take the column definitions and static columns arrays and calculate how
	 * they relate to column indexes. The callback function will then apply the
	 * definition found for a column to a suitable configuration object.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
	 *  @param {array} aoCols The aoColumns array that defines columns individually
	 *  @param {function} fn Callback function - takes two parameters, the calculated
	 *    column index and the definition for that column.
	 *  @memberof DataTable#oApi
	 */
	function _fnApplyColumnDefs( oSettings, aoColDefs, aoCols, fn )
	{
		var i, iLen, j, jLen, k, kLen, def;
		var columns = oSettings.aoColumns;
	
		// Column definitions with aTargets
		if ( aoColDefs )
		{
			/* Loop over the definitions array - loop in reverse so first instance has priority */
			for ( i=aoColDefs.length-1 ; i>=0 ; i-- )
			{
				def = aoColDefs[i];
	
				/* Each definition can target multiple columns, as it is an array */
				var aTargets = def.targets !== undefined ?
					def.targets :
					def.aTargets;
	
				if ( ! $.isArray( aTargets ) )
				{
					aTargets = [ aTargets ];
				}
	
				for ( j=0, jLen=aTargets.length ; j<jLen ; j++ )
				{
					if ( typeof aTargets[j] === 'number' && aTargets[j] >= 0 )
					{
						/* Add columns that we don't yet know about */
						while( columns.length <= aTargets[j] )
						{
							_fnAddColumn( oSettings );
						}
	
						/* Integer, basic index */
						fn( aTargets[j], def );
					}
					else if ( typeof aTargets[j] === 'number' && aTargets[j] < 0 )
					{
						/* Negative integer, right to left column counting */
						fn( columns.length+aTargets[j], def );
					}
					else if ( typeof aTargets[j] === 'string' )
					{
						/* Class name matching on TH element */
						for ( k=0, kLen=columns.length ; k<kLen ; k++ )
						{
							if ( aTargets[j] == "_all" ||
							     $(columns[k].nTh).hasClass( aTargets[j] ) )
							{
								fn( k, def );
							}
						}
					}
				}
			}
		}
	
		// Statically defined columns array
		if ( aoCols )
		{
			for ( i=0, iLen=aoCols.length ; i<iLen ; i++ )
			{
				fn( i, aoCols[i] );
			}
		}
	}
	
	/**
	 * Add a data array to the table, creating DOM node etc. This is the parallel to
	 * _fnGatherData, but for adding rows from a Javascript source, rather than a
	 * DOM source.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {array} aData data array to be added
	 *  @param {node} [nTr] TR element to add to the table - optional. If not given,
	 *    DataTables will create a row automatically
	 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	 *    if nTr is.
	 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
	 *  @memberof DataTable#oApi
	 */
	function _fnAddData ( oSettings, aDataIn, nTr, anTds )
	{
		/* Create the object for storing information about this new row */
		var iRow = oSettings.aoData.length;
		var oData = $.extend( true, {}, DataTable.models.oRow, {
			src: nTr ? 'dom' : 'data',
			idx: iRow
		} );
	
		oData._aData = aDataIn;
		oSettings.aoData.push( oData );
	
		/* Create the cells */
		var nTd, sThisType;
		var columns = oSettings.aoColumns;
	
		// Invalidate the column types as the new data needs to be revalidated
		for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
		{
			columns[i].sType = null;
		}
	
		/* Add to the display array */
		oSettings.aiDisplayMaster.push( iRow );
	
		var id = oSettings.rowIdFn( aDataIn );
		if ( id !== undefined ) {
			oSettings.aIds[ id ] = oData;
		}
	
		/* Create the DOM information, or register it if already present */
		if ( nTr || ! oSettings.oFeatures.bDeferRender )
		{
			_fnCreateTr( oSettings, iRow, nTr, anTds );
		}
	
		return iRow;
	}
	
	
	/**
	 * Add one or more TR elements to the table. Generally we'd expect to
	 * use this for reading data from a DOM sourced table, but it could be
	 * used for an TR element. Note that if a TR is given, it is used (i.e.
	 * it is not cloned).
	 *  @param {object} settings dataTables settings object
	 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
	 *  @returns {array} Array of indexes for the added rows
	 *  @memberof DataTable#oApi
	 */
	function _fnAddTr( settings, trs )
	{
		var row;
	
		// Allow an individual node to be passed in
		if ( ! (trs instanceof $) ) {
			trs = $(trs);
		}
	
		return trs.map( function (i, el) {
			row = _fnGetRowElements( settings, el );
			return _fnAddData( settings, row.data, el, row.cells );
		} );
	}
	
	
	/**
	 * Take a TR element and convert it to an index in aoData
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} n the TR element to find
	 *  @returns {int} index if the node is found, null if not
	 *  @memberof DataTable#oApi
	 */
	function _fnNodeToDataIndex( oSettings, n )
	{
		return (n._DT_RowIndex!==undefined) ? n._DT_RowIndex : null;
	}
	
	
	/**
	 * Take a TD element and convert it into a column data index (not the visible index)
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iRow The row number the TD/TH can be found in
	 *  @param {node} n The TD/TH element to find
	 *  @returns {int} index if the node is found, -1 if not
	 *  @memberof DataTable#oApi
	 */
	function _fnNodeToColumnIndex( oSettings, iRow, n )
	{
		return $.inArray( n, oSettings.aoData[ iRow ].anCells );
	}
	
	
	/**
	 * Get the data for a given cell from the internal cache, taking into account data mapping
	 *  @param {object} settings dataTables settings object
	 *  @param {int} rowIdx aoData row id
	 *  @param {int} colIdx Column index
	 *  @param {string} type data get type ('display', 'type' 'filter' 'sort')
	 *  @returns {*} Cell data
	 *  @memberof DataTable#oApi
	 */
	function _fnGetCellData( settings, rowIdx, colIdx, type )
	{
		var draw           = settings.iDraw;
		var col            = settings.aoColumns[colIdx];
		var rowData        = settings.aoData[rowIdx]._aData;
		var defaultContent = col.sDefaultContent;
		var cellData       = col.fnGetData( rowData, type, {
			settings: settings,
			row:      rowIdx,
			col:      colIdx
		} );
	
		if ( cellData === undefined ) {
			if ( settings.iDrawError != draw && defaultContent === null ) {
				_fnLog( settings, 0, "Requested unknown parameter "+
					(typeof col.mData=='function' ? '{function}' : "'"+col.mData+"'")+
					" for row "+rowIdx+", column "+colIdx, 4 );
				settings.iDrawError = draw;
			}
			return defaultContent;
		}
	
		// When the data source is null and a specific data type is requested (i.e.
		// not the original data), we can use default column data
		if ( (cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined ) {
			cellData = defaultContent;
		}
		else if ( typeof cellData === 'function' ) {
			// If the data source is a function, then we run it and use the return,
			// executing in the scope of the data object (for instances)
			return cellData.call( rowData );
		}
	
		if ( cellData === null && type == 'display' ) {
			return '';
		}
		return cellData;
	}
	
	
	/**
	 * Set the value for a specific cell, into the internal data cache
	 *  @param {object} settings dataTables settings object
	 *  @param {int} rowIdx aoData row id
	 *  @param {int} colIdx Column index
	 *  @param {*} val Value to set
	 *  @memberof DataTable#oApi
	 */
	function _fnSetCellData( settings, rowIdx, colIdx, val )
	{
		var col     = settings.aoColumns[colIdx];
		var rowData = settings.aoData[rowIdx]._aData;
	
		col.fnSetData( rowData, val, {
			settings: settings,
			row:      rowIdx,
			col:      colIdx
		}  );
	}
	
	
	// Private variable that is used to match action syntax in the data property object
	var __reArray = /\[.*?\]$/;
	var __reFn = /\(\)$/;
	
	/**
	 * Split string on periods, taking into account escaped periods
	 * @param  {string} str String to split
	 * @return {array} Split string
	 */
	function _fnSplitObjNotation( str )
	{
		return $.map( str.match(/(\\.|[^\.])+/g) || [''], function ( s ) {
			return s.replace(/\\\./g, '.');
		} );
	}
	
	
	/**
	 * Return a function that can be used to get data from a source object, taking
	 * into account the ability to use nested objects as a source
	 *  @param {string|int|function} mSource The data source for the object
	 *  @returns {function} Data get function
	 *  @memberof DataTable#oApi
	 */
	function _fnGetObjectDataFn( mSource )
	{
		if ( $.isPlainObject( mSource ) )
		{
			/* Build an object of get functions, and wrap them in a single call */
			var o = {};
			$.each( mSource, function (key, val) {
				if ( val ) {
					o[key] = _fnGetObjectDataFn( val );
				}
			} );
	
			return function (data, type, row, meta) {
				var t = o[type] || o._;
				return t !== undefined ?
					t(data, type, row, meta) :
					data;
			};
		}
		else if ( mSource === null )
		{
			/* Give an empty string for rendering / sorting etc */
			return function (data) { // type, row and meta also passed, but not used
				return data;
			};
		}
		else if ( typeof mSource === 'function' )
		{
			return function (data, type, row, meta) {
				return mSource( data, type, row, meta );
			};
		}
		else if ( typeof mSource === 'string' && (mSource.indexOf('.') !== -1 ||
			      mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1) )
		{
			/* If there is a . in the source string then the data source is in a
			 * nested object so we loop over the data for each level to get the next
			 * level down. On each loop we test for undefined, and if found immediately
			 * return. This allows entire objects to be missing and sDefaultContent to
			 * be used if defined, rather than throwing an error
			 */
			var fetchData = function (data, type, src) {
				var arrayNotation, funcNotation, out, innerSrc;
	
				if ( src !== "" )
				{
					var a = _fnSplitObjNotation( src );
	
					for ( var i=0, iLen=a.length ; i<iLen ; i++ )
					{
						// Check if we are dealing with special notation
						arrayNotation = a[i].match(__reArray);
						funcNotation = a[i].match(__reFn);
	
						if ( arrayNotation )
						{
							// Array notation
							a[i] = a[i].replace(__reArray, '');
	
							// Condition allows simply [] to be passed in
							if ( a[i] !== "" ) {
								data = data[ a[i] ];
							}
							out = [];
	
							// Get the remainder of the nested object to get
							a.splice( 0, i+1 );
							innerSrc = a.join('.');
	
							// Traverse each entry in the array getting the properties requested
							if ( $.isArray( data ) ) {
								for ( var j=0, jLen=data.length ; j<jLen ; j++ ) {
									out.push( fetchData( data[j], type, innerSrc ) );
								}
							}
	
							// If a string is given in between the array notation indicators, that
							// is used to join the strings together, otherwise an array is returned
							var join = arrayNotation[0].substring(1, arrayNotation[0].length-1);
							data = (join==="") ? out : out.join(join);
	
							// The inner call to fetchData has already traversed through the remainder
							// of the source requested, so we exit from the loop
							break;
						}
						else if ( funcNotation )
						{
							// Function call
							a[i] = a[i].replace(__reFn, '');
							data = data[ a[i] ]();
							continue;
						}
	
						if ( data === null || data[ a[i] ] === undefined )
						{
							return undefined;
						}
						data = data[ a[i] ];
					}
				}
	
				return data;
			};
	
			return function (data, type) { // row and meta also passed, but not used
				return fetchData( data, type, mSource );
			};
		}
		else
		{
			/* Array or flat object mapping */
			return function (data, type) { // row and meta also passed, but not used
				return data[mSource];
			};
		}
	}
	
	
	/**
	 * Return a function that can be used to set data from a source object, taking
	 * into account the ability to use nested objects as a source
	 *  @param {string|int|function} mSource The data source for the object
	 *  @returns {function} Data set function
	 *  @memberof DataTable#oApi
	 */
	function _fnSetObjectDataFn( mSource )
	{
		if ( $.isPlainObject( mSource ) )
		{
			/* Unlike get, only the underscore (global) option is used for for
			 * setting data since we don't know the type here. This is why an object
			 * option is not documented for `mData` (which is read/write), but it is
			 * for `mRender` which is read only.
			 */
			return _fnSetObjectDataFn( mSource._ );
		}
		else if ( mSource === null )
		{
			/* Nothing to do when the data source is null */
			return function () {};
		}
		else if ( typeof mSource === 'function' )
		{
			return function (data, val, meta) {
				mSource( data, 'set', val, meta );
			};
		}
		else if ( typeof mSource === 'string' && (mSource.indexOf('.') !== -1 ||
			      mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1) )
		{
			/* Like the get, we need to get data from a nested object */
			var setData = function (data, val, src) {
				var a = _fnSplitObjNotation( src ), b;
				var aLast = a[a.length-1];
				var arrayNotation, funcNotation, o, innerSrc;
	
				for ( var i=0, iLen=a.length-1 ; i<iLen ; i++ )
				{
					// Check if we are dealing with an array notation request
					arrayNotation = a[i].match(__reArray);
					funcNotation = a[i].match(__reFn);
	
					if ( arrayNotation )
					{
						a[i] = a[i].replace(__reArray, '');
						data[ a[i] ] = [];
	
						// Get the remainder of the nested object to set so we can recurse
						b = a.slice();
						b.splice( 0, i+1 );
						innerSrc = b.join('.');
	
						// Traverse each entry in the array setting the properties requested
						if ( $.isArray( val ) )
						{
							for ( var j=0, jLen=val.length ; j<jLen ; j++ )
							{
								o = {};
								setData( o, val[j], innerSrc );
								data[ a[i] ].push( o );
							}
						}
						else
						{
							// We've been asked to save data to an array, but it
							// isn't array data to be saved. Best that can be done
							// is to just save the value.
							data[ a[i] ] = val;
						}
	
						// The inner call to setData has already traversed through the remainder
						// of the source and has set the data, thus we can exit here
						return;
					}
					else if ( funcNotation )
					{
						// Function call
						a[i] = a[i].replace(__reFn, '');
						data = data[ a[i] ]( val );
					}
	
					// If the nested object doesn't currently exist - since we are
					// trying to set the value - create it
					if ( data[ a[i] ] === null || data[ a[i] ] === undefined )
					{
						data[ a[i] ] = {};
					}
					data = data[ a[i] ];
				}
	
				// Last item in the input - i.e, the actual set
				if ( aLast.match(__reFn ) )
				{
					// Function call
					data = data[ aLast.replace(__reFn, '') ]( val );
				}
				else
				{
					// If array notation is used, we just want to strip it and use the property name
					// and assign the value. If it isn't used, then we get the result we want anyway
					data[ aLast.replace(__reArray, '') ] = val;
				}
			};
	
			return function (data, val) { // meta is also passed in, but not used
				return setData( data, val, mSource );
			};
		}
		else
		{
			/* Array or flat object mapping */
			return function (data, val) { // meta is also passed in, but not used
				data[mSource] = val;
			};
		}
	}
	
	
	/**
	 * Return an array with the full table data
	 *  @param {object} oSettings dataTables settings object
	 *  @returns array {array} aData Master data array
	 *  @memberof DataTable#oApi
	 */
	function _fnGetDataMaster ( settings )
	{
		return _pluck( settings.aoData, '_aData' );
	}
	
	
	/**
	 * Nuke the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnClearTable( settings )
	{
		settings.aoData.length = 0;
		settings.aiDisplayMaster.length = 0;
		settings.aiDisplay.length = 0;
		settings.aIds = {};
	}
	
	
	 /**
	 * Take an array of integers (index array) and remove a target integer (value - not
	 * the key!)
	 *  @param {array} a Index array to target
	 *  @param {int} iTarget value to find
	 *  @memberof DataTable#oApi
	 */
	function _fnDeleteIndex( a, iTarget, splice )
	{
		var iTargetIndex = -1;
	
		for ( var i=0, iLen=a.length ; i<iLen ; i++ )
		{
			if ( a[i] == iTarget )
			{
				iTargetIndex = i;
			}
			else if ( a[i] > iTarget )
			{
				a[i]--;
			}
		}
	
		if ( iTargetIndex != -1 && splice === undefined )
		{
			a.splice( iTargetIndex, 1 );
		}
	}
	
	
	/**
	 * Mark cached data as invalid such that a re-read of the data will occur when
	 * the cached data is next requested. Also update from the data source object.
	 *
	 * @param {object} settings DataTables settings object
	 * @param {int}    rowIdx   Row index to invalidate
	 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
	 *     or 'data'
	 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
	 *     row will be invalidated
	 * @memberof DataTable#oApi
	 *
	 * @todo For the modularisation of v1.11 this will need to become a callback, so
	 *   the sort and filter methods can subscribe to it. That will required
	 *   initialisation options for sorting, which is why it is not already baked in
	 */
	function _fnInvalidate( settings, rowIdx, src, colIdx )
	{
		var row = settings.aoData[ rowIdx ];
		var i, ien;
		var cellWrite = function ( cell, col ) {
			// This is very frustrating, but in IE if you just write directly
			// to innerHTML, and elements that are overwritten are GC'ed,
			// even if there is a reference to them elsewhere
			while ( cell.childNodes.length ) {
				cell.removeChild( cell.firstChild );
			}
	
			cell.innerHTML = _fnGetCellData( settings, rowIdx, col, 'display' );
		};
	
		// Are we reading last data from DOM or the data object?
		if ( src === 'dom' || ((! src || src === 'auto') && row.src === 'dom') ) {
			// Read the data from the DOM
			row._aData = _fnGetRowElements(
					settings, row, colIdx, colIdx === undefined ? undefined : row._aData
				)
				.data;
		}
		else {
			// Reading from data object, update the DOM
			var cells = row.anCells;
	
			if ( cells ) {
				if ( colIdx !== undefined ) {
					cellWrite( cells[colIdx], colIdx );
				}
				else {
					for ( i=0, ien=cells.length ; i<ien ; i++ ) {
						cellWrite( cells[i], i );
					}
				}
			}
		}
	
		// For both row and cell invalidation, the cached data for sorting and
		// filtering is nulled out
		row._aSortData = null;
		row._aFilterData = null;
	
		// Invalidate the type for a specific column (if given) or all columns since
		// the data might have changed
		var cols = settings.aoColumns;
		if ( colIdx !== undefined ) {
			cols[ colIdx ].sType = null;
		}
		else {
			for ( i=0, ien=cols.length ; i<ien ; i++ ) {
				cols[i].sType = null;
			}
	
			// Update DataTables special `DT_*` attributes for the row
			_fnRowAttributes( settings, row );
		}
	}
	
	
	/**
	 * Build a data source object from an HTML row, reading the contents of the
	 * cells that are in the row.
	 *
	 * @param {object} settings DataTables settings object
	 * @param {node|object} TR element from which to read data or existing row
	 *   object from which to re-read the data from the cells
	 * @param {int} [colIdx] Optional column index
	 * @param {array|object} [d] Data source object. If `colIdx` is given then this
	 *   parameter should also be given and will be used to write the data into.
	 *   Only the column in question will be written
	 * @returns {object} Object with two parameters: `data` the data read, in
	 *   document order, and `cells` and array of nodes (they can be useful to the
	 *   caller, so rather than needing a second traversal to get them, just return
	 *   them from here).
	 * @memberof DataTable#oApi
	 */
	function _fnGetRowElements( settings, row, colIdx, d )
	{
		var
			tds = [],
			td = row.firstChild,
			name, col, o, i=0, contents,
			columns = settings.aoColumns,
			objectRead = settings._rowReadObject;
	
		// Allow the data object to be passed in, or construct
		d = d !== undefined ?
			d :
			objectRead ?
				{} :
				[];
	
		var attr = function ( str, td  ) {
			if ( typeof str === 'string' ) {
				var idx = str.indexOf('@');
	
				if ( idx !== -1 ) {
					var attr = str.substring( idx+1 );
					var setter = _fnSetObjectDataFn( str );
					setter( d, td.getAttribute( attr ) );
				}
			}
		};
	
		// Read data from a cell and store into the data object
		var cellProcess = function ( cell ) {
			if ( colIdx === undefined || colIdx === i ) {
				col = columns[i];
				contents = $.trim(cell.innerHTML);
	
				if ( col && col._bAttrSrc ) {
					var setter = _fnSetObjectDataFn( col.mData._ );
					setter( d, contents );
	
					attr( col.mData.sort, cell );
					attr( col.mData.type, cell );
					attr( col.mData.filter, cell );
				}
				else {
					// Depending on the `data` option for the columns the data can
					// be read to either an object or an array.
					if ( objectRead ) {
						if ( ! col._setter ) {
							// Cache the setter function
							col._setter = _fnSetObjectDataFn( col.mData );
						}
						col._setter( d, contents );
					}
					else {
						d[i] = contents;
					}
				}
			}
	
			i++;
		};
	
		if ( td ) {
			// `tr` element was passed in
			while ( td ) {
				name = td.nodeName.toUpperCase();
	
				if ( name == "TD" || name == "TH" ) {
					cellProcess( td );
					tds.push( td );
				}
	
				td = td.nextSibling;
			}
		}
		else {
			// Existing row object passed in
			tds = row.anCells;
	
			for ( var j=0, jen=tds.length ; j<jen ; j++ ) {
				cellProcess( tds[j] );
			}
		}
	
		// Read the ID from the DOM if present
		var rowNode = row.firstChild ? row : row.nTr;
	
		if ( rowNode ) {
			var id = rowNode.getAttribute( 'id' );
	
			if ( id ) {
				_fnSetObjectDataFn( settings.rowId )( d, id );
			}
		}
	
		return {
			data: d,
			cells: tds
		};
	}
	/**
	 * Create a new TR element (and it's TD children) for a row
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iRow Row to consider
	 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
	 *    DataTables will create a row automatically
	 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	 *    if nTr is.
	 *  @memberof DataTable#oApi
	 */
	function _fnCreateTr ( oSettings, iRow, nTrIn, anTds )
	{
		var
			row = oSettings.aoData[iRow],
			rowData = row._aData,
			cells = [],
			nTr, nTd, oCol,
			i, iLen;
	
		if ( row.nTr === null )
		{
			nTr = nTrIn || document.createElement('tr');
	
			row.nTr = nTr;
			row.anCells = cells;
	
			/* Use a private property on the node to allow reserve mapping from the node
			 * to the aoData array for fast look up
			 */
			nTr._DT_RowIndex = iRow;
	
			/* Special parameters can be given by the data source to be used on the row */
			_fnRowAttributes( oSettings, row );
	
			/* Process each column */
			for ( i=0, iLen=oSettings.aoColumns.length ; i<iLen ; i++ )
			{
				oCol = oSettings.aoColumns[i];
	
				nTd = nTrIn ? anTds[i] : document.createElement( oCol.sCellType );
				nTd._DT_CellIndex = {
					row: iRow,
					column: i
				};
				
				cells.push( nTd );
	
				// Need to create the HTML if new, or if a rendering function is defined
				if ( (!nTrIn || oCol.mRender || oCol.mData !== i) &&
					 (!$.isPlainObject(oCol.mData) || oCol.mData._ !== i+'.display')
				) {
					nTd.innerHTML = _fnGetCellData( oSettings, iRow, i, 'display' );
				}
	
				/* Add user defined class */
				if ( oCol.sClass )
				{
					nTd.className += ' '+oCol.sClass;
				}
	
				// Visibility - add or remove as required
				if ( oCol.bVisible && ! nTrIn )
				{
					nTr.appendChild( nTd );
				}
				else if ( ! oCol.bVisible && nTrIn )
				{
					nTd.parentNode.removeChild( nTd );
				}
	
				if ( oCol.fnCreatedCell )
				{
					oCol.fnCreatedCell.call( oSettings.oInstance,
						nTd, _fnGetCellData( oSettings, iRow, i ), rowData, iRow, i
					);
				}
			}
	
			_fnCallbackFire( oSettings, 'aoRowCreatedCallback', null, [nTr, rowData, iRow, cells] );
		}
	
		// Remove once webkit bug 131819 and Chromium bug 365619 have been resolved
		// and deployed
		row.nTr.setAttribute( 'role', 'row' );
	}
	
	
	/**
	 * Add attributes to a row based on the special `DT_*` parameters in a data
	 * source object.
	 *  @param {object} settings DataTables settings object
	 *  @param {object} DataTables row object for the row to be modified
	 *  @memberof DataTable#oApi
	 */
	function _fnRowAttributes( settings, row )
	{
		var tr = row.nTr;
		var data = row._aData;
	
		if ( tr ) {
			var id = settings.rowIdFn( data );
	
			if ( id ) {
				tr.id = id;
			}
	
			if ( data.DT_RowClass ) {
				// Remove any classes added by DT_RowClass before
				var a = data.DT_RowClass.split(' ');
				row.__rowc = row.__rowc ?
					_unique( row.__rowc.concat( a ) ) :
					a;
	
				$(tr)
					.removeClass( row.__rowc.join(' ') )
					.addClass( data.DT_RowClass );
			}
	
			if ( data.DT_RowAttr ) {
				$(tr).attr( data.DT_RowAttr );
			}
	
			if ( data.DT_RowData ) {
				$(tr).data( data.DT_RowData );
			}
		}
	}
	
	
	/**
	 * Create the HTML header for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnBuildHead( oSettings )
	{
		var i, ien, cell, row, column;
		var thead = oSettings.nTHead;
		var tfoot = oSettings.nTFoot;
		var createHeader = $('th, td', thead).length === 0;
		var classes = oSettings.oClasses;
		var columns = oSettings.aoColumns;
	
		if ( createHeader ) {
			row = $('<tr/>').appendTo( thead );
		}
	
		for ( i=0, ien=columns.length ; i<ien ; i++ ) {
			column = columns[i];
			cell = $( column.nTh ).addClass( column.sClass );
	
			if ( createHeader ) {
				cell.appendTo( row );
			}
	
			// 1.11 move into sorting
			if ( oSettings.oFeatures.bSort ) {
				cell.addClass( column.sSortingClass );
	
				if ( column.bSortable !== false ) {
					cell
						.attr( 'tabindex', oSettings.iTabIndex )
						.attr( 'aria-controls', oSettings.sTableId );
	
					_fnSortAttachListener( oSettings, column.nTh, i );
				}
			}
	
			if ( column.sTitle != cell[0].innerHTML ) {
				cell.html( column.sTitle );
			}
	
			_fnRenderer( oSettings, 'header' )(
				oSettings, cell, column, classes
			);
		}
	
		if ( createHeader ) {
			_fnDetectHeader( oSettings.aoHeader, thead );
		}
		
		/* ARIA role for the rows */
	 	$(thead).find('>tr').attr('role', 'row');
	
		/* Deal with the footer - add classes if required */
		$(thead).find('>tr>th, >tr>td').addClass( classes.sHeaderTH );
		$(tfoot).find('>tr>th, >tr>td').addClass( classes.sFooterTH );
	
		// Cache the footer cells. Note that we only take the cells from the first
		// row in the footer. If there is more than one row the user wants to
		// interact with, they need to use the table().foot() method. Note also this
		// allows cells to be used for multiple columns using colspan
		if ( tfoot !== null ) {
			var cells = oSettings.aoFooter[0];
	
			for ( i=0, ien=cells.length ; i<ien ; i++ ) {
				column = columns[i];
				column.nTf = cells[i].cell;
	
				if ( column.sClass ) {
					$(column.nTf).addClass( column.sClass );
				}
			}
		}
	}
	
	
	/**
	 * Draw the header (or footer) element based on the column visibility states. The
	 * methodology here is to use the layout array from _fnDetectHeader, modified for
	 * the instantaneous column visibility, to construct the new layout. The grid is
	 * traversed over cell at a time in a rows x columns grid fashion, although each
	 * cell insert can cover multiple elements in the grid - which is tracks using the
	 * aApplied array. Cell inserts in the grid will only occur where there isn't
	 * already a cell in that position.
	 *  @param {object} oSettings dataTables settings object
	 *  @param array {objects} aoSource Layout array from _fnDetectHeader
	 *  @param {boolean} [bIncludeHidden=false] If true then include the hidden columns in the calc,
	 *  @memberof DataTable#oApi
	 */
	function _fnDrawHead( oSettings, aoSource, bIncludeHidden )
	{
		var i, iLen, j, jLen, k, kLen, n, nLocalTr;
		var aoLocal = [];
		var aApplied = [];
		var iColumns = oSettings.aoColumns.length;
		var iRowspan, iColspan;
	
		if ( ! aoSource )
		{
			return;
		}
	
		if (  bIncludeHidden === undefined )
		{
			bIncludeHidden = false;
		}
	
		/* Make a copy of the master layout array, but without the visible columns in it */
		for ( i=0, iLen=aoSource.length ; i<iLen ; i++ )
		{
			aoLocal[i] = aoSource[i].slice();
			aoLocal[i].nTr = aoSource[i].nTr;
	
			/* Remove any columns which are currently hidden */
			for ( j=iColumns-1 ; j>=0 ; j-- )
			{
				if ( !oSettings.aoColumns[j].bVisible && !bIncludeHidden )
				{
					aoLocal[i].splice( j, 1 );
				}
			}
	
			/* Prep the applied array - it needs an element for each row */
			aApplied.push( [] );
		}
	
		for ( i=0, iLen=aoLocal.length ; i<iLen ; i++ )
		{
			nLocalTr = aoLocal[i].nTr;
	
			/* All cells are going to be replaced, so empty out the row */
			if ( nLocalTr )
			{
				while( (n = nLocalTr.firstChild) )
				{
					nLocalTr.removeChild( n );
				}
			}
	
			for ( j=0, jLen=aoLocal[i].length ; j<jLen ; j++ )
			{
				iRowspan = 1;
				iColspan = 1;
	
				/* Check to see if there is already a cell (row/colspan) covering our target
				 * insert point. If there is, then there is nothing to do.
				 */
				if ( aApplied[i][j] === undefined )
				{
					nLocalTr.appendChild( aoLocal[i][j].cell );
					aApplied[i][j] = 1;
	
					/* Expand the cell to cover as many rows as needed */
					while ( aoLocal[i+iRowspan] !== undefined &&
					        aoLocal[i][j].cell == aoLocal[i+iRowspan][j].cell )
					{
						aApplied[i+iRowspan][j] = 1;
						iRowspan++;
					}
	
					/* Expand the cell to cover as many columns as needed */
					while ( aoLocal[i][j+iColspan] !== undefined &&
					        aoLocal[i][j].cell == aoLocal[i][j+iColspan].cell )
					{
						/* Must update the applied array over the rows for the columns */
						for ( k=0 ; k<iRowspan ; k++ )
						{
							aApplied[i+k][j+iColspan] = 1;
						}
						iColspan++;
					}
	
					/* Do the actual expansion in the DOM */
					$(aoLocal[i][j].cell)
						.attr('rowspan', iRowspan)
						.attr('colspan', iColspan);
				}
			}
		}
	}
	
	
	/**
	 * Insert the required TR nodes into the table for display
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnDraw( oSettings )
	{
		/* Provide a pre-callback function which can be used to cancel the draw is false is returned */
		var aPreDraw = _fnCallbackFire( oSettings, 'aoPreDrawCallback', 'preDraw', [oSettings] );
		if ( $.inArray( false, aPreDraw ) !== -1 )
		{
			_fnProcessingDisplay( oSettings, false );
			return;
		}
	
		var i, iLen, n;
		var anRows = [];
		var iRowCount = 0;
		var asStripeClasses = oSettings.asStripeClasses;
		var iStripes = asStripeClasses.length;
		var iOpenRows = oSettings.aoOpenRows.length;
		var oLang = oSettings.oLanguage;
		var iInitDisplayStart = oSettings.iInitDisplayStart;
		var bServerSide = _fnDataSource( oSettings ) == 'ssp';
		var aiDisplay = oSettings.aiDisplay;
	
		oSettings.bDrawing = true;
	
		/* Check and see if we have an initial draw position from state saving */
		if ( iInitDisplayStart !== undefined && iInitDisplayStart !== -1 )
		{
			oSettings._iDisplayStart = bServerSide ?
				iInitDisplayStart :
				iInitDisplayStart >= oSettings.fnRecordsDisplay() ?
					0 :
					iInitDisplayStart;
	
			oSettings.iInitDisplayStart = -1;
		}
	
		var iDisplayStart = oSettings._iDisplayStart;
		var iDisplayEnd = oSettings.fnDisplayEnd();
	
		/* Server-side processing draw intercept */
		if ( oSettings.bDeferLoading )
		{
			oSettings.bDeferLoading = false;
			oSettings.iDraw++;
			_fnProcessingDisplay( oSettings, false );
		}
		else if ( !bServerSide )
		{
			oSettings.iDraw++;
		}
		else if ( !oSettings.bDestroying && !_fnAjaxUpdate( oSettings ) )
		{
			return;
		}
	
		if ( aiDisplay.length !== 0 )
		{
			var iStart = bServerSide ? 0 : iDisplayStart;
			var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
	
			for ( var j=iStart ; j<iEnd ; j++ )
			{
				var iDataIndex = aiDisplay[j];
				var aoData = oSettings.aoData[ iDataIndex ];
				if ( aoData.nTr === null )
				{
					_fnCreateTr( oSettings, iDataIndex );
				}
	
				var nRow = aoData.nTr;
	
				/* Remove the old striping classes and then add the new one */
				if ( iStripes !== 0 )
				{
					var sStripe = asStripeClasses[ iRowCount % iStripes ];
					if ( aoData._sRowStripe != sStripe )
					{
						$(nRow).removeClass( aoData._sRowStripe ).addClass( sStripe );
						aoData._sRowStripe = sStripe;
					}
				}
	
				// Row callback functions - might want to manipulate the row
				// iRowCount and j are not currently documented. Are they at all
				// useful?
				_fnCallbackFire( oSettings, 'aoRowCallback', null,
					[nRow, aoData._aData, iRowCount, j, iDataIndex] );
	
				anRows.push( nRow );
				iRowCount++;
			}
		}
		else
		{
			/* Table is empty - create a row with an empty message in it */
			var sZero = oLang.sZeroRecords;
			if ( oSettings.iDraw == 1 &&  _fnDataSource( oSettings ) == 'ajax' )
			{
				sZero = oLang.sLoadingRecords;
			}
			else if ( oLang.sEmptyTable && oSettings.fnRecordsTotal() === 0 )
			{
				sZero = oLang.sEmptyTable;
			}
	
			anRows[ 0 ] = $( '<tr/>', { 'class': iStripes ? asStripeClasses[0] : '' } )
				.append( $('<td />', {
					'valign':  'top',
					'colSpan': _fnVisbleColumns( oSettings ),
					'class':   oSettings.oClasses.sRowEmpty
				} ).html( sZero ) )[0];
		}
	
		/* Header and footer callbacks */
		_fnCallbackFire( oSettings, 'aoHeaderCallback', 'header', [ $(oSettings.nTHead).children('tr')[0],
			_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );
	
		_fnCallbackFire( oSettings, 'aoFooterCallback', 'footer', [ $(oSettings.nTFoot).children('tr')[0],
			_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );
	
		var body = $(oSettings.nTBody);
	
		body.children().detach();
		body.append( $(anRows) );
	
		/* Call all required callback functions for the end of a draw */
		_fnCallbackFire( oSettings, 'aoDrawCallback', 'draw', [oSettings] );
	
		/* Draw is complete, sorting and filtering must be as well */
		oSettings.bSorted = false;
		oSettings.bFiltered = false;
		oSettings.bDrawing = false;
	}
	
	
	/**
	 * Redraw the table - taking account of the various features which are enabled
	 *  @param {object} oSettings dataTables settings object
	 *  @param {boolean} [holdPosition] Keep the current paging position. By default
	 *    the paging is reset to the first page
	 *  @memberof DataTable#oApi
	 */
	function _fnReDraw( settings, holdPosition )
	{
		var
			features = settings.oFeatures,
			sort     = features.bSort,
			filter   = features.bFilter;
	
		if ( sort ) {
			_fnSort( settings );
		}
	
		if ( filter ) {
			_fnFilterComplete( settings, settings.oPreviousSearch );
		}
		else {
			// No filtering, so we want to just use the display master
			settings.aiDisplay = settings.aiDisplayMaster.slice();
		}
	
		if ( holdPosition !== true ) {
			settings._iDisplayStart = 0;
		}
	
		// Let any modules know about the draw hold position state (used by
		// scrolling internally)
		settings._drawHold = holdPosition;
	
		_fnDraw( settings );
	
		settings._drawHold = false;
	}
	
	
	/**
	 * Add the options to the page HTML for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnAddOptionsHtml ( oSettings )
	{
		var classes = oSettings.oClasses;
		var table = $(oSettings.nTable);
		var holding = $('<div/>').insertBefore( table ); // Holding element for speed
		var features = oSettings.oFeatures;
	
		// All DataTables are wrapped in a div
		var insert = $('<div/>', {
			id:      oSettings.sTableId+'_wrapper',
			'class': classes.sWrapper + (oSettings.nTFoot ? '' : ' '+classes.sNoFooter)
		} );
	
		oSettings.nHolding = holding[0];
		oSettings.nTableWrapper = insert[0];
		oSettings.nTableReinsertBefore = oSettings.nTable.nextSibling;
	
		/* Loop over the user set positioning and place the elements as needed */
		var aDom = oSettings.sDom.split('');
		var featureNode, cOption, nNewNode, cNext, sAttr, j;
		for ( var i=0 ; i<aDom.length ; i++ )
		{
			featureNode = null;
			cOption = aDom[i];
	
			if ( cOption == '<' )
			{
				/* New container div */
				nNewNode = $('<div/>')[0];
	
				/* Check to see if we should append an id and/or a class name to the container */
				cNext = aDom[i+1];
				if ( cNext == "'" || cNext == '"' )
				{
					sAttr = "";
					j = 2;
					while ( aDom[i+j] != cNext )
					{
						sAttr += aDom[i+j];
						j++;
					}
	
					/* Replace jQuery UI constants @todo depreciated */
					if ( sAttr == "H" )
					{
						sAttr = classes.sJUIHeader;
					}
					else if ( sAttr == "F" )
					{
						sAttr = classes.sJUIFooter;
					}
	
					/* The attribute can be in the format of "#id.class", "#id" or "class" This logic
					 * breaks the string into parts and applies them as needed
					 */
					if ( sAttr.indexOf('.') != -1 )
					{
						var aSplit = sAttr.split('.');
						nNewNode.id = aSplit[0].substr(1, aSplit[0].length-1);
						nNewNode.className = aSplit[1];
					}
					else if ( sAttr.charAt(0) == "#" )
					{
						nNewNode.id = sAttr.substr(1, sAttr.length-1);
					}
					else
					{
						nNewNode.className = sAttr;
					}
	
					i += j; /* Move along the position array */
				}
	
				insert.append( nNewNode );
				insert = $(nNewNode);
			}
			else if ( cOption == '>' )
			{
				/* End container div */
				insert = insert.parent();
			}
			// @todo Move options into their own plugins?
			else if ( cOption == 'l' && features.bPaginate && features.bLengthChange )
			{
				/* Length */
				featureNode = _fnFeatureHtmlLength( oSettings );
			}
			else if ( cOption == 'f' && features.bFilter )
			{
				/* Filter */
				featureNode = _fnFeatureHtmlFilter( oSettings );
			}
			else if ( cOption == 'r' && features.bProcessing )
			{
				/* pRocessing */
				featureNode = _fnFeatureHtmlProcessing( oSettings );
			}
			else if ( cOption == 't' )
			{
				/* Table */
				featureNode = _fnFeatureHtmlTable( oSettings );
			}
			else if ( cOption ==  'i' && features.bInfo )
			{
				/* Info */
				featureNode = _fnFeatureHtmlInfo( oSettings );
			}
			else if ( cOption == 'p' && features.bPaginate )
			{
				/* Pagination */
				featureNode = _fnFeatureHtmlPaginate( oSettings );
			}
			else if ( DataTable.ext.feature.length !== 0 )
			{
				/* Plug-in features */
				var aoFeatures = DataTable.ext.feature;
				for ( var k=0, kLen=aoFeatures.length ; k<kLen ; k++ )
				{
					if ( cOption == aoFeatures[k].cFeature )
					{
						featureNode = aoFeatures[k].fnInit( oSettings );
						break;
					}
				}
			}
	
			/* Add to the 2D features array */
			if ( featureNode )
			{
				var aanFeatures = oSettings.aanFeatures;
	
				if ( ! aanFeatures[cOption] )
				{
					aanFeatures[cOption] = [];
				}
	
				aanFeatures[cOption].push( featureNode );
				insert.append( featureNode );
			}
		}
	
		/* Built our DOM structure - replace the holding div with what we want */
		holding.replaceWith( insert );
		oSettings.nHolding = null;
	}
	
	
	/**
	 * Use the DOM source to create up an array of header cells. The idea here is to
	 * create a layout grid (array) of rows x columns, which contains a reference
	 * to the cell that that point in the grid (regardless of col/rowspan), such that
	 * any column / row could be removed and the new grid constructed
	 *  @param array {object} aLayout Array to store the calculated layout in
	 *  @param {node} nThead The header/footer element for the table
	 *  @memberof DataTable#oApi
	 */
	function _fnDetectHeader ( aLayout, nThead )
	{
		var nTrs = $(nThead).children('tr');
		var nTr, nCell;
		var i, k, l, iLen, jLen, iColShifted, iColumn, iColspan, iRowspan;
		var bUnique;
		var fnShiftCol = function ( a, i, j ) {
			var k = a[i];
	                while ( k[j] ) {
				j++;
			}
			return j;
		};
	
		aLayout.splice( 0, aLayout.length );
	
		/* We know how many rows there are in the layout - so prep it */
		for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
		{
			aLayout.push( [] );
		}
	
		/* Calculate a layout array */
		for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
		{
			nTr = nTrs[i];
			iColumn = 0;
	
			/* For every cell in the row... */
			nCell = nTr.firstChild;
			while ( nCell ) {
				if ( nCell.nodeName.toUpperCase() == "TD" ||
				     nCell.nodeName.toUpperCase() == "TH" )
				{
					/* Get the col and rowspan attributes from the DOM and sanitise them */
					iColspan = nCell.getAttribute('colspan') * 1;
					iRowspan = nCell.getAttribute('rowspan') * 1;
					iColspan = (!iColspan || iColspan===0 || iColspan===1) ? 1 : iColspan;
					iRowspan = (!iRowspan || iRowspan===0 || iRowspan===1) ? 1 : iRowspan;
	
					/* There might be colspan cells already in this row, so shift our target
					 * accordingly
					 */
					iColShifted = fnShiftCol( aLayout, i, iColumn );
	
					/* Cache calculation for unique columns */
					bUnique = iColspan === 1 ? true : false;
	
					/* If there is col / rowspan, copy the information into the layout grid */
					for ( l=0 ; l<iColspan ; l++ )
					{
						for ( k=0 ; k<iRowspan ; k++ )
						{
							aLayout[i+k][iColShifted+l] = {
								"cell": nCell,
								"unique": bUnique
							};
							aLayout[i+k].nTr = nTr;
						}
					}
				}
				nCell = nCell.nextSibling;
			}
		}
	}
	
	
	/**
	 * Get an array of unique th elements, one for each column
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} nHeader automatically detect the layout from this node - optional
	 *  @param {array} aLayout thead/tfoot layout from _fnDetectHeader - optional
	 *  @returns array {node} aReturn list of unique th's
	 *  @memberof DataTable#oApi
	 */
	function _fnGetUniqueThs ( oSettings, nHeader, aLayout )
	{
		var aReturn = [];
		if ( !aLayout )
		{
			aLayout = oSettings.aoHeader;
			if ( nHeader )
			{
				aLayout = [];
				_fnDetectHeader( aLayout, nHeader );
			}
		}
	
		for ( var i=0, iLen=aLayout.length ; i<iLen ; i++ )
		{
			for ( var j=0, jLen=aLayout[i].length ; j<jLen ; j++ )
			{
				if ( aLayout[i][j].unique &&
					 (!aReturn[j] || !oSettings.bSortCellsTop) )
				{
					aReturn[j] = aLayout[i][j].cell;
				}
			}
		}
	
		return aReturn;
	}
	
	/**
	 * Create an Ajax call based on the table's settings, taking into account that
	 * parameters can have multiple forms, and backwards compatibility.
	 *
	 * @param {object} oSettings dataTables settings object
	 * @param {array} data Data to send to the server, required by
	 *     DataTables - may be augmented by developer callbacks
	 * @param {function} fn Callback function to run when data is obtained
	 */
	function _fnBuildAjax( oSettings, data, fn )
	{
		// Compatibility with 1.9-, allow fnServerData and event to manipulate
		_fnCallbackFire( oSettings, 'aoServerParams', 'serverParams', [data] );
	
		// Convert to object based for 1.10+ if using the old array scheme which can
		// come from server-side processing or serverParams
		if ( data && $.isArray(data) ) {
			var tmp = {};
			var rbracket = /(.*?)\[\]$/;
	
			$.each( data, function (key, val) {
				var match = val.name.match(rbracket);
	
				if ( match ) {
					// Support for arrays
					var name = match[0];
	
					if ( ! tmp[ name ] ) {
						tmp[ name ] = [];
					}
					tmp[ name ].push( val.value );
				}
				else {
					tmp[val.name] = val.value;
				}
			} );
			data = tmp;
		}
	
		var ajaxData;
		var ajax = oSettings.ajax;
		var instance = oSettings.oInstance;
		var callback = function ( json ) {
			_fnCallbackFire( oSettings, null, 'xhr', [oSettings, json, oSettings.jqXHR] );
			fn( json );
		};
	
		if ( $.isPlainObject( ajax ) && ajax.data )
		{
			ajaxData = ajax.data;
	
			var newData = typeof ajaxData === 'function' ?
				ajaxData( data, oSettings ) :  // fn can manipulate data or return
				ajaxData;                      // an object object or array to merge
	
			// If the function returned something, use that alone
			data = typeof ajaxData === 'function' && newData ?
				newData :
				$.extend( true, data, newData );
	
			// Remove the data property as we've resolved it already and don't want
			// jQuery to do it again (it is restored at the end of the function)
			delete ajax.data;
		}
	
		var baseAjax = {
			"data": data,
			"success": function (json) {
				var error = json.error || json.sError;
				if ( error ) {
					_fnLog( oSettings, 0, error );
				}
	
				oSettings.json = json;
				callback( json );
			},
			"dataType": "json",
			"cache": false,
			"type": oSettings.sServerMethod,
			"error": function (xhr, error, thrown) {
				var ret = _fnCallbackFire( oSettings, null, 'xhr', [oSettings, null, oSettings.jqXHR] );
	
				if ( $.inArray( true, ret ) === -1 ) {
					if ( error == "parsererror" ) {
						_fnLog( oSettings, 0, 'Invalid JSON response', 1 );
					}
					else if ( xhr.readyState === 4 ) {
						_fnLog( oSettings, 0, 'Ajax error', 7 );
					}
				}
	
				_fnProcessingDisplay( oSettings, false );
			}
		};
	
		// Store the data submitted for the API
		oSettings.oAjaxData = data;
	
		// Allow plug-ins and external processes to modify the data
		_fnCallbackFire( oSettings, null, 'preXhr', [oSettings, data] );
	
		if ( oSettings.fnServerData )
		{
			// DataTables 1.9- compatibility
			oSettings.fnServerData.call( instance,
				oSettings.sAjaxSource,
				$.map( data, function (val, key) { // Need to convert back to 1.9 trad format
					return { name: key, value: val };
				} ),
				callback,
				oSettings
			);
		}
		else if ( oSettings.sAjaxSource || typeof ajax === 'string' )
		{
			// DataTables 1.9- compatibility
			oSettings.jqXHR = $.ajax( $.extend( baseAjax, {
				url: ajax || oSettings.sAjaxSource
			} ) );
		}
		else if ( typeof ajax === 'function' )
		{
			// Is a function - let the caller define what needs to be done
			oSettings.jqXHR = ajax.call( instance, data, callback, oSettings );
		}
		else
		{
			// Object to extend the base settings
			oSettings.jqXHR = $.ajax( $.extend( baseAjax, ajax ) );
	
			// Restore for next time around
			ajax.data = ajaxData;
		}
	}
	
	
	/**
	 * Update the table using an Ajax call
	 *  @param {object} settings dataTables settings object
	 *  @returns {boolean} Block the table drawing or not
	 *  @memberof DataTable#oApi
	 */
	function _fnAjaxUpdate( settings )
	{
		if ( settings.bAjaxDataGet ) {
			settings.iDraw++;
			_fnProcessingDisplay( settings, true );
	
			_fnBuildAjax(
				settings,
				_fnAjaxParameters( settings ),
				function(json) {
					_fnAjaxUpdateDraw( settings, json );
				}
			);
	
			return false;
		}
		return true;
	}
	
	
	/**
	 * Build up the parameters in an object needed for a server-side processing
	 * request. Note that this is basically done twice, is different ways - a modern
	 * method which is used by default in DataTables 1.10 which uses objects and
	 * arrays, or the 1.9- method with is name / value pairs. 1.9 method is used if
	 * the sAjaxSource option is used in the initialisation, or the legacyAjax
	 * option is set.
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {bool} block the table drawing or not
	 *  @memberof DataTable#oApi
	 */
	function _fnAjaxParameters( settings )
	{
		var
			columns = settings.aoColumns,
			columnCount = columns.length,
			features = settings.oFeatures,
			preSearch = settings.oPreviousSearch,
			preColSearch = settings.aoPreSearchCols,
			i, data = [], dataProp, column, columnSearch,
			sort = _fnSortFlatten( settings ),
			displayStart = settings._iDisplayStart,
			displayLength = features.bPaginate !== false ?
				settings._iDisplayLength :
				-1;
	
		var param = function ( name, value ) {
			data.push( { 'name': name, 'value': value } );
		};
	
		// DataTables 1.9- compatible method
		param( 'sEcho',          settings.iDraw );
		param( 'iColumns',       columnCount );
		param( 'sColumns',       _pluck( columns, 'sName' ).join(',') );
		param( 'iDisplayStart',  displayStart );
		param( 'iDisplayLength', displayLength );
	
		// DataTables 1.10+ method
		var d = {
			draw:    settings.iDraw,
			columns: [],
			order:   [],
			start:   displayStart,
			length:  displayLength,
			search:  {
				value: preSearch.sSearch,
				regex: preSearch.bRegex
			}
		};
	
		for ( i=0 ; i<columnCount ; i++ ) {
			column = columns[i];
			columnSearch = preColSearch[i];
			dataProp = typeof column.mData=="function" ? 'function' : column.mData ;
	
			d.columns.push( {
				data:       dataProp,
				name:       column.sName,
				searchable: column.bSearchable,
				orderable:  column.bSortable,
				search:     {
					value: columnSearch.sSearch,
					regex: columnSearch.bRegex
				}
			} );
	
			param( "mDataProp_"+i, dataProp );
	
			if ( features.bFilter ) {
				param( 'sSearch_'+i,     columnSearch.sSearch );
				param( 'bRegex_'+i,      columnSearch.bRegex );
				param( 'bSearchable_'+i, column.bSearchable );
			}
	
			if ( features.bSort ) {
				param( 'bSortable_'+i, column.bSortable );
			}
		}
	
		if ( features.bFilter ) {
			param( 'sSearch', preSearch.sSearch );
			param( 'bRegex', preSearch.bRegex );
		}
	
		if ( features.bSort ) {
			$.each( sort, function ( i, val ) {
				d.order.push( { column: val.col, dir: val.dir } );
	
				param( 'iSortCol_'+i, val.col );
				param( 'sSortDir_'+i, val.dir );
			} );
	
			param( 'iSortingCols', sort.length );
		}
	
		// If the legacy.ajax parameter is null, then we automatically decide which
		// form to use, based on sAjaxSource
		var legacy = DataTable.ext.legacy.ajax;
		if ( legacy === null ) {
			return settings.sAjaxSource ? data : d;
		}
	
		// Otherwise, if legacy has been specified then we use that to decide on the
		// form
		return legacy ? data : d;
	}
	
	
	/**
	 * Data the data from the server (nuking the old) and redraw the table
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} json json data return from the server.
	 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
	 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
	 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
	 *  @param {array} json.aaData The data to display on this page
	 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
	 *  @memberof DataTable#oApi
	 */
	function _fnAjaxUpdateDraw ( settings, json )
	{
		// v1.10 uses camelCase variables, while 1.9 uses Hungarian notation.
		// Support both
		var compat = function ( old, modern ) {
			return json[old] !== undefined ? json[old] : json[modern];
		};
	
		var data = _fnAjaxDataSrc( settings, json );
		var draw            = compat( 'sEcho',                'draw' );
		var recordsTotal    = compat( 'iTotalRecords',        'recordsTotal' );
		var recordsFiltered = compat( 'iTotalDisplayRecords', 'recordsFiltered' );
	
		if ( draw ) {
			// Protect against out of sequence returns
			if ( draw*1 < settings.iDraw ) {
				return;
			}
			settings.iDraw = draw * 1;
		}
	
		_fnClearTable( settings );
		settings._iRecordsTotal   = parseInt(recordsTotal, 10);
		settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
	
		for ( var i=0, ien=data.length ; i<ien ; i++ ) {
			_fnAddData( settings, data[i] );
		}
		settings.aiDisplay = settings.aiDisplayMaster.slice();
	
		settings.bAjaxDataGet = false;
		_fnDraw( settings );
	
		if ( ! settings._bInitComplete ) {
			_fnInitComplete( settings, json );
		}
	
		settings.bAjaxDataGet = true;
		_fnProcessingDisplay( settings, false );
	}
	
	
	/**
	 * Get the data from the JSON data source to use for drawing a table. Using
	 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
	 * source object, or from a processing function.
	 *  @param {object} oSettings dataTables settings object
	 *  @param  {object} json Data source object / array from the server
	 *  @return {array} Array of data to use
	 */
	function _fnAjaxDataSrc ( oSettings, json )
	{
		var dataSrc = $.isPlainObject( oSettings.ajax ) && oSettings.ajax.dataSrc !== undefined ?
			oSettings.ajax.dataSrc :
			oSettings.sAjaxDataProp; // Compatibility with 1.9-.
	
		// Compatibility with 1.9-. In order to read from aaData, check if the
		// default has been changed, if not, check for aaData
		if ( dataSrc === 'data' ) {
			return json.aaData || json[dataSrc];
		}
	
		return dataSrc !== "" ?
			_fnGetObjectDataFn( dataSrc )( json ) :
			json;
	}
	
	/**
	 * Generate the node required for filtering text
	 *  @returns {node} Filter control element
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlFilter ( settings )
	{
		var classes = settings.oClasses;
		var tableId = settings.sTableId;
		var language = settings.oLanguage;
		var previousSearch = settings.oPreviousSearch;
		var features = settings.aanFeatures;
		var input = '<input type="search" class="'+classes.sFilterInput+'"/>';
	
		var str = language.sSearch;
		str = str.match(/_INPUT_/) ?
			str.replace('_INPUT_', input) :
			str+input;
	
		var filter = $('<div/>', {
				'id': ! features.f ? tableId+'_filter' : null,
				'class': classes.sFilter
			} )
			.append( $('<label/>' ).append( str ) );
	
		var searchFn = function() {
			/* Update all other filter input elements for the new display */
			var n = features.f;
			var val = !this.value ? "" : this.value; // mental IE8 fix :-(
	
			/* Now do the filter */
			if ( val != previousSearch.sSearch ) {
				_fnFilterComplete( settings, {
					"sSearch": val,
					"bRegex": previousSearch.bRegex,
					"bSmart": previousSearch.bSmart ,
					"bCaseInsensitive": previousSearch.bCaseInsensitive
				} );
	
				// Need to redraw, without resorting
				settings._iDisplayStart = 0;
				_fnDraw( settings );
			}
		};
	
		var searchDelay = settings.searchDelay !== null ?
			settings.searchDelay :
			_fnDataSource( settings ) === 'ssp' ?
				400 :
				0;
	
		var jqFilter = $('input', filter)
			.val( previousSearch.sSearch )
			.attr( 'placeholder', language.sSearchPlaceholder )
			.on(
				'keyup.DT search.DT input.DT paste.DT cut.DT',
				searchDelay ?
					_fnThrottle( searchFn, searchDelay ) :
					searchFn
			)
			.on( 'keypress.DT', function(e) {
				/* Prevent form submission */
				if ( e.keyCode == 13 ) {
					return false;
				}
			} )
			.attr('aria-controls', tableId);
	
		// Update the input elements whenever the table is filtered
		$(settings.nTable).on( 'search.dt.DT', function ( ev, s ) {
			if ( settings === s ) {
				// IE9 throws an 'unknown error' if document.activeElement is used
				// inside an iframe or frame...
				try {
					if ( jqFilter[0] !== document.activeElement ) {
						jqFilter.val( previousSearch.sSearch );
					}
				}
				catch ( e ) {}
			}
		} );
	
		return filter[0];
	}
	
	
	/**
	 * Filter the table using both the global filter and column based filtering
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} oSearch search information
	 *  @param {int} [iForce] force a research of the master array (1) or not (undefined or 0)
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterComplete ( oSettings, oInput, iForce )
	{
		var oPrevSearch = oSettings.oPreviousSearch;
		var aoPrevSearch = oSettings.aoPreSearchCols;
		var fnSaveFilter = function ( oFilter ) {
			/* Save the filtering values */
			oPrevSearch.sSearch = oFilter.sSearch;
			oPrevSearch.bRegex = oFilter.bRegex;
			oPrevSearch.bSmart = oFilter.bSmart;
			oPrevSearch.bCaseInsensitive = oFilter.bCaseInsensitive;
		};
		var fnRegex = function ( o ) {
			// Backwards compatibility with the bEscapeRegex option
			return o.bEscapeRegex !== undefined ? !o.bEscapeRegex : o.bRegex;
		};
	
		// Resolve any column types that are unknown due to addition or invalidation
		// @todo As per sort - can this be moved into an event handler?
		_fnColumnTypes( oSettings );
	
		/* In server-side processing all filtering is done by the server, so no point hanging around here */
		if ( _fnDataSource( oSettings ) != 'ssp' )
		{
			/* Global filter */
			_fnFilter( oSettings, oInput.sSearch, iForce, fnRegex(oInput), oInput.bSmart, oInput.bCaseInsensitive );
			fnSaveFilter( oInput );
	
			/* Now do the individual column filter */
			for ( var i=0 ; i<aoPrevSearch.length ; i++ )
			{
				_fnFilterColumn( oSettings, aoPrevSearch[i].sSearch, i, fnRegex(aoPrevSearch[i]),
					aoPrevSearch[i].bSmart, aoPrevSearch[i].bCaseInsensitive );
			}
	
			/* Custom filtering */
			_fnFilterCustom( oSettings );
		}
		else
		{
			fnSaveFilter( oInput );
		}
	
		/* Tell the draw function we have been filtering */
		oSettings.bFiltered = true;
		_fnCallbackFire( oSettings, null, 'search', [oSettings] );
	}
	
	
	/**
	 * Apply custom filtering functions
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterCustom( settings )
	{
		var filters = DataTable.ext.search;
		var displayRows = settings.aiDisplay;
		var row, rowIdx;
	
		for ( var i=0, ien=filters.length ; i<ien ; i++ ) {
			var rows = [];
	
			// Loop over each row and see if it should be included
			for ( var j=0, jen=displayRows.length ; j<jen ; j++ ) {
				rowIdx = displayRows[ j ];
				row = settings.aoData[ rowIdx ];
	
				if ( filters[i]( settings, row._aFilterData, rowIdx, row._aData, j ) ) {
					rows.push( rowIdx );
				}
			}
	
			// So the array reference doesn't break set the results into the
			// existing array
			displayRows.length = 0;
			$.merge( displayRows, rows );
		}
	}
	
	
	/**
	 * Filter the table on a per-column basis
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sInput string to filter on
	 *  @param {int} iColumn column to filter
	 *  @param {bool} bRegex treat search string as a regular expression or not
	 *  @param {bool} bSmart use smart filtering or not
	 *  @param {bool} bCaseInsensitive Do case insenstive matching or not
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterColumn ( settings, searchStr, colIdx, regex, smart, caseInsensitive )
	{
		if ( searchStr === '' ) {
			return;
		}
	
		var data;
		var out = [];
		var display = settings.aiDisplay;
		var rpSearch = _fnFilterCreateSearch( searchStr, regex, smart, caseInsensitive );
	
		for ( var i=0 ; i<display.length ; i++ ) {
			data = settings.aoData[ display[i] ]._aFilterData[ colIdx ];
	
			if ( rpSearch.test( data ) ) {
				out.push( display[i] );
			}
		}
	
		settings.aiDisplay = out;
	}
	
	
	/**
	 * Filter the data table based on user input and draw the table
	 *  @param {object} settings dataTables settings object
	 *  @param {string} input string to filter on
	 *  @param {int} force optional - force a research of the master array (1) or not (undefined or 0)
	 *  @param {bool} regex treat as a regular expression or not
	 *  @param {bool} smart perform smart filtering or not
	 *  @param {bool} caseInsensitive Do case insenstive matching or not
	 *  @memberof DataTable#oApi
	 */
	function _fnFilter( settings, input, force, regex, smart, caseInsensitive )
	{
		var rpSearch = _fnFilterCreateSearch( input, regex, smart, caseInsensitive );
		var prevSearch = settings.oPreviousSearch.sSearch;
		var displayMaster = settings.aiDisplayMaster;
		var display, invalidated, i;
		var filtered = [];
	
		// Need to take account of custom filtering functions - always filter
		if ( DataTable.ext.search.length !== 0 ) {
			force = true;
		}
	
		// Check if any of the rows were invalidated
		invalidated = _fnFilterData( settings );
	
		// If the input is blank - we just want the full data set
		if ( input.length <= 0 ) {
			settings.aiDisplay = displayMaster.slice();
		}
		else {
			// New search - start from the master array
			if ( invalidated ||
				 force ||
				 prevSearch.length > input.length ||
				 input.indexOf(prevSearch) !== 0 ||
				 settings.bSorted // On resort, the display master needs to be
				                  // re-filtered since indexes will have changed
			) {
				settings.aiDisplay = displayMaster.slice();
			}
	
			// Search the display array
			display = settings.aiDisplay;
	
			for ( i=0 ; i<display.length ; i++ ) {
				if ( rpSearch.test( settings.aoData[ display[i] ]._sFilterRow ) ) {
					filtered.push( display[i] );
				}
			}
	
			settings.aiDisplay = filtered;
		}
	}
	
	
	/**
	 * Build a regular expression object suitable for searching a table
	 *  @param {string} sSearch string to search for
	 *  @param {bool} bRegex treat as a regular expression or not
	 *  @param {bool} bSmart perform smart filtering or not
	 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
	 *  @returns {RegExp} constructed object
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterCreateSearch( search, regex, smart, caseInsensitive )
	{
		search = regex ?
			search :
			_fnEscapeRegex( search );
		
		if ( smart ) {
			/* For smart filtering we want to allow the search to work regardless of
			 * word order. We also want double quoted text to be preserved, so word
			 * order is important - a la google. So this is what we want to
			 * generate:
			 * 
			 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
			 */
			var a = $.map( search.match( /"[^"]+"|[^ ]+/g ) || [''], function ( word ) {
				if ( word.charAt(0) === '"' ) {
					var m = word.match( /^"(.*)"$/ );
					word = m ? m[1] : word;
				}
	
				return word.replace('"', '');
			} );
	
			search = '^(?=.*?'+a.join( ')(?=.*?' )+').*$';
		}
	
		return new RegExp( search, caseInsensitive ? 'i' : '' );
	}
	
	
	/**
	 * Escape a string such that it can be used in a regular expression
	 *  @param {string} sVal string to escape
	 *  @returns {string} escaped string
	 *  @memberof DataTable#oApi
	 */
	var _fnEscapeRegex = DataTable.util.escapeRegex;
	
	var __filter_div = $('<div>')[0];
	var __filter_div_textContent = __filter_div.textContent !== undefined;
	
	// Update the filtering data for each row if needed (by invalidation or first run)
	function _fnFilterData ( settings )
	{
		var columns = settings.aoColumns;
		var column;
		var i, j, ien, jen, filterData, cellData, row;
		var fomatters = DataTable.ext.type.search;
		var wasInvalidated = false;
	
		for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			row = settings.aoData[i];
	
			if ( ! row._aFilterData ) {
				filterData = [];
	
				for ( j=0, jen=columns.length ; j<jen ; j++ ) {
					column = columns[j];
	
					if ( column.bSearchable ) {
						cellData = _fnGetCellData( settings, i, j, 'filter' );
	
						if ( fomatters[ column.sType ] ) {
							cellData = fomatters[ column.sType ]( cellData );
						}
	
						// Search in DataTables 1.10 is string based. In 1.11 this
						// should be altered to also allow strict type checking.
						if ( cellData === null ) {
							cellData = '';
						}
	
						if ( typeof cellData !== 'string' && cellData.toString ) {
							cellData = cellData.toString();
						}
					}
					else {
						cellData = '';
					}
	
					// If it looks like there is an HTML entity in the string,
					// attempt to decode it so sorting works as expected. Note that
					// we could use a single line of jQuery to do this, but the DOM
					// method used here is much faster http://jsperf.com/html-decode
					if ( cellData.indexOf && cellData.indexOf('&') !== -1 ) {
						__filter_div.innerHTML = cellData;
						cellData = __filter_div_textContent ?
							__filter_div.textContent :
							__filter_div.innerText;
					}
	
					if ( cellData.replace ) {
						cellData = cellData.replace(/[\r\n]/g, '');
					}
	
					filterData.push( cellData );
				}
	
				row._aFilterData = filterData;
				row._sFilterRow = filterData.join('  ');
				wasInvalidated = true;
			}
		}
	
		return wasInvalidated;
	}
	
	
	/**
	 * Convert from the internal Hungarian notation to camelCase for external
	 * interaction
	 *  @param {object} obj Object to convert
	 *  @returns {object} Inverted object
	 *  @memberof DataTable#oApi
	 */
	function _fnSearchToCamel ( obj )
	{
		return {
			search:          obj.sSearch,
			smart:           obj.bSmart,
			regex:           obj.bRegex,
			caseInsensitive: obj.bCaseInsensitive
		};
	}
	
	
	
	/**
	 * Convert from camelCase notation to the internal Hungarian. We could use the
	 * Hungarian convert function here, but this is cleaner
	 *  @param {object} obj Object to convert
	 *  @returns {object} Inverted object
	 *  @memberof DataTable#oApi
	 */
	function _fnSearchToHung ( obj )
	{
		return {
			sSearch:          obj.search,
			bSmart:           obj.smart,
			bRegex:           obj.regex,
			bCaseInsensitive: obj.caseInsensitive
		};
	}
	
	/**
	 * Generate the node required for the info display
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {node} Information element
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlInfo ( settings )
	{
		var
			tid = settings.sTableId,
			nodes = settings.aanFeatures.i,
			n = $('<div/>', {
				'class': settings.oClasses.sInfo,
				'id': ! nodes ? tid+'_info' : null
			} );
	
		if ( ! nodes ) {
			// Update display on each draw
			settings.aoDrawCallback.push( {
				"fn": _fnUpdateInfo,
				"sName": "information"
			} );
	
			n
				.attr( 'role', 'status' )
				.attr( 'aria-live', 'polite' );
	
			// Table is described by our info div
			$(settings.nTable).attr( 'aria-describedby', tid+'_info' );
		}
	
		return n[0];
	}
	
	
	/**
	 * Update the information elements in the display
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnUpdateInfo ( settings )
	{
		/* Show information about the table */
		var nodes = settings.aanFeatures.i;
		if ( nodes.length === 0 ) {
			return;
		}
	
		var
			lang  = settings.oLanguage,
			start = settings._iDisplayStart+1,
			end   = settings.fnDisplayEnd(),
			max   = settings.fnRecordsTotal(),
			total = settings.fnRecordsDisplay(),
			out   = total ?
				lang.sInfo :
				lang.sInfoEmpty;
	
		if ( total !== max ) {
			/* Record set after filtering */
			out += ' ' + lang.sInfoFiltered;
		}
	
		// Convert the macros
		out += lang.sInfoPostFix;
		out = _fnInfoMacros( settings, out );
	
		var callback = lang.fnInfoCallback;
		if ( callback !== null ) {
			out = callback.call( settings.oInstance,
				settings, start, end, max, total, out
			);
		}
	
		$(nodes).html( out );
	}
	
	
	function _fnInfoMacros ( settings, str )
	{
		// When infinite scrolling, we are always starting at 1. _iDisplayStart is used only
		// internally
		var
			formatter  = settings.fnFormatNumber,
			start      = settings._iDisplayStart+1,
			len        = settings._iDisplayLength,
			vis        = settings.fnRecordsDisplay(),
			all        = len === -1;
	
		return str.
			replace(/_START_/g, formatter.call( settings, start ) ).
			replace(/_END_/g,   formatter.call( settings, settings.fnDisplayEnd() ) ).
			replace(/_MAX_/g,   formatter.call( settings, settings.fnRecordsTotal() ) ).
			replace(/_TOTAL_/g, formatter.call( settings, vis ) ).
			replace(/_PAGE_/g,  formatter.call( settings, all ? 1 : Math.ceil( start / len ) ) ).
			replace(/_PAGES_/g, formatter.call( settings, all ? 1 : Math.ceil( vis / len ) ) );
	}
	
	
	
	/**
	 * Draw the table for the first time, adding all required features
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnInitialise ( settings )
	{
		var i, iLen, iAjaxStart=settings.iInitDisplayStart;
		var columns = settings.aoColumns, column;
		var features = settings.oFeatures;
		var deferLoading = settings.bDeferLoading; // value modified by the draw
	
		/* Ensure that the table data is fully initialised */
		if ( ! settings.bInitialised ) {
			setTimeout( function(){ _fnInitialise( settings ); }, 200 );
			return;
		}
	
		/* Show the display HTML options */
		_fnAddOptionsHtml( settings );
	
		/* Build and draw the header / footer for the table */
		_fnBuildHead( settings );
		_fnDrawHead( settings, settings.aoHeader );
		_fnDrawHead( settings, settings.aoFooter );
	
		/* Okay to show that something is going on now */
		_fnProcessingDisplay( settings, true );
	
		/* Calculate sizes for columns */
		if ( features.bAutoWidth ) {
			_fnCalculateColumnWidths( settings );
		}
	
		for ( i=0, iLen=columns.length ; i<iLen ; i++ ) {
			column = columns[i];
	
			if ( column.sWidth ) {
				column.nTh.style.width = _fnStringToCss( column.sWidth );
			}
		}
	
		_fnCallbackFire( settings, null, 'preInit', [settings] );
	
		// If there is default sorting required - let's do it. The sort function
		// will do the drawing for us. Otherwise we draw the table regardless of the
		// Ajax source - this allows the table to look initialised for Ajax sourcing
		// data (show 'loading' message possibly)
		_fnReDraw( settings );
	
		// Server-side processing init complete is done by _fnAjaxUpdateDraw
		var dataSrc = _fnDataSource( settings );
		if ( dataSrc != 'ssp' || deferLoading ) {
			// if there is an ajax source load the data
			if ( dataSrc == 'ajax' ) {
				_fnBuildAjax( settings, [], function(json) {
					var aData = _fnAjaxDataSrc( settings, json );
	
					// Got the data - add it to the table
					for ( i=0 ; i<aData.length ; i++ ) {
						_fnAddData( settings, aData[i] );
					}
	
					// Reset the init display for cookie saving. We've already done
					// a filter, and therefore cleared it before. So we need to make
					// it appear 'fresh'
					settings.iInitDisplayStart = iAjaxStart;
	
					_fnReDraw( settings );
	
					_fnProcessingDisplay( settings, false );
					_fnInitComplete( settings, json );
				}, settings );
			}
			else {
				_fnProcessingDisplay( settings, false );
				_fnInitComplete( settings );
			}
		}
	}
	
	
	/**
	 * Draw the table for the first time, adding all required features
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} [json] JSON from the server that completed the table, if using Ajax source
	 *    with client-side processing (optional)
	 *  @memberof DataTable#oApi
	 */
	function _fnInitComplete ( settings, json )
	{
		settings._bInitComplete = true;
	
		// When data was added after the initialisation (data or Ajax) we need to
		// calculate the column sizing
		if ( json || settings.oInit.aaData ) {
			_fnAdjustColumnSizing( settings );
		}
	
		_fnCallbackFire( settings, null, 'plugin-init', [settings, json] );
		_fnCallbackFire( settings, 'aoInitComplete', 'init', [settings, json] );
	}
	
	
	function _fnLengthChange ( settings, val )
	{
		var len = parseInt( val, 10 );
		settings._iDisplayLength = len;
	
		_fnLengthOverflow( settings );
	
		// Fire length change event
		_fnCallbackFire( settings, null, 'length', [settings, len] );
	}
	
	
	/**
	 * Generate the node required for user display length changing
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Display length feature node
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlLength ( settings )
	{
		var
			classes  = settings.oClasses,
			tableId  = settings.sTableId,
			menu     = settings.aLengthMenu,
			d2       = $.isArray( menu[0] ),
			lengths  = d2 ? menu[0] : menu,
			language = d2 ? menu[1] : menu;
	
		var select = $('<select/>', {
			'name':          tableId+'_length',
			'aria-controls': tableId,
			'class':         classes.sLengthSelect
		} );
	
		for ( var i=0, ien=lengths.length ; i<ien ; i++ ) {
			select[0][ i ] = new Option(
				typeof language[i] === 'number' ?
					settings.fnFormatNumber( language[i] ) :
					language[i],
				lengths[i]
			);
		}
	
		var div = $('<div><label/></div>').addClass( classes.sLength );
		if ( ! settings.aanFeatures.l ) {
			div[0].id = tableId+'_length';
		}
	
		div.children().append(
			settings.oLanguage.sLengthMenu.replace( '_MENU_', select[0].outerHTML )
		);
	
		// Can't use `select` variable as user might provide their own and the
		// reference is broken by the use of outerHTML
		$('select', div)
			.val( settings._iDisplayLength )
			.on( 'change.DT', function(e) {
				_fnLengthChange( settings, $(this).val() );
				_fnDraw( settings );
			} );
	
		// Update node value whenever anything changes the table's length
		$(settings.nTable).on( 'length.dt.DT', function (e, s, len) {
			if ( settings === s ) {
				$('select', div).val( len );
			}
		} );
	
		return div[0];
	}
	
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Note that most of the paging logic is done in
	 * DataTable.ext.pager
	 */
	
	/**
	 * Generate the node required for default pagination
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {node} Pagination feature node
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlPaginate ( settings )
	{
		var
			type   = settings.sPaginationType,
			plugin = DataTable.ext.pager[ type ],
			modern = typeof plugin === 'function',
			redraw = function( settings ) {
				_fnDraw( settings );
			},
			node = $('<div/>').addClass( settings.oClasses.sPaging + type )[0],
			features = settings.aanFeatures;
	
		if ( ! modern ) {
			plugin.fnInit( settings, node, redraw );
		}
	
		/* Add a draw callback for the pagination on first instance, to update the paging display */
		if ( ! features.p )
		{
			node.id = settings.sTableId+'_paginate';
	
			settings.aoDrawCallback.push( {
				"fn": function( settings ) {
					if ( modern ) {
						var
							start      = settings._iDisplayStart,
							len        = settings._iDisplayLength,
							visRecords = settings.fnRecordsDisplay(),
							all        = len === -1,
							page = all ? 0 : Math.ceil( start / len ),
							pages = all ? 1 : Math.ceil( visRecords / len ),
							buttons = plugin(page, pages),
							i, ien;
	
						for ( i=0, ien=features.p.length ; i<ien ; i++ ) {
							_fnRenderer( settings, 'pageButton' )(
								settings, features.p[i], i, buttons, page, pages
							);
						}
					}
					else {
						plugin.fnUpdate( settings, redraw );
					}
				},
				"sName": "pagination"
			} );
		}
	
		return node;
	}
	
	
	/**
	 * Alter the display settings to change the page
	 *  @param {object} settings DataTables settings object
	 *  @param {string|int} action Paging action to take: "first", "previous",
	 *    "next" or "last" or page number to jump to (integer)
	 *  @param [bool] redraw Automatically draw the update or not
	 *  @returns {bool} true page has changed, false - no change
	 *  @memberof DataTable#oApi
	 */
	function _fnPageChange ( settings, action, redraw )
	{
		var
			start     = settings._iDisplayStart,
			len       = settings._iDisplayLength,
			records   = settings.fnRecordsDisplay();
	
		if ( records === 0 || len === -1 )
		{
			start = 0;
		}
		else if ( typeof action === "number" )
		{
			start = action * len;
	
			if ( start > records )
			{
				start = 0;
			}
		}
		else if ( action == "first" )
		{
			start = 0;
		}
		else if ( action == "previous" )
		{
			start = len >= 0 ?
				start - len :
				0;
	
			if ( start < 0 )
			{
			  start = 0;
			}
		}
		else if ( action == "next" )
		{
			if ( start + len < records )
			{
				start += len;
			}
		}
		else if ( action == "last" )
		{
			start = Math.floor( (records-1) / len) * len;
		}
		else
		{
			_fnLog( settings, 0, "Unknown paging action: "+action, 5 );
		}
	
		var changed = settings._iDisplayStart !== start;
		settings._iDisplayStart = start;
	
		if ( changed ) {
			_fnCallbackFire( settings, null, 'page', [settings] );
	
			if ( redraw ) {
				_fnDraw( settings );
			}
		}
	
		return changed;
	}
	
	
	
	/**
	 * Generate the node required for the processing node
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Processing element
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlProcessing ( settings )
	{
		return $('<div/>', {
				'id': ! settings.aanFeatures.r ? settings.sTableId+'_processing' : null,
				'class': settings.oClasses.sProcessing
			} )
			.html( settings.oLanguage.sProcessing )
			.insertBefore( settings.nTable )[0];
	}
	
	
	/**
	 * Display or hide the processing indicator
	 *  @param {object} settings dataTables settings object
	 *  @param {bool} show Show the processing indicator (true) or not (false)
	 *  @memberof DataTable#oApi
	 */
	function _fnProcessingDisplay ( settings, show )
	{
		if ( settings.oFeatures.bProcessing ) {
			$(settings.aanFeatures.r).css( 'display', show ? 'block' : 'none' );
		}
	
		_fnCallbackFire( settings, null, 'processing', [settings, show] );
	}
	
	/**
	 * Add any control elements for the table - specifically scrolling
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Node to add to the DOM
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlTable ( settings )
	{
		var table = $(settings.nTable);
	
		// Add the ARIA grid role to the table
		table.attr( 'role', 'grid' );
	
		// Scrolling from here on in
		var scroll = settings.oScroll;
	
		if ( scroll.sX === '' && scroll.sY === '' ) {
			return settings.nTable;
		}
	
		var scrollX = scroll.sX;
		var scrollY = scroll.sY;
		var classes = settings.oClasses;
		var caption = table.children('caption');
		var captionSide = caption.length ? caption[0]._captionSide : null;
		var headerClone = $( table[0].cloneNode(false) );
		var footerClone = $( table[0].cloneNode(false) );
		var footer = table.children('tfoot');
		var _div = '<div/>';
		var size = function ( s ) {
			return !s ? null : _fnStringToCss( s );
		};
	
		if ( ! footer.length ) {
			footer = null;
		}
	
		/*
		 * The HTML structure that we want to generate in this function is:
		 *  div - scroller
		 *    div - scroll head
		 *      div - scroll head inner
		 *        table - scroll head table
		 *          thead - thead
		 *    div - scroll body
		 *      table - table (master table)
		 *        thead - thead clone for sizing
		 *        tbody - tbody
		 *    div - scroll foot
		 *      div - scroll foot inner
		 *        table - scroll foot table
		 *          tfoot - tfoot
		 */
		var scroller = $( _div, { 'class': classes.sScrollWrapper } )
			.append(
				$(_div, { 'class': classes.sScrollHead } )
					.css( {
						overflow: 'hidden',
						position: 'relative',
						border: 0,
						width: scrollX ? size(scrollX) : '100%'
					} )
					.append(
						$(_div, { 'class': classes.sScrollHeadInner } )
							.css( {
								'box-sizing': 'content-box',
								width: scroll.sXInner || '100%'
							} )
							.append(
								headerClone
									.removeAttr('id')
									.css( 'margin-left', 0 )
									.append( captionSide === 'top' ? caption : null )
									.append(
										table.children('thead')
									)
							)
					)
			)
			.append(
				$(_div, { 'class': classes.sScrollBody } )
					.css( {
						position: 'relative',
						overflow: 'auto',
						width: size( scrollX )
					} )
					.append( table )
			);
	
		if ( footer ) {
			scroller.append(
				$(_div, { 'class': classes.sScrollFoot } )
					.css( {
						overflow: 'hidden',
						border: 0,
						width: scrollX ? size(scrollX) : '100%'
					} )
					.append(
						$(_div, { 'class': classes.sScrollFootInner } )
							.append(
								footerClone
									.removeAttr('id')
									.css( 'margin-left', 0 )
									.append( captionSide === 'bottom' ? caption : null )
									.append(
										table.children('tfoot')
									)
							)
					)
			);
		}
	
		var children = scroller.children();
		var scrollHead = children[0];
		var scrollBody = children[1];
		var scrollFoot = footer ? children[2] : null;
	
		// When the body is scrolled, then we also want to scroll the headers
		if ( scrollX ) {
			$(scrollBody).on( 'scroll.DT', function (e) {
				var scrollLeft = this.scrollLeft;
	
				scrollHead.scrollLeft = scrollLeft;
	
				if ( footer ) {
					scrollFoot.scrollLeft = scrollLeft;
				}
			} );
		}
	
		$(scrollBody).css(
			scrollY && scroll.bCollapse ? 'max-height' : 'height', 
			scrollY
		);
	
		settings.nScrollHead = scrollHead;
		settings.nScrollBody = scrollBody;
		settings.nScrollFoot = scrollFoot;
	
		// On redraw - align columns
		settings.aoDrawCallback.push( {
			"fn": _fnScrollDraw,
			"sName": "scrolling"
		} );
	
		return scroller[0];
	}
	
	
	
	/**
	 * Update the header, footer and body tables for resizing - i.e. column
	 * alignment.
	 *
	 * Welcome to the most horrible function DataTables. The process that this
	 * function follows is basically:
	 *   1. Re-create the table inside the scrolling div
	 *   2. Take live measurements from the DOM
	 *   3. Apply the measurements to align the columns
	 *   4. Clean up
	 *
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnScrollDraw ( settings )
	{
		// Given that this is such a monster function, a lot of variables are use
		// to try and keep the minimised size as small as possible
		var
			scroll         = settings.oScroll,
			scrollX        = scroll.sX,
			scrollXInner   = scroll.sXInner,
			scrollY        = scroll.sY,
			barWidth       = scroll.iBarWidth,
			divHeader      = $(settings.nScrollHead),
			divHeaderStyle = divHeader[0].style,
			divHeaderInner = divHeader.children('div'),
			divHeaderInnerStyle = divHeaderInner[0].style,
			divHeaderTable = divHeaderInner.children('table'),
			divBodyEl      = settings.nScrollBody,
			divBody        = $(divBodyEl),
			divBodyStyle   = divBodyEl.style,
			divFooter      = $(settings.nScrollFoot),
			divFooterInner = divFooter.children('div'),
			divFooterTable = divFooterInner.children('table'),
			header         = $(settings.nTHead),
			table          = $(settings.nTable),
			tableEl        = table[0],
			tableStyle     = tableEl.style,
			footer         = settings.nTFoot ? $(settings.nTFoot) : null,
			browser        = settings.oBrowser,
			ie67           = browser.bScrollOversize,
			dtHeaderCells  = _pluck( settings.aoColumns, 'nTh' ),
			headerTrgEls, footerTrgEls,
			headerSrcEls, footerSrcEls,
			headerCopy, footerCopy,
			headerWidths=[], footerWidths=[],
			headerContent=[], footerContent=[],
			idx, correction, sanityWidth,
			zeroOut = function(nSizer) {
				var style = nSizer.style;
				style.paddingTop = "0";
				style.paddingBottom = "0";
				style.borderTopWidth = "0";
				style.borderBottomWidth = "0";
				style.height = 0;
			};
	
		// If the scrollbar visibility has changed from the last draw, we need to
		// adjust the column sizes as the table width will have changed to account
		// for the scrollbar
		var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
		
		if ( settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined ) {
			settings.scrollBarVis = scrollBarVis;
			_fnAdjustColumnSizing( settings );
			return; // adjust column sizing will call this function again
		}
		else {
			settings.scrollBarVis = scrollBarVis;
		}
	
		/*
		 * 1. Re-create the table inside the scrolling div
		 */
	
		// Remove the old minimised thead and tfoot elements in the inner table
		table.children('thead, tfoot').remove();
	
		if ( footer ) {
			footerCopy = footer.clone().prependTo( table );
			footerTrgEls = footer.find('tr'); // the original tfoot is in its own table and must be sized
			footerSrcEls = footerCopy.find('tr');
		}
	
		// Clone the current header and footer elements and then place it into the inner table
		headerCopy = header.clone().prependTo( table );
		headerTrgEls = header.find('tr'); // original header is in its own table
		headerSrcEls = headerCopy.find('tr');
		headerCopy.find('th, td').removeAttr('tabindex');
	
	
		/*
		 * 2. Take live measurements from the DOM - do not alter the DOM itself!
		 */
	
		// Remove old sizing and apply the calculated column widths
		// Get the unique column headers in the newly created (cloned) header. We want to apply the
		// calculated sizes to this header
		if ( ! scrollX )
		{
			divBodyStyle.width = '100%';
			divHeader[0].style.width = '100%';
		}
	
		$.each( _fnGetUniqueThs( settings, headerCopy ), function ( i, el ) {
			idx = _fnVisibleToColumnIndex( settings, i );
			el.style.width = settings.aoColumns[idx].sWidth;
		} );
	
		if ( footer ) {
			_fnApplyToChildren( function(n) {
				n.style.width = "";
			}, footerSrcEls );
		}
	
		// Size the table as a whole
		sanityWidth = table.outerWidth();
		if ( scrollX === "" ) {
			// No x scrolling
			tableStyle.width = "100%";
	
			// IE7 will make the width of the table when 100% include the scrollbar
			// - which is shouldn't. When there is a scrollbar we need to take this
			// into account.
			if ( ie67 && (table.find('tbody').height() > divBodyEl.offsetHeight ||
				divBody.css('overflow-y') == "scroll")
			) {
				tableStyle.width = _fnStringToCss( table.outerWidth() - barWidth);
			}
	
			// Recalculate the sanity width
			sanityWidth = table.outerWidth();
		}
		else if ( scrollXInner !== "" ) {
			// legacy x scroll inner has been given - use it
			tableStyle.width = _fnStringToCss(scrollXInner);
	
			// Recalculate the sanity width
			sanityWidth = table.outerWidth();
		}
	
		// Hidden header should have zero height, so remove padding and borders. Then
		// set the width based on the real headers
	
		// Apply all styles in one pass
		_fnApplyToChildren( zeroOut, headerSrcEls );
	
		// Read all widths in next pass
		_fnApplyToChildren( function(nSizer) {
			headerContent.push( nSizer.innerHTML );
			headerWidths.push( _fnStringToCss( $(nSizer).css('width') ) );
		}, headerSrcEls );
	
		// Apply all widths in final pass
		_fnApplyToChildren( function(nToSize, i) {
			// Only apply widths to the DataTables detected header cells - this
			// prevents complex headers from having contradictory sizes applied
			if ( $.inArray( nToSize, dtHeaderCells ) !== -1 ) {
				nToSize.style.width = headerWidths[i];
			}
		}, headerTrgEls );
	
		$(headerSrcEls).height(0);
	
		/* Same again with the footer if we have one */
		if ( footer )
		{
			_fnApplyToChildren( zeroOut, footerSrcEls );
	
			_fnApplyToChildren( function(nSizer) {
				footerContent.push( nSizer.innerHTML );
				footerWidths.push( _fnStringToCss( $(nSizer).css('width') ) );
			}, footerSrcEls );
	
			_fnApplyToChildren( function(nToSize, i) {
				nToSize.style.width = footerWidths[i];
			}, footerTrgEls );
	
			$(footerSrcEls).height(0);
		}
	
	
		/*
		 * 3. Apply the measurements
		 */
	
		// "Hide" the header and footer that we used for the sizing. We need to keep
		// the content of the cell so that the width applied to the header and body
		// both match, but we want to hide it completely. We want to also fix their
		// width to what they currently are
		_fnApplyToChildren( function(nSizer, i) {
			nSizer.innerHTML = '<div class="dataTables_sizing">'+headerContent[i]+'</div>';
			nSizer.childNodes[0].style.height = "0";
			nSizer.childNodes[0].style.overflow = "hidden";
			nSizer.style.width = headerWidths[i];
		}, headerSrcEls );
	
		if ( footer )
		{
			_fnApplyToChildren( function(nSizer, i) {
				nSizer.innerHTML = '<div class="dataTables_sizing">'+footerContent[i]+'</div>';
				nSizer.childNodes[0].style.height = "0";
				nSizer.childNodes[0].style.overflow = "hidden";
				nSizer.style.width = footerWidths[i];
			}, footerSrcEls );
		}
	
		// Sanity check that the table is of a sensible width. If not then we are going to get
		// misalignment - try to prevent this by not allowing the table to shrink below its min width
		if ( table.outerWidth() < sanityWidth )
		{
			// The min width depends upon if we have a vertical scrollbar visible or not */
			correction = ((divBodyEl.scrollHeight > divBodyEl.offsetHeight ||
				divBody.css('overflow-y') == "scroll")) ?
					sanityWidth+barWidth :
					sanityWidth;
	
			// IE6/7 are a law unto themselves...
			if ( ie67 && (divBodyEl.scrollHeight >
				divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll")
			) {
				tableStyle.width = _fnStringToCss( correction-barWidth );
			}
	
			// And give the user a warning that we've stopped the table getting too small
			if ( scrollX === "" || scrollXInner !== "" ) {
				_fnLog( settings, 1, 'Possible column misalignment', 6 );
			}
		}
		else
		{
			correction = '100%';
		}
	
		// Apply to the container elements
		divBodyStyle.width = _fnStringToCss( correction );
		divHeaderStyle.width = _fnStringToCss( correction );
	
		if ( footer ) {
			settings.nScrollFoot.style.width = _fnStringToCss( correction );
		}
	
	
		/*
		 * 4. Clean up
		 */
		if ( ! scrollY ) {
			/* IE7< puts a vertical scrollbar in place (when it shouldn't be) due to subtracting
			 * the scrollbar height from the visible display, rather than adding it on. We need to
			 * set the height in order to sort this. Don't want to do it in any other browsers.
			 */
			if ( ie67 ) {
				divBodyStyle.height = _fnStringToCss( tableEl.offsetHeight+barWidth );
			}
		}
	
		/* Finally set the width's of the header and footer tables */
		var iOuterWidth = table.outerWidth();
		divHeaderTable[0].style.width = _fnStringToCss( iOuterWidth );
		divHeaderInnerStyle.width = _fnStringToCss( iOuterWidth );
	
		// Figure out if there are scrollbar present - if so then we need a the header and footer to
		// provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
		var bScrolling = table.height() > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
		var padding = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right' );
		divHeaderInnerStyle[ padding ] = bScrolling ? barWidth+"px" : "0px";
	
		if ( footer ) {
			divFooterTable[0].style.width = _fnStringToCss( iOuterWidth );
			divFooterInner[0].style.width = _fnStringToCss( iOuterWidth );
			divFooterInner[0].style[padding] = bScrolling ? barWidth+"px" : "0px";
		}
	
		// Correct DOM ordering for colgroup - comes before the thead
		table.children('colgroup').insertBefore( table.children('thead') );
	
		/* Adjust the position of the header in case we loose the y-scrollbar */
		divBody.scroll();
	
		// If sorting or filtering has occurred, jump the scrolling back to the top
		// only if we aren't holding the position
		if ( (settings.bSorted || settings.bFiltered) && ! settings._drawHold ) {
			divBodyEl.scrollTop = 0;
		}
	}
	
	
	
	/**
	 * Apply a given function to the display child nodes of an element array (typically
	 * TD children of TR rows
	 *  @param {function} fn Method to apply to the objects
	 *  @param array {nodes} an1 List of elements to look through for display children
	 *  @param array {nodes} an2 Another list (identical structure to the first) - optional
	 *  @memberof DataTable#oApi
	 */
	function _fnApplyToChildren( fn, an1, an2 )
	{
		var index=0, i=0, iLen=an1.length;
		var nNode1, nNode2;
	
		while ( i < iLen ) {
			nNode1 = an1[i].firstChild;
			nNode2 = an2 ? an2[i].firstChild : null;
	
			while ( nNode1 ) {
				if ( nNode1.nodeType === 1 ) {
					if ( an2 ) {
						fn( nNode1, nNode2, index );
					}
					else {
						fn( nNode1, index );
					}
	
					index++;
				}
	
				nNode1 = nNode1.nextSibling;
				nNode2 = an2 ? nNode2.nextSibling : null;
			}
	
			i++;
		}
	}
	
	
	
	var __re_html_remove = /<.*?>/g;
	
	
	/**
	 * Calculate the width of columns for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnCalculateColumnWidths ( oSettings )
	{
		var
			table = oSettings.nTable,
			columns = oSettings.aoColumns,
			scroll = oSettings.oScroll,
			scrollY = scroll.sY,
			scrollX = scroll.sX,
			scrollXInner = scroll.sXInner,
			columnCount = columns.length,
			visibleColumns = _fnGetColumns( oSettings, 'bVisible' ),
			headerCells = $('th', oSettings.nTHead),
			tableWidthAttr = table.getAttribute('width'), // from DOM element
			tableContainer = table.parentNode,
			userInputs = false,
			i, column, columnIdx, width, outerWidth,
			browser = oSettings.oBrowser,
			ie67 = browser.bScrollOversize;
	
		var styleWidth = table.style.width;
		if ( styleWidth && styleWidth.indexOf('%') !== -1 ) {
			tableWidthAttr = styleWidth;
		}
	
		/* Convert any user input sizes into pixel sizes */
		for ( i=0 ; i<visibleColumns.length ; i++ ) {
			column = columns[ visibleColumns[i] ];
	
			if ( column.sWidth !== null ) {
				column.sWidth = _fnConvertToWidth( column.sWidthOrig, tableContainer );
	
				userInputs = true;
			}
		}
	
		/* If the number of columns in the DOM equals the number that we have to
		 * process in DataTables, then we can use the offsets that are created by
		 * the web- browser. No custom sizes can be set in order for this to happen,
		 * nor scrolling used
		 */
		if ( ie67 || ! userInputs && ! scrollX && ! scrollY &&
		     columnCount == _fnVisbleColumns( oSettings ) &&
		     columnCount == headerCells.length
		) {
			for ( i=0 ; i<columnCount ; i++ ) {
				var colIdx = _fnVisibleToColumnIndex( oSettings, i );
	
				if ( colIdx !== null ) {
					columns[ colIdx ].sWidth = _fnStringToCss( headerCells.eq(i).width() );
				}
			}
		}
		else
		{
			// Otherwise construct a single row, worst case, table with the widest
			// node in the data, assign any user defined widths, then insert it into
			// the DOM and allow the browser to do all the hard work of calculating
			// table widths
			var tmpTable = $(table).clone() // don't use cloneNode - IE8 will remove events on the main table
				.css( 'visibility', 'hidden' )
				.removeAttr( 'id' );
	
			// Clean up the table body
			tmpTable.find('tbody tr').remove();
			var tr = $('<tr/>').appendTo( tmpTable.find('tbody') );
	
			// Clone the table header and footer - we can't use the header / footer
			// from the cloned table, since if scrolling is active, the table's
			// real header and footer are contained in different table tags
			tmpTable.find('thead, tfoot').remove();
			tmpTable
				.append( $(oSettings.nTHead).clone() )
				.append( $(oSettings.nTFoot).clone() );
	
			// Remove any assigned widths from the footer (from scrolling)
			tmpTable.find('tfoot th, tfoot td').css('width', '');
	
			// Apply custom sizing to the cloned header
			headerCells = _fnGetUniqueThs( oSettings, tmpTable.find('thead')[0] );
	
			for ( i=0 ; i<visibleColumns.length ; i++ ) {
				column = columns[ visibleColumns[i] ];
	
				headerCells[i].style.width = column.sWidthOrig !== null && column.sWidthOrig !== '' ?
					_fnStringToCss( column.sWidthOrig ) :
					'';
	
				// For scrollX we need to force the column width otherwise the
				// browser will collapse it. If this width is smaller than the
				// width the column requires, then it will have no effect
				if ( column.sWidthOrig && scrollX ) {
					$( headerCells[i] ).append( $('<div/>').css( {
						width: column.sWidthOrig,
						margin: 0,
						padding: 0,
						border: 0,
						height: 1
					} ) );
				}
			}
	
			// Find the widest cell for each column and put it into the table
			if ( oSettings.aoData.length ) {
				for ( i=0 ; i<visibleColumns.length ; i++ ) {
					columnIdx = visibleColumns[i];
					column = columns[ columnIdx ];
	
					$( _fnGetWidestNode( oSettings, columnIdx ) )
						.clone( false )
						.append( column.sContentPadding )
						.appendTo( tr );
				}
			}
	
			// Tidy the temporary table - remove name attributes so there aren't
			// duplicated in the dom (radio elements for example)
			$('[name]', tmpTable).removeAttr('name');
	
			// Table has been built, attach to the document so we can work with it.
			// A holding element is used, positioned at the top of the container
			// with minimal height, so it has no effect on if the container scrolls
			// or not. Otherwise it might trigger scrolling when it actually isn't
			// needed
			var holder = $('<div/>').css( scrollX || scrollY ?
					{
						position: 'absolute',
						top: 0,
						left: 0,
						height: 1,
						right: 0,
						overflow: 'hidden'
					} :
					{}
				)
				.append( tmpTable )
				.appendTo( tableContainer );
	
			// When scrolling (X or Y) we want to set the width of the table as 
			// appropriate. However, when not scrolling leave the table width as it
			// is. This results in slightly different, but I think correct behaviour
			if ( scrollX && scrollXInner ) {
				tmpTable.width( scrollXInner );
			}
			else if ( scrollX ) {
				tmpTable.css( 'width', 'auto' );
				tmpTable.removeAttr('width');
	
				// If there is no width attribute or style, then allow the table to
				// collapse
				if ( tmpTable.width() < tableContainer.clientWidth && tableWidthAttr ) {
					tmpTable.width( tableContainer.clientWidth );
				}
			}
			else if ( scrollY ) {
				tmpTable.width( tableContainer.clientWidth );
			}
			else if ( tableWidthAttr ) {
				tmpTable.width( tableWidthAttr );
			}
	
			// Get the width of each column in the constructed table - we need to
			// know the inner width (so it can be assigned to the other table's
			// cells) and the outer width so we can calculate the full width of the
			// table. This is safe since DataTables requires a unique cell for each
			// column, but if ever a header can span multiple columns, this will
			// need to be modified.
			var total = 0;
			for ( i=0 ; i<visibleColumns.length ; i++ ) {
				var cell = $(headerCells[i]);
				var border = cell.outerWidth() - cell.width();
	
				// Use getBounding... where possible (not IE8-) because it can give
				// sub-pixel accuracy, which we then want to round up!
				var bounding = browser.bBounding ?
					Math.ceil( headerCells[i].getBoundingClientRect().width ) :
					cell.outerWidth();
	
				// Total is tracked to remove any sub-pixel errors as the outerWidth
				// of the table might not equal the total given here (IE!).
				total += bounding;
	
				// Width for each column to use
				columns[ visibleColumns[i] ].sWidth = _fnStringToCss( bounding - border );
			}
	
			table.style.width = _fnStringToCss( total );
	
			// Finished with the table - ditch it
			holder.remove();
		}
	
		// If there is a width attr, we want to attach an event listener which
		// allows the table sizing to automatically adjust when the window is
		// resized. Use the width attr rather than CSS, since we can't know if the
		// CSS is a relative value or absolute - DOM read is always px.
		if ( tableWidthAttr ) {
			table.style.width = _fnStringToCss( tableWidthAttr );
		}
	
		if ( (tableWidthAttr || scrollX) && ! oSettings._reszEvt ) {
			var bindResize = function () {
				$(window).on('resize.DT-'+oSettings.sInstance, _fnThrottle( function () {
					_fnAdjustColumnSizing( oSettings );
				} ) );
			};
	
			// IE6/7 will crash if we bind a resize event handler on page load.
			// To be removed in 1.11 which drops IE6/7 support
			if ( ie67 ) {
				setTimeout( bindResize, 1000 );
			}
			else {
				bindResize();
			}
	
			oSettings._reszEvt = true;
		}
	}
	
	
	/**
	 * Throttle the calls to a function. Arguments and context are maintained for
	 * the throttled function
	 *  @param {function} fn Function to be called
	 *  @param {int} [freq=200] call frequency in mS
	 *  @returns {function} wrapped function
	 *  @memberof DataTable#oApi
	 */
	var _fnThrottle = DataTable.util.throttle;
	
	
	/**
	 * Convert a CSS unit width to pixels (e.g. 2em)
	 *  @param {string} width width to be converted
	 *  @param {node} parent parent to get the with for (required for relative widths) - optional
	 *  @returns {int} width in pixels
	 *  @memberof DataTable#oApi
	 */
	function _fnConvertToWidth ( width, parent )
	{
		if ( ! width ) {
			return 0;
		}
	
		var n = $('<div/>')
			.css( 'width', _fnStringToCss( width ) )
			.appendTo( parent || document.body );
	
		var val = n[0].offsetWidth;
		n.remove();
	
		return val;
	}
	
	
	/**
	 * Get the widest node
	 *  @param {object} settings dataTables settings object
	 *  @param {int} colIdx column of interest
	 *  @returns {node} widest table node
	 *  @memberof DataTable#oApi
	 */
	function _fnGetWidestNode( settings, colIdx )
	{
		var idx = _fnGetMaxLenString( settings, colIdx );
		if ( idx < 0 ) {
			return null;
		}
	
		var data = settings.aoData[ idx ];
		return ! data.nTr ? // Might not have been created when deferred rendering
			$('<td/>').html( _fnGetCellData( settings, idx, colIdx, 'display' ) )[0] :
			data.anCells[ colIdx ];
	}
	
	
	/**
	 * Get the maximum strlen for each data column
	 *  @param {object} settings dataTables settings object
	 *  @param {int} colIdx column of interest
	 *  @returns {string} max string length for each column
	 *  @memberof DataTable#oApi
	 */
	function _fnGetMaxLenString( settings, colIdx )
	{
		var s, max=-1, maxIdx = -1;
	
		for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			s = _fnGetCellData( settings, i, colIdx, 'display' )+'';
			s = s.replace( __re_html_remove, '' );
			s = s.replace( /&nbsp;/g, ' ' );
	
			if ( s.length > max ) {
				max = s.length;
				maxIdx = i;
			}
		}
	
		return maxIdx;
	}
	
	
	/**
	 * Append a CSS unit (only if required) to a string
	 *  @param {string} value to css-ify
	 *  @returns {string} value with css unit
	 *  @memberof DataTable#oApi
	 */
	function _fnStringToCss( s )
	{
		if ( s === null ) {
			return '0px';
		}
	
		if ( typeof s == 'number' ) {
			return s < 0 ?
				'0px' :
				s+'px';
		}
	
		// Check it has a unit character already
		return s.match(/\d$/) ?
			s+'px' :
			s;
	}
	
	
	
	function _fnSortFlatten ( settings )
	{
		var
			i, iLen, k, kLen,
			aSort = [],
			aiOrig = [],
			aoColumns = settings.aoColumns,
			aDataSort, iCol, sType, srcCol,
			fixed = settings.aaSortingFixed,
			fixedObj = $.isPlainObject( fixed ),
			nestedSort = [],
			add = function ( a ) {
				if ( a.length && ! $.isArray( a[0] ) ) {
					// 1D array
					nestedSort.push( a );
				}
				else {
					// 2D array
					$.merge( nestedSort, a );
				}
			};
	
		// Build the sort array, with pre-fix and post-fix options if they have been
		// specified
		if ( $.isArray( fixed ) ) {
			add( fixed );
		}
	
		if ( fixedObj && fixed.pre ) {
			add( fixed.pre );
		}
	
		add( settings.aaSorting );
	
		if (fixedObj && fixed.post ) {
			add( fixed.post );
		}
	
		for ( i=0 ; i<nestedSort.length ; i++ )
		{
			srcCol = nestedSort[i][0];
			aDataSort = aoColumns[ srcCol ].aDataSort;
	
			for ( k=0, kLen=aDataSort.length ; k<kLen ; k++ )
			{
				iCol = aDataSort[k];
				sType = aoColumns[ iCol ].sType || 'string';
	
				if ( nestedSort[i]._idx === undefined ) {
					nestedSort[i]._idx = $.inArray( nestedSort[i][1], aoColumns[iCol].asSorting );
				}
	
				aSort.push( {
					src:       srcCol,
					col:       iCol,
					dir:       nestedSort[i][1],
					index:     nestedSort[i]._idx,
					type:      sType,
					formatter: DataTable.ext.type.order[ sType+"-pre" ]
				} );
			}
		}
	
		return aSort;
	}
	
	/**
	 * Change the order of the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 *  @todo This really needs split up!
	 */
	function _fnSort ( oSettings )
	{
		var
			i, ien, iLen, j, jLen, k, kLen,
			sDataType, nTh,
			aiOrig = [],
			oExtSort = DataTable.ext.type.order,
			aoData = oSettings.aoData,
			aoColumns = oSettings.aoColumns,
			aDataSort, data, iCol, sType, oSort,
			formatters = 0,
			sortCol,
			displayMaster = oSettings.aiDisplayMaster,
			aSort;
	
		// Resolve any column types that are unknown due to addition or invalidation
		// @todo Can this be moved into a 'data-ready' handler which is called when
		//   data is going to be used in the table?
		_fnColumnTypes( oSettings );
	
		aSort = _fnSortFlatten( oSettings );
	
		for ( i=0, ien=aSort.length ; i<ien ; i++ ) {
			sortCol = aSort[i];
	
			// Track if we can use the fast sort algorithm
			if ( sortCol.formatter ) {
				formatters++;
			}
	
			// Load the data needed for the sort, for each cell
			_fnSortData( oSettings, sortCol.col );
		}
	
		/* No sorting required if server-side or no sorting array */
		if ( _fnDataSource( oSettings ) != 'ssp' && aSort.length !== 0 )
		{
			// Create a value - key array of the current row positions such that we can use their
			// current position during the sort, if values match, in order to perform stable sorting
			for ( i=0, iLen=displayMaster.length ; i<iLen ; i++ ) {
				aiOrig[ displayMaster[i] ] = i;
			}
	
			/* Do the sort - here we want multi-column sorting based on a given data source (column)
			 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
			 * follow on it's own, but this is what we want (example two column sorting):
			 *  fnLocalSorting = function(a,b){
			 *    var iTest;
			 *    iTest = oSort['string-asc']('data11', 'data12');
			 *      if (iTest !== 0)
			 *        return iTest;
			 *    iTest = oSort['numeric-desc']('data21', 'data22');
			 *    if (iTest !== 0)
			 *      return iTest;
			 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
			 *  }
			 * Basically we have a test for each sorting column, if the data in that column is equal,
			 * test the next column. If all columns match, then we use a numeric sort on the row
			 * positions in the original data array to provide a stable sort.
			 *
			 * Note - I know it seems excessive to have two sorting methods, but the first is around
			 * 15% faster, so the second is only maintained for backwards compatibility with sorting
			 * methods which do not have a pre-sort formatting function.
			 */
			if ( formatters === aSort.length ) {
				// All sort types have formatting functions
				displayMaster.sort( function ( a, b ) {
					var
						x, y, k, test, sort,
						len=aSort.length,
						dataA = aoData[a]._aSortData,
						dataB = aoData[b]._aSortData;
	
					for ( k=0 ; k<len ; k++ ) {
						sort = aSort[k];
	
						x = dataA[ sort.col ];
						y = dataB[ sort.col ];
	
						test = x<y ? -1 : x>y ? 1 : 0;
						if ( test !== 0 ) {
							return sort.dir === 'asc' ? test : -test;
						}
					}
	
					x = aiOrig[a];
					y = aiOrig[b];
					return x<y ? -1 : x>y ? 1 : 0;
				} );
			}
			else {
				// Depreciated - remove in 1.11 (providing a plug-in option)
				// Not all sort types have formatting methods, so we have to call their sorting
				// methods.
				displayMaster.sort( function ( a, b ) {
					var
						x, y, k, l, test, sort, fn,
						len=aSort.length,
						dataA = aoData[a]._aSortData,
						dataB = aoData[b]._aSortData;
	
					for ( k=0 ; k<len ; k++ ) {
						sort = aSort[k];
	
						x = dataA[ sort.col ];
						y = dataB[ sort.col ];
	
						fn = oExtSort[ sort.type+"-"+sort.dir ] || oExtSort[ "string-"+sort.dir ];
						test = fn( x, y );
						if ( test !== 0 ) {
							return test;
						}
					}
	
					x = aiOrig[a];
					y = aiOrig[b];
					return x<y ? -1 : x>y ? 1 : 0;
				} );
			}
		}
	
		/* Tell the draw function that we have sorted the data */
		oSettings.bSorted = true;
	}
	
	
	function _fnSortAria ( settings )
	{
		var label;
		var nextSort;
		var columns = settings.aoColumns;
		var aSort = _fnSortFlatten( settings );
		var oAria = settings.oLanguage.oAria;
	
		// ARIA attributes - need to loop all columns, to update all (removing old
		// attributes as needed)
		for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
		{
			var col = columns[i];
			var asSorting = col.asSorting;
			var sTitle = col.sTitle.replace( /<.*?>/g, "" );
			var th = col.nTh;
	
			// IE7 is throwing an error when setting these properties with jQuery's
			// attr() and removeAttr() methods...
			th.removeAttribute('aria-sort');
	
			/* In ARIA only the first sorting column can be marked as sorting - no multi-sort option */
			if ( col.bSortable ) {
				if ( aSort.length > 0 && aSort[0].col == i ) {
					th.setAttribute('aria-sort', aSort[0].dir=="asc" ? "ascending" : "descending" );
					nextSort = asSorting[ aSort[0].index+1 ] || asSorting[0];
				}
				else {
					nextSort = asSorting[0];
				}
	
				label = sTitle + ( nextSort === "asc" ?
					oAria.sSortAscending :
					oAria.sSortDescending
				);
			}
			else {
				label = sTitle;
			}
	
			th.setAttribute('aria-label', label);
		}
	}
	
	
	/**
	 * Function to run on user sort request
	 *  @param {object} settings dataTables settings object
	 *  @param {node} attachTo node to attach the handler to
	 *  @param {int} colIdx column sorting index
	 *  @param {boolean} [append=false] Append the requested sort to the existing
	 *    sort if true (i.e. multi-column sort)
	 *  @param {function} [callback] callback function
	 *  @memberof DataTable#oApi
	 */
	function _fnSortListener ( settings, colIdx, append, callback )
	{
		var col = settings.aoColumns[ colIdx ];
		var sorting = settings.aaSorting;
		var asSorting = col.asSorting;
		var nextSortIdx;
		var next = function ( a, overflow ) {
			var idx = a._idx;
			if ( idx === undefined ) {
				idx = $.inArray( a[1], asSorting );
			}
	
			return idx+1 < asSorting.length ?
				idx+1 :
				overflow ?
					null :
					0;
		};
	
		// Convert to 2D array if needed
		if ( typeof sorting[0] === 'number' ) {
			sorting = settings.aaSorting = [ sorting ];
		}
	
		// If appending the sort then we are multi-column sorting
		if ( append && settings.oFeatures.bSortMulti ) {
			// Are we already doing some kind of sort on this column?
			var sortIdx = $.inArray( colIdx, _pluck(sorting, '0') );
	
			if ( sortIdx !== -1 ) {
				// Yes, modify the sort
				nextSortIdx = next( sorting[sortIdx], true );
	
				if ( nextSortIdx === null && sorting.length === 1 ) {
					nextSortIdx = 0; // can't remove sorting completely
				}
	
				if ( nextSortIdx === null ) {
					sorting.splice( sortIdx, 1 );
				}
				else {
					sorting[sortIdx][1] = asSorting[ nextSortIdx ];
					sorting[sortIdx]._idx = nextSortIdx;
				}
			}
			else {
				// No sort on this column yet
				sorting.push( [ colIdx, asSorting[0], 0 ] );
				sorting[sorting.length-1]._idx = 0;
			}
		}
		else if ( sorting.length && sorting[0][0] == colIdx ) {
			// Single column - already sorting on this column, modify the sort
			nextSortIdx = next( sorting[0] );
	
			sorting.length = 1;
			sorting[0][1] = asSorting[ nextSortIdx ];
			sorting[0]._idx = nextSortIdx;
		}
		else {
			// Single column - sort only on this column
			sorting.length = 0;
			sorting.push( [ colIdx, asSorting[0] ] );
			sorting[0]._idx = 0;
		}
	
		// Run the sort by calling a full redraw
		_fnReDraw( settings );
	
		// callback used for async user interaction
		if ( typeof callback == 'function' ) {
			callback( settings );
		}
	}
	
	
	/**
	 * Attach a sort handler (click) to a node
	 *  @param {object} settings dataTables settings object
	 *  @param {node} attachTo node to attach the handler to
	 *  @param {int} colIdx column sorting index
	 *  @param {function} [callback] callback function
	 *  @memberof DataTable#oApi
	 */
	function _fnSortAttachListener ( settings, attachTo, colIdx, callback )
	{
		var col = settings.aoColumns[ colIdx ];
	
		_fnBindAction( attachTo, {}, function (e) {
			/* If the column is not sortable - don't to anything */
			if ( col.bSortable === false ) {
				return;
			}
	
			// If processing is enabled use a timeout to allow the processing
			// display to be shown - otherwise to it synchronously
			if ( settings.oFeatures.bProcessing ) {
				_fnProcessingDisplay( settings, true );
	
				setTimeout( function() {
					_fnSortListener( settings, colIdx, e.shiftKey, callback );
	
					// In server-side processing, the draw callback will remove the
					// processing display
					if ( _fnDataSource( settings ) !== 'ssp' ) {
						_fnProcessingDisplay( settings, false );
					}
				}, 0 );
			}
			else {
				_fnSortListener( settings, colIdx, e.shiftKey, callback );
			}
		} );
	}
	
	
	/**
	 * Set the sorting classes on table's body, Note: it is safe to call this function
	 * when bSort and bSortClasses are false
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnSortingClasses( settings )
	{
		var oldSort = settings.aLastSort;
		var sortClass = settings.oClasses.sSortColumn;
		var sort = _fnSortFlatten( settings );
		var features = settings.oFeatures;
		var i, ien, colIdx;
	
		if ( features.bSort && features.bSortClasses ) {
			// Remove old sorting classes
			for ( i=0, ien=oldSort.length ; i<ien ; i++ ) {
				colIdx = oldSort[i].src;
	
				// Remove column sorting
				$( _pluck( settings.aoData, 'anCells', colIdx ) )
					.removeClass( sortClass + (i<2 ? i+1 : 3) );
			}
	
			// Add new column sorting
			for ( i=0, ien=sort.length ; i<ien ; i++ ) {
				colIdx = sort[i].src;
	
				$( _pluck( settings.aoData, 'anCells', colIdx ) )
					.addClass( sortClass + (i<2 ? i+1 : 3) );
			}
		}
	
		settings.aLastSort = sort;
	}
	
	
	// Get the data to sort a column, be it from cache, fresh (populating the
	// cache), or from a sort formatter
	function _fnSortData( settings, idx )
	{
		// Custom sorting function - provided by the sort data type
		var column = settings.aoColumns[ idx ];
		var customSort = DataTable.ext.order[ column.sSortDataType ];
		var customData;
	
		if ( customSort ) {
			customData = customSort.call( settings.oInstance, settings, idx,
				_fnColumnIndexToVisible( settings, idx )
			);
		}
	
		// Use / populate cache
		var row, cellData;
		var formatter = DataTable.ext.type.order[ column.sType+"-pre" ];
	
		for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			row = settings.aoData[i];
	
			if ( ! row._aSortData ) {
				row._aSortData = [];
			}
	
			if ( ! row._aSortData[idx] || customSort ) {
				cellData = customSort ?
					customData[i] : // If there was a custom sort function, use data from there
					_fnGetCellData( settings, i, idx, 'sort' );
	
				row._aSortData[ idx ] = formatter ?
					formatter( cellData ) :
					cellData;
			}
		}
	}
	
	
	
	/**
	 * Save the state of a table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnSaveState ( settings )
	{
		if ( !settings.oFeatures.bStateSave || settings.bDestroying )
		{
			return;
		}
	
		/* Store the interesting variables */
		var state = {
			time:    +new Date(),
			start:   settings._iDisplayStart,
			length:  settings._iDisplayLength,
			order:   $.extend( true, [], settings.aaSorting ),
			search:  _fnSearchToCamel( settings.oPreviousSearch ),
			columns: $.map( settings.aoColumns, function ( col, i ) {
				return {
					visible: col.bVisible,
					search: _fnSearchToCamel( settings.aoPreSearchCols[i] )
				};
			} )
		};
	
		_fnCallbackFire( settings, "aoStateSaveParams", 'stateSaveParams', [settings, state] );
	
		settings.oSavedState = state;
		settings.fnStateSaveCallback.call( settings.oInstance, settings, state );
	}
	
	
	/**
	 * Attempt to load a saved table state
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} oInit DataTables init object so we can override settings
	 *  @param {function} callback Callback to execute when the state has been loaded
	 *  @memberof DataTable#oApi
	 */
	function _fnLoadState ( settings, oInit, callback )
	{
		var i, ien;
		var columns = settings.aoColumns;
		var loaded = function ( s ) {
			if ( ! s || ! s.time ) {
				callback();
				return;
			}
	
			// Allow custom and plug-in manipulation functions to alter the saved data set and
			// cancelling of loading by returning false
			var abStateLoad = _fnCallbackFire( settings, 'aoStateLoadParams', 'stateLoadParams', [settings, s] );
			if ( $.inArray( false, abStateLoad ) !== -1 ) {
				callback();
				return;
			}
	
			// Reject old data
			var duration = settings.iStateDuration;
			if ( duration > 0 && s.time < +new Date() - (duration*1000) ) {
				callback();
				return;
			}
	
			// Number of columns have changed - all bets are off, no restore of settings
			if ( s.columns && columns.length !== s.columns.length ) {
				callback();
				return;
			}
	
			// Store the saved state so it might be accessed at any time
			settings.oLoadedState = $.extend( true, {}, s );
	
			// Restore key features - todo - for 1.11 this needs to be done by
			// subscribed events
			if ( s.start !== undefined ) {
				settings._iDisplayStart    = s.start;
				settings.iInitDisplayStart = s.start;
			}
			if ( s.length !== undefined ) {
				settings._iDisplayLength   = s.length;
			}
	
			// Order
			if ( s.order !== undefined ) {
				settings.aaSorting = [];
				$.each( s.order, function ( i, col ) {
					settings.aaSorting.push( col[0] >= columns.length ?
						[ 0, col[1] ] :
						col
					);
				} );
			}
	
			// Search
			if ( s.search !== undefined ) {
				$.extend( settings.oPreviousSearch, _fnSearchToHung( s.search ) );
			}
	
			// Columns
			//
			if ( s.columns ) {
				for ( i=0, ien=s.columns.length ; i<ien ; i++ ) {
					var col = s.columns[i];
	
					// Visibility
					if ( col.visible !== undefined ) {
						columns[i].bVisible = col.visible;
					}
	
					// Search
					if ( col.search !== undefined ) {
						$.extend( settings.aoPreSearchCols[i], _fnSearchToHung( col.search ) );
					}
				}
			}
	
			_fnCallbackFire( settings, 'aoStateLoaded', 'stateLoaded', [settings, s] );
			callback();
		}
	
		if ( ! settings.oFeatures.bStateSave ) {
			callback();
			return;
		}
	
		var state = settings.fnStateLoadCallback.call( settings.oInstance, settings, loaded );
	
		if ( state !== undefined ) {
			loaded( state );
		}
		// otherwise, wait for the loaded callback to be executed
	}
	
	
	/**
	 * Return the settings object for a particular table
	 *  @param {node} table table we are using as a dataTable
	 *  @returns {object} Settings object - or null if not found
	 *  @memberof DataTable#oApi
	 */
	function _fnSettingsFromNode ( table )
	{
		var settings = DataTable.settings;
		var idx = $.inArray( table, _pluck( settings, 'nTable' ) );
	
		return idx !== -1 ?
			settings[ idx ] :
			null;
	}
	
	
	/**
	 * Log an error message
	 *  @param {object} settings dataTables settings object
	 *  @param {int} level log error messages, or display them to the user
	 *  @param {string} msg error message
	 *  @param {int} tn Technical note id to get more information about the error.
	 *  @memberof DataTable#oApi
	 */
	function _fnLog( settings, level, msg, tn )
	{
		msg = 'DataTables warning: '+
			(settings ? 'table id='+settings.sTableId+' - ' : '')+msg;
	
		if ( tn ) {
			msg += '. For more information about this error, please see '+
			'http://datatables.net/tn/'+tn;
		}
	
		if ( ! level  ) {
			// Backwards compatibility pre 1.10
			var ext = DataTable.ext;
			var type = ext.sErrMode || ext.errMode;
	
			if ( settings ) {
				_fnCallbackFire( settings, null, 'error', [ settings, tn, msg ] );
			}
	
			if ( type == 'alert' ) {
				alert( msg );
			}
			else if ( type == 'throw' ) {
				throw new Error(msg);
			}
			else if ( typeof type == 'function' ) {
				type( settings, tn, msg );
			}
		}
		else if ( window.console && console.log ) {
			console.log( msg );
		}
	}
	
	
	/**
	 * See if a property is defined on one object, if so assign it to the other object
	 *  @param {object} ret target object
	 *  @param {object} src source object
	 *  @param {string} name property
	 *  @param {string} [mappedName] name to map too - optional, name used if not given
	 *  @memberof DataTable#oApi
	 */
	function _fnMap( ret, src, name, mappedName )
	{
		if ( $.isArray( name ) ) {
			$.each( name, function (i, val) {
				if ( $.isArray( val ) ) {
					_fnMap( ret, src, val[0], val[1] );
				}
				else {
					_fnMap( ret, src, val );
				}
			} );
	
			return;
		}
	
		if ( mappedName === undefined ) {
			mappedName = name;
		}
	
		if ( src[name] !== undefined ) {
			ret[mappedName] = src[name];
		}
	}
	
	
	/**
	 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
	 * shallow copy arrays. The reason we need to do this, is that we don't want to
	 * deep copy array init values (such as aaSorting) since the dev wouldn't be
	 * able to override them, but we do want to deep copy arrays.
	 *  @param {object} out Object to extend
	 *  @param {object} extender Object from which the properties will be applied to
	 *      out
	 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
	 *      independent copy with the exception of the `data` or `aaData` parameters
	 *      if they are present. This is so you can pass in a collection to
	 *      DataTables and have that used as your data source without breaking the
	 *      references
	 *  @returns {object} out Reference, just for convenience - out === the return.
	 *  @memberof DataTable#oApi
	 *  @todo This doesn't take account of arrays inside the deep copied objects.
	 */
	function _fnExtend( out, extender, breakRefs )
	{
		var val;
	
		for ( var prop in extender ) {
			if ( extender.hasOwnProperty(prop) ) {
				val = extender[prop];
	
				if ( $.isPlainObject( val ) ) {
					if ( ! $.isPlainObject( out[prop] ) ) {
						out[prop] = {};
					}
					$.extend( true, out[prop], val );
				}
				else if ( breakRefs && prop !== 'data' && prop !== 'aaData' && $.isArray(val) ) {
					out[prop] = val.slice();
				}
				else {
					out[prop] = val;
				}
			}
		}
	
		return out;
	}
	
	
	/**
	 * Bind an event handers to allow a click or return key to activate the callback.
	 * This is good for accessibility since a return on the keyboard will have the
	 * same effect as a click, if the element has focus.
	 *  @param {element} n Element to bind the action to
	 *  @param {object} oData Data object to pass to the triggered function
	 *  @param {function} fn Callback function for when the event is triggered
	 *  @memberof DataTable#oApi
	 */
	function _fnBindAction( n, oData, fn )
	{
		$(n)
			.on( 'click.DT', oData, function (e) {
					$(n).blur(); // Remove focus outline for mouse users
					fn(e);
				} )
			.on( 'keypress.DT', oData, function (e){
					if ( e.which === 13 ) {
						e.preventDefault();
						fn(e);
					}
				} )
			.on( 'selectstart.DT', function () {
					/* Take the brutal approach to cancelling text selection */
					return false;
				} );
	}
	
	
	/**
	 * Register a callback function. Easily allows a callback function to be added to
	 * an array store of callback functions that can then all be called together.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sStore Name of the array storage for the callbacks in oSettings
	 *  @param {function} fn Function to be called back
	 *  @param {string} sName Identifying name for the callback (i.e. a label)
	 *  @memberof DataTable#oApi
	 */
	function _fnCallbackReg( oSettings, sStore, fn, sName )
	{
		if ( fn )
		{
			oSettings[sStore].push( {
				"fn": fn,
				"sName": sName
			} );
		}
	}
	
	
	/**
	 * Fire callback functions and trigger events. Note that the loop over the
	 * callback array store is done backwards! Further note that you do not want to
	 * fire off triggers in time sensitive applications (for example cell creation)
	 * as its slow.
	 *  @param {object} settings dataTables settings object
	 *  @param {string} callbackArr Name of the array storage for the callbacks in
	 *      oSettings
	 *  @param {string} eventName Name of the jQuery custom event to trigger. If
	 *      null no trigger is fired
	 *  @param {array} args Array of arguments to pass to the callback function /
	 *      trigger
	 *  @memberof DataTable#oApi
	 */
	function _fnCallbackFire( settings, callbackArr, eventName, args )
	{
		var ret = [];
	
		if ( callbackArr ) {
			ret = $.map( settings[callbackArr].slice().reverse(), function (val, i) {
				return val.fn.apply( settings.oInstance, args );
			} );
		}
	
		if ( eventName !== null ) {
			var e = $.Event( eventName+'.dt' );
	
			$(settings.nTable).trigger( e, args );
	
			ret.push( e.result );
		}
	
		return ret;
	}
	
	
	function _fnLengthOverflow ( settings )
	{
		var
			start = settings._iDisplayStart,
			end = settings.fnDisplayEnd(),
			len = settings._iDisplayLength;
	
		/* If we have space to show extra rows (backing up from the end point - then do so */
		if ( start >= end )
		{
			start = end - len;
		}
	
		// Keep the start record on the current page
		start -= (start % len);
	
		if ( len === -1 || start < 0 )
		{
			start = 0;
		}
	
		settings._iDisplayStart = start;
	}
	
	
	function _fnRenderer( settings, type )
	{
		var renderer = settings.renderer;
		var host = DataTable.ext.renderer[type];
	
		if ( $.isPlainObject( renderer ) && renderer[type] ) {
			// Specific renderer for this type. If available use it, otherwise use
			// the default.
			return host[renderer[type]] || host._;
		}
		else if ( typeof renderer === 'string' ) {
			// Common renderer - if there is one available for this type use it,
			// otherwise use the default
			return host[renderer] || host._;
		}
	
		// Use the default
		return host._;
	}
	
	
	/**
	 * Detect the data source being used for the table. Used to simplify the code
	 * a little (ajax) and to make it compress a little smaller.
	 *
	 *  @param {object} settings dataTables settings object
	 *  @returns {string} Data source
	 *  @memberof DataTable#oApi
	 */
	function _fnDataSource ( settings )
	{
		if ( settings.oFeatures.bServerSide ) {
			return 'ssp';
		}
		else if ( settings.ajax || settings.sAjaxSource ) {
			return 'ajax';
		}
		return 'dom';
	}
	

	
	
	/**
	 * Computed structure of the DataTables API, defined by the options passed to
	 * `DataTable.Api.register()` when building the API.
	 *
	 * The structure is built in order to speed creation and extension of the Api
	 * objects since the extensions are effectively pre-parsed.
	 *
	 * The array is an array of objects with the following structure, where this
	 * base array represents the Api prototype base:
	 *
	 *     [
	 *       {
	 *         name:      'data'                -- string   - Property name
	 *         val:       function () {},       -- function - Api method (or undefined if just an object
	 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
	 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
	 *       },
	 *       {
	 *         name:     'row'
	 *         val:       {},
	 *         methodExt: [ ... ],
	 *         propExt:   [
	 *           {
	 *             name:      'data'
	 *             val:       function () {},
	 *             methodExt: [ ... ],
	 *             propExt:   [ ... ]
	 *           },
	 *           ...
	 *         ]
	 *       }
	 *     ]
	 *
	 * @type {Array}
	 * @ignore
	 */
	var __apiStruct = [];
	
	
	/**
	 * `Array.prototype` reference.
	 *
	 * @type object
	 * @ignore
	 */
	var __arrayProto = Array.prototype;
	
	
	/**
	 * Abstraction for `context` parameter of the `Api` constructor to allow it to
	 * take several different forms for ease of use.
	 *
	 * Each of the input parameter types will be converted to a DataTables settings
	 * object where possible.
	 *
	 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
	 *   of:
	 *
	 *   * `string` - jQuery selector. Any DataTables' matching the given selector
	 *     with be found and used.
	 *   * `node` - `TABLE` node which has already been formed into a DataTable.
	 *   * `jQuery` - A jQuery object of `TABLE` nodes.
	 *   * `object` - DataTables settings object
	 *   * `DataTables.Api` - API instance
	 * @return {array|null} Matching DataTables settings objects. `null` or
	 *   `undefined` is returned if no matching DataTable is found.
	 * @ignore
	 */
	var _toSettings = function ( mixed )
	{
		var idx, jq;
		var settings = DataTable.settings;
		var tables = $.map( settings, function (el, i) {
			return el.nTable;
		} );
	
		if ( ! mixed ) {
			return [];
		}
		else if ( mixed.nTable && mixed.oApi ) {
			// DataTables settings object
			return [ mixed ];
		}
		else if ( mixed.nodeName && mixed.nodeName.toLowerCase() === 'table' ) {
			// Table node
			idx = $.inArray( mixed, tables );
			return idx !== -1 ? [ settings[idx] ] : null;
		}
		else if ( mixed && typeof mixed.settings === 'function' ) {
			return mixed.settings().toArray();
		}
		else if ( typeof mixed === 'string' ) {
			// jQuery selector
			jq = $(mixed);
		}
		else if ( mixed instanceof $ ) {
			// jQuery object (also DataTables instance)
			jq = mixed;
		}
	
		if ( jq ) {
			return jq.map( function(i) {
				idx = $.inArray( this, tables );
				return idx !== -1 ? settings[idx] : null;
			} ).toArray();
		}
	};
	
	
	/**
	 * DataTables API class - used to control and interface with  one or more
	 * DataTables enhanced tables.
	 *
	 * The API class is heavily based on jQuery, presenting a chainable interface
	 * that you can use to interact with tables. Each instance of the API class has
	 * a "context" - i.e. the tables that it will operate on. This could be a single
	 * table, all tables on a page or a sub-set thereof.
	 *
	 * Additionally the API is designed to allow you to easily work with the data in
	 * the tables, retrieving and manipulating it as required. This is done by
	 * presenting the API class as an array like interface. The contents of the
	 * array depend upon the actions requested by each method (for example
	 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
	 * return an array of objects or arrays depending upon your table's
	 * configuration). The API object has a number of array like methods (`push`,
	 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
	 * `unique` etc) to assist your working with the data held in a table.
	 *
	 * Most methods (those which return an Api instance) are chainable, which means
	 * the return from a method call also has all of the methods available that the
	 * top level object had. For example, these two calls are equivalent:
	 *
	 *     // Not chained
	 *     api.row.add( {...} );
	 *     api.draw();
	 *
	 *     // Chained
	 *     api.row.add( {...} ).draw();
	 *
	 * @class DataTable.Api
	 * @param {array|object|string|jQuery} context DataTable identifier. This is
	 *   used to define which DataTables enhanced tables this API will operate on.
	 *   Can be one of:
	 *
	 *   * `string` - jQuery selector. Any DataTables' matching the given selector
	 *     with be found and used.
	 *   * `node` - `TABLE` node which has already been formed into a DataTable.
	 *   * `jQuery` - A jQuery object of `TABLE` nodes.
	 *   * `object` - DataTables settings object
	 * @param {array} [data] Data to initialise the Api instance with.
	 *
	 * @example
	 *   // Direct initialisation during DataTables construction
	 *   var api = $('#example').DataTable();
	 *
	 * @example
	 *   // Initialisation using a DataTables jQuery object
	 *   var api = $('#example').dataTable().api();
	 *
	 * @example
	 *   // Initialisation as a constructor
	 *   var api = new $.fn.DataTable.Api( 'table.dataTable' );
	 */
	_Api = function ( context, data )
	{
		if ( ! (this instanceof _Api) ) {
			return new _Api( context, data );
		}
	
		var settings = [];
		var ctxSettings = function ( o ) {
			var a = _toSettings( o );
			if ( a ) {
				settings = settings.concat( a );
			}
		};
	
		if ( $.isArray( context ) ) {
			for ( var i=0, ien=context.length ; i<ien ; i++ ) {
				ctxSettings( context[i] );
			}
		}
		else {
			ctxSettings( context );
		}
	
		// Remove duplicates
		this.context = _unique( settings );
	
		// Initial data
		if ( data ) {
			$.merge( this, data );
		}
	
		// selector
		this.selector = {
			rows: null,
			cols: null,
			opts: null
		};
	
		_Api.extend( this, this, __apiStruct );
	};
	
	DataTable.Api = _Api;
	
	// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
	// isPlainObject.
	$.extend( _Api.prototype, {
		any: function ()
		{
			return this.count() !== 0;
		},
	
	
		concat:  __arrayProto.concat,
	
	
		context: [], // array of table settings objects
	
	
		count: function ()
		{
			return this.flatten().length;
		},
	
	
		each: function ( fn )
		{
			for ( var i=0, ien=this.length ; i<ien; i++ ) {
				fn.call( this, this[i], i, this );
			}
	
			return this;
		},
	
	
		eq: function ( idx )
		{
			var ctx = this.context;
	
			return ctx.length > idx ?
				new _Api( ctx[idx], this[idx] ) :
				null;
		},
	
	
		filter: function ( fn )
		{
			var a = [];
	
			if ( __arrayProto.filter ) {
				a = __arrayProto.filter.call( this, fn, this );
			}
			else {
				// Compatibility for browsers without EMCA-252-5 (JS 1.6)
				for ( var i=0, ien=this.length ; i<ien ; i++ ) {
					if ( fn.call( this, this[i], i, this ) ) {
						a.push( this[i] );
					}
				}
			}
	
			return new _Api( this.context, a );
		},
	
	
		flatten: function ()
		{
			var a = [];
			return new _Api( this.context, a.concat.apply( a, this.toArray() ) );
		},
	
	
		join:    __arrayProto.join,
	
	
		indexOf: __arrayProto.indexOf || function (obj, start)
		{
			for ( var i=(start || 0), ien=this.length ; i<ien ; i++ ) {
				if ( this[i] === obj ) {
					return i;
				}
			}
			return -1;
		},
	
		iterator: function ( flatten, type, fn, alwaysNew ) {
			var
				a = [], ret,
				i, ien, j, jen,
				context = this.context,
				rows, items, item,
				selector = this.selector;
	
			// Argument shifting
			if ( typeof flatten === 'string' ) {
				alwaysNew = fn;
				fn = type;
				type = flatten;
				flatten = false;
			}
	
			for ( i=0, ien=context.length ; i<ien ; i++ ) {
				var apiInst = new _Api( context[i] );
	
				if ( type === 'table' ) {
					ret = fn.call( apiInst, context[i], i );
	
					if ( ret !== undefined ) {
						a.push( ret );
					}
				}
				else if ( type === 'columns' || type === 'rows' ) {
					// this has same length as context - one entry for each table
					ret = fn.call( apiInst, context[i], this[i], i );
	
					if ( ret !== undefined ) {
						a.push( ret );
					}
				}
				else if ( type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell' ) {
					// columns and rows share the same structure.
					// 'this' is an array of column indexes for each context
					items = this[i];
	
					if ( type === 'column-rows' ) {
						rows = _selector_row_indexes( context[i], selector.opts );
					}
	
					for ( j=0, jen=items.length ; j<jen ; j++ ) {
						item = items[j];
	
						if ( type === 'cell' ) {
							ret = fn.call( apiInst, context[i], item.row, item.column, i, j );
						}
						else {
							ret = fn.call( apiInst, context[i], item, i, j, rows );
						}
	
						if ( ret !== undefined ) {
							a.push( ret );
						}
					}
				}
			}
	
			if ( a.length || alwaysNew ) {
				var api = new _Api( context, flatten ? a.concat.apply( [], a ) : a );
				var apiSelector = api.selector;
				apiSelector.rows = selector.rows;
				apiSelector.cols = selector.cols;
				apiSelector.opts = selector.opts;
				return api;
			}
			return this;
		},
	
	
		lastIndexOf: __arrayProto.lastIndexOf || function (obj, start)
		{
			// Bit cheeky...
			return this.indexOf.apply( this.toArray.reverse(), arguments );
		},
	
	
		length:  0,
	
	
		map: function ( fn )
		{
			var a = [];
	
			if ( __arrayProto.map ) {
				a = __arrayProto.map.call( this, fn, this );
			}
			else {
				// Compatibility for browsers without EMCA-252-5 (JS 1.6)
				for ( var i=0, ien=this.length ; i<ien ; i++ ) {
					a.push( fn.call( this, this[i], i ) );
				}
			}
	
			return new _Api( this.context, a );
		},
	
	
		pluck: function ( prop )
		{
			return this.map( function ( el ) {
				return el[ prop ];
			} );
		},
	
		pop:     __arrayProto.pop,
	
	
		push:    __arrayProto.push,
	
	
		// Does not return an API instance
		reduce: __arrayProto.reduce || function ( fn, init )
		{
			return _fnReduce( this, fn, init, 0, this.length, 1 );
		},
	
	
		reduceRight: __arrayProto.reduceRight || function ( fn, init )
		{
			return _fnReduce( this, fn, init, this.length-1, -1, -1 );
		},
	
	
		reverse: __arrayProto.reverse,
	
	
		// Object with rows, columns and opts
		selector: null,
	
	
		shift:   __arrayProto.shift,
	
	
		slice: function () {
			return new _Api( this.context, this );
		},
	
	
		sort:    __arrayProto.sort, // ? name - order?
	
	
		splice:  __arrayProto.splice,
	
	
		toArray: function ()
		{
			return __arrayProto.slice.call( this );
		},
	
	
		to$: function ()
		{
			return $( this );
		},
	
	
		toJQuery: function ()
		{
			return $( this );
		},
	
	
		unique: function ()
		{
			return new _Api( this.context, _unique(this) );
		},
	
	
		unshift: __arrayProto.unshift
	} );
	
	
	_Api.extend = function ( scope, obj, ext )
	{
		// Only extend API instances and static properties of the API
		if ( ! ext.length || ! obj || ( ! (obj instanceof _Api) && ! obj.__dt_wrapper ) ) {
			return;
		}
	
		var
			i, ien,
			j, jen,
			struct, inner,
			methodScoping = function ( scope, fn, struc ) {
				return function () {
					var ret = fn.apply( scope, arguments );
	
					// Method extension
					_Api.extend( ret, ret, struc.methodExt );
					return ret;
				};
			};
	
		for ( i=0, ien=ext.length ; i<ien ; i++ ) {
			struct = ext[i];
	
			// Value
			obj[ struct.name ] = typeof struct.val === 'function' ?
				methodScoping( scope, struct.val, struct ) :
				$.isPlainObject( struct.val ) ?
					{} :
					struct.val;
	
			obj[ struct.name ].__dt_wrapper = true;
	
			// Property extension
			_Api.extend( scope, obj[ struct.name ], struct.propExt );
		}
	};
	
	
	// @todo - Is there need for an augment function?
	// _Api.augment = function ( inst, name )
	// {
	// 	// Find src object in the structure from the name
	// 	var parts = name.split('.');
	
	// 	_Api.extend( inst, obj );
	// };
	
	
	//     [
	//       {
	//         name:      'data'                -- string   - Property name
	//         val:       function () {},       -- function - Api method (or undefined if just an object
	//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
	//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
	//       },
	//       {
	//         name:     'row'
	//         val:       {},
	//         methodExt: [ ... ],
	//         propExt:   [
	//           {
	//             name:      'data'
	//             val:       function () {},
	//             methodExt: [ ... ],
	//             propExt:   [ ... ]
	//           },
	//           ...
	//         ]
	//       }
	//     ]
	
	_Api.register = _api_register = function ( name, val )
	{
		if ( $.isArray( name ) ) {
			for ( var j=0, jen=name.length ; j<jen ; j++ ) {
				_Api.register( name[j], val );
			}
			return;
		}
	
		var
			i, ien,
			heir = name.split('.'),
			struct = __apiStruct,
			key, method;
	
		var find = function ( src, name ) {
			for ( var i=0, ien=src.length ; i<ien ; i++ ) {
				if ( src[i].name === name ) {
					return src[i];
				}
			}
			return null;
		};
	
		for ( i=0, ien=heir.length ; i<ien ; i++ ) {
			method = heir[i].indexOf('()') !== -1;
			key = method ?
				heir[i].replace('()', '') :
				heir[i];
	
			var src = find( struct, key );
			if ( ! src ) {
				src = {
					name:      key,
					val:       {},
					methodExt: [],
					propExt:   []
				};
				struct.push( src );
			}
	
			if ( i === ien-1 ) {
				src.val = val;
			}
			else {
				struct = method ?
					src.methodExt :
					src.propExt;
			}
		}
	};
	
	
	_Api.registerPlural = _api_registerPlural = function ( pluralName, singularName, val ) {
		_Api.register( pluralName, val );
	
		_Api.register( singularName, function () {
			var ret = val.apply( this, arguments );
	
			if ( ret === this ) {
				// Returned item is the API instance that was passed in, return it
				return this;
			}
			else if ( ret instanceof _Api ) {
				// New API instance returned, want the value from the first item
				// in the returned array for the singular result.
				return ret.length ?
					$.isArray( ret[0] ) ?
						new _Api( ret.context, ret[0] ) : // Array results are 'enhanced'
						ret[0] :
					undefined;
			}
	
			// Non-API return - just fire it back
			return ret;
		} );
	};
	
	
	/**
	 * Selector for HTML tables. Apply the given selector to the give array of
	 * DataTables settings objects.
	 *
	 * @param {string|integer} [selector] jQuery selector string or integer
	 * @param  {array} Array of DataTables settings objects to be filtered
	 * @return {array}
	 * @ignore
	 */
	var __table_selector = function ( selector, a )
	{
		// Integer is used to pick out a table by index
		if ( typeof selector === 'number' ) {
			return [ a[ selector ] ];
		}
	
		// Perform a jQuery selector on the table nodes
		var nodes = $.map( a, function (el, i) {
			return el.nTable;
		} );
	
		return $(nodes)
			.filter( selector )
			.map( function (i) {
				// Need to translate back from the table node to the settings
				var idx = $.inArray( this, nodes );
				return a[ idx ];
			} )
			.toArray();
	};
	
	
	
	/**
	 * Context selector for the API's context (i.e. the tables the API instance
	 * refers to.
	 *
	 * @name    DataTable.Api#tables
	 * @param {string|integer} [selector] Selector to pick which tables the iterator
	 *   should operate on. If not given, all tables in the current context are
	 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
	 *   select multiple tables or as an integer to select a single table.
	 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
	 */
	_api_register( 'tables()', function ( selector ) {
		// A new instance is created if there was a selector specified
		return selector ?
			new _Api( __table_selector( selector, this.context ) ) :
			this;
	} );
	
	
	_api_register( 'table()', function ( selector ) {
		var tables = this.tables( selector );
		var ctx = tables.context;
	
		// Truncate to the first matched table
		return ctx.length ?
			new _Api( ctx[0] ) :
			tables;
	} );
	
	
	_api_registerPlural( 'tables().nodes()', 'table().node()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTable;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().body()', 'table().body()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTBody;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().header()', 'table().header()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTHead;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().footer()', 'table().footer()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTFoot;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().containers()', 'table().container()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTableWrapper;
		}, 1 );
	} );
	
	
	
	/**
	 * Redraw the tables in the current context.
	 */
	_api_register( 'draw()', function ( paging ) {
		return this.iterator( 'table', function ( settings ) {
			if ( paging === 'page' ) {
				_fnDraw( settings );
			}
			else {
				if ( typeof paging === 'string' ) {
					paging = paging === 'full-hold' ?
						false :
						true;
				}
	
				_fnReDraw( settings, paging===false );
			}
		} );
	} );
	
	
	
	/**
	 * Get the current page index.
	 *
	 * @return {integer} Current page index (zero based)
	 *//**
	 * Set the current page.
	 *
	 * Note that if you attempt to show a page which does not exist, DataTables will
	 * not throw an error, but rather reset the paging.
	 *
	 * @param {integer|string} action The paging action to take. This can be one of:
	 *  * `integer` - The page index to jump to
	 *  * `string` - An action to take:
	 *    * `first` - Jump to first page.
	 *    * `next` - Jump to the next page
	 *    * `previous` - Jump to previous page
	 *    * `last` - Jump to the last page.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'page()', function ( action ) {
		if ( action === undefined ) {
			return this.page.info().page; // not an expensive call
		}
	
		// else, have an action to take on all tables
		return this.iterator( 'table', function ( settings ) {
			_fnPageChange( settings, action );
		} );
	} );
	
	
	/**
	 * Paging information for the first table in the current context.
	 *
	 * If you require paging information for another table, use the `table()` method
	 * with a suitable selector.
	 *
	 * @return {object} Object with the following properties set:
	 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
	 *  * `pages` - Total number of pages
	 *  * `start` - Display index for the first record shown on the current page
	 *  * `end` - Display index for the last record shown on the current page
	 *  * `length` - Display length (number of records). Note that generally `start
	 *    + length = end`, but this is not always true, for example if there are
	 *    only 2 records to show on the final page, with a length of 10.
	 *  * `recordsTotal` - Full data set length
	 *  * `recordsDisplay` - Data set length once the current filtering criterion
	 *    are applied.
	 */
	_api_register( 'page.info()', function ( action ) {
		if ( this.context.length === 0 ) {
			return undefined;
		}
	
		var
			settings   = this.context[0],
			start      = settings._iDisplayStart,
			len        = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1,
			visRecords = settings.fnRecordsDisplay(),
			all        = len === -1;
	
		return {
			"page":           all ? 0 : Math.floor( start / len ),
			"pages":          all ? 1 : Math.ceil( visRecords / len ),
			"start":          start,
			"end":            settings.fnDisplayEnd(),
			"length":         len,
			"recordsTotal":   settings.fnRecordsTotal(),
			"recordsDisplay": visRecords,
			"serverSide":     _fnDataSource( settings ) === 'ssp'
		};
	} );
	
	
	/**
	 * Get the current page length.
	 *
	 * @return {integer} Current page length. Note `-1` indicates that all records
	 *   are to be shown.
	 *//**
	 * Set the current page length.
	 *
	 * @param {integer} Page length to set. Use `-1` to show all records.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'page.len()', function ( len ) {
		// Note that we can't call this function 'length()' because `length`
		// is a Javascript property of functions which defines how many arguments
		// the function expects.
		if ( len === undefined ) {
			return this.context.length !== 0 ?
				this.context[0]._iDisplayLength :
				undefined;
		}
	
		// else, set the page length
		return this.iterator( 'table', function ( settings ) {
			_fnLengthChange( settings, len );
		} );
	} );
	
	
	
	var __reload = function ( settings, holdPosition, callback ) {
		// Use the draw event to trigger a callback
		if ( callback ) {
			var api = new _Api( settings );
	
			api.one( 'draw', function () {
				callback( api.ajax.json() );
			} );
		}
	
		if ( _fnDataSource( settings ) == 'ssp' ) {
			_fnReDraw( settings, holdPosition );
		}
		else {
			_fnProcessingDisplay( settings, true );
	
			// Cancel an existing request
			var xhr = settings.jqXHR;
			if ( xhr && xhr.readyState !== 4 ) {
				xhr.abort();
			}
	
			// Trigger xhr
			_fnBuildAjax( settings, [], function( json ) {
				_fnClearTable( settings );
	
				var data = _fnAjaxDataSrc( settings, json );
				for ( var i=0, ien=data.length ; i<ien ; i++ ) {
					_fnAddData( settings, data[i] );
				}
	
				_fnReDraw( settings, holdPosition );
				_fnProcessingDisplay( settings, false );
			} );
		}
	};
	
	
	/**
	 * Get the JSON response from the last Ajax request that DataTables made to the
	 * server. Note that this returns the JSON from the first table in the current
	 * context.
	 *
	 * @return {object} JSON received from the server.
	 */
	_api_register( 'ajax.json()', function () {
		var ctx = this.context;
	
		if ( ctx.length > 0 ) {
			return ctx[0].json;
		}
	
		// else return undefined;
	} );
	
	
	/**
	 * Get the data submitted in the last Ajax request
	 */
	_api_register( 'ajax.params()', function () {
		var ctx = this.context;
	
		if ( ctx.length > 0 ) {
			return ctx[0].oAjaxData;
		}
	
		// else return undefined;
	} );
	
	
	/**
	 * Reload tables from the Ajax data source. Note that this function will
	 * automatically re-draw the table when the remote data has been loaded.
	 *
	 * @param {boolean} [reset=true] Reset (default) or hold the current paging
	 *   position. A full re-sort and re-filter is performed when this method is
	 *   called, which is why the pagination reset is the default action.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'ajax.reload()', function ( callback, resetPaging ) {
		return this.iterator( 'table', function (settings) {
			__reload( settings, resetPaging===false, callback );
		} );
	} );
	
	
	/**
	 * Get the current Ajax URL. Note that this returns the URL from the first
	 * table in the current context.
	 *
	 * @return {string} Current Ajax source URL
	 *//**
	 * Set the Ajax URL. Note that this will set the URL for all tables in the
	 * current context.
	 *
	 * @param {string} url URL to set.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'ajax.url()', function ( url ) {
		var ctx = this.context;
	
		if ( url === undefined ) {
			// get
			if ( ctx.length === 0 ) {
				return undefined;
			}
			ctx = ctx[0];
	
			return ctx.ajax ?
				$.isPlainObject( ctx.ajax ) ?
					ctx.ajax.url :
					ctx.ajax :
				ctx.sAjaxSource;
		}
	
		// set
		return this.iterator( 'table', function ( settings ) {
			if ( $.isPlainObject( settings.ajax ) ) {
				settings.ajax.url = url;
			}
			else {
				settings.ajax = url;
			}
			// No need to consider sAjaxSource here since DataTables gives priority
			// to `ajax` over `sAjaxSource`. So setting `ajax` here, renders any
			// value of `sAjaxSource` redundant.
		} );
	} );
	
	
	/**
	 * Load data from the newly set Ajax URL. Note that this method is only
	 * available when `ajax.url()` is used to set a URL. Additionally, this method
	 * has the same effect as calling `ajax.reload()` but is provided for
	 * convenience when setting a new URL. Like `ajax.reload()` it will
	 * automatically redraw the table once the remote data has been loaded.
	 *
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'ajax.url().load()', function ( callback, resetPaging ) {
		// Same as a reload, but makes sense to present it for easy access after a
		// url change
		return this.iterator( 'table', function ( ctx ) {
			__reload( ctx, resetPaging===false, callback );
		} );
	} );
	
	
	
	
	var _selector_run = function ( type, selector, selectFn, settings, opts )
	{
		var
			out = [], res,
			a, i, ien, j, jen,
			selectorType = typeof selector;
	
		// Can't just check for isArray here, as an API or jQuery instance might be
		// given with their array like look
		if ( ! selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined ) {
			selector = [ selector ];
		}
	
		for ( i=0, ien=selector.length ; i<ien ; i++ ) {
			// Only split on simple strings - complex expressions will be jQuery selectors
			a = selector[i] && selector[i].split && ! selector[i].match(/[\[\(:]/) ?
				selector[i].split(',') :
				[ selector[i] ];
	
			for ( j=0, jen=a.length ; j<jen ; j++ ) {
				res = selectFn( typeof a[j] === 'string' ? $.trim(a[j]) : a[j] );
	
				if ( res && res.length ) {
					out = out.concat( res );
				}
			}
		}
	
		// selector extensions
		var ext = _ext.selector[ type ];
		if ( ext.length ) {
			for ( i=0, ien=ext.length ; i<ien ; i++ ) {
				out = ext[i]( settings, opts, out );
			}
		}
	
		return _unique( out );
	};
	
	
	var _selector_opts = function ( opts )
	{
		if ( ! opts ) {
			opts = {};
		}
	
		// Backwards compatibility for 1.9- which used the terminology filter rather
		// than search
		if ( opts.filter && opts.search === undefined ) {
			opts.search = opts.filter;
		}
	
		return $.extend( {
			search: 'none',
			order: 'current',
			page: 'all'
		}, opts );
	};
	
	
	var _selector_first = function ( inst )
	{
		// Reduce the API instance to the first item found
		for ( var i=0, ien=inst.length ; i<ien ; i++ ) {
			if ( inst[i].length > 0 ) {
				// Assign the first element to the first item in the instance
				// and truncate the instance and context
				inst[0] = inst[i];
				inst[0].length = 1;
				inst.length = 1;
				inst.context = [ inst.context[i] ];
	
				return inst;
			}
		}
	
		// Not found - return an empty instance
		inst.length = 0;
		return inst;
	};
	
	
	var _selector_row_indexes = function ( settings, opts )
	{
		var
			i, ien, tmp, a=[],
			displayFiltered = settings.aiDisplay,
			displayMaster = settings.aiDisplayMaster;
	
		var
			search = opts.search,  // none, applied, removed
			order  = opts.order,   // applied, current, index (original - compatibility with 1.9)
			page   = opts.page;    // all, current
	
		if ( _fnDataSource( settings ) == 'ssp' ) {
			// In server-side processing mode, most options are irrelevant since
			// rows not shown don't exist and the index order is the applied order
			// Removed is a special case - for consistency just return an empty
			// array
			return search === 'removed' ?
				[] :
				_range( 0, displayMaster.length );
		}
		else if ( page == 'current' ) {
			// Current page implies that order=current and fitler=applied, since it is
			// fairly senseless otherwise, regardless of what order and search actually
			// are
			for ( i=settings._iDisplayStart, ien=settings.fnDisplayEnd() ; i<ien ; i++ ) {
				a.push( displayFiltered[i] );
			}
		}
		else if ( order == 'current' || order == 'applied' ) {
			if ( search == 'none') {
				a = displayMaster.slice();
			}
			else if ( search == 'applied' ) {
				a = displayFiltered.slice();
			}
			else if ( search == 'removed' ) {
				// O(n+m) solution by creating a hash map
				var displayFilteredMap = {};
	
				for ( var i=0, ien=displayFiltered.length ; i<ien ; i++ ) {
					displayFilteredMap[displayFiltered[i]] = null;
				}
	
				a = $.map( displayMaster, function (el) {
					return ! displayFilteredMap.hasOwnProperty(el) ?
						el :
						null;
				} );
			}
		}
		else if ( order == 'index' || order == 'original' ) {
			for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				if ( search == 'none' ) {
					a.push( i );
				}
				else { // applied | removed
					tmp = $.inArray( i, displayFiltered );
	
					if ((tmp === -1 && search == 'removed') ||
						(tmp >= 0   && search == 'applied') )
					{
						a.push( i );
					}
				}
			}
		}
	
		return a;
	};
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Rows
	 *
	 * {}          - no selector - use all available rows
	 * {integer}   - row aoData index
	 * {node}      - TR node
	 * {string}    - jQuery selector to apply to the TR elements
	 * {array}     - jQuery array of nodes, or simply an array of TR nodes
	 *
	 */
	var __row_selector = function ( settings, selector, opts )
	{
		var rows;
		var run = function ( sel ) {
			var selInt = _intVal( sel );
			var i, ien;
			var aoData = settings.aoData;
	
			// Short cut - selector is a number and no options provided (default is
			// all records, so no need to check if the index is in there, since it
			// must be - dev error if the index doesn't exist).
			if ( selInt !== null && ! opts ) {
				return [ selInt ];
			}
	
			if ( ! rows ) {
				rows = _selector_row_indexes( settings, opts );
			}
	
			if ( selInt !== null && $.inArray( selInt, rows ) !== -1 ) {
				// Selector - integer
				return [ selInt ];
			}
			else if ( sel === null || sel === undefined || sel === '' ) {
				// Selector - none
				return rows;
			}
	
			// Selector - function
			if ( typeof sel === 'function' ) {
				return $.map( rows, function (idx) {
					var row = aoData[ idx ];
					return sel( idx, row._aData, row.nTr ) ? idx : null;
				} );
			}
	
			// Selector - node
			if ( sel.nodeName ) {
				var rowIdx = sel._DT_RowIndex;  // Property added by DT for fast lookup
				var cellIdx = sel._DT_CellIndex;
	
				if ( rowIdx !== undefined ) {
					// Make sure that the row is actually still present in the table
					return aoData[ rowIdx ] && aoData[ rowIdx ].nTr === sel ?
						[ rowIdx ] :
						[];
				}
				else if ( cellIdx ) {
					return aoData[ cellIdx.row ] && aoData[ cellIdx.row ].nTr === sel ?
						[ cellIdx.row ] :
						[];
				}
				else {
					var host = $(sel).closest('*[data-dt-row]');
					return host.length ?
						[ host.data('dt-row') ] :
						[];
				}
			}
	
			// ID selector. Want to always be able to select rows by id, regardless
			// of if the tr element has been created or not, so can't rely upon
			// jQuery here - hence a custom implementation. This does not match
			// Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
			// but to select it using a CSS selector engine (like Sizzle or
			// querySelect) it would need to need to be escaped for some characters.
			// DataTables simplifies this for row selectors since you can select
			// only a row. A # indicates an id any anything that follows is the id -
			// unescaped.
			if ( typeof sel === 'string' && sel.charAt(0) === '#' ) {
				// get row index from id
				var rowObj = settings.aIds[ sel.replace( /^#/, '' ) ];
				if ( rowObj !== undefined ) {
					return [ rowObj.idx ];
				}
	
				// need to fall through to jQuery in case there is DOM id that
				// matches
			}
			
			// Get nodes in the order from the `rows` array with null values removed
			var nodes = _removeEmpty(
				_pluck_order( settings.aoData, rows, 'nTr' )
			);
	
			// Selector - jQuery selector string, array of nodes or jQuery object/
			// As jQuery's .filter() allows jQuery objects to be passed in filter,
			// it also allows arrays, so this will cope with all three options
			return $(nodes)
				.filter( sel )
				.map( function () {
					return this._DT_RowIndex;
				} )
				.toArray();
		};
	
		return _selector_run( 'row', selector, run, settings, opts );
	};
	
	
	_api_register( 'rows()', function ( selector, opts ) {
		// argument shifting
		if ( selector === undefined ) {
			selector = '';
		}
		else if ( $.isPlainObject( selector ) ) {
			opts = selector;
			selector = '';
		}
	
		opts = _selector_opts( opts );
	
		var inst = this.iterator( 'table', function ( settings ) {
			return __row_selector( settings, selector, opts );
		}, 1 );
	
		// Want argument shifting here and in __row_selector?
		inst.selector.rows = selector;
		inst.selector.opts = opts;
	
		return inst;
	} );
	
	_api_register( 'rows().nodes()', function () {
		return this.iterator( 'row', function ( settings, row ) {
			return settings.aoData[ row ].nTr || undefined;
		}, 1 );
	} );
	
	_api_register( 'rows().data()', function () {
		return this.iterator( true, 'rows', function ( settings, rows ) {
			return _pluck_order( settings.aoData, rows, '_aData' );
		}, 1 );
	} );
	
	_api_registerPlural( 'rows().cache()', 'row().cache()', function ( type ) {
		return this.iterator( 'row', function ( settings, row ) {
			var r = settings.aoData[ row ];
			return type === 'search' ? r._aFilterData : r._aSortData;
		}, 1 );
	} );
	
	_api_registerPlural( 'rows().invalidate()', 'row().invalidate()', function ( src ) {
		return this.iterator( 'row', function ( settings, row ) {
			_fnInvalidate( settings, row, src );
		} );
	} );
	
	_api_registerPlural( 'rows().indexes()', 'row().index()', function () {
		return this.iterator( 'row', function ( settings, row ) {
			return row;
		}, 1 );
	} );
	
	_api_registerPlural( 'rows().ids()', 'row().id()', function ( hash ) {
		var a = [];
		var context = this.context;
	
		// `iterator` will drop undefined values, but in this case we want them
		for ( var i=0, ien=context.length ; i<ien ; i++ ) {
			for ( var j=0, jen=this[i].length ; j<jen ; j++ ) {
				var id = context[i].rowIdFn( context[i].aoData[ this[i][j] ]._aData );
				a.push( (hash === true ? '#' : '' )+ id );
			}
		}
	
		return new _Api( context, a );
	} );
	
	_api_registerPlural( 'rows().remove()', 'row().remove()', function () {
		var that = this;
	
		this.iterator( 'row', function ( settings, row, thatIdx ) {
			var data = settings.aoData;
			var rowData = data[ row ];
			var i, ien, j, jen;
			var loopRow, loopCells;
	
			data.splice( row, 1 );
	
			// Update the cached indexes
			for ( i=0, ien=data.length ; i<ien ; i++ ) {
				loopRow = data[i];
				loopCells = loopRow.anCells;
	
				// Rows
				if ( loopRow.nTr !== null ) {
					loopRow.nTr._DT_RowIndex = i;
				}
	
				// Cells
				if ( loopCells !== null ) {
					for ( j=0, jen=loopCells.length ; j<jen ; j++ ) {
						loopCells[j]._DT_CellIndex.row = i;
					}
				}
			}
	
			// Delete from the display arrays
			_fnDeleteIndex( settings.aiDisplayMaster, row );
			_fnDeleteIndex( settings.aiDisplay, row );
			_fnDeleteIndex( that[ thatIdx ], row, false ); // maintain local indexes
	
			// For server-side processing tables - subtract the deleted row from the count
			if ( settings._iRecordsDisplay > 0 ) {
				settings._iRecordsDisplay--;
			}
	
			// Check for an 'overflow' they case for displaying the table
			_fnLengthOverflow( settings );
	
			// Remove the row's ID reference if there is one
			var id = settings.rowIdFn( rowData._aData );
			if ( id !== undefined ) {
				delete settings.aIds[ id ];
			}
		} );
	
		this.iterator( 'table', function ( settings ) {
			for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				settings.aoData[i].idx = i;
			}
		} );
	
		return this;
	} );
	
	
	_api_register( 'rows.add()', function ( rows ) {
		var newRows = this.iterator( 'table', function ( settings ) {
				var row, i, ien;
				var out = [];
	
				for ( i=0, ien=rows.length ; i<ien ; i++ ) {
					row = rows[i];
	
					if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
						out.push( _fnAddTr( settings, row )[0] );
					}
					else {
						out.push( _fnAddData( settings, row ) );
					}
				}
	
				return out;
			}, 1 );
	
		// Return an Api.rows() extended instance, so rows().nodes() etc can be used
		var modRows = this.rows( -1 );
		modRows.pop();
		$.merge( modRows, newRows );
	
		return modRows;
	} );
	
	
	
	
	
	/**
	 *
	 */
	_api_register( 'row()', function ( selector, opts ) {
		return _selector_first( this.rows( selector, opts ) );
	} );
	
	
	_api_register( 'row().data()', function ( data ) {
		var ctx = this.context;
	
		if ( data === undefined ) {
			// Get
			return ctx.length && this.length ?
				ctx[0].aoData[ this[0] ]._aData :
				undefined;
		}
	
		// Set
		var row = ctx[0].aoData[ this[0] ];
		row._aData = data;
	
		// If the DOM has an id, and the data source is an array
		if ( $.isArray( data ) && row.nTr.id ) {
			_fnSetObjectDataFn( ctx[0].rowId )( data, row.nTr.id );
		}
	
		// Automatically invalidate
		_fnInvalidate( ctx[0], this[0], 'data' );
	
		return this;
	} );
	
	
	_api_register( 'row().node()', function () {
		var ctx = this.context;
	
		return ctx.length && this.length ?
			ctx[0].aoData[ this[0] ].nTr || null :
			null;
	} );
	
	
	_api_register( 'row.add()', function ( row ) {
		// Allow a jQuery object to be passed in - only a single row is added from
		// it though - the first element in the set
		if ( row instanceof $ && row.length ) {
			row = row[0];
		}
	
		var rows = this.iterator( 'table', function ( settings ) {
			if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
				return _fnAddTr( settings, row )[0];
			}
			return _fnAddData( settings, row );
		} );
	
		// Return an Api.rows() extended instance, with the newly added row selected
		return this.row( rows[0] );
	} );
	
	
	
	var __details_add = function ( ctx, row, data, klass )
	{
		// Convert to array of TR elements
		var rows = [];
		var addRow = function ( r, k ) {
			// Recursion to allow for arrays of jQuery objects
			if ( $.isArray( r ) || r instanceof $ ) {
				for ( var i=0, ien=r.length ; i<ien ; i++ ) {
					addRow( r[i], k );
				}
				return;
			}
	
			// If we get a TR element, then just add it directly - up to the dev
			// to add the correct number of columns etc
			if ( r.nodeName && r.nodeName.toLowerCase() === 'tr' ) {
				rows.push( r );
			}
			else {
				// Otherwise create a row with a wrapper
				var created = $('<tr><td/></tr>').addClass( k );
				$('td', created)
					.addClass( k )
					.html( r )
					[0].colSpan = _fnVisbleColumns( ctx );
	
				rows.push( created[0] );
			}
		};
	
		addRow( data, klass );
	
		if ( row._details ) {
			row._details.detach();
		}
	
		row._details = $(rows);
	
		// If the children were already shown, that state should be retained
		if ( row._detailsShow ) {
			row._details.insertAfter( row.nTr );
		}
	};
	
	
	var __details_remove = function ( api, idx )
	{
		var ctx = api.context;
	
		if ( ctx.length ) {
			var row = ctx[0].aoData[ idx !== undefined ? idx : api[0] ];
	
			if ( row && row._details ) {
				row._details.remove();
	
				row._detailsShow = undefined;
				row._details = undefined;
			}
		}
	};
	
	
	var __details_display = function ( api, show ) {
		var ctx = api.context;
	
		if ( ctx.length && api.length ) {
			var row = ctx[0].aoData[ api[0] ];
	
			if ( row._details ) {
				row._detailsShow = show;
	
				if ( show ) {
					row._details.insertAfter( row.nTr );
				}
				else {
					row._details.detach();
				}
	
				__details_events( ctx[0] );
			}
		}
	};
	
	
	var __details_events = function ( settings )
	{
		var api = new _Api( settings );
		var namespace = '.dt.DT_details';
		var drawEvent = 'draw'+namespace;
		var colvisEvent = 'column-visibility'+namespace;
		var destroyEvent = 'destroy'+namespace;
		var data = settings.aoData;
	
		api.off( drawEvent +' '+ colvisEvent +' '+ destroyEvent );
	
		if ( _pluck( data, '_details' ).length > 0 ) {
			// On each draw, insert the required elements into the document
			api.on( drawEvent, function ( e, ctx ) {
				if ( settings !== ctx ) {
					return;
				}
	
				api.rows( {page:'current'} ).eq(0).each( function (idx) {
					// Internal data grab
					var row = data[ idx ];
	
					if ( row._detailsShow ) {
						row._details.insertAfter( row.nTr );
					}
				} );
			} );
	
			// Column visibility change - update the colspan
			api.on( colvisEvent, function ( e, ctx, idx, vis ) {
				if ( settings !== ctx ) {
					return;
				}
	
				// Update the colspan for the details rows (note, only if it already has
				// a colspan)
				var row, visible = _fnVisbleColumns( ctx );
	
				for ( var i=0, ien=data.length ; i<ien ; i++ ) {
					row = data[i];
	
					if ( row._details ) {
						row._details.children('td[colspan]').attr('colspan', visible );
					}
				}
			} );
	
			// Table destroyed - nuke any child rows
			api.on( destroyEvent, function ( e, ctx ) {
				if ( settings !== ctx ) {
					return;
				}
	
				for ( var i=0, ien=data.length ; i<ien ; i++ ) {
					if ( data[i]._details ) {
						__details_remove( api, i );
					}
				}
			} );
		}
	};
	
	// Strings for the method names to help minification
	var _emp = '';
	var _child_obj = _emp+'row().child';
	var _child_mth = _child_obj+'()';
	
	// data can be:
	//  tr
	//  string
	//  jQuery or array of any of the above
	_api_register( _child_mth, function ( data, klass ) {
		var ctx = this.context;
	
		if ( data === undefined ) {
			// get
			return ctx.length && this.length ?
				ctx[0].aoData[ this[0] ]._details :
				undefined;
		}
		else if ( data === true ) {
			// show
			this.child.show();
		}
		else if ( data === false ) {
			// remove
			__details_remove( this );
		}
		else if ( ctx.length && this.length ) {
			// set
			__details_add( ctx[0], ctx[0].aoData[ this[0] ], data, klass );
		}
	
		return this;
	} );
	
	
	_api_register( [
		_child_obj+'.show()',
		_child_mth+'.show()' // only when `child()` was called with parameters (without
	], function ( show ) {   // it returns an object and this method is not executed)
		__details_display( this, true );
		return this;
	} );
	
	
	_api_register( [
		_child_obj+'.hide()',
		_child_mth+'.hide()' // only when `child()` was called with parameters (without
	], function () {         // it returns an object and this method is not executed)
		__details_display( this, false );
		return this;
	} );
	
	
	_api_register( [
		_child_obj+'.remove()',
		_child_mth+'.remove()' // only when `child()` was called with parameters (without
	], function () {           // it returns an object and this method is not executed)
		__details_remove( this );
		return this;
	} );
	
	
	_api_register( _child_obj+'.isShown()', function () {
		var ctx = this.context;
	
		if ( ctx.length && this.length ) {
			// _detailsShown as false or undefined will fall through to return false
			return ctx[0].aoData[ this[0] ]._detailsShow || false;
		}
		return false;
	} );
	
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Columns
	 *
	 * {integer}           - column index (>=0 count from left, <0 count from right)
	 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
	 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
	 * "{string}:name"     - column name
	 * "{string}"          - jQuery selector on column header nodes
	 *
	 */
	
	// can be an array of these items, comma separated list, or an array of comma
	// separated lists
	
	var __re_column_selector = /^([^:]+):(name|visIdx|visible)$/;
	
	
	// r1 and r2 are redundant - but it means that the parameters match for the
	// iterator callback in columns().data()
	var __columnData = function ( settings, column, r1, r2, rows ) {
		var a = [];
		for ( var row=0, ien=rows.length ; row<ien ; row++ ) {
			a.push( _fnGetCellData( settings, rows[row], column ) );
		}
		return a;
	};
	
	
	var __column_selector = function ( settings, selector, opts )
	{
		var
			columns = settings.aoColumns,
			names = _pluck( columns, 'sName' ),
			nodes = _pluck( columns, 'nTh' );
	
		var run = function ( s ) {
			var selInt = _intVal( s );
	
			// Selector - all
			if ( s === '' ) {
				return _range( columns.length );
			}
	
			// Selector - index
			if ( selInt !== null ) {
				return [ selInt >= 0 ?
					selInt : // Count from left
					columns.length + selInt // Count from right (+ because its a negative value)
				];
			}
	
			// Selector = function
			if ( typeof s === 'function' ) {
				var rows = _selector_row_indexes( settings, opts );
	
				return $.map( columns, function (col, idx) {
					return s(
							idx,
							__columnData( settings, idx, 0, 0, rows ),
							nodes[ idx ]
						) ? idx : null;
				} );
			}
	
			// jQuery or string selector
			var match = typeof s === 'string' ?
				s.match( __re_column_selector ) :
				'';
	
			if ( match ) {
				switch( match[2] ) {
					case 'visIdx':
					case 'visible':
						var idx = parseInt( match[1], 10 );
						// Visible index given, convert to column index
						if ( idx < 0 ) {
							// Counting from the right
							var visColumns = $.map( columns, function (col,i) {
								return col.bVisible ? i : null;
							} );
							return [ visColumns[ visColumns.length + idx ] ];
						}
						// Counting from the left
						return [ _fnVisibleToColumnIndex( settings, idx ) ];
	
					case 'name':
						// match by name. `names` is column index complete and in order
						return $.map( names, function (name, i) {
							return name === match[1] ? i : null;
						} );
	
					default:
						return [];
				}
			}
	
			// Cell in the table body
			if ( s.nodeName && s._DT_CellIndex ) {
				return [ s._DT_CellIndex.column ];
			}
	
			// jQuery selector on the TH elements for the columns
			var jqResult = $( nodes )
				.filter( s )
				.map( function () {
					return $.inArray( this, nodes ); // `nodes` is column index complete and in order
				} )
				.toArray();
	
			if ( jqResult.length || ! s.nodeName ) {
				return jqResult;
			}
	
			// Otherwise a node which might have a `dt-column` data attribute, or be
			// a child or such an element
			var host = $(s).closest('*[data-dt-column]');
			return host.length ?
				[ host.data('dt-column') ] :
				[];
		};
	
		return _selector_run( 'column', selector, run, settings, opts );
	};
	
	
	var __setColumnVis = function ( settings, column, vis ) {
		var
			cols = settings.aoColumns,
			col  = cols[ column ],
			data = settings.aoData,
			row, cells, i, ien, tr;
	
		// Get
		if ( vis === undefined ) {
			return col.bVisible;
		}
	
		// Set
		// No change
		if ( col.bVisible === vis ) {
			return;
		}
	
		if ( vis ) {
			// Insert column
			// Need to decide if we should use appendChild or insertBefore
			var insertBefore = $.inArray( true, _pluck(cols, 'bVisible'), column+1 );
	
			for ( i=0, ien=data.length ; i<ien ; i++ ) {
				tr = data[i].nTr;
				cells = data[i].anCells;
	
				if ( tr ) {
					// insertBefore can act like appendChild if 2nd arg is null
					tr.insertBefore( cells[ column ], cells[ insertBefore ] || null );
				}
			}
		}
		else {
			// Remove column
			$( _pluck( settings.aoData, 'anCells', column ) ).detach();
		}
	
		// Common actions
		col.bVisible = vis;
		_fnDrawHead( settings, settings.aoHeader );
		_fnDrawHead( settings, settings.aoFooter );
	
		// Update colspan for no records display. Child rows and extensions will use their own
		// listeners to do this - only need to update the empty table item here
		if ( ! settings.aiDisplay.length ) {
			$(settings.nTBody).find('td[colspan]').attr('colspan', _fnVisbleColumns(settings));
		}
	
		_fnSaveState( settings );
	};
	
	
	_api_register( 'columns()', function ( selector, opts ) {
		// argument shifting
		if ( selector === undefined ) {
			selector = '';
		}
		else if ( $.isPlainObject( selector ) ) {
			opts = selector;
			selector = '';
		}
	
		opts = _selector_opts( opts );
	
		var inst = this.iterator( 'table', function ( settings ) {
			return __column_selector( settings, selector, opts );
		}, 1 );
	
		// Want argument shifting here and in _row_selector?
		inst.selector.cols = selector;
		inst.selector.opts = opts;
	
		return inst;
	} );
	
	_api_registerPlural( 'columns().header()', 'column().header()', function ( selector, opts ) {
		return this.iterator( 'column', function ( settings, column ) {
			return settings.aoColumns[column].nTh;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().footer()', 'column().footer()', function ( selector, opts ) {
		return this.iterator( 'column', function ( settings, column ) {
			return settings.aoColumns[column].nTf;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().data()', 'column().data()', function () {
		return this.iterator( 'column-rows', __columnData, 1 );
	} );
	
	_api_registerPlural( 'columns().dataSrc()', 'column().dataSrc()', function () {
		return this.iterator( 'column', function ( settings, column ) {
			return settings.aoColumns[column].mData;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().cache()', 'column().cache()', function ( type ) {
		return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
			return _pluck_order( settings.aoData, rows,
				type === 'search' ? '_aFilterData' : '_aSortData', column
			);
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().nodes()', 'column().nodes()', function () {
		return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
			return _pluck_order( settings.aoData, rows, 'anCells', column ) ;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().visible()', 'column().visible()', function ( vis, calc ) {
		var ret = this.iterator( 'column', function ( settings, column ) {
			if ( vis === undefined ) {
				return settings.aoColumns[ column ].bVisible;
			} // else
			__setColumnVis( settings, column, vis );
		} );
	
		// Group the column visibility changes
		if ( vis !== undefined ) {
			// Second loop once the first is done for events
			this.iterator( 'column', function ( settings, column ) {
				_fnCallbackFire( settings, null, 'column-visibility', [settings, column, vis, calc] );
			} );
	
			if ( calc === undefined || calc ) {
				this.columns.adjust();
			}
		}
	
		return ret;
	} );
	
	_api_registerPlural( 'columns().indexes()', 'column().index()', function ( type ) {
		return this.iterator( 'column', function ( settings, column ) {
			return type === 'visible' ?
				_fnColumnIndexToVisible( settings, column ) :
				column;
		}, 1 );
	} );
	
	_api_register( 'columns.adjust()', function () {
		return this.iterator( 'table', function ( settings ) {
			_fnAdjustColumnSizing( settings );
		}, 1 );
	} );
	
	_api_register( 'column.index()', function ( type, idx ) {
		if ( this.context.length !== 0 ) {
			var ctx = this.context[0];
	
			if ( type === 'fromVisible' || type === 'toData' ) {
				return _fnVisibleToColumnIndex( ctx, idx );
			}
			else if ( type === 'fromData' || type === 'toVisible' ) {
				return _fnColumnIndexToVisible( ctx, idx );
			}
		}
	} );
	
	_api_register( 'column()', function ( selector, opts ) {
		return _selector_first( this.columns( selector, opts ) );
	} );
	
	
	
	var __cell_selector = function ( settings, selector, opts )
	{
		var data = settings.aoData;
		var rows = _selector_row_indexes( settings, opts );
		var cells = _removeEmpty( _pluck_order( data, rows, 'anCells' ) );
		var allCells = $( [].concat.apply([], cells) );
		var row;
		var columns = settings.aoColumns.length;
		var a, i, ien, j, o, host;
	
		var run = function ( s ) {
			var fnSelector = typeof s === 'function';
	
			if ( s === null || s === undefined || fnSelector ) {
				// All cells and function selectors
				a = [];
	
				for ( i=0, ien=rows.length ; i<ien ; i++ ) {
					row = rows[i];
	
					for ( j=0 ; j<columns ; j++ ) {
						o = {
							row: row,
							column: j
						};
	
						if ( fnSelector ) {
							// Selector - function
							host = data[ row ];
	
							if ( s( o, _fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null ) ) {
								a.push( o );
							}
						}
						else {
							// Selector - all
							a.push( o );
						}
					}
				}
	
				return a;
			}
			
			// Selector - index
			if ( $.isPlainObject( s ) ) {
				// Valid cell index and its in the array of selectable rows
				return s.column !== undefined && s.row !== undefined && $.inArray( s.row, rows ) !== -1 ?
					[s] :
					[];
			}
	
			// Selector - jQuery filtered cells
			var jqResult = allCells
				.filter( s )
				.map( function (i, el) {
					return { // use a new object, in case someone changes the values
						row:    el._DT_CellIndex.row,
						column: el._DT_CellIndex.column
	 				};
				} )
				.toArray();
	
			if ( jqResult.length || ! s.nodeName ) {
				return jqResult;
			}
	
			// Otherwise the selector is a node, and there is one last option - the
			// element might be a child of an element which has dt-row and dt-column
			// data attributes
			host = $(s).closest('*[data-dt-row]');
			return host.length ?
				[ {
					row: host.data('dt-row'),
					column: host.data('dt-column')
				} ] :
				[];
		};
	
		return _selector_run( 'cell', selector, run, settings, opts );
	};
	
	
	
	
	_api_register( 'cells()', function ( rowSelector, columnSelector, opts ) {
		// Argument shifting
		if ( $.isPlainObject( rowSelector ) ) {
			// Indexes
			if ( rowSelector.row === undefined ) {
				// Selector options in first parameter
				opts = rowSelector;
				rowSelector = null;
			}
			else {
				// Cell index objects in first parameter
				opts = columnSelector;
				columnSelector = null;
			}
		}
		if ( $.isPlainObject( columnSelector ) ) {
			opts = columnSelector;
			columnSelector = null;
		}
	
		// Cell selector
		if ( columnSelector === null || columnSelector === undefined ) {
			return this.iterator( 'table', function ( settings ) {
				return __cell_selector( settings, rowSelector, _selector_opts( opts ) );
			} );
		}
	
		// Row + column selector
		var columns = this.columns( columnSelector );
		var rows = this.rows( rowSelector );
		var a, i, ien, j, jen;
	
		this.iterator( 'table', function ( settings, idx ) {
			a = [];
	
			for ( i=0, ien=rows[idx].length ; i<ien ; i++ ) {
				for ( j=0, jen=columns[idx].length ; j<jen ; j++ ) {
					a.push( {
						row:    rows[idx][i],
						column: columns[idx][j]
					} );
				}
			}
		}, 1 );
	
	    // Now pass through the cell selector for options
	    var cells = this.cells( a, opts );
	
		$.extend( cells.selector, {
			cols: columnSelector,
			rows: rowSelector,
			opts: opts
		} );
	
		return cells;
	} );
	
	
	_api_registerPlural( 'cells().nodes()', 'cell().node()', function () {
		return this.iterator( 'cell', function ( settings, row, column ) {
			var data = settings.aoData[ row ];
	
			return data && data.anCells ?
				data.anCells[ column ] :
				undefined;
		}, 1 );
	} );
	
	
	_api_register( 'cells().data()', function () {
		return this.iterator( 'cell', function ( settings, row, column ) {
			return _fnGetCellData( settings, row, column );
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().cache()', 'cell().cache()', function ( type ) {
		type = type === 'search' ? '_aFilterData' : '_aSortData';
	
		return this.iterator( 'cell', function ( settings, row, column ) {
			return settings.aoData[ row ][ type ][ column ];
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().render()', 'cell().render()', function ( type ) {
		return this.iterator( 'cell', function ( settings, row, column ) {
			return _fnGetCellData( settings, row, column, type );
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().indexes()', 'cell().index()', function () {
		return this.iterator( 'cell', function ( settings, row, column ) {
			return {
				row: row,
				column: column,
				columnVisible: _fnColumnIndexToVisible( settings, column )
			};
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().invalidate()', 'cell().invalidate()', function ( src ) {
		return this.iterator( 'cell', function ( settings, row, column ) {
			_fnInvalidate( settings, row, src, column );
		} );
	} );
	
	
	
	_api_register( 'cell()', function ( rowSelector, columnSelector, opts ) {
		return _selector_first( this.cells( rowSelector, columnSelector, opts ) );
	} );
	
	
	_api_register( 'cell().data()', function ( data ) {
		var ctx = this.context;
		var cell = this[0];
	
		if ( data === undefined ) {
			// Get
			return ctx.length && cell.length ?
				_fnGetCellData( ctx[0], cell[0].row, cell[0].column ) :
				undefined;
		}
	
		// Set
		_fnSetCellData( ctx[0], cell[0].row, cell[0].column, data );
		_fnInvalidate( ctx[0], cell[0].row, 'data', cell[0].column );
	
		return this;
	} );
	
	
	
	/**
	 * Get current ordering (sorting) that has been applied to the table.
	 *
	 * @returns {array} 2D array containing the sorting information for the first
	 *   table in the current context. Each element in the parent array represents
	 *   a column being sorted upon (i.e. multi-sorting with two columns would have
	 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
	 *   the column index that the sorting condition applies to, the second is the
	 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
	 *   index of the sorting order from the `column.sorting` initialisation array.
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {integer} order Column index to sort upon.
	 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
	 * @returns {DataTables.Api} this
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {array} order 1D array of sorting information to be applied.
	 * @param {array} [...] Optional additional sorting conditions
	 * @returns {DataTables.Api} this
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {array} order 2D array of sorting information to be applied.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'order()', function ( order, dir ) {
		var ctx = this.context;
	
		if ( order === undefined ) {
			// get
			return ctx.length !== 0 ?
				ctx[0].aaSorting :
				undefined;
		}
	
		// set
		if ( typeof order === 'number' ) {
			// Simple column / direction passed in
			order = [ [ order, dir ] ];
		}
		else if ( order.length && ! $.isArray( order[0] ) ) {
			// Arguments passed in (list of 1D arrays)
			order = Array.prototype.slice.call( arguments );
		}
		// otherwise a 2D array was passed in
	
		return this.iterator( 'table', function ( settings ) {
			settings.aaSorting = order.slice();
		} );
	} );
	
	
	/**
	 * Attach a sort listener to an element for a given column
	 *
	 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
	 *   listener to. This can take the form of a single DOM node, a jQuery
	 *   collection of nodes or a jQuery selector which will identify the node(s).
	 * @param {integer} column the column that a click on this node will sort on
	 * @param {function} [callback] callback function when sort is run
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'order.listener()', function ( node, column, callback ) {
		return this.iterator( 'table', function ( settings ) {
			_fnSortAttachListener( settings, node, column, callback );
		} );
	} );
	
	
	_api_register( 'order.fixed()', function ( set ) {
		if ( ! set ) {
			var ctx = this.context;
			var fixed = ctx.length ?
				ctx[0].aaSortingFixed :
				undefined;
	
			return $.isArray( fixed ) ?
				{ pre: fixed } :
				fixed;
		}
	
		return this.iterator( 'table', function ( settings ) {
			settings.aaSortingFixed = $.extend( true, {}, set );
		} );
	} );
	
	
	// Order by the selected column(s)
	_api_register( [
		'columns().order()',
		'column().order()'
	], function ( dir ) {
		var that = this;
	
		return this.iterator( 'table', function ( settings, i ) {
			var sort = [];
	
			$.each( that[i], function (j, col) {
				sort.push( [ col, dir ] );
			} );
	
			settings.aaSorting = sort;
		} );
	} );
	
	
	
	_api_register( 'search()', function ( input, regex, smart, caseInsen ) {
		var ctx = this.context;
	
		if ( input === undefined ) {
			// get
			return ctx.length !== 0 ?
				ctx[0].oPreviousSearch.sSearch :
				undefined;
		}
	
		// set
		return this.iterator( 'table', function ( settings ) {
			if ( ! settings.oFeatures.bFilter ) {
				return;
			}
	
			_fnFilterComplete( settings, $.extend( {}, settings.oPreviousSearch, {
				"sSearch": input+"",
				"bRegex":  regex === null ? false : regex,
				"bSmart":  smart === null ? true  : smart,
				"bCaseInsensitive": caseInsen === null ? true : caseInsen
			} ), 1 );
		} );
	} );
	
	
	_api_registerPlural(
		'columns().search()',
		'column().search()',
		function ( input, regex, smart, caseInsen ) {
			return this.iterator( 'column', function ( settings, column ) {
				var preSearch = settings.aoPreSearchCols;
	
				if ( input === undefined ) {
					// get
					return preSearch[ column ].sSearch;
				}
	
				// set
				if ( ! settings.oFeatures.bFilter ) {
					return;
				}
	
				$.extend( preSearch[ column ], {
					"sSearch": input+"",
					"bRegex":  regex === null ? false : regex,
					"bSmart":  smart === null ? true  : smart,
					"bCaseInsensitive": caseInsen === null ? true : caseInsen
				} );
	
				_fnFilterComplete( settings, settings.oPreviousSearch, 1 );
			} );
		}
	);
	
	/*
	 * State API methods
	 */
	
	_api_register( 'state()', function () {
		return this.context.length ?
			this.context[0].oSavedState :
			null;
	} );
	
	
	_api_register( 'state.clear()', function () {
		return this.iterator( 'table', function ( settings ) {
			// Save an empty object
			settings.fnStateSaveCallback.call( settings.oInstance, settings, {} );
		} );
	} );
	
	
	_api_register( 'state.loaded()', function () {
		return this.context.length ?
			this.context[0].oLoadedState :
			null;
	} );
	
	
	_api_register( 'state.save()', function () {
		return this.iterator( 'table', function ( settings ) {
			_fnSaveState( settings );
		} );
	} );
	
	
	
	/**
	 * Provide a common method for plug-ins to check the version of DataTables being
	 * used, in order to ensure compatibility.
	 *
	 *  @param {string} version Version string to check for, in the format "X.Y.Z".
	 *    Note that the formats "X" and "X.Y" are also acceptable.
	 *  @returns {boolean} true if this version of DataTables is greater or equal to
	 *    the required version, or false if this version of DataTales is not
	 *    suitable
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
	 */
	DataTable.versionCheck = DataTable.fnVersionCheck = function( version )
	{
		var aThis = DataTable.version.split('.');
		var aThat = version.split('.');
		var iThis, iThat;
	
		for ( var i=0, iLen=aThat.length ; i<iLen ; i++ ) {
			iThis = parseInt( aThis[i], 10 ) || 0;
			iThat = parseInt( aThat[i], 10 ) || 0;
	
			// Parts are the same, keep comparing
			if (iThis === iThat) {
				continue;
			}
	
			// Parts are different, return immediately
			return iThis > iThat;
		}
	
		return true;
	};
	
	
	/**
	 * Check if a `<table>` node is a DataTable table already or not.
	 *
	 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
	 *      selector for the table to test. Note that if more than more than one
	 *      table is passed on, only the first will be checked
	 *  @returns {boolean} true the table given is a DataTable, or false otherwise
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
	 *      $('#example').dataTable();
	 *    }
	 */
	DataTable.isDataTable = DataTable.fnIsDataTable = function ( table )
	{
		var t = $(table).get(0);
		var is = false;
	
		if ( table instanceof DataTable.Api ) {
			return true;
		}
	
		$.each( DataTable.settings, function (i, o) {
			var head = o.nScrollHead ? $('table', o.nScrollHead)[0] : null;
			var foot = o.nScrollFoot ? $('table', o.nScrollFoot)[0] : null;
	
			if ( o.nTable === t || head === t || foot === t ) {
				is = true;
			}
		} );
	
		return is;
	};
	
	
	/**
	 * Get all DataTable tables that have been initialised - optionally you can
	 * select to get only currently visible tables.
	 *
	 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
	 *    or visible tables only.
	 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
	 *    DataTables
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    $.each( $.fn.dataTable.tables(true), function () {
	 *      $(table).DataTable().columns.adjust();
	 *    } );
	 */
	DataTable.tables = DataTable.fnTables = function ( visible )
	{
		var api = false;
	
		if ( $.isPlainObject( visible ) ) {
			api = visible.api;
			visible = visible.visible;
		}
	
		var a = $.map( DataTable.settings, function (o) {
			if ( !visible || (visible && $(o.nTable).is(':visible')) ) {
				return o.nTable;
			}
		} );
	
		return api ?
			new _Api( a ) :
			a;
	};
	
	
	/**
	 * Convert from camel case parameters to Hungarian notation. This is made public
	 * for the extensions to provide the same ability as DataTables core to accept
	 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
	 * parameters.
	 *
	 *  @param {object} src The model object which holds all parameters that can be
	 *    mapped.
	 *  @param {object} user The object to convert from camel case to Hungarian.
	 *  @param {boolean} force When set to `true`, properties which already have a
	 *    Hungarian value in the `user` object will be overwritten. Otherwise they
	 *    won't be.
	 */
	DataTable.camelToHungarian = _fnCamelToHungarian;
	
	
	
	/**
	 *
	 */
	_api_register( '$()', function ( selector, opts ) {
		var
			rows   = this.rows( opts ).nodes(), // Get all rows
			jqRows = $(rows);
	
		return $( [].concat(
			jqRows.filter( selector ).toArray(),
			jqRows.find( selector ).toArray()
		) );
	} );
	
	
	// jQuery functions to operate on the tables
	$.each( [ 'on', 'one', 'off' ], function (i, key) {
		_api_register( key+'()', function ( /* event, handler */ ) {
			var args = Array.prototype.slice.call(arguments);
	
			// Add the `dt` namespace automatically if it isn't already present
			args[0] = $.map( args[0].split( /\s/ ), function ( e ) {
				return ! e.match(/\.dt\b/) ?
					e+'.dt' :
					e;
				} ).join( ' ' );
	
			var inst = $( this.tables().nodes() );
			inst[key].apply( inst, args );
			return this;
		} );
	} );
	
	
	_api_register( 'clear()', function () {
		return this.iterator( 'table', function ( settings ) {
			_fnClearTable( settings );
		} );
	} );
	
	
	_api_register( 'settings()', function () {
		return new _Api( this.context, this.context );
	} );
	
	
	_api_register( 'init()', function () {
		var ctx = this.context;
		return ctx.length ? ctx[0].oInit : null;
	} );
	
	
	_api_register( 'data()', function () {
		return this.iterator( 'table', function ( settings ) {
			return _pluck( settings.aoData, '_aData' );
		} ).flatten();
	} );
	
	
	_api_register( 'destroy()', function ( remove ) {
		remove = remove || false;
	
		return this.iterator( 'table', function ( settings ) {
			var orig      = settings.nTableWrapper.parentNode;
			var classes   = settings.oClasses;
			var table     = settings.nTable;
			var tbody     = settings.nTBody;
			var thead     = settings.nTHead;
			var tfoot     = settings.nTFoot;
			var jqTable   = $(table);
			var jqTbody   = $(tbody);
			var jqWrapper = $(settings.nTableWrapper);
			var rows      = $.map( settings.aoData, function (r) { return r.nTr; } );
			var i, ien;
	
			// Flag to note that the table is currently being destroyed - no action
			// should be taken
			settings.bDestroying = true;
	
			// Fire off the destroy callbacks for plug-ins etc
			_fnCallbackFire( settings, "aoDestroyCallback", "destroy", [settings] );
	
			// If not being removed from the document, make all columns visible
			if ( ! remove ) {
				new _Api( settings ).columns().visible( true );
			}
	
			// Blitz all `DT` namespaced events (these are internal events, the
			// lowercase, `dt` events are user subscribed and they are responsible
			// for removing them
			jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
			$(window).off('.DT-'+settings.sInstance);
	
			// When scrolling we had to break the table up - restore it
			if ( table != thead.parentNode ) {
				jqTable.children('thead').detach();
				jqTable.append( thead );
			}
	
			if ( tfoot && table != tfoot.parentNode ) {
				jqTable.children('tfoot').detach();
				jqTable.append( tfoot );
			}
	
			settings.aaSorting = [];
			settings.aaSortingFixed = [];
			_fnSortingClasses( settings );
	
			$( rows ).removeClass( settings.asStripeClasses.join(' ') );
	
			$('th, td', thead).removeClass( classes.sSortable+' '+
				classes.sSortableAsc+' '+classes.sSortableDesc+' '+classes.sSortableNone
			);
	
			// Add the TR elements back into the table in their original order
			jqTbody.children().detach();
			jqTbody.append( rows );
	
			// Remove the DataTables generated nodes, events and classes
			var removedMethod = remove ? 'remove' : 'detach';
			jqTable[ removedMethod ]();
			jqWrapper[ removedMethod ]();
	
			// If we need to reattach the table to the document
			if ( ! remove && orig ) {
				// insertBefore acts like appendChild if !arg[1]
				orig.insertBefore( table, settings.nTableReinsertBefore );
	
				// Restore the width of the original table - was read from the style property,
				// so we can restore directly to that
				jqTable
					.css( 'width', settings.sDestroyWidth )
					.removeClass( classes.sTable );
	
				// If the were originally stripe classes - then we add them back here.
				// Note this is not fool proof (for example if not all rows had stripe
				// classes - but it's a good effort without getting carried away
				ien = settings.asDestroyStripes.length;
	
				if ( ien ) {
					jqTbody.children().each( function (i) {
						$(this).addClass( settings.asDestroyStripes[i % ien] );
					} );
				}
			}
	
			/* Remove the settings object from the settings array */
			var idx = $.inArray( settings, DataTable.settings );
			if ( idx !== -1 ) {
				DataTable.settings.splice( idx, 1 );
			}
		} );
	} );
	
	
	// Add the `every()` method for rows, columns and cells in a compact form
	$.each( [ 'column', 'row', 'cell' ], function ( i, type ) {
		_api_register( type+'s().every()', function ( fn ) {
			var opts = this.selector.opts;
			var api = this;
	
			return this.iterator( type, function ( settings, arg1, arg2, arg3, arg4 ) {
				// Rows and columns:
				//  arg1 - index
				//  arg2 - table counter
				//  arg3 - loop counter
				//  arg4 - undefined
				// Cells:
				//  arg1 - row index
				//  arg2 - column index
				//  arg3 - table counter
				//  arg4 - loop counter
				fn.call(
					api[ type ](
						arg1,
						type==='cell' ? arg2 : opts,
						type==='cell' ? opts : undefined
					),
					arg1, arg2, arg3, arg4
				);
			} );
		} );
	} );
	
	
	// i18n method for extensions to be able to use the language object from the
	// DataTable
	_api_register( 'i18n()', function ( token, def, plural ) {
		var ctx = this.context[0];
		var resolved = _fnGetObjectDataFn( token )( ctx.oLanguage );
	
		if ( resolved === undefined ) {
			resolved = def;
		}
	
		if ( plural !== undefined && $.isPlainObject( resolved ) ) {
			resolved = resolved[ plural ] !== undefined ?
				resolved[ plural ] :
				resolved._;
		}
	
		return resolved.replace( '%d', plural ); // nb: plural might be undefined,
	} );
	/**
	 * Version string for plug-ins to check compatibility. Allowed format is
	 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
	 * only for non-release builds. See http://semver.org/ for more information.
	 *  @member
	 *  @type string
	 *  @default Version number
	 */
	DataTable.version = "1.10.19";

	/**
	 * Private data store, containing all of the settings objects that are
	 * created for the tables on a given page.
	 *
	 * Note that the `DataTable.settings` object is aliased to
	 * `jQuery.fn.dataTableExt` through which it may be accessed and
	 * manipulated, or `jQuery.fn.dataTable.settings`.
	 *  @member
	 *  @type array
	 *  @default []
	 *  @private
	 */
	DataTable.settings = [];

	/**
	 * Object models container, for the various models that DataTables has
	 * available to it. These models define the objects that are used to hold
	 * the active state and configuration of the table.
	 *  @namespace
	 */
	DataTable.models = {};
	
	
	
	/**
	 * Template object for the way in which DataTables holds information about
	 * search information for the global filter and individual column filters.
	 *  @namespace
	 */
	DataTable.models.oSearch = {
		/**
		 * Flag to indicate if the filtering should be case insensitive or not
		 *  @type boolean
		 *  @default true
		 */
		"bCaseInsensitive": true,
	
		/**
		 * Applied search term
		 *  @type string
		 *  @default <i>Empty string</i>
		 */
		"sSearch": "",
	
		/**
		 * Flag to indicate if the search term should be interpreted as a
		 * regular expression (true) or not (false) and therefore and special
		 * regex characters escaped.
		 *  @type boolean
		 *  @default false
		 */
		"bRegex": false,
	
		/**
		 * Flag to indicate if DataTables is to use its smart filtering or not.
		 *  @type boolean
		 *  @default true
		 */
		"bSmart": true
	};
	
	
	
	
	/**
	 * Template object for the way in which DataTables holds information about
	 * each individual row. This is the object format used for the settings
	 * aoData array.
	 *  @namespace
	 */
	DataTable.models.oRow = {
		/**
		 * TR element for the row
		 *  @type node
		 *  @default null
		 */
		"nTr": null,
	
		/**
		 * Array of TD elements for each row. This is null until the row has been
		 * created.
		 *  @type array nodes
		 *  @default []
		 */
		"anCells": null,
	
		/**
		 * Data object from the original data source for the row. This is either
		 * an array if using the traditional form of DataTables, or an object if
		 * using mData options. The exact type will depend on the passed in
		 * data from the data source, or will be an array if using DOM a data
		 * source.
		 *  @type array|object
		 *  @default []
		 */
		"_aData": [],
	
		/**
		 * Sorting data cache - this array is ostensibly the same length as the
		 * number of columns (although each index is generated only as it is
		 * needed), and holds the data that is used for sorting each column in the
		 * row. We do this cache generation at the start of the sort in order that
		 * the formatting of the sort data need be done only once for each cell
		 * per sort. This array should not be read from or written to by anything
		 * other than the master sorting methods.
		 *  @type array
		 *  @default null
		 *  @private
		 */
		"_aSortData": null,
	
		/**
		 * Per cell filtering data cache. As per the sort data cache, used to
		 * increase the performance of the filtering in DataTables
		 *  @type array
		 *  @default null
		 *  @private
		 */
		"_aFilterData": null,
	
		/**
		 * Filtering data cache. This is the same as the cell filtering cache, but
		 * in this case a string rather than an array. This is easily computed with
		 * a join on `_aFilterData`, but is provided as a cache so the join isn't
		 * needed on every search (memory traded for performance)
		 *  @type array
		 *  @default null
		 *  @private
		 */
		"_sFilterRow": null,
	
		/**
		 * Cache of the class name that DataTables has applied to the row, so we
		 * can quickly look at this variable rather than needing to do a DOM check
		 * on className for the nTr property.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *  @private
		 */
		"_sRowStripe": "",
	
		/**
		 * Denote if the original data source was from the DOM, or the data source
		 * object. This is used for invalidating data, so DataTables can
		 * automatically read data from the original source, unless uninstructed
		 * otherwise.
		 *  @type string
		 *  @default null
		 *  @private
		 */
		"src": null,
	
		/**
		 * Index in the aoData array. This saves an indexOf lookup when we have the
		 * object, but want to know the index
		 *  @type integer
		 *  @default -1
		 *  @private
		 */
		"idx": -1
	};
	
	
	/**
	 * Template object for the column information object in DataTables. This object
	 * is held in the settings aoColumns array and contains all the information that
	 * DataTables needs about each individual column.
	 *
	 * Note that this object is related to {@link DataTable.defaults.column}
	 * but this one is the internal data store for DataTables's cache of columns.
	 * It should NOT be manipulated outside of DataTables. Any configuration should
	 * be done through the initialisation options.
	 *  @namespace
	 */
	DataTable.models.oColumn = {
		/**
		 * Column index. This could be worked out on-the-fly with $.inArray, but it
		 * is faster to just hold it as a variable
		 *  @type integer
		 *  @default null
		 */
		"idx": null,
	
		/**
		 * A list of the columns that sorting should occur on when this column
		 * is sorted. That this property is an array allows multi-column sorting
		 * to be defined for a column (for example first name / last name columns
		 * would benefit from this). The values are integers pointing to the
		 * columns to be sorted on (typically it will be a single integer pointing
		 * at itself, but that doesn't need to be the case).
		 *  @type array
		 */
		"aDataSort": null,
	
		/**
		 * Define the sorting directions that are applied to the column, in sequence
		 * as the column is repeatedly sorted upon - i.e. the first value is used
		 * as the sorting direction when the column if first sorted (clicked on).
		 * Sort it again (click again) and it will move on to the next index.
		 * Repeat until loop.
		 *  @type array
		 */
		"asSorting": null,
	
		/**
		 * Flag to indicate if the column is searchable, and thus should be included
		 * in the filtering or not.
		 *  @type boolean
		 */
		"bSearchable": null,
	
		/**
		 * Flag to indicate if the column is sortable or not.
		 *  @type boolean
		 */
		"bSortable": null,
	
		/**
		 * Flag to indicate if the column is currently visible in the table or not
		 *  @type boolean
		 */
		"bVisible": null,
	
		/**
		 * Store for manual type assignment using the `column.type` option. This
		 * is held in store so we can manipulate the column's `sType` property.
		 *  @type string
		 *  @default null
		 *  @private
		 */
		"_sManualType": null,
	
		/**
		 * Flag to indicate if HTML5 data attributes should be used as the data
		 * source for filtering or sorting. True is either are.
		 *  @type boolean
		 *  @default false
		 *  @private
		 */
		"_bAttrSrc": false,
	
		/**
		 * Developer definable function that is called whenever a cell is created (Ajax source,
		 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
		 * allowing you to modify the DOM element (add background colour for example) when the
		 * element is available.
		 *  @type function
		 *  @param {element} nTd The TD node that has been created
		 *  @param {*} sData The Data for the cell
		 *  @param {array|object} oData The data for the whole row
		 *  @param {int} iRow The row index for the aoData data store
		 *  @default null
		 */
		"fnCreatedCell": null,
	
		/**
		 * Function to get data from a cell in a column. You should <b>never</b>
		 * access data directly through _aData internally in DataTables - always use
		 * the method attached to this property. It allows mData to function as
		 * required. This function is automatically assigned by the column
		 * initialisation method
		 *  @type function
		 *  @param {array|object} oData The data array/object for the array
		 *    (i.e. aoData[]._aData)
		 *  @param {string} sSpecific The specific data type you want to get -
		 *    'display', 'type' 'filter' 'sort'
		 *  @returns {*} The data for the cell from the given row's data
		 *  @default null
		 */
		"fnGetData": null,
	
		/**
		 * Function to set data for a cell in the column. You should <b>never</b>
		 * set the data directly to _aData internally in DataTables - always use
		 * this method. It allows mData to function as required. This function
		 * is automatically assigned by the column initialisation method
		 *  @type function
		 *  @param {array|object} oData The data array/object for the array
		 *    (i.e. aoData[]._aData)
		 *  @param {*} sValue Value to set
		 *  @default null
		 */
		"fnSetData": null,
	
		/**
		 * Property to read the value for the cells in the column from the data
		 * source array / object. If null, then the default content is used, if a
		 * function is given then the return from the function is used.
		 *  @type function|int|string|null
		 *  @default null
		 */
		"mData": null,
	
		/**
		 * Partner property to mData which is used (only when defined) to get
		 * the data - i.e. it is basically the same as mData, but without the
		 * 'set' option, and also the data fed to it is the result from mData.
		 * This is the rendering method to match the data method of mData.
		 *  @type function|int|string|null
		 *  @default null
		 */
		"mRender": null,
	
		/**
		 * Unique header TH/TD element for this column - this is what the sorting
		 * listener is attached to (if sorting is enabled.)
		 *  @type node
		 *  @default null
		 */
		"nTh": null,
	
		/**
		 * Unique footer TH/TD element for this column (if there is one). Not used
		 * in DataTables as such, but can be used for plug-ins to reference the
		 * footer for each column.
		 *  @type node
		 *  @default null
		 */
		"nTf": null,
	
		/**
		 * The class to apply to all TD elements in the table's TBODY for the column
		 *  @type string
		 *  @default null
		 */
		"sClass": null,
	
		/**
		 * When DataTables calculates the column widths to assign to each column,
		 * it finds the longest string in each column and then constructs a
		 * temporary table and reads the widths from that. The problem with this
		 * is that "mmm" is much wider then "iiii", but the latter is a longer
		 * string - thus the calculation can go wrong (doing it properly and putting
		 * it into an DOM object and measuring that is horribly(!) slow). Thus as
		 * a "work around" we provide this option. It will append its value to the
		 * text that is found to be the longest string for the column - i.e. padding.
		 *  @type string
		 */
		"sContentPadding": null,
	
		/**
		 * Allows a default value to be given for a column's data, and will be used
		 * whenever a null data source is encountered (this can be because mData
		 * is set to null, or because the data source itself is null).
		 *  @type string
		 *  @default null
		 */
		"sDefaultContent": null,
	
		/**
		 * Name for the column, allowing reference to the column by name as well as
		 * by index (needs a lookup to work by name).
		 *  @type string
		 */
		"sName": null,
	
		/**
		 * Custom sorting data type - defines which of the available plug-ins in
		 * afnSortData the custom sorting will use - if any is defined.
		 *  @type string
		 *  @default std
		 */
		"sSortDataType": 'std',
	
		/**
		 * Class to be applied to the header element when sorting on this column
		 *  @type string
		 *  @default null
		 */
		"sSortingClass": null,
	
		/**
		 * Class to be applied to the header element when sorting on this column -
		 * when jQuery UI theming is used.
		 *  @type string
		 *  @default null
		 */
		"sSortingClassJUI": null,
	
		/**
		 * Title of the column - what is seen in the TH element (nTh).
		 *  @type string
		 */
		"sTitle": null,
	
		/**
		 * Column sorting and filtering type
		 *  @type string
		 *  @default null
		 */
		"sType": null,
	
		/**
		 * Width of the column
		 *  @type string
		 *  @default null
		 */
		"sWidth": null,
	
		/**
		 * Width of the column when it was first "encountered"
		 *  @type string
		 *  @default null
		 */
		"sWidthOrig": null
	};
	
	
	/*
	 * Developer note: The properties of the object below are given in Hungarian
	 * notation, that was used as the interface for DataTables prior to v1.10, however
	 * from v1.10 onwards the primary interface is camel case. In order to avoid
	 * breaking backwards compatibility utterly with this change, the Hungarian
	 * version is still, internally the primary interface, but is is not documented
	 * - hence the @name tags in each doc comment. This allows a Javascript function
	 * to create a map from Hungarian notation to camel case (going the other direction
	 * would require each property to be listed, which would at around 3K to the size
	 * of DataTables, while this method is about a 0.5K hit.
	 *
	 * Ultimately this does pave the way for Hungarian notation to be dropped
	 * completely, but that is a massive amount of work and will break current
	 * installs (therefore is on-hold until v2).
	 */
	
	/**
	 * Initialisation options that can be given to DataTables at initialisation
	 * time.
	 *  @namespace
	 */
	DataTable.defaults = {
		/**
		 * An array of data to use for the table, passed in at initialisation which
		 * will be used in preference to any data which is already in the DOM. This is
		 * particularly useful for constructing tables purely in Javascript, for
		 * example with a custom Ajax call.
		 *  @type array
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.data
		 *
		 *  @example
		 *    // Using a 2D array data source
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "data": [
		 *          ['Trident', 'Internet Explorer 4.0', 'Win 95+', 4, 'X'],
		 *          ['Trident', 'Internet Explorer 5.0', 'Win 95+', 5, 'C'],
		 *        ],
		 *        "columns": [
		 *          { "title": "Engine" },
		 *          { "title": "Browser" },
		 *          { "title": "Platform" },
		 *          { "title": "Version" },
		 *          { "title": "Grade" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using an array of objects as a data source (`data`)
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "data": [
		 *          {
		 *            "engine":   "Trident",
		 *            "browser":  "Internet Explorer 4.0",
		 *            "platform": "Win 95+",
		 *            "version":  4,
		 *            "grade":    "X"
		 *          },
		 *          {
		 *            "engine":   "Trident",
		 *            "browser":  "Internet Explorer 5.0",
		 *            "platform": "Win 95+",
		 *            "version":  5,
		 *            "grade":    "C"
		 *          }
		 *        ],
		 *        "columns": [
		 *          { "title": "Engine",   "data": "engine" },
		 *          { "title": "Browser",  "data": "browser" },
		 *          { "title": "Platform", "data": "platform" },
		 *          { "title": "Version",  "data": "version" },
		 *          { "title": "Grade",    "data": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 */
		"aaData": null,
	
	
		/**
		 * If ordering is enabled, then DataTables will perform a first pass sort on
		 * initialisation. You can define which column(s) the sort is performed
		 * upon, and the sorting direction, with this variable. The `sorting` array
		 * should contain an array for each column to be sorted initially containing
		 * the column's index and a direction string ('asc' or 'desc').
		 *  @type array
		 *  @default [[0,'asc']]
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.order
		 *
		 *  @example
		 *    // Sort by 3rd column first, and then 4th column
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "order": [[2,'asc'], [3,'desc']]
		 *      } );
		 *    } );
		 *
		 *    // No initial sorting
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "order": []
		 *      } );
		 *    } );
		 */
		"aaSorting": [[0,'asc']],
	
	
		/**
		 * This parameter is basically identical to the `sorting` parameter, but
		 * cannot be overridden by user interaction with the table. What this means
		 * is that you could have a column (visible or hidden) which the sorting
		 * will always be forced on first - any sorting after that (from the user)
		 * will then be performed as required. This can be useful for grouping rows
		 * together.
		 *  @type array
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.orderFixed
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "orderFixed": [[0,'asc']]
		 *      } );
		 *    } )
		 */
		"aaSortingFixed": [],
	
	
		/**
		 * DataTables can be instructed to load data to display in the table from a
		 * Ajax source. This option defines how that Ajax call is made and where to.
		 *
		 * The `ajax` property has three different modes of operation, depending on
		 * how it is defined. These are:
		 *
		 * * `string` - Set the URL from where the data should be loaded from.
		 * * `object` - Define properties for `jQuery.ajax`.
		 * * `function` - Custom data get function
		 *
		 * `string`
		 * --------
		 *
		 * As a string, the `ajax` property simply defines the URL from which
		 * DataTables will load data.
		 *
		 * `object`
		 * --------
		 *
		 * As an object, the parameters in the object are passed to
		 * [jQuery.ajax](http://api.jquery.com/jQuery.ajax/) allowing fine control
		 * of the Ajax request. DataTables has a number of default parameters which
		 * you can override using this option. Please refer to the jQuery
		 * documentation for a full description of the options available, although
		 * the following parameters provide additional options in DataTables or
		 * require special consideration:
		 *
		 * * `data` - As with jQuery, `data` can be provided as an object, but it
		 *   can also be used as a function to manipulate the data DataTables sends
		 *   to the server. The function takes a single parameter, an object of
		 *   parameters with the values that DataTables has readied for sending. An
		 *   object may be returned which will be merged into the DataTables
		 *   defaults, or you can add the items to the object that was passed in and
		 *   not return anything from the function. This supersedes `fnServerParams`
		 *   from DataTables 1.9-.
		 *
		 * * `dataSrc` - By default DataTables will look for the property `data` (or
		 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
		 *   from an Ajax source or for server-side processing - this parameter
		 *   allows that property to be changed. You can use Javascript dotted
		 *   object notation to get a data source for multiple levels of nesting, or
		 *   it my be used as a function. As a function it takes a single parameter,
		 *   the JSON returned from the server, which can be manipulated as
		 *   required, with the returned value being that used by DataTables as the
		 *   data source for the table. This supersedes `sAjaxDataProp` from
		 *   DataTables 1.9-.
		 *
		 * * `success` - Should not be overridden it is used internally in
		 *   DataTables. To manipulate / transform the data returned by the server
		 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
		 *
		 * `function`
		 * ----------
		 *
		 * As a function, making the Ajax call is left up to yourself allowing
		 * complete control of the Ajax request. Indeed, if desired, a method other
		 * than Ajax could be used to obtain the required data, such as Web storage
		 * or an AIR database.
		 *
		 * The function is given four parameters and no return is required. The
		 * parameters are:
		 *
		 * 1. _object_ - Data to send to the server
		 * 2. _function_ - Callback function that must be executed when the required
		 *    data has been obtained. That data should be passed into the callback
		 *    as the only parameter
		 * 3. _object_ - DataTables settings object for the table
		 *
		 * Note that this supersedes `fnServerData` from DataTables 1.9-.
		 *
		 *  @type string|object|function
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.ajax
		 *  @since 1.10.0
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax.
		 *   // Note DataTables expects data in the form `{ data: [ ...data... ] }` by default).
		 *   $('#example').dataTable( {
		 *     "ajax": "data.json"
		 *   } );
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax, using `dataSrc` to change
		 *   // `data` to `tableData` (i.e. `{ tableData: [ ...data... ] }`)
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": "tableData"
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax, using `dataSrc` to read data
		 *   // from a plain array rather than an array in an object
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": ""
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Manipulate the data returned from the server - add a link to data
		 *   // (note this can, should, be done using `render` for the column - this
		 *   // is just a simple example of how the data can be manipulated).
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": function ( json ) {
		 *         for ( var i=0, ien=json.length ; i<ien ; i++ ) {
		 *           json[i][0] = '<a href="/message/'+json[i][0]+'>View message</a>';
		 *         }
		 *         return json;
		 *       }
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Add data to the request
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "data": function ( d ) {
		 *         return {
		 *           "extra_search": $('#extra').val()
		 *         };
		 *       }
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Send request as POST
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "type": "POST"
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Get the data from localStorage (could interface with a form for
		 *   // adding, editing and removing rows).
		 *   $('#example').dataTable( {
		 *     "ajax": function (data, callback, settings) {
		 *       callback(
		 *         JSON.parse( localStorage.getItem('dataTablesData') )
		 *       );
		 *     }
		 *   } );
		 */
		"ajax": null,
	
	
		/**
		 * This parameter allows you to readily specify the entries in the length drop
		 * down menu that DataTables shows when pagination is enabled. It can be
		 * either a 1D array of options which will be used for both the displayed
		 * option and the value, or a 2D array which will use the array in the first
		 * position as the value, and the array in the second position as the
		 * displayed options (useful for language strings such as 'All').
		 *
		 * Note that the `pageLength` property will be automatically set to the
		 * first value given in this array, unless `pageLength` is also provided.
		 *  @type array
		 *  @default [ 10, 25, 50, 100 ]
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.lengthMenu
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
		 *      } );
		 *    } );
		 */
		"aLengthMenu": [ 10, 25, 50, 100 ],
	
	
		/**
		 * The `columns` option in the initialisation parameter allows you to define
		 * details about the way individual columns behave. For a full list of
		 * column options that can be set, please see
		 * {@link DataTable.defaults.column}. Note that if you use `columns` to
		 * define your columns, you must have an entry in the array for every single
		 * column that you have in your table (these can be null if you don't which
		 * to specify any options).
		 *  @member
		 *
		 *  @name DataTable.defaults.column
		 */
		"aoColumns": null,
	
		/**
		 * Very similar to `columns`, `columnDefs` allows you to target a specific
		 * column, multiple columns, or all columns, using the `targets` property of
		 * each object in the array. This allows great flexibility when creating
		 * tables, as the `columnDefs` arrays can be of any length, targeting the
		 * columns you specifically want. `columnDefs` may use any of the column
		 * options available: {@link DataTable.defaults.column}, but it _must_
		 * have `targets` defined in each object in the array. Values in the `targets`
		 * array may be:
		 *   <ul>
		 *     <li>a string - class name will be matched on the TH for the column</li>
		 *     <li>0 or a positive integer - column index counting from the left</li>
		 *     <li>a negative integer - column index counting from the right</li>
		 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
		 *   </ul>
		 *  @member
		 *
		 *  @name DataTable.defaults.columnDefs
		 */
		"aoColumnDefs": null,
	
	
		/**
		 * Basically the same as `search`, this parameter defines the individual column
		 * filtering state at initialisation time. The array must be of the same size
		 * as the number of columns, and each element be an object with the parameters
		 * `search` and `escapeRegex` (the latter is optional). 'null' is also
		 * accepted and the default will be used.
		 *  @type array
		 *  @default []
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.searchCols
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "searchCols": [
		 *          null,
		 *          { "search": "My filter" },
		 *          null,
		 *          { "search": "^[0-9]", "escapeRegex": false }
		 *        ]
		 *      } );
		 *    } )
		 */
		"aoSearchCols": [],
	
	
		/**
		 * An array of CSS classes that should be applied to displayed rows. This
		 * array may be of any length, and DataTables will apply each class
		 * sequentially, looping when required.
		 *  @type array
		 *  @default null <i>Will take the values determined by the `oClasses.stripe*`
		 *    options</i>
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.stripeClasses
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stripeClasses": [ 'strip1', 'strip2', 'strip3' ]
		 *      } );
		 *    } )
		 */
		"asStripeClasses": null,
	
	
		/**
		 * Enable or disable automatic column width calculation. This can be disabled
		 * as an optimisation (it takes some time to calculate the widths) if the
		 * tables widths are passed in using `columns`.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.autoWidth
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "autoWidth": false
		 *      } );
		 *    } );
		 */
		"bAutoWidth": true,
	
	
		/**
		 * Deferred rendering can provide DataTables with a huge speed boost when you
		 * are using an Ajax or JS data source for the table. This option, when set to
		 * true, will cause DataTables to defer the creation of the table elements for
		 * each row until they are needed for a draw - saving a significant amount of
		 * time.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.deferRender
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajax": "sources/arrays.txt",
		 *        "deferRender": true
		 *      } );
		 *    } );
		 */
		"bDeferRender": false,
	
	
		/**
		 * Replace a DataTable which matches the given selector and replace it with
		 * one which has the properties of the new initialisation object passed. If no
		 * table matches the selector, then the new DataTable will be constructed as
		 * per normal.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.destroy
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "srollY": "200px",
		 *        "paginate": false
		 *      } );
		 *
		 *      // Some time later....
		 *      $('#example').dataTable( {
		 *        "filter": false,
		 *        "destroy": true
		 *      } );
		 *    } );
		 */
		"bDestroy": false,
	
	
		/**
		 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
		 * that it allows the end user to input multiple words (space separated) and
		 * will match a row containing those words, even if not in the order that was
		 * specified (this allow matching across multiple columns). Note that if you
		 * wish to use filtering in DataTables this must remain 'true' - to remove the
		 * default filtering input box and retain filtering abilities, please use
		 * {@link DataTable.defaults.dom}.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.searching
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "searching": false
		 *      } );
		 *    } );
		 */
		"bFilter": true,
	
	
		/**
		 * Enable or disable the table information display. This shows information
		 * about the data that is currently visible on the page, including information
		 * about filtered data if that action is being performed.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.info
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "info": false
		 *      } );
		 *    } );
		 */
		"bInfo": true,
	
	
		/**
		 * Allows the end user to select the size of a formatted page from a select
		 * menu (sizes are 10, 25, 50 and 100). Requires pagination (`paginate`).
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.lengthChange
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "lengthChange": false
		 *      } );
		 *    } );
		 */
		"bLengthChange": true,
	
	
		/**
		 * Enable or disable pagination.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.paging
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "paging": false
		 *      } );
		 *    } );
		 */
		"bPaginate": true,
	
	
		/**
		 * Enable or disable the display of a 'processing' indicator when the table is
		 * being processed (e.g. a sort). This is particularly useful for tables with
		 * large amounts of data where it can take a noticeable amount of time to sort
		 * the entries.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.processing
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "processing": true
		 *      } );
		 *    } );
		 */
		"bProcessing": false,
	
	
		/**
		 * Retrieve the DataTables object for the given selector. Note that if the
		 * table has already been initialised, this parameter will cause DataTables
		 * to simply return the object that has already been set up - it will not take
		 * account of any changes you might have made to the initialisation object
		 * passed to DataTables (setting this parameter to true is an acknowledgement
		 * that you understand this). `destroy` can be used to reinitialise a table if
		 * you need.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.retrieve
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      initTable();
		 *      tableActions();
		 *    } );
		 *
		 *    function initTable ()
		 *    {
		 *      return $('#example').dataTable( {
		 *        "scrollY": "200px",
		 *        "paginate": false,
		 *        "retrieve": true
		 *      } );
		 *    }
		 *
		 *    function tableActions ()
		 *    {
		 *      var table = initTable();
		 *      // perform API operations with oTable
		 *    }
		 */
		"bRetrieve": false,
	
	
		/**
		 * When vertical (y) scrolling is enabled, DataTables will force the height of
		 * the table's viewport to the given height at all times (useful for layout).
		 * However, this can look odd when filtering data down to a small data set,
		 * and the footer is left "floating" further down. This parameter (when
		 * enabled) will cause DataTables to collapse the table's viewport down when
		 * the result set will fit within the given Y height.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.scrollCollapse
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollY": "200",
		 *        "scrollCollapse": true
		 *      } );
		 *    } );
		 */
		"bScrollCollapse": false,
	
	
		/**
		 * Configure DataTables to use server-side processing. Note that the
		 * `ajax` parameter must also be given in order to give DataTables a
		 * source to obtain the required data for each draw.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverSide
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "xhr.php"
		 *      } );
		 *    } );
		 */
		"bServerSide": false,
	
	
		/**
		 * Enable or disable sorting of columns. Sorting of individual columns can be
		 * disabled by the `sortable` option for each column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.ordering
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "ordering": false
		 *      } );
		 *    } );
		 */
		"bSort": true,
	
	
		/**
		 * Enable or display DataTables' ability to sort multiple columns at the
		 * same time (activated by shift-click by the user).
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.orderMulti
		 *
		 *  @example
		 *    // Disable multiple column sorting ability
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "orderMulti": false
		 *      } );
		 *    } );
		 */
		"bSortMulti": true,
	
	
		/**
		 * Allows control over whether DataTables should use the top (true) unique
		 * cell that is found for a single column, or the bottom (false - default).
		 * This is useful when using complex headers.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.orderCellsTop
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "orderCellsTop": true
		 *      } );
		 *    } );
		 */
		"bSortCellsTop": false,
	
	
		/**
		 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
		 * `sorting\_3` to the columns which are currently being sorted on. This is
		 * presented as a feature switch as it can increase processing time (while
		 * classes are removed and added) so for large data sets you might want to
		 * turn this off.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.orderClasses
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "orderClasses": false
		 *      } );
		 *    } );
		 */
		"bSortClasses": true,
	
	
		/**
		 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
		 * used to save table display information such as pagination information,
		 * display length, filtering and sorting. As such when the end user reloads
		 * the page the display display will match what thy had previously set up.
		 *
		 * Due to the use of `localStorage` the default state saving is not supported
		 * in IE6 or 7. If state saving is required in those browsers, use
		 * `stateSaveCallback` to provide a storage solution such as cookies.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.stateSave
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "stateSave": true
		 *      } );
		 *    } );
		 */
		"bStateSave": false,
	
	
		/**
		 * This function is called when a TR element is created (and all TD child
		 * elements have been inserted), or registered if using a DOM source, allowing
		 * manipulation of the TR element (adding classes etc).
		 *  @type function
		 *  @param {node} row "TR" element for the current row
		 *  @param {array} data Raw data array for this row
		 *  @param {int} dataIndex The index of this row in the internal aoData array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.createdRow
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "createdRow": function( row, data, dataIndex ) {
		 *          // Bold the grade for all 'A' grade browsers
		 *          if ( data[4] == "A" )
		 *          {
		 *            $('td:eq(4)', row).html( '<b>A</b>' );
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
		"fnCreatedRow": null,
	
	
		/**
		 * This function is called on every 'draw' event, and allows you to
		 * dynamically modify any aspect you want about the created DOM.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.drawCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "drawCallback": function( settings ) {
		 *          alert( 'DataTables has redrawn the table' );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnDrawCallback": null,
	
	
		/**
		 * Identical to fnHeaderCallback() but for the table footer this function
		 * allows you to modify the table footer on every 'draw' event.
		 *  @type function
		 *  @param {node} foot "TR" element for the footer
		 *  @param {array} data Full table data (as derived from the original HTML)
		 *  @param {int} start Index for the current display starting point in the
		 *    display array
		 *  @param {int} end Index for the current display ending point in the
		 *    display array
		 *  @param {array int} display Index array to translate the visual position
		 *    to the full data array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.footerCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "footerCallback": function( tfoot, data, start, end, display ) {
		 *          tfoot.getElementsByTagName('th')[0].innerHTML = "Starting index is "+start;
		 *        }
		 *      } );
		 *    } )
		 */
		"fnFooterCallback": null,
	
	
		/**
		 * When rendering large numbers in the information element for the table
		 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
		 * to have a comma separator for the 'thousands' units (e.g. 1 million is
		 * rendered as "1,000,000") to help readability for the end user. This
		 * function will override the default method DataTables uses.
		 *  @type function
		 *  @member
		 *  @param {int} toFormat number to be formatted
		 *  @returns {string} formatted string for DataTables to show the number
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.formatNumber
		 *
		 *  @example
		 *    // Format a number using a single quote for the separator (note that
		 *    // this can also be done with the language.thousands option)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "formatNumber": function ( toFormat ) {
		 *          return toFormat.toString().replace(
		 *            /\B(?=(\d{3})+(?!\d))/g, "'"
		 *          );
		 *        };
		 *      } );
		 *    } );
		 */
		"fnFormatNumber": function ( toFormat ) {
			return toFormat.toString().replace(
				/\B(?=(\d{3})+(?!\d))/g,
				this.oLanguage.sThousands
			);
		},
	
	
		/**
		 * This function is called on every 'draw' event, and allows you to
		 * dynamically modify the header row. This can be used to calculate and
		 * display useful information about the table.
		 *  @type function
		 *  @param {node} head "TR" element for the header
		 *  @param {array} data Full table data (as derived from the original HTML)
		 *  @param {int} start Index for the current display starting point in the
		 *    display array
		 *  @param {int} end Index for the current display ending point in the
		 *    display array
		 *  @param {array int} display Index array to translate the visual position
		 *    to the full data array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.headerCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "fheaderCallback": function( head, data, start, end, display ) {
		 *          head.getElementsByTagName('th')[0].innerHTML = "Displaying "+(end-start)+" records";
		 *        }
		 *      } );
		 *    } )
		 */
		"fnHeaderCallback": null,
	
	
		/**
		 * The information element can be used to convey information about the current
		 * state of the table. Although the internationalisation options presented by
		 * DataTables are quite capable of dealing with most customisations, there may
		 * be times where you wish to customise the string further. This callback
		 * allows you to do exactly that.
		 *  @type function
		 *  @param {object} oSettings DataTables settings object
		 *  @param {int} start Starting position in data for the draw
		 *  @param {int} end End position in data for the draw
		 *  @param {int} max Total number of rows in the table (regardless of
		 *    filtering)
		 *  @param {int} total Total number of rows in the data set, after filtering
		 *  @param {string} pre The string that DataTables has formatted using it's
		 *    own rules
		 *  @returns {string} The string to be displayed in the information element.
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.infoCallback
		 *
		 *  @example
		 *    $('#example').dataTable( {
		 *      "infoCallback": function( settings, start, end, max, total, pre ) {
		 *        return start +" to "+ end;
		 *      }
		 *    } );
		 */
		"fnInfoCallback": null,
	
	
		/**
		 * Called when the table has been initialised. Normally DataTables will
		 * initialise sequentially and there will be no need for this function,
		 * however, this does not hold true when using external language information
		 * since that is obtained using an async XHR call.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} json The JSON object request from the server - only
		 *    present if client-side Ajax sourced data is used
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.initComplete
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "initComplete": function(settings, json) {
		 *          alert( 'DataTables has finished its initialisation.' );
		 *        }
		 *      } );
		 *    } )
		 */
		"fnInitComplete": null,
	
	
		/**
		 * Called at the very start of each table draw and can be used to cancel the
		 * draw by returning false, any other return (including undefined) results in
		 * the full draw occurring).
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @returns {boolean} False will cancel the draw, anything else (including no
		 *    return) will allow it to complete.
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.preDrawCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "preDrawCallback": function( settings ) {
		 *          if ( $('#test').val() == 1 ) {
		 *            return false;
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
		"fnPreDrawCallback": null,
	
	
		/**
		 * This function allows you to 'post process' each row after it have been
		 * generated for each table draw, but before it is rendered on screen. This
		 * function might be used for setting the row class name etc.
		 *  @type function
		 *  @param {node} row "TR" element for the current row
		 *  @param {array} data Raw data array for this row
		 *  @param {int} displayIndex The display index for the current table draw
		 *  @param {int} displayIndexFull The index of the data in the full list of
		 *    rows (after filtering)
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.rowCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "rowCallback": function( row, data, displayIndex, displayIndexFull ) {
		 *          // Bold the grade for all 'A' grade browsers
		 *          if ( data[4] == "A" ) {
		 *            $('td:eq(4)', row).html( '<b>A</b>' );
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
		"fnRowCallback": null,
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * This parameter allows you to override the default function which obtains
		 * the data from the server so something more suitable for your application.
		 * For example you could use POST data, or pull information from a Gears or
		 * AIR database.
		 *  @type function
		 *  @member
		 *  @param {string} source HTTP source to obtain the data from (`ajax`)
		 *  @param {array} data A key/value pair object containing the data to send
		 *    to the server
		 *  @param {function} callback to be called on completion of the data get
		 *    process that will draw the data on the page.
		 *  @param {object} settings DataTables settings object
		 *
		 *  @dtopt Callbacks
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverData
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"fnServerData": null,
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 *  It is often useful to send extra data to the server when making an Ajax
		 * request - for example custom filtering information, and this callback
		 * function makes it trivial to send extra information to the server. The
		 * passed in parameter is the data set that has been constructed by
		 * DataTables, and you can add to this or modify it as you require.
		 *  @type function
		 *  @param {array} data Data array (array of objects which are name/value
		 *    pairs) that has been constructed by DataTables and will be sent to the
		 *    server. In the case of Ajax sourced data with server-side processing
		 *    this will be an empty array, for server-side processing there will be a
		 *    significant number of parameters!
		 *  @returns {undefined} Ensure that you modify the data array passed in,
		 *    as this is passed by reference.
		 *
		 *  @dtopt Callbacks
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverParams
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"fnServerParams": null,
	
	
		/**
		 * Load the table state. With this function you can define from where, and how, the
		 * state of a table is loaded. By default DataTables will load from `localStorage`
		 * but you might wish to use a server-side database or cookies.
		 *  @type function
		 *  @member
		 *  @param {object} settings DataTables settings object
		 *  @param {object} callback Callback that can be executed when done. It
		 *    should be passed the loaded state object.
		 *  @return {object} The DataTables state object to be loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoadCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadCallback": function (settings, callback) {
		 *          $.ajax( {
		 *            "url": "/state_load",
		 *            "dataType": "json",
		 *            "success": function (json) {
		 *              callback( json );
		 *            }
		 *          } );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateLoadCallback": function ( settings ) {
			try {
				return JSON.parse(
					(settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem(
						'DataTables_'+settings.sInstance+'_'+location.pathname
					)
				);
			} catch (e) {}
		},
	
	
		/**
		 * Callback which allows modification of the saved state prior to loading that state.
		 * This callback is called when the table is loading state from the stored data, but
		 * prior to the settings object being modified by the saved state. Note that for
		 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
		 * a plug-in.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object that is to be loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoadParams
		 *
		 *  @example
		 *    // Remove a saved filter, so filtering is never loaded
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadParams": function (settings, data) {
		 *          data.oSearch.sSearch = "";
		 *        }
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Disallow state loading by returning false
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadParams": function (settings, data) {
		 *          return false;
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateLoadParams": null,
	
	
		/**
		 * Callback that is called when the state has been loaded from the state saving method
		 * and the DataTables settings object has been modified as a result of the loaded state.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object that was loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoaded
		 *
		 *  @example
		 *    // Show an alert with the filtering value that was saved
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoaded": function (settings, data) {
		 *          alert( 'Saved filter was: '+data.oSearch.sSearch );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateLoaded": null,
	
	
		/**
		 * Save the table state. This function allows you to define where and how the state
		 * information for the table is stored By default DataTables will use `localStorage`
		 * but you might wish to use a server-side database or cookies.
		 *  @type function
		 *  @member
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object to be saved
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateSaveCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateSaveCallback": function (settings, data) {
		 *          // Send an Ajax request to the server with the state object
		 *          $.ajax( {
		 *            "url": "/state_save",
		 *            "data": data,
		 *            "dataType": "json",
		 *            "method": "POST"
		 *            "success": function () {}
		 *          } );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateSaveCallback": function ( settings, data ) {
			try {
				(settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem(
					'DataTables_'+settings.sInstance+'_'+location.pathname,
					JSON.stringify( data )
				);
			} catch (e) {}
		},
	
	
		/**
		 * Callback which allows modification of the state to be saved. Called when the table
		 * has changed state a new state save is required. This method allows modification of
		 * the state saving object prior to actually doing the save, including addition or
		 * other state properties or modification. Note that for plug-in authors, you should
		 * use the `stateSaveParams` event to save parameters for a plug-in.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object to be saved
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateSaveParams
		 *
		 *  @example
		 *    // Remove a saved filter, so filtering is never saved
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateSaveParams": function (settings, data) {
		 *          data.oSearch.sSearch = "";
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateSaveParams": null,
	
	
		/**
		 * Duration for which the saved state information is considered valid. After this period
		 * has elapsed the state will be returned to the default.
		 * Value is given in seconds.
		 *  @type int
		 *  @default 7200 <i>(2 hours)</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.stateDuration
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateDuration": 60*60*24; // 1 day
		 *      } );
		 *    } )
		 */
		"iStateDuration": 7200,
	
	
		/**
		 * When enabled DataTables will not make a request to the server for the first
		 * page draw - rather it will use the data already on the page (no sorting etc
		 * will be applied to it), thus saving on an XHR at load time. `deferLoading`
		 * is used to indicate that deferred loading is required, but it is also used
		 * to tell DataTables how many records there are in the full table (allowing
		 * the information element and pagination to be displayed correctly). In the case
		 * where a filtering is applied to the table on initial load, this can be
		 * indicated by giving the parameter as an array, where the first element is
		 * the number of records available after filtering and the second element is the
		 * number of records without filtering (allowing the table information element
		 * to be shown correctly).
		 *  @type int | array
		 *  @default null
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.deferLoading
		 *
		 *  @example
		 *    // 57 records available in the table, no filtering applied
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "scripts/server_processing.php",
		 *        "deferLoading": 57
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // 57 records after filtering, 100 without filtering (an initial filter applied)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "scripts/server_processing.php",
		 *        "deferLoading": [ 57, 100 ],
		 *        "search": {
		 *          "search": "my_filter"
		 *        }
		 *      } );
		 *    } );
		 */
		"iDeferLoading": null,
	
	
		/**
		 * Number of rows to display on a single page when using pagination. If
		 * feature enabled (`lengthChange`) then the end user will be able to override
		 * this to a custom setting using a pop-up menu.
		 *  @type int
		 *  @default 10
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.pageLength
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "pageLength": 50
		 *      } );
		 *    } )
		 */
		"iDisplayLength": 10,
	
	
		/**
		 * Define the starting point for data display when using DataTables with
		 * pagination. Note that this parameter is the number of records, rather than
		 * the page number, so if you have 10 records per page and want to start on
		 * the third page, it should be "20".
		 *  @type int
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.displayStart
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "displayStart": 20
		 *      } );
		 *    } )
		 */
		"iDisplayStart": 0,
	
	
		/**
		 * By default DataTables allows keyboard navigation of the table (sorting, paging,
		 * and filtering) by adding a `tabindex` attribute to the required elements. This
		 * allows you to tab through the controls and press the enter key to activate them.
		 * The tabindex is default 0, meaning that the tab follows the flow of the document.
		 * You can overrule this using this parameter if you wish. Use a value of -1 to
		 * disable built-in keyboard navigation.
		 *  @type int
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.tabIndex
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "tabIndex": 1
		 *      } );
		 *    } );
		 */
		"iTabIndex": 0,
	
	
		/**
		 * Classes that DataTables assigns to the various components and features
		 * that it adds to the HTML table. This allows classes to be configured
		 * during initialisation in addition to through the static
		 * {@link DataTable.ext.oStdClasses} object).
		 *  @namespace
		 *  @name DataTable.defaults.classes
		 */
		"oClasses": {},
	
	
		/**
		 * All strings that DataTables uses in the user interface that it creates
		 * are defined in this object, allowing you to modified them individually or
		 * completely replace them all as required.
		 *  @namespace
		 *  @name DataTable.defaults.language
		 */
		"oLanguage": {
			/**
			 * Strings that are used for WAI-ARIA labels and controls only (these are not
			 * actually visible on the page, but will be read by screenreaders, and thus
			 * must be internationalised as well).
			 *  @namespace
			 *  @name DataTable.defaults.language.aria
			 */
			"oAria": {
				/**
				 * ARIA label that is added to the table headers when the column may be
				 * sorted ascending by activing the column (click or return when focused).
				 * Note that the column header is prefixed to this string.
				 *  @type string
				 *  @default : activate to sort column ascending
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.aria.sortAscending
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "aria": {
				 *            "sortAscending": " - click/return to sort ascending"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sSortAscending": ": activate to sort column ascending",
	
				/**
				 * ARIA label that is added to the table headers when the column may be
				 * sorted descending by activing the column (click or return when focused).
				 * Note that the column header is prefixed to this string.
				 *  @type string
				 *  @default : activate to sort column ascending
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.aria.sortDescending
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "aria": {
				 *            "sortDescending": " - click/return to sort descending"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sSortDescending": ": activate to sort column descending"
			},
	
			/**
			 * Pagination string used by DataTables for the built-in pagination
			 * control types.
			 *  @namespace
			 *  @name DataTable.defaults.language.paginate
			 */
			"oPaginate": {
				/**
				 * Text to use when using the 'full_numbers' type of pagination for the
				 * button to take the user to the first page.
				 *  @type string
				 *  @default First
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.first
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "first": "First page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sFirst": "First",
	
	
				/**
				 * Text to use when using the 'full_numbers' type of pagination for the
				 * button to take the user to the last page.
				 *  @type string
				 *  @default Last
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.last
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "last": "Last page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sLast": "Last",
	
	
				/**
				 * Text to use for the 'next' pagination button (to take the user to the
				 * next page).
				 *  @type string
				 *  @default Next
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.next
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "next": "Next page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sNext": "Next",
	
	
				/**
				 * Text to use for the 'previous' pagination button (to take the user to
				 * the previous page).
				 *  @type string
				 *  @default Previous
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.previous
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "previous": "Previous page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sPrevious": "Previous"
			},
	
			/**
			 * This string is shown in preference to `zeroRecords` when the table is
			 * empty of data (regardless of filtering). Note that this is an optional
			 * parameter - if it is not given, the value of `zeroRecords` will be used
			 * instead (either the default or given value).
			 *  @type string
			 *  @default No data available in table
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.emptyTable
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "emptyTable": "No data available in table"
			 *        }
			 *      } );
			 *    } );
			 */
			"sEmptyTable": "No data available in table",
	
	
			/**
			 * This string gives information to the end user about the information
			 * that is current on display on the page. The following tokens can be
			 * used in the string and will be dynamically replaced as the table
			 * display updates. This tokens can be placed anywhere in the string, or
			 * removed as needed by the language requires:
			 *
			 * * `\_START\_` - Display index of the first record on the current page
			 * * `\_END\_` - Display index of the last record on the current page
			 * * `\_TOTAL\_` - Number of records in the table after filtering
			 * * `\_MAX\_` - Number of records in the table without filtering
			 * * `\_PAGE\_` - Current page number
			 * * `\_PAGES\_` - Total number of pages of data in the table
			 *
			 *  @type string
			 *  @default Showing _START_ to _END_ of _TOTAL_ entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.info
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "info": "Showing page _PAGE_ of _PAGES_"
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",
	
	
			/**
			 * Display information string for when the table is empty. Typically the
			 * format of this string should match `info`.
			 *  @type string
			 *  @default Showing 0 to 0 of 0 entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoEmpty
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoEmpty": "No entries to show"
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfoEmpty": "Showing 0 to 0 of 0 entries",
	
	
			/**
			 * When a user filters the information in a table, this string is appended
			 * to the information (`info`) to give an idea of how strong the filtering
			 * is. The variable _MAX_ is dynamically updated.
			 *  @type string
			 *  @default (filtered from _MAX_ total entries)
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoFiltered
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoFiltered": " - filtering from _MAX_ records"
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfoFiltered": "(filtered from _MAX_ total entries)",
	
	
			/**
			 * If can be useful to append extra information to the info string at times,
			 * and this variable does exactly that. This information will be appended to
			 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
			 * being used) at all times.
			 *  @type string
			 *  @default <i>Empty string</i>
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoPostFix
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoPostFix": "All records shown are derived from real information."
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfoPostFix": "",
	
	
			/**
			 * This decimal place operator is a little different from the other
			 * language options since DataTables doesn't output floating point
			 * numbers, so it won't ever use this for display of a number. Rather,
			 * what this parameter does is modify the sort methods of the table so
			 * that numbers which are in a format which has a character other than
			 * a period (`.`) as a decimal place will be sorted numerically.
			 *
			 * Note that numbers with different decimal places cannot be shown in
			 * the same table and still be sortable, the table must be consistent.
			 * However, multiple different tables on the page can use different
			 * decimal place characters.
			 *  @type string
			 *  @default 
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.decimal
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "decimal": ","
			 *          "thousands": "."
			 *        }
			 *      } );
			 *    } );
			 */
			"sDecimal": "",
	
	
			/**
			 * DataTables has a build in number formatter (`formatNumber`) which is
			 * used to format large numbers that are used in the table information.
			 * By default a comma is used, but this can be trivially changed to any
			 * character you wish with this parameter.
			 *  @type string
			 *  @default ,
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.thousands
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "thousands": "'"
			 *        }
			 *      } );
			 *    } );
			 */
			"sThousands": ",",
	
	
			/**
			 * Detail the action that will be taken when the drop down menu for the
			 * pagination length option is changed. The '_MENU_' variable is replaced
			 * with a default select list of 10, 25, 50 and 100, and can be replaced
			 * with a custom select box if required.
			 *  @type string
			 *  @default Show _MENU_ entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.lengthMenu
			 *
			 *  @example
			 *    // Language change only
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "lengthMenu": "Display _MENU_ records"
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Language and options change
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "lengthMenu": 'Display <select>'+
			 *            '<option value="10">10</option>'+
			 *            '<option value="20">20</option>'+
			 *            '<option value="30">30</option>'+
			 *            '<option value="40">40</option>'+
			 *            '<option value="50">50</option>'+
			 *            '<option value="-1">All</option>'+
			 *            '</select> records'
			 *        }
			 *      } );
			 *    } );
			 */
			"sLengthMenu": "Show _MENU_ entries",
	
	
			/**
			 * When using Ajax sourced data and during the first draw when DataTables is
			 * gathering the data, this message is shown in an empty row in the table to
			 * indicate to the end user the the data is being loaded. Note that this
			 * parameter is not used when loading data by server-side processing, just
			 * Ajax sourced data with client-side processing.
			 *  @type string
			 *  @default Loading...
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.loadingRecords
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "loadingRecords": "Please wait - loading..."
			 *        }
			 *      } );
			 *    } );
			 */
			"sLoadingRecords": "Loading...",
	
	
			/**
			 * Text which is displayed when the table is processing a user action
			 * (usually a sort command or similar).
			 *  @type string
			 *  @default Processing...
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.processing
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "processing": "DataTables is currently busy"
			 *        }
			 *      } );
			 *    } );
			 */
			"sProcessing": "Processing...",
	
	
			/**
			 * Details the actions that will be taken when the user types into the
			 * filtering input text box. The variable "_INPUT_", if used in the string,
			 * is replaced with the HTML text box for the filtering input allowing
			 * control over where it appears in the string. If "_INPUT_" is not given
			 * then the input box is appended to the string automatically.
			 *  @type string
			 *  @default Search:
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.search
			 *
			 *  @example
			 *    // Input text box will be appended at the end automatically
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "search": "Filter records:"
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Specify where the filter should appear
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "search": "Apply filter _INPUT_ to table"
			 *        }
			 *      } );
			 *    } );
			 */
			"sSearch": "Search:",
	
	
			/**
			 * Assign a `placeholder` attribute to the search `input` element
			 *  @type string
			 *  @default 
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.searchPlaceholder
			 */
			"sSearchPlaceholder": "",
	
	
			/**
			 * All of the language information can be stored in a file on the
			 * server-side, which DataTables will look up if this parameter is passed.
			 * It must store the URL of the language file, which is in a JSON format,
			 * and the object has the same properties as the oLanguage object in the
			 * initialiser object (i.e. the above parameters). Please refer to one of
			 * the example language files to see how this works in action.
			 *  @type string
			 *  @default <i>Empty string - i.e. disabled</i>
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.url
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "url": "http://www.sprymedia.co.uk/dataTables/lang.txt"
			 *        }
			 *      } );
			 *    } );
			 */
			"sUrl": "",
	
	
			/**
			 * Text shown inside the table records when the is no information to be
			 * displayed after filtering. `emptyTable` is shown when there is simply no
			 * information in the table at all (regardless of filtering).
			 *  @type string
			 *  @default No matching records found
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.zeroRecords
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "zeroRecords": "No records to display"
			 *        }
			 *      } );
			 *    } );
			 */
			"sZeroRecords": "No matching records found"
		},
	
	
		/**
		 * This parameter allows you to have define the global filtering state at
		 * initialisation time. As an object the `search` parameter must be
		 * defined, but all other parameters are optional. When `regex` is true,
		 * the search string will be treated as a regular expression, when false
		 * (default) it will be treated as a straight string. When `smart`
		 * DataTables will use it's smart filtering methods (to word match at
		 * any point in the data), when false this will not be done.
		 *  @namespace
		 *  @extends DataTable.models.oSearch
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.search
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "search": {"search": "Initial search"}
		 *      } );
		 *    } )
		 */
		"oSearch": $.extend( {}, DataTable.models.oSearch ),
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * By default DataTables will look for the property `data` (or `aaData` for
		 * compatibility with DataTables 1.9-) when obtaining data from an Ajax
		 * source or for server-side processing - this parameter allows that
		 * property to be changed. You can use Javascript dotted object notation to
		 * get a data source for multiple levels of nesting.
		 *  @type string
		 *  @default data
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.ajaxDataProp
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"sAjaxDataProp": "data",
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * You can instruct DataTables to load data from an external
		 * source using this parameter (use aData if you want to pass data in you
		 * already have). Simply provide a url a JSON object can be obtained from.
		 *  @type string
		 *  @default null
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.ajaxSource
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"sAjaxSource": null,
	
	
		/**
		 * This initialisation variable allows you to specify exactly where in the
		 * DOM you want DataTables to inject the various controls it adds to the page
		 * (for example you might want the pagination controls at the top of the
		 * table). DIV elements (with or without a custom class) can also be added to
		 * aid styling. The follow syntax is used:
		 *   <ul>
		 *     <li>The following options are allowed:
		 *       <ul>
		 *         <li>'l' - Length changing</li>
		 *         <li>'f' - Filtering input</li>
		 *         <li>'t' - The table!</li>
		 *         <li>'i' - Information</li>
		 *         <li>'p' - Pagination</li>
		 *         <li>'r' - pRocessing</li>
		 *       </ul>
		 *     </li>
		 *     <li>The following constants are allowed:
		 *       <ul>
		 *         <li>'H' - jQueryUI theme "header" classes ('fg-toolbar ui-widget-header ui-corner-tl ui-corner-tr ui-helper-clearfix')</li>
		 *         <li>'F' - jQueryUI theme "footer" classes ('fg-toolbar ui-widget-header ui-corner-bl ui-corner-br ui-helper-clearfix')</li>
		 *       </ul>
		 *     </li>
		 *     <li>The following syntax is expected:
		 *       <ul>
		 *         <li>'&lt;' and '&gt;' - div elements</li>
		 *         <li>'&lt;"class" and '&gt;' - div with a class</li>
		 *         <li>'&lt;"#id" and '&gt;' - div with an ID</li>
		 *       </ul>
		 *     </li>
		 *     <li>Examples:
		 *       <ul>
		 *         <li>'&lt;"wrapper"flipt&gt;'</li>
		 *         <li>'&lt;lf&lt;t&gt;ip&gt;'</li>
		 *       </ul>
		 *     </li>
		 *   </ul>
		 *  @type string
		 *  @default lfrtip <i>(when `jQueryUI` is false)</i> <b>or</b>
		 *    <"H"lfr>t<"F"ip> <i>(when `jQueryUI` is true)</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.dom
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "dom": '&lt;"top"i&gt;rt&lt;"bottom"flp&gt;&lt;"clear"&gt;'
		 *      } );
		 *    } );
		 */
		"sDom": "lfrtip",
	
	
		/**
		 * Search delay option. This will throttle full table searches that use the
		 * DataTables provided search input element (it does not effect calls to
		 * `dt-api search()`, providing a delay before the search is made.
		 *  @type integer
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.searchDelay
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "searchDelay": 200
		 *      } );
		 *    } )
		 */
		"searchDelay": null,
	
	
		/**
		 * DataTables features six different built-in options for the buttons to
		 * display for pagination control:
		 *
		 * * `numbers` - Page number buttons only
		 * * `simple` - 'Previous' and 'Next' buttons only
		 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
		 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
		 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
		 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
		 *  
		 * Further methods can be added using {@link DataTable.ext.oPagination}.
		 *  @type string
		 *  @default simple_numbers
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.pagingType
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "pagingType": "full_numbers"
		 *      } );
		 *    } )
		 */
		"sPaginationType": "simple_numbers",
	
	
		/**
		 * Enable horizontal scrolling. When a table is too wide to fit into a
		 * certain layout, or you have a large number of columns in the table, you
		 * can enable x-scrolling to show the table in a viewport, which can be
		 * scrolled. This property can be `true` which will allow the table to
		 * scroll horizontally when needed, or any CSS unit, or a number (in which
		 * case it will be treated as a pixel measurement). Setting as simply `true`
		 * is recommended.
		 *  @type boolean|string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.scrollX
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollX": true,
		 *        "scrollCollapse": true
		 *      } );
		 *    } );
		 */
		"sScrollX": "",
	
	
		/**
		 * This property can be used to force a DataTable to use more width than it
		 * might otherwise do when x-scrolling is enabled. For example if you have a
		 * table which requires to be well spaced, this parameter is useful for
		 * "over-sizing" the table, and thus forcing scrolling. This property can by
		 * any CSS unit, or a number (in which case it will be treated as a pixel
		 * measurement).
		 *  @type string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.scrollXInner
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollX": "100%",
		 *        "scrollXInner": "110%"
		 *      } );
		 *    } );
		 */
		"sScrollXInner": "",
	
	
		/**
		 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
		 * to the given height, and enable scrolling for any data which overflows the
		 * current viewport. This can be used as an alternative to paging to display
		 * a lot of data in a small area (although paging and scrolling can both be
		 * enabled at the same time). This property can be any CSS unit, or a number
		 * (in which case it will be treated as a pixel measurement).
		 *  @type string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.scrollY
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollY": "200px",
		 *        "paginate": false
		 *      } );
		 *    } );
		 */
		"sScrollY": "",
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * Set the HTTP method that is used to make the Ajax call for server-side
		 * processing or Ajax sourced data.
		 *  @type string
		 *  @default GET
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverMethod
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"sServerMethod": "GET",
	
	
		/**
		 * DataTables makes use of renderers when displaying HTML elements for
		 * a table. These renderers can be added or modified by plug-ins to
		 * generate suitable mark-up for a site. For example the Bootstrap
		 * integration plug-in for DataTables uses a paging button renderer to
		 * display pagination buttons in the mark-up required by Bootstrap.
		 *
		 * For further information about the renderers available see
		 * DataTable.ext.renderer
		 *  @type string|object
		 *  @default null
		 *
		 *  @name DataTable.defaults.renderer
		 *
		 */
		"renderer": null,
	
	
		/**
		 * Set the data property name that DataTables should use to get a row's id
		 * to set as the `id` property in the node.
		 *  @type string
		 *  @default DT_RowId
		 *
		 *  @name DataTable.defaults.rowId
		 */
		"rowId": "DT_RowId"
	};
	
	_fnHungarianMap( DataTable.defaults );
	
	
	
	/*
	 * Developer note - See note in model.defaults.js about the use of Hungarian
	 * notation and camel case.
	 */
	
	/**
	 * Column options that can be given to DataTables at initialisation time.
	 *  @namespace
	 */
	DataTable.defaults.column = {
		/**
		 * Define which column(s) an order will occur on for this column. This
		 * allows a column's ordering to take multiple columns into account when
		 * doing a sort or use the data from a different column. For example first
		 * name / last name columns make sense to do a multi-column sort over the
		 * two columns.
		 *  @type array|int
		 *  @default null <i>Takes the value of the column index automatically</i>
		 *
		 *  @name DataTable.defaults.column.orderData
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderData": [ 0, 1 ], "targets": [ 0 ] },
		 *          { "orderData": [ 1, 0 ], "targets": [ 1 ] },
		 *          { "orderData": 2, "targets": [ 2 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "orderData": [ 0, 1 ] },
		 *          { "orderData": [ 1, 0 ] },
		 *          { "orderData": 2 },
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"aDataSort": null,
		"iDataSort": -1,
	
	
		/**
		 * You can control the default ordering direction, and even alter the
		 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
		 * using this parameter.
		 *  @type array
		 *  @default [ 'asc', 'desc' ]
		 *
		 *  @name DataTable.defaults.column.orderSequence
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderSequence": [ "asc" ], "targets": [ 1 ] },
		 *          { "orderSequence": [ "desc", "asc", "asc" ], "targets": [ 2 ] },
		 *          { "orderSequence": [ "desc" ], "targets": [ 3 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          { "orderSequence": [ "asc" ] },
		 *          { "orderSequence": [ "desc", "asc", "asc" ] },
		 *          { "orderSequence": [ "desc" ] },
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"asSorting": [ 'asc', 'desc' ],
	
	
		/**
		 * Enable or disable filtering on the data in this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.searchable
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "searchable": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "searchable": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
		"bSearchable": true,
	
	
		/**
		 * Enable or disable ordering on this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.orderable
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderable": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "orderable": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
		"bSortable": true,
	
	
		/**
		 * Enable or disable the display of this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.visible
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "visible": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "visible": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
		"bVisible": true,
	
	
		/**
		 * Developer definable function that is called whenever a cell is created (Ajax source,
		 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
		 * allowing you to modify the DOM element (add background colour for example) when the
		 * element is available.
		 *  @type function
		 *  @param {element} td The TD node that has been created
		 *  @param {*} cellData The Data for the cell
		 *  @param {array|object} rowData The data for the whole row
		 *  @param {int} row The row index for the aoData data store
		 *  @param {int} col The column index for aoColumns
		 *
		 *  @name DataTable.defaults.column.createdCell
		 *  @dtopt Columns
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [3],
		 *          "createdCell": function (td, cellData, rowData, row, col) {
		 *            if ( cellData == "1.7" ) {
		 *              $(td).css('color', 'blue')
		 *            }
		 *          }
		 *        } ]
		 *      });
		 *    } );
		 */
		"fnCreatedCell": null,
	
	
		/**
		 * This parameter has been replaced by `data` in DataTables to ensure naming
		 * consistency. `dataProp` can still be used, as there is backwards
		 * compatibility in DataTables for this option, but it is strongly
		 * recommended that you use `data` in preference to `dataProp`.
		 *  @name DataTable.defaults.column.dataProp
		 */
	
	
		/**
		 * This property can be used to read data from any data source property,
		 * including deeply nested objects / properties. `data` can be given in a
		 * number of different ways which effect its behaviour:
		 *
		 * * `integer` - treated as an array index for the data source. This is the
		 *   default that DataTables uses (incrementally increased for each column).
		 * * `string` - read an object property from the data source. There are
		 *   three 'special' options that can be used in the string to alter how
		 *   DataTables reads the data from the source object:
		 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
		 *      Javascript to read from nested objects, so to can the options
		 *      specified in `data`. For example: `browser.version` or
		 *      `browser.name`. If your object parameter name contains a period, use
		 *      `\\` to escape it - i.e. `first\\.name`.
		 *    * `[]` - Array notation. DataTables can automatically combine data
		 *      from and array source, joining the data with the characters provided
		 *      between the two brackets. For example: `name[, ]` would provide a
		 *      comma-space separated list from the source array. If no characters
		 *      are provided between the brackets, the original array source is
		 *      returned.
		 *    * `()` - Function notation. Adding `()` to the end of a parameter will
		 *      execute a function of the name given. For example: `browser()` for a
		 *      simple function on the data source, `browser.version()` for a
		 *      function in a nested property or even `browser().version` to get an
		 *      object property if the function called returns an object. Note that
		 *      function notation is recommended for use in `render` rather than
		 *      `data` as it is much simpler to use as a renderer.
		 * * `null` - use the original data source for the row rather than plucking
		 *   data directly from it. This action has effects on two other
		 *   initialisation options:
		 *    * `defaultContent` - When null is given as the `data` option and
		 *      `defaultContent` is specified for the column, the value defined by
		 *      `defaultContent` will be used for the cell.
		 *    * `render` - When null is used for the `data` option and the `render`
		 *      option is specified for the column, the whole data source for the
		 *      row is used for the renderer.
		 * * `function` - the function given will be executed whenever DataTables
		 *   needs to set or get the data for a cell in the column. The function
		 *   takes three parameters:
		 *    * Parameters:
		 *      * `{array|object}` The data source for the row
		 *      * `{string}` The type call data requested - this will be 'set' when
		 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
		 *        when gathering data. Note that when `undefined` is given for the
		 *        type DataTables expects to get the raw data for the object back<
		 *      * `{*}` Data to set when the second parameter is 'set'.
		 *    * Return:
		 *      * The return value from the function is not required when 'set' is
		 *        the type of call, but otherwise the return is what will be used
		 *        for the data requested.
		 *
		 * Note that `data` is a getter and setter option. If you just require
		 * formatting of data for output, you will likely want to use `render` which
		 * is simply a getter and thus simpler to use.
		 *
		 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
		 * name change reflects the flexibility of this property and is consistent
		 * with the naming of mRender. If 'mDataProp' is given, then it will still
		 * be used by DataTables, as it automatically maps the old name to the new
		 * if required.
		 *
		 *  @type string|int|function|null
		 *  @default null <i>Use automatically calculated column index</i>
		 *
		 *  @name DataTable.defaults.column.data
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Read table data from objects
		 *    // JSON structure for each row:
		 *    //   {
		 *    //      "engine": {value},
		 *    //      "browser": {value},
		 *    //      "platform": {value},
		 *    //      "version": {value},
		 *    //      "grade": {value}
		 *    //   }
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/objects.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          { "data": "platform" },
		 *          { "data": "version" },
		 *          { "data": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Read information from deeply nested objects
		 *    // JSON structure for each row:
		 *    //   {
		 *    //      "engine": {value},
		 *    //      "browser": {value},
		 *    //      "platform": {
		 *    //         "inner": {value}
		 *    //      },
		 *    //      "details": [
		 *    //         {value}, {value}
		 *    //      ]
		 *    //   }
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/deep.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          { "data": "platform.inner" },
		 *          { "data": "details.0" },
		 *          { "data": "details.1" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `data` as a function to provide different information for
		 *    // sorting, filtering and display. In this case, currency (price)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": function ( source, type, val ) {
		 *            if (type === 'set') {
		 *              source.price = val;
		 *              // Store the computed dislay and filter values for efficiency
		 *              source.price_display = val=="" ? "" : "$"+numberFormat(val);
		 *              source.price_filter  = val=="" ? "" : "$"+numberFormat(val)+" "+val;
		 *              return;
		 *            }
		 *            else if (type === 'display') {
		 *              return source.price_display;
		 *            }
		 *            else if (type === 'filter') {
		 *              return source.price_filter;
		 *            }
		 *            // 'sort', 'type' and undefined all just use the integer
		 *            return source.price;
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using default content
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null,
		 *          "defaultContent": "Click to edit"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using array notation - outputting a list from an array
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": "name[, ]"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 */
		"mData": null,
	
	
		/**
		 * This property is the rendering partner to `data` and it is suggested that
		 * when you want to manipulate data for display (including filtering,
		 * sorting etc) without altering the underlying data for the table, use this
		 * property. `render` can be considered to be the the read only companion to
		 * `data` which is read / write (then as such more complex). Like `data`
		 * this option can be given in a number of different ways to effect its
		 * behaviour:
		 *
		 * * `integer` - treated as an array index for the data source. This is the
		 *   default that DataTables uses (incrementally increased for each column).
		 * * `string` - read an object property from the data source. There are
		 *   three 'special' options that can be used in the string to alter how
		 *   DataTables reads the data from the source object:
		 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
		 *      Javascript to read from nested objects, so to can the options
		 *      specified in `data`. For example: `browser.version` or
		 *      `browser.name`. If your object parameter name contains a period, use
		 *      `\\` to escape it - i.e. `first\\.name`.
		 *    * `[]` - Array notation. DataTables can automatically combine data
		 *      from and array source, joining the data with the characters provided
		 *      between the two brackets. For example: `name[, ]` would provide a
		 *      comma-space separated list from the source array. If no characters
		 *      are provided between the brackets, the original array source is
		 *      returned.
		 *    * `()` - Function notation. Adding `()` to the end of a parameter will
		 *      execute a function of the name given. For example: `browser()` for a
		 *      simple function on the data source, `browser.version()` for a
		 *      function in a nested property or even `browser().version` to get an
		 *      object property if the function called returns an object.
		 * * `object` - use different data for the different data types requested by
		 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
		 *   of the object is the data type the property refers to and the value can
		 *   defined using an integer, string or function using the same rules as
		 *   `render` normally does. Note that an `_` option _must_ be specified.
		 *   This is the default value to use if you haven't specified a value for
		 *   the data type requested by DataTables.
		 * * `function` - the function given will be executed whenever DataTables
		 *   needs to set or get the data for a cell in the column. The function
		 *   takes three parameters:
		 *    * Parameters:
		 *      * {array|object} The data source for the row (based on `data`)
		 *      * {string} The type call data requested - this will be 'filter',
		 *        'display', 'type' or 'sort'.
		 *      * {array|object} The full data source for the row (not based on
		 *        `data`)
		 *    * Return:
		 *      * The return value from the function is what will be used for the
		 *        data requested.
		 *
		 *  @type string|int|function|object|null
		 *  @default null Use the data source value.
		 *
		 *  @name DataTable.defaults.column.render
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Create a comma separated list from an array of objects
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/deep.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          {
		 *            "data": "platform",
		 *            "render": "[, ].name"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Execute a function to obtain data
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null, // Use the full data source object for the renderer's source
		 *          "render": "browserName()"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // As an object, extracting different data for the different types
		 *    // This would be used with a data source such as:
		 *    //   { "phone": 5552368, "phone_filter": "5552368 555-2368", "phone_display": "555-2368" }
		 *    // Here the `phone` integer is used for sorting and type detection, while `phone_filter`
		 *    // (which has both forms) is used for filtering for if a user inputs either format, while
		 *    // the formatted phone number is the one that is shown in the table.
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null, // Use the full data source object for the renderer's source
		 *          "render": {
		 *            "_": "phone",
		 *            "filter": "phone_filter",
		 *            "display": "phone_display"
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Use as a function to create a link from the data source
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": "download_link",
		 *          "render": function ( data, type, full ) {
		 *            return '<a href="'+data+'">Download</a>';
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 */
		"mRender": null,
	
	
		/**
		 * Change the cell type created for the column - either TD cells or TH cells. This
		 * can be useful as TH cells have semantic meaning in the table body, allowing them
		 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
		 *  @type string
		 *  @default td
		 *
		 *  @name DataTable.defaults.column.cellType
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Make the first column use TH cells
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "cellType": "th"
		 *        } ]
		 *      } );
		 *    } );
		 */
		"sCellType": "td",
	
	
		/**
		 * Class to give to each cell in this column.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @name DataTable.defaults.column.class
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "class": "my_class", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "class": "my_class" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sClass": "",
	
		/**
		 * When DataTables calculates the column widths to assign to each column,
		 * it finds the longest string in each column and then constructs a
		 * temporary table and reads the widths from that. The problem with this
		 * is that "mmm" is much wider then "iiii", but the latter is a longer
		 * string - thus the calculation can go wrong (doing it properly and putting
		 * it into an DOM object and measuring that is horribly(!) slow). Thus as
		 * a "work around" we provide this option. It will append its value to the
		 * text that is found to be the longest string for the column - i.e. padding.
		 * Generally you shouldn't need this!
		 *  @type string
		 *  @default <i>Empty string<i>
		 *
		 *  @name DataTable.defaults.column.contentPadding
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          null,
		 *          {
		 *            "contentPadding": "mmm"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sContentPadding": "",
	
	
		/**
		 * Allows a default value to be given for a column's data, and will be used
		 * whenever a null data source is encountered (this can be because `data`
		 * is set to null, or because the data source itself is null).
		 *  @type string
		 *  @default null
		 *
		 *  @name DataTable.defaults.column.defaultContent
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          {
		 *            "data": null,
		 *            "defaultContent": "Edit",
		 *            "targets": [ -1 ]
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          null,
		 *          {
		 *            "data": null,
		 *            "defaultContent": "Edit"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sDefaultContent": null,
	
	
		/**
		 * This parameter is only used in DataTables' server-side processing. It can
		 * be exceptionally useful to know what columns are being displayed on the
		 * client side, and to map these to database fields. When defined, the names
		 * also allow DataTables to reorder information from the server if it comes
		 * back in an unexpected order (i.e. if you switch your columns around on the
		 * client-side, your server-side code does not also need updating).
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @name DataTable.defaults.column.name
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "name": "engine", "targets": [ 0 ] },
		 *          { "name": "browser", "targets": [ 1 ] },
		 *          { "name": "platform", "targets": [ 2 ] },
		 *          { "name": "version", "targets": [ 3 ] },
		 *          { "name": "grade", "targets": [ 4 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "name": "engine" },
		 *          { "name": "browser" },
		 *          { "name": "platform" },
		 *          { "name": "version" },
		 *          { "name": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sName": "",
	
	
		/**
		 * Defines a data source type for the ordering which can be used to read
		 * real-time information from the table (updating the internally cached
		 * version) prior to ordering. This allows ordering to occur on user
		 * editable elements such as form inputs.
		 *  @type string
		 *  @default std
		 *
		 *  @name DataTable.defaults.column.orderDataType
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderDataType": "dom-text", "targets": [ 2, 3 ] },
		 *          { "type": "numeric", "targets": [ 3 ] },
		 *          { "orderDataType": "dom-select", "targets": [ 4 ] },
		 *          { "orderDataType": "dom-checkbox", "targets": [ 5 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          { "orderDataType": "dom-text" },
		 *          { "orderDataType": "dom-text", "type": "numeric" },
		 *          { "orderDataType": "dom-select" },
		 *          { "orderDataType": "dom-checkbox" }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sSortDataType": "std",
	
	
		/**
		 * The title of this column.
		 *  @type string
		 *  @default null <i>Derived from the 'TH' value for this column in the
		 *    original HTML table.</i>
		 *
		 *  @name DataTable.defaults.column.title
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "title": "My column title", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "title": "My column title" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sTitle": null,
	
	
		/**
		 * The type allows you to specify how the data for this column will be
		 * ordered. Four types (string, numeric, date and html (which will strip
		 * HTML tags before ordering)) are currently available. Note that only date
		 * formats understood by Javascript's Date() object will be accepted as type
		 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
		 * 'numeric', 'date' or 'html' (by default). Further types can be adding
		 * through plug-ins.
		 *  @type string
		 *  @default null <i>Auto-detected from raw data</i>
		 *
		 *  @name DataTable.defaults.column.type
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "type": "html", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "type": "html" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sType": null,
	
	
		/**
		 * Defining the width of the column, this parameter may take any CSS value
		 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
		 * been given a specific width through this interface ensuring that the table
		 * remains readable.
		 *  @type string
		 *  @default null <i>Automatic</i>
		 *
		 *  @name DataTable.defaults.column.width
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "width": "20%", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "width": "20%" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sWidth": null
	};
	
	_fnHungarianMap( DataTable.defaults.column );
	
	
	
	/**
	 * DataTables settings object - this holds all the information needed for a
	 * given table, including configuration, data and current application of the
	 * table options. DataTables does not have a single instance for each DataTable
	 * with the settings attached to that instance, but rather instances of the
	 * DataTable "class" are created on-the-fly as needed (typically by a
	 * $().dataTable() call) and the settings object is then applied to that
	 * instance.
	 *
	 * Note that this object is related to {@link DataTable.defaults} but this
	 * one is the internal data store for DataTables's cache of columns. It should
	 * NOT be manipulated outside of DataTables. Any configuration should be done
	 * through the initialisation options.
	 *  @namespace
	 *  @todo Really should attach the settings object to individual instances so we
	 *    don't need to create new instances on each $().dataTable() call (if the
	 *    table already exists). It would also save passing oSettings around and
	 *    into every single function. However, this is a very significant
	 *    architecture change for DataTables and will almost certainly break
	 *    backwards compatibility with older installations. This is something that
	 *    will be done in 2.0.
	 */
	DataTable.models.oSettings = {
		/**
		 * Primary features of DataTables and their enablement state.
		 *  @namespace
		 */
		"oFeatures": {
	
			/**
			 * Flag to say if DataTables should automatically try to calculate the
			 * optimum table and columns widths (true) or not (false).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bAutoWidth": null,
	
			/**
			 * Delay the creation of TR and TD elements until they are actually
			 * needed by a driven page draw. This can give a significant speed
			 * increase for Ajax source and Javascript source data, but makes no
			 * difference at all fro DOM and server-side processing tables.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bDeferRender": null,
	
			/**
			 * Enable filtering on the table or not. Note that if this is disabled
			 * then there is no filtering at all on the table, including fnFilter.
			 * To just remove the filtering input use sDom and remove the 'f' option.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bFilter": null,
	
			/**
			 * Table information element (the 'Showing x of y records' div) enable
			 * flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bInfo": null,
	
			/**
			 * Present a user control allowing the end user to change the page size
			 * when pagination is enabled.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bLengthChange": null,
	
			/**
			 * Pagination enabled or not. Note that if this is disabled then length
			 * changing must also be disabled.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bPaginate": null,
	
			/**
			 * Processing indicator enable flag whenever DataTables is enacting a
			 * user request - typically an Ajax request for server-side processing.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bProcessing": null,
	
			/**
			 * Server-side processing enabled flag - when enabled DataTables will
			 * get all data from the server for every draw - there is no filtering,
			 * sorting or paging done on the client-side.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bServerSide": null,
	
			/**
			 * Sorting enablement flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bSort": null,
	
			/**
			 * Multi-column sorting
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bSortMulti": null,
	
			/**
			 * Apply a class to the columns which are being sorted to provide a
			 * visual highlight or not. This can slow things down when enabled since
			 * there is a lot of DOM interaction.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bSortClasses": null,
	
			/**
			 * State saving enablement flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bStateSave": null
		},
	
	
		/**
		 * Scrolling settings for a table.
		 *  @namespace
		 */
		"oScroll": {
			/**
			 * When the table is shorter in height than sScrollY, collapse the
			 * table container down to the height of the table (when true).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bCollapse": null,
	
			/**
			 * Width of the scrollbar for the web-browser's platform. Calculated
			 * during table initialisation.
			 *  @type int
			 *  @default 0
			 */
			"iBarWidth": 0,
	
			/**
			 * Viewport width for horizontal scrolling. Horizontal scrolling is
			 * disabled if an empty string.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
			"sX": null,
	
			/**
			 * Width to expand the table to when using x-scrolling. Typically you
			 * should not need to use this.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 *  @deprecated
			 */
			"sXInner": null,
	
			/**
			 * Viewport height for vertical scrolling. Vertical scrolling is disabled
			 * if an empty string.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
			"sY": null
		},
	
		/**
		 * Language information for the table.
		 *  @namespace
		 *  @extends DataTable.defaults.oLanguage
		 */
		"oLanguage": {
			/**
			 * Information callback function. See
			 * {@link DataTable.defaults.fnInfoCallback}
			 *  @type function
			 *  @default null
			 */
			"fnInfoCallback": null
		},
	
		/**
		 * Browser support parameters
		 *  @namespace
		 */
		"oBrowser": {
			/**
			 * Indicate if the browser incorrectly calculates width:100% inside a
			 * scrolling element (IE6/7)
			 *  @type boolean
			 *  @default false
			 */
			"bScrollOversize": false,
	
			/**
			 * Determine if the vertical scrollbar is on the right or left of the
			 * scrolling container - needed for rtl language layout, although not
			 * all browsers move the scrollbar (Safari).
			 *  @type boolean
			 *  @default false
			 */
			"bScrollbarLeft": false,
	
			/**
			 * Flag for if `getBoundingClientRect` is fully supported or not
			 *  @type boolean
			 *  @default false
			 */
			"bBounding": false,
	
			/**
			 * Browser scrollbar width
			 *  @type integer
			 *  @default 0
			 */
			"barWidth": 0
		},
	
	
		"ajax": null,
	
	
		/**
		 * Array referencing the nodes which are used for the features. The
		 * parameters of this object match what is allowed by sDom - i.e.
		 *   <ul>
		 *     <li>'l' - Length changing</li>
		 *     <li>'f' - Filtering input</li>
		 *     <li>'t' - The table!</li>
		 *     <li>'i' - Information</li>
		 *     <li>'p' - Pagination</li>
		 *     <li>'r' - pRocessing</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
		"aanFeatures": [],
	
		/**
		 * Store data information - see {@link DataTable.models.oRow} for detailed
		 * information.
		 *  @type array
		 *  @default []
		 */
		"aoData": [],
	
		/**
		 * Array of indexes which are in the current display (after filtering etc)
		 *  @type array
		 *  @default []
		 */
		"aiDisplay": [],
	
		/**
		 * Array of indexes for display - no filtering
		 *  @type array
		 *  @default []
		 */
		"aiDisplayMaster": [],
	
		/**
		 * Map of row ids to data indexes
		 *  @type object
		 *  @default {}
		 */
		"aIds": {},
	
		/**
		 * Store information about each column that is in use
		 *  @type array
		 *  @default []
		 */
		"aoColumns": [],
	
		/**
		 * Store information about the table's header
		 *  @type array
		 *  @default []
		 */
		"aoHeader": [],
	
		/**
		 * Store information about the table's footer
		 *  @type array
		 *  @default []
		 */
		"aoFooter": [],
	
		/**
		 * Store the applied global search information in case we want to force a
		 * research or compare the old search to a new one.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @namespace
		 *  @extends DataTable.models.oSearch
		 */
		"oPreviousSearch": {},
	
		/**
		 * Store the applied search for each column - see
		 * {@link DataTable.models.oSearch} for the format that is used for the
		 * filtering information for each column.
		 *  @type array
		 *  @default []
		 */
		"aoPreSearchCols": [],
	
		/**
		 * Sorting that is applied to the table. Note that the inner arrays are
		 * used in the following manner:
		 * <ul>
		 *   <li>Index 0 - column number</li>
		 *   <li>Index 1 - current sorting direction</li>
		 * </ul>
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @todo These inner arrays should really be objects
		 */
		"aaSorting": null,
	
		/**
		 * Sorting that is always applied to the table (i.e. prefixed in front of
		 * aaSorting).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
		"aaSortingFixed": [],
	
		/**
		 * Classes to use for the striping of a table.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
		"asStripeClasses": null,
	
		/**
		 * If restoring a table - we should restore its striping classes as well
		 *  @type array
		 *  @default []
		 */
		"asDestroyStripes": [],
	
		/**
		 * If restoring a table - we should restore its width
		 *  @type int
		 *  @default 0
		 */
		"sDestroyWidth": 0,
	
		/**
		 * Callback functions array for every time a row is inserted (i.e. on a draw).
		 *  @type array
		 *  @default []
		 */
		"aoRowCallback": [],
	
		/**
		 * Callback functions for the header on each draw.
		 *  @type array
		 *  @default []
		 */
		"aoHeaderCallback": [],
	
		/**
		 * Callback function for the footer on each draw.
		 *  @type array
		 *  @default []
		 */
		"aoFooterCallback": [],
	
		/**
		 * Array of callback functions for draw callback functions
		 *  @type array
		 *  @default []
		 */
		"aoDrawCallback": [],
	
		/**
		 * Array of callback functions for row created function
		 *  @type array
		 *  @default []
		 */
		"aoRowCreatedCallback": [],
	
		/**
		 * Callback functions for just before the table is redrawn. A return of
		 * false will be used to cancel the draw.
		 *  @type array
		 *  @default []
		 */
		"aoPreDrawCallback": [],
	
		/**
		 * Callback functions for when the table has been initialised.
		 *  @type array
		 *  @default []
		 */
		"aoInitComplete": [],
	
	
		/**
		 * Callbacks for modifying the settings to be stored for state saving, prior to
		 * saving state.
		 *  @type array
		 *  @default []
		 */
		"aoStateSaveParams": [],
	
		/**
		 * Callbacks for modifying the settings that have been stored for state saving
		 * prior to using the stored values to restore the state.
		 *  @type array
		 *  @default []
		 */
		"aoStateLoadParams": [],
	
		/**
		 * Callbacks for operating on the settings object once the saved state has been
		 * loaded
		 *  @type array
		 *  @default []
		 */
		"aoStateLoaded": [],
	
		/**
		 * Cache the table ID for quick access
		 *  @type string
		 *  @default <i>Empty string</i>
		 */
		"sTableId": "",
	
		/**
		 * The TABLE node for the main table
		 *  @type node
		 *  @default null
		 */
		"nTable": null,
	
		/**
		 * Permanent ref to the thead element
		 *  @type node
		 *  @default null
		 */
		"nTHead": null,
	
		/**
		 * Permanent ref to the tfoot element - if it exists
		 *  @type node
		 *  @default null
		 */
		"nTFoot": null,
	
		/**
		 * Permanent ref to the tbody element
		 *  @type node
		 *  @default null
		 */
		"nTBody": null,
	
		/**
		 * Cache the wrapper node (contains all DataTables controlled elements)
		 *  @type node
		 *  @default null
		 */
		"nTableWrapper": null,
	
		/**
		 * Indicate if when using server-side processing the loading of data
		 * should be deferred until the second draw.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 *  @default false
		 */
		"bDeferLoading": false,
	
		/**
		 * Indicate if all required information has been read in
		 *  @type boolean
		 *  @default false
		 */
		"bInitialised": false,
	
		/**
		 * Information about open rows. Each object in the array has the parameters
		 * 'nTr' and 'nParent'
		 *  @type array
		 *  @default []
		 */
		"aoOpenRows": [],
	
		/**
		 * Dictate the positioning of DataTables' control elements - see
		 * {@link DataTable.model.oInit.sDom}.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default null
		 */
		"sDom": null,
	
		/**
		 * Search delay (in mS)
		 *  @type integer
		 *  @default null
		 */
		"searchDelay": null,
	
		/**
		 * Which type of pagination should be used.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default two_button
		 */
		"sPaginationType": "two_button",
	
		/**
		 * The state duration (for `stateSave`) in seconds.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type int
		 *  @default 0
		 */
		"iStateDuration": 0,
	
		/**
		 * Array of callback functions for state saving. Each array element is an
		 * object with the following parameters:
		 *   <ul>
		 *     <li>function:fn - function to call. Takes two parameters, oSettings
		 *       and the JSON string to save that has been thus far created. Returns
		 *       a JSON string to be inserted into a json object
		 *       (i.e. '"param": [ 0, 1, 2]')</li>
		 *     <li>string:sName - name of callback</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
		"aoStateSave": [],
	
		/**
		 * Array of callback functions for state loading. Each array element is an
		 * object with the following parameters:
		 *   <ul>
		 *     <li>function:fn - function to call. Takes two parameters, oSettings
		 *       and the object stored. May return false to cancel state loading</li>
		 *     <li>string:sName - name of callback</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
		"aoStateLoad": [],
	
		/**
		 * State that was saved. Useful for back reference
		 *  @type object
		 *  @default null
		 */
		"oSavedState": null,
	
		/**
		 * State that was loaded. Useful for back reference
		 *  @type object
		 *  @default null
		 */
		"oLoadedState": null,
	
		/**
		 * Source url for AJAX data for the table.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default null
		 */
		"sAjaxSource": null,
	
		/**
		 * Property from a given object from which to read the table data from. This
		 * can be an empty string (when not server-side processing), in which case
		 * it is  assumed an an array is given directly.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
		"sAjaxDataProp": null,
	
		/**
		 * Note if draw should be blocked while getting data
		 *  @type boolean
		 *  @default true
		 */
		"bAjaxDataGet": true,
	
		/**
		 * The last jQuery XHR object that was used for server-side data gathering.
		 * This can be used for working with the XHR information in one of the
		 * callbacks
		 *  @type object
		 *  @default null
		 */
		"jqXHR": null,
	
		/**
		 * JSON returned from the server in the last Ajax request
		 *  @type object
		 *  @default undefined
		 */
		"json": undefined,
	
		/**
		 * Data submitted as part of the last Ajax request
		 *  @type object
		 *  @default undefined
		 */
		"oAjaxData": undefined,
	
		/**
		 * Function to get the server-side data.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type function
		 */
		"fnServerData": null,
	
		/**
		 * Functions which are called prior to sending an Ajax request so extra
		 * parameters can easily be sent to the server
		 *  @type array
		 *  @default []
		 */
		"aoServerParams": [],
	
		/**
		 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
		 * required).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
		"sServerMethod": null,
	
		/**
		 * Format numbers for display.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type function
		 */
		"fnFormatNumber": null,
	
		/**
		 * List of options that can be used for the user selectable length menu.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
		"aLengthMenu": null,
	
		/**
		 * Counter for the draws that the table does. Also used as a tracker for
		 * server-side processing
		 *  @type int
		 *  @default 0
		 */
		"iDraw": 0,
	
		/**
		 * Indicate if a redraw is being done - useful for Ajax
		 *  @type boolean
		 *  @default false
		 */
		"bDrawing": false,
	
		/**
		 * Draw index (iDraw) of the last error when parsing the returned data
		 *  @type int
		 *  @default -1
		 */
		"iDrawError": -1,
	
		/**
		 * Paging display length
		 *  @type int
		 *  @default 10
		 */
		"_iDisplayLength": 10,
	
		/**
		 * Paging start point - aiDisplay index
		 *  @type int
		 *  @default 0
		 */
		"_iDisplayStart": 0,
	
		/**
		 * Server-side processing - number of records in the result set
		 * (i.e. before filtering), Use fnRecordsTotal rather than
		 * this property to get the value of the number of records, regardless of
		 * the server-side processing setting.
		 *  @type int
		 *  @default 0
		 *  @private
		 */
		"_iRecordsTotal": 0,
	
		/**
		 * Server-side processing - number of records in the current display set
		 * (i.e. after filtering). Use fnRecordsDisplay rather than
		 * this property to get the value of the number of records, regardless of
		 * the server-side processing setting.
		 *  @type boolean
		 *  @default 0
		 *  @private
		 */
		"_iRecordsDisplay": 0,
	
		/**
		 * The classes to use for the table
		 *  @type object
		 *  @default {}
		 */
		"oClasses": {},
	
		/**
		 * Flag attached to the settings object so you can check in the draw
		 * callback if filtering has been done in the draw. Deprecated in favour of
		 * events.
		 *  @type boolean
		 *  @default false
		 *  @deprecated
		 */
		"bFiltered": false,
	
		/**
		 * Flag attached to the settings object so you can check in the draw
		 * callback if sorting has been done in the draw. Deprecated in favour of
		 * events.
		 *  @type boolean
		 *  @default false
		 *  @deprecated
		 */
		"bSorted": false,
	
		/**
		 * Indicate that if multiple rows are in the header and there is more than
		 * one unique cell per column, if the top one (true) or bottom one (false)
		 * should be used for sorting / title by DataTables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bSortCellsTop": null,
	
		/**
		 * Initialisation object that is used for the table
		 *  @type object
		 *  @default null
		 */
		"oInit": null,
	
		/**
		 * Destroy callback functions - for plug-ins to attach themselves to the
		 * destroy so they can clean up markup and events.
		 *  @type array
		 *  @default []
		 */
		"aoDestroyCallback": [],
	
	
		/**
		 * Get the number of records in the current record set, before filtering
		 *  @type function
		 */
		"fnRecordsTotal": function ()
		{
			return _fnDataSource( this ) == 'ssp' ?
				this._iRecordsTotal * 1 :
				this.aiDisplayMaster.length;
		},
	
		/**
		 * Get the number of records in the current record set, after filtering
		 *  @type function
		 */
		"fnRecordsDisplay": function ()
		{
			return _fnDataSource( this ) == 'ssp' ?
				this._iRecordsDisplay * 1 :
				this.aiDisplay.length;
		},
	
		/**
		 * Get the display end point - aiDisplay index
		 *  @type function
		 */
		"fnDisplayEnd": function ()
		{
			var
				len      = this._iDisplayLength,
				start    = this._iDisplayStart,
				calc     = start + len,
				records  = this.aiDisplay.length,
				features = this.oFeatures,
				paginate = features.bPaginate;
	
			if ( features.bServerSide ) {
				return paginate === false || len === -1 ?
					start + records :
					Math.min( start+len, this._iRecordsDisplay );
			}
			else {
				return ! paginate || calc>records || len===-1 ?
					records :
					calc;
			}
		},
	
		/**
		 * The DataTables object for this table
		 *  @type object
		 *  @default null
		 */
		"oInstance": null,
	
		/**
		 * Unique identifier for each instance of the DataTables object. If there
		 * is an ID on the table node, then it takes that value, otherwise an
		 * incrementing internal counter is used.
		 *  @type string
		 *  @default null
		 */
		"sInstance": null,
	
		/**
		 * tabindex attribute value that is added to DataTables control elements, allowing
		 * keyboard navigation of the table and its controls.
		 */
		"iTabIndex": 0,
	
		/**
		 * DIV container for the footer scrolling table if scrolling
		 */
		"nScrollHead": null,
	
		/**
		 * DIV container for the footer scrolling table if scrolling
		 */
		"nScrollFoot": null,
	
		/**
		 * Last applied sort
		 *  @type array
		 *  @default []
		 */
		"aLastSort": [],
	
		/**
		 * Stored plug-in instances
		 *  @type object
		 *  @default {}
		 */
		"oPlugins": {},
	
		/**
		 * Function used to get a row's id from the row's data
		 *  @type function
		 *  @default null
		 */
		"rowIdFn": null,
	
		/**
		 * Data location where to store a row's id
		 *  @type string
		 *  @default null
		 */
		"rowId": null
	};

	/**
	 * Extension object for DataTables that is used to provide all extension
	 * options.
	 *
	 * Note that the `DataTable.ext` object is available through
	 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
	 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
	 *  @namespace
	 *  @extends DataTable.models.ext
	 */
	
	
	/**
	 * DataTables extensions
	 * 
	 * This namespace acts as a collection area for plug-ins that can be used to
	 * extend DataTables capabilities. Indeed many of the build in methods
	 * use this method to provide their own capabilities (sorting methods for
	 * example).
	 *
	 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
	 * reasons
	 *
	 *  @namespace
	 */
	DataTable.ext = _ext = {
		/**
		 * Buttons. For use with the Buttons extension for DataTables. This is
		 * defined here so other extensions can define buttons regardless of load
		 * order. It is _not_ used by DataTables core.
		 *
		 *  @type object
		 *  @default {}
		 */
		buttons: {},
	
	
		/**
		 * Element class names
		 *
		 *  @type object
		 *  @default {}
		 */
		classes: {},
	
	
		/**
		 * DataTables build type (expanded by the download builder)
		 *
		 *  @type string
		 */
		builder: "-source-",
	
	
		/**
		 * Error reporting.
		 * 
		 * How should DataTables report an error. Can take the value 'alert',
		 * 'throw', 'none' or a function.
		 *
		 *  @type string|function
		 *  @default alert
		 */
		errMode: "alert",
	
	
		/**
		 * Feature plug-ins.
		 * 
		 * This is an array of objects which describe the feature plug-ins that are
		 * available to DataTables. These feature plug-ins are then available for
		 * use through the `dom` initialisation option.
		 * 
		 * Each feature plug-in is described by an object which must have the
		 * following properties:
		 * 
		 * * `fnInit` - function that is used to initialise the plug-in,
		 * * `cFeature` - a character so the feature can be enabled by the `dom`
		 *   instillation option. This is case sensitive.
		 *
		 * The `fnInit` function has the following input parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 *
		 * And the following return is expected:
		 * 
		 * * {node|null} The element which contains your feature. Note that the
		 *   return may also be void if your plug-in does not require to inject any
		 *   DOM elements into DataTables control (`dom`) - for example this might
		 *   be useful when developing a plug-in which allows table control via
		 *   keyboard entry
		 *
		 *  @type array
		 *
		 *  @example
		 *    $.fn.dataTable.ext.features.push( {
		 *      "fnInit": function( oSettings ) {
		 *        return new TableTools( { "oDTSettings": oSettings } );
		 *      },
		 *      "cFeature": "T"
		 *    } );
		 */
		feature: [],
	
	
		/**
		 * Row searching.
		 * 
		 * This method of searching is complimentary to the default type based
		 * searching, and a lot more comprehensive as it allows you complete control
		 * over the searching logic. Each element in this array is a function
		 * (parameters described below) that is called for every row in the table,
		 * and your logic decides if it should be included in the searching data set
		 * or not.
		 *
		 * Searching functions have the following input parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 * 2. `{array|object}` Data for the row to be processed (same as the
		 *    original format that was passed in as the data source, or an array
		 *    from a DOM data source
		 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
		 *    can be useful to retrieve the `TR` element if you need DOM interaction.
		 *
		 * And the following return is expected:
		 *
		 * * {boolean} Include the row in the searched result set (true) or not
		 *   (false)
		 *
		 * Note that as with the main search ability in DataTables, technically this
		 * is "filtering", since it is subtractive. However, for consistency in
		 * naming we call it searching here.
		 *
		 *  @type array
		 *  @default []
		 *
		 *  @example
		 *    // The following example shows custom search being applied to the
		 *    // fourth column (i.e. the data[3] index) based on two input values
		 *    // from the end-user, matching the data in a certain range.
		 *    $.fn.dataTable.ext.search.push(
		 *      function( settings, data, dataIndex ) {
		 *        var min = document.getElementById('min').value * 1;
		 *        var max = document.getElementById('max').value * 1;
		 *        var version = data[3] == "-" ? 0 : data[3]*1;
		 *
		 *        if ( min == "" && max == "" ) {
		 *          return true;
		 *        }
		 *        else if ( min == "" && version < max ) {
		 *          return true;
		 *        }
		 *        else if ( min < version && "" == max ) {
		 *          return true;
		 *        }
		 *        else if ( min < version && version < max ) {
		 *          return true;
		 *        }
		 *        return false;
		 *      }
		 *    );
		 */
		search: [],
	
	
		/**
		 * Selector extensions
		 *
		 * The `selector` option can be used to extend the options available for the
		 * selector modifier options (`selector-modifier` object data type) that
		 * each of the three built in selector types offer (row, column and cell +
		 * their plural counterparts). For example the Select extension uses this
		 * mechanism to provide an option to select only rows, columns and cells
		 * that have been marked as selected by the end user (`{selected: true}`),
		 * which can be used in conjunction with the existing built in selector
		 * options.
		 *
		 * Each property is an array to which functions can be pushed. The functions
		 * take three attributes:
		 *
		 * * Settings object for the host table
		 * * Options object (`selector-modifier` object type)
		 * * Array of selected item indexes
		 *
		 * The return is an array of the resulting item indexes after the custom
		 * selector has been applied.
		 *
		 *  @type object
		 */
		selector: {
			cell: [],
			column: [],
			row: []
		},
	
	
		/**
		 * Internal functions, exposed for used in plug-ins.
		 * 
		 * Please note that you should not need to use the internal methods for
		 * anything other than a plug-in (and even then, try to avoid if possible).
		 * The internal function may change between releases.
		 *
		 *  @type object
		 *  @default {}
		 */
		internal: {},
	
	
		/**
		 * Legacy configuration options. Enable and disable legacy options that
		 * are available in DataTables.
		 *
		 *  @type object
		 */
		legacy: {
			/**
			 * Enable / disable DataTables 1.9 compatible server-side processing
			 * requests
			 *
			 *  @type boolean
			 *  @default null
			 */
			ajax: null
		},
	
	
		/**
		 * Pagination plug-in methods.
		 * 
		 * Each entry in this object is a function and defines which buttons should
		 * be shown by the pagination rendering method that is used for the table:
		 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
		 * buttons are displayed in the document, while the functions here tell it
		 * what buttons to display. This is done by returning an array of button
		 * descriptions (what each button will do).
		 *
		 * Pagination types (the four built in options and any additional plug-in
		 * options defined here) can be used through the `paginationType`
		 * initialisation parameter.
		 *
		 * The functions defined take two parameters:
		 *
		 * 1. `{int} page` The current page index
		 * 2. `{int} pages` The number of pages in the table
		 *
		 * Each function is expected to return an array where each element of the
		 * array can be one of:
		 *
		 * * `first` - Jump to first page when activated
		 * * `last` - Jump to last page when activated
		 * * `previous` - Show previous page when activated
		 * * `next` - Show next page when activated
		 * * `{int}` - Show page of the index given
		 * * `{array}` - A nested array containing the above elements to add a
		 *   containing 'DIV' element (might be useful for styling).
		 *
		 * Note that DataTables v1.9- used this object slightly differently whereby
		 * an object with two functions would be defined for each plug-in. That
		 * ability is still supported by DataTables 1.10+ to provide backwards
		 * compatibility, but this option of use is now decremented and no longer
		 * documented in DataTables 1.10+.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Show previous, next and current page buttons only
		 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
		 *      return [ 'previous', page, 'next' ];
		 *    };
		 */
		pager: {},
	
	
		renderer: {
			pageButton: {},
			header: {}
		},
	
	
		/**
		 * Ordering plug-ins - custom data source
		 * 
		 * The extension options for ordering of data available here is complimentary
		 * to the default type based ordering that DataTables typically uses. It
		 * allows much greater control over the the data that is being used to
		 * order a column, but is necessarily therefore more complex.
		 * 
		 * This type of ordering is useful if you want to do ordering based on data
		 * live from the DOM (for example the contents of an 'input' element) rather
		 * than just the static string that DataTables knows of.
		 * 
		 * The way these plug-ins work is that you create an array of the values you
		 * wish to be ordering for the column in question and then return that
		 * array. The data in the array much be in the index order of the rows in
		 * the table (not the currently ordering order!). Which order data gathering
		 * function is run here depends on the `dt-init columns.orderDataType`
		 * parameter that is used for the column (if any).
		 *
		 * The functions defined take two parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 * 2. `{int}` Target column index
		 *
		 * Each function is expected to return an array:
		 *
		 * * `{array}` Data for the column to be ordering upon
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Ordering using `input` node values
		 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
		 *    {
		 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
		 *        return $('input', td).val();
		 *      } );
		 *    }
		 */
		order: {},
	
	
		/**
		 * Type based plug-ins.
		 *
		 * Each column in DataTables has a type assigned to it, either by automatic
		 * detection or by direct assignment using the `type` option for the column.
		 * The type of a column will effect how it is ordering and search (plug-ins
		 * can also make use of the column type if required).
		 *
		 * @namespace
		 */
		type: {
			/**
			 * Type detection functions.
			 *
			 * The functions defined in this object are used to automatically detect
			 * a column's type, making initialisation of DataTables super easy, even
			 * when complex data is in the table.
			 *
			 * The functions defined take two parameters:
			 *
		     *  1. `{*}` Data from the column cell to be analysed
		     *  2. `{settings}` DataTables settings object. This can be used to
		     *     perform context specific type detection - for example detection
		     *     based on language settings such as using a comma for a decimal
		     *     place. Generally speaking the options from the settings will not
		     *     be required
			 *
			 * Each function is expected to return:
			 *
			 * * `{string|null}` Data type detected, or null if unknown (and thus
			 *   pass it on to the other type detection functions.
			 *
			 *  @type array
			 *
			 *  @example
			 *    // Currency type detection plug-in:
			 *    $.fn.dataTable.ext.type.detect.push(
			 *      function ( data, settings ) {
			 *        // Check the numeric part
			 *        if ( ! data.substring(1).match(/[0-9]/) ) {
			 *          return null;
			 *        }
			 *
			 *        // Check prefixed by currency
			 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
			 *          return 'currency';
			 *        }
			 *        return null;
			 *      }
			 *    );
			 */
			detect: [],
	
	
			/**
			 * Type based search formatting.
			 *
			 * The type based searching functions can be used to pre-format the
			 * data to be search on. For example, it can be used to strip HTML
			 * tags or to de-format telephone numbers for numeric only searching.
			 *
			 * Note that is a search is not defined for a column of a given type,
			 * no search formatting will be performed.
			 * 
			 * Pre-processing of searching data plug-ins - When you assign the sType
			 * for a column (or have it automatically detected for you by DataTables
			 * or a type detection plug-in), you will typically be using this for
			 * custom sorting, but it can also be used to provide custom searching
			 * by allowing you to pre-processing the data and returning the data in
			 * the format that should be searched upon. This is done by adding
			 * functions this object with a parameter name which matches the sType
			 * for that target column. This is the corollary of <i>afnSortData</i>
			 * for searching data.
			 *
			 * The functions defined take a single parameter:
			 *
		     *  1. `{*}` Data from the column cell to be prepared for searching
			 *
			 * Each function is expected to return:
			 *
			 * * `{string|null}` Formatted string that will be used for the searching.
			 *
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
			 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
			 *    }
			 */
			search: {},
	
	
			/**
			 * Type based ordering.
			 *
			 * The column type tells DataTables what ordering to apply to the table
			 * when a column is sorted upon. The order for each type that is defined,
			 * is defined by the functions available in this object.
			 *
			 * Each ordering option can be described by three properties added to
			 * this object:
			 *
			 * * `{type}-pre` - Pre-formatting function
			 * * `{type}-asc` - Ascending order function
			 * * `{type}-desc` - Descending order function
			 *
			 * All three can be used together, only `{type}-pre` or only
			 * `{type}-asc` and `{type}-desc` together. It is generally recommended
			 * that only `{type}-pre` is used, as this provides the optimal
			 * implementation in terms of speed, although the others are provided
			 * for compatibility with existing Javascript sort functions.
			 *
			 * `{type}-pre`: Functions defined take a single parameter:
			 *
		     *  1. `{*}` Data from the column cell to be prepared for ordering
			 *
			 * And return:
			 *
			 * * `{*}` Data to be sorted upon
			 *
			 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
			 * functions, taking two parameters:
			 *
		     *  1. `{*}` Data to compare to the second parameter
		     *  2. `{*}` Data to compare to the first parameter
			 *
			 * And returning:
			 *
			 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
			 *   than the second parameter, ===0 if the two parameters are equal and
			 *   >0 if the first parameter should be sorted height than the second
			 *   parameter.
			 * 
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    // Numeric ordering of formatted numbers with a pre-formatter
			 *    $.extend( $.fn.dataTable.ext.type.order, {
			 *      "string-pre": function(x) {
			 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
			 *        return parseFloat( a );
			 *      }
			 *    } );
			 *
			 *  @example
			 *    // Case-sensitive string ordering, with no pre-formatting method
			 *    $.extend( $.fn.dataTable.ext.order, {
			 *      "string-case-asc": function(x,y) {
			 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			 *      },
			 *      "string-case-desc": function(x,y) {
			 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
			 *      }
			 *    } );
			 */
			order: {}
		},
	
		/**
		 * Unique DataTables instance counter
		 *
		 * @type int
		 * @private
		 */
		_unique: 0,
	
	
		//
		// Depreciated
		// The following properties are retained for backwards compatiblity only.
		// The should not be used in new projects and will be removed in a future
		// version
		//
	
		/**
		 * Version check function.
		 *  @type function
		 *  @depreciated Since 1.10
		 */
		fnVersionCheck: DataTable.fnVersionCheck,
	
	
		/**
		 * Index for what 'this' index API functions should use
		 *  @type int
		 *  @deprecated Since v1.10
		 */
		iApiIndex: 0,
	
	
		/**
		 * jQuery UI class container
		 *  @type object
		 *  @deprecated Since v1.10
		 */
		oJUIClasses: {},
	
	
		/**
		 * Software version
		 *  @type string
		 *  @deprecated Since v1.10
		 */
		sVersion: DataTable.version
	};
	
	
	//
	// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
	//
	$.extend( _ext, {
		afnFiltering: _ext.search,
		aTypes:       _ext.type.detect,
		ofnSearch:    _ext.type.search,
		oSort:        _ext.type.order,
		afnSortData:  _ext.order,
		aoFeatures:   _ext.feature,
		oApi:         _ext.internal,
		oStdClasses:  _ext.classes,
		oPagination:  _ext.pager
	} );
	
	
	$.extend( DataTable.ext.classes, {
		"sTable": "dataTable",
		"sNoFooter": "no-footer",
	
		/* Paging buttons */
		"sPageButton": "paginate_button",
		"sPageButtonActive": "current",
		"sPageButtonDisabled": "disabled",
	
		/* Striping classes */
		"sStripeOdd": "odd",
		"sStripeEven": "even",
	
		/* Empty row */
		"sRowEmpty": "dataTables_empty",
	
		/* Features */
		"sWrapper": "dataTables_wrapper",
		"sFilter": "dataTables_filter",
		"sInfo": "dataTables_info",
		"sPaging": "dataTables_paginate paging_", /* Note that the type is postfixed */
		"sLength": "dataTables_length",
		"sProcessing": "dataTables_processing",
	
		/* Sorting */
		"sSortAsc": "sorting_asc",
		"sSortDesc": "sorting_desc",
		"sSortable": "sorting", /* Sortable in both directions */
		"sSortableAsc": "sorting_asc_disabled",
		"sSortableDesc": "sorting_desc_disabled",
		"sSortableNone": "sorting_disabled",
		"sSortColumn": "sorting_", /* Note that an int is postfixed for the sorting order */
	
		/* Filtering */
		"sFilterInput": "",
	
		/* Page length */
		"sLengthSelect": "",
	
		/* Scrolling */
		"sScrollWrapper": "dataTables_scroll",
		"sScrollHead": "dataTables_scrollHead",
		"sScrollHeadInner": "dataTables_scrollHeadInner",
		"sScrollBody": "dataTables_scrollBody",
		"sScrollFoot": "dataTables_scrollFoot",
		"sScrollFootInner": "dataTables_scrollFootInner",
	
		/* Misc */
		"sHeaderTH": "",
		"sFooterTH": "",
	
		// Deprecated
		"sSortJUIAsc": "",
		"sSortJUIDesc": "",
		"sSortJUI": "",
		"sSortJUIAscAllowed": "",
		"sSortJUIDescAllowed": "",
		"sSortJUIWrapper": "",
		"sSortIcon": "",
		"sJUIHeader": "",
		"sJUIFooter": ""
	} );
	
	
	var extPagination = DataTable.ext.pager;
	
	function _numbers ( page, pages ) {
		var
			numbers = [],
			buttons = extPagination.numbers_length,
			half = Math.floor( buttons / 2 ),
			i = 1;
	
		if ( pages <= buttons ) {
			numbers = _range( 0, pages );
		}
		else if ( page <= half ) {
			numbers = _range( 0, buttons-2 );
			numbers.push( 'ellipsis' );
			numbers.push( pages-1 );
		}
		else if ( page >= pages - 1 - half ) {
			numbers = _range( pages-(buttons-2), pages );
			numbers.splice( 0, 0, 'ellipsis' ); // no unshift in ie6
			numbers.splice( 0, 0, 0 );
		}
		else {
			numbers = _range( page-half+2, page+half-1 );
			numbers.push( 'ellipsis' );
			numbers.push( pages-1 );
			numbers.splice( 0, 0, 'ellipsis' );
			numbers.splice( 0, 0, 0 );
		}
	
		numbers.DT_el = 'span';
		return numbers;
	}
	
	
	$.extend( extPagination, {
		simple: function ( page, pages ) {
			return [ 'previous', 'next' ];
		},
	
		full: function ( page, pages ) {
			return [  'first', 'previous', 'next', 'last' ];
		},
	
		numbers: function ( page, pages ) {
			return [ _numbers(page, pages) ];
		},
	
		simple_numbers: function ( page, pages ) {
			return [ 'previous', _numbers(page, pages), 'next' ];
		},
	
		full_numbers: function ( page, pages ) {
			return [ 'first', 'previous', _numbers(page, pages), 'next', 'last' ];
		},
		
		first_last_numbers: function (page, pages) {
	 		return ['first', _numbers(page, pages), 'last'];
	 	},
	
		// For testing and plug-ins to use
		_numbers: _numbers,
	
		// Number of number buttons (including ellipsis) to show. _Must be odd!_
		numbers_length: 7
	} );
	
	
	$.extend( true, DataTable.ext.renderer, {
		pageButton: {
			_: function ( settings, host, idx, buttons, page, pages ) {
				var classes = settings.oClasses;
				var lang = settings.oLanguage.oPaginate;
				var aria = settings.oLanguage.oAria.paginate || {};
				var btnDisplay, btnClass, counter=0;
	
				var attach = function( container, buttons ) {
					var i, ien, node, button;
					var clickHandler = function ( e ) {
						_fnPageChange( settings, e.data.action, true );
					};
	
					for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
						button = buttons[i];
	
						if ( $.isArray( button ) ) {
							var inner = $( '<'+(button.DT_el || 'div')+'/>' )
								.appendTo( container );
							attach( inner, button );
						}
						else {
							btnDisplay = null;
							btnClass = '';
	
							switch ( button ) {
								case 'ellipsis':
									container.append('<span class="ellipsis">&#x2026;</span>');
									break;
	
								case 'first':
									btnDisplay = lang.sFirst;
									btnClass = button + (page > 0 ?
										'' : ' '+classes.sPageButtonDisabled);
									break;
	
								case 'previous':
									btnDisplay = lang.sPrevious;
									btnClass = button + (page > 0 ?
										'' : ' '+classes.sPageButtonDisabled);
									break;
	
								case 'next':
									btnDisplay = lang.sNext;
									btnClass = button + (page < pages-1 ?
										'' : ' '+classes.sPageButtonDisabled);
									break;
	
								case 'last':
									btnDisplay = lang.sLast;
									btnClass = button + (page < pages-1 ?
										'' : ' '+classes.sPageButtonDisabled);
									break;
	
								default:
									btnDisplay = button + 1;
									btnClass = page === button ?
										classes.sPageButtonActive : '';
									break;
							}
	
							if ( btnDisplay !== null ) {
								node = $('<a>', {
										'class': classes.sPageButton+' '+btnClass,
										'aria-controls': settings.sTableId,
										'aria-label': aria[ button ],
										'data-dt-idx': counter,
										'tabindex': settings.iTabIndex,
										'id': idx === 0 && typeof button === 'string' ?
											settings.sTableId +'_'+ button :
											null
									} )
									.html( btnDisplay )
									.appendTo( container );
	
								_fnBindAction(
									node, {action: button}, clickHandler
								);
	
								counter++;
							}
						}
					}
				};
	
				// IE9 throws an 'unknown error' if document.activeElement is used
				// inside an iframe or frame. Try / catch the error. Not good for
				// accessibility, but neither are frames.
				var activeEl;
	
				try {
					// Because this approach is destroying and recreating the paging
					// elements, focus is lost on the select button which is bad for
					// accessibility. So we want to restore focus once the draw has
					// completed
					activeEl = $(host).find(document.activeElement).data('dt-idx');
				}
				catch (e) {}
	
				attach( $(host).empty(), buttons );
	
				if ( activeEl !== undefined ) {
					$(host).find( '[data-dt-idx='+activeEl+']' ).focus();
				}
			}
		}
	} );
	
	
	
	// Built in type detection. See model.ext.aTypes for information about
	// what is required from this methods.
	$.extend( DataTable.ext.type.detect, [
		// Plain numbers - first since V8 detects some plain numbers as dates
		// e.g. Date.parse('55') (but not all, e.g. Date.parse('22')...).
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _isNumber( d, decimal ) ? 'num'+decimal : null;
		},
	
		// Dates (only those recognised by the browser's Date.parse)
		function ( d, settings )
		{
			// V8 tries _very_ hard to make a string passed into `Date.parse()`
			// valid, so we need to use a regex to restrict date formats. Use a
			// plug-in for anything other than ISO8601 style strings
			if ( d && !(d instanceof Date) && ! _re_date.test(d) ) {
				return null;
			}
			var parsed = Date.parse(d);
			return (parsed !== null && !isNaN(parsed)) || _empty(d) ? 'date' : null;
		},
	
		// Formatted numbers
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _isNumber( d, decimal, true ) ? 'num-fmt'+decimal : null;
		},
	
		// HTML numeric
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _htmlNumeric( d, decimal ) ? 'html-num'+decimal : null;
		},
	
		// HTML numeric, formatted
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _htmlNumeric( d, decimal, true ) ? 'html-num-fmt'+decimal : null;
		},
	
		// HTML (this is strict checking - there must be html)
		function ( d, settings )
		{
			return _empty( d ) || (typeof d === 'string' && d.indexOf('<') !== -1) ?
				'html' : null;
		}
	] );
	
	
	
	// Filter formatting functions. See model.ext.ofnSearch for information about
	// what is required from these methods.
	// 
	// Note that additional search methods are added for the html numbers and
	// html formatted numbers by `_addNumericSort()` when we know what the decimal
	// place is
	
	
	$.extend( DataTable.ext.type.search, {
		html: function ( data ) {
			return _empty(data) ?
				data :
				typeof data === 'string' ?
					data
						.replace( _re_new_lines, " " )
						.replace( _re_html, "" ) :
					'';
		},
	
		string: function ( data ) {
			return _empty(data) ?
				data :
				typeof data === 'string' ?
					data.replace( _re_new_lines, " " ) :
					data;
		}
	} );
	
	
	
	var __numericReplace = function ( d, decimalPlace, re1, re2 ) {
		if ( d !== 0 && (!d || d === '-') ) {
			return -Infinity;
		}
	
		// If a decimal place other than `.` is used, it needs to be given to the
		// function so we can detect it and replace with a `.` which is the only
		// decimal place Javascript recognises - it is not locale aware.
		if ( decimalPlace ) {
			d = _numToDecimal( d, decimalPlace );
		}
	
		if ( d.replace ) {
			if ( re1 ) {
				d = d.replace( re1, '' );
			}
	
			if ( re2 ) {
				d = d.replace( re2, '' );
			}
		}
	
		return d * 1;
	};
	
	
	// Add the numeric 'deformatting' functions for sorting and search. This is done
	// in a function to provide an easy ability for the language options to add
	// additional methods if a non-period decimal place is used.
	function _addNumericSort ( decimalPlace ) {
		$.each(
			{
				// Plain numbers
				"num": function ( d ) {
					return __numericReplace( d, decimalPlace );
				},
	
				// Formatted numbers
				"num-fmt": function ( d ) {
					return __numericReplace( d, decimalPlace, _re_formatted_numeric );
				},
	
				// HTML numeric
				"html-num": function ( d ) {
					return __numericReplace( d, decimalPlace, _re_html );
				},
	
				// HTML numeric, formatted
				"html-num-fmt": function ( d ) {
					return __numericReplace( d, decimalPlace, _re_html, _re_formatted_numeric );
				}
			},
			function ( key, fn ) {
				// Add the ordering method
				_ext.type.order[ key+decimalPlace+'-pre' ] = fn;
	
				// For HTML types add a search formatter that will strip the HTML
				if ( key.match(/^html\-/) ) {
					_ext.type.search[ key+decimalPlace ] = _ext.type.search.html;
				}
			}
		);
	}
	
	
	// Default sort methods
	$.extend( _ext.type.order, {
		// Dates
		"date-pre": function ( d ) {
			var ts = Date.parse( d );
			return isNaN(ts) ? -Infinity : ts;
		},
	
		// html
		"html-pre": function ( a ) {
			return _empty(a) ?
				'' :
				a.replace ?
					a.replace( /<.*?>/g, "" ).toLowerCase() :
					a+'';
		},
	
		// string
		"string-pre": function ( a ) {
			// This is a little complex, but faster than always calling toString,
			// http://jsperf.com/tostring-v-check
			return _empty(a) ?
				'' :
				typeof a === 'string' ?
					a.toLowerCase() :
					! a.toString ?
						'' :
						a.toString();
		},
	
		// string-asc and -desc are retained only for compatibility with the old
		// sort methods
		"string-asc": function ( x, y ) {
			return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		},
	
		"string-desc": function ( x, y ) {
			return ((x < y) ? 1 : ((x > y) ? -1 : 0));
		}
	} );
	
	
	// Numeric sorting types - order doesn't matter here
	_addNumericSort( '' );
	
	
	$.extend( true, DataTable.ext.renderer, {
		header: {
			_: function ( settings, cell, column, classes ) {
				// No additional mark-up required
				// Attach a sort listener to update on sort - note that using the
				// `DT` namespace will allow the event to be removed automatically
				// on destroy, while the `dt` namespaced event is the one we are
				// listening for
				$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
					if ( settings !== ctx ) { // need to check this this is the host
						return;               // table, not a nested one
					}
	
					var colIdx = column.idx;
	
					cell
						.removeClass(
							column.sSortingClass +' '+
							classes.sSortAsc +' '+
							classes.sSortDesc
						)
						.addClass( columns[ colIdx ] == 'asc' ?
							classes.sSortAsc : columns[ colIdx ] == 'desc' ?
								classes.sSortDesc :
								column.sSortingClass
						);
				} );
			},
	
			jqueryui: function ( settings, cell, column, classes ) {
				$('<div/>')
					.addClass( classes.sSortJUIWrapper )
					.append( cell.contents() )
					.append( $('<span/>')
						.addClass( classes.sSortIcon+' '+column.sSortingClassJUI )
					)
					.appendTo( cell );
	
				// Attach a sort listener to update on sort
				$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
					if ( settings !== ctx ) {
						return;
					}
	
					var colIdx = column.idx;
	
					cell
						.removeClass( classes.sSortAsc +" "+classes.sSortDesc )
						.addClass( columns[ colIdx ] == 'asc' ?
							classes.sSortAsc : columns[ colIdx ] == 'desc' ?
								classes.sSortDesc :
								column.sSortingClass
						);
	
					cell
						.find( 'span.'+classes.sSortIcon )
						.removeClass(
							classes.sSortJUIAsc +" "+
							classes.sSortJUIDesc +" "+
							classes.sSortJUI +" "+
							classes.sSortJUIAscAllowed +" "+
							classes.sSortJUIDescAllowed
						)
						.addClass( columns[ colIdx ] == 'asc' ?
							classes.sSortJUIAsc : columns[ colIdx ] == 'desc' ?
								classes.sSortJUIDesc :
								column.sSortingClassJUI
						);
				} );
			}
		}
	} );
	
	/*
	 * Public helper functions. These aren't used internally by DataTables, or
	 * called by any of the options passed into DataTables, but they can be used
	 * externally by developers working with DataTables. They are helper functions
	 * to make working with DataTables a little bit easier.
	 */
	
	var __htmlEscapeEntities = function ( d ) {
		return typeof d === 'string' ?
			d.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') :
			d;
	};
	
	/**
	 * Helpers for `columns.render`.
	 *
	 * The options defined here can be used with the `columns.render` initialisation
	 * option to provide a display renderer. The following functions are defined:
	 *
	 * * `number` - Will format numeric data (defined by `columns.data`) for
	 *   display, retaining the original unformatted data for sorting and filtering.
	 *   It takes 5 parameters:
	 *   * `string` - Thousands grouping separator
	 *   * `string` - Decimal point indicator
	 *   * `integer` - Number of decimal points to show
	 *   * `string` (optional) - Prefix.
	 *   * `string` (optional) - Postfix (/suffix).
	 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
	 *   parameters.
	 *
	 * @example
	 *   // Column definition using the number renderer
	 *   {
	 *     data: "salary",
	 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
	 *   }
	 *
	 * @namespace
	 */
	DataTable.render = {
		number: function ( thousands, decimal, precision, prefix, postfix ) {
			return {
				display: function ( d ) {
					if ( typeof d !== 'number' && typeof d !== 'string' ) {
						return d;
					}
	
					var negative = d < 0 ? '-' : '';
					var flo = parseFloat( d );
	
					// If NaN then there isn't much formatting that we can do - just
					// return immediately, escaping any HTML (this was supposed to
					// be a number after all)
					if ( isNaN( flo ) ) {
						return __htmlEscapeEntities( d );
					}
	
					flo = flo.toFixed( precision );
					d = Math.abs( flo );
	
					var intPart = parseInt( d, 10 );
					var floatPart = precision ?
						decimal+(d - intPart).toFixed( precision ).substring( 2 ):
						'';
	
					return negative + (prefix||'') +
						intPart.toString().replace(
							/\B(?=(\d{3})+(?!\d))/g, thousands
						) +
						floatPart +
						(postfix||'');
				}
			};
		},
	
		text: function () {
			return {
				display: __htmlEscapeEntities,
				filter: __htmlEscapeEntities
			};
		}
	};
	
	
	/*
	 * This is really a good bit rubbish this method of exposing the internal methods
	 * publicly... - To be fixed in 2.0 using methods on the prototype
	 */
	
	
	/**
	 * Create a wrapper function for exporting an internal functions to an external API.
	 *  @param {string} fn API function name
	 *  @returns {function} wrapped function
	 *  @memberof DataTable#internal
	 */
	function _fnExternApiFunc (fn)
	{
		return function() {
			var args = [_fnSettingsFromNode( this[DataTable.ext.iApiIndex] )].concat(
				Array.prototype.slice.call(arguments)
			);
			return DataTable.ext.internal[fn].apply( this, args );
		};
	}
	
	
	/**
	 * Reference to internal functions for use by plug-in developers. Note that
	 * these methods are references to internal functions and are considered to be
	 * private. If you use these methods, be aware that they are liable to change
	 * between versions.
	 *  @namespace
	 */
	$.extend( DataTable.ext.internal, {
		_fnExternApiFunc: _fnExternApiFunc,
		_fnBuildAjax: _fnBuildAjax,
		_fnAjaxUpdate: _fnAjaxUpdate,
		_fnAjaxParameters: _fnAjaxParameters,
		_fnAjaxUpdateDraw: _fnAjaxUpdateDraw,
		_fnAjaxDataSrc: _fnAjaxDataSrc,
		_fnAddColumn: _fnAddColumn,
		_fnColumnOptions: _fnColumnOptions,
		_fnAdjustColumnSizing: _fnAdjustColumnSizing,
		_fnVisibleToColumnIndex: _fnVisibleToColumnIndex,
		_fnColumnIndexToVisible: _fnColumnIndexToVisible,
		_fnVisbleColumns: _fnVisbleColumns,
		_fnGetColumns: _fnGetColumns,
		_fnColumnTypes: _fnColumnTypes,
		_fnApplyColumnDefs: _fnApplyColumnDefs,
		_fnHungarianMap: _fnHungarianMap,
		_fnCamelToHungarian: _fnCamelToHungarian,
		_fnLanguageCompat: _fnLanguageCompat,
		_fnBrowserDetect: _fnBrowserDetect,
		_fnAddData: _fnAddData,
		_fnAddTr: _fnAddTr,
		_fnNodeToDataIndex: _fnNodeToDataIndex,
		_fnNodeToColumnIndex: _fnNodeToColumnIndex,
		_fnGetCellData: _fnGetCellData,
		_fnSetCellData: _fnSetCellData,
		_fnSplitObjNotation: _fnSplitObjNotation,
		_fnGetObjectDataFn: _fnGetObjectDataFn,
		_fnSetObjectDataFn: _fnSetObjectDataFn,
		_fnGetDataMaster: _fnGetDataMaster,
		_fnClearTable: _fnClearTable,
		_fnDeleteIndex: _fnDeleteIndex,
		_fnInvalidate: _fnInvalidate,
		_fnGetRowElements: _fnGetRowElements,
		_fnCreateTr: _fnCreateTr,
		_fnBuildHead: _fnBuildHead,
		_fnDrawHead: _fnDrawHead,
		_fnDraw: _fnDraw,
		_fnReDraw: _fnReDraw,
		_fnAddOptionsHtml: _fnAddOptionsHtml,
		_fnDetectHeader: _fnDetectHeader,
		_fnGetUniqueThs: _fnGetUniqueThs,
		_fnFeatureHtmlFilter: _fnFeatureHtmlFilter,
		_fnFilterComplete: _fnFilterComplete,
		_fnFilterCustom: _fnFilterCustom,
		_fnFilterColumn: _fnFilterColumn,
		_fnFilter: _fnFilter,
		_fnFilterCreateSearch: _fnFilterCreateSearch,
		_fnEscapeRegex: _fnEscapeRegex,
		_fnFilterData: _fnFilterData,
		_fnFeatureHtmlInfo: _fnFeatureHtmlInfo,
		_fnUpdateInfo: _fnUpdateInfo,
		_fnInfoMacros: _fnInfoMacros,
		_fnInitialise: _fnInitialise,
		_fnInitComplete: _fnInitComplete,
		_fnLengthChange: _fnLengthChange,
		_fnFeatureHtmlLength: _fnFeatureHtmlLength,
		_fnFeatureHtmlPaginate: _fnFeatureHtmlPaginate,
		_fnPageChange: _fnPageChange,
		_fnFeatureHtmlProcessing: _fnFeatureHtmlProcessing,
		_fnProcessingDisplay: _fnProcessingDisplay,
		_fnFeatureHtmlTable: _fnFeatureHtmlTable,
		_fnScrollDraw: _fnScrollDraw,
		_fnApplyToChildren: _fnApplyToChildren,
		_fnCalculateColumnWidths: _fnCalculateColumnWidths,
		_fnThrottle: _fnThrottle,
		_fnConvertToWidth: _fnConvertToWidth,
		_fnGetWidestNode: _fnGetWidestNode,
		_fnGetMaxLenString: _fnGetMaxLenString,
		_fnStringToCss: _fnStringToCss,
		_fnSortFlatten: _fnSortFlatten,
		_fnSort: _fnSort,
		_fnSortAria: _fnSortAria,
		_fnSortListener: _fnSortListener,
		_fnSortAttachListener: _fnSortAttachListener,
		_fnSortingClasses: _fnSortingClasses,
		_fnSortData: _fnSortData,
		_fnSaveState: _fnSaveState,
		_fnLoadState: _fnLoadState,
		_fnSettingsFromNode: _fnSettingsFromNode,
		_fnLog: _fnLog,
		_fnMap: _fnMap,
		_fnBindAction: _fnBindAction,
		_fnCallbackReg: _fnCallbackReg,
		_fnCallbackFire: _fnCallbackFire,
		_fnLengthOverflow: _fnLengthOverflow,
		_fnRenderer: _fnRenderer,
		_fnDataSource: _fnDataSource,
		_fnRowAttributes: _fnRowAttributes,
		_fnExtend: _fnExtend,
		_fnCalculateEnd: function () {} // Used by a lot of plug-ins, but redundant
		                                // in 1.10, so this dead-end function is
		                                // added to prevent errors
	} );
	

	// jQuery access
	$.fn.dataTable = DataTable;

	// Provide access to the host jQuery object (circular reference)
	DataTable.$ = $;

	// Legacy aliases
	$.fn.dataTableSettings = DataTable.settings;
	$.fn.dataTableExt = DataTable.ext;

	// With a capital `D` we return a DataTables API instance rather than a
	// jQuery object
	$.fn.DataTable = function ( opts ) {
		return $(this).dataTable( opts ).api();
	};

	// All properties that are available to $.fn.dataTable should also be
	// available on $.fn.DataTable
	$.each( DataTable, function ( prop, val ) {
		$.fn.DataTable[ prop ] = val;
	} );


	// Information about events fired by DataTables - for documentation.
	/**
	 * Draw event, fired whenever the table is redrawn on the page, at the same
	 * point as fnDrawCallback. This may be useful for binding events or
	 * performing calculations when the table is altered at all.
	 *  @name DataTable#draw.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * Search event, fired when the searching applied to the table (using the
	 * built-in global search, or column filters) is altered.
	 *  @name DataTable#search.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * Page change event, fired when the paging of the table is altered.
	 *  @name DataTable#page.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * Order event, fired when the ordering applied to the table is altered.
	 *  @name DataTable#order.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * DataTables initialisation complete event, fired when the table is fully
	 * drawn, including Ajax data loaded, if Ajax data is required.
	 *  @name DataTable#init.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The JSON object request from the server - only
	 *    present if client-side Ajax sourced data is used</li></ol>
	 */

	/**
	 * State save event, fired when the table has changed state a new state save
	 * is required. This event allows modification of the state saving object
	 * prior to actually doing the save, including addition or other state
	 * properties (for plug-ins) or modification of a DataTables core property.
	 *  @name DataTable#stateSaveParams.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The state information to be saved
	 */

	/**
	 * State load event, fired when the table is loading state from the stored
	 * data, but prior to the settings object being modified by the saved state
	 * - allowing modification of the saved state is required or loading of
	 * state for a plug-in.
	 *  @name DataTable#stateLoadParams.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The saved state information
	 */

	/**
	 * State loaded event, fired when state has been loaded from stored data and
	 * the settings object has been modified by the loaded data.
	 *  @name DataTable#stateLoaded.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The saved state information
	 */

	/**
	 * Processing event, fired when DataTables is doing some kind of processing
	 * (be it, order, searcg or anything else). It can be used to indicate to
	 * the end user that there is something happening, or that something has
	 * finished.
	 *  @name DataTable#processing.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {boolean} bShow Flag for if DataTables is doing processing or not
	 */

	/**
	 * Ajax (XHR) event, fired whenever an Ajax request is completed from a
	 * request to made to the server for new data. This event is called before
	 * DataTables processed the returned data, so it can also be used to pre-
	 * process the data returned from the server, if needed.
	 *
	 * Note that this trigger is called in `fnServerData`, if you override
	 * `fnServerData` and which to use this event, you need to trigger it in you
	 * success function.
	 *  @name DataTable#xhr.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 *  @param {object} json JSON returned from the server
	 *
	 *  @example
	 *     // Use a custom property returned from the server in another DOM element
	 *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
	 *       $('#status').html( json.status );
	 *     } );
	 *
	 *  @example
	 *     // Pre-process the data returned from the server
	 *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
	 *       for ( var i=0, ien=json.aaData.length ; i<ien ; i++ ) {
	 *         json.aaData[i].sum = json.aaData[i].one + json.aaData[i].two;
	 *       }
	 *       // Note no return - manipulate the data directly in the JSON object.
	 *     } );
	 */

	/**
	 * Destroy event, fired when the DataTable is destroyed by calling fnDestroy
	 * or passing the bDestroy:true parameter in the initialisation object. This
	 * can be used to remove bound events, added DOM nodes, etc.
	 *  @name DataTable#destroy.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * Page length change event, fired when number of records to show on each
	 * page (the length) is changed.
	 *  @name DataTable#length.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 *  @param {integer} len New length
	 */

	/**
	 * Column sizing has changed.
	 *  @name DataTable#column-sizing.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * Column visibility has changed.
	 *  @name DataTable#column-visibility.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 *  @param {int} column Column index
	 *  @param {bool} vis `false` if column now hidden, or `true` if visible
	 */

	return $.fn.dataTable;
}));


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collapsible_vue__ = __webpack_require__(437);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98a2b5c4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Collapsible_vue__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1950)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-98a2b5c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collapsible_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98a2b5c4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Collapsible_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98a2b5c4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Collapsible_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(37);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(28);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exportExcelFromApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



/**
 * Trigger Excel download from an API endpoint.
 * Reads filename from Content-Disposition (UTF-8 RFC 5987) or falls back.
 * @param {string} url - API endpoint
 * @param {object} params - query params { year, agentCode }
 * @param {string} fallbackFilename - used if server doesn't send Content-Disposition
 * @param {string} authToken - bearer token (optional, for axios config)
 * @returns {Promise<void>}
 */
var exportExcelFromApi = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, params, fallbackFilename, authToken) {
        var response, cd, filename, m1, m2, blob, blobUrl, link;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                            url: url,
                            method: "GET",
                            params: params,
                            responseType: "blob",
                            headers: authToken ? { Authorization: "Bearer " + authToken } : {}
                        });

                    case 2:
                        response = _context.sent;


                        // Parse filename from Content-Disposition
                        cd = response.headers["content-disposition"] || "";
                        filename = fallbackFilename || "report.xlsx";
                        m1 = /filename\*=UTF-8''([^;]+)/i.exec(cd);
                        m2 = /filename="?([^";]+)"?/i.exec(cd);

                        if (m1) {
                            try {
                                filename = decodeURIComponent(m1[1]);
                            } catch (e) {/* keep fallback */}
                        } else if (m2) {
                            filename = m2[1];
                        }

                        blob = new Blob([response.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        });
                        blobUrl = window.URL.createObjectURL(blob);
                        link = document.createElement("a");

                        link.href = blobUrl;
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setTimeout(function () {
                            return window.URL.revokeObjectURL(blobUrl);
                        }, 1000);

                    case 17:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function exportExcelFromApi(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(51);
var IObject = __webpack_require__(86);
var toObject = __webpack_require__(36);
var toLength = __webpack_require__(32);
var asc = __webpack_require__(109);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(8);
var core = __webpack_require__(50);
var fails = __webpack_require__(28);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(29);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (options) {
  var mappedProps = options.mappedProps,
      name = options.name,
      ctr = options.ctr,
      ctrArgs = options.ctrArgs,
      events = options.events,
      beforeCreate = options.beforeCreate,
      afterCreate = options.afterCreate,
      props = options.props,
      rest = _objectWithoutProperties(options, ['mappedProps', 'name', 'ctr', 'ctrArgs', 'events', 'beforeCreate', 'afterCreate', 'props']);

  var promiseName = '$' + name + 'Promise';
  var instanceName = '$' + name + 'Object';

  assert(!(rest.props instanceof Array), '`props` should be an object, not Array');

  return _extends({}, typeof GENERATE_DOC !== 'undefined' ? { $vgmOptions: options } : {}, {
    mixins: [_mapElementMixin2.default],
    props: _extends({}, props, mappedPropsToVueProps(mappedProps)),
    render: function render() {
      return '';
    },
    provide: function provide() {
      var _this = this;

      var promise = this.$mapPromise.then(function (map) {
        // Infowindow needs this to be immediately available
        _this.$map = map;

        // Initialize the maps with the given options
        var options = _extends({}, _this.options, {
          map: map
        }, (0, _bindProps.getPropsValues)(_this, mappedProps));
        delete options.options; // delete the extra options

        if (beforeCreate) {
          var result = beforeCreate.bind(_this)(options);

          if (result instanceof Promise) {
            return result.then(function () {
              return { options: options };
            });
          }
        }
        return { options: options };
      }).then(function (_ref) {
        var _Function$prototype$b;

        var options = _ref.options;

        var ConstructorObject = ctr();
        // https://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
        _this[instanceName] = ctrArgs ? new ((_Function$prototype$b = Function.prototype.bind).call.apply(_Function$prototype$b, [ConstructorObject, null].concat(_toConsumableArray(ctrArgs(options, (0, _bindProps.getPropsValues)(_this, props || {}))))))() : new ConstructorObject(options);

        (0, _bindProps.bindProps)(_this, _this[instanceName], mappedProps);
        (0, _bindEvents2.default)(_this, _this[instanceName], events);

        if (afterCreate) {
          afterCreate.bind(_this)(_this[instanceName]);
        }
        return _this[instanceName];
      });
      this[promiseName] = promise;
      return _defineProperty({}, promiseName, promise);
    },
    destroyed: function destroyed() {
      // Note: not all Google Maps components support maps
      if (this[instanceName] && this[instanceName].setMap) {
        this[instanceName].setMap(null);
      }
    }
  }, rest);
};

exports.mappedPropsToVueProps = mappedPropsToVueProps;

var _bindEvents = __webpack_require__(139);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(91);

var _mapElementMixin = __webpack_require__(629);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 *
 * @param {Object} options
 * @param {Object} options.mappedProps - Definitions of props
 * @param {Object} options.mappedProps.PROP.type - Value type
 * @param {Boolean} options.mappedProps.PROP.twoWay
 *  - Whether the prop has a corresponding PROP_changed
 *   event
 * @param {Boolean} options.mappedProps.PROP.noBind
 *  - If true, do not apply the default bindProps / bindEvents.
 * However it will still be added to the list of component props
 * @param {Object} options.props - Regular Vue-style props.
 *  Note: must be in the Object form because it will be
 *  merged with the `mappedProps`
 *
 * @param {Object} options.events - Google Maps API events
 *  that are not bound to a corresponding prop
 * @param {String} options.name - e.g. `polyline`
 * @param {=> String} options.ctr - constructor, e.g.
 *  `google.maps.Polyline`. However, since this is not
 *  generally available during library load, this becomes
 *  a function instead, e.g. () => google.maps.Polyline
 *  which will be called only after the API has been loaded
 * @param {(MappedProps, OtherVueProps) => Array} options.ctrArgs -
 *   If the constructor in `ctr` needs to be called with
 *   arguments other than a single `options` object, e.g. for
 *   GroundOverlay, we call `new GroundOverlay(url, bounds, options)`
 *   then pass in a function that returns the argument list as an array
 *
 * Otherwise, the constructor will be called with an `options` object,
 *   with property and values merged from:
 *
 *   1. the `options` property, if any
 *   2. a `map` property with the Google Maps
 *   3. all the properties passed to the component in `mappedProps`
 * @param {Object => Any} options.beforeCreate -
 *  Hook to modify the options passed to the initializer
 * @param {(options.ctr, Object) => Any} options.afterCreate -
 *  Hook called when
 *
 */


function assert(v, message) {
  if (!v) throw new Error(message);
}

/**
 * Strips out the extraneous properties we have in our
 * props definitions
 * @param {Object} props
 */
function mappedPropsToVueProps(mappedProps) {
  return Object.entries(mappedProps).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        prop = _ref4[1];

    var value = {};

    if ('type' in prop) value.type = prop.type;
    if ('default' in prop) value.default = prop.default;
    if ('required' in prop) value.required = prop.required;

    return [key, value];
  }).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        val = _ref6[1];

    acc[key] = val;
    return acc;
  }, {});
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(477);
var $export = __webpack_require__(8);
var shared = __webpack_require__(88)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(481))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(33)) {
  var LIBRARY = __webpack_require__(65);
  var global = __webpack_require__(27);
  var fails = __webpack_require__(28);
  var $export = __webpack_require__(8);
  var $typed = __webpack_require__(104);
  var $buffer = __webpack_require__(130);
  var ctx = __webpack_require__(51);
  var anInstance = __webpack_require__(68);
  var propertyDesc = __webpack_require__(73);
  var hide = __webpack_require__(39);
  var redefineAll = __webpack_require__(74);
  var toInteger = __webpack_require__(53);
  var toLength = __webpack_require__(32);
  var toIndex = __webpack_require__(475);
  var toAbsoluteIndex = __webpack_require__(76);
  var toPrimitive = __webpack_require__(58);
  var has = __webpack_require__(43);
  var classof = __webpack_require__(81);
  var isObject = __webpack_require__(29);
  var toObject = __webpack_require__(36);
  var isArrayIter = __webpack_require__(116);
  var create = __webpack_require__(70);
  var getPrototypeOf = __webpack_require__(45);
  var gOPN = __webpack_require__(71).f;
  var getIterFn = __webpack_require__(132);
  var uid = __webpack_require__(77);
  var wks = __webpack_require__(31);
  var createArrayMethod = __webpack_require__(55);
  var createArrayIncludes = __webpack_require__(92);
  var speciesConstructor = __webpack_require__(89);
  var ArrayIterators = __webpack_require__(133);
  var Iterators = __webpack_require__(82);
  var $iterDetect = __webpack_require__(97);
  var setSpecies = __webpack_require__(75);
  var arrayFill = __webpack_require__(108);
  var arrayCopyWithin = __webpack_require__(447);
  var $DP = __webpack_require__(34);
  var $GOPD = __webpack_require__(44);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductItemRow_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f07a858_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItemRow_vue__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1845)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f07a858"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductItemRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f07a858_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItemRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f07a858_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItemRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installFssTooltips;
/* =============================================================================
   CR-FormSummaryStock — FS-088 tooltip ของปุ่มวงกลม (.fss-act) ทั้งโมดูล

   เดิมใช้ title ของ browser ล้วน ๆ ซึ่ง "บางครั้งไม่ขึ้น" (QA แจ้ง 14/10/2026):
     ต้องวางเมาส์นิ่ง ~1 วินาที · ขึ้นแล้วหายเอง · ไม่ขึ้นซ้ำจนกว่าเอาเมาส์ออก-เข้าใหม่ · หลังคลิกไม่ขึ้น
   เปลี่ยนเป็น tooltip ของ Bootstrap 4 (โหลดอยู่แล้วทั้งระบบผ่าน Metronic vendors.bundle.js)
   ขึ้นทันทีที่ hover และหน้าตาเหมือนกันทุก browser

   ── ทำไมผูกแบบ delegate ที่ body ครั้งเดียว ───────────────────────────────────
   ปุ่มถูกวาดใหม่ตลอด (DataTables วาดแถวใหม่ทุกครั้งที่ค้นหา · v-if ใน popup)
   ผูกรายปุ่มต้องตามผูก/ถอดทุกครั้ง พลาดเมื่อไรก็ได้ tooltip ค้าง
   option `selector` ของ Bootstrap สร้าง tooltip ให้ปุ่มตอน hover ครั้งแรกเอง ปุ่มใหม่จึงได้ด้วยเสมอ

   ── title ยังอยู่บนปุ่ม ─────────────────────────────────────────────────────
   Bootstrap ปกติย้าย title ไป data-original-title ถาวร (กัน tooltip ของ browser ซ้อน)
   ที่นี่ย้ายเฉพาะตอนแสดง แล้วคืนตอนซ่อน เพราะ
     • Vue เขียน :title ใหม่เมื่อข้อความเปลี่ยน (เช่นปุ่มลบในแถบลายเซ็นสลับตามสถานะ)
       ถ้าย้ายถาวร Bootstrap จะแสดงข้อความเก่าค้าง
     • เทสและโค้ดเดิมอ่าน title ของปุ่มอยู่หลายจุด
   ============================================================================= */

var installed = false;
var retryTimer = null;
var retries = 0;

function installFssTooltips() {
  if (installed) return;

  // App.vue ตั้ง window.jQuery เป็นตัวใน bundle (ไม่มี plugin ของ Bootstrap) ก่อน
  // แล้วค่อยโหลด vendors.bundle.js ของ Metronic แบบ async ซึ่งแทน window.jQuery ด้วยตัวที่มี .tooltip
  // ตอนโมดูลนี้ถูกโหลดจึงอาจยังไม่พร้อม — รอเช็คซ้ำทุก 0.5 วินาที (สูงสุด ~30 วินาที)
  var $ = window.jQuery;
  if (!$ || !$.fn || !$.fn.tooltip) {
    if (!retryTimer && retries < 60) {
      retries++;
      retryTimer = setTimeout(function () {
        retryTimer = null;
        installFssTooltips();
      }, 500);
    }
    return;
  }
  installed = true;

  var BTN = ".fss-act";

  $(document.body).tooltip({
    selector: BTN + "[title], " + BTN + "[data-original-title]",
    container: "body",
    trigger: "hover",
    boundary: "window",
    template: '<div class="tooltip fss-tooltip" role="tooltip">' + '<div class="arrow"></div><div class="tooltip-inner"></div></div>'
  });

  // ก่อนแสดง: เอาข้อความล่าสุดจาก title (Vue อาจเพิ่งเปลี่ยน) แล้วซ่อน title ไม่ให้ tooltip ของ browser ซ้อน
  $(document.body).on("show.bs.tooltip", BTN, function () {
    var title = this.getAttribute("title");
    if (title) {
      this.setAttribute("data-original-title", title);
      this.setAttribute("title", "");
    }
  });

  // ซ่อนแล้ว: คืน title ให้ปุ่มเหมือนเดิม
  $(document.body).on("hidden.bs.tooltip", BTN, function () {
    var original = this.getAttribute("data-original-title");
    if (original && !this.getAttribute("title")) {
      this.setAttribute("title", original);
    }
  });

  // คลิกแล้วปุ่มมักหายไปทันที (ลบแถว · ปิด popup · v-if) ถ้าไม่ปิดก่อน tooltip จะค้างกลางจอ
  $(document).on("mousedown", function () {
    $(BTN).each(function () {
      if ($(this).data("bs.tooltip")) $(this).tooltip("hide");
    });
    $(".fss-tooltip").remove();
  });
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(31)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(39)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(77)('meta');
var isObject = __webpack_require__(29);
var has = __webpack_require__(43);
var setDesc = __webpack_require__(34).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(28)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(866);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("31853880", content, true, {});

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(51);
var call = __webpack_require__(458);
var isArrayIter = __webpack_require__(116);
var anObject = __webpack_require__(26);
var toLength = __webpack_require__(32);
var getIterFn = __webpack_require__(132);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(26);
var dPs = __webpack_require__(464);
var enumBugKeys = __webpack_require__(112);
var IE_PROTO = __webpack_require__(125)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(111)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(114).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(466);
var hiddenKeys = __webpack_require__(112).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(466);
var enumBugKeys = __webpack_require__(112);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(40);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(27);
var dP = __webpack_require__(34);
var DESCRIPTORS = __webpack_require__(33);
var SPECIES = __webpack_require__(31)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(53);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CurrencyDirective */
/* unused harmony export CurrencyInput */
/* unused harmony export parseCurrency */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/**
 * Vue Currency Input 1.13.0
 * (c) 2019 Matthias Stiller
 * @license MIT
 */


var createCurrencyFormat = function (numberFormat) {
  var ps = numberFormat.format(123456);
  var ns = numberFormat.format(-1);
  var minimumFractionDigits = numberFormat.resolvedOptions().minimumFractionDigits || 0;
  var maximumFractionDigits = numberFormat.resolvedOptions().maximumFractionDigits || 0;
  var decimalSymbol = minimumFractionDigits > 0 ? ps.substr(ps.indexOf('6') + 1, 1) : null;
  var prefix = ps.substring(0, ps.indexOf('1'));
  var negativePrefix = ns.substring(0, ns.indexOf('1'));
  var suffix = ps.substring(ps.lastIndexOf(minimumFractionDigits > 0 ? '0' : '6') + 1);
  var groupingSymbol = ps.substr(ps.indexOf('3') + 1, 1);
  return {
    prefix: prefix,
    negativePrefix: negativePrefix,
    suffix: suffix,
    groupingSymbol: groupingSymbol,
    decimalSymbol: decimalSymbol,
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits
  }
};
function createCurrencyFormat$1 (ref) {
  var locale = ref.locale;
  var currency = ref.currency;
  var precision = ref.precision;
  var autoDecimalMode = ref.autoDecimalMode;
  var valueAsInteger = ref.valueAsInteger;
  var minimumFractionDigits = 2;
  var maximumFractionDigits = 2;
  if (typeof precision === 'number') {
    minimumFractionDigits = maximumFractionDigits = precision;
  } else if (typeof precision === 'object' && !autoDecimalMode && !valueAsInteger) {
    minimumFractionDigits = precision.min || 0;
    maximumFractionDigits = precision.max !== undefined ? precision.max : 20;
  }
  if (currency == null) {
    return createCurrencyFormat(new Intl.NumberFormat(locale, { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: maximumFractionDigits }))
  } else if (typeof currency === 'object') {
    return Object.assign({}, createCurrencyFormat(new Intl.NumberFormat(locale, { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: maximumFractionDigits })),
      {prefix: currency.prefix || '',
      negativePrefix: ("-" + (currency.prefix || '')),
      suffix: currency.suffix || ''})
  } else {
    var currencyFormat = createCurrencyFormat(new Intl.NumberFormat(locale, { currency: currency, style: 'currency' }));
    if (precision !== undefined) {
      if (currencyFormat.minimumFractionDigits > 0) {
        currencyFormat.minimumFractionDigits = minimumFractionDigits;
      }
      if (currencyFormat.maximumFractionDigits > 0) {
        currencyFormat.maximumFractionDigits = maximumFractionDigits;
      }
    }
    return currencyFormat
  }
}

var removeLeadingZeros = function (str) { return str.replace(/^0+(0$|[^0])/, '$1'); };
var onlyDigits = function (str) { return str.replace(/\D+/g, ''); };
var count = function (str, search) { return (str.match(new RegExp(("\\" + search), 'g')) || []).length; };
var endsWith = function (str, search) {
  return str.substring(str.length - search.length, str.length) === search
};
var startsWith = function (str, search) {
  return str.substring(0, search.length) === search
};
var stripCurrencySymbolAndMinusSign = function (str, ref) {
  var prefix = ref.prefix;
  var suffix = ref.suffix;
  var value = str.replace(prefix, '').replace(suffix, '');
  return {
    value: value.replace('-', ''),
    negative: startsWith(value, '-')
  }
};
var isNumber = function (str) { return str.match(/^-?\d+(\.\d+)?$/); };

var toInteger = function (number, valueAsInteger, fractionDigits) {
  return valueAsInteger ? Number(number.toFixed(fractionDigits).split('.').join('')) : number
};
var toFloat = function (number, valueAsInteger, fractionDigits) {
  return valueAsInteger ? number / Math.pow(10, fractionDigits) : number
};

function parse (str, currencyFormat, valueAsInteger) {
  if ( valueAsInteger === void 0 ) valueAsInteger = false;
  if (typeof str === 'string') {
    if (isNumber(str)) {
      return toInteger(Number(str), valueAsInteger, currencyFormat.minimumFractionDigits)
    }
    var ref = stripCurrencySymbolAndMinusSign(str, currencyFormat);
    var value = ref.value;
    var negative = ref.negative;
    var numberParts = value.split(currencyFormat.decimalSymbol);
    if (numberParts.length > 2) {
      return null
    }
    var integer = numberParts[0].replace(new RegExp(("\\" + (currencyFormat.groupingSymbol)), 'g'), '');
    if (integer.length && !integer.match(/^\d+$/g)) {
      return null
    }
    var number = integer;
    if (numberParts.length === 2) {
      var fraction = numberParts[1];
      if (fraction.length && !fraction.match(/^\d+$/g)) {
        return null
      }
      number += "." + fraction;
    }
    if (number) {
      if (negative) {
        number = "-" + number;
      }
      return toInteger(Number(number), valueAsInteger, currencyFormat.minimumFractionDigits)
    }
  }
  return null
}

var parseCurrency = function (formattedValue, options) { return parse(formattedValue, createCurrencyFormat$1(options), options.valueAsInteger); };

var DEFAULT_OPTIONS = {
  locale: undefined,
  currency: 'EUR',
  valueAsInteger: false,
  distractionFree: true,
  precision: undefined,
  autoDecimalMode: false,
  min: null,
  max: null
};

var setCaretPosition = function (el, position) { return el.setSelectionRange(position, position); };
var getCaretPositionAfterFormat = function (newValue, inputtedValue, caretPosition, currencyFormat, options) {
  var prefix = currencyFormat.prefix;
  var suffix = currencyFormat.suffix;
  var decimalSymbol = currencyFormat.decimalSymbol;
  var maximumFractionDigits = currencyFormat.maximumFractionDigits;
  var groupingSymbol = currencyFormat.groupingSymbol;
  var decimalSymbolPosition = inputtedValue.indexOf(decimalSymbol) + 1;
  var caretPositionFromLeft = inputtedValue.length - caretPosition;
  if (Math.abs(newValue.length - inputtedValue.length) > 1 && caretPosition <= decimalSymbolPosition) {
    return newValue.indexOf(decimalSymbol) + 1
  } else if (newValue.substr(caretPosition, 1) === groupingSymbol && count(newValue, groupingSymbol) === count(inputtedValue, groupingSymbol) + 1) {
    return newValue.length - caretPositionFromLeft - 1
  } else {
    if (!options.autoDecimalMode && decimalSymbolPosition !== 0 && caretPosition > decimalSymbolPosition) {
      if (onlyDigits(inputtedValue.substr(decimalSymbolPosition)).length - 1 === maximumFractionDigits) {
        caretPositionFromLeft -= 1;
      }
    }
    return options.distractionFree.hideCurrencySymbol
      ? newValue.length - caretPositionFromLeft
      : Math.max(newValue.length - Math.max(caretPositionFromLeft, suffix.length), prefix.length === 0 ? 0 : prefix.length + 1)
  }
};
var getDistractionFreeCaretPosition = function (formatConfig, options, value, caretPosition) {
  var result = caretPosition;
  if (options.distractionFree.hideCurrencySymbol) {
    result -= formatConfig.prefix.length;
  }
  if (options.distractionFree.hideGroupingSymbol) {
    result -= count(value.substring(0, caretPosition), formatConfig.groupingSymbol);
  }
  return Math.max(0, result)
};

var isValidInteger = function (integer, groupingSymbol) { return integer.match(new RegExp(("^-?(0|[1-9]\\d{0,2}(\\" + groupingSymbol + "?\\d{3})*)$"))); };
var isFractionIncomplete = function (value, ref) {
  var decimalSymbol = ref.decimalSymbol;
  var groupingSymbol = ref.groupingSymbol;
  var numberParts = value.split(decimalSymbol);
  return endsWith(value, decimalSymbol) && numberParts.length === 2 && isValidInteger(numberParts[0], groupingSymbol)
};
var checkIncompleteValue = function (value, negative, previousConformedValue, formatConfig) {
  var prefix = formatConfig.prefix;
  var negativePrefix = formatConfig.negativePrefix;
  var suffix = formatConfig.suffix;
  var decimalSymbol = formatConfig.decimalSymbol;
  var maximumFractionDigits = formatConfig.maximumFractionDigits;
  if (value === '' && negative && previousConformedValue !== negativePrefix) {
    return ("" + negativePrefix + suffix)
  } else if (maximumFractionDigits > 0) {
    if (isFractionIncomplete(value, formatConfig)) {
      return ("" + (negative ? negativePrefix : prefix) + value + suffix)
    } else if (startsWith(value, decimalSymbol)) {
      return ((negative ? negativePrefix : prefix) + "0" + decimalSymbol + ((onlyDigits(value.substr(1)).substr(0, maximumFractionDigits))) + suffix)
    }
  }
  return null
};
var getAutoDecimalModeConformedValue = function (value, previousConformedValue, ref) {
  var minimumFractionDigits = ref.minimumFractionDigits;
  if (value === '') {
    return { conformedValue: '' }
  } else {
    var negative = startsWith(value, '-');
    var conformedValue = value === '-' ? Number(-0) : Number(("" + (negative ? '-' : '') + (removeLeadingZeros(onlyDigits(value))))) / Math.pow(10, minimumFractionDigits);
    return {
      conformedValue: conformedValue,
      fractionDigits: conformedValue.toFixed(minimumFractionDigits).slice(-minimumFractionDigits)
    }
  }
};
var isFractionInvalid = function (fraction, numberOfFractionDigits) { return fraction.length > 0 && numberOfFractionDigits === 0; };
function conformToMask (str, formatConfig, options, previousConformedValue) {
  if ( previousConformedValue === void 0 ) previousConformedValue = '';
  if (typeof str === 'string') {
    str = str.trim();
    if (formatConfig.minimumFractionDigits > 0 && options.autoDecimalMode) {
      return getAutoDecimalModeConformedValue(str, previousConformedValue, formatConfig)
    }
    var ref = stripCurrencySymbolAndMinusSign(str, formatConfig);
    var value = ref.value;
    var negative = ref.negative;
    var incompleteValue = checkIncompleteValue(value, negative, previousConformedValue, formatConfig);
    if (incompleteValue != null) {
      return { conformedValue: incompleteValue }
    }
    var ref$1 = value.split(formatConfig.decimalSymbol);
    var integer = ref$1[0];
    var fraction = ref$1.slice(1);
    var integerDigits = removeLeadingZeros(onlyDigits(integer));
    var fractionDigits = onlyDigits(fraction.join('')).substr(0, formatConfig.maximumFractionDigits);
    if (isFractionInvalid(fraction, fractionDigits.length)) {
      return { conformedValue: previousConformedValue }
    }
    var number = integerDigits;
    if (negative) {
      number = "-" + number;
    }
    if (isNumber(number)) {
      return {
        conformedValue: Number((number + "." + fractionDigits)),
        fractionDigits: fractionDigits
      }
    } else if (number === '-' && previousConformedValue !== formatConfig.negativePrefix) {
      return { conformedValue: previousConformedValue }
    } else {
      return { conformedValue: '' }
    }
  }
  return { conformedValue: previousConformedValue }
}

function dispatchEvent (el, eventName, data) {
  var event = document.createEvent('CustomEvent');
  event.initCustomEvent(eventName, true, true, data);
  el.dispatchEvent(event);
}

var equal = function (a, b) {
  if (a === b) {
    return true
  }
  if (a.valueOf !== Object.prototype.valueOf) {
    return a.valueOf() === b.valueOf()
  }
  var keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) {
    return false
  }
  if (!keys.every(Object.prototype.hasOwnProperty.bind(b))) {
    return false
  }
  return keys.every(function (key) { return equal(a[key], b[key]); })
};

var init = function (el, optionsFromBinding, defaultOptions) {
  var inputElement = el.tagName.toLowerCase() === 'input' ? el : el.querySelector('input');
  if (!inputElement) {
    throw new Error('No input element found')
  }
  var options = Object.assign({}, defaultOptions, optionsFromBinding);
  var min = options.min;
  var max = options.max;
  var distractionFree = options.distractionFree;
  var autoDecimalMode = options.autoDecimalMode;
  if (typeof distractionFree === 'boolean') {
    options.distractionFree = {
      hideCurrencySymbol: distractionFree,
      hideNegligibleDecimalDigits: distractionFree,
      hideGroupingSymbol: distractionFree
    };
  }
  if (autoDecimalMode) {
    options.distractionFree.hideNegligibleDecimalDigits = false;
  }
  if (min != null && max != null && min > max) {
    throw new Error('Invalid value range')
  }
  var currencyFormat = createCurrencyFormat$1(options);
  inputElement.$ci = Object.assign({}, inputElement.$ci || {},
    {options: options,
    currencyFormat: currencyFormat});
  return inputElement
};
var applyFixedFractionFormat = function (el, value) {
  var ref = el.$ci;
  var ref_options = ref.options;
  var min = ref_options.min;
  var max = ref_options.max;
  var locale = ref_options.locale;
  var ref_currencyFormat = ref.currencyFormat;
  var minimumFractionDigits = ref_currencyFormat.minimumFractionDigits;
  var maximumFractionDigits = ref_currencyFormat.maximumFractionDigits;
  if (min != null && (value == null || value < min)) {
    value = min;
  }
  if (max != null && value > max) {
    value = max;
  }
  if (value != null) {
    value = new Intl.NumberFormat(locale, { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: maximumFractionDigits }).format(value);
  }
  format(el, value);
};
var hideCurrencySymbolOnFocus = function (el) { return el.$ci.focus && el.$ci.options.distractionFree.hideCurrencySymbol; };
var hideGroupingSymbolOnFocus = function (el) { return el.$ci.focus && el.$ci.options.distractionFree.hideGroupingSymbol; };
var hideNegligibleDecimalDigitsOnFocus = function (el) { return el.$ci.focus && el.$ci.options.distractionFree.hideNegligibleDecimalDigits; };
var updateInputValue = function (el, value) {
  if (value != null) {
    var ref = el.$ci;
    var options = ref.options;
    var currencyFormat = ref.currencyFormat;
    var previousConformedValue = ref.previousConformedValue;
    var formatConfig = Object.assign({}, currencyFormat);
    if (hideCurrencySymbolOnFocus(el)) {
      formatConfig.prefix = '';
      formatConfig.negativePrefix = '-';
      formatConfig.suffix = '';
    }
    var ref$1 = conformToMask(value, formatConfig, options, previousConformedValue);
    var conformedValue = ref$1.conformedValue;
    var fractionDigits = ref$1.fractionDigits;
    if (typeof conformedValue === 'number') {
      var formattedValue = new Intl.NumberFormat(options.locale, {
        useGrouping: !hideGroupingSymbolOnFocus(el),
        minimumFractionDigits: hideNegligibleDecimalDigitsOnFocus(el) ? fractionDigits.replace(/0+$/, '').length : Math.min(formatConfig.minimumFractionDigits, fractionDigits.length),
        maximumFractionDigits: formatConfig.maximumFractionDigits
      }).format(Math.abs(conformedValue));
      var isNegativeZero = conformedValue === 0 && (1 / conformedValue < 0);
      el.value = "" + (isNegativeZero || conformedValue < 0 ? formatConfig.negativePrefix : formatConfig.prefix) + formattedValue + (formatConfig.suffix);
      el.$ci.numberValue = conformedValue;
    } else {
      el.value = conformedValue;
      el.$ci.numberValue = parse(el.value, formatConfig, false);
    }
  } else {
    el.value = el.$ci.numberValue = null;
  }
  el.$ci.previousConformedValue = el.value;
};
var format = function (el, value) {
  updateInputValue(el, value);
  var ref = el.$ci;
  var numberValue = ref.numberValue;
  var currencyFormat = ref.currencyFormat;
  var options = ref.options;
  if (numberValue != null) {
    numberValue = toInteger(numberValue, options.valueAsInteger, currencyFormat.maximumFractionDigits);
  }
  dispatchEvent(el, 'format-complete', { numberValue: numberValue });
};
var addEventListener = function (el) {
  el.addEventListener('input', function () {
    var value = el.value;
    var selectionStart = el.selectionStart;
    var el_$ci = el.$ci;
    var currencyFormat = el_$ci.currencyFormat;
    var options = el_$ci.options;
    format(el, value);
    if (el.$ci.focus) {
      setCaretPosition(el, getCaretPositionAfterFormat(el.value, value, selectionStart, currencyFormat, options));
    }
  }, { capture: true });
  el.addEventListener('format', function (ref) {
    var detail = ref.detail;
    var ref$1 = el.$ci;
    var focus = ref$1.focus;
    var currencyFormat = ref$1.currencyFormat;
    var options = ref$1.options;
    if (!focus) {
      applyFixedFractionFormat(el, toFloat(detail.value, options.valueAsInteger, currencyFormat.maximumFractionDigits));
    }
  });
  el.addEventListener('focus', function () {
    el.$ci.focus = true;
    if (hideCurrencySymbolOnFocus(el) || hideGroupingSymbolOnFocus(el) || hideNegligibleDecimalDigitsOnFocus(el)) {
      setTimeout(function () {
        var value = el.value;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        updateInputValue(el, el.value);
        if (Math.abs(selectionStart - selectionEnd) > 0) {
          el.setSelectionRange(0, el.value.length);
        } else {
          setCaretPosition(el, getDistractionFreeCaretPosition(el.$ci.currencyFormat, el.$ci.options, value, selectionStart));
        }
      });
    }
  });
  el.addEventListener('blur', function () {
    el.$ci.focus = false;
    applyFixedFractionFormat(el, el.$ci.numberValue);
  });
};
var directive = {
  bind: function bind (el, ref, ref$1) {
    var options = ref.value;
    var context = ref$1.context;
    var inputElement = init(el, options, context.$CI_DEFAULT_OPTIONS || DEFAULT_OPTIONS);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
      var value = inputElement.value;
      var inputElement_$ci = inputElement.$ci;
      var currencyFormat = inputElement_$ci.currencyFormat;
      var options = inputElement_$ci.options;
      applyFixedFractionFormat(inputElement, toFloat(parse(value, currencyFormat), options.valueAsInteger, currencyFormat.maximumFractionDigits));
    });
    addEventListener(inputElement);
  },
  componentUpdated: function componentUpdated (el, ref, ref$1) {
    var value = ref.value;
    var oldValue = ref.oldValue;
    var context = ref$1.context;
    if (!equal(value, oldValue)) {
      var inputElement = init(el, value, context.$CI_DEFAULT_OPTIONS || DEFAULT_OPTIONS);
      applyFixedFractionFormat(inputElement, inputElement.$ci.numberValue);
    }
  }
};

function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }
var component = {
  render: function render (h) {
    return h('input', {
      domProps: {
        value: this.formattedValue
      },
      directives: [{
        name: 'currency',
        value: this.options
      }],
      on: this.listeners()
    })
  },
  directives: {
    currency: directive
  },
  name: 'CurrencyInput',
  props: {
    value: {
      type: Number,
      default: null
    },
    locale: {
      type: String,
      default: undefined
    },
    currency: {
      type: [String, Object],
      default: undefined
    },
    distractionFree: {
      type: [Boolean, Object],
      default: undefined
    },
    precision: {
      type: [Number, Object],
      default: undefined
    },
    autoDecimalMode: {
      type: Boolean,
      default: undefined
    },
    valueAsInteger: {
      type: Boolean,
      default: undefined
    },
    min: {
      type: Number,
      default: undefined
    },
    max: {
      type: Number,
      default: undefined
    }
  },
  data: function data () {
    return {
      formattedValue: this.value
    }
  },
  computed: {
    options: function options () {
      var this$1 = this;
      var options = Object.assign({}, this.$CI_DEFAULT_OPTIONS || DEFAULT_OPTIONS);
      Object.keys(DEFAULT_OPTIONS).forEach(function (key) {
        if (this$1[key] !== undefined) {
          options[key] = this$1[key];
        }
      });
      return options
    }
  },
  watch: {
    value: function value (value$1) {
      dispatchEvent(this.$el, 'format', { value: value$1 });
    }
  },
  methods: {
    listeners: function listeners () {
      var this$1 = this;
      var ref = this.$listeners;
      var input = ref.input;
      var rest = objectWithoutProperties( ref, ["input"] );
      var listeners = rest;
      return Object.assign({}, listeners,
        {'format-complete': function (ref) {
          var detail = ref.detail;
          this$1.$emit('input', detail.numberValue);
          this$1.formattedValue = this$1.$el.value;
        }})
    }
  }
};

var plugin = {
  install: function install (Vue, ref) {
    if ( ref === void 0 ) ref = {};
    var componentName = ref.componentName; if ( componentName === void 0 ) componentName = component.name;
    var directiveName = ref.directiveName; if ( directiveName === void 0 ) directiveName = 'currency';
    var globalOptions = ref.globalOptions; if ( globalOptions === void 0 ) globalOptions = {};
    var defaultOptions = Object.assign({}, DEFAULT_OPTIONS, globalOptions);
    Vue.prototype.$CI_DEFAULT_OPTIONS = defaultOptions;
    Vue.component(componentName, component);
    Vue.directive(directiveName, directive);
    Vue.prototype.$parseCurrency = function (str, options) {
      if ( options === void 0 ) options = defaultOptions;
      return parseCurrency(str, options);
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 80 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(49);
var TAG = __webpack_require__(31)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(34).f;
var has = __webpack_require__(43);
var TAG = __webpack_require__(31)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var defined = __webpack_require__(56);
var fails = __webpack_require__(28);
var spaces = __webpack_require__(128);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(26);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(49);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(50);
var global = __webpack_require__(27);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(65) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(37);
var SPECIES = __webpack_require__(31)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var string_namespaceObject = {};
__webpack_require__.r(string_namespaceObject);
__webpack_require__.d(string_namespaceObject, "capitalize", function() { return string_capitalize; });
__webpack_require__.d(string_namespaceObject, "uppercase", function() { return string_uppercase; });
__webpack_require__.d(string_namespaceObject, "lowercase", function() { return string_lowercase; });
__webpack_require__.d(string_namespaceObject, "placeholder", function() { return string_placeholder; });
__webpack_require__.d(string_namespaceObject, "truncate", function() { return string_truncate; });
var other_namespaceObject = {};
__webpack_require__.r(other_namespaceObject);
__webpack_require__.d(other_namespaceObject, "currency", function() { return other_currency; });
__webpack_require__.d(other_namespaceObject, "pluralize", function() { return other_pluralize; });
__webpack_require__.d(other_namespaceObject, "ordinal", function() { return other_ordinal; });

// CONCATENATED MODULE: ./src/util/index.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var ArrayProto = Array.prototype,
    ObjProto = Object.prototype;
var slice = ArrayProto.slice,
    util_toString = ObjProto.toString;
var util = {};

util.isArray = function (obj) {
  return Array.isArray(obj);
};

var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

util.isArrayLike = function (obj) {
  if (_typeof(obj) !== 'object' || !obj) {
    return false;
  }

  var length = obj.length;
  return typeof length === 'number' && length % 1 === 0 && length >= 0 && length <= MAX_ARRAY_INDEX;
};

util.isObject = function (obj) {
  var type = _typeof(obj);

  return type === 'function' || type === 'object' && !!obj;
};

util.each = function (obj, callback) {
  var i, len;

  if (util.isArray(obj)) {
    for (i = 0, len = obj.length; i < len; i++) {
      if (callback(obj[i], i, obj) === false) {
        break;
      }
    }
  } else {
    for (i in obj) {
      if (callback(obj[i], i, obj) === false) {
        break;
      }
    }
  }

  return obj;
};

util.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function (name) {
  util['is' + name] = function (obj) {
    return util_toString.call(obj) === '[object ' + name + ']';
  };
});

util.toArray = function (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);

  while (i--) {
    ret[i] = list[i + start];
  }

  return ret;
};

util.toNumber = function (value) {
  if (typeof value !== 'string') {
    return value;
  } else {
    var parsed = Number(value);
    return isNaN(parsed) ? value : parsed;
  }
};

util.convertRangeToArray = function (range) {
  return _toConsumableArray(Array(range + 1).keys()).slice(1);
};

util.convertArray = function (value) {
  if (util.isArray(value)) {
    return value;
  } else if (util.isPlainObject(value)) {
    // convert plain object to array.
    var keys = Object.keys(value);
    var i = keys.length;
    var res = new Array(i);
    var key;

    while (i--) {
      key = keys[i];
      res[i] = {
        $key: key,
        $value: value[key]
      };
    }

    return res;
  } else {
    return value || [];
  }
};

function multiIndex(obj, is) {
  // obj,['1','2','3'] -> ((obj['1'])['2'])['3']
  return is.length ? multiIndex(obj[is[0]], is.slice(1)) : obj;
}

util.getPath = function (obj, is) {
  // obj,'1.2.3' -> multiIndex(obj,['1','2','3'])
  return multiIndex(obj, is.split('.'));
};
/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 *
 * @param {*} obj
 * @return {Boolean}
 */


var util_toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';

util.isPlainObject = function (obj) {
  return util_toString.call(obj) === OBJECT_STRING;
};

util.exist = function (value) {
  return value !== null && typeof value !== 'undefined';
};

/* harmony default export */ var src_util = (util);
// CONCATENATED MODULE: ./src/string/capitalize.js
/**
 *  Converts a string into Capitalize
 * 
 * 'abc' => 'Abc'
 * 
 * @param {Object} options
 */
function capitalize(value, options) {
  var globalOptions = this && this.capitalize ? this.capitalize : {};
  options = options || globalOptions;
  var onlyFirstLetter = options.onlyFirstLetter != null ? options.onlyFirstLetter : false;
  if (!value && value !== 0) return '';

  if (onlyFirstLetter === true) {
    return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
  } else {
    value = value.toString().toLowerCase().split(' ');
    return value.map(function (item) {
      return item.charAt(0).toUpperCase() + item.slice(1);
    }).join(' ');
  }
}

/* harmony default export */ var string_capitalize = (capitalize);
// CONCATENATED MODULE: ./src/string/uppercase.js
/**
 * Converts a string to UPPERCASE
 * 
 * 'abc' => 'ABC'
 */
function uppercase(value) {
  return value || value === 0 ? value.toString().toUpperCase() : '';
}

/* harmony default export */ var string_uppercase = (uppercase);
// CONCATENATED MODULE: ./src/string/lowercase.js
/**
 * Converts a string to lowercase
 * 
 * 'AbC' => 'abc'
 */
function lowercase(value) {
  return value || value === 0 ? value.toString().toLowerCase() : '';
}

/* harmony default export */ var string_lowercase = (lowercase);
// CONCATENATED MODULE: ./src/string/placeholder.js
/**
 *  If the value is missing outputs the placeholder text
 * 
 * '' => {placeholder}
 * 'foo' => 'foo'
 */
function placeholder(input, property) {
  return input === undefined || input === '' || input === null ? property : input;
}

/* harmony default export */ var string_placeholder = (placeholder);
// CONCATENATED MODULE: ./src/string/truncate.js
/**
 *  Truncate at the given || default length
 *
 * 'lorem ipsum dolor' => 'lorem ipsum dol...'
 */
function truncate(value, length) {
  length = length || 15;
  if (!value || typeof value !== 'string') return '';
  if (value.length <= length) return value;
  return value.substring(0, length) + '...';
}

/* harmony default export */ var string_truncate = (truncate);
// CONCATENATED MODULE: ./src/string/index.js






// CONCATENATED MODULE: ./src/array/limitBy.js

/**
 * Limit filter for arrays
 *
 * @param {Number|Array} arr (If Number, decimal expected)
 * @param {Number} n
 * @param {Number} offset (Decimal expected)
 */

function limitBy(arr, n, offset) {
  arr = src_util.isArray(arr) ? arr : src_util.convertRangeToArray(arr);
  offset = offset ? parseInt(offset, 10) : 0;
  n = src_util.toNumber(n);
  return typeof n === 'number' ? arr.slice(offset, offset + n) : arr;
}

/* harmony default export */ var array_limitBy = (limitBy);
// CONCATENATED MODULE: ./src/array/filterBy.js

/**
 * Filter filter for arrays
 *
 * @param {Array} arr
 * @param {String} prop
 * @param {String|Number} search
 */

function filterBy(arr, search) {
  var arr = src_util.convertArray(arr);

  if (search == null) {
    return arr;
  }

  if (typeof search === 'function') {
    return arr.filter(search);
  } // cast to lowercase string


  search = ('' + search).toLowerCase();
  var n = 2; // extract and flatten keys

  var keys = Array.prototype.concat.apply([], src_util.toArray(arguments, n));
  var res = [];
  var item, key, val, j;

  for (var i = 0, l = arr.length; i < l; i++) {
    item = arr[i];
    val = item && item.$value || item;
    j = keys.length;

    if (j) {
      while (j--) {
        key = keys[j];

        if (key === '$key' && contains(item.$key, search) || contains(src_util.getPath(val, key), search)) {
          res.push(item);
          break;
        }
      }
    } else if (contains(item, search)) {
      res.push(item);
    }
  }

  return res;
}

function contains(val, search) {
  var i;

  if (src_util.isPlainObject(val)) {
    var keys = Object.keys(val);
    i = keys.length;

    while (i--) {
      if (contains(val[keys[i]], search)) {
        return true;
      }
    }
  } else if (src_util.isArray(val)) {
    i = val.length;

    while (i--) {
      if (contains(val[i], search)) {
        return true;
      }
    }
  } else if (val != null) {
    return val.toString().toLowerCase().indexOf(search) > -1;
  }
}

/* harmony default export */ var array_filterBy = (filterBy);
// CONCATENATED MODULE: ./src/array/orderBy.js

/**
 * Filter filter for arrays
 *
 * @param {String|Array<String>|Function} ...sortKeys
 * @param {Number} [order]
 */

function orderBy(arr) {
  var _comparator = null;
  var sortKeys;
  arr = src_util.convertArray(arr); // determine order (last argument)

  var args = src_util.toArray(arguments, 1);
  var order = args[args.length - 1];

  if (typeof order === 'number') {
    order = order < 0 ? -1 : 1;
    args = args.length > 1 ? args.slice(0, -1) : args;
  } else {
    order = 1;
  } // determine sortKeys & comparator


  var firstArg = args[0];

  if (!firstArg) {
    return arr;
  } else if (typeof firstArg === 'function') {
    // custom comparator
    _comparator = function comparator(a, b) {
      return firstArg(a, b) * order;
    };
  } else {
    // string keys. flatten first
    sortKeys = Array.prototype.concat.apply([], args);

    _comparator = function comparator(a, b, i) {
      i = i || 0;
      return i >= sortKeys.length - 1 ? baseCompare(a, b, i) : baseCompare(a, b, i) || _comparator(a, b, i + 1);
    };
  }

  function baseCompare(a, b, sortKeyIndex) {
    var sortKey = sortKeys[sortKeyIndex];

    if (sortKey) {
      if (sortKey !== '$key') {
        if (src_util.isObject(a) && '$value' in a) a = a.$value;
        if (src_util.isObject(b) && '$value' in b) b = b.$value;
      }

      a = src_util.isObject(a) ? src_util.getPath(a, sortKey) : a;
      b = src_util.isObject(b) ? src_util.getPath(b, sortKey) : b;
      a = typeof a === 'string' ? a.toLowerCase() : a;
      b = typeof b === 'string' ? b.toLowerCase() : b;
    }

    return a === b ? 0 : a > b ? order : -order;
  } // sort on a copy to avoid mutating original array


  return arr.slice().sort(_comparator);
}

/* harmony default export */ var array_orderBy = (orderBy);
// CONCATENATED MODULE: ./src/array/find.js

/**
 * Get first matching element from a filtered array
 *
 * @param {Array} arr
 * @param {String|Number} search
 * @returns {mixed}
 */

function find(arr, search) {
  var array = array_filterBy.apply(this, arguments);
  array.splice(1);
  return array;
}

/* harmony default export */ var array_find = (find);
// CONCATENATED MODULE: ./src/array/index.js





// CONCATENATED MODULE: ./src/other/currency.js

/**
 * 
 * 12345 => $12,345.00
 *
 * @param {String} symbol
 * @param {Number} decimals Decimal places
 * @param {Object} options
 */

function currency(value, symbol, decimals, options) {
  var globalOptions = this && this.currency ? this.currency : {};
  symbol = src_util.exist(symbol) ? symbol : globalOptions.symbol;
  decimals = src_util.exist(decimals) ? decimals : globalOptions.decimalDigits;
  options = options || globalOptions;
  var thousandsSeparator, symbolOnLeft, spaceBetweenAmountAndSymbol;
  var digitsRE = /(\d{3})(?=\d)/g;
  value = parseFloat(value);
  if (!isFinite(value) || !value && value !== 0) return '';
  symbol = typeof symbol !== 'undefined' ? symbol : '$';
  decimals = typeof decimals !== 'undefined' ? decimals : 2;
  thousandsSeparator = options.thousandsSeparator != null ? options.thousandsSeparator : ',';
  symbolOnLeft = options.symbolOnLeft != null ? options.symbolOnLeft : true;
  spaceBetweenAmountAndSymbol = options.spaceBetweenAmountAndSymbol != null ? options.spaceBetweenAmountAndSymbol : false;
  var number = Math.abs(value);
  var stringified = toFixed(number, decimals);
  stringified = options.decimalSeparator ? stringified.replace('.', options.decimalSeparator) : stringified;

  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;

  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? thousandsSeparator : '') : '';

  var _float = decimals ? stringified.slice(-1 - decimals) : '';

  symbol = spaceBetweenAmountAndSymbol ? symbolOnLeft ? symbol + ' ' : ' ' + symbol : symbol;
  symbol = symbolOnLeft ? symbol + head + _int.slice(i).replace(digitsRE, '$1' + thousandsSeparator) + _float : head + _int.slice(i).replace(digitsRE, '$1' + thousandsSeparator) + _float + symbol;
  var sign = value < 0 ? '-' : '';
  return sign + symbol;
}

function toFixed(num, precision) {
  return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
}

/* harmony default export */ var other_currency = (currency);
// CONCATENATED MODULE: ./src/other/pluralize.js

/**
 * 'item' => 'items'
 *
 * @param {String|Array} word
 * @param {Object} options
 *
 */

function pluralize(value, word, options) {
  var globalOptions = this && this.pluralize ? this.pluralize : {};
  options = options || globalOptions;
  var output = '';
  var includeNumber = options.includeNumber != null ? options.includeNumber : false;
  if (includeNumber === true) output += value + ' ';
  if (!value && value !== 0 || !word) return output;

  if (Array.isArray(word)) {
    output += word[value - 1] || word[word.length - 1];
  } else {
    output += word + (value === 1 ? '' : 's');
  }

  return output;
}

/* harmony default export */ var other_pluralize = (pluralize);
// CONCATENATED MODULE: ./src/other/ordinal.js

/**
 * 42 => 'nd'
 *
 * @params {Object} options
 * 
 */

function ordinal(value, options) {
  var globalOptions = this && this.ordinal ? this.ordinal : {};
  options = options || globalOptions;
  var output = '';
  var includeNumber = options.includeNumber != null ? options.includeNumber : false;
  if (includeNumber === true) output += value;
  var j = value % 10,
      k = value % 100;
  if (j == 1 && k != 11) output += 'st';else if (j == 2 && k != 12) output += 'nd';else if (j == 3 && k != 13) output += 'rd';else output += 'th';
  return output;
}

/* harmony default export */ var other_ordinal = (ordinal);
// CONCATENATED MODULE: ./src/other/index.js




// CONCATENATED MODULE: ./src/index.js




var Vue2Filters = {
  install: function install(Vue, options) {
    src_util.each(string_namespaceObject, function (value, key) {
      Vue.filter(key, value.bind(options));
    });
    src_util.each(other_namespaceObject, function (value, key) {
      Vue.filter(key, value.bind(options));
    });
  },
  mixin: {
    methods: {
      limitBy: array_limitBy,
      filterBy: array_filterBy,
      orderBy: array_orderBy,
      find: array_find
    }
  }
};
/* harmony default export */ var src = __webpack_exports__["default"] = (Vue2Filters);

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Vue2Filters);
  window.Vue2Filters = Vue2Filters;
}

/***/ })
/******/ ]);
});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropsValues = getPropsValues;
exports.bindProps = bindProps;

var _WatchPrimitiveProperties = __webpack_require__(138);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getPropsValues(vueInst, props) {
  return Object.keys(props).reduce(function (acc, prop) {
    if (vueInst[prop] !== undefined) {
      acc[prop] = vueInst[prop];
    }
    return acc;
  }, {});
}

/**
  * Binds the properties defined in props to the google maps instance.
  * If the prop is an Object type, and we wish to track the properties
  * of the object (e.g. the lat and lng of a LatLng), then we do a deep
  * watch. For deep watch, we also prevent the _changed event from being
  * emitted if the data source was external.
  */
function bindProps(vueInst, googleMapsInst, props) {
  var _loop = function (attribute) {
    var _props$attribute = props[attribute],
        twoWay = _props$attribute.twoWay,
        type = _props$attribute.type,
        trackProperties = _props$attribute.trackProperties,
        noBind = _props$attribute.noBind;


    if (noBind) return 'continue';

    var setMethodName = 'set' + capitalizeFirstLetter(attribute);
    var getMethodName = 'get' + capitalizeFirstLetter(attribute);
    var eventName = attribute.toLowerCase() + '_changed';
    var initialValue = vueInst[attribute];

    if (typeof googleMapsInst[setMethodName] === 'undefined') {
      throw new Error(setMethodName + ' is not a method of (the Maps object corresponding to) ' + vueInst.$options._componentTag);
    }

    // We need to avoid an endless
    // propChanged -> event emitted -> propChanged -> event emitted loop
    // although this may really be the user's responsibility
    if (type !== Object || !trackProperties) {
      // Track the object deeply
      vueInst.$watch(attribute, function () {
        var attributeValue = vueInst[attribute];

        googleMapsInst[setMethodName](attributeValue);
      }, {
        immediate: typeof initialValue !== 'undefined',
        deep: type === Object
      });
    } else {
      (0, _WatchPrimitiveProperties2.default)(vueInst, trackProperties.map(function (prop) {
        return attribute + '.' + prop;
      }), function () {
        googleMapsInst[setMethodName](vueInst[attribute]);
      }, vueInst[attribute] !== undefined);
    }

    if (twoWay && (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName])) {
      googleMapsInst.addListener(eventName, function () {
        // eslint-disable-line no-unused-vars
        vueInst.$emit(eventName, googleMapsInst[getMethodName]());
      });
    }
  };

  for (var attribute in props) {
    var _ret = _loop(attribute);

    if (_ret === 'continue') continue;
  }
}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(46);
var toLength = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(76);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(27);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(40);
var redefineAll = __webpack_require__(74);
var meta = __webpack_require__(66);
var forOf = __webpack_require__(69);
var anInstance = __webpack_require__(68);
var isObject = __webpack_require__(29);
var fails = __webpack_require__(28);
var $iterDetect = __webpack_require__(97);
var setToStringTag = __webpack_require__(83);
var inheritIfRequired = __webpack_require__(115);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(478);
var redefine = __webpack_require__(40);
var hide = __webpack_require__(39);
var fails = __webpack_require__(28);
var defined = __webpack_require__(56);
var wks = __webpack_require__(31);
var regexpExec = __webpack_require__(123);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(49);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(29);
var cof = __webpack_require__(49);
var MATCH = __webpack_require__(31)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(31)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(65) || !__webpack_require__(28)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(27)[K];
});


/***/ }),
/* 99 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(81);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(8);
var aFunction = __webpack_require__(37);
var ctx = __webpack_require__(51);
var forOf = __webpack_require__(69);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(8);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(53);
var defined = __webpack_require__(56);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var hide = __webpack_require__(39);
var uid = __webpack_require__(77);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserSmlMapping_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a7577b4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserSmlMapping_vue__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1778)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a7577b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserSmlMapping_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a7577b4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserSmlMapping_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a7577b4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserSmlMapping_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(103)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(36);
var toAbsoluteIndex = __webpack_require__(76);
var toLength = __webpack_require__(32);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(667);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(34);
var createDesc = __webpack_require__(73);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);
var document = __webpack_require__(27).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(31)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(27).document;
module.exports = document && document.documentElement;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);
var setPrototypeOf = __webpack_require__(124).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(82);
var ITERATOR = __webpack_require__(31)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(70);
var descriptor = __webpack_require__(73);
var setToStringTag = __webpack_require__(83);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(39)(IteratorPrototype, __webpack_require__(31)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(65);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(40);
var hide = __webpack_require__(39);
var Iterators = __webpack_require__(82);
var $iterCreate = __webpack_require__(117);
var setToStringTag = __webpack_require__(83);
var getPrototypeOf = __webpack_require__(45);
var ITERATOR = __webpack_require__(31)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var macrotask = __webpack_require__(129).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(49)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(37);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(85);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(29);
var anObject = __webpack_require__(26);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(51)(Function.call, __webpack_require__(44).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(88)('keys');
var uid = __webpack_require__(77);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(96);
var defined = __webpack_require__(56);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(53);
var defined = __webpack_require__(56);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(51);
var invoke = __webpack_require__(456);
var html = __webpack_require__(114);
var cel = __webpack_require__(111);
var global = __webpack_require__(27);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(49)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(27);
var DESCRIPTORS = __webpack_require__(33);
var LIBRARY = __webpack_require__(65);
var $typed = __webpack_require__(104);
var hide = __webpack_require__(39);
var redefineAll = __webpack_require__(74);
var fails = __webpack_require__(28);
var anInstance = __webpack_require__(68);
var toInteger = __webpack_require__(53);
var toLength = __webpack_require__(32);
var toIndex = __webpack_require__(475);
var gOPN = __webpack_require__(71).f;
var dP = __webpack_require__(34).f;
var arrayFill = __webpack_require__(108);
var setToStringTag = __webpack_require__(83);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var core = __webpack_require__(50);
var LIBRARY = __webpack_require__(65);
var wksExt = __webpack_require__(476);
var defineProperty = __webpack_require__(34).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(81);
var ITERATOR = __webpack_require__(31)('iterator');
var Iterators = __webpack_require__(82);
module.exports = __webpack_require__(50).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(64);
var step = __webpack_require__(459);
var Iterators = __webpack_require__(82);
var toIObject = __webpack_require__(46);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(118)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 134 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductLoanItemRow_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc4aec7c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLoanItemRow_vue__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1905)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc4aec7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductLoanItemRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc4aec7c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLoanItemRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc4aec7c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLoanItemRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockProgressModal_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d44a3c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockProgressModal_vue__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1937)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32d44a3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockProgressModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d44a3c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockProgressModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d44a3c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockProgressModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockSignatureModal_vue__ = __webpack_require__(354);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67d77557_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockSignatureModal_vue__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1947)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67d77557"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockSignatureModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67d77557_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockSignatureModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67d77557_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockSignatureModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WatchPrimitiveProperties;
/**
 * Watch the individual properties of a PoD object, instead of the object
 * per se. This is different from a deep watch where both the reference
 * and the individual values are watched.
 *
 * In effect, it throttles the multiple $watch to execute at most once per tick.
 */
function WatchPrimitiveProperties(vueInst, propertiesToTrack, handler) {
  var immediate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var isHandled = false;

  function requestHandle() {
    if (!isHandled) {
      isHandled = true;
      vueInst.$nextTick(function () {
        isHandled = false;
        handler();
      });
    }
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = propertiesToTrack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var prop = _step.value;

      vueInst.$watch(prop, requestHandle, { immediate: immediate });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (vueInst, googleMapsInst, events) {
  var _loop = function (eventName) {
    if (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName]) {
      googleMapsInst.addListener(eventName, function (ev) {
        vueInst.$emit(eventName, ev);
      });
    }
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/

exports.default = {
  props: ['resizeBus'],

  data: function data() {
    return {
      _actualResizeBus: null
    };
  },
  created: function created() {
    if (typeof this.resizeBus === 'undefined') {
      this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
    } else {
      this.$data._actualResizeBus = this.resizeBus;
    }
  },


  methods: {
    _resizeCallback: function _resizeCallback() {
      this.resize();
    },
    _delayedResizeCallback: function _delayedResizeCallback() {
      var _this = this;

      this.$nextTick(function () {
        return _this._resizeCallback();
      });
    }
  },

  watch: {
    resizeBus: function resizeBus(newVal) {
      // eslint-disable-line no-unused-vars
      this.$data._actualResizeBus = newVal;
    },
    '$data._actualResizeBus': function $data_actualResizeBus(newVal, oldVal) {
      if (oldVal) {
        oldVal.$off('resize', this._delayedResizeCallback);
      }
      if (newVal) {
        newVal.$on('resize', this._delayedResizeCallback);
      }
    }
  },

  destroyed: function destroyed() {
    if (this.$data._actualResizeBus) {
      this.$data._actualResizeBus.$off('resize', this._delayedResizeCallback);
    }
  }
};

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var Language =
/*#__PURE__*/
function () {
  function Language(language, months, monthsAbbr, days) {
    _classCallCheck(this, Language);

    this.language = language;
    this.months = months;
    this.monthsAbbr = monthsAbbr;
    this.days = days;
    this.rtl = false;
    this.ymd = false;
    this.yearSuffix = '';
  }

  _createClass(Language, [{
    key: "language",
    get: function get() {
      return this._language;
    },
    set: function set(language) {
      if (typeof language !== 'string') {
        throw new TypeError('Language must be a string');
      }

      this._language = language;
    }
  }, {
    key: "months",
    get: function get() {
      return this._months;
    },
    set: function set(months) {
      if (months.length !== 12) {
        throw new RangeError("There must be 12 months for ".concat(this.language, " language"));
      }

      this._months = months;
    }
  }, {
    key: "monthsAbbr",
    get: function get() {
      return this._monthsAbbr;
    },
    set: function set(monthsAbbr) {
      if (monthsAbbr.length !== 12) {
        throw new RangeError("There must be 12 abbreviated months for ".concat(this.language, " language"));
      }

      this._monthsAbbr = monthsAbbr;
    }
  }, {
    key: "days",
    get: function get() {
      return this._days;
    },
    set: function set(days) {
      if (days.length !== 7) {
        throw new RangeError("There must be 7 days for ".concat(this.language, " language"));
      }

      this._days = days;
    }
  }]);

  return Language;
}(); // eslint-disable-next-line

var en = new Language('English', ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']) // eslint-disable-next-line
;

var utils = {
  /**
   * @type {Boolean}
   */
  useUtc: false,

  /**
   * Returns the full year, using UTC or not
   * @param {Date} date
   */
  getFullYear: function getFullYear(date) {
    return this.useUtc ? date.getUTCFullYear() : date.getFullYear();
  },

  /**
   * Returns the month, using UTC or not
   * @param {Date} date
   */
  getMonth: function getMonth(date) {
    return this.useUtc ? date.getUTCMonth() : date.getMonth();
  },

  /**
   * Returns the date, using UTC or not
   * @param {Date} date
   */
  getDate: function getDate(date) {
    return this.useUtc ? date.getUTCDate() : date.getDate();
  },

  /**
   * Returns the day, using UTC or not
   * @param {Date} date
   */
  getDay: function getDay(date) {
    return this.useUtc ? date.getUTCDay() : date.getDay();
  },

  /**
   * Returns the hours, using UTC or not
   * @param {Date} date
   */
  getHours: function getHours(date) {
    return this.useUtc ? date.getUTCHours() : date.getHours();
  },

  /**
   * Returns the minutes, using UTC or not
   * @param {Date} date
   */
  getMinutes: function getMinutes(date) {
    return this.useUtc ? date.getUTCMinutes() : date.getMinutes();
  },

  /**
   * Sets the full year, using UTC or not
   * @param {Date} date
   */
  setFullYear: function setFullYear(date, value, useUtc) {
    return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value);
  },

  /**
   * Sets the month, using UTC or not
   * @param {Date} date
   */
  setMonth: function setMonth(date, value, useUtc) {
    return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value);
  },

  /**
   * Sets the date, using UTC or not
   * @param {Date} date
   * @param {Number} value
   */
  setDate: function setDate(date, value, useUtc) {
    return this.useUtc ? date.setUTCDate(value) : date.setDate(value);
  },

  /**
   * Check if date1 is equivalent to date2, without comparing the time
   * @see https://stackoverflow.com/a/6202196/4455925
   * @param {Date} date1
   * @param {Date} date2
   */
  compareDates: function compareDates(date1, date2) {
    var d1 = new Date(date1.getTime());
    var d2 = new Date(date2.getTime());

    if (this.useUtc) {
      d1.setUTCHours(0, 0, 0, 0);
      d2.setUTCHours(0, 0, 0, 0);
    } else {
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);
    }

    return d1.getTime() === d2.getTime();
  },

  /**
   * Validates a date object
   * @param {Date} date - an object instantiated with the new Date constructor
   * @return {Boolean}
   */
  isValidDate: function isValidDate(date) {
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      return false;
    }

    return !isNaN(date.getTime());
  },

  /**
   * Return abbreviated week day name
   * @param {Date}
   * @param {Array}
   * @return {String}
   */
  getDayNameAbbr: function getDayNameAbbr(date, days) {
    if (_typeof(date) !== 'object') {
      throw TypeError('Invalid Type');
    }

    return days[this.getDay(date)];
  },

  /**
   * Return name of the month
   * @param {Number|Date}
   * @param {Array}
   * @return {String}
   */
  getMonthName: function getMonthName(month, months) {
    if (!months) {
      throw Error('missing 2nd parameter Months array');
    }

    if (_typeof(month) === 'object') {
      return months[this.getMonth(month)];
    }

    if (typeof month === 'number') {
      return months[month];
    }

    throw TypeError('Invalid type');
  },

  /**
   * Return an abbreviated version of the month
   * @param {Number|Date}
   * @return {String}
   */
  getMonthNameAbbr: function getMonthNameAbbr(month, monthsAbbr) {
    if (!monthsAbbr) {
      throw Error('missing 2nd paramter Months array');
    }

    if (_typeof(month) === 'object') {
      return monthsAbbr[this.getMonth(month)];
    }

    if (typeof month === 'number') {
      return monthsAbbr[month];
    }

    throw TypeError('Invalid type');
  },

  /**
   * Alternative get total number of days in month
   * @param {Number} year
   * @param {Number} m
   * @return {Number}
   */
  daysInMonth: function daysInMonth(year, month) {
    return /8|3|5|10/.test(month) ? 30 : month === 1 ? !(year % 4) && year % 100 || !(year % 400) ? 29 : 28 : 31;
  },

  /**
   * Get nth suffix for date
   * @param {Number} day
   * @return {String}
   */
  getNthSuffix: function getNthSuffix(day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st';

      case 2:
      case 22:
        return 'nd';

      case 3:
      case 23:
        return 'rd';

      default:
        return 'th';
    }
  },

  /**
   * Formats date object
   * @param {Date}
   * @param {String}
   * @param {Object}
   * @return {String}
   */
  formatDate: function formatDate(date, format, translation) {
    translation = !translation ? en : translation;
    var year = this.getFullYear(date);
    var month = this.getMonth(date) + 1;
    var day = this.getDate(date);
    var str = format.replace(/dd/, ('0' + day).slice(-2)).replace(/d/, day).replace(/yyyy/, year).replace(/yy/, String(year).slice(2)).replace(/MMMM/, this.getMonthName(this.getMonth(date), translation.months)).replace(/MMM/, this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr)).replace(/MM/, ('0' + month).slice(-2)).replace(/M(?!a|ä|e)/, month).replace(/su/, this.getNthSuffix(this.getDate(date))).replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
    return str;
  },

  /**
   * Creates an array of dates for each day in between two dates.
   * @param {Date} start
   * @param {Date} end
   * @return {Array}
   */
  createDateArray: function createDateArray(start, end) {
    var dates = [];

    while (start <= end) {
      dates.push(new Date(start));
      start = this.setDate(new Date(start), this.getDate(new Date(start)) + 1);
    }

    return dates;
  },

  /**
   * method used as a prop validator for input values
   * @param {*} val
   * @return {Boolean}
   */
  validateDateInput: function validateDateInput(val) {
    return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number';
  }
};
var makeDateUtils = function makeDateUtils(useUtc) {
  return _objectSpread({}, utils, {
    useUtc: useUtc
  });
};
var utils$1 = _objectSpread({}, utils) // eslint-disable-next-line
;

var script = {
  props: {
    selectedDate: Date,
    resetTypedDate: [Date],
    format: [String, Function],
    translation: Object,
    inline: Boolean,
    id: String,
    name: String,
    refName: String,
    openDate: Date,
    placeholder: String,
    inputClass: [String, Object, Array],
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    bootstrapStyling: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      input: null,
      typedDate: false,
      utils: constructedDateUtils
    };
  },
  computed: {
    formattedValue: function formattedValue() {
      if (!this.selectedDate) {
        return null;
      }

      if (this.typedDate) {
        return this.typedDate;
      }

      return typeof this.format === 'function' ? this.format(this.selectedDate) : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation);
    },
    computedInputClass: function computedInputClass() {
      if (this.bootstrapStyling) {
        if (typeof this.inputClass === 'string') {
          return [this.inputClass, 'form-control'].join(' ');
        }

        return _objectSpread({
          'form-control': true
        }, this.inputClass);
      }

      return this.inputClass;
    }
  },
  watch: {
    resetTypedDate: function resetTypedDate() {
      this.typedDate = false;
    }
  },
  methods: {
    showCalendar: function showCalendar() {
      this.$emit('showCalendar');
    },

    /**
     * Attempt to parse a typed date
     * @param {Event} event
     */
    parseTypedDate: function parseTypedDate(event) {
      // close calendar if escape or enter are pressed
      if ([27, // escape
      13 // enter
      ].includes(event.keyCode)) {
        this.input.blur();
      }

      if (this.typeable) {
        var typedDate = Date.parse(this.input.value);

        if (!isNaN(typedDate)) {
          this.typedDate = this.input.value;
          this.$emit('typedDate', new Date(this.typedDate));
        }
      }
    },

    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred: function inputBlurred() {
      if (this.typeable && isNaN(Date.parse(this.input.value))) {
        this.clearDate();
        this.input.value = null;
        this.typedDate = null;
      }

      this.$emit('closeCalendar');
    },

    /**
     * emit a clearDate event
     */
    clearDate: function clearDate() {
      this.$emit('clearDate');
    }
  },
  mounted: function mounted() {
    this.input = this.$el.querySelector('input');
  }
} // eslint-disable-next-line
;

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: { "input-group": _vm.bootstrapStyling } },
    [
      _vm.calendarButton
        ? _c(
            "span",
            {
              staticClass: "vdp-datepicker__calendar-button",
              class: { "input-group-prepend": _vm.bootstrapStyling },
              style: { "cursor:not-allowed;": _vm.disabled },
              on: { click: _vm.showCalendar }
            },
            [
              _c(
                "span",
                { class: { "input-group-text": _vm.bootstrapStyling } },
                [
                  _c("i", { class: _vm.calendarButtonIcon }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.calendarButtonIconContent) +
                        "\n        "
                    ),
                    !_vm.calendarButtonIcon
                      ? _c("span", [_vm._v("…")])
                      : _vm._e()
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: _vm.refName,
        class: _vm.computedInputClass,
        attrs: {
          type: _vm.inline ? "hidden" : "text",
          name: _vm.name,
          id: _vm.id,
          "open-date": _vm.openDate,
          placeholder: _vm.placeholder,
          "clear-button": _vm.clearButton,
          disabled: _vm.disabled,
          required: _vm.required,
          readonly: !_vm.typeable,
          autocomplete: "off"
        },
        domProps: { value: _vm.formattedValue },
        on: {
          click: _vm.showCalendar,
          keyup: _vm.parseTypedDate,
          blur: _vm.inputBlurred
        }
      }),
      _vm._v(" "),
      _vm.clearButton && _vm.selectedDate
        ? _c(
            "span",
            {
              staticClass: "vdp-datepicker__clear-button",
              class: { "input-group-append": _vm.bootstrapStyling },
              on: {
                click: function($event) {
                  return _vm.clearDate()
                }
              }
            },
            [
              _c(
                "span",
                { class: { "input-group-text": _vm.bootstrapStyling } },
                [
                  _c("i", { class: _vm.clearButtonIcon }, [
                    !_vm.clearButtonIcon ? _c("span", [_vm._v("×")]) : _vm._e()
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("afterDateInput")
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var DateInput = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
var script$1 = {
  props: {
    showDayView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    fullMonthName: Boolean,
    allowedToShowView: Function,
    dayCellContent: {
      type: Function,
      "default": function _default(day) {
        return day.date;
      }
    },
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    mondayFirst: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    /**
     * Returns an array of day names
     * @return {String[]}
     */
    daysOfWeek: function daysOfWeek() {
      if (this.mondayFirst) {
        var tempDays = this.translation.days.slice();
        tempDays.push(tempDays.shift());
        return tempDays;
      }

      return this.translation.days;
    },

    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays: function blankDays() {
      var d = this.pageDate;
      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());

      if (this.mondayFirst) {
        return this.utils.getDay(dObj) > 0 ? this.utils.getDay(dObj) - 1 : 6;
      }

      return this.utils.getDay(dObj);
    },

    /**
     * @return {Object[]}
     */
    days: function days() {
      var d = this.pageDate;
      var days = []; // set up a new date object to the beginning of the current 'page'

      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      var daysInMonth = this.utils.daysInMonth(this.utils.getFullYear(dObj), this.utils.getMonth(dObj));

      for (var i = 0; i < daysInMonth; i++) {
        days.push({
          date: this.utils.getDate(dObj),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedDate(dObj),
          isDisabled: this.isDisabledDate(dObj),
          isHighlighted: this.isHighlightedDate(dObj),
          isHighlightStart: this.isHighlightStart(dObj),
          isHighlightEnd: this.isHighlightEnd(dObj),
          isToday: this.utils.compareDates(dObj, new Date()),
          isWeekend: this.utils.getDay(dObj) === 0 || this.utils.getDay(dObj) === 6,
          isSaturday: this.utils.getDay(dObj) === 6,
          isSunday: this.utils.getDay(dObj) === 0
        });
        this.utils.setDate(dObj, this.utils.getDate(dObj) + 1);
      }

      return days;
    },

    /**
     * Gets the name of the month the current page is on
     * @return {String}
     */
    currMonthName: function currMonthName() {
      var monthName = this.fullMonthName ? this.translation.months : this.translation.monthsAbbr;
      return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate), monthName);
    },

    /**
     * Gets the name of the year that current page is on
     * @return {Number}
     */
    currYearName: function currYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
    },

    /**
     * Is this translation using year/month/day format?
     * @return {Boolean}
     */
    isYmd: function isYmd() {
      return this.translation.ymd && this.translation.ymd === true;
    },

    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextMonthDisabled(this.pageTimestamp) : this.isPreviousMonthDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousMonthDisabled(this.pageTimestamp) : this.isNextMonthDisabled(this.pageTimestamp);
    }
  },
  methods: {
    selectDate: function selectDate(date) {
      if (date.isDisabled) {
        this.$emit('selectedDisabled', date);
        return false;
      }

      this.$emit('selectDate', date);
    },

    /**
     * @return {Number}
     */
    getPageMonth: function getPageMonth() {
      return this.utils.getMonth(this.pageDate);
    },

    /**
     * Emit an event to show the month picker
     */
    showMonthCalendar: function showMonthCalendar() {
      this.$emit('showMonthCalendar');
    },

    /**
     * Change the page month
     * @param {Number} incrementBy
     */
    changeMonth: function changeMonth(incrementBy) {
      var date = this.pageDate;
      this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
      this.$emit('changedMonth', date);
    },

    /**
     * Decrement the page month
     */
    previousMonth: function previousMonth() {
      if (!this.isPreviousMonthDisabled()) {
        this.changeMonth(-1);
      }
    },

    /**
     * Is the previous month disabled?
     * @return {Boolean}
     */
    isPreviousMonthDisabled: function isPreviousMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.to) >= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(d);
    },

    /**
     * Increment the current page month
     */
    nextMonth: function nextMonth() {
      if (!this.isNextMonthDisabled()) {
        this.changeMonth(+1);
      }
    },

    /**
     * Is the next month disabled?
     * @return {Boolean}
     */
    isNextMonthDisabled: function isNextMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.from) <= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(d);
    },

    /**
     * Whether a day is selected
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedDate: function isSelectedDate(dObj) {
      return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj);
    },

    /**
     * Whether a day is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledDate: function isDisabledDate(date) {
      var _this = this;

      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.dates !== 'undefined') {
        this.disabledDates.dates.forEach(function (d) {
          if (_this.utils.compareDates(date, d)) {
            disabledDates = true;
            return true;
          }
        });
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to && date < this.disabledDates.to) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from && date > this.disabledDates.from) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.ranges !== 'undefined') {
        this.disabledDates.ranges.forEach(function (range) {
          if (typeof range.from !== 'undefined' && range.from && typeof range.to !== 'undefined' && range.to) {
            if (date < range.to && date > range.from) {
              disabledDates = true;
              return true;
            }
          }
        });
      }

      if (typeof this.disabledDates.days !== 'undefined' && this.disabledDates.days.indexOf(this.utils.getDay(date)) !== -1) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.daysOfMonth !== 'undefined' && this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    },

    /**
     * Whether a day is highlighted (only if it is not disabled already except when highlighted.includeDisabled is true)
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightedDate: function isHighlightedDate(date) {
      var _this2 = this;

      if (!(this.highlighted && this.highlighted.includeDisabled) && this.isDisabledDate(date)) {
        return false;
      }

      var highlighted = false;

      if (typeof this.highlighted === 'undefined') {
        return false;
      }

      if (typeof this.highlighted.dates !== 'undefined') {
        this.highlighted.dates.forEach(function (d) {
          if (_this2.utils.compareDates(date, d)) {
            highlighted = true;
            return true;
          }
        });
      }

      if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
        highlighted = date >= this.highlighted.from && date <= this.highlighted.to;
      }

      if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(this.utils.getDay(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.daysOfMonth !== 'undefined' && this.highlighted.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.customPredictor === 'function' && this.highlighted.customPredictor(date)) {
        highlighted = true;
      }

      return highlighted;
    },
    dayClasses: function dayClasses(day) {
      return {
        'selected': day.isSelected,
        'disabled': day.isDisabled,
        'highlighted': day.isHighlighted,
        'today': day.isToday,
        'weekend': day.isWeekend,
        'sat': day.isSaturday,
        'sun': day.isSunday,
        'highlight-start': day.isHighlightStart,
        'highlight-end': day.isHighlightEnd
      };
    },

    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightStart: function isHighlightStart(date) {
      return this.isHighlightedDate(date) && this.highlighted.from instanceof Date && this.utils.getFullYear(this.highlighted.from) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.from) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.from) === this.utils.getDate(date);
    },

    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightEnd: function isHighlightEnd(date) {
      return this.isHighlightedDate(date) && this.highlighted.to instanceof Date && this.utils.getFullYear(this.highlighted.to) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.to) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.to) === this.utils.getDate(date);
    },

    /**
     * Helper
     * @param  {mixed}  prop
     * @return {Boolean}
     */
    isDefined: function isDefined(prop) {
      return typeof prop !== 'undefined' && prop;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showDayView,
          expression: "showDayView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextMonth() : _vm.previousMonth();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "day__month_btn",
            class: _vm.allowedToShowView("month") ? "up" : "",
            on: { click: _vm.showMonthCalendar }
          },
          [
            _vm._v(
              _vm._s(_vm.isYmd ? _vm.currYearName : _vm.currMonthName) +
                " " +
                _vm._s(_vm.isYmd ? _vm.currMonthName : _vm.currYearName)
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousMonth() : _vm.nextMonth();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.isRtl ? "flex-rtl" : "" },
        [
          _vm._l(_vm.daysOfWeek, function(d) {
            return _c(
              "span",
              { key: d.timestamp, staticClass: "cell day-header" },
              [_vm._v(_vm._s(d))]
            )
          }),
          _vm._v(" "),
          _vm.blankDays > 0
            ? _vm._l(_vm.blankDays, function(d) {
                return _c("span", {
                  key: d.timestamp,
                  staticClass: "cell day blank"
                })
              })
            : _vm._e(),
          _vm._l(_vm.days, function(day) {
            return _c("span", {
              key: day.timestamp,
              staticClass: "cell day",
              class: _vm.dayClasses(day),
              domProps: { innerHTML: _vm._s(_vm.dayCellContent(day)) },
              on: {
                click: function($event) {
                  return _vm.selectDate(day)
                }
              }
            })
          })
        ],
        2
      )
    ],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerDay = normalizeComponent_1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

//
var script$2 = {
  props: {
    showMonthView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    months: function months() {
      var d = this.pageDate;
      var months = []; // set up a new date object to the beginning of the current 'page'

      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate())) : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());

      for (var i = 0; i < 12; i++) {
        months.push({
          month: this.utils.getMonthName(i, this.translation.months),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedMonth(dObj),
          isDisabled: this.isDisabledMonth(dObj)
        });
        this.utils.setMonth(dObj, this.utils.getMonth(dObj) + 1);
      }

      return months;
    },

    /**
     * Get year name on current page.
     * @return {String}
     */
    pageYearName: function pageYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
    },

    /**
     * Is the left hand navigation disabled
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextYearDisabled(this.pageTimestamp) : this.isPreviousYearDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation disabled
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousYearDisabled(this.pageTimestamp) : this.isNextYearDisabled(this.pageTimestamp);
    }
  },
  methods: {
    /**
     * Emits a selectMonth event
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      if (month.isDisabled) {
        return false;
      }

      this.$emit('selectMonth', month);
    },

    /**
     * Changes the year up or down
     * @param {Number} incrementBy
     */
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedYear', date);
    },

    /**
     * Decrements the year
     */
    previousYear: function previousYear() {
      if (!this.isPreviousYearDisabled()) {
        this.changeYear(-1);
      }
    },

    /**
     * Checks if the previous year is disabled or not
     * @return {Boolean}
     */
    isPreviousYearDisabled: function isPreviousYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      return this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(this.pageDate);
    },

    /**
     * Increments the year
     */
    nextYear: function nextYear() {
      if (!this.isNextYearDisabled()) {
        this.changeYear(1);
      }
    },

    /**
     * Checks if the next year is disabled or not
     * @return {Boolean}
     */
    isNextYearDisabled: function isNextYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      return this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(this.pageDate);
    },

    /**
     * Emits an event that shows the year calendar
     */
    showYearCalendar: function showYearCalendar() {
      this.$emit('showYearCalendar');
    },

    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth: function isSelectedMonth(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date) && this.utils.getMonth(this.selectedDate) === this.utils.getMonth(date);
    },

    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth: function isDisabledMonth(date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getMonth(date) < this.utils.getMonth(this.disabledDates.to) && this.utils.getFullYear(date) <= this.utils.getFullYear(this.disabledDates.to) || this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getMonth(date) > this.utils.getMonth(this.disabledDates.from) && this.utils.getFullYear(date) >= this.utils.getFullYear(this.disabledDates.from) || this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showMonthView,
          expression: "showMonthView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextYear() : _vm.previousYear();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "month__year_btn",
            class: _vm.allowedToShowView("year") ? "up" : "",
            on: { click: _vm.showYearCalendar }
          },
          [_vm._v(_vm._s(_vm.pageYearName))]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousYear() : _vm.nextYear();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.months, function(month) {
        return _c(
          "span",
          {
            key: month.timestamp,
            staticClass: "cell month",
            class: { selected: month.isSelected, disabled: month.isDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.selectMonth(month)
              }
            }
          },
          [_vm._v(_vm._s(month.month))]
        )
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerMonth = normalizeComponent_1(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

//
var script$3 = {
  props: {
    showYearView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  computed: {
    years: function years() {
      var d = this.pageDate;
      var years = []; // set up a new date object to the beginning of the current 'page'7

      var dObj = this.useUtc ? new Date(Date.UTC(Math.floor(d.getUTCFullYear() / 10) * 10, d.getUTCMonth(), d.getUTCDate())) : new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());

      for (var i = 0; i < 10; i++) {
        years.push({
          year: this.utils.getFullYear(dObj),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedYear(dObj),
          isDisabled: this.isDisabledYear(dObj)
        });
        this.utils.setFullYear(dObj, this.utils.getFullYear(dObj) + 1);
      }

      return years;
    },

    /**
     * @return {String}
     */
    getPageDecade: function getPageDecade() {
      var decadeStart = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10;
      var decadeEnd = decadeStart + 9;
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(decadeStart, " - ").concat(decadeEnd).concat(yearSuffix);
    },

    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextDecadeDisabled(this.pageTimestamp) : this.isPreviousDecadeDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousDecadeDisabled(this.pageTimestamp) : this.isNextDecadeDisabled(this.pageTimestamp);
    }
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  methods: {
    selectYear: function selectYear(year) {
      if (year.isDisabled) {
        return false;
      }

      this.$emit('selectYear', year);
    },
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedDecade', date);
    },
    previousDecade: function previousDecade() {
      if (this.isPreviousDecadeDisabled()) {
        return false;
      }

      this.changeYear(-10);
    },
    isPreviousDecadeDisabled: function isPreviousDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      var disabledYear = this.utils.getFullYear(this.disabledDates.to);
      var lastYearInPreviousPage = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10 - 1;
      return disabledYear > lastYearInPreviousPage;
    },
    nextDecade: function nextDecade() {
      if (this.isNextDecadeDisabled()) {
        return false;
      }

      this.changeYear(10);
    },
    isNextDecadeDisabled: function isNextDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      var disabledYear = this.utils.getFullYear(this.disabledDates.from);
      var firstYearInNextPage = Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10;
      return disabledYear < firstYearInNextPage;
    },

    /**
     * Whether the selected date is in this year
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedYear: function isSelectedYear(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date);
    },

    /**
     * Whether a year is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledYear: function isDisabledYear(date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined' || !this.disabledDates) {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showYearView,
          expression: "showYearView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextDecade() : _vm.previousDecade();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.getPageDecade))]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousDecade() : _vm.nextDecade();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.years, function(year) {
        return _c(
          "span",
          {
            key: year.timestamp,
            staticClass: "cell year",
            class: { selected: year.isSelected, disabled: year.isDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.selectYear(year)
              }
            }
          },
          [_vm._v(_vm._s(year.year))]
        )
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerYear = normalizeComponent_1(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

//
var script$4 = {
  components: {
    DateInput: DateInput,
    PickerDay: PickerDay,
    PickerMonth: PickerMonth,
    PickerYear: PickerYear
  },
  props: {
    value: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    name: String,
    refName: String,
    id: String,
    format: {
      type: [String, Function],
      "default": 'dd MMM yyyy'
    },
    language: {
      type: Object,
      "default": function _default() {
        return en;
      }
    },
    openDate: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    dayCellContent: Function,
    fullMonthName: Boolean,
    disabledDates: Object,
    highlighted: Object,
    placeholder: String,
    inline: Boolean,
    calendarClass: [String, Object, Array],
    inputClass: [String, Object, Array],
    wrapperClass: [String, Object, Array],
    mondayFirst: Boolean,
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    bootstrapStyling: Boolean,
    initialView: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    useUtc: Boolean,
    minimumView: {
      type: String,
      "default": 'day'
    },
    maximumView: {
      type: String,
      "default": 'year'
    }
  },
  data: function data() {
    var startDate = this.openDate ? new Date(this.openDate) : new Date();
    var constructedDateUtils = makeDateUtils(this.useUtc);
    var pageTimestamp = constructedDateUtils.setDate(startDate, 1);
    return {
      /*
       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
       * This represents the first day of the current viewing month
       * {Number}
       */
      pageTimestamp: pageTimestamp,

      /*
       * Selected Date
       * {Date}
       */
      selectedDate: null,

      /*
       * Flags to show calendar views
       * {Boolean}
       */
      showDayView: false,
      showMonthView: false,
      showYearView: false,

      /*
       * Positioning
       */
      calendarHeight: 0,
      resetTypedDate: new Date(),
      utils: constructedDateUtils
    };
  },
  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    openDate: function openDate() {
      this.setPageDate();
    },
    initialView: function initialView() {
      this.setInitialView();
    }
  },
  computed: {
    computedInitialView: function computedInitialView() {
      if (!this.initialView) {
        return this.minimumView;
      }

      return this.initialView;
    },
    pageDate: function pageDate() {
      return new Date(this.pageTimestamp);
    },
    translation: function translation() {
      return this.language;
    },
    calendarStyle: function calendarStyle() {
      return {
        position: this.isInline ? 'static' : undefined
      };
    },
    isOpen: function isOpen() {
      return this.showDayView || this.showMonthView || this.showYearView;
    },
    isInline: function isInline() {
      return !!this.inline;
    },
    isRtl: function isRtl() {
      return this.translation.rtl === true;
    }
  },
  methods: {
    /**
     * Called in the event that the user navigates to date pages and
     * closes the picker without selecting a date.
     */
    resetDefaultPageDate: function resetDefaultPageDate() {
      if (this.selectedDate === null) {
        this.setPageDate();
        return;
      }

      this.setPageDate(this.selectedDate);
    },

    /**
     * Effectively a toggle to show/hide the calendar
     * @return {mixed}
     */
    showCalendar: function showCalendar() {
      if (this.disabled || this.isInline) {
        return false;
      }

      if (this.isOpen) {
        return this.close(true);
      }

      this.setInitialView();
    },

    /**
     * Sets the initial picker page view: day, month or year
     */
    setInitialView: function setInitialView() {
      var initialView = this.computedInitialView;

      if (!this.allowedToShowView(initialView)) {
        throw new Error("initialView '".concat(this.initialView, "' cannot be rendered based on minimum '").concat(this.minimumView, "' and maximum '").concat(this.maximumView, "'"));
      }

      switch (initialView) {
        case 'year':
          this.showYearCalendar();
          break;

        case 'month':
          this.showMonthCalendar();
          break;

        default:
          this.showDayCalendar();
          break;
      }
    },

    /**
     * Are we allowed to show a specific picker view?
     * @param {String} view
     * @return {Boolean}
     */
    allowedToShowView: function allowedToShowView(view) {
      var views = ['day', 'month', 'year'];
      var minimumViewIndex = views.indexOf(this.minimumView);
      var maximumViewIndex = views.indexOf(this.maximumView);
      var viewIndex = views.indexOf(view);
      return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
    },

    /**
     * Show the day picker
     * @return {Boolean}
     */
    showDayCalendar: function showDayCalendar() {
      if (!this.allowedToShowView('day')) {
        return false;
      }

      this.close();
      this.showDayView = true;
      return true;
    },

    /**
     * Show the month picker
     * @return {Boolean}
     */
    showMonthCalendar: function showMonthCalendar() {
      if (!this.allowedToShowView('month')) {
        return false;
      }

      this.close();
      this.showMonthView = true;
      return true;
    },

    /**
     * Show the year picker
     * @return {Boolean}
     */
    showYearCalendar: function showYearCalendar() {
      if (!this.allowedToShowView('year')) {
        return false;
      }

      this.close();
      this.showYearView = true;
      return true;
    },

    /**
     * Set the selected date
     * @param {Number} timestamp
     */
    setDate: function setDate(timestamp) {
      var date = new Date(timestamp);
      this.selectedDate = date;
      this.setPageDate(date);
      this.$emit('selected', date);
      this.$emit('input', date);
    },

    /**
     * Clear the selected date
     */
    clearDate: function clearDate() {
      this.selectedDate = null;
      this.setPageDate();
      this.$emit('selected', null);
      this.$emit('input', null);
      this.$emit('cleared');
    },

    /**
     * @param {Object} date
     */
    selectDate: function selectDate(date) {
      this.setDate(date.timestamp);

      if (!this.isInline) {
        this.close(true);
      }

      this.resetTypedDate = new Date();
    },

    /**
     * @param {Object} date
     */
    selectDisabledDate: function selectDisabledDate(date) {
      this.$emit('selectedDisabled', date);
    },

    /**
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      var date = new Date(month.timestamp);

      if (this.allowedToShowView('day')) {
        this.setPageDate(date);
        this.$emit('changedMonth', month);
        this.showDayCalendar();
      } else {
        this.selectDate(month);
      }
    },

    /**
     * @param {Object} year
     */
    selectYear: function selectYear(year) {
      var date = new Date(year.timestamp);

      if (this.allowedToShowView('month')) {
        this.setPageDate(date);
        this.$emit('changedYear', year);
        this.showMonthCalendar();
      } else {
        this.selectDate(year);
      }
    },

    /**
     * Set the datepicker value
     * @param {Date|String|Number|null} date
     */
    setValue: function setValue(date) {
      if (typeof date === 'string' || typeof date === 'number') {
        var parsed = new Date(date);
        date = isNaN(parsed.valueOf()) ? null : parsed;
      }

      if (!date) {
        this.setPageDate();
        this.selectedDate = null;
        return;
      }

      this.selectedDate = date;
      this.setPageDate(date);
    },

    /**
     * Sets the date that the calendar should open on
     */
    setPageDate: function setPageDate(date) {
      if (!date) {
        if (this.openDate) {
          date = new Date(this.openDate);
        } else {
          date = new Date();
        }
      }

      this.pageTimestamp = this.utils.setDate(new Date(date), 1);
    },

    /**
     * Handles a month change from the day picker
     */
    handleChangedMonthFromDayPicker: function handleChangedMonthFromDayPicker(date) {
      this.setPageDate(date);
      this.$emit('changedMonth', date);
    },

    /**
     * Set the date from a typedDate event
     */
    setTypedDate: function setTypedDate(date) {
      this.setDate(date.getTime());
    },

    /**
     * Close all calendar layers
     * @param {Boolean} emitEvent - emit close event
     */
    close: function close(emitEvent) {
      this.showDayView = this.showMonthView = this.showYearView = false;

      if (!this.isInline) {
        if (emitEvent) {
          this.$emit('closed');
        }

        document.removeEventListener('click', this.clickOutside, false);
      }
    },

    /**
     * Initiate the component
     */
    init: function init() {
      if (this.value) {
        this.setValue(this.value);
      }

      if (this.isInline) {
        this.setInitialView();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
} // eslint-disable-next-line
;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "vdp-datepicker",
      class: [_vm.wrapperClass, _vm.isRtl ? "rtl" : ""]
    },
    [
      _c(
        "date-input",
        {
          attrs: {
            selectedDate: _vm.selectedDate,
            resetTypedDate: _vm.resetTypedDate,
            format: _vm.format,
            translation: _vm.translation,
            inline: _vm.inline,
            id: _vm.id,
            name: _vm.name,
            refName: _vm.refName,
            openDate: _vm.openDate,
            placeholder: _vm.placeholder,
            inputClass: _vm.inputClass,
            typeable: _vm.typeable,
            clearButton: _vm.clearButton,
            clearButtonIcon: _vm.clearButtonIcon,
            calendarButton: _vm.calendarButton,
            calendarButtonIcon: _vm.calendarButtonIcon,
            calendarButtonIconContent: _vm.calendarButtonIconContent,
            disabled: _vm.disabled,
            required: _vm.required,
            bootstrapStyling: _vm.bootstrapStyling,
            "use-utc": _vm.useUtc
          },
          on: {
            showCalendar: _vm.showCalendar,
            closeCalendar: _vm.close,
            typedDate: _vm.setTypedDate,
            clearDate: _vm.clearDate
          }
        },
        [_vm._t("afterDateInput", null, { slot: "afterDateInput" })],
        2
      ),
      _vm._v(" "),
      _vm.allowedToShowView("day")
        ? _c(
            "picker-day",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showDayView: _vm.showDayView,
                fullMonthName: _vm.fullMonthName,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                highlighted: _vm.highlighted,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                pageTimestamp: _vm.pageTimestamp,
                isRtl: _vm.isRtl,
                mondayFirst: _vm.mondayFirst,
                dayCellContent: _vm.dayCellContent,
                "use-utc": _vm.useUtc
              },
              on: {
                changedMonth: _vm.handleChangedMonthFromDayPicker,
                selectDate: _vm.selectDate,
                showMonthCalendar: _vm.showMonthCalendar,
                selectedDisabled: _vm.selectDisabledDate
              }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowedToShowView("month")
        ? _c(
            "picker-month",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showMonthView: _vm.showMonthView,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                isRtl: _vm.isRtl,
                "use-utc": _vm.useUtc
              },
              on: {
                selectMonth: _vm.selectMonth,
                showYearCalendar: _vm.showYearCalendar,
                changedYear: _vm.setPageDate
              }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowedToShowView("year")
        ? _c(
            "picker-year",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showYearView: _vm.showYearView,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                isRtl: _vm.isRtl,
                "use-utc": _vm.useUtc
              },
              on: { selectYear: _vm.selectYear, changedDecade: _vm.setPageDate }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = function (inject) {
    if (!inject) return
    inject("data-v-64ca2bb5_0", { source: ".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n", map: {"version":3,"sources":["Datepicker.vue"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,eAAe;AACjB","file":"Datepicker.vue","sourcesContent":[".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  

  
  var Datepicker = normalizeComponent_1(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    browser,
    undefined
  );

/* harmony default export */ __webpack_exports__["a"] = (Datepicker);


/***/ }),
/* 142 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(142);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);
var settle = __webpack_require__(652);
var buildURL = __webpack_require__(151);
var parseHeaders = __webpack_require__(659);
var isURLSameOrigin = __webpack_require__(657);
var createError = __webpack_require__(147);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(655);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(651);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  utils.forEach(['url', 'method', 'params', 'data'], function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(['headers', 'auth', 'proxy'], function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach([
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength',
    'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken',
    'socketPath'
  ], function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(38);
var normalizeHeaderName = __webpack_require__(658);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  // Only Node.JS has a process variable that is of [[Class]] process
  if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(144);
  } else if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(144);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(614)))

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




window.$ = window.jQuery = window.jquery = __webpack_require__(30);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ready: false,
      NotificationTitle: "",
      NotificationTBody: "",
      IsNotification: false,
      logoutTimer: null,
      checkTime: 0,
      maxCheckTime: 86400000,
      hiddenTime: 0,
      hiddenCheckInterval: 1000 // 1 second
    };
  },
  methods: {
    // CR-StockCoverDays (QA BUG-02): ซ่อนหัวข้อเมนู (kt-menu__section) ที่ไม่มีเมนูย่อยที่ user เข้าได้เลย
    // นับเฉพาะลิงก์ปลายทาง (a.kt-menu__link ที่ไม่ใช่ตัวเปิด submenu) ระหว่างหัวข้อนี้กับหัวข้อถัดไป —
    // เมนูที่ไม่มีสิทธิ์ถูก v-if ตัดออกจาก DOM แล้ว จึงไม่ต้องรู้เงื่อนไขสิทธิ์ของแต่ละเมนู
    syncMenuSections: function syncMenuSections() {
      var nav = this.$el && this.$el.querySelector ? this.$el.querySelector("#kt_aside_menu .kt-menu__nav") : null;
      if (!nav) return;
      var sections = nav.querySelectorAll(":scope > li.kt-menu__section");
      for (var i = 0; i < sections.length; i++) {
        var hasItem = false;
        for (var el = sections[i].nextElementSibling; el && !el.classList.contains("kt-menu__section"); el = el.nextElementSibling) {
          if (el.querySelector("a.kt-menu__link:not(.kt-menu__toggle)")) {
            hasItem = true;
            break;
          }
        }
        sections[i].style.display = hasItem ? "" : "none";
      }
    },

    /**
     * QA 08/10/2026 (CR-FormSummaryStock) เรื่องที่ 2
     *   หัวข้อกลุ่มเมนู เช่น "รายงาน (Report)" แสดงอยู่แม้ไม่มีเมนูย่อยสักตัวใต้มัน
     *   เพราะ v-if ของหัวข้อกับของเมนูย่อยแต่ละตัวเป็นคนละเงื่อนไขกัน
     *   ผู้ใช้จึงเห็นหัวข้อลอย ๆ กดอะไรไม่ได้
     *
     *   แก้แบบกลาง: ไล่ดูทุก .kt-menu__section ว่ามีเมนูที่มองเห็นได้คั่นอยู่ก่อนถึง
     *   section ถัดไปหรือไม่ ถ้าไม่มีก็ซ่อนหัวข้อนั้น
     *
     *   เลือกวิธีนี้แทนการไปไล่แก้ v-if ของหัวข้อทีละอัน เพราะเมนูย่อยใต้แต่ละหัวข้อ
     *   เป็นของหลายทีม/หลาย CR การรวมเงื่อนไขด้วยมือเสี่ยงทำเมนูของทีมอื่นหาย
     *   วิธีนี้ไม่แตะ v-if ของใครเลย และครอบทุกหัวข้อโดยอัตโนมัติ
     */
    hideEmptyMenuSections: function hideEmptyMenuSections() {
      this.$nextTick(function () {
        var nav = document.querySelector('#kt_aside_menu .kt-menu__nav');
        if (!nav) return;

        var children = Array.prototype.slice.call(nav.children);

        // FS-137 (BUG-15 · 21/10/2026): <li> ใน sidebar ไม่มี key → Vue reuse DOM node ตอน re-render
        //   display:none ที่ตั้งให้ "หัวข้อ" (ฟังก์ชันนี้ / syncMenuSections) จึงติดไปกับ "เมนู" ได้
        //   แล้ว offsetParent ของเมนูเป็น null → หัวข้อถูกซ่อนซ้ำทุกรอบ (เมนูหายถาวรหลัง F5)
        //   ฟังก์ชันนี้ตั้ง display ได้เฉพาะหัวข้อ และ li ระดับบนของ sidebar ไม่มี v-show / inline display
        //   จาก markup → ล้างค่าที่ค้างบน li อื่นก่อนคำนวณ
        children.forEach(function (node) {
          if (node.className.indexOf('kt-menu__section') < 0 && node.style.display === 'none') {
            node.style.display = '';
          }
        });

        children.forEach(function (node, index) {
          if (node.className.indexOf('kt-menu__section') < 0) return;

          var hasVisibleItem = false;

          for (var i = index + 1; i < children.length; i++) {
            var next = children[i];

            // ถึงหัวข้อถัดไปแล้ว = จบขอบเขตของหัวข้อนี้
            if (next.className.indexOf('kt-menu__section') >= 0) break;

            // v-if ที่เป็นเท็จจะไม่มี element อยู่ใน DOM เลย
            // ที่เหลือจึงเช็คแค่ว่าไม่ได้ถูกซ่อนด้วย CSS
            if (next.className.indexOf('kt-menu__item') >= 0 && next.offsetParent !== null) {
              hasVisibleItem = true;
              break;
            }
          }

          node.style.display = hasVisibleItem ? '' : 'none';
        });
      });
    },
    subIsActive: function subIsActive(input) {
      var _this = this;

      var paths = Array.isArray(input) ? input : [input];
      return paths.some(function (path) {
        return _this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    signOut: function signOut() {
      // #65: ไม่ logout ICT SSO — ลบ local token เท่านั้น
      // เพื่อให้ ICT user กด login กลับมาได้โดยไม่ต้องกรอก password
      this.$root.signOut();
    },
    companyChange: function companyChange(e) {},
    startCheckTimer: function startCheckTimer() {
      var _this2 = this;

      this.clearTimer();
      this.logoutTimer = setInterval(function () {
        _this2.checkTime += 1000;
        if (_this2.checkTime >= _this2.maxCheckTime) {
          _this2.showCheckTimeoutModal();
        }
      }, 1000);
    },
    resetTimer: function resetTimer() {
      this.checkTime = 0;
      localStorage.setItem('lastActiveTime', Date.now());
    },
    clearTimer: function clearTimer() {
      if (this.logoutTimer) {
        clearInterval(this.logoutTimer);
        this.logoutTimer = null;
      }
      if (this.hiddenTimer) {
        clearInterval(this.hiddenTimer);
        this.hiddenTimer = null;
      }
    },
    showCheckTimeoutModal: function showCheckTimeoutModal() {
      this.clearTimer();
      localStorage.setItem('showCheckTimeoutModal', 'true');
      $('#checkTimeoutModal').modal('show');
    },
    handleOkClick: function handleOkClick() {
      // #64: idle timeout → ลบ local token เท่านั้น ไม่ logout ICT SSO
      // เพื่อให้ auto-login กลับมาได้โดยไม่ต้องกรอก password ใหม่
      $('#checkTimeoutModal').modal('hide');
      localStorage.removeItem('showCheckTimeoutModal');
      localStorage.setItem('triggerLogout', Date.now());
      // ใช้ removeUser() แทน signOut() เพื่อไม่ redirect ไป ADFS signout
      this.$root.mgr.removeUser().then(function () {
        window.location.href = '/Account/Login';
      });
    },
    handleStorageChange: function handleStorageChange(event) {
      if (event.key === 'lastActiveTime' && event.newValue) {
        this.resetTimer();
      } else if (event.key === 'showCheckTimeoutModal' && event.newValue === 'true') {
        this.showCheckTimeoutModal();
      } else if (event.key === 'showCheckTimeoutModal' && event.newValue === null) {
        $('#checkTimeoutModal').modal('hide');
      } else if (event.key === 'triggerLogout' && event.newValue) {
        // #67: cross-tab idle timeout → ใช้ removeUser() เหมือน tab หลัก (ไม่ logout ICT SSO)
        this.$root.mgr.removeUser().then(function () {
          window.location.href = '/Account/Login';
        });
      }
    },
    handleVisibilityChange: function handleVisibilityChange() {
      var _this3 = this;

      if (document.hidden) {
        this.hiddenTime = Date.now();
        this.hiddenTimer = setInterval(function () {
          var now = Date.now();
          var hiddenDuration = now - _this3.hiddenTime;
          _this3.checkTime += hiddenDuration;
          _this3.hiddenTime = now;
          if (_this3.checkTime >= _this3.maxCheckTime) {
            _this3.showCheckTimeoutModal();
          }
        }, this.hiddenCheckInterval);
      } else {
        if (this.hiddenTimer) {
          clearInterval(this.hiddenTimer);
          this.hiddenTimer = null;
        }
        this.hiddenTime = 0;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('mousemove', this.resetTimer);
    window.removeEventListener('keydown', this.resetTimer);
    window.removeEventListener('click', this.resetTimer);
    window.removeEventListener('storage', this.handleStorageChange);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.clearTimer();
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, alertStep, currentStep, landing;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this4;
              alertStep = [];
              _context3.next = 4;
              return self.$root.authenticate(self.$route.path);

            case 4:
              if (!self.$root.isAuthenticated) {
                _context3.next = 7;
                break;
              }

              _context3.next = 7;
              return self.$root.loadProfiles();

            case 7:
              _context3.t0 = self.$root.isAuthenticated;

              if (!_context3.t0) {
                _context3.next = 12;
                break;
              }

              _context3.next = 11;
              return self.$root.canAccessPage(self.$route);

            case 11:
              _context3.t0 = !_context3.sent;

            case 12:
              if (!_context3.t0) {
                _context3.next = 22;
                break;
              }

              if (!(self.$route.path === "/")) {
                _context3.next = 19;
                break;
              }

              _context3.next = 16;
              return self.$root.budgetLandingPath();

            case 16:
              _context3.t1 = _context3.sent;
              _context3.next = 20;
              break;

            case 19:
              _context3.t1 = null;

            case 20:
              landing = _context3.t1;

              __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({
                path: landing || "/Error/Unauthorized"
              });

            case 22:

              self.$loadScript("/themes/metronic/assets/vendors/base/vendors.bundle.js").then(function () {
                self.$loadScript("/themes/metronic/assets/demo/default/base/scripts.bundle.js").then(function () {
                  self.$loadScript("/themes/metronic/assets/app/bundle/app.bundle.js").then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            self.$loadScript("/themes/metronic/assets/app/custom/general/crud/forms/widgets/bootstrap-datepicker.js").then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                              var result;
                              return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      //self.$loadScript("/js/setting.js").then(() => {
                                      $(document).on("show.bs.modal", ".modal", function () {
                                        var zIndex = 1040 + 10 * $(".modal:visible").length;
                                        $(self).css("z-index", zIndex);
                                        setTimeout(function () {
                                          $(".modal-backdrop").not(".modal-stack").css("z-index", zIndex - 1).addClass("modal-stack");
                                        }, 0);
                                      });

                                      // Set custom validator methods
                                      $.validator.addMethod("regex", function (value, element, regexp) {
                                        var re = new RegExp(regexp);
                                        return this.optional(element) || re.test(value);
                                      }, "Please check your input.");

                                      $.validator.addMethod("emailNullable", function (value, ele) {
                                        var val = $(ele).val();
                                        var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
                                        return !val || pattern.test(val);
                                      }, "Invalid email format");

                                      _context.next = 5;
                                      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/CompanyProfile/GetMyProfiles").then(function (response) {
                                        if (response.status == 200) {
                                          self.$root.profiles = response.data;
                                          $.ready();
                                          self.ready = true;

                                          // if (response.data[0].isNotification) {
                                          //   if (response.data[0].notificationBody !== null && response.data[0].notificationTitle !== null) {
                                          //     Swal.fire({
                                          //       title: response.data[0].notificationTitle,
                                          //       html:
                                          //         '<p style="text-align: left;">' +
                                          //         response.data[0].notificationBody +
                                          //         "</p>",
                                          //       icon: "warning",
                                          //     });
                                          //   }

                                          //   else if (response.data[0].notificationTitle2 !== null) {
                                          //     Swal.fire({
                                          //       title: response.data[0].notificationTitle2,
                                          //       html:
                                          //         '<p style="text-align: left;">' +
                                          //         response.data[0].notificationBody2 +
                                          //         "</p>",
                                          //       icon: "warning",
                                          //     });
                                          //   }
                                          // }
                                        }
                                      });

                                    case 5:
                                      _context.next = 7;
                                      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Users/GetNotify").then(function (response) {
                                        if (response.status == 200) {
                                          if (response.data.notificationBody !== null) {
                                            alertStep.push({
                                              "title": response.data.notificationTitle,
                                              "body": '<p style="text-align: left;">' + response.data.notificationBody + "</p>",
                                              "icon": "warning"
                                            });
                                          }
                                          if (response.data.notificationBodyPMPastDue !== null) {
                                            alertStep.push({
                                              "title": response.data.notificationTitlePMPastDue,
                                              "body": '<p style="text-align: left;">' + response.data.notificationBodyPMPastDue + "</p>",
                                              "icon": "warning"
                                            });
                                          }
                                          if (response.data.notificationBodyPMAdvance !== null) {
                                            alertStep.push({
                                              "title": response.data.notificationTitlePMAdvance,
                                              "body": '<p style="text-align: left;">' + response.data.notificationBodyPMAdvance + "</p>",
                                              "icon": "warning"
                                            });
                                          }
                                          // if (response.data.notificationBody !== null) {
                                          //   Swal.fire({
                                          //     title: response.data.notificationTitle,
                                          //     html:
                                          //       '<p style="text-align: left;">' +
                                          //       response.data.notificationBody +
                                          //       "</p>",
                                          //     icon: "warning",
                                          //   }).then((result) => {
                                          //     if (response.data.notificationBodyPM !== null) {
                                          //       Swal.fire({
                                          //         title: response.data.notificationTitlePM,
                                          //         html:
                                          //           '<p style="text-align: left;">' +
                                          //           response.data.notificationBodyPM +
                                          //           "</p>",
                                          //         icon: "warning",
                                          //       });
                                          //     }
                                          //   });
                                          // }
                                        }
                                      });

                                    case 7:
                                      _context.next = 9;
                                      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Users/GetBeerClaimQINotify").then(function (response) {
                                        if (response.status == 200) {
                                          if (response.data.isNotification) {
                                            alertStep.push({
                                              "title": response.data.notificationTitle,
                                              "body": '<p style="text-align: left;">' + response.data.notificationBody + "</p>",
                                              "icon": "warning"
                                            });
                                          }
                                        }
                                      });

                                    case 9:
                                      if (!(_this4.$route.fullPath == "/" || _this4.$route.fullPath == "/Error/Unauthorized" || _this4.$route.fullPath.length <= 1)) {
                                        _context.next = 12;
                                        break;
                                      }

                                      _context.next = 12;
                                      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Users/GetOverdueNotify").then(function (response) {
                                        if (response.status == 200) {
                                          if (response.data.isNotification) {
                                            alertStep.push({
                                              "title": response.data.notificationTitle,
                                              "body": '<p style="text-align: left;">' + response.data.notificationBody + "</p>",
                                              "icon": "warning"
                                            });
                                          }
                                        }
                                      });

                                    case 12:
                                      if (!(_this4.$route.fullPath == "/" || _this4.$route.fullPath == "/Error/Unauthorized" || _this4.$route.fullPath.length <= 1)) {
                                        _context.next = 15;
                                        break;
                                      }

                                      _context.next = 15;
                                      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Users/GetBeforeOverdueNotify").then(function (response) {
                                        if (response.status == 200) {
                                          if (response.data.isNotification) {
                                            alertStep.push({
                                              "title": response.data.notificationTitle,
                                              "body": '<p style="text-align: left;">' + response.data.notificationBody + "</p>",
                                              "icon": "warning"
                                            });
                                          }
                                        }
                                      });

                                    case 15:
                                      currentStep = 0;

                                    case 16:
                                      if (!(currentStep < alertStep.length)) {
                                        _context.next = 31;
                                        break;
                                      }

                                      _context.next = 19;
                                      return Swal.fire({
                                        title: alertStep[currentStep].title,
                                        html: alertStep[currentStep].body,
                                        icon: alertStep[currentStep].icon,
                                        showCancelButton: currentStep > 0,
                                        currentProgressStep: currentStep,
                                        reverseButtons: true,
                                        cancelButtonText: 'Back'
                                      });

                                    case 19:
                                      result = _context.sent;

                                      if (!(result.value || result.dismiss == 'backdrop')) {
                                        _context.next = 24;
                                        break;
                                      }

                                      currentStep++;
                                      _context.next = 29;
                                      break;

                                    case 24:
                                      if (!(result.dismiss == "cancel")) {
                                        _context.next = 28;
                                        break;
                                      }

                                      currentStep--;
                                      _context.next = 29;
                                      break;

                                    case 28:
                                      return _context.abrupt("break", 31);

                                    case 29:
                                      _context.next = 16;
                                      break;

                                    case 31:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, _this4);
                            }))
                            // ALERT BEERCLAIM QI -----------
                            );

                          case 1:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this4);
                  })));
                });
              });

              _this4.startCheckTimer();
              window.addEventListener('mousemove', _this4.resetTimer);
              window.addEventListener('keydown', _this4.resetTimer);
              window.addEventListener('click', _this4.resetTimer);
              window.addEventListener('storage', _this4.handleStorageChange);
              document.addEventListener('visibilitychange', _this4.handleVisibilityChange);
              if (localStorage.getItem('showCheckTimeoutModal') === 'true') {
                _this4.showCheckTimeoutModal();
              }

              _this4.hideEmptyMenuSections();

            case 31:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  },

  updated: function updated() {
    // สิทธิ์/โปรไฟล์โหลดแล้ว sidebar re-render → คำนวณหัวข้อเมนูใหม่
    //   merge เข้า sit/c-20260831 (13/10/2026): 2 CR แก้ปัญหาหัวข้อเมนูว่างแยกกัน และต่างคนต่างมี updated()
    //   key ซ้ำใน object literal ตัวหลังจะทับตัวแรกเงียบ ๆ จึงรวมไว้ที่ hook เดียว เรียกครบทั้งสอง
    this.syncMenuSections(); // CR-StockCoverDays QA BUG-02 — ซ่อนหัวข้อที่ไม่มีลิงก์ปลายทางใน DOM
    this.hideEmptyMenuSections(); // CR-FormSummaryStock QA เรื่องที่ 2 — ซ่อนหัวข้อที่ไม่มีเมนูที่มองเห็นได้
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    var self = this;
    return {
      cfelSubFolderName: null

    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var self = this;
      var router = this.$router;

      if (!$("#createFolderELearningModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/Folder/AddSubFolder",
        data: {
          folderName: self.cfelSubFolderName,
          parentFolderId: router.currentRoute.params.id
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $("#createFolderELearningModal").modal("hide");
            //this.$router.push(`/5S/E-Learning/Detials/${router.currentRoute.params.id}`);
            //this.$router.go();
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error").then(function () {
          $("#createFolderELearningModal").modal("hide");
        });
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              // set validation rules
              $("#createFolderELearningModal form").validate({
                rules: {
                  cfelSubFolderName: "required"
                },
                messages: {
                  cfelSubFolderName: "กรุณาระบุหมวดหมู่"
                }
              });

              $("#createFolderELearningModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              }).modal("show");

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_plupload__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var Action = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend({
  template: "\n  <div>\n    <a :href=\"'/Api/FileElearning/FileStream/' + data.folderAndFileId\" @click.prevent=\"Play\" v-if=\"data.showPlayButton\" title=\"\u0E40\u0E25\u0E48\u0E19\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"text-info fas fa-play\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"download\" v-if=\"data.showDownloadButton\" title=\"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"text-info fas fa-download\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditFolderButton\" title=\"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"text-info la la-pencil\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"editFile\" v-if=\"data.showEditFileButton\" title=\"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E44\u0E1F\u0E25\u0E4C\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"text-info la la-pencil\"></i>\n    </a>\n    <a :href=\"'/5S/E-Learning/Detials/' + data.folderAndFileId\" @click.prevent=\"Details\" v-if=\"data.showDetailsButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"text-info far fa-folder-open\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"Delete\" v-if=\"data.showDeletesFolderButton\" title=\"\u0E25\u0E1A\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"text-danger fas fa-trash-alt\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"DeleteFile\" v-if=\"data.showDeletesFileButton\" title=\"\u0E25\u0E1A\u0E44\u0E1F\u0E25\u0E4C\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"text-danger fas fa-trash-alt\"></i>\n    </a>\n  </div>",
  methods: {
    Play: function Play() {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "get",
        url: "/Api/FileElearning/FileStream/" + self.data.folderAndFileId
      }).then(function (response) {
        if (response.status == "200") {
          //window.open(response.data);
          window.open(response.data, "_blank", "location=yes,height=500,width=600,scrollbars=no,status=yes");
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        self.$parent.reloadDataTable();
        KTApp.unblockPage();
      });
    },
    download: function download() {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "get",
        url: "/Api/FileElearning/" + self.data.folderAndFileId,
        responseType: "arraybuffer"
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            //console.log(matches);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          var blob = new Blob([response.data], { type: contentType }),
              url = window.URL.createObjectURL(blob);

          var browserOpen = ["jpg", "jpeg", "png", "gif", "pdf"];
          if (browserOpen.includes(self.data.contentType)) {
            var nAgt = navigator.userAgent;
            if (nAgt.includes('Chrome/') || nAgt.includes('Safari/') || nAgt.includes('Edg/') || nAgt.includes('Safari/') || nAgt.includes('Firefox/')) {
              window.open(url);
            } else {
              if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, filename);
              }
            }
          } else {

            var nAgt = navigator.userAgent;
            if (nAgt.includes('Chrome/') || nAgt.includes('Safari/') || nAgt.includes('Edg/') || nAgt.includes('Safari/') || nAgt.includes('Firefox/')) {
              var a = $("<a />", {
                href: url,
                download: decodeURIComponent(filename)
              }).appendTo("body").get(0).click();
            } else {
              if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, filename);
              }
            }
          }
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        self.$parent.reloadDataTable();
        KTApp.unblockPage();
      });
    },
    edit: function edit() {
      var _this = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งเปลี่ยนชื่อหมวดหมู่ย่อย",
        type: "info",
        html: "กรุณาระบุชื่อหมวดหมู่ย่อย <strong>",
        input: "text",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(value) {
          if (value) {
            return value;
          } else {
            Swal.showValidationMessage("กรุณาระบุชื่อหมวดหมู่ย่อย");
          }
        }
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/Folder", {
            FolderElearningId: _this.data.folderAndFileId,
            FolderName: result.value
          }).then(function (response) {
            if (response.data.status == true) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    editFile: function editFile() {
      var _this2 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งเปลี่ยนชื่อไฟล์",
        type: "info",
        html: "กรุณาระบุชื่อไฟล์ <strong>",
        input: "text",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(value) {
          if (value) {
            return value;
          } else {
            Swal.showValidationMessage("กรุณาระบุชื่อไฟล์");
          }
        }
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/FileElearning", {
            FileElearningId: _this2.data.folderAndFileId,
            FileName: result.value
          }).then(function (response) {
            if (response.data.status == true) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    Details: function Details() {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/5S/E-Learning/Detials/" + self.data.folderAndFileId
      });
      self.$parent.id = self.data.folderAndFileId;
      self.$parent.reloadDataTableChangeParam(false);
    },
    Delete: function Delete() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลหมวดหมู่ย่อย",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลหมวดหมู่ย่อย <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลหมวดหมู่ย่อยไม่ถูกใช้งาน",
        inputPlaceholder: "ต้องการลบข้อมูลหมวดหมู่ย่อย",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/Folder/" + _this3.data.folderAndFileId + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    DeleteFile: function DeleteFile() {
      var _this4 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบไฟล์",
        type: "warning",
        html: "กรุณายืนยันคำสั่งคำสั่งลบไฟล์ <strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/FileElearning/" + _this4.data.folderAndFileId + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

var ActionUrlFile = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend({
  template: "\n  <div>\n    <a :href=\"'/Api/FileElearning/' + data.folderAndFileId\" @click.prevent=\"download\"  v-if=\"data.contentTypeGroup == 'file-image'\" title=\"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\" >\n      <i class=\"text-info fas fa-file-image\"></i> {{data.folderAndFileName}}\n    </a>\n    <a :href=\"'/Api/FileElearning/' + data.folderAndFileId\" @click.prevent=\"download\"  v-if=\"data.contentTypeGroup == 'file-power-point'\" title=\"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\" >\n      <i class=\"text-info fas fa-file-powerpoint\"></i> {{data.folderAndFileName}}\n    </a>\n    <a :href=\"'/Api/FileElearning/' + data.folderAndFileId\" @click.prevent=\"download\"  v-if=\"data.contentTypeGroup == 'file-pdf'\" title=\"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\" >\n      <i class=\"text-info fas fa-file-pdf\"></i> {{data.folderAndFileName}}\n    </a>\n    <a :href=\"'/Api/FileElearning/' + data.folderAndFileId\" @click.prevent=\"download\"  v-if=\"data.contentTypeGroup == 'file-excel'\" title=\"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\" >\n      <i class=\"text-info fas fa-file-excel\"></i> {{data.folderAndFileName}}\n    </a>\n    <a :href=\"'/Api/FileElearning/' + data.folderAndFileId\" @click.prevent=\"download\"  v-if=\"data.contentTypeGroup == 'file-word'\" title=\"\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\" >\n      <i class=\"text-info fas fa-file-word\"></i> {{data.folderAndFileName}}\n    </a>\n\n    <a :href=\"'/Api/FileElearning/FileStream/' + data.folderAndFileId\" @click.prevent=\"Play\" v-if=\"data.contentTypeGroup == 'file-video'\" title=\"\u0E40\u0E25\u0E48\u0E19\">\n      <i class=\"text-info fas fa-play\"></i> {{data.folderAndFileName}}\n    </a>\n  </div>",
  methods: {
    Play: function Play() {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "get",
        url: "/Api/FileElearning/FileStream/" + self.data.folderAndFileId
      }).then(function (response) {
        if (response.status == "200") {
          //window.open(response.data);
          window.open(response.data, "_blank", "location=yes,height=500,width=600,scrollbars=no,status=yes");
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        self.$parent.reloadDataTable();
        KTApp.unblockPage();
      });
    },

    download: function download() {
      var self = this;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });
      console.log('get download 2', self.data);

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "get",
        url: "/Api/FileElearning/" + self.data.folderAndFileId,
        responseType: "arraybuffer"
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            //console.log(matches);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          var blob = new Blob([response.data], { type: contentType }),
              url = window.URL.createObjectURL(blob);

          var browserOpen = ["jpg", "jpeg", "png", "gif", "pdf"];
          if (browserOpen.includes(self.data.contentType)) {
            var nAgt = navigator.userAgent;
            if (nAgt.includes('Chrome/') || nAgt.includes('Safari/') || nAgt.includes('Edg/') || nAgt.includes('Safari/') || nAgt.includes('Firefox/')) {
              window.open(url);
            } else {
              if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, filename);
              }
            }
          } else {

            var nAgt = navigator.userAgent;
            if (nAgt.includes('Chrome/') || nAgt.includes('Safari/') || nAgt.includes('Edg/') || nAgt.includes('Safari/') || nAgt.includes('Firefox/')) {
              var a = $("<a />", {
                href: url,
                download: decodeURIComponent(filename)
              }).appendTo("body").get(0).click();
            } else {
              if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, filename);
              }
            }
          }
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        self.$parent.reloadDataTable();
        KTApp.unblockPage();
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      uuid: null,
      FileUpload: null,
      delFilename: null,
      delFolderName: null,
      delFolderId: null,
      delParentFolderId: null,
      delCreateDate: null,
      delCreateBy: null,
      delStatus: false,
      delItems: [],
      IsShowUploadBtn: false,
      delFolderLevel: 0,
      id: null,
      delParentLink: null
    };
  },

  methods: {
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#folderDetilsTable").DataTable().ajax.reload(null, resetPaging);
    },
    reloadDataTableChangeParam: function reloadDataTableChangeParam() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#folderDetilsTable").DataTable().ajax.url("/Api/Folder/" + this.id).load();
      // $("#folderDetilsTable")
      //   .DataTable()
      //   .ajax.reload(null, resetPaging);
    },
    AddSub: function AddSub() {
      var router = this.$router;
      var self = this;
      router.push({
        path: "/5S/E-Learning/Detials/" + self.delFolderId + "/AddSubFolder"
      });
    },
    GotoParent: function GotoParent(id) {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/5S/E-Learning/Detials/" + id
      });
      self.id = id;
      self.reloadDataTableChangeParam(false);
    },
    Goback: function Goback() {
      var self = this;
      if (self.delParentFolderId != null) {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
        });

        self.$router.push({
          path: "/5S/E-Learning/Detials/" + self.delParentFolderId
        });
        self.id = self.delParentFolderId;
        self.reloadDataTableChangeParam(false);
      } else {
        //this.$router.go(-1)

        self.$router.push("/5S/E-Learning");
      }
    },
    GetContentType: function GetContentType(fileName) {
      var extension = fileName.split('.').pop().toLowerCase();
      var allowedExtensions = ["jpg", "jpeg", "png", "pdf", "xlsx", "xls", "doc", "docx", "mp4", "avi", "ppt", "pptx"];

      return allowedExtensions.includes(extension) ? extension : "unknown";
    },
    initPlUploader: function initPlUploader() {
      var self = this;
      self.uuid = this._uid;

      var uploader = new __WEBPACK_IMPORTED_MODULE_3_plupload___default.a.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        multi_selection: false,
        browse_button: "uploader-order",
        url: "#",
        chunk_size: "1mb",
        max_retries: 5,
        filters: {
          max_file_size: "1024mb",
          mime_types: [{
            title: "doc files",
            extensions: "jpg,jpeg,png,pdf,xlsx,xls,doc,docx,mp4,avi,ppt,pptx"
          }]
        },
        init: {
          PostInit: function PostInit() {},
          FilesAdded: function FilesAdded(up, files) {
            var $imageContainer = $("#container-file");
            if ($("#files", $imageContainer).data("file-id") != null) {
              $imageContainer.empty();
            }
            var removeFiles = [];
            __WEBPACK_IMPORTED_MODULE_3_plupload___default.a.each(files, function (file) {
              self.delFilename = file.name;
              if ($('div[data-file-name="' + file.name + '"]', $imageContainer).length == 0) {
                var nativeData = file.getNative();

                if (files[0]) {
                  var contentType = self.GetContentType(file.name);
                  self.FileUpload = {
                    isNew: true,
                    fileDataContext: nativeData,
                    contentType: contentType,
                    fileId: file.id,
                    fileName: file.name
                  };
                }

                if (typeof FileReader != "undefined") {
                  var image_holder = $('<div class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap" id="' + file.id + '"></div>');
                  $('<div style="display:none" id="files" data-file-id="' + file.id + '" data-file-name="' + file.name + '" data-file-uploaded="false" alt="' + file.name + '">' + file.name + '<div id="myProgress" class="progress' + file.id + '"><div id="myBar" class="progress-bar bg-ptimary"><b></b></div ></div></div>').appendTo(image_holder);
                  image_holder.appendTo($imageContainer);
                  var reader = new FileReader();
                  reader.onload = function (e) {
                    $("div[data-file-id=" + file.id + "]").attr("src", e.target.result).show();
                  };
                  reader.readAsDataURL(nativeData);
                  self.mockProgress(file.id);
                }
              } else {
                removeFiles.push(file);
              }
            });
            if (removeFiles.length > 0) {
              for (var i = 0; i < removeFiles.length; i++) {
                up.removeFile(removeFiles[i]);
              }
              swal("ขออภัย", "ไม่สามารถเลือกไฟล์ซ้ำได้", "warning");
            }
          },
          UploadProgress: function UploadProgress(up, file) {},
          FileUploaded: function FileUploaded(up, file, info) {
            console.log("FileUploaded");
          },
          Error: function Error(up, err) {
            console.log(err);
            swal("Error", "เกิดข้อผิดพลาด: " + err.message, "error");
          }
        }
      });

      uploader.init();
    },
    mockProgress: function mockProgress(fileId) {
      var _this5 = this;

      var progress = 0;
      var interval = setInterval(function () {
        progress += 50;
        if (progress <= 100) {
          $('#myBar').css('width', progress + '%');
          document.getElementById(fileId).getElementsByTagName("b")[0].innerHTML = "<span>" + progress + "%</span>";
        } else {
          clearInterval(interval);
          _this5.IsShowUploadBtn = true;
        }
      }, 10);
    },
    UploadFile: function UploadFile(e) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var router, self, uploadedFile, file, formData, uploadResponse;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                router = _this6.$router;
                self = _this6;

                if ($(_this6.$refs.form).validate().form()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังอัพโหลด กรุณารอสักครู่..."
                });

                uploadedFile = null;

                if (!(_this6.FileUpload && _this6.FileUpload.isNew && _this6.FileUpload.fileDataContext)) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 7;
                file = _this6.FileUpload;
                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("IsMaster", true);
                formData.append("FolderName", "Elearning");

                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 15:
                uploadResponse = _context.sent;


                uploadedFile = {
                  contentType: file.contentType || "-",
                  downloadUrl: uploadResponse.data.fileUrl,
                  fileInfoId: uploadResponse.data.fileInfoId,
                  fileName: file.fileName,
                  gridFsId: uploadResponse.data.gridFsId,
                  sysName: "-"
                };
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](7);

                console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", _context.t0);

              case 22:

                __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                  method: "post",
                  url: "/Api/FileElearning",
                  data: {
                    folderElearningId: self.delFolderId,
                    fileName: uploadedFile.fileName,
                    fileDescription: null,
                    fileUpload: uploadedFile
                  }
                }).then(function (response) {
                  if (response.data.status) {
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      self.reloadDataTable(false);
                    });
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  // always executed
                  //Clear brows file
                  self.IsShowUploadBtn = false;
                  var $imageContainer = $("#container-file");
                  $imageContainer.empty();
                  KTApp.unblockPage();
                });

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6, [[7, 19]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, user, table;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this7;
              router = _this7.$router;
              _context2.next = 4;
              return _this7.$root.getUser();

            case 4:
              user = _context2.sent;
              table = $("#folderDetilsTable");

              self.initPlUploader();
              self.id = _this7.$route.params.id;

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              // begin first table
              table.DataTable({
                responsive: true,
                //processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Folder/" + self.id, // "/Api/Folder/Search",
                  type: "get",
                  //dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    //console.log(d);
                    // return JSON.stringify(
                    //   $.extend(d, {
                    //     SearchKeyword: self.melKeyword,
                    //     SearchInActiveStatus: self.melInActiveStatus
                    //   })
                    // );
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12'tr>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[2, "desc"]],
                columns: [{
                  data: "folderAndFileName",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, {
                  data: "folderAndFileName",
                  render: function render(data, type, full, meta) {
                    //If file
                    if (full.isItemFile) {

                      if (full.contentTypeGroup == "file-video") {
                        return '<div class="actionsName"></div>';
                        // return "<i class='fas fa-file-video'> " + data;
                      } else if (full.contentTypeGroup == "file-image") {
                        return '<div class="actionsName"></div>';
                        // "<i class='fas fa-file-image'></i> " + data;
                      } else if (full.contentTypeGroup == "file-pdf") {
                        return '<div class="actionsName"></div>';
                        // return "<i class='fas fa-file-pdf'></i> " + data;
                      } else if (full.contentTypeGroup == "file-excel") {
                        return '<div class="actionsName"></div>';
                        // return "<i class='fas fa-file-excel'></i> " + data;
                      } else if (full.contentTypeGroup == "file-word") {
                        return '<div class="actionsName"></div>';
                        // return "<i class='fas fa-file-word'></i> " + data;
                      } else if (full.contentTypeGroup == "file-power-point") {
                        return '<div class="actionsName"></div>';
                        // "<i class='fas fa-file-image'></i> " + data;
                      } else {
                        return data;
                      }
                    }
                    //If folder
                    else {
                        return '<a href="/5S/E-Learning/Detials/' + full.folderAndFileId + '" title="รายละเอียด"><i class="text-info far fa-folder-open">' + data + "</i></a>";
                        //return "<i class='fas fa-folder'></i> " + data;
                      }
                  }
                }, {
                  data: "folderAndFileId",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.createdDateFormat;
                  }
                }, {
                  data: "viewed",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.isItemFile) {
                      return data;
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "folderAndFileId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  KTApp.unblockPage();
                  self.delFolderName = settings.json.folderName;
                  self.delFolderId = settings.json.folderElearningId;
                  self.delCreateDate = settings.json.createdDateFormat;
                  self.delCreateBy = settings.json.createdBy;
                  self.delItems = settings.json.itemsCombine;
                  self.delStatus = !settings.json.inActiveStatus;
                  self.delParentFolderId = settings.json.parentFolderElearningId;
                  self.delFolderLevel = settings.json.folderLevel;
                  self.delParentLink = settings.json.parents;
                }
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showDownloadButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S", "AGENT_E-Learning"]) && data.isItemFile && data.contentTypeGroup != "file-video";
                    data.showPlayButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S", "AGENT_E-Learning"]) && data.isItemFile && data.contentTypeGroup == "file-video";
                    data.showEditFolderButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]) && !data.isItemFile;
                    data.showEditFileButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]) && data.isItemFile;
                    data.showDeletesFolderButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]) && !data.isItemFile;
                    data.showDeletesFileButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]) && data.isItemFile;
                    data.showDetailsButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S", "AGENT_E-Learning"]) && !data.isItemFile;
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actionsName").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new ActionUrlFile({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this7);
    }))();
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    var self = this;
    return {
      cfelFolderName: null

    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var self = this;

      if (!$("#createFolderELearningModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/Folder/AddFolder",
        data: {
          folderName: self.cfelFolderName,
          level: 1
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $("#createFolderELearningModal").modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error").then(function () {
          $("#createFolderELearningModal").modal("hide");
        });
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              //console.log(this.$route.params.id);

              if (router.currentRoute.params.id != undefined) {}
              //Call api get foldername


              // set validation rules
              $("#createFolderELearningModal form").validate({
                rules: {
                  cfelFolderName: "required"
                },
                messages: {
                  cfelFolderName: "กรุณาระบุโฟลเดอร์"
                }
              });

              $("#createFolderELearningModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              }).modal("show");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\"class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n    <a href=\"#\" onclick=\"return false;\" v-else class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/Folder/" + _this.data.folderElearningId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n    <a href=\"#\" onclick=\"return false;\" v-else class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/Folder/" + _this2.data.folderElearningId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" title=\"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"text-info la la-pencil\"></i>\n    </a>\n    <a :href=\"'/5S/E-Learning/Detials/' + data.folderElearningId\" @click.prevent=\"Details\" v-if=\"data.showOpenFolderButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"text-info far fa-folder-open\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"Delete\" v-if=\"data.showDeletesButton\" title=\"\u0E25\u0E1A\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"text-danger fas fa-trash-alt\"></i>\n    </a>\n  </div>",
  data: function data() {
    console.log(this);
    return {
      //Id: data.,
    };
  },
  methods: {
    edit: function edit() {
      var _this3 = this;

      var self = this;
      // router.push({
      //   path: `/5S/E-Learning/RenameFolder/${this.data.folderElearningId}`
      // });
      Swal.fire({
        title: "คำสั่งเปลี่ยนชื่อหมวดหมู่",
        type: "info",
        html: "กรุณาระบุชื่อหมวดหมู่ <strong>",
        input: "text",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(value) {
          if (value) {
            return value;
          } else {
            Swal.showValidationMessage("กรุณาระบุชื่อหมวดหมู่");
          }
        }
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/Folder", {
            FolderElearningId: _this3.data.folderElearningId,
            FolderName: result.value
          }).then(function (response) {
            console.log(response.data.status);
            if (response.data.status == true) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    Delete: function Delete() {
      var _this4 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลหมวดหมู่",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลหมวดหมู่ <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลหมวดหมู่ไม่ถูกใช้งาน",
        inputPlaceholder: "ต้องการลบข้อมูลหมวดหมู่",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/Folder/" + _this4.data.folderElearningId + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    Details: function Details() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/5S/E-Learning/Detials/" + this.data.folderElearningId
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      melKeyword: null,
      melInActiveStatus: null,
      //config
      melInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.melKeyword = "";
      //default Active Data
      this.melInActiveStatus = false;
      $("#melInActiveStatus").val(this.melInActiveStatus + "").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#folderTable").DataTable();
      table.search(this.id | this.name);
      //table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#folderTable").DataTable().ajax.reload(null, resetPaging);
    },
    CheckRoute: function CheckRoute() {
      var url = this.$route.path;
      if (url == "/5S/E-Learning/Detials/" + this.$root.$route.params.id) return false;else if (url == "/5S/E-Learning/Detials/" + this.$root.$route.params.id + "/AddSubFolder") return false;
      // else if(url == '/Borrow/Approve/'+this.$root.$route.params.id) return false;
      // else if(url == '/Borrow/OpenJopReturn/'+this.$root.$route.params.id) return false;
      // else if(url == '/Borrow/Add') return false;
      else return true;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this5;

              //default Active Data

              self.melInActiveStatus = false;
              $("#melInActiveStatus").val(self.melInActiveStatus + "").trigger("change");

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#folderTable");

              // begin first table

              if (!_this5.$root.canShow(["COMPANY_PROFILE_TYPE_AGENT"])) {
                table.DataTable({
                  responsive: true,
                  processing: true,
                  serverSide: true,
                  searchDelay: 500,
                  ajax: {
                    url: "/Api/Folder/Search",
                    type: "post",
                    dataType: "json",
                    contentType: "application/json",
                    beforeSend: function beforeSend(request) {
                      request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                    },
                    data: function data(d) {
                      //console.log(d);
                      return JSON.stringify($.extend(d, {
                        SearchKeyword: self.melKeyword,
                        SearchInActiveStatus: self.melInActiveStatus
                      }));
                    }
                  },
                  // DOM Layout settings
                  dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n          <'row'<'col-sm-12'tr>>\n          <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                  lengthMenu: [30, 50, 100],

                  pageLength: 30,

                  language: {
                    lengthMenu: "Display _MENU_"
                  },

                  // Order settings
                  order: [[2, "desc"]],
                  columns: [{
                    data: "folderName",
                    render: function render(data, type, full, meta) {
                      return '<a href="/5S/E-Learning/Detials/' + full.folderElearningId + '" title="รายละเอียด">' + data + "</i></a>";
                    }
                  }, { data: "createdBy", className: "text-center" }, {
                    data: "createdDate",
                    className: "text-center",
                    render: function render(data, type, full, meta) {
                      return full.createdDateFormat;
                    }
                  }, {
                    data: "folderElearningId",
                    className: "text-center",
                    orderable: false,
                    render: function render(data, type, full, meta) {
                      return '<div class="actions"></div>';
                    }
                  }]
                }).on("error.dt", function (e, settings, techNote, message) {
                  __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
                }).on("draw.dt", function () {
                  $(".actionsStatus").each(function (i, el) {
                    var $dt = table.DataTable();
                    var $tr = $(el).parents("tr").first();
                    var data = $dt.row($tr).data();
                    if (data) {
                      data.showEditStatusButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]);
                      data.showUnEditStatusButton = self.$root.canShow(["AGENT_E-Learning"]);
                      if (data.inActiveStatus == 0) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                    }
                  });
                  $(".actions").each(function (i, el) {
                    var $dt = table.DataTable();
                    var $tr = $(el).parents("tr").first();
                    var data = $dt.row($tr).data();
                    if (data) {
                      data.showEditButton = self.$root.canShow(["ADMIN_5S"]);
                      data.showOpenFolderButton = self.$root.canShow(["ADMIN_5S", "AGENT_E-Learning", "ADVISOR_5S", "TEAM_5S"]);
                      data.showDeletesButton = self.$root.canShow(["ADMIN_5S"]);
                      new Action({ data: { data: data }, parent: self }).$mount(el);
                    }
                  });
                });
              } else {
                table.DataTable({
                  responsive: true,
                  processing: true,
                  serverSide: true,
                  searchDelay: 500,
                  ajax: {
                    url: "/Api/Folder/Search",
                    type: "post",
                    dataType: "json",
                    contentType: "application/json",
                    beforeSend: function beforeSend(request) {
                      request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                    },
                    data: function data(d) {
                      //console.log(d);
                      return JSON.stringify($.extend(d, {
                        SearchKeyword: self.melKeyword,
                        SearchInActiveStatus: self.melInActiveStatus
                      }));
                    }
                  },
                  // DOM Layout settings
                  dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n          <'row'<'col-sm-12'tr>>\n          <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                  lengthMenu: [30, 50, 100],

                  pageLength: 30,

                  language: {
                    lengthMenu: "Display _MENU_"
                  },

                  // Order settings
                  order: [[2, "desc"]],
                  columns: [{
                    data: "folderName",
                    render: function render(data, type, full, meta) {
                      return '<a href="/5S/E-Learning/Detials/' + full.folderElearningId + '" title="รายละเอียด">' + data + "</i></a>";
                    }
                  }, { data: "createdBy", className: "text-center" }, {
                    data: "createdDate",
                    className: "text-center",
                    render: function render(data, type, full, meta) {
                      return full.createdDateFormat;
                    }
                  }, {
                    data: "inActiveStatus",
                    className: "text-center",
                    width: "10%",
                    orderable: false,
                    render: function render(data, type, full, meta) {
                      return '<div class="actionsStatus"></div>';
                    }
                  }, {
                    data: "folderElearningId",
                    className: "text-center",
                    orderable: false,
                    render: function render(data, type, full, meta) {
                      return '<div class="actions"></div>';
                    }
                  }]
                }).on("error.dt", function (e, settings, techNote, message) {
                  __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
                }).on("draw.dt", function () {
                  $(".actionsStatus").each(function (i, el) {
                    var $dt = table.DataTable();
                    var $tr = $(el).parents("tr").first();
                    var data = $dt.row($tr).data();
                    if (data) {
                      data.showEditStatusButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]);
                      data.showUnEditStatusButton = self.$root.canShow(["AGENT_E-Learning"]);
                      if (data.inActiveStatus == 0) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                    }
                  });
                  $(".actions").each(function (i, el) {
                    var $dt = table.DataTable();
                    var $tr = $(el).parents("tr").first();
                    var data = $dt.row($tr).data();
                    if (data) {
                      data.showEditButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]);
                      data.showOpenFolderButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S", "AGENT_E-Learning"]);
                      data.showDeletesButton = self.$root.canShow(["ADMIN_5S", "MANAGER_5S"]);
                      new Action({ data: { data: data }, parent: self }).$mount(el);
                    }
                  });
                });
              }
              //table.trigger("draw.dt"); //call ajax delete this row

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this5);
    }))();
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      delFolderName: null,
      delFolderId: null,
      delCreateDate: null,
      delCreateBy: null,
      delStatus: false,
      delItems: []
    };
  },

  methods: {
    FolderClick: function FolderClick(id) {
      var router = this.$router;
      // router.push({
      //   path: `/5S/E-Learning/Detials/${id}`
      // });
      this.$router.go("/5S/E-Learning/Detials/" + id);
    },
    AddSub: function AddSub() {
      var router = this.$router;
      var self = this;
      router.push({
        path: "/5S/E-Learning/Detials/" + self.delFolderId + "/AddSubFolder"
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Folder/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  console.log(response.data);
                  //console.log(response.data);
                  if (response.data != null) {

                    self.delFolderName = response.data.folderName;
                    self.delFolderId = response.data.folderElearningId;
                    self.delCreateDate = response.data.createdDateFormat;
                    self.delCreateBy = response.data.createdBy;
                    self.delItems = response.data.itemsCombine;
                    self.delStatus = !response.data.inActiveStatus;
                    // // self.ordDownloadUrl =
                    // //   "/Api/DownloadFile/Byte?" + response.data[0].downloadUrl;
                    // if (response.data[0].downloadUrl) {
                    //   self.ordDownloadUrl =
                    //     "/Api/DownloadFile/Byte?" + response.data[0].downloadUrl;
                    // }
                    // self.ordStocks = response.data;
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสินค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {
      reAaIsInitial: true,
      reAaDateReq: null,
      reAPMAgentCode: [],
      reAPMRegion: [],
      reAPMDateStart: null,
      reAPMDateEnd: null,
      reAPMCreatedUserId: [],
      reAPMBarcodeNo: null,
      reAaProductBrand: [],
      reAPMStatus: null,
      reAPMAlertCount: [],
      reAPMAlertCycle: [],
      reAPMBrand: [],
      reAPMShopId: [],
      reAPMShopIdOptions: [],
      reAPMType: [],

      pmrSubAgentCodes: [],
      pmrSubAgentCodeOptions: [],

      shmShopPMType: [],
      shmShopPMTypeOptions: [],

      LoadshmShopPMTypeOptions: function LoadshmShopPMTypeOptions(e) {
        var self = this;
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Select2MasterShopTypePM", {
          params: {
            page: 1,
            all: true
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.shmShopPMTypeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
        }).catch(function (error) {});
      }

    }, _defineProperty(_ref, "pmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.reAPMAgentCode,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reAPMCreatedUserIdOptions", []), _defineProperty(_ref, "reAPMBarcodeOptions", []), _defineProperty(_ref, "reAPMAgentCodeOptions", []), _defineProperty(_ref, "reAPMRegionOptions", []), _defineProperty(_ref, "rePM3Options", {
      placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2Agent",
        type: "post",
        delay: 300,
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            province_id: [],
            department: [],
            AgentCodes: []
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      },
      templateResult: function templateResult(data) {
        return data.text;
      },
      language: {
        noResults: function noResults() {
          return "ไม่พบข้อมูลร้านค้า";
        }
      }
    }), _defineProperty(_ref, "reAPMStatusOptions", {
      minimumResultsForSearch: -1,
      placeholder: "ทั้งหมด",
      allowClear: true,
      data: [{
        id: false,
        text: "ร้านเปิด",
        data: null
      }, {
        id: true,
        text: "ร้านปิด",
        data: null
      }]
    }), _defineProperty(_ref, "reAPMAlertCountOptions", [
      // {
      //   id: 7,
      //   label: "7",
      // },
      // {
      //   id: 15,
      //   label: "15",
      // },
    ]), _defineProperty(_ref, "reAPMTypeOptions", [{
      id: "บริษัท",
      label: "บริษัท"
    }, {
      id: "เครื่องเช่า",
      label: "เครื่องเช่า"
    }, {
      id: "ส่วนบุคคล",
      label: "ส่วนบุคคล"
    }]), _defineProperty(_ref, "reAPMAlertCycleOptions", [{
      id: 1,
      label: "1"
    }, {
      id: 2,
      label: "2"
    }, {
      id: 3,
      label: "3"
    }, {
      id: 4,
      label: "4"
    }, {
      id: 5,
      label: "5"
    }, {
      id: 6,
      label: "มากกว่า 5"
    }]), _defineProperty(_ref, "reAPMBrandOptions", []), _defineProperty(_ref, "rePMShopTypeId", []), _defineProperty(_ref, "rePMShopTypeIdOptions", []), _defineProperty(_ref, "rePMMachineProductCode", []), _defineProperty(_ref, "rePMMachineProductCodeOptions", []), _defineProperty(_ref, "rePMProvinceId", null), _defineProperty(_ref, "rePMAmpherId", null), _defineProperty(_ref, "rePMProvinceIdOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/MasterLocation/Select2SearchProvince",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "rePMAmpherIdOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/MasterLocation/Select2SearchAmpher",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            provinceId: self.rePMProvinceId,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  computed: {},
  methods: {
    showDate: function showDate(date) {
      this.date = date;
    },

    formReset: function formReset(e) {
      var self = this;
      self.reAPMAgentCode = [];
      self.reAPMRegion = [];
      self.reAPMDateStart = null, self.reAPMDateEnd = null, self.reAPMAlertCount = [];
      self.reAPMal = [];
      self.reAPMCreatedUserId = [];
      self.reAPMBarcodeNo = null;
      self.rePMMachineProductCode = [];
      self.reAPMStatus = null;
      self.reAPMBrand = [];
      self.NFCCode = [];
      self.reAPMAlertCycle = [];
      self.reAPMShopId = [];
      self.reAPMType = [];
      self.rePMShopTypeId = [];
      self.rePMProvinceId = null;
      self.rePMAmpherId = null;

      self.pmrSubAgentCodes = [];
      self.pmrSubAgentCodeOptions = [];

      $("#pmrSubAgentCodes").val("").trigger("change");

      $("#reAPMAgentCode").val("").trigger("change");

      $("#reAPMRegion").val("").trigger("change");

      $("#reAPMAlertCount").val("").trigger("change");

      $("#reAPMAlertCycle").val("").trigger("change");

      $("#reAPMCreatedUserId").val("").trigger("change");

      $("#reAPMShopId").val("").trigger("change");

      $("#reAPMStatus").val("").trigger("change");

      $("#reAPMStatus").val("").trigger("change");

      $("#reAPMBrand").val("").trigger("change");

      $("#rePMProvinceId").val("").trigger("change");

      $("#rePMAmpherId").val("").trigger("change");

      $("#reAPMDateStart").val("").trigger("change");

      $("#reAPMDateEnd").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    exportAlertPM: function exportAlertPM(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportAlertPM",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reAPMAgentCode,
          SubAgentCode: self.pmrSubAgentCodes,
          Department: self.reAPMRegion,
          MonthStart: self.reAPMDateStart != null ? self.reAPMDateStart.format("MM/YYYY") : null,
          MonthEnd: self.reAPMDateEnd != null ? self.reAPMDateEnd.format("MM/YYYY") : null,
          AlertCount: self.reAPMAlertCount,
          AlertCycle: self.reAPMAlertCycle,
          CreatedUserId: self.reAPMCreatedUserId,
          ShopId: self.reAPMShopId,
          BarcodeNo: self.reAPMBarcodeNo ? self.reAPMBarcodeNo.split(",").map(function (s) {
            return s.trim();
          }) : [],
          InActiveStatus: self.reAPMStatus,
          ProductBrandId: self.reAPMBrand,
          Type: self.reAPMType,
          IsInitial: self.reAaIsInitial,
          ShopTypeId: self.rePMShopTypeId,
          ProvinceId: self.rePMProvinceId,
          AmpherId: self.rePMAmpherId,
          MachineProductCode: self.rePMMachineProductCode,
          PMType: self.shmShopPMType
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#alertPMTable").DataTable();
      table.draw();
    },
    LoadreAPMShopIdOptions: function LoadreAPMShopIdOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.reAPMShopIdOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/AlertPM/ShopOptions", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reAPMShopIdOptions = [];
            data.forEach(function (element) {
              self.reAPMShopIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reAPMShopIdOptions);
        }).catch(function (error) {});
      }
    },
    LoadreAPMCreatedUserIdOptions: function LoadreAPMCreatedUserIdOptions(_ref3) {
      var action = _ref3.action,
          searchQuery = _ref3.searchQuery,
          callback = _ref3.callback;

      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        var self = this;
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/AlertPM/UserOptions", {
          params: {
            page: 1,
            all: true
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            var result = [];
            data.forEach(function (element) {
              result.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, result);
        }).catch(function (error) {});
      }
    },

    reLoadreAPMCreatedUserIdOptions: function reLoadreAPMCreatedUserIdOptions() {
      this.$refs.reAPMCreatedUserId.trigger.searchQuery = null;
    },
    // LoadreAPMBarcodeOptions({ action, searchQuery, callback }) {
    //   var self = this;
    //   self.reAPMBarcodeOptions = [];
    //   if (action === ASYNC_SEARCH) {
    //     axios
    //       .get("/Api/Report/AlertPM/Select2Barcode", {
    //         params: {
    //           page: 1,
    //           all: true,
    //           search: searchQuery,
    //         },
    //       })
    //       .then(function(response) {
    //         if (response.status == 200) {
    //           var data = response.data.results;
    //           self.reAPMBarcodeOptions = [];
    //           data.forEach((element) => {
    //             self.reAPMBarcodeOptions.push({
    //               id: element.id,
    //               label: element.text,
    //             });
    //           });
    //         }
    //         callback(null, self.reAPMBarcodeOptions);
    //       })
    //       .catch(function(error) {});
    //   }
    // },
    LoadreAPMAgentCodeOptions: function LoadreAPMAgentCodeOptions(e) {
      var self = this;
      self.reAPMAgentCodeOptions = [{ id: "", label: "Loading...", isDisabled: true }]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: self.reAPMRegion,
        AgentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          self.reAPMAgentCodeOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAPMAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAPMRegionOptions: function LoadreAPMRegionOptions(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.reAPMRegionOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAPMRegionOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAPMBrandOptions: function LoadreAPMBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2ProductBrand", {
        params: {
          page: 1,
          productTypeId: 6,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAPMBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAPMAlertCountOptions: function LoadreAPMAlertCountOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/AlertPM/AlertCountOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAPMAlertCountOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    // ปิดไว้จากเคส https://bt.sbpds.co.th/view.php?id=3084 พี่นัท PM บอกว่า สร้างเป็นแบ static เลยดีกว่า
    // LoadreAPMAlertCycleOptions: function(e) {
    //   var self = this;
    //   axios
    //     .get("/Api/Report/AlertPM/AlertCycleOptions", {
    //       params: {
    //         page: 1,
    //         all: true,
    //       },
    //     })
    //     .then(function(response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         data.forEach((element) => {
    //           self.reAPMAlertCycleOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function(error) {});
    // },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    LoadShopTypeIdOptions: function LoadShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMMachineProductCodeOptions: function LoadrePMMachineProductCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          productTypeId: 3,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMMachineProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    onAmpherIdChange: function onAmpherIdChange() {
      $("#rePMAmpherId").val("").trigger("change");
    },
    AgentClearAfterselect: function AgentClearAfterselect() {
      var self = this;
      self.pmrSubAgentCodes = [];

      $("#pmrSubAgentCodes").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              // self.LoadreAPMCreatedUserIdOptions();

              self.LoadreAPMAgentCodeOptions();
              self.LoadreAPMRegionOptions();
              self.LoadreAPMBrandOptions();
              self.LoadreAPMAlertCountOptions();
              // self.LoadreAPMAlertCycleOptions();
              self.LoadShopTypeIdOptions();
              self.LoadrePMMachineProductCodeOptions();
              self.LoadshmShopPMTypeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
              $("#reAPMStatus").val(false + "").trigger("change");

              $(self.$refs.reAPMDateStart).datepicker({
                format: "mm/yyyy",
                viewMode: "months",
                minViewMode: "months",
                autoclose: true,
                clearBtn: true,
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.reAPMDateStart).datepicker("update", !!self.reAPMDateStart ? self.reAPMDateStart.format("MM/YYYY") : null).on("changeDate", function (e) {
                self.reAPMDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reAPMDateEnd).datepicker({
                format: "mm/yyyy",
                viewMode: "months",
                minViewMode: "months",
                autoclose: true,
                clearBtn: true,
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.reAPMDateEnd).datepicker("update", !!self.reAPMDateEnd ? self.reAPMDateEnd.format("MM/YYYY") : null).on("changeDate", function (e) {
                self.reAPMDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#alertPMTable");

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/AlertPM",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      AgentCode: self.reAPMAgentCode,
                      SubAgentCode: self.pmrSubAgentCodes,
                      Department: self.reAPMRegion,
                      MonthStart: self.reAPMDateStart != null ? self.reAPMDateStart.format("MM/YYYY") : null,
                      MonthEnd: self.reAPMDateEnd != null ? self.reAPMDateEnd.format("MM/YYYY") : null,
                      AlertCount: self.reAPMAlertCount,
                      AlertCycle: self.reAPMAlertCycle,
                      CreatedUserId: self.reAPMCreatedUserId,
                      ShopId: self.reAPMShopId,
                      BarcodeNo: self.reAPMBarcodeNo ? self.reAPMBarcodeNo.split(",").map(function (s) {
                        return s.trim();
                      }) : [],
                      InActiveStatus: self.reAPMStatus,
                      ProductBrandId: self.reAPMBrand,
                      Type: self.reAPMType,
                      IsInitial: self.reAaIsInitial,
                      ShopTypeId: self.rePMShopTypeId,
                      ProvinceId: self.rePMProvinceId,
                      AmpherId: self.rePMAmpherId,
                      MachineProductCode: self.rePMMachineProductCode,
                      PMType: self.shmShopPMType
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[13, "desc"]],
                columns: [{ data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "agentTypeName", className: "text-center" }, { data: "department", className: "text-center" }, { data: "createdUser", className: "text-center" }, { data: "shopCode", className: "text-center" }, { data: "name1", className: "text-center" }, { data: "name2", className: "text-center" }, { data: "shopPMTypeName", className: "text-center" }, { data: "type", className: "text-center" },
                //{ data: "barcodeNo", className: "text-center" },
                { data: "barcodeNoOld", className: "text-center" }, { data: "machineProductName", className: "text-center" }, { data: "productBrandName", className: "text-center" }, {
                  data: "lastDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.lastDateString;
                  }
                }, {
                  data: "alertDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.alertDateString;
                  }
                }, { data: "alertConfigDay", className: "text-center" }, { data: "round", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reAaIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {
      reAaIsInitial: true,
      reAaDateReq: null,
      reJIDepartments: [],
      reJIAgentCodes: [],
      reMachineType: [],
      reBarbutlerType: [],
      reBarcodeMachine: null,
      reBarcodeBarbutler: null,
      reJIStatus: [],
      reJICloseUser: [],
      reJICreatedUser: [],
      reJIDateStart: null
    }, _defineProperty(_ref, "reJIDateStart", null), _defineProperty(_ref, "reJICreatedUserOptions", []), _defineProperty(_ref, "reJICloseUserOptions", []), _defineProperty(_ref, "reJIDepartmentsOptions", []), _defineProperty(_ref, "reJIAgentCodesOptions", []), _defineProperty(_ref, "reShopTypeIdOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/ShopType/Select2SearchShopType",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reJIStatusOptions", []), _defineProperty(_ref, "reProductBrandIdOptions", {
      placeholder: "ทั้งหมด",
      allowClear: true,
      data: [{ id: "Singha", text: "Singha", data: null }, { id: "Leo", text: "Leo", data: null }, { id: "Carlsberg", text: "Carlsberg", data: null }, { id: "Asahi", text: "Asahi", data: null }, { id: "Kronenbourg", text: "Kronenbourg", data: null }, { id: "Snowy", text: "Snowy", data: null }]
    }), _defineProperty(_ref, "reProvinceIdOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/MasterLocation/Select2SearchProvince",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reAmpherIdOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/MasterLocation/Select2SearchAmpher",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            provinceId: self.reProvinceId,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reMachineTypeOptions", {
      minimumResultsForSearch: -1,
      placeholder: "กรุณาเลือกเขตการขาย",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2MachineType",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reBarbutlerTypeOptions", {
      minimumResultsForSearch: -1,
      placeholder: "กรุณาเลือกเขตการขาย",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2BarButlerType",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reJIDepartments = [];
      self.reJIAgentCodes = [];
      self.reJIStatus = [];
      self.reJIDateStart = null;
      self.reJIDateEnd = null;
      self.reJICreatedUser = [];
      self.reJICloseUser = [];

      $("#reJIDepartments").val("").trigger("change");

      $("#reJIAgentCodes").val("").trigger("change");

      $("#reJIStatus").val("").trigger("change");

      $("#reJICreatedUser").val("").trigger("change");

      $("#reJICloseUser").val("").trigger("change");

      $("#reJIDateStart").val("").trigger("change");

      $("#reJIDateEnd").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#JobIssueTable").DataTable();
      table.draw();
    },
    exportMasterShop: function exportMasterShop(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportJobIssue",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reJIAgentCodes,
          Region: self.reJIDepartments,
          JobStatusCode: self.reJIStatus,
          CreateDateStart: self.reJIDateStart != null ? self.reJIDateStart.format("DD/MM/YYYY") : null,
          CreateDateEnd: self.reJIDateEnd != null ? self.reJIDateEnd.format("DD/MM/YYYY") : null,
          UserCreate: self.reJICreatedUser,
          UserClose: self.reJICloseUser
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreJICreatedUserOptions: function LoadreJICreatedUserOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/JobIssue/CreatedUserOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reJICreatedUserOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreJICloseUserOptions: function LoadreJICloseUserOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/JobIssue/CloseUserOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reJICloseUserOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreJIDepartmentsOptions: function LoadreJIDepartmentsOptions(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.reJIDepartmentsOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reJIDepartmentsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreJIAgentCodesOptions: function LoadreJIAgentCodesOptions(e) {
      var self = this;
      self.reJIAgentCodesOptions = [{ id: "", label: "Loading...", isDisabled: true }]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: self.reJIDepartments,
        AgentCodes: [],
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          self.reJIAgentCodesOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.reJIAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreJIStatusOptions: function LoadreJIStatusOptions(e) {
      var self = this;
      var data = [{ id: "JOB_STATUS_WAITING", label: "รอดำเนินการ" }, { id: "JOB_STATUS_SUCCESS", label: "ดำเนินการเรียบร้อย" }, { id: "JOB_STATUS_PENDING", label: "ระหว่างดำเนินการ" }, { id: "JOB_STATUS_CANCEL", label: "ยกเลิก" }];
      data.forEach(function (element) {
        self.reJIStatusOptions.push({
          id: element.id,
          label: element.label
        });
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreJICreatedUserOptions();
              self.LoadreJICloseUserOptions();
              self.LoadreJIDepartmentsOptions();
              self.LoadreJIAgentCodesOptions();
              self.LoadreJIStatusOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reJIDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reJIDateStart = moment().set("date",1);
              $(self.$refs.reJIDateStart).datepicker("update", !!self.reJIDateStart ? self.reJIDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                //self.reJIDateStart = moment(e.date);
                self.reJIDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reJIDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reJIDateEnd = moment().endOf('month');
              $(self.$refs.reJIDateEnd).datepicker("update", !!self.reJIDateEnd ? self.reJIDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                //self.reJIDateEnd = moment(e.date);
                self.reJIDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#JobIssueTable");

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/JobIssue",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      AgentCode: self.reJIAgentCodes,
                      Region: self.reJIDepartments,
                      JobStatusCode: self.reJIStatus,
                      CreateDateStart: self.reJIDateStart != null ? self.reJIDateStart.format("DD/MM/YYYY") : null,
                      CreateDateEnd: self.reJIDateEnd != null ? self.reJIDateEnd.format("DD/MM/YYYY") : null,
                      UserCreate: self.reJICreatedUser,
                      UserClose: self.reJICloseUser,
                      IsInitial: self.reAaIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[0, "desc"]],
                columns: [
                // { data: "createdDateString", className: "text-center" },
                {
                  data: "createdDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.createdDateString;
                  }
                }, { data: "jobNumber", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "region", className: "text-center" }, { data: "shopCode", className: "text-center" }, { data: "customeR_NAME", className: "text-center" }, { data: "namE2", className: "text-center" }, { data: "detail", className: "text-center" }, { data: "jobStatusName", className: "text-center" }, { data: "createdUser", className: "text-center" }, { data: "closedUserName", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reAaIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      reDepartments: [],
      reAgentCodes: [],
      reShopTypeId: [],
      reMonth: null,
      reYear: null,
      reShopStatus: null,
      reProductBrandId: null,
      reProvinceId: null,
      reAmpherId: null,
      brandHeaders: [],
      reDepartmentsOptions: [],
      reIsTransaction: true,
      reStartDate: null,
      reEndDate: null,
      // reDepartmentsOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAgentCodesOptions: [],
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url:
      //       "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      reShopTypeIdOptions: [],
      // reShopTypeIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ShopType/Select2SearchShopType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reMonthOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "1", text: "January", data: null }, { id: "2", text: "February", data: null }, { id: "3", text: "March", data: null }, { id: "4", text: "April", data: null }, { id: "5", text: "May", data: null }, { id: "6", text: "June", data: null }, { id: "7", text: "July", data: null }, { id: "8", text: "August", data: null }, { id: "9", text: "September", data: null }, { id: "10", text: "October", data: null }, { id: "11", text: "November", data: null }, { id: "12", text: "December", data: null }]
      },
      reYearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }, {
          id: new Date().getFullYear() - 2,
          text: new Date().getFullYear() - 2,
          data: null
        }, {
          id: new Date().getFullYear() - 3,
          text: new Date().getFullYear() - 3,
          data: null
        }, {
          id: new Date().getFullYear() - 4,
          text: new Date().getFullYear() - 4,
          data: null
        }]
      },
      reShopStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ร้านเปิด", data: null }, { id: "true", text: "ร้านปิด", data: null }]
      },
      reProductBrandIdOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "Singha", text: "Singha", data: null }, { id: "Leo", text: "Leo", data: null }, { id: "Asahi", text: "Asahi", data: null }, { id: "Carlsberg", text: "Carlsberg", data: null }, { id: "Kopper", text: "Kopper", data: null }, { id: "Kronenbourg", text: "Kronenbourg", data: null }, { id: "Snowy", text: "Snowy", data: null }, { id: "ANDAMAN", text: "ANDAMAN", data: null }, { id: "BUSSABA", text: "BUSSABA", data: null }, { id: "DH", text: "D&H-Est.33", data: null }, { id: "SinghaLight", text: "Singha Light", data: null }, { id: "UKorn", text: "U Korn Beer", data: null }, { id: "CHALAWAN", text: "CHALAWAN PALE ALE", data: null }, { id: "CHATRI", text: "CHATRI IPA", data: null }, { id: "HOF", text: "HOF", data: null }, { id: "Other", text: "Other", data: null }]
      },
      reProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              provinceId: self.reProvinceId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reDepartments = [];
      self.reAgentCodes = [];
      self.reShopTypeId = [];
      self.reMonth = null, self.reYear = null;
      self.reShopStatus = null;
      self.reProductBrandId = null;
      self.reAmpherId = null;
      self.reProvinceId = null;
      self.reIsTransaction = true;
      self.reStartDate = null;
      self.reEndDate = null;

      $("#reDepartments").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#reMonth").val("").trigger("change");

      $("#reYear").val("").trigger("change");

      $("#reShopStatus").val(false + "").trigger("change");

      $("#reProductBrandId").val("").trigger("change");

      $("#reProvinceId").val("").trigger("change");

      $("#reAmpherId").val("").trigger("change");

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#MasterShopTable").DataTable();
      table.draw();
    },
    exportMasterShop: function exportMasterShop(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportMasterShopByBrand",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reAgentCodes,
          Department: self.reDepartments,
          ProductBrand: self.reProductBrandId,
          ShopType: self.reShopTypeId,
          Month: self.reMonth,
          Year: self.reYear,
          InActiveStatus: self.reShopStatus,
          ProvinceId: self.reProvinceId,
          AmperId: self.reAmpherId,
          IsTransaction: !self.reIsTransaction,
          StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
          EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      self.reAgentCodesOptions = [{ id: "", label: "Loading...", isDisabled: true }]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: self.reDepartments,
        AgentCodes: [],
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          self.reAgentCodesOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreDepartmentsOptions: function LoadreDepartmentsOptions(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.reDepartmentsOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reDepartmentsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreShopTypeIdOptions: function LoadreShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreAgentCodesOptions();
              self.LoadreDepartmentsOptions();
              self.LoadreShopTypeIdOptions();

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
              $("#reShopStatus").val(false + "").trigger("change");

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#MasterShopTable");

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,

                ajax: {
                  url: "/Api/Report/MasterShopByBrand",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      AgentCode: self.reAgentCodes,
                      Department: self.reDepartments,
                      ProductBrand: self.reProductBrandId,
                      ShopType: self.reShopTypeId,
                      Month: self.reMonth,
                      Year: self.reYear,
                      InActiveStatus: self.reShopStatus,
                      ProvinceId: self.reProvinceId,
                      AmperId: self.reAmpherId,
                      IsInitial: self.reAaIsInitial,
                      IsTransaction: !self.reIsTransaction,
                      StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                      EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[12, "desc"]],
                columns: [{ data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "department", className: "text-center" }, { data: "name1", className: "text-center" }, { data: "name2", className: "text-center" }, { data: "channel", className: "text-center" }, { data: "address", className: "text-center" }, { data: "tambon", className: "text-center" }, { data: "amper", className: "text-center" }, { data: "province", className: "text-center" }, { data: "zipCode", className: "text-center" }, { data: "module", className: "text-center" }, {
                  data: "createdDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.createdDateString;
                  }
                }, { data: "day", className: "text-center" }, { data: "month", className: "text-center" }, { data: "year", className: "text-center" }, { data: "singha", className: "text-center" }, { data: "leo", className: "text-center" }, { data: "asahi", className: "text-center" }, { data: "carlsberg", className: "text-center" }, { data: "kopper", className: "text-center" }, { data: "kronenbourg", className: "text-center" }, { data: "snowy", className: "text-center" }, { data: "andaman", className: "text-center" }, { data: "bussaba", className: "text-center" }, { data: "dh", className: "text-center" }, { data: "singhaLight", className: "text-center" }, { data: "ukorn", className: "text-center" }, { data: "chalawan", className: "text-center" }, { data: "chatri", className: "text-center" }, { data: "hof", className: "text-center" }, { data: "other", className: "text-center" }],
                columnDefs: [{
                  targets: [7, 8, 9, 10, 13, 14, 15] /* column index */
                  , orderable: false /* true or false */
                }],
                drawCallback: function drawCallback(settings) {
                  self.reAaIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      reDepartments: [],
      reAgentCodes: [],
      reShopTypeId: [],
      reType: null,
      reMonth: null,
      reYear: null,
      reShopStatus: 'ACTIVE',
      reProductBrandId: null,
      reUserIds: [],
      reUserIdsOptions: [],
      reUserStatus: null,
      brandHeaders: [],
      reDepartmentsOptions: [],
      // reDepartmentsOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAgentCodesOptions: [],
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url:
      //       "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      reMonthOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "1", text: "January", data: null }, { id: "2", text: "February", data: null }, { id: "3", text: "March", data: null }, { id: "4", text: "April", data: null }, { id: "5", text: "May", data: null }, { id: "5", text: "June", data: null }, { id: "7", text: "July", data: null }, { id: "8", text: "August", data: null }, { id: "9", text: "September", data: null }, { id: "10", text: "October", data: null }, { id: "11", text: "November", data: null }, { id: "12", text: "December", data: null }]
      },
      reYearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() + 1,
          text: new Date().getFullYear() + 1,
          data: null
        }, {
          id: new Date().getFullYear() + 2,
          text: new Date().getFullYear() + 2,
          data: null
        }, {
          id: new Date().getFullYear() + 3,
          text: new Date().getFullYear() + 3,
          data: null
        }, {
          id: new Date().getFullYear() + 4,
          text: new Date().getFullYear() + 4,
          data: null
        }]
      },
      reShopStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "ACTIVE", text: "ร้านเปิด", data: null }, { id: "INACTIVE", text: "ร้านปิด", data: null }]
      },
      reUserStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      },
      reProductBrandIdOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกแบรนด์สินค้า",
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reTypeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "PM", text: "PM", data: null }, { id: "QI", text: "QC", data: null }, { id: "MKT", text: "MKT", data: null }, { id: "MT", text: "MT", data: null }]
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reDepartments = [];
      self.reAgentCodes = [];
      self.reType = null;
      self.reMonth = null, self.reYear = null;
      self.reShopStatus = 'ACTIVE';
      self.reProductBrandId = null;
      self.reUserIds = [];
      self.reUserStatus = null;

      $("#reDepartments").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#reMonth").val("").trigger("change");

      $("#reYear").val("").trigger("change");

      $("#reShopStatus").val(self.reShopStatus).trigger("change");

      $("#reProductBrandId").val("").trigger("change");

      $("#reType").val("").trigger("change");

      $("#reUserIds").val("").trigger("change");

      $("#reUserStatus").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#SurveyTable").DataTable();
      table.draw();
    },
    exportMasterShop: function exportMasterShop(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportSurvey",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reAgentCodes,
          Department: self.reDepartments,
          ProductBrandId: self.reProductBrandId,
          Month: self.reMonth,
          Year: self.reYear,
          Status: self.reShopStatus,
          TypeModule: self.reType,
          UserIds: self.reUserIds,
          UserStatus: self.reUserStatus
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreDepartmentsOptions: function LoadreDepartmentsOptions(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.reDepartmentsOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reDepartmentsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      self.reAgentCodesOptions = [{ id: "", label: "Loading...", isDisabled: true }]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: self.reDepartments,
        AgentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          self.reAgentCodesOptions = []; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadUserIdsOptions: function LoadUserIdsOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Survey/UserOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reUserIdsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreDepartmentsOptions();
              self.LoadreAgentCodesOptions();
              self.LoadUserIdsOptions();
              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#SurveyTable");

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/Survey",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      AgentCode: self.reAgentCodes,
                      Department: self.reDepartments,
                      ProductBrandId: self.reProductBrandId,
                      Month: self.reMonth,
                      Year: self.reYear,
                      Status: self.reShopStatus,
                      TypeModule: self.reType,
                      IsInitial: self.reAaIsInitial,
                      UserIds: self.reUserIds,
                      UserStatus: self.reUserStatus
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[11, "desc"]],
                columns: [{ data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "department", className: "text-center" }, { data: "custCode", className: "text-center" }, { data: "name1", className: "text-center" }, { data: "name2", className: "text-center" }, { data: "address", className: "text-center" }, { data: "tambon", className: "text-center" }, { data: "amper", className: "text-center" }, { data: "province", className: "text-center" }, { data: "zipCode", className: "text-center" },
                // { data: "month", className: "text-center" },
                {
                  data: "monthInt",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.month;
                  }
                }, { data: "year", className: "text-center" }, { data: "brand", className: "text-center" },
                // { data: "แบรนด์สินค้า", className: "text-center" },
                { data: "fullName", className: "text-center" }, { data: "d01", className: "text-center" }, { data: "d02", className: "text-center" }, { data: "d03", className: "text-center" }, { data: "d04", className: "text-center" }, { data: "d05", className: "text-center" }, { data: "d06", className: "text-center" }, { data: "d07", className: "text-center" }, { data: "d08", className: "text-center" }, { data: "d09", className: "text-center" }, { data: "d10", className: "text-center" }, { data: "d11", className: "text-center" }, { data: "d12", className: "text-center" }, { data: "d13", className: "text-center" }, { data: "d14", className: "text-center" }, { data: "d15", className: "text-center" }, { data: "d16", className: "text-center" }, { data: "d17", className: "text-center" }, { data: "d18", className: "text-center" }, { data: "d19", className: "text-center" }, { data: "d20", className: "text-center" }, { data: "d21", className: "text-center" }, { data: "d22", className: "text-center" }, { data: "d23", className: "text-center" }, { data: "d24", className: "text-center" }, { data: "d25", className: "text-center" }, { data: "d26", className: "text-center" }, { data: "d27", className: "text-center" }, { data: "d28", className: "text-center" }, { data: "d29", className: "text-center" }, { data: "d30", className: "text-center" }, { data: "d31", className: "text-center" }],
                columnDefs: [{
                  targets: [7, 8, 9, 10] /* column index */
                  , orderable: false /* true or false */
                }],
                drawCallback: function drawCallback(settings) {
                  self.reAaIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    // Generate year options: current year+1 to current year-4
    var currentYear = new Date().getFullYear();
    var yearData = [{ id: (currentYear + 1).toString(), text: (currentYear + 1).toString() }, { id: currentYear.toString(), text: currentYear.toString() }, { id: (currentYear - 1).toString(), text: (currentYear - 1).toString() }, { id: (currentYear - 2).toString(), text: (currentYear - 2).toString() }, { id: (currentYear - 3).toString(), text: (currentYear - 3).toString() }, { id: (currentYear - 4).toString(), text: (currentYear - 4).toString() }];

    return {
      EvaluationId: 0,
      currentMonth: 0,
      currentTypeCode: "SYSTEM",
      currentScoreNew: null,
      currentScore: null,
      currentRemark: null,
      searchYear: currentYear.toString(),
      searchAgentCode: [],
      searchAgentOptions: [],
      yearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: true,
        data: yearData
      },
      statusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "MY_APPROVAL", text: "ใบงานที่ต้องอนุมัติ" }, { id: "DRAFT", text: "บันทึก" }, { id: "WAITING_CONFIRM", text: "รอยืนยัน" }, { id: "COMPLETED", text: "ดำเนินการเรียบร้อย" }, { id: "CANCELED", text: "ยกเลิก" }]
      },
      dataTable: null,
      dataSource: [],
      dataSourceRemark: []
    };
  },
  methods: {
    formReset: function formReset(e) {
      //   const currentYear = new Date().getFullYear();
      //   this.searchYear = currentYear.toString(); 
      //   this.searchStatus = null;

      //   // Reset all Select2 dropdowns
      //   $("#searchYear").val(currentYear.toString()).trigger("change"); 
      //   $("#searchStatus").val(null).trigger("change");

      //   // Reload filter dropdowns
      //  // this.loadFilterDropdowns();

      // Reload table
      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      if (e) e.preventDefault();
    },
    formSubmit2: function formSubmit2(e) {
      if (e) e.preventDefault();
    },
    loadAgentOptions: function loadAgentOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        IsShowInAgentScoreReport: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.searchAgentOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    loadAgentScore: function loadAgentScore() {

      self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กรุณารอสักครู่..."
      });

      var params = {};
      if (self.searchYear) {
        params.Year = self.searchYear;
      }
      if (self.searchAgentCode && self.searchAgentCode.length > 0) {
        params.AgentCodeSap = self.searchAgentCode;
      }

      try {
        __WEBPACK_IMPORTED_MODULE_1_axios___default()({
          method: "post",
          url: "/Api/AgentScore/AgentScoreEvalation",
          data: params
        }).then(function (response) {
          self.dataSource = response.data;
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error").then(function () {});
        }).then(function () {
          // always executed
          KTApp.unblockPage();
        });
      } catch (error) {
        console.error("Error load score data:", error);
      }
    },

    ApproveJobAgentEvaluationALL: function ApproveJobAgentEvaluationALL(e) {
      var _this = this;

      var self = this;
      var data = {
        Year: self.searchYear,
        StatusCode: 'APPROVE',
        All: true
      };

      var data_len = self.dataSource.length;
      if (data_len <= 0) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่ต้องการยืนยัน", "error").then(function () {});
      } else {
        Swal.fire({
          title: "ยืนยัน",
          type: "warning",
          html: "ต้องการยืนยันทุกตัวแทนจำหน่ายใช่หรือไม่? ",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {

            KTApp.blockPage({
              opacity: 0.05,
              message: "กรุณารอสักครู่..."
            });
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/AgentScore/ApproveJobAgentEvaluationALL", data).then(function (response) {
              if (response.data) {
                _this.loadAgentScore();
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.message, "error");
              }
            }).catch(function (error) {
              console.log(error);
              Swal.fire("เกิดข้อผิดพลาด", error.response.message, "error");
            }).then(function () {
              KTApp.unblockPage();
            });
          }
        });
      }
    },
    ApproveJobAgentEvaluation: function ApproveJobAgentEvaluation(evaluationId, statusCode) {
      var _this2 = this;

      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กรุณารอสักครู่..."
      });

      var data = {
        evaluationId: evaluationId,
        statusCode: statusCode
      };

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/AgentScore/ApproveJobAgentEvaluation", data).then(function (response) {
        if (response.data) {
          _this2.loadAgentScore();
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.message, "error");
        }
      }).catch(function (error) {
        console.log(error);
        Swal.fire("เกิดข้อผิดพลาด", error.response.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },

    SaveCommentEdit: function SaveCommentEdit(e) {
      var _this3 = this;

      var self = this;

      var form = $(this.$refs.editForm);
      if (!form.valid()) {
        return;
      } else {
        if (self.currentScoreNew !== null && self.currentScoreNew !== '') {
          var data = {
            monthNo: self.currentMonth,
            evaluationId: self.EvaluationId,
            oldScore: self.currentScore || 0,
            NewScore: self.currentScoreNew,
            Remark: self.currentRemark,
            typeCode: self.currentTypeCode
          };

          KTApp.blockPage({
            opacity: 0.05,
            message: "กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/AgentScore/AddJobAgentEvaluationScoreRemarkLog", data).then(function (response) {
            if (response.data) {
              _this3.loadAgentScore();
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.message, "error");
            }
          }).catch(function (error) {
            console.log(error);
            Swal.fire("เกิดข้อผิดพลาด", error.response.message, "error");
          }).then(function () {
            KTApp.unblockPage();
          });
          // -- End Submit Barcode
        }

        $('#EditModal').modal('hide');
      }
    },
    initEditValidator: function initEditValidator() {
      var form = $(this.$refs.editForm);

      // ลบ instance เก่าก่อน
      if (form.data('validator')) {
        form.validate().destroy();
      }

      form.validate({
        ignore: [],
        rules: {
          currentScoreNew: {
            required: true,
            number: true,
            min: 0
          },
          currentRemark: {
            required: true
          }
        },
        messages: {
          currentScoreNew: {
            required: "กรุณากรอกคะแนน",
            number: "กรุณากรอกตัวเลข",
            min: "คะแนนต้องไม่น้อยกว่า 0"
          },
          currentRemark: {
            required: "กรุณากรอกหมายเหตุ"
          }
        }
      });
    },
    showModal: function showModal(evaluationId, month, typecode, score, remark) {
      var _this4 = this;

      var self = this;
      setTimeout(function () {
        self.EvaluationId = evaluationId;
        self.currentMonth = month;
        self.currentTypeCode = typecode;
        self.currentScoreNew = score;
        self.currentScore = score;
        self.currentRemark = '';
      }, 50);

      self.dataSourceRemark = [];

      KTApp.blockPage({
        opacity: 0.05,
        message: "กรุณารอสักครู่..."
      });

      try {
        __WEBPACK_IMPORTED_MODULE_1_axios___default()({
          method: "get",
          url: "/Api/AgentScore/GetAgentScoreEvalationRemark?evalid=" + evaluationId + "&month=" + month + "&typecode=" + typecode
        }).then(function (response) {

          if (response.status == 200) {
            var data = response.data;

            setTimeout(function () {
              data.forEach(function (element) {
                self.dataSourceRemark.push({
                  logId: element.logId,
                  scoreId: element.scoreId,
                  oldScore: element.oldScore,
                  newScore: element.newScore,
                  remark: element.remark,
                  actionType: element.actionType,
                  createdUserId: element.createdUserId,
                  createdDateText: moment(element.createdDate).format('DD/MM/YYYY HH:mm:ss'),
                  createdDate: element.createdDate,
                  updatedUserId: element.updatedUserId,
                  updatedDate: element.updatedDate,
                  firstName: element.firstName,
                  lastName: element.lastName,
                  fullName: element.fullName,
                  monthNo: element.monthNo,
                  evaluationId: element.evaluationId,
                  typeCode: element.typeCode
                });
              });

              console.log(self.dataSourceRemark);
            }, 50);
          }
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error").then(function () {});
        }).then(function () {
          // always executed
          KTApp.unblockPage();
        });
      } catch (error) {
        console.error("Error load score data:", error);
      }

      // $('#EditModal').on('shown.bs.modal', () => {
      //   $('body').addClass('modal-open');

      // });

      $('#EditModal').modal('show');
      $('#EditModal').off('shown.bs.modal').on('hidden.bs.modal', function () {
        $('body').addClass('modal-open');
      });

      this.$nextTick(function () {
        _this4.initEditValidator();
      });
    },
    closeModal: function closeModal() {
      $('#EditModal').modal('hide');
    }
  },
  mounted: function mounted() {
    // Load job types and filter dropdowns
    var self = this;
    this.loadAgentOptions();
    this.loadAgentScore();

    // Set default year
    this.$nextTick();
    var currentYear = new Date().getFullYear();
    $("#searchYear").val(currentYear.toString()).trigger("change");

    // $(self.$refs.editForm).validate({
    //   ignore: ":hidden, .ignore",
    //   rules: {
    //     currentScoreNew: "required",
    //     currentRemark: "required", 
    //   },
    //   messages: {
    //     currentScoreNew: "กรุณากรอกคะแนน",
    //     currentRemark: "กรุณากรอกหมายเหตุ", 
    //   },
    // });
  },

  watch: {
    '$route.query.reload': function $routeQueryReload() {
      // Reload datatable when returning from form with reload query param
      if (this.dataTable) {
        this.dataTable.ajax.reload();
      }
    },
    searchYear: function searchYear(newVal, oldVal) {

      this.loadAgentScore();
    },
    searchAgentCode: function searchAgentCode(newVal, oldVal) {
      this.loadAgentScore();
    }

  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      isEdit: false,
      abcClaimTypeCode: null,
      abcAgentCode: null,
      abcAgentCodeTmp: null,
      abcShopCode: null,
      abcAmpher: null,
      abcProvince: null,
      abcPhone: null,
      abcClaimItems: [],
      index: 0,

      // Configurations
      abcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2AgentData",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopData",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    uploadFile: function uploadFile(file) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var formData, _response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = new FormData();

                formData.append('File', file);
                formData.append('FolderName', 'BeerClaim');
                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/Api/File/FileUpload', formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 6:
                _response = _context.sent;
                return _context.abrupt("return", _response.data);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                throw _context.t0;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 10]]);
      }))();
    },
    formSubmit: function formSubmit(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var router, self, cItems, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, uploadedFiles, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, file, uploadResponse;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if ($(_this2.$refs.form).validate().form()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", false);

              case 2:
                if (!(_this2.abcClaimItems == null || _this2.abcClaimItems.length == 0)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", false);

              case 4:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                router = _this2.$router;
                self = _this2;
                cItems = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 11;
                _iterator = self.abcClaimItems[Symbol.iterator]();

              case 13:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 55;
                  break;
                }

                element = _step.value;
                uploadedFiles = [];

                if (!element.uploadFiles) {
                  _context2.next = 49;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 20;
                _iterator2 = element.uploadFiles[Symbol.iterator]();

              case 22:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 35;
                  break;
                }

                file = _step2.value;

                if (!(file && file.fileDataContext)) {
                  _context2.next = 31;
                  break;
                }

                _context2.next = 27;
                return self.uploadFile(file.fileDataContext);

              case 27:
                uploadResponse = _context2.sent;

                // console.log('uploadResponse',uploadResponse)
                uploadedFiles.push({
                  contentType: file.fileDataContext.type,
                  downloadUrl: uploadResponse.fileUrl,
                  fileInfoId: uploadResponse.fileInfoId,
                  fileName: file.fileDataContext.name,
                  gridFsId: uploadResponse.gridFsId,
                  sysName: '-'
                });
                _context2.next = 32;
                break;

              case 31:
                if (file && file.claimItemPictureId) {
                  uploadedFiles.push({
                    claimItemPictureId: file.claimItemPictureId,
                    fileInfoId: file.fileInfoId
                  });
                }

              case 32:
                _iteratorNormalCompletion2 = true;
                _context2.next = 22;
                break;

              case 35:
                _context2.next = 41;
                break;

              case 37:
                _context2.prev = 37;
                _context2.t0 = _context2["catch"](20);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 41:
                _context2.prev = 41;
                _context2.prev = 42;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 44:
                _context2.prev = 44;

                if (!_didIteratorError2) {
                  _context2.next = 47;
                  break;
                }

                throw _iteratorError2;

              case 47:
                return _context2.finish(44);

              case 48:
                return _context2.finish(41);

              case 49:
                if (element.machineCategory === 'true') {
                  element.machineCategory = true;
                }
                if (element.machineCategory === 'false') {
                  element.machineCategory = false;
                }
                cItems.push({
                  ProductBrandId: element.productBrandId,
                  MaterialCode: element.materialCode,
                  Barcode: element.barcode,
                  ManufacturingDate: element.manufacturingDate ? element.manufacturingDate.format("DD/MM/YYYY") : null,
                  Weight: element.weight,
                  ProblemTypeCode: element.problemTypeCode,
                  ProblemDesc: element.problemDesc,
                  MachineTypeCode: element.machineTypeCode,
                  MachineBarcode: element.machineBarcode,
                  MachineCategory: element.machineCategory,
                  Pressure: element.pressure,
                  Temperature: element.temperature,
                  PMDate: element.pmDate ? element.pmDate.format("DD/MM/YYYY") : null,
                  JumpDate: element.jumpDate ? element.jumpDate.format("DD/MM/YYYY") : null,
                  StandardInstallCode: element.standardInstallCode,
                  AgentReceivedDate: element.agentReceivedDate.format("DD/MM/YYYY"),
                  ShopReceivedDate: element.shopReceivedDate ? element.shopReceivedDate.format("DD/MM/YYYY") : null,
                  Invoice: element.invoice,
                  Pictures: uploadedFiles
                });

              case 52:
                _iteratorNormalCompletion = true;
                _context2.next = 13;
                break;

              case 55:
                _context2.next = 61;
                break;

              case 57:
                _context2.prev = 57;
                _context2.t1 = _context2["catch"](11);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 61:
                _context2.prev = 61;
                _context2.prev = 62;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 64:
                _context2.prev = 64;

                if (!_didIteratorError) {
                  _context2.next = 67;
                  break;
                }

                throw _iteratorError;

              case 67:
                return _context2.finish(64);

              case 68:
                return _context2.finish(61);

              case 69:

                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BeerClaim", {
                  BeerClaimItems: cItems,
                  ClaimTypeCode: _this2.abcClaimTypeCode,
                  ClaimAgentCode: _this2.abcClaimTypeCode == "BEER_CLAIM_TYPE_AGENT" ? _this2.abcAgentCode : null,
                  ClaimShopCode: _this2.abcClaimTypeCode == "BEER_CLAIM_TYPE_SHOP" ? _this2.abcShopCode : null
                }).then(function (response) {
                  if (response.data.status) {
                    KTApp.unblockPage();
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      router.go(-1), self.$parent.reloadDataTable(false);
                    });
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

              case 70:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[11, 57, 61, 69], [20, 37, 41, 49], [42,, 44, 48], [62,, 64, 68]]);
      }))();
    },

    onAgentCodeChange: function onAgentCodeChange(id, text, data, ref) {
      var self = this;
      if (isArray(data) && data.length > 0) {
        self.abcAmpher = data[0].data.ampherName;
        self.abcProvince = data[0].data.provinceName;
        self.abcPhone = data[0].data.phone;
        self.abcAgentCodeTmp = self.abcAgentCode;
      }
    },
    onShopCodeChange: function onShopCodeChange(id, text, data, ref) {
      var self = this;
      if (isArray(data) && data.length > 0) {
        self.abcAmpher = data[0].data.ampherName;
        self.abcProvince = data[0].data.provinceName;
        self.abcPhone = data[0].data.phone;
        self.abcAgentCodeTmp = data[0].data.agentCode;
      }
    },
    onClaimTypeCodeChange: function onClaimTypeCodeChange() {
      var self = this;
      self.abcAgentCode = null;
      self.abcShopCode = null;
      self.abcAmpher = null;
      self.abcProvince = null;
      self.abcPhone = null;
      self.abcClaimItems = [];

      $("#abcAgentCode").val("").trigger("change");

      $("#abcShopCode").val("").trigger("change");
    },
    onRemoveItemClick: function onRemoveItemClick(index) {
      this.abcClaimItems.splice(index, 1);
    },
    onEditItemClick: function onEditItemClick(index) {
      var router = this.$router;
      var item = this.abcClaimItems[index];
      if (this.abcClaimItems.length > 0) {
        router.push({
          path: "/BeerClaim/Claim/Add/AddItem/" + index
        });
      } else {
        router.push({
          path: "/BeerClaim/Claim/Add"
        });
      }
    },
    handleBackButton: function handleBackButton(event) {
      var modalBackdrop = document.querySelector('.modal-backdrop');
      if (modalBackdrop !== null && modalBackdrop !== undefined && modalBackdrop !== '') {
        modalBackdrop.remove();
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this3;
              router = _this3.$router;
              _context3.next = 4;
              return _this3.$root.getUser();

            case 4:
              user = _context3.sent;

              window.addEventListener('popstate', _this3.handleBackButton);
              // set validation rules
              $(_this3.$refs.form).validate({
                rules: {
                  abcClaimTypeCode: "required",
                  abcAgentCode: "required",
                  abcShopCode: "required"
                },
                messages: {
                  abcClaimTypeCode: "กรุณาเลือกประเภทการเคลม",
                  abcAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
                  abcShopCode: "กรุณาเลือกร้านค้า"
                }
              });

              $(_this3.$refs.form).validate().settings.ignore = ":hidden";

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  destroyed: function destroyed() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              window.removeEventListener('popstate', _this4.handleBackButton);

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_plupload__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      IsDisabled: true,
      IsDisabledMachineBarcode: false,
      IsDisabledBarcode: false,
      IsDisabledProblemTypeCode: false,
      IsDisabledDate: true,
      fileUploader: null,
      uploadFiles: [],
      modalImageURL: '',
      isFromImageModal: false,
      checkMacBarcode: true,
      checkBarcode: true,
      isEdit: false,
      bciProductBrandId: null,
      bciProductBrand: null,
      bciMaterialCode: null,
      bciMaterial: null,
      bciBarcode: null,
      bciBarcodeOld: null,
      bciBarcodeNew: null,
      bciDepcode: null,
      bciMacDepcode: null,
      bciManufacturingDate: null,
      bciWeight: 0,
      bciProblemTypeCode: null,
      bciProblemType: null,
      bciProblemDesc: null,
      bciMachineTypeCode: null,
      bciMachineType: null,
      bciMachineBarcode: null,
      bciMachineBarcodeOld: null,
      bciMachineCategory: null,
      bciPressure: null,
      bciTemperature: null,
      bciPMDate: null,
      bciJumpDate: null,
      bciStandardInstallCode: null,
      bciStandardInstall: null,
      bciAgentReceivedDate: null,
      bciShopReceivedDate: null,
      bciInvoice: null,
      //Options
      bciMachineTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "MACHINE_TYPE",
              keySearch: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      bciStandardInstallCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "STANDARD_INSTALL",
              keySearch: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      bciProblemTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "PROBLEM_TYPE",
              keySearch: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      bciMachineCategoryOptions: {
        placeholder: "กรุณาเลือกประเภทเครื่องเบียร์สด",
        allowClear: true,
        data: [{ id: "false", text: "ไม่มีหัวจ่ายในตัว", data: null }, { id: "true", text: "มีหัวจ่ายในตัว", data: null }]
      },
      //เฉพาะ หมวดหมู่ สินค้าสำเร็จรูป + ประเภท น้ำเบียร์
      bciMaterialCodeOptions: {
        placeholder: "เลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              productGroupId: "14",
              productTypeId: "22",
              onlyHasBarcode: true
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    showModal: function showModal(imageURL) {
      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', function () {
        $('body').addClass('modal-open');
      });
    },
    closeModal: function closeModal() {
      $('#imageModal').modal('hide');
    },

    formSubmit: function formSubmit(e) {
      e.preventDefault();
      if (!$("#addClaimItemModal form").validate().form() || !this.checkMacBarcode || !this.checkBarcode) {
        if (!this.checkMacBarcode) {
          this.onBlurBarcode(true);
        }
        if (!this.checkBarcode) {
          this.onBlurBarcode(false);
        }
        return false;
      }

      var self = this;
      var router = this.$router;
      var index = this.$route.params.id;
      if (index.includes("add_")) {
        self.$parent.abcClaimItems.push({
          productBrandId: self.bciProductBrandId,
          productBrand: self.bciProductBrand,
          materialCode: self.bciMaterialCode,
          material: self.bciMaterial,
          barcode: self.bciBarcode,
          barcodeNew: self.bciBarcodeNew,
          barcodeOld: self.bciBarcodeOld,
          depCode: self.bciDepcode,
          manufacturingDate: self.bciManufacturingDate,
          weight: self.bciWeight,
          problemTypeCode: self.bciProblemTypeCode,
          problemType: self.bciProblemType,
          problemDesc: self.bciProblemDesc,
          machineTypeCode: self.bciMachineTypeCode,
          machineType: self.bciMachineType,
          machineBarcode: self.bciMachineBarcode,
          machineBarcodeOld: self.bciMachineBarcodeOld,
          macDepcode: self.bciMacDepcode,
          machineCategory: self.bciMachineCategory,
          pressure: self.bciPressure,
          temperature: self.bciTemperature,
          pmDate: self.bciPMDate,
          jumpDate: self.bciJumpDate,
          standardInstallCode: self.bciStandardInstallCode,
          standardInstall: self.bciStandardInstall,
          agentReceivedDate: self.bciAgentReceivedDate,
          shopReceivedDate: self.bciShopReceivedDate,
          invoice: self.bciInvoice,
          uploadFiles: self.uploadFiles
        });
        self.$parent.index += 1;
      } else {
        self.$parent.abcClaimItems[index].productBrandId = self.bciProductBrandId;
        self.$parent.abcClaimItems[index].productBrand = self.bciProductBrand;
        self.$parent.abcClaimItems[index].materialCode = self.bciMaterialCode;
        self.$parent.abcClaimItems[index].material = self.bciMaterial;
        self.$parent.abcClaimItems[index].barcode = self.bciBarcode;
        self.$parent.abcClaimItems[index].barcodeNew = self.bciBarcodeNew;
        self.$parent.abcClaimItems[index].barcodeOld = self.bciBarcodeOld;
        self.$parent.abcClaimItems[index].manufacturingDate = self.bciManufacturingDate;
        self.$parent.abcClaimItems[index].weight = self.bciWeight;
        self.$parent.abcClaimItems[index].problemTypeCode = self.bciProblemTypeCode;
        self.$parent.abcClaimItems[index].problemType = self.bciProblemType;
        self.$parent.abcClaimItems[index].problemDesc = self.bciProblemDesc;
        self.$parent.abcClaimItems[index].machineTypeCode = self.bciMachineTypeCode;
        self.$parent.abcClaimItems[index].machineType = self.bciMachineType;
        self.$parent.abcClaimItems[index].machineBarcode = self.bciMachineBarcode;
        self.$parent.abcClaimItems[index].machineBarcodeOld = self.bciMachineBarcodeOld;
        self.$parent.abcClaimItems[index].machineCategory = self.bciMachineCategory;
        self.$parent.abcClaimItems[index].pressure = self.bciPressure;
        self.$parent.abcClaimItems[index].temperature = self.bciTemperature;
        self.$parent.abcClaimItems[index].pmDate = self.bciPMDate;
        self.$parent.abcClaimItems[index].jumpDate = self.bciJumpDate;
        self.$parent.abcClaimItems[index].standardInstallCode = self.bciStandardInstallCode;
        self.$parent.abcClaimItems[index].standardInstall = self.bciStandardInstall;
        self.$parent.abcClaimItems[index].agentReceivedDate = self.bciAgentReceivedDate;
        self.$parent.abcClaimItems[index].shopReceivedDate = self.bciShopReceivedDate;
        self.$parent.abcClaimItems[index].invoice = self.bciInvoice;
        self.$parent.abcClaimItems[index].uploadFiles = self.uploadFiles;
        //let claim = self.$parent.abcClaimItems[index];
      }
      $("#addClaimItemModal").modal("hide");
    },
    onMaterialCodeChange: function onMaterialCodeChange(id, text, data, ref) {
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.bciMaterial = data[0].text;
      }
      //set brand
      if (data[0] && data[0].data) {
        self.bciProductBrandId = data[0].data.productBrandId;
        self.bciProductBrand = data[0].data.productBrandName;
      }
    },
    onProblemTypeCodeChange: function onProblemTypeCodeChange(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciProblemType = data[0].text;
    },
    onMachineTypeCodeChange: function onMachineTypeCodeChange(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciMachineType = data[0].text;
    },
    onStandardInstallCodeChange: function onStandardInstallCodeChange(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciStandardInstall = data[0].text;
    },
    onBlurBarcode: function onBlurBarcode(isMachine) {
      var self = this;
      var barcode = isMachine ? self.bciMachineBarcode : self.bciBarcode;
      barcode = barcode ? barcode.split('(')[0].trim() : barcode;
      if (barcode === '') {
        $("#addClaimItemModal form").validate().element("#" + (isMachine ? 'bciMachineBarcode' : 'bciBarcode'));
      }
      if (barcode != null && barcode != '') {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BeerClaim/BarcodeData", {
          BarcodeNO: barcode,
          IsMachine: isMachine
        }).then(function (response) {
          if (response.status == 200) {
            if (isMachine) {
              self.bciMacDepcode = response.data.departmentMaterialCode ? response.data.departmentMaterialCode : null;
              self.bciMachineBarcode = response.data.departmentMaterialCode ? response.data.barcodeNOOld + "(" + response.data.departmentMaterialCode + ")" : response.data.barcodeNOOld;
              self.bciMachineBarcodeOld = response.data.barcodeNOOld;
              self.checkMacBarcode = true;
              self.$refs.bciMachineCategorySelect2.setSelectedData({
                id: response.data.machineCategory
              });
              if (response.data.pmDateFormat) {
                self.bciPMDate = moment(response.data.pmDateFormat, "DD/MM/YYYY");
                $(self.$refs.bciPMDate).datepicker("update", response.data.pmDateFormat2);
              }
            } else {
              self.bciDepcode = response.data.departmentMaterialCode ? response.data.departmentMaterialCode : null;
              self.bciBarcode = response.data.departmentMaterialCode ? response.data.barcodeNOOld + " (" + response.data.departmentMaterialCode + ")" : response.data.barcodeNOOld;
              self.checkBarcode = true;
              if (response.data.barcodeNO) {
                self.bciBarcodeNew = response.data.barcodeNO;
              }

              if (response.data.barcodeNOOld) {
                self.bciBarcodeOld = response.data.barcodeNOOld;
              }

              if (response.data.manufacturingDateFormat) {
                self.bciManufacturingDate = moment(response.data.manufacturingDateFormat, "DD/MM/YYYY");
                $(self.$refs.bciManufacturingDate).datepicker("update", response.data.manufacturingDateFormat2);
              }
            }
          } else {
            if (isMachine) {
              self.checkMacBarcode = false;
              var validator = $("#addClaimItemModal form").validate();
              validator.showErrors({
                bciMachineBarcode: "ไม่พบข้อมูล BARCODE (เครื่องเบียร์สด)"
              });
              self.$refs.bciMachineCategorySelect2.setSelectedData({
                id: null
              });
              self.bciPMDate = null;
              $(self.$refs.bciPMDate).datepicker("update", null);
            } else {
              self.checkBarcode = false;
              var _validator = $("#addClaimItemModal form").validate();
              _validator.showErrors({
                bciBarcode: "ไม่พบข้อมูล BARCODE (ถัง)"
              });
              self.bciManufacturingDate = null;
              $(self.$refs.bciManufacturingDate).datepicker("update", null);
            }
          }
        });

        if (!isMachine) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BeerClaim/BarcodeRetrieveDate", {
            BarcodeNO: barcode,
            AgentCode: self.$parent.abcAgentCodeTmp,
            ShopCode: self.$parent.abcShopCode
          }).then(function (response) {
            if (response.status == 200) {
              if (response.data.agentReceivedDateFormat) {
                self.bciAgentReceivedDate = moment(response.data.agentReceivedDateFormat, "DD/MM/YYYY");
                $(self.$refs.bciAgentReceivedDate).datepicker("update", response.data.agentReceivedDateFormat2);
              } else {
                self.bciAgentReceivedDate = null;
                $(self.$refs.bciAgentReceivedDate).datepicker("update", null);
              }

              if (response.data.shopReceivedDateFormat) {
                self.bciShopReceivedDate = moment(response.data.shopReceivedDateFormat, "DD/MM/YYYY");
                $(self.$refs.bciShopReceivedDate).datepicker("update", response.data.shopReceivedDateFormat2);
              } else {
                self.bciShopReceivedDate = null;
                $(self.$refs.bciShopReceivedDate).datepicker("update", null);
              }
            } else {
              self.bciAgentReceivedDate = null;
              $(self.$refs.bciAgentReceivedDate).datepicker("update", null);

              self.bciShopReceivedDate = null;
              $(self.$refs.bciShopReceivedDate).datepicker("update", null);
            }
          });
        }
      }
    },
    deleteImage: function deleteImage(index) {
      this.uploadFiles.splice(index, 1);
      this.$refs.fileInput1.value = '';
    },
    handleFileUpload: function handleFileUpload(event, index) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var self, file, reader;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                file = event.target.files[0];

                if (file) {
                  reader = new FileReader();

                  reader.onload = function (e) {
                    var imagePreview = e.target.result;
                    self.uploadFiles.push({
                      fileURL: imagePreview,
                      fileDataContext: file
                    });
                  };
                  reader.readAsDataURL(file);
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var self, router, user, arrows, index, claim, manufacturingDate, agentReceivedDate, shopReceivedDate, jumpDate, pmDate, loadPictures;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              self = _this2;
              router = _this2.$router;
              _context4.next = 4;
              return _this2.$root.getUser();

            case 4:
              user = _context4.sent;


              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.bciManufacturingDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.bciManufacturingDate).datepicker("update", !!self.bciManufacturingDate ? self.bciManufacturingDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bciManufacturingDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.bciPMDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.bciPMDate).datepicker("update", !!self.bciPMDate ? self.bciPMDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bciPMDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.bciJumpDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.bciJumpDate).datepicker("update", !!self.bciJumpDate ? self.bciJumpDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bciJumpDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.bciAgentReceivedDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.bciAgentReceivedDate).datepicker("update", !!self.bciAgentReceivedDate ? self.bciAgentReceivedDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bciAgentReceivedDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.bciShopReceivedDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.bciShopReceivedDate).datepicker("update", !!self.bciShopReceivedDate ? self.bciShopReceivedDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bciShopReceivedDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              //#region :: set validation rules
              $("#addClaimItemModal form").validate({
                rules: {
                  bciMachineTypeCode: "required",
                  bciMachineBarcode: "required",
                  bciMachineCategory: "required",
                  bciStandardInstallCode: "required",
                  bciMaterialCode: "required",
                  bciBarcode: "required",
                  bciProblemTypeCode: "required",
                  bciProblemDesc: "required",
                  bciInvoice: "required",
                  bciAgentReceivedDate: "required",
                  bciShopReceivedDate: "required"
                },
                messages: {
                  bciMachineTypeCode: "กรุณาเลือกชนิดเครื่อง",
                  bciMachineBarcode: "กรุณากรอก BARCODE (เครื่องเบียร์สด)",
                  bciMachineCategory: "กรุณาเลือกประเภทเครื่องเบียร์สด",
                  bciStandardInstallCode: "กรุณาเลือกมาตรฐานติดตั้ง",
                  bciMaterialCode: "กรุณาเลือกสินค้า",
                  bciBarcode: "กรุณากรอก BARCODE (ถัง)",
                  bciProblemTypeCode: "กรุณาเลือกปัญหาที่พบ",
                  bciProblemDesc: "กรุณากรอกรายละเอียดของปัญหา",
                  bciInvoice: "กรุณากรอกเลขที่ Invoice",
                  bciAgentReceivedDate: "กรุณาเลือกวันที่สินค้าเข้าตัวแทนจำหน่าย",
                  bciShopReceivedDate: "กรุณาวันที่สินค้าเข้าร้านค้า"
                }
              });
              $(_this2.$refs.formItem).validate().settings.ignore = ":hidden";
              //#endregion :: set validation rules

              //#region :: Set Value
              index = _this2.$route.params.id;

              if (!index.includes("add_")) {
                claim = self.$parent.abcClaimItems[index];

                if (claim) {
                  if (claim.isBeerClaimAdmin !== undefined) {
                    if (claim.isBeerClaimAdmin && claim.claimStatusCode != "CLAIM_STATUS_SUBMIT") {
                      _this2.IsDisabled = false;
                      _this2.IsDisabledMachineBarcode = true;
                      _this2.IsDisabledBarcode = true;
                    }
                    if (claim.isBeerClaimAdmin) {
                      _this2.IsDisabledDate = false;
                    }
                    if (claim.isBeerClaimAdmin && claim.claimStatusCode !== 'CLAIM_STATUS_SUBMIT' && claim.claimStatusCode !== 'CLAIM_STATUS_QI_INSPECT' && claim.claimStatusCode !== 'CLAIM_STATUS_COMMIT') {
                      _this2.IsDisabledProblemTypeCode = true;
                    }
                  }
                  //#region :: รายละเอียด สินค้าเบียร์สด
                  self.bciProductBrand = claim.productBrand;
                  self.bciProductBrandId = claim.productBrandId;
                  setTimeout(function () {
                    if (claim.materialCode) {
                      self.$refs.bciMaterialCodeSelect2.setSelectedData({
                        id: claim.materialCode,
                        text: claim.material
                      });
                    }
                  }, 100);
                  if (claim.manufacturingDate) {
                    manufacturingDate = moment(claim.manufacturingDate);

                    self.bciManufacturingDate = manufacturingDate;
                    $(self.$refs.bciManufacturingDate).datepicker("update", manufacturingDate.format("DD-MM-YYYY"));
                  }

                  if (claim.agentReceivedDate) {
                    agentReceivedDate = moment(claim.agentReceivedDate);

                    self.bciAgentReceivedDate = agentReceivedDate;
                    $(self.$refs.bciAgentReceivedDate).datepicker("update", agentReceivedDate.format("DD-MM-YYYY"));
                  }

                  if (claim.shopReceivedDate) {
                    shopReceivedDate = moment(claim.shopReceivedDate);

                    self.bciShopReceivedDate = shopReceivedDate;
                    $(self.$refs.bciShopReceivedDate).datepicker("update", shopReceivedDate.format("DD-MM-YYYY"));
                  }
                  claim.barcode = claim.barcode ? claim.barcode.split('(')[0].trim() : claim.barcode;
                  self.bciBarcode = claim.depCode ? claim.barcodeOld + " (" + claim.depCode + ")" : claim.barcodeOld;
                  self.bciBarcodeNew = claim.barcodeNew;
                  self.bciBarcodeOld = claim.barcodeOld;
                  self.bciWeight = claim.weight;
                  self.bciInvoice = claim.invoice;
                  //#endregion :: รายละเอียด สินค้าเบียร์สด

                  //#region :: รายละเอียด ปัญหาที่พบ
                  if (claim.problemTypeCode) {
                    self.$refs.bciProblemTypeCodeSelect2.setSelectedData({
                      id: claim.problemTypeCode,
                      text: claim.problemType
                    });
                  }
                  self.bciProblemDesc = claim.problemDesc;
                  //#endregion :: รายละเอียด ปัญหาที่พบ

                  //#region :: รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ
                  claim.machineBarcode = claim.machineBarcode ? claim.machineBarcode.split('(')[0].trim() : claim.machineBarcode;
                  self.bciMachineBarcode = claim.macDepcode ? claim.machineBarcodeOld + "(" + claim.macDepcode + ")" : claim.machineBarcodeOld;
                  self.bciPressure = claim.pressure;
                  self.bciTemperature = claim.temperature;

                  if (claim.machineTypeCode) {
                    self.$refs.bciMachineTypeCodeSelect2.setSelectedData({
                      id: claim.machineTypeCode,
                      text: claim.machineType
                    });
                  }

                  if (claim.machineCategory == true || claim.machineCategory === false || claim.machineCategory == 'true' || claim.machineCategory == 'false') {
                    self.$refs.bciMachineCategorySelect2.setSelectedData({
                      id: claim.machineCategory
                    });
                  }

                  if (claim.jumpDate) {
                    jumpDate = moment(claim.jumpDate);

                    self.bciJumpDate = jumpDate;
                    $(self.$refs.bciJumpDate).datepicker("update", jumpDate.format("DD-MM-YYYY"));
                  }

                  if (claim.pmDate) {
                    pmDate = moment(claim.pmDate);

                    self.bciPMDate = pmDate;
                    $(self.$refs.bciPMDate).datepicker("update", pmDate.format("DD-MM-YYYY"));
                  }
                  //#endregion :: รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ

                  //#region :: รายละเอียด การใช้งาน และการบำรุงรักษา
                  if (claim.standardInstallCode) {
                    self.$refs.bciStandardInstallCodeSelect2.setSelectedData({
                      id: claim.standardInstallCode,
                      text: claim.standardInstall
                    });
                  }
                  //#endregion :: รายละเอียด การใช้งาน และการบำรุงรักษา
                  if (claim.uploadFiles && typeof claim.uploadFiles !== 'undefined') {
                    self.uploadFiles = claim.uploadFiles;
                  } else {
                    if (claim.claimItemPicture && typeof claim.claimItemPicture !== 'undefined' && claim.claimItemPicture.length > 0) {
                      loadPictures = function () {
                        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                          var _this3 = this;

                          return regeneratorRuntime.wrap(function _callee3$(_context3) {
                            while (1) {
                              switch (_context3.prev = _context3.next) {
                                case 0:
                                  claim.claimItemPicture.map(function () {
                                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(element) {
                                      return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                        while (1) {
                                          switch (_context2.prev = _context2.next) {
                                            case 0:
                                              self.uploadFiles.push({
                                                claimItemPictureId: element.claimItemPictureId,
                                                fileInfoId: element.fileInfoId,
                                                fileURL: element.fileData
                                              });

                                            case 1:
                                            case "end":
                                              return _context2.stop();
                                          }
                                        }
                                      }, _callee2, _this3);
                                    }));

                                    return function (_x) {
                                      return _ref2.apply(this, arguments);
                                    };
                                  }());

                                case 1:
                                case "end":
                                  return _context3.stop();
                              }
                            }
                          }, _callee3, this);
                        }));

                        return function loadPictures() {
                          return _ref.apply(this, arguments);
                        };
                      }();

                      loadPictures();
                    }
                  }

                  $("#addClaimItemModal").on("hidden.bs.modal", function () {
                    if (!self.isFromImageModal) {
                      // Set go back
                      router.go(-1);
                    } else {
                      self.isFromImageModal = false;
                    }
                  }).modal("show");
                } else {
                  $("#addClaimItemModal").modal("hide");
                }
              } else {
                $("#addClaimItemModal").on("hidden.bs.modal", function () {
                  if (!self.isFromImageModal) {
                    // Set go back
                    router.go(-1);
                  } else {
                    self.isFromImageModal = false;
                  }
                }).modal("show");
              }
              //#endregion :: Set Value

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }))();
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_plupload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: "ระบุผลการวิเคราะห์น้ำเบียร์",
      labResult: null,
      isEdit: true,
      bnt: "บันทึก",
      maxLength: 330,
      uuid: null,
      File: [],
      FileCount: 0
    };
  },
  methods: {
    formReset: function formReset() {
      var self = this;
      var $imageContainer = $("#container-file" + self.uuid);
      if ($("#files", $imageContainer).data("file-id") != null) {
        $imageContainer.empty();
      }
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      var self = this;
      if (!$(self.$refs.form).validate().form()) {
        return false;
      }

      //ระบุผลการวิเคราะห์
      // let status = "CLAIM_STATUS_BEER_ANALYZE_SPECIFY";
      // if (
      //   self.$parent.data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_SPECIFY"
      // ) {
      //   //ส่งผลการวิเคราะห์
      //   status = "CLAIM_STATUS_BEER_ANALYZE_RESULT";
      // }

      // ส่งผลการวิเคราะห์
      var status = "CLAIM_STATUS_BEER_ANALYZE_RESULT";

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังเปลี่ยนสถานะเบียร์เคลม กรุณารอสักครู่..."
      });

      // $(".btm-remove-img-beerclaim").each(function() {
      //   var $img = $(this);
      //   var file = {
      //     FileID : $img.data("file-newid"),
      //     FileName : null,
      //     FileDescription : null,
      //   };
      //   self.File.push(file);
      // });

      // if (self.File.length > 0) {
      //   $("#files").each(function(e) {
      //     console.log(e);
      //     var $img = $(this);
      //     console.log($img);
      //     self.File[e].FileName = $img.data("file-name");
      //   });
      // }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/BeerClaim/EditStatus", {
        ClaimItemId: self.$parent.data.claimItemId,
        StatusCode: status,
        LabResult: self.labResult,
        File: self.File
      }).then(function (response) {
        if (response.data.status) {
          self.$parent.$parent.reloadDataTable();

          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $(self.$el).modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    deleteImg: function deleteImg() {
      var self = this;
      self.uuid = this._uid;
      $("#container-file" + self.uuid).on("click", ".btm-remove-img-beerclaim", function (e) {
        e.preventDefault();
        var $img = $(this);
        Swal.fire({
          title: "ยืนยันคำสั่ง",
          text: "คุณต้องการลบไฟล์นี้หรือไม่",
          icon: "danger",
          confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบไฟล์นี้</span></span>",
          confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",

          showCancelButton: true,
          cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
          cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon",

          // imageUrl: Setting.rootPath + "uploads/" + $img.data("file-newid"),
          imageWidth: 400,
          imageAlt: "Custom image",
          buttons: true,
          dangerMode: true
        }).then(function (result) {
          var file = $img.data("file-newid");
          // let url = Setting.rootPath + "Api/File/DeleteFile/" + file;
          var url = "/Api/File/DeleteFile/" + file;
          if (result.value) {
            if ($img.data("type") != "1") {
              $.ajax({
                type: "Get",
                url: url,
                cache: false,
                success: function success(response) {
                  var fileId = "#" + $img.data("file-id");
                  $(fileId).remove();
                  Swal.fire("เรียบร้อย!", "ลบไฟล์เรียบร้อย", "success");
                },
                failure: function failure(response) {
                  swal("Internal Error", "Oops, your note was not saved.", // had a missing comma
                  "error");
                }
              });
            } else {
              var fileId = "#" + $img.data("file-id");
              $(fileId).remove();
              Swal.fire("เรียบร้อย!", "ลบไฟล์เรียบร้อย", "success");
            }
          }
        });
      });
    },
    initPlUploader: function initPlUploader() {
      var self = this;
      self.uuid = this._uid;
      // console.log(self.uuid);

      var uploader = new __WEBPACK_IMPORTED_MODULE_1_plupload___default.a.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        //multi_selection: false,
        browse_button: "uploader-order" + self.uuid, // you can pass in id...
        //url: Setting.rootPath + "Components/Plupload?reference=" + self.uuid, // คือ Url มาตรฐานของ plupload
        url: "/Components/Plupload?reference=" + self.uuid,

        chunk_size: "1mb",
        max_retries: 5,
        filters: {
          max_file_size: "1024mb",
          mime_types: [{
            title: "doc files",
            extensions: "jpg,jpeg,png,pdf,xlsx,xls,doc,docx,mp4,avi,ppt,pptx"
          }]
        },
        //resize: {
        //width: 300,
        //quality: 100,
        //},
        init: {
          PostInit: function PostInit() {},

          FilesAdded: function FilesAdded(up, files) {
            self.FileCount = files.length;

            if (self.FileCount > 5) {
              Swal.fire("ขออภัย", "แนบไฟล์มากสุด 5 ไฟล์", "warning");
            } else {
              self.File = [];
              var $uploadBtn = $(up.settings.browse_button[0]);
              var $imageContainer = $("#container-file" + self.uuid);
              //mApp.block($imageContainer.parents('.m-portlet__body'))

              if ($("#files", $imageContainer).data("file-id") != null) {
                $(".btm-remove-img-beerclaim").each(function () {
                  var $img = $(this);
                  var file = $img.data("file-newid");
                  var url = "/Api/File/DeleteFile/" + file;
                  $.ajax({
                    type: "Get",
                    url: url,
                    cache: false,
                    success: function success(response) {
                      //console.log("FilesAdded pass");
                    },
                    failure: function failure(response) {
                      Swal.fire("Internal Error", "Oops, your note was not saved.", // had a missing comma
                      "error");
                    }
                  });
                });
                $imageContainer.empty();
              }

              var removeFiles = [];
              __WEBPACK_IMPORTED_MODULE_1_plupload___default.a.each(files, function (file) {
                if ($('div[data-file-name="' + file.name + '"]', $imageContainer).length == 0) {
                  console.log(file.id);
                  var nativeData = file.getNative();
                  if (typeof FileReader != "undefined") {
                    var image_holder = $('<div class="col-md-12 m--margin-top-20 loader loader-secondary bg-overlay img-wrap" id="' + file.id + '"></div>');

                    $('<div style="display:none" id="files" data-file-id="' + file.id + '" data-file-name="' + file.name + '" data-file-uploaded="false" alt="' + file.name + '">' + file.name + '<div id="myProgress" class=" progress' + file.id + '"><div id="myBar' +
                    // file.id +
                    '" class="progress-bar bg-success"><b></b></div ></div></div>').appendTo(image_holder);

                    image_holder.appendTo($imageContainer);

                    var reader = new FileReader();
                    reader.onload = function (e) {
                      $("div[data-file-id=" + file.id + "]").attr("src", e.target.result).show();
                    };
                    reader.readAsDataURL(nativeData);
                  }
                } else {
                  removeFiles.push(file);
                }
              });

              if (removeFiles.length > 0) {
                for (var i = 0; i < removeFiles.length; i++) {
                  up.removeFile(removeFiles[i]);
                }

                Swal.fire("ขออภัย", "ไม่สามารถเลือกไฟล์ซ้ำได้", "warning");
              }

              up.start();
            }
          },

          // BeforeUpload: function(up, file) {
          //   check_object_radio();
          //   set_upload_param(up, file.name, true);
          // },

          UploadProgress: function UploadProgress(up, file) {
            // console.log("UploadProgress");
            // console.log(file);
            document.getElementById(file.id).getElementsByTagName("b")[0].innerHTML = "<span>" + file.percent + "%</span>";
            $("#myBar" + file.id + " .progress-bar .bg-success").css("width", file.percent - 1 + "%");
          },

          FileUploaded: function FileUploaded(up, file, info) {
            // console.log("FileUploaded");
            if (info.response == "OK") {
              // console.log("OK");
              var $uploadBtn = $(up.settings.browse_button[0]);
              var $imageContainer = $("#container-file" + self.uuid);
              var $img = $("div[data-file-id=" + file.id + "]");
              $img.attr("data-file-uploaded", "true");
              //var url = Setting.rootPath + "Api/File/MoveFile";
              var url = "/Api/File/MoveFile";
              var ref = $("#uploader-order" + self.uuid).data("ref");
              $.ajax({
                url: url,
                type: "post",
                data: {
                  FileID: $img.data("file-id"),
                  FileName: $img.data("file-name"),
                  Reference: ref
                },
                datatype: "json",
                ContentType: "application/json;utf-8"
              }).done(function (data) {
                // console.log("done");
                var File = {
                  FileID: data.fileName,
                  FileName: file.name,
                  FileDescription: null
                };
                self.File.push(File);

                /*ถ้าสำเร็จให้ทำอะไรต่อ */
                $("#myBar" + file.id).remove();
                // $(
                //   '<div id="myBar' +
                //     //file.id +
                //     '" class="progress-bar bg-success" style="width:100%"><b>100%</b></div >'
                // ).appendTo($(".progress" + file.id));

                $('<a href="javascript:;" style="position:absolute;top: 20px;right: 20px;padding-left: 5px;padding-top: 0px;padding-right: 5px;padding-bottom: 0px;" class="btn m-btn--pill btn-danger m-btn btm-remove-img-beerclaim close" data-file-newid="' + data.fileName + '" data-file-id="' + file.id + '" ><span class="m--font-inverse-danger la la-trash"></span></a>').appendTo("#" + data.fileID);

                $('<div id="newid" data-file-newid="' + data.fileName + '"></div>').appendTo("#" + data.fileID);

                // $("#" + file.id).removeClass(
                //   "kt-spinner kt-spinner--lg kt-spinner--warning"
                // );

                $("#" + file.id).add;
              });
            }
          },

          Error: function Error(up, err) {
            // console.log("Error");
            // console.log(err.file.id);
            $("#myBar" + err.file.id).remove();
            $('<div id="myBar' + err.file.id + '" class="myBar" style="background-color:red;width:100%"><b>false</b></div >').appendTo($(".progress" + err.file.id));
            $("#" + err.file.id).removeClass("kt-spinner kt-spinner--lg kt-spinner--warning");
            var a = $('<a class="btn m-btn--pill btn-info m-btn btm-reload-img-beerclaim"><span class="fas fa-redo-alt"></span></a>');
            a.appendTo("#" + err.file.id);
            a.data("up", up);
            a.data("file", err.file);
            a.click(function () {
              var $this = $(this);
              var myUp = $this.data("up");
              var myFile = $this.data("file");
              myFile.status = __WEBPACK_IMPORTED_MODULE_1_plupload___default.a.QUEUED;
              $("#" + myFile.id).remove();
              myUp.addFile(myFile);
            });
            var d = $('<a class="btn m-btn--pill btn-danger m-btn btm-delete-img-beerclaim" style="position:absolute;top:10px;right:20px;"><span class="far fa-trash-alt"></span></a>');
            d.appendTo("#" + err.file.id);
            d.click(function () {
              $("#" + err.file.id).remove();
            });
          }
        }
      });
      uploader.init();
    }
  },
  mounted: function mounted() {
    var self = this;

    self.initPlUploader();
    self.deleteImg();

    //กรณี ส่งผลการวิเคราะห์
    // if (
    //   self.$parent.data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_SPECIFY"
    // ) {
    //   //console.log(self.$parent.data.claimItemId);
    //   //console.log(self.$parent.data.labResult);
    //   self.labResult = self.$parent.data.labResult;
    //   self.title = "ส่งผลการวิเคราะห์";
    //   self.isEdit = false;
    //   self.bnt = "ยืนยัน";
    // }

    $(self.$refs.form).validate({
      rules: {
        labResult: "required"
      },
      messages: {
        labResult: "กรุณากรอกผลแลบ"
      }
    });

    $(self.$el).on("hidden.bs.modal", function () {
      $(self.$refs.labResult).val("").trigger("change");
    });
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      maxLength: 220,
      abcClaimTypeCode: null,
      abcAgentCode: null,
      abcShopCode: null,
      abcAmpher: null,
      abcProvince: null,
      abcPhone: null,
      abcClaimItems: [],
      requiredRejectedReasonCode: false,
      requiredReasonOther: false,
      index: 0,
      abcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2AgentData",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopData",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcRejectedReasonOptions: {
        placeholder: "กรุณาเลือกสาเหตุที่ไม่อนุมัติการเคลม",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "REJECTED_REASON",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    SelectClaimItems: function SelectClaimItems(value, isApprove) {
      var self = this;
      if (value == "All") {
        self.abcClaimItems.forEach(function (e) {
          e.IsSelectApprove = document.getElementById("myCheck").checked;
        });
      } else {
        document.getElementById("myCheck").checked = false;
        var data = self.abcClaimItems.filter(function (o) {
          return o.claimItemId == value;
        });
        // self.abcClaimItems.filter(
        //   (o) => o.claimItemId == value
        // )[0].IsSelectApprove = !data[0].IsSelectApprove
        if (data != null) {
          //console.log("data ", data);
          //console.log("type ", data[0].problemTypeCode);
          //ถังชำรุด
          if (data[0].problemTypeCode == "PROBLEM_TYPE_DAMAGED_TANK") {
            if (isApprove == false) {
              //set required
              self.requiredRejectedReasonCode = true;
              self.requiredReasonOther = false;

              data[0].showRejectedReasonCode = true;
              data[0].reasonOther = null;
            } else {
              //set required
              self.requiredReasonOther = true;

              data[0].showRejectedReasonCode = false;
              data[0].rejectedReasonCode = null;
              data[0].reasonOther = null;

              $("#rejectedReasonCode0").val("").trigger("change");
            }
            //console.log("ถังชำรุด");
          }
          //รสชาติ, กลิ่น, สี, ฟอง ผิดปกติ
          else if (data[0].problemTypeCode == "PROBLEM_TYPE_UNUSUAL_TASTE") {
              //set required
              self.requiredRejectedReasonCode = false;
              self.requiredReasonOther = true;
              //console.log("รสชาติ");


              if (isApprove == false) {
                //set required
                self.requiredRejectedReasonCode = true;
                self.requiredReasonOther = false;

                data[0].showRejectedReasonCode = true;
                data[0].reasonOther = null;
              } else {
                //set required
                self.requiredReasonOther = true;

                data[0].showRejectedReasonCode = false;
                data[0].rejectedReasonCode = null;
                data[0].reasonOther = null;

                $("#rejectedReasonCode0").val("").trigger("change");
              }
            }
        }
        //console.log("data ", data);
      }
    },
    onRejectedReasonCodeChange: function onRejectedReasonCodeChange(id, text, data, ref) {
      var self = this;
      //console.log("text", text);
      if (text == "REJECTED_REASON_OTHER") {
        self.requiredReasonOther = true;
      } else {
        //reset val
        self.abcClaimItems[0].reasonOther = null;
      }
    },
    formSubmit: function formSubmit(e) {
      var _this = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var self = this;
      var cItems = [];

      var selectData = self.abcClaimItems.filter(function (o) {
        return o.IsSelectApprove == null;
      });

      if (selectData.length > 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกผลการอนุมัติเคลม", "error");
      } else {
        self.abcClaimItems.forEach(function (element) {
          cItems.push({
            IsSelectApprove: element.IsSelectApprove == "true" ? true : element.IsSelectApprove == true ? true : false,
            ClaimItemId: element.claimItemId,
            ReasonCode: element.rejectedReasonCode,
            ReasonOther: element.reasonOther
          });
        });

        //console.log("cItems ", cItems);
        Swal.fire({
          title: "รายการที่เลือกอนุมัติการเคลมทั้งหมด " + cItems.filter(function (o) {
            return o.IsSelectApprove == true;
          }).length + " รายการ",
          type: "warning",
          html: "กรุณายืนยันรายการเคลมที่อนุมัติ<strong>" + "</strong>",
          inputValue: 0,
          inputPlaceholder: "รายการอนุมัติการเคลม",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            KTApp.blockPage({
              opacity: 0.05,
              message: "กำลังเปลี่ยนสถานะเบียร์เคลม กรุณารอสักครู่..."
            });
            var router = _this.$router;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BeerClaim/Approve", {
              BeerClaimItems: cItems,
              ClaimId: _this.$route.params.id
            }).then(function (response) {
              if (response.data.status) {
                KTApp.unblockPage();
                Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                  router.go(-1), self.$parent.reloadDataTable(false);
                });
              } else {
                //console.log(response);
                var msg = response.data.message;
                var start = msg.indexOf("||");
                var end = msg.lastIndexOf("||");
                if (start >= 0) {
                  var str = msg.substr(start + 2, end - start - 2);
                  var oldStr = msg.substr(start, end - start + 2);
                  // console.log(start);
                  // console.log(end);
                  // console.log(str);
                  // console.log(oldStr);
                  var repl = "<strong class='text-danger'>" + str + "</strong>";
                  msg = msg.replace(oldStr, repl);
                }

                Swal.fire("เกิดข้อผิดพลาด", msg, "error");
              }
            }).catch(function (error) {
              var msg = response.data.message;
              var start = msg.indexOf("||");
              var end = msg.lastIndexOf("||");
              if (start >= 0) {
                var str = msg.substr(start + 2, end - start - 2);
                var oldStr = msg.substr(start, end - start + 2);
                // console.log(start);
                // console.log(end);
                // console.log(str);
                // console.log(oldStr);
                var repl = "<strong class='text-danger'>" + str + "</strong>";
                msg = msg.replace(oldStr, repl);
              }

              Swal.fire("เกิดข้อผิดพลาด", msg, "error");
            }).then(function () {
              // always executed
              KTApp.unblockPage();
            });
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;
              router = _this2.$router;


              $("#myCheck").click(function (e) {
                $(this).closest("table").find("td input:checkbox").prop("checked", this.checked);
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BeerClaim/" + _this2.$route.params.id).then(function (response) {
                //console.log(response);
                if (response.status == 200) {
                  setTimeout(function () {
                    if (response.data.claimTypeCode) {
                      self.$refs.abcClaimTypeCodeSelect2.setSelectedData({
                        id: response.data.claimTypeCode,
                        text: response.data.claimTypeName
                      });
                    }
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimAgentCode) {
                      self.$refs.abcAgentCodeSelect2.setSelectedData({
                        id: response.data.claimAgentCode,
                        text: response.data.claimAgentName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimShopCode) {
                      self.$refs.abcShopCodeSelect2.setSelectedData({
                        id: response.data.claimShopCode,
                        text: response.data.claimShopName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                  }, 100);

                  //#region :: set beerClaimItems
                  setTimeout(function () {
                    if (response.data.beerClaimItems) {
                      response.data.beerClaimItems.filter(function (o) {
                        return o.claimStatusCode == "CLAIM_STATUS_WARE_DELIVER" || o.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_APPROVE";
                      }).forEach(function (b) {
                        //console.log("b ", b);
                        setTimeout(function () {
                          self.abcClaimItems.push({
                            productBrandId: b.productBrandId,
                            productBrand: b.productBrandName,
                            materialCode: b.materialCode,
                            material: b.materialName,
                            barcode: b.barcodeNumber,
                            barcodeOld: b.barcodeNumberOld,
                            departmentMaterialCode: b.departmentMaterialCode,
                            manufacturingDate: b.manufacturingDateFormat ? moment(b.manufacturingDateFormat, "DD/MM/YYYY") : null,
                            weight: b.weight,
                            problemTypeCode: b.problemTypeCode,
                            problemType: b.problemTypeName,
                            problemDesc: b.problemDesc,
                            machineTypeCode: b.machineTypeCode,
                            machineType: b.machineTypeName,
                            machineBarcode: b.machineBarcodeNumber,
                            machineCategory: b.machineCategory,
                            pressure: b.pressure,
                            temperature: b.temperature,
                            pmDate: b.pmDateFormat ? moment(b.pmDateFormat) : null,
                            jumpDate: b.jumpDateFormat ? moment(b.jumpDateFormat) : null,
                            standardInstallCode: b.standardInstallCode,
                            standardInstall: b.standardInstallName,
                            claimStatusCode: b.claimStatusCode,
                            claimItemId: b.claimItemId,
                            agentReceivedDate: b.agentReceivedDateFormat ? moment(b.agentReceivedDateFormat, "DD/MM/YYYY") : null,
                            shopReceivedDate: b.shopReceivedDateFormat ? moment(b.shopReceivedDateFormat, "DD/MM/YYYY") : null,
                            invoice: b.invoice,
                            IsSelectApprove: b.preApproveStatus != null ? b.preApproveStatus : null,
                            showRejectedReasonCode: b.preApproveStatus != null ? !b.preApproveStatus : false,
                            rejectedReasonCode: b.preRejectedReasonCode != null ? b.preRejectedReasonCode : null,
                            rejectedReasonName: b.preRejectedReasonName != null ? b.preRejectedReasonName : null,
                            reasonOther: b.preRejectedReasonCode != null && b.preRejectedReasonCode == "REJECTED_REASON_OTHER" ? b.preRejectedReasonOther : null,
                            labResult: b.labResult,
                            causedByExternalFactor: b.causedByExternalFactor,
                            causedByInternalFactor: b.causedByInternalFactor
                          });
                          self.index += 1;

                          //set required
                          if (b.preApproveStatus != null && b.preApproveStatus) {
                            self.requiredReasonOther = true;
                          }

                          if (b.problemTypeCode == "PROBLEM_TYPE_UNUSUAL_TASTE") {
                            self.requiredReasonOther = true;
                          }

                          setTimeout(function () {
                            //console.log("x", self.abcClaimItems.length);
                            for (var i = 0; i < self.abcClaimItems.length; i++) {
                              //console.log("xx", self.$refs);
                              if (self.abcClaimItems[i].rejectedReasonCode) {
                                self.$refs.rejectedReasonCodeSelect2[i].setSelectedData({
                                  id: self.abcClaimItems[i].rejectedReasonCode,
                                  text: self.abcClaimItems[i].rejectedReasonName
                                });
                              }
                            }
                          }, 50);
                        }, 50);
                      });
                      //console.log("list edit ", self.abcClaimItems);
                    }
                  }, 100);
                  //#endregion :: set beerClaimItems
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลเบียร์เคลมที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลเบียร์เคลมได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              // set validation rules
              $(self.$refs.form).validate({
                rules: {
                  rejectedReasonCode: "required"
                },
                messages: {
                  rejectedReasonCode: "กรุณาเลือกสาเหตุที่ไม่อนุมัติการเคลม"
                }
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      isEdit: false,
      abcClaimTypeCode: null,
      abcAgentCode: null,
      abcShopCode: null,
      abcAmpher: null,
      abcProvince: null,
      abcPhone: null,
      abcClaimItems: [],
      index: 0,

      // Configurations
      abcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2AgentData",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopData",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    onAgentCodeChange: function onAgentCodeChange(id, text, data, ref) {
      var self = this;
      //console.log("data agent ", data);
      if (data[0].data) {
        self.abcAmpher = data[0].data.ampherName;
        self.abcProvince = data[0].data.provinceName;
        self.abcPhone = data[0].data.phone;
      }
    },
    onShopCodeChange: function onShopCodeChange(id, text, data, ref) {
      var self = this;
      //console.log("data shop ", data);
      if (data[0].data) {
        self.abcAmpher = data[0].data.ampherName;
        self.abcProvince = data[0].data.provinceName;
        self.abcPhone = data[0].data.phone;
      }
    },
    onClaimTypeCodeChange: function onClaimTypeCodeChange() {
      var self = this;
      self.abcAmpher = null;
      self.abcProvince = null;
      self.abcPhone = null;
      self.abcAgentCode = null;
      self.abcShopCode = null;
      self.abcClaimItems = [];
    },
    onDetailItemClick: function onDetailItemClick(index) {
      var router = this.$router;
      var item = this.abcClaimItems[index];
      //console.log("list " ,this.abcClaimItems[index]);
      router.push({
        path: "/BeerClaim/Claim/Detail/" + this.$route.params.id + "/ClaimItem/" + index
      });
    },
    handleBackButton: function handleBackButton(event) {
      var modalBackdrops = document.querySelectorAll('.modal-backdrop');
      modalBackdrops.forEach(function (modalBackdrop) {
        modalBackdrop.remove();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              window.addEventListener('popstate', _this.handleBackButton);

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BeerClaim/" + _this.$route.params.id).then(function (response) {
                //console.log(response);
                if (response.status == 200) {
                  setTimeout(function () {
                    if (response.data.claimTypeCode) {
                      self.$refs.abcClaimTypeCodeSelect2.setSelectedData({
                        id: response.data.claimTypeCode,
                        text: response.data.claimTypeName
                      });
                    }
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimAgentCode) {
                      self.$refs.abcAgentCodeSelect2.setSelectedData({
                        id: response.data.claimAgentCode,
                        text: response.data.claimAgentName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimShopCode) {
                      self.$refs.abcShopCodeSelect2.setSelectedData({
                        id: response.data.claimShopCode,
                        text: response.data.claimShopName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                  }, 100);

                  //#region :: set beerClaimItems
                  setTimeout(function () {
                    if (response.data.beerClaimItems) {
                      response.data.beerClaimItems.forEach(function (b) {
                        //console.log("b ", b);
                        self.abcClaimItems.push({
                          productBrandId: b.productBrandId,
                          productBrand: b.productBrandName,
                          materialCode: b.materialCode,
                          material: b.materialName,
                          depCode: b.departmentMaterialCode,
                          barcodeOld: b.barcodeNumberOld,
                          manufacturingDate: b.manufacturingDateFormat ? moment(b.manufacturingDateFormat, "DD/MM/YYYY") : null,
                          weight: b.weight,
                          problemTypeCode: b.problemTypeCode,
                          problemType: b.problemTypeName,
                          problemDesc: b.problemDesc,
                          machineTypeCode: b.machineTypeCode,
                          machineType: b.machineTypeName,
                          machineBarcode: b.machineDepartmentMaterialCode ? b.machineBarcodeNumberOld + "(" + b.machineDepartmentMaterialCode + ")" : b.machineBarcodeNumberOld,
                          machineCategory: b.machineCategory,
                          pressure: b.pressure,
                          temperature: b.temperature,
                          pmDate: b.pmDateFormat ? moment(b.pmDateFormat, "DD/MM/YYYY") : null,
                          jumpDate: b.jumpDateFormat ? moment(b.jumpDateFormat, "DD/MM/YYYY") : null,
                          standardInstallCode: b.standardInstallCode,
                          standardInstall: b.standardInstallName,
                          claimStatusCode: b.claimStatusCode,
                          claimItemId: b.claimItemId,
                          agentReceivedDate: b.agentReceivedDateFormat ? moment(b.agentReceivedDateFormat, "DD/MM/YYYY") : null,
                          shopReceivedDate: b.shopReceivedDateFormat ? moment(b.shopReceivedDateFormat, "DD/MM/YYYY") : null,
                          invoice: b.invoice,
                          claimItemPicture: b.claimItemPicture
                        });
                        self.index += 1;
                      });
                      //console.log("list edit ", self.abcClaimItems);
                    }
                  }, 100);
                  //#endregion :: set beerClaimItems
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลเบียร์เคลมที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลเบียร์เคลมได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  destroyed: function destroyed() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              window.removeEventListener('popstate', _this2.handleBackButton);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      uploadFiles: [],
      modalImageURL: '',
      isEdit: false,
      bciProductBrandId: null,
      bciProductBrand: null,
      bciMaterialCode: null,
      bciMaterial: null,
      bciBarcode: null,
      bciManufacturingDate: null,
      bciWeight: 0,
      bciProblemTypeCode: null,
      bciProblemType: null,
      bciProblemDesc: null,
      bciMachineTypeCode: null,
      bciMachineType: null,
      bciMachineBarcode: null,
      bciMachineCategory: null,
      bciPressure: null,
      bciTemperature: null,
      bciPMDate: null,
      bciJumpDate: null,
      bciStandardInstallCode: null,
      bciStandardInstall: null,
      bciAgentReceivedDate: null,
      bciShopReceivedDate: null,
      bciInvoice: null,
      //Options
      bciMachineTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "MACHINE_TYPE",
              keySearch: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      bciStandardInstallCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "STANDARD_INSTALL",
              keySearch: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      bciProblemTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "PROBLEM_TYPE",
              keySearch: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      bciMachineCategoryOptions: {
        placeholder: "กรุณาเลือกประเภทเครื่องเบียร์สด",
        allowClear: true,
        data: [{ id: "false", text: "ไม่มีหัวจ่ายในตัว", data: null }, { id: "true", text: "มีหัวจ่ายในตัว", data: null }]
      },
      //เฉพาะ หมวดหมู่ สินค้าสำเร็จรูป + ประเภท น้ำเบียร์
      bciMaterialCodeOptions: {
        placeholder: "เลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              productGroupId: "14",
              productTypeId: "22",
              onlyHasBarcode: true
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    showModal: function showModal(imageURL) {
      this.modalImageURL = imageURL;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', function () {
        $('body').addClass('modal-open');
      });
    },
    closeModal: function closeModal() {
      $('#imageModal').modal('hide');
    },

    onMaterialCodeChange: function onMaterialCodeChange(id, text, data, ref) {
      var self = this;
      //console.log(data);
      //set product name
      if (data[0] && data[0].text) {
        self.bciMaterial = data[0].text;
      }
      //set brand
      if (data[0] && data[0].data) {
        self.bciProductBrandId = data[0].data.productBrandId;
        self.bciProductBrand = data[0].data.productBrandName;
        //console.log("bciProductBrandId ", self.bciProductBrandId);
      }
    },
    onProblemTypeCodeChange: function onProblemTypeCodeChange(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciProblemType = data[0].text;
    },
    onMachineTypeCodeChange: function onMachineTypeCodeChange(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciMachineType = data[0].text;
    },
    onStandardInstallCodeChange: function onStandardInstallCodeChange(id, text, data, ref) {
      var self = this;
      //set name
      if (data[0] && data[0].text) self.bciStandardInstall = data[0].text;
    },
    onBlurBarcode: function onBlurBarcode(isMachine) {
      var self = this;
      // console.log(isMachine);
      // console.log("bciMachineBarcode", self.bciMachineBarcode);
      // console.log("bciBarcode", self.bciBarcode);
      var barcode = isMachine ? self.bciMachineBarcode : self.bciBarcode;
      if (barcode != null) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BeerClaim/BarcodeData", {
          BarcodeNO: isMachine ? self.bciMachineBarcode : self.bciBarcode,
          IsMachine: isMachine
        }).then(function (response) {
          //console.log("response", response);
          if (response.status == 200) {
            if (isMachine) {
              self.$refs.bciMachineCategorySelect2.setSelectedData({
                id: response.data.machineCategory + ""
              });
              if (response.data.pmDateFormat) {
                self.bciPMDate = moment(response.data.pmDateFormat, "DD/MM/YYYY");
                $(self.$refs.bciPMDate).datepicker("update", response.data.pmDateFormat2);
              }
            } else {
              if (response.data.manufacturingDateFormat) {
                self.bciManufacturingDate = moment(response.data.manufacturingDateFormat, "DD/MM/YYYY");
                $(self.$refs.bciManufacturingDate).datepicker("update", response.data.manufacturingDateFormat2);
              }
            }
          } else {
            if (isMachine) {
              self.$refs.bciMachineCategorySelect2.setSelectedData({
                id: null
              });
              self.bciPMDate = null;
              $(self.$refs.bciPMDate).datepicker("update", null);
            } else {
              self.bciManufacturingDate = null;
              $(self.$refs.bciManufacturingDate).datepicker("update", null);
            }
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, user, arrows, index, loadPictures, claim, manufacturingDate, agentReceivedDate, shopReceivedDate, jumpDate, pmDate;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context2.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context2.sent;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.bciManufacturingDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.bciManufacturingDate).datepicker("update", !!self.bciManufacturingDate ? self.bciManufacturingDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bciManufacturingDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.bciPMDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.bciPMDate).datepicker("update", !!self.bciPMDate ? self.bciPMDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bciPMDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.bciJumpDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.bciJumpDate).datepicker("update", !!self.bciJumpDate ? self.bciJumpDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bciJumpDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.bciAgentReceivedDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.bciAgentReceivedDate).datepicker("update", !!self.bciAgentReceivedDate ? self.bciAgentReceivedDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bciAgentReceivedDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.bciShopReceivedDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.bciShopReceivedDate).datepicker("update", !!self.bciShopReceivedDate ? self.bciShopReceivedDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bciShopReceivedDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              //#region :: Set Value
              index = _this.$route.params.id;
              //console.log("index ", index);

              if (!index.includes("add_")) {
                loadPictures = function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var i, element;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            for (i = 0; i < self.claimItemPicture.length; i++) {
                              element = self.claimItemPicture[i];

                              self.uploadFiles.push({
                                fileURL: element.fileData
                              });
                            }

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));

                  return function loadPictures() {
                    return _ref.apply(this, arguments);
                  };
                }();

                claim = self.$parent.abcClaimItems[index];
                //console.log("claim mounted ", claim);

                //#region :: รายละเอียด สินค้าเบียร์สด

                self.bciProductBrand = claim.productBrand;
                self.bciProductBrandId = claim.productBrandId;

                setTimeout(function () {
                  if (claim.materialCode) {
                    self.$refs.bciMaterialCodeSelect2.setSelectedData({
                      id: claim.materialCode,
                      text: claim.material
                    });
                  }
                }, 100);

                if (claim.manufacturingDate) {
                  manufacturingDate = moment(claim.manufacturingDate);

                  self.bciManufacturingDate = manufacturingDate;
                  $(self.$refs.bciManufacturingDate).datepicker("update", manufacturingDate.format("DD-MM-YYYY"));
                }

                if (claim.agentReceivedDate) {
                  agentReceivedDate = moment(claim.agentReceivedDate);

                  self.bciAgentReceivedDate = agentReceivedDate;
                  $(self.$refs.bciAgentReceivedDate).datepicker("update", agentReceivedDate.format("DD-MM-YYYY"));
                }

                if (claim.shopReceivedDate) {
                  shopReceivedDate = moment(claim.shopReceivedDate);

                  self.bciShopReceivedDate = shopReceivedDate;
                  // console.log("shopReceivedDate ", shopReceivedDate);
                  $(self.$refs.bciShopReceivedDate).datepicker("update", shopReceivedDate.format("DD-MM-YYYY"));
                }

                self.bciBarcode = claim.depCode ? claim.barcodeOld + "(" + claim.depCode + ")" : claim.barcodeOld;
                self.bciWeight = claim.weight;
                self.bciInvoice = claim.invoice;
                //#endregion :: รายละเอียด สินค้าเบียร์สด

                //#region :: รายละเอียด ปัญหาที่พบ
                if (claim.problemTypeCode) {
                  self.$refs.bciProblemTypeCodeSelect2.setSelectedData({
                    id: claim.problemTypeCode,
                    text: claim.problemType
                  });
                }
                self.bciProblemDesc = claim.problemDesc;
                //#endregion :: รายละเอียด ปัญหาที่พบ

                self.claimItemPicture = claim.claimItemPicture;

                loadPictures();
                //#region :: รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ
                self.bciMachineBarcode = claim.machineBarcode;
                self.bciPressure = claim.pressure;
                self.bciTemperature = claim.temperature;

                if (claim.machineTypeCode) {
                  self.$refs.bciMachineTypeCodeSelect2.setSelectedData({
                    id: claim.machineTypeCode,
                    text: claim.machineType
                  });
                }

                self.$refs.bciMachineCategorySelect2.setSelectedData({
                  id: claim.machineCategory + ""
                });

                if (claim.jumpDate) {
                  jumpDate = moment(claim.jumpDate);

                  self.bciJumpDate = jumpDate;
                  $(self.$refs.bciJumpDate).datepicker("update", jumpDate.format("DD-MM-YYYY"));
                }

                if (claim.pmDate) {
                  pmDate = moment(claim.pmDate);

                  self.bciPMDate = pmDate;
                  $(self.$refs.bciPMDate).datepicker("update", pmDate.format("DD-MM-YYYY"));
                }
                //#endregion :: รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ

                //#region :: รายละเอียด การใช้งาน และการบำรุงรักษา
                if (claim.standardInstallCode) {
                  self.$refs.bciStandardInstallCodeSelect2.setSelectedData({
                    id: claim.standardInstallCode,
                    text: claim.standardInstall
                  });
                }
                //#endregion :: รายละเอียด การใช้งาน และการบำรุงรักษา
              }
              //#endregion :: Set Value

              $("#addClaimItemModal").on("hidden.bs.modal", function (e) {
                if (e.target.id && e.target.id == 'addClaimItemModal') {
                  router.go(-1);
                }
              }).modal("show");

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      abcClaimTypeCode: null,
      abcAgentCode: null,
      abcShopCode: null,
      abcAmpher: null,
      abcProvince: null,
      abcPhone: null,
      abcClaimItems: [],
      index: 0,
      abcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2AgentData",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopData",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    SelectClaimItems: function SelectClaimItems(value) {
      var self = this;
      if (value == "All") {
        self.abcClaimItems.forEach(function (e) {
          e.IsSelectCommit = document.getElementById("myCheck").checked;
        });
      } else {
        document.getElementById("myCheck").checked = false;
        var data = self.abcClaimItems.filter(function (o) {
          return o.claimItemId == value;
        });
        self.abcClaimItems.filter(function (o) {
          return o.claimItemId == value;
        })[0].IsSelectCommit = !data[0].IsSelectCommit;
      }
    },
    formSubmit: function formSubmit(e) {
      var _this = this;

      var self = this;
      var cItems = [];

      self.abcClaimItems.forEach(function (element) {
        cItems.push({
          MaterialCode: element.materialCode,
          Barcode: element.barcode,
          IsSelectCommit: element.IsSelectCommit == "true" ? true : element.IsSelectCommit == true ? true : false,
          ClaimItemId: element.claimItemId
        });
      });
      Swal.fire({
        title: "รายการที่เลือกส่งเคลมทั้งหมด " + cItems.filter(function (o) {
          return o.IsSelectCommit == true;
        }).length + " รายการ",
        type: "warning",
        html: "กรุณายืนยันรายการเครมที่สามารถส่งเครมได้ <strong>" + "</strong>",
        inputValue: 0,
        inputPlaceholder: "รายการเครมที่สามารถส่งเครมได้",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังเปลี่ยนสถานะเบียร์เคลม กรุณารอสักครู่..."
          });
          var router = _this.$router;

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BeerClaim/Commit", {
            BeerClaimItems: cItems,
            ClaimId: _this.$route.params.id
          }).then(function (response) {
            if (response.data.status) {
              KTApp.unblockPage();
              Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                router.go(-1), self.$parent.reloadDataTable(false);
              });
            } else {
              //console.log(response);
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;
              router = _this2.$router;


              $("#myCheck").click(function (e) {
                $(this).closest("table").find("td input:checkbox").prop("checked", this.checked);
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BeerClaim/" + _this2.$route.params.id).then(function (response) {
                //console.log(response);
                if (response.status == 200) {
                  setTimeout(function () {
                    if (response.data.claimTypeCode) {
                      self.$refs.abcClaimTypeCodeSelect2.setSelectedData({
                        id: response.data.claimTypeCode,
                        text: response.data.claimTypeName
                      });
                    }
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimAgentCode) {
                      self.$refs.abcAgentCodeSelect2.setSelectedData({
                        id: response.data.claimAgentCode,
                        text: response.data.claimAgentName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimShopCode) {
                      self.$refs.abcShopCodeSelect2.setSelectedData({
                        id: response.data.claimShopCode,
                        text: response.data.claimShopName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                  }, 100);

                  //#region :: set beerClaimItems
                  setTimeout(function () {
                    if (response.data.beerClaimItems) {
                      response.data.beerClaimItems.filter(function (o) {
                        return o.claimStatusCode == "CLAIM_STATUS_QI_INSPECT";
                      }).forEach(function (b) {
                        //console.log("b ", b);
                        self.abcClaimItems.push({
                          productBrandId: b.productBrandId,
                          productBrand: b.productBrandName,
                          materialCode: b.materialCode,
                          material: b.materialName,
                          barcode: b.barcodeNumber,
                          barcodeOld: b.barcodeNumberOld,
                          departmentMaterialCode: b.departmentMaterialCode,
                          manufacturingDate: b.manufacturingDateFormat ? moment(b.manufacturingDateFormat, "DD/MM/YYYY") : null,
                          weight: b.weight,
                          problemTypeCode: b.problemTypeCode,
                          problemType: b.problemTypeName,
                          problemDesc: b.problemDesc,
                          machineTypeCode: b.machineTypeCode,
                          machineType: b.machineTypeName,
                          machineBarcode: b.machineBarcodeNumber,
                          machineCategory: b.machineCategory,
                          pressure: b.pressure,
                          temperature: b.temperature,
                          pmDate: b.pmDateFormat ? moment(b.pmDateFormat) : null,
                          jumpDate: b.jumpDateFormat ? moment(b.jumpDateFormat) : null,
                          standardInstallCode: b.standardInstallCode,
                          standardInstall: b.standardInstallName,
                          claimStatusCode: b.claimStatusCode,
                          claimItemId: b.claimItemId,
                          agentReceivedDate: b.agentReceivedDateFormat ? moment(b.agentReceivedDateFormat, "DD/MM/YYYY") : null,
                          shopReceivedDate: b.shopReceivedDateFormat ? moment(b.shopReceivedDateFormat, "DD/MM/YYYY") : null,
                          invoice: b.invoice,
                          IsSelectCommit: false
                        });
                        self.index += 1;
                      });
                      //console.log("list edit ", self.abcClaimItems);
                    }
                  }, 100);
                  //#endregion :: set beerClaimItems
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลเบียร์เคลมที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลเบียร์เคลมได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_currency_input__ = __webpack_require__(79);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_currency_input__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      locale: "th",
      currency: "THB",
      abcClaimTypeCode: null,
      abcAgentCode: null,
      abcShopCode: null,
      abcAmpher: null,
      abcProvince: null,
      abcPhone: null,
      abcClaimItems: [],
      index: 0,
      abcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2AgentData",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopData",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      var _this = this;

      var self = this;
      var cItems = [];
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      self.abcClaimItems.forEach(function (element) {
        cItems.push({
          IsSelectApprove: element.IsSelectApprove == "true" ? true : element.IsSelectApprove == true ? true : false,
          ClaimItemId: element.claimItemId,
          ClaimPrice: element.claimPrice
        });
      });
      Swal.fire({
        title: "รายการที่เลือกสรุปผลการอนุมัติและชดเชยทั้งหมด " + cItems.filter(function (o) {
          return o.IsSelectApprove == true;
        }).length + " รายการ",
        type: "warning",
        html: "กรุณายืนยันรายการเคลมที่สรุปผลการอนุมัติและชดเชย<strong>" + "</strong>",
        inputValue: 0,
        inputPlaceholder: "รายการสรุปผลการอนุมัติและชดเชย",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังเปลี่ยนสถานะเบียร์เคลม กรุณารอสักครู่..."
          });
          var router = _this.$router;

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BeerClaim/Conclude", {
            BeerClaimItems: cItems,
            ClaimId: _this.$route.params.id
          }).then(function (response) {
            if (response.data.status) {
              KTApp.unblockPage();
              Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                router.go(-1), self.$parent.reloadDataTable(false);
              });
            } else {
              //console.log(response);
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            //console.log(error);
            Swal.fire("เกิดข้อผิดพลาด", error.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;
              router = _this2.$router;


              $("#myCheck").click(function (e) {
                $(this).closest("table").find("td input:checkbox").prop("checked", this.checked);
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BeerClaim/" + _this2.$route.params.id).then(function (response) {
                //console.log(response);
                if (response.status == 200) {
                  setTimeout(function () {
                    if (response.data.claimTypeCode) {
                      self.$refs.abcClaimTypeCodeSelect2.setSelectedData({
                        id: response.data.claimTypeCode,
                        text: response.data.claimTypeName
                      });
                    }
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimAgentCode) {
                      self.$refs.abcAgentCodeSelect2.setSelectedData({
                        id: response.data.claimAgentCode,
                        text: response.data.claimAgentName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimShopCode) {
                      self.$refs.abcShopCodeSelect2.setSelectedData({
                        id: response.data.claimShopCode,
                        text: response.data.claimShopName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                  }, 100);

                  //#region :: set beerClaimItems
                  setTimeout(function () {
                    if (response.data.beerClaimItems) {
                      response.data.beerClaimItems.filter(function (o) {
                        return o.claimStatusCode == "CLAIM_STATUS_APPROVE" || o.claimStatusCode == "CLAIM_STATUS_REJECT";
                      }).forEach(function (b) {
                        var _self$abcClaimItems$p;

                        //console.log("b ", b);
                        self.abcClaimItems.push((_self$abcClaimItems$p = {
                          productBrandId: b.productBrandId,
                          productBrand: b.productBrandName,
                          materialCode: b.materialCode,
                          material: b.materialName,
                          barcode: b.barcodeNumber,
                          barcodeOld: b.barcodeNumberOld,
                          departmentMaterialCode: b.departmentMaterialCode,
                          manufacturingDate: b.manufacturingDateFormat ? moment(b.manufacturingDateFormat, "DD/MM/YYYY") : null,
                          weight: b.weight,
                          problemTypeCode: b.problemTypeCode,
                          problemType: b.problemTypeName,
                          problemDesc: b.problemDesc,
                          machineTypeCode: b.machineTypeCode,
                          machineType: b.machineTypeName,
                          machineBarcode: b.machineBarcodeNumber,
                          machineCategory: b.machineCategory,
                          pressure: b.pressure,
                          temperature: b.temperature,
                          pmDate: b.pmDateFormat ? moment(b.pmDateFormat) : null,
                          jumpDate: b.jumpDateFormat ? moment(b.jumpDateFormat) : null,
                          standardInstallCode: b.standardInstallCode,
                          standardInstall: b.standardInstallName,
                          claimStatusCode: b.claimStatusCode,
                          claimItemId: b.claimItemId,
                          agentReceivedDate: b.agentReceivedDateFormat ? moment(b.agentReceivedDateFormat, "DD/MM/YYYY") : null,
                          shopReceivedDate: b.shopReceivedDateFormat ? moment(b.shopReceivedDateFormat, "DD/MM/YYYY") : null,
                          invoice: b.invoice,
                          IsSelectApprove: b.claimStatusCode == "CLAIM_STATUS_APPROVE" ? true : false
                        }, _defineProperty(_self$abcClaimItems$p, "claimStatusCode", b.claimStatusCode), _defineProperty(_self$abcClaimItems$p, "claimPrice", null), _defineProperty(_self$abcClaimItems$p, "approveStatus", b.approveStatus), _defineProperty(_self$abcClaimItems$p, "reason", b.rejectedReasonName != null ? b.rejectedReasonCode == "REJECTED_REASON_OTHER" ? "(" + b.rejectedReasonName + ") " + b.reasonOther : b.rejectedReasonName : b.reasonOther), _self$abcClaimItems$p));
                        self.index += 1;
                      });
                      //console.log("list edit ", self.abcClaimItems);
                    }
                  }, 100);
                  //#endregion :: set beerClaimItems
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลเบียร์เคลมที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลเบียร์เคลมได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      isBeerClaimAdmin: false,
      isEdit: false,
      abcClaimTypeCode: null,
      abcAgentCode: null,
      abcShopCode: null,
      abcAmpher: null,
      abcProvince: null,
      abcPhone: null,
      abcClaimItems: [],
      index: 0,
      abcAgentCodeTmp: null,

      // Configurations
      abcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2AgentData",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopData",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    uploadFile: function uploadFile(file) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var formData, _response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = new FormData();

                formData.append('File', file);
                formData.append('FolderName', 'BeerClaim');
                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/Api/File/FileUpload', formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 6:
                _response = _context.sent;
                return _context.abrupt("return", _response.data);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                throw _context.t0;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 10]]);
      }))();
    },
    formSubmit: function formSubmit(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var router, self, cItems, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, uploadedFiles, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, file, uploadResponse;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if ($(_this2.$refs.form).validate().form()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", false);

              case 2:
                if (!(_this2.abcClaimItems == null || _this2.abcClaimItems.length == 0)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", false);

              case 4:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                router = _this2.$router;
                self = _this2;
                cItems = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 11;
                _iterator = self.abcClaimItems[Symbol.iterator]();

              case 13:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 57;
                  break;
                }

                element = _step.value;

                if (!(!element.claimStatusCode || element.claimStatusCode == "CLAIM_STATUS_SUBMIT" || self.isBeerClaimAdmin)) {
                  _context2.next = 54;
                  break;
                }

                if (element.uploadFiles === undefined) {
                  element.uploadFiles = element.Pictures;
                }
                uploadedFiles = [];

                if (!element.uploadFiles) {
                  _context2.next = 51;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 22;
                _iterator2 = element.uploadFiles[Symbol.iterator]();

              case 24:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 37;
                  break;
                }

                file = _step2.value;

                if (!(file && file.fileDataContext)) {
                  _context2.next = 33;
                  break;
                }

                _context2.next = 29;
                return self.uploadFile(file.fileDataContext);

              case 29:
                uploadResponse = _context2.sent;

                uploadedFiles.push({
                  contentType: file.fileDataContext.type,
                  downloadUrl: uploadResponse.fileUrl,
                  fileInfoId: uploadResponse.fileInfoId,
                  fileName: file.fileDataContext.name,
                  gridFsId: uploadResponse.gridFsId,
                  sysName: '-'
                });
                _context2.next = 34;
                break;

              case 33:
                if (file && file.claimItemPictureId) {
                  uploadedFiles.push({
                    claimItemPictureId: file.claimItemPictureId,
                    fileInfoId: file.fileInfoId
                  });
                }

              case 34:
                _iteratorNormalCompletion2 = true;
                _context2.next = 24;
                break;

              case 37:
                _context2.next = 43;
                break;

              case 39:
                _context2.prev = 39;
                _context2.t0 = _context2["catch"](22);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 43:
                _context2.prev = 43;
                _context2.prev = 44;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 46:
                _context2.prev = 46;

                if (!_didIteratorError2) {
                  _context2.next = 49;
                  break;
                }

                throw _iteratorError2;

              case 49:
                return _context2.finish(46);

              case 50:
                return _context2.finish(43);

              case 51:
                if (element.machineCategory === 'true') {
                  element.machineCategory = true;
                }
                if (element.machineCategory === 'false') {
                  element.machineCategory = false;
                }
                cItems.push({
                  ProductBrandId: element.productBrandId,
                  MaterialCode: element.materialCode,
                  Barcode: element.barcode,
                  ManufacturingDate: element.manufacturingDate ? element.manufacturingDate.format("DD/MM/YYYY") : null,
                  Weight: element.weight,
                  ProblemTypeCode: element.problemTypeCode,
                  ProblemDesc: element.problemDesc,
                  MachineTypeCode: element.machineTypeCode,
                  MachineBarcode: element.machineBarcode,
                  MachineCategory: element.machineCategory,
                  Pressure: element.pressure,
                  Temperature: element.temperature,
                  PMDate: element.pmDate ? element.pmDate.format("DD/MM/YYYY") : null,
                  JumpDate: element.jumpDate ? element.jumpDate.format("DD/MM/YYYY") : null,
                  StandardInstallCode: element.standardInstallCode,
                  AgentReceivedDate: element.agentReceivedDate.format("DD/MM/YYYY"),
                  ShopReceivedDate: element.shopReceivedDate ? element.shopReceivedDate.format("DD/MM/YYYY") : null,
                  Invoice: element.invoice,
                  Pictures: uploadedFiles
                });

              case 54:
                _iteratorNormalCompletion = true;
                _context2.next = 13;
                break;

              case 57:
                _context2.next = 63;
                break;

              case 59:
                _context2.prev = 59;
                _context2.t1 = _context2["catch"](11);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 63:
                _context2.prev = 63;
                _context2.prev = 64;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 66:
                _context2.prev = 66;

                if (!_didIteratorError) {
                  _context2.next = 69;
                  break;
                }

                throw _iteratorError;

              case 69:
                return _context2.finish(66);

              case 70:
                return _context2.finish(63);

              case 71:

                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/BeerClaim", {
                  BeerClaimItems: cItems,
                  ClaimId: _this2.$route.params.id,
                  ClaimTypeCode: _this2.abcClaimTypeCode,
                  ClaimAgentCode: _this2.abcClaimTypeCode == "BEER_CLAIM_TYPE_AGENT" ? _this2.abcAgentCode : null,
                  ClaimShopCode: _this2.abcClaimTypeCode == "BEER_CLAIM_TYPE_SHOP" ? _this2.abcShopCode : null
                }).then(function (response) {
                  if (response.data.status) {
                    KTApp.unblockPage();
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      router.go(-1), self.$parent.reloadDataTable(false);
                    });
                  } else {
                    //console.log(response);
                    Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

              case 72:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[11, 59, 63, 71], [22, 39, 43, 51], [44,, 46, 50], [64,, 66, 70]]);
      }))();
    },

    onAgentCodeChange: function onAgentCodeChange(id, text, data, ref) {
      var self = this;
      //console.log("data agent ", data);
      if (data[0].data) {
        self.abcAmpher = data[0].data.ampherName;
        self.abcProvince = data[0].data.provinceName;
        self.abcPhone = data[0].data.phone;
        self.abcAgentCodeTmp = self.abcAgentCode;
      }
    },
    onShopCodeChange: function onShopCodeChange(id, text, data, ref) {
      var self = this;
      //console.log("data shop ", data);
      if (data[0].data) {
        self.abcAmpher = data[0].data.ampherName;
        self.abcProvince = data[0].data.provinceName;
        self.abcPhone = data[0].data.phone;
        self.abcAgentCodeTmp = data[0].data.agentCode;
      }
    },
    onClaimTypeCodeChange: function onClaimTypeCodeChange() {
      var self = this;
      self.abcAmpher = null;
      self.abcProvince = null;
      self.abcPhone = null;
      self.abcAgentCode = null;
      self.abcShopCode = null;
      self.abcClaimItems = [];
    },
    onRemoveItemClick: function onRemoveItemClick(index) {
      this.abcClaimItems.splice(index, 1);
    },
    onEditItemClick: function onEditItemClick(index) {
      var router = this.$router;
      var item = this.abcClaimItems[index];
      //console.log("list " ,this.abcClaimItems[index]);
      router.push({
        path: "/BeerClaim/Claim/Edit/" + this.$route.params.id + "/EditItem/" + index
      });
    },
    handleBackButton: function handleBackButton(event) {
      var modalBackdrops = document.querySelectorAll('.modal-backdrop');
      modalBackdrops.forEach(function (modalBackdrop) {
        modalBackdrop.remove();
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, router, user, resultAdmin, paramsID, parts;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this3;
              router = _this3.$router;
              _context3.next = 4;
              return _this3.$root.getUser();

            case 4:
              user = _context3.sent;

              window.addEventListener('popstate', _this3.handleBackButton);

              if (_this3.$root.canShow(['super_admin']) == true) {
                self.isBeerClaimAdmin = true;
              } else {
                if (_typeof(_this3.$root.user.profile.role) == "object") {
                  resultAdmin = _this3.$root.user.profile.role.filter(function (word) {
                    return word == "ADMIN_BEER_CLAIM";
                  });

                  if (resultAdmin.length > 0) {
                    self.isBeerClaimAdmin = true;
                  } else {
                    self.isBeerClaimAdmin = false;
                  }
                } else if (typeof _this3.$root.user.profile.role == "string") {
                  if (_this3.$root.user.profile.role == "ADMIN_BEER_CLAIM") {
                    self.isBeerClaimAdmin = true;
                  } else {
                    self.isBeerClaimAdmin = false;
                  }
                } else {
                  self.isBeerClaimAdmin = false;
                }
              }
              paramsID = _this3.$route.params.id;

              if (_this3.$route.params.id == 0) {
                parts = _this3.$route.path.split('/');

                paramsID = parts[4];
                router.go(-1);
              }
              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
              });
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BeerClaim/" + paramsID).then(function (response) {
                //console.log(response);
                if (response.status == 200) {
                  setTimeout(function () {
                    if (response.data.claimTypeCode) {
                      self.$refs.abcClaimTypeCodeSelect2.setSelectedData({
                        id: response.data.claimTypeCode,
                        text: response.data.claimTypeName
                      });
                    }
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimAgentCode) {
                      self.$refs.abcAgentCodeSelect2.setSelectedData({
                        id: response.data.claimAgentCode,
                        text: response.data.claimAgentName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                    self.abcAgentCodeTmp = response.data.claimAgentCode;
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimShopCode) {
                      self.$refs.abcShopCodeSelect2.setSelectedData({
                        id: response.data.claimShopCode,
                        text: response.data.claimShopName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                  }, 100);

                  //#region :: set beerClaimItems
                  setTimeout(function () {
                    if (response.data.beerClaimItems) {
                      response.data.beerClaimItems.forEach(function (b) {
                        self.abcClaimItems.push({
                          isBeerClaimAdmin: self.isBeerClaimAdmin,
                          productBrandId: b.productBrandId,
                          productBrand: b.productBrandName,
                          materialCode: b.materialCode,
                          material: b.materialName,
                          barcode: b.barcodeNumber,
                          depCode: b.departmentMaterialCode,
                          macDepcode: b.machineDepartmentMaterialCode,
                          barcodeOld: b.barcodeNumberOld,
                          manufacturingDate: b.manufacturingDateFormat ? moment(b.manufacturingDateFormat, "DD/MM/YYYY") : null,
                          weight: b.weight,
                          problemTypeCode: b.problemTypeCode,
                          problemType: b.problemTypeName,
                          problemDesc: b.problemDesc,
                          machineTypeCode: b.machineTypeCode,
                          machineType: b.machineTypeName,
                          machineBarcode: b.machineBarcodeNumber,
                          machineBarcodeOld: b.machineBarcodeNumberOld,
                          machineCategory: b.machineCategory,
                          pressure: b.pressure,
                          temperature: b.temperature,
                          pmDate: b.pmDateFormat ? moment(b.pmDateFormat, "DD/MM/YYYY") : null,
                          jumpDate: b.jumpDateFormat ? moment(b.jumpDateFormat, "DD/MM/YYYY") : null,
                          standardInstallCode: b.standardInstallCode,
                          standardInstall: b.standardInstallName,
                          claimStatusCode: b.claimStatusCode,
                          claimItemId: b.claimItemId,
                          agentReceivedDate: b.agentReceivedDateFormat ? moment(b.agentReceivedDateFormat, "DD/MM/YYYY") : null,
                          shopReceivedDate: b.shopReceivedDateFormat ? moment(b.shopReceivedDateFormat, "DD/MM/YYYY") : null,
                          invoice: b.invoice,
                          claimItemPicture: b.claimItemPicture,
                          Pictures: b.claimItemPicture
                        });
                        self.index += 1;
                      });
                      //console.log("list edit ", self.abcClaimItems);
                    }
                  }, 100);
                  //#endregion :: set beerClaimItems
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลเบียร์เคลมที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลเบียร์เคลมได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              // set validation rules
              $(_this3.$refs.form).validate({
                rules: {
                  abcClaimTypeCode: "required",
                  abcAgentCode: "required",
                  abcShopCode: "required"
                },
                messages: {
                  abcClaimTypeCode: "กรุณาเลือกประเภทการเคลม",
                  abcAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
                  abcShopCode: "กรุณาเลือกร้านค้า"
                }
              });

              $(_this3.$refs.form).validate().settings.ignore = ":hidden";

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_currency_input__ = __webpack_require__(79);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_currency_input__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      isBeerclaimAdmin: false,
      isApprove: false,
      locale: "th",
      currency: "THB",
      picked: "two",
      abcClaimTypeCode: null,
      abcAgentCode: null,
      abcShopCode: null,
      abcAmpher: null,
      abcProvince: null,
      abcPhone: null,
      abcClaimItems: [],
      index: 0,
      abcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2AgentData",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      abcShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopData",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      var _this = this;

      var self = this;
      var cItems = [];
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }
      self.abcClaimItems.forEach(function (element) {
        cItems.push({
          ClaimItemId: element.claimItemId,
          ClaimPrice: element.claimPrice,
          CheckClaimPriceOnly: true
        });
      });
      Swal.fire({
        title: "บันทึกข้อมูลจำนวนเงิน",
        type: "warning",
        html: "กรุณายืนยันเพื่อบันทึกข้อมูลจำนวนเงิน <strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูลจำนวนเงิน กรุณารอสักครู่..."
          });
          var router = _this.$router;
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BeerClaim/Conclude", {
            BeerClaimItems: cItems,
            ClaimId: _this.$route.params.id
          }).then(function (response) {
            if (response.data.status) {
              KTApp.unblockPage();
              Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                router.go(-1), self.$parent.reloadDataTable(false);
              });
            } else {
              //console.log(response);
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            //console.log(error);
            Swal.fire("เกิดข้อผิดพลาด", error.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, resultAdmin;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;
              router = _this2.$router;


              if (_this2.$root.canShow(['super_admin']) == true) {
                self.isBeerclaimAdmin = true;
              } else {
                if (_typeof(_this2.$root.user.profile.role) == "object") {
                  resultAdmin = _this2.$root.user.profile.role.filter(function (word) {
                    return word == "ADMIN_BEER_CLAIM";
                  });

                  if (resultAdmin.length > 0) {
                    self.isBeerclaimAdmin = true;
                  } else {
                    self.isBeerclaimAdmin = false;
                  }
                } else if (typeof _this2.$root.user.profile.role == "string") {
                  if (_this2.$root.user.profile.role == "ADMIN_BEER_CLAIM") {
                    self.isBeerclaimAdmin = true;
                  } else {
                    self.isBeerclaimAdmin = false;
                  }
                } else {
                  self.isBeerclaimAdmin = false;
                }
              }
              $("#myCheck").click(function (e) {
                $(this).closest("table").find("td input:checkbox").prop("checked", this.checked);
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BeerClaim/" + _this2.$route.params.id).then(function (response) {
                //console.log(response);
                if (response.status == 200) {
                  setTimeout(function () {
                    if (response.data.claimTypeCode) {
                      self.$refs.abcClaimTypeCodeSelect2.setSelectedData({
                        id: response.data.claimTypeCode,
                        text: response.data.claimTypeName
                      });
                    }
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimAgentCode) {
                      self.$refs.abcAgentCodeSelect2.setSelectedData({
                        id: response.data.claimAgentCode,
                        text: response.data.claimAgentName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                  }, 100);

                  setTimeout(function () {
                    if (response.data.claimShopCode) {
                      self.$refs.abcShopCodeSelect2.setSelectedData({
                        id: response.data.claimShopCode,
                        text: response.data.claimShopName
                      });
                    }
                    self.abcAmpher = response.data.ampherName;
                    self.abcProvince = response.data.provinceName;
                    self.abcPhone = response.data.tel;
                  }, 100);

                  //#region :: set beerClaimItems
                  setTimeout(function () {
                    if (response.data.beerClaimItems) {
                      response.data.beerClaimItems.forEach(function (b) {
                        //console.log("b ", b);
                        if (b.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE") {
                          self.isApprove = true;
                        }
                        self.abcClaimItems.push({
                          isBeerclaimAdmin: self.isBeerclaimAdmin,
                          claimPrice: b.claimPrice,
                          productBrandId: b.productBrandId,
                          productBrand: b.productBrandName,
                          materialCode: b.materialCode,
                          material: b.materialName,
                          barcode: b.barcodeNumber,
                          barcodeOld: b.barcodeNumberOld,
                          depCode: b.departmentMaterialCode,
                          manufacturingDate: b.manufacturingDateFormat ? moment(b.manufacturingDateFormat, "DD/MM/YYYY") : null,
                          weight: b.weight,
                          problemTypeCode: b.problemTypeCode,
                          problemType: b.problemTypeName,
                          problemDesc: b.problemDesc,
                          machineTypeCode: b.machineTypeCode,
                          machineType: b.machineTypeName,
                          machineBarcode: b.machineBarcodeNumber,
                          machineCategory: b.machineCategory,
                          pressure: b.pressure,
                          temperature: b.temperature,
                          pmDate: b.pmDateFormat ? moment(b.pmDateFormat) : null,
                          jumpDate: b.jumpDateFormat ? moment(b.jumpDateFormat) : null,
                          standardInstallCode: b.standardInstallCode,
                          standardInstall: b.standardInstallName,
                          claimStatusCode: b.claimStatusCode,
                          claimStatusName: b.claimStatusName,
                          claimItemId: b.claimItemId,
                          agentReceivedDate: b.agentReceivedDateFormat ? moment(b.agentReceivedDateFormat, "DD/MM/YYYY") : null,
                          shopReceivedDate: b.shopReceivedDateFormat ? moment(b.shopReceivedDateFormat, "DD/MM/YYYY") : null,
                          invoice: b.invoice,
                          IsSelectApprove: false
                        });
                        self.index += 1;
                      });
                      //console.log("list edit ", self.abcClaimItems);
                    }
                  }, 100);
                  //#endregion :: set beerClaimItems
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลเบียร์เคลมที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลเบียร์เคลมได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AnalyzeSpecifyForm__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

//กรณีมีปุ่มให้กดยืนยัน
// <a href="#" @click.prevent="showShowReqApproval" v-if="data.showShowReqApproval" title="ยืนยันผลการเคลม" class="btn btn-sm btn-clean btn-icon btn-icon-md">
//   <i class="fas flaticon-interface-5"></i>
// </a>
var BeerClaimActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div style=\"display: flex; flex-direction: row; align-items: center; justify-content: center\">\n    <a href=\"#\" @click.prevent=\"detailBeerClaim\" v-if=\"data.showDetailButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"la la-file-text\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"showDocRequest\" title=\"\u0E43\u0E1A\u0E04\u0E33\u0E23\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E40\u0E04\u0E25\u0E21\u0E40\u0E1A\u0E35\u0E22\u0E23\u0E4C\u0E2A\u0E14\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"la la-print\" style=\"color: #800080\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"editBeerClaim\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"editStatusQIBeerClaim\" v-if=\"data.showEditStatusQIButton\" title=\"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E30 (\u0E40\u0E08\u0E49\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48 QC \u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A)\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"fas flaticon-interface-4\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"editStatusAnalyzeDeliver\" v-if=\"data.showEditStatusAnalyzeDeliver\" title=\"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E30 (\u0E2A\u0E48\u0E07\u0E27\u0E34\u0E40\u0E04\u0E23\u0E32\u0E30\u0E2B\u0E4C\u0E19\u0E49\u0E33\u0E40\u0E1A\u0E35\u0E22\u0E23\u0E4C)\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"fas flaticon-interface-4\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"showAnalyzeSpecifyForm\" v-if=\"data.showEditStatusAnalyzeSpecify\" title=\"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E30 (\u0E23\u0E30\u0E1A\u0E38\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E27\u0E34\u0E40\u0E04\u0E23\u0E32\u0E30\u0E2B\u0E4C)\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"fas flaticon-interface-4\"></i>\n    </a>\n    <!--<a href=\"#\" @click.prevent=\"showAnalyzeResultForm\" v-if=\"data.showEditStatusAnalyzeResult\" title=\"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E30 (\u0E2A\u0E48\u0E07\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E27\u0E34\u0E40\u0E04\u0E23\u0E32\u0E30\u0E2B\u0E4C)\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"fas flaticon-interface-4\"></i>\n    </a>-->\n    <a href=\"#\" @click.prevent=\"commitBeerClaim\" v-if=\"data.showCommitButton\" title=\"\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E48\u0E07\u0E40\u0E04\u0E25\u0E21\u0E44\u0E14\u0E49\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"flaticon-list\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"showApprove\" v-if=\"data.showApprove\" title=\"\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E40\u0E04\u0E25\u0E21\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"fas flaticon-interface-5\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"showConclude\" v-if=\"data.showConclude\" title=\"\u0E2A\u0E23\u0E38\u0E1B\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E41\u0E25\u0E30\u0E0A\u0E14\u0E40\u0E0A\u0E22\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"fas flaticon-interface-5\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"resultBeerClaim\" v-if=\"data.showResult\" title=\"\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E40\u0E04\u0E25\u0E21\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"flaticon-list-3\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"editStatusCancel\" v-if=\"data.checkStatusforCancel\" title=\"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E41\u0E08\u0E49\u0E07\u0E40\u0E04\u0E25\u0E21\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"la la-trash\" style=\"color:Red\"></i>\n    </a>\n    <analyze-specify-form ref=\"analyzeSpecifyForm\"></analyze-specify-form>\n  </div>",
  components: {
    analyzeSpecifyForm: __WEBPACK_IMPORTED_MODULE_4__AnalyzeSpecifyForm__["a" /* default */]
  },
  methods: {
    detailBeerClaim: function detailBeerClaim() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        path: "/BeerClaim/Claim/Detail/" + this.data.claimId
      });
    },
    showDocRequest: function showDocRequest() {
      var rootPath = "https://" + window.location.host;
      window.open(rootPath + "/Print/BeerClaimRequest/" + this.data.claimId);
    },
    editBeerClaim: function editBeerClaim() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        path: "/BeerClaim/Claim/Edit/" + this.data.claimId
      });
    },
    commitBeerClaim: function commitBeerClaim() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        path: "/BeerClaim/Claim/Commit/" + this.data.claimId
      });
    },
    showApprove: function showApprove() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        path: "/BeerClaim/Claim/Approve/" + this.data.claimId
      });
    },
    showConclude: function showConclude() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        path: "/BeerClaim/Claim/Conclude/" + this.data.claimId
      });
    },
    resultBeerClaim: function resultBeerClaim() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        path: "/BeerClaim/Claim/Result/" + this.data.claimId
      });
    },
    editStatusQIBeerClaim: function editStatusQIBeerClaim() {
      var _this = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งการเปลี่ยนสถานะเบียร์เคลม",
        type: "warning",
        html: "กรุณายืนยันคำสั่งการเปลี่ยนสถานะเบียร์เคลม <strong>" + "</strong>",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการเปลี่ยนสถานะเบียร์เคลม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังเปลี่ยนสถานะเบียร์เคลม กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BeerClaim/EditStatus", {
            ClaimItemId: _this.data.claimItemId,
            StatusCode: "CLAIM_STATUS_QI_INSPECT"
          }).then(function (response) {
            // console.log("response ", response);
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    editStatusAnalyzeDeliver: function editStatusAnalyzeDeliver() {
      var _this2 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งการเปลี่ยนสถานะเบียร์เคลม",
        type: "warning",
        html: "กรุณายืนยันคำสั่งการเปลี่ยนสถานะเบียร์เคลม <strong>" + "</strong>",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการเปลี่ยนสถานะเบียร์เคลม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังเปลี่ยนสถานะเบียร์เคลม กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BeerClaim/EditStatus", {
            ClaimItemId: _this2.data.claimItemId,
            StatusCode: "CLAIM_STATUS_BEER_ANALYZE_DELIVER"
          }).then(function (response) {
            //console.log("response ", response);
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    showAnalyzeSpecifyForm: function showAnalyzeSpecifyForm() {
      $(this.$refs.analyzeSpecifyForm.$el).modal("show");
    },
    showAnalyzeResultForm: function showAnalyzeResultForm() {
      var self = this;
      $(this.$refs.analyzeSpecifyForm.$el).on("hidden.bs.modal", function () {
        // Set go back
        //router.go(-1);
        self.$parent.reloadDataTable();
      }).modal("show");
    },
    //กรณีมีปุ่มให้กดยืนยัน
    // showShowReqApproval: function() {
    //   let self = this;
    //   Swal.fire({
    //     title: "คำสั่งการยืนยันผลการเคลม",
    //     type: "warning",
    //     html: "กรุณายืนยันคำสั่งการยืนยันผลการเคลม <strong>" + "</strong>",
    //     input: this.data.userCount > 0 ? "checkbox" : "",
    //     inputValue: 0,
    //     inputPlaceholder: "ต้องการยืนยันผลการเคลม",
    //     showCancelButton: true,
    //     confirmButtonText: "ยืนยัน",
    //     cancelButtonText: "ยกเลิก",
    //     showLoaderOnConfirm: true,
    //   }).then((result) => {
    //     if (result.value) {
    //       KTApp.blockPage({
    //         opacity: 0.05,
    //         message: "กำลังยืนยันผลการเคลม กรุณารอสักครู่...",
    //       });
    //       axios
    //         .post("/Api/BeerClaim/ConfirmJobRequestApproval", {
    //           ClaimId: this.data.claimId,
    //         })
    //         .then(function(response) {
    //           //console.log("response ", response);
    //           if (response.data.data) {
    //             self.$parent.reloadDataTable();
    //             Swal.fire("สำเร็จ", response.data.message, "success");
    //           } else {
    //             Swal.fire(
    //               "เกิดข้อผิดพลาด",
    //               error.response.data.message,
    //               "error"
    //             );
    //           }
    //         })
    //         .catch(function(error) {
    //           Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
    //         })
    //         .then(function() {
    //           // always executed
    //           KTApp.unblockPage();
    //         });
    //     }
    //   });
    // },
    editStatusCancel: function editStatusCancel() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งยกเลิกข้อมูลใบงาน",
        type: "warning",
        html: "กรุณายืนยันคำสั่งยกเลิกข้อมูลใบคำร้อง<br/>ขอเคลมเบียร์สด <strong>" + this.data.claimNumber + "</strong>",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องยกเลิกการแจ้งเคลม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังยกเลิกการแจ้งเคลม กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BeerClaim/EditStatus", {
            ClaimItemId: _this3.data.claimItemId,
            StatusCode: "CLAIM_STATUS_CANCEL"
          }).then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

var BeerClaimDocActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div style=\"display: flex; flex-direction: row; align-items: center; justify-content: center\">\n    <a href=\"#\" @click.prevent=\"showDocHold\" v-if=\"data.showDocHold\" title=\"\u0E43\u0E1A Hold\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"flaticon-file-2 iconsize\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"showDocHoldAdd\" v-if=\"data.showDocHoldAdd\" title=\"\u0E43\u0E1A Hold\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"flaticon-file-2 iconsize\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"showDocCCR\" v-if=\"data.showDocCCR\" title=\"\u0E43\u0E1A CCR\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"flaticon-list-1 iconsize\" style=\"color:Gold\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"showDocApprove\" v-if=\"data.showDocApprove\" title=\"\u0E41\u0E08\u0E49\u0E07\u0E1C\u0E25\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E40\u0E04\u0E25\u0E21\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"flaticon-interface-10 iconsize\" style=\"color:Green\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"showDocReject\" v-if=\"data.showDocReject\" title=\"\u0E41\u0E08\u0E49\u0E07\u0E1C\u0E25\u0E44\u0E21\u0E48\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23\u0E40\u0E04\u0E25\u0E21\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"flaticon-interface-11 iconsize\" style=\"color:Red\" ></i>\n    </a>\n  </div>",
  methods: {
    showDocHold: function showDocHold() {
      var rootPath = "https://" + window.location.host;
      window.open(rootPath + "/Print/Hold/" + this.data.claimId);
    },
    showDocHoldAdd: function showDocHoldAdd() {
      var rootPath = "https://" + window.location.host;
      window.open(rootPath + "/Print/Holdadd/" + this.data.claimId);
    },
    showDocCCR: function showDocCCR() {
      var rootPath = "https://" + window.location.host;

      var type = this.data.claimStatusCode;
      window.open(rootPath + "/Print/CcrForm?Id=" + this.data.claimId + "&type=" + type);
    },
    showDocApprove: function showDocApprove() {
      var rootPath = "https://" + window.location.host;
      window.open(rootPath + "/Print/Approval/" + this.data.claimId);
    },
    showDocReject: function showDocReject() {
      var rootPath = "https://" + window.location.host;
      window.open(rootPath + "/Print/DisApproval/" + this.data.claimId);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      bcSearch: null,
      bcClaimTypeCode: null,
      bcClaimStatusCode: null,
      bcStartDate: null,
      bcEndDate: null,
      bcClaimShowDocCCR: "WorkMe",
      bcClaimShowDocCCROptions: [],
      bcClaimStatusCancel: false,
      bcClaimShowDocCCRTemp: "WorkMe",

      // Configurations
      bcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      bcClaimStatusCodeOptions: {
        placeholder: "กรุณาเลือกสถานะการเคลม",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/BeerClaim/Options",
          data: function data(params) {
            var query = {
              IsCheck: self.bcClaimShowDocCCR,
              search: "CLAIM_STATUS",
              KeySearch: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.bcSearch = null;
      self.bcStartDate = null;
      self.bcEndDate = null;
      self.bcClaimTypeCode = null;
      self.bcClaimStatusCode = null;
      self.bcClaimShowDocCCR = "WorkMe";
      self.bcClaimStatusCancel = false;

      $("#bcStartDate").val("").trigger("change");

      $("#bcEndDate").val("").trigger("change");

      $("#bcClaimTypeCode").val("").trigger("change");

      $("#bcClaimStatusCode").val("").trigger("change");

      $("#bcClaimShowDocCCR").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#claimTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#claimTable").DataTable().ajax.reload(null, resetPaging);
    },
    Select2CCROptions: function Select2CCROptions(index) {
      var self = this;
      self.bcClaimShowDocCCROptions = [];
      if (self.$root.canShow(["ADMIN_BEER_CLAIM"])) {
        self.bcClaimShowDocCCROptions = [{ id: "WorkMe", label: "เลือกตรวจสอบใบเคลม" }, { id: "ShowCCR", label: "เลือกปริ้นใบ CCR" }];
      } else {
        self.bcClaimShowDocCCROptions = [{ id: "WorkMe", label: "เลือกตรวจสอบใบเคลม" }, { id: "ShowCCR", label: "เลือกปริ้นใบ CCR" }];
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.bcStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.bcStartDate).datepicker("update", !!self.bcStartDate ? self.bcStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bcStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.bcEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reEndDate = moment().endOf('month');
              $(self.$refs.bcEndDate).datepicker("update", !!self.bcEndDate ? self.bcEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.bcEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              self.Select2CCROptions();

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#claimTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/BeerClaim/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.bcSearch,
                      StartDate: self.bcStartDate != null ? self.bcStartDate.format("DD/MM/YYYY") : self.bcStartDate,
                      EndDate: self.bcEndDate != null ? self.bcEndDate.format("DD/MM/YYYY") : self.bcEndDate,
                      ClaimStatusCancel: self.bcClaimStatusCancel,
                      ClaimTypeCode: self.bcClaimTypeCode,
                      ClaimStatusCode: self.bcClaimStatusCode,
                      ClaimShowDocCCR: self.bcClaimShowDocCCR
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[7, "desc"]],
                columns: [{
                  data: "claimNumber",
                  className: "text-center"
                }, {
                  data: "claimTypeCode",
                  className: "text-center",
                  width: "10%",
                  render: function render(data, type, full, meta) {
                    return full.claimTypeName;
                  }
                }, {
                  data: "claimAgentName",
                  width: "20%",
                  render: function render(data, type, full, meta) {
                    return full.claimAgentName != null ? full.claimAgentName : full.claimShopName;
                  }
                }, {
                  data: "invoice",
                  className: "text-center"
                }, {
                  data: "barcodeNumberOld",
                  className: "text-center"
                }, {
                  data: "departmentMaterialCode",
                  className: "text-center"
                }, {
                  data: "claimStatusCode",
                  className: "text-center",
                  width: "15%",
                  render: function render(data, type, full, meta) {
                    if (full.claimStatusCode == "CLAIM_STATUS_CANCEL") {
                      return '<span class="text-danger">' + full.claimStatusName + "</span>";
                    } else {
                      return full.claimStatusName;
                    }
                  }
                }, {
                  data: "claimDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.claimDateFormat;
                  }
                }, {
                  data: "claimId",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="docAction"></div>';
                  }
                }, {
                  data: "claimItemId",
                  className: "text-center",
                  width: "15%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                DatatableWarning.alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showDetailButton = self.$root.canShow(["AGENT_ADMIN_BEER_CLAIM", "QI_OFFICER_BEER_CLAIM", "PLANT_ACCOUNTANT_BEER_CLAIM", "LAB_BEER_CLAIM", "MANAGER_BEER_CLAIM", "ADMIN_BEER_CLAIM"]);
                    data.showEditButton = self.$root.canShow(["AGENT_ADMIN_BEER_CLAIM"]) && data.claimStatusCode == "CLAIM_STATUS_SUBMIT" || self.$root.canShow(["ADMIN_BEER_CLAIM"]);
                    data.showEditStatusQIButton = self.$root.canShow([
                    // "ADMIN_BEER_CLAIM",
                    "QI_OFFICER_BEER_CLAIM"]) && data.claimStatusCode == "CLAIM_STATUS_SUBMIT";
                    data.showEditStatusAnalyzeDeliver = self.$root.canShow([
                    // "ADMIN_BEER_CLAIM",
                    "PLANT_ACCOUNTANT_BEER_CLAIM"]) && data.claimStatusCode == "CLAIM_STATUS_BEER_DELIVER";
                    data.showEditStatusAnalyzeSpecify = self.$root.canShow([
                    // "ADMIN_BEER_CLAIM", 
                    "LAB_BEER_CLAIM"]) && data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_DELIVER";
                    data.showEditStatusAnalyzeResult = self.$root.canShow([
                    // "ADMIN_BEER_CLAIM",
                    "PLANT_ACCOUNTANT_BEER_CLAIM"]) && data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_SPECIFY";
                    //กรณีมีปุ่มให้กดยืนยัน
                    // data.showShowReqApproval =
                    //   self.$root.canShow(["ADMIN_BEER_CLAIM"]) &&
                    //   data.isShowReqApproval;
                    // data.showDeleteButton = self.$root.canShow([
                    //   "ADMIN_PM",
                    //   "USER_PM"
                    // ]);
                    data.showCommitButton = self.$root.canShow(["QI_OFFICER_BEER_CLAIM"]) && data.claimStatusCode == "CLAIM_STATUS_QI_INSPECT";
                    data.showApprove = self.$root.canShow(["MANAGER_BEER_CLAIM"]) && (data.claimStatusCode == "CLAIM_STATUS_WARE_DELIVER" && data.preApproveStatus != null || data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_APPROVE");
                    data.showConclude = self.$root.canShow(["ADMIN_BEER_CLAIM"]) && (data.claimStatusCode == "CLAIM_STATUS_APPROVE" || data.claimStatusCode == "CLAIM_STATUS_REJECT");

                    data.showResult = self.$root.canShow(["AGENT_ADMIN_BEER_CLAIM"]) && (data.claimStatusCode == "CLAIM_STATUS_REVOKE" || data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE" || data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_REJECT") || self.$root.canShow(["ADMIN_BEER_CLAIM"]) && data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE";

                    if (self.$root.canShow(["ADMIN_BEER_CLAIM"]) && !["CLAIM_STATUS_APPROVE", "CLAIM_STATUS_CONCLUDE_APPROVE", "CLAIM_STATUS_CONCLUDE_REJECT", "CLAIM_STATUS_REJECT", "CLAIM_STATUS_CANCEL"].includes(data.claimStatusCode)) {
                      data.checkStatusforCancel = true;
                    } else {
                      data.checkStatusforCancel = false;
                    }

                    new BeerClaimActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                }), $(".docAction").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showDocHold = self.$root.canShow(["ADMIN_BEER_CLAIM", "COMPANY_PROFILE_TYPE_AGENT", "AGENT_ADMIN_BEER_CLAIM", "QI_OFFICER_BEER_CLAIM", "PLANT_ACCOUNTANT_BEER_CLAIM", "ADMIN_PLANT_BEER_CLAIM", "MANAGER_BEER_CLAIM", "LAB_BEER_CLAIM"]) && (data.claimStatusCode == "CLAIM_STATUS_COMMIT" || data.claimStatusCode == "CLAIM_STATUS_BEER_DELIVER" || data.claimStatusCode == "CLAIM_STATUS_WARE_DELIVER" || data.claimStatusCode == "CLAIM_STATUS_APPROVE" || data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE" || data.claimStatusCode == "CLAIM_STATUS_REJECT" || data.claimStatusCode == "CLAIM_STATUS_BEER_DELIVER" || data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_DELIVER" || data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_RESULT" || data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_APPROVE");

                    data.showDocHoldAdd = self.$root.canShow(["ADMIN_BEER_CLAIM", "COMPANY_PROFILE_TYPE_AGENT", "AGENT_ADMIN_BEER_CLAIM"]) && data.claimStatusCode == "CLAIM_STATUS_TANK_RECEIVE";
                    data.showDocCCR =
                    // self.$root.canShow([
                    //   "PLANT_ACCOUNTANT_BEER_CLAIM",
                    //   "LAB_BEER_CLAIM",
                    //   "ADMIN_BEER_CLAIM",
                    //   "MANAGER_BEER_CLAIM",
                    // ]) && data.labResult != null;
                    self.$root.canShow(["PLANT_ACCOUNTANT_BEER_CLAIM", "LAB_BEER_CLAIM", "ADMIN_PLANT_BEER_CLAIM", "MANAGER_BEER_CLAIM", "ADMIN_BEER_CLAIM"]) && data.labResult != null;

                    if (data.claimPrice > 0) {
                      data.showDocApprove = self.$root.canShow(["ADMIN_BEER_CLAIM", "MANAGER_BEER_CLAIM", "AGENT_ADMIN_BEER_CLAIM"]) && (data.claimStatusCode == "CLAIM_STATUS_APPROVE" || data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE");
                    } else {
                      data.showDocApprove = self.$root.canShow(["ADMIN_BEER_CLAIM", "MANAGER_BEER_CLAIM"]) && (data.claimStatusCode == "CLAIM_STATUS_APPROVE" || data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE");
                    }

                    data.showDocReject = self.$root.canShow(["ADMIN_BEER_CLAIM", "MANAGER_BEER_CLAIM", "AGENT_ADMIN_BEER_CLAIM"]) && (data.claimStatusCode == "CLAIM_STATUS_REJECT" || data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_REJECT");
                    new BeerClaimDocActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  },

  watch: {
    bcClaimShowDocCCR: function bcClaimShowDocCCR(newval) {
      if (typeof this.$root.user.profile.role == "string") {
        if (this.$root.user.profile.role == "ADMIN_BEER_CLAIM") {
          var check = false;
          if (newval === undefined && this.bcClaimShowDocCCRTemp !== undefined) {
            check = true;
          } else if (newval !== undefined && this.bcClaimShowDocCCRTemp === undefined) {
            check = true;
          } else {
            check = false;
          }
          if (check) {
            this.$refs.bcClaimStatusCodeSelect2.$el.value = '';
            $(this.$refs.bcClaimStatusCodeSelect2.$el).trigger('change');
            $(this.$refs.bcClaimStatusCodeSelect2.$el).select2('close');
          }
          this.bcClaimShowDocCCRTemp = newval;
        }
      }
    }
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductLoanItemRow__ = __webpack_require__(135);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__["a" /* default */],
    plItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductLoanItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      isChange: true,
      plItems: [],
      i: 0,
      cbpDocNumber: null,
      cbpAgentCode: null,
      cbpBorrower: null,
      //cbpCompanyProfile: null,
      cbpRecipientInsteadName: null,
      cbpRecipientInsteadTel: null,
      cbpRequestDate: null,
      cbpRequestType: [],
      cbpRequestTypeOptions: [],
      cbpProductGroupCode: null,
      cbpProductGroupId: null,
      cbpProductGroupOptions: [],
      cbpRemark: null,
      cbpAmount: null,
      cbpIsAgent: false,
      //config
      cbpAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductLoan/Select2SearchAgentOrg",
          data: function data(params) {
            var query = {
              userId: self.cbpBorrower,
              search: params.term,
              page: params.page || 1
            };
            return query;
          },

          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cbpBorrowerOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/ProductLoan/Select2Borrower",
          data: function data(params) {
            var query = {
              userId: "",
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      for (var i = 0; i < this.plItems.length; i++) {
        this.plItems[i].index = i;
      }

      var len = this.plItems.length + 1;

      this.plItems.push({
        index: len,
        plStatus: null,
        plProductId: null,
        plProductType: null,
        plQuota: null,
        plQty: 0,
        plPrice: 0,
        plAvgPrice: 0,
        plInitialPrice: 0,
        plAgent: null,
        plShopId: null,
        plShopActivityId: null,
        plActivityId: null,
        plIsShop: false,
        plActivityIdRemark: null,
        plReturnDate: null,
        plAvailableQty: 0,
        selectedStatusCodeData: null,
        selectedProductData: null,
        selectedProductTypeData: null,
        selectedQuotaData: null,
        selectedAgentData: null,
        selectedShopData: null,
        selectedActivityData: null
      });

      // console.log(this.plItems)
      // for (var i = 0; i < this.plItems.length; i++) {
      //   console.log(this.plItems[i].index);
      // }
    },
    onRemoveItemClick: function onRemoveItemClick(i, delItem) {
      // console.log("index : " + i);
      var self = this;
      self.plItemsTemp = self.plItems;
      self.plItems = [];
      self.plItemsTemp.splice(i, 1);
      self.isChange = false;
      // self.isChange = true;
      /*=== Binding items=== */
      setTimeout(function () {
        self.plItems = self.plItemsTemp;

        setTimeout(function () {
          for (var _i = 0; _i < self.plItems.length; _i++) {
            /*=== Check Is Shop & Set Selected Select2=== */
            if (self.plItems[_i].plShopId === null && self.plItems[_i].plActivityId === null || self.plItems[_i].plShopActivityId === null) {
              self.$refs.plItems[_i].$refs.plShopActivityId.setSelectedData({
                id: "0",
                text: "ไม่ระบุ"
              });
            } else if (self.plItems[_i].plActivityId != null) {
              self.$refs.plItems[_i].$refs.plShopActivityId.setSelectedData(self.plItems[_i].selectedActivityData);
            } else {
              self.$refs.plItems[_i].$refs.plShopActivityId.setSelectedData(self.plItems[_i].selectedShopData);
            }

            /*=== Check Is Agent & Set Selected Select2=== */
            if (self.plItems[_i].plAgent === null) {
              self.$refs.plItems[_i].$refs.plAgent.setSelectedData({
                id: "0",
                text: "ไม่ระบุ"
              });
            }
            if (self.plItems[_i].plAgent !== null) {
              self.$refs.plItems[_i].$refs.plAgent.setSelectedData(self.plItems[_i].selectedAgentData);
            }

            /*=== Status : Set Selected Select2=== */
            self.$refs.plItems[_i].$refs.plStatus.setSelectedData(self.plItems[_i].selectedStatusCodeData);

            /*=== ProductId : Set Selected Select2=== */
            self.$refs.plItems[_i].$refs.plProductId.setSelectedData(self.plItems[_i].selectedProductData);
            /*=== ProductType : Set Selected Select2=== */
            self.$refs.plItems[_i].$refs.plProductType.setSelectedData(self.plItems[_i].selectedProductTypeData);

            /*=== Quota : Set Selected Select2=== */
            self.$refs.plItems[_i].$refs.plQuota.setSelectedData(self.plItems[_i].selectedQuotaData);

            /*=== Set DatePicker ReturnDate=== */
            if (self.plItems[_i].plReturnDate != null) {
              $(self.$refs.plItems[_i].$refs.plReturnDate).datepicker("update", self.plItems[_i].plReturnDate.format("DD/MM/YYYY"));
            }
          }
        }, 50);
      }, 50);
    },

    onProductTypeChange: function onProductTypeChange(e) {
      // console.log("TypeChange");
    },
    onProductGroupChange: function onProductGroupChange() {
      // console.log("GroupChange");
      var self = this;
      if (self.cbpProductGroupCode === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
        self.cbpProductGroupId = "1";
      }
      if (self.cbpProductGroupCode === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS") {
        self.cbpProductGroupId = "2";
      }

      //Clear Product,Status select2 Item
      setTimeout(function () {
        for (var i = 0; i < self.plItems.length; i++) {
          self.$refs.plItems[i].$refs.plProductType.setSelectedData({
            id: null,
            text: null
          });

          self.$refs.plItems[i].$refs.plProductId.setSelectedData({
            id: null,
            text: null
          });

          if (self.cbpIsAgent && self.cbpProductGroupId == "2") {
            self.$refs.plItems[i].$refs.plStatus.setSelectedData({
              id: null,
              text: null
            });
          }
        }
      }, 10);
    },
    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.plItems.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการ", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่..."
      });

      var pItems = [];
      for (var i = 0; i < self.plItems.length; i++) {
        var element = self.plItems[i];
        pItems.push({
          Index: element.index + 1,
          Status: element.plStatus,
          ProductId: element.plProductId,
          ProductType: element.plProductType,
          AgentCode: element.plAgent,
          QuotaId: element.plQuota,
          Qty: element.plQty,
          Price: element.plPrice,
          ShopId: element.plShopId,
          ActivityId: element.plActivityId,
          IsShop: element.plIsShop,
          Remark: element.plActivityRemark,
          ReturnDate: element.plReturnDate != null ? element.plReturnDate.format("DD/MM/YYYY") : null
        });
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/ProductLoan",
        data: {
          requestDocNo: null,
          agentCode: self.cbpAgentCode,
          borrower: self.cbpBorrower,
          representName: self.cbpRecipientInsteadName,
          RepresentTel: self.cbpRecipientInsteadTel,
          requestDate: self.cbpRequestDate.format("DD/MM/YYYY"),
          requestType: self.cbpRequestType,
          productGroupId: self.cbpProductGroupCode,
          amount: self.cbpAmount,
          isAgent: self.cbpIsAgent,
          productLoanItems: pItems,
          remark: self.cbpRemark
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    cbpBorrowerChange: function cbpBorrowerChange(id, text, data, ref) {
      var self = this;

      self.$refs.cbpAgentCode.setSelectedData({
        id: null,
        text: null
      });

      setTimeout(function () {
        //Set data radio checkbox ProductLoanProductGroup
        self.cbpProductGroupOptions = [];
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/ProductLoanProductGroupOptions", {
          params: {
            userId: self.cbpBorrower
          }
        }).then(function (response) {
          if (response.status == 200) {
            if (response.data.results != null && response.data.results.length > 0) {
              for (var i = 0; i < response.data.results.length; i++) {
                self.cbpProductGroupOptions.push({
                  id: response.data.results[i].id,
                  text: response.data.results[i].text
                });
              }
            }
          } else {
            Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้", "warning");
            router.go(-1);
          }
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้", "error");
          router.go(-1);
        }).then(function () {
          // always executed
          KTApp.unblockPage();
        });

        for (var i = 0; i < self.plItems.length; i++) {
          self.$refs.plItems[i].$refs.plAgent.setSelectedData({
            id: null,
            text: null
          });
        }
      }, 10);
    },
    onAgentCodeChange: function onAgentCodeChange(id, text, data, ref) {
      var self = this;
      self.cbpIsAgent = false;
      if (text !== "") {
        self.cbpIsAgent = data[0].data.agent;
        //self.cbpCompanyProfile = data[0].data.companyProfileId;
        //Set AgentCode เพราะ Id ต้อง get จาก Data
        //self.cbpAgentCode = data[0].data.id;

        setTimeout(function () {
          for (var i = 0; i < self.plItems.length; i++) {
            self.$refs.plItems[i].$refs.plAgent.setSelectedData({
              id: null,
              text: null
            });
          }
        }, 10);
      }
    },
    copyNote: function copyNote() {
      var _this = this;

      Swal.fire({
        title: "คำสั่งแก้ไข หมายเหตุกิจกรรม",
        type: "warning",
        html: "กรุณายืนยันคำสั่งคัดลอกแก้ไข หมายเหตุกิจกรรม ทั้งหมดตามข้อมูลแถวที่ 1",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {

        if (result.value) {
          var self = _this;
          // Start copy comment
          if (self.plItems != null && self.plItems.length > 0) {
            // copy activityRemark from 1st row.
            var activityRemarkRow1 = self.plItems[0].plActivityRemark;

            for (var i = 1; i < self.plItems.length; i++) {
              //self.plItems[i].plActivityRemark = activityRemarkRow1;
              self.$set(self.plItems[i], 'plActivityRemark', activityRemarkRow1);
            }
          }
        }
      });
    }
  },
  computed: {
    totalCal: function totalCal() {
      var self = this;
      var totalSum = 0;
      if (self.plItems != null && self.plItems.length > 0) {
        for (var i = 0; i < self.plItems.length; i++) {
          //เลือกใช้ราคากลางก่อน ถ้าไม่มีค่อยไปใช้ราคาเฉลี่ย
          if (self.plItems[i].plInitialPrice != 0) {
            totalSum += Number(self.plItems[i].plQty * self.plItems[i].plInitialPrice);
            self.plItems[i].plPrice = self.plItems[i].plInitialPrice;
          } else {
            totalSum += Number(self.plItems[i].plQty * self.plItems[i].plAvgPrice);
            self.plItems[i].plPrice = self.plItems[i].plAvgPrice;
          }
          self.cbpAmount = totalSum;
        }
      }
      return totalSum;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;
              router = _this2.$router;
              _context.next = 4;
              return _this2.$root.getUser();

            case 4:
              user = _context.sent;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.cbpRequestDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                startDate: moment().format("DD/MM/YYYY"), //Current day
                endDate: moment().format("DD/MM/YYYY"), //Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              self.cbpRequestDate = moment();
              $(self.$refs.cbpRequestDate).datepicker("update", self.cbpRequestDate.format("DD/MM/YYYY")).on("changeDate", function (e) {
                self.cbpRequestDate = moment(e.date);
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/Options", {
                params: {
                  search: "PRODUCT_LOAN_REQUEST_TYPE"
                }
              }).then(function (response) {
                if (response.status == 200) {
                  if (response.data.results != null && response.data.results.length > 0) {
                    for (var i = 0; i < response.data.results.length; i++) {
                      self.cbpRequestTypeOptions.push({
                        id: response.data.results[i].id,
                        text: response.data.results[i].text
                      });
                    }
                  }
                  return self.cbpRequestTypeOptions;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              // set validation rules
              $(self.$refs.form).validate({
                rules: {
                  cbpAgentCode: "required",
                  cbpBorrower: "required",
                  cbpRequestDate: "required",
                  cbpRequestType: "required",
                  cbpProductGroupCode: "required"
                },
                messages: {
                  cbpAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
                  cbpBorrower: "กรุณากรอกผู้ขอเบิก/ยืม",
                  cbpRequestDate: "กรุณากรอกวันที่",
                  cbpRequestType: "กรุณาเลือกประเภทใบคำร้องขอ",
                  cbpProductGroupCode: "กรุณาเลือกหมวดหมู่สินค้า"
                }
              });
              $(_this2.$refs.form).validate().settings.ignore = ":hidden";

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductLoanItemRow__ = __webpack_require__(135);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__["a" /* default */],
    plItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductLoanItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      isChange: false,
      plItems: [],
      plApproveHistoryItems: [],
      plItemsTemp: [],
      i: 0,
      ubpDocNo: null,
      ubpProductLoanId: null,
      ubpBorrower: null,
      ubpAgentCode: null,
      ubpRepresentName: null,
      ubpRepresentTel: null,
      ubpReqDate: null,
      ubpRequestType: [],
      ubpRequestTypeOptions: [],
      ubpProductGroup: null,
      ubpProductGroupId: null,
      ubpProductGroupOptions: [],
      ubpRemark: null,
      ubpIsAgent: false,
      ubpIsApprove: false,
      ubpStatusCode: null,
      ubpIsEdit: false,

      /* begin: Set Select2 Options*/
      ubpAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductLoan/Select2SearchAgentOrg",
          data: function data(params) {
            var query = {
              userId: self.ubpBorrower,
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      ubpBorrowerOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/ProductLoan/Select2Borrower",
          data: function data(params) {
            var query = {
              userId: "",
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
      /* end: Set Select2 Options*/
    };
  },

  methods: {
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      this.plItems.push({
        plProductLoanItemId: null,
        plStatus: null,
        plProductId: null,
        plProductType: null,
        plQuota: null,
        plQty: 0,
        plPrice: 0,
        plAvgPrice: 0,
        plInitialPrice: 0,
        plAgent: null,
        plShopId: null,
        plShopActivityId: null,
        plActivityId: null,
        plIsShop: false,
        plActivityIdRemark: null,
        plReturnDate: null,
        plAvailableQty: 0,
        plStatusCode: null,
        selectedStatusCodeData: null,
        selectedProductData: null,
        selectedProductTypeData: null,
        selectedQuotaData: null,
        selectedAgentData: null,
        selectedShopData: null,
        selectedActivityData: null
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      var self = this;
      self.plItemsTemp = self.plItems;
      self.plItems = [];
      self.plItemsTemp.splice(index, 1);
      self.isChange = false;
      /*=== Binding items=== */
      setTimeout(function () {
        self.plItems = self.plItemsTemp;

        setTimeout(function () {
          for (var i = 0; i < self.plItems.length; i++) {
            /*=== Check Is Shop & Set Selected Select2=== */
            if (self.plItems[i].plShopId === null && self.plItems[i].plActivityId === null || self.plItems[i].plShopActivityId === null) {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData({
                id: "0",
                text: "ไม่ระบุ"
              });
            } else if (self.plItems[i].plActivityId != null) {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(self.plItems[i].selectedActivityData);
            } else {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(self.plItems[i].selectedShopData);
            }

            /*=== Check Is Agent & Set Selected Select2=== */
            if (self.plItems[i].plAgent === null) {
              self.$refs.plItems[i].$refs.plAgent.setSelectedData({
                id: "0",
                text: "ไม่ระบุ"
              });
            }
            if (self.plItems[i].plAgent !== null) {
              self.$refs.plItems[i].$refs.plAgent.setSelectedData(self.plItems[i].selectedAgentData);
            }

            /*=== Status : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plStatus.setSelectedData(self.plItems[i].selectedStatusCodeData);

            /*=== ProductId : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plProductId.setSelectedData(self.plItems[i].selectedProductData);
            /*=== ProductType : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plProductType.setSelectedData(self.plItems[i].selectedProductTypeData);

            /*=== Quota : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plQuota.setSelectedData(self.plItems[i].selectedQuotaData);

            /*=== Set DatePicker ReturnDate=== */
            if (self.plItems[i].plReturnDate != null) {
              $(self.$refs.plItems[i].$refs.plReturnDate).datepicker("update", self.plItems[i].plReturnDate.format("DD/MM/YYYY"));
            }
          }
        }, 50);

        // setTimeout(function() {
        //   for (let i = 0; i < self.plItems.length; i++) {
        //     /*=== Check Is Shop & Set Selected Select2=== */
        //     if (
        //       (self.plItems[i].plShopId === null &&
        //         self.plItems[i].plActivityId === null) ||
        //       self.plItems[i].plShopActivityId === null
        //     ) {
        //       self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData({
        //         id: "0",
        //         text: "ไม่ระบุ"
        //       });
        //     } else if (self.plItems[i].plActivityId != null) {
        //       self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(
        //         self.plItems[i].selectedActivityData
        //       );
        //     } else {
        //       self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(
        //         self.plItems[i].selectedShopData
        //       );
        //     }

        //     /*=== Check Is Agent & Set Selected Select2=== */
        //     if (self.plItems[i].plAgent === null) {
        //       self.$refs.plItems[i].$refs.plAgent.setSelectedData({
        //         id: "0",
        //         text: "ไม่ระบุ"
        //       });
        //     }
        //     if (self.plItems[i].plAgent !== null) {
        //       self.$refs.plItems[i].$refs.plAgent.setSelectedData(
        //         self.plItems[i].selectedAgentData
        //       );
        //     }

        //     /*=== Status : Set Selected Select2=== */
        //     self.$refs.plItems[i].$refs.plStatus.setSelectedData(
        //       self.plItems[i].selectedStatusCodeData
        //     );

        //     /*=== ProductId : Set Selected Select2=== */
        //     self.$refs.plItems[i].$refs.plProductId.setSelectedData(
        //       self.plItems[i].selectedProductData
        //     );
        //     /*=== ProductType : Set Selected Select2=== */
        //     self.$refs.plItems[i].$refs.plProductType.setSelectedData(
        //       self.plItems[i].selectedProductTypeData
        //     );

        //     /*=== Quota : Set Selected Select2=== */
        //     self.$refs.plItems[i].$refs.plQuota.setSelectedData(
        //       self.plItems[i].selectedQuotaData
        //     );

        //     /*=== Set DatePicker ReturnDate=== */
        //     if (self.plItems[i].plReturnDate != null) {
        //       $(self.$refs.plItems[i].$refs.plReturnDate).datepicker(
        //         "update",
        //         self.plItems[i].plReturnDate.format("DD/MM/YYYY")
        //       );
        //     }
        //   }
        // }, 50);
      }, 50);
    },

    formSubmit: function formSubmit() {
      //e.preventDefault();

      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.plItems.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการ", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var pItems = [];

      self.plItems.forEach(function (element) {
        pItems.push({
          ProductLoanItemId: element.plProductLoanItemId,
          Status: element.plStatus,
          ProductId: element.plProductId,
          ProductType: element.plProductType,
          AgentCode: element.plAgent,
          QuotaId: element.plQuota,
          Qty: element.plQty,
          Price: element.plPrice,
          ShopId: element.plShopId,
          ActivityId: element.plActivityId,
          IsShop: element.plIsShop,
          Remark: element.plActivityRemark,
          ReturnDate: element.plReturnDate != null ? element.plReturnDate.format("DD/MM/YYYY") : null
        });
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "put",
        url: "/Api/ProductLoan",
        data: {
          productLoanId: self.ubpProductLoanId,
          agentCode: self.ubpAgentCode,
          borrower: self.ubpBorrower,
          representName: self.ubpRepresentName,
          RepresentTel: self.ubpRepresentTel,
          requestDate: self.ubpReqDate,
          requestType: self.ubpRequestType,
          productGroupId: self.ubpProductGroup,
          amount: self.ubpAmount,
          isAgent: self.ubpIsAgent,
          productLoanItems: pItems
        }
      }).then(function (response) {
        if (response.data.status) {
          // Swal.fire("สำเร็จ", response.data.message, "success").then(
          //   function() {
          //     router.go(-1), self.$parent.reloadDataTable(false);
          //   }
          // );
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onAgentCodeChange: function onAgentCodeChange(id, text, data, ref) {
      var self = this;
      if (text !== "") {
        self.ubpIsAgent = data[0].data.agent;
      }
    },
    onProductGroupChange: function onProductGroupChange() {
      if (this.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
        this.ubpProductGroupId = "1";
      }
      if (this.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS") {
        this.ubpProductGroupId = "2";
      }
    },
    ubpBorrowerChange: function ubpBorrowerChange(id, text, data, ref) {
      var self = this;
      if (this.isChange) {
        $("#ubpAgentCode").val("").trigger("change");
      }

      setTimeout(function () {
        self.ubpProductGroupOptions = [];
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/ProductLoanProductGroupOptions", {
          params: {
            userId: self.ubpBorrower
          }
        }).then(function (response) {
          if (response.status == 200) {
            if (response.data.results != null && response.data.results.length > 0) {
              for (var i = 0; i < response.data.results.length; i++) {
                self.ubpProductGroupOptions.push({
                  id: response.data.results[i].id,
                  text: response.data.results[i].text
                });
              }
            }
          } else {
            Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้", "warning");
            router.go(-1);
          }
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้", "error");
          router.go(-1);
        }).then(function () {
          // always executed
          KTApp.unblockPage();
        });
      }, 10);
    },
    onRequestTypeChange: function onRequestTypeChange(e) {},
    onSendForApprove: function onSendForApprove(e) {
      var router = this.$router;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductLoan/" + this.$route.params.id + "/SendForApprove").then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        //router.go(-1);
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onApprove: function onApprove(e) {
      var _this = this;

      e.preventDefault();
      var self = this;
      var router = this.$router;

      console.log(self.plItems.length);

      //Validate form
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.plItems.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการ", "warning");
        return false;
      }

      Swal.fire({
        title: "คำสั่งอนุมัติการเบิก/ยืม",
        type: "warning",
        html: "กรุณายืนยันอนุมัติการเบิก/ยืม <strong>",
        inputValue: 0,
        inputPlaceholder: "อนุมัติการเบิก/ยืม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(result) {
          var pItems, i, element;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result.value) {
                    _context.next = 9;
                    break;
                  }

                  KTApp.blockPage({
                    opacity: 0.05,
                    message: "กำลังอนุมัติข้อมูล กรุณารอสักครู่..."
                  });

                  //UpdateBorrowProduct

                  if (!self.ubpIsEdit) {
                    _context.next = 7;
                    break;
                  }

                  //self.formSubmit();
                  pItems = [];
                  // self.plItems.forEach(element => {
                  //   pItems.push({
                  //     ProductLoanItemId: element.plProductLoanItemId,
                  //     Status: element.plStatus,
                  //     ProductId: element.plProductId,
                  //     ProductType: element.plProductType,
                  //     AgentCode: element.plAgent,
                  //     QuotaId: element.plQuota,
                  //     Qty: element.plQty,
                  //     Price: element.plPrice,
                  //     ShopId: element.plShopId,
                  //     ActivityId: element.plActivityId,
                  //     IsShop: element.plIsShop,
                  //     Remark: element.plActivityRemark,
                  //     ReturnDate:element.plReturnDate != null
                  //         ? element.plReturnDate.format("DD/MM/YYYY")
                  //         : null
                  //   });
                  // });

                  for (i = 0; i < self.plItems.length; i++) {
                    element = self.plItems[i];

                    pItems.push({
                      Index: i + 1,
                      ProductLoanItemId: element.plProductLoanItemId,
                      Status: element.plStatus,
                      ProductId: element.plProductId,
                      ProductType: element.plProductType,
                      AgentCode: element.plAgent,
                      QuotaId: element.plQuota,
                      Qty: element.plQty,
                      Price: element.plPrice,
                      ShopId: element.plShopId,
                      ActivityId: element.plActivityId,
                      IsShop: element.plIsShop,
                      Remark: element.plActivityRemark,
                      ReturnDate: element.plReturnDate != null ? element.plReturnDate.format("DD/MM/YYYY") : null
                    });
                  }

                  // AXIOS POST STEP 1 HARE
                  _context.next = 7;
                  return new Promise(function (resolve) {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                      method: "put",
                      url: "/Api/ProductLoan",
                      data: {
                        productLoanId: self.ubpProductLoanId,
                        agentCode: self.ubpAgentCode,
                        borrower: self.ubpBorrower,
                        representName: self.ubpRepresentName,
                        RepresentTel: self.ubpRepresentTel,
                        requestDate: self.ubpReqDate,
                        requestType: self.ubpRequestType,
                        productGroupId: self.ubpProductGroup,
                        amount: self.ubpAmount,
                        isAgent: self.ubpIsAgent,
                        productLoanItems: pItems,
                        remark: self.ubpRemark
                      }
                    }).then(function (response) {
                      if (response.data.status) {
                        resolve('resolved');
                        // Swal.fire("สำเร็จ", response.data.message, "success").then(
                        //   function() {
                        //     router.go(-1), self.$parent.reloadDataTable(false);
                        //   }
                        // );
                      } else {
                        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                      }
                    }).catch(function (error) {
                      Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                      KTApp.unblockPage();
                    }).then(function () {
                      // always executed
                      //KTApp.unblockPage();
                    });
                  });

                case 7:
                  _context.next = 9;
                  return new Promise(function (resolve) {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductLoan/" + _this.$route.params.id + "/Approve").then(function (response) {
                      if (response.data.status) {
                        resolve('resolved');
                        Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                          //router.go(-1), self.$parent.reloadDataTable(false);
                          router.push({ path: "/Borrow" });
                          self.$parent.reloadDataTable(false);
                        });
                      } else {
                        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                      }
                    }).catch(function (error) {
                      Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                    }).then(function () {
                      // always executed
                      KTApp.unblockPage();
                    });
                  });

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    onReject: function onReject(e) {
      var _this2 = this;

      e.preventDefault();
      var self = this;
      var router = this.$router;
      Swal.fire({
        title: "คำสั่งไม่อนุมัติเบิกคลังสินค้า",
        type: "warning",
        html: "กรุณายืนยันไม่อนุมัติเบิกคลังสินค้า <strong>",
        input: "text",
        inputAttributes: {
          autocapitalize: "off"
        },
        // inputValue: 0,
        inputPlaceholder: "กรุณาระบุหมายเหตุผลไม่อนุมัติเบิกคลังสินค้า",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        inputValidator: function inputValidator(value) {
          return new Promise(function (resolve) {
            if (value === "") {
              resolve("กรุณาระบุหมายเหตุผลไม่อนุมัติเบิกคลังสินค้า");
            } else {
              resolve();
            }
          });
        }
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_0_axios___default()({
            method: "post",
            url: "/Api/ProductLoan/Reject",
            data: {
              Id: _this2.$route.params.id,
              Remark: result.value
            }
          })
          // .post("/Api/ProductLoan/" + this.$route.params.id + "/Reject",)
          .then(function (response) {
            if (response.data.status) {
              Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                //router.go(-1), self.$parent.reloadDataTable(false);
                router.push({ path: "/Borrow" });
                self.$parent.reloadDataTable(false);
              });
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        } else {}
      });
    },
    copyNote: function copyNote() {
      var _this3 = this;

      Swal.fire({
        title: "คำสั่งแก้ไข หมายเหตุกิจกรรม",
        type: "warning",
        html: "กรุณายืนยันคำสั่งคัดลอกแก้ไข หมายเหตุกิจกรรม ทั้งหมดตามข้อมูลแถวที่ 1",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {

        if (result.value) {
          var self = _this3;
          // Start copy comment
          if (self.plItems != null && self.plItems.length > 0) {
            // copy activityRemark from 1st row.
            var activityRemarkRow1 = self.plItems[0].plActivityRemark;

            for (var i = 1; i < self.plItems.length; i++) {
              //self.plItems[i].plActivityRemark = activityRemarkRow1;
              self.$set(self.plItems[i], 'plActivityRemark', activityRemarkRow1);
            }
          }
        }
      });
    }
  },
  computed: {
    totalCal: function totalCal() {
      var self = this;
      var totalSum = 0;
      if (self.plItems != null && self.plItems.length > 0) {
        for (var i = 0; i < self.plItems.length; i++) {
          if (self.plItems[i].plInitialPrice != 0) {
            totalSum += Number(self.plItems[i].plQty * self.plItems[i].plInitialPrice);
            self.plItems[i].plPrice = self.plItems[i].plInitialPrice;
          } else {
            totalSum += Number(self.plItems[i].plQty * self.plItems[i].plAvgPrice);
            self.plItems[i].plPrice = self.plItems[i].plAvgPrice;
          }

          // if (self.plItems[i].plAvgPrice != 0) {
          //   totalSum += Number(
          //     self.plItems[i].plQty * self.plItems[i].plAvgPrice
          //   );
          //   self.plItems[i].plPrice = self.plItems[i].plAvgPrice;
          // } else {
          //   totalSum += Number(
          //     self.plItems[i].plQty * self.plItems[i].plInitialPrice
          //   );
          //   self.plItems[i].plPrice = self.plItems[i].plInitialPrice;
          // }
          self.ubpAmount = totalSum;
        }
      }
      return totalSum;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, arrows, table;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this4;
              router = _this4.$router;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.ubpReqDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                //startDate: moment().format("DD/MM/YYYY"), //Current day
                //endDate: moment().format("DD/MM/YYYY"), //Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              self.ubpReqDate = moment();
              $(self.$refs.ubpReqDate).datepicker("update", self.ubpReqDate.format("DD/MM/YYYY")).on("changeDate", function (e) {
                self.ubpReqDate = moment(e.date);
              });

              //Begin :Get Value RequestType CheckBox
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/Options", {
                params: {
                  search: "PRODUCT_LOAN_REQUEST_TYPE"
                }
              }).then(function (response) {
                if (response.status == 200) {
                  if (response.data.results != null && response.data.results.length > 0) {
                    for (var i = 0; i < response.data.results.length; i++) {
                      self.ubpRequestTypeOptions.push({
                        id: response.data.results[i].id,
                        text: response.data.results[i].text
                      });
                    }
                  }
                  return self.ubpRequestTypeOptions;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });
              //End :Get Value RequestType CheckBox

              //Begin :Get Value ProductGroup Radio checkbox
              // axios
              //   .get("/Api/Variables/Options", {
              //     params: {
              //       search: "PRODUCT_LOAN_PRODUCT_GROUP"
              //     }
              //   })
              //   .then(function(response) {
              //     if (response.status == 200) {
              //       if (
              //         response.data.results != null &&
              //         response.data.results.length > 0
              //       ) {
              //         for (let i = 0; i < response.data.results.length; i++) {
              //           self.ubpProductGroupOptions.push({
              //             id: response.data.results[i].id,
              //             text: response.data.results[i].text
              //           });
              //         }
              //       }
              //     } else {
              //       Swal.fire(
              //         "เกิดข้อผิดพลาด",
              //         "ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
              //         "warning"
              //       );
              //       router.go(-1);
              //     }
              //   })
              //   .catch(function(error) {
              //     Swal.fire(
              //       "เกิดข้อผิดพลาด",
              //       "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
              //       "error"
              //     );
              //     router.go(-1);
              //   })
              //   .then(function() {
              //     // always executed
              //     KTApp.unblockPage();
              //   });
              //End :Get Value ProductGroup Radio checkbox

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductLoan/" + _this4.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  if (response.data != null) {
                    self.ubpProductLoanId = response.data.productLoanHeaderId;
                    self.ubpDocNo = response.data.requestDocNo;
                    self.ubpRepresentName = response.data.representativeName;
                    self.ubpRepresentTel = response.data.representativeNameL;
                    self.ubpStatusCode = response.data.productLoanStatusCode;
                    self.ubpIsApprove = response.data.isApprove;
                    self.ubpIsEdit = response.data.isEdit;
                    self.ubpBorrower = response.data.requestUser;
                    if (response.data.requestUserId) {
                      self.$refs.ubpBorrowerSelect2.setSelectedData({
                        id: response.data.requestUserId,
                        text: response.data.requestUser
                      });
                    }
                    // self.ubpAgentCode = response.data.agentOrgName;
                    setTimeout(function () {
                      if (response.data.agentOrgCode) {
                        self.$refs.ubpAgentSelect2.setSelectedData({
                          id: response.data.agentOrgCode,
                          text: response.data.agentOrgName,
                          data: {
                            agent: response.data.isAgent,
                            org: !response.data.isAgent,
                            id: response.data.agentOrgCode
                          }
                        });
                      }
                    }, 50);
                    self.ubpReqDate = response.data.requestDateFormat;

                    self.ubpIsAgent = response.data.isAgent;
                    self.ubpRequestType = response.data.requestTypeList;
                    self.ubpProductGroup = response.data.productGroupId;
                    if (self.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
                      self.ubpProductGroupId = "1";
                    }
                    if (self.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS") {
                      self.ubpProductGroupId = "2";
                    }

                    self.ubpRemark = response.data.remark;
                    self.ubpAmount = response.data.amount;
                    if (response.data.productLoanItem.length > 0) {
                      var _loop = function _loop(i) {
                        item = response.data.productLoanItem[i];

                        self.plItems.push({
                          plProductId: item.materialCode,
                          plProductType: item.productTypeId,
                          plProductLoanItemId: item.productLoanItemId,
                          plStatus: item.statusCode,
                          selectedStatusCodeData: {
                            id: item.statusCode,
                            text: item.statusName,
                            data: null
                          },
                          selectedProductData: {
                            id: item.materialCode,
                            text: item.materialName + " [" + item.materialCode + "]",
                            data: item.productData
                          },
                          selectedProductTypeData: {
                            id: item.productTypeId,
                            text: item.productTypeName,
                            data: null
                          },
                          plQuota: item.quotaId,
                          selectedQuotaData: {
                            id: item.quotaId,
                            text: item.quotaName,
                            data: null
                          },
                          plAgent: item.agentCode,
                          selectedAgentData: {
                            id: item.agentCode,
                            text: "[" + item.agentCode + "] " + item.agentCodeName,
                            data: null
                          },
                          plShopId: item.shopId,
                          selectedShopData: {
                            id: item.shopId,
                            text: item.shopName,
                            data: null
                          },
                          plActivityId: item.activityId,
                          selectedActivityData: {
                            id: item.activityId,
                            text: item.activityName
                          },
                          plQty: item.qty, //Stamp Qty
                          plAvailableQty: item.productData.availableQTY, //Current Qty
                          plPrice: 0, //Stamp Price
                          plAvgPrice: item.productData.avgPrice, //Current avgPrice
                          plInitialPrice: item.productData.initialPrice, //Current initialPrice
                          plIsShop: item.shopId != null ? true : false,
                          plShopActivityId: "",
                          plActivityRemark: item.activityRemark,
                          plReturnDate: item.returnDateFormat != null ? moment(item.returnDateFormat, "DD/MM/YYYY") : null
                        });
                        setTimeout(function () {
                          /*=== Status : Set Selected Select2=== */
                          self.$refs.plItems[i].$refs.plStatus.setSelectedData(self.plItems[i].selectedStatusCodeData);
                          /*=== ProductType : Set Selected Select2=== */
                          self.$refs.plItems[i].$refs.plProductType.setSelectedData(self.plItems[i].selectedProductTypeData);
                          setTimeout(function () {
                            /*=== ProductId : Set Selected Select2=== */
                            self.$refs.plItems[i].$refs.plProductId.setSelectedData(self.plItems[i].selectedProductData);
                          }, 100);
                          /*=== Quota : Set Selected Select2=== */
                          self.$refs.plItems[i].$refs.plQuota.setSelectedData(self.plItems[i].selectedQuotaData);
                          /*=== Check Is Agent & Set Selected Select2=== */
                          if (self.plItems[i].plAgent === null) {
                            self.$refs.plItems[i].$refs.plAgent.setSelectedData({
                              id: "0",
                              text: "ไม่ระบุ"
                            });
                          } else if (self.plItems[i].plAgent !== null) {
                            self.$refs.plItems[i].$refs.plAgent.setSelectedData(self.plItems[i].selectedAgentData);
                          }
                          setTimeout(function () {
                            /*=== Set Selected Select2 ShopActivity=== */
                            if (self.plItems[i].plShopActivityId == "") {
                              /*=== Set Selected Select2 ShopActivity is "ไม่ระบุ"=== */
                              if (self.plItems[i].plShopId === null && self.plItems[i].plActivityId === null) {
                                self.plItems[i].plShopActivityId = "0";
                                self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData({
                                  id: "0",
                                  text: "ไม่ระบุ"
                                });
                              }
                              //=== Set Selected Select2 ShopActivity is "Activity"===//
                              else if (self.plItems[i].plActivityId != null) {
                                  self.plItems[i].plShopActivityId = self.plItems[i].plActivityId;
                                  self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(self.plItems[i].selectedActivityData);
                                }
                                //=== Set Selected Select2 ShopActivity is "Shop"===//
                                else {
                                    self.plItems[i].plShopActivityId = self.plItems[i].plShopId;
                                    self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(self.plItems[i].selectedShopData);
                                  }
                            }
                          }, 100);
                          /*=== set datepicker returnDate === */
                          if (self.plItems[i].plReturnDate != null) {
                            $(self.$refs.plItems[i].$refs.plReturnDate).datepicker("update", self.plItems[i].plReturnDate.format("DD/MM/YYYY"));
                          }
                          self.isChange = true;
                        }, 300);
                      };

                      for (var i = 0; i < response.data.productLoanItem.length; i++) {
                        var item;

                        _loop(i);
                      }
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed

                KTApp.unblockPage();
              });

              table = $("#table-history");

              // begin first table

              table.DataTable({
                responsive: true,
                // processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/ProductLoan/ApproveHistorySearch",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      ProductLoanId: self.$route.params.id
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12'tr>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[2, "desc"]],
                select: {
                  style: "multi",
                  selector: "td:first-child"
                },
                columns: [{ data: "createdDateFormat", className: "text-center" }, { data: "approveUser", className: "text-center" }, { data: "approveLevel", className: "text-center" }, { data: "approveStatus", className: "text-center" }, { data: "remark", className: "text-center" }]
              }).on("draw.dt", function () {});
              // table.trigger("draw.dt"); //call ajax delete this row

              // set validation rules
              $(self.$refs.form).validate({
                rules: {
                  ubpAgentCode: "required",
                  ubpBorrower: "required",
                  ubpRequestDate: "required",
                  ubpRequestType: "required",
                  ubpProductGroup: "required"
                },
                messages: {
                  ubpAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
                  ubpBorrower: "กรุณากรอกผู้ขอเบิก/ยืม",
                  ubpRequestDate: "กรุณากรอกวันที่",
                  ubpRequestType: "กรุณาเลือกประเภทใบคำร้องขอ",
                  ubpProductGroup: "กรุณาเลือกหมวดหมู่สินค้า"
                }
              });

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JobBorrowProductRow__ = __webpack_require__(1189);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    JobBorrowProductRow: __WEBPACK_IMPORTED_MODULE_3__JobBorrowProductRow__["a" /* default */],
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      qty: null,
      tpbPlantId: null,
      tpbProductId: null,
      jobsBorrow: [],
      jobsBorrowName: null,
      itemjobBTransit: null,
      jobBTransitOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          url: "/Api/Transport/Select2Transport",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              showVendorTransport: false,
              agentCodes: []
            };

            return JSON.stringify(query);
          },

          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var router = this.$router;
      var self = this;

      if (!$("#JobBorrowProductModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var jItems = [];

      self.jobsBorrow.forEach(function (element) {
        var pItems = [];
        element.items.forEach(function (p) {
          pItems.push({
            MaterialCode: p.materialCode,
            Qty: p.qty,
            QuotaId: p.quotaId,
            BorrowQuantity: p.borrowQuantity
          });
        });

        jItems.push({
          ProductLoanHeaderId: element.productLoanHeaderId,
          BorrowerId: element.borrowerId,
          BorrowerIsAgent: element.borrowerIsAgent,
          IsPickUp: element.isPickUp,
          AgentCode: element.agentCode,
          TransitId: element.TransitId,
          RequestDate: element.requestDate,
          NextShopCode: element.isAgent ? element.shopActivityId : null,
          ActivityId: element.isActivity ? element.shopActivityId : null,
          ActivityRemark: element.activityRemark,
          Items: pItems
        });
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/ProductLoan/OpenJob",
        data: {
          Obj: jItems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $("#JobBorrowProductModal").modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error").then(function () {
            $("#JobBorrowProductModal").modal("hide");
          });
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error").then(function () {
          $("#JobBorrowProductModal").modal("hide");
        });
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              // set validation rules
              $("#JobBorrowProductModal form").validate({
                rules: {
                  tpbPlantId: "required",
                  tpbProductId: "required",
                  qty: "required"
                },
                messages: {
                  tpbPlantId: "กรุณาเลือกชื่อเจ้าของทรัพย์สิน",
                  tpbProductId: "กรุณาเลือกสินค้า",
                  qty: "กรุณาระบุจำนวน"
                }
              });

              $("#JobBorrowProductModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              });

              __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductLoan/GetJob/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  if (response.data != null && response.data.length > 0) {
                    self.jobsBorrow = response.data;
                    self.jobsBorrowName = response.data[0].borrowerName;
                  }
                  $("#JobBorrowProductModal").modal("show");
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก", "warning");
                  //router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้", "error");
                //router.go(-1);
              }).then(function () {
                // always executed

                KTApp.unblockPage();
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JobBorrowProductReturnItemRow__ = __webpack_require__(1188);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__["a" /* default */],
    ProductReturnItemRow: __WEBPACK_IMPORTED_MODULE_4__JobBorrowProductReturnItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      isChange: false,
      plItems: [],
      plItemsTemp: [],
      i: 0,
      ubpDocNo: null,
      ubpProductLoanId: null,
      ubpBorrower: null,
      ubpBorrowerId: null,
      //ubpCompanyProfile: null,
      ubpAgentCode: null,
      ubpRepresentName: null,
      ubpRepresentTel: null,
      ubpReqDate: null,
      ubpReqDateString: null,
      ubpRequestType: [],
      ubpRequestTypeOptions: [],
      ubpProductGroup: null,
      ubpProductGroupId: null,
      ubpProductGroupOptions: [],
      ubpRemark: null,
      ubpIsAgent: false,
      ubpIsApprove: false,
      ubpStatusCode: null,
      ubpIsEdit: false,
      isSubmitting: false

      /* begin: Set Select2 Options*/
      //   ubpAgentOptions: {
      //     placeholder: "กรุณาเลือก",
      //     allowClear: true,
      //     ajax: {
      //       url: "/Api/ProductLoan/Select2SearchAgentOrg",
      //       data: function(params) {
      //         var query = {
      //           userId: self.ubpBorrower,
      //           search: params.term,
      //           page: params.page || 1
      //         };
      //         return query;
      //       },
      //       processResults: function(data, params) {
      //         return {
      //           results: data.results,
      //           pagination: {
      //             more: data.more
      //           }
      //         };
      //       },
      //       transport: function(params, success, failure) {
      //         params.beforeSend = function(request) {
      //           request.setRequestHeader(
      //             "Authorization",
      //             "Bearer " + self.$root.user.access_token
      //           );
      //         };
      //         var $request = $.ajax(params);
      //         $request.then(success);
      //         $request.fail(failure);
      //         return $request;
      //       }
      //     }
      //   },
      //   ubpBorrowerOptions: {
      //     placeholder: "กรุณาเลือก",
      //     allowClear: true,
      //     ajax: {
      //       delay: 300,
      //       url: "/Api/ProductLoan/Select2Borrower",
      //       data: function(params) {
      //         var query = {
      //           userId: "",
      //           search: params.term,
      //           page: params.page || 1
      //         };
      //         return query;
      //       },
      //       processResults: function(data, params) {
      //         return {
      //           results: data.results,
      //           pagination: {
      //             more: data.more
      //           }
      //         };
      //       },
      //       transport: function(params, success, failure) {
      //         params.beforeSend = function(request) {
      //           request.setRequestHeader(
      //             "Authorization",
      //             "Bearer " + self.$root.user.access_token
      //           );
      //         };
      //         var $request = $.ajax(params);
      //         $request.then(success);
      //         $request.fail(failure);
      //         return $request;
      //       }
      //     }
      //   }
      /* end: Set Select2 Options*/
    };
  },

  methods: {
    formSubmit: function formSubmit(e) {
      if (this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      e.preventDefault();

      var router = this.$router;
      var self = this;

      var pItems = [];
      self.plItems.forEach(function (element) {
        pItems.push({
          ProductLoanItemId: element.plProductLoanItemId,
          MaterialCode: element.plProductId,
          AgentCode: element.plAgentCode,
          QuotaId: element.plQuotaId,
          Qty: element.plQty,
          Damaged: element.plDamaged > 0 ? element.plDamaged : 0,
          Lost: element.plLost > 0 ? element.plLost : 0,
          Return: element.plReturn > 0 ? element.plReturn : 0
          // Damaged: element.plDamaged != null ? element.plDamaged : 0,
          // Lost: element.plLost != null ? element.plLost : 0,
          // Return: element.plReturn != null ? element.plReturn : 0,
        });
      });

      var jItems = {
        ProductLoanHeaderId: self.ubpProductLoanId,
        RequestDate: self.ubpReqDate,
        BorrowerId: self.ubpBorrowerId,
        Remark: self.ubpRemark,
        Items: pItems
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/ProductLoan/OpenJobReturn",
        data: {
          Obj: jItems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
        this.isSubmitting = false;
      });
    },
    onProductGroupChange: function onProductGroupChange() {
      if (this.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
        this.ubpProductGroupId = "1";
      }
      if (this.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS") {
        this.ubpProductGroupId = "2";
      }
    },
    onRequestTypeChange: function onRequestTypeChange(e) {}
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              //Begin :Get Value RequestType CheckBox
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/Options", {
                params: {
                  search: "PRODUCT_LOAN_REQUEST_TYPE"
                }
              }).then(function (response) {
                if (response.status == 200) {
                  if (response.data.results != null && response.data.results.length > 0) {
                    for (var i = 0; i < response.data.results.length; i++) {
                      self.ubpRequestTypeOptions.push({
                        id: response.data.results[i].id,
                        text: response.data.results[i].text
                      });
                    }
                  }
                  return self.ubpRequestTypeOptions;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });
              //End :Get Value RequestType CheckBox

              //Begin :Get Value ProductGroup Radio checkbox
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/Options", {
                params: {
                  search: "PRODUCT_LOAN_PRODUCT_GROUP"
                }
              }).then(function (response) {
                if (response.status == 200) {
                  if (response.data.results != null && response.data.results.length > 0) {
                    for (var i = 0; i < response.data.results.length; i++) {
                      self.ubpProductGroupOptions.push({
                        id: response.data.results[i].id,
                        text: response.data.results[i].text
                      });
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });
              //End :Get Value ProductGroup Radio checkbox

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductLoan/GetJobReturn/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  if (response.data != null) {
                    self.ubpProductLoanId = response.data.productLoanHeaderId;
                    self.ubpDocNo = response.data.requestDocNo;
                    self.ubpRepresentName = response.data.representativeName;
                    self.ubpRepresentTel = response.data.representativeNameL;
                    self.ubpStatusCode = response.data.productLoanStatusCode;
                    self.ubpIsApprove = response.data.isApprove;
                    self.ubpIsAgent = response.data.isAgent;
                    self.ubpBorrower = response.data.requestUser;
                    self.ubpBorrowerId = response.data.requestUserId;
                    self.ubpAgentCode = response.data.agentOrgName;
                    self.ubpRemark = response.data.remark;

                    self.ubpRequestType = response.data.requestTypeList;
                    self.ubpProductGroup = response.data.productGroupId;

                    if (self.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
                      self.ubpProductGroupId = "1";
                    }
                    if (self.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS") {
                      self.ubpProductGroupId = "2";
                    }

                    self.ubpReqDateString = response.data.requestDateFormat;
                    self.ubpReqDate = response.data.requestDate;
                    if (response.data.productItem.length > 0) {
                      for (var i = 0; i < response.data.productItem.length; i++) {
                        var item = response.data.productItem[i];
                        var IsDisabled = false;
                        if (item.outstanding < 1) {
                          IsDisabled = true;
                        }
                        self.plItems.push({
                          //   plProductId: item.materialCode,
                          //   plProductType: item.productTypeId,
                          plProductLoanItemId: item.productLoanItemId,
                          plStatus: item.statusName,
                          plProductType: item.productTypeName,
                          plProductId: item.materialCode,
                          plProductName: item.materialName + " [" + item.materialCode + "]",
                          plQuota: item.quotaName,
                          plQuotaId: item.quotaId,
                          plAgent: item.agentCode != null ? "[" + item.agentCode + "] " + item.agentCodeName : "ไม่ระบุ",
                          plAgentCode: item.agentCode,
                          plShopActivityName: item.shopActivityName,
                          plQty: item.qty,
                          plActivityRemark: item.activityRemark,
                          plReturnDate: item.returnDateFormat,
                          plOutstanding: item.outstanding,
                          plReturn: null,
                          plDamaged: null,
                          plLost: null,
                          plIsHide: item.hasBarcode,
                          plReqDateString: response.data.requestDateFormat,
                          IsDisabled: IsDisabled
                        });
                      }
                    } else {
                      Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลรายการยืม", "warning");
                      router.go(-1);
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed

                KTApp.unblockPage();
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_1__Shared_Datepicker__["a" /* default */]
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var self = this;

    return {
      CheckStockAnswer: "",
      itemStatus: null,
      itemQty: 0,
      itemProductId: null,
      itemProductType: null,
      itemQuota: null,
      itemAgent: null,
      itemShopActivityId: null,
      requiredRemark: false,
      requiredDate: false

    };
  },


  methods: {
    preventInvalidChars: function preventInvalidChars(event) {
      if (event.key === '.' || event.key === '+' || event.key === '-' || event.key === 'e' || event.key === 'E') {
        event.preventDefault();
      }
    },
    checkTotal: function checkTotal(val) {
      var plReturn = this.item.plReturn !== null && !isNaN(this.item.plReturn) ? parseInt(this.item.plReturn) : 0;
      var plDamaged = this.item.plDamaged !== null && !isNaN(this.item.plDamaged) ? parseInt(this.item.plDamaged) : 0;
      var plLost = this.item.plLost !== null && !isNaN(this.item.plLost) ? parseInt(this.item.plLost) : 0;
      var total = plReturn + plDamaged + plLost;
      if (total > this.item.plOutstanding) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("", "ไม่สามารถระบุตัวเลขเกินจำนวนคงเหลือของรายการ", "warning");
        if (val == 1) {
          this.item.plReturn = null;
        } else if (val == 2) {
          this.item.plDamaged = null;
        } else {
          this.item.plLost = null;
        }
      }
    }
  },
  mounted: function mounted() {
    var self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>'
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>'
      };
    }

    $(self.$refs.plReturnDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows
    });

    $(self.$refs.plReturnDate)
    //.datepicker("update", self.item.plReturnDate.format("DD/MM/YYYY"))
    .on("changeDate", function (e) {
      e.date != undefined ? self.item.plReturnDate = moment(e.date) : self.item.plReturnDate = null;
    });
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  props: {
    rowIndex: Number,
    itemIndex: Number,
    showHeader: {
      type: Boolean,
      default: true
    },
    rootItems: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var self = this;

    return {
      itemjobBTransit: null,
      jobBTransitOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Transport/Select2Transport",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              showVendorTransport: true,
              agentCodes: []
            };

            return JSON.stringify(query);
          },

          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  methods: {
    onjobBTransitChange: function onjobBTransitChange(id, text, data, ref) {
      var self = this;

      self.item.TransitId = self.itemjobBTransit;
    },
    updatePickUpStatus: function updatePickUpStatus(e) {
      var self = this;
      if (e.target.checked) {
        self.item.isPickUp = true;
      } else {
        self.item.isPickUp = false;
      }
    }
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n  <a href=\"#\" @click.prevent=\"detail\" v-if=\"data.showDetailButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-search\"></i>\n    </a>\n    <a :href=\"'/Print/BorrowRetrievePrint/' + data.productLoanHeaderId\" target=\"_blank\" v-if=\"data.showDetailButton\" title=\"\u0E43\u0E1A\u0E08\u0E48\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n        <i class=\"la la-print\" style=\"color: #800080\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"openJob\" v-if=\"data.showopenJobButton\" title=\"\u0E40\u0E1B\u0E34\u0E14 Job\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"kt-font-priceTier flaticon-file-1 kt-font-success\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"openJobReturn\" v-if=\"data.showopenJobReturnButton\" title=\"\u0E40\u0E1B\u0E34\u0E14 Job \u0E23\u0E31\u0E1A\u0E04\u0E37\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"kt-font-priceTier flaticon-interface-4 kt-font-danger\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"openJobCompleted('complete')\" v-if=\"data.showOpenJobCompletedButton\" title=\"\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"fa fa-archive kt-font-primary\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"openJobCompleted('done')\" v-if=\"data.showOpenJobDoneButton\" title=\"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E40\u0E1B\u0E47\u0E19 &quot;\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22&quot;\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-refresh kt-font-success\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"approve\" v-if=\"data.showApproveButton\" title=\"\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-file-text\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"print\" v-if=\"data.showprintButton\" title=\"\u0E1E\u0E34\u0E21\u0E1E\u0E4C\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"fas fa-print\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"deleteProductLoan\" v-if=\"data.showDeleteButton\" title=\"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"undo\" v-if=\"data.showUndoButton\" title=\"\u0E16\u0E2D\u0E22\u0E2A\u0E16\u0E32\u0E19\u0E30\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"fas fa-undo-alt\"></i>\n    </a>\n  </div>",
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Borrow/Edit/" + this.data.productLoanHeaderId
      });
    },
    detail: function detail() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Borrow/Edit/" + this.data.productLoanHeaderId
      });
    },
    approve: function approve() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Borrow/Approve/" + this.data.productLoanHeaderId
      });
    },
    openJob: function openJob() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Borrow/OpenJop/" + this.data.productLoanHeaderId
      });
    },
    openJobReturn: function openJobReturn() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Borrow/OpenJopReturn/" + this.data.productLoanHeaderId
      });
    },
    deleteProductLoan: function deleteProductLoan() {
      var _this = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งยกเลิกข้อมูลการเบิก/ยืม",
        type: "warning",
        html: "กรุณายืนยันคำสั่งยกเลิกข้อมูลการเบิก/ยืม <strong>" + "</strong> หลังจากยกเลิกแล้วจะส่งผลให้ข้อมูลการเบิก/ยืมนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ยกเลิกข้อมูลการเบิก/ยืม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/ProductLoan/" + _this.data.productLoanHeaderId + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    openJobCompleted: function openJobCompleted(type) {
      var _this2 = this;

      var self = this;
      var alerttext = "กรุณายืนยันคำสั่งปรับสถานะการเปิดใบงาน <strong>" + "</strong> หลังจากปรับสถานะการเปิดใบงานเป็นเสร็จสิ้นแล้วจะส่งผลให้เอกสารนั้นดูได้อย่างเดียว";
      if (type == 'done') {
        alerttext = "</strong> กรุณายืนยันคำสั่งปรับสถานะคอลัมน์เปิดใบงานเป็น \"ดำเนินการเรียบร้อย\"";
      }
      Swal.fire({
        title: "คำสั่งปรับสถานะการเปิดใบงาน",
        type: "warning",
        html: alerttext,
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ปรับสถานะการเปิดใบงาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/ProductLoan/" + _this2.data.productLoanHeaderId + "/OpenJobCompleted?type=" + type).then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      mbpAgent: null,
      mbpReqUser: null,
      mbpReqType: null,
      mbpReqDate: null,
      mbpReqDocNo: null,
      mbpReqStatus: null,
      mbpReqSearch: null,
      mbpOpenJopStatusCodes: [],
      mbpProductGroupId: null,
      mbpProductIds: [],

      mbpAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductLoan/Select2AgentOrg4Search",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      mbpReqTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "PRODUCT_LOAN_REQUEST_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      mbpReqStatusOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "PRODUCT_LOAN_STATUS",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      mbpOpenJopStatusCodesOptions: [],
      // mbpOpenJopStatusCodesOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options",
      //     data: function(params) {
      //       var query = {
      //         search: "OPEN_JOB_STATUS",
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      mbpProductGroupOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "PRODUCT_LOAN_PRODUCT_GROUP",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      mbpProductIdsOptions: []
      // mbpProductIdsOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: false,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       let productGroupId = "";
      //       if (self.mbpProductGroupId != null) {
      //         if (self.mbpProductGroupId == "PRODUCT_LOAN_PRODUCT_GROUP_SPARE")
      //           productGroupId = "1";
      //         else if (
      //           self.mbpProductGroupId == "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS"
      //         )
      //           productGroupId = "2";
      //       }

      //       var query = {
      //         search: params.term,
      //         // productTypeId:
      //         //   self.item.plProductType != null ? self.item.plProductType : "",
      //         productGroupId: productGroupId,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.mbpReqDate = null;
      self.mbpReqSearch = null;
      self.mbpProductIds = [];

      $("#mbpReqDate").val("").trigger("change");

      $("#mbpAgent").val("").trigger("change");

      $("#mbpReqType").val("").trigger("change");

      $("#mbpReqStatus").val("").trigger("change");

      $("#mbpProductGroupId").val("").trigger("change");

      $("#mbpProductIds").val("").trigger("change");

      //set default OpenJobStatus
      self.mbpOpenJopStatusCodes = ["OPEN_JOB_STATUS_WAITING", "OPEN_JOB_STATUS_DONE"];

      self.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#table").DataTable();
      table.search(this.id);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#table").DataTable().ajax.reload(null, resetPaging);
    },
    CheckRoute: function CheckRoute() {
      var url = this.$route.path;
      if (url == "/Borrow/Edit/" + this.$root.$route.params.id) return false;else if (url == "/Borrow/Approve/" + this.$root.$route.params.id) return false;else if (url == "/Borrow/OpenJopReturn/" + this.$root.$route.params.id) return false;else if (url == "/Borrow/Add") return false;else return true;
    },

    LoadalAreaNewOptions: function LoadalAreaNewOptions(e) {
      var self = this;

      var productGroupId = "";
      if (self.mbpProductGroupId != null) {
        if (self.mbpProductGroupId == "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") productGroupId = "1";else if (self.mbpProductGroupId == "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS") productGroupId = "2";
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          productGroupId: productGroupId,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.mbpProductIdsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadmbpOpenJopStatusCodesOptions: function LoadmbpOpenJopStatusCodesOptions(e) {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options", {
        params: {
          search: "OPEN_JOB_STATUS",
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.mbpOpenJopStatusCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;


              self.LoadalAreaNewOptions();
              self.LoadmbpOpenJopStatusCodesOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.mbpReqDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });

              //self.mbpReqDate = moment();
              $(self.$refs.mbpReqDate)
              //.datepicker("update", self.mbpReqDate.format("DD/MM/YYYY"))
              .on("changeDate", function (e) {
                self.mbpReqDate = moment(e.date);
              });

              //set default OpenJobStatus
              self.mbpOpenJopStatusCodes = ["OPEN_JOB_STATUS_WAITING", "OPEN_JOB_STATUS_DONE"];
              // self.$refs.mbpOpenJopStatusCodes.setSelectedData([
              //   { id: "OPEN_JOB_STATUS_WAITING", text: "รอดำเนินการ" },
              //   { id: "OPEN_JOB_STATUS_DONE", text: "ดำเนินการเรียบร้อย" },
              // ]);
              $.fn.dataTable.ext.errMode = 'none';
              table = $("#table");

              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/ProductLoan/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    //check for clear date value
                    var idDate = $("#mbpReqDate").val();
                    if (idDate == null || idDate == "") self.mbpReqDate = null;

                    var jsonSearch = {
                      AgentId: self.mbpAgent,
                      CreatedUser: self.mbpReqUser,
                      RequestDocNo: self.mbpReqDocNo,
                      RequestDocType: self.mbpReqType,
                      RequestDate: self.mbpReqDate != null ? self.mbpReqDate.format("DD/MM/YYYY") : self.mbpReqDate,
                      ProductLoanStatus: self.mbpReqStatus,
                      OpenJopStatusCodes: self.mbpOpenJopStatusCodes,
                      ProductIds: self.mbpProductIds,
                      SearchKeyword: self.mbpReqSearch,
                      ProductGroupId: self.mbpProductGroupId
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[1, "desc"]],
                select: {
                  style: "multi",
                  selector: "td:first-child"
                },
                columns: [{ data: "requestDateFormat", className: "text-center" }, { data: "requestDocNo", className: "text-center" }, { data: "requestTypeName", className: "text-center" }, { data: "productGroupName", className: "text-center" }, {
                  data: "amount",
                  render: function render(value) {
                    return self.$options.filters.currency(value, "฿");
                  },
                  className: "text-center"
                }, { data: "agentOrgName", className: "text-center" }, { data: "requestUser", className: "text-center" }, { data: "activityRemark", className: "text-center" }, {
                  data: "productLoanStatus",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.productLoanStatusCode == "PRODUCT_LOAN_STATUS_INPROGRESS_1" || full.productLoanStatusCode == "PRODUCT_LOAN_STATUS_INPROGRESS_2" || full.productLoanStatusCode == "PRODUCT_LOAN_STATUS_INPROGRESS_3") {
                      return '<span class="text-warning">' + full.productLoanStatus + "</span>";
                    } else if (full.productLoanStatusCode == "PRODUCT_LOAN_STATUS_APPROVED") {
                      return '<span class="text-success">' + full.productLoanStatus + "</span>";
                    } else if (full.productLoanStatusCode == "PRODUCT_LOAN_STATUS_REJECT") {
                      return '<span class="text-danger">' + full.productLoanStatus + "</span>";
                    } else {
                      return full.productLoanStatus;
                    }
                  }
                }, {
                  data: "openJobStatusCode",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.openJobStatusCode == "OPEN_JOB_STATUS_DONE") {
                      return '<span class="text-success"><i class="fa fa-check-circle"></i>' + full.openJobStatus + "</span>";
                    } else if (full.openJobStatusCode == "OPEN_JOB_STATUS_WAITING") {
                      return '<span class="text-dark"><i class="fa fa-circle-notch"></i>' + full.openJobStatus + "</span>";
                    } else return full.openJobStatus;
                  }
                }, {
                  data: "productLoanHeaderId",
                  className: "text-center",
                  width: "15%",
                  // orderable: true,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "JOB_ADMIN_BORROW", "JOB_ADMIN_BORROW_PLANT"]) && data.productLoanStatus == "PRODUCT_LOAN_STATUS_SAVED";
                    data.showDetailButton = self.$root.canShow(["MANAGE_MASTER", "JOB_ADMIN_BORROW", "JOB_ADMIN_BORROW_PLANT", "JOB_ADMIN_BORROW_APPROVE", "JOB_ADMIN_BORROW_OPENJOB"]);
                    data.showopenJobButton = data.isShowOpenJop && self.$root.canShow(["MANAGE_MASTER", "JOB_ADMIN_BORROW_OPENJOB"]);
                    data.showopenJobReturnButton = data.isShowOpenJopReturn && self.$root.canShow(["MANAGE_MASTER", "JOB_ADMIN_BORROW_OPENJOB"]);
                    data.showApproveButton = data.isApprove && self.$root.canShow(["JOB_ADMIN_BORROW_APPROVE"]);
                    // data.showprintButton = self.$root.canShow(['MANAGE_MASTER']);
                    data.showDeleteButton = data.productLoanStatusCode != "PRODUCT_LOAN_STATUS_APPROVED" && data.productLoanStatusCode != "PRODUCT_LOAN_STATUS_CANCEL" && self.$root.canShow(["MANAGE_MASTER"]);
                    //data.showUndoButton = self.$root.canShow(['MANAGE_MASTER']);
                    data.showOpenJobCompletedButton = data.isShowOpenJopCompleted && self.$root.canShow(["MANAGE_MASTER", "JOB_ADMIN_BORROW_OPENJOB"]);
                    data.showOpenJobDoneButton = data.openJobStatusCode == "OPEN_JOB_STATUS_COMPLETED" && self.$root.canShow(["MANAGE_MASTER"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              // table.trigger("draw.dt"); //call ajax delete this row

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              $("#PictureModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                //self.$parent.reloadDataTable(false);
              }).modal("show");

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_1__Shared_Datepicker__["a" /* default */]
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var self = this;

    return {
      CheckStockAnswer: "",
      itemStatus: null,
      itemQty: 0,
      itemProductId: null,
      itemImage: null,
      modalImage: null,
      itemProductType: null,
      itemQuota: null,
      itemAgent: null,
      itemShopActivityId: null,
      requiredRemark: false,
      requiredDate: false,
      plStatusOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          delay: 300,
          //url: "/Api/Variables/Options",
          url: "/Api/Variables/ProductLoanItemStatusOptions",
          data: function data(params) {
            var query = {
              search: "PRODUCT_LOAN_ITEM_STATUS",
              page: params.page || 1,
              isAgent: self.$parent.cbpIsAgent !== undefined ? self.$parent.cbpIsAgent : self.$parent.ubpIsAgent,
              productGroupCode: self.$parent.cbpProductGroupCode !== undefined ? self.$parent.cbpProductGroupCode : self.$parent.ubpProductGroup
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      plProductIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function data(params) {
            var query = {
              search: params.term,
              productTypeId: self.item.plProductType != null ? self.item.plProductType : "",
              productGroupId: self.$parent.cbpProductGroupId !== undefined ? self.$parent.cbpProductGroupId : self.$parent.ubpProductGroupId,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      plProductTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/ProductType/Select2ProductTypeByGroup",
          data: function data(params) {
            var query = {
              search: params.term,
              productGroupId: self.$parent.cbpProductGroupId !== undefined ? self.$parent.cbpProductGroupId : self.$parent.ubpProductGroupId,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      plQuotaOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Quota/Select2Quota",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      plShopIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          url: "/Api/ProductLoan/Select2ShopActivity",
          data: function data(params) {
            var query = {
              userId: self.$parent.cbpBorrower !== undefined ? self.$parent.cbpBorrower : self.$parent.ubpBorrower,
              agentCode: self.item.plAgent != null ? self.item.plAgent : 0,
              isAgent: self.$parent.cbpIsAgent !== undefined ? self.$parent.cbpIsAgent : self.$parent.ubpIsAgent,
              search: params.term,
              page: params.page || 1
            };
            return query;
          },

          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      plAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          url: "/Api/ProductLoan/Select2SearchAgent",
          data: function data(params) {
            var agent = null;
            if (self.$parent.cbpIsAgent !== undefined) {
              if (self.$parent.cbpIsAgent) {
                agent = self.$parent.cbpAgentCode;
              }
            } else {
              if (self.$parent.ubpIsAgent) {
                agent = self.$parent.ubpAgentCode;
              }
            }

            var query = {
              userId: self.$parent.cbpBorrower !== undefined ? self.$parent.cbpBorrower : self.$parent.ubpBorrower,
              agentCode: agent,
              search: params.term,
              page: params.page || 1
            };
            return query;
          },

          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },


  methods: {
    // getStock: function() {
    //   var vm = this;
    //   vm.CheckStockAnswer = "";
    //   if (this.item.plQty > this.item.plAvailableQty) {
    //     vm.CheckStockAnswer =
    //       "จำนวน Stock ไม่เพียงพอ ระบุได้ไม่เกิน " +
    //       this.item.plAvailableQty +
    //       " ชิ้น";

    //     this.item.plQty = this.item.plAvailableQty;
    //   }

    //   return false;
    // },
    onRemoveItemClick: function onRemoveItemClick(e) {
      var self = this;
      self.$emit("removeItem", self.rowIndex, self.item);
    },

    onStatusChange: function onStatusChange(id, text, data, ref) {
      var self = this;
      self.item.plStatus = self.itemStatus;
      self.requiredDate = false;

      if (data.length != 0) {
        if (data[0].text == "ยืม") {
          self.requiredDate = true;
        }

        //Set selectedStatusCodeData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
        self.item.selectedStatusCodeData = {
          id: data[0].id,
          text: data[0].text
        };
      }
    },
    onProductTypeChange: function onProductTypeChange(id, text, data, ref) {
      var self = this;
      self.item.plProductType = self.itemProductType;

      if (self.$parent.isChange) {
        $("#" + self.$refs.plProductId.id).val("").trigger("change");

        //Set selectedProductTypeData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
        if (data.length != 0) {
          self.item.selectedProductTypeData = {
            id: data[0].id,
            text: data[0].text
          };
        }
      } else {
        self.$parent.isChange = true;
      }
    },
    onQuotaChange: function onQuotaChange(id, text, data, ref) {
      var self = this;
      self.item.plQuota = self.itemQuota;
      //Set selectedQuotaData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
      if (data.length != 0) {
        self.item.selectedQuotaData = {
          id: data[0].id,
          text: data[0].text
        };
      }
    },
    onProductChange: function onProductChange(id, text, data, ref) {
      // console.log("onProductChange");
      // console.log(id, text, data, ref)

      if (data.length === 0) {
        return false;
      }

      var self = this;
      self.item.plProductId = self.itemProductId;
      // if (self.$parent.isChange) {
      self.item.plProductId = self.itemProductId;
      self.item.plAvailableQty = data[0].data.availableQTY;
      self.item.plProductType = data[0].data.productTypeId;

      /*============ Check Stock ============*/
      // if (data[0].data.availableQTY === 0) {
      //   self.item.plProductId = null;
      //   $("#" + self.$refs.plProductId.id)
      //     .val("")
      //     .trigger("change");

      //   Swal.fire({
      //     title: "เกิดข้อผิดพลาด",
      //     html:
      //       "ไม่สามารถเลือก " +
      //       data[0].text +
      //       " เนื่องจากไม่มีในสต๊อก <strong> ",
      //     type: "warning"
      //   });

      //   return false;
      // }
      /*============ Check Price ============*/
      if (data[0].data.avgPrice == 0 && data[0].data.initialPrice == 0) {
        // console.log("123");
        self.item.plAvgPrice = 0;
        self.item.plInitialPrice = 0;

        //Call Api Recheck Price
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("/Api/Product/Select2Product", {
          params: {
            search: self.item.plProductId,
            productTypeId: self.item.plProductType != null ? self.item.plProductType : "",
            productGroupId: self.$parent.ubpProductGroupId !== null ? self.$parent.ubpProductGroupId : "",
            page: 1
          }
        }).then(function (response) {
          if (response.status == 200) {
            if (response.data.results != null && response.data.results.length > 0) {
              self.item.plAvgPrice = response.data.results[0].data.avgPrice;
              self.item.plInitialPrice = response.data.results[0].data.initialPrice;

              if (self.item.plInitialPrice == 0) {
                if (self.$root.canShow(["MANAGE_PRODUCT"])) {
                  __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    title: "เกิดข้อผิดพลาด",
                    html: "ไม่สามารถเลือก " + data[0].text + " เนื่องจากไม่มีราคาสินค้า <strong> ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "เพิ่มข้อมูลราคาสินค้า"
                  }).then(function (result) {
                    if (result.value) {
                      var routeData = self.$router.resolve({
                        path: "/Master/Product/Update/" + data[0].id
                      });
                      window.open(routeData.href, "_blank");
                    }
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    title: "เกิดข้อผิดพลาด",
                    html: "ไม่สามารถเลือก " + data[0].text + " เนื่องจากไม่มีราคาสินค้า <strong> กรุณาติดต่อ Admin",
                    type: "warning"
                  });
                }

                //Set Unselect
                self.item.plProductId = null;
                self.itemProductId = null;
                $("#" + self.$refs.plProductId.id).val("").trigger("change");
              }
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("เกิดข้อผิดพลาด", "ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้", "warning");
          }
        });
      } else {
        // console.log("456");
        // if (self.$parent.isChange) {
        self.$parent.isChange = false;

        self.item.plAvgPrice = data[0].data.avgPrice;
        self.item.plInitialPrice = data[0].data.initialPrice;

        self.$refs.plProductType.setSelectedData({
          id: data[0].data.productTypeId,
          text: data[0].data.productTypeName
        });

        self.item.selectedProductTypeData = {
          id: data[0].data.productTypeId,
          text: data[0].data.productTypeName
        };

        //Set selectedProductData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
        self.item.selectedProductData = {
          id: data[0].id,
          text: data[0].text,
          data: data[0].data
        };

        setTimeout(function () {
          self.$parent.isChange = true;
        }, 50);
        // }
      }
      // set image 
      var imgDownload = null;
      if (data && data[0] && data[0].data && data[0].data.picture) {
        imgDownload = data[0].data.picture;
      }
      if (imgDownload) {
        var fileUrl = imgDownload.fileInfoId;
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("/Api/File/FileDownload", {
          params: {
            FileInfoId: fileUrl
          }
        }).then(function (response) {
          if (response.status === 200 && response.data.success) {
            self.itemImage = response.data.fileUrl;
          } else {
            self.itemImage = false;
          }
        }).catch(function (error) {
          self.itemImage = false;
        });
      } else {
        self.itemImage = false;
      }
      // set image
      // }
    },
    onShopIdChange: function onShopIdChange(id, text, data, ref) {
      var self = this;

      if (data.length === 0) {
        return false;
      } else {
        if (self.$parent.isChange) {
          self.item.plShopActivityId = self.itemShopActivityId;

          self.item.selectedActivityData = self.item.selectedShopData;
          this.requiredRemark = false;
          self.item.plIsShop = false;
          self.item.plShopId = null;
          self.item.plActivityId = null;

          //Check Shop Or Activity
          if (text == "0") {
            self.item.plShopActivityId = self.itemShopActivityId = null;
          }

          if (data[0].data != null) {
            if (data[0].data.shop) {
              self.item.plShopActivityId = self.itemShopActivityId = self.item.plShopId = text;
              self.item.plIsShop = true;
              //Set selectedShopData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
              self.item.selectedShopData = {
                id: data[0].id,
                text: data[0].text
              };
            }
            if (!data[0].data.shop) {
              self.item.plShopActivityId = self.itemShopActivityId = self.item.plActivityId = text;
              this.requiredRemark = true;
              //Set selectedActivityData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
              self.item.selectedActivityData = {
                id: data[0].id,
                text: data[0].text
              };
            }
          }
        }
      }
    },
    onAgentChange: function onAgentChange(id, text, data, ref) {
      var self = this;
      if (self.$parent.isChange) {
        self.item.plAgent = self.itemAgent;

        //Clear Shop or Activity Select2
        $("#" + self.$refs.plShopActivityId.id).val("").trigger("change");

        //Set selectedAgentData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
        if (data.length != 0) {
          self.item.selectedAgentData = {
            id: data[0].id,
            text: data[0].text
          };
        }
      }
    },
    onReturnDateClick: function onReturnDateClick() {
      var self = this;
      var plReturnDate = self.item.plReturnDate;
      if (plReturnDate != null) {
        var reqDate = self.$parent.cbpReqDate !== undefined ? self.$parent.cbpReqDate : self.$parent.ubpReqDate;
        var today = moment();
        var startDate = reqDate < plReturnDate ? reqDate : plReturnDate;
        startDate = today < startDate ? today : startDate;
        $(self.$refs.plReturnDate).datepicker("setStartDate", startDate.format("DD/MM/YYYY"));
      } else {
        $(self.$refs.plReturnDate).datepicker("setStartDate", moment().format("DD/MM/YYYY"));
      }
    },
    pictureModal: function pictureModal(fileUrl, rowIndex) {
      var self = this;
      self.modalImage = null;
      if (fileUrl) {
        self.modalImage = fileUrl;
        var modalId = "#PictureModal" + rowIndex;
        $(modalId).modal("show");
      } else {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("เกิดข้อผิดพลาด", "กรุณาคลิกลิงก์ที่ถูกต้อง", "error");
      }
    }
  },

  mounted: function mounted() {
    var self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>'
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>'
      };
    }

    $(self.$refs.plReturnDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      //startDate: moment().format("DD/MM/YYYY"), // Current day
      //endDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows
    });

    $(self.$refs.plReturnDate)
    //.datepicker("update", self.item.plReturnDate.format("DD/MM/YYYY"))
    .on("changeDate", function (e) {
      e.date != undefined ? self.item.plReturnDate = moment(e.date) : self.item.plReturnDate = null;
    });
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductLoanItemRow__ = __webpack_require__(135);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__["a" /* default */],
    plItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductLoanItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      isChange: false,
      plItems: [],
      plItemsTemp: [],
      i: 0,
      ubpDocNo: null,
      ubpProductLoanId: null,
      ubpBorrower: null,
      //ubpCompanyProfile: null,
      ubpAgentCode: null,
      ubpRepresentName: null,
      ubpRepresentTel: null,
      ubpReqDate: null,
      ubpRequestType: [],
      ubpRequestTypeOptions: [],
      ubpProductGroup: null,
      ubpProductGroupId: null,
      ubpProductGroupOptions: [],
      ubpRemark: null,
      ubpIsAgent: false,
      ubpIsApprove: false,
      ubpStatusCode: null,
      ubpIsEdit: false,

      /* begin: Set Select2 Options*/
      ubpAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductLoan/Select2SearchAgentOrg",
          data: function data(params) {
            var query = {
              userId: self.ubpBorrower,
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      ubpBorrowerOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/ProductLoan/Select2Borrower",
          data: function data(params) {
            var query = {
              userId: "",
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
      /* end: Set Select2 Options*/
    };
  },

  methods: {
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      this.plItems.push({
        plProductLoanItemId: null,
        plStatus: null,
        plProductId: null,
        plProductType: null,
        plQuota: null,
        plQty: 0,
        plPrice: 0,
        plAvgPrice: 0,
        plInitialPrice: 0,
        plAgent: null,
        plShopId: null,
        plShopActivityId: null,
        plActivityId: null,
        plIsShop: false,
        plActivityIdRemark: null,
        plReturnDate: null,
        plAvailableQty: 0,
        plStatusCode: null,
        selectedStatusCodeData: null,
        selectedProductData: null,
        selectedProductTypeData: null,
        selectedQuotaData: null,
        selectedAgentData: null,
        selectedShopData: null,
        selectedActivityData: null
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      var self = this;
      self.plItemsTemp = self.plItems;
      self.plItems = [];
      self.plItemsTemp.splice(index, 1);
      self.isChange = false;
      /*=== Binding items=== */
      setTimeout(function () {
        self.plItems = self.plItemsTemp;

        setTimeout(function () {
          for (var i = 0; i < self.plItems.length; i++) {
            /*=== Check Is Shop & Set Selected Select2=== */
            if (self.plItems[i].plShopId === null && self.plItems[i].plActivityId === null || self.plItems[i].plShopActivityId === null) {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData({
                id: "0",
                text: "ไม่ระบุ"
              });
            } else if (self.plItems[i].plActivityId != null) {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(self.plItems[i].selectedActivityData);
            } else {
              self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(self.plItems[i].selectedShopData);
            }

            /*=== Check Is Agent & Set Selected Select2=== */
            if (self.plItems[i].plAgent === null) {
              self.$refs.plItems[i].$refs.plAgent.setSelectedData({
                id: "0",
                text: "ไม่ระบุ"
              });
            }
            if (self.plItems[i].plAgent !== null) {
              self.$refs.plItems[i].$refs.plAgent.setSelectedData(self.plItems[i].selectedAgentData);
            }

            /*=== Status : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plStatus.setSelectedData(self.plItems[i].selectedStatusCodeData);

            /*=== ProductId : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plProductId.setSelectedData(self.plItems[i].selectedProductData);
            /*=== ProductType : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plProductType.setSelectedData(self.plItems[i].selectedProductTypeData);

            /*=== Quota : Set Selected Select2=== */
            self.$refs.plItems[i].$refs.plQuota.setSelectedData(self.plItems[i].selectedQuotaData);

            /*=== Set DatePicker ReturnDate=== */
            if (self.plItems[i].plReturnDate != null) {
              $(self.$refs.plItems[i].$refs.plReturnDate).datepicker("update", self.plItems[i].plReturnDate.format("DD/MM/YYYY"));
            }
          }
        }, 50);
      }, 50);
    },

    onSendForApprove: function onSendForApprove(e) {
      var _this = this;

      var router = this.$router;
      var self = this;

      Swal.fire({
        title: "ยืนยันการส่งขออนุมัติ",
        type: "warning",
        html: "ต้องการแก้ไขข้อมูลกด บันทึกข้อมูล <strong>" + "</strong> ก่อนส่งขออนุมัติค่ะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูลการส่งขออนุมัติ กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductLoan/" + _this.$route.params.id + "/SendForApprove").then(function (response) {
            if (response.data.status) {
              Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                router.go(-1), self.$parent.reloadDataTable(false);
              });
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            //router.go(-1);
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      var router = this.$router;
      var self = this;
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.plItems.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการ", "warning");
        return false;
      }

      var pItems = [];
      for (var i = 0; i < self.plItems.length; i++) {
        var element = self.plItems[i];
        pItems.push({
          Index: i + 1,
          ProductLoanItemId: element.plProductLoanItemId,
          Status: element.plStatus,
          ProductId: element.plProductId,
          ProductType: element.plProductType,
          AgentCode: element.plAgent,
          QuotaId: element.plQuota,
          Qty: element.plQty,
          Price: element.plPrice,
          ShopId: element.plShopId,
          ActivityId: element.plActivityId,
          IsShop: element.plIsShop,
          Remark: element.plActivityRemark,
          ReturnDate: element.plReturnDate != null ? element.plReturnDate.format("DD/MM/YYYY") : null
        });
      }
      // self.plItems.forEach(element => {
      //   pItems.push({
      //     ProductLoanItemId: element.plProductLoanItemId,
      //     Status: element.plStatus,
      //     ProductId: element.plProductId,
      //     ProductType: element.plProductType,
      //     AgentCode: element.plAgent,
      //     QuotaId: element.plQuota,
      //     Qty: element.plQty,
      //     Price: element.plPrice,
      //     ShopId: element.plShopId,
      //     ActivityId: element.plActivityId,
      //     IsShop: element.plIsShop,
      //     Remark: element.plActivityRemark,
      //     ReturnDate:
      //       element.plReturnDate != null
      //         ? element.plReturnDate.format("DD/MM/YYYY")
      //         : null
      //   });
      // });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "put",
        url: "/Api/ProductLoan",
        data: {
          productLoanId: self.ubpProductLoanId,
          agentCode: self.ubpAgentCode,
          borrower: self.ubpBorrower,
          representName: self.ubpRepresentName,
          RepresentTel: self.ubpRepresentTel,
          requestDate: self.ubpReqDate.format("DD/MM/YYYY"),
          requestType: self.ubpRequestType,
          productGroupId: self.ubpProductGroup,
          amount: self.ubpAmount,
          isAgent: self.ubpIsAgent,
          productLoanItems: pItems,
          remark: self.ubpRemark
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onAgentCodeChange: function onAgentCodeChange(id, text, data, ref) {
      var self = this;

      if (this.isChange) {
        if (text !== "") {
          self.ubpIsAgent = data[0].data.agent;
          //self.ubpCompanyProfile = data[0].data.companyProfileId;
          //Set AgentCode เพราะ Id ต้อง get จาก Data
          //self.ubpAgentCode = data[0].data.id;

          setTimeout(function () {
            for (var i = 0; i < self.plItems.length; i++) {
              self.$refs.plItems[i].$refs.plAgent.setSelectedData({
                id: null,
                text: null
              });
            }
          }, 10);
        }
      }
    },
    onProductGroupChange: function onProductGroupChange() {
      if (this.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
        this.ubpProductGroupId = "1";
      }
      if (this.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS") {
        this.ubpProductGroupId = "2";
      }

      if (this.isChange) {
        var self = this;
        //Clear Product,Status select2 Item
        setTimeout(function () {
          for (var i = 0; i < self.plItems.length; i++) {
            self.$refs.plItems[i].$refs.plProductType.setSelectedData({
              id: null,
              text: null
            });

            self.$refs.plItems[i].$refs.plProductId.setSelectedData({
              id: null,
              text: null
            });

            if (self.ubpIsAgent && self.ubpProductGroupId == "2") {
              self.$refs.plItems[i].$refs.plStatus.setSelectedData({
                id: null,
                text: null
              });
            }
          }
        }, 10);
      }
    },
    ubpBorrowerChange: function ubpBorrowerChange(id, text, data, ref) {
      var self = this;

      if (this.isChange) {
        $("#ubpAgentCode").val("").trigger("change");

        setTimeout(function () {
          for (var i = 0; i < self.plItems.length; i++) {
            self.$refs.plItems[i].$refs.plAgent.setSelectedData({
              id: null,
              text: null
            });
          }
        }, 10);
      }

      setTimeout(function () {
        self.ubpProductGroupOptions = [];
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/ProductLoanProductGroupOptions", {
          params: {
            userId: self.ubpBorrower
          }
        }).then(function (response) {
          if (response.status == 200) {
            if (response.data.results != null && response.data.results.length > 0) {
              for (var i = 0; i < response.data.results.length; i++) {
                self.ubpProductGroupOptions.push({
                  id: response.data.results[i].id,
                  text: response.data.results[i].text
                });
              }
            }
          } else {
            Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้", "warning");
            router.go(-1);
          }
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้", "error");
          router.go(-1);
        }).then(function () {
          // always executed
          KTApp.unblockPage();
        });
      }, 10);
    },
    onRequestTypeChange: function onRequestTypeChange(e) {},

    copyNote: function copyNote() {
      var _this2 = this;

      Swal.fire({
        title: "คำสั่งแก้ไข หมายเหตุกิจกรรม",
        type: "warning",
        html: "กรุณายืนยันคำสั่งคัดลอกแก้ไข หมายเหตุกิจกรรม ทั้งหมดตามข้อมูลแถวที่ 1",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {

        if (result.value) {
          var self = _this2;
          // Start copy comment
          if (self.plItems != null && self.plItems.length > 0) {
            // copy activityRemark from 1st row.
            var activityRemarkRow1 = self.plItems[0].plActivityRemark;

            for (var i = 1; i < self.plItems.length; i++) {
              //self.plItems[i].plActivityRemark = activityRemarkRow1;
              self.$set(self.plItems[i], 'plActivityRemark', activityRemarkRow1);
            }
          }
        }
      });
    }
  },
  computed: {
    totalCal: function totalCal() {
      var self = this;
      var totalSum = 0;
      if (self.plItems != null && self.plItems.length > 0) {
        for (var i = 0; i < self.plItems.length; i++) {
          if (self.plItems[i].plInitialPrice != 0) {
            totalSum += Number(self.plItems[i].plQty * self.plItems[i].plInitialPrice);
            self.plItems[i].plPrice = self.plItems[i].plInitialPrice;
          } else {
            totalSum += Number(self.plItems[i].plQty * self.plItems[i].plAvgPrice);
            self.plItems[i].plPrice = self.plItems[i].plAvgPrice;
          }

          // if (self.plItems[i].plAvgPrice != 0) {
          //   totalSum += Number(
          //     self.plItems[i].plQty * self.plItems[i].plAvgPrice
          //   );
          //   self.plItems[i].plPrice = self.plItems[i].plAvgPrice;
          // } else {
          //   totalSum += Number(
          //     self.plItems[i].plQty * self.plItems[i].plInitialPrice
          //   );
          //   self.plItems[i].plPrice = self.plItems[i].plInitialPrice;
          // }
          self.ubpAmount = totalSum;
        }
      }
      return totalSum;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;
              router = _this3.$router;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.ubpReqDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                //startDate: moment().format("DD/MM/YYYY"), //Current day
                //endDate: moment().format("DD/MM/YYYY"), //Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              self.ubpReqDate = moment();
              $(self.$refs.ubpReqDate).datepicker("update", self.ubpReqDate.format("DD/MM/YYYY")).on("changeDate", function (e) {
                self.ubpReqDate = moment(e.date);
              });

              //Begin :Get Value RequestType CheckBox
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/Options", {
                params: {
                  search: "PRODUCT_LOAN_REQUEST_TYPE"
                }
              }).then(function (response) {
                if (response.status == 200) {
                  if (response.data.results != null && response.data.results.length > 0) {
                    for (var i = 0; i < response.data.results.length; i++) {
                      self.ubpRequestTypeOptions.push({
                        id: response.data.results[i].id,
                        text: response.data.results[i].text
                      });
                    }
                  }
                  return self.ubpRequestTypeOptions;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลประเภทใบคำร้องขอได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });
              //End :Get Value RequestType CheckBox

              //Begin :Get Value ProductGroup Radio checkbox
              // axios
              //   .get("/Api/Variables/Options", {
              //     params: {
              //       search: "PRODUCT_LOAN_PRODUCT_GROUP"
              //     }
              //   })
              //   .then(function(response) {
              //     if (response.status == 200) {
              //       if (
              //         response.data.results != null &&
              //         response.data.results.length > 0
              //       ) {
              //         for (let i = 0; i < response.data.results.length; i++) {
              //           self.ubpProductGroupOptions.push({
              //             id: response.data.results[i].id,
              //             text: response.data.results[i].text
              //           });
              //         }
              //       }
              //     } else {
              //       Swal.fire(
              //         "เกิดข้อผิดพลาด",
              //         "ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
              //         "warning"
              //       );
              //       router.go(-1);
              //     }
              //   })
              //   .catch(function(error) {
              //     Swal.fire(
              //       "เกิดข้อผิดพลาด",
              //       "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลหมวดหมู่สินค้าได้ในขณะนี้",
              //       "error"
              //     );
              //     router.go(-1);
              //   })
              //   .then(function() {
              //     // always executed
              //     KTApp.unblockPage();
              //   });
              //End :Get Value ProductGroup Radio checkbox

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductLoan/" + _this3.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  if (response.data != null) {
                    self.ubpProductLoanId = response.data.productLoanHeaderId;
                    self.ubpDocNo = response.data.requestDocNo;
                    self.ubpRepresentName = response.data.representativeName;
                    self.ubpRepresentTel = response.data.representativeNameL;
                    self.ubpStatusCode = response.data.productLoanStatusCode;
                    self.ubpIsApprove = response.data.isApprove;
                    self.ubpIsAgent = response.data.isAgent;
                    self.ubpIsEdit = response.data.isEdit && !response.data.productLoanStatusCode.includes("INPROGRESS");
                    if (response.data.requestUserId) {
                      self.$refs.ubpBorrowerSelect2.setSelectedData({
                        id: response.data.requestUserId,
                        text: response.data.requestUser
                      });
                    }

                    setTimeout(function () {
                      if (response.data.agentOrgCode) {
                        self.$refs.ubpAgentSelect2.setSelectedData({
                          id: response.data.agentOrgCode,
                          text: response.data.agentOrgName,
                          data: {
                            agent: response.data.isAgent,
                            org: !response.data.isAgent,
                            id: response.data.agentOrgCode
                          }
                        });
                      }
                    }, 50);

                    self.ubpRequestType = response.data.requestTypeList;
                    self.ubpProductGroup = response.data.productGroupId;

                    if (self.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_SPARE") {
                      self.ubpProductGroupId = "1";
                    }
                    if (self.ubpProductGroup === "PRODUCT_LOAN_PRODUCT_GROUP_PREMIUMS") {
                      self.ubpProductGroupId = "2";
                    }

                    self.ubpReqDate = moment(response.data.requestDateFormat, "DD/MM/YYYY");
                    $(self.$refs.ubpReqDate).datepicker("update", response.data.requestDateFormat2);
                    self.ubpRemark = response.data.remark;
                    self.ubpAmount = response.data.amount;

                    if (response.data.productLoanItem.length > 0) {
                      var _loop = function _loop(i) {
                        item = response.data.productLoanItem[i];

                        self.plItems.push({
                          plProductId: item.materialCode,
                          plProductType: item.productTypeId,
                          plProductLoanItemId: item.productLoanItemId,
                          plStatus: item.statusCode,
                          selectedStatusCodeData: {
                            id: item.statusCode,
                            text: item.statusName,
                            data: null
                          },

                          selectedProductData: {
                            id: item.materialCode,
                            text: item.materialName + " [" + item.materialCode + "]",
                            data: item.productData
                          },

                          selectedProductTypeData: {
                            id: item.productTypeId,
                            text: item.productTypeName,
                            data: null
                          },

                          plQuota: item.quotaId,
                          selectedQuotaData: {
                            id: item.quotaId,
                            text: item.quotaName,
                            data: null
                          },
                          plAgent: item.agentCode,
                          selectedAgentData: {
                            id: item.agentCode,
                            text: "[" + item.agentCode + "] " + item.agentCodeName,
                            data: null
                          },
                          plShopId: item.shopId,
                          selectedShopData: {
                            id: item.shopId,
                            text: item.shopName,
                            data: null
                          },
                          plActivityId: item.activityId,
                          selectedActivityData: {
                            id: item.activityId,
                            text: item.activityName
                          },
                          plQty: item.qty, //Stamp Qty
                          plAvailableQty: item.productData.availableQTY, //Current Qty
                          plPrice: 0, //Stamp Price
                          plAvgPrice: item.productData.avgPrice, //Current avgPrice
                          plInitialPrice: item.productData.initialPrice, //Current initialPrice
                          plIsShop: item.shopId != null ? true : false,
                          plShopActivityId: "",
                          plActivityRemark: item.activityRemark,
                          plReturnDate: item.returnDateFormat != null ? moment(item.returnDateFormat, "DD/MM/YYYY") : null
                        });

                        setTimeout(function () {
                          /*=== Status : Set Selected Select2=== */
                          self.$refs.plItems[i].$refs.plStatus.setSelectedData(self.plItems[i].selectedStatusCodeData);

                          /*=== ProductType : Set Selected Select2=== */
                          self.$refs.plItems[i].$refs.plProductType.setSelectedData(self.plItems[i].selectedProductTypeData);

                          setTimeout(function () {
                            /*=== ProductId : Set Selected Select2=== */
                            self.$refs.plItems[i].$refs.plProductId.setSelectedData(self.plItems[i].selectedProductData);
                          }, 100);

                          /*=== Quota : Set Selected Select2=== */
                          self.$refs.plItems[i].$refs.plQuota.setSelectedData(self.plItems[i].selectedQuotaData);

                          /*=== Check Is Agent & Set Selected Select2=== */
                          if (self.plItems[i].plAgent === null) {
                            self.$refs.plItems[i].$refs.plAgent.setSelectedData({
                              id: "0",
                              text: "ไม่ระบุ"
                            });
                          } else if (self.plItems[i].plAgent !== null) {
                            self.$refs.plItems[i].$refs.plAgent.setSelectedData(self.plItems[i].selectedAgentData);
                          }
                          setTimeout(function () {
                            /*=== Set Selected Select2 ShopActivity=== */
                            if (self.plItems[i].plShopActivityId == "") {
                              /*=== Set Selected Select2 ShopActivity is "ไม่ระบุ"=== */
                              if (self.plItems[i].plShopId === null && self.plItems[i].plActivityId === null) {
                                self.plItems[i].plShopActivityId = "0";
                                self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData({
                                  id: "0",
                                  text: "ไม่ระบุ"
                                });
                              }
                              //=== Set Selected Select2 ShopActivity is "Activity"===//
                              else if (self.plItems[i].plActivityId != null) {
                                  self.plItems[i].plShopActivityId = self.plItems[i].plActivityId;
                                  self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(self.plItems[i].selectedActivityData);
                                }
                                //=== Set Selected Select2 ShopActivity is "Shop"===//
                                else {
                                    self.plItems[i].plShopActivityId = self.plItems[i].plShopId;
                                    self.$refs.plItems[i].$refs.plShopActivityId.setSelectedData(self.plItems[i].selectedShopData);
                                  }
                            }
                          }, 100);

                          /*=== set datepicker returnDate === */
                          if (self.plItems[i].plReturnDate != null) {
                            $(self.$refs.plItems[i].$refs.plReturnDate).datepicker("update", self.plItems[i].plReturnDate.format("DD/MM/YYYY"));
                          }
                          self.isChange = true;
                        }, 300);
                      };

                      for (var i = 0; i < response.data.productLoanItem.length; i++) {
                        var item;

                        _loop(i);
                      }
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed

                KTApp.unblockPage();
              });

              table = $("#table-history");

              // begin first table

              table.DataTable({
                responsive: true,
                // processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/ProductLoan/ApproveHistorySearch",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      ProductLoanId: self.$route.params.id
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12'tr>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[2, "desc"]],
                select: {
                  style: "multi",
                  selector: "td:first-child"
                },
                columns: [{ data: "createdDateFormat", className: "text-center" }, { data: "approveUser", className: "text-center" }, { data: "approveLevel", className: "text-center" }, { data: "approveStatus", className: "text-center" }, { data: "remark", className: "text-center" }]
              }).on("draw.dt", function () {});
              // table.trigger("draw.dt"); //call ajax delete this row

              // set validation rules
              $(self.$refs.form).validate({
                rules: {
                  ubpAgentCode: "required",
                  ubpBorrower: "required",
                  ubpRequestDate: "required",
                  ubpRequestType: "required",
                  ubpProductGroup: "required"
                },
                messages: {
                  ubpAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
                  ubpBorrower: "กรุณากรอกผู้ขอเบิก/ยืม",
                  ubpRequestDate: "กรุณากรอกวันที่",
                  ubpRequestType: "กรุณาเลือกประเภทใบคำร้องขอ",
                  ubpProductGroup: "กรุณาเลือกหมวดหมู่สินค้า"
                }
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      isEditMode: false,
      approveGroupId: null,
      isDataLoaded: false, // Add flag to control rendering
      isValidating: false, // Flag to prevent recursive validation
      uidCounter: 0, // Counter for unique IDs
      formData: {
        groupName: "",
        isActive: true,
        orgs: [],
        approvers: []
      },
      orgOptions: {
        placeholder: "กรุณาเลือกแผนก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterOrg/Select2Org",
          type: "get",
          delay: 300,
          dataType: "json",
          data: function data(params) {
            return {
              search: params.term,
              page: params.page || 1
            };
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      approverOptions: {
        placeholder: "กรุณาเลือกพนักงาน",
        allowClear: true,
        ajax: {
          url: "/Api/Users/Select2UserForBudgetApprovers",
          type: "get",
          delay: 300,
          dataType: "json",
          data: function data(params) {
            return {
              search: params.term,
              page: params.page || 1
            };
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    onOrgSelected: function onOrgSelected(selectedOrgId, currentIndex) {
      var self = this;

      if (!selectedOrgId) return;

      // Prevent recursive validation
      if (self.isValidating) return;

      // Check duplicate within the same group
      var duplicateIndex = self.formData.orgs.findIndex(function (org, idx) {
        return idx !== currentIndex && org.orgId === selectedOrgId;
      });

      if (duplicateIndex !== -1) {
        self.isValidating = true;
        Swal.fire({
          title: "แจ้งเตือน",
          text: "แผนกนี้ถูกเลือกไว้แล้วในกลุ่มนี้ กรุณาเลือกแผนกอื่น",
          type: "warning",
          confirmButtonText: "ตกลง"
        }).then(function () {
          // Clear the selection
          self.formData.orgs[currentIndex].orgId = "";
          if (self.$refs['orgSelect_' + currentIndex] && self.$refs['orgSelect_' + currentIndex][0]) {
            self.$refs['orgSelect_' + currentIndex][0].clearData();
          }
          self.isValidating = false;
        });
        return;
      }

      // Check if org is used in another group
      self.isValidating = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/BudgetPlan/ApproveGroup/CheckOrgUsage", {
        params: {
          orgId: selectedOrgId,
          currentGroupId: self.approveGroupId || 0
        },
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token
        }
      }).then(function (response) {
        if (response.data && response.data.isUsed) {
          Swal.fire({
            title: "แจ้งเตือน",
            html: "\u0E41\u0E1C\u0E19\u0E01 '<strong>" + response.data.orgName + "</strong>' \u0E16\u0E39\u0E01\u0E43\u0E0A\u0E49\u0E43\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21 '<strong>" + response.data.groupName + "</strong>' \u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27<br>\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E0B\u0E49\u0E33\u0E44\u0E14\u0E49",
            type: "warning",
            confirmButtonText: "ตกลง"
          }).then(function () {
            // Clear the selection
            self.formData.orgs[currentIndex].orgId = "";
            if (self.$refs['orgSelect_' + currentIndex] && self.$refs['orgSelect_' + currentIndex][0]) {
              self.$refs['orgSelect_' + currentIndex][0].clearData();
            }
            self.isValidating = false;
          });
        } else {
          // No error, clear validation flag
          self.isValidating = false;
        }
      }).catch(function (error) {
        console.error("Error checking org usage:", error);
        self.isValidating = false;
      });
    },
    addOrg: function addOrg() {
      this.formData.orgs.push({
        _uid: ++this.uidCounter,
        orgId: ""
      });
    },
    removeOrg: function removeOrg(index) {
      this.formData.orgs.splice(index, 1);
    },
    addApprover: function addApprover() {
      if (this.formData.approvers.length >= 5) {
        Swal.fire({
          title: "แจ้งเตือน",
          text: "สามารถเพิ่มผู้อนุมัติได้สูงสุด 5 ระดับเท่านั้น",
          type: "warning"
        });
        return;
      }
      // Auto assign approval level based on current count
      var nextLevel = this.formData.approvers.length + 1;
      this.formData.approvers.push({
        _uid: ++this.uidCounter,
        userId: "",
        approvalLevel: nextLevel,
        approverType: "APPROVE", // Default to APPROVE
        isSignatureRequired: false, // Default to ไม่บันทึก
        emailNotificationType: "SEPARATE" // FR-011: Default to แยกใบงาน
      });
    },
    removeApprover: function removeApprover(index) {
      this.formData.approvers.splice(index, 1);
      // Reassign approval levels after removal (keep approverType)
      this.formData.approvers.forEach(function (approver, idx) {
        approver.approvalLevel = idx + 1;
      });
    },
    onApproverTypeChanged: function onApproverTypeChanged(index) {
      // When type changes to CONFIRM, auto-set isSignatureRequired to false
      if (this.formData.approvers[index].approverType === "CONFIRM") {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.formData.approvers[index], "isSignatureRequired", false);
      }
    },
    onSignatureChanged: function onSignatureChanged(index, value) {
      if (value) {
        // Only 1 row per group can have "บันทึก" — auto-set others to "ไม่บันทึก"
        this.formData.approvers.forEach(function (approver, idx) {
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(approver, "isSignatureRequired", idx === index);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.formData.approvers[index], "isSignatureRequired", false);
      }
    },
    loadApproveGroupData: function loadApproveGroupData() {
      var self = this;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/BudgetPlan/ApproveGroup/" + self.approveGroupId, {
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token
        }
      }).then(function (response) {
        console.log("API Response:", response.data);

        // Support both formats: {data: {...}} and direct object
        var data = response.data.data || response.data;

        if (data && data.groupName) {
          console.log("Loaded data:", data);

          self.formData.groupName = data.groupName;
          self.formData.isActive = data.isActive;

          // Load orgs with formatted text for Select2 [Code] Name
          self.formData.orgs = (data.orgs || []).map(function (org) {
            return {
              _uid: ++self.uidCounter,
              orgId: org.orgId,
              orgText: "[" + org.orgCode + "] " + org.orgName // Format: [Code] Name
            };
          });

          // Load approvers with formatted text for Select2 [Email] Full Name
          self.formData.approvers = (data.approvers || []).map(function (approver) {
            return {
              _uid: ++self.uidCounter,
              userId: approver.userId,
              approvalLevel: approver.approvalLevel,
              approverType: approver.approverType || "APPROVE",
              isSignatureRequired: approver.isSignatureRequired || false,
              emailNotificationType: approver.emailNotificationType || "SEPARATE", // FR-011
              userText: "[" + approver.userEmail + "] " + approver.userName // Format: [Email] Full Name
            };
          });

          console.log("FormData after load:", self.formData);

          // Set flag to trigger rendering
          self.isDataLoaded = true;

          // Initialize Select2 with loaded data after Vue renders
          self.$nextTick(function () {
            // Wait for DOM to be ready
            setTimeout(function () {
              console.log("Initializing Select2...");
              console.log("Refs available:", Object.keys(self.$refs));

              // Initialize org Select2 with loaded data
              self.formData.orgs.forEach(function (org, index) {
                var refName = 'orgSelect_' + index;
                console.log("Looking for ref:", refName);

                if (self.$refs[refName] && self.$refs[refName][0]) {
                  var select2Component = self.$refs[refName][0];
                  console.log("Found org select2 component");

                  // Use setSelectedData method
                  select2Component.setSelectedData({
                    id: org.orgId,
                    text: org.orgText
                  });
                  console.log("Set org data:", org.orgText, org.orgId);
                } else {
                  console.log("Ref not found:", refName);
                }
              });

              // Initialize approver Select2 with loaded data
              self.formData.approvers.forEach(function (approver, index) {
                var refName = 'approverSelect_' + index;
                console.log("Looking for ref:", refName);

                if (self.$refs[refName] && self.$refs[refName][0]) {
                  var select2Component = self.$refs[refName][0];
                  console.log("Found approver select2 component");

                  // Use setSelectedData method
                  select2Component.setSelectedData({
                    id: approver.userId,
                    text: approver.userText
                  });
                  console.log("Set approver data:", approver.userText, approver.userId);
                } else {
                  console.log("Ref not found:", refName);
                }
              });
            }, 200); // Increase timeout to 200ms
          });
        } else {
          console.log("No data in response");
        }
      }).catch(function (error) {
        console.error("Error loading approve group:", error);
        Swal.fire("ผิดพลาด", "ไม่สามารถโหลดข้อมูลกลุ่มอนุมัติได้", "error").then(function () {
          __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/BudgetPlan/ApproveGroup" });
        });
      }).finally(function () {
        KTApp.unblockPage();
      });
    },
    validateForm: function validateForm() {
      if (!this.formData.groupName || this.formData.groupName.trim() === "") {
        Swal.fire("แจ้งเตือน", "กรุณากรอกชื่อกลุ่มอนุมัติ", "warning");
        return false;
      }

      if (this.formData.orgs.length === 0) {
        Swal.fire("แจ้งเตือน", "กรุณาเพิ่มแผนกอย่างน้อย 1 แผนก", "warning");
        return false;
      }

      // Check duplicate orgs
      var orgIds = this.formData.orgs.map(function (o) {
        return o.orgId;
      });
      var uniqueOrgIds = [].concat(_toConsumableArray(new Set(orgIds)));
      if (orgIds.length !== uniqueOrgIds.length) {
        Swal.fire("แจ้งเตือน", "มีแผนกซ้ำกัน กรุณาตรวจสอบ", "warning");
        return false;
      }

      // Check empty org
      if (orgIds.some(function (id) {
        return !id || id === "";
      })) {
        Swal.fire("แจ้งเตือน", "กรุณาเลือกแผนกให้ครบถ้วน", "warning");
        return false;
      }

      if (this.formData.approvers.length === 0) {
        Swal.fire("แจ้งเตือน", "กรุณาเพิ่มผู้อนุมัติอย่างน้อย 1 คน", "warning");
        return false;
      }

      // Check empty approver
      if (this.formData.approvers.some(function (approver) {
        return !approver.userId || approver.userId === "";
      })) {
        Swal.fire("แจ้งเตือน", "กรุณาเลือกผู้อนุมัติให้ครบถ้วน", "warning");
        return false;
      }

      return true;
    },
    submitForm: function submitForm() {
      var self = this;

      if (!self.validateForm()) {
        return;
      }

      Swal.fire({
        title: "ยืนยันการบันทึก",
        text: "คุณต้องการบันทึกข้อมูลกลุ่มอนุมัตินี้หรือไม่?",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
          });

          var payload = {
            id: self.approveGroupId || 0,
            groupName: self.formData.groupName,
            isActive: self.formData.isActive,
            orgs: self.formData.orgs.map(function (o) {
              return { orgId: o.orgId };
            }),
            approvers: self.formData.approvers.map(function (a) {
              return {
                userId: a.userId,
                approvalLevel: a.approvalLevel,
                approverType: a.approverType || "APPROVE",
                isSignatureRequired: a.approverType === "APPROVE" ? a.isSignatureRequired || false : false,
                emailNotificationType: a.emailNotificationType || "SEPARATE" // FR-011
              };
            })
          };

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/BudgetPlan/ApproveGroup/Save", payload, {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token
            }
          }).then(function (response) {
            if (response.data && response.data.success) {
              Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                // Navigate back and trigger reload
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
                  path: "/BudgetPlan/ApproveGroup",
                  query: { reload: Date.now() }
                });
              });
            } else {
              Swal.fire("ผลลัพธ์", response.data.message || "เกิดข้อผิดพลาด", "warning");
            }
          }).catch(function (error) {
            console.error("Save error:", error);
            var errorMessage = "เกิดข้อผิดพลาดในการบันทึกข้อมูล";
            if (error.response && error.response.data && error.response.data.message) {
              errorMessage = error.response.data.message;
            } else if (error.response && error.response.data) {
              console.error("Full error response:", error.response.data);
              errorMessage = JSON.stringify(error.response.data);
            }
            Swal.fire("ผิดพลาด", errorMessage, "error");
          }).finally(function () {
            KTApp.unblockPage();
          });
        }
      });
    }
  },
  mounted: function mounted() {
    // Check if edit mode
    if (this.$route.params.id) {
      this.isEditMode = true;
      this.approveGroupId = parseInt(this.$route.params.id);
      this.loadApproveGroupData();
    } else {
      // Create mode - set flag immediately
      this.isDataLoaded = true;
    }
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(11);
__webpack_require__(13);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" class=\"btn btn-sm btn-success\" @click.prevent=\"toggleStatus\"> \n      <i class=\"fas fa-play\"></i> \u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    toggleStatus: function toggleStatus() {
      var _this = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขสถานะ กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BudgetPlan/ApproveGroup/" + _this.data.id + "/ToggleStatus", {}, {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token
            }
          }).then(function (response) {
            if (response.data.success) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", "ปรับปรุงสถานะการใช้งานสำเร็จ", "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            var errorMsg = error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด";
            Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
          }).then(function () {
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" class=\"btn btn-sm btn-danger\" @click.prevent=\"toggleStatus\">\n      <i class=\"fas fa-pause\"></i> \u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    toggleStatus: function toggleStatus() {
      var _this2 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขสถานะ กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BudgetPlan/ApproveGroup/" + _this2.data.id + "/ToggleStatus", {}, {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token
            }
          }).then(function (response) {
            if (response.data.success) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", "ปรับปรุงสถานะการใช้งานสำเร็จ", "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            var errorMsg = error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด";
            Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
          }).then(function () {
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

var ApproveGroupActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editApproveGroup\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"deleteApproveGroup\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    editApproveGroup: function editApproveGroup() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/BudgetPlan/ApproveGroup/Edit/" + this.data.id });
    },
    deleteApproveGroup: function deleteApproveGroup() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "ยืนยันการลบ",
        type: "warning",
        html: "คุณต้องการลบกลุ่มอนุมัตินี้หรือไม่?",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/BudgetPlan/ApproveGroup/" + _this3.data.id + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("ผลลัพธ์", response.data.message, "warning");
            }
          }).catch(function (error) {
            Swal.fire("ผิดพลาด", error.response.data.message, "error");
          }).finally(function () {
            KTApp.unblockPage();
          });
        }
      });
    }
  },
  props: ["data"]
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    DatatableWarning: __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */]
  },
  data: function data() {
    return {
      searchGroupName: "",
      searchStatus: "false",
      statusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน" }, { id: "true", text: "ไม่ใช้งาน" }]
      },
      dataTable: null
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      this.dataTable.ajax.reload();
    },
    formReset: function formReset() {
      this.searchGroupName = "";
      // #98: รีเซ็ตเป็น default "ใช้งาน" (false = Active) แทน empty
      this.searchStatus = "false";
      $("#approveGroup_statusKey").val("false").trigger("change");
      this.dataTable.ajax.reload();
    },
    goToCreate: function goToCreate() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/BudgetPlan/ApproveGroup/Create" });
    },
    reloadDataTable: function reloadDataTable() {
      this.dataTable.ajax.reload();
    },
    initDataTable: function initDataTable() {
      var self = this;
      self.dataTable = $("#approveGroupTable").DataTable({
        responsive: true,
        searchDelay: 500,
        processing: true,
        serverSide: true,
        searching: false,
        dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
        lengthMenu: [50, 100, 200, 500],
        pageLength: 50,
        language: {
          processing: '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span>',
          lengthMenu: "Display _MENU_"
        },
        ajax: {
          url: "/Api/BudgetPlan/ApproveGroup/Search",
          type: "POST",
          contentType: "application/json",
          headers: {
            Authorization: "Bearer " + self.$root.user.access_token
          },
          data: function data(d) {
            return JSON.stringify({
              draw: d.draw,
              start: d.start,
              length: d.length,
              groupName: self.searchGroupName,
              inActiveStatus: self.searchStatus
            });
          },
          error: function error(xhr, _error, code) {
            console.log(xhr);
            console.log(code);
          }
        },
        columns: [{
          data: null,
          className: "text-center",
          orderable: false,
          width: "8%",
          render: function render(data, type, row, meta) {
            return meta.row + meta.settings._iDisplayStart + 1;
          }
        }, {
          data: "groupName",
          className: "text-left",
          width: "35%"
        }, {
          data: "orgCount",
          className: "text-center",
          width: "12%",
          render: function render(data) {
            return data || 0;
          }
        }, {
          data: "approverCount",
          className: "text-center",
          width: "12%",
          render: function render(data) {
            return data || 0;
          }
        }, {
          data: null,
          className: "text-center",
          orderable: false,
          width: "13%",
          render: function render(data) {
            return "<div class='actionsStatus'></div>";
          }
        }, {
          data: null,
          responsivePriority: -1,
          orderable: false,
          className: "text-center",
          width: "10%",
          render: function render(data, type, row) {
            return "<div class='actions'></div>";
          }
        }]
      }).on("draw.dt", function () {
        $("#approveGroupTable .actionsStatus").each(function (i, el) {
          var $dt = self.dataTable;
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            // Mount StatusActions component based on status
            if (!data.inActiveStatus) {
              new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);
            } else {
              new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
            }
          }
        });
        $("#approveGroupTable .actions").each(function (i, el) {
          var $dt = self.dataTable;
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            new ApproveGroupActions({
              propsData: {
                data: data
              }
            }).$mount(el);
          }
        });
      });
    }
  },
  mounted: function mounted() {
    this.initDataTable();
    // Set default status to "ใช้งาน" (false = Active)
    $("#approveGroup_statusKey").val("false").trigger("change");
  },

  watch: {
    '$route.query.reload': function $routeQueryReload() {
      // Reload datatable when returning from form with reload query param
      if (this.dataTable) {
        this.dataTable.ajax.reload();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.dataTable) {
      this.dataTable.destroy();
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GLTypeSelect__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a,
    GlTypeSelect: __WEBPACK_IMPORTED_MODULE_3__GLTypeSelect__["a" /* default */]
  },
  data: function data() {
    var currentYear = new Date().getFullYear();
    var now = new Date();
    var currentDate = String(now.getDate()).padStart(2, '0') + '/' + String(now.getMonth() + 1).padStart(2, '0') + '/' + now.getFullYear();

    return {
      // Search
      searchKeyword: "", // คงไว้เพื่อ backward compat — หน้าจอไม่ใช้แล้ว
      searchOrgCodes: [],

      // ---- CR-BudgetReport ข้อ 2: filter แบบ cascading ----
      searchIOCodes: [],
      searchGLCodes: [],
      searchGLTypeNames: [],
      ioTreeOptions: [],
      glTreeOptions: [],
      glTypeTreeOptions: [],
      orgFilterTreeOptions: [],
      // กัน race: ถ้าผู้ใช้เปลี่ยน filter เร็วกว่า response กลับมา ให้ทิ้งของเก่า (SQ-02)
      filterOptionsSeq: 0,

      // Form Data
      formData: {
        year: currentYear.toString(),
        cctrCode: "",
        cctrName: "",
        isFilteredView: false, // Issue 47: true = กำลังดูผลลัพธ์จาก filter → ข้าม delete logic ตอน save
        ioList: [{
          ioCode: "",
          ioName: "",
          collapsed: false,
          isFromDb: false,
          glList: [{
            glCode: "",
            glName: "",
            glTypeName: "",
            collapsed: false,
            isFromDb: false,
            orgList: []
          }]
        }]
      },

      // UI State
      level1Collapsed: false,
      isSaving: false,
      isLoading: false,
      isExporting: false,

      // Options
      yearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: false,
        data: [{ id: currentYear.toString(), text: currentYear.toString() }, { id: (currentYear + 1).toString(), text: (currentYear + 1).toString() }]
      },
      orgOptions: {
        placeholder: "กรุณาเลือกแผนก",
        allowClear: true,
        data: []
      },
      orgTreeOptions: [],
      // ISS-39: หมวดหมู่ที่มีอยู่ ใช้เป็นตัวเลือกของช่อง "หมวดหมู่"
      glTypeNameOptions: [],

      // Current Date
      currentDate: currentDate,

      // UID Counter for unique keys
      orgUidCounter: 0
    };
  },
  computed: {
    isEditMode: function isEditMode() {
      return !!(this.$route.params.year && this.$route.params.cctrCode) && !this.isViewMode;
    },
    isViewMode: function isViewMode() {
      return this.$route.path.includes('/View/');
    },
    isReadOnly: function isReadOnly() {
      // ทั้ง Edit mode ที่มี data จาก DB และ View mode ควรเป็น readonly สำหรับบาง field
      // แต่ View mode จะเป็น readonly ทั้งหมด
      return this.isViewMode;
    },
    pageTitle: function pageTitle() {
      if (this.isViewMode) {
        return 'ดูรายละเอียดแผนงบประมาณ';
      } else if (this.isEditMode) {
        return 'แก้ไขแผนงบประมาณ';
      } else {
        return 'เพิ่มแผนงบประมาณ';
      }
    },
    pageIcon: function pageIcon() {
      if (this.isViewMode) {
        return 'fas fa-eye';
      } else if (this.isEditMode) {
        return 'fas fa-edit';
      } else {
        return 'fas fa-plus-circle';
      }
    }
  },
  mounted: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.loadDropdownData();

            case 2:
              if (!(this.isEditMode || this.isViewMode)) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return this.loadEditData();

            case 5:
              _context.next = 7;
              return this.reloadFilterOptions();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    goBack: function goBack() {
      this.$router.push("/BudgetPlan/List");
    },

    // Check if any org in the entire CCTR has been used
    isCCTRCodeReadOnly: function isCCTRCodeReadOnly() {
      if (this.isViewMode) return true;
      if (!this.isEditMode) return false;

      // Check if any org in any GL in any IO has been used
      for (var i = 0; i < this.formData.ioList.length; i++) {
        var io = this.formData.ioList[i];
        for (var j = 0; j < io.glList.length; j++) {
          var gl = io.glList[j];
          for (var k = 0; k < gl.orgList.length; k++) {
            var org = gl.orgList[k];
            if (org.isReadOnly) {
              return true;
            }
          }
        }
      }
      return false;
    },

    // Check if any org under this IO has been used
    isIOCodeReadOnly: function isIOCodeReadOnly(ioIndex) {
      if (this.isViewMode) return true;
      if (!this.isEditMode) return false;

      var io = this.formData.ioList[ioIndex];
      if (!io) return false;

      for (var j = 0; j < io.glList.length; j++) {
        var gl = io.glList[j];
        for (var k = 0; k < gl.orgList.length; k++) {
          var org = gl.orgList[k];
          if (org.isReadOnly) {
            return true;
          }
        }
      }
      return false;
    },

    // Check if any org under this GL has been used
    isGLCodeReadOnly: function isGLCodeReadOnly(ioIndex, glIndex) {
      if (this.isViewMode) return true;
      if (!this.isEditMode) return false;

      var io = this.formData.ioList[ioIndex];
      if (!io) return false;

      var gl = io.glList[glIndex];
      if (!gl) return false;

      for (var k = 0; k < gl.orgList.length; k++) {
        var org = gl.orgList[k];
        if (org.isReadOnly) {
          return true;
        }
      }
      return false;
    },

    // Load Dropdown Data
    loadDropdownData: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self, response, orgData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = this;
                _context2.prev = 1;

                self.isLoading = true;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Create/Dropdown", {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 5:
                response = _context2.sent;


                if (response.data && response.data.success) {
                  // Set org options
                  orgData = (response.data.data.orgCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });

                  self.orgOptions = {
                    placeholder: "กรุณาเลือกแผนก",
                    allowClear: true,
                    data: orgData
                  };

                  // ISS-39: หมวดหมู่ที่มีอยู่แล้ว
                  self.glTypeNameOptions = response.data.data.glTypeNames || [];
                  // Treeselect options format: [{id, label}]
                  self.orgTreeOptions = (response.data.data.orgCodes || []).map(function (item) {
                    return { id: item.value, label: item.text };
                  });

                  // orgTreeOptions is already set above, treeselect will use it via v-model binding
                }

                self.isLoading = false;
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](1);

                self.isLoading = false;
                console.error("Error loading dropdown data:", _context2.t0);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 10]]);
      }));

      function loadDropdownData() {
        return _ref2.apply(this, arguments);
      }

      return loadDropdownData;
    }(),

    // Load Edit Data
    loadEditData: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var self, year, cctrCode, response, data, date;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self = this;
                year = self.$route.params.year;
                cctrCode = self.$route.params.cctrCode;

                if (!(!year || !cctrCode)) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                _context3.prev = 5;

                self.isLoading = true;
                KTApp.blockPage({ opacity: 0.05, message: "กำลังโหลดข้อมูล..." });

                _context3.next = 10;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Edit/" + year + "/" + cctrCode, {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 10:
                response = _context3.sent;


                KTApp.unblockPage();
                self.isLoading = false;

                if (!(response.data && response.data.success && response.data.data)) {
                  _context3.next = 27;
                  break;
                }

                data = response.data.data;

                if (data.found) {
                  _context3.next = 19;
                  break;
                }

                Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลแผนงบประมาณที่ต้องการแก้ไข", "error");
                self.$router.push("/BudgetPlan/List");
                return _context3.abrupt("return");

              case 19:

                // Populate form data
                self.formData.year = data.year.toString();
                self.formData.cctrCode = data.cctrCode;
                self.formData.cctrName = data.cctrName;
                self.formData.isFilteredView = false; // Issue 47: โหลดข้อมูลเต็ม → อนุญาตให้ลบได้

                // FR-006: ใช้ lastModifiedDate จาก API (BudgetPlan_CostCenter.UpdatedDate ?? CreatedDate)
                if (data.lastModifiedDate) {
                  date = new Date(data.lastModifiedDate);

                  self.currentDate = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
                }

                if (data.ioList && data.ioList.length > 0) {
                  self.formData.ioList = data.ioList.map(function (io) {
                    return {
                      ioCode: io.ioCode,
                      ioName: io.ioName || "",
                      collapsed: false,
                      isFromDb: io.isFromDb !== false,
                      glList: (io.glList || []).map(function (gl) {
                        return {
                          glCode: gl.glCode,
                          glName: gl.glName || "",
                          glTypeName: gl.glTypeName || "",
                          collapsed: false,
                          isFromDb: gl.isFromDb !== false,
                          orgList: (gl.orgList || []).map(function (org) {
                            self.orgUidCounter++;
                            return {
                              _uid: self.orgUidCounter,
                              orgCode: org.orgCode,
                              orgName: org.orgName || "",
                              budgetAmount: org.budgetAmount || 0,
                              usedAmount: org.usedAmount || 0,
                              addedAmount: org.addedAmount || 0,
                              sendbackAmount: org.sendbackAmount || 0,
                              reducedAmount: org.reducedAmount || 0,
                              remainingAmount: org.remainingAmount || 0,
                              budgetTotal: org.budgetTotal || 0,
                              isReadOnly: org.isReadOnly === true,
                              budgetPlanId: org.budgetPlanId,
                              // Store original codes for tracking changes
                              originalCCTRCode: data.cctrCode,
                              originalIOCode: io.ioCode,
                              originalGLCode: gl.glCode
                            };
                          })
                        };
                      })
                    };
                  });
                } else {
                  // Cascade filter: ถ้า API ส่ง ioList ว่างกลับมา (ไม่มี Org ที่ user มีสิทธิ์)
                  // ให้เคลียร์ default IO/GL ว่างออก เพื่อไม่แสดง Level 2,3 ที่ไม่มีข้อมูล
                  self.formData.ioList = [];
                }
                _context3.next = 29;
                break;

              case 27:
                Swal.fire("เกิดข้อผิดพลาด", response.data.message || "ไม่สามารถโหลดข้อมูลได้", "error");
                self.$router.push("/BudgetPlan/List");

              case 29:
                _context3.next = 38;
                break;

              case 31:
                _context3.prev = 31;
                _context3.t0 = _context3["catch"](5);

                KTApp.unblockPage();
                self.isLoading = false;
                console.error("Error loading edit data:", _context3.t0);
                Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดข้อมูลได้", "error");
                self.$router.push("/BudgetPlan/List");

              case 38:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 31]]);
      }));

      function loadEditData() {
        return _ref3.apply(this, arguments);
      }

      return loadEditData;
    }(),

    // Toggle Functions
    toggleLevel1: function toggleLevel1() {
      this.level1Collapsed = !this.level1Collapsed;
    },
    toggleIO: function toggleIO(ioIndex) {
      this.formData.ioList[ioIndex].collapsed = !this.formData.ioList[ioIndex].collapsed;
    },
    toggleGL: function toggleGL(ioIndex, glIndex) {
      this.formData.ioList[ioIndex].glList[glIndex].collapsed = !this.formData.ioList[ioIndex].glList[glIndex].collapsed;
    },

    // Add Functions
    addIO: function addIO() {
      this.formData.ioList.unshift({
        ioCode: "",
        ioName: "",
        collapsed: false,
        isFromDb: false,
        glList: [{
          glCode: "",
          glName: "",
          glTypeName: "",
          collapsed: false,
          isFromDb: false,
          orgList: []
        }]
      });
    },
    addGL: function addGL(ioIndex) {
      this.formData.ioList[ioIndex].glList.unshift({
        glCode: "",
        glName: "",
        glTypeName: "",
        collapsed: false,
        isFromDb: false,
        orgList: []
      });
    },
    addOrgRow: function addOrgRow(ioIndex, glIndex) {
      this.orgUidCounter++;
      this.formData.ioList[ioIndex].glList[glIndex].orgList.push({
        _uid: this.orgUidCounter,
        orgCode: null,
        orgName: "",
        budgetAmount: 0,
        usedAmount: 0,
        addedAmount: 0,
        sendbackAmount: 0,
        reducedAmount: 0,
        remainingAmount: 0,
        budgetTotal: 0,
        isReadOnly: false,
        budgetPlanId: null
      });
    },

    // Remove Functions
    removeIO: function removeIO(ioIndex) {
      var self = this;
      Swal.fire({
        title: "ยืนยันการลบ",
        text: "คุณต้องการลบ IO นี้หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ใช่, ลบ",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          self.formData.ioList.splice(ioIndex, 1);
        }
      });
    },
    removeGL: function removeGL(ioIndex, glIndex) {
      var self = this;
      Swal.fire({
        title: "ยืนยันการลบ",
        text: "คุณต้องการลบ GL นี้หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ใช่, ลบ",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          self.formData.ioList[ioIndex].glList.splice(glIndex, 1);
        }
      });
    },
    removeOrgRow: function removeOrgRow(ioIndex, glIndex, orgIndex) {
      var self = this;
      var org = this.formData.ioList[ioIndex].glList[glIndex].orgList[orgIndex];
      if (org.budgetPlanId && org.usedAmount > 0) {
        Swal.fire("ไม่สามารถลบได้", "รายการนี้มีการใช้งบประมาณแล้ว", "error");
        return;
      }
      Swal.fire({
        title: "ยืนยันการลบ",
        text: "คุณต้องการลบรายการนี้หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ใช่, ลบ",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          self.formData.ioList[ioIndex].glList[glIndex].orgList.splice(orgIndex, 1);
        }
      });
    },

    // Blur Events - Auto load data
    onCCTRBlur: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var self, code, year, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = this;
                code = self.formData.cctrCode;
                year = self.formData.year;

                if (!(!code || !year)) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                _context4.prev = 5;
                _context4.next = 8;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Create/Lookup", {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  },
                  params: {
                    type: "CCTR",
                    code: code,
                    year: year
                  }
                });

              case 8:
                response = _context4.sent;


                if (response.data && response.data.success && response.data.data) {
                  if (response.data.data.found) {
                    self.formData.cctrName = response.data.data.name;
                  }
                }
                _context4.next = 15;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](5);

                console.error("Error looking up CCTR:", _context4.t0);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 12]]);
      }));

      function onCCTRBlur() {
        return _ref4.apply(this, arguments);
      }

      return onCCTRBlur;
    }(),
    onIOBlur: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(ioIndex) {
        var self, io, code, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                self = this;
                io = self.formData.ioList[ioIndex];
                code = io.ioCode;

                if (code) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return");

              case 5:
                _context5.prev = 5;
                _context5.next = 8;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Create/Lookup", {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  },
                  params: {
                    type: "IO",
                    code: code
                  }
                });

              case 8:
                response = _context5.sent;


                if (response.data && response.data.success && response.data.data) {
                  if (response.data.data.found) {
                    io.ioName = response.data.data.name;
                  }
                }
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](5);

                console.error("Error looking up IO:", _context5.t0);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 12]]);
      }));

      function onIOBlur(_x) {
        return _ref5.apply(this, arguments);
      }

      return onIOBlur;
    }(),
    onGLBlur: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(ioIndex, glIndex) {
        var self, gl, code, response, year, cctrCode, ioCode, glCode;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                self = this;
                gl = self.formData.ioList[ioIndex].glList[glIndex];
                code = gl.glCode;

                if (code) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return");

              case 5:
                _context6.prev = 5;
                _context6.next = 8;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Create/Lookup", {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  },
                  params: {
                    type: "GL",
                    code: code
                  }
                });

              case 8:
                response = _context6.sent;


                if (response.data && response.data.success && response.data.data) {
                  if (response.data.data.found) {
                    gl.glName = response.data.data.name;
                  }
                }
                _context6.next = 15;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](5);

                console.error("Error looking up GL:", _context6.t0);

              case 15:

                // Also load existing budget data if all fields are filled
                // But NOT if GL already has data from DB (edit mode) - to preserve original codes
                year = self.formData.year;
                cctrCode = self.formData.cctrCode;
                ioCode = self.formData.ioList[ioIndex].ioCode;
                glCode = gl.glCode;

                if (!(year && cctrCode && ioCode && glCode && !gl.isFromDb)) {
                  _context6.next = 22;
                  break;
                }

                _context6.next = 22;
                return self.loadBudgetData(ioIndex, glIndex);

              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5, 12]]);
      }));

      function onGLBlur(_x2, _x3) {
        return _ref6.apply(this, arguments);
      }

      return onGLBlur;
    }(),
    onOrgChange: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(ioIndex, glIndex, orgIndex) {
        var self, year, cctrCode, ioCode, glCode, orgCode, orgList, isDuplicate;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                self = this;
                // When org is selected, check for existing budget

                year = this.formData.year;
                cctrCode = this.formData.cctrCode;
                ioCode = this.formData.ioList[ioIndex].ioCode;
                glCode = this.formData.ioList[ioIndex].glList[glIndex].glCode;
                orgCode = this.formData.ioList[ioIndex].glList[glIndex].orgList[orgIndex].orgCode;

                // Check for duplicate org in the same GL

                if (!orgCode) {
                  _context7.next = 15;
                  break;
                }

                orgList = this.formData.ioList[ioIndex].glList[glIndex].orgList;
                isDuplicate = orgList.some(function (org, idx) {
                  return idx !== orgIndex && org.orgCode === orgCode;
                });

                if (!isDuplicate) {
                  _context7.next = 15;
                  break;
                }

                Swal.fire("ไม่สามารถเพิ่มได้", "แผนกนี้มีอยู่ในรายการแล้ว กรุณาเลือกแผนกอื่น", "warning");
                // Clear the selection
                self.formData.ioList[ioIndex].glList[glIndex].orgList[orgIndex].orgCode = null;
                self.formData.ioList[ioIndex].glList[glIndex].orgList[orgIndex].orgName = "";
                // Reset Select2 dropdown
                self.$nextTick(function () {
                  var selectId = "#orgSelect-" + ioIndex + "-" + glIndex + "-" + orgIndex;
                  $(selectId).val(null).trigger("change");
                });
                return _context7.abrupt("return");

              case 15:
                if (!(year && cctrCode && ioCode && glCode && orgCode)) {
                  _context7.next = 18;
                  break;
                }

                _context7.next = 18;
                return this.loadSingleBudgetData(ioIndex, glIndex, orgIndex);

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onOrgChange(_x4, _x5, _x6) {
        return _ref7.apply(this, arguments);
      }

      return onOrgChange;
    }(),

    // Load Budget Data
    loadBudgetData: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(ioIndex, glIndex) {
        var self, response, budgetList, currentCCTRCode, currentIOCode, currentGLCode;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                self = this;
                _context8.prev = 1;
                _context8.next = 4;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Create/BudgetData", {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  },
                  params: {
                    year: self.formData.year,
                    cctrCode: self.formData.cctrCode,
                    ioCode: self.formData.ioList[ioIndex].ioCode,
                    glCode: self.formData.ioList[ioIndex].glList[glIndex].glCode
                  }
                });

              case 4:
                response = _context8.sent;


                if (response.data && response.data.success && response.data.data) {
                  budgetList = response.data.data;

                  if (budgetList.length > 0) {
                    // Store current codes as original codes for tracking changes
                    currentCCTRCode = self.formData.cctrCode;
                    currentIOCode = self.formData.ioList[ioIndex].ioCode;
                    currentGLCode = self.formData.ioList[ioIndex].glList[glIndex].glCode;

                    // Replace orgList with existing data

                    self.formData.ioList[ioIndex].glList[glIndex].orgList = budgetList.map(function (item) {
                      self.orgUidCounter++;
                      return {
                        _uid: self.orgUidCounter,
                        orgCode: item.orgCode,
                        orgName: item.orgName,
                        budgetAmount: item.budgetAmount || 0,
                        usedAmount: item.usedAmount || 0,
                        addedAmount: item.addedAmount || 0,
                        sendbackAmount: item.sendbackAmount || 0,
                        reducedAmount: item.reducedAmount || 0,
                        remainingAmount: item.remainingAmount || 0,
                        budgetTotal: item.budgetTotal || 0,
                        isReadOnly: item.usedAmount > 0 || item.addedAmount > 0 || item.sendbackAmount > 0 || item.reducedAmount > 0,
                        budgetPlanId: item.budgetPlanId,
                        // Store original codes for tracking changes
                        originalCCTRCode: currentCCTRCode,
                        originalIOCode: currentIOCode,
                        originalGLCode: currentGLCode
                      };
                    });
                  }
                }
                _context8.next = 11;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](1);

                console.error("Error loading budget data:", _context8.t0);

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[1, 8]]);
      }));

      function loadBudgetData(_x7, _x8) {
        return _ref8.apply(this, arguments);
      }

      return loadBudgetData;
    }(),

    loadSingleBudgetData: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(ioIndex, glIndex, orgIndex) {
        var self, org, response, item;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                self = this;
                org = self.formData.ioList[ioIndex].glList[glIndex].orgList[orgIndex];
                _context9.prev = 2;
                _context9.next = 5;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Create/BudgetData", {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  },
                  params: {
                    year: self.formData.year,
                    cctrCode: self.formData.cctrCode,
                    ioCode: self.formData.ioList[ioIndex].ioCode,
                    glCode: self.formData.ioList[ioIndex].glList[glIndex].glCode,
                    orgCode: org.orgCode
                  }
                });

              case 5:
                response = _context9.sent;


                if (response.data && response.data.success && response.data.data && response.data.data.length > 0) {
                  item = response.data.data[0];

                  org.budgetAmount = item.budgetAmount || 0;
                  org.usedAmount = item.usedAmount || 0;
                  org.addedAmount = item.addedAmount || 0;
                  org.sendbackAmount = item.sendbackAmount || 0;
                  org.reducedAmount = item.reducedAmount || 0;
                  org.remainingAmount = item.remainingAmount || 0;
                  org.budgetTotal = item.budgetTotal || 0;
                  org.isReadOnly = item.usedAmount > 0 || item.addedAmount > 0 || item.sendbackAmount > 0 || item.reducedAmount > 0;
                  org.budgetPlanId = item.budgetPlanId;
                  // Store original codes for tracking changes
                  org.originalCCTRCode = self.formData.cctrCode;
                  org.originalIOCode = self.formData.ioList[ioIndex].ioCode;
                  org.originalGLCode = self.formData.ioList[ioIndex].glList[glIndex].glCode;
                }
                _context9.next = 12;
                break;

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9["catch"](2);

                console.error("Error loading single budget data:", _context9.t0);

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[2, 9]]);
      }));

      function loadSingleBudgetData(_x9, _x10, _x11) {
        return _ref9.apply(this, arguments);
      }

      return loadSingleBudgetData;
    }(),

    // Calculate
    calculateRemaining: function calculateRemaining(ioIndex, glIndex, orgIndex) {
      var org = this.formData.ioList[ioIndex].glList[glIndex].orgList[orgIndex];
      org.remainingAmount = (org.budgetAmount || 0) + (org.addedAmount || 0) + (org.sendbackAmount || 0) - (org.usedAmount || 0) - (org.reducedAmount || 0);
    },
    validateAndCalculateRemaining: function validateAndCalculateRemaining(ioIndex, glIndex, orgIndex) {
      var org = this.formData.ioList[ioIndex].glList[glIndex].orgList[orgIndex];
      // Ensure positive value
      if (org.budgetAmount === null || org.budgetAmount === undefined || org.budgetAmount === '' || isNaN(org.budgetAmount) || org.budgetAmount < 0) {
        org.budgetAmount = 0;
      }
      this.calculateRemaining(ioIndex, glIndex, orgIndex);
    },
    onBudgetFocus: function onBudgetFocus(event, org) {
      // Mark as editing and show raw number (without comma)
      this.$set(org, '_isEditing', true);
      // Set value to raw number
      event.target.value = org.budgetAmount || 0;
      // Select all text for easy editing
      event.target.select();
    },
    onBudgetBlur: function onBudgetBlur(event, ioIndex, glIndex, orgIndex) {
      var org = this.formData.ioList[ioIndex].glList[glIndex].orgList[orgIndex];
      // Parse the value (remove commas if user typed them)
      var rawValue = event.target.value.replace(/,/g, '');
      var numValue = parseFloat(rawValue);

      // Validate and set value
      if (isNaN(numValue) || numValue < 0) {
        numValue = 0;
      }
      org.budgetAmount = numValue;

      // Mark as not editing (will show formatted number)
      this.$set(org, '_isEditing', false);

      // Calculate remaining
      this.calculateRemaining(ioIndex, glIndex, orgIndex);
    },
    preventNegativeInput: function preventNegativeInput(event) {
      // Allow: backspace, delete, tab, escape, enter, home, end, arrows
      var allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
      if (allowedKeys.indexOf(event.key) !== -1) return;
      // Allow Ctrl/Cmd+A, C, V, X
      if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].indexOf(event.key.toLowerCase()) !== -1) return;
      // Allow digits and decimal point only
      if (/^[0-9.]$/.test(event.key)) {
        // Prevent multiple decimal points
        if (event.key === '.' && event.target.value.indexOf('.') !== -1) {
          event.preventDefault();
        }
        return;
      }
      // Block everything else (letters, minus, symbols, etc.)
      event.preventDefault();
    },
    calculateGLTotal: function calculateGLTotal(gl, field) {
      var total = 0;
      gl.orgList.forEach(function (org) {
        total += org[field] || 0;
      });
      return total;
    },
    calculateIOTotal: function calculateIOTotal(io, field) {
      var self = this;
      var total = 0;
      io.glList.forEach(function (gl) {
        total += self.calculateGLTotal(gl, field);
      });
      return total;
    },
    calculateGLBudgetTotal: function calculateGLBudgetTotal(gl) {
      var total = 0;
      gl.orgList.forEach(function (org) {
        // ใช้ budgetTotal จาก backend (Initial + Added - Reduced, ไม่รวมคืนเงิน)
        total += org.budgetTotal || 0;
      });
      return total;
    },
    calculateIOBudgetTotal: function calculateIOBudgetTotal(io) {
      var self = this;
      var total = 0;
      io.glList.forEach(function (gl) {
        total += self.calculateGLBudgetTotal(gl);
      });
      return total;
    },

    // ================= CR-BudgetReport ข้อ 2: cascading filter =================

    /// เปลี่ยน filter ช่องใด -> โหลดตัวเลือกของช่องที่เหลือใหม่ (Q-C3 เรียก API ทุกครั้ง)
    onFilterChanged: function onFilterChanged() {
      this.reloadFilterOptions();
    },

    /// โหลดตัวเลือกที่ยังเป็นไปได้ของทั้ง 4 ช่อง
    /// ตัวเลือกของช่องหนึ่งไม่ถูกกรองด้วยค่าที่เลือกในช่องนั้นเอง (ฝั่ง API จัดการให้)
    reloadFilterOptions: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var self, seq, response, d;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                self = this;

                if (!(!self.formData.year || !self.formData.cctrCode)) {
                  _context10.next = 3;
                  break;
                }

                return _context10.abrupt("return");

              case 3:
                seq = ++self.filterOptionsSeq;
                _context10.prev = 4;
                _context10.next = 7;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Create/FilterOptions", {
                  headers: { Authorization: "Bearer " + self.$root.user.access_token },
                  params: {
                    year: self.formData.year,
                    cctrCode: self.formData.cctrCode,
                    ioCodes: self.searchIOCodes.join(","),
                    glCodes: self.searchGLCodes.join(","),
                    glTypeNames: self.searchGLTypeNames.join(","),
                    orgCodes: self.searchOrgCodes.join(",")
                  }
                });

              case 7:
                response = _context10.sent;

                if (!(seq !== self.filterOptionsSeq)) {
                  _context10.next = 10;
                  break;
                }

                return _context10.abrupt("return");

              case 10:

                if (response.data && response.data.success) {
                  d = response.data.data || {};

                  self.ioTreeOptions = self.toTreeOptions(d.ios);
                  self.glTreeOptions = self.toTreeOptions(d.gls);
                  self.glTypeTreeOptions = self.toTreeOptions(d.glTypes);
                  self.orgFilterTreeOptions = self.toTreeOptions(d.orgs);
                } else {
                  // ตัวเลือกเดิมยังใช้ได้ จึงไม่ขัดจังหวะผู้ใช้ — แต่ต้องเห็นใน console
                  console.warn("โหลดตัวเลือก filter ไม่สำเร็จ", response.data && response.data.message || "unknown error");
                }
                _context10.next = 16;
                break;

              case 13:
                _context10.prev = 13;
                _context10.t0 = _context10["catch"](4);

                // ไม่ขัดจังหวะผู้ใช้ — ตัวเลือกเดิมยังใช้ได้
                if (seq === self.filterOptionsSeq) {
                  console.warn("โหลดตัวเลือก filter ไม่สำเร็จ", _context10.t0);
                }

              case 16:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[4, 13]]);
      }));

      function reloadFilterOptions() {
        return _ref10.apply(this, arguments);
      }

      return reloadFilterOptions;
    }(),

    toTreeOptions: function toTreeOptions(list) {
      return (list || []).map(function (item) {
        return { id: item.value, label: item.text };
      });
    },

    // Search
    searchBudgetPlan: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var self, response, searchResult;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                self = this;

                // ไม่เลือกอะไรเลย = ดูทั้งหมด ไม่ต้องบังคับให้กรอก (filter เป็น multi-select แล้ว)

                void 0;

                _context11.prev = 2;

                KTApp.blockPage({ opacity: 0.05, message: "กำลังค้นหา..." });

                _context11.next = 6;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Create/Search", {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  },
                  params: {
                    year: self.formData.year,
                    cctrCode: self.formData.cctrCode, // Issue 46: ส่ง CCTR ที่เลือกจากหน้าแรก
                    orgCodes: self.searchOrgCodes.join(","),
                    ioCodes: self.searchIOCodes.join(","),
                    glCodes: self.searchGLCodes.join(","),
                    glTypeNames: self.searchGLTypeNames.join(",")
                  }
                });

              case 6:
                response = _context11.sent;


                KTApp.unblockPage();

                if (response.data && response.data.success && response.data.data) {
                  searchResult = response.data.data;


                  if (searchResult.cctrCode) {
                    // Populate form with search result
                    self.formData.cctrCode = searchResult.cctrCode;
                    self.formData.cctrName = searchResult.cctrName || "";
                    self.formData.isFilteredView = true; // Issue 47: บันทึกจาก filtered view ห้ามลบรายการที่ถูก filter ออก

                    if (searchResult.ioList && searchResult.ioList.length > 0) {
                      self.formData.ioList = searchResult.ioList.map(function (io) {
                        return {
                          ioCode: io.ioCode,
                          ioName: io.ioName || "",
                          collapsed: false,
                          isFromDb: true,
                          glList: (io.glList || []).map(function (gl) {
                            return {
                              glCode: gl.glCode,
                              glName: gl.glName || "",
                              glTypeName: gl.glTypeName || "",
                              collapsed: false,
                              isFromDb: true,
                              orgList: (gl.orgList || []).map(function (org) {
                                self.orgUidCounter++;
                                return {
                                  _uid: self.orgUidCounter,
                                  orgCode: org.orgCode,
                                  orgName: org.orgName || "",
                                  budgetAmount: org.budgetAmount || 0,
                                  usedAmount: org.usedAmount || 0,
                                  addedAmount: org.addedAmount || 0,
                                  sendbackAmount: org.sendbackAmount || 0,
                                  reducedAmount: org.reducedAmount || 0,
                                  remainingAmount: org.remainingAmount || 0,
                                  budgetTotal: org.budgetTotal || 0,
                                  isReadOnly: org.usedAmount > 0 || org.addedAmount > 0 || org.sendbackAmount > 0 || org.reducedAmount > 0,
                                  budgetPlanId: org.budgetPlanId,
                                  // Store original codes for tracking changes
                                  originalCCTRCode: searchResult.cctrCode,
                                  originalIOCode: io.ioCode,
                                  originalGLCode: gl.glCode
                                };
                              })
                            };
                          })
                        };
                      });
                    }
                  } else {
                    Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลที่ตรงกับเงื่อนไข", "info");
                  }
                }
                _context11.next = 16;
                break;

              case 11:
                _context11.prev = 11;
                _context11.t0 = _context11["catch"](2);

                KTApp.unblockPage();
                console.error("Error searching:", _context11.t0);
                Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถค้นหาข้อมูลได้", "error");

              case 16:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[2, 11]]);
      }));

      function searchBudgetPlan() {
        return _ref11.apply(this, arguments);
      }

      return searchBudgetPlan;
    }(),
    clearSearch: function clearSearch() {
      // Clear search filters only
      this.searchKeyword = "";
      this.searchOrgCodes = [];
      this.searchIOCodes = [];
      this.searchGLCodes = [];
      this.searchGLTypeNames = [];
      this.reloadFilterOptions();

      // In Edit/View mode: reload data from original year/cctr
      if (this.isEditMode || this.isViewMode) {
        this.loadEditData();
      }
    },

    // Save
    saveBudgetPlan: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var self, hasValidData, i, io, j, gl, k, org, confirmResult, response, message;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                self = this;

                // Validation

                if (self.formData.year) {
                  _context12.next = 4;
                  break;
                }

                Swal.fire("กรุณากรอกข้อมูล", "กรุณาเลือกปีงบประมาณ", "warning");
                return _context12.abrupt("return");

              case 4:
                if (self.formData.cctrCode) {
                  _context12.next = 7;
                  break;
                }

                Swal.fire("กรุณากรอกข้อมูล", "กรุณากรอกรหัส CCTR", "warning");
                return _context12.abrupt("return");

              case 7:
                if (self.formData.cctrName) {
                  _context12.next = 10;
                  break;
                }

                Swal.fire("กรุณากรอกข้อมูล", "กรุณากรอกชื่อ CCTR", "warning");
                return _context12.abrupt("return");

              case 10:

                // Validate IO/GL/Org
                hasValidData = false;
                i = 0;

              case 12:
                if (!(i < self.formData.ioList.length)) {
                  _context12.next = 42;
                  break;
                }

                io = self.formData.ioList[i];

                if (io.ioCode) {
                  _context12.next = 17;
                  break;
                }

                Swal.fire("กรุณากรอกข้อมูล", "กรุณากรอกรหัส IO ใน IO #" + (i + 1), "warning");
                return _context12.abrupt("return");

              case 17:
                j = 0;

              case 18:
                if (!(j < io.glList.length)) {
                  _context12.next = 39;
                  break;
                }

                gl = io.glList[j];

                if (gl.glCode) {
                  _context12.next = 23;
                  break;
                }

                Swal.fire("กรุณากรอกข้อมูล", "กรุณากรอกรหัส GL ใน IO #" + (i + 1) + " GL #" + (j + 1), "warning");
                return _context12.abrupt("return");

              case 23:
                k = 0;

              case 24:
                if (!(k < gl.orgList.length)) {
                  _context12.next = 36;
                  break;
                }

                org = gl.orgList[k];

                if (org.orgCode) {
                  _context12.next = 29;
                  break;
                }

                Swal.fire("กรุณากรอกข้อมูล", "กรุณาเลือกแผนกในรายการที่ " + (k + 1), "warning");
                return _context12.abrupt("return");

              case 29:
                if (!(org.budgetAmount === null || org.budgetAmount === undefined || org.budgetAmount === '' || org.budgetAmount < 0)) {
                  _context12.next = 32;
                  break;
                }

                Swal.fire("กรุณากรอกข้อมูล", "กรุณากรอกงบประมาณ (อนุญาตให้เป็น 0 ได้)", "warning");
                return _context12.abrupt("return");

              case 32:
                hasValidData = true;

              case 33:
                k++;
                _context12.next = 24;
                break;

              case 36:
                j++;
                _context12.next = 18;
                break;

              case 39:
                i++;
                _context12.next = 12;
                break;

              case 42:
                if (hasValidData) {
                  _context12.next = 45;
                  break;
                }

                Swal.fire("กรุณากรอกข้อมูล", "กรุณาเพิ่มรายการแผนกและงบประมาณอย่างน้อย 1 รายการ", "warning");
                return _context12.abrupt("return");

              case 45:
                _context12.next = 47;
                return Swal.fire({
                  title: "ยืนยันการบันทึก",
                  text: "คุณต้องการบันทึกข้อมูลแผนงบประมาณนี้หรือไม่?",
                  type: "question",
                  showCancelButton: true,
                  confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ยกเลิก"
                });

              case 47:
                confirmResult = _context12.sent;

                if (confirmResult.value) {
                  _context12.next = 50;
                  break;
                }

                return _context12.abrupt("return");

              case 50:
                _context12.prev = 50;

                self.isSaving = true;
                KTApp.blockPage({ opacity: 0.05, message: "กำลังบันทึกข้อมูล..." });

                _context12.next = 55;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BudgetPlan/Create/Save", self.formData, {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 55:
                response = _context12.sent;


                KTApp.unblockPage();
                self.isSaving = false;

                if (!(response.data && response.data.success)) {
                  _context12.next = 64;
                  break;
                }

                _context12.next = 61;
                return Swal.fire({
                  title: "บันทึกสำเร็จ",
                  text: response.data.message || "บันทึกข้อมูลแผนงบประมาณเรียบร้อยแล้ว",
                  type: "success"
                });

              case 61:
                self.$router.push({ path: "/BudgetPlan/List", query: { reload: Date.now() } });
                _context12.next = 65;
                break;

              case 64:
                Swal.fire("เกิดข้อผิดพลาด", response.data.message || "ไม่สามารถบันทึกข้อมูลได้", "error");

              case 65:
                _context12.next = 75;
                break;

              case 67:
                _context12.prev = 67;
                _context12.t0 = _context12["catch"](50);

                KTApp.unblockPage();
                self.isSaving = false;
                console.error("Error saving:", _context12.t0);
                message = "ไม่สามารถบันทึกข้อมูลได้";

                if (_context12.t0.response && _context12.t0.response.data && _context12.t0.response.data.message) {
                  message = _context12.t0.response.data.message;
                }
                Swal.fire("เกิดข้อผิดพลาด", message, "error");

              case 75:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[50, 67]]);
      }));

      function saveBudgetPlan() {
        return _ref12.apply(this, arguments);
      }

      return saveBudgetPlan;
    }(),

    // Check if GL can be deleted (no org has been used)
    canDeleteGL: function canDeleteGL(gl) {
      // Can delete if no org list or all orgs are not readonly
      if (!gl.orgList || gl.orgList.length === 0) {
        return true;
      }
      return gl.orgList.every(function (org) {
        return !org.isReadOnly;
      });
    },

    // Check if IO can be deleted (no GL has been used)
    canDeleteIO: function canDeleteIO(io) {
      var self = this;
      // Can delete if no GL list or all GLs can be deleted
      if (!io.glList || io.glList.length === 0) {
        return true;
      }
      return io.glList.every(function (gl) {
        return self.canDeleteGL(gl);
      });
    },

    // Format Number
    formatNumber: function formatNumber(value) {
      if (value === null || value === undefined) return "0.00";
      return parseFloat(value).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    // Export Budget History to Excel
    exportBudgetHistory: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var self, year, cctrCode, params, response, filename, contentDisposition, filenameMatch, blob, link, message;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                self = this;
                year = self.formData.year;
                cctrCode = self.formData.cctrCode;

                if (!(!year || !cctrCode)) {
                  _context13.next = 6;
                  break;
                }

                Swal.fire("ไม่สามารถ Export ได้", "กรุณาเลือกข้อมูลงบประมาณก่อน", "warning");
                return _context13.abrupt("return");

              case 6:
                _context13.prev = 6;

                self.isExporting = true;

                // Build query parameters
                params = new URLSearchParams();

                params.append("year", year);
                params.append("cctrCode", cctrCode);

                // Add optional filters from search
                if (self.searchOrgCodes && self.searchOrgCodes.length > 0) {
                  params.append("orgCodes", self.searchOrgCodes.join(","));
                }
                // CR-BudgetReport ข้อ 2 (UC-02): ไฟล์ที่ export ต้องสะท้อน filter ที่เลือกบนหน้าจอ
                if (self.searchIOCodes && self.searchIOCodes.length > 0) {
                  params.append("ioCodes", self.searchIOCodes.join(","));
                }
                if (self.searchGLCodes && self.searchGLCodes.length > 0) {
                  params.append("glCodes", self.searchGLCodes.join(","));
                }
                if (self.searchGLTypeNames && self.searchGLTypeNames.length > 0) {
                  params.append("glTypeNames", self.searchGLTypeNames.join(","));
                }

                _context13.next = 17;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/ExportHistory?" + params.toString(), {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  },
                  responseType: "blob"
                });

              case 17:
                response = _context13.sent;


                self.isExporting = false;

                // Get filename from Content-Disposition header or use default
                filename = "BudgetHistory_" + year + "_" + cctrCode + ".xlsx";
                contentDisposition = response.headers["content-disposition"];

                if (contentDisposition) {
                  filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);

                  if (filenameMatch && filenameMatch[1]) {
                    filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ""));
                  }
                }

                // Create download link
                blob = new Blob([response.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                link = document.createElement("a");

                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
                window.URL.revokeObjectURL(link.href);

                Swal.fire("สำเร็จ", "Export ข้อมูลงบประมาณเรียบร้อยแล้ว", "success");
                _context13.next = 38;
                break;

              case 31:
                _context13.prev = 31;
                _context13.t0 = _context13["catch"](6);

                self.isExporting = false;
                console.error("Error exporting budget history:", _context13.t0);

                message = "ไม่สามารถ Export ข้อมูลได้";

                if (_context13.t0.response && _context13.t0.response.status === 404) {
                  message = "ไม่พบข้อมูลสำหรับ Export";
                } else if (_context13.t0.response && _context13.t0.response.data && _context13.t0.response.data.message) {
                  message = _context13.t0.response.data.message;
                }

                Swal.fire("เกิดข้อผิดพลาด", message, "error");

              case 38:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[6, 31]]);
      }));

      function exportBudgetHistory() {
        return _ref13.apply(this, arguments);
      }

      return exportBudgetHistory;
    }()
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      errorMessage: "",
      detailData: null
    };
  },
  computed: {
    totalUsedAmount: function totalUsedAmount() {
      if (!this.detailData) return 0;
      return this.detailData.usedAmount || 0;
    },
    totalAddedAmount: function totalAddedAmount() {
      if (!this.detailData) return 0;
      return this.detailData.addedAmount || 0;
    },
    totalReducedAmount: function totalReducedAmount() {
      if (!this.detailData) return 0;
      return this.detailData.reducedAmount || 0;
    },
    budgetTotal: function budgetTotal() {
      if (!this.detailData) return 0;
      var A = this.detailData.initialBudgetAmount || 0;
      var B = this.totalAddedAmount - (this.detailData.sendbackAmount || 0); // 18.3: ไม่รวมคืนเงินในงบประมาณรวม
      var D = this.totalReducedAmount;
      return A + B - D;
    },
    budgetRemaining: function budgetRemaining() {
      if (!this.detailData) return 0;
      var A = this.detailData.initialBudgetAmount || 0;
      var B = this.totalAddedAmount;
      var C = this.totalUsedAmount;
      var D = this.totalReducedAmount;
      return A + B - (C + D);
    }
  },
  mounted: function mounted() {
    this.loadDetail();
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    loadDetail: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var self, budgetPlanId, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;
                budgetPlanId = self.$route.params.id;

                if (budgetPlanId) {
                  _context.next = 5;
                  break;
                }

                self.errorMessage = "ไม่พบรหัสงบประมาณ";
                return _context.abrupt("return");

              case 5:

                self.isLoading = true;
                self.errorMessage = "";

                _context.prev = 7;
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/" + budgetPlanId + "/Detail", {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 10:
                response = _context.sent;


                if (response.data && response.data.success) {
                  self.detailData = response.data.data;
                } else {
                  self.errorMessage = response.data.message || "ไม่สามารถโหลดข้อมูลได้";
                }
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](7);

                console.error("Error loading detail:", _context.t0);
                self.errorMessage = "เกิดข้อผิดพลาดในการโหลดข้อมูล";

              case 18:
                _context.prev = 18;

                self.isLoading = false;
                return _context.finish(18);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 14, 18, 21]]);
      }));

      function loadDetail() {
        return _ref.apply(this, arguments);
      }

      return loadDetail;
    }(),
    formatNumber: function formatNumber(value) {
      if (value === null || value === undefined) return "0.00";
      return parseFloat(value).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      jobs: [],
      selectedJobs: [],
      selectAll: false,
      isLoading: false,
      isProcessing: false // #93: ป้องกันการกดปุ่มซ้ำ + #94 race condition
    };
  },
  mounted: function mounted() {
    this.loadPendingJobs();
  },

  methods: {
    loadPendingJobs: function loadPendingJobs() {
      var self = this;
      self.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/PendingApprovalJobs").then(function (response) {
        self.jobs = response.data || [];
      }).catch(function (error) {
        console.error("Failed to load pending jobs:", error);
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดข้อมูลได้", "error");
      }).finally(function () {
        self.isLoading = false;
      });
    },
    toggleSelectAll: function toggleSelectAll() {
      if (this.selectAll) {
        this.selectedJobs = this.jobs.map(function (j) {
          return j.id;
        });
      } else {
        this.selectedJobs = [];
      }
    },
    bulkApprove: function bulkApprove() {
      var self = this;
      if (self.selectedJobs.length === 0 || self.isProcessing) return; // #93: guard re-entry

      Swal.fire({
        title: "ยืนยันอนุมัติ",
        text: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34/\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19 " + self.selectedJobs.length + " \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          // #92: loading overlay + #93: lock button (ใช้รูปแบบเดียวกับหน้า approve job)
          self.isProcessing = true;
          Swal.fire({
            title: "กำลังดำเนินการ...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            onBeforeOpen: function onBeforeOpen() {
              Swal.showLoading();
            }
          });

          var payload = self.selectedJobs.map(function (jobId) {
            var job = self.jobs.find(function (j) {
              return j.id === jobId;
            });
            return { jobId: jobId, remark: job ? job.remark : "" };
          });

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BudgetPlan/BulkApprove", payload).then(function (response) {
            Swal.fire("สำเร็จ", response.data.message || "อนุมัติเรียบร้อย", "success");
            self.selectedJobs = [];
            self.selectAll = false;
            self.loadPendingJobs();
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response && error.response.data && error.response.data.message || error.message, "error");
          }).finally(function () {
            self.isProcessing = false;
          });
        }
      });
    },
    bulkReject: function bulkReject() {
      var self = this;
      if (self.selectedJobs.length === 0 || self.isProcessing) return; // #93: guard re-entry

      // Validate: ห้ามเลือกรายการ "รอยืนยัน" (CONFIRM) — ใช้ได้เฉพาะปุ่ม "อนุมัติ/ยืนยัน" เท่านั้น
      var confirmJobs = self.selectedJobs.filter(function (jobId) {
        var job = self.jobs.find(function (j) {
          return j.id === jobId;
        });
        return job && job.approverType === 'CONFIRM';
      });
      if (confirmJobs.length > 0) {
        Swal.fire("ไม่สามารถดำเนินการได้", "กรุณานำใบงานสถานะ \"รอยืนยัน\" ออกจากตัวเลือก ไม่สามารถดำเนินการใบงานนี้ได้ ต้องใช้รูปแบบ \"อนุมัติ/ยืนยัน รายการที่เลือก\" เท่านั้น", "warning");
        return;
      }

      // Validate: ต้องกรอกหมายเหตุ/เหตุผล ทุกใบที่เลือก
      var missingRemark = self.selectedJobs.filter(function (jobId) {
        var job = self.jobs.find(function (j) {
          return j.id === jobId;
        });
        return !job || !job.remark || !job.remark.trim();
      });
      if (missingRemark.length > 0) {
        Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกหมายเหตุ/เหตุผล ของใบงานที่เลือกทุกใบ", "warning");
        return;
      }

      Swal.fire({
        title: "ยืนยันไม่อนุมัติ/ส่งกลับแก้ไข",
        text: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23 " + self.selectedJobs.length + " \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          // #92: loading overlay + #93: lock button (ใช้รูปแบบเดียวกับหน้า approve job)
          self.isProcessing = true;
          Swal.fire({
            title: "กำลังดำเนินการ...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            onBeforeOpen: function onBeforeOpen() {
              Swal.showLoading();
            }
          });

          var payload = self.selectedJobs.map(function (jobId) {
            var job = self.jobs.find(function (j) {
              return j.id === jobId;
            });
            return { jobId: jobId, remark: job ? job.remark : "" };
          });

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BudgetPlan/BulkReject", payload).then(function (response) {
            Swal.fire("สำเร็จ", response.data.message || "ดำเนินการเรียบร้อย", "success");
            self.selectedJobs = [];
            self.selectAll = false;
            self.loadPendingJobs();
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response && error.response.data && error.response.data.message || error.message, "error");
          }).finally(function () {
            self.isProcessing = false;
          });
        }
      });
    },
    formatNumber: function formatNumber(num) {
      if (num == null) return "0.00";
      return Number(num).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var _methods;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__webpack_require__(664);

__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a
  },
  data: function data() {
    // Generate year options: current year and next year
    var currentYear = new Date().getFullYear();
    var budgetYearData = [{ id: currentYear.toString(), text: currentYear.toString() }, { id: (currentYear + 1).toString(), text: (currentYear + 1).toString() }];

    return {
      // Mode flags
      isViewMode: false,
      isEditMode: false,
      jobId: null,
      jobData: null,
      // Dropdown options
      budgetYearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: false,
        data: budgetYearData
      },
      cctrOptions: {
        placeholder: "เลือก CCTR",
        allowClear: true,
        data: []
      },
      ioOptions: {
        placeholder: "เลือก IO",
        allowClear: true,
        data: []
      },
      glOptions: {
        placeholder: "เลือก GL",
        allowClear: true,
        data: []
      },
      orgOptions: {
        placeholder: "เลือก แผนก",
        allowClear: true,
        data: []
      },
      // Issue 43.2: เก็บ codes/names ของใบงานที่ load เพื่อ inject เข้า dropdown
      jobCCTRCode: null,
      jobCCTRName: null,
      jobIOCode: null,
      jobIOName: null,
      jobGLCode: null,
      jobGLName: null,
      jobOrgCode: null,
      jobOrgName: null,
      jobTargetIOCode: null,
      jobTargetIOName: null,
      jobTargetGLCode: null,
      jobTargetGLName: null,
      jobTargetOrgCode: null,
      jobTargetOrgName: null,
      jobTypeOptions: {
        placeholder: "เลือกประเภทใบงาน",
        allowClear: false,
        data: []
      },
      sourceJobOptions: {
        placeholder: "เลือกครั้งที่",
        allowClear: true,
        data: []
      },
      // Selected values
      selectedBudgetYear: currentYear.toString(), // Default to current year
      selectedCCTR: null,
      selectedIO: null,
      selectedGL: null,
      selectedOrg: null,
      selectedJobType: null,
      selectedSourceJobId: null, // For refund job type
      sourceJobData: null, // Data of selected source job (for SENDBACK)
      loadedRefundAmount: 0, // ISS-70: ยอดเดิมของใบคืนที่เปิดแก้ (คืนสิทธิ์ให้ตัวเองตอนเช็กเพดาน)
      loadedRefundSourceId: null, // ISS-70: ใบเบิกต้นทางเดิมของใบคืนที่เปิดแก้
      // Budget info
      budgetInfo: null,
      originalBudgetPlanId: null, // Issue 35: track original plan ID to detect plan changes
      sequenceNo: 1,
      jobDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()(),
      // Items
      items: [],
      // Direct amount input (for ADJUST_ADD and ADJUST_TRANSFER)
      directAmount: null,
      directAmountEditing: false, // Track if directAmount input is being edited
      // Target budget (for ADJUST_TRANSFER)
      selectedTargetYear: null,
      selectedTargetCCTR: null,
      selectedTargetIO: null,
      selectedTargetGL: null,
      selectedTargetOrg: null,
      targetBudgetInfo: null,
      // Other fields
      remark: "",
      // Vendor (for CREATE job type)
      vendorId: null,
      vendorDisplayName: "",
      otherVendorName: "", // FR-016
      vendorSelect2Initialized: false,
      // Raw dropdown data from API
      rawDropdownData: null,
      // Raw dropdown data for target budget selection (bi-directional filtering)
      rawTargetDropdownData: null,
      // Flag to indicate target dropdowns are loading
      isLoadingTargetDropdowns: false,
      // Flag to control dropdown rendering
      dropdownsLoaded: false,
      // Flag to prevent infinite loop when reloading dropdowns
      isReloadingDropdowns: false,
      // Debounce timer for dropdown reload
      dropdownReloadTimer: null,
      // Flag to track submission in progress
      isSubmitting: false,
      // Approval data
      approvalHistory: [],
      jobStatus: 0,
      currentUserApproverId: null,
      canApprove: false,
      currentApprovalLevel: 0,
      maxApproveOnlyLevel: 0,
      currentApproverType: null,
      canReturn: false,
      canReject: false,
      // Attachment files
      attachments: [],
      isLoadingFiles: false, // Issue 24: loading state for file URLs
      uploadingFile: false,
      // Add jobs table (for ADJUST_ADD)
      showAddJobsTable: false,
      loadingAddJobs: false,
      addJobsList: []
    };
  },
  computed: {
    canEdit: function canEdit() {
      // Can edit only if status = 0 (DRAFT) or 5 (RETURNED) and not in view mode
      if (this.isViewMode) return false;
      if (this.isEditMode && this.jobData) {
        return this.jobData.status === 0 || this.jobData.status === 5;
      }
      return true; // Create mode
    },
    isBudgetUser: function isBudgetUser() {
      // ตรวจสอบว่า user เป็น BUDGET_PLAN_USER (ไม่ใช่ REVIEWER หรือ MANAGER)
      var isReviewer = this.$root.canShowExSuperAdmin([['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET']]);
      var isManager = this.$root.canShowExSuperAdmin([['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']]);
      return !isReviewer && !isManager;
    },
    pageTitle: function pageTitle() {
      if (this.isViewMode) return "ดูรายละเอียดใบงาน เลขที่ " + (this.jobData && this.jobData.jobNumber ? this.jobData.jobNumber : "");
      if (this.isEditMode) return "แก้ไขรายละเอียดใบงาน เลขที่ " + (this.jobData && this.jobData.jobNumber ? this.jobData.jobNumber : "");
      return "สร้างใบงานงบประมาณ";
    },
    // แสดงชื่อ CCTR ที่เลือก (ใช้แสดงในช่องปลายทางแบบ readonly)
    selectedCCTRDisplay: function selectedCCTRDisplay() {
      var _this = this;

      if (!this.selectedCCTR || !this.cctrOptions || !this.cctrOptions.data) {
        return '';
      }
      var selected = this.cctrOptions.data.find(function (item) {
        return item.id === _this.selectedCCTR;
      });
      return selected ? selected.text : this.selectedCCTR;
    },
    // Dropdown data arrays for target budget selection
    budgetYears: function budgetYears() {
      // Return budget year options from data
      var currentYear = new Date().getFullYear();
      return [{ value: currentYear.toString(), text: currentYear.toString() }, { value: (currentYear + 1).toString(), text: (currentYear + 1).toString() }];
    },
    cctrList: function cctrList() {
      if (!this.cctrOptions || !this.cctrOptions.data) return [];
      return this.cctrOptions.data.map(function (item) {
        return { value: item.id, text: item.text };
      });
    },
    ioList: function ioList() {
      if (!this.ioOptions || !this.ioOptions.data) return [];
      return this.ioOptions.data.map(function (item) {
        return { value: item.id, text: item.text };
      });
    },
    glList: function glList() {
      if (!this.glOptions || !this.glOptions.data) return [];
      return this.glOptions.data.map(function (item) {
        return { value: item.id, text: item.text };
      });
    },
    orgList: function orgList() {
      if (!this.orgOptions || !this.orgOptions.data) return [];
      return this.orgOptions.data.map(function (item) {
        return { value: item.id, text: item.text };
      });
    },
    targetYearOptions: function targetYearOptions() {
      var currentYear = new Date().getFullYear();
      return {
        placeholder: "-- เลือก --",
        allowClear: false,
        data: [{ id: currentYear.toString(), text: currentYear.toString() }, { id: (currentYear + 1).toString(), text: (currentYear + 1).toString() }]
      };
    },
    targetCCTROptions: function targetCCTROptions() {
      return {
        placeholder: "-- เลือก --",
        allowClear: false,
        data: this.cctrList.map(function (item) {
          return { id: item.value, text: item.text };
        })
      };
    },
    // Target IO options - ใช้ bi-directional filtering จาก rawTargetDropdownData
    targetIOOptions: function targetIOOptions() {
      var data = [];
      if (this.rawTargetDropdownData && this.rawTargetDropdownData.ioCodes) {
        data = this.rawTargetDropdownData.ioCodes.map(function (item) {
          return { id: item.value, text: item.text };
        });
      } else if (this.rawDropdownData && this.rawDropdownData.ioCodes) {
        // ใช้ข้อมูลจาก source ถ้ายังไม่ได้โหลด target dropdown data
        data = this.rawDropdownData.ioCodes.map(function (item) {
          return { id: item.value, text: item.text };
        });
      }
      return {
        placeholder: "-- เลือก IO --",
        allowClear: true,
        data: data
      };
    },
    // Target GL options - ใช้ bi-directional filtering จาก rawTargetDropdownData
    targetGLOptions: function targetGLOptions() {
      var data = [];
      if (this.rawTargetDropdownData && this.rawTargetDropdownData.glCodes) {
        data = this.rawTargetDropdownData.glCodes.map(function (item) {
          return { id: item.value, text: item.text };
        });
      } else if (this.rawDropdownData && this.rawDropdownData.glCodes) {
        // ใช้ข้อมูลจาก source ถ้ายังไม่ได้โหลด target dropdown data
        data = this.rawDropdownData.glCodes.map(function (item) {
          return { id: item.value, text: item.text };
        });
      }
      return {
        placeholder: "-- เลือก GL --",
        allowClear: true,
        data: data
      };
    },
    // Target Org options - ใช้ bi-directional filtering จาก rawTargetDropdownData
    targetOrgOptions: function targetOrgOptions() {
      var data = [];
      if (this.rawTargetDropdownData && this.rawTargetDropdownData.orgCodes) {
        data = this.rawTargetDropdownData.orgCodes.map(function (item) {
          return { id: item.value, text: item.text };
        });
      } else if (this.rawDropdownData && this.rawDropdownData.orgCodes) {
        // ใช้ข้อมูลจาก source ถ้ายังไม่ได้โหลด target dropdown data
        data = this.rawDropdownData.orgCodes.map(function (item) {
          return { id: item.value, text: item.text };
        });
      }
      return {
        placeholder: "-- เลือก แผนก --",
        allowClear: true,
        data: data
      };
    },
    totalAmount: function totalAmount() {
      // For ADJUST_ADD, ADJUST_TRANSFER, and ADJUST_REDUCE, use directAmount
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD' || this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' || this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return parseFloat(this.directAmount) || 0;
      }

      // For other types, sum from items
      return this.items.reduce(function (sum, item) {
        return sum + (parseFloat(item.amount) || 0);
      }, 0);
    },
    totalAmountText: function totalAmountText() {
      return this.numberToThaiText(this.totalAmount);
    },
    totalItemsAmount: function totalItemsAmount() {
      // Sum from items (for SENDBACK "คืน" column)
      return this.items.reduce(function (sum, item) {
        return sum + (parseFloat(item.amount) || 0);
      }, 0);
    },
    remainingAfterUse: function remainingAfterUse() {
      if (!this.budgetInfo) return 0;

      // Calculate based on transaction type (works for both View and Edit modes)
      // Use carryForwardBudget as base (งบยกมา) which already handles snapshot for CREATE jobs

      // For ADJUST_TRANSFER: deduct transfer amount from carry forward
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        return this.carryForwardBudget - (this.directAmount || 0);
      }

      // For ADJUST_ADD: add to carry forward budget
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD') {
        return this.carryForwardBudget + this.totalAmount;
      }

      // For ADJUST_REDUCE: deduct from carry forward budget
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return this.carryForwardBudget - this.totalAmount;
      }

      // For refund job type (SENDBACK): add money back (increase remaining)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        return this.carryForwardBudget + this.totalItemsAmount;
      }

      // For other job types (CREATE): deduct from carry forward
      return this.carryForwardBudget - this.totalAmount;
    },
    carryForwardBudget: function carryForwardBudget() {
      if (!this.budgetInfo) return 0;

      // In View/Edit mode: show budget BEFORE this transaction was applied
      if (this.jobId && this.jobData) {
        // Issue 35: ถ้า BudgetPlanId เปลี่ยน (user เปลี่ยน filter) ใช้ข้อมูลจาก budgetInfo ใหม่ (เหมือน Create mode)
        if (this.originalBudgetPlanId && this.budgetInfo.budgetPlanId !== this.originalBudgetPlanId) {
          return this.budgetInfo.remainingAmount;
        }

        // Same plan: use snapshot values
        // Use SnapshotRemainingAmount if available (งบคงเหลือก่อนทำรายการ = งบยกมา)
        if (this.jobData.snapshotRemainingAmount != null) {
          return this.jobData.snapshotRemainingAmount;
        }

        // Fallback to snapshotBudgetAmount for old jobs that don't have snapshotRemainingAmount
        if (this.jobData.snapshotBudgetAmount != null) {
          return this.jobData.snapshotBudgetAmount;
        }

        // สำหรับ TRANSFER ที่ไม่มี snapshot (ใบงานเก่า): คำนวณย้อนหลังจากค่าปัจจุบัน + ยอดโอน
        if (this.jobData.jobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
          return this.budgetInfo.budgetAmount + (this.jobData.totalAmount || 0);
        }

        // Otherwise use current remaining amount
        return this.budgetInfo.remainingAmount;
      }

      // In Create mode: show current available budget
      return this.budgetInfo.remainingAmount;
    },
    // งบยกมาของ Target (ก่อนรับโอน) = งบคงเหลือปัจจุบัน (remainingAmount)
    targetCarryForwardBudget: function targetCarryForwardBudget() {
      if (!this.targetBudgetInfo) return 0;

      // ใช้ SnapshotRemainingAmount ถ้ามี (งบคงเหลือก่อนรับโอน = งบยกมา)
      if (this.targetBudgetInfo.snapshotRemainingAmount != null) {
        return this.targetBudgetInfo.snapshotRemainingAmount;
      }

      // Fallback: ใช้ snapshotBudgetAmount ถ้ามี (สำหรับ jobs เก่า)
      if (this.targetBudgetInfo.snapshotBudgetAmount != null) {
        return this.targetBudgetInfo.snapshotBudgetAmount;
      }

      // สำหรับใบงานเก่าที่ไม่มี snapshot: คำนวณย้อนหลังจากค่าปัจจุบัน - ยอดรับโอน
      // (เพราะ remainingAmount ปัจจุบันรวมยอดรับโอนแล้ว)
      if (this.jobId && this.jobData) {
        return this.targetBudgetInfo.remainingAmount - (this.jobData.totalAmount || 0);
      }

      // Create mode: ใช้ค่า remainingAmount ปัจจุบัน
      return this.targetBudgetInfo.remainingAmount;
    },
    // งบคงเหลือหลังรับโอนของ Target
    targetRemainingAfterTransfer: function targetRemainingAfterTransfer() {
      if (!this.targetBudgetInfo) return 0;

      // งบยกมา (ก่อนรับโอน) + ยอดรับโอน
      return this.targetCarryForwardBudget + (this.directAmount || 0);
    },
    createdByName: function createdByName() {
      // If we have job data (Edit/View mode), use the createdByName from API
      if (this.jobData && this.jobData.createdByName) {
        return this.jobData.createdByName;
      }
      // Otherwise (Create mode), use current user
      if (this.$root && this.$root.user) {
        var fullName = ((this.$root.user.firstName || "") + " " + (this.$root.user.lastName || "")).trim();
        return fullName || this.$root.user.userName || "-";
      }
      return "-";
    },
    canSave: function canSave() {
      var baseRequirement = this.selectedBudgetYear && this.selectedCCTR && this.selectedIO && this.selectedGL && this.selectedOrg && this.selectedJobType && this.budgetInfo && this.jobDate // 25.2: วันที่เอกสาร required
      ;

      // For refund job type, also require source job selection and attachments
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        var hasSourceJob = this.selectedSourceJobId !== null && this.selectedSourceJobId !== undefined && this.selectedSourceJobId !== '';
        var _hasAttachments = Array.isArray(this.attachments) && this.attachments.length > 0;
        return baseRequirement && hasSourceJob && _hasAttachments;
      }

      // For add job type, require amount and attachments (remark is optional)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD') {
        return baseRequirement && this.directAmount && Array.isArray(this.attachments) && this.attachments.length > 0;
      }

      // For reduce job type, require amount and attachments (remark is optional)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return baseRequirement && this.directAmount && Array.isArray(this.attachments) && this.attachments.length > 0;
      }

      // For transfer job type, require target budget, amount, and attachments (remark is optional)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        return baseRequirement && this.targetBudgetInfo && this.directAmount && Array.isArray(this.attachments) && this.attachments.length > 0;
      }

      // For CREATE job type, require attachments and vendor
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE') {
        var hasAttachments = Array.isArray(this.attachments) && this.attachments.length > 0;
        var hasVendor = this.vendorId !== null && this.vendorId !== undefined && this.vendorId !== '';
        // FR-016: ถ้าเลือก "อื่นๆ" ต้องกรอก OtherVendorName
        if (this.vendorId === 'OTHER' && (!this.otherVendorName || !this.otherVendorName.trim())) {
          return false;
        }
        return baseRequirement && hasAttachments && hasVendor;
      }

      return baseRequirement;
    },
    sortedApprovalHistory: function sortedApprovalHistory() {
      // เรียงจาก ApproveDate ล่าสุดขึ้นก่อน (DESC)
      return this.approvalHistory.slice().sort(function (a, b) {
        return new Date(b.approveDate) - new Date(a.approveDate);
      });
    },
    showApproveButtons: function showApproveButtons() {
      // แสดงปุ่มเฉพาะเมื่อ status เป็น PENDING_APPROVAL (1) หรือ APPROVED/รอยืนยัน (2)
      if (!this.jobData || !this.canApprove) return false;
      var status = this.jobData.status;
      // Status 1 = รออนุมัติ (PENDING_APPROVAL), Status 2 = รอยืนยัน (APPROVED)
      return status === 1 || status === 2;
    },
    approveButtonText: function approveButtonText() {
      // ใช้ ApproverType จาก backend กำหนดข้อความปุ่ม
      // CONFIRM = ผู้ยืนยัน → "ยืนยันข้อมูล", APPROVE = ผู้อนุมัติ → "อนุมัติ"
      if (this.currentApproverType === 'CONFIRM') {
        return 'ยืนยันข้อมูล';
      }
      return 'อนุมัติ';
    },
    showReturnButton: function showReturnButton() {
      // ปุ่ม "ส่งกลับแก้ไข": Level 1-2 เท่านั้น (canReturn จาก backend)
      return this.canReturn;
    },
    showRejectButton: function showRejectButton() {
      // ปุ่ม "ไม่อนุมัติ": Level 3+ ไม่สนใจประเภท (canReject จาก backend)
      return this.canReject;
    },
    isApprovalRequired: function isApprovalRequired() {
      // ADJUST types don't require approval (Status = 6 directly)
      // Only CREATE requires approval (Status = 0 → needs approval flow)
      return this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE';
    },
    totalAddJobsAmount: function totalAddJobsAmount() {
      // Calculate total amount from all ADJUST_ADD jobs
      if (!this.addJobsList || this.addJobsList.length === 0) {
        return 0;
      }
      return this.addJobsList.reduce(function (sum, job) {
        return sum + (job.amount || 0);
      }, 0);
    },
    totalRecentSendbackAmount: function totalRecentSendbackAmount() {
      // Calculate total amount from recent SENDBACK jobs (after last CREATE)
      if (!this.budgetInfo || !this.budgetInfo.recentSendbackJobs || this.budgetInfo.recentSendbackJobs.length === 0) {
        return 0;
      }
      return this.budgetInfo.recentSendbackJobs.reduce(function (sum, job) {
        return sum + (job.totalAmount || 0);
      }, 0);
    }
  },
  watch: {
    selectedBudgetYear: function selectedBudgetYear() {
      this.onSelectionChange();
      // Reload approved jobs if JobType is SENDBACK (ไม่ทำใน View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && !this.isViewMode) {
        this.selectedSourceJobId = null; // Reset selected source job
        this.sourceJobData = null; // Reset source job data
        this.loadApprovedJobs();
      }
      // เมื่อเปลี่ยนปีงบประมาณต้นทาง ให้ reset และโหลด target dropdowns ใหม่ (เฉพาะประเภทโยกงบ และไม่ใช่ View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' && !this.isViewMode) {
        this.selectedTargetIO = null;
        this.selectedTargetGL = null;
        this.selectedTargetOrg = null;
        this.targetBudgetInfo = null;
        this.initializeTargetDropdowns();
      }
    },
    selectedCCTR: function selectedCCTR() {
      this.onSelectionChange();
      // Reload approved jobs if JobType is SENDBACK (ไม่ทำใน View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && !this.isViewMode) {
        this.selectedSourceJobId = null; // Reset selected source job
        this.sourceJobData = null; // Reset source job data
        this.loadApprovedJobs();
      }
      // เมื่อเปลี่ยน CCTR ต้นทาง ให้ reset และโหลด target dropdowns ใหม่ (เฉพาะประเภทโยกงบ และไม่ใช่ View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' && !this.isViewMode) {
        this.selectedTargetIO = null;
        this.selectedTargetGL = null;
        this.selectedTargetOrg = null;
        this.targetBudgetInfo = null;
        this.initializeTargetDropdowns();
      }
    },
    selectedIO: function selectedIO() {
      this.onSelectionChange();
      // Reload approved jobs if JobType is SENDBACK (ไม่ทำใน View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && !this.isViewMode) {
        this.selectedSourceJobId = null; // Reset selected source job
        this.sourceJobData = null; // Reset source job data
        this.loadApprovedJobs();
      }
    },
    selectedGL: function selectedGL() {
      this.onSelectionChange();
      // Reload approved jobs if JobType is SENDBACK (ไม่ทำใน View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && !this.isViewMode) {
        this.selectedSourceJobId = null; // Reset selected source job
        this.sourceJobData = null; // Reset source job data
        this.loadApprovedJobs();
      }
    },
    selectedOrg: function selectedOrg() {
      this.onSelectionChange();
      // Reload approved jobs if JobType is SENDBACK (ไม่ทำใน View mode)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && !this.isViewMode) {
        this.selectedSourceJobId = null; // Reset selected source job
        this.sourceJobData = null; // Reset source job data
        this.loadApprovedJobs();
      }
    },
    selectedJobType: function selectedJobType(newVal, oldVal) {
      // ไม่ reset ค่าใน View mode เพราะเป็นการแสดงข้อมูลเท่านั้น
      if (this.isViewMode) {
        return;
      }

      // When job type changes, reset source job and load approved jobs if refund type
      if (newVal === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        this.selectedSourceJobId = null;
        this.sourceJobData = null;
        this.loadApprovedJobs();
      } else {
        // Explicitly destroy sourceJob Select2 BEFORE v-if removes element
        // (ป้องกัน Select2 dropdown container ค้างอยู่ใน DOM)
        if (oldVal === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && this.$refs.sourceJobSelect2) {
          var $sourceEl = this.$refs.sourceJobSelect2.$refs ? $(this.$refs.sourceJobSelect2.$refs.select) : $(this.$refs.sourceJobSelect2);
          if ($sourceEl.length && $sourceEl.hasClass('select2-hidden-accessible')) {
            $sourceEl.select2('destroy');
          }
        }
        this.selectedSourceJobId = null;
        this.sourceJobData = null;
        this.sourceJobOptions.data = [];
      }

      // เมื่อเปลี่ยนเป็นประเภท "โยกงบ" ให้โหลด dropdown options สำหรับ target และ reset ค่า
      if (newVal === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        // Reset target selections
        this.selectedTargetIO = null;
        this.selectedTargetGL = null;
        this.selectedTargetOrg = null;
        this.targetBudgetInfo = null;
        this.directAmount = null;
        // โหลด target dropdown options (ใช้ Year และ CCTR จาก source)
        this.initializeTargetDropdowns();
      } else {
        // Reset target data เมื่อเปลี่ยนไปประเภทอื่น
        this.rawTargetDropdownData = null;
        this.selectedTargetIO = null;
        this.selectedTargetGL = null;
        this.selectedTargetOrg = null;
        this.targetBudgetInfo = null;
      }

      // เมื่อเปลี่ยนเป็นประเภท "CREATE" ให้ initialize vendor dropdown
      var self = this;
      if (newVal === 'BUDGET_JOB_TYPE_CREATE') {
        self.$nextTick(function () {
          self.initVendorSelect2();
        });
      } else {
        // Explicitly destroy vendor Select2 BEFORE v-if removes element
        if (oldVal === 'BUDGET_JOB_TYPE_CREATE' && this.$refs.vendorSelect2) {
          var $vendorEl = $(this.$refs.vendorSelect2);
          if ($vendorEl.length && $vendorEl.hasClass('select2-hidden-accessible')) {
            $vendorEl.off().select2('destroy');
          }
        }
        // Reset vendor เมื่อเปลี่ยนไปประเภทอื่น
        this.vendorId = null;
        this.vendorDisplayName = "";
        this.vendorSelect2Initialized = false;
      }
    },
    selectedSourceJobId: function selectedSourceJobId(newVal) {
      // For SENDBACK job type, load source job data and pre-populate items from source job
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        if (newVal) {
          // Find selected job data from dropdown options
          var selectedJob = this.sourceJobOptions.data.find(function (j) {
            return j.id == newVal;
          });
          if (selectedJob) {
            this.sourceJobData = selectedJob;
          }
          // Load source job items as initial values (Create mode only)
          if (!this.jobId) {
            this.loadJobItems(newVal);
          }
        } else {
          this.sourceJobData = null;
          if (!this.jobId) {
            this.items = [];
          }
        }
        return;
      }

      // When source job selected, load its items (for other job types)
      if (newVal) {
        this.loadJobItems(newVal);
      } else {
        this.items = [];
      }
    }
  },
  methods: (_methods = {
    getBudgetTableHeader: function getBudgetTableHeader() {
      // Header for the "amount used/returned" column
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        return 'คืน';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD') {
        return 'เพิ่มงบ';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        return 'โยกงบออก';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return 'ปรับลดงบประมาณ';
      } else {
        return 'ใช้ไป';
      }
    },
    getBudgetAmountForDisplay: function getBudgetAmountForDisplay() {
      // For ADJUST_TRANSFER, show directAmount
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        return this.directAmount || 0;
      }
      // For ADJUST_REDUCE, show directAmount
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return this.directAmount || 0;
      }
      // For ADJUST_ADD in view/edit mode, show addedAmount from budgetInfo
      // In create mode, show totalAmount (the amount being added)
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD') {
        if (this.jobId) {
          // View/Edit mode: show TotalAmount snapshot ของใบงานนั้นๆ
          return this.directAmount || 0;
        }
        // Create mode: show totalAmount (the amount being added)
        return this.totalAmount || 0;
      }
      // For other types (CREATE, SENDBACK), show total amount
      return this.totalAmount;
    },
    getBudgetAmountClass: function getBudgetAmountClass() {
      // Return CSS class for amount column
      if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
        return 'text-success';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD') {
        return '';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER') {
        return 'text-warning';
      } else if (this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
        return 'text-danger';
      } else {
        return 'text-danger';
      }
    },
    goBack: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ path: "/BudgetPlan/Job" });
    },
    // File attachment methods
    handleFileSelect: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(event) {
        var _this2 = this;

        var self, files, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, _ret;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = this;
                files = event.target.files;

                if (!(!files || files.length === 0)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
                  var allowedTypes, base64Url, formData, response;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          // Validate file type
                          allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'image/jpeg', 'image/jpg', 'image/png'];

                          if (allowedTypes.includes(file.type)) {
                            _context.next = 4;
                            break;
                          }

                          Swal.fire('ไฟล์ไม่ถูกต้อง', 'กรุณาเลือกไฟล์ PDF, Word, Excel หรือรูปภาพเท่านั้น', 'warning');
                          return _context.abrupt("return", "continue");

                        case 4:
                          if (!(file.size > 10 * 1024 * 1024)) {
                            _context.next = 7;
                            break;
                          }

                          Swal.fire('ไฟล์ใหญ่เกินไป', "\u0E44\u0E1F\u0E25\u0E4C " + file.name + " \u0E21\u0E35\u0E02\u0E19\u0E32\u0E14\u0E40\u0E01\u0E34\u0E19 10 MB", 'warning');
                          return _context.abrupt("return", "continue");

                        case 7:
                          _context.next = 9;
                          return new Promise(function (resolve) {
                            var reader = new FileReader();
                            reader.onload = function (e) {
                              return resolve(e.target.result);
                            };
                            reader.readAsDataURL(file);
                          });

                        case 9:
                          base64Url = _context.sent;
                          _context.prev = 10;

                          self.uploadingFile = true;

                          formData = new FormData();

                          formData.append('File', file);
                          formData.append('IsMaster', false);
                          formData.append('FolderName', 'BudgetPlanJobEvidence');

                          _context.next = 18;
                          return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/Api/File/FileUpload', formData, {
                            headers: {
                              'Content-Type': 'multipart/form-data'
                            }
                          });

                        case 18:
                          response = _context.sent;


                          // Add to attachments array with base64 URL for immediate preview
                          self.attachments.push({
                            fileName: file.name,
                            fileSize: file.size,
                            uploadedDate: new Date(),
                            fileInfoId: response.data.fileInfoId,
                            gridFsId: response.data.gridFsId,
                            url: base64Url, // Use base64 for immediate preview
                            bucketName: 'BudgetPlanJobEvidence',
                            isNew: true, // Mark as new file
                            seq: self.attachments.length + 1 // Assign sequence number
                          });

                          Swal.fire({
                            type: 'success',
                            title: 'อัพโหลดสำเร็จ',
                            text: "\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E1F\u0E25\u0E4C " + file.name + " \u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
                            timer: 1500,
                            showConfirmButton: false
                          });

                          _context.next = 27;
                          break;

                        case 23:
                          _context.prev = 23;
                          _context.t0 = _context["catch"](10);

                          console.error('Upload error:', _context.t0);
                          Swal.fire('เกิดข้อผิดพลาด', "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E1F\u0E25\u0E4C " + file.name + " \u0E44\u0E14\u0E49", 'error');

                        case 27:
                          _context.prev = 27;

                          self.uploadingFile = false;
                          return _context.finish(27);

                        case 30:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2, [[10, 23, 27, 30]]);
                });


                // Validate and upload each file
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 8;
                _iterator = files[Symbol.iterator]();

              case 10:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 19;
                  break;
                }

                file = _step.value;
                return _context2.delegateYield(_loop(file), "t0", 13);

              case 13:
                _ret = _context2.t0;

                if (!(_ret === "continue")) {
                  _context2.next = 16;
                  break;
                }

                return _context2.abrupt("continue", 16);

              case 16:
                _iteratorNormalCompletion = true;
                _context2.next = 10;
                break;

              case 19:
                _context2.next = 25;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t1 = _context2["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 25:
                _context2.prev = 25;
                _context2.prev = 26;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 28:
                _context2.prev = 28;

                if (!_didIteratorError) {
                  _context2.next = 31;
                  break;
                }

                throw _iteratorError;

              case 31:
                return _context2.finish(28);

              case 32:
                return _context2.finish(25);

              case 33:

                // Clear file input
                event.target.value = '';

              case 34:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 21, 25, 33], [26,, 28, 32]]);
      }));

      function handleFileSelect(_x) {
        return _ref.apply(this, arguments);
      }

      return handleFileSelect;
    }(),
    removeAttachment: function removeAttachment(index) {
      var self = this;
      Swal.fire({
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบไฟล์นี้หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ยกเลิก'
      }).then(function (result) {
        if (result.value) {
          self.attachments.splice(index, 1);
          // Re-assign seq after removal
          self.attachments.forEach(function (file, i) {
            file.seq = i + 1;
          });
          Swal.fire('ลบสำเร็จ!', 'ลบไฟล์เรียบร้อยแล้ว', 'success');
        }
      });
    },
    downloadFile: function downloadFile(file) {
      var self = this;
      var fileName = file.fileName || 'download';

      // If file has fileInfoId, use API endpoint (for files from server)
      if (file.fileInfoId) {
        // Get file extension to determine content type
        var ext = fileName.split('.').pop().toLowerCase();
        var contentType = 'application/octet-stream';

        // Map common extensions to content types
        var contentTypeMap = {
          'pdf': 'application/pdf',
          'doc': 'application/msword',
          'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'xls': 'application/vnd.ms-excel',
          'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'jpg': 'image/jpeg',
          'jpeg': 'image/jpeg',
          'png': 'image/png'
        };

        contentType = contentTypeMap[ext] || contentType;

        // Use API endpoint to download file
        var downloadUrl = "/Api/File/FileDownloadByte?FileInfoId=" + encodeURIComponent(file.fileInfoId) + "&ContentType=" + encodeURIComponent(contentType) + "&FileName=" + encodeURIComponent(fileName);

        // Create hidden link and trigger download
        var link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      // If file has base64 data URL (newly uploaded file not yet saved)
      else if (file.url && file.url.startsWith('data:')) {
          fetch(file.url).then(function (res) {
            return res.blob();
          }).then(function (blob) {
            var blobUrl = window.URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.style.display = 'none';
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(function () {
              return window.URL.revokeObjectURL(blobUrl);
            }, 100);
          }).catch(function (error) {
            console.error('Download error:', error);
            Swal.fire('เกิดข้อผิดพลาด', 'ไม่สามารถดาวน์โหลดไฟล์ได้', 'error');
          });
        }
        // Fallback for other cases
        else if (file.url) {
            var _link = document.createElement('a');
            _link.href = file.url;
            _link.download = fileName;
            _link.click();
          }
    },
    getFileIcon: function getFileIcon(fileName) {
      if (!fileName) return 'fas fa-file';

      var ext = fileName.split('.').pop().toLowerCase();
      switch (ext) {
        case 'pdf':
          return 'fas fa-file-pdf text-danger';
        case 'doc':
        case 'docx':
          return 'fas fa-file-word text-primary';
        case 'xls':
        case 'xlsx':
          return 'fas fa-file-excel text-success';
        case 'jpg':
        case 'jpeg':
        case 'png':
          return 'fas fa-file-image text-info';
        default:
          return 'fas fa-file';
      }
    },
    isImageFile: function isImageFile(fileName) {
      if (!fileName) return false;
      var ext = fileName.split('.').pop().toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext);
    },
    viewImage: function viewImage(url) {
      if (!url) return;
      window.open(url, '_blank');
    },
    openFileInNewTab: function openFileInNewTab(file) {
      if (file.fileInfoId) {
        // ใช้ download endpoint เสมอ — window.open(data:URI) ถูก Chrome block
        var fileName = file.fileName || 'download';
        var ext = fileName.split('.').pop().toLowerCase();
        var downloadUrl = '/Api/File/FileDownloadByte?FileInfoId=' + encodeURIComponent(file.fileInfoId) + '&ContentType=' + encodeURIComponent(ext) + '&FileName=' + encodeURIComponent(fileName);
        window.open(downloadUrl, '_blank');
      } else if (file.url) {
        window.open(file.url, '_blank');
      }
    },
    onFileDragEnd: function onFileDragEnd() {
      // Re-assign seq after drag
      this.attachments.forEach(function (file, index) {
        file.seq = index + 1;
      });
    },
    formatFileSize: function formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '0 Bytes';

      var k = 1024;
      var sizes = ['Bytes', 'KB', 'MB', 'GB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));

      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },
    formatDateTime: function formatDateTime(date) {
      if (!date) return '-';

      var d = new Date(date);
      var day = String(d.getDate()).padStart(2, '0');
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var year = d.getFullYear();
      var hours = String(d.getHours()).padStart(2, '0');
      var minutes = String(d.getMinutes()).padStart(2, '0');

      return day + "/" + month + "/" + year + " " + hours + ":" + minutes;
    },
    loadJobData: function loadJobData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var self, response, ensureSelect2Option, selectedJob, sourceResponse, sourceJobData, formattedAmount, $cctr, $io, $gl, $org, orgText, $tIO, $tGL, $tOrg, tOrgText;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self = _this3;

                if (self.jobId) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _context3.prev = 3;

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังโหลดข้อมูลใบงาน..."
                });

                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/" + self.jobId, {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 7:
                response = _context3.sent;

                if (!(response.data && response.data.success && response.data.data)) {
                  _context3.next = 104;
                  break;
                }

                // Issue 43.2: inject missing dropdown options ก่อน trigger('change')
                // กรณี user ไม่ได้ map Org ต้นทาง → option ไม่อยู่ใน Select2 DOM → ต้องเพิ่มก่อน
                ensureSelect2Option = function ensureSelect2Option($el, value, displayText) {
                  if (value && !$el.find('option[value="' + value + '"]').length) {
                    $el.append('<option value="' + value + '">' + (displayText || value) + '</option>');
                  }
                };

                // Manually trigger Select2 to update with loaded values


                self.jobData = response.data.data;

                // Issue 35: track original BudgetPlanId to detect plan changes
                self.originalBudgetPlanId = response.data.data.budgetPlanId;

                // Set job status
                self.jobStatus = response.data.data.status || 0;

                // Issue 35: Set year from job data (may differ from current year default)
                if (response.data.data.year) {
                  self.selectedBudgetYear = response.data.data.year.toString();
                }

                // Set form data from loaded job
                self.selectedCCTR = response.data.data.cctrCode;
                self.selectedIO = response.data.data.ioCode;
                self.selectedGL = response.data.data.glCode;
                self.selectedOrg = response.data.data.orgCode;
                // Issue 43.2: เก็บ codes/names จาก API เพื่อ inject เข้า dropdown กรณี user ไม่ได้ map
                self.jobCCTRCode = response.data.data.cctrCode;
                self.jobCCTRName = response.data.data.cctrName || "";
                self.jobIOCode = response.data.data.ioCode;
                self.jobIOName = response.data.data.ioName || "";
                self.jobGLCode = response.data.data.glCode;
                self.jobGLName = response.data.data.glName || "";
                self.jobOrgCode = response.data.data.orgCode;
                self.jobOrgName = response.data.data.orgName || "";
                self.selectedJobType = response.data.data.jobType;
                self.sequenceNo = response.data.data.sequenceNo;
                self.jobDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(response.data.data.jobDate);
                // Update datepicker display if in Edit mode
                if (self.canEdit && self.$refs.jobDatePicker) {
                  $(self.$refs.jobDatePicker).datepicker("update", self.jobDate.format("DD/MM/YYYY"));
                }
                self.remark = response.data.data.remark || "";
                self.items = response.data.data.items || [];
                // Issue 24: attachFiles ย้ายไป loadFileUrls() (lazy load หลัง unblockPage)

                // For CREATE job type, load vendor info
                if (response.data.data.jobType === 'BUDGET_JOB_TYPE_CREATE') {
                  if (response.data.data.vendorId) {
                    self.vendorId = response.data.data.vendorId.toString();
                    self.vendorDisplayName = response.data.data.vendorName || '';
                  } else {
                    // VendorId is null = "อื่นๆ"
                    self.vendorId = 'OTHER';
                    self.vendorDisplayName = 'อื่นๆ';
                    self.otherVendorName = response.data.data.otherVendorName || ''; // FR-016
                  }
                }

                // For ADJUST_ADD, ADJUST_TRANSFER, and ADJUST_REDUCE, load totalAmount as directAmount
                if (response.data.data.jobType === 'BUDGET_JOB_TYPE_ADJUST_ADD' || response.data.data.jobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' || response.data.data.jobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE') {
                  self.directAmount = response.data.data.totalAmount;
                }

                // For ADJUST_TRANSFER, load target budget info

                if (!(response.data.data.jobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' && response.data.data.targetBudgetPlanId)) {
                  _context3.next = 49;
                  break;
                }

                self.targetBudgetInfo = {
                  found: true,
                  budgetPlanId: response.data.data.targetBudgetPlanId,
                  year: response.data.data.targetYear,
                  cctrCode: response.data.data.targetCCTRCode,
                  cctrName: response.data.data.targetCCTRName,
                  ioCode: response.data.data.targetIOCode,
                  ioName: response.data.data.targetIOName,
                  glCode: response.data.data.targetGLCode,
                  glName: response.data.data.targetGLName,
                  orgCode: response.data.data.targetOrgCode,
                  initialBudgetAmount: response.data.data.targetInitialBudgetAmount || 0,
                  addedAmount: response.data.data.targetAddedAmount || 0,
                  budgetAmount: response.data.data.targetBudgetAmount || 0,
                  usedAmount: response.data.data.targetUsedAmount || 0,
                  remainingAmount: response.data.data.targetRemainingAmount || 0,
                  // Snapshot: ข้อมูลก่อนรับโอน
                  snapshotBudgetAmount: response.data.data.targetSnapshotBudgetAmount,
                  snapshotRemainingAmount: response.data.data.targetSnapshotRemainingAmount
                };

                // Also set selected values for target budget dropdowns (for Edit mode)
                self.selectedTargetYear = response.data.data.targetYear ? response.data.data.targetYear.toString() : null;
                self.selectedTargetCCTR = response.data.data.targetCCTRCode;
                self.selectedTargetIO = response.data.data.targetIOCode;
                self.selectedTargetGL = response.data.data.targetGLCode;
                self.selectedTargetOrg = response.data.data.targetOrgCode;
                // Issue 43.3: เก็บ target names สำหรับ inject เข้า dropdown
                self.jobTargetIOCode = response.data.data.targetIOCode;
                self.jobTargetIOName = response.data.data.targetIOName || "";
                self.jobTargetGLCode = response.data.data.targetGLCode;
                self.jobTargetGLName = response.data.data.targetGLName || "";
                self.jobTargetOrgCode = response.data.data.targetOrgCode;
                self.jobTargetOrgName = response.data.data.targetOrgName || "";

                // โหลด target dropdown data สำหรับ Edit mode (bi-directional filtering)
                _context3.next = 49;
                return self.initializeTargetDropdowns();

              case 49:
                if (!(response.data.data.jobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && response.data.data.sourceJobId)) {
                  _context3.next = 68;
                  break;
                }

                self.selectedSourceJobId = response.data.data.sourceJobId;
                self.loadedRefundAmount = parseFloat(response.data.data.totalAmount || 0);
                self.loadedRefundSourceId = response.data.data.sourceJobId;

                // Load approved jobs to populate dropdown
                _context3.next = 55;
                return self.loadApprovedJobs();

              case 55:

                // Find source job data from dropdown options
                selectedJob = self.sourceJobOptions.data.find(function (j) {
                  return j.id == response.data.data.sourceJobId;
                });

                // If not found in dropdown (might be deleted/cancelled), load from job data directly

                if (selectedJob) {
                  _context3.next = 67;
                  break;
                }

                _context3.prev = 57;
                _context3.next = 60;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/" + response.data.data.sourceJobId, {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 60:
                sourceResponse = _context3.sent;


                if (sourceResponse.data && sourceResponse.data.success && sourceResponse.data.data) {
                  sourceJobData = sourceResponse.data.data;
                  formattedAmount = parseFloat(sourceJobData.totalAmount || 0).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  });


                  selectedJob = {
                    id: sourceJobData.id,
                    text: "\u0E04\u0E23\u0E31\u0E49\u0E07\u0E17\u0E35\u0E48 " + sourceJobData.sequenceNo + " : " + sourceJobData.jobNumber + " \u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19 " + formattedAmount,
                    jobNumber: sourceJobData.jobNumber,
                    totalAmount: sourceJobData.totalAmount
                  };

                  // Add to dropdown options so it can be displayed
                  self.sourceJobOptions.data.push(selectedJob);
                }
                _context3.next = 67;
                break;

              case 64:
                _context3.prev = 64;
                _context3.t0 = _context3["catch"](57);

                console.error('Error loading source job:', _context3.t0);

              case 67:

                if (selectedJob) {
                  self.sourceJobData = selectedJob;
                }

              case 68:

                // Load approval history and check permission
                self.approvalHistory = response.data.data.approvalHistory || [];
                self.canApprove = response.data.data.canApprove || false;
                self.currentApprovalLevel = response.data.data.currentApprovalLevel || 0;
                self.maxApproveOnlyLevel = response.data.data.maxApproveOnlyLevel || 0;
                self.currentApproverType = response.data.data.currentApproverType || null;
                self.canReturn = response.data.data.canReturn || false;
                self.canReject = response.data.data.canReject || false;

                // Update budget info display
                self.budgetYear = response.data.data.year;
                self.budgetAmount = response.data.data.budgetAmount;
                self.usedAmount = response.data.data.usedAmount;
                self.remainingAmount = response.data.data.remainingAmount;

                // Wait for next tick to ensure Select2 components are rendered
                _context3.next = 81;
                return self.$nextTick();

              case 81:
                if (self.$refs.cctrSelect2) {
                  $cctr = $(self.$refs.cctrSelect2.$el);

                  ensureSelect2Option($cctr, self.selectedCCTR, self.jobCCTRName ? "[" + self.jobCCTRCode + "] " + self.jobCCTRName : self.jobCCTRCode);
                  $cctr.val(self.selectedCCTR).trigger('change');
                }
                if (self.$refs.ioSelect2) {
                  $io = $(self.$refs.ioSelect2.$el);

                  ensureSelect2Option($io, self.selectedIO, self.jobIOName ? "[" + self.jobIOCode + "] " + self.jobIOName : self.jobIOCode);
                  $io.val(self.selectedIO).trigger('change');
                }
                if (self.$refs.glSelect2) {
                  $gl = $(self.$refs.glSelect2.$el);

                  ensureSelect2Option($gl, self.selectedGL, self.jobGLName ? "[" + self.jobGLCode + "] " + self.jobGLName : self.jobGLCode);
                  $gl.val(self.selectedGL).trigger('change');
                }
                if (self.$refs.orgSelect2) {
                  $org = $(self.$refs.orgSelect2.$el);
                  orgText = self.jobOrgName ? "[" + self.jobOrgCode + "] " + self.jobOrgName : self.jobOrgCode;

                  ensureSelect2Option($org, self.selectedOrg, orgText);
                  $org.val(self.selectedOrg).trigger('change');
                }
                if (self.$refs.jobTypeSelect2) {
                  $(self.$refs.jobTypeSelect2.$el).val(self.selectedJobType).trigger('change');
                }

                // For TRANSFER job type, set target budget dropdown values

                if (!(self.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' && self.targetBudgetInfo)) {
                  _context3.next = 94;
                  break;
                }

                _context3.next = 89;
                return self.$nextTick();

              case 89:
                _context3.next = 91;
                return self.$nextTick();

              case 91:

                // Issue 43.3: inject missing target dropdown options ก่อน trigger('change')
                if (self.$refs.targetIOSelect2 && self.$refs.targetIOSelect2.$refs.select) {
                  $tIO = $(self.$refs.targetIOSelect2.$refs.select);

                  ensureSelect2Option($tIO, self.selectedTargetIO, self.jobTargetIOName ? "[" + self.jobTargetIOCode + "] " + self.jobTargetIOName : self.jobTargetIOCode);
                  $tIO.val(self.selectedTargetIO).trigger('change');
                }
                if (self.$refs.targetGLSelect2 && self.$refs.targetGLSelect2.$refs.select) {
                  $tGL = $(self.$refs.targetGLSelect2.$refs.select);

                  ensureSelect2Option($tGL, self.selectedTargetGL, self.jobTargetGLName ? "[" + self.jobTargetGLCode + "] " + self.jobTargetGLName : self.jobTargetGLCode);
                  $tGL.val(self.selectedTargetGL).trigger('change');
                }
                if (self.$refs.targetOrgSelect2 && self.$refs.targetOrgSelect2.$refs.select) {
                  $tOrg = $(self.$refs.targetOrgSelect2.$refs.select);
                  tOrgText = self.jobTargetOrgName ? "[" + self.jobTargetOrgCode + "] " + self.jobTargetOrgName : self.jobTargetOrgCode;

                  ensureSelect2Option($tOrg, self.selectedTargetOrg, tOrgText);
                  $tOrg.val(self.selectedTargetOrg).trigger('change');
                }

              case 94:
                if (!(self.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK' && self.selectedSourceJobId && self.sourceJobData)) {
                  _context3.next = 98;
                  break;
                }

                _context3.next = 97;
                return self.$nextTick();

              case 97:

                if (self.$refs.sourceJobSelect2) {
                  // Use the Select2 component's setSelectedData method
                  self.$refs.sourceJobSelect2.setSelectedData(self.sourceJobData);
                }

              case 98:
                if (!(!self.isViewMode && self.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' && self.vendorId)) {
                  _context3.next = 102;
                  break;
                }

                _context3.next = 101;
                return self.$nextTick();

              case 101:
                self.initVendorSelect2(self.vendorId, self.vendorDisplayName);

              case 102:
                _context3.next = 104;
                return self.onSelectionChange();

              case 104:
                _context3.next = 110;
                break;

              case 106:
                _context3.prev = 106;
                _context3.t1 = _context3["catch"](3);

                console.error("Error loading job data:", _context3.t1);
                Swal.fire("ผิดพลาด", "ไม่สามารถโหลดข้อมูลใบงานได้", "error").then(function () {
                  self.goBack();
                });

              case 110:
                _context3.prev = 110;

                KTApp.unblockPage();
                return _context3.finish(110);

              case 113:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[3, 106, 110, 113], [57, 64]]);
      }))();
    },

    // Issue 24: โหลด file metadata + signed URL แยกจากข้อมูลหลัก — ไม่ block UI
    loadFileUrls: function loadFileUrls() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var self, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this4;

                if (self.jobId) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:

                self.isLoadingFiles = true;
                _context4.prev = 4;
                _context4.next = 7;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/" + self.jobId + "/FileUrls", {
                  headers: { Authorization: "Bearer " + self.$root.user.access_token }
                });

              case 7:
                response = _context4.sent;


                if (response.data && response.data.success && response.data.data) {
                  // set attachments ทั้ง array (metadata + signed URL ครบ)
                  self.attachments = response.data.data;
                }
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](4);

                console.error("Error loading file URLs:", _context4.t0);

              case 14:
                _context4.prev = 14;

                self.isLoadingFiles = false;
                return _context4.finish(14);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[4, 11, 14, 17]]);
      }))();
    },

    formatNumber: function formatNumber(value) {
      if (value === null || value === undefined) return "0.00";
      return parseFloat(value).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    initJobDatePicker: function initJobDatePicker() {
      var self = this;
      // Only init for Create/Edit mode (View mode shows text only)
      if (self.isViewMode) return;
      self.$nextTick(function () {
        if (!self.$refs.jobDatePicker) return;
        var arrows;
        if (KTUtil.isRTL()) {
          arrows = {
            leftArrow: '<i class="la la-angle-right"></i>',
            rightArrow: '<i class="la la-angle-left"></i>'
          };
        } else {
          arrows = {
            leftArrow: '<i class="la la-angle-left"></i>',
            rightArrow: '<i class="la la-angle-right"></i>'
          };
        }
        $(self.$refs.jobDatePicker).datepicker({
          autoclose: true,
          clearBtn: false,
          format: "dd/mm/yyyy",
          rtl: KTUtil.isRTL(),
          orientation: "bottom right", // Issue 42.1: ชิดขวา ป้องกัน popup ล้นขอบหน้าจอ
          todayBtn: "linked",
          todayHighlight: true,
          templates: arrows,
          container: "body" // Issue 42.1: ป้องกัน calendar popup ถูกบังโดย parent card/col
        });
        // Set initial value
        $(self.$refs.jobDatePicker).datepicker("update", self.jobDate ? self.jobDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
          self.jobDate = e.dates.length !== 0 ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(e.date) : null;
        });
      });
    },
    formatDateThai: function formatDateThai(date) {
      if (!date) return "-";
      if (__WEBPACK_IMPORTED_MODULE_4_moment___default.a.isMoment(date)) return date.format("DD/MM/YYYY");
      var d = new Date(date);
      var day = String(d.getDate()).padStart(2, '0');
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var year = d.getFullYear();
      return day + "/" + month + "/" + year;
    },
    formatDate: function formatDate(date) {
      if (!date) return "-";
      var d = new Date(date);
      var day = String(d.getDate()).padStart(2, "0");
      var month = String(d.getMonth() + 1).padStart(2, "0");
      var year = d.getFullYear();
      var hours = String(d.getHours()).padStart(2, "0");
      var minutes = String(d.getMinutes()).padStart(2, "0");
      return day + "/" + month + "/" + year + " " + hours + ":" + minutes;
    },
    formatDateFromISO: function formatDateFromISO(isoDate) {
      if (!isoDate) return "-";
      var d = new Date(isoDate);
      var day = String(d.getDate()).padStart(2, "0");
      var month = String(d.getMonth() + 1).padStart(2, "0");
      var year = d.getFullYear();
      return day + "/" + month + "/" + year;
    },
    toggleAddJobsTable: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var self;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                self = this;

                if (self.showAddJobsTable) {
                  _context5.next = 5;
                  break;
                }

                if (!(self.addJobsList.length === 0)) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 5;
                return self.loadAddJobs();

              case 5:
                self.showAddJobsTable = !self.showAddJobsTable;

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function toggleAddJobsTable() {
        return _ref2.apply(this, arguments);
      }

      return toggleAddJobsTable;
    }(),
    loadAddJobs: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var self, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                self = this;

                if (!(!self.budgetInfo || !self.budgetInfo.budgetPlanId)) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                _context6.prev = 3;

                self.loadingAddJobs = true;
                _context6.next = 7;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/AddJobs/" + self.budgetInfo.budgetPlanId, {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 7:
                response = _context6.sent;


                if (response.data && response.data.success && response.data.data) {
                  self.addJobsList = response.data.data;
                } else {
                  self.addJobsList = [];
                }
                _context6.next = 16;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](3);

                console.error("Error loading ADJUST_ADD jobs:", _context6.t0);
                Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดรายการใบเพิ่มเงินได้", "error");
                self.addJobsList = [];

              case 16:
                _context6.prev = 16;

                self.loadingAddJobs = false;
                return _context6.finish(16);

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[3, 11, 16, 19]]);
      }));

      function loadAddJobs() {
        return _ref3.apply(this, arguments);
      }

      return loadAddJobs;
    }(),
    viewJobDetail: function viewJobDetail(jobId) {
      if (!jobId) return;
      // Open in new tab
      var url = "/BudgetPlan/Job/View/" + jobId;
      window.open(url, "_blank");
    },
    numberToThaiText: function numberToThaiText(num) {
      if (!num || num === 0) return "ศูนย์บาทถ้วน";

      var digits = ["", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า"];
      var positions = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

      var parts = num.toFixed(2).split(".");
      var intPart = parseInt(parts[0]);
      var decPart = parts[1];
      var result = "";

      // Convert integer part
      if (intPart === 0) {
        result = "ศูนย์";
      } else {
        var intStr = intPart.toString();
        var len = intStr.length;

        for (var i = 0; i < len; i++) {
          var digit = parseInt(intStr[i]);
          var pos = len - i - 1;
          var posInGroup = pos % 6;

          if (digit !== 0) {
            if (posInGroup === 1 && digit === 2) {
              result += "ยี่";
            } else if (posInGroup === 1 && digit === 1) {
              result += "";
            } else if (posInGroup === 0 && digit === 1 && len > 1 && intStr[i - 1] !== "0") {
              result += "เอ็ด";
            } else {
              result += digits[digit];
            }
            result += positions[posInGroup];
          }

          if (pos === 6 && i < len - 1) {
            result += "ล้าน";
          }
        }
      }
      result += "บาท";

      // Convert decimal part
      var dec = parseInt(decPart);
      if (dec === 0) {
        result += "ถ้วน";
      } else {
        var decStr = dec.toString().padStart(2, "0");
        if (decStr[0] !== "0") {
          if (decStr[0] === "2") {
            result += "ยี่สิบ";
          } else if (decStr[0] === "1") {
            result += "สิบ";
          } else {
            result += digits[parseInt(decStr[0])] + "สิบ";
          }
        }
        if (decStr[1] !== "0") {
          if (decStr[1] === "1" && decStr[0] !== "0") {
            result += "เอ็ด";
          } else {
            result += digits[parseInt(decStr[1])];
          }
        }
        result += "สตางค์";
      }

      return result;
    },
    loadDropdownData: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var self, headers, dropdownParams, dropdownPromise, jobTypesPromise, responses, dropdownResponse, jobTypesResponse, allowedJobTypes;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                self = this;
                _context7.prev = 1;

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังโหลดข้อมูล..."
                });

                headers = {
                  Authorization: "Bearer " + this.$root.user.access_token
                };

                // Load dropdowns and job types in parallel
                // Pass year filter on initial load to avoid duplicate CCTRs

                dropdownParams = {};

                if (self.selectedBudgetYear) {
                  dropdownParams.year = self.selectedBudgetYear;
                }
                dropdownPromise = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/Dropdown", { headers: headers, params: dropdownParams });
                jobTypesPromise = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/Types", { headers: headers });
                _context7.next = 10;
                return Promise.all([dropdownPromise, jobTypesPromise]);

              case 10:
                responses = _context7.sent;
                dropdownResponse = responses[0];
                jobTypesResponse = responses[1];

                // Process dropdown data (API returns { success, data })

                if (dropdownResponse.data && dropdownResponse.data.data) {
                  self.rawDropdownData = dropdownResponse.data.data;

                  // Populate CCTR dropdown
                  self.cctrOptions = {
                    placeholder: "เลือก CCTR",
                    allowClear: true,
                    data: (self.rawDropdownData.costCenters || []).map(function (item) {
                      return { id: item.value, text: item.text };
                    })
                  };

                  // Populate IO dropdown
                  self.ioOptions = {
                    placeholder: "เลือก IO",
                    allowClear: true,
                    data: (self.rawDropdownData.ioCodes || []).map(function (item) {
                      return { id: item.value, text: item.text };
                    })
                  };

                  // Populate GL dropdown
                  self.glOptions = {
                    placeholder: "เลือก GL",
                    allowClear: true,
                    data: (self.rawDropdownData.glCodes || []).map(function (item) {
                      return { id: item.value, text: item.text };
                    })
                  };

                  // Populate Org dropdown
                  self.orgOptions = {
                    placeholder: "เลือก แผนก",
                    allowClear: true,
                    data: (self.rawDropdownData.orgCodes || []).map(function (item) {
                      return { id: item.value, text: item.text };
                    })
                  };
                }

                // Process job types data
                if (jobTypesResponse.data && Array.isArray(jobTypesResponse.data)) {
                  // กรอง jobType ตามสิทธิ์: BUDGET_PLAN_USER เห็นเฉพาะ CREATE และ ADJUST_SENDBACK
                  // เฉพาะใน Create mode เท่านั้น (Edit/View mode แสดงทุกประเภท)
                  allowedJobTypes = jobTypesResponse.data;

                  if (self.isBudgetUser && !self.isEditMode && !self.isViewMode) {
                    allowedJobTypes = jobTypesResponse.data.filter(function (item) {
                      return item.value === 'BUDGET_JOB_TYPE_CREATE' || item.value === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK';
                    });
                  }

                  self.jobTypeOptions = {
                    placeholder: "เลือกประเภทใบงาน",
                    allowClear: false,
                    data: allowedJobTypes.map(function (item) {
                      return { id: item.value, text: item.text };
                    })
                  };

                  console.log("Job types loaded:", self.jobTypeOptions.data);

                  // Set default job type to first item if available and in create mode
                  if (!self.isEditMode && !self.isViewMode && allowedJobTypes.length > 0) {
                    self.selectedJobType = allowedJobTypes[0].value;
                  }
                } else {
                  console.error("Invalid job types response:", jobTypesResponse.data);
                }

                // Set flag to render dropdowns - this will cause select2 components to mount with data
                self.dropdownsLoaded = true;
                _context7.next = 22;
                break;

              case 18:
                _context7.prev = 18;
                _context7.t0 = _context7["catch"](1);

                console.error("Error loading dropdown data:", _context7.t0);
                Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดข้อมูลได้", "error");

              case 22:
                _context7.prev = 22;

                KTApp.unblockPage();
                return _context7.finish(22);

              case 25:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 18, 22, 25]]);
      }));

      function loadDropdownData() {
        return _ref4.apply(this, arguments);
      }

      return loadDropdownData;
    }(),
    onSelectionChange: function onSelectionChange() {
      // Prevent infinite loop when reloading dropdowns
      if (this.isReloadingDropdowns) {
        return;
      }

      // Reload dropdowns based on current selections (bi-directional filtering)
      // loadBudgetInfo จะถูกเรียกหลัง dropdown validation เสร็จ (ภายใน reloadDropdownsBasedOnSelection)
      this.reloadDropdownsBasedOnSelection();
    },
    reloadDropdownsBasedOnSelection: function reloadDropdownsBasedOnSelection() {
      var self = this;

      // Clear existing timer
      if (self.dropdownReloadTimer) {
        clearTimeout(self.dropdownReloadTimer);
      }

      // Debounce: wait 300ms before calling API
      self.dropdownReloadTimer = setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var headers, params, response, newCctrData, newIoData, newGlData, newOrgData;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                // Set flag to prevent infinite loop
                self.isReloadingDropdowns = true;

                headers = {
                  Authorization: "Bearer " + self.$root.user.access_token
                };

                // Build query params based on current selections

                params = {};

                if (self.selectedBudgetYear) {
                  params.year = self.selectedBudgetYear;
                }
                if (self.selectedCCTR) {
                  params.cctrCode = self.selectedCCTR;
                }
                if (self.selectedIO) {
                  params.ioCode = self.selectedIO;
                }
                if (self.selectedGL) {
                  params.glCode = self.selectedGL;
                }
                if (self.selectedOrg) {
                  params.orgCode = self.selectedOrg;
                }

                // Call API with filter parameters
                _context8.next = 11;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/Dropdown", {
                  headers: headers,
                  params: params
                });

              case 11:
                response = _context8.sent;


                if (response.data && response.data.data) {
                  self.rawDropdownData = response.data.data;

                  console.log('[Dropdown] API Response:', {
                    cctr: response.data.data.costCenters ? response.data.data.costCenters.length : 0,
                    io: response.data.data.ioCodes ? response.data.data.ioCodes.length : 0,
                    gl: response.data.data.glCodes ? response.data.data.glCodes.length : 0,
                    org: response.data.data.orgCodes ? response.data.data.orgCodes.length : 0
                  });

                  // Create NEW data arrays
                  newCctrData = (response.data.data.costCenters || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });
                  newIoData = (response.data.data.ioCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });
                  newGlData = (response.data.data.glCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });
                  newOrgData = (response.data.data.orgCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });


                  console.log('[Dropdown] Mapped data:', {
                    cctr: newCctrData.length,
                    io: newIoData.length,
                    gl: newGlData.length,
                    org: newOrgData.length
                  });

                  // Reload ALL dropdowns in next tick
                  // ถ้า dropdown มี selection อยู่ → validate ว่า value ยังมีใน options ใหม่หรือไม่
                  // ถ้าไม่มี → clear selection (ป้องกัน combination ที่ไม่มีอยู่จริง)
                  self.$nextTick(function () {

                    // Helper: rebuild select2 dropdown และ validate selection
                    function rebuildDropdown($el, newData, currentSelection, options, label) {
                      $el.select2('destroy');
                      $el.empty();
                      $el.append('<option value=""></option>');
                      newData.forEach(function (item) {
                        $el.append('<option value="' + item.id + '">' + item.text + '</option>');
                      });
                      // Issue 44: ไม่ส่ง data ใน select2 options เพราะเพิ่ม <option> ใน DOM แล้ว (ป้องกัน item ซ้ำ)
                      var s2Options = { placeholder: options.placeholder, allowClear: options.allowClear };
                      $el.select2(s2Options);

                      if (currentSelection) {
                        var stillExists = newData.some(function (item) {
                          return item.id === currentSelection;
                        });
                        if (stillExists) {
                          $el.val(currentSelection).trigger('change.select2');
                          console.log('[' + label + '] Reloaded - selection preserved:', currentSelection);
                          return currentSelection;
                        } else {
                          $el.val(null).trigger('change.select2');
                          console.log('[' + label + '] Reloaded - selection cleared (value not in filtered options)');
                          return null;
                        }
                      }
                      console.log('[' + label + '] Reloaded with', newData.length, 'items (no selection)');
                      return null;
                    }

                    // Issue 43.2 → 44: inject ค่าของใบงานเข้า dropdown กรณี user ไม่ได้ map Org นั้น
                    // View mode: inject เสมอ (user ไม่สามารถเปลี่ยน filter ได้)
                    // Edit mode: ไม่ inject เพราะ user กำลังเปลี่ยน filter → ต้องให้ cascade filter ทำงานปกติ
                    if (self.jobId && self.isViewMode) {
                      if (self.jobCCTRCode && !newCctrData.some(function (item) {
                        return item.id === self.jobCCTRCode;
                      })) {
                        var cctrText = self.jobCCTRName ? "[" + self.jobCCTRCode + "] " + self.jobCCTRName : self.jobCCTRCode;
                        newCctrData.push({ id: self.jobCCTRCode, text: cctrText });
                      }
                      if (self.jobIOCode && !newIoData.some(function (item) {
                        return item.id === self.jobIOCode;
                      })) {
                        var ioText = self.jobIOName ? "[" + self.jobIOCode + "] " + self.jobIOName : self.jobIOCode;
                        newIoData.push({ id: self.jobIOCode, text: ioText });
                      }
                      if (self.jobGLCode && !newGlData.some(function (item) {
                        return item.id === self.jobGLCode;
                      })) {
                        var glText = self.jobGLName ? "[" + self.jobGLCode + "] " + self.jobGLName : self.jobGLCode;
                        newGlData.push({ id: self.jobGLCode, text: glText });
                      }
                    }

                    // Rebuild CCTR
                    if (self.$refs.cctrSelect2 && self.$refs.cctrSelect2.$refs.select) {
                      self.cctrOptions = { placeholder: "เลือก CCTR", allowClear: true, data: newCctrData };
                      var validatedCCTR = rebuildDropdown($(self.$refs.cctrSelect2.$refs.select), newCctrData, self.selectedCCTR, self.cctrOptions, 'CCTR');
                      if (validatedCCTR !== self.selectedCCTR) self.selectedCCTR = validatedCCTR;
                    }

                    // Rebuild IO
                    if (self.$refs.ioSelect2 && self.$refs.ioSelect2.$refs.select) {
                      self.ioOptions = { placeholder: "เลือก IO", allowClear: true, data: newIoData };
                      var validatedIO = rebuildDropdown($(self.$refs.ioSelect2.$refs.select), newIoData, self.selectedIO, self.ioOptions, 'IO');
                      if (validatedIO !== self.selectedIO) self.selectedIO = validatedIO;
                    }

                    // Rebuild GL
                    if (self.$refs.glSelect2 && self.$refs.glSelect2.$refs.select) {
                      self.glOptions = { placeholder: "เลือก GL", allowClear: true, data: newGlData };
                      var validatedGL = rebuildDropdown($(self.$refs.glSelect2.$refs.select), newGlData, self.selectedGL, self.glOptions, 'GL');
                      if (validatedGL !== self.selectedGL) self.selectedGL = validatedGL;
                    }

                    // Rebuild Org
                    if (self.$refs.orgSelect2 && self.$refs.orgSelect2.$refs.select) {
                      // Issue 43.2 → 44: View mode เท่านั้น — inject org ที่ไม่ได้ map
                      if (self.jobId && self.isViewMode && self.jobOrgCode) {
                        var hasJobOrg = newOrgData.some(function (item) {
                          return item.id === self.jobOrgCode;
                        });
                        if (!hasJobOrg) {
                          var orgDisplayText = self.jobOrgName ? "[" + self.jobOrgCode + "] " + self.jobOrgName : self.jobOrgCode;
                          newOrgData.push({ id: self.jobOrgCode, text: orgDisplayText });
                        }
                      }
                      self.orgOptions = { placeholder: "เลือกแผนก", allowClear: true, data: newOrgData };
                      var validatedOrg = rebuildDropdown($(self.$refs.orgSelect2.$refs.select), newOrgData, self.selectedOrg, self.orgOptions, 'Org');
                      if (validatedOrg !== self.selectedOrg) self.selectedOrg = validatedOrg;
                    }

                    // หลัง validation เสร็จ: load budget info ถ้าครบ 4 fields
                    if (self.selectedCCTR && self.selectedIO && self.selectedGL && self.selectedOrg) {
                      self.loadBudgetInfo();
                    } else {
                      self.budgetInfo = null;
                      if (!self.jobId) {
                        self.sequenceNo = 1;
                      }
                    }
                  });
                }
                _context8.next = 18;
                break;

              case 15:
                _context8.prev = 15;
                _context8.t0 = _context8["catch"](0);

                console.error("Error reloading dropdowns:", _context8.t0);

              case 18:
                _context8.prev = 18;

                // Reset flag after completion
                setTimeout(function () {
                  self.isReloadingDropdowns = false;
                }, 100);
                return _context8.finish(18);

              case 21:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 15, 18, 21]]);
      })), 300); // 300ms debounce
    },
    clearAllFilters: function clearAllFilters() {
      var self = this;

      // Set flag to prevent infinite loop during clearing
      self.isReloadingDropdowns = true;

      // Clear all selections
      self.selectedBudgetYear = new Date().getFullYear().toString();
      self.selectedCCTR = null;
      self.selectedIO = null;
      self.selectedGL = null;
      self.selectedOrg = null;

      // Clear select2 UI
      if (self.$refs.cctrSelect2 && self.$refs.cctrSelect2.$refs.select) {
        $(self.$refs.cctrSelect2.$refs.select).val(null).trigger('change.select2');
      }
      if (self.$refs.ioSelect2 && self.$refs.ioSelect2.$refs.select) {
        $(self.$refs.ioSelect2.$refs.select).val(null).trigger('change.select2');
      }
      if (self.$refs.glSelect2 && self.$refs.glSelect2.$refs.select) {
        $(self.$refs.glSelect2.$refs.select).val(null).trigger('change.select2');
      }
      if (self.$refs.orgSelect2 && self.$refs.orgSelect2.$refs.select) {
        $(self.$refs.orgSelect2.$refs.select).val(null).trigger('change.select2');
      }

      // Clear source job dropdown (สำหรับใบงานคืนเงิน)
      self.selectedSourceJobId = null;
      self.sourceJobData = null;
      self.sourceJobOptions.data = [];
      if (self.$refs.sourceJobSelect2 && self.$refs.sourceJobSelect2.$refs.select) {
        var $sourceJob = $(self.$refs.sourceJobSelect2.$refs.select);
        $sourceJob.select2('destroy');
        $sourceJob.empty();
        $sourceJob.append('<option value=""></option>');
        $sourceJob.select2(self.sourceJobOptions);
      }

      // Clear vendor (สำหรับใบงาน CREATE)
      self.vendorId = null;
      self.vendorDisplayName = "";
      if (self.$refs.vendorSelect2) {
        var $vendor = $(self.$refs.vendorSelect2);
        if ($vendor.hasClass('select2-hidden-accessible')) {
          $vendor.val(null).trigger('change');
        }
      }

      // Clear budget info
      self.budgetInfo = null;

      // Reset flag and reload all dropdowns with no filters
      setTimeout(function () {
        self.isReloadingDropdowns = false;
        self.reloadDropdownsBasedOnSelection();
      }, 100);

      console.log('[Clear] All filters cleared');
    },
    clearTargetFilters: function clearTargetFilters() {
      var self = this;

      // Clear target selections
      self.selectedTargetIO = null;
      self.selectedTargetGL = null;
      self.selectedTargetOrg = null;
      self.targetBudgetInfo = null;

      // Clear select2 UI
      if (self.$refs.targetIOSelect2 && self.$refs.targetIOSelect2.$refs.select) {
        $(self.$refs.targetIOSelect2.$refs.select).val(null).trigger('change.select2');
      }
      if (self.$refs.targetGLSelect2 && self.$refs.targetGLSelect2.$refs.select) {
        $(self.$refs.targetGLSelect2.$refs.select).val(null).trigger('change.select2');
      }
      if (self.$refs.targetOrgSelect2 && self.$refs.targetOrgSelect2.$refs.select) {
        $(self.$refs.targetOrgSelect2.$refs.select).val(null).trigger('change.select2');
      }

      // Reload target dropdowns to show all options
      self.initializeTargetDropdowns();

      console.log('[Clear] Target filters cleared');
    },
    loadBudgetInfo: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var params, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                params = {
                  year: this.selectedBudgetYear,
                  cctrCode: this.selectedCCTR,
                  ioCode: this.selectedIO,
                  glCode: this.selectedGL,
                  orgCode: this.selectedOrg
                };

                if (this.jobId) {
                  params.jobId = this.jobId;
                }
                _context9.next = 5;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/BudgetInfo", {
                  headers: {
                    Authorization: "Bearer " + this.$root.user.access_token
                  },
                  params: params
                });

              case 5:
                response = _context9.sent;

                if (response.data && response.data.success && response.data.data) {
                  this.budgetInfo = response.data.data;
                  // Only update sequenceNo in Create mode (not in Edit/View mode)
                  if (!this.jobId) {
                    this.sequenceNo = response.data.data.nextSequenceNo || 1;
                  }
                } else {
                  this.budgetInfo = null;
                  // Only update sequenceNo in Create mode
                  if (!this.jobId) {
                    this.sequenceNo = 1;
                  }
                  Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลงบประมาณตามเงื่อนไขที่เลือก", "warning");
                }
                _context9.next = 15;
                break;

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9["catch"](0);

                this.budgetInfo = null;
                // Only update sequenceNo in Create mode
                if (!this.jobId) {
                  this.sequenceNo = 1;
                }
                console.error("Error loading budget info:", _context9.t0);
                Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดข้อมูลงบประมาณได้", "error");

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 9]]);
      }));

      function loadBudgetInfo() {
        return _ref6.apply(this, arguments);
      }

      return loadBudgetInfo;
    }(),
    // เมื่อเปลี่ยนค่า target IO, GL หรือ Org - ทำ bi-directional filtering และโหลดข้อมูลงบปลายทาง
    onTargetSelectionChange: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var self;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                self = this;

                // ใน View mode ไม่ต้องโหลดข้อมูลใหม่ (ใช้ข้อมูล snapshot จาก loadJobData)

                if (!this.isViewMode) {
                  _context10.next = 3;
                  break;
                }

                return _context10.abrupt("return");

              case 3:

                // ตั้งค่า target Year และ CCTR ให้ตรงกับ source
                this.selectedTargetYear = this.selectedBudgetYear;
                this.selectedTargetCCTR = this.selectedCCTR;

                // ทำ bi-directional filtering - โหลด dropdown options ใหม่ตามค่าที่เลือก
                _context10.next = 7;
                return this.reloadTargetDropdownsBasedOnSelection();

              case 7:

                // โหลดข้อมูลงบปลายทางถ้าเลือกครบ
                this.loadTargetBudgetInfo();

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function onTargetSelectionChange() {
        return _ref7.apply(this, arguments);
      }

      return onTargetSelectionChange;
    }(),
    // โหลด dropdown options สำหรับ target โดยใช้ bi-directional filtering
    reloadTargetDropdownsBasedOnSelection: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var self, params, response, newIoData, newGlData, newOrgData;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                self = this;

                // ต้องมี Year และ CCTR จาก source

                if (!(!this.selectedBudgetYear || !this.selectedCCTR)) {
                  _context11.next = 3;
                  break;
                }

                return _context11.abrupt("return");

              case 3:
                if (!this.isLoadingTargetDropdowns) {
                  _context11.next = 5;
                  break;
                }

                return _context11.abrupt("return");

              case 5:
                _context11.prev = 5;

                this.isLoadingTargetDropdowns = true;

                params = {
                  year: this.selectedBudgetYear,
                  cctrCode: this.selectedCCTR
                };

                // เพิ่ม filter ตามค่าที่เลือก (bi-directional)

                if (this.selectedTargetIO) {
                  params.ioCode = this.selectedTargetIO;
                }
                if (this.selectedTargetGL) {
                  params.glCode = this.selectedTargetGL;
                }
                if (this.selectedTargetOrg) {
                  params.orgCode = this.selectedTargetOrg;
                }

                console.log('[Target Dropdown] Calling API with params:', params);

                _context11.next = 14;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/Dropdown", {
                  headers: {
                    Authorization: "Bearer " + this.$root.user.access_token
                  },
                  params: params
                });

              case 14:
                response = _context11.sent;


                console.log('[Target Dropdown] API Response:', response.data);

                if (response.data && response.data.data) {
                  self.rawTargetDropdownData = response.data.data;
                  console.log('[Target Dropdown] Set rawTargetDropdownData:', {
                    ioCodes: self.rawTargetDropdownData.ioCodes ? self.rawTargetDropdownData.ioCodes.length : 0,
                    glCodes: self.rawTargetDropdownData.glCodes ? self.rawTargetDropdownData.glCodes.length : 0,
                    orgCodes: self.rawTargetDropdownData.orgCodes ? self.rawTargetDropdownData.orgCodes.length : 0
                  });

                  // สร้าง data arrays ใหม่
                  newIoData = (self.rawTargetDropdownData.ioCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });
                  newGlData = (self.rawTargetDropdownData.glCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });
                  newOrgData = (self.rawTargetDropdownData.orgCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });

                  // Reload Select2 dropdowns ใน next tick
                  // NOTE: ไม่ reload dropdown ที่มี selection อยู่แล้ว เพื่อให้ user สามารถเปลี่ยนใจเลือก item อื่นได้

                  self.$nextTick(function () {
                    // Reload Target IO dropdown - เฉพาะเมื่อไม่มี selection
                    if (!self.selectedTargetIO && self.$refs.targetIOSelect2 && self.$refs.targetIOSelect2.$refs.select) {
                      var $io = $(self.$refs.targetIOSelect2.$refs.select);

                      $io.select2('destroy');
                      $io.empty();
                      $io.append('<option value=""></option>');
                      newIoData.forEach(function (item) {
                        $io.append('<option value="' + item.id + '">' + item.text + '</option>');
                      });

                      // Issue 44: ไม่ส่ง data ใน select2 options (ป้องกัน item ซ้ำ)
                      $io.select2({ placeholder: "-- เลือก IO --", allowClear: true });
                      console.log('[Target IO] Reloaded with', newIoData.length, 'items (no selection)');
                    } else if (self.selectedTargetIO) {
                      console.log('[Target IO] Skipped reload - has selection:', self.selectedTargetIO);
                    }

                    // Reload Target GL dropdown - เฉพาะเมื่อไม่มี selection
                    if (!self.selectedTargetGL && self.$refs.targetGLSelect2 && self.$refs.targetGLSelect2.$refs.select) {
                      var $gl = $(self.$refs.targetGLSelect2.$refs.select);

                      $gl.select2('destroy');
                      $gl.empty();
                      $gl.append('<option value=""></option>');
                      newGlData.forEach(function (item) {
                        $gl.append('<option value="' + item.id + '">' + item.text + '</option>');
                      });

                      $gl.select2({ placeholder: "-- เลือก GL --", allowClear: true });
                      console.log('[Target GL] Reloaded with', newGlData.length, 'items (no selection)');
                    } else if (self.selectedTargetGL) {
                      console.log('[Target GL] Skipped reload - has selection:', self.selectedTargetGL);
                    }

                    // Reload Target Org dropdown - เฉพาะเมื่อไม่มี selection
                    if (!self.selectedTargetOrg && self.$refs.targetOrgSelect2 && self.$refs.targetOrgSelect2.$refs.select) {
                      var $org = $(self.$refs.targetOrgSelect2.$refs.select);

                      $org.select2('destroy');
                      $org.empty();
                      $org.append('<option value=""></option>');
                      newOrgData.forEach(function (item) {
                        $org.append('<option value="' + item.id + '">' + item.text + '</option>');
                      });

                      $org.select2({ placeholder: "-- เลือก แผนก --", allowClear: true });
                      console.log('[Target Org] Reloaded with', newOrgData.length, 'items (no selection)');
                    } else if (self.selectedTargetOrg) {
                      console.log('[Target Org] Skipped reload - has selection:', self.selectedTargetOrg);
                    }
                  });
                }
                _context11.next = 22;
                break;

              case 19:
                _context11.prev = 19;
                _context11.t0 = _context11["catch"](5);

                console.error("Error reloading target dropdowns:", _context11.t0);

              case 22:
                _context11.prev = 22;

                this.isLoadingTargetDropdowns = false;
                return _context11.finish(22);

              case 25:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[5, 19, 22, 25]]);
      }));

      function reloadTargetDropdownsBasedOnSelection() {
        return _ref8.apply(this, arguments);
      }

      return reloadTargetDropdownsBasedOnSelection;
    }(),
    // โหลด dropdown options สำหรับ target ครั้งแรก (เมื่อเปลี่ยน job type เป็น transfer)
    initVendorSelect2: function initVendorSelect2(preselectedId, preselectedText, retryCount) {
      var self = this;
      retryCount = retryCount || 0;

      // ถ้า element ยังไม่มี ให้รอ nextTick (จำกัด 5 ครั้ง เพื่อป้องกัน infinite loop)
      if (!self.$refs.vendorSelect2) {
        if (retryCount >= 5) {
          console.warn('initVendorSelect2: element not found after 5 retries, aborting.');
          return;
        }
        self.$nextTick(function () {
          self.initVendorSelect2(preselectedId, preselectedText, retryCount + 1);
        });
        return;
      }

      var $el = $(self.$refs.vendorSelect2);

      // Destroy existing instance
      if ($el.hasClass('select2-hidden-accessible')) {
        $el.select2('destroy');
      }

      $el.select2({
        placeholder: "เลือก Vendor",
        allowClear: true,
        ajax: {
          url: '/Api/Vendors/Select2Vendor',
          dataType: 'json',
          delay: 300,
          headers: {
            'Authorization': 'Bearer ' + self.$root.user.access_token
          },
          data: function data(params) {
            return {
              search: params.term || '',
              page: params.page || 1
            };
          },
          processResults: function processResults(data, params) {
            params.page = params.page || 1;
            var results = (data.results || []).map(function (item) {
              return { id: item.id, text: item.text };
            });
            // เพิ่ม "อื่นๆ" เป็นตัวเลือกสุดท้าย (เฉพาะหน้าแรกหรือไม่มีหน้าถัดไป)
            if (!data.more) {
              results.push({ id: 'OTHER', text: 'อื่นๆ' });
            }
            return {
              results: results,
              pagination: {
                more: data.more || false
              }
            };
          },
          cache: true
        },
        minimumInputLength: 0
      });

      // Handle select event
      $el.on('select2:select', function (e) {
        self.vendorId = e.params.data.id;
        self.vendorDisplayName = e.params.data.text;
      });

      // Handle clear event
      $el.on('select2:unselect', function () {
        self.vendorId = null;
        self.vendorDisplayName = "";
      });

      // Pre-select value if provided (for Edit/View mode)
      if (preselectedId && preselectedText) {
        var option = new Option(preselectedText, preselectedId, true, true);
        $el.append(option).trigger('change');
        self.vendorId = preselectedId;
        self.vendorDisplayName = preselectedText;
      }

      self.vendorSelect2Initialized = true;
    },
    initializeTargetDropdowns: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var self, response, newIoData, newGlData, newOrgData, tIoText, tGlText, tOrgText;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                self = this;

                if (!(!this.selectedBudgetYear || !this.selectedCCTR)) {
                  _context12.next = 3;
                  break;
                }

                return _context12.abrupt("return");

              case 3:
                _context12.prev = 3;

                this.isLoadingTargetDropdowns = true;

                console.log('[Initialize Target Dropdown] Calling API with year:', this.selectedBudgetYear, 'cctrCode:', this.selectedCCTR);

                _context12.next = 8;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/Dropdown", {
                  headers: {
                    Authorization: "Bearer " + this.$root.user.access_token
                  },
                  params: {
                    year: this.selectedBudgetYear,
                    cctrCode: this.selectedCCTR
                  }
                });

              case 8:
                response = _context12.sent;


                console.log('[Initialize Target Dropdown] API Response:', response.data);

                if (response.data && response.data.data) {
                  self.rawTargetDropdownData = response.data.data;
                  console.log('[Initialize Target Dropdown] Set rawTargetDropdownData:', {
                    ioCodes: self.rawTargetDropdownData.ioCodes ? self.rawTargetDropdownData.ioCodes.length : 0,
                    glCodes: self.rawTargetDropdownData.glCodes ? self.rawTargetDropdownData.glCodes.length : 0,
                    orgCodes: self.rawTargetDropdownData.orgCodes ? self.rawTargetDropdownData.orgCodes.length : 0
                  });

                  // สร้าง data arrays ใหม่
                  newIoData = (self.rawTargetDropdownData.ioCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });
                  newGlData = (self.rawTargetDropdownData.glCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });
                  newOrgData = (self.rawTargetDropdownData.orgCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });

                  // Issue 43.3 → 44: inject missing target options — View mode เท่านั้น

                  if (self.jobId && self.isViewMode) {
                    if (self.jobTargetIOCode && !newIoData.some(function (item) {
                      return item.id === self.jobTargetIOCode;
                    })) {
                      tIoText = self.jobTargetIOName ? "[" + self.jobTargetIOCode + "] " + self.jobTargetIOName : self.jobTargetIOCode;

                      newIoData.push({ id: self.jobTargetIOCode, text: tIoText });
                    }
                    if (self.jobTargetGLCode && !newGlData.some(function (item) {
                      return item.id === self.jobTargetGLCode;
                    })) {
                      tGlText = self.jobTargetGLName ? "[" + self.jobTargetGLCode + "] " + self.jobTargetGLName : self.jobTargetGLCode;

                      newGlData.push({ id: self.jobTargetGLCode, text: tGlText });
                    }
                    if (self.jobTargetOrgCode && !newOrgData.some(function (item) {
                      return item.id === self.jobTargetOrgCode;
                    })) {
                      tOrgText = self.jobTargetOrgName ? "[" + self.jobTargetOrgCode + "] " + self.jobTargetOrgName : self.jobTargetOrgCode;

                      newOrgData.push({ id: self.jobTargetOrgCode, text: tOrgText });
                    }
                  }

                  // Reload Select2 dropdowns ใน next tick
                  self.$nextTick(function () {
                    // Reload Target IO dropdown
                    if (self.$refs.targetIOSelect2 && self.$refs.targetIOSelect2.$refs.select) {
                      var $io = $(self.$refs.targetIOSelect2.$refs.select);
                      $io.select2('destroy');
                      $io.empty();
                      $io.append('<option value=""></option>');
                      newIoData.forEach(function (item) {
                        $io.append('<option value="' + item.id + '">' + item.text + '</option>');
                      });
                      // Issue 44: ไม่ส่ง data ใน select2 options (ป้องกัน item ซ้ำ)
                      $io.select2({ placeholder: "-- เลือก IO --", allowClear: true });
                      console.log('[Initialize Target IO] Reloaded with', newIoData.length, 'items');
                    }

                    // Reload Target GL dropdown
                    if (self.$refs.targetGLSelect2 && self.$refs.targetGLSelect2.$refs.select) {
                      var $gl = $(self.$refs.targetGLSelect2.$refs.select);
                      $gl.select2('destroy');
                      $gl.empty();
                      $gl.append('<option value=""></option>');
                      newGlData.forEach(function (item) {
                        $gl.append('<option value="' + item.id + '">' + item.text + '</option>');
                      });
                      $gl.select2({ placeholder: "-- เลือก GL --", allowClear: true });
                      console.log('[Initialize Target GL] Reloaded with', newGlData.length, 'items');
                    }

                    // Reload Target Org dropdown
                    if (self.$refs.targetOrgSelect2 && self.$refs.targetOrgSelect2.$refs.select) {
                      var $org = $(self.$refs.targetOrgSelect2.$refs.select);
                      $org.select2('destroy');
                      $org.empty();
                      $org.append('<option value=""></option>');
                      newOrgData.forEach(function (item) {
                        $org.append('<option value="' + item.id + '">' + item.text + '</option>');
                      });
                      $org.select2({ placeholder: "-- เลือก แผนก --", allowClear: true });
                      console.log('[Initialize Target Org] Reloaded with', newOrgData.length, 'items');
                    }
                  });
                }
                _context12.next = 16;
                break;

              case 13:
                _context12.prev = 13;
                _context12.t0 = _context12["catch"](3);

                console.error("Error initializing target dropdowns:", _context12.t0);

              case 16:
                _context12.prev = 16;

                this.isLoadingTargetDropdowns = false;
                return _context12.finish(16);

              case 19:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[3, 13, 16, 19]]);
      }));

      function initializeTargetDropdowns() {
        return _ref9.apply(this, arguments);
      }

      return initializeTargetDropdowns;
    }(),
    loadTargetBudgetInfo: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var params, response;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;

                // ตั้งค่า target Year และ CCTR ให้ตรงกับ source (บังคับใช้ค่าเดียวกัน)
                this.selectedTargetYear = this.selectedBudgetYear;
                this.selectedTargetCCTR = this.selectedCCTR;

                // ตรวจสอบว่าเลือก IO, GL, Org ปลายทางครบหรือไม่

                if (!(!this.selectedBudgetYear || !this.selectedCCTR || !this.selectedTargetIO || !this.selectedTargetGL || !this.selectedTargetOrg)) {
                  _context13.next = 6;
                  break;
                }

                this.targetBudgetInfo = null;
                return _context13.abrupt("return");

              case 6:
                if (!(this.selectedTargetIO === this.selectedIO && this.selectedTargetGL === this.selectedGL && this.selectedTargetOrg === this.selectedOrg)) {
                  _context13.next = 10;
                  break;
                }

                this.targetBudgetInfo = null;
                Swal.fire("ข้อผิดพลาด", "ไม่สามารถโยกงบไปยังงบเดียวกันได้ กรุณาเลือก IO, GL หรือแผนกปลายทางที่ต่างจากต้นทาง", "error");
                return _context13.abrupt("return");

              case 10:
                params = {
                  year: this.selectedBudgetYear, // ใช้ Year จาก source
                  cctrCode: this.selectedCCTR, // ใช้ CCTR จาก source
                  ioCode: this.selectedTargetIO,
                  glCode: this.selectedTargetGL,
                  orgCode: this.selectedTargetOrg
                };


                console.log("loadTargetBudgetInfo params:", params);

                _context13.next = 14;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/BudgetInfo", {
                  headers: {
                    Authorization: "Bearer " + this.$root.user.access_token
                  },
                  params: params
                });

              case 14:
                response = _context13.sent;


                console.log("loadTargetBudgetInfo response:", response.data);

                if (response.data && response.data.success && response.data.data && response.data.data.found) {
                  this.targetBudgetInfo = response.data.data;

                  // ตรวจสอบว่างบปลายทางถูกระงับการใช้งานหรือไม่
                  if (this.targetBudgetInfo.inActiveStatus) {
                    this.targetBudgetInfo = null;
                    Swal.fire("ไม่สามารถดำเนินการได้", "งบปลายทางถูกระงับการใช้งาน ไม่สามารถโยกงบได้", "warning");
                  }
                } else {
                  this.targetBudgetInfo = null;
                  console.log("Target budget not found - selected combination may not exist in BudgetPlan");
                  // แจ้งเตือนผู้ใช้ว่าไม่พบงบประมาณที่ตรงกับเงื่อนไขที่เลือก
                  Swal.fire({
                    title: "ไม่พบงบประมาณปลายทาง",
                    html: "ไม่พบงบประมาณที่ตรงกับเงื่อนไขที่เลือก<br>กรุณาตรวจสอบว่ามีงบประมาณที่ใช้ IO, GL และแผนกปลายทางนี้อยู่",
                    type: "warning",
                    confirmButtonText: "ตกลง"
                  });
                }
                _context13.next = 23;
                break;

              case 19:
                _context13.prev = 19;
                _context13.t0 = _context13["catch"](0);

                this.targetBudgetInfo = null;
                console.error("Error loading target budget info:", _context13.t0);

              case 23:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 19]]);
      }));

      function loadTargetBudgetInfo() {
        return _ref10.apply(this, arguments);
      }

      return loadTargetBudgetInfo;
    }(),
    loadApprovedJobs: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var self, response, savedSelection;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                self = this;
                _context14.prev = 1;

                if (!(!this.selectedBudgetYear || !this.selectedCCTR || !this.selectedIO || !this.selectedGL || !this.selectedOrg)) {
                  _context14.next = 4;
                  break;
                }

                return _context14.abrupt("return");

              case 4:
                _context14.next = 6;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/ApprovedJobs", {
                  headers: {
                    Authorization: "Bearer " + this.$root.user.access_token
                  },
                  params: {
                    year: this.selectedBudgetYear,
                    cctrCode: this.selectedCCTR,
                    ioCode: this.selectedIO,
                    glCode: this.selectedGL,
                    orgCode: this.selectedOrg
                  }
                });

              case 6:
                response = _context14.sent;


                // Save current selection to preserve it in view/edit mode
                savedSelection = this.selectedSourceJobId;

                // Clear selected value before loading new data (only in create mode)

                if (!this.jobId) {
                  this.selectedSourceJobId = null;
                }

                if (response.data && Array.isArray(response.data)) {
                  // Format the text to display: "ครั้งที่ X : JobNumber [VendorName] จำนวนเงิน Amount"
                  this.sourceJobOptions.data = response.data.map(function (item) {
                    var formattedAmount = parseFloat(item.totalAmount || 0).toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    });
                    var vendorLabel = item.vendorName ? "[" + item.vendorName + "]" : "[อื่นๆ]";
                    // ISS-70: มีใบคืนแล้ว -> บอกยอดที่ยังคืนได้
                    var refundedLabel = item.refundedAmount > 0 ? " (คืนได้อีก " + parseFloat(item.refundableAmount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ")" : "";
                    return {
                      id: item.id,
                      text: item.text + " : " + item.jobNumber + " " + vendorLabel + " จำนวนเงิน " + formattedAmount + refundedLabel,
                      jobNumber: item.jobNumber,
                      totalAmount: item.totalAmount,
                      refundedAmount: item.refundedAmount,
                      refundableAmount: item.refundableAmount
                    };
                  });
                } else {
                  this.sourceJobOptions.data = [];
                }

                // Refresh Select2 with new data by destroying and re-initializing
                // Return a promise to ensure the caller can wait for this to complete
                return _context14.abrupt("return", new Promise(function (resolve) {
                  self.$nextTick(function () {
                    if (self.$refs.sourceJobSelect2 && self.$refs.sourceJobSelect2.$refs.select) {
                      var $select = $(self.$refs.sourceJobSelect2.$refs.select);

                      // Destroy existing Select2 instance and clear old DOM options
                      $select.select2('destroy');
                      $select.empty();
                      $select.append('<option value=""></option>');

                      // Re-initialize with updated options
                      $select.select2(self.sourceJobOptions);

                      // Clear any auto-selected value only in create mode
                      if (!self.jobId) {
                        $select.val(null).trigger('change');
                      } else if (savedSelection) {
                        // In view/edit mode, restore the saved selection
                        self.selectedSourceJobId = savedSelection;
                      }
                    }
                    resolve();
                  });
                }));

              case 13:
                _context14.prev = 13;
                _context14.t0 = _context14["catch"](1);

                console.error("Error loading approved jobs:", _context14.t0);
                this.sourceJobOptions.data = [];

              case 17:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[1, 13]]);
      }));

      function loadApprovedJobs() {
        return _ref11.apply(this, arguments);
      }

      return loadApprovedJobs;
    }(),
    loadJobItems: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(jobId) {
        var response;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Job/" + jobId + "/Items", {
                  headers: {
                    Authorization: "Bearer " + this.$root.user.access_token
                  }
                });

              case 3:
                response = _context15.sent;


                if (response.data && Array.isArray(response.data)) {
                  this.items = response.data.map(function (item, index) {
                    return {
                      seqNo: index + 1,
                      itemNo: item.itemNo !== null && item.itemNo !== undefined ? item.itemNo.toString() : "",
                      materialNumber: item.materialNumber || "",
                      description: item.description || "",
                      quantity: item.quantity,
                      unitPrice: item.unitPrice,
                      amount: item.amount,
                      remark: item.remark || ""
                    };
                  });
                } else {
                  this.items = [];
                }
                _context15.next = 12;
                break;

              case 7:
                _context15.prev = 7;
                _context15.t0 = _context15["catch"](0);

                console.error("Error loading job items:", _context15.t0);
                this.items = [];
                Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดรายการได้", "error");

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 7]]);
      }));

      function loadJobItems(_x2) {
        return _ref12.apply(this, arguments);
      }

      return loadJobItems;
    }(),
    addItem: function addItem() {
      this.items.push({
        seqNo: this.items.length + 1,
        itemNo: "",
        materialNumber: "",
        description: "",
        quantity: null,
        unitPrice: null,
        amount: null,
        remark: ""
      });
    },
    removeItem: function removeItem(index) {
      this.items.splice(index, 1);
      // Re-sequence items
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].seqNo = i + 1;
      }
    },
    onItemNoInput: function onItemNoInput(item) {
      // Validate item number (must be number or empty)
      if (item.itemNo && !/^\d*$/.test(item.itemNo)) {
        item.itemNo = item.itemNo.replace(/[^\d]/g, "");
      }
    },
    calculateItemAmount: function calculateItemAmount(item) {
      if (item.quantity && item.unitPrice) {
        item.amount = parseFloat((item.quantity * item.unitPrice).toFixed(2));
      }
    },
    // Validation methods for positive values only
    preventNegativeInput: function preventNegativeInput(event) {
      // Allow: backspace, delete, tab, escape, enter, decimal point, comma
      var allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', '.', ',', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (allowedKeys.indexOf(event.key) !== -1) {
        // Allow decimal point only once
        if ((event.key === '.' || event.key === ',') && event.target.value.indexOf('.') !== -1) {
          event.preventDefault();
        }
        return;
      }
      // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      if (event.ctrlKey && ['a', 'c', 'v', 'x'].indexOf(event.key.toLowerCase()) !== -1) {
        return;
      }
      // Block if not a number
      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    },
    sanitizeNumberInput: function sanitizeNumberInput(event) {
      // Remove any non-numeric characters except decimal point
      var sanitized = event.target.value.replace(/[^\d.]/g, '');
      // Ensure only one decimal point
      var parts = sanitized.split('.');
      if (parts.length > 2) {
        sanitized = parts[0] + '.' + parts.slice(1).join('');
      }
      if (event.target.value !== sanitized) {
        event.target.value = sanitized;
      }
    },
    // ====== Number Format Focus/Blur Methods ======
    onDirectAmountFocus: function onDirectAmountFocus(event) {
      // Mark as editing and show raw number
      this.directAmountEditing = true;
      event.target.value = this.directAmount || '';
      event.target.select();
    },
    onDirectAmountBlur: function onDirectAmountBlur(event) {
      // Parse the value (remove commas if user typed them)
      var rawValue = (event.target.value || '').toString().replace(/,/g, '');
      var numValue = parseFloat(rawValue);

      // Validate and set value
      if (isNaN(numValue) || numValue < 0) {
        numValue = 0;
      }
      this.directAmount = numValue;
      this.directAmountEditing = false;
    },
    onItemUnitPriceFocus: function onItemUnitPriceFocus(event, item) {
      this.$set(item, '_editingUnitPrice', true);
      event.target.value = item.unitPrice || '';
      event.target.select();
    },
    onItemUnitPriceBlur: function onItemUnitPriceBlur(event, item) {
      var rawValue = (event.target.value || '').toString().replace(/,/g, '');
      var numValue = parseFloat(rawValue);

      if (isNaN(numValue) || numValue < 0) {
        numValue = 0;
      }
      item.unitPrice = numValue;
      this.$set(item, '_editingUnitPrice', false);
      this.calculateItemAmount(item);
    },
    onItemAmountFocus: function onItemAmountFocus(event, item) {
      this.$set(item, '_editingAmount', true);
      event.target.value = item.amount || '';
      event.target.select();
    },
    onItemAmountBlur: function onItemAmountBlur(event, item) {
      var rawValue = (event.target.value || '').toString().replace(/,/g, '');
      var numValue = parseFloat(rawValue);

      if (isNaN(numValue) || numValue < 0) {
        numValue = 0;
      }
      item.amount = numValue;
      this.$set(item, '_editingAmount', false);
    },
    // ====== End Number Format Methods ======
    validateDirectAmount: function validateDirectAmount() {
      if (this.directAmount === null || this.directAmount === undefined || this.directAmount === '' || isNaN(this.directAmount) || this.directAmount < 0) {
        this.directAmount = 0;
      }
    },
    validateItemQuantity: function validateItemQuantity(item) {
      if (item.quantity === null || item.quantity === undefined || item.quantity === '' || isNaN(item.quantity) || item.quantity < 0) {
        item.quantity = 0;
      }
      this.calculateItemAmount(item);
    },
    validateItemUnitPrice: function validateItemUnitPrice(item) {
      if (item.unitPrice === null || item.unitPrice === undefined || item.unitPrice === '' || isNaN(item.unitPrice) || item.unitPrice < 0) {
        item.unitPrice = 0;
      }
      this.calculateItemAmount(item);
    },
    validateItemAmount: function validateItemAmount(item) {
      if (item.amount === null || item.amount === undefined || item.amount === '' || isNaN(item.amount) || item.amount < 0) {
        item.amount = 0;
      }
    },
    saveJob: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var _this5 = this;

        var self, sourceJob, refundable, confirmResult, itemsData, requestData, apiUrl, httpMethod, budgetInfoStale, response, successMessage, message;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                self = this;

                // Validation

                if (this.canSave) {
                  _context16.next = 4;
                  break;
                }

                Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกข้อมูลให้ครบถ้วน", "warning");
                return _context16.abrupt("return");

              case 4:
                if (!((this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' || this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') && this.items.length === 0)) {
                  _context16.next = 7;
                  break;
                }

                Swal.fire("ไม่มีรายการ", "กรุณาเพิ่มรายการอย่างน้อย 1 รายการ", "warning");
                return _context16.abrupt("return");

              case 7:
                if (!(this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD')) {
                  _context16.next = 11;
                  break;
                }

                if (!(!this.directAmount || this.directAmount <= 0)) {
                  _context16.next = 11;
                  break;
                }

                Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกจำนวนเงินที่เพิ่ม", "warning");
                return _context16.abrupt("return");

              case 11:
                if (!(this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE')) {
                  _context16.next = 18;
                  break;
                }

                if (!(!this.directAmount || this.directAmount <= 0)) {
                  _context16.next = 15;
                  break;
                }

                Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกจำนวนเงินที่ลด", "warning");
                return _context16.abrupt("return");

              case 15:
                if (!(this.directAmount > this.budgetInfo.remainingAmount)) {
                  _context16.next = 18;
                  break;
                }

                Swal.fire("จำนวนเงินเกิน", "จำนวนเงินที่ลดต้องไม่เกินงบคงเหลือ (" + this.formatNumber(this.budgetInfo.remainingAmount) + " บาท)", "warning");
                return _context16.abrupt("return");

              case 18:
                if (!(this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER')) {
                  _context16.next = 28;
                  break;
                }

                if (this.targetBudgetInfo) {
                  _context16.next = 22;
                  break;
                }

                Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือกงบปลายทางให้ครบถ้วน", "warning");
                return _context16.abrupt("return");

              case 22:
                if (!(!this.directAmount || this.directAmount <= 0)) {
                  _context16.next = 25;
                  break;
                }

                Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกจำนวนเงินที่โอน", "warning");
                return _context16.abrupt("return");

              case 25:
                if (!(this.directAmount > this.budgetInfo.budgetAmount)) {
                  _context16.next = 28;
                  break;
                }

                Swal.fire("จำนวนเงินเกิน", "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E42\u0E2D\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19\u0E07\u0E1A\u0E15\u0E49\u0E19\u0E17\u0E32\u0E07 (" + this.formatNumber(this.budgetInfo.budgetAmount) + " \u0E1A\u0E32\u0E17)", "warning");
                return _context16.abrupt("return");

              case 28:
                if (!(this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK')) {
                  _context16.next = 35;
                  break;
                }

                sourceJob = this.sourceJobOptions.data.find(function (j) {
                  return j.id == _this5.selectedSourceJobId;
                });

                if (!sourceJob) {
                  _context16.next = 35;
                  break;
                }

                refundable = sourceJob.refundableAmount !== undefined && sourceJob.refundableAmount !== null ? parseFloat(sourceJob.refundableAmount) + (this.jobId && this.loadedRefundSourceId == this.selectedSourceJobId ? this.loadedRefundAmount : 0) : parseFloat(sourceJob.totalAmount || 0);

                if (!(this.totalAmount > refundable)) {
                  _context16.next = 35;
                  break;
                }

                Swal.fire("จำนวนเงินเกิน", "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E04\u0E37\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19\u0E22\u0E2D\u0E14\u0E17\u0E35\u0E48\u0E04\u0E37\u0E19\u0E44\u0E14\u0E49\u0E02\u0E2D\u0E07\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01 (\u0E04\u0E37\u0E19\u0E44\u0E14\u0E49\u0E2D\u0E35\u0E01 " + this.formatNumber(refundable) + " \u0E1A\u0E32\u0E17)", "warning");
                return _context16.abrupt("return");

              case 35:
                if (!(this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE')) {
                  _context16.next = 45;
                  break;
                }

                if (!(!this.attachments || this.attachments.length === 0)) {
                  _context16.next = 39;
                  break;
                }

                Swal.fire("ข้อมูลไม่ครบ", "กรุณาแนบไฟล์เอกสารอย่างน้อย 1 ไฟล์", "warning");
                return _context16.abrupt("return");

              case 39:
                if (this.vendorId) {
                  _context16.next = 42;
                  break;
                }

                Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือก Vendor", "warning");
                return _context16.abrupt("return");

              case 42:
                if (!(this.vendorId === 'OTHER' && !this.otherVendorName.trim())) {
                  _context16.next = 45;
                  break;
                }

                Swal.fire("ข้อมูลไม่ครบ", "กรุณาระบุข้อมูล Vendor", "warning");
                return _context16.abrupt("return");

              case 45:
                _context16.next = 47;
                return Swal.fire({
                  title: "ยืนยันการบันทึก",
                  text: "คุณต้องการบันทึกใบงานนี้หรือไม่?",
                  type: "question",
                  showCancelButton: true,
                  confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ยกเลิก"
                });

              case 47:
                confirmResult = _context16.sent;

                if (confirmResult.value) {
                  _context16.next = 50;
                  break;
                }

                return _context16.abrupt("return");

              case 50:
                _context16.prev = 50;

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล..."
                });

                // Prepare items based on job type
                itemsData = [];

                if (this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' || this.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
                  itemsData = this.items.map(function (item, index) {
                    return {
                      seqNo: index + 1,
                      itemNo: item.itemNo ? parseInt(item.itemNo) : null,
                      materialNumber: item.materialNumber || null,
                      description: item.description || "",
                      quantity: item.quantity || null,
                      unitPrice: item.unitPrice || null,
                      amount: item.amount || null,
                      remark: item.remark || null
                    };
                  });
                }
                // For ADJUST_ADD and ADJUST_TRANSFER, items array will be empty

                // Prepare data
                requestData = {
                  jobType: this.selectedJobType,
                  jobDate: this.jobDate.format("YYYY-MM-DDTHH:mm:ss"),
                  totalAmount: this.totalAmount,
                  totalAmountText: this.totalAmountText,
                  remark: this.remark,
                  sourceJobId: this.selectedSourceJobId ? parseInt(this.selectedSourceJobId) : null, // สำหรับการคืนเงิน
                  targetBudgetPlanId: this.targetBudgetInfo ? this.targetBudgetInfo.budgetPlanId : null, // สำหรับการโยกงบ
                  vendorId: this.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' && this.vendorId && this.vendorId !== 'OTHER' ? parseInt(this.vendorId) : null, // สำหรับ Vendor (CREATE เท่านั้น)
                  otherVendorName: this.vendorId === 'OTHER' ? this.otherVendorName : null, // FR-016
                  items: itemsData,
                  attachFiles: this.attachments // ไฟล์แนบ
                };

                // Choose API endpoint based on mode

                apiUrl = "/Api/BudgetPlan/Job/Create";
                httpMethod = "post";

                if (!(this.isEditMode && this.jobId)) {
                  _context16.next = 72;
                  break;
                }

                // Edit mode: use Update API
                apiUrl = "/Api/BudgetPlan/Job/Update";
                httpMethod = "put";
                requestData.jobId = this.jobId;

                // Issue 35: ตรวจสอบว่า budgetInfo ตรงกับ filter ปัจจุบัน (ป้องกัน stale data จาก race condition)
                budgetInfoStale = !this.budgetInfo || String(this.budgetInfo.year) !== String(this.selectedBudgetYear) || this.budgetInfo.cctrCode !== this.selectedCCTR || this.budgetInfo.ioCode !== this.selectedIO || this.budgetInfo.glCode !== this.selectedGL || (this.budgetInfo.orgCode || '') !== (this.selectedOrg || '');

                if (!budgetInfoStale) {
                  _context16.next = 65;
                  break;
                }

                _context16.next = 65;
                return this.loadBudgetInfo();

              case 65:
                if (!(!this.budgetInfo || !this.budgetInfo.budgetPlanId)) {
                  _context16.next = 68;
                  break;
                }

                KTApp.unblockPage();
                // loadBudgetInfo จะแสดง warning แล้ว ถ้าไม่พบข้อมูล
                return _context16.abrupt("return");

              case 68:

                requestData.budgetPlanId = this.budgetInfo.budgetPlanId;

                // DEBUG Issue 35: ตรวจสอบค่าก่อนส่ง API
                console.log('[saveJob] DEBUG Issue 35:', {
                  budgetInfoStale: budgetInfoStale,
                  originalBudgetPlanId: this.originalBudgetPlanId,
                  currentBudgetPlanId: this.budgetInfo.budgetPlanId,
                  budgetPlanChanged: this.budgetInfo.budgetPlanId !== this.originalBudgetPlanId,
                  selectedFilters: {
                    year: this.selectedBudgetYear,
                    cctr: this.selectedCCTR,
                    io: this.selectedIO,
                    gl: this.selectedGL,
                    org: this.selectedOrg
                  },
                  budgetInfoFilters: {
                    year: this.budgetInfo.year,
                    cctr: this.budgetInfo.cctrCode,
                    io: this.budgetInfo.ioCode,
                    gl: this.budgetInfo.glCode,
                    org: this.budgetInfo.orgCode
                  }
                });
                _context16.next = 73;
                break;

              case 72:
                // Create mode: add budgetPlanId
                requestData.budgetPlanId = this.budgetInfo.budgetPlanId;

              case 73:
                _context16.next = 75;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                  method: httpMethod,
                  url: apiUrl,
                  data: requestData,
                  headers: {
                    Authorization: "Bearer " + this.$root.user.access_token
                  }
                });

              case 75:
                response = _context16.sent;


                // Unblock page before showing dialog
                KTApp.unblockPage();

                if (!(response.data && response.data.success)) {
                  _context16.next = 85;
                  break;
                }

                successMessage = this.isEditMode ? "แก้ไขใบงานเลขที่ <strong>" + response.data.jobNumber + "</strong> เรียบร้อยแล้ว" : "สร้างใบงานเลขที่ <strong>" + response.data.jobNumber + "</strong> เรียบร้อยแล้ว";
                _context16.next = 81;
                return Swal.fire({
                  title: "บันทึกสำเร็จ",
                  html: successMessage,
                  type: "success"
                });

              case 81:

                // Set jobId for future use
                self.jobId = response.data.jobId;

                // Redirect back to list page with reload query param
                self.$router.push({ path: "/BudgetPlan/Job", query: { reload: Date.now() } });
                _context16.next = 86;
                break;

              case 85:
                Swal.fire("เกิดข้อผิดพลาด", response.data && response.data.message || "ไม่สามารถบันทึกข้อมูลได้", "error");

              case 86:
                _context16.next = 94;
                break;

              case 88:
                _context16.prev = 88;
                _context16.t0 = _context16["catch"](50);

                // Unblock page on error
                KTApp.unblockPage();

                message = "ไม่สามารถบันทึกข้อมูลได้";

                if (_context16.t0.response && _context16.t0.response.data && _context16.t0.response.data.message) {
                  message = _context16.t0.response.data.message;
                }
                Swal.fire("เกิดข้อผิดพลาด", message, "error");

              case 94:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[50, 88]]);
      }));

      function saveJob() {
        return _ref13.apply(this, arguments);
      }

      return saveJob;
    }(),
    submitForApproval: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var self, confirmResult, _requestData, response, message, result, itemsData, budgetInfoStale, requestData, updateResponse, _message, _response, _message2;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                self = this;

                // Set submitting flag

                self.isSubmitting = true;

                // ถ้ายังไม่มี jobId (Create Mode) ให้ Save ก่อน

                if (self.jobId) {
                  _context17.next = 34;
                  break;
                }

                _context17.next = 5;
                return Swal.fire({
                  title: "ยืนยันการสร้างและส่งอนุมัติ",
                  text: "ระบบจะบันทึกข้อมูลและส่งอนุมัติในคราวเดียว คุณต้องการดำเนินการต่อหรือไม่?",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "ใช่, บันทึกและส่งอนุมัติ",
                  cancelButtonText: "ยกเลิก"
                });

              case 5:
                confirmResult = _context17.sent;

                if (confirmResult.value) {
                  _context17.next = 9;
                  break;
                }

                self.isSubmitting = false;
                return _context17.abrupt("return");

              case 9:
                _context17.prev = 9;

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล..."
                });

                _requestData = {
                  budgetPlanId: self.budgetInfo.budgetPlanId,
                  jobType: self.selectedJobType,
                  jobDate: self.jobDate.format("YYYY-MM-DDTHH:mm:ss"),
                  totalAmount: self.totalAmount,
                  totalAmountText: self.totalAmountText,
                  remark: self.remark,
                  vendorId: self.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' && self.vendorId && self.vendorId !== 'OTHER' ? parseInt(self.vendorId) : null,
                  otherVendorName: self.vendorId === 'OTHER' ? self.otherVendorName : null, // FR-016
                  items: self.items.map(function (item, index) {
                    return {
                      seqNo: index + 1,
                      itemNo: item.itemNo ? parseInt(item.itemNo) : null,
                      materialNumber: item.materialNumber || null,
                      description: item.description || "",
                      quantity: item.quantity || null,
                      unitPrice: item.unitPrice || null,
                      amount: item.amount || null,
                      remark: item.remark || null
                    };
                  }),
                  attachFiles: self.attachments
                };
                _context17.next = 14;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BudgetPlan/Job/Create", _requestData, {
                  headers: {
                    Authorization: "Bearer " + this.$root.user.access_token
                  }
                });

              case 14:
                response = _context17.sent;

                if (!(!response.data || !response.data.success)) {
                  _context17.next = 20;
                  break;
                }

                KTApp.unblockPage();
                self.isSubmitting = false;
                Swal.fire("เกิดข้อผิดพลาด", response.data && response.data.message || "ไม่สามารถบันทึกข้อมูลได้", "error");
                return _context17.abrupt("return");

              case 20:

                // Set jobId from response
                self.jobId = response.data.jobId;

                // Unblock page before showing next loading dialog
                KTApp.unblockPage();

                // Continue to submit for approval
                _context17.next = 32;
                break;

              case 24:
                _context17.prev = 24;
                _context17.t0 = _context17["catch"](9);

                KTApp.unblockPage();
                self.isSubmitting = false;
                message = "ไม่สามารถบันทึกข้อมูลได้";

                if (_context17.t0.response && _context17.t0.response.data && _context17.t0.response.data.message) {
                  message = _context17.t0.response.data.message;
                }
                Swal.fire("เกิดข้อผิดพลาด", message, "error");
                return _context17.abrupt("return");

              case 32:
                _context17.next = 72;
                break;

              case 34:
                _context17.next = 36;
                return Swal.fire({
                  title: "ยืนยันการบันทึกและส่งอนุมัติ",
                  text: "ระบบจะบันทึกข้อมูลและส่งอนุมัติในคราวเดียว คุณต้องการดำเนินการต่อหรือไม่?",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "ใช่, บันทึกและส่งอนุมัติ",
                  cancelButtonText: "ยกเลิก"
                });

              case 36:
                result = _context17.sent;

                if (result.value) {
                  _context17.next = 40;
                  break;
                }

                self.isSubmitting = false;
                return _context17.abrupt("return");

              case 40:
                _context17.prev = 40;

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล..."
                });

                // Prepare items based on job type
                itemsData = [];

                if (self.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' || self.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK') {
                  itemsData = self.items.map(function (item, index) {
                    return {
                      seqNo: index + 1,
                      itemNo: item.itemNo ? parseInt(item.itemNo) : null,
                      materialNumber: item.materialNumber || null,
                      description: item.description || "",
                      quantity: item.quantity || null,
                      unitPrice: item.unitPrice || null,
                      amount: item.amount || null,
                      remark: item.remark || null
                    };
                  });
                }

                // Issue 39: stale check เหมือน saveJob (ref Issue 35)
                budgetInfoStale = !self.budgetInfo || String(self.budgetInfo.year) !== String(self.selectedBudgetYear) || self.budgetInfo.cctrCode !== self.selectedCCTR || self.budgetInfo.ioCode !== self.selectedIO || self.budgetInfo.glCode !== self.selectedGL || (self.budgetInfo.orgCode || '') !== (self.selectedOrg || '');

                if (!budgetInfoStale) {
                  _context17.next = 48;
                  break;
                }

                _context17.next = 48;
                return self.loadBudgetInfo();

              case 48:
                if (!(!self.budgetInfo || !self.budgetInfo.budgetPlanId)) {
                  _context17.next = 52;
                  break;
                }

                KTApp.unblockPage();
                self.isSubmitting = false;
                return _context17.abrupt("return");

              case 52:
                requestData = {
                  jobId: self.jobId,
                  budgetPlanId: self.budgetInfo.budgetPlanId, // Issue 39: ส่ง budgetPlanId เหมือนปุ่มบันทึก
                  jobType: self.selectedJobType,
                  jobDate: __WEBPACK_IMPORTED_MODULE_4_moment___default.a.isMoment(self.jobDate) ? self.jobDate.format("YYYY-MM-DDTHH:mm:ss") : self.jobDate,
                  totalAmount: self.totalAmount,
                  totalAmountText: self.totalAmountText,
                  remark: self.remark,
                  sourceJobId: self.selectedSourceJobId ? parseInt(self.selectedSourceJobId) : null,
                  targetBudgetPlanId: self.targetBudgetInfo ? self.targetBudgetInfo.budgetPlanId : null,
                  vendorId: self.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' && self.vendorId && self.vendorId !== 'OTHER' ? parseInt(self.vendorId) : null,
                  otherVendorName: self.vendorId === 'OTHER' ? self.otherVendorName : null, // FR-016
                  items: itemsData,
                  attachFiles: self.attachments
                };
                _context17.next = 55;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/BudgetPlan/Job/Update", requestData, {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 55:
                updateResponse = _context17.sent;

                if (!(!updateResponse.data || !updateResponse.data.success)) {
                  _context17.next = 61;
                  break;
                }

                KTApp.unblockPage();
                self.isSubmitting = false;
                Swal.fire("เกิดข้อผิดพลาด", updateResponse.data && updateResponse.data.message || "ไม่สามารถบันทึกข้อมูลได้", "error");
                return _context17.abrupt("return");

              case 61:

                // Unblock page before showing next loading dialog
                KTApp.unblockPage();

                // Continue to submit for approval
                _context17.next = 72;
                break;

              case 64:
                _context17.prev = 64;
                _context17.t1 = _context17["catch"](40);

                KTApp.unblockPage();
                self.isSubmitting = false;
                _message = "ไม่สามารถบันทึกข้อมูลได้";

                if (_context17.t1.response && _context17.t1.response.data && _context17.t1.response.data.message) {
                  _message = _context17.t1.response.data.message;
                }
                Swal.fire("เกิดข้อผิดพลาด", _message, "error");
                return _context17.abrupt("return");

              case 72:
                _context17.prev = 72;

                Swal.fire({
                  title: "กำลังส่งอนุมัติ...",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  onBeforeOpen: function onBeforeOpen() {
                    Swal.showLoading();
                  }
                });

                _context17.next = 76;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BudgetPlan/Job/" + self.jobId + "/SubmitForApproval", {}, {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 76:
                _response = _context17.sent;

                if (!_response.data.success) {
                  _context17.next = 83;
                  break;
                }

                _context17.next = 80;
                return Swal.fire({
                  title: "สำเร็จ",
                  text: _response.data.message,
                  type: "success"
                });

              case 80:

                // Redirect to list
                self.$router.push({ path: "/BudgetPlan/Job", query: { reload: "1" } });
                _context17.next = 84;
                break;

              case 83:
                Swal.fire("เกิดข้อผิดพลาด", _response.data.message, "error");

              case 84:
                _context17.next = 92;
                break;

              case 86:
                _context17.prev = 86;
                _context17.t2 = _context17["catch"](72);

                console.error("Error submitting for approval:", _context17.t2);
                _message2 = "ไม่สามารถส่งอนุมัติได้";

                if (_context17.t2.response && _context17.t2.response.data && _context17.t2.response.data.message) {
                  _message2 = _context17.t2.response.data.message;
                }
                Swal.fire("เกิดข้อผิดพลาด", _message2, "error");

              case 92:
                _context17.prev = 92;

                KTApp.unblockPage();
                self.isSubmitting = false;
                return _context17.finish(92);

              case 96:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[9, 24], [40, 64], [72, 86, 92, 96]]);
      }));

      function submitForApproval() {
        return _ref14.apply(this, arguments);
      }

      return submitForApproval;
    }(),
    approveJob: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var self, confirmText, result, response, message;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                self = this;

                // Confirm dialog

                confirmText = self.currentApproverType === 'CONFIRM' ? "ยืนยันข้อมูล" : "อนุมัติ";
                _context18.next = 4;
                return Swal.fire({
                  title: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23" + confirmText,
                  text: "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23" + confirmText + "\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
                  input: 'textarea',
                  inputPlaceholder: 'หมายเหตุ (ถ้ามี)',
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "\u0E43\u0E0A\u0E48, " + confirmText,
                  cancelButtonText: "ยกเลิก"
                });

              case 4:
                result = _context18.sent;

                if (!(!result.value && result.value !== '')) {
                  _context18.next = 7;
                  break;
                }

                return _context18.abrupt("return");

              case 7:
                _context18.prev = 7;

                Swal.fire({
                  title: "\u0E01\u0E33\u0E25\u0E31\u0E07" + confirmText + "...",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  onBeforeOpen: function onBeforeOpen() {
                    Swal.showLoading();
                  }
                });

                _context18.next = 11;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BudgetPlan/Job/" + self.jobId + "/Approve", {
                  remark: result.value || ''
                }, {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 11:
                response = _context18.sent;

                if (!response.data.success) {
                  _context18.next = 18;
                  break;
                }

                _context18.next = 15;
                return Swal.fire({
                  title: "สำเร็จ",
                  text: response.data.message,
                  type: "success"
                });

              case 15:
                self.$router.push({ path: "/BudgetPlan/Job", query: { reload: Date.now() } });
                _context18.next = 19;
                break;

              case 18:
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");

              case 19:
                _context18.next = 29;
                break;

              case 21:
                _context18.prev = 21;
                _context18.t0 = _context18["catch"](7);

                console.error("Error approving job:", _context18.t0);
                message = "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16" + confirmText + "\u0E44\u0E14\u0E49";

                if (_context18.t0.response && _context18.t0.response.data && _context18.t0.response.data.message) {
                  message = _context18.t0.response.data.message;
                }
                _context18.next = 28;
                return Swal.fire("เกิดข้อผิดพลาด", message, "error");

              case 28:
                self.$router.push({ path: "/BudgetPlan/Job", query: { reload: Date.now() } });

              case 29:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[7, 21]]);
      }));

      function approveJob() {
        return _ref15.apply(this, arguments);
      }

      return approveJob;
    }(),
    rejectJob: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(actionType) {
        var self, isReject, actionText, dialogConfig, result, response, message;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                self = this;

                // actionType: 'return' = ส่งกลับแก้ไข (Level 1-2), 'reject' = ไม่อนุมัติ (Level 3+)

                isReject = actionType === 'reject';
                actionText = isReject ? "ไม่อนุมัติ" : "ส่งกลับแก้ไข";

                // Confirm dialog with required remark

                dialogConfig = {
                  input: 'textarea',
                  inputPlaceholder: 'เหตุผล (บังคับกรอก)',
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#d33",
                  cancelButtonColor: "#6c757d",
                  cancelButtonText: "ยกเลิก",
                  inputValidator: function inputValidator(value) {
                    if (!value) {
                      return 'กรุณากรอกเหตุผล';
                    }
                  }
                };


                if (isReject) {
                  // ไม่อนุมัติ (REJECTED) - Level 3+ จบ process
                  dialogConfig.title = "ยืนยันไม่อนุมัติ";
                  dialogConfig.text = "ไม่อนุมัติรายการนี้ใช่หรือไม่?";
                  dialogConfig.confirmButtonText = "ไม่อนุมัติ";
                } else {
                  // ส่งกลับแก้ไข (RETURNED) - Level 1-2
                  dialogConfig.title = "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23" + actionText;
                  dialogConfig.text = "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23" + actionText + "\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?";
                  dialogConfig.confirmButtonText = "\u0E43\u0E0A\u0E48, " + actionText;
                }

                _context19.next = 7;
                return Swal.fire(dialogConfig);

              case 7:
                result = _context19.sent;

                if (result.value) {
                  _context19.next = 10;
                  break;
                }

                return _context19.abrupt("return");

              case 10:
                _context19.prev = 10;

                Swal.fire({
                  title: "\u0E01\u0E33\u0E25\u0E31\u0E07" + actionText + "...",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  onBeforeOpen: function onBeforeOpen() {
                    Swal.showLoading();
                  }
                });

                _context19.next = 14;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BudgetPlan/Job/" + self.jobId + "/Reject", {
                  remark: result.value
                }, {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 14:
                response = _context19.sent;

                if (!response.data.success) {
                  _context19.next = 21;
                  break;
                }

                _context19.next = 18;
                return Swal.fire({
                  title: "สำเร็จ",
                  text: response.data.message,
                  type: "success"
                });

              case 18:
                self.$router.push({ path: "/BudgetPlan/Job", query: { reload: Date.now() } });
                _context19.next = 22;
                break;

              case 21:
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");

              case 22:
                _context19.next = 32;
                break;

              case 24:
                _context19.prev = 24;
                _context19.t0 = _context19["catch"](10);

                console.error("Error rejecting job:", _context19.t0);
                message = "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16" + actionText + "\u0E44\u0E14\u0E49";

                if (_context19.t0.response && _context19.t0.response.data && _context19.t0.response.data.message) {
                  message = _context19.t0.response.data.message;
                }
                _context19.next = 31;
                return Swal.fire("เกิดข้อผิดพลาด", message, "error");

              case 31:
                self.$router.push({ path: "/BudgetPlan/Job", query: { reload: Date.now() } });

              case 32:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[10, 24]]);
      }));

      function rejectJob(_x3) {
        return _ref16.apply(this, arguments);
      }

      return rejectJob;
    }()
  }, _defineProperty(_methods, "formatDateTime", function formatDateTime(dateTime) {
    if (!dateTime) return '-';
    var date = new Date(dateTime);
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    var hours = String(date.getHours()).padStart(2, '0');
    var minutes = String(date.getMinutes()).padStart(2, '0');
    return day + "/" + month + "/" + year + " " + hours + ":" + minutes;
  }), _defineProperty(_methods, "formatNumber", function formatNumber(value) {
    if (!value && value !== 0) return '-';
    return parseFloat(value).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }), _methods),
  mounted: function mounted() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
      var self;
      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              self = _this6;

              // Detect mode from route

              if (self.$route.path.includes('/View/')) {
                self.isViewMode = true;
                self.jobId = parseInt(self.$route.params.id);
              } else if (self.$route.path.includes('/Edit/')) {
                self.isEditMode = true;
                self.jobId = parseInt(self.$route.params.id);
              }

              _context20.next = 4;
              return self.loadDropdownData();

            case 4:

              // Issue 25.3: วันที่เอกสาร อยู่นอก v-if="budgetInfo" แล้ว → init datepicker ตอน mounted
              // ต้อง init ก่อน loadJobData เพราะ loadJobData จะ update datepicker value
              self.initJobDatePicker();

              // Load job data if in Edit or View mode

              if (!self.jobId) {
                _context20.next = 9;
                break;
              }

              _context20.next = 8;
              return self.loadJobData();

            case 8:
              // Issue 24: โหลด signed URL หลัง unblockPage — ให้ข้อมูลหลักแสดงก่อน
              // ไม่ใส่ await เพื่อไม่ block mounted hook
              self.loadFileUrls();

            case 9:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, _this6);
    }))();
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__webpack_require__(11);
__webpack_require__(13);
__webpack_require__(9);

var BudgetPlanJobActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a :href=\"'/BudgetPlan/Job/View/' + data.id\" @click.prevent=\"viewJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E14\u0E39\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E07\u0E1A\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13\">\n      <i class=\"fas fa-search\"></i>\n    </a>\n    <a :href=\"'/BudgetPlan/Job/Edit/' + data.id\" @click.prevent=\"editJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E07\u0E1A\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13\" v-if=\"data.status === 0 || data.status === 5\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a :href=\"'/BudgetPlan/Job/Edit/' + data.id\" @click.prevent=\"approveJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E07\u0E1A\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13\" v-if=\"data.canApprove\">\n      <i class=\"fas fa-check-circle\" style=\"color: #5867dd;\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"cancelJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E07\u0E1A\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13\" v-if=\"data.status === 0 || data.status === 5 || (data.status === 1 && data.currentApprovalLevel <= 1)\">\n      <i class=\"la la-trash\" style=\"color: #fd397a;\"></i>\n    </a>\n  </div>",
  methods: {
    viewJob: function viewJob() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: "/BudgetPlan/Job/View/" + this.data.id });
    },
    editJob: function editJob() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: "/BudgetPlan/Job/Edit/" + this.data.id });
    },
    approveJob: function approveJob() {
      // Navigate to view page for approval
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: "/BudgetPlan/Job/View/" + this.data.id });
    },
    cancelJob: function cancelJob() {
      var self = this;
      Swal.fire({
        title: "ยืนยันการยกเลิก",
        type: "warning",
        html: "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E43\u0E1A\u0E07\u0E32\u0E19 <strong>" + this.data.jobNumber + "</strong> \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?<br/><br/><span class=\"text-danger\">\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38: \u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E08\u0E30\u0E04\u0E37\u0E19\u0E22\u0E2D\u0E14\u0E07\u0E1A\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E44\u0E1B\u0E01\u0E25\u0E31\u0E1A\u0E04\u0E37\u0E19</span>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        confirmButtonColor: "#dc3545",
        cancelButtonText: "ปิด",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/Api/BudgetPlan/Job/" + self.data.id, {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token
            }
          }).then(function (response) {
            return response.data;
          }).catch(function (error) {
            Swal.showValidationMessage(error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด");
          });
        },
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        if (result.value) {
          if (result.value.success) {
            self.$parent.reloadDataTable();
            Swal.fire("สำเร็จ", result.value.message || "ยกเลิกใบงานเรียบร้อยแล้ว", "success");
          } else {
            Swal.fire("เกิดข้อผิดพลาด", result.value.message || "ไม่สามารถยกเลิกใบงานได้", "error");
          }
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_4__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    // Generate year options: current year+1 to current year-4
    var currentYear = new Date().getFullYear();
    var yearData = [{ id: (currentYear + 1).toString(), text: (currentYear + 1).toString() }, { id: currentYear.toString(), text: currentYear.toString() }, { id: (currentYear - 1).toString(), text: (currentYear - 1).toString() }, { id: (currentYear - 2).toString(), text: (currentYear - 2).toString() }, { id: (currentYear - 3).toString(), text: (currentYear - 3).toString() }, { id: (currentYear - 4).toString(), text: (currentYear - 4).toString() }];

    return {
      isApprover: false,
      searchYear: currentYear.toString(),
      searchCCTR: null,
      searchIO: null,
      searchGL: null,
      searchOrgCode: null,
      searchJobType: null,
      searchStatus: null,
      searchJobNumber: "",
      searchVendor: "", // FR-012
      // ---- CR-BudgetReport ข้อ 5 ----
      searchProductName: "",
      searchJobDateFrom: "",
      searchJobDateTo: "",
      yearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: true,
        data: yearData
      },
      cctrOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: []
      },
      ioOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: []
      },
      glOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: []
      },
      orgOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: []
      },
      jobTypeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: []
      },
      statusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "MY_APPROVAL", text: "ใบงานที่ต้องอนุมัติ" }, { id: "DRAFT", text: "บันทึก" }, { id: "RETURNED", text: "รอแก้ไขข้อมูล" }, { id: "PENDING_L1", text: "รออนุมัติ ลำดับที่ 1" }, { id: "PENDING_L2", text: "รออนุมัติ ลำดับที่ 2" }, { id: "PENDING_L3", text: "รออนุมัติ ลำดับที่ 3" }, { id: "PENDING_L4", text: "รออนุมัติ ลำดับที่ 4" }, { id: "WAITING_CONFIRM", text: "รอยืนยัน" }, { id: "COMPLETED", text: "ดำเนินการเรียบร้อย" }, { id: "REJECTED", text: "ไม่อนุมัติ" }, { id: "CANCELED", text: "ยกเลิก" }]
      },
      dataTable: null,
      isReloadingDropdowns: false,
      dropdownReloadTimer: null
    };
  },
  methods: {
    formReset: function formReset(e) {
      var currentYear = new Date().getFullYear();
      this.searchYear = currentYear.toString();
      this.searchCCTR = null;
      this.searchIO = null;
      this.searchGL = null;
      this.searchOrgCode = null;
      this.searchJobType = null;
      this.searchStatus = null;
      this.searchJobNumber = "";
      this.searchVendor = ""; // FR-012
      this.searchProductName = "";
      this.searchJobDateFrom = "";
      this.searchJobDateTo = "";
      // ปฏิทินเป็น jQuery ไม่ผูกกับ v-model จึงต้องล้างเอง
      $(this.$refs.jobDateFrom).datepicker("update", "");
      $(this.$refs.jobDateTo).datepicker("update", "");

      // Reset all Select2 dropdowns
      $("#searchYear").val(currentYear.toString()).trigger("change");
      $("#searchCCTR").val(null).trigger("change");
      $("#searchIO").val(null).trigger("change");
      $("#searchGL").val(null).trigger("change");
      $("#searchOrgCode").val(null).trigger("change");
      $("#searchJobType").val(null).trigger("change");
      $("#searchStatus").val(null).trigger("change");

      // Reload filter dropdowns
      this.loadFilterDropdowns();

      // Reload table
      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      if (e) e.preventDefault();
      var dateMessage = this.validateJobDateRange();
      if (dateMessage) {
        Swal.fire("ไม่สามารถทำรายการได้", dateMessage, "warning");
        return;
      }
      var table = $("#budgetPlanJobTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.dataTable) {
        this.dataTable.ajax.reload(null, resetPaging);
      }
    },
    /**
     * ISS-99 (ผู้ใช้สั่ง 23 ต.ค. 2026) ช่วงวันที่ต้องสอดคล้องกับปีงบประมาณที่เลือก
     * ข้อความ/ลำดับเดียวกับ BudgetDateRangeRule.ValidateJobSearch ฝั่ง API · คืน null = ผ่าน
     * ปี "ทั้งหมด" ข้ามปีได้ (Q99-3) · ไม่กรอกวันที่ทั้ง 2 ช่อง = ผ่าน
     */
    validateJobDateRange: function validateJobDateRange() {
      var from = this.searchJobDateFrom ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.searchJobDateFrom, "DD/MM/YYYY", true) : null;
      var to = this.searchJobDateTo ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.searchJobDateTo, "DD/MM/YYYY", true) : null;
      if (from && !from.isValid()) from = null;
      if (to && !to.isValid()) to = null;
      if (!!from !== !!to) {
        return "โปรดระบุช่วงวันที่(เริ่มต้น)และวันที่(สิ้นสุด)ของปีงบประมาณที่ต้องการค้นหา";
      }
      if (!from) return null;
      var year = parseInt(this.searchYear, 10);
      if (!isNaN(year) && (from.year() !== year || to.year() !== year)) {
        return "โปรดระบุช่วงวันที่ภายในปีงบประมาณ " + year;
      }
      if (from.isAfter(to, "day")) {
        return "วันที่(เริ่มต้น) ต้องไม่มากกว่าวันที่(สิ้นสุด)";
      }
      return null;
    },
    /**
     * ISS-99 (Claude เสนอ · ผู้ใช้ตกลง 23 ต.ค. 2026): เลือกปีแล้ว ปฏิทินเลือกได้เฉพาะวันในปีนั้น
     * ปี "ทั้งหมด" = ไม่จำกัด · วันที่เลือกไว้ก่อนเปลี่ยนปีไม่ล้าง — ไปเจอข้อความตอนกดค้นหาแทน
     */
    applyJobDateLimits: function applyJobDateLimits() {
      var year = parseInt(this.searchYear, 10);
      var start = isNaN(year) ? -Infinity : new Date(year, 0, 1);
      var end = isNaN(year) ? Infinity : new Date(year, 11, 31);
      [this.$refs.jobDateFrom, this.$refs.jobDateTo].forEach(function (el) {
        if (!el) return;
        $(el).datepicker("setStartDate", start);
        $(el).datepicker("setEndDate", end);
      });
    },
    goToCreate: function goToCreate() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: "/BudgetPlan/Job/Create" });
    },
    loadJobTypes: function loadJobTypes() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, $select;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/BudgetPlan/Job/Types", {
                  headers: {
                    Authorization: "Bearer " + _this.$root.user.access_token
                  }
                });

              case 3:
                response = _context.sent;

                if (!(response.data && Array.isArray(response.data))) {
                  _context.next = 9;
                  break;
                }

                _this.jobTypeOptions.data = response.data.map(function (item) {
                  return {
                    id: item.value,
                    text: item.text
                  };
                });

                _context.next = 8;
                return _this.$nextTick();

              case 8:
                if (_this.$refs.searchJobTypeSelect2 && _this.$refs.searchJobTypeSelect2.$el) {
                  $select = $(_this.$refs.searchJobTypeSelect2.$el);

                  if ($select.data('select2')) {
                    $select.select2('destroy');
                  }
                  $select.select2({
                    data: _this.jobTypeOptions.data,
                    placeholder: _this.jobTypeOptions.placeholder,
                    allowClear: _this.jobTypeOptions.allowClear
                  });
                  $select.val(null).trigger('change');
                }

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                console.error("Error loading job types:", _context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }))();
    },
    loadFilterDropdowns: function loadFilterDropdowns() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self, headers, params, response, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this2;
                _context2.prev = 1;
                headers = {
                  Authorization: "Bearer " + _this2.$root.user.access_token
                };

                // Build query params

                params = {};

                if (self.searchYear) {
                  params.year = self.searchYear;
                }

                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/BudgetPlan/Job/Dropdown", {
                  headers: headers,
                  params: params
                });

              case 7:
                response = _context2.sent;

                if (!(response.data && response.data.data)) {
                  _context2.next = 20;
                  break;
                }

                data = response.data.data;

                // Update dropdown options

                self.cctrOptions.data = (data.costCenters || []).map(function (item) {
                  return { id: item.value, text: item.text };
                });
                self.ioOptions.data = (data.ioCodes || []).map(function (item) {
                  return { id: item.value, text: item.text };
                });
                self.glOptions.data = (data.glCodes || []).map(function (item) {
                  return { id: item.value, text: item.text };
                });
                self.orgOptions.data = (data.orgCodes || []).map(function (item) {
                  return { id: item.value, text: item.text };
                });

                // Refresh Select2 dropdowns
                _context2.next = 16;
                return self.$nextTick();

              case 16:
                self.refreshSelect2Dropdown('cctrSelect2', 'searchCCTR', self.cctrOptions);
                self.refreshSelect2Dropdown('ioSelect2', 'searchIO', self.ioOptions);
                self.refreshSelect2Dropdown('glSelect2', 'searchGL', self.glOptions);
                self.refreshSelect2Dropdown('orgSelect2', 'searchOrgCode', self.orgOptions);

              case 20:
                _context2.next = 25;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2["catch"](1);

                console.error("Error loading filter dropdowns:", _context2.t0);

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 22]]);
      }))();
    },

    /**
     * ISS-07 · ปฏิทินช่วงวันที่ใบงาน — bootstrap-datepicker แบบเดียวกับหน้าอื่นในระบบ
     * (เทียบแบบจาก Components/PM/SearchCheckIn.vue) · รูปแบบ dd/mm/yyyy
     * เก็บค่าเป็น string ตรง ๆ — ParseFilterDate ฝั่ง API รับ dd/MM/yyyy อยู่แล้ว
     */
    initJobDatepickers: function initJobDatepickers() {
      var self = this;
      var arrows = KTUtil.isRTL() ? { leftArrow: '<i class="la la-angle-right"></i>', rightArrow: '<i class="la la-angle-left"></i>' } : { leftArrow: '<i class="la la-angle-left"></i>', rightArrow: '<i class="la la-angle-right"></i>' };

      var dpOptions = {
        autoclose: true,
        clearBtn: true,
        format: "dd/mm/yyyy",
        rtl: KTUtil.isRTL(),
        orientation: "bottom left",
        todayBtn: "linked",
        todayHighlight: true,
        templates: arrows
      };

      $(self.$refs.jobDateFrom).datepicker(dpOptions).on("changeDate", function (e) {
        self.searchJobDateFrom = e.date ? $(self.$refs.jobDateFrom).val() : "";
      });
      $(self.$refs.jobDateTo).datepicker(dpOptions).on("changeDate", function (e) {
        self.searchJobDateTo = e.date ? $(self.$refs.jobDateTo).val() : "";
      });
      self.applyJobDateLimits(); // ISS-99
    },

    refreshSelect2Dropdown: function refreshSelect2Dropdown(refName, selectId, options) {
      var self = this;
      if (self.$refs[refName] && self.$refs[refName].$el) {
        var $select = $(self.$refs[refName].$el);
        if ($select.data('select2')) {
          $select.select2('destroy');
        }
        $select.empty();
        $select.append('<option value=""></option>');
        options.data.forEach(function (item) {
          $select.append('<option value="' + item.id + '">' + item.text + '</option>');
        });
        $select.select2({
          data: options.data,
          placeholder: options.placeholder,
          allowClear: options.allowClear
        });
        $select.val(null).trigger('change.select2');
      }
    },
    reloadDropdownsBasedOnSelection: function reloadDropdownsBasedOnSelection() {
      var self = this;

      // Clear existing timer
      if (self.dropdownReloadTimer) {
        clearTimeout(self.dropdownReloadTimer);
      }

      // Debounce: wait 300ms before calling API
      self.dropdownReloadTimer = setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var headers, params, response, data, newCctrData, newIoData, newGlData, newOrgData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                self.isReloadingDropdowns = true;

                headers = {
                  Authorization: "Bearer " + self.$root.user.access_token
                };

                // Build query params based on current selections

                params = {};

                if (self.searchYear) {
                  params.year = self.searchYear;
                }
                if (self.searchCCTR) {
                  params.cctrCode = self.searchCCTR;
                }
                if (self.searchIO) {
                  params.ioCode = self.searchIO;
                }
                if (self.searchGL) {
                  params.glCode = self.searchGL;
                }
                if (self.searchOrgCode) {
                  params.orgCode = self.searchOrgCode;
                }

                _context3.next = 11;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/BudgetPlan/Job/Dropdown", {
                  headers: headers,
                  params: params
                });

              case 11:
                response = _context3.sent;


                if (response.data && response.data.data) {
                  data = response.data.data;

                  // Create new data arrays

                  newCctrData = (data.costCenters || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });
                  newIoData = (data.ioCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });
                  newGlData = (data.glCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });
                  newOrgData = (data.orgCodes || []).map(function (item) {
                    return { id: item.value, text: item.text };
                  });

                  // Reload dropdowns in next tick
                  // NOTE: ไม่ reload dropdown ที่มี selection อยู่แล้ว เพื่อให้ user สามารถเปลี่ยนใจเลือก item อื่นได้

                  self.$nextTick(function () {
                    // Reload CCTR dropdown - เฉพาะเมื่อไม่มี selection
                    if (!self.searchCCTR) {
                      self.reloadSelectWithValidation('cctrSelect2', 'searchCCTR', newCctrData, self.cctrOptions);
                    }
                    // Reload IO dropdown - เฉพาะเมื่อไม่มี selection
                    if (!self.searchIO) {
                      self.reloadSelectWithValidation('ioSelect2', 'searchIO', newIoData, self.ioOptions);
                    }
                    // Reload GL dropdown - เฉพาะเมื่อไม่มี selection
                    if (!self.searchGL) {
                      self.reloadSelectWithValidation('glSelect2', 'searchGL', newGlData, self.glOptions);
                    }
                    // Reload Org dropdown - เฉพาะเมื่อไม่มี selection
                    if (!self.searchOrgCode) {
                      self.reloadSelectWithValidation('orgSelect2', 'searchOrgCode', newOrgData, self.orgOptions);
                    }

                    self.isReloadingDropdowns = false;
                  });
                }
                _context3.next = 19;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](0);

                console.error("Error reloading dropdowns:", _context3.t0);
                self.isReloadingDropdowns = false;

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 15]]);
      })), 300);
    },
    reloadSelectWithValidation: function reloadSelectWithValidation(refName, dataKey, newData, optionsObj) {
      var self = this;
      if (self.$refs[refName] && self.$refs[refName].$el) {
        var $select = $(self.$refs[refName].$el);
        var currentValue = self[dataKey];

        $select.select2('destroy');
        $select.empty();
        $select.append('<option value=""></option>');
        newData.forEach(function (item) {
          $select.append('<option value="' + item.id + '">' + item.text + '</option>');
        });

        optionsObj.data = newData;
        $select.select2({
          data: newData,
          placeholder: optionsObj.placeholder,
          allowClear: optionsObj.allowClear
        });

        // Check if current value is still valid
        var isValid = newData.some(function (x) {
          return x.id === currentValue;
        });
        if (currentValue && isValid) {
          self[dataKey] = currentValue;
          $select.val(currentValue).trigger('change.select2');
        } else {
          self[dataKey] = null;
          $select.val(null).trigger('change.select2');
        }
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var self, currentYear, table;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // ISS-07: ปฏิทินต้องผูกก่อน แล้วค่อยโหลดข้อมูลตาราง
              _this3.initJobDatepickers();

              // Load job types and filter dropdowns
              _context4.next = 3;
              return _this3.loadJobTypes();

            case 3:
              _context4.next = 5;
              return _this3.loadFilterDropdowns();

            case 5:
              self = _this3;

              // Check ว่า user เป็น approver หรือไม่ (ซ่อนปุ่ม "ตรวจสอบ..." ถ้าไม่ใช่)

              __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/BudgetPlan/IsApprover").then(function (res) {
                self.isApprover = res.data === true;
              }).catch(function () {
                self.isApprover = false;
              });

              // Set default year
              _context4.next = 9;
              return _this3.$nextTick();

            case 9:
              currentYear = new Date().getFullYear();

              $("#searchYear").val(currentYear.toString()).trigger("change");

              $.fn.dataTable.ext.errMode = "none";
              table = $("#budgetPlanJobTable");

              self.dataTable = table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/BudgetPlan/Job/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      Year: self.searchYear || "",
                      CCTRCode: self.searchCCTR || "",
                      IOCode: self.searchIO || "",
                      GLCode: self.searchGL || "",
                      OrgCode: self.searchOrgCode || "",
                      JobType: self.searchJobType || "",
                      StatusFilter: self.searchStatus || "",
                      JobNumber: self.searchJobNumber || "",
                      VendorSearch: self.searchVendor || "", // FR-012
                      ProductNameSearch: self.searchProductName || "", // ข้อ 5
                      JobDateFrom: self.searchJobDateFrom || "",
                      JobDateTo: self.searchJobDateTo || "",
                      CurrentUserId: self.$root.user.profile.sub // Pass current user ID for canApprove check
                    }));
                  }
                },
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [50, 100, 200, 500],
                pageLength: 100,
                language: {
                  lengthMenu: "Display _MENU_"
                },
                order: [[0, "asc"]],
                columns: [
                // FR-012 §4.3.2: IO column with toggle +/- (ซ่อน CCTR, ประเภทใบงาน, เลขที่ใบงาน, วันที่)
                {
                  data: "ioCode",
                  className: "text-left dt-control",
                  width: "12%",
                  render: function render(data, type, full, meta) {
                    var ioText = data && full.ioName ? "[" + data + "] " + full.ioName : data || "-";
                    return ioText;
                  }
                }, {
                  data: "glCode",
                  className: "text-left",
                  width: "12%",
                  render: function render(data, type, full, meta) {
                    if (data && full.glName) {
                      return "[" + data + "] " + full.glName;
                    }
                    return data || "-";
                  }
                }, {
                  data: "orgCode",
                  className: "text-left",
                  width: "8%",
                  render: function render(data, type, full, meta) {
                    if (data && full.orgName) {
                      return "[" + data + "] " + full.orgName;
                    }
                    return data || "-";
                  }
                },
                // FR-012: รายการสินค้า (#96: ขยาย +5%)
                {
                  data: "itemsDisplay",
                  className: "text-left",
                  width: "20%",
                  render: function render(data) {
                    if (!data) return "-";
                    return "<small>" + data.replace(/\n/g, "<br/>") + "</small>";
                  }
                },
                // FR-012: จำนวนเงินรวม
                {
                  data: "totalAmount",
                  className: "text-right",
                  width: "8%",
                  render: function render(data) {
                    if (data == null) return "0.00";
                    return Number(data).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                  }
                },
                // FR-012: Vendor (#96: ลด -5%)
                {
                  data: "vendorName",
                  className: "text-left",
                  width: "7%",
                  render: function render(data) {
                    return data || "-";
                  }
                }, {
                  data: "statusName",
                  className: "text-center",
                  width: "8%",
                  render: function render(data, type, full, meta) {
                    var badgeClass = "badge-secondary";
                    var displayText = data;

                    switch (full.status) {
                      case 0:
                        // DRAFT
                        badgeClass = "badge-secondary";
                        displayText = "บันทึก";
                        break;
                      case 1:
                        // PENDING_APPROVAL
                        badgeClass = "badge-warning";
                        displayText = "รออนุมัติ ลำดับที่ " + full.currentApprovalLevel;
                        break;
                      case 2:
                        // APPROVED (waiting confirm) - รอยืนยัน
                        badgeClass = "badge-info";
                        displayText = "รอยืนยัน";
                        break;
                      case 3:
                        // CONFIRMED
                        badgeClass = "badge-success";
                        displayText = "ดำเนินการเรียบร้อย";
                        break;
                      case 4:
                        // REJECTED
                        badgeClass = "badge-danger";
                        displayText = "ไม่อนุมัติ";
                        break;
                      case 5:
                        // RETURNED
                        badgeClass = "badge-warning";
                        displayText = "รอแก้ไขข้อมูล";
                        break;
                      case 6:
                        // COMPLETED
                        badgeClass = "badge-success";
                        displayText = "ดำเนินการเรียบร้อย";
                        break;
                      case 7:
                        // CANCELED
                        badgeClass = "badge-danger";
                        displayText = "ยกเลิก";
                        break;
                    }
                    return "<span class=\"badge " + badgeClass + "\">" + displayText + "</span>";
                  }
                }, {
                  data: "id",
                  className: "text-center",
                  width: "5%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                // ISS-99: API ปฏิเสธช่วงวันที่ (เช่น แก้วันที่แล้วเปลี่ยนหน้า/เรียงโดยไม่กดค้นหา) -> แจ้งข้อความจาก API
                var xhr = settings && settings.jqXHR;
                var apiMessage = xhr && xhr.status === 400 && xhr.responseJSON && xhr.responseJSON.message;
                if (apiMessage) {
                  Swal.fire("ไม่สามารถทำรายการได้", apiMessage, "warning");
                  return;
                }
                __WEBPACK_IMPORTED_MODULE_5__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new BudgetPlanJobActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

              // FR-012 §4.3.2: Toggle child row เมื่อคลิก IO column (dt-control)
              $("#budgetPlanJobTable tbody").on("click", "td.dt-control", function () {
                var tr = $(this).closest("tr");
                var row = self.dataTable.row(tr);

                if (row.child.isShown()) {
                  row.child.hide();
                  tr.removeClass("shown");
                } else {
                  var d = row.data();
                  if (d) {
                    var cctr = d.cctrCode ? "[" + d.cctrCode + "] " + (d.cctrName || "") : "-";
                    var jobType = d.jobTypeName || "-";
                    var jobNumber = d.jobNumber || "-";
                    var lastDate = "-";
                    if (d.lastModifiedDate) {
                      var dt = new Date(d.lastModifiedDate);
                      lastDate = String(dt.getDate()).padStart(2, "0") + "/" + String(dt.getMonth() + 1).padStart(2, "0") + "/" + dt.getFullYear() + " " + String(dt.getHours()).padStart(2, "0") + ":" + String(dt.getMinutes()).padStart(2, "0");
                    }
                    row.child('<table class="table table-sm table-borderless mb-0" style="background:#f9f9f9;">' + '<tr><td><strong>CCTR:</strong> ' + cctr + '</td></tr>' + '<tr><td><strong>ประเภทใบงาน:</strong> ' + jobType + '</td></tr>' + '<tr><td><strong>เลขที่ใบงาน:</strong> ' + jobNumber + '</td></tr>' + '<tr><td><strong>วันที่เคลื่อนไหว:</strong> ' + lastDate + '</td></tr>' + '</table>').show();
                    tr.addClass("shown");
                  }
                }
              });

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this3);
    }))();
  },

  watch: {
    '$route.query.reload': function $routeQueryReload() {
      // Reload datatable when returning from form with reload query param
      if (this.dataTable) {
        this.dataTable.ajax.reload();
      }
    },
    searchYear: function searchYear(newVal, oldVal) {
      this.applyJobDateLimits(); // ISS-99
      if (oldVal !== null && newVal !== oldVal) {
        // Reset filter dropdowns when year changes
        this.searchCCTR = null;
        this.searchIO = null;
        this.searchGL = null;
        this.searchOrgCode = null;

        $("#searchCCTR").val(null).trigger("change.select2");
        $("#searchIO").val(null).trigger("change.select2");
        $("#searchGL").val(null).trigger("change.select2");
        $("#searchOrgCode").val(null).trigger("change.select2");

        // Reload dropdown data
        this.loadFilterDropdowns();
      }
    },
    searchCCTR: function searchCCTR(newVal, oldVal) {
      if (oldVal !== undefined && !this.isReloadingDropdowns) {
        this.reloadDropdownsBasedOnSelection();
      }
    },
    searchIO: function searchIO(newVal, oldVal) {
      if (oldVal !== undefined && !this.isReloadingDropdowns) {
        this.reloadDropdownsBasedOnSelection();
      }
    },
    searchGL: function searchGL(newVal, oldVal) {
      if (oldVal !== undefined && !this.isReloadingDropdowns) {
        this.reloadDropdownsBasedOnSelection();
      }
    },
    searchOrgCode: function searchOrgCode(newVal, oldVal) {
      if (oldVal !== undefined && !this.isReloadingDropdowns) {
        this.reloadDropdownsBasedOnSelection();
      }
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(11);
__webpack_require__(13);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a v-if=\"canEdit\" href=\"#\" class=\"btn btn-sm btn-success\" @click.prevent=\"toggleStatus\">\n      <i class=\"fas fa-play\"></i> \u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n    <span v-else class=\"badge badge-success\">\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19</span>\n  </div>",
  props: ['canEdit'],
  methods: {
    toggleStatus: function toggleStatus() {
      var _this = this;

      var self = this;

      // Check if this CostCenter has used jobs - cannot deactivate
      if (this.data.hasUsedJobs) {
        Swal.fire({
          title: "ไม่สามารถปิดสถานะได้",
          type: "warning",
          html: "ไม่สามารถปิดสถานะได้ เนื่องจากมีการใช้งบประมาณภายใต้ CCTR นี้แล้ว",
          confirmButtonText: "ตกลง"
        });
        return;
      }

      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขสถานะ กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BudgetPlan/CostCenter/" + _this.data.year + "/" + _this.data.costCenterCode + "/ToggleStatus", {}, {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token
            }
          }).then(function (response) {
            if (response.data.success) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", "ปรับปรุงสถานะการใช้งานสำเร็จ", "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            var errorMsg = error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด";
            Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
          }).then(function () {
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a v-if=\"canEdit\" href=\"#\" class=\"btn btn-sm btn-danger\" @click.prevent=\"toggleStatus\">\n      <i class=\"fas fa-pause\"></i> \u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n    <span v-else class=\"badge badge-danger\">\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19</span>\n  </div>",
  props: ['canEdit'],
  methods: {
    toggleStatus: function toggleStatus() {
      var _this2 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขสถานะ กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BudgetPlan/CostCenter/" + _this2.data.year + "/" + _this2.data.costCenterCode + "/ToggleStatus", {}, {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token
            }
          }).then(function (response) {
            if (response.data.success) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", "ปรับปรุงสถานะการใช้งานสำเร็จ", "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            var errorMsg = error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด";
            Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
          }).then(function () {
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

var BudgetPlanActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"viewBudgetPlan\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E14\u0E39\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\">\n      <i class=\"fas fa-search\"></i>\n    </a>\n    <a v-if=\"canEdit\" href=\"#\" @click.prevent=\"editBudgetPlan\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a v-if=\"canEdit\" href=\"#\" @click.prevent=\"deleteBudgetPlan\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  props: ['canEdit'],
  methods: {
    viewBudgetPlan: function viewBudgetPlan() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/BudgetPlan/View/" + this.data.year + "/" + this.data.costCenterCode });
    },
    editBudgetPlan: function editBudgetPlan() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/BudgetPlan/Edit/" + this.data.year + "/" + this.data.costCenterCode });
    },
    deleteBudgetPlan: function deleteBudgetPlan() {
      var _this3 = this;

      var self = this;

      // Check if this CostCenter has used jobs - cannot delete
      if (this.data.hasUsedJobs) {
        Swal.fire({
          title: "ไม่สามารถลบได้",
          type: "warning",
          html: "ไม่สามารถลบได้ เนื่องจากมีการใช้งบประมาณภายใต้ CCTR นี้แล้ว",
          confirmButtonText: "ตกลง"
        });
        return;
      }

      Swal.fire({
        title: "ยืนยันการลบ",
        type: "warning",
        html: "คุณต้องการลบข้อมูล Cost Center นี้หรือไม่?",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/BudgetPlan/CostCenter/" + _this3.data.year + "/" + _this3.data.costCenterCode + "/Delete").then(function (response) {
            if (response.data.success) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            var errorMsg = error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด";
            Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
          }).then(function () {
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  computed: {
    // ตรวจสอบว่า user มีสิทธิ์แก้ไขได้หรือไม่ (BUDGET_PLAN_REVIEWER หรือ BUDGET_PLAN_MANAGER)
    canEdit: function canEdit() {
      return this.$root.canShowExSuperAdmin([['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']]);
    }
  },
  data: function data() {
    // Generate year options: current year+1, current year, current year-1 to -4
    var currentYear = new Date().getFullYear();
    var yearData = [{ id: (currentYear + 1).toString(), text: (currentYear + 1).toString() }, { id: currentYear.toString(), text: currentYear.toString() }, { id: (currentYear - 1).toString(), text: (currentYear - 1).toString() }, { id: (currentYear - 2).toString(), text: (currentYear - 2).toString() }, { id: (currentYear - 3).toString(), text: (currentYear - 3).toString() }, { id: (currentYear - 4).toString(), text: (currentYear - 4).toString() }];

    // Import year options: only current year and current year + 1
    var importYearData = [{ id: (currentYear + 1).toString(), text: (currentYear + 1).toString() }, { id: currentYear.toString(), text: currentYear.toString() }];

    // Search year options (same list but with allowClear)
    var searchYearData = yearData.slice(); // copy array

    return {
      searchCCTR: "",
      searchYear: currentYear.toString(), // Default: current year
      searchStatus: "1", // Default: ใช้งาน
      searchYearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: true,
        data: searchYearData
      },
      statusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "1", text: "ใช้งาน" }, { id: "0", text: "ไม่ใช้งาน" }]
      },
      // Import Modal
      importYear: null,
      importFile: null,
      importFileName: "",
      yearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: false,
        data: importYearData // Import: เฉพาะปีปัจจุบันและปีถัดไป
      },
      // Store import rows for error export
      lastImportRows: null
    };
  },
  methods: {
    downloadTemplate: function downloadTemplate() {
      // Create a temporary link element to trigger download
      var link = document.createElement('a');
      link.href = '/Template/Budget Approval_Import_Template.xlsx';
      link.download = 'Budget Approval_Import_Template.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formReset: function formReset(e) {
      this.searchCCTR = "";
      this.searchYear = null;
      this.searchStatus = null;
      $("#budgetList_statusKey").val("").trigger("change");
      $("#budgetList_yearKey").val("").trigger("change");
      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#budgetPlanTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#budgetPlanTable").DataTable().ajax.reload(null, resetPaging);
    },
    // Import Modal Methods
    showImportModal: function showImportModal() {
      this.resetImportForm();
      $("#importBudgetPlanModal").modal("show");
    },
    resetImportForm: function resetImportForm() {
      this.importYear = null;
      this.importFile = null;
      this.importFileName = "";
      if (this.$refs.importFileInput) {
        this.$refs.importFileInput.value = "";
      }
      $("#importYearSelect").val("").trigger("change");
    },
    onFileChange: function onFileChange(e) {
      var file = e.target.files[0];
      if (file) {
        // Validate file extension
        var ext = file.name.split(".").pop().toLowerCase();
        if (ext !== "xlsx") {
          Swal.fire("ผิดพลาด", "กรุณาเลือกไฟล์ .xlsx เท่านั้น", "error");
          this.$refs.importFileInput.value = "";
          this.importFile = null;
          this.importFileName = "";
          return;
        }
        this.importFile = file;
        this.importFileName = file.name;
      } else {
        this.importFile = null;
        this.importFileName = "";
      }
    },
    submitImport: function submitImport() {
      if (!this.importYear) {
        Swal.fire("ผิดพลาด", "กรุณาเลือกปีงบประมาณ", "warning");
        return;
      }
      if (!this.importFile) {
        Swal.fire("ผิดพลาด", "กรุณาเลือกไฟล์ Excel", "warning");
        return;
      }

      var self = this;
      var formData = new FormData();
      formData.append("file", this.importFile);
      formData.append("year", this.importYear);

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังนำเข้าข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/BudgetPlan/Import", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(function (response) {
        if (response.data.success) {
          $("#importBudgetPlanModal").modal("hide");
          self.reloadDataTable(true);

          // Show result summary
          var result = response.data.data;
          var message = "\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08<br/>";
          message += "- \u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E35\u0E48\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32: " + (result.importedCount || 0) + " \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23<br/>";
          if (result.errorCount > 0) {
            message += "- \u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E35\u0E48\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14: " + result.errorCount + " \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23";
          }

          Swal.fire({
            title: "สำเร็จ",
            html: message,
            type: "success"
          });
        } else {
          // Store import rows for error export
          self.lastImportRows = response.data.importRows || null;

          // Show validation errors with download button
          var errorHtml = "<p>" + (response.data.message || "นำเข้าข้อมูลไม่สำเร็จ") + "</p>";

          if (self.lastImportRows && self.lastImportRows.length > 0) {
            errorHtml += "<p>\u0E04\u0E25\u0E34\u0E01 <strong>\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 Error Detail</strong> \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14</p>";
          }

          Swal.fire({
            title: "นำเข้าข้อมูลไม่สำเร็จ",
            html: errorHtml,
            type: "error",
            showCancelButton: self.lastImportRows && self.lastImportRows.length > 0,
            confirmButtonText: "ตกลง",
            cancelButtonText: '<i class="fas fa-download"></i> ดาวน์โหลด Error Detail',
            cancelButtonColor: "#5867dd"
          }).then(function (result) {
            if (result.dismiss === Swal.DismissReason.cancel) {
              // Download error detail
              self.downloadErrorDetail();
            }
          });
        }
      }).catch(function (error) {
        var message = "เกิดข้อผิดพลาดในการนำเข้าข้อมูล";
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    goToCreate: function goToCreate() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/BudgetPlan/Create" });
    },
    downloadErrorDetail: function downloadErrorDetail() {
      if (!this.lastImportRows || this.lastImportRows.length === 0) {
        Swal.fire("ผิดพลาด", "ไม่พบข้อมูลสำหรับ export", "warning");
        return;
      }

      var self = this;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังสร้างไฟล์ กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/BudgetPlan/ExportErrors", {
        importRows: this.lastImportRows,
        year: this.importYear
      }, {
        responseType: "blob"
      }).then(function (response) {
        // Create download link
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement("a");
        link.href = url;

        // Get filename from header or use default
        var contentDisposition = response.headers["content-disposition"];
        var filename = "BudgetPlan_ImportErrors.xlsx";
        if (contentDisposition) {
          var filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ""));
          }
        }

        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดาวน์โหลดไฟล์ได้", "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, currentYear, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;

              // Set default values for dropdowns

              _context.next = 3;
              return _this4.$nextTick();

            case 3:
              currentYear = new Date().getFullYear();

              $("#budgetList_statusKey").val("1").trigger("change");
              $("#budgetList_yearKey").val(currentYear.toString()).trigger("change");

              $.fn.dataTable.ext.errMode = "none";
              table = $("#budgetPlanTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/BudgetPlan/CostCenter/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      CostCenterCode: self.searchCCTR,
                      Year: self.searchYear,
                      Status: self.searchStatus
                    }));
                  }
                },
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [50, 100, 200, 500],
                pageLength: 100,
                language: {
                  lengthMenu: "Display _MENU_"
                },
                order: [[0, "asc"], [2, "desc"]], // Sort by CCTR (asc), then Year (desc)
                columns: [{ data: "costCenterCode", className: "text-center", width: "15%" }, { data: "costCenterName", className: "text-center", width: "35%" }, { data: "year", className: "text-center", width: "15%" }, {
                  data: "modifiedDate",
                  className: "text-center",
                  width: "12%",
                  render: function render(data, type, full, meta) {
                    if (data) {
                      var d = new Date(data);
                      var day = String(d.getDate()).padStart(2, '0');
                      var month = String(d.getMonth() + 1).padStart(2, '0');
                      var year = d.getFullYear();
                      return day + "/" + month + "/" + year;
                    }
                    return "-";
                  }
                }, {
                  data: "isActive",
                  className: "text-center",
                  width: "13%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "id",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    // InActiveStatus: 0 = Active, 1 = Inactive
                    // isActive (from query): true = Active, false = Inactive
                    if (data.isActive) {
                      new StatusActionsTrue({ data: { data: data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
                    } else {
                      new StatusActionsFalse({ data: { data: data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
                    }
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new BudgetPlanActions({ data: { data: data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
                  }
                });
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    // เทียบแบบ case-insensitive — URL อาจเป็น /BudgetPlan/Monitoring หรือ /budgetplan/monitoring
    isHubRoute: function isHubRoute() {
      return this.$route.path.toLowerCase() === "/budgetplan/monitoring";
    }
  },
  data: function data() {
    return {
      cards: [{
        path: "/BudgetPlan/Monitoring/SendApprovalGroup",
        icon: "fas fa-envelope fa-3x text-primary",
        title: "Budget Plan — Email Monitoring",
        description: "ดู log การส่งอีเมลแจ้งเตือนผู้อนุมัติ + manual trigger"
      }, {
        path: "/BudgetPlan/Monitoring/BiSnapData",
        icon: "fas fa-database fa-3x text-success",
        title: "BI SnapData Monitoring",
        description: "ดู log การ snap ข้อมูลรายเดือนสำหรับ BI (BI_SnapDataLog)"
      }]
    };
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      filterMonthPeriod: "",
      filterStatus: "",
      logs: [],
      isLoading: false,
      isSendingNotify: false,
      notifyResult: null
    };
  },

  computed: {
    notifyAlertClass: function notifyAlertClass() {
      if (!this.notifyResult) return "";
      var level = this.notifyResult.level || this.notifyResult.Level;
      if (level === "ERROR") return "alert-danger";
      if (level === "WARN") return "alert-warning";
      var sent = this.notifyResult.notificationSent || this.notifyResult.NotificationSent;
      return sent ? "alert-success" : "alert-info";
    }
  },
  mounted: function mounted() {
    this.loadLogs();
  },

  methods: {
    loadLogs: function loadLogs() {
      var self = this;
      var params = {};
      if (self.filterMonthPeriod) params.monthPeriod = self.filterMonthPeriod;
      if (self.filterStatus) params.status = self.filterStatus;

      self.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BISnapData/Logs", { params: params }).then(function (response) {
        self.logs = response.data;
      }).catch(function (error) {
        console.error("Failed to load BI SnapData logs:", error);
      }).finally(function () {
        self.isLoading = false;
      });
    },
    sendNotifyEmail: function sendNotifyEmail() {
      var self = this;
      self.isSendingNotify = true;
      self.notifyResult = null;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Monitor/bi_snapdata_notify").then(function (response) {
        self.notifyResult = response.data;
      }).catch(function (error) {
        var data = error.response && error.response.data || {};
        self.notifyResult = {
          level: "ERROR",
          message: "เกิดข้อผิดพลาด: " + (data.message || data.Message || error.message),
          notificationSent: false
        };
      }).finally(function () {
        self.isSendingNotify = false;
      });
    },
    formatDateTime: function formatDateTime(dateStr) {
      if (!dateStr) return "-";
      var d = new Date(dateStr);
      return d.toLocaleDateString("th-TH") + " " + d.toLocaleTimeString("th-TH");
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      filterDate: "",
      filterStatus: "",
      logs: [],
      isSending: false,
      sendResult: null
    };
  },
  mounted: function mounted() {
    this.loadLogs();
  },

  methods: {
    loadLogs: function loadLogs() {
      var self = this;
      var params = {};
      if (self.filterDate) params.date = self.filterDate;
      if (self.filterStatus) params.status = self.filterStatus;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/ApprovalEmailLogs", { params: params }).then(function (response) {
        self.logs = response.data;
      }).catch(function (error) {
        console.error("Failed to load email logs:", error);
      });
    },
    triggerSend: function triggerSend() {
      var self = this;
      self.isSending = true;
      self.sendResult = null;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BudgetPlan/SendApprovalGroup").then(function (response) {
        self.sendResult = response.data;
        self.loadLogs();
      }).catch(function (error) {
        self.sendResult = {
          success: false,
          message: "เกิดข้อผิดพลาด: " + (error.response && error.response.data && error.response.data.message || error.message)
        };
      }).finally(function () {
        self.isSending = false;
      });
    },
    retryEmail: function retryEmail(logId) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BudgetPlan/RetryApprovalEmail/" + logId).then(function () {
        self.loadLogs();
      }).catch(function (error) {
        alert("Retry failed: " + error.message);
      });
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return "-";
      var d = new Date(dateStr);
      return d.toLocaleDateString("th-TH") + " " + d.toLocaleTimeString("th-TH");
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/**
 * ISS-45 (8 ต.ค. 2026) ช่อง "หมวดหมู่" ของการ์ด GL — select2 แบบ tags
 * แทน <datalist> ของ ISS-39 ซึ่ง Chrome กรองตัวเลือกด้วยค่าที่อยู่ในช่องเสมอ
 * (คลิกแล้วเห็นแค่ค่าที่เลือกอยู่) และวาด popup เป็นกล่องสีดำตามธีมเบราว์เซอร์
 * คงเงื่อนไขของ BA (QA BUG-12): เลือกจากหมวดหมู่ที่มีใน DB + พิมพ์ชื่อใหม่ได้
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: String,
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "เลือกหรือพิมพ์หมวดหมู่"
    }
  },
  mounted: function mounted() {
    this.init();
  },
  watch: {
    options: function options() {
      this.destroy();
      this.init();
    },
    value: function value(_value) {
      var $select = $(this.$refs.select);
      if (($select.val() || "") === (_value || "")) return;
      this.ensureOption(_value);
      $select.val(_value || null).trigger("change.select2");
    },
    disabled: function disabled(_disabled) {
      $(this.$refs.select).prop("disabled", _disabled);
    }
  },
  methods: {
    init: function init() {
      var self = this;
      var $select = $(self.$refs.select);

      // option ว่างตัวแรก — select2 ต้องมีถึงจะแสดง placeholder และล้างค่าได้
      $select.empty().append(new Option("", "", false, false));
      (self.options || []).forEach(function (name) {
        $select.append(new Option(name, name, false, false));
      });
      // ค่าที่บันทึกไว้แต่ไม่อยู่ในรายการ (เช่น หมวดหมู่ที่เพิ่งพิมพ์ใหม่) ต้องยังแสดงได้
      self.ensureOption(self.value);

      $select.select2({
        tags: true,
        width: "100%",
        placeholder: self.placeholder,
        allowClear: true,
        maximumInputLength: 200,
        createTag: function createTag(params) {
          var term = $.trim(params.term);
          return term ? { id: term, text: term, newTag: true } : null;
        }
      }).val(self.value || null).trigger("change.select2").on("change", function () {
        var selected = $select.val() || "";
        if (selected !== (self.value || "")) self.$emit("input", selected);
      });
    },
    ensureOption: function ensureOption(value) {
      if (!value) return;
      var $select = $(this.$refs.select);
      var exists = $select.find("option").filter(function () {
        return this.value === value;
      }).length > 0;
      if (!exists) $select.append(new Option(value, value, false, false));
    },
    destroy: function destroy() {
      var $select = $(this.$refs.select);
      if ($select.data("select2")) $select.off("change").select2("destroy");
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    return {
      searchCCTR: null,
      searchIO: null,
      searchGL: null,
      searchOrgCodes: [],

      // spec sheet 4: ช่องพิมพ์ — คั่นหลายค่าด้วย ',' (= OR ฝั่ง API)
      searchVendor: "",
      searchProductName: "",

      // เก็บเป็น moment (หรือ null) — bootstrap-datepicker ไม่ bind กับ v-model
      searchDateFrom: __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf("year"),
      searchDateTo: __WEBPACK_IMPORTED_MODULE_1_moment___default()(),

      cctrOptions: { placeholder: "ทั้งหมด", allowClear: true, data: [] },
      ioOptions: { placeholder: "ทั้งหมด", allowClear: true, data: [] },
      glOptions: { placeholder: "ทั้งหมด", allowClear: true, data: [] },
      orgOptions: { placeholder: "ทั้งหมด", allowClear: true, data: [] },

      headers: [],
      rows: [],
      // ISS-88: ลำดับจาก server = Vendor น้อย → มาก ("อื่นๆ" ท้ายสุด) จึงถือเป็น "asc" ตั้งต้น
      vendorSortDir: "asc",
      grandTotalLabel: "Grand Total",
      grandTotalQuantity: null,
      grandTotalAmount: 0,

      hasSearched: false,
      isLoading: false,
      isExporting: false,

      // กัน race condition ของ cascading dropdown (Design §4 SQ-02)
      dropdownSeq: 0
    };
  },
  computed: {
    /**
     * ISS-88: แถวที่แสดงตามทิศ sort ของคอลัมน์ Vendor
     *   แบ่งเป็นบล็อกต่อ Vendor (เริ่มที่แถว showVendor) แล้วสลับทั้งบล็อก — โครงสร้างภายใน Vendor
     *   (ชื่อสินค้า/กลุ่มราคา/ใบคืน/เส้นคั่น) คงเดิม · "อื่นๆ" อยู่ท้ายเสมอ · Grand Total อยู่นอก rows
     *   Excel ไม่ตาม (ใช้ลำดับเริ่มต้น · Q88-3)
     */
    displayRows: function displayRows() {
      if (this.vendorSortDir !== "desc") return this.rows;
      var blocks = [];
      this.rows.forEach(function (r, i) {
        if (i === 0 || r.showVendor) blocks.push([]);
        blocks[blocks.length - 1].push(r);
      });
      var isOther = function isOther(b) {
        return (b[0].vendor || "").indexOf("อื่นๆ") === 0;
      };
      var normal = blocks.filter(function (b) {
        return !isOther(b);
      }).reverse();
      var others = blocks.filter(isOther);
      return [].concat.apply([], normal.concat(others));
    }
  },
  watch: {
    // cascading: เปลี่ยน filter ใดก็โหลดตัวเลือกของช่องที่เหลือใหม่ (Q-C3)
    searchCCTR: function searchCCTR() {
      this.clearScopedFilters();
      this.loadDropdowns();
    },
    searchIO: function searchIO() {
      this.loadDropdowns();
    },
    searchGL: function searchGL() {
      this.loadDropdowns();
    },
    searchOrgCodes: function searchOrgCodes() {
      this.loadDropdowns();
    },
    searchDateFrom: function searchDateFrom() {
      this.loadDropdowns();
    },
    searchDateTo: function searchDateTo() {
      this.loadDropdowns();
    }
  },
  mounted: function mounted() {
    this.initDatepickers();
    this.loadDropdowns();
  },
  methods: {
    toggleVendorSort: function toggleVendorSort() {
      this.vendorSortDir = this.vendorSortDir === "asc" ? "desc" : "asc";
    },
    /**
     * ปฏิทิน — ใช้ bootstrap-datepicker แบบเดียวกับหน้าอื่นในระบบ
     * (เทียบแบบจาก Components/PM/SearchCheckIn.vue) · รูปแบบ dd/mm/yyyy
     * jQuery ไม่ bind กับ Vue model จึงต้องรับค่าผ่าน event changeDate เอง
     */
    initDatepickers: function initDatepickers() {
      var self = this;
      var arrows = KTUtil.isRTL() ? { leftArrow: '<i class="la la-angle-right"></i>', rightArrow: '<i class="la la-angle-left"></i>' } : { leftArrow: '<i class="la la-angle-left"></i>', rightArrow: '<i class="la la-angle-right"></i>' };

      var dpOptions = {
        autoclose: true,
        clearBtn: true,
        format: "dd/mm/yyyy",
        rtl: KTUtil.isRTL(),
        orientation: "bottom left",
        todayBtn: "linked",
        todayHighlight: true,
        templates: arrows
      };

      $(self.$refs.venDateFrom).datepicker(dpOptions).on("changeDate", function (e) {
        self.searchDateFrom = e.date ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(e.date) : null;
      });
      $(self.$refs.venDateTo).datepicker(dpOptions).on("changeDate", function (e) {
        self.searchDateTo = e.date ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(e.date) : null;
      });

      self.syncDatepickerInputs();
    },

    /** เขียนค่าใน data ลงช่องปฏิทิน (ใช้ตอน init และตอนล้างค่า) */
    syncDatepickerInputs: function syncDatepickerInputs() {
      var self = this;
      $(self.$refs.venDateFrom).datepicker("update", self.searchDateFrom ? self.searchDateFrom.format("DD/MM/YYYY") : "");
      $(self.$refs.venDateTo).datepicker("update", self.searchDateTo ? self.searchDateTo.format("DD/MM/YYYY") : "");
    },

    /**
     * 🔴 Shared/Select2.vue ผูก select2 ครั้งเดียวตอน mounted และ **ไม่มี watcher**
     * บน prop select2-options → ถ้าเราแค่เปลี่ยนค่าใน options ตัวเลือกจะไม่ขึ้นเลย
     * จึงต้องสั่ง re-init เอง (วิธีเดียวกับ BudgetPlanJobList.refreshSelect2Dropdown)
     */
    refreshSelect2: function refreshSelect2(elId, options) {
      var $select = $("#" + elId);
      if (!$select.length) return;

      var current = $select.val();

      if ($select.data("select2")) $select.select2("destroy");
      $select.empty();
      $select.append('<option value=""></option>');
      (options.data || []).forEach(function (item) {
        $select.append($("<option></option>").attr("value", item.id).text(item.text));
      });

      $select.select2({
        placeholder: options.placeholder,
        allowClear: options.allowClear
      });

      // คงค่าที่ผู้ใช้เลือกไว้ ถ้ายังอยู่ในตัวเลือกชุดใหม่
      var stillThere = current && (options.data || []).some(function (item) {
        return Array.isArray(current) ? current.indexOf(String(item.id)) >= 0 : String(item.id) === String(current);
      });
      $select.val(stillThere ? current : null).trigger("change.select2");
    },

    clearScopedFilters: function clearScopedFilters() {
      this.searchIO = null;
      this.searchGL = null;
      this.searchOrgCodes = [];
      $("#venIO").val(null).trigger("change");
      $("#venGL").val(null).trigger("change");
      $("#venOrg").val(null).trigger("change");
    },

    loadDropdowns: function loadDropdowns() {
      var self = this;
      var seq = ++self.dropdownSeq;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Report/Vendor/Dropdown", { params: self.buildParams() }).then(function (response) {
        // ทิ้ง response ที่ล้าสมัย (ผู้ใช้เปลี่ยน filter เร็วกว่า response กลับมา)
        if (seq !== self.dropdownSeq) return;
        if (!response.data || !response.data.success) {
          // ไม่เด้ง modal ขัดจังหวะผู้ใช้ แต่ต้องเห็นใน console
          // (ฝั่ง API log ไว้แล้วผ่าน BudgetActivityLog.LogError)
          console.warn("Failed to load vendor usage report dropdowns:", response.data && response.data.message || "unknown error");
          return;
        }

        var d = response.data.data;

        // แก้ค่าในที่เดิม แล้วสั่ง select2 สร้างตัวเลือกใหม่
        // (การสร้าง object ใหม่ด้วย Object.assign ไม่มีผล เพราะ Select2.vue ไม่ watch prop นี้)
        self.cctrOptions.data = (d.cctrs || []).map(self.toOption);
        self.ioOptions.data = (d.ios || []).map(self.toOption);
        self.glOptions.data = (d.gls || []).map(self.toOption);
        self.orgOptions.data = (d.orgs || []).map(self.toOption);

        self.refreshSelect2("venCCTR", self.cctrOptions);
        self.refreshSelect2("venIO", self.ioOptions);
        self.refreshSelect2("venGL", self.glOptions);
        self.refreshSelect2("venOrg", self.orgOptions);
      }).catch(function (error) {
        console.error("Failed to load vendor usage report dropdowns:", error);
      });
    },

    toOption: function toOption(item) {
      return { id: item.code, text: item.text };
    },

    buildParams: function buildParams() {
      var params = {};
      if (this.searchCCTR) params.cctrCode = this.searchCCTR;
      if (this.searchIO) params.ioCode = this.searchIO;
      if (this.searchGL) params.glCode = this.searchGL;
      if (this.searchOrgCodes && this.searchOrgCodes.length > 0) {
        params.orgCodes = this.searchOrgCodes.join(",");
      }
      if (this.searchVendor && this.searchVendor.trim()) {
        params.vendorSearch = this.searchVendor.trim();
      }
      if (this.searchProductName && this.searchProductName.trim()) {
        params.productName = this.searchProductName.trim();
      }
      // API รับได้ทั้ง yyyy-MM-dd และ dd/MM/yyyy (ParseReportDate)
      if (this.searchDateFrom) params.dateFrom = this.searchDateFrom.format("DD/MM/YYYY");
      if (this.searchDateTo) params.dateTo = this.searchDateTo.format("DD/MM/YYYY");
      return params;
    },

    validate: function validate() {
      // CCTR ไม่บังคับแล้ว — spec sheet 4 ไม่ได้ระบุว่าเป็น required (ISS-06)
      // ISS-98 (ผู้ใช้สั่ง 23 ต.ค. 2026): ข้อความ/ลำดับเดียวกับ BudgetDateRangeRule.ValidateVendorReport ฝั่ง API
      //   ไม่กรอกทั้ง 2 ช่อง = ค้นหาได้ทุกปีเหมือนเดิม
      var from = this.searchDateFrom;
      var to = this.searchDateTo;
      var message = null;
      if (!!from !== !!to) {
        message = "โปรดระบุช่วงวันที่(เริ่มต้น)และวันที่(สิ้นสุด)ของปีงบประมาณที่ต้องการค้นหา";
      } else if (from && from.year() !== to.year()) {
        message = "โปรดระบุช่วงวันที่ภายในปีงบประมาณใดงบประมาณหนึ่งเท่านั้น";
      } else if (from && from.isAfter(to, "day")) {
        message = "วันที่(เริ่มต้น) ต้องไม่มากกว่าวันที่(สิ้นสุด)";
      }
      if (message) {
        Swal.fire("ไม่สามารถทำรายการได้", message, "warning");
        return false;
      }
      return true;
    },

    search: function search() {
      var self = this;
      if (!self.validate()) return;

      self.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/Report/Vendor", { params: self.buildParams() }).then(function (response) {
        if (!response.data || !response.data.success) {
          Swal.fire("เกิดข้อผิดพลาด", response.data && response.data.message || "ไม่สามารถดึงข้อมูลได้", "error");
          return;
        }
        var d = response.data.data;
        self.headers = d.headers || [];
        self.rows = d.rows || [];
        self.vendorSortDir = "asc";
        self.grandTotalLabel = d.grandTotalLabel || "Grand Total";
        self.grandTotalQuantity = d.grandTotalQuantity;
        self.grandTotalAmount = d.grandTotalAmount || 0;
        self.hasSearched = true;
      }).catch(function (error) {
        console.error("Failed to load vendor usage report:", error);
        var message = error.response && error.response.data && error.response.data.message || "ไม่สามารถดึงข้อมูลรายงานได้";
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      }).finally(function () {
        self.isLoading = false;
      });
    },

    resetForm: function resetForm() {
      this.searchCCTR = null;
      $("#venCCTR").val(null).trigger("change");
      this.clearScopedFilters();

      this.searchVendor = "";
      this.searchProductName = "";

      this.searchDateFrom = __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf("year");
      this.searchDateTo = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
      this.syncDatepickerInputs();

      this.headers = [];
      this.rows = [];
      this.grandTotalQuantity = null;
      this.grandTotalAmount = 0;
      this.hasSearched = false;

      this.loadDropdowns();
    },

    exportExcel: function exportExcel() {
      var self = this;
      if (!self.validate()) return;

      self.isExporting = true;

      var params = new URLSearchParams();
      var p = self.buildParams();
      Object.keys(p).forEach(function (k) {
        params.append(k, p[k]);
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetPlan/ExportVendorUsage?" + params.toString(), {
        headers: { Authorization: "Bearer " + self.$root.user.access_token },
        responseType: "blob"
      }).then(function (response) {
        var filename = "VendorUsage_" + self.searchCCTR + ".xlsx";
        var contentDisposition = response.headers["content-disposition"];
        if (contentDisposition) {
          var match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match && match[1]) {
            filename = decodeURIComponent(match[1].replace(/['"]/g, ""));
          }
        }

        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(link.href);

        Swal.fire("สำเร็จ", "Export รายงานตาม Vendor เรียบร้อยแล้ว", "success");
      }).catch(function (error) {
        console.error("Error exporting vendor usage report:", error);
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถ Export ข้อมูลได้", "error");
      }).finally(function () {
        self.isExporting = false;
      });
    },

    // ---------- formatters (ให้ตรงกับ number format ของไฟล์ Excel) ----------
    // ISS-25 (1 ต.ค. 2026): ค่าลบใช้เครื่องหมาย "-" ไม่ใช่วงเล็บ ให้ตรงกับ
    // number format ของไฟล์ Excel ที่เปลี่ยนไปตั้งแต่ ISS-18d — สีแดงทำที่ markup
    fmtAccounting: function fmtAccounting(value) {
      if (value === null || value === undefined || value === "") return "";
      var n = Number(value);
      if (isNaN(n)) return "";
      if (n === 0) return "-";
      var text = Math.abs(n).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return n < 0 ? "-" + text : text;
    },

    // "จำนวน" ไม่บังคับทศนิยม — เอกสารที่ไม่ระบุจำนวนต้องเว้นว่าง (ไม่ใช่ 0)
    fmtQuantity: function fmtQuantity(value) {
      if (value === null || value === undefined || value === "") return "";
      var n = Number(value);
      if (isNaN(n)) return "";
      if (n === 0) return "-";
      var text = Math.abs(n).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      return n < 0 ? "-" + text : text;
    },

    // true = ค่านี้ติดลบ (ISS-25)
    isNegative: function isNegative(value) {
      if (value === null || value === undefined || value === "") return false;
      var n = Number(value);
      return !isNaN(n) && n < 0;
    },

    // ISS-28: แถวรายการติดลบ -> ตัวเลขทั้งแถวเป็นสีแดง
    // ไม่ใช่เฉพาะช่องที่ค่าติดลบ เพราะราคาต่อหน่วยเป็นบวกแต่อยู่ในรายการคืนเงินเดียวกัน
    isNegativeRow: function isNegativeRow(r) {
      if (!r) return false;
      return this.isNegative(r.quantity) || this.isNegative(r.amount);
    }
  }
});

// yyyy-MM-dd ตาม local time (ห้ามใช้ toISOString เพราะจะเลื่อนวันตาม timezone)

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var result, returnToUrl;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.$root.mgr.signinRedirectCallback();

            case 3:
              result = _context.sent;
              returnToUrl = "/";

              if (result.state !== undefined) {

                returnToUrl = result.state;
              }
              _this.$router.push({ path: returnToUrl });
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

              _this.$router.push({ name: "Unauthorized" });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 9]]);
    }))();
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Treeselect: __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default.a },
  data: function data() {
    var now = new Date();
    return {
      // Permission
      isSuperAdmin: false,

      // Filter
      selectedAgents: null,
      agentOptions: [],
      selectedYear: now.getFullYear(),
      selectedMonth: now.getMonth() + 1,

      // All agents data from API
      dashboardData: [],

      monthsTH: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
      monthsTH_Full: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
      monthsEN: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],

      // Chart instances
      chartInstances: [],

      // Remark modal
      remarkModal: { monthName: "", text: "" }
    };
  },
  computed: {
    chartAgents: function chartAgents() {
      if (this.dashboardData.length === 0) {
        return [{ agentCode: "", agentName: "", _empty: true }];
      }
      return this.dashboardData;
    },
    displayThaiMonth: function displayThaiMonth() {
      return this.monthsTH_Full[this.selectedMonth - 1] + " " + this.selectedYear;
    }
  },
  watch: {
    selectedAgents: function selectedAgents() {
      this.loadDashboardData();
    },
    selectedYear: function selectedYear() {
      this.loadDashboardData();
    },
    selectedMonth: function selectedMonth() {
      this.$nextTick(function () {
        this.renderCharts();
      }.bind(this));
    }
  },
  methods: {
    checkPermission: function checkPermission() {
      this.isSuperAdmin = this.$root.canShow(["super_admin"]);
    },
    clearSelectedAgents: function clearSelectedAgents() {
      this.selectedAgents = null;
    },
    loadAgentOptions: function loadAgentOptions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/AgentScore/AgentScoreDashboardAgentList", {});

              case 3:
                res = _context.sent;

                if (res.data && Array.isArray(res.data)) {
                  _this.agentOptions = res.data.map(function (item) {
                    return { id: item.id, label: item.text };
                  });
                }
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.error("loadAgentOptions error:", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    loadDashboardData: function loadDashboardData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res, apiData, existingCodes, self;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(!_this2.selectedAgents || _this2.selectedAgents.length === 0)) {
                  _context2.next = 5;
                  break;
                }

                _this2.dashboardData = [];
                _this2.$nextTick(function () {
                  this.renderCharts();
                }.bind(_this2));
                return _context2.abrupt("return");

              case 5:
                params = { Year: _this2.selectedYear, Month: _this2.selectedMonth };

                if (_this2.selectedAgents && _this2.selectedAgents.length > 0) {
                  params.AgentCodeSap = _this2.selectedAgents;
                }
                _context2.next = 9;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/AgentScore/AgentScoreDashboard", params);

              case 9:
                res = _context2.sent;
                apiData = res.data && Array.isArray(res.data) ? res.data : [];

                // เติม agent ที่เลือกแต่ไม่มีข้อมูลจาก API ให้แสดงเป็น 0

                if (_this2.selectedAgents && _this2.selectedAgents.length > 0) {
                  existingCodes = apiData.map(function (d) {
                    return d.agentCode;
                  });
                  self = _this2;

                  _this2.selectedAgents.forEach(function (code) {
                    if (existingCodes.indexOf(code) === -1) {
                      var opt = self.agentOptions.find(function (o) {
                        return o.id === code;
                      });
                      var agentName = opt ? opt.label.replace(code + " - ", "") : "";
                      apiData.push({
                        agentCode: code,
                        agentName: agentName,
                        syS_JAN: null, syS_FEB: null, syS_MAR: null, syS_APR: null,
                        syS_MAY: null, syS_JUN: null, syS_JUL: null, syS_AUG: null,
                        syS_SEP: null, syS_OCT: null, syS_NOV: null, syS_DEC: null,
                        maC_JAN: null, maC_FEB: null, maC_MAR: null, maC_APR: null,
                        maC_MAY: null, maC_JUN: null, maC_JUL: null, maC_AUG: null,
                        maC_SEP: null, maC_OCT: null, maC_NOV: null, maC_DEC: null
                      });
                    }
                  });
                }

                _this2.dashboardData = apiData;
                _this2.$nextTick(function () {
                  this.renderCharts();
                }.bind(_this2));
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](0);

                console.error("loadDashboardData error:", _context2.t0);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 16]]);
      }))();
    },
    extractSysScores: function extractSysScores(item) {
      return [item.syS_JAN, item.syS_FEB, item.syS_MAR, item.syS_APR, item.syS_MAY, item.syS_JUN, item.syS_JUL, item.syS_AUG, item.syS_SEP, item.syS_OCT, item.syS_NOV, item.syS_DEC];
    },
    extractMacScores: function extractMacScores(item) {
      return [item.maC_JAN, item.maC_FEB, item.maC_MAR, item.maC_APR, item.maC_MAY, item.maC_JUN, item.maC_JUL, item.maC_AUG, item.maC_SEP, item.maC_OCT, item.maC_NOV, item.maC_DEC];
    },
    getAgentScores: function getAgentScores(agent, type) {
      if (agent._empty) return [null, null, null, null, null, null, null, null, null, null, null, null];
      var scores = type === "SYS" ? this.extractSysScores(agent) : this.extractMacScores(agent);
      var maxMonth = this.selectedMonth;
      return scores.map(function (s, i) {
        return i < maxMonth ? s : null;
      });
    },
    getScoreBoxValue: function getScoreBoxValue(agent, type) {
      if (agent._empty) return "-";
      var scores = this.getAgentScores(agent, type);
      for (var i = scores.length - 1; i >= 0; i--) {
        if (scores[i] !== null && scores[i] !== undefined) return scores[i];
      }
      return "-";
    },
    extractSysRemarks: function extractSysRemarks(item) {
      return [item.syS_JAN_Remark, item.syS_FEB_Remark, item.syS_MAR_Remark, item.syS_APR_Remark, item.syS_MAY_Remark, item.syS_JUN_Remark, item.syS_JUL_Remark, item.syS_AUG_Remark, item.syS_SEP_Remark, item.syS_OCT_Remark, item.syS_NOV_Remark, item.syS_DEC_Remark];
    },
    extractMacRemarks: function extractMacRemarks(item) {
      return [item.maC_JAN_Remark, item.maC_FEB_Remark, item.maC_MAR_Remark, item.maC_APR_Remark, item.maC_MAY_Remark, item.maC_JUN_Remark, item.maC_JUL_Remark, item.maC_AUG_Remark, item.maC_SEP_Remark, item.maC_OCT_Remark, item.maC_NOV_Remark, item.maC_DEC_Remark];
    },
    getAgentRemarks: function getAgentRemarks(agent, type) {
      if (agent._empty) return [null, null, null, null, null, null, null, null, null, null, null, null];
      var remarks = type === "SYS" ? this.extractSysRemarks(agent) : this.extractMacRemarks(agent);
      var maxMonth = this.selectedMonth;
      return remarks.map(function (r, i) {
        return i < maxMonth ? r || null : null;
      });
    },
    hasRemarks: function hasRemarks(agent, type) {
      if (agent._empty) return false;
      var remarks = this.getAgentRemarks(agent, type);
      return remarks.some(function (r) {
        return r !== null;
      });
    },
    openRemarkModal: function openRemarkModal(agent, type, monthIdx) {
      var remarks = this.getAgentRemarks(agent, type);
      this.remarkModal = {
        monthName: this.monthsTH_Full[monthIdx] + " " + this.selectedYear,
        text: remarks[monthIdx] || ""
      };
      $("#remarkModal").modal("show");
    },
    getAgentLabel: function getAgentLabel(agent) {
      if (agent._empty) return "";
      return (agent.agentCode || "") + " " + (agent.agentName || "");
    },
    destroyCharts: function destroyCharts() {
      for (var i = 0; i < this.chartInstances.length; i++) {
        if (this.chartInstances[i].recording) this.chartInstances[i].recording.destroy();
        if (this.chartInstances[i].keg) this.chartInstances[i].keg.destroy();
      }
      this.chartInstances = [];
    },
    renderCharts: function renderCharts() {
      this.destroyCharts();

      __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults.global.defaultFontFamily = "'Noto Sans Thai UI', sans-serif";

      var self = this;
      var agents = this.chartAgents;

      var chartOptions = {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            ticks: { min: 0, max: 50, stepSize: 10 }
          }]
        },
        legend: { display: false },
        animation: {
          onComplete: function onComplete() {
            var ctx = this.chart.ctx;
            ctx.font = "bold 11px Noto Sans Thai UI";
            ctx.textAlign = "center";
            ctx.textBaseline = "bottom";
            this.data.datasets.forEach(function (dataset) {
              var meta = dataset._meta[Object.keys(dataset._meta)[0]];
              meta.data.forEach(function (element, index) {
                var value = dataset.data[index];
                if (value !== null && value !== undefined) {
                  ctx.fillStyle = value >= 40 ? "#0abb87" : "#fd397a";
                  ctx.fillText(value, element._model.x, element._model.y - 6);
                }
              });
            });
          }
        }
      };

      for (var i = 0; i < agents.length; i++) {
        var agent = agents[i];
        var kegCanvas = document.getElementById("kegChart-" + i);
        var recordingCanvas = document.getElementById("recordingChart-" + i);
        if (!kegCanvas || !recordingCanvas) continue;

        var macScores = self.getAgentScores(agent, "MAC");
        var sysScores = self.getAgentScores(agent, "SYS");

        var kegInstance = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(kegCanvas, {
          type: "line",
          data: {
            labels: self.monthsTH,
            datasets: [{
              label: "คะแนนการบริหารถัง",
              data: macScores,
              borderColor: "#0abb87",
              backgroundColor: "rgba(10, 187, 135, 0.1)",
              borderWidth: 2,
              pointRadius: 4,
              pointBackgroundColor: "#0abb87",
              fill: true
            }]
          },
          options: chartOptions
        });

        var recordingInstance = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(recordingCanvas, {
          type: "line",
          data: {
            labels: self.monthsTH,
            datasets: [{
              label: "คะแนนความครบถ้วนของการบันทึกข้อมูล",
              data: sysScores,
              borderColor: "#5867dd",
              backgroundColor: "rgba(88, 103, 221, 0.1)",
              borderWidth: 2,
              pointRadius: 4,
              pointBackgroundColor: "#5867dd",
              fill: true
            }]
          },
          options: chartOptions
        });

        self.chartInstances.push({ recording: recordingInstance, keg: kegInstance });
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, arrows;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this3.checkPermission();

              // Year datepicker (calendar year-only)
              self = _this3;
              arrows = {
                leftArrow: '<i class="la la-angle-left"></i>',
                rightArrow: '<i class="la la-angle-right"></i>'
              };

              $(self.$refs.odYear).datepicker({
                format: "yyyy",
                viewMode: "years",
                minViewMode: "years",
                autoclose: true,
                clearBtn: true,
                orientation: "bottom left",
                templates: arrows
              }).on("changeDate", function (e) {
                if (e.date) {
                  self.selectedYear = e.date.getFullYear();
                }
              });
              $(self.$refs.odYear).datepicker("setDate", new Date(self.selectedYear, 0, 1));

              _context3.next = 7;
              return _this3.loadAgentOptions();

            case 7:
              if (_this3.agentOptions.length > 0) {
                _this3.selectedAgents = [_this3.agentOptions[0].id];
              }
              _context3.next = 10;
              return _this3.loadDashboardData();

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyCharts();
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      mbpAgent: null,
      dashboardURL: '/dbs-sit-dashboard/',
      showDashboard: false // ใช้สำหรับควบคุมการแสดง iframe แบบ lazy
    };
  },
  methods: {},
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, domain_origin, iframURL;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              // รอ 1.5 วินาที ก่อนแสดง iframe เพื่อลดโอกาสเกิด race condition

              if (_this.$root.canShow(['super_admin'])) {
                _this.showDashboard = true;

                domain_origin = window.location.origin;

                if (domain_origin.indexOf("dbs.boonrawd.co.th") > -1) {
                  self.dashboardURL = "/dbs-dashboard/";
                }
                iframURL = domain_origin + "" + self.dashboardURL;


                setTimeout(function () {
                  $("#ifdashboard").attr("src", iframURL);
                }, 500);
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  beforeMount: function beforeMount() {
    if (this.$route.meta.defaultChild) {
      this.$router.push(this.$route.path + "/" + this.$route.meta.defaultChild);
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.$route.meta.defaultChild) {
      this.$router.push(this.$route.path + "/" + this.$route.meta.defaultChild);
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JobAddSpareUsedList_vue__ = __webpack_require__(1213);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        sparePartUsedList: __WEBPACK_IMPORTED_MODULE_2__JobAddSpareUsedList_vue__["a" /* default */]
    },
    data: function data() {
        return {
            uuid: "",
            job: {},
            isEditable: null,
            jobNumber: null,
            jobTypeName: null,
            jobStatus: null,
            items: [],
            isSpareAdded: false,
            selectedBarcode: {},
            selectedGroup: {},
            jobSparePartUsedList: [] // for send data to save
        };
    },
    methods: {
        formSubmit: function formSubmit(e) {
            e.preventDefault();
        },

        openSparePartModal: function openSparePartModal(group, barcode) {
            this.selectedBarcode = barcode;
            this.selectedGroup = group;
            this.$refs.sparePartUsedList.open(barcode);
        },
        handleSparePartSave: function handleSparePartSave(updatedList) {
            // อัปเดตรายการอะไหล่ของ barcode ที่เลือก
            console.log("BarcodeNo : " + this.selectedBarcode.barcodeNoOld);

            this.selectedBarcode.sparePartUsedItems = []; // reset spare used before add new.
            var sumSpareUsedQty = 0;

            //=== must filter only qty != 0
            for (var i = 0; i < updatedList.length; i++) {
                var item = updatedList[i];

                if (item.qty != 0) {
                    if (this.selectedBarcode.barcodeId == 0) {
                        // Case : No have barcode
                        sumSpareUsedQty += item.qty;
                    }
                    this.selectedBarcode.sparePartUsedItems.push({

                        //jobSparePartUsedId: 0,
                        jobId: this.job.jobId,
                        jobItemId: this.selectedGroup.jobItemId,
                        repairMaterialCode: this.selectedBarcode.materialCode,
                        barcodeId: this.selectedBarcode.barcodeId,
                        spareMaterialCode: item.materialCode,
                        spareUsedQty: item.qty
                    });
                }
            }
            if (this.selectedBarcode.barcodeId == 0) this.selectedBarcode.barcodeNoOld = sumSpareUsedQty; // To show sum QTY case No have barcode.
        },
        showModal: function showModal(jobData) {
            var self = this;
            self.items = []; // reset array
            // Find JobItem then push to items[]

            // set isSpareAdded from job
            self.isSpareAdded = jobData.isSpareAdded;

            var url = "/Api/Jobs/FindJobItem/?id=" + jobData.jobId;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
                if (response.status == 200) {
                    var data = response.data;
                    self.isEditable = data.isEditable;
                    self.jobNumber = data.jobNumber;
                    self.jobTypeName = data.jobTypeName;
                    self.jobStatus = data.jobStatus;

                    for (var i = 0; i < data.items.length; i++) {
                        var item = data.items[i];

                        //=== must filter only qty != 0
                        //for (let j = 0; j < item.barcodeSpareUseds.length; j++) {
                        //    let barcodeItem = item.barcodeSpareUseds[j];
                        //    // Set QTY for No have Barode
                        //    if (barcodeItem.barcodeId == 0) { 
                        //        let sumSpareUsedQty = 0;
                        //        for (let k = 0; k < barcodeItem.sparePartUsedItems.length; k++) {
                        //            let usedItem = barcodeItem.sparePartUsedItems[k];
                        //            sumSpareUsedQty += usedItem.spareUsedQty;
                        //        }
                        //        barcodeItem.barcodeNoOld = sumSpareUsedQty;
                        //    }
                        //}
                        item.barcodeSpareUseds.forEach(function (barcodeItem) {
                            if (barcodeItem.barcodeId === 0) {
                                barcodeItem.barcodeNoOld = barcodeItem.sparePartUsedItems.reduce(function (sum, usedItem) {
                                    return sum + (usedItem.spareUsedQty || 0);
                                }, 0);
                            }
                        });

                        self.items.push({
                            jobItemId: item.jobItemId,
                            materialCode: item.materialCode,
                            materialName: item.materialName,
                            description: item.description,
                            quantity: item.quantity,
                            checkedQuantity: item.checkedQuantity,
                            unitName: item.baseUnit,
                            hasBarcode: item.hasBarcode,
                            isDisabled: item.isDisabled,
                            barcodes: item.barcodes,
                            barcodeSpareUseds: item.barcodeSpareUseds
                        });
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลลูกค้าที่คุณเลือก", "warning");
                    KTApp.unblockPage();
                }
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
                KTApp.unblockPage();
            }).then(function () {
                // always executed
                KTApp.unblockPage();
            });
        },

        btnAddSpareParts: function btnAddSpareParts() {
            var _this = this;

            var self = this;

            //=== Prepare jobSparePartUsedList
            this.jobSparePartUsedList = []; // reset list

            // loop set spare used item
            // items -> barcodeSpareUseds -> sparePartUsedItems
            this.items.forEach(function (item) {
                if (item.barcodeSpareUseds && item.barcodeSpareUseds.length > 0) {
                    item.barcodeSpareUseds.forEach(function (used) {
                        if (used.sparePartUsedItems && used.sparePartUsedItems.length > 0) {
                            used.sparePartUsedItems.forEach(function (spare) {
                                _this.jobSparePartUsedList.push(spare);
                            });
                        }
                    });
                }
            });

            console.log("รวมทั้งหมด:", this.jobSparePartUsedList.length, "รายการ");
            console.table(this.jobSparePartUsedList);

            // -- Begin Add Spare
            KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
            });
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Jobs/AddSpareParts", {
                jobId: self.job.jobId,
                isSpareAdded: self.isSpareAdded, // self.job.isSpareAdded,
                jobSparePartUsedList: self.jobSparePartUsedList
            }).then(function (response) {
                if (response.data.status) {

                    // set isSpareAdded back to jobData if success
                    self.job.isSpareAdded = self.isSpareAdded;

                    __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire("สำเร็จ", response.data.message, "success");
                    self.$parent.reloadDataTable();
                    $(self.$el).modal("hide");
                } else {
                    var msg = response.data.message;

                    __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
                        title: "เกิดข้อผิดพลาด",
                        html: msg,
                        type: "error",
                        showCancelButton: true,
                        confirmButtonText: "<i class='fa fa-archive'></i> ฉันต้องการปิดใบงานนี้",
                        cancelButtonText: "ตรวจสอบข้อมูล"
                    }).then(function (result) {
                        if (result.value) {
                            self.commitJob(true);
                        }
                    });
                }
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }).then(function () {
                // always executed
                KTApp.unblockPage();
            });
            // -- End Commit Job
        },

        getBarcodeHeader: function getBarcodeHeader(group) {
            if (!group.barcodeSpareUseds || group.barcodeSpareUseds.length === 0) return 'Barcode';
            return group.barcodeSpareUseds[0].barcodeId === 0 ? 'จำนวน' : 'Barcode';
        }
    },
    mounted: function mounted() {
        var self = this;
        self.uuid = self.$uuid.v1();

        $(self.$refs.modal).on("hidden.bs.modal", function () {
            self.uuid = self.$uuid.v1();
            self.job = {};
        });
    }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        //barcode: Object,
        //spareParts: Array,
        //selectedBarcode:null
    },
    data: function data() {
        return {
            masterProductSpareList: [], // loaded from API
            selectedBarcode: null
        };
    },
    methods: {
        validateUInt: function validateUInt(part) {
            // ถ้าเป็น NaN หรือ < 0 ให้กลับไปเป็น 0
            if (part.qty === '' || part.qty === null || isNaN(part.qty) || part.qty < 0) {
                part.qty = 0;
            }
            // ตัดทศนิยมออก (force uint)
            part.qty = Math.floor(part.qty);
        },
        open: function open(barcode) {
            var _this = this;

            this.selectedBarcode = barcode;
            this.fetchMasterProductSpareList(); // โหลด list ทุกครั้งที่เปิด

            //this.updateMasterQtyFromSelectedBarcode(); // sync qty จาก used items

            this.$nextTick(function () {
                //$(this.$refs.modalRoot).modal('show');
                $(_this.$refs.modalRoot).modal({
                    backdrop: 'static',
                    keyboard: false
                });
            });
        },
        fetchMasterProductSpareList: function fetchMasterProductSpareList() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var url;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                try {
                                    url = "/Api/Jobs/GetSupplierSpare";

                                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
                                        if (response.status == 200) {
                                            _this2.masterProductSpareList = response.data;

                                            // Update Qty from spareUsed
                                            _this2.updateMasterQtyFromSelectedBarcode();

                                            //console.log("supplier spare data : "+response.data.length);
                                        } else {
                                            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลอะไหล่ซัพพลายเออร์", "warning");
                                            KTApp.unblockPage();
                                        }
                                    }).catch(function (error) {
                                        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
                                        KTApp.unblockPage();
                                    }).then(function () {
                                        // always executed
                                        KTApp.unblockPage();
                                    });
                                } catch (error) {
                                    console.error('โหลดข้อมูล master ล้มเหลว:', error);
                                }

                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        updateMasterQtyFromSelectedBarcode: function updateMasterQtyFromSelectedBarcode() {
            var usedItems = this.selectedBarcode && this.selectedBarcode.sparePartUsedItems || [];

            //console.log("UsedItems : " + usedItems.length);
            //usedItems.forEach(used => {
            //    console.log(" Used:" + used.spareMaterialCode + ", qty " + used.spareUsedQty);
            //});

            //this.masterProductSpareList.forEach(master => {
            //     //const matched = usedItems.find(item => item.spareMaterialCode === master.materialCode);
            //     //usedItems.forEach(used => {
            //         console.log("master:" + master.materialCode);
            //     //});
            //     //master.qty = matched ? matched.spareUsedQty : 0;
            //});

            //=== start set qty ===
            this.masterProductSpareList.forEach(function (master) {
                //console.log("master:", master.materialCode);
                var matched = usedItems.find(function (item) {
                    return String(item.spareMaterialCode).trim() === String(master.materialCode).trim();
                });

                master.qty = matched ? matched.spareUsedQty : 0;
            });
        },
        save: function save() {
            this.$emit('save', this.masterProductSpareList); // ส่งค่ากลับให้ parent
            $(this.$refs.modalRoot).modal('hide');
        },
        close: function close() {
            this.$emit('close');
            $(this.$refs.modalRoot).modal('hide');
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            // เมื่อปิด Sub-Modal ให้คืน scroll ให้ Modal แม่
                            $(_this3.$refs.modalRoot).on('hidden.bs.modal', function () {
                                if ($('.modal.show').length > 0) {
                                    $('body').addClass('modal-open');
                                }
                            });

                        case 1:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this3);
        }))();
    }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JobCNItemRow__ = __webpack_require__(1215);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    jobCnItemRow: __WEBPACK_IMPORTED_MODULE_3__JobCNItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      jobNumber: null,
      cnFormBarcode: null,
      cnFormMaterialCode: [],
      cnFormOriginPlant: [],
      cnFormDestinationAgent: [],
      cnFormCNStatus: [],
      cnFormCNToAgent: [],
      jobCNItems: [],
      cnRemark: null,
      maxLength: 350,
      cnFormMaterialCodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cnFormOriginPlantOptions: {
        placeholder: "กรุณาเลือกคลังสินค้าที่จ่ายออก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Plant/PlantOptions",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cnFormDestinationAgentOptions: {
        placeholder: "กรุณาเลือกตัวแทนฯที่ได้รับจากคลังสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cnFormCNStatusOptions: {
        placeholder: "กรุณาเลือกการคืน",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "CN_STATUS",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cnFormCNToAgentOptions: {
        placeholder: "กรุณาเลือกระบบ CN ให้(ตัวแทนฯ)",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  methods: {
    formSubmit: function formSubmit(e) {
      //e.preventDefault();

      var self = this;
      var router = this.$router;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่..."
      });

      var cnItems = [];
      self.jobCNItems.forEach(function (element) {
        if (element.cnToAgentCode2 == "") {
          element.cnToAgentCode2 = null;
        }
        cnItems.push({
          Id: element.id,
          OriginPlantCode2: element.originPlantCode2,
          DestinationAgentCode2: element.destinationAgentCode2,
          CNToAgentCode2: element.cnToAgentCode2
        });
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "put",
        url: "/Api/JobsCN/UpdateJobCN",
        data: {
          jobId: this.$route.params.id,
          isConfirm: false,
          obj: cnItems,
          cnRemark: self.cnRemark
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", "บันทึกข้อมูล CN ของใบงานสำเร็จ", "success").then(function () {
            //router.go(-1), self.$parent.reloadDataTable(false);
            self.getJobCN(e);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    formSubmitConfirm: function formSubmitConfirm(e) {
      var _this = this;

      //e.preventDefault();

      var self = this;
      var router = this.$router;

      var cnItems = [];
      self.jobCNItems.forEach(function (element) {
        cnItems.push({
          Id: element.id,
          OriginPlantCode2: element.originPlantCode2,
          DestinationAgentCode2: element.destinationAgentCode2,
          CNToAgentCode2: element.cnToAgentCode2 || null
        });
      });

      Swal.fire({
        title: "ต้องการยืนยันข้อมูล CN ใช่หรือไม่ ?",
        type: "warning",
        html: "เมื่อยืนยันข้อมูล CN จะไม่สามารถ แก้ไขข้อมูลในภายหลังได้ <strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default()({
            method: "put",
            url: "/Api/JobsCN/UpdateJobCN",
            data: {
              jobId: _this.$route.params.id,
              isConfirm: true,
              obj: cnItems
            }
          }).then(function (response) {
            if (response.data.status) {
              Swal.fire("สำเร็จ", "ยืนยันข้อมูล CN ของใบงานสำเร็จ", "success").then(function () {
                router.go(-1), self.$parent.reloadDataTable(false);
              });
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    getJobCN: function getJobCN(e) {
      e.preventDefault();

      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      self.jobCNItems = [];

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/JobsCN/GetJobCN",
        data: {
          jobId: this.$route.params.id,
          barcode: self.cnFormBarcode,
          materialCode: self.cnFormMaterialCode,
          originPlant: self.cnFormOriginPlant,
          destinationAgent: self.cnFormDestinationAgent,
          status: self.cnFormCNStatus,
          toAgent: self.cnFormCNToAgent
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data;
          self.jobNumber = data.jobNumber;
          self.cnRemark = data.cnRemark;
          self.jobCNItems = data.items;

          if (response.data.items.length > 0) {
            var _loop = function _loop(i) {
              item = response.data.items[i];


              setTimeout(function () {
                if (self.jobCNItems[i].cnToAgentCode2 !== null) {
                  self.$refs.jobCNItems[i].$refs.cnToAgentCode2.setSelectedData({
                    id: response.data.items[i].cnToAgentCode2,
                    text: "[ " + response.data.items[i].cnToAgentCode2 + " ] " + response.data.items[i].cnToAgentName2
                  });
                }

                if (self.jobCNItems[i].originPlantCode2 !== null) {
                  self.$refs.jobCNItems[i].$refs.originPlantCode2.setSelectedData({
                    id: response.data.items[i].originPlantCode2,
                    text: "[ " + response.data.items[i].originPlantCode2 + " ] " + response.data.items[i].originPlantName2
                  });
                }
                //default โรงงานที่ส่งออก
                else if (self.jobCNItems[i].originPlantCode !== null) {
                    self.jobCNItems[i].originPlantCode2 = self.jobCNItems[i].originPlantCode;

                    self.$refs.jobCNItems[i].$refs.originPlantCode2.setSelectedData({
                      id: response.data.items[i].originPlantCode,
                      text: "[ " + response.data.items[i].originPlantCode + " ] " + response.data.items[i].originPlantName
                    });
                  }
              }, 50);
            };

            for (var i = 0; i < response.data.items.length; i++) {
              var item;

              _loop(i);
            }
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
          KTApp.unblockPage();
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
        KTApp.unblockPage();
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    getJobCNReset: function getJobCNReset(e) {
      var self = this;

      self.cnFormBarcode = null;
      self.cnFormMaterialCode = [];
      self.jobCNItems = [];
      $("#cnFormMaterialCode").val("").trigger("change");

      self.cnFormOriginPlant = [];
      $("#cnFormOriginPlant").val("").trigger("change");

      self.cnFormDestinationAgent = [];
      $("#cnFormDestinationAgent").val("").trigger("change");

      self.cnFormCNStatus = [];
      $("#cnFormCNStatus").val("").trigger("change");

      self.cnFormCNToAgent = [];
      $("#cnFormCNToAgent").val("").trigger("change");

      self.getJobCN(e);
    },
    confirmCopyOriginPlant: function confirmCopyOriginPlant(e) {
      var _this2 = this;

      Swal.fire({
        title: "คำสั่งคัดลอกรหัสคลัง",
        type: "warning",
        html: "กรุณายืนยันคำสั่งคัดลอกรหัสคลังทั้งหมด ตามข้อมูลแถวที่ 1",
        inputPlaceholder: "ต้องการคัดลอกรหัสคลัง",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value == true) {
          _this2.copyOriginPlant();
        }
      });
    },
    copyOriginPlant: function copyOriginPlant() {
      var self = this;
      var plantCode = "";
      var plantText = "";

      var _loop2 = function _loop2(i) {
        element = self.jobCNItems[i];


        if (i == 0) {
          plantCode = element.originPlantCode2;
          if (element.originPlantText) {
            plantText = element.originPlantText;
          } else {
            plantText = "[ " + element.originPlantCode2 + " ] " + element.originPlantName2;
          }
        } else {
          element.originPlantCode2 = plantCode;

          setTimeout(function () {
            if (element.originPlantCode2 !== "") {
              self.$refs.jobCNItems[i].$refs.originPlantCode2.setSelectedData({
                id: plantCode,
                text: plantText
              });
            } else {
              self.$refs.jobCNItems[i].$refs.originPlantCode2.setSelectedData({
                id: null,
                text: null
              });
            }
          }, 50);
        }
        //console.log(element.originPlantCode2);
        //console.log(element);
      };

      for (var i = 0; i < self.jobCNItems.length; i++) {
        var element;

        _loop2(i);
      }
    },

    confirmCopyCnToAgentCode: function confirmCopyCnToAgentCode(e) {
      var _this3 = this;

      Swal.fire({
        title: "คำสั่งคัดลอกแก้ไข CN ให้(ตัวแทนฯ)",
        type: "warning",
        html: "กรุณายืนยันคำสั่งคัดลอกแก้ไข CN ให้(ตัวแทนฯ) ทั้งหมด ตามข้อมูลแถวที่ 1",
        inputPlaceholder: "ต้องการคัดลอกแก้ไข CN ให้(ตัวแทนฯ)",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value == true) {
          _this3.copyCnToAgentCode();
        }
      });
    },
    copyCnToAgentCode: function copyCnToAgentCode() {
      var self = this;
      var agentCode = "";
      var agentText = "";

      var _loop3 = function _loop3(i) {
        element = self.jobCNItems[i];


        if (i == 0) {
          agentCode = element.cnToAgentCode2;
          if (element.originPlantText) {
            agentText = element.cnToAgentText2;
          } else {
            agentText = "[ " + element.cnToAgentCode2 + " ] " + element.cnToAgentName2;
          }
        } else {
          element.cnToAgentCode2 = agentCode;

          setTimeout(function () {
            if (element.cnToAgentCode2 !== "") {
              self.$refs.jobCNItems[i].$refs.cnToAgentCode2.setSelectedData({
                id: agentCode,
                text: agentText
              });
            } else {
              self.$refs.jobCNItems[i].$refs.cnToAgentCode2.setSelectedData({
                id: null,
                text: null
              });
            }
          }, 50);
        }
        // console.log("i ", i);
        // console.log("cnToAgentCode2 ", element.cnToAgentCode2);
        // console.log(element);
      };

      for (var i = 0; i < self.jobCNItems.length; i++) {
        var element;

        _loop3(i);
      }
    }
  },
  mounted: function mounted() {
    var self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>'
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>'
      };
    }

    $(self.$refs.jobForm).validate({
      ignore: ":hidden, .ignore",
      rules: {},
      messages: {}
    });

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
    });

    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: "post",
      url: "/Api/JobsCN/GetJobCN",
      data: {
        jobId: this.$route.params.id,
        barcode: self.cnFormBarcode,
        materialCode: self.cnFormMaterialCode,
        originPlant: self.cnFormOriginPlant,
        destinationAgent: self.cnFormDestinationAgent,
        status: self.cnFormCNStatus,
        toAgent: self.cnFormCNToAgent
      }
    }).then(function (response) {
      if (response.status == 200) {
        var data = response.data;
        self.jobNumber = data.jobNumber;
        self.cnRemark = data.cnRemark;
        self.jobCNItems = data.items;

        if (response.data.items.length > 0) {
          var _loop4 = function _loop4(i) {
            item = response.data.items[i];


            setTimeout(function () {
              if (self.jobCNItems[i].cnToAgentCode2 !== null) {
                self.$refs.jobCNItems[i].$refs.cnToAgentCode2.setSelectedData({
                  id: response.data.items[i].cnToAgentCode2,
                  text: "[ " + response.data.items[i].cnToAgentCode2 + " ] " + response.data.items[i].cnToAgentName2
                });
              }

              if (self.jobCNItems[i].originPlantCode2 !== null) {
                self.$refs.jobCNItems[i].$refs.originPlantCode2.setSelectedData({
                  id: response.data.items[i].originPlantCode2,
                  text: "[ " + response.data.items[i].originPlantCode2 + " ] " + response.data.items[i].originPlantName2
                });
              }
              //default โรงงานที่ส่งออก
              else if (self.jobCNItems[i].originPlantCode !== null) {
                  self.jobCNItems[i].originPlantCode2 = self.jobCNItems[i].originPlantCode;

                  self.$refs.jobCNItems[i].$refs.originPlantCode2.setSelectedData({
                    id: response.data.items[i].originPlantCode,
                    text: "[ " + response.data.items[i].originPlantCode + " ] " + response.data.items[i].originPlantName
                  });
                }
            }, 50);
          };

          for (var i = 0; i < response.data.items.length; i++) {
            var item;

            _loop4(i);
          }
        }
      } else {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
        KTApp.unblockPage();
      }
    }).catch(function (error) {
      Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
      KTApp.unblockPage();
    }).then(function () {
      // always executed
      KTApp.unblockPage();
    });
    $(this.$refs.jobForm).validate().settings.ignore = ":hidden";
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */]
  },
  props: {
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var self = this;
    return {
      originPlantCode: null,
      originPlantCode2: null,
      destinationAgentCode: null,
      destinationAgentCode2: null,
      cnToAgentCode2: null,
      originPlantOptions: {
        placeholder: "กรุณาเลือกคลังสินค้าที่จ่ายออก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Plant/PlantOptions",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      destinationAgentOptions: {
        placeholder: "กรุณาเลือกตัวแทนฯที่ได้รับจากคลังสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cnToAgentOptions: {
        placeholder: "เลือกCN ให้(ตัวแทนฯ)",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  methods: {
    onOriginPlantChange: function onOriginPlantChange(id, text, data, ref) {
      var self = this;
      if (data.length != 0) {
        self.item.originPlantText = data[0].text;
        //console.log("data", text);
        //console.log(self.item);
      } else {
        self.item.originPlantText = "";
      }
    },
    onCnToAgentCode2Change: function onCnToAgentCode2Change(id, text, data, ref) {
      var self = this;
      if (data.length != 0) {
        self.item.cnToAgentText2 = data[0].text;
        self.item.cnToAgentName2 = data[0].agenT_NAME;
        //console.log("data", text);
        //console.log(self.item);
      } else {
        self.item.cnToAgentText2 = "";
      }
    }
  },
  mounted: function mounted() {
    // $(".required", this.$el).each(function() {
    //   const $input = $(this);
    //   $input.rules("add", {
    //     required: true,
    //     messages: {
    //       required: $input.data("msg-required"),
    //     },
    //   });
    // });
    // $(".min", this.$el).each(function() {
    //   const $input = $(this);
    //   $input.rules("add", {
    //     min: true,
    //     messages: {
    //       min: $input.data("msg-min"),
    //     },
    //   });
    // });
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JobItemRow__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__JobRefDocumentRow__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JobRefInvoiceRow__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JobRefJobRow__ = __webpack_require__(1222);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var BarcodeActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n<div>\n  <a v-if=\"$parent.jobStatus == 'JOB_STATUS_PENDING'\" href=\"#\" @click.prevent=\"remove\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E25\u0E1A\u0E1A\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14\">\n    <i class=\"fa fa-trash-alt kt-font-danger\"></i>\n  </a>\n</div>\n",
  methods: {
    remove: function remove() {
      var self = this;

      Swal.fire({
        title: "คำสั่งลบข้อมูลบาร์โค้ด",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลบาร์โค้ด <strong>" + self.data.barcodeNo + "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/RemoveBarcode", {
            jobId: self.$parent.$route.params.id,
            barcodes: [self.data.barcodeNo]
          }).then(function (response) {
            if (response.data.status) {
              $(self.$parent.$refs.barcodeTable).DataTable().ajax.reload(null, true);
              $(self.$parent.$refs.barcodeTable2).DataTable().ajax.reload(null, true);

              var job = response.data.data.job;
              for (var i = 0; i < job.items.length; i++) {
                var item = job.items[i];
                for (var j = 0; j < self.$parent.items.length; j++) {
                  var oldItem = self.$parent.items[j];
                  if (oldItem.jobItemId == item.itemId) {
                    oldItem.checkedQuantity = item.checkedQuantity;
                    oldItem.quantity = item.quantity;
                    break;
                  }
                }
              }

              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    jobItemRow: __WEBPACK_IMPORTED_MODULE_4__JobItemRow__["a" /* default */],
    jobRefDocumentRow: __WEBPACK_IMPORTED_MODULE_5__JobRefDocumentRow__["a" /* default */],
    jobRefInvoiceRow: __WEBPACK_IMPORTED_MODULE_6__JobRefInvoiceRow__["a" /* default */],
    jobRefJobRow: __WEBPACK_IMPORTED_MODULE_7__JobRefJobRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      isSubAgentOrShop: false,
      isEditable: true,
      isEditableTypePICKUP: true,
      isEdit: false,
      isTransitInit: false,
      barcodeForm: {
        barcode: "",
        isLoading: false
      },
      uuid: "",
      uuid_attach: "",
      uuid_evidence: "",
      noUseSML: false,
      doUploader: null,
      fileUploader: null,
      selectedItem: {},
      findType: true,
      scanBarcodeMessage: "",
      scanBarcodeResults: [],
      originData: null,
      originLocationIdOptions: {
        placeholder: "กรุณาเลือกสถานที่ต้นทาง (Origin)",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2JobLocation",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };

            query = self.genOriginQuery(query);

            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          if (!data.id || !data.data) return data.text;

          if (data.data.locationType == "PLANT") {
            return data.text;
          } else if (data.data.locationType == "AGENT") {
            var $container = $("<div class='select2-result-repository clearfix'>" + "<div class='select2-result-repository__meta'>" + "<div class='select2-result-repository__title'></div>" + "<div class='select2-result-repository__description'></div>" + "</div>" + "</div>");

            $container.find(".select2-result-repository__title").text(data.text);

            if (data.data.agentType != "HEAD_OFFICE") {
              $container.find(".select2-result-repository__description").html("SAP Code: " + data.id + "<br />HQ: " + data.data.headOffice);
            } else {
              $container.find(".select2-result-repository__description").text("SAP Code: " + data.id + " สำนักงานใหญ่");
            }

            return $container;
          } else {
            return data.text;
          }
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลสถานที่ต้นทาง (Origin)";
          }
        }
      },
      destinationData: null,
      destinationLocationIdOptions: {
        placeholder: "กรุณาเลือกสถานที่ปลายทาง (Destination)",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2JobLocation",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };

            query = self.genDestinationQuery(query);

            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          if (!data.id || !data.data) return data.text;

          if (data.data.locationType == "PLANT") {
            return data.text;
          } else if (data.data.locationType == "AGENT") {
            var $container = $("<div class='select2-result-repository clearfix'>" + "<div class='select2-result-repository__meta'>" + "<div class='select2-result-repository__title'></div>" + "<div class='select2-result-repository__description'></div>" + "</div>" + "</div>");

            $container.find(".select2-result-repository__title").text(data.text);

            if (data.data.agentType != "HEAD_OFFICE") {
              $container.find(".select2-result-repository__description").html("SAP Code: " + data.id + "<br />HQ: " + data.data.headOffice);
            } else {
              $container.find(".select2-result-repository__description").text("SAP Code: " + data.id + " สำนักงานใหญ่");
            }

            return $container;
          } else {
            return data.text;
          }
        },
        language: {
          noResults: function noResults() {
            if (self.$route.meta.jobType == "EXCHANGE") {
              var originEl = self.$refs.originLocationId.$el;
              var selectedData = $(originEl).select2("data");
              if (selectedData.length == 0) {
                return "กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อนเลือกสถานที่ปลายทาง (Destination)";
              }
            }
            return "ไม่พบข้อมูลสถานที่ปลายทาง (Destination)";
          }
        }
      },
      finishedProductCodeOptions: {
        placeholder: "กรุณาเลือกสินค้าที่ต้องการผลิต",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              // สินค้าสำเร็จรูป
              productGroupId: 14
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลสินค้า";
          }
        }
      },
      transportOptions: {
        placeholder: "กรุณาเลือกรถสำหรับขนส่งสินค้า/ทรัพย์สิน",
        allowClear: true,
        ajax: {
          url: "/Api/Transport/Select2Transport",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              showVendorTransport: false,
              agentCodes: [],
              isShowAll: true
            };

            if (self.$route.meta.jobType == "TRANSFER_TO_AGENT" || self.$route.meta.jobType == "BORROW") {
              query.showVendorTransport = true;

              if (self.destinationData && self.destinationData.data.locationType == "AGENT") {
                query.agentCodes.push(self.destinationLocationId);
              }

              if (self.refDocuments) {
                self.refDocuments.forEach(function (doc) {
                  query.agentCodes.push(doc.shipTo);
                });
              }
            } else if (self.$route.meta.jobType == "RETURN") {
              query.showVendorTransport = true;
              query.agentCodes.push(self.originLocationId);
            } else if (self.$route.meta.jobType == "RETRIEVE_ITEM" && self.originData.data.locationType == "AGENT" && self.destinationData.data.locationType == "PLANT") {
              query.showVendorTransport = true;
              query.agentCodes.push(self.destinationLocationId);
            } else if (self.$route.meta.jobType == "EXCHANGE") {
              var originEl = self.$refs.originLocationId.$el;
              var selectedData = $(originEl).select2("data");
              if (selectedData.length > 0) {
                var origin = selectedData[0];
                if (origin.data.locationType == "PLANT") {
                  query.showVendorTransport = true;
                } else if (origin.data.locationType == "AGENT") {
                  query.agentCodes.push(self.originLocationId);
                  query.agentCodes.push(self.destinationLocationId);
                }
              }
            } else if (self.$route.meta.jobType == "RETURN_ADHOC") {
              query.showVendorTransport = true;
              query.showAllAgentTransport = true;
            }
            // query.agentCodes.push();

            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        language: {
          noResults: function noResults() {
            if (self.$route.meta.jobType == "RETURN") {
              if (!self.originData) {
                return "กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อนเลือกข้อมูลรถสำหรับขนส่งสินค้า/ทรัพย์สิน";
              }
            }

            return "ไม่พบข้อมูลรถสำหรับขนส่งสินค้า/ทรัพย์สิน";
          }
        }
      },
      shopCodeOptions: {
        placeholder: "กรุณาเลือกร้านค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2Shop",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };

            query.agentCodes = [self.originLocationId];

            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      },
      userIds: [],
      userIdsOptions: {
        placeholder: "เลือก User",
        allowClear: true,
        ajax: {
          url: "/Api/Users/Select2JobUser",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };

            query = self.genUserQuery(query);

            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      // Form Data
      jobNumber: null,
      jobDate: null,
      jobTypeName: null,
      jobStatus: "JOB_STATUS_WAITING",
      fromJobNumber: null,
      originLocationId: null,
      destinationLocationId: null,
      finishedProductCode: null,
      remark: null,
      items: [],
      shopItems: [],
      shopReturnItems: [],
      ItemHistory: [],
      pickupItems: [],
      pickupReturnItems: [],
      refDocuments: [],
      refInvoices: [],
      refJobs: [],
      uploadFiles: [],
      parentJobType: null,
      parentJobTypeName: null,
      showItems: true,
      transitId: null,
      transitId2: null,
      pickupAtOrigin: false,
      localBarcodes: [],
      localMaterialName: null,
      localMaterialCode: null,
      hasApproveProcess: false,
      signatureGridFSId: null,
      signatureFileUrl: null,
      signatureFileInfoId: null,
      evidenceGridFSId: null,
      evidenceFileUrl: null,
      evidenceFileInfoId: null,
      evidenceRequired: false,
      evidenceCanPickFromGallery: false,
      evidenceRefCode: null,
      evidenceFileName: null,
      productLoan: null,
      isBeerClaimAdmin: true,
      // Job object สำหรับเก็บข้อมูลทั้งหมดจาก API
      job: {
        jobDestinations: [],
        items: []
      },
      // Multi-shop destinations for TRANSFER_TO_MULTI_SHOP
      jobDestinations: [{
        _uid: Date.now(), // Unique ID for Vue key binding
        destinationLocationId: null,
        destinationName: '',
        destinationData: null,
        items: []
      }],
      nextDestinationUid: Date.now() + 1, // Counter for generating unique IDs
      hideItems: ["RETURN_ADHOC", "NEW_SHOP", "PM_CHECK", "EDIT_NFC", "INSPECTIONS_AND_BORROW_PROPERTY", "QI_NO_EQUIPMENT", "TYPING_BARCODE", "QI_LESS_THAN_61", "EDIT_SHOP"],
      isPreviousBalance: false
    };
  },

  methods: {
    isShowOnJobTypes: function isShowOnJobTypes(types) {
      var self = this;

      if ((typeof types === "undefined" ? "undefined" : _typeof(types)) == "object" && Array.isArray(types)) {
        return $.grep(types, function (ele, idx) {
          if ((typeof ele === "undefined" ? "undefined" : _typeof(ele)) == "object" && Array.isArray(ele)) {
            return ele[0] == self.$route.meta.jobType && self.parentJobType == ele[1];
          } else {
            return ele == self.$route.meta.jobType;
          }
        }).length > 0;
      } else {
        return types == self.$route.meta.jobType;
      }
    },
    approvalProcess: function approvalProcess() {
      var approve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;

      if (approve && self.uploadFiles.length == 0) {
        // if (self.$route.meta.jobType == "DESTROY") {
        //   let hasBarcode = false;
        //   for (let i = 0; i < self.items.length; i++) {
        //     const item = self.items[i];
        //     hasBarcode = hasBarcode || item.hasBarcode;
        //   }

        //   if (hasBarcode) {
        //     Swal.fire(
        //       "เกิดข้อผิดพลาด",
        //       "กรุณาอัพโหลดไฟล์เอกสารก่อนอนุมัติใบงาน",
        //       "error"
        //     );
        //     return;
        //   }
        // } else {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาอัพโหลดไฟล์เอกสารก่อนอนุมัติใบงาน", "error");
        return;
        // }
      }

      var apprSwal = Swal.mixin({
        customClass: {
          confirmButton: approve ? "btn btn-success" : "btn btn-danger",
          cancelButton: "btn btn-secondary"
        },
        buttonsStyling: false
      });

      apprSwal.fire({
        title: approve ? "คำสั่งอนุมัติ" : "คำสั่งไม่อนุมัติ",
        type: "warning",
        html: "กรุณายืนยัน" + (approve ? "คำสั่งอนุมัติ" : "คำสั่งไม่อนุมัติ") + " <strong>" + self.jobNumber + "</strong>",
        showCancelButton: true,
        confirmButtonText: approve ? "อนุมัติ" : "ไม่อนุมัติ",
        cancelButtonText: "ตรวจสอบ"
      }).then(function (result) {
        if (result.value) {
          self.approvalProcessJob(approve, false);
        }
      });
    },
    approvalProcessJob: function approvalProcessJob() {
      var approve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var self = this;
      var router = this.$router;

      var data = {
        jobId: self.$route.params.id,
        force: force,
        approve: approve,
        attachments: self.uploadFiles
      };

      // -- Begin Commit Job
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/Commit", data).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            // self.$parent.reloadDataTable();
            router.push({ name: "JobSearch" });
          });
        } else {
          var msg = response.data.message;
          if (response.data.errors) {
            var html = "";
            for (var key in response.data.errors) {
              if (response.data.errors.hasOwnProperty(key)) {
                var err = response.data.errors[key];
                html += "<li>" + err[1] + "</li>";
              }
            }

            if (html) {
              msg += "<div class='text-left mt-3'>หากคุณต้องการปิดใบงานนี้ กรุณายืนยันอีกครั้งโดยคลิกปุ่ม <strong>ฉันต้องการปิดใบงานนี้</strong><br /><br />สาเหตุ: <ul>" + html + "</ul></div>";
            }
          }

          Swal.fire({
            title: "เกิดข้อผิดพลาด",
            html: msg,
            type: "error",
            showCancelButton: true,
            confirmButtonText: "<i class='fa fa-archive'></i> ฉันต้องการปิดใบงานนี้",
            cancelButtonText: "ตรวจสอบข้อมูล"
          }).then(function (result) {
            if (result.value) {
              self.approvalProcessJob(true, true);
            }
          });
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
      // -- End Commit Job
    },
    submitBarcode: function submitBarcode() {
      var self = this;
      if (self.barcodeForm.barcode) {
        var data = {
          jobId: self.$route.params.id,
          barcode: self.barcodeForm.barcode
        };

        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังสแกนบาร์โค้ด กรุณารอสักครู่..."
        });

        self.scanBarcodeMessage = "";
        self.scanBarcodeResults = [];

        // -- Begin Submit Barcode
        self.barcodeForm.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/ScanBarcode", data).then(function (response) {
          toastr.options = {
            closeButton: true,
            debug: false,
            newestOnTop: false,
            progressBar: false,
            positionClass: "toast-bottom-right",
            preventDuplicates: false,
            onclick: null,
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "5000",
            extendedTimeOut: "5000",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut"
          };

          var data = response.data;
          self.barcodeForm.barcode = "";
          if (data.status) {
            var job = data.data.job;
            self.jobStatus = job.jobStatusCode;
            self.isEditable = false;
            for (var i = 0; i < job.items.length; i++) {
              var item = job.items[i];
              for (var j = 0; j < self.items.length; j++) {
                var oldItem = self.items[j];
                if (oldItem.jobItemId == item.itemId) {
                  oldItem.checkedQuantity = item.checkedQuantity;
                  oldItem.quantity = item.quantity;
                  break;
                }
              }
            }
            toastr.success(data.message);
          } else {
            toastr.error(data.message);
          }

          self.scanBarcodeMessage = data.message;
          self.scanBarcodeResults = data.data.barcodeResults;

          var table = $(self.$refs.barcodeScanTable).DataTable();
          table.clear().draw();
          table.rows.add(self.scanBarcodeResults).draw();
          // });
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }).then(function () {
          self.barcodeForm.isLoading = false;
          KTApp.unblockPage();
        });
        // -- End Submit Barcode
      }
    },
    commit: function commit(e) {
      e.preventDefault();

      var self = this;

      if (!$(self.$refs.jobForm).validate().form()) {
        return false;
      }

      if (self.evidenceRequired && self.evidenceCanPickFromGallery && !self.evidenceFileUrl && (!self.evidenceFileName || !self.evidenceRefCode)) {
        Swal.fire({
          title: "เกิดข้อผิดพลาด",
          html: "กรุณาอัพโหลดรูปภาพหลักฐาน",
          type: "error",
          confirmButtonText: "อัพโหลด"
        });
        return;
      }

      Swal.fire({
        title: "คำสั่งปิดใบงาน",
        type: "warning",
        html: "กรุณายืนยันคำสั่งปิดใบงาน <strong>" + self.jobNumber + "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          self.commitJob();
        }
      });
    },

    commitJob: function commitJob() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;
      var router = this.$router;

      var data = {
        jobId: self.$route.params.id,
        force: force,
        shopItems: [],
        evidenceFileName: self.evidenceFileName,
        evidenceRefCode: self.evidenceRefCode,
        evidenceFileInfoId: self.evidenceFileUrl,
        evidenceFileUrl: self.evidenceFileUrl,
        evidenceGridFSId: self.evidenceGridFSId
      };

      for (var i = 0; i < self.shopItems.length; i++) {
        var shopItem = self.shopItems[i];
        data.shopItems.push({
          signatureGridFSId: shopItem.signatureGridFSId,
          signatureFileUrl: shopItem.signatureFileUrl,
          signatureFileInfoId: shopItem.signatureFileInfoId,
          shopName: shopItem.shopName,
          shopCode: shopItem.shopCode,
          smlBillNumber: shopItem.smlBillNumber,
          // ส่ง id ของ barcode ในร้านนี้ไปด้วย ให้ backend match ด้วย id แทน shopName/signatureFileInfoId
          jobItemBarcodeIds: (shopItem.items || []).reduce(function (ids, item) {
            return ids.concat((item.barcodes || []).map(function (barcode) {
              return barcode.jobItemBarcodeId;
            }));
          }, [])
        });
      }

      // -- Begin Commit Job
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/Commit", data).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            // self.$parent.reloadDataTable();
            router.push({ name: "JobSearch" });
          });
        } else {
          var msg = response.data.message;
          if (response.data.errors) {
            var html = "";
            for (var key in response.data.errors) {
              if (response.data.errors.hasOwnProperty(key)) {
                var err = response.data.errors[key];
                html += "<li>" + err[1] + "</li>";
              }
            }

            if (html) {
              msg += "<div class='text-left mt-3'>หากคุณต้องการปิดใบงานนี้ กรุณายืนยันอีกครั้งโดยคลิกปุ่ม <strong>ฉันต้องการปิดใบงานนี้</strong><br /><br />สาเหตุ: <ul>" + html + "</ul></div>";
            }
          }

          var start = msg.indexOf("||");
          var end = msg.lastIndexOf("||");
          if (start >= 0) {
            var str = msg.substr(start + 2, end - start - 2);
            var oldStr = msg.substr(start, end - start + 2);
            // console.log(start);
            // console.log(end);
            // console.log(str);
            // console.log(oldStr);
            var repl = "<strong class='text-danger'>" + str + "</strong>";
            msg = msg.replace(oldStr, repl);
          }

          Swal.fire({
            title: "เกิดข้อผิดพลาด",
            html: msg,
            type: "error",
            showCancelButton: true,
            confirmButtonText: "<i class='fa fa-archive'></i> ฉันต้องการปิดใบงานนี้",
            cancelButtonText: "ตรวจสอบข้อมูล"
          }).then(function (result) {
            if (result.value) {
              self.commitJob(true);
            }
          });
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
      // -- End Commit Job
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      var self = this;
      var router = this.$router;

      if (!$(self.$refs.jobForm).validate().form()) {
        return false;
      }

      if (self.noUseSML === true) {
        self.refInvoices = [];
      }

      var job = {
        jobType: self.$route.meta.jobType,
        jobDate: self.jobDate.format("DD/MM/YYYY"),
        originLocationId: self.originLocationId,
        originLocationType: self.originData ? self.originData.data.locationType : null,
        destinationLocationId: self.destinationLocationId,
        destinationLocationType: self.destinationData ? self.destinationData.data.locationType : null,
        finishedProductCode: self.finishedProductCode,
        remark: self.remark,
        items: self.items,
        refDocuments: self.refDocuments,
        refInvoices: self.refInvoices,
        attachments: self.uploadFiles,
        pickupAtOrigin: self.pickupAtOrigin,
        transitId: self.transitId,
        noUseSML: self.noUseSML,
        evidenceFileInfoId: self.evidenceFileUrl,
        evidenceFileUrl: self.evidenceFileUrl,
        evidenceGridFSId: self.evidenceGridFSId,
        assignToUsers: self.userIds,
        isPreviousBalance: self.isPreviousBalance
      };

      // Add jobDestinations for TRANSFER_TO_MULTI_SHOP
      if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        job.jobDestinations = self.jobDestinations;
      }

      if (self.isShowOnJobTypes(["REPAIR_SUPPLIER", "RETURN_SUPPLIER"]) || self.$route.meta.jobType == "DESTROY" && (self.jobStatus == "JOB_STATUS_REQUEST_APPROVAL" || self.jobStatus == "JOB_STATUS_SUCCESS")) {
        // ไฟล์เอกสาร
        if (self.uploadFiles == null || self.uploadFiles.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "ใบงานจะต้องมี ไฟล์เอกสาร อย่างน้อย 1 รายการ", "error");
          return false;
        }
      } else if (self.isShowOnJobTypes(["TRANSFER_TO_AGENT", ["RETRIEVE_ITEM", "JOB_TYPE_TRANSFER_TO_AGENT"]])) {
        // ใบส่งสินค้า (Delivery Order)
        if (self.refDocuments == null || self.refDocuments.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "ใบงานจะต้องมี ใบส่งสินค้า (Delivery Order) อย่างน้อย 1 รายการ", "error");
          return false;
        }
      } else if (self.isShowOnJobTypes(["TRANSFER_TO_SHOP", ["RETRIEVE_ITEM", "JOB_TYPE_TRANSFER_TO_SHOP"]])) {
        // บิลขาย (Invoice)
        if ((self.refInvoices == null || self.refInvoices.length == 0) && self.$route.meta.jobType == "TRANSFER_TO_SHOP" && self.originData && self.originData.data.locationType == "AGENT" && !self.originData.data.noSML && !self.noUseSML) {
          Swal.fire("เกิดข้อผิดพลาด", "ใบงานจะต้องมี บิลขาย (Invoice) อย่างน้อย 1 รายการ", "error");
          return false;
        }
      } else if (self.showRefInvoices) {
        // ใบเบิกสินค้า
        if (self.refInvoices == null || self.refInvoices.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", this.$route.meta.jobType == "PICKUP" ? "ใบงานจะต้องมี ใบโอนสินค้า อย่างน้อย 1 รายการ" : "ใบงานจะต้องมี ใบเบิกสินค้า อย่างน้อย 1 รายการ", "error");
          return false;
        }
      }

      // Validation for TRANSFER_TO_MULTI_SHOP
      if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        if (!self.jobDestinations || self.jobDestinations.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "ใบงานจะต้องมี สถานที่ปลายทาง อย่างน้อย 1 รายการ", "error");
          return false;
        }

        // Check each destination
        for (var i = 0; i < self.jobDestinations.length; i++) {
          var dest = self.jobDestinations[i];

          if (!dest.destinationLocationId) {
            Swal.fire("เกิดข้อผิดพลาด", "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E16\u0E32\u0E19\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E32\u0E22\u0E17\u0E32\u0E07 (Destination) \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E25\u0E33\u0E14\u0E31\u0E1A\u0E17\u0E35\u0E48 " + (i + 1), "error");
            return false;
          }

          if (!dest.items || dest.items.length == 0) {
            Swal.fire("เกิดข้อผิดพลาด", "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32/\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2A\u0E34\u0E19 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E25\u0E33\u0E14\u0E31\u0E1A\u0E17\u0E35\u0E48 " + (i + 1), "error");
            return false;
          }
        }
      }

      if (job.items.length == 0 && self.$route.meta.jobType != "RETURN_ADHOC" && self.$route.meta.jobType != "TRANSFER_TO_MULTI_SHOP") {
        Swal.fire("เกิดข้อผิดพลาด", "ใบงานจะต้องมี รายการสินค้า/ทรัพย์สิน อย่างน้อย 1 รายการ", "error");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      if (self.isEdit) {
        job.jobId = self.$route.params.id;
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: self.isEdit ? "put" : "post",
        url: "/Api/Jobs",
        data: {
          job: job,
          evidenceFileName: self.evidenceFileName,
          evidenceRefCode: self.evidenceRefCode
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            // self.$parent.reloadDataTable();
            router.push({ name: "JobSearch" });
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onAddRefDocumentClick: function onAddRefDocumentClick(e) {
      this.refDocuments.push({
        id: null,
        documentNumber: null,
        documentDate: null,
        items: []
      });
    },
    onAddRefInvoiceClick: function onAddRefInvoiceClick(e) {
      this.refInvoices.push({
        id: null,
        documentNumber: null,
        documentDate: null,
        isPreviousBalance: false,
        items: []
      });
    },
    onRemoveRefDocumentClick: function onRemoveRefDocumentClick(index, delItem) {
      this.refDocuments.splice(index, 1);
    },
    onRemoveRefInvoiceClick: function onRemoveRefInvoiceClick(index, delItem) {
      this.refInvoices.splice(index, 1);
    },
    onRemoveUploadFileClick: function onRemoveUploadFileClick(index, delItem) {
      this.uploadFiles.splice(index, 1);
    },
    onAddItemClick: function onAddItemClick(e) {
      this.items.push({
        materialCode: null,
        materialName: null,
        description: null,
        quantity: 0,
        checkedQuantity: 0,
        unitName: null,
        barcodeStatus: null
      });
    },
    onCalculateItemClick: function onCalculateItemClick($event) {
      var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "คุณต้องการคำนวณรายการสินค้า/ทรัพย์สินหรือไม่? ระบบจะล้างข้อมูลในรายการสินค้า/ทรัพย์สินออกทั้งหมด";

      var self = this;
      var newItems = [];

      Swal.fire({
        title: "คำนวณรายการสินค้า/ทรัพย์สิน",
        type: "warning",
        html: msg,
        showCancelButton: true,
        confirmButtonText: '<i class="fa fa-calculator"></i> คำนวณใหม่',
        cancelButtonText: "ไม่ต้องการ"
      }).then(function (result) {
        if (result.value) {
          self.refDocuments.forEach(function (doc) {
            doc.items.forEach(function (dItem) {
              if (dItem.productGroupId == 2 || dItem.productGroupId == 14 || dItem.productGroupId == 1 && dItem.productTypeId != 4 && dItem.productTypeId != 5) {
                // 1	เครื่องและอุปกรณ์เบียร์สด
                // 2	พรีเมี่ยมสื่อ
                // 14	สินค้าสำเร็จรูป
                // Add Filter Here
                var exists = $.grep(newItems, function (obj, idx) {
                  return obj.materialCode == dItem.materialCode;
                });

                if (exists.length > 0) {
                  exists[0].quantity += dItem.quantity;
                } else {
                  newItems.push({
                    materialCode: dItem.materialCode,
                    materialName: dItem.materialName,
                    description: null,
                    quantity: dItem.quantity,
                    checkedQuantity: 0,
                    unitName: dItem.salesUnit,
                    hasBarcode: dItem.hasBarcode,
                    selectedMaterialCodeData: {
                      id: dItem.materialCode,
                      text: dItem.materialName + " [" + dItem.materialCode + "]",
                      data: {
                        baseUnit: dItem.salesUnit,
                        materialCode: dItem.materialCode,
                        hasBarcode: dItem.hasBarcode
                      }
                    }
                  });
                }
              }
            });
          });

          self.refInvoices.forEach(function (doc) {
            doc.items.forEach(function (dItem) {
              if (self.$route.meta.jobType == "TRANSFER_TO_SHOP" && (dItem.productGroupId == 2 || dItem.productGroupId == 14 || dItem.productGroupId == 1 && dItem.productTypeId != 4 && dItem.productTypeId != 5) || self.$route.meta.jobType == "PICKUP" && dItem.productGroupId == 1 && (dItem.productTypeId == 4 || dItem.productTypeId == 5) || self.$route.meta.jobType != "TRANSFER_TO_SHOP" && self.$route.meta.jobType != "PICKUP") {
                // 1	เครื่องและอุปกรณ์เบียร์สด
                // 2	พรีเมี่ยมสื่อ
                // 14	สินค้าสำเร็จรูป
                // Add Filter Here
                var exists = $.grep(newItems, function (obj, idx) {
                  return obj.materialCode == dItem.materialCode;
                });

                if (exists.length > 0) {
                  exists[0].quantity += dItem.quantity;
                } else {
                  // เพิ่มใหม่เฉพาะ invoice ที่ไม่ยกยอด
                  if (doc.isPreviousBalance == false) {
                    newItems.push({
                      materialCode: dItem.materialCode,
                      materialName: dItem.materialName,
                      description: null,
                      quantity: dItem.quantity,
                      checkedQuantity: 0,
                      unitName: dItem.salesUnit,
                      hasBarcode: dItem.hasBarcode,
                      selectedMaterialCodeData: {
                        id: dItem.materialCode,
                        text: dItem.materialName + " [" + dItem.materialCode + "]",
                        data: {
                          baseUnit: dItem.salesUnit,
                          materialCode: dItem.materialCode,
                          hasBarcode: dItem.hasBarcode
                        }
                      }
                    });
                  }
                }
              }
            });
          });

          // ลบเฉพาะ items ที่ไม่ได้ scan barcode
          self.items = self.items.filter(function (item) {
            return item.checkedQuantity > 0;
          });
          // for (let i = 0; i < self.items.length; i++) {
          //   if(self.items[i].checkedQuantity == 0){
          //     self.items.splice(i, 1);
          //   }
          // }

          var _loop = function _loop(i) {
            var item = newItems[i];
            self.items.push(item);
            //หา index ล่าสุดของ items
            var len = self.items.length;
            setTimeout(function () {
              self.$refs.jobItems[len - 1].$refs.materialCode.setSelectedData(item.selectedMaterialCodeData);
            }, 50);
          };

          for (var i = 0; i < newItems.length; i++) {
            _loop(i);
          }
        }
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      var self = this;
      var newItems = self.items.slice();
      self.items.splice(0, self.items.length);
      newItems.splice(index, 1);

      var _loop2 = function _loop2(i) {
        var item = newItems[i];
        self.items.push(item);
        setTimeout(function () {
          self.$refs.jobItems[i].$refs.materialCode.setSelectedData(item.selectedMaterialCodeData);
        }, 50);
      };

      for (var i = 0; i < newItems.length; i++) {
        _loop2(i);
      }
    },

    // === Multi-shop destinations methods ===
    onAddDestinationClick: function onAddDestinationClick() {
      this.jobDestinations.push({
        _uid: this.nextDestinationUid++, // Assign unique ID
        destinationLocationId: null,
        destinationName: '',
        destinationData: null,
        items: []
      });
    },
    onRemoveDestinationClick: function onRemoveDestinationClick(destIndex) {
      var self = this;
      Swal.fire({
        title: "คำสั่งลบร้านค้าปลายทาง",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบร้านค้าปลายทางที่ " + (destIndex + 1),
        showCancelButton: true,
        confirmButtonText: '<i class="fa fa-check"></i> ยืนยัน',
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          self.jobDestinations.splice(destIndex, 1);
        }
      });
    },
    onMultiDestinationChange: function onMultiDestinationChange(id, val, data, ref, destIndex) {
      var _this = this;

      if (data && data.length > 0) {
        var selectedData = data[0];
        var selectedLocationId = selectedData.id;
        var selectedLocationName = selectedData.text;
        var selectedDataObj = selectedData.data || {};

        // ใช้ id เป็น uniqueCode เพื่อเช็คซ้ำ
        var uniqueCode = selectedLocationId;

        if (!uniqueCode) {
          this.jobDestinations[destIndex].destinationLocationId = selectedLocationId;
          this.jobDestinations[destIndex].destinationName = selectedLocationName;
          this.jobDestinations[destIndex].destinationData = selectedDataObj;
          return;
        }

        // รวบรวม id ที่เลือกไว้แล้วทั้งหมด (ยกเว้น index ปัจจุบัน)
        var existingCodes = this.jobDestinations.map(function (dest, index) {
          if (index !== destIndex && dest.destinationLocationId) {
            return dest.destinationLocationId;
          }
          return null;
        }).filter(function (code) {
          return code !== null && code !== undefined;
        });

        // เช็คซ้ำ
        if (existingCodes.includes(uniqueCode)) {
          Swal.fire({
            title: "เลือกปลายทางซ้ำ",
            html: selectedLocationName + " \u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E25\u0E49\u0E27",
            type: "warning",
            confirmButtonText: "ตกลง"
          }).then(function () {
            // เคลียร์ร้านค้านี้ออก (ใช้ jQuery โดยตรงเหมือนกรณีเปลี่ยนต้นทาง)
            $("#destinationLocationId_" + destIndex).val("").trigger("change");

            // Clear data model
            _this.jobDestinations[destIndex].destinationLocationId = null;
            _this.jobDestinations[destIndex].destinationName = null;
            _this.jobDestinations[destIndex].destinationData = null;
          });
          return; // ออกจากฟังก์ชันทันที ไม่ให้ดำเนินการต่อ
        }

        // ถ้าไม่ซ้ำ ให้บันทึกข้อมูลปกติ
        this.jobDestinations[destIndex].destinationLocationId = selectedLocationId;
        this.jobDestinations[destIndex].destinationName = selectedLocationName;
        this.jobDestinations[destIndex].destinationData = selectedDataObj;
      }
    },
    formatNumber: function formatNumber(value) {
      if (!value && value !== 0) return '-';
      return Number(value).toLocaleString('th-TH');
    },
    onAddMultiShopItemClick: function onAddMultiShopItemClick(destIndex) {
      this.jobDestinations[destIndex].items.push({
        materialCode: null,
        materialName: null,
        description: null,
        quantity: 0,
        checkedQuantity: 0,
        unitName: null
      });
    },
    onRemoveMultiShopItemClick: function onRemoveMultiShopItemClick(destIndex, itemIndex) {
      var self = this;
      var destination = self.jobDestinations[destIndex];
      var newItems = destination.items.slice();
      destination.items.splice(0, destination.items.length);
      newItems.splice(itemIndex, 1);

      var _loop3 = function _loop3(i) {
        var item = newItems[i];
        destination.items.push(item);
        setTimeout(function () {
          var refKey = 'jobItems_' + destIndex + '_' + i;
          if (self.$refs[refKey] && self.$refs[refKey][0]) {
            self.$refs[refKey][0].$refs.materialCode.setSelectedData(item.selectedMaterialCodeData);
          }
        }, 50);
      };

      for (var i = 0; i < newItems.length; i++) {
        _loop3(i);
      }
    },

    // === End Multi-shop destinations methods ===
    onShowBarcodeClick: function onShowBarcodeClick(index, item) {
      this.selectedItem = item;
      if (this.findType === true) {
        this.initializeBarcodeTable();
      } else {
        this.initializeBarcodeTable2();
      }
      $(this.$refs.barcodeModal).modal("show");
    },
    initializeBarcodeTable: function initializeBarcodeTable() {
      var self = this;

      if ($.fn.DataTable.isDataTable(self.$refs.barcodeTable)) {
        $(self.$refs.barcodeTable).DataTable().ajax.reload(null, true);
      } else {
        $(self.$refs.barcodeTable).DataTable({
          responsive: true,
          processing: true,
          serverSide: true,
          searchDelay: 500,
          ajax: {
            url: "/Api/Jobs/FindBarcode",
            type: "post",
            beforeSend: function beforeSend(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            },
            data: function data(d) {
              d.jobId = self.$route.params.id;
              d.jobItemId = self.selectedItem.jobItemId;
            }
          },
          // DOM Layout settings
          dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n            <'row'<'col-sm-12'tr>>\n            <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
          lengthMenu: [50, 100, 200, 500],
          pageLength: 100,
          language: {
            lengthMenu: "Display _MENU_"
          },
          // Order settings
          order: [[6, "desc"]],
          columns: [{
            data: "barcodeNoOld",
            className: "text-center",
            width: "5%",
            sortable: false
          }, {
            data: "barcodeNoOld",
            className: "text-center",
            width: "20%"
          }, {
            data: "departmentMaterialCode",
            className: "text-center",
            width: "20%"
          }, {
            data: "prevPlantCode",
            className: "text-center",
            width: "15%",
            sortable: false,
            render: function render(data, type, full, meta) {
              if (full.prevPlantCode) {
                return full.prevPlantName;
              } else if (full.prevAgentCode) {
                return full.prevAgentName + " (ตัวแทนฯ)";
              } else if (full.prevShopCode) {
                return full.prevShopName + " (ตัวแทนฯย่อย/ร้านค้า)";
              } else if (full.prevSubShopId) {
                return full.prevSubShopName + " (ร้านค้าของตัวแทนฯย่อย)";
              } else if (full.prevVendorId) {
                return full.prevVendorName + " (ซัพพลายเออร์)";
              }
              return "";
            }
          }, {
            data: "rootAgentName",
            className: "text-center",
            width: "15%",
            sortable: false
          }, {
            data: "tobeBarcodeStatusName",
            className: "text-center",
            width: "15%",
            sortable: false
          }, {
            data: "scanDate",
            className: "text-center",
            width: "15%",
            render: function render(data, type, full, meta) {
              return moment(data).format("DD/MM/YYYY HH:mm:ss");
            }
          }, { data: "scanBy", className: "text-center", width: "15%" }, {
            data: "barcodeNoOld",
            className: "text-center",
            width: "10%",
            sortable: false,
            render: function render(data, type, full, meta) {
              return '<div class="actions"></div>';
            }
          }, {
            data: "spareParts",
            render: function render(data, type, full, meta) {
              var parts = [];
              data.forEach(function (part) {
                if (part.materialCode) {
                  parts.push(part.customSparePartName + " (" + part.materialCode + ")");
                } else {
                  parts.push(part.customSparePartName);
                }
              });
              return parts.join(", ");
            }
          }],
          drawCallback: function drawCallback(settings) {
            // Need to redo the counters if filtered or sorted
            for (var i = 0, iLen = settings.aiDisplay.length; i < iLen; i++) {
              $("td:eq(0)", settings.aoData[settings.aiDisplay[i]].nTr).html(settings._iDisplayStart + i + 1);
              $('[data-toggle="popover"]', settings.aoData[settings.aiDisplay[i]].nTr).popover();
            }
          }
        });
      }
    },
    initializeBarcodeTable2: function initializeBarcodeTable2() {
      var self = this;

      if ($.fn.DataTable.isDataTable(self.$refs.barcodeTable2)) {
        $(self.$refs.barcodeTable2).DataTable().ajax.reload(null, true);
      } else {
        $(self.$refs.barcodeTable2).DataTable({
          responsive: true,
          processing: true,
          serverSide: true,
          searchDelay: 500,
          ajax: {
            url: "/Api/Jobs/FindBarcode",
            type: "post",
            beforeSend: function beforeSend(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            },
            data: function data(d) {
              d.jobId = self.$route.params.id;
              d.jobItemId = self.selectedItem.jobItemId;
            }
          },
          // DOM Layout settings
          dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n            <'row'<'col-sm-12'tr>>\n            <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
          lengthMenu: [50, 100, 200, 500],
          pageLength: 100,
          language: {
            lengthMenu: "Display _MENU_"
          },
          // Order settings
          order: [[1, "desc"]],
          columns: [{
            data: "barcodeNoOld",
            className: "text-center",
            width: "5%",
            sortable: false
          }, {
            data: "barcodeNoOld",
            className: "text-center",
            width: "20%"
          }, {
            data: "departmentMaterialCode",
            className: "text-center",
            width: "20%"
          }, {
            data: "scanDate",
            className: "text-center",
            width: "15%",
            render: function render(data, type, full, meta) {
              return moment(data).format("DD/MM/YYYY HH:mm:ss");
            }
          }, { data: "scanBy", className: "text-center", width: "15%" }, {
            data: "barcodeNoOld",
            className: "text-center",
            width: "10%",
            sortable: false,
            render: function render(data, type, full, meta) {
              return '<div class="actions"></div>';
            }
          }, {
            data: "spareParts",
            render: function render(data, type, full, meta) {
              var parts = [];
              data.forEach(function (part) {
                if (part.materialCode) {
                  parts.push(part.customSparePartName + " (" + part.materialCode + ")");
                } else {
                  parts.push(part.customSparePartName);
                }
              });
              return parts.join(", ");
            }
          }],
          drawCallback: function drawCallback(settings) {
            // Need to redo the counters if filtered or sorted
            for (var i = 0, iLen = settings.aiDisplay.length; i < iLen; i++) {
              $("td:eq(0)", settings.aoData[settings.aiDisplay[i]].nTr).html(settings._iDisplayStart + i + 1);
              $('[data-toggle="popover"]', settings.aoData[settings.aiDisplay[i]].nTr).popover();
            }
          }
        });
      }
    },
    onShowLocalBarcodeClick: function onShowLocalBarcodeClick(item) {
      var _this2 = this;

      this.localBarcodes = [];

      var i = 0;
      item.barcodes.forEach(function (barcode) {
        _this2.localBarcodes.push([++i, barcode.barcodeNoOld, barcode.departmentMaterialCode, moment(barcode.scanDate).format("DD/MM/YYYY HH:mm:ss"), barcode.scanBy]);
      });

      this.localMaterialName = item.materialName;
      this.localMaterialCode = item.materialCode;

      var table = $(this.$refs.barcodeLocalTable).DataTable();
      table.clear().draw();
      table.rows.add(this.localBarcodes).draw();

      // this.localBarcodes.forEach(barcode => {
      //   barcode.scanDateText = moment(barcode.scanDate).format(
      //     "DD/MM/YYYY HH:mm:ss"
      //   );
      // });

      $(this.$refs.barcodeLocalModal).modal("show");
    },
    onTransitIdChange: function onTransitIdChange(id, value, data, ref) {
      var self = this;
      if (self.isTransitInit && (self.jobStatus == "JOB_STATUS_PENDING" || self.jobStatus == "JOB_STATUS_PICKUP") && value) {
        // -- Begin Submit Barcode
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/SetTransit", {
          jobId: self.$route.params.id,
          transitId: value
        }).then(function (response) {
          toastr.options = {
            closeButton: true,
            debug: false,
            newestOnTop: false,
            progressBar: false,
            positionClass: "toast-bottom-right",
            preventDuplicates: false,
            onclick: null,
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "5000",
            extendedTimeOut: "5000",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut"
          };

          if (response.data.status) {
            toastr.success(response.data.message);
          } else {
            toastr.error(response.data.message);
          }
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }).then(function () {});
        // -- End Submit Barcode
      }
    },
    canCommit: function canCommit() {
      return this.isShowOnJobTypes("PICKUP") && this.jobStatus == "JOB_STATUS_PICKUP" || this.evidenceRequired && this.evidenceCanPickFromGallery && (this.jobStatus == "JOB_STATUS_WAITING" || this.jobStatus == "JOB_STATUS_PENDING");
    },
    initEvidenceUploader: function initEvidenceUploader() {
      var self = this;
      var uploader = new __WEBPACK_IMPORTED_MODULE_2_plupload___default.a.Uploader({
        runtimes: "html5",

        browse_button: "uploader-evidence",

        url: "/Components/Plupload?reference=" + self.uuid_evidence,

        max_retries: 5,

        chunk_size: "1mb",

        filters: {
          max_file_size: "10mb",
          mime_types: [{
            title: "Image files",
            extensions: "jpg,jpeg,png,JPG,JPEG,PNG"
          }]
        },
        resize: {
          width: 640,
          quality: 100
        },

        multi_selection: false,

        init: {
          BeforeUpload: function BeforeUpload(up) {
            up.settings.url = "/Components/Plupload?reference=" + self.uuid_evidence;
          },
          FilesAdded: function FilesAdded(up, files) {
            Swal.fire({
              title: "ระบบกำลังอัพโหลดรูปภาพหลักฐาน",
              html: "กรุณารอสักครู่...",
              onBeforeOpen: function onBeforeOpen() {
                Swal.showLoading();
              }
            });

            up.start();
          },

          UploadComplete: function UploadComplete(up, files) {
            self.evidenceRefCode = self.uuid_evidence;
            self.evidenceFileName = files[0].name;
            up.splice();
            self.uuid_evidence = self.$uuid.v1();
            Swal.fire("สำเร็จ", "อัพโหลดรูปภาพหลักฐานสำเร็จ", "success");
          },

          Error: function Error(up, err) {
            Swal.fire("เกิดข้อผิดพลาด", "File Id " + err.file.id + " Error #" + err.code + ": " + err.message, "error");
          }
        }
      });
      uploader.init();
    },
    initDOUploader: function initDOUploader() {
      var self = this;
      if (self.doUploader) {
        self.doUploader.destroy();
        self.doUploader = null;
      }
      self.doUploader = new __WEBPACK_IMPORTED_MODULE_2_plupload___default.a.Uploader({
        runtimes: "html5",

        browse_button: self.$refs.uploadDOBtn, // you can pass in id...
        container: self.$refs.uploadDOBtnContainer, // ... or DOM Element itself

        url: "/Components/Plupload?reference=" + self.uuid,

        max_retries: 5,

        chunk_size: "1mb",

        filters: {
          max_file_size: "10mb",
          mime_types: [{ title: "Excel file", extensions: "xlsx" }]
        },

        // multi_selection: false,

        init: {
          BeforeUpload: function BeforeUpload(up) {
            up.settings.url = "/Components/Plupload?reference=" + self.uuid;
          },
          FilesAdded: function FilesAdded(up, files) {
            Swal.fire({
              title: "ระบบกำลังอัพโหลดไฟล์",
              html: "กรุณารอสักครู่...",
              onBeforeOpen: function onBeforeOpen() {
                Swal.showLoading();
              }
            });

            up.start();
          },

          UploadComplete: function UploadComplete(up, files) {
            // Commit upload files
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/ImportDOExcel", {
              jobId: self.$route.params.id,
              fileNames: $.map(files, function (obj, idx) {
                return obj.name;
              }),
              reference: self.uuid
            }).then(function (response) {
              var valides = 0;
              var invalides = 0;

              if (response.data.status) {
                response.data.data.forEach(function (doc) {
                  if ($.grep(self.refDocuments, function (curr, idx) {
                    if (curr.documentNumber == doc.documentNumber) {
                      $.extend(curr, doc);
                      return true;
                    }
                    return false;
                  }).length == 0) {
                    if (self.$route.meta.jobType == "TRANSFER_TO_AGENT") {
                      if (self.originLocationId == doc.plantCode) {
                        valides++;
                        self.refDocuments.push(doc);
                      } else {
                        invalides++;
                      }
                    } else {
                      self.refDocuments.push(doc);
                    }
                  }
                });

                if (self.$route.meta.jobType == "TRANSFER_TO_AGENT") {
                  if (valides > 0 && invalides > 0) {
                    self.onCalculateItemClick(null, response.data.message + " <u>แต่พบบางข้อมูลที่สถานที่ต้นทางไม่ตรงตามที่เลือก ซึ่งระบบจะไม่นำเข้าให้</u><br />คุณต้องการคำนวณรายการสินค้า/ทรัพย์สินหรือไม่? ระบบจะล้างข้อมูลในรายการสินค้า/ทรัพย์สินออกทั้งหมด");
                  } else if (valides > 0 && invalides == 0) {
                    self.onCalculateItemClick(null, response.data.message + "<br />คุณต้องการคำนวณรายการสินค้า/ทรัพย์สินหรือไม่? ระบบจะล้างข้อมูลในรายการสินค้า/ทรัพย์สินออกทั้งหมด");
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", "ไฟล์ที่นำเข้าไม่มีข้อมูลใบส่งสินค้า (Delivery Order)", "error");
                  }
                } else {
                  if (valides > 0) {
                    self.onCalculateItemClick(null, response.data.message + "<br />คุณต้องการคำนวณรายการสินค้า/ทรัพย์สินหรือไม่? ระบบจะล้างข้อมูลในรายการสินค้า/ทรัพย์สินออกทั้งหมด");
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", "ไฟล์ที่นำเข้าไม่มีข้อมูลใบส่งสินค้า (Delivery Order)", "error");
                  }
                }
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            }).catch(function (error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }).then(function () {
              up.splice();
              self.uuid = self.$uuid.v1();
            });
          },

          Error: function Error(up, err) {
            Swal.fire("เกิดข้อผิดพลาด", "File Id " + err.file.id + " Error #" + err.code + ": " + err.message, "error");
          }
        }
      });
      self.doUploader.init();
    },
    initFileUploader: function initFileUploader() {
      var self = this;
      if (self.fileUploader) {
        self.fileUploader.destroy();
        self.fileUploader = null;
      }
      self.fileUploader = new __WEBPACK_IMPORTED_MODULE_2_plupload___default.a.Uploader({
        runtimes: "html5",

        browse_button: self.$refs.uploadFileBtn, // you can pass in id...
        container: self.$refs.uploadFileBtnContainer, // ... or DOM Element itself

        url: "/Components/Plupload?reference=" + self.uuid_attach,

        max_retries: 5,

        chunk_size: "1mb",

        filters: {
          max_file_size: "10mb",
          mime_types: [{ title: "Image files", extensions: "jpg,gif,png" }, { title: "Word files", extensions: "docx,doc" }, { title: "Excel files", extensions: "xlsx,xls" }, { title: "PDF files", extensions: "pdf" }]
        },

        // multi_selection: false,

        init: {
          BeforeUpload: function BeforeUpload(up) {
            up.settings.url = "/Components/Plupload?reference=" + self.uuid_attach;
          },
          FilesAdded: function FilesAdded(up, files) {
            Swal.fire({
              title: "ระบบกำลังอัพโหลดไฟล์",
              html: "กรุณารอสักครู่...",
              onBeforeOpen: function onBeforeOpen() {
                Swal.showLoading();
              }
            });

            up.start();
          },

          UploadComplete: function UploadComplete(up, files) {
            files.forEach(function (file) {
              var blob = file.getNative();
              var fileURL = URL.createObjectURL(blob);
              self.uploadFiles.push({
                fileId: null,
                documentName: file.name,
                fileName: file.name,
                contentType: file.type,
                size: file.size,
                reference: self.uuid_attach,
                fileURL: fileURL,
                isPreview: true
              });
            });
            up.splice();
            Swal.fire("สำเร็จ", "อัพโหลดไฟล์เอกสารสำเร็จ", "success");
          },

          Error: function Error(up, err) {
            Swal.fire("เกิดข้อผิดพลาด", "File Id " + err.file.id + " Error #" + err.code + ": " + err.message, "error");
          }
        }
      });
      self.fileUploader.init();
    },
    openPreview: function openPreview(fileURL) {
      window.open(fileURL, '_blank');
    },
    onOriginLocationChange: function onOriginLocationChange(id, val, data, ref) {
      var self = this;
      console.log('[onOriginLocationChange] Called with:', { id: id, val: val, data: data });

      self.refDocuments = [];
      self.refInvoices = [];
      self.originData = null;
      self.noUseSML = false;

      //alert(self.$route.meta.jobType);
      //alert(data[0].data.locationType);

      /** 
      Check location for Shop or SubAgent to set default checkbox can pick up a    t origin
      JobType : TRANSFER_TO_SHOP only. 
      **/
      if (self.$route.meta.jobType == "TRANSFER_TO_SHOP" || self.$route.meta.jobType == "JOB_TYPE_TRANSFER_TO_SHOP") {
        if (null != data && data.length > 0) {
          if (data[0].data != null && (data[0].data.locationType == "SHOP" || data[0].data.locationType == "SUBAGENT")) {
            self.isSubAgentOrShop = true;
            self.pickupAtOrigin = true;
          } else {
            self.isSubAgentOrShop = false;
            //self.pickupAtOrigin = false;
          }
        }
      }

      //AssignToUsers
      if (self.userIds.length > 0) {
        self.userIds = [];
        this.$refs.userIds.setSelectedData([]);
      }

      // Reset Destination (Single destination)
      self.destinationLocationId = null;
      $("#destinationLocationId").val("").trigger("change");

      // Reset JobDestinations (TRANSFER_TO_MULTI_SHOP - Multiple destinations)
      if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP" || self.$route.meta.jobType == "JOB_TYPE_TRANSFER_TO_MULTI_SHOP") {
        // Clear Select2 UI สำหรับทุก destination
        self.jobDestinations.forEach(function (dest, index) {
          $("#destinationLocationId_" + index).val("").trigger("change");
        });

        // Reset data model with new unique ID
        self.jobDestinations = [{
          _uid: self.nextDestinationUid++, // Assign unique ID
          destinationLocationId: null,
          destinationName: '',
          destinationData: null,
          items: []
        }];
        console.log('[onOriginLocationChange] Reset jobDestinations to 1 empty destination for TRANSFER_TO_MULTI_SHOP');
      }

      if (self.$refs.originLocationId) {
        var originEl = self.$refs.originLocationId.$el;
        var selectedData = $(originEl).select2("data");
        //console.log("selectedData", selectedData[0]);
        if (selectedData.length > 0) {
          self.originData = selectedData[0];
          console.log('[onOriginLocationChange] Set originData:', self.originData);
        }
      }
      if (self.$route.meta.jobType == "RETURN_ADHOC" && self.originData && self.originData.data.locationType == "PLANT") {
        self.findType = true;
        $(self.$refs.barcodeTableWrapper).show();
        $(self.$refs.barcodeTable2Wrapper).hide();
      } else {
        self.findType = false;
        $(self.$refs.barcodeTable2Wrapper).show();
        $(self.$refs.barcodeTableWrapper).hide();
      }
    },
    onDestinationLocationChange: function onDestinationLocationChange(id, val, data, ref) {
      var self = this;
      self.destinationData = null;
      if (self.$refs.destinationLocationId) {
        var destinationEl = self.$refs.destinationLocationId.$el;
        var selectedData = $(destinationEl).select2("data");
        if (selectedData.length > 0) {
          self.destinationData = selectedData[0];
        }
      }
    },
    genOriginQuery: function genOriginQuery(query) {
      var self = this;
      query.jobType = self.$route.meta.jobType;

      // ระบุว่าเป็น origin dropdown เฉพาะ TRANSFER_TO_MULTI_SHOP เพื่อให้ backend จัดเรียง Agent ก่อน Shop
      if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        query.isDestination = false;
      }

      if (self.$route.meta.jobType == "RETRIEVE_NEW_ITEM" || self.$route.meta.jobType == "PRODUCE" || self.$route.meta.jobType == "DESTROY" || self.$route.meta.jobType == "TRANSFER_TO_AGENT" || self.$route.meta.jobType == "REPAIR" || self.$route.meta.jobType == "REPAIR_SUPPLIER" || self.$route.meta.jobType == "BORROW" || self.$route.meta.jobType == "HOLD_CHECKER") {
        query.types = ["PLANT"];
      } else if (self.$route.meta.jobType == "TRANSFER_TO_SHOP" || self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        // Allow both AGENT and SHOP for both create and edit modes
        query.types = ["AGENT", "SHOP"];
      } else if (self.$route.meta.jobType == "RETURN_ADHOC") {
        query.types = ["PLANT", "AGENT", "SHOP"];
      } else if (self.$route.meta.jobType == "EXCHANGE") {
        query.types = ["PLANT", "AGENT"];
      } else if (self.$route.meta.jobType == "RETURN_SUPPLIER") {
        query.types = ["VENDOR"];
      } else if (self.$route.meta.jobType == "PICKUP" || self.$route.meta.jobType == "RETURN" || self.$route.meta.jobType == "NEW_SHOP" || self.$route.meta.jobType == "PM_CHECK" || self.$route.meta.jobType == "EDIT_NFC" || self.$route.meta.jobType == "INSPECTIONS_AND_BORROW_PROPERTY" || self.$route.meta.jobType == "QI_NO_EQUIPMENT" || self.$route.meta.jobType == "TYPING_BARCODE" || self.$route.meta.jobType == "QI_LESS_THAN_61" || self.$route.meta.jobType == "EDIT_SHOP") {
        query.types = ["AGENT"];
      } else if (self.$route.meta.jobType == "BEER_CLAIM") {
        query.types = ["AGENT", "SHOP"];
      }

      return query;
    },
    genDestinationQuery: function genDestinationQuery(query) {
      var self = this;

      if (self.$route.meta.jobType == "RETRIEVE_NEW_ITEM" || self.$route.meta.jobType == "PRODUCE" || self.$route.meta.jobType == "DESTROY" || self.$route.meta.jobType == "REPAIR" || self.$route.meta.jobType == "RETURN" || self.$route.meta.jobType == "HOLD_CHECKER") {
        query.types = ["PLANT"];
      } else if (self.$route.meta.jobType == "REPAIR_SUPPLIER") {
        query.types = ["VENDOR"];
      } else if (self.$route.meta.jobType == "TRANSFER_TO_AGENT" || self.$route.meta.jobType == "BORROW") {
        query.types = ["AGENT", "SHOP"];
      } else if (self.$route.meta.jobType == "TRANSFER_TO_SHOP") {
        // TRANSFER_TO_SHOP - logic เดิม (ไม่เปลี่ยนแปลง)
        if (self.originData && self.originData.data.locationType == "SHOP") {
          query.subAgentCode = self.originLocationId;
          query.types = ["SUBSHOP"];
        } else if (self.originData && self.originData.data.noSML || self.noUseSML) {
          query.agentCodeSAP = self.originLocationId;
          query.types = ["SHOP"];
        }
      } else if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        // ส่ง jobType สำหรับ TRANSFER_TO_MULTI_SHOP เพื่อให้ Handler แสดงรูปแบบพิเศษ
        query.jobType = "TRANSFER_TO_MULTI_SHOP";
        // บอกว่าเป็น Destination (ไม่ใช่ Origin)
        query.isDestination = true;

        console.log('[genDestinationQuery] TRANSFER_TO_MULTI_SHOP - originData:', self.originData);

        if (self.originData && self.originData.data.locationType == "SHOP") {
          // ถ้า Origin เป็น SHOP และเป็น SubAgent (column SubAgent = 1) → แสดง SUBSHOP (L4)
          if (self.originData.data.isSubAgent || self.originData.data.subAgent == 1 || self.originData.data.subAgent === true) {
            query.subAgentCode = self.originLocationId;
            query.types = ["SUBSHOP"];
            console.log('[genDestinationQuery] Origin is SHOP (SubAgent), setting subAgentCode:', self.originLocationId, 'types: SUBSHOP');
          } else {
            // ถ้าเป็น SHOP ธรรมดา → ไม่มีปลายทางที่จะเลือก (ต้องส่งจาก Agent เท่านั้น)
            query.types = ["-1"];
            console.log('[genDestinationQuery] Origin is normal SHOP (not SubAgent), no valid destinations');
          }
        } else if (self.originData && self.originData.data.locationType == "AGENT") {
          // ถ้า Origin เป็น AGENT (L2) → แสดง SHOP ภายใต้ Agent นั้น (L3)
          query.agentCodeSAP = self.originLocationId;
          query.types = ["SHOP"];
          console.log('[genDestinationQuery] Origin is AGENT, setting agentCodeSAP:', self.originLocationId, 'types: SHOP');
        } else if (self.originData && self.originData.data.noSML || self.noUseSML) {
          // กรณีไม่ใช้ SML
          query.agentCodeSAP = self.originLocationId;
          query.types = ["SHOP"];
          console.log('[genDestinationQuery] Origin with noSML, setting agentCodeSAP:', self.originLocationId);
        } else {
          query.types = ["-1"];
          console.log('[genDestinationQuery] No valid origin, setting types to -1');
        }
      } else if (self.$route.meta.jobType == "EXCHANGE") {
        if (self.originData) {
          query.types = [self.originData.data.locationType];
        } else {
          query.types = ["-1"];
        }

        if (self.originData) {
          if (self.originData.data.locationType == "PLANT") {
            query.notPlantCode = self.originLocationId;
          } else if (self.originData.data.locationType == "AGENT") {
            query.notAgentCodeSAP = self.originLocationId;
          } else if (self.originData.data.locationType == "SHOP") {
            query.notShopId = self.originLocationId;
          }
        }
      } else if (self.$route.meta.jobType == "RETURN_SUPPLIER") {
        query.jobType = "RETURN_SUPPLIER";
        query.types = ["PLANT"];
      }

      return query;
    },
    onShowScanModal: function onShowScanModal() {
      $(this.$refs.barcodeScanModal).modal("show");
    },
    genUserQuery: function genUserQuery(query) {
      var self = this;
      var locationType = self.originData ? self.originData.data.locationType : null;

      if (locationType == "SHOP") {
        query.shopCode = self.originLocationId;
      } else if (locationType == "AGENT") {
        query.agentCode = self.originLocationId;
      } else if (locationType == "PLANT") {
        query.plantCode = self.originLocationId;
      }

      query.jobType = self.$route.meta.jobType;
      return query;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, result, arrows, url;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;

              self.uuid = self.$uuid.v1();
              self.uuid_attach = self.$uuid.v1();
              self.uuid_evidence = self.$uuid.v1();

              if (_this3.$root.canShow(['super_admin', 'MANAGE_MASTER', 'JOB_ADMIN_BORROW_APPROVE']) == true) {
                self.isBeerClaimAdmin = true;
              } else {
                if (_typeof(_this3.$root.user.profile.role) == "object") {
                  result = _this3.$root.user.profile.role.filter(function (word) {
                    return word == "ADMIN_BEER_CLAIM";
                  });

                  if (result.length > 0) {
                    self.isBeerClaimAdmin = false;
                  } else {
                    self.isBeerClaimAdmin = true;
                  }
                } else if (typeof _this3.$root.user.profile.role == "string") {
                  if (_this3.$root.user.profile.role == "ADMIN_BEER_CLAIM") {
                    self.isBeerClaimAdmin = false;
                  } else {
                    self.isBeerClaimAdmin = true;
                  }
                } else {
                  self.isBeerClaimAdmin = true;
                }
              }

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.jobDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              self.jobDate = moment();
              $(self.$refs.jobDate).datepicker("update", self.jobDate.format("DD/MM/YYYY")).on("changeDate", function (e) {
                self.jobDate = moment(e.date);
              });

              $(self.$refs.jobForm).validate({
                ignore: ":hidden, .ignore",
                rules: {
                  jobDate: "required",
                  originLocationId: "required",
                  destinationLocationId: "required",
                  finishedProductCode: "required",
                  transitId: self.$route.meta.jobType === "TRANSFER_TO_MULTI_SHOP" ? false : "required"
                },
                messages: {
                  jobDate: "กรุณาเลือกวันที่เอกสาร",
                  originLocationId: "กรุณาเลือกสถานที่ต้นทาง (Origin)",
                  destinationLocationId: "กรุณาเลือกสถานที่ปลายทาง (Destination)",
                  finishedProductCode: "กรุณาเลือกสินค้าที่ต้องการผลิต",
                  transitId: "กรุณาเลือกรถสำหรับขนส่งสินค้า/ทรัพย์สิน"
                }
              });

              self.initDOUploader();
              self.initFileUploader();
              self.initEvidenceUploader();

              if (self.$route.params.id) {
                self.isEdit = true;

                // Edit
                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
                });

                url = "/Api/Jobs/" + _this3.$route.params.id;

                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (response) {
                  if (response.status == 200) {
                    var data = response.data;

                    // เก็บข้อมูลทั้งหมดไว้ใน self.job
                    self.job = data;

                    console.log('[JobForm Edit] Full data from API:', data);
                    console.log('[JobForm Edit] job.items:', data.items);
                    console.log('[JobForm Edit] jobDestinations:', data.jobDestinations);

                    self.isEditable = data.isEditable;
                    self.$route.meta.jobType = data.jobType.replace("JOB_TYPE_", "");
                    self.jobNumber = data.jobNumber;
                    self.jobTypeName = data.jobTypeName;
                    self.jobStatus = data.jobStatus;
                    $(self.$refs.jobDate).datepicker("update", data.jobDate);
                    self.remark = data.remark;
                    self.uploadFiles = data.attachments;
                    self.parentJobType = data.parentJobType;
                    self.parentJobTypeName = data.parentJobTypeName;
                    self.pickupAtOrigin = data.pickupAtOrigin;
                    self.hasApproveProcess = data.hasApproveProcess;
                    self.signatureGridFSId = data.signatureGridFSId;
                    self.signatureFileUrl = data.signatureFileUrl;
                    self.signatureFileInfoId = data.signatureFileInfoId;
                    self.evidenceGridFSId = data.evidenceGridFSId;
                    self.evidenceFileUrl = data.evidenceFileUrl;
                    self.evidenceFileInfoId = data.evidenceFileInfoId;
                    self.evidenceRequired = data.evidenceRequired;
                    self.evidenceCanPickFromGallery = data.evidenceCanPickFromGallery;
                    self.fromJobNumber = data.fromJobNumber;
                    self.fromJobTypeName = data.fromJobTypeName;
                    self.refJobs = data.refJobs;
                    self.productLoan = data.productLoan;

                    if (data.transitId2) {
                      self.transitId2 = data.transitId2;
                      setTimeout(function () {
                        self.$refs.transitId2.setSelectedData({
                          id: data.transitId2,
                          text: data.transitName2
                        });
                      }, 100);
                    }

                    var _loop4 = function _loop4(i) {
                      var item = data.items[i];
                      self.items.push({
                        jobItemId: item.jobItemId,
                        barcodeStatus: item.barcodeStatus,
                        barcodeStatusName: item.barcodeStatusName,
                        materialCode: item.materialCode,
                        materialName: item.materialName,
                        quotaId: item.quotaId,
                        quotaName: item.quotaName,
                        description: item.description,
                        quantity: item.quantity,
                        checkedQuantity: item.checkedQuantity,
                        unitName: item.baseUnit,
                        hasBarcode: item.hasBarcode,
                        isDisabled: item.isDisabled,
                        selectedBarcodeStatusData: {
                          id: item.barcodeStatus,
                          text: item.barcodeStatusName
                        },
                        selectedMaterialCodeData: {
                          id: item.materialCode,
                          text: item.materialName + " [" + item.materialCode + "]",
                          data: {
                            baseUnit: item.baseUnit,
                            materialCode: item.materialCode,
                            hasBarcode: item.hasBarcode
                          }
                        },
                        productLoanReturn: item.productLoanReturn
                      });

                      if (self.showItems && data.jobType != "JOB_TYPE_TRANSFER_TO_MULTI_SHOP") {
                        setTimeout(function () {
                          if (self.$refs.jobItems && self.$refs.jobItems[i]) {
                            self.$refs.jobItems[i].$refs.materialCode.setSelectedData(self.items[i].selectedMaterialCodeData);

                            var matData = self.items[i].selectedMaterialCodeData;
                            if (!matData.data.hasBarcode && (data.jobType == "JOB_TYPE_BORROW" || data.jobType == "JOB_TYPE_DESTROY")) {
                              self.$refs.jobItems[i].$refs.quotaOptions.setSelectedData({
                                id: self.items[i].quotaId,
                                text: self.items[i].quotaName
                              });
                            }
                          }
                        }, 100);
                      }

                      if (data.jobType == "JOB_TYPE_AUDIT_STOCK") {
                        setTimeout(function () {
                          if (self.$refs.jobItems && self.$refs.jobItems[i]) {
                            self.$refs.jobItems[i].$refs.barcodeStatus.setSelectedData(self.items[i].selectedBarcodeStatusData);
                          }
                        }, 100);
                      }
                    };

                    for (var i = 0; i < data.items.length; i++) {
                      _loop4(i);
                    }

                    // alert(data.jobType);

                    if (data.jobType == "JOB_TYPE_RETRIEVE_NEW_ITEM" || data.jobType == "JOB_TYPE_DESTROY" || data.jobType == "JOB_TYPE_REPAIR" || data.jobType == "JOB_TYPE_HOLD_CHECKER") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "PLANT"
                          }
                        });
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_TRANSFER_TO_AGENT") {
                      setTimeout(function () {
                        self.$refs.transitId.setSelectedData({
                          id: data.transitId,
                          text: data.transitName
                        });

                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "PLANT"
                          }
                        });

                        // if (self.pickupAtOrigin) {
                        //   self.$refs.destinationLocationId.setSelectedData({
                        //     id: data.destinationLocationId,
                        //     text: data.destinationLocationName,
                        //     data: {
                        //       locationType: "AGENT"
                        //     }
                        //   });
                        // }
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_BORROW") {
                      setTimeout(function () {
                        if (self.$refs.transitId !== undefined) {
                          self.$refs.transitId.setSelectedData({
                            id: data.transitId,
                            text: data.transitName
                          });
                        }

                        if (self.$refs.originLocationId !== undefined) {
                          self.$refs.originLocationId.setSelectedData({
                            id: data.originLocationId,
                            text: data.originLocationName,
                            data: {
                              locationType: data.originLocationType
                            }
                          });
                        }

                        if (data.destinationLocationId) {
                          setTimeout(function () {
                            if (self.$refs.destinationLocationId !== undefined) {
                              self.$refs.destinationLocationId.setSelectedData({
                                id: data.destinationLocationId,
                                text: data.destinationLocationName,
                                data: {
                                  locationType: data.destinationLocationType
                                }
                              });
                            }
                          }, 100);
                        }
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_PRODUCE") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "PLANT"
                          }
                        });

                        self.$refs.finishedProductCode.setSelectedData({
                          id: data.finishedProductCode,
                          text: data.finishedProductName + " [" + data.finishedProductCode + "]"
                        });
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_RETRIEVE_ITEM") {
                      setTimeout(function () {
                        if (data.transitId) {
                          self.$refs.transitId.setSelectedData({
                            id: data.transitId,
                            text: data.transitName
                          });
                        }

                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: data.originLocationId.length == 7 ? "AGENT" : data.originLocationId.length == 4 ? "PLANT" : "SHOP",
                            noSML: data.originNoSML
                          }
                        });

                        setTimeout(function () {
                          self.noUseSML = data.noUseSML;
                        }, 100);

                        setTimeout(function () {
                          self.$refs.destinationLocationId.setSelectedData({
                            id: data.destinationLocationId,
                            text: data.destinationLocationName,
                            data: {
                              locationType: data.destinationLocationId.length == 7 ? "AGENT" : data.destinationLocationId.length == 4 ? "PLANT" : "SHOP"
                            }
                          });
                        }, 100);
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_REPAIR_SUPPLIER") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "PLANT"
                          }
                        });

                        setTimeout(function () {
                          self.$refs.destinationLocationId.setSelectedData({
                            id: data.destinationLocationId,
                            text: data.destinationLocationName,
                            data: {
                              locationType: "VENDOR"
                            }
                          });
                        }, 100);
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_RETURN_SUPPLIER") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "VENDOR"
                          }
                        });

                        setTimeout(function () {
                          self.$refs.destinationLocationId.setSelectedData({
                            id: data.destinationLocationId,
                            text: data.destinationLocationName,
                            data: {
                              locationType: "PLANT"
                            }
                          });
                        }, 100);
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_RETURN") {
                      setTimeout(function () {
                        self.$refs.transitId.setSelectedData({
                          id: data.transitId,
                          text: data.transitName
                        });

                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "AGENT",
                            noSML: data.originNoSML
                          }
                        });

                        setTimeout(function () {
                          self.noUseSML = data.noUseSML;
                        }, 100);

                        setTimeout(function () {
                          self.$refs.destinationLocationId.setSelectedData({
                            id: data.destinationLocationId,
                            text: data.destinationLocationName,
                            data: {
                              locationType: "PLANT"
                            }
                          });
                        }, 100);

                        //jobAssignToUsers
                        if (data.jobAssignToUsers.length > 0) {
                          setTimeout(function () {
                            var userOptions = $.map(data.jobAssignToUsers, function (obj, idx) {
                              return {
                                id: obj.assignToUserId,
                                text: obj.displayName
                              };
                            });
                            self.$refs.userIds.setSelectedData(userOptions);
                          }, 100);
                        }
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_AUDIT_STOCK") {
                      setTimeout(function () {

                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "AGENT",
                            noSML: data.originNoSML
                          }
                        });
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_PICKUP" || data.jobType == "JOB_TYPE_RETURN_ADHOC") {

                      if (data.jobStatusCode != "JOB_STATUS_SUCCESS" && data.jobStatusCode != "JOB_STATUS_PICKUP") {
                        self.isEdit = true;
                      } else {
                        self.isEdit = false;
                      }

                      self.isPreviousBalance = data.isPreviousBalance;
                      self.isEditableTypePICKUP = false;

                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: data.originLocationType,
                            noSML: data.originNoSML,
                            isPreviousBalance: data.originIsPreviousBalance
                          }
                        });
                      }, 100);

                      //jobAssignToUsers
                      if (data.jobAssignToUsers.length > 0) {
                        setTimeout(function () {
                          var userOptions = $.map(data.jobAssignToUsers, function (obj, idx) {
                            return {
                              id: obj.assignToUserId,
                              text: obj.displayName
                            };
                          });
                          self.$refs.userIds.setSelectedData(userOptions);
                        }, 100);
                      }

                      setTimeout(function () {
                        self.noUseSML = data.noUseSML;
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_TRANSFER_TO_SHOP") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: data.originLocationType,
                            noSML: data.originNoSML
                          }
                        });
                        setTimeout(function () {
                          self.noUseSML = data.noUseSML;
                        }, 100);

                        if (data.originLocationId != data.destinationLocationId) {
                          setTimeout(function () {
                            // ต้องรอ origin เข้า onchange event ก่อน จึงจะ set ได้
                            // หน่วงเวลา
                            if (self.$refs.destinationLocationId !== undefined) {
                              self.$refs.destinationLocationId.setSelectedData({
                                id: data.destinationLocationId,
                                text: data.destinationLocationName,
                                data: {
                                  locationType: data.destinationLocationType
                                }
                              });
                            }
                          }, 100);
                        }

                        //jobAssignToUsers
                        if (data.jobAssignToUsers.length > 0) {
                          setTimeout(function () {
                            var userOptions = $.map(data.jobAssignToUsers, function (obj, idx) {
                              return {
                                id: obj.assignToUserId,
                                text: obj.displayName
                              };
                            });
                            self.$refs.userIds.setSelectedData(userOptions);
                          }, 100);
                        }
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_TRANSFER_TO_MULTI_SHOP") {
                      setTimeout(function () {
                        // Set Transit (รถ)
                        if (data.transitId && self.$refs.transitId) {
                          self.$refs.transitId.setSelectedData({
                            id: data.transitId,
                            text: data.transitName
                          });
                        }

                        // Set Origin
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: data.originLocationType,
                            noSML: data.originNoSML
                          }
                        });

                        setTimeout(function () {
                          self.noUseSML = data.noUseSML;
                        }, 100);

                        // Load JobDestinations
                        console.log('[TRANSFER_TO_MULTI_SHOP] Raw data from API:', data);
                        console.log('[TRANSFER_TO_MULTI_SHOP] jobDestinations:', data.jobDestinations);

                        if (data.jobDestinations && data.jobDestinations.length > 0) {
                          self.jobDestinations = data.jobDestinations.map(function (dest) {
                            return {
                              _uid: self.nextDestinationUid++, // Assign unique ID when loading from API
                              destinationLocationId: dest.destinationLocationId,
                              destinationName: dest.destinationName,
                              items: dest.items || []
                            };
                          });
                          console.log('[TRANSFER_TO_MULTI_SHOP] Loaded jobDestinations:', self.jobDestinations);
                        }

                        // jobAssignToUsers
                        if (data.jobAssignToUsers && data.jobAssignToUsers.length > 0) {
                          setTimeout(function () {
                            var userOptions = $.map(data.jobAssignToUsers, function (obj, idx) {
                              return {
                                id: obj.assignToUserId,
                                text: obj.displayName
                              };
                            });
                            self.$refs.userIds.setSelectedData(userOptions);
                          }, 100);
                        }
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_EXCHANGE") {
                      setTimeout(function () {
                        self.$refs.transitId.setSelectedData({
                          id: data.transitId,
                          text: data.transitName
                        });

                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: data.originLocationId.length == 7 ? "AGENT" : data.originLocationId.length == 4 ? "PLANT" : "SHOP",
                            noSML: data.originNoSML
                          }
                        });

                        setTimeout(function () {
                          self.noUseSML = data.noUseSML;
                        }, 100);

                        setTimeout(function () {
                          self.$refs.destinationLocationId.setSelectedData({
                            id: data.destinationLocationId,
                            text: data.destinationLocationName,
                            data: {
                              locationType: data.destinationLocationId.length == 7 ? "AGENT" : data.destinationLocationId.length == 4 ? "PLANT" : "SHOP"
                            }
                          });
                        }, 100);

                        //jobAssignToUsers
                        if (data.jobAssignToUsers.length > 0) {
                          setTimeout(function () {
                            var userOptions = $.map(data.jobAssignToUsers, function (obj, idx) {
                              return {
                                id: obj.assignToUserId,
                                text: obj.displayName
                              };
                            });
                            self.$refs.userIds.setSelectedData(userOptions);
                          }, 100);
                        }
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_NEW_SHOP") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "AGENT"
                          }
                        });
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_PM_CHECK") {

                      // if (data.destinationLocationId) {
                      //     setTimeout(function() {
                      //       self.$refs.destinationLocationId.setSelectedData({
                      //         id: data.destinationLocationId,
                      //         text: data.destinationLocationName,
                      //         data: {
                      //           locationType: data.destinationLocationType,
                      //         },
                      //       });
                      //     }, 100);
                      //   }

                      if (data.destinationLocationId && data.destinationLocationType == 'SUBSHOP') {
                        setTimeout(function () {
                          self.$refs.originLocationId.setSelectedData({
                            id: data.destinationLocationId,
                            text: data.destinationLocationName,
                            data: {
                              locationType: "SUBSHOP"
                            }
                          });
                        }, 100);
                      } else {
                        setTimeout(function () {
                          self.$refs.originLocationId.setSelectedData({
                            id: data.originLocationId,
                            text: data.originLocationName,
                            data: {
                              locationType: "SHOP"
                            }
                          });
                        }, 100);
                      }
                    } else if (data.jobType == "JOB_TYPE_EDIT_NFC") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "SHOP"
                          }
                        });
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_INSPECTIONS_AND_BORROW_PROPERTY") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "SHOP"
                          }
                        });
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_BEER_CLAIM") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: data.destinationLocationId.length == 7 ? "AGENT" : "SHOP"
                          }
                        });

                        setTimeout(function () {
                          self.$refs.destinationLocationId.setSelectedData({
                            id: data.destinationLocationId,
                            text: data.destinationLocationName,
                            data: {
                              locationType: data.destinationLocationType
                            }
                          });
                        }, 100);
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_QI_NO_EQUIPMENT") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "SHOP"
                          }
                        });
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_TYPING_BARCODE") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "SHOP"
                          }
                        });
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_QI_LESS_THAN_61") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "SHOP"
                          }
                        });
                      }, 100);
                    } else if (data.jobType == "JOB_TYPE_EDIT_SHOP") {
                      setTimeout(function () {
                        self.$refs.originLocationId.setSelectedData({
                          id: data.originLocationId,
                          text: data.originLocationName,
                          data: {
                            locationType: "AGENT"
                          }
                        });
                      }, 100);
                    }

                    if (data.jobType == "JOB_TYPE_PICKUP") {
                      if (data.jobStatus == "JOB_STATUS_SUCCESS" || data.jobStatus == "JOB_STATUS_PICKUP") {
                        self.showItems = false;
                      }
                      self.shopItems = data.shopItems;
                      self.shopReturnItems = data.shopReturnItems;
                      self.pickupItems = data.pickupItems;
                      self.pickupReturnItems = data.pickupReturnItems;

                      setTimeout(function () {
                        for (var i = 0; i < self.shopItems.length; i++) {
                          var _item = self.shopItems[i];
                          if (_item.shopCode) {
                            self.$refs.shopCodes[i].setSelectedData({
                              id: _item.shopCode,
                              text: _item.shopCodeName
                            });
                          }
                        }
                      }, 100);

                      if (data.noUseSML && data.jobStatus != "JOB_STATUS_WAITING") {
                        self.ItemHistory = data.itemHistory;
                      }
                    }

                    setTimeout(function () {
                      self.refDocuments = data.refDocuments;
                      self.refInvoices = data.refInvoices;
                      self.isTransitInit = true;

                      setTimeout(function () {
                        $(".sml-bill-number.required").each(function () {
                          var $input = $(this);
                          $input.rules("add", {
                            required: true,
                            messages: {
                              required: "กรุณากรอกเลขที่บิลขาย"
                            }
                          });
                        });

                        self.initDOUploader();
                        self.initFileUploader();
                        self.initEvidenceUploader();
                      }, 100);
                    }, 100);
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลลูกค้าที่คุณเลือก", "warning");
                    KTApp.unblockPage();
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลลูกค้าได้ในขณะนี้", "error");
                  KTApp.unblockPage();
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

                $(self.$refs.barcodeLocalTable).DataTable({
                  responsive: true,
                  data: _this3.localBarcodes,

                  // DOM Layout settings
                  dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n            <'row'<'col-sm-12'tr>>\n            <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                  lengthMenu: [50, 100, 200, 500],

                  pageLength: 100,

                  language: {
                    lengthMenu: "Display _MENU_"
                  },

                  // Order settings
                  order: [[1, "desc"]],

                  columns: [{
                    className: "text-center",
                    width: "5%",
                    sortable: false
                  }, { className: "text-center", width: "20%" }, { className: "text-center", width: "20%" }, {
                    className: "text-center",
                    width: "20%"
                  }, { className: "text-center" }],

                  drawCallback: function drawCallback(settings) {
                    for (var i = 0, iLen = settings._iDisplayLength; i < iLen; i++) {
                      $("tbody tr:eq(" + i + ") td:eq(0)", self.$refs.barcodeLocalTable).html(settings._iDisplayStart + i + 1);
                    }

                    $('[data-toggle="popover"]', self.$refs.barcodeLocalTable).popover();
                  }
                });

                $(self.$refs.barcodeScanTable).DataTable({
                  responsive: true,
                  data: _this3.scanBarcodeResults,

                  // DOM Layout settings
                  dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n            <'row'<'col-sm-12'tr>>\n            <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                  lengthMenu: [50, 100, 200, 500],

                  pageLength: 100,

                  language: {
                    lengthMenu: "Display _MENU_"
                  },

                  // Order settings
                  order: [[1, "desc"]],

                  columns: [{
                    data: "barcodeNo",
                    className: "text-center",
                    width: "5%",
                    sortable: false
                  }, { data: "barcodeNoOld", className: "text-center", width: "20%" }, { data: "departmentMaterialCode", className: "text-center", width: "20%" }, { data: "message", className: "text-center" }],

                  drawCallback: function drawCallback(settings) {
                    // Need to redo the counters if filtered or sorted
                    for (var i = 0, iLen = settings._iDisplayLength; i < iLen; i++) {
                      $("tbody tr:eq(" + i + ") td:eq(0)", self.$refs.barcodeScanTable).html(settings._iDisplayStart + i + 1);
                    }

                    $('[data-toggle="popover"]', self.$refs.barcodeScanTable).popover();
                  }
                });
              } else {
                // Create
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/MasterLocation/Select2JobLocation", self.genOriginQuery({
                  search: "",
                  page: 1
                })).then(function (response) {
                  if (response.status == 200) {
                    var data = response.data;

                    // Debug: Log to see what API returns
                    console.log('[TRANSFER_TO_MULTI_SHOP] Origin API Response:', data.results);

                    if (data.results.length > 0) {
                      var firstOrigin = data.results[0];

                      // For TRANSFER_TO_SHOP and TRANSFER_TO_MULTI_SHOP, prefer AGENT over SHOP as default
                      if (self.$route.meta.jobType == "TRANSFER_TO_SHOP" || self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP" || self.$route.meta.jobType == "AUDIT_STOCK") {

                        var agentOrigin = data.results.find(function (item) {
                          return item.data && item.data.locationType == "AGENT";
                        });
                        console.log('[TRANSFER_TO_MULTI_SHOP] Found AGENT:', agentOrigin);
                        if (agentOrigin) {
                          firstOrigin = agentOrigin;
                        }
                      }

                      console.log('[TRANSFER_TO_MULTI_SHOP] Setting default origin:', firstOrigin);
                      self.$refs.originLocationId.setSelectedData(firstOrigin);

                      // Manually trigger onOriginLocationChange to set originData
                      setTimeout(function () {
                        if (self.$refs.originLocationId) {
                          var originEl = self.$refs.originLocationId.$el;
                          var selectedData = $(originEl).select2("data");
                          console.log('[TRANSFER_TO_MULTI_SHOP] After setSelectedData, select2 data:', selectedData);
                          if (selectedData.length > 0) {
                            self.onOriginLocationChange(selectedData[0].id, selectedData[0].id, selectedData, self.$refs.originLocationId);
                          }
                        }
                      }, 100);
                    }
                  }
                }).finally(function () {
                  // Skip auto-selecting destination for TRANSFER_TO_MULTI_SHOP (uses multiple destinations)
                  if (self.$route.meta.jobType != "EXCHANGE" && self.$route.meta.jobType != "TRANSFER_TO_MULTI_SHOP") {
                    setTimeout(function () {
                      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/MasterLocation/Select2JobLocation", self.genDestinationQuery({
                        search: "",
                        page: 1
                      })).then(function (response) {
                        if (response.status == 200) {
                          var data = response.data;
                          if (data.results.length > 0) {
                            var firstDestination = data.results[0];
                            if (firstDestination && self.$refs.destinationLocationId !== undefined) {
                              self.$refs.destinationLocationId.setSelectedData(firstDestination);
                            }
                          }
                        }
                      });
                    }, 100);
                  }
                });
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },

  computed: {
    // showOriginLocation() {
    //   return this.isShowOnJobTypes([
    //     "TRANSFER_TO_AGENT",
    //     "TRANSFER_TO_SHOP",
    //     "EXCHANGE",
    //     "BORROW",
    //     ["RETRIEVE_ITEM", "JOB_TYPE_TRANSFER_TO_AGENT"],
    //     ["RETRIEVE_ITEM", "JOB_TYPE_TRANSFER_TO_SHOP"],
    //     ["RETRIEVE_ITEM", "JOB_TYPE_EXCHANGE"],
    //     ["RETRIEVE_ITEM", "JOB_TYPE_BORROW"],
    //   ]);
    // },
    // showDestinationLocation() {
    //   return (
    //     // this.originLocationId != this.destinationLocationId &&
    //     this.isShowOnJobTypes([
    //       "RETRIEVE_ITEM",
    //       "REPAIR_SUPPLIER",
    //       "RETURN_SUPPLIER",
    //       "RETURN",
    //       "EXCHANGE",
    //       "BEER_CLAIM",
    //     ]) ||
    //     (this.$route.meta.jobType == "BORROW" && !this.pickupAtOrigin) ||
    //     (this.$route.meta.jobType == "TRANSFER_TO_SHOP" &&
    //       this.originData &&
    //       this.originData.data.locationType == "SHOP") ||
    //     (this.$route.meta.jobType == "TRANSFER_TO_SHOP" &&
    //       this.originData &&
    //       (this.originData.data.noSML || this.noUseSML))
    //   );
    // },
    showSmlBillNumber: function showSmlBillNumber() {
      //return !(this.originData && this.originData.data.locationType == "AGENT" && this.originData.data.noSML);
      return this.originData && this.originData.data.locationType == "AGENT" && !this.originData.data.noSML && !this.noUseSML;
    },
    showRefInvoices: function showRefInvoices() {
      //console.log("showRefInvoices");
      if (this.originData) {
        return this.isShowOnJobTypes(['RETURN', ['RETRIEVE_ITEM', 'JOB_TYPE_RETURN'], 'EXCHANGE', ['RETRIEVE_ITEM', 'JOB_TYPE_EXCHANGE'], 'PICKUP', ['RETRIEVE_ITEM', 'JOB_TYPE_PICKUP']]) && this.originData.data.locationType == 'AGENT' && !this.originData.data.noSML && !this.noUseSML;

        //   return (
        //     this.isShowOnJobTypes([
        //       "PICKUP",
        //       "RETURN",
        //       "EXCHANGE",
        //       ["RETRIEVE_ITEM", "JOB_TYPE_PICKUP"],
        //       ["RETRIEVE_ITEM", "JOB_TYPE_RETURN"],
        //       ["RETRIEVE_ITEM", "JOB_TYPE_EXCHANGE"],
        //     ]) &&
        //     !(this.originData.data.locationType == "AGENT" && this.originData.data.noSML) &&
        //     this.originData.data.locationType != "PLANT"
        //   );
      } else {
        return this.isShowOnJobTypes(["PICKUP", "RETURN", ["RETRIEVE_ITEM", "JOB_TYPE_PICKUP"]]);
      }
    },
    canPickupAtOrigin: function canPickupAtOrigin() {
      var self = this;
      var shipTos = [];

      self.refDocuments.forEach(function (doc) {
        var exists = $.grep(shipTos, function (obj, idx) {
          return obj == doc.shipTo;
        });

        if (exists.length == 0) {
          shipTos.push(doc.shipTo);
        }
      });

      self.refInvoices.forEach(function (doc) {
        var exists = $.grep(shipTos, function (obj, idx) {
          return obj == doc.shipTo;
        });

        if (exists.length == 0) {
          shipTos.push(doc.shipTo);
        }
      });

      if (shipTos.length <= 1) {
        return true;
      } else {
        self.pickupAtOrigin = false; // reset
        return false;
      }
    },
    canPickupAtOriginMultiShop: function canPickupAtOriginMultiShop() {
      var self = this;

      // สำหรับ TRANSFER_TO_MULTI_SHOP ตรวจสอบจำนวน destinations
      if (self.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        if (self.jobDestinations.length <= 1) {
          return true;
        } else {
          self.pickupAtOrigin = false; // uncheck และ disable เมื่อมีมากกว่า 1 ปลายทาง
          return false;
        }
      }

      // สำหรับ job types อื่นๆ ใช้ logic เดิม
      return self.canPickupAtOrigin;
    }
  },
  watch: {
    "$refs.destinationLocationId": function $refsDestinationLocationId(newValue, oldValue) {
      if (newValue && !oldValue && this.destinationData) {}
    },

    // Watch jobDestinations length สำหรับ TRANSFER_TO_MULTI_SHOP
    "jobDestinations.length": function jobDestinationsLength(newLength, oldLength) {
      if (this.$route.meta.jobType == "TRANSFER_TO_MULTI_SHOP") {
        // ถ้ามีปลายทางมากกว่า 1 → uncheck pickupAtOrigin
        if (newLength > 1 && this.pickupAtOrigin) {
          this.pickupAtOrigin = false;
          console.log('[TRANSFER_TO_MULTI_SHOP] Unchecked pickupAtOrigin because destinations > 1');
        }
      }
    }
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      uuid: "",
      job: {},
      uploader: null,
      uploadErrors: null
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();
    },
    commitJob: function commitJob() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;
      // -- Begin Commit Job
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Jobs/Commit", {
        jobId: self.job.jobId,
        force: force
      }).then(function (response) {
        if (response.data.status) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire("สำเร็จ", response.data.message, "success");
          self.$parent.reloadDataTable();
          $(self.$el).modal("hide");
        } else {
          var msg = response.data.message;
          if (response.data.errors) {
            msg += "<div class='text-left mt-3'>หากคุณต้องการปิดใบงานนี้ กรุณายืนยันอีกครั้งโดยคลิกปุ่ม <strong>ฉันต้องการปิดใบงานนี้</strong><br /><br />สาเหตุ: <ul>";
            for (var key in response.data.errors) {
              if (response.data.errors.hasOwnProperty(key)) {
                var err = response.data.errors[key];
                msg += "<li>" + err[1] + "</li>";
              }
            }
            msg += "</ul></div>";
          }

          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
            title: "เกิดข้อผิดพลาด",
            html: msg,
            type: "error",
            showCancelButton: true,
            confirmButtonText: "<i class='fa fa-archive'></i> ฉันต้องการปิดใบงานนี้",
            cancelButtonText: "ตรวจสอบข้อมูล"
          }).then(function (result) {
            if (result.value) {
              self.commitJob(true);
            }
          });
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
      // -- End Commit Job
    }
  },
  mounted: function mounted() {
    var self = this;
    self.uuid = self.$uuid.v1();

    $(self.$refs.modal).on("hidden.bs.modal", function () {
      self.uuid = self.$uuid.v1();
      self.job = {};
      self.uploadErrors = null;
    });

    // Init Uploader
    self.uploader = new __WEBPACK_IMPORTED_MODULE_1_plupload___default.a.Uploader({
      runtimes: "html5",

      browse_button: self.$refs.uploadBtn, // you can pass in id...
      container: self.$refs.uploadBtnContainer, // ... or DOM Element itself

      url: "/Components/Plupload?reference=" + self.uuid,

      max_retries: 5,

      chunk_size: "1mb",

      filters: {
        max_file_size: "10mb",
        mime_types: [{ title: "Text file", extensions: "txt,json" }]
      },

      init: {
        FilesAdded: function FilesAdded(up, files) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
            title: "ระบบกำลังอัพโหลดไฟล์",
            html: "กรุณารอสักครู่...",
            onBeforeOpen: function onBeforeOpen() {
              __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.showLoading();
            }
          });

          up.start();
        },

        UploadComplete: function UploadComplete(up, files) {
          // Commit upload files
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Jobs/Upload", {
            jobId: self.job.jobId,
            fileName: files[0].name,
            reference: self.uuid
          }).then(function (response) {
            if (response.data.status) {
              self.uploadErrors = null;
              __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
                title: "อัพโหลดไฟล์สำเร็จ",
                html: response.data.message + "<br />คุณต้องการ <strong>ปิดใบงาน</strong> ตอนนี้หรือไม่?",
                type: "success",
                showCancelButton: true,
                confirmButtonText: "<i class='fa fa-archive'></i> ปิดใบงานเดี๋ยวนี้",
                cancelButtonText: "ไว้คราวหลัง"
              }).then(function (result) {
                if (result.value) {
                  self.commitJob();
                }
              });
            } else {
              self.uploadErrors = response.data.errors;
              __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            self.uploadErrors = error.response.data.errors;
            __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          });
        },

        Error: function Error(up, err) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire("เกิดข้อผิดพลาด", "File Id " + err.file.id + " Error #" + err.code + ": " + err.message, "error");
        }
      }
    });

    self.uploader.init();
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */]
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    },
    jobType: {
      type: String
    },
    originLocationId: {
      type: String
    },
    originData: {
      type: Object
    },
    noUseSML: {
      type: Boolean,
      default: false
    },
    parentJobType: {
      type: String
    },
    allItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var self = this;
    return {
      materialCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า/ทรัพย์สิน",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              productGroupId: 0
            };

            // if (
            //   self.jobType == "RETRIEVE_NEW_ITEM" ||
            //   self.jobType == "PRODUCE" ||
            //   self.jobType == "REPAIR" ||
            //   self.jobType == "REPAIR_SUPPLIER" ||
            //   self.jobType == "RETURN_SUPPLIER" ||
            //   self.jobType == "RETURN" ||
            //   self.jobType == "RETURN_ADHOC" ||
            //   self.jobType == "EXCHANGE" ||
            //   self.jobType == "BORROW"
            // ) {
            //   // เครื่องและอุปกรณ์เบียร์สด
            //   query.productGroupId = 1;
            // } else if (
            //   self.jobType == "TRANSFER_TO_AGENT" ||
            //   self.jobType == "TRANSFER_TO_SHOP" ||
            //   self.jobType == "PICKUP"
            // ) {
            //   // สินค้าสำเร็จรูป
            //   query.productGroupId = 14;
            // } else if (self.jobType == "DESTROY") {
            //   if (self.originLocationId == "9901") {
            //     delete query.productGroupId;
            //   } else {
            //     // เครื่องและอุปกรณ์เบียร์สด
            //     query.productGroupId = 1;
            //     // ถ้าไม่ใช่ 9901 คลังปากเกร็ด ให้แสดงเฉพาะที่มีบาร์โค้ด
            //     query.onlyHasBarcode = true;
            //   }
            // }

            // if (self.noUseSML) {
            //   delete query.productGroupId;
            // }
            // console.log(self.jobType, self.originData);

            if (self.jobType == "RETRIEVE_NEW_ITEM" || self.jobType == "PRODUCE" || self.jobType == "TRANSFER_TO_AGENT" || self.jobType == "RETRIEVE_ITEM" || self.jobType == "REPAIR" || self.jobType == "REPAIR_SUPPLIER" || self.jobType == "PICKUP" || self.jobType == "EXCHANGE" || self.jobType == "RETURN" || self.jobType == "RETURN_ADHOC" || self.jobType == "RETURN_SUPPLIER" || self.jobType == "HOLD_CHECKER") {
              delete query.productGroupId;
              query.onlyHasBarcode = true;
              if (self.parentJobType == "JOB_TYPE_RETURN" && self.jobType == "RETRIEVE_ITEM" || self.jobType == "RETURN") {
                query.excludeProductGroupId = 14;
              }
            } else if (self.jobType == "AUDIT_STOCK") {

              // 👉 หา row ปัจจุบัน
              var $row = $(this).closest('tr');
              // 👉 ดึงค่าสถานะ BARCODE ใน row เดียวกัน
              var barcodeStatus = $row.find('.select-barcode-status').val();

              // ส่งสินค้าไปยังร้านค้าหลายแห่ง: exclude productTypeId 4,5
              delete query.productGroupId;
              query.onlyHasBarcode = false;
              // // jQuery จะ serialize เป็น excludeProductTypeIds=4&excludeProductTypeIds=5
              // // ASP.NET Core Model Binder จะรับเป็น int[] อัตโนมัติ
              query.excludeProductTypeIds = [99];
              query.barcodeStatusCode = barcodeStatus;
            } else if (self.jobType == "TRANSFER_TO_MULTI_SHOP") {
              // ส่งสินค้าไปยังร้านค้าหลายแห่ง: exclude productTypeId 4,5
              delete query.productGroupId;
              query.onlyHasBarcode = false;
              // jQuery จะ serialize เป็น excludeProductTypeIds=4&excludeProductTypeIds=5
              // ASP.NET Core Model Binder จะรับเป็น int[] อัตโนมัติ
              query.excludeProductTypeIds = [4, 5];
            } else if (self.jobType == "TRANSFER_TO_SHOP") {
              if (self.originData && self.originData.data.locationType == "AGENT" && !self.originData.data.noSML && !self.noUseSML) {
                // ตัวแทนฯที่ใช้ SML และไม่ได้เลือก "ไม่อ้างอิงข้อมูลระบบ SML" : แสดงเฉพาะสินค้าที่มีบาร์โค้ด
                delete query.productGroupId;
                query.onlyHasBarcode = true;
              } else {
                // ตัวแทนฯที่ใช้ SML และเลือก "ไม่อ้างอิงข้อมูลระบบ SML" : แสดงทุกสินค้า ยกเว้น สินค้า PRODUCT_GROUP_ID = 14
                // ตัวแทนฯที่ไม่ใช้ SML : แสดงทุกสินค้า ยกเว้น สินค้า PRODUCT_GROUP_ID = 14
                delete query.productGroupId;
                query.excludeProductGroupId = 14;
              }
            } else if (self.jobType == "DESTROY") {
              if (self.originData && self.originData.data.locationType == "PLANT" && self.originData.id == "9901") {
                // โปรไฟล์ คลังปากเกร็ด : แสดงทุกสินค้า ยกเว้น สินค้า PRODUCT_GROUP_ID = 14
                delete query.productGroupId;
                query.excludeProductGroupId = 14;
              } else {
                // อื่นๆ : แสดงเฉพาะสินค้าที่มีบาร์โค้ด
                delete query.productGroupId;
                query.onlyHasBarcode = true;
              }
            }

            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            // ตั้งค่า traditional: true เพื่อให้ serialize array ถูกต้องสำหรับ ASP.NET Core
            // จาก excludeProductTypeIds[]=4 เป็น excludeProductTypeIds=4&excludeProductTypeIds=5
            params.traditional = true;
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      quotaOptions: {
        placeholder: "กรุณาเลือกโควต้าสำหรับตัดสต๊อค",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Quota/Select2Quota",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      MbBarcodeStatusOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Barcode/Select2BarcodeAuditStockStatus",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              all: true
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }

    };
  },

  methods: {
    onQuotaMounted: function onQuotaMounted(sender) {
      var $input = $(sender);
      $input.rules("add", {
        required: true,
        messages: {
          required: "กรุณาเลือกโควต้าสำหรับอัพเดทสต็อก"
        }
      });
    },
    onRemoveItemClick: function onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    },
    onShowBarcodeClick: function onShowBarcodeClick(e) {
      this.$emit("showBarcode", this.rowIndex, this.item);
    },
    checkDuplicateAuditStockItem: function checkDuplicateAuditStockItem(materialCode, barcodeStatus) {
      if (this.jobType !== "AUDIT_STOCK" || !materialCode || !barcodeStatus) {
        return false;
      }
      var isDuplicate = $.grep(this.allItems, function (obj, i) {
        return obj.materialCode === materialCode && obj.barcodeStatus === barcodeStatus;
      });
      // มากกว่า 1 เพราะรวมแถวปัจจุบันด้วย
      if (isDuplicate.length > 1) {
        Swal.fire("เกิดข้อผิดพลาด", "สถานะบาร์โค้ดและสินค้า/ทรัพย์สินซ้ำกับรายการที่มีอยู่แล้ว", "warning");
        return true;
      }
      return false;
    },
    onMaterialCodeChange: function onMaterialCodeChange(id, value, data, ref) {
      if (value) {
        var selected = data[0];
        this.item.selectedMaterialCodeData = selected;
        this.item.unitName = selected.data.baseUnit;

        // Auto-select barcode status for AUDIT_STOCK based on product type
        if (this.jobType === "AUDIT_STOCK" && selected.data.productTypeId) {
          var typeId = selected.data.productTypeId;
          var statusCode, statusText;

          if (typeId === 4 || typeId === 5) {
            statusCode = "PRODUCT_BARCODE_STATUS_NOT_READY";
            statusText = "ถังเปล่า";
          } else if (typeId === 22) {
            statusCode = "PRODUCT_BARCODE_STATUS_READY_TO_SHIP";
            statusText = "ถังเต็ม";
          } else {
            statusCode = "PRODUCT_BARCODE_STATUS_OCCUPIED";
            statusText = "ระหว่างใช้งาน";
          }

          this.$refs.barcodeStatus.setSelectedData({
            id: statusCode,
            text: statusText
          });
          this.barcodeStatus = statusCode;
        }

        // ตรวจสอบซ้ำ: สถานะบาร์โค้ด + สินค้า
        if (this.checkDuplicateAuditStockItem(value, this.barcodeStatus)) {
          this.item.materialCode = null;
          this.item.selectedMaterialCodeData = null;
          this.item.unitName = null;
          $(this.$refs.materialCode.$refs.select).val("").trigger("change");
          return;
        }
      } else {
        this.item.unitName = null;
        delete this.item.selectedMaterialCodeData;
      }

      var $form = $("#" + id).parents("form");
      $form.validate().element("#" + id);
    },
    onBarcodeStatusChange: function onBarcodeStatusChange(id, value, data, ref) {
      this.barcodeStatus = value;

      // ตรวจสอบซ้ำ: สถานะบาร์โค้ด + สินค้า
      if (this.item.materialCode && this.checkDuplicateAuditStockItem(this.item.materialCode, value)) {
        this.item.barcodeStatus = null;
        this.barcodeStatus = null;
        $(this.$refs.barcodeStatus.$refs.select).val("").trigger("change");
        return;
      }

      var $form = $("#" + id).parents("form");
      $form.validate().element("#" + id);
    }
  },
  mounted: function mounted() {

    $(".required", this.$el).each(function () {
      var $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required")
        }
      });
    });

    $(".min", this.$el).each(function () {
      var $input = $(this);
      $input.rules("add", {
        min: true,
        messages: {
          min: $input.data("msg-min")
        }
      });
    });
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JobImportBarcodeForm__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__JobAddSpareProductList__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_DatatableWarning__ = __webpack_require__(24);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

// CR-Job-Stock: route helper — write-off jobs use dedicated route
function getJobEditPath(data) {
  if (data && data.jobTypeCode === "JOB_TYPE_WRITE_OFF_STOCK") {
    return "/Jobs/WriteOffStock/Edit/" + data.jobId;
  }
  return "/Jobs/Edit/" + data.jobId;
}
function getJobViewPath(data) {
  if (data && data.jobTypeCode === "JOB_TYPE_WRITE_OFF_STOCK") {
    return "/Jobs/WriteOffStock/View/" + data.jobId;
  }
  // existing jobs use /Jobs/Edit/:id even when not editable (read-only handled inside JobForm)
  return "/Jobs/Edit/" + data.jobId;
}

var JobActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n\n    <a v-if=\"!data.isEditable && (data.jobTypeCode != 'JOB_TYPE_WRITE_OFF_STOCK' || $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT']))\" :href=\"getViewUrl(data)\" @click.prevent=\"view\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E1A\u0E07\u0E32\u0E19\">\n      <i class=\"fa fa-search\"></i>\n    </a>\n\n    <a v-if=\"data.isDeletable && data.jobTypeCode != 'JOB_TYPE_AUDIT_STOCK'\" href=\"#\" @click.prevent=\"setValidate\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\"\n      :title=\"!data.isNoValidate ? '\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E1A\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14' : '\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E1A\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14'\">\n      <i class=\"fa\" :class=\"{ 'fa-lock kt-font-success': !data.isNoValidate, 'fa-unlock kt-font-danger': data.isNoValidate }\"></i>\n    </a>\n\n    <a v-if=\"data.isOffline\" href=\"#\" @click.prevent=\"upload\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E1F\u0E25\u0E4C Export \u0E08\u0E32\u0E01 Handheld\">\n      <i class=\"fa fa-upload kt-font-dark\"></i>\n    </a>\n\n    <a v-if=\"(data.isOfflineAdminBeerClaim && data.jobTypeCode != 'JOB_TYPE_DESTROY' && data.jobTypeCode != 'JOB_TYPE_PICKUP' && data.jobTypeCode != 'JOB_TYPE_REPAIR' && data.jobTypeCode != 'JOB_TYPE_HOLD_CHECKER' && data.jobTypeCode != 'JOB_TYPE_WRITE_OFF_STOCK' && (data.isOffline || data.jobStatusCode == 'JOB_STATUS_PENDING' || data.jobStatusCode == 'JOB_STATUS_WAITING')) || (data.jobTypeCode == 'JOB_TYPE_DESTROY' && data.jobStatusCode == 'JOB_STATUS_REQUEST_APPROVAL') || (data.jobTypeCode == 'JOB_TYPE_PICKUP' && data.jobStatusCode == 'JOB_STATUS_PICKUP')\" href=\"#\" @click.prevent=\"commit\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E1B\u0E34\u0E14\u0E43\u0E1A\u0E07\u0E32\u0E19\">\n      <i class=\"fa fa-archive kt-font-primary\"></i>\n    </a>\n\n    <a v-if=\"data.jobTypeCode == 'JOB_TYPE_WRITE_OFF_STOCK' && data.jobStatusCode == 'JOB_STATUS_PENDING' && $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT'])\" href=\"#\" @click.prevent=\"closeWriteOff(data)\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E1B\u0E34\u0E14\u0E43\u0E1A\u0E07\u0E32\u0E19\">\n      <i class=\"fa fa-archive kt-font-primary\"></i>\n    </a>\n\n    <a v-if=\"data.isOffline && $root.canShow(['super_admin']) && data.jobTypeCode != 'JOB_TYPE_PICKUP' && data.jobTypeCode != 'JOB_TYPE_REPAIR' && data.jobTypeCode != 'JOB_TYPE_HOLD_CHECKER'\" href=\"#\" @click.prevent=\"goOnline\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E1A\u0E1A Online\">\n      <i class=\"fa fa-toggle-on kt-font-success\"></i>\n    </a>\n\n    <a v-if=\"data.isEditable && (data.jobTypeCode != 'JOB_TYPE_WRITE_OFF_STOCK' || $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT']))\" :href=\"getEditUrl(data)\" @click.prevent=\"edit\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E1A\u0E07\u0E32\u0E19\">\n      <i class=\"fa fa-edit kt-font-warning\"></i>\n    </a>\n\n    <a v-if=\"data.isDeletableRetrive && (data.jobTypeCode != 'JOB_TYPE_WRITE_OFF_STOCK' || $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT']))\" href=\"#\" @click.prevent=\"remove\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E43\u0E1A\u0E07\u0E32\u0E19\">\n      <i class=\"fa fa-trash-alt kt-font-danger\"></i>\n    </a>\n\n    <a v-if=\"data.jobTypeCode == 'JOB_TYPE_RETURN_ADHOC' && data.originLocationType == 'PLANT' && data.jobStatusCode == 'JOB_STATUS_CN_APPROVAL'\" :href=\"'/Jobs/EditCN/' + data.jobId\" @click.prevent=\"editCN\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 CN\">\n      <i class=\"fa fa-file-invoice\" style=\"color: #800080\"></i>\n    </a>\n\n    <a v-if=\"data.jobTypeCode == 'JOB_TYPE_RETURN_ADHOC' && data.originLocationType == 'PLANT' && (data.jobStatusCode == 'JOB_STATUS_CN_APPROVAL' || data.jobStatusCode == 'JOB_STATUS_SUCCESS')\" :href=\"'/Print/CNForm/' + data.jobId\" target=\"_blank\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A CN\">\n      <i class=\"fa fa-print\" style=\"color: #800080\"></i>\n    </a>\n\n    <a v-if=\"data.jobTypeCode == 'JOB_TYPE_EXCHANGE' && data.jobStatusCode == 'JOB_STATUS_SUCCESS'\" :href=\"'/Print/ExchanceForm/' + data.jobId\" target=\"_blank\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E42\u0E2D\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\">\n      <i class=\"fa fa-print\" style=\"color: #800080\"></i>\n    </a>\n\n    <a v-if=\"data.jobTypeCode == 'JOB_TYPE_WRITE_OFF_STOCK' && data.jobStatusCode == 'JOB_STATUS_SUCCESS' && $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT', 'JOB_ADMIN_WRITE_OFF_STOCK_AGENT', 'JOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT'])\" :href=\"'/Print/WriteOffForm/' + data.jobId\" target=\"_blank\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A\u0E07\u0E32\u0E19\">\n      <i class=\"fa fa-print\" style=\"color: #800080\"></i>\n    </a>\n\n    <a v-if=\"data.jobTypeCode == 'JOB_TYPE_WRITE_OFF_STOCK' && data.jobStatusCode == 'JOB_STATUS_SUCCESS' && $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT'])\" href=\"#\" @click.prevent=\"exportWriteOffExcel(data)\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"Export Excel\">\n      <i class=\"fa fa-file-excel\" style=\"color: #28a745\"></i>\n    </a>\n\n    <a v-if=\"data.jobTypeCode == 'JOB_TYPE_RETURN_SUPPLIER' && data.canAssignSpareParts\" href=\"#\" @click.prevent=\"spareConfig(data)\"\n    class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E23\u0E30\u0E1A\u0E38\u0E2D\u0E30\u0E44\u0E2B\u0E25\u0E48\u0E0B\u0E31\u0E1E\u0E1E\u0E25\u0E32\u0E22\u0E40\u0E2D\u0E2D\u0E23\u0E4C\">\n      <i class=\"fa fa-list-alt\" \n        :style=\"{ color: data.isSpareAdded ? '#28a745' : '#fd397a', borderRadius: '3px' }\"></i>\n    </a>\n  </div>",
  methods: {
    upload: function upload() {
      this.$parent.$refs.barcodeForm.job = this.data;
      $(this.$parent.$refs.barcodeForm.$el).modal("show");
    },
    spareConfig: function spareConfig(jobData) {

      this.$parent.$refs.spareProductList.job = jobData;
      this.$parent.$refs.spareProductList.showModal(jobData);

      //$(this.$parent.$refs.spareProductList.$el).modal("show");
      // ดึง DOM element ที่แท้จริงจาก ref โดยไม่อ้างผ่าน $el
      var modalEl = this.$parent.$refs.spareProductList.$refs.spareProductList;
      //$(modalEl).modal("show");

      $(modalEl).modal({
        backdrop: 'static',
        keyboard: false
      });
    },


    setValidate: function setValidate() {
      if (!this.$root.canShow(["super_admin"])) {
        Swal.fire({
          title: "ไม่มีสิทธิ์",
          type: "warning",
          html: "คุณไม่มีสิทธิ์ เปิด/ปิดการตรวจสอบสถานะบาร์โค้ดของใบงาน <strong>" + this.data.jobNumber + "</strong> กรุณาแจ้งผู้ดูแลระบบให้ดำเนินการ"
        });
        return;
      }

      var self = this;

      if (!this.data.isNoValidate) {
        Swal.fire({
          title: "คำสั่งปิดการตรวจสอบสถานะบาร์โค้ด",
          type: "warning",
          html: "กรุณายืนยันคำสั่งปิดการตรวจสอบสถานะบาร์โค้ดของใบงาน <strong>" + this.data.jobNumber + "</strong>",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            self.doSetValidate();
          }
        });
      } else {
        self.doSetValidate();
      }
    },
    doSetValidate: function doSetValidate() {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/SetValidate", {
        jobId: this.data.jobId,
        isNoValidate: !this.data.isNoValidate
      }).then(function (response) {
        if (response.data.status) {
          self.$parent.reloadDataTable();
          Swal.fire("สำเร็จ", response.data.message, "success");
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    editCN: function editCN() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/Jobs/EditCN/" + this.data.jobId });
    },
    // CR-Job-Stock: helpers used by template — write-off jobs use dedicated route
    getEditUrl: function getEditUrl(data) {
      return getJobEditPath(data);
    },
    getViewUrl: function getViewUrl(data) {
      return getJobViewPath(data);
    },
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: getJobEditPath(this.data) });
    },
    view: function view() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: getJobViewPath(this.data) });
    },
    handlerEdit: function handlerEdit(e) {
      document.getElementById(this.data.jobId).href = getJobEditPath(this.data);
    },
    remove: function remove() {
      var _this = this;

      var self = this;

      Swal.fire({
        title: "คำสั่งยกเลิกข้อมูลใบงาน",
        type: "warning",
        html: "กรุณายืนยันคำสั่งยกเลิกข้อมูลใบงาน <strong>" + this.data.jobNumber + "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังยกเลิกข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/Delete", {
            jobId: _this.data.jobId
          }).then(function (response) {
            if (response.data.status) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    goOnline: function goOnline() {
      var _this2 = this;

      var self = this;

      Swal.fire({
        title: "คำสั่งเปิดใช้งานแบบ Online",
        type: "warning",
        html: "กรุณายืนยันคำสั่งเปิดใช้งานแบบ Online ใบงาน <strong>" + this.data.jobNumber + "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/Online", {
            jobId: _this2.data.jobId
          }).then(function (response) {
            if (response.data.status) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    exportWriteOffExcel: function exportWriteOffExcel(data) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังสร้างไฟล์ กรุณารอสักครู่..."
      });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/WriteOffStockJobs/" + data.jobId + "/ExportExcel", {
        responseType: "blob"
      }).then(function (response) {
        var cd = response.headers["content-disposition"] || "";
        var match = cd.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
        var filename = match ? decodeURIComponent(match[1].replace(/^"|"$/g, "")) : "WriteOff.xlsx";
        var blob = new Blob([response.data], {
          type: response.headers["content-type"]
        });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }).catch(function (err) {
        Swal.fire("เกิดข้อผิดพลาด", "Export ไม่สำเร็จ", "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    closeWriteOff: function closeWriteOff(data) {
      var self = this;
      Swal.fire({
        title: "คำสั่งปิดใบงาน",
        type: "warning",
        html: "กรุณายืนยันคำสั่งปิดใบงาน <strong>" + data.jobNumber + "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/WriteOffStockJobs/" + data.jobId + "/Close", {}).then(function (response) {
            if (response.data.status) {
              Swal.fire("สำเร็จ", response.data.message, "success");
              self.$parent.reloadDataTable();
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response && error.response.data && error.response.data.message ? error.response.data.message : "ไม่สามารถปิดใบงานได้", "error");
          }).then(function () {
            KTApp.unblockPage();
          });
        }
      });
    },
    commit: function commit() {
      var self = this;
      if (self.data.jobTypeCode == "JOB_TYPE_PICKUP") {
        Swal.fire({
          title: "คำสั่งปิดใบงาน",
          type: "warning",
          html: "การปิดใบงานประเภท <strong>" + this.data.jobTypeName + (!this.data.originNoSML ? "</strong> จะต้องสร้างบิลขายภายในระบบ SML เพื่อบันทึกปิดใบงานก่อน" : "</strong> กรอกข้อมูลลูกค้าเพื่อบันทึกปิดใบงานก่อน"),
          showCancelButton: true,
          confirmButtonText: !this.data.originNoSML ? "กรอกบิลขาย" : "กรอกข้อมูลลูกค้า",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/Jobs/Edit/" + self.data.jobId });
          }
        });
      } else if (self.data.jobTypeCode == "JOB_TYPE_DESTROY") {
        Swal.fire({
          title: "คำสั่งปิดใบงาน",
          type: "warning",
          html: "การปิดใบงานประเภท <strong>" + this.data.jobTypeName + "</strong> จะต้องพิมพ์ใบขออนุมัติทำลายสินค้าและอัพโหลด เพื่อบันทึกปิดใบงานก่อน",
          showCancelButton: true,
          confirmButtonText: "อัพโหลดใบขออนุมัติฯ",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/Jobs/Edit/" + self.data.jobId });
          }
        });
      } else if (self.data.evidenceRequired && self.data.evidenceCanPickFromGallery) {
        Swal.fire({
          title: "คำสั่งปิดใบงาน",
          type: "warning",
          html: "การปิดใบงานประเภท <strong>" + this.data.jobTypeName + "</strong> จะต้องอัพโหลดรูปภาพหลักฐาน เพื่อบันทึกปิดใบงานก่อน",
          showCancelButton: true,
          confirmButtonText: "อัพโหลดรูปภาพหลักฐาน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/Jobs/Edit/" + self.data.jobId });
          }
        });
      } else {
        Swal.fire({
          title: "คำสั่งปิดใบงาน",
          type: "warning",
          html: "กรุณายืนยันคำสั่งปิดใบงาน <strong>" + this.data.jobNumber + "</strong>",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            self.commitJob();
          }
        });
      }
    },
    commitJob: function commitJob() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;

      // -- Begin Commit Job
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      if (self.data.isNoValidate && (self.data.jobTypeCode == "JOB_TYPE_TRANSFER_TO_AGENT" || self.data.jobTypeCode == "JOB_TYPE_EXCHANGE" || self.data.jobTypeCode == "JOB_TYPE_RETRIEVE_ITEM" && (self.data.fromJobTypeName == "ส่งสินค้าไปยังตัวแทน ฯ" || self.data.fromJobTypeName == "โอนทรัพย์สิน"))) {
        force = true;
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/Commit", {
        jobId: self.data.jobId,
        force: force
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success");
          self.$parent.reloadDataTable();
          $(self.$el).modal("hide");
        } else {
          var msg = response.data.message;
          if (response.data.errors) {
            var html = "";
            var foundBarcodeMessage = false;

            if (self.data.jobTypeCode == "JOB_TYPE_HOLD_CHECKER") {
              for (var key in response.data.errors) {
                if (response.data.errors.hasOwnProperty(key)) {
                  var errors = response.data.errors[key];
                  var cnt = errors.length / 5;
                  for (var i = 0; i < cnt; i++) {
                    var _err = errors[i * 5 + 1];
                    html += "<li>" + _err + "</li>";
                  }
                }
              }
            } else {
              for (var key in response.data.errors) {
                if (response.data.errors.hasOwnProperty(key)) {
                  var err = response.data.errors[key];
                  html += "<li>" + err[1] + "</li>";
                }
              }
            }

            if (html) {
              if (self.data.jobTypeCode == "JOB_TYPE_TRANSFER_TO_AGENT" || self.data.jobTypeCode == "JOB_TYPE_EXCHANGE" || self.data.jobTypeCode == "JOB_TYPE_RETRIEVE_ITEM" && (self.data.fromJobTypeName == "ส่งสินค้าไปยังตัวแทน ฯ" || self.data.fromJobTypeName == "โอนทรัพย์สิน")) {

                for (var key in response.data.errors) {
                  if (response.data.errors.hasOwnProperty(key)) {
                    var errors = response.data.errors[key];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var error = _step.value;

                        if (error.includes("จำนวนบาร์โค้ดของ")) {
                          foundBarcodeMessage = true;
                          break;
                        }
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }

                    if (foundBarcodeMessage) break;
                  }
                }
                if (foundBarcodeMessage) {
                  msg += "<div class='text-left mt-3'>กรุณาสแกนบาร์โค้ดให้ครบก่อนค่ะ<br /><br />สาเหตุ: <ul>" + html + "</ul></div>";
                } else {
                  msg += "<div class='text-left mt-3'>ข้อมูลบาร์โค้ดไม่ถูกต้องกรุณาตรวจสอบใหม่อีกครั้งค่ะ<br /><br />สาเหตุ: <ul>" + html + "</ul></div>";
                }
              } else {
                msg += "<div class='text-left mt-3'>หากคุณต้องการปิดใบงานนี้ กรุณายืนยันอีกครั้งโดยคลิกปุ่ม <strong>ฉันต้องการปิดใบงานนี้</strong><br /><br />สาเหตุ: <ul>" + html + "</ul></div>";
              }
            }
          }

          var start = msg.indexOf("||");
          var end = msg.lastIndexOf("||");
          if (start >= 0) {
            var str = msg.substr(start + 2, end - start - 2);
            var oldStr = msg.substr(start, end - start + 2);
            // console.log(start);
            // console.log(end);
            // console.log(str);
            // console.log(oldStr);
            var repl = "<strong class='text-danger'>" + str + "</strong>";
            msg = msg.replace(oldStr, repl);
          }

          if (self.data.jobTypeCode == "JOB_TYPE_TRANSFER_TO_AGENT" || self.data.jobTypeCode == "JOB_TYPE_EXCHANGE" || self.data.jobTypeCode == "JOB_TYPE_RETRIEVE_ITEM" && (self.data.fromJobTypeName == "ส่งสินค้าไปยังตัวแทน ฯ" || self.data.fromJobTypeName == "โอนทรัพย์สิน")) {
            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              html: msg,
              type: "error",
              confirmButtonText: "OK"
            });
          } else {
            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              html: msg,
              type: "error",
              showCancelButton: true,
              confirmButtonText: "<i class='fa fa-archive'></i> ฉันต้องการปิดใบงานนี้",
              cancelButtonText: "ตรวจสอบข้อมูล"
            }).then(function (result) {
              if (result.value) {
                self.commitJob(true);
              }
            });
          }
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
      // -- End Commit Job
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    barcodeForm: __WEBPACK_IMPORTED_MODULE_4__JobImportBarcodeForm__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect___default.a,
    spareProductList: __WEBPACK_IMPORTED_MODULE_5__JobAddSpareProductList__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      jobUsersId: [],
      // jobStatusCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "เลือกสถานะใบงานที่ต้องการค้นหา",
      //   multiple: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=JOB_STATUS",
      //     delay: 300,
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      jobStatusCodeOptions: [],
      // jobTypeCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "เลือกประเภทใบงานที่ต้องการค้นหา",
      //   multiple: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Jobs/JobType/Options",
      //     delay: 300,
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      jobTypeCodeOptions: [],
      originLocationIdOptions: [],
      // originLocationIdOptions: {
      //   placeholder: "เลือกสถานที่ต้นทาง (Origin) ที่ต้องการค้นหา",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Jobs/Origin/Options",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     if (!data.id || !data.data) return data.text;

      //     if (data.data.locationType == "PLANT") {
      //       return data.text;
      //     } else if (data.data.locationType == "AGENT") {
      //       var $container = $(
      //         "<div class='select2-result-repository clearfix'>" +
      //           "<div class='select2-result-repository__meta'>" +
      //           "<div class='select2-result-repository__title'></div>" +
      //           "<div class='select2-result-repository__description'></div>" +
      //           "</div>" +
      //           "</div>"
      //       );

      //       $container
      //         .find(".select2-result-repository__title")
      //         .text(data.text);

      //       if (data.data.agentType != "HEAD_OFFICE") {
      //         $container
      //           .find(".select2-result-repository__description")
      //           .text(
      //             "SAP Code: " + data.id + "<br />HQ: " + data.data.headOffice
      //           );
      //       } else {
      //         $container
      //           .find(".select2-result-repository__description")
      //           .text("SAP Code: " + data.id + " สำนักงานใหญ่");
      //       }

      //       return $container;
      //     } else {
      //       return data.text;
      //     }
      //   },
      // },
      // originLocationIdOptions:[],
      destinationLocationIdOptions: {
        placeholder: "เลือกสถานที่ปลายทาง (Destination) ที่ต้องการค้นหา",
        allowClear: true,
        ajax: {
          url: "/Api/Jobs/Destination/Options",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          if (!data.id || !data.data) return data.text;

          if (data.data.locationType == "PLANT") {
            return data.text;
          } else if (data.data.locationType == "AGENT") {
            var $container = $("<div class='select2-result-repository clearfix'>" + "<div class='select2-result-repository__meta'>" + "<div class='select2-result-repository__title'></div>" + "<div class='select2-result-repository__description'></div>" + "</div>" + "</div>");

            $container.find(".select2-result-repository__title").text(data.text);

            if (data.data.agentType != "HEAD_OFFICE") {
              $container.find(".select2-result-repository__description").text("SAP Code: " + data.id + "<br />HQ: " + data.data.headOffice);
            } else {
              $container.find(".select2-result-repository__description").text("SAP Code: " + data.id + " สำนักงานใหญ่");
            }

            return $container;
          } else {
            return data.text;
          }
        }
      },
      // destinationLocationIdOptions:[],
      keyword: "",
      jobNumber: "",
      jobStatusCode: [],
      jobTypeCode: [],
      originLocationId: [],
      destinationLocationId: [],
      productTypeId: [],
      productTypeIdOptions: [],
      assetCode: [],
      assetCodeOptions: [],
      canAssignSpareParts: false
    };
  },
  methods: {
    LoadjobStatusCodeOptions: function LoadjobStatusCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Variables/Options?search=JOB_STATUS", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.jobStatusCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadjobTypeCodeOptions: function LoadjobTypeCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Jobs/JobType/Options", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.jobTypeCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadoriginLocationIdOptions: function LoadoriginLocationIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.originLocationIdOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/Origin/Options", {
          page: 1,
          all: true,
          search: searchQuery
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.originLocationIdOptions = [];
            data.forEach(function (element) {
              self.originLocationIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.originLocationIdOptions);
        }).catch(function (error) {});
      }
    },
    LoaddestinationLocationIdOptions: function LoaddestinationLocationIdOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.destinationLocationIdOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/Destination/Options", {
          page: 1,
          search: searchQuery,
          all: true
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.destinationLocationIdOptions = [];
            data.forEach(function (element) {
              self.destinationLocationIdOptions.push({
                id: element.id,
                label: element.text,
                search: searchQuery
              });
            });
          }
          callback(null, self.destinationLocationIdOptions);
        }).catch(function (error) {});
      }
    },
    LoadjobUsersIdOptions: function LoadjobUsersIdOptions(_ref3) {
      var action = _ref3.action,
          searchQuery = _ref3.searchQuery,
          callback = _ref3.callback;

      if (action === __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Jobs/User/Options", {
          page: 1,
          search: searchQuery,
          all: true
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            var result = [];
            data.forEach(function (element) {
              result.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, result);
        }).catch(function (error) {});
      }
    },

    reLoadjobUsersIdOptions: function reLoadjobUsersIdOptions() {
      this.$refs.jobUsersId.trigger.searchQuery = null;
    },
    LoadProductTypeIdOptions: function LoadProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.productTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadAssetCodeOptions: function LoadAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.assetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    formReset: function formReset(e) {

      this.keyword = "";
      this.jobNumber = "";
      this.jobStatusCode = ["JOB_STATUS_WAITING", "JOB_STATUS_PENDING", "JOB_STATUS_PICKUP", "JOB_STATUS_REQUEST_APPROVAL", "JOB_STATUS_CN_APPROVAL", "JOB_STATUS_SUCCESS"];
      //this.$refs.jobTypeCode.setSelectedData([]);
      // this.$refs.originLocationId.setSelectedData([]);
      // this.$refs.destinationLocationId.setSelectedData([]);
      this.jobTypeCode = [];
      this.originLocationId = [];
      this.destinationLocationId = [];

      this.jobsDateStart = null;
      this.jobsDateEnd = null;

      this.jobUsersId = [];
      this.productTypeId = [];
      this.assetCode = [];

      $("#jobsDateStart").val("").trigger("change");
      $("#jobsDateEnd").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $(this.$refs.jobTable).DataTable();
      table.search(this.keyword);
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $(this.$refs.jobTable).DataTable().ajax.reload(null, resetPaging);
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    CheckRoleAdminBeerClaim: function CheckRoleAdminBeerClaim() {
      var self = this;
      var status = true;
      if (_typeof(self.$root.user.profile.role) == "object") {
        var result = self.$root.user.profile.role.filter(function (word) {
          return word == "ADMIN_BEER_CLAIM";
        });
        if (result.length > 0) {
          status = false;
        } else {
          status = true;
        }
      } else if (typeof self.$root.user.profile.role == "string") {
        if (self.$root.user.profile.role == "ADMIN_BEER_CLAIM") {
          status = false;
        } else {
          status = true;
        }
      } else {
        status = true;
      }
      return status;
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // console.log(from);
    next();
    if (from && (from.name == "JobEdit" || from.path.toLowerCase().startsWith("/jobs/create"))) {
      this.$nextTick(function () {
        this.reloadDataTable();
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;

              self.jobStatusCode = ["JOB_STATUS_WAITING", "JOB_STATUS_PENDING", "JOB_STATUS_PICKUP", "JOB_STATUS_REQUEST_APPROVAL", "JOB_STATUS_CN_APPROVAL", "JOB_STATUS_SUCCESS"];
              self.LoadjobStatusCodeOptions();
              self.LoadjobTypeCodeOptions();
              // self.LoadoriginLocationIdOptions();
              // self.LoaddestinationLocationIdOptions();
              self.LoadProductTypeIdOptions();
              self.LoadAssetCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.jobsDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });

              $(self.$refs.jobsDateStart).datepicker("update", !!self.jobsDateStart ? self.jobsDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.jobsDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });

              $(self.$refs.jobsDateEnd).datepicker("update", !!self.jobsDateStart ? self.jobsDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              // begin first table
              $.fn.dataTable.ext.errMode = 'none';
              table = $(self.$refs.jobTable);

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,

                ajax: {
                  url: "/Api/Jobs/Find",
                  type: "post",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    d.jobNumber = self.jobNumber;
                    d.jobStatusCode = self.jobStatusCode;
                    d.jobTypeCode = self.jobTypeCode;
                    d.originLocationId = self.originLocationId;
                    d.destinationLocationId = self.destinationLocationId;
                    d.jobsDateStart = self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null;
                    d.jobsDateEnd = self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null;
                    d.jobUsersId = self.jobUsersId;
                    d.productTypeId = self.productTypeId;
                    d.assetCode = self.assetCode;
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n            <'row'<'col-sm-12'tr>>\n    \t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "desc"]],

                columns: [{
                  data: "jobRunning",
                  width: "10%",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.isOffline) {
                      return '<i class="fa fa-genderless kt-font-danger"></i> ' + full.jobNumber;
                    } else {
                      return '<i class="fa fa-genderless kt-font-success"></i> ' + full.jobNumber;
                    }
                  }
                }, {
                  data: "jobTypeName",
                  width: "10%",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.jobTypeCode == "JOB_TYPE_PRODUCE") {
                      return data + "<br /><span class='text-info'><strong><i class='fa fa-question-circle'></i> " + full.finishedProductCode + "</strong><br />" + full.finishedProductName + "</span>";
                    } else {
                      return data;
                    }
                  }
                }, {
                  data: "originName",
                  width: "20%",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>" + data + "</pre>";

                    if (full.fromJobNumber) {
                      html += "<br /><span class='text-info'><strong><i class='fa fa-question-circle'></i> " + full.fromJobNumber + "</strong><br />" + full.fromJobTypeName + "</span>";
                    }

                    if (full.productLoanHeaderId) {
                      if (full.jobTypeCode == "JOB_TYPE_RETRIEVE_ITEM" && full.destinationLocationType == "PLANT") {
                        html += "<br /><span class='text-warning'><strong><i class='fa fa-question-circle'></i> " + full.productLoanRequestDocNo + "</strong><br />รับคืนจากการยืม</span>";
                      } else {
                        html += "<br /><span class='text-warning'><strong><i class='fa fa-question-circle'></i> " + full.productLoanRequestDocNo + "</strong></span>";
                      }
                    }

                    if (full.claimId) {
                      html += "<br /><span class='text-danger'><strong><i class='fa fa-question-circle'></i> " + full.claimNumber + "</strong><br />เคลมเบียร์</span>";
                    }

                    return html;
                  }
                }, {
                  data: "destinationName",
                  width: "20%",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    // TRANSFER_TO_MULTI_SHOP: แสดงรายชื่อปลายทางทั้งหมดจาก jobDestinations
                    if (full.jobTypeCode == "JOB_TYPE_TRANSFER_TO_MULTI_SHOP") {
                      if (full.jobDestinations && full.jobDestinations.length > 0) {
                        var html = '<div class="text-left">';
                        full.jobDestinations.forEach(function (dest, index) {
                          var destText = '';
                          if (dest.shipToShop) {
                            // ปลายทางเป็น SHOP
                            destText = "[" + (dest.destinationShop.custCode || '') + "] " + (dest.destinationShop.customerName || '') + " " + (dest.destinationShop.name2 ? '(' + dest.destinationShop.name2 + ')' : '');
                          } else if (dest.shipToShopSubAgent) {
                            // ปลายทางเป็น SUBSHOP
                            destText = "[" + (dest.destinationShopSubAgent.subAgentCode || '') + "] " + (dest.destinationShopSubAgent.subAgentName || '') + " " + (dest.destinationShopSubAgent.subAgentName2 ? '(' + dest.destinationShopSubAgent.subAgentName2 + ')' : '');
                          }
                          html += index + 1 + ". " + destText + "<br />";
                        });
                        html += '</div>';
                        return html;
                      }
                      return data || '-';
                    }

                    // TRANSFER_TO_AGENT, TRANSFER_TO_SHOP: แสดง shipTos
                    if (full.jobTypeCode == "JOB_TYPE_TRANSFER_TO_AGENT" || full.jobTypeCode == "JOB_TYPE_TRANSFER_TO_SHOP") return full.shipTos.length > 0 ? full.shipTos.join(", ") : data;

                    // NEW_SHOP: แสดง data ปกติ
                    if (full.jobTypeCode == "JOB_TYPE_NEW_SHOP") {
                      return data;
                    }

                    // กรณีอื่นๆ: ถ้า destination = origin ไม่แสดง
                    if (data == full.originName) return "";else return data;
                  }
                }, {
                  data: "jobStatusName",
                  width: "10%",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.jobTypeCode == "JOB_TYPE_DESTROY" && full.jobStatusCode == "JOB_STATUS_SUCCESS") {
                      return '<span class="text-success"><i class="fa fa-check-circle"></i> ' + data + "</span>" + (full.approve ? '<br /><span class="text-success">( อนุมัติ )</span>' : '<br /><span class="text-danger">( ไม่อนุมัติ )</span>');
                    } else if (full.jobStatusCode == "JOB_STATUS_SUCCESS") {
                      return '<span class="text-success"><i class="fa fa-check-circle"></i> ' + data + "</span>";
                    } else if (full.jobStatusCode == "JOB_STATUS_PENDING") {
                      return '<span class="text-warning"><i class="fa fa-sync-alt"></i> ' + data + "</span>";
                    } else if (full.jobStatusCode == "JOB_STATUS_PICKUP") {
                      return '<span class="text-warning"><i class="fa fa-truck-pickup"></i> ' + data + "</span>";
                    } else if (full.jobStatusCode == "JOB_STATUS_REQUEST_APPROVAL") {
                      return '<span class="text-warning"><i class="fa fa-file-signature"></i> ' + data + "</span>";
                    } else if (full.jobStatusCode == "JOB_STATUS_CN_APPROVAL") {
                      return '<span style="color: #800080"><i class="fa fa-exclamation-triangle"></i> ' + data + "</span>";
                    } else {
                      return '<span class="text-danger"><i class="fa fa-ban"></i> ' + data + "</span>";
                    }
                  }
                }, {
                  data: "totalCheckedQuantity",
                  className: "text-center",
                  width: "5%",
                  render: function render(data, type, full, meta) {

                    // let total = full.totalCheckedQuantity + full.totalQuantityNoBarcode;
                    // if (total > 0) {
                    //   let str =
                    //     self.$options.filters.currency(
                    //       total,
                    //       "",
                    //       0
                    //     ) +
                    //     "/" +
                    //     self.$options.filters.currency((full.totalQuantity + full.totalQuantityNoBarcode), "", 0);

                    //   if (full.totalQuantity != full.totalCheckedQuantity) {
                    //     return (
                    //       "<span class='text-danger'><i class='fa fa-exclamation-circle'></i> " +
                    //       str +
                    //       "</span>"
                    //     );
                    //   } else {
                    //     return str;
                    //   }
                    // } else {
                    //   return self.$options.filters.currency(
                    //     full.totalCheckedQuantity,
                    //     "",
                    //     0
                    //   );
                    // }

                    if (full.totalQuantity > 0) {
                      if (full.jobTypeCode == 'JOB_TYPE_AUDIT_STOCK') {
                        return self.$options.filters.currency(full.totalQuantity + full.totalQuantityNoBarcode, "", 0);
                      }
                      var str = self.$options.filters.currency(full.totalCheckedQuantity + full.totalQuantityNoBarcode, "", 0) + "/" + self.$options.filters.currency(full.totalQuantity + full.totalQuantityNoBarcode, "", 0);

                      if (full.totalQuantity != full.totalCheckedQuantity) {
                        return "<span class='text-danger'><i class='fa fa-exclamation-circle'></i> " + str + "</span>";
                      } else {
                        return str;
                      }
                    } else {
                      return self.$options.filters.currency(full.totalCheckedQuantity + full.totalQuantityNoBarcode, "", 0);
                    }
                  }
                  // render: function(data, type, full, meta) {
                  //   //let total = full.totalCheckedQuantity + full.totalQuantityNoBarcode;
                  //   let totalCheckedQuantity = full.totalCheckedQuantity;
                  //   let totalQuantity = full.totalQuantity;
                  //   let totalQuantityNoBarcode = full.totalQuantityNoBarcode;

                  //   if (totalQuantity > 0) {
                  //     let str = self.$options.filters.currency(totalQuantity, "", 0) + "/" + self.$options.filters.currency((full.totalQuantity + full.totalQuantityNoBarcode), "", 0);
                  //     // let str = self.$options.filters.currency(totalCheckedQuantity, "", 0) + "/" + self.$options.filters.currency((totalQuantity + totalQuantityNoBarcode), "", 0);

                  //     if (totalQuantity != totalCheckedQuantity) {
                  //       return ("<span class='text-danger'><i class='fa fa-exclamation-circle'></i> " + str + "</span>");
                  //     }
                  //     else {
                  //       return str;
                  //     }
                  //   }
                  //   else {
                  //     return self.$options.filters.currency(totalCheckedQuantity, "", 0);
                  //   }
                  // },
                }, { data: "lastUpdateDate", width: "10%", className: "text-center" }, { data: "lastUpdateUser", width: "10%", className: "text-center" }, { data: "offlineBy" }, { data: "remark" }, {
                  data: "jobId",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_8__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    // For ADMIN_BEER_CLAIM
                    if (data.isDeletable == true) {
                      if (self.$root.canShow(['super_admin', 'MANAGE_MASTER', 'JOB_ADMIN_BORROW_APPROVE']) == true) {
                        data.isDeletable = true;
                      } else {
                        data.isDeletable = self.CheckRoleAdminBeerClaim();
                      }
                    }

                    data.isDeletableRetrive = data.isDeletable;

                    if (self.$root.user.profile.profile_type == 'COMPANY_PROFILE_TYPE_BR' && self.$root.user.profile.plant != "" && self.$root.user.profile.plant !== null && (data.jobStatusCode == 'JOB_STATUS_WAITING' || data.jobStatusCode == 'JOB_STATUS_PENDING') && data.jobTypeCode == 'JOB_TYPE_RETRIEVE_ITEM' && (data.productLoanTypeName == 'รับคืนจากการยืม' || data.fromJobTypeName == 'ส่งสินค้า/ทรัพย์สินคืนต้นทาง')) {
                      data.isDeletableRetrive = true;
                    }

                    if (data.jobStatusCode == "JOB_STATUS_CN_APPROVAL" && (self.$root.user.profile.profile_type == 'COMPANY_PROFILE_TYPE_BR' && self.$root.user.profile.plant != "" && self.$root.user.profile.plant !== null || self.$root.canShow(['super_admin', 'MANAGE_MASTER']) == true)) {
                      data.isDeletableRetrive = true;
                    }

                    if (data.isEditable == true) {
                      if (self.$root.canShow(['super_admin', 'MANAGE_MASTER', 'JOB_ADMIN_BORROW_APPROVE']) == true) {
                        data.isEditable = true;
                      } else {
                        data.isEditable = self.CheckRoleAdminBeerClaim();
                      }
                    }

                    // For add supplier spare
                    //if (data.isEditable == true) {
                    if (self.$root.canShow(['super_admin', 'OFFICER_QIMAINTAIN', 'OFFICER_PLANT_QIMAINTAIN', 'LEAD_QIMAINTAIN', 'JOB_ADMIN_RETURN_SUPPLIER']) == true) {
                      data.canAssignSpareParts = true;
                    } else {
                      data.canAssignSpareParts = false;
                    }
                    //}


                    data.isOfflineAdminBeerClaim = self.CheckRoleAdminBeerClaim(); // false คือปิด true คือเปิด
                    // For ADMIN_BEER_CLAIM
                    new JobActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    itemIndex: Number,
    showHeader: {
      type: Boolean,
      default: true
    },
    rootItems: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    jobType: {
      type: String
    }
  },
  data: function data() {
    return {
      oldDocumentNumber: null
    };
  },

  methods: {
    onDocumentNumberBlur: function onDocumentNumberBlur() {
      var self = this;

      var hasDocNumber = $.grep(self.rootItems, function (obj, i) {
        return i != self.rowIndex && obj.documentNumber == self.item.documentNumber;
      }).length > 0;

      if (hasDocNumber) {
        Swal.fire("เกิดข้อผิดพลาด", "คุณกรอกเลขที่ใบส่งสินค้าซ้ำ", "warning");
        return false;
      }

      if (self.item.documentNumber && self.oldDocumentNumber != self.item.documentNumber) {
        self.oldDocumentNumber = self.item.documentNumber;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/DeliveryOrders/" + encodeURIComponent(self.item.documentNumber)).then(function (response) {
          if (response.status == 200) {
            var data = response.data;
            self.item.id = data.id;
            self.item.documentNumber = data.documentNumber;
            self.item.documentDate = data.documentDate;
            self.item.items = data.items;

            self.$parent.onCalculateItemClick();
          } else {
            self.item.id = null;
            self.item.documentDate = null;
            self.item.items = [];

            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลใบส่งสินค้า " + self.item.documentNumber + "<br />ทั้งนี้อาจจะเกิดจากความล่าช้าในการ Sync ข้อมูลจากฐานข้อมูล SAP<br /><br />หากคุณยืนยันความถูกต้องของเลขที่ใบส่งสินค้านี้ คุณสามารถคงค่านี้ไว้ได้ระบบจะดำเนินการผูกข้อมูลให้อัตโนมัติในภายหลังที่ได้รับข้อมูลจากฐานข้อมูล SAP แล้ว", "warning");
          }
        }).catch(function (error) {
          self.item.id = null;
          self.item.documentDate = null;
          self.item.items = [];

          Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลใบส่งสินค้าได้ในขณะนี้", "error");
        });
      } else {
        self.item.id = null;
        self.item.documentDate = null;
        self.item.items = [];
      }
    },
    onRemoveItemClick: function onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    }
  },
  mounted: function mounted() {
    $(".required", this.$el).each(function () {
      var $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required")
        }
      });
    });
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    apiUrl: {
      type: String,
      default: "/Api/Sml/Invoice"
    },
    rowIndex: Number,
    itemIndex: Number,
    showHeader: {
      type: Boolean,
      default: true
    },
    rootItems: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    jobType: {
      type: String
    },
    agentCode: {
      type: String
    }
  },
  data: function data() {
    return {
      oldDocumentNumber: null
    };
  },

  methods: {
    onDocumentNumberBlur: function onDocumentNumberBlur() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;

      var hasDocNumber = $.grep(self.rootItems, function (obj, i) {
        return i != self.rowIndex && obj.documentNumber == self.item.documentNumber;
      }).length > 0;

      if (hasDocNumber) {
        Swal.fire("เกิดข้อผิดพลาด", "คุณกรอกเลขที่ใบส่งสินค้าซ้ำ", "warning");
        return false;
      }

      if (self.item.documentNumber && (force || self.oldDocumentNumber != self.item.documentNumber)) {
        self.oldDocumentNumber = self.item.documentNumber;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(self.apiUrl + "/" + encodeURIComponent(self.item.documentNumber) + "?agentCode=" + self.agentCode).then(function (response) {
          if (response.status == 200) {
            var data = response.data;
            self.item.id = data.id;
            self.item.documentNumber = data.documentNumber;
            self.item.documentDate = data.documentDate;
            self.item.refDocNumber = data.refDocNumber;
            self.item.shipTo = data.shipTo;
            self.item.shipToName = data.shipToName;
            self.item.soldTo = data.soldTo;
            self.item.soldToName = data.soldToName;
            self.item.items = data.items;

            self.$parent.onCalculateItemClick();
          } else {
            self.item.id = null;
            self.item.documentDate = null;
            self.item.items = [];

            if (self.apiUrl == "/Api/Sml/Invoice") {
              Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลบิลขาย (Invoice) " + self.item.documentNumber + "<br />กรุณาตรวจสอบข้อมูลในระบบ SML ทั้งนี้ท่านจะต้องสร้างใบเบิกสินค้าโดยอ้างอิงเลขที่เอกสารของบิลขายก่อนจึงจะสามารถใช้งานได้", "warning");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลเอกสาร " + self.item.documentNumber + "<br />กรุณาตรวจสอบข้อมูลในระบบ SML", "warning");
            }
          }
        }).catch(function (error) {
          self.item.id = null;
          self.item.documentDate = null;
          self.item.items = [];
          console.log(error.response);

          if (!self.agentCode) {
            Swal.fire("เกิดข้อผิดพลาด", 'กรุณาเลือกตัวแทนฯในช่อง "สถานที่ต้นทาง (Origin)" ก่อน', "error");
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data && error.response.data.message ? error.response.data.message : "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลใบส่งสินค้าได้ในขณะนี้", "error");
          }
        });
      } else {
        self.item.id = null;
        self.item.documentDate = null;
        self.item.items = [];
      }
    },
    onRemoveItemClick: function onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    }
  },
  mounted: function mounted() {
    $(".required", this.$el).each(function () {
      var $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required")
        }
      });
    });
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    itemIndex: Number,
    showHeader: {
      type: Boolean,
      default: true
    },
    rootItems: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__ = __webpack_require__(54);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    productItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      monthCanEdit: 2, /* Default FEB, configurable */
      kPIProductType: "KPI_ACCESSORY_DILAPIDATED",
      isShow: false,
      isExportingSelected: false,
      isExportingAll: false,
      productitems: [],
      productTotalList: [],
      totalCost: 0,
      totalMonth: [],
      totalPoductCost: 0,
      totalProductCostOfMonth: 0,
      i: 0,
      agentCode: null,
      year: new Date().getFullYear(),
      agentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }]
      }
    };
  },

  computed: {
    canExportAllAgents: function canExportAllAgents() {
      return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
    }
  },
  methods: {
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var listProductCode = [];
      this.productitems.forEach(function (element) {
        listProductCode.push(element.productCode);
      });

      this.productitems.push({
        productCode: null,
        productCost: 0,
        isMonth: [],
        totalCal: 0,
        totalCalOfmonth: 0,
        isDisableMonth: [],
        isDisableProduct: false,
        listProductCode: listProductCode
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.productitems.splice(index, 1);
      for (var i = 0; i < this.productitems.length; i++) {}
      this.changeTotal();
    },
    agentCodeChange: function agentCodeChange() {
      var self = this;
      // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
      if (!self.agentCode) {
        self.isShow = false;
        return;
      }
      self.isShow = true;
      self.productitems = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct/getAccessory",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year
        }
      }).then(function (response) {
        var date = new Date();
        var monthNo = date.getMonth() + 1;
        var yearNo = date.getFullYear();

        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            var _loop = function _loop(i) {
              item = response.data[i];
              monthQtyItem = [];
              monthDisable = [];

              if (yearNo <= self.year) {
                /* Current Year */
                for (var j = 1; j < item.monthView.length; j++) {
                  if (j > monthNo) {
                    monthDisable[j] = true;
                  } else if (j <= monthNo) {
                    if (item.monthView[j].hasKpiData) {
                      monthDisable[j] = false;
                      monthQtyItem[j] = item.monthView[j].monthQty;
                      monthDisable[j] = item.monthView[j].isDisableMonth;
                    }
                  } else {
                    monthQtyItem[j] = item.monthView[j].monthQty;
                    monthDisable[j] = item.monthView[j].isDisableMonth;
                    monthDisable[j] = true;
                  }
                }
              } else {
                /* Previous Year */
                for (var _j = 1; _j < item.monthView.length; _j++) {
                  if (item.monthView[_j].hasKpiData) {
                    monthQtyItem[_j] = item.monthView[_j].monthQty;
                  }

                  //if (self.year == yearNo) {
                  //  monthDisable[j] = false;
                  //}
                  //else {
                  //  monthDisable[j] = true;
                  //}

                  //==== Check with config ====
                  if (self.year < yearNo) {
                    var currentMonth = new Date().getMonth() + 1;

                    console.log("Current Year : " + yearNo);
                    console.log("Current Month : " + currentMonth);
                    console.log("Previous Year : " + self.year);
                    console.log("Editable Month : " + self.monthCanEdit);

                    if (currentMonth <= self.monthCanEdit) {
                      //
                      monthDisable[_j] = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
                    } else {
                      //
                      monthDisable[_j] = true;
                    }
                  } else {
                    monthDisable[_j] = false;
                  }
                }
              }

              self.productitems.push({
                productCode: item.productCode,
                productCost: item.productCost,
                isMonth: monthQtyItem,
                isDisableMonth: monthDisable,
                isDisableProduct: true,
                productCodeOptionsData: {
                  id: item.productCode,
                  text: item.productName + " [" + item.productCode + "]",
                  data: null
                }
              });

              setTimeout(function () {
                self.$refs.Items[i].$refs.productCode.setSelectedData(self.productitems[i].productCodeOptionsData);
                self.changeTotal();
              }, 100);
            };

            for (var i = 0; i < response.data.length; i++) {
              var item;
              var monthQtyItem;
              var monthDisable;

              _loop(i);
            }
            self.isShow = true;
          } else {
            self.changeTotal();
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
          router.go(-1);
          self.isShow = false;
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
        router.go(-1);
        self.isShow = false;
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    changeTotal: function changeTotal() {
      var _this = this;

      this.totalCost = 0;
      this.totalMonth = [];
      this.totalPoductCost = 0;
      this.totalProductCostOfMonth = 0;
      this.productitems.forEach(function (e) {
        _this.totalCost = _this.totalCost + Number(e.productCost);
        _this.totalPoductCost = _this.totalPoductCost + Number(e.totalCost);
        _this.totalProductCostOfMonth = _this.totalProductCostOfMonth + Number(e.totalCalOfmonth);
        for (var i = 1; i < e.isMonth.length; i++) {
          if (e.isMonth[i] != null) {
            var oldtotal = _this.totalMonth[i] == undefined ? 0 : _this.totalMonth[i];
            _this.totalMonth[i] = Number(e.isMonth[i]) + oldtotal;
          }
        }
      });
    },
    exportExcelSelected: function exportExcelSelected() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.isExportingSelected) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_this2.year) {
                  _context.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context.abrupt("return");

              case 5:
                _this2.isExportingSelected = true;
                _context.prev = 6;
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIComplain/Export/AccessoriesDilapidated", { year: _this2.year, agentCode: _this2.agentCode || null }, "รายงาน_อุปกรณ์เบียร์สดสูญหาย.xlsx", _this2.$root.user && _this2.$root.user.access_token);

              case 9:
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);

                console.error("[KPI Export Selected]", _context.t0);
                msg = _context.t0.response && _context.t0.response.statusText || _context.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context.prev = 16;

                _this2.isExportingSelected = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 11, 16, 19]]);
      }))();
    },
    exportExcelAllAgents: function exportExcelAllAgents() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.isExportingAll) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (_this3.year) {
                  _context2.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context2.abrupt("return");

              case 5:
                _this3.isExportingAll = true;
                _context2.prev = 6;
                _context2.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIComplain/Export/AccessoriesDilapidated/AllAgents", { year: _this3.year }, "รายงาน_อุปกรณ์เบียร์สดสูญหาย_ทุกตัวแทน.xlsx", _this3.$root.user && _this3.$root.user.access_token);

              case 9:
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);

                console.error("[KPI Export All]", _context2.t0);
                msg = _context2.t0.response && _context2.t0.response.statusText || _context2.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context2.prev = 16;

                _this3.isExportingAll = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 11, 16, 19]]);
      }))();
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.agentCode === null || self.agentCode == "") {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือก ตัวแทนจำหน่าย", "warning");
        return false;
      }
      if (self.productitems.length < 1) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการอุปกรณ์เบียร์สดสูญหาย", "warning");
        return false;
      }

      var countRow = self.productitems[0].isMonth;
      for (var i = 0; i < self.productitems.length; i++) {
        if (self.productitems[i].isMonth.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนอุปกรณ์เบียร์สดสูญหาย", "warning");
          return false;
        }

        if (self.productitems[i].productCost == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
          return false;
        }

        if (countRow.filter(function (o) {
          return o != "";
        }).length != self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
          return false;
        } else if (countRow.filter(function (o) {
          return o != "";
        }).length == self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          var data = self.productitems[i].isMonth.filter(function (o) {
            return o != null;
          });
          var row = self.productitems[0].isMonth.filter(function (o) {
            return o != null;
          });
          var deleteData = self.productitems[i].isMonth.filter(function (o) {
            return o == "";
          });
          var deletRow = row.filter(function (o) {
            return o == "";
          });

          if (row.length - deletRow.length != data.length - deleteData.length) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }

        var date = new Date();
        var month = date.getMonth() + 1;
        if (self.productitems[i].isMonth.length <= month && new Date().getFullYear() == self.year) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบทุกเดือนจนถึงเดือนปัจจุบัน", "warning");
          return false;
        }

        if (self.productitems[i].isMonth.length <= 12) {
          if (self.year < new Date().getFullYear()) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน", "warning");
            return false;
          }
        }

        if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
          Swal.fire("เกิดข้อผิดพลาด", "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var sItems = [];
      self.productitems.forEach(function (element) {
        sItems.push({
          ProductCode: element.productCode,
          ProductCost: element.productCost,
          MonthQty: element.isMonth
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
          KPIItem: sItems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            self.agentCodeChange();
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this4;

              $(_this4.$refs.form).validate().settings.ignore = ":hidden";

              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/Api/KPIProduct/kpiconfig');

            case 4:
              res = _context3.sent;

              _this4.monthCanEdit = res.data.monthCanEdit;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__ = __webpack_require__(54);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    productItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      monthCanEdit: 2, /* Default FEB, configurable */
      kPIProductType: "KPI_ACCESSORY_LOST",
      isShow: false,
      isExportingSelected: false,
      isExportingAll: false,
      productitems: [],
      productTotalList: [],
      totalCost: 0,
      totalMonth: [],
      totalPoductCost: 0,
      totalProductCostOfMonth: 0,
      i: 0,
      agentCode: null,
      year: new Date().getFullYear(),
      agentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }]
      }
    };
  },

  computed: {
    canExportAllAgents: function canExportAllAgents() {
      return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
    }
  },
  methods: {
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var listProductCode = [];
      this.productitems.forEach(function (element) {
        listProductCode.push(element.productCode);
      });

      this.productitems.push({
        productCode: null,
        productCost: 0,
        isMonth: [],
        totalCal: 0,
        totalCalOfmonth: 0,
        isDisableMonth: [],
        isDisableProduct: false,
        listProductCode: listProductCode
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.productitems.splice(index, 1);
      for (var i = 0; i < this.productitems.length; i++) {}
      this.changeTotal();
    },
    agentCodeChange: function agentCodeChange() {
      var self = this;
      // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
      if (!self.agentCode) {
        self.isShow = false;
        return;
      }
      self.isShow = true;
      self.productitems = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct/getAccessory",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year
        }
      }).then(function (response) {
        var date = new Date();
        var monthNo = date.getMonth() + 1;
        var yearNo = date.getFullYear();

        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            var _loop = function _loop(i) {
              item = response.data[i];
              monthQtyItem = [];
              monthDisable = [];

              if (yearNo <= self.year) {
                /* Current Year */
                for (var j = 1; j < item.monthView.length; j++) {
                  if (j > monthNo) {
                    monthDisable[j] = true;
                  } else if (j <= monthNo) {
                    if (item.monthView[j].hasKpiData) {
                      monthDisable[j] = false;
                      monthQtyItem[j] = item.monthView[j].monthQty;
                      monthDisable[j] = item.monthView[j].isDisableMonth;
                    }
                  } else {
                    monthQtyItem[j] = item.monthView[j].monthQty;
                    monthDisable[j] = item.monthView[j].isDisableMonth;
                    monthDisable[j] = true;
                  }
                }
              } else {
                /* Previous Year */
                for (var _j = 1; _j < item.monthView.length; _j++) {
                  if (item.monthView[_j].hasKpiData) {
                    monthQtyItem[_j] = item.monthView[_j].monthQty;
                  }

                  //if (self.year == yearNo) {
                  //  monthDisable[j] = false;
                  //}
                  //else {
                  //  monthDisable[j] = true;
                  //}

                  //==== Check with config ====
                  if (self.year < yearNo) {
                    var currentMonth = new Date().getMonth() + 1;

                    console.log("Current Year : " + yearNo);
                    console.log("Current Month : " + currentMonth);
                    console.log("Previous Year : " + self.year);
                    console.log("Editable Month : " + self.monthCanEdit);

                    if (currentMonth <= self.monthCanEdit) {
                      //
                      monthDisable[_j] = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
                    } else {
                      //
                      monthDisable[_j] = true;
                    }
                  } else {
                    monthDisable[_j] = false;
                  }
                }
              }

              self.productitems.push({
                productCode: item.productCode,
                productCost: item.productCost,
                isMonth: monthQtyItem,
                isDisableMonth: monthDisable,
                isDisableProduct: true,
                productCodeOptionsData: {
                  id: item.productCode,
                  text: item.productName + " [" + item.productCode + "]",
                  data: null
                }
              });

              setTimeout(function () {
                self.$refs.Items[i].$refs.productCode.setSelectedData(self.productitems[i].productCodeOptionsData);
                self.changeTotal();
              }, 100);
            };

            for (var i = 0; i < response.data.length; i++) {
              var item;
              var monthQtyItem;
              var monthDisable;

              _loop(i);
            }
            self.isShow = true;
          } else {
            self.changeTotal();
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
          router.go(-1);
          self.isShow = false;
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
        router.go(-1);
        self.isShow = false;
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    changeTotal: function changeTotal() {
      var _this = this;

      this.totalCost = 0;
      this.totalMonth = [];
      this.totalPoductCost = 0;
      this.totalProductCostOfMonth = 0;
      this.productitems.forEach(function (e) {
        _this.totalCost = _this.totalCost + Number(e.productCost);
        _this.totalPoductCost = _this.totalPoductCost + Number(e.totalCost);
        _this.totalProductCostOfMonth = _this.totalProductCostOfMonth + Number(e.totalCalOfmonth);
        for (var i = 1; i < e.isMonth.length; i++) {
          if (e.isMonth[i] != null) {
            var oldtotal = _this.totalMonth[i] == undefined ? 0 : _this.totalMonth[i];
            _this.totalMonth[i] = Number(e.isMonth[i]) + oldtotal;
          }
        }
      });
    },
    exportExcelSelected: function exportExcelSelected() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.isExportingSelected) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_this2.year) {
                  _context.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context.abrupt("return");

              case 5:
                _this2.isExportingSelected = true;
                _context.prev = 6;
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/AccessoriesLost", { year: _this2.year, agentCode: _this2.agentCode || null }, "รายงาน_อุปกรณ์ส่งเสริมสูญหาย.xlsx", _this2.$root.user && _this2.$root.user.access_token);

              case 9:
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);

                console.error("[KPI Export Selected]", _context.t0);
                msg = _context.t0.response && _context.t0.response.statusText || _context.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context.prev = 16;

                _this2.isExportingSelected = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 11, 16, 19]]);
      }))();
    },
    exportExcelAllAgents: function exportExcelAllAgents() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.isExportingAll) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (_this3.year) {
                  _context2.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context2.abrupt("return");

              case 5:
                _this3.isExportingAll = true;
                _context2.prev = 6;
                _context2.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/AccessoriesLost/AllAgents", { year: _this3.year }, "รายงาน_อุปกรณ์ส่งเสริมสูญหาย_ทุกตัวแทน.xlsx", _this3.$root.user && _this3.$root.user.access_token);

              case 9:
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);

                console.error("[KPI Export All]", _context2.t0);
                msg = _context2.t0.response && _context2.t0.response.statusText || _context2.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context2.prev = 16;

                _this3.isExportingAll = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 11, 16, 19]]);
      }))();
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.agentCode === null || self.agentCode == "") {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือก ตัวแทนจำหน่าย", "warning");
        return false;
      }
      if (self.productitems.length < 1) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการอุปกรณ์ส่งเสริมสูญหาย", "warning");
        return false;
      }

      var countRow = self.productitems[0].isMonth;
      for (var i = 0; i < self.productitems.length; i++) {
        if (self.productitems[i].isMonth.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนอุปกรณ์ส่งเสริมสูญหาย", "warning");
          return false;
        }

        if (self.productitems[i].productCost == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
          return false;
        }

        if (countRow.filter(function (o) {
          return o != "";
        }).length != self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
          return false;
        } else if (countRow.filter(function (o) {
          return o != "";
        }).length == self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          var data = self.productitems[i].isMonth.filter(function (o) {
            return o != null;
          });
          var row = self.productitems[0].isMonth.filter(function (o) {
            return o != null;
          });
          var deleteData = self.productitems[i].isMonth.filter(function (o) {
            return o == "";
          });
          var deletRow = row.filter(function (o) {
            return o == "";
          });

          if (row.length - deletRow.length != data.length - deleteData.length) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }

        var date = new Date();
        var month = date.getMonth() + 1;
        if (self.productitems[i].isMonth.length <= month && new Date().getFullYear() == self.year) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบทุกเดือนจนถึงเดือนปัจจุบัน", "warning");
          return false;
        }

        if (self.productitems[i].isMonth.length <= 12) {
          if (self.year < new Date().getFullYear()) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน", "warning");
            return false;
          }
        }

        if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
          Swal.fire("เกิดข้อผิดพลาด", "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var sItems = [];
      self.productitems.forEach(function (element) {
        sItems.push({
          ProductCode: element.productCode,
          ProductCost: element.productCost,
          MonthQty: element.isMonth
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
          KPIItem: sItems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            self.agentCodeChange();
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this4;

              $(_this4.$refs.form).validate().settings.ignore = ":hidden";

              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/Api/KPIProduct/kpiconfig');

            case 4:
              res = _context3.sent;

              _this4.monthCanEdit = res.data.monthCanEdit;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__ = __webpack_require__(54);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    productItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      monthCanEdit: 2, /* Default FEB, configurable */
      kPIProductType: "KPI_DAMAGE_MACH",
      isShow: false,
      isExportingSelected: false,
      isExportingAll: false,
      productitems: [],
      productTotalList: [],
      totalCost: 0,
      totalMonth: [],
      totalPoductCost: 0,
      totalProductCostOfMonth: 0,
      i: 0,
      agentCode: null,
      year: new Date().getFullYear(),
      agentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }]
      }
    };
  },

  computed: {
    canExportAllAgents: function canExportAllAgents() {
      return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
    }
  },
  methods: {
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var listProductCode = [];
      this.productitems.forEach(function (element) {
        listProductCode.push(element.productCode);
      });

      this.productitems.push({
        productCode: null,
        productCost: 0,
        isMonth: [],
        totalCal: 0,
        totalCalOfmonth: 0,
        isDisableMonth: [],
        isDisableProduct: false,
        listProductCode: listProductCode
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.productitems.splice(index, 1);
      for (var i = 0; i < this.productitems.length; i++) {}
      this.changeTotal();
    },
    agentCodeChange: function agentCodeChange() {
      var self = this;
      // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
      if (!self.agentCode) {
        self.isShow = false;
        return;
      }
      self.isShow = true;
      self.productitems = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct/getAccessory",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year
        }
      }).then(function (response) {
        var date = new Date();
        var monthNo = date.getMonth() + 1;
        var yearNo = date.getFullYear();

        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            var _loop = function _loop(i) {
              item = response.data[i];
              monthQtyItem = [];
              monthDisable = [];

              if (yearNo <= self.year) {
                /* Current Year */
                for (var j = 1; j < item.monthView.length; j++) {
                  if (j > monthNo) {
                    monthDisable[j] = true;
                  } else if (j <= monthNo) {
                    if (item.monthView[j].hasKpiData) {
                      monthDisable[j] = false;
                      monthQtyItem[j] = item.monthView[j].monthQty;
                      monthDisable[j] = item.monthView[j].isDisableMonth;
                    }
                  } else {
                    monthQtyItem[j] = item.monthView[j].monthQty;
                    monthDisable[j] = item.monthView[j].isDisableMonth;
                    monthDisable[j] = true;
                  }
                }
              } else {
                /* Previous Year */
                for (var _j = 1; _j < item.monthView.length; _j++) {
                  if (item.monthView[_j].hasKpiData) {
                    monthQtyItem[_j] = item.monthView[_j].monthQty;
                  }

                  //if (self.year == yearNo) {
                  //  monthDisable[j] = false;
                  //}
                  //else {
                  //  monthDisable[j] = true;
                  //}

                  //==== Check with config ====
                  if (self.year < yearNo) {
                    var currentMonth = new Date().getMonth() + 1;

                    console.log("Current Year : " + yearNo);
                    console.log("Current Month : " + currentMonth);
                    console.log("Previous Year : " + self.year);
                    console.log("Editable Month : " + self.monthCanEdit);

                    if (currentMonth <= self.monthCanEdit) {
                      //
                      monthDisable[_j] = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
                    } else {
                      //
                      monthDisable[_j] = true;
                    }
                  } else {
                    monthDisable[_j] = false;
                  }
                }
              }

              self.productitems.push({
                productCode: item.productCode,
                productCost: item.productCost,
                isMonth: monthQtyItem,
                isDisableMonth: monthDisable,
                isDisableProduct: true,
                productCodeOptionsData: {
                  id: item.productCode,
                  text: item.productName + " [" + item.productCode + "]",
                  data: null
                }
              });

              setTimeout(function () {
                self.$refs.Items[i].$refs.productCode.setSelectedData(self.productitems[i].productCodeOptionsData);
                self.changeTotal();
              }, 100);
            };

            for (var i = 0; i < response.data.length; i++) {
              var item;
              var monthQtyItem;
              var monthDisable;

              _loop(i);
            }
            self.isShow = true;
          } else {
            self.changeTotal();
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
          router.go(-1);
          self.isShow = false;
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
        router.go(-1);
        self.isShow = false;
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    changeTotal: function changeTotal() {
      var _this = this;

      this.totalCost = 0;
      this.totalMonth = [];
      this.totalPoductCost = 0;
      this.totalProductCostOfMonth = 0;
      this.productitems.forEach(function (e) {
        _this.totalCost = _this.totalCost + Number(e.productCost);
        _this.totalPoductCost = _this.totalPoductCost + Number(e.totalCost);
        _this.totalProductCostOfMonth = _this.totalProductCostOfMonth + Number(e.totalCalOfmonth);
        for (var i = 1; i < e.isMonth.length; i++) {
          if (e.isMonth[i] != null) {
            var oldtotal = _this.totalMonth[i] == undefined ? 0 : _this.totalMonth[i];
            _this.totalMonth[i] = Number(e.isMonth[i]) + oldtotal;
          }
        }
      });
    },
    exportExcelSelected: function exportExcelSelected() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.isExportingSelected) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_this2.year) {
                  _context.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context.abrupt("return");

              case 5:
                _this2.isExportingSelected = true;
                _context.prev = 6;
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIComplain/Export/DamageMach", { year: _this2.year, agentCode: _this2.agentCode || null }, "รายงาน_เครื่องเบียร์สดชำรุด.xlsx", _this2.$root.user && _this2.$root.user.access_token);

              case 9:
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);

                console.error("[KPI Export Selected]", _context.t0);
                msg = _context.t0.response && _context.t0.response.statusText || _context.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context.prev = 16;

                _this2.isExportingSelected = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 11, 16, 19]]);
      }))();
    },
    exportExcelAllAgents: function exportExcelAllAgents() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.isExportingAll) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (_this3.year) {
                  _context2.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context2.abrupt("return");

              case 5:
                _this3.isExportingAll = true;
                _context2.prev = 6;
                _context2.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIComplain/Export/DamageMach/AllAgents", { year: _this3.year }, "รายงาน_เครื่องเบียร์สดชำรุด_ทุกตัวแทน.xlsx", _this3.$root.user && _this3.$root.user.access_token);

              case 9:
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);

                console.error("[KPI Export All]", _context2.t0);
                msg = _context2.t0.response && _context2.t0.response.statusText || _context2.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context2.prev = 16;

                _this3.isExportingAll = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 11, 16, 19]]);
      }))();
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }
      if (self.agentCode === null || self.agentCode == "") {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือก ตัวแทนจำหน่าย", "warning");
        return false;
      }
      if (self.productitems.length < 1) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการเครื่องเบียร์สดชำรุด", "warning");
        return false;
      }

      var countRow = self.productitems[0].isMonth;
      for (var i = 0; i < self.productitems.length; i++) {
        if (self.productitems[i].isMonth.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนเครื่องเบียร์สดชำรุด", "warning");
          return false;
        }

        if (self.productitems[i].productCost == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
          return false;
        }

        if (countRow.filter(function (o) {
          return o != "";
        }).length != self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
          return false;
        } else if (countRow.filter(function (o) {
          return o != "";
        }).length == self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          var data = self.productitems[i].isMonth.filter(function (o) {
            return o != null;
          });
          var row = self.productitems[0].isMonth.filter(function (o) {
            return o != null;
          });
          var deleteData = self.productitems[i].isMonth.filter(function (o) {
            return o == "";
          });
          var deletRow = row.filter(function (o) {
            return o == "";
          });

          if (row.length - deletRow.length != data.length - deleteData.length) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }

        var date = new Date();
        var month = date.getMonth() + 1;
        if (self.productitems[i].isMonth.length <= month && new Date().getFullYear() == self.year) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบทุกเดือนจนถึงเดือนปัจจุบัน", "warning");
          return false;
        }

        if (self.productitems[i].isMonth.length <= 12) {
          if (self.year < new Date().getFullYear()) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน", "warning");
            return false;
          }
        }

        if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
          Swal.fire("เกิดข้อผิดพลาด", "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var sItems = [];
      self.productitems.forEach(function (element) {
        sItems.push({
          ProductCode: element.productCode,
          ProductCost: element.productCost,
          MonthQty: element.isMonth
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
          KPIItem: sItems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            self.agentCodeChange();
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this4;

              $(_this4.$refs.form).validate().settings.ignore = ":hidden";

              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/Api/KPIProduct/kpiconfig');

            case 4:
              res = _context3.sent;

              _this4.monthCanEdit = res.data.monthCanEdit;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__ = __webpack_require__(54);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    productItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      monthCanEdit: 2, /* Default FEB, configurable */
      kPIProductType: "KPI_LOST_MACH",
      isShow: false,
      isExportingSelected: false,
      isExportingAll: false,
      productitems: [],
      productTotalList: [],
      totalCost: 0,
      totalMonth: [],
      totalPoductCost: 0,
      totalProductCostOfMonth: 0,
      i: 0,
      agentCode: null,
      year: new Date().getFullYear(),
      agentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }]
      }
    };
  },

  computed: {
    canExportAllAgents: function canExportAllAgents() {
      return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
    }
  },
  methods: {
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var listProductCode = [];
      this.productitems.forEach(function (element) {
        listProductCode.push(element.productCode);
      });

      this.productitems.push({
        productCode: null,
        productCost: 0,
        isMonth: [],
        totalCal: 0,
        totalCalOfmonth: 0,
        isDisableMonth: [],
        isDisableProduct: false,
        listProductCode: listProductCode
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.productitems.splice(index, 1);
      for (var i = 0; i < this.productitems.length; i++) {}
      this.changeTotal();
    },
    agentCodeChange: function agentCodeChange() {
      var self = this;
      // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
      if (!self.agentCode) {
        self.isShow = false;
        return;
      }
      self.isShow = true;
      self.productitems = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct/getAccessory",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year
        }
      }).then(function (response) {
        var date = new Date();
        var monthNo = date.getMonth() + 1;
        var yearNo = date.getFullYear();

        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            var _loop = function _loop(i) {
              item = response.data[i];
              monthQtyItem = [];
              monthDisable = [];

              if (yearNo <= self.year) {
                /* Current Year */
                for (var j = 1; j < item.monthView.length; j++) {
                  if (j > monthNo) {
                    monthDisable[j] = true;
                  } else if (j <= monthNo) {
                    if (item.monthView[j].hasKpiData) {
                      monthDisable[j] = false;
                      monthQtyItem[j] = item.monthView[j].monthQty;
                      monthDisable[j] = item.monthView[j].isDisableMonth;
                    }
                  } else {
                    monthQtyItem[j] = item.monthView[j].monthQty;
                    monthDisable[j] = item.monthView[j].isDisableMonth;
                    monthDisable[j] = true;
                  }
                }
              } else {
                /* Previous Year */
                for (var _j = 1; _j < item.monthView.length; _j++) {
                  if (item.monthView[_j].hasKpiData) {
                    monthQtyItem[_j] = item.monthView[_j].monthQty;
                  }

                  //if (self.year == yearNo) {
                  //  monthDisable[j] = false;
                  //}
                  //else {
                  //  monthDisable[j] = true;
                  //}

                  //==== Check with config ====
                  if (self.year < yearNo) {
                    var currentMonth = new Date().getMonth() + 1;

                    console.log("Current Year : " + yearNo);
                    console.log("Current Month : " + currentMonth);
                    console.log("Previous Year : " + self.year);
                    console.log("Editable Month : " + self.monthCanEdit);

                    if (currentMonth <= self.monthCanEdit) {
                      //
                      monthDisable[_j] = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
                    } else {
                      //
                      monthDisable[_j] = true;
                    }
                  } else {
                    monthDisable[_j] = false;
                  }
                }
              }

              self.productitems.push({
                productCode: item.productCode,
                productCost: item.productCost,
                isMonth: monthQtyItem,
                isDisableMonth: monthDisable,
                isDisableProduct: true,
                productCodeOptionsData: {
                  id: item.productCode,
                  text: item.productName + " [" + item.productCode + "]",
                  data: null
                }
              });

              setTimeout(function () {
                self.$refs.Items[i].$refs.productCode.setSelectedData(self.productitems[i].productCodeOptionsData);
                self.changeTotal();
              }, 100);
            };

            for (var i = 0; i < response.data.length; i++) {
              var item;
              var monthQtyItem;
              var monthDisable;

              _loop(i);
            }
            self.isShow = true;
          } else {
            self.changeTotal();
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
          router.go(-1);
          self.isShow = false;
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
        router.go(-1);
        self.isShow = false;
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    changeTotal: function changeTotal() {
      var _this = this;

      this.totalCost = 0;
      this.totalMonth = [];
      this.totalPoductCost = 0;
      this.totalProductCostOfMonth = 0;
      this.productitems.forEach(function (e) {
        _this.totalCost = _this.totalCost + Number(e.productCost);
        _this.totalPoductCost = _this.totalPoductCost + Number(e.totalCost);
        _this.totalProductCostOfMonth = _this.totalProductCostOfMonth + Number(e.totalCalOfmonth);
        for (var i = 1; i < e.isMonth.length; i++) {
          if (e.isMonth[i] != null) {
            var oldtotal = _this.totalMonth[i] == undefined ? 0 : _this.totalMonth[i];
            _this.totalMonth[i] = Number(e.isMonth[i]) + oldtotal;
          }
        }
      });
    },
    exportExcelSelected: function exportExcelSelected() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.isExportingSelected) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_this2.year) {
                  _context.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context.abrupt("return");

              case 5:
                _this2.isExportingSelected = true;
                _context.prev = 6;
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIComplain/Export/LostMach", { year: _this2.year, agentCode: _this2.agentCode || null }, "รายงาน_เครื่องเบียร์สดสูญหาย.xlsx", _this2.$root.user && _this2.$root.user.access_token);

              case 9:
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);

                console.error("[KPI Export Selected]", _context.t0);
                msg = _context.t0.response && _context.t0.response.statusText || _context.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context.prev = 16;

                _this2.isExportingSelected = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 11, 16, 19]]);
      }))();
    },
    exportExcelAllAgents: function exportExcelAllAgents() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.isExportingAll) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (_this3.year) {
                  _context2.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context2.abrupt("return");

              case 5:
                _this3.isExportingAll = true;
                _context2.prev = 6;
                _context2.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIComplain/Export/LostMach/AllAgents", { year: _this3.year }, "รายงาน_เครื่องเบียร์สดสูญหาย_ทุกตัวแทน.xlsx", _this3.$root.user && _this3.$root.user.access_token);

              case 9:
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);

                console.error("[KPI Export All]", _context2.t0);
                msg = _context2.t0.response && _context2.t0.response.statusText || _context2.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context2.prev = 16;

                _this3.isExportingAll = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 11, 16, 19]]);
      }))();
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }
      if (self.agentCode === null || self.agentCode == "") {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือก ตัวแทนจำหน่าย", "warning");
        return false;
      }
      if (self.productitems.length < 1) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการเครื่องเบียร์สดสูญหาย", "warning");
        return false;
      }

      var countRow = self.productitems[0].isMonth;
      for (var i = 0; i < self.productitems.length; i++) {
        if (self.productitems[i].isMonth.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนเครื่องเบียร์สดสูญหาย", "warning");
          return false;
        }

        if (self.productitems[i].productCost == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
          return false;
        }

        if (countRow.filter(function (o) {
          return o != "";
        }).length != self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
          return false;
        } else if (countRow.filter(function (o) {
          return o != "";
        }).length == self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          var data = self.productitems[i].isMonth.filter(function (o) {
            return o != null;
          });
          var row = self.productitems[0].isMonth.filter(function (o) {
            return o != null;
          });
          var deleteData = self.productitems[i].isMonth.filter(function (o) {
            return o == "";
          });
          var deletRow = row.filter(function (o) {
            return o == "";
          });

          if (row.length - deletRow.length != data.length - deleteData.length) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }

        var date = new Date();
        var month = date.getMonth() + 1;
        if (self.productitems[i].isMonth.length <= month && new Date().getFullYear() == self.year) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบทุกเดือนจนถึงเดือนปัจจุบัน", "warning");
          return false;
        }

        if (self.productitems[i].isMonth.length <= 12) {
          if (self.year < new Date().getFullYear()) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน", "warning");
            return false;
          }
        }

        if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
          Swal.fire("เกิดข้อผิดพลาด", "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var sItems = [];
      self.productitems.forEach(function (element) {
        sItems.push({
          ProductCode: element.productCode,
          ProductCost: element.productCost,
          MonthQty: element.isMonth
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
          KPIItem: sItems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            self.agentCodeChange();
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this4;

              $(_this4.$refs.form).validate().settings.ignore = ":hidden";

              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/Api/KPIProduct/kpiconfig');

            case 4:
              res = _context3.sent;

              _this4.monthCanEdit = res.data.monthCanEdit;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__ = __webpack_require__(54);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    productItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      monthCanEdit: 2, /* Default FEB, configurable */
      kPIProductType: "KPI_LOST_TANK",
      isShow: false,
      isExportingSelected: false,
      isExportingAll: false,
      productitems: [],
      productTotalList: [],
      totalCost: 0,
      totalMonth: [],
      totalPoductCost: 0,
      totalProductCostOfMonth: 0,
      i: 0,
      agentCode: null,
      year: new Date().getFullYear(),
      agentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }]
      }
    };
  },

  computed: {
    canExportAllAgents: function canExportAllAgents() {
      return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
    }
  },
  methods: {
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var listProductCode = [];
      this.productitems.forEach(function (element) {
        listProductCode.push(element.productCode);
      });

      this.productitems.push({
        productCode: null,
        productCost: 0,
        isMonth: [],
        totalCal: 0,
        totalCalOfmonth: 0,
        isDisableMonth: [],
        isDisableProduct: false,
        listProductCode: listProductCode
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.productitems.splice(index, 1);
      for (var i = 0; i < this.productitems.length; i++) {}
      this.changeTotal();
    },
    agentCodeChange: function agentCodeChange() {
      var self = this;
      // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
      if (!self.agentCode) {
        self.isShow = false;
        return;
      }
      self.isShow = true;
      self.productitems = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct/getAccessory",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year
        }
      }).then(function (response) {
        var date = new Date();
        var monthNo = date.getMonth() + 1;
        var yearNo = date.getFullYear();

        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            var _loop = function _loop(i) {
              item = response.data[i];
              monthQtyItem = [];
              monthDisable = [];

              if (yearNo == self.year) {
                /* Current Year */
                for (var j = 1; j < item.monthView.length; j++) {
                  if (j > monthNo) {
                    monthDisable[j] = true;
                  } else if (j <= monthNo) {
                    if (item.monthView[j].hasKpiData) {
                      monthDisable[j] = false;
                      monthQtyItem[j] = item.monthView[j].monthQty;
                      monthDisable[j] = item.monthView[j].isDisableMonth;
                    }
                  } else {
                    monthQtyItem[j] = item.monthView[j].monthQty;
                    monthDisable[j] = item.monthView[j].isDisableMonth;
                    monthDisable[j] = true;
                  }
                }
              } else {
                /* Previous Year */
                for (var _j = 1; _j < item.monthView.length; _j++) {
                  if (item.monthView[_j].hasKpiData) {
                    monthQtyItem[_j] = item.monthView[_j].monthQty;
                  }

                  //if (self.year == yearNo) {
                  //  monthDisable[j] = false;
                  //}
                  //else {
                  //  monthDisable[j] = true;
                  //}

                  //==== Check with config ====
                  if (self.year < yearNo) {
                    var currentMonth = new Date().getMonth() + 1;

                    console.log("Current Year : " + yearNo);
                    console.log("Current Month : " + currentMonth);
                    console.log("Previous Year : " + self.year);
                    console.log("Editable Month : " + self.monthCanEdit);

                    if (currentMonth <= self.monthCanEdit) {
                      //
                      monthDisable[_j] = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
                    } else {
                      //
                      monthDisable[_j] = true;
                    }
                  } else {
                    monthDisable[_j] = false;
                  }
                }
              }

              self.productitems.push({
                productCode: item.productCode,
                productCost: item.productCost,
                isMonth: monthQtyItem,
                isDisableMonth: monthDisable,
                isDisableProduct: true,
                productCodeOptionsData: {
                  id: item.productCode,
                  text: item.productName + " [" + item.productCode + "]",
                  data: null
                }
              });

              setTimeout(function () {
                self.$refs.Items[i].$refs.productCode.setSelectedData(self.productitems[i].productCodeOptionsData);
                self.changeTotal();
              }, 100);
            };

            for (var i = 0; i < response.data.length; i++) {
              var item;
              var monthQtyItem;
              var monthDisable;

              _loop(i);
            }
            self.isShow = true;
          } else {
            self.changeTotal();
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
          router.go(-1);
          self.isShow = false;
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
        router.go(-1);
        self.isShow = false;
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    changeTotal: function changeTotal() {
      var _this = this;

      this.totalCost = 0;
      this.totalMonth = [];
      this.totalPoductCost = 0;
      this.totalProductCostOfMonth = 0;
      this.productitems.forEach(function (e) {
        _this.totalCost = _this.totalCost + Number(e.productCost);
        _this.totalPoductCost = _this.totalPoductCost + Number(e.totalCost);
        _this.totalProductCostOfMonth = _this.totalProductCostOfMonth + Number(e.totalCalOfmonth);
        for (var i = 1; i < e.isMonth.length; i++) {
          if (e.isMonth[i] != null) {
            var oldtotal = _this.totalMonth[i] == undefined ? 0 : _this.totalMonth[i];
            _this.totalMonth[i] = Number(e.isMonth[i]) + oldtotal;
          }
        }
      });
    },
    exportExcelSelected: function exportExcelSelected() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.isExportingSelected) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_this2.year) {
                  _context.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context.abrupt("return");

              case 5:
                _this2.isExportingSelected = true;
                _context.prev = 6;
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIComplain/Export/LostTank", { year: _this2.year, agentCode: _this2.agentCode || null }, "รายงาน_ถังเปล่า_Co2_สูญหาย.xlsx", _this2.$root.user && _this2.$root.user.access_token);

              case 9:
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);

                console.error("[KPI Export Selected]", _context.t0);
                msg = _context.t0.response && _context.t0.response.statusText || _context.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context.prev = 16;

                _this2.isExportingSelected = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 11, 16, 19]]);
      }))();
    },
    exportExcelAllAgents: function exportExcelAllAgents() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.isExportingAll) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (_this3.year) {
                  _context2.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context2.abrupt("return");

              case 5:
                _this3.isExportingAll = true;
                _context2.prev = 6;
                _context2.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIComplain/Export/LostTank/AllAgents", { year: _this3.year }, "รายงาน_ถังเปล่า_Co2_สูญหาย_ทุกตัวแทน.xlsx", _this3.$root.user && _this3.$root.user.access_token);

              case 9:
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);

                console.error("[KPI Export All]", _context2.t0);
                msg = _context2.t0.response && _context2.t0.response.statusText || _context2.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context2.prev = 16;

                _this3.isExportingAll = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 11, 16, 19]]);
      }))();
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.agentCode === null || self.agentCode == "") {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือก ตัวแทนจำหน่าย", "warning");
        return false;
      }
      if (self.productitems.length < 1) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการถังเปล่า/Co2 สูญหาย", "warning");
        return false;
      }

      var countRow = self.productitems[0].isMonth;
      for (var i = 0; i < self.productitems.length; i++) {
        if (self.productitems[i].isMonth.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนถังเปล่า/Co2 สูญหาย", "warning");
          return false;
        }

        if (self.productitems[i].productCost == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
          return false;
        }

        if (countRow.filter(function (o) {
          return o != "";
        }).length != self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
          return false;
        } else if (countRow.filter(function (o) {
          return o != "";
        }).length == self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          var data = self.productitems[i].isMonth.filter(function (o) {
            return o != null;
          });
          var row = self.productitems[0].isMonth.filter(function (o) {
            return o != null;
          });
          var deleteData = self.productitems[i].isMonth.filter(function (o) {
            return o == "";
          });
          var deletRow = row.filter(function (o) {
            return o == "";
          });

          if (row.length - deletRow.length != data.length - deleteData.length) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }

        var date = new Date();
        var month = date.getMonth() + 1;
        if (self.productitems[i].isMonth.length <= month && new Date().getFullYear() == self.year) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบทุกเดือนจนถึงเดือนปัจจุบัน", "warning");
          return false;
        }

        if (self.productitems[i].isMonth.length <= 12) {
          if (self.year < new Date().getFullYear()) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน", "warning");
            return false;
          }
        }

        if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
          Swal.fire("เกิดข้อผิดพลาด", "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var sItems = [];
      self.productitems.forEach(function (element) {
        sItems.push({
          ProductCode: element.productCode,
          ProductCost: element.productCost,
          MonthQty: element.isMonth
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
          KPIItem: sItems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            self.agentCodeChange();
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this4;

              $(_this4.$refs.form).validate().settings.ignore = ":hidden";

              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/Api/KPIProduct/kpiconfig');

            case 4:
              res = _context3.sent;

              _this4.monthCanEdit = res.data.monthCanEdit;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductItemCalRow__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__ = __webpack_require__(54);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    productItemCalRow: __WEBPACK_IMPORTED_MODULE_4__ProductItemCalRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      monthCanEdit: 2, /* Default FEB, configurable */
      kPIProductType: "KPI_PRODUCT_CYCLE",
      isShow: false,
      isExportingSelected: false,
      isExportingAll: false,
      productitems: [],
      productTotalList: [],
      totalCost: 0,
      totalPoductCost: 0,
      totalProductCostOfMonth: 0,
      i: 0,
      agentCode: null,
      year: new Date().getFullYear(),
      agentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }]
      }
    };
  },

  computed: {
    canExportAllAgents: function canExportAllAgents() {
      return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
    }
  },
  methods: {
    initializeData: function initializeData() {
      return Array(12).fill().map(function () {
        return {
          data1: null,
          data2: null,
          data3: null,
          data4: null,
          data5: null
        };
      });
    },
    calculateMonthTotal: function calculateMonthTotal(monthIndex, dataIndex) {
      if (dataIndex === 5) {
        var totalData1 = this.productitems.reduce(function (acc, item) {
          return acc + item.data[monthIndex - 1]['data1'];
        }, 0);
        var totalData2 = this.productitems.reduce(function (acc, item) {
          return acc + item.data[monthIndex - 1]['data2'];
        }, 0);
        var totalData3 = this.productitems.reduce(function (acc, item) {
          return acc + item.data[monthIndex - 1]['data3'];
        }, 0);
        var totalPercent = (totalData3 / (totalData1 + totalData2) * 100).toFixed(2);
        if (!(totalPercent == Number.POSITIVE_INFINITY || totalPercent == Number.NEGATIVE_INFINITY) && !isNaN(parseFloat(totalPercent))) {
          return totalPercent;
        } else {
          return 0;
        }
      } else {
        return this.productitems.reduce(function (acc, item) {
          return acc + item.data[monthIndex - 1]['data' + dataIndex];
        }, 0);
      }
    },
    calculateTotalData: function calculateTotalData(dataIndex) {
      var total = 0;
      for (var monthIndex = 1; monthIndex <= 12; monthIndex++) {
        total += this.calculateMonthTotal(monthIndex, dataIndex);
      }
      return total;
    },
    calculateTotalPercent: function calculateTotalPercent() {
      var totalData1 = this.calculateTotalData(1);
      var totalData2 = this.calculateTotalData(2);
      var totalData3 = this.calculateTotalData(3);
      var totalPercent = (totalData3 / (totalData1 + totalData2) * 100).toFixed(2);
      if (!(totalPercent == Number.POSITIVE_INFINITY || totalPercent == Number.NEGATIVE_INFINITY) && !isNaN(parseFloat(totalPercent))) {
        return totalPercent;
      } else {
        return 0;
      }
    },
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var listProductCode = [];
      this.productitems.forEach(function (element) {
        listProductCode.push(element.productCode);
      });
      this.productitems.push({
        productCode: null,
        productCost: 0,
        data: this.initializeData(),
        isDisableRow: false,
        isDisableProduct: false,
        listProductCode: listProductCode
      });
    },
    isDisableRow: function isDisableRow() {
      var date = new Date();
      var monthNo = date.getMonth() + 1;
      var yearNo = date.getFullYear();

      var isDisable = false;

      if (this.year < yearNo) {
        /* Previous Year */

        if (monthNo <= this.monthCanEdit) {
          isDisable = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
        } else {
          isDisable = true;
        }
      } else {
        /* Current Year */
        isDisable = false;
      }
      return isDisable;
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.productitems.splice(index, 1);
      for (var i = 0; i < this.productitems.length; i++) {}
      this.changeTotal();
    },
    agentCodeChange: function agentCodeChange() {
      var self = this;
      var router = this.$router;
      // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
      if (!self.agentCode) {
        self.isShow = false;
        return;
      }
      self.isShow = true;
      self.productitems = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct/getAccessory",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year
        }
      }).then(function (response) {
        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            var _loop = function _loop(i) {
              item = response.data[i];

              var kpiData = [];
              for (var j = 1; j < item.monthView.length; j++) {
                var totalData1 = item.monthView[j].monthQty !== null ? parseInt(item.monthView[j].monthQty) : null;
                var totalData2 = item.monthView[j].monthQtyReceive !== null ? parseInt(item.monthView[j].monthQtyReceive) : null;
                var totalData3 = item.monthView[j].monthQtyReturn !== null ? parseInt(item.monthView[j].monthQtyReturn) : null;
                var totalData4 = null;
                var totalPercent = null;
                if (totalData2 === null || totalData3 === null) {
                  totalData1 = null;
                }
                if (totalData1 !== null && totalData2 !== null && totalData3 !== null) {
                  totalData4 = totalData1 + totalData2 - totalData3;
                  if (totalData1 === 0 && totalData2 === 0) {
                    totalPercent = 0;
                  } else {
                    totalPercent = (totalData3 / (totalData1 + totalData2) * 100).toFixed(2);
                    if (!isNaN(parseFloat(totalPercent))) {
                      totalPercent = parseFloat(totalPercent);
                    } else {
                      totalPercent = 0;
                    }
                  }
                }
                kpiData.push({
                  data1: totalData1,
                  data2: totalData2,
                  data3: totalData3,
                  data4: totalData4,
                  data5: parseFloat(totalPercent)
                });
              }
              self.productitems.push({
                productCode: item.productCode,
                productCost: item.productCost,
                //isDisableRow: false,
                isDisableRow: self.isDisableRow(),
                isDisableProduct: true,
                data: kpiData,
                productCodeOptionsData: {
                  id: item.productCode,
                  text: item.productName + " [" + item.productCode + "]",
                  data: null
                }
              });

              setTimeout(function () {
                self.$refs.Items[i].$refs.productCode.setSelectedData(self.productitems[i].productCodeOptionsData);
                self.changeTotal();
              }, 100);
            };

            for (var i = 0; i < response.data.length; i++) {
              var item;

              _loop(i);
            }
            self.isShow = true;
          } else {
            self.changeTotal();
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
          router.go(-1);
          self.isShow = false;
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
        router.go(-1);
        self.isShow = false;
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    changeTotal: function changeTotal() {
      var _this = this;

      this.totalCost = 0;
      this.productitems.forEach(function (e) {
        _this.totalCost = _this.totalCost + Number(e.productCost);
      });
    },
    exportExcelSelected: function exportExcelSelected() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.isExportingSelected) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_this2.year) {
                  _context.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context.abrupt("return");

              case 5:
                _this2.isExportingSelected = true;
                _context.prev = 6;
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/ProductCycle", { year: _this2.year, agentCode: _this2.agentCode || null }, "รายงาน_ถังเปล่าหมุนเวียน.xlsx", _this2.$root.user && _this2.$root.user.access_token);

              case 9:
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);

                console.error("[KPI Export Selected]", _context.t0);
                msg = _context.t0.response && _context.t0.response.statusText || _context.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context.prev = 16;

                _this2.isExportingSelected = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 11, 16, 19]]);
      }))();
    },
    exportExcelAllAgents: function exportExcelAllAgents() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.isExportingAll) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (_this3.year) {
                  _context2.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context2.abrupt("return");

              case 5:
                _this3.isExportingAll = true;
                _context2.prev = 6;
                _context2.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/ProductCycle/AllAgents", { year: _this3.year }, "รายงาน_ถังเปล่าหมุนเวียน_ทุกตัวแทน.xlsx", _this3.$root.user && _this3.$root.user.access_token);

              case 9:
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);

                console.error("[KPI Export All]", _context2.t0);
                msg = _context2.t0.response && _context2.t0.response.statusText || _context2.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context2.prev = 16;

                _this3.isExportingAll = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 11, 16, 19]]);
      }))();
    },

    formSubmit: function formSubmit(e) {
      var self = this;
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }
      if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
        Swal.fire("เกิดข้อผิดพลาด", "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล", "warning");
        return false;
      }
      if (self.agentCode === null || self.agentCode == "") {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือก ตัวแทนจำหน่าย", "warning");
        return false;
      }
      if (self.productitems.length < 1) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการถังเปล่าหมุนเวียน", "warning");
        return false;
      }
      for (var i = 0; i < self.productitems.length; i++) {
        if (self.productitems[i].productCost == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
          return false;
        }
        var isDataEntered = false;
        var item = self.productitems[i];
        for (var monthIndex = 1; monthIndex <= 12; monthIndex++) {
          if (item.data[monthIndex - 1]['data1'] !== "" && item.data[monthIndex - 1]['data1'] !== null || item.data[monthIndex - 1]['data2'] !== "" && item.data[monthIndex - 1]['data2'] !== null || item.data[monthIndex - 1]['data3'] !== "" && item.data[monthIndex - 1]['data3'] !== null) {
            isDataEntered = true;
            break;
          }
        }
        if (!isDataEntered) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนถังเปล่าหมุนเวียน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
          return false;
        }
      }
      for (var _i = 0; _i < self.productitems.length; _i++) {
        var _item = self.productitems[_i];
        for (var _monthIndex = 1; _monthIndex <= 12; _monthIndex++) {
          if (_item.data[_monthIndex - 1]['data1'] !== "" && _item.data[_monthIndex - 1]['data1'] !== null && (_item.data[_monthIndex - 1]['data2'] === null || _item.data[_monthIndex - 1]['data3'] === null) || _item.data[_monthIndex - 1]['data2'] !== "" && _item.data[_monthIndex - 1]['data2'] !== null && (_item.data[_monthIndex - 1]['data1'] === null || _item.data[_monthIndex - 1]['data3'] === null) || _item.data[_monthIndex - 1]['data3'] !== "" && _item.data[_monthIndex - 1]['data3'] !== null && (_item.data[_monthIndex - 1]['data1'] === null || _item.data[_monthIndex - 1]['data2'] === null)) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนของเดือน " + _monthIndex + " ให้ครบถ้วน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }
      }
      if (self.year == new Date().getFullYear()) {
        var date = new Date();
        var checkmonth = date.getMonth() + 1;
        for (var _i2 = 0; _i2 < self.productitems.length; _i2++) {
          var isDataEmpty = false;
          var _item2 = self.productitems[_i2];
          for (var _monthIndex2 = 1; _monthIndex2 <= checkmonth; _monthIndex2++) {
            if (_item2.data[_monthIndex2 - 1]['data1'] === "" || _item2.data[_monthIndex2 - 1]['data1'] === null || _item2.data[_monthIndex2 - 1]['data2'] === "" || _item2.data[_monthIndex2 - 1]['data2'] === null || _item2.data[_monthIndex2 - 1]['data3'] === "" || _item2.data[_monthIndex2 - 1]['data3'] === null) {
              isDataEmpty = true;
              break;
            }
          }
          if (isDataEmpty) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกข้อมูลให้ครบทุกเดือนจนถึงเดือนปัจจุบัน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }
      }
      if (self.year < new Date().getFullYear()) {
        for (var _i3 = 0; _i3 < self.productitems.length; _i3++) {
          var _isDataEmpty = false;
          var _item3 = self.productitems[_i3];
          for (var _monthIndex3 = 1; _monthIndex3 <= 12; _monthIndex3++) {
            if (_item3.data[_monthIndex3 - 1]['data1'] === "" || _item3.data[_monthIndex3 - 1]['data1'] === null || _item3.data[_monthIndex3 - 1]['data2'] === "" || _item3.data[_monthIndex3 - 1]['data2'] === null || _item3.data[_monthIndex3 - 1]['data3'] === "" || _item3.data[_monthIndex3 - 1]['data3'] === null) {
              _isDataEmpty = true;
              break;
            }
          }
          if (_isDataEmpty) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }
      }
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var sItems = [];
      self.productitems.forEach(function (element) {
        var kpiData = [];
        element.data.forEach(function (elementData) {
          kpiData.push({
            Qty: elementData.data1,
            QtyReceive: elementData.data2,
            QtyReturn: elementData.data3
          });
        });
        sItems.push({
          ProductCode: element.productCode,
          ProductCost: element.productCost,
          MonthQtyData: kpiData
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
          KPIItem: sItems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            self.agentCodeChange();
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this4;

              $(_this4.$refs.form).validate().settings.ignore = ":hidden";

              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/Api/KPIProduct/kpiconfig');

            case 4:
              res = _context3.sent;

              _this4.monthCanEdit = res.data.monthCanEdit;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__ = __webpack_require__(54);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    productItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      monthCanEdit: 2, /* Default FEB, configurable */
      kPIProductType: "KPI_PRODUCT_DILAPIDATED",
      isShow: false,
      isExportingSelected: false,
      isExportingAll: false,
      productitems: [],
      productTotalList: [],
      totalCost: 0,
      totalMonth: [],
      totalPoductCost: 0,
      totalProductCostOfMonth: 0,
      i: 0,
      agentCode: null,
      year: new Date().getFullYear(),
      agentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }]
      }
    };
  },

  computed: {
    canExportAllAgents: function canExportAllAgents() {
      return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
    }
  },
  methods: {
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var listProductCode = [];
      this.productitems.forEach(function (element) {
        listProductCode.push(element.productCode);
      });

      this.productitems.push({
        productCode: null,
        productCost: 0,
        isMonth: [],
        totalCal: 0,
        totalCalOfmonth: 0,
        isDisableMonth: [],
        isDisableProduct: false,
        listProductCode: listProductCode
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.productitems.splice(index, 1);
      for (var i = 0; i < this.productitems.length; i++) {}
      this.changeTotal();
    },
    agentCodeChange: function agentCodeChange() {
      var self = this;
      // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
      if (!self.agentCode) {
        self.isShow = false;
        return;
      }
      self.isShow = true;
      self.productitems = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct/getAccessory",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year
        }
      }).then(function (response) {
        var date = new Date();
        var monthNo = date.getMonth() + 1;
        var yearNo = date.getFullYear();

        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            var _loop = function _loop(i) {
              item = response.data[i];
              monthQtyItem = [];
              monthDisable = [];

              if (new Date().getFullYear() == self.year) {
                /* Current Year */
                for (var j = 1; j < item.monthView.length; j++) {
                  if (j > monthNo) {
                    monthDisable[j] = true;
                  } else if (j <= monthNo) {
                    if (item.monthView[j].hasKpiData) {
                      monthDisable[j] = false;
                      monthQtyItem[j] = item.monthView[j].monthQty;
                      monthDisable[j] = item.monthView[j].isDisableMonth;
                    }
                  } else {
                    monthQtyItem[j] = item.monthView[j].monthQty;
                    monthDisable[j] = item.monthView[j].isDisableMonth;
                    monthDisable[j] = true;
                  }
                }
              } else {
                /* Previous Year */
                for (var _j = 1; _j < item.monthView.length; _j++) {
                  if (item.monthView[_j].hasKpiData) {
                    monthQtyItem[_j] = item.monthView[_j].monthQty;
                  }

                  //if (self.year == yearNo) {
                  //  monthDisable[j] = false;
                  //}
                  //else {
                  //  monthDisable[j] = true;
                  //}

                  //==== Check with config ====
                  if (self.year < yearNo) {
                    var currentMonth = new Date().getMonth() + 1;

                    console.log("Current Year : " + yearNo);
                    console.log("Current Month : " + currentMonth);
                    console.log("Previous Year : " + self.year);
                    console.log("Editable Month : " + self.monthCanEdit);

                    if (currentMonth <= self.monthCanEdit) {
                      //
                      monthDisable[_j] = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
                    } else {
                      //
                      monthDisable[_j] = true;
                    }
                  } else {
                    monthDisable[_j] = false;
                  }
                }
              }

              self.productitems.push({
                productCode: item.productCode,
                productCost: item.productCost,
                isMonth: monthQtyItem,
                isDisableMonth: monthDisable,
                isDisableProduct: true,
                productCodeOptionsData: {
                  id: item.productCode,
                  text: item.productName + " [" + item.productCode + "]",
                  data: null
                }
              });

              setTimeout(function () {
                self.$refs.Items[i].$refs.productCode.setSelectedData(self.productitems[i].productCodeOptionsData);
                self.changeTotal();
              }, 100);
            };

            for (var i = 0; i < response.data.length; i++) {
              var item;
              var monthQtyItem;
              var monthDisable;

              _loop(i);
            }
            self.isShow = true;
          } else {
            self.changeTotal();
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการที่คุณเลือก", "warning");
          router.go(-1);
          self.isShow = false;
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
        router.go(-1);
        self.isShow = false;
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    changeTotal: function changeTotal() {
      var _this = this;

      this.totalCost = 0;
      this.totalMonth = [];
      this.totalPoductCost = 0;
      this.totalProductCostOfMonth = 0;
      this.productitems.forEach(function (e) {
        _this.totalCost = _this.totalCost + Number(e.productCost);
        _this.totalPoductCost = _this.totalPoductCost + Number(e.totalCost);
        _this.totalProductCostOfMonth = _this.totalProductCostOfMonth + Number(e.totalCalOfmonth);
        for (var i = 1; i < e.isMonth.length; i++) {
          if (e.isMonth[i] != null) {
            var oldtotal = _this.totalMonth[i] == undefined ? 0 : _this.totalMonth[i];
            _this.totalMonth[i] = Number(e.isMonth[i]) + oldtotal;
          }
        }
      });
    },
    exportExcelSelected: function exportExcelSelected() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.isExportingSelected) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_this2.year) {
                  _context.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context.abrupt("return");

              case 5:
                _this2.isExportingSelected = true;
                _context.prev = 6;
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/ProductDilapidated", { year: _this2.year, agentCode: _this2.agentCode || null }, "รายงาน_สินค้าที่ชำรุดเสียหาย.xlsx", _this2.$root.user && _this2.$root.user.access_token);

              case 9:
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);

                console.error("[KPI Export Selected]", _context.t0);
                msg = _context.t0.response && _context.t0.response.statusText || _context.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context.prev = 16;

                _this2.isExportingSelected = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 11, 16, 19]]);
      }))();
    },
    exportExcelAllAgents: function exportExcelAllAgents() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.isExportingAll) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (_this3.year) {
                  _context2.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context2.abrupt("return");

              case 5:
                _this3.isExportingAll = true;
                _context2.prev = 6;
                _context2.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/ProductDilapidated/AllAgents", { year: _this3.year }, "รายงาน_สินค้าที่ชำรุดเสียหาย_ทุกตัวแทน.xlsx", _this3.$root.user && _this3.$root.user.access_token);

              case 9:
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);

                console.error("[KPI Export All]", _context2.t0);
                msg = _context2.t0.response && _context2.t0.response.statusText || _context2.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context2.prev = 16;

                _this3.isExportingAll = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 11, 16, 19]]);
      }))();
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.agentCode === null || self.agentCode == "") {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือก ตัวแทนจำหน่าย", "warning");
        return false;
      }
      if (self.productitems.length < 1) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการสินค้าที่ชำรุดเสียหาย", "warning");
        return false;
      }

      var countRow = self.productitems[0].isMonth;
      for (var i = 0; i < self.productitems.length; i++) {
        if (self.productitems[i].isMonth.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าที่ชำรุดเสียหาย", "warning");
          return false;
        }

        if (self.productitems[i].productCost == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
          return false;
        }
        if (countRow.filter(function (o) {
          return o != "";
        }).length != self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
          return false;
        } else if (countRow.filter(function (o) {
          return o != "";
        }).length == self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          var data = self.productitems[i].isMonth.filter(function (o) {
            return o != null;
          });
          var row = self.productitems[0].isMonth.filter(function (o) {
            return o != null;
          });
          var deleteData = self.productitems[i].isMonth.filter(function (o) {
            return o == "";
          });
          var deletRow = row.filter(function (o) {
            return o == "";
          });

          if (row.length - deletRow.length != data.length - deleteData.length) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }

        var date = new Date();
        var month = date.getMonth() + 1;
        if (self.productitems[i].isMonth.length <= month && new Date().getFullYear() == self.year) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบทุกเดือนจนถึงเดือนปัจจุบัน", "warning");
          return false;
        }

        if (self.productitems[i].isMonth.length <= 12) {
          if (self.year < new Date().getFullYear()) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน", "warning");
            return false;
          }
        }
        if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
          Swal.fire("เกิดข้อผิดพลาด", "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var sItems = [];
      self.productitems.forEach(function (element) {
        sItems.push({
          ProductCode: element.productCode,
          ProductCost: element.productCost,
          MonthQty: element.isMonth
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
          KPIItem: sItems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            self.agentCodeChange();
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this4;

              $(_this4.$refs.form).validate().settings.ignore = ":hidden";

              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/Api/KPIProduct/kpiconfig');

            case 4:
              res = _context3.sent;

              _this4.monthCanEdit = res.data.monthCanEdit;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__ = __webpack_require__(54);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    productItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      monthCanEdit: 2, /* Default FEB, configurable */
      kPIProductType: "KPI_PRODUCT_EXPIRE",
      isShow: false,
      isExportingSelected: false,
      isExportingAll: false,
      productitems: [],
      productTotalList: [],
      totalCost: 0,
      totalMonth: [],
      totalPoductCost: 0,
      totalProductCostOfMonth: 0,
      i: 0,
      agentCode: null,
      year: new Date().getFullYear(),
      agentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }]
      }
    };
  },

  computed: {
    canExportAllAgents: function canExportAllAgents() {
      return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
    }
  },
  methods: {
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var listProductCode = [];
      this.productitems.forEach(function (element) {
        listProductCode.push(element.productCode);
      });

      this.productitems.push({
        productCode: null,
        productCost: 0,
        isMonth: [],
        totalCal: 0,
        totalCalOfmonth: 0,
        isDisableMonth: [],
        isDisableProduct: false,
        listProductCode: listProductCode
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.productitems.splice(index, 1);
      for (var i = 0; i < this.productitems.length; i++) {}
      this.changeTotal();
    },
    agentCodeChange: function agentCodeChange() {
      var self = this;
      // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
      if (!self.agentCode) {
        self.isShow = false;
        return;
      }
      self.isShow = true;
      self.productitems = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct/getAccessory",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year
        }
      }).then(function (response) {
        var date = new Date();
        var monthNo = date.getMonth() + 1;
        var yearNo = date.getFullYear();
        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            var _loop = function _loop(i) {
              item = response.data[i];
              monthQtyItem = [];
              monthDisable = [];

              if (new Date().getFullYear() == self.year) {
                /* Current Year */
                for (var j = 1; j < item.monthView.length; j++) {
                  if (j > monthNo) {
                    monthDisable[j] = true;
                  } else if (j <= monthNo) {
                    if (item.monthView[j].hasKpiData) {
                      monthDisable[j] = false;
                      monthQtyItem[j] = item.monthView[j].monthQty;
                      monthDisable[j] = item.monthView[j].isDisableMonth;
                    }
                  } else {
                    monthQtyItem[j] = item.monthView[j].monthQty;
                    monthDisable[j] = item.monthView[j].isDisableMonth;
                    monthDisable[j] = true;
                  }
                }
              } else {
                /* Previous Year */
                for (var _j = 1; _j < item.monthView.length; _j++) {
                  if (item.monthView[_j].hasKpiData) {
                    monthQtyItem[_j] = item.monthView[_j].monthQty;
                  }

                  //if (self.year == yearNo) {
                  //  monthDisable[j] = false;
                  //}
                  //else {
                  //  monthDisable[j] = true;
                  //}

                  //==== Check with config ====
                  if (self.year < yearNo) {
                    var currentMonth = new Date().getMonth() + 1;

                    console.log("Current Year : " + yearNo);
                    console.log("Current Month : " + currentMonth);
                    console.log("Previous Year : " + self.year);
                    console.log("Editable Month : " + self.monthCanEdit);

                    if (currentMonth <= self.monthCanEdit) {
                      //
                      monthDisable[_j] = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
                    } else {
                      //
                      monthDisable[_j] = true;
                    }
                  } else {
                    monthDisable[_j] = false;
                  }
                }
              }

              self.productitems.push({
                productCode: item.productCode,
                productCost: item.productCost,
                isMonth: monthQtyItem,
                isDisableMonth: monthDisable,
                isDisableProduct: true,
                productCodeOptionsData: {
                  id: item.productCode,
                  text: item.productName + " [" + item.productCode + "]",
                  data: null
                }
              });

              setTimeout(function () {
                self.$refs.Items[i].$refs.productCode.setSelectedData(self.productitems[i].productCodeOptionsData);
                self.changeTotal();
              }, 100);
            };

            for (var i = 0; i < response.data.length; i++) {
              var item;
              var monthQtyItem;
              var monthDisable;

              _loop(i);
            }
            self.isShow = true;
          } else {
            self.changeTotal();
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก", "warning");
          router.go(-1);
          self.isShow = false;
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้", "error");
        router.go(-1);
        self.isShow = false;
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    changeTotal: function changeTotal() {
      var _this = this;

      this.totalCost = 0;
      this.totalMonth = [];
      this.totalPoductCost = 0;
      this.totalProductCostOfMonth = 0;
      this.productitems.forEach(function (e) {
        _this.totalCost = _this.totalCost + Number(e.productCost);
        _this.totalPoductCost = _this.totalPoductCost + Number(e.totalCost);
        _this.totalProductCostOfMonth = _this.totalProductCostOfMonth + Number(e.totalCalOfmonth);
        for (var i = 1; i < e.isMonth.length; i++) {
          if (e.isMonth[i] != null) {
            var oldtotal = _this.totalMonth[i] == undefined ? 0 : _this.totalMonth[i];
            _this.totalMonth[i] = Number(e.isMonth[i]) + oldtotal;
          }
        }
      });
    },
    exportExcelSelected: function exportExcelSelected() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.isExportingSelected) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_this2.year) {
                  _context.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context.abrupt("return");

              case 5:
                _this2.isExportingSelected = true;
                _context.prev = 6;
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/ProductExpire", { year: _this2.year, agentCode: _this2.agentCode || null }, "รายงาน_สินค้าหมดอายุ.xlsx", _this2.$root.user && _this2.$root.user.access_token);

              case 9:
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);

                console.error("[KPI Export Selected]", _context.t0);
                msg = _context.t0.response && _context.t0.response.statusText || _context.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context.prev = 16;

                _this2.isExportingSelected = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 11, 16, 19]]);
      }))();
    },
    exportExcelAllAgents: function exportExcelAllAgents() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.isExportingAll) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (_this3.year) {
                  _context2.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context2.abrupt("return");

              case 5:
                _this3.isExportingAll = true;
                _context2.prev = 6;
                _context2.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/ProductExpire/AllAgents", { year: _this3.year }, "รายงาน_สินค้าหมดอายุ_ทุกตัวแทน.xlsx", _this3.$root.user && _this3.$root.user.access_token);

              case 9:
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);

                console.error("[KPI Export All]", _context2.t0);
                msg = _context2.t0.response && _context2.t0.response.statusText || _context2.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context2.prev = 16;

                _this3.isExportingAll = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 11, 16, 19]]);
      }))();
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.agentCode === null || self.agentCode == "") {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือก ตัวแทนจำหน่าย", "warning");
        return false;
      }
      if (self.productitems.length < 1) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการสินค้าที่หมดอายุ", "warning");
        return false;
      }

      var countRow = self.productitems[0].isMonth;
      for (var i = 0; i < self.productitems.length; i++) {
        if (self.productitems[i].isMonth.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าที่หมดอายุ", "warning");
          return false;
        }

        if (self.productitems[i].productCost == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
          return false;
        }

        if (countRow.filter(function (o) {
          return o != "";
        }).length != self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
          return false;
        } else if (countRow.filter(function (o) {
          return o != "";
        }).length == self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          var data = self.productitems[i].isMonth.filter(function (o) {
            return o != null;
          });
          var row = self.productitems[0].isMonth.filter(function (o) {
            return o != null;
          });
          var deleteData = self.productitems[i].isMonth.filter(function (o) {
            return o == "";
          });
          var deletRow = row.filter(function (o) {
            return o == "";
          });

          if (row.length - deletRow.length != data.length - deleteData.length) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }

        var date = new Date();
        var month = date.getMonth() + 1;
        if (self.productitems[i].isMonth.length <= month && new Date().getFullYear() == self.year) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบทุกเดือนจนถึงเดือนปัจจุบัน", "warning");
          return false;
        }

        if (self.productitems[i].isMonth.length <= 12) {
          if (self.year < new Date().getFullYear()) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน", "warning");
            return false;
          }
        }

        if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
          Swal.fire("เกิดข้อผิดพลาด", "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });
      var sItems = [];
      self.productitems.forEach(function (element) {
        sItems.push({
          ProductCode: element.productCode,
          ProductCost: element.productCost,
          MonthQty: element.isMonth
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
          KPIItem: sItems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            self.agentCodeChange();
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this4;

              $(_this4.$refs.form).validate().settings.ignore = ":hidden";

              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/Api/KPIProduct/kpiconfig');

            case 4:
              res = _context3.sent;

              _this4.monthCanEdit = res.data.monthCanEdit;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  props: {
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    },
    kPIProductType: {
      type: String,
      required: true
    },
    yearSelected: {
      type: Number
    }
  },
  data: function data() {
    var self = this;
    var date = new Date();
    var monthNo = date.getMonth() + 1;
    var yearNo = date.getFullYear();
    return {
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      currency: "THB",
      locale: "th",
      productCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              productTypeOption: self.kPIProductType
            };
            return query;
          },
          processResults: function processResults(data, params) {
            if (self.item.listProductCode != null) {
              data.results = data.results.filter(function (o) {
                return !self.item.listProductCode.includes(o.id);
              });
            }
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  methods: {
    ChecktotalCostAll: function ChecktotalCostAll(_uid, dataIndex) {
      var total = 0;
      for (var monthIndex = 1; monthIndex <= 12; monthIndex++) {
        total += this.item.data[monthIndex - 1]['data' + dataIndex];
      }
      return total;
    },
    calTotalPercent: function calTotalPercent(_uid) {
      var totalData1 = this.ChecktotalCostAll(_uid, 1);
      var totalData2 = this.ChecktotalCostAll(_uid, 2);
      var totalData3 = this.ChecktotalCostAll(_uid, 3);
      if (totalData1 == 0 && totalData2 == 0) {
        return 0;
      }
      var totalPercent = (totalData3 / (totalData1 + totalData2) * 100).toFixed(2);
      if (totalPercent == Number.POSITIVE_INFINITY || totalPercent == Number.NEGATIVE_INFINITY || isNaN(totalPercent)) {
        totalPercent = '0.00';
      }
      return parseFloat(totalPercent);
    },
    onRemoveItemClick: function onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    },
    calculateTotalValue: function calculateTotalValue(item, monthIndex) {
      var monthData = item.data[monthIndex - 1];
      var val1 = parseInt(monthData.data1) || 0;
      var val2 = parseInt(monthData.data2) || 0;
      var val3 = parseInt(monthData.data3) || 0;
      var val4 = val1 + val2 - val3;
      var val5 = (val3 / (val1 + val2) * 100).toFixed(2);
      if (val5 == Number.POSITIVE_INFINITY || val5 == Number.NEGATIVE_INFINITY || isNaN(val5)) {
        val5 = '0.00';
      }
      this.$set(item.data[monthIndex - 1], 'data4', val4);
      this.$set(item.data[monthIndex - 1], 'data5', parseFloat(val5));
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              $(".required", _this.$el).each(function () {
                var $input = $(this);
                $input.rules("add", {
                  required: true,
                  messages: {
                    required: $input.data("msg-required")
                  }
                });
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */]
  },
  props: {
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    },
    kPIProductType: {
      type: String,
      required: true
    },
    yearSelected: {
      type: [String, Number]
    }
  },
  data: function data() {
    var self = this;
    return {
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      isMonth: [],
      currency: "THB",
      locale: "th",
      totalCostAll: 0,
      totalCalOfmonthAll: 0,
      productCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              productTypeOption: self.kPIProductType
            };
            return query;
          },
          processResults: function processResults(data, params) {
            if (self.item.listProductCode != null) {
              data.results = data.results.filter(function (o) {
                return !self.item.listProductCode.includes(o.id);
              });
            }
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  computed: {
    totalCost: function totalCost() {
      var qtyTotal = 0;
      this.item.isMonth.forEach(function (element) {
        qtyTotal = qtyTotal + Number(element);
      });
      return this.item.totalCost = this.item.productCost * qtyTotal;
    },
    totalCalOfmonth: function totalCalOfmonth() {
      var length = 0;
      this.item.isMonth.forEach(function (element) {
        if (element != 0) {
          length++;
        }
      });
      return this.item.totalCalOfmonth = Math.ceil(this.item.totalCost / length);
    }
  },
  methods: {
    ChecktotalCostAll: function ChecktotalCostAll(uid) {
      this.totalCost2();
      this.totalCalOfmonth2();
      $("#totalCost" + uid).val(this.totalCostAll);
      $("#totalCost" + uid).keyup();
      $("#totalCalOfmonth" + uid).keyup();
      return this.totalCostAll;
    },
    onRemoveItemClick: function onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    },
    changeProductCost: function changeProductCost(e, uid) {
      this.totalCost2();
      this.totalCalOfmonth2();
    },
    changeMonth: function changeMonth(e, i, uid) {
      this.isMonth[i] = e.target.value;
      this.totalCost2();
      this.totalCalOfmonth2();
      $("#totalCost" + uid).val(this.totalCostAll);
      $("#totalCost" + uid).keyup();
      $("#totalCalOfmonth" + uid).keyup();
      for (var j = 1; j < this.item.isMonth.length; j++) {
        $("#isMonth" + j + uid).keyup();
      }
      $("#isMonth" + i + uid).keyup();
    },
    totalCost2: function totalCost2() {
      var qtyTotal = 0;
      this.item.isMonth.forEach(function (element) {
        qtyTotal = qtyTotal + Number(element);
      });
      this.totalCostAll = this.item.totalCost = this.item.productCost * qtyTotal;
    },
    totalCalOfmonth2: function totalCalOfmonth2() {
      var length = 0;
      this.item.isMonth.forEach(function (element) {
        if (element != 0) {
          length++;
        }
      });
      if (length == 0) this.totalCalOfmonthAll = this.item.totalCalOfmonth = 0;else this.totalCalOfmonthAll = this.item.totalCalOfmonth = Math.ceil(this.totalCostAll / length);
    }
  },
  mounted: function mounted() {
    $(".required", this.$el).each(function () {
      var $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required")
        }
      });
    });
    this.isMonth = this.item.isMonth;
    this.totalCost2();
    this.totalCalOfmonth2();
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__ = __webpack_require__(54);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    productItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      monthCanEdit: 2, /* Default FEB, configurable */
      kPIProductType: "KPI_PRODUCT_LOST",
      isShow: false,
      isExportingSelected: false,
      isExportingAll: false,
      productitems: [],
      productTotalList: [],
      totalCost: 0,
      totalMonth: [],
      totalPoductCost: 0,
      totalProductCostOfMonth: 0,
      i: 0,
      agentCode: null,
      year: new Date().getFullYear(),
      agentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }]
      }
    };
  },

  computed: {
    canExportAllAgents: function canExportAllAgents() {
      return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
    }
  },
  methods: {
    onAddItemClick: function onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var listProductCode = [];
      this.productitems.forEach(function (element) {
        listProductCode.push(element.productCode);
      });

      this.productitems.push({
        productCode: null,
        productCost: 0,
        isMonth: [],
        totalCal: 0,
        totalCalOfmonth: 0,
        isDisableMonth: [],
        isDisableProduct: false,
        listProductCode: listProductCode
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.productitems.splice(index, 1);
      for (var i = 0; i < this.productitems.length; i++) {}
      this.changeTotal();
    },
    agentCodeChange: function agentCodeChange() {
      var self = this;
      // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
      if (!self.agentCode) {
        self.isShow = false;
        return;
      }
      self.isShow = true;
      self.productitems = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct/getAccessory",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year
        }
      }).then(function (response) {
        var date = new Date();
        var monthNo = date.getMonth() + 1;
        var yearNo = date.getFullYear();

        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            var _loop = function _loop(i) {
              item = response.data[i];
              monthQtyItem = [];
              monthDisable = [];

              if (new Date().getFullYear() == self.year) {
                /* Current Year */
                for (var j = 1; j < item.monthView.length; j++) {
                  if (j > monthNo) {
                    monthDisable[j] = true;
                  } else if (j <= monthNo) {
                    if (item.monthView[j].hasKpiData) {
                      monthDisable[j] = false;
                      monthQtyItem[j] = item.monthView[j].monthQty;
                      monthDisable[j] = item.monthView[j].isDisableMonth;
                    }
                  } else {
                    monthQtyItem[j] = item.monthView[j].monthQty;
                    monthDisable[j] = item.monthView[j].isDisableMonth;
                    monthDisable[j] = true;
                  }
                }
              } else {
                /* Previous Year */
                for (var _j = 1; _j < item.monthView.length; _j++) {
                  if (item.monthView[_j].hasKpiData) {
                    monthQtyItem[_j] = item.monthView[_j].monthQty;
                  }

                  //if (self.year == yearNo) {
                  //  monthDisable[j] = false;
                  //}
                  //else {
                  //  monthDisable[j] = true;
                  //}

                  //==== Check with config ====
                  if (self.year < yearNo) {
                    var currentMonth = new Date().getMonth() + 1;

                    console.log("Current Year : " + yearNo);
                    console.log("Current Month : " + currentMonth);
                    console.log("Previous Year : " + self.year);
                    console.log("Editable Month : " + self.monthCanEdit);

                    if (currentMonth <= self.monthCanEdit) {
                      //
                      monthDisable[_j] = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
                    } else {
                      //
                      monthDisable[_j] = true;
                    }
                  } else {
                    monthDisable[_j] = false;
                  }
                }
              }
              self.productitems.push({
                productCode: item.productCode,
                productCost: item.productCost,
                isMonth: monthQtyItem,
                isDisableMonth: monthDisable,
                isDisableProduct: true,
                productCodeOptionsData: {
                  id: item.productCode,
                  text: item.productName + " [" + item.productCode + "]",
                  data: null
                }
              });

              setTimeout(function () {
                self.$refs.Items[i].$refs.productCode.setSelectedData(self.productitems[i].productCodeOptionsData);
                self.changeTotal();
              }, 100);
            };

            for (var i = 0; i < response.data.length; i++) {
              var item;
              var monthQtyItem;
              var monthDisable;

              _loop(i);
            }
            self.isShow = true;
          } else {
            self.changeTotal();
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการที่คุณเลือก", "warning");
          router.go(-1);
          self.isShow = false;
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
        router.go(-1);
        self.isShow = false;
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    changeTotal: function changeTotal() {
      var _this = this;

      this.totalCost = 0;
      this.totalMonth = [];
      this.totalPoductCost = 0;
      this.totalProductCostOfMonth = 0;
      this.productitems.forEach(function (e) {
        _this.totalCost = _this.totalCost + Number(e.productCost);
        _this.totalPoductCost = _this.totalPoductCost + Number(e.totalCost);
        _this.totalProductCostOfMonth = _this.totalProductCostOfMonth + Number(e.totalCalOfmonth);
        for (var i = 1; i < e.isMonth.length; i++) {
          if (e.isMonth[i] != null) {
            var oldtotal = _this.totalMonth[i] == undefined ? 0 : _this.totalMonth[i];
            _this.totalMonth[i] = Number(e.isMonth[i]) + oldtotal;
          }
        }
      });
    },
    exportExcelSelected: function exportExcelSelected() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.isExportingSelected) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_this2.year) {
                  _context.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context.abrupt("return");

              case 5:
                _this2.isExportingSelected = true;
                _context.prev = 6;
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/ProductLost", { year: _this2.year, agentCode: _this2.agentCode || null }, "รายงาน_สินค้าสูญหาย.xlsx", _this2.$root.user && _this2.$root.user.access_token);

              case 9:
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);

                console.error("[KPI Export Selected]", _context.t0);
                msg = _context.t0.response && _context.t0.response.statusText || _context.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context.prev = 16;

                _this2.isExportingSelected = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 11, 16, 19]]);
      }))();
    },
    exportExcelAllAgents: function exportExcelAllAgents() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.isExportingAll) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (_this3.year) {
                  _context2.next = 5;
                  break;
                }

                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                return _context2.abrupt("return");

              case 5:
                _this3.isExportingAll = true;
                _context2.prev = 6;
                _context2.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/ProductLost/AllAgents", { year: _this3.year }, "รายงาน_สินค้าสูญหาย_ทุกตัวแทน.xlsx", _this3.$root.user && _this3.$root.user.access_token);

              case 9:
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](6);

                console.error("[KPI Export All]", _context2.t0);
                msg = _context2.t0.response && _context2.t0.response.statusText || _context2.t0.message || "Export ล้มเหลว";

                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

              case 16:
                _context2.prev = 16;

                _this3.isExportingAll = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 11, 16, 19]]);
      }))();
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.agentCode === null || self.agentCode == "") {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือก ตัวแทนจำหน่าย", "warning");
        return false;
      }
      if (self.productitems.length < 1) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการสินค้าที่สูญหาย", "warning");
        return false;
      }

      var countRow = self.productitems[0].isMonth;
      for (var i = 0; i < self.productitems.length; i++) {
        if (self.productitems[i].isMonth.length == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าที่สูญหาย", "warning");
          return false;
        }

        if (self.productitems[i].productCost == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
          return false;
        }
        if (countRow.filter(function (o) {
          return o != "";
        }).length != self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
          return false;
        } else if (countRow.filter(function (o) {
          return o != "";
        }).length == self.productitems[i].isMonth.filter(function (o) {
          return o != "";
        }).length) {
          var data = self.productitems[i].isMonth.filter(function (o) {
            return o != null;
          });
          var row = self.productitems[0].isMonth.filter(function (o) {
            return o != null;
          });
          var deleteData = self.productitems[i].isMonth.filter(function (o) {
            return o == "";
          });
          var deletRow = row.filter(function (o) {
            return o == "";
          });

          if (row.length - deletRow.length != data.length - deleteData.length) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
            return false;
          }
        }

        var date = new Date();
        var month = date.getMonth() + 1;
        if (self.productitems[i].isMonth.length <= month && new Date().getFullYear() == self.year) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบทุกเดือนจนถึงเดือนปัจจุบัน", "warning");
          return false;
        }

        if (self.productitems[i].isMonth.length <= 12) {
          if (self.year < new Date().getFullYear()) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน", "warning");
            return false;
          }
        }
        if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
          Swal.fire("เกิดข้อผิดพลาด", "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var sItems = [];
      self.productitems.forEach(function (element) {
        sItems.push({
          ProductCode: element.productCode,
          ProductCost: element.productCost,
          MonthQty: element.isMonth
        });
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/KPIProduct",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
          KPIItem: sItems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            self.agentCodeChange();
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this4;

              $(_this4.$refs.form).validate().settings.ignore = ":hidden";

              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/Api/KPIProduct/kpiconfig');

            case 4:
              res = _context3.sent;

              _this4.monthCanEdit = res.data.monthCanEdit;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__ = __webpack_require__(54);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
        datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
        productItemRow: __WEBPACK_IMPORTED_MODULE_4__ProductItemRow__["a" /* default */]
    },
    data: function data() {
        var self = this;
        return {
            monthCanEdit: 2, /* Default FEB, configurable */
            kPIProductType: "KPI_PRODUCT_SLOW",
            isShow: false,
            isExportingSelected: false,
            isExportingAll: false,
            productitems: [],
            productTotalList: [],
            totalCost: 0,
            totalMonth: [],
            totalPoductCost: 0,
            totalProductCostOfMonth: 0,
            i: 0,
            agentCode: null,
            year: new Date().getFullYear(),
            agentCodeOptions: {
                placeholder: "กรุณาเลือก",
                allowClear: true,
                ajax: {
                    url: "/Api/Agents/Select2SearchAgentName",
                    type: "post",
                    dataType: "json",
                    contentType: "application/json",
                    data: function data(params) {
                        var query = {
                            search: params.term,
                            department: [],
                            province_id: [],
                            page: params.page || 1
                        };
                        return JSON.stringify(query);
                    },
                    processResults: function processResults(data, params) {
                        return {
                            results: data.results,
                            pagination: {
                                more: data.more
                            }
                        };
                    },
                    transport: function transport(params, success, failure) {
                        params.beforeSend = function (request) {
                            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                        };
                        var $request = $.ajax(params);
                        $request.then(success);
                        $request.fail(failure);
                        return $request;
                    }
                }
            },
            yearOptions: {
                placeholder: "กรุณาเลือก",
                data: [{
                    id: new Date().getFullYear(),
                    text: new Date().getFullYear(),
                    data: null
                }, {
                    id: new Date().getFullYear() - 1,
                    text: new Date().getFullYear() - 1,
                    data: null
                }]
            }
        };
    },

    computed: {
        canExportAllAgents: function canExportAllAgents() {
            return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
        }
    },
    methods: {
        onAddItemClick: function onAddItemClick(e) {
            if (!$(this.$refs.form).validate().form()) {
                return false;
            }

            var listProductCode = [];
            this.productitems.forEach(function (element) {
                listProductCode.push(element.productCode);
            });

            this.productitems.push({
                productCode: null,
                productCost: 0,
                isMonth: [],
                totalCal: 0,
                totalCalOfmonth: 0,
                isDisableMonth: [],
                isDisableProduct: false,
                listProductCode: listProductCode
            });
        },
        onRemoveItemClick: function onRemoveItemClick(index, delItem) {
            this.productitems.splice(index, 1);
            for (var i = 0; i < this.productitems.length; i++) {}
            this.changeTotal();
        },
        agentCodeChange: function agentCodeChange() {
            var self = this;
            // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
            if (!self.agentCode) {
                self.isShow = false;
                return;
            }
            self.isShow = true;
            self.productitems = [];
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: "post",
                url: "/Api/KPIProduct/getAccessory",
                data: {
                    AgentCodes: self.agentCode,
                    KPIProductType: self.kPIProductType,
                    Year: self.year
                }
            }).then(function (response) {
                var date = new Date();
                var monthNo = date.getMonth() + 1;
                var yearNo = date.getFullYear(); /* Current Year */

                if (response.status == 200) {
                    if (response.data != null && response.data.length > 0) {
                        var _loop = function _loop(i) {
                            item = response.data[i];
                            monthQtyItem = [];
                            monthDisable = [];

                            if (yearNo == self.year) {
                                /* Current Year */
                                for (var j = 1; j < item.monthView.length; j++) {
                                    if (j > monthNo) {
                                        monthDisable[j] = true;
                                    } else if (j <= monthNo) {
                                        if (item.monthView[j].hasKpiData) {
                                            monthDisable[j] = false;
                                            monthQtyItem[j] = item.monthView[j].monthQty;
                                            monthDisable[j] = item.monthView[j].isDisableMonth;
                                        }
                                    } else {
                                        monthQtyItem[j] = item.monthView[j].monthQty;
                                        monthDisable[j] = item.monthView[j].isDisableMonth;
                                        monthDisable[j] = true;
                                    }
                                }
                            } else {
                                /* ปีก่อนหน้า */
                                for (var _j = 1; _j < item.monthView.length; _j++) {
                                    if (item.monthView[_j].hasKpiData) {
                                        monthQtyItem[_j] = item.monthView[_j].monthQty;
                                    }
                                    /* Set disable/enable textbox */
                                    /*
                                    for test :
                                    self.year (selected year)   = 2024
                                    yearNo (current year)       = 2025
                                     */
                                    //==== OLD ====
                                    //if (self.year == yearNo) {
                                    //    monthDisable[j] = false;
                                    //}
                                    //else {
                                    //    monthDisable[j] = true;
                                    //}

                                    //==== New ====

                                    if (self.year < yearNo) {
                                        var currentMonth = new Date().getMonth() + 1;

                                        //console.log("Current Year : " + yearNo);
                                        //console.log("Current Month : " + currentMonth);
                                        //console.log("Previous Year : " + self.year);
                                        //console.log("Editable Month : " + self.monthCanEdit);

                                        if (currentMonth <= self.monthCanEdit) {
                                            //
                                            monthDisable[_j] = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
                                        } else {
                                            //
                                            monthDisable[_j] = true;
                                        }
                                    } else {
                                        monthDisable[_j] = false;
                                    }
                                }
                            }

                            self.productitems.push({
                                productCode: item.productCode,
                                productCost: item.productCost,
                                isMonth: monthQtyItem,
                                isDisableMonth: monthDisable,
                                isDisableProduct: true,
                                productCodeOptionsData: {
                                    id: item.productCode,
                                    text: item.productName + " [" + item.productCode + "]",
                                    data: null
                                }
                            });

                            setTimeout(function () {
                                self.$refs.Items[i].$refs.productCode.setSelectedData(self.productitems[i].productCodeOptionsData);
                                self.changeTotal();
                            }, 100);
                        };

                        for (var i = 0; i < response.data.length; i++) {
                            var item;
                            var monthQtyItem;
                            var monthDisable;

                            _loop(i);
                        }
                        self.isShow = true;
                    } else {
                        self.changeTotal();
                    }
                } else {
                    Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
                    router.go(-1);
                    self.isShow = false;
                }
            }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
                router.go(-1);
                self.isShow = false;
            }).then(function () {
                // always executed
                KTApp.unblockPage();
            });
        },
        changeTotal: function changeTotal() {
            var _this = this;

            this.totalCost = 0;
            this.totalMonth = [];
            this.totalPoductCost = 0;
            this.totalProductCostOfMonth = 0;
            this.productitems.forEach(function (e) {
                _this.totalCost = _this.totalCost + Number(e.productCost);
                _this.totalPoductCost = _this.totalPoductCost + Number(e.totalCost);
                _this.totalProductCostOfMonth = _this.totalProductCostOfMonth + Number(e.totalCalOfmonth);
                for (var i = 1; i < e.isMonth.length; i++) {
                    if (e.isMonth[i] != null) {
                        var oldtotal = _this.totalMonth[i] == undefined ? 0 : _this.totalMonth[i];
                        _this.totalMonth[i] = Number(e.isMonth[i]) + oldtotal;
                    }
                }
            });
        },
        exportExcelSelected: function exportExcelSelected() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var msg;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this2.isExportingSelected) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 2:
                                if (_this2.year) {
                                    _context.next = 5;
                                    break;
                                }

                                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                                return _context.abrupt("return");

                            case 5:
                                _this2.isExportingSelected = true;
                                _context.prev = 6;
                                _context.next = 9;
                                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/ProductSlow", { year: _this2.year, agentCode: _this2.agentCode || null }, "รายงาน_สินค้าเคลื่อนไหวช้า.xlsx", _this2.$root.user && _this2.$root.user.access_token);

                            case 9:
                                _context.next = 16;
                                break;

                            case 11:
                                _context.prev = 11;
                                _context.t0 = _context["catch"](6);

                                console.error("[KPI Export Selected]", _context.t0);
                                msg = _context.t0.response && _context.t0.response.statusText || _context.t0.message || "Export ล้มเหลว";

                                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

                            case 16:
                                _context.prev = 16;

                                _this2.isExportingSelected = false;
                                return _context.finish(16);

                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[6, 11, 16, 19]]);
            }))();
        },
        exportExcelAllAgents: function exportExcelAllAgents() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var msg;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!_this3.isExportingAll) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 2:
                                if (_this3.year) {
                                    _context2.next = 5;
                                    break;
                                }

                                Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
                                return _context2.abrupt("return");

                            case 5:
                                _this3.isExportingAll = true;
                                _context2.prev = 6;
                                _context2.next = 9;
                                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shared_exportExcelHelper__["a" /* exportExcelFromApi */])("/Api/KPIProduct/Export/ProductSlow/AllAgents", { year: _this3.year }, "รายงาน_สินค้าเคลื่อนไหวช้า_ทุกตัวแทน.xlsx", _this3.$root.user && _this3.$root.user.access_token);

                            case 9:
                                _context2.next = 16;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2["catch"](6);

                                console.error("[KPI Export All]", _context2.t0);
                                msg = _context2.t0.response && _context2.t0.response.statusText || _context2.t0.message || "Export ล้มเหลว";

                                Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });

                            case 16:
                                _context2.prev = 16;

                                _this3.isExportingAll = false;
                                return _context2.finish(16);

                            case 19:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3, [[6, 11, 16, 19]]);
            }))();
        },

        formSubmit: function formSubmit(e) {
            var router = this.$router;
            var self = this;

            if (!$(this.$refs.form).validate().form()) {
                return false;
            }
            if (self.agentCode === null || self.agentCode == "") {
                Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือก ตัวแทนจำหน่าย", "warning");
                return false;
            }
            if (self.productitems.length < 1) {
                Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการสินค้าที่เคลื่อนไหวช้า", "warning");
                return false;
            }

            var countRow = self.productitems[0].isMonth;
            for (var i = 0; i < self.productitems.length; i++) {
                if (self.productitems[i].isMonth.length == 0) {
                    Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าที่เคลื่อนไหวช้า", "warning");
                    return false;
                }

                if (self.productitems[i].productCost == 0) {
                    Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
                    return false;
                }

                if (countRow.filter(function (o) {
                    return o != "";
                }).length != self.productitems[i].isMonth.filter(function (o) {
                    return o != "";
                }).length) {
                    Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
                    return false;
                } else if (countRow.filter(function (o) {
                    return o != "";
                }).length == self.productitems[i].isMonth.filter(function (o) {
                    return o != "";
                }).length) {
                    var data = self.productitems[i].isMonth.filter(function (o) {
                        return o != null;
                    });
                    var row = self.productitems[0].isMonth.filter(function (o) {
                        return o != null;
                    });
                    var deleteData = self.productitems[i].isMonth.filter(function (o) {
                        return o == "";
                    });
                    var deletRow = row.filter(function (o) {
                        return o == "";
                    });

                    if (row.length - deletRow.length != data.length - deleteData.length) {
                        Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0", "warning");
                        return false;
                    }
                }

                var date = new Date();
                var month = date.getMonth() + 1;
                if (self.productitems[i].isMonth.length <= month && new Date().getFullYear() == self.year) {
                    Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบทุกเดือนจนถึงเดือนปัจจุบัน", "warning");
                    return false;
                }

                if (self.productitems[i].isMonth.length <= 12) {
                    if (self.year < new Date().getFullYear()) {
                        Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน", "warning");
                        return false;
                    }
                }

                if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
                    Swal.fire("เกิดข้อผิดพลาด", "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล", "warning");
                    return false;
                }
            }

            KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
            });

            var sItems = [];
            self.productitems.forEach(function (element) {
                sItems.push({
                    ProductCode: element.productCode,
                    ProductCost: element.productCost,
                    MonthQty: element.isMonth
                });
            });
            __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                method: "post",
                url: "/Api/KPIProduct",
                data: {
                    AgentCodes: self.agentCode,
                    KPIProductType: self.kPIProductType,
                    Year: self.year,
                    KPIItem: sItems
                }
            }).then(function (response) {
                if (response.data.status) {
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                        self.agentCodeChange();
                    });
                } else {
                    Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }
            }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }).then(function () {
                // always executed
                KTApp.unblockPage();
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            var self, res;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            self = _this4;

                            $(_this4.$refs.form).validate().settings.ignore = ":hidden";

                            _context3.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/Api/KPIProduct/kpiconfig');

                        case 4:
                            res = _context3.sent;

                            _this4.monthCanEdit = res.data.monthCanEdit;

                        case 6:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this4);
        }))();
    }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      lmReqSearch: null,
      lmDateInstallStart: null,
      lmDateInstallEnd: null,
      lmDateOfBillingDate_Start: null,
      lmDateOfBillingDate_End: null,
      lmContractExpireDate_Start: null,
      lmContractExpireDate_End: null,
      lmAgentCode: [],
      lmPhase: [],
      lmLot: [],
      lmShop: [],
      lmProductTypeCode: [],
      lmMachineProductBrandId: [],
      lmProductCode: [],
      lmSupplierId: [],
      lmShopProvinceId: [],
      lmAgentCodeOptions: [],
      // lmAgentCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกAgent",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmShopOptions: [],
      // lmShopOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Shop/ShopOption",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmProductTypeCodeptions: [],
      // lmProductTypeCodeptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmProductCodeOptions: [],
      // lmProductCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmShopProvinceIdOptions: [],
      // lmShopProvinceIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกจังหวัด",
      //   ajax: {
      //     url: "/Api/MasterLocation/Select2SearchProvince",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmSupplierIdOptions: [],
      // lmSupplierIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกSupplier",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Vendors/Select2Vendor",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmPhaseOptions: [],
      // lmPhaseOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือก Phase",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterPhase/Select2Phase",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmLotOptions: [],
      // lmLotOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือก Lot",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterPhase/Select2Lot",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmMachineProductBrandIdOptions: []
      // lmMachineProductBrandIdOptions: {
      //   placeholder: "กรุณาเลือก แบรนด์เครื่องเบียร์สด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2BrandMachine",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         ProductType: [3],
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.lmReqSearch = null;
      self.lmDateInstallStart = null;
      self.lmDateInstallEnd = null;
      self.lmDateOfBillingDate_Start = null;
      self.lmDateOfBillingDate_End = null;
      self.lmContractExpireDate_Start = null;
      self.lmContractExpireDate_End = null;
      self.lmAgentCode = [];
      self.lmPhase = [];
      self.lmLot = [];
      self.lmShop = [];
      self.lmProductTypeCode = [];
      self.lmMachineProductBrandId = [];
      self.lmProductCode = [];
      self.lmSupplierId = [];
      self.lmShopProvinceId = [];

      $("#lmDateInstallStart").val(null).trigger("change");
      $("#lmDateInstallEnd").val(null).trigger("change");
      $("#lmDateOfBillingDate_Start").val(null).trigger("change");
      $("#lmDateOfBillingDate_End").val(null).trigger("change");
      $("#lmContractExpireDate_Start").val(null).trigger("change");
      $("#lmContractExpireDate_End").val(null).trigger("change");

      $("#lmAgentCode").val("").trigger("change");

      $("#lmPhase").val("").trigger("change");

      $("#lmLot").val("").trigger("change");

      $("#lmShop").val("").trigger("change");

      $("#lmProductTypeCode").val("").trigger("change");

      $("#lmMachineProductBrandId").val("").trigger("change");

      $("#lmProductCode").val("").trigger("change");

      $("#lmSupplierId").val("").trigger("change");

      $("#lmShopProvinceId").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#MachineDetailTable").DataTable();
      table.draw();
    },
    exportListMachine: function exportListMachine(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/MachineTransaction/ExportListMachine",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: self.lmReqSearch,
          DateInstallStart: self.lmDateInstallStart != null ? self.lmDateInstallStart.format("DD/MM/YYYY") : self.lmDateInstallStart,
          DateInstallEnd: self.lmDateInstallEnd != null ? self.lmDateInstallEnd.format("DD/MM/YYYY") : self.lmDateInstallEnd,
          DateOfBillingDate_Start: self.lmDateOfBillingDate_Start != null ? self.lmDateOfBillingDate_Start.format("DD/MM/YYYY") : self.lmDateOfBillingDate_Start,
          DateOfBillingDate_End: self.lmDateOfBillingDate_End != null ? self.lmDateOfBillingDate_End.format("DD/MM/YYYY") : self.lmDateOfBillingDate_End,
          ContractExpireDate_Start: self.lmContractExpireDate_Start != null ? self.lmContractExpireDate_Start.format("DD/MM/YYYY") : self.lmContractExpireDate_Start,
          ContractExpireDate_End: self.lmContractExpireDate_End != null ? self.lmContractExpireDate_End.format("DD/MM/YYYY") : self.lmContractExpireDate_End,
          AgentCode: self.lmAgentCode,
          Phase: self.lmPhase,
          Lot: self.lmLot,
          ShopCode: self.lmShop,
          ProductTypeCode: self.lmProductTypeCode,
          MachineProductBrandId: self.lmMachineProductBrandId,
          ProductCode: self.lmProductCode,
          SupplierId: self.lmSupplierId,
          ShopProvinceId: self.lmShopProvinceId
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadlmAgentCodeOptions: function LoadlmAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.lmAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadlmProductTypeCodeptions: function LoadlmProductTypeCodeptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.lmProductTypeCodeptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadlmProductCodeOptions: function LoadlmProductCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.lmProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadlmShopProvinceIdOptions: function LoadlmShopProvinceIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/MasterLocation/Select2SearchProvince", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.lmShopProvinceIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadlmSupplierIdOptions: function LoadlmSupplierIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.lmSupplierIdOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Vendors/Select2Vendor", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.lmSupplierIdOptions = [];
            data.forEach(function (element) {
              self.lmSupplierIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }

          callback(null, self.lmSupplierIdOptions);
        }).catch(function (error) {});
      }
    },

    LoadlmPhaseOptions: function LoadlmPhaseOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterPhase/Select2Phase", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.lmPhaseOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadlmLotOptions: function LoadlmLotOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/MasterPhase/Select2Lot", {
        page: 1,
        Phases: self.lmPhase
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.lmLotOptions = [];
          data.forEach(function (element) {
            self.lmLotOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadlmMachineProductBrandIdOptions: function LoadlmMachineProductBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2BrandMachine", {
        params: {
          page: 1,
          ProductType: [3],
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.lmMachineProductBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadlmShopOptions: function LoadlmShopOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Shop/ShopOption", {}).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.lmShopOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadlmAgentCodeOptions();
              self.LoadlmProductTypeCodeptions();
              self.LoadlmProductCodeOptions();
              self.LoadlmShopProvinceIdOptions();
              // self.LoadlmSupplierIdOptions();
              self.LoadlmPhaseOptions();
              self.LoadlmLotOptions();
              self.LoadlmMachineProductBrandIdOptions();
              self.LoadlmShopOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.lmDateInstallStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.lmDateInstallStart).datepicker("update", !!self.lmDateInstallStart ? self.lmDateInstallStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.lmDateInstallStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.lmDateInstallEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.lmDateInstallEnd).datepicker("update", !!self.lmDateInstallEnd ? self.lmDateInstallEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.lmDateInstallEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.lmDateOfBillingDate_Start).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.lmDateOfBillingDate_Start).datepicker("update", !!self.lmDateOfBillingDate_Start ? self.lmDateOfBillingDate_Start.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.lmDateOfBillingDate_Start = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.lmDateOfBillingDate_End).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.lmDateOfBillingDate_End).datepicker("update", !!self.lmDateOfBillingDate_End ? self.lmDateOfBillingDate_End.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.lmDateOfBillingDate_End = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.lmContractExpireDate_Start).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.lmContractExpireDate_Start).datepicker("update", !!self.lmContractExpireDate_Start ? self.lmContractExpireDate_Start.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.lmContractExpireDate_Start = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.lmContractExpireDate_End).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.lmContractExpireDate_End).datepicker("update", !!self.lmContractExpireDate_End ? self.lmContractExpireDate_End.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.lmContractExpireDate_End = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#MachineDetailTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/MachineTransaction/SearchMachineTransaction",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      SearchKeyword: self.lmReqSearch,
                      DateInstallStart: self.lmDateInstallStart != null ? self.lmDateInstallStart.format("DD/MM/YYYY") : self.lmDateInstallStart,
                      DateInstallEnd: self.lmDateInstallEnd != null ? self.lmDateInstallEnd.format("DD/MM/YYYY") : self.lmDateInstallEnd,
                      DateOfBillingDate_Start: self.lmDateOfBillingDate_Start != null ? self.lmDateOfBillingDate_Start.format("DD/MM/YYYY") : self.lmDateOfBillingDate_Start,
                      DateOfBillingDate_End: self.lmDateOfBillingDate_End != null ? self.lmDateOfBillingDate_End.format("DD/MM/YYYY") : self.lmDateOfBillingDate_End,
                      ContractExpireDate_Start: self.lmContractExpireDate_Start != null ? self.lmContractExpireDate_Start.format("DD/MM/YYYY") : self.lmContractExpireDate_Start,
                      ContractExpireDate_End: self.lmContractExpireDate_End != null ? self.lmContractExpireDate_End.format("DD/MM/YYYY") : self.lmContractExpireDate_End,
                      AgentCode: self.lmAgentCode,
                      Phase: self.lmPhase,
                      Lot: self.lmLot,
                      ShopCode: self.lmShop,
                      ProductTypeCode: self.lmProductTypeCode,
                      MachineProductBrandId: self.lmMachineProductBrandId,
                      ProductCode: self.lmProductCode,
                      SupplierId: self.lmSupplierId,
                      ShopProvinceId: self.lmShopProvinceId
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [100, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[1, "desc"]],
                columns: [{ data: "supplierName", className: "text-center" }, { data: "phase", className: "text-center" }, { data: "lot", className: "text-center" }, { data: "installmentLatest", className: "text-center" }, { data: "dateInstallDay", className: "text-center" }, { data: "dateInstallMonth", className: "text-center" }, { data: "dateInstallYear", className: "text-center" }, { data: "dateOfBillingString", className: "text-center" },
                // { data: "contractExpireDateString", className: "text-center" },
                { data: "contractExpireDay", className: "text-center" }, { data: "contractExpireMonth", className: "text-center" }, { data: "contractExpireYear", className: "text-center" }, { data: "po", className: "text-center" }, { data: "invoiceNo", className: "text-center" }, {
                  data: "price",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "barcodeOldNO", className: "text-center" }, { data: "departmentMaterialCode", className: "text-center" }, { data: "machineProductTypeName", className: "text-center" }, { data: "machineProductName", className: "text-center" }, { data: "machineProductBrandName", className: "text-center" }, { data: "agentProvinceName", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "shopName", className: "text-center" }, { data: "shopName2", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  // self.reAaIsInitial = false;
                  // self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;
                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;
                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    lmPhase: function lmPhase() {
      //console.log(this.remdPhase);
      this.LoadlmLotOptions();
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <input type=\"checkbox\" id=\"data\" @click=\"checkbox('data')\"/>\n  </div>",
  methods: {
    checkbox: function checkbox(e) {
      var self = this;
      self.$parent.saveSummit(this.data.headerId);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      pmPhase: null,
      pmLot: null,
      pmTracheNo: null,
      svOpenButton: false,
      pmSupplier: null,
      pmInvoice: null,
      pmPO: null,
      pmSaveSubmit: [],
      pmSubmitAll: false,
      pmPhaseOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Phase",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      pmLotOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MachinePayment/Select2Lot",
          data: function data(params) {
            var query = {
              search: params.term,
              Phase: self.pmPhase,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      pmSupplierOptions: {
        placeholder: "กรุณาเลือกSupplier",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Vendors/Select2Vendor",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      pmTracheNoOptions: {
        placeholder: "กรุณาเลือกงวด",
        allowClear: true,
        ajax: {
          url: "/Api/MachinePayment/Select2Tranche",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              billStatus: true,
              paymentStatus: false,
              phase: self.pmPhase,
              lot: self.pmLot
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.pmPhase = [];
      self.pmLot = [];
      self.pmTracheNo = null;
      self.pmSupplier = null;
      self.pmInvoice = null;
      self.pmPO = null;

      $("#pmPhase").val("").trigger("change");

      $("#pmLot").val("").trigger("change");

      $("#pmSupplier").val("").trigger("change");

      $("#pmTracheNo").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#machineTransactionTable").DataTable();
      table.draw();
    },
    formSave: function formSave(e) {
      var self = this;
      var router = this.$router;
      e.preventDefault();
      if (!self.pmSubmitAll && self.pmSaveSubmit.length == 0) {
        Swal.fire("การเตือน", "กรุณาเลือกข้อมูล", "warning");
      } else {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
        });

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/MachinePayment/Save", {
          Phase: self.pmPhase,
          Lot: self.pmLot,
          Tranche: self.pmTracheNo,
          Supplier: self.pmSupplier,
          PO: self.pmPO,
          Invoice: self.pmInvoice,
          HeaderId: self.pmSaveSubmit,
          SubmitAll: self.pmSubmitAll
        }).then(function (response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
              //router.go(), self.$parent.reloadDataTable(false);
              self.formReset(e);
            });
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }).then(function () {
          KTApp.unblockPage();
        });
      }
    },
    formSaveReset: function formSaveReset(e) {
      var self = this;
    },
    saveSummit: function saveSummit(e) {
      var self = this;
      if (e == "All") {
        self.pmSubmitAll = !self.pmSubmitAll;
      } else {
        var check = self.pmSaveSubmit.includes(e);
        if (!check) {
          self.pmSaveSubmit.push(e);
        } else {
          self.pmSaveSubmit = self.pmSaveSubmit.filter(function (o) {
            return o != e;
          });
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              $("#selectAll").click(function (e) {
                $(this).closest("table").find("td input:checkbox").prop("checked", this.checked);
              });
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              table = $("#machineTransactionTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/MachinePayment/SearchPayment",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      Phase: self.pmPhase,
                      Lot: self.pmLot,
                      Tranche: self.pmTracheNo,
                      Supplier: self.pmSupplier,
                      PO: self.pmPO,
                      Invoice: self.pmInvoice
                    }));
                  }
                  //  success:function(data) {
                  //      var self = this
                  //      if(data.data.length != 0)
                  //      {
                  //         self.svOpenButton = true;
                  //      }
                  // },
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [100, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "desc"]],
                columns: [{
                  data: "dateOfBilling",
                  className: "text-center",
                  width: "8%",
                  render: function render(data, type, full, meta) {
                    return full.dateOfBillingString;
                  }
                }, {
                  data: "vendorName",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "phase",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "lot",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "trancheNo",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "productTypeName",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "productName",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "productBrandName",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "amount",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "totalPrice",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "po",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "invoiceNo",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "billStatus",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data) {
                      return '<i class="fas fa-check-circle text-success"></i>';
                    } else {
                      return '<i class="fas fa-times-circle text-danger"></i>';
                    }
                  }
                }, {
                  data: "headerId",
                  className: "text-center",
                  orderable: false,
                  width: "10%",
                  render: function render(data, type, full, meta) {
                    // return '<input type="checkbox" id="selectAll" @click="saveSummit("All")"/>';
                    return '<div class="actions"></div>';
                  }
                }],
                rowCallback: function rowCallback(row, data, index) {
                  // $(row)
                  // .find("td:eq(10)")
                  // .css("background-color", "#F2DCDB");
                  // $(row)
                  // .find("td:eq(1)")
                  // .css("background-color", "#F2DCDB");
                },
                drawCallback: function drawCallback(settings) {
                  if (settings.json.data.length === 0) {
                    return false;
                  }

                  $.fn.dataTable.ext.errMode = 'none';
                  var table = $("#machineTransactionTable");
                  var rows = table.find($("tr"));

                  var prevCheck = "";
                  var mergeRow = 1;
                  for (var r = 0; r <= rows.length; r++) {
                    var dateOfBilling = $($(rows[r]).find("td")[0]).text();
                    var phase = $($(rows[r]).find("td")[2]).text();
                    var lot = $($(rows[r]).find("td")[3]).text();
                    var trancheNo = $($(rows[r]).find("td")[4]).text();
                    var check = dateOfBilling + "#" + phase + "#" + lot + "#" + trancheNo;
                    if (prevCheck == "") {
                      prevCheck = check;
                      continue;
                    }
                    if (prevCheck == check) {
                      mergeRow = mergeRow + 1;
                      continue;
                    }

                    //hide col
                    // col 1 merge ไม่ได้ เนื่องจากอาจจะมีต่าง supplier
                    var cols = [0, 2, 3, 4, 9, 10, 11, 12, 13];
                    for (var h = 1; h < mergeRow; h++) {
                      for (var i = 0; i < cols.length; i++) {
                        var c = cols[i];
                        $($(rows[r - h]).find("td")[c]).hide();
                      }
                    }

                    for (var i = 0; i < cols.length; i++) {
                      var _c = cols[i];
                      $($(rows[r - mergeRow]).find("td")[_c]).attr("rowspan", mergeRow);
                    }
                    //
                    mergeRow = 1;
                    prevCheck = check;
                  }
                  //   for (var i = 0; i < colsLength; i++) {
                  //     if (cols.includes(i)) {
                  //       var startIndex = 0;
                  //       var lastIndex = 0;
                  //       var startText = $($(rows[0]).find("td")[i]).text();
                  //       //console.log("startText ", startText);
                  //       for (var j = 1; j < rows.length; j++) {
                  //         var cRow = $(rows[j]);
                  //         var cCol = $(cRow.find("td")[i]);

                  //         var currentText = cCol.text();
                  //         //console.log("currentText ", currentText);

                  //         if (currentText == startText) {
                  //           removeLater.push(cCol);
                  //           lastIndex = j;
                  //           if (i == 12) {
                  //             var cCol2 = $(cRow.find("td")[i + 1]);
                  //             var cCol3 = $(cRow.find("td")[i + 2]);

                  //             removeLater.push(cCol2);
                  //             removeLater.push(cCol3);
                  //           }

                  //           if (i == 5) {
                  //             var cCol4 = $(cRow.find("td")[i + 5]);
                  //             removeLater.push(cCol4);
                  //           }
                  //         } else {
                  //           var spanLength = lastIndex - startIndex;
                  //           if (spanLength >= 1) {
                  //             $($(rows[startIndex]).find("td")[i]).attr(
                  //               "rowspan",
                  //               spanLength + 1
                  //             );
                  //           }

                  //           if (i == 12) {
                  //             $($(rows[startIndex]).find("td")[i + 1]).attr(
                  //               "rowspan",
                  //               spanLength + 1
                  //             );
                  //             $($(rows[startIndex]).find("td")[i + 2]).attr(
                  //               "rowspan",
                  //               spanLength + 1
                  //             );
                  //           }
                  //           if (i == 5) {
                  //             $($(rows[startIndex]).find("td")[i + 5]).attr(
                  //               "rowspan",
                  //               spanLength + 1
                  //             );
                  //           }

                  //           lastIndex = j;
                  //           startIndex = j;
                  //           startText = currentText;
                  //         }
                  //       }

                  //       var spanLength = lastIndex - startIndex;
                  //       if (spanLength >= 1) {
                  //         $($(rows[startIndex]).find("td")[i]).attr(
                  //           "rowspan",
                  //           spanLength + 1
                  //         );

                  //         if (i == 12) {
                  //           $($(rows[startIndex]).find("td")[i + 1]).attr(
                  //             "rowspan",
                  //             spanLength + 1
                  //           );
                  //           $($(rows[startIndex]).find("td")[i + 2]).attr(
                  //             "rowspan",
                  //             spanLength + 1
                  //           );
                  //         }

                  //         if (i == 5) {
                  //           $($(rows[startIndex]).find("td")[i + 5]).attr(
                  //             "rowspan",
                  //             spanLength + 1
                  //           );
                  //         }
                  //       }
                  //     }
                  //   }

                  //   for (var i in removeLater) {
                  //     $(removeLater[i]).hide();
                  //   }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  //console.log(data);
                  if (data) {
                    data.showDetailButton = self.$root.canShow();
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      svPhase: null,
      svLot: null,
      svTranche: null,
      svTracheNo: null,
      svOpenButton: false,
      svBilling: null,
      svAmount: null,
      svInvoice: null,
      svPhaseOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Phase",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      svLotOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MachinePayment/Select2Lot",
          data: function data(params) {
            var query = {
              search: params.term,
              Phase: self.svPhase,
              page: params.page || 1,
              isPaid: true
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      svTrancheOptions: {
        placeholder: "กรุณาเลือกงวด",
        allowClear: true,
        ajax: {
          url: "/Api/MachinePayment/Select2Tranche",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              billStatus: false,
              paymentStatus: false,
              phase: self.svPhase,
              lot: self.svLot,
              isPaid: true
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.svPhase = null;
      self.svLot = null;
      self.svTracheNo = null;
      self.svAmount = null;
      self.svInvoice = null;
      self.svBilling = null;

      $("#svPhase").val("").trigger("change");

      $("#svLot").val("").trigger("change");

      $("#svTracheNo").val("").trigger("change");

      $("#svBilling").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#machineTransactionTable").DataTable();
      table.draw();
    },
    formSave: function formSave(e) {
      var self = this;
      var router = this.$router;
      e.preventDefault();
      var valid = false;
      if (!$(self.$refs.formSave).validate().form()) {
        return false;
      }
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/MachinePayment/Add", {
        Phase: self.svPhase,
        Lot: self.svLot,
        Tranche: self.svTracheNo,
        BillingDate: self.svBilling != null ? self.svBilling.format("YYYY-MM-DD") : self.svBilling,
        Invoice: self.svInvoice,
        Amount: self.svAmount
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            //router.go(), self.$parent.reloadDataTable(false);
            self.formReset(e);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    formSaveReset: function formSaveReset(e) {
      var self = this;
      self.svAmount = null;
      self.svInvoice = null;
      self.svBilling = null;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#machineTransactionTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/MachinePayment/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      Phase: self.svPhase,
                      Lot: self.svLot,
                      Tranche: self.svTracheNo
                    }));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [100, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[1, "desc"]],
                columns: [{ data: "supplier" }, { data: "phase" }, { data: "lot" }, { data: "tranche" }, { data: "productName" }, { data: "productType" }, { data: "productBrand" }, { data: "count" }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

              $(self.$refs.svBilling).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.svBilling).datepicker("update", !!self.svBilling ? self.svBilling.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.svBilling = e.dates.length != 0 ? moment(e.date) : null;
              });

              // set validation rules
              $(self.$refs.formSave).validate({
                rules: {
                  svBilling: "required",
                  svAmount: "required",
                  svInvoice: "required"
                },
                messages: {
                  svBilling: "กรุณาเลือกวันที่",
                  svAmount: "กรุณากรอกจำนวนยอดรวม",
                  svInvoice: "กรุณากรอกเลขที่ Invoice"
                }
              });
              $(self.$refs.formSave).validate().settings.ignore = ":hidden";

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    var self = this;

    return {
      mktaObjectives: null,
      mktaActivityName: null,
      mktaAgentName: null,
      mktaShopName: null,
      mktaShopName2: null,
      mktaProvinceName: null,
      mktaActivityDate: null,
      mktaActivityDateStart: null,
      mktaActivityDateEnd: null,
      mktaShopType: null,
      mktaSaleItemPG: [],
      mktaSaleItem: [],
      mktaBuget: null,
      mktaItem: [],
      mktaNLat: null,
      mktaNLng: null,
      mktaOLat: null,
      mktaOLng: null,
      mktaMarkers: [],
      mktaIsApprove: false
    };
  },

  methods: {
    onApprove: function onApprove(e) {
      var _this = this;

      e.preventDefault();
      var self = this;
      var router = this.$router;
      Swal.fire({
        title: "คำสั่งอนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม",
        type: "warning",
        html: "กรุณายืนยันอนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม <strong>",
        inputValue: 0,
        inputPlaceholder: "อนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังอนุมัติข้อมูล กรุณารอสักครู่..."
          });

          //UpdateBorrowProduct
          if (self.ubpIsEdit) {
            self.formSubmit();
          }

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Marketing/" + _this.$route.params.id + "/Approve").then(function (response) {
            if (response.data.status) {
              Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                router.go(-1), self.$parent.reloadDataTable(false);
                //router.push({ path: `/Borrow` });
              });
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    onReject: function onReject(e) {
      var _this2 = this;

      e.preventDefault();
      var self = this;
      var router = this.$router;
      Swal.fire({
        title: "คำสั่งไม่อนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม",
        type: "warning",
        html: "กรุณายืนยันไม่อนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม <strong>",
        // input: "text",
        // inputAttributes: {
        //   autocapitalize: "off",
        // },
        // // inputValue: 0,
        // inputPlaceholder:
        //   "กรุณาระบุหมายเหตุผลไม่อนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
        // inputValidator: (value) => {
        //   return new Promise((resolve) => {
        //     if (value === "") {
        //       resolve("กรุณาระบุเหตุผลไม่อนุมัติแก้ไขข้อมูลพื้นที่กิจกรรม");
        //     } else {
        //       resolve();
        //     }
        //   });
        // },
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_0_axios___default()({
            method: "post",
            url: "/Api/Marketing/Reject",
            data: {
              Id: _this2.$route.params.id,
              Remark: result.value
            }
          })
          // .post("/Api/ProductLoan/" + this.$route.params.id + "/Reject",)
          .then(function (response) {
            if (response.data.status) {
              Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                router.go(-1), self.$parent.reloadDataTable(false);
                //router.push({ path: `/Borrow` });
              });
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        } else {}
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;
              router = _this3.$router;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Marketing/" + _this3.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  if (response.data != null) {
                    self.mktaObjectives = response.data.objectives, self.mktaActivityName = response.data.activityName != null ? response.data.activityName : "-", self.mktaAgentName = response.data.agentName, self.mktaShopName = response.data.shopName != null ? response.data.shopName : "-", self.mktaShopName2 = response.data.shopName2 != null && response.data.shopName2 != "" ? response.data.shopName2 : "-", self.mktaProvinceName = response.data.provinceName, self.mktaActivityDate = response.data.activityDateString != null ? response.data.activityDateString : "-", self.mktaActivityDateStart = response.data.activityDateStartString != null ? response.data.activityDateStartString : "-", self.mktaActivityDateEnd = response.data.activityDateEndString != null ? response.data.activityDateEndString : "-", self.mktaShopType = response.data.shopType != null ? response.data.shopType : "-", self.mktaSaleItemPG = response.data.saleItems.filter(function (o) {
                      return o.saleItemTypeCode == "MKT_SALE_ITEM_TYPE_PG";
                    }), self.mktaSaleItem = response.data.saleItems.filter(function (o) {
                      return o.saleItemTypeCode == "MKT_SALE_ITEM_TYPE_SALE";
                    }), self.mktaBuget = new Intl.NumberFormat().format(response.data.budget), self.mktaItem = response.data.items, self.mktaIsApprove = response.data.isRequestChange, self.mktaNLat = parseFloat(response.data.newLatitude), self.mktaNLng = parseFloat(response.data.newLongitude), self.mktaOLat = parseFloat(response.data.oldLatitude), self.mktaOLng = parseFloat(response.data.oldLongitude), self.mktaMarkers = [{
                      positionN: { lat: self.mktaNLat, lng: self.mktaNLng },
                      positionO: { lat: self.mktaOLat, lng: self.mktaOLng }
                    }];
                  }
                  console.log(self.mktaNLat);
                  console.log(self.mktaNLng);
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed

                KTApp.unblockPage();
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    var self = this;

    return {
      mktObjectives: null,
      mktActivityName: null,
      mktAgentName: null,
      mktShopName: null,
      mktShopName2: null,
      mktProvinceName: null,
      mktActivityDate: null,
      mktActivityDateStart: null,
      mktActivityDateEnd: null,
      mktShopType: null,
      mktSaleItemPG: [],
      mktSaleItem: [],
      mktBuget: null,
      mktItem: [],
      mktObjectivesCode: null,
      mktRemark: null
    };
  },

  methods: {},
  computed: {},
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Marketing/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  if (response.data != null) {
                    self.mktRemark = response.data.remark;

                    self.mktObjectives = response.data.objectives;
                    self.mktActivityName = response.data.activityName != null ? response.data.activityName : "-";
                    self.mktAgentName = response.data.agentName, self.mktShopName = response.data.shopName != null ? response.data.shopName : "-";
                    self.mktShopName2 = response.data.shopName2 != null && response.data.shopName2 != "" ? response.data.shopName2 : "-";
                    self.mktProvinceName = response.data.provinceName;
                    self.mktActivityDate = response.data.activityDateString != null ? response.data.activityDateString : "-";
                    self.mktActivityDateStart = response.data.activityDateStartString != null ? response.data.activityDateStartString : "-";
                    self.mktActivityDateEnd = response.data.activityDateEndString != null ? response.data.activityDateEndString : "-";
                    self.mktShopType = response.data.shopType != null ? response.data.shopType : "-";
                    self.mktBuget = new Intl.NumberFormat().format(response.data.budget), self.mktItem = response.data.items;
                    self.mktObjectivesCode = response.data.objectivesCode;
                    if (response.data.saleItems != null) {
                      self.mktSaleItemPG = response.data.saleItems.filter(function (o) {
                        return o.saleItemTypeCode == "MKT_SALE_ITEM_TYPE_PG";
                      }), self.mktSaleItem = response.data.saleItems.filter(function (o) {
                        return o.saleItemTypeCode == "MKT_SALE_ITEM_TYPE_SALE";
                      });
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed

                KTApp.unblockPage();
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var ActionsCanceled = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a  v-if=\"data.showEditStatusButton\"  class=\"btn btn-sm btn-danger \" style=\"color:white;width: 80%;\">\n      \u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\n    </a>\n  </div>"
});
var ActionsSaved = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a  v-if=\"data.showEditStatusButton\"  class=\"btn btn-sm btn-warning \" style=\"color:white;width: 80%;\">\n      \u0E40\u0E1B\u0E34\u0E14\n    </a>\n  </div>"
});

var ActionsComplete = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a  v-if=\"data.showEditStatusButton\"  class=\"btn btn-sm btn-success  \" style=\"color:white;width: 80%;\">\n      \u0E1B\u0E34\u0E14\n    </a>\n  </div>"
});

var mktActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a  href=\"#\"  :id ='data.activityHeaderId' @contextmenu=\"handler(data.activityHeaderId)\" @click.prevent=\"detailMkt\"  v-if=\"data.showDetailButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-file-text\"></i>\n    </a>\n    <a  href=\"#\"  @click.prevent=\"closeMkt\"  v-if=\"data.showCloseButton\" title=\"\u0E1B\u0E34\u0E14\u0E43\u0E1A\u0E07\u0E32\u0E19\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-archive\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"detailAprroveMkt\" v-if=\"data.isRequestChange\" title=\"\u0E02\u0E2D\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    \n  </div>",
  methods: {
    detailMkt: function detailMkt() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        path: "/Marketing/MarketingList/Detail/" + this.data.activityHeaderId
      });
    },
    detailAprroveMkt: function detailAprroveMkt() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        path: "/Marketing/ApproveDetail/" + this.data.activityHeaderId
      });
    },
    handler: function handler(e) {
      var name = this.data.activityHeaderId.toString();
      document.getElementById(name).href = "/Marketing/MarketingList/Detail/" + this.data.activityHeaderId;
    },
    closeMkt: function closeMkt() {
      var _this = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งปิดใบงาน",
        type: "warning",
        html: "กรุณายืนยันคำสั่งปิดใบงาน <strong>",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการปิดใบงาน",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังดำเนินการ กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Marketing/CloseActivity/" + _this.data.activityHeaderId).then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      keySearch: null,
      objectives: null,
      mktStatus: null,

      objectivesOptions: {
        placeholder: "กรุณาเลือกประเภทกิจกรรมที่ต้องการค้นหา",
        allowClear: true,
        ajax: {
          url: "/Api/Marketing/Select2Objectives",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      mktStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "MKT_ACTIVITY_STATUS_COMPLETE", text: "ปิด", data: null }, { id: "MKT_ACTIVITY_STATUS_SAVED", text: "เปิด", data: null }, { id: "MKT_ACTIVITY_STATUS_CANCELED", text: "ยกเลิก", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.keySearch = null;
      self.objectives = null;
      self.mktStatus = null;

      $("#objectives").val("").trigger("change");

      $("#mktStatus").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#marketingTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#marketingTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;


              $.fn.dataTable.ext.errMode = 'none';
              table = $("#marketingTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Marketing/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.keySearch,
                      Objectives: self.objectives,
                      StatusCode: self.mktStatus
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[9, "desc"]],
                columns: [{
                  data: "objectives",
                  width: "10%",
                  className: "text-center"
                }, {
                  data: "activityName",
                  className: "text-center",
                  width: "10%"
                }, {
                  data: "agentName",
                  className: "text-center",
                  width: "10%"
                }, {
                  data: "provinceName",
                  className: "text-center",
                  width: "10%"
                }, {
                  data: "shopName",
                  className: "text-center",
                  width: "10%"
                }, {
                  data: "shopName2",
                  className: "text-center",
                  width: "10%"
                }, {
                  data: "activityDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.activityDateString;
                  }
                }, {
                  data: "activityDateStart",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.activityDateStartString;
                  }
                }, {
                  data: "activityDateEnd",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.activityDateEndString;
                  }
                }, {
                  data: "createDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.createDateString;
                  }
                }, {
                  data: "statusCode",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "activityHeaderId",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGER_MKT", "ADMIN_MKT"]);
                    if (data.statusCode == "เปิด") new ActionsSaved({ data: { data: data }, parent: self }).$mount(el);else if (data.statusCode == "ปิด") new ActionsComplete({ data: { data: data }, parent: self }).$mount(el);else if (data.statusCode == "ยกเลิก") new ActionsCanceled({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  var listCanClose = ["MKT_ACTIVITY_TYPE_EVENT", "MKT_ACTIVITY_TYPE_FOOD_FESTIVAL"];
                  if (data) {
                    data.showDetailButton = self.$root.canShow(["MANAGE_MASTER", "MANAGER_MKT", "ADMIN_MKT"]);
                    data.showCloseButton = data.statusCode == "เปิด" && listCanClose.includes(data.objectivesCode) && self.$root.canShow(["MANAGE_MASTER", "MANAGER_MKT", "ADMIN_MKT"]);
                    // data.showDetailAprroveButton =
                    new mktActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // userName: null,
      // password: null,
      // confirmPassword: null,
      // email: null,
      // givenName: null,
      // familyName: null,
      // position: null,
      // phoneNumber: null,
      // roleName: null
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$("#agentCreateModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Users/Create", {
        userName: this.userName,
        password: this.password,
        confirmPassword: this.confirmPassword,
        email: this.email,
        givenName: this.givenName,
        familyName: this.familyName,
        position: this.position,
        phoneNumber: this.phoneNumber,
        roleName: this.roleName
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $("#holdCreateModal").modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              $("#dateType").select2({
                tags: true,
                placeholder: "กรุณาเลือก",
                allowClear: true
              });

              // set validation rules
              $("#agentCreateModal form").validate({
                // rules: {
                //   userName: "required",
                //   email: {
                //     required: true,
                //     email: true
                //   },
                //   password: {
                //     required: true,
                //     minlength: 6
                //   },
                //   confirmPassword: {
                //     equalTo: "#password"
                //   },
                //   givenName: "required",
                //   familyName: "required",
                //   phoneNumber: "required"
                // },
                // messages: {
                //   userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
                //   email: {
                //     required: "กรุณากรอกอีเมล",
                //     email: "กรุณากรอกอีเมลให้ถูกต้อง"
                //   },
                //   password: {
                //     required: "กรุณากรอกรหัสผ่าน",
                //     minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร"
                //   },
                //   confirmPassword: {
                //     equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง"
                //   },
                //   givenName: "กรุณากรอกชื่อ",
                //   familyName: "กรุณากรอกชื่อสกุล",
                //   phoneNumber: "กรุณากรอกเบอร์โทรศัพท์"
                // }
              });
              $("#agentCreateModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              }).modal("show");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // userName: null,
      // password: null,
      // confirmPassword: null,
      // email: null,
      // givenName: null,
      // familyName: null,
      // position: null,
      // phoneNumber: null,
      // roleName: null
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$("#agentCreateModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Users/Create", {
        userName: this.userName,
        password: this.password,
        confirmPassword: this.confirmPassword,
        email: this.email,
        givenName: this.givenName,
        familyName: this.familyName,
        position: this.position,
        phoneNumber: this.phoneNumber,
        roleName: this.roleName
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $("#holdCreateModal").modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              $("#dateType").select2({
                tags: true,
                placeholder: "กรุณาเลือก",
                allowClear: true
              });

              // set validation rules
              $("#agentCreateModal form").validate({
                // rules: {
                //   userName: "required",
                //   email: {
                //     required: true,
                //     email: true
                //   },
                //   password: {
                //     required: true,
                //     minlength: 6
                //   },
                //   confirmPassword: {
                //     equalTo: "#password"
                //   },
                //   givenName: "required",
                //   familyName: "required",
                //   phoneNumber: "required"
                // },
                // messages: {
                //   userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
                //   email: {
                //     required: "กรุณากรอกอีเมล",
                //     email: "กรุณากรอกอีเมลให้ถูกต้อง"
                //   },
                //   password: {
                //     required: "กรุณากรอกรหัสผ่าน",
                //     minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร"
                //   },
                //   confirmPassword: {
                //     equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง"
                //   },
                //   givenName: "กรุณากรอกชื่อ",
                //   familyName: "กรุณากรอกชื่อสกุล",
                //   phoneNumber: "กรุณากรอกเบอร์โทรศัพท์"
                // }
              });
              $("#agentCreateExcelModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              }).modal("show");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_lazy_image__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_lazy_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_lazy_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the component

// import the styles



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_v_lazy_image__["VLazyImagePlugin"]);
__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#agentTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Agents/" + _this.data.agentCodeSap + "/Toggle").then(function (response) {
            if (response.data.data) {
              Swal.fire("สำเร็จ", response.data.message, "success");
              self.$parent.reloadDataTable();
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#agentTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        Swal.fire("สำเร็จ", "success");
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Agents/" + _this2.data.agentCodeSap + "/Toggle").then(function (response) {
            if (response.data.data) {
              Swal.fire("สำเร็จ", response.data.message, "success");
              self.$parent.reloadDataTable();
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var AgentActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  // <a href="#" @click.prevent="deleteAgent" v-if="data.showDeleteButton" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ลบข้อมูลการถือครอง">
  //     <i class="la la-trash"></i>
  //   </a>
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editAgent\" v-if=\"data.showEditButton\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E15\u0E31\u0E27\u0E41\u0E17\u0E19\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\">\n      <i class=\"la la-edit\"></i>\n    </a>\n\n  </div>",
  methods: {
    editAgent: function editAgent() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/Master/Agents/Edit/" + this.data.agentCodeSap });
    },
    deleteAgent: function deleteAgent() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบการถือครอง",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลตัวแทนจำหน่าย <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ตัวแทนจำหน่ายนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลตัวแทนจำหน่ายออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Agents/" + _this3.data.agentCodeSap + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_4__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      agentList_areaKey: null,
      agentListProvinceKey: [],
      agentListProvinceKeyOptions: [],
      agentListAgentKey: [],
      agentListAgentKeyOptions: [],
      agentList_activeStatusKey: false,
      aglKeyword: null,
      alAreaNew: [],
      //config
      agentList_activeStatusKeyOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      },
      alAreaNewOptions: []
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.alAreaNew = [];
      this.agentListProvinceKey = [];
      this.agentListAgentKey = [];
      $("#agentList_areaKey").val("").trigger("change");

      $("#alAreaNew").val("").trigger("change");

      //default Active Data
      this.agentList_activeStatusKey = false;
      $("#agentList_activeStatusKey").val(this.agentList_activeStatusKey + "").trigger("change");
      this.aglKeyword = "";
      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#agentTable").DataTable();
      table.search();
      table.draw();
    },
    exportAgent: function exportAgent(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/Report/exportAgent",
        responseType: "arraybuffer",
        data: {
          Department: [], //$("select#agentList_areaKey").val(),
          ProvinceId: self.agentListProvinceKey,
          AgentCodeSap: self.agentListAgentKey,
          ActiveStatus: self.agentList_activeStatusKey,
          SalesArea: self.alAreaNew,
          SearchKeyword: self.aglKeyword
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // link.download = "ข้อมูลตัวแทนจำหน่าย" + filename;
          link.download = "ข้อมูลตัวแทนจำหน่าย"; //+ filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#agentTable").DataTable().ajax.reload(null, resetPaging);
    },
    LoadagentListProvinceKeyOptions: function LoadagentListProvinceKeyOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Agents/Select2SearchProvince", {
        page: 1,
        department: [],
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.agentListProvinceKeyOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    LoadagentListAgentKeyOptions: function LoadagentListAgentKeyOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Agents/Select2SearchAgentName", {
        province_id: self.agentListProvinceKey,
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.agentListAgentKeyOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadalAreaNewOptions: function LoadalAreaNewOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.alAreaNewOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;
              //default Active Data

              self.agentList_activeStatusKey = false;
              $("#agentList_activeStatusKey").val(self.agentList_activeStatusKey + "").trigger("change");

              self.LoadagentListProvinceKeyOptions();
              self.LoadagentListAgentKeyOptions();
              self.LoadalAreaNewOptions();

              $("#agentList_areaKey").select2({
                tags: true,
                placeholder: "กรุณาเลือก",
                allowClear: true,
                ajax: {
                  url: "/Api/Agents/Select2SearchDepartment",
                  data: function data(params) {
                    var query = {
                      search: params.term,
                      page: params.page || 1
                    };
                    return query;
                  },
                  processResults: function processResults(data, params) {
                    return {
                      results: data.results,
                      pagination: {
                        more: data.more
                      }
                    };
                  },
                  transport: function transport(params, success, failure) {
                    params.beforeSend = function (request) {
                      request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                    };
                    var $request = $.ajax(params);
                    $request.then(success);
                    $request.fail(failure);
                    return $request;
                  }
                }
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#agentTable");

              table.DataTable({
                // data: dataSet,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Agents/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      Department: [], //$("select#agentList_areaKey").val(),
                      ProvinceId: self.agentListProvinceKey,
                      AgentCodeSap: self.agentListAgentKey,
                      ActiveStatus: self.agentList_activeStatusKey,
                      SalesArea: self.alAreaNew,
                      SearchKeyword: self.aglKeyword
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[1, "desc"]],
                columns: [{
                  data: null,
                  className: "details-control",
                  defaultContent: "",
                  orderable: false
                }, { data: "agentCodeSap" }, { data: "agentName", width: "20%",

                  render: function render(data, type, full, meta) {
                    var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>" + data + "</pre>";
                    return html;
                  }
                }, { data: "address" }, { data: "provinceName", orderable: false }, { data: "salesAreaName" }, { data: "tel" }, { data: "email" }, { data: "contact" }, { data: "contactTel" }, { data: "latitude" }, { data: "longitude" },
                // {
                //   data: "picture",
                //   sortable: false,
                //   render: function(data, type, row) {
                //     return `<img src="https://image.bangkokbiznews.com/kt/media/image/news/2019/04/29/833758/750x422_833758_1556527455.jpg"/>`;
                //     // return `<v-lazy-image src="https://image.bangkokbiznews.com/kt/media/image/news/2019/04/29/833758/750x422_833758_1556527455.jpg"/>`;
                //     // return `<img src="<v-lazy-image src="/Api/DownloadImg/{0}"/>" style="max-width: 200px;" />`;
                //     //   .formatUnicorn(
                //     //     Setting.rootPath + data.substr(8)
                //     //   );
                //   }
                // },
                {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "agentCodeSap",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MASTER_AGENT"]);
                    if (data.inActiveStatus == 0) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MASTER_AGENT"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MASTER_AGENT"]);
                    new AgentActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              // table.trigger("draw.dt"); //call ajax delete this row

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_lazy_image__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_lazy_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_lazy_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_v_lazy_image__["VLazyImagePlugin"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2_vue__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      agentCode: null,
      agentName: null,
      OwnerTypeCode: null,
      OwnerTypeCodeOption: [],
      adress: null,
      Area: null,
      Province: null,
      tel: null,
      email: null,
      lat: null,
      lng: null,
      FileUpload: [],
      status: null,
      markers: [],
      agentOnwer: null,
      agentContact: null,
      agentContactTel: null,
      agentStatus: false,
      IsSendReport: false,
      IsSpecialPM: false,
      isPreviousBalance: false,
      isNotReturnPlant: false,
      isReturnSaleProduct: false,
      isShowInAgentScoreReport: false,
      // CR-PM-2026 Req 2 — per-agent radius config (reserved for future agent-level checkin)
      useSettingCheckinRange: true,
      apiLoadedCheckInRange: undefined, // Issue 2: defensive — track fetched value
      customCheckInRange: null,
      customCheckInRangeMaxError: null,
      smlMapping: {
        mappingToAgentCode: null,
        useMappingDocSML: true,
        useMappingShopSML: true,
        whCode: null,
        location1Code: null,
        location2Code: null
      },
      mappingToAgentCodeOptions: {
        placeholder: "เลือกตัวแทน (สำนักงานใหญ่)",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };

            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลตัวแทน (สำนักงานใหญ่)";
          }
        }
      },
      auAreaNew: null,
      auAreaNewOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterSalesArea/FindOptions",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  // mounted() {
  //   this.initPlUploader();
  // },
  methods: {
    // CR-PM-2026 Req 2 — reset to default (use Setting)
    resetCheckinRange: function resetCheckinRange() {
      this.useSettingCheckinRange = true;
      this.customCheckInRange = null;
    },
    checkCustomCheckInRangeMax: function checkCustomCheckInRangeMax(e) {
      var raw = e.target.value;
      var val = Number(raw);
      if (raw !== "" && !isNaN(val) && val > 10000) {
        this.customCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
        // Clamp value back to 10000 (block typing beyond)
        this.customCheckInRange = 10000;
        this.$nextTick(function () {
          if (e.target) e.target.value = 10000;
        });
      } else {
        this.customCheckInRangeMaxError = null;
      }
    },

    getMap: function getMap() {
      var _this = this;

      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition(function (position) {
        _this.lat = position.coords.latitude;
        _this.lng = position.coords.longitude;
        _this.markers = [{
          position: { lat: _this.lat, lng: _this.lng },
          animation: google.maps.Animation.DROP
        }];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates: function updateCoordinates(location) {
      this.lat = location.latLng.lat();
      this.lng = location.latLng.lng();
      map: this.map;
      this.markers = [{ position: { lat: this.lat, lng: this.lng } }];
    },
    arrayBufferToBase64: function arrayBufferToBase64(buffer) {
      //var base64 = String.fromCharCode.apply(null, new Uint16Array(buffer));
      var base64 = btoa(buffer);
      return base64;
    },
    handleImageError: function handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad: function handleImageLoad(image) {
      image.isLoaded = true;
    },
    removeImage: function removeImage(pictureId) {
      var _this2 = this;

      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then(function (result) {
        if (result.value) {
          _this2.FileUpload = _this2.FileUpload.filter(function (img) {
            return img.pictureId !== pictureId;
          });
          Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
        }
      });
    },
    uploadFile: function uploadFile() {
      var _this3 = this;

      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();

      input.addEventListener("change", function (event) {
        var files = event.target.files;
        Array.from(files).forEach(function (file) {
          if (["image/jpeg", "image/jpg", "image/png"].includes(file.type) && file.size <= 10 * 1024 * 1024) {
            var reader = new FileReader();
            reader.onload = function (e) {
              var newImage = {
                pictureId: Date.now().toString(),
                fileName: file.name,
                urlImg: e.target.result,
                fileDataContext: file,
                isNew: true,
                isLoaded: true
              };
              _this3.FileUpload.push(newImage);
            };
            reader.readAsDataURL(file);
          } else {
            alert("กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)");
          }
        });
      });
    },
    formSubmit: function formSubmit(e) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var router, self, uploadedFiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, formData, uploadResponse, picturesData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                router = _this4.$router;
                self = _this4;

                if ($(_this4.$refs.form).validate().form()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                uploadedFiles = [];

                // Upload new files to GCS

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 9;
                _iterator = _this4.FileUpload[Symbol.iterator]();

              case 11:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 34;
                  break;
                }

                file = _step.value;

                if (!(file.isNew && file.fileDataContext)) {
                  _context.next = 30;
                  break;
                }

                _context.prev = 14;
                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("IsMaster", true);
                formData.append("FolderName", "MasterAgent");

                _context.next = 21;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 21:
                uploadResponse = _context.sent;


                uploadedFiles.push({
                  contentType: "-",
                  downloadUrl: uploadResponse.data.fileUrl,
                  fileInfoId: uploadResponse.data.fileInfoId,
                  fileName: uploadResponse.data.fileInfoId,
                  gridFsId: uploadResponse.data.gridFsId,
                  sysName: "-"
                });
                _context.next = 28;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](14);

                console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", _context.t0);

              case 28:
                _context.next = 31;
                break;

              case 30:
                if (!file.isNew) {
                  // Keep existing files
                  uploadedFiles.push(file);
                }

              case 31:
                _iteratorNormalCompletion = true;
                _context.next = 11;
                break;

              case 34:
                _context.next = 40;
                break;

              case 36:
                _context.prev = 36;
                _context.t1 = _context["catch"](9);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 40:
                _context.prev = 40;
                _context.prev = 41;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 43:
                _context.prev = 43;

                if (!_didIteratorError) {
                  _context.next = 46;
                  break;
                }

                throw _iteratorError;

              case 46:
                return _context.finish(43);

              case 47:
                return _context.finish(40);

              case 48:
                picturesData = uploadedFiles.length > 0 ? uploadedFiles : [];


                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Agents", {
                  AgentCodeSap: _this4.agentCode,
                  OwnerTypeCode: _this4.OwnerTypeCode,
                  Email: _this4.email,
                  InActiveStatus: !_this4.status,
                  Tel: _this4.tel,
                  Latitude: _this4.lat,
                  Longitude: _this4.lng,
                  AgentPictures: picturesData,
                  SalesAreaId: _this4.auAreaNew,
                  smlMapping: _this4.smlMapping,
                  isPreviousBalance: _this4.isPreviousBalance,
                  isNotReturnPlant: _this4.isNotReturnPlant,
                  IsSendReport: _this4.IsSendReport,
                  IsSpecialPM: _this4.IsSpecialPM,
                  isReturnSaleProduct: _this4.isReturnSaleProduct,
                  isShowInAgentScoreReport: _this4.isShowInAgentScoreReport,
                  // CR-PM-2026 Req 2 — radius
                  UseSettingCheckinRange: _this4.useSettingCheckinRange,
                  CheckInRange: _this4.useSettingCheckinRange ? null : _this4.customCheckInRange
                }).then(function (response) {
                  if (response.data.status) {
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      router.go(-1), self.$parent.reloadDataTable(false);
                    });
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

              case 50:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4, [[9, 36, 40, 48], [14, 25], [41,, 43, 47]]);
      }))();
    },
    openMap: function openMap() {
      var self = this;
      window.open("https://www.google.com/maps/search/?api=1&query=" + self.lat + "," + self.lng, "_blank");
    },

    LoadOwnerTypeCodeOption: function LoadOwnerTypeCodeOption(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Variables/Options?search=MASTER_OWNER_TYPE", {
        params: {
          page: 1,
          all: true,
          searchCode: "OWNER_AGENT"
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OwnerTypeCodeOption.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this5;
              router = _this5.$router;
              _context2.next = 4;
              return _this5.$root.getUser();

            case 4:
              user = _context2.sent;

              self.LoadOwnerTypeCodeOption();

              $(_this5.$refs.form).validate({
                // CR-PM-2026 Issue 14: required เฉพาะกรณี "กำหนดเอง" (useSettingCheckinRange=false)
                rules: {
                  customCheckInRange: {
                    required: function required() {
                      return !self.useSettingCheckinRange;
                    }
                  }
                },
                messages: {
                  customCheckInRange: "กรุณาระบุระยะ (เมตร)"
                }
              });

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Agents/" + _this5.$route.params.AgentID).then(function (response) {
                if (response.status == 200) {
                  self.agentCode = response.data.agentCodeSap;
                  self.agentName = response.data.agentName;
                  self.adress = response.data.address;
                  self.Area = response.data.department;
                  self.Province = response.data.provinceName;
                  self.tel = response.data.tel;
                  self.email = response.data.email;
                  self.agentOnwer = response.data.owner;
                  self.agentContact = response.data.contact;
                  self.agentContactTel = response.data.contactTel;
                  self.agentStatus = !response.data.agentStatus;
                  self.IsSendReport = response.data.isSendReport;
                  self.IsSpecialPM = response.data.isSpecialPM != null ? response.data.isSpecialPM : false;
                  self.isPreviousBalance = response.data.isPreviousBalance;
                  self.isNotReturnPlant = response.data.isNotReturnPlant;
                  self.isReturnSaleProduct = response.data.isReturnSaleProduct;
                  self.isShowInAgentScoreReport = response.data.isShowInAgentScoreReport;
                  // CR-PM-2026 Req 2 — load radius config
                  self.useSettingCheckinRange = response.data.useSettingCheckinRange != null ? response.data.useSettingCheckinRange : true;
                  self.customCheckInRange = !self.useSettingCheckinRange ? response.data.checkInRange : null;
                  self.apiLoadedCheckInRange = response.data.checkInRange != null ? response.data.checkInRange : null;
                  self.OwnerTypeCode = response.data.ownerTypeCode;
                  if (response.data.salesAreaId) {
                    self.$refs.auAreaNewSelect2.setSelectedData({
                      id: response.data.salesAreaId,
                      text: response.data.salesAreaName
                    });
                  }

                  response.data.latitude === null ? self.lat = null : self.lat = parseFloat(response.data.latitude);

                  response.data.longitude === null ? self.lng = null : self.lng = parseFloat(response.data.longitude);

                  self.markers = [{ position: { lat: self.lat, lng: self.lng } }];
                  self.status = !response.data.inActiveStatus;

                  // Load existing images to FileUpload array (GCS format)
                  self.FileUpload = response.data.pictures.map(function (element) {
                    return {
                      pictureId: element.pictureId,
                      fileName: element.fileName,
                      fileInfoId: element.fileInfoId,
                      downloadUrl: element.downloadUrl,
                      urlImg: element.urlImg,
                      gridFsId: element.gridFsId,
                      sysName: element.sysName,
                      isNew: false,
                      isLoaded: true
                    };
                  });

                  var smlMapping = response.data.smlMapping;
                  self.smlMapping.useMappingDocSML = smlMapping.useMappingDocSML;
                  self.smlMapping.useMappingShopSML = smlMapping.useMappingShopSML;
                  self.smlMapping.whCode = smlMapping.whCode;
                  self.smlMapping.location1Code = smlMapping.location1Code;
                  self.smlMapping.location2Code = smlMapping.location2Code;
                  if (smlMapping.mappingToAgentCode) {
                    self.$refs.mappingToAgentCode.setSelectedData({
                      id: smlMapping.mappingToAgentCode,
                      text: "[" + smlMapping.mappingToAgentCode + "] " + smlMapping.mappingToAgentName
                    });
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลตัวแทนจำหน่ายที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลตัวแทนจำหน่ายได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ItemRow__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    itemRows: __WEBPACK_IMPORTED_MODULE_3__ItemRow__["a" /* default */]
  },
  data: function data() {
    var _ref;

    var self = this;
    return _ref = {
      uuid: null,
      current_upload_row: null,

      reqBrand: false,
      reqBrandMsg: "กรุณาเลือกแบรนด์สินค้า",

      brandsitems: [],

      apmrAgentCode: null,
      apmrSubAgentCode: null,
      apmrShopCodes: null,
      apmrSubShopCodes: null,

      reAlertConfigType: "SHOP",
      reAlertConfigTypeOptions: []

    }, _defineProperty(_ref, "reAlertConfigTypeOptions", {
      placeholder: "ทั้งหมด",
      allowClear: true,
      data: [{ id: "AGENT", text: "ประเภทตัวแทนจำหน่าย", data: null }, { id: "SHOP", text: "ประเภทร้านค้า", data: null }]
    }), _defineProperty(_ref, "pmrAgentCodesOptions", []), _defineProperty(_ref, "pmrShopCodesOptions", []), _defineProperty(_ref, "apmrAgentCodeOptions", {
      placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      allowClear: true,
      multiple: false,
      ajax: {
        url: self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
        type: "post",
        delay: 300,
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            province_id: [],
            department: [],
            agentCodes: []
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "apmrShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      multiple: false,
      ajax: {
        url: "/Api/Shop/Select2ShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "apmrSubShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      multiple: false,
      ajax: {
        url: "/Api/Shop/SubShopOptionAlertReport",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {

          var query = {
            agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
            shopCodes: self.apmrSubAgentCode != null ? [self.apmrSubAgentCode] : null,
            search: params.term,
            page: params.page || 1,
            all: true
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "apmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      multiple: false,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
            shopCodes: self.apmrAgentCode != null ? [self.apmrShopCodes] : null,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },

  computed: {
    BcBalanceCal: function BcBalanceCal() {
      this.bcBalance = this.bcUsed != null ? this.bcBudget - this.bcUsed : this.bcBudget;
      return this.bcBalance;
    }
  },
  methods: {
    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (self.brandsitems == undefined || self.brandsitems == null || self.brandsitems.length <= 0) {
        self.reqBrand = true;
      } else {
        self.reqBrand = false;
      }

      if (!$(this.$refs.form).validate().form() || self.reqBrand) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("/Api/MasterOverdueSetting/SaveAlertPMConfig", {
        AlertConfigType: self.reAlertConfigType,
        AgentCodes: self.apmrAgentCode,
        ShopCodes: self.apmrShopCodes,
        SubAgentCodes: self.apmrSubAgentCode,
        SubAgentShopCodes: self.apmrSubShopCodes,
        Brands: self.brandsitems
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          //console.log(response);
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    doUploadClick: function doUploadClick(row) {
      var self = this;
      self.current_upload_row = row;
      $("#btnupload").click();
    },
    GetDownloadFile: function GetDownloadFile(fileDownload) {
      var self = this;
      var fileUrl = fileDownload.fileInfoId;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("/Api/File/FileDownload", {
        params: {
          FileInfoId: fileUrl
        }
      }).then(function (response) {
        self.current_upload_row.DownloadFileUrl = response.data.fileUrl;
      }).catch(function (error) {});
    },
    uploadFile: function uploadFile() {
      var self = this;
      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg,application/msword,application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.presentation";
      input.click();

      input.addEventListener("change", function (event) {
        var files = event.target.files;
        Array.from(files).forEach(function (file) {
          if (["image/jpeg", "image/jpg", "image/png", "application/msword", "application/vnd.ms-excel", "application/vnd.ms-powerpoint", "text/plain", "application/pdf", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(file.type) && file.size <= 100 * 1024 * 1024) {
            var reader = new FileReader();

            var _BucketName = "MasterAlertPM";
            self.current_upload_row.FileName = file.name;
            try {
              var isUploadFile = true;
              var formData = new FormData();
              formData.append("File", file);
              formData.append("IsMaster", true);
              formData.append("FolderName", _BucketName);

              var uploadResponse = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("/Api/File/FileUpload", formData, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }).then(function (response) {
                self.current_upload_row.DownloadUrl = response.data.fileUrl;
                self.current_upload_row.FileInfoId = response.data.fileInfoId;
                self.current_upload_row.FileName = file.name;
                self.current_upload_row.GridFsId = response.data.gridFsId;
                self.current_upload_row.SysName = "-";
                self.current_upload_row.BucketName = _BucketName;
                self.GetDownloadFile(response.data);
              });
            } catch (error) {
              console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
            }
          } else {
            alert("กรุณาเลือกไฟล์ที่ถูกต้อง (ขนาดไม่เกิน 100MB)");
          }
        });
      });
    },
    onAddItemClick: function onAddItemClick(e) {
      this.brandsitems.push({
        Brandid: null,
        BrandName: null,
        Days: 15,
        FileUpload: null,
        ContentType: null,
        DownloadUrl: null,
        FileInfoId: null,
        FileName: null,
        GridFsId: null,
        SysName: null,
        DownloadFileUrl: null,
        BucketName: null
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.brandsitems.splice(index, 1);
      for (var i = 0; i < this.brandsitems.length; i++) {}
    },

    onApmrAgentTypeCodeChange: function onApmrAgentTypeCodeChange(obj) {

      var self = this;

      this.apmrAgentCode = null;
      $("#apmrAgentCode").val("").trigger("change");

      this.apmrShopCodes = null;
      $("#apmrShopCodes").val("").trigger("change");

      this.apmrSubAgentCode = null;
      $("#apmrSubAgentCode").val("").trigger("change");

      this.apmrSubShopCodes = null;
      $("#apmrSubShopCodes").val("").trigger("change");
    },
    onApmrAgentCodeChange: function onApmrAgentCodeChange() {

      this.apmrShopCodes = null;
      $("#apmrShopCodes").val("").trigger("change");

      this.apmrPmUserId = null;
      $("#apmrPmUserId").val("").trigger("change");
    },

    onApmrSubAgentCodeChange: function onApmrSubAgentCodeChange(id, text, data, ref) {

      var self = this;
      if (data[0] != undefined) {
        this.apmrAgentCode = data[0].data;
      }

      this.apmrPmUserId = null;
      $("#apmrPmUserId").val("").trigger("change");

      this.apmrSubShopCodes = null;
      $("#apmrSubShopCodes").val("").trigger("change");
    },
    GetBrands: function GetBrands() {

      var self = this;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("/Api/Report/PM/ProductBrandOptions", {
        params: {
          search: null,
          page: 1
        }
      }).then(function (response) {
        $.each(response.data.results, function (key, value) {
          self.brandsitems.push({
            Brandid: value.data,
            BrandName: value.text,
            Days: 15,
            FileUpload: null,
            ContentType: null,
            DownloadUrl: null,
            FileInfoId: null,
            FileName: null,
            GridFsId: null,
            SysName: null,
            DownloadFileUrl: null,
            BucketName: null
          });
        });
      }).catch(function (error) {});
    },

    AgentClearAfterselect: function AgentClearAfterselect() {
      var self = this;

      self.apmrShopCodes = null;
      self.apmrSubAgentCode = null;
      self.apmrSubShopCodes = null;

      $("#apmrShopCodes").val("").trigger("change");
      $("#apmrSubAgentCode").val("").trigger("change");
      $("#apmrSubShopCodes").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    SubAgentClearAfterselect: function SubAgentClearAfterselect() {
      var self = this;
      self.apmrSubShopCodes = null;

      $("#apmrSubShopCodes").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    ShopClearAfterselect: function ShopClearAfterselect() {
      var self = this;

      self.apmrSubAgentCode = null;
      self.apmrSubShopCodes = null;

      $("#apmrSubAgentCode").val("").trigger("change");
      $("#apmrSubShopCodes").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },

    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.GetBrands();

              //set Current Year
              _this.bcYear = new Date();
              $(_this.$refs.form).validate({
                rules: {
                  apmrAgentCode: "required",
                  reAlertConfigType: "required"

                },
                messages: {
                  apmrAgentCode: "กรุณาระบุตัวแทนจำหน่อย",
                  reAlertConfigType: "กรุณาระบุประเภทการตั้งค่าข้อมูลวัน Alert PM"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ItemRow__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    itemRows: __WEBPACK_IMPORTED_MODULE_3__ItemRow__["a" /* default */]
  },
  data: function data() {
    var _ref;

    var self = this;
    return _ref = {
      current_id: 0,
      uuid: null,
      current_upload_row: null,

      reqBrand: false,
      reqBrandMsg: "กรุณาเลือกแบรนด์สินค้า",

      brandsitems: [],

      apmrAgentCode: null,
      apmrSubAgentCode: null,
      apmrShopCodes: null,
      apmrSubShopCodes: null,

      reAlertConfigType: "SHOP",
      reAlertConfigTypeOptions: []

    }, _defineProperty(_ref, "reAlertConfigTypeOptions", {
      placeholder: "ทั้งหมด",
      allowClear: true,
      data: [{ id: "AGENT", text: "ประเภทตัวแทนจำหน่าย", data: null }, { id: "SHOP", text: "ประเภทร้านค้า", data: null }]
    }), _defineProperty(_ref, "pmrAgentCodesOptions", []), _defineProperty(_ref, "pmrShopCodesOptions", []), _defineProperty(_ref, "apmrAgentCodeOptions", {
      placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      allowClear: true,
      multiple: false,
      ajax: {
        url: self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
        type: "post",
        delay: 300,
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            province_id: [],
            department: [],
            agentCodes: []
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "apmrShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      multiple: false,
      ajax: {
        url: "/Api/Shop/Select2ShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "apmrSubShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      multiple: false,
      ajax: {
        url: "/Api/Shop/SubShopOptionAlertReport",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {

          var query = {
            agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
            shopCodes: self.apmrSubAgentCode != null ? [self.apmrSubAgentCode] : null,
            search: params.term,
            page: params.page || 1,
            all: true
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "apmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      multiple: false,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
            shopCodes: self.apmrAgentCode != null ? [self.apmrShopCodes] : null,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },

  computed: {
    BcBalanceCal: function BcBalanceCal() {
      this.bcBalance = this.bcUsed != null ? this.bcBudget - this.bcUsed : this.bcBudget;
      return this.bcBalance;
    }
  },
  methods: {
    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (self.brandsitems == undefined || self.brandsitems == null || self.brandsitems.length <= 0) {
        self.reqBrand = true;
      } else {
        self.reqBrand = false;
      }

      if (!$(this.$refs.form).validate().form() || self.reqBrand) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("/Api/MasterOverdueSetting/SaveAlertPMConfig", {
        Id: self.current_id,
        AlertConfigType: self.reAlertConfigType,
        AgentCodes: self.apmrAgentCode,
        ShopCodes: self.apmrShopCodes,
        SubAgentCodes: self.apmrSubAgentCode,
        SubAgentShopCodes: self.apmrSubShopCodes,
        Brands: self.brandsitems
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          //console.log(response);
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    doUploadClick: function doUploadClick(row) {
      var self = this;
      self.current_upload_row = row;
      $("#btnupload").click();
    },
    GetDownloadFile: function GetDownloadFile(fileDownload) {
      var self = this;
      var fileUrl = fileDownload.fileInfoId;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("/Api/File/FileDownload", {
        params: {
          FileInfoId: fileUrl
        }
      }).then(function (response) {
        self.current_upload_row.DownloadFileUrl = response.data.fileUrl;
      }).catch(function (error) {});
    },
    uploadFile: function uploadFile() {
      var self = this;
      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg,application/msword,application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.presentation";
      input.click();

      input.addEventListener("change", function (event) {
        var files = event.target.files;
        Array.from(files).forEach(function (file) {
          if (["image/jpeg", "image/jpg", "image/png", "application/msword", "application/vnd.ms-excel", "application/vnd.ms-powerpoint", "text/plain", "application/pdf", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(file.type) && file.size <= 100 * 1024 * 1024) {
            var reader = new FileReader();

            var _BucketName = "MasterAlertPM";
            self.current_upload_row.FileName = file.name;
            try {
              var isUploadFile = true;
              var formData = new FormData();
              formData.append("File", file);
              formData.append("IsMaster", true);
              formData.append("FolderName", _BucketName);

              var uploadResponse = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("/Api/File/FileUpload", formData, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }).then(function (response) {
                self.current_upload_row.DownloadUrl = response.data.fileUrl;
                self.current_upload_row.FileInfoId = response.data.fileInfoId;
                self.current_upload_row.FileName = file.name;
                self.current_upload_row.GridFsId = response.data.gridFsId;
                self.current_upload_row.SysName = "-";
                self.current_upload_row.BucketName = _BucketName;
                self.GetDownloadFile(response.data);
              });
            } catch (error) {
              console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
            }
          } else {
            alert("กรุณาเลือกไฟล์ที่ถูกต้อง (ขนาดไม่เกิน 100MB)");
          }
        });
      });
    },
    onAddItemClick: function onAddItemClick(e) {
      this.brandsitems.push({
        Brandid: null,
        BrandName: null,
        Days: 15,
        FileUpload: null,
        ContentType: null,
        DownloadUrl: null,
        FileInfoId: null,
        FileName: null,
        GridFsId: null,
        SysName: null,
        DownloadFileUrl: null,
        BucketName: null
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.brandsitems.splice(index, 1);
      for (var i = 0; i < this.brandsitems.length; i++) {}
    },

    onApmrAgentTypeCodeChange: function onApmrAgentTypeCodeChange(obj) {

      var self = this;

      this.apmrAgentCode = null;
      $("#apmrAgentCode").val("").trigger("change");

      this.apmrShopCodes = null;
      $("#apmrShopCodes").val("").trigger("change");

      this.apmrSubAgentCode = null;
      $("#apmrSubAgentCode").val("").trigger("change");

      this.apmrSubShopCodes = null;
      $("#apmrSubShopCodes").val("").trigger("change");
    },
    onApmrAgentCodeChange: function onApmrAgentCodeChange() {

      this.apmrShopCodes = null;
      $("#apmrShopCodes").val("").trigger("change");

      this.apmrPmUserId = null;
      $("#apmrPmUserId").val("").trigger("change");
    },

    onApmrSubAgentCodeChange: function onApmrSubAgentCodeChange(id, text, data, ref) {

      var self = this;
      if (data[0] != undefined) {
        this.apmrAgentCode = data[0].data;
      }

      this.apmrPmUserId = null;
      $("#apmrPmUserId").val("").trigger("change");

      this.apmrSubShopCodes = null;
      $("#apmrSubShopCodes").val("").trigger("change");
    },
    AgentClearAfterselect: function AgentClearAfterselect() {
      var self = this;

      self.apmrShopCodes = null;
      self.apmrSubAgentCode = null;
      self.apmrSubShopCodes = null;

      $("#apmrShopCodes").val("").trigger("change");
      $("#apmrSubAgentCode").val("").trigger("change");
      $("#apmrSubShopCodes").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    SubAgentClearAfterselect: function SubAgentClearAfterselect() {
      var self = this;
      self.apmrSubShopCodes = null;

      $("#apmrSubShopCodes").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    ShopClearAfterselect: function ShopClearAfterselect() {
      var self = this;

      self.apmrSubAgentCode = null;
      self.apmrSubShopCodes = null;

      $("#apmrSubAgentCode").val("").trigger("change");
      $("#apmrSubShopCodes").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },

    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              //self.GetBrands();

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("/Api/MasterOverdueSetting/GetAlertPMConfig/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.current_id = response.data.id;
                  self.reAlertConfigType = response.data.alertTypeName;
                  self.apmrAgentCode = response.data.agentCode;
                  self.apmrSubAgentCode = response.data.suB_AGENT_CODE;
                  self.apmrShopCodes = response.data.shoP_ID;
                  self.apmrSubShopCodes = response.data.suB_SHOP_ID;

                  setTimeout(function () {

                    if (response.data.alertTypeName) {
                      self.$refs.reAlertConfigType.setSelectedData({
                        id: response.data.alertTypeName,
                        text: response.data.alertTypeName == "SHOP" ? "ประเภทร้านค้า" : "ประเภทตัวแทนจำหน่าย"
                      });
                    }
                  }, 50);
                  setTimeout(function () {

                    if (response.data.agentCode) {
                      self.$refs.apmrAgentCodeSelect2.setSelectedData({
                        id: response.data.agentCode,
                        text: "[" + response.data.agentCode + "] " + response.data.agenT_NAME
                      });
                    }
                  }, 100);
                  setTimeout(function () {

                    if (response.data.suB_AGENT_CODE) {
                      self.$refs.apmrSubAgentCodeSelect2.setSelectedData({
                        id: response.data.suB_AGENT_CODE,
                        text: "[" + response.data.suB_AGENT_CODE + "] " + response.data.suB_AGENT_NAME
                      });
                    }
                  }, 100);
                  setTimeout(function () {

                    if (response.data.shoP_ID) {
                      self.$refs.apmrShopCodesSelect2.setSelectedData({
                        id: response.data.shoP_ID,
                        text: "[" + response.data.shoP_CODE + "] " + response.data.shoP_NAME
                      });
                    }
                  }, 100);
                  setTimeout(function () {

                    if (response.data.suB_SHOP_ID) {
                      self.$refs.apmrSubShopCodesSelect2.setSelectedData({
                        id: response.data.suB_SHOP_ID,
                        text: "[" + response.data.suB_SHOP_CODE + "] " + response.data.suB_SHOP_NAME
                      });
                    }
                  }, 100);

                  $.each(response.data.brandFiles, function (key, brand) {
                    self.brandsitems.push({
                      Brandid: brand.brandid,
                      BrandName: brand.brandName,
                      Days: brand.days,
                      FileUpload: brand.fileUpload,
                      ContentType: brand.contentType,
                      DownloadUrl: brand.downloadUrl,
                      FileInfoId: brand.fileInfoId,
                      FileName: brand.fileName,
                      GridFsId: brand.gridFsId,
                      SysName: brand.sysName,
                      DownloadFileUrl: brand.downloadFileUrl,
                      BucketName: brand.bucketName
                    });
                  });
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลตัวแทนจำหน่ายที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลตัวแทนจำหน่ายได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              //set Current Year
              _this.bcYear = new Date();
              $(_this.$refs.form).validate({
                rules: {
                  apmrAgentCode: "required",
                  reAlertConfigType: "required"

                },
                messages: {
                  apmrAgentCode: "กรุณาระบุตัวแทนจำหน่อย",
                  reAlertConfigType: "กรุณาระบุประเภทการตั้งค่าข้อมูลวัน Alert PM"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_plupload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */]
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var self = this;

    return {

      uuid: null
      // brandidOptions: {
      //   placeholder: "กรุณาเลือกแบรนด์",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Report/PM/ProductBrandOptions",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) { 
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more
      //         }
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     }
      //   }
      // },

    };
  },


  computed: {
    totalCal: function totalCal() {
      return this.item.odcTotal = this.item.odcQuantity * this.item.odcPrice;
    }
  },
  methods: {
    removeFile: function removeFile() {
      var _this = this;

      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then(function (result) {
        if (result.value) {
          setTimeout(function () {
            // ล้างค่าที่เกี่ยวกับไฟล์ออกจาก item
            _this.item.FileInfoId = '';
            _this.item.GridFsId = '';
            _this.item.FileName = '';
            _this.item.DownloadFileUrl = '';
            _this.item.DownloadUrl = '';

            Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
          }, 500);
        }
      });
    },
    onRemoveItemClick: function onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    },
    doUpload: function doUpload(row, rowIndex) {

      var self = this;
      this.$parent.doUploadClick(self.item);
    },
    OpenFileUpload: function OpenFileUpload(url) {

      alert(url);
      // Object.assign(document.createElement('a'), {
      //  // target: '_blank',
      //   download : 'download',
      //   rel: 'noopener noreferrer',
      //   href: url,
      // }).click();
    }
  },
  mounted: function mounted() {

    $(".required", this.$el).each(function () {
      var $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required")
        }
      });
    });
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);
var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#brandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BudgetBrand/" + _this.data.budgetId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#brandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BudgetBrand/" + _this2.data.budgetId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var BudgetBrandActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"deleteItem\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/AlertPMConfig/Edit/" + this.data.id
      });
    },
    deleteItem: function deleteItem() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูล ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูล <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/MasterOverdueSetting/" + _this3.data.id + "/DeleteAlertPMConfig").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref;

    var self = this;
    return _ref = {
      pmrAgentCodes: [],
      pmrShopCodes: [],
      pmrInActiveStatus: null,
      pmrRouteName: null,
      pmrPmUserId: [],

      pmrSubAgentCodes: [],
      pmrSubAgentCodeOptions: [],
      pmrSubAgentShopCodes: [],
      pmrSubAgentShopCodesOptions: [],

      rePMBrand: [],
      rePMBrandOptions: [],
      rePMPMBrandOptions: [],
      reAlertConfigTypeOptions: [],
      reAlertConfigType: []

    }, _defineProperty(_ref, "reAlertConfigTypeOptions", [{
      id: "ALL",
      label: "ทั้งหมด"
    }, {
      id: "ประเภทตัวแทนจำหน่าย",
      label: "ประเภทตัวแทนจำหน่าย"
    }, {
      id: "ประเภทร้านค้า",
      label: "ประเภทร้านค้า"
    }]), _defineProperty(_ref, "pmrAgentCodesOptions", []), _defineProperty(_ref, "pmrShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Shop/Select2ShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "pmrSubAgentShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      //pmrSubAgentCodes
      ajax: {
        url: "/Api/Shop/SubShopOptionAlertReport",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            shopCodes: self.pmrSubAgentCodes,
            search: params.term,
            page: params.page || 1,
            all: true
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "pmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            shopCodes: self.pmrShopCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.pmrAgentCodes = [];
      self.pmrShopCodes = [];
      self.pmrSubAgentCodes = [];
      self.pmrSubAgentShopCodes = [];
      self.reAlertConfigType = [];
      self.rePMBrand = [];

      $("#pmrAgentCodes").val("").trigger("change");

      $("#pmrShopCodes").val("").trigger("change");

      $("#rePMBrand").val("").trigger("change");

      $("#reAlertConfigType").val("").trigger("change");

      $("#pmrSubAgentCodes").val("").trigger("change");

      $("#pmrSubAgentShopCodes").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#brandTable").DataTable();
      table.search(this.equipment);
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#brandTable").DataTable().ajax.reload(null, resetPaging);
    },
    CheckRoute: function CheckRoute() {
      var url = this.$route.path;
      console.log(this.$route.params.id);
      if (url == "/Master/AlertPMConfig/Edit/" + this.$root.$route.params.id) return false;else if (url == "/Master/AlertPMConfig/Add") return false;else return true;
    },

    LoadpmrAgentCodesOptions: function LoadpmrAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM", {
        province_id: [],
        department: [],
        agentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.pmrAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMBrandOptions: function LoadrePMBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Report/PM/ProductBrandOptions", {
        params: {
          page: 1,
          // productTypeId: 6,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMBrandOptions.push({
              id: element.data,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    AgentClearAfterselect: function AgentClearAfterselect() {
      var self = this;

      self.pmrShopCodes = [];
      self.pmrSubAgentCodes = [];
      self.pmrSubAgentShopCodes = [];

      $("#pmrShopCodes").val("").trigger("change");
      $("#pmrSubAgentCodes").val("").trigger("change");
      $("#pmrSubAgentShopCodes").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    SubAgentClearAfterselect: function SubAgentClearAfterselect() {
      var self = this;
      self.pmrSubAgentShopCodes = [];

      $("#pmrSubAgentShopCodes").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    ShopClearAfterselect: function ShopClearAfterselect() {
      var self = this;

      self.pmrSubAgentCodes = [];
      self.pmrSubAgentShopCodes = [];

      $("#pmrSubAgentCodes").val("").trigger("change");
      $("#pmrSubAgentShopCodes").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },

    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;

              //default Active Data

              self.LoadpmrAgentCodesOptions();
              self.LoadrePMBrandOptions();

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#brandTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/MasterOverdueSetting/AlertPMConfigSearch",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      AgentCodes: self.pmrAgentCodes,
                      ShopIds: self.pmrShopCodes,
                      SubAgentCodes: self.pmrSubAgentCodes,
                      SubAgentShopIds: self.pmrSubAgentShopCodes,
                      BrandIds: self.rePMBrand,
                      AlertTypes: self.reAlertConfigType
                    }));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings

                order: [[0, "desc"]],
                columns: [{ data: "agentCode" }, { data: "agenT_NAME" }, { data: "suB_AGENT_NAME" }, { data: "shoP_CODE" }, { data: "shoP_NAME" }, { data: "shoP_NAME2" }, { data: "brands" }, { data: "alertType" }, {
                  data: "id",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(['super_admin', 'MANAGE_MASTER', 'MANAGE_SETTING']);
                    if (data.inActiveStatus == false) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == true) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(['super_admin', 'MANAGE_MASTER', 'MANAGE_SETTING']);
                    data.showDeleteButton = self.$root.canShow(['super_admin', 'MANAGE_MASTER', 'MANAGE_SETTING']);
                    new BudgetBrandActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              table.trigger("draw.dt"); //call ajax delete this row

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */]
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var self = this;

    return {
      aAgent: self.item.aAgentRow,
      aAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    onAgentChange: function onAgentChange(id, text, data, ref) {
      this.item.aAgentRow = this.aAgent;
      this.item.selectedAgentRow = {
        id: data[0].id,
        text: data[0].text
      };
    },
    onRemoveAItemClick: function onRemoveAItemClick(e) {
      var self = this;
      self.$emit("removeItem", self.rowIndex, self.item);
    },
    detail: function detail() {
      var self = this;
      if (self.aAgent != null) {
        if (self.$parent.edit) __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
          path: "/Master/Approver/Edit/" + self.$parent.uaApproveGroupID + "/Agent/" + self.aAgent
        });else __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
          path: "/Master/Approver/Add/Agent/" + self.aAgent
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกตัวแทนจำหน่าย", "error");
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      apAgentCode: null,
      apAgentName: null,
      apAdress: null,
      apArea: null,
      apProvince: null,
      apTel: null,
      apEmail: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Agents/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.apAgentCode = response.data.agentCodeSap;
                  self.apAgentName = response.data.agentName;
                  self.apAdress = response.data.address;
                  self.apArea = response.data.department;
                  self.apProvince = response.data.provinceName;
                  self.apTel = response.data.tel;
                  self.apEmail = response.data.email;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลตัวแทนจำหน่ายที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลตัวแทนจำหน่ายได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });
              $("#SearchDetailModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                //self.$parent.reloadDataTable(false);
              }).modal("show");

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      aeEmployeeNO: null,
      aeEmployeeName: null,
      aeTel: null,
      aeEmail: null,
      aePosition: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Employee/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.aeEmployeeNO = response.data.empNo;
                  self.aeEmployeeName = response.data.firstNameTH + "  " + response.data.lastNameTH;
                  self.aeTel = response.data.officeTel;
                  self.aeEmail = response.data.email;
                  self.aePosition = response.data.positionName;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลตัวแทนจำหน่ายที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลตัวแทนจำหน่ายได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });
              $("#SearchDetailModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                //self.$parent.reloadDataTable(false);
              }).modal("show");

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */]
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var self = this;

    return {
      apUser: self.item.apUserRow,
      apLevel: self.item.apLevelRow,
      apEdit: self.item.apEditRow,
      apApproveRow: self.item.apApproveRow,
      apUserOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Users/Select2User",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      apLevelOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        minimumResultsForSearch: -1,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "APPROVE_LEVEL",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      apEditOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        minimumResultsForSearch: -1,
        data: [{ id: true, text: "มี" }, { id: false, text: "ไม่มี" }]
      },
      apApproveOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        minimumResultsForSearch: -1,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "APPROVE_ROLE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    onUserChange: function onUserChange(id, text, data, ref) {
      this.item.apUserRow = this.apUser;
      this.item.selectedUserRow = {
        id: data[0].id,
        text: data[0].text
      };
    },
    onLevelChange: function onLevelChange(id, text, data, ref) {
      var self = this;
      var $id = "#apEditId" + self._uid;
      if (text == "APPROVE_LEVEL_2") {
        $($id).val("true").trigger("change");
      } else {
        $($id).val("false").trigger("change");
      }
      this.item.apEditRow = this.apEdit;
      this.item.apLevelRow = this.apLevel;
      this.item.selectedLevelRow = {
        id: data[0].id,
        text: data[0].text
      };
    },
    onEditChange: function onEditChange(id, text, data, ref) {
      this.item.apEditRow = this.apEdit;
      this.item.selectedEditRow = {
        id: data[0].id,
        text: data[0].text
      };
    },
    onApproveChange: function onApproveChange(id, text, data, ref) {
      this.item.apApproveRow = this.apApproveRow;
      this.item.selectedApproveRow = {
        id: data[0].id,
        text: data[0].text
      };
    },
    onRemoveAPItemClick: function onRemoveAPItemClick(e) {
      var self = this;
      self.$emit("removeItem", self.rowIndex, self.item);
    },
    detail: function detail() {
      var self = this;
      console.log(self.apUser);
      if (self.apUser != null) {
        if (self.$parent.edit) __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
          path: "/Master/Approver/Edit/" + self.$parent.uaApproveGroupID + "/User/" + self.apUser
        });else __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
          path: "/Master/Approver/Add/User/" + self.apUser
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกพนักงาน", "error");
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);
var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#approverTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Approver/" + _this.data.requestHeaderId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#approverTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Approver/" + _this2.data.requestHeaderId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var ApproverActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editApprover\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n     <a href=\"#\" @click.prevent=\"deleteApprover\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    editApprover: function editApprover() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/Approver/Edit/" + this.data.requestHeaderId
      });
    },
    deleteApprover: function deleteApprover() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลผู้อนุมัติการเบิกยืมสินค้า",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลผู้อนุมัติการเบิกยืมสินค้า <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลผู้อนุมัติการเบิกยืมสินค้านี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลผู้อนุมัติการเบิกยืมสินค้าออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Approver/" + _this3.data.requestHeaderId + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      aplSearch: null,
      // aplEmpId: null,
      // aplAgentCode: null,
      // aplApprover: null,
      aplEmpId: [],
      aplAgentCode: [],
      aplApprover: [],
      aplInActiveStatus: null,
      // Configurations
      aplEmpIdOptions: [],
      // aplEmpIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Employee/Select2Employee",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more
      //         }
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     }
      //   }
      // },
      aplAgentCodeOptions: [],
      // aplAgentCodeOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchAgentName",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: [],
      //         province_id: [],
      //         page: params.page || 1
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more
      //         }
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     }
      //   }
      // },
      aplApproverOptions: [],
      // aplApproverOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Users/Select2User",
      //     data: function(params) {
      //       var query = {
      //         userId: "",
      //         search: params.term,
      //         page: params.page || 1
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more
      //         }
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     }
      //   }
      // },
      aplInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    LoadaplEmpIdOptions: function LoadaplEmpIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.aplEmpIdOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Employee/Select2Employee", {
          params: { page: 1, all: true, search: searchQuery }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.aplEmpIdOptions = [];
            data.forEach(function (element) {
              self.aplEmpIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.aplEmpIdOptions);
        }).catch(function (error) {});
      }
    },

    LoadaplAgentCodeOptions: function LoadaplAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Agents/Select2SearchAgentName", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.aplAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadaplApproverOptions: function LoadaplApproverOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Users/Select2User", {
        page: 1,
        all: true,
        userId: ""
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.aplApproverOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    formReset: function formReset(e) {
      var self = this;
      self.aplSearch = null;
      this.aplEmpId = [];
      this.aplAgentCode = [];
      this.aplApprover = [];
      // $("#aplAgentCode")
      //   .val("")
      //   .trigger("change");

      // $("#aplEmpId")
      //   .val("")
      //   .trigger("change");

      // $("#aplApprover")
      //   .val("")
      //   .trigger("change");

      //default Active Data
      this.aplInActiveStatus = false;
      $("#aplInActiveStatus").val(this.aplInActiveStatus + "").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#approverTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#approverTable").DataTable().ajax.reload(null, resetPaging);
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;


              self.LoadaplAgentCodeOptions();
              self.LoadaplApproverOptions();
              //default Active Data
              self.aplInActiveStatus = false;
              $("#aplInActiveStatus").val(self.aplInActiveStatus + "").trigger("change");

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#approverTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Approver/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      AgentCode: self.aplAgentCode,
                      EmpId: self.aplEmpId,
                      Approver: self.aplApprover,
                      SearchKeyword: self.aplSearch,
                      InActiveStatus: self.aplInActiveStatus
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "asc"]],
                columns: [{
                  data: "requestHeaderId",
                  width: "20%",
                  className: "text-center"
                }, { data: "approveGroup", className: "text-center" }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "requestHeaderId",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_APPROVER"]);
                    if (data.inActiveStatus == 0) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_APPROVER"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_APPROVER"]);
                    new ApproverActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      auUserNO: null,
      auUserName: null,
      auTel: null,
      auEmail: null,
      auPosition: null,
      auCompany: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Users/GetUser/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.auUserNO = response.data.employeeCode;
                  self.auUserName = response.data.displayName;
                  self.auTel = response.data.phoneNumber;
                  self.auEmail = response.data.email;
                  self.auPosition = response.data.position;
                  self.auCompany = response.data.companyProfileName;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลผู้อนุมัติที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลผู้อนุมัติได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });
              $("#SearchDetailModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                //self.$parent.reloadDataTable(false);
              }).modal("show");

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */]
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var self = this;

    return {
      brtEmployee: self.item.brtEmployeeRow,
      brtEmployeeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    onEmployeeChange: function onEmployeeChange(id, text, data, ref) {
      this.item.brtEmployeeRow = this.brtEmployee;
      this.item.selectedEmployeeRow = {
        id: data[0].id,
        text: data[0].text
      };
    },
    onRemoveBRTItemClick: function onRemoveBRTItemClick(e) {
      var self = this;
      self.$emit("removeItem", self.rowIndex, self.item);
    },
    detail: function detail() {
      var self = this;
      if (self.brtEmployee != null) {
        if (self.$parent.edit) __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
          path: "/Master/Approver/Edit/" + self.$parent.uaApproveGroupID + "/Employee/" + self.brtEmployee
        });else __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
          path: "/Master/Approver/Add/Employee/" + self.brtEmployee
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกพนักงาน", "error");
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AgentItemRow__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BRTItemRow__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApproverItemRow__ = __webpack_require__(620);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    aItemRow: __WEBPACK_IMPORTED_MODULE_3__AgentItemRow__["a" /* default */],
    brtItemRow: __WEBPACK_IMPORTED_MODULE_4__BRTItemRow__["a" /* default */],
    apItemRow: __WEBPACK_IMPORTED_MODULE_5__ApproverItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      edit: false,
      aItems: [],
      aItemsTemp: [],
      brtItems: [],
      brtItemsTemp: [],
      apItems: [],
      apItemsTemp: [],
      caApproveGroup: null,
      caRemark: null,
      caInActiveStatus: true,
      i: 0
    };
  },
  methods: {
    onAddAItemClick: function onAddAItemClick(e) {
      this.aItems.push({
        aAgentRow: null,
        selectedAgentRow: null
      });
    },
    onAddBrtItemClick: function onAddBrtItemClick(e) {
      this.brtItems.push({
        brtEmployeeRow: null,
        selectedEmployeeRow: null
      });
    },
    onAddapItemClick: function onAddapItemClick(e) {
      this.apItems.push({
        apUserRow: null,
        apLevelRow: null,
        apEditRow: null,
        apApproveRow: null,
        selectedUserRow: null,
        selectedLevelRow: null,
        selectedEditRow: null,
        selectedApproveRow: null
      });
    },
    onRemoveAItemClick: function onRemoveAItemClick(index, delItem) {
      var self = this;
      self.aItemsTemp = self.aItems;
      self.aItems = [];
      self.aItemsTemp.splice(index, 1);
      setTimeout(function () {
        self.aItems = self.aItemsTemp;

        setTimeout(function () {
          for (var i = 0; i < self.aItems.length; i++) {
            /*=== Status : Set Selected Select2=== */
            self.$refs.aItems[i].$refs.aAgent.setSelectedData(self.aItems[i].selectedAgentRow);
          }
        }, 50);
      }, 50);
    },
    onRemoveBRTItemClick: function onRemoveBRTItemClick(index, delItem) {
      var self = this;
      self.brtItemsTemp = self.brtItems;
      self.brtItems = [];
      this.brtItemsTemp.splice(index, 1);
      setTimeout(function () {
        self.brtItems = self.brtItemsTemp;

        setTimeout(function () {
          for (var i = 0; i < self.brtItems.length; i++) {
            /*=== Status : Set Selected Select2=== */
            self.$refs.brtItems[i].$refs.brtEmployee.setSelectedData(self.brtItems[i].selectedEmployeeRow);
          }
        }, 50);
      }, 50);
    },
    onRemoveAPItemClick: function onRemoveAPItemClick(index, delItem) {
      var self = this;
      self.apItemsTemp = self.apItems;
      self.apItems = [];
      this.apItemsTemp.splice(index, 1);
      setTimeout(function () {
        self.apItems = self.apItemsTemp;

        setTimeout(function () {
          for (var i = 0; i < self.apItems.length; i++) {
            /*=== Status : Set Selected Select2=== */
            self.$refs.apItems[i].$refs.apUser.setSelectedData(self.apItems[i].selectedUserRow);

            self.$refs.apItems[i].$refs.apLevel.setSelectedData(self.apItems[i].selectedLevelRow);

            self.$refs.apItems[i].$refs.apEdit.setSelectedData(self.apItems[i].selectedEditRow);

            self.$refs.apItems[i].$refs.apApprove.setSelectedData(self.apItems[i].selectedApproveRow);
          }
        }, 50);
      }, 50);
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }
      if (self.aItems.length + self.brtItems.length <= 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกพนักงานหรือตัวแทนจำหน่ายอย่างน้อย 1 คน", "error");
        return false;
      }
      var listApItems = [];
      self.apItems.forEach(function (element) {
        listApItems.push(element.apLevelRow);
      });
      if (!listApItems.includes("APPROVE_LEVEL_1")) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกสายงานอนุมัติลำดับที่ 1", "error");
        return false;
      } else if (!listApItems.includes("APPROVE_LEVEL_2") && listApItems.includes("APPROVE_LEVEL_3")) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกสายงานอนุมัติลำดับที่ 2", "error");
        return false;
      }
      var caItems = [];
      var cbrtItems = [];
      var capItems = [];
      var orderAgent = 1;
      var orderEmp = 1;
      var orderApprove = 1;
      self.aItems.forEach(function (element) {
        caItems.push({
          AgentCode: element.aAgentRow,
          OrderId: orderAgent
        });
        orderAgent = orderAgent + 1;
      });
      self.brtItems.forEach(function (element) {
        cbrtItems.push({
          EmpID: element.brtEmployeeRow,
          OrderId: orderEmp
        });
        orderEmp = orderEmp + 1;
      });
      self.apItems.forEach(function (element) {
        capItems.push({
          UserId: element.apUserRow,
          Level: element.apLevelRow,
          IsEdit: element.apEditRow,
          Role: element.apApproveRow,
          OrderId: orderApprove
        });
        orderApprove = orderApprove + 1;
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/Approver",
        data: {
          ApproveGroup: self.caApproveGroup,
          Remark: self.caRemark,
          Agents: caItems,
          Emps: cbrtItems,
          ApproverItems: capItems,
          InActiveStatus: !this.caInActiveStatus
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              // set validation rules
              $(self.$refs.form).validate({
                rules: {
                  caApproveGroup: "required"
                },
                messages: {
                  caApproveGroup: "กรุณากรอกชื่อกลุ่ม"
                }
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AgentItemRow__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BRTItemRow__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApproverItemRow__ = __webpack_require__(620);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    aItemRow: __WEBPACK_IMPORTED_MODULE_3__AgentItemRow__["a" /* default */],
    brtItemRow: __WEBPACK_IMPORTED_MODULE_4__BRTItemRow__["a" /* default */],
    apItemRow: __WEBPACK_IMPORTED_MODULE_5__ApproverItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      edit: true,
      aItems: [],
      aItemsTemp: [],
      brtItems: [],
      brtItemsTemp: [],
      apItems: [],
      apItemsTemp: [],
      uaApproveGroupID: null,
      uaApproveGroup: null,
      uaRemark: null,
      uaInActiveStatus: true,
      i: 0
    };
  },
  methods: {
    onAddAItemClick: function onAddAItemClick(e) {
      this.aItems.push({
        aAgentRow: null,
        selectedAgentRow: null,
        aAgentId: null
      });
    },
    onAddBrtItemClick: function onAddBrtItemClick(e) {
      console.log("onAddBrtItemClick");
      this.brtItems.push({
        brtEmployeeRow: null,
        selectedEmployeeRow: null,
        brtEmployeeId: null
        //order: this.brtItems.length + 1
      });
      console.log(this.brtItems);
    },
    onAddapItemClick: function onAddapItemClick(e) {
      this.apItems.push({
        apApproveId: null,
        apUserRow: null,
        apLevelRow: null,
        apEditRow: null,
        apApproveRow: null,
        selectedUserRow: null,
        selectedLevelRow: null,
        selectedEditRow: null,
        selectedApproveRow: null
      });
    },
    onRemoveAItemClick: function onRemoveAItemClick(index, delItem) {
      var self = this;
      self.aItemsTemp = self.aItems;
      self.aItems = [];
      self.aItemsTemp.splice(index, 1);
      setTimeout(function () {
        self.aItems = self.aItemsTemp;

        setTimeout(function () {
          for (var i = 0; i < self.aItems.length; i++) {
            /*=== Status : Set Selected Select2=== */
            self.$refs.aItems[i].$refs.aAgent.setSelectedData(self.aItems[i].selectedAgentRow);
          }
        }, 50);
      }, 50);
    },
    onRemoveBRTItemClick: function onRemoveBRTItemClick(index, delItem) {
      var self = this;
      self.brtItemsTemp = self.brtItems;
      self.brtItems = [];
      this.brtItemsTemp.splice(index, 1);
      setTimeout(function () {
        self.brtItems = self.brtItemsTemp;

        setTimeout(function () {
          for (var i = 0; i < self.brtItems.length; i++) {
            /*=== Status : Set Selected Select2=== */
            self.$refs.brtItems[i].$refs.brtEmployee.setSelectedData(self.brtItems[i].selectedEmployeeRow);
          }
        }, 50);
      }, 50);
    },
    onRemoveAPItemClick: function onRemoveAPItemClick(index, delItem) {
      var self = this;
      self.apItemsTemp = self.apItems;
      self.apItems = [];
      this.apItemsTemp.splice(index, 1);
      setTimeout(function () {
        self.apItems = self.apItemsTemp;

        setTimeout(function () {
          for (var i = 0; i < self.apItems.length; i++) {
            /*=== Status : Set Selected Select2=== */
            self.$refs.apItems[i].$refs.apUser.setSelectedData(self.apItems[i].selectedUserRow);

            self.$refs.apItems[i].$refs.apLevel.setSelectedData(self.apItems[i].selectedLevelRow);

            self.$refs.apItems[i].$refs.apEdit.setSelectedData(self.apItems[i].selectedEditRow);

            self.$refs.apItems[i].$refs.apApprove.setSelectedData(self.apItems[i].selectedApproveRow);
          }
        }, 50);
      }, 50);
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }
      if (self.aItems.length + self.brtItems.length <= 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกพนักงานหรือตัวแทนจำหน่ายอย่างน้อย 1 คน", "error");
        return false;
      }
      var listApItems = [];
      self.apItems.forEach(function (element) {
        listApItems.push(element.apLevelRow);
      });
      if (!listApItems.includes("APPROVE_LEVEL_1")) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกสายงานอนุมัติลำดับที่ 1", "error");
        return false;
      } else if (!listApItems.includes("APPROVE_LEVEL_2") && listApItems.includes("APPROVE_LEVEL_3")) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกสายงานอนุมัติลำดับที่ 2", "error");
        return false;
      }
      var uaItems = [];
      var cbrtItems = [];
      var uapItems = [];
      var orderAgent = 1;
      var orderEmp = 1;
      var orderApprove = 1;
      self.aItems.forEach(function (element) {
        uaItems.push({
          AgentItemID: element.aAgentId,
          AgentCode: element.aAgentRow,
          OrderId: orderAgent
        });
        orderAgent = orderAgent + 1;
      });
      self.brtItems.forEach(function (element) {
        cbrtItems.push({
          EmpItemID: element.brtEmployeeId,
          EmpID: element.brtEmployeeRow,
          OrderId: orderEmp
        });
        orderEmp = orderEmp + 1;
      });
      self.apItems.forEach(function (element) {
        uapItems.push({
          UserId: element.apUserRow,
          Level: element.apLevelRow,
          IsEdit: element.apEditRow,
          Role: element.apApproveRow,
          ApproveItemID: element.apApproveId,
          OrderId: orderApprove
        });
        orderApprove = orderApprove + 1;
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "put",
        url: "/Api/Approver",
        data: {
          RequestHeaderId: self.uaApproveGroupID,
          ApproveGroup: self.uaApproveGroup,
          Remark: self.uaRemark,
          Agents: uaItems,
          Emps: cbrtItems,
          ApproverItems: uapItems,
          InActiveStatus: !this.uaInActiveStatus
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  computed: {},

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Approver/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  if (response.data != null) {
                    self.uaApproveGroup = response.data.approveGroup;
                    self.uaRemark = response.data.remark;
                    self.uaApproveGroupID = response.data.requestHeaderId;
                    self.uaInActiveStatus = !response.data.inActiveStatus;
                    if (response.data.agents.length > 0) {
                      var _loop = function _loop(i) {
                        item = response.data.agents[i];

                        self.aItems.push({
                          aAgentRow: item.code,
                          aAgentId: item.agetItemID,
                          selectedAgentRow: {
                            id: item.code,
                            text: item.name
                          }
                        });
                        setTimeout(function () {
                          self.$refs.aItems[i].$refs.aAgent.setSelectedData(self.aItems[i].selectedAgentRow);
                        }, 100);
                      };

                      for (var i = 0; i < response.data.agents.length; i++) {
                        var item;

                        _loop(i);
                      }
                    }
                    if (response.data.emps.length > 0) {
                      var _loop2 = function _loop2(i) {
                        item = response.data.emps[i];

                        self.brtItems.push({
                          brtEmployeeRow: item.id,
                          brtEmployeeId: item.empItemID,
                          selectedEmployeeRow: {
                            id: item.id,
                            text: item.fullName
                          }
                          //order: item.order
                        });
                        setTimeout(function () {
                          self.$refs.brtItems[i].$refs.brtEmployee.setSelectedData(self.brtItems[i].selectedEmployeeRow);
                        }, 100);
                      };

                      for (var i = 0; i < response.data.emps.length; i++) {
                        var item;

                        _loop2(i);
                      }
                    }
                    if (response.data.approverItems.length > 0) {
                      var _loop3 = function _loop3(i) {
                        item = response.data.approverItems[i];
                        selectedEditRowText = "";

                        self.apItems.push({
                          apUserRow: item.userId,
                          apApproveId: item.approveID,
                          selectedUserRow: {
                            id: item.userId,
                            text: item.userFullName
                          },
                          apLevelRow: item.level,
                          selectedLevelRow: {
                            id: item.level,
                            text: item.levelName
                          },
                          apEditRow: item.isEdit,

                          // selectedEditRow: {
                          //   id: item.isEdit,
                          //   text: isEdite
                          // },
                          apApproveRow: item.role,
                          selectedApproveRow: {
                            id: item.role,
                            text: item.roleName
                          }
                        });

                        setTimeout(function () {
                          self.$refs.apItems[i].$refs.apUser.setSelectedData(self.apItems[i].selectedUserRow);
                          self.$refs.apItems[i].$refs.apLevel.setSelectedData(self.apItems[i].selectedLevelRow);

                          $(self.$refs.apItems[i].$refs.apEdit.$el).val(self.apItems[i].apEditRow + "").trigger("change");

                          self.$refs.apItems[i].$refs.apApprove.setSelectedData(self.apItems[i].selectedApproveRow);
                        }, 100);
                      };

                      for (var i = 0; i < response.data.approverItems.length; i++) {
                        var item;
                        var selectedEditRowText;

                        _loop3(i);
                      }
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              // set validation rules
              $(self.$refs.form).validate({
                rules: {
                  uaApproveGroup: "required"
                },
                messages: {
                  uaApproveGroup: "กรุณากรอกชื่อกลุ่ม"
                }
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Datepicker__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1__Shared_Datepicker__["a" /* default */] },
  data: function data() {
    return {
      // userName: null,
      // password: null,
      // confirmPassword: null,
      // email: null,
      // givenName: null,
      // familyName: null,
      // position: null,
      // phoneNumber: null,
      // roleName: null
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$("#holdCreateModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Users/Create", {
        userName: this.userName,
        password: this.password,
        confirmPassword: this.confirmPassword,
        email: this.email,
        givenName: this.givenName,
        familyName: this.familyName,
        position: this.position,
        phoneNumber: this.phoneNumber,
        roleName: this.roleName
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $("#holdCreateModal").modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              $("#ProductType").select2({
                tags: true,
                placeholder: "กรุณาเลือก",
                allowClear: true
              });
              $("#ProductName").select2({
                tags: true,
                placeholder: "กรุณาเลือก",
                allowClear: true
              });

              // set validation rules
              $("#holdCreateModal form").validate({
                // rules: {
                //   userName: "required",
                //   email: {
                //     required: true,
                //     email: true
                //   },
                //   password: {
                //     required: true,
                //     minlength: 6
                //   },
                //   confirmPassword: {
                //     equalTo: "#password"
                //   },
                //   givenName: "required",
                //   familyName: "required",
                //   phoneNumber: "required"
                // },
                // messages: {
                //   userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
                //   email: {
                //     required: "กรุณากรอกอีเมล",
                //     email: "กรุณากรอกอีเมลให้ถูกต้อง"
                //   },
                //   password: {
                //     required: "กรุณากรอกรหัสผ่าน",
                //     minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร"
                //   },
                //   confirmPassword: {
                //     equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง"
                //   },
                //   givenName: "กรุณากรอกชื่อ",
                //   familyName: "กรุณากรอกชื่อสกุล",
                //   phoneNumber: "กรุณากรอกเบอร์โทรศัพท์"
                // }
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dbBarcode: null,
      dbMaterial: null,
      dbAssetCode: null,
      dbAssetOwner: null,
      dbNfc: null,
      dbRefcode: null,
      dbProductType: null,
      dbProduct: null,
      dbStautsProduct: null,
      dbLocation: null,
      dbStartDate: null,
      dbLongDate: null,
      dbOwner: null,
      dbBarcodeOld: null,
      dbBarcodeCL: null,
      dbLeasedAssets: null,
      dbSupplier: null,
      dbExprie: null,
      dbBeerDetail: null,
      dbBarcodeYear: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Barcode/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  // console.log(response);
                  self.dbBarcode = response.data.barcodeNo;
                  self.dbMaterial = response.data.materialCode;
                  self.dbAssetCode = response.data.accountMaterialCode;
                  self.dbAssetOwner = response.data.departmentMaterialCode;
                  self.dbNfc = response.data.nfcCode;
                  self.dbRefcode = response.data.refCode;
                  self.dbProductType = response.data.productTypeName;
                  self.dbProduct = response.data.materialDesc;
                  self.dbBarcodeOld = response.data.barcodeIdOld;
                  self.dbBarcodeCL = response.data.barcodeCooling;
                  self.dbStartDate = response.data.warrantyStartDateS;
                  self.dbLongDate = response.data.warrantyTime;
                  self.dbLeasedAssets = response.data.isLeasedAssets == 1 ? 'ทรัพย์สินเช่า' : 'ทรัพย์สินบริษัท';
                  self.dbOwner = response.data.assetOwnerName;
                  self.dbSupplier = response.data.supplierName;
                  self.dbExprie = response.data.exprie;
                  self.dbBeerDetail = response.data.beerDetail;
                  self.dbBarcodeYear = response.data.barcodeYear;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลตัวแทนจำหน่ายที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลตัวแทนจำหน่ายได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#detailTable");
              //begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Barcode/SearchHistory",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      BarcodeId: self.$route.params.id
                    }));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n      <'row'<'col-sm-12'tr>>\n    \t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[5, "desc"]],

                columns: [{
                  data: "jobDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.jobDateText;
                  }
                }, { data: "jobNO", className: "text-center" }, { data: "destination", className: "text-center" }, { data: "barcodeStatueName", className: "text-center" }, { data: "scanBy", className: "text-center" }, {
                  data: "scanDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.scanDateText;
                  }
                }, { data: "jobTypeName", className: "text-center" }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_2__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

              $("#SearchDetailModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                //self.$parent.reloadDataTable(false);
              }).modal("show");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import the component

// import the styles



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      DlbRefno: [],
      DlbRefnoOptions: [],
      DlbOldBarcode: ""
    };
  },
  methods: {
    LoadDlbRefnoOptions: function LoadDlbRefnoOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.DlbRefnoOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Barcode/Select2RefCode", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.DlbRefnoOptions = [];
            data.forEach(function (element) {
              self.DlbRefnoOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.DlbRefnoOptions);
        }).catch(function (error) {});
      }
    },

    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (this.DlbOldBarcode == "" && this.DlbRefno.length == 0) {
        Swal.fire("", "กรุณาระบุข้อมูล BARCODE หรือ รหัสอ้างอิง", "warning");
        return false;
      }

      if (!$("#downloadBarcodeModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/Barcode/Download",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: null,
          ProductTypeId: [],
          AssetOwnerId: [],
          WarrantyTime: null,
          RefCode: this.DlbRefno,
          OldBarcode: this.DlbOldBarcode
        }
      }).then(function (response) {
        if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
          return false;
        }
        var filename = "";
        var contentType = response.headers["content-type"];
        var disposition = response.headers["content-disposition"];

        //===Get Filename===
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        //Save file
        var blob = new Blob([response.data], { type: contentType });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        $("#DlbRefno").val("").trigger("change");
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              // set validation rules
              $("#downloadBarcodeModal form").validate({
                rules: { DlbRefno: "required" },
                messages: { DlbRefno: "กรุณาเลือกรหัสอ้างอิง" }
              });

              $("#downloadBarcodeModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                // self.$parent.reloadDataTable(false);
              }).modal("show");

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(141);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      DatePickerFormat: "yyyy",
      isGenBarcode: false,
      ebBarcodeOld: null,
      ebDepartmentMaterialCode: null,
      ebBarcodeYear: 0,
      showDatePicker: false,
      ebAccountMaterialCode: null,
      ebBarcodeCL: null,
      ebAssetCode: null,
      ebAssetCodeOptions: [],
      ebAssetOwnerId: null,
      ebAssetOwnerOptions: [],
      ebSupplierId: null,
      ebSupplierOptions: [],
      ebWarrantyStartDate: null,
      ebWarrantyTime: null,
      ebExprie: null,
      ebIsLeasedAssets: null,
      ebIsLeasedAssetsOptions: []
    };
  },
  methods: {
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    validateYearInput: function validateYearInput(event) {
      var value = event.target.value.replace(/\D/g, ""); // เอาเฉพาะตัวเลข
      this.ebBarcodeYear = value.slice(0, 4); // จำกัดให้พิมพ์ได้สูงสุด 4 ตัว
    },
    LoadebMaterialCodeOptions: function LoadebMaterialCodeOptions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/product/Select2ProductReport", {
                  page: 1,
                  all: true,
                  search: "",
                  ExcludeProductGroupId: 14
                });

              case 3:
                _response = _context.sent;

                if (_response.status === 200) {
                  _this.ebAssetCodeOptions = _response.data.results.map(function (item) {
                    return {
                      id: item.id,
                      label: item.text
                    };
                  });
                }
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.error("Error loading product data:", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },

    LoadebAssetOwnerOptions: function LoadebAssetOwnerOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/assetOwner/Select2SearchAssetOwner", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.ebAssetOwnerOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadebSupplierIdOptions: function LoadebSupplierIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Vendors/Select2Vendor", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.ebSupplierOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadLeasedAssetsOptions: function LoadLeasedAssetsOptions(e) {
      var self = this;
      self.ebIsLeasedAssetsOptions = [];
      var data = [{ id: 0, text: "ทรัพย์สินบริษัท" }, { id: 1, text: "ทรัพย์สินเช่า" }];
      data.forEach(function (element) {
        self.ebIsLeasedAssetsOptions.push({
          id: element.id,
          label: element.text
        });
      });
    },
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var self = this;
      if (!self.ebAssetCode || !self.ebAssetOwnerId || !self.ebSupplierId || self.ebIsLeasedAssets === null || self.ebIsLeasedAssets === undefined) {
        return false;
      }

      self.submit();
    },
    submit: function submit() {
      var router = this.$router;
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Barcode/EditDataBarcode", {
        BarcodeId: this.$route.params.id,
        BarcodeNoOld: this.ebBarcodeOld,
        DepartmentMaterialCode: this.ebDepartmentMaterialCode,
        BarcodeYear: this.ebBarcodeYear,
        AccountMaterialCode: this.ebAccountMaterialCode,
        BarcodeCooling: this.ebBarcodeCL,
        MaterialCode: this.ebAssetCode,
        AssetOwnerId: this.ebAssetOwnerId,
        VendorId: this.ebSupplierId,
        WarrantyStartDate: this.ebWarrantyStartDate.format("DD/MM/YYYY"),
        WarrantyTime: this.ebWarrantyTime,
        Exprie: this.ebExprie,
        IsLeasedAssets: this.ebIsLeasedAssets
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $(self.$el).modal("hide");
            self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
      }).finally(function () {
        KTApp.unblockPage(); // ปิด loading page ทุกกรณี
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, arrows;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this2;
              router = _this2.$router;

              self.isGenBarcode = false;
              self.LoadebMaterialCodeOptions();
              self.LoadebAssetOwnerOptions();
              self.LoadLeasedAssetsOptions();
              self.LoadebSupplierIdOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.ebWarrantyStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(),
                maxDate: moment().add(30, "days"),
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              self.ebWarrantyStartDate = moment();
              $(self.$refs.ebWarrantyStartDate).datepicker("update", self.ebWarrantyStartDate.format("DD/MM/YYYY")).on("changeDate", function (e) {
                self.ebWarrantyStartDate = moment(e.date);
              }).on("blur", function () {
                var inputValue = $(this).val().trim();
                var parsedDate = moment(inputValue, "DD/MM/YYYY", true);
                if (parsedDate.isValid()) {
                  self.ebWarrantyStartDate = parsedDate;
                } else {
                  $(this).val(self.ebWarrantyStartDate.format("DD/MM/YYYY"));
                }
              });

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Barcode/" + _this2.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.ebBarcodeOld = response.data.barcodeIdOld;
                  self.ebDepartmentMaterialCode = response.data.departmentMaterialCode;
                  self.ebBarcodeYear = response.data.barcodeYear ? response.data.barcodeYear : 0;
                  self.ebAccountMaterialCode = response.data.accountMaterialCode;
                  self.ebBarcodeCL = response.data.barcodeCooling;
                  self.ebAssetCode = response.data.materialCode;
                  self.ebAssetOwnerId = response.data.assetOwner;
                  self.ebSupplierId = response.data.supplierID;

                  self.ebWarrantyStartDate = moment(response.data.warrantyStartDateS, "DD/MM/YYYY");
                  $(self.$refs.ebWarrantyStartDate).datepicker("update", response.data.warrantyStartDateS);

                  self.ebWarrantyTime = response.data.warrantyTime;
                  self.ebExprie = response.data.exprie;
                  self.ebIsLeasedAssets = response.data.isLeasedAssets;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลตัวแทนจำหน่ายที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลตัวแทนจำหน่ายได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              $("#EditBarcodeModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
              }).modal("show");

              // set validation rules
              $(_this2.$refs.form).validate({
                rules: {
                  ebBarcodeOld: {
                    required: true,
                    minlength: 7,
                    maxlength: 7
                  },
                  ebBarcodeYear: "required",
                  ebWarrantyStartDate: "required",
                  ebWarrantyTime: "required",
                  ebExprie: "required"
                },
                messages: {
                  ebBarcodeOld: {
                    required: "กรุณากรอก BARCODE",
                    minlength: "รหัสบาร์โค้ดต้องมี 7 ตัว",
                    maxlength: "รหัสบาร์โค้ดต้องมี 7 ตัว"
                  },
                  ebBarcodeYear: "กรุณากรอก ปี(สินค้า)",
                  ebWarrantyStartDate: "กรุณาเลือก วันที่เริ่มต้น",
                  ebWarrantyTime: "กรุณากรอก ระยะเวลาประกัน(วัน)",
                  ebExprie: "กรุณากรอก อายุของทรัพย์สิน(วัน)"
                }
              });

              $(_this2.$refs.form).validate().settings.ignore = ":hidden";

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      Flie: "เลือกไฟล์",
      seen: false,
      isPass: true,
      barcodeList: [],
      barcodeListWarning: []
    };
  },
  methods: {
    resetFile: function resetFile() {
      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();
      $("#importFileBarcode").val("");
      this.seen = false;
      this.Flie = "เลือกไฟล์";
      this.isPass = true;
      this.barcodeList = [];
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!this.isPass) {
        Swal.fire("กรุณาตรวจสอบข้อมูลให้ถูกต้อง", "", "warning");
        return false;
      }
      if (this.barcodeList.length < 1) {
        Swal.fire("กรุณาเลือกไฟล์ก่อนบันทึกข้อมูล", "", "warning");
        return false;
      }

      var valid = false;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var self = this;
      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Barcode/Import", this.barcodeList).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              $("#importFileBarcode").change(function (e) {
                self.seen = true;
                self.Flie = e.target.files[0].name;

                $("#PreviewTable thead").remove();
                $("#PreviewTable tbody").remove();

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังแสดงข้อมูล กรุณารอสักครู่..."
                });

                var formData = new FormData();
                formData.append("file", e.target.files[0]);
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Barcode/Preview", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }).then(function (response) {
                  self.barcodeList = response.data;
                  var $table = $("#PreviewTable");

                  var hasBarcodeId = response.data.some(function (item) {
                    return item.BarcodeId != null && item.BarcodeId > 0;
                  });

                  var head = '<thead>' + '<tr role="row">' + '<th class="text-center">ลำดับ</th>' + '<th class="text-center" style="width:8%;">BARCODE</th>' + '<th class="text-center" style="width:10%;">รหัสทรัพย์สิน(เบียร์สด)</th>' + '<th class="text-center" style="width:8%;">ปี(สินค้า)</th>' + '<th class="text-center" style="width:10%;">รหัสทรัพย์สิน(บัญชี)</th>' + '<th class="text-center" style="width:5%;">BARCODE COOLING</th>' + '<th class="text-center">รหัสสินค้า</th>' + '<th class="text-center">ชื่อสินค้า</th>' + '<th class="text-center" style="width:5%;">รหัสประเภทสินค้า</th>' + '<th class="text-center">ชื่อประเภทสินค้า</th>' + '<th class="text-center" style="width:5%;">วันที่เริ่มต้น</th>' + '<th class="text-center">ระยะเวลาประกัน(วัน)</th>' + '<th class="text-center">อายุของทรัพย์สิน(วัน)</th>' + '<th class="text-center">รหัสเจ้าของทรัพย์สิน</th>' + '<th class="text-center">ชื่อเจ้าของทรัพย์สิน</th>' + '<th class="text-center">รหัส Supplier</th>' + '<th class="text-center">ชื่อ Supplier</th>' + '<th class="text-center">สถานะทรัพย์สินเช่า</th>';
                  if (hasBarcodeId) {
                    head += '<th class="text-center">BARCODE ID</th>';
                  }
                  head += '</tr></thead>';

                  $table.append(head);
                  var data = response.data;
                  var table_body = $("<tbody></tbody>");
                  for (var i = 0; i < data.length; i++) {
                    var borders_assetDB = null;
                    var borders_startDate = null;
                    var borders_longDate = null;
                    var borders_exprie = null;
                    var borders_oldBarcode = null;
                    var borders_isLeasedAssets = null;
                    var borders_VenderCode = null;
                    var borders_VenderName = null;
                    var borders_plantOwnerName = null;
                    var borders_plantOwnerId = null;
                    var borders_productypeID = null;
                    var borders_productypeName = null;
                    var borders_productName = null;
                    var borders_materialcode = null;
                    var borders_assetAc = null;
                    var borders_barcodeYear = null;
                    var borders_cooling = null;
                    var borders_barcodeID = "";

                    if (data[i].assetDBMS == null || data[i].assetDBMS == "") {
                      borders_assetDB = 'style="color:#ff0000;"';
                      data[i].assetDBMS = "";
                    }

                    if (data[i].startDate == null || data[i].startDate == "") {
                      borders_startDate = 'style=" color:#ff0000;"';
                      data[i].startDate = "กรุณากรอกวันที่เริ่มต้น";
                      self.isPass = false;
                    }

                    if (data[i].IsstartDate == true) {
                      borders_startDate = 'style="color:#ff0000;"';
                    }

                    if (data[i].longDate == null || data[i].longDate == "") {
                      borders_longDate = 'style="color:#ff0000;"';
                      data[i].longDate = "กรุณากรอกระยะเวลาประกันถัง(วัน)";
                      self.isPass = false;
                    }

                    if (data[i].isLeasedAssets == null) {
                      data[i].isLeasedAssets = "กรุณากรอกสถานะทรัพย์สินเช่า";
                      borders_isLeasedAssets = 'style="color:#ff0000;"';
                      self.isPass = false;
                    }

                    if (data[i].barcodeYear == null) {
                      data[i].barcodeYear = 0;
                    }

                    if (data[i].barcodeOld != null) {
                      if (data[i].barcodeOld.length != 7 || data[i].barcodeOldCount >= 1) {
                        borders_oldBarcode = 'style="color:#ff0000;"';
                      }
                    } else if (data[i].barcodeOld == null || data[i].barcodeOld == "") {
                      data[i].barcodeOldMS = "กรุณากรอก BARCODE";
                      borders_oldBarcode = 'style="color:#ff0000;"';
                      self.isPass = false;
                    }

                    if (data[i].assetDB != null) {
                      if (data[i].assetDBCount >= 1) {
                        borders_assetDB = 'style="color:#ff0000;"';
                        self.isPass = false;
                      }
                    }

                    if (data[i].vendorMS == null) {
                      data[i].vendorMS = "กรุณากรอกรหัส Supplier";
                      borders_VenderCode = 'style="color:#ff0000;"';
                      self.isPass = false;
                    }

                    if (data[i].vendorCount > 0) {
                      borders_VenderCode = 'style="color:#ff0000;"';
                      borders_VenderName = 'style="color:#ff0000;"';
                      self.isPass = false;
                    }

                    if (data[i].vendorName == null) {
                      data[i].vendorName = "";
                      borders_VenderName = 'style="color:#ff0000;"';
                    }

                    if (data[i].plantOwnerID == null || data[i].plantOwnerID == "") {
                      data[i].plantOwnerID = "กรุณากรอกรหัสเจ้าของทรัพย์สิน";
                      borders_plantOwnerId = 'style="color:#ff0000;"';
                      self.isPass = false;
                    }

                    if (data[i].plantOwnerName == null || data[i].plantOwnerName == "") {
                      data[i].plantOwnerName = "";
                      borders_plantOwnerName = 'style="color:#ff0000;"';
                    }

                    if (data[i].exprie == null || data[i].exprie == "") {
                      data[i].exprie = "กรุณากรอกอายุของทรัพย์สิน(วัน)";
                      borders_exprie = 'style="color:#ff0000;"';
                      self.isPass = false;
                    }

                    if (data[i].productypeID == null || data[i].productypeID == "") {
                      data[i].productypeID = "กรุณากรอกรหัสประเภทสินค้า";
                      borders_productypeID = 'style="color:#ff0000;"';
                      self.isPass = false;
                    }

                    if (data[i].productypeName == null || data[i].productypeName == "") {
                      data[i].productypeName = "";
                      borders_productypeName = 'style="color:#ff0000;"';
                    }

                    if (data[i].productName == null || data[i].productName == "") {
                      data[i].productName = "";
                      borders_productName = 'style="color:#ff0000;"';
                    }

                    if (data[i].materialcode == null || data[i].materialcode == "") {
                      data[i].materialcode = "กรุณากรอกรหัสสินค้า";
                      borders_materialcode = 'style="color:#ff0000;"';
                      self.isPass = false;
                    }

                    if (data[i].assetAc == null || data[i].assetAc == "") {
                      data[i].assetAc = "";
                      borders_assetAc = 'style="color:#ff0000;"';
                    }

                    if (data[i].barcodeCooling != null && data[i].barcodeCooling != "" && data[i].barcodeCoolingCount > 0) {
                      borders_cooling = 'style="color:#ff0000;"';
                      self.isPass = false;
                    }

                    if (data[i].BarcodeId == null || data[i].BarcodeId <= 0) {
                      data[i].BarcodeId = "";
                      borders_barcodeID = 'style="color:#ff0000;"';
                    }

                    var showbarcode = data[i].barcodeYear;
                    if (data[i].assetYearDBMS != null && data[i].assetYearDBMS != "") {
                      showbarcode = '<span style="color:#ff0000;">' + data[i].assetYearDBMS + '</span>';
                    } else {
                      if (data[i].barcodeYear <= 0) {
                        showbarcode = "";
                      }
                    }

                    var row = '<tr role="row" class="odd">' + '<td class="text-center">' + (i + 1) + '</td>' + '<td class="text-center" ' + borders_oldBarcode + '>' + data[i].barcodeOldMS + '</td>' + '<td class="text-center" ' + borders_assetDB + '>' + data[i].assetDBMS + '</td>' + '<td class="text-center" ' + borders_barcodeYear + '>' + showbarcode + '</td>' + '<td class="text-center" ' + borders_assetAc + '>' + data[i].assetAc + '</td>' + '<td class="text-center" ' + borders_cooling + '>' + data[i].barcodeCooling + '</td>' + '<td class="text-center" ' + borders_materialcode + '>' + data[i].materialcode + '</td>' + '<td class="text-center" ' + borders_productName + '>' + data[i].productName + '</td>' + '<td class="text-center" ' + borders_productypeID + '>' + data[i].productypeID + '</td>' + '<td class="text-center" ' + borders_productypeName + '>' + data[i].productypeName + '</td>' + '<td class="text-center" ' + borders_startDate + '>' + data[i].startDate + '</td>' + '<td class="text-center" ' + borders_longDate + '>' + data[i].longDate + '</td>' + '<td class="text-center" ' + borders_exprie + '>' + data[i].exprie + '</td>' + '<td class="text-center" ' + borders_plantOwnerId + '>' + data[i].plantOwnerID + '</td>' + '<td class="text-center" ' + borders_plantOwnerName + '>' + data[i].plantOwnerName + '</td>' + '<td class="text-center" ' + borders_VenderCode + '>' + data[i].vendorMS + '</td>' + '<td class="text-center" ' + borders_VenderName + '>' + data[i].vendorName + '</td>' + '<td class="text-center" ' + borders_isLeasedAssets + '>' + data[i].isLeasedAssets + '</td>';
                    if (hasBarcodeId) {
                      row += '<td class="text-center" ' + borders_barcodeID + '>' + data[i].BarcodeId + '</td>';
                    }
                    row += '</tr>';
                    $(row).appendTo(table_body);
                  }

                  table_body.appendTo($table);
                  KTApp.unblockPage();
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถอ่านข้อมูลจากไฟล์ที่นำเข้า", "error");
                }).then(function () {
                  KTApp.unblockPage();
                });
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




var simulateAsyncOperation = function simulateAsyncOperation(fn) {
  setTimeout(fn, 2000);
};

__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var Actions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"detail\" v-if=\"data.showDetailButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"fa fa-search\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"editBarCode\" v-if=\"data.showEditBarCodeButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 BARCODE\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n     <a href=\"#\" @click.prevent=\"toggleStatus(data)\" v-if=\"data.showCancelBarCodeButton\" title=\"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01 BARCODE\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash text-danger\" ></i>\n    </a>\n  </div>",
  methods: {

    toggleStatus: function toggleStatus(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Barcode/" + this.data.barcodeId + "/ValidateBarcodeMapping").then(function (response) {

        if (response.data.data == "") {
          // no confirm
          self.submittoggle("A0");
        } else {
          // confirm again
          Swal.fire({
            title: "คำสั่งแก้ไขสถานะ",
            type: "warning",
            html: response.data.message,
            inputPlaceholder: "ต้องการแก้ไขสถานะ",
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true
          }).then(function (result) {
            if (result.value === true || result.value === false) {
              self.submittoggle(response.data.data);
            }
          });
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดำเนินการได้", "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    submittoggle: function submittoggle(mastermappingid) {
      var self = this;
      var table = $("#barcodeTable");
      if (mastermappingid != null && mastermappingid.length > 10) {
        self.submitCancel(mastermappingid);
      } else {
        Swal.fire({
          title: "คำสั่งแก้ไขสถานะ",
          type: "warning",
          html: "กรุณายืนยันการยกเลิกรายการ BARCODE",
          inputPlaceholder: "ต้องการแก้ไขสถานะ",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value === true || result.value === false) {
            self.submitCancel(mastermappingid);
          }
        });
      }
    },
    submitCancel: function submitCancel(mastermappingid) {
      var self = this;
      var table = $("#barcodeTable");
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Barcode/" + this.data.barcodeId + "/" + mastermappingid + "/Toggle").then(function (response) {
        if (response.data.data) {
          self.$parent.reloadDataTable();
          Swal.fire("สำเร็จ", "ยกเลิก BARCODE สำเร็จ", "success");
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response && error.response.data && error.response.data.message || "ไม่สามารถดำเนินการได้", "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    detail: function detail() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/ManageBarcode/Detail/" + this.data.barcodeId
      });
    },
    editBarCode: function editBarCode() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/ManageBarcode/EditBarCode/" + this.data.barcodeId
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      MbIsShowCancel: false,
      MbWarrantyTime: null,
      MbExprie: null,
      MbProductTypeId: [],
      MbAssetOwnerId: [],
      MbAgentId: [],
      MbPlantId: [],
      MbShopId: [],
      MbShop2Id: [],
      MbIntendantId: [],
      MbIntendantSubShopId: [],
      MbSupShopId: [],
      MbSupShop2Id: [],
      MbSupplierId: [],
      MbCurrentSupplierId: [],
      MbBarcodeStautsId: [],
      MbBarcodeStautsDisabled: false,
      MbOldBarcode: "",
      MbBarcodeCooling: "",
      MbDepartmentMaterialCode: "",
      MbAccountMaterialCode: "",
      MbCurrentSupplierOptions: [],
      MbRefNo: [],
      MbRefNoOptions: [],
      MbBarcodeStatusOptions: [],
      MbSupplierOptions: [],
      MbShopOptions: [],
      MbSupShopOptions: [],
      MbPlantOptions: [],
      MbAgentOptions: [],
      MbProductTypeIdOptions: [],
      MbAssetOwnerOptions: [],
      MbIntendantOptions: [],
      MbIntendantSubShopOptions: [],
      MbDepartmentMaterialCodeOptions: [],
      MbAssetCode: [],
      MbAssetCodeOptions: [],
      MbBrandId: [],
      MbBrandIdOptions: [],
      ProductIdBrand: [],
      ProductIdBrandOptions: [],
      fullProductData: [],
      fullSubAgentData: [],
      MbHostAgentCode: [],
      MbHostAgentCodeOptions: [],
      MbHostSubAgentCode: [],
      reBHostSubAgentCodeOptions: [],
      MbCurrentLocationType: null,
      MbCurrentLocationTypeOptions: [],
      MbBarcodeYear: [],
      AllBarcodeYearOptions: [],
      IsLeasedAssets: null,
      LeasedAssetsOptions: [],
      // CR 02/09/2026 — filter "สถานะใช้งาน" (1=ใช้งาน เป็นค่าเริ่มต้น, 0=ปิดใช้งาน, null=ทั้งหมด)
      ActiveStatus: 1,
      ActiveStatusOptions: [],
      ActiveStatusInfoText: 'ใช้งาน = ไม่แสดงข้อมูล BARCODE ที่ คอลัมน์ "ผู้ดูแลทรัพย์สิน" 1.Z000002 คลัง Writeoff(ตัวแทนจำหน่าย), 2.คลังสินค้าที่ตั้งค่า "ประเภทคลังสินค้า = คลัง(จัดการข้อมูล)"<br/>*กำหนดเป็นค่าเริ่มต้น<br/>ปิดใช้งาน = แสดงข้อมูล BARCODE ที่ คอลัมน์ "ผู้ดูแลทรัพย์สิน" 1.Z000002 คลัง Writeoff(ตัวแทนจำหน่าย), 2.คลังสินค้าที่ตั้งค่า "ประเภทคลังสินค้า = คลัง(จัดการข้อมูล)"'
    };
  },
  computed: {
    // CR 02/09/2026 — ไม่แสดง filter "สถานะใช้งาน" ให้สิทธิ์ แอดมินตัวแทนจำหน่าย / แอดมินตัวแทนจำหน่ายย่อย
    // (super_admin เห็นเสมอ — canShow คืน true ให้ super_admin ทุกกรณี จึงต้องใช้ canShowExSuperAdmin)
    showActiveStatusFilter: function showActiveStatusFilter() {
      return this.$root.canShow(["super_admin"]) || !this.$root.canShowExSuperAdmin(["MANAGE_BARCODE_AGENT", "MANAGE_BARCODE_SUB_AGENT"]);
    },
    pageTitle: function pageTitle() {
      var breadcrumb = {
        MANAGE_MASTER: "จัดการข้อมูล BARCODE",
        MANAGE_BARCODE_AGENT: "จัดการข้อมูล BARCODE (ตัวแทน)",
        MANAGE_BARCODE_SUB_AGENT: "จัดการข้อมูล BARCODE (ตัวแทนจำหน่ายย่อย)"
      };
      var userRoles = this.$root.user.profile.role;
      userRoles = Array.isArray(userRoles) ? userRoles : userRoles ? [userRoles] : [];

      // super_admin เห็นทุกสิทธิ์ (canShow() return true เสมอ) → ใช้หัวข้อหลัก
      // ให้ตรงกับเมนูและ breadcrumb
      if (userRoles.includes("super_admin")) {
        return breadcrumb.MANAGE_MASTER;
      }

      // เทียบตามลำดับสิทธิ์ ไม่ใช่ลำดับที่ role มาใน array ของ user
      var _arr = ["MANAGE_MASTER", "MANAGE_BARCODE_AGENT", "MANAGE_BARCODE_SUB_AGENT"];
      for (var _i = 0; _i < _arr.length; _i++) {
        var key = _arr[_i];
        if (userRoles.includes(key)) {
          return breadcrumb[key];
        }
      }
      return breadcrumb.MANAGE_MASTER;
    },
    filteredProductIdBrandOptions: function filteredProductIdBrandOptions() {
      var _this = this;

      if (!this.MbBrandId.length) {
        return this.ProductIdBrandOptions;
      }
      var filteredOptions = [];
      this.fullProductData.forEach(function (item) {
        if (_this.MbBrandId.map(Number).includes(item.data.productBrandId)) {
          filteredOptions.push({
            id: item.id,
            label: item.text,
            productBrandId: item.data.productBrandId
          });
        }
      });
      return filteredOptions;
    },
    filteredSubAgentOptions: function filteredSubAgentOptions() {
      var _this2 = this;

      if (!this.MbHostAgentCode.length) {
        return this.reBHostSubAgentCodeOptions;
      }
      return this.fullSubAgentData.filter(function (item) {
        return item.data && _this2.MbHostAgentCode.includes(item.data);
      }).map(function (item) {
        return {
          id: item.id,
          label: item.text
        };
      });
    }
  },
  methods: {
    clickcheckbox: function clickcheckbox(e) {

      var self = this;
      setTimeout(function () {
        if (self.MbIsShowCancel) {
          self.MbBarcodeStautsDisabled = true;
          self.MbBarcodeStautsId = [];
        } else {
          self.MbBarcodeStautsDisabled = false;
        }
      }, 100);

      //self.$parent.saveSummit(this.data.headerId);
    },
    LoadMbCurrentSupplierOptions: _.debounce(function (_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.MbCurrentSupplierOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Vendors/Select2Vendor", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.MbCurrentSupplierOptions = [];
            if (data.length > 1) self.MbCurrentSupplierOptions = [{ id: "0", label: "ทั้งหมด" }];
            data.forEach(function (element) {
              self.MbCurrentSupplierOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }

          callback(null, self.MbCurrentSupplierOptions);
        }).catch(function (error) {});
      }
    }, 1000),
    reLoadMbCurrentSupplierOptions: function reLoadMbCurrentSupplierOptions() {
      this.$refs.MbCurrentSupplierId.trigger.searchQuery = null;
    },
    LoadMbBarcodeStatusOptions: function LoadMbBarcodeStatusOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Barcode/Select2BarcodeStatus", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.MbBarcodeStatusOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    reLoadMbSupplierOptions: function reLoadMbSupplierOptions() {
      this.$refs.MbSupplierId.trigger.searchQuery = null;
    },
    LoadMbSupplierOptions: function LoadMbSupplierOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.MbSupplierOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Vendors/Select2Vendor", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.MbSupplierOptions = [];
            data.forEach(function (element) {
              self.MbSupplierOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.MbSupplierOptions);
        }).catch(function (error) {});
      }
    },

    LoadMbSupShopOptions: _.debounce(function (_ref3) {
      var action = _ref3.action,
          searchQuery = _ref3.searchQuery,
          callback = _ref3.callback;

      var self = this;
      var MbShopId = self.mapMbShop();
      self.MbSupShopOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Barcode/Select2SupShop", {
          page: 1,
          all: true,
          search: searchQuery,
          ShopId: MbShopId,
          agentCodes: self.MbAgentId
        }).then(function (response) {
          if (response.status == 200) {
            self.MbSupShopOptions = [];
            var data = response.data.results;
            if (data.length > 1) self.MbSupShopOptions = [{ id: "0", label: "ทั้งหมด" }];
            data.forEach(function (element) {
              self.MbSupShopOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }

          callback(null, self.MbSupShopOptions);
        }).catch(function (error) {});
      }
    }, 1000),
    reLoadMbSupShopOptions: function reLoadMbSupShopOptions() {
      this.$refs.MbSupShopId.trigger.searchQuery = null;
    },
    LoadMbSupShop2Options: _.debounce(function (_ref4) {
      var action = _ref4.action,
          searchQuery = _ref4.searchQuery,
          callback = _ref4.callback;

      var self = this;
      var MbShopId = self.mapMbShop();

      self.MbSupShopOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Barcode/Select2SupShop", {
          page: 1,
          all: true,
          search: searchQuery,
          ShopId: MbShopId,
          agentCodes: self.MbAgentId,
          Name2: true
        }).then(function (response) {
          if (response.status == 200) {
            self.MbSupShopOptions = [];
            var data = response.data.results;
            if (data.length > 1) self.MbSupShopOptions = [{ id: "0", label: "ทั้งหมด" }];
            data.forEach(function (element) {
              self.MbSupShopOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }

          callback(null, self.MbSupShopOptions);
        }).catch(function (error) {});
      }
    }, 1000),
    reLoadMbSupShop2Options: function reLoadMbSupShop2Options() {
      this.$refs.MbSupShop2Id.trigger.searchQuery = null;
    },
    LoadMbShopOptions: _.debounce(function (_ref5) {
      var action = _ref5.action,
          searchQuery = _ref5.searchQuery,
          callback = _ref5.callback;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Barcode/Select2Shop", {
        page: 1,
        all: true,
        search: searchQuery,
        agentCodes: self.MbAgentId
      }).then(function (response) {
        if (response.status == 200) {
          self.MbShopOptions = [];
          var data = response.data.results;
          if (data.length > 1) self.MbShopOptions = [{ id: "0", label: "ทั้งหมด" }];
          data.forEach(function (element) {
            self.MbShopOptions.push({
              id: element.id,
              label: element.text,
              isDisabled: self.MbAgentId[0] == "" ? true : false
            });
          });
        }
        callback(null, self.MbShopOptions);
      }).catch(function (error) {});
    }, 1000),
    LoadMbShop2Options: _.debounce(function (_ref6) {
      var action = _ref6.action,
          searchQuery = _ref6.searchQuery,
          callback = _ref6.callback;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Barcode/Select2Shop", {
        page: 1,
        all: true,
        search: searchQuery,
        agentCodes: self.MbAgentId,
        Name2: true
      }).then(function (response) {
        if (response.status == 200) {
          self.MbShopOptions = [];
          var data = response.data.results;
          if (data.length > 1) self.MbShopOptions = [{ id: "0", label: "ทั้งหมด" }];
          data.forEach(function (element) {
            self.MbShopOptions.push({
              id: element.id,
              label: element.text,
              isDisabled: self.MbAgentId[0] == "" ? true : false
            });
          });
        }
        callback(null, self.MbShopOptions);
      }).catch(function (error) {});
    }, 1000),
    reLoadMbShopOptions: function reLoadMbShopOptions() {
      this.$refs.MbShopId.trigger.searchQuery = null;
    },
    reLoadMbShop2Options: function reLoadMbShop2Options() {
      this.$refs.MbShop2Id.trigger.searchQuery = null;
    },
    LoadMbPlantOptions: function LoadMbPlantOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Plant/Select2SearchPlant", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          self.MbPlantOptions = [];
          var data = response.data.results;
          if (data.length > 1) self.MbPlantOptions = [{ id: "0", label: "ทั้งหมด" }];
          data.forEach(function (element) {
            self.MbPlantOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadMbAgentOptions: function LoadMbAgentOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Barcode/Select2SearchAgentName", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          self.MbAgentOptions = [];
          var data = response.data.results;
          if (data.length > 1) self.MbAgentOptions = [{ id: "0", label: "ทั้งหมด" }];
          data.forEach(function (element) {
            self.MbAgentOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadMbProductTypeIdOptions: function LoadMbProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.MbProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadMbAssetOwnerOptions: function LoadMbAssetOwnerOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/assetOwner/Select2SearchAssetOwner", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.MbAssetOwnerOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadMbRefNoOptions: function LoadMbRefNoOptions(_ref7) {
      var action = _ref7.action,
          searchQuery = _ref7.searchQuery,
          callback = _ref7.callback;

      var self = this;
      self.MbRefNoOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Barcode/Select2RefCode", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.MbRefNoOptions = [];
            data.forEach(function (element) {
              self.MbRefNoOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.MbRefNoOptions);
        }).catch(function (error) {});
      }
    },

    LoadMbIntendant: _.debounce(function (_ref8) {
      var action = _ref8.action,
          searchQuery = _ref8.searchQuery,
          callback = _ref8.callback;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Barcode/Select2Intendant", {
        page: 1,
        all: true,
        search: searchQuery,
        ShopCodes: self.MbShopId,
        AgentCodes: self.MbAgentId
      }).then(function (response) {
        if (response.status == 200) {
          self.MbIntendantOptions = [];
          var data = response.data.results;
          if (data.length > 1) self.MbIntendantOptions = [{ id: "0", label: "ทั้งหมด" }];
          data.forEach(function (element) {
            self.MbIntendantOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
        callback(null, self.MbIntendantOptions);
      }).catch(function (error) {});
    }, 1000),
    reLoadMbIntendant: function reLoadMbIntendant() {
      this.$refs.MbIntendantId.trigger.searchQuery = null;
    },
    LoadMbIntendantSubShop: _.debounce(function (_ref9) {
      var action = _ref9.action,
          searchQuery = _ref9.searchQuery,
          callback = _ref9.callback;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Barcode/Select2IntendantSubShop", {
        page: 1,
        all: true,
        search: searchQuery,
        ShopCodes: self.MbShopId
      }).then(function (response) {
        if (response.status == 200) {
          self.MbIntendantSubShopOptions = [];
          var data = response.data.results;
          if (data.length > 1) self.MbIntendantSubShopOptions = [{ id: "0", label: "ทั้งหมด" }];
          data.forEach(function (element) {
            self.MbIntendantSubShopOptions.push({
              id: element.id,
              label: element.text,
              isDisabled: self.MbIntendantOptions[0] == "" ? true : false
            });
          });
        }
        callback(null, self.MbIntendantSubShopOptions);
      }).catch(function (error) {});
    }, 1000),
    reLoadMbIntendantSubShop: function reLoadMbIntendantSubShop() {
      this.$refs.MbIntendantSubShopId.trigger.searchQuery = null;
    },
    mapMbShop: function mapMbShop() {
      var self = this;
      var dataSet = [].concat(_toConsumableArray(self.MbShopId), _toConsumableArray(self.MbShop2Id));
      var MbShopId = new Set(dataSet);
      return MbShopId;
    },
    mapMbSupShop: function mapMbSupShop() {
      var self = this;
      var dataSet = [].concat(_toConsumableArray(self.MbSupShopId), _toConsumableArray(self.MbSupShop2Id));
      var MbSupShopId = new Set(dataSet);
      return MbSupShopId;
    },
    formReset: function formReset(e) {
      this.MbOldBarcode = "";
      this.MbWarrantyTime = "";
      this.MbExprie = "";
      this.MbProductTypeId = [];
      this.MbAssetOwnerId = [];
      this.MbStatusId = [];
      this.MbDepartmentMaterialCode = "";
      this.MbAccountMaterialCode = "";
      this.MbBarcodeCooling = "";
      this.MbAssetCode = [];
      this.MbBrandId = [];
      this.ProductIdBrand = [];
      this.MbHostAgentCode = [];
      this.MbHostSubAgentCode = [];
      this.MbCurrentLocationType = null;
      this.MbBarcodeYear = [];
      this.MbIntendantSubShopId = [];
      this.MbSupplierId = [];
      this.MbCurrentSupplierId = [];
      this.MbBarcodeStautsId = [];
      this.MbBarcodeStautsDisabled = false;
      this.MbRefNo = [];
      this.IsLeasedAssets = null;
      this.ActiveStatus = 1; // CR 02/09/2026 — กลับไปที่ค่าเริ่มต้น "ใช้งาน"
      this.MbIsShowCancel = false;

      $("#MbAgentId").val("").trigger("change");
      this.MbAgentId = [];
      this.MbPlantId = [];

      $("#MbShopId").val("").trigger("change");
      this.MbShopId = [];

      $("#MbShop2Id").val("").trigger("change");
      this.MbShop2Id = [];

      $("#MbSupShopId").val("").trigger("change");
      this.MbSupShopId = [];

      $("#MbSupShop2Id").val("").trigger("change");
      this.MbSupShop2Id = [];

      $("#MbIntendantId").val("").trigger("change");
      this.MbIntendantId = [];

      $("#MbIntendantSubShopId").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#barcodeTable").DataTable();
      table.search(this.equipment);
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#barcodeTable").DataTable().ajax.reload(null, resetPaging);
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    exportBarcode: function exportBarcode(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/Barcode/ExportBarcode",
        responseType: "arraybuffer",
        data: {
          AgentId: self.MbAgentId,
          PlantId: self.MbPlantId,
          ShopId: self.mapMbShop(),
          SupShopId: self.mapMbSupShop(),
          IntendantId: self.MbIntendantId,
          IntendantSubShopId: self.MbIntendantSubShopId,
          CurrentSupplierId: self.MbCurrentSupplierId,
          OldBarcode: self.MbOldBarcode,
          DepartmentMaterialCode: self.MbDepartmentMaterialCode,
          AccountMaterialCode: self.MbAccountMaterialCode,
          BarcodeCooling: self.MbBarcodeCooling,
          ProductTypeId: self.MbProductTypeId,
          AssetCode: self.MbAssetCode,
          BrandId: self.MbBrandId,
          ProductIdBrand: self.ProductIdBrand,
          HostAgentCode: self.MbHostAgentCode,
          HostSubAgentCode: self.MbHostSubAgentCode,
          AssetOwnerId: self.MbAssetOwnerId,
          CurrentLocationType: self.MbCurrentLocationType,
          BarcodeYear: self.MbBarcodeYear,
          StatusId: self.MbBarcodeStautsId,
          SupplierId: self.MbSupplierId,
          Exprie: self.MbExprie,
          WarrantyTime: self.MbWarrantyTime,
          RefCode: self.MbRefNo,
          IsLeasedAssets: self.IsLeasedAssets,
          ActiveStatus: self.showActiveStatusFilter ? self.ActiveStatus : null,
          IsShowCancel: self.MbIsShowCancel
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    LoadreBAssetCodeOptions: function LoadreBAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true,
          excludeProductGroupId: 14
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.MbAssetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    BrandIdClearAfterSelect: function BrandIdClearAfterSelect() {
      this.ProductIdBrand = [];
    },
    BrandIdClearAfterDeSelect: function BrandIdClearAfterDeSelect() {
      this.ProductIdBrand = [];
    },
    LoadreBBrandIdOptions: function LoadreBBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.MbBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    loadProductData: function loadProductData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/product/Select2ProductReport", {
                  page: 1,
                  all: true,
                  search: "",
                  productGroupIds: [14]
                });

              case 3:
                response = _context.sent;

                if (response.status === 200) {
                  _this3.fullProductData = response.data.results;
                  _this3.ProductIdBrandOptions = _this3.fullProductData.map(function (item) {
                    return {
                      id: item.id,
                      label: item.text,
                      productBrandId: item.data.productBrandId
                    };
                  });
                }
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.error("Error loading product data:", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 7]]);
      }))();
    },

    AgentCodeClearAfterSelect: function AgentCodeClearAfterSelect() {
      this.MbHostSubAgentCode = [];
    },
    AgentCodeClearAfterDeSelect: function AgentCodeClearAfterDeSelect() {
      this.MbHostSubAgentCode = [];
    },
    LoadreBHostAgentCodeOptions: function LoadreBHostAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Barcode/Select2SearchAgentName", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.MbHostAgentCodeOptions = [];
          data.forEach(function (element) {
            self.MbHostAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    loadSubAgentOptions: function loadSubAgentOptions() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Report/Select2SubShopAgent", {
                  page: 1,
                  onlySubAgent: true,
                  onlySubAgentBarcode: true,
                  all: true
                });

              case 3:
                response = _context2.sent;

                if (response.status === 200) {
                  _this4.fullSubAgentData = response.data.results;
                  _this4.reBHostSubAgentCodeOptions = _this4.fullSubAgentData.map(function (item) {
                    return {
                      id: item.id,
                      label: item.text
                    };
                  });
                }
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                console.error("Error loading product data:", _context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 7]]);
      }))();
    },

    LoadLeasedAssetsOptions: function LoadLeasedAssetsOptions(e) {
      var self = this;
      self.LeasedAssetsOptions = [];
      var data = [{ id: 0, text: "ทรัพย์สินบริษัท" }, { id: 1, text: "ทรัพย์สินเช่า" }];
      data.forEach(function (element) {
        self.LeasedAssetsOptions.push({
          id: element.id,
          label: element.text
        });
      });
    },
    // CR 02/09/2026 — ตัวเลือก filter "สถานะใช้งาน"
    LoadActiveStatusOptions: function LoadActiveStatusOptions(e) {
      var self = this;
      self.ActiveStatusOptions = [{ id: 1, label: "ใช้งาน" }, { id: 0, label: "ปิดใช้งาน" }];
    },
    LoadCurrentLocationTypeOptions: function LoadCurrentLocationTypeOptions(e) {
      var self = this;
      self.MbCurrentLocationTypeOptions = [];
      var data = [{ id: "คลัง/โรงงาน", text: "คลัง/โรงงาน" }, { id: "ตัวแทนจำหน่าย", text: "ตัวแทนจำหน่าย" }, { id: "ตัวแทนจำหน่ายย่อย", text: "ตัวแทนจำหน่ายย่อย" }, { id: "ร้านค้า", text: "ร้านค้า" }, { id: "ร้านค้า (ตัวแทนฯย่อย)", text: "ร้านค้า (ตัวแทนฯย่อย)" }, { id: "ซัพพลายเออร์", text: "ซัพพลายเออร์" }];
      data.forEach(function (element) {
        self.MbCurrentLocationTypeOptions.push({
          id: element.id,
          label: element.text
        });
      });
    },
    reLoadBarcodeYearOptions: function reLoadBarcodeYearOptions() {
      this.$refs.MbBarcodeYear.trigger.searchQuery = null;
    },
    LoadBarcodeYearOptions: function LoadBarcodeYearOptions(_ref10) {
      var _this5 = this;

      var action = _ref10.action,
          searchQuery = _ref10.searchQuery,
          callback = _ref10.callback;

      if (this.AllBarcodeYearOptions.length === 0) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Report/Select2BarcodeYear", {
          params: {
            page: 1,
            all: true
          }
        }).then(function (response) {
          if (response.status === 200) {
            _this5.AllBarcodeYearOptions = response.data.results.map(function (element) {
              return {
                id: element.id,
                label: element.text
              };
            });
            callback(null, _this5.AllBarcodeYearOptions);
          }
        }).catch(function (error) {
          callback(error, []);
        });
      } else {
        var query = searchQuery ? searchQuery.toLowerCase() : "";
        var filteredOptions = this.AllBarcodeYearOptions.filter(function (option) {
          return option.label.toLowerCase().includes(query);
        });
        callback(null, filteredOptions);
      }
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this6;

              self.LoadMbBarcodeStatusOptions();
              self.LoadMbPlantOptions();
              self.LoadMbAgentOptions();
              self.LoadMbProductTypeIdOptions();
              self.LoadMbAssetOwnerOptions();
              self.LoadreBAssetCodeOptions();
              self.LoadreBBrandIdOptions();
              self.LoadreBHostAgentCodeOptions();
              self.LoadCurrentLocationTypeOptions();
              self.loadProductData();
              self.loadSubAgentOptions();
              self.LoadLeasedAssetsOptions();
              self.LoadActiveStatusOptions();

              // CR 02/09/2026 — ปุ่ม Info ของ filter "สถานะใช้งาน"
              self.$nextTick(function () {
                if (self.$refs.ActiveStatusInfo) {
                  $(self.$refs.ActiveStatusInfo).popover();
                }
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#barcodeTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Barcode/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      AgentId: self.MbAgentId,
                      PlantId: self.MbPlantId,
                      ShopId: self.mapMbShop(),
                      SupShopId: self.mapMbSupShop(),
                      IntendantId: self.MbIntendantId,
                      IntendantSubShopId: self.MbIntendantSubShopId,
                      CurrentSupplierId: self.MbCurrentSupplierId,
                      OldBarcode: self.MbOldBarcode,
                      DepartmentMaterialCode: self.MbDepartmentMaterialCode,
                      AccountMaterialCode: self.MbAccountMaterialCode,
                      BarcodeCooling: self.MbBarcodeCooling,
                      ProductTypeId: self.MbProductTypeId,
                      AssetCode: self.MbAssetCode,
                      BrandId: self.MbBrandId,
                      ProductIdBrand: self.ProductIdBrand,
                      HostAgentCode: self.MbHostAgentCode,
                      HostSubAgentCode: self.MbHostSubAgentCode,
                      AssetOwnerId: self.MbAssetOwnerId,
                      CurrentLocationType: self.MbCurrentLocationType,
                      BarcodeYear: self.MbBarcodeYear,
                      StatusId: self.MbBarcodeStautsId,
                      SupplierId: self.MbSupplierId,
                      Exprie: self.MbExprie,
                      WarrantyTime: self.MbWarrantyTime,
                      RefCode: self.MbRefNo,
                      IsLeasedAssets: self.IsLeasedAssets,
                      ActiveStatus: self.showActiveStatusFilter ? self.ActiveStatus : null,
                      IsShowCancel: self.MbIsShowCancel
                    }));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [50, 100, 200, 500],
                pageLength: 100,
                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[0, "desc"]],
                columns: [{ data: "barcodeIdOld" }, { data: "departmentMaterialCode" }, { data: "accountMaterialCode" }, { data: "barcodeCooling" }, { data: "materialCode" }, { data: "materialDesc" }, { data: "productTypeName" }, { data: "finishedProductCode" }, { data: "beerDetail" }, { data: "status",
                  render: function render(data, type, full, meta) {
                    if (full.inActiveStatus) {
                      return "<span style='color:red !important;'>ยกเลิก</span>";
                    } else {
                      return data;
                    }
                  }
                }, { data: "locations",
                  render: function render(data, type, full, meta) {
                    if (data === null || data === undefined) {
                      return "";
                    }
                    var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>" + data + "</pre>";
                    return html;
                  }
                }, { data: "hostAgentName" }, { data: "currentLocationType" }, { data: "refCode" }, {
                  data: "warrantyStartDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.warrantyStartDateS;
                  }
                }, { data: "warrantyTime" }, { data: "exprie" }, { data: "supplierName" }, {
                  data: "barcodeId",
                  className: "text-center",
                  width: "15%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();

                  var data = $dt.row($tr).data();
                  if (data) {

                    console.log(data);
                    //alert( data.inActiveStatus); //&& data.status  !="ยกเลิก"
                    var isShowCacelBarcodeButtonByCode = false;
                    if ((data.materialCode == "COOL-ROOM-01" || data.materialCode == "FONT-SHOP-01") && data.inActiveStatus == false) {
                      isShowCacelBarcodeButtonByCode = true;
                    }

                    data.showDetailButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_BARCODE_AGENT", "MANAGE_BARCODE_SUB_AGENT"]);
                    data.showEditBarCodeButton = self.$root.canShow(["super_admin", "MANAGE_MASTER"]);
                    data.showCancelBarCodeButton = isShowCacelBarcodeButtonByCode && self.$root.canShow(["super_admin", "MANAGE_MASTER", "MANAGE_BARCODE",, "MANAGE_BARCODE_AGENT", "MANAGE_BARCODE_SUB_AGENT"]);

                    new Actions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }))();
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      qty: null,
      tpbAssetOwnerId: null,
      tpbProductId: null,
      tpbVendorId: null,
      tpbProductOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2ProductByType",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              productTypeId: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      tpbVendorOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      tpbAssetOwnerOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/assetOwner/Select2SearchAssetOwner",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$("#templateBarcodeModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดาวโหลด Template Barcode กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;
      var win = window.open("/Api/Barcode/DownloadTemplate?AssetOwnerId=" + self.tpbAssetOwnerId + "&VendorId=" + self.tpbVendorId + "&ProductId=" + self.tpbProductId + "&Rows=" + self.qty, "_blank");
      win.focus(KTApp.unblockPage());
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              // set validation rules
              $("#templateBarcodeModal form").validate({
                rules: {
                  tpbAssetOwnerId: "required",
                  tpbProductId: "required",
                  qty: "required",
                  tpbVendorId: "required"
                },
                messages: {
                  tpbAssetOwnerId: "กรุณาเลือกชื่อเจ้าของทรัพย์สิน",
                  tpbProductId: "กรุณาเลือกสินค้า",
                  qty: "กรุณาระบุจำนวน",
                  tpbVendorId: "กรุณาเลือก Supplier"
                }
              });

              $("#templateBarcodeModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                // self.$parent.reloadDataTable(false);
              }).modal("show");

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Datepicker__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1__Shared_Datepicker__["a" /* default */] },
  data: function data() {
    return {
      // userName: null,
      // password: null,
      // confirmPassword: null,
      // email: null,
      // givenName: null,
      // familyName: null,
      // position: null,
      // phoneNumber: null,
      // roleName: null
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$("#holdCreateModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Users/Create", {
        userName: this.userName,
        password: this.password,
        confirmPassword: this.confirmPassword,
        email: this.email,
        givenName: this.givenName,
        familyName: this.familyName,
        position: this.position,
        phoneNumber: this.phoneNumber,
        roleName: this.roleName
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $("#holdCreateModal").modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              $("#ProductType").select2({
                tags: true,
                placeholder: "กรุณาเลือก",
                allowClear: true
              });
              $("#ProductName").select2({
                tags: true,
                placeholder: "กรุณาเลือก",
                allowClear: true
              });

              // set validation rules
              $("#holdCreateModal form").validate({
                // rules: {
                //   userName: "required",
                //   email: {
                //     required: true,
                //     email: true
                //   },
                //   password: {
                //     required: true,
                //     minlength: 6
                //   },
                //   confirmPassword: {
                //     equalTo: "#password"
                //   },
                //   givenName: "required",
                //   familyName: "required",
                //   phoneNumber: "required"
                // },
                // messages: {
                //   userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
                //   email: {
                //     required: "กรุณากรอกอีเมล",
                //     email: "กรุณากรอกอีเมลให้ถูกต้อง"
                //   },
                //   password: {
                //     required: "กรุณากรอกรหัสผ่าน",
                //     minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร"
                //   },
                //   confirmPassword: {
                //     equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง"
                //   },
                //   givenName: "กรุณากรอกชื่อ",
                //   familyName: "กรุณากรอกชื่อสกุล",
                //   phoneNumber: "กรุณากรอกเบอร์โทรศัพท์"
                // }
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_currency_input__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(141);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_currency_input__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      DatePickerFormat: "yyyy",
      locale: "th",
      currency: "THB",
      bcBudgetName: null,
      bcProductBrandId: null,
      bcBudgetType: null,
      bcBudget: null,
      bcUsed: 0,
      bcBalance: null,
      bcYear: null,
      bcStatus: true, //init checkbox
      bcProductBrandIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      bcBudgetTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "BUDGET_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  computed: {
    BcBalanceCal: function BcBalanceCal() {
      this.bcBalance = this.bcUsed != null ? this.bcBudget - this.bcUsed : this.bcBudget;
      return this.bcBalance;
    }
  },
  methods: {
    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/BudgetBrand", {
        BudgetName: self.bcBudgetName,
        BudgetType: self.bcBudgetType,
        Year: self.bcYear.getFullYear(),
        Budget: self.bcBudget,
        UsedAmout: self.bcUsed,
        Balance: self.bcBalance,
        InActiveStatus: !self.bcStatus
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          //console.log(response);
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              //set Current Year

              _this.bcYear = new Date();
              $(_this.$refs.form).validate({
                rules: {
                  bcBudgetName: "required",
                  bcBudgetType: "required",
                  bcBudget: "required",
                  bcYear: "required"
                },
                messages: {
                  bcBudgetName: "กรุณาระบุชื่องบประมาณ",
                  bcBudgetType: "กรุณาเลือกประเภทงบประมาณ",
                  bcBudget: "กรุณาระบุงบประมาณ",
                  bcYear: "กรุณาระบุปีงบประมาณ"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      DlbRefno: [],
      exBudgetType: "",
      exYear: null,
      exStatus: null,
      exBudgetTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "BUDGET_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      exYearOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/BudgetBrand/Select2BudgetYear",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      exStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset() {
      this.exStatus = false;
      $("#exStatus").val(this.exStatus + "").trigger("change");

      this.exYear = null;
      $("#exYear").val(this.exYear + "").trigger("change");

      this.exBudgetType = "";
      $("#exBudgetType").val(this.exBudgetType + "").trigger("change");
    },

    formSubmit: function formSubmit(e) {
      var self = this;
      var router = this.$router;

      e.preventDefault();

      if (!$("#brandExportModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/BudgetBrand/Export",
        responseType: "arraybuffer",
        data: {
          BudgetType: self.exBudgetType != "" ? [self.exBudgetType] : [],
          Year: self.exYear,
          ActiveStatus: self.exStatus
        }
      }).then(function (response) {
        var filename = "";
        var contentType = response.headers["content-type"];
        var disposition = response.headers["content-disposition"];

        //===Get Filename===
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        //Save file
        var blob = new Blob([response.data], { type: contentType });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        self.formReset();
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;

              //default Active Data

              self.exStatus = false;
              $("#exStatus").val(self.exStatus + "").trigger("change");

              // set validation rules
              $("#brandExportModal form").validate({
                rules: { DlbRefno: "required" },
                messages: { DlbRefno: "กรุณาเลือกรหัสอ้างอิง" }
              });

              $("#brandExportModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              }).modal("show");

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);
var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#brandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BudgetBrand/" + _this.data.budgetId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#brandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BudgetBrand/" + _this2.data.budgetId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var BudgetBrandActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E07\u0E1A\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13\u0E23\u0E32\u0E22\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"deleteBudget\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E07\u0E1A\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13\u0E23\u0E32\u0E22\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/ManageBrand/Edit/" + this.data.budgetId
      });
    },
    deleteBudget: function deleteBudget() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลงบประมาณ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลงบประมาณรายแบรนด์ <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลงบประมาณรายแบรนด์นี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลงบประมาณรายแบรนด์ออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/BudgetBrand/" + _this3.data.budgetId + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      DatePickerFormat: "yyyy",
      blKeyword: null,
      blBudgetType: [],
      blBudgetTypeOptions: [],
      blYear: null,
      blStatus: null,
      blProductBrandIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },

      // blBudgetTypeOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options",
      //     data: function(params) {
      //       var query = {
      //         search: "BUDGET_TYPE",
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },

      blYearOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/BudgetBrand/Select2BudgetYear",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },

      blStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.blKeyword = null;

      this.blBudgetType = [];

      $("#blYear").val("").trigger("change");

      //default Active Data
      this.blStatus = false;
      $("#blStatus").val(this.blStatus + "").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#brandTable").DataTable();
      table.search(this.equipment);
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#brandTable").DataTable().ajax.reload(null, resetPaging);
    },
    CheckRoute: function CheckRoute() {
      var url = this.$route.path;
      console.log(this.$route.params.id);
      if (url == "/Master/ManageBrand/Edit/" + this.$root.$route.params.id) return false;else if (url == "/Master/ManageBrand/Add") return false;else return true;
    },

    LoadblBudgetTypeOptions: function LoadblBudgetTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Variables/Options", {
        params: {
          page: 1,
          search: "BUDGET_TYPE"
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.blBudgetTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;

              //default Active Data

              self.blStatus = false;
              $("#blStatus").val(self.blStatus + "").trigger("change");

              $("#brandKey").select2({
                tags: true,
                placeholder: "กรุณาเลือก",
                allowClear: true
              });

              self.LoadblBudgetTypeOptions();

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#brandTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/BudgetBrand/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      BudgetName: self.blKeyword,
                      BudgetType: self.blBudgetType,
                      Year: self.blYear,
                      ActiveStatus: self.blStatus
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[1, "desc"]],
                columns: [{ data: "budgetName" }, { data: "budgetTypeDesc", width: "20%" }, { data: "year" }, {
                  data: "budget",
                  render: function render(value) {
                    return self.$options.filters.currency(value, "฿");
                  }
                }, {
                  data: "usedAmout",
                  render: function render(value) {
                    return self.$options.filters.currency(value, "฿");
                  }
                }, {
                  data: "balance",
                  render: function render(value) {
                    return self.$options.filters.currency(value, "฿");
                  }
                }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "budgetId",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_BRAND"]);
                    if (data.inActiveStatus == false) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == true) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_BRAND"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_BRAND"]);
                    new BudgetBrandActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              table.trigger("draw.dt"); //call ajax delete this row

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_currency_input__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_filters__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_filters__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_currency_input__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue2_filters___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      locale: "th",
      currency: "THB",
      buBudgetName: null,
      buProductBrand: null,
      buProductBrandId: null,
      buBudgetType: null,
      buBudget: null,
      buUsed: null,
      buBalance: null,
      buYear: null,
      buStatus: null
    };
  },

  computed: {
    BuBalanceCal: function BuBalanceCal() {
      this.buBalance = this.buUsed != null ? this.buBudget - this.buUsed : this.buBudget;
      return this.buBalance;
    }
  },
  methods: {
    formSubmit: function formSubmit(e) {
      var self = this;
      var router = this.$router;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/BudgetBrand", {
        BudgetBrandId: self.$route.params.id,
        BudgetName: self.buBudgetName,
        BudgetType: self.buBudgetType,
        Year: self.buYear,
        Budget: self.buBudget,
        UsedAmout: self.buUsed,
        Balance: self.buBalance,
        InActiveStatus: !self.buStatus
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              $(_this.$refs.form).validate({
                rules: {
                  buBudgetName: "required",
                  buBudget: "required"
                },
                messages: {
                  buBudgetName: "กรุณาระบุชื่องบประมาณ",
                  buBudget: "กรุณาระบุงบประมาณ"
                }
              });
              $(_this.$refs.form).validate().settings.ignore = ":hidden";

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/BudgetBrand/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.buBudgetName = response.data.budgetName;
                  self.buProductBrandId = response.data.productBrandId;
                  self.buBudgetType = response.data.budgetTypeDesc;
                  self.buYear = response.data.year;
                  self.buBudget = response.data.budget;
                  response.data.usedAmout != null ? self.buUsed = response.data.usedAmout : self.buUsed = 0;
                  self.buBalance = response.data.balance;
                  self.buStatus = !response.data.inActiveStatus;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสินค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ItemRow__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import the component


// import the styles


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default.a,
    orderItemRow: __WEBPACK_IMPORTED_MODULE_3__ItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      cucProfileName: null,
      cucProfileTypeCode: null,
      cucPlantCode: null,
      cucAgentCode: null,
      cucShopCode: null,
      cucRoles: [],
      cucInActiveStatus: true,
      cucCompanyCode: null,
      scvdRole: null, // CR-StockCoverDays: SCVD role ที่เลือก (radio ไม่มี v-model) — ใช้คุมการแสดง/ผูกช่อง "บริษัท" (เฉพาะ Viewer ผูกคลัง)
      cucAgenCodeMapping: [],
      ShowAgentMappingSelect2: false,
      cucPhases: [],
      ShowPhaseSelect2: false,
      EmailAlertPM: false,
      EmailWebAlertOverdue: false,
      ShowEmailAlertPM: false,

      OdcAgentOptions: [],
      odcitems: [],
      ShowRoleOptionUserAndCoolService: false,

      // Budget Plan
      cucBudgetOrgIds: [],
      cucBudgetOrgOptions: [],
      ShowBudgetOrgSelect2: false,
      // Configurations
      cucProfileTypeCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        minimumResultsForSearch: -1,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "COMPANY_PROFILE_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cucCompanyCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        //minimumResultsForSearch: -1,
        ajax: {
          url: "/Api/CompanyProfile/Select2Company",
          data: function data(params) {
            var query = {
              profileTypeCode: self.cucProfileTypeCode,
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cucAgenCodeMappingOptions: [],
      // cucAgenCodeMappingOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   minimumResultsForSearch: -1,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchAgentName",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: [],
      //         province_id: [],
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      cucPhaseOptions: []
      // cucPhaseOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือก Phase",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterPhase/Select2Phase",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    showPmExampleModal: function showPmExampleModal() {
      $("#pmExampleModal").modal("show");
    },
    onAddItemClick: function onAddItemClick(e) {

      var _ucode = Date.now().toString(36) + Math.random().toString(36);
      this.odcitems.push({
        ucode: _ucode,
        odcAgentCode: null,
        odcSubAgentCode: null,
        odcRouteAgentOption: null,
        isSubAgentEditable: true,
        isAgentEditable: true,
        isDuplicated: false,
        isOptionRequired: true
      });

      this.onValidateDuplicated();
    },
    onValidateDuplicated: function onValidateDuplicated(e) {
      var arrItems = JSON.parse(JSON.stringify(this.odcitems));

      $.each(this.odcitems, function (index, obj) {
        obj.isDuplicated = false;
        $.each(arrItems, function (index2, obj2) {
          if (index != index2 && obj.odcAgentCode == obj2.odcAgentCode && obj.odcSubAgentCode == obj2.odcSubAgentCode) {
            obj.isDuplicated = true;
          }
        });
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.odcitems.splice(index, 1);
      for (var i = 0; i < this.odcitems.length; i++) {}
      this.onValidateDuplicated();
    },

    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var self = this;
      var router = this.$router;
      self.cucRoles = [];

      var radioVal = $("input:radio:checked");
      if (radioVal.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกบทบาท", "error");
      } else {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
        });

        $(radioVal).each(function (i) {
          self.cucRoles.push($(this).val());
        });

        if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_BR") {
          self.cucPlantCode = self.cucCompanyCode;
        } else if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_SCVD") {
          // CR-StockCoverDays: เฉพาะ "ผู้ใช้งาน" (SCVD_VIEWER) ผูกคลัง; แอดมิน/ทีม เห็นทุกคลัง → ไม่ผูก plant
          self.cucPlantCode = self.scvdRole == "SCVD_VIEWER" ? self.cucCompanyCode : null;
        } else if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_AGENT") {
          self.cucAgentCode = self.cucCompanyCode;
        } else if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_SUB_AGENT") {
          self.cucShopCode = self.cucCompanyCode;
        }

        if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") {
          var chk = self.cucRoles.includes("ADMIN_QI") || self.cucRoles.includes("MANAGER_QI") || self.cucRoles.includes("USER_QI");

          if (!chk) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกบทบาท จัดการข้อมูล", "error");
            KTApp.unblockPage();
            return false;
          }
        }

        //EmailAlertPm
        var EmailAlertPM = false;
        if ((self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_MKT" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") && (self.cucRoles.includes("USER_QI") || self.cucRoles.includes("USER_MKT"))) {
          EmailAlertPM = self.EmailAlertPM;
        }

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/CompanyProfile", {
          ProfileName: self.cucProfileName,
          ProfileTypeCode: self.cucProfileTypeCode,
          PlantCode: self.cucPlantCode,
          AgentCode: self.cucAgentCode,
          ShopCode: self.cucShopCode,
          Roles: self.cucRoles,
          InActiveStatus: !self.cucInActiveStatus,
          AgentCodes: self.cucAgenCodeMapping,
          Phases: self.cucPhases,
          EmailAlertPM: EmailAlertPM,
          EmailWebAlertOverdue: self.EmailWebAlertOverdue,
          PMClaims: self.odcitems,
          BudgetOrgIds: self.cucBudgetOrgIds
        }).then(function (response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
              router.go(-1), self.$parent.reloadDataTable(false);
            });
          } else {
            //console.log(response);
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }).then(function () {
          // always executed
          KTApp.unblockPage();
        });
      }
    },
    onClearRadioVal: function onClearRadioVal(name) {
      $("input[name=" + name + "]").prop("checked", false);

      this.ShowAgentMappingSelect2 = false;
      $("#cucAgenCodeMapping").val("").trigger("change");
      this.cucAgenCodeMapping = [];

      this.ShowPhaseSelect2 = false;
      $("#cucPhases").val("").trigger("change");
      this.cucPhases = [];

      // CR-StockCoverDays: เคลียร์ SCVD role ที่จำไว้ → ช่อง "บริษัท" กลับไปซ่อน
      if (name == "MANAGE_COMPANYPROFILE_SCVD") {
        this.scvdRole = null;
      }
    },
    onClearRadioValQI: function onClearRadioValQI(e) {
      $("#USER_DASHBOARD").prop("checked", false);
    },
    OnRadioBtnChange: function OnRadioBtnChange(e) {
      var self = this;
      var val = e.target.value;

      this.odcitems = [];
      if (val == 'USER_PM') {
        // || val == 'COOL_SERVICE_PM'
        self.ShowRoleOptionUserAndCoolService = true;
      } else {
        self.ShowRoleOptionUserAndCoolService = false;
      }

      //เครื่องเช่า
      if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING" && (val.includes("MANAGER") || val.includes("USER"))) {
        self.ShowPhaseSelect2 = true;
      } else {
        self.ShowPhaseSelect2 = false;
        $("#cucPhases").val("").trigger("change");
        self.cucPhases = [];
      }

      //อื่นๆ ที่ไม่ใช่เครื่องเช่า (ph2)
      if (self.cucProfileTypeCode != "COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING" && (self.cucProfileTypeCode != "COMPANY_PROFILE_TYPE_BEER_CLAIM" && val.includes("MANAGER") || val.includes("USER") || val.includes("TEAM") || val.includes("ADVISOR") || val.includes("COOL_SERVICE_PM") || val.includes("QI_OFFICER"))) {
        self.ShowAgentMappingSelect2 = true;
      } else {
        self.ShowAgentMappingSelect2 = false;
        $("#cucAgenCodeMapping").val("").trigger("change");

        this.cucAgenCodeMapping = [];
      }

      //cr-ตัวแทนย่อย
      if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_PM" && val.includes("USER")) {
        //|| val.includes("COOL_SERVICE_PM")
        self.ShowAgentMappingSelect2 = false;
      }

      //CR-FormSummaryStock: ชื่อบทบาทของ CR นี้ไม่มีคำที่บล็อก (ph2) ใช้ match (MANAGER/USER/TEAM/ADVISOR/...)
      //ช่อง "ตัวแทนจำหน่าย" จึงถูกปิดไปใน else ด้านบน ต้องเปิดเองเฉพาะ "แอดมิน (ตัวแทนจำหน่าย)"
      //เพราะขอบเขตข้อมูลของบทบาทนี้อ่านจาก AgentMapping ของโปรไฟล์ — ไม่ผูกตัวแทน = เห็นข้อมูล 0 รายการ
      //ส่วน "แอดมินทีมเบียร์สด" เห็นตัวแทนจำหน่ายทุกรายอยู่แล้ว จึงไม่ต้องผูก
      //(ซ่อนไว้ jQuery validate ข้าม required ให้เองผ่าน settings.ignore = ":hidden")
      if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK") {
        self.ShowAgentMappingSelect2 = val == "FORM_SUMMARY_STOCK_AGENT";
      }

      //EmailAlertPm
      if ((self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_MKT" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") && val.includes("USER")) {
        self.ShowEmailAlertPM = true;
      } else {
        self.ShowEmailAlertPM = false;
      }
    },
    onCucProfileTypeCodeChange: function onCucProfileTypeCodeChange() {
      var self = this;
      //Reset value
      $("input:radio").prop("checked", false);
      self.ShowAgentMappingSelect2 = false;
      $("#cucAgenCodeMapping").val("").trigger("change");

      this.cucAgenCodeMapping = [];

      self.ShowPhaseSelect2 = false;
      $("#cucPhases").val("").trigger("change");
      self.cucPhases = [];

      // Reset Budget Plan fields
      self.ShowBudgetOrgSelect2 = false;
      self.cucBudgetOrgIds = [];

      $("#cucCompanyCode").val("").trigger("change");

      if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_BR") {
        //Set Checked Def.
        $("#brJOB_RETRIEVE_ITEM").prop("checked", true);
      } else if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_AGENT") {
        //Set Checked Def.
        $("#aJOB_RETRIEVE_ITEM").prop("checked", true);
      } else if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_SUB_AGENT") {
        //Set Checked Def.
        $("#sJOB_RETRIEVE_ITEM").prop("checked", true);
      } else if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") {
        $("#USER_DASHBOARD").prop("checked", true);
      }
    },
    // onChnageAgenCodeMapping: function(e) {
    //   var self = this;
    //   self.ShowAgentMappingSelect2 = false;
    //   self.cucAgenCodeMapping = [];

    //   // if(self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_PM" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_BEER_CLAIM" ||
    //   // self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_QI" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_MKT" ||
    //   // self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_5S" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING"){
    //   //   return true;
    //   // }else{
    //   //   return false;
    //   // }
    // },
    onShowCompanySelect2: function onShowCompanySelect2(e) {
      var self = this;
      // CR-StockCoverDays: SCVD ผูกคลังเฉพาะ "ผู้ใช้งาน" (SCVD_VIEWER) เท่านั้น
      // แอดมิน (SCVD_ADMIN) + ทีมสร้าง/แก้ไข (SCVD_TEAM_EDIT) เห็นทุกคลัง → ซ่อนช่อง "บริษัท" + ไม่ required
      // (ซ่อนแล้ว jQuery validate ข้าม required อัตโนมัติผ่าน settings.ignore = ":hidden")
      if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_SCVD") {
        return self.scvdRole == "SCVD_VIEWER";
      }
      if (self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_BR" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_AGENT" || self.cucProfileTypeCode == "COMPANY_PROFILE_TYPE_SUB_AGENT") {
        return true;
      } else {
        return false;
      }
    },
    SelectAllAgent: function SelectAllAgent(e) {
      var self = this;
      var checkAllAgent = $("input[name=cucIsAllAgent]").prop("checked");
      if (checkAllAgent) {
        self.cucAgenCodeMappingOptions.forEach(function (x) {
          self.cucAgenCodeMapping.push(x.id);
        });
      } else {
        self.cucAgenCodeMapping = [];
        $("#cucAgenCodeMapping").val("").trigger("change");
      }
    },
    LoadcucAgenCodeMappingOptions: function LoadcucAgenCodeMappingOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Agents/Select2SearchAgentName", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.cucAgenCodeMappingOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadcucPhaseOptions: function LoadcucPhaseOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/MasterPhase/Select2Phase", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.cucPhaseOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    // Budget Plan Methods
    OnBudgetPlanRoleChange: function OnBudgetPlanRoleChange(e) {
      var self = this;
      var val = e.target.value;

      // ผู้ตรวจสอบ (Reviewer) จะมองเห็นทุก Org ไม่ต้องเลือก
      if (val == "BUDGET_PLAN_REVIEWER") {
        self.ShowBudgetOrgSelect2 = false;
        self.cucBudgetOrgIds = [];
      } else {
        // ผู้ใช้งาน และ ผู้จัดการฝ่าย ต้องเลือก Org
        self.ShowBudgetOrgSelect2 = true;
      }
    },
    LoadcucBudgetOrgOptions: function LoadcucBudgetOrgOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/CompanyProfile/Select2BudgetOrgs", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.cucBudgetOrgOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              self.LoadcucAgenCodeMappingOptions();
              self.LoadcucPhaseOptions();
              self.LoadcucBudgetOrgOptions();

              //set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  cucProfileName: "required",
                  cucProfileTypeCode: "required",
                  cucCompanyCode: "required",
                  cucRoles: {
                    required: true,
                    minlength: 1
                  },
                  cucAgenCodeMapping: "required",
                  cucPhases: "required"
                },
                messages: {
                  cucProfileName: "กรุณากรอกชื่อโปรไฟล์บริษัท",
                  cucProfileTypeCode: "กรุณาเลือกประเภทโปรไฟล์บริษัท",
                  cucCompanyCode: "กรุณาเลือกบริษัท",
                  cucRoles: "กรุณาเลือกบทบาท",
                  cucAgenCodeMapping: "กรุณาเลือกตัวแทนจำหน่าย",
                  cucPhases: "กรุณาเลือก Phase"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#custProfileTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/CompanyProfile/" + _this.data.id + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#custProfileTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/CompanyProfile/" + _this2.data.id + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editCompanyProfile\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n     <a href=\"#\" @click.prevent=\"deleteCompanyProfile\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    editCompanyProfile: function editCompanyProfile() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/CompanyProfile/Edit/" + this.data.id
      });
    },
    deleteCompanyProfile: function deleteCompanyProfile() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลโปรไฟล์บริษัท",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลโปรไฟล์บริษัท <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้โปรไฟล์บริษัทนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลโปรไฟล์บริษัทออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/CompanyProfile/" + _this3.data.id + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      cplInActiveStatus: null,
      cplKeyword: null,
      cplProfileTypeCode: null,
      cplAgentCode: null,

      // Configurations
      cplProfileTypeCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "COMPANY_PROFILE_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cplInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      },
      cplAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      //default Active Data
      this.cplInActiveStatus = false;
      $("#cplInActiveStatus").val(this.cplInActiveStatus + "").trigger("change");

      $("#cplProfileTypeCode").val("").trigger("change");

      $("#cplAgentCode").val("").trigger("change");

      this.cplKeyword = null;

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#custProfileTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#custProfileTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;

              //default Active Data

              self.cplInActiveStatus = false;
              $("#cplInActiveStatus").val(self.cplInActiveStatus + "").trigger("change");
              $.fn.dataTable.ext.errMode = 'none';
              table = $("#custProfileTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/CompanyProfile/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      CompanyType: self.cplProfileTypeCode,
                      InActiveStatus: self.cplInActiveStatus,
                      SearchKeyword: self.cplKeyword,
                      AgentCode: self.cplAgentCode
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[6, "desc"]],
                columns: [{
                  data: null,
                  className: "details-control",
                  defaultContent: "",
                  orderable: false
                }, { data: "profileName" }, { data: "profileTypeName", className: "text-center" }, { data: "companyName", className: "text-center",

                  render: function render(data, type, full, meta) {
                    var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>" + data + "</pre>";
                    return html;
                  }
                }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, { data: "agentMappingStringFormat", className: "text-center" }, {
                  data: "id",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_COMPANY_PROFILE"]);
                    if (data.inActiveStatus == false) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == true) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_COMPANY_PROFILE"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_COMPANY_PROFILE"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ItemRow__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import the component


// import the styles


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default.a,
    orderItemRow: __WEBPACK_IMPORTED_MODULE_3__ItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      isChange: false,
      cuuId: null,
      cuuProfileName: null,
      cuuProfileTypeCode: null,
      cuuPlantCode: null,
      cuuAgentCode: null,
      cuuShopCode: null,
      cuuSubAgent: null,
      cuuRoles: [],
      cuuRoleType: [],
      cuuRoleTypeOptions: [],
      cuuInActiveStatus: null,
      cuuCompanyCode: null,
      scvdRole: null, // CR-StockCoverDays: SCVD role ที่เลือก (radio ไม่มี v-model) — ใช้คุมการแสดง/ผูกช่อง "บริษัท" (เฉพาะ Viewer ผูกคลัง)
      ShowAgentMappingSelect2: false,
      cuuAgenCodeMapping: [],
      cuuPhases: [],
      ShowPhaseSelect2: false,
      EmailAlertPM: false,
      EmailWebAlertOverdue: false,
      ShowEmailAlertPM: false,

      OdcAgentOptions: [],
      odcitems: [],
      ShowRoleOptionUserAndCoolService: false,

      // Budget Plan
      cuuBudgetOrgIds: [],
      cuuBudgetOrgOptions: [],
      ShowBudgetOrgSelect2: false,

      // Configurations
      cuuProfileTypeCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        minimumResultsForSearch: -1,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "COMPANY_PROFILE_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cuuCompanyCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        //minimumResultsForSearch: -1,
        ajax: {
          url: "/Api/CompanyProfile/Select2Company",
          data: function data(params) {
            var query = {
              profileTypeCode: self.cuuProfileTypeCode,
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cuuAgenCodeMappingOptions: [],
      // cuuAgenCodeMappingOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   minimumResultsForSearch: -1,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchAgentName",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: [],
      //         province_id: [],
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      cuuPhaseOptions: []
      // cuuPhaseOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือก Phase",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterPhase/Select2Phase",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    showPmExampleModal: function showPmExampleModal() {
      $("#pmExampleModal").modal("show");
    },
    onAddItemClick: function onAddItemClick(e) {
      var _ucode = Date.now().toString(36) + Math.random().toString(36);
      this.odcitems.push({
        ucode: _ucode,
        odcAgentCode: null,
        odcSubAgentCode: null,
        odcRouteAgentOption: null,
        isSubAgentEditable: true,
        isAgentEditable: true,
        isDuplicated: false,
        isOptionRequired: true
      });

      this.onValidateDuplicated();
    },
    onValidateDuplicated: function onValidateDuplicated(e) {
      var arrItems = JSON.parse(JSON.stringify(this.odcitems));

      $.each(this.odcitems, function (index, obj) {
        obj.isDuplicated = false;
        $.each(arrItems, function (index2, obj2) {
          if (index != index2 && obj.odcAgentCode == obj2.odcAgentCode && obj.odcSubAgentCode == obj2.odcSubAgentCode) {
            obj.isDuplicated = true;
          }
        });
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.odcitems.splice(index, 1);
      for (var i = 0; i < this.odcitems.length; i++) {}
      this.onValidateDuplicated();
    },

    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var self = this;
      var router = this.$router;

      var radioVal = $("input:radio:checked");
      if (radioVal.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกบทบาท", "error");
        // always executed
        KTApp.unblockPage();
      } else {
        //Begin:Get all radio value
        var allRadio = $("input:radio");
        var radioVal = [];
        var existingVal = [];
        var checkedVal = [];
        $(allRadio).each(function (i) {
          var val = $(this).val();
          radioVal.push(val);
        });
        var uniqueArray = Array.from(new Set(radioVal));
        //End:Get all radio value

        //Begin:Check Val Existing not in radio value
        $(self.cuuRoles).each(function (i) {
          if (!uniqueArray.includes(this)) {
            existingVal.push(this);
          }
        });
        //End:Check Val Existing not in radio value

        var checkedList = $("input:radio:checked");
        $(checkedList).each(function (i) {
          var checked = $(this).val();
          checkedVal.push(checked);
        });

        var finalVal = checkedVal.concat(existingVal);
        if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") {
          var chk = finalVal.includes("ADMIN_QI") || finalVal.includes("MANAGER_QI") || finalVal.includes("USER_QI");

          if (!chk) {
            Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกบทบาท จัดการข้อมูล", "error");
            KTApp.unblockPage();
            return false;
          }
        }

        if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_BR") {
          self.cuuPlantCode = self.cuuCompanyCode;
        } else if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_SCVD") {
          // CR-StockCoverDays: เฉพาะ "ผู้ใช้งาน" (SCVD_VIEWER) ผูกคลัง; แอดมิน/ทีม เห็นทุกคลัง → ไม่ผูก plant
          self.cuuPlantCode = self.scvdRole == "SCVD_VIEWER" ? self.cuuCompanyCode : null;
        } else if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_AGENT") {
          self.cuuAgentCode = self.cuuCompanyCode;
        } else if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_SUB_AGENT") {
          self.cuuShopCode = self.cuuCompanyCode;
        }

        //EmailAlertPm
        var EmailAlertPM = false;
        if ((self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_MKT" || self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") && (finalVal.includes("USER_QI") || finalVal.includes("USER_MKT"))) {
          EmailAlertPM = self.EmailAlertPM;
        }

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/CompanyProfile", {
          CompanyProfileId: self.cuuId,
          ProfileName: self.cuuProfileName,
          ProfileTypeCode: self.cuuProfileTypeCode,
          PlantCode: self.cuuPlantCode,
          AgentCode: self.cuuAgentCode,
          ShopCode: self.cuuShopCode,
          Roles: finalVal,
          InActiveStatus: !self.cuuInActiveStatus,
          AgentCodes: self.cuuAgenCodeMapping,
          Phases: self.cuuPhases,
          EmailAlertPM: EmailAlertPM,
          EmailWebAlertOverdue: self.EmailWebAlertOverdue,
          PMClaims: self.odcitems,
          BudgetOrgIds: self.cuuBudgetOrgIds
        }).then(function (response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
              router.go(-1), self.$parent.reloadDataTable(false);
            });
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }).then(function () {
          // always executed
          KTApp.unblockPage();
        });
      }
    },
    cuuProfileTypeChange: function cuuProfileTypeChange(ref) {
      var self = this;
      if (self.isChange) {

        $("#cuuAgenCodeMapping").val("").trigger("change");

        this.cuuAgenCodeMapping = [];

        $("input:radio").prop("checked", false);

        $("#cuuCompanyCode").val("").trigger("change");

        self.ShowAgentMappingSelect2 = false;
        $("#cucAgenCodeMapping").val("").trigger("change");

        this.cucAgenCodeMapping = [];

        self.ShowPhaseSelect2 = false;
        $("#cuuPhases").val("").trigger("change");
        self.cuuPhases = [];

        if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_BR") {
          //Set Checked Def.
          $("#brJOB_RETRIEVE_ITEM").prop("checked", true);
        } else if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_AGENT") {
          //Set Checked Def.
          $("#aJOB_RETRIEVE_ITEM").prop("checked", true);
        } else if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_SUB_AGENT") {
          //Set Checked Def.
          $("#sJOB_RETRIEVE_ITEM").prop("checked", true);
        }
      } else {
        self.isChange = false;
      }
    },
    onClearRadioVal: function onClearRadioVal(name) {
      $("input[name=" + name + "]").prop("checked", false);
      this.ShowAgentMappingSelect2 = false;

      $("#cuuAgenCodeMapping").val("").trigger("change");

      this.cuuAgenCodeMapping = [];

      this.ShowPhaseSelect2 = false;
      $("#cuuPhases").val("").trigger("change");
      this.cuuPhases = [];

      // CR-StockCoverDays: เคลียร์ SCVD role ที่จำไว้ → ช่อง "บริษัท" กลับไปซ่อน
      if (name == "MANAGE_COMPANYPROFILE_SCVD") {
        this.scvdRole = null;
      }
    },
    onClearRadioValQI: function onClearRadioValQI(e) {
      $("#USER_DASHBOARD").prop("checked", false);
    },
    OnRadioBtnChange: function OnRadioBtnChange(e) {
      var self = this;
      var val = e.target.value;

      //this.odcitems = [];
      if (val == 'USER_PM') {
        // || val == 'COOL_SERVICE_PM'
        self.ShowRoleOptionUserAndCoolService = true;
      } else {
        self.ShowRoleOptionUserAndCoolService = false;
      }

      //เครื่องเช่า
      if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING" && (val.includes("MANAGER") || val.includes("USER"))) {
        self.ShowPhaseSelect2 = true;
      } else {
        self.ShowPhaseSelect2 = false;
        $("#cuuPhases").val("").trigger("change");
        self.cuuPhases = [];
      }

      //อื่นๆ ที่ไม่ใช่เครื่องเช่า (ph2)
      if (self.cuuProfileTypeCode != "COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING" && (self.cuuProfileTypeCode != "COMPANY_PROFILE_TYPE_BEER_CLAIM" && val.includes("MANAGER") || val.includes("USER") || val.includes("ADVISOR") || val.includes("TEAM") || val.includes("COOL_SERVICE_PM") || val.includes("QI_OFFICER"))) {
        self.ShowAgentMappingSelect2 = true;
      } else {
        self.ShowAgentMappingSelect2 = false;
        $("#cuuAgenCodeMapping").val("").trigger("change");

        this.cuuAgenCodeMapping = [];
      }

      //cr-ตัวแทนย่อย
      if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_PM" && val.includes("USER")) {
        // || val.includes("COOL_SERVICE_PM")
        self.ShowAgentMappingSelect2 = false;
      }

      //CR-FormSummaryStock: ชื่อบทบาทของ CR นี้ไม่มีคำที่บล็อก (ph2) ใช้ match (MANAGER/USER/TEAM/ADVISOR/...)
      //ช่อง "ตัวแทนจำหน่าย" จึงถูกปิดไปใน else ด้านบน ต้องเปิดเองเฉพาะ "แอดมิน (ตัวแทนจำหน่าย)"
      //เพราะขอบเขตข้อมูลของบทบาทนี้อ่านจาก AgentMapping ของโปรไฟล์ — ไม่ผูกตัวแทน = เห็นข้อมูล 0 รายการ
      //ส่วน "แอดมินทีมเบียร์สด" เห็นตัวแทนจำหน่ายทุกรายอยู่แล้ว จึงไม่ต้องผูก
      //(ซ่อนไว้ jQuery validate ข้าม required ให้เองผ่าน settings.ignore = ":hidden")
      if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK") {
        self.ShowAgentMappingSelect2 = val == "FORM_SUMMARY_STOCK_AGENT";
      }

      //EmailAlertPm
      if ((self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_MKT" || self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") && val.includes("USER")) {
        self.ShowEmailAlertPM = true;
      } else {
        self.ShowEmailAlertPM = false;
      }
    },
    onShowCompanySelect2: function onShowCompanySelect2(e) {
      var self = this;
      // CR-StockCoverDays: SCVD ผูกคลังเฉพาะ "ผู้ใช้งาน" (SCVD_VIEWER) เท่านั้น
      // แอดมิน (SCVD_ADMIN) + ทีมสร้าง/แก้ไข (SCVD_TEAM_EDIT) เห็นทุกคลัง → ซ่อนช่อง "บริษัท" + ไม่ required
      // (ซ่อนแล้ว jQuery validate ข้าม required อัตโนมัติผ่าน settings.ignore = ":hidden")
      if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_SCVD") {
        return self.scvdRole == "SCVD_VIEWER";
      }
      if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_BR" || self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_AGENT" || self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_SUB_AGENT") {
        return true;
      } else {
        return false;
      }
    },
    SelectAllAgent: function SelectAllAgent(e) {
      var self = this;
      var checkAllAgent = $("input[name=cuuIsAllAgent]").prop("checked");
      if (checkAllAgent) {
        self.cuuAgenCodeMappingOptions.forEach(function (x) {
          self.cuuAgenCodeMapping.push(x.id);
        });
      } else {
        self.cuuAgenCodeMapping = [];
        $("#cuuAgenCodeMapping").val("").trigger("change");
      }
    },
    LoadcuuAgenCodeMappingOptions: function LoadcuuAgenCodeMappingOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Agents/Select2SearchAgentName", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.cuuAgenCodeMappingOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadcuuPhaseOptions: function LoadcuuPhaseOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/MasterPhase/Select2Phase", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.cuuPhaseOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    // Budget Plan Methods
    OnBudgetPlanRoleChange: function OnBudgetPlanRoleChange(e) {
      var self = this;
      var val = e.target.value;

      // ผู้ตรวจสอบ (Reviewer) จะมองเห็นทุก Org ไม่ต้องเลือก
      if (val == "BUDGET_PLAN_REVIEWER") {
        self.ShowBudgetOrgSelect2 = false;
        self.cuuBudgetOrgIds = [];
      } else {
        // ผู้ใช้งาน และ ผู้จัดการฝ่าย ต้องเลือก Org
        self.ShowBudgetOrgSelect2 = true;
      }
    },
    LoadcuuBudgetOrgOptions: function LoadcuuBudgetOrgOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/CompanyProfile/Select2BudgetOrgs", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.cuuBudgetOrgOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              self.LoadcuuAgenCodeMappingOptions();
              self.LoadcuuPhaseOptions();
              self.LoadcuuBudgetOrgOptions();

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/CompanyProfile/" + _this.$route.params.id + "/GetRowEdit").then(function (response) {

                console.log('------------------------start-----------------------------');
                console.log(response);

                if (response.status == 200) {
                  self.cuuId = response.data.id;
                  self.cuuProfileName = response.data.profileName;
                  self.cuuInActiveStatus = !response.data.inActiveStatus;
                  self.EmailAlertPM = response.data.emailAlertPM;
                  self.EmailWebAlertOverdue = response.data.emailWebAlertOverdue;
                  self.cuuProfileTypeCode = response.data.profileTypeCode;

                  setTimeout(function () {
                    if (response.data.profileTypeCode) {
                      self.$refs.cuuProfileTypeCodeSelect2.setSelectedData({
                        id: response.data.profileTypeCode,
                        text: response.data.profileTypeName
                      });

                      setTimeout(function () {
                        if (response.data.plantCode) {
                          self.cuuCompanyCode = response.data.plantCode;
                          self.$refs.cuuCompanyCodeSelect2.setSelectedData({
                            id: response.data.plantCode,
                            text: response.data.plantName
                          });
                        }

                        if (response.data.agentCode) {
                          self.cuuCompanyCode = response.data.agentCode;
                          self.$refs.cuuCompanyCodeSelect2.setSelectedData({
                            id: response.data.agentCode,
                            text: response.data.agentName
                          });
                        }

                        if (response.data.shopCode) {
                          self.cuuCompanyCode = response.data.shopCode;
                          self.$refs.cuuCompanyCodeSelect2.setSelectedData({
                            id: response.data.shopCode,
                            text: response.data.shopName
                          });
                        }
                      }, 100);
                    }

                    if (response.data.agentMapping) {
                      if (response.data.agentMapping.length > 0) {
                        self.ShowAgentMappingSelect2 = true;
                      }
                      response.data.agentMapping.forEach(function (x) {
                        self.cuuAgenCodeMapping.push(x.agentCode);
                      });
                      // var agentMappingOptions = $.map(
                      //   response.data.agentMapping,
                      //   function(obj, idx) {
                      //     return {
                      //       id: obj.agentCode,
                      //       text: "[" + obj.agentCode + "] " + obj.agentName,
                      //     };
                      //   }
                      // );
                      // self.$refs.cuuAgenCodeMappingSelect2.setSelectedData(
                      //   agentMappingOptions
                      // );
                    }

                    if (response.data.phases) {
                      if (response.data.phases.length > 0) {
                        self.ShowPhaseSelect2 = true;
                      }
                      response.data.phases.forEach(function (x) {
                        self.cuuPhases.push(x);
                      });
                      // var phaseOptions = $.map(response.data.phases, function(
                      //   obj,
                      //   idx
                      // ) {
                      //   return {
                      //     id: obj,
                      //     text: obj,
                      //   };
                      // });
                      // self.$refs.cuuPhasesSelect2.setSelectedData(phaseOptions);
                    }

                    //เครื่องเช่า
                    if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING") {
                      if (response.data.roles[0].includes("MANAGER") || response.data.roles[0].includes("USER")) {
                        self.ShowPhaseSelect2 = true;
                      }
                    }

                    //BEER_CLAIM
                    if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_BEER_CLAIM") {
                      if (response.data.roles[0].includes("QI_OFFICER_BEER_CLAIM")) {
                        self.ShowAgentMappingSelect2 = true;
                      } else self.ShowAgentMappingSelect2 = false;
                    }

                    //อื่นๆ ที่ไม่ใช่เครื่องเช่า (ph2)
                    if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_PM" || self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_QI" || self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_MKT" || self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_5S") {
                      if (response.data.roles[0].includes("MANAGER") || response.data.roles[0].includes("USER") || response.data.roles[0].includes("COOL_SERVICE_PM")) {
                        self.ShowAgentMappingSelect2 = true;
                      }
                    }

                    //CR-FormSummaryStock: radio ถูก restore ด้วย .attr("checked") ซึ่งไม่ยิง change
                    //จึงต้องตัดสินการแสดงช่อง "ตัวแทนจำหน่าย" เองตอนโหลด โดยยึดตามบทบาทที่บันทึกไว้
                    //ไม่ยึดจำนวน agentMapping ที่โหลดมา เพราะโปรไฟล์ตัวแทนที่ยังไม่เคยผูกตัวแทนจะมี 0 แถว
                    //แล้วช่องจะไม่โผล่ ทำให้แก้ให้ครบไม่ได้
                    if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK") {
                      self.ShowAgentMappingSelect2 = response.data.roles != null && response.data.roles.includes("FORM_SUMMARY_STOCK_AGENT");
                    }

                    //cr-ตัวแทนย่อย 

                    var is_user_role = false;
                    if (response.data.roles != null) {
                      for (var i = 0; i < response.data.roles.length; i++) {
                        if (response.data.roles[i].includes("USER")) {
                          is_user_role = true;
                          break;
                        }
                      }
                    }
                    if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_PM" && is_user_role) {
                      //|| response.data.roles[0].includes("COOL_SERVICE_PM")

                      self.ShowAgentMappingSelect2 = false;
                      self.ShowRoleOptionUserAndCoolService = true;

                      //self.odcitems = response.data.pmClaims;

                      console.log(response.data.pmClaims);

                      var _loop = function _loop(_i) {
                        _ucode = Date.now().toString(36) + Math.random().toString(36);
                        item = response.data.pmClaims[_i];

                        self.odcitems.push({
                          ucode: _ucode,
                          odcAgentCode: item.odcAgentCode,
                          odcSubAgentCode: item.odcSubAgentCode,
                          odcRouteAgentOption: item.odcRouteAgentOption,
                          isSubAgentEditable: item.isSubAgentEditable,
                          isAgentEditable: item.isAgentEditable,
                          isDuplicated: item.isDuplicated,
                          isOptionRequired: false,
                          HideGroupOdcRouteAgentOptionShow: item.odcAgentCode != null ? false : true,

                          selectedAgentCodeData: {
                            id: item.odcAgentCode,
                            text: "[" + item.odcAgentCode + "] " + item.odcAgentName,
                            data: null
                          },
                          selectedSubAgentData: {
                            id: item.odcSubAgentCode,
                            text: item.odcSubAgentName,
                            data: null
                          }

                        });
                        //
                        setTimeout(function () {
                          if (self.odcitems[_i].selectedAgentCodeData.id != null) {
                            self.$refs.pmRoleItems[_i].$refs.odcAgentCode.setSelectedData(self.odcitems[_i].selectedAgentCodeData);
                          }
                        }, 100);
                        setTimeout(function () {
                          if (self.odcitems[_i].selectedSubAgentData.id != null) {
                            self.$refs.pmRoleItems[_i].$refs.odcSubAgentCode.setSelectedData(self.odcitems[_i].selectedSubAgentData);
                          }
                        }, 100);
                      };

                      for (var _i = 0; _i < response.data.pmClaims.length; _i++) {
                        var _ucode;

                        var item;

                        _loop(_i);
                      }
                    }

                    // console.log(self.odcitems);

                    //EmailAlertPm
                    if ((self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_MKT" || self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_QI") && response.data.roles[0].includes("USER")) {
                      self.ShowEmailAlertPM = true;
                    } else {
                      self.ShowEmailAlertPM = false;
                    }

                    // Budget Plan Org Mapping
                    if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_BUDGET") {
                      if (response.data.budgetOrgMapping && response.data.budgetOrgMapping.length > 0) {
                        self.cuuBudgetOrgIds = response.data.budgetOrgMapping.map(function (item) {
                          return item.orgId;
                        });
                        // ถ้ามี OrgIds แสดงว่าไม่ใช่ Reviewer
                        self.ShowBudgetOrgSelect2 = true;
                      } else {
                        // ถ้าไม่มี OrgIds ตรวจสอบว่าเป็น Reviewer หรือไม่
                        if (response.data.roles.includes("BUDGET_PLAN_REVIEWER")) {
                          self.ShowBudgetOrgSelect2 = false;
                        } else {
                          self.ShowBudgetOrgSelect2 = true;
                        }
                      }
                    }
                  }, 100);

                  if (response.data.roles.length > 0) {
                    var formatId = "";
                    if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_SUB_AGENT") formatId = "s";
                    if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_AGENT") formatId = "a";
                    if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_BR") formatId = "br";

                    for (var i = 0; i < response.data.roles.length; i++) {
                      var role = response.data.roles[i];
                      $("#" + formatId + role).attr("checked", true);
                      self.cuuRoles.push(role);
                    }
                    // CR-StockCoverDays: จำ SCVD role ที่โหลดมา (radio ไม่มี v-model) เพื่อคุมการแสดงช่อง "บริษัท"
                    if (self.cuuProfileTypeCode == "COMPANY_PROFILE_TYPE_SCVD") {
                      self.scvdRole = response.data.roles.find(function (r) {
                        return r == "SCVD_ADMIN" || r == "SCVD_VIEWER" || r == "SCVD_TEAM_EDIT";
                      }) || null;
                    }

                    //$("#aSUB_AGENT_ADMIN_PM").attr("checked", true);
                  }
                  setTimeout(function () {
                    self.isChange = true;
                  }, 50);
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลโปรไฟล์บริษัทคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลโปรไฟล์บริษัทได้ในขณะนี้", "error");

                return;
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  cuuProfileName: "required",
                  cuuProfileTypeCode: "required",
                  cuuCompanyCode: "required",
                  cuuRoles: {
                    required: true,
                    minlength: 1
                  },
                  cuuAgenCodeMapping: "required",
                  cuuPhases: "required"
                },
                messages: {
                  cuuProfileName: "กรุณากรอกชื่อโปรไฟล์บริษัท",
                  cuuProfileTypeCode: "กรุณาเลือกประเภทโปรไฟล์บริษัท",
                  cuuCompanyCode: "กรุณาเลือกบริษัท",
                  cuuRoles: "กรุณาเลือกบทบาท",
                  cuuAgenCodeMapping: "กรุณาเลือกตัวแทนจำหน่าย",
                  cuuPhases: "กรุณาเลือก Phase"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */]
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var self = this;
    var ldata = [];

    ldata.push({
      id: "AGENT_SHOP",
      text: "ร้านค้าทั้งหมดของตัวแทนจำหน่าย"
    });
    ldata.push({
      id: "AGENT_SHOP_SUBAGENT_SHOP",
      text: "ร้านค้าทั้งหมดของตัวแทนจำหน่าย และ ร้านค้าทั้งหมดของตัวแทนจำหน่ายย่อย"
    });

    return {
      itemAgentCode: null,
      RouteAgentOptions: ldata,
      OdcAgentOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          //type: "POST",
          delay: 300,
          url: "/Api/Agents/Select2Agents",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      OdcSubAgentOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่ายย่อย",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Agents/Select2SubShopAgent",
          data: function data(params) {
            var agent = null;
            if (self.item.odcAgentCode !== undefined) {
              if (self.item.odcAgentCode) {
                agent = self.item.odcAgentCode;
              }
            }

            var query = {
              agentCode: agent,
              all: true,
              onlySubAgent: true,
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      odcBudgetIdOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/BudgetBrand/Select2BudgetQuery",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      odcQuotaIdOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Quota/Select2Quota",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },


  computed: {
    totalCal: function totalCal() {
      return this.item.odcTotal = this.item.odcQuantity * this.item.odcPrice;
    }
  },
  methods: {
    onClearRadioVal: function onClearRadioVal(name) {
      var _this = this;

      $("input[name=" + name + "]").prop("checked", false);

      setTimeout(function () {
        _this.$parent.odcitems[_this.rowIndex].isSubAgentEditable = true;

        _this.$parent.odcitems[_this.rowIndex].isOptionRequired = true;
      }, 100);
    },
    onRemoveItemClick: function onRemoveItemClick(e) {
      //alert(this.rowIndex);
      //this.$parent.odcitems.splice(this.rowIndex-1, 1);
      this.$emit("removeItem", this.rowIndex, this.item);
    },

    onAgentChange: function onAgentChange(id, text, data, ref) {
      var self = this;
      // clear sub agent 
      $("#odcSubAgentCode" + self._uid).val("").trigger("change");

      this.$parent.onValidateDuplicated();
    },
    onRouteAgentOptionGroupChange: function onRouteAgentOptionGroupChange(id, text, data, ref) {
      var self = this;

      this.$parent.odcitems[this.rowIndex].isOptionRequired = false;

      if (this.$parent.odcitems[this.rowIndex].odcRouteAgentOption == "AGENT_SHOP_SUBAGENT_SHOP") {
        this.$parent.odcitems[this.rowIndex].isSubAgentEditable = false;
        this.$parent.odcitems[this.rowIndex].odcSubAgentCode = null;
        $("#odcSubAgentCode" + self._uid).val("").trigger("change");
      } else {
        this.$parent.odcitems[this.rowIndex].isSubAgentEditable = true;
      }
    },
    onSubAgentChange: function onSubAgentChange(id, text, data, ref) {
      var self = this;

      if (($("#odcAgentCode" + self._uid).val() == null || $("#odcAgentCode" + self._uid).val().length <= 0) && $("#odcSubAgentCode" + self._uid).val() != null && $("#odcSubAgentCode" + self._uid).val().length > 0) {
        $("input[name=" + 'odcRouteAgentOption' + self._uid + "]").prop("checked", false);
        $("#gOdcRouteAgentOption" + self._uid).hide();
        this.$parent.odcitems[this.rowIndex].isOptionRequired = false;
      } else {
        $("#gOdcRouteAgentOption" + self._uid).show();
        if (this.$parent.odcitems[this.rowIndex].odcRouteAgentOption != null) {
          this.$parent.odcitems[this.rowIndex].isOptionRequired = false;
        } else {
          this.$parent.odcitems[this.rowIndex].isOptionRequired = true;
        }
      }

      this.$parent.onValidateDuplicated();
    }
  },
  mounted: function mounted() {

    $(".required", this.$el).each(function () {
      var $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required")
        }
      });
    });
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      cocContactName: null,
      cocContactLastName: null,
      cocContactPositions: null,
      cocContactNickName: null,
      cocContactTel: null,
      cocContactEmail: null,
      cocCompanyId: null,
      cocAgentId: null,
      cocVendorId: null,
      cocPlantId: null,
      cocOtherId: null,
      cocContactType: null,
      cocInActiveStatus: true,
      cocContactTypeOptions: {
        placeholder: "กรุณาเลือก",
        data: [{ id: "agent", text: "Agent", data: null }, { id: "vendor", text: "Supplier", data: null }, { id: "plant", text: "คลังสินค้า", data: null }, { id: "other", text: "อื่นๆ", data: null }]
      },
      cocCompanyIdOptions: {
        placeholder: "กรุณาเลือก",
        data: [{ id: "", text: "", data: null }]
      },
      cocAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cocVendorOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cocPlantOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Plant/Select2Plant",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$(this.$refs.form).validate().form()) {
        //console.log("if : ");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;

      var tmp = "";
      if (this.cocContactType == "agent") {
        tmp = this.cocAgentId;
      } else if (this.cocContactType == "vendor") {
        tmp = this.cocVendorId;
      } else if (this.cocContactType == "plant") {
        tmp = this.cocPlantId;
      } else if (this.cocContactType == "other") {
        tmp = this.cocOtherId;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/TransitContactor", {
        ContactName: this.cocContactName,
        ContactLastName: this.cocContactLastName,
        ContactPositions: this.cocContactPositions,
        ContactNickName: this.cocContactNickName,
        ContactTel: this.cocContactTel,
        ContactEmail: this.cocContactEmail,
        CompanyType: this.cocContactType,
        CompanyID: tmp,
        InActiveStatus: !this.cocInActiveStatus
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          //console.log(response);
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
    // validateEmail() {
    //   const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   var check = re.test(this.cocContactEmail);
    //   if (check) {
    //     // email valid
    //     console.log("email valid");
    //   } else {
    //     //email invalid
    //     console.log("email invalid");
    //   }
    // },
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              $(_this.$refs.form).validate({
                rules: {
                  cocContactType: "required",
                  cocCompanyId: "required",
                  cocAgentId: "required",
                  cocVendorId: "required",
                  cocPlantId: "required",
                  cocContactName: "required",
                  cocContactLastName: "required",
                  cocContactPositions: "required",
                  cocContactTel: "required",
                  cocContactEmail: {
                    required: true,
                    regex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    //email: true,
                  }
                },
                messages: {
                  cocContactType: "กรุณาเลือกประเภทผู้ติดต่อ",
                  cocCompanyId: "กรุณาเลือกบริษัท",
                  cocAgentId: "กรุณาเลือกบริษัท",
                  cocVendorId: "กรุณาเลือกบริษัท",
                  cocPlantId: "กรุณาเลือกบริษัท",
                  cocContactName: "กรุณากรอกชื่อ",
                  cocContactLastName: "กรุณากรอกนามสกุล",
                  cocContactPositions: "กรุณากรอกตำแหน่ง",
                  cocContactTel: "กรุณากรอกเบอร์ติดต่อ",
                  cocContactEmail: {
                    required: "กรุณากรอกอีเมล",
                    regex: "กรุณากรอกอีเมลให้ถูกต้อง"
                    //email: "กรุณากรอกอีเมลให้ถูกต้อง",
                  }
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);
var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#contactTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/TransitContactor/" + _this.data.transitContactorId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#contactTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/TransitContactor/" + _this2.data.transitContactorId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1C\u0E39\u0E49\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"remove\" v-if=\"data.showDeleteButton\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1C\u0E39\u0E49\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/Contact/Update/" + this.data.transitContactorId
      });
    },
    remove: function remove() {
      var _this3 = this;

      var self = this;

      Swal.fire({
        title: "คำสั่งลบข้อมูลผู้ติดต่อ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบผู้ติดต่อ <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ผู้ติดต่อนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบผู้ติดต่อออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/TransitContactor/" + _this3.data.transitContactorId + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    return {
      colKeyword: "",
      colCompanyType: "",
      colCompanyName: "",
      colInActiveStatus: "",
      //config
      colInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      },
      colCompanyTypeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "agent", text: "Agent", data: null }, { id: "vendor", text: "Supplier", data: null }, { id: "plant", text: "คลังสินค้า", data: null }, { id: "other", text: "อื่นๆ", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.colKeyword = "";

      //default Active Data
      this.colCompanyType = false;
      $("#colCompanyType").val("").trigger("change");

      this.colInActiveStatus = false;
      $("#colInActiveStatus").val(this.colInActiveStatus + "").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#contactTable").DataTable();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#contactTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;

              //default Active Data

              self.colInActiveStatus = false;
              $("#colInActiveStatus").val(self.colInActiveStatus + "").trigger("change");

              $("#colInActiveStatus").select2({
                tags: true,
                placeholder: "ทั้งหมด",
                allowClear: true
              });

              $("#colCompanyType").select2({
                tags: true,
                placeholder: "ทั้งหมด",
                allowClear: true
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#contactTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/TransitContactor/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.colKeyword,
                      CompanyType: $("#colCompanyType").val(),
                      InActiveStatus: $("#colInActiveStatus").val()
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[2, "desc"]],
                columns: [{ data: "createdDateFormat" }, {
                  data: "companyType",
                  width: "10%",
                  render: function render(data, type, full, meta) {
                    if (data == "agent") return "Agent";else if (data == "vendor") return "Supplier";else if (data == "plant") return "คลังสินค้า";else return "อื่นๆ";
                  }
                }, { data: "companyName",

                  render: function render(data, type, full, meta) {
                    var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>" + data + "</pre>";
                    return html;
                  }

                }, { data: "contactFullName", width: "20%" }, { data: "nickName" }, { data: "tel" }, { data: "email" }, { data: "position" }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "createDate",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_CONTACT"]);
                    if (data.inActiveStatus == false) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == true) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_CONTACT"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_CONTACT"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      couContactName: null,
      couContactLastName: null,
      couContactPositions: null,
      couContactNickName: null,
      couContactTel: null,
      couContactEmail: null,
      couCompanyId: null,
      couAgentId: null,
      couVendorId: null,
      couPlantId: null,
      couOtherId: null,
      couContactType: null,
      couInActiveStatus: true,
      couContactTypeOptions: {
        placeholder: "กรุณาเลือก",
        data: [{ id: "agent", text: "Agent", data: null }, { id: "vendor", text: "Supplier", data: null }, { id: "plant", text: "คลังสินค้า", data: null }, { id: "other", text: "อื่นๆ", data: null }]
      },
      couCompanyIdOptions: {
        placeholder: "กรุณาเลือก",
        data: [{ id: "", text: "", data: null }]
      },
      couAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }

      },
      couVendorOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      couPlantOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Plant/Select2Plant",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;

      var tmp = "";
      if (this.couContactType == "agent") {
        tmp = this.couAgentId;
      } else if (this.couContactType == "vendor") {
        tmp = this.couVendorId;
      } else if (this.couContactType == "plant") {
        tmp = this.couPlantId;
      } else if (this.couContactType == "other") {
        tmp = this.couOtherId;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/TransitContactor", {
        TransitContactorId: this.$route.params.id,
        ContactName: this.couContactName,
        ContactLastName: this.couContactLastName,
        ContactPositions: this.couContactPositions,
        ContactNickName: this.couContactNickName,
        ContactTel: this.couContactTel,
        ContactEmail: this.couContactEmail,
        CompanyType: this.couContactType,
        CompanyID: tmp,
        InActiveStatus: !this.couInActiveStatus
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/TransitContactor/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.couContactName = response.data.contactName;
                  self.couContactLastName = response.data.contactLastName;
                  self.couContactPositions = response.data.position;
                  self.couContactNickName = response.data.nickName;
                  self.couContactTel = response.data.tel;
                  self.couContactEmail = response.data.email;
                  self.couInActiveStatus = !response.data.inActiveStatus;
                  if (response.data.companyType) {
                    $(self.$refs.couContactTypeSelect2.$el).val(response.data.companyType).trigger("change");
                  }

                  if (response.data.companyId && response.data.companyType == "agent") {
                    self.$refs.couAgentIdSelect2.setSelectedData({
                      id: response.data.companyId,
                      text: "[" + response.data.companyId + "] " + response.data.companyName
                    });
                  }

                  if (response.data.companyId && response.data.companyType == "vendor") {
                    self.$refs.couVendorIdSelect2.setSelectedData({
                      id: response.data.companyId,
                      text: "[" + response.data.vendorNo + "] " + response.data.companyName
                    });
                  }

                  if (response.data.companyId && response.data.companyType == "plant") {
                    self.$refs.couPlantIdSelect2.setSelectedData({
                      id: response.data.companyId,
                      text: response.data.companyName + " (" + response.data.plantDesc2 + ")"
                    });
                  }

                  if (response.data.companyId && response.data.companyType == "other") {
                    self.couOtherId = response.data.companyId;
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลขนส่งคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลขนส่งได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              $(_this.$refs.form).validate({
                rules: {
                  couContactType: "required",
                  couCompanyId: "required",
                  couAgentId: "required",
                  couVendorId: "required",
                  couPlantId: "required",
                  couContactName: "required",
                  couContactLastName: "required",
                  couContactPositions: "required",
                  couContactTel: "required",
                  couContactEmail: {
                    required: true,
                    email: true
                  }

                },
                messages: {
                  couContactType: "กรุณาเลือกประเภทผู้ติดต่อ",
                  couCompanyId: "กรุณาเลือกบริษัท",
                  couAgentId: "กรุณาเลือกบริษัท",
                  couVendorId: "กรุณาเลือกบริษัท",
                  couPlantId: "กรุณาเลือกบริษัท",
                  couContactName: "กรุณากรอกชื่อ",
                  couContactLastName: "กรุณากรอกนามสกุล",
                  couContactPositions: "กรุณากรอกตำแหน่ง",
                  couContactTel: "กรุณากรอกเบอร์ติดต่อ",
                  couContactEmail: {
                    required: "กรุณากรอกอีเมล",
                    email: "กรุณากรอกอีเมลให้ถูกต้อง"
                  }

                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      hocProductTypeId: null,
      hocHolderTime: null,
      hocAgentCode: null,
      hocShopTypeCode: null,
      hocProductBrandId: null,
      hocInActiveStatus: true,
      // Configurations
      hocProductTypeIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductType/Select2ProductType",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      hocAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      hocShopTypeCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      hocProductBrandIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/ProductHolder", {
        ProductTypeId: this.hocProductTypeId,
        HolderTime: this.hocHolderTime,
        AgentCode: this.hocAgentCode,
        ShopTypeId: this.hocShopTypeCode,
        ProductBrandId: this.hocProductBrandId,
        InActiveStatus: !this.hocInActiveStatus
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          //console.log(response);
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onHocAgentCodeChange: function onHocAgentCodeChange(ref) {
      this.$refs.hocShopTypeCodeSelect2.setSelectedData({
        id: "",
        text: ""
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  hocProductTypeId: "required",
                  hocHolderTime: "required"
                  // hocAgentCode: "required",
                  // hocShopTypeCode: "required",
                  // hocProductBrandId: "required"
                },
                messages: {
                  hocProductTypeId: "กรุณาเลือกประเภทสินค้าถือครอง",
                  hocHolderTime: "กรุณากรอกระยะเวลาการถือครอง"
                  // hocAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
                  // hocShopTypeCode: "กรุณาเลือกประเภทร้านค้า",
                  // hocProductBrandId: "กรุณาเลือกแบรนด์สินค้า"
                }
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import the styles


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      exholProductTypeId: [],
      exholAgentCode: [],
      exholShopTypeId: [],
      exholProductBrandId: [],
      exholHolderTime: null,
      exholInActiveStatus: null,
      exholProductTypeIdOptions: [],
      exholAgentCodeOptions: [],
      // exholProductTypeIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      // exholAgentCodeOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchAgentName",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: [],
      //         province_id: [],
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      exholShopTypeIdOptions: [],
      // exholShopTypeIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Shop/Select2ShopDistinctShopType",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      exholProductBrandIdOptions: [],
      // exholProductBrandIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2ProductBrand",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      exholInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset() {
      this.exStatus = false;
      $("#exStatus").val(this.exStatus + "").trigger("change");

      this.exYear = null;
      $("#exYear").val(this.exYear + "").trigger("change");

      this.exBudgetType = "";
      $("#exBudgetType").val(this.exBudgetType + "").trigger("change");
    },

    formSubmit: function formSubmit(e) {
      var self = this;
      var router = this.$router;

      e.preventDefault();

      if (!$("#downloadBarcodeModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/ProductHolder/Export",
        responseType: "arraybuffer",
        data: {
          ProductTypeId: self.exholProductTypeId,
          AgentCode: self.exholAgentCode,
          ShopTypeId: self.exholShopTypeId,
          ProductBrandId: self.exholProductBrandId,
          HolderTime: self.exholHolderTime,
          ActiveStatus: self.exholInActiveStatus
        }
      }).then(function (response) {
        var filename = "";
        var contentType = response.headers["content-type"];
        var disposition = response.headers["content-disposition"];

        //===Get Filename===
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        //Save file
        var blob = new Blob([response.data], { type: contentType });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadexholProductTypeIdOptions: function LoadexholProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.exholProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadexholAgentCodeOptions: function LoadexholAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Agents/Select2SearchAgentName", {
        page: 1,
        all: true,
        department: [],
        province_id: []
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.exholAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadexholShopTypeIdOptions: function LoadexholShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Shop/Select2ShopDistinctShopType", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.exholShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadexholProductBrandIdOptions: function LoadexholProductBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductBrand/Select2ProductBrand", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.exholProductBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              self.LoadexholProductTypeIdOptions();
              self.LoadexholAgentCodeOptions();
              self.LoadexholShopTypeIdOptions();
              self.LoadexholProductBrandIdOptions();
              //default Active Data
              self.exholInActiveStatus = false;
              $("#exholInActiveStatus").val(self.exholInActiveStatus + "").trigger("change");

              // set validation rules
              $("#downloadBarcodeModal form").validate({
                rules: { DlbRefno: "required" },
                messages: { DlbRefno: "กรุณาเลือกรหัสอ้างอิง" }
              });

              $("#downloadBarcodeModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              }).modal("show");

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      Flie: "เลือกไฟล์",
      seen: false,
      submitBtn: false,
      productHoldingList: []
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      var self = this;
      var router = this.$router;
      e.preventDefault();

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      // add array list
      var items = [];
      self.productHoldingList.forEach(function (element) {
        items.push({
          ProductTypeId: element.productTypeId,
          HolderTime: element.time,
          AgentCode: element.agentCode,
          ShopTypeId: element.shopTypeId,
          ProductBrandId: element.productBrandId,
          Status: element.status
        });
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/ProductHolder/Import", {
        Obj: items
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    resetFile: function resetFile() {
      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();
      $("#importProductHolding").val("");
      this.seen = false;
      this.Flie = "เลือกไฟล์";
      this.submitBtn = false;
    },
    DownLoadTemplate: function DownLoadTemplate() {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/ProductHolder/Template",
        responseType: "arraybuffer",
        data: {}
      }).then(function (response) {
        var filename = "";
        var contentType = response.headers["content-type"];
        var disposition = response.headers["content-disposition"];

        //===Get Filename===
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        //Save file
        var blob = new Blob([response.data], { type: contentType });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },

    chooseFile: function chooseFile(e) {
      var self = this;
      var router = this.$router;
      self.seen = true;
      self.submitBtn = false;
      self.Flie = e.target.files[0].name;

      //Check extention
      var extension = self.Flie.split(".").pop();
      var extall = "xls,xlsx";

      // if(extension.match("xls|xlsx")){
      //   console.log(extension);
      // }

      if (parseInt(extall.indexOf(extension)) < 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกไฟล์ .xls หรือ .xlsx เท่านั้น", "warning");
        self.Flie = "";
        return false;
      }

      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();
      self.productHoldingList = [];
      var formData = new FormData();
      formData.append("file", e.target.files[0]);

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/ProductHolder/Preview", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(function (response) {
        self.productHoldingList = response.data.data;
        self.submitBtn = response.data.isValid;
        if (response.data.data.length > 0) {
          if (response.data.isValid) self.submitBtn = true;
        }

        var $table = $("#PreviewTable");
        var head = "<thead>" + '<tr role="row">' + '<th class="text-center" aria-label="ลำดับ: activate to sort column ascending" style="width:5% ;">ลำดับ</th>' + '<th class="text-center" aria-label="รหัสประเภทสินค้าถือครอง: activate to sort column ascending" style="width:10% ;" >รหัสประเภทสินค้าถือครอง</th>' + '<th class="text-center" aria-label="ประเภทสินค้าถือครอง: activate to sort column ascending" style="width:10% ;" >ประเภทสินค้าถือครอง</th>' + '<th class="text-center" aria-label="รหัสตัวแทนจำหน่าย: activate to sort column ascending" style="width:10%;">รหัสตัวแทนจำหน่าย</th>' + '<th class="text-center" aria-label="ตัวแทนจำหน่าย: activate to sort column ascending" style="width:15%;">ตัวแทนจำหน่าย</th>' + '<th class="text-center" aria-label="รหัสประเภทร้านค้า: activate to sort column ascending" style="width:8% ;">รหัสประเภทร้านค้า</th>' + '<th class="text-center" aria-label="ประเภทร้านค้า: activate to sort column ascending" style="width:10% ;">ประเภทร้านค้า</th>' + '<th class="text-center" aria-label="รหัสแบรนด์สินค้า: activate to sort column ascending" style="width: 8%;">รหัสแบรนด์สินค้า</th>' + '<th class="text-center" aria-label="แบรนด์สินค้า: activate to sort column ascending" style="width: 10%;">แบรนด์สินค้า</th>' + '<th class="text-center" aria-label="ระยะเวลาการถือครอง(วัน): activate to sort column ascending" style="width:10% ;">ระยะเวลาการถือครอง(วัน)</th>' + '<th class="text-center" aria-label="สถานะ: activate to sort column ascending" style="width:10% ;">สถานะ</th>' + "</tr>" + "</thead>";
        $table.append(head);
        var data = response.data.data;
        var table_body = $("<tbody></tbody>");
        for (var i = 0; i < data.length; i++) {
          $('<tr role="row" class="odd"><td class="text-center">' + (i + 1) + "</td>" + '<td class="text-center" ' + data[i].productTypeIdCSS + ">" + data[i].productTypeId + "</td>" + '<td class="text-center" ' + data[i].productTypeIdCSS + ">" + data[i].productTypeName + "</td>" + '<td class="text-center" ' + data[i].agentCodeCSS + ">" + data[i].agentCode + "</td>" + '<td class="text-center" ' + data[i].agentCodeCSS + ">" + data[i].agentName + "</td>" + '<td class="text-center" ' + data[i].shopTypeIdCSS + ">" + data[i].shopTypeId + "</td>" + '<td class="text-center" ' + data[i].shopTypeIdCSS + ">" + data[i].shopTypeName + "</td>" + '<td class="text-center" ' + data[i].productBrandIdCSS + ">" + data[i].productBrandId + "</td>" + '<td class="text-center" ' + data[i].productBrandIdCSS + ">" + data[i].productBrandName + "</td>" + '<td class="text-center" ' + data[i].timeCSS + ">" + data[i].time + "</td>" + '<td class="text-center" ' + data[i].statusCSS + ">" + data[i].status + "</td>" + "</tr>").appendTo(table_body);
          table_body.appendTo($table);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;

              // $("#importProductHolding").change(function(e) {
              //   self.seen = true;
              //   self.Flie = e.target.files[0].name;
              //   $("#PreviewTable thead").remove();
              //   $("#PreviewTable tbody").remove();
              //   self.productHoldingList = [];
              //   let formData = new FormData();
              //   formData.append("file", e.target.files[0]);
              //   axios
              //     .post("/Api/ProductHolder/Preview", formData, {
              //       headers: {
              //         "Content-Type": "multipart/form-data"
              //       }
              //     })
              //     .then(response => {
              //       self.productHoldingList = response.data.data;
              //       self.submitBtn = response.data.isValid;
              //       self.submitBtn = response.data.data.length > 0 ? true : false;

              //       var $table = $("#PreviewTable");
              //       var head =
              //         "<thead>" +
              //         '<tr role="row">' +
              //         '<th class="text-center" aria-label="ลำดับ: activate to sort column ascending" style="width:5% ;">ลำดับ</th>' +
              //         '<th class="text-center" aria-label="รหัสประเภทสินค้าถือครอง: activate to sort column ascending" style="width:10% ;" >รหัสประเภทสินค้าถือครอง</th>' +
              //         '<th class="text-center" aria-label="รหัสตัวแทนจำหน่าย: activate to sort column ascending" style="width:15%;">รหัสตัวแทนจำหน่าย</th>' +
              //         '<th class="text-center" aria-label="รหัสประเภทร้านค้า: activate to sort column ascending" style="width:10% ;">รหัสประเภทร้านค้า</th>' +
              //         '<th class="text-center" aria-label="รหัสแบรนด์สินค้า: activate to sort column ascending" style="width: 10%;">รหัสแบรนด์สินค้า</th>' +
              //         '<th class="text-center" aria-label="ระยะเวลาการถือครอง(วัน): activate to sort column ascending" style="width:10% ;">ระยะเวลาการถือครอง(วัน)</th>' +
              //         '<th class="text-center" aria-label="สถานะ: activate to sort column ascending" style="width:10% ;">สถานะ</th>' +
              //         "</tr>" +
              //         "</thead>";
              //       $table.append(head);
              //       var data = response.data.data;
              //       var table_body = $("<tbody></tbody>");
              //       for (var i = 0; i < data.length; i++) {

              //         $(
              //           '<tr role="row" class="odd"><td class="text-center">' +
              //             (i + 1) +"</td>" +
              //             '<td class="text-center" '+data[i].productTypeIdCSS +'>' +
              //             data[i].productTypeId +
              //             '</td>' +
              //             '<td class="text-center" '+data[i].agentCodeCSS +'>' +
              //             data[i].agentCode +
              //             '</td>' +
              //             '<td class="text-center" '+data[i].shopTypeIdCSS +'>' +
              //             data[i].shopTypeId +
              //             '</td>' +
              //             '<td class="text-center" '+data[i].productBrandIdCSS +'>' +
              //             data[i].productBrandId +
              //             '</td>' +
              //             '<td class="text-center" '+data[i].timeCSS +'>' +
              //             data[i].time +
              //             '</td>'+
              //             '<td class="text-center" '+data[i].statusCSS +'>' +
              //             data[i].status +
              //             '</td>'+
              //             '</tr>'
              //         ).appendTo(table_body);
              //         table_body.appendTo($table);
              //       }
              //     });
              // });

              // set validation rules

              $(_this.$refs.form).validate({
                rules: {},
                messages: {}
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);
var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#holdTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/ProductHolder/" + _this.data.productHolderID + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#holdTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/ProductHolder/" + _this2.data.productHolderID + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var HoldActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editHolding\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n     <a href=\"#\" @click.prevent=\"deleteHolding\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    editHolding: function editHolding() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/Holding/Edit/" + this.data.productHolderID
      });
    },
    deleteHolding: function deleteHolding() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบการถือครอง",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลการถือครอง <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้การถือครองนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลการถือครองออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/ProductHolder/" + _this3.data.productHolderID + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      holProductTypeId: [],
      holProductTypeIdOptions: [],
      holHolderTime: null,
      holAgentCode: [],
      holAgentCodeOptions: [],
      holShopTypeId: [],
      holShopTypeIdOptions: [],
      holProductBrandId: [],
      holProductBrandIdOptions: [],
      holInActiveStatus: null,
      // holProductBrandIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2ProductBrand",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      holInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.holProductTypeId = [];
      this.holAgentCode = [];
      this.holShopTypeId = [];
      this.holProductBrandId = [];

      $("#holHolderTime").val("");

      //default Active Data
      this.holInActiveStatus = false;
      $("#holInActiveStatus").val(this.holInActiveStatus + "").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#holdTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#holdTable").DataTable().ajax.reload(null, resetPaging);
    },
    onHolAgentCodeChange: function onHolAgentCodeChange(state, value) {
      this.holShopTypeId = [];
    },
    CheckRoute: function CheckRoute() {
      var url = this.$route.path;
      if (url == "/Master/Holding/Edit/" + this.$root.$route.params.id) return false;else if (url == "/Master/Holding/Import") return false;else if (url == "/Master/Holding/Add") return false;else return true;
    },

    LoadholProductTypeIdOptions: function LoadholProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.holProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadholAgentCodeOptions: function LoadholAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Agents/Select2SearchAgentName", {
        page: 1,
        department: [],
        province_id: []
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.holAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadholShopTypeIdOptions: function LoadholShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.holShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadholProductBrandIdOptions: function LoadholProductBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductBrand/Select2ProductBrand", {
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.holProductBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;

              //default Active Data

              self.holInActiveStatus = false;
              $("#holInActiveStatus").val(self.holInActiveStatus + "").trigger("change");

              $("#holInActiveStatus").select2({
                tags: true,
                placeholder: "ทั้งหมด",
                allowClear: true
              });

              self.LoadholProductTypeIdOptions();
              self.LoadholAgentCodeOptions();
              self.LoadholShopTypeIdOptions();
              self.LoadholProductBrandIdOptions();

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#holdTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/ProductHolder/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      ProductTypeId: self.holProductTypeId,
                      AgentCode: self.holAgentCode,
                      ShopTypeId: self.holShopTypeId,
                      ProductBrandId: self.holProductBrandId,
                      HolderTime: $("#holHolderTime").val(),
                      ActiveStatus: $("#holInActiveStatus").val()
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "asc"]],
                columns: [{ data: "productTypeName" }, { data: "agentCodeName", width: "20%" }, { data: "shopTypeName" }, { data: "productBrandName" }, { data: "holderTime" }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "ProductHolderID",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MASTER_HOLDING"]);
                    if (data.inActiveStatus == 0) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MASTER_HOLDING"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MASTER_HOLDING"]);
                    new HoldActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      isChange: false,
      houProductTypeId: null,
      houHolderTime: null,
      houAgentCode: null,
      houShopTypeCode: null,
      houProductBrandId: null,
      houInActiveStatus: true,
      // Configurations
      houProductTypeIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductType/Select2ProductType",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      houAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      houShopTypeCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      houProductBrandIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/ProductHolder", {
        ProductTypeId: this.houProductTypeId,
        HolderTime: this.houHolderTime,
        AgentCode: this.houAgentCode,
        ShopTypeId: this.houShopTypeCode,
        ProductBrandId: this.houProductBrandId,
        InActiveStatus: !this.houInActiveStatus,
        ProductHolderId: this.$route.params.id
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onHouAgentCodeChange: function onHouAgentCodeChange(ref) {
      // this.$refs.houShopTypeCodeSelect2.setSelectedData({
      //   id: "",
      //   text: ""
      // });
      if (this.isChange) {
        $("#houShopTypeCode").val("").trigger("change");
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  houProductTypeId: "required",
                  houHolderTime: "required"
                  // houAgentCode: "required",
                  // houShopTypeCode: "required",
                  // houProductBrandId: "required"
                },
                messages: {
                  houProductTypeId: "กรุณาเลือกประเภทสินค้าถือครอง",
                  houHolderTime: "กรุณากรอกระยะเวลาการถือครอง"
                  // houAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
                  // houShopTypeCode: "กรุณาเลือกประเภทร้านค้า",
                  // houProductBrandId: "กรุณาเลือกแบรนด์สินค้า"
                }
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductHolder/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.houHolderTime = response.data.holderTime;
                  self.houInActiveStatus = !response.data.inActiveStatus;

                  if (response.data.productTypeID) {
                    self.$refs.houProductTypeIdSelect2.setSelectedData({
                      id: response.data.productTypeID,
                      text: response.data.productTypeName
                    });
                  }

                  if (response.data.agentCode) {
                    self.$refs.houAgentCodeSelect2.setSelectedData({
                      id: response.data.agentCode,
                      text: response.data.agentCodeName
                    });
                  }

                  if (response.data.shopTypeId) {
                    self.$refs.houShopTypeCodeSelect2.setSelectedData({
                      id: response.data.shopTypeId,
                      text: response.data.shopTypeName
                    });
                  }

                  if (response.data.productBrandID) {
                    self.$refs.houProductBrandIdSelect2.setSelectedData({
                      id: response.data.productBrandID,
                      text: response.data.productBrandName
                    });
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการถือครองที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการถือครองได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                self.isChange = true;
                KTApp.unblockPage();
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      DlbRefno: [],
      DlbRefnoOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MachineTransaction/Select2RefCode",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$("#downloadPhaseModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/MachineTransaction/Download",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: null,
          ProductTypeId: [],
          AssetOwnerId: [],
          WarrantyTime: null,
          RefCode: this.DlbRefno
        }
      }).then(function (response) {
        var filename = "";
        var contentType = response.headers["content-type"];
        var disposition = response.headers["content-disposition"];

        //===Get Filename===
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        //Save file
        var blob = new Blob([response.data], { type: contentType });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        $("#DlbRefno").val("").trigger("change");
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              // set validation rules
              $("#downloadPhaseModal form").validate({
                rules: { DlbRefno: "required" },
                messages: { DlbRefno: "กรุณาเลือกรหัสอ้างอิง" }
              });

              $("#downloadPhaseModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              }).modal("show");

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      Flie: "เลือกไฟล์ เครื่องเช่า",
      seen: false,
      dataList: [],
      valid: true,

      imInstallmentModel: 60,
      imPOModel: null,
      imStartDateModel: null,
      imPriceModel: null,
      imPhaseModel: null,
      imPhaseOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Phase",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      imLotModel: null,
      imLotOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Lot",
          data: function data(params) {
            var query = {
              search: params.term,
              phase: self.imPhaseModel,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    resetFile: function resetFile() {
      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();
      $("#importFile").val("");
      this.seen = false;
      this.Flie = "เลือกไฟล์ เครื่องเช่า";
      this.dataList = [];
    },
    formSubmit: function formSubmit(e) {
      var self = this;
      var router = this.$router;
      e.preventDefault();
      //   var valid = false;
      //   console.log(self.valid);
      if (!$(self.$refs.form).validate().form()) {
        return false;
      }
      if (!self.valid) {
        return false;
      }
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/MachineTransaction/Import", this.dataList).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
      // }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.imStartDateModel).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment().subtract(1, "month"), //last month
                maxDate: moment(), //current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              self.imStartDateModel = moment();
              $(self.$refs.imStartDateModel).datepicker("update", self.imStartDateModel.format("DD/MM/YYYY")).on("changeDate", function (e) {
                self.imStartDateModel = moment(e.date);
              });

              $("#importFile").change(function (e) {
                self.seen = true;
                self.Flie = e.target.files[0].name;

                if (!$(self.$refs.form).validate().form()) {
                  $("#importFile").val("");
                  self.seen = false;
                  self.Flie = "เลือกไฟล์ เครื่องเช่า";
                  return false;
                }

                $("#PreviewTable thead").remove();
                $("#PreviewTable tbody").remove();

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังแสดงข้อมูล กรุณารอสักครู่..."
                });

                var formData = new FormData();
                formData.append("file", e.target.files[0]);
                formData.append("Installment", self.imInstallmentModel);
                formData.append("PO", self.imPOModel);
                formData.append("StartDate", self.imStartDateModel.format("DD/MM/YYYY"));
                formData.append("Price", self.imPriceModel);
                formData.append("Phase", self.imPhaseModel);
                formData.append("Lot", self.imLotModel);
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/MachineTransaction/Preview", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }).then(function (response) {
                  //console.log(response);
                  if (response.status == 400) {
                    Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                  } else if (response.status == 200) {
                    self.dataList = response.data;
                    var $table = $("#PreviewTable");
                    var head = "<thead>" + '<tr role="row">' + '<th class="text-center" aria-label="ลำดับ: activate to sort column ascending" >ลำดับ</th>' + '<th class="text-center" aria-label="ระบุ PHASE: activate to sort column ascending" >ระบุ PHASE</th>' + '<th class="text-center" aria-label="ระบุ Lot: activate to sort column ascending" style="width:8% ;" >ระบุ Lot</th>' + '<th class="text-center" aria-label="ระบุจำนวนงวด: activate to sort column ascending">ระบุจำนวนงวด</th>' + '<th class="text-center" aria-label="เลขที่ PO: activate to sort column ascending" >เลขที่ PO</th>' + '<th class="text-center" aria-label="ราคาของเครื่องประเภท: activate to sort column ascending" style="width:8% ;" >ราคาของเครื่องประเภท</th>' + '<th class="text-center" aria-label="ว/ด/ป ติดตั้ง: activate to sort column ascending">ว/ด/ป ติดตั้ง</th>' + '<th class="text-center" aria-label="ว/ด/ป เริ่มสัญญา: activate to sort column ascending" >ว/ด/ป เริ่มสัญญา</th>' + '<th class="text-center" aria-label="BARCODE: activate to sort column ascending" style="width:8% ;" >BARCODE</th>' + '<th class="text-center" aria-label="สถานะ: activate to sort column ascending">สถานะ</th>' + '<th class="text-center" aria-label="Id: activate to sort column ascending">Id</th>' + '<th class="text-center" aria-label="RefCode: activate to sort column ascending">RefCode</th>' +
                    // '<th class="text-center" aria-label="ID: activate to sort column ascending">ID</th>' +
                    "</tr>" + "</thead>";
                    $table.append(head);
                    var data = response.data;
                    var table_body = $("<tbody></tbody>");
                    for (var i = 0; i < data.length; i++) {
                      var borders_oldbarcode = null;
                      var borders_remark = null;
                      var borders_installDate = null;
                      if (!data[i].validOldBarcode) {
                        borders_oldbarcode = 'style="color:#ff0000;"';
                      }
                      if (!data[i].validInstallDate) {
                        borders_installDate = 'style="color:#ff0000;"';
                      }
                      //console.log(data[i].validates);
                      self.valid = self.valid || data[i].validates;
                      if (!data[i].validates) {
                        borders_remark = 'style="color:#ff0000;"';
                      }
                      $("<tr role=\"row\" class=\"odd\">\n                  <td class=\"text-center\">" + (i + 1) + "</td>\n                  <td class=\"text-center\">" + data[i].phase + "</td>\n                  <td class=\"text-center\">" + data[i].lot + "</td>\n                  <td class=\"text-center\">" + data[i].installment + "</td>\n                  <td class=\"text-center\">" + data[i].po + "</td>\n                  <td class=\"text-center\">" + data[i].price + "</td>\n                  <td class=\"text-center\" " + borders_installDate + ">\n                    " + (data[i].validInstallDate == false ? data[i].pInstallDate : data[i].installDate) + "\n                  </td>\n                  <td class=\"text-center\">" + data[i].startDate + "</td>\n                  <td class=\"text-center\" " + borders_oldbarcode + ">\n                    " + (data[i].pOldBarcode != null ? data[i].pOldBarcode : "") + "\n                  </td>\n                  <td class=\"text-center\" " + borders_remark + ">" + data[i].remark + "</td>\n                  <td class=\"text-center\">" + data[i].id + "</td>\n                  <td class=\"text-center\">" + data[i].refCode + "</td>\n                </tr>").appendTo(table_body);
                      table_body.appendTo($table);
                    }
                  }
                  KTApp.unblockPage();
                }).catch(function (error) {
                  //console.log(error.response);
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                  KTApp.unblockPage();
                });
              });

              // set validation rules
              $(self.$refs.form).validate({
                rules: {
                  imInstallmentModel: "required",
                  imPOModel: "required",
                  imStartDateModel: "required",
                  imPriceModel: "required",
                  imLotModel: "required",
                  imPhaseModel: "required"
                },
                messages: {
                  imInstallmentModel: "กรุณากรอกจำนวนงวด",
                  imPOModel: "กรุณากรอกPO",
                  imStartDateModel: "กรุณาเลือกวันที่เริ่มสัญญา",
                  imPriceModel: "กรุณากรอกค่าเช่าต่องวด",
                  imLotModel: "กกรุณาเลือกLot",
                  imPhaseModel: "กรุณาเลือกPhase"
                }
              });
              $(self.$refs.form).validate().settings.ignore = ":hidden";

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

//let Actions = Vue.extend({
//  template: `
//  <div>
//    <a href="#" @click.prevent="detail" v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
//      <i class="fa fa-search"></i>
//    </a>
//  </div>`,
//  methods: {
//    detail: function() {
//      router.push({
//        path: `/Master/ManageBarcode/Detail/${this.data.barcodeId}`
//      });
//    }
//  }
//});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      MbKeyword: ""
    };
  },
  methods: {
    downloadTemplate: function downloadTemplate(e) {
      e.preventDefault();
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดาวโหลด Template เครื่องเช่า กรุณารอสักครู่..."
      });
      var win = window.open("/Api/MachineTransaction/DownloadTemplate", "_blank");
      win.focus(KTApp.unblockPage());
    },
    formReset: function formReset(e) {
      this.MbKeyword = "";
      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#machineTransactionTable").DataTable();
      table.search(this.equipment);
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#machineTransactionTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              $.fn.dataTable.ext.errMode = 'none';
              table = $("#machineTransactionTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/MachineTransaction/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.MbKeyword,
                      RefCode: []
                    }));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [100, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[1, "desc"]],
                columns: [{ data: "phase" }, { data: "lot" }, { data: "installment" }, { data: "po" }, {
                  data: "price",
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "dateInstall" }, { data: "oldBarcode" }, { data: "contractStartDate" }, { data: "contractExpireDate" }, { data: "refCode" }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });
              //.on("draw.dt", function () {
              //    $(".actions").each(function (i, el) {
              //        var $dt = table.DataTable();
              //        var $tr = $(el)
              //            .parents("tr")
              //            .first();
              //        var data = $dt.row($tr).data();
              //        if (data) {
              //            data.showDetailButton = self.$root.canShow([
              //                "MANAGE_MASTER",
              //                "MANAGER_EQUIPMENT_LEASING"
              //            ]);
              //            new Actions({ data: { data }, parent: self }).$mount(el);
              //        }
              //    });
              //});

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_plupload__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {
      mbAssetOwnerName: null,
      odMaterialName: null,
      odMaterialCode: null,
      odYear: null,
      odEffectiveDateFrom: null,
      odEffectiveDateTo: null,
      odPrice: null,
      odInActiveStatus: true,
      mbAssetOwnerId: null,
      MbAssetOwnerOptions: [],
      odMaterialCodeOptions: []
    }, _defineProperty(_ref, "MbAssetOwnerOptions", {
      placeholder: "เลือกเจ้าของทรัพย์สิน ",
      allowClear: true,
      ajax: {
        url: "/Api/assetOwner/Select2SearchAssetOwner",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            onlyHasBarcode: true
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "odMaterialCodeOptions", {
      placeholder: "เลือกสินค้า",
      allowClear: true,
      ajax: {
        url: "/Api/Product/Select2Product",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            onlyHasBarcode: true
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  methods: {
    formSubmit: function formSubmit(e) {

      var router = this.$router;
      var self = this;

      var dateValidate = true;

      // if(self.odEffectiveDateFrom!=null && self.odEffectiveDateFrom != "" && self.odEffectiveDateFrom != undefined && 
      // self.odEffectiveDateTo!=null && self.odEffectiveDateTo != "" && self.odEffectiveDateTo != undefined 
      // )
      // {
      //   let y = moment().year();
      //   if(self.odYear!=null){
      //     y = parseInt(self.odYear.format("YYYY"));
      //   } 
      //   var startDate = moment("01/01/"+y, "DD/MM/YYYY");
      //   var endDate = moment("31/12/"+y, "DD/MM/YYYY");

      //   var _odEffectiveDateFrom = moment(self.odEffectiveDateFrom, "DD/MM/YYYY");
      //   var _odEffectiveDateTo = moment(self.odEffectiveDateTo, "DD/MM/YYYY");

      //   let dateFromBetween = _odEffectiveDateFrom.isBetween(startDate, endDate, 'days', true);  
      //   let dateToBetween = _odEffectiveDateTo.isBetween(startDate, endDate, 'days', true);  

      //   let before  = _odEffectiveDateFrom.isBefore(_odEffectiveDateTo) ;

      //   if(!before){
      //     Swal.fire("แจ้งเตือน",  "วันที่มีผลเริ่มต้น ต้องน้อยกว่า วันที่มีผลสิ้นสุด" , "warning"); 
      //     dateValidate = false;
      //   }

      //   if(!dateFromBetween || !dateToBetween){
      //     Swal.fire("แจ้งเตือน",  "วันที่มีผลเริ่มต้นและวันที่มีผลสิ้นสุด ต้องอยู่ระหว่างวันที่ "+startDate.format("DD/MM/YYYY")+" - " + endDate.format("DD/MM/YYYY") , "warning"); 
      //     dateValidate =  false;
      //   } 
      // }

      if (!dateValidate) {
        return false;
      } else {

        if (!$(this.$refs.form).validate().form()) {
          return false;
        }

        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
        });

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/MasterProductUnitPrice/ValidateDate", {
          odMaterialCode: this.odMaterialCode,
          mbAssetOwnerId: this.mbAssetOwnerId,
          odYear: self.odYear != null ? self.odYear.format("YYYY") : self.odYear,
          odEffectiveDateFrom: self.odEffectiveDateFrom
          // odEffectiveDateFrom:
          // self.odEffectiveDateFrom != null
          //         ? self.odEffectiveDateFrom.format("DD/MM/YYYY")
          //         : self.odEffectiveDateFrom, 
          // odEffectiveDateTo:
          // self.odEffectiveDateTo != null
          //         ? self.odEffectiveDateTo.format("DD/MM/YYYY")
          //         : self.odEffectiveDateTo,  

        }).then(function (response) {
          console.log(response.data);
          if (response.data != null && response.data != "") {
            // มีข้อมูลอยู่แล้ว
            console.log(response);
            var product = response.data.materialcode + " " + response.data.materialdesC_TH2;
            Swal.fire({
              title: "แจ้งเตือน",
              html: "ปี : " + response.data.year + "<br> สินค้า : " + product + "<br> เจ้าของทรัพย์สิน :" + response.data.assetOwnerName + " <br> มีการกำหนดราคาไว้แล้วคือราคา " + response.data.unitPrice + " <br> ถ้าหากบันทึกใหม่ระบบจะปิดการใช้งานรายการเดิมและบันทึกรายการใหม่ให้แทน<br>หากต้องการใช้งานราคาใหม่กรุณากดยืนยัน ",
              icon: "warning",
              showCancelButton: true,
              //confirmButtonColor: "#3085d6",
              //cancelButtonColor: "#d33",
              confirmButtonText: "ยืนยัน",
              cancelButtonText: "ยกเลิก"
            }).then(function (result) {
              if (result.value) {
                self.SaveChange();
              } else {
                //alert('no');
              }
            });
          } else {
            //add new
            self.SaveChange();
          }
          //console.log(response);
        }).catch(function (error) {
          console.log(error);
          Swal.fire("เกิดข้อผิดพลาด", "ERR", "error");
        }).then(function () {
          // always executed
          KTApp.unblockPage();
        });
      }
    },
    onMbAssetOwnerIdChange: function onMbAssetOwnerIdChange(id, text, data, ref) {
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.mbAssetOwnerName = data[0].text;
      }
    },
    onMaterialCodeChange: function onMaterialCodeChange(id, text, data, ref) {
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.odMaterialName = data[0].text;
      }
    },
    SaveChange: function SaveChange() {
      var self = this;
      var router = this.$router;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/MasterProductUnitPrice", {
        mbAssetOwnerId: this.mbAssetOwnerId,
        mbAssetOwnerName: this.mbAssetOwnerName,
        odMaterialName: this.odMaterialName,
        odMaterialCode: this.odMaterialCode,
        odTranTypeCode: this.odTranTypeCode,
        odYear: self.odYear != null ? self.odYear.format("YYYY") : self.odYear,
        odPrice: this.odPrice,
        odEffectiveDateFrom: moment().format("DD/MM/YYYY"),
        // odEffectiveDateFrom:
        // self.odEffectiveDateFrom != null
        //         ? self.odEffectiveDateFrom.format("DD/MM/YYYY")
        //         : self.odEffectiveDateFrom, 
        // odEffectiveDateTo:
        // self.odEffectiveDateTo != null
        //         ? self.odEffectiveDateTo.format("DD/MM/YYYY")
        //         : self.odEffectiveDateTo, 

        odInActiveStatus: !this.odInActiveStatus

      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          //console.log(response);
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    ConfigDate: function ConfigDate() {

      var self = this;
      var arrows;
      // set validation rules
      if (KTUtil.isRTL()) {
        arrows = {
          leftArrow: '<i class="la la-angle-right"></i>',
          rightArrow: '<i class="la la-angle-left"></i>'
        };
      } else {
        arrows = {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>'
        };
      }

      var y = moment().year();
      if (self.odYear != null) {
        y = parseInt(self.odYear.format("YYYY"));
      }

      /*
      $(self.$refs.odEffectiveDateFrom).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      // startDate : "01/01/"+y,
      // endDate:"31/12/"+y,
      //endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: self.arrows,
      });
      $(self.$refs.odEffectiveDateFrom)
      .datepicker(
        "update",
        !!self.odEffectiveDateFrom ? self.odEffectiveDateFrom.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.odEffectiveDateFrom = e.dates.length != 0 ? moment(e.date) : null;
      }); 
       $(self.$refs.odEffectiveDateTo).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(), 
      // startDate : "01/01/"+y,
      // endDate:"31/12/"+y,
      //endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: self.arrows,
      });
      $(self.$refs.odEffectiveDateTo)
      .datepicker(
        "update",
        !!self.odEffectiveDateTo ? self.odEffectiveDateTo.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.odEffectiveDateTo = e.dates.length != 0 ? moment(e.date) : null;
      });  
      */
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              // set validation rules
              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(_this.$refs.form).validate({

                rules: {
                  odMaterialCode: "required",
                  odYear: "required",
                  odPrice: "required",
                  // odEffectiveDateFrom: "required",
                  //  odEffectiveDateTo: "required",
                  mbAssetOwnerId: "required"

                },
                messages: {
                  odMaterialCode: "กรุณาเลือกชื่อสินค้า",
                  odYear: "กรุณาเลือกปี (ค.ศ.)",
                  odPrice: "กรุณากรอกจำนวนเงินราคาค่าถัง",
                  //  odEffectiveDateFrom : "กรุณากรอก Effective From", 
                  // odEffectiveDateTo : "กรุณากรอกจำนวนเงินราคาค่าถัง", 
                  mbAssetOwnerId: "กรุณาเลือกเจ้าของทรัพย์สิน"
                }
              });

              $("#odEffectiveDateFrom").val(moment().format('DD/MM/YYYY'));
              self.ConfigDate();

              $(self.$refs.odYear).datepicker({
                format: "yyyy",
                viewMode: "years",
                minViewMode: "years",
                autoclose: true,
                clearBtn: true,
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                templates: arrows
              });
              $(self.$refs.odYear).datepicker("update", !!self.odYear ? self.odYear.format("YYYY") : null).on("changeDate", function (e) {
                self.odYear = e.dates.length != 0 ? moment(e.date) : null;
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      console.log(this.data);
      var self = this;
      var table = $("#BarcodeAlertConfigTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/MasterProductUnitPrice/" + _this.data.id + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    savedata: function savedata() {
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/MasterProductUnitPrice/" + this.data.id + "/Toggle").then(function (response) {
        if (response.data.data) {
          $("#BarcodeAlertConfigTable").DataTable().ajax.reload(null, false);
          //   self.$parent.reloadDataTable(); 
          Swal.fire("สำเร็จ", response.data.message, "success");
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        console.log(error);
        //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#BarcodeAlertConfigTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/MasterProductUnitPrice/ValidateDate", {
            Id: _this2.data.id,
            odMaterialCode: _this2.data.materialcode,
            mbAssetOwnerId: _this2.data.assetOwnerId,
            odYear: _this2.data.year

          }).then(function (response) {
            console.log(response.data);
            if (response.data != null && response.data != "") {
              // มีข้อมูลอยู่แล้ว
              console.log(response);
              var product = response.data.materialcode + " " + response.data.materialdesC_TH2;
              Swal.fire({
                title: "แจ้งเตือน",
                html: "ปี : " + response.data.year + "<br> สินค้า : " + product + "<br> เจ้าของทรัพย์สิน :" + response.data.assetOwnerName + " <br> มีการกำหนดราคาไว้แล้วคือราคา " + response.data.unitPrice + " ",
                icon: "warning",
                showCancelButton: true,
                showConfirmButton: false,
                //confirmButtonColor: "#3085d6",
                //cancelButtonColor: "#d33",
                // confirmButtonText: "ยืนยัน",
                cancelButtonText: "ยกเลิก"
              }).then(function (result) {
                if (result.value) {
                  self.savedata();
                }
              });
            } else {
              self.savedata();
            }
            //console.log(response);
          }).catch(function (error) {
            console.log(error);
            Swal.fire("เกิดข้อผิดพลาด", "ERR", "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div> \n    <a href=\"#\" @click.prevent=\"editData\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"deleteData\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    detailData: function detailData() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Master/MasterProductUnitPrice/Detail/" + this.data.id
      });
    },
    editData: function editData() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Master/MasterProductUnitPrice/Edit/" + this.data.id
      });
    },
    deleteData: function deleteData() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูล",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูล <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ลบข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/MasterProductUnitPrice/" + _this3.data.id + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      odInActiveStatus: null,
      orlKeyword: null,
      MbSKUOptions: [],
      MbSKUId: [],
      odYear: null, // moment() ,
      odInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      this.MbSKUId = [];
      this.odYear = null;
      this.odInActiveStatus = null;
      $("#odInActiveStatus").val(this.pbInActiveStatus + "").trigger("change");

      $("#odYear").val("").trigger("change");
      // $(function(){
      //   self.odYear = moment().year();  
      //   $("#odYear").val(moment().year()).trigger("change"); 
      // });

      self.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#BarcodeAlertConfigTable").DataTable();
      table.search(this.id | this.name);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#BarcodeAlertConfigTable").DataTable().ajax.reload(null, resetPaging);
    },
    LoadMbSKUTransTypeOptions: function LoadMbSKUTransTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterOverdueSetting/Select2BarcodeAlertTransType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.MbSKUTransTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadMbSKUOptions: function LoadMbSKUOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.MbSKUOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;

              self.LoadMbSKUOptions();
              //self.LoadMbSKUTransTypeOptions(); 
              // $(function(){
              //   self.odYear = moment() ;  
              //   $("#odYear").val(moment().year()).trigger("change"); 
              // });
              $("#odInActiveStatus").val("false").trigger('change');

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }
              $.fn.dataTable.ext.errMode = 'none';
              table = $("#BarcodeAlertConfigTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/MasterProductUnitPrice/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    //check for clear date value
                    var idDate = $("#orlInvDate").val();
                    if (idDate == null || idDate == "") self.orlInvDate = null;

                    var jsonSearch = {
                      InActiveStatus: self.odInActiveStatus,
                      SearchKeyword: self.orlKeyword,
                      ProductCodes: self.MbSKUId,
                      //TransTypes: self.MbSKUTransTypeId  ,
                      odYear: self.odYear != null ? self.odYear.format("YYYY") : self.odYear
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[0, "asc"]],
                columns: [
                // { data: "rowNum", className: "text-center" },
                {
                  data: "rowNum",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, {
                  data: "materialcode",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.materialcode + "-" + full.materialdesC_TH2;
                  }
                }, { data: "assetOwnerName", className: "text-center" }, { data: "year", className: "text-center" }, { data: "unitPrice", className: "text-center" }, {
                  data: "effectiveDateStart",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return moment(data).format("DD/MM/YYYY");
                  }
                },
                // {
                //   data: "effectiveDateEnd",
                //   className: "text-center",
                //   render: function(data, type, full, meta) {
                //     return moment(data).format("DD/MM/YYYY")  ;
                //   },
                // },
                {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                },
                // {
                //   data: "inActiveStatus",
                //   className: "text-center",
                //   width: "10%",
                //   orderable: false,
                //   render: function(data, type, full, meta) {

                //     if(data)
                //       return '<div class="actionsStatus">Inactive</div>';
                //     else
                //     return '<div class="actionsStatus">Active</div>';
                //   },
                // },

                {
                  data: "id",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                alert(message);
                __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_ALERT"]);
                    if (data.inActiveStatus == 0) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  //console.log(data);
                  if (data) {
                    data.showDetailButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_ALERT"]);
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_ALERT"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_ALERT"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

              $(self.$refs.odYear).datepicker({
                format: "yyyy",
                viewMode: "years",
                minViewMode: "years",
                autoclose: true,
                clearBtn: true,
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                templates: arrows
              });
              $(self.$refs.odYear).datepicker("update", !!self.odYear ? self.odYear.format("YYYY") : null).on("changeDate", function (e) {
                self.odYear = e.dates.length != 0 ? moment(e.date) : null;
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(5);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var _ref;

    var self = this;
    return _ref = {
      mbAssetOwnerName: null,
      odMaterialName: null,
      odMaterialCode: null,
      odYear: null,
      odEffectiveDateFrom: null,
      odEffectiveDateTo: null,
      odPrice: null,
      odInActiveStatus: true,
      odMaterialCodeOptions: [],
      mbAssetOwnerId: null,
      MbAssetOwnerOptions: []

    }, _defineProperty(_ref, "MbAssetOwnerOptions", {
      placeholder: "เลือกเจ้าของทรัพย์สิน ",
      allowClear: true,
      ajax: {
        url: "/Api/assetOwner/Select2SearchAssetOwner",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            onlyHasBarcode: true
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "odMaterialCodeOptions", {
      placeholder: "เลือกสินค้า",
      allowClear: true,
      ajax: {
        url: "/Api/Product/Select2Product",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            onlyHasBarcode: true
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  methods: {
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/MasterProductUnitPrice/ValidateDate", {
        Id: this.$route.params.id,
        odMaterialCode: this.odMaterialCode,
        mbAssetOwnerId: this.mbAssetOwnerId,
        odYear: self.odYear != null ? self.odYear.format("YYYY") : self.odYear
      }).then(function (response) {

        if (response.data != null && response.data != "" && self.odInActiveStatus) {
          // มีข้อมูลอยู่แล้ว
          console.log(response);
          var product = response.data.materialcode + " " + response.data.materialdesC_TH2;
          Swal.fire({
            title: "แจ้งเตือน",
            html: "ปี : " + response.data.year + "<br> สินค้า : " + product + "<br> เจ้าของทรัพย์สิน :" + response.data.assetOwnerName + " <br> มีการกำหนดราคาไว้แล้วคือราคา " + response.data.unitPrice + " <br> ถ้าหากบันทึกใหม่ระบบจะปิดการใช้งานรายการเดิมและบันทึกรายการใหม่ให้แทน<br>หากต้องการใช้งานราคาใหม่กรุณากดยืนยัน ",
            icon: "warning",
            showCancelButton: true,
            //confirmButtonColor: "#3085d6",
            //cancelButtonColor: "#d33",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก"
          }).then(function (result) {
            if (result.value) {
              self.SaveChange();
            } else {}
          });
        } else {
          self.SaveChange();
        }
      }).catch(function (error) {
        console.log(error);
        Swal.fire("เกิดข้อผิดพลาด", "ERR", "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    onMbAssetOwnerIdChange: function onMbAssetOwnerIdChange(id, text, data, ref) {
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.mbAssetOwnerName = data[0].text;
      }
    },
    onMaterialCodeChange: function onMaterialCodeChange(id, text, data, ref) {
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.odMaterialName = data[0].text;
      }
    },
    odTranTypeCodeChange: function odTranTypeCodeChange(id, text, data, ref) {
      //nothing
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.odTranTypeName = data[0].text;
      }
    },
    SaveChange: function SaveChange() {
      var self = this;
      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/MasterProductUnitPrice", {
        Id: this.$route.params.id,
        mbAssetOwnerId: this.mbAssetOwnerId,
        mbAssetOwnerName: this.mbAssetOwnerName,
        odMaterialName: this.odMaterialName,
        odMaterialCode: this.odMaterialCode,
        odTranTypeCode: this.odTranTypeCode,
        odYear: self.odYear != null ? self.odYear.format("YYYY") : self.odYear,
        odPrice: this.odPrice,
        odEffectiveDateFrom: self.odEffectiveDateFrom,
        // self.odEffectiveDateFrom != null
        //         ? self.odEffectiveDateFrom.format("DD/MM/YYYY")
        //         : self.odEffectiveDateFrom, 
        // odEffectiveDateTo:
        // self.odEffectiveDateTo != null
        //         ? self.odEffectiveDateTo.format("DD/MM/YYYY")
        //         : self.odEffectiveDateTo, 

        odInActiveStatus: !this.odInActiveStatus
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    ConfigDate: function ConfigDate() {

      var self = this;
      var arrows;
      // set validation rules
      if (KTUtil.isRTL()) {
        arrows = {
          leftArrow: '<i class="la la-angle-right"></i>',
          rightArrow: '<i class="la la-angle-left"></i>'
        };
      } else {
        arrows = {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>'
        };
      }

      var y = moment().year();
      if (self.odYear != null) {
        y = parseInt(self.odYear.format("YYYY"));
      }

      /*
           $(self.$refs.odEffectiveDateFrom).datepicker({
           autoclose: true,
           clearBtn: true,
           format: "dd/mm/yyyy",
           rtl: KTUtil.isRTL(),
           // startDate : "01/01/"+y,
           // endDate:"31/12/"+y,
           //endDate: moment().format("DD/MM/YYYY"), // Current day
           orientation: "bottom left",
           todayBtn: "linked",
           todayHighlight: true,
           templates: self.arrows,
           });
           $(self.$refs.odEffectiveDateFrom)
           .datepicker(
             "update",
             !!self.odEffectiveDateFrom ? self.odEffectiveDateFrom.format("DD/MM/YYYY") : null
           )
           .on("changeDate", function(e) {
             self.odEffectiveDateFrom = e.dates.length != 0 ? moment(e.date) : null;
           }); 
            $(self.$refs.odEffectiveDateTo).datepicker({
           autoclose: true,
           clearBtn: true,
           format: "dd/mm/yyyy",
           rtl: KTUtil.isRTL(), 
           // startDate : "01/01/"+y,
           // endDate:"31/12/"+y,
           //endDate: moment().format("DD/MM/YYYY"), // Current day
           orientation: "bottom left",
           todayBtn: "linked",
           todayHighlight: true,
           templates: self.arrows,
           });
           $(self.$refs.odEffectiveDateTo)
           .datepicker(
             "update",
             !!self.odEffectiveDateTo ? self.odEffectiveDateTo.format("DD/MM/YYYY") : null
           )
           .on("changeDate", function(e) {
             self.odEffectiveDateTo = e.dates.length != 0 ? moment(e.date) : null;
           });  
            */
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              // set validation rules
              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(_this.$refs.form).validate({

                rules: {
                  odMaterialCode: "required",
                  odYear: "required",
                  odPrice: "required"
                  //  odEffectiveDateFrom: "required",
                  //  odEffectiveDateTo: "required",

                },
                messages: {
                  odMaterialCode: "กรุณาเลือกชื่อสินค้า",
                  odYear: "กรุณาเลือกปี (ค.ศ.)",
                  odPrice: "กรุณากรอกจำนวนเงินราคาค่าถัง"
                  //  odEffectiveDateFrom : "กรุณากรอก Effective From", 
                  //   odEffectiveDateTo : "กรุณากรอกจำนวนเงินราคาค่าถัง", 
                }
              });

              self.ConfigDate();

              $(self.$refs.odYear).datepicker({
                format: "yyyy",
                viewMode: "years",
                minViewMode: "years",
                autoclose: true,
                clearBtn: true,
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                templates: arrows
              });
              $(self.$refs.odYear).datepicker("update", !!self.odYear ? self.odYear.format("YYYY") : null).on("changeDate", function (e) {
                self.odYear = e.dates.length != 0 ? moment(e.date) : null;
              });
              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/MasterProductUnitPrice/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {

                  self.odEffectiveDateFrom = moment(response.data.effectiveDateStart).format("DD/MM/YYYY");
                  $("#odEffectiveDateFrom").val(moment(response.data.effectiveDateStart).format("DD/MM/YYYY"));
                  // self.odEffectiveDateTo = moment( response.data.effectiveDateEnd);

                  self.odInActiveStatus = !response.data.inActiveStatus;
                  self.odYear = moment(response.data.year + "-01-01");
                  self.odPrice = response.data.unitPrice;

                  // $(self.$refs.odEffectiveDateFrom)
                  // .datepicker(
                  //   "update",
                  //   !!self.odEffectiveDateFrom ? self.odEffectiveDateFrom.format("DD/MM/YYYY") : null
                  // )
                  // .on("changeDate", function(e) {
                  //   self.odEffectiveDateFrom = e.dates.length != 0 ? moment(e.date) : null;
                  // });

                  // $(self.$refs.odEffectiveDateTo)
                  // .datepicker(
                  //   "update",
                  //   !!self.odEffectiveDateTo ? self.odEffectiveDateTo.format("DD/MM/YYYY") : null
                  // )
                  // .on("changeDate", function(e) {
                  //   self.odEffectiveDateTo = e.dates.length != 0 ? moment(e.date) : null;
                  // });

                  $(self.$refs.odYear).datepicker("update", !!self.odYear ? self.odYear.format("YYYY") : null).on("changeDate", function (e) {
                    self.odYear = e.dates.length != 0 ? moment(e.date) : null;
                  });

                  if (response.data.assetOwnerId) {
                    self.$refs.mbAssetOwnerIdSelect2.setSelectedData({
                      id: response.data.assetOwnerId,
                      text: response.data.assetOwnerName
                    });
                  }

                  if (response.data.materialcode) {
                    self.$refs.odMaterialCodeSelect2.setSelectedData({
                      id: response.data.materialcode,
                      text: response.data.materialdesC_TH2 + " [" + response.data.materialcode + "]"
                    });
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderItemRow__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_plupload__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    orderItemRow: __WEBPACK_IMPORTED_MODULE_4__OrderItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      uuid: null,
      FileUpload: null,
      odcFilename: null,
      odcitems: [],
      i: 0,
      odcInvoiceNo: null,
      odcInvoiceDate: null,
      odcSupplier: null,
      odcSummary: 0,
      odcFileChk: false,
      odcSupplierOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  methods: {
    onAddItemClick: function onAddItemClick(e) {
      this.odcitems.push({
        odcMaterialCode: null,
        odcQuantity: 0,
        odcPrice: 0,
        odcTotal: null,
        odcBudgetId: null,
        odcQuotaId: null
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.odcitems.splice(index, 1);
      for (var i = 0; i < this.odcitems.length; i++) {}
    },
    initPlUploader: function initPlUploader() {
      var self = this;
      self.uuid = this._uid;

      var uploader = new __WEBPACK_IMPORTED_MODULE_5_plupload___default.a.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        multi_selection: false,
        browse_button: "uploader-order",
        url: "#",

        chunk_size: "1mb",
        max_retries: 5,
        filters: {
          max_file_size: "10mb",
          mime_types: [{
            title: "doc files",
            extensions: "jpg,jpeg,png,JPG,JPEG,PNG,pdf,PDF,xlsx,xls,doc,docx"
          }]
        },
        resize: {
          width: 300,
          quality: 100
        },
        init: {
          FilesAdded: function FilesAdded(up, files) {
            var $imageContainer = $("#container-file");
            if ($("#files", $imageContainer).data("file-id") != null) {
              $imageContainer.empty();
            }
            __WEBPACK_IMPORTED_MODULE_5_plupload___default.a.each(files, function (file) {
              self.odcFilename = file.name;
              if ($('div[data-file-name="' + file.name + '"]', $imageContainer).length == 0) {
                var nativeData = file.getNative();

                if (files[0]) {
                  self.odcFileChk = true;
                  self.FileUpload = {
                    isNew: true,
                    fileDataContext: nativeData,
                    fileId: file.id,
                    fileName: file.name
                  };
                }

                if (typeof FileReader != "undefined") {
                  var image_holder = $('<div class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap" id="' + file.id + '"></div>');
                  $('<div style="display:none" id="files" data-file-id="' + file.id + '" data-file-name="' + file.name + '" data-file-uploaded="false" alt="' + file.name + '">' + file.name + '<div id="myProgress" class=" progress' + file.id + '"><div id="myBar' + '" class="progress-bar bg-success"><b></b></div ></div></div>').appendTo(image_holder);
                  image_holder.appendTo($imageContainer);
                  var reader = new FileReader();
                  reader.onload = function (e) {
                    $("div[data-file-id=" + file.id + "]").attr("src", e.target.result).show();
                  };
                  reader.readAsDataURL(nativeData);
                }
              }
            });
            up.start();
          },

          UploadProgress: function UploadProgress(up, file) {
            document.getElementById(file.id).getElementsByTagName("b")[0].innerHTML = "<span>" + file.percent + "%</span>";
            document.getElementById("myBar").style.width = file.percent - 1 + "%";
          }
        }
      });
      uploader.init();
    },
    formSubmit: function formSubmit(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var router, self, sItems, uploadedFile, file, formData, uploadResponse;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                router = _this.$router;
                self = _this;

                if ($(_this.$refs.form).validate().form()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:
                if (!(self.odcitems.length == 0)) {
                  _context.next = 7;
                  break;
                }

                Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการสินค้า/ทรัพย์สิน", "warning");
                return _context.abrupt("return", false);

              case 7:
                if (!(self.odcFileChk == false)) {
                  _context.next = 10;
                  break;
                }

                Swal.fire("เกิดข้อผิดพลาด", "กรุณาแนบไฟล์", "warning");
                return _context.abrupt("return", false);

              case 10:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                sItems = [];

                self.odcitems.forEach(function (element) {
                  sItems.push(_defineProperty({
                    MATERIALCODE: element.odcMaterialCode,
                    Price: element.odcPrice,
                    QTY: element.odcQuantity,
                    Summary: element.odcSummary,
                    BudgetId: element.odcBudgetId,
                    QuotaId: element.odcQuotaId
                  }, "Summary", element.odcTotal));
                });

                uploadedFile = null;

                if (!(_this.FileUpload && _this.FileUpload.isNew && _this.FileUpload.fileDataContext)) {
                  _context.next = 29;
                  break;
                }

                _context.prev = 15;
                file = _this.FileUpload;
                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("FolderName", "StockOrder");

                _context.next = 22;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 22:
                uploadResponse = _context.sent;


                uploadedFile = {
                  contentType: file.fileDataContext.type || "-",
                  downloadUrl: uploadResponse.data.fileUrl,
                  fileInfoId: uploadResponse.data.fileInfoId,
                  fileName: file.fileName,
                  gridFsId: uploadResponse.data.gridFsId,
                  sysName: "-"
                };
                _context.next = 29;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](15);

                console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", _context.t0);

              case 29:

                __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                  method: "post",
                  url: "/Api/Stock",
                  data: {
                    invoiceNo: self.odcInvoiceNo,
                    invoiceDate: self.odcInvoiceDate.format("DD/MM/YYYY"),
                    vendorId: self.odcSupplier,
                    stockItems: sItems,
                    fileUpload: uploadedFile
                  }
                }).then(function (response) {
                  if (response.data.status) {
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      router.go(-1), self.$parent.reloadDataTable(false);
                    });
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[15, 26]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, arrows;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this2;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.odcInvoiceDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              self.odcInvoiceDate = moment();
              $(self.$refs.odcInvoiceDate).datepicker("update", self.odcInvoiceDate.format("DD/MM/YYYY")).on("changeDate", function (e) {
                self.odcInvoiceDate = moment(e.date);
              });

              self.initPlUploader();

              $(_this2.$refs.form).validate({
                rules: {
                  odcInvoiceNo: "required",
                  odcInvoiceDate: "required",
                  odcSupplier: "required"
                },
                messages: {
                  odcInvoiceNo: "กรุณาระบุ InvoiceNo",
                  odcInvoiceDate: "กรุณาระบุ InvoiceDate",
                  odcSupplier: "กรุณาระบุ Supplier"
                }
              });

              $(_this2.$refs.form).validate().settings.ignore = ":hidden";

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      ordInvoiceNo: null,
      ordInvoiceDate: null,
      ordSupplier: null,
      ordStocks: null,
      ordFileName: null,
      ordDownloadUrl: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Stock/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  //console.log(response.data);
                  if (response.data != null && response.data.length > 0) {
                    self.ordInvoiceNo = response.data[0].invoiceNo;
                    self.ordInvoiceDate = response.data[0].invoiceDateFormat;
                    self.ordSupplier = response.data[0].vendorName;
                    self.ordFileName = response.data[0].fileName;
                    // self.ordDownloadUrl =
                    //   "/Api/DownloadFile/Byte?" + response.data[0].downloadUrl;
                    if (response.data[0].downloadUrl) {
                      self.ordDownloadUrl = "/Api/File/FileDownloadByte?FileInfoId=" + response.data[0].downloadUrl + "&ContentType=" + encodeURIComponent(response.data[0].contentType) + "&FileName=" + encodeURIComponent(response.data[0].fileName);
                    }
                    self.ordStocks = response.data;
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสินค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    oddTotalQty: function oddTotalQty() {
      var sum = 0;
      if (this.ordStocks != null && this.ordStocks.length > 0) {
        for (var i = 0; i < this.ordStocks.length; i++) {
          var stock = this.ordStocks[i];
          sum += stock.qty;
        }
      }
      return sum;
    },
    oddTotalPrice: function oddTotalPrice() {
      var sum = 0;
      if (this.ordStocks != null && this.ordStocks.length > 0) {
        for (var i = 0; i < this.ordStocks.length; i++) {
          var stock = this.ordStocks[i];
          sum += stock.price;
        }
      }
      return sum;
    },
    oddTotalSum: function oddTotalSum() {
      var sum = 0;
      if (this.ordStocks != null && this.ordStocks.length > 0) {
        for (var i = 0; i < this.ordStocks.length; i++) {
          var stock = this.ordStocks[i];
          sum += stock.summaryItem;
        }
      }
      return sum;
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */]
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    var self = this;

    return {
      odcMaterialCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      odcBudgetIdOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/BudgetBrand/Select2BudgetQuery",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      odcQuotaIdOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Quota/Select2Quota",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },


  computed: {
    totalCal: function totalCal() {
      return this.item.odcTotal = this.item.odcQuantity * this.item.odcPrice;
    }
  },
  methods: {
    onRemoveItemClick: function onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    }
  },
  mounted: function mounted() {
    $(".required", this.$el).each(function () {
      var $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required")
        }
      });
    });
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

// let StatusActionsTrue = Vue.extend({
//   template: `
//   <div>
//     <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
//       <i class="fas fa-play"></i>เปิดใช้งาน
//     </a>
//   </div>`,
//   methods: {
//     editStatus: function() {
//       let self = this;
//       var table = $("#orderTable");
//       Swal.fire({
//         title: "คำสั่งแก้ไขสถานะ",
//         type: "warning",
//         html:
//           "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
//           "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
//         inputPlaceholder: "ต้องการแก้ไขสถานะ",
//         showCancelButton: true,
//         confirmButtonText: "ยืนยัน",
//         cancelButtonText: "ยกเลิก",
//         showLoaderOnConfirm: true
//       }).then(result => {
//         if (result.value === true || result.value === false) {
//           KTApp.blockPage({
//             opacity: 0.05,
//             message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
//           });

//           axios
//             .put("/Api/Stock/" + this.data.stockHeaderId + "/Toggle")
//             .then(function(response) {
//               if (response.data.data) {
//                 self.$parent.reloadDataTable();
//                 Swal.fire("สำเร็จ", response.data.message, "success");
//               } else {
//                 Swal.fire(
//                   "เกิดข้อผิดพลาด",
//                   error.response.data.message,
//                   "error"
//                 );
//               }
//             })
//             .catch(function(error) {
//               Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
//             })
//             .then(function() {
//               // always executed
//               KTApp.unblockPage();
//             });
//         }
//       });
//     }
//   }
// });
// let StatusActionsFalse = Vue.extend({
//   template: `
//   <div>
//     <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
//       <i class="fas fa-pause"></i>ปิดใช้งาน
//     </a>
//   </div>`,
//   methods: {
//     editStatus: function() {
//       let self = this;
//       var table = $("#orderTable");
//       Swal.fire({
//         title: "คำสั่งแก้ไขสถานะ",
//         type: "warning",
//         html:
//           "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
//           "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
//         inputPlaceholder: "ต้องการแก้ไขสถานะ",
//         showCancelButton: true,
//         confirmButtonText: "ยืนยัน",
//         cancelButtonText: "ยกเลิก",
//         showLoaderOnConfirm: true
//       }).then(result => {
//         if (result.value === true || result.value === false) {
//           KTApp.blockPage({
//             opacity: 0.05,
//             message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
//           });

//           axios
//             .put("/Api/Stock/" + this.data.stockHeaderId + "/Toggle")
//             .then(function(response) {
//               if (response.data.data) {
//                 self.$parent.reloadDataTable();
//                 Swal.fire("สำเร็จ", response.data.message, "success");
//               } else {
//                 Swal.fire(
//                   "เกิดข้อผิดพลาด",
//                   error.response.data.message,
//                   "error"
//                 );
//               }
//             })
//             .catch(function(error) {
//               Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
//             })
//             .then(function() {
//               // always executed
//               KTApp.unblockPage();
//             });
//         }
//       });
//     }
//   }
// });
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"detailStock\" v-if=\"data.showDetailButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-file-text\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"editStock\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"deleteStock\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    detailStock: function detailStock() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Master/Order/Detail/" + this.data.stockHeaderId
      });
    },
    editStock: function editStock() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Master/Order/Edit/" + this.data.stockHeaderId
      });
    },
    deleteStock: function deleteStock() {
      var _this = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลการสั่งซื้อ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลการสั่งซื้อ <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลการสั่งซื้อนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ลบข้อมูลการสั่งซื้อ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/Stock/" + _this.data.stockHeaderId + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      orlKeyword: null,
      orlInvDate: null,
      //orlInActiveStatus: null,
      orlVendorId: [],
      orlQuotaId: [],
      orlProductId: [],
      //config
      // orlInActiveStatusOptions: {
      //   placeholder: "ทั้งหมด",
      //   allowClear: true,
      //   data: [
      //     { id: "false", text: "ใช้งาน", data: null },
      //     { id: "true", text: "ปิดใช้งาน", data: null }
      //   ]
      // },
      orlVendorIdOptions: [],
      // orlVendorIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Vendors/Select2Vendor",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      orlQuotaIdOptions: [],
      // orlQuotaIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Quota/Select2Quota",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      orlProductIdOptions: []
      // orlProductIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Stock/Select2ProductStockItemQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.orlKeyword = null;
      self.orlInvDate = null;
      self.orlVendorId = [];
      self.orlQuotaId = [];
      self.orlProductId = [];

      // $("#orlInActiveStatus")
      //   .val("")
      //   .trigger("change");

      $("#orlInvDate").val("").trigger("change");

      $("#orlVendorId").val("").trigger("change");

      $("#orlQuotaId").val("").trigger("change");

      $("#orlProductId").val("").trigger("change");
      self.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#orderTable").DataTable();
      table.search(this.id | this.name);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#orderTable").DataTable().ajax.reload(null, resetPaging);
    },
    //LoadaOrlVendorIdOptions({ action, searchQuery, callback }) {
    LoadaOrlVendorIdOptions: function LoadaOrlVendorIdOptions() {
      var inputdata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var self = this;
      self.orlVendorIdOptions = [];

      if (inputdata) {
        if (inputdata.action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Vendors/Select2Vendor", {
            params: {
              page: 1,
              all: true,
              search: inputdata.searchQuery
            }
          }).then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.orlVendorIdOptions = [];
              data.forEach(function (element) {
                self.orlVendorIdOptions.push({
                  id: element.id,
                  label: element.text
                });
              });
            }
            inputdata.callback(null, self.orlVendorIdOptions);
          }).catch(function (error) {});
        }
      }
    },

    LoadaOrlQuotaIdOptions: function LoadaOrlQuotaIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Quota/Select2Quota", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.orlQuotaIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadaOrlProductIdOptions: function LoadaOrlProductIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Stock/Select2ProductStockItemQuery", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.orlProductIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;


              self.LoadaOrlVendorIdOptions();
              self.LoadaOrlQuotaIdOptions();
              self.LoadaOrlProductIdOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.orlInvDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.orlInvDate = moment();
              $(self.$refs.orlInvDate)
              //.datepicker("update", self.orlInvDate.format("DD/MM/YYYY"))
              .on("changeDate", function (e) {
                self.orlInvDate = moment(e.date);
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#orderTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Stock/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    //check for clear date value
                    var idDate = $("#orlInvDate").val();
                    if (idDate == null || idDate == "") self.orlInvDate = null;

                    var jsonSearch = {
                      SearchKeyword: self.orlKeyword,
                      InvoiceDate: self.orlInvDate != null ? self.orlInvDate.format("DD/MM/YYYY") : self.orlInvDate,
                      VendorId: self.orlVendorId,
                      QuotaId: self.orlQuotaId,
                      MaterialCode: self.orlProductId
                      //InActiveStatus: self.orlInActiveStatus
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[1, "desc"]],
                columns: [{ data: "invoiceNo", className: "text-center" }, {
                  data: "invoiceDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.invoiceDateFormat;
                  }
                }, { data: "vendorName", className: "text-center" }, {
                  data: "summary",
                  render: function render(value) {
                    return self.$options.filters.currency(value, "฿");
                  },
                  className: "text-center"
                },
                // {
                //   data: "inActiveStatus",
                //   className: "text-center",
                //   width: "10%",
                //   orderable: false,
                //   render: function(data, type, full, meta) {
                //     return '<div class="actionsStatus"></div>';
                //   }
                // },
                {
                  data: "stockHeaderId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // $(".actionsStatus").each(function(i, el) {
                //   var $dt = table.DataTable();
                //   var $tr = $(el)
                //     .parents("tr")
                //     .first();
                //   var data = $dt.row($tr).data();
                //   if (data) {
                //     data.showEditStatusButton = self.$root.canShow(['MANAGE_MASTER', 'MANAGE_ORDER']);
                //     if (data.inActiveStatus == 0)
                //       new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                //         el
                //       );
                //     else if (data.inActiveStatus == 1)
                //       new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                //         el
                //       );
                //   }
                // });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  //console.log(data);
                  if (data) {
                    data.showDetailButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_ORDER"]);
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_ORDER"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_ORDER"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderItemRow__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_plupload__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */],
    orderItemRow: __WEBPACK_IMPORTED_MODULE_4__OrderItemRow__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      uuid: null,
      oruItems: [],
      i: 0,
      oruStockHeaderId: null,
      oruInvoiceNo: null,
      oruInvoiceDate: null,
      oruSupplier: null,
      oruSummary: 0,
      attachedId: null,
      oruFileName: null,
      oruDownloadUrl: null,
      oruSupplierOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  methods: {
    onAddItemClick: function onAddItemClick(e) {
      this.oruItems.push({
        odcMaterialCode: null,
        odcQuantity: 0,
        odcPrice: 0,
        odcTotal: null,
        odcBudgetId: null,
        odcQuotaId: null
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index, delItem) {
      this.oruItems.splice(index, 1);
      for (var i = 0; i < this.oruItems.length; i++) {}
    },
    initPlUploader: function initPlUploader() {
      var self = this;
      self.uuid = this._uid;

      var uploader = new __WEBPACK_IMPORTED_MODULE_5_plupload___default.a.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        multi_selection: false,
        // multipart: false,
        browse_button: "uploader-order", // you can pass in id...
        // container: document.getElementById("uploader-agent"), // ... or DOM Element itself
        url: "/Components/Plupload?reference=" + self.uuid, // คือ Url มาตรฐานของ plupload

        chunk_size: "1mb",
        max_retries: 5,
        filters: {
          max_file_size: "10mb",
          mime_types: [{
            title: "doc files",
            extensions: "jpg,jpeg,png,JPG,JPEG,PNG,pdf,PDF,xlsx,xls,doc,docx"
          }]
        },
        resize: {
          width: 300,
          quality: 100
        },
        init: {
          FilesAdded: function FilesAdded(up, files) {
            var $imageContainer = $("#container-file");
            if ($("#files", $imageContainer).data("file-id") != null) {
              $imageContainer.empty();
            }
            __WEBPACK_IMPORTED_MODULE_5_plupload___default.a.each(files, function (file) {
              self.odcFilename = file.name;
              if ($('div[data-file-name="' + file.name + '"]', $imageContainer).length == 0) {
                var nativeData = file.getNative();

                if (files[0]) {
                  self.odcFileChk = true;
                  self.FileUpload = {
                    isNew: true,
                    fileDataContext: nativeData,
                    fileId: file.id,
                    fileName: file.name
                  };
                }

                if (typeof FileReader != "undefined") {
                  var image_holder = $('<div class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap" id="' + file.id + '"></div>');
                  $('<div style="display:none" id="files" data-file-id="' + file.id + '" data-file-name="' + file.name + '" data-file-uploaded="false" alt="' + file.name + '">' + file.name + '<div id="myProgress" class=" progress' + file.id + '"><div id="myBar' + '" class="progress-bar bg-success"><b></b></div ></div></div>').appendTo(image_holder);
                  image_holder.appendTo($imageContainer);
                  var reader = new FileReader();
                  reader.onload = function (e) {
                    $("div[data-file-id=" + file.id + "]").attr("src", e.target.result).show();
                  };
                  reader.readAsDataURL(nativeData);
                }
              }
            });
            up.start();
          },

          UploadProgress: function UploadProgress(up, file) {
            document.getElementById(file.id).getElementsByTagName("b")[0].innerHTML = "<span>" + file.percent + "%</span>";
            document.getElementById("myBar").style.width = file.percent - 1 + "%";
          }
        }
      });
      uploader.init();
    },
    formSubmit: function formSubmit(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var router, self, sItems, uploadedFile, file, formData, uploadResponse;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                router = _this.$router;
                self = _this;

                if ($(_this.$refs.form).validate().form()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:
                if (!(self.oruItems.length == 0)) {
                  _context.next = 7;
                  break;
                }

                Swal.fire("เกิดข้อผิดพลาด", "กรุณาเพิ่มรายการสินค้า/ทรัพย์สิน", "warning");
                return _context.abrupt("return", false);

              case 7:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                sItems = [];

                self.oruItems.forEach(function (element) {
                  sItems.push(_defineProperty({
                    MATERIALCODE: element.odcMaterialCode,
                    Price: element.odcPrice,
                    QTY: element.odcQuantity,
                    Summary: element.oruSummary,
                    BudgetId: element.odcBudgetId,
                    QuotaId: element.odcQuotaId
                  }, "Summary", element.odcTotal));
                });

                uploadedFile = null;

                if (!(_this.FileUpload && _this.FileUpload.isNew && _this.FileUpload.fileDataContext)) {
                  _context.next = 26;
                  break;
                }

                _context.prev = 12;
                file = _this.FileUpload;
                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("FolderName", "StockOrder");

                _context.next = 19;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 19:
                uploadResponse = _context.sent;


                uploadedFile = {
                  contentType: file.fileDataContext.type || "-",
                  downloadUrl: uploadResponse.data.fileUrl,
                  fileInfoId: uploadResponse.data.fileInfoId,
                  fileName: file.fileName,
                  gridFsId: uploadResponse.data.gridFsId,
                  sysName: "-"
                };
                _context.next = 26;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](12);

                console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", _context.t0);

              case 26:

                __WEBPACK_IMPORTED_MODULE_0_axios___default()({
                  method: "put",
                  url: "/Api/Stock",
                  data: {
                    stockHeaderId: self.oruStockHeaderId,
                    invoiceNo: self.oruInvoiceNo,
                    invoiceDate: self.oruInvoiceDate.format("DD/MM/YYYY"),
                    vendorId: self.oruSupplier,
                    attachedId: self.attachedId,
                    fileUpload: uploadedFile,
                    stockItems: sItems
                  }
                }).then(function (response) {
                  if (response.data.status) {
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      router.go(-1), self.$parent.reloadDataTable(false);
                    });
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 23]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, arrows;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this2;
              router = _this2.$router;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.oruInvoiceDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              self.oruInvoiceDate = moment();
              $(self.$refs.oruInvoiceDate).datepicker("update", self.oruInvoiceDate.format("DD/MM/YYYY")).on("changeDate", function (e) {
                self.oruInvoiceDate = moment(e.date);
              });

              self.initPlUploader();

              $(_this2.$refs.form).validate({
                rules: {
                  oruInvoiceNo: "required",
                  oruInvoiceDate: "required",
                  oruSupplier: "required"
                },
                messages: {
                  oruInvoiceNo: "กรุณาระบุ InvoiceNo",
                  oruInvoiceDate: "กรุณาระบุ InvoiceDate",
                  oruSupplier: "กรุณาระบุ Supplier"
                }
              });

              $(_this2.$refs.form).validate().settings.ignore = ":hidden";

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Stock/" + _this2.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  if (response.data != null && response.data.length > 0) {
                    self.oruStockHeaderId = response.data[0].stockHeaderId;
                    self.oruInvoiceNo = response.data[0].invoiceNo;
                    self.attachedId = response.data[0].attachedId;
                    self.oruFileName = response.data[0].fileName;
                    if (response.data[0].downloadUrl) {
                      self.oruDownloadUrl = "/Api/File/FileDownloadByte?FileInfoId=" + response.data[0].downloadUrl + "&ContentType=" + encodeURIComponent(response.data[0].contentType) + "&FileName=" + encodeURIComponent(response.data[0].fileName);
                    }
                    self.oruInvoiceDate = moment(response.data[0].invoiceDateFormat, "DD/MM/YYYY");
                    $(self.$refs.oruInvoiceDate).datepicker("update", response.data[0].invoiceDateFormat2);

                    if (response.data[0].vendorId) {
                      self.$refs.oruSupplierSelect2.setSelectedData({
                        id: response.data[0].vendorId,
                        text: response.data[0].vendorName
                      });
                    }

                    var _loop = function _loop(i) {
                      item = response.data[i];

                      self.oruItems.push({
                        odcMaterialCode: item.materialCode,
                        odcQuantity: item.qty,
                        odcPrice: item.price,
                        odcTotal: item.summaryItem,
                        odcBudgetId: item.budgetId,
                        odcQuotaId: item.quotaId,
                        selectedMaterialCodeData: {
                          id: item.materialCode,
                          text: item.materialName + " [" + item.materialCode + "]",
                          data: null
                        },
                        selectedBudgetData: {
                          id: item.budgetId,
                          text: item.budgetName,
                          data: null
                        },
                        selectedQuotaData: {
                          id: item.quotaId,
                          text: item.quotaName,
                          data: null
                        }
                      });

                      setTimeout(function () {
                        self.$refs.orderItems[i].$refs.odcMaterialCode.setSelectedData(self.oruItems[i].selectedMaterialCodeData);

                        self.$refs.orderItems[i].$refs.odcBudgetId.setSelectedData(self.oruItems[i].selectedBudgetData);

                        self.$refs.orderItems[i].$refs.odcQuotaId.setSelectedData(self.oruItems[i].selectedQuotaData);
                      }, 100);
                    };

                    for (var i = 0; i < response.data.length; i++) {
                      var item;

                      _loop(i);
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_plupload__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {
      odMaterialName: null,
      odMaterialCode: null,
      odTranTypeCode: null,
      odDayBeforeAlert: null,
      odEffectiveDate: null,
      odRentalPrice: null,
      odInActiveStatus: true,
      odTranTypeName: null,
      odDayAlert: null,

      odTranTypeCodeOptions: [],
      odMaterialCodeOptions: []

    }, _defineProperty(_ref, "odMaterialCodeOptions", {
      placeholder: "เลือกสินค้า",
      allowClear: true,
      ajax: {
        url: "/Api/Product/Select2Product",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            onlyHasBarcode: true
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "odTranTypeCodeOptions", {
      placeholder: "เลือกประเภทของการกระจายสินค้า",
      allowClear: true,
      ajax: {
        url: "/Api/MasterOverdueSetting/Select2BarcodeAlertTransType",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            onlyHasBarcode: true
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  methods: {
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/MasterOverdueSetting", {

        odMaterialName: this.odMaterialName,
        odMaterialCode: this.odMaterialCode,
        odTranTypeCode: this.odTranTypeCode,
        odDayBeforeAlert: this.odDayBeforeAlert,
        odDayAlert: this.odDayAlert,
        odEffectiveDate: self.odEffectiveDate != null ? self.odEffectiveDate.format("DD/MM/YYYY") : self.odEffectiveDate,
        odRentalPrice: this.odRentalPrice,
        odInActiveStatus: !this.odInActiveStatus

      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          //console.log(response);
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onMaterialCodeChange: function onMaterialCodeChange(id, text, data, ref) {
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.odMaterialName = data[0].text;
      }
    },
    odTranTypeCodeChange: function odTranTypeCodeChange(id, text, data, ref) {
      //nothing
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.odTranTypeName = data[0].text;
      }
    }

  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              // set validation rules
              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(_this.$refs.form).validate({

                rules: {
                  odMaterialCode: "required",
                  odTranTypeCode: "required",
                  odDayBeforeAlert: "required",
                  odRentalPrice: "required",
                  odDayAlert: "required"

                },
                messages: {
                  odMaterialCode: "กรุณาเลือกชื่อสินค้า",
                  odTranTypeCode: "กรุณาเลือกประเภทของการกระจายสินค้า",
                  odDayBeforeAlert: "กรุณากรอกจำนวนวันแจ้งเตือนก่อนครบกำหนด",
                  odRentalPrice: "กรุณากรอกจำนวนเงินค่าเช่า กรณีเกินกำหนด (วันละ)",
                  odDayAlert: "กรุณากรอกจำนวนวันครบกำหนด"
                }
              });
              $(self.$refs.odEffectiveDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                //endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.odEffectiveDate).datepicker("update", !!self.odEffectiveDate ? self.odEffectiveDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.odEffectiveDate = e.dates.length != 0 ? moment(e.date) : null;
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      console.log(this.data);
      var self = this;
      var table = $("#BarcodeAlertConfigTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/MasterOverdueSetting/" + _this.data.id + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#BarcodeAlertConfigTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/MasterOverdueSetting/" + _this2.data.id + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div> \n    <a href=\"#\" @click.prevent=\"editData\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"deleteData\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    detailData: function detailData() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Master/OverdueSetting/Detail/" + this.data.id
      });
    },
    editData: function editData() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Master/OverdueSetting/Edit/" + this.data.id
      });
    },
    deleteData: function deleteData() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูล",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูล <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ลบข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/MasterOverdueSetting/" + _this3.data.id + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      odInActiveStatus: null,
      orlKeyword: null,
      MbSKUOptions: [],
      MbSKUId: [],
      MbSKUTransTypeOptions: [],
      MbSKUTransTypeId: [],
      odInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      this.MbSKUId = [];
      this.MbSKUTransTypeId = [];
      // $("#orlInActiveStatus")
      //   .val("")
      //   .trigger("change");
      this.odInActiveStatus = null;
      $("#odInActiveStatus").val(this.pbInActiveStatus + "").trigger("change");

      self.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#BarcodeAlertConfigTable").DataTable();
      table.search(this.id | this.name);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#BarcodeAlertConfigTable").DataTable().ajax.reload(null, resetPaging);
    },
    LoadMbSKUTransTypeOptions: function LoadMbSKUTransTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterOverdueSetting/Select2BarcodeAlertTransType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.MbSKUTransTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadMbSKUOptions: function LoadMbSKUOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.MbSKUOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;

              self.LoadMbSKUOptions();
              self.LoadMbSKUTransTypeOptions();

              $("#odInActiveStatus").val("false").trigger('change');

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }
              $.fn.dataTable.ext.errMode = 'none';
              table = $("#BarcodeAlertConfigTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/MasterOverdueSetting/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    //check for clear date value
                    var idDate = $("#orlInvDate").val();
                    if (idDate == null || idDate == "") self.orlInvDate = null;

                    var jsonSearch = {
                      InActiveStatus: self.odInActiveStatus,
                      SearchKeyword: self.orlKeyword,
                      ProductCodes: self.MbSKUId,
                      TransTypes: self.MbSKUTransTypeId
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "asc"]],
                columns: [
                // { data: "rowNum", className: "text-center" },
                {
                  data: "rowNum",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "alertTransTypeName", className: "text-center" }, {
                  data: "materialcode",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.materialcode + "-" + full.materialdesC_TH2;
                  }
                }, { data: "dayAlertBeforeDueDate", className: "text-center" }, { data: "totalDueDate", className: "text-center" }, {
                  data: "rentalFeePerDay",
                  render: function render(value) {
                    return self.$options.filters.currency(value, "฿");
                  },
                  className: "text-center"
                }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "id",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                alert(message);
                __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_ALERT"]);
                    if (data.inActiveStatus == 0) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  //console.log(data);
                  if (data) {
                    data.showDetailButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_ALERT"]);
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_ALERT"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_ALERT"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  name: "GoogleMap",
  data: function data() {
    var _ref;

    var self = this;
    return _ref = {
      odMaterialName: null,
      odMaterialCode: null,
      odTranTypeCode: null,
      odDayBeforeAlert: null,
      odEffectiveDate: null,
      odRentalPrice: null,
      odInActiveStatus: true,
      odTranTypeName: null,
      odDayAlert: null,

      odTranTypeCodeOptions: [],
      odMaterialCodeOptions: []

    }, _defineProperty(_ref, "odMaterialCodeOptions", {
      placeholder: "เลือกสินค้า",
      allowClear: true,
      ajax: {
        url: "/Api/Product/Select2Product",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            onlyHasBarcode: true
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "odTranTypeCodeOptions", {
      placeholder: "เลือกประเภทของการกระจายสินค้า",
      allowClear: true,
      ajax: {
        url: "/Api/MasterOverdueSetting/Select2BarcodeAlertTransType",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            onlyHasBarcode: true
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  methods: {
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/MasterOverdueSetting", {
        Id: this.$route.params.id,
        odMaterialName: this.odMaterialName,
        odMaterialCode: this.odMaterialCode,
        odTranTypeCode: this.odTranTypeCode,
        odDayBeforeAlert: this.odDayBeforeAlert,
        odDayAlert: this.odDayAlert,
        odEffectiveDate: self.odEffectiveDate != null ? self.odEffectiveDate.format("DD/MM/YYYY") : self.odEffectiveDate,
        odRentalPrice: this.odRentalPrice,
        odInActiveStatus: !this.odInActiveStatus
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onMaterialCodeChange: function onMaterialCodeChange(id, text, data, ref) {
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.odMaterialName = data[0].text;
      }
    },
    odTranTypeCodeChange: function odTranTypeCodeChange(id, text, data, ref) {
      //nothing
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.odTranTypeName = data[0].text;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              // set validation rules
              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(_this.$refs.form).validate({

                rules: {
                  odMaterialCode: "required",
                  odTranTypeCode: "required",
                  odDayBeforeAlert: "required",
                  odRentalPrice: "required",
                  odDayAlert: "required"

                },
                messages: {
                  odMaterialCode: "กรุณาเลือกชื่อสินค้า",
                  odTranTypeCode: "กรุณาเลือกประเภทของการกระจายสินค้า",
                  odDayBeforeAlert: "กรุณากรอกจำนวนวันแจ้งเตือนก่อนครบกำหนด",
                  odRentalPrice: "กรุณากรอกจำนวนเงินค่าเช่า กรณีเกินกำหนด (วันละ)",
                  odDayAlert: "กรุณากรอกจำนวนวันครบกำหนด"
                }
              });
              $(self.$refs.odEffectiveDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                //endDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.odEffectiveDate).datepicker("update", !!self.odEffectiveDate ? self.odEffectiveDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.odEffectiveDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/MasterOverdueSetting/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {

                  self.odDayBeforeAlert = response.data.dayAlertBeforeDueDate;
                  self.odDayAlert = response.data.totalDueDate;
                  //self.odEffectiveDate = response.data.odEffectiveDate;
                  self.odRentalPrice = response.data.rentalFeePerDay;
                  self.odInActiveStatus = !response.data.inActiveStatus;

                  var strEffectiveDate = moment(response.data.effectiveDate).format("DD/MM/YYYY");

                  self.odEffectiveDate = moment(response.data.effectiveDate);

                  $(self.$refs.odEffectiveDate).datepicker("update", !!self.odEffectiveDate ? self.odEffectiveDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                    self.odEffectiveDate = e.dates.length != 0 ? moment(e.date) : null;
                  });

                  if (response.data.materialcode) {
                    self.$refs.odMaterialCodeSelect2.setSelectedData({
                      id: response.data.materialcode,
                      text: response.data.materialdesC_TH2 + " [" + response.data.materialcode + "]"
                    });
                  }
                  if (response.data.barcodeMovementActionType) {
                    self.$refs.odTranTypeCodeSelect2.setSelectedData({
                      id: response.data.barcodeMovementActionType,
                      text: response.data.alertTransTypeName
                    });
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      DlbRefno: [],
      DlbRefnoOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2RefCode",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$("#downloadPhaseModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/MasterPhase/Download",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: null,
          ProductTypeId: [],
          AssetOwnerId: [],
          WarrantyTime: null,
          RefCode: this.DlbRefno
        }
      }).then(function (response) {
        var filename = "";
        var contentType = response.headers["content-type"];
        var disposition = response.headers["content-disposition"];

        //===Get Filename===
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        //Save file
        var blob = new Blob([response.data], { type: contentType });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        $("#DlbRefno").val("").trigger("change");
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              // set validation rules
              $("#downloadPhaseModal form").validate({
                rules: { DlbRefno: "required" },
                messages: { DlbRefno: "กรุณาเลือกรหัสอ้างอิง" }
              });

              $("#downloadPhaseModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              }).modal("show");

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      Flie: "เลือกไฟล์",
      seen: false,
      phaseList: []
    };
  },
  methods: {
    resetFile: function resetFile() {
      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();
      $("#importFilePhase").val("");
      this.seen = false;
      this.Flie = "เลือกไฟล์";
      this.phaseList = [];
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var valid = false;
      // this.phaseList.forEach(element => {
      //   valid = valid || element.validates;
      // });
      // if (valid) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var self = this;
      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/MasterPhase/Import", this.phaseList).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
      // }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              $("#importFilePhase").change(function (e) {
                self.seen = true;
                self.Flie = e.target.files[0].name;

                $("#PreviewTable thead").remove();
                $("#PreviewTable tbody").remove();

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังแสดงข้อมูล กรุณารอสักครู่..."
                });

                var formData = new FormData();
                formData.append("file", e.target.files[0]);
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/MasterPhase/Preview", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }).then(function (response) {
                  self.phaseList = response.data;
                  var $table = $("#PreviewTable");
                  var head = "<thead>" + '<tr role="row">' + '<th class="text-center" aria-label="ลำดับ: activate to sort column ascending" >ลำดับ</th>' + '<th class="text-center" aria-label="Phase: activate to sort column ascending" >Phase</th>' + '<th class="text-center" aria-label="Lot: activate to sort column ascending" style="width:8% ;" >Lot</th>' + '<th class="text-center" aria-label="Material Code: activate to sort column ascending">รหัสสินค้า</th>' + '<th class="text-center" aria-label="ID: activate to sort column ascending">ID</th>' + "</tr>" + "</thead>";
                  $table.append(head);
                  var data = response.data;
                  var table_body = $("<tbody></tbody>");
                  for (var i = 0; i < data.length; i++) {
                    var borders_materialcode = null;
                    if (!data[i].validates) {
                      borders_materialcode = 'style="color:#ff0000;"';
                    }
                    $('<tr role="row" class="odd"><td class="text-center">' + (i + 1) + "</td>" + '<td class="text-center">' + data[i].phase + "</td>" + '<td class="text-center">' + data[i].lot + "</td>" + '<td class="text-center" ' + borders_materialcode + ">" + data[i].hMaterial + "</td>" + '<td class="text-center" ' + borders_materialcode + ">" + data[i].pId + "</td>" + "</tr>").appendTo(table_body);
                    table_body.appendTo($table);
                  }
                  KTApp.unblockPage();
                });
              });

              // set validation rules
              // $("#importBarcodeModal form").validate({
              //   rules: {},
              //   messages: {}
              // });

              // $("#importBarcodeModal")
              //   .on("hidden.bs.modal", function() {
              //     // Set go back
              //     router.go(-1);
              //     self.$parent.reloadDataTable(false);
              //   })
              //   .modal("show");

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

//let Actions = Vue.extend({
//  template: `
//  <div>
//    <a href="#" @click.prevent="detail" v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
//      <i class="fa fa-search"></i>
//    </a>
//  </div>`,
//  methods: {
//    detail: function() {
//      router.push({
//        path: `/Master/ManageBarcode/Detail/${this.data.barcodeId}`
//      });
//    }
//  }
//});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      MbKeyword: ""
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.MbKeyword = "";
      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#phaseTable").DataTable();
      table.search(this.equipment);
      table.draw();
    },
    downloadTemplate: function downloadTemplate(e) {
      e.preventDefault();
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดาวโหลด Template Phase กรุณารอสักครู่..."
      });
      var win = window.open("/Api/MasterPhase/DownloadTemplate", "_blank");
      win.focus(KTApp.unblockPage());
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#phaseTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              $.fn.dataTable.ext.errMode = 'none';
              table = $("#phaseTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/MasterPhase/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.MbKeyword,
                      RefCode: []
                    }));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [100, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[1, "desc"]],
                columns: [{ data: "phase" }, { data: "lot" }, { data: "materialCode" }, { data: "refCode" }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });
              //.on("draw.dt", function () {
              //    $(".actions").each(function (i, el) {
              //        var $dt = table.DataTable();
              //        var $tr = $(el)
              //            .parents("tr")
              //            .first();
              //        var data = $dt.row($tr).data();
              //        if (data) {
              //            data.showDetailButton = self.$root.canShow([
              //                "MANAGE_MASTER",
              //                "MANAGER_EQUIPMENT_LEASING"
              //            ]);
              //            new Actions({ data: { data }, parent: self }).$mount(el);
              //        }
              //    });
              //});

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              $("#Modal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                //self.$parent.reloadDataTable(false);
              }).modal("show");

              $("#statusStock").select2({
                placeholder: "-",
                allowClear: true
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#plantTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Plant/" + _this.data.plantId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#plantTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        Swal.fire("สำเร็จ", "success");
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Plant/" + _this2.data.plantId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n  </div>",
  // <a href="#" @click.prevent="deletePlant" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
  //   <i class="la la-trash"></i>
  // </a>
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/Plant/Edit/" + this.data.plantId
      });
    }
    // deletePlant: function() {
    //   let self = this;
    //   Swal.fire({
    //     title: "คำสั่งลบคลังสินค้า",
    //     type: "warning",
    //     html:
    //       "กรุณายืนยันคำสั่งลบข้อมูลคลังสินค้า <strong>" +
    //       "</strong> หลังจากลบแล้วจะส่งผลให้คลังสินค้านี้ไม่ถูกใช้งาน",
    //     input: this.data.userCount > 0 ? "checkbox" : "",
    //     inputValue: 0,
    //     inputPlaceholder: "ต้องการลบข้อมูลคลังสินค้าออกจากข้อมูล",
    //     showCancelButton: true,
    //     confirmButtonText: "ยืนยัน",
    //     cancelButtonText: "ยกเลิก",
    //     showLoaderOnConfirm: true
    //   }).then(result => {
    //     if (result.value) {
    //       KTApp.blockPage({
    //         opacity: 0.05,
    //         message: "กำลังลบข้อมูล กรุณารอสักครู่..."
    //       });
    //       axios
    //         .put("/Api/Plant/" + this.data.plantId + "/Delete")
    //         .then(function(response) {
    //           if (response.data.data) {
    //             self.$parent.reloadDataTable();
    //             Swal.fire("สำเร็จ", response.data.message, "success");
    //           } else {
    //             Swal.fire(
    //               "เกิดข้อผิดพลาด",
    //               error.response.data.message,
    //               "error"
    //             );
    //           }
    //         })
    //         .catch(function(error) {
    //           Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
    //         })
    //         .then(function() {
    //           // always executed
    //           KTApp.unblockPage();
    //         });
    //     }
    //   });
    // }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    return {
      keyword: "",
      activeStatusKey: "",
      //config
      activeStatusKeyOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.keyword = "";

      //default Active Data
      this.activeStatusKey = false;
      $("#activeStatusKey").val(this.activeStatusKey + "").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#plantTable").DataTable();
      //table.search(this.stockID | this.stockName);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#plantTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;

              //default Active Data

              self.activeStatusKey = false;
              $("#activeStatusKey").val(self.activeStatusKey + "").trigger("change");

              $("#plantKey").select2({
                tags: true,
                placeholder: "กรุณาเลือก",
                allowClear: true,
                ajax: {
                  url: "/Api/Plant/Select2SearchPlant",
                  data: function data(params) {
                    var query = {
                      search: params.term,
                      page: params.page || 1
                    };
                    return query;
                  },
                  processResults: function processResults(data, params) {
                    return {
                      results: data.results,
                      pagination: {
                        more: data.more
                      }
                    };
                  },
                  transport: function transport(params, success, failure) {
                    params.beforeSend = function (request) {
                      request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                    };
                    var $request = $.ajax(params);
                    $request.then(success);
                    $request.fail(failure);
                    return $request;
                  }
                }
              });

              $("#activeStatusKey").select2({
                tags: true,
                placeholder: "ทั้งหมด",
                allowClear: true
              });
              //const user = await this.$root.getUser();

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#plantTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Plant/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.keyword,
                      ActiveStatus: $("#activeStatusKey").val()
                    }));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n      <'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[9, "desc"]],
                columns: [{
                  data: null,
                  className: "details-control",
                  defaultContent: "",
                  orderable: false
                }, { data: "plantId", className: "text-center" }, { data: "plantDesc", className: "text-center" }, { data: "address", className: "text-center" }, { data: "email", className: "text-center" }, { data: "tel", className: "text-center" }, { data: "contact", className: "text-center" }, { data: "latitude", className: "text-center" }, { data: "longitude", className: "text-center" },
                // { data: "img", className: "text-center" },
                {
                  data: "productsList",
                  className: "text-center"
                }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "plantId",
                  className: "text-center",
                  width: "13%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PLANT"]);
                    if (data.inActiveStatus == false) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == true) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PLANT"]);
                    // data.showDeleteButton = self.$root.canShow([
                    //   "MANAGE_MASTER",
                    //   "MANAGE_PLANT"
                    // ]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the styles


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  name: "GoogleMap",
  data: function data() {
    var self = this;
    return {
      StePlantId: null,
      StePlantName: null,
      SteAddress: null,
      SteContactName: null,
      SteProduct: [],
      SteTel: null,
      SteEmail: null,
      SteManufacture: false,
      SteUseStockCoverDays: false,
      SteInActiveStatus: null,
      steProvinceId: null,
      steAmphurId: null,
      steTumbolId: null,
      FileUpload: [],
      SteProductOptions: [],
      OwnerTypeCode: null,
      OwnerTypeCodeOption: [],
      // SteProductOptions: {
      //   multiple: true,
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      steProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      steAmphurIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              provinceId: self.steProvinceId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      steTumbolIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchTumbol",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              ampherId: self.steAmphurId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      SteLat: null,
      SteLng: null,
      markers: []
    };
  },
  methods: {
    handleImageError: function handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad: function handleImageLoad(image) {
      image.isLoaded = true;
    },
    removeImage: function removeImage(pictureId) {
      var _this = this;

      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then(function (result) {
        if (result.value) {
          _this.FileUpload = _this.FileUpload.filter(function (img) {
            return img.pictureId !== pictureId;
          });
          Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
        }
      });
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();

      input.addEventListener("change", function (event) {
        var files = event.target.files;
        Array.from(files).forEach(function (file) {
          if (["image/jpeg", "image/jpg", "image/png"].includes(file.type) && file.size <= 10 * 1024 * 1024) {
            var reader = new FileReader();
            reader.onload = function (e) {
              var newImage = {
                pictureId: Date.now().toString(),
                fileName: file.name,
                urlImg: e.target.result,
                fileDataContext: file,
                isNew: true,
                isLoaded: true
              };
              _this2.FileUpload.push(newImage);
            };
            reader.readAsDataURL(file);
          } else {
            alert("กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)");
          }
        });
      });
    },
    formSubmit: function formSubmit(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var router, self, uploadedFiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, formData, uploadResponse, picturesData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if ($(_this3.$refs.form).validate().form()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", false);

              case 2:
                router = _this3.$router;
                self = _this3;


                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                uploadedFiles = [];

                // Upload new files to GCS

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 9;
                _iterator = _this3.FileUpload[Symbol.iterator]();

              case 11:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 34;
                  break;
                }

                file = _step.value;

                if (!(file.isNew && file.fileDataContext)) {
                  _context.next = 30;
                  break;
                }

                _context.prev = 14;
                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("IsMaster", true);
                formData.append("FolderName", "MasterPlant");

                _context.next = 21;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 21:
                uploadResponse = _context.sent;


                uploadedFiles.push({
                  contentType: "-",
                  downloadUrl: uploadResponse.data.fileUrl,
                  fileInfoId: uploadResponse.data.fileInfoId,
                  fileName: uploadResponse.data.fileInfoId,
                  gridFsId: uploadResponse.data.gridFsId,
                  sysName: "-"
                });
                _context.next = 28;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](14);

                console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", _context.t0);

              case 28:
                _context.next = 31;
                break;

              case 30:
                if (!file.isNew) {
                  // Keep existing files
                  uploadedFiles.push(file);
                }

              case 31:
                _iteratorNormalCompletion = true;
                _context.next = 11;
                break;

              case 34:
                _context.next = 40;
                break;

              case 36:
                _context.prev = 36;
                _context.t1 = _context["catch"](9);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 40:
                _context.prev = 40;
                _context.prev = 41;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 43:
                _context.prev = 43;

                if (!_didIteratorError) {
                  _context.next = 46;
                  break;
                }

                throw _iteratorError;

              case 46:
                return _context.finish(43);

              case 47:
                return _context.finish(40);

              case 48:
                picturesData = uploadedFiles.length > 0 ? uploadedFiles : [];


                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/Plant", {
                  PlantId: _this3.$route.params.Plantid,
                  Email: _this3.SteEmail,
                  Tel: _this3.SteTel,
                  ContactName: _this3.SteContactName,
                  Address: _this3.SteAddress,
                  TumbolId: _this3.steTumbolId,
                  AmphurId: _this3.steAmphurId,
                  ProvinceId: _this3.steProvinceId,
                  Latitude: _this3.SteLat,
                  Longitude: _this3.SteLng,
                  Manufacture: _this3.SteManufacture,
                  UseStockCoverDays: _this3.SteUseStockCoverDays,
                  InActiveStatus: !_this3.SteInActiveStatus,
                  Products: _this3.SteProduct,
                  PlantPictures: picturesData,
                  OwnerTypeCode: _this3.OwnerTypeCode
                }).then(function (response) {
                  if (response.data.status) {
                    KTApp.unblockPage();
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      router.go(-1), self.$parent.reloadDataTable(false);
                    });
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

              case 50:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[9, 36, 40, 48], [14, 25], [41,, 43, 47]]);
      }))();
    },

    getMap: function getMap() {
      var _this4 = this;

      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition(function (position) {
        _this4.SteLat = position.coords.latitude;
        _this4.SteLng = position.coords.longitude;
        _this4.markers = [{
          position: { lat: _this4.SteLat, lng: _this4.SteLng },
          animation: google.maps.Animation.DROP
        }];
      });
    },
    openMap: function openMap() {
      var self = this;
      window.open("https://www.google.com/maps/search/?api=1&query=" + self.SteLat + "," + self.SteLng, "_blank");
    },


    //get current lat,lng (dragable)
    updateCoordinates: function updateCoordinates(location) {
      this.SteLat = location.latLng.lat();
      this.SteLng = location.latLng.lng();
      map: this.map;
      this.markers = [{ position: { lat: this.SteLat, lng: this.SteLng } }];
    },
    onProvinceChange: function onProvinceChange(id, value, data, ref) {
      $("#steAmphurId").val("").trigger("change");

      $("#steTumbolId").val("").trigger("change");
    },
    onAmphurChange: function onAmphurChange(id, value, data, ref) {
      $("#steTumbolId").val("").trigger("change");
    },

    LoadSteProductOptions: function LoadSteProductOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.SteProductOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadOwnerTypeCodeOption: function LoadOwnerTypeCodeOption(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/Options?search=MASTER_OWNER_TYPE", {
        params: {
          page: 1,
          all: true,
          searchCode: "OWNER_PLANT"
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OwnerTypeCodeOption.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this5;
              router = _this5.$router;
              _context2.next = 4;
              return _this5.$root.getUser();

            case 4:
              user = _context2.sent;

              self.LoadSteProductOptions();
              self.LoadOwnerTypeCodeOption();

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Plant/" + _this5.$route.params.Plantid).then(function (response) {
                if (response.status == 200) {
                  self.StePlantId = response.data.plantId;
                  self.StePlantName = response.data.plantDesc;
                  self.SteAddress = response.data.address;
                  self.SteContactName = response.data.contact;
                  self.SteEmail = response.data.email;
                  self.SteTel = response.data.tel;
                  self.SteManufacture = response.data.manufacture;
                  self.SteUseStockCoverDays = response.data.useStockCoverDays;
                  self.OwnerTypeCode = response.data.ownerTypeCode;
                  if (response.data.products) {
                    response.data.products.forEach(function (x) {
                      self.SteProduct.push(x.materialCode);
                    });

                    // var productOptions = $.map(response.data.products, function(
                    //   obj,
                    //   idx
                    // ) {
                    //   return {
                    //     id: obj.materialCode,
                    //     text: obj.materialDesc_th,
                    //   };
                    // });
                    //self.$refs.SteProductSelect2.setSelectedData(productOptions);
                  }
                  setTimeout(function () {
                    if (response.data.ampherId) {
                      self.$refs.steAmphurIdSelect2.setSelectedData({
                        id: response.data.ampherId,
                        text: response.data.ampherName
                      });
                    }

                    setTimeout(function () {
                      if (response.data.tumbolId) {
                        self.$refs.steTumbolIdSelect2.setSelectedData({
                          id: response.data.tumbolId,
                          text: response.data.tumbolName
                        });
                      }
                    }, 50);
                  }, 100);

                  if (response.data.provinceId) {
                    self.$refs.steProvinceIdSelect2.setSelectedData({
                      id: response.data.provinceId,
                      text: response.data.provinceName
                    });
                  }

                  self.SteInActiveStatus = !response.data.inActiveStatus;
                  //Set lat lng
                  response.data.latitude === null ? self.SteLat = null : self.SteLat = parseFloat(response.data.latitude);
                  response.data.longitude === null ? self.SteLng = null : self.SteLng = parseFloat(response.data.longitude);

                  self.markers = [{ position: { lat: self.SteLat, lng: self.SteLng } }];

                  // Load existing images to FileUpload array (GCS format)
                  self.FileUpload = response.data.pictures.map(function (element) {
                    return {
                      pictureId: element.pictureId,
                      fileName: element.fileName,
                      fileInfoId: element.fileInfoId,
                      downloadUrl: element.downloadUrl,
                      urlImg: element.urlImg,
                      gridFsId: element.gridFsId,
                      sysName: element.sysName,
                      isNew: false,
                      isLoaded: true
                    };
                  });
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลคลังสินค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลคลังสินค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              //set validation rules
              $(_this5.$refs.form).validate({
                rules: {
                  steProvinceId: "required",
                  steAmphurId: "required",
                  steTumbolId: "required"
                },
                messages: {
                  steProvinceId: "กรุณาเลือกจังหวัด",
                  steAmphurId: "กรุณาเลือกอำเภอ",
                  steTumbolId: "กรุณาเลือกตำบล"
                }
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              $("#Modal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                //self.$parent.reloadDataTable(false);
              }).modal("show");

              /*
              $("#statusStock").select2({
                placeholder: "-",
                allowClear: true
              });
              */

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      PrdMaterialCode: null,
      PrdProductDesc_th: null,
      PrdProductDesc_th2: null,
      PrdProductBrandDesc: null,
      PrdProductTypeDesc: null,
      PrdProductGroupDesc: null,
      PrdProductBrandId: null,
      PrdProductTypeId: null,
      PrdProductGroupId: null,
      PrdBaseUnit: null,
      PrdInActiveStatus: null,
      PrdIsBarButler: null,
      PrdBarButlerQty: null,
      uuid: null,
      imgDownload: [],
      PrdInitialPrice: null,
      PrdAvgPrice: null,
      PrdQty: null,
      PrdAvQty: null,
      PrdIsForJobHold: null,
      PrdHasBarcode: null,
      PrdPMSpare: null,
      isSpareOrMachine: false,
      IsQiSpare: false,
      IsQiMachine: false,
      IsQiEquipment: false,
      IsSupplierSpare: false,
      QiSubProductTypeDesc: null
    };
  },
  methods: {
    handleImageError: function handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad: function handleImageLoad(image) {
      image.isLoaded = true;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              self.uuid = _this._uid;

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              // set validation rules
              $(_this.$refs.form).validate({
                rules: {},
                messages: {}
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Product/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.PrdMaterialCode = response.data.materialCode;
                  self.PrdProductDesc_th = response.data.materialDesc_th;
                  self.PrdProductDesc_th2 = response.data.materialDesc_th2;
                  self.PrdProductBrandId = response.data.materialBrand;
                  self.PrdProductBrandDesc = response.data.materialBrandDesc;
                  self.PrdProductGroupId = response.data.materialGrp;
                  self.PrdProductGroupDesc = response.data.materialGrpDesc;
                  self.PrdProductTypeId = response.data.materialType;
                  self.PrdProductTypeDesc = response.data.materialTypeDesc;
                  self.PrdBaseUnit = response.data.baseUnit;
                  self.PrdInitialPrice = response.data.initialPrice;
                  self.PrdAvgPrice = response.data.avgPrice;
                  self.PrdInActiveStatus = !response.data.inActiveStatus;
                  self.PrdQty = response.data.qty;
                  self.PrdAvQty = response.data.availableQty;
                  self.PrdIsForJobHold = response.data.isForJobHold;
                  self.PrdHasBarcode = response.data.hasBarcode;
                  self.PrdIsBarButler = response.data.isBarButler;
                  self.PrdBarButlerQty = response.data.barButlerQty;
                  self.PrdPMSpare = response.data.pmSpareName;

                  self.IsQiSpare = response.data.isQiSpare;
                  self.IsQiMachine = response.data.isQiMachine;
                  self.IsQiEquipment = response.data.isQiEquipment;
                  self.IsSupplierSpare = response.data.isSupplierSpare;
                  self.QiSubProductTypeDesc = response.data.qiSubProductTypeDesc;

                  if (self.IsQiEquipment || self.IsQiMachine) self.isSpareOrMachine = true;else self.isSpareOrMachine = false;

                  self.imgDownload = response.data.pictures.map(function (element) {
                    return {
                      pictureId: element.pictureId,
                      downloadUrl: element.urlImg,
                      isLoaded: true
                    };
                  });
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสินค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#ProductTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Product/" + _this.data.materialCode + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#ProductTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Product/" + _this2.data.materialCode + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"details\" v-if=\"data.showDetailButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-file-text\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n     <a href=\"#\" @click.prevent=\"confirmDel\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    details: function details() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/Product/Detail/" + this.data.materialCode
      });
    },
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/Product/Update/" + this.data.materialCode
      });
    },
    confirmDel: function confirmDel() {
      Swal.fire({
        title: "ลบข้อมูล",
        type: "warning",
        text: "ต้องการลบข้อมูลหรือไม่ ?",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          //Swal.fire({ type: "success", text: "You have a bike!" });
        } else if (result.value === 0) {
          //Swal.fire({ type: "error", text: "You don't have a bike :(" });
        } else {
            //console.log(`modal was dismissed by ${result.dismiss}`);
          }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      PrlKeyword: "",
      PrlStatus: "",
      PrlIsForJobHold: "",
      PrlHasBarcode: "",
      PrlProductBrandId: [],
      PrlProductGroupId: [],
      PrlProductTypeId: [],
      PrlPMSpareCode: [],
      PrlPMSpareCodeOptions: [],
      // PrlPMSpareCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทอะไหล่งาน PM",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=PMSPARE_CODE",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      PrlProductBrandIdOptions: [],
      // PrlProductBrandIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      PrlProductGroupIdOptions: [],
      // PrlProductGroupIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      PrlProductTypeIdOptions: [],
      // PrlProductTypeIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      PrlStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      },
      PrlIsForJobHoldOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "true", text: "ใช้งาน", data: null }, { id: "false", text: "ปิดใช้งาน", data: null }]
      },
      PrlHasBarcodeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "true", text: "มี BARCODE", data: null }, { id: "false", text: "ไม่มี BARCODE", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.PrlKeyword = "";
      this.PrlPMSpareCode = [];
      this.PrlProductBrandId = [];
      this.PrlProductGroupId = [];
      this.PrlProductTypeId = [];

      $("#PrlProductBrandId").val("").trigger("change");

      $("#PrlProductTypeId").val("").trigger("change");

      $("#PrlProductGroupId").val("").trigger("change");

      $("#PrlIsForJobHold").val("").trigger("change");

      $("#PrlHasBarcode").val("").trigger("change");

      $("#PrlPMSpareCode").val("").trigger("change");

      //default Active Data
      this.PrlStatus = false;
      $("#PrlStatus").val(this.PrlStatus + "").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#ProductTable").DataTable();
      //table.search(this.id);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#ProductTable").DataTable().ajax.reload(null, resetPaging);
    },
    LoadPrlProductBrandIdOptions: function LoadPrlProductBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.PrlProductBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadPrlProductGroupIdOptions: function LoadPrlProductGroupIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductGroup/Select2ProductGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.PrlProductGroupIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadPrlProductTypeIdOptions: function LoadPrlProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.PrlProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadPrlPMSpareCodeOptions: function LoadPrlPMSpareCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Variables/Options?search=PMSPARE_CODE", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.PrlPMSpareCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;

              //default Active Data

              self.PrlStatus = false;
              $("#PrlStatus").val(self.PrlStatus + "").trigger("change");

              self.LoadPrlProductBrandIdOptions();
              self.LoadPrlProductGroupIdOptions();
              self.LoadPrlProductTypeIdOptions();
              self.LoadPrlPMSpareCodeOptions();

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#ProductTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Product/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    console.log(self.PrlPMSpareCode);
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.PrlKeyword,
                      ActiveStatus: self.PrlStatus,
                      ProductType: self.PrlProductTypeId,
                      ProductBrand: self.PrlProductBrandId,
                      ProductGroup: self.PrlProductGroupId,
                      IsForJobHold: self.PrlIsForJobHold,
                      HasBarcode: self.PrlHasBarcode,
                      PMSpareCode: self.PrlPMSpareCode
                    }));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "asc"]],
                select: {
                  style: "multi",
                  selector: "td:first-child"
                },
                columns: [{ data: "materialCode", className: "text-center" }, { data: "materialDesc_th2", className: "text-center" }, { data: "materialBrandDesc", className: "text-center" }, { data: "materialGrpDesc", className: "text-center" }, { data: "materialTypeDesc", className: "text-center" }, { data: "baseUnit", className: "text-center" }, {
                  data: "isForJobHold",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return data ? "เปิดใช้งาน" : "ปิดใช้งาน";
                  }
                }, {
                  data: "hasBarcode",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return data ? "มีข้อมูล BARCODE" : "ไม่มีข้อมูล BARCODE";
                  }
                }, { data: "pmSpareName", className: "text-center", orderable: false }, {
                  data: "status",
                  className: "text-center",
                  width: "12%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "materialCode",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCT"]);
                    if (data.inActiveStatus == false) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == true) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });

                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showDetailButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCT"]);
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCT"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return _defineProperty({
      isChange: false,
      hocHolderTime: null,
      PruMaterialCode: null,
      PruProductDesc_th: null,
      PruProductDesc_th2: null,
      PruProductBrandDesc: null,
      PruProductTypeDesc: null,
      PruProductGroupDesc: null,
      PruProductBrandId: null,
      PruProductTypeId: null,
      PruProductGroupId: null,
      PruBaseUnit: null,
      PruUnitId: null,
      PruInActiveStatus: null,
      PruIsBarButler: null,
      PruBarButlerQty: null,
      PruMaterialType: null,
      FileUpload: [],
      locale: "th",
      currency: "THB",
      PruInitialPrice: null,
      PruAvgPrice: null,
      PruQty: null,
      PruAvQty: null,
      PruIsForJobHold: null,
      PruHasBarcode: null,
      PruUseStockCoverDays: false,
      PruPMSpare: null,
      QiSubProductTypeOptions: [],

      isSpareOrMachine: false,
      IsQiMachine: false,
      IsQiEquipment: false,

      IsQiSpare: false,
      IsSupplierSpare: false,
      QiSubProductType: null,

      PruPMSpareOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกประเภทอะไหล่งาน PM",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options?search=PMSPARE_CODE",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      PruProductBrandIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              InActiveStatus: true
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      PruUnitIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2ProductUnit",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      PruProductTypeIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductType/Select2ProductTypeByGroup",
          data: function data(params) {
            var query = {
              productGroupId: self.PruProductGroupId,
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },

      PruProductGroupIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductGroup/Select2ProductGroup",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }

    }, "QiSubProductTypeOptions", {
      minimumResultsForSearch: -1,
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/QiJobs/Select2SubProductType",
        data: function data(params) {
          var query = {
            search: "",
            page: 1
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    });
  },
  methods: {
    handleImageError: function handleImageError(image) {
      image.isLoaded = false;
      // console.error("รูปภาพโหลดไม่สำเร็จ:", image.fileName);
    },
    handleImageLoad: function handleImageLoad(image) {
      image.isLoaded = true;
      // console.log("รูปภาพโหลดสำเร็จ:", image.fileName);
    },
    removeImage: function removeImage(pictureId) {
      var _this = this;

      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then(function (result) {
        if (result.value) {
          _this.FileUpload = _this.FileUpload.filter(function (img) {
            return img.pictureId !== pictureId;
          });
          Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
        }
      });
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();

      input.addEventListener("change", function (event) {
        var files = event.target.files;
        Array.from(files).forEach(function (file) {
          if (["image/jpeg", "image/jpg", "image/png"].includes(file.type) && file.size <= 10 * 1024 * 1024) {
            var reader = new FileReader();
            reader.onload = function (e) {
              var newImage = {
                pictureId: Date.now().toString(),
                fileName: file.name,
                urlImg: e.target.result,
                fileDataContext: file,
                isNew: true,
                isLoaded: true
              };
              _this2.FileUpload.push(newImage);
            };
            reader.readAsDataURL(file);
          } else {
            alert("กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)");
          }
        });
      });
    },
    formSubmit: function formSubmit(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var router, self, uploadedFiles, isUploadFile, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, formData, uploadResponse, picturesData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                router = _this3.$router;
                self = _this3;


                if (self.PruProductBrandId == "" || self.PruProductBrandId == null) {
                  _this3.PruProductBrandId = 1;
                }

                //if(self.isSpareOrMachine && !self.QiSubProductType){
                //    //alert('required SubProductType');
                //    return false;
                // }

                if ($(_this3.$refs.form).validate().form()) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", false);

              case 5:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                uploadedFiles = [];
                isUploadFile = false;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 11;
                _iterator = _this3.FileUpload[Symbol.iterator]();

              case 13:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 37;
                  break;
                }

                file = _step.value;

                if (!(file.isNew && file.fileDataContext)) {
                  _context.next = 33;
                  break;
                }

                _context.prev = 16;

                isUploadFile = true;
                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("IsMaster", true);
                formData.append("FolderName", "MasterProduct");

                _context.next = 24;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 24:
                uploadResponse = _context.sent;


                uploadedFiles.push({
                  contentType: "-",
                  downloadUrl: uploadResponse.data.fileUrl,
                  fileInfoId: uploadResponse.data.fileInfoId,
                  fileName: uploadResponse.data.fileInfoId,
                  gridFsId: uploadResponse.data.gridFsId,
                  sysName: "-"
                });
                _context.next = 31;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](16);

                console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", _context.t0);

              case 31:
                _context.next = 34;
                break;

              case 33:
                if (!file.isNew) {
                  uploadedFiles.push(file);
                }

              case 34:
                _iteratorNormalCompletion = true;
                _context.next = 13;
                break;

              case 37:
                _context.next = 43;
                break;

              case 39:
                _context.prev = 39;
                _context.t1 = _context["catch"](11);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 43:
                _context.prev = 43;
                _context.prev = 44;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 46:
                _context.prev = 46;

                if (!_didIteratorError) {
                  _context.next = 49;
                  break;
                }

                throw _iteratorError;

              case 49:
                return _context.finish(46);

              case 50:
                return _context.finish(43);

              case 51:
                picturesData = isUploadFile && uploadedFiles.length > 0 ? uploadedFiles : [];


                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/Product", {
                  MaterialCode: _this3.$route.params.id,
                  MaterialDesc_TH2: _this3.PruProductDesc_th2,
                  ProductBrandId: _this3.PruProductBrandId,
                  UnitId: _this3.PruUnitId,
                  ProductGroupId: _this3.PruProductGroupId,
                  ProductTypeId: _this3.PruProductTypeId,
                  InitialPrice: _this3.PruInitialPrice,
                  InActiveStatus: !_this3.PruInActiveStatus,
                  IsForJobHold: _this3.PruIsForJobHold,
                  HasBarcode: _this3.PruHasBarcode,
                  IsBarButler: _this3.PruIsBarButler,
                  BarButlerQty: _this3.PruBarButlerQty,
                  UseStockCoverDays: _this3.PruUseStockCoverDays,
                  PMSpareCode: _this3.PruPMSpare != "" ? _this3.PruPMSpare : null,
                  Pictures: picturesData,
                  IsQiSpare: _this3.IsQiSpare,
                  IsQiMachine: _this3.IsQiMachine,
                  IsQiEquipment: _this3.IsQiEquipment,
                  IsSupplierSpare: _this3.IsSupplierSpare,
                  QiSubProductType: _this3.QiSubProductType
                }).then(function (response) {
                  if (response.data.status) {
                    KTApp.unblockPage();
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      router.go(-1), self.$parent.reloadDataTable(false);
                    });
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

              case 53:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[11, 39, 43, 51], [16, 28], [44,, 46, 50]]);
      }))();
    },

    PruProductGroupChange: function PruProductGroupChange(id, text, data, ref) {
      if (this.isChange) {
        $("#PruProductTypeId").val("").trigger("change");
      }
    },
    onUsePruAvgPriceClick: function onUsePruAvgPriceClick() {
      var self = this;
      self.PruInitialPrice = self.PruAvgPrice;
    },
    onSubProductTypeChange: function onSubProductTypeChange(selectedId) {
      //console.log("Selected ID:", selectedId)

      if (!selectedId) {
        this.isSpareOrMachine = false; // unchecked when clear ddl.
        this.IsQiEquipment = false;
        this.IsQiMachine = false;
        return;
      } else {
        this.isSpareOrMachine = true;
        if (selectedId == "6") {
          this.IsQiMachine = true;
          this.IsQiEquipment = false;
        } else {
          this.IsQiMachine = false;
          this.IsQiEquipment = true;
        }
      }
      // ค้นหา object เต็มจาก options (ถ้าจำเป็น)
      //const selectedItem = this.QiSubProductTypeOptions.find(x => x.id === selectedId)

      //if (selectedItem) {
      //  this.isSpareOrMachine = true;
      //}
    },
    onSpareOrMachineChange: function onSpareOrMachineChange() {

      if (!this.isSpareOrMachine) {
        this.QiSubProductType = null;

        $("#QiSubProductType").val("").trigger("change"); // Reset to unselected
      }
    }
  },
  computed: {},
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this4;
              router = _this4.$router;
              _context2.next = 4;
              return _this4.$root.getUser();

            case 4:
              user = _context2.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Product/" + _this4.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.PruMaterialCode = response.data.materialCode;
                  self.PruProductDesc_th = response.data.materialDesc_th;
                  self.PruProductDesc_th2 = response.data.materialDesc_th2;
                  self.PruProductBrandId = response.data.materialBrand;
                  self.PruProductBrandDesc = response.data.materialBrandDesc;
                  self.PruUnitId = response.data.unitId;
                  self.PruBaseUnit = response.data.baseUnit;
                  self.PruInActiveStatus = !response.data.inActiveStatus;
                  self.PruInitialPrice = response.data.initialPrice;
                  self.PruAvgPrice = response.data.avgPrice;
                  self.PruQty = response.data.qty;
                  self.PruAvQty = response.data.availableQty;
                  self.PruIsForJobHold = response.data.isForJobHold;
                  self.PruHasBarcode = response.data.hasBarcode;
                  self.PruUseStockCoverDays = response.data.useStockCoverDays;
                  self.PruMaterialType = response.data.materialType;
                  self.PruIsBarButler = response.data.isBarButler;
                  self.PruBarButlerQty = response.data.barButlerQty;

                  self.IsQiSpare = response.data.isQiSpare;
                  self.IsQiMachine = response.data.isQiMachine;
                  self.IsQiEquipment = response.data.isQiEquipment;
                  self.IsSupplierSpare = response.data.isSupplierSpare;
                  self.QiSubProductType = response.data.qiSubProductType;

                  if (self.IsQiEquipment || self.IsQiMachine) self.isSpareOrMachine = true;else self.isSpareOrMachine = false;

                  console.log("IsQiEquipment:", self.IsQiEquipment);
                  console.log("IsQiMachine:", self.IsQiMachine);
                  console.log("Result:", self.IsQiEquipment || self.IsQiMachine);

                  if (response.data.materialBrand && response.data.materialBrandDesc != " ") {
                    self.$refs.PruProductBrandIdSelect2.setSelectedData({
                      id: response.data.materialBrand,
                      text: response.data.materialBrandDesc
                    });
                  }

                  if (response.data.baseUnit) {
                    self.$refs.PruUnitIdSelect2.setSelectedData({
                      id: response.data.unitId,
                      text: response.data.baseUnit
                    });
                  }

                  if (response.data.materialGrp) {
                    self.$refs.PruProductGroupIdSelect2.setSelectedData({
                      id: response.data.materialGrp,
                      text: response.data.materialGrpDesc
                    });
                  }

                  if (response.data.materialType) {
                    self.$refs.PruProductTypeIdSelect2.setSelectedData({
                      id: response.data.materialType,
                      text: response.data.materialTypeDesc
                    });
                  }

                  if (response.data.materialGrp) {
                    self.$refs.PruPMSpareSelect2.setSelectedData({
                      id: response.data.pmSpareCode,
                      text: response.data.pmSpareName
                    });
                  }

                  if (response.data.qiSubProductType) {
                    self.$refs.QiSubProductTypeSelect2.setSelectedData({
                      id: response.data.qiSubProductType,
                      text: response.data.qiSubProductTypeDesc
                    });
                  }

                  self.FileUpload = response.data.pictures.map(function (element) {
                    return {
                      pictureId: element.pictureId,
                      fileName: element.fileName,
                      fileInfoId: element.fileInfoId,
                      downloadUrl: element.downloadUrl,
                      urlImg: element.urlImg,
                      gridFsId: element.gridFsId,
                      sysName: element.sysName,
                      isNew: false,
                      isLoaded: true
                    };
                  });
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสินค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                self.isChange = true;
                KTApp.unblockPage();
              });

              $(_this4.$refs.form).validate({
                rules: {
                  PruProductTypeId: "required",
                  PruProductGroupId: "required",
                  QiSubProductType: {
                    required: function required() {
                      return self.isSpareOrMachine === true;
                    }
                  }
                },
                messages: {
                  PruProductTypeId: "กรุณาเลือกประเภทสินค้า",
                  PruProductGroupId: "กรุณาเลือกหมวดหมู่สินค้า",
                  QiSubProductType: "ประเภทเครื่องเบียร์สด/อุปกรณ์"
                }
              });

              $(_this4.$refs.form).validate().settings.ignore = ":hidden";

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_currency_input__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_currency_input__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      proName: null,
      proRival: false,
      proStatus: true,
      proPMStatus: false
    };
  },

  computed: {},
  methods: {
    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/ProductBrand", {
        ProductBrandName: self.proName,
        RivalBrand: self.proRival,
        InActiveStatus: !self.proStatus,
        PmBrand: self.proRival
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          //console.log(response);
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              //set Current Year

              _this.bcYear = new Date();
              $(_this.$refs.form).validate({
                rules: {
                  proName: "required"
                },
                messages: {
                  proName: "กรุณาระบุชื่อแบรนด์"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);
var RivalActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" v-if=\"data.showEditStatusButton\"  class=\"btn btn-sm btn-danger disabled\">\n      <i class=\"fab fa-product-hunt\"></i>\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\u0E04\u0E39\u0E48\u0E41\u0E02\u0E48\u0E07\n    </a>\n  </div>"
});

var RivalActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"\" v-if=\"data.showEditStatusButton\"  class=\"btn btn-sm btn-success disabled\">\n      <i class=\"fab fa-product-hunt\"></i>\u0E41\u0E1A\u0E23\u0E19\u0E14\u0E4C\u0E43\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D\n    </a>\n  </div>"
});
var PMStatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"\" @click.prevent=\"editPMStatus\" v-if=\"data.showEditPMStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editPMStatus: function editPMStatus() {
      var _this = this;

      var self = this;
      var table = $("#productBrandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะการทำ PM",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะการทำ PM <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะการทำ PM",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/ProductBrand/" + _this.data.productBrandId + "/TogglePM").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var PMStatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editPMStatus\" v-if=\"data.showEditPMStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editPMStatus: function editPMStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#productBrandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะการทำ PM ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะการทำ PM  <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะการทำ PM ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/ProductBrand/" + _this2.data.productBrandId + "/TogglePM").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this3 = this;

      var self = this;
      var table = $("#productBrandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/ProductBrand/" + _this3.data.productBrandId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this4 = this;

      var self = this;
      var table = $("#productBrandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/ProductBrand/" + _this4.data.productBrandId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var productBrandActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editProductBrand\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n     <a href=\"#\" @click.prevent=\"deleteProductBrand\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    editProductBrand: function editProductBrand() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/ProductBrand/Edit/" + this.data.productBrandId
      });
    },
    deleteProductBrand: function deleteProductBrand() {
      var _this5 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลแบรนด์",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลแบรนด์",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลแบรนด์",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/ProductBrand/" + _this5.data.productBrandId + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      pbSearch: null,

      pbInActiveStatus: null,
      pbRivalStatus: null,
      pbPMStatus: null,

      pbInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      },
      pbRivalStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "แบรนด์ในเครือ", data: null }, { id: "true", text: "แบรนด์คู่แข่ง", data: null }]
      },
      pbPMStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "true", text: "ใช้งาน", data: null }, { id: "false", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.pbSearch = null;

      this.pbInActiveStatus = null;
      $("#pbInActiveStatus").val(this.pbInActiveStatus + "").trigger("change");

      this.pbPMStatus = null;
      $("#pbPMStatus").val(this.pbPMStatus + "").trigger("change");

      this.pbRivalStatus = null;
      $("#pbRivalStatus").val(this.pbRivalStatus + "").trigger("change");

      this.formSubmit(e);
    },

    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#productBrandTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#productBrandTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this6;


              $("#pbInActiveStatus").val("false").trigger('change');

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#productBrandTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/ProductBrand/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.pbSearch,
                      InActiveStatus: self.pbInActiveStatus,
                      RivalBrand: self.pbRivalStatus,
                      PmBrand: self.pbPMStatus
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "asc"]],
                columns: [{
                  data: "productBrandName",
                  width: "20%",
                  className: "text-center"
                }, {
                  data: "rivalBrand",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsRival"></div>';
                  }
                }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "pmBrand",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsPMStatus"></div>';
                  }
                }, {
                  data: "productBrandId",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]);
                    if (data.inActiveStatus == 0) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actionsPMStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditPMStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]);
                    if (data.pmBrand == 1) new PMStatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.pmBrand == null || data.pmBrand == 0) new PMStatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actionsRival").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]);
                    if (data.rivalBrand == 0) new RivalActionsFalse({ data: { data: data }, parent: self }).$mount(el);else if (data.rivalBrand == 1) new RivalActionsTrue({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"]);
                    new productBrandActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this6);
    }))();
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_currency_input__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_currency_input__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      proId: null,
      proName: null,
      proRival: false,
      proStatus: true,
      proPMStatus: false
    };
  },

  computed: {},
  methods: {
    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/ProductBrand", {
        ProductBrandId: self.proId,
        ProductBrandName: self.proName,
        RivalBrand: self.proRival,
        InActiveStatus: !self.proStatus,
        PmBrand: self.proRival
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          //console.log(response);
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              //set Current Year

              _this.bcYear = new Date();
              $(_this.$refs.form).validate({
                rules: {
                  proName: "required"
                },
                messages: {
                  proName: "กรุณาระบุชื่อแบรนด์"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductBrand/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.proId = response.data.productBrandId;
                  self.proName = response.data.productBrandName;
                  self.proRival = response.data.rivalBrand;
                  self.proStatus = !response.data.inActiveStatus;
                  self.proPMStatus = response.data.pmBrand;
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEdit: false,
      roleName: null,
      description: null,
      roleClaims: [{
        text: "แดชบอร์ด",
        value: "DASHBOARD",
        opened: true,
        selected: true,
        disabled: true
      }, {
        text: "ข้อมูลพื้นฐาน",
        value: "MASTER",
        opened: false,
        selected: false,
        children: [{
          text: "สมาชิก",
          value: "MASTER_USER",
          opened: true,
          selected: false,
          children: [{
            text: "อ่านข้อมูลสมาชิก",
            value: "MASTER_USER_GET",
            opened: true,
            selected: false
          }, {
            text: "เพิ่มข้อมูลสมาชิก",
            value: "MASTER_USER_CREATE",
            opened: true,
            selected: false
          }, {
            text: "แก้ไขข้อมูลสมาชิก (ข้อมูล, รหัสผ่าน, รีเซ็ตรหัสผ่าน)",
            value: "MASTER_USER_EDIT",
            opened: true,
            selected: false
          }]
        }, {
          text: "บทบาท",
          value: "MASTER_ROLE",
          opened: true,
          selected: false,
          children: [{
            text: "อ่านข้อมูลบทบาท",
            value: "MASTER_ROLE_GET",
            opened: true,
            selected: false
          }, {
            text: "เพิ่มข้อมูลบทบาท",
            value: "MASTER_ROLE_CREATE",
            opened: true,
            selected: false
          }, {
            text: "แก้ไขข้อมูลบทบาท",
            value: "MASTER_ROLE_EDIT",
            opened: true,
            selected: false
          }, {
            text: "ลบข้อมูลบทบาท",
            value: "MASTER_ROLE_DELETE",
            opened: true,
            selected: false
          }]
        }, {
          text: "จัดการไฟล์",
          value: "MASTER_FILE_MANAGER",
          opened: true,
          selected: false,
          children: [{
            text: "อ่านไฟล์",
            value: "MASTER_FILE_MANAGER_GET",
            opened: true,
            selected: false
          }, {
            text: "อัพโหลดไฟล์",
            value: "MASTER_FILE_MANAGER_UPLOAD",
            opened: true,
            selected: false
          }, {
            text: "ลบไฟล์",
            value: "MASTER_FILE_MANAGER_DELETE",
            opened: true,
            selected: false
          }]
        }, {
          text: "ระยะเวลาถือครองสินค้า",
          value: "MASTER_HOLDING",
          opened: true,
          selected: false,
          children: [{
            text: "อ่านข้อมูลการถือครอง",
            value: "MASTER_HOLDING_GET",
            opened: true,
            selected: false
          }, {
            text: "เพิ่มข้อมูลการถือครอง",
            value: "MASTER_HOLDING_CREATE",
            opened: true,
            selected: false
          }, {
            text: "แก้ไขข้อมูลการถือครอง",
            value: "MASTER_HOLDING_EDIT",
            opened: true,
            selected: false
          }, {
            text: "ลบข้อมูลการถือครอง",
            value: "MASTER_HOLDING_DELETE",
            opened: true,
            selected: false
          }]
        }, {
          text: "รายงานความเคลื่อนไหว",
          value: "SEARCHBEER",
          opened: true,
          selected: true,
          disabled: true
        }, {
          text: "การจัดการข้อมูลตัวแทนจำหน่าย",
          value: "AGENT",
          opened: true,
          selected: false,
          children: [{
            text: "อ่านข้อมูลตัวแทนจำหน่าย",
            value: "AGENT_GET",
            opened: true,
            selected: false
          }, {
            text: "เพิ่มข้อมูลตัวแทนจำหน่าย",
            value: "AGENT_CREATE",
            opened: true,
            selected: false
          }, {
            text: "เพิ่มข้อมูลตัวแทนจำหน่าย(Excel)",
            value: "AGENT_CREATE_EXCEL",
            opened: true,
            selected: false
          }, {
            text: "แก้ไขข้อมูลตัวแทนจำหน่าย",
            value: "AGENT_EDIT",
            opened: true,
            selected: false
          }, {
            text: "ลบข้อมูลตัวแทนจำหน่าย",
            value: "AGENT_DELETE",
            opened: true,
            selected: false
          }]
        }, {
          text: "จัดการงบประมาณรายแบรนด์",
          value: "BRAND",
          opened: true,
          selected: false,
          children: [{
            text: "อ่านข้อมูลงบประมาณรายแบรนด์",
            value: "BRAND_GET",
            opened: true,
            selected: false
          }, {
            text: "เพิ่มข้อมูลงบประมาณแบรนด์",
            value: "BRAND_CREATE",
            opened: true,
            selected: false
          }, {
            text: "แก้ไขข้อมูลตัวแทนจำหน่าย",
            value: "AGENT_EDIT",
            opened: true,
            selected: false
          }]
        }, {
          text: "จัดการ Stock สินค้า",
          value: "STOCKPRODUCT",
          opened: true,
          selected: false,
          children: [{
            text: "อ่านข้อมูลงบประมาณรายแบรนด์",
            value: "STOCK_PRODUCT_GET",
            opened: true,
            selected: false
          }, {
            text: "แก้ไขข้อมูลตัวแทนจำหน่าย",
            value: "STOCK_PRODUCT_EDIT",
            opened: true,
            selected: false
          }]
        }, {
          text: "อัพโหลดง Stock รายแบรนด์",
          value: "STOCKPRODUCT",
          opened: true,
          selected: false
        }, {
          text: "จัดการข้อมูลการเบิก/ยืม",
          value: "MANAGE_ฺBORROW_PRODUCT",
          opened: true,
          selected: false,
          children: [{
            text: "อ่านข้อมูลการเบิก/ยืม",
            value: "MANAGE_ฺBORROW_PRODUCT_GET",
            opened: true,
            selected: false
          }, {
            text: "เพิ่มข้อมูลการเบิก/ยืม",
            value: "MANAGE_ฺBORROW_PRODUCT_CREATE",
            opened: true,
            selected: false
          }, {
            text: "แก้ไขข้อมูลการเบิก/ยืม",
            value: "MANAGE_ฺBORROW_PRODUCT_EDIT",
            opened: true,
            selected: false
          }, {
            text: "ลบข้อมูลการเบิก/ยืม",
            value: "MANAGE_ฺBORROW_PRODUCT_DELETE",
            opened: true,
            selected: false
          }]
        }]
      }]
    };
  },
  methods: {
    claimClick: function claimClick(node) {
      var selfParent = node.$parent;
      while (selfParent.model) {
        if (selfParent.model.children.length > 0) {
          // Force selected is true . we will set it depending on children
          selfParent.model.selected = true;
        }
        for (var i = 0; i < selfParent.model.children.length; i++) {
          var child = selfParent.model.children[i];
          selfParent.model.selected = selfParent.model.selected && child.selected;
        }
        selfParent = selfParent.$parent;
      }
    },
    getSelectedClaims: function getSelectedClaims(parent) {
      if (!parent) {
        var pClaims = [];
        for (var pi = 0; pi < this.roleClaims.length; pi++) {
          var p = this.roleClaims[pi];
          pClaims = pClaims.concat(this.getSelectedClaims(p));
        }
        return pClaims;
      }

      var claims = [];
      if (parent.selected) {
        claims.push(parent.value);
      }

      if (parent.children) {
        for (var i = 0; i < parent.children.length; i++) {
          var child = parent.children[i];
          claims = claims.concat(this.getSelectedClaims(child));
        }
      }
      return claims;
    },
    setSelectedClaims: function setSelectedClaims(selected, claims) {
      if (Array.isArray(selected)) {
        for (var i = 0; i < selected.length; i++) {
          var s = selected[i];
          this.setSelectedClaims(s, this.roleClaims);
        }
      } else if (typeof selected === "string" && claims) {
        for (var _i = 0; _i < claims.length; _i++) {
          var cl = claims[_i];
          if (!cl.selected) {
            cl.selected = cl.value === selected;
          }
          this.setSelectedClaims(selected, cl.children);
        }
      }
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$("#roleFormModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.isEdit ? "/Api/Roles/Update" : "/Api/Roles/Create", {
        roleName: this.roleName,
        description: this.description,
        roleClaims: this.getSelectedClaims()
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $("#roleFormModal").modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    var router = this.$router;

    // set validation rules
    $("#roleFormModal form").validate({
      rules: {
        roleName: {
          required: true,
          regex: "^[a-zA-Z0-9_]+$"
        },
        description: "required"
      },
      messages: {
        roleName: {
          required: "กรุณากรอกชื่อบทบาท",
          regex: "ชื่อบทบาทสามารถประกอบไปด้วยตัวอักษรภาษาอังกฤษและตัวเลขเท่านั้น และไม่สามารถเว้นช่องว่างหรือใส่อักขระพิเศษได้"
        },
        description: "กรุณาคำอธิบาย"
      }
    });

    $("#roleFormModal").on("hidden.bs.modal", function () {
      // Set go back
      router.go(-1);
      self.$parent.reloadDataTable(false);
    });

    if (this.$route.params.roleName) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Roles/" + this.$route.params.roleName).then(function (response) {
        if (response.status == 200) {
          self.isEdit = true;
          self.roleName = self.$route.params.roleName;
          self.description = response.data.description;
          self.setSelectedClaims(response.data.roleClaims);

          $("#roleFormModal").modal("show");
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลบทบาทที่คุณเลือก", "warning");
          router.go(-1);
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลบทบาทได้ในขณะนี้", "error");
        router.go(-1);
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    } else {
      $("#roleFormModal").modal("show");
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var RoleActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E17\u0E1A\u0E32\u0E17\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"remove\" v-if=\"data.showDeleteButton\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E17\u0E1A\u0E32\u0E17\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/Master/Roles/Edit/" + this.data.roleName });
    },
    remove: function remove() {
      var _this = this;

      var self = this;

      Swal.fire({
        title: "คำสั่งลบบทบาท",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบบทบาท <strong>" + this.data.roleName + "</strong> หลังจากลบแล้วจะส่งผลให้สมาชิกที่เข้าระบบใหม่ไม่สามารถใช้งานบทบาทนี้ได้อีก",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบบทบาทออกจากข้อมูลสมาชิกด้วย",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === 0 || result.value === 1) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Roles/Delete", {
            roleName: _this.data.roleName,
            force: result.value === 1
          }).then(function (response) {
            if (response.data.status) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      keyword: ""
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.keyword = "";
      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#roleTable").DataTable();
      table.search(this.keyword);
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#roleTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, user, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;
              _context.next = 3;
              return _this2.$root.getUser();

            case 3:
              user = _context.sent;
              table = $("#roleTable");

              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,

                ajax: {
                  url: "/Api/Roles/Find",
                  type: "post",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n      <'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[1, "desc"]],
                columns: [{ data: "roleName", width: "20%" }, { data: "description" }, {
                  data: "userCount",
                  className: "text-center",
                  width: "10%",
                  render: function render(data, type, full, meta) {
                    return data;
                  }
                }, {
                  data: "roleName",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MASTER_ROLE"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MASTER_ROLE"]);
                    new RoleActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  name: "GoogleMap",
  data: function data() {
    var self = this;

    return {
      sacName: null,
      sacProvince: [],
      cshSubAgent: false,
      sacInActiveStatus: true,
      sacProvinceOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/MasterSalesArea", {
        Name: this.sacName,
        ProvinceId: this.sacProvince,
        InActiveStatus: !this.sacInActiveStatus
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          //console.log(response);
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;

              // set validation rules

              $(_this.$refs.form).validate({
                rules: {
                  sacName: "required"
                },
                messages: {
                  sacName: "กรุณากรอกชื่อเขตการขาย"
                }
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#salesAreaTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/MasterSalesArea/" + _this.data.id + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#salesAreaTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        Swal.fire("สำเร็จ", "success");
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/MasterSalesArea/" + _this2.data.id + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"deleteItem\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",

  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/SalesArea/Edit/" + this.data.id
      });
    },
    deleteItem: function deleteItem() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบเขตการขาย",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลเขตการขาย <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้เขตการขายนี้ไม่ถูกใช้งาน และข้อมูลที่ผูกกับตัวแทนจำหน่ายจะถูกลบ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/MasterSalesArea/" + _this3.data.id + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    return {
      keyword: "",
      activeStatusKey: false,
      //config
      activeStatusKeyOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.keyword = "";

      //default Active Data
      this.activeStatusKey = false;
      $("#activeStatusKey").val(this.activeStatusKey + "").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#salesAreaTable").DataTable();
      //table.search(this.stockID | this.stockName);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#salesAreaTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;

              //default Active Data

              self.activeStatusKey = false;
              $("#activeStatusKey").val(self.activeStatusKey + "").trigger("change");
              $("#activeStatusKey").select2({
                tags: true,
                placeholder: "ทั้งหมด",
                allowClear: true
              });
              //const user = await this.$root.getUser();

              table = $("#salesAreaTable");

              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/MasterSalesArea/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.keyword,
                      InActiveStatus: $("#activeStatusKey").val()
                    }));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n      <'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "asc"]],
                columns: [{ data: "createdDate", className: "text-center", visible: false }, {
                  data: "name",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "name", className: "text-center" }, { data: "provinceNameString", className: "text-center" }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "id",
                  className: "text-center",
                  width: "13%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_SETTING"]);
                    if (data.inActiveStatus == false) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == true) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_SETTING"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_SETTING"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  name: "GoogleMap",
  data: function data() {
    var self = this;
    return {
      sauProvince: [],
      sauName: null,
      sauInActiveStatus: null,
      sauProvinceOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/MasterSalesArea", {
        Id: this.$route.params.SalesAreaid,
        Name: this.sauName,
        ProvinceId: this.sauProvince,
        InActiveStatus: !this.sauInActiveStatus
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              //self.initPlUploader();

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/MasterSalesArea/" + _this.$route.params.SalesAreaid).then(function (response) {
                if (response.status == 200) {
                  self.sauName = response.data.name;
                  self.sauInActiveStatus = !response.data.inActiveStatus;
                  if (response.data.salesAreaProvince) {
                    var provinceOptions = $.map(response.data.salesAreaProvince, function (obj, idx) {
                      return {
                        id: obj.provinceId,
                        text: obj.provinceName
                      };
                    });
                    self.$refs.sauProvinceSelect2.setSelectedData(provinceOptions);
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลเขตการขายคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลเขตการขายได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              //set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  sacName: "required"
                },
                messages: {
                  sacName: "กรุณากรอกชื่อเขตการขาย"
                }
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_currency_input__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_currency_input__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
    },
    data: function data() {
        var self = this;
        return {
            msCheckInRange: null,
            msCheckInRangeMaxError: null
        };
    },

    computed: {},
    methods: {
        checkMsCheckInRangeMax: function checkMsCheckInRangeMax(e) {
            var raw = e.target.value;
            var val = Number(raw);
            if (raw !== "" && !isNaN(val) && val > 10000) {
                this.msCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
                // Clamp value back to 10000 (block typing beyond)
                this.msCheckInRange = 10000;
                this.$nextTick(function () {
                    if (e.target) e.target.value = 10000;
                });
            } else {
                this.msCheckInRangeMaxError = null;
            }
        },

        formSubmit: function formSubmit(e) {
            var router = this.$router;
            var self = this;

            if (!$(this.$refs.form).validate().form()) {
                return false;
            }

            KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
            });

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Setting", {
                CheckInRange: self.msCheckInRange
            }).then(function (response) {
                if (response.data.status) {
                    KTApp.unblockPage();
                    Swal.fire("สำเร็จ", response.data.message, "success").then();
                } else {
                    //console.log(response);
                    Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }
            }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }).then(function () {
                // always executed
                KTApp.unblockPage();
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var self;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            self = _this;


                            $(_this.$refs.form).validate({
                                rules: {
                                    msCheckInRange: "required"
                                },
                                messages: {
                                    msCheckInRange: "กรุณาระบุระยะ Check-In"
                                }
                            });

                            $(_this.$refs.form).validate().settings.ignore = ":hidden";

                            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Setting").then(function (response) {
                                if (response.status == 200) {
                                    self.msCheckInRange = response.data.checkInRange;
                                } else {
                                    Swal.fire("เกิดข้อผิดพลาด", "ไม่พบการตั้งค่าคุณเลือก", "warning");
                                    router.go(-1);
                                }
                            }).catch(function (error) {
                                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงการตั้งค่าได้ในขณะนี้", "error");
                                router.go(-1);
                            }).then(function () {
                                // always executed
                                KTApp.unblockPage();
                            });

                        case 4:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  name: "GoogleMap",
  data: function data() {
    var self = this;

    return {
      cshCustomerCode: null,
      cshCustomerName: null,
      cshName2: null,
      cshShopType: null,
      cshShopGroup: null,
      cshShopPMType: null,
      cshAddress: null,
      cshProvinceId: null,
      cshAmphurId: null,
      cshTumbolId: null,
      cshSubAgent: false,
      cshContactFullName: null,
      cshEmail: null,
      cshTel: null,
      cshAgentCode: null,
      cshContactAgentName: null,
      cshContactAgentLName: null,
      cshEmpId: null,
      cshInActiveStatus: true,
      cShIgnoreBarcodeValidation: false,
      cShIsSpecialPM: false,
      cshLat: null,
      cshLng: null,
      // CR-PM-2026 Req 2 — per-shop radius config (default = use Setting)
      useSettingCheckinRange: true,
      customCheckInRange: null,
      customCheckInRangeMaxError: null,
      markers: [],
      FileUpload: [],

      cshStatus: "STATUS_SHOP_ACTIVE_NEW",
      InActiveStatus: "STATUS_SHOP_INACTIVE_CLOSE",

      cshActive: [],
      cshInActive: [],
      cshShopTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cshShopGroupOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopGroup",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cshShopPMTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Select2MasterShopTypePM",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cshEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cshProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cshAmphurIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              provinceId: self.cshProvinceId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cshTumbolIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchTumbol",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              ampherId: self.cshAmphurId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cshAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    // CR-PM-2026 Req 2 — reset to default (use Setting)
    resetCheckinRange: function resetCheckinRange() {
      this.useSettingCheckinRange = true;
      this.customCheckInRange = null;
      this.customCheckInRangeMaxError = null;
    },
    checkCustomCheckInRangeMax: function checkCustomCheckInRangeMax(e) {
      var raw = e.target.value;
      var val = Number(raw);
      if (raw !== "" && !isNaN(val) && val > 10000) {
        this.customCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
        // Clamp value back to 10000 (block typing beyond)
        this.customCheckInRange = 10000;
        this.$nextTick(function () {
          if (e.target) e.target.value = 10000;
        });
      } else {
        this.customCheckInRangeMaxError = null;
      }
    },
    handleImageError: function handleImageError(image) {
      image.isLoaded = false;
      // console.error("รูปภาพโหลดไม่สำเร็จ:", image.fileName);
    },
    handleImageLoad: function handleImageLoad(image) {
      image.isLoaded = true;
      // console.log("รูปภาพโหลดสำเร็จ:", image.fileName);
    },
    removeImage: function removeImage(pictureId) {
      var _this = this;

      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then(function (result) {
        if (result.value) {
          _this.FileUpload = _this.FileUpload.filter(function (img) {
            return img.pictureId !== pictureId;
          });
          Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
        }
      });
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();

      input.addEventListener("change", function (event) {
        var files = event.target.files;
        Array.from(files).forEach(function (file) {
          if (["image/jpeg", "image/jpg", "image/png"].includes(file.type) && file.size <= 10 * 1024 * 1024) {
            var reader = new FileReader();
            reader.onload = function (e) {
              var newImage = {
                pictureId: Date.now().toString(),
                fileName: file.name,
                urlImg: e.target.result,
                fileDataContext: file,
                isNew: true,
                isLoaded: true
              };
              _this2.FileUpload.push(newImage);
            };
            reader.readAsDataURL(file);
          } else {
            alert("กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)");
          }
        });
      });
    },

    //formSubmit: function (e) {
    formSubmit: function formSubmit(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var router, self, uploadedFiles, isUploadFile, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, formData, uploadResponse, picturesData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if ($(_this3.$refs.form).validate().form()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", false);

              case 2:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                router = _this3.$router;
                self = _this3;
                uploadedFiles = [];
                isUploadFile = false;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 10;
                _iterator = _this3.FileUpload[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 37;
                  break;
                }

                file = _step.value;

                if (!(file.isNew && file.fileDataContext)) {
                  _context.next = 33;
                  break;
                }

                _context.prev = 15;

                isUploadFile = true;
                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("IsMaster", true);
                formData.append("FolderName", "MasterProduct");

                _context.next = 23;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 23:
                uploadResponse = _context.sent;


                console.log('uploadResponse', uploadResponse);

                uploadedFiles.push({
                  contentType: "-",
                  downloadUrl: uploadResponse.data.fileUrl,
                  fileInfoId: uploadResponse.data.fileInfoId,
                  fileName: uploadResponse.data.fileInfoId,
                  gridFsId: uploadResponse.data.gridFsId,
                  sysName: "-"
                });
                _context.next = 31;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](15);

                console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", _context.t0);

              case 31:
                _context.next = 34;
                break;

              case 33:
                if (!file.isNew) {
                  uploadedFiles.push(file);
                }

              case 34:
                _iteratorNormalCompletion = true;
                _context.next = 12;
                break;

              case 37:
                _context.next = 43;
                break;

              case 39:
                _context.prev = 39;
                _context.t1 = _context["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 43:
                _context.prev = 43;
                _context.prev = 44;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 46:
                _context.prev = 46;

                if (!_didIteratorError) {
                  _context.next = 49;
                  break;
                }

                throw _iteratorError;

              case 49:
                return _context.finish(46);

              case 50:
                return _context.finish(43);

              case 51:
                picturesData = isUploadFile && uploadedFiles.length > 0 ? uploadedFiles : [];


                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Shop", {
                  CustomerCode: _this3.cshCustomerCode,
                  CustomerName: _this3.cshCustomerName,
                  Name2: _this3.cshName2,
                  ShopTypeId: _this3.cshShopType,
                  ShopPMType: _this3.cshShopPMType,
                  ShopGroupId: _this3.cshShopGroup,
                  Address: _this3.cshAddress,
                  ProvinceId: _this3.cshProvinceId,
                  AmphurId: _this3.cshAmphurId,
                  TumbolId: _this3.cshTumbolId,
                  ContactFullName: _this3.cshContactFullName,
                  Email: _this3.cshEmail,
                  Tel: _this3.cshTel,
                  AgentCode: _this3.cshAgentCode,
                  Latitude: _this3.cshLat,
                  Longitude: _this3.cshLng,
                  ContactAgentName: _this3.cshContactAgentName,
                  ContactAgentLastName: _this3.cshContactAgentLName,
                  EmployeeId: _this3.cshEmpId,
                  ShopPictures: picturesData, //this.cshImgUpload,
                  SubAgent: _this3.cshSubAgent,
                  InActiveStatus: !_this3.cshInActiveStatus,
                  Reason: _this3.cshInActiveStatus == true ? _this3.cshStatus : _this3.InActiveStatus,
                  ignoreBarcodeValidation: _this3.cShIgnoreBarcodeValidation,
                  isSpecialPM: _this3.cShIsSpecialPM,
                  // CR-PM-2026 Req 2 — radius
                  UseSettingCheckinRange: _this3.useSettingCheckinRange,
                  CheckInRange: _this3.useSettingCheckinRange ? null : _this3.customCheckInRange
                }).then(function (response) {
                  if (response.data.status) {
                    KTApp.unblockPage();
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      router.go(-1), self.$parent.reloadDataTable(false);
                    });
                  } else {
                    //console.log(response);
                    Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

              case 53:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[10, 39, 43, 51], [15, 28], [44,, 46, 50]]);
      }))();
    },

    getMap: function getMap() {
      var _this4 = this;

      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition(function (position) {
        _this4.cshLat = position.coords.latitude;
        _this4.cshLng = position.coords.longitude;
        _this4.markers = [{
          position: { lat: _this4.cshLat, lng: _this4.cshLng },
          animation: google.maps.Animation.DROP
        }];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates: function updateCoordinates(location) {
      this.cshLat = location.latLng.lat();
      this.cshLng = location.latLng.lng();
      map: this.map;
      this.markers = [{ position: { lat: this.cshLat, lng: this.cshLng } }];
    },
    deleteImg: function deleteImg() {
      $("#container-img").on("click", ".btm-remove-img-plant", function (e) {
        e.preventDefault();
        var $img = $(this);
        Swal.fire({
          title: "ยืนยันคำสั่ง",
          text: "คุณต้องการลบรูปภาพนี้หรือไม่",
          icon: "danger",
          confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
          confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",

          showCancelButton: true,
          cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
          cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon",

          // imageUrl: Setting.rootPath + "uploads/" + $img.data("file-newid"),
          imageWidth: 400,
          imageAlt: "Custom image",
          buttons: true,
          dangerMode: true
        }).then(function (result) {
          var file = $img.data("file-newid");
          // let url = Setting.rootPath + "Api/File/DeleteFile/" + file;
          var url = "/Api/File/DeleteFile/" + file;
          if (result.value) {
            if ($img.data("type") != "1") {
              $.ajax({
                type: "Get",
                url: url,
                cache: false,
                success: function success(response) {
                  var fileId = "#" + $img.data("file-id");
                  $(fileId).remove();
                  Swal.fire("เรียบร้อย!", "ลบรูปภาพเรียบร้อย", "success");
                },
                failure: function failure(response) {
                  swal("Internal Error", "Oops, your note was not saved.", // had a missing comma
                  "error");
                }
              });
            } else {
              var fileId = "#" + $img.data("file-id");
              $(fileId).remove();
              Swal.fire("เรียบร้อย!", "ลบรูปภาพเรียบร้อย", "success");
            }
          }
        });
      });
    },
    initPlUploader: function initPlUploader() {
      console.log("initPlUploader");
      var self = this;
      var uploader = new __WEBPACK_IMPORTED_MODULE_2_plupload___default.a.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        browse_button: "uploader-shop", // you can pass in id...
        //url: Setting.rootPath + "Components/Plupload?reference=" + self.uuid, // คือ Url มาตรฐานของ plupload
        url: "/Components/Plupload?reference=" + self.uuid,

        chunk_size: "1mb",
        max_retries: 5,
        filters: {
          max_file_size: "10mb",
          mime_types: [{ title: "Image files", extensions: "jpg,jpeg,png,JPG,JPEG,PNG" }]
        },
        resize: {
          width: 300,
          quality: 100
        },
        init: {
          PostInit: function PostInit() {},

          FilesAdded: function FilesAdded(up, files) {
            var $uploadBtn = $(up.settings.browse_button[0]);
            var $imageContainer = $("#container-img");
            //mApp.block($imageContainer.parents('.m-portlet__body'))

            var removeFiles = [];
            __WEBPACK_IMPORTED_MODULE_2_plupload___default.a.each(files, function (file) {
              if ($('img[data-file-name="' + file.name + '"]', $imageContainer).length == 0) {
                var nativeData = file.getNative();
                if (typeof FileReader != "undefined") {
                  var image_holder = $('<div class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap" id="' + file.id + '"></div>');
                  $('<img class="img-plant -avatar js-avatar-me img-thumbnail card-img-top" style="display:none" data-file-id="' + file.id + '" data-file-name="' + file.name + '" data-file-uploaded="false" alt="' + file.name + '" /><div id="myProgress" class=" progress' + file.id + '"><div id="myBar' + file.id + '" class="progress-bar bg-success"><b></b></div ></div >').appendTo(image_holder);
                  image_holder.appendTo($imageContainer);
                  var reader = new FileReader();
                  reader.onload = function (e) {
                    $("img[data-file-id=" + file.id + "]").attr("src", e.target.result).show();
                  };
                  reader.readAsDataURL(nativeData);
                }
              } else {
                removeFiles.push(file);
              }
            });

            if (removeFiles.length > 0) {
              for (var i = 0; i < removeFiles.length; i++) {
                up.removeFile(removeFiles[i]);
              }

              swal("ขออภัย", "ไม่สามารถเลือกไฟล์ซ้ำได้", "warning");
            }

            up.start();
          },

          // BeforeUpload: function(up, file) {
          //   check_object_radio();
          //   set_upload_param(up, file.name, true);
          // },

          UploadProgress: function UploadProgress(up, file) {
            document.getElementById(file.id).getElementsByTagName("b")[0].innerHTML = "<span>" + file.percent + "%</span>";
            $("#myBar" + file.id + " .progress-bar .bg-success").css("width", file.percent - 1 + "%");
          },

          FileUploaded: function FileUploaded(up, file, info) {
            console.log("FileUploaded");
            if (info.response == "OK") {
              var $uploadBtn = $(up.settings.browse_button[0]);
              var $imageContainer = $("#container-img");
              var $img = $("img[data-file-id=" + file.id + "]");
              $img.attr("data-file-uploaded", "true");
              //var url = Setting.rootPath + "Api/File/MoveFile";
              var url = "/Api/File/MoveFile";
              var ref = $("#uploader-shop").data("ref");
              $.ajax({
                url: url,
                type: "post",
                data: {
                  FileID: $img.data("file-id"),
                  FileName: $img.data("file-name"),
                  Reference: ref
                },
                datatype: "json",
                ContentType: "application/json;utf-8"
              }).done(function (data) {
                /*ถ้าสำเร็จให้ทำอะไรต่อ */
                $("#myBar" + file.id).remove();
                $('<div id="myBar' + file.id + '" class="progress-bar bg-success" style="width:100%"><b>100%</b></div >').appendTo($(".progress" + file.id));
                $('<a href="javascript:;" style="position:absolute;top:10px;right:20px;" class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close" data-file-newid="' + data.fileName + '" data-file-id="' + file.id + '" ><span class="m--font-inverse-danger la la-trash"></span></a>').appendTo("#" + data.fileID);
                // $("#" + file.id).removeClass(
                //   "kt-spinner kt-spinner--lg kt-spinner--warning"
                // );
                $("#" + file.id).add;
              });
            }
          },

          Error: function Error(up, err) {
            $("#myBar" + err.file.id).remove();
            $('<div id="myBar' + err.file.id + '" class="myBar" style="background-color:red;width:100%"><b>false</b></div >').appendTo($(".progress" + err.file.id));
            $("#" + err.file.id).removeClass("kt-spinner kt-spinner--lg kt-spinner--warning");
            var a = $('<a class="btn m-btn--pill btn-info m-btn btm-reload-img-plant"><span class="fas fa-redo-alt"></span></a>');
            a.appendTo("#" + err.file.id);
            a.data("up", up);
            a.data("file", err.file);
            a.click(function () {
              var $this = $(this);
              var myUp = $this.data("up");
              var myFile = $this.data("file");
              myFile.status = __WEBPACK_IMPORTED_MODULE_2_plupload___default.a.QUEUED;
              $("#" + myFile.id).remove();
              myUp.addFile(myFile);
            });
            var d = $('<a class="btn m-btn--pill btn-danger m-btn btm-delete-img-plant" style="position:absolute;top:10px;right:20px;"><span class="far fa-trash-alt"></span></a>');
            d.appendTo("#" + err.file.id);
            d.click(function () {
              $("#" + err.file.id).remove();
            });
          }
        }
      });
      uploader.init();
    },
    openMap: function openMap() {
      var self = this;
      window.open("https://www.google.com/maps/search/?api=1&query=" + self.cshLat + "," + self.cshLng, "_blank");
    },
    getStatusShop: function getStatusShop() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Shop/StatusShop").then(function (response) {
        if (response.status == 200) {
          self.cshActive = response.data.filter(function (o) {
            return o.statusGroup == "STATUS_SHOP_ACTIVE";
          });
          self.cshInActive = response.data.filter(function (o) {
            return o.statusGroup == "STATUS_SHOP_INACTIVE";
          });
        }
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this5;
              router = _this5.$router;


              self.getStatusShop();

              // set validation rules
              $(_this5.$refs.form).validate({
                rules: {
                  cshCustomerCode: "required",
                  cshCustomerName: "required",
                  cshShopType: "required",
                  cshShopGroup: "required",
                  cshShopPMType: "required",
                  // cshEmail: {
                  //   emailNullable: true,
                  // },
                  cshAddress: "required",
                  cshProvinceId: "required",
                  cshAmphurId: "required",
                  cshTumbolId: "required",
                  cshTel: "required",
                  cshAgentCode: "required",
                  cshName2: "required",
                  // CR-PM-2026 Issue 14: required เฉพาะกรณี "กำหนดเอง" (useSettingCheckinRange=false)
                  customCheckInRange: {
                    required: function required() {
                      return !self.useSettingCheckinRange;
                    }
                  }
                },
                messages: {
                  cshCustomerCode: "กรุณากรอกรหัสร้านค้า",
                  cshCustomerName: "กรุณากรอกชื่อร้านค้า",
                  cshShopType: "กรุณาเลือกประเภทร้านค้า",
                  cshShopPMType: "ประเภทการล้างเครื่อง",
                  cshShopGroup: "กรุณาเลือกสถานะประเภทร้านค้า",
                  // cshEmail: {
                  //   emailNullable: "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง",
                  // },
                  cshAddress: "กรุณากรอกที่อยู่",
                  cshProvinceId: "กรุณาเลือกประเภทจังหวัด",
                  cshAmphurId: "กรุณาเลือกประเภทอำเภอ",
                  cshTumbolId: "กรุณาเลือกประเภทตำบล",
                  cshTel: "กรุณากรอกเบอร์โทร",
                  cshAgentCode: "กรุณาเลือกผู้ดูแลร้านค้า",
                  cshName2: "กรุณากรอกชื่อร้านค้า 2",
                  customCheckInRange: "กรุณาระบุระยะ (เมตร)"
                }
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      canEdit: true,
      eShCustomerCode: null,
      eShCustomerName: null,
      eShName2: null,
      eShShopType: null,
      eShShopPMType: null,
      eShShopGroup: null,
      eShAddress: null,
      eShProvinceId: null,
      eShAmphurId: null,
      eShTumbolId: null,
      eShSubAgent: null,
      eShEmail: null,
      eShContactFullName: null,
      eShContactAgentName: null,
      eShContactAgentLName: null,
      eShEmp: null,
      eShTel: null,
      // CR-PM-2026 Req 2 — Radius config
      useSettingCheckinRange: true,
      customCheckInRange: null,
      customCheckInRangeMaxError: null,
      apiLoadedCheckInRange: undefined, // Issue 2: defensive — track fetched value to detect NULL master case (undefined = not loaded yet)
      eShLat: null,
      eShLng: null,
      eShInActiveStatus: null,
      eShIgnoreBarcodeValidation: null,
      eShIsSpecialPM: false,
      eShAgentCode: null,
      eShmarkers: [],
      FileUpload: [],

      eShStatus: "STATUS_SHOP_ACTIVE_NEW",
      InActiveStatus: "STATUS_SHOP_INACTIVE_CLOSE",
      eShActive: [],
      eShInActive: [],
      eshIfChk: null,
      eShEmpOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShShopPMTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Select2MasterShopTypePM",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShShopTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShShopGroupOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopGroup",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShAmphurIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              provinceId: self.eShProvinceId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShTumbolIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchTumbol",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              ampherId: self.eShAmphurId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    // CR-PM-2026 Req 2 — reset radius to default
    resetCheckinRange: function resetCheckinRange() {
      this.useSettingCheckinRange = true;
      this.customCheckInRange = null;
      this.customCheckInRangeMaxError = null;
    },

    // CR-PM-2026 Issue 19 — enforce max 10,000 m on radius input
    checkCustomCheckInRangeMax: function checkCustomCheckInRangeMax(e) {
      var raw = e.target.value;
      var val = Number(raw);
      if (raw !== "" && !isNaN(val) && val > 10000) {
        this.customCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
        // Clamp value back to 10000 (block typing beyond)
        this.customCheckInRange = 10000;
        this.$nextTick(function () {
          if (e.target) e.target.value = 10000;
        });
      } else {
        this.customCheckInRangeMaxError = null;
      }
    },
    handleImageError: function handleImageError(image) {
      image.isLoaded = false;
      // console.error("รูปภาพโหลดไม่สำเร็จ:", image.fileName);
    },
    handleImageLoad: function handleImageLoad(image) {
      image.isLoaded = true;
      // console.log("รูปภาพโหลดสำเร็จ:", image.fileName);
    },
    removeImage: function removeImage(pictureId) {
      var _this = this;

      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then(function (result) {
        if (result.value) {
          _this.FileUpload = _this.FileUpload.filter(function (img) {
            return img.pictureId !== pictureId;
          });
          Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
        }
      });
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();

      input.addEventListener("change", function (event) {
        var files = event.target.files;
        Array.from(files).forEach(function (file) {
          if (["image/jpeg", "image/jpg", "image/png"].includes(file.type) && file.size <= 10 * 1024 * 1024) {
            var reader = new FileReader();
            reader.onload = function (e) {
              var newImage = {
                pictureId: Date.now().toString(),
                fileName: file.name,
                urlImg: e.target.result,
                fileDataContext: file,
                isNew: true,
                isLoaded: true
              };
              _this2.FileUpload.push(newImage);
            };
            reader.readAsDataURL(file);
          } else {
            alert("กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)");
          }
        });
      });
    },
    onSubmit: function onSubmit(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var router, self, uploadedFiles, isUploadFile, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, formData, uploadResponse, picturesData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //onSubmit: function(e) {
                router = _this3.$router;
                self = _this3;

                if ($(_this3.$refs.form).validate().form()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                uploadedFiles = [];
                isUploadFile = false;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 10;
                _iterator = _this3.FileUpload[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 36;
                  break;
                }

                file = _step.value;

                if (!(file.isNew && file.fileDataContext)) {
                  _context.next = 32;
                  break;
                }

                _context.prev = 15;

                isUploadFile = true;
                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("IsMaster", true);
                formData.append("FolderName", "MasterShop");

                _context.next = 23;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 23:
                uploadResponse = _context.sent;


                //console.log('uploadResponse', uploadResponse)

                uploadedFiles.push({
                  contentType: "-",
                  downloadUrl: uploadResponse.data.fileUrl,
                  fileInfoId: uploadResponse.data.fileInfoId,
                  fileName: uploadResponse.data.fileInfoId,
                  gridFsId: uploadResponse.data.gridFsId,
                  sysName: "-"
                });
                _context.next = 30;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context["catch"](15);

                console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", _context.t0);

              case 30:
                _context.next = 33;
                break;

              case 32:
                if (!file.isNew) {
                  //alert('old file : ' + file.fileInfoId);

                  uploadedFiles.push(file);
                }

              case 33:
                _iteratorNormalCompletion = true;
                _context.next = 12;
                break;

              case 36:
                _context.next = 42;
                break;

              case 38:
                _context.prev = 38;
                _context.t1 = _context["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 42:
                _context.prev = 42;
                _context.prev = 43;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 45:
                _context.prev = 45;

                if (!_didIteratorError) {
                  _context.next = 48;
                  break;
                }

                throw _iteratorError;

              case 48:
                return _context.finish(45);

              case 49:
                return _context.finish(42);

              case 50:

                //alert("uploadedFiles.length : " + uploadedFiles.length);

                //const picturesData = isUploadFile && uploadedFiles.length > 0 ? uploadedFiles : [];

                picturesData = uploadedFiles.length > 0 ? uploadedFiles : []; // Case : Remove image.


                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/Shop", {
                  ShopId: self.$route.params.id,
                  CustomerCode: self.eShCustomerCode,
                  Latitude: self.eShLat,
                  Longitude: self.eShLng,
                  ContactAgentName: self.eShContactAgentName,
                  ContactAgentLastName: self.eShContactAgentLName,
                  EmployeeId: self.eShEmp,
                  InActiveStatus: !self.eShInActiveStatus,
                  ShopPictures: picturesData, //self.eShImgUpload,
                  SubAgent: self.eShSubAgent,
                  CustomerName: self.eShCustomerName,
                  Name2: self.eShName2,
                  ShopTypeId: self.eShShopType,
                  ShopGroupId: self.eShShopGroup,
                  ShopPMType: self.eShShopPMType,
                  Address: self.eShAddress,
                  ProvinceId: self.eShProvinceId,
                  AmphurId: self.eShAmphurId,
                  TumbolId: self.eShTumbolId,
                  ContactFullName: self.eShContactFullName,
                  Email: self.eShEmail,
                  Tel: self.eShTel,
                  AgentCode: self.eShAgentCode,
                  Reason: self.eShInActiveStatus == true ? self.eShStatus : self.InActiveStatus,
                  IgnoreBarcodeValidation: self.eShIgnoreBarcodeValidation,
                  IsSpecialPM: self.eShIsSpecialPM,
                  // CR-PM-2026 Req 2
                  UseSettingCheckinRange: self.useSettingCheckinRange,
                  CheckInRange: self.useSettingCheckinRange ? null : self.customCheckInRange
                }).then(function (response) {
                  if (response.data.status) {
                    KTApp.unblockPage();
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      router.go(-1), self.$parent.reloadDataTable(false);
                    });
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

              case 52:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[10, 38, 42, 50], [15, 27], [43,, 45, 49]]);
      }))();
    },

    getMap: function getMap() {
      var _this4 = this;

      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition(function (position) {
        _this4.eShLat = position.coords.latitude;
        _this4.eShLng = position.coords.longitude;
        _this4.eShmarkers = [{
          position: { lat: _this4.eShLat, lng: _this4.eShLng },
          animation: google.maps.Animation.DROP
        }];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates: function updateCoordinates(location) {
      this.eShLat = location.latLng.lat();
      this.eShLng = location.latLng.lng();
      map: this.map;
      this.eShmarkers = [{ position: { lat: this.eShLat, lng: this.eShLng } }];
    },
    openMap: function openMap() {
      var self = this;
      window.open("https://www.google.com/maps/search/?api=1&query=" + self.eShLat + "," + self.eShLng, "_blank");
    },
    getStatusShop: function getStatusShop() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Shop/StatusShop").then(function (response) {
        if (response.status == 200) {
          self.eShActive = response.data.filter(function (o) {
            return o.statusGroup == "STATUS_SHOP_ACTIVE";
          });
          self.eShInActive = response.data.filter(function (o) {
            return o.statusGroup == "STATUS_SHOP_INACTIVE";
          });
        }
      });
    },
    chkStatus: function chkStatus() {
      if (this.eshIfChk == "STATUS_SHOP_INACTIVE_CLOSE") {
        this.eShActive = this.eShActive.filter(function (o) {
          return o.statusCode == "STATUS_SHOP_ACTIVE_NEW" || o.statusCode == "STATUS_SHOP_ACTIVE_CLOSE";
        });
      } else if (this.eshIfChk == "STATUS_SHOP_INACTIVE_CHANGE") {
        this.eShActive = this.eShActive.filter(function (o) {
          return o.statusCode == "STATUS_SHOP_ACTIVE_NEW" || o.statusCode == "STATUS_SHOP_ACTIVE_COMEBACK";
        });
      } else if (this.eshIfChk == "STATUS_SHOP_INACTIVE_BEER") {
        this.eShActive = this.eShActive.filter(function (o) {
          return o.statusCode == "STATUS_SHOP_ACTIVE_NEW" || o.statusCode == "STATUS_SHOP_ACTIVE_BEER";
        });
      } else {
        this.eShActive = this.eShActive;
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this5;
              router = _this5.$router;
              _context2.next = 4;
              return _this5.$root.getUser();

            case 4:
              user = _context2.sent;


              self.getStatusShop();
              //self.initPlUploader();

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              // set validation rules
              $(_this5.$refs.form).validate({
                rules: {
                  eShCustomerName: "required",
                  eShShopType: "required",
                  eShShopPMType: "required",
                  eShShopGroup: "required",
                  // eShEmail: {
                  //   emailNullable: true
                  // },
                  eShAddress: "required",
                  eShProvinceId: "required",
                  eShAmphurId: "required",
                  eShTumbolId: "required",
                  eShTel: "required",
                  eShAgentCode: "required",
                  eShName2: "required",
                  // CR-PM-2026 Issue 14: required เฉพาะกรณี "กำหนดเอง" (useSettingCheckinRange=false)
                  customCheckInRange: {
                    required: function required() {
                      return !self.useSettingCheckinRange;
                    }
                  }
                },
                messages: {
                  eShCustomerName: "กรุณากรอกชื่อร้านค้า",
                  eShShopType: "กรุณาเลือกประเภทร้านค้า",
                  eShShopGroup: "กรุณาเลือกสถานะประเภทร้านค้า",
                  // eShEmail: {
                  //   emailNullable: "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง"
                  // },
                  eShAddress: "กรุณากรอกที่อยู่",
                  eShProvinceId: "กรุณาเลือกประเภทจังหวัด",
                  eShAmphurId: "กรุณาเลือกประเภทอำเภอ",
                  eShTumbolId: "กรุณาเลือกประเภทตำบล",
                  eShTel: "กรุณากรอกเบอร์โทร",
                  eShAgentCode: "กรุณาเลือกผู้ดูแลร้านค้า",
                  eShName2: "กรุณากรอกชื่อร้านค้า 2",
                  eShShopPMType: "ประเภทการล้างเครื่อง",
                  customCheckInRange: "กรุณาระบุระยะ (เมตร)"
                }
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Shop/" + _this5.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.canEdit = response.data.canEdit;
                  self.eShCustomerCode = response.data.custCode;
                  self.eShCustomerName = response.data.customerName;
                  self.eShName2 = response.data.name2;
                  self.eShAddress = response.data.address;
                  self.eShEmail = response.data.email;
                  self.eShTel = response.data.tel;
                  self.eShContactFullName = response.data.fullName;
                  self.eShContactAgentName = response.data.contactAgentName;
                  self.eShContactAgentLName = response.data.contactAgentLastName;
                  self.eShSubAgent = response.data.subAgent;
                  self.eShInActiveStatus = !response.data.inActiveStatus;
                  self.eShStatus = !response.data.inActiveStatus ? response.data.reason : "STATUS_SHOP_ACTIVE_NEW";
                  self.InActiveStatus = response.data.inActiveStatus ? response.data.reason : "STATUS_SHOP_INACTIVE_CLOSE";
                  self.eshIfChk = response.data.inActiveStatus ? response.data.reason : "STATUS_SHOP_INACTIVE_CLOSE";
                  self.eShIgnoreBarcodeValidation = response.data.ignoreBarcodeValidation;
                  self.eShIsSpecialPM = response.data.isSpecialPM != null ? response.data.isSpecialPM : false;

                  self.eShShopPMType = response.data.shopPMType;
                  if (response.data.shopPMType) {
                    self.$refs.eShShopPMTypeSelect2.setSelectedData({
                      id: response.data.shopPMType,
                      text: response.data.shopPMTypeName
                    });
                  }

                  if (self.$root.canShow('super_admin')) {
                    if (response.data.employeeId) {
                      self.$refs.eShEmpSelect2.setSelectedData({
                        id: response.data.employeeId,
                        text: "[" + response.data.employeeNo + "] " + response.data.employeeName + " " + response.data.employeeLastName
                      });
                    }
                  }

                  if (response.data.shopTypeId) {
                    self.$refs.eShShopTypeSelect2.setSelectedData({
                      id: response.data.shopTypeId,
                      text: response.data.shopTypeName
                    });
                  }

                  if (response.data.shopGroupId) {
                    self.$refs.eShShopGroupSelect2.setSelectedData({
                      id: response.data.shopGroupId.toString(),
                      text: response.data.shopGroupName
                    });
                  }

                  if (response.data.provinceId) {
                    self.$refs.eShProvinceIdSelect2.setSelectedData({
                      id: response.data.provinceId,
                      text: response.data.provinceName
                    });
                  }

                  if (response.data.ampherId) {
                    self.$refs.eShAmphurIdSelect2.setSelectedData({
                      id: response.data.ampherId,
                      text: response.data.ampherName
                    });
                  }

                  if (response.data.tambolId) {
                    self.$refs.eShTumbolIdSelect2.setSelectedData({
                      id: response.data.tambolId,
                      text: response.data.tambolName
                    });
                  }

                  if (response.data.agentCode) {
                    self.$refs.eShAgentCodeSelect2.setSelectedData({
                      id: response.data.agentCode,
                      text: response.data.agentName
                    });
                  }
                  // CR-PM-2026 Req 2
                  self.useSettingCheckinRange = response.data.useSettingCheckinRange != null ? response.data.useSettingCheckinRange : true;
                  self.customCheckInRange = !self.useSettingCheckinRange ? response.data.checkInRange : null;
                  // Issue 2: capture fetched value to detect NULL master case
                  self.apiLoadedCheckInRange = response.data.checkInRange != null ? response.data.checkInRange : null;

                  //Set lat lng
                  response.data.latitude === null ? self.eShLat = null : self.eShLat = parseFloat(response.data.latitude);
                  response.data.longitude === null ? self.eShLng = null : self.eShLng = parseFloat(response.data.longitude);

                  self.eShmarkers = [{ position: { lat: self.eShLat, lng: self.eShLng } }];

                  //alert(response.data.pictures[0].pictureId);

                  self.FileUpload = response.data.pictures.map(function (element) {
                    return {
                      pictureId: element.pictureId,
                      fileName: element.fileName,
                      fileInfoId: element.fileInfoId,
                      downloadUrl: element.downloadUrl,
                      urlImg: element.urlImg,
                      gridFsId: element.gridFsId,
                      sysName: element.sysName,
                      isNew: false,
                      isLoaded: true
                    };
                  });
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลคลังสินค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลคลังสินค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"> \n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n    <div class=\"dropdown-menu dropdown-primary\">\n    <p class=\"text-center\">\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25</p>\n    <a class=\"dropdown-item\" href=\"#\" @click.prevent=\"toggleStatus(item)\" v-for=\"item in self.shmInActive\"> - {{item.statusName}}</a>\n    </div>\n  </div>",
  methods: {
    toggleStatus: function toggleStatus(e) {
      var _this = this;

      var self = this;
      var table = $("#shopTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน" + "</strong> *หมายเหตุ " + e.statusName + "",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/Shop/" + _this.data.customerCode + "/" + e.statusCode + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\"  v-if=\"data.showEditStatusButton\" @click = \"returnActive\" class=\"btn btn-sm btn-danger\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n    <div class=\"dropdown-menu dropdown-primary\">\n    <p class=\"text-center\">\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25</p>\n    <a class=\"dropdown-item\" href=\"#\" @click.prevent=\"toggleStatus(item)\" v-for=\"item in self.shmFilterActive\"> - {{item.statusName}}</a>\n    </div>\n  </div>",
  methods: {
    returnActive: function returnActive() {
      if (this.data.reason == "STATUS_SHOP_INACTIVE_CLOSE") {
        this.self.shmFilterActive = this.self.shmActive.filter(function (o) {
          return (
            //o.statusCode == "STATUS_SHOP_ACTIVE_NEW" ||
            o.statusCode == "STATUS_SHOP_ACTIVE_CLOSE"
          );
        });
      } else if (this.data.reason == "STATUS_SHOP_INACTIVE_CHANGE") {
        this.self.shmFilterActive = this.self.shmActive.filter(function (o) {
          return (
            //o.statusCode == "STATUS_SHOP_ACTIVE_NEW" ||
            o.statusCode == "STATUS_SHOP_ACTIVE_COMEBACK"
          );
        });
      } else if (this.data.reason == "STATUS_SHOP_INACTIVE_BEER") {
        this.self.shmFilterActive = this.self.shmActive.filter(function (o) {
          return (
            //o.statusCode == "STATUS_SHOP_ACTIVE_NEW" ||
            o.statusCode == "STATUS_SHOP_ACTIVE_BEER"
          );
        });
      } else if (this.data.reason == "STATUS_SHOP_INACTIVE_DUPLICATE") {
        this.self.shmFilterActive = this.self.shmActive.filter(function (o) {
          return (
            //o.statusCode == "STATUS_SHOP_ACTIVE_NEW" ||
            o.statusCode == "STATUS_SHOP_ACTIVE_CLOSE" || o.statusCode == "STATUS_SHOP_ACTIVE_COMEBACK" || o.statusCode == "STATUS_SHOP_ACTIVE_BEER"
          );
        });
      } else {
        this.self.shmFilterActive = this.self.shmActive;
      }

      return this.self.shmFilterActive;
    },

    toggleStatus: function toggleStatus(e) {
      var _this2 = this;

      var self = this;
      var rolsCek = this.$root.canShow(["super_admin"]);
      if (this.data.reason == "STATUS_SHOP_INACTIVE_STOP" && !rolsCek) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถเปิดใช้งานได้ เนื่องจาก คุณไม่ได้รับอนุญาตให้เปลี่ยนสถานะร้านที่ปิดกิจการถาวร", "error");
      } else if (this.data.reason == "STATUS_SHOP_INACTIVE_DUPLICATE" && !rolsCek) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถเปิดใช้งานได้ เนื่องจาก ร้านค้าซ้ำในระบบ", "error");
      } else {
        var table = $("#shopTable");
        Swal.fire({
          title: "คำสั่งแก้ไขสถานะ",
          type: "warning",
          html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน" + "</strong> *หมายเหตุ " + e.statusName + "",
          inputPlaceholder: "ต้องการแก้ไขสถานะ",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value === true || result.value === false) {
            KTApp.blockPage({
              opacity: 0.05,
              message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
            });

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/Shop/" + _this2.data.customerCode + "/" + e.statusCode + "/Toggle").then(function (response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
              }
            }).catch(function (error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }).then(function () {
              // always executed
              KTApp.unblockPage();
            });
          }
        });
      }
    }
  },
  computed: {}
});
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n     <a href=\"#\" @click.prevent=\"deleteShop\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Master/ManageShop/Edit/" + this.data.customerCode
      });
    },
    deleteShop: function deleteShop() {
      Swal.fire({
        title: "ลบข้อมูล",
        type: "warning",
        text: "ต้องการลบข้อมูลหรือไม่ ?",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          //Swal.fire({ type: "success", text: "You have a bike!" });
        } else if (result.value === 0) {
          //Swal.fire({ type: "error", text: "You don't have a bike :(" });
        } else {
            //console.log(`modal was dismissed by ${result.dismiss}`);
          }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      shmKeyword: null,
      shmInActiveStatus: null,
      shmShopTypeId: [],
      shmShopGroupId: [],
      shmAgentCode: [],
      shmProvinceId: null,
      shmAmpherId: null,
      shmSubAgent: null,
      shmStatus: null,
      InActiveStatus: null,
      shmActive: [],
      shmInActive: [],
      shmFilterActive: [],
      //config
      shmInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      },
      shmSubAgentOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "true", text: "ใช่", data: null }, { id: "false", text: "ไม่ใช่", data: null }]
      },
      shmShopTypeIdOptions: [],
      shmShopGroupIdOptions: [],
      shmProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            1;
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      shmAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              provinceId: self.shmProvinceId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      shmAgentCodeOptions: []
      // shmAgentCodeOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchAgentName",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: null,
      //         province_id: null,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.shmKeyword = "";
      this.shmAgentCode = [];
      this.shmShopTypeId = [];
      this.shmShopGroupId = [];
      //default Active Data
      this.shmInActiveStatus = false;
      $("#shmInActiveStatus").val(this.shmInActiveStatus + "").trigger("change");

      $("#shmShopTypeId").val("").trigger("change");

      $("#shmShopGroupId").val("").trigger("change");

      $("#shmProvinceId").val("").trigger("change");

      $("#shmAmpherId").val("").trigger("change");

      $("#shmSubAgent").val("").trigger("change");

      $("#shmAgentCode").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#shopTable").DataTable();
      table.search(this.id | this.name);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    exportShop: function exportShop(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportShop",
        responseType: "arraybuffer",
        data: {
          // CustomerCode: self.shmCustomerCode,
          // CustomerName: self.shmCustomerName,
          // Name2: self.shmName2,
          // Tel: self.shmTel,
          // Firstname: self.shmFirstname,
          // TambolId: self.shmTambolId,
          // AmpherId: self.shmAmpherId,
          // ProvinceId: self.shmProvinceId,
          // Address: self.shmAddress,
          // Email: self.shmEmail,
          // AgentName: self.shmAgentName,
          // SubAgent: self.shmSubAgent,
          // EmployeeName: self.shmEmployeeName,
          // Latitude: self.shmLatitude,
          // Longitude: self.shmLongitude,
          // Reason: self.shmReason
          SearchKeyword: self.shmKeyword,
          ShopTypeId: self.shmShopTypeId,
          ShopGroupId: self.shmShopGroupId,
          ProvinceId: self.shmProvinceId,
          AmpherId: self.shmAmpherId,
          InActiveStatus: self.shmInActiveStatus,
          SubAgent: self.shmSubAgent,
          AgentCodes: self.shmAgentCode
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          var fname = filename.split("RPT_")[1];
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // link.download = "ข้อมูลร้านค้า" + filename;
          link.download = "จัดการข้อมูลร้านค้า_" + fname; //+ filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#shopTable").DataTable().ajax.reload(null, resetPaging);
    },
    onAmpherIdChange: function onAmpherIdChange() {
      $("#shmAmpherId").val("").trigger("change");
    },
    getStatusShop: function getStatusShop() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Shop/StatusShop").then(function (response) {
        if (response.status == 200) {
          self.shmActive = response.data.filter(function (o) {
            return o.statusGroup == "STATUS_SHOP_ACTIVE";
          });
          self.shmInActive = response.data.filter(function (o) {
            return o.statusGroup == "STATUS_SHOP_INACTIVE";
          });
        }
      });
    },

    LoadAgentCodeOptions: function LoadAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Agents/Select2SearchAgentName", {
        department: null,
        province_id: null,
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shmAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadShopTypeIdOptions: function LoadShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shmShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadShopGroupIdOptions: function LoadShopGroupIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shmShopGroupIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;

              self.getStatusShop();
              //default Active Data
              self.shmInActiveStatus = false;
              $("#shmInActiveStatus").val(self.shmInActiveStatus + "").trigger("change");

              self.LoadAgentCodeOptions();
              self.LoadShopTypeIdOptions();
              self.LoadShopGroupIdOptions();

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#shopTable");

              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Shop/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    //console.log(d);
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.shmKeyword,
                      ShopTypeId: self.shmShopTypeId,
                      ShopGroupId: self.shmShopGroupId,
                      ProvinceId: self.shmProvinceId,
                      AmpherId: self.shmAmpherId,
                      InActiveStatus: self.shmInActiveStatus,
                      SubAgent: self.shmSubAgent,
                      AgentCodes: self.shmAgentCode
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[1, "asc"]],
                columns: [{
                  data: null,
                  className: "details-control",
                  defaultContent: "",
                  orderable: false
                }, { data: "custCode", className: "text-center" }, { data: "customerName", className: "text-center" }, { data: "name2", className: "text-center" }, { data: "shopTypeName", className: "text-center" }, { data: "shopGroupName", className: "text-center" }, { data: "agentName", className: "text-center",
                  render: function render(data, type, full, meta) {
                    var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>" + data + "</pre>";
                    return html;
                  }
                }, {
                  data: "subAgent",
                  className: "text-center",
                  width: "7%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data == true) return '<i class="text-success fa fa-check-circle"></i>';else return '<i class="text-danger fa fa-times-circle"></i>';
                  }
                }, { data: "address", className: "text-center" }, { data: "email", className: "text-center" }, { data: "tel", className: "text-center" }, { data: "fullName", className: "text-center" }, { data: "contactAgentFullName", className: "text-center" }, { data: "employeeFullName", className: "text-center" }, { data: "ampherName", className: "text-center", orderable: false }, { data: "provinceName", className: "text-center", orderable: false }, { data: "latitude", className: "text-center" }, { data: "longitude", className: "text-center" }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "customerCode",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_SHOP"]);

                    if (data.inActiveStatus == 0) new StatusActionsTrue({
                      data: { data: data, self: self },
                      parent: self
                    }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({
                      data: { data: data, self: self },
                      parent: self
                    }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  //console.log(data);
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_SHOP"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    var self = this;

    return {
      AgentType: "AGENT",
      dtsCustomerChangeRequestId: null,
      dtsCustCode: null,
      dtsCustomerName: null,
      dtsCustomerName2: null,
      dtsCustomerType: null,
      dtsUserName: null,
      dtsAmpher: null,
      dtsProvince: null,
      dtsOldLatitude: null,
      dtsNewLatitude: null,
      dtsOldLongitude: null,
      dtsNewLongitude: null,
      dtsStatus: null,
      dtsIsApprove: true,
      dtsNLat: null,
      dtsNLng: null,
      dtsOLat: null,
      dtsOLng: null,
      dtsMarkers: [],

      dtsSubAgentCode: null,
      dtsSubAgentCustCode: null,
      dtsSubAgentCustomerName: null,
      dtsSubAgentCustomerName2: null
    };
  },

  methods: {
    onApprove: function onApprove(e) {
      var _this = this;

      e.preventDefault();
      var self = this;
      var router = this.$router;
      Swal.fire({
        title: "คำสั่งอนุมัติแก้ไขข้อมูลร้านค้า",
        type: "warning",
        html: "กรุณายืนยันอนุมัติแก้ไขข้อมูลร้านค้า <strong>",
        inputValue: 0,
        inputPlaceholder: "อนุมัติแก้ไขข้อมูลร้านค้า",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังอนุมัติข้อมูล กรุณารอสักครู่..."
          });

          //UpdateBorrowProduct
          if (self.ubpIsEdit) {
            self.formSubmit();
          }

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ShopChangeRequest/" + _this.$route.params.id + "/Approve").then(function (response) {
            if (response.data.status) {
              Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                router.go(-1), self.$parent.reloadDataTable(false);
                //router.push({ path: `/Borrow` });
              });
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    onReject: function onReject(e) {
      var _this2 = this;

      e.preventDefault();
      var self = this;
      var router = this.$router;
      Swal.fire({
        title: "คำสั่งไม่อนุมัติแก้ไขข้อมูลร้านค้า",
        type: "warning",
        html: "กรุณายืนยันไม่อนุมัติแก้ไขข้อมูลร้านค้า <strong>",
        // input: "text",
        // inputAttributes: {
        //   autocapitalize: "off",
        // },
        // // inputValue: 0,
        // inputPlaceholder: "กรุณาระบุหมายเหตุผลไม่อนุมัติแก้ไขข้อมูลร้านค้า",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
        // inputValidator: (value) => {
        //   return new Promise((resolve) => {
        //     if (value === "") {
        //       resolve("กรุณาระบุหมายเหตุผลไม่อนุมัติแก้ไขข้อมูลร้านค้า");
        //     } else {
        //       resolve();
        //     }
        //   });
        // },
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_0_axios___default()({
            method: "post",
            url: "/Api/ShopChangeRequest/Reject",
            data: {
              Id: _this2.$route.params.id,
              Remark: result.value
            }
          })
          // .post("/Api/ProductLoan/" + this.$route.params.id + "/Reject",)
          .then(function (response) {
            if (response.data.status) {
              Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                router.go(-1), self.$parent.reloadDataTable(false);
                //router.push({ path: `/Borrow` });
              });
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        } else {}
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;
              router = _this3.$router;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ShopChangeRequest/" + _this3.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  if (response.data != null) {
                    self.AgentType = response.data.subAgentShopCode != null && response.data.subAgentShopCode != "" ? "SUB_AGENT" : "AGENT", self.dtsCustomerChangeRequestId = response.data.dtsCustomerChangeRequestId, self.dtsCustCode = response.data.custCode, self.dtsCustomerName = response.data.customerName, self.dtsCustomerName2 = response.data.customerName2, self.dtsCustomerType = response.data.shopTypeName, self.dtsUserName = response.data.employeeFullName, self.dtsAmpher = response.data.ampherName, self.dtsProvince = response.data.provinceName, self.dtsOldLatitude = response.data.oldLatitude, self.dtsNewLatitude = response.data.newLatitude, self.dtsOldLongitude = response.data.oldLongitude, self.dtsNewLongitude = response.data.newLongitude, self.dtsStatus = response.data.statusValue, self.dtsIsApprove = response.data.isEnd;
                    self.dtsNLat = parseFloat(response.data.newLatitude);
                    self.dtsNLng = parseFloat(response.data.newLongitude);
                    self.dtsOLat = parseFloat(response.data.oldLatitude);
                    self.dtsOLng = parseFloat(response.data.oldLongitude);
                    self.dtsMarkers = [{
                      positionN: { lat: self.dtsNLat, lng: self.dtsNLng },
                      positionO: { lat: self.dtsOLat, lng: self.dtsOLng }
                    }];

                    self.dtsSubAgentCode = response.data.subAgentCode;
                    self.dtsSubAgentCustCode = response.data.subAgentShopCode;
                    self.dtsSubAgentCustomerName = response.data.subAgentShopName;
                    self.dtsSubAgentCustomerName2 = response.data.subAgentShopName2;
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed

                KTApp.unblockPage();
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"detail\" v-if=\"data.showDetailButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-file-text\"></i>\n    </a>\n  </div>",
  methods: {
    detail: function detail() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Master/ManageShopChangeRequest/Detail/" + this.data.customerChangeRequestId
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      shcmKeyword: null,
      shcmApproveStatus: null,
      shcmEmpId: null,
      shcmShopTypeId: [],
      shcmProvinceId: null,
      shcmAmpherId: null,
      shcmShopTypeIdOptions: [],
      //config
      // shcmShopTypeIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ShopType/Select2SearchShopType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      shcmProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      shcmAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              provinceId: self.shcmProvinceId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      shcmEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      shcmApproveStatusOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "APPROVE_CHANGE_REQUEST_STATUS",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.shcmKeyword = "";
      this.shcmShopTypeId = [];
      $("#shcmApproveStatus").val("").trigger("change");

      $("#shcmShopTypeId").val("").trigger("change");

      $("#shcmProvinceId").val("").trigger("change");

      $("#shcmAmpherId").val("").trigger("change");

      $("#shcmEmpId").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#shopChangeRequestTable").DataTable();
      table.search(this.id | this.name);
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#shopChangeRequestTable").DataTable().ajax.reload(null, resetPaging);
    },
    onAmpherIdChange: function onAmpherIdChange() {
      $("#shcmAmpherId").val("").trigger("change");
    },
    LoadShopTypeIdOptions: function LoadShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shcmShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadShopTypeIdOptions();
              table = $("#shopChangeRequestTable");

              $.fn.dataTable.ext.errMode = 'none';
              // begin first table
              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/ShopChangeRequest/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.shcmKeyword,
                      ShopTypeId: self.shcmShopTypeId,
                      ProvinceId: self.shcmProvinceId,
                      AmpherId: self.shcmAmpherId,
                      Status: self.shcmApproveStatus
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[5, "desc"]],
                columns: [{ data: "customerCode", className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.custCode;
                  }
                }, { data: "customerName", className: "text-center" }, { data: "customerName2", className: "text-center" }, { data: "shopTypeName", className: "text-center" }, { data: "employeeFullName", className: "text-center" }, {
                  data: "createDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.createDateStringFormat2;
                  }
                },
                // { data: "ampherName", className: "text-center" },
                // { data: "provinceName", className: "text-center" },
                { data: "statusValue", className: "text-center" }, {
                  data: "customerChangeRequestId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showDetailButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_SHOPPROFILE", "ADMIN_MKT", "ADMIN_PM", "ADMIN_QI", "MANAGER_MKT", "USER_QI"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  name: "GoogleMap",
  data: function data() {
    var self = this;

    return {
      cssaShopSubAgentCode: null,
      cshCustomerCode: null,
      cssaShopSubAgentName: null,
      cssaShopSubAgentName2: null,
      cssaShopType: null,
      cssaShopPMType: null,
      cshShopGroup: null,
      cssaAddress: null,
      cssaProvinceId: null,
      cssaAmphurId: null,
      cssaTumbolId: null,
      cshSubAgent: false,
      cssaContactFullName: null,
      cssaEmail: null,
      cssaTel: null,
      cssaShopCode: null,
      cssaContactShopName: null,
      cssaContactShopLName: null,
      cssaEmpId: null,
      cssaInActiveStatus: true,
      cShIsSpecialPM: false,
      cshLat: null,
      cshLng: null,
      // CR-PM-2026 Req 2 — per-subagent-shop radius config (default = use Setting)
      useSettingCheckinRange: true,
      customCheckInRange: null,
      customCheckInRangeMaxError: null,
      markers: [],
      FileUpload: [],
      cssaShopTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cssaShopPMTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Select2MasterShopTypePM",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cshShopGroupOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopGroup",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cssaEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cssaProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cssaAmphurIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              provinceId: self.cssaProvinceId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cssaTumbolIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchTumbol",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              ampherId: self.cssaAmphurId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      cssaShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/ShopOption",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    // CR-PM-2026 Req 2 — reset to default (use Setting)
    resetCheckinRange: function resetCheckinRange() {
      this.useSettingCheckinRange = true;
      this.customCheckInRange = null;
      this.customCheckInRangeMaxError = null;
    },
    checkCustomCheckInRangeMax: function checkCustomCheckInRangeMax(e) {
      var raw = e.target.value;
      var val = Number(raw);
      if (raw !== "" && !isNaN(val) && val > 10000) {
        this.customCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
        // Clamp value back to 10000 (block typing beyond)
        this.customCheckInRange = 10000;
        this.$nextTick(function () {
          if (e.target) e.target.value = 10000;
        });
      } else {
        this.customCheckInRangeMaxError = null;
      }
    },
    formSubmit: function formSubmit(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var router, self, uploadedFiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, formData, uploadResponse, picturesData, response, errorMsg;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if ($(_this.$refs.form).validate().form()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", false);

              case 2:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                router = _this.$router;
                self = _this;
                _context.prev = 5;

                // Upload new files to GCS
                uploadedFiles = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 10;
                _iterator = _this.FileUpload[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 26;
                  break;
                }

                file = _step.value;

                if (!(file.isNew && file.fileDataContext)) {
                  _context.next = 23;
                  break;
                }

                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("IsMaster", true);
                formData.append("FolderName", "MasterShopSubAgent");

                _context.next = 21;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 21:
                uploadResponse = _context.sent;


                if (uploadResponse.data && uploadResponse.data.fileInfoId) {
                  uploadedFiles.push({
                    fileInfoId: uploadResponse.data.fileInfoId,
                    fileName: uploadResponse.data.fileInfoId,
                    downloadUrl: uploadResponse.data.fileUrl
                  });
                }

              case 23:
                _iteratorNormalCompletion = true;
                _context.next = 12;
                break;

              case 26:
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 32:
                _context.prev = 32;
                _context.prev = 33;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 35:
                _context.prev = 35;

                if (!_didIteratorError) {
                  _context.next = 38;
                  break;
                }

                throw _iteratorError;

              case 38:
                return _context.finish(35);

              case 39:
                return _context.finish(32);

              case 40:

                // Prepare pictures data for API
                picturesData = uploadedFiles.map(function (pic) {
                  return {
                    fileInfoId: pic.fileInfoId,
                    fileName: pic.fileName,
                    downloadUrl: pic.downloadUrl
                  };
                });
                _context.next = 43;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/SubAgent", {
                  SubAgentCode: _this.cssaShopSubAgentCode,
                  ShopSubAgentName: _this.cssaShopSubAgentName,
                  ShopSubAgentName2: _this.cssaShopSubAgentName2,
                  ShopTypeId: _this.cssaShopType,
                  ShopPMType: _this.cssaShopPMType,
                  ShopGroupId: _this.cshShopGroup,
                  Address: _this.cssaAddress,
                  ProvinceId: _this.cssaProvinceId,
                  AmphurId: _this.cssaAmphurId,
                  TumbolId: _this.cssaTumbolId,
                  ContactFullName: _this.cssaContactFullName,
                  Email: _this.cssaEmail,
                  Tel: _this.cssaTel,
                  ShopCode: _this.cssaShopCode,
                  Latitude: _this.cshLat,
                  Longitude: _this.cshLng,
                  ContactShopName: _this.cssaContactShopName,
                  ContactShopLastName: _this.cssaContactShopLName,
                  EmployeeId: _this.cssaEmpId,
                  SubAgentPictures: picturesData,
                  InActiveStatus: !_this.cssaInActiveStatus,
                  IsSpecialPM: _this.cShIsSpecialPM,
                  // CR-PM-2026 Req 2 — radius
                  UseSettingCheckinRange: _this.useSettingCheckinRange,
                  CheckInRange: _this.useSettingCheckinRange ? null : _this.customCheckInRange
                });

              case 43:
                response = _context.sent;


                if (response.data.status) {
                  KTApp.unblockPage();
                  Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                    router.go(-1);
                    self.$parent.reloadDataTable(false);
                  });
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                }
                _context.next = 51;
                break;

              case 47:
                _context.prev = 47;
                _context.t1 = _context["catch"](5);
                errorMsg = _context.t1.response && _context.t1.response.data && _context.t1.response.data.message ? _context.t1.response.data.message : _context.t1.message;

                Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");

              case 51:
                _context.prev = 51;

                KTApp.unblockPage();
                return _context.finish(51);

              case 54:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[5, 47, 51, 54], [10, 28, 32, 40], [33,, 35, 39]]);
      }))();
    },

    getMap: function getMap() {
      var _this2 = this;

      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition(function (position) {
        _this2.cshLat = position.coords.latitude;
        _this2.cshLng = position.coords.longitude;
        _this2.markers = [{
          position: { lat: _this2.cshLat, lng: _this2.cshLng },
          animation: google.maps.Animation.DROP
        }];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates: function updateCoordinates(location) {
      this.cshLat = location.latLng.lat();
      this.cshLng = location.latLng.lng();
      map: this.map;
      this.markers = [{ position: { lat: this.cshLat, lng: this.cshLng } }];
    },
    uploadFile: function uploadFile() {
      var _this3 = this;

      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();
      input.addEventListener("change", function (event) {
        var file = event.target.files[0];
        if (file) {
          var reader = new FileReader();
          reader.onload = function (e) {
            var newImage = {
              pictureId: "new_" + Date.now(),
              urlImg: e.target.result,
              fileName: file.name,
              isNew: true,
              fileDataContext: file,
              isLoaded: true
            };
            _this3.FileUpload.push(newImage);
          };
          reader.readAsDataURL(file);
        }
      });
    },
    removeImage: function removeImage(pictureId) {
      var _this4 = this;

      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        icon: "warning",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then(function (result) {
        if (result.value) {
          _this4.FileUpload = _this4.FileUpload.filter(function (img) {
            return img.pictureId !== pictureId;
          });
          Swal.fire("เรียบร้อย!", "ลบรูปภาพเรียบร้อย", "success");
        }
      });
    },
    handleImageError: function handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad: function handleImageLoad(image) {
      image.isLoaded = true;
    },
    onShopCodeChange: function onShopCodeChange(id, text, data, ref) {
      var router = this.$router;
      var self = this;

      console.log(text);
      if (text != (null || "")) {
        self.cssaContactShopName = data[0].data.firstName;
        self.cssaContactShopLName = data[0].data.lastName;
      } else {
        self.cssaContactShopName = null;
        self.cssaContactShopLName = null;
      }
    },
    openMap: function openMap() {
      var self = this;
      window.open("https://www.google.com/maps/search/?api=1&query=" + self.cshLat + "," + self.cshLng, "_blank");
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this5;
              router = _this5.$router;

              // set validation rules

              $(_this5.$refs.form).validate({
                rules: {
                  cssaShopSubAgentName: "required",
                  cssaShopSubAgentCode: "required",
                  cssaShopSubAgentName2: "required",
                  cssaShopCode: "required",
                  cshShopGroup: "required",
                  cssaShopPMType: "required",
                  // CR-PM-2026 Issue 14: required เฉพาะกรณี "กำหนดเอง" (useSettingCheckinRange=false)
                  customCheckInRange: {
                    required: function required() {
                      return !self.useSettingCheckinRange;
                    }
                  }
                },
                messages: {
                  cssaShopSubAgentCode: "กรุณากรอกรหัสร้านร้านค้า (ตัวแทนจำหน่ายย่อย)",
                  cssaShopSubAgentName: "กรุณากรอกชื่อร้านค้า (ตัวแทนจำหน่ายย่อย)",
                  cssaShopSubAgentName2: "กรุณากรอกชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย)",
                  cssaShopCode: "กรุณาเลือกผู้ดูแลร้านค้าตัวแทนจำหน่ายย่อย",
                  cshShopGroup: "กรุณาเลือกสถานะประเภทร้านค้า",
                  cssaShopPMType: "ประเภทการล้างเครื่อง",
                  customCheckInRange: "กรุณาระบุระยะ (เมตร)"
                }
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      isChange: false,
      essaShopSubAgentId: null,
      essaShopSubAgentCode: null,
      essaShopSubAgentName: null,
      essaShopSubAgentName2: null,
      essaShopType: null,
      essaShopPMType: null,
      eShShopGroup: null,
      essaAddress: null,
      essaProvinceId: null,
      essaAmphurId: null,
      essaTumbolId: null,
      essaContactFullName: null,
      essaEmail: null,
      essaTel: null,
      essaShopCode: null,
      essaContactShopName: null,
      essaContactShopLName: null,
      essaEmpId: null,
      essaInActiveStatus: null,
      eShIsSpecialPM: false,
      essaLat: null,
      essaLng: null,
      essaMarkers: [],
      // CR-PM-2026 Req 2 — Radius config
      useSettingCheckinRange: true,
      customCheckInRange: null,
      customCheckInRangeMaxError: null,
      apiLoadedCheckInRange: undefined, // Issue 2: defensive — track fetched value (undefined = not loaded yet)
      FileUpload: [],
      //config
      essaShopPMTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Select2MasterShopTypePM",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      essaShopTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShShopGroupOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopGroup",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      essaProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      essaAmphurIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              provinceId: self.essaProvinceId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      essaTumbolIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchTumbol",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              ampherId: self.essaAmphurId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      essaShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/ShopOption",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      essaEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    // CR-PM-2026 Req 2 — reset radius to default
    resetCheckinRange: function resetCheckinRange() {
      this.useSettingCheckinRange = true;
      this.customCheckInRange = null;
    },
    checkCustomCheckInRangeMax: function checkCustomCheckInRangeMax(e) {
      var raw = e.target.value;
      var val = Number(raw);
      if (raw !== "" && !isNaN(val) && val > 10000) {
        this.customCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
        // Clamp value back to 10000 (block typing beyond)
        this.customCheckInRange = 10000;
        this.$nextTick(function () {
          if (e.target) e.target.value = 10000;
        });
      } else {
        this.customCheckInRangeMaxError = null;
      }
    },
    uploadFile: function uploadFile() {
      var _this = this;

      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();
      input.addEventListener("change", function (event) {
        var file = event.target.files[0];
        if (file) {
          var reader = new FileReader();
          reader.onload = function (e) {
            var newImage = {
              pictureId: "new_" + Date.now(),
              urlImg: e.target.result,
              fileName: file.name,
              isNew: true,
              fileDataContext: file,
              isLoaded: true
            };
            _this.FileUpload.push(newImage);
          };
          reader.readAsDataURL(file);
        }
      });
    },
    removeImage: function removeImage(pictureId) {
      var _this2 = this;

      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        icon: "warning",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then(function (result) {
        if (result.value) {
          _this2.FileUpload = _this2.FileUpload.filter(function (img) {
            return img.pictureId !== pictureId;
          });
          Swal.fire("เรียบร้อย!", "ลบรูปภาพเรียบร้อย", "success");
        }
      });
    },
    handleImageError: function handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad: function handleImageLoad(image) {
      image.isLoaded = true;
    },
    onSubmit: function onSubmit(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var router, self, uploadedFiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, formData, uploadResponse, picturesData, response, errorMsg;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                router = _this3.$router;
                self = _this3;

                if ($(_this3.$refs.form).validate().form()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                _context.prev = 5;

                // Upload new files to GCS
                uploadedFiles = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 10;
                _iterator = _this3.FileUpload[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 29;
                  break;
                }

                file = _step.value;

                if (!(file.isNew && file.fileDataContext)) {
                  _context.next = 25;
                  break;
                }

                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("IsMaster", true);
                formData.append("FolderName", "MasterShopSubAgent");

                _context.next = 21;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 21:
                uploadResponse = _context.sent;


                if (uploadResponse.data && uploadResponse.data.fileInfoId) {
                  uploadedFiles.push({
                    fileInfoId: uploadResponse.data.fileInfoId,
                    fileName: uploadResponse.data.fileInfoId,
                    downloadUrl: uploadResponse.data.fileUrl
                  });
                }
                _context.next = 26;
                break;

              case 25:
                if (!file.isNew) {
                  // Existing image - include in the list
                  uploadedFiles.push({
                    fileInfoId: file.fileInfoId,
                    fileName: file.fileName,
                    downloadUrl: file.downloadUrl
                  });
                }

              case 26:
                _iteratorNormalCompletion = true;
                _context.next = 12;
                break;

              case 29:
                _context.next = 35;
                break;

              case 31:
                _context.prev = 31;
                _context.t0 = _context["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 35:
                _context.prev = 35;
                _context.prev = 36;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 38:
                _context.prev = 38;

                if (!_didIteratorError) {
                  _context.next = 41;
                  break;
                }

                throw _iteratorError;

              case 41:
                return _context.finish(38);

              case 42:
                return _context.finish(35);

              case 43:

                // Prepare pictures data for API
                picturesData = uploadedFiles.map(function (pic) {
                  return {
                    fileInfoId: pic.fileInfoId,
                    fileName: pic.fileName,
                    downloadUrl: pic.downloadUrl
                  };
                });
                _context.next = 46;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/SubAgent", {
                  ShopSubAgentId: _this3.essaShopSubAgentId,
                  SubAgentCode: _this3.essaShopSubAgentCode,
                  ShopSubAgentName: _this3.essaShopSubAgentName,
                  ShopSubAgentName2: _this3.essaShopSubAgentName2,
                  ShopTypeId: _this3.essaShopType,
                  ShopGroupId: _this3.eShShopGroup,
                  Address: _this3.essaAddress,
                  ProvinceId: _this3.essaProvinceId,
                  AmphurId: _this3.essaAmphurId,
                  TumbolId: _this3.essaTumbolId,
                  ContactFullName: _this3.essaContactFullName,
                  Email: _this3.essaEmail,
                  Tel: _this3.essaTel,
                  ShopCode: _this3.essaShopCode,
                  Latitude: _this3.essaLat,
                  Longitude: _this3.essaLng,
                  ContactShopName: _this3.essaContactShopName,
                  ContactShopLastName: _this3.essaContactShopLName,
                  EmployeeId: _this3.essaEmpId,
                  SubAgentPictures: picturesData,
                  InActiveStatus: !_this3.essaInActiveStatus,
                  ShopPMType: _this3.essaShopPMType,
                  IsSpecialPM: _this3.eShIsSpecialPM,
                  // CR-PM-2026 Req 2
                  UseSettingCheckinRange: _this3.useSettingCheckinRange,
                  CheckInRange: _this3.useSettingCheckinRange ? null : _this3.customCheckInRange
                });

              case 46:
                response = _context.sent;


                if (response.data.status) {
                  KTApp.unblockPage();
                  Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                    router.go(-1);
                    self.$parent.reloadDataTable(false);
                  });
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                }
                _context.next = 54;
                break;

              case 50:
                _context.prev = 50;
                _context.t1 = _context["catch"](5);
                errorMsg = _context.t1.response && _context.t1.response.data && _context.t1.response.data.message ? _context.t1.response.data.message : _context.t1.message;

                Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");

              case 54:
                _context.prev = 54;

                KTApp.unblockPage();
                return _context.finish(54);

              case 57:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[5, 50, 54, 57], [10, 31, 35, 43], [36,, 38, 42]]);
      }))();
    },

    getMap: function getMap() {
      var _this4 = this;

      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition(function (position) {
        _this4.essaLat = position.coords.latitude;
        _this4.essaLng = position.coords.longitude;
        _this4.essaMarkers = [{
          position: { lat: _this4.essaLat, lng: _this4.essaLng },
          animation: google.maps.Animation.DROP
        }];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates: function updateCoordinates(location) {
      this.essaLat = location.latLng.lat();
      this.essaLng = location.latLng.lng();
      map: this.map;
      this.essaMarkers = [{ position: { lat: this.essaLat, lng: this.essaLng } }];
    },
    onProvinceIdChange: function onProvinceIdChange(id, text, data, ref) {
      var self = this;
      //console.log("onProvinceIdChange : " + self.isChange);
      if (self.isChange) {
        self.essaAmphurId = null;
        self.essaTumbolId = null;

        $("#essaAmphurId").val("").trigger("change");

        $("#essaTumbolId").val("").trigger("change");
      }
    },
    onAmphurIdChange: function onAmphurIdChange(id, text, data, ref) {
      var self = this;
      //console.log("onAmphurIdChange : " + self.isChange);
      if (self.isChange) {
        self.essaTumbolId = null;

        $("#essaTumbolId").val("").trigger("change");
      }
    },
    openMap: function openMap() {
      var self = this;
      window.open("https://www.google.com/maps/search/?api=1&query=" + self.essaLat + "," + self.essaLng, "_blank");
    }
  },
  computed: {},
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this5;
              router = _this5.$router;
              _context2.next = 4;
              return _this5.$root.getUser();

            case 4:
              user = _context2.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              // set validation rules
              $(_this5.$refs.form).validate({
                rules: {
                  essaShopSubAgentCode: "required",
                  essaShopSubAgentName: "required",
                  essaShopSubAgentName2: "required",
                  essaShopCode: "required",
                  eShShopGroup: "required",
                  essaShopPMType: "required",
                  // CR-PM-2026 Issue 14: required เฉพาะกรณี "กำหนดเอง" (useSettingCheckinRange=false)
                  customCheckInRange: {
                    required: function required() {
                      return !self.useSettingCheckinRange;
                    }
                  }
                },
                messages: {
                  essaShopSubAgentCode: "กรุณากรอกรหัสร้านค้า (ตัวแทนจำหน่ายย่อย)",
                  essaShopSubAgentName: "กรุณากรอกชื่อร้านค้า (ตัวแทนจำหน่ายย่อย)",
                  essaShopSubAgentName2: "กรุณากรอกชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย)",
                  essaShopCode: "กรุณาเลือกผู้ดูแลร้านค้าตัวแทนจำหน่ายย่อย",
                  eShShopGroup: "กรุณาเลือกสถานะประเภทร้านค้า",
                  essaShopPMType: "ประเภทการล้างเครื่อง",
                  customCheckInRange: "กรุณาระบุระยะ (เมตร)"
                }
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/SubAgent/" + _this5.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.essaShopSubAgentId = response.data.subAgentId;
                  self.essaShopSubAgentCode = response.data.subAgentCode;
                  self.essaShopSubAgentName = response.data.subAgentName;
                  self.essaShopSubAgentName2 = response.data.subAgentName2;
                  self.essaAddress = response.data.address;
                  self.essaEmail = response.data.email;
                  self.essaTel = response.data.tel;
                  self.essaContactFullName = response.data.fullName;
                  self.essaInActiveStatus = !response.data.inActiveStatus;
                  self.essaContactShopName = response.data.contactShopName;
                  self.essaContactShopLName = response.data.contactShopLastName;
                  self.eShIsSpecialPM = response.data.isSpecialPM != null ? response.data.isSpecialPM : false;
                  // CR-PM-2026 Req 2
                  self.useSettingCheckinRange = response.data.useSettingCheckinRange != null ? response.data.useSettingCheckinRange : true;
                  self.customCheckInRange = !self.useSettingCheckinRange ? response.data.checkInRange : null;
                  self.apiLoadedCheckInRange = response.data.checkInRange != null ? response.data.checkInRange : null;

                  self.eessaShopPMType = response.data.shopPMType;
                  if (response.data.shopPMType) {
                    self.$refs.essaShopPMTypeSelect2.setSelectedData({
                      id: response.data.shopPMType,
                      text: response.data.shopPMTypeName
                    });
                  }

                  if (response.data.shopTypeId) {
                    var txt = response.data.shopTypeName;
                    if (response.data.subShopTypeName) txt += " " + response.data.subShopTypeName;
                    self.$refs.essaShopTypeSelect2.setSelectedData({
                      id: response.data.shopTypeId,
                      text: txt
                    });
                  }

                  if (response.data.shopGroupId) {
                    self.$refs.eShShopGroupSelect2.setSelectedData({
                      id: response.data.shopGroupId.toString(),
                      text: response.data.shopGroupName
                    });
                  }

                  if (response.data.provinceId) {
                    self.$refs.essaProvinceIdSelect2.setSelectedData({
                      id: response.data.provinceId,
                      text: response.data.provinceName
                    });
                  }

                  if (response.data.ampherId) {
                    self.$refs.essaAmphurIdSelect2.setSelectedData({
                      id: response.data.ampherId,
                      text: response.data.ampherName
                    });
                  }

                  if (response.data.tambolId) {
                    self.$refs.essaTumbolIdSelect2.setSelectedData({
                      id: response.data.tambolId,
                      text: response.data.tambolName
                    });
                  }

                  if (response.data.shopCode) {
                    self.$refs.essaShopCodeSelect2.setSelectedData({
                      id: response.data.shopCode,
                      text: response.data.shopName
                    });
                  }

                  if (response.data.employeeId) {
                    self.$refs.essaEmpIdSelect2.setSelectedData({
                      id: response.data.employeeId,
                      text: "[" + response.data.employeeNo + "] " + response.data.employeeName + " " + response.data.employeeLastName
                    });
                  }

                  //Set lat lng
                  response.data.latitude === null ? self.essaLat = null : self.essaLat = parseFloat(response.data.latitude);
                  response.data.longitude === null ? self.essaLng = null : self.essaLng = parseFloat(response.data.longitude);

                  self.essaMarkers = [{ position: { lat: self.essaLat, lng: self.essaLng } }];

                  // Load existing pictures into FileUpload array
                  if (response.data.pictures && response.data.pictures.length > 0) {
                    response.data.pictures.forEach(function (element) {
                      self.FileUpload.push({
                        pictureId: element.pictureId,
                        urlImg: element.urlImg,
                        fileName: element.fileName,
                        fileInfoId: element.fileInfoId,
                        downloadUrl: element.downloadUrl,
                        isNew: false,
                        isLoaded: true
                      });
                    });
                  }

                  setTimeout(function () {
                    self.isChange = true;
                  }, 50);
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลคลังสินค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลคลังสินค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles

// import { ASYNC_SEARCH } from "@riophae/vue-treeselect";


__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#subAgentTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/SubAgent/" + _this.data.subAgentId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#subAgentTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put("/Api/SubAgent/" + _this2.data.subAgentId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n  </div>",
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Master/ManageShopSubAgent/Edit/" + this.data.subAgentId
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      sumKeyword: null,
      sumInActiveStatus: null,
      sumShopTypeId: [],
      shmShopGroupId: [],
      sumProvinceId: null,
      sumAmpherId: null,
      sumSubShopAgent: [],
      sumSubShopAgentOptions: [],
      //config
      sumInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      },
      sumSubAgentOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "true", text: "ใช่", data: null }, { id: "false", text: "ไม่ใช่", data: null }]
      },
      sumShopTypeIdOptions: [],
      sumProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      shmShopGroupIdOptions: [],
      sumAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              provinceId: self.sumProvinceId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.sumKeyword = "";
      this.sumShopTypeId = [];
      this.shmShopGroupId = [];
      this.sumSubShopAgent = [];
      //default Active Data
      this.sumInActiveStatus = false;
      $("#sumInActiveStatus").val(this.sumInActiveStatus + "").trigger("change");

      $("#sumShopTypeId").val("").trigger("change");

      $("#shmShopGroupId").val("").trigger("change");

      $("#sumProvinceId").val("").trigger("change");

      $("#sumAmpherId").val("").trigger("change");

      $("#sumSubShopAgent").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#subAgentTable").DataTable();
      table.search(this.id | this.name);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    exportShopSubAgent: function exportShopSubAgent(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportShopSubAgent",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: self.sumKeyword,
          ShopTypeId: self.sumShopTypeId,
          ShopGroupId: self.shmShopGroupId,
          ProvinceId: self.sumProvinceId,
          AmpherId: self.sumAmpherId,
          InActiveStatus: self.sumInActiveStatus,
          SubAgentCode: self.sumSubShopAgent
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          var fname = filename.split("RPT_")[1];
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // link.download = "ข้อมูลร้านค้า" + filename;
          link.download = "จัดการข้อมูลร้านค้าตัวแทนจำหน่ายย่อย_" + fname; //+ filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#subAgentTable").DataTable().ajax.reload(null, resetPaging);
    },
    onAmpherIdChange: function onAmpherIdChange() {
      $("#sumAmpherId").val("").trigger("change");
    },
    LoadShopTypeIdOptions: function LoadShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.sumShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadSumSubShopAgentOptions: function LoadSumSubShopAgentOptions(_ref) {
      var searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.sumSubShopAgentOptions = [];
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/SubAgent/Select2SearchSubAgent", {
        page: 1,
        all: true,
        search: searchQuery
        //subShopAgent: sumSubShopAgent,
      }).then(function (response) {
        if (response.status == 200) {
          self.sumSubShopAgentOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.sumSubShopAgentOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
        callback(null, self.sumSubShopAgentOptions);
      }).catch(function (error) {});
    },
    // 1000),
    reLoadSumSubShopAgentOptions: function reLoadSumSubShopAgentOptions() {
      this.$refs.sumSubShopAgent.trigger.searchQuery = null;
    },
    LoadShopGroupIdOptions: function LoadShopGroupIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shmShopGroupIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;

              self.LoadShopTypeIdOptions();
              self.LoadShopGroupIdOptions();
              //self.LoadSumSubShopAgentIdOptions();
              //default Active Data
              self.sumInActiveStatus = false;
              $("#sumInActiveStatus").val(self.sumInActiveStatus + "").trigger("change");

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#subAgentTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/SubAgent/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    //console.log(d);
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.sumKeyword,
                      ShopTypeId: self.sumShopTypeId,
                      ShopGroupId: self.shmShopGroupId,
                      ProvinceId: self.sumProvinceId,
                      AmpherId: self.sumAmpherId,
                      InActiveStatus: self.sumInActiveStatus,
                      SubAgentCode: self.sumSubShopAgent
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[1, "desc"]],
                columns: [{
                  data: null,
                  className: "details-control",
                  defaultContent: "",
                  orderable: false
                }, {
                  data: "subAgentId",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.subAgentCode;
                  }
                }, { data: "subAgentName", className: "text-center" }, { data: "subAgentName2", className: "text-center" }, { data: "shopTypeName", className: "text-center" }, { data: "shopGroupName", className: "text-center" }, { data: "shopName", className: "text-center" }, { data: "shopName2", className: "text-center" }, { data: "address", className: "text-center" }, { data: "email", className: "text-center" }, { data: "tel", className: "text-center" }, { data: "fullName", className: "text-center" }, { data: "contactShopFullName", className: "text-center" }, { data: "employeeFullName", className: "text-center" }, { data: "ampherName", className: "text-center", orderable: false }, { data: "provinceName", className: "text-center", orderable: false }, { data: "latitude", className: "text-center" }, { data: "longitude", className: "text-center" }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "customerCode",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_SHOP_SUB_AGENT"]);
                    if (data.inActiveStatus == 0) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  //console.log(data);
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_SHOP_SUB_AGENT"]);
                    // data.showDeleteButton = self.$root.canShow([
                    //   "MANAGE_MASTER",
                    //   "MANAGE_SHOP_SUB_AGENT"
                    // ]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#supplierTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Vendors/" + _this.data.vendorId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#supplierTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Vendors/" + _this2.data.vendorId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 Supplier\">\n      <i class=\"la la-edit\"></i>\n    </a>\n  </div>",
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/Supplier/Update/" + this.data.vendorId
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    return {
      sulKeyword: "",
      sulInActiveStatus: false,
      //config
      sulInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.sulKeyword = "";
      this.sulInActiveStatus = false;
      $("#sulInActiveStatus").val(this.sulInActiveStatus + "").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#supplierTable").DataTable();
      table.search();
      table.draw();
    },
    exportSuplier: function exportSuplier(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/Report/ExportSuplier",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: self.sulKeyword,
          InActiveStatus: self.sulInActiveStatus
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // link.download = "ข้อมูลSuplier" + filename;
          link.download = "ข้อมูลSuplier"; //+ filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#supplierTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;

              //default inActive

              self.sulInActiveStatus = false;
              $("#sulInActiveStatus").val(self.sulInActiveStatus + "").trigger("change");

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#supplierTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Vendors/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.sulKeyword,
                      InActiveStatus: self.sulInActiveStatus
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[1, "desc"]],
                columns: [{ data: null, orderable: false, defaultContent: "" }, { data: "no", className: "text-center" }, { data: "name", width: "20%", className: "text-center" }, { data: "taxNo", className: "text-center" }, { data: "email", className: "text-center" }, { data: "tel", className: "text-center" }, { data: "address", className: "text-center" }, { data: "latitude", className: "text-center" }, { data: "longitude", className: "text-center" }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "vendorId",
                  className: "text-center",
                  width: "13%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(['MANAGE_MASTER', 'MANAGE_SUPPLIER']);
                    if (data.inActiveStatus == false) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == true) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(['MANAGE_MASTER', 'MANAGE_SUPPLIER']);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Treeselect: __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default.a
  },
  data: function data() {
    return {
      suuNo: null,
      suuName: null,
      suuTaxNo: null,
      suuEmail: null,
      suuTel: null,
      suuAddress: null,
      suuInActiveStatus: true,
      suuLat: null,
      suuLng: null,
      suuMarkers: [],
      FileUpload: [],
      OwnerTypeCode: null,
      OwnerTypeCodeOption: []
    };
  },

  methods: {
    uploadFile: function uploadFile() {
      var _this = this;

      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();
      input.addEventListener("change", function (event) {
        var file = event.target.files[0];
        if (file) {
          var reader = new FileReader();
          reader.onload = function (e) {
            var newImage = {
              pictureId: "new_" + Date.now(),
              urlImg: e.target.result,
              fileName: file.name,
              isNew: true,
              fileDataContext: file,
              isLoaded: true
            };
            _this.FileUpload.push(newImage);
          };
          reader.readAsDataURL(file);
        }
      });
    },
    removeImage: function removeImage(pictureId) {
      var _this2 = this;

      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        icon: "warning",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then(function (result) {
        if (result.value) {
          _this2.FileUpload = _this2.FileUpload.filter(function (img) {
            return img.pictureId !== pictureId;
          });
          Swal.fire("เรียบร้อย!", "ลบรูปภาพเรียบร้อย", "success");
        }
      });
    },
    handleImageError: function handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad: function handleImageLoad(image) {
      image.isLoaded = true;
    },
    onSubmit: function onSubmit(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var router, self, uploadedFiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, formData, uploadResponse, picturesData, response, errorMsg;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                router = _this3.$router;
                self = _this3;

                if ($(_this3.$refs.form).validate().form()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                _context.prev = 5;

                // Upload new files to GCS
                uploadedFiles = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 10;
                _iterator = _this3.FileUpload[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 29;
                  break;
                }

                file = _step.value;

                if (!(file.isNew && file.fileDataContext)) {
                  _context.next = 25;
                  break;
                }

                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("IsMaster", true);
                formData.append("FolderName", "MasterVendor");

                _context.next = 21;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 21:
                uploadResponse = _context.sent;


                if (uploadResponse.data && uploadResponse.data.fileInfoId) {
                  uploadedFiles.push({
                    fileInfoId: uploadResponse.data.fileInfoId,
                    fileName: uploadResponse.data.fileInfoId,
                    downloadUrl: uploadResponse.data.fileUrl
                  });
                }
                _context.next = 26;
                break;

              case 25:
                if (!file.isNew) {
                  // Existing image - include in the list
                  uploadedFiles.push({
                    fileInfoId: file.fileInfoId,
                    fileName: file.fileName,
                    downloadUrl: file.downloadUrl
                  });
                }

              case 26:
                _iteratorNormalCompletion = true;
                _context.next = 12;
                break;

              case 29:
                _context.next = 35;
                break;

              case 31:
                _context.prev = 31;
                _context.t0 = _context["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 35:
                _context.prev = 35;
                _context.prev = 36;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 38:
                _context.prev = 38;

                if (!_didIteratorError) {
                  _context.next = 41;
                  break;
                }

                throw _iteratorError;

              case 41:
                return _context.finish(38);

              case 42:
                return _context.finish(35);

              case 43:

                // Prepare pictures data for API
                picturesData = uploadedFiles.map(function (pic) {
                  return {
                    fileInfoId: pic.fileInfoId,
                    fileName: pic.fileName,
                    downloadUrl: pic.downloadUrl
                  };
                });
                _context.next = 46;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/Vendors", {
                  VendorId: _this3.$route.params.id,
                  Latitude: _this3.suuLat,
                  Longitude: _this3.suuLng,
                  InActiveStatus: !_this3.suuInActiveStatus,
                  VendorPictures: picturesData,
                  OwnerTypeCode: _this3.OwnerTypeCode
                });

              case 46:
                response = _context.sent;


                if (response.data.status) {
                  KTApp.unblockPage();
                  Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                    router.go(-1);
                    self.$parent.reloadDataTable(false);
                  });
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                }
                _context.next = 54;
                break;

              case 50:
                _context.prev = 50;
                _context.t1 = _context["catch"](5);
                errorMsg = _context.t1.response && _context.t1.response.data && _context.t1.response.data.message ? _context.t1.response.data.message : _context.t1.message;

                Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");

              case 54:
                _context.prev = 54;

                KTApp.unblockPage();
                return _context.finish(54);

              case 57:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[5, 50, 54, 57], [10, 31, 35, 43], [36,, 38, 42]]);
      }))();
    },

    getMap: function getMap() {
      var _this4 = this;

      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition(function (position) {
        _this4.suuLat = position.coords.latitude;
        _this4.suuLng = position.coords.longitude;
        _this4.suuMarkers = [{
          position: { lat: _this4.suuLat, lng: _this4.suuLng },
          animation: google.maps.Animation.DROP
        }];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates: function updateCoordinates(location) {
      this.suuLat = location.latLng.lat();
      this.suuLng = location.latLng.lng();
      map: this.map;
      this.suuMarkers = [{ position: { lat: this.suuLat, lng: this.suuLng } }];
    },
    openMap: function openMap() {
      var self = this;
      window.open("https://www.google.com/maps/search/?api=1&query=" + self.suuLat + "," + self.suuLng, "_blank");
    },

    LoadOwnerTypeCodeOption: function LoadOwnerTypeCodeOption(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/Options?search=MASTER_OWNER_TYPE", {
        params: {
          page: 1,
          all: true,
          searchCode: "OWNER_SUP"
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OwnerTypeCodeOption.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this5;
              router = _this5.$router;
              _context2.next = 4;
              return _this5.$root.getUser();

            case 4:
              user = _context2.sent;

              self.LoadOwnerTypeCodeOption();

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              //set validation rules
              $(_this5.$refs.form).validate({
                rules: {
                  //SteContactName: "required"
                },
                messages: {
                  //SteContactName: "กรุณาระบุชื่อผู้ติดต่อ"
                }
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Vendors/" + _this5.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.suuNo = response.data.no;
                  self.suuName = response.data.name;
                  self.suuAddress = response.data.address;
                  self.suuTaxNo = response.data.taxNo;
                  self.suuEmail = response.data.email;
                  self.suuTel = response.data.tel;
                  self.suuInActiveStatus = !response.data.inActiveStatus;
                  self.OwnerTypeCode = response.data.ownerTypeCode;

                  //Set lat lng
                  response.data.latitude === null ? self.suuLat = null : self.suuLat = parseFloat(response.data.latitude);
                  response.data.longitude === null ? self.suuLng = null : self.suuLng = parseFloat(response.data.longitude);

                  self.suuMarkers = [{ position: { lat: self.suuLat, lng: self.suuLng } }];

                  // Load existing pictures into FileUpload array
                  if (response.data.pictures && response.data.pictures.length > 0) {
                    response.data.pictures.forEach(function (element) {
                      self.FileUpload.push({
                        pictureId: element.pictureId,
                        urlImg: element.urlImg,
                        fileName: element.fileName,
                        fileInfoId: element.fileInfoId,
                        downloadUrl: element.downloadUrl,
                        isNew: false,
                        isLoaded: true
                      });
                    });
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลคลังสินค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลคลังสินค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      trcCarReg: null,
      trcCompanyType: null,
      trcCompanyId: null,
      trcAgentId: null,
      trcVendorId: null,
      trcDriverFirstName: null,
      trcDriverLastName: null,
      trcDriverTel: null,
      trcTransitContactorId: null,
      trcEmpId: null,
      trcInActiveStatus: true,
      trcEmpTel: null,
      trcEmpEmail: null,
      trcEmpPosition: null,
      trcTransitContactorTel: null,
      trcTransitContactorEmail: null,
      trcTransitContactorPosition: null,
      // Configurations
      trcCompanyTypeOptions: {
        placeholder: "กรุณาเลือก",
        data: [{ id: "agent", text: "Agent", data: null }, { id: "vendor", text: "Supplier", data: null }]
      },
      trcCompanyIdOptions: {
        placeholder: "กรุณาเลือก",
        data: [{ id: "", text: "", data: null }]
      },
      trcAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      trcVendorOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      trcEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      trcTransitContactorIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/TransitContactor/Select2TransitContactor",
          data: function data(params) {
            var tmp = "";
            console.log(self.trcCompanyType);
            if (self.trcCompanyType == "agent") {
              tmp = self.trcAgentId;
            } else if (self.trcCompanyType == "vendor") {
              tmp = self.trcVendorId;
            }

            var query = {
              search: params.term,
              page: params.page || 1,
              companyType: self.trcCompanyType,
              companyId: tmp
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  methods: {
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;

      var tmp = "";
      if (this.trcCompanyType == "agent") {
        tmp = this.trcAgentId;
      } else if (this.trcCompanyType == "vendor") {
        tmp = this.trcVendorId;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Transport", {
        CarReg: this.trcCarReg,
        CompanyType: this.trcCompanyType,
        CompanyId: tmp,
        DriverFirstName: this.trcDriverFirstName,
        DriverLastName: this.trcDriverLastName,
        DriverTel: this.trcDriverTel,
        TransitContactorId: this.trcTransitContactorId,
        EmpId: this.trcEmpId,
        InActiveStatus: !this.trcInActiveStatus
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onTrcEmpIdChange: function onTrcEmpIdChange(id, text, data, ref) {
      this.trcEmpEmail = data[0].data.email;
      this.trcEmpTel = data[0].data.tel;
      this.trcEmpPosition = data[0].data.positionName;
    },
    onTrcTransitContactorIdChange: function onTrcTransitContactorIdChange(id, text, data, ref) {
      this.trcTransitContactorEmail = data[0].data.email;
      this.trcTransitContactorTel = data[0].data.tel;
      this.trcTransitContactorPosition = data[0].data.position;
    },
    VenderChange: function VenderChange(id, text, data, ref) {
      this.trcVendorId = text;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  trcCarReg: "required",
                  trcCompanyType: "required",
                  trcAgentId: "required",
                  trcVendorId: "required",
                  trcCompanyId: "required",
                  trcDriverFirstName: "required",
                  trcDriverLastName: "required",
                  trcDriverTel: "required",
                  trcTransitContactorId: "required",
                  trcEmpId: "required"
                },
                messages: {
                  trcCarReg: "กรุณากรอกเลขทะเบียน",
                  trcCompanyType: "กรุณาเลือกประเภทบริษัท",
                  trcAgentId: "กรุณาเลือกบริษัท",
                  trcVendorId: "กรุณาเลือกบริษัท",
                  trcCompanyId: "กรุณาเลือกบริษัท",
                  trcDriverFirstName: "กรุณากรอกชื่อคนขับ",
                  trcDriverLastName: "กรุณากรอกนามสกุล",
                  trcDriverTel: "กรุณากรอกเบอร์ติดต่อ",
                  trcTransitContactorId: "กรุณาเลือกผู้ประสานงาน(ภายนอก)",
                  trcEmpId: "กรุณาเลือกผู้ประสานงาน(Boonrawd)"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      trasitId: null,
      treCarReg: null,
      treCompanyType: null,
      treCompanyId: null,
      treCompanyName: null,
      treDriverFirstName: null,
      treDriverLastName: null,
      treDriverTel: null,
      treTransitContactorId: null,
      treEmpId: null,
      treInActiveStatus: null,
      treEmpTel: null,
      treEmpEmail: null,
      treEmpPosition: null,
      treTransitContactorTel: null,
      treTransitContactorEmail: null,
      treTransitContactorPosition: null,
      treEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      treTransitContactorIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/TransitContactor/Select2TransitContactor",
          data: function data(params) {
            var tmp = "";
            if (self.treCompanyType == "agent") {
              tmp = self.treCompanyId;
            } else if (self.treCompanyType == "vendor") {
              tmp = self.treCompanyId;
            }

            var query = {
              search: params.term,
              page: params.page || 1,
              companyType: self.treCompanyType,
              companyId: tmp
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },

  methods: {
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;

      if (this.trcCompanyType == "Agent") {
        this.treCompanyType = "agent";
      } else if (this.trcCompanyType == "Vendor") {
        this.treCompanyType = "vendor";
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/Transport", {
        TransitId: this.trasitId,
        CarReg: this.treCarReg,
        CompanyType: this.treCompanyType,
        CompanyId: this.treCompanyId,
        DriverFirstName: this.treDriverFirstName,
        DriverLastName: this.treDriverLastName,
        DriverTel: this.treDriverTel,
        TransitContactorId: this.treTransitContactorId,
        EmpId: this.treEmpId,
        InActiveStatus: !this.treInActiveStatus
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onTreEmpIdChange: function onTreEmpIdChange(id, text, data, ref) {
      this.treEmpEmail = data[0].data.email;
      this.treEmpTel = data[0].data.officeTel;
      this.treEmpPosition = data[0].data.positionName;
    },
    onTreTransitContactorIdChange: function onTreTransitContactorIdChange(id, text, data, ref) {
      this.treTransitContactorEmail = data[0].data.email;
      this.treTransitContactorTel = data[0].data.tel;
      this.treTransitContactorPosition = data[0].data.position;
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Transport/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  self.trasitId = response.data.trasitId;
                  self.treCarReg = response.data.carReg;
                  if (response.data.companyType == "agent") {
                    self.treCompanyType = "agent";
                  } else if (response.data.companyType == "vendor") {
                    self.treCompanyType = "Supplier";
                  } else {
                    self.treCompanyType = "vendor";
                  }
                  self.treInActiveStatus = !response.data.inActiveStatus;
                  self.treCompanyId = response.data.companyCode;
                  self.treCompanyName = response.data.companyName;
                  self.treDriverFirstName = response.data.driverName;
                  self.treDriverLastName = response.data.driverLastName;
                  self.treDriverTel = response.data.driverTel;
                  self.treTransitContactorTel = response.data.contactTel;
                  self.treTransitContactorEmail = response.data.contactEmail;
                  self.treTransitContactorPosition = response.data.contactPosition;
                  self.treEmpTel = response.data.employeeTel;
                  self.treEmpEmail = response.data.employeeEmail;
                  self.treEmpPosition = response.data.employeePosName;
                  if (response.data.employeeId) {
                    self.$refs.treEmpIdSelect2.setSelectedData({
                      id: response.data.employeeId,
                      text: "[" + response.data.employeeNO + "] " + response.data.employeeName + " " + response.data.employeeLastName,
                      data: {
                        email: response.data.employeeEmail,
                        positionName: response.data.employeePosName,
                        officeTel: response.data.employeeTel
                      }
                    });
                  }
                  if (response.data.transitContactorId) {
                    self.$refs.treTransitContactorIdSelect2.setSelectedData({
                      id: response.data.transitContactorId,
                      text: response.data.contactName + " " + response.data.contactLastname,
                      data: {
                        email: response.data.contactEmail,
                        position: response.data.contactPosition,
                        tel: response.data.contactTel
                      }
                    });
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลขนส่งคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลขนส่งได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  treDriverFirstName: "required",
                  treDriverLastName: "required",
                  treDriverTel: "required",
                  treTransitContactorId: "required",
                  treEmpId: "required"
                },
                messages: {
                  treDriverFirstName: "กรุณากรอกชื่อคนขับ",
                  treDriverLastName: "กรุณากรอกนามสกุล",
                  treDriverTel: "กรุณากรอกเบอร์ติดต่อ",
                  treTransitContactorId: "กรุณาเลือกผู้ประสานงาน(ภายนอก)",
                  treEmpId: "กรุณาเลือกผู้ประสานงาน(Boonrawd)"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this = this;

      var self = this;
      var table = $("#transportTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Transport/" + _this.data.trasitId + "/Toggle").then(function (response) {
            if (response.data.data) {
              Swal.fire("สำเร็จ", response.data.message, "success");
              self.$parent.reloadDataTable();
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            console.log(error);
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#transportTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        Swal.fire("สำเร็จ", "success");
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Transport/" + _this2.data.trasitId + "/Toggle").then(function (response) {
            if (response.data.data) {
              Swal.fire("สำเร็จ", response.data.message, "success");
              self.$parent.reloadDataTable();
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            console.log(error);
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n     <a href=\"#\" @click.prevent=\"deleteTran\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n  </div>",
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/ManageTransport/Edit/" + this.data.trasitId
      });
    },
    deleteTran: function deleteTran() {
      var _this3 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลขนส่ง",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูลขนส่ง <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลขนส่งนี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลขนส่ง",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Transport/" + _this3.data.trasitId + "/Delete").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    return {
      MtsKeyword: "",
      MtsStatus: "",

      MtsStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.MtsKeyword = "";

      //default Active Data
      this.MtsStatus = false;
      $("#MtsStatus").val(this.MtsStatus + "").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#transportTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#transportTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;

              //default Active Data

              self.MtsStatus = false;
              $("#MtsStatus").val(self.MtsStatus + "").trigger("change");

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#transportTable");
              // begin first table

              table.DataTable({
                // data: dataSet,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Transport/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.MtsKeyword,
                      InActiveStatus: self.MtsStatus
                    }));
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n      <'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[5, "desc"]],
                select: {
                  style: "multi",
                  selector: "td:first-child"
                },
                columns: [
                // { data: "trasitId", className: "text-center" },
                { data: "carReg", className: "text-center" }, { data: "companyName", className: "text-center",

                  render: function render(data, type, full, meta) {
                    var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>" + data + "</pre>";
                    return html;
                  }

                }, { data: "driverName", className: "text-center" }, { data: "driverTel", className: "text-center" }, { data: "contactName", className: "text-center" }, { data: "contactTel", className: "text-center" }, { data: "contactEmail", className: "text-center" }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "trasitId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_TRANSPORT"]);
                    if (data.inActiveStatus == false) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == true) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });

                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_TRANSPORT"]);
                    data.showDeleteButton = self.$root.canShow(["MANAGE_MASTER", "MANAGE_TRANSPORT"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      var self = this;
      if (!$(self.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/CompanyProfile/CreateDefault", {
        agentCode: $(self.$refs.agentCode).val()
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $(self.$el).modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var self = this;

    $(self.$refs.form).validate({
      rules: {
        agentCode: "required"
      },
      messages: {
        agentCode: "กรุณาเลือกตัวแทนจำหน่าย"
      }
    });

    $(self.$el).on("hidden.bs.modal", function () {
      $('body').addClass('modal-open');
      $(self.$refs.agentCode).val("").trigger("change");
    });

    $(self.$refs.agentCode).select2({
      placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      allowClear: true,
      ajax: {
        url: "/Api/Agents/Select2SearchAgentName",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    });
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubAgentProfileCreateForm__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserSmlMapping_vue__ = __webpack_require__(106);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    subAgentProfileCreateForm: __WEBPACK_IMPORTED_MODULE_0__SubAgentProfileCreateForm__["a" /* default */],
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    userSmlMapping: __WEBPACK_IMPORTED_MODULE_3__UserSmlMapping_vue__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      userName: null,
      password: null,
      confirmPassword: null,
      email: null,
      givenName: null,
      familyName: null,
      position: null,
      phoneNumber: null,
      companyProfileId: null,
      useraCompanyProfile: null,
      useraCompanyProfileOptions: {
        placeholder: "เลือกโปรไฟล์บริษัท",
        allowClear: true,
        ajax: {
          url: "/Api/CompanyProfile/Options",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      selectedCompanyProfiles: [],
      userSmlMappings: []
    };
  },
  methods: {
    onCompanyProfileChange: function onCompanyProfileChange(id, value, data, ref) {
      this.selectedCompanyProfiles = data;
    },

    showSubAgentProfileCreateForm: function showSubAgentProfileCreateForm() {
      $(this.$refs.subAgentProfileCreateForm.$el).modal("show");
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$("#userCreateModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var tempCompanyProfile = this.useraCompanyProfile;
      this.useraCompanyProfile = [];
      if (tempCompanyProfile != null) {
        this.useraCompanyProfile.push(tempCompanyProfile);
      }

      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Users/Create", {
        userName: this.userName,
        password: this.password,
        confirmPassword: this.confirmPassword,
        email: this.email,
        givenName: this.givenName,
        familyName: this.familyName,
        position: this.position,
        phoneNumber: this.phoneNumber,
        companyProfileId: this.useraCompanyProfile,
        userSmlMappings: this.userSmlMappings
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $("#userCreateModal").modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              // set validation rules
              $("#userCreateModal form").validate({
                rules: {
                  userName: "required",
                  email: {
                    required: true,
                    email: true
                  },
                  password: {
                    required: true,
                    minlength: 6
                  },
                  confirmPassword: {
                    equalTo: "#password"
                  },
                  givenName: "required",
                  familyName: "required",
                  phoneNumber: "required",
                  companyProfile: "required"
                },
                messages: {
                  userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
                  email: {
                    required: "กรุณากรอกอีเมล",
                    email: "กรุณากรอกอีเมลให้ถูกต้อง"
                  },
                  password: {
                    required: "กรุณากรอกรหัสผ่าน",
                    minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร"
                  },
                  confirmPassword: {
                    equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง"
                  },
                  givenName: "กรุณากรอกชื่อ",
                  familyName: "กรุณากรอกชื่อสกุล",
                  phoneNumber: "กรุณากรอกเบอร์โทรศัพท์",
                  companyProfile: "กรุณาเลือกโปรไฟล์บริษัทฯ"
                }
              });

              $("#userCreateModal #companyProfile").select2({
                placeholder: "เลือกโปรไฟล์บริษัท",
                allowClear: true,
                ajax: {
                  url: "/Api/CompanyProfile/Options",
                  data: function data(params) {
                    var query = {
                      search: params.term,
                      page: params.page || 1
                    };
                    return query;
                  },
                  processResults: function processResults(data, params) {
                    return {
                      results: data.results,
                      pagination: {
                        more: data.more
                      }
                    };
                  },
                  transport: function transport(params, success, failure) {
                    params.beforeSend = function (request) {
                      request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                    };
                    var $request = $.ajax(params);
                    $request.then(success);
                    $request.fail(failure);
                    return $request;
                  }
                }
              }).change(function () {
                self.companyProfileId = $(this).val();
              });

              $("#userCreateModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              }).modal("show");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var UserActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\"@click.prevent=\"forgotPassword\" v-if=\"data.showEditButton\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E2A\u0E48\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\">\n      <i class=\"la la-envelope\"></i>\n    </a>\n  </div>",
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/Master/AgentUsers/Edit/" + this.data.userName });
    },
    forgotPassword: function forgotPassword() {
      var _this = this;

      Swal.fire({
        title: "ส่งอีเมลรีเซ็ตรหัสผ่าน",
        html: "ระบบจะส่งลิ้งค์สำหรับรีเซ็ตรหัสผ่านของ <strong>" + this.data.userName + "</strong> ไปยังอีเมล <strong>" + this.data.email + "</strong>",
        showCancelButton: true,
        confirmButtonText: "ส่งอีเมล",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังส่งอีเมล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Users/ForgotPassword", {
            userName: _this.data.userName,
            email: result.value
          }).then(function (response) {
            if (response.data.status) {
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      keyword: "",
      companyProfileId: null
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.keyword = "";
      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#userTable").DataTable();
      table.search(this.keyword);
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#userTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, user, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;
              _context.next = 3;
              return _this2.$root.getUser();

            case 3:
              user = _context.sent;
              table = $("#userTable");


              $(self.$refs.companyProfileId).select2({
                placeholder: "เลือกโปรไฟล์บริษัท",
                allowClear: true,
                ajax: {
                  url: "/Api/CompanyProfile/Options",
                  data: function data(params) {
                    var query = {
                      search: params.term,
                      page: params.page || 1
                    };
                    return query;
                  },
                  processResults: function processResults(data, params) {
                    return {
                      results: data.results,
                      pagination: {
                        more: data.more
                      }
                    };
                  },
                  transport: function transport(params, success, failure) {
                    params.beforeSend = function (request) {
                      request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                    };
                    var $request = $.ajax(params);
                    $request.then(success);
                    $request.fail(failure);
                    return $request;
                  }
                }
              }).on("change", function () {
                self.companyProfileId = $(this).val();
              });
              $.fn.dataTable.ext.errMode = 'none';
              // begin first table
              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,

                ajax: {
                  url: "/Api/Users/Find",
                  type: "post",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return $.extend({}, d, {
                      companyProfileId: self.companyProfileId
                    });
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n      <'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[6, "desc"]],

                columns: [{ data: "userName" }, { data: "email" }, { data: "fullName" }, { data: "phoneNumber", className: "text-center" }, { data: "position", className: "text-center" }, { data: "companyProfiles", width: "15%" }, {
                  data: "lastLogOnDateTime",
                  className: "text-center",
                  render: function render(data, type, row, meta) {
                    return row.lastLogOnDateTimeString;
                  }
                }, {
                  data: "userName",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShowExSuperAdmin("MANAGE_SUB_AGENT_USER");
                    new UserActions({ data: { data: data } }).$mount(el);
                  }
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_3__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubAgentProfileCreateForm__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserSmlMapping_vue__ = __webpack_require__(106);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    subAgentProfileCreateForm: __WEBPACK_IMPORTED_MODULE_0__SubAgentProfileCreateForm__["a" /* default */],
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    userSmlMapping: __WEBPACK_IMPORTED_MODULE_3__UserSmlMapping_vue__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      userName: null,
      email: null,
      givenName: null,
      familyName: null,
      position: null,
      phoneNumber: null,
      roleName: null,
      lastLogOnDateTimeString: null,
      companyProfileId: null,
      useraCompanyProfile: null,
      useraCompanyProfileOptions: {
        placeholder: "เลือกโปรไฟล์บริษัท",
        allowClear: true,
        ajax: {
          url: "/Api/CompanyProfile/Options",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      selectedCompanyProfiles: [],
      userSmlMappings: []
    };
  },
  methods: {
    onCompanyProfileChange: function onCompanyProfileChange(id, value, data, ref) {
      this.selectedCompanyProfiles = data;
    },

    showSubAgentProfileCreateForm: function showSubAgentProfileCreateForm() {
      $(this.$refs.subAgentProfileCreateForm.$el).modal("show");
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$("#userUpdateModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var tempCompanyProfile = this.useraCompanyProfile;
      this.useraCompanyProfile = [];
      if (tempCompanyProfile != null) {
        this.useraCompanyProfile.push(tempCompanyProfile);
      }

      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Users/Update", {
        userName: this.userName,
        email: this.email,
        givenName: this.givenName,
        familyName: this.familyName,
        position: this.position,
        phoneNumber: this.phoneNumber,
        roleName: this.roleName,
        companyProfileId: this.useraCompanyProfile,
        userSmlMappings: this.userSmlMappings
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $("#userUpdateModal").modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              $.validator.addMethod("regex", function (value, element, regexp) {
                var re = new RegExp(regexp);
                return this.optional(element) || re.test(value);
              }, "Please check your input.");

              // set validation rules
              $("#userUpdateModal form").validate({
                rules: {
                  userName: "required",
                  email: {
                    required: true,
                    email: true
                  },
                  givenName: "required",
                  familyName: "required",
                  phoneNumber: "required",
                  companyProfile: "required"
                },
                messages: {
                  userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
                  email: {
                    required: "กรุณากรอกอีเมล",
                    email: "กรุณากรอกอีเมลให้ถูกต้อง"
                  },
                  givenName: "กรุณากรอกชื่อ",
                  familyName: "กรุณากรอกชื่อสกุล",
                  phoneNumber: "กรุณากรอกเบอร์โทรศัพท์",
                  companyProfile: "กรุณาเลือกโปรไฟล์บริษัทฯ"
                }
              });

              $("#userUpdateModal #companyProfile").select2({
                placeholder: "เลือกโปรไฟล์บริษัท",
                allowClear: true,
                ajax: {
                  url: "/Api/CompanyProfile/Options",
                  data: function data(params) {
                    var query = {
                      search: params.term,
                      page: params.page || 1
                    };
                    return query;
                  },
                  processResults: function processResults(data, params) {
                    return {
                      results: data.results,
                      pagination: {
                        more: data.more
                      }
                    };
                  },
                  transport: function transport(params, success, failure) {
                    params.beforeSend = function (request) {
                      request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                    };
                    var $request = $.ajax(params);
                    $request.then(success);
                    $request.fail(failure);
                    return $request;
                  }
                }
              }).change(function () {
                self.companyProfileId = $(this).val();
              });

              $("#userUpdateModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              });

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Users/" + _this.$route.params.userId).then(function (response) {
                if (response.status == 200) {
                  self.userName = response.data.userName;
                  self.email = response.data.email;
                  self.phoneNumber = response.data.phoneNumber;
                  self.givenName = response.data.givenName;
                  self.familyName = response.data.familyName;
                  self.position = response.data.position;
                  self.lastLogOnDateTimeString = response.data.lastLogOnDateTimeString;
                  self.roleName = response.data.roleName;
                  // self.companyProfileId = response.data.companyProfileId;
                  // self.companyProfileName = response.data.companyProfileName;

                  if (self.roleName) {
                    $("#userUpdateModal #roleName").append("<option selected value='" + response.data.roleName + "'>" + response.data.roleDescription + "</option>").trigger("change");
                  }

                  // if (self.companyProfileId) {
                  //   $("#userUpdateModal #companyProfile")
                  //     .append(
                  //       "<option selected value='" +
                  //         response.data.companyProfileId +
                  //         "'>" +
                  //         response.data.companyProfileName +
                  //         "</option>"
                  //     )
                  //     .trigger("change");
                  // }

                  self.userSmlMappings = response.data.userSmlMappings;

                  if (response.data.companyProfiles) {
                    var companyOptions = $.map(response.data.companyProfiles, function (obj, idx) {
                      return {
                        id: obj.companyProfileId,
                        text: obj.companyProfileName,
                        data: obj.data
                      };
                    });
                    self.$refs.useraCompanyProfileSelect2.setSelectedData(companyOptions);
                  }

                  $("#userUpdateModal").modal("show");
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสมาชิกที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสมาชิกได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      var self = this;
      if (!$(self.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/CompanyProfile/CreateSubDefault", {
        customerCode: $(self.$refs.customerCode).val()
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $(self.$el).modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var self = this;

    $(self.$refs.form).validate({
      rules: {
        customerCode: "required"
      },
      messages: {
        customerCode: "กรุณาเลือกตัวแทนฯย่อย"
      }
    });

    $(self.$el).on("hidden.bs.modal", function () {
      $(self.$refs.customerCode).val("").trigger("change");
    });

    $(self.$refs.customerCode).select2({
      placeholder: "กรุณาเลือกตัวแทนฯย่อย",
      allowClear: true,
      ajax: {
        url: "/Api/Shop/Select2Shop",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            onlySubAgent: true
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    });
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      userName: null,
      password: null,
      confirmPassword: null
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      e.preventDefault();

      if (!$("#userChangePasswordModal form").validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังเปลี่ยนรหัสผ่าน กรุณารอสักครู่..."
      });

      var router = this.$router;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Users/ChangePassword", {
        userName: this.userName,
        password: this.password,
        confirmPassword: this.confirmPassword
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            $("#userChangePasswordModal").modal("hide");
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    var router = this.$router;

    self.userName = this.$route.params.userId;

    // set validation rules
    $("#userChangePasswordModal form").validate({
      rules: {
        userName: "required",
        password: {
          required: true,
          minlength: 6
        },
        confirmPassword: {
          equalTo: "#password"
        }
      },
      messages: {
        userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
        password: {
          required: "กรุณากรอกรหัสผ่าน",
          minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร"
        },
        confirmPassword: {
          equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง"
        }
      }
    });

    $("#userChangePasswordModal").on("hidden.bs.modal", function () {
      // Set go back
      router.go(-1);
      self.$parent.reloadDataTable(false);
    }).modal("show");
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgentProfileCreateForm__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserSmlMapping_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import the styles


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    agentProfileCreateForm: __WEBPACK_IMPORTED_MODULE_0__AgentProfileCreateForm__["a" /* default */],
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a,
    userSmlMapping: __WEBPACK_IMPORTED_MODULE_5__UserSmlMapping_vue__["a" /* default */]
  },
  data: function data() {
    var _ref;

    var self = this;
    return _ref = {
      userName: null,
      password: null,
      confirmPassword: null,
      email: null,
      givenName: null,
      familyName: null,
      position: null,
      phoneNumber: null,
      roleName: null,
      companyProfileId: null,
      inActiveStatus: true,
      FileUpload: null,
      usercCompanyProfile: null,
      usercCompanyProfiles: [],
      usercCompanyProfileOptions: {
        placeholder: "เลือกโปรไฟล์บริษัท",
        allowClear: true,
        ajax: {
          url: "/Api/CompanyProfile/Options",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      usercCompanyProfilesOptions: {
        placeholder: "เลือกโปรไฟล์บริษัท",
        allowClear: true,
        ajax: {
          url: "/Api/CompanyProfile/Options",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    }, _defineProperty(_ref, "usercCompanyProfilesOptions", []), _defineProperty(_ref, "roleNameOptions", []), _defineProperty(_ref, "userSmlMappings", []), _defineProperty(_ref, "selectedCompanyProfiles", []), _ref;
  },
  methods: {
    handleImageError: function handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad: function handleImageLoad(image) {
      image.isLoaded = true;
    },
    removeImage: function removeImage(pictureId) {
      var _this = this;

      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then(function (result) {
        if (result.value) {
          _this.FileUpload = null;
          Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
        }
      });
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.multiple = false;
      input.click();

      input.addEventListener("change", function (event) {
        var file = event.target.files[0];
        if (file && ["image/jpeg", "image/jpg", "image/png"].includes(file.type) && file.size <= 10 * 1024 * 1024) {
          var reader = new FileReader();
          reader.onload = function (e) {
            _this2.FileUpload = {
              pictureId: Date.now().toString(),
              fileName: file.name,
              urlImg: e.target.result,
              fileDataContext: file,
              isNew: true,
              isLoaded: true
            };
          };
          reader.readAsDataURL(file);
        } else {
          alert("กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)");
        }
      });
    },

    showAgentProfileCreateForm: function showAgentProfileCreateForm() {
      $(this.$refs.agentProfileCreateForm.$el).modal("show");
    },
    formSubmit: function formSubmit(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tempCompanyProfile, uploadedFile, file, formData, uploadResponse, router;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                if ($("#userCreateModal form").validate().form()) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", false);

              case 3:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                if (!Array.isArray(_this3.usercCompanyProfiles) && _this3.companyProfile != null) {
                  tempCompanyProfile = _this3.usercCompanyProfiles;

                  _this3.usercCompanyProfiles = [];
                  _this3.usercCompanyProfiles.push(tempCompanyProfile);
                }

                uploadedFile = null;

                if (!(_this3.FileUpload && _this3.FileUpload.isNew && _this3.FileUpload.fileDataContext)) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 7;
                file = _this3.FileUpload;
                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("IsMaster", true);
                formData.append("FolderName", "MasterUser");

                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 15:
                uploadResponse = _context.sent;


                uploadedFile = {
                  contentType: "-",
                  downloadUrl: uploadResponse.data.fileUrl,
                  fileInfoId: uploadResponse.data.fileInfoId,
                  fileName: uploadResponse.data.fileInfoId,
                  gridFsId: uploadResponse.data.gridFsId,
                  sysName: "-"
                };
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](7);

                console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", _context.t0);

              case 22:
                router = _this3.$router;

                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Users/Create", {
                  userName: _this3.userName,
                  password: _this3.password,
                  confirmPassword: _this3.confirmPassword,
                  email: _this3.email,
                  givenName: _this3.givenName,
                  familyName: _this3.familyName,
                  position: _this3.position,
                  phoneNumber: _this3.phoneNumber,
                  roles: _this3.roleName,
                  companyProfileId: _this3.usercCompanyProfiles,
                  inActiveStatus: !_this3.inActiveStatus,
                  signImg: uploadedFile,
                  userSmlMappings: _this3.userSmlMappings
                }).then(function (response) {
                  if (response.data.status) {
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      $("#userCreateModal").modal("hide");
                    });
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[7, 19]]);
      }))();
    },

    LoadroleNameOptions: function LoadroleNameOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Roles/Options", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.roleNameOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadusercCompanyProfilesOptions: function LoadusercCompanyProfilesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/CompanyProfile/Options", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.usercCompanyProfilesOptions.push({
              id: element.id,
              label: element.text,
              data: element.data
            });
          });
        }
      }).catch(function (error) {});
    },
    handleBackButton: function handleBackButton(event) {
      var modalBackdrops = document.querySelectorAll('.modal-backdrop');
      modalBackdrops.forEach(function (modalBackdrop) {
        modalBackdrop.remove();
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this4;
              router = _this4.$router;
              _context2.next = 4;
              return _this4.$root.getUser();

            case 4:
              user = _context2.sent;

              self.LoadroleNameOptions();
              self.LoadusercCompanyProfilesOptions();
              window.addEventListener('popstate', _this4.handleBackButton);

              // set validation rules
              $("#userCreateModal form").validate({
                rules: {
                  userName: "required",
                  email: {
                    required: true,
                    email: true
                  },
                  password: {
                    required: true,
                    minlength: 6
                  },
                  confirmPassword: {
                    equalTo: "#password"
                  },
                  givenName: "required",
                  familyName: "required",
                  phoneNumber: "required"
                },
                messages: {
                  userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
                  email: {
                    required: "กรุณากรอกอีเมล",
                    email: "กรุณากรอกอีเมลให้ถูกต้อง"
                  },
                  password: {
                    required: "กรุณากรอกรหัสผ่าน",
                    minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร"
                  },
                  confirmPassword: {
                    equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง"
                  },
                  givenName: "กรุณากรอกชื่อ",
                  familyName: "กรุณากรอกชื่อสกุล",
                  phoneNumber: "กรุณากรอกเบอร์โทรศัพท์"
                }
              });

              // $("#userCreateModal #roleName")
              //   .select2({
              //     placeholder: "เลือกบทบาท",
              //     allowClear: true,
              //     ajax: {
              //       url: "/Api/Roles/Options",
              //       data: function(params) {
              //         var query = {
              //           search: params.term,
              //           page: params.page || 1
              //         };
              //         return query;
              //       },
              //       processResults: function(data, params) {
              //         return {
              //           results: data.results,
              //           pagination: {
              //             more: data.more
              //           }
              //         };
              //       },
              //       transport: function(params, success, failure) {
              //         params.beforeSend = function(request) {
              //           request.setRequestHeader(
              //             "Authorization",
              //             "Bearer " + self.$root.user.access_token
              //           );
              //         };
              //         var $request = $.ajax(params);
              //         $request.then(success);
              //         $request.fail(failure);
              //         return $request;
              //       }
              //     }
              //   })
              //   .change(function() {
              //     self.roleName = $(this).val();
              //   });

              // $("#userCreateModal #companyProfile")
              //   .select2({
              //     placeholder: "เลือกโปรไฟล์บริษัท",
              //     allowClear: true,
              //     ajax: {
              //       url: "/Api/CompanyProfile/Options",
              //       data: function(params) {
              //         var query = {
              //           search: params.term,
              //           page: params.page || 1
              //         };
              //         return query;
              //       },
              //       processResults: function(data, params) {
              //         return {
              //           results: data.results,
              //           pagination: {
              //             more: data.more
              //           }
              //         };
              //       },
              //       transport: function(params, success, failure) {
              //         params.beforeSend = function(request) {
              //           request.setRequestHeader(
              //             "Authorization",
              //             "Bearer " + self.$root.user.access_token
              //           );
              //         };
              //         var $request = $.ajax(params);
              //         $request.then(success);
              //         $request.fail(failure);
              //         return $request;
              //       }
              //     }
              //   })
              //   .change(function() {
              //     self.companyProfileId = $(this).val();
              //   });

              $("#userCreateModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              }).modal("show");

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  },

  watch: {
    usercCompanyProfiles: function usercCompanyProfiles() {
      var _this5 = this;

      this.selectedCompanyProfiles = this.usercCompanyProfilesOptions.filter(function (e, i) {
        return _this5.usercCompanyProfiles.findIndex(function (a) {
          return a === e.id;
        }) >= 0;
      });
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var UserActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"edit\" v-if=\"data.showEditButton\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <span class=\"dropdown\" v-if=\"data.showEditButton && data.openId == false\">\n        <a href=\"#\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" data-toggle=\"dropdown\" aria-expanded=\"true\" title=\"\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E2D\u0E37\u0E48\u0E19\u0E46\">\n          <i class=\"la la-ellipsis-h\"></i>\n        </a>\n        <div class=\"dropdown-menu dropdown-menu-right\">\n            <a class=\"dropdown-item\" href=\"#\" @click.prevent=\"changePassword\"><i class=\"la la-key\"></i> \u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19</a>\n            <a class=\"dropdown-item\" href=\"#\" @click.prevent=\"forgotPassword\"><i class=\"la la-envelope\"></i> \u0E2A\u0E48\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19</a>\n        </div>\n    </span>\n  </div>",
  methods: {
    edit: function edit() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/Master/Users/Edit/" + this.data.userName });
    },
    changePassword: function changePassword() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/Master/Users/ChangePassword/" + this.data.userName
      });
    },
    forgotPassword: function forgotPassword() {
      var _this = this;

      Swal.fire({
        title: "ส่งอีเมลรีเซ็ตรหัสผ่าน",
        html: "ระบบจะส่งลิ้งค์สำหรับรีเซ็ตรหัสผ่านของ <strong>" + this.data.userName + "</strong> ไปยังอีเมลข้างล่างนี้",
        input: "text",
        inputValue: this.data.email,
        inputAttributes: {
          autocapitalize: "off",
          placeholder: "อีเมลที่ใช้รับลิ้งค์สำหรับรีเซ็ตรหัสผ่าน"
        },
        inputValidator: function inputValidator(value) {
          if (!value) {
            return "กรุณากรอกอีเมลที่ใช้รับลิ้งค์สำหรับรีเซ็ตรหัสผ่าน";
          }

          var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!emailRegex.test(String(value).toLowerCase())) {
            return "คุณกรอกอีเมลไม่ถูกต้อง";
          }
        },
        showCancelButton: true,
        confirmButtonText: "ส่งอีเมล",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังส่งอีเมล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Users/ForgotPassword", {
            userName: _this.data.userName,
            email: result.value
          }).then(function (response) {
            if (response.data.status) {
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this2 = this;

      var self = this;
      var table = $("#userTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Users/" + _this2.data.userName + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this3 = this;

      var self = this;
      var table = $("#userTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/Users/" + _this3.data.userName + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    return {
      keyword: "",
      status: -1,
      inActiveStatus: null,
      roles: [],
      rolesOptions: [],
      //Configurations
      inActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      this.keyword = "";
      this.status = -1;

      this.roles = [];

      //default Active Data
      this.inActiveStatus = false;
      $("#inActiveStatus").val(this.inActiveStatus + "").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#userTable").DataTable();
      table.search(this.keyword);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#userTable").DataTable().ajax.reload(null, resetPaging);
    },
    LoadrolesOptions: function LoadrolesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Roles/Options", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rolesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, user, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this4;
              _context.next = 3;
              return _this4.$root.getUser();

            case 3:
              user = _context.sent;
              table = $("#userTable");


              self.LoadrolesOptions();

              //default Active Data
              self.inActiveStatus = false;
              $("#inActiveStatus").val(self.inActiveStatus + "").trigger("change");

              $.fn.dataTable.ext.errMode = 'none';
              // begin first table
              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,

                ajax: {
                  url: "/Api/Users/Find",
                  type: "post",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return $.extend({}, d, {
                      roles: self.roles,
                      inActiveStatus: $("#inActiveStatus").val()
                    });
                  }
                },

                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n      <'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[6, "desc"]],

                columns: [{ data: "userName" }, { data: "email" }, { data: "roles" }, { data: "fullName" }, { data: "phoneNumber", className: "text-center" }, { data: "position", className: "text-center" }, { data: "companyProfiles", width: "15%" }, {
                  data: "lastLogOnDateTime",
                  className: "text-center",
                  render: function render(data, type, row, meta) {
                    return row.lastLogOnDateTimeString;
                  }
                }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "userName",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow("MASTER_USER");
                    data.openId = data.openID;
                    new UserActions({ data: { data: data } }).$mount(el);
                  }
                });
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["MASTER_USER"]);
                    if (data.inActiveStatus == 0) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

              // $("#roles").select2({
              //   tags: true,
              //   placeholder: "เลือกบทบาท",
              //   allowClear: true,
              //   ajax: {
              //     url: "/Api/Roles/Options",
              //     data: function(params) {
              //       var query = {
              //         search: params.term,
              //         page: params.page || 1,
              //       };
              //       return query;
              //     },
              //     processResults: function(data, params) {
              //       return {
              //         results: data.results,
              //         pagination: {
              //           more: data.more,
              //         },
              //       };
              //     },
              //     transport: function(params, success, failure) {
              //       params.beforeSend = function(request) {
              //         request.setRequestHeader(
              //           "Authorization",
              //           "Bearer " + self.$root.user.access_token
              //         );
              //       };
              //       var $request = $.ajax(params);
              //       $request.then(success);
              //       $request.fail(failure);
              //       return $request;
              //     },
              //   },
              // });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    selectedCompanyProfiles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    userSmlMappings: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    agents: function agents() {
      var _this = this;

      var mappings = [];
      this.agents.forEach(function (agent) {
        var existed = false;
        _this.userSmlMappings.forEach(function (map) {
          if (map.mappingToAgentCode == agent.agentCode) {
            existed = true;
            mappings.push(map);
          }
        });
        if (!existed) {
          mappings.push({
            mappingToAgentCode: agent.agentCode,
            mappingToAgentName: agent.agentName,
            whCode: null,
            location1Code: null,
            location2Code: null
          });
        }
      });
      this.userSmlMappings = mappings;
      this.$emit("update:userSmlMappings", this.userSmlMappings);
    }
  },
  computed: {
    agents: function agents() {
      var profiles = this.selectedCompanyProfiles.map(function (o) {
        return { companyProfileTypeCode: o.data.companyProfileTypeCode, agentCode: o.data.agentCode, agentName: o.data.agentName };
      });

      return profiles.filter(function (e, i) {
        return e.companyProfileTypeCode === "COMPANY_PROFILE_TYPE_AGENT" && profiles.findIndex(function (a) {
          return a.agentCode === e.agentCode;
        }) === i;
      });
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgentProfileCreateForm__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_plupload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserSmlMapping_vue__ = __webpack_require__(106);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the styles



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    agentProfileCreateForm: __WEBPACK_IMPORTED_MODULE_0__AgentProfileCreateForm__["a" /* default */],
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a,
    userSmlMapping: __WEBPACK_IMPORTED_MODULE_6__UserSmlMapping_vue__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      userName: null,
      email: null,
      givenName: null,
      familyName: null,
      position: null,
      phoneNumber: null,
      roleName: [],
      lastLogOnDateTimeString: null,
      companyProfileId: null,
      inActiveStatus: true,
      FileUpload: null,
      companyProfile: [],
      companyProfileOptions: [],
      roleNameOptions: [],
      selectedCompanyProfiles: [],
      userSmlMappings: []
    };
  },
  methods: {
    handleImageError: function handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad: function handleImageLoad(image) {
      image.isLoaded = true;
    },
    removeImage: function removeImage(pictureId) {
      var _this = this;

      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then(function (result) {
        if (result.value) {
          _this.FileUpload = null;
          Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
        }
      });
    },
    uploadFile: function uploadFile() {
      var _this2 = this;

      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.multiple = false;
      input.click();

      input.addEventListener("change", function (event) {
        var file = event.target.files[0];
        if (file && ["image/jpeg", "image/jpg", "image/png"].includes(file.type) && file.size <= 10 * 1024 * 1024) {
          var reader = new FileReader();
          reader.onload = function (e) {
            _this2.FileUpload = {
              pictureId: Date.now().toString(),
              fileName: file.name,
              urlImg: e.target.result,
              fileDataContext: file,
              isNew: true,
              isLoaded: true
            };
          };
          reader.readAsDataURL(file);
        } else {
          alert("กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)");
        }
      });
    },
    onCompanyProfileChange: function onCompanyProfileChange(id, value, data, ref) {
      this.selectedCompanyProfiles = data;
    },

    showAgentProfileCreateForm: function showAgentProfileCreateForm() {
      $(this.$refs.agentProfileCreateForm.$el).modal("show");
    },
    formSubmit: function formSubmit(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tempCompanyProfile, uploadedFile, file, formData, uploadResponse, router;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                if ($("#userUpdateModal form").validate().form()) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", false);

              case 3:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                if (!Array.isArray(_this3.companyProfile) && _this3.companyProfile != null) {
                  tempCompanyProfile = _this3.companyProfile;

                  _this3.companyProfile = [];
                  _this3.companyProfile.push(tempCompanyProfile);
                }

                uploadedFile = null;

                if (!(_this3.FileUpload && _this3.FileUpload.isNew && _this3.FileUpload.fileDataContext)) {
                  _context.next = 24;
                  break;
                }

                _context.prev = 7;
                file = _this3.FileUpload;
                formData = new FormData();

                formData.append("File", file.fileDataContext);
                formData.append("IsMaster", true);
                formData.append("FolderName", "MasterUser");

                _context.next = 15;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 15:
                uploadResponse = _context.sent;


                uploadedFile = {
                  contentType: "-",
                  downloadUrl: uploadResponse.data.fileUrl,
                  fileInfoId: uploadResponse.data.fileInfoId,
                  fileName: uploadResponse.data.fileInfoId,
                  gridFsId: uploadResponse.data.gridFsId,
                  sysName: "-"
                };
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](7);

                console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", _context.t0);

              case 22:
                _context.next = 25;
                break;

              case 24:
                if (_this3.FileUpload && !_this3.FileUpload.isNew) {
                  uploadedFile = {
                    pictureId: _this3.FileUpload.pictureId,
                    downloadUrl: _this3.FileUpload.downloadUrl,
                    fileInfoId: _this3.FileUpload.fileInfoId,
                    fileName: _this3.FileUpload.fileInfoId,
                    gridFsId: _this3.FileUpload.gridFsId,
                    sysName: "-"
                  };
                }

              case 25:
                router = _this3.$router;

                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Users/Update", {
                  userName: _this3.userName,
                  email: _this3.email,
                  givenName: _this3.givenName,
                  familyName: _this3.familyName,
                  position: _this3.position,
                  phoneNumber: _this3.phoneNumber,
                  roles: _this3.roleName,
                  companyProfileId: _this3.companyProfile,
                  inActiveStatus: !_this3.inActiveStatus,
                  signImg: uploadedFile,
                  userSmlMappings: _this3.userSmlMappings
                }).then(function (response) {
                  if (response.data.status) {
                    Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                      $("#userUpdateModal").modal("hide");
                    });
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  // always executed
                  KTApp.unblockPage();
                });

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[7, 19]]);
      }))();
    },

    LoadcompanyProfileOptions: function LoadcompanyProfileOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/CompanyProfile/Options", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.companyProfileOptions.push({
              id: element.id,
              label: element.text,
              data: element.data
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadroleNameOptions: function LoadroleNameOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Roles/Options", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.roleNameOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this4;
              router = _this4.$router;
              _context2.next = 4;
              return _this4.$root.getUser();

            case 4:
              user = _context2.sent;

              self.LoadcompanyProfileOptions();
              self.LoadroleNameOptions();

              $.validator.addMethod("regex", function (value, element, regexp) {
                var re = new RegExp(regexp);
                return this.optional(element) || re.test(value);
              }, "Please check your input.");

              // set validation rules
              $("#userUpdateModal form").validate({
                rules: {
                  userName: "required",
                  email: {
                    required: true,
                    email: true
                  },
                  givenName: "required",
                  familyName: "required",
                  phoneNumber: "required"
                },
                messages: {
                  userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
                  email: {
                    required: "กรุณากรอกอีเมล",
                    email: "กรุณากรอกอีเมลให้ถูกต้อง"
                  },
                  givenName: "กรุณากรอกชื่อ",
                  familyName: "กรุณากรอกชื่อสกุล",
                  phoneNumber: "กรุณากรอกเบอร์โทรศัพท์"
                }
              });

              $("#userUpdateModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                self.$parent.reloadDataTable(false);
              });

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Users/" + _this4.$route.params.userId).then(function (response) {
                if (response.status == 200) {
                  self.userName = response.data.userName;
                  self.email = response.data.email;
                  self.phoneNumber = response.data.phoneNumber;
                  self.givenName = response.data.givenName;
                  self.familyName = response.data.familyName;
                  self.position = response.data.position;
                  self.lastLogOnDateTimeString = response.data.lastLogOnDateTimeString;
                  self.inActiveStatus = !response.data.inActiveStatus;

                  if (response.data.rolesSelect2) {
                    response.data.rolesSelect2.forEach(function (x) {
                      self.roleName.push(x.id);
                    });
                  } else {
                    if (response.data.roleName) self.roleName.push(response.data.roleName);
                  }

                  self.userSmlMappings = response.data.userSmlMappings;

                  if (response.data.companyProfiles) {
                    response.data.companyProfiles.forEach(function (x) {
                      self.companyProfile.push(x.companyProfileId);
                    });
                  }

                  if (response.data.signPic) {
                    var element = response.data.signPic;
                    self.FileUpload = {
                      pictureId: element.pictureId,
                      fileName: element.fileName,
                      fileInfoId: element.fileInfoId,
                      downloadUrl: element.downloadUrl,
                      urlImg: element.urlImg,
                      gridFsId: element.gridFsId,
                      sysName: element.sysName,
                      isNew: false,
                      isLoaded: true
                    };
                  }

                  $("#userUpdateModal").modal("show");
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสมาชิกที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสมาชิกได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  },

  watch: {
    companyProfile: function companyProfile() {
      var _this5 = this;

      this.selectedCompanyProfiles = this.companyProfileOptions.filter(function (e, i) {
        return _this5.companyProfile.findIndex(function (a) {
          return a === e.id;
        }) >= 0;
      });
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      CONFIRM_PHRASE: "DELETE",
      SOAK_MIN_DAYS: 7,
      isFirstRun: false,
      soakDays: null,
      config: {},
      queue: [],
      purgedRows: 0,
      cloudRows: 0,
      lastRun: null,
      lastStatus: null,
      lastJobName: null,

      maxObjects: null,
      sampleSize: 20,
      persist: false,

      isLoading: false,
      running: null,
      result: null,
      errorMessage: null,
      rawJson: "",
      showRaw: false,

      showTestTools: false,
      uploading: false,
      pickedCount: 0,
      uploaded: [],

      pending: null,
      confirmInput: "",

      actions: [{
        mode: "PREVIEW", endpoint: "Preview", title: "Preview", phase: "Phase 2",
        icon: "fas fa-search text-primary", tone: "safe", btn: "btn-primary",
        desc: "นับรูปที่เข้าเงื่อนไข + ดูตัวอย่าง ไม่แตะข้อมูลใด ๆ",
        risk: "ปลอดภัย 100% — ไม่เขียนอะไรเลย",
        confirm: false
      }, {
        mode: "MARK", endpoint: "Mark", title: "Mark", phase: "Phase 3",
        icon: "fas fa-eye-slash text-warning", tone: "warn", btn: "btn-warning",
        desc: "เข้าคิว + ซ่อนรูปในหน้า /PMReport/PM ทันที",
        risk: "ยังไม่ลบไฟล์ — rollback ได้ 100%",
        confirm: true, needPhrase: false,
        confirmText: "รูปจะหายจากหน้าจอทันที แต่ไฟล์บน GCS ยังอยู่ครบ · ย้อนกลับได้ตามขั้นตอน §6.11"
      }, {
        mode: "SWEEP", endpoint: "Sweep", title: "Sweep", phase: "Phase 4",
        icon: "fas fa-trash text-danger", tone: "danger", btn: "btn-danger",
        desc: "ลบไฟล์บน GCS ตามคิว PENDING / FAILED",
        risk: "🔴 ลบจริง กู้ไม่ได้",
        confirm: true, needPhrase: true,
        confirmText: "จะลบไฟล์บน GCS ตามคิวที่ค้างอยู่ (จำกัดด้วย MaxObjects)"
      }, {
        mode: "PURGE", endpoint: "Purge", title: "Purge (cron)", phase: "Phase 5",
        icon: "fas fa-clock text-danger", tone: "danger", btn: "btn-danger",
        desc: "เส้นเดียวกับที่ cron เรียก: Mark → Sweep → Housekeep",
        risk: "🔴 ลบจริง · เคารพ IsEnabled",
        confirm: true, needPhrase: true,
        confirmText: "จำลองการทำงานของ cronjob 02:00 ทั้งกระบวนการ — ถ้า IsEnabled = 0 จะ return ทันทีโดยไม่ทำอะไร"
      }]
    };
  },

  computed: {
    resultOk: function resultOk() {
      return this.errorMessage == null;
    },
    pendingCount: function pendingCount() {
      var q = this.queue.filter(function (x) {
        return x.status === "PENDING" || x.status === "FAILED";
      });
      return q.reduce(function (a, b) {
        return a + (b.count || 0);
      }, 0);
    },
    pathList: function pathList() {
      return this.uploaded.filter(function (u) {
        return u.ok;
      }).map(function (u) {
        return u.path;
      }).join(String.fromCharCode(10));
    }
  },
  mounted: function mounted() {
    this.loadStatus();
  },

  methods: {
    onPickFiles: function onPickFiles() {
      var f = this.$refs.testFiles;
      this.pickedCount = f && f.files ? f.files.length : 0;
    },
    uploadTestFiles: function uploadTestFiles() {
      var self = this;
      var input = self.$refs.testFiles;
      if (!input || !input.files || input.files.length === 0) return;
      var files = Array.prototype.slice.call(input.files);
      self.uploading = true;
      self.uploaded = [];

      // อัปโหลดทีละไฟล์ตามลำดับ — จำนวนน้อย ไม่ต้องขนาน
      var chain = Promise.resolve();
      files.forEach(function (f) {
        chain = chain.then(function () {
          var fd = new FormData();
          fd.append("file", f);
          return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/PMImageRetention/TestUpload", fd, {
            headers: { "Content-Type": "multipart/form-data" }
          }).then(function (res) {
            var d = res.data || {};
            self.uploaded.push({
              ok: d.status === "SUCCESS",
              path: d.fileInfoId,
              message: d.message
            });
          }).catch(function (e) {
            self.uploaded.push({
              ok: false,
              message: e.response && e.response.data && e.response.data.message || e.message
            });
          });
        });
      });

      chain.finally(function () {
        self.uploading = false;
        self.pickedCount = 0;
        if (input) input.value = "";
      });
    },
    copyPaths: function copyPaths() {
      var box = this.$refs.pathBox;
      if (!box) return;
      box.select();
      try {
        document.execCommand("copy");
      } catch (e) {/* เบราว์เซอร์ไม่รองรับ → ให้ copy เอง */}
    },
    loadStatus: function loadStatus() {
      var self = this;
      self.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/PMImageRetention/Status").then(function (res) {
        var d = res.data || {};
        self.config = d.config || {};
        self.queue = d.queue || [];
        self.purgedRows = d.purgedRows || 0;
        self.cloudRows = d.cloudRows || 0;
        self.lastRun = d.lastRun || null;
        self.lastStatus = d.lastStatus || null;
        self.lastJobName = d.lastJobName || null;
        self.isFirstRun = !!d.isFirstRun;
        self.soakDays = d.soakDays === undefined ? null : d.soakDays;
      }).catch(function (e) {
        console.error("load status fail", e);
      }).finally(function () {
        self.isLoading = false;
      });
    },

    // 🛡️ first-run guard — Purge ทำ Mark+Sweep รอบเดียว ห้ามใช้ตอนที่ยังไม่เคย mark อะไรเลย
    isBlocked: function isBlocked(action) {
      if (!action) return false;
      return action.mode === "PURGE" && this.isFirstRun;
    },
    trigger: function trigger(action) {
      if (this.isBlocked(action)) return;
      if (!action.confirm) {
        this.run(action);
        return;
      }
      this.confirmInput = "";
      this.pending = action;
    },
    run: function run(action) {
      var self = this;
      self.pending = null;
      self.running = action.mode;
      self.result = null;
      self.errorMessage = null;

      var params = {};
      if (self.maxObjects) params.maxObjects = self.maxObjects;
      if (action.mode === "PREVIEW") {
        params.persist = self.persist;
        params.sampleSize = self.sampleSize;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/PMImageRetention/" + action.endpoint, { params: params }).then(function (res) {
        var d = res.data || {};
        self.rawJson = JSON.stringify(d, null, 2);
        if (d.status === "FAILED") {
          self.errorMessage = d.message || "รันไม่สำเร็จ";
          self.result = { mode: action.mode, batchId: d.batchId };
        } else {
          self.result = d.result || { mode: action.mode };
        }
        self.loadStatus();
      }).catch(function (e) {
        self.errorMessage = e.response && e.response.data && e.response.data.message || e.message;
        self.result = { mode: action.mode };
        self.rawJson = JSON.stringify(e.response ? e.response.data : e.message, null, 2);
      }).finally(function () {
        self.running = null;
      });
    },
    queueBadgeClass: function queueBadgeClass(s) {
      if (s === "PENDING") return "badge-warning";
      if (s === "DELETED") return "badge-danger";
      if (s === "NOTFOUND") return "badge-secondary";
      if (s === "FAILED") return "badge-dark";
      if (s === "REVERTED") return "badge-info";
      if (s === "DRYRUN") return "badge-light";
      return "badge-success";
    },
    queueHint: function queueHint(s) {
      if (s === "PENDING") return "รอลบ";
      if (s === "DELETED") return "ลบแล้ว";
      if (s === "NOTFOUND") return "ไม่พบไฟล์ (ถือว่าสำเร็จ)";
      if (s === "FAILED") return "รอ retry";
      if (s === "SKIPPED_SHARED") return "มีคนอ้างอยู่ ไม่ลบ";
      if (s === "SKIPPED_PATH") return "path ไม่ผ่าน guard";
      if (s === "REVERTED") return "ยกเลิกถาวร";
      if (s === "DRYRUN") return "แถวจำลอง";
      return "";
    },
    fmt: function fmt(n) {
      if (n == null) return "-";
      return Number(n).toLocaleString();
    },
    formatDateTime: function formatDateTime(v) {
      if (!v) return "-";
      var d = new Date(v);
      return d.toLocaleDateString("th-TH") + " " + d.toLocaleTimeString("th-TH");
    },
    formatDate: function formatDate(v) {
      if (!v) return "-";
      return new Date(v).toLocaleDateString("th-TH");
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MonitoringHub",
  computed: {
    isHubRoute: function isHubRoute() {
      return this.$route.path.toLowerCase() === "/monitoring";
    }
  },
  data: function data() {
    return {
      cards: [{
        path: "/Monitoring/ScheduledJobs",
        icon: "fas fa-clock fa-3x text-primary",
        title: "Scheduled Jobs",
        description: "สถานะงาน cron/SQL ทั้งหมด + log history + toggle แจ้งเตือน"
      }, {
        path: "/Monitoring/SendEmailReportAgent",
        icon: "fas fa-envelope fa-3x text-info",
        title: "Send Email Report Agent",
        description: "ดู log + manual trigger การส่งอีเมลรายงานตัวแทน"
      }, {
        path: "/Monitoring/SCVD",
        icon: "fas fa-box-open fa-3x text-success",
        title: "Stock Cover Days",
        description: "รัน Backfill / Close Period ด้วยตนเอง + ดูสถานะ Period"
      }, {
        path: "/Monitoring/ClearImage",
        icon: "fas fa-images fa-3x text-warning",
        title: "Clear PM Image",
        description: "ลบรูปล้างเครื่อง PM บน GCS (เก็บ 12 รอบล่าสุด) — Preview / Mark / Sweep / Purge"
      }]
    };
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [],
      summary: {},
      filterGroup: "",
      filterIssue: "",
      filterActive: "active", // CR JobMonitor Phase 1 — default แสดงเฉพาะ job ที่เปิดใช้งาน
      isLoading: false,
      historyJob: null,
      history: [],
      isLoadingHistory: false,
      togglingJobs: {}, // {jobName: true} while toggling notify
      togglingActive: {} // {jobName: true} while toggling active
    };
  },

  computed: {
    availableGroups: function availableGroups() {
      var set = {};
      this.items.forEach(function (i) {
        if (i.jobGroup) set[i.jobGroup] = true;
      });
      return Object.keys(set).sort();
    },
    filteredItems: function filteredItems() {
      var self = this;
      return self.items.filter(function (i) {
        if (self.filterIssue && i.issue !== self.filterIssue) return false;
        return true;
      });
    }
  },
  mounted: function mounted() {
    this.loadStatus();
  },

  methods: {
    loadStatus: function loadStatus() {
      var self = this;
      var params = {};
      if (self.filterGroup) params.jobGroup = self.filterGroup;
      params.activeFilter = self.filterActive || "active";
      self.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Monitor/scheduled_jobs_status", { params: params }).then(function (response) {
        self.items = response.data.items || [];
        self.summary = response.data.summary || {};
      }).catch(function (error) {
        console.error("Failed to load scheduled jobs status:", error);
      }).finally(function () {
        self.isLoading = false;
      });
    },
    openHistory: function openHistory(item) {
      var self = this;
      self.historyJob = item.jobName;
      self.history = [];
      self.isLoadingHistory = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Monitor/scheduled_jobs_history", { params: { jobName: item.jobName, top: 50 } }).then(function (response) {
        self.history = response.data.rows || [];
      }).catch(function (error) {
        console.error("Failed to load history:", error);
      }).finally(function () {
        self.isLoadingHistory = false;
      });
    },
    statusBadgeClass: function statusBadgeClass(s) {
      if (s === "SUCCESS") return "badge-success";
      if (s === "FAILED") return "badge-danger";
      if (s === "PARTIAL") return "badge-warning";
      if (s === "RUNNING") return "badge-info";
      return "badge-light";
    },
    issueBadgeClass: function issueBadgeClass(s) {
      if (s === "OK") return "badge-success";
      if (s === "STALE") return "badge-warning";
      if (s === "FAILED") return "badge-danger";
      if (s === "STUCK") return "badge-dark";
      if (s === "NEVER_RAN") return "badge-secondary";
      return "badge-light";
    },
    formatDateTime: function formatDateTime(dateStr) {
      if (!dateStr) return "-";
      var d = new Date(dateStr);
      return d.toLocaleDateString("th-TH") + " " + d.toLocaleTimeString("th-TH");
    },
    isManageable: function isManageable(jobName) {
      // job ที่มีหน้าจัดการ/จำลอง trigger ของตัวเอง — เพิ่มชื่อได้เรื่อย ๆ
      return jobName === "Alert/SendEmailReportAgent" || jobName === "PMImageRetention/Purge";
    },
    formatCron: function formatCron(cron) {
      if (!cron) return "-";
      var parts = cron.trim().split(/\s+/);
      if (parts.length !== 5) return cron;
      var m = parts[0],
          h = parts[1],
          dom = parts[2],
          mon = parts[3],
          dow = parts[4];
      var pad = function pad(s) {
        return s.length === 1 ? "0" + s : s;
      };
      var timePart = "";
      if (/^\d+$/.test(h) && /^\d+$/.test(m)) {
        timePart = pad(h) + ":" + pad(m);
      } else {
        timePart = h + ":" + m;
      }
      // Daily
      if (dom === "*" && mon === "*" && dow === "*") {
        return "Daily " + timePart;
      }
      // Monthly last day
      if (dom === "L" && mon === "*" && dow === "*") {
        return "Monthly EOM " + timePart;
      }
      // Monthly specific day
      if (/^\d+$/.test(dom) && mon === "*" && dow === "*") {
        return "Monthly Day " + dom + " " + timePart;
      }
      // Weekly
      if (dom === "*" && mon === "*" && /^\d+$/.test(dow)) {
        var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        return "Weekly " + (days[parseInt(dow, 10)] || dow) + " " + timePart;
      }
      // Hourly (every hour)
      if (h === "*" && /^\d+$/.test(m)) {
        return "Hourly :" + pad(m);
      }
      return cron;
    },

    // CR JobMonitor Phase 1 — เปิด/ปิดการทำงานของ job
    toggleActive: function toggleActive(item, event) {
      var self = this;
      var newValue = event.target.checked;
      var label = newValue ? "เปิดใช้งาน" : "ปิดการทำงาน";

      if (!window.confirm(label + " job \"" + item.jobName + "\" ?")) {
        event.target.checked = !newValue;
        return;
      }

      self.$set(self.togglingActive, item.jobName, true);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Monitor/scheduled_jobs_toggle_active", null, {
        params: { jobName: item.jobName, isActive: newValue }
      }).then(function () {
        item.isActive = newValue;
        // ถ้ากำลังกรองอยู่ แถวนี้อาจต้องหายไป จึงโหลดใหม่
        if (self.filterActive !== "all") self.loadStatus();
      }).catch(function (e) {
        console.error("toggle active fail", e);
        event.target.checked = !newValue; // revert
      }).then(function () {
        self.$set(self.togglingActive, item.jobName, false);
      });
    },
    toggleNotify: function toggleNotify(item, event) {
      var self = this;
      var newValue = event.target.checked;
      // optimistic update
      self.$set(self.togglingJobs, item.jobName, true);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Monitor/scheduled_jobs_toggle_notify", null, {
        params: { jobName: item.jobName, isNotify: newValue }
      }).then(function () {
        item.isNotify = newValue;
      }).catch(function (e) {
        console.error("toggle notify fail", e);
        // revert checkbox if API failed
        event.target.checked = !newValue;
      }).finally(function () {
        self.$set(self.togglingJobs, item.jobName, false);
      });
    },
    onRowClick: function onRowClick(item) {
      if (!this.isManageable(item.jobName)) return;
      if (item.jobName === "Alert/SendEmailReportAgent") {
        this.$router.push("/Monitoring/SendEmailReportAgent");
      } else if (item.jobName === "PMImageRetention/Purge") {
        this.$router.push("/Monitoring/ClearImage");
      }
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MonitoringScvd",
  data: function data() {
    var now = new Date();
    var prev = new Date(now.getFullYear(), now.getMonth() - 1, 1); // last completed month
    return {
      bf: { fromYear: 2025, fromMonth: 1, toYear: prev.getFullYear(), toMonth: prev.getMonth() + 1, force: false, running: false },
      cp: { year: prev.getFullYear(), month: prev.getMonth() + 1, force: false, running: false },
      periods: [],
      periodYear: now.getFullYear(),
      loading: false
    };
  },

  computed: {
    yearOptions: function yearOptions() {
      var y = new Date().getFullYear();
      return [y + 1, y, y - 1, y - 2];
    }
  },
  mounted: function mounted() {
    this.loadPeriods();
  },

  methods: {
    fmtDate: function fmtDate(d) {
      if (!d) return "-";
      try {
        return new Date(d).toLocaleString("th-TH");
      } catch (e) {
        return d;
      }
    },
    validMonth: function validMonth(m) {
      return Number.isInteger(m) && m >= 1 && m <= 12;
    },
    loadPeriods: function loadPeriods() {
      var _this = this;

      this.loading = true;
      var params = {};
      if (this.periodYear) params.year = this.periodYear;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Monitor/scvd_periods", { params: params }).then(function (res) {
        _this.periods = res.data && res.data.items || [];
      }).catch(function (err) {
        if (err.response && err.response.status === 403) {
          _this.$router.push("/");return;
        }
        console.error("loadPeriods", err);
      }).finally(function () {
        _this.loading = false;
      });
    },
    runBackfill: function runBackfill() {
      var b = this.bf;
      if (!b.fromYear || !b.toYear || !this.validMonth(b.fromMonth) || !this.validMonth(b.toMonth)) {
        Swal.fire("ข้อมูลไม่ครบ", "กรอกปี/เดือน (1-12) ให้ครบ", "warning");
        return;
      }
      var self = this;
      Swal.fire({
        title: "ยืนยันรัน Backfill",
        html: "ช่วง <b>" + b.fromYear + "-" + b.fromMonth + "</b> ถึง <b>" + b.toYear + "-" + b.toMonth + "</b>" + (b.force ? "<br><span style='color:#c0392b'>force = ON → ทับเดือนที่ปิดแล้ว (คำนวณใหม่)</span>" : ""),
        icon: "question", showCancelButton: true, confirmButtonText: "รัน", cancelButtonText: "ยกเลิก"
      }).then(function (r) {
        if (!r.value) return;
        self.bf.running = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Monitor/scvd_backfill", null, {
          params: { fromYear: b.fromYear, fromMonth: b.fromMonth, toYear: b.toYear, toMonth: b.toMonth, force: b.force }
        }).then(function (res) {
          var d = res.data || {};
          if (d.status === "SUCCESS") {
            var x = d.result || {};
            Swal.fire("สำเร็จ", "ปิด " + (x.monthsClosed || 0) + " · ข้าม " + (x.monthsSkipped || 0) + " · guard " + (x.monthsGuarded || 0) + " · rows " + (x.totalRows || 0), "success");
            self.loadPeriods();
          } else if (d.status === "FORBIDDEN") {
            self.$router.push("/");
          } else {
            Swal.fire("ไม่สำเร็จ", d.result && d.result.message || d.message || "error", "error");
          }
        }).catch(function (err) {
          if (err.response && err.response.status === 403) {
            self.$router.push("/");return;
          }
          Swal.fire("เกิดข้อผิดพลาด", err.response && err.response.data && err.response.data.message || err.message, "error");
        }).finally(function () {
          self.bf.running = false;
        });
      });
    },
    runClose: function runClose() {
      var c = this.cp;
      if (!c.year || !this.validMonth(c.month)) {
        Swal.fire("ข้อมูลไม่ครบ", "กรอกปี/เดือน (1-12) ให้ครบ", "warning");
        return;
      }
      var self = this;
      Swal.fire({
        title: "ยืนยันปิดรอบ",
        html: "เดือน <b>" + c.year + "-" + c.month + "</b>" + (c.force ? "<br><span style='color:#c0392b'>force = ON → ทับถ้าปิดแล้ว</span>" : ""),
        icon: "question", showCancelButton: true, confirmButtonText: "ปิดรอบ", cancelButtonText: "ยกเลิก"
      }).then(function (r) {
        if (!r.value) return;
        self.cp.running = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Monitor/scvd_close_period", null, {
          params: { year: c.year, month: c.month, force: c.force }
        }).then(function (res) {
          var d = res.data || {};
          if (d.status === "SUCCESS") {
            var x = d.result || {};
            Swal.fire(x.skipped ? "ข้าม (ปิดอยู่แล้ว)" : "สำเร็จ", x.message || "ปิดรอบสำเร็จ", x.skipped ? "info" : "success");
            self.loadPeriods();
          } else if (d.status === "FORBIDDEN") {
            self.$router.push("/");
          } else {
            Swal.fire("ไม่สำเร็จ", d.result && d.result.message || d.message || "error", "error");
          }
        }).catch(function (err) {
          if (err.response && err.response.status === 403) {
            self.$router.push("/");return;
          }
          Swal.fire("เกิดข้อผิดพลาด", err.response && err.response.data && err.response.data.message || err.message, "error");
        }).finally(function () {
          self.cp.running = false;
        });
      });
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(141);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */] },
  data: function data() {
    return {
      datePickerFormat: "dd/MM/yyyy",
      periodDate: null,
      sendMode: "all",
      selectedAgent: "",
      agents: [],
      isLoadingAgents: false,
      isSending: false,
      sendResult: null,
      disabledDates: { from: new Date() }, // ห้ามเลือกอนาคต
      batchHistory: [],
      isLoadingBatch: false,
      perAgentRows: [],
      perAgentFilter: "",
      isLoadingPerAgent: false
    };
  },

  computed: {
    periodYmd: function periodYmd() {
      if (!this.periodDate) return "";
      var d = new Date(this.periodDate);
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, "0");
      var day = String(d.getDate()).padStart(2, "0");
      return y + m + day;
    },
    canSend: function canSend() {
      if (!this.periodYmd) return false;
      if (this.sendMode === "single" && !this.selectedAgent) return false;
      return true;
    },
    sendResultClass: function sendResultClass() {
      if (!this.sendResult) return "";
      return this.sendResult.ok ? "alert-success" : "alert-danger";
    },
    sendResultLabel: function sendResultLabel() {
      if (!this.sendResult) return "";
      return this.sendResult.ok ? "✓ ส่งเสร็จสิ้น" : "✗ ส่งไม่สำเร็จ";
    },
    sendResultMessage: function sendResultMessage() {
      return this.sendResult ? this.sendResult.message : "";
    }
  },
  mounted: function mounted() {
    this.loadAgents();
    this.loadBatchHistory();
    this.loadPerAgent();
  },

  methods: {
    loadAgents: function loadAgents() {
      var self = this;
      self.isLoadingAgents = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Alert/agents").then(function (r) {
        self.agents = r.data.items || [];
      }).catch(function (e) {
        console.error("agents load fail", e);
      }).finally(function () {
        self.isLoadingAgents = false;
      });
    },
    loadBatchHistory: function loadBatchHistory() {
      var self = this;
      self.isLoadingBatch = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Monitor/scheduled_jobs_history", { params: { jobName: "Alert/SendEmailReportAgent", top: 50 } }).then(function (r) {
        self.batchHistory = r.data.rows || [];
      }).catch(function (e) {
        console.error("batch history fail", e);
      }).finally(function () {
        self.isLoadingBatch = false;
      });
    },
    loadPerAgent: function loadPerAgent() {
      var self = this;
      var params = {};
      if (self.perAgentFilter) params.dataperiod = self.perAgentFilter;
      self.isLoadingPerAgent = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Alert/emailreport_per_agent_history", { params: params }).then(function (r) {
        self.perAgentRows = r.data.items || [];
      }).catch(function (e) {
        console.error("per-agent fail", e);
      }).finally(function () {
        self.isLoadingPerAgent = false;
      });
    },
    onSend: function onSend() {
      var self = this;
      if (!self.canSend) return;
      self.isSending = true;
      self.sendResult = null;

      var params = { dataperiod: self.periodYmd };
      if (self.sendMode === "single") params.agent = self.selectedAgent;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Alert/SendEmailReportAgent", { params: params }).then(function (r) {
        self.sendResult = { ok: true, message: r.data };
        // reload history
        self.loadBatchHistory();
        self.loadPerAgent();
      }).catch(function (e) {
        var data = e.response && e.response.data || {};
        var msg = data.error || data.message || e.message;
        self.sendResult = { ok: false, message: msg };
      }).finally(function () {
        self.isSending = false;
      });
    },
    statusBadgeClass: function statusBadgeClass(s) {
      if (s === "SUCCESS") return "badge-success";
      if (s === "FAILED") return "badge-danger";
      if (s === "PARTIAL") return "badge-warning";
      if (s === "RUNNING") return "badge-info";
      return "badge-light";
    },
    formatDateTime: function formatDateTime(dateStr) {
      if (!dateStr) return "-";
      var d = new Date(dateStr);
      return d.toLocaleDateString("th-TH") + " " + d.toLocaleTimeString("th-TH");
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;

    var is_super_admin = self.$root.canShow(["super_admin"]) || self.$root.canShow(["ADMIN_PM"]);
    var is_agent_admin_pm = self.$root.canShow(["AGENT_ADMIN_PM"]);
    var is_sub_agent_admin_pm = self.$root.canShow(["SUB_AGENT_ADMIN_PM"]);

    return {
      apmrTypeCode: null,
      apmrDate: null,
      apmrAgentCode: null,
      apmrSubAgentCode: null,
      apmrShopCodes: [],
      apmrSubShopCodes: [],
      apmrRouteName: null,
      apmrPmUserId: null,
      apmrInActiveStatus: true,
      apmrAgentTypeCode: is_agent_admin_pm ? "AGENT" : "SUB_AGENT",
      isEdit: false,
      IS_RADIO_SHOW_AGENT: is_agent_admin_pm || is_super_admin ? true : false,
      IS_RADIO_SHOW_SUB_AGENT: is_super_admin || is_sub_agent_admin_pm ? true : false,

      // Configurations
      apmrTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "PM_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      apmrAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              agentCodes: []
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      apmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      apmrSubShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,

        ajax: {
          url: "/Api/Shop/SubShopOptionAlertReport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              shopCodes: self.apmrSubAgentCode != null ? [self.apmrSubAgentCode] : null,
              search: params.term,
              page: params.page || 1,
              all: true
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      apmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              agentCodes: null, //self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      apmrPmUserIdOptions: {
        placeholder: "กรุณาเลือกผู้ดำเนินการ",
        allowClear: true,
        ajax: {
          url: "/Api/PM/Select2PmUser",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {

            var query = {
              agentTypeCode: self.apmrAgentTypeCode,
              agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              subAgentCodes: self.apmrSubAgentCode != null ? [self.apmrSubAgentCode] : null,
              IS_SUPER_ADMIN: self.$root.canShow(["super_admin"]),
              IS_AGENT_ADMIN_PM: self.$root.canShowExSuperAdmin(["AGENT_ADMIN_PM"]),
              IS_SUB_AGENT_ADMIN_PM: self.$root.canShowExSuperAdmin(["SUB_AGENT_ADMIN_PM"]),
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/PM/RoutePlan/Add", {
        AgentCode: this.apmrAgentCode,
        TypeCode: this.apmrTypeCode,
        RoutePlanDate: this.apmrDate.format("DD/MM/YYYY"),
        ShopCodes: this.apmrShopCodes,
        RouteName: this.apmrRouteName,
        PmUserId: this.apmrPmUserId,
        InActiveStatus: !this.apmrInActiveStatus,

        SubAgentCode: this.apmrSubAgentCode,
        SubAgentShopCodes: this.apmrSubShopCodes,
        AgentTypeCode: this.apmrAgentTypeCode
      }).then(function (response) {
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          //console.log(response);
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onApmrTypeCodeChange: function onApmrTypeCodeChange(id, text, data, ref) {
      var self = this;
      if (text != "") {
        if (text == "PM_TYPE_ADHOC") {
          self.apmrDate = moment();
          self.isEdit = true;
        } else if (text == "PM_TYPE_ROUTE_PLAN") {
          self.apmrDate = moment().add(1, "days");
          self.isEdit = false;
        }

        $(self.$refs.apmrDate).datepicker("setStartDate", self.apmrDate.format("DD/MM/YYYY")).datepicker("update", !!self.apmrDate ? self.apmrDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
          self.apmrDate = e.dates.length != 0 ? moment(e.date) : null;
        });
      }
    },
    onApmrAgentTypeCodeChange: function onApmrAgentTypeCodeChange(obj) {

      var self = this;

      this.apmrAgentCode = null;
      $("#apmrAgentCode").val("").trigger("change");

      this.apmrShopCodes = [];
      $("#apmrShopCodes").val("").trigger("change");

      this.apmrSubAgentCode = [];
      $("#apmrSubAgentCode").val("").trigger("change");

      this.apmrSubShopCodes = null;
      $("#apmrSubShopCodes").val("").trigger("change");
    },
    onApmrAgentCodeChange: function onApmrAgentCodeChange() {

      this.apmrShopCodes = [];
      $("#apmrShopCodes").val("").trigger("change");

      this.apmrPmUserId = null;
      $("#apmrPmUserId").val("").trigger("change");

      // this.apmrSubAgentCode = []; 
      // $("#apmrSubAgentCode")
      // .val("")
      // .trigger("change");

    },

    onApmrSubAgentCodeChange: function onApmrSubAgentCodeChange(id, text, data, ref) {

      var self = this;
      if (data[0] != undefined) {
        this.apmrAgentCode = data[0].data;
      }
      // this.apmrShopCodes = [];  
      // $("#apmrShopCodes")
      //   .val("")
      //   .trigger("change"); 

      this.apmrPmUserId = null;
      $("#apmrPmUserId").val("").trigger("change");

      this.apmrSubShopCodes = [];
      $("#apmrSubShopCodes").val("").trigger("change");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.apmrDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                startDate: moment().format("DD/MM/YYYY"), // Current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.apmrDate).datepicker("update", !!self.apmrDate ? self.apmrDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.apmrDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  apmrTypeCode: "required",
                  apmrDate: "required",
                  apmrAgentCode: "required",
                  apmrShopCodes: "required",
                  apmrRouteName: "required",
                  apmrPmUserId: "required",
                  apmrSubAgentCode: "required",
                  apmrSubShopCodes: "required"
                },
                messages: {
                  apmrTypeCode: "กรุณาเลือกประเภท",
                  apmrDate: "กรุณาเลือกวันที่",
                  apmrAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
                  apmrShopCodes: "กรุณาเลือกร้านค้า",
                  apmrSubAgentCode: "กรุณาเลือกตัวแทนจำหน่ายย่อย",
                  apmrSubShopCodes: "กรุณาเลือกร้านค้า",
                  apmrRouteName: "กรุณากรอกชื่อรูท",
                  apmrPmUserId: "กรุณาเลือกผู้ดำเนินการ"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      barcodeShopMappings: [],
      modalImageURL: '',
      shopName: null,
      shopName2: null,
      checkInDate: null,
      checkOutDate: null, // CR-PM-2026 Req 2
      checkInByUserFullName: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/PM/CheckIn/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  console.log(response.data);
                  self.checkInByUserFullName = response.data.checkInByUserFullName;
                  self.checkInDate = response.data.checkInDateFormat;
                  self.checkOutDate = response.data.quitShopDateFormat || ''; // CR-PM-2026 Req 2
                  self.shopName = response.data.agentTypeCode == "AGENT" ? response.data.shopName : response.data.subAgentShopName;
                  self.shopName2 = response.data.agentTypeCode == "AGENT" ? response.data.shopName2 : response.data.subAgentShopName2;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล Check-In ร้านค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูล Check-In ร้านค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/PM/BarcodeMapping/GetAll?ShopId=" + _this.$route.params.id2 + "&PMCheckInId=" + _this.$route.params.id + "&SubAgentShopId=" + _this.$route.params.id3).then(function (response) {

                // console.log(response.data.data );

                if (response.status == 200) {
                  //console.log(response.data.data.length);

                  if (response.data != null && response.data.data.length > 0) {
                    var _loop = function _loop() {
                      var el = response.data.data[i];

                      //loop barCodeSet
                      var barcodeSets = [];
                      if (el.barCodeSet != null && el.barCodeSet.length > 0) {
                        el.barCodeSet.forEach(function (el2) {
                          //loop brand
                          var brand = "";
                          if (el2.brand != null && el2.brand.length > 0) {
                            el2.brand.forEach(function (el3) {
                              if (brand != "") brand += ", ";

                              // brand += "[" + el3.brandId + "] " + el3.brandName;
                              brand += el3.brandName;
                            });
                          }

                          barcodeSets.push({
                            barcodeId: el2.barcodeId,
                            barcodeNo: el2.barcodeNo,
                            barcodeNoOld: el2.barcodeNoOld,
                            barcodeType: el2.barcodeType,
                            barcodeSubTypeName: el2.barcodeSubTypeName,
                            isBarButler: el2.isBarButler,
                            isCoolRoom: el2.isCoolRoom,
                            isPersonalDispenser: el2.isPersonalDispenser,
                            nfcCode: el2.nfcCode,
                            productId: el2.productId,
                            productName: el2.productName,
                            brand: brand,
                            fileUrl: el2.fileUrl,
                            isImgCloud: el2.isImgCloud != null && el2.isImgCloud != undefined ? el2.isImgCloud : false
                          });
                        });

                        // console.log(barcodeSets)
                        // console.log('>>>>>>>>');
                        console.log(el);
                        // console.log('<<<<<<<<<<>>>>>>>>>>>>>>>>>>');

                        self.barcodeShopMappings.push({
                          barcodeShopMappingId: el.barcodeShopMappingId,
                          barcodeSets: barcodeSets,
                          isPM: el.isPM,
                          isMT: el.isMT,
                          indexDisplay: el.indexDisplay,
                          deleteReason: el.deleteReason,
                          isDelete: el.isDelete,
                          remark: el.remark,
                          showRemark: el.subIndex == 1 || el.subIndex == 0 ? true : false
                        });
                      }
                    };

                    for (var i = 0; i < response.data.data.length; i++) {
                      _loop();
                    }
                  }
                  console.log(self.barcodeShopMappings);
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล Check-In ร้านค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูล Check-In ร้านค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    showModal: function showModal(imageURL) {

      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', function () {
        $('body').addClass('modal-open');
      });
    },
    closeModal: function closeModal() {
      $('#imageModal').modal('hide');
    },
    barcodeTypeText: function barcodeTypeText(barcodeType, barcodeSubTypeName) {
      if (barcodeType == "BARCODE_TYPE_COOL_ROOM") return "ห้อง Cool Room";else if (barcodeType == "BARCODE_TYPE_DISPENSER") return "หัวจ่าย";else if (barcodeType == "BARCODE_TYPE_REGULATOR_JUMP") return barcodeSubTypeName;else if (barcodeType == "BARCODE_TYPE_REGULATOR") return barcodeSubTypeName;else if (barcodeType == "BARCODE_TYPE_MACHINE") return "เครื่องเบียร์สด";else if (barcodeType == "BARCODE_TYPE_PERSONAL_DISPENSER") return "หัวจ่ายส่วนบุคคล";
    },
    detailPM: function detailPM(barcodeShopMappingId) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/PM/PMCheckIn/" + this.$route.params.id + "/PMDetail/" + barcodeShopMappingId
      });
    },
    detailMT: function detailMT(barcodeShopMappingId) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/PM/PMCheckIn/" + this.$route.params.id + "/MTDetail/" + barcodeShopMappingId
      });
    },
    pictureModal: function pictureModal(fileUrl) {
      var router = this.$router;
      var url = "/PM/PMCheckIn/" + this.$route.params.id + "/BarcodeMappingDetail/" + this.$route.params.id2 + "/" + this.$route.params.id3 + "/Picture/" + encodeURIComponent(fileUrl);
      if (fileUrl != null) {
        router.push({
          path: url
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาคลิก Link", "error");
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;

    var is_super_admin = self.$root.canShow(["super_admin"]) || self.$root.canShow(["ADMIN_PM"]);
    var is_agent_admin_pm = self.$root.canShow(["AGENT_ADMIN_PM"]);
    var is_sub_agent_admin_pm = self.$root.canShow(["SUB_AGENT_ADMIN_PM"]);

    return {
      epmrPMRoutePlanId: null,
      epmrTypeCode: null,
      epmrDate: null,
      epmrAgentCode: null,
      epmrShopCodes: [],
      epmrRouteName: null,
      epmrPmUserId: null,
      epmrInActiveStatus: null,
      isEdit: false,

      epmrSubAgentCode: null,
      epmrSubShopCodes: [],
      epmrAgentTypeCode: is_agent_admin_pm ? "AGENT" : "SUB_AGENT",
      IS_RADIO_SHOW_AGENT: is_agent_admin_pm || is_super_admin ? true : false,
      IS_RADIO_SHOW_SUB_AGENT: is_super_admin || is_sub_agent_admin_pm ? true : false,

      // Configurations
      epmrTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "PM_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      epmrAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              agentCodes: []
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      epmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              agentCodes: self.epmrAgentCode != null ? [self.epmrAgentCode] : null,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      epmrSubShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,

        ajax: {
          url: "/Api/Shop/SubShopOptionAlertReport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              agentCodes: self.epmrAgentCode != null ? [self.epmrAgentCode] : null,
              shopCodes: self.epmrSubAgentCode != null ? [self.epmrSubAgentCode] : null,
              search: params.term,
              page: params.page || 1,
              all: true
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      epmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              agentCodes: null, //self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      epmrPmUserIdOptions: {
        placeholder: "กรุณาเลือกผู้ดำเนินการ",
        allowClear: true,
        ajax: {
          url: "/Api/PM/Select2PmUser",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              //agentCodes: self.epmrAgentCode != null ? [self.epmrAgentCode] : null,
              agentTypeCode: self.epmrAgentTypeCode,
              agentCodes: self.epmrAgentCode != null ? [self.epmrAgentCode] : null,
              subAgentCodes: self.epmrSubAgentCode != null ? [self.epmrSubAgentCode] : null,
              IS_SUPER_ADMIN: self.$root.canShow(["super_admin"]),
              IS_AGENT_ADMIN_PM: self.$root.canShowExSuperAdmin(["AGENT_ADMIN_PM"]),
              IS_SUB_AGENT_ADMIN_PM: self.$root.canShowExSuperAdmin(["SUB_AGENT_ADMIN_PM"]),
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = this.$router;
      var self = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/PM/RoutePlan/Edit", {
        PMRoutePlanId: this.epmrPMRoutePlanId,
        AgentCode: this.epmrAgentCode,
        TypeCode: this.epmrTypeCode,
        RoutePlanDate: this.epmrDate.format("DD/MM/YYYY"),
        ShopCodes: this.epmrShopCodes,
        RouteName: this.epmrRouteName,
        PmUserId: this.epmrPmUserId,
        InActiveStatus: !this.epmrInActiveStatus,

        SubAgentCode: this.epmrSubAgentCode,
        SubAgentShopCodes: this.epmrSubShopCodes,
        AgentTypeCode: this.epmrAgentTypeCode
      }).then(function (response) {
        console.log(response);
        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    onEpmrTypeCodeChange: function onEpmrTypeCodeChange(id, text, data, ref) {
      var self = this;
      if (text != "") {
        if (text == "PM_TYPE_ADHOC") {
          self.epmrDate = moment();
          self.isEdit = true;
        } else if (text == "PM_TYPE_ROUTE_PLAN") {
          self.epmrDate = moment().add(1, "days");
          self.isEdit = false;
        }

        $(self.$refs.epmrDate).datepicker("update", !!self.epmrDate ? self.epmrDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
          self.epmrDate = e.dates.length != 0 ? moment(e.date) : null;
        });
      }
    },
    onEpmrAgentCodeChange: function onEpmrAgentCodeChange() {
      this.epmrShopCodes = [];

      $("#epmrShopCodes").val("").trigger("change");

      this.epmrPmUserId = null;

      $("#epmrPmUserId").val("").trigger("change");

      //   this.epmrSubAgentCode = []; 
      // $("#epmrSubAgentCode")
      // .val("")
      // .trigger("change");
    },

    onEpmrAgentTypeCodeChange: function onEpmrAgentTypeCodeChange(obj) {

      var self = this;

      this.epmrAgentCode = null;
      $("#epmrAgentCode").val("").trigger("change");

      this.epmrShopCodes = [];
      $("#epmrShopCodes").val("").trigger("change");

      this.epmrSubAgentCode = [];
      $("#epmrSubAgentCode").val("").trigger("change");

      this.epmrSubShopCodes = null;
      $("#epmrSubShopCodes").val("").trigger("change");
    },
    onEpmrSubAgentCodeChange: function onEpmrSubAgentCodeChange(id, text, data, ref) {
      var self = this;
      if (data[0] != undefined) {
        this.epmrAgentCode = data[0].data;
      }
      // this.epmrShopCodes = [];  
      // $("#epmrShopCodes")
      //   .val("")
      //   .trigger("change"); 

      this.epmrPmUserId = null;
      $("#epmrPmUserId").val("").trigger("change");

      this.epmrSubShopCodes = [];
      $("#epmrSubShopCodes").val("").trigger("change");
    },
    onDateClick: function onDateClick() {
      var self = this;
      var epmrDate = self.epmrDate;
      if (epmrDate != null) {
        var today = moment();
        var startDate = today < epmrDate ? today : epmrDate;
        $(self.$refs.epmrDate).datepicker("setStartDate", startDate.format("DD/MM/YYYY"));
      } else {
        $(self.$refs.epmrDate).datepicker("setStartDate", moment().format("DD/MM/YYYY"));
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.epmrDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.epmrDate).datepicker("update", !!self.epmrDate ? self.epmrDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.epmrDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  epmrTypeCode: "required",
                  epmrDate: "required",
                  epmrAgentCode: "required",
                  epmrShopCodes: "required",
                  epmrRouteName: "required",
                  epmrPmUserId: "required",
                  epmrSubAgentCode: "required",
                  epmrSubShopCodes: "required"
                },
                messages: {
                  epmrTypeCode: "กรุณาเลือกประเภท",
                  epmrDate: "กรุณาเลือกวันที่",
                  epmrAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
                  epmrShopCodes: "กรุณาเลือกประเภทร้านค้า",
                  epmrSubAgentCode: "กรุณาเลือกตัวแทนจำหน่ายย่อย",
                  epmrSubShopCodes: "กรุณาเลือกร้านค้า",
                  epmrRouteName: "กรุณากรอกชื่อรูท",
                  epmrPmUserId: "กรุณาเลือกผู้ดำเนินการ"

                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/PM/RoutePlan/" + _this.$route.params.id).then(function (response) {
                console.log(response);
                if (response.status == 200) {
                  self.epmrPMRoutePlanId = response.data.pmRoutePlanId;
                  self.epmrInActiveStatus = !response.data.inActiveStatus;
                  self.epmrRouteName = response.data.routeName;

                  //self.epmrSubAgentCode = response.data.subAgentCode;
                  //self.epmrSubShopCodes = response.data.routeName;
                  self.epmrAgentTypeCode = response.data.agentTypeCode;

                  if (response.data.typeCode) {
                    self.$refs.epmrTypeCodeSelect2.setSelectedData({
                      id: response.data.typeCode,
                      text: response.data.typeName
                    });
                  }

                  setTimeout(function () {
                    self.epmrAgentCode = response.data.agentCode;
                  }, 100);

                  if (response.data.subAgentCode) {
                    self.$refs.epmrSubAgentCodeSelect2.setSelectedData({
                      id: response.data.subAgentCode,
                      text: "[" + response.data.subAgentCustCode + "] " + response.data.subAgentName + " (" + response.data.agentName + ")"
                    });
                  }
                  setTimeout(function () {
                    // console.log('-------x-----');
                    // console.log(response.data);
                    // console.log(obj);

                    if (response.data.pmRoutePlanShops) {
                      var subAgentShopOptions = $.map(response.data.pmRoutePlanShops, function (obj, idx) {
                        return {
                          id: obj.subAgentShopCode,
                          text: obj.subAgentShopName
                        };
                      });
                      self.$refs.epmrSubShopCodesSelect2.setSelectedData(subAgentShopOptions);
                    }
                  }, 100);
                  ///

                  if (response.data.agentCode) {
                    self.$refs.epmrAgentCodeSelect2.setSelectedData({
                      id: response.data.agentCode,
                      text: response.data.agentName
                    });
                  }

                  setTimeout(function () {
                    if (response.data.pmRoutePlanShops) {
                      var shopOptions = $.map(response.data.pmRoutePlanShops, function (obj, idx) {
                        return {
                          id: obj.shopCode,
                          text: obj.shopName
                        };
                      });
                      self.$refs.epmrShopCodesSelect2.setSelectedData(shopOptions);
                    }

                    if (response.data.pmUserId) {
                      self.$refs.epmrPmUserIdSelect2.setSelectedData({
                        id: response.data.pmUserId,
                        text: response.data.pmUserName
                      });
                    }

                    self.epmrDate = moment(response.data.routePlanDateFormat, "DD/MM/YYYY");
                    $(self.$refs.epmrDate).datepicker("update", response.data.routePlanDateFormat2);
                  }, 100);
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล Route Plan/Adhoc ที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูล Route Plan/Adhoc ได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      createUser: null,
      mtDate: null,
      signatureFileUrl: null,
      barcodeShopMappingId: null,
      resolve: null,
      failureMachineOther: null,
      failureMachineReasonOther: null,
      failureMachineCodes: [],
      failureMachineReasonCodes: [],
      //
      pmStartDate: null,
      pmEndDate: null,
      diffMins: null,
      machineSpares: [],
      dispensers: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/PM/MTDetail", {
                BarcodeShopMappingId: _this.$route.params.id2,
                PMCheckInId: _this.$route.params.id
              }).then(function (response) {
                if (response.status == 200) {
                  //console.log(response.data);
                  if (response.data) {
                    self.barcodeShopMappingId = response.data.barcodeShopMappingId;
                    self.createUser = response.data.createUser;
                    self.mtDate = response.data.mtDateFormat;
                    self.resolve = response.data.resolve;
                    self.signatureFileUrl = response.data.signatureFileUrl;
                    self.failureMachineOther = response.data.failureMachineOther;
                    self.failureMachineReasonOther = response.data.failureMachineReasonOther;
                    if (response.data.failureMachineCodes != null && response.data.failureMachineCodes.length > 0) {
                      response.data.failureMachineCodes.forEach(function (el) {
                        self.failureMachineCodes.push({
                          failureMachineId: el.failureMachineId,
                          failureMachineCode: el.failureMachineCode,
                          failureMachineName: el.failureMachineName
                        });
                      });
                    }
                    if (response.data.failureMachineReasonCodes != null && response.data.failureMachineReasonCodes.length > 0) {
                      response.data.failureMachineReasonCodes.forEach(function (el) {
                        self.failureMachineReasonCodes.push({
                          failureMachineReasonId: el.failureMachineReasonId,
                          failureMachineReasonCode: el.failureMachineReasonCode,
                          failureMachineReasonName: el.failureMachineReasonName
                        });
                      });
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการทำ MT", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการทำ MT ได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    showModal: function showModal(imageURL) {

      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', function () {
        $('body').addClass('modal-open');
      });
    },
    closeModal: function closeModal() {
      $('#imageModal').modal('hide');
    },
    pictureModal: function pictureModal(fileUrl) {
      var router = this.$router;
      //console.log(fileUrl);
      if (fileUrl != null) {
        router.push({
          path: "/PM/PMCheckIn/" + this.$route.params.id + "/MTDetail/" + this.$route.params.id2 + "/Picture/" + encodeURIComponent(fileUrl)
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาคลิก Link", "error");
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      modalImageURL: '',
      modalImageFileInfo: '',
      pmStartDate: null,
      pmEndDate: null,
      signatureFileUrl: null,
      signatureFileInfo: null,
      diffMins: null,
      createUser: null,
      machineSpares: [],
      dispensers: [],
      barcodeShopMappingId: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/PM/PMDetail", {
                BarcodeShopMappingId: _this.$route.params.id2,
                PMCheckInId: _this.$route.params.id
              }).then(function (response) {
                if (response.status == 200) {
                  //console.log(response.data.data.length);
                  if (response.data) {
                    self.pmStartDate = response.data.pmStartDateFormat;
                    self.pmEndDate = response.data.pmEndDateFormat;
                    self.diffMins = response.data.diffMins;
                    self.signatureFileUrl = response.data.signatureFileUrl;
                    self.signatureFileInfo = response.data.signatureFileInfoId;
                    self.createUser = response.data.createUser;
                    self.isImgCloud = response.data.isImgCloud;

                    if (response.data.set != null) {
                      var s = response.data.set;

                      //machineSpares
                      var machineSpares = [];
                      if (s.machineSpares != null && s.machineSpares.length > 0) {
                        s.machineSpares.forEach(function (m) {
                          //surveys
                          var surveys = [];
                          if (m.surveys != null && m.surveys.length > 0) {
                            m.surveys.forEach(function (sur) {
                              surveys.push({
                                answerCode: sur.answerCode,
                                answerText: sur.answerText,
                                questionCode: sur.questionCode,
                                questionText: sur.questionText,
                                surveyDate: sur.surveyDateFormat
                              });
                            });
                          }

                          //spares
                          var spares = [];
                          if (m.spares != null && m.spares.length > 0) {
                            m.spares.forEach(function (sp) {
                              spares.push({
                                materialCode: sp.materialCode,
                                materialName: sp.materialName,
                                amount: sp.amount,
                                changeDate: sp.changeDateFormat
                              });
                            });
                          }

                          machineSpares.push({
                            surveys: surveys,
                            spares: spares
                          });
                        });
                      }

                      //dispensers
                      var dispensers = [];
                      if (s.dispensers != null && s.dispensers.length > 0) {
                        s.dispensers.forEach(function (d) {
                          //surveys
                          var surveys = [];
                          if (d.surveys != null && d.surveys.length > 0) {
                            d.surveys.forEach(function (sur) {
                              surveys.push({
                                answerCode: sur.answerCode,
                                answerText: sur.answerText,
                                questionCode: sur.questionCode,
                                questionText: sur.questionText,
                                surveyDate: sur.surveyDateFormat
                              });
                            });
                          }

                          //spares
                          var spares = [];
                          if (d.spares != null && d.spares.length > 0) {
                            d.spares.forEach(function (sp) {
                              spares.push({
                                materialCode: sp.materialCode,
                                materialName: sp.materialName,
                                amount: sp.amount,
                                changeDate: sp.changeDateFormat
                              });
                            });
                          }

                          //cleanUps
                          var cleanUps = [];
                          if (d.cleanUps != null && d.cleanUps.length > 0) {
                            d.cleanUps.forEach(function (c) {
                              cleanUps.push({
                                cleanUpChoiceCode: c.cleanUpChoiceCode,
                                cleanUpChoiceName: c.cleanUpChoiceName,
                                fileUrl: c.fileUrl,
                                fileInfoId: c.fileInfoId,
                                isImgCloud: c.isImgCloud
                              });
                            });
                          }

                          dispensers.push({
                            productBrandId: d.productBrandId,
                            productBrandName: d.productBrandName,
                            surveys: surveys,
                            spares: spares,
                            cleanUps: cleanUps
                          });
                        });
                      }
                      self.machineSpares = machineSpares;
                      self.dispensers = dispensers;
                      self.barcodeShopMappingId = s.barcodeShopMappingId;
                      //console.log(self.set);
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการทำ PM", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการทำ PM ได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    showModal: function showModal(imageURL, fileInfoId) {

      this.modalImageURL = imageURL;
      this.modalImageFileInFo = fileInfoId;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', function () {
        $('body').addClass('modal-open');
      });
    },
    closeModal: function closeModal() {
      $('#imageModal').modal('hide');
    },
    pictureModal: function pictureModal(fileUrl, fileInfoId) {
      var router = this.$router;
      this.modalImageFileInFo = fileInfoId;
      if (fileUrl != null) {
        router.push({
          path: '/PM/DownloadImage/' + encodeURIComponent(fileUrl)
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาคลิก Link", "error");
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      barcodeShopMappings: [],
      barcodeShopMappingsOther: [],
      barcodeBrands: [],
      modalImageURL: '',
      shopName: null,
      shopName2: null,
      checkInDate: null,
      checkOutDate: null, // CR-PM-2026 Req 2
      checkInByUserFullName: null,
      checkInId: null,
      pmSurveyCheckInId: null,
      isPM: false

    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/PMSurvey/PMSurveyCheckIn/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  console.log(response.data);
                  self.checkInByUserFullName = response.data.checkInByUserFullName;
                  self.checkInDate = response.data.checkInDateFormat;
                  self.checkOutDate = response.data.quitShopDateFormat || ''; // CR-PM-2026 Req 2
                  self.shopName = response.data.agentTypeCode == "AGENT" ? response.data.shopName : response.data.subAgentShopName;
                  self.shopName2 = response.data.agentTypeCode == "AGENT" ? response.data.shopName2 : response.data.subAgentShopName2;
                  self.checkInId = response.data.checkInId;
                  self.pmSurveyCheckInId = response.data.pmSurveyCheckInId;
                  self.isPM = response.data.isPM;
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล Check-In ร้านค้าที่คุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูล Check-In ร้านค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/PMSurvey/BarcodeMapping/GetAll?ShopId=" +
              // "/Api/PMSurvey/BarcodeMapping/GetAll?ShopId=" +
              _this.$route.params.id2 + "&PMSurveyCheckInId=" + _this.$route.params.id + "&SubAgentShopId=" + _this.$route.params.id3).then(function (response) {

                console.log(response.data);

                if (response.status == 200) {
                  //console.log(response.data.data.length);


                  if (response.data != null && response.data.length > 0) {
                    var _loop = function _loop() {
                      var el = response.data[i];

                      //loop barCodeSet
                      var barcodeSets = [];

                      if (el.barcodeSets != null && el.barcodeSets.length > 0) {

                        el.barcodeSets.forEach(function (el2) {
                          //loop brand
                          var brand = "";
                          if (el2.brand != null && el2.brand.length > 0) {
                            el2.brand.forEach(function (el3) {
                              if (brand != "") brand += ", ";

                              // brand += "[" + el3.brandId + "] " + el3.brandName;
                              brand += el3.brandName;
                            });
                          }
                          barcodeSets.push({
                            barcodeId: el2.barcodeId,
                            barcodeNo: el2.barcodeNo,
                            barcodeNoOld: el2.barcodeNoOld,
                            barcodeType: el2.barcodeType,
                            barcodeSubTypeName: el2.barcodeSubTypeName,
                            isBarButler: el2.isBarButler,
                            isCoolRoom: el2.isCoolRoom,
                            isPersonalDispenser: el2.isPersonalDispenser,
                            nfcCode: el2.nfcCode,
                            productId: el2.productId,
                            productName: el2.productName,
                            brand: brand,
                            fileUrl: el2.fileUrl,
                            isImgCloud: el2.isImgCloud != null && el2.isImgCloud != undefined ? el2.isImgCloud : false
                          });
                        });

                        console.log(barcodeSets);

                        if (el.groupId == 0) {
                          self.barcodeShopMappingsOther.push({
                            groupName: el.groupName,
                            groupId: el.groupId,
                            barcodeShopMappingId: el.id,
                            barcodeSets: barcodeSets,
                            isPM: el.isPM,
                            isMT: el.isMT,
                            indexDisplay: el.index,
                            deleteReason: el.deleteReason,
                            isDelete: el.isDelete
                          });
                        } else {
                          self.barcodeShopMappings.push({
                            groupName: el.groupName,
                            groupId: el.groupId,
                            barcodeShopMappingId: el.id,
                            barcodeSets: barcodeSets,
                            isPM: el.isPM,
                            isMT: el.isMT,
                            indexDisplay: el.index,
                            deleteReason: el.deleteReason,
                            isDelete: el.isDelete
                          });
                        }
                      }

                      self.barcodeShopMappings.sort(function (a, b) {
                        return a.groupName;
                      });

                      if (response.data != null && response.data.length > 0) {
                        self.barcodeBrands = response.data[0].brands;
                      }
                    };

                    for (var i = 0; i < response.data.length; i++) {
                      _loop();
                    }
                  }
                  //console.log(self.barcodeShopMappings);
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล Check-In ร้านค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                console.log(error);
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูล Check-In ร้านค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    showModal: function showModal(imageURL) {

      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', function () {
        $('body').addClass('modal-open');
      });
    },
    closeModal: function closeModal() {
      $('#imageModal').modal('hide');
    },
    barcodeTypeText: function barcodeTypeText(barcodeType, barcodeSubTypeName) {
      if (barcodeType == "BARCODE_TYPE_COOL_ROOM") return "ห้อง Cool Room";else if (barcodeType == "BARCODE_TYPE_DISPENSER") return "หัวจ่าย";else if (barcodeType == "BARCODE_TYPE_REGULATOR_JUMP") return barcodeSubTypeName;else if (barcodeType == "BARCODE_TYPE_REGULATOR") return barcodeSubTypeName;else if (barcodeType == "BARCODE_TYPE_MACHINE") return "เครื่องเบียร์สด";else if (barcodeType == "BARCODE_TYPE_PERSONAL_DISPENSER") return "หัวจ่ายส่วนบุคคล";
    },
    detailPM: function detailPM(checkInId, pmSurveyCheckInId) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        path: "/PM/PMSurveyCheckIn/" + checkInId + "/PMSurveyDetail/" + pmSurveyCheckInId
      });
    },

    // detailMT(barcodeShopMappingId) {
    //   router.push({
    //     path: `/PM/PMCheckIn/${this.$route.params.id}/MTDetail/${barcodeShopMappingId}`,
    //   });
    // },
    pictureModal: function pictureModal(fileUrl) {
      var router = this.$router;
      var url = "/PM/PMCheckIn/" + this.$route.params.id + "/BarcodeMappingDetail/" + this.$route.params.id2 + "/" + this.$route.params.id3 + "/Picture/" + encodeURIComponent(fileUrl);
      if (fileUrl != null) {
        router.push({
          path: url
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาคลิก Link", "error");
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      modalImageURL: '',
      pmStartDate: null,
      pmEndDate: null,
      signatureFileUrl: null,
      diffMins: null,
      createUser: null,
      machineSpares: [],
      dispensers: [],
      barcodeShopMappingId: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/PMSurvey/PMSurveyDetail", {
                PMSurveyCheckInId: _this.$route.params.id2,
                PMCheckInId: _this.$route.params.id
              }).then(function (response) {
                if (response.status == 200) {
                  //console.log(response.data.data.length);
                  if (response.data) {
                    self.pmStartDate = response.data[0].pmStartDateFormat;
                    self.pmEndDate = response.data[0].pmEndDateFormat;
                    self.diffMins = response.data[0].diffMins;
                    self.signatureFileUrl = response.data[0].signatureFileUrl;
                    self.createUser = response.data[0].createUser;
                    self.isImgCloud = response.data[0].isImgCloud;

                    var dispensers = [];

                    $.each(response.data, function (key, response_data) {
                      if (response_data.set != null) {
                        var s = response_data.set;

                        //machineSpares
                        var machineSpares = [];
                        if (s.machineSpares != null && s.machineSpares.length > 0) {
                          s.machineSpares.forEach(function (m) {
                            //surveys
                            var surveys = [];
                            if (m.surveys != null && m.surveys.length > 0) {
                              m.surveys.forEach(function (sur) {
                                surveys.push({
                                  answerCode: sur.answerCode,
                                  answerText: sur.answerText,
                                  questionCode: sur.questionCode,
                                  questionText: sur.questionText,
                                  surveyDate: sur.surveyDateFormat
                                });
                              });
                            }

                            //spares
                            var spares = [];
                            if (m.spares != null && m.spares.length > 0) {
                              m.spares.forEach(function (sp) {
                                spares.push({
                                  materialCode: sp.materialCode,
                                  materialName: sp.materialName,
                                  amount: sp.amount,
                                  changeDate: sp.changeDateFormat
                                });
                              });
                            }

                            machineSpares.push({
                              surveys: surveys,
                              spares: spares
                            });
                          });
                        }

                        /// 
                        //dispensers

                        if (s.dispensers != null && s.dispensers.length > 0) {
                          s.dispensers.forEach(function (d) {
                            //surveys
                            var surveys = [];
                            if (d.surveys != null && d.surveys.length > 0) {
                              d.surveys.forEach(function (sur) {
                                surveys.push({
                                  answerCode: sur.answerCode,
                                  answerText: sur.answerText,
                                  questionCode: sur.questionCode,
                                  questionText: sur.questionText,
                                  surveyDate: sur.surveyDateFormat
                                });
                              });
                            }

                            //spares
                            var spares = [];
                            if (d.spares != null && d.spares.length > 0) {
                              d.spares.forEach(function (sp) {
                                spares.push({
                                  materialCode: sp.materialCode,
                                  materialName: sp.materialName,
                                  amount: sp.amount,
                                  changeDate: sp.changeDateFormat
                                });
                              });
                            }

                            //cleanUps
                            var cleanUps = [];
                            if (d.cleanUps != null && d.cleanUps.length > 0) {
                              d.cleanUps.forEach(function (c) {
                                cleanUps.push({
                                  cleanUpChoiceCode: c.cleanUpChoiceCode,
                                  cleanUpChoiceName: c.cleanUpChoiceName,
                                  fileUrl: c.fileUrl,
                                  isImgCloud: c.isImgCloud
                                });
                              });
                            }

                            dispensers.push({
                              productBrandId: d.productBrandId,
                              productBrandName: d.productBrandName,
                              surveys: surveys,
                              spares: spares,
                              cleanUps: cleanUps
                            });
                          });
                        }
                        self.machineSpares = machineSpares;
                        self.dispensers = dispensers;
                        self.barcodeShopMappingId = s.barcodeShopMappingId;
                        //console.log(self.set);
                      }
                    });
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการทำ PM", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการทำ PM ได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    showModal: function showModal(imageURL) {

      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', function () {
        $('body').addClass('modal-open');
      });
    },
    closeModal: function closeModal() {
      $('#imageModal').modal('hide');
    },
    pictureModal: function pictureModal(fileUrl) {
      var router = this.$router;
      console.log(fileUrl);
      if (fileUrl != null) {
        router.push({
          path: "/PM/PMCheckIn/" + this.$route.params.id + "/PMDetail/" + this.$route.params.id2 + "/Picture/" + encodeURIComponent(fileUrl)
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาคลิก Link", "error");
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              $("#PictureModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                //self.$parent.reloadDataTable(false);
              }).modal("show");

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"detailBarcodeMapping\" v-if=\"data.showDetailButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-file-text\"></i>\n    </a>\n  </div>",
  methods: {
    detailBarcodeMapping: function detailBarcodeMapping() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/PM/PMCheckIn/" + this.data.checkInId + "/BarcodeMappingDetail/" + this.data.shopId + "/" + (this.data.subAgentShopCode != null ? this.data.subAgentShopCode : 0)
      });
    }
  }
});
// CR-PM-2026 Req 1: Reason cell + icon to view checkout media
var ActionReason = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  // CR-PM-2026 Req 3 update: icon = fa-camera-retro #ffb822 stack vertical (icon above text)
  // CR-PM-2026 Issue 15: ลด padding/margin ของ anchor → ไม่ใช้ btn-icon-md / btn-sm
  template: "\n  <div style=\"display:flex; flex-direction:column; align-items:center;\">\n    <a href=\"#\" v-if=\"data.showMediaIcon\" @click.prevent=\"viewMedia(data)\"\n       title=\"\u0E41\u0E2A\u0E14\u0E07\u0E20\u0E32\u0E1E\u0E16\u0E48\u0E32\u0E22/\u0E25\u0E32\u0E22\u0E40\u0E0B\u0E47\u0E19\" style=\"padding:0; margin:0; line-height:1; display:inline-block; cursor:pointer;\">\n       <i class=\"fa fa-camera-retro fa-lg\" style=\"color:#ffb822;\"></i>\n    </a>\n    <span>{{ data.reasonForFailedWork }}</span>\n  </div>",
  methods: {
    viewMedia: function viewMedia(row) {
      // 2026-08-26 (item 2.1): ชื่อไฟล์ปุ่ม "ดาวน์โหลดรูปภาพ" = pattern เดียวกับหน้า ViewImage gallery
      var isSub = row.agentTypeCode == "SUB_AGENT";
      var agentName = (isSub ? row.subAgentName : row.agentName) || "";
      var shop2Name = (isSub ? row.subAgentShopName2 : row.shopName2) || "";
      var dlBase = ["Check-in out", agentName, shop2Name, "ออกไม่สำเร็จ"].map(function (s) {
        return (s || "").trim();
      }) // 2026-08-30: trim กัน space ท้ายชื่อร้านจาก DB ติดมาในชื่อไฟล์
      .filter(function (s) {
        return s;
      }).join("_");
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/Api/PM/CheckoutMedia', { params: { pmCheckInId: row.checkInId } }).then(function (res) {
        var d = res.data || {};
        // CR-PM-2026 Issue 13: title ชิดซ้าย (move ใส่ html, ปล่อย swal title ว่าง)
        var titleHtml = '<div style="text-align:left; font-size:1.4em; font-weight:600; margin-bottom:15px; color:#212529;">ภาพถ่าย/ลายเซ็น</div>';
        // CR-PM-2026 Issue 13: subtitle gray (#6c757d) แทน #5867dd
        var subtitleHtml = d.mediaTitle ? '<div style="text-align:left; color:#6c757d; font-weight:600; margin-bottom:10px;">' + d.mediaTitle + '</div>' : '';
        var imgHtml = '';
        var firstFileInfoId = null;
        var firstName = 'download.jpg';
        if (d.files && d.files.length > 0) {
          d.files.forEach(function (f) {
            if (!firstFileInfoId && f.fileInfoId) {
              firstFileInfoId = f.fileInfoId;firstName = f.fileName || firstName;
            }
            // CR-PM-2026 Issue 13: padding 0 20px รอบรูป (ไม่ให้รูปติดขอบ modal)
            imgHtml += '<div style="margin-bottom:10px; text-align:center; padding:0 20px;">' + '<img src="' + (f.url || '') + '" style="max-width:100%;max-height:450px;" />' + '</div>';
          });
        } else {
          imgHtml = '<div class="text-muted">ไม่พบไฟล์แนบ</div>';
        }
        // CR-PM-2026 Issue 13: label "หมายเหตุ" gray
        var noteHtml = '<div class="mt-3" style="text-align:left;"><strong style="color:#6c757d;">หมายเหตุ</strong>' + '<div style="border:1px solid #ebedf2;padding:8px;border-radius:4px;margin-top:4px;min-height:40px;">' + (d.exitNote || '') + '</div></div>';
        // CR-PM-2026 Issue 13: buttons เป็น outline-secondary
        // CR-PM-2026: ใช้ backend proxy /Api/File/FileDownloadByte (same-origin, default ContentType=octet-stream → force download)
        //   pattern same as BudgetPlanJobCreate.downloadFile
        // item 2.1: ใช้ชื่อตาม pattern ViewImage + คง extension เดิมของไฟล์ต้นทาง
        var extMatch = /(\.[a-zA-Z0-9]{1,5})$/.exec(firstName || "");
        var dlFileName = dlBase + (extMatch ? extMatch[1] : ".jpg");
        var dlUrl = firstFileInfoId ? '/Api/File/FileDownloadByte?FileInfoId=' + encodeURIComponent(firstFileInfoId) + '&FileName=' + encodeURIComponent(dlFileName) : null;
        var footerHtml = '<div style="text-align:right; margin-top:15px;">' + (dlUrl ? '<a href="' + dlUrl + '" download="' + dlFileName + '" class="btn btn-outline-secondary mr-2"><i class="la la-save"></i> ดาวน์โหลดรูปภาพ</a>' : '') + '<button type="button" id="btn-close-media-popup" class="btn btn-outline-secondary"><i class="la la-times"></i> ปิดหน้าต่าง</button>' + '</div>';
        swal.fire({
          html: titleHtml + subtitleHtml + imgHtml + noteHtml + footerHtml,
          width: '650px',
          showCloseButton: true,
          showConfirmButton: false,
          onOpen: function onOpen() {
            var btn = document.getElementById('btn-close-media-popup');
            if (btn) btn.addEventListener('click', function () {
              swal.close();
            });
          }
        });
      }).catch(function () {
        swal.fire('ผิดพลาด', 'ไม่สามารถโหลดข้อมูลได้', 'error');
      });
    }
  }
});

var ActionRemark = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    {{data.pmRemark}}&nbsp;\n    <a href=\"#\" @click.prevent=\"AddRemark(data.checkInId,data.pmRemark)\" v-if=\"data.showRemarkButton\" data-id=\"data.checkInId\" title=\"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n       <i class=\"la la-edit\"></i>\n    </a>\n  </div>",
  methods: {
    AddRemark: function AddRemark(id, currentRemark) {
      var _this = this;

      var remark_checkin_id = id;
      swal.fire({
        title: 'หมายเหตุ',
        html: $('<form id="frmRemark"  ></form>').html('\
                <div class="form-group">' + '<input type="text" id="txtremark" class="form-control" name="txtremark" value="' + (currentRemark != null ? currentRemark : "") + '" maxlength="100"/>' + '</div>'),
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'บันทึกข้อมูล',
        showCloseButton: true,
        allowOutsideClick: false,
        preConfirm: function preConfirm() {

          var valid = true;
          if (valid) {
            var dataForm = new FormData($('#frmRemark')[0]);
            var remark = $("#frmRemark :input[name='txtremark']").val();
            console.log(dataForm);
            valid = false;

            KTApp.blockPage({
              opacity: 0.05,
              message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
            });

            var _router = _this.$router;
            var self = _this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/Api/PM/CheckIn/AddRemark', { CheckInId: id, Remark: remark }).then(function (response) {

              if (response.data) {
                KTApp.unblockPage();
                Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                  //router.go(-1), 
                  self.$parent.reloadDataTable(false);
                });
              } else {
                //console.log(response);
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            }).catch(function (error) {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }).then(function () {
              // always executed
              KTApp.unblockPage();
            });
          }
          return false;
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {
      isExporting: false, // 2026-08-10: disable ปุ่ม Export ระหว่างประมวลผล (กันกดซ้ำ)
      chlKeyword: null,
      // Issue 39: date range (from/to)
      chlCheckInDateFrom: moment().startOf("month"), // 2026-08-09: default เดือนปัจจุบัน (1 → วันนี้)
      chlCheckInDateTo: moment(),
      chlShopIds: [],
      chlShopIdsOptions: [],
      chlPMResult: null,

      pmrAgentCodes: [],
      pmrShopCodes: [],
      pmrSubAgentCodes: [],
      pmrSubAgentCodeOptions: [],
      pmrSubAgentShopCodes: [],
      pmrSubAgentShopCodesOptions: [],

      pmrAgentCodesOptions: [],
      // pmrAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: self.$root.canShow(["AGENT_ADMIN_PM"])
      //       ? "/Api/Agents/AgentOptions"
      //       : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         agentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      // pmrAgentTypeCodeOptions: {
      //   placeholder: "กรุณาเลือกประเภทตัวแทนจำหน่าย",
      //   allowClear: false,
      //   data: [
      //     { id: "AGENT", text: "ตัวแทนจำหน่าย", data: null },
      //     { id: "SUB_AGENT", text: "ตัวแทนจำหน่ายย่อย", data: null },
      //   ],
      // },
      pmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }

    }, _defineProperty(_ref, "pmrSubAgentShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      //pmrSubAgentCodes
      ajax: {
        url: "/Api/Shop/SubShopOptionAlertReport",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            shopCodes: self.pmrSubAgentCodes,
            search: params.term,
            page: params.page || 1,
            all: true
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "pmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "chlPMResultOptions", {
      placeholder: "กรุณาเลือกผลการดำเนินการ",
      allowClear: false,
      ajax: {
        delay: 300,
        url: "/Api/Variables/Options",
        data: function data(params) {
          var query = {
            search: "PM_RESULT",
            keySearch: params.term,
            page: params.page || 1
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.chlKeyword = null;
      self.chlCheckInDateFrom = moment().startOf("month"); // 2026-08-09: reset กลับ default เดือนปัจจุบัน
      self.chlCheckInDateTo = moment();
      self.chlShopIds = [];
      self.chlPMResult = null;

      self.pmrAgentCodes = [];
      self.pmrShopCodes = [];
      self.pmrSubAgentCodes = [];
      self.pmrSubAgentShopCodes = [];

      $("#pmrSubAgentCodes").val("").trigger("change");

      $("#pmrSubAgentShopCodes").val("").trigger("change");

      $("#pmrAgentCodes").val("").trigger("change");

      $("#pmrShopCodes").val("").trigger("change");

      // 2026-08-09: reset → แสดง default เดือนปัจจุบัน (แทนการ clear เป็นว่าง)
      $("#chlCheckInDateFrom").datepicker("update", self.chlCheckInDateFrom.format("DD/MM/YYYY"));
      $("#chlCheckInDateTo").datepicker("update", self.chlCheckInDateTo.format("DD/MM/YYYY"));

      // $("#chlShopIds")
      //   .val("")
      //   .trigger("change");

      $("#chlPMResult").val("").trigger("change");

      self.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#checkInTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#checkInTable").DataTable().ajax.reload(null, resetPaging);
    },
    LoadchlShopIdsOptions: function LoadchlShopIdsOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Shop/Select2ShopAgent", {
          page: 1,
          all: true,
          search: searchQuery
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.chlShopIdsOptions = [];
            data.forEach(function (element) {
              self.chlShopIdsOptions.push({
                id: element.id,
                label: element.text
              });
            });

            callback(null, self.chlShopIdsOptions);
          }
        }).catch(function (error) {});
      }
    },

    exportData: function exportData(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      // var curentShop = [];
      // if (
      //   self.OdCurrentLocationSubAgent.length != 0 ||
      //   self.OdCurrentLocationShop.length
      // ) {
      //   curentShop = self.OdCurrentLocationSubAgent.concat(
      //     self.OdCurrentLocationShop
      //   );
      // }
      /*
      var idDate = $("#chlCheckInDate").val();
            if (idDate == null || idDate == "") self.chlCheckInDate = null;
             let jsonSearch = {
              SearchKeyword: self.chlKeyword,
              CheckInDate:
                self.chlCheckInDate != null
                  ? self.chlCheckInDate.format("DD/MM/YYYY")
                  : self.chlCheckInDate,
              AgentCodes: self.pmrAgentCodes ,//chlShopIds,
              ShopIds: self.pmrShopCodes ,//chlShopIds,
              SubAgentShopIds: self.pmrSubAgentShopCodes,//chlShopIds,
              SubAgentCodes: self.pmrSubAgentCodes  ,//chlShopIds,
              PMResult: self.chlPMResult, 
            };
            return JSON.stringify($.extend(d, jsonSearch));
      */

      self.isExporting = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/PM/CheckIn/Export",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: self.chlKeyword,
          CheckInDateFrom: self.chlCheckInDateFrom != null ? self.chlCheckInDateFrom.format("DD/MM/YYYY") : self.chlCheckInDateFrom,
          CheckInDateTo: self.chlCheckInDateTo != null ? self.chlCheckInDateTo.format("DD/MM/YYYY") : self.chlCheckInDateTo,
          AgentCodes: self.pmrAgentCodes,
          ShopIds: self.pmrShopCodes,
          SubAgentShopIds: self.pmrSubAgentShopCodes,
          SubAgentCodes: self.pmrSubAgentCodes,
          PMResult: self.chlPMResult
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลคงค้างเกินกำหนดหรือไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
        self.isExporting = false;
      });
    },
    LoadpmrAgentCodesOptions: function LoadpmrAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM", {
        province_id: [],
        department: [],
        agentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.pmrAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, dpOptions, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;


              self.LoadpmrAgentCodesOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              // Issue 39: init 2 datepickers (from + to)
              dpOptions = {
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(),
                maxDate: moment().add(30, "days"),
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              };

              $(self.$refs.chlCheckInDateFrom).datepicker(dpOptions);
              $(self.$refs.chlCheckInDateFrom).on("changeDate", function (e) {
                self.chlCheckInDateFrom = e.date ? moment(e.date) : null;
              });
              $(self.$refs.chlCheckInDateTo).datepicker(dpOptions);
              $(self.$refs.chlCheckInDateTo).on("changeDate", function (e) {
                self.chlCheckInDateTo = e.date ? moment(e.date) : null;
              });
              // 2026-08-09: แสดง default เดือนปัจจุบันในช่อง datepicker (jQuery ไม่ bind กับ Vue model)
              if (self.chlCheckInDateFrom) $(self.$refs.chlCheckInDateFrom).datepicker("update", self.chlCheckInDateFrom.format("DD/MM/YYYY"));
              if (self.chlCheckInDateTo) $(self.$refs.chlCheckInDateTo).datepicker("update", self.chlCheckInDateTo.format("DD/MM/YYYY"));

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#checkInTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/PM/CheckIn/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    // Issue 39: date range — clear stale state if input was cleared
                    var idDateFrom = $("#chlCheckInDateFrom").val();
                    if (idDateFrom == null || idDateFrom == "") self.chlCheckInDateFrom = null;
                    var idDateTo = $("#chlCheckInDateTo").val();
                    if (idDateTo == null || idDateTo == "") self.chlCheckInDateTo = null;

                    var jsonSearch = {
                      SearchKeyword: self.chlKeyword,
                      CheckInDateFrom: self.chlCheckInDateFrom != null ? self.chlCheckInDateFrom.format("DD/MM/YYYY") : self.chlCheckInDateFrom,
                      CheckInDateTo: self.chlCheckInDateTo != null ? self.chlCheckInDateTo.format("DD/MM/YYYY") : self.chlCheckInDateTo,
                      AgentCodes: self.pmrAgentCodes, //chlShopIds,
                      ShopIds: self.pmrShopCodes, //chlShopIds,
                      SubAgentShopIds: self.pmrSubAgentShopCodes, //chlShopIds,
                      SubAgentCodes: self.pmrSubAgentCodes, //chlShopIds,
                      PMResult: self.chlPMResult
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "desc"]],
                columns: [{
                  data: "checkInDate",
                  // CR-PM-2026 Req 2 — dt-control toggles expand row showing วันที่ Check-Out
                  className: "text-center dt-control",
                  render: function render(data, type, full, meta) {
                    return full.checkInDateFormat;
                  }
                }, { data: "routeName", className: "text-center" }, {
                  data: "agentName",
                  className: "text-center",
                  width: "15%",
                  render: function render(data, type, full, meta) {
                    if (full.agentTypeCode == "SUB_AGENT") {
                      return full.subAgentName != null ? full.subAgentName : "";
                    } else {
                      return full.agentName != null ? full.agentName : "";
                    }
                  }
                }, {
                  data: "agentTypeCode",
                  className: "text-center",
                  width: "10%",
                  render: function render(data, type, full, meta) {
                    return full.agentTypeName;
                  }
                }, { data: "checkInByUserFullName", className: "text-center" }, {
                  data: "shopName",
                  className: "text-center",
                  width: "15%",
                  render: function render(data, type, full, meta) {
                    if (full.agentTypeCode == "SUB_AGENT") {
                      return full.subAgentShopName != null ? full.subAgentShopName : "";
                    } else {
                      return full.shopName != null ? full.shopName : "";
                    }
                  }
                }, {
                  data: "shopName2",
                  className: "text-center",
                  width: "15%",
                  render: function render(data, type, full, meta) {
                    if (full.agentTypeCode == "SUB_AGENT") {
                      return full.subAgentShopName2 != null ? full.subAgentShopName2 : "";
                    } else {
                      return full.shopName2 != null ? full.shopName2 : "";
                    }
                  }
                },

                // { data: "shopName", className: "text-center" },
                // { data: "shopName2", className: "text-center" },
                { data: "workStatusText", className: "text-center" }, {
                  data: "reasonForFailedWork",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    // CR-PM-2026 Req 1: icon 🖼️ appears only when failed
                    var html = '<div class="reason_actions" data-reason="' + (data || '') + '" data-failed="' + (full.workStatusText === 'ดำเนินการไม่สำเร็จ' ? '1' : '0') + '"></div>';
                    return html;
                  }
                }, {
                  data: "checkInItemId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="remark_actions"></div>';
                  }
                }, {
                  data: "checkInItemId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  //console.log(data);
                  if (data) {
                    data.showDetailButton = data.isBarcodeMapping && self.$root.canShow(["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                // CR-PM-2026 Req 1: Mount ActionReason in เหตุผล column
                $(".reason_actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showMediaIcon = data.workStatusText === 'ดำเนินการไม่สำเร็จ';
                    new ActionReason({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".remark_actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  //console.log(data);
                  if (data) {
                    data.showRemarkButton = self.$root.canShow(["ADMIN_PM", "super_admin"]);
                    new ActionRemark({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

              // CR-PM-2026 Req 2 — Expand/collapse row to show วันที่ Check-Out (mirror BudgetPlanJobList pattern)
              $("#checkInTable tbody").on("click", "td.dt-control", function () {
                var tr = $(this).closest("tr");
                var row = table.DataTable().row(tr);
                if (row.child.isShown()) {
                  row.child.hide();
                  tr.removeClass("shown");
                } else {
                  var d = row.data();
                  if (d) {
                    var checkout = d.quitShopDateFormat ? d.quitShopDateFormat : "-";
                    row.child('<div style="background:#f9f9f9; padding:8px 16px;">' + '<strong>วันที่ Check-Out:</strong> ' + checkout + '</div>').show();
                    tr.addClass("shown");
                  }
                }
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var RoutePlanActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div> \n    <a href=\"#\" @click.prevent=\"editRoutePlan\" v-if=\"data.showEditButton && data.checkEdit\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"deleteRoutePlan\" v-if=\"data.showDeleteButton\" title=\"\u0E25\u0E1A\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-trash\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"copyRoutePlan\" title=\"\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md text-warning\">\n      <i class=\"la la-copy\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"unlockShopSurvey\" v-if=\"data.lockedShopSurveyStatus\" title=\"\u0E25\u0E47\u0E2D\u0E04 Survey PM\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md text-warning\">\n      <i class=\"fa fa-unlock text-danger\"></i> \n    </a>\n    <a href=\"#\" @click.prevent=\"unlockShopSurvey\" v-if=\"!data.lockedShopSurveyStatus\" title=\"\u0E1B\u0E25\u0E14\u0E25\u0E47\u0E2D\u0E04 Survey PM\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md text-warning\">\n      <i class=\"fa fa-lock text-success\"></i> \n    </a>\n  </div>",
  methods: {
    copyRoutePlan: function copyRoutePlan() {
      var _this = this;

      var self = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/PM/RoutePlan/" + this.data.pmRoutePlanId + "/" + this.data.pmRoutePlanShopId + "/ValidateCopy").then(function (response) {
        if (response.status == 200) {
          self.eShActive = response.data.filter(function (o) {
            return o.statusGroup == "STATUS_SHOP_ACTIVE";
          });
          self.eShInActive = response.data.filter(function (o) {
            return o.statusGroup == "STATUS_SHOP_INACTIVE";
          });
        }
      });

      Swal.fire({
        title: 'คำสั่งคัดลอก Route Plan/Adhoc "' + this.data.routeName + '"',
        type: "warning",
        html: "<div class='form-group'><label>กรุณาเลือกวันที่ Route Plan/Adhoc</label><div class='input-group date'><input id='swalRouteDatePicker' readonly type='text' class='form-control'><div class='input-group-append'><span class='input-group-text'><i class='la la-calendar-check-o'></i></span></div></div>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        onOpen: function onOpen() {
          var arrows;
          if (KTUtil.isRTL()) {
            arrows = {
              leftArrow: '<i class="la la-angle-right"></i>',
              rightArrow: '<i class="la la-angle-left"></i>'
            };
          } else {
            arrows = {
              leftArrow: '<i class="la la-angle-left"></i>',
              rightArrow: '<i class="la la-angle-right"></i>'
            };
          }

          var datepicker = $("#swalRouteDatePicker").datepicker({
            autoclose: true,
            clearBtn: true,
            format: "dd/mm/yyyy",
            rtl: KTUtil.isRTL(),
            orientation: "bottom left",
            todayBtn: "linked",
            todayHighlight: true,
            templates: arrows
          });

          if (self.data.typeCode == "PM_TYPE_ADHOC") {
            datepicker.datepicker("setStartDate", new Date(moment().format("YYYY/MM/DD")));
            datepicker.datepicker("setEndDate", new Date(moment().format("YYYY/MM/DD")));
            datepicker.datepicker("update", moment().format("DD/MM/YYYY"));
          } else {
            datepicker.datepicker("setStartDate", new Date(moment().add(1, "days").format("YYYY/MM/DD")));
            datepicker.datepicker("update", moment().add(1, "days").format("DD/MM/YYYY"));
          }
        }
      }).then(function (result) {
        if (result.value) {
          var date = $("#swalRouteDatePicker").val();
          if (!date) {
            Swal.fire({
              title: 'คำสั่งคัดลอก Route Plan/Adhoc "' + _this.data.routeName + '"',
              type: "error",
              text: "กรุณาเลือกวันที่"
            }).then(function () {
              self.copyRoutePlan();
            });
            return;
          }

          KTApp.blockPage({
            opacity: 0.05,
            message: "คำสั่งคัดลอก กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/PM/RoutePlan/" + _this.data.pmRoutePlanId + "/" + _this.data.pmRoutePlanShopId + "/Copy", {
            routePlanDate: date
          }).then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    editRoutePlan: function editRoutePlan() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        path: "/PM/PMRoutePlan/Edit/" + this.data.pmRoutePlanId
      });
    },
    deleteRoutePlan: function deleteRoutePlan() {
      var _this2 = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งลบ Route Plan/Adhoc",
        type: "warning",
        html: "กรุณายืนยันคำสั่งลบข้อมูล Route Plan/Adhoc <strong>" + "</strong> หลังจากลบแล้วจะส่งผลให้ Route Plan/Adhoc นี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลการ Route Plan/Adhoc ออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/PM/RoutePlan/" + _this2.data.pmRoutePlanId + "/" + _this2.data.pmRoutePlanShopId + "/Delete").then(function (response) {
            //console.log(response);
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    },
    unlockShopSurvey: function unlockShopSurvey() {
      var _this3 = this;

      var self = this;
      var title_html = "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E17\u0E33 Survey PM \t<br/>\u0E0A\u0E37\u0E48\u0E2D\u0E23\u0E39\u0E17 : " + this.data.routeName + "\t<br/> \u0E0A\u0E37\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32 : " + this.data.shopName + "<strong>";
      if (this.data.lockedShopSurveyStatus == true) {
        title_html = "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E40\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E17\u0E33 Survey PM \t<br/>\u0E0A\u0E37\u0E48\u0E2D\u0E23\u0E39\u0E17 : " + this.data.routeName + "\t<br/> \u0E0A\u0E37\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32 : " + this.data.shopName + "<strong>";
      }

      if (!self.$root.canShow(["super_admin"])) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดำเนินการได้ กรุณาติดต่อผู้ดูแลระบบ", "error");
      } else {
        Swal.fire({
          title: "กรุณายืนยันคำสั่งปิดการตรวจสอบสถานะการทำ Survey PM  ",
          type: "warning",
          html: title_html,
          input: this.data.userCount > 0 ? "checkbox" : "",
          inputValue: 0,
          // inputPlaceholder: "ต้องการลบข้อมูลการ Route Plan/Adhoc ออกจากข้อมูล",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            KTApp.blockPage({
              opacity: 0.05,
              message: "กำลังลบข้อมูล กรุณารอสักครู่..."
            });
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/PM/RoutePlan/" + _this3.data.pmRoutePlanId + "/" + _this3.data.pmRoutePlanShopId + "/IgnorValidateSurvey").then(function (response) {
              //console.log(response);
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            }).catch(function (error) {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }).then(function () {
              // always executed
              KTApp.unblockPage();
            });
          }
        });
      } //end if
    }
  }
});

var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-success\">\n      <i class=\"fas fa-play\"></i>\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this4 = this;

      var self = this;
      var table = $("#userTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/PM/RoutePlan/" + _this4.data.pmRoutePlanId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});
var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"editStatus\" v-if=\"data.showEditStatusButton\" class=\"btn btn-sm btn-danger\">\n      <i class=\"fas fa-pause\"></i>\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n  </div>",
  methods: {
    editStatus: function editStatus() {
      var _this5 = this;

      var self = this;
      var table = $("#userTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html: "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" + "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/PM/RoutePlan/" + _this5.data.pmRoutePlanId + "/Toggle").then(function (response) {
            if (response.data.data) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            // always executed
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {
      pmrSearch: null,
      pmrTypeCode: null,
      pmrStartDate: null,
      pmrEndDate: null,
      pmrAgentCodes: [],
      pmrShopCodes: [],
      pmrInActiveStatus: null,
      pmrRouteName: null,
      pmrPmUserId: [],

      pmrSubAgentCodes: [],
      pmrSubAgentCodeOptions: [],
      pmrSubAgentShopCodes: [],
      pmrSubAgentShopCodesOptions: [],

      // Configurations
      pmrInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      },
      pmrTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "PM_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      pmrPmUserIdOptions: {
        placeholder: "กรุณาเลือกผู้ดำเนินการ",
        allowClear: true,
        ajax: {
          url: "/Api/PM/Select2PmUser",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      pmrAgentCodesOptions: [],
      // pmrAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: self.$root.canShow(["AGENT_ADMIN_PM"])
      //       ? "/Api/Agents/AgentOptions"
      //       : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         agentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      pmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }

    }, _defineProperty(_ref, "pmrSubAgentShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      //pmrSubAgentCodes
      ajax: {
        url: "/Api/Shop/SubShopOptionAlertReport",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            shopCodes: self.pmrSubAgentCodes,
            search: params.term,
            page: params.page || 1,
            all: true
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "pmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.pmrSearch = null;
      self.pmrStartDate = null;
      self.pmrEndDate = null;
      self.pmrTypeCode = null;
      self.pmrAgentCodes = [];
      self.pmrShopCodes = [];
      self.pmrInActiveStatus = false;
      self.pmrRouteName = null;
      self.pmrPmUserId = [];
      self.pmrSubAgentCodes = [];
      self.pmrSubAgentShopCodes = [];

      $("#pmrStartDate").val("").trigger("change");

      $("#pmrEndDate").val("").trigger("change");

      $("#pmrTypeCode").val("").trigger("change");

      $("#pmrAgentCodes").val("").trigger("change");

      $("#pmrShopCodes").val("").trigger("change");

      $("#pmrPmUserId").val("").trigger("change");

      $("#pmrInActiveStatus").val(self.pmrInActiveStatus + "").trigger("change");

      $("#pmrSubAgentCodes").val("").trigger("change");

      $("#pmrSubAgentShopCodes").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#routePlanTable").DataTable();
      table.search();
      table.draw();
    },
    exportRoutePlan: function exportRoutePlan(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/PM/RoutePlan/ExportRoutePlan",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: self.pmrSearch,
          StartDate: self.pmrStartDate != null ? self.pmrStartDate.format("DD/MM/YYYY") : self.pmrStartDate,
          EndDate: self.pmrEndDate != null ? self.pmrEndDate.format("DD/MM/YYYY") : self.pmrEndDate,
          TypeCode: self.pmrTypeCode,
          AgentCodes: self.pmrAgentCodes,
          ShopCodes: self.pmrShopCodes,
          SubAgentCodes: self.pmrSubAgentCodes,
          SubAgentShopCodes: self.pmrSubAgentShopCodes,
          RouteName: self.pmrRouteName,
          PmUserId: self.pmrPmUserId,
          ActiveStatus: self.pmrInActiveStatus
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#routePlanTable").DataTable().ajax.reload(null, resetPaging);
    },
    LoadpmrAgentCodesOptions: function LoadpmrAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM", {
        province_id: [],
        department: [],
        agentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.pmrAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, today, lastDayOfYear, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this6;


              self.LoadpmrAgentCodesOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              today = moment();
              lastDayOfYear = moment().endOf("year");

              self.pmrStartDate = today;
              self.pmrEndDate = lastDayOfYear;

              $(self.$refs.pmrStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.pmrStartDate).datepicker("update", !!self.pmrStartDate ? self.pmrStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.pmrStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.pmrEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reEndDate = moment().endOf('month');
              $(self.$refs.pmrEndDate).datepicker("update", !!self.pmrEndDate ? self.pmrEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.pmrEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              //default Active Data
              self.pmrInActiveStatus = false;
              $("#pmrInActiveStatus").val(self.pmrInActiveStatus + "").trigger("change");

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#routePlanTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/PM/RoutePlan/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      SearchKeyword: self.pmrSearch,
                      StartDate: self.pmrStartDate != null ? self.pmrStartDate.format("DD/MM/YYYY") : self.pmrStartDate,
                      EndDate: self.pmrEndDate != null ? self.pmrEndDate.format("DD/MM/YYYY") : self.pmrEndDate,
                      TypeCode: self.pmrTypeCode,
                      AgentCodes: self.pmrAgentCodes,
                      ShopCodes: self.pmrShopCodes,
                      SubAgentCodes: self.pmrSubAgentCodes,
                      SubAgentShopCodes: self.pmrSubAgentShopCodes,
                      RouteName: self.pmrRouteName,
                      PmUserId: self.pmrPmUserId,
                      ActiveStatus: self.pmrInActiveStatus
                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[3, "desc"]],
                columns: [{
                  data: "typeCode",
                  className: "text-center",
                  width: "10%",
                  render: function render(data, type, full, meta) {
                    return full.typeName;
                  }
                }, {
                  data: "agentName",
                  className: "text-center",
                  width: "15%",
                  render: function render(data, type, full, meta) {
                    if (full.agentTypeCode == "SUB_AGENT") {
                      return full.subAgentName;
                    } else {
                      return full.agentName;
                    }
                  }
                }, {
                  data: "agentTypeCode",
                  className: "text-center",
                  width: "10%",
                  render: function render(data, type, full, meta) {
                    return full.agentTypeName;
                  }
                }, {
                  data: "routePlanDate",
                  className: "text-center",
                  width: "10%",
                  render: function render(data, type, full, meta) {
                    return full.routePlanDateFormat;
                  }
                }, {
                  data: "routeName",
                  className: "text-center",
                  orderable: false,
                  width: "10%"
                }, {
                  data: "shopName",
                  className: "text-center",
                  orderable: false,
                  width: "20%",
                  render: function render(data, type, full, meta) {
                    if (full.agentTypeCode == "SUB_AGENT") {
                      return full.subAgentShopName;
                    } else {
                      return full.shopName;
                    }
                  }
                }, {
                  data: "shopName2",
                  className: "text-center",
                  orderable: false,
                  width: "20%",
                  render: function render(data, type, full, meta) {
                    if (full.agentTypeCode == "SUB_AGENT") {
                      return full.subAgentShopName2;
                    } else {
                      return full.shopName2;
                    }
                  }
                }, {
                  data: "pmUserName",
                  className: "text-center",
                  orderable: false,
                  width: "10%"
                }, {
                  data: "createByUserFullName",
                  className: "text-center",
                  width: "10%"
                }, {
                  data: "inActiveStatus",
                  className: "text-center",
                  width: "10%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "pmRoutePlanShopId",
                  className: "text-center",
                  width: "5%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditButton = self.$root.canShow(["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]);

                    var routePlanDate = new Date(data.routePlanDate);
                    data.showDeleteButton = self.$root.canShow(["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]) && routePlanDate > new Date();

                    if (data.typeCode == "PM_TYPE_ROUTE_PLAN") {
                      data.checkEdit = routePlanDate > new Date() ? true : false;
                    } else if (data.typeCode == "PM_TYPE_ADHOC") {
                      data.checkEdit = !data.isCheckIn;
                    }

                    new RoutePlanActions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showEditStatusButton = self.$root.canShow(["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"]);
                    if (data.inActiveStatus == 0) new StatusActionsTrue({ data: { data: data }, parent: self }).$mount(el);else if (data.inActiveStatus == 1) new StatusActionsFalse({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this6);
    }))();
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"detailBarcodeMapping\" v-if=\"data.showDetailButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-file-text\"></i>\n    </a>\n  </div>",
  methods: {
    detailBarcodeMapping: function detailBarcodeMapping() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/PM/PMSurveyCheckIn/" + this.data.pmSurveyCheckInId + "/PMSurveyBarcodeMappingDetail/" + this.data.shopId + "/" + (this.data.subAgentShopCode != null ? this.data.subAgentShopCode : 0)
      });
    }
  }
});
// CR-PM-2026 Req 1: Reason cell + icon to view checkout media (Survey)
var ActionReason = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  // CR-PM-2026 Req 3 update: icon = fa-camera-retro #ffb822 stack vertical (icon above text)
  // CR-PM-2026 Issue 15: ลด padding/margin ของ anchor → ไม่ใช้ btn-icon-md / btn-sm
  template: "\n  <div style=\"display:flex; flex-direction:column; align-items:center;\">\n    <a href=\"#\" v-if=\"data.showMediaIcon\" @click.prevent=\"viewMedia(data)\"\n       title=\"\u0E41\u0E2A\u0E14\u0E07\u0E20\u0E32\u0E1E\u0E16\u0E48\u0E32\u0E22/\u0E25\u0E32\u0E22\u0E40\u0E0B\u0E47\u0E19\" style=\"padding:0; margin:0; line-height:1; display:inline-block; cursor:pointer;\">\n       <i class=\"fa fa-camera-retro fa-lg\" style=\"color:#ffb822;\"></i>\n    </a>\n    <span>{{ data.reasonForFailedWork }}</span>\n  </div>",
  methods: {
    viewMedia: function viewMedia(row) {
      // 2026-08-26 (item 2.1): ชื่อไฟล์ปุ่ม "ดาวน์โหลดรูปภาพ" = pattern เดียวกับหน้า ViewImage gallery
      var isSub = row.agentTypeCode == "SUB_AGENT";
      var agentName = (isSub ? row.subAgentName : row.agentName) || "";
      var shop2Name = (isSub ? row.subAgentShopName2 : row.shopName2) || "";
      var dlBase = ["ข้อมูล Survey", shop2Name, agentName, "ออกไม่สำเร็จ"] // 2026-08-27: สลับ ร้าน2 มาก่อนตัวแทน (เฉพาะ Survey)
      .map(function (s) {
        return (s || "").trim();
      }) // 2026-08-30: trim กัน space ท้ายชื่อร้านจาก DB ติดมาในชื่อไฟล์
      .filter(function (s) {
        return s;
      }).join("_");
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/Api/PM/CheckoutMedia', { params: { pmSurveyCheckInId: row.pmSurveyCheckInId } }).then(function (res) {
        var d = res.data || {};
        // CR-PM-2026 Issue 13: title ชิดซ้าย (move ใส่ html, ปล่อย swal title ว่าง)
        var titleHtml = '<div style="text-align:left; font-size:1.4em; font-weight:600; margin-bottom:15px; color:#212529;">ภาพถ่าย/ลายเซ็น</div>';
        // CR-PM-2026 Issue 13: subtitle gray (#6c757d) แทน #5867dd
        var subtitleHtml = d.mediaTitle ? '<div style="text-align:left; color:#6c757d; font-weight:600; margin-bottom:10px;">' + d.mediaTitle + '</div>' : '';
        var imgHtml = '';
        var firstFileInfoId = null;
        var firstName = 'download.jpg';
        if (d.files && d.files.length > 0) {
          d.files.forEach(function (f) {
            if (!firstFileInfoId && f.fileInfoId) {
              firstFileInfoId = f.fileInfoId;firstName = f.fileName || firstName;
            }
            // CR-PM-2026 Issue 13: padding 0 20px รอบรูป (ไม่ให้รูปติดขอบ modal)
            imgHtml += '<div style="margin-bottom:10px; text-align:center; padding:0 20px;">' + '<img src="' + (f.url || '') + '" style="max-width:100%;max-height:450px;" />' + '</div>';
          });
        } else {
          imgHtml = '<div class="text-muted">ไม่พบไฟล์แนบ</div>';
        }
        // CR-PM-2026 Issue 13: label "หมายเหตุ" gray
        var noteHtml = '<div class="mt-3" style="text-align:left;"><strong style="color:#6c757d;">หมายเหตุ</strong>' + '<div style="border:1px solid #ebedf2;padding:8px;border-radius:4px;margin-top:4px;min-height:40px;">' + (d.exitNote || '') + '</div></div>';
        // CR-PM-2026 Issue 13: buttons เป็น outline-secondary
        // CR-PM-2026: ใช้ backend proxy /Api/File/FileDownloadByte (same-origin, default ContentType=octet-stream → force download)
        //   pattern same as BudgetPlanJobCreate.downloadFile
        // item 2.1: ใช้ชื่อตาม pattern ViewImage + คง extension เดิมของไฟล์ต้นทาง
        var extMatch = /(\.[a-zA-Z0-9]{1,5})$/.exec(firstName || "");
        var dlFileName = dlBase + (extMatch ? extMatch[1] : ".jpg");
        var dlUrl = firstFileInfoId ? '/Api/File/FileDownloadByte?FileInfoId=' + encodeURIComponent(firstFileInfoId) + '&FileName=' + encodeURIComponent(dlFileName) : null;
        var footerHtml = '<div style="text-align:right; margin-top:15px;">' + (dlUrl ? '<a href="' + dlUrl + '" download="' + dlFileName + '" class="btn btn-outline-secondary mr-2"><i class="la la-save"></i> ดาวน์โหลดรูปภาพ</a>' : '') + '<button type="button" id="btn-close-media-popup" class="btn btn-outline-secondary"><i class="la la-times"></i> ปิดหน้าต่าง</button>' + '</div>';
        swal.fire({
          html: titleHtml + subtitleHtml + imgHtml + noteHtml + footerHtml,
          width: '650px',
          showCloseButton: true,
          showConfirmButton: false,
          onOpen: function onOpen() {
            var btn = document.getElementById('btn-close-media-popup');
            if (btn) btn.addEventListener('click', function () {
              swal.close();
            });
          }
        });
      }).catch(function () {
        swal.fire('ผิดพลาด', 'ไม่สามารถโหลดข้อมูลได้', 'error');
      });
    }
  }
});

var ActionRemark = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    {{data.pmRemark}}&nbsp;\n    <a href=\"#\" @click.prevent=\"AddRemark(data.checkInId,data.pmSurveyCheckInId,data.pmRemark)\" v-if=\"data.showRemarkButton\" data-id=\"data.checkInId\" title=\"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n       <i class=\"la la-edit\"></i>\n    </a>\n  </div>",
  methods: {
    AddRemark: function AddRemark(id, surveyId, currentRemark) {
      var _this = this;

      var remark_checkin_id = id;
      swal.fire({
        title: 'หมายเหตุ',
        html: $('<form id="frmRemark"  ></form>').html('\
                <div class="form-group">' + '<input type="text" id="txtremark" class="form-control" name="txtremark" value="' + (currentRemark != null ? currentRemark : "") + '" maxlength="100"/>' + '</div>'),
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'บันทึกข้อมูล',
        showCloseButton: true,
        allowOutsideClick: false,
        preConfirm: function preConfirm() {

          var valid = true;
          if (valid) {
            var dataForm = new FormData($('#frmRemark')[0]);
            var remark = $("#frmRemark :input[name='txtremark']").val();
            console.log(dataForm);
            valid = false;

            KTApp.blockPage({
              opacity: 0.05,
              message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
            });

            var _router = _this.$router;
            var self = _this;

            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/Api/PMSurvey/SurveyCheckIn/AddRemark', { CheckInId: id, SurveyCheckInId: surveyId, Remark: remark }).then(function (response) {

              if (response.data) {
                KTApp.unblockPage();
                Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
                  //router.go(-1), 
                  self.$parent.reloadDataTable(false);
                });
              } else {
                //console.log(response);
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            }).catch(function (error) {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }).then(function () {
              // always executed
              KTApp.unblockPage();
            });
          }
          return false;
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {
      isExporting: false, // 2026-08-10: disable ปุ่ม Export ระหว่างประมวลผล (กันกดซ้ำ)
      chlKeyword: null,
      // Issue 40: date range (from/to)
      chlCheckInDateFrom: moment().startOf("month"), // 2026-08-09: default เดือนปัจจุบัน (1 → วันนี้)
      chlCheckInDateTo: moment(),
      chlShopIds: [],
      chlShopIdsOptions: [],
      chlPMResult: null,

      pmrAgentCodes: [],
      pmrShopCodes: [],
      pmrSubAgentCodes: [],
      pmrSubAgentCodeOptions: [],
      pmrSubAgentShopCodes: [],
      pmrSubAgentShopCodesOptions: [],

      pmrAgentCodesOptions: [],
      // pmrAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: self.$root.canShow(["AGENT_ADMIN_PM"])
      //       ? "/Api/Agents/AgentOptions"
      //       : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         agentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      // pmrAgentTypeCodeOptions: {
      //   placeholder: "กรุณาเลือกประเภทตัวแทนจำหน่าย",
      //   allowClear: false,
      //   data: [
      //     { id: "AGENT", text: "ตัวแทนจำหน่าย", data: null },
      //     { id: "SUB_AGENT", text: "ตัวแทนจำหน่ายย่อย", data: null },
      //   ],
      // },
      pmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }

    }, _defineProperty(_ref, "pmrSubAgentShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      //pmrSubAgentCodes
      ajax: {
        url: "/Api/Shop/SubShopOptionAlertReport",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            shopCodes: self.pmrSubAgentCodes,
            search: params.term,
            page: params.page || 1,
            all: true
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "pmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "chlPMResultOptions", {
      placeholder: "กรุณาเลือกผลการดำเนินการ",
      allowClear: false,
      ajax: {
        delay: 300,
        url: "/Api/Variables/Options",
        data: function data(params) {
          var query = {
            search: "PM_RESULT",
            keySearch: params.term,
            page: params.page || 1
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.chlKeyword = null;
      self.chlCheckInDateFrom = moment().startOf("month"); // 2026-08-09: reset กลับ default เดือนปัจจุบัน
      self.chlCheckInDateTo = moment();
      self.chlShopIds = [];
      self.chlPMResult = null;

      self.pmrAgentCodes = [];
      self.pmrShopCodes = [];
      self.pmrSubAgentCodes = [];
      self.pmrSubAgentShopCodes = [];

      $("#pmrSubAgentCodes").val("").trigger("change");

      $("#pmrSubAgentShopCodes").val("").trigger("change");

      $("#pmrAgentCodes").val("").trigger("change");

      $("#pmrShopCodes").val("").trigger("change");

      // 2026-08-09: reset → แสดง default เดือนปัจจุบัน (แทนการ clear เป็นว่าง)
      $("#chlCheckInDateFrom").datepicker("update", self.chlCheckInDateFrom.format("DD/MM/YYYY"));
      $("#chlCheckInDateTo").datepicker("update", self.chlCheckInDateTo.format("DD/MM/YYYY"));

      // $("#chlShopIds")
      //   .val("")
      //   .trigger("change");

      $("#chlPMResult").val("").trigger("change");

      self.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#checkInTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#checkInTable").DataTable().ajax.reload(null, resetPaging);
    },
    LoadchlShopIdsOptions: function LoadchlShopIdsOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Shop/Select2ShopAgent", {
          page: 1,
          all: true,
          search: searchQuery
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.chlShopIdsOptions = [];
            data.forEach(function (element) {
              self.chlShopIdsOptions.push({
                id: element.id,
                label: element.text
              });
            });

            callback(null, self.chlShopIdsOptions);
          }
        }).catch(function (error) {});
      }
    },

    exportData: function exportData(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      // var curentShop = [];
      // if (
      //   self.OdCurrentLocationSubAgent.length != 0 ||
      //   self.OdCurrentLocationShop.length
      // ) {
      //   curentShop = self.OdCurrentLocationSubAgent.concat(
      //     self.OdCurrentLocationShop
      //   );
      // }
      /*
      var idDate = $("#chlCheckInDate").val();
            if (idDate == null || idDate == "") self.chlCheckInDate = null;
             let jsonSearch = {
              SearchKeyword: self.chlKeyword,
              CheckInDate:
                self.chlCheckInDate != null
                  ? self.chlCheckInDate.format("DD/MM/YYYY")
                  : self.chlCheckInDate,
              AgentCodes: self.pmrAgentCodes ,//chlShopIds,
              ShopIds: self.pmrShopCodes ,//chlShopIds,
              SubAgentShopIds: self.pmrSubAgentShopCodes,//chlShopIds,
              SubAgentCodes: self.pmrSubAgentCodes  ,//chlShopIds,
              PMResult: self.chlPMResult, 
            };
            return JSON.stringify($.extend(d, jsonSearch));
      */

      self.isExporting = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/PMSurvey/SurveyCheckIn/Export",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: self.chlKeyword,
          CheckInDateFrom: self.chlCheckInDateFrom != null ? self.chlCheckInDateFrom.format("DD/MM/YYYY") : self.chlCheckInDateFrom,
          CheckInDateTo: self.chlCheckInDateTo != null ? self.chlCheckInDateTo.format("DD/MM/YYYY") : self.chlCheckInDateTo,
          AgentCodes: self.pmrAgentCodes,
          ShopIds: self.pmrShopCodes,
          SubAgentShopIds: self.pmrSubAgentShopCodes,
          SubAgentCodes: self.pmrSubAgentCodes,
          PMResult: self.chlPMResult
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลคงค้างเกินกำหนดหรือไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
        self.isExporting = false;
      });
    },
    LoadpmrAgentCodesOptions: function LoadpmrAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM", {
        province_id: [],
        department: [],
        agentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.pmrAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, dpOptions, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;


              self.LoadpmrAgentCodesOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              // Issue 40: init 2 datepickers (from + to)
              dpOptions = {
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(),
                maxDate: moment().add(30, "days"),
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              };

              $(self.$refs.chlCheckInDateFrom).datepicker(dpOptions);
              $(self.$refs.chlCheckInDateFrom).on("changeDate", function (e) {
                self.chlCheckInDateFrom = e.date ? moment(e.date) : null;
              });
              $(self.$refs.chlCheckInDateTo).datepicker(dpOptions);
              $(self.$refs.chlCheckInDateTo).on("changeDate", function (e) {
                self.chlCheckInDateTo = e.date ? moment(e.date) : null;
              });
              // 2026-08-09: แสดง default เดือนปัจจุบันในช่อง datepicker (jQuery ไม่ bind กับ Vue model)
              if (self.chlCheckInDateFrom) $(self.$refs.chlCheckInDateFrom).datepicker("update", self.chlCheckInDateFrom.format("DD/MM/YYYY"));
              if (self.chlCheckInDateTo) $(self.$refs.chlCheckInDateTo).datepicker("update", self.chlCheckInDateTo.format("DD/MM/YYYY"));

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#checkInTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/PMSurvey/SurveyCheckIn/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    // Issue 40: date range — clear stale state if input was cleared
                    var idDateFrom = $("#chlCheckInDateFrom").val();
                    if (idDateFrom == null || idDateFrom == "") self.chlCheckInDateFrom = null;
                    var idDateTo = $("#chlCheckInDateTo").val();
                    if (idDateTo == null || idDateTo == "") self.chlCheckInDateTo = null;

                    var jsonSearch = {
                      SearchKeyword: self.chlKeyword,
                      CheckInDateFrom: self.chlCheckInDateFrom != null ? self.chlCheckInDateFrom.format("DD/MM/YYYY") : self.chlCheckInDateFrom,
                      CheckInDateTo: self.chlCheckInDateTo != null ? self.chlCheckInDateTo.format("DD/MM/YYYY") : self.chlCheckInDateTo,
                      AgentCodes: self.pmrAgentCodes, //chlShopIds,
                      ShopIds: self.pmrShopCodes, //chlShopIds,
                      SubAgentShopIds: self.pmrSubAgentShopCodes, //chlShopIds,
                      SubAgentCodes: self.pmrSubAgentCodes, //chlShopIds,
                      PMResult: self.chlPMResult
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "desc"]],
                columns: [{
                  data: "checkInDate",
                  // CR-PM-2026 Req 2 — dt-control toggles expand row showing วันที่ Check-Out
                  className: "text-center dt-control",
                  render: function render(data, type, full, meta) {
                    return full.checkInDateFormat;
                  }
                }, { data: "routeName", className: "text-center" }, {
                  data: "agentName",
                  className: "text-center",
                  width: "15%",
                  render: function render(data, type, full, meta) {
                    if (full.agentTypeCode == "SUB_AGENT") {
                      return full.subAgentName != null ? full.subAgentName : "";
                    } else {
                      return full.agentName != null ? full.agentName : "";
                    }
                  }
                }, {
                  data: "agentTypeCode",
                  className: "text-center",
                  width: "10%",
                  render: function render(data, type, full, meta) {
                    return full.agentTypeName;
                  }
                }, { data: "checkInByUserFullName", className: "text-center" }, {
                  data: "shopName",
                  className: "text-center",
                  width: "15%",
                  render: function render(data, type, full, meta) {
                    if (full.agentTypeCode == "SUB_AGENT") {
                      return full.subAgentShopName != null ? full.subAgentShopName : "";
                    } else {
                      return full.shopName != null ? full.shopName : "";
                    }
                  }
                }, {
                  data: "shopName2",
                  className: "text-center",
                  width: "15%",
                  render: function render(data, type, full, meta) {
                    if (full.agentTypeCode == "SUB_AGENT") {
                      return full.subAgentShopName2 != null ? full.subAgentShopName2 : "";
                    } else {
                      return full.shopName2 != null ? full.shopName2 : "";
                    }
                  }
                },

                // { data: "shopName", className: "text-center" },
                // { data: "shopName2", className: "text-center" },
                { data: "workStatusText", className: "text-center" }, {
                  data: "reasonForFailedWork",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="reason_actions"></div>';
                  }
                }, {
                  data: "checkInItemId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="remark_actions"></div>';
                  }
                }, {
                  data: "checkInItemId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  //console.log(data);
                  if (data) {
                    data.showDetailButton = self.$root.canShow(["ADMIN_PM", "AGENT_ADMIN_PM", 'SUB_AGENT_ADMIN_PM', "COOL_SERVICE_PM"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                // CR-PM-2026 Req 1: Mount ActionReason in เหตุผล column (Survey)
                $(".reason_actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showMediaIcon = data.workStatusText === 'ดำเนินการไม่สำเร็จ';
                    new ActionReason({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
                $(".remark_actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  //console.log(data);
                  if (data) {
                    data.showRemarkButton = self.$root.canShow(["ADMIN_PM", "super_admin"]);
                    new ActionRemark({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

              // CR-PM-2026 Req 2 — Expand/collapse row to show วันที่ Check-Out (mirror BudgetPlanJobList pattern)
              $("#checkInTable tbody").on("click", "td.dt-control", function () {
                var tr = $(this).closest("tr");
                var row = table.DataTable().row(tr);
                if (row.child.isShown()) {
                  row.child.hide();
                  tr.removeClass("shown");
                } else {
                  var d = row.data();
                  if (d) {
                    var checkout = d.quitShopDateFormat ? d.quitShopDateFormat : "-";
                    row.child('<div style="background:#f9f9f9; padding:8px 16px;">' + '<strong>วันที่ Check-Out:</strong> ' + checkout + '</div>').show();
                    tr.addClass("shown");
                  }
                }
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              $("#PictureModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                //self.$parent.reloadDataTable(false);
              }).modal("show");

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Action Button Design System + Stepper ของโมดูลนี้ (QA เรื่องที่ 11 + 16)

// FS-088 — tooltip ของปุ่มวงกลมเป็นแบบ Bootstrap (ผูกครั้งเดียวทั้งโมดูล เรียกซ้ำได้)

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__["a" /* installFssTooltips */])();


__webpack_require__(9);

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F08 — popup "แนบไฟล์เอกสารที่เซ็นแล้ว"
//
// เปิดจากปุ่มแนบไฟล์ในตารางของ FormSummaryStockList.vue ผ่าน $refs:
//   this.$parent.$refs.attachmentModal.open(rowData)
// ปิด popup แล้ว component emit "closed" ให้หน้ารายการ reload ตาราง (สีปุ่มแดง/เขียวจะได้ตรง)
//
// Template ที่ mirror: SBP.Web/App/Components/BudgetPlan/BudgetPlanList.vue (Import Modal)
//   — bootstrap 4 modal + FormData + axios + KTApp.block + Swal.fire
//
// SweetAlert2 = 8.13.3 (SBP.Web/package.json ^8.2.3) → ใช้ option ชื่อ `type` (ไม่ใช่ `icon` ของ v9+)
// และอ่านผลการยืนยันจาก `result.value`
//
// กฎทั้งหมดด้านล่างถูก "บังคับซ้ำที่ฝั่ง server" ใน UploadFormSummaryStockAttachmentCommandHandler
// ที่ตรวจในนี้เป็นแค่ด่านแรกเพื่อ UX (ไม่ต้องรอ round-trip)
// ─────────────────────────────────────────────────────────────────────────────

// ชนิดไฟล์ที่อนุญาต — ตรงกับ FormSummaryStockAttachmentRules.AllowedExtensions (backend)
var ALLOWED_EXTENSIONS = [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".jpg", ".jpeg", ".png"];

// 10 MB ต่อไฟล์ — ตรงกับ FormSummaryStockAttachmentRules.MaxFileSizeBytes
var MAX_FILE_SIZE = 10 * 1024 * 1024;

// เพดานจำนวนไฟล์สำรอง กรณี API ไม่ได้ส่ง maxFiles กลับมา
var DEFAULT_MAX_FILES = 5;

// escape ก่อนยัดชื่อไฟล์ลง Swal html — ชื่อไฟล์มาจากผู้ใช้ ห้ามเชื่อ
function escapeHtml(value) {
  if (value === null || value === undefined) return "";
  return String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

// ขนาดไฟล์อ่านง่าย ใช้เฉพาะข้อความเตือนฝั่ง UI (ตัวเลขที่แสดงในตารางมาจาก API)
function formatBytes(bytes) {
  if (!bytes || bytes <= 0) return "-";
  if (bytes >= 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(2) + " MB";
  if (bytes >= 1024) return (bytes / 1024).toFixed(2) + " KB";
  return bytes + " B";
}

function getExtension(fileName) {
  if (!fileName) return "";
  var dotIndex = String(fileName).lastIndexOf(".");
  if (dotIndex < 0) return "";
  return String(fileName).substring(dotIndex).toLowerCase();
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // FormSummaryStock_Header.Id ของใบงานที่กำลังเปิดอยู่
      headerId: null,
      documentNo: "",
      // แถวไฟล์จาก API: { id, fileName, contentType, sizeText, downloadUrl, uploadedAt, canPreview }
      files: [],
      maxFiles: DEFAULT_MAX_FILES,
      loading: false,
      uploading: false,
      isDragOver: false,
      // F08 (F2) — กันกดซ้ำระหว่างรวมไฟล์
      downloadingAll: false,
      // QA เรื่องที่ 18 — id ของไฟล์ที่กำลังดาวน์โหลด (null = ไม่มี)
      downloadingId: null
    };
  },
  computed: {
    fileCount: function fileCount() {
      return this.files ? this.files.length : 0;
    },
    isFull: function isFull() {
      return this.fileCount >= this.maxFiles;
    },
    acceptAttr: function acceptAttr() {
      return ALLOWED_EXTENSIONS.join(",");
    }
  },
  methods: {
    // ── เปิด/ปิด popup ────────────────────────────────────────────────────
    // เรียกจากหน้ารายการ: this.$parent.$refs.attachmentModal.open(rowData)
    open: function open(row) {
      if (!row || !row.id) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบใบงานที่ต้องการแนบไฟล์", "error");
        return;
      }

      this.headerId = row.id;
      this.documentNo = row.documentNo || "";
      this.files = [];
      this.isDragOver = false;
      this.uploading = false;
      this.downloadingAll = false;
      this.resetFileInput();

      // $refs safety — root element ไม่ได้อยู่ใน v-if จึงมีเสมอ แต่กันไว้เผื่อถูกเรียกก่อน mount เสร็จ
      if (this.$refs.modalRoot) {
        $(this.$refs.modalRoot).modal("show");
      }

      this.loadFiles();
    },

    // ── F08 (F2) : ดาวน์โหลดไฟล์แนบทั้งหมด ────────────────────────────────
    //
    //   endpoint ต้องการ Bearer token จึงยิงด้วย axios แล้วแปลงเป็น blob
    //   ใช้ <a href> ธรรมดาไม่ได้ เพราะการ navigate ของเบราว์เซอร์ไม่แนบ header ให้
    //   (บทเรียนเดียวกับปุ่มดาวน์โหลด ZIP ของ F13)
    //
    //   สูงสุด 5 ไฟล์ × 10 MB = 50 MB จึงรอในคำขอเดียวได้ ไม่ต้องมี progress
    downloadAll: function downloadAll() {
      var self = this;

      if (!self.headerId || self.fileCount === 0 || self.downloadingAll) return;

      self.downloadingAll = true;
      KTApp.block("#formSummaryStockAttachmentModal .modal-content", {});

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/FormSummaryStock/Attachment/DownloadAll",
        responseType: "blob",
        data: { headerId: self.headerId },
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        var contentType = response.headers["content-type"] || "";

        // server ปฏิเสธ (ไม่มีไฟล์ / ไม่มีสิทธิ์) จะคืน JSON ไม่ใช่ไฟล์
        if (contentType.indexOf("application/json") !== -1) {
          var reader = new FileReader();
          reader.onload = function () {
            var message = "ดาวน์โหลดไฟล์แนบไม่สำเร็จ";
            try {
              var parsed = JSON.parse(reader.result);
              if (parsed && parsed.message) message = parsed.message;
            } catch (e) {
              // ปล่อยข้อความเริ่มต้นไว้
            }
            Swal.fire("ดาวน์โหลดไม่ได้", message, "warning");
          };
          reader.readAsText(response.data);
          return;
        }

        // ชื่อไฟล์ถูก encode เป็น %20 ฝั่ง server แล้ว
        var filename = "";
        var disposition = response.headers["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var marker = "filename=";
          var at = disposition.indexOf(marker);
          if (at !== -1) {
            filename = disposition.substring(at + marker.length);
            var semi = filename.indexOf(";");
            if (semi !== -1) filename = filename.substring(0, semi);
            filename = filename.trim().replace(/^["']|["']$/g, "");
          }
        }

        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(response.data);
        link.download = decodeURIComponent(filename) || "เอกสารแนบ.zip";
        link.click();

        setTimeout(function () {
          window.URL.revokeObjectURL(link.href);
        }, 30000);
      }).catch(function () {
        Swal.fire("เกิดข้อผิดพลาด", "ดาวน์โหลดไฟล์แนบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
      }).then(function () {
        self.downloadingAll = false;
        KTApp.unblock("#formSummaryStockAttachmentModal .modal-content");
      });
    },

    // ── โหลดรายการไฟล์แนบของใบงาน ─────────────────────────────────────────
    loadFiles: function loadFiles(showBlock) {
      var self = this;
      var block = showBlock !== false;

      if (!self.headerId) return Promise.resolve();

      self.loading = true;
      if (block) self.blockModal("กำลังโหลดข้อมูล กรุณารอสักครู่...");

      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Attachments", { headerId: self.headerId }, {
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token
        }
      }).then(function (response) {
        var data = response.data || {};
        if (data.success) {
          self.files = data.files || [];
          if (data.maxFiles > 0) self.maxFiles = data.maxFiles;
        } else {
          self.files = [];
          Swal.fire("เกิดข้อผิดพลาด", data.message || "ไม่สามารถโหลดรายการไฟล์แนบได้", "error");
        }
      }).catch(function (error) {
        self.files = [];
        Swal.fire("เกิดข้อผิดพลาด", self.resolveErrorMessage(error, "ไม่สามารถโหลดรายการไฟล์แนบได้"), "error");
      }).then(function () {
        self.loading = false;
        if (block) self.unblockModal();
      });
    },

    // ── เลือกไฟล์ด้วยการคลิก ──────────────────────────────────────────────
    pickFile: function pickFile() {
      if (this.uploading) return;

      if (this.isFull) {
        Swal.fire("แนบไฟล์ไม่ได้", "ใบงานนี้มีไฟล์แนบครบ " + this.maxFiles + " ไฟล์แล้ว กรุณาลบไฟล์เดิมออกก่อนจึงจะแนบไฟล์ใหม่ได้", "warning");
        return;
      }

      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      }
    },

    onFileChange: function onFileChange(e) {
      var files = e && e.target ? e.target.files : null;
      this.uploadFiles(files);
    },

    // ── ลากไฟล์มาวาง ──────────────────────────────────────────────────────
    onDragOver: function onDragOver() {
      if (this.uploading || this.isFull) return;
      this.isDragOver = true;
    },

    onDragLeave: function onDragLeave() {
      this.isDragOver = false;
    },

    onDrop: function onDrop(e) {
      this.isDragOver = false;

      if (this.uploading) return;

      if (this.isFull) {
        Swal.fire("แนบไฟล์ไม่ได้", "ใบงานนี้มีไฟล์แนบครบ " + this.maxFiles + " ไฟล์แล้ว กรุณาลบไฟล์เดิมออกก่อนจึงจะแนบไฟล์ใหม่ได้", "warning");
        return;
      }

      var files = e && e.dataTransfer ? e.dataTransfer.files : null;
      this.uploadFiles(files);
    },

    // ── อัพโหลด (ทีละไฟล์เรียงกัน แล้วสรุปผลครั้งเดียว) ───────────────────
    uploadFiles: function uploadFiles(fileList) {
      var self = this;

      if (!fileList || fileList.length === 0) return;
      if (self.uploading) return;

      var picked = Array.prototype.slice.call(fileList);
      var accepted = [];
      var rejected = [];

      picked.forEach(function (file) {
        var reason = self.validateFile(file, self.fileCount + accepted.length);
        if (reason) {
          rejected.push(escapeHtml(file.name) + " — " + reason);
        } else {
          accepted.push(file);
        }
      });

      if (accepted.length === 0) {
        self.resetFileInput();
        Swal.fire({
          title: "แนบไฟล์ไม่ได้",
          type: "warning",
          html: rejected.join("<br/>")
        });
        return;
      }

      self.uploading = true;
      self.blockModal("กำลังอัพโหลดไฟล์ กรุณารอสักครู่...");

      var succeeded = 0;
      var failed = rejected.slice();
      var chain = Promise.resolve();

      accepted.forEach(function (file) {
        chain = chain.then(function () {
          return self.sendFile(file);
        }).then(function (result) {
          if (result.success) {
            succeeded++;
          } else {
            failed.push(escapeHtml(file.name) + " — " + escapeHtml(result.message));
          }
        });
      });

      chain.then(function () {
        return self.loadFiles(false);
      }).then(function () {
        self.uploading = false;
        self.unblockModal();
        self.resetFileInput();

        if (failed.length === 0) {
          Swal.fire("สำเร็จ", "แนบไฟล์เอกสารสำเร็จ " + succeeded + " ไฟล์", "success");
        } else if (succeeded > 0) {
          Swal.fire({
            title: "แนบไฟล์บางส่วนไม่สำเร็จ",
            type: "warning",
            html: "แนบสำเร็จ " + succeeded + " ไฟล์<br/>ไม่สำเร็จ " + failed.length + " ไฟล์<br/>" + failed.join("<br/>")
          });
        } else {
          Swal.fire({
            title: "เกิดข้อผิดพลาด",
            type: "error",
            html: failed.join("<br/>")
          });
        }
      });
    },

    // ส่ง 1 ไฟล์ — คืน { success, message } เสมอ (ไม่ reject) เพื่อให้ chain เดินต่อได้
    sendFile: function sendFile(file) {
      var self = this;

      var formData = new FormData();
      formData.append("headerId", self.headerId);
      formData.append("file", file);

      // ไม่กำหนด Content-Type เอง — axios/เบราว์เซอร์ต้องเป็นคนใส่ boundary ของ multipart ให้
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Attachment/Upload", formData, {
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token
        }
      }).then(function (response) {
        var data = response.data || {};
        return {
          success: !!data.success,
          message: data.message || "แนบไฟล์ไม่สำเร็จ"
        };
      }).catch(function (error) {
        return {
          success: false,
          message: self.resolveErrorMessage(error, "แนบไฟล์ไม่สำเร็จ")
        };
      });
    },

    // ตรวจก่อนส่ง — คืนข้อความเหตุผลเมื่อไฟล์ใช้ไม่ได้, คืน null เมื่อผ่าน
    validateFile: function validateFile(file, projectedCount) {
      if (!file) return "ไม่พบไฟล์";

      if (projectedCount >= this.maxFiles) {
        return "เกินจำนวนสูงสุด " + this.maxFiles + " ไฟล์ต่อใบงาน";
      }

      var ext = getExtension(file.name);
      if (ALLOWED_EXTENSIONS.indexOf(ext) < 0) {
        return "ชนิดไฟล์ไม่รองรับ (รองรับ PDF, Word, Excel และรูปภาพ .jpg/.png)";
      }

      if (!file.size || file.size <= 0) {
        return "ไฟล์ว่าง ไม่มีข้อมูล";
      }

      if (file.size > MAX_FILE_SIZE) {
        return "ขนาด " + formatBytes(file.size) + " เกิน 10 MB";
      }

      return null;
    },

    // ── ดู / ดาวน์โหลด ────────────────────────────────────────────────────
    // "ดู" = PDF และรูปภาพเท่านั้น (backend ส่ง canPreview มาให้) เปิด preview ในแถบใหม่
    viewFile: function viewFile(file) {
      if (!file || !file.downloadUrl) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบลิงก์ของไฟล์นี้ กรุณาลองใหม่อีกครั้ง", "error");
        return;
      }
      window.open(file.downloadUrl, "_blank", "noopener");
    },

    /**
     * QA 08/10/2026 เรื่องที่ 18 — ต้องดาวน์โหลดลงเครื่องจริง ไม่ใช่เปิดแท็บใหม่
     *
     * ของเดิมชี้ <a download> ไปที่ downloadUrl ซึ่งเป็น signed URL ของ GCS
     * attribute download ใช้ได้เฉพาะลิงก์ origin เดียวกัน เบราว์เซอร์จึงไม่สนใจแล้วเปิดแท็บแทน
     * กลายเป็นว่าปุ่มนี้ทำงานเหมือนปุ่ม "ดู" ทุกประการ
     *
     * ตอนนี้ดึงผ่าน endpoint ของแอปเอง (same-origin) แล้วบันทึกจาก blob
     */
    downloadFile: function downloadFile(file) {
      var self = this;

      if (!file || !file.id) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบไฟล์ที่ต้องการดาวน์โหลด กรุณาลองใหม่อีกครั้ง", "error");
        return;
      }

      if (self.downloadingId) return;
      self.downloadingId = file.id;

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/FormSummaryStock/Attachment/Download",
        responseType: "blob",
        data: { headerId: self.headerId, attachmentId: file.id },
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        var contentType = response.headers["content-type"] || "";

        // server ปฏิเสธ (ไม่มีสิทธิ์ / ไฟล์หาย) จะคืน JSON ไม่ใช่ไฟล์
        if (contentType.indexOf("application/json") !== -1) {
          var reader = new FileReader();
          reader.onload = function () {
            var message = "ดาวน์โหลดไฟล์ไม่สำเร็จ";
            try {
              var parsed = JSON.parse(reader.result);
              if (parsed && parsed.message) message = parsed.message;
            } catch (e) {
              // ปล่อยข้อความเริ่มต้นไว้
            }
            Swal.fire("ดาวน์โหลดไม่สำเร็จ", message, "error");
          };
          reader.readAsText(response.data);
          return;
        }

        self.saveBlob(response.data, file.fileName || "attachment");
      }).catch(function () {
        Swal.fire("ดาวน์โหลดไม่สำเร็จ", "ไม่สามารถดาวน์โหลดไฟล์นี้ได้ กรุณาลองใหม่อีกครั้ง", "error");
      }).then(function () {
        self.downloadingId = null;
      });
    },

    // บันทึก blob ลงเครื่อง
    saveBlob: function saveBlob(blob, fileName) {
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // ปล่อย object URL ทีหลังเล็กน้อย — บางเบราว์เซอร์ยังอ่านอยู่ตอน click เพิ่งจบ
      window.setTimeout(function () {
        window.URL.revokeObjectURL(url);
      }, 1000);
    },

    // ── ลบไฟล์ (hard delete — ยืนยัน 1 ครั้งแล้วหายจริง) ──────────────────
    confirmDelete: function confirmDelete(file) {
      var self = this;

      if (!file || !file.id) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบไฟล์ที่ต้องการลบ", "error");
        return;
      }

      Swal.fire({
        title: "ยืนยันการลบไฟล์แนบ",
        type: "warning",
        html: "ต้องการลบไฟล์ <strong>" + escapeHtml(file.fileName) + "</strong> ใช่หรือไม่?<br/>" + "<small class='text-muted'>ไฟล์จะถูกลบออกจากระบบทันทีและกู้คืนไม่ได้ " + "(ต่างจากการลบใบงานที่ยังเก็บข้อมูลไว้ในฐานข้อมูล)</small>",
        showCancelButton: true,
        confirmButtonText: "ยืนยันลบ",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          self.deleteFile(file);
        }
      });
    },

    deleteFile: function deleteFile(file) {
      var self = this;

      self.blockModal("กำลังลบไฟล์ กรุณารอสักครู่...");

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Attachment/Delete", { headerId: self.headerId, attachmentId: file.id }, {
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token
        }
      }).then(function (response) {
        var data = response.data || {};
        if (data.success) {
          return self.loadFiles(false).then(function () {
            Swal.fire("สำเร็จ", data.message || "ลบไฟล์แนบสำเร็จ", "success");
          });
        }
        Swal.fire("เกิดข้อผิดพลาด", data.message || "ลบไฟล์แนบไม่สำเร็จ", "error");
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", self.resolveErrorMessage(error, "ลบไฟล์แนบไม่สำเร็จ"), "error");
      }).then(function () {
        self.unblockModal();
      });
    },

    // ── helper ────────────────────────────────────────────────────────────
    typeLabel: function typeLabel(file) {
      var ext = this.normalizedType(file);
      if (ext === "pdf") return "PDF";
      if (ext === "doc" || ext === "docx") return "Word";
      if (ext === "xls" || ext === "xlsx") return "Excel";
      if (ext === "jpg" || ext === "jpeg" || ext === "png") return "รูปภาพ";
      return ext ? ext.toUpperCase() : "-";
    },

    // FS-036 ข้อ 6 — Excel/Word เปิดดูออนไลน์ไม่ได้ (ตรงกับ canPreview = false ฝั่ง backend)
    //   ตัดสินจาก "ชนิดไฟล์" ไม่ใช่ !canPreview เพราะ canPreview อาจไม่มีค่ามาจาก API
    //   แล้วหมายเหตุจะไปโผล่กับ PDF/รูปภาพซึ่งเปิดดูได้อยู่แล้ว
    isDownloadOnly: function isDownloadOnly(file) {
      var ext = this.normalizedType(file);
      return ext === "doc" || ext === "docx" || ext === "xls" || ext === "xlsx";
    },

    typeIcon: function typeIcon(file) {
      var ext = this.normalizedType(file);
      if (ext === "pdf") return "fas fa-file-pdf text-danger";
      if (ext === "doc" || ext === "docx") return "fas fa-file-word text-primary";
      if (ext === "xls" || ext === "xlsx") return "fas fa-file-excel text-success";
      if (ext === "jpg" || ext === "jpeg" || ext === "png") return "fas fa-file-image text-info";
      return "fas fa-file";
    },

    // Attachment.ContentType ของระบบเก็บเป็น "นามสกุลไม่มีจุด" (Issue #33) แต่รองรับทั้ง 2 แบบไว้
    normalizedType: function normalizedType(file) {
      if (!file) return "";
      var raw = file.contentType || getExtension(file.fileName);
      return String(raw).toLowerCase().replace(/^\./, "");
    },

    formatDate: function formatDate(value) {
      return value ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format("DD/MM/YYYY HH:mm") : "-";
    },

    resetFileInput: function resetFileInput() {
      // $refs safety — input อยู่นอก v-if จึงมีเสมอ แต่กันไว้เผื่อ reset ถูกเรียกก่อน mount เสร็จ
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },

    // บังเฉพาะกล่อง modal ไม่บังทั้งหน้า เพราะ popup ยังเปิดค้างระหว่างทำงาน
    blockModal: function blockModal(message) {
      if (this.$refs.modalContent) {
        KTApp.block(this.$refs.modalContent, {
          overlayColor: "#000000",
          opacity: 0.05,
          message: message
        });
      }
    },

    unblockModal: function unblockModal() {
      if (this.$refs.modalContent) {
        KTApp.unblock(this.$refs.modalContent);
      }
    },

    resolveErrorMessage: function resolveErrorMessage(error, fallback) {
      return error && error.response && error.response.data && error.response.data.message ? error.response.data.message : fallback;
    }
  },
  mounted: function mounted() {
    var self = this;

    if (self.$refs.modalRoot) {
      // ปิด popup แล้วให้หน้ารายการ reload ตาราง — สีปุ่มแนบไฟล์ (แดง/เขียว) จะได้ตรงกับจำนวนไฟล์จริง
      $(self.$refs.modalRoot).on("hidden.bs.modal", function () {
        self.files = [];
        self.isDragOver = false;
        self.uploading = false;
        self.resetFileInput();
        self.$emit("closed");
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$refs.modalRoot) {
      $(this.$refs.modalRoot).off("hidden.bs.modal");
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormSummaryStockProgressModal__ = __webpack_require__(136);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Action Button Design System + Stepper ของโมดูลนี้ (QA เรื่องที่ 11 + 16)

// FS-088 — tooltip ของปุ่มวงกลมเป็นแบบ Bootstrap (ผูกครั้งเดียวทั้งโมดูล เรียกซ้ำได้)

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__["a" /* installFssTooltips */])();

// import the component

// import the styles

// FS-033 — popup ความคืบหน้าตัวเดียวกับที่ขั้น 3B / ขั้นที่ 6 ใช้


__webpack_require__(9);

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F03 — ขั้นที่ 1 "เลือก Filter" (/PrintSummary/Barcodes/New)
//
// Dropdown ทั้ง 9 ตัว copy loader + markup มาจากหน้ารายงาน "Stock รายบาร์โค้ด"
//   SBP.Web/App/Components/Report/Barcodes.vue  (ระบุบรรทัดต้นทางกำกับไว้ทุก method)
// เพื่อให้ตัวเลือกที่ผู้ใช้เห็นในสองหน้านี้เป็นชุดเดียวกันเป๊ะ
//
// การส่ง state ข้าม step: ใช้ pattern ของ repo คือ "route ลูกอ่านค่าจาก $parent"
//   ต้นแบบ: SBP.Web/App/Components/BeerClaim/AddBeerClaim.vue (พ่อถือ state)
//         + SBP.Web/App/Components/BeerClaim/AddBeerClaimItem.vue:1113-1115 (ลูกอ่าน $parent)
//   → หน้านี้เป็น "พ่อ" ของ /New/Preview และ /New/GroupPreview จึงถือ filter + ผลประมวลผลไว้เอง
//     · FormSummaryStockPreview.vue:214-226  อ่าน $parent.processResult / filterLabels / filter
//     · FormSummaryStockGroupPreview.vue:347-413 อ่าน $parent.groupProcessResult / groupAgentCodes
//       (+ ถอยไปอ่าน processResult.agents และ filter.agentCodes ถ้าไม่มี — หน้านี้เซ็ตให้ครบทั้งคู่)
//
// ── spec ฉบับเซ็น 16/09/2026 (F03) ──────────────────────────────────────────
// Filter บังคับทั้ง 2 ตัวเป็น multi-select (ยังคง "เลือกได้อย่างใดอย่างหนึ่ง")
//   • เลือก 1 ราย     → POST /Api/FormSummaryStock/Process      → /New/Preview       (ของเดิม)
//   • เลือก 2 รายขึ้นไป → POST /Api/FormSummaryStock/GroupProcess → /New/GroupPreview (ขั้นที่ 3B)
//   • ตัวเลือก "ทั้งหมด" เป็น option แรกของ dropdown และใส่ให้เมื่อ dropdown นั้นมีตัวเลือกมากกว่า 1 รายการ
//     (FS-010 — เดิมทำเป็นปุ่มลอยนอกกล่อง ย้ายมาเป็น option ตามแพตเทิร์นที่ระบบใช้อยู่ Barcodes.vue:1259)
//     เลือก "ทั้งหมด" แล้ว watcher จะขยายเป็นรหัสจริงทุกตัวทันที → payload ที่ส่งไป API
//     ไม่มี sentinel "0" ปนไป และเหมือนกับตอนที่ยังเป็นปุ่มทุกประการ
//   • dropdown "ตัวแทนจำหน่าย (Group)" เหลือเฉพาะสำนักงานใหญ่ + ตัวแทนที่ไม่มีสาขา
//     (ส่ง IsHead = true ให้ Select2SearchAgentCodeQuery — ดู LoadHeadAgentCodeOptions)
//
// SweetAlert2 = ^8.2.3 (SBP.Web/package.json) → ใช้ option ชื่อ `type` (ไม่ใช่ `icon` ของ v9+)
// vue-treeselect = ^0.4.0 → options เป็น { id, label } และต้อง import CSS เอง
// ─────────────────────────────────────────────────────────────────────────────

// ตรงกับ SBP.Application/FormSummaryStock/Models/FormSummaryStockFilter.cs (FormSummaryStockFilterType)
var FILTER_TYPE_AGENT = "AGENT";
var FILTER_TYPE_GROUP = "GROUP";

// id ของ option "ทั้งหมด" ใน dropdown — ใช้ "0" ตรงกับแพตเทิร์นของระบบ (Barcodes.vue:1259)
// เป็นแค่ sentinel บนหน้าจอเท่านั้น ไม่เคยถูกส่งออกไปกับ payload (watcher ขยายเป็นรหัสจริงก่อนเสมอ)
var SELECT_ALL_ID = "0";

// ข้อความที่แสดงแทนรายการจริงเมื่อผู้ใช้เลือก "ทั้งหมด" (QA เรื่องที่ 9)
var SELECT_ALL_LABEL = "ทั้งหมด";

// CR-01 (08/10/2026) — รหัสสินค้าที่ไม่ติดตามการคงค้าง (เป็นของร้านค้า ไม่ใช่ของบริษัท)
//   ต้องตรงกับ FormSummaryStockConstants.ProductCodeCoolRoom / ProductCodeFontShop ฝั่ง server
var EXCLUDED_PRODUCT_CODES = ["COOL-ROOM-01", "FONT-SHOP-01"];

// treeselect คืนค่า id ตามชนิดที่ option ใส่ไว้ (บาง loader ใส่เป็น string เช่น ปีคงค้าง)
// แต่ FormSummaryStockFilter.cs ประกาศเป็น List<int> → บังคับชนิดตอนประกอบ payload
function toIntList(values) {
  if (!values || values.length === 0) return null;
  return values.map(function (v) {
    return parseInt(v, 10);
  }).filter(function (v) {
    return !isNaN(v);
  });
}

// FormSummaryStockFilter.AssetCode = List<string>
function toStringList(values) {
  if (!values || values.length === 0) return null;
  return values.map(function (v) {
    return String(v);
  });
}

// FS-078 — เลิกหน่วงเปิด popup ของ "ประมวลผลตัวแทนรายเดียว" (เดิม SINGLE_PROCESS_DEFER_MS = 700 ของ FS-033)
//   popup เปิดทันทีทั้งสองโหมด จึงไม่ต้องมี overlay คั่นช่วงหน่วงอีก

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a,
    FormSummaryStockProgressModal: __WEBPACK_IMPORTED_MODULE_6__FormSummaryStockProgressModal__["a" /* default */]
  },
  computed: {
    // treeselect แบบ multiple คืนค่าเป็น array เสมอ — แต่กัน null/undefined ไว้ให้ทุกที่ที่อ่านค่า
    // ใช้ .length ได้อย่างปลอดภัย (ตัว template ผูกกับ computed เหล่านี้ ไม่ผูกกับ v-model ตรง ๆ)
    // FS-016 — v-model เก็บ sentinel "0" ไว้ตามที่ผู้ใช้เลือก (กล่องจะได้โชว์ chip "ทั้งหมด"
    // ชิ้นเดียว ไม่ระเบิดเป็นรหัสทุกราย) การขยายเป็นรหัสจริงย้ายมาทำที่นี่แทน
    // ทุกอย่างที่อยู่ถัดจากนี้ (count / isGroupDocumentMode / payload) อ่านผ่าน computed คู่นี้
    // อยู่แล้ว ผลลัพธ์ปลายทางจึงเท่าเดิมเป๊ะ
    agentCodeList: function agentCodeList() {
      var raw = Array.isArray(this.reBHostAgentCode) ? this.reBHostAgentCode : [];
      return this.hasSelectAllOption(raw) ? this.realOptionIds(this.reBHostAgentCodeOptions) : raw;
    },
    groupCodeList: function groupCodeList() {
      var raw = Array.isArray(this.HeadAgentCode) ? this.HeadAgentCode : [];
      return this.hasSelectAllOption(raw) ? this.realOptionIds(this.HeadAgentCodeOptions) : raw;
    },
    agentCodeCount: function agentCodeCount() {
      return this.agentCodeList.length;
    },
    groupCodeCount: function groupCodeCount() {
      return this.groupCodeList.length;
    },
    // filter บังคับเลือกได้อย่างใดอย่างหนึ่ง — เลือกตัวไหนแล้วอีกตัวถูกปิด
    isAgentSelected: function isAgentSelected() {
      return this.agentCodeCount > 0;
    },
    isGroupSelected: function isGroupSelected() {
      return this.groupCodeCount > 0;
    },
    // รหัสที่จะประมวลผลจริง (มาจาก filter บังคับตัวที่ผู้ใช้เลือกไว้)
    selectedCodes: function selectedCodes() {
      return this.isAgentSelected ? this.agentCodeList : this.groupCodeList;
    },
    // 2 รายขึ้นไป = โหมดสร้างเอกสารรวม (ขั้นที่ 3B)
    isGroupDocumentMode: function isGroupDocumentMode() {
      return this.selectedCodes.length > 1;
    },
    // FS-033 — popup ความคืบหน้าอยู่ได้เฉพาะตอนอยู่หน้าเลือก Filter
    //   (route ลูก 3B mount popup ตัวเดียวกัน ห้ามให้อยู่ใน DOM พร้อมกัน)
    isOnFilterStep: function isOnFilterStep() {
      return this.$route.path === "/PrintSummary/Barcodes/New";
    },
    // ค่าที่ jQuery-validate เอาไปเช็ค required — มีค่าเมื่อเลือก filter บังคับตัวใดตัวหนึ่งแล้ว
    // (ส่งเป็นจำนวนที่เลือก เพื่อให้ค่าเปลี่ยนทุกครั้งที่ผู้ใช้เพิ่ม/ลดรายการ → validator re-check)
    requiredFilterValue: function requiredFilterValue() {
      var count = this.agentCodeCount + this.groupCodeCount;
      return count > 0 ? String(count) : "";
    }
  },
  data: function data() {
    return {
      // ── Filter บังคับ (multi select — เลือกได้อย่างใดอย่างหนึ่ง แต่ในตัวที่เลือกใส่ได้หลายราย) ──
      // ชื่อ v-model/options ใช้ชื่อเดียวกับ Barcodes.vue เพื่อให้ loader copy มาได้ตรง ๆ
      reBHostAgentCode: [],
      reBHostAgentCodeOptions: [],
      HeadAgentCode: [],
      HeadAgentCodeOptions: [],

      // ── Filter ไม่บังคับ (multi select ทั้ง 7 ตัว) ─────────────────────────
      AssetOwnerId: [],
      AssetOwnerOptions: [],
      Circulate: [],
      CirculateOptions: [],
      PeriodRange: [],
      PeriodRangeOptions: [],
      BarcodeYear: [],
      AllBarcodeYearOptions: [],
      PeriodYear: [],
      PeriodYearOptions: [],
      reBProductTypeId: [],
      reBProductTypeIdOptions: [],
      reBAssetCode: [],
      reBAssetCodeOptions: [],

      // ── State ที่ส่งต่อให้ step 2 (/New/Preview, /New/GroupPreview อ่านผ่าน $parent) ──
      // filter object ที่ POST ไปแล้ว — Preview/GroupPreview ใช้ตัวเดียวกันนี้ยิง Save/Export ต่อ
      filter: null,
      // ผลลัพธ์จาก /Api/FormSummaryStock/Process (โหมดตัวแทนรายเดียว)
      processResult: null,
      // ผลลัพธ์จาก /Api/FormSummaryStock/GroupProcess (โหมดสร้างเอกสารรวม — FormSummaryStockGroupPreview.vue:306)
      groupProcessResult: null,
      // รหัสตัวแทนที่เลือกไว้ตอนยิง GroupProcess (GroupPreview ใช้ยิง GroupExportExcel ต่อ — :307)
      groupAgentCodes: [],
      // ข้อความ filter ภาษาไทยที่ประกอบจาก label ฝั่ง client (ใช้เป็น fallback ของ filterText จาก API)
      filterLabels: [],

      // ── FS-033 : state ระหว่างรอผลของงานประมวลผลเบื้องหลัง ────────────────
      //   เก็บ filter ที่ "กำลังประมวลผลอยู่" ไว้ต่างหาก แล้วค่อยย้ายไปที่ filter จริง
      //   เมื่อผลออกมาสำเร็จ — งานที่ถูกยกเลิก/ล้มเหลวจะได้ไม่ไปทับ state ของผลก่อนหน้า
      pendingFilter: null,
      pendingFilterLabels: [],
      pendingIsGroup: false
    };
  },
  watch: {
    // filter บังคับเลือกได้อย่างใดอย่างหนึ่ง — เลือกตัวหนึ่งแล้วต้องล้างอีกตัวทันที
    // (ไม่เกิด loop เพราะการ set เป็น [] ทำให้ watcher อีกฝั่งเข้าเงื่อนไข length === 0 แล้วจบ)
    reBHostAgentCode: function reBHostAgentCode(val) {
      // FS-010 / FS-016 — option "ทั้งหมด" ต้องได้ผลเท่ากับ "เลือกทุกตัวจริง ๆ"
      // แต่ การขยายเป็นรหัสจริงย้ายไปทำที่ computed agentCodeList แล้ว (FS-016)
      // v-model จึงเก็บแค่ sentinel — กล่องจะได้โชว์ chip "ทั้งหมด" ชิ้นเดียว
      // คงกติกาเดิม: ขณะเลือก Group อยู่ ห้ามเลือกตัวแทนรายตัว
      // (treeselect ถูก :disabled="isGroupSelected" อยู่แล้ว — กันซ้ำที่นี่ไม่ให้เลือกข้ามเงื่อนไขได้)
      if (this.hasSelectAllOption(val)) {
        // FS-016 — เลือก "ทั้งหมด" ให้เหลือ chip เดียวในกล่อง ไม่ใส่รหัสจริงลง v-model
        // (การขยายเป็นรหัสจริงทำที่ computed agentCodeList แล้ว)
        // เงื่อนไข length !== 1 กันไม่ให้ assign ซ้ำจนวน watcher ไม่รู้จบ
        var onlySentinel = this.isGroupSelected ? [] : [SELECT_ALL_ID];
        if (val.length !== onlySentinel.length) {
          this.reBHostAgentCode = onlySentinel;
        }
        this.ClearAfterselect();
        return;
      }
      if (val && val.length > 0 && this.groupCodeCount > 0) {
        this.HeadAgentCode = [];
      }
    },
    HeadAgentCode: function HeadAgentCode(val) {
      // กติกาเดียวกับด้านบน (ฝั่ง Group) — ขณะเลือกตัวแทนรายตัวอยู่ ห้ามเลือก Group
      if (this.hasSelectAllOption(val)) {
        // FS-016 — กติกาเดียวกับฝั่งตัวแทนรายตัว
        var onlySentinelG = this.isAgentSelected ? [] : [SELECT_ALL_ID];
        if (val.length !== onlySentinelG.length) {
          this.HeadAgentCode = onlySentinelG;
        }
        this.ClearAfterselect();
        return;
      }
      if (val && val.length > 0 && this.agentCodeCount > 0) {
        this.reBHostAgentCode = [];
      }
    }
  },
  methods: {
    // ─────────────────────────────────────────────────────────────────────────
    // Dropdown loaders — copy จาก SBP.Web/App/Components/Report/Barcodes.vue
    // ─────────────────────────────────────────────────────────────────────────

    /***** ddl ชื่อตัวแทนจำหน่าย — ที่มา: Barcodes.vue:1546 LoadreBHostAgentCodeOptions *****/
    LoadreBHostAgentCodeOptions: function LoadreBHostAgentCodeOptions(e) {
      var self = this;
      // FS-023 — ต้องใช้ endpoint ของ CR นี้เท่านั้น
      //   /Api/Report/Select2Agent ไม่มี branch ของ FORM_SUMMARY_STOCK_* (ReportController.cs:205-352)
      //   ผู้ใช้กลุ่ม B จึงร่วงผ่าน if/else ทั้งชุดแล้วได้ AgentCodes ว่าง = ไม่ถูกกรอง
      //   วัดจริง 25/09/2026: TESTFSSAGENT (มีสิทธิ์ 2 ราย) ได้ 94 ราย
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Select2Agent", {
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          // FS-010 — "ทั้งหมด" เป็น option แรก และใส่ก็ต่อเมื่อมีตัวเลือกมากกว่า 1 รายการ
          // (เงื่อนไขเดิมของปุ่ม `options.length > 1` ตรงกับแพตเทิร์น `data.length > 1` ของระบบพอดี)
          self.reBHostAgentCodeOptions = data.length > 1 ? [{ id: SELECT_ALL_ID, label: "ทั้งหมด" }] : [];
          data.forEach(function (element) {
            self.reBHostAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    /***** ddl ตัวแทนจำหน่าย (Group) — ที่มา: Barcodes.vue:1242 LoadHeadAgentCodeOptions *****/
    // ต่างจากต้นทาง 3 จุด (ตั้งใจ):
    //   1) ต้นทางส่ง department: self.rePMRegion (ตัวกรอง Region ของหน้ารายงาน) — หน้านี้ไม่มี Region → ส่ง []
    //      เหมือนที่ LoadreBHostAgentCodeOptions ทำ
    //   2) ต้นทางแทรก option { id: "0", label: "ทั้งหมด" } เสมอ — หน้านี้แทรกเฉพาะตอนมีตัวเลือก > 1 รายการ
    //      และ watcher จะขยาย sentinel "0" เป็นรหัสจริงทุกตัวทันทีที่ผู้ใช้เลือก
    //      (spec ต้องการรหัสจริงทุกตัวใน payload เพื่อสร้างเอกสารทีละฉบับ ไม่ใช่ sentinel "0")
    //   3) ส่ง IsHead: true (spec ฉบับเซ็น 16/09/2026 — ตัวเลือกเหลือเฉพาะสำนักงานใหญ่ + ตัวแทนที่ไม่มีสาขา)
    //      Select2SearchAgentCodeQueryHandler.cs:113-141 แทนค่า ID/Text ของทุกรายด้วย
    //      HEAD_OFFICE_CODE_SAP ของตัวเอง แล้ว GroupBy ทิ้งตัวซ้ำ → สาขาถูกยุบเข้าสำนักงานใหญ่หมด
    //      ส่วนตัวแทนที่ไม่มีสาขาชี้ HEAD_OFFICE_CODE_SAP กลับหาตัวเอง จึงยังอยู่ในรายการ 1 ราย
    //      (FS-023 — ย้ายมาใช้ /Api/FormSummaryStock/Select2Agent แล้ว ซึ่งส่ง IsHead ต่อให้ query ตรง ๆ)
    LoadHeadAgentCodeOptions: function LoadHeadAgentCodeOptions(e) {
      var self = this;
      // FS-023 — เหตุผลเดียวกับ dropdown ด้านบน · endpoint ของ CR นี้รับ IsHead แล้ว
      //   และบังคับ AgentCodes ก่อนยุบสาขา จึงได้เฉพาะสำนักงานใหญ่ที่อยู่ในสิทธิ์
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Select2Agent", {
        page: 1,
        IsHead: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          // FS-010 — เงื่อนไขเดียวกับ dropdown "ชื่อตัวแทนจำหน่าย"
          self.HeadAgentCodeOptions = data.length > 1 ? [{ id: SELECT_ALL_ID, label: "ทั้งหมด" }] : [];
          data.forEach(function (element) {
            self.HeadAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    /***** ddl เจ้าของทรัพย์สิน — ที่มา: Barcodes.vue:1705 LoadAssetOwnerOptions *****/
    LoadAssetOwnerOptions: function LoadAssetOwnerOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/assetOwner/Select2SearchAssetOwner", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.AssetOwnerOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    /***** ddl หมุนเวียน/ไม่หมุนเวียน — ที่มา: Barcodes.vue:1685 LoadCirculateOptions (ไม่มี endpoint) *****/
    LoadCirculateOptions: function LoadCirculateOptions(e) {
      var self = this;
      self.CirculateOptions = [];
      var data = [{
        id: 1,
        text: "หมุนเวียน"
      }, {
        id: 2,
        text: "ไม่หมุนเวียน"
      }];
      data.forEach(function (element) {
        self.CirculateOptions.push({
          id: element.id,
          label: element.text
        });
      });
    },

    /***** ddl ช่วงคงค้าง — ที่มา: Barcodes.vue:1650 LoadOdPeriodOptions *****/
    LoadOdPeriodOptions: function LoadOdPeriodOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ReportOverdue/Select2PeriodOption", {
        params: {
          page: 1,
          all: true,
          PeriodRangeType: 2
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.PeriodRangeOptions = [];
          data.forEach(function (element) {
            self.PeriodRangeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },


    /***** ddl ปี(สินค้า) — ที่มา: Barcodes.vue:1596-1599 reLoadBarcodeYearOptions / LoadBarcodeYearOptions *****/
    reLoadBarcodeYearOptions: function reLoadBarcodeYearOptions() {
      // $refs safety (.claude/rules/vue-patterns.md) — treeselect อยู่ใน v-show จึงมีเสมอ
      // แต่ trigger จะยังไม่ถูกสร้างถ้า event open ยิงก่อน child mount เสร็จ
      if (this.$refs.BarcodeYear && this.$refs.BarcodeYear.trigger) {
        this.$refs.BarcodeYear.trigger.searchQuery = null;
      }
    },
    LoadBarcodeYearOptions: function LoadBarcodeYearOptions(_ref) {
      var _this = this;

      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      if (this.AllBarcodeYearOptions.length === 0) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Report/Select2BarcodeYear", {
          params: {
            page: 1,
            all: true
          }
        }).then(function (response) {
          if (response.status === 200) {
            _this.AllBarcodeYearOptions = response.data.results.map(function (element) {
              return {
                id: element.id,
                label: element.text
              };
            });
            callback(null, _this.AllBarcodeYearOptions);
          }
        }).catch(function (error) {
          callback(error, []);
        });
      } else {
        var query = searchQuery ? searchQuery.toLowerCase() : "";
        var filteredOptions = this.AllBarcodeYearOptions.filter(function (option) {
          return option.label.toLowerCase().includes(query);
        });
        callback(null, filteredOptions);
      }
    },


    /***** ddl ปีคงค้าง — ที่มา: Barcodes.vue:1674 LoadPeriodYearOptions (ไม่มี endpoint · 2021 → ปีปัจจุบัน) *****/
    LoadPeriodYearOptions: function LoadPeriodYearOptions(e) {
      var self = this;
      self.PeriodYearOptions = [];
      var currentYear = new Date().getFullYear();
      for (var year = 2021; year <= currentYear; year++) {
        self.PeriodYearOptions.push({
          id: year.toString(),
          label: year.toString()
        });
      }
    },

    /***** ddl ประเภทสินค้า — ที่มา: Barcodes.vue:1127 LoadreBProductTypeIdOptions *****/
    LoadreBProductTypeIdOptions: function LoadreBProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    /***** ddl ชื่อสินค้า — ที่มา: Barcodes.vue:1171 LoadreBAssetCodeOptions *****/
    LoadreBAssetCodeOptions: function LoadreBAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true,
          excludeProductGroupId: 14
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            // CR-01 (08/10/2026) — ไม่แสดงสินค้าของร้านค้าใน dropdown
            //   เครื่องส่วนบุคคล [COOL-ROOM-01] · หัวจ่ายส่วนบุคคล [FONT-SHOP-01]
            //   กรองฝั่งนี้เพราะ /Api/Product/Select2Product เป็น endpoint กลาง
            //   ที่โมดูลอื่นใช้ร่วมด้วย แก้ที่นั่นจะกระทบหน้าจออื่นทั้งระบบ
            //   (ฝั่งข้อมูลกรองซ้ำอีกชั้นที่ GetFormSummaryStockBarcodesQueryHandler
            //    เพื่อให้ยอดรวม / Excel / PDF ไม่นับ แม้ผู้ใช้จะส่งรหัสมาเองตรง ๆ)
            if (EXCLUDED_PRODUCT_CODES.indexOf(String(element.id)) >= 0) return;

            self.reBAssetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    /***** ที่มา: Barcodes.vue:1789 ClearAfterselect *****/
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },

    // ─────────────────────────────────────────────────────────────────────────
    // Form actions
    // ─────────────────────────────────────────────────────────────────────────

    // ── option "ทั้งหมด" (FS-010) ────────────────────────────────────────────
    // เดิมเป็นปุ่ม selectAllAgentCodes/selectAllGroupCodes นอก dropdown
    // ย้ายมาเป็น option แรกของ dropdown แล้ว แต่ "ผลลัพธ์" ต้องเท่าเดิมเป๊ะ คือ
    // ใส่รหัสจริงทุกตัวที่ dropdown มีลง v-model (ไม่ปล่อย sentinel "0" หลุดไปกับ payload)
    // เพราะปลายทางต้องสร้างเอกสารทีละฉบับตามรหัสจริง
    // ขอบเขตของแอดมิน (ตัวแทนจำหน่าย) ถูกบังคับที่ /Api/FormSummaryStock/Select2Agent (FS-023)
    // → "ทั้งหมด" ของผู้ใช้กลุ่มนี้ = เฉพาะรายที่อยู่ในโปรไฟล์ (spec F03)
    // (ก่อน FS-023 คอมเมนต์นี้ไม่จริง — หน้านี้เคยโหลดจาก /Api/Report/Select2Agent ซึ่งไม่กรองอะไรเลย)

    // ค่าที่เลือกอยู่มี option "ทั้งหมด" ปนมาหรือไม่
    hasSelectAllOption: function hasSelectAllOption(values) {
      return Array.isArray(values) && values.some(function (v) {
        return String(v) === SELECT_ALL_ID;
      });
    },

    // รหัสจริงทุกตัวใน dropdown (ตัด sentinel "ทั้งหมด" ออก)
    realOptionIds: function realOptionIds(options) {
      return (options || []).filter(function (o) {
        return String(o.id) !== SELECT_ALL_ID;
      }).map(function (o) {
        return o.id;
      });
    },

    // แปลง id ที่เลือก → ข้อความ label สำหรับ echo ให้ผู้ใช้อ่านในขั้นที่ 2
    labelsOf: function labelsOf(options, values) {
      if (!options || !values) return "";
      var list = Array.isArray(values) ? values : [values];
      if (list.length === 0) return "";

      var map = {};
      options.forEach(function (o) {
        map[String(o.id)] = o.label;
      });

      return list.map(function (v) {
        return map[String(v)] != null ? map[String(v)] : String(v);
      }).join(", ");
    },

    // สรุป filter ที่ผู้ใช้เลือกเป็นคู่ label/ค่า — ใช้เป็น fallback เมื่อ API ไม่ส่ง filterText มา
    buildFilterLabels: function buildFilterLabels() {
      var self = this;
      var pairs = [];

      // QA 08/10/2026 เรื่องที่ 9 — ผู้ใช้เลือก "ทั้งหมด" ต้องแสดงคำว่า "ทั้งหมด"
      //   ไม่ใช่กางรายชื่อตัวแทน 100+ รายจนเต็มกล่องจนอ่านไม่ออก
      //   ค่าที่ผู้ใช้เลือกจริงอยู่ใน v-model (sentinel "0") ส่วน agentCodeList/groupCodeList
      //   เป็นรหัสที่ขยายแล้วสำหรับส่ง API — การแสดงผลจึงต้องดูจาก v-model
      if (self.isAgentSelected) {
        pairs.push({
          label: "ชื่อตัวแทนจำหน่าย",
          text: self.hasSelectAllOption(self.reBHostAgentCode) ? SELECT_ALL_LABEL : self.labelsOf(self.reBHostAgentCodeOptions, self.agentCodeList)
        });
      }
      if (self.isGroupSelected) {
        pairs.push({
          label: "ตัวแทนจำหน่าย (Group)",
          text: self.hasSelectAllOption(self.HeadAgentCode) ? SELECT_ALL_LABEL : self.labelsOf(self.HeadAgentCodeOptions, self.groupCodeList)
        });
      }

      var optional = [["เจ้าของทรัพย์สิน", self.AssetOwnerOptions, self.AssetOwnerId], ["หมุนเวียน/ไม่หมุนเวียน", self.CirculateOptions, self.Circulate], ["ช่วงคงค้าง", self.PeriodRangeOptions, self.PeriodRange], ["ปี(สินค้า)", self.AllBarcodeYearOptions, self.BarcodeYear], ["ปีคงค้าง", self.PeriodYearOptions, self.PeriodYear], ["ประเภทสินค้า", self.reBProductTypeIdOptions, self.reBProductTypeId], ["ชื่อสินค้า", self.reBAssetCodeOptions, self.reBAssetCode]];

      optional.forEach(function (item) {
        if (item[2] && item[2].length > 0) {
          // หลักเดียวกับ filter บังคับ — เลือก "ทั้งหมด" ก็แสดง "ทั้งหมด"
          pairs.push({
            label: item[0],
            text: self.hasSelectAllOption(item[2]) ? SELECT_ALL_LABEL : self.labelsOf(item[1], item[2])
          });
        }
      });

      return pairs;
    },

    // payload ที่ตรงกับ SBP.Application/FormSummaryStock/Models/FormSummaryStockFilter.cs
    // และ FormSummaryStockGroupFilterRequest (GetFormSummaryStockGroupSummaryQuery.cs:56) ที่เพิ่ม agentCodes
    // (ไม่ส่ง IsSuperAdmin / AllowedAgentCodes — controller เป็นผู้เซ็ตเท่านั้น)
    //
    // ส่ง agentCodes ติดไปทุกครั้ง แม้เส้นทางตัวแทนรายเดียว:
    //   • /Process bind เป็น FormSummaryStockFilter ซึ่งไม่มี property นี้ → JSON binder ข้ามให้เอง
    //   • แต่ FormSummaryStockGroupPreview.vue:412-416 ใช้ $parent.filter.agentCodes เป็นค่าสำรอง
    //     จึงต้องมีติดอยู่ใน object เดียวกับที่เก็บไว้บน this.filter
    // ส่วน agentCode / headAgentCode เติมเฉพาะตอนเลือกรายเดียว (เส้นทางเดิมของขั้นที่ 3 ใช้ค่านี้)
    buildFilter: function buildFilter() {
      var self = this;
      var isAgent = self.isAgentSelected;
      var codes = self.selectedCodes.map(function (v) {
        return String(v);
      });
      var single = codes.length === 1 ? codes[0] : null;

      // FS-091 — บอก server ว่าผู้ใช้เลือก "ทั้งหมด" หรือเลือกบางราย (ใช้ตั้งชื่อไฟล์รวม)
      //   ต้องดูจาก v-model (sentinel "0") เพราะ codes ถูกขยายเป็นรหัสจริงไปแล้ว แยกจากการติ๊กครบเองไม่ได้
      //   ส่งเฉพาะโหมดหลายตัวแทน — ตัวแทนรายเดียวไม่มีไฟล์รวม
      var isAllAgents = codes.length > 1 ? self.hasSelectAllOption(isAgent ? self.reBHostAgentCode : self.HeadAgentCode) : null;

      return {
        filterType: isAgent ? FILTER_TYPE_AGENT : FILTER_TYPE_GROUP,
        agentCode: isAgent ? single : null,
        headAgentCode: isAgent ? null : single,
        agentCodes: codes,
        isAllAgents: isAllAgents,
        assetOwnerId: toIntList(self.AssetOwnerId),
        circulate: toIntList(self.Circulate),
        periodRange: toIntList(self.PeriodRange),
        barcodeYear: toIntList(self.BarcodeYear),
        periodYear: toIntList(self.PeriodYear),
        productTypeId: toIntList(self.reBProductTypeId),
        assetCode: toStringList(self.reBAssetCode)
      };
    },

    goBack: function goBack() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: "/PrintSummary/Barcodes" });
    },

    formReset: function formReset(e) {
      // "ล้างข้อมูล" = ล้างเฉพาะเงื่อนไขบนฟอร์ม ไม่ได้ลบข้อมูลจริง
      this.reBHostAgentCode = [];
      this.HeadAgentCode = [];
      this.AssetOwnerId = [];
      this.Circulate = [];
      this.PeriodRange = [];
      this.BarcodeYear = [];
      this.PeriodYear = [];
      this.reBProductTypeId = [];
      this.reBAssetCode = [];

      this.filter = null;
      this.processResult = null;
      this.groupProcessResult = null;
      this.groupAgentCodes = [];
      this.filterLabels = [];

      this.ClearAfterselect();

      // $refs safety — ฟอร์มอยู่ใน v-show (ไม่ใช่ v-if) จึงมีเสมอ แต่กันไว้เผื่อ reset ถูกเรียกก่อน mount เสร็จ
      if (this.$refs.filterForm) {
        var validator = $(this.$refs.filterForm).data("validator");
        if (validator) {
          validator.resetForm();
        }
      }
    },

    // ข้อความ error กลางของ axios catch — ใช้ร่วมกันทั้ง 2 เส้นทาง
    describeAxiosError: function describeAxiosError(error) {
      return error && error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด";
    },

    // "ประมวลผล" — แยกเส้นทางตามจำนวนตัวแทนที่เลือก (spec ฉบับเซ็น 16/09/2026)
    //   1 ราย      → /Process      → /New/Preview       (เอกสารเดียว — เส้นทางเดิม)
    //   2 รายขึ้นไป → /GroupProcess → /New/GroupPreview  (ขั้นที่ 3B — สร้างเอกสารรวม)
    formSubmit: function formSubmit(e) {
      if (e) e.preventDefault();

      var self = this;

      if (!self.$refs.filterForm) return;
      if (!$(self.$refs.filterForm).valid()) return;

      if (self.isGroupDocumentMode) {
        self.submitGroupProcess();
      } else {
        self.submitSingleProcess();
      }
    },

    // ── FS-033 : "ประมวลผล" เป็นงานเบื้องหลัง + popup ความคืบหน้า ───────────
    //
    //   spec §M นับ "กด ประมวลผล (ขั้นที่ 2 → 3B)" เป็น 1 ใน 5 กรณีที่ต้องมี Popup Progress
    //   ของเดิมเป็น request เดียวที่รอจนจบแล้วบล็อกหน้าจอด้วย KTApp.blockPage
    //   → ไม่มี % ไม่มี log ไม่มีปุ่มยกเลิก และชุดใหญ่ ๆ เสี่ยงชน timeout ของ HTTP/reverse proxy
    //
    //   ตอนนี้ทั้ง 2 เส้นทางยิง endpoint ที่คืน jobId ทันที แล้วให้ popup poll ความคืบหน้าเอง
    //   ผลลัพธ์จริงมารับทีหลังด้วย ProcessResult / GroupProcessResult (รูปร่างเดิมทุกประการ)

    submitSingleProcess: function submitSingleProcess() {
      var self = this;
      var filter = self.buildFilter();

      self.pendingFilter = filter;
      self.pendingFilterLabels = self.buildFilterLabels();
      self.pendingIsGroup = false;

      // FS-078 — เปิด popup ความคืบหน้าทันทีเหมือนโหมดหลายตัวแทน ไม่มี overlay spinner คั่นก่อน
      //   ของเดิม (FS-033) หน่วง popup 700ms แล้วใช้ KTApp.blockPage คั่นช่วงนั้น
      //   ผู้ใช้: popup คือ loading ของขั้นนี้อยู่แล้ว ไม่ต้องมี spinner อีกชั้น
      self.$refs.progressModal.start({
        title: "กำลังประมวลผลข้อมูล",
        jobKind: "process",
        showTimer: true, // FS-126
        payload: filter,
        endpoints: { start: "/Api/FormSummaryStock/ProcessStart" }
      });
    },

    submitGroupProcess: function submitGroupProcess() {
      var self = this;
      var filter = self.buildFilter();

      self.pendingFilter = filter;
      self.pendingFilterLabels = self.buildFilterLabels();
      self.pendingIsGroup = true;

      // โหมดรวมวนอย่างน้อย 2 ตัวแทน ไม่มีทางจบเร็วพอจะกระพริบ → เปิด popup ทันที
      //   FS-105 — ติดขัดที่รายไหน popup หยุดรอให้เลือก "ประมวลผลใหม่" / "ข้าม" ผ่าน GroupProcessResume
      self.$refs.progressModal.start({
        title: "กำลังประมวลผลข้อมูล " + filter.agentCodes.length + " ตัวแทนจำหน่าย",
        jobKind: "process",
        showTimer: true, // FS-126
        payload: filter,
        endpoints: {
          start: "/Api/FormSummaryStock/GroupProcessStart",
          resume: "/Api/FormSummaryStock/GroupProcessResume"
        }
      });
    },

    // งานประมวลผลจบแล้ว (จบเอง / ยกเลิก / ล้มเหลว)
    //
    //   spec: "เมื่อประมวลผลจบครบทั้งหมด → ปิด popup อัตโนมัติ → เข้าสู่หน้าถัดไป"
    //   จึงรับผลก่อน แล้วค่อยสั่งปิด popup เอง (ไม่ให้ popup ปิดตัวเองก่อนแล้วจอโล่งรอ API)
    //   งานที่ถูกยกเลิก/ล้มเหลว ปล่อยให้ popup ค้างไว้พร้อมข้อความและปุ่มปิด
    onProcessFinished: function onProcessFinished(summary) {
      var self = this;

      if (!summary || summary.state !== "Completed") return;

      var isGroup = self.pendingIsGroup;
      var resultUrl = isGroup ? "/Api/FormSummaryStock/GroupProcessResult" : "/Api/FormSummaryStock/ProcessResult";

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(resultUrl, { batchId: summary.batchId }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var data = response && response.data || {};

        if (!data.success) {
          // ประมวลผลไม่ผ่าน (เช่น filter ไม่ถูกต้อง / ไม่มีข้อมูล)
          // → ปิด popup แล้วอยู่หน้าเดิมให้ผู้ใช้แก้ filter ได้ทันที
          self.closeProgress();
          Swal.fire("เกิดข้อผิดพลาด", data.message || "ไม่สามารถประมวลผลข้อมูลได้", "error");
          return;
        }

        // เก็บไว้บน component นี้ (route แม่) ให้ step 2 อ่านผ่าน $parent
        self.filter = self.pendingFilter;
        self.filterLabels = self.pendingFilterLabels;

        if (isGroup) {
          // ชื่อ property ต้องตรงกับที่ FormSummaryStockGroupPreview.vue ประกาศไว้
          self.groupProcessResult = data;

          // FS-105 — ตัวแทนที่ติดขัดแล้วผู้ใช้กด "ข้าม" ต้องไม่ถูกส่งไปบันทึก/Export ในรอบนี้
          //   (ผู้ใช้ต้องไปสร้างเอกสารของรายนั้นเองภายหลัง) — ขั้นที่ 2 ใช้รายการนี้ส่งต่อ
          var failedCodes = (data.failedAgents || []).map(function (agent) {
            return agent.agentCode;
          });
          self.groupAgentCodes = self.pendingFilter.agentCodes.filter(function (code) {
            return failedCodes.indexOf(code) === -1;
          });
          self.processResult = null;
        } else {
          self.processResult = data;
          // ล้าง state ของโหมดรวม กัน GroupPreview อ่านผลค้างจากการประมวลผลครั้งก่อน
          self.groupProcessResult = null;
          self.groupAgentCodes = [];
        }

        self.closeProgress();

        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
          path: isGroup ? "/PrintSummary/Barcodes/New/GroupPreview" : "/PrintSummary/Barcodes/New/Preview"
        });
      }).catch(function (error) {
        self.closeProgress();
        Swal.fire("เกิดข้อผิดพลาด", self.describeAxiosError(error), "error");
      });
    },

    // ปิด popup อย่างปลอดภัย — ถูกเรียกหลัง await จึงอาจไม่มี component อยู่แล้ว
    closeProgress: function closeProgress() {
      if (this.$refs.progressModal) this.$refs.progressModal.close();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;
              _context.next = 3;
              return _this2.$nextTick();

            case 3:

              // โหลด dropdown ทั้งหมด (ยกเว้น ปี(สินค้า) ที่เป็น async load-options โหลดตอนเปิด dropdown)
              self.LoadreBHostAgentCodeOptions();
              self.LoadHeadAgentCodeOptions();
              self.LoadAssetOwnerOptions();
              self.LoadCirculateOptions();
              self.LoadOdPeriodOptions();
              self.LoadPeriodYearOptions();
              self.LoadreBProductTypeIdOptions();
              self.LoadreBAssetCodeOptions();

              // ── Validation ─────────────────────────────────────────────────────────
              // ignore: [] เพื่อให้ validator เห็น hidden input ที่ผูกกับ filter บังคับ
              // (pattern เดียวกับ AgentScoreList.vue:825-855)
              if (self.$refs.filterForm) {
                $(self.$refs.filterForm).validate({
                  ignore: [],
                  errorElement: "div",
                  errorClass: "text-danger kt-margin-b-10",
                  rules: {
                    fssCreate_requiredFilter: {
                      required: true
                    }
                  },
                  messages: {
                    fssCreate_requiredFilter: {
                      required: "กรุณาเลือก ชื่อตัวแทนจำหน่าย หรือ ตัวแทนจำหน่าย (Group) อย่างใดอย่างหนึ่ง"
                    }
                  }
                });
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormSummaryStockAttachmentModal__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormSummaryStockSignatureModal__ = __webpack_require__(137);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Action Button Design System + Stepper ของโมดูลนี้ (QA เรื่องที่ 11 + 16)

// FS-088 — tooltip ของปุ่มวงกลมเป็นแบบ Bootstrap (ผูกครั้งเดียวทั้งโมดูล เรียกซ้ำได้)

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__["a" /* installFssTooltips */])();





__webpack_require__(9);

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F05 — ขั้นที่ 3 "บันทึกแล้ว" (/PrintSummary/Barcodes/:documentNo)
//
// อ่านจาก snapshot ที่บันทึกไว้เท่านั้น (POST /Api/FormSummaryStock/Document)
// ไม่คำนวณใหม่ — ตัวเลขต้องตรงกับตอนกดบันทึกเสมอ
//
// route นี้เป็นลูกของ /PrintSummary/Barcodes (FormSummaryStockList.vue) แบบเดียวกับ /New
// จึงเข้าถึงได้ทั้งจากปุ่ม "ดูรายละเอียด" ในตาราง (FormSummaryStockList.vue:264)
// และจากขั้นที่ 2 หลังบันทึกสำเร็จ
//
// SweetAlert2 = ^8.2.3 (SBP.Web/package.json) → ใช้ option ชื่อ `type` (ไม่ใช่ `icon` ของ v9+)
// ─────────────────────────────────────────────────────────────────────────────

// ปุ่มที่ยังไม่ถึงคิวพัฒนา — แจ้งผู้ใช้เป็นภาษาไทยแทนการเงียบ (ห้ามใช้ alert()/console.log)
// รูปแบบเดียวกับ FormSummaryStockList.vue:showUnderDevelopment
function showUnderDevelopment(featureName) {
  Swal.fire("อยู่ระหว่างพัฒนา", "ฟังก์ชัน " + featureName + " อยู่ระหว่างพัฒนา", "info");
}

// FS-029 — ข้อความ tooltip ของปุ่ม Excel เมื่อรายละเอียดบาร์โค้ดหมดอายุ
//   คำต่อคำเดียวกับหน้ารายการ (FormSummaryStockList.vue : EXCEL_EXPIRED_TOOLTIP)
//   ห้ามเขียนใหม่ให้ต่างกัน — ผู้ใช้เห็นทั้ง 2 หน้าและต้องได้คำอธิบายชุดเดียวกัน
var EXCEL_EXPIRED_TOOLTIP = "ไม่สามารถ Export ข้อมูลได้ เนื่องจากข้อมูลรายละเอียดบาร์โค้ดถูกลบไปแล้ว (ระบบเก็บข้อมูล 2 ปีนับจากวันบันทึกเอกสาร)";

// FS-035 — หน้าชั่วคราวในแท็บใหม่ระหว่างรอ BIRT สร้างไฟล์
//   เขียนเป็นสตริงบรรทัดเดียว ไม่มี \n โดยตั้งใจ (ไฟล์ .vue นี้เคยเจอปัญหา escape ของ \n
//   จนทำให้ bundle พัง — ดูคอมเมนต์เรื่อง regex ที่ exportExcel)
var PDF_PREVIEW_PLACEHOLDER = '<!DOCTYPE html><html lang="th"><head><meta charset="utf-8">' + "<title>กำลังเตรียมไฟล์ PDF</title></head>" + '<body style="font-family: sans-serif; padding: 24px; color: #48465b;">' + "กำลังเตรียมไฟล์ PDF กรุณารอสักครู่...</body></html>";

// อายุของ blob URL ก่อนถูกคืนหน่วยความจำ — ต้องนานพอให้แท็บใหม่โหลดไฟล์เสร็จ
// (เพิกถอนเร็วเกินไป = แท็บที่เพิ่งเปิดจะกลายเป็นหน้าว่าง)
var BLOB_URL_TTL_MS = 60000;

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    /**
     * QA เรื่องที่ 17 — เลขที่เอกสารที่ผู้ใช้พิมพ์มาใน URL
     * ใช้แสดงในหน้า "ไม่พบเอกสาร" เพื่อให้รู้ว่าเรียกอะไรไปแล้วไม่เจอ
     * อ่านจาก route ไม่ใช่จาก document เพราะกรณีนี้ document เป็น null
     */
    requestedDocumentNo: function requestedDocumentNo() {
      return this.$route && this.$route.params && this.$route.params.documentNo || "";
    },
    // FormSummaryStock_Header.Id — route ส่งมาแค่ documentNo จึงต้องรอ API ตอบก่อน
    // ใช้เปิด popup แนบไฟล์ (F08) และ popup ลายเซ็น (F15) ซึ่งทั้งคู่อ้างอิงด้วย Id ไม่ใช่เลขที่เอกสาร
    headerId: function headerId() {
      return this.document && this.document.id ? this.document.id : 0;
    },
    documentNo: function documentNo() {
      return this.document && this.document.documentNo ? this.document.documentNo : this.$route.params.documentNo;
    },
    snapshotDateText: function snapshotDateText() {
      if (!this.document || !this.document.snapshotDate) return "-";
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.document.snapshotDate).format("DD/MM/YYYY HH:mm");
    },
    agentName: function agentName() {
      return this.document ? this.document.agentName : "";
    },
    // FS-096 — "[รหัส] ชื่อ" แบบเดียวกับหน้ารายการ (FormSummaryStockList.vue คอลัมน์ตัวแทน)
    agentLabel: function agentLabel() {
      var code = this.document ? this.document.agentCode : "";
      var name = this.agentName;
      if (code && name) return "[" + code + "] " + name;
      if (code) return "[" + code + "]";
      return name || "-";
    },
    filterText: function filterText() {
      return this.document ? this.document.filterText : "";
    },
    // FS-076 — [0] filter บังคับ · [1..] filter ไม่บังคับทีละตัว (ไม่มี "+ " นำหน้า — เติมตอนแสดง)
    filterLines: function filterLines() {
      return this.document && this.document.filterLines ? this.document.filterLines : [];
    },
    // FS-116 — หัวแถวรายละเอียด ไม่มี [รหัส] (แบบขั้นที่ 2 · FS-106/107)
    agentNameOnly: function agentNameOnly() {
      return this.agentName || (this.document ? this.document.agentCode : "");
    },
    // FS-118 — แยก filterLines เป็น { label, text } ให้แสดงเป็นตารางแบบขั้นที่ 2
    //   server ประกอบบรรทัดแรกด้วย " — " และ filter ไม่บังคับด้วย ": " (GetFormSummaryStockDocumentQueryHandler)
    filterItems: function filterItems() {
      return this.filterLines.map(function (line, index) {
        var text = String(line);
        var sep = index === 0 ? " — " : ": ";
        var at = text.indexOf(sep);
        if (at < 0) return { label: "", text: text };
        return { label: text.substring(0, at), text: text.substring(at + sep.length) };
      });
    },
    details: function details() {
      return this.document && this.document.details ? this.document.details : [];
    },
    totalQty: function totalQty() {
      return this.document ? this.document.totalQty : 0;
    },
    totalAmount: function totalAmount() {
      return this.document ? this.document.totalAmount : 0;
    },
    totalAmountText: function totalAmountText() {
      return this.document ? this.document.totalAmountText : "";
    },
    attachmentCount: function attachmentCount() {
      return this.document && this.document.attachmentCount ? this.document.attachmentCount : 0;
    },
    /**
     * FS-050 — ใช้ตัดสินสีปุ่มแนบไฟล์ให้ตรงกับหน้ารายการเอกสาร
     *   เขียวเข้ม = มีไฟล์แล้ว · แดง = ยังไม่มีไฟล์
     * (FormSummaryStockList.vue:552 — เงื่อนไขเดียวกัน)
     */
    hasAttachment: function hasAttachment() {
      return this.attachmentCount > 0;
    },
    isNoData: function isNoData() {
      return this.details.length === 0;
    },
    noDataMessage: function noDataMessage() {
      if (this.loadError) return this.loadError;
      return "เอกสารนี้ไม่มีรายการสินค้าคงค้างที่บันทึกไว้";
    },

    // FS-012 — สถานะปุ่มลายเซ็น
    //   เอกสารบันทึกแล้ว "แนบแล้ว" จึงหมายถึงมีภาพตรึงไว้กับเอกสารฉบับนี้จริง
    //   (ตรึงตั้งแต่วันบันทึก เปลี่ยนไม่ได้อีก — ปุ่มจึงเป็นแค่ทางเข้าไปดูภาพ)
    // FS-017 — เอกสารที่ไม่ได้เลือกภาพเฉพาะกิจจะถูกพิมพ์ด้วยลายเซ็นค่าเริ่มต้นของระบบ
    //   ตาม spec (CR-Features.md:320) ถือว่ามีลายเซ็นแล้ว ปุ่มจึงต้องเขียวเช่นกัน
    hasSignature: function hasSignature() {
      return !!this.signatureAttachedId || this.hasDefaultSignature;
    },
    signatureButtonText: function signatureButtonText() {
      return this.hasSignature ? "ลายเซ็นผู้จัดทำ (ดูภาพ)" : "ลายเซ็นผู้จัดทำ";
    },

    // ── FS-029 — สถานะอายุ Export Excel (F09) ────────────────────────────────
    // แหล่งข้อมูลที่ถูกต้องคือ /Api/FormSummaryStock/Document (server คำนวณให้
    // ด้วยสูตรเดียวกับหน้ารายการ — GetFormSummaryStockDocumentQueryHandler)
    //
    // ระหว่างที่ response ของ endpoint นั้นยังไม่ส่ง 4 ฟิลด์นี้ออกมา (การเพิ่มฟิลด์
    // ต้องแก้ FormSummaryStockController ซึ่งอยู่นอกขอบเขตงานรอบนี้) จะใช้แถวของ
    // เอกสารใบเดียวกันจาก /Api/FormSummaryStock/Search แทน — ดู loadExcelExpiry()
    // ห้ามคำนวณจากวันที่ฝั่ง client เอง เพราะนาฬิกาเครื่องผู้ใช้เชื่อไม่ได้
    excelExpiry: function excelExpiry() {
      if (this.document && this.document.isExcelAvailable !== undefined) {
        return this.document;
      }
      return this.excelExpiryFallback;
    },
    // ไม่รู้สถานะ = ถือว่ายัง export ได้ เพื่อไม่ให้ใบที่ปกติถูกล็อคโดยไม่ตั้งใจ
    // (ด่านจริงอยู่ที่ ExportFormSummaryStockExcelCommandHandler อยู่แล้ว)
    excelAvailable: function excelAvailable() {
      var src = this.excelExpiry;
      return !src || src.isExcelAvailable !== false;
    },
    excelTitle: function excelTitle() {
      return this.excelAvailable ? "Export Excel (รายละเอียดบาร์โค้ด)" : EXCEL_EXPIRED_TOOLTIP;
    },
    // แยกวันที่ออกจากข้อความเตือน เพราะ design ให้คนละสี (เหมือนหน้ารายการ)
    excelExpireDateText: function excelExpireDateText() {
      var src = this.excelExpiry;
      if (!src || !src.excelExpireDate) return "";
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(src.excelExpireDate).format("DD/MM/YYYY");
    },

    // ── FS-036 ข้อ 5 — จำนวนรายการระดับบาร์โค้ดในไฟล์ Excel ───────────────────
    // ใช้ "จำนวนคงค้างรวม" ของเอกสารเป็นจำนวนบาร์โค้ด ไม่ใช่เลขที่เดาขึ้นมา:
    // FormSummaryStockAggregator.BuildRows กำหนด Qty = g.Count() คือ "จำนวนบาร์โค้ด
    // ในกลุ่ม (1 แถวจาก SP = 1 บาร์โค้ด)" → ผลรวมทุกแถว = จำนวนบาร์โค้ดทั้งใบ
    // ซึ่งเป็นชุดเดียวกับที่ ExportFormSummaryStockExcelCommandHandler เขียนลงไฟล์
    barcodeDetailCount: function barcodeDetailCount() {
      return this.totalQty ? Number(this.totalQty) : 0;
    },
    excelNoteText: function excelNoteText() {
      // Export ไม่ได้แล้ว = ห้ามบอกว่ามี N รายการอยู่ในไฟล์ (ข้อมูลถูกลบไปแล้วจริง ๆ)
      if (!this.excelAvailable) return "";
      if (!this.barcodeDetailCount) return "";
      return "ข้อมูลระดับบาร์โค้ด " + this.barcodeDetailCount.toLocaleString("en-US") + " รายการอยู่ในไฟล์ Excel";
    }
  },
  data: function data() {
    return {
      // ผลลัพธ์จาก /Api/FormSummaryStock/Document
      document: null,
      // ข้อความผิดพลาดจาก API (แสดงแทนตารางเปล่า)
      loadError: "",
      // F04 (D10) — บรรทัด "*สำนักงานใหญ่ + สาขา [ ... ]" ค่าว่าง = ไม่ต้องแสดง
      branchLine: "",
      // FS-012 — AttachedId ของลายเซ็นที่ตรึงไว้กับเอกสารฉบับนี้ (null = ยังไม่มีภาพ)
      //   /Api/FormSummaryStock/Document ไม่ได้คืนค่านี้มา จึงอ่านจาก endpoint Signature
      //   ตัวเดียวกับที่ popup ใช้ (ห้ามแก้ฝั่ง backend ในรอบนี้)
      signatureAttachedId: null,
      // FS-017 — ระบบมีลายเซ็นค่าเริ่มต้นหรือไม่ + url ของภาพที่เอกสารนี้ใช้จริง (signed URL อายุสั้น)
      hasDefaultSignature: false,
      signatureImageUrl: "",
      // FS-018 — สิทธิ์จัดการลายเซ็น (canManage จาก /Api/FormSummaryStock/Signature)
      //   ค่าเริ่มต้นต้องเป็น false เสมอ — ซ่อนปุ่มไว้ก่อนจนกว่า API จะยืนยันว่ามีสิทธิ์
      canManageSignature: false,
      // FS-029 — แถวของเอกสารใบนี้จากผลค้นหา (ใช้เฉพาะตอนที่ /Document ยังไม่ส่ง
      //   สถานะอายุ Excel มาเอง) null = ยังไม่รู้สถานะ → ปุ่มทำงานตามปกติ
      excelExpiryFallback: null
    };
  },
  methods: {
    formatQty: function formatQty(value) {
      if (value == null || value === "") return "-";
      return Number(value).toLocaleString("en-US");
    },
    formatAmount: function formatAmount(value) {
      if (value == null || value === "") return "-";
      return Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    loadDocument: function loadDocument() {
      var self = this;
      var documentNo = self.$route.params.documentNo;

      if (!documentNo) {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].replace({ path: "/PrintSummary/Barcodes" });
        return;
      }

      // FS-029 — ล้างสถานะอายุ Excel ของใบก่อนหน้าทิ้งก่อนเสมอ
      //   (component ถูก reuse เมื่อเปลี่ยน :documentNo — ค้างไว้จะกลายเป็นสถานะของใบอื่น)
      self.excelExpiryFallback = null;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Document", { documentNo: documentNo }, {
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token
        }
      }).then(function (response) {
        if (response.data.success) {
          self.loadError = "";
          self.document = response.data;
          // headerId เพิ่งมีค่าหลังบรรทัดนี้ จึงโหลดบรรทัดสาขาต่อได้
          self.loadBranchLine();
          // FS-012 — สถานะลายเซ็นใช้กำหนดสี/ข้อความบนปุ่ม ต้องรู้ตั้งแต่เปิดหน้า
          self.loadSignatureState();
          // FS-029 — สถานะอายุ Export Excel ต้องรู้ก่อนผู้ใช้กดปุ่ม
          self.loadExcelExpiry();
        } else {
          self.document = null;
          self.loadError = response.data.message || "ไม่พบเอกสารที่ต้องการ";
          // QA เรื่องที่ 17 ข้อ 5 — เดิมหัวเรื่อง "ไม่พบข้อมูล" + เนื้อหา "ไม่พบใบงาน..."
          //   อ่านต่อกันเป็น "ไม่พบข้อมูลไม่พบใบงาน" · หน้าจอบอกรายละเอียดอยู่แล้ว
          //   popup จึงเหลือแค่ประโยคเดียว ไม่ต้องย้ำซ้ำ
          //   FS-080 — กด OK (หรือปิด popup ทางใดก็ได้) แล้วกลับหน้ารายการทันที
          //     ผู้ใช้เลือกทางแรกของรายงาน "popup error + redirect กลับ Screen 1 เมื่อ user กด OK"
          //     หน้าแจ้งไม่พบด้านหลังยังอยู่ระหว่าง popup เปิด — จอไม่ว่าง และไม่มีปุ่มหลอกกลับมา
          Swal.fire("ไม่พบเอกสาร", self.loadError, "warning").then(self.goBackToList);
        }
      }).catch(function (error) {
        var errorMsg = error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด";
        self.document = null;
        self.loadError = errorMsg;
        // FS-080 — กติกาเดียวกับกรณีไม่พบเอกสาร
        Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error").then(self.goBackToList);
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    goBackToList: function goBackToList() {
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ path: "/PrintSummary/Barcodes" });
    },
    // F06 (E1) — พิมพ์ฟอร์ม PDF จาก snapshot ผ่าน BIRT
    //   ⚠ template ใช้ TH Sarabun New ชั่วคราว — spec ต้องการ Singha Water (Q7 ยังไม่ได้ไฟล์)
    //
    // FS-035 — ปุ่มนี้คือ "เปิดดูก่อนพิมพ์" (spec §F) ไม่ใช่ปุ่มดาวน์โหลด
    //   ของเดิมสร้าง <a download> แล้ว .click() → ไฟล์ลงเครื่องทันที ผู้ใช้ไม่ได้ดูก่อน
    //   ตอนนี้เปิดไฟล์ในแท็บใหม่แทน แล้วให้ผู้ใช้สั่งพิมพ์/บันทึกจากตัวอ่าน PDF ของเบราว์เซอร์เอง
    exportPdf: function exportPdf() {
      var self = this;

      if (!self.headerId) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบเลขที่อ้างอิงของเอกสารนี้", "error");
        return;
      }

      // ── เปิดแท็บ "เดี๋ยวนี้" ขณะยังอยู่ใน user gesture ของการคลิก ──────────
      //   ถ้ารอไปเปิดตอน axios ตอบกลับ เบราว์เซอร์จะถือว่าเป็น popup ที่ไม่ได้มาจาก
      //   การกระทำของผู้ใช้แล้วบล็อกทิ้งเงียบ ๆ (ผู้ใช้จะเห็นแค่ "กดแล้วไม่มีอะไรเกิดขึ้น")
      var previewTab = window.open("", "_blank");
      if (previewTab && previewTab.document) {
        previewTab.document.write(PDF_PREVIEW_PLACEHOLDER);
        previewTab.document.close();
      }

      // FS-133 — เปิดแท็บได้ → ขอตั๋วแล้วชี้แท็บไปที่ URL จริง (PdfView/{ตั๋ว}/{ชื่อไฟล์}.pdf)
      //   แถบที่อยู่และชื่อไฟล์ตอนกดดาวน์โหลดในตัวดู PDF จึงเป็นชื่อเอกสาร ไม่ใช่ GUID ของ blob:
      //   โดน popup blocker (ไม่มีแท็บ) → ใช้ทางเดิมด้านล่าง : ดึงไฟล์แล้วเสนอให้ดาวน์โหลดแทน
      //   หน้ารายการ (FormSummaryStockList.vue) ใช้กติกาเดียวกัน — แก้ที่ไหนต้องแก้คู่กัน
      if (previewTab) {
        self.openPdfByTicket(previewTab);
        return;
      }

      KTApp.blockPage({ opacity: 0.05, message: "กำลังสร้างไฟล์ PDF กรุณารอสักครู่..." });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/FormSummaryStock/PrintPdf",
        responseType: "blob",
        data: { headerId: self.headerId },
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        var contentType = response.headers["content-type"] || "";

        // server ปฏิเสธ (ไม่มีสิทธิ์ / render ไม่สำเร็จ) จะคืน JSON ไม่ใช่ไฟล์
        if (contentType.indexOf("application/json") !== -1) {
          self.closePreviewTab(previewTab);

          var reader = new FileReader();
          reader.onload = function () {
            var message = "พิมพ์เอกสารไม่สำเร็จ";
            try {
              var parsed = JSON.parse(reader.result);
              if (parsed && parsed.message) message = parsed.message;
            } catch (e) {
              // ใช้ข้อความเริ่มต้น
            }
            Swal.fire("พิมพ์ไม่ได้", message, "warning");
          };
          reader.readAsText(response.data);
          return;
        }

        var filename = "";
        var disposition = response.headers["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var marker = "filename=";
          var at = disposition.indexOf(marker);
          if (at !== -1) {
            filename = disposition.substring(at + marker.length);
            var semi = filename.indexOf(";");
            if (semi !== -1) filename = filename.substring(0, semi);
            filename = filename.trim().replace(/^["']|["']$/g, "");
          }
        }

        // บังคับ MIME เป็น application/pdf — บาง proxy คืน content-type เป็น
        // octet-stream ซึ่งจะทำให้แท็บใหม่ "ดาวน์โหลด" แทนที่จะ "เปิดดู"
        var pdfBlob = new Blob([response.data], { type: "application/pdf" });
        var blobUrl = window.URL.createObjectURL(pdfBlob);
        var fileName = decodeURIComponent(filename) || "เอกสาร.pdf";

        if (previewTab && !previewTab.closed) {
          previewTab.location.href = blobUrl;
        } else {
          // โดน popup blocker — ต้องบอกผู้ใช้ให้รู้ ไม่ใช่เงียบ
          // และต้องมีทางออกให้ด้วย (ดาวน์โหลดแทน) ไม่ใช่บอกว่าทำไม่ได้เฉย ๆ
          Swal.fire({
            title: "เบราว์เซอร์บล็อกการเปิดแท็บใหม่",
            text: "ไฟล์ PDF สร้างเสร็จแล้ว แต่เบราว์เซอร์ไม่อนุญาตให้เปิดแท็บใหม่ " + "กรุณาอนุญาต popup ของเว็บนี้แล้วกดพิมพ์อีกครั้ง หรือกดปุ่มด้านล่างเพื่อดาวน์โหลดไฟล์แทน",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "ดาวน์โหลดไฟล์แทน",
            cancelButtonText: "ปิด"
          }).then(function (result) {
            if (!result || !result.value) return;
            var link = document.createElement("a");
            link.href = blobUrl;
            link.download = fileName;
            link.click();
          });
        }

        // คืนหน่วยความจำของ blob — หน่วงไว้ให้แท็บใหม่ (หรือการดาวน์โหลด) โหลดไฟล์เสร็จก่อน
        setTimeout(function () {
          window.URL.revokeObjectURL(blobUrl);
        }, BLOB_URL_TTL_MS);
      }).catch(function () {
        self.closePreviewTab(previewTab);
        Swal.fire("เกิดข้อผิดพลาด", "พิมพ์เอกสารไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    // FS-133 — ขอตั๋วเปิด PDF (ตรวจสิทธิ์ชุดเดียวกับ PrintPdf) แล้วเปิดในแท็บที่เตรียมไว้
    //   ตั๋วอายุ 5 นาที — หมดอายุแล้วแท็บจะแสดงหน้าแจ้งพร้อมปุ่ม "ไปที่เอกสาร" (server ทำ)
    openPdfByTicket: function openPdfByTicket(previewTab) {
      var self = this;

      KTApp.blockPage({ opacity: 0.05, message: "กำลังเปิดเอกสาร PDF..." });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/FormSummaryStock/PdfTicket",
        data: { headerId: self.headerId },
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        var data = response.data || {};
        if (!data.success || !data.url) {
          self.closePreviewTab(previewTab);
          Swal.fire("พิมพ์ไม่ได้", data.message || "พิมพ์เอกสารไม่สำเร็จ", "warning");
          return;
        }
        if (!previewTab.closed) previewTab.location.href = data.url;
      }).catch(function () {
        self.closePreviewTab(previewTab);
        Swal.fire("เกิดข้อผิดพลาด", "พิมพ์เอกสารไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    // FS-035 — ปิดแท็บที่เปิดค้างไว้เมื่อสร้างไฟล์ไม่สำเร็จ
    //   ปล่อยทิ้งไว้ผู้ใช้จะเจอแท็บว่างค้าง แล้วเข้าใจผิดว่าระบบแฮงก์
    closePreviewTab: function closePreviewTab(previewTab) {
      if (previewTab && !previewTab.closed) {
        try {
          previewTab.close();
        } catch (e) {
          // ปิดไม่ได้ก็ไม่เป็นไร — ข้อความแจ้งเตือนอยู่ที่แท็บหลักอยู่แล้ว
        }
      }
    },
    // F07 (E3) — Export Excel รายละเอียดบาร์โค้ด 46 คอลัมน์ จาก snapshot ของเอกสารนี้
    exportExcel: function exportExcel() {
      var self = this;

      // FS-029 — หมดอายุแล้วต้องกดไม่ได้จริง ไม่ใช่แค่ทำให้ปุ่มดูจาง
      //   (tooltip บนปุ่มอธิบายเหตุผลอยู่แล้ว จึงไม่เด้ง popup ซ้ำ — เหมือนหน้ารายการ)
      if (!self.excelAvailable) return;

      if (!self.headerId) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบเลขที่อ้างอิงของเอกสารนี้", "error");
        return;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังสร้างไฟล์ Excel กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/FormSummaryStock/ExportExcel",
        responseType: "arraybuffer",
        data: { headerId: self.headerId },
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token
        }
      }).then(function (response) {
        var contentType = response.headers["content-type"] || "";

        // server ปฏิเสธ (หมดอายุ / ไม่มีสิทธิ์ / ไม่มีข้อมูล) จะคืน JSON ไม่ใช่ไฟล์
        // ตัว body ยังเป็น arraybuffer จึงต้อง decode ก่อน ไม่งั้น popup จะว่างเปล่า
        if (contentType.indexOf("application/json") !== -1) {
          var message = "ไม่สามารถ Export Excel ได้";
          try {
            var parsed = JSON.parse(new TextDecoder("utf-8").decode(new Uint8Array(response.data)));
            if (parsed && parsed.message) message = parsed.message;
          } catch (e) {
            // ปล่อยข้อความเริ่มต้นไว้
          }
          Swal.fire("ไม่สามารถ Export ได้", message, "warning");
          return;
        }

        // ชื่อไฟล์ถูก encode เป็น %20 ฝั่ง server แล้ว decodeURIComponent จึงคืนช่องว่างถูกต้อง
        var filename = "";
        var disposition = response.headers["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          // ดึงชื่อไฟล์จาก Content-Disposition โดยไม่ใช้ regex
          // (หลีกเลี่ยงปัญหา escape ของ \n ในไฟล์ .vue ซึ่งเคยทำให้ bundle พัง)
          var marker = "filename=";
          var at = disposition.indexOf(marker);
          if (at !== -1) {
            filename = disposition.substring(at + marker.length);
            var semi = filename.indexOf(";");
            if (semi !== -1) filename = filename.substring(0, semi);
            filename = filename.trim().replace(/^["']|["']$/g, "");
          }
        }

        var blob = new Blob([response.data], { type: contentType });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = decodeURIComponent(filename);
        link.click();
      }).catch(function () {
        Swal.fire("เกิดข้อผิดพลาด", "สร้างไฟล์ Excel ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    // FS-029 — สถานะอายุ Export Excel ของเอกสารใบนี้
    //
    //   แหล่งที่ถูกต้องคือ /Api/FormSummaryStock/Document ซึ่ง handler คำนวณให้แล้ว
    //   (GetFormSummaryStockDocumentQueryHandler — สูตรเดียวกับหน้ารายการ)
    //   แต่ response ของ endpoint นั้นยัง "ไม่" ส่ง 4 ฟิลด์นี้ออกมา เพราะการเพิ่มฟิลด์
    //   ต้องแก้ FormSummaryStockController ซึ่งอยู่นอกขอบเขตงานรอบนี้
    //   → ระหว่างนี้จึงอ่านแถวของใบเดียวกันจากผลค้นหา (endpoint ที่ส่งฟิลด์นี้อยู่แล้ว)
    //   เมื่อวันหนึ่ง /Document ส่งฟิลด์มาเอง computed excelExpiry จะเลือกใช้ค่านั้นก่อน
    //   และฟังก์ชันนี้จะไม่ยิง API ซ้ำอีก (เช็กที่บรรทัดแรก)
    //
    //   best-effort — ล้มเหลวก็ไม่รบกวนผู้ใช้ด้วย popup: ปุ่มจะทำงานตามปกติแล้วให้
    //   ExportFormSummaryStockExcelCommandHandler เป็นด่านปฏิเสธเหมือนเดิม
    loadExcelExpiry: function loadExcelExpiry() {
      var self = this;

      if (!self.document) return;
      if (self.document.isExcelAvailable !== undefined) return;

      var documentNo = self.document.documentNo;
      if (!documentNo) return;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Search", {
        draw: 1,
        start: 0,
        length: 5,
        documentNo: documentNo,
        search: { value: "", regex: false }
      }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var rows = response && response.data && response.data.data ? response.data.data : [];

        // ผลค้นหาเป็นแบบ "มีคำนี้อยู่ในเลขที่เอกสาร" จึงอาจได้ใบอื่นติดมาด้วย
        // ต้องจับคู่เลขที่เอกสารให้ตรงเป๊ะ ห้ามหยิบแถวแรกมาใช้ดื้อ ๆ
        var match = null;
        for (var i = 0; i < rows.length; i++) {
          if (rows[i] && rows[i].documentNo === documentNo) {
            match = rows[i];
            break;
          }
        }

        // ใบยังเปลี่ยนไม่ทัน (ผู้ใช้กดดูใบอื่นระหว่างรอ) = ทิ้งผลลัพธ์นี้
        if (self.document && self.document.documentNo === documentNo) {
          self.excelExpiryFallback = match;
        }
      }).catch(function () {
        self.excelExpiryFallback = null;
      });
    },

    // F04 (D10) — บรรทัดสาขาย่อย ใช้ endpoint เดียวกับฟอร์ม PDF
    //   โหลดไม่สำเร็จก็ปล่อยว่างไว้ ไม่ขึ้น error (เป็นข้อมูลประกอบ)
    loadBranchLine: function loadBranchLine() {
      var self = this;

      if (!self.headerId) return;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/CustomerBox", { headerId: self.headerId }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var data = response && response.data || {};
        self.branchLine = data.success && data.hasBranchLine ? data.branchLine : "";
      }).catch(function () {
        self.branchLine = "";
      });
    },

    // FS-012 — อ่านว่าเอกสารฉบับนี้มีภาพลายเซ็นตรึงไว้หรือยัง เพื่อกำหนดสี/ข้อความบนปุ่ม
    //   ใช้ endpoint เดียวกับ popup (ห้ามแก้ backend ในรอบนี้) และเป็น best-effort
    //   ล้มเหลวก็แค่ปุ่มกลับไปเป็นโทนจาง ไม่ต้องรบกวนผู้ใช้ด้วย popup error
    loadSignatureState: function loadSignatureState() {
      var self = this;

      self.signatureAttachedId = null;
      self.hasDefaultSignature = false;
      self.signatureImageUrl = "";
      // FS-018 — รีเซ็ตเป็น "ไม่มีสิทธิ์" ทุกครั้งที่โหลดเอกสารใหม่ (ซ่อนปุ่มไว้ก่อน)
      self.canManageSignature = false;
      if (!self.headerId) return;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Signature", { headerId: self.headerId }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var data = response && response.data || {};

        // FS-018 — handler เซ็ต CanManage ไว้ตั้งแต่บรรทัดแรกของ Handle() จึงเชื่อถือได้
        //   แม้ success = false — อ่านก่อนด่าน success กันกรณี storage ล่มแล้วกลุ่ม A เสียปุ่มไปด้วย
        self.canManageSignature = !!data.canManage;

        if (!data.success) return;

        self.signatureAttachedId = data.documentAttachedId || null;
        // FS-017 — ไม่มีภาพเฉพาะเอกสาร = ใช้ค่าเริ่มต้นของระบบ ซึ่งก็ถือว่ามีลายเซ็น
        self.hasDefaultSignature = !data.isMissingDefault && !!data.defaultAttachedId;
        self.signatureImageUrl = data.documentImageUrl || data.defaultImageUrl || "";
      }).catch(function () {
        self.signatureAttachedId = null;
        self.hasDefaultSignature = false;
        self.signatureImageUrl = "";
        // FS-018 — เรียกไม่สำเร็จ = ไม่รู้สิทธิ์ ให้ถือว่าไม่มีสิทธิ์ (ซ่อนปุ่มไว้ก่อน)
        self.canManageSignature = false;
      });
    },

    // F08 — popup แนบไฟล์เอกสาร
    //   blocker เดิม (API Document ไม่ส่ง Header.Id) ถูกปิดไปแล้ว — response มี id แล้ว
    openAttachment: function openAttachment() {
      if (!this.headerId) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบเลขที่อ้างอิงของเอกสารนี้", "error");
        return;
      }
      this.$refs.attachmentModal.open({
        id: this.headerId,
        documentNo: this.documentNo
      });
    },

    // F15 — popup ลายเซ็นผู้จัดทำ (เอกสารบันทึกแล้ว จึงส่ง headerId จริง)
    openSignature: function openSignature() {
      if (!this.headerId) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบเลขที่อ้างอิงของเอกสารนี้", "error");
        return;
      }
      this.$refs.signatureModal.open({
        id: this.headerId,
        documentNo: this.documentNo
      });
    }
  },
  components: {
    "form-summary-stock-attachment-modal": __WEBPACK_IMPORTED_MODULE_5__FormSummaryStockAttachmentModal__["a" /* default */],
    FormSummaryStockSignatureModal: __WEBPACK_IMPORTED_MODULE_6__FormSummaryStockSignatureModal__["a" /* default */]
  },
  watch: {
    // กดดูเอกสารใบอื่นขณะอยู่หน้านี้ (component ถูก reuse) → โหลดใบใหม่
    "$route.params.documentNo": function $routeParamsDocumentNo() {
      this.loadDocument();
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$nextTick();

            case 2:
              _this.loadDocument();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormSummaryStockProgressModal__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormSummaryStockSignatureModal__ = __webpack_require__(137);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Action Button Design System + Stepper ของโมดูลนี้ (QA เรื่องที่ 11 + 16)

// FS-088 — tooltip ของปุ่มวงกลมเป็นแบบ Bootstrap (ผูกครั้งเดียวทั้งโมดูล เรียกซ้ำได้)

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__["a" /* installFssTooltips */])();




__webpack_require__(9);

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F12 — ขั้นที่ 3B "ตรวจสอบข้อมูลก่อนสร้างเอกสารรวม"
// (/PrintSummary/Barcodes/New/GroupPreview — ใช้เมื่อเลือกตัวแทนจำหน่าย 2 รายขึ้นไป)
//
// หน้านี้ยังไม่บันทึกอะไรลงฐานข้อมูล — แสดงผลลัพธ์ที่ FormSummaryStockCreate.vue
// ยิง /Api/FormSummaryStock/GroupProcess มาแล้ว เพื่อให้ผู้ใช้ตรวจก่อนกด "บันทึกข้อมูล"
//
// การรับ state จากขั้นที่ 1: อ่านจาก $parent (= FormSummaryStockCreate.vue ซึ่งเป็น route แม่)
//   กลไกเดียวกับ FormSummaryStockPreview.vue:213-228 เป๊ะ ๆ
//   (repo นี้ไม่มี Vuex / store module / การส่ง object ผ่าน route params — $parent คือ pattern เดียวที่มี)
//   → route ของหน้านี้ต้องเป็น "ลูกของ New" เหมือน Preview ไม่งั้น $parent จะกลายเป็นหน้ารายการ
//
// ⚠ ต้องให้ FormSummaryStockCreate.vue เพิ่ม state 2 ตัว (ยังไม่มีในไฟล์นั้น — เป็นงาน D9/F03):
//     groupProcessResult : ผลจาก /Api/FormSummaryStock/GroupProcess
//     groupAgentCodes    : array ของรหัสตัวแทนที่ผู้ใช้เลือก (ใช้ยิง GroupExportExcel ต่อ)
//   ระหว่างที่ยังไม่มี หน้านี้ถอยไปอ่าน processResult / filter.agentCodes ให้เอง (ดู computed ด้านล่าง)
//
// เข้าหน้านี้ตรง ๆ (refresh / กด URL) จะไม่มีผลประมวลผล → เด้งกลับขั้นที่ 1
//
// SweetAlert2 = ^8.2.3 (SBP.Web/package.json) → ใช้ option ชื่อ `type` (ไม่ใช่ `icon` ของ v9+)
// และอ่านผลจาก `result.value`
// ─────────────────────────────────────────────────────────────────────────────

// ปุ่มที่ยังไม่ถึงคิวพัฒนา — แจ้งผู้ใช้เป็นภาษาไทยแทนการเงียบ (ห้ามใช้ alert()/console.log)
// รูปแบบเดียวกับ FormSummaryStockDetail.vue:250 และ FormSummaryStockList.vue
function showUnderDevelopment(featureName) {
  Swal.fire("อยู่ระหว่างพัฒนา", "ฟังก์ชัน " + featureName + " อยู่ระหว่างพัฒนา", "info");
}

// สำเนา filter แบบตื้น + แนบรหัสตัวแทนที่เลือก (หลีกเลี่ยง Object.assign ให้ตรงกับ ES5 ที่ repo ใช้อยู่)
function withAgentCodes(filter, agentCodes) {
  var payload = {};
  for (var key in filter) {
    if (Object.prototype.hasOwnProperty.call(filter, key)) {
      payload[key] = filter[key];
    }
  }
  payload.agentCodes = agentCodes;
  return payload;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormSummaryStockProgressModal: __WEBPACK_IMPORTED_MODULE_4__FormSummaryStockProgressModal__["a" /* default */], FormSummaryStockSignatureModal: __WEBPACK_IMPORTED_MODULE_5__FormSummaryStockSignatureModal__["a" /* default */] },
  data: function data() {
    return {
      // สถานะกาง/พับของแต่ละตัวแทน — key = agentCode
      // ค่าเริ่มต้นคือ "พับไว้ทั้งหมด" (spec: ค่าเริ่มต้น = ซ่อน)
      expandedAgents: {},
      // FS-055 — คำค้นของช่องค้นหาตัวแทนเหนือตาราง (กรองฝั่ง client)
      agentKeyword: "",
      isExporting: false,
      // F11 — กันกดซ้ำระหว่างสร้างเอกสารรวม (งานยาว อาจหลายนาที)
      isSaving: false,
      // F15 — ภาพลายเซ็นที่เลือกไว้ จะถูกใช้กับทุกฉบับในชุด (null = ใช้ค่าเริ่มต้นระบบ)
      signatureAttachedId: null,
      // FS-017 — ดู FormSummaryStockPreview.vue (กติกาเดียวกัน ภาพนี้ใช้กับทุกฉบับในชุด)
      hasDefaultSignature: false,
      signatureImageUrl: "",
      // QA เรื่องที่ 1 — "*สำนักงานใหญ่ + สาขา [ ... ]" (ว่าง = ไม่ต้องแสดง)
      branchLine: "",
      // FS-018 — สิทธิ์จัดการลายเซ็น (canManage จาก /Api/FormSummaryStock/Signature)
      //   ค่าเริ่มต้นต้องเป็น false เสมอ — ซ่อนปุ่มไว้ก่อนจนกว่า API จะยืนยันว่ามีสิทธิ์
      canManageSignature: false
    };
  },
  computed: {
    // FS-012 — สถานะปุ่มลายเซ็น
    //   ขั้นนี้ยังไม่บันทึกเอกสาร "แนบแล้ว" จึงหมายถึงผู้ใช้เลือกภาพเฉพาะกิจไว้แล้ว
    //   (null = ปล่อยให้ทุกฉบับในชุดใช้ลายเซ็นค่าเริ่มต้นของระบบ)
    // FS-021 — ตกหล่นจาก FS-017 (ตอนนั้นแก้ Preview/Detail ไปแล้ว แต่หน้านี้ได้แค่ครึ่งเดียว)
    //   "มีลายเซ็น" = เอกสารในชุดนี้จะพิมพ์ออกมาพร้อมภาพแน่นอน ไม่ได้เลือกภาพเฉพาะกิจ
    //   ก็ยังได้ลายเซ็นค่าเริ่มต้นของระบบ ซึ่ง spec (CR-Features.md:320) ระบุว่า
    //   "ระบบต้องมีภาพเสมอ" → สถานะเริ่มต้นจึงต้องเป็นเขียว ไม่ใช่โทนจางทั้งที่ thumbnail ขึ้นข้าง ๆ
    hasSignature: function hasSignature() {
      return !!this.signatureAttachedId || this.hasDefaultSignature;
    },
    signatureButtonText: function signatureButtonText() {
      return this.hasSignature ? "ลายเซ็นผู้จัดทำ (คลิกเพื่อเปลี่ยน)" : "ลายเซ็นผู้จัดทำ";
    },

    // ผลลัพธ์จาก /Api/FormSummaryStock/GroupProcess ที่ขั้นที่ 1 เก็บไว้
    // (ถอยไปอ่าน processResult ได้ ถ้าขั้นที่ 1 ยังใช้ชื่อเดิมอยู่และมี agents ติดมา)
    groupResult: function groupResult() {
      var parent = this.$parent;
      if (!parent) return null;
      if (parent.groupProcessResult) return parent.groupProcessResult;
      if (parent.processResult && parent.processResult.agents) return parent.processResult;
      return null;
    },
    filterText: function filterText() {
      return this.groupResult && this.groupResult.filterText ? this.groupResult.filterText : "";
    },
    filterLabels: function filterLabels() {
      return this.$parent && this.$parent.filterLabels ? this.$parent.filterLabels : [];
    },
    agents: function agents() {
      return this.groupResult && this.groupResult.agents ? this.groupResult.agents : [];
    },
    // API เรียงมาให้แล้ว (มีข้อมูลก่อน → มูลค่ามากไปน้อย) — ที่นี่แค่แยกเป็น 2 ส่วนเพื่อวาดเส้นคั่น
    /**
     * FS-055 — ตัวแทนที่ตรงกับคำค้น
     *   ค้นได้ทั้งรหัสและชื่อ แบบเดียวกับหน้าสรุปผล (GroupResult)
     *   ตัด case ทิ้งและตัดช่องว่างหัวท้าย กัน paste ติดมา
     */
    matchedAgents: function matchedAgents() {
      var keyword = (this.agentKeyword || "").trim().toLowerCase();
      if (!keyword) return this.agents;

      return this.agents.filter(function (agent) {
        var haystack = ((agent.agentCode || "") + " " + (agent.agentName || "")).toLowerCase();
        return haystack.indexOf(keyword) !== -1;
      });
    },
    agentsWithData: function agentsWithData() {
      return this.matchedAgents.filter(function (agent) {
        return agent.hasData;
      });
    },
    agentsWithoutData: function agentsWithoutData() {
      return this.matchedAgents.filter(function (agent) {
        return !agent.hasData;
      });
    },
    // FS-105 — ตัวแทนที่ติดขัด เรียกข้อมูลไม่ได้ และผู้ใช้กด "ข้าม" (API ส่งแยกจาก agents)
    //   ลำดับไล่ต่อจากตัวแทนในตารางหลัก ให้คอลัมน์ "ลำดับ" ต่อเนื่องทั้งตาราง
    allFailedAgents: function allFailedAgents() {
      var list = this.groupResult && this.groupResult.failedAgents ? this.groupResult.failedAgents : [];
      var offset = this.agents.length;

      return list.map(function (agent, index) {
        return Object.assign({}, agent, { seqNo: offset + index + 1 });
      });
    },
    failedAgents: function failedAgents() {
      var keyword = (this.agentKeyword || "").trim().toLowerCase();
      if (!keyword) return this.allFailedAgents;

      return this.allFailedAgents.filter(function (agent) {
        var haystack = ((agent.agentCode || "") + " " + (agent.agentName || "")).toLowerCase();
        return haystack.indexOf(keyword) !== -1;
      });
    },
    totalQty: function totalQty() {
      return this.groupResult ? this.groupResult.totalQty : 0;
    },
    totalAmount: function totalAmount() {
      return this.groupResult ? this.groupResult.totalAmount : 0;
    },
    // FS-105 — "จากทั้งหมด N ตัวแทนจำหน่าย" ต้องนับรายที่ติดขัดด้วย (ผู้ใช้เลือกมาครบ N ราย)
    agentCount: function agentCount() {
      return this.agents.length + this.allFailedAgents.length;
    },
    // จำนวนเอกสารที่จะถูกสร้างจริง — ใช้ค่าจาก API เป็นหลัก (แหล่งความจริงเดียว)
    //
    // FS-055 — ทางถอยต้องนับจาก "ตัวแทนทั้งหมด" ไม่ใช่ agentsWithData ที่ถูกกรองด้วยคำค้น
    //   ไม่งั้นพิมพ์ค้นหาแล้วจำนวนเอกสารที่จะสร้างจะลดตามไปด้วย ซึ่งอันตรายมาก
    //   (ช่องค้นหามีไว้ดูข้อมูลเท่านั้น ห้ามมีผลกับสิ่งที่จะถูกบันทึก)
    documentCount: function documentCount() {
      if (this.groupResult && this.groupResult.documentCount != null) {
        return this.groupResult.documentCount;
      }
      return this.agents.filter(function (agent) {
        return agent.hasData;
      }).length;
    },
    saveButtonText: function saveButtonText() {
      return "บันทึกข้อมูล (สร้าง " + this.documentCount + " เอกสาร)";
    },
    // ไม่มีเอกสารให้สร้างเลย → กดบันทึก/Export ไม่ได้
    isNoData: function isNoData() {
      return this.documentCount === 0;
    },
    noDataMessage: function noDataMessage() {
      if (this.groupResult && this.groupResult.message) {
        return this.groupResult.message;
      }
      return "ไม่พบรายการสินค้าคงค้างของตัวแทนจำหน่ายที่เลือกเลย กรุณาแก้ไข Filter แล้วประมวลผลใหม่อีกครั้ง";
    },
    // รหัสตัวแทนที่จะส่งไปกับ API — ไล่จากแหล่งที่เชื่อถือได้มากไปน้อย
    agentCodes: function agentCodes() {
      var parent = this.$parent;

      if (parent && parent.groupAgentCodes && parent.groupAgentCodes.length > 0) {
        return parent.groupAgentCodes.slice();
      }

      var filter = parent ? parent.filter : null;
      if (filter && filter.agentCodes && filter.agentCodes.length > 0) {
        return filter.agentCodes.slice();
      }

      // ถอยไปใช้รหัสที่ API เพิ่งคืนมา — ตรงกับตารางที่ผู้ใช้เห็นอยู่ตรงหน้าเสมอ
      return this.agents.map(function (agent) {
        return agent.agentCode;
      });
    }
  },
  methods: {
    formatQty: function formatQty(value) {
      if (value == null || value === "") return "-";
      return Number(value).toLocaleString("en-US");
    },
    formatAmount: function formatAmount(value) {
      if (value == null || value === "") return "-";
      return Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    // FS-106 ข้อ 2 / FS-107 — หัวตารางรายละเอียดสินค้าแสดงชื่อตัวแทนอย่างเดียว ไม่มี [รหัส]
    //   (หาชื่อไม่เจอค่อยถอยไปใช้รหัส ไม่ให้หัวตารางว่าง)
    agentNameOnly: function agentNameOnly(agent) {
      if (!agent) return "";
      return agent.agentName || agent.agentCode || "";
    },
    agentLabel: function agentLabel(agent) {
      if (!agent) return "-";
      if (!agent.agentName) return "[" + agent.agentCode + "]";
      return "[" + agent.agentCode + "] " + agent.agentName;
    },
    isExpanded: function isExpanded(agentCode) {
      return this.expandedAgents[agentCode] === true;
    },
    // Vue 2 ไม่ตรวจจับการเพิ่ม key ใหม่ในอ็อบเจกต์ → ต้องใช้ $set
    toggleDetail: function toggleDetail(agentCode) {
      this.$set(this.expandedAgents, agentCode, !this.isExpanded(agentCode));
    },
    goBackToFilter: function goBackToFilter() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: "/PrintSummary/Barcodes/New" });
    },

    // ── FS-033 : Export Excel ตรวจรายละเอียด (ไฟล์ชั่วคราว — ระบบไม่เก็บไว้) ──
    //
    //   spec §M นับปุ่มนี้เป็น 1 ใน 5 กรณีที่ต้องมี Popup Progress
    //   ของเดิมยิง request เดียวแล้วบล็อกหน้าจอด้วย KTApp.blockPage — ไม่มี % ไม่มีปุ่มยกเลิก
    //   ทั้งที่งานจริงต้องวนประมวลผลทุกตัวแทนในชุดซ้ำอีกรอบ (หลายนาที)
    //
    //   ตอนนี้ยิง GroupExportExcelStart ที่คืน jobId ทันที แล้วให้ popup poll ความคืบหน้า
    //   ไฟล์พร้อมเมื่อไรผู้ใช้กด "ดาวน์โหลดไฟล์" บน popup (แพตเทิร์นเดียวกับ ZIP ขั้นที่ 6)
    exportExcel: function exportExcel() {
      var self = this;

      var filter = self.$parent ? self.$parent.filter : null;
      if (!filter) {
        Swal.fire("ไม่พบข้อมูล", "ไม่พบเงื่อนไขที่ใช้ประมวลผล กรุณากลับไปเลือก Filter แล้วประมวลผลใหม่อีกครั้ง", "warning");
        return;
      }

      if (self.isExporting || self.isSaving) return;
      self.isExporting = true;

      self.$refs.progressModal.start({
        title: "กำลังสร้างไฟล์ Excel ตรวจรายละเอียด",
        jobKind: "file",
        showTimer: true, // FS-126 · FS-139 — ปุ่มนี้ตกหล่นตอนทำ FS-126
        payload: withAgentCodes(filter, self.agentCodes),
        endpoints: {
          start: "/Api/FormSummaryStock/GroupExportExcelStart",
          // ไฟล์ .xlsx ต้องดาวน์โหลดผ่าน endpoint ที่ตอบ content-type ตามนามสกุล
          // (GroupZipDownload ตอบ application/zip ตายตัว ซึ่งใช้กับไฟล์นี้ไม่ได้)
          download: "/Api/FormSummaryStock/GroupFileDownload?jobId={jobId}"
        }
      });
    },

    // F11 (H2) + F14 (K1/K2) — สร้างเอกสารรวมพร้อม popup ความคืบหน้า
    //
    //   งานจริง 55 ตัวแทนกินเวลาหลายนาที เกิน timeout ของ HTTP request ปกติ
    //   จึงใช้ GroupSaveStart ที่คืน batchId ทันที แล้วให้ popup ไป poll ความคืบหน้าเอง
    //   (ไม่ใช้ KTApp.blockPage คั่นเฉย ๆ อีกแล้ว — ผู้ใช้ต้องเห็นว่าถึงไหนและกดยกเลิกได้)
    saveDocuments: function saveDocuments() {
      var self = this;
      var filter = self.$parent ? self.$parent.filter : null;

      if (!filter || !self.agentCodes || self.agentCodes.length === 0) {
        Swal.fire("ไม่พบเงื่อนไข", "กรุณากลับไปเลือกตัวแทนจำหน่ายใหม่อีกครั้ง", "warning");
        return;
      }

      if (self.isSaving) return;

      Swal.fire({
        title: "ยืนยันสร้างเอกสารรวม",
        html: "ระบบจะสร้างเอกสาร <strong>1 ฉบับต่อ 1 ตัวแทนจำหน่าย</strong><br>" + "ตัวแทนที่ไม่มีสินค้าคงค้างจะถูกข้าม ไม่สร้างเอกสารเปล่า<br><br>" + "จำนวนที่จะสร้าง: <strong>" + self.documentCount + "</strong> ฉบับ",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "ยืนยันสร้างเอกสาร",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        // SweetAlert2 v8 — ผลการยืนยันอยู่ที่ result.value
        if (!result.value) return;

        self.isSaving = true;

        self.$refs.progressModal.start({
          title: "กำลังสร้างเอกสารรวม",
          // FS-033 — บอกชนิดงานให้ popup ตรง ๆ ไม่ต้องเดาจาก URL
          //   (งานนี้งานเดียวที่ยกเลิกแล้วลบเอกสาร และมีปุ่ม resume/rollback บน popup error)
          jobKind: "document",
          showTimer: true, // FS-126
          // FS-110 — สร้างครบแล้วค้าง popup ไว้ 1 วินาทีให้เห็น 100% แล้วปิดเอง → ไปขั้นที่ 3 (สรุปผล)
          autoCloseMs: 1000,
          payload: withAgentCodes(filter, self.agentCodes),
          endpoints: { start: self.buildGroupSaveUrl() }
        });
      });
    },

    // ── F15 : ลายเซ็นผู้จัดทำของทั้งชุด ───────────────────────────────────
    openSignature: function openSignature() {
      // ยังไม่มีเลขที่เอกสารในขั้นนี้ — ส่ง id = 0 บอก popup ว่าเป็นโหมดก่อนบันทึก
      // (รูปแบบเดียวกับหน้าเอกสารเดี่ยว)
      // FS-070 — ส่งภาพที่หน้านี้ถืออยู่ไปด้วย ไม่งั้นเปิดครั้งที่ 2 popup จะลืมภาพที่เพิ่งบันทึก
      //   (โหมดก่อนบันทึก server ยังไม่มีเอกสารให้ผูกภาพ — หน้านี้คือที่เดียวที่รู้)
      this.$refs.signatureModal.open({
        id: 0,
        documentNo: "",
        attachedId: this.signatureAttachedId
      });
    },

    // FS-017 — อ่านลายเซ็นค่าเริ่มต้นของระบบตั้งแต่เปิดหน้า (best-effort เหมือนหน้าเอกสารเดี่ยว)
    /**
     * QA 08/10/2026 เรื่องที่ 1 — บรรทัด "*สำนักงานใหญ่ + สาขา [ ... ]"
     *
     * แสดงเฉพาะตอนที่ผู้ใช้เลือก "ตัวแทนจำหน่าย (Group)" มาสำนักงานใหญ่เดียว
     *   เลือกหลายสำนักงานใหญ่ หรือเลือก "ทั้งหมด" จะไม่มีสำนักงานใหญ่ตัวเดียวให้อ้างถึง
     *   การหยิบมาแสดงรายเดียวจะทำให้เข้าใจผิดว่ายอดรวมมาจากกลุ่มนั้นกลุ่มเดียว
     *
     * ใช้ endpoint CustomerBox ตัวเดียวกับหน้าตัวแทนรายเดียวและฟอร์ม PDF
     * (รองรับโหมดก่อนบันทึกอยู่แล้ว — ส่ง headerId = 0)
     */
    loadBranchLine: function loadBranchLine() {
      var self = this;
      var filter = self.$parent ? self.$parent.filter : null;

      self.branchLine = "";

      if (!filter) return;

      // รหัสที่เลือกจริง — มาจาก agentCodes ที่ขั้นที่ 1 ประกอบไว้
      var codes = Array.isArray(filter.agentCodes) ? filter.agentCodes : [];
      var headCode = filter.headAgentCode;

      // ไม่ใช่โหมด Group หรือไม่ได้เลือกสำนักงานใหญ่เดียว → ไม่มีบรรทัดนี้
      if (!headCode) return;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/CustomerBox", {
        headerId: 0,
        filterType: filter.filterType,
        agentCode: null,
        headAgentCode: headCode
      }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var data = response && response.data || {};
        self.branchLine = data.success && data.hasBranchLine ? data.branchLine : "";
      }).catch(function () {
        // best-effort — ไม่มีบรรทัดนี้ก็ยังใช้งานหน้าได้ครบ ไม่ต้องรบกวนผู้ใช้
        self.branchLine = "";
      });
    },

    loadDefaultSignature: function loadDefaultSignature() {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Signature", { headerId: 0 }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var data = response && response.data || {};

        // FS-018 — handler เซ็ต CanManage ไว้ตั้งแต่บรรทัดแรกของ Handle() จึงเชื่อถือได้
        //   แม้ success = false — อ่านก่อนด่าน success กันกรณี storage ล่มแล้วกลุ่ม A เสียปุ่มไปด้วย
        self.canManageSignature = !!data.canManage;

        if (!data.success) return;

        self.hasDefaultSignature = !data.isMissingDefault && !!data.defaultAttachedId;
        if (!self.signatureAttachedId) {
          self.signatureImageUrl = data.documentImageUrl || data.defaultImageUrl || "";
        }
      }).catch(function () {
        self.hasDefaultSignature = false;
        // FS-018 — เรียกไม่สำเร็จ = ไม่รู้สิทธิ์ ให้ถือว่าไม่มีสิทธิ์ (ซ่อนปุ่มไว้ก่อน)
        self.canManageSignature = false;
      });
    },

    onSignatureSelected: function onSignatureSelected(attachedId, imageUrl) {
      this.signatureAttachedId = attachedId || null;
      // FS-021 — เดิมรับ imageUrl มาแล้วทิ้ง thumbnail จึงค้างเป็นภาพเก่าหลังอัพโหลดใหม่
      //   ล้างภาพเฉพาะกิจแล้ว popup จะส่ง url ของค่าเริ่มต้นกลับมาแทน
      if (typeof imageUrl === "string") this.signatureImageUrl = imageUrl;
    },

    // แนบลายเซ็นเป็น query string — ไม่ปนกับ filter ที่ถูก serialize เก็บเป็น FilterJson
    // ฝั่ง server จะเชื่อค่านี้เฉพาะเมื่อผู้ใช้มีสิทธิ์จัดการลายเซ็นจริง
    buildGroupSaveUrl: function buildGroupSaveUrl() {
      var base = "/Api/FormSummaryStock/GroupSaveStart";
      return this.signatureAttachedId ? base + "?signatureAttachedId=" + encodeURIComponent(this.signatureAttachedId) : base;
    },

    // popup รายงานว่างานจบแล้ว (จบเอง / ยกเลิก / ล้มเหลว)
    //
    //   FS-033 — popup ตัวเดียวกันถูกใช้กับงาน Export Excel ด้วยแล้ว
    //   จึงต้องแยกด้วย jobKind ไม่ใช่เหมาเอาว่าทุกงานคือการสร้างเอกสาร
    onBatchFinished: function onBatchFinished(summary) {
      var isDocumentJob = !summary || summary.jobKind !== "file";

      if (isDocumentJob) this.isSaving = false;else this.isExporting = false;

      // รีเฟรชรายการใบงานที่หน้าค้นหา (route ปู่ = FormSummaryStockList.vue)
      if (isDocumentJob && summary && summary.createdCount > 0 && this.$parent && this.$parent.$parent && typeof this.$parent.$parent.reloadDataTable === "function") {
        this.$parent.$parent.reloadDataTable();
      }
    },

    // ผู้ใช้กดปิด popup แล้ว -> ไปหน้าขั้นที่ 6 สรุปผลทั้งชุด (F13)
    //
    //   ส่ง batchId ทาง query string เพื่อให้หน้านั้น refresh ได้และเปิดซ้ำทีหลังได้
    //   (หน้าขั้นที่ 6 อ่านข้อมูลจากฐานข้อมูล ไม่ใช่จาก state ในหน่วยความจำ)
    //
    //   ไม่มีเอกสารถูกสร้างเลย (ถูกข้ามหมด) ก็ไม่ต้องไป
    //   ปล่อยให้ผู้ใช้อยู่หน้า 3B เพื่อแก้เงื่อนไขแล้วลองใหม่ (ยกเลิก → ขั้นที่ 1 ดู FS-136 ด้านล่าง)
    //   FS-033 — งาน Export Excel ใช้ popup ตัวเดียวกัน แต่ต้องไม่พาไปหน้าขั้นที่ 6
    //   FS-031 — กด "ยกเลิกและลบไฟล์ที่สร้างแล้ว" แล้วเอกสารถูกลบหมด ก็ต้องไม่ไปเช่นกัน
    //            (popup ส่ง rolledBack = true มาให้ และตั้ง createdCount = 0 ไว้แล้ว)
    onBatchClosed: function onBatchClosed(summary) {
      this.isSaving = false;
      this.isExporting = false;

      if (summary && summary.jobKind === "file") return;

      // FS-136 — งานบันทึกจบแบบ "ยกเลิก" ทุกทาง (กลางคัน · ก่อนใบแรกเสร็จ · FS-031 ลบหลังติดขัด)
      //   → กลับขั้นที่ 1 (เลือก Filter) โดยคงค่าที่เลือกไว้ (หน้าเลือก Filter เป็น parent route จึงไม่ถูกสร้างใหม่)
      //   เดิมยกเลิกกลางคันแล้ว popup ส่ง createdCount ของเอกสารที่เพิ่งถูกลบไป (H3)
      //   จึงพาไปหน้าสรุปผล แล้วขึ้น "ไม่พบเอกสารในชุดนี้"
      if (summary && (summary.state === "Cancelled" || summary.rolledBack)) {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: "/PrintSummary/Barcodes/New" });
        return;
      }

      if (summary && summary.createdCount > 0 && summary.batchId) {
        // ส่ง batchId ทาง route params ไม่ใส่ใน URL
        //   spec: หน้าขั้นที่ 6 แสดงครั้งเดียว เปิดซ้ำไม่ได้ (ผู้ใช้ตัดสิน 25/09/2026)
        //   params ของ named route อยู่แค่ในหน่วยความจำ refresh แล้วหายตามที่ต้องการ
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
          name: "FormSummaryStockGroupResult",
          params: { batchId: summary.batchId }
        });
      }
    }
  },
  mounted: function mounted() {
    this.loadDefaultSignature();
    this.loadBranchLine();
    // เข้าหน้านี้ตรง ๆ โดยไม่ผ่านขั้นที่ 1 (refresh / paste URL) → ไม่มีผลประมวลผลให้แสดง
    if (!this.groupResult) {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({ path: "/PrintSummary/Barcodes/New" });
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormSummaryStockProgressModal__ = __webpack_require__(136);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Action Button Design System + Stepper ของโมดูลนี้ (QA เรื่องที่ 11 + 16)

// FS-088 — tooltip ของปุ่มวงกลมเป็นแบบ Bootstrap (ผูกครั้งเดียวทั้งโมดูล เรียกซ้ำได้)

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__["a" /* installFssTooltips */])();



__webpack_require__(9);

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F13 (J1) — ขั้นที่ 6 "สรุปผลการสร้างเอกสารรวม"
//   /PrintSummary/Barcodes/GroupResult
//
// รับ batchId ทาง route params ของ named route (ไม่ใช่ query string และไม่ใช่ $parent
//   เพราะ route นี้เป็น sibling ของ "New" — $parent คือหน้ารายการ)
//   spec ฉบับเซ็น 16/09/2026 ระบุว่าเป็น "หน้าชั่วคราว แสดงเพียงครั้งเดียว —
//   หากปิดหน้าจอไปแล้ว จะไม่สามารถเปิดหน้าสรุปเดียวกันขึ้นมาดูซ้ำได้"
//   ถ้ารับทาง query string จะ refresh/bookmark เปิดซ้ำได้ ซึ่งขัดกับ spec ข้อนี้
//   (เคยทำแบบนั้นไว้ — ผู้ใช้ตัดสินให้ยึด spec เมื่อ 25/09/2026)
//
// ── popup เตือนก่อนออกจากหน้า (spec บังคับ) ─────────────────────────────────
//   ออกจากหน้านี้แล้วต้องไปหาเอกสารทีละฉบับในหน้ารายการ จึงต้องเตือนก่อน
//   ครอบ 2 ทาง:
//     1. เปลี่ยน route ภายใน SPA  -> beforeRouteLeave
//     2. ปิดแท็บ / refresh / กด back -> beforeunload
//   ปุ่ม "กลับสู่หน้าค้นหา" ถือว่าผู้ใช้ตั้งใจออกแล้ว จึงข้ามการเตือน
//   ส่วนการคลิกเลขที่เอกสาร (FS-032) เปิดแท็บใหม่ = ยังอยู่หน้าเดิม จึงห้ามตั้ง leaveConfirmed
//
//   FS-019 — สาระของ popup นี้คือกันผู้ใช้ลืมดาวน์โหลด ZIP จึงต้องบอกด้วยว่า
//   "ยังไม่ได้ทำอะไรบ้าง" ไม่ใช่เตือนลอย ๆ ดู zipExcelDone / zipPdfDone
//   ข้อความของ beforeunload แก้ไม่ได้ (เบราว์เซอร์บังคับข้อความมาตรฐานของตัวเอง)
//   ส่วนนี้จึงมีผลเฉพาะเส้นทาง beforeRouteLeave
//
// SweetAlert2 = ^8.2.3 → ใช้ option ชื่อ `type` และอ่านผลจาก `result.value`
//   v8 รองรับ reverseButtons / focusCancel แล้ว (ใช้สลับให้ "ยังอยู่หน้านี้" เป็นปุ่มหลัก)
// ─────────────────────────────────────────────────────────────────────────────

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormSummaryStockProgressModal: __WEBPACK_IMPORTED_MODULE_4__FormSummaryStockProgressModal__["a" /* default */] },
  data: function data() {
    return {
      batchId: "",
      documents: [],
      documentCount: 0,
      totalQty: 0,
      // FS-121 — ยอดรวมแถว Grand Total · Filter ที่เลือกแบบขั้นที่ 2 · แถวที่กางรายละเอียดอยู่ (key = doc.id)
      totalAmount: 0,
      filterLabels: [],
      expandedDocs: {},
      filter: null,
      loadError: "",

      // true = ผู้ใช้กดปุ่มออกเอง ไม่ต้องเตือนซ้ำ
      leaveConfirmed: false,

      // FS-032 — คำค้นของช่อง "ค้นหารหัส/ชื่อตัวแทนจำหน่าย" เหนือตาราง (กรองฝั่ง client)
      agentKeyword: "",

      // ── FS-019 : จำว่างาน ZIP ฝั่งไหน "สำเร็จจริง" ไปแล้วบ้าง ──────────────
      //   ใช้ตัดสินว่าจะขึ้นกล่องเตือนงานค้างใน popup ก่อนออกจากหน้าหรือไม่
      //   เงื่อนไขที่นับว่าทำแล้ว = งานจบด้วยสถานะ Completed และมีไฟล์ผลลัพธ์จริง
      //   (แค่ "กดปุ่ม" ไม่นับ — งานอาจล้ม ถูกยกเลิก หรือขาดการติดต่อกลางทาง)
      zipExcelDone: false,
      zipPdfDone: false,

      // ฝั่งของงาน ZIP ที่กำลังรันอยู่ ("excel" / "pdf")
      //   popup ความคืบหน้าใช้ตัวเดียวกันทั้ง 2 ฝั่ง และไม่ได้บอกกลับมาว่าเป็นงานอะไร
      zipJobKind: ""
    };
  },
  computed: {
    // FS-032 — แถวที่ผ่านคำค้น
    //   ค้นได้ทั้งรหัสและชื่อตัวแทน (ผู้ใช้จำได้อย่างใดอย่างหนึ่ง)
    //   ตัด case ทิ้งเพราะรหัสบางรายมีตัวอักษรปน · ตัดช่องว่างหัวท้ายกัน paste ติดมา
    //   ไม่แตะ seqNo ของแถว — เลขลำดับต้องเป็นลำดับเดิมของทั้งชุด ไม่ใช่ลำดับในผลค้นหา
    filteredDocuments: function filteredDocuments() {
      var keyword = (this.agentKeyword || "").trim().toLowerCase();
      if (!keyword) return this.documents;

      return this.documents.filter(function (doc) {
        var haystack = ((doc.agentCode || "") + " " + (doc.agentName || "")).toLowerCase();
        return haystack.indexOf(keyword) !== -1;
      });
    },

    // FS-019 — รายการงานที่ "ยังไม่ได้ทำ" สำหรับกล่องเหลืองใน popup ก่อนออกจากหน้า
    //   ไม่มีเอกสารเลย = ไม่มีงานให้ทำ (ปุ่ม ZIP ทั้งคู่ถูก disable อยู่แล้ว)
    pendingZipTasks: function pendingZipTasks() {
      if (this.documentCount === 0) return [];

      var tasks = [];

      if (!this.zipExcelDone) {
        tasks.push({
          key: "excel",
          text: "Export Excel " + this.documentCount + " เอกสาร (รายละเอียดบาร์โค้ด) — ดาวน์โหลด ZIP"
        });
      }

      if (!this.zipPdfDone) {
        tasks.push({
          key: "pdf",
          text: "พิมพ์ PDF " + this.documentCount + " เอกสาร — ดาวน์โหลด ZIP"
        });
      }

      return tasks;
    }
  },
  methods: {
    // FS-121 — ฟังก์ชันชุดเดียวกับขั้นที่ 2 (FormSummaryStockGroupPreview.vue)
    formatQty: function formatQty(value) {
      if (value == null || value === "") return "-";
      return Number(value).toLocaleString("en-US");
    },
    agentLabel: function agentLabel(doc) {
      if (!doc) return "-";
      if (!doc.agentName) return "[" + doc.agentCode + "]";
      return "[" + doc.agentCode + "] " + doc.agentName;
    },
    isExpanded: function isExpanded(id) {
      return this.expandedDocs[id] === true;
    },
    // Vue 2 ไม่ตรวจจับการเพิ่ม key ใหม่ในอ็อบเจกต์ → ต้องใช้ $set
    toggleDetail: function toggleDetail(id) {
      this.$set(this.expandedDocs, id, !this.isExpanded(id));
    },

    formatAmount: function formatAmount(value) {
      if (value == null || value === "") return "-";
      return Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    loadResult: function loadResult() {
      var self = this;

      // params ของ named route อยู่แค่ในหน่วยความจำ — refresh แล้วค่านี้หายตามตั้งใจ
      self.batchId = self.$route.params.batchId || "";

      if (!self.batchId) {
        // เข้าตรง / refresh / กด back กลับมา = ไม่มี state แล้ว ตาม spec ห้ามเปิดซ้ำ
        // เด้งกลับหน้ารายการเงียบ ๆ ไม่ต้องขึ้น error ให้ผู้ใช้ตกใจ
        // (leaveConfirmed กัน popup เตือนเด้งซ้อนตอนเปลี่ยน route)
        self.leaveConfirmed = true;
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({ path: "/PrintSummary/Barcodes" });
        return;
      }

      KTApp.blockPage({ opacity: 0.05, message: "กำลังโหลดข้อมูล..." });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/GroupResult", { batchId: self.batchId }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var data = response && response.data || {};

        if (!data.success) {
          self.loadError = data.message || "ไม่พบข้อมูลชุดเอกสารนี้";
          return;
        }

        self.documents = data.documents || [];
        self.documentCount = data.documentCount || 0;
        self.totalQty = data.totalQty || 0;
        self.totalAmount = data.totalAmount || 0;
        self.filterLabels = data.filterLabels || [];
        self.filter = data.filter || null;
        self.loadError = "";
      }).catch(function () {
        self.loadError = "เกิดข้อผิดพลาดระหว่างโหลดข้อมูล กรุณาลองใหม่อีกครั้ง";
      }).then(function () {
        KTApp.unblockPage();
      });
    },

    // F13 (J2) — รวม Excel ทั้งชุดเป็น ZIP
    //   ใช้ popup ความคืบหน้าตัวเดียวกับตอนสร้างเอกสาร (F14) โดยสลับ endpoint
    //   งานนี้กินเวลาหลายนาทีเช่นกัน จึงต้องทำเบื้องหลัง ไม่ใช่รอในคำขอเดียว
    exportZipExcel: function exportZipExcel() {
      if (!this.batchId || this.documentCount === 0) return;

      // FS-019 — จำไว้ว่างานที่กำลังจะรันเป็นฝั่งไหน ไว้ใช้ตอนรับ event finished
      this.zipJobKind = "excel";

      this.$refs.progressModal.start({
        title: "กำลังสร้างไฟล์ ZIP (Excel)",
        showTimer: true, // FS-126
        payload: { batchId: this.batchId },
        endpoints: {
          start: "/Api/FormSummaryStock/GroupZipExcelStart"
        }
      });
    },

    // F13 (J2) — รวมฟอร์ม PDF ทั้งชุดเป็น ZIP
    //   ใช้ popup ความคืบหน้าตัวเดียวกับฝั่ง Excel ต่างแค่ endpoint ที่เริ่มงาน
    //   งานนี้หนักกว่าฝั่ง Excel เพราะ BIRT render ทีละฉบับ
    exportZipPdf: function exportZipPdf() {
      if (!this.batchId || this.documentCount === 0) return;

      // FS-019 — จำไว้ว่างานที่กำลังจะรันเป็นฝั่งไหน ไว้ใช้ตอนรับ event finished
      this.zipJobKind = "pdf";

      this.$refs.progressModal.start({
        title: "กำลังสร้างไฟล์ ZIP (PDF)",
        showTimer: true, // FS-126
        payload: { batchId: this.batchId },
        endpoints: {
          start: "/Api/FormSummaryStock/GroupZipPdfStart"
        }
      });
    },

    // FS-019 — งาน ZIP จบแล้ว (popup ความคืบหน้า emit "finished")
    //
    //   นับว่า "ทำแล้ว" ต่อเมื่อครบ 2 เงื่อนไข:
    //     1. state === "Completed"  — ไม่ใช่ Cancelled / Failed
    //        (ฝั่ง backend เรียก store.Complete(... Completed) เฉพาะตอนงานสำเร็จ)
    //     2. hasResultFile === true — มีไฟล์ ZIP ให้ดาวน์โหลดจริง
    //        ค่านี้อยู่บน popup ความคืบหน้า มาจาก GroupProgress
    //        (CompleteWithFile จะตั้งให้เฉพาะงานที่ผลิตไฟล์ได้สำเร็จ)
    //
    //   ไม่ผูกกับ "ผู้ใช้กดปุ่มดาวน์โหลดไฟล์แล้วหรือยัง" เพราะ popup ความคืบหน้า
    //   ไม่ได้ส่งสัญญาณนั้นออกมา และห้ามแก้ไฟล์นั้นในงานนี้
    onZipFinished: function onZipFinished(payload) {
      var info = payload || {};
      var modal = this.$refs.progressModal;
      var hasFile = !!(modal && modal.hasResultFile);

      if (info.state !== "Completed" || !hasFile) return;

      if (this.zipJobKind === "excel") {
        this.zipExcelDone = true;
      } else if (this.zipJobKind === "pdf") {
        this.zipPdfDone = true;
      }
    },

    // FS-019 — ประกอบเนื้อความ popup ยืนยันออกจากหน้า (3 ส่วนตาม design)
    //   1. ข้อความหลัก
    //   2. กล่องเหลืองรายการงานค้าง — แสดงเฉพาะเมื่อยังมีงานที่ยังไม่ได้ทำ
    //   3. กล่องหมายเหตุ
    //
    //   ใช้ style ฝังในบรรทัดโดยตั้งใจ: Swal สร้าง DOM ไว้นอก component
    //   ทำให้ <style scoped> ของไฟล์นี้ใช้ไม่ได้
    buildLeaveConfirmHtml: function buildLeaveConfirmHtml() {
      var tasks = this.pendingZipTasks;

      var html = '<div style="text-align:left;" data-test="fss-leave-main">' + "เมื่อออกจากหน้านี้แล้ว จะไม่สามารถกลับมาเปิดดูหน้าสรุปผลรวมนี้ได้อีก" + "</div>";

      if (tasks.length > 0) {
        var items = "";

        for (var i = 0; i < tasks.length; i++) {
          items += '<li data-test="fss-leave-pending-' + tasks[i].key + '" style="margin-top:0.25rem;">' + tasks[i].text + "</li>";
        }

        html += '<div data-test="fss-leave-pending" style="text-align:left;' + "background-color:#fff4de;border:1px solid #ffd77a;" + "border-left:4px solid #ffb822;border-radius:4px;" + 'padding:0.75rem 0.9rem;margin-top:0.9rem;color:#48465b;">' + "<strong>หากยังไม่ได้ดำเนินการต่อไปนี้ กรุณากลับไปดำเนินการก่อน:</strong>" + '<ul style="margin:0.5rem 0 0;padding-left:1.2rem;">' + items + "</ul>" + "</div>";
      }

      html += '<div data-test="fss-leave-note" style="text-align:left;' + "background-color:#f7f8fa;border:1px solid #ebedf2;border-radius:4px;" + "padding:0.65rem 0.9rem;margin-top:0.9rem;color:#74788d;" + 'font-style:italic;font-size:0.9rem;">' + "หมายเหตุ: เอกสารทั้งหมดที่สร้างสำเร็จแล้ว จะยังคงอยู่ในเมนู " + "&quot;รายการเอกสาร&quot; สามารถเปิดดูรายละเอียดและพิมพ์ทีละเอกสารได้ตามปกติ" + "</div>";

      return html;
    },

    // URL ของเอกสารรายฉบับ — ใช้ทั้งกับ href (คลิกกลาง/copy link ได้) และ window.open
    documentUrl: function documentUrl(doc) {
      return "/PrintSummary/Barcodes/" + encodeURIComponent(doc.documentNo);
    },

    // FS-032 ข้อ 2 — เปิดเอกสารรายฉบับใน "แท็บใหม่"
    //
    //   ของเดิมใช้ router.push = เปลี่ยนหน้าในแท็บเดิม ซึ่งทำให้หน้าสรุปชุดนี้หายถาวร
    //   (เป็นหน้าชั่วคราวที่ spec บอกว่าแสดงครั้งเดียว)
    //
    //   ⚠ ต้องไม่ตั้ง leaveConfirmed ที่นี่ — ผู้ใช้ยังอยู่หน้าเดิม ไม่ได้ออกไปไหน
    //     ถ้าตั้งไว้ การออกจากหน้าครั้งถัดไปจะไม่เตือน (FS-019 พัง)
    //
    //   ตัด opener ทิ้งด้วยเหตุผลความปลอดภัย — แท็บใหม่ไม่ควรเข้าถึง window ของหน้านี้ได้
    viewDocument: function viewDocument(doc) {
      var opened = window.open(this.documentUrl(doc), "_blank");
      if (opened) opened.opener = null;
    },

    /**
     * FS-054 — ปุ่ม "กลับสู่หน้าค้นหา" ต้องขึ้น popup ยืนยันเหมือนทางออกอื่น
     *
     * ของเดิมตั้ง leaveConfirmed = true ก่อน push ด้วยเหตุผลว่า
     * "กดปุ่มนี้ = ผู้ใช้ตั้งใจออกแล้ว" แต่สาระของ popup คือกันลืมดาวน์โหลด ZIP (FS-019)
     * และหน้านี้ spec บังคับว่าแสดงครั้งเดียว เปิดซ้ำไม่ได้ (FS-039 ข้อ 2)
     * คนที่กดปุ่มนี้จึงมีโอกาสลืมพอ ๆ กับคนที่ปิดแท็บ — ที่ผ่านมาทางออกที่คนใช้บ่อยที่สุด
     * กลับเป็นทางเดียวที่ไม่เตือน
     *
     * แก้ด้วยการ "ไม่ตั้ง leaveConfirmed" แล้วปล่อยให้ beforeRouteLeave เด้ง popup เอง
     * ได้ popup ตัวเดียวกันเป๊ะ ไม่ต้องเขียนซ้ำ และไม่มีทางเด้ง 2 ครั้ง
     */
    leaveToList: function leaveToList() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: "/PrintSummary/Barcodes" });
    },

    // เตือนตอนปิดแท็บ / refresh / กด back ของเบราว์เซอร์
    onBeforeUnload: function onBeforeUnload(event) {
      if (this.leaveConfirmed) return undefined;

      // เบราว์เซอร์สมัยใหม่ไม่ให้กำหนดข้อความเอง — ต้อง preventDefault + returnValue
      event.preventDefault();
      event.returnValue = "";
      return "";
    }
  },
  mounted: function mounted() {
    this.loadResult();
    window.addEventListener("beforeunload", this.onBeforeUnload);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
  },
  // เตือนตอนเปลี่ยนหน้าภายใน SPA (spec: ออกแล้วต้องไปหาเอกสารทีละฉบับในหน้ารายการ)
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.leaveConfirmed || this.loadError) {
      next();
      return;
    }

    Swal.fire({
      title: "ยืนยันการออกจากหน้าสรุปผลการสร้างเอกสาร",
      html: this.buildLeaveConfirmHtml(),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "ออกจากหน้า",
      cancelButtonText: "ยังอยู่หน้านี้",
      // FS-019 — ยกให้ "ยังอยู่หน้านี้" เป็นปุ่มหลัก
      //   focusCancel : ปุ่มที่โฟกัสอยู่คือปุ่มที่ Enter จะกดโดน จึงต้องเป็น
      //                 ตัวที่ปลอดภัย ไม่ใช่ตัวที่พาผู้ใช้ออกไปทั้งที่ยังไม่ได้โหลดไฟล์
      //   ไม่ใช้ reverseButtons — design วาง [ออกจากหน้า] ไว้ซ้าย [ยังอยู่หน้านี้] ไว้ขวา
      focusCancel: true
    }).then(function (result) {
      // SweetAlert2 v8 — ผลการยืนยันอยู่ที่ result.value
      next(result.value === true);
    });
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormSummaryStockAttachmentModal__ = __webpack_require__(628);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Action Button Design System + Stepper ของโมดูลนี้ (QA เรื่องที่ 11 + 16)

// FS-088 — tooltip ของปุ่มวงกลมเป็นแบบ Bootstrap (ผูกครั้งเดียวทั้งโมดูล เรียกซ้ำได้)

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__["a" /* installFssTooltips */])();







__webpack_require__(11);
__webpack_require__(13);
__webpack_require__(9);

// FS-077 — overlay "กำลังค้นหาข้อมูล..." ต้องค้างอย่างน้อยเท่านี้ (ms)
var SEARCH_MIN_LOADING_MS = 1000;

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F02 — หน้า "ค้นหาใบงาน" (/PrintSummary/Barcodes)
//
// Template ที่ mirror: SBP.Web/App/Components/StockCoverDays/StockCoverDaysList.vue
//   (worktree scvd-dev) — root v-show ตาม route + <router-view/> พี่น้องกัน, kt-portlet head/body,
//   form.kt-form ref="searchForm", <table> ที่มีแต่ <thead> ให้ DataTables เติม body,
//   server-side DataTable, Vue.extend mini-component ต่อแถวที่ mount ตอน draw.dt,
//   KTApp.block/unblock ที่ preXhr.dt/xhr.dt, DatatableWarning.alert ที่ error.dt
//   และ flow ยืนยันด้วย SweetAlert2 → axios → reloadDataTable()
//
// SweetAlert2 = ^8.2.3 (SBP.Web/package.json) → ใช้ option ชื่อ `type` (ไม่ใช่ `icon` ของ v9+)
// และอ่านผลจาก `result.value`
//
// spec ฉบับลูกค้าเซ็นยืนยัน 16/09/2026 เพิ่มในหน้านี้:
//   F02 — filter "สถานะแนบไฟล์เอกสาร" (ทั้งหมด / มีเอกสารแนบ / ไม่มีเอกสารแนบ)
//         + ปุ่มคำสั่ง 5 ปุ่มเป็น "ปุ่มมีข้อความ" ไม่ใช่ไอคอนล้วน (จัด 2 บรรทัด)
//   F09 — filter "อายุ Export Excel" 4 สถานะ + บรรทัด "หมดอายุ Export Excel" ทุกแถว
//         + ปุ่ม Excel เทากดไม่ได้เมื่อรายละเอียดบาร์โค้ดหมดอายุ (พร้อม tooltip)
//   F16 — ปุ่มลบแสดงตาม data.canDelete ที่ server คำนวณมา (แอดมินตัวแทนลบใบที่
//         แอดมินทีมเบียร์สดสร้างไม่ได้) — การซ่อนปุ่มเป็นแค่ UX ฝั่ง API บังคับซ้ำเสมอ
// ─────────────────────────────────────────────────────────────────────────────

// รูปแบบวันที่ที่ backend รับ (FormSummaryStockDatatable.DateFrom/DateTo = "dd/MM/yyyy")
var DATE_FORMAT = "DD/MM/YYYY";

// ปุ่มที่ยังไม่ถึงคิวพัฒนา — แจ้งผู้ใช้เป็นภาษาไทยแทนการเงียบ (ห้ามใช้ alert()/console.log)
// F07 (E3) — ดาวน์โหลด Excel ของเอกสาร 1 ฉบับ
//   endpoint คืนไฟล์เป็น binary จึงต้องอ่านเป็น arraybuffer แล้วแปลงเป็น Blob
//   กรณีไม่สำเร็จ server คืน JSON { success:false, message } มาแทนไฟล์ ซึ่งยังเป็น arraybuffer อยู่
//   จึงต้องแปลงกลับเป็นข้อความก่อนอ่าน message (ไม่งั้นผู้ใช้จะเห็น popup ว่างเปล่า)
//   pattern การดึงชื่อไฟล์: เหมือน FormSummaryStockGroupPreview.vue และ Report/Barcodes.vue:1014-1034
function downloadDocumentExcel(headerId, accessToken) {
  KTApp.blockPage({
    opacity: 0.05,
    message: "กำลังสร้างไฟล์ Excel กรุณารอสักครู่..."
  });

  __WEBPACK_IMPORTED_MODULE_3_axios___default()({
    method: "post",
    url: "/Api/FormSummaryStock/ExportExcel",
    responseType: "arraybuffer",
    data: { headerId: headerId },
    headers: { Authorization: "Bearer " + accessToken }
  }).then(function (response) {
    var contentType = response.headers["content-type"] || "";

    // server ปฏิเสธ (หมดอายุ / ไม่มีสิทธิ์ / ไม่มีข้อมูล) → เป็น JSON ไม่ใช่ไฟล์
    if (contentType.indexOf("application/json") !== -1) {
      var text = "";
      try {
        text = new TextDecoder("utf-8").decode(new Uint8Array(response.data));
      } catch (e) {
        text = "";
      }
      var message = "ไม่สามารถ Export Excel ได้";
      try {
        var parsed = JSON.parse(text);
        if (parsed && parsed.message) message = parsed.message;
      } catch (e) {
        // ปล่อยข้อความเริ่มต้นไว้
      }
      Swal.fire("ไม่สามารถ Export ได้", message, "warning");
      return;
    }

    var filename = "";
    var disposition = response.headers["content-disposition"];
    if (disposition && disposition.indexOf("attachment") !== -1) {
      // ดึงชื่อไฟล์จาก Content-Disposition โดยไม่ใช้ regex
      // (หลีกเลี่ยงปัญหา escape ของ \n ในไฟล์ .vue ซึ่งเคยทำให้ bundle พัง)
      var marker = "filename=";
      var at = disposition.indexOf(marker);
      if (at !== -1) {
        filename = disposition.substring(at + marker.length);
        var semi = filename.indexOf(";");
        if (semi !== -1) filename = filename.substring(0, semi);
        filename = filename.trim().replace(/^["']|["']$/g, "");
      }
    }

    var blob = new Blob([response.data], { type: contentType });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = decodeURIComponent(filename);
    link.click();
  }).catch(function () {
    Swal.fire("เกิดข้อผิดพลาด", "สร้างไฟล์ Excel ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
  }).then(function () {
    KTApp.unblockPage();
  });
}

// F06 (E1) — เปิดฟอร์ม PDF ของเอกสาร 1 ฉบับ
//   โครงเดียวกับ downloadDocumentExcel ด้านบน — endpoint ต้องการ Bearer token
//   จึงยิงด้วย axios แล้วแปลงเป็น blob ไม่ใช้ <a href> ที่ไม่แนบ header
//
// FS-035 — spec §F (L1495-1499) ระบุว่าปุ่มนี้คือ "เปิดดูก่อนพิมพ์" ไม่ใช่ดาวน์โหลดทันที
//   เปิดแท็บเปล่าทันทีใน user gesture ก่อน (กัน popup blocker) แล้วค่อยชี้ไปที่ blob เมื่อไฟล์มา
//   หน้ารายละเอียด (FormSummaryStockDetail.vue) ใช้กติกาเดียวกัน — แก้ที่ไหนต้องแก้คู่กัน
function downloadDocumentPdf(headerId, accessToken) {
  // ต้องเรียก window.open ตรงนี้ ไม่ใช่ใน .then() — เบราว์เซอร์อนุญาตเฉพาะที่เกิดจากการกดของผู้ใช้
  var previewTab = window.open("", "_blank");
  if (previewTab && previewTab.document) {
    previewTab.document.write('<!doctype html><meta charset="utf-8">' + "<title>กำลังเตรียมเอกสาร</title>" + '<body style="font-family:sans-serif;padding:24px">' + "กำลังสร้างไฟล์ PDF กรุณารอสักครู่...</body>");
  }

  // FS-133 — เปิดแท็บได้ → ขอตั๋วแล้วชี้แท็บไปที่ URL จริง (PdfView/{ตั๋ว}/{ชื่อไฟล์}.pdf)
  //   แถบที่อยู่และชื่อไฟล์ตอนกดดาวน์โหลดในตัวดู PDF จึงเป็นชื่อเอกสาร ไม่ใช่ GUID ของ blob:
  //   โดน popup blocker (ไม่มีแท็บ) → ใช้ทางเดิมด้านล่าง : ดึงไฟล์แล้วเสนอให้ดาวน์โหลดแทน
  if (previewTab) {
    openPdfByTicket(headerId, accessToken, previewTab);
    return;
  }

  KTApp.blockPage({
    opacity: 0.05,
    message: "กำลังสร้างไฟล์ PDF กรุณารอสักครู่..."
  });

  __WEBPACK_IMPORTED_MODULE_3_axios___default()({
    method: "post",
    url: "/Api/FormSummaryStock/PrintPdf",
    responseType: "blob",
    data: { headerId: headerId },
    headers: { Authorization: "Bearer " + accessToken }
  }).then(function (response) {
    var contentType = response.headers["content-type"] || "";

    if (contentType.indexOf("application/json") !== -1) {
      // server ปฏิเสธ — ปิดแท็บที่เปิดค้างไว้ ไม่ทิ้งหน้าเปล่าให้ผู้ใช้งง
      if (previewTab) previewTab.close();

      var reader = new FileReader();
      reader.onload = function () {
        var message = "พิมพ์เอกสารไม่สำเร็จ";
        try {
          var parsed = JSON.parse(reader.result);
          if (parsed && parsed.message) message = parsed.message;
        } catch (e) {
          // ใช้ข้อความเริ่มต้น
        }
        Swal.fire("พิมพ์ไม่ได้", message, "warning");
      };
      reader.readAsText(response.data);
      return;
    }

    // FS-035 — บังคับ MIME เป็น application/pdf เพื่อให้เบราว์เซอร์เปิดด้วยตัวอ่าน PDF
    //   ไม่ใช่ถือเป็นไฟล์ให้ดาวน์โหลด
    var blob = new Blob([response.data], { type: "application/pdf" });
    var blobUrl = window.URL.createObjectURL(blob);

    if (previewTab) {
      previewTab.location.href = blobUrl;
    } else {
      // โดน popup blocker — อย่าเงียบ บอกผู้ใช้แล้วให้ทางเลือกดาวน์โหลดแทน
      Swal.fire({
        title: "เบราว์เซอร์บล็อกการเปิดแท็บใหม่",
        html: "กรุณาอนุญาต popup ของเว็บไซต์นี้เพื่อเปิดดูเอกสารก่อนพิมพ์<br/>" + "หรือกดปุ่มด้านล่างเพื่อดาวน์โหลดไฟล์แทน",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ดาวน์โหลดไฟล์แทน",
        cancelButtonText: "ปิด"
      }).then(function (result) {
        if (result.value !== true) return;

        var filename = "";
        var disposition = response.headers["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var marker = "filename=";
          var at = disposition.indexOf(marker);
          if (at !== -1) {
            filename = disposition.substring(at + marker.length);
            var semi = filename.indexOf(";");
            if (semi !== -1) filename = filename.substring(0, semi);
            filename = filename.trim().replace(/^["']|["']$/g, "");
          }
        }

        var link = document.createElement("a");
        link.href = blobUrl;
        link.download = decodeURIComponent(filename) || "เอกสาร.pdf";
        link.click();
      });
    }

    setTimeout(function () {
      window.URL.revokeObjectURL(blobUrl);
    }, 60000);
  }).catch(function () {
    if (previewTab) previewTab.close();
    Swal.fire("เกิดข้อผิดพลาด", "พิมพ์เอกสารไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
  }).then(function () {
    KTApp.unblockPage();
  });
}

// FS-133 — ขอตั๋วเปิด PDF (ตรวจสิทธิ์ชุดเดียวกับ PrintPdf) แล้วเปิดในแท็บที่เตรียมไว้
//   ตั๋วอายุ 5 นาที — หมดอายุแล้วแท็บจะแสดงหน้าแจ้งพร้อมปุ่ม "ไปที่เอกสาร" (server ทำ)
//   หน้ารายละเอียด (FormSummaryStockDetail.vue) ใช้กติกาเดียวกัน — แก้ที่ไหนต้องแก้คู่กัน
function openPdfByTicket(headerId, accessToken, previewTab) {
  KTApp.blockPage({ opacity: 0.05, message: "กำลังเปิดเอกสาร PDF..." });

  __WEBPACK_IMPORTED_MODULE_3_axios___default()({
    method: "post",
    url: "/Api/FormSummaryStock/PdfTicket",
    data: { headerId: headerId },
    headers: { Authorization: "Bearer " + accessToken }
  }).then(function (response) {
    var data = response.data || {};
    if (!data.success || !data.url) {
      previewTab.close();
      Swal.fire("พิมพ์ไม่ได้", data.message || "พิมพ์เอกสารไม่สำเร็จ", "warning");
      return;
    }
    previewTab.location.href = data.url;
  }).catch(function () {
    previewTab.close();
    Swal.fire("เกิดข้อผิดพลาด", "พิมพ์เอกสารไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
  }).then(function () {
    KTApp.unblockPage();
  });
}

function showUnderDevelopment(featureName) {
  Swal.fire("อยู่ระหว่างพัฒนา", "ฟังก์ชัน " + featureName + " อยู่ระหว่างพัฒนา", "info");
}

// ลบใบงาน = Soft Delete (is_deleted = 1) — ยืนยัน 1 ครั้ง แล้ว POST /Api/FormSummaryStock/Delete
// เอกสารระบุ: ใบงานหายจากรายการแต่ข้อมูลยังอยู่ในฐานข้อมูล กู้คืนต้องติดต่อพนักงาน SBP เท่านั้น
function deleteFormSummaryStock(ctx) {
  var self = ctx;
  var documentNo = self.data && self.data.documentNo ? self.data.documentNo : "";

  Swal.fire({
    title: "ยืนยันการลบใบงาน",
    type: "warning",
    html: "ต้องการลบใบงานเลขที่ <strong>" + documentNo + "</strong> ใช่หรือไม่?<br/>" + "<small class='text-muted'>ใบงานจะหายจากรายการทันที หากต้องการกู้คืนต้องติดต่อพนักงาน SBP เท่านั้น</small>",
    showCancelButton: true,
    confirmButtonText: "ยืนยันลบ",
    cancelButtonText: "ยกเลิก",
    showLoaderOnConfirm: true
  }).then(function (result) {
    if (result.value) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังลบข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/FormSummaryStock/Delete", { id: self.data.id }, {
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token
        }
      }).then(function (response) {
        if (response.data.success) {
          self.$parent.reloadDataTable();
          Swal.fire("สำเร็จ", "ลบข้อมูลสำเร็จ", "success");
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        var errorMsg = error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด";
        Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    }
  });
}

// ข้อความ tooltip ของปุ่ม Excel เมื่อรายละเอียดบาร์โค้ดหมดอายุ — คำต่อคำตาม CR-Features.md F02/F09
// จำนวนไฟล์แนบสูงสุดต่อเอกสาร — ตรงกับฝั่ง server (FormSummaryStockAttachmentRules)
var MAX_ATTACHMENTS = 5;

var EXCEL_EXPIRED_TOOLTIP = "ไม่สามารถ Export ข้อมูลได้ เนื่องจากข้อมูลรายละเอียดบาร์โค้ดถูกลบไปแล้ว (ระบบเก็บข้อมูล 2 ปีนับจากวันบันทึกเอกสาร)";

// Row actions — 5 ปุ่มตาม CR-Features.md F02:
//   ดูรายละเอียด / PDF / Excel / แนบไฟล์เอกสาร (แดง = 0 ไฟล์, เขียว = มีไฟล์ ≥ 1) / ลบ
// สีปุ่มแนบไฟล์อ่านจาก data.attachmentCount ที่ API ค้นหาส่งมาพร้อมแถว — ไม่ยิง API รายแถว
//
// F09 — ปุ่ม Excel เทาและกดไม่ได้เมื่อ data.isExcelAvailable = false
//   ตั้งใจไม่ใส่ class "disabled" ของ Bootstrap 4 เพราะ a.btn.disabled ตั้ง pointer-events: none
//   ซึ่งจะทำให้ tooltip (title) ไม่ขึ้นตอน hover — แต่ spec บังคับว่าต้องมี tooltip อธิบายเหตุผล
//   จึงใช้ aria-disabled + ทำให้จาง แล้วกันการกดจริงที่ method exportExcel() แทน
//   + บรรทัด "หมดอายุ Export Excel วว/ดด/ปปปป" ใต้ปุ่มคำสั่งทุกแถว
//     ใช้สีเทาปกติ "ทุกสถานะ" ไม่แยกสี/พื้นแถวตามสถานะ (spec ระบุชัด — ปุ่ม Excel กับ filter
//     เป็นตัวบอกสถานะอยู่แล้ว)
// F16 — ปุ่มลบแสดงเมื่อ data.canDelete = true เท่านั้น (server คำนวณมาให้)
//   การซ่อนปุ่มเป็นแค่ UX — ด่านจริงอยู่ที่ DeleteFormSummaryStockCommandHandler
var FormSummaryStockActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <!-- QA 08/10/2026 \u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E17\u0E35\u0E48 3 \u2014 \u0E04\u0E2D\u0E25\u0E31\u0E21\u0E19\u0E4C \"\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\" \u0E40\u0E1B\u0E47\u0E19\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E25\u0E49\u0E27\u0E19 + tooltip\n         (spec \u0E09\u0E1A\u0E31\u0E1A\u0E40\u0E0B\u0E47\u0E19\u0E16\u0E39\u0E01 BA \u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D I \u0E40\u0E21\u0E37\u0E48\u0E2D 08/10/2026 \u0E41\u0E17\u0E19\u0E17\u0E35\u0E48 FS-005 \u0E17\u0E35\u0E48\u0E43\u0E2B\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E1B\u0E38\u0E48\u0E21\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21)\n\n         QA \u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E17\u0E35\u0E48 16 \u2014 Action Button Design System: \u0E27\u0E07\u0E01\u0E25\u0E21 sm 28px \xB7 \u0E2A\u0E35\u0E15\u0E32\u0E21\u0E04\u0E27\u0E32\u0E21\u0E2B\u0E21\u0E32\u0E22\n           \uD83D\uDD35 \u0E14\u0E39 \xB7 \uD83D\uDFE0 \u0E1E\u0E34\u0E21\u0E1E\u0E4C PDF \xB7 \uD83D\uDFE2 Excel / \u0E41\u0E19\u0E1A\u0E44\u0E1F\u0E25\u0E4C (\u0E21\u0E35\u0E44\u0E1F\u0E25\u0E4C) \xB7 \uD83D\uDD34 \u0E25\u0E1A / \u0E41\u0E19\u0E1A\u0E44\u0E1F\u0E25\u0E4C (0/5) \xB7 Excel \u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38 = inactive \u0E40\u0E17\u0E32\n           FS-079 (13/10/2026) \u2014 \u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2A\u0E31\u0E48\u0E07\u0E01\u0E25\u0E31\u0E1A\u0E21\u0E32\u0E43\u0E0A\u0E49\u0E41\u0E1A\u0E1A\u0E19\u0E35\u0E49 \u0E22\u0E01\u0E40\u0E25\u0E34\u0E01 style /Jobs \u0E02\u0E2D\u0E07 FS-071\n           \u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E15\u0E32\u0E21\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19: \u0E16\u0E31\u0E07\u0E02\u0E22\u0E30 fa-trash (\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 la-trash \u0E02\u0E2D\u0E07 FS-063)\n\n         \u26A0 \u0E17\u0E38\u0E01\u0E1B\u0E38\u0E48\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35 title \u0E40\u0E2A\u0E21\u0E2D \u2014 \u0E40\u0E1B\u0E47\u0E19\u0E17\u0E31\u0E49\u0E07 tooltip \u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49 (\u0E40\u0E01\u0E13\u0E11\u0E4C\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E17\u0E35\u0E48 3) \u0E41\u0E25\u0E30 selector \u0E02\u0E2D\u0E07\u0E40\u0E17\u0E2A\n         data-test \u0E43\u0E2A\u0E48\u0E44\u0E27\u0E49\u0E43\u0E2B\u0E49\u0E40\u0E17\u0E2A\u0E08\u0E31\u0E1A\u0E1B\u0E38\u0E48\u0E21\u0E44\u0E14\u0E49\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E1C\u0E39\u0E01\u0E01\u0E31\u0E1A\u0E04\u0E25\u0E32\u0E2A\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E32 -->\n    <div class=\"fss-actions fss-act-group\">\n      <a href=\"#\" @click.prevent=\"viewDocument\"\n         class=\"fss-act fss-act--sm fss-act--blue\"\n         data-test=\"fss-row-view\"\n         title=\"\u0E14\u0E39\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\">\n        <i class=\"fas fa-search\"></i>\n      </a>\n      <a href=\"#\" @click.prevent=\"exportPdf\"\n         class=\"fss-act fss-act--sm fss-act--orange\"\n         data-test=\"fss-row-pdf\"\n         title=\"\u0E1E\u0E34\u0E21\u0E1E\u0E4C PDF\">\n        <i class=\"fas fa-print\"></i>\n      </a>\n      <a href=\"#\" @click.prevent=\"exportExcel\"\n         class=\"fss-act fss-act--sm fss-act--green\"\n         :class=\"{ 'fss-act--disabled': !excelAvailable }\"\n         data-test=\"fss-row-excel\"\n         :aria-disabled=\"!excelAvailable\"\n         :title=\"excelTitle\">\n        <i class=\"fas fa-file-excel\"></i>\n      </a>\n      <a href=\"#\" @click.prevent=\"openAttachment\"\n         class=\"fss-act fss-act--sm\"\n         :class=\"hasAttachment ? 'fss-act--green fss-attach-has' : 'fss-act--red'\"\n         data-test=\"fss-row-attach\"\n         :title=\"attachmentTitle\">\n        <i class=\"fas fa-paperclip\"></i>\n      </a>\n      <a v-if=\"showDelete\" href=\"#\" @click.prevent=\"deleteDocument\"\n         class=\"fss-act fss-act--sm fss-act--red\"\n         data-test=\"fss-row-delete\"\n         title=\"\u0E25\u0E1A\">\n        <i class=\"fas fa-trash\"></i>\n      </a>\n    </div>\n    <!-- design \u0E43\u0E2B\u0E49\u0E40\u0E19\u0E49\u0E19\u0E04\u0E33\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E14\u0E49\u0E27\u0E22\u0E2A\u0E35\u0E41\u0E14\u0E07 \u0E2A\u0E48\u0E27\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E35\u0E1B\u0E01\u0E15\u0E34 \u0E08\u0E30\u0E44\u0E14\u0E49\u0E2D\u0E48\u0E32\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E07\u0E48\u0E32\u0E22\n         \u0E44\u0E21\u0E48\u0E08\u0E21\u0E44\u0E1B\u0E01\u0E31\u0E1A\u0E2A\u0E35\u0E41\u0E14\u0E07\u0E17\u0E31\u0E49\u0E07\u0E1A\u0E23\u0E23\u0E17\u0E31\u0E14 -->\n    <div v-if=\"excelExpireDateText\" class=\"fss-expire-line\">\n      <span class=\"fss-expire-warn\">\u26A0 \u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38 Export Excel</span>\n      <span class=\"fss-expire-date\">{{ excelExpireDateText }}</span>\n    </div>\n  </div>",
  props: ['canEdit'],
  computed: {
    fileCount: function fileCount() {
      return this.data && this.data.attachmentCount ? this.data.attachmentCount : 0;
    },
    hasAttachment: function hasAttachment() {
      return this.fileCount > 0;
    },
    attachmentTitle: function attachmentTitle() {
      // QA เรื่องที่ 3 — ปุ่มเป็นไอคอนล้วนแล้ว tooltip จึงต้องบอกทั้งชื่อและจำนวน
      return "แนบไฟล์เอกสาร (" + this.fileCount + "/" + MAX_ATTACHMENTS + ")";
    },
    // F09 — สถานะมาจาก server เสมอ (นาฬิกาเครื่อง client เชื่อไม่ได้)
    // ไม่ส่งค่ามา = ถือว่ายัง export ได้ เพื่อไม่ให้ใบเก่าถูกล็อคโดยไม่ตั้งใจ
    excelAvailable: function excelAvailable() {
      return !this.data || this.data.isExcelAvailable !== false;
    },
    excelTitle: function excelTitle() {
      return this.excelAvailable ? "Export Excel (รายละเอียดบาร์โค้ด)" : EXCEL_EXPIRED_TOOLTIP;
    },
    // บรรทัดใต้ปุ่มคำสั่ง — ซ่อนเมื่อใบนั้นยังไม่มีวันหมดอายุ (ExcelExpireDate = NULL)
    // แยกวันที่ออกจากข้อความเตือน เพราะ design ให้คนละสี
    excelExpireDateText: function excelExpireDateText() {
      if (!this.data || !this.data.excelExpireDate) return "";
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.data.excelExpireDate).format("DD/MM/YYYY");
    },
    // F16 — ปุ่มลบต้องผ่านทั้งสิทธิ์ใช้งานหน้าจอ (canEdit) และสิทธิ์ลบรายแถว (canDelete)
    // ไม่ส่ง canDelete มา = ไม่แสดงปุ่ม (ปฏิเสธไว้ก่อนปลอดภัยกว่า)
    showDelete: function showDelete() {
      return this.canEdit === true && !!this.data && this.data.canDelete === true;
    }
  },
  methods: {
    viewDocument: function viewDocument() {
      // URL ใบที่บันทึกแล้ว = /PrintSummary/Barcodes/{DocNo} (CR-Features.md F05)
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ path: "/PrintSummary/Barcodes/" + this.data.documentNo });
    },
    // F06 (E1) — พิมพ์ฟอร์ม PDF ของแถวนี้
    exportPdf: function exportPdf() {
      if (!this.data || !this.data.id) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบเลขที่อ้างอิงของเอกสารนี้", "error");
        return;
      }
      downloadDocumentPdf(this.data.id, this.$root.user.access_token);
    },
    // F07 (E3) — Export Excel รายละเอียดบาร์โค้ด 46 คอลัมน์ จาก snapshot ของใบนี้
    exportExcel: function exportExcel() {
      // F09 — หมดอายุแล้วต้องกดไม่ได้จริง ไม่ใช่แค่ทำให้ปุ่มดูจาง
      // (tooltip บนปุ่มอธิบายเหตุผลอยู่แล้ว จึงไม่เด้ง popup ซ้ำ)
      if (!this.excelAvailable) return;

      if (!this.data || !this.data.id) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบเลขที่อ้างอิงของเอกสารนี้", "error");
        return;
      }

      downloadDocumentExcel(this.data.id, this.$root.user.access_token);
    },
    // F08 — เปิด popup แนบไฟล์เอกสาร (FormSummaryStockAttachmentModal.vue)
    //   component นี้ mount ด้วย { parent: self } ตอน draw.dt → $parent = หน้ารายการที่ถือ modal ไว้
    //   การ reload ตารางหลังปิด popup ทำผ่าน @closed="reloadDataTable()" ที่ template ของหน้ารายการ
    openAttachment: function openAttachment() {
      // $refs safety — modal อยู่นอก v-if/v-show จึงมีเสมอ แต่กันไว้เผื่อ mount ยังไม่เสร็จ
      var modal = this.$parent && this.$parent.$refs ? this.$parent.$refs.attachmentModal : null;

      if (!modal || typeof modal.open !== "function") {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถเปิดหน้าต่างแนบไฟล์เอกสารได้ กรุณาโหลดหน้าใหม่อีกครั้ง", "error");
        return;
      }

      modal.open(this.data);
    },
    deleteDocument: function deleteDocument() {
      deleteFormSummaryStock(this);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_6__Shared_Select2__["a" /* default */],
    // F08 — popup แนบไฟล์เอกสาร (เรียกผ่าน $refs.attachmentModal.open(rowData))
    "form-summary-stock-attachment-modal": __WEBPACK_IMPORTED_MODULE_8__FormSummaryStockAttachmentModal__["a" /* default */]
  },
  computed: {
    // สิทธิ์สร้าง/ลบใบงาน — Profile "พิมพ์เอกสารสรุปข้อมูล" (super_admin ผ่านเสมอผ่าน canShow)
    // ค่าคงที่ตรงกับ SBP.Application/Constants/FORM_SUMMARY_STOCK_ROLE.cs + COMPANY_PROFILE_TYPE.cs
    canEdit: function canEdit() {
      return this.$root.canShow([["FORM_SUMMARY_STOCK_ADMIN", "COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK"], ["FORM_SUMMARY_STOCK_AGENT", "COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK"]]);
    }
  },
  data: function data() {
    var self = this;

    return {
      // moment object หรือ null — แปลงเป็น "DD/MM/YYYY" ตอนส่งให้ API
      searchDateFrom: null,
      searchDateTo: null,
      // FS-014 — คำค้นเลขที่เอกสาร ("" = ไม่กรอง) · trim ก่อนส่งให้ API
      //   ใช้ "" ไม่ใช่ null เพราะผูกกับ <input> ตรง ๆ (v-model ของ input จะได้ string เสมอ)
      // FS-077 — เวลาที่เริ่มโหลดรอบล่าสุด + เลขรอบ (กัน timer รอบเก่าปลด overlay ของรอบใหม่)
      searchStartedAt: 0,
      searchRound: 0,
      searchDocumentNo: "",
      // null = "ทั้งหมด" (ค่าเริ่มต้นตาม CR-Features.md F02)
      searchAgentCode: null,
      // F09 — null = "ทั้งหมด" · ค่าที่ส่งตรงกับ FormSummaryStockExcelExpiryStatus (ฝั่ง C#)
      searchExcelExpiryStatus: null,
      // FS-004 — null = "ทั้งหมด" · ค่าที่ส่งตรงกับ FormSummaryStockAttachmentStatus (ฝั่ง C#)
      searchAttachmentStatus: null,
      // ตัวเลือก filter "อายุ Export Excel" — สี/สัญลักษณ์อยู่ในตัวเลือกเท่านั้น
      // ไม่นำไปใช้กับข้อความในแถว (spec ระบุชัดว่าแถวใช้สีเทาเหมือนกันทุกสถานะ)
      excelExpiryStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        minimumResultsForSearch: -1,
        data: [{ id: "ACTIVE", text: "🟢 ยังใช้ได้ปกติ" }, { id: "NEAR_EXPIRY", text: "🟠 ใกล้หมดอายุ (ภายใน 30 วัน)" }, { id: "EXPIRED", text: "🔴 หมดอายุแล้ว (ลบข้อมูล)" }]
      },
      // FS-004 — ตัวเลือก filter "สถานะแนบไฟล์เอกสาร" (ข้อความคำต่อคำตาม CR-Features.md F02)
      // ไม่ใส่ตัวเลือก "ทั้งหมด" ในรายการ เพราะใช้ placeholder + allowClear แทน
      // (แพตเทิร์นเดียวกับ excelExpiryStatusOptions ด้านบน — ล้างค่าแล้ว server ถือว่าไม่กรอง)
      attachmentStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        minimumResultsForSearch: -1,
        data: [{ id: "HAS_FILE", text: "มีเอกสารแนบ" }, { id: "NO_FILE", text: "ไม่มีเอกสารแนบ" }]
      },
      // Agent Select2 — scoped ajax ฝั่ง server (ตัวแทนที่ user มีสิทธิ์เห็นเท่านั้น)
      // mirror pattern: StockCoverDaysList.vue plantOptions → /Api/StockCoverDayTarget/Select2Plant
      agentOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        ajax: {
          url: "/Api/FormSummaryStock/Select2Agent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      // "ล้างข้อมูล" = ล้างเฉพาะเงื่อนไขค้นหา ไม่ได้ลบข้อมูลจริง
      // FS-014 — ช่องเลขที่เอกสารต้องล้างตรงนี้เท่านั้น พึ่งปุ่ม type="reset" ไม่ได้
      //   formSubmit() ที่ถูกเรียกท้ายเมธอดนี้สั่ง e.preventDefault() ซึ่งยกเลิก default action
      //   ของปุ่ม reset ไปด้วย DOM จึงไม่ถูกล้างเอง (และต่อให้ล้างได้ การ reset ก็ไม่ยิง event
      //   "input" จึงไม่อัปเดต v-model อยู่ดี) ถ้าไม่ล้างตรงนี้ คำค้นเก่าจะยังติดไปกับ payload
      //   ทำให้กด "ล้างข้อมูล" แล้วผลลัพธ์ยังว่างอยู่ทั้งที่ filter อื่นถูกล้างหมดแล้ว
      this.searchDocumentNo = "";
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.searchAgentCode = null;
      this.searchExcelExpiryStatus = null;
      this.searchAttachmentStatus = null;

      // $refs safety — element อยู่ใน v-show (ไม่ใช่ v-if) จึงมีเสมอ แต่กันไว้เผื่อ reset ถูกเรียกก่อน mount เสร็จ
      if (this.$refs.fssList_dateFrom) {
        $(this.$refs.fssList_dateFrom).datepicker("update", null);
      }
      if (this.$refs.fssList_dateTo) {
        $(this.$refs.fssList_dateTo).datepicker("update", null);
      }
      $("#fssList_agentCode").val("").trigger("change");
      // select2 แบบ data ในตัว ใช้ .val(null) ตาม pattern ของ BudgetPlanJobList.vue:393
      // (ต่างจาก agent select2 ด้านบนที่เป็น ajax จึงใช้ .val(""))
      $("#fssList_excelExpiryStatus").val(null).trigger("change");
      $("#fssList_attachmentStatus").val(null).trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      if (e) e.preventDefault();

      // ตรวจช่วงวันที่ให้ผู้ใช้เห็นทันที (ข้อความไทย) แทนการยิงค้นหาที่ได้ผลลัพธ์ว่างเปล่า
      if (this.searchDateFrom && this.searchDateTo && this.searchDateFrom.isAfter(this.searchDateTo, "day")) {
        Swal.fire("ข้อมูลไม่ถูกต้อง", "กรุณาระบุวันที่บันทึก (จาก) ไม่เกินวันที่บันทึก (ถึง)", "warning");
        return;
      }

      // FS-014 — เอา `table.search();` (ไม่ส่งอาร์กิวเมนต์) ออก เพราะเป็น dead code:
      //   .search() แบบไม่มีพารามิเตอร์ของ DataTables เป็น "getter" คืนคำค้นปัจจุบัน ไม่ได้ตั้งค่าใด ๆ
      //   และหน้านี้ไม่มีกล่องค้นหาของ DataTables อยู่แล้ว (dom ด้านล่างไม่มีตัว `f`)
      //   คำค้นเลขที่เอกสารส่งผ่าน payload ของเราเอง (DocumentNo) ใน ajax.data ไม่ใช่ผ่าน global search
      //   -> เหลือแค่ draw() พอ · draw() แบบไม่ใส่อาร์กิวเมนต์ = reset paging กลับหน้า 1 ให้ด้วย
      //      ซึ่งเป็นพฤติกรรมที่ต้องการเมื่อเปลี่ยนเงื่อนไขค้นหา
      var table = $("#formSummaryStockTable").DataTable();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#formSummaryStockTable").DataTable().ajax.reload(null, resetPaging);
    },
    goToCreate: function goToCreate() {
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ path: "/PrintSummary/Barcodes/New" });
    }
  },
  // FS-125 (19/10/2026) — กลับมาหน้ารายการจากหน้าลูก (รายละเอียด / สร้างเอกสาร) ด้วย router
  //   หน้ารายการไม่ถูก mount ใหม่ (หน้าลูกเป็น child route · portlet ถูกซ่อนด้วย v-show) จึงต้อง:
  //   1. reload ข้อมูลแถว — จำนวนไฟล์แนบ (สีปุ่มแนบ) ที่เปลี่ยนในหน้ารายละเอียดจะได้ตรง · คงหน้า/เงื่อนไขค้นหาเดิม
  //   2. คำนวณความกว้างคอลัมน์ใหม่ — ถ้าตารางถูกสร้างตอนซ่อนอยู่ (เปิดหน้ารายละเอียดตรงจากลิงก์ก่อน)
  //      DataTables ตั้งความกว้าง th เป็น 0px คอลัมน์ "คำสั่ง" จึงขยายกินที่เหลือ (~584px แทน 230px)
  watch: {
    $route: function $route(to, from) {
      if (to.path !== "/PrintSummary/Barcodes" || !from || from.path === to.path) return;

      this.$nextTick(function () {
        var $table = $("#formSummaryStockTable");
        if (!$.fn.DataTable.isDataTable($table)) return;

        var table = $table.DataTable();
        table.columns.adjust();
        if (table.responsive) table.responsive.recalc();
        table.ajax.reload(null, false);
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, datepickerOptions, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              _context.next = 3;
              return _this.$nextTick();

            case 3:

              // ── Datepicker ช่วงวันที่บันทึก ─────────────────────────────────────────
              // mirror pattern: SBP.Web/App/Components/Job/JobList.vue:1359-1401 (bootstrap-datepicker global)
              // ไม่กำหนด minDate/maxDate เพราะเป็นการค้นหาเอกสารย้อนหลัง
              datepickerOptions = {
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true
              };


              if (self.$refs.fssList_dateFrom) {
                $(self.$refs.fssList_dateFrom).datepicker(datepickerOptions).on("changeDate", function (e) {
                  self.searchDateFrom = e.dates.length != 0 ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(e.date) : null;
                });
              }

              if (self.$refs.fssList_dateTo) {
                $(self.$refs.fssList_dateTo).datepicker(datepickerOptions).on("changeDate", function (e) {
                  self.searchDateTo = e.dates.length != 0 ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(e.date) : null;
                });
              }

              // ── Datatable (server-side) ────────────────────────────────────────────
              $.fn.dataTable.ext.errMode = "none";
              table = $("#formSummaryStockTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                // FS-014 — เอา `searchDelay: 500` ออกพร้อมกับ table.search() ที่เป็น dead code
                //   หน้านี้ไม่ได้เปิดกล่องค้นหาของ DataTables (dom ด้านล่างไม่มีตัว `f`)
                //   ตั้ง searchDelay ไว้จึงไม่มีผลอะไร และทำให้คนอ่านทีหลังเข้าใจผิดว่ามี global search อยู่
                //   การค้นหาเลขที่เอกสารใช้ช่อง fssList_documentNo + payload DocumentNo แทน
                // server บังคับเรียงใบใหม่สุดขึ้นก่อนเสมอ (SnapshotDate DESC, Id DESC) → ปิด sort ฝั่ง client
                ordering: false,
                ajax: {
                  url: "/Api/FormSummaryStock/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      // FS-014 — คำค้นเลขที่เอกสาร · trim ก่อนส่ง (ผู้ใช้ copy จาก Excel/PDF มักติดช่องว่าง
                      //   หรือขึ้นบรรทัดใหม่มาด้วย) · ว่าง = null เพื่อให้ server ถือว่าไม่กรอง
                      //   server กรองด้วย Contains ก่อน CountAsync จึงได้ยอดรวม/จำนวนหน้าถูกต้อง
                      DocumentNo: self.searchDocumentNo ? self.searchDocumentNo.trim() : null,
                      DateFrom: self.searchDateFrom ? self.searchDateFrom.format(DATE_FORMAT) : null,
                      DateTo: self.searchDateTo ? self.searchDateTo.format(DATE_FORMAT) : null,
                      AgentCode: self.searchAgentCode,
                      // F09 — null/"" = ทั้งหมด (server ถือว่าไม่กรอง)
                      ExcelExpiryStatus: self.searchExcelExpiryStatus,
                      // FS-004 — null/"" = ทั้งหมด (server กรองด้วย EXISTS ก่อนนับ/แบ่งหน้า)
                      AttachmentStatus: self.searchAttachmentStatus
                    }));
                  }
                },
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [50, 100, 200, 500],
                pageLength: 100,
                // QA 08/10/2026 เรื่องที่ 4 — ข้อความของตารางต้องเป็นภาษาไทยทั้งหมด
                //   ของเดิมปล่อยให้ DataTables ใช้ค่าเริ่มต้นภาษาอังกฤษ
                //   ผู้ใช้ค้นหาไม่เจอแล้วเห็น "No data available in table"
                // เรื่องที่ 7 — ระหว่างรอผลให้ขึ้น "กำลังค้นหา..." แทน "Processing..."
                language: {
                  lengthMenu: "แสดง _MENU_ แถว",
                  emptyTable: "ไม่พบข้อมูลที่ค้นหา",
                  zeroRecords: "ไม่พบข้อมูลที่ค้นหา",
                  info: "แสดง _START_ ถึง _END_ จากทั้งหมด _TOTAL_ รายการ",
                  infoEmpty: "ไม่มีรายการที่ตรงกับเงื่อนไข",
                  infoFiltered: "(กรองจากทั้งหมด _MAX_ รายการ)",
                  processing: "กำลังค้นหา...",
                  loadingRecords: "กำลังโหลดข้อมูล...",
                  paginate: {
                    first: "หน้าแรก",
                    last: "หน้าสุดท้าย",
                    next: "ถัดไป",
                    previous: "ก่อนหน้า"
                  }
                },
                columns: [{
                  data: "documentNo",
                  className: "text-center",
                  width: "12%",
                  render: function render(data, type, full, meta) {
                    return data ? data : "-";
                  }
                }, {
                  data: "snapshotDate",
                  className: "text-center",
                  width: "13%",
                  render: function render(data, type, full, meta) {
                    return data ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(data).format("DD/MM/YYYY HH:mm") : "-";
                  }
                }, {
                  data: "agentName",
                  className: "text-left",
                  width: "38%",
                  // FS-062 — mockup หน้ารายการเขียนรูปแบบ "[รหัส] ชื่อ"
                  //   เช่น [1000297] บริษัท สมุย เบียร์ จำกัด
                  //   ของเดิมแสดงแต่ชื่อ ไม่มีรหัสนำหน้า
                  //   รูปแบบเดียวกับหน้าสรุปผลขั้นที่ 6 ที่แก้ไปแล้วตอน FS-053 ข้อ 1
                  render: function render(data, type, full, meta) {
                    var code = full.agentCode || full.headAgentCode;

                    // ครบทั้งคู่ = รูปแบบเต็มตาม mockup
                    if (code && data) return "[" + code + "] " + data;

                    // มีรหัสแต่ snapshot ชื่อว่าง — แสดงรหัสอย่างเดียว
                    //   ห้ามต่อ "-" ท้ายวงเล็บ จะกลายเป็น "[1000836] -" ซึ่งอ่านแล้วสับสน
                    if (code) return "[" + code + "]";

                    // ไม่มีรหัส (ข้อมูลเก่าที่ไม่ได้ stamp ไว้) — เหลือแค่ชื่อ ไม่ใส่วงเล็บว่าง
                    if (data) return data;

                    return "-";
                  }
                }, {
                  data: "createdByName",
                  className: "text-center",
                  width: "37%",
                  render: function render(data, type, full, meta) {
                    return data ? data : "-";
                  }
                }, {
                  data: "id",
                  className: "text-center",
                  width: "230px",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                // FS-077 — เริ่มจับเวลาขั้นต่ำ 1 วินาที (ยิง ajax 1 ครั้ง = 1 รอบ)
                self.searchRound += 1;
                self.searchStartedAt = Date.now();
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("xhr.dt", function () {
                // FS-077 — overlay ต้องค้างอย่างน้อย 1 วินาที (ของเดิมตอบเร็วจนขึ้นแว้บเดียวแล้วหาย)
                //   ตอบเร็วกว่า 1 วินาที → รอจนครบค่อย unblock · ช้ากว่านั้น → unblock ทันที
                //   round กันกรณีโหลดซ้อน (เปลี่ยนหน้าระหว่างรอ) ไม่ให้ timer รอบเก่ามาปลด overlay ของรอบใหม่
                var round = self.searchRound;
                var remain = SEARCH_MIN_LOADING_MS - (Date.now() - self.searchStartedAt);
                if (remain <= 0) {
                  KTApp.unblock(self.$refs.searchForm);
                  return;
                }
                setTimeout(function () {
                  if (round === self.searchRound) KTApp.unblock(self.$refs.searchForm);
                }, remain);
              }).on("draw.dt", function () {
                // scope selector ไว้ในตารางนี้เท่านั้น — หน้าลูก (<router-view/>) อยู่ใน DOM พร้อมกัน
                // จึงห้ามใช้ $(".actions") แบบ global เพราะอาจ mount ทับ action ของหน้าลูก
                $("#formSummaryStockTable .actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new FormSummaryStockActions({
                      data: { data: data },
                      parent: self,
                      propsData: { canEdit: self.canEdit }
                    }).$mount(el);
                  }
                });
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form_summary_stock_actions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormSummaryStockSignatureModal__ = __webpack_require__(137);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Action Button Design System + Stepper ของโมดูลนี้ (QA เรื่องที่ 11 + 16)

// FS-088 — tooltip ของปุ่มวงกลมเป็นแบบ Bootstrap (ผูกครั้งเดียวทั้งโมดูล เรียกซ้ำได้)

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__form_summary_stock_tooltips__["a" /* installFssTooltips */])();



__webpack_require__(9);

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F04 — ขั้นที่ 2 "ตรวจสอบข้อมูล" (/PrintSummary/Barcodes/New/Preview)
//
// หน้านี้ยังไม่บันทึกอะไรลงฐานข้อมูล — แสดงผลลัพธ์ที่ FormSummaryStockCreate.vue
// ยิง /Api/FormSummaryStock/Process มาแล้ว เพื่อให้ผู้ใช้ตรวจก่อนกด "บันทึกข้อมูล"
//
// การรับ state จากขั้นที่ 1: อ่านจาก $parent (= FormSummaryStockCreate.vue ซึ่งเป็น route แม่)
//   ต้นแบบใน repo: SBP.Web/App/Components/BeerClaim/AddBeerClaimItem.vue:1113-1115
//                  (route ลูกอ่าน self.$parent.<dataProp> โดย route ส่งแค่ scalar)
//   repo นี้ไม่มี Vuex / store module / การส่ง object ผ่าน route params — $parent คือ pattern เดียวที่มี
//
// เข้าหน้านี้ตรง ๆ (refresh / กด URL) จะไม่มี $parent.processResult → เด้งกลับขั้นที่ 1
//
// SweetAlert2 = ^8.2.3 (SBP.Web/package.json) → ใช้ option ชื่อ `type` (ไม่ใช่ `icon` ของ v9+)
// และอ่านผลจาก `result.value`
// ─────────────────────────────────────────────────────────────────────────────

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormSummaryStockSignatureModal: __WEBPACK_IMPORTED_MODULE_4__FormSummaryStockSignatureModal__["a" /* default */] },
  data: function data() {
    return {
      // F04 (D10) — บรรทัด "*สำนักงานใหญ่ + สาขา [ ... ]" ค่าว่าง = ไม่ต้องแสดง
      branchLine: "",

      // F15 — ภาพลายเซ็นเฉพาะกิจที่เลือกไว้ก่อนกดบันทึก
      //   เอกสารยังไม่มี Id ตอนนี้ จึงผูกกับ header ไม่ได้ — ถือ AttachedId ไว้ที่หน้านี้
      //   แล้วแนบไปกับคำสั่งบันทึก (null = ใช้ค่าเริ่มต้นของระบบ)
      signatureAttachedId: null,
      // FS-017 — ระบบมีลายเซ็นค่าเริ่มต้นอยู่หรือไม่ (ใช้ตัดสินสีปุ่มตอนยังไม่เลือกภาพเอง)
      hasDefaultSignature: false,
      // FS-017 — url ของภาพที่จะถูกใช้จริง สำหรับ thumbnail ข้างปุ่ม (signed URL อายุสั้น)
      signatureImageUrl: "",
      // FS-018 — สิทธิ์จัดการลายเซ็น (canManage จาก /Api/FormSummaryStock/Signature)
      //   ค่าเริ่มต้นต้องเป็น false เสมอ — ซ่อนปุ่มไว้ก่อนจนกว่า API จะยืนยันว่ามีสิทธิ์
      canManageSignature: false
    };
  },
  computed: {
    // FS-012 — สถานะปุ่มลายเซ็น
    //   ขั้นนี้ยังไม่บันทึกเอกสาร "แนบแล้ว" จึงหมายถึงผู้ใช้เลือกภาพเฉพาะกิจไว้แล้ว
    //   (null = เอกสารฉบับนี้จะใช้ลายเซ็นค่าเริ่มต้นของระบบ)
    // FS-017 — "มีลายเซ็น" = เอกสารนี้จะพิมพ์ออกมาพร้อมภาพแน่นอน
    //   ไม่ได้เลือกภาพเฉพาะกิจก็ยังได้ลายเซ็นค่าเริ่มต้นของระบบ ซึ่ง spec (CR-Features.md:320)
    //   ระบุว่า "ระบบต้องมีภาพเสมอ" → สถานะเริ่มต้นจึงต้องเป็นเขียว ไม่ใช่โทนจาง
    //   (ของเดิมดูแค่ signatureAttachedId จึงจางตลอดจนกว่าจะเลือกเอง = ไม่ตรง design)
    hasSignature: function hasSignature() {
      return !!this.signatureAttachedId || this.hasDefaultSignature;
    },
    signatureButtonText: function signatureButtonText() {
      return this.hasSignature ? "ลายเซ็นผู้จัดทำ (คลิกเพื่อเปลี่ยน)" : "ลายเซ็นผู้จัดทำ";
    },

    // ผลลัพธ์จาก /Api/FormSummaryStock/Process ที่ขั้นที่ 1 เก็บไว้
    processResult: function processResult() {
      return this.$parent && this.$parent.processResult ? this.$parent.processResult : null;
    },
    // ข้อความสรุป filter ภาษาไทยจาก API (ถ้าไม่มีจะ fallback ไปใช้ filterLabels ที่ประกอบฝั่ง client)
    filterText: function filterText() {
      return this.processResult && this.processResult.filterText ? this.processResult.filterText : "";
    },
    filterLabels: function filterLabels() {
      return this.$parent && this.$parent.filterLabels ? this.$parent.filterLabels : [];
    },
    details: function details() {
      return this.processResult && this.processResult.details ? this.processResult.details : [];
    },
    totalQty: function totalQty() {
      return this.processResult ? this.processResult.totalQty : 0;
    },
    totalAmount: function totalAmount() {
      return this.processResult ? this.processResult.totalAmount : 0;
    },
    totalAmountText: function totalAmountText() {
      return this.processResult ? this.processResult.totalAmountText : "";
    },
    // ไม่มีรายการให้บันทึก — ครอบทั้งกรณี status "ไม่ใช่สำนักงานใหญ่" และกรณีไม่มีบาร์โค้ดคงค้าง
    isNoData: function isNoData() {
      return this.details.length === 0;
    },

    // FS-108 — รหัสที่เลือก : ตัวแทนจำหน่าย = agentCode · Group = headAgentCode (filter ของขั้นที่ 1)
    selectedCode: function selectedCode() {
      var filter = this.$parent ? this.$parent.filter : null;
      if (!filter) return "";
      return filter.filterType === "GROUP" ? filter.headAgentCode || "" : filter.agentCode || "";
    },
    selectedName: function selectedName() {
      return this.processResult && this.processResult.agentName ? this.processResult.agentName : "";
    },
    // "[รหัส] ชื่อ" แบบเดียวกับโหมดหลายตัวแทน (FS-082)
    agentLabel: function agentLabel() {
      var code = this.selectedCode;
      var name = this.selectedName;
      if (!code) return name;
      return name ? "[" + code + "] " + name : "[" + code + "]";
    },
    // FS-106 ข้อ 2 / FS-107 — หัวรายละเอียดแสดงชื่ออย่างเดียว ไม่มี [รหัส]
    agentNameOnly: function agentNameOnly() {
      return this.selectedName || this.selectedCode;
    },
    noDataMessage: function noDataMessage() {
      if (this.processResult && this.processResult.message) {
        return this.processResult.message;
      }
      return "ไม่พบรายการสินค้าคงค้างตามเงื่อนไขที่เลือก กรุณาแก้ไข Filter แล้วประมวลผลใหม่อีกครั้ง";
    }
  },
  methods: {
    formatQty: function formatQty(value) {
      if (value == null || value === "") return "-";
      return Number(value).toLocaleString("en-US");
    },
    formatAmount: function formatAmount(value) {
      if (value == null || value === "") return "-";
      return Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    goBackToFilter: function goBackToFilter() {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: "/PrintSummary/Barcodes/New" });
    },

    // ── F04 (D10) : บรรทัดสาขาย่อย ────────────────────────────────────────
    //
    //   เอกสารยังไม่ถูกบันทึกในขั้นนี้ จึงส่ง filter ไปแทน headerId
    //   endpoint เดียวกับที่ฟอร์ม PDF ใช้ — ตัวเลขบนจอกับบนกระดาษจะได้ไม่เพี้ยนกัน
    //
    //   โหลดไม่สำเร็จก็ปล่อยให้บรรทัดนี้ว่างไว้ ไม่ต้องขึ้น error
    //   (เป็นข้อมูลประกอบ ไม่ใช่ตัวเลขที่ผู้ใช้ต้องตรวจ)
    loadBranchLine: function loadBranchLine() {
      var self = this;
      var filter = self.$parent ? self.$parent.filter : null;

      if (!filter) return;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/CustomerBox", {
        headerId: 0,
        filterType: filter.filterType,
        agentCode: filter.agentCode,
        headAgentCode: filter.headAgentCode
      }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var data = response && response.data || {};
        self.branchLine = data.success && data.hasBranchLine ? data.branchLine : "";
      }).catch(function () {
        self.branchLine = "";
      });
    },

    // ── F15 : ลายเซ็นผู้จัดทำ ─────────────────────────────────────────────
    openSignature: function openSignature() {
      // ยังไม่มีเลขที่เอกสารในขั้นนี้ — ส่ง id = 0 ให้ popup รู้ว่าเป็นโหมดก่อนบันทึก
      // FS-070 — ส่งภาพที่หน้านี้ถืออยู่ไปด้วย ไม่งั้นเปิดครั้งที่ 2 popup จะลืมภาพที่เพิ่งบันทึก
      //   (โหมดก่อนบันทึก server ยังไม่มีเอกสารให้ผูกภาพ — หน้านี้คือที่เดียวที่รู้)
      this.$refs.signatureModal.open({
        id: 0,
        documentNo: "",
        attachedId: this.signatureAttachedId
      });
    },

    onSignatureSelected: function onSignatureSelected(attachedId, imageUrl) {
      this.signatureAttachedId = attachedId || null;
      // FS-017 — ล้างภาพเฉพาะกิจแล้ว popup จะส่ง url ของค่าเริ่มต้นกลับมาแทน
      if (typeof imageUrl === "string") this.signatureImageUrl = imageUrl;
    },

    // FS-017 — อ่านลายเซ็นค่าเริ่มต้นของระบบตั้งแต่เปิดหน้า เพื่อให้ปุ่ม + thumbnail ถูกต้อง
    //   ใช้ endpoint เดียวกับ popup (headerId = 0 คือโหมดก่อนบันทึก) เป็น best-effort
    //   ล้มเหลวก็แค่ปุ่มกลับไปเป็นโทนจาง ไม่ต้องรบกวนผู้ใช้
    loadDefaultSignature: function loadDefaultSignature() {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Signature", { headerId: 0 }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var data = response && response.data || {};

        // FS-018 — handler เซ็ต CanManage ไว้ตั้งแต่บรรทัดแรกของ Handle() จึงเชื่อถือได้
        //   แม้ success = false — อ่านก่อนด่าน success กันกรณี storage ล่มแล้วกลุ่ม A เสียปุ่มไปด้วย
        self.canManageSignature = !!data.canManage;

        if (!data.success) return;

        self.hasDefaultSignature = !data.isMissingDefault && !!data.defaultAttachedId;
        if (!self.signatureAttachedId) {
          self.signatureImageUrl = data.documentImageUrl || data.defaultImageUrl || "";
        }
      }).catch(function () {
        self.hasDefaultSignature = false;
        // FS-018 — เรียกไม่สำเร็จ = ไม่รู้สิทธิ์ ให้ถือว่าไม่มีสิทธิ์ (ซ่อนปุ่มไว้ก่อน)
        self.canManageSignature = false;
      });
    },

    // แนบลายเซ็นเป็น query string — ไม่ปนกับ filter ที่ถูก serialize เก็บเป็น FilterJson
    buildSaveUrl: function buildSaveUrl() {
      var base = "/Api/FormSummaryStock/Save";
      return this.signatureAttachedId ? base + "?signatureAttachedId=" + encodeURIComponent(this.signatureAttachedId) : base;
    },
    saveDocument: function saveDocument() {
      var self = this;

      // filter object ชุดเดียวกับที่ใช้ประมวลผล — บันทึกแล้ว snapshot ต้องตรงกับที่ผู้ใช้เพิ่งตรวจ
      var filter = self.$parent ? self.$parent.filter : null;
      if (!filter) {
        Swal.fire("ไม่พบข้อมูล", "ไม่พบเงื่อนไขที่ใช้ประมวลผล กรุณากลับไปเลือก Filter แล้วประมวลผลใหม่อีกครั้ง", "warning");
        return;
      }

      Swal.fire({
        title: "ยืนยันการบันทึกข้อมูล",
        type: "warning",
        html: "ต้องการบันทึกเอกสารสรุปสินค้าคงค้างใช่หรือไม่?<br/>" + "<small class='text-muted'>ระบบจะล็อค snapshot ของข้อมูล และออกเลขที่เอกสารให้อัตโนมัติ</small>",
        showCancelButton: true,
        confirmButtonText: "ยืนยันบันทึก",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
          });

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(self.buildSaveUrl(), filter, {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token
            }
          }).then(function (response) {
            if (response.data.success) {
              // รีเฟรชรายการใบงานที่หน้าค้นหา (route ปู่ = FormSummaryStockList.vue)
              // ต้นแบบเรียกข้ามสองชั้น: BeerClaim/AnalyzeSpecifyForm.vue:176
              if (self.$parent && self.$parent.$parent && typeof self.$parent.$parent.reloadDataTable === "function") {
                self.$parent.$parent.reloadDataTable();
              }

              Swal.fire("สำเร็จ", response.data.message || "บันทึกข้อมูลสำเร็จ", "success");

              // ไปขั้นที่ 3 = ใบงานที่บันทึกแล้ว
              __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
                path: "/PrintSummary/Barcodes/" + response.data.documentNo
              });
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message || "ไม่สามารถบันทึกข้อมูลได้", "error");
            }
          }).catch(function (error) {
            var errorMsg = error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด";
            Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
          }).then(function () {
            KTApp.unblockPage();
          });
        }
      });
    }
  },
  mounted: function mounted() {
    this.loadBranchLine();
    this.loadDefaultSignature();
    // เข้าหน้านี้ตรง ๆ โดยไม่ผ่านขั้นที่ 1 (refresh / paste URL) → ไม่มีผลประมวลผลให้แสดง
    if (!this.processResult) {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({ path: "/PrintSummary/Barcodes/New" });
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(9);

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F14 (K1) — Popup แสดงความคืบหน้าของงานที่ใช้เวลานาน
//
// spec ระบุว่าใช้กับ 5 งาน: ประมวลผล (2→3/3B) / บันทึกข้อมูล (3B→6) /
// Export Excel ตรวจ / ZIP Excel / ZIP PDF
// component นี้จึงไม่ผูกกับงานใดงานหนึ่ง — ผู้เรียกส่ง "endpoint" เข้ามา
//   start(payload)  -> คืน { batchId }
//   progress(id)    -> คืนสถานะ
//   cancel(id)      -> สั่งหยุด
//   download(id)    -> เฉพาะงานที่ผลิตไฟล์
//   resume          -> ปุ่มบน Popup Error ของงานหลายตัวแทน (FS-031 / FS-105)
//                      ส่ง { batchId, skipFailed } — false = ประมวลผลใหม่จากรายที่ติดขัด · true = ข้าม
//
// FS-033 (26/09/2026) — ต่อครบทั้ง 5 กรณีแล้ว:
//   FormSummaryStockCreate.vue      : ประมวลผล (ProcessStart / GroupProcessStart)
//   FormSummaryStockGroupPreview.vue: บันทึกข้อมูล (GroupSaveStart) · Export Excel ตรวจ
//   FormSummaryStockGroupResult.vue : ZIP Excel · ZIP PDF
//
// FS-031 (26/09/2026) — ติดขัดกลางทางแล้ว popup เปลี่ยนเป็น "Popup Error (พื้นส้ม)"
//   พร้อมสถิติ · รายที่ติดขัด · ปุ่มดูรายละเอียด (สาเหตุ+เวลา+เลขอ้างอิง) ·
//   และ 2 ทางเลือกตาม spec §M (ประมวลผลต่อจากรายที่ติดขัด / ลบเอกสารที่สร้างแล้ว)
//
// FS-105 (15/10/2026) — ผู้ใช้สั่งปรับ (งานหลายตัวแทนทั้ง "ประมวลผล" และ "บันทึกข้อมูล"):
//   • งานหยุดรอที่รายที่ติดขัดทันที (สถานะ Paused) ไม่ใช่ทำต่อจนครบแล้วค่อยถาม
//   • ทางเลือกที่ 2 เปลี่ยนเป็น "ข้ามการประมวลผลตัวแทนจำหน่ายที่ติดขัด" แล้วทำรายถัดไป
//     (ไม่ลบอะไร — ผู้ใช้ไปสร้างเอกสารของรายที่ติดขัดเองภายหลัง)
//   • ติดขัดอีกรายในรอบต่อไป popup ก็ขึ้นถามอีกครั้ง
//
// ── ทำไมเป็น polling ────────────────────────────────────────────────────────
//   โปรเจกต์นี้ไม่มี SignalR/WebSocket (ตรวจแล้ว) การเพิ่มเข้ามาเพื่อ CR เดียว
//   กระทบ infra ทั้งระบบ — polling คือทางที่ตรงกับของเดิมที่สุด
//
// ── สิ่งที่ปุ่มยกเลิกทำจริง (FS-028) ────────────────────────────────────────
//   กดยกเลิกแล้วระบบ "หยุดไม่สร้างใบต่อไป" + "ลบเอกสารที่สร้างไปแล้วทั้งชุดทิ้ง"
//   (งาน H3 ทำเสร็จแล้ว — RollbackBatchAsync soft delete หัวเอกสารทุกใบของ BatchId นั้น)
//   เป็นการลบที่ผู้ใช้กู้คืนเองไม่ได้ ข้อความยืนยันจึงต้องบอกตรง ๆ ก่อนกด
//
// SweetAlert2 = ^8.2.3 → ใช้ option ชื่อ `type` และอ่านผลจาก `result.value`
// ─────────────────────────────────────────────────────────────────────────────

// ถี่เกินไปจะยิง API รัว ห่างเกินไปแถบจะกระตุก — 1.5 วินาทีพอดีกับงานที่ใช้เวลาหลายนาที
var POLL_INTERVAL_MS = 1500;

// จำนวนครั้งที่ยอมให้ poll ไม่สำเร็จติดกันก่อนยอมแพ้ (เน็ตสะดุดชั่วคราวไม่ควรล้มทั้งงาน)
var MAX_CONSECUTIVE_ERRORS = 5;

// FS-082 — ตัวแทนแสดงเป็น "[รหัส] ชื่อ" แบบเดียวกับหน้าอื่นในโมดูล (หน้ารายการ · ขั้นที่ 6 · Filter ที่เลือก)
//   ใช้ร่วมกันทั้งบรรทัด "กำลังทำ:" · รายการที่เสร็จแล้ว · popup error ให้ทั้ง popup เป็นรูปแบบเดียว
//   (ต่างจากตัวอย่างในรายงาน QA เรื่องที่ 10 ที่ไม่มีวงเล็บ — ผู้ใช้สั่ง 14/10/2026)
function agentLabel(code, name) {
  if (!code) return name || "";
  return name ? "[" + code + "] " + name : "[" + code + "]";
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: "กำลังดำเนินการ",
      batchId: null,

      agentCount: 0,
      processedCount: 0,
      createdCount: 0,
      skippedCount: 0,
      failedCount: 0,
      percent: 0,

      currentAgentCode: "",
      currentAgentName: "",

      state: "Running",
      finishedMessage: "",
      items: [],

      cancelRequested: false,
      consecutiveErrors: 0,
      timer: null,

      // F13 (J2) — งานที่ผลิตไฟล์ (เช่น ZIP) จะตั้ง 2 ค่านี้เมื่อจบ
      hasResultFile: false,
      resultFileName: "",
      downloading: false,

      // ── FS-033 : ชนิดของงาน ───────────────────────────────────────────────
      //   "document" = สร้างเอกสารรวม (ยกเลิกแล้วลบเอกสาร · มีปุ่มประมวลผลใหม่/ข้าม เมื่อติดขัด)
      //   "file"     = ผลิตไฟล์ให้ดาวน์โหลด (ZIP / Excel ตรวจ) — ยกเลิกแล้วทิ้งแค่ไฟล์
      //   "process"  = ประมวลผลเพื่อแสดงผลบนหน้าจอ — ยังไม่บันทึกอะไรลงระบบเลย
      //   ผู้เรียกส่งมาทาง start() · ถ้าไม่ส่งจะเดาจาก endpoint (ดู computed jobKindResolved)
      jobKind: "",

      // FS-033 — หน่วงการเปิด popup กี่มิลลิวินาที (0 = เปิดทันที)
      //   ใช้กับงานที่ "อาจจะ" สั้นมาก เช่นประมวลผลตัวแทนรายเดียวที่มีบาร์โค้ดไม่กี่ร้อยแถว
      //   งานที่จบก่อนครบเวลานี้จะไม่เห็น popup แวบขึ้นมาเลย
      deferMs: 0,
      deferTimer: null,
      isShown: false,

      // FS-110 — งานจบครบแล้วปิด popup เองหลังค้างไว้กี่ ms (0 = ไม่ปิดเอง รอผู้ใช้กด "ปิด")
      //   ผู้เรียกส่งมาทาง start() · ตอนนี้ใช้แค่งานสร้างเอกสารรวม (spec: "สำเร็จครบ → ปิด popup อัตโนมัติ")
      autoCloseMs: 0,
      autoCloseTimer: null,

      // FS-126 — ตัวนับเวลา : เวลาที่สะสมแล้ว (ms) + จุดเริ่มของช่วงที่กำลังเดิน (null = หยุดอยู่)
      showTimer: false,
      timerElapsedMs: 0,
      timerRunningSince: null,
      timerNow: 0,
      timerTick: null,

      // FS-031 / FS-105 — สถานะของ 2 ปุ่มบน popup error
      resuming: false,
      skipping: false,

      // endpoint ที่ผู้เรียกกำหนด — ดูหมายเหตุที่หัวไฟล์
      endpoints: {
        start: "/Api/FormSummaryStock/GroupSaveStart",
        progress: "/Api/FormSummaryStock/GroupProgress",
        cancel: "/Api/FormSummaryStock/GroupCancel",

        // F13 (J2) — ใช้เฉพาะงานที่ผลิตไฟล์ · {jobId} จะถูกแทนด้วย batchId ของงานนั้น
        download: "/Api/FormSummaryStock/GroupZipDownload?jobId={jobId}",

        // FS-031 / FS-105 — 2 ทางเลือกบน popup error (ประมวลผลใหม่ / ข้าม) ใช้ endpoint เดียวกัน
        //   งาน "ประมวลผล" หลายตัวแทนส่ง /GroupProcessResume มาทับ (FormSummaryStockCreate.vue)
        resume: "/Api/FormSummaryStock/GroupSaveResume"
      }
    };
  },
  computed: {
    isRunning: function isRunning() {
      return this.state === "Running";
    },

    // FS-126 — HH:MM:SS ของเวลาที่งานวิ่งจริง (ไม่นับช่วงหยุดรอผู้ใช้)
    elapsedText: function elapsedText() {
      var ms = this.timerElapsedMs;
      if (this.timerRunningSince !== null) ms += Math.max(0, this.timerNow - this.timerRunningSince);

      var total = Math.floor(ms / 1000);
      var pad = function pad(n) {
        return n < 10 ? "0" + n : String(n);
      };
      return pad(Math.floor(total / 3600)) + ":" + pad(Math.floor(total % 3600 / 60)) + ":" + pad(total % 60);
    },

    // ── FS-033 : ชนิดของงาน ─────────────────────────────────────────────────
    //
    //   ผู้เรียกควรส่ง jobKind มาทาง start() แต่ต้องเดาจาก endpoint ได้ด้วย
    //   เพราะมีเทสที่เรียก requestCancel() ตรง ๆ โดยตั้งแค่ endpoints.start
    //   (formsummarystock-groupresult.spec.js GR-8 / GR-9)
    jobKindResolved: function jobKindResolved() {
      if (this.jobKind) return this.jobKind;

      var start = this.endpoints.start || "";

      // งานสร้างเอกสารรวมเท่านั้นที่ยกเลิกแล้วลบเอกสารทิ้ง (H3 / RollbackBatchAsync)
      if (start.indexOf("GroupSaveStart") !== -1) return "document";
      if (start.indexOf("ProcessStart") !== -1) return "process";

      return "file";
    },
    isDocumentJob: function isDocumentJob() {
      return this.jobKindResolved === "document";
    },

    // ── FS-031 : โหมดข้อผิดพลาด ─────────────────────────────────────────────
    //
    //   spec §M : "ถ้าระบบติดขัดที่ตัวแทนจำหน่ายรายใดรายหนึ่ง — Popup Progress
    //   จะเปลี่ยนเป็น Popup Error" → เงื่อนไขคือ "มีรายที่ล้มเหลว" ไม่ใช่
    //   "ทั้งงานล้มเหลว" เพราะ handler ตั้งใจให้รายเดียวพังแล้วชุดยังเดินต่อได้
    //   (งานที่ล้มทั้งก้อนใช้ alert เดิม — ไม่มีรายที่ติดขัดให้ชี้)
    //
    //   ⚠ ชุดที่ "ถูกยกเลิก" ไม่ใช่ "ติดขัดกลางทาง" — ต้องไม่เข้าโหมดนี้
    //     ใบที่กำลังบันทึกอยู่ตอนผู้ใช้กดยกเลิกจะถูกบันทึกเป็น Failed ด้วย
    //     (SaveFormSummaryStockCommandHandler คืนผลว่าไม่สำเร็จเมื่อ token ถูกยกเลิก)
    //     ถ้านับเป็น error ผู้ใช้จะโดนถาม "จะทำต่อหรือจะลบ" ทั้งที่เพิ่งสั่งยกเลิกเอง
    //     และเอกสารทั้งชุดถูกลบไปแล้วตั้งแต่ตอนยกเลิก (H3) ไม่มีอะไรให้เลือกอีก
    isErrorMode: function isErrorMode() {
      if (this.isRunning) return false;
      if (this.state === "Cancelled") return false;
      return this.failedItem !== null;
    },
    // FS-105 — รายที่ผู้ใช้กด "ข้าม" ไปแล้วถือว่าตัดสินแล้ว ไม่นับเป็นรายที่ติดขัดอยู่
    failedItem: function failedItem() {
      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];
        if (item.status === "Failed" && !item.isSkippedByUser) return item;
      }
      return null;
    },

    // FS-105 — งานหยุดรออยู่ที่รายที่ติดขัด = ต้องให้ผู้ใช้เลือก 1 ใน 2 ทาง (ไม่มีปุ่มปิด)
    canChooseAfterFailure: function canChooseAfterFailure() {
      return this.state === "Paused" && this.isErrorMode;
    },

    // FS-105 — "ประมวลผลสำเร็จแล้ว N จากทั้งหมด M ..."
    //   งานบันทึก = นับเอกสารที่สร้างได้ (ตาม mockup "34 จากทั้งหมด 55 เอกสาร")
    //   งานประมวลผล = นับตัวแทนที่เรียกข้อมูลได้แล้ว ทั้งที่มีและไม่มีสินค้าคงค้าง (ยังไม่มีเอกสาร)
    successCount: function successCount() {
      if (this.isDocumentJob) return this.createdCount;
      return this.createdCount + this.skippedCount;
    },
    unitLabel: function unitLabel() {
      return this.isDocumentJob ? "เอกสาร" : "ตัวแทนจำหน่าย";
    },
    failedLabel: function failedLabel() {
      var item = this.failedItem;
      if (!item) return "-";
      return agentLabel(item.agentCode, item.agentName);
    },
    failedReference: function failedReference() {
      var item = this.failedItem;
      return item && item.errorReference ? item.errorReference : "-";
    },
    displayTitle: function displayTitle() {
      if (!this.isErrorMode) return this.title;
      return "พบข้อผิดพลาดที่ตัวแทนจำหน่ายรายที่ " + this.failedItem.seqNo;
    },
    barClass: function barClass() {
      if (this.state === "Cancelled") return "bg-warning";
      if (this.state === "Failed") return "bg-danger";
      if (this.failedCount > 0) return "bg-warning";
      return this.isRunning ? "progress-bar-striped progress-bar-animated" : "bg-success";
    },
    resultAlertClass: function resultAlertClass() {
      if (this.state === "Cancelled") return "alert-warning";
      if (this.state === "Failed") return "alert-danger";
      return this.failedCount > 0 ? "alert-warning" : "alert-success";
    },
    currentLabel: function currentLabel() {
      return agentLabel(this.currentAgentCode, this.currentAgentName) || "-";
    },
    // แปลงรายการจาก API ให้พร้อมวาด แล้วเรียงล่าสุดไว้บน (ผู้ใช้สนใจตัวที่เพิ่งจบ)
    displayItems: function displayItems() {
      var tones = { Created: "ok", Skipped: "skip", Failed: "fail" };
      var icons = { Created: "✔", Skipped: "–", Failed: "✕" };

      return this.items.slice().reverse().map(function (item) {
        return {
          key: item.seqNo + "-" + item.agentCode,
          seqNo: item.seqNo,
          label: agentLabel(item.agentCode, item.agentName),
          tone: tones[item.status] || "skip",
          icon: icons[item.status] || "•",
          // FS-105 — รายที่ติดขัดแล้วผู้ใช้กดข้าม บอกให้ชัดว่าข้ามไปแล้ว ไม่ได้ค้างอยู่
          note: item.isSkippedByUser ? (item.message || "ติดขัด") + " · ข้ามแล้ว" : item.documentNo || item.message || ""
        };
      });
    }
  },
  watch: {
    // FS-126 — เดินเฉพาะตอน Running · ออกจาก Running (Paused / จบ) = หยุดสะสม · กลับมา Running = เดินต่อ
    state: function state(value) {
      if (!this.showTimer) return;
      if (value === "Running") this.resumeElapsedTimer();else this.pauseElapsedTimer();
    }
  },
  methods: {
    // ── FS-126 : ตัวนับเวลา ──────────────────────────────────────────────────
    resumeElapsedTimer: function resumeElapsedTimer() {
      var self = this;
      if (self.timerRunningSince !== null) return;

      self.timerRunningSince = Date.now();
      self.timerNow = self.timerRunningSince;
      if (!self.timerTick) {
        self.timerTick = setInterval(function () {
          self.timerNow = Date.now();
        }, 1000);
      }
    },
    pauseElapsedTimer: function pauseElapsedTimer() {
      if (this.timerRunningSince !== null) {
        this.timerElapsedMs += Math.max(0, Date.now() - this.timerRunningSince);
        this.timerRunningSince = null;
      }
      if (this.timerTick) {
        clearInterval(this.timerTick);
        this.timerTick = null;
      }
    },
    resetElapsedTimer: function resetElapsedTimer() {
      this.pauseElapsedTimer();
      this.timerElapsedMs = 0;
      this.timerNow = 0;
    },

    /**
     * เริ่มงานใหม่แล้วเปิด popup
     *   options.title     ชื่องานที่แสดงบนหัว popup
     *   options.payload   body ที่ส่งไปให้ endpoint start
     *   options.endpoints ทับค่า endpoint เริ่มต้น (ถ้างานอื่นใช้คนละชุด)
     *   options.jobKind   "document" | "file" | "process" (FS-033 — ดู jobKindResolved)
     *   options.deferMs   FS-033 — หน่วงการเปิด popup กี่ ms (0/ไม่ส่ง = เปิดทันที)
     *   options.autoCloseMs FS-110 — งานจบครบแล้วปิด popup เองหลังกี่ ms (0/ไม่ส่ง = รอกด "ปิด")
     *   options.showTimer FS-126 — true = แสดงตัวนับเวลา HH:MM:SS มุมขวาบน (เริ่มนับตอนเรียก start)
     */
    start: function start(options) {
      var self = this;
      var opts = options || {};

      self.reset();
      self.title = opts.title || "กำลังดำเนินการ";
      self.jobKind = opts.jobKind || "";
      self.deferMs = opts.deferMs || 0;
      self.autoCloseMs = opts.autoCloseMs || 0;

      // FS-126 — เริ่มนับตั้งแต่ผู้ใช้กดเริ่มงาน
      self.showTimer = opts.showTimer === true;
      if (self.showTimer) self.resumeElapsedTimer();

      if (opts.endpoints) {
        self.endpoints = Object.assign({}, self.endpoints, opts.endpoints);
      }

      // FS-033 — งานที่ "อาจจะ" สั้นมากให้หน่วงไว้ก่อน จะได้ไม่มี popup กระพริบ
      //   งานที่ยาวจริงจะถูกเปิดเมื่อครบเวลา ส่วนงานที่จบก่อนจะไม่เปิดเลย
      //   (ยกเว้นงานที่จบแบบผิดพลาด — finish() จะบังคับเปิดให้ผู้ใช้เห็นเสมอ)
      if (self.deferMs > 0) {
        self.deferTimer = setTimeout(function () {
          self.deferTimer = null;
          if (self.isRunning) self.showModal();
        }, self.deferMs);
      } else {
        self.showModal();
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(self.endpoints.start, opts.payload || {}, {
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        var data = response && response.data || {};

        if (!data.success) {
          self.state = "Failed";
          self.finishedMessage = data.message || "เริ่มงานไม่สำเร็จ";
          return;
        }

        self.batchId = data.batchId;
        self.agentCount = data.agentCount || 0;
        self.scheduleNextPoll();
      }).catch(function () {
        self.state = "Failed";
        self.finishedMessage = "เริ่มงานไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
      });
    },

    // ── polling ───────────────────────────────────────────────────────────
    scheduleNextPoll: function scheduleNextPoll() {
      var self = this;
      self.clearTimer();
      self.timer = setTimeout(function () {
        self.poll();
      }, POLL_INTERVAL_MS);
    },

    poll: function poll() {
      var self = this;

      if (!self.batchId || !self.isRunning) return;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(self.endpoints.progress, { batchId: self.batchId }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var data = response && response.data || {};

        if (!data.success) {
          // ไม่พบชุดนี้แล้ว — แอปอาจถูก restart ระหว่างทาง (เช่น deploy)
          // FS-120 — บอกผู้ใช้ว่าต้องทำอะไรต่อ แทนข้อความจาก server ("ไม่พบข้อมูลความคืบหน้า...")
          self.state = "Failed";
          self.finishedMessage = self.serverLostMessage();
          self.finish();
          return;
        }

        self.consecutiveErrors = 0;
        self.applyProgress(data);

        if (data.isRunning) {
          self.scheduleNextPoll();
        } else {
          self.finish();
        }
      }).catch(function () {
        // เน็ตสะดุดชั่วคราวไม่ควรล้มทั้งงาน — ลองใหม่จนกว่าจะเกินโควตา
        self.consecutiveErrors++;

        if (self.consecutiveErrors >= MAX_CONSECUTIVE_ERRORS) {
          self.state = "Failed";
          // FS-120 — งานประมวลผลยังไม่บันทึกอะไร ประมวลผลใหม่ได้เลย จึงใช้ข้อความเดียวกับกรณี server รีสตาร์ท
          //   งานบันทึก / สร้างไฟล์ คงข้อความเดิม — งานอาจยังทำอยู่เบื้องหลัง กดซ้ำแล้วอาจได้เอกสารซ้ำ
          self.finishedMessage = self.jobKindResolved === "process" ? self.serverLostMessage() : "ขาดการติดต่อกับระบบ งานอาจยังทำงานอยู่เบื้องหลัง " + "กรุณาตรวจสอบที่หน้ารายการเอกสาร";
          self.finish();
          return;
        }

        self.scheduleNextPoll();
      });
    },

    // FS-120 — ข้อความเมื่อ Web Server มีปัญหาระหว่างทาง (รีสตาร์ท / deploy) แล้วงานหายจากหน่วยความจำ
    //   ปุ่ม "ประมวลผลใหม่ / ข้าม" ของ FS-105 ใช้ไม่ได้ เพราะ server ไม่มีงานนี้แล้ว → ให้ผู้ใช้เริ่มใหม่เอง
    //   งานบันทึก : เอกสารบางส่วนอาจสร้างไปแล้ว ต้องตรวจก่อน ไม่งั้นกดบันทึกซ้ำได้เอกสารซ้ำ
    serverLostMessage: function serverLostMessage() {
      if (this.isDocumentJob) {
        return "Web Server มีปัญหาในระหว่างบันทึกข้อมูล เอกสารบางส่วนอาจถูกสร้างไปแล้ว " + "กรุณาปิดหน้าต่างแล้วตรวจสอบที่หน้ารายการเอกสารก่อนบันทึกข้อมูลอีกครั้ง";
      }
      if (this.jobKindResolved === "file") {
        return "Web Server มีปัญหาในระหว่างสร้างไฟล์ กรุณาปิดหน้าต่างแล้วกดสร้างไฟล์อีกครั้ง";
      }
      return "Web Server มีปัญหาในระหว่างประมวลผล กรุณาปิดหน้าต่างแล้วกดประมวลผลอีกครั้ง";
    },

    applyProgress: function applyProgress(data) {
      this.state = data.state || "Running";
      this.percent = data.percent || 0;
      this.agentCount = data.agentCount || this.agentCount;
      this.processedCount = data.processedCount || 0;
      this.createdCount = data.createdCount || 0;
      this.skippedCount = data.skippedCount || 0;
      this.failedCount = data.failedCount || 0;
      this.currentAgentCode = data.currentAgentCode || "";
      this.currentAgentName = data.currentAgentName || "";
      this.items = data.items || [];

      // F13 (J2) — งานที่ผลิตไฟล์จะส่ง 2 ค่านี้มาด้วย งานอื่นจะเป็น false/null
      this.hasResultFile = data.hasResultFile === true;
      this.resultFileName = data.resultFileName || "";

      if (!data.isRunning) {
        this.finishedMessage = data.message || "";
      }
    },

    // FS-033 — เปิด popup จริง (แยกออกมาเพราะ deferMs ทำให้เปิดได้ 2 จังหวะ)
    showModal: function showModal() {
      if (this.isShown) return;

      this.clearDeferTimer();
      this.isShown = true;

      if (this.$refs.modalRoot) {
        $(this.$refs.modalRoot).modal("show");
      }

      this.$emit("shown", { batchId: this.batchId });
    },

    clearDeferTimer: function clearDeferTimer() {
      if (this.deferTimer) {
        clearTimeout(this.deferTimer);
        this.deferTimer = null;
      }
    },

    clearAutoCloseTimer: function clearAutoCloseTimer() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
    },

    // FS-110 — ปิดเองได้เมื่อ งานจบ Completed · ไม่มีรายที่ติดขัดค้างอยู่ · มีเอกสารให้ไปดูที่ขั้นที่ 6
    //   รายที่ผู้ใช้กด "ข้าม" (FS-105) แล้วทำต่อจนจบ = ผ่านเงื่อนไข (ผู้ใช้ตัดสินใจแล้ว — ผู้ใช้ยืนยัน 16/10/2026)
    //   ยกเลิก / Failed / หยุดรอที่รายที่ติดขัด → ไม่ปิดเอง
    canAutoClose: function canAutoClose() {
      return this.autoCloseMs > 0 && this.state === "Completed" && !this.isErrorMode && this.createdCount > 0;
    },

    finish: function finish() {
      this.clearTimer();
      this.clearDeferTimer();

      // FS-033/FS-031 — งานที่ถูกหน่วงไว้แล้วจบแบบไม่เรียบร้อย ต้องบังคับให้ popup โผล่
      //   ไม่งั้นผู้ใช้จะไม่เห็นทั้งข้อความผิดพลาดและปุ่มแก้ไขสถานการณ์เลย
      if (!this.isShown && (this.state !== "Completed" || this.failedCount > 0)) {
        this.showModal();
      }

      this.$emit("finished", {
        batchId: this.batchId,
        state: this.state,
        jobKind: this.jobKindResolved,
        createdCount: this.createdCount,
        skippedCount: this.skippedCount,
        failedCount: this.failedCount
      });

      // FS-110 — ค้างไว้ให้เห็น 100% ก่อน แล้วปิดเองเหมือนผู้ใช้กด "ปิด" (→ ผู้เรียกพาไปขั้นที่ 6)
      if (this.canAutoClose()) {
        var self = this;
        self.clearAutoCloseTimer();
        self.autoCloseTimer = setTimeout(function () {
          self.autoCloseTimer = null;
          self.close();
        }, self.autoCloseMs);
      }
    },

    // ── FS-031 : popup ย่อย "ตรวจสอบข้อมูลข้อความผิดพลาด" ─────────────────
    //
    //   spec §M : "เปิด popup ย่อยแสดงข้อมูลข้อความผิดพลาดโดยละเอียด
    //   (สาเหตุทางเทคนิค + เวลาที่เกิดเหตุ + เลขอ้างอิง) เพื่อให้ผู้ใช้ถ่ายภาพ/คัดลอก
    //   ส่งต่อทีมดูแลระบบ SBP"
    //
    //   ใช้ style ฝังในบรรทัดโดยตั้งใจ: Swal สร้าง DOM ไว้นอก component
    //   ทำให้ <style scoped> ของไฟล์นี้ใช้ไม่ได้
    openErrorDetail: function openErrorDetail() {
      var item = this.failedItem;
      if (!item) return;

      var rowStyle = "padding:0.35rem 0;border-bottom:1px solid #ebedf2;";
      var labelStyle = "color:#74788d;font-size:0.85rem;";
      var valueStyle = "color:#48465b;word-break:break-all;";

      function row(label, value, testId) {
        return '<div style="' + rowStyle + '">' + '<div style="' + labelStyle + '">' + label + "</div>" + '<div style="' + valueStyle + '" data-test="' + testId + '">' + value + "</div>" + "</div>";
      }

      Swal.fire({
        title: "ข้อมูลข้อความผิดพลาด",
        html: '<div style="text-align:left;">' + row("เลขอ้างอิง (แจ้งทีมดูแลระบบ SBP)", this.failedReference, "fss-error-detail-reference") + row("เวลาที่เกิดเหตุ", this.formatDateTime(item.failedAt), "fss-error-detail-time") + row("ตัวแทนจำหน่ายที่ติดขัด", this.failedLabel, "fss-error-detail-agent") + row("ลำดับที่", String(item.seqNo), "fss-error-detail-seq") + row("สาเหตุทางเทคนิค", item.errorDetail || "ไม่ทราบสาเหตุ", "fss-error-detail-cause") + "</div>",
        type: "error",
        confirmButtonText: "ปิด"
      });
    },

    // เวลาแบบไทยอ่านง่าย — ค่าที่ได้จาก API เป็น ISO string
    formatDateTime: function formatDateTime(value) {
      if (!value) return "-";

      var date = new Date(value);
      if (isNaN(date.getTime())) return String(value);

      function pad(n) {
        return n < 10 ? "0" + n : String(n);
      }

      return pad(date.getDate()) + "/" + pad(date.getMonth() + 1) + "/" + date.getFullYear() + " " + pad(date.getHours()) + ":" + pad(date.getMinutes()) + ":" + pad(date.getSeconds());
    },

    // ── FS-031 ทางเลือกที่ 1 : ประมวลผลใหม่เริ่มจากรายที่ติดขัด ────────────
    //
    //   ไม่ต้องยืนยันซ้ำ — ทางเลือกนี้ไม่ทำให้อะไรหาย และผู้ใช้เพิ่งอ่าน
    //   คำอธิบายบน popup error มาแล้ว การถามซ้ำมีแต่จะทำให้กดผ่านโดยไม่อ่าน
    resumeFromFailure: function resumeFromFailure() {
      this.continueAfterFailure(false);
    },

    // ── FS-105 ทางเลือกที่ 2 : ข้ามการประมวลผลตัวแทนจำหน่ายที่ติดขัด ────────
    //
    //   แทนปุ่มเดิม "ยกเลิกและลบไฟล์ที่สร้างแล้ว" (ผู้ใช้สั่ง 15/10/2026)
    //   ไม่ลบอะไร จึงไม่ต้องยืนยันซ้ำเช่นเดียวกับทางเลือกที่ 1
    skipFailedAgent: function skipFailedAgent() {
      this.continueAfterFailure(true);
    },

    // ทั้งสองทางเปิดรอบใหม่บน batchId เดิม แล้ว poll ต่อ
    //   server ใส่รายการที่จบแล้วกลับเข้ามาให้ % และ log เดินต่อ ไม่เด้งกลับไป 0
    continueAfterFailure: function continueAfterFailure(skipFailed) {
      var self = this;

      if (!self.batchId || self.resuming || self.skipping) return;

      if (skipFailed) self.skipping = true;else self.resuming = true;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(self.endpoints.resume, { batchId: self.batchId, skipFailed: skipFailed }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var data = response && response.data || {};

        if (!data.success) {
          Swal.fire("ทำงานต่อไม่ได้", data.message || "ไม่สามารถประมวลผลต่อได้", "warning");
          return;
        }

        // กลับเข้าโหมด "กำลังทำงาน" แล้ว poll ต่อด้วย batchId เดิม
        //   (ข้ามรายสุดท้ายของชุด server ปิดงานให้ทันที — poll รอบแรกจะเห็นสถานะจบเอง)
        self.state = "Running";
        self.finishedMessage = "";
        self.cancelRequested = false;
        self.consecutiveErrors = 0;
        self.agentCount = data.agentCount || self.agentCount;
        self.showModal();
        self.scheduleNextPoll();
      }).catch(function () {
        Swal.fire("เกิดข้อผิดพลาด", "สั่งประมวลผลต่อไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
      }).then(function () {
        self.resuming = false;
        self.skipping = false;
      });
    },

    // ── F13 (J2) : ดาวน์โหลดไฟล์ผลลัพธ์ ───────────────────────────────────
    //
    //   ต้องยิงด้วย axios พร้อม Authorization header — endpoint ป้องกันด้วย Bearer
    //   การใช้ <a href> ธรรมดาจะไม่แนบ token แล้วได้ 401
    //
    //   ใช้ responseType "blob" ไม่ใช่ "arraybuffer" เพื่อให้เบราว์เซอร์จัดการ
    //   หน่วยความจำเอง (ไฟล์ ZIP ของ 55 เอกสารอาจใหญ่หลายร้อย MB)
    downloadResult: function downloadResult() {
      var self = this;

      if (!self.batchId || !self.endpoints.download || self.downloading) return;

      var url = self.endpoints.download.replace("{jobId}", encodeURIComponent(self.batchId));

      self.downloading = true;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, {
        responseType: "blob",
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        var contentType = response.headers["content-type"] || "";

        // server ปฏิเสธ (ไฟล์หมดอายุ) จะคืน JSON ไม่ใช่ไฟล์
        if (contentType.indexOf("application/json") !== -1) {
          var reader = new FileReader();
          reader.onload = function () {
            var message = "ไม่พบไฟล์ที่ต้องการดาวน์โหลด";
            try {
              var parsed = JSON.parse(reader.result);
              if (parsed && parsed.message) message = parsed.message;
            } catch (e) {
              // ปล่อยข้อความเริ่มต้นไว้
            }
            Swal.fire("ดาวน์โหลดไม่ได้", message, "warning");
          };
          reader.readAsText(response.data);
          return;
        }

        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(response.data);
        link.download = self.resultFileName || "download.zip";
        link.click();

        // คืนหน่วยความจำให้เบราว์เซอร์ ไม่ปล่อยให้ค้างจนกว่าจะปิดแท็บ
        setTimeout(function () {
          window.URL.revokeObjectURL(link.href);
        }, 30000);
      }).catch(function () {
        Swal.fire("เกิดข้อผิดพลาด", "ดาวน์โหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
      }).then(function () {
        self.downloading = false;
      });
    },

    // ── ยกเลิก ────────────────────────────────────────────────────────────
    //
    // FS-028 — ข้อความต้องตรงกับสิ่งที่ระบบทำจริง (ยืนยันจากโค้ดแล้ว):
    //   FormSummaryStockController.GroupSaveStart จับ OperationCanceledException
    //   -> SaveFormSummaryStockBatchCommandHandler.RollbackBatchAsync()
    //   -> soft delete "หัวเอกสาร" (FormSummaryStock_Header.IsDeleted = 1) ทุกใบของ BatchId นั้น
    //   ทุก query ของ module กรอง IsDeleted ออกอยู่แล้ว เอกสารจึงหายจากหน้ารายการ
    //   เปิดดู / พิมพ์ PDF / Export Excel ไม่ได้อีก และไม่มีหน้าจอไหนกู้คืนให้ได้
    //
    //   ของเดิมเขียนว่าเอกสาร "ยังอยู่ในระบบ" และให้ผู้ใช้ไปลบเอง
    //   = ผู้ใช้ตัดสินใจบนข้อมูลที่ผิด ทั้งที่เป็นการลบที่กู้ไม่ได้
    //
    // ⚠ popup ตัวนี้ใช้ร่วมกับงาน ZIP ด้วย และงาน ZIP ก็รายงาน item เป็น Created เหมือนกัน
    //   (ExportFormSummaryStockBatchZipCommandHandler) แต่ยกเลิกงาน ZIP ไม่ได้ลบเอกสารเลย
    //   จึงต้องแยกด้วย endpoint ที่ผู้เรียกส่งมา ไม่ใช่ดู createdCount อย่างเดียว
    //
    // ปุ่มที่โฟกัสต้องเป็น "ทำต่อ" (focusCancel) — Enter ต้องไม่ไปโดนตัวที่ลบข้อมูลทิ้ง
    //   บทเรียนเดียวกับ popup ออกจากหน้าสรุปผล (FS-019)
    //
    // ใช้ style ฝังในบรรทัดโดยตั้งใจ: Swal สร้าง DOM ไว้นอก component
    //   ทำให้ <style scoped> ของไฟล์นี้ใช้ไม่ได้
    requestCancel: function requestCancel() {
      var self = this;

      var boxStyle = "text-align:left;border-radius:4px;" + "padding:0.75rem 0.9rem;margin-top:0.9rem;color:#48465b;";

      // งานสร้างเอกสารรวมเท่านั้นที่ยกเลิกแล้วลบเอกสารทิ้ง (H3 / RollbackBatchAsync)
      var jobKind = self.jobKindResolved;
      var isDocumentJob = jobKind === "document";

      var body = void 0;

      if (jobKind === "process") {
        // FS-033 — ขั้น "ประมวลผล" ยังไม่ได้บันทึกอะไรลงระบบเลย ไม่มีทั้งเอกสารและไฟล์ให้ทิ้ง
        //   ข้อความจึงต้องไม่มีคำที่สื่อว่าจะมีอะไรหาย (บทเรียนกลับด้านของ FS-028 —
        //   ตอนนั้นข้อความเบาเกินความจริง ตอนนี้ต้องไม่หนักเกินความจริง)
        body = '<div data-test="fss-cancel-note" style="' + boxStyle + 'background-color:#f7f8fa;border:1px solid #ebedf2;">' + "ขั้นตอนนี้เป็นการคำนวณเพื่อแสดงผลเท่านั้น " + "<strong>ยังไม่มีการบันทึกเอกสารหรือไฟล์ใดลงระบบ</strong> — " + "ท่านจะยังอยู่ที่หน้าเลือก Filter และสั่งประมวลผลใหม่ได้ทันที" + "</div>";
      } else if (!isDocumentJob) {
        // งาน ZIP / Excel ตรวจ — ยกเลิกแล้วทิ้งแค่ไฟล์ที่ทำค้างอยู่ ไม่แตะเอกสารที่บันทึกไว้แล้ว
        body = '<div data-test="fss-cancel-note" style="' + boxStyle + 'background-color:#f7f8fa;border:1px solid #ebedf2;">' + "ไฟล์ที่กำลังสร้างจะถูกทิ้ง — <strong>เอกสารที่บันทึกไว้แล้วไม่ได้รับผลกระทบ</strong> " + "สั่งสร้างไฟล์ใหม่ได้ตลอด" + "</div>";
      } else if (self.createdCount > 0) {
        body = '<div data-test="fss-cancel-delete-warning" style="' + boxStyle + "background-color:#fff0f4;border:1px solid #f8bfd0;" + 'border-left:4px solid #fd397a;">' + "<strong>เอกสารที่สร้างไปแล้ว " + self.createdCount + " ฉบับ จะถูกลบออกจากระบบทั้งหมด</strong><br>" + "ลบแล้ว<strong>กู้คืนไม่ได้</strong> — เอกสารจะหายจากหน้ารายการเอกสาร " + "เปิดดู พิมพ์ PDF หรือ Export Excel ไม่ได้อีก<br>" + "หากยังต้องการเอกสารเหล่านี้ ต้องสั่งสร้างใหม่ทั้งชุด" + "</div>";
      } else {
        // ยังไม่มีเอกสารถูกสร้าง = ไม่มีอะไรให้ลบ ไม่ต้องขู่ผู้ใช้เกินจริง
        body = '<div data-test="fss-cancel-note" style="' + boxStyle + 'background-color:#f7f8fa;border:1px solid #ebedf2;">' + "ยังไม่มีเอกสารถูกสร้างในชุดนี้ จึงไม่มีเอกสารที่ต้องลบ" + "</div>";
      }

      var willDelete = isDocumentJob && self.createdCount > 0;

      var cancelTitle = "ยืนยันยกเลิกการสร้างไฟล์";
      if (isDocumentJob) cancelTitle = "ยืนยันยกเลิกการสร้างเอกสาร";else if (jobKind === "process") cancelTitle = "ยืนยันยกเลิกการประมวลผล";

      Swal.fire({
        title: cancelTitle,
        html: '<div style="text-align:left;" data-test="fss-cancel-main">' + (isDocumentJob ? "ระบบจะหยุดหลังจากเอกสารฉบับที่กำลังทำอยู่เสร็จ" : "ระบบจะหยุดหลังจากรายการที่กำลังทำอยู่เสร็จ") + "</div>" + body,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: willDelete ? "ยืนยันยกเลิกและลบเอกสาร" : "ยืนยันยกเลิก",
        cancelButtonText: "ทำต่อ",
        // สีแดงของระบบ — ปุ่มที่ลบข้อมูลต้องไม่หน้าตาเหมือนปุ่มยืนยันทั่วไป
        //   งานที่ไม่ได้ลบอะไรใช้สีเริ่มต้นของ SweetAlert2 v8 ตามเดิม
        confirmButtonColor: willDelete ? "#fd397a" : "#3085d6",
        // ปุ่มที่โฟกัสอยู่คือปุ่มที่ Enter จะกดโดน จึงต้องเป็นตัวที่ไม่ทำให้ข้อมูลหาย
        focusCancel: true
      }).then(function (result) {
        // SweetAlert2 v8 — ผลการยืนยันอยู่ที่ result.value
        if (!result.value) return;

        self.cancelRequested = true;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(self.endpoints.cancel, { batchId: self.batchId }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).catch(function () {
          // ยกเลิกไม่สำเร็จก็ปล่อยให้ polling รายงานสถานะจริงต่อไป
          self.cancelRequested = false;
        });
      });
    },

    // ── ปิด ───────────────────────────────────────────────────────────────
    //   extra — ข้อมูลเพิ่มที่ผู้เรียกต้องรู้ (ผู้เรียกปัจจุบันยังรองรับ rolledBack:true ของ FS-031)
    close: function close(extra) {
      this.clearTimer();
      this.clearDeferTimer();
      this.clearAutoCloseTimer();

      if (this.isShown && this.$refs.modalRoot) {
        $(this.$refs.modalRoot).modal("hide");
      }
      this.isShown = false;

      this.$emit("closed", Object.assign({
        batchId: this.batchId,
        state: this.state,
        jobKind: this.jobKindResolved,
        createdCount: this.createdCount
      }, extra || {}));
    },

    reset: function reset() {
      this.clearTimer();
      this.clearDeferTimer();

      // FS-126
      this.resetElapsedTimer();
      this.showTimer = false;

      this.batchId = null;
      this.agentCount = 0;
      this.processedCount = 0;
      this.createdCount = 0;
      this.skippedCount = 0;
      this.failedCount = 0;
      this.percent = 0;
      this.currentAgentCode = "";
      this.currentAgentName = "";
      this.state = "Running";
      this.finishedMessage = "";
      this.items = [];
      this.cancelRequested = false;
      this.consecutiveErrors = 0;
      this.hasResultFile = false;
      this.resultFileName = "";
      this.downloading = false;

      // FS-031/FS-033
      this.resuming = false;
      this.skipping = false;
      this.isShown = false;
      this.jobKind = "";
      this.deferMs = 0;

      // FS-110
      this.clearAutoCloseTimer();
      this.autoCloseMs = 0;
    },

    clearTimer: function clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  },
  // ออกจากหน้าไปโดยที่ยัง poll อยู่ ต้องหยุด timer ไม่งั้นมันยิง API ต่อไปเรื่อย ๆ
  beforeDestroy: function beforeDestroy() {
    this.clearTimer();
    this.clearDeferTimer();
    this.clearAutoCloseTimer();
    this.pauseElapsedTimer();
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_summary_stock_actions_css__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_summary_stock_actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__form_summary_stock_actions_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_summary_stock_tooltips__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormSummaryStockSignaturePdfPreview__ = __webpack_require__(1348);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Action Button Design System ของโมดูลนี้ (QA เรื่องที่ 16) — ใช้ที่ปุ่มลบภาพ

// FS-088 — tooltip ของปุ่มวงกลมเป็นแบบ Bootstrap (ผูกครั้งเดียวทั้งโมดูล เรียกซ้ำได้)

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__form_summary_stock_tooltips__["a" /* installFssTooltips */])();

__webpack_require__(9);

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F15 — popup "จัดการลายเซ็นผู้จัดทำ" 2 แถบ
//
// เปิดจากหน้าตรวจสอบ/รายละเอียดเอกสารผ่าน $refs:
//   this.$refs.signatureModal.open({ id, documentNo })
//   เอกสารที่ยังไม่ถูกบันทึกให้ส่ง id = 0 — component จะคืน attachedId ผ่าน event
//   "selected" ให้หน้าแม่ถือไว้ แล้วแนบไปกับคำสั่งบันทึก (query string signatureAttachedId)
//
// spec ฉบับเซ็น 16/09/2026:
//   • แถบ 1 "ใช้กับเอกสารนี้เท่านั้น"        — ไม่กระทบค่าเริ่มต้น / มีปุ่มลบ
//   • แถบ 2 "จัดการลายเซ็นค่าเริ่มต้นระบบ"  — กระทบทั้งระบบ / ไม่มีปุ่มลบ / ยืนยันซ้ำก่อนบันทึก
//   • เห็นปุ่มจัดการเฉพาะแอดมินทีมเบียร์สด (canManage มาจาก API ไม่ใช่เดาจาก role ฝั่ง client)
//
// FS-013 (24/09/2026) — จัดหน้าใหม่ให้ตรง design: หัวสีน้ำเงิน · ป้าย "กระทบทั้งระบบ" ·
//   กล่องคำอธิบายสีฟ้า · คำกำกับกรอบลายเซ็น · คลิกภาพเพื่อขยาย · กล่องข้อมูลไฟล์ ·
//   ป้ายแหล่งที่มา · ปุ่มลบเต็มใบ · dropzone · แถบเตือนสีเหลือง · ปุ่มยืนยันท้าย popup
//
// SweetAlert2 = 8.13.3 (SBP.Web/package.json ^8.2.3) → ใช้ option `type` (ไม่ใช่ `icon` ของ v9+)
// และอ่านผลการยืนยันจาก `result.value`
//
// กฎชนิด/ขนาดไฟล์ถูกบังคับซ้ำที่ server ใน UploadFormSummaryStockSignatureCommandHandler
// ที่ตรวจในนี้เป็นแค่ด่านแรกเพื่อ UX
// ─────────────────────────────────────────────────────────────────────────────

// ตรงกับ FormSummaryStockSignatureRules.AllowedExtensions (backend)
var ALLOWED_EXTENSIONS = [".png", ".jpg", ".jpeg"];

// 10 MB — ตรงกับ FormSummaryStockSignatureRules.MaxFileSizeBytes
var MAX_FILE_SIZE = 10 * 1024 * 1024;

function getExtension(fileName) {
  if (!fileName) return "";
  var dotIndex = String(fileName).lastIndexOf(".");
  if (dotIndex < 0) return "";
  return String(fileName).substring(dotIndex).toLowerCase();
}

function formatBytes(bytes) {
  if (!bytes || bytes <= 0) return "-";
  if (bytes >= 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(2) + " MB";
  if (bytes >= 1024) return (bytes / 1024).toFixed(2) + " KB";
  return bytes + " B";
}



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormSummaryStockSignaturePdfPreview: __WEBPACK_IMPORTED_MODULE_4__FormSummaryStockSignaturePdfPreview__["a" /* default */] },
  data: function data() {
    return {
      // FS-087 — tooltip ปุ่มแดงตอนภาพ "เลือกไว้แต่ยังไม่บันทึก" ใช้ข้อความเดียวกันทั้งสองแถบ
      //   ข้อความตามที่ผู้ใช้กำหนด 14/10/2026 — "ยกเลิกภาพที่เลือก" ติดวงเล็บ ไม่เว้นวรรค
      STAGED_DISCARD_TITLE: "ยกเลิกภาพที่เลือก(ยังไม่บันทึกจะกลับไปใช้ค่าเริ่มต้นระบบ)",

      // 0 = เอกสารยังไม่ถูกบันทึก (เปิดจากหน้าตรวจสอบก่อนกดบันทึก)
      headerId: 0,
      documentNo: "",
      activeTab: "document",

      canManage: false,
      isMissingDefault: false,
      hasDocumentOverride: false,

      defaultAttachedId: null,
      defaultImageUrl: "",
      defaultFileName: "",
      defaultUpdatedAt: null,

      documentAttachedId: null,
      documentImageUrl: "",
      documentFileName: "",

      // ── design ข้อ 6 : ขนาดไฟล์ + ขนาดภาพ ──────────────────────────────
      // endpoint Signature ไม่ได้คืนค่าพวกนี้ (และห้ามแก้ฝั่ง backend ในรอบนี้)
      // จึงรู้ "ขนาดไฟล์" เฉพาะไฟล์ที่ผู้ใช้เพิ่งเลือกในรอบนี้ (File.size)
      // ส่วน "ขนาดภาพ" อ่านจากภาพที่โหลดเสร็จ (naturalWidth/naturalHeight)
      // 0 = ไม่รู้ → ซ่อนบรรทัดนั้นไปเลย ไม่แสดงค่าหลอก
      documentFileSize: 0,
      documentImageWidth: 0,
      documentImageHeight: 0,
      defaultFileSize: 0,
      defaultImageWidth: 0,
      defaultImageHeight: 0,

      // โหมดก่อนบันทึก (headerId = 0) — เอกสารยังไม่มีแถวใน DB ให้ผูก
      // API จึงคืน documentAttachedId = null เสมอ ต้องจำภาพที่เพิ่งอัพโหลดไว้เองเพื่อโชว์ preview
      pendingAttachedId: null,
      pendingFileName: "",
      pendingFileSize: 0,
      pendingObjectUrl: "",

      // ── ภาพที่ผู้ใช้เลือกไว้แต่ "ยังไม่บันทึก" (QA 08/10/2026 เรื่องที่ 12/13/14) ──
      //
      // เดิมเลือกไฟล์ปุ๊บ = อัพโหลดทันที ทำให้
      //   • แถบ 1 ขึ้น popup "สำเร็จ" ทั้งที่ยังไม่ได้กดปุ่ม (เรื่องที่ 14)
      //   • thumbnail ปุ่มล่างขวาเปลี่ยนก่อนบันทึก และกดยกเลิกแล้วไม่คืนค่า (เรื่องที่ 13)
      //   • แถบ 2 ขึ้น popup ยืนยันทันที ไม่มีขั้น preview (เรื่องที่ 12)
      //
      // ตอนนี้เลือกไฟล์ = พักไว้ดูก่อนเท่านั้น ยังไม่ยิง API และยังไม่ emit อะไรให้หน้าแม่
      // จะอัพโหลดจริงเมื่อกดปุ่มบันทึกของแถบนั้นเท่านั้น
      stagedFile: null,
      stagedScope: "", // "document" | "default" | "" (ไม่มี)
      stagedPreviewUrl: "",
      stagedFileName: "",
      stagedFileSize: 0,

      // แถบที่กดปุ่มอัพโหลดไว้ — ใช้ตอน input file ยิง change กลับมา
      pendingScope: "document",
      // แถบที่กำลังถูกลากไฟล์มาวาง ("" = ไม่มี) ใช้ไฮไลต์เฉพาะ dropzone ที่ชี้อยู่
      dragScope: "",
      zoomImageUrl: "",
      loading: false,
      uploading: false
    };
  },
  computed: {
    /**
     * เอกสารที่บันทึกแล้ว (มี headerId) จะเปลี่ยนลายเซ็นไม่ได้
     * ยังไม่บันทึก (headerId = 0) คือหน้าขั้นที่ 3 / 3B ซึ่งยังเลือกได้อยู่
     *
     * ⚠ เดิม computed ถูกประกาศ 2 ก้อนในไฟล์เดียว ก้อนหลังทับก้อนแรก
     *   ทำให้ isDocumentLocked หายไปทั้งตัว (ป้าย fss-sig-locked จึงไม่เคยขึ้น)
     *   FS-013 รวมเป็นก้อนเดียวแล้ว
     */
    isDocumentLocked: function isDocumentLocked() {
      return this.headerId > 0;
    },

    /**
     * ปุ่มหลักท้าย popup แสดงเฉพาะตอนที่ "เลือกแล้วมีผล" ได้จริง
     * — เอกสารบันทึกแล้ว (ล็อก) หรือคนที่ไม่มีสิทธิ์จัดการ จะเห็นแค่ปุ่มปิด
     */
    showApplyButton: function showApplyButton() {
      return this.canManage && !this.isDocumentLocked && this.activeTab === "document";
    },

    // ── ภาพที่พักไว้ยังไม่บันทึก (เรื่องที่ 12/13/14) ────────────────────
    hasStagedDocument: function hasStagedDocument() {
      return this.stagedScope === "document" && !!this.stagedPreviewUrl;
    },
    hasStagedDefault: function hasStagedDefault() {
      return this.stagedScope === "default" && !!this.stagedPreviewUrl;
    },

    /**
     * ภาพที่แสดงในกรอบ preview ของแต่ละแถบ
     * ถ้ามีภาพที่เพิ่งเลือก (ยังไม่บันทึก) ให้โชว์ภาพนั้นเพื่อให้ตรวจก่อน
     * ถ้าไม่มี ก็โชว์ภาพที่บันทึกไว้จริงตามเดิม
     */
    documentPreviewUrl: function documentPreviewUrl() {
      return this.hasStagedDocument ? this.stagedPreviewUrl : this.documentImageUrl;
    },
    defaultPreviewUrl: function defaultPreviewUrl() {
      return this.hasStagedDefault ? this.stagedPreviewUrl : this.defaultImageUrl;
    },

    /**
     * ปุ่ม "บันทึกเป็นค่าเริ่มต้นระบบ →" ของแถบ 2 (spec บรรทัด 2857-2860)
     * โผล่เฉพาะตอนมีภาพใหม่รออยู่ — ไม่มีภาพใหม่ก็ไม่มีอะไรให้บันทึก
     */
    showSaveDefaultButton: function showSaveDefaultButton() {
      return this.canManage && this.activeTab === "default";
    },

    defaultUpdatedAtText: function defaultUpdatedAtText() {
      if (!this.defaultUpdatedAt) return "";
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.defaultUpdatedAt).format("DD/MM/YYYY HH:mm");
    },

    documentSizeText: function documentSizeText() {
      return this.documentFileSize > 0 ? formatBytes(this.documentFileSize) : "";
    },
    documentDimensionText: function documentDimensionText() {
      if (!this.documentImageWidth || !this.documentImageHeight) return "";
      return this.documentImageWidth + " x " + this.documentImageHeight + " px";
    },
    defaultSizeText: function defaultSizeText() {
      return this.defaultFileSize > 0 ? formatBytes(this.defaultFileSize) : "";
    },
    defaultDimensionText: function defaultDimensionText() {
      if (!this.defaultImageWidth || !this.defaultImageHeight) return "";
      return this.defaultImageWidth + " x " + this.defaultImageHeight + " px";
    },
    stagedSizeText: function stagedSizeText() {
      return this.stagedFileSize > 0 ? formatBytes(this.stagedFileSize) : "";
    }
  },
  methods: {
    // ── เปิด/ปิด popup ────────────────────────────────────────────────────
    open: function open(row) {
      this.headerId = row && row.id ? row.id : 0;
      this.documentNo = row && row.documentNo || "";
      this.activeTab = "document";
      this.pendingScope = "document";
      this.dragScope = "";
      this.zoomImageUrl = "";
      this.uploading = false;

      // ข้อมูลที่รู้ได้เฉพาะฝั่ง client ต้องล้างทุกครั้งที่เปิดใหม่
      // ไม่งั้นจะเอาขนาดไฟล์/ภาพของเอกสารใบก่อนมาโชว์
      //
      // FS-070 — ยกเว้นภาพที่บันทึกไว้แล้วในโหมดก่อนบันทึก ซึ่งหน้าแม่ยังถืออยู่
      //   โหมดนี้ (headerId = 0) server ยังไม่มีเอกสารให้ผูกภาพ ภาพนั้นจึงมีอยู่ที่นี่ที่เดียว
      //   ของเดิมล้างทิ้งทุกครั้ง → เปิดครั้งที่ 2 กรอบโชว์ภาพเก่า · ป้ายขึ้น "ค่าเริ่มต้นระบบ"
      //   · ปุ่มลบ (FS-064) ไม่โผล่ ทั้งที่เอกสารยังผูกกับภาพนั้นอยู่
      //   เก็บไว้เฉพาะเมื่อ attachedId ตรงกับที่หน้าแม่ส่งมา — ถ้าหน้าแม่ล้างภาพไปแล้ว ก็ล้างตาม
      var keepPending = !this.headerId && !!(row && row.attachedId) && row.attachedId === this.pendingAttachedId;
      this.clearClientOnlyInfo(keepPending);
      this.clearStagedFile();
      this.resetFileInput();

      if (this.$refs.modalRoot) {
        $(this.$refs.modalRoot).modal("show");
      }

      this.loadState();
    },

    close: function close() {
      if (this.$refs.modalRoot) {
        $(this.$refs.modalRoot).modal("hide");
      }
    },

    /**
     * ปุ่มหลักท้าย popup — ยืนยันว่าจะใช้ภาพที่เห็นอยู่กับเอกสารฉบับนี้
     * ภาพถูกอัพโหลดไปแล้วตั้งแต่ตอนเลือกไฟล์ (flow เดิม ไม่ได้เปลี่ยนเป็น 2 ขั้น)
     * ปุ่มนี้จึงแค่ส่งค่าให้หน้าแม่ซ้ำอีกครั้งเพื่อความแน่นอน แล้วปิด popup
     */
    applySelection: function applySelection() {
      // QA เรื่องที่ 14 — มีภาพใหม่รออยู่ ให้อัพโหลดตอนนี้ (ตอนเลือกไฟล์ยังไม่ได้อัพ)
      // upload() จะ emit ให้หน้าแม่และปิด popup ให้เองเมื่อสำเร็จ
      if (this.hasStagedDocument && this.stagedFile) {
        this.upload(this.stagedFile, 0, true);
        return;
      }

      if (!this.headerId) {
        // FS-017 — ส่ง url ของภาพกลับไปด้วย (อาร์กิวเมนต์ที่ 2) เพื่อให้หน้าแม่โชว์ thumbnail ได้
        // ผู้ฟังเดิมรับอาร์กิวเมนต์เดียว การเพิ่มท้ายจึงไม่กระทบใคร
        this.$emit("selected", this.pendingAttachedId || null, this.documentImageUrl || this.defaultImageUrl || "");
      }
      this.close();
    },

    // ── โหลดสถานะลายเซ็นทั้ง 2 แถบ ────────────────────────────────────────
    loadState: function loadState() {
      var self = this;
      self.loading = true;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Signature", { headerId: self.headerId }).then(function (response) {
        var data = response && response.data || {};

        if (!data.success) {
          Swal.fire("เกิดข้อผิดพลาด", data.message || "ไม่สามารถอ่านข้อมูลลายเซ็นได้", "error");
          return;
        }

        self.canManage = !!data.canManage;
        self.isMissingDefault = !!data.isMissingDefault;
        self.hasDocumentOverride = !!data.hasDocumentOverride;

        self.defaultAttachedId = data.defaultAttachedId || null;
        self.defaultImageUrl = data.defaultImageUrl || "";
        self.defaultFileName = data.defaultFileName || "";
        self.defaultUpdatedAt = data.defaultUpdatedAt || null;

        self.documentAttachedId = data.documentAttachedId || null;
        self.documentImageUrl = data.documentImageUrl || "";
        self.documentFileName = data.documentFileName || "";
        self.documentFileSize = 0;

        if (!self.headerId && self.pendingAttachedId) {
          // โหมดก่อนบันทึก — เพิ่งอัพโหลดไปในรอบนี้
          // API ยังไม่มีเอกสารให้ผูก จึงต้องโชว์ภาพที่ผู้ใช้เพิ่งเลือก ไม่ใช่ค่าเริ่มต้น
          self.documentAttachedId = self.pendingAttachedId;
          self.documentImageUrl = self.pendingObjectUrl || self.documentImageUrl;
          self.documentFileName = self.pendingFileName || self.documentFileName;
          self.documentFileSize = self.pendingFileSize || 0;
          self.hasDocumentOverride = true;
        } else if (!self.documentImageUrl && self.defaultImageUrl) {
          // เอกสารยังไม่เคยเลือกภาพเฉพาะกิจ → โชว์ค่าเริ่มต้นให้เห็นว่าจะได้ภาพไหน
          self.documentImageUrl = self.defaultImageUrl;
          self.documentFileName = self.defaultFileName;
          self.documentFileSize = self.defaultFileSize;
        }
      }).catch(function () {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถอ่านข้อมูลลายเซ็นได้ กรุณาลองใหม่อีกครั้ง", "error");
      }).then(function () {
        self.loading = false;
      });
    },

    // ── เลือกไฟล์ ─────────────────────────────────────────────────────────
    pickFile: function pickFile(scope) {
      if (!this.canManage || this.uploading) return;
      if (scope === "document" && this.isDocumentLocked) return;
      this.pendingScope = scope;
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },

    onFileChosen: function onFileChosen(event) {
      var input = event && event.target;
      var file = input && input.files && input.files.length ? input.files[0] : null;
      if (!file) return;

      // ใช้ "แถบที่เปิดอยู่ตอนไฟล์มาถึง" เป็นตัวตัดสิน ไม่ใช่แถบตอนที่กดปุ่ม
      //   input file ตัวเดียวใช้ร่วมกันทั้ง 2 แถบ ถ้าผู้ใช้กดปุ่มอัพโหลดแล้วสลับแถบ
      //   ก่อนเลือกไฟล์ (หน้าต่างเลือกไฟล์ของ OS ไม่ได้ล็อกหน้าจอ) ภาพจะไปเข้าแถบผิด
      //   แถบ 2 กระทบทั้งระบบ จึงต้องไม่พลาดเด็ดขาด
      //   ส่วนการลากไฟล์มาวางระบุแถบมาเองอยู่แล้วที่ onDrop()
      this.handleFile(file, this.activeTab === "default" ? "default" : "document");
    },

    // ── ลากไฟล์มาวาง (design ข้อ 9) ───────────────────────────────────────
    onDragOver: function onDragOver(scope) {
      if (!this.canManage || this.uploading) return;
      if (scope === "document" && this.isDocumentLocked) return;
      this.dragScope = scope;
    },

    onDragLeave: function onDragLeave() {
      this.dragScope = "";
    },

    onDrop: function onDrop(scope, event) {
      this.dragScope = "";

      if (!this.canManage || this.uploading) return;
      if (scope === "document" && this.isDocumentLocked) return;

      var transfer = event && event.dataTransfer;
      var file = transfer && transfer.files && transfer.files.length ? transfer.files[0] : null;
      if (!file) return;

      this.pendingScope = scope;
      this.handleFile(file, scope);
    },

    /**
     * ทางเข้าเดียวของทั้ง "เลือกไฟล์" และ "ลากมาวาง"
     *
     * QA 08/10/2026 เรื่องที่ 12/13/14 — ตรงนี้ "ไม่อัพโหลดแล้ว"
     * เลือกไฟล์ = พักไว้ให้ดู preview เท่านั้น ยังไม่ยิง API ยังไม่ emit ให้หน้าแม่
     * ผู้ใช้ต้องกดปุ่มบันทึกของแถบนั้นเองถึงจะมีผลจริง
     */
    handleFile: function handleFile(file, scope) {
      if (!this.validate(file)) {
        this.resetFileInput();
        return;
      }

      this.stageFile(file, scope);
      this.resetFileInput();
    },

    // เก็บไฟล์ที่เลือกไว้รอบันทึก + สร้าง object URL ไว้โชว์ preview
    stageFile: function stageFile(file, scope) {
      this.clearStagedFile();

      this.stagedFile = file;
      this.stagedScope = scope === "default" ? "default" : "document";
      this.stagedFileName = file.name || "";
      this.stagedFileSize = file.size || 0;

      if (window.URL && window.URL.createObjectURL) {
        this.stagedPreviewUrl = window.URL.createObjectURL(file);
      }
    },

    // ล้างภาพที่พักไว้ + คืน object URL (กันหน่วยความจำรั่วเมื่อเลือกหลายรอบ)
    clearStagedFile: function clearStagedFile() {
      if (this.stagedPreviewUrl && window.URL && window.URL.revokeObjectURL) {
        window.URL.revokeObjectURL(this.stagedPreviewUrl);
      }
      this.stagedFile = null;
      this.stagedScope = "";
      this.stagedPreviewUrl = "";
      this.stagedFileName = "";
      this.stagedFileSize = 0;
    },

    // ปุ่ม "เลือกภาพใหม่" ข้างแถบแจ้งเตือน — ทิ้งภาพที่พักไว้ กลับไปใช้ภาพเดิม
    discardStagedFile: function discardStagedFile() {
      this.clearStagedFile();
      this.resetFileInput();
    },

    validate: function validate(file) {
      var extension = getExtension(file.name);

      if (ALLOWED_EXTENSIONS.indexOf(extension) < 0) {
        Swal.fire("ชนิดไฟล์ไม่รองรับ", "กรุณาใช้ไฟล์ PNG หรือ JPG เท่านั้น", "warning");
        return false;
      }

      if (file.size > MAX_FILE_SIZE) {
        Swal.fire("ไฟล์ใหญ่เกินกำหนด", "ไฟล์มีขนาด " + formatBytes(file.size) + " ซึ่งเกิน 10 MB กรุณาย่อขนาดภาพก่อน", "warning");
        return false;
      }

      return true;
    },

    /**
     * ปุ่ม "บันทึกเป็นค่าเริ่มต้นระบบ →" ของแถบ 2 (QA เรื่องที่ 12)
     * spec บรรทัด 2873 — กดปุ่มนี้แล้วระบบต้องถามยืนยันซ้ำอีกครั้งก่อนบันทึกจริง
     */
    saveAsSystemDefault: function saveAsSystemDefault() {
      if (!this.canManage || this.uploading) return;

      if (!this.hasStagedDefault || !this.stagedFile) {
        Swal.fire("ยังไม่ได้เลือกภาพ", "กรุณาเลือกภาพลายเซ็นใหม่ก่อน แล้วตรวจดูในกรอบด้านบนให้เรียบร้อย", "info");
        return;
      }

      this.confirmThenUploadDefault(this.stagedFile);
    },

    // ── แถบ 2 ต้องยืนยันซ้ำก่อนบันทึก (spec) ──────────────────────────────
    confirmThenUploadDefault: function confirmThenUploadDefault(file) {
      var self = this;

      Swal.fire({
        title: "ยืนยันเปลี่ยนลายเซ็นค่าเริ่มต้นของระบบ",
        html: "ภาพนี้จะถูกใช้กับ<strong>ทุกเอกสาร</strong>ที่บันทึกหลังจากนี้ทั้งระบบ<br>" + "และไม่สามารถลบได้ เปลี่ยนได้ด้วยการอัพโหลดทับเท่านั้น<br><br>" + "ต้องการดำเนินการต่อหรือไม่",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยันเปลี่ยนค่าเริ่มต้น",
        cancelButtonText: "ยกเลิก",
        confirmButtonClass: "btn btn-danger",
        cancelButtonClass: "btn btn-secondary"
      }).then(function (result) {
        // SweetAlert2 v8 — ผลการยืนยันอยู่ที่ result.value
        if (result.value) {
          self.upload(file, 1);
        } else {
          self.resetFileInput();
        }
      });
    },

    /**
     * อัพโหลดจริง — เรียกจากปุ่มบันทึกของแต่ละแถบเท่านั้น ไม่ได้เรียกตอนเลือกไฟล์แล้ว
     *
     * @param scope       0 = เฉพาะเอกสารนี้ (แถบ 1) · 1 = ค่าเริ่มต้นระบบ (แถบ 2)
     * @param closeAfter  true = ปิด popup เมื่อสำเร็จ (ใช้กับปุ่มของแถบ 1)
     */
    upload: function upload(file, scope, closeAfter) {
      var self = this;

      var formData = new FormData();
      formData.append("file", file);
      formData.append("scope", scope);
      formData.append("headerId", self.headerId || 0);

      self.uploading = true;
      KTApp.block("#formSummaryStockSignatureModal .modal-content", {});

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Signature/Upload", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then(function (response) {
        var data = response && response.data || {};

        if (!data.success) {
          Swal.fire("ไม่สำเร็จ", data.message || "อัพโหลดไม่สำเร็จ", "error");
          return;
        }

        Swal.fire("สำเร็จ", data.message, "success");

        // ขนาดไฟล์รู้ได้เฉพาะจากไฟล์ที่ผู้ใช้เพิ่งเลือก — เก็บไว้โชว์ในกล่อง "ไฟล์ปัจจุบัน"
        if (scope === 1) {
          self.defaultFileSize = file.size;
        } else {
          self.documentFileSize = file.size;
        }

        // บันทึกแล้ว — ภาพไม่ได้ "รออยู่" อีกต่อไป ล้างสถานะพักไว้ทิ้ง
        self.clearStagedFile();

        // เอกสารที่ยังไม่ถูกบันทึก — ส่ง attachedId ให้หน้าแม่ถือไว้ใช้ตอนกดบันทึก
        //
        // QA เรื่องที่ 13 — จุดนี้คือจุดเดียวที่ thumbnail ของหน้าแม่จะเปลี่ยน
        // และมาถึงได้ก็ต่อเมื่อผู้ใช้กดปุ่มบันทึกแล้วเท่านั้น
        if (scope === 0 && !self.headerId) {
          self.rememberPendingImage(file, data.attachedId || null);
          // FS-017 — ภาพที่เพิ่งเลือกยังไม่มี signed URL จาก server จึงส่ง object URL ในเครื่องไปก่อน
          self.$emit("selected", data.attachedId || null, self.pendingObjectUrl || self.documentImageUrl || "");
        }

        self.loadState();
        self.$emit("changed");

        if (closeAfter) self.close();
      }).catch(function () {
        Swal.fire("เกิดข้อผิดพลาด", "อัพโหลดภาพลายเซ็นไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
      }).then(function () {
        self.uploading = false;
        self.resetFileInput();
        KTApp.unblock("#formSummaryStockSignatureModal .modal-content");
      });
    },

    // ปุ่มแดงในแถบ 1 ทำสองหน้าที่ตามสถานะ — ภาพยังพักอยู่ = "ยกเลิกภาพที่เลือก"
    // ส่วนภาพที่บันทึกไว้แล้ว = "ลบภาพเฉพาะเอกสารนี้" ซึ่งต้องถามยืนยันก่อน
    removeOrDiscardDocument: function removeOrDiscardDocument() {
      if (this.hasStagedDocument) {
        this.discardStagedFile();
        return;
      }
      this.removeDocumentSignature();
    },

    // ── ลบภาพเฉพาะกิจ (แถบ 1 เท่านั้น) ────────────────────────────────────
    removeDocumentSignature: function removeDocumentSignature() {
      var self = this;

      if (!self.headerId) {
        // ยังไม่บันทึก — แค่ล้างค่าที่หน้าแม่ถือไว้ ไม่ต้องเรียก API
        self.clearPendingImage();
        self.documentAttachedId = null;
        self.hasDocumentOverride = false;
        self.documentImageUrl = self.defaultImageUrl;
        self.documentFileName = self.defaultFileName;
        self.documentFileSize = self.defaultFileSize;
        // FS-017 — ล้างภาพเฉพาะกิจแล้ว เอกสารจะกลับไปใช้ลายเซ็นค่าเริ่มต้นของระบบ
        self.$emit("selected", null, self.defaultImageUrl || "");
        return;
      }

      Swal.fire({
        title: "ยืนยันลบลายเซ็นเฉพาะเอกสารนี้",
        text: "เอกสารฉบับนี้จะกลับไปใช้ลายเซ็นค่าเริ่มต้นของระบบ",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ยืนยันลบ",
        cancelButtonText: "ยกเลิก",
        confirmButtonClass: "btn btn-danger",
        cancelButtonClass: "btn btn-secondary"
      }).then(function (result) {
        if (!result.value) return;

        KTApp.block("#formSummaryStockSignatureModal .modal-content", {});

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/FormSummaryStock/Signature/Delete", { headerId: self.headerId }).then(function (response) {
          var data = response && response.data || {};

          if (!data.success) {
            Swal.fire("ไม่สำเร็จ", data.message || "ลบไม่สำเร็จ", "error");
            return;
          }

          Swal.fire("สำเร็จ", data.message, "success");
          self.loadState();
          self.$emit("changed");
        }).catch(function () {
          Swal.fire("เกิดข้อผิดพลาด", "ลบลายเซ็นไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
        }).then(function () {
          KTApp.unblock("#formSummaryStockSignatureModal .modal-content");
        });
      });
    },

    // ── ข้อมูลที่อ่านได้เฉพาะฝั่ง client (design ข้อ 5 · 6) ────────────────
    onImageLoad: function onImageLoad(scope, event) {
      var image = event && event.target;
      if (!image) return;

      if (scope === "default") {
        this.defaultImageWidth = image.naturalWidth || 0;
        this.defaultImageHeight = image.naturalHeight || 0;
      } else {
        this.documentImageWidth = image.naturalWidth || 0;
        this.documentImageHeight = image.naturalHeight || 0;
      }
    },

    zoom: function zoom(url) {
      if (url) this.zoomImageUrl = url;
    },

    closeZoom: function closeZoom() {
      this.zoomImageUrl = "";
    },

    /**
     * โหมดก่อนบันทึก — จำภาพที่เพิ่งอัพโหลดไว้เอง
     * ใช้ object URL ของไฟล์ที่ผู้ใช้เลือก เพราะ API คืน documentImageUrl ให้ไม่ได้
     * (เอกสารยังไม่มีแถวใน DB ให้ผูก AttachedId)
     */
    rememberPendingImage: function rememberPendingImage(file, attachedId) {
      this.revokePendingObjectUrl();
      this.pendingAttachedId = attachedId;
      this.pendingFileName = file ? file.name : "";
      this.pendingFileSize = file ? file.size : 0;
      this.pendingObjectUrl = file && window.URL && window.URL.createObjectURL ? window.URL.createObjectURL(file) : "";
    },

    clearPendingImage: function clearPendingImage() {
      this.revokePendingObjectUrl();
      this.pendingAttachedId = null;
      this.pendingFileName = "";
      this.pendingFileSize = 0;
    },

    // object URL กินหน่วยความจำจนกว่าจะ revoke — ปล่อยทุกครั้งที่เลิกใช้ภาพนั้น
    revokePendingObjectUrl: function revokePendingObjectUrl() {
      if (this.pendingObjectUrl && window.URL && window.URL.revokeObjectURL) {
        window.URL.revokeObjectURL(this.pendingObjectUrl);
      }
      this.pendingObjectUrl = "";
    },

    clearClientOnlyInfo: function clearClientOnlyInfo(keepPending) {
      // FS-070 — keepPending = true ห้ามล้างภาพที่บันทึกไว้ และห้าม revoke object URL
      //   เพราะ thumbnail บนปุ่มของหน้าแม่ใช้ URL เดียวกันนี้อยู่ revoke ไปภาพหน้าแม่จะแตก
      if (!keepPending) this.clearPendingImage();
      this.documentFileSize = 0;
      this.documentImageWidth = 0;
      this.documentImageHeight = 0;
      this.defaultFileSize = 0;
      this.defaultImageWidth = 0;
      this.defaultImageHeight = 0;
    },

    // input file เดิมถือไฟล์เก่าไว้ — ถ้าไม่ล้าง เลือกไฟล์ชื่อเดิมซ้ำจะไม่ยิง change
    resetFileInput: function resetFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    }
  },
  mounted: function mounted() {
    var self = this;

    // QA เรื่องที่ 13 — ปิด popup ด้วยปุ่ม × หรือ "ยกเลิก" ต้องทิ้งภาพที่เลือกไว้
    // ปุ่มสองตัวนั้นใช้ data-dismiss ของ Bootstrap จึงไม่ผ่าน close() ของเรา
    // ต้องดักที่ event ของ modal เองถึงจะครอบทุกทางออก (รวมกด ESC และคลิกนอกกรอบ)
    if (this.$refs.modalRoot) {
      $(this.$refs.modalRoot).on("hidden.bs.modal", function () {
        self.clearStagedFile();
        self.resetFileInput();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$refs.modalRoot) {
      $(this.$refs.modalRoot).off("hidden.bs.modal");
    }
    this.clearStagedFile();
    this.revokePendingObjectUrl();
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FormSummaryStockSignaturePdfPreview",
  props: {
    src: { type: String, default: "" },
    alt: { type: String, default: "" },
    emptyText: { type: String, default: "ยังไม่มีภาพลายเซ็น" },
    testId: { type: String, default: "" }
  },
  data: function data() {
    return {
      // เส้นจุดของฟอร์มเป็นตัวอักษร "." — วาดยาวเกินแล้วตัดที่ความกว้างจริง (121.4 pt)
      //   ฟอนต์บนเว็บไม่ใช่ Singha Water TH ความกว้างของจุดจึงต่างกันเล็กน้อย
      dots: new Array(120).join(".")
    };
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      modalImageURL: '',
      chdCheckInDate: null,
      chdFullname: null,
      chdShopName: null,
      chdShopName2: null,
      chdTotalScore: null,
      chdCheckInBarcodes: null,
      chdSurveys: null,
      chdQuestions: null,
      chdChoices: null,
      chdCheckInItemId: null,
      chdCheckOutDate: null,
      chdCheckOutFullname: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/QICheckIn/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  //console.log(response.data);
                  if (response.data != null) {
                    self.chdCheckInDate = response.data.checkInDateFormat;
                    self.chdFullname = response.data.checkInByUserFullName;
                    if (response.data.shopTypeCode == "SUB_AGENT") {
                      self.chdShopName = response.data.subAgentShopName;
                      self.chdShopName2 = response.data.subAgentShopName2;
                    } else {
                      self.chdShopName = response.data.shopName;
                      self.chdShopName2 = response.data.shopName2;
                    }

                    self.chdTotalScore = response.data.totalScore;
                    self.chdCheckInBarcodes = response.data.checkInBarcodes;
                    self.chdSurveys = response.data.surveyItems;
                    self.chdCheckInItemId = response.data.checkInItemId;
                    self.chdCheckOutDate = response.data.checkOutDateFormat;
                    self.chdCheckOutFullname = response.data.checkOutByUserFullName;
                    self.buildDisplayQuestions();
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลการเช็คอินร้านค้าคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการเช็คอินร้านค้าได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/QICheckIn/MaintenanceSurvey").then(function (response) {
                if (response.status == 200) {
                  //console.log(response.data);
                  if (response.data != null) {
                    self.chdQuestions = response.data.questions;
                    self.chdChoices = self.chdQuestions[0].choices;
                    self.buildDisplayQuestions();
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดึงข้อมูลแบบสอบถามได้", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลแบบสอบถามได้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    showModal: function showModal(imageURL) {
      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', function () {
        $('body').addClass('modal-open');
      });
    },
    closeModal: function closeModal() {
      $('#imageModal').modal('hide');
    },
    showDispenserProductBrands: function showDispenserProductBrands(items) {
      var text = "";
      //console.log(items);
      if (items != null && items.length > 0) {
        for (var i = 0; i < items.length; i++) {
          text += "[" + items[i].productBrandId + "] " + items[i].productBrandName;
          if (i != items.length - 1) text += ", ";
        }
      }
      return text;
    },

    // CR-1: สร้าง question rows จาก survey items จริง (รองรับ transaction เก่าที่มีหัวข้อถูก soft delete)
    buildDisplayQuestions: function buildDisplayQuestions() {
      if (!this.chdSurveys || this.chdSurveys.length === 0 || !this.chdQuestions || !this.chdChoices) return;

      // Build map of master data questions by code
      var masterMap = {};
      for (var i = 0; i < this.chdQuestions.length; i++) {
        masterMap[this.chdQuestions[i].code] = this.chdQuestions[i];
      }

      // Extract unique question codes from survey items (in submission order)
      var seenCodes = {};
      var surveyQuestionCodes = [];
      for (var i = 0; i < this.chdSurveys.length; i++) {
        var code = this.chdSurveys[i].questionCode;
        if (!seenCodes[code]) {
          seenCodes[code] = true;
          surveyQuestionCodes.push({
            code: code,
            text: this.chdSurveys[i].questionText
          });
        }
      }

      // Check if all survey codes exist in master data
      var hasMissingCodes = false;
      for (var i = 0; i < surveyQuestionCodes.length; i++) {
        if (!masterMap[surveyQuestionCodes[i].code]) {
          hasMissingCodes = true;
          break;
        }
      }

      // If all codes exist in master data, keep master data order (new transaction)
      if (!hasMissingCodes) return;

      // Old transaction: rebuild questions from survey items
      var displayQuestions = [];
      for (var i = 0; i < surveyQuestionCodes.length; i++) {
        var sq = surveyQuestionCodes[i];
        if (masterMap[sq.code]) {
          // Use master data version (has correct choices + isRequiredPicture)
          displayQuestions.push(masterMap[sq.code]);
        } else {
          // Construct question from survey item snapshot
          var choices = [];
          for (var j = 0; j < this.chdChoices.length; j++) {
            var c = this.chdChoices[j];
            choices.push({
              code: c.code,
              text: c.text,
              order: c.order,
              point: c.point,
              isRequiredPicture: false
            });
          }
          displayQuestions.push({
            code: sq.code,
            text: sq.text,
            order: 0,
            choices: choices
          });
        }
      }

      this.chdQuestions = displayQuestions;
    },
    pictureModal: function pictureModal(fileUrl) {
      var self = this;
      var router = this.$router;
      //console.log(fileUrl);
      if (fileUrl != null) {
        router.push({
          path: "/QC/QCCheckIn/Detail/" + self.chdCheckInItemId + "/Picture/" + encodeURIComponent(fileUrl)
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาคลิก Link", "error");
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"detailCheckIn\" v-if=\"data.showDetailButton\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\">\n      <i class=\"la la-file-text\"></i>\n    </a>\n  </div>",
  methods: {
    detailCheckIn: function detailCheckIn() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/QC/QCCheckIn/Detail/" + this.data.checkInItemId
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      chlKeyword: null,
      chlCheckInDate: null,
      chlShopIds: [],
      chlShopIdsOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/QCFilterShopOption",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },

      chlSubShopIds: [],
      chlSubShopIdsOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/QCFilterSubShopOption",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1,
              ParentShopCodes: self.chlShopIds || []
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }

    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.chlKeyword = null;
      self.chlCheckInDate = null;

      $("#chlCheckInDate").val("").trigger("change");

      $("#chlShopIds").val("").trigger("change");

      $("#chlSubShopIds").val("").trigger("change");

      self.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#checkInTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#checkInTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.chlCheckInDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.chlCheckInDate).on("changeDate", function (e) {
                self.chlCheckInDate = moment(e.date);
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#checkInTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/QICheckIn/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    //check for clear date value
                    var idDate = $("#chlCheckInDate").val();
                    if (idDate == null || idDate == "") self.chlCheckInDate = null;

                    var jsonSearch = {
                      SearchKeyword: self.chlKeyword,
                      CheckInDate: self.chlCheckInDate != null ? self.chlCheckInDate.format("DD/MM/YYYY") : self.chlCheckInDate,
                      ShopIds: self.chlShopIds,
                      SubShopIds: self.chlSubShopIds
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "desc"]],
                columns: [{
                  data: "checkInDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.checkInDateFormat;
                  }
                }, { data: "checkInByUserFullName", className: "text-center" }, {
                  data: "totalScore",
                  className: "text-center"
                }, {
                  data: "shopTypeCode",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.shopTypeCode == "AGENT" ? "ร้านค้าตัวแทนจำหน่าย" : "ร้านค้าตัวแทนจำหน่ายย่อย";
                  }
                }, { data: "displayShopName", className: "text-center" }, { data: "displayShopName2", className: "text-center" }, {
                  data: "checkInItemId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_5__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  //console.log(data);
                  if (data && data.checkInItemId) {
                    data.showDetailButton = self.$root.canShow(["ADMIN_QI", "MANAGER_QI", "USER_QI"]);
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });
              //table.trigger("draw.dt"); //call ajax delete this row

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;


              $("#PictureModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                //self.$parent.reloadDataTable(false);
              }).modal("show");

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      qiJobId: null,
      qiJobNumber: null,
      qiTypeCode: '',
      qiSubType: 0,
      qiStatusName: null,
      qiAreaPlant: true,
      agentCodeSap: '',
      agentName: '',
      createdDate: null,
      createdUserName: null,
      finishedDate: null,
      confirmedDate: null,
      confirmedUserName: null,
      qiTypeName: null,
      barcodeNoOld: null,
      materialNameShow: null,
      qiSubProductType: null,
      amount: null,
      showBarcodeBtn: false,
      showFormMachine: false,
      showFormEquipment: false,
      showFormDrawback: false,
      showFormRepair: false,
      evalData: {
        evalMach1: null,
        evalMach2: null,
        evalMach3: null,
        evalMach4: null,
        evalMach5: null,
        evalRemark: null,
        evalEqpt1: null,
        evalEqpt2: null,
        evalEqpt3: null,
        evalFlag: null
      },
      items: [],
      services: [],
      pictures: [],
      modalImageURL: '',
      tableName: '',
      tableFormData: [],
      tableDataRepair: [],
      remark: '',
      isUnrepair: false,
      UnrepairRemark: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context3.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context3.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/QIJobs/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  //console.log(response.data);
                  if (response.data != null) {
                    self.qiJobId = response.data.qiJobId;
                    self.isUnrepair = response.data.isUnrepair;
                    self.UnrepairRemark = response.data.unrepairRemark;
                    self.qiJobNumber = response.data.qiJobNumber ? "\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48\u0E43\u0E1A\u0E07\u0E32\u0E19 : " + response.data.qiJobNumber : '';
                    self.qiTypeCode = response.data.qiTypeCode;
                    self.qiSubType = response.data.qiSubType;
                    self.agentCodeSap = response.data.agentCodeSap;
                    self.agentName = response.data.agentName;

                    var qiStatusCode = response.data.qiStatusCode;
                    var evalFlag = response.data.formData ? response.data.formData.evalFlag : null;;
                    var statusIcon = '';
                    var statusText = self.qiStatusName = response.data.qiStatusName;
                    if (qiStatusCode == "JOB_QI_STATUS_PENDING") {
                      statusIcon = '<i class="fa fa-sync-alt"></i>';
                    } else if (qiStatusCode == "JOB_QI_STATUS_SUCCESS") {
                      statusIcon = '<i class="fa fa-check-circle"></i>';
                      if (evalFlag === 1) {
                        statusText += ' <span class="text-danger">(ซ่อมไม่ได้)</span>';
                      } else if (evalFlag === 2) {
                        statusText += ' <span class="text-success">(ซ่อมได้)</span>';
                      } else if (evalFlag === 3) {
                        statusText += ' <span class="text-warning">(ไม่เสีย)</span>';
                      }
                    } else if (qiStatusCode == "JOB_QI_STATUS_REQUEST_APPROVAL") {
                      statusIcon = '<i class="fa fa-file-signature"></i>';
                    } else if (qiStatusCode == "JOB_QI_STATUS_REPAIR_COMPLETED") {
                      statusIcon = '<i class="fa fa-check"></i>';
                    } else if (qiStatusCode == "JOB_QI_STATUS_CANCEL") {
                      statusIcon = '<i class="fa fa-ban text-danger"></i>';
                    }
                    self.qiStatusName = statusIcon + ' ' + statusText;

                    self.createdDate = response.data.createdDateFormat ? response.data.createdDateFormat : '-';
                    self.createdUserName = response.data.createdUserName ? response.data.createdUserName : '-';
                    self.finishedDate = response.data.finishedDate && response.data.finishedUserId != null ? self.setDateFormat(response.data.finishedDate, true) : '-';
                    self.confirmedDate = response.data.confirmedDate ? self.setDateFormat(response.data.confirmedDate, true) : '-';
                    self.confirmedUserName = response.data.confirmedUserName ? response.data.confirmedUserName : '-';

                    var additionalText = '';
                    if (response.data.qiTypeCode === "JOB_QI_TYPE_DRAWBACK" && response.data.finishedDate != null) {
                      if (response.data.qiSubType === 1) {
                        additionalText = ' <span>(เบิก)</span>';
                      } else {
                        additionalText = ' <span>(คืน)</span>';
                      }
                    }
                    self.qiTypeName = response.data.qiTypeName ? response.data.qiTypeName + additionalText : '-';

                    self.barcodeNoOld = response.data.barcodeNoOld ? response.data.barcodeNoOld : '-';
                    self.materialNameShow = response.data.materialNameShow ? response.data.materialNameShow : '-';
                    self.qiAreaPlant = response.data.qiAreaPlant;

                    var qiSubProductType = response.data.qiSubProductType ? response.data.qiSubProductType : 0;
                    if (qiSubProductType == 5) {
                      self.showBarcodeBtn = true;
                    }
                    self.amount = response.data.amount ? response.data.amount : '-';

                    // แบบฟอร์มแยกแต่ละประเภท,ประเภทย่อยของใบงาน
                    if (response.data.qiTypeCode === "JOB_QI_TYPE_EVALUATE" && response.data.finishedDate != null) {
                      if (response.data.qiSubType === 1) {
                        self.showFormMachine = true;
                        self.showFormEquipment = false;
                      } else {
                        self.showFormMachine = false;
                        self.showFormEquipment = true;
                      }
                      if (response.data.formData) {
                        self.evalData.evalMach1 = response.data.formData.evalMach1;
                        self.evalData.evalMach2 = response.data.formData.evalMach2;
                        self.evalData.evalMach3 = response.data.formData.evalMach3;
                        self.evalData.evalMach4 = response.data.formData.evalMach4;
                        self.evalData.evalMach5 = response.data.formData.evalMach5;
                        self.evalData.evalEqpt1 = response.data.formData.evalEqpt1;
                        self.evalData.evalEqpt2 = response.data.formData.evalEqpt2;
                        self.evalData.evalEqpt3 = response.data.formData.evalEqpt3;
                        self.evalData.evalFlag = response.data.formData.evalFlag;
                        self.evalData.evalRemark = response.data.formData.evalRemark;
                      }
                    } else if (response.data.qiTypeCode === "JOB_QI_TYPE_DRAWBACK" && response.data.finishedDate != null) {
                      self.showFormDrawback = true;
                    } else if (response.data.qiTypeCode === "JOB_QI_TYPE_REPAIR" && response.data.finishedDate != null) {
                      self.showFormRepair = true;
                      self.qiSubProductType = response.data.qiSubProductType;
                      if (response.data.formData) {
                        self.remark = response.data.formData.remark;
                        self.setTableData(response.data.qiSubType, response.data.qiSubProductType, response.data.formData);
                      }

                      //if (response.data.picture && typeof response.data.picture !== 'undefined' && response.data.picture.length > 0) {
                      //  async function loadPictures() {
                      //    response.data.picture.map(async (element) => {
                      //      self.pictures.push({
                      //        fileInfoId: element.fileInfoId,
                      //        downloadUrl: element.downloadUrl
                      //      });
                      //    });
                      //  }
                      //  loadPictures();
                      //}
                    }

                    //=== set pictures ===
                    if (response.data.picture && typeof response.data.picture !== 'undefined' && response.data.picture.length > 0) {
                      var loadPictures = function () {
                        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                          var _this2 = this;

                          return regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  response.data.picture.map(function () {
                                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(element) {
                                      return regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1) {
                                          switch (_context.prev = _context.next) {
                                            case 0:
                                              self.pictures.push({
                                                fileInfoId: element.fileInfoId,
                                                downloadUrl: element.downloadUrl
                                              });

                                            case 1:
                                            case "end":
                                              return _context.stop();
                                          }
                                        }
                                      }, _callee, _this2);
                                    }));

                                    return function (_x) {
                                      return _ref2.apply(this, arguments);
                                    };
                                  }());

                                case 1:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2, this);
                        }));

                        return function loadPictures() {
                          return _ref.apply(this, arguments);
                        };
                      }();

                      loadPictures();
                    }

                    //response.data.picture.forEach((element) => {
                    //    self.pictures.push({
                    //        fileInfoId: element.fileInfoId,
                    //        downloadUrl: element.downloadUrl
                    //    });
                    //});


                    if (response.data.items && Array.isArray(response.data.items)) {
                      if (response.data.qiTypeCode == "JOB_QI_TYPE_DRAWBACK") {
                        self.amount = response.data.items.reduce(function (total, item) {
                          return total + item.quantity;
                        }, 0);
                      }
                      self.items = response.data.items;
                    }
                    if (response.data.services && Array.isArray(response.data.services)) {
                      self.services = response.data.services;
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลใบงานช่างซ่อมคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลใบงานช่างซ่อมได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }))();
  },

  methods: {
    showModal: function showModal(imageURL) {
      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', function () {
        $('body').addClass('modal-open');
      });
    },
    closeModal: function closeModal() {
      $('#imageModal').modal('hide');
    },
    showDispenserProductBrands: function showDispenserProductBrands(items) {
      var text = "";
      //console.log(items);
      if (items != null && items.length > 0) {
        for (var i = 0; i < items.length; i++) {
          text += "[" + items[i].productBrandId + "] " + items[i].productBrandName;
          if (i != items.length - 1) text += ", ";
        }
      }
      return text;
    },
    setDateFormat: function setDateFormat(dateStr) {
      var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        calendar: 'gregory'
      };
      if (includeTime) {
        options = _extends({}, options, {
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      var dateStrFormat = new Date(dateStr).toLocaleDateString('th-TH', options);
      return dateStrFormat;
    },
    setTableData: function setTableData(qiSubType, qiSubProductType, formData) {
      var self = this;
      if (qiSubType === 1) {
        self.tableName = 'การตรวจเช็คเครื่องทำความเย็นเบียร์สด :';
        self.tableDataRepair = [{ item: 'ตรวจเช็ค ความสมบูรณ์ ภายนอกตัวเครื่อง', result: formData.mach1, remark: formData.machRemark1 }, { item: 'ตรวจเช็ค ความสมบูรณ์ของ เอจิเตเตอร์', result: formData.mach2, remark: formData.machRemark2 }, { item: 'ตรวจเช็ค ความสมบูรณ์ของ คอมเพรสเซอร์', result: formData.mach3, remark: formData.machRemark3 }, { item: 'ตรวจเช็ค ความสมบูรณ์ของ ระบบสายไฟ', result: formData.mach4, remark: formData.machRemark4 }, { item: 'ตรวจเช็ค ความสมบูรณ์ของ ระบบน้ำยาหล่อลื่น', result: formData.mach5, remark: formData.machRemark5 }, { item: 'ตรวจเช็ค ความสมบูรณ์ของ ระบบระบายความร้อน', result: formData.mach6, remark: formData.machRemark6 }, { item: 'ตรวจเช็ค ความสมบูรณ์ของ วอเตอร์บาศก์', result: formData.mach7, remark: formData.machRemark7 }, { item: 'ตรวจเช็ค ความสมบูรณ์ของ เทอร์โมสตัท', result: formData.mach8, remark: formData.machRemark8 }];

        self.tableFormData = [{ label: "ถอดประกอบ แยก ชิ้นส่วนอุปกรณ์ ออกจากกัน จุดวางชิ้นส่วนที่ถอดประกอบจุดที่", variable: formData.mach9 || '-' }, { label: "ทำความสะอาดเพื่อหาร่องรอยอาการเสีย", variable: formData.mach10 ? "\u0E08\u0E38\u0E14\u0E25\u0E49\u0E32\u0E07\u0E17\u0E35\u0E48 " + formData.mach10 : '-' }, { label: "เปลี่ยนอะไหล่ เติมสารเคมี ทำสี", variable: formData.mach11 || formData.mach12 ? "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E19\u0E49\u0E33\u0E22\u0E32 " + (formData.mach11 || '-') + " \u0E41\u0E23\u0E07\u0E14\u0E31\u0E19 " + (formData.mach12 || '-') + " PSI" : '-' }, { label: "ประกอบชิ้นส่วนอุปกรณ์กลับ", variable: formData.mach13 != null ? formData.mach13 == 1 || formData.mach13 == '1' ? 'ครบ' : 'ไม่ครบ' : '-' }, { label: "การทำความสะอาดเพื่อรอส่งชิ้นงาน", variable: formData.mach14 != null ? formData.mach14 == 1 || formData.mach14 == '1' ? 'ทำแล้ว' : 'ยังไม่ได้ทำ' : '-' }, { label: "ทดสอบประสิทธิภาพของอุปกรณ์เต็มรูปแบบ ตรวจสอบความสมบูรณ์ของอุปกรณ์", variable: formData.machTimeStart && formData.machTimeEnd && formData.machTime ? "\u0E40\u0E2A\u0E35\u0E22\u0E1A\u0E1B\u0E25\u0E31\u0E4A\u0E01\u0E15\u0E31\u0E49\u0E07\u0E41\u0E15\u0E48\u0E40\u0E27\u0E25\u0E32 " + formData.machTimeStart + " - " + formData.machTimeEnd + "<br>\u0E23\u0E27\u0E21\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32 " + formData.machTime + " \u0E19\u0E32\u0E17\u0E35" : '-' }, { label: "การหีบห่ออุปกรณ์ และรับประกันงานซ่อม", variable: formData.mach15 != null ? formData.mach15 ? 'ซีลม้วนพลาสติก' : '-' : '-' }, { label: "การส่งอุปกรณ์ซ่อมเสร็จ กลับคลังสินค้า วันที่รับประกัน", variable: formData.machGuaranteeDate ? self.setDateFormat(formData.machGuaranteeDate) : '-' }];
      } else {
        if (qiSubProductType === 1) {
          self.tableName = 'การตรวจเช็คหัวจั้ม :';
          self.tableDataRepair = [{ item: 'ตรวจเช็ค ความสมบูรณ์ ตัวแกนหัวจัมพ์', result: formData.eqptJump1, remark: formData.eqptRemarkJump1 }, { item: 'ตรวจเช็ค ความสมบูรณ์ ลูกยางหัวจัมพ์', result: formData.eqptJump2, remark: formData.eqptRemarkJump2 }];
        } else if (qiSubProductType === 2) {
          self.tableName = 'การตรวจเช็คเรคกูเรเตอร์';
          self.tableDataRepair = [{ item: 'ตรวจเช็ค ความสมบูรณ์ ภายนอกเกจวัดแรงดัน', result: formData.eqptGauge1, remark: formData.eqptRemarkGauge1 }, { item: 'ตรวจเช็ค ความสมบูรณ์ อุปกรณ์พ่วงต่อเกจวัดแรงดันCO2', result: formData.eqptGauge2, remark: formData.eqptRemarkGauge2 }];
        } else if (qiSubProductType === 3) {
          self.tableName = 'การตรวจเช็ควาล์ว :';
          self.tableDataRepair = [{ item: 'ตรวจเช็ค ความสมบูรณ์ ตัวแกนวาล์ว', result: formData.eqptValve1, remark: formData.eqptRemarkValve1 }, { item: 'ตรวจเช็ค ความสมบูรณ์ ลูกยางวาล์ว', result: formData.eqptValve2, remark: formData.eqptRemarkValve2 }];
        } else if (qiSubProductType === 4) {
          self.tableName = 'การตรวจเช็คคอยล์ :';
          self.tableDataRepair = [{ item: 'ตรวจเช็ค ความสมบูรณ์ ภายนอกคอยล์', result: formData.eqptCoil1, remark: formData.eqptRemarkCoil1 }];
        } else if (qiSubProductType === 5) {
          self.tableName = 'การตรวจเช็คหัวจ่ายเบียร์สด :';
          self.tableDataRepair = [{ item: 'ตรวจเช็ค ความสมบูรณ์ ภายนอกหัวจ่าย', result: formData.eqptDisp1, remark: formData.eqptRemarkDisp1 }, { item: 'ตรวจเช็ค ความสมบูรณ์ของ แกนน้ำเบียร์', result: formData.eqptDisp2, remark: formData.eqptRemarkDisp2 }];
        }

        self.tableFormData = [{ label: "ถอดประกอบ แยก ชิ้นส่วนอุปกรณ์ ออกจากกัน จุดวางชิ้นส่วนที่ถอดประกอบจุดที่", variable: formData.eqpt1 || '-' }, { label: "ทำความสะอาดเพื่อหาร่องรอยอาการเสีย", variable: formData.eqpt2 ? "\u0E08\u0E38\u0E14\u0E25\u0E49\u0E32\u0E07\u0E17\u0E35\u0E48 " + formData.eqpt2 : '-' }, { label: "เปลี่ยนอะไหล่", variable: formData.eqpt3 == 1 ? 'ปกติ' : formData.eqpt3 == null ? '-' : 'เสื่อมสภาพ' }, { label: "ประกอบชิ้นส่วนอุปกรณ์กลับ", variable: formData.eqpt4 == null ? '-' : formData.eqpt4 == 1 || formData.eqpt4 == '1' ? 'ครบ' : 'ไม่ครบ' }, { label: "การทำความสะอาดเพื่อรอส่งชิ้นงาน", variable: formData.eqpt5 == null ? '-' : formData.eqpt5 == 1 || formData.eqpt5 == '1' ? 'ทำแล้ว' : 'ยังไม่ได้ทำ' }, { label: "ทดสอบประสิทธิภาพของอุปกรณ์เต็มรูปแบบ ตรวจสอบความสมบูรณ์ของอุปกรณ์", variable: formData.eqptTimeStart && formData.eqptTimeEnd && formData.eqptTime ? "\u0E40\u0E2A\u0E35\u0E22\u0E1A\u0E1B\u0E25\u0E31\u0E4A\u0E01\u0E15\u0E31\u0E49\u0E07\u0E41\u0E15\u0E48\u0E40\u0E27\u0E25\u0E32 " + formData.eqptTimeStart + " - " + formData.eqptTimeEnd + "<br>\u0E23\u0E27\u0E21\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32 " + formData.eqptTime + " \u0E19\u0E32\u0E17\u0E35" : '-' }, { label: "การหีบห่ออุปกรณ์", variable: formData.eqpt6 == 1 ? 'ปิดผนึกถุงพลาสติก' : formData.eqpt6 == null ? '-' : 'ลงกล่องเก็บอุปกรณ์' }, { label: "วันที่รับประกัน", variable: formData.eqptGuaranteeDate ? self.setDateFormat(formData.eqptGuaranteeDate) : '-' }];
      }
    },
    showBarcodesModal: function showBarcodesModal(qiJobId) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/QIJobs/BarcodesInfo/" + qiJobId).then(function (response) {
        var barcodes = response.data;
        var tableData = barcodes.map(function (barcode, index) {
          return {
            index: index + 1,
            barcodeNoOld: barcode.barcodeNoOld || '-'
          };
        });

        $(_this3.$refs.barcodeLocalTable).DataTable({
          data: tableData,
          language: { search: "ค้นหา", searchPlaceholder: "BARCODE" },
          columns: [{ data: 'index', className: 'text-center' }, { data: 'barcodeNoOld', className: 'text-center' }],
          destroy: true
        });

        $(_this3.$refs.barcodesModal).modal('show');
      }).catch(function (error) {
        console.error('Error fetching barcodes:', error);
      });
    }
  },
  computed: {
    totalQuantity: function totalQuantity() {
      return this.items.reduce(function (sum, item) {
        return sum + (item.quantity || 0);
      }, 0);
    },
    totalQuantityService: function totalQuantityService() {
      return this.services.reduce(function (sum, item) {
        return sum + (item.quantity || 0);
      }, 0);
    },
    totalValue: function totalValue() {
      return this.items.reduce(function (sum, item) {
        return sum + item.quantity * item.unitPrice;
      }, 0);
    },
    totalValueService: function totalValueService() {
      return this.services.reduce(function (sum, item) {
        return sum + item.quantity * item.unitPrice;
      }, 0);
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      qiJobId: null,
      qiJobNumber: null,
      qiStatusCode: null,
      qiTypeCode: '',
      qiSubType: 0,
      qiStatusName: null,
      qiAreaPlant: true,
      createdDate: null,
      createdUserName: null,
      finishedDate: null,
      confirmedDate: null,
      confirmedUserName: null,
      qiTypeName: null,
      amount: null,
      items: [],
      originalOptions: [],
      materialCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true
      },
      errors: [],
      isDisable: true,
      pictures: [],
      modalImageURL: '',
      isFromImageModal: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, router, user, response, qiStatusCode, statusIcon, statusText, additionalText, loadPictures;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context3.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context3.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              _context3.prev = 6;
              _context3.next = 9;
              return self.loadMaterialOptions();

            case 9:
              _context3.next = 11;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/QIJobs/" + _this.$route.params.id);

            case 11:
              response = _context3.sent;

              if (!(response.status === 200 && response.data)) {
                _context3.next = 38;
                break;
              }

              self.qiJobId = response.data.qiJobId;
              self.qiJobNumber = response.data.qiJobNumber ? "\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48\u0E43\u0E1A\u0E07\u0E32\u0E19 : " + response.data.qiJobNumber : '';
              self.qiTypeCode = response.data.qiTypeCode;
              self.qiSubType = response.data.qiSubType;

              qiStatusCode = response.data.qiStatusCode;
              statusIcon = '';
              statusText = self.qiStatusName = response.data.qiStatusName;

              if (qiStatusCode === "JOB_QI_STATUS_PENDING") {
                statusIcon = '<i class="fa fa-sync-alt"></i>';
              } else if (qiStatusCode === "JOB_QI_STATUS_REQUEST_APPROVAL") {
                statusIcon = '<i class="fa fa-file-signature"></i>';
              } else if (qiStatusCode === "JOB_QI_STATUS_REPAIR_COMPLETED") {
                statusIcon = '<i class="fa fa-check"></i>';
              } else if (qiStatusCode === "JOB_QI_STATUS_CANCEL") {
                statusIcon = '<i class="fa fa-ban text-danger"></i>';
              } else if (qiStatusCode == "JOB_QI_STATUS_SUCCESS") {
                statusIcon = '<i class="fa fa-check-circle"></i>';
                self.isDisable = false;
              }
              self.qiStatusCode = qiStatusCode;
              self.qiStatusName = statusIcon + ' ' + statusText;
              self.qiAreaPlant = response.data.qiAreaPlant;

              self.createdDate = response.data.createdDateFormat || '-';
              self.createdUserName = response.data.createdUserName || '-';
              self.finishedDate = response.data.finishedDate ? self.setDateFormat(response.data.finishedDate, true) : '-';
              self.confirmedDate = response.data.confirmedDate ? self.setDateFormat(response.data.confirmedDate, true) : '-';
              self.confirmedUserName = response.data.confirmedUserName || '-';

              additionalText = '';

              if (response.data.qiTypeCode === "JOB_QI_TYPE_DRAWBACK" && response.data.finishedDate) {
                additionalText = response.data.qiSubType === 1 ? ' <span>(เบิก)</span>' : ' <span>(คืน)</span>';
              }
              self.qiTypeName = response.data.qiTypeName ? response.data.qiTypeName + additionalText : '-';
              self.amount = response.data.amount || '-';

              if (response.data.items && Array.isArray(response.data.items)) {
                if (response.data.qiTypeCode === "JOB_QI_TYPE_DRAWBACK") {
                  self.amount = response.data.items.reduce(function (total, item) {
                    return total + item.quantity;
                  }, 0);
                }
                self.items = response.data.items;
              }

              //response.data.picture.forEach((element) => {
              //    self.pictures.push({
              //        fileInfoId: element.fileInfoId,
              //        downloadUrl: element.downloadUrl
              //    });
              //});
              //=== set pictures ===
              if (response.data.picture && typeof response.data.picture !== 'undefined' && response.data.picture.length > 0) {
                loadPictures = function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                    var _this2 = this;

                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            response.data.picture.map(function () {
                              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(element) {
                                return regeneratorRuntime.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {
                                      case 0:
                                        self.pictures.push({
                                          fileInfoId: element.fileInfoId,
                                          downloadUrl: element.downloadUrl
                                        });

                                      case 1:
                                      case "end":
                                        return _context.stop();
                                    }
                                  }
                                }, _callee, _this2);
                              }));

                              return function (_x) {
                                return _ref2.apply(this, arguments);
                              };
                            }());

                          case 1:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this);
                  }));

                  return function loadPictures() {
                    return _ref.apply(this, arguments);
                  };
                }();

                loadPictures();
              }

              self.$nextTick(function () {
                return self.updateSelect2Options();
              });

              _context3.next = 39;
              break;

            case 38:
              throw new Error("ไม่พบข้อมูลใบงานช่างซ่อมคุณเลือก");

            case 39:
              _context3.next = 45;
              break;

            case 41:
              _context3.prev = 41;
              _context3.t0 = _context3["catch"](6);

              Swal.fire("เกิดข้อผิดพลาด", _context3.t0.message || "ระบบเกิดข้อผิดพลาด", "error");
              router.go(-1);

            case 45:
              _context3.prev = 45;

              KTApp.unblockPage();
              return _context3.finish(45);

            case 48:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[6, 41, 45, 48]]);
    }))();
  },


  methods: {
    showModal: function showModal(imageURL) {
      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', function () {
        $('body').addClass('modal-open');
      });
    },
    closeModal: function closeModal() {
      $('#imageModal').modal('hide');
    },
    onAddItemClick: function onAddItemClick(e) {
      var _this3 = this;

      if (!this.validateItems()) {
        return false;
      }
      this.items.push({
        qiJobItemId: Date.now(),
        materialCode: "",
        quantity: 0,
        unitPrice: 0,
        remark: ""
      });
      this.$nextTick(function () {
        return _this3.updateSelect2Options();
      });
    },
    onRemoveItemClick: function onRemoveItemClick(index) {
      var _this4 = this;

      this.items.splice(index, 1);
      this.$nextTick(function () {
        return _this4.updateSelect2Options();
      });
    },
    onMaterialCodeChange: function onMaterialCodeChange(index) {
      var _this5 = this;

      var materialCode = this.items[index].materialCode;
      if (!materialCode) {
        return;
      }
      this.$nextTick(function () {
        var selectedItem = _this5.originalOptions.find(function (item) {
          return item.id === materialCode;
        });
        if (selectedItem) {
          _this5.$set(_this5.items[index], 'unitPrice', selectedItem.data.qiPrice);
        }
      });
    },
    loadMaterialOptions: function loadMaterialOptions() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/QIJobs/ProductOption", {
                  page: 0,
                  limit: 1000,
                  optionWithCode: true,
                  qiTypes: ['QiSpare']
                });

              case 3:
                response = _context4.sent;


                if (response.status === 200) {
                  _this6.originalOptions = response.data.results.map(function (element) {
                    return {
                      id: element.id,
                      text: element.text,
                      data: element.data
                    };
                  });

                  _this6.updateSelect2Options();
                }
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);

                console.error('Error loading material options:', _context4.t0);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 7]]);
      }))();
    },
    getMaterialCodeOptions: function getMaterialCodeOptions(index) {
      var selectedCodes = this.items.map(function (item, idx) {
        return idx !== index ? item.materialCode : null;
      }).filter(function (code) {
        return code;
      });
      var availableOptions = this.originalOptions.filter(function (option) {
        return !selectedCodes.includes(option.id);
      });
      return {
        data: availableOptions,
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true
      };
    },
    updateSelect2Options: function updateSelect2Options() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var usedOptions;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                usedOptions = _this7.items.map(function (item) {
                  return item.materialCode;
                });

                _this7.materialCodeOptions.data = _this7.originalOptions.filter(function (option) {
                  return !usedOptions.includes(option.id);
                });

                _this7.$nextTick(function () {
                  _this7.items.forEach(function (item, i) {
                    var selectRef = _this7.$refs["materialSelect2-" + i];
                    if (selectRef && selectRef.$el) {
                      $(selectRef.$el).select2('destroy').select2(_this7.materialCodeOptions);
                    }
                  });
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    setDateFormat: function setDateFormat(dateStr) {
      var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        calendar: 'gregory'
      };
      if (includeTime) {
        options = _extends({}, options, {
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      var dateStrFormat = new Date(dateStr).toLocaleDateString('th-TH', options);
      return dateStrFormat;
    },
    validateItems: function validateItems() {
      var _this8 = this;

      var isValid = true;
      this.errors = []; // รีเซ็ตข้อผิดพลาด
      this.items.forEach(function (item, index) {
        var materialSelect2Ref = _this8.$refs["materialSelect2-" + index];
        if (materialSelect2Ref && materialSelect2Ref.length) {
          var select2Element = materialSelect2Ref[0];
          if (!select2Element.value) {
            isValid = false;
            _this8.$set(_this8.errors, index, _extends({}, _this8.errors[index], { materialCode: 'กรุณาเลือกสินค้า' }));
          } else {
            _this8.$set(_this8.errors, index, _extends({}, _this8.errors[index], { materialCode: '' }));
          }
        }

        var quantityInputRef = _this8.$refs["quantity-" + index];
        if (quantityInputRef && quantityInputRef.length) {
          var quantityElement = quantityInputRef[0];
          if ($(quantityElement).val() == '') {
            isValid = false;
            _this8.$set(_this8.errors, index, _extends({}, _this8.errors[index], { quantity: 'กรุณากรอกจำนวน' }));
          } else {
            _this8.$set(_this8.errors, index, _extends({}, _this8.errors[index], { quantity: '' }));
          }
        }

        var unitPriceInputRef = _this8.$refs["unitPrice-" + index];
        if (unitPriceInputRef && unitPriceInputRef.length) {
          var _quantityElement = unitPriceInputRef[0];
          if ($(_quantityElement).val() == '') {
            isValid = false;
            _this8.$set(_this8.errors, index, _extends({}, _this8.errors[index], { unitPrice: 'กรุณากรอกราคา/หน่วย' }));
          } else {
            _this8.$set(_this8.errors, index, _extends({}, _this8.errors[index], { unitPrice: '' }));
          }
        }
      });
      return isValid;
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (!this.validateItems()) {
        return false;
      }

      if (this.items.length == 0) {
        Swal.fire("", "กรุณาเพิ่มรายการอุปกรณ์", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/QIJobs/EditDrawback",
        data: {
          QIJobId: this.qiJobId,
          QIJobItems: this.items
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire({
            title: "ไม่สามารถบันทึกข้อมูลได้",
            type: "error",
            html: response.data.message.replace(/\n/g, "<br>")
          });
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  computed: {
    totalQuantity: function totalQuantity() {
      return this.items.reduce(function (sum, item) {
        return sum + (item.quantity || 0);
      }, 0);
    },
    totalValue: function totalValue() {
      return this.items.reduce(function (sum, item) {
        return sum + (item.quantity * item.unitPrice || 0);
      }, 0);
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      qiJobId: null,
      qiJobNumber: null,
      qiStatusCode: null,
      qiTypeCode: '',
      qiSubType: 0,
      qiStatusName: null,
      qiAreaPlant: true,
      createdDate: null,
      createdUserName: null,
      finishedDate: null,
      confirmedDate: null,
      confirmedUserName: null,
      qiTypeName: null,
      barcodeNoOld: null,
      materialNameShow: null,
      amount: null,
      items: [],
      services: [],
      originalOptions: [],
      materialCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true
      },
      errors: {
        items: [],
        services: []
      },
      isDisable: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user, response, qiStatusCode, statusIcon, statusText, additionalText;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              _context.prev = 6;
              _context.next = 9;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/QIJobs/" + _this.$route.params.id, {
                params: {
                  withFile: false
                }
              });

            case 9:
              response = _context.sent;

              if (!(response.status === 200 && response.data)) {
                _context.next = 37;
                break;
              }

              self.qiJobId = response.data.qiJobId;
              self.qiJobNumber = response.data.qiJobNumber ? "\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48\u0E43\u0E1A\u0E07\u0E32\u0E19 : " + response.data.qiJobNumber : '';
              self.qiTypeCode = response.data.qiTypeCode;
              self.qiSubType = response.data.qiSubType;

              qiStatusCode = response.data.qiStatusCode;
              statusIcon = '';
              statusText = self.qiStatusName = response.data.qiStatusName;

              if (qiStatusCode === "JOB_QI_STATUS_PENDING") {
                statusIcon = '<i class="fa fa-sync-alt"></i>';
              } else if (qiStatusCode === "JOB_QI_STATUS_REQUEST_APPROVAL") {
                statusIcon = '<i class="fa fa-file-signature"></i>';
              } else if (qiStatusCode === "JOB_QI_STATUS_REPAIR_COMPLETED") {
                statusIcon = '<i class="fa fa-check"></i>';
              } else if (qiStatusCode === "JOB_QI_STATUS_CANCEL") {
                statusIcon = '<i class="fa fa-ban text-danger"></i>';
              } else if (qiStatusCode == "JOB_QI_STATUS_SUCCESS") {
                statusIcon = '<i class="fa fa-check-circle"></i>';
              }
              self.qiStatusCode = qiStatusCode;
              self.qiStatusName = statusIcon + ' ' + statusText;

              self.barcodeNoOld = response.data.barcodeNoOld ? response.data.barcodeNoOld : '-';
              self.materialNameShow = response.data.materialNameShow ? response.data.materialNameShow : '-';
              self.qiAreaPlant = response.data.qiAreaPlant;

              self.createdDate = response.data.createdDateFormat || '-';
              self.createdUserName = response.data.createdUserName || '-';
              self.finishedDate = response.data.finishedDate && response.data.finishedUserId != null ? self.setDateFormat(response.data.finishedDate, true) : '-';
              self.confirmedDate = response.data.confirmedDate ? self.setDateFormat(response.data.confirmedDate, true) : '-';
              self.confirmedUserName = response.data.confirmedUserName || '-';

              additionalText = '';

              if (response.data.qiTypeCode === "JOB_QI_TYPE_DRAWBACK" && response.data.finishedDate) {
                additionalText = response.data.qiSubType === 1 ? ' <span>(เบิก)</span>' : ' <span>(คืน)</span>';
              }
              self.qiTypeName = response.data.qiTypeName ? response.data.qiTypeName + additionalText : '-';
              self.amount = response.data.amount || '-';

              if (response.data.items && Array.isArray(response.data.items)) {
                if (response.data.qiTypeCode === "JOB_QI_TYPE_DRAWBACK") {
                  self.amount = response.data.items.reduce(function (total, item) {
                    return total + item.quantity;
                  }, 0);
                }
                self.items = response.data.items;
              }

              if (response.data.services && Array.isArray(response.data.services)) {
                self.services = response.data.services;
              }

              _context.next = 38;
              break;

            case 37:
              throw new Error("ไม่พบข้อมูลใบงานช่างซ่อมคุณเลือก");

            case 38:
              _context.next = 44;
              break;

            case 40:
              _context.prev = 40;
              _context.t0 = _context["catch"](6);

              Swal.fire("เกิดข้อผิดพลาด", _context.t0.message || "ระบบเกิดข้อผิดพลาด", "error");
              router.go(-1);

            case 44:
              _context.prev = 44;

              KTApp.unblockPage();
              return _context.finish(44);

            case 47:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[6, 40, 44, 47]]);
    }))();
  },

  methods: {
    setDateFormat: function setDateFormat(dateStr) {
      var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        calendar: 'gregory'
      };
      if (includeTime) {
        options = _extends({}, options, {
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      var dateStrFormat = new Date(dateStr).toLocaleDateString('th-TH', options);
      return dateStrFormat;
    },
    validateItems: function validateItems() {
      var _this2 = this;

      var isValid = true;

      this.errors.items = [];
      this.items.forEach(function (item, index) {
        if (!item.unitPrice || item.unitPrice === 0) {
          isValid = false;
          _this2.$set(_this2.errors.items, index, { unitPrice: 'กรุณากรอกราคา/หน่วย' });
          _this2.$set(_this2.errors.items, index, _extends({}, _this2.errors.items[index], { unitPrice: 'กรุณาเลือกสินค้า' }));
        } else {
          _this2.$set(_this2.errors.items, index, _extends({}, _this2.errors.items[index], { unitPrice: '' }));
        }
      });

      this.errors.services = [];
      this.services.forEach(function (service, index) {
        if (!service.unitPrice || service.unitPrice === 0) {
          isValid = false;
          _this2.$set(_this2.errors.services, index, _extends({}, _this2.errors.services[index], { unitPrice: 'กรุณากรอกราคา/หน่วย' }));
        } else {
          _this2.$set(_this2.errors.services, index, _extends({}, _this2.errors.services[index], { unitPrice: '' }));
        }
      });
      console.log(this.errors);
      return isValid;
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (!this.validateItems()) {
        return false;
      }

      if (this.items.length == 0) {
        Swal.fire("", "กรุณาเพิ่มรายการอุปกรณ์", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/QIJobs/EditDrawback",
        data: {
          QIJobId: this.qiJobId,
          QIJobItems: this.items,
          QIJobService: this.services
        }
      }).then(function (response) {
        console.log(response);
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  },
  computed: {
    totalQuantity: function totalQuantity() {
      return this.items.reduce(function (sum, item) {
        return sum + (item.quantity || 0);
      }, 0);
    },
    totalValue: function totalValue() {
      return this.items.reduce(function (sum, item) {
        return sum + (item.quantity * item.unitPrice || 0);
      }, 0);
    },
    totalQuantityService: function totalQuantityService() {
      return this.services.reduce(function (sum, item) {
        return sum + (item.quantity || 0);
      }, 0);
    },
    totalValueService: function totalValueService() {
      return this.services.reduce(function (sum, item) {
        return sum + item.quantity * item.unitPrice;
      }, 0);
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_DatatableWarning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div style=\"display: flex; flex-direction: row; align-items: center; justify-content: center\">\n    <a href=\"#\" @click.prevent=\"setValidate\" v-if=\"data.showValidateButton\" class=\"btn btn-sm btn-clean btn-icon\"\n      :title=\"data.isValidate ? '\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02' : '\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02'\">\n      <i class=\"fa\" :class=\"{ 'fa-lock kt-font-success': data.isValidate, 'fa-unlock kt-font-danger': !data.isValidate }\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"detailQi\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"fa fa-search\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"editQi\" v-if=\"data.showEditButton\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"fa fa-edit kt-font-warning\"></i>\n    </a>\n    <a href=\"#\" @click.prevent=\"remove\" v-if=\"data.showCancelButton\" class=\"btn btn-sm btn-clean btn-icon\" title=\"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E43\u0E1A\u0E07\u0E32\u0E19\">\n      <i class=\"fa fa-trash-alt kt-font-danger\"></i>\n    </a>\n  </div>",
  methods: {

    detailQi: function detailQi() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Maintain/QIJob/Detail/" + this.data.qiJobId
      });
    },
    editQi: function editQi() {
      if (this.data.qiTypeCode == "JOB_QI_TYPE_DRAWBACK") {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
          path: "/Maintain/QIJob/EditDrawback/" + this.data.qiJobId
        });
      } else if (this.data.qiTypeCode == "JOB_QI_TYPE_REPAIR") {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
          path: "/Maintain/QIJob/EditRepair/" + this.data.qiJobId
        });
      }
    },
    setValidate: function setValidate() {
      var self = this;
      if (this.data.isValidate) {
        Swal.fire({
          title: "คำสั่งปิดการตรวจสอบเงื่อนไขของเครื่อง หรืออุปกรณ์",
          type: "warning",
          html: "กรุณายืนยันคำสั่งปิดการตรวจสอบสถานะ,ประเภทอุปกรณ์,ที่ตั้ง<br>BARCODE ของใบงาน <strong>" + this.data.qiJobNumber + "</strong>",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            self.doSetValidate();
          }
        });
      } else {
        Swal.fire({
          title: "คำสั่งเปิดการตรวจสอบเงื่อนไขของเครื่อง หรืออุปกรณ์",
          type: "warning",
          html: "กรุณายืนยันคำสั่งเปิดการตรวจสอบสถานะ,ประเภทอุปกรณ์,ที่ตั้ง<br>BARCODE ของใบงาน <strong>" + this.data.qiJobNumber + "</strong>",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true
        }).then(function (result) {
          if (result.value) {
            self.doSetValidate();
          }
        });
      }
    },
    doSetValidate: function doSetValidate() {
      var self = this;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/QIJobs/SetValidate", {
        qiJobId: this.data.qiJobId,
        isValidate: !this.data.isValidate
      }).then(function (response) {
        if (response.data.status) {
          self.$parent.reloadDataTable();
          Swal.fire("สำเร็จ", response.data.message, "success");
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    remove: function remove() {
      var _this = this;

      var self = this;
      Swal.fire({
        title: "คำสั่งยกเลิกข้อมูลใบงาน",
        type: "warning",
        html: "กรุณายืนยันคำสั่งยกเลิกข้อมูลใบงาน <strong>" + this.data.qiJobNumber + "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(function (result) {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังยกเลิกข้อมูล กรุณารอสักครู่..."
          });
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/QIJobs/Delete", {
            qiJobId: _this.data.qiJobId
          }).then(function (response) {
            if (response.data.status) {
              self.$parent.reloadDataTable();
              Swal.fire("สำเร็จ", response.data.message, "success");
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          }).catch(function (error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }).then(function () {
            KTApp.unblockPage();
          });
        }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      qiKeyword: null,
      qiOldBarcode: null,
      qiStatusCode: [],
      qiStatusCodeOptions: [],
      qiProductCode: null,
      qiProductCodeOptions: [],
      qiTypeCode: null,
      qiTypeCodeOptions: [],
      qiUserId: [],
      qiUserOptions: [],
      jobsDateStart: null,
      jobsDateEnd: null
    };
  },
  methods: {
    LoadQiStatusCodeOptions: function LoadQiStatusCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=JOB_QI_STATUS", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.qiStatusCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadQiTypeCodeOptions: function LoadQiTypeCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=JOB_QI_TYPE", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.qiTypeCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreProductCodeOptions: function LoadreProductCodeOptions(e) {
      var self = this;
      var qiTypesArray = ['QiSpare', 'QiMachine', 'QiEquipment'];
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/QIJobs/ProductOption", {
        page: 0,
        limit: 1000,
        optionWithCode: true,
        qiTypes: qiTypesArray
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductCodeOptions = [];
          data.forEach(function (element) {
            self.qiProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    reLoadUsersIdOptions: function reLoadUsersIdOptions() {
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions: function LoadUsersIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      if (action === __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/QIJobs/User/Options", {
          page: 1,
          search: searchQuery,
          all: true
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            var result = [];
            data.forEach(function (element) {
              result.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, result);
        }).catch(function (error) {});
      }
    },

    formReset: function formReset(e) {
      this.qiStatusCode = ["JOB_QI_STATUS_PENDING", "JOB_QI_STATUS_REPAIR_COMPLETED", "JOB_QI_STATUS_REQUEST_APPROVAL"];
      this.qiKeyword = null;
      this.qiOldBarcode = null;
      this.qiProductCode = null;
      this.qiTypeCode = null;
      this.qiUserId = [];
      this.jobsDateStart = null;
      this.jobsDateEnd = null;
      $("#jobsDateStart").val("").trigger("change");
      $("#jobsDateEnd").val("").trigger("change");
      $("#qiUserId").val("").trigger("change");
      $("#qiProductCode").val("").trigger("change");
      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#qiJobsTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#qiJobsTable").DataTable().ajax.reload(null, resetPaging);
    },
    showBarcodesModal: function showBarcodesModal(qiJobId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/QIJobs/BarcodesInfo/" + qiJobId).then(function (response) {
        var barcodes = response.data;
        var tableData = barcodes.map(function (barcode, index) {
          return {
            index: index + 1,
            barcodeNoOld: barcode.barcodeNoOld || '-'
          };
        });

        $(_this2.$refs.barcodeLocalTable).DataTable({
          data: tableData,
          language: { search: "ค้นหา", searchPlaceholder: "BARCODE" },
          columns: [{ data: 'index', className: 'text-center' }, { data: 'barcodeNoOld', className: 'text-center' }],
          destroy: true
        });

        $(_this2.$refs.barcodesModal).modal('show');
      }).catch(function (error) {
        console.error('Error fetching barcodes:', error);
      });
    },

    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/QIJobs/ExportSearch",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: self.qiKeyword,
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          QIJobStatusCode: self.qiStatusCode,
          QIJobTypeCode: self.qiTypeCode && self.qiTypeCode.length > 0 ? self.qiTypeCode : ['JOB_QI_TYPE_EVALUATE', 'JOB_QI_TYPE_DRAWBACK', 'JOB_QI_TYPE_REPAIR'],
          ProductCode: self.qiProductCode,
          QIJobUsersId: self.qiUserId,
          Barcode: self.qiOldBarcode
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    }

  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;

              self.qiStatusCode = ["JOB_QI_STATUS_PENDING", "JOB_QI_STATUS_REPAIR_COMPLETED", "JOB_QI_STATUS_REQUEST_APPROVAL"];
              self.LoadQiStatusCodeOptions();
              self.LoadQiTypeCodeOptions();
              self.LoadreProductCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.jobsDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.jobsDateStart).on("changeDate", function (e) {
                self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.jobsDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.jobsDateEnd).on("changeDate", function (e) {
                self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#qiJobsTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/QIJobs/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      SearchKeyword: self.qiKeyword,
                      StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
                      EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
                      QIJobStatusCode: self.qiStatusCode,
                      QIJobTypeCode: self.qiTypeCode && self.qiTypeCode.length > 0 ? self.qiTypeCode : ['JOB_QI_TYPE_EVALUATE', 'JOB_QI_TYPE_DRAWBACK', 'JOB_QI_TYPE_REPAIR'],
                      ProductCode: self.qiProductCode,
                      QIJobUsersId: self.qiUserId,
                      Barcode: self.qiOldBarcode
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [30, 50, 100],
                pageLength: 30,
                language: { lengthMenu: "Display _MENU_" },

                // Order settings
                order: [[6, "desc"]],
                columns: [{
                  data: "qiJobNumber",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data ? data : '-';
                  }
                }, {
                  data: "qiTypeName",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var additionalText = '';
                    if (full.qiTypeCode == "JOB_QI_TYPE_DRAWBACK" && full.finishedDate != null) {
                      if (full.qiSubType === 1) {
                        additionalText = ' <br><span>(เบิก)</span>';
                      } else {
                        additionalText = ' <br><span>(คืน)</span>';
                      }
                    } else if (full.qiTypeCode == "JOB_QI_TYPE_REPAIR" && full.finishedDate != null) {
                      if (full.qiAreaPlant) {
                        additionalText = ' <br><span>(คลังสินค้า)</span>';
                      } else {
                        additionalText = ' <br><span>(ตัวแทน)</span>';
                      }
                    }
                    return data ? data + additionalText : '-';
                  }
                }, {
                  data: "barcodeInfo",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if ((full.qiTypeCode === 'JOB_QI_TYPE_EVALUATE' || full.qiTypeCode === 'JOB_QI_TYPE_REPAIR') && full.qiSubType === 1) {
                      if (data && data.length > 0) {
                        return data[0].barcodeNoOld ? data[0].barcodeNoOld : '-';
                      }
                    } else if ((full.qiTypeCode === 'JOB_QI_TYPE_EVALUATE' || full.qiTypeCode === 'JOB_QI_TYPE_REPAIR') && full.qiSubType === 2 && full.barcodeInfo && full.barcodeInfo.length > 0 && full.barcodeInfo[0].barcodeId != null) {
                      return "<button\n                        type=\"button\"\n                        class=\"btn btn-outline-hover-info btn-elevate btn-circle btn-icon\"\n                        title=\"\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 BARCODE\"\n                        data-qijob-id=\"" + full.qiJobId + "\"\n                      >\n                        <i class=\"text-info la la-list\"></i>\n                      </button>";
                    }
                    return '-';
                  }
                }, {
                  data: "amount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.qiTypeCode == "JOB_QI_TYPE_DRAWBACK") {
                      //return full.sumItems ? full.sumItems : '-';
                      if (!full.sumItems) return '-';
                      return Number(full.sumItems).toLocaleString('en-US');
                    } else {

                      //return data ? data : '-';
                      if (!data) return '-';
                      return Number(data).toLocaleString('en-US');
                    }
                  }
                }, {
                  data: "materialNameShow",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.qiTypeCode === "JOB_QI_TYPE_DRAWBACK" && full.items && full.items.length > 0) {
                      var displayItems = full.items.slice(0, 2).map(function (item) {
                        return item.materialName + ' [' + item.materialCode + ']';
                      }).join(',<br> ');
                      // เพิ่มไอคอนแว่นขยายเพื่อดูเพิ่มเติม
                      var expandIcon = full.items.length > 2 ? '<a href="/Maintain/QIJob/Detail/' + full.qiJobId + '" class="btn btn-link btn-sm px-0 py-0"><i class="fa fa-search"></i></a>' : '';
                      return displayItems + " " + (full.items.length > 2 ? '...' : '') + " " + expandIcon;
                    } else {
                      if ((full.qiTypeCode === 'JOB_QI_TYPE_EVALUATE' || full.qiTypeCode === 'JOB_QI_TYPE_REPAIR') && full.qiSubType === 1) {
                        if (full.barcodeInfo && full.barcodeInfo.length > 0) {
                          var firstBarcode = full.barcodeInfo[0];
                          return firstBarcode.barcodeProductName ? firstBarcode.barcodeProductName + " [" + firstBarcode.barcodeProductCode + "]" : '-';
                        }
                        return '-';
                      }
                      return data ? data : '-';
                    }
                  }
                }, {
                  data: "qiStatusName",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.qiStatusCode == "JOB_QI_STATUS_PENDING") {
                      return '<span><i class="fa fa-sync-alt"></i> ' + data + "</span>";
                    } else if (full.qiStatusCode == "JOB_QI_STATUS_SUCCESS" && full.qiTypeCode == "JOB_QI_TYPE_EVALUATE") {
                      var additionalText = '';
                      if (full.evalFlag === 1) {
                        additionalText = ' <br><span class="text-danger">(ซ่อมไม่ได้)</span>';
                      } else if (full.evalFlag === 2) {
                        additionalText = ' <br><span class="text-success">(ซ่อมได้)</span>';
                      } else if (full.evalFlag === 3) {
                        additionalText = ' <br><span class="text-warning">(ไม่เสีย)</span>';
                      }
                      return '<span><i class="fa fa-check-circle"></i> ' + data + additionalText + "</span>";
                    } else if (full.qiStatusCode == "JOB_QI_STATUS_SUCCESS") {
                      return '<span><i class="fa fa-check-circle"></i> ' + data + "</span>";
                    } else if (full.qiStatusCode == "JOB_QI_STATUS_REQUEST_APPROVAL") {
                      return '<span><i class="fa fa-file-signature"></i> ' + data + "</span>";
                    } else if (full.qiStatusCode == "JOB_QI_STATUS_REPAIR_COMPLETED") {
                      return '<span><i class="fa fa-check"></i> ' + data + "</span>";
                    } else if (full.qiStatusCode == "JOB_QI_STATUS_CANCEL") {
                      return '<span class="text-danger"><i class="fa fa-ban"></i> ' + data + "</span>";
                    }
                    return data ? data : '-';
                  }
                }, {
                  data: "CreatedDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.createdDateFormat;
                  }
                }, { data: "createdUserName", className: "text-center" }, {
                  data: "confirmedUserName",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data ? data : '-';
                  }
                }, {
                  data: "qiJobId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_5__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    data.showValidateButton = false;
                    if (data.qiStatusCode == "JOB_QI_STATUS_PENDING" && (data.qiTypeCode == "JOB_QI_TYPE_EVALUATE" || data.qiTypeCode == "JOB_QI_TYPE_REPAIR") && self.$root.canShow(["OFFICER_QIMAINTAIN"])) {
                      data.showValidateButton = true;
                    }

                    data.showEditButton = false;
                    if ((data.qiStatusCode == "JOB_QI_STATUS_REQUEST_APPROVAL" || data.qiStatusCode == "JOB_QI_STATUS_SUCCESS") && data.qiTypeCode == "JOB_QI_TYPE_DRAWBACK" && self.$root.canShow(["OFFICER_QIMAINTAIN"]) || (data.qiStatusCode == "JOB_QI_STATUS_REPAIR_COMPLETED" || data.qiStatusCode == "JOB_QI_STATUS_SUCCESS") && data.qiTypeCode == "JOB_QI_TYPE_REPAIR" && self.$root.canShow(["OFFICER_QIMAINTAIN"])) {
                      data.showEditButton = true;
                    }

                    if (data.isUnrepair) {
                      data.showEditButton = false;
                    }

                    data.showCancelButton = false;
                    if ((data.qiStatusCode == "JOB_QI_STATUS_PENDING" || data.qiStatusCode == "JOB_QI_STATUS_REQUEST_APPROVAL") && self.$root.canShow(["OFFICER_QIMAINTAIN"])) {
                      data.showCancelButton = true;
                    }

                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

              $('#qiJobsTable').on('click', 'button', function () {
                var qiJobId = $(this).data('qijob-id');
                self.showBarcodesModal(qiJobId);
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_2__Shared_Datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      refCode: null,
      recvitems: [],
      isReferenceCodeLocked: false,
      originalOptions: [],
      odcMaterialCodeOptions: {},
      errors: []
    };
  },

  methods: {
    validateItems: function validateItems() {
      var _this = this;

      var isValid = true;
      this.errors = []; // รีเซ็ตข้อผิดพลาด

      this.recvitems.forEach(function (item, index) {
        // ตรวจสอบ MaterialCode
        if (!item.MaterialCode) {
          isValid = false;
          _this.$set(_this.errors, index, _extends({}, _this.errors[index], { materialCode: 'กรุณาเลือกสินค้า' }));
        } else {
          _this.$set(_this.errors, index, _extends({}, _this.errors[index], { materialCode: '' }));
        }
        // ตรวจสอบ Quantity
        if (!item.Quantity || item.Quantity <= 0) {
          isValid = false;
          _this.$set(_this.errors, index, _extends({}, _this.errors[index], { quantity: 'กรุณากรอกจำนวน' }));
        } else {
          _this.$set(_this.errors, index, _extends({}, _this.errors[index], { quantity: '' }));
        }
      });

      return isValid;
    },
    onInputChange: function onInputChange(index, field) {
      if (field === 'quantity') {
        if (this.recvitems[index].Quantity && this.recvitems[index].Quantity > 0) {
          this.$set(this.errors, index, _extends({}, this.errors[index], { quantity: '' }));
        }
      }
    },

    formSubmit: function formSubmit(e) {
      var router = this.$router;
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (!this.validateItems()) {
        return false;
      }

      if (self.refCode == "" || self.refCode == null) {
        Swal.fire("", "กรุณากรอก เลขที่ใบเบิกสินค้า", "warning");
        return false;
      }

      if (self.recvitems.length == 0) {
        Swal.fire("", "กรุณาดึงข้อมูลรายการอะไหล่", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/QIJobs/AddReceive",
        data: {
          refCode: this.refCode,
          QIJobItems: this.recvitems
        }
      }).then(function (response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(function () {
            router.go(-1), self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    getMaterial: function getMaterial() {
      var self = this;
      if (!self.refCode) {
        Swal.fire("", "กรุณากรอก เลขที่ใบเบิกสินค้า", "warning");
        return false;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/QIJobs/ProductBorrow", {
        RequestDocNo: self.refCode
      }).then(function (response) {
        if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
          self.recvitems = response.data.map(function (item) {
            return {
              QIJobItemId: Date.now(),
              MaterialCode: item.materialCode,
              MaterialName: item.materialNameShow,
              Quantity: item.quantity,
              UnitName: item.baseUnit,
              UnitPrice: item.unitPrice,
              Remark: item.remark || ''
            };
          });
          self.isReferenceCodeLocked = true;
        } else if (response.data.message) {
          Swal.fire("", response.data.message, "warning");
        } else {
          Swal.fire("", "ไม่พบข้อมูลรายการอะไหล่", "warning");
        }
      }).catch(function (error) {
        console.error('Error loading material options:', error);
      });
    },
    loadMaterialOptions: function loadMaterialOptions() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/QIJobs/ProductOption", {
        page: 0,
        limit: 1000,
        optionWithCode: true,
        qiTypes: ['QiSpare']
      }).then(function (response) {
        if (response.status === 200) {
          _this2.originalOptions = response.data.results.map(function (element) {
            return {
              id: element.id,
              text: element.text,
              data: element.data
            };
          });
          _this2.updateSelect2Options();
        }
      }).catch(function (error) {
        console.error('Error loading material options:', error);
      });
    },
    updateSelect2Options: function updateSelect2Options() {
      var usedCodes = this.recvitems.map(function (item) {
        return item.MaterialCode;
      });
      var availableOptions = this.originalOptions.filter(function (option) {
        return !usedCodes.includes(option.id);
      });
      this.odcMaterialCodeOptions = {
        data: availableOptions,
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true
      };
    },
    getMaterialCodeOptions: function getMaterialCodeOptions(index) {
      var selectedCodes = this.recvitems.map(function (item, idx) {
        return idx !== index ? item.MaterialCode : null;
      }).filter(function (code) {
        return code;
      });
      return {
        data: this.originalOptions.filter(function (option) {
          return !selectedCodes.includes(option.id);
        }),
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true
      };
    },
    onMaterialCodeChange: function onMaterialCodeChange(index) {
      var materialCode = this.recvitems[index].MaterialCode;
      if (!materialCode) return;

      var selectedItem = this.originalOptions.find(function (item) {
        return item.id === materialCode;
      });
      if (selectedItem) {
        this.$set(this.recvitems[index], 'MaterialName', selectedItem.text);
        this.$set(this.recvitems[index], 'UnitName', selectedItem.data.baseUnit);
        this.$set(this.recvitems[index], 'UnitPrice', selectedItem.data.qiPrice);
      } else {
        console.warn('Item not found in originalOptions');
      }
    },
    editReferenceCode: function editReferenceCode() {
      this.refCode = "";
      this.recvitems = [];
      this.isReferenceCodeLocked = false;
    }
  },
  mounted: function mounted() {
    this.loadMaterialOptions();
    $(this.$refs.form).validate({
      rules: {
        refCode: "required"
      },
      messages: {
        refCode: "กรุณาระบุ เลขที่ใบเบิกสินค้า"
      }
    });
  },

  watch: {
    recvitems: {
      deep: true,
      handler: function handler(newValue, oldValue) {
        var _this3 = this;

        newValue.forEach(function (item, index) {
          // ตรวจสอบ MaterialCode
          if (item.MaterialCode) {
            _this3.$set(_this3.errors, index, _extends({}, _this3.errors[index], { materialCode: '' }));
          }
          // ตรวจสอบ Quantity
          if (item.Quantity && item.Quantity > 0) {
            _this3.$set(_this3.errors, index, _extends({}, _this3.errors[index], { quantity: '' }));
          }
        });
      }
    }
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var self = this;
    return {
      qiJobId: null,
      qiJobNumber: null,
      qiStatusName: null,
      refCode: '',
      createdDate: null,
      createdUserName: null,
      finishedDate: null,
      qiTypeName: null,
      materialNameShow: null,
      amount: null,
      items: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/QIJobs/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  //console.log(response.data);
                  if (response.data != null) {
                    self.qiJobId = response.data.qiJobId;
                    self.qiJobNumber = response.data.qiJobNumber ? "\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48\u0E43\u0E1A\u0E07\u0E32\u0E19 : " + response.data.qiJobNumber : '';
                    self.refCode = response.data.refCode;
                    self.qiStatusName = response.data.qiStatusName;
                    self.createdDate = response.data.createdDateFormat ? response.data.createdDateFormat : '-';
                    self.createdUserName = response.data.createdUserName ? response.data.createdUserName : '-';
                    self.finishedDate = response.data.finishedDate ? self.setDateFormat(response.data.finishedDate, true) : '-';
                    self.amount = response.data.amount ? response.data.amount : '-';

                    if (response.data.items && Array.isArray(response.data.items)) {
                      self.amount = response.data.items.reduce(function (total, item) {
                        return total + item.quantity;
                      }, 0);
                      self.items = response.data.items;
                    }
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลใบงานช่างซ่อมคุณเลือก", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลใบงานช่างซ่อมได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    formatNumber: function formatNumber(value) {
      if (value == null || value === '') return '-';
      return Number(value).toLocaleString('en-US');
    },
    setDateFormat: function setDateFormat(dateStr) {
      var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        calendar: 'gregory'
      };
      if (includeTime) {
        options = _extends({}, options, {
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      var dateStrFormat = new Date(dateStr).toLocaleDateString('th-TH', options);
      return dateStrFormat;
    }
  },
  computed: {
    totalQuantity: function totalQuantity() {
      return this.items.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);
    }
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_DatatableWarning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div style=\"display: flex; flex-direction: row; align-items: center; justify-content: center\">\n    <a href=\"#\" @click.prevent=\"detailQi\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"fa fa-search\"></i>\n    </a>\n  </div>",
  methods: {
    detailQi: function detailQi() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Maintain/Recv/Detail/" + this.data.qiJobId
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_4__Shared_Datepicker__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      qiKeyword: null,
      qiProductCode: null,
      qiProductCodeOptions: [],
      qiUserId: [],
      qiUserOptions: [],
      jobsDateStart: null,
      jobsDateEnd: null
    };
  },
  methods: {
    LoadreProductCodeOptions: function LoadreProductCodeOptions(e) {
      var self = this;
      var qiTypesArray = ['QiSpare'];
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/QIJobs/ProductOption", {
        page: 0,
        limit: 1000,
        optionWithCode: true,
        qiTypes: qiTypesArray
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductCodeOptions = [];
          data.forEach(function (element) {
            self.qiProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    reLoadUsersIdOptions: function reLoadUsersIdOptions() {
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions: function LoadUsersIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      if (action === __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/QIJobs/User/Options", {
          page: 1,
          search: searchQuery,
          type: ["JOB_QI_TYPE_PRODUCT_RECEIVE"],
          all: true
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            var result = [];
            data.forEach(function (element) {
              result.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, result);
        }).catch(function (error) {});
      }
    },

    formReset: function formReset(e) {
      this.qiKeyword = null;
      this.qiProductCode = null;
      this.qiUserId = [];
      this.jobsDateStart = null;
      this.jobsDateEnd = null;
      $("#jobsDateStart").val("").trigger("change");
      $("#jobsDateEnd").val("").trigger("change");
      $("#qiUserId").val("").trigger("change");
      $("#qiProductCode").val("").trigger("change");
      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#qiRecvTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#qiRecvTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreProductCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.jobsDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.jobsDateStart).on("changeDate", function (e) {
                self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.jobsDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.jobsDateEnd).on("changeDate", function (e) {
                self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#qiRecvTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/QIJobs/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      SearchKeyword: self.qiKeyword,
                      StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
                      EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
                      QIJobTypeCode: ["JOB_QI_TYPE_PRODUCT_RECEIVE"],
                      ProductCode: self.qiProductCode,
                      QIJobUsersId: self.qiUserId
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [30, 50, 100],
                pageLength: 30,
                language: { lengthMenu: "Display _MENU_" },

                // Order settings
                order: [[5, "desc"]],
                columns: [{
                  data: "qiJobNumber",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data ? data : '-';
                  }
                }, {
                  data: "refCode",
                  className: "text-center"
                }, {
                  data: "amount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (!full.sumItems) return '-';

                    return Number(full.sumItems).toLocaleString('en-US');
                  }
                }, {
                  data: "materialNameShow",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.items && full.items.length > 0) {
                      var displayItems = full.items.slice(0, 2).map(function (item) {
                        return item.materialName + ' [' + item.materialCode + ']';
                      }).join(',<br> ');
                      var expandIcon = full.items.length > 2 ? '<a href="/Maintain/Recv/Detail/' + full.qiJobId + '" class="btn btn-link btn-sm px-0 py-0"><i class="fa fa-search"></i></a>' : '';
                      return displayItems + " " + (full.items.length > 2 ? '...' : '') + " " + expandIcon;
                    }
                    return data ? data : '-';
                  }
                }, {
                  data: "qiStatusName",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.qiStatusCode == "JOB_QI_STATUS_SUCCESS") {
                      return '<span><i class="fa fa-check-circle"></i> ' + data + "</span>";
                    }
                    return data ? data : '-';
                  }
                }, {
                  data: "CreatedDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.createdDateFormat;
                  }
                }, { data: "createdUserName", className: "text-center" }, {
                  data: "qiJobId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_5__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var Action = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div style=\"display: flex; flex-direction: row; align-items: center; justify-content: center\">\n    <a href=\"#\" @click.prevent=\"detailQi\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\" class=\"btn btn-sm btn-clean btn-icon\">\n      <i class=\"fa fa-search\"></i>\n    </a>\n  </div>",
  methods: {
    detailQi: function detailQi() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Maintain/Recv/Detail/" + this.data.qiJobId
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_3__Shared_Datepicker__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      qiProductCode: null,
      qiProductCodeOptions: [],
      qiUserId: [],
      qiUserOptions: []
    };
  },
  methods: {
    LoadreProductCodeOptions: function LoadreProductCodeOptions(e) {
      var self = this;
      var qiTypesArray = ['QiSpare'];
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("/Api/QIJobs/ProductOption", {
        page: 0,
        limit: 1000,
        optionWithCode: true,
        qiTypes: qiTypesArray
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductCodeOptions = [];
          data.forEach(function (element) {
            self.qiProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    reLoadUsersIdOptions: function reLoadUsersIdOptions() {
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions: function LoadUsersIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("/Api/QIJobs/User/Options", {
          page: 1,
          search: searchQuery,
          type: ["JOB_QI_TYPE_DRAWBACK"],
          all: true
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            var result = [];
            data.forEach(function (element) {
              result.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, result);
        }).catch(function (error) {});
      }
    },

    formReset: function formReset(e) {
      this.jobsDateStart = null;
      this.jobsDateEnd = null;
      this.qiProductCode = null;
      this.qiUserId = [];
      $("#jobsDateStart").val("").trigger("change");
      $("#jobsDateEnd").val("").trigger("change");
      $("#qiUserId").val("").trigger("change");
      $("#qiProductCode").val("").trigger("change");
      this.formSubmit(e);
    },
    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        method: "post",
        url: "/Api/QIJobs/ExportStockByUser",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          QIProductCode: self.qiProductCode,
          QIUserId: self.qiUserId
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#qiStockTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#qiStockTable").DataTable().ajax.reload(null, resetPaging);
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreProductCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.jobsDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.jobsDateStart).on("changeDate", function (e) {
                self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.jobsDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.jobsDateEnd).on("changeDate", function (e) {
                self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#qiStockTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/QIJobs/SearchSpare",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
                      EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
                      QIProductCode: self.qiProductCode,
                      QIUserId: self.qiUserId
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [30, 50, 100],
                pageLength: 30,
                language: { lengthMenu: "Display _MENU_" },
                order: self.$root.user.profile.role == "QI_QIMAINTAIN" ? [[5, "desc"]] : [[1, "asc"]],
                columns: [{ data: "materialNameShow", className: "text-center" }, { data: "fullName", className: "text-center", visible: _this.$root.user.profile.role != "QI_QIMAINTAIN" }, {
                  data: "issuedOut", className: "text-center",
                  render: function render(data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                  }
                }, {
                  data: "used", className: "text-center",
                  render: function render(data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                  }
                }, {
                  data: "return", className: "text-center",
                  render: function render(data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                  }
                }, {
                  data: "avaliable", className: "text-center",
                  render: function render(data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import the component

// import the styles


__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      finishedDateStart: null,
      finishedDateEnd: null,
      qiProductCode: null,
      qiProductType: null,
      checkerStatus: null,
      qiProductCodeOptions: [],
      qiProductTypeOptions: [],
      qiProductBrandOptions: [],
      qiCheckerStatusOptions: [],
      qiOldBarcode: null,
      qiJobNumber: null,
      qiUserId: []
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      this.jobsDateStart = null;
      this.jobsDateEnd = null;
      this.finishedDateStart = null;
      this.finishedDateEnd = null;
      this.qiProductCode = null;
      this.qiProductType = null;
      this.checkerStatus = null;
      this.qiOldBarcode = null;
      this.qiJobNumber = null;
      this.qiUserId = [];

      $("#jobsDateStart").val("").trigger("change");
      $("#jobsDateEnd").val("").trigger("change");
      $("#finishedDateStart").val("").trigger("change");
      $("#finishedDateEnd").val("").trigger("change");
      $("#qiProductCode").val("").trigger("change");
      $("#qiProductType").val("").trigger("change");
      $("#checkerStatus").val("").trigger("change");
      $("#qiUserId").val("").trigger("change");

      // this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#reportTable").DataTable();
      table.search();
      table.draw();
    },
    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/QIJobs/ExportChecker",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          QIProductCode: self.qiProductCode,
          QIProductType: self.qiProductType,
          QICheckerStatus: self.checkerStatus,
          Barcode: self.qiOldBarcode,
          QIJobNumber: self.qiJobNumber,
          QiUserId: self.qiUserId,
          FinishedStartDate: self.finishedDateStart != null ? self.finishedDateStart.format("DD/MM/YYYY") : null,
          FinishedEndDate: self.finishedDateEnd != null ? self.finishedDateEnd.format("DD/MM/YYYY") : null
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    LoadreProductCodeOptions: function LoadreProductCodeOptions(e) {
      var self = this;
      var qiTypesArray = ['QiSpare', 'QiMachine', 'QiEquipment'];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/QIJobs/ProductOption", {
        page: 0,
        limit: 1000,
        optionWithCode: true,
        qiTypes: qiTypesArray
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductCodeOptions = [];
          data.forEach(function (element) {
            self.qiProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreQIProductTypeOptions: function LoadreQIProductTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/QIJobs/SubProductType").then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductTypeOptions = [];
          data.forEach(function (element) {
            self.qiProductTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreQIProductBrandOptions: function LoadreQIProductBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductBrandOptions = [];
          data.forEach(function (element) {
            self.qiProductBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreEvalStatusOptionsOptions: function LoadreEvalStatusOptionsOptions(e) {
      var self = this;
      self.qiCheckerStatusOptions = [];
      var data = [{
        id: "StatusChecked",
        text: "รับเข้าคลังดีแล้ว"
      }, {
        id: "StatusWait",
        text: "ยังไม่ได้รับเข้าคลังดี"
      }];
      data.forEach(function (element) {
        self.qiCheckerStatusOptions.push({
          id: element.id,
          label: element.text
        });
      });
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    reLoadUsersIdOptions: function reLoadUsersIdOptions() {
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions: function LoadUsersIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/QIJobs/User/Options", {
          page: 1,
          search: searchQuery,
          all: true
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            var result = [];
            data.forEach(function (element) {
              result.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, result);
        }).catch(function (error) {});
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreProductCodeOptions();
              self.LoadreQIProductTypeOptions();
              self.LoadreQIProductBrandOptions();
              self.LoadreEvalStatusOptionsOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.jobsDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.jobsDateStart).on("changeDate", function (e) {
                self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.jobsDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.jobsDateEnd).on("changeDate", function (e) {
                self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.finishedDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.finishedDateStart).on("changeDate", function (e) {
                self.finishedDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.finishedDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.finishedDateEnd).on("changeDate", function (e) {
                self.finishedDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#reportTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/QIJobs/SearchChecker",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
                      EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
                      QIProductCode: self.qiProductCode,
                      QIProductType: self.qiProductType,
                      QICheckerStatus: self.checkerStatus,
                      Barcode: self.qiOldBarcode,
                      QIJobNumber: self.qiJobNumber,
                      QiUserId: self.qiUserId,
                      FinishedStartDate: self.finishedDateStart != null ? self.finishedDateStart.format("DD/MM/YYYY") : null,
                      FinishedEndDate: self.finishedDateEnd != null ? self.finishedDateEnd.format("DD/MM/YYYY") : null
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [30, 50, 100],
                pageLength: 30,
                language: { lengthMenu: "Display _MENU_" },
                // order: [[10, "asc"]],
                ordering: false,
                columns: [{
                  data: "checkerDate",
                  className: "text-center",
                  render: function render(data) {
                    return data ? moment(data).format("DD/MM/YYYY") : "ยังไม่ได้รับเข้าคลังดี";
                  }
                }, {
                  data: "checkerDate",
                  className: "text-center",
                  render: function render(data) {
                    return data ? moment(data).format("MM") : "-";
                  }
                }, {
                  data: "checkerDate",
                  className: "text-center",
                  render: function render(data) {
                    return data ? moment(data).format("YYYY") : "-";
                  }
                }, {
                  data: "qiJobNumber",
                  className: "text-center",
                  render: function render(data) {
                    return data && data.trim() ? data : "-";
                  }
                }, {
                  data: "subProductTypeName",
                  className: "text-center",
                  render: function render(data) {
                    return data && data.trim() ? data : "-";
                  }
                }, {
                  data: "materialCode",
                  className: "text-center",
                  render: function render(data) {
                    return data && data.trim() ? data : "-";
                  }
                }, {
                  data: "materialName",
                  className: "text-center",
                  render: function render(data) {
                    return data && data.trim() ? data : "-";
                  }
                }, {
                  data: "amount",
                  className: "text-center",
                  render: function render(data) {
                    return data !== null && data !== undefined ? Number(data).toLocaleString('en-US') : 0;
                  }
                }, {
                  data: "barcodeNoOld",
                  className: "text-center",
                  render: function render(data) {
                    return data && data.trim() ? data : "ไม่มี BARCODE";
                  }
                }, {
                  data: null,
                  className: "text-center",
                  render: function render(data, type, row) {
                    return row.firstName && row.lastName ? row.firstName + " " + row.lastName : row.fullName ? row.fullName : "-";
                  }
                }, {
                  data: null,
                  className: "text-center",
                  render: function render(data, type, row) {
                    var guaranteeDate = row.qiSubType === 1 ? row.machGuaranteeDate : row.qiSubType === 2 ? row.eqptGuaranteeDate : null;
                    return guaranteeDate ? moment(guaranteeDate).format("DD/MM/YYYY") : "-";
                  }
                }, {
                  data: "finishedDate",
                  className: "text-center",
                  render: function render(data) {
                    return data ? moment(data).format("DD/MM/YYYY") : "-";
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                DatatableWarning.alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import the component

// import the styles


__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      qiProductCode: null,
      jobStatus: null,
      qiJobNumber: null,
      jobArea: [],
      qiUserId: [],
      qiProductCodeOptions: [],
      qiJobAreaOptions: [],
      qiJobStatusOptions: []
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      this.jobsDateStart = moment().startOf('month');
      this.jobsDateEnd = moment();
      var startOfMonth = this.jobsDateStart.format('DD/MM/YYYY');
      var today = this.jobsDateEnd.format('DD/MM/YYYY');

      this.qiJobNumber = null;
      this.qiProductCode = null;
      this.jobArea = null;
      this.jobStatus = null;
      this.qiUserId = null;

      $("#qiProductCode").val("").trigger("change");
      $("#jobArea").val("").trigger("change");
      $("#jobStatus").val("").trigger("change");
      $("#qiUserId").val("").trigger("change");

      $(this.$refs.jobsDateStart).datepicker('update', startOfMonth);
      $(this.$refs.jobsDateEnd).datepicker('update', today);
      $(this.$refs.jobsDateStart).val(startOfMonth).trigger('change');
      $(this.$refs.jobsDateEnd).val(today).trigger('change');
      // this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#reportTable").DataTable();
      table.search();
      table.draw();
    },
    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/QIJobs/ExportDrawback",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          QIProductCode: self.qiProductCode,
          QIJobStatus: self.jobStatus,
          QIJobNumber: self.qiJobNumber,
          QIJobArea: self.jobArea,
          QIUserId: self.qiUserId
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    LoadreProductCodeOptions: function LoadreProductCodeOptions(e) {
      var self = this;
      var qiTypesArray = ['QiSpare'];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/QIJobs/ProductOption", {
        page: 0,
        limit: 1000,
        optionWithCode: true,
        qiTypes: qiTypesArray
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductCodeOptions = [];
          data.forEach(function (element) {
            self.qiProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadJobAreaOptions: function LoadJobAreaOptions(e) {
      var self = this;
      self.qiJobAreaOptions = [];
      var data = [{
        id: "Plant",
        text: "ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด"
      }, {
        id: "Agent",
        text: "ซ่อมในตัวแทนจำหน่าย"
      }];
      data.forEach(function (element) {
        self.qiJobAreaOptions.push({
          id: element.id,
          label: element.text
        });
      });
    },
    LoadJobStatusOptions: function LoadJobStatusOptions(e) {
      var self = this;
      self.qiJobStatusOptions = [];
      var data = [{
        id: "Out",
        text: "เบิก"
      }, {
        id: "In",
        text: "คืน"
      }, {
        id: "Recv",
        text: "รับเข้า"
      }];
      data.forEach(function (element) {
        self.qiJobStatusOptions.push({
          id: element.id,
          label: element.text
        });
      });
    },
    reLoadUsersIdOptions: function reLoadUsersIdOptions() {
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions: function LoadUsersIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/QIJobs/User/Options", {
          page: 1,
          search: searchQuery,
          type: ["JOB_QI_TYPE_DRAWBACK"],
          all: true
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            var result = [];
            data.forEach(function (element) {
              result.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, result);
        }).catch(function (error) {});
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, today, startOfMonth, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreProductCodeOptions();
              self.LoadJobAreaOptions();
              self.LoadJobStatusOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              today = moment();
              startOfMonth = moment().startOf('month');

              self.jobsDateStart = startOfMonth;
              self.jobsDateEnd = today;

              $(self.$refs.jobsDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              }).datepicker('setDate', startOfMonth.toDate());
              $(self.$refs.jobsDateStart).on("changeDate", function (e) {
                self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.jobsDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              }).datepicker('setDate', today.toDate());
              $(self.$refs.jobsDateEnd).on("changeDate", function (e) {
                self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#reportTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/QIJobs/SearchDrawback",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
                      EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
                      QIProductCode: self.qiProductCode,
                      QIJobStatus: self.jobStatus,
                      QIJobNumber: self.qiJobNumber,
                      QIJobArea: self.jobArea,
                      QIUserId: self.qiUserId
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [30, 50, 100],
                pageLength: 30,
                language: { lengthMenu: "Display _MENU_" },
                ordering: false,
                columns: [{
                  data: "finishedDate",
                  className: "text-center",
                  render: function render(data) {
                    return data ? moment(data).format("DD/MM/YYYY") : "";
                  }
                }, {
                  data: "finishedDate",
                  className: "text-center",
                  render: function render(data) {
                    return data ? moment(data).format("MM") : "-";
                  }
                }, {
                  data: "finishedDate",
                  className: "text-center",
                  render: function render(data) {
                    return data ? moment(data).format("YYYY") : "-";
                  }
                }, {
                  data: "qiAreaPlant",
                  className: "text-center",
                  render: function render(data) {
                    return data ? "ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด" : "ซ่อมในตัวแทนจำหน่าย";
                  }
                }, {
                  data: "qiTypeCode",
                  className: "text-center",
                  render: function render(data, type, row) {
                    if (data === "JOB_QI_TYPE_PRODUCT_RECEIVE") {
                      return "รับเข้า";
                    } else if (row.qiSubType === 1) {
                      return "เบิก";
                    } else if (row.qiSubType === 2) {
                      return "คืน";
                    }
                    return "-";
                  }
                }, {
                  data: "materialCode",
                  className: "text-center",
                  render: function render(data) {
                    return data ? data : "-";
                  }
                }, {
                  data: "materialName",
                  className: "text-center",
                  render: function render(data) {
                    return data ? data : "-";
                  }
                }, {
                  data: "quantity",
                  className: "text-center",
                  render: function render(data) {
                    return data !== null && data !== undefined ? Number(data).toLocaleString('en-US') : 0;
                  }
                }, {
                  data: "unitPrice",
                  className: "text-center",
                  render: function render(data) {
                    return data !== null && data !== undefined ? Number(data).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0;
                  }
                }, {
                  data: null,
                  className: "text-center",
                  render: function render(data, type, row) {
                    return Number(row.quantity * row.unitPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 0;
                  }
                }, {
                  data: "qiTypeCode",
                  className: "text-center",
                  render: function render(data, type, row) {
                    if (data === "JOB_QI_TYPE_PRODUCT_RECEIVE") {
                      return "-";
                    } else {
                      return row.firstName ? row.firstName + " " + row.lastName : row.fullName || "-";
                    }
                  }
                }, {
                  data: "qiTypeCode",
                  className: "text-center",
                  render: function render(data, type, row) {
                    if (data === "JOB_QI_TYPE_PRODUCT_RECEIVE") {
                      return row.firstName ? row.firstName + " " + row.lastName : row.fullName || "-";
                    } else {
                      return row.firstNameConfirm ? row.firstNameConfirm + " " + row.lastNameConfirm : row.fullNameConfirm || "-";
                    }
                  }
                }, {
                  data: "remark",
                  className: "text-center",
                  render: function render(data) {
                    return data ? data : "-";
                  }
                }, {
                  data: "qiJobNumber",
                  className: "text-center",
                  render: function render(data) {
                    return data ? data : "-";
                  }
                }, {
                  data: "refCode",
                  className: "text-center",
                  render: function render(data) {
                    return data ? data : "-";
                  }
                }]

              }).on("error.dt", function (e, settings, techNote, message) {
                DatatableWarning.alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    return {
      reYearStart: new Date().getFullYear(),
      reYearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{ id: new Date().getFullYear(), text: new Date().getFullYear() }, { id: new Date().getFullYear() - 1, text: new Date().getFullYear() - 1 }, { id: new Date().getFullYear() - 2, text: new Date().getFullYear() - 2 }]
      },
      months: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
      tableData: Array(12).fill().map(function () {
        return {
          fixCost: null,
          variableCost: 0,
          repairCost: 0,
          uplift: null
        };
      })
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      this.reYearStart = new Date().getFullYear();
      $("#reYearStart").val(this.reYearStart).trigger("change");
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
    },
    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/QIJobs/ReportSummary",
        responseType: "arraybuffer",
        data: {
          YearStart: self.reYearStart,
          IsExport: true
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    getSummaryData: function getSummaryData() {
      var self = this;
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/QIJobs/CalReportSummary",
        data: {
          YearStart: self.reYearStart,
          IsRecal: false
        }
      }).then(function (response) {
        if (response.status == "200") {
          var apiData = response.data;

          var months = Array.from({ length: 12 }, function (_, i) {
            return {
              month: i + 1,
              fixCost: null,
              variableCost: 0,
              repairCost: 0,
              uplift: null
            };
          });
          apiData.forEach(function (item) {
            var monthIndex = item.month - 1;
            months[monthIndex].fixCost += item.fixCost || 0;
            months[monthIndex].variableCost += item.variableCost || 0;
            months[monthIndex].repairCost += item.repairCost || 0;
            months[monthIndex].uplift += item.uplift || 0;
          });
          self.tableData = months.map(function (month) {
            return {
              month: month.month,
              fixCost: month.fixCost || null,
              variableCost: month.variableCost || 0,
              repairCost: month.repairCost || 0,
              uplift: month.uplift || null
            };
          });
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    Recalculate: function Recalculate(index) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var self;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;


                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
                });

                __WEBPACK_IMPORTED_MODULE_1_axios___default()({
                  method: "post",
                  url: "/Api/QIJobs/CalReportSummary",
                  data: {
                    YearStart: self.reYearStart,
                    monthStart: self.tableData[index].month,
                    IsRecal: true
                  }
                }).then(function (response) {
                  if (response.status == "200") {
                    var data = response.data;
                    if (data.length > 0) {
                      var result = data[0];
                      self.$set(self.tableData, index, {
                        month: self.tableData[index].month,
                        fixCost: self.tableData[index].fixCost || null,
                        uplift: self.tableData[index].uplift || null,
                        variableCost: result.variableCost || 0,
                        repairCost: result.repairCost || 0
                      });
                    } else {
                      Swal.fire("ไม่สามารถคำนวณใหม่ได้ เนื่องจากไม่มีข้อมูล", "", "warning");
                    }
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  KTApp.unblockPage();
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    saveSummary: function saveSummary(rowIndex) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self, summaryData, dataToSave;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this2;
                summaryData = _this2.tableData[rowIndex];

                if (!(summaryData.fixCost === undefined || summaryData.fixCost == null || summaryData.fixCost == "")) {
                  _context2.next = 5;
                  break;
                }

                Swal.fire("", "กรุณาระบุ Fix Cost", "warning");
                return _context2.abrupt("return", false);

              case 5:
                if (!(summaryData.uplift === undefined || summaryData.uplift == null || summaryData.uplift == "")) {
                  _context2.next = 8;
                  break;
                }

                Swal.fire("", "กรุณาระบุ % Uplift", "warning");
                return _context2.abrupt("return", false);

              case 8:

                KTApp.blockPage({
                  opacity: 0.05,
                  message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
                });

                dataToSave = {
                  year: _this2.reYearStart,
                  month: summaryData.month,
                  fixCost: summaryData.fixCost,
                  variableCost: summaryData.variableCost,
                  totalMaintainCost: parseFloat(_this2.calculateTotalCost(summaryData.fixCost, summaryData.variableCost)),
                  repairCost: summaryData.repairCost,
                  costReduction: parseFloat(_this2.calculateCostReduction(_this2.calculateTotalCost(summaryData.fixCost, summaryData.variableCost), summaryData.repairCost)),
                  percentage: parseFloat(_this2.calculatePercentage(_this2.calculateCostReduction(_this2.calculateTotalCost(summaryData.fixCost, summaryData.variableCost), summaryData.repairCost), summaryData.repairCost)),
                  uplift: summaryData.uplift
                };


                __WEBPACK_IMPORTED_MODULE_1_axios___default()({
                  method: "post",
                  url: "/Api/QIJobs/SaveSummary",
                  data: dataToSave
                }).then(function (response) {
                  if (response.data.status) {
                    Swal.fire("บันทึกข้อมูลสำเร็จ", "", "success");
                  } else {
                    Swal.fire("ไม่สามารถบันทึกข้อมูลได้", "", "error");
                  }
                }).catch(function (error) {
                  Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
                }).then(function () {
                  KTApp.unblockPage();
                  self.getSummaryData();
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    calculateTotalCost: function calculateTotalCost(fixCost, variableCost) {
      return ((fixCost || 0) + (variableCost || 0)).toFixed(2);
    },
    calculateCostReduction: function calculateCostReduction(totalCost, repairCost) {
      return ((repairCost || 0) - (totalCost || 0)).toFixed(2);
    },
    calculatePercentage: function calculatePercentage(costReduction, repairCost) {
      return repairCost !== 0 ? (costReduction / repairCost * 100).toFixed(2) : 0;
    },
    sumColumn: function sumColumn(column) {
      var sum = this.tableData.reduce(function (acc, item) {
        return acc + (parseFloat(item[column]) || 0);
      }, 0);
      return sum.toFixed(2);
    },
    sumTotalCost: function sumTotalCost() {
      var _this3 = this;

      var sum = this.tableData.reduce(function (acc, item) {
        return acc + parseFloat(_this3.calculateTotalCost(item.fixCost, item.variableCost));
      }, 0);
      return sum.toFixed(2);
    },
    sumCostReduction: function sumCostReduction() {
      var _this4 = this;

      var sum = this.tableData.reduce(function (acc, item) {
        return acc + parseFloat(_this4.calculateCostReduction(_this4.calculateTotalCost(item.fixCost, item.variableCost), item.repairCost));
      }, 0);
      return sum.toFixed(2);
    },
    sumPercentage: function sumPercentage() {
      var totalCostReduction = this.sumCostReduction();
      var totalServiceCost = this.sumColumn('repairCost');
      return totalServiceCost !== 0 ? (totalCostReduction / totalServiceCost * 100).toFixed(1) : 0;
    },
    sumColumnUplift: function sumColumnUplift() {
      var validMonths = this.tableData.filter(function (item) {
        return item.uplift !== null && item.uplift !== undefined && item.uplift !== '';
      });
      var sum = validMonths.reduce(function (acc, item) {
        return acc + (parseFloat(item.uplift) || 0);
      }, 0);
      var avgUplift = validMonths.length > 0 ? (sum / validMonths.length).toFixed(1) : 0;
      return avgUplift;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this5.getSummaryData();

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  },

  watch: {
    reYearStart: function reYearStart(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getSummaryData();
      }
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import the component

// import the styles

__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      reYearStart: new Date().getFullYear(),
      reYearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }, {
          id: new Date().getFullYear() - 2,
          text: new Date().getFullYear() - 2,
          data: null
        }]
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      this.reYearStart = new Date().getFullYear();
      $("#reYearStart").val(this.reYearStart).trigger("change");
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#reportTable").DataTable();
      table.search();
      table.draw();
    },
    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/QIJobs/ExportRepairSum",
        responseType: "arraybuffer",
        data: {
          YearStart: self.reYearStart
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table, monthNames;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.jobsDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.jobsDateStart).on("changeDate", function (e) {
                self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.jobsDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.jobsDateEnd).on("changeDate", function (e) {
                self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#reportTable");
              monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

              table.DataTable({
                responsive: false,
                scrollX: true,
                scrollCollapse: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/QIJobs/SearchRepairSum",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      YearStart: self.reYearStart
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  },
                  dataSrc: function dataSrc(json) {
                    var dataFromApi = json.data || [];
                    var fullMonthData = monthNames.map(function (monthName, index) {
                      var monthIndex = index + 1;
                      var monthData = dataFromApi.find(function (d) {
                        return d.month === monthIndex;
                      }) || {};
                      return {
                        month: monthName,
                        totalRepairPlantMac: monthData.totalRepairPlantMac || 0,
                        totalServiceCostPlantMac: monthData.totalServiceCostPlantMac || 0,
                        totalItemsPlantMac: monthData.totalItemsPlantMac || 0,
                        totalItemsCostPlantMac: monthData.totalItemsCostPlantMac || 0,
                        totalRepairPlantEqpt: monthData.totalRepairPlantEqpt || 0,
                        totalServiceCostPlantEqpt: monthData.totalServiceCostPlantEqpt || 0,
                        totalItemsPlantEqpt: monthData.totalItemsPlantEqpt || 0,
                        totalItemsCostPlantEqpt: monthData.totalItemsCostPlantEqpt || 0,
                        totalRepairAgentCount: monthData.totalRepairAgentCount || 0,
                        totalRepairAgentMac: monthData.totalRepairAgentMac || 0,
                        totalServiceCostAgentMac: monthData.totalServiceCostAgentMac || 0,
                        totalRepairAgentEqpt: monthData.totalRepairAgentEqpt || 0,
                        totalServiceCostAgentEqpt: monthData.totalServiceCostAgentEqpt || 0,
                        totalItemsAgent: monthData.totalItemsAgent || 0,
                        totalItemsCostAgent: monthData.totalItemsCostAgent || 0
                      };
                    });
                    return fullMonthData;
                  }
                },
                info: false,
                paging: false,
                searching: false,
                ordering: false,
                columns: [{ data: "month", className: "text-center", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalRepairPlantMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalServiceCostPlantMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalItemsPlantMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalItemsCostPlantMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalRepairPlantEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalServiceCostPlantEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalItemsPlantEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalItemsCostPlantEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalRepairAgentCount", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalRepairAgentMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalServiceCostAgentMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalRepairAgentEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalServiceCostAgentEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalItemsAgent", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }, { data: "totalItemsCostAgent", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') }],
                footerCallback: function footerCallback(row, data, start, end, display) {
                  var api = this.api();

                  var intVal = function intVal(i) {
                    return typeof i === "string" ? i.replace(/[\$,]/g, "") * 1 : typeof i === "number" ? i : 0;
                  };

                  api.columns([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], { page: "current" }).every(function () {
                    var sum = this.data().reduce(function (a, b) {
                      return intVal(a) + intVal(b);
                    }, 0);
                    $(this.footer()).html($.fn.dataTable.render.number(',', '.', 0, '').display(sum));
                  });

                  var totalService = api.column(2).data().reduce(function (a, b) {
                    return intVal(a) + intVal(b);
                  }, 0) + api.column(6).data().reduce(function (a, b) {
                    return intVal(a) + intVal(b);
                  }, 0) + api.column(11).data().reduce(function (a, b) {
                    return intVal(a) + intVal(b);
                  }, 0) + api.column(13).data().reduce(function (a, b) {
                    return intVal(a) + intVal(b);
                  }, 0);

                  var totalParts = api.column(4).data().reduce(function (a, b) {
                    return intVal(a) + intVal(b);
                  }, 0) + api.column(8).data().reduce(function (a, b) {
                    return intVal(a) + intVal(b);
                  }, 0) + api.column(15).data().reduce(function (a, b) {
                    return intVal(a) + intVal(b);
                  }, 0);

                  $('#totalService').html($.fn.dataTable.render.number(',', '.', 0, '').display(totalService));
                  $('#totalParts').html($.fn.dataTable.render.number(',', '.', 0, '').display(totalParts));
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                DatatableWarning.alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import the component

// import the styles


__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      qiProductCode: null,
      jobSubtype: null,
      qiProductCodeOptions: [],
      qiEvalStatusOptions: [],
      qiJobSubtype: [],
      qiUserId: [],
      jobArea: [],
      qiJobAreaOptions: [],
      qiOldBarcode: null,
      qiJobNumber: null
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      this.jobsDateStart = moment().startOf('month');
      this.jobsDateEnd = moment();
      var startOfMonth = this.jobsDateStart.format('DD/MM/YYYY');
      var today = this.jobsDateEnd.format('DD/MM/YYYY');

      this.qiProductCode = null;
      this.qiProductType = null;
      this.qiProductBrand = null;
      this.qiEvalStatus = null;
      this.qiOldBarcode = null;
      this.qiJobNumber = null;

      $("#qiProductCode").val("").trigger("change");
      $("#qiProductType").val("").trigger("change");
      $("#qiProductBrand").val("").trigger("change");
      $("#qiEvalStatus").val("").trigger("change");

      $(this.$refs.jobsDateStart).datepicker('update', startOfMonth);
      $(this.$refs.jobsDateEnd).datepicker('update', today);
      $(this.$refs.jobsDateStart).val(startOfMonth).trigger('change');
      $(this.$refs.jobsDateEnd).val(today).trigger('change');

      // this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
    },
    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/QIJobs/ExportRepairUsage",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          Barcode: self.qiOldBarcode,
          QIJobNumber: self.qiJobNumber,
          QIProductCode: self.qiProductCode,
          QISubtype: self.jobSubtype,
          QIJobArea: self.jobArea,
          QIUserId: self.qiUserId
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    LoadreProductCodeOptions: function LoadreProductCodeOptions(e) {
      var self = this;
      var qiTypesArray = ['QiMachine', 'QiEquipment'];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/QIJobs/ProductOption", {
        page: 0,
        limit: 1000,
        optionWithCode: true,
        qiTypes: qiTypesArray
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductCodeOptions = [];
          data.forEach(function (element) {
            self.qiProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadJobAreaOptions: function LoadJobAreaOptions(e) {
      var self = this;
      self.qiJobAreaOptions = [];
      var data = [{
        id: "Plant",
        text: "ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด"
      }, {
        id: "Agent",
        text: "ซ่อมในตัวแทนจำหน่าย"
      }];
      data.forEach(function (element) {
        self.qiJobAreaOptions.push({
          id: element.id,
          label: element.text
        });
      });
    },
    LoadreSubtypeOptions: function LoadreSubtypeOptions(e) {
      var self = this;
      self.qiJobSubtype = [];
      var data = [{
        id: "1",
        text: "เครื่องเบียร์สด"
      }, {
        id: "2",
        text: "อุปกรณ์เบียร์สด"
      }];
      data.forEach(function (element) {
        self.qiJobSubtype.push({
          id: element.id,
          label: element.text
        });
      });
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    reLoadUsersIdOptions: function reLoadUsersIdOptions() {
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions: function LoadUsersIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/QIJobs/User/Options", {
          page: 1,
          search: searchQuery,
          all: true
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            var result = [];
            data.forEach(function (element) {
              result.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, result);
        }).catch(function (error) {});
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, today, startOfMonth;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreProductCodeOptions();
              self.LoadreSubtypeOptions();
              self.LoadJobAreaOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              today = moment();
              startOfMonth = moment().startOf('month');

              self.jobsDateStart = startOfMonth;
              self.jobsDateEnd = today;

              $(self.$refs.jobsDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              }).datepicker('setDate', startOfMonth.toDate());
              $(self.$refs.jobsDateStart).on("changeDate", function (e) {
                self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.jobsDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              }).datepicker('setDate', today.toDate());
              $(self.$refs.jobsDateEnd).on("changeDate", function (e) {
                self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import the component

// import the styles

__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      qiProductCode: null,
      qiProductCodeOptions: []
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      this.jobsDateStart = moment().startOf('month');
      this.jobsDateEnd = moment();
      var startOfMonth = this.jobsDateStart.format('DD/MM/YYYY');
      var today = this.jobsDateEnd.format('DD/MM/YYYY');

      this.qiProductCode = null;

      $("#qiProductCode").val("").trigger("change");

      $(this.$refs.jobsDateStart).datepicker('update', startOfMonth);
      $(this.$refs.jobsDateEnd).datepicker('update', today);
      $(this.$refs.jobsDateStart).val(startOfMonth).trigger('change');
      $(this.$refs.jobsDateEnd).val(today).trigger('change');
      // this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#reportTable").DataTable();
      table.search();
      table.draw();
    },
    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/QIJobs/ExportStockSparePart",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          QIProductCode: self.qiProductCode
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    LoadreProductCodeOptions: function LoadreProductCodeOptions(e) {
      var self = this;
      var qiTypesArray = ['QiSpare'];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/QIJobs/ProductOption", {
        page: 0,
        limit: 1000,
        optionWithCode: true,
        qiTypes: qiTypesArray
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductCodeOptions = [];
          data.forEach(function (element) {
            self.qiProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, today, startOfMonth, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreProductCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              today = moment();
              startOfMonth = moment().startOf('month');

              self.jobsDateStart = startOfMonth;
              self.jobsDateEnd = today;

              $(self.$refs.jobsDateStart).datepicker({
                autoclose: true,
                clearBtn: false,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              }).datepicker('setDate', startOfMonth.toDate());
              $(self.$refs.jobsDateStart).on("changeDate", function (e) {
                self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.jobsDateEnd).datepicker({
                autoclose: true,
                clearBtn: false,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              }).datepicker('setDate', today.toDate());
              $(self.$refs.jobsDateEnd).on("changeDate", function (e) {
                self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#reportTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/QIJobs/StockSparePart",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
                      EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
                      QIProductCode: self.qiProductCode
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [30, 50, 100],
                pageLength: 30,
                language: { lengthMenu: "Display _MENU_" },
                ordering: false,
                columns: [{
                  data: "materialCode",
                  className: "text-center",
                  render: function render(data) {
                    return data && data.trim() ? data : "-";
                  }
                }, {
                  data: "materialName",
                  className: "text-center",
                  render: function render(data) {
                    return data && data.trim() ? data : "-";
                  }
                }, {
                  data: "beginningBalance",
                  className: "text-center",
                  render: function render(data) {
                    return data !== null && data !== undefined ? Number(data).toLocaleString('en-US') : 0;
                  }
                }, {
                  data: "receiveIn",
                  className: "text-center",
                  render: function render(data) {
                    return data !== null && data !== undefined ? Number(data).toLocaleString('en-US') : 0;
                  }
                }, {
                  data: "total",
                  className: "text-center",
                  render: function render(data) {
                    return data !== null && data !== undefined ? Number(data).toLocaleString('en-US') : 0;
                  }
                }, {
                  data: "issuedOut",
                  className: "text-center",
                  render: function render(data) {
                    return data !== null && data !== undefined ? Number(data).toLocaleString('en-US') : 0;
                  }
                }, {
                  data: "return",
                  className: "text-center",
                  render: function render(data) {
                    return data !== null && data !== undefined ? Number(data).toLocaleString('en-US') : 0;
                  }
                }, {
                  data: "remaining",
                  className: "text-center",
                  render: function render(data) {
                    return data !== null && data !== undefined ? Number(data).toLocaleString('en-US') : 0;
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                DatatableWarning.alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import the component

// import the styles


__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      jobSubtype: null,
      qiProductCode: null,
      qiJobSubtype: [],
      qiProductCodeOptions: []
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      this.jobsDateStart = moment().startOf('month');
      this.jobsDateEnd = moment();
      var startOfMonth = this.jobsDateStart.format('DD/MM/YYYY');
      var today = this.jobsDateEnd.format('DD/MM/YYYY');

      this.qiProductCode = null;
      this.jobSubtype = null;

      $("#qiProductCode").val("").trigger("change");
      $("#jobSubtype").val("").trigger("change");

      $(this.$refs.jobsDateStart).datepicker('update', startOfMonth);
      $(this.$refs.jobsDateEnd).datepicker('update', today);
      $(this.$refs.jobsDateStart).val(startOfMonth).trigger('change');
      $(this.$refs.jobsDateEnd).val(today).trigger('change');
      // this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
    },
    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/QIJobs/ExportSparePartsUsed",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          QIProductCode: self.qiProductCode,
          QISubtype: self.jobSubtype
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    LoadreProductCodeOptions: function LoadreProductCodeOptions(e) {
      var self = this;
      var qiTypesArray = ['QiMachine', 'QiEquipment'];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/QIJobs/ProductOption", {
        page: 0,
        limit: 1000,
        optionWithCode: true,
        qiTypes: qiTypesArray
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductCodeOptions = [];
          data.forEach(function (element) {
            self.qiProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreSubtypeOptions: function LoadreSubtypeOptions(e) {
      var self = this;
      self.qiJobSubtype = [];
      var data = [{
        id: "1",
        text: "เครื่องเบียร์สด"
      }, {
        id: "2",
        text: "อุปกรณ์เบียร์สด"
      }];
      data.forEach(function (element) {
        self.qiJobSubtype.push({
          id: element.id,
          label: element.text
        });
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, today, startOfMonth;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreProductCodeOptions();
              self.LoadreSubtypeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              today = moment();
              startOfMonth = moment().startOf('month');

              self.jobsDateStart = startOfMonth;
              self.jobsDateEnd = today;

              $(self.$refs.jobsDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              }).datepicker('setDate', startOfMonth.toDate());
              $(self.$refs.jobsDateStart).on("changeDate", function (e) {
                self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.jobsDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              }).datepicker('setDate', today.toDate());
              $(self.$refs.jobsDateEnd).on("changeDate", function (e) {
                self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import the component

// import the styles


__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      qiProductCode: null,
      qiProductType: null,
      qiProductBrand: null,
      qiEvalStatus: null,
      qiProductCodeOptions: [],
      qiProductTypeOptions: [],
      qiProductBrandOptions: [],
      qiEvalStatusOptions: [],
      qiOldBarcode: null,
      qiJobNumber: null
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      this.jobsDateStart = moment().startOf('month');
      this.jobsDateEnd = moment();
      var startOfMonth = this.jobsDateStart.format('DD/MM/YYYY');
      var today = this.jobsDateEnd.format('DD/MM/YYYY');

      this.qiProductCode = null;
      this.qiProductType = null;
      this.qiProductBrand = null;
      this.qiEvalStatus = null;
      this.qiOldBarcode = null;
      this.qiJobNumber = null;

      $("#qiProductCode").val("").trigger("change");
      $("#qiProductType").val("").trigger("change");
      $("#qiProductBrand").val("").trigger("change");
      $("#qiEvalStatus").val("").trigger("change");

      $(this.$refs.jobsDateStart).datepicker('update', startOfMonth);
      $(this.$refs.jobsDateEnd).datepicker('update', today);
      $(this.$refs.jobsDateStart).val(startOfMonth).trigger('change');
      $(this.$refs.jobsDateEnd).val(today).trigger('change');

      // this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#reportTable").DataTable();
      table.search();
      table.draw();
    },
    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/QIJobs/ExportStockPending",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          QIProductCode: self.qiProductCode,
          QIProductType: self.qiProductType,
          QIProductBrand: self.qiProductBrand,
          QIEvalStatus: self.qiEvalStatus,
          Barcode: self.qiOldBarcode,
          QIJobNumber: self.qiJobNumber
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    LoadreProductCodeOptions: function LoadreProductCodeOptions(e) {
      var self = this;
      var qiTypesArray = ['QiSpare', 'QiMachine', 'QiEquipment'];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/QIJobs/ProductOption", {
        page: 0,
        limit: 1000,
        optionWithCode: true,
        qiTypes: qiTypesArray
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductCodeOptions = [];
          data.forEach(function (element) {
            self.qiProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreQIProductTypeOptions: function LoadreQIProductTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/QIJobs/SubProductType").then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductTypeOptions = [];
          data.forEach(function (element) {
            self.qiProductTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreQIProductBrandOptions: function LoadreQIProductBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.qiProductBrandOptions = [];
          data.forEach(function (element) {
            self.qiProductBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreEvalStatusOptions: function LoadreEvalStatusOptions(e) {
      var self = this;
      self.qiEvalStatusOptions = [];
      var data = [{
        id: "StatusRepair",
        text: "รอซ่อม"
      }, {
        id: "StatusMaintain",
        text: "รอบำรุงรักษา"
      }, {
        id: "StatusDestroy",
        text: "รอทำลาย"
      }, {
        id: "StatusRepairSupplier",
        text: "ส่งซ่อมซัพพลายเออร์"
      }];
      data.forEach(function (element) {
        self.qiEvalStatusOptions.push({
          id: element.id,
          label: element.text
        });
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, today, startOfMonth, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreProductCodeOptions();
              self.LoadreQIProductTypeOptions();
              self.LoadreQIProductBrandOptions();
              self.LoadreEvalStatusOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              today = moment();
              startOfMonth = moment().startOf('month');

              self.jobsDateStart = startOfMonth;
              self.jobsDateEnd = today;

              $(self.$refs.jobsDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              }).datepicker('setDate', startOfMonth.toDate());
              $(self.$refs.jobsDateStart).on("changeDate", function (e) {
                self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.jobsDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              }).datepicker('setDate', today.toDate());
              $(self.$refs.jobsDateEnd).on("changeDate", function (e) {
                self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#reportTable");
              // begin first table

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/QIJobs/StockPending",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
                      EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
                      QIProductCode: self.qiProductCode,
                      QIProductType: self.qiProductType,
                      QIProductBrand: self.qiProductBrand,
                      QIEvalStatus: self.qiEvalStatus,
                      Barcode: self.qiOldBarcode,
                      QIJobNumber: self.qiJobNumber
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [30, 50, 100],
                pageLength: 30,
                language: { lengthMenu: "Display _MENU_" },
                order: [[7, "asc"]],
                ordering: false,
                columns: [{
                  data: "subProductTypeName", className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data ? data : '-';
                  }
                }, {
                  data: "materialCode", className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data ? data : '-';
                  }
                }, {
                  data: "materialName", className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data ? data : '-';
                  }
                }, {
                  data: "productBrandName", className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (!data || data.trim() === '') {
                      return '-';
                    }
                    return data;
                  }
                }, {
                  data: "barcodeNoOld",
                  className: "text-center",
                  render: function render(data, type, row) {
                    return data && data.trim() ? data : "ไม่มี BARCODE";
                  }
                }, {
                  data: "amountToProcess", className: "text-center",
                  render: function render(data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                  }
                }, {
                  data: "completedAmount", className: "text-center",
                  render: function render(data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                  }
                }, {
                  data: "remainingAmount", className: "text-center",
                  render: function render(data, type, full, meta) {
                    return Number(data).toLocaleString('en-US');
                  }
                }, {
                  data: "finishedDate",
                  className: "text-center",
                  render: function render(data, type, row) {
                    if (!data || data === "0001-01-01T00:00:00") return "-";
                    return moment(data).format("DD/MM/YYYY");
                  }
                }, {
                  data: "evalRemark",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (!data || data.trim() === '') {
                      return '-';
                    }
                    return data;
                  }
                }, {
                  data: "qiJobNumber",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data ? data : '-';
                  }
                }, {
                  data: "evalFlag",
                  className: "text-center",
                  render: function render(data, type, row) {
                    switch (data) {
                      case 1:
                        return "รอทำลาย";
                      case 2:
                        return "รอซ่อม";
                      case 3:
                        return "รอบำรุงรักษา";
                      case 4:
                        return "ส่งซ่อมซัพพลายเออร์";
                      default:
                        return "-";
                    }
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                DatatableWarning.alert(techNote);
              }).on("draw.dt", function () {
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new Action({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      reAaDepartment: [],
      reAaProvince: [],
      reAaAgentCode: [],
      reAaStatus: null,
      reAaProductTypeId: [],
      reAaProductBrand: [],
      reAaAssetCode: [],

      reAaStatusOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reAaProductTypeIdOptions: [],
      // reAaProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAaProductBrandOptions: [],
      // reAaProductBrandOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAaAssetCodeOptions: [],
      // reAaAssetCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAaDepartmentOptions: [],
      // reAaDepartmentOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAaProvinceOptions: [],
      // reAaProvinceOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกจังหวัด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2AgentProvince",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAaAgentCodeOptions: []
      // reAaAgentCodeOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Options",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลตัวแทนจำหน่าย";
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reAaDepartment = [];
      self.reAaProvince = [];
      self.reAaAgentCode = [];
      self.reAaStatus = null;
      self.reAaProductTypeId = [];
      self.reAaProductBrand = [];
      self.reAaAssetCode = [];

      $("#reAaDepartment").val("").trigger("change");

      $("#reAaProvince").val("").trigger("change");

      $("#reAaAgentCode").val("").trigger("change");

      $("#reAaStatus").val("").trigger("change");

      $("#reAaProductTypeId").val("").trigger("change");

      $("#reAaProductBrand").val("").trigger("change");

      $("#reAaAssetCode").val("").trigger("change");
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#stockByAgentTable").DataTable();
      table.draw();
    },
    LoadreAaProductTypeIdOptions: function LoadreAaProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAaProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAaProductBrandOptions: function LoadreAaProductBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAaProductBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAaAssetCodeOptions: function LoadreAaAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAaAssetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAaDepartmentOptions: function LoadreAaDepartmentOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAaDepartmentOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAaProvinceOptions: function LoadreAaProvinceOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2AgentProvince", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAaProvinceOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAaAgentCodeOptions: function LoadreAaAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a
      // .post("/Api/Agents/Options", {
      //   page: 1,
      //   province_id: [],
      //   department: [],
      //   AgentCodes: [],
      // })
      .post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAaAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ExportAgentAssets: function ExportAgentAssets(e) {
      e.preventDefault();
      var self = this;

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportAgentAssets",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reAaIsInitial,
          SalesArea: self.reAaDepartment,
          Province: self.reAaProvince,
          AgentCode: self.reAaAgentCode,
          Status: self.reAaStatus,
          ProductTypeId: self.reAaProductTypeId,
          AssetCode: self.reAaAssetCode,
          BrandId: self.reAaProductBrand
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreAaProductTypeIdOptions();
              self.LoadreAaProductBrandOptions();
              self.LoadreAaAssetCodeOptions();
              self.LoadreAaDepartmentOptions();
              self.LoadreAaProvinceOptions();
              self.LoadreAaAgentCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#stockByAgentTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/AgentAssets",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      IsInitial: self.reAaIsInitial,
                      SalesArea: self.reAaDepartment,
                      Province: self.reAaProvince,
                      AgentCode: self.reAaAgentCode,
                      Status: self.reAaStatus,
                      ProductTypeId: self.reAaProductTypeId,
                      AssetCode: self.reAaAssetCode,
                      BrandId: self.reAaProductBrand
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[1, "desc"]],
                columns: [{
                  data: "department",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "department", className: "text-center" }, { data: "province", className: "text-center" }, { data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "assetCode", className: "text-center" }, { data: "assetName", className: "text-center" }, { data: "brandName", className: "text-center" }, { data: "statusName", className: "text-center" }, {
                  data: "agentAssetAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null || data != "" || data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "shopAssetAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null || data != "" || data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "salesUnit", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reAaIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.form, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.form);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var currentYear = new Date().getFullYear();
    var yearData = [{ id: (currentYear + 1).toString(), text: (currentYear + 1).toString() }, { id: currentYear.toString(), text: currentYear.toString() }, { id: (currentYear - 1).toString(), text: (currentYear - 1).toString() }, { id: (currentYear - 2).toString(), text: (currentYear - 2).toString() }, { id: (currentYear - 3).toString(), text: (currentYear - 3).toString() }, { id: (currentYear - 4).toString(), text: (currentYear - 4).toString() }];

    return {
      searchYear: currentYear.toString(),
      searchAgentCode: [],
      searchAgentOptions: [],
      yearOptions: {
        placeholder: "เลือกปีงบประมาณ",
        allowClear: true,
        data: yearData
      },
      dataSource: []
    };
  },
  methods: {
    loadAgentOptions: function loadAgentOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/AgentScore/AgentScoreDashboardAgentList", {}).then(function (response) {
        if (response.status == 200 && Array.isArray(response.data)) {
          response.data.forEach(function (element) {
            self.searchAgentOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    loadAgentScore: function loadAgentScore() {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กรุณารอสักครู่..."
      });

      var params = {
        StatusCode: "APPROVE"
      };
      if (self.searchYear) {
        params.Year = self.searchYear;
      }
      if (self.searchAgentCode && self.searchAgentCode.length > 0) {
        params.AgentCodeSap = self.searchAgentCode;
      }

      try {
        __WEBPACK_IMPORTED_MODULE_1_axios___default()({
          method: "post",
          url: "/Api/AgentScore/AgentScoreEvalation",
          data: params
        }).then(function (response) {
          self.dataSource = response.data;
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error").then(function () {});
        }).then(function () {
          KTApp.unblockPage();
        });
      } catch (error) {
        console.error("Error load score data:", error);
      }
    },

    exportData: function exportData() {
      var self = this;

      if (!self.searchYear) {
        Swal.fire("แจ้งเตือน", "กรุณาเลือกปีงบประมาณ", "warning");
        return;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/AgentScore/ExportEvaluationData",
        responseType: "arraybuffer",
        data: {
          Year: self.searchYear,
          StatusCode: "APPROVE",
          AgentCodeSap: self.searchAgentCode && self.searchAgentCode.length > 0 ? self.searchAgentCode : null
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          //link.download = decodeURIComponent(filename);
          link.download = moment().format("YYYY-MM-DD") + "_รายงานประเมินตัวแทนจำหน่ายเบียร์สด" + ".xlsx";
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลที่อนุมัติแล้วตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่อนุมัติแล้ว", "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    this.loadAgentOptions();
    this.loadAgentScore();

    this.$nextTick();
    var currentYear = new Date().getFullYear();
    $("#searchYear").val(currentYear.toString()).trigger("change");
  },

  watch: {
    searchYear: function searchYear(newVal, oldVal) {
      this.loadAgentScore();
    },
    searchAgentCode: function searchAgentCode(newVal, oldVal) {
      this.loadAgentScore();
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect_dist_vue_treeselect_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Treeselect: __WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect___default.a
  },
  data: function data() {
    return {
      dataTable: null,
      dataAsOfLabel: '',
      searchSource: null,
      groupVisible: { full: false, empty: false, transit: false },

      // Filter values
      headAgentCode: [],
      agentCode: [],
      productType: [],
      materialCode: [],
      productBrand: [],
      barcodeStatusCode: [],
      brand: [],
      ownerType: [],
      retentionPeriod: [],

      // Filter options
      headAgentCodeOptions: [],
      agentCodeOptions: [],
      productTypeOptions: [],
      materialCodeOptions: [],
      productBrandOptions: [],
      fullProductData: [],
      barcodeStatusCodeOptions: [],
      brandOptions: [],
      ownerTypeOptions: [],
      retentionPeriodOptions: [{ id: "ไม่เกิน 1 เดือน", label: "ไม่เกิน 1 เดือน" }, { id: "ไม่เกิน 3 เดือน", label: "ไม่เกิน 3 เดือน" }, { id: "ไม่เกิน 5 เดือน", label: "ไม่เกิน 5 เดือน" }, { id: "เกิน 5 เดือน", label: "เกิน 5 เดือน" }]
    };
  },
  mounted: function mounted() {
    this.loadHeadAgentCodeOptions();
    this.loadAgentCodeOptions();
    this.loadProductTypeOptions();
    this.loadMaterialCodeOptions();
    this.loadProductData();
    this.loadBarcodeStatusCodeOptions();
    this.loadBrandOptions();
    this.loadOwnerTypeOptions();
    this.initDataTable();
  },
  computed: {
    filteredProductBrandOptions: function filteredProductBrandOptions() {
      if (!this.brand.length) {
        return this.productBrandOptions;
      }
      var selectedBrandIds = this.brand.map(Number);
      var filteredOptions = [];
      this.fullProductData.forEach(function (item) {
        if (selectedBrandIds.indexOf(item.data.productBrandId) !== -1) {
          filteredOptions.push({
            id: item.id,
            label: item.text,
            productBrandId: item.data.productBrandId
          });
        }
      });
      return filteredOptions;
    }
  },
  methods: {
    // ชื่อตัวแทนจำหน่าย(Group)
    loadHeadAgentCodeOptions: function loadHeadAgentCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", { province_id: [], department: [], AgentCodes: [], page: 1, IsShowInAgentScoreReport: true, IsHead: true }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.headAgentCodeOptions.push({ id: element.id, label: element.text });
          });
        }
      }).catch(function () {});
    },

    // ชื่อตัวแทนจำหน่าย
    loadAgentCodeOptions: function loadAgentCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Report/Select2Agent", {
        province_id: [], department: [], AgentCodes: [], page: 1, all: true, IsShowInAgentScoreReport: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.agentCodeOptions.push({ id: element.id, label: element.text });
          });
        }
      }).catch(function () {});
    },

    // ประเภทสินค้า
    loadProductTypeOptions: function loadProductTypeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductType/Select2ProductType", { params: { page: 1, all: true } }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            if (element.id == 4 || element.id == 5) {
              self.productTypeOptions.push({ id: element.id, label: element.text });
            }
          });
        }
      }).catch(function () {});
    },

    // ชื่อสินค้า
    loadMaterialCodeOptions: function loadMaterialCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Product/Select2Product", {
        params: { page: 1, all: true, excludeProductGroupId: 14 }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.materialCodeOptions.push({ id: element.id, label: element.text });
          });
        }
      }).catch(function () {});
    },

    // ชื่อแบรนด์สินค้า — โหลดข้อมูลทั้งหมดพร้อม productBrandId เพื่อใช้ filter ตามแบรนด์
    loadProductData: function loadProductData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/product/Select2ProductReport", {
        page: 1,
        all: true,
        search: "",
        productGroupIds: [14]
      }).then(function (response) {
        if (response.status === 200) {
          self.fullProductData = response.data.results;
          self.productBrandOptions = self.fullProductData.map(function (item) {
            return {
              id: item.id,
              label: item.text,
              productBrandId: item.data.productBrandId
            };
          });
        }
      }).catch(function (error) {
        console.error("Error loading product data:", error);
      });
    },

    // เคลียร์ ชื่อแบรนด์สินค้า เมื่อเลือก/ยกเลิก แบรนด์สินค้า
    BrandIdClearAfterSelect: function BrandIdClearAfterSelect() {
      this.productBrand = [];
    },
    BrandIdClearAfterDeSelect: function BrandIdClearAfterDeSelect() {
      this.productBrand = [];
    },

    // สถานะ
    loadBarcodeStatusCodeOptions: function loadBarcodeStatusCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", { params: { page: 1, all: true } }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.barcodeStatusCodeOptions.push({ id: element.id, label: element.text });
          });
        }
      }).catch(function () {});
    },

    // แบรนด์
    loadBrandOptions: function loadBrandOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", { params: { page: 1, all: true } }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.brandOptions.push({ id: element.id, label: element.text });
          });
        }
      }).catch(function () {});
    },

    // ประเภทผู้ถือครอง
    loadOwnerTypeOptions: function loadOwnerTypeOptions() {
      var self = this;
      var data = [{ id: "ตัวแทนจำหน่าย", label: "ตัวแทนจำหน่าย" }, { id: "ตัวแทนจำหน่ายย่อย", label: "ตัวแทนจำหน่ายย่อย" }, { id: "ร้านค้า", label: "ร้านค้า" }, { id: "ร้านค้า (ตัวแทนฯย่อย)", label: "ร้านค้า (ตัวแทนฯย่อย)" }];
      self.ownerTypeOptions = data;
    },

    toggleGroup: function toggleGroup(group) {
      this.groupVisible[group] = !this.groupVisible[group];
      var scrollBody = $(this.$refs.stockOverdueTable).closest('.dataTables_scrollBody');
      var scrollHead = scrollBody.prev('.dataTables_scrollHead');
      var scrollFoot = scrollBody.next('.dataTables_scrollFoot');
      var cssClass = 'hide-' + group + '-sub';

      var tables = $().add(scrollBody.find('table')).add(scrollHead.find('table')).add(scrollFoot.find('table'));

      if (this.groupVisible[group]) {
        tables.removeClass(cssClass);
      } else {
        tables.addClass(cssClass);
      }

      if (this.dataTable) {
        this.dataTable.columns.adjust();
      }

      // Sync top scrollbar width
      var self = this;
      self.$nextTick(function () {
        var topContent = self.$refs.topScrollContent;
        if (!topContent) return;
        var bodyTable = scrollBody.find('table');
        var headTable = scrollHead.find('table');
        var w = 0;
        if (bodyTable.length) w = Math.max(w, bodyTable[0].scrollWidth);
        if (headTable.length) w = Math.max(w, headTable[0].scrollWidth);
        topContent.style.width = w + 'px';
      });
    },

    formSubmit: function formSubmit(e) {
      e.preventDefault();
      this.searchSource = "generate";
      if (this.dataTable) {
        this.dataTable.ajax.reload();
      } else {
        this.initDataTable();
      }
    },

    initDataTable: function initDataTable() {
      var self = this;

      function calcRetentionRange(selected) {
        if (!selected || selected.length === 0) return { from: null, to: null };
        var rangeMap = {
          "ไม่เกิน 1 เดือน": { from: 1, to: 30 },
          "ไม่เกิน 3 เดือน": { from: 31, to: 90 },
          "ไม่เกิน 5 เดือน": { from: 91, to: 150 },
          "เกิน 5 เดือน": { from: 151, to: null }
        };
        var froms = [],
            tos = [],
            hasOpenEnd = false;
        selected.forEach(function (r) {
          var rng = rangeMap[r];
          if (!rng) return;
          froms.push(rng.from);
          if (rng.to !== null) {
            tos.push(rng.to);
          } else {
            hasOpenEnd = true;
          }
        });
        return {
          from: froms.length ? Math.min.apply(null, froms) : null,
          to: hasOpenEnd ? null : tos.length ? Math.max.apply(null, tos) : null
        };
      }

      function formatNumber(val) {
        if (val === null || val === undefined || val === 0) return "-";
        return val.toLocaleString();
      }

      self.dataTable = $(self.$refs.stockOverdueTable).DataTable({
        scrollX: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/SearchStockOverdue",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function beforeSend(request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          },
          data: function data(d) {
            var retentionRange = calcRetentionRange(self.retentionPeriod);
            var jsonSearch = {
              IsInitial: false,
              AgentCodes: self.agentCode,
              HeadAgentCodes: self.headAgentCode,
              AssetCodes: self.materialCode,
              ProductTypeIds: self.productType,
              BarcodeStatusCodes: self.barcodeStatusCode,
              FinishedProductCodes: self.productBrand,
              BrandIds: self.brand,
              CurrentLocationType: self.ownerType,
              OverDueFrom: retentionRange.from,
              OverDueTo: retentionRange.to,
              Source: self.searchSource
            };
            self.searchSource = null;
            return JSON.stringify($.extend(d, jsonSearch));
          }
        },
        drawCallback: function drawCallback() {
          var api = this.api();
          api.columns.adjust();
          var now = moment();
          self.dataAsOfLabel = 'ข้อมูล ณ วันที่ ' + now.format('DD/MM/YYYY h:mm a');

          // merge column 0 (ประเภทผู้ถือครอง) — rowspan เมื่อค่าซ้ำกัน
          var rows = api.rows({ page: 'current' }).nodes();
          var lastVal = null;
          var lastTd = null;
          var rowspanCount = 1;

          $(rows).each(function () {
            var td = $('td', this).eq(0);
            var val = td.text();
            if (val === lastVal && lastTd) {
              rowspanCount++;
              lastTd.attr('rowspan', rowspanCount);
              td.css('display', 'none');
            } else {
              lastVal = val;
              lastTd = td;
              rowspanCount = 1;
              td.attr('rowspan', 1);
              td.css('display', '');
            }
          });
        },
        dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
        lengthMenu: [50, 100, 200, 500],
        pageLength: 50,
        language: {
          lengthMenu: "Display _MENU_"
        },
        order: [[0, "asc"]],
        columns: [
        // ข้อมูลพื้นฐาน
        { data: "ownerType", className: "text-left", orderable: true }, { data: "agentName", className: "text-left", orderable: true, render: function render(data, type, row) {
            return '[' + (row.agentCode || '') + ']  ' + (data || '');
          } }, { data: "assetCode", className: "text-center", orderable: true }, { data: "assetName", className: "text-left", orderable: false }, { data: "brandCode", className: "text-center", orderable: false }, { data: "brandName", className: "text-left", orderable: false },
        // ถังเต็ม
        { data: "full_1Month", className: "text-center col-full-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "full_3Month", className: "text-center col-full-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "full_5Month", className: "text-center col-full-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "full_Over5Month", className: "text-center col-full-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "full_Total", className: "text-center font-weight-bold", orderable: false, render: function render(data) {
            return formatNumber(data);
          } },
        // ถังเปล่า
        { data: "empty_1Month", className: "text-center col-empty-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "empty_3Month", className: "text-center col-empty-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "empty_5Month", className: "text-center col-empty-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "empty_Over5Month", className: "text-center col-empty-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "empty_Total", className: "text-center font-weight-bold", orderable: false, render: function render(data) {
            return formatNumber(data);
          } },
        // ระหว่างนำส่ง
        { data: "transit_1Month", className: "text-center col-transit-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "transit_3Month", className: "text-center col-transit-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "transit_5Month", className: "text-center col-transit-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "transit_Over5Month", className: "text-center col-transit-sub", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "transit_Total", className: "text-center font-weight-bold", orderable: false, render: function render(data) {
            return formatNumber(data);
          } },
        // Grand Total
        { data: "grandTotal", className: "text-center font-weight-bold", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }],
        rowGroup: {
          dataSrc: function dataSrc(row) {
            return row.ownerType || "(ไม่ระบุ)";
          },
          startRender: function startRender(rows, group) {
            return $('<tr class="group-header"/>').append('<td colspan="22" class="td-header">' + group + "</td>");
          },
          endRender: function endRender(rows, group) {
            var colDefs = [{ key: "full_1Month", cls: "col-full-sub" }, { key: "full_3Month", cls: "col-full-sub" }, { key: "full_5Month", cls: "col-full-sub" }, { key: "full_Over5Month", cls: "col-full-sub" }, { key: "full_Total", cls: "" }, { key: "empty_1Month", cls: "col-empty-sub" }, { key: "empty_3Month", cls: "col-empty-sub" }, { key: "empty_5Month", cls: "col-empty-sub" }, { key: "empty_Over5Month", cls: "col-empty-sub" }, { key: "empty_Total", cls: "" }, { key: "transit_1Month", cls: "col-transit-sub" }, { key: "transit_3Month", cls: "col-transit-sub" }, { key: "transit_5Month", cls: "col-transit-sub" }, { key: "transit_Over5Month", cls: "col-transit-sub" }, { key: "transit_Total", cls: "" }, { key: "grandTotal", cls: "" }];
            var sums = {};
            colDefs.forEach(function (d) {
              sums[d.key] = rows.data().pluck(d.key).reduce(function (a, b) {
                return a + Number(b);
              }, 0);
            });

            var tr = $('<tr class="group-footer-sub"/>');
            tr.append('<td class="td-footer" colspan="6" style="max-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + group + ' Total</td>');
            colDefs.forEach(function (d) {
              tr.append('<td class="td-footer text-center ' + d.cls + '">' + formatNumber(sums[d.key]) + "</td>");
            });
            return tr;
          }
        },
        footerCallback: function footerCallback() {
          var api = this.api();
          var json = api.ajax.json();
          if (!json || !json.groupSummary) {
            for (var i = 6; i <= 21; i++) {
              $(api.column(i).footer()).html("");
            }
            return;
          }
          var s = json.groupSummary;
          var footerCols = ["tot_Full_1Month", "tot_Full_3Month", "tot_Full_5Month", "tot_Full_Over5Month", "tot_Full_Total", "tot_Empty_1Month", "tot_Empty_3Month", "tot_Empty_5Month", "tot_Empty_Over5Month", "tot_Empty_Total", "tot_Transit_1Month", "tot_Transit_3Month", "tot_Transit_5Month", "tot_Transit_Over5Month", "tot_Transit_Total", "tot_GrandTotal"];
          for (var i = 0; i < footerCols.length; i++) {
            $(api.column(6 + i).footer()).html(formatNumber(s[footerCols[i]]));
          }
        }
      });

      // Apply default collapse
      self.$nextTick(function () {
        var scrollBody = $(self.$refs.stockOverdueTable).closest('.dataTables_scrollBody');
        var scrollHead = scrollBody.prev('.dataTables_scrollHead');
        var scrollFoot = scrollBody.next('.dataTables_scrollFoot');
        var tables = $().add(scrollBody.find('table')).add(scrollHead.find('table')).add(scrollFoot.find('table'));
        tables.addClass('hide-full-sub hide-empty-sub hide-transit-sub');
        if (self.dataTable) self.dataTable.columns.adjust();
      });

      // Sync top scrollbar with DataTables scrollBody
      self.$nextTick(function () {
        var scrollBody = $(self.$refs.stockOverdueTable).closest('.dataTables_scrollBody');
        var topWrapper = self.$refs.topScrollWrapper;
        var topContent = self.$refs.topScrollContent;
        if (!scrollBody.length || !topWrapper || !topContent) return;

        function syncTopScrollWidth() {
          var bodyTable = scrollBody.find('table');
          var headTable = scrollBody.prev('.dataTables_scrollHead').find('table');
          var w = 0;
          if (bodyTable.length) w = Math.max(w, bodyTable[0].scrollWidth);
          if (headTable.length) w = Math.max(w, headTable[0].scrollWidth);
          topContent.style.width = w + 'px';
        }
        syncTopScrollWidth();

        var syncing = false;
        $(topWrapper).on('scroll', function () {
          if (syncing) return;
          syncing = true;
          scrollBody[0].scrollLeft = topWrapper.scrollLeft;
          syncing = false;
        });
        scrollBody.on('scroll', function () {
          if (syncing) return;
          syncing = true;
          topWrapper.scrollLeft = scrollBody[0].scrollLeft;
          syncing = false;
        });

        // Update width on draw (e.g. column toggle)
        $(self.$refs.stockOverdueTable).on('draw.dt', function () {
          self.$nextTick(function () {
            syncTopScrollWidth();
          });
        });
      });
    },

    exportCompareReport: function exportCompareReport(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      function calcRetentionRange(selected) {
        if (!selected || selected.length === 0) return { from: null, to: null };
        var rangeMap = {
          "ไม่เกิน 1 เดือน": { from: 1, to: 30 },
          "ไม่เกิน 3 เดือน": { from: 31, to: 90 },
          "ไม่เกิน 5 เดือน": { from: 91, to: 150 },
          "เกิน 5 เดือน": { from: 151, to: null }
        };
        var froms = [],
            tos = [],
            hasOpenEnd = false;
        selected.forEach(function (r) {
          var rng = rangeMap[r];
          if (!rng) return;
          froms.push(rng.from);
          if (rng.to !== null) {
            tos.push(rng.to);
          } else {
            hasOpenEnd = true;
          }
        });
        return {
          from: froms.length ? Math.min.apply(null, froms) : null,
          to: hasOpenEnd ? null : tos.length ? Math.max.apply(null, tos) : null
        };
      }

      var retentionRange = calcRetentionRange(self.retentionPeriod);

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/Report/ExportCompareSnapshotVsBarcode",
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token,
          "Content-Type": "application/json"
        },
        data: JSON.stringify({
          IsInitial: false,
          AgentCodes: self.agentCode,
          HeadAgentCodes: self.headAgentCode,
          AssetCodes: self.materialCode,
          ProductTypeIds: self.productType,
          BarcodeStatusCodes: self.barcodeStatusCode,
          FinishedProductCodes: self.productBrand,
          BrandIds: self.brand,
          CurrentLocationType: self.ownerType,
          OverDueFrom: retentionRange.from,
          OverDueTo: retentionRange.to,
          Source: "export"
        })
      }).then(function (response) {
        KTApp.unblockPage();
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = moment().format("YYYY-MM-DD") + "_รายงานStockระบบเบียร์สด(ตรวจสอบข้อมูล).xlsx";
        link.click();
      }).catch(function () {
        KTApp.unblockPage();
      });
    },

    exportReport: function exportReport(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      function calcRetentionRange(selected) {
        if (!selected || selected.length === 0) return { from: null, to: null };
        var rangeMap = {
          "ไม่เกิน 1 เดือน": { from: 1, to: 30 },
          "ไม่เกิน 3 เดือน": { from: 31, to: 90 },
          "ไม่เกิน 5 เดือน": { from: 91, to: 150 },
          "เกิน 5 เดือน": { from: 151, to: null }
        };
        var froms = [],
            tos = [],
            hasOpenEnd = false;
        selected.forEach(function (r) {
          var rng = rangeMap[r];
          if (!rng) return;
          froms.push(rng.from);
          if (rng.to !== null) {
            tos.push(rng.to);
          } else {
            hasOpenEnd = true;
          }
        });
        return {
          from: froms.length ? Math.min.apply(null, froms) : null,
          to: hasOpenEnd ? null : tos.length ? Math.max.apply(null, tos) : null
        };
      }

      var retentionRange = calcRetentionRange(self.retentionPeriod);

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/Report/ExportStockOverdue",
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token,
          "Content-Type": "application/json"
        },
        data: JSON.stringify({
          IsInitial: false,
          AgentCodes: self.agentCode,
          HeadAgentCodes: self.headAgentCode,
          AssetCodes: self.materialCode,
          ProductTypeIds: self.productType,
          BarcodeStatusCodes: self.barcodeStatusCode,
          FinishedProductCodes: self.productBrand,
          BrandIds: self.brand,
          CurrentLocationType: self.ownerType,
          OverDueFrom: retentionRange.from,
          OverDueTo: retentionRange.to,
          Source: "export"
        })
      }).then(function (response) {
        KTApp.unblockPage();
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        // link.download =
        //   "รายงานStockระบบเบียร์สด_" +
        //   moment().format("DDMMYYYY") +
        //   ".xlsx";
        link.download = moment().format("YYYY-MM-DD") + "_รายงานStockระบบเบียร์สด" + ".xlsx";
        link.click();
      }).catch(function () {
        KTApp.unblockPage();
      });
    },

    formReset: function formReset() {
      this.headAgentCode = [];
      this.agentCode = [];
      this.productType = [];
      this.materialCode = [];
      this.productBrand = [];
      this.barcodeStatusCode = [];
      this.brand = [];
      this.ownerType = [];
      this.retentionPeriod = [];
      this.dataAsOfLabel = '';

      if (this.dataTable) {
        this.dataTable.destroy();
        this.dataTable = null;
      }
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles


__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      reStartDate: null,
      reEndDate: null,
      reSalesArea: [],
      reAgentCodes: [],
      dataTable: [],
      brandHeader: [],
      volume: [],
      brandItem: [],
      reSalesAreaOptions: [],

      reAgentCodesOptions: []
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reSalesArea = [];
      self.reAgentCodes = [];
      self.dataTable = [], self.brandHeader = [], self.volume = [], self.brandItem = [], $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reSalesArea").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;
      self.dataTable = [], self.brandHeader = [], self.volume = [], self.brandItem = [], this.getDataFromApi();
      e.preventDefault();
      table.draw();
    },
    getDataFromApi: function getDataFromApi() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/AmountBeerClaim",
        data: {
          StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
          EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
          SalesArea: self.reSalesArea,
          AgentCode: self.reAgentCodes,
          IsInitial: self.reAaIsInitial
        }
      }).then(function (response) {
        self.dataTable = response.data.data;
        self.dataTable.forEach(function (e) {
          var brand = self.brandHeader.includes(e.productBrandName);
          if (!brand) {
            self.brandHeader.push(e.productBrandName);
          }
        });
        self.dataTable.forEach(function (e) {
          var brand = self.brandHeader.includes(e.productBrandName);
          if (brand) {
            var list = [];
            list.push(e.productBrandName, e.volume, e.price);
            var item = self.brandItem.filter(function (o) {
              return o[0] == e.productBrandName && o[1] == e.volume;
            });
            if (item.length == 0) {
              self.brandItem.push(list);
            }
          }
        });
        self.reAaIsInitial = false;
      });
    },
    sumTotal: function sumTotal(data) {
      var total = 0;
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          total = total + data[i].price;
        }
      }
      return total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onlyUnique: function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },

    LoadreSalesAreaOptions: function LoadreSalesAreaOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reSalesAreaOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      self.reAgentCodesOptions = [{ id: "0", label: "Loading..." }];
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S", {
        province_id: [],
        department: [],
        AgentCodes: [],
        SalesAreaIds: self.reSalesArea,
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reAgentCodesOptions = [];
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreAgentCodesOptions();
              self.LoadreSalesAreaOptions();
              _this.getDataFromApi();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });
              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import "vue-collapsible-component/lib/vue-collapsible.css";
 //"vue-collapsible-component";
// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_4__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reApIsInitial: true,
      reApDateReq: null,
      reApAssetOwner: [],
      reApProductGroup: [],
      reApProductType: [],
      reApMaterialCode: [],
      reApProductBrand: [],
      reApBarcodeStatusCode: [],
      reApLastActivityDateStart: null,
      reApLastActivityDateEnd: null,
      reApBarcodeNo: null,
      reApBarcodeNoOld: null,
      reApDepartmentMaterial: [],
      reApAccountMaterial: [],
      reApNFCCode: [],
      reApPricing: null,
      reApRetrieveDateStart: null,
      reApRetrieveDateEnd: null,
      reApWarrantyTime: null,
      reApWarrantyEndDateStart: null,
      reApWarrantyEndDateEnd: null,
      reApWarrantyStatus: [],
      reApRepairWarrantyDateStart: null,
      reApRepairWarrantyDateEnd: null,
      reApAssetLifeTime: null,
      reApEndOfLifeDateStart: null,
      reApEndOfLifeDateEnd: null,
      reApBookValue: null,
      reApVendor: [],
      reApAssetOwnerOptions: [],
      // reApAssetOwnerOptions: {
      //   placeholder: "กรุณาเลือกเจ้าของทรัพย์สิน",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterAssetOwner/Select2AssetOwner",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApProductGroupOptions: [],
      // reApProductGroupOptions: {
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApProductTypeOptions: [],
      // reApProductTypeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApMaterialCodeOptions: [],
      // reApMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApProductBrandOptions: [],
      // reApProductBrandOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApBarcodeStatusCodeOptions: [],
      // reApBarcodeStatusCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะ",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApBarcodeNoOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2Barcode",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reApBarcodeNoOldOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกรหัส BARCODE",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeOld",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reApDepartmentMaterialOptions: [],
      // reApDepartmentMaterialOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสทรัพย์สิน(เบียร์สด)",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApAccountMaterialOptions: [],
      // reApAccountMaterialOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสทรัพย์สิน(บัญชี)",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2AccountMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApNFCCodeOptions: [],
      // reApNFCCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัส NFC",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2NFC",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApWarrantyStatusOptions: [{ id: "อยู่ในประกัน", label: "อยู่ในประกัน" }, { id: "หมดประกัน", label: "หมดประกัน" }],

      // reApWarrantyStatusOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะการประกัน",
      //   allowClear: true,
      //   data: [
      //     { id: "อยู่ในประกัน", text: "อยู่ในประกัน", data: null },
      //     { id: "หมดประกัน", text: "หมดประกัน", data: null },
      //   ],
      // },
      reApVendorOptions: []
      // reApVendorOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกผู้จำหน่าย(Supplier)",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Vendors/Select2Vendor",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reAp1 = [], self.reApProductGroup = [], self.reApProductType = [], self.reApMaterialCode = [], self.reApProductBrand = [], self.reApBarcodeStatusCode = [], self.reApLastActivityDateStart = null, self.reApLastActivityDateEnd = null, self.reApBarcodeNo = null, self.reApBarcodeNoOld = null, self.reApDepartmentMaterial = [], self.reApAccountMaterial = [], self.reApNFCCode = [], self.reApPricing = null, self.reApRetrieveDateStart = null, self.reApRetrieveDateEnd = null, self.reApWarrantyTime = null, self.reApWarrantyEndDateStart = null, self.reApWarrantyEndDateEnd = null, self.reApWarrantyStatus = [], self.reApRepairWarrantyDateStart = null, self.reApRepairWarrantyDateEnd = null, self.reApAssetLifeTime = null, self.reApEndOfLifeDateStart = null, self.reApEndOfLifeDateEnd = null, self.reApBookValue = null, self.reApVendor = [], self.reApAssetOwner = [];
      $("#reApAssetOwner").val("").trigger("change");

      $("#reApProductGroup").val("").trigger("change");

      $("#reApProductType").val("").trigger("change");

      $("#reApMaterialCode").val("").trigger("change");

      $("#reApProductBrand").val("").trigger("change");

      $("#reApBarcodeStatusCode").val("").trigger("change");

      $("#reApBarcodeNoOld").val("").trigger("change");

      $("#reApDepartmentMaterial").val("").trigger("change");

      $("#reApAccountMaterial").val("").trigger("change");

      $("#reApWarrantyStatus").val("").trigger("change");

      $("#reApVendor").val("").trigger("change");
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      if (e.submitter.innerText != "Generate Report") {
        return false;
      }

      // วันที่เคลื่อนไหวล่าสุด
      if (!self.reApLastActivityDateStart && self.reApLastActivityDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่เคลื่อนไหวล่าสุด(เริ่มต้น)", "warning");
        return false;
      } else if (self.reApLastActivityDateStart && !self.reApLastActivityDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่เคลื่อนไหวล่าสุด(สิ้นสุด)", "warning");
        return false;
      }

      // วันที่รับเข้า

      if (!self.reApRetrieveDateStart && self.reApRetrieveDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่รับเข้า(เริ่มต้น)", "warning");
        return false;
      } else if (self.reApRetrieveDateStart && !self.reApRetrieveDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่รับเข้า(สิ้นสุด)", "warning");
        return false;
      }

      // วันหมดอายุสินค้า
      if (!self.reApEndOfLifeDateStart && self.reApEndOfLifeDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันหมดอายุสินค้า(เริ่มต้น)", "warning");
        return false;
      } else if (self.reApEndOfLifeDateStart && !self.reApEndOfLifeDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันหมดอายุสินค้า(สิ้นสุด)", "warning");
        return false;
      }

      // วันสิ้นสุดการรับประกัน

      if (!self.reApWarrantyEndDateStart && self.reApWarrantyEndDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันสิ้นสุดการรับประกัน(เริ่มต้น)", "warning");
        return false;
      } else if (self.reApWarrantyEndDateStart && !self.reApWarrantyEndDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันสิ้นสุดการรับประกัน(สิ้นสุด)", "warning");
        return false;
      }

      // วันที่รับประกัน

      if (!self.reApRepairWarrantyDateStart && self.reApRepairWarrantyDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่รับประกัน(หลังการซ่อม)(เริ่มต้น)", "warning");
        return false;
      } else if (self.reApRepairWarrantyDateStart && !self.reApRepairWarrantyDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่รับประกัน(หลังการซ่อม)(สิ้นสุด)", "warning");
        return false;
      }

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var status = null;

      e.preventDefault();
      var table = $("#assetProductTable").DataTable();
      table.draw();
    },
    exportAssetProduct: function exportAssetProduct(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportAssetProducts",
        responseType: "arraybuffer",
        data: {
          AssetOwnerId: self.reApAssetOwner,
          ProductGroupId: self.reApProductGroup,
          ProductTypeId: self.reApProductType,
          MaterialCode: self.reApMaterialCode,
          ProductBrandId: self.reApProductBrand,
          BarcodeStatusCode: self.reApBarcodeStatusCode,
          LastActivityDateStart: self.reApLastActivityDateStart != null ? self.reApLastActivityDateStart.format("DD/MM/YYYY") : null,
          LastActivityDateEnd: self.reApLastActivityDateEnd != null ? self.reApLastActivityDateEnd.format("DD/MM/YYYY") : null,
          BarcodeNo: self.reApBarcodeNo,
          BarcodeNoOld: self.reApBarcodeNoOld,
          DepartmentMaterialCode: self.reApDepartmentMaterial,
          AccountMaterialCode: self.reApAccountMaterial,
          NFCCode: self.reApNFCCode,
          Pricing: self.reApPricing,
          RetrieveDateStart: self.reApRetrieveDateStart != null ? self.reApRetrieveDateStart.format("DD/MM/YYYY") : null,
          RetrieveDateEnd: self.reApRetrieveDateEnd != null ? self.reApRetrieveDateEnd.format("DD/MM/YYYY") : null,
          WarrantyTime: self.reApWarrantyTime,
          WarrantyEndDateStart: self.reApWarrantyEndDateStart != null ? self.reApWarrantyEndDateStart.format("DD/MM/YYYY") : null,
          WarrantyEndDateEnd: self.reApWarrantyEndDateEnd != null ? self.reApWarrantyEndDateEnd.format("DD/MM/YYYY") : null,
          WarrantyStatus: self.reApWarrantyStatus,
          RepairWarrantyDateStart: self.reApRepairWarrantyDateStart != null ? self.reApRepairWarrantyDateStart.format("DD/MM/YYYY") : null,
          RepairWarrantyDateEnd: self.reApRepairWarrantyDateEnd != null ? self.reApRepairWarrantyDateEnd.format("DD/MM/YYYY") : null,
          AssetLifeTime: self.reApAssetLifeTime,
          EndOfLifeDateStart: self.reApEndOfLifeDateStart != null ? self.reApEndOfLifeDateStart.format("DD/MM/YYYY") : null,
          EndOfLifeDateEnd: self.reApEndOfLifeDateEnd != null ? self.reApEndOfLifeDateEnd.format("DD/MM/YYYY") : null,
          BookValue: self.reApBookValue,
          VendorId: self.reApVendor
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    openCollap: function openCollap(e) {
      var coll = document.getElementsByClassName("collapsible");
      var i;

      for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function () {
          this.classList.toggle("active");
          var content = this.nextElementSibling;
          if (content.style.display === "block") {
            content.style.display = "none";
          } else {
            content.style.display = "block";
          }
        });
      }
    },
    LoadreApAssetOwnerOptions: function LoadreApAssetOwnerOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterAssetOwner/Select2AssetOwner", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reApAssetOwnerOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreApProductGroupOptions: function LoadreApProductGroupOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductGroup/Select2ProductGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reApProductGroupOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreApProductTypeOptions: function LoadreApProductTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reApProductTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreApMaterialCodeOptions: function LoadreApMaterialCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reApMaterialCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreApProductBrandOptions: function LoadreApProductBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reApProductBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreApBarcodeStatusCodeOptions: function LoadreApBarcodeStatusCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reApBarcodeStatusCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreApDepartmentMaterialOptions: function LoadreApDepartmentMaterialOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.reApDepartmentMaterialOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2DepartmentMaterial", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reApDepartmentMaterialOptions = [];
            data.forEach(function (element) {
              self.reApDepartmentMaterialOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reApDepartmentMaterialOptions);
        }).catch(function (error) {});
      }
    },
    LoadreApAccountMaterialOptions: function LoadreApAccountMaterialOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.reApAccountMaterialOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2AccountMaterial", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reApAccountMaterialOptions = [];
            data.forEach(function (element) {
              self.reApAccountMaterialOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reApAccountMaterialOptions);
        }).catch(function (error) {});
      }
    },
    LoadreApNFCCodeOptions: function LoadreApNFCCodeOptions(_ref3) {
      var action = _ref3.action,
          searchQuery = _ref3.searchQuery,
          callback = _ref3.callback;

      var self = this;
      self.reApNFCCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2NFC", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reApNFCCodeOptions = [];
            data.forEach(function (element) {
              self.reApNFCCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reApNFCCodeOptions);
        }).catch(function (error) {});
      }
    },
    LoadreApVendorOptions: function LoadreApVendorOptions(_ref4) {
      var action = _ref4.action,
          searchQuery = _ref4.searchQuery,
          callback = _ref4.callback;

      var self = this;
      self.reApVendorOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Vendors/Select2Vendor", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reApVendorOptions = [];
            data.forEach(function (element) {
              self.reApVendorOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reApVendorOptions);
        }).catch(function (error) {});
      }
    },

    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreApAssetOwnerOptions();
              self.LoadreApProductGroupOptions();
              self.LoadreApProductTypeOptions();
              self.LoadreApMaterialCodeOptions();
              self.LoadreApProductBrandOptions();
              self.LoadreApBarcodeStatusCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reApDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reApLastActivityDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateStart = moment().set("date",1);
              $(self.$refs.reApLastActivityDateStart).datepicker("update", !!self.reApLastActivityDateStart ? self.reApLastActivityDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reApLastActivityDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reApLastActivityDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reApLastActivityDateEnd).datepicker("update", !!self.reApLastActivityDateEnd ? self.reApLastActivityDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reApLastActivityDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reApRetrieveDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApRetrieveDateStart = moment().set("date",1);
              $(self.$refs.reApRetrieveDateStart).datepicker("update", !!self.reApRetrieveDateStart ? self.reApRetrieveDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                //self.reApRetrieveDateStart = moment(e.date);
                self.reApRetrieveDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reApRetrieveDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApRetrieveDateEnd = moment().endOf('month');
              $(self.$refs.reApRetrieveDateEnd).datepicker("update", !!self.reApRetrieveDateEnd ? self.reApRetrieveDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                //self.reApRetrieveDateEnd = moment(e.date);
                self.reApRetrieveDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reApWarrantyEndDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApWarrantyEndDateStart = moment().set("date",1);
              $(self.$refs.reApWarrantyEndDateStart)
              //.datepicker("update", (self.reApWarrantyEndDateStart != null) ? self.reApWarrantyEndDateStart.format("DD/MM/YYYY") : null)
              .on("changeDate", function (e) {
                //self.reApWarrantyEndDateStart = moment(e.date);
                self.reApWarrantyEndDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reApWarrantyEndDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApWarrantyEndDateEnd = moment().endOf('month');
              $(self.$refs.reApWarrantyEndDateEnd)
              //.datepicker("update", (self.reApWarrantyEndDateEnd != null) ? self.reApWarrantyEndDateEnd.format("DD/MM/YYYY") : null)
              .on("changeDate", function (e) {
                //self.reApWarrantyEndDateEnd = moment(e.date);
                self.reApWarrantyEndDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reApRepairWarrantyDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApRepairWarrantyDateStart = moment().set("date",1);
              $(self.$refs.reApRepairWarrantyDateStart).datepicker("update", !!self.reApRepairWarrantyDateStart ? self.reApRepairWarrantyDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                //self.reApRepairWarrantyDateStart = moment(e.date);
                self.reApRepairWarrantyDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reApRepairWarrantyDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApRepairWarrantyDateEnd = moment().endOf('month');
              $(self.$refs.reApRepairWarrantyDateEnd).datepicker("update", !!self.reApRepairWarrantyDateEnd ? self.reApRepairWarrantyDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                //self.reApRepairWarrantyDateEnd = moment(e.date);
                self.reApRepairWarrantyDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reApEndOfLifeDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApEndOfLifeDateStart = moment().set("date",1);
              $(self.$refs.reApEndOfLifeDateStart).datepicker("update", !!self.reApEndOfLifeDateStart ? self.reApEndOfLifeDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                //self.reApEndOfLifeDateStart = moment(e.date);
                self.reApEndOfLifeDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reApEndOfLifeDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApEndOfLifeDateEnd = moment().endOf('month');
              $(self.$refs.reApEndOfLifeDateEnd).datepicker("update", !!self.reApEndOfLifeDateEnd ? self.reApEndOfLifeDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                //self.reApEndOfLifeDateEnd = moment(e.date);
                self.reApEndOfLifeDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#assetProductTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/AssetProducts",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      IsInitial: self.reApIsInitial,
                      AssetOwnerId: self.reApAssetOwner,
                      ProductGroupId: self.reApProductGroup,
                      ProductTypeId: self.reApProductType,
                      MaterialCode: self.reApMaterialCode,
                      ProductBrandId: self.reApProductBrand,
                      BarcodeStatusCode: self.reApBarcodeStatusCode,
                      LastActivityDateStart: self.reApLastActivityDateStart != null ? self.reApLastActivityDateStart.format("DD/MM/YYYY") : null,
                      LastActivityDateEnd: self.reApLastActivityDateEnd != null ? self.reApLastActivityDateEnd.format("DD/MM/YYYY") : null,
                      BarcodeNo: self.reApBarcodeNo,
                      BarcodeNoOld: self.reApBarcodeNoOld,
                      DepartmentMaterialCode: self.reApDepartmentMaterial,
                      AccountMaterialCode: self.reApAccountMaterial,
                      NFCCode: self.reApNFCCode,
                      Pricing: self.reApPricing,
                      RetrieveDateStart: self.reApRetrieveDateStart != null ? self.reApRetrieveDateStart.format("DD/MM/YYYY") : null,
                      RetrieveDateEnd: self.reApRetrieveDateEnd != null ? self.reApRetrieveDateEnd.format("DD/MM/YYYY") : null,
                      WarrantyTime: self.reApWarrantyTime,
                      WarrantyEndDateStart: self.reApWarrantyEndDateStart != null ? self.reApWarrantyEndDateStart.format("DD/MM/YYYY") : null,
                      WarrantyEndDateEnd: self.reApWarrantyEndDateEnd != null ? self.reApWarrantyEndDateEnd.format("DD/MM/YYYY") : null,
                      WarrantyStatus: self.reApWarrantyStatus,
                      RepairWarrantyDateStart: self.reApRepairWarrantyDateStart != null ? self.reApRepairWarrantyDateStart.format("DD/MM/YYYY") : null,
                      RepairWarrantyDateEnd: self.reApRepairWarrantyDateEnd != null ? self.reApRepairWarrantyDateEnd.format("DD/MM/YYYY") : null,
                      AssetLifeTime: self.reApAssetLifeTime,
                      EndOfLifeDateStart: self.reApEndOfLifeDateStart != null ? self.reApEndOfLifeDateStart.format("DD/MM/YYYY") : null,
                      EndOfLifeDateEnd: self.reApEndOfLifeDateEnd != null ? self.reApEndOfLifeDateEnd.format("DD/MM/YYYY") : null,
                      BookValue: self.reApBookValue,
                      VendorId: self.reApVendor
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "desc"]],
                columns: [{
                  data: "lastActivityDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "assetOwnerName", className: "text-center" }, { data: "productGroupName", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "materialCode", className: "text-center" }, { data: "materialName", className: "text-center" }, { data: "productBrandName", className: "text-center" }, { data: "barcodeStatusName", className: "text-center" }, { data: "barcodeNoOld", className: "text-center" }, { data: "departmentMaterialCode", className: "text-center" }, { data: "accountMaterialCode", className: "text-center" }, {
                  data: "pricing",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return self.$options.filters.currency(data, "฿");
                  }
                }, {
                  data: "quantity",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null || data != "" || data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "amount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return self.$options.filters.currency(data, "฿");
                  }
                }, {
                  data: "retrieveDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.retrieveDateString;
                  }
                }, {
                  data: "warrantyTime",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null && data != "" && data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "warrantyEndDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.warrantyEndDateString;
                  }
                }, { data: "warrantyStatus", className: "text-center" }, {
                  data: "repairWarrantyDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.repairWarrantyDateString;
                  }
                }, {
                  data: "assetLifeTime",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null && data != "" && data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "endOfLifeDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.endOfLifeDateString;
                  }
                }, {
                  data: "bookValue",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return self.$options.filters.currency(data, "฿");
                  }
                }, { data: "vendorName", className: "text-center" }, {
                  data: "lastActivityDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.lastActivityDateString;
                  }
                }],
                rowCallback: function rowCallback(row, data, index) {
                  if (data.warrantyStatus == "หมดประกัน") {
                    $(row).find("td:eq(19)").css("color", "white");
                    $(row).find("td:eq(19)").css("background-color", "#EB355E");
                  }
                },
                drawCallback: function drawCallback(settings) {
                  self.reApIsInitial = false;
                  self.reApDateReq = moment().format("DD/MM/YYYY h:mm a");
                }
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.form, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.form);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_7__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAprDateReq: null,
      reAprIsInitial: true,
      reAprDateCycle: null,
      reAprPlantCode: [],
      reAprJobTypeCode: [],
      reAprProductGroupId: [],
      reAprProductTypeId: [],
      reAprProductBrandId: [],
      reAprAssetProductCode: [],

      reAprDateCycleOptions: {
        placeholder: "กรุณาเลือกรอบข้อมูล",
        allowClear: true,
        ajax: {
          url: "/Api/Jobs/DistinctJobDate/Options",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reAprJobTypeCodeOptions: [],
      // reAprJobTypeCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะ",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=JOB_TYPE",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAprPlantCodeOptions: [],
      // reAprPlantCodeOptions: {
      //   placeholder: "กรุณาเลือกโรงงาน / คลังสินค้า",
      //   multipla: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/Select2Plant",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAprProductGroupIdOptions: [],
      // reAprProductGroupIdOptions: {
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAprProductTypeIdOptions: [],
      // reAprProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAprProductBrandIdOptions: [],
      // reAprProductBrandIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAprAssetProductCodeOptions: []
      // reAprAssetProductCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.reAprDateCycle = null;
      self.reAprPlantCode = [];
      self.reAprJobTypeCode = [];
      self.reAprProductGroupId = [];
      self.reAprProductTypeId = [];
      self.reAprProductBrandId = [];
      self.reAprAssetProductCode = [];

      $("#reAprDateCycle").empty().trigger("change");

      $("#reAprPlantCode").val("").trigger("change");

      $("#reAprJobTypeCode").val("").trigger("change");

      $("#reAprProductGroupId").val("").trigger("change");

      $("#reAprProductTypeId").val("").trigger("change");

      $("#reAprProductBrandId").val("").trigger("change");

      $("#reAprAssetProductCode").val("").trigger("change");
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      e.preventDefault();
      var table = $("#AverageBarcodeTable").DataTable();
      table.draw();
    },
    LoadreAprJobTypeCodeOptions: function LoadreAprJobTypeCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=JOB_TYPE", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAprJobTypeCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAprPlantCodeOptions: function LoadreAprPlantCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Plant/Select2Plant", {
        all: true,
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAprPlantCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAprProductGroupIdOptions: function LoadreAprProductGroupIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductGroup/Select2ProductGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAprProductGroupIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAprProductTypeIdOptions: function LoadreAprProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAprProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAprProductBrandIdOptions: function LoadreAprProductBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAprProductBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAprAssetProductCodeOptions: function LoadreAprAssetProductCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAprAssetProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ExportAverageBarcode: function ExportAverageBarcode(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      e.preventDefault();
      var self = this;

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportAverageBarcode",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reAprIsInitial,
          DateCycle: self.reAprDateCycle,
          PlantCode: self.reAprPlantCode,
          JobTypeCode: self.reAprJobTypeCode,
          ProductGroupId: self.reAprProductGroupId,
          ProductTypeId: self.reAprProductTypeId,
          AssetProductCode: self.reAprAssetProductCode,
          ProductBrandId: self.reAprProductBrandId
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreAprJobTypeCodeOptions();
              self.LoadreAprPlantCodeOptions();
              self.LoadreAprProductGroupIdOptions();
              self.LoadreAprProductTypeIdOptions();
              self.LoadreAprProductBrandIdOptions();
              self.LoadreAprAssetProductCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAprDateReq = moment().format("DD/MM/YYYY h:mm a");

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#AverageBarcodeTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/AverageBarcode",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      IsInitial: self.reAprIsInitial,
                      DateCycle: self.reAprDateCycle,
                      PlantCode: self.reAprPlantCode,
                      JobTypeCode: self.reAprJobTypeCode,
                      ProductGroupId: self.reAprProductGroupId,
                      ProductTypeId: self.reAprProductTypeId,
                      AssetProductCode: self.reAprAssetProductCode,
                      ProductBrandId: self.reAprProductBrandId
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[1, "desc"]],
                columns: [{ data: "dateCycle", className: "text-center" }, { data: "jobTypeName", className: "text-center" }, { data: "plantName", className: "text-center" }, { data: "productGroupName", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "assetProductName", className: "text-center" }, { data: "productBrandName", className: "text-center" }, {
                  data: "totalCycles",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null || data != "" || data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "totalBarcodes",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null || data != "" || data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "averageCycles", className: "text-center" }, { data: "maxCycle", className: "text-center" }, { data: "minCycle", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reAprIsInitial = false;
                  self.reAprDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.form, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.form);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  reAprDateCycle: "required"
                },
                messages: {
                  reAprDateCycle: "กรุณาเลือกรอบข้อมูล"
                }
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles


__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {

      rePMShopTypeId: [],
      shmShopGroupId: [],
      shmPMTypeId: [],
      shmPMTypeIdOptions: [],
      rePMShopTypeIdOptions: [],
      shmShopGroupIdOptions: [],

      rePMPMBrandOptions: [],

      reAaIsInitial: true,
      reAaDateReq: null,
      reDepartments: [],
      reAgentCodes: [],
      reMachineType: [],
      reBarbutlerType: [],
      reBarcodeMachine: null,
      reBarcodeBarbutler: null,
      reShopStatus: 'ACTIVE',
      reProductBrandId: null,
      reProvinceId: null,
      reAmpherId: null,
      brandHeaders: [],
      reDepartmentsOptions: [],
      // reType: [],
      reIsTransaction: true,
      reStartDate: null,
      reEndDate: null,
      pmrSubAgentCodes: [],
      pmrSubAgentCodeOptions: [],
      rePMMachineType: [],
      rePMMachineOptions: [{
        id: "บริษัท",
        label: "บริษัท"
      }, {
        id: "เครื่องเช่า",
        label: "เครื่องเช่า"
      }, {
        id: "ส่วนบุคคล",
        label: "ส่วนบุคคล"
      }],
      rePMDispenserType: [],
      rePMDispenserOptions: [{
        id: "บริษัท",
        label: "บริษัท"
      }, {
        id: "เครื่องเช่า",
        label: "เครื่องเช่า"
      }, {
        id: "ส่วนบุคคล",
        label: "ส่วนบุคคล"
      }],
      brandColumns: [],
      reAgentCodesOptions: [],
      reShopTypeIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reShopStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "ACTIVE", text: "ร้านเปิด", data: null }, { id: "INACTIVE", text: "ร้านปิด", data: null }]
      },
      reProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              provinceId: self.reProvinceId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    }, _defineProperty(_ref, "pmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.reAgentCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reMachineTypeOptions", []), _defineProperty(_ref, "reBarbutlerTypeOptions", []), _ref;
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reDepartments = [];
      self.reAgentCodes = [];
      self.reMachineType = [];
      self.reBarbutlerType = [];
      self.reShopStatus = 'ACTIVE';
      self.reProductBrandId = null;
      self.reAmpherId = null;
      self.reProvinceId = null;
      self.reBarcodeMachine = null;
      self.reBarcodeBarbutler = null;
      // self.reType = [];
      self.rePMMachineType = [];
      self.rePMDispenserType = [];
      self.reIsTransaction = true;
      self.reStartDate = null;
      self.reEndDate = null;
      self.pmrSubAgentCodes = [];
      self.pmrSubAgentCodeOptions = [];

      self.rePMShopTypeId = [];
      self.shmShopGroupId = [];
      self.shmPMTypeId = [];

      $("#reBarbutlerType").val("").trigger("change");

      $("#reMachineType").val("").trigger("change");

      $("#reDepartments").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#pmrSubAgentCodes").val("").trigger("change");

      $("#reShopStatus").val("").trigger("change");

      $("#reProductBrandId").val("").trigger("change");

      $("#reProvinceId").val("").trigger("change");

      $("#reAmpherId").val("").trigger("change");

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#BarbutlerTable").DataTable();
      table.draw();
    },
    exportMasterShop: function exportMasterShop(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportBarbutler",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reAgentCodes,
          SubAgentCode: self.pmrSubAgentCodes,
          Department: self.reDepartments,
          ProductBrands: self.reProductBrandId,
          Status: self.reShopStatus,
          ProvinceId: self.reProvinceId,
          AmperId: self.reAmpherId,
          BarcodeMachine: self.reBarcodeMachine,
          BarcodeMachineType: self.reMachineType,
          BarcodeBarbutler: self.reBarcodeBarbutler,
          BarcodeBarbutlerType: self.reBarbutlerType,
          // Type: self.reType,
          MachineType: self.rePMMachineType,
          DispenserType: self.rePMDispenserType,
          IsTransaction: !self.reIsTransaction,
          StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
          EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
          ShopTypeId: self.rePMShopTypeId,
          ShopGroupId: self.shmShopGroupId,
          PMTypes: self.shmPMTypeId

        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // link.download = "ข้อมูลหัวจ่ายแยกตามแบรนด์" + filename;
          link.download = "ข้อมูลหัวจ่าย" + filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreDepartmentsOptions: function LoadreDepartmentsOptions(e) {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reDepartmentsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      self.reAgentCodesOptions = [{ id: "", label: "Loading...", isDisabled: true }];
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        page: 1,
        province_id: [],
        department: self.reDepartments,
        AgentCodes: [],
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          self.reAgentCodesOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreMachineTypeOptions: function LoadreMachineTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2MachineType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reMachineTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBarbutlerTypeOptions: function LoadreBarbutlerTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2BarButlerType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBarbutlerTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadShopTypeIdOptions: function LoadShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadPMTypeIdOptions: function LoadPMTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Select2MasterShopTypePM", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shmPMTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadShopGroupIdOptions: function LoadShopGroupIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shmShopGroupIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMPMBrandOptions: function LoadrePMPMBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a //PM/PMBrandOptions
      .get("/Api/Report/PM/ProductBrandOptions", {
        params: {
          page: 1,
          productTypeId: 6,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          //id: "BUSSABA", text: "BUSSABA", data: null

          setTimeout(function () {
            data.forEach(function (element) {
              self.rePMPMBrandOptions.push({
                id: element.data,
                label: element.text,
                data: element.data
              });
            });

            self.LoadDataTable(self.rePMPMBrandOptions);
          }, 100);
        }
      }).catch(function (error) {});
    },
    LoadDataTable: function LoadDataTable(e) {
      var self = this;

      //self.rePMPMBrandOptions.filter(val => val.id.includes(self.reProductBrandId));

      var thead = $(document).find('#BarbutlerTable > thead > tr:eq(1)');
      self.rePMPMBrandOptions.forEach(function (value, index) {
        thead.append('<th class="all text-center">  &nbsp;&nbsp;' + value.label + ' &nbsp;&nbsp; </th>');
      });

      var table = $("#BarbutlerTable");

      var lColums = [];

      lColums.push({ data: "agentCode", className: "text-center" });
      lColums.push({ data: "agentName", className: "text-center" });
      lColums.push({
        data: "agentType",
        className: "text-center",
        render: function render(data, type, full, meta) {
          return full.agentTypeName;
        }
      });
      lColums.push({ data: "department", className: "text-center" });
      lColums.push({ data: "customerCode", className: "text-center" });
      lColums.push({ data: "name1", className: "text-center" });
      lColums.push({ data: "name2", className: "text-center" });

      lColums.push({ data: "shopTypeName", className: "text-center" });
      lColums.push({ data: "shopGroupName", className: "text-center" });
      lColums.push({ data: "shopPMTypeName", className: "text-center" });

      lColums.push({ data: "module", className: "text-center" });
      lColums.push({
        data: "createDate",
        className: "text-center",
        render: function render(data, type, full, meta) {
          return full.createDateFormat;
        }
      });
      lColums.push({ data: "day", className: "text-center" });
      lColums.push({ data: "month", className: "text-center" });
      lColums.push({ data: "year", className: "text-center" });
      lColums.push({ data: "barcodeMachineOld", className: "text-center" });
      lColums.push({ data: "barcodeMachineType", className: "text-center" });
      lColums.push({ data: "machineType", className: "text-center" });
      lColums.push({ data: "dispenserType", className: "text-center" });
      lColums.push({ data: "barcodeBarbutlerOld", className: "text-center" });
      lColums.push({ data: "barcodeBarbutlerType", className: "text-center" });

      self.rePMPMBrandOptions.forEach(function (value, index) {

        lColums.push({
          data: value.label,
          orderable: false,
          className: "text-center",
          render: function render(data, type, full, meta) {
            return full.pmBrands.filter(function (e) {
              return e.brandId === value.data;
            }).map(function (e) {
              return e.brandSummary;
            });
          }
        });
      });

      table.DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/BarButler",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function beforeSend(request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          },
          data: function data(d) {
            var jsonSearch = {
              IsInitial: self.reAaIsInitial,
              AgentCode: self.reAgentCodes,
              SubAgentCode: self.pmrSubAgentCodes,
              Department: self.reDepartments,
              ProductBrands: self.reProductBrandId,
              Status: self.reShopStatus,
              ProvinceId: self.reProvinceId,
              AmperId: self.reAmpherId,
              BarcodeMachine: self.reBarcodeMachine,
              BarcodeMachineType: self.reMachineType,
              BarcodeBarbutler: self.reBarcodeBarbutler,
              BarcodeBarbutlerType: self.reBarbutlerType,
              // Type: self.reType,
              MachineType: self.rePMMachineType,
              DispenserType: self.rePMDispenserType,
              IsTransaction: !self.reIsTransaction,
              StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
              EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,

              ShopTypeId: self.rePMShopTypeId,
              ShopGroupId: self.shmShopGroupId,
              PMTypes: self.shmPMTypeId

            };
            return JSON.stringify($.extend(d, jsonSearch));
          }
        },
        // DOM Layout settings
        dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n          <'row'<'col-sm-12'tr>>\n          <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_"
        },

        // Order settings
        order: [[8, "desc"]],
        columns: lColums,
        columnDefs: [{
          targets: [8, 9, 10] /* column index */
          , orderable: false /* true or false */
        }],
        drawCallback: function drawCallback(settings) {
          self.reAaIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
        }
      });
    },
    AgentClearAfterselect: function AgentClearAfterselect() {
      var self = this;
      self.pmrSubAgentCodes = [];

      $("#pmrSubAgentCodes").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadrePMPMBrandOptions();
              self.LoadreDepartmentsOptions();
              self.LoadreAgentCodesOptions();
              self.LoadreMachineTypeOptions();
              self.LoadreBarbutlerTypeOptions();
              self.LoadShopTypeIdOptions();
              self.LoadShopGroupIdOptions();
              self.LoadPMTypeIdOptions();

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {

      rePMBrand: [],

      pmrAgentCodes: [],
      pmrAgentCodesOptions: [],

      pmrSubAgentCodes: [],
      pmrSubAgentCodeOptions: [],

      pmrSubAgentShopCodes: [],
      pmrSubAgentShopCodesOptions: [],

      pmrShopCodes: [],

      //-----------------------------
      reTotalSetOptions: [],
      reTotalSet: []

    }, _defineProperty(_ref, "reTotalSetOptions", [{
      id: "1",
      label: "1"
    }, {
      id: "2",
      label: "2"
    }, {
      id: "3",
      label: "3"
    }, {
      id: "4",
      label: "4"
    }, {
      id: "5",
      label: "5"
    }, {
      id: "6",
      label: "6"
    }, {
      id: "7",
      label: "7"
    }, {
      id: "8",
      label: "8"
    }, {
      id: "9",
      label: "9"
    }, {
      id: "10",
      label: "10"
    }]), _defineProperty(_ref, "pmrShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Shop/Select2ShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "pmrSubAgentShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      //pmrSubAgentCodes
      ajax: {
        url: "/Api/Shop/SubShopOptionAlertReport",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            shopCodes: self.pmrSubAgentCodes,
            search: params.term,
            page: params.page || 1,
            all: true
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "pmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.pmrAgentCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "rePMBrandOptions", []), _ref;
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.rePMBrand = [];
      self.reTotalSet = [];
      self.pmrAgentCodes = [];
      self.pmrSubAgentCodes = [];
      self.pmrSubAgentShopCodes = [];
      self.pmrShopCodes = [];

      $("#pmrShopCodes").val("").trigger("change");

      $("#pmrAgentCodes").val("").trigger("change");

      $("#pmrSubAgentShopCodes").val("").trigger("change");

      $("#pmrSubAgentCodes").val("").trigger("change");

      $("#reTotalSet").val("").trigger("change");

      $("#reTotalSet").val("").trigger("change");

      $("#rePMBrand").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#pmTable").DataTable();
      table.draw();
    },
    exportPM: function exportPM(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportBarcodeMapping",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.pmrAgentCodes,
          SubAgentCode: self.pmrSubAgentCodes,
          Brand: self.rePMBrand,
          ShopId: self.pmrShopCodes,
          SubAgentShopId: self.pmrSubAgentShopCodes,
          TotalSet: self.reTotalSet

        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          var fname = filename.split("RPT_")[1];

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "รายงานจำนวนชุดอุปกรณ์_" + fname; //+ filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },

    LoadpmrAgentCodesOptions: function LoadpmrAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM", {
        province_id: [],
        department: [],
        agentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.pmrAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    LoadrePMBrandOptions: function LoadrePMBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/PM/ProductBrandOptions", {
        params: {
          page: 1,
          productTypeId: 6,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadrePMBrandOptions();
              self.LoadpmrAgentCodesOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reBsDateReq: null,
      reBsBarcodeStatusCode: [],
      reBsAssetOwnerId: [],
      reBsProvinceId: [],
      reBsAssetHolderType: [],
      reBsProductGroupId: [],
      reBsProductTypeId: [],
      reBsProductCode: [],
      TotalAmount: 0,
      isShowFooter: false,
      reBsBarcodeStatusCodeOptions: [],
      reBsIsInitial: true,
      // reBsBarcodeStatusCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะ",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBsAssetOwnerIdOptions: [],
      // reBsAssetOwnerIdOptions: {
      //   placeholder: "กรุณาเลือกเจ้าของทรัพย์สิน",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterAssetOwner/Select2AssetOwner",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBsProvinceIdOptions: [],
      // reBsProvinceIdOptions: {
      //   placeholder: "กรุณาเลือกจังหวัด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchProvince",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: [],
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBsAssetHolderTypeOptions: [{ id: "ตัวแทนจำหน่าย", label: "ตัวแทนจำหน่าย" }, { id: "โรงงาน/คลัง", label: "โรงงาน/คลัง" }, { id: "ตัวแทนจำหน่ายย่อย", label: "ตัวแทนจำหน่ายย่อย" }, { id: "ร้านค้า", label: "ร้านค้า" }, { id: "ซัพพลายเออร์", label: "ซัพพลายเออร์" }, { id: "ร้านค้าของตัวแทนฯย่อย", label: "ร้านค้าของตัวแทนฯย่อย" }],
      // reBsAssetHolderTypeOptions: {
      //   placeholder: "กรุณาเลือกประเภทผู้ถือครอง",
      //   allowClear: true,
      //   data: [
      //     { id: "ตัวแทนจำหน่าย", text: "ตัวแทนจำหน่าย" },
      //     { id: "โรงงาน/คลัง", text: "โรงงาน/คลัง" },
      //     { id: "ตัวแทนจำหน่ายย่อย", text: "ตัวแทนจำหน่ายย่อย" },
      //     { id: "ร้านค้า", text: "ร้านค้า" },
      //     { id: "ซัพพลายเออร์", text: "ซัพพลายเออร์" },
      //     { id: "ร้านค้าของตัวแทนฯย่อย", text: "ร้านค้าของตัวแทนฯย่อย" },
      //   ],
      // },
      reBsProductGroupIdOptions: [],
      // reBsProductGroupIdOptions: {
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBsProductTypeIdOptions: [],
      // reBsProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBsProductCodeOptions: []
      // reBsProductCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.reBsBarcodeStatusCode = [];
      self.reBsAssetOwnerId = [];
      self.reBsProvinceId = [];
      self.reBsAssetHolderType = [];
      self.reBsProductGroupId = [];
      self.reBsProductTypeId = [];
      self.reBsProductCode = [];

      $("#reBsBarcodeStatusCode").val("").trigger("change");

      $("#reBsAssetOwnerId").val("").trigger("change");

      $("#reBsProvinceId").val("").trigger("change");

      $("#reBsAssetHolderType").val("").trigger("change");

      $("#reBsProductGroupId").val("").trigger("change");

      $("#reBsProductTypeId").val("").trigger("change");

      $("#reBsProductCode").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reBsIsInitial = true;
      }
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      e.preventDefault();
      var table = $("#barcodeStatusTable").DataTable();
      table.draw();
    },
    LoadreBsBarcodeStatusCodeOptions: function LoadreBsBarcodeStatusCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBsBarcodeStatusCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBsAssetOwnerIdOptions: function LoadreBsAssetOwnerIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterAssetOwner/Select2AssetOwner", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBsAssetOwnerIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBsProvinceIdOptions: function LoadreBsProvinceIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Agents/Select2SearchProvince", {
        department: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBsProvinceIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBsProductGroupIdOptions: function LoadreBsProductGroupIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductGroup/Select2ProductGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBsProductGroupIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBsProductTypeIdOptions: function LoadreBsProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBsProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBsProductCodeOptions: function LoadreBsProductCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBsProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ExportBarcodeStatus: function ExportBarcodeStatus(e) {
      e.preventDefault();
      var self = this;

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportBarcodeStatus",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reBsIsInitial,
          BarcodeStatusCode: self.reBsBarcodeStatusCode,
          AssetOwnerId: self.reBsAssetOwnerId,
          ProvinceId: self.reBsProvinceId,
          AssetHolderType: self.reBsAssetHolderType,
          ProductGroupId: self.reBsProductGroupId,
          ProductTypeId: self.reBsProductTypeId,
          ProductCode: self.reBsProductCode,
          CurrentAgentCode: [],
          CurrentSubShopId: [],
          CurrentPlantCode: []
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreBsBarcodeStatusCodeOptions();
              self.LoadreBsAssetOwnerIdOptions();
              self.LoadreBsProvinceIdOptions();
              self.LoadreBsProductGroupIdOptions();
              self.LoadreBsProductTypeIdOptions();
              self.LoadreBsProductCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reBsDateReq = moment().format("DD/MM/YYYY h:mm a");

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#barcodeStatusTable");
              //begin first table

              table.DataTable({
                paging: false,
                autoWidth: true,
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/BarcodeStatus",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    self.isShowFooter = false;
                    self.TotalAmount = 0;

                    var jsonSearch = {
                      IsInitial: self.reBsIsInitial,
                      BarcodeStatusCode: self.reBsBarcodeStatusCode,
                      AssetOwnerId: self.reBsAssetOwnerId,
                      ProvinceId: self.reBsProvinceId,
                      AssetHolderType: self.reBsAssetHolderType,
                      ProductGroupId: self.reBsProductGroupId,
                      ProductTypeId: self.reBsProductTypeId,
                      ProductCode: self.reBsProductCode,
                      CurrentAgentCode: [],
                      CurrentSubShopId: [],
                      CurrentPlantCode: []
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                orderFixed: [0, "desc"],
                //order: [[0, "desc"]],
                columns: [{ data: "barcodeStatusName", className: "text-center" }, { data: "assetOwnerName", className: "text-center" }, {
                  data: "provinceId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return full.provinceName;
                  }
                }, { data: "assetHolderType", className: "text-center" }, { data: "productGroupName", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "productCode", className: "text-center" }, { data: "productName", className: "text-center" }, {
                  data: "totalBarcodes",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null || data != "" || data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }],
                rowCallback: function rowCallback(row, data, index) {
                  if (data.barcodeStatusName == null) {
                    $(row).find("td:eq(7)").css("font-weight", "bold");
                    $(row).find("td:eq(7)").css("color", "#93a2dd");
                    $(row).find("td:eq(8)").css("font-weight", "bold");
                    $(row).find("td:eq(8)").css("color", "#93a2dd");
                    $(row).css("background-color", "#e1e1ef");
                  }
                },
                drawCallback: function drawCallback(settings) {
                  self.reBsDateReq = moment().format("DD/MM/YYYY h:mm a");
                  self.reBsIsInitial = false;

                  if (settings.json.recordsTotal > 0) {
                    var totalAmount = settings.json.data[0].grandTotalBarcodes;
                    self.isShowFooter = true;
                    self.TotalAmount = totalAmount != null || totalAmount != "" || data !== 0 ? totalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";
                    $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
                  }
                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.form, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.form);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import "vue-collapsible-component/lib/vue-collapsible.css";
 //"vue-collapsible-component";
// import the component

// import the styles



__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_4__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      UsersId: [],
      MbIsShowCancel: false,
      // CR 02/09/2026 — filter "สถานะใช้งาน" (1=ใช้งาน เป็นค่าเริ่มต้น, 0=ปิดใช้งาน, null=ทั้งหมด)
      ActiveStatus: 1,
      ActiveStatusOptions: [{ id: 1, label: "ใช้งาน" }, { id: 0, label: "ปิดใช้งาน" }],
      // CR 02/09/2026 ข้อ 4 — filter "สถานะทรัพย์สินเช่า" (null=ทั้งหมด เป็นค่าเริ่มต้น)
      IsLeasedAssets: null,
      LeasedAssetsOptions: [{ id: 0, label: "ทรัพย์สินบริษัท" }, { id: 1, label: "ทรัพย์สินเช่า" }],
      ActiveStatusInfoText: 'ใช้งาน = ไม่แสดงข้อมูล BARCODE ที่ คอลัมน์ "ผู้ดูแลทรัพย์สิน" 1.Z000002 คลัง Writeoff(ตัวแทนจำหน่าย), 2.คลังสินค้าที่ตั้งค่า "ประเภทคลังสินค้า = คลัง(จัดการข้อมูล)"<br/>*กำหนดเป็นค่าเริ่มต้น<br/>ปิดใช้งาน = แสดงข้อมูล BARCODE ที่ คอลัมน์ "ผู้ดูแลทรัพย์สิน" 1.Z000002 คลัง Writeoff(ตัวแทนจำหน่าย), 2.คลังสินค้าที่ตั้งค่า "ประเภทคลังสินค้า = คลัง(จัดการข้อมูล)"',
      MbBarcodeStautsDisabled: false,
      reBBarcodeStatusCode: [],
      reBBarcode: null,
      reBDepartmentMaterialCode: [],
      reBProductTypeId: [],
      reBBrandId: [],
      reBAssetCode: [],
      reBCurrentLocationPlant: [],
      reBCurrentLocationAgent: [],
      reBCurrentLocationSubAgent: [],
      reBCurrentLocationShop: [],
      reBCurrentLocationSubShop: [],
      reBCurrentLocationVendor: [],
      reBCurrentLocationType: null,
      reBDepartment: [],
      reBProvince: [],
      reBShopTypeId: [],
      //reBHostAgentCode: null,
      reBHostAgentCode: [],
      reBTransitId: null,
      reBOnHoldDays: null,
      reBBarcodeStatusCodeOptions: [],

      ProductIdBrand: [],
      ProductIdBrandOptions: [],
      fullProductData: [],

      BarcodeYear: [],
      BarcodeYearOptions: [],
      AllBarcodeYearOptions: [],

      UnitPrice: [],
      UnitPriceOptions: [],

      PeriodRange: [],
      PeriodRangeOptions: [],

      PeriodYear: [],
      PeriodYearOptions: [],

      Circulate: [],
      CirculateOptions: [],

      AssetOwnerId: [],
      AssetOwnerOptions: [],

      OwnerType: [],
      OwnerTypeOptions: [],

      HeadAgentCode: [],
      HeadAgentCodeOptions: [],

      reBBarcodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reBDepartmentMaterialCodeOptions: [],
      reBNFCCodeOptions: [],
      reBProductTypeIdOptions: [],
      reBBrandIdOptions: [],
      reBAssetCodeOptions: [],
      reBCurrentLocationPlantOptions: [],
      reBCurrentLocationAgentOptions: [],
      reBCurrentLocationSubAgentOptions: [],
      reBCurrentLocationShopOptions: [],
      reBCurrentLocationSubShopOptions: [],
      // reBCurrentLocationSubShopOptions: {
      //   placeholder: "กรุณาเลือกผู้ถือครอง(ร้านค้าตัวแทนย่อย)",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Shop/SubShopOption",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBCurrentLocationVendorOptions: [],
      reBCurrentLocationTypeOptions: [],
      reBDepartmentOptions: [],
      reBProvinceOptions: [],
      reBShopTypeIdOptions: [],
      reBHostAgentCodeOptions: [],
      reBTransitIdOptions: {
        placeholder: "กรุณาเลือกขนส่ง",
        allowClear: true,
        ajax: {
          url: "/Api/Transport/Select2Transport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              showVendorTransport: true,
              agentCodes: [],
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },

      OdCurrentLocationSubAgentOptions: []

    };
  },
  computed: {
    // CR 02/09/2026 — ไม่แสดง filter "สถานะใช้งาน" ให้สิทธิ์ แอดมินตัวแทนจำหน่าย / แอดมินตัวแทนจำหน่ายย่อย
    // (super_admin เห็นเสมอ — canShow คืน true ให้ super_admin ทุกกรณี จึงต้องใช้ canShowExSuperAdmin)
    showActiveStatusFilter: function showActiveStatusFilter() {
      return this.$root.canShow(["super_admin"]) || !this.$root.canShowExSuperAdmin(["AGENT_REPORT", "SUB_AGENT_REPORT"]);
    },
    filteredProductIdBrandOptions: function filteredProductIdBrandOptions() {
      var _this = this;

      if (!this.reBBrandId.length) {
        return this.ProductIdBrandOptions;
      }
      var filteredOptions = [];
      this.fullProductData.forEach(function (item) {
        if (_this.reBBrandId.map(Number).includes(item.data.productBrandId)) {
          filteredOptions.push({
            id: item.id,
            label: item.text,
            productBrandId: item.data.productBrandId
          });
        }
      });
      return filteredOptions;
    },
    showDDLAgentName: function showDDLAgentName() {
      var userRoles = this.$root.user.profile.role;
      var hasBr = userRoles.includes("BR_REPORT");
      var hasAgent = userRoles.includes("AGENT_REPORT");
      var hasSubAgent = userRoles.includes("SUB_AGENT_REPORT");

      if (hasSubAgent) {
        if (hasAgent || hasBr) return true; /* หากเป็นตัวแทนย่อย และเป็นตัวแทนหรือกลุ่มbr ก็จะยังแสดง filter */
        else return false; /* หากเป็นตัวแทนย่อยอย่างเดียวจะ return false */
      }
      return true;
    }
  },
  methods: {
    clickcheckbox: function clickcheckbox(e) {

      var self = this;
      setTimeout(function () {
        if (self.MbIsShowCancel) {
          self.MbBarcodeStautsDisabled = true;
          self.reBBarcodeStatusCode = [];
        } else {
          self.MbBarcodeStautsDisabled = false;
        }
      }, 100);

      //self.$parent.saveSummit(this.data.headerId);
    },
    formReset: function formReset(e) {
      var self = this;

      self.UsersId = [];
      self.reBBarcodeStatusCode = [];
      self.reBBarcode = null;
      self.reBDepartmentMaterialCode = [];
      self.reBProductTypeId = [];
      self.reBBrandId = [];
      self.reBAssetCode = [];
      self.reBCurrentLocationPlant = [];
      self.reBCurrentLocationAgent = [];
      self.reBCurrentLocationSubAgent = [];
      self.reBCurrentLocationShop = [];
      self.reBCurrentLocationSubShop = [];
      self.reBCurrentLocationVendor = [];
      self.reBCurrentLocationType = null;
      self.reBDepartment = [];
      self.reBProvince = [];
      self.reBShopTypeId = [];
      self.reBHostAgentCode = [];
      self.reBTransitId = null;
      self.reBOnHoldDays = null;
      self.ProductIdBrand = [];
      self.Circulate = [];
      self.BarcodeYear = [];
      self.UnitPrice = [];
      self.PeriodRange = [];
      self.PeriodYear = [];
      self.AssetOwnerId = [];
      self.OwnerType = [];
      self.HeadAgentCode = [];
      self.MbIsShowCancel = false;
      self.ActiveStatus = 1; // CR 02/09/2026 — กลับไปที่ค่าเริ่มต้น "ใช้งาน"
      self.IsLeasedAssets = null; // CR 02/09/2026 ข้อ 4

      $("#reBBarcodeStatusCode").val("").trigger("change");

      $("#reBBarcode").val("").trigger("change");

      $("#reBDepartmentMaterialCode").val("").trigger("change");

      $("#reBProductTypeId").val("").trigger("change");

      $("#reBBrandId").val("").trigger("change");

      $("#reBAssetCode").val("").trigger("change");

      $("#reBCurrentLocationPlant").val("").trigger("change");

      $("#reBCurrentLocationAgent").val("").trigger("change");

      $("#reBCurrentLocationSubAgent").val("").trigger("change");

      $("#reBCurrentLocationShop").val("").trigger("change");

      $("#reBCurrentLocationSubShop").val("").trigger("change");

      $("#reBCurrentLocationVendor").val("").trigger("change");

      $("#reBCurrentLocationType").val("").trigger("change");

      $("#reBDepartment").val("").trigger("change");

      $("#reBProvince").val("").trigger("change");

      $("#reBShopTypeId").val("").trigger("change");

      $("#reBHostAgentCode").val("").trigger("change");

      $("#reBTransitId").val("").trigger("change");

      $("#ProductIdBrand").val("").trigger("change");
      $("#Circulate").val("").trigger("change");
      $("#BarcodeYear").val("").trigger("change");
      $("#UnitPrice").val("").trigger("change");
      $("#PeriodRange").val("").trigger("change");
      $("#PeriodYear").val("").trigger("change");
      $("#AssetOwnerId").val("").trigger("change");
      $("#OwnerType").val("").trigger("change");
      $("#HeadAgentCode").val("").trigger("change");
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#brandCountTable").DataTable();
      table.draw();
    },
    exportBarcodes: function exportBarcodes(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      var curentShop = [];
      if (self.reBCurrentLocationSubAgent.length != 0 || self.reBCurrentLocationShop.length) {
        curentShop = self.reBCurrentLocationSubAgent.concat(self.reBCurrentLocationShop);
        // console.log(curentShop);
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportBarcodes",
        responseType: "arraybuffer",
        data: {
          UserIds: self.UsersId,
          BarcodeStatusCode: self.reBBarcodeStatusCode,
          Barcode: self.reBBarcode,
          DepartmentMaterialCode: self.reBDepartmentMaterialCode,
          ProductTypeId: self.reBProductTypeId,
          AssetCode: self.reBAssetCode,
          BrandId: self.reBBrandId,
          CurrentLocationPlant: self.reBCurrentLocationPlant,
          CurrentLocationAgent: self.reBCurrentLocationAgent,
          CurrentLocationShop: self.reBCurrentLocationShop,
          //CurrentLocationShop: self.reBCurrentLocationSubAgent.concat(
          //    self.reBCurrentLocationShop
          //),
          CurrentLocationSubAgent: self.reBCurrentLocationSubAgent,
          CurrentLocationSubShop: self.reBCurrentLocationSubShop,
          CurrentLocationType: self.reBCurrentLocationType,
          CurrentLocationVendor: self.reBCurrentLocationVendor,

          //SalesAreaId: self.reBDepartment,
          SalesAreaIds: self.reBDepartment,

          Province: self.reBProvince,
          ShopTypeId: self.reBShopTypeId,
          HostAgentCode: self.reBHostAgentCode,
          TransitId: self.reBTransitId,
          OnHoldDays: self.reBOnHoldDays,
          ProductIdBrand: self.ProductIdBrand,
          BarcodeYear: self.BarcodeYear,
          UnitPrice: self.UnitPrice,
          PeriodRange: self.PeriodRange,
          PeriodYear: self.PeriodYear,
          Circulate: self.Circulate,
          AssetOwnerId: self.AssetOwnerId,
          OwnerType: self.OwnerType,
          HeadAgentCode: self.HeadAgentCode,
          IsShowCancel: self.MbIsShowCancel,
          ActiveStatus: self.showActiveStatusFilter ? self.ActiveStatus : null,
          // ข้อ 4: ส่งเฉพาะเมื่อเป็นผู้ดูแลระบบ (role อื่นไม่เห็น filter นี้)
          IsLeasedAssets: self.$root.canShow(['super_admin']) ? self.IsLeasedAssets : null
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          // console.log(disposition);
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            // console.log(matches);
            if (matches != null && matches[1]) {
              // console.log(matches);
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreBBarcodeStatusCodeOptions: function LoadreBBarcodeStatusCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBBarcodeStatusCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBDepartmentMaterialCodeOptions: function LoadreBDepartmentMaterialCodeOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.reBDepartmentMaterialCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2DepartmentMaterial", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBDepartmentMaterialCodeOptions = [];
            data.forEach(function (element) {
              self.reBDepartmentMaterialCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reBDepartmentMaterialCodeOptions);
        }).catch(function (error) {});
      }
    },
    LoadreBNFCCodeOptions: function LoadreBNFCCodeOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.reBNFCCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2NFC", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBNFCCodeOptions = [];
            data.forEach(function (element) {
              self.reBNFCCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reBNFCCodeOptions);
        });
      }
    },

    LoadreBProductTypeIdOptions: function LoadreBProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBBrandIdOptions: function LoadreBBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBAssetCodeOptions: function LoadreBAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true,
          excludeProductGroupId: 14
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBAssetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadUsersIdOptions: function LoadUsersIdOptions(_ref3) {
      var action = _ref3.action,
          searchQuery = _ref3.searchQuery,
          callback = _ref3.callback;

      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/User/Options", {
          page: 1,
          search: searchQuery,
          all: true
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            var result = [];
            data.forEach(function (element) {
              result.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, result);
        }).catch(function (error) {});
      }
    },

    reLoadUsersIdOptions: function reLoadUsersIdOptions() {
      this.$refs.UsersId.trigger.searchQuery = null;
    },
    LoadreBCurrentLocationPlantOptions: function LoadreBCurrentLocationPlantOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Plant/Select2Plant", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBCurrentLocationPlantOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    /***** ddl Agent *****/
    LoadHeadAgentCodeOptions: function LoadHeadAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: self.rePMRegion,
        AgentCodes: [],
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reBCurrentLocationAgentOptions = [];

          if (data.length > 1) self.reBCurrentLocationAgentOptions = [{ id: "0", label: "ทั้งหมด" }];

          data.forEach(function (element) {
            self.reBCurrentLocationAgentOptions.push({
              id: element.id,
              label: element.text
            });
            self.HeadAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    reLoadreBCurrentLocationSubAgentOptions: function reLoadreBCurrentLocationSubAgentOptions() {
      this.$refs.reBCurrentLocationSubAgent.trigger.searchQuery = null;
    },
    /***** ddl SubAgent *****/
    LoadreBCurrentLocationSubAgentOptions: function LoadreBCurrentLocationSubAgentOptions(_ref4) {
      var action = _ref4.action,
          searchQuery = _ref4.searchQuery,
          callback = _ref4.callback;

      var self = this;
      self.reBCurrentLocationSubAgentOptions = [];

      var reBCurrentLocationAgentTEMP = self.reBCurrentLocationAgent;
      var reBCurrentLocationShopTEMP = self.reBCurrentLocationShop;

      if (reBCurrentLocationAgentTEMP != null && reBCurrentLocationAgentTEMP.length == 1 && reBCurrentLocationAgentTEMP[0] == '0') {
        reBCurrentLocationAgentTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
      }
      if (reBCurrentLocationShopTEMP != null && reBCurrentLocationShopTEMP.length == 1 && reBCurrentLocationShopTEMP[0] == '0') {
        reBCurrentLocationShopTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
      }

      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2SubShopAgent", {
          page: 1,
          onlySubAgent: true,
          all: true,
          search: searchQuery,
          agentCodes: reBCurrentLocationAgentTEMP, // self.reBCurrentLocationAgent
          shopCodes: reBCurrentLocationShopTEMP //self.reBCurrentLocationShop
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBCurrentLocationSubAgentOptions = [];

            if (data.length > 1) self.reBCurrentLocationSubAgentOptions = [{ id: "0", label: "ทั้งหมด" }];

            data.forEach(function (element) {
              self.reBCurrentLocationSubAgentOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reBCurrentLocationSubAgentOptions);
        });
      }
    },


    reLoadreBCurrentLocationShopOptions: function reLoadreBCurrentLocationShopOptions() {
      this.$refs.reBCurrentLocationShop.trigger.searchQuery = null;
    },
    /***** ddl Shop *****/
    LoadreBCurrentLocationShopOptions: function LoadreBCurrentLocationShopOptions(_ref5) {
      var action = _ref5.action,
          searchQuery = _ref5.searchQuery,
          callback = _ref5.callback;

      var self = this;

      var reBCurrentLocationAgentTEMP = self.reBCurrentLocationAgent;
      var reBCurrentLocationSubAgentTEMP = self.reBCurrentLocationSubAgent;

      if (reBCurrentLocationAgentTEMP != null && reBCurrentLocationAgentTEMP.length == 1 && reBCurrentLocationAgentTEMP[0] == '0') {
        reBCurrentLocationAgentTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
      }
      if (reBCurrentLocationSubAgentTEMP != null && reBCurrentLocationSubAgentTEMP.length == 1 && reBCurrentLocationSubAgentTEMP[0] == '0') {
        reBCurrentLocationSubAgentTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
      }

      self.reBCurrentLocationShopOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Shop/Select2ShopByAgentAlerReport", {
          page: 1,
          all: true,
          agentCodes: reBCurrentLocationAgentTEMP, //self.reBCurrentLocationAgent,
          customerCode: reBCurrentLocationSubAgentTEMP,
          search: searchQuery
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBCurrentLocationShopOptions = [];

            if (data.length > 1) self.reBCurrentLocationShopOptions = [{ id: "0", label: "ทั้งหมด" }];

            data.forEach(function (element) {
              self.reBCurrentLocationShopOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reBCurrentLocationShopOptions);
        });
      }
    },


    reLoadreBCurrentLocationSubShopOptions: function reLoadreBCurrentLocationSubShopOptions() {
      this.$refs.reBCurrentLocationSubShop.trigger.searchQuery = null;
    },

    /***** ddl SubShop *****/
    LoadreBCurrentLocationSubShopOptions: function LoadreBCurrentLocationSubShopOptions(_ref6) {
      var action = _ref6.action,
          searchQuery = _ref6.searchQuery,
          callback = _ref6.callback;

      var self = this;
      self.reBCurrentLocationSubShopOptions = [];

      var reBCurrentLocationAgentTEMP = self.reBCurrentLocationAgent;
      var reBCurrentLocationSubAgentTEMP = self.reBCurrentLocationSubAgent;
      var reBCurrentLocationShopTEMP = self.reBCurrentLocationShop;

      if (reBCurrentLocationAgentTEMP != null && reBCurrentLocationAgentTEMP.length == 1 && reBCurrentLocationAgentTEMP[0] == '0') {
        reBCurrentLocationAgentTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
      }
      if (reBCurrentLocationSubAgentTEMP != null && reBCurrentLocationSubAgentTEMP.length == 1 && reBCurrentLocationSubAgentTEMP[0] == '0') {
        reBCurrentLocationSubAgentTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
      }
      if (reBCurrentLocationShopTEMP != null && reBCurrentLocationShopTEMP.length == 1 && reBCurrentLocationShopTEMP[0] == '0') {
        reBCurrentLocationShopTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
      }

      var allShops = [];

      if (self.reBCurrentLocationSubAgent != null && self.reBCurrentLocationSubAgent.length > 0 && reBCurrentLocationSubAgentTEMP.length > 0) {
        for (var i = 0, len = self.reBCurrentLocationSubAgent.length; i < len; ++i) {
          allShops.push(self.reBCurrentLocationSubAgent[i]);
        }
      }
      if (self.reBCurrentLocationShop != null && self.reBCurrentLocationShop.length > 0 && reBCurrentLocationShopTEMP.length > 0) {
        for (var i = 0, len = self.reBCurrentLocationShop.length; i < len; ++i) {
          allShops.push(self.reBCurrentLocationShop[i]);
        }
      }

      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Shop/SubShopOptionAlertReport", {
          page: 1,
          all: true,
          search: searchQuery,
          agentCodes: reBCurrentLocationAgentTEMP, //self.reBCurrentLocationAgent,
          shopCodes: allShops
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBCurrentLocationSubShopOptions = [];

            if (data.length > 1) self.reBCurrentLocationSubShopOptions = [{ id: "0", label: "ทั้งหมด" }];

            data.forEach(function (element) {
              self.reBCurrentLocationSubShopOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reBCurrentLocationSubShopOptions);
        });
      }
    },


    AgentClearAfterselect: function AgentClearAfterselect() {
      var self = this;

      self.reBCurrentLocationSubAgent = [];
      self.reBCurrentLocationShop = [];
      self.reBCurrentLocationSubShop = [];

      $("#reBCurrentLocationSubAgent").val("").trigger("change");
      $("#reBCurrentLocationShop").val("").trigger("change");
      $("#reBCurrentLocationSubShop").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },

    SubAgentClearAfterselect: function SubAgentClearAfterselect() {
      var self = this;

      self.reBCurrentLocationShop = [];
      self.reBCurrentLocationSubShop = [];

      $("#reBCurrentLocationShop").val("").trigger("change");
      $("#reBCurrentLocationSubShop").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },

    ShopClearAfterselect: function ShopClearAfterselect() {
      var self = this;
      self.reBCurrentLocationSubShop = [];

      $("#reBCurrentLocationSubShop").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },

    /**** End Modify  *****/

    reLoadreBCurrentLocationVendorOptions: function reLoadreBCurrentLocationVendorOptions() {
      this.$refs.reBCurrentLocationVendor.trigger.searchQuery = null;
    },
    LoadreBCurrentLocationVendorOptions: function LoadreBCurrentLocationVendorOptions(_ref7) {
      var action = _ref7.action,
          searchQuery = _ref7.searchQuery,
          callback = _ref7.callback;

      var self = this;
      self.reBCurrentLocationVendorOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Vendors/Select2Vendor", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBCurrentLocationVendorOptions = [];
            data.forEach(function (element) {
              self.reBCurrentLocationVendorOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reBCurrentLocationVendorOptions);
        }).catch(function (error) {});
      }
    },

    LoadreBProvinceOptions: function LoadreBProvinceOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Agents/Select2SearchProvince", {
        page: 1,
        all: true,
        department: []
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBProvinceOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBShopTypeIdOptions: function LoadreBShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBHostAgentCodeOptions: function LoadreBHostAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reBHostAgentCodeOptions = [];
          data.forEach(function (element) {
            self.reBHostAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    loadProductData: function loadProductData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/product/Select2ProductReport", {
                  page: 1,
                  all: true,
                  search: "",
                  productGroupIds: [14]
                });

              case 3:
                response = _context.sent;

                if (response.status === 200) {
                  _this2.fullProductData = response.data.results;
                  _this2.ProductIdBrandOptions = _this2.fullProductData.map(function (item) {
                    return {
                      id: item.id,
                      label: item.text,
                      productBrandId: item.data.productBrandId
                    };
                  });
                }
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.error("Error loading product data:", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 7]]);
      }))();
    },

    BrandIdClearAfterSelect: function BrandIdClearAfterSelect() {
      this.ProductIdBrand = [];
    },
    BrandIdClearAfterDeSelect: function BrandIdClearAfterDeSelect() {
      this.ProductIdBrand = [];
    },
    reLoadBarcodeYearOptions: function reLoadBarcodeYearOptions() {
      this.$refs.BarcodeYear.trigger.searchQuery = null;
    },
    LoadBarcodeYearOptions: function LoadBarcodeYearOptions(_ref8) {
      var _this3 = this;

      var action = _ref8.action,
          searchQuery = _ref8.searchQuery,
          callback = _ref8.callback;

      if (this.AllBarcodeYearOptions.length === 0) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2BarcodeYear", {
          params: {
            page: 1,
            all: true
          }
        }).then(function (response) {
          if (response.status === 200) {
            _this3.AllBarcodeYearOptions = response.data.results.map(function (element) {
              return {
                id: element.id,
                label: element.text
              };
            });
            callback(null, _this3.AllBarcodeYearOptions);
          }
        }).catch(function (error) {
          callback(error, []);
        });
      } else {
        var query = searchQuery ? searchQuery.toLowerCase() : "";
        var filteredOptions = this.AllBarcodeYearOptions.filter(function (option) {
          return option.label.toLowerCase().includes(query);
        });
        callback(null, filteredOptions);
      }
    },

    LoadUnitPriceOptions: function LoadUnitPriceOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ProductUnitPrice", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.UnitPriceOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadOdPeriodOptions: function LoadOdPeriodOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ReportOverdue/Select2PeriodOption", {
        params: {
          page: 1,
          all: true,
          PeriodRangeType: 2
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.PeriodRangeOptions = [];
          data.forEach(function (element) {
            self.PeriodRangeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    LoadPeriodYearOptions: function LoadPeriodYearOptions(e) {
      var self = this;
      self.PeriodYearOptions = [];
      var currentYear = new Date().getFullYear();
      for (var year = 2021; year <= currentYear; year++) {
        self.PeriodYearOptions.push({
          id: year.toString(),
          label: year.toString()
        });
      }
    },
    LoadCirculateOptions: function LoadCirculateOptions(e) {
      var self = this;
      self.CirculateOptions = [];
      var data = [{
        id: 1,
        text: "หมุนเวียน"
      }, {
        id: 2,
        text: "ไม่หมุนเวียน"
      }];
      data.forEach(function (element) {
        self.CirculateOptions.push({
          id: element.id,
          label: element.text
        });
      });
    },
    LoadAssetOwnerOptions: function LoadAssetOwnerOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/assetOwner/Select2SearchAssetOwner", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.AssetOwnerOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadOwnerTypeOptions: function LoadOwnerTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=MASTER_OWNER_TYPE", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OwnerTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadCurrentLocationTypeOptions: function LoadCurrentLocationTypeOptions(e) {
      var self = this;
      self.reBCurrentLocationTypeOptions = [];
      var data = [{ id: "คลัง/โรงงาน", text: "คลัง/โรงงาน" }, { id: "ตัวแทนจำหน่าย", text: "ตัวแทนจำหน่าย" }, { id: "ตัวแทนจำหน่ายย่อย", text: "ตัวแทนจำหน่ายย่อย" }, { id: "ร้านค้า", text: "ร้านค้า" }, { id: "ร้านค้า (ตัวแทนฯย่อย)", text: "ร้านค้า (ตัวแทนฯย่อย)" }, { id: "ซัพพลายเออร์", text: "ซัพพลายเออร์" }];
      data.forEach(function (element) {
        self.reBCurrentLocationTypeOptions.push({
          id: element.id,
          label: element.text
        });
      });
    },
    LoadDepartmentOptions: function LoadDepartmentOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBDepartmentOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, arrows;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this4;

              // CR 02/09/2026 — ปุ่ม Info ของ filter "สถานะใช้งาน"

              self.$nextTick(function () {
                if (self.$refs.ActiveStatusInfo) {
                  $(self.$refs.ActiveStatusInfo).popover();
                }
              });

              self.LoadreBBarcodeStatusCodeOptions();
              self.LoadreBProductTypeIdOptions();
              self.LoadreBBrandIdOptions();
              self.LoadreBAssetCodeOptions();
              self.LoadreBCurrentLocationPlantOptions();
              self.LoadHeadAgentCodeOptions();
              //self.LoadreBCurrentLocationSubAgentOptions();
              self.LoadreBProvinceOptions();
              self.LoadreBShopTypeIdOptions();
              self.LoadreBHostAgentCodeOptions();
              self.loadProductData();
              self.LoadUnitPriceOptions();
              self.LoadOdPeriodOptions();
              self.LoadPeriodYearOptions();
              self.LoadCirculateOptions();
              self.LoadAssetOwnerOptions();
              self.LoadOwnerTypeOptions();
              self.LoadCurrentLocationTypeOptions();
              self.LoadDepartmentOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reBcDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reBc01).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reMmTransactionDateEnd = moment().endOf('month');
              $(self.$refs.reBc01).datepicker("update", !!self.reBc01 ? self.reBc01.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBc01 = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reBc02).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reMmTransactionDateEnd = moment().endOf('month');
              $(self.$refs.reBc02).datepicker("update", !!self.reBc02 ? self.reBc02.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBc02 = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reBc03).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reMmTransactionDateEnd = moment().endOf('month');
              $(self.$refs.reBc03).datepicker("update", !!self.reBc03 ? self.reBc03.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBc03 = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(_this4.$refs.form).validate().settings.ignore = ":hidden";

            case 29:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import "vue-collapsible-component/lib/vue-collapsible.css";
 //"vue-collapsible-component";
// import the component

// import the styles



__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_4__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reBrwRequestDocNo: [],
      reBrwLastApproveMonth: [],
      reBrwLastApproveYear: [],
      reBrwRequestTypeCodes: [],
      reBrwBorrowerId: [],
      reBrwBorrowerAgentOrg: [],
      reBrwAgentCode: [],
      reBrwShopId: [],
      reBrwActivityId: [],
      reBrwActivityRemark: null,
      reBrwJobNumber: [],
      reBrwJobDateStart: null,
      reBrwJobDateEnd: null,
      reBrwReturnDateStart: null,
      reBrwReturnDateEnd: null,
      reBrwOverDaysStart: null,
      reBrwOverDaysEnd: null,
      reBrwRemainingStart: null,
      reBrwRemainingEnd: null,
      reBrwProductTypeId: [],
      reBrwQuotaId: [],
      reBrwProductCode: [],
      reBCurrentLocationShop: [],
      reBrwProductGroupId: [],
      reBrwLastApproveDateStart: null,
      reBrwLastApproveDateEnd: null,
      reBrwLastApproveMonthOptions: [],
      // reBrwLastApproveMonthOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเดือน",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ApproveMonthQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwLastApproveYearOptions: [],
      // reBrwLastApproveYearOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกปี",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2LastApproveYearQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwRequestTypeCodesOptions: [],
      // reBrwRequestTypeCodesOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกปี",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=PRODUCT_LOAN_REQUEST_TYPE",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwBorrowerIdOptions: [],
      // reBrwBorrowerIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกผู้ขอเบิก/ยืม",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2BorrowerQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwBorrowerAgentOrgOptions: [],
      // reBrwBorrowerAgentOrgOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย/หน่วยงาน",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2AgentOrgQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //     templateResult: function(data) {
      //       return data.text;
      //     },
      //     language: {
      //       noResults: function() {
      //         return "ไม่พบข้อมูลตัวแทนจำหน่าย/หน่วยงาน";
      //       },
      //     },
      //   },
      // },
      reBrwAgentCodeOptions: [],
      // reBrwAgentCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2AgentBorrow",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลตัวแทนจำหน่าย";
      //     },
      //   },
      // },
      reBrwShopIdOptions: [],
      // reBrwShopIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ShopBorrow",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwActivityIdOptions: [],
      // reBrwActivityIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกชื่องานกิจกรรม",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ActivityBorrow",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwJobNumberOptions: [],
      // reBrwJobNumberOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเลขที่เอกสารใบเบิกยืม",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2JobNumber",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBBarcodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reBrwRequestDocNoOptions: [],
      // reBrwRequestDocNoOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเลขที่เอกสารใบคำร้องขอ",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2RequestDocNoQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwProductTypeIdOptions: [],
      // reBrwProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwQuotaIdOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกโควตา (แบรนด์)",
        ajax: {
          url: "/Api/Quota/Select2Quota",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reBrwProductCodeOptions: [],
      // reBrwProductCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwProductGroupIdOptions: [],
      // reBrwProductGroupIdOptions: {
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reViewPermissionCode: null,
      reViewPermissionOptions: [],
      reShop: [],
      reShopOptions: []
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.reBrwRequestDocNo = [];
      self.reBrwLastApproveMonth = [];
      self.reBrwLastApproveYear = [];
      self.reBrwRequestTypeCodes = [];
      self.reBrwBorrowerId = [];
      self.reBrwBorrowerAgentOrg = [];
      self.reBrwAgentCode = [];
      self.reBrwShopId = [];
      self.reBrwActivityId = [];
      self.reBrwActivityRemark = null, self.reBrwJobNumber = [];
      self.reBrwJobDateStart = null;
      self.reBrwJobDateEnd = null;
      self.reBrwReturnDateStart = null;
      self.reBrwReturnDateEnd = null;
      self.reBrwOverDaysStart = null;
      self.reBrwOverDaysEnd = null;
      self.reBrwRemainingStart = null;
      self.reBrwRemainingEnd = null;
      self.reBrwProductTypeId = [];
      self.reBrwQuotaId = [];
      self.reBrwProductCode = [];
      self.reBCurrentLocationShop = [];
      self.reBrwProductGroupId = [];
      self.reBrwLastApproveDateStart = null;
      self.reBrwLastApproveDateEnd = null;
      self.reShop = [];

      $("#reBrwRequestDocNo").val("").trigger("change");

      $("#reBrwLastApproveMonth").val("").trigger("change");

      $("#reBrwLastApproveYear").val("").trigger("change");

      $("#reBrwRequestTypeCodes").val("").trigger("change");

      $("#reBrwBorrowerId").val("").trigger("change");

      $("#reBrwBorrowerAgentOrg").val("").trigger("change");

      $("#reBrwAgentCode").val("").trigger("change");

      $("#reBrwShopId").val("").trigger("change");

      $("#reBrwActivityId").val("").trigger("change");

      $("#reBrwJobNumber").val("").trigger("change");

      $("#reBrwProductTypeId").val("").trigger("change");

      $("#reBrwQuotaId").val("").trigger("change");

      $("#reBrwProductCode").val("").trigger("change");

      $("#reBrwProductGroupId").val("").trigger("change");

      $("#reShop").val("").trigger("change");
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#brandCountTable").DataTable();
      table.draw();
    },
    exportBarcodes: function exportBarcodes(e) {
      e.preventDefault();
      var self = this;

      if (self.reBrwLastApproveDateStart !== null || self.reBrwLastApproveDateEnd !== null) {
        if (self.reBrwLastApproveDateStart === null && self.reBrwLastApproveDateEnd !== null) {
          Swal.fire("กรุณาระบุ", "วันที่อนุมัติ(เริ่มต้น)", "warning");
          return false;
        } else if (self.reBrwLastApproveDateStart !== null && self.reBrwLastApproveDateEnd === null) {
          Swal.fire("กรุณาระบุ", "วันที่อนุมัติ(สิ้นสุด)", "warning");
          return false;
        }
      }

      if (self.reBrwJobDateStart !== null || self.reBrwJobDateEnd !== null) {
        if (self.reBrwJobDateStart === null && self.reBrwJobDateEnd !== null) {
          Swal.fire("กรุณาระบุ", "วันที่ส่งสินค้า(เริ่มต้น)", "warning");
          return false;
        } else if (self.reBrwJobDateStart !== null && self.reBrwJobDateEnd === null) {
          Swal.fire("กรุณาระบุ", "วันที่ส่งสินค้า(สิ้นสุด)", "warning");
          return false;
        }
      }

      if (self.reBrwReturnDateStart !== null || self.reBrwReturnDateEnd !== null) {
        if (self.reBrwReturnDateStart === null && self.reBrwReturnDateEnd !== null) {
          Swal.fire("กรุณาระบุ", "วันที่กำหนดคืนสินค้า(เริ่มต้น)", "warning");
          return false;
        } else if (self.reBrwReturnDateStart !== null && self.reBrwReturnDateEnd === null) {
          Swal.fire("กรุณาระบุ", "วันที่กำหนดคืนสินค้า(สิ้นสุด)", "warning");
          return false;
        }
      }

      if (self.reBrwOverDaysStart == "") {
        self.reBrwOverDaysStart = null;
      }
      if (self.reBrwOverDaysEnd == "") {
        self.reBrwOverDaysEnd = null;
      }
      if (self.reBrwOverDaysStart !== null || self.reBrwOverDaysEnd !== null) {
        if (self.reBrwOverDaysStart === null && self.reBrwOverDaysEnd !== null) {
          Swal.fire("กรุณาระบุ", "เกินกำหนดการคืน(เริ่มต้น)", "warning");
          return false;
        } else if (self.reBrwOverDaysStart !== null && self.reBrwOverDaysEnd === null) {
          Swal.fire("กรุณาระบุ", "เกินกำหนดการคืน(สิ้นสุด)", "warning");
          return false;
        }
      }

      if (self.reBrwRemainingStart == "") {
        self.reBrwRemainingStart = null;
      }
      if (self.reBrwRemainingEnd == "") {
        self.reBrwRemainingEnd = null;
      }
      if (self.reBrwRemainingStart !== null || self.reBrwRemainingEnd !== null) {
        if (self.reBrwRemainingStart === null && self.reBrwRemainingEnd !== null) {
          Swal.fire("กรุณาระบุ", "คงค้าง(เริ่มต้น)", "warning");
          return false;
        } else if (self.reBrwRemainingStart !== null && self.reBrwRemainingEnd === null) {
          Swal.fire("กรุณาระบุ", "คงค้าง(สิ้นสุด)", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportBorrow",
        responseType: "arraybuffer",
        data: {
          RequestDocNo: self.reBrwRequestDocNo,
          LastApproveDateStart: self.reBrwLastApproveDateStart != null ? self.reBrwLastApproveDateStart.format("DD/MM/YYYY") : null,
          LastApproveDateEnd: self.reBrwLastApproveDateEnd != null ? self.reBrwLastApproveDateEnd.format("DD/MM/YYYY") : null,
          LastApproveMonth: self.reBrwLastApproveMonth,
          LastApproveYear: self.reBrwLastApproveYear,
          RequestTypeCodes: self.reBrwRequestTypeCodes,
          BorrowerId: self.reBrwBorrowerId,
          BorrowerAgentOrg: self.reBrwBorrowerAgentOrg,
          AgentCode: self.reBrwAgentCode,
          ShopId: self.reBrwShopId,
          ActivityId: self.reBrwActivityId,
          ActivityRemark: self.reBrwActivityRemark,
          JobNumber: self.reBrwJobNumber,
          JobDateStart: self.reBrwJobDateStart != null ? self.reBrwJobDateStart.format("DD/MM/YYYY") : null,
          JobDateEnd: self.reBrwJobDateEnd != null ? self.reBrwJobDateEnd.format("DD/MM/YYYY") : null,
          ReturnDateStart: self.reBrwReturnDateStart != null ? self.reBrwReturnDateStart.format("DD/MM/YYYY") : null,
          ReturnDateEnd: self.reBrwReturnDateEnd != null ? self.reBrwReturnDateEnd.format("DD/MM/YYYY") : null,
          OverDaysStart: self.reBrwOverDaysStart,
          OverDaysEnd: self.reBrwOverDaysEnd,
          RemainingStart: self.reBrwRemainingStart,
          RemainingEnd: self.reBrwRemainingEnd,
          ProductGroupId: self.reBrwProductGroupId,
          ProductTypeId: self.reBrwProductTypeId,
          ProductCode: self.reBrwProductCode,
          QuotaId: self.reBrwQuotaId,
          ViewPermissionCode: self.reViewPermissionCode,
          ShopCode: self.reShop
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);

            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreBrwLastApproveMonthOptions: function LoadreBrwLastApproveMonthOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ApproveMonthQuery", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBrwLastApproveMonthOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBrwLastApproveYearOptions: function LoadreBrwLastApproveYearOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2LastApproveYearQuery", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBrwLastApproveYearOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBrwRequestTypeCodesOptions: function LoadreBrwRequestTypeCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=PRODUCT_LOAN_REQUEST_TYPE", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBrwRequestTypeCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBrwBorrowerIdOptions: function LoadreBrwBorrowerIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2BorrowerQuery", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBrwBorrowerIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBrwBorrowerAgentOrgOptions: function LoadreBrwBorrowerAgentOrgOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2AgentOrgQuery", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBrwBorrowerAgentOrgOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    // LoadreBrwAgentCodeOptions: function(e) {
    //   var self = this;
    //   axios
    //     .get("/Api/Report/Select2AgentBorrow", {
    //       params: {
    //         page: 1,
    //         all: true,
    //       },
    //     })
    //     .then(function(response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         data.forEach((element) => {
    //           self.reBrwAgentCodeOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function(error) {});
    // },
    LoadreBrwAgentCodeOptions: _.debounce(function (_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2AgentBorrow", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBrwAgentCodeOptions = [];
            data.forEach(function (element) {
              self.reBrwAgentCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
            callback(null, self.reBrwAgentCodeOptions);
          }
        }).catch(function (error) {});
      }
    }, 700),
    LoadreBrwShopIdOptions: function LoadreBrwShopIdOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.reBrwShopIdOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ShopBorrow", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBrwShopIdOptions = [];
            data.forEach(function (element) {
              self.reBrwShopIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reBrwShopIdOptions);
        }).catch(function (error) {});
      }
    },

    LoadreBrwActivityIdOptions: function LoadreBrwActivityIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ActivityBorrow", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBrwActivityIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBrwJobNumberOptions: function LoadreBrwJobNumberOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2JobNumber", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBrwJobNumberOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBrwRequestDocNoOptions: function LoadreBrwRequestDocNoOptions(_ref3) {
      var action = _ref3.action,
          searchQuery = _ref3.searchQuery,
          callback = _ref3.callback;

      var self = this;
      self.reBrwRequestDocNoOptions = [];
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2RequestDocNoQuery", {
        params: {
          page: 1,
          all: true,
          search: searchQuery
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reBrwRequestDocNoOptions = [];
          data.forEach(function (element) {
            self.reBrwRequestDocNoOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
        callback(null, self.reBrwRequestDocNoOptions);
      }).catch(function (error) {});
    },

    LoadreBrwProductTypeIdOptions: function LoadreBrwProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBrwProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBrwProductCodeOptions: function LoadreBrwProductCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBrwProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBrwProductGroupIdOptions: function LoadreBrwProductGroupIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductGroup/Select2ProductGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBrwProductGroupIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    LoadreViewJobRetrieveOptions: function LoadreViewJobRetrieveOptions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var self;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ViewJobRetrieve", {}).then(function (response) {
                  if (response.status == 200) {
                    var data = response.data.results;
                    data.forEach(function (element) {
                      self.reViewPermissionOptions.push({
                        id: element.id,
                        label: element.text
                      });

                      if (element.data == "active") {
                        self.reViewPermissionCode = element.id;
                      }
                    });
                  }
                }).catch(function (error) {});

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    ChangeOptions: function ChangeOptions(type) {
      console.log("ChangeOptions");
      var self = this;
      if (self.LoadFrist == false) {
        if (type == "View") {
          self.formReset();
        }
      }
    },
    LoadShopOptions: function LoadShopOptions(_ref4) {
      var action = _ref4.action,
          searchQuery = _ref4.searchQuery,
          callback = _ref4.callback;

      var self = this;
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2SubAgentBorrow", {
          page: 1,
          all: true,
          search: searchQuery
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reShopOptions = [];
            data.forEach(function (element) {
              self.reShopOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }

          callback(null, self.reShopOptions);
        }).catch(function (error) {});
      }
    },

    reLoadShopOptions: function reLoadShopOptions() {
      this.$refs.reShop.trigger.searchQuery = null;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, arrows;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this2;


              self.LoadreBrwLastApproveMonthOptions();
              self.LoadreBrwLastApproveYearOptions();
              self.LoadreBrwRequestTypeCodesOptions();
              self.LoadreBrwBorrowerIdOptions();
              self.LoadreBrwBorrowerAgentOrgOptions();
              // self.LoadreBrwAgentCodeOptions();
              self.LoadreBrwActivityIdOptions();
              self.LoadreBrwJobNumberOptions();
              self.LoadreBrwProductTypeIdOptions();
              self.LoadreBrwProductCodeOptions();
              self.LoadreBrwProductGroupIdOptions();
              _context2.next = 13;
              return self.LoadreViewJobRetrieveOptions();

            case 13:
              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reBcDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reBrwLastApproveDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reBrwLastApproveDateStart).datepicker("update", !!self.reBrwLastApproveDateStart ? self.reBrwLastApproveDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBrwLastApproveDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reBrwLastApproveDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reBrwLastApproveDateEnd).datepicker("update", !!self.reBrwLastApproveDateEnd ? self.reBrwLastApproveDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBrwLastApproveDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              //=====
              $(self.$refs.reBrwJobDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reBrwJobDateStart).datepicker("update", !!self.reBrwJobDateStart ? self.reBrwJobDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBrwJobDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reBrwJobDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reBrwJobDateEnd).datepicker("update", !!self.reBrwJobDateEnd ? self.reBrwJobDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBrwJobDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reBrwJobDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reBrwJobDateStart).datepicker("update", !!self.reBrwJobDateStart ? self.reBrwJobDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBrwJobDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reBrwJobDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reBrwJobDateEnd).datepicker("update", !!self.reBrwJobDateEnd ? self.reBrwJobDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBrwJobDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reBrwReturnDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reBrwReturnDateStart).datepicker("update", !!self.reBrwReturnDateStart ? self.reBrwReturnDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBrwReturnDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(_this2.$refs.form).validate().settings.ignore = ":hidden";

              $(self.$refs.reBrwReturnDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reBrwReturnDateEnd).datepicker("update", !!self.reBrwReturnDateEnd ? self.reBrwReturnDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBrwReturnDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(_this2.$refs.form).validate().settings.ignore = ":hidden";

            case 33:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var Actions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a href=\"#\" @click.prevent=\"barcodeModal\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E1A\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14\u0E02\u0E32\u0E14\u0E2A\u0E48\u0E07\">\n      <i class=\"la la-search\"></i>\n    </a>\n  </div>",
  methods: {
    barcodeModal: function barcodeModal() {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        path: "/Report/BrandCount/BarCode/" + this.data.transferJobId
      });
    }
  }
});

var ActionsTransferJob = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n    <a href=\"#\" @click.prevent=\"openJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E15\u0E49\u0E19\u0E17\u0E32\u0E07\">\n      <i class=\"la la-external-link\"></i>\n    </a>\n  ",
  methods: {
    openJob: function openJob() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Jobs/GetJobId", {
        JobNumber: this.data.transferJobNumber
      }).then(function (response) {
        if (response.status == 200) {
          window.open("/Jobs/Edit/" + response.data, "_blank");
        } else {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
        }
      }).catch(function (error) {
        // always executed
        KTApp.unblockPage();
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  }
});

var ActionsChildJob = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n    <a href=\"#\" @click.prevent=\"openChildJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E15\u0E49\u0E19\u0E17\u0E32\u0E07\">\n      <i class=\"la la-external-link\"></i>\n    </a>\n  ",
  methods: {
    openChildJob: function openChildJob() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Jobs/GetJobId", {
        JobNumber: this.childJobs
      }).then(function (response) {
        if (response.status == 200) {
          window.open("/Jobs/Edit/" + response.data, "_blank");
        } else {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
        }
      }).catch(function (error) {
        // always executed
        KTApp.unblockPage();
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reBcIsInitial: true,
      isShowFooter: false,
      reBcDateReq: null,
      reBcTransferJobCommitDateStart: null,
      reBcTransferJobCommitDateEnd: null,
      reBcRetrieveJobCommitDateStart: null,
      reBcRetrieveJobCommitDateEnd: null,
      reBcTransferJobNumber: null,
      reBcChildJobs: null,
      reBcTransferJobTypeCode: null,
      reBcOrigin: [],
      reBcDestination: [],
      reBcTransitId: [],
      reBcTransitContact: null,
      reBcTransitContactTel: null,
      reBcTransferJobStatusCode: [],
      reBcCompletedJob: null,
      reBcResult: null,

      reBcTotalDestSingha: null,
      reBcTotalDestLeo: null,
      reBcTotalDestAsahi: null,
      reBcTotalDestCarlsberg: null,
      reBcTotalDestKronenbourg: null,
      reBcTotalDestSnowy: null,
      reBcTotalDestKopper: null,
      reBcTotalDestOther: null,
      reBcTotalDestCo2: null,
      reBcTotalDest: null,

      reBcTransferJobTypeCodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกประเภทเอกสาร",
        allowClear: true,
        data: [{
          id: "JOB_TYPE_TRANSFER_TO_AGENT",
          text: "ส่งสินค้าไปยังตัวแทน ฯ",
          data: null
        }, {
          id: "JOB_TYPE_RETURN",
          text: "ส่งสินค้า/ทรัพย์สินคืนต้นทาง",
          data: null
        }]
        // minimumResultsForSearch: -1,
        // placeholder: "กรุณาเลือกประเภทเอกสาร",
        // allowClear: true,
        // ajax: {
        //   url: "/Api/Variables/Options?search=JOB_TYPE",
        //   data: function(params) {
        //     var query = {
        //       search: params.term,
        //       page: params.page || 1
        //     };
        //     return query;
        //   },
        //   processResults: function(data, params) {
        //     return {
        //       results: data.results,
        //       pagination: {
        //         more: data.more
        //       }
        //     };
        //   },
        //   transport: function(params, success, failure) {
        //     params.beforeSend = function(request) {
        //       request.setRequestHeader(
        //         "Authorization",
        //         "Bearer " + self.$root.user.access_token
        //       );
        //     };
        //     var $request = $.ajax(params);
        //     $request.then(success);
        //     $request.fail(failure);
        //     return $request;
        //   }
        // }
      },
      reBcOriginOptions: [],
      // reBcOriginOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกต้นทาง",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2PlantAgent",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBcDestinationOptions: [],
      // reBcDestinationOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกปลายทาง",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2PlantAgent",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBcTransitIdOptions: [],
      // reBcTransitIdOptions: {
      //   placeholder: "กรุณาเลือกรถขนส่ง",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Transport/Select2Transport",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         showVendorTransport: true,
      //         agentCodes: [],
      //         isShowPickup: true,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBcTransferJobStatusCodeOptions: [],
      // reBcTransferJobStatusCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะต้นทาง",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=JOB_STATUS",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBcCompletedJobOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกสถานะปลายทาง",
        allowClear: true,
        data: [{
          id: 1,
          text: "ดำเนินการเรียบร้อย",
          data: null
        }, {
          id: 0,
          text: "ระหว่างดำเนินการ",
          data: null
        }]
      },
      reBcResultOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกผลการส่ง",
        allowClear: true,
        data: [{
          id: "ส่งครบ",
          text: "ส่งครบ",
          data: null
        }, {
          id: "ขาดส่ง",
          text: "ขาดส่ง",
          data: null
        }]
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.reBcTransferJobCommitDateStart = null;
      self.reBcTransferJobCommitDateEnd = null;
      self.reBcRetrieveJobCommitDateStart = null;
      self.reBcRetrieveJobCommitDateEnd = null;
      self.reBcTransferJobNumber = null;
      self.reBcChildJobs = null;
      self.reBcTransferJobTypeCode = null;
      self.reBcOrigin = [];
      self.reBcDestination = [];
      self.reBcTransitId = [];
      self.reBcTransitContact = null;
      self.reBcTransitContactTel = null;
      self.reBcTransferJobStatusCode = [];
      self.reBcCompletedJob = null;
      self.reBcResult = null;

      $("#reBcTransferJobTypeCode").val("").trigger("change");

      $("#reBcOrigin").val("").trigger("change");

      $("#reBcDestination").val("").trigger("change");

      $("#reBcTransitId").val("").trigger("change");

      $("#reBcTransferJobStatusCode").val("").trigger("change");

      $("#reBcCompletedJob").val("").trigger("change");

      $("#reBcResult").val("").trigger("change");
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      if (!self.reBcTransferJobCommitDateStart && self.reBcTransferJobCommitDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่ส่ง(เริ่มต้น)", "warning");
        return false;
      } else if (self.reBcTransferJobCommitDateStart && !self.reBcTransferJobCommitDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่ส่ง(สิ้นสุด)", "warning");
        return false;
      }

      if (!self.reBcRetrieveJobCommitDateStart && self.reBcRetrieveJobCommitDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่รับ(เริ่มต้น)", "warning");
        return false;
      } else if (self.reBcRetrieveJobCommitDateStart && !self.reBcRetrieveJobCommitDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่รับ(สิ้นสุด)", "warning");
        return false;
      }

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      e.preventDefault();
      var table = $("#brandCountTable").DataTable();
      table.draw();
    },
    LoadreBcOriginOptions: function LoadreBcOriginOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2PlantAgent", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBcOriginOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBcDestinationOptions: function LoadreBcDestinationOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2PlantAgent", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBcDestinationOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreBcTransitIdOptions: function LoadreBcTransitIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.reBcTransitIdOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Transport/Select2Transport", {
          showVendorTransport: true,
          agentCodes: [],
          isShowPickup: true,
          page: 1,
          search: searchQuery
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBcTransitIdOptions = [];
            data.forEach(function (element) {
              self.reBcTransitIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reBcTransitIdOptions);
        });
      }
    },

    LoadreBcTransferJobStatusCodeOptions: function LoadreBcTransferJobStatusCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=JOB_STATUS", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reBcTransferJobStatusCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    ExportBrandCount: function ExportBrandCount(e) {
      e.preventDefault();
      var self = this;

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportBrandCount",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reBcIsInitial,
          TransferJobCommitDateStart: self.reBcTransferJobCommitDateStart != null ? self.reBcTransferJobCommitDateStart.format("DD/MM/YYYY") : self.reBcTransferJobCommitDateStart,
          TransferJobCommitDateEnd: self.reBcTransferJobCommitDateEnd != null ? self.reBcTransferJobCommitDateEnd.format("DD/MM/YYYY") : self.reBcTransferJobCommitDateEnd,
          RetrieveJobCommitDateStart: self.reBcRetrieveJobCommitDateStart != null ? self.reBcRetrieveJobCommitDateStart.format("DD/MM/YYYY") : self.reBcRetrieveJobCommitDateStart,
          RetrieveJobCommitDateEnd: self.reBcRetrieveJobCommitDateEnd != null ? self.reBcRetrieveJobCommitDateEnd.format("DD/MM/YYYY") : self.reBcRetrieveJobCommitDateEnd,
          TransferJobNumber: self.reBcTransferJobNumber,
          ChildJobs: self.reBcChildJobs,
          TransferJobTypeCode: self.reBcTransferJobTypeCode,
          OriginCode: self.reBcOrigin,
          DestinationCode: self.reBcDestination,
          TransitId: self.reBcTransitId,
          TransitContact: self.reBcTransitContact,
          TransitContactTel: self.reBcTransitContactTel,
          TransferJobStatusCode: self.reBcTransferJobStatusCode,
          CompletedJob: self.reBcCompletedJob,
          Result: self.reBcResult
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    HiddenJobTransferToAgent: function HiddenJobTransferToAgent(JobTypeCode) {
      var showStatus = true;
      if (this.$root.canShow(['super_admin', 'MANAGE_MASTER', 'JOB_ADMIN_BORROW_APPROVE']) == true) {
        showStatus = true;
      } else {
        if (this.$root.user.profile.profile_type == "COMPANY_PROFILE_TYPE_AGENT") {
          if (JobTypeCode == "JOB_TYPE_TRANSFER_TO_AGENT") {
            showStatus = false;
          } else {
            showStatus = true;
          }
        } else {
          showStatus = true;
        }
      }
      return showStatus;
    }, HiddenJobReturn: function HiddenJobReturn(JobTypeCode) {
      var showStatus = true;
      if (this.$root.canShow(['super_admin', 'MANAGE_MASTER', 'JOB_ADMIN_BORROW_APPROVE']) == true) {
        showStatus = true;
      } else {
        if (this.$root.user.profile.profile_type == "COMPANY_PROFILE_TYPE_AGENT") {
          if (JobTypeCode == "JOB_TYPE_RETURN") {
            showStatus = false;
          } else {
            showStatus = true;
          }
        } else {
          showStatus = true;
        }
      }
      return showStatus;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreBcOriginOptions();
              self.LoadreBcDestinationOptions();
              self.LoadreBcTransferJobStatusCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reBcDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reBcTransferJobCommitDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.reBcTransferJobCommitDateStart).datepicker("update", !!self.reBcTransferJobCommitDateStart ? self.reBcTransferJobCommitDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBcTransferJobCommitDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reBcTransferJobCommitDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateEnd = moment().endOf('month');
              $(self.$refs.reBcTransferJobCommitDateEnd).datepicker("update", !!self.reBcTransferJobCommitDateEnd ? self.reBcTransferJobCommitDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBcTransferJobCommitDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reBcRetrieveJobCommitDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reMmTransactionDateEnd = moment().endOf('month');
              $(self.$refs.reBcRetrieveJobCommitDateStart).datepicker("update", !!self.reBcRetrieveJobCommitDateStart ? self.reBcRetrieveJobCommitDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBcRetrieveJobCommitDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reBcRetrieveJobCommitDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reMmTransactionDateEnd = moment().endOf('month');
              $(self.$refs.reBcRetrieveJobCommitDateEnd).datepicker("update", !!self.reBcRetrieveJobCommitDateEnd ? self.reBcRetrieveJobCommitDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reBcRetrieveJobCommitDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#brandCountTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/BrandCount",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    self.isShowFooter = false;

                    var jsonSearch = {
                      IsInitial: self.reBcIsInitial,
                      TransferJobCommitDateStart: self.reBcTransferJobCommitDateStart != null ? self.reBcTransferJobCommitDateStart.format("DD/MM/YYYY") : self.reBcTransferJobCommitDateStart,
                      TransferJobCommitDateEnd: self.reBcTransferJobCommitDateEnd != null ? self.reBcTransferJobCommitDateEnd.format("DD/MM/YYYY") : self.reBcTransferJobCommitDateEnd,
                      RetrieveJobCommitDateStart: self.reBcRetrieveJobCommitDateStart != null ? self.reBcRetrieveJobCommitDateStart.format("DD/MM/YYYY") : self.reBcRetrieveJobCommitDateStart,
                      RetrieveJobCommitDateEnd: self.reBcRetrieveJobCommitDateEnd != null ? self.reBcRetrieveJobCommitDateEnd.format("DD/MM/YYYY") : self.reBcRetrieveJobCommitDateEnd,
                      TransferJobNumber: self.reBcTransferJobNumber,
                      ChildJobs: self.reBcChildJobs,
                      TransferJobTypeCode: self.reBcTransferJobTypeCode,
                      OriginCode: self.reBcOrigin,
                      DestinationCode: self.reBcDestination,
                      TransitId: self.reBcTransitId,
                      TransitContact: self.reBcTransitContact,
                      TransitContactTel: self.reBcTransitContactTel,
                      TransferJobStatusCode: self.reBcTransferJobStatusCode,
                      CompletedJob: self.reBcCompletedJob,
                      Result: self.reBcResult
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[1, "desc"]],
                columns: [{
                  data: "transferJobCommitDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, {
                  data: "transferJobCommitDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.transferJobCommitDateString;
                  }
                }, {
                  data: "retrieveJobCommitDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.retrieveJobCommitDateString;
                  }
                }, {
                  data: "transferMinutes",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.transferMinutesString;
                  }
                }, {
                  data: "transferJobNumber",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var jobStatus = self.HiddenJobTransferToAgent(full.transferJobTypeCode);
                    if (jobStatus) {
                      return data + '<div class="actionsTransferJob"></div>';
                    } else {
                      return data;
                    }
                  }
                }, {
                  data: "childJobs",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      var str = "";
                      for (var i = 0; i < full.childJobsList.length; i++) {
                        var jobStatus = self.HiddenJobReturn(full.transferJobTypeCode);
                        if (jobStatus) {
                          str += full.childJobsList[i] + '<div class="actionsChildJob" data-childJobs="' + full.childJobsList[i] + '"></div><br>';
                        } else {
                          str += full.childJobsList[i];
                        }
                      }
                      return str;
                      //return data+'<div class="actionsChildJob"></div>';
                    } else {
                      return "";
                    }
                  }
                }, { data: "transferJobTypeName", className: "text-center" }, { data: "originCode", className: "text-center" }, { data: "originName", className: "text-center" }, { data: "destinationCode", className: "text-center" }, { data: "destinationName", className: "text-center" }, {
                  data: "destSinghaAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "destLeoAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "destAsahiAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "destCarlsbergAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "destKronenbourgAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "destSnowyAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "destKopperAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "destOtherAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "destCo2Amount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "destAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "transitCompanyNameString",
                  className: "text-center"
                  // render : function (data, type, full, meta){
                  //   if(full.pickupAtOrigin){
                  //     return "รับเอง"
                  //   }
                  //   else if(full.transitCompanyName != null){
                  //     return full.transitCompanyName +" ("+full.transitCarReg+")";
                  //   }
                  //   else{
                  //     return "";
                  //   }
                  //}
                }, { data: "transitContactFullName", className: "text-center" }, { data: "transitContactTel", className: "text-center" }, { data: "transferJobStatusName", className: "text-center" }, {
                  data: "completedJob",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data === 1) {
                      return "ดำเนินการเรียบร้อย";
                    } else {
                      return "ระหว่างดำเนินการ";
                    }
                  }
                }, { data: "result", className: "text-center" }, {
                  data: "diffAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "transferJobId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (full.diffAmount !== 0) {
                      return '<div class="action"></div>';
                    } else {
                      return "";
                    }
                  }
                }],
                rowCallback: function rowCallback(row, data, index) {
                  if (data.childJobsList.length > 0) {
                    $(row).prop("rowspan", data.childJobsList.length);

                    // $.each( data.childJobsList, function( key, value ) {

                    //   //$(row).find('td:eq(ุ6)').row html( '<b>A</b>' );

                    // });
                  }

                  if (data.transferJobStatusCode === "JOB_STATUS_SUCCESS") {
                    $(row).find("td:eq(24)").css("color", "#00B050");
                  }
                  if (data.completedJob === 1) {
                    $(row).find("td:eq(25)").css("color", "#00B050");
                  }
                  if (data.completedJob === 0) {
                    $(row).find("td:eq(25)").css("color", "#FFC000");
                  }
                  if (data.result === "ส่งครบ") {
                    $(row).find("td:eq(26)").css("color", "#00B050");
                  }
                  if (data.result === "ขาดส่ง") {
                    $(row).find("td:eq(26)").css("color", "#FF0000");
                  }
                  if (data.diffAmount !== 0) {
                    $(row).find("td:eq(27)").css("color", "#FF0000");
                  }
                },
                drawCallback: function drawCallback(settings) {
                  self.reBcIsInitial = false;
                  self.reBcDateReq = moment().format("DD/MM/YYYY h:mm a");

                  var allPage = table.DataTable().page.info().pages;
                  var currentPage = table.DataTable().page.info().page + 1;

                  self.isShowFooter = false;
                  self.isShowFooter = null;
                  self.reBcTotalDestLeo = null;
                  self.reBcTotalDest = null;
                  self.reBcTotalDestAsahi = null;
                  self.reBcTotalDestCarlsberg = null;
                  self.reBcTotalDestCo2 = null;
                  self.reBcTotalDestKopper = null;
                  self.reBcTotalDestKronenbourg = null;
                  self.reBcTotalDestLeo = null;
                  self.reBcTotalDestOther = null;
                  self.reBcTotalDestSingha = null;
                  self.reBcTotalDestSnowy = null;

                  if (allPage == currentPage) {
                    self.isShowFooter = true;
                    self.reBcTotalDestLeo = settings.json.data[0].total.destLeoAmountTotal !== 0 ? settings.json.data[0].total.destLeoAmountTotal : "-";
                    self.reBcTotalDest = settings.json.data[0].total.destAmountTotal !== 0 ? settings.json.data[0].total.destAmountTotal : "-";
                    self.reBcTotalDestAsahi = settings.json.data[0].total.destAsahiAmountTotal !== 0 ? settings.json.data[0].total.destAsahiAmountTotal : "-";
                    self.reBcTotalDestCarlsberg = settings.json.data[0].total.destCarlsbergAmountTotal !== 0 ? settings.json.data[0].total.destCarlsbergAmountTotal : "-";
                    self.reBcTotalDestCo2 = settings.json.data[0].total.destCo2AmountTotal !== 0 ? settings.json.data[0].total.destCo2AmountTotal : "-";
                    self.reBcTotalDestKopper = settings.json.data[0].total.destKopperAmountTotal !== 0 ? settings.json.data[0].total.destKopperAmountTotal : "-";
                    self.reBcTotalDestKronenbourg = settings.json.data[0].total.destKronenbourgAmountTotal !== 0 ? settings.json.data[0].total.destKronenbourgAmountTotal : "-";
                    self.reBcTotalDestLeo = settings.json.data[0].total.destLeoAmountTotal !== 0 ? settings.json.data[0].total.destLeoAmountTotal : "-";
                    self.reBcTotalDestOther = settings.json.data[0].total.destOtherAmountTotal !== 0 ? settings.json.data[0].total.destOtherAmountTotal : "-";
                    self.reBcTotalDestSingha = settings.json.data[0].total.destSinghaAmountTotal !== 0 ? settings.json.data[0].total.destSinghaAmountTotal : "-";
                    self.reBcTotalDestSnowy = settings.json.data[0].total.destSnowyAmountTotal !== 0 ? settings.json.data[0].total.destSnowyAmountTotal : "-";

                    //$.fn.dataTable.tables( {visible: true, api: true} ).columns.adjust();
                  }
                }
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.form, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.form);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
                $(".action").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new Actions({ data: { data: data }, parent: self }).$mount(el);
                  }
                });

                $(".actionsTransferJob").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new ActionsTransferJob({ data: { data: data }, parent: self }).$mount(el);
                  }
                });

                $(".actionsChildJob").each(function (i, el) {
                  // console.log(i);
                  var childJobs = el.getAttribute("data-childJobs");
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new ActionsChildJob({ data: { childJobs: childJobs }, parent: self }).$mount(el);
                  }
                });
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    var self = this;
    return {
      items: []
    };
  },
  methods: {
    formSubmit: function formSubmit(e) {}
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, router, user;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              router = _this.$router;
              _context.next = 4;
              return _this.$root.getUser();

            case 4:
              user = _context.sent;


              $("#brandCountBarcodeModal").on("hidden.bs.modal", function () {
                // Set go back
                router.go(-1);
                //self.$parent.reloadDataTable(false);
              }).modal("show");

              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
              });

              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Report/BrandCount/Barcode/" + _this.$route.params.id).then(function (response) {
                if (response.status == 200) {
                  if (response.data != null && response.data.length > 0) {
                    self.items = response.data;
                  }
                } else {
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "warning");
                  router.go(-1);
                }
              }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
                router.go(-1);
              }).then(function () {
                // always executed
                KTApp.unblockPage();
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      reIsInitial: true,
      dataTable: [],
      brandHeader: [],
      volume: [],
      brandItem: [],
      costMonthList: [[], [], [], [], [], [], [], [], [], [], [], []],
      totalCostMonth: [],
      totalCost: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      sumTotal: 0,
      totalCostBarnd: [],
      sumType: [],
      numberOfTanks: [],
      reAaDateReq: null,
      // year : new Date().getFullYear()+543,
      year: new Date().getFullYear(),
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [
        // { id: new Date().getFullYear()+543, text: new Date().getFullYear()+543, data: null },
        // { id: new Date().getFullYear()+542, text: new Date().getFullYear()+542, data: null },
        // { id: new Date().getFullYear()+541, text: new Date().getFullYear()+541, data: null },
        // { id: new Date().getFullYear()+540, text: new Date().getFullYear()+540, data: null },
        // { id: new Date().getFullYear()+539, text: new Date().getFullYear()+539, data: null }
        { id: new Date().getFullYear(), text: new Date().getFullYear(), data: null }, { id: new Date().getFullYear() - 1, text: new Date().getFullYear() - 1, data: null }, { id: new Date().getFullYear() - 2, text: new Date().getFullYear() - 2, data: null }, { id: new Date().getFullYear() - 3, text: new Date().getFullYear() - 3, data: null }, { id: new Date().getFullYear() - 4, text: new Date().getFullYear() - 4, data: null }]
      },
      sumPriceTotalbrandHeader: [],
      sumPriceTotalCostBarnd: 0,
      sumPriceTotalbrandHeader2: [],
      sumPriceTotalCostBarnd2: 0
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      // self.year = new Date().getFullYear()+543;
      self.year = new Date().getFullYear();
      self.dataTable = [];
      self.brandHeader = [];
      self.volume = [];
      self.brandItem = [];
      self.costMonthList = [[], [], [], [], [], [], [], [], [], [], [], []];
      self.totalCostMonth = [];
      self.totalCost = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      self.sumTotal = 0;
      self.totalCostBarnd = [];
      self.sumType = [];

      $("#year").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;
      self.dataTable = [];
      self.brandHeader = [];
      self.volume = [];
      self.brandItem = [];
      self.costMonthList = [[], [], [], [], [], [], [], [], [], [], [], []];
      self.totalCostMonth = [];
      self.totalCost = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      self.sumTotal = 0;
      self.totalCostBarnd = [];
      self.sumType = [];
      self.numberOfTanks = [];
      this.getDataFromApi();
      e.preventDefault();
      table.draw();
    },
    getDataFromApi: function getDataFromApi() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/CostBeerClaim",
        data: {
          // Year : self.year-543
          Year: self.year,
          IsInitial: self.reIsInitial
        }
      }).then(function (response) {
        self.dataTable = response.data.data;
        self.dataTable.forEach(function (e) {
          var brand = self.brandHeader.includes(e.productBrandName);
          if (!brand) {
            self.brandHeader.push(e.productBrandName);
          }
        });

        // brandItem
        self.dataTable.forEach(function (e) {
          var brand = self.brandHeader.includes(e.productBrandName);
          if (brand) {
            var list = [];
            list.push(e.productBrandName, e.volume, e.price);

            var item = self.brandItem.filter(function (o) {
              return o[0] == e.productBrandName && o[1] == e.volume;
            });
            if (item.length == 0) {
              self.brandItem.push(list);
            }
          }
        });

        // costMonthList
        for (var x = 0; x < self.costMonthList.length; x++) {
          for (var y = 0; y < self.brandItem.length; y++) {
            var costMonth = 0;
            self.costMonthList[x].push(costMonth);
          }
        }

        self.dataTable.forEach(function (e) {
          if (self.brandItem.length > 0) {
            for (var x = 0; x < self.brandItem.length; x++) {
              var price = 0;
              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 1) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }

              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 2) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }

              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 3) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }

              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 4) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }

              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 5) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }

              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 6) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }

              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 7) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }

              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 8) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }

              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 9) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }

              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 10) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }

              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 11) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }

              if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 12) {
                self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
              }
            }
          }
        });
        // end costMonthList

        // totalCostMonth
        if (self.brandItem.length > 0) {
          for (var x = 0; x < self.brandItem.length; x++) {
            var price = 0;
            self.totalCostMonth.push(price);

            for (var y = 0; y < 12; y++) {
              self.totalCostMonth[x] = parseFloat(self.totalCostMonth[x]) + parseFloat(self.costMonthList[y][x]);
            }
          }
        }
        // end totalCostMonth

        self.dataTable.forEach(function (e) {
          self.totalCost[e.month - 1] = self.totalCost[e.month - 1] + e.price;
          self.sumTotal = self.sumTotal + e.price;
        });
        self.dataTable.forEach(function (e) {
          var data = {
            BrandName: e.productBrandName,
            Month: e.month,
            Price: e.price,
            Type: e.problemTypeCode
          };

          var list = self.totalCostBarnd.filter(function (o) {
            return o.BrandName == e.productBrandName && o.Month == e.month && o.Type == e.problemTypeCode;
          });
          if (list.length != 0) {
            list[0].Price = list[0].Price + e.price;
          } else {
            self.totalCostBarnd.push(data);
          }

          var type = self.sumType.filter(function (o) {
            return o.Type == e.problemTypeCode;
          });
          var dataType = {
            Price: e.price,
            Type: e.problemTypeCode
          };
          if (type.length != 0) {
            type[0].Price = type[0].Price + e.price;
          } else {
            self.sumType.push(dataType);
          }
        });

        // totalCostBarnd
        self.sumPriceTotalbrandHeader = [];
        self.sumPriceTotalbrandHeader2 = [];

        if (self.totalCostBarnd.length > 0) {
          for (var i = 0; i < self.brandHeader.length; i++) {
            self.sumPriceTotalCostBarnd = 0;
            self.sumPriceTotalCostBarnd2 = 0;
            for (var j = 0; j < self.totalCostBarnd.length; j++) {
              if (self.brandHeader[i] == self.totalCostBarnd[j].BrandName) {
                if (self.totalCostBarnd[j].Price && self.totalCostBarnd[j].Price > 0 && self.totalCostBarnd[j].Type == "PROBLEM_TYPE_DAMAGED_TANK") {
                  self.sumPriceTotalCostBarnd = parseFloat(self.sumPriceTotalCostBarnd) + parseFloat(self.totalCostBarnd[j].Price);
                }

                if (self.totalCostBarnd[j].Price && self.totalCostBarnd[j].Price > 0 && self.totalCostBarnd[j].Type == "PROBLEM_TYPE_UNUSUAL_TASTE") {
                  self.sumPriceTotalCostBarnd2 = parseFloat(self.sumPriceTotalCostBarnd2) + parseFloat(self.totalCostBarnd[j].Price);
                }
              }
            }
            self.sumPriceTotalbrandHeader.push(self.sumPriceTotalCostBarnd);
            self.sumPriceTotalbrandHeader2.push(self.sumPriceTotalCostBarnd2);
          }
        }
        // end

        // จำนวนถัง
        if (self.brandItem.length > 0) {
          for (var x = 0; x < self.brandItem.length; x++) {
            var numberOfTanks = 0;
            for (var y = 0; y < self.dataTable.length; y++) {
              if (self.brandItem[x][0] == self.dataTable[y].productBrandName && self.brandItem[x][1] == self.dataTable[y].volume && self.dataTable[y].price >= 0) {
                numberOfTanks++;
              }
            }
            self.numberOfTanks.push(numberOfTanks);
          }
        }
        // end
      });
      self.reIsInitial = false;
    },
    onlyUnique: function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              _this.getDataFromApi();
              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
              // self.reAaDateReq = moment().format("DD/MM/") + (new Date().getFullYear() + 543) + " " + moment().format("H:mm");
              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reIsInitial: true,
      reAaDateReq: null,
      reStartDate: null,
      reEndDate: null,
      reDepartments: [],
      reAgentCodes: [],
      reQuarter: null,
      reYear: new Date().getFullYear(),
      reYearOptions: [],
      reDepartmentsOptions: [],
      reAgentCodesOptions: [],
      reQuarterOptions: [{ id: "1", label: "ไตรมาส 1" }, { id: "2", label: "ไตรมาส 2" }, { id: "3", label: "ไตรมาส 3" }, { id: "4", label: "ไตรมาส 4" }],
      LoadPeriodYearOptions: function LoadPeriodYearOptions(e) {
        var self = this;
        self.reYearOptions = [];
        var currentYear = new Date().getFullYear();
        for (var year = 2021; year <= currentYear; year++) {
          self.reYearOptions.push({
            id: year.toString(),
            label: year.toString()
          });
        }
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reDepartments = [];
      self.reAgentCodes = [];
      self.reQuarter = null;
      self.reYear = new Date().getFullYear().toString();

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reDepartments").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#reQuarter").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#5SByAgentTable").DataTable();
      table.draw();
    },
    LoadreDepartmentsOptions: function LoadreDepartmentsOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reDepartmentsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadreDepartmentsOptions();
              self.LoadreAgentCodesOptions();
              self.LoadPeriodYearOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#5SByAgentTable");

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/EvaluateTransactionView5",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      Quarter: self.reQuarter,
                      Year: self.reYear,
                      SalesArea: self.reDepartments,
                      AgentCodes: self.reAgentCodes,
                      IsInitial: self.reIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[2, "desc"]],
                columns: [{
                  data: "agentCode",
                  className: "text-center",
                  sortable: false,
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "agentName", className: "text-center" }, { data: "departments", className: "text-center" }, { data: "advisorCount", className: "text-center" }, { data: "qualityCount", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

              $(_this.$refs.form).validate({
                rules: {
                  reYear: "required"
                }
              });
              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAaDateReq: null,
      reObjectivesCode: null,
      reStartDate: null,
      reEndDate: null,
      reAgentCodes: [],
      reUserIds: null,
      reStatus: null,
      reAgentCodesOptions: [],
      reAaIsInitial: true,
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_MKT",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      reUserIdsOptions: {
        placeholder: "กรุณาเลือกเจ้าหน้าที่",
        allowClear: true,
        ajax: {
          delay: 300,
          method: "post",
          url: "/Api/Users/Select2UserMkt",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              agentCodes: self.reAgentCodes
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reObjectivesCodeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "MKT_ACTIVITY_TYPE_EVENT", text: "Event", data: null }, {
          id: "MKT_ACTIVITY_TYPE_FOOD_FESTIVAL",
          text: "มหกรรมอาหาร",
          data: null
        }]
      },
      reStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "MKT_ACTIVITY_STATUS_COMPLETE", text: "ปิด", data: null }, { id: "MKT_ACTIVITY_STATUS_SAVED", text: "เปิด", data: null }]
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reObjectivesCode = null;
      self.reAgentCodes = [];
      self.reUserIds = null;
      self.reStatus = null;

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reObjectivesCode").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#reUserIds").val("").trigger("change");

      $("#reStatus").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#EventAndFoodTable").DataTable();
      table.draw();
    },
    exportEventAndFoodTable: function exportEventAndFoodTable(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportMKTEventAndFood",
        responseType: "arraybuffer",
        data: {
          ObjectivesCode: self.reObjectivesCode,
          EventStartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
          EventEndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
          AgentCode: self.reAgentCodes,
          CreatedUserId: self.reUserIds,
          StatusCode: self.reStatus
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_MKT", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreAgentCodesOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reEndDate = moment().endOf('month');
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#EventAndFoodTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/MKTEventAndFood",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      IsInitial: self.reAaIsInitial,
                      ObjectivesCode: self.reObjectivesCode,
                      EventStartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                      EventEndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
                      AgentCode: self.reAgentCodes,
                      CreatedUserId: self.reUserIds,
                      StatusCode: self.reStatus
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                //orderFixed : [0, "asc"],
                order: [[0, "asc"]],
                columns: [{
                  data: "activityHeaderId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "objectivesName", className: "text-center" }, { data: "activityName", className: "text-center" }, { data: "statusName", className: "text-center" }, { data: "createdName", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "provinceName", className: "text-center", orderable: false }, {
                  data: "eventStartDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.eventStartDateString;
                  }
                }, {
                  data: "eventEndDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.eventEndDateString;
                  }
                }, { data: "pgSaleItem", className: "text-center", orderable: false }, {
                  data: "pgSaleItemQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "saleItem", className: "text-center", orderable: false }, {
                  data: "saleItemQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "budget",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "productRequistion",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "productRequistionQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "productBorrow", className: "text-center", orderable: false }, {
                  data: "productBorrowQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "equipmentRequistion",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "equipmentRequistionQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "equipmentBorrow",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "equipmentBorrowQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "premiumsRequistion",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "premiumsRequistionQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "premiumsBorrow",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "premiumsBorrowQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reAaIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  if (settings.json.recordsTotal > 0) {
                    // self.isShowFooter = true;
                    // self.TotalAmount = settings.json.data[0].grandTotalBarcodes;
                    $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
                  }

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reFrIsInitial: true,
      reFrDateReq: null,
      reFrJobDateStart: null,
      reFrJobDateEnd: null,
      reFrBarcode: null,
      reFrDepartmentMaterialCode: [],
      reFrJobNumber: null,
      reFrSparePartCode: [],
      reFrByUser: [],
      reFrProductGroup: [],
      reFrProductType: [],
      reFrMaterialCode: [],
      reJrJobRetrieve: [],
      TotalAmount: 0,
      isShowFooter: false,
      reFrBarcodeOptions: {
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reFrDepartmentMaterialCodeOptions: [],
      // reFrDepartmentMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสทรัพย์สินเบียร์สด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reFrSparePartCodeOptions: [],
      // reFrSparePartCodeOptions: {
      //   placeholder: "กรุณาเลือกรายการอะไหล่",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/ProductJob",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reFrByUserOptions: [],
      // reFrByUserOptions: {
      //   placeholder: "กรุณาเลือกผู้ซ่อม",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ByUser",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reFrProductGroupOptions: [],
      // reFrProductGroupOptions: {
      //   placeholder: "กรุณาเลือกหมวดสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reFrProductTypeOptions: [],
      // reFrProductTypeOptions: {
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reFrMaterialCodeOptions: []
      // reFrMaterialCodeOptions: {
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reFrJobDateStart = null;
      self.reFrJobDateEnd = null;
      self.reFrBarcode = null;
      self.reFrDepartmentMaterialCode = [];
      self.reFrJobNumber = null;
      self.reFrSparePartCode = [];
      self.reFrByUser = [];
      self.reFrProductGroup = [];
      self.reFrProductType = [];
      self.reFrMaterialCode = [];

      $("#reFrJobDateStart").val("").trigger("change");

      $("#reFrJobDateEnd").val("").trigger("change");

      $("#reFrBarcode").val("").trigger("change");

      $("#reFrDepartmentMaterialCode").val("").trigger("change");

      $("#reFrSparePartCode").val("").trigger("change");

      $("#reFrByUser").val("").trigger("change");

      $("#reFrProductGroup").val("").trigger("change");

      $("#reFrProductType").val("").trigger("change");

      $("#reFrMaterialCode").val("").trigger("change");

      //this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      if (!self.reFrJobDateStart && self.reFrJobDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่เริ่มต้น", "warning");
        return false;
      } else if (self.reFrJobDateStart && !self.reFrJobDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่สิ้นสุด", "warning");
        return false;
      }

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var status = null;
      // if(self.reFrDepartmentMaterialCode !=null){
      //   status = $("#reFrDepartmentMaterialCode").text();
      //   console
      // }

      e.preventDefault();
      var table = $("#fixedProductTable").DataTable();
      table.draw();
    },
    exportFixedProducts: function exportFixedProducts(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportFixedProducts",
        responseType: "arraybuffer",
        data: {
          JobDateStart: self.reFrJobDateStart != null ? self.reFrJobDateStart.format("DD/MM/YYYY") : self.reFrJobDateStart,
          JobDateEnd: self.reFrJobDateEnd != null ? self.reFrJobDateEnd.format("DD/MM/YYYY") : self.reFrJobDateEnd,
          Barcode: self.reFrBarcode,
          DepartmentMaterialCode: self.reFrDepartmentMaterialCode,
          SparePartCode: self.reFrSparePartCode,
          JobNumber: self.reFrJobNumber,
          ByUser: self.reFrByUser,
          MaterialCode: self.reFrMaterialCode,
          ProductGroup: self.reFrProductGroup,
          ProductType: self.reFrProductType,
          IsInitial: self.reFrIsInitial
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreFrDepartmentMaterialCodeOptions: function LoadreFrDepartmentMaterialCodeOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.reFrDepartmentMaterialCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2DepartmentMaterial", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reFrDepartmentMaterialCodeOptions = [];
            data.forEach(function (element) {
              self.reFrDepartmentMaterialCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reFrDepartmentMaterialCodeOptions);
        }).catch(function (error) {});
      }
    },

    LoadreFrSparePartCodeOptions: function LoadreFrSparePartCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/ProductJob", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reFrSparePartCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreFrByUserOptions: function LoadreFrByUserOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ByUser", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reFrByUserOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreFrProductGroupOptions: function LoadreFrProductGroupOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductGroup/Select2ProductGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reFrProductGroupOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreFrProductTypeOptions: function LoadreFrProductTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reFrProductTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreFrMaterialCodeOptions: function LoadreFrMaterialCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reFrMaterialCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreFrSparePartCodeOptions();
              self.LoadreFrByUserOptions();
              self.LoadreFrProductGroupOptions();
              self.LoadreFrProductTypeOptions();
              self.LoadreFrMaterialCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reFrDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reFrJobDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });

              $(self.$refs.reFrJobDateStart).on("changeDate", function (e) {
                self.reFrJobDateStart = moment(e.date);
              });

              $(self.$refs.reFrJobDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });

              $(self.$refs.reFrJobDateEnd).on("changeDate", function (e) {
                self.reFrJobDateEnd = moment(e.date);
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#fixedProductTable");
              // begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/FixedProducts",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    self.isShowFooter = false;
                    self.TotalAmount = 0;

                    var jsonSearch = {
                      JobDateStart: self.reFrJobDateStart != null ? self.reFrJobDateStart.format("DD/MM/YYYY") : self.reFrJobDateStart,
                      JobDateEnd: self.reFrJobDateEnd != null ? self.reFrJobDateEnd.format("DD/MM/YYYY") : self.reFrJobDateEnd,
                      Barcode: self.reFrBarcode,
                      IsInitial: self.reFrIsInitial,
                      DepartmentMaterialCode: self.reFrDepartmentMaterialCode,
                      SparePartCode: self.reFrSparePartCode,
                      JobNumber: self.reFrJobNumber,
                      ByUser: self.reFrByUser,
                      MaterialCode: self.reFrMaterialCode,
                      ProductGroup: self.reFrProductGroup,
                      ProductType: self.reFrProductType
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[2, "desc"]],
                columns: [{
                  data: "jobDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "jobNumber", className: "text-center" }, {
                  data: "jobDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.jobDateString;
                  }
                }, { data: "monthString", className: "text-center" }, { data: "year", className: "text-center" }, { data: "displayName", className: "text-center" }, { data: "productGroupName", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "materialName", className: "text-center" }, { data: "barcodeNoOld", className: "text-center" }, { data: "departmentMaterialCode", className: "text-center" }, { data: "sparePartName", className: "text-center" }, {
                  data: "quantity",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null || data != "" || data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "pricing",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return self.$options.filters.currency(data, "฿");
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reFrIsInitial = false;
                  self.reFrDateReq = moment().format("DD/MM/YYYY h:mm a");

                  var allPage = table.DataTable().page.info().pages;
                  var currentPage = table.DataTable().page.info().page + 1;

                  if (allPage == currentPage) {
                    self.isShowFooter = true;
                    self.TotalAmount = settings.json.data[0].totalAmount;
                  }
                }
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.form, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.form);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      reInvDateStart: null,
      reInvDateEnd: null,
      reAaIsInitial: true,
      reAaDateReq: null,
      reInvPhase: null,
      reInvLot: null,
      reInvBrand: null,
      reInvStatus: null,
      reInvInvoice: null,
      reInvProductTypeId: null,
      reInvSupplier: null,
      reInvPriceStart: null,
      reInvPriceEnd: null,
      reInvLastQty: null,
      reInvLastPrice: null,
      reInvLastPriceTotal: null,
      reInvLastGrandPriceTotal: null,

      reInvStatusOptions: {
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        data: [{ id: "วางบิลเสร็จสิ้น", text: "วางบิลเสร็จสิ้น", data: null }, { id: "ชำระแล้ว", text: "ชำระแล้ว", data: null }]
      },
      reInvProductTypeIdOptions: {
        placeholder: "กรุณาเลือกแบรนด์สินค้า",
        data: [{ id: "3", text: "เครื่องทำความเย็น", data: null }, { id: "6", text: "หัวจ่าย", data: null }]
      },
      reInvSupplierOptions: {
        placeholder: "กรุณาเลือกSupplier",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Vendors/Select2Vendor",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reInvPhaseOptions: {
        placeholder: "กรุณาเลือกPhase",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Phase",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reInvLotOptions: {
        placeholder: "กรุณาเลือกLot",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Lot",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              Phase: self.reInvPhase
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reInvBrandOptions: {
        placeholder: "กรุณาเลือกแบรนด์เครื่องเบียร์สด",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2BrandMachine",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              ProductType: "3,6"
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reInvDateStart = null;
      self.reInvDateEnd = null;
      self.reInvPhase = null;
      self.reInvLot = null;
      self.reInvBrand = null;
      self.reInvStatus = null;
      self.reInvInvoice = null;
      self.reInvProductTypeId = null;
      self.reInvSupplier = null;
      self.reInvPriceStart = null;
      self.reInvPriceEnd = null;

      $("#reInvPhase").val("").trigger("change");

      $("#reInvLot").val("").trigger("change");

      $("#reInvBrand").val("").trigger("change");

      $("#reInvStatus").val("").trigger("change");

      $("#reInvProductTypeId").val("").trigger("change");

      $("#reInvSupplier").val("").trigger("change");

      this.formSubmit(e);

      //var table = $("#InvoiceTable").DataTable();
      //table.draw();
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#InvoiceTable").DataTable();
      table.draw();
    },
    exportInvoice: function exportInvoice(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportInvoice",
        responseType: "arraybuffer",
        data: {
          DateStart: self.reInvDateStart != null ? self.reInvDateStart.format("DD/MM/YYYY") : self.reInvDateStart,
          DateEnd: self.reInvDateEnd != null ? self.reInvDateEnd.format("DD/MM/YYYY") : self.reInvDateEnd,
          Phase: self.reInvPhase,
          Lot: self.reInvLot,
          Brand: self.reInvBrand,
          Status: self.reInvStatus,
          Invoice: self.reInvInvoice,
          ProductTypeId: self.reInvProductTypeId,
          PriceStart: self.reInvPriceStart,
          PriceEnd: self.reInvPriceEnd,
          Supplier: self.reInvSupplier
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reInvDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.reInvDateStart).datepicker("update", !!self.reInvDateStart ? self.reInvDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reInvDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reInvDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.reInvDateEnd).datepicker("update", !!self.reInvDateEnd ? self.reInvDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reInvDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#InvoiceTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/Invoice",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      DateStart: self.reInvDateStart ? self.reInvDateStart.format("DD/MM/YYYY") : null,
                      DateEnd: self.reInvDateEnd ? self.reInvDateEnd.format("DD/MM/YYYY") : null,
                      Phase: self.reInvPhase,
                      Lot: self.reInvLot,
                      Brand: self.reInvBrand,
                      Status: self.reInvStatus,
                      Invoice: self.reInvInvoice,
                      ProductTypeId: self.reInvProductTypeId,
                      PriceStart: self.reInvPriceStart,
                      PriceEnd: self.reInvPriceEnd,
                      Supplier: self.reInvSupplier,
                      IsInitial: self.reAaIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [100, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[0, "desc"]],
                columns: [{
                  data: "date",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.dateStringFormat;
                  }
                }, {
                  data: "invoice",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "phase",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "lot",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "trancheNo",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "supplierName",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "productTypeName",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "productName",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "productBrand",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "qty",
                  className: "text-center",
                  orderable: false
                }, {
                  data: "price",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "priceTotal",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "priceGrandtotal",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "billStatus",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data) {
                      var value = full.priceGrandtotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                      return '<p class="text-success">' + value + '<br><i class="fas fa-check-circle text-success"></i>';
                    } else {
                      return '<i class="fas fa-times-circle text-danger"></i>';
                    }
                  }
                }, {
                  data: "paymentStatus",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data) {
                      return '<i class="fas fa-check-circle text-success"></i>';
                    } else {
                      return '<i class="fas fa-times-circle text-danger"></i>';
                    }
                  }
                }],
                rowCallback: function rowCallback(row, data, index) {
                  $(row).find("td:eq(11)").css("background-color", "#F2DCDB");
                },
                drawCallback: function drawCallback(settings) {
                  self.reAaIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  if (settings.json.data.length === 0) {
                    self.reInvLastQty = 0;
                    self.reInvLastPrice = 0;
                    self.reInvLastPriceTotal = 0;
                    self.reInvLastGrandPriceTotal = 0;
                    return false;
                  }

                  var table = $("#InvoiceTable");
                  var rows = table.find($("tr"));
                  var prevCheck = "";
                  var mergeRow = 1;

                  for (var r = 0; r <= rows.length; r++) {
                    var dateOfBilling = $($(rows[r]).find("td")[0]).text();
                    var phase = $($(rows[r]).find("td")[2]).text();
                    var lot = $($(rows[r]).find("td")[3]).text();
                    var trancheNo = $($(rows[r]).find("td")[4]).text();
                    var check = dateOfBilling + "#" + phase + "#" + lot + "#" + trancheNo;
                    if (prevCheck == "") {
                      prevCheck = check;
                      continue;
                    }
                    if (prevCheck == check) {
                      mergeRow = mergeRow + 1;
                      continue;
                    }

                    //hide col
                    var cols = [0, 1, 2, 3, 4, 12, 13, 14];
                    for (var h = 1; h < mergeRow; h++) {
                      for (var i = 0; i < cols.length; i++) {
                        var c = cols[i];
                        $($(rows[r - h]).find("td")[c]).hide();
                      }
                    }

                    for (var i = 0; i < cols.length; i++) {
                      var _c = cols[i];
                      $($(rows[r - mergeRow]).find("td")[_c]).attr("rowspan", mergeRow);
                    }

                    mergeRow = 1;
                    prevCheck = check;
                  }

                  // var colsLength = 13;
                  // var removeLater = new Array();
                  // for (var i = 0; i < colsLength; i++) {
                  //   if (i == 0 || i == 1 || i == 2 || i == 3) {
                  //     var startIndex = 0;
                  //     var lastIndex = 0;
                  //     var startText = $($(rows[0]).find("td")[i]).text();
                  //     for (var j = 1; j < rows.length; j++) {
                  //       var cRow = $(rows[j]);
                  //       var cCol = $(cRow.find("td")[i]);

                  //       var currentText = cCol.text();

                  //       if (currentText == startText) {
                  //         removeLater.push(cCol);
                  //         lastIndex = j;
                  //         if (i == 1) {
                  //           var cCol1 = $(cRow.find("td")[i + 10]);
                  //           var cCol2 = $(cRow.find("td")[i + 11]);
                  //           var cCol3 = $(cRow.find("td")[i + 12]);
                  //           removeLater.push(cCol1);
                  //           removeLater.push(cCol2);
                  //           removeLater.push(cCol3);
                  //         }
                  //       } else {
                  //         var spanLength = lastIndex - startIndex;
                  //         if (spanLength >= 1) {
                  //           $($(rows[startIndex]).find("td")[i]).attr(
                  //             "rowspan",
                  //             spanLength + 1
                  //           );
                  //         }

                  //         if (i == 1) {
                  //           $($(rows[startIndex]).find("td")[i + 10]).attr(
                  //             "rowspan",
                  //             spanLength + 1
                  //           );
                  //           $($(rows[startIndex]).find("td")[i + 11]).attr(
                  //             "rowspan",
                  //             spanLength + 1
                  //           );
                  //           $($(rows[startIndex]).find("td")[i + 12]).attr(
                  //             "rowspan",
                  //             spanLength + 1
                  //           );
                  //         }

                  //         lastIndex = j;
                  //         startIndex = j;
                  //         startText = currentText;
                  //       }
                  //     }

                  //     var spanLength = lastIndex - startIndex;
                  //     if (spanLength >= 1) {
                  //       $($(rows[startIndex]).find("td")[i]).attr(
                  //         "rowspan",
                  //         spanLength + 1
                  //       );

                  //       if (i == 1) {
                  //         $($(rows[startIndex]).find("td")[i + 10]).attr(
                  //           "rowspan",
                  //           spanLength + 1
                  //         );
                  //         $($(rows[startIndex]).find("td")[i + 11]).attr(
                  //           "rowspan",
                  //           spanLength + 1
                  //         );
                  //         $($(rows[startIndex]).find("td")[i + 12]).attr(
                  //           "rowspan",
                  //           spanLength + 1
                  //         );
                  //       }
                  //     }
                  //   }
                  // }

                  // for (var i in removeLater) {
                  //   $(removeLater[i]).hide();
                  // }

                  //========================
                  var allPage = table.DataTable().page.info().pages;
                  var currentPage = table.DataTable().page.info().page + 1;

                  self.reInvLastQty = settings.json.data[0].totalRecord.qty;
                  self.reInvLastPrice = settings.json.data[0].totalRecord.price;
                  self.reInvLastPriceTotal = settings.json.data[0].totalRecord.priceTotal;
                  self.reInvLastGrandPriceTotal = settings.json.data[0].totalRecord.priceGrandtotal;
                  $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_datatables_net_bs4_css_dataTables_bootstrap4_css__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_datatables_net_bs4_css_dataTables_bootstrap4_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_datatables_net_bs4_css_dataTables_bootstrap4_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_datatables_net_rowgroup_bs4_css_rowGroup_bootstrap4_css__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_datatables_net_rowgroup_bs4_css_rowGroup_bootstrap4_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_datatables_net_rowgroup_bs4_css_rowGroup_bootstrap4_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_plupload__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_plupload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_plupload__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




// CSS




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(14);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var ActionsretrieveJob = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n    <a href=\"#\" @click.prevent=\"openJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E15\u0E49\u0E19\u0E17\u0E32\u0E07\">\n      <i class=\"la la-external-link\"></i>\n    </a>\n  ",
  methods: {
    openJob: function openJob() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Jobs/GetJobId", {
        JobNumber: this.data.retrieveJobNumber
      }).then(function (response) {
        if (response.status == 200) {
          window.open("/Jobs/Edit/" + response.data, "_blank");
        } else {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
        }
      }).catch(function (error) {
        // always executed
        KTApp.unblockPage();
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  }
});

var ActionreturnJob = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n    <a href=\"#\" @click.prevent=\"openJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E15\u0E49\u0E19\u0E17\u0E32\u0E07\">\n      <i class=\"la la-external-link\"></i>\n    </a>\n  ",
  methods: {
    openJob: function openJob() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Jobs/GetJobId", {
        JobNumber: this.data.returnJobNumber
      }).then(function (response) {
        if (response.status == 200) {
          window.open("/Jobs/Edit/" + response.data, "_blank");
        } else {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
        }
      }).catch(function (error) {
        // always executed
        KTApp.unblockPage();
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  }
});
var ActionsrefJob = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n    <a href=\"#\" @click.prevent=\"openJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E15\u0E49\u0E19\u0E17\u0E32\u0E07\">\n      <i class=\"la la-external-link\"></i>\n    </a>\n  ",
  methods: {
    openJob: function openJob() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Jobs/GetJobId", {
        JobNumber: this.data.refJobNumber
      }).then(function (response) {
        if (response.status == 200) {
          window.open("/Jobs/Edit/" + response.data, "_blank");
        } else {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
        }
      }).catch(function (error) {
        // always executed
        KTApp.unblockPage();
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  }
});
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {

      grandTotal: 0,

      companies: [],
      jobNumber: null,
      columns: null,
      reJrDateReq: null,
      LoadFrist: true,
      reJrIsInitial: true,
      reJrLastActivityDateStart: null,
      reJrLastActivityDateEnd: null,
      reWeek: null,
      reAaAgentCode: [],
      reAaStatus: null,
      reJrProductBrand: [],
      reApMaterialCode: [],
      reJrProductType: [],
      TotalAmount: 10,
      isShowFooter: false,

      reAaAgentCodeOptions: [],
      reAaStatusOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reJrProductBrandOptions: [],
      reJrProductTypeOptions: [],
      reApMaterialCodeOptions: [],
      reWeekOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        data: [{ id: "1", text: "1" }, { id: "2", text: "2" }, { id: "3", text: "3" }, { id: "4", text: "4" }, { id: "5", text: "5" }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reAaAgentCode = [];
      self.reAaStatus = null;
      self.reWeek = null;
      self.jobNumber = null;
      self.reJrLastActivityDateStart = null;
      self.reJrLastActivityDateEnd = null;
      self.reJrLastActivityWeek = null;
      self.reJrProductBrand = [];
      self.reJrProductType = [];
      self.reApMaterialCode = [];

      $("#reWeek").val("").trigger("change");

      $("#reAaStatus").val("").trigger("change");

      $("#reAaAgentCode").val("").trigger("change");

      $("#reJrLastActivityDateStart").val("").trigger("change");

      $("#reJrLastActivityDateEnd").val("").trigger("change");

      $("#reJrLastActivityWeek").val("").trigger("change");

      $("#reJrProductBrand").val("").trigger("change");

      $("#reJrProductType").val("").trigger("change");

      $("#reApMaterialCode").val("").trigger("change");
    },
    formResetValue: function formResetValue(e) {
      var self = this;
      self.reJrLastActivityDateStart = null;
      self.reJrLastActivityDateEnd = null;
      self.reJrProductBrand = [];

      self.reJrProductType = [];
      self.reApMaterialCode = [];

      $("#reJrLastActivityDateStart").val("").trigger("change");

      $("#reJrLastActivityDateEnd").val("").trigger("change");

      $("#reJrProductBrand").val("").trigger("change");

      $("#reJrProductType").val("").trigger("change");

      $("#reApMaterialCode").val("").trigger("change");

      //this.formSubmit(e, "ล้างค่าทั้งหมด");
    },
    exportJobStock: function exportJobStock(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportAuditStock",
        responseType: "arraybuffer",
        data: {
          IsInitial: false,
          ProductType: self.reJrProductType,
          BrandCode: self.reJrProductBrand,
          MaterialCode: self.reApMaterialCode,
          JobNumber: self.jobNumber,
          BarcodeStatus: self.reAaStatus,
          AgentCodes: self.reAaAgentCode,
          WeekNo: self.reWeek,
          StartDate: self.reJrLastActivityDateStart != null ? self.reJrLastActivityDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.reJrLastActivityDateEnd != null ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY") : null
        }
      }).then(function (response) {
        KTApp.unblockPage();
        if (response.status === 204 || !response.data || response.data.byteLength === 0) {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
          return;
        }
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = moment().format("YYYY-MM-DD") + "_รายงานตรวจสอบSTOCKตัวแทนจำหน่าย" + ".xlsx";
        link.click();
      }).catch(function () {
        KTApp.unblockPage();
      })
      /*
      .then(function(response) {
        if (response.status == "200") {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];
           //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
           //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire(
            "ไม่พบข้อมูล",
            "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
            "warning"
          );
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
        */
      .then(function () {
        KTApp.unblockPage();
      });
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#jobStockTable").DataTable();
      table.draw();
    },
    // formSubmit: async function (e, innerText = null) {
    //   let self = this;

    //   if (innerText == "ล้างค่าทั้งหมด") {
    //     self.reJrIsInitial = true;
    //   }

    //   if (
    //     !$(this.$refs.form)
    //       .validate()
    //       .form()
    //   ) {
    //     return false;
    //   }

    //   let status = null;
    //   // if(self.reJrReturnStatus !=null){
    //   //   status = $("#reJrReturnStatus").text();
    //   //   console
    //   // }

    //   // e.preventDefault();
    //   // var table = $("#jobRetrieveTable").DataTable();
    //   // table.draw();

    //   e.preventDefault();
    //   // var table = $("#jobRetrieveTable").DataTable();
    //   // var tableSubAgent = $("#jobRetrieveSubAgentTable").DataTable();

    //   // if (self.reViewPermissionCode == "SUB_AGENT_REPORT")
    //   // {
    //   //   await self.GenCollums(tableSubAgent, "submit");
    //   // }
    //   // else
    //   // {
    //   //   await self.GenCollums(table, "submit");
    //   // }
    // }, 
    LoadreAaAgentCodeOptions: function LoadreAaAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a
      // .post("/Api/Agents/Options", {
      //   page: 1,
      //   province_id: [],
      //   department: [],
      //   AgentCodes: [],
      // })
      .post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        IsShowInAgentScoreReport: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAaAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreJrProductBrandOptions: function LoadreJrProductBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reJrProductBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreJrProductTypeOptions: function LoadreJrProductTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reJrProductTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreApMaterialCodeOptions: function LoadreApMaterialCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reApMaterialCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    // sum ต่อบริษัท
    getCompanySum: function getCompanySum(company) {
      return company.items.reduce(function (sum, item) {
        sum.full += item.full;
        sum.empty += item.empty;
        return sum;
      }, { full: 0, empty: 0 });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _table$DataTable;

      var self, formatNumber, formatOrDash, renderEmpty, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              renderEmpty = function renderEmpty(val) {
                var num = Number(val);

                if (!num) return "-";

                var formatted = formatNumber(num);

                if (num >= 100) {
                  //#63A361#BF124D
                  return '<span class="font-weight-bold" style="color:#BF124D !important;">' + formatted + '</span>';
                }

                return formatted;
              };

              formatOrDash = function formatOrDash(val) {
                var num = Number(val);
                if (!num) return "-";
                return formatNumber(num);
              };

              formatNumber = function formatNumber(val) {
                return Number(val).toLocaleString("en-US");
              };

              self = _this;

              //console.log($.fn.dataTable.RowGroup);

              self.LoadreJrProductBrandOptions();
              self.LoadreJrProductTypeOptions();
              self.LoadreApMaterialCodeOptions();
              self.LoadreAaAgentCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reJrDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reJrLastActivityDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reJrLastActivityDateStart = moment().set("date",1);
              $(self.$refs.reJrLastActivityDateStart).datepicker("update", !!self.reJrLastActivityDateStart ? self.reJrLastActivityDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reJrLastActivityDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reJrLastActivityDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });

              //self.reJrLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reJrLastActivityDateEnd).datepicker("update", !!self.reJrLastActivityDateEnd ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reJrLastActivityDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              table = $("#jobStockTable");
              //begin first table

              table.DataTable((_table$DataTable = {
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: false
              }, _defineProperty(_table$DataTable, "scrollX", true), _defineProperty(_table$DataTable, "processing", true), _defineProperty(_table$DataTable, "serverSide", true), _defineProperty(_table$DataTable, "searchDelay", 500), _defineProperty(_table$DataTable, "ajax", {
                url: "/Api/Report/SearchAuditStock",
                type: "post",
                dataType: "json",
                contentType: "application/json",
                beforeSend: function beforeSend(request) {
                  request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                },
                data: function data(d) {

                  var jsonSearch = {
                    IsInitial: false,
                    ProductType: self.reJrProductType,
                    BrandCode: self.reJrProductBrand,
                    MaterialCode: self.reApMaterialCode,
                    JobNumber: self.jobNumber,
                    BarcodeStatus: self.reAaStatus,
                    AgentCodes: self.reAaAgentCode,
                    WeekNo: self.reWeek,
                    StartDate: self.reJrLastActivityDateStart != null ? self.reJrLastActivityDateStart.format("DD/MM/YYYY") : null,
                    EndDate: self.reJrLastActivityDateEnd != null ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY") : null

                  };

                  // alert(JSON.stringify($.extend(d, jsonSearch)));
                  // console.log(jsonSearch);
                  return JSON.stringify($.extend(d, jsonSearch));
                }
              }), _defineProperty(_table$DataTable, "dom", "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>"), _defineProperty(_table$DataTable, "lengthMenu", [50, 100, 200, 500]), _defineProperty(_table$DataTable, "pageLength", 50), _defineProperty(_table$DataTable, "language", {
                lengthMenu: "Display _MENU_"
              }), _defineProperty(_table$DataTable, "order", []), _defineProperty(_table$DataTable, "columns", [{ data: "year", className: "text-center", orderable: false }, { data: "monthName", className: "text-left", orderable: false }, { data: "day", className: "text-center", orderable: false }, { data: "weekNo", className: "text-center", orderable: false }, { data: "jobNumber", className: "text-center", orderable: false }, { data: "updatedDate", className: "text-center", orderable: false }, { data: "agentCode", className: "text-center", orderable: false }, { data: "agentName", className: "text-left", orderable: false }, { data: "materialCode", className: "text-center", orderable: false }, { data: "materialDesc", className: "text-left", orderable: false }, {
                data: "full",
                className: "text-center jas-bg-green",
                orderable: false,
                render: function render(data, type, row) {
                  if (type !== "display") return data;
                  return formatOrDash(data);
                }
              }, {
                data: "empty",
                orderable: false,
                className: "text-center jas-bg-red",
                render: function render(data, type, row) {
                  if (type !== "display") return data;
                  return renderEmpty(data);
                },
                createdCell: function createdCell(td, cellData, rowData, row, col) {
                  var value = Number(cellData);
                  if (value >= 100) {
                    $(td).removeClass('jas-bg-red').addClass('jas-bg-red-strong');
                  }
                }
              }, {
                data: "inUse",
                className: "text-center jas-bg-gray",
                orderable: false,
                render: function render(data, type, row) {
                  if (type !== "display") return data;
                  return formatOrDash(data);
                }
              }, { data: "remark", className: "text-left", orderable: false }]), _defineProperty(_table$DataTable, "rowGroup", {
                // ใช้ composite key (agent + job) เพื่อให้ agent เดียวกันคนละ job แยกเป็นคนละ group
                dataSrc: function dataSrc(row) {
                  return (row.agentName || '') + '|' + (row.jobNumber || '');
                },
                startRender: function startRender(rows, group, level) {
                  var agentName = rows.data()[0].agentName;
                  return $('<tr class="group-header"/>').append('<td colspan="14" class="td-header">' + agentName + '</td>');
                },
                endRender: function endRender(rows, group, level) {
                  var totalFull = rows.data().pluck("full").reduce(function (a, b) {
                    return a + Number(b);
                  }, 0);

                  var totalEmpty = rows.data().pluck("empty").reduce(function (a, b) {
                    return a + Number(b);
                  }, 0);

                  var totalInUse = rows.data().pluck("inUse").reduce(function (a, b) {
                    return a + Number(b);
                  }, 0);

                  var emptyBgClass = totalEmpty >= 100 ? 'jas-bg-red-strong' : 'jas-bg-red';
                  return $('<tr class="group-footer-sub"/>').append('<td class="td-footer text-center" colspan="10"> Total ' + rows.data()[0].agentName + '</td>').append('<td class="td-footer text-center text-success" style="color: rgb(99, 163, 97) !important;">' + formatOrDash(totalFull) + '</td>').append('<td class="td-footer text-center ' + emptyBgClass + '">' + renderEmpty(totalEmpty) + '</td>').append('<td class="td-footer text-center">' + formatOrDash(totalInUse) + '</td>').append('<td class="td-footer"></td>');
                }
              }), _defineProperty(_table$DataTable, "footerCallback", function footerCallback(row, data, start, end, display) {

                var api = this.api();
                var json = api.ajax.json();

                if (!json || !json.groupSummary) return;

                var summary = json.groupSummary;
                // Full (column index 10 after inserting updatedDate at index 5)
                $(api.column(10).footer()).html(formatOrDash(summary.totalFull));

                // Empty
                var emptyFooter = $(api.column(11).footer());
                emptyFooter.removeClass('jas-bg-red jas-bg-red-strong').addClass(Number(summary.totalEmpty) >= 100 ? 'jas-bg-red-strong' : 'jas-bg-red').html(renderEmpty(summary.totalEmpty));

                // InUse
                $(api.column(12).footer()).html(formatOrDash(summary.totalInUse));
              }), _defineProperty(_table$DataTable, "drawCallback", function drawCallback(settings) {
                self.reAaIsInitial = false;
                //self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a"); 
              }), _table$DataTable)).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              // $(this.$refs.form).validate().settings.ignore = ":hidden";

              // Sync top scrollbar with DataTables scrollBody
              self.$nextTick(function () {
                var scrollBody = $('#jobStockTable').closest('.dataTables_scrollBody');
                var topWrapper = self.$refs.topScrollWrapper;
                var topContent = self.$refs.topScrollContent;
                if (!scrollBody.length || !topWrapper || !topContent) return;

                function syncTopScrollWidth() {
                  var bodyTable = scrollBody.find('table');
                  var headTable = scrollBody.prev('.dataTables_scrollHead').find('table');
                  var w = 0;
                  if (bodyTable.length) w = Math.max(w, bodyTable[0].scrollWidth);
                  if (headTable.length) w = Math.max(w, headTable[0].scrollWidth);
                  topContent.style.width = w + 'px';
                }
                syncTopScrollWidth();

                var syncing = false;
                $(topWrapper).on('scroll', function () {
                  if (syncing) return;
                  syncing = true;
                  scrollBody[0].scrollLeft = topWrapper.scrollLeft;
                  syncing = false;
                });
                scrollBody.on('scroll', function () {
                  if (syncing) return;
                  syncing = true;
                  topWrapper.scrollLeft = scrollBody[0].scrollLeft;
                  syncing = false;
                });

                $('#jobStockTable').on('draw.dt', function () {
                  self.$nextTick(function () {
                    syncTopScrollWidth();
                  });
                });
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles





__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      isLoadData: false,
      odYear: moment(),
      reJobGroupType: null,
      reCommitDateStart: null,
      reCommitDateEnd: null,
      MbSKUOptions: [],
      MbSKUId: [],
      reAaAgentCode: [],
      reAaAgentCodeOptions: [],
      odMonth: moment().format("M"),
      odMonthKey: 0,
      reJobGroupTypeOptions: [],
      odMonthOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ "id": "1", "text": "มกราคม", "data": null }, { "id": "2", "text": "กุมภาพันธ์", "data": null }, { "id": "3", "text": "มีนาคม", "data": null }, { "id": "4", "text": "เมษายน", "data": null }, { "id": "5", "text": "พฤษภาคม", "data": null }, { "id": "6", "text": "มิถุนายน", "data": null }, { "id": "7", "text": "กรกฎาคม", "data": null }, { "id": "8", "text": "สิงหาคม", "data": null }, { "id": "9", "text": "กันยายน", "data": null }, { "id": "10", "text": "ตุลาคม", "data": null }, { "id": "11", "text": "พฤศจิกายน", "data": null }, { "id": "12", "text": "ธันวาคม", "data": null }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      if (e) e.preventDefault();
      var self = this;
      self.odYear = moment();
      self.odMonth = moment().format("M");
      self.MbSKUId = [];
      self.reJobGroupType = [];
      self.reAaAgentCode = [];
      self.reCommitDateStart = null;
      self.reCommitDateEnd = null;

      self.odMonthKey++;

      $(self.$refs.odYear).datepicker("update", self.odYear.format("YYYY"));
      $(self.$refs.reCommitDateStart).datepicker("update", null);
      $(self.$refs.reCommitDateEnd).datepicker("update", null);

      $("#reJobGroupType").val("").trigger("change");
    },
    formResetValue: function formResetValue(e) {
      var self = this;
      self.odYear = moment();
      self.odMonth = null;
      self.MbSKUId = [];
      self.reJobGroupType = [];
      self.reCommitDateStart = null;
      self.reCommitDateEnd = null;

      $("#odMonth").val("").trigger("change");

      $("#reJobGroupType").val("").trigger("change");

      this.formSubmit(e, "ล้างค่าทั้งหมด");
    },
    exportData: function exportData(e) {
      e.preventDefault();
      var self = this;
      self.isLoadData = true;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/AgentScore/ExportData",
        responseType: "arraybuffer",
        data: {
          Year: self.odYear.format("YYYY"),
          StartDate: self.reCommitDateStart != null ? self.reCommitDateStart.format("DD/MM/YYYY") : self.reCommitDateStart,
          EndDate: self.reCommitDateEnd != null ? self.reCommitDateEnd.format("DD/MM/YYYY") : self.reCommitDateEnd,
          Month: self.odMonth,
          GroupJobTypeCode: self.reJobGroupType,
          ProductGroupCode: self.MbSKUId,
          AgentCodeSap: self.reAaAgentCode
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // link.download = decodeURIComponent(filename);
          link.download = moment().format("YYYY-MM-DD") + "_รายงานคะแนนการทำระบบเบียร์สด" + ".xlsx";
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      this.isLoadData = true;
      var table = $("#reportTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


      $("#reportTable").DataTable().ajax.reload(null, resetPaging);
    },
    // LoadMbSKUOptions: function(e) {
    //   var self = this;
    //   axios
    //     .get("/Api/Product/Select2Product", {
    //       params: {
    //         page: 1,
    //         all: true,
    //       },
    //     })
    //     .then(function(response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         data.forEach((element) => {
    //           self.MbSKUOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function(error) {});
    // }, 

    LoadreJobGroupTypeOptions: function LoadreJobGroupTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/AgentScore/Select2JobTypeAgentGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reJobGroupTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadMbSKUOptions: function LoadMbSKUOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.MbSKUOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAaAgentCodeOptions: function LoadreAaAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        IsShowInAgentScoreReport: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAaAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.LoadMbSKUOptions();
              self.LoadreJobGroupTypeOptions();
              self.LoadreAaAgentCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#reportTable");


              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/AgentScore/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      IsLoadData: self.isLoadData,
                      Year: self.odYear.format("YYYY"),
                      StartDate: self.reCommitDateStart != null ? self.reCommitDateStart.format("DD/MM/YYYY") : self.reCommitDateStart,
                      EndDate: self.reCommitDateEnd != null ? self.reCommitDateEnd.format("DD/MM/YYYY") : self.reCommitDateEnd,
                      Month: self.odMonth,
                      GroupJobTypeCode: self.reJobGroupType,
                      ProductGroupCode: self.MbSKUId,
                      AgentCodeSap: self.reAaAgentCode

                    }));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 50,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                //ลำดับ	ปี	เดือน	วันที่	โรงงาน	รหัสตัวแทนฯ	ชื่อตัวแทนจำหน่าย			ประเภทใบงาน	จำนวนใบงาน	ชื่อสินค้า /จำนวนสินค้า 

                // Order settings
                order: [[2, "asc"]],
                columns: [
                //{ data: "month", className: "text-center" },
                { data: "year", className: "text-center" }, { data: "monthTH", className: "text-left" }, {
                  data: "commitDate",
                  className: "text-left",
                  width: "5%",
                  render: function render(data, type, full, meta) {
                    return full.commitDateText;
                  }
                }, { data: "plants", className: "text-left" }, { data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-left" }, { data: "groupJobTypeName", className: "text-left" }, { data: "totalJob", className: "text-center" }, {
                  data: "materialSummary",
                  className: "text-left",
                  width: "20%",
                  render: function render(data, type, full, meta) {
                    var div = '<div class="row"> ';
                    full.materialSummaryList.forEach(function (item, index) {
                      div += '<div class="col-12"> ' + item + '</div> ';
                    });
                    div += '</div> ';

                    return div;
                  }
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {});

              //self.reJrDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reCommitDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reCommitDateStart = moment().set("date",1);
              $(self.$refs.reCommitDateStart).datepicker("update", !!self.reCommitDateStart ? self.reCommitDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reCommitDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reCommitDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reCommitDateEnd = moment().endOf('month');
              $(self.$refs.reCommitDateEnd).datepicker("update", !!self.reCommitDateEnd ? self.reCommitDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reCommitDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              if (!self.odYear) {
                self.odYear = moment();
              }

              $(self.$refs.odYear).datepicker({
                format: "yyyy",
                viewMode: "years",
                minViewMode: "years",
                autoclose: true,
                clearBtn: true,
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                templates: arrows
              });
              $(self.$refs.odYear).datepicker("update", !!self.odYear ? self.odYear.format("YYYY") : null).on("changeDate", function (e) {
                self.odYear = e.dates.length != 0 ? moment(e.date) : null;
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var ActionsretrieveJob = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n    <a href=\"#\" @click.prevent=\"openJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E15\u0E49\u0E19\u0E17\u0E32\u0E07\">\n      <i class=\"la la-external-link\"></i>\n    </a>\n  ",
  methods: {
    openJob: function openJob() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Jobs/GetJobId", {
        JobNumber: this.data.retrieveJobNumber
      }).then(function (response) {
        if (response.status == 200) {
          window.open("/Jobs/Edit/" + response.data, "_blank");
        } else {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
        }
      }).catch(function (error) {
        // always executed
        KTApp.unblockPage();
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  }
});

var ActionreturnJob = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n    <a href=\"#\" @click.prevent=\"openJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E15\u0E49\u0E19\u0E17\u0E32\u0E07\">\n      <i class=\"la la-external-link\"></i>\n    </a>\n  ",
  methods: {
    openJob: function openJob() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Jobs/GetJobId", {
        JobNumber: this.data.returnJobNumber
      }).then(function (response) {
        if (response.status == 200) {
          window.open("/Jobs/Edit/" + response.data, "_blank");
        } else {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
        }
      }).catch(function (error) {
        // always executed
        KTApp.unblockPage();
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  }
});
var ActionsrefJob = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n    <a href=\"#\" @click.prevent=\"openJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E15\u0E49\u0E19\u0E17\u0E32\u0E07\">\n      <i class=\"la la-external-link\"></i>\n    </a>\n  ",
  methods: {
    openJob: function openJob() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Jobs/GetJobId", {
        JobNumber: this.data.refJobNumber
      }).then(function (response) {
        if (response.status == 200) {
          window.open("/Jobs/Edit/" + response.data, "_blank");
        } else {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
        }
      }).catch(function (error) {
        // always executed
        KTApp.unblockPage();
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  }
});
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      isJobRetrieveTable: false,
      isJobRetrieveSubAgentTable: false,
      columns: null,
      LoadFrist: true,
      reJrIsInitial: true,
      reJrDateReq: null,
      reJrLastActivityDateStart: null,
      reJrLastActivityDateEnd: null,
      reJrProductBrand: [],
      reApMaterialCode: [],
      reJrReturnStatus: [],
      reJrRetrieveJob: null,
      reJrTransit: [],
      reJrReturnJob: null,
      reJrOriginAgent: [],
      reJrProductType: [],
      reJrDestinationPlant: [],
      reJrJobRetrieve: [],
      TotalAmount: 10,
      isShowFooter: false,
      reJrProductBrandOptions: [],
      // reJrProductBrandOptions: {
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJrReturnStatusOptions: [],
      // reJrReturnStatusOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะ",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=RETURN_STATUS_JOBRETRIEVE",
      //     delay: 300,
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJrTransitOptions: [],
      // reJrTransitOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Transport/Select2Transport",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         showVendorTransport: true,
      //         agentCodes: [],
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJrOriginAgentOptions: [],
      // reJrOriginAgentOptions: {
      //   placeholder: "กรุณาเลือกต้นทาง (ตัวแทน)",
      //   multipla: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Options",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: null,
      //         province_id: null,
      //         page: params.page || 1,
      //         isDelete: false,
      //         inActive: false,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJrProductTypeOptions: [],
      // reJrProductTypeOptions: {
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   multipla: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reJrDestinationPlantOptions: [],
      // reJrDestinationPlantOptions: {
      //   placeholder: "กรุณาเลือกปลายทาง",
      //   multipla: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/Select2Plant",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApMaterialCodeOptions: [],
      // reApMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reViewPermissionCode: null,
      reViewPermissionOptions: [],
      reScanByUserId: [],
      reScanByUserIdOptions: [],
      reShop: [],
      reShopOptions: [],
      reOriginCode: [],
      reOriginCodeOptions: [],
      reDestinationCode: [],
      reDestinationCodeOptions: [],
      reAssetHolderType: null,
      reAssetHolderTypeOptions: {
        placeholder: "กรุณาเลือกประเภทผู้ถือครอง",
        allowClear: true,
        data: [{ id: "ตัวแทนจำหน่าย", text: "ตัวแทนจำหน่าย" }, { id: "ตัวแทนจำหน่ายย่อย", text: "ตัวแทนจำหน่ายย่อย" }, { id: "ร้านค้า", text: "ร้านค้า" }]
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reJrLastActivityDateStart = null;
      self.reJrLastActivityDateEnd = null;
      self.reJrProductBrand = [];
      self.reJrReturnStatus = null;
      self.reJrRetrieveJob = null;
      self.reJrTransit = [];
      self.reJrReturnJob = null;
      self.reJrOriginAgent = [];
      self.reJrProductType = [];
      self.reJrDestinationPlant = [];
      self.reApMaterialCode = [];
      self.reScanByUserId = [];
      self.reShop = [];
      self.reOriginCode = [];
      self.reDestinationCode = [];
      self.reAssetHolderType = null;

      $("#reJrLastActivityDateStart").val("").trigger("change");

      $("#reJrLastActivityDateEnd").val("").trigger("change");

      $("#reJrProductBrand").val("").trigger("change");

      $("#reJrReturnStatus").val("").trigger("change");

      $("#reJrTransit").val("").trigger("change");

      $("#reJrOriginAgent").val("").trigger("change");

      $("#reJrProductType").val("").trigger("change");

      $("#reJrDestinationPlant").val("").trigger("change");

      $("#reApMaterialCode").val("").trigger("change");

      $("#reScanByUserId").val("").trigger("change");
      $("#reShop").val("").trigger("change");
      $("#reOriginCode").val("").trigger("change");
      $("#reDestinationCode").val("").trigger("change");
      $("#reAssetHolderType").val("").trigger("change");

      //this.formSubmit(e);
      //this.formSubmit(e, e.target.innerText);
    },
    formResetValue: function formResetValue(e) {
      var self = this;
      self.reJrLastActivityDateStart = null;
      self.reJrLastActivityDateEnd = null;
      self.reJrProductBrand = [];
      self.reJrReturnStatus = null;
      self.reJrRetrieveJob = null;
      self.reJrTransit = [];
      self.reJrReturnJob = null;
      self.reJrOriginAgent = [];
      self.reJrProductType = [];
      self.reJrDestinationPlant = [];
      self.reApMaterialCode = [];
      self.reScanByUserId = [];
      self.reShop = [];
      self.reOriginCode = [];
      self.reDestinationCode = [];
      self.reAssetHolderType = null;

      $("#reJrLastActivityDateStart").val("").trigger("change");

      $("#reJrLastActivityDateEnd").val("").trigger("change");

      $("#reJrProductBrand").val("").trigger("change");

      $("#reJrReturnStatus").val("").trigger("change");

      $("#reJrTransit").val("").trigger("change");

      $("#reJrOriginAgent").val("").trigger("change");

      $("#reJrProductType").val("").trigger("change");

      $("#reJrDestinationPlant").val("").trigger("change");

      $("#reApMaterialCode").val("").trigger("change");

      $("#reScanByUserId").val("").trigger("change");
      $("#reShop").val("").trigger("change");
      $("#reOriginCode").val("").trigger("change");
      $("#reDestinationCode").val("").trigger("change");
      $("#reAssetHolderType").val("").trigger("change");

      //this.formSubmit(e, "ล้างค่าทั้งหมด");
    },
    exportJobRetrieve: function exportJobRetrieve(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportJobRetrieve",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reJrIsInitial,
          LastActivityDateStart: self.reJrLastActivityDateStart != null ? self.reJrLastActivityDateStart.format("DD/MM/YYYY") : self.reJrLastActivityDateStart,
          LastActivityDateEnd: self.reJrLastActivityDateEnd != null ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY") : self.reJrLastActivityDateEnd,
          RetrieveJobNumber: self.reJrRetrieveJob,
          ReturnJobNumber: self.reJrReturnJob,
          ProductTypeId: self.reJrProductType,
          ProductBrandId: self.reJrProductBrand,
          TransitId: self.reJrTransit,
          OriginAgentCode: self.reJrOriginAgent,
          DestinationPlantCode: self.reJrDestinationPlant,
          ReturnStatus: self.reJrReturnStatus,
          MaterialCode: self.reApMaterialCode,
          ViewPermissionCode: self.reViewPermissionCode,
          ScanByUserId: self.reScanByUserId,
          ShopCode: self.reShop,
          OriginCode: self.reOriginCode,
          DestinationCode: self.reDestinationCode,
          AssetHolderType: self.reAssetHolderType
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    onReturnStatusChange: function onReturnStatusChange(id, text, data, ref) {
      var self = this;
      self.reJrReturnStatus = "";
      if (text != "") {
        self.reJrReturnStatus = data[0].text;
      }
    },
    formSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var self, status, table, tableSubAgent;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;


                if (innerText == "ล้างค่าทั้งหมด") {
                  self.reJrIsInitial = true;
                }

                if ($(this.$refs.form).validate().form()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:
                status = null;
                // if(self.reJrReturnStatus !=null){
                //   status = $("#reJrReturnStatus").text();
                //   console
                // }

                // e.preventDefault();
                // var table = $("#jobRetrieveTable").DataTable();
                // table.draw();

                e.preventDefault();
                table = $("#jobRetrieveTable").DataTable();
                tableSubAgent = $("#jobRetrieveSubAgentTable").DataTable();

                if (!(self.reViewPermissionCode == "SUB_AGENT_REPORT")) {
                  _context.next = 13;
                  break;
                }

                _context.next = 11;
                return self.GenCollums(tableSubAgent, "submit");

              case 11:
                _context.next = 15;
                break;

              case 13:
                _context.next = 15;
                return self.GenCollums(table, "submit");

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function formSubmit(_x) {
        return _ref.apply(this, arguments);
      }

      return formSubmit;
    }(),
    LoadreJrProductBrandOptions: function LoadreJrProductBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reJrProductBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreJrTransitOptions: function LoadreJrTransitOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.reJrTransitOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Transport/Select2Transport", {
          showVendorTransport: true,
          agentCodes: [],
          page: 1,
          all: true,
          search: searchQuery
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reJrTransitOptions = [];
            data.forEach(function (element) {
              self.reJrTransitOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reJrTransitOptions);
        });
      }
    },

    LoadreJrOriginAgentOptions: function LoadreJrOriginAgentOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Agents/Options", {
        department: null,
        province_id: null,
        page: 1,
        isDelete: false,
        inActive: false,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reJrOriginAgentOptions.push({
              id: element.id,
              label: element.text
            });

            self.reDestinationCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreJrProductTypeOptions: function LoadreJrProductTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reJrProductTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreJrDestinationPlantOptions: function LoadreJrDestinationPlantOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Plant/Select2Plant", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reJrDestinationPlantOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreApMaterialCodeOptions: function LoadreApMaterialCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reApMaterialCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    LoadreViewJobRetrieveOptions: function LoadreViewJobRetrieveOptions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ViewJobRetrieve", {}).then(function (response) {
                  if (response.status == 200) {
                    var data = response.data.results;
                    data.forEach(function (element) {
                      self.reViewPermissionOptions.push({
                        id: element.id,
                        label: element.text
                      });

                      if (element.data == "active") {
                        self.reViewPermissionCode = element.id;
                      }
                    });
                  }
                }).catch(function (error) {});

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    ChangeOptions: function ChangeOptions(type) {
      var self = this;
      if (self.LoadFrist == false) {
        if (type == "View") {
          self.formResetValue();
          self.LoadStatusCodeOptions();
        }
      }
    },
    GenCollums: function GenCollums(table) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;
      self.columns = null;

      if (self.reViewPermissionCode == "SUB_AGENT_REPORT") {
        self.columns = [{
          data: "lastActivityDate",
          className: "text-center",
          render: function render(data, type, full, meta) {
            var t = table.DataTable();
            var page = t.page.info().start + 1;
            return page + meta.row;
          }
        }, {
          data: "lastActivityDate",
          className: "text-center",
          render: function render(data, type, full, meta) {
            return full.lastActivityDateString;
          }
        }, {
          data: "retrieveJobNumber",
          className: "text-center",
          render: function render(data, type, full, meta) {
            if (data != null) {
              return data + '<div class="actionsretrieveJobNumber"></div>';
            } else {
              return "";
            }
          }
        }, { data: "productTypeName", className: "text-center" }, { data: "productBrandName", className: "text-center" }, { data: "materialcode", className: "text-center" }, { data: "productName", className: "text-center" }, {
          data: "amount",
          className: "text-center",
          render: function render(data, type, full, meta) {
            if (data != null || data != "" || data !== 0) {
              return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
              return "";
            }
          }
        }, { data: "originCUST_CODE", className: "text-center" }, { data: "originName", className: "text-center" }, { data: "destinationName", className: "text-center" }, { data: "scanByUserName", className: "text-center" }, {
          data: "returnStatus",
          className: "text-center",
          render: function render(data, type, full, meta) {
            if (data == "คืนเอง") {
              return '<span class="text-info"> คืนเอง</span>';
            } else if (data == "ได้รับการคืนแทน") {
              return '<span class="text-danger"> ได้รับการคืนแทน</span>';
            } else if (data == "Adhoc") {
              return '<span class="text-dark"> Ad hoc</span>';
            }
          }
        }];
      } else {
        self.columns = [{
          data: "lastActivityDate",
          className: "text-center",
          render: function render(data, type, full, meta) {
            var t = table.DataTable();
            var page = t.page.info().start + 1;
            return page + meta.row;
          }
        }, {
          data: "lastActivityDate",
          className: "text-center",
          render: function render(data, type, full, meta) {
            return full.lastActivityDateString;
          }
        }, {
          data: "retrieveJobNumber",
          className: "text-center",
          render: function render(data, type, full, meta) {
            if (data != null) {
              return data + '<div class="actionsretrieveJobNumber"></div>';
            } else {
              return "";
            }
          }
        }, {
          data: "returnJobNumber",
          className: "text-center",
          render: function render(data, type, full, meta) {
            if (data != null) {
              return data + '<div class="actionreturnJobNumber"></div>';
            } else {
              return "";
            }
          }
        }, {
          data: "refJobNumber",
          className: "text-center",
          render: function render(data, type, full, meta) {
            if (data != null) {
              return data + '<div class="refJobNumber"></div>';
            } else {
              return "";
            }
          }
        }, { data: "productTypeName", className: "text-center" }, { data: "productBrandName", className: "text-center" }, { data: "productName", className: "text-center" }, {
          data: "amount",
          className: "text-center",
          render: function render(data, type, full, meta) {
            if (data != null || data != "" || data !== 0) {
              return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
              return "";
            }
          }
        }, { data: "transitConcatString", className: "text-center" }, { data: "transitConcatString2", className: "text-center" }, { data: "originAgentCode", className: "text-center" }, { data: "originAgentName", className: "text-center" }, { data: "destinationPlantName", className: "text-center" }, {
          data: "returnStatus",
          className: "text-center",
          render: function render(data, type, full, meta) {
            if (data == "คืนเอง") {
              return '<span class="text-info"> คืนเอง</span>';
            } else if (data == "ได้รับการคืนแทน") {
              return '<span class="text-danger"> ได้รับการคืนแทน</span>';
            } else if (data == "Adhoc") {
              return '<span class="text-dark"> Ad hoc</span>';
            }
          }
        }];
      }

      if (action == "submit") {
        table.clear();
        table.destroy();
        self.isJobRetrieveTable = false;
        self.isJobRetrieveSubAgentTable = false;
        if (self.reViewPermissionCode == "SUB_AGENT_REPORT") {
          self.isJobRetrieveSubAgentTable = true;
          table = $("#jobRetrieveSubAgentTable");
        } else {
          self.isJobRetrieveTable = true;
          table = $("#jobRetrieveTable");
        }

        self.GetDataTable(table);
      }
    },
    GetDataTable: function GetDataTable(table) {
      var self = this;

      table.DataTable({
        autoWidth: true,
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        scrollY: "100%",
        ajax: {
          url: "/Api/Report/JobRetrieve",
          type: "post",
          // dataType: "json",
          // contentType: "application/json",
          beforeSend: function beforeSend(request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          },
          data: function data(d) {
            self.isShowFooter = false;
            self.TotalAmount = 0;

            d.IsInitial = self.reJrIsInitial;
            d.LastActivityDateStart = self.reJrLastActivityDateStart != null ? self.reJrLastActivityDateStart.format("DD/MM/YYYY") : self.reJrLastActivityDateStart;
            d.LastActivityDateEnd = self.reJrLastActivityDateEnd != null ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY") : self.reJrLastActivityDateEnd;
            d.RetrieveJobNumber = self.reJrRetrieveJob;
            d.ReturnJobNumber = self.reJrReturnJob;
            d.ProductTypeId = self.reJrProductType;
            d.ProductBrandId = self.reJrProductBrand;
            d.TransitId = self.reJrTransit;
            d.OriginAgentCode = self.reJrOriginAgent;
            d.DestinationPlantCode = self.reJrDestinationPlant;
            d.ReturnStatus = self.reJrReturnStatus;
            d.MaterialCode = self.reApMaterialCode;
            d.ViewPermissionCode = self.reViewPermissionCode;
            d.ScanByUserId = self.reScanByUserId;
            d.ShopCode = self.reShop;
            d.OriginCode = self.reOriginCode;
            d.DestinationCode = self.reDestinationCode;
            d.AssetHolderType = self.reAssetHolderType;

            // let jsonSearch = {
            //   IsInitial: self.reJrIsInitial,
            //   LastActivityDateStart:
            //     self.reJrLastActivityDateStart != null
            //       ? self.reJrLastActivityDateStart.format("DD/MM/YYYY")
            //       : self.reJrLastActivityDateStart,
            //   LastActivityDateEnd:
            //     self.reJrLastActivityDateEnd != null
            //       ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY")
            //       : self.reJrLastActivityDateEnd,
            //   RetrieveJobNumber: self.reJrRetrieveJob,
            //   ReturnJobNumber: self.reJrReturnJob,
            //   ProductTypeId: self.reJrProductType,
            //   ProductBrandId: self.reJrProductBrand,
            //   TransitId: self.reJrTransit,
            //   OriginAgentCode: self.reJrOriginAgent,
            //   DestinationPlantCode: self.reJrDestinationPlant,
            //   ReturnStatus: self.reJrReturnStatus,
            //   MaterialCode: self.reApMaterialCode,
            // };
            // return JSON.stringify($.extend(d, jsonSearch));
          }
        },
        // DOM Layout settings
        dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n          <'row'<'col-sm-12'tr>>\n          <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_"
        },
        // Order settings
        order: [[1, "desc"]],
        columns: self.columns,
        drawCallback: function drawCallback(settings) {
          self.reJrIsInitial = false;
          self.reJrDateReq = moment().format("DD/MM/YYYY h:mm a");

          var allPage = table.DataTable().page.info().pages;
          var currentPage = table.DataTable().page.info().page + 1;

          if (allPage == currentPage) {
            self.isShowFooter = true;
            self.TotalAmount = settings.json.data[0].totalAmount;

            $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
          }
        }
      }).on("preXhr.dt", function () {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
        });
      }).on("xhr.dt", function () {
        KTApp.unblock(self.$refs.form);
      }).on("draw.dt", function () {
        $(".actionsretrieveJobNumber").each(function (i, el) {
          var $dt = table.DataTable();
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            new ActionsretrieveJob({ data: { data: data }, parent: self }).$mount(el);
          }
        });

        $(".actionreturnJobNumber").each(function (i, el) {
          var $dt = table.DataTable();
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            new ActionreturnJob({ data: { data: data }, parent: self }).$mount(el);
          }
        });

        $(".refJobNumber").each(function (i, el) {
          var $dt = table.DataTable();
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            new ActionsrefJob({ data: { data: data }, parent: self }).$mount(el);
          }
        });
      });
    },
    LoadreScanByUserIdOptions: function LoadreScanByUserIdOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2ScanUser", {
        page: 1,
        search: null
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reScanByUserIdOptions = [];
          data.forEach(function (element) {
            self.reScanByUserIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    LoadreShopOptions: function LoadreShopOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Shop/ShopOption", {}).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reShopOptions.push({
              id: element.id,
              label: element.text
            });

            self.reOriginCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadStatusCodeOptions: function LoadStatusCodeOptions(e) {
      var self = this;
      if (self.reViewPermissionCode == "SUB_AGENT_REPORT") {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=RETURN_STATUS_JOBRETRIEVE_ADHOC", {
          params: {
            page: 1,
            all: true
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reJrReturnStatusOptions = [];
            data.forEach(function (element) {
              self.reJrReturnStatusOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
        }).catch(function (error) {});
      } else {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=RETURN_STATUS_JOBRETRIEVE", {
          params: {
            page: 1,
            all: true
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reJrReturnStatusOptions = [];
            data.forEach(function (element) {
              self.reJrReturnStatusOptions.push({
                id: element.text,
                label: element.text
              });
            });
          }
        }).catch(function (error) {});
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, arrows, table, tableSubAgent;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this2;


              self.LoadreJrProductBrandOptions();
              self.LoadreJrOriginAgentOptions();
              self.LoadreJrProductTypeOptions();
              self.LoadreJrDestinationPlantOptions();
              self.LoadreApMaterialCodeOptions();

              // self.LoadreScanByUserIdOptions();
              // self.LoadreShopOptions();
              _context3.next = 8;
              return self.LoadreViewJobRetrieveOptions();

            case 8:
              self.LoadStatusCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reJrDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reJrLastActivityDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reJrLastActivityDateStart = moment().set("date",1);
              $(self.$refs.reJrLastActivityDateStart).datepicker("update", !!self.reJrLastActivityDateStart ? self.reJrLastActivityDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reJrLastActivityDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reJrLastActivityDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reJrLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reJrLastActivityDateEnd).datepicker("update", !!self.reJrLastActivityDateEnd ? self.reJrLastActivityDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reJrLastActivityDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              table = $("#jobRetrieveTable");
              tableSubAgent = $("#jobRetrieveSubAgentTable");

              if (!(self.reViewPermissionCode == "SUB_AGENT_REPORT")) {
                _context3.next = 25;
                break;
              }

              self.isJobRetrieveSubAgentTable = true;
              _context3.next = 21;
              return self.GenCollums(tableSubAgent);

            case 21:
              self.GetDataTable(tableSubAgent);
              self.LoadFrist = false;
              _context3.next = 30;
              break;

            case 25:
              self.isJobRetrieveTable = true;
              _context3.next = 28;
              return self.GenCollums(table);

            case 28:
              self.GetDataTable(table);
              self.LoadFrist = false;

            case 30:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect_dist_vue_treeselect_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Treeselect: __WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect___default.a
  },
  data: function data() {
    return {
      // DataTable instance
      dataTable: null,

      // Month/Year filter
      monthYear: null,

      // label แสดง "ข้อมูล ณ ..."
      dataAsOfLabel: '',

      // Filter values
      productType: [],
      barcodeStatusCode: [],
      agentCode: [],
      materialCode: [],
      retentionPeriod: [],
      headAgentCode: [],
      productBrand: [],
      score: [],
      ownerType: [],
      brand: [],

      // Filter options
      productTypeOptions: [],
      barcodeStatusCodeOptions: [],
      agentCodeOptions: [],
      materialCodeOptions: [],
      retentionPeriodOptions: [{ id: "ไม่เกิน 3 เดือน", label: "ไม่เกิน 3 เดือน" }, { id: "ไม่เกิน 4 เดือน", label: "ไม่เกิน 4 เดือน" }, { id: "เกิน 4 เดือน", label: "เกิน 4 เดือน" }, { id: "เกิน 5 เดือน", label: "เกิน 5 เดือน" }],
      headAgentCodeOptions: [],
      productBrandOptions: [],
      fullProductData: [],
      scoreOptions: [{ id: 10, label: "10" }, { id: 20, label: "20" }, { id: 40, label: "40" }],
      ownerTypeOptions: [],
      brandOptions: []
    };
  },
  mounted: function mounted() {
    this.initMonthYearPicker();
    this.loadProductTypeOptions();
    this.loadBarcodeStatusCodeOptions();
    this.loadAgentCodeOptions();
    this.loadMaterialCodeOptions();
    this.loadHeadAgentCodeOptions();
    this.loadProductBrandOptions();
    this.loadOwnerTypeOptions();
    this.loadBrandOptions();
    this.initDataTable();
  },
  computed: {
    filteredProductBrandOptions: function filteredProductBrandOptions() {
      if (!this.brand.length) {
        return this.productBrandOptions;
      }
      var selectedBrandIds = this.brand.map(Number);
      var filteredOptions = [];
      this.fullProductData.forEach(function (item) {
        if (selectedBrandIds.indexOf(item.data.productBrandId) !== -1) {
          filteredOptions.push({
            id: item.id,
            label: item.text,
            productBrandId: item.data.productBrandId
          });
        }
      });
      return filteredOptions;
    }
  },
  methods: {
    showCriteriaModal: function showCriteriaModal() {
      $("#criteriaModal").modal("show");
    },
    initMonthYearPicker: function initMonthYearPicker() {
      var self = this;
      var arrows;
      if (KTUtil.isRTL()) {
        arrows = {
          leftArrow: '<i class="la la-angle-right"></i>',
          rightArrow: '<i class="la la-angle-left"></i>'
        };
      } else {
        arrows = {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>'
        };
      }

      // Default = current month/year
      self.monthYear = moment();

      $(self.$refs.monthYearPicker).datepicker({
        format: "mm/yyyy",
        viewMode: "months",
        minViewMode: "months",
        autoclose: true,
        clearBtn: true,
        rtl: KTUtil.isRTL(),
        orientation: "bottom left",
        templates: arrows
      });
      $(self.$refs.monthYearPicker).datepicker("update", self.monthYear.format("MM/YYYY")).on("changeDate", function (e) {
        self.monthYear = e.dates.length !== 0 ? moment(e.date) : null;
      });
    },

    // ประเภทสินค้า
    loadProductTypeOptions: function loadProductTypeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: { page: 1, all: true }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            if (element.id == 4 || element.id == 5) {
              self.productTypeOptions.push({
                id: element.id,
                label: element.text
              });
            }
          });
        }
      }).catch(function (error) {});
    },

    // สถานะ
    loadBarcodeStatusCodeOptions: function loadBarcodeStatusCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", {
        params: { page: 1, all: true }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.barcodeStatusCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    // ชื่อตัวแทนจำหน่าย
    loadAgentCodeOptions: function loadAgentCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Report/Select2Agent", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        all: true,
        IsShowInAgentScoreReport: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.agentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    // ชื่อสินค้า
    loadMaterialCodeOptions: function loadMaterialCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Product/Select2Product", {
        params: { page: 1, all: true, excludeProductGroupId: 14 }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.materialCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    // เคลียร์ ชื่อแบรนด์สินค้า เมื่อเลือก/ยกเลิก แบรนด์สินค้า
    BrandIdClearAfterSelect: function BrandIdClearAfterSelect() {
      this.productBrand = [];
    },
    BrandIdClearAfterDeSelect: function BrandIdClearAfterDeSelect() {
      this.productBrand = [];
    },

    // ชื่อตัวแทนจำหน่าย(Group)
    loadHeadAgentCodeOptions: function loadHeadAgentCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        IsShowInAgentScoreReport: true,
        IsHead: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.headAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    // ชื่อแบรนด์สินค้า — โหลดข้อมูลทั้งหมดพร้อม productBrandId เพื่อใช้ filter ตามแบรนด์
    loadProductBrandOptions: function loadProductBrandOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/product/Select2ProductReport", {
        page: 1,
        all: true,
        search: "",
        productGroupIds: [14]
      }).then(function (response) {
        if (response.status === 200) {
          self.fullProductData = response.data.results;
          self.productBrandOptions = self.fullProductData.map(function (item) {
            return {
              id: item.id,
              label: item.text,
              productBrandId: item.data.productBrandId
            };
          });
        }
      }).catch(function (error) {
        console.error("Error loading product data:", error);
      });
    },

    // ประเภทผู้ถือครอง — ใช้ hardcoded เหมือน Barcodes (SP รับ Thai text)
    loadOwnerTypeOptions: function loadOwnerTypeOptions() {
      var self = this;
      var data = [{ id: "ตัวแทนจำหน่าย", label: "ตัวแทนจำหน่าย" }, { id: "ตัวแทนจำหน่ายย่อย", label: "ตัวแทนจำหน่ายย่อย" }, { id: "ร้านค้า", label: "ร้านค้า" }, { id: "ร้านค้า (ตัวแทนฯย่อย)", label: "ร้านค้า (ตัวแทนฯย่อย)" }];
      self.ownerTypeOptions = data;
    },

    // แบรนด์
    loadBrandOptions: function loadBrandOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: { page: 1, all: true }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.brandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    formSubmit: function formSubmit(e) {
      e.preventDefault();
      this.dataTable.ajax.reload();
    },

    initDataTable: function initDataTable() {
      var self = this;

      // map ช่วงคงค้าง option → day range สำหรับ @OverDueFrom / @OverDueTo
      function calcRetentionRange(selected) {
        if (!selected || selected.length === 0) return { from: null, to: null };
        var rangeMap = {
          "ไม่เกิน 3 เดือน": { from: 1, to: 90 },
          "ไม่เกิน 4 เดือน": { from: 91, to: 120 },
          "เกิน 4 เดือน": { from: 121, to: null },
          "เกิน 5 เดือน": { from: 151, to: null }
        };
        var froms = [],
            tos = [],
            hasOpenEnd = false;
        selected.forEach(function (r) {
          var rng = rangeMap[r];
          if (!rng) return;
          froms.push(rng.from);
          if (rng.to !== null) {
            tos.push(rng.to);
          } else {
            hasOpenEnd = true;
          }
        });
        return {
          from: froms.length ? Math.min.apply(null, froms) : null,
          to: hasOpenEnd ? null : tos.length ? Math.max.apply(null, tos) : null
        };
      }

      function formatNumber(val) {
        if (val === null || val === undefined || val === 0) return "-";
        return val.toLocaleString();
      }

      function renderScore(val) {
        if (val === null || val === undefined || val === 0) return "-";
        if (val >= 40) return '<span>' + val + "</span>";
        if (val >= 20) return '<span>' + val + "</span>";
        return '<span>' + val + "</span>";
      }

      self.dataTable = $(self.$refs.kegRotationTable).DataTable({
        scrollX: true,
        responsive: false,
        processing: true,
        serverSide: true,
        deferLoading: 0,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/SearchMachineScore",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function beforeSend(request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          },
          data: function data(d) {
            var retentionRange = calcRetentionRange(self.retentionPeriod);
            var jsonSearch = {
              IsInitial: false,
              AgentCodes: self.agentCode,
              HeadAgentCodes: self.headAgentCode,
              AssetCodes: self.materialCode,
              ProductTypeIds: self.productType,
              BarcodeStatusCodes: self.barcodeStatusCode,
              FinishedProductCodes: self.productBrand,
              BrandIds: self.brand,
              CurrentLocationType: self.ownerType,
              OverDueFrom: retentionRange.from,
              OverDueTo: retentionRange.to,
              FinalScore: self.score.length === 1 ? self.score[0] : 0,
              Month: self.monthYear ? self.monthYear.month() + 1 : null,
              Year: self.monthYear ? self.monthYear.year() : null
            };
            return JSON.stringify($.extend(d, jsonSearch));
          }
        },
        drawCallback: function drawCallback() {
          this.api().columns.adjust();
          var thaiMonths = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];
          var now = moment();
          var isCurrentMonth = !self.monthYear || self.monthYear.year() === now.year() && self.monthYear.month() === now.month();
          if (isCurrentMonth) {
            self.dataAsOfLabel = 'ข้อมูล ณ วันที่ ' + now.format('DD/MM/YYYY h:mm a');
          } else {
            self.dataAsOfLabel = 'ข้อมูล ณ เดือน ' + thaiMonths[self.monthYear.month()] + ' ' + self.monthYear.year();
          }
        },
        dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
        lengthMenu: [50, 100, 200, 500],
        pageLength: 50,
        language: {
          lengthMenu: "Display _MENU_"
        },
        order: [[0, "asc"]],
        columns: [{ data: "agentCode", className: "text-center", orderable: true }, { data: "agentName", className: "text-left", orderable: true }, { data: "assetCode", className: "text-center", orderable: false }, { data: "assetName", className: "text-left", orderable: false },
        // High Season
        { data: "high_3Month", className: "text-center bg-green", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "high_3_4Month", className: "text-center bg-yellow", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "high_Over4Month", className: "text-center bg-red", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "high_Total", className: "text-center", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "high_Score", className: "text-center", orderable: false, render: function render(data, type) {
            return type === "display" ? renderScore(data) : data;
          } },
        // Low Season
        { data: "low_5Month", className: "text-center bg-green", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "low_5_6Month", className: "text-center bg-yellow", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "low_Over6Month", className: "text-center bg-red", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "low_Total", className: "text-center", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "low_Score", className: "text-center", orderable: false, render: function render(data, type) {
            return type === "display" ? renderScore(data) : data;
          } },
        // Summary
        { data: "total", className: "text-center", orderable: false, render: function render(data) {
            return formatNumber(data);
          } },
        // Summary
        { data: "finalScore", className: "text-center", orderable: false, render: function render(data) {
            return '';
          } }],
        rowGroup: {
          dataSrc: "agentCode",
          startRender: function startRender(rows, group) {
            var agentName = rows.data()[0].agentName || group;
            return $('<tr class="group-header"/>').append('<td colspan="16" class="td-header">' + agentName + "</td>");
          },
          endRender: function endRender(rows, group) {
            var agentName = rows.data()[0].agentName || group;
            var totH3 = rows.data().pluck("high_3Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totH34 = rows.data().pluck("high_3_4Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totHO4 = rows.data().pluck("high_Over4Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totHT = rows.data().pluck("high_Total").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var hsArr = rows.data().pluck("high_Score").toArray().filter(function (x) {
              return Number(x) !== 0;
            });
            var totHS = hsArr.length ? Math.min.apply(null, hsArr) : 0;
            var totL5 = rows.data().pluck("low_5Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totL56 = rows.data().pluck("low_5_6Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totLO6 = rows.data().pluck("low_Over6Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totLT = rows.data().pluck("low_Total").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var lsArr = rows.data().pluck("low_Score").toArray().filter(function (x) {
              return Number(x) !== 0;
            });
            var totLS = lsArr.length ? Math.min.apply(null, lsArr) : 0;
            var totTotal = rows.data().pluck("total").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var fsArr = rows.data().pluck("finalScore").toArray().filter(function (x) {
              return Number(x) !== 0;
            });
            var finalScore = fsArr.length ? Math.min.apply(null, fsArr) : 0;

            return $('<tr class="group-footer-sub"/>').append('<td class="td-footer" colspan="4" style="max-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">Total ' + agentName + "</td>").append('<td class="td-footer text-center">' + formatNumber(totH3) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totH34) + "</td>").append('<td class="td-footer text-center" style="color: #C00000 !important;">' + formatNumber(totHO4) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totHT) + "</td>").append('<td class="td-footer text-center" style="color:#0033CC !important;">' + renderScore(totHS) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totL5) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totL56) + "</td>").append('<td class="td-footer text-center" style="color: #C00000 !important;">' + formatNumber(totLO6) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totLT) + "</td>").append('<td class="td-footer text-center" style="color:#0033CC !important;">' + renderScore(totLS) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totTotal) + "</td>").append('<td class="td-footer text-center" style="color:#0033CC !important;">' + formatNumber(finalScore) + "</td>");
          }
        },
        footerCallback: function footerCallback() {
          var api = this.api();
          var json = api.ajax.json();
          if (!json || !json.groupSummary) {
            // clear footer เมื่อไม่มีข้อมูล
            for (var i = 4; i <= 15; i++) {
              $(api.column(i).footer()).html("");
            }
            return;
          }
          var s = json.groupSummary;
          $(api.column(4).footer()).html(formatNumber(s.tot_High_3Month));
          $(api.column(5).footer()).html(formatNumber(s.tot_High_3_4Month));
          $(api.column(6).footer()).html(formatNumber(s.tot_High_Over4Month));
          $(api.column(7).footer()).html(formatNumber(s.tot_High_Total));
          $(api.column(8).footer()).html("");
          $(api.column(9).footer()).html(formatNumber(s.tot_Low_5Month));
          $(api.column(10).footer()).html(formatNumber(s.tot_Low_5_6Month));
          $(api.column(11).footer()).html(formatNumber(s.tot_Low_Over6Month));
          $(api.column(12).footer()).html(formatNumber(s.tot_Low_Total));
          $(api.column(13).footer()).html("");
          $(api.column(14).footer()).html(formatNumber(s.tot_Total));
          $(api.column(15).footer()).html("");
        }
      });

      // Sync top scrollbar with DataTables scrollBody
      self.$nextTick(function () {
        var scrollBody = $(self.$refs.kegRotationTable).closest('.dataTables_scrollBody');
        var topWrapper = self.$refs.topScrollWrapper;
        var topContent = self.$refs.topScrollContent;
        if (!scrollBody.length || !topWrapper || !topContent) return;

        function syncTopScrollWidth() {
          var bodyTable = scrollBody.find('table');
          var headTable = scrollBody.prev('.dataTables_scrollHead').find('table');
          var w = 0;
          if (bodyTable.length) w = Math.max(w, bodyTable[0].scrollWidth);
          if (headTable.length) w = Math.max(w, headTable[0].scrollWidth);
          topContent.style.width = w + 'px';
        }
        syncTopScrollWidth();

        var syncing = false;
        $(topWrapper).on('scroll', function () {
          if (syncing) return;
          syncing = true;
          scrollBody[0].scrollLeft = topWrapper.scrollLeft;
          syncing = false;
        });
        scrollBody.on('scroll', function () {
          if (syncing) return;
          syncing = true;
          topWrapper.scrollLeft = scrollBody[0].scrollLeft;
          syncing = false;
        });

        $(self.$refs.kegRotationTable).on('draw.dt', function () {
          self.$nextTick(function () {
            syncTopScrollWidth();
          });
        });
      });
    },

    exportCompareReport: function exportCompareReport(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/Report/ExportCompareSnapshotVsBarcodeReport",
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token,
          "Content-Type": "application/json"
        },
        data: JSON.stringify(function () {
          var rangeMap = {
            "ไม่เกิน 3 เดือน": { from: 1, to: 90 },
            "ไม่เกิน 4 เดือน": { from: 91, to: 120 },
            "เกิน 4 เดือน": { from: 121, to: null },
            "ไม่เกิน 5 เดือน": { from: 1, to: 150 },
            "ไม่เกิน 6 เดือน": { from: 151, to: 180 },
            "เกิน 6 เดือน": { from: 181, to: null }
          };
          var froms = [],
              tos = [],
              hasOpenEnd = false;
          self.retentionPeriod.forEach(function (r) {
            var rng = rangeMap[r];
            if (!rng) return;
            froms.push(rng.from);
            if (rng.to !== null) {
              tos.push(rng.to);
            } else {
              hasOpenEnd = true;
            }
          });
          var overDueFrom = froms.length ? Math.min.apply(null, froms) : null;
          var overDueTo = hasOpenEnd ? null : tos.length ? Math.max.apply(null, tos) : null;
          return {
            IsInitial: false,
            AgentCodes: self.agentCode,
            HeadAgentCodes: self.headAgentCode,
            AssetCodes: self.materialCode,
            ProductTypeIds: self.productType,
            BarcodeStatusCodes: self.barcodeStatusCode,
            FinishedProductCodes: self.productBrand,
            BrandIds: self.brand,
            CurrentLocationType: self.ownerType,
            OverDueFrom: overDueFrom,
            OverDueTo: overDueTo,
            FinalScore: self.score.length === 1 ? String(self.score[0]) : "0",
            Month: self.monthYear ? self.monthYear.month() + 1 : null,
            Year: self.monthYear ? self.monthYear.year() : null
          };
        }())
      }).then(function (response) {
        KTApp.unblockPage();
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = moment().format("YYYY-MM-DD") + "_รายงานคะแนนถังคงค้าง(ตรวจสอบข้อมูล).xlsx";
        link.click();
      }).catch(function () {
        KTApp.unblockPage();
      });
    },

    exportMachineScore: function exportMachineScore(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/Report/ExportMachineScore",
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token,
          "Content-Type": "application/json"
        },
        data: JSON.stringify(function () {
          var rangeMap = {
            "ไม่เกิน 3 เดือน": { from: 1, to: 90 },
            "ไม่เกิน 4 เดือน": { from: 91, to: 120 },
            "เกิน 4 เดือน": { from: 121, to: null },
            "ไม่เกิน 5 เดือน": { from: 1, to: 150 },
            "ไม่เกิน 6 เดือน": { from: 151, to: 180 },
            "เกิน 6 เดือน": { from: 181, to: null }
          };
          var froms = [],
              tos = [],
              hasOpenEnd = false;
          self.retentionPeriod.forEach(function (r) {
            var rng = rangeMap[r];
            if (!rng) return;
            froms.push(rng.from);
            if (rng.to !== null) {
              tos.push(rng.to);
            } else {
              hasOpenEnd = true;
            }
          });
          var overDueFrom = froms.length ? Math.min.apply(null, froms) : null;
          var overDueTo = hasOpenEnd ? null : tos.length ? Math.max.apply(null, tos) : null;
          return {
            IsInitial: false,
            AgentCodes: self.agentCode,
            HeadAgentCodes: self.headAgentCode,
            AssetCodes: self.materialCode,
            ProductTypeIds: self.productType,
            BarcodeStatusCodes: self.barcodeStatusCode,
            FinishedProductCodes: self.productBrand,
            BrandIds: self.brand,
            CurrentLocationType: self.ownerType,
            OverDueFrom: overDueFrom,
            OverDueTo: overDueTo,
            FinalScore: self.score.length === 1 ? String(self.score[0]) : "0",
            Month: self.monthYear ? self.monthYear.month() + 1 : null,
            Year: self.monthYear ? self.monthYear.year() : null
          };
        }())
      }).then(function (response) {
        KTApp.unblockPage();
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        // link.download =
        //   "รายงานคะแนนถังคงค้าง(ผู้ดูแลระบบ)_" +
        //   moment().format("DDMMYYYY") +
        //   ".xlsx";

        link.download = moment().format("YYYY-MM-DD") + "_รายงานคะแนนถังคงค้าง" + ".xlsx";
        link.click();
      }).catch(function () {
        KTApp.unblockPage();
      });
    },

    formReset: function formReset() {
      this.productType = [];
      this.barcodeStatusCode = [];
      this.agentCode = [];
      this.materialCode = [];
      this.retentionPeriod = [];
      this.headAgentCode = [];
      this.productBrand = [];
      this.score = [];
      this.ownerType = [];
      this.brand = [];

      // Reset month/year to current
      this.monthYear = moment();
      $(this.$refs.monthYearPicker).datepicker("update", this.monthYear.format("MM/YYYY"));
      this.dataAsOfLabel = '';

      if (this.dataTable) {
        this.dataTable.ajax.reload();
      }
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect_dist_vue_treeselect_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Treeselect: __WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect___default.a
  },
  data: function data() {
    return {
      // DataTable instance
      dataTable: null,

      // Month/Year filter
      monthYear: null,

      // label แสดง "ข้อมูล ณ ..."
      dataAsOfLabel: '',

      // Filter values
      productType: [],
      barcodeStatusCode: [],
      agentCode: [],
      materialCode: [],
      retentionPeriod: [],
      headAgentCode: [],
      productBrand: [],
      ownerType: [],
      brand: [],

      // Filter options
      productTypeOptions: [],
      barcodeStatusCodeOptions: [],
      agentCodeOptions: [],
      materialCodeOptions: [],
      retentionPeriodOptions: [{ id: "ไม่เกิน 3 เดือน", label: "ไม่เกิน 3 เดือน" }, { id: "ไม่เกิน 4 เดือน", label: "ไม่เกิน 4 เดือน" }, { id: "เกิน 4 เดือน", label: "เกิน 4 เดือน" }, { id: "เกิน 5 เดือน", label: "เกิน 5 เดือน" }],
      headAgentCodeOptions: [],
      productBrandOptions: [],
      fullProductData: [],
      ownerTypeOptions: [],
      brandOptions: []
    };
  },
  mounted: function mounted() {
    this.initMonthYearPicker();
    this.loadProductTypeOptions();
    this.loadBarcodeStatusCodeOptions();
    this.loadAgentCodeOptions();
    this.loadMaterialCodeOptions();
    this.loadHeadAgentCodeOptions();
    this.loadProductBrandOptions();
    this.loadOwnerTypeOptions();
    this.loadBrandOptions();
    this.initDataTable();
  },
  computed: {
    filteredProductBrandOptions: function filteredProductBrandOptions() {
      if (!this.brand.length) {
        return this.productBrandOptions;
      }
      var selectedBrandIds = this.brand.map(Number);
      var filteredOptions = [];
      this.fullProductData.forEach(function (item) {
        if (selectedBrandIds.indexOf(item.data.productBrandId) !== -1) {
          filteredOptions.push({
            id: item.id,
            label: item.text,
            productBrandId: item.data.productBrandId
          });
        }
      });
      return filteredOptions;
    }
  },
  methods: {
    showCriteriaModal: function showCriteriaModal() {
      $("#criteriaModal").modal("show");
    },
    initMonthYearPicker: function initMonthYearPicker() {
      var self = this;
      var arrows;
      if (KTUtil.isRTL()) {
        arrows = {
          leftArrow: '<i class="la la-angle-right"></i>',
          rightArrow: '<i class="la la-angle-left"></i>'
        };
      } else {
        arrows = {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>'
        };
      }

      // Default = current month/year
      self.monthYear = moment();

      $(self.$refs.monthYearPicker).datepicker({
        format: "mm/yyyy",
        viewMode: "months",
        minViewMode: "months",
        autoclose: true,
        clearBtn: true,
        rtl: KTUtil.isRTL(),
        orientation: "bottom left",
        templates: arrows
      });
      $(self.$refs.monthYearPicker).datepicker("update", self.monthYear.format("MM/YYYY")).on("changeDate", function (e) {
        self.monthYear = e.dates.length !== 0 ? moment(e.date) : null;
      });
    },

    // ประเภทสินค้า
    loadProductTypeOptions: function loadProductTypeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: { page: 1, all: true }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            if (element.id == 4 || element.id == 5) {
              self.productTypeOptions.push({
                id: element.id,
                label: element.text
              });
            }
          });
        }
      }).catch(function (error) {});
    },

    // สถานะ
    loadBarcodeStatusCodeOptions: function loadBarcodeStatusCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", {
        params: { page: 1, all: true }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.barcodeStatusCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    // ชื่อตัวแทนจำหน่าย
    loadAgentCodeOptions: function loadAgentCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Report/Select2Agent", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        all: true,
        IsShowInAgentScoreReport: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.agentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    // ชื่อสินค้า
    loadMaterialCodeOptions: function loadMaterialCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/Product/Select2Product", {
        params: { page: 1, all: true, excludeProductGroupId: 14 }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.materialCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    // เคลียร์ ชื่อแบรนด์สินค้า เมื่อเลือก/ยกเลิก แบรนด์สินค้า
    BrandIdClearAfterSelect: function BrandIdClearAfterSelect() {
      this.productBrand = [];
    },
    BrandIdClearAfterDeSelect: function BrandIdClearAfterDeSelect() {
      this.productBrand = [];
    },

    // ชื่อตัวแทนจำหน่าย(Group)
    loadHeadAgentCodeOptions: function loadHeadAgentCodeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1,
        IsShowInAgentScoreReport: true,
        IsHead: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.headAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    // ชื่อแบรนด์สินค้า — โหลดข้อมูลทั้งหมดพร้อม productBrandId เพื่อใช้ filter ตามแบรนด์
    loadProductBrandOptions: function loadProductBrandOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/product/Select2ProductReport", {
        page: 1,
        all: true,
        search: "",
        productGroupIds: [14]
      }).then(function (response) {
        if (response.status === 200) {
          self.fullProductData = response.data.results;
          self.productBrandOptions = self.fullProductData.map(function (item) {
            return {
              id: item.id,
              label: item.text,
              productBrandId: item.data.productBrandId
            };
          });
        }
      }).catch(function (error) {
        console.error("Error loading product data:", error);
      });
    },

    // ประเภทผู้ถือครอง — ใช้ hardcoded เหมือน Barcodes (SP รับ Thai text)
    loadOwnerTypeOptions: function loadOwnerTypeOptions() {
      var self = this;
      var data = [{ id: "ตัวแทนจำหน่าย", label: "ตัวแทนจำหน่าย" }, { id: "ตัวแทนจำหน่ายย่อย", label: "ตัวแทนจำหน่ายย่อย" }, { id: "ร้านค้า", label: "ร้านค้า" }, { id: "ร้านค้า (ตัวแทนฯย่อย)", label: "ร้านค้า (ตัวแทนฯย่อย)" }];
      self.ownerTypeOptions = data;
    },

    // แบรนด์
    loadBrandOptions: function loadBrandOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: { page: 1, all: true }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.brandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    formSubmit: function formSubmit(e) {
      e.preventDefault();
      this.dataTable.ajax.reload();
    },

    initDataTable: function initDataTable() {
      var self = this;

      // map ช่วงคงค้าง option → day range สำหรับ @OverDueFrom / @OverDueTo
      function calcRetentionRange(selected) {
        if (!selected || selected.length === 0) return { from: null, to: null };
        var rangeMap = {
          "ไม่เกิน 3 เดือน": { from: 1, to: 90 },
          "ไม่เกิน 4 เดือน": { from: 91, to: 120 },
          "เกิน 4 เดือน": { from: 121, to: null },
          "เกิน 5 เดือน": { from: 151, to: null }
        };
        var froms = [],
            tos = [],
            hasOpenEnd = false;
        selected.forEach(function (r) {
          var rng = rangeMap[r];
          if (!rng) return;
          froms.push(rng.from);
          if (rng.to !== null) {
            tos.push(rng.to);
          } else {
            hasOpenEnd = true;
          }
        });
        return {
          from: froms.length ? Math.min.apply(null, froms) : null,
          to: hasOpenEnd ? null : tos.length ? Math.max.apply(null, tos) : null
        };
      }

      function formatNumber(val) {
        if (val === null || val === undefined || val === 0) return "-";
        return val.toLocaleString();
      }

      self.dataTable = $(self.$refs.kegRotationTable).DataTable({
        scrollX: true,
        responsive: false,
        processing: true,
        serverSide: true,
        deferLoading: 0,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/SearchMachineScore",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function beforeSend(request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          },
          data: function data(d) {
            var retentionRange = calcRetentionRange(self.retentionPeriod);
            var jsonSearch = {
              IsInitial: false,
              AgentCodes: self.agentCode,
              HeadAgentCodes: self.headAgentCode,
              AssetCodes: self.materialCode,
              ProductTypeIds: self.productType,
              BarcodeStatusCodes: self.barcodeStatusCode,
              FinishedProductCodes: self.productBrand,
              BrandIds: self.brand,
              CurrentLocationType: self.ownerType,
              OverDueFrom: retentionRange.from,
              OverDueTo: retentionRange.to,
              FinalScore: 0,
              Month: self.monthYear ? self.monthYear.month() + 1 : null,
              Year: self.monthYear ? self.monthYear.year() : null
            };
            return JSON.stringify($.extend(d, jsonSearch));
          }
        },
        drawCallback: function drawCallback() {
          this.api().columns.adjust();
          var thaiMonths = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'];
          var now = moment();
          var isCurrentMonth = !self.monthYear || self.monthYear.year() === now.year() && self.monthYear.month() === now.month();
          if (isCurrentMonth) {
            self.dataAsOfLabel = 'ข้อมูล ณ วันที่ ' + now.format('DD/MM/YYYY h:mm a');
          } else {
            self.dataAsOfLabel = 'ข้อมูล ณ เดือน ' + thaiMonths[self.monthYear.month()] + ' ' + self.monthYear.year();
          }
        },
        dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
        lengthMenu: [50, 100, 200, 500],
        pageLength: 50,
        language: {
          lengthMenu: "Display _MENU_"
        },
        order: [[0, "asc"]],
        columns: [{ data: "agentCode", className: "text-center", orderable: true }, { data: "agentName", className: "text-left", orderable: true }, { data: "assetCode", className: "text-center", orderable: false }, { data: "assetName", className: "text-left", orderable: false },
        // High Season
        { data: "high_3Month", className: "text-center bg-green", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "high_3_4Month", className: "text-center bg-yellow", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "high_Over4Month", className: "text-center bg-red", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "high_Total", className: "text-center", orderable: false, render: function render(data) {
            return formatNumber(data);
          } },
        // Low Season
        { data: "low_5Month", className: "text-center bg-green", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "low_5_6Month", className: "text-center bg-yellow", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "low_Over6Month", className: "text-center bg-red", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }, { data: "low_Total", className: "text-center", orderable: false, render: function render(data) {
            return formatNumber(data);
          } },
        // Summary
        { data: "total", className: "text-center", orderable: false, render: function render(data) {
            return formatNumber(data);
          } }],
        rowGroup: {
          dataSrc: "agentCode",
          startRender: function startRender(rows, group) {
            var agentName = rows.data()[0].agentName || group;
            return $('<tr class="group-header"/>').append('<td colspan="13" class="td-header">' + agentName + "</td>");
          },
          endRender: function endRender(rows, group) {
            var agentName = rows.data()[0].agentName || group;
            var totH3 = rows.data().pluck("high_3Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totH34 = rows.data().pluck("high_3_4Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totHO4 = rows.data().pluck("high_Over4Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totHT = rows.data().pluck("high_Total").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totL5 = rows.data().pluck("low_5Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totL56 = rows.data().pluck("low_5_6Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totLO6 = rows.data().pluck("low_Over6Month").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totLT = rows.data().pluck("low_Total").reduce(function (a, b) {
              return a + Number(b);
            }, 0);
            var totTotal = rows.data().pluck("total").reduce(function (a, b) {
              return a + Number(b);
            }, 0);

            return $('<tr class="group-footer-sub"/>').append('<td class="td-footer" colspan="4" style="max-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">Total ' + agentName + "</td>").append('<td class="td-footer text-center">' + formatNumber(totH3) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totH34) + "</td>").append('<td class="td-footer text-center" style="color: #C00000 !important;">' + formatNumber(totHO4) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totHT) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totL5) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totL56) + "</td>").append('<td class="td-footer text-center" style="color: #C00000 !important;">' + formatNumber(totLO6) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totLT) + "</td>").append('<td class="td-footer text-center">' + formatNumber(totTotal) + "</td>");
          }
        },
        footerCallback: function footerCallback() {
          var api = this.api();
          var json = api.ajax.json();
          if (!json || !json.groupSummary) {
            // clear footer เมื่อไม่มีข้อมูล
            for (var i = 4; i <= 12; i++) {
              $(api.column(i).footer()).html("");
            }
            return;
          }
          var s = json.groupSummary;
          $(api.column(4).footer()).html(formatNumber(s.tot_High_3Month));
          $(api.column(5).footer()).html(formatNumber(s.tot_High_3_4Month));
          $(api.column(6).footer()).html(formatNumber(s.tot_High_Over4Month));
          $(api.column(7).footer()).html(formatNumber(s.tot_High_Total));
          $(api.column(8).footer()).html(formatNumber(s.tot_Low_5Month));
          $(api.column(9).footer()).html(formatNumber(s.tot_Low_5_6Month));
          $(api.column(10).footer()).html(formatNumber(s.tot_Low_Over6Month));
          $(api.column(11).footer()).html(formatNumber(s.tot_Low_Total));
          $(api.column(12).footer()).html(formatNumber(s.tot_Total));
        }
      });

      // Sync top scrollbar with DataTables scrollBody
      self.$nextTick(function () {
        var scrollBody = $(self.$refs.kegRotationTable).closest('.dataTables_scrollBody');
        var topWrapper = self.$refs.topScrollWrapper;
        var topContent = self.$refs.topScrollContent;
        if (!scrollBody.length || !topWrapper || !topContent) return;

        function syncTopScrollWidth() {
          var bodyTable = scrollBody.find('table');
          var headTable = scrollBody.prev('.dataTables_scrollHead').find('table');
          var w = 0;
          if (bodyTable.length) w = Math.max(w, bodyTable[0].scrollWidth);
          if (headTable.length) w = Math.max(w, headTable[0].scrollWidth);
          topContent.style.width = w + 'px';
        }
        syncTopScrollWidth();

        var syncing = false;
        $(topWrapper).on('scroll', function () {
          if (syncing) return;
          syncing = true;
          scrollBody[0].scrollLeft = topWrapper.scrollLeft;
          syncing = false;
        });
        scrollBody.on('scroll', function () {
          if (syncing) return;
          syncing = true;
          topWrapper.scrollLeft = scrollBody[0].scrollLeft;
          syncing = false;
        });

        $(self.$refs.kegRotationTable).on('draw.dt', function () {
          self.$nextTick(function () {
            syncTopScrollWidth();
          });
        });
      });
    },

    exportCompareReport: function exportCompareReport(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/Report/ExportCompareSnapshotVsBarcodeReportAgent",
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token,
          "Content-Type": "application/json"
        },
        data: JSON.stringify(function () {
          var rangeMap = {
            "ไม่เกิน 3 เดือน": { from: 1, to: 90 },
            "ไม่เกิน 4 เดือน": { from: 91, to: 120 },
            "เกิน 4 เดือน": { from: 121, to: null },
            "ไม่เกิน 5 เดือน": { from: 1, to: 150 },
            "ไม่เกิน 6 เดือน": { from: 151, to: 180 },
            "เกิน 6 เดือน": { from: 181, to: null }
          };
          var froms = [],
              tos = [],
              hasOpenEnd = false;
          self.retentionPeriod.forEach(function (r) {
            var rng = rangeMap[r];
            if (!rng) return;
            froms.push(rng.from);
            if (rng.to !== null) {
              tos.push(rng.to);
            } else {
              hasOpenEnd = true;
            }
          });
          var overDueFrom = froms.length ? Math.min.apply(null, froms) : null;
          var overDueTo = hasOpenEnd ? null : tos.length ? Math.max.apply(null, tos) : null;
          return {
            IsInitial: false,
            AgentCodes: self.agentCode,
            HeadAgentCodes: self.headAgentCode,
            AssetCodes: self.materialCode,
            ProductTypeIds: self.productType,
            BarcodeStatusCodes: self.barcodeStatusCode,
            FinishedProductCodes: self.productBrand,
            BrandIds: self.brand,
            CurrentLocationType: self.ownerType,
            OverDueFrom: overDueFrom,
            OverDueTo: overDueTo,
            FinalScore: "0",
            Month: self.monthYear ? self.monthYear.month() + 1 : null,
            Year: self.monthYear ? self.monthYear.year() : null
          };
        }())
      }).then(function (response) {
        KTApp.unblockPage();
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = moment().format("YYYY-MM-DD") + "_รายงานคะแนนถังคงค้าง(ตรวจสอบข้อมูล).xlsx";
        link.click();
      }).catch(function () {
        KTApp.unblockPage();
      });
    },

    exportMachineScore: function exportMachineScore(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/Report/ExportMachineScoreAgent",
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token,
          "Content-Type": "application/json"
        },
        data: JSON.stringify(function () {
          var rangeMap = {
            "ไม่เกิน 3 เดือน": { from: 1, to: 90 },
            "ไม่เกิน 4 เดือน": { from: 91, to: 120 },
            "เกิน 4 เดือน": { from: 121, to: null },
            "ไม่เกิน 5 เดือน": { from: 1, to: 150 },
            "ไม่เกิน 6 เดือน": { from: 151, to: 180 },
            "เกิน 6 เดือน": { from: 181, to: null }
          };
          var froms = [],
              tos = [],
              hasOpenEnd = false;
          self.retentionPeriod.forEach(function (r) {
            var rng = rangeMap[r];
            if (!rng) return;
            froms.push(rng.from);
            if (rng.to !== null) {
              tos.push(rng.to);
            } else {
              hasOpenEnd = true;
            }
          });
          var overDueFrom = froms.length ? Math.min.apply(null, froms) : null;
          var overDueTo = hasOpenEnd ? null : tos.length ? Math.max.apply(null, tos) : null;
          return {
            IsInitial: false,
            AgentCodes: self.agentCode,
            HeadAgentCodes: self.headAgentCode,
            AssetCodes: self.materialCode,
            ProductTypeIds: self.productType,
            BarcodeStatusCodes: self.barcodeStatusCode,
            FinishedProductCodes: self.productBrand,
            BrandIds: self.brand,
            CurrentLocationType: self.ownerType,
            OverDueFrom: overDueFrom,
            OverDueTo: overDueTo,
            FinalScore: "0",
            Month: self.monthYear ? self.monthYear.month() + 1 : null,
            Year: self.monthYear ? self.monthYear.year() : null
          };
        }())
      }).then(function (response) {
        KTApp.unblockPage();
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = moment().format("YYYY-MM-DD") + "_รายงานคะแนนถังคงค้าง(ตัวแทนจำหน่าย)" + ".xlsx";
        link.click();
      }).catch(function () {
        KTApp.unblockPage();
      });
    },

    formReset: function formReset() {
      this.productType = [];
      this.barcodeStatusCode = [];
      this.agentCode = [];
      this.materialCode = [];
      this.retentionPeriod = [];
      this.headAgentCode = [];
      this.productBrand = [];
      this.ownerType = [];
      this.brand = [];

      // Reset month/year to current
      this.monthYear = moment();
      $(this.$refs.monthYearPicker).datepicker("update", this.monthYear.format("MM/YYYY"));
      this.dataAsOfLabel = '';

      if (this.dataTable) {
        this.dataTable.ajax.reload();
      }
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      relmPhase: null,
      relmLot: null,
      relmProductBrandId: null,
      relmCurrentAgentCode: null,
      relmProductTypeId: null,
      relmCurrentVendorId: null,
      headers: [],
      database: [],
      phase: [],
      totalPhase: [],
      GrandTotal: null,
      relmCurrentAgentCodeOptions: {
        // minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกAgent",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: []
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      relmProductTypeIdOptions: {
        // minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกประเภทสินค้า",
        data: [{ id: "3", text: "เครื่องทำความเย็น", data: null }, { id: "6", text: "หัวจ่าย", data: null }]
      },
      relmCurrentVendorIdOptions: {
        //minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกSupplier",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Vendors/Select2Vendor",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      relmPhaseOptions: {
        // minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกPhase",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Phase",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      relmLotOptions: {
        // minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกLot",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Lot",
          data: function data(params) {
            var query = {
              search: params.term,
              Phase: self.relmPhase,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      relmProductBrandIdOptions: {
        // minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกแบรนด์เครื่องเบียร์สด",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2BrandMachine",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              ProductType: "3,6"
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.relmPhase = null;
      self.relmLot = null;
      self.relmProductBrandId = null;
      self.relmCurrentAgentCode = null;
      self.relmProductTypeId = null;
      self.relmCurrentVendorId = null;
      self.headers = [];
      self.database = [];
      self.phase = [];
      self.totalPhase = [];
      self.GrandTotal = null;

      $("#relmPhase").val("").trigger("change");

      $("#relmLot").val("").trigger("change");

      $("#relmProductBrandId").val("").trigger("change");

      $("#relmCurrentAgentCode").val("").trigger("change");

      $("#relmProductTypeId").val("").trigger("change");

      $("#relmCurrentVendorId").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;
      // self.headers = [];
      // self.database = [];
      // self.phase = [];
      // self.totalPhase = [];
      // self.GrandTotal = null;

      e.preventDefault();
      var table = $("#datatable").DataTable();
      table.draw();
    },
    exportLeaseMachine: function exportLeaseMachine(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportMachineTransation",
        responseType: "arraybuffer",
        data: _defineProperty({
          Phase: self.relmPhase,
          Lot: self.relmLot,
          ProductBrandId: self.relmProductBrandId,
          CurrentAgentCode: self.relmCurrentAgentCode,
          ProductTypeId: self.reAaProductTypeId,
          CurrentVendorId: self.relmCurrentVendorId
        }, "ProductTypeId", self.relmProductTypeId)
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          console.log(response.data);
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    getDataFromApi: function getDataFromApi(data) {
      var self = this;

      self.headers = [];
      self.database = [];
      self.phase = [];
      self.totalPhase = [];
      self.GrandTotal = null;

      data.forEach(function (e) {
        self.GrandTotal = self.GrandTotal + e.total;
        e.phase.forEach(function (o) {
          var chk = self.headers.includes(o.phase);
          if (!chk) {
            self.headers.push(o.phase);
          }
        });
      });
      self.headers = self.headers.sort();
      self.database = data;

      self.database.forEach(function (o) {
        o.phase.forEach(function (i) {
          self.phase.push(i);
        });
      });

      self.headers.forEach(function (e) {
        var data = self.phase.filter(function (o) {
          return o.phase == e;
        });
        var total = 0;
        data.forEach(function (d) {
          total = total + d.total;
        });

        var item = [e, total];
        self.totalPhase.push(item);
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }
              $.fn.dataTable.ext.errMode = 'none';
              table = $("#datatable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                ajax: {
                  url: "/Api/Report/MachineTransation",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var _$$extend;

                    return JSON.stringify($.extend(d, (_$$extend = {
                      Phase: self.relmPhase,
                      Lot: self.relmLot,
                      ProductBrandId: self.relmProductBrandId,
                      CurrentAgentCode: self.relmCurrentAgentCode,
                      ProductTypeId: self.reAaProductTypeId,
                      CurrentVendorId: self.relmCurrentVendorId
                    }, _defineProperty(_$$extend, "ProductTypeId", self.relmProductTypeId), _defineProperty(_$$extend, "IsInitial", self.reAaIsInitial), _$$extend)));
                  },
                  complete: function complete(response, xhr, status) {
                    // console.log("response.responseJSON.data");
                    // console.log(response.responseJSON.data);
                    self.getDataFromApi(response.responseJSON.data);
                    self.reAaIsInitial = false;
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [100, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },

                // Order settings
                order: [[0, "asc"]],
                columns: [{
                  data: "agentCode",
                  className: "text-center",
                  width: "10%"
                }, {
                  data: "agentName",
                  className: "text-center",
                  width: "10%"
                }]
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reInv1).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.reInv1).datepicker("update", !!self.reInv1 ? self.reInv1.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reInv1 = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reInv2).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.reInv2).datepicker("update", !!self.reInv2 ? self.reInv2.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reInv2 = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      reAaDateReq: null,
      reStartDate: null,
      reEndDate: null,
      reAgentCode: null,
      reIsInitial: true,
      reAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: []
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reAgentCode = null;

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reAgentCode").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#MTMonthlyTable").DataTable();
      table.draw();
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reEndDate = moment().endOf('month');
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#MTMonthlyTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/MTMonthly",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                      EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
                      AgentCode: self.reAgentCode,
                      IsInitial: self.reIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[2, "desc"]],
                columns: [{
                  data: "mtDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "agentName", className: "text-center" }, {
                  data: "mtDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.mtDateString;
                  }
                }, { data: "shopName", className: "text-center" }, { data: "shopName2", className: "text-center" }, { data: "failureMachine", className: "text-left text-wrap" }, { data: "failureMachineOther", className: "text-left text-wrap" }, { data: "failureMachineReason", className: "text-left text-wrap" }, { data: "resolve", className: "text-left text-wrap" }, {
                  data: "machine",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    //console.log(data);
                    if (data != null) {
                      return data.machineBarcode;
                    } else return "";
                  }
                }, {
                  data: "machine",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    //console.log(data);
                    if (data != null) {
                      return data.machineBarcodeOld;
                    } else return "";
                  }
                }, {
                  data: "dispenser",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    //console.log(data);
                    if (data != null) {
                      return data.dispenserBarcode;
                    } else return "";
                  }
                }, {
                  data: "dispenser",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    //console.log(data);
                    if (data != null) {
                      return data.dispenserBarcodeOld;
                    } else return "";
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      remdDateInstallStart: null,
      remdDateInstallEnd: null,
      remdContractStartDate_Start: null,
      remdContractStartDate_End: null,
      remdContractExpireDate_Start: null,
      remdContractExpireDate_End: null,
      remdAgentCode: [],
      remdPhase: [],
      remdLot: [],
      remdMachineProductCode: [],
      remdDispenserProductCode: [],
      remdMachineProductBrandId: [],
      remdDispenserProductBrandId: [],
      remdSupplierId: [],
      reAaIsInitial: true,
      reAaDateReq: null,
      reInv7: null,
      reAaProductTypeId: [],
      remdShopProvinceId: [],
      remdAgentCodeOptions: [],
      // remdAgentCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกAgent",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdMachineProductCodeOptions: [],
      // remdMachineProductCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทเครื่อง",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         productTypeId: 3,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdDispenserProductCodeptions: [],
      // remdDispenserProductCodeptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทหัวจ่าย",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         productTypeId: 6,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdDispenserProductBrandIdOptions: [],
      // remdDispenserProductBrandIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกBrand หัวจ่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2BrandMachine",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         ProductType: "6",
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdShopProvinceIdOptions: [],
      // remdShopProvinceIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกจังหวัด",
      //   ajax: {
      //     url: "/Api/MasterLocation/Select2SearchProvince",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdSupplierIdOptions: [],
      // remdSupplierIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกSupplier",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Vendors/Select2Vendor",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdPhaseOptions: [],
      // remdPhaseOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกPhase",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterPhase/Select2Phase",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdLotOptions: [],
      // remdLotOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกLot",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterPhase/Select2Lot",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      remdMachineProductBrandIdOptions: []
      // remdMachineProductBrandIdOptions: {
      //   placeholder: "กรุณาเลือกแบรนด์เครื่องเบียร์สด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2BrandMachine",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         ProductType: [3],
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.remdDateInstallStart = null;
      self.remdDateInstallEnd = null;
      self.remdContractStartDate_Start = null;
      self.remdContractStartDate_End = null;
      self.remdContractExpireDate_Start = null, self.remdContractExpireDate_End = null, self.remdAgentCode = [];
      self.remdPhase = [];
      self.remdLot = [];
      self.remdMachineProductCode = [];
      self.remdDispenserProductCode = [];
      self.remdMachineProductBrandId = [];
      self.remdDispenserProductBrandId = [];
      self.remdSupplierId = [];
      self.reInv7 = null;
      self.reAaProductTypeId = [];
      self.remdShopProvinceId = [];

      $("#remdAgentCode").val("").trigger("change");

      $("#remdPhase").val("").trigger("change");

      $("#remdLot").val("").trigger("change");

      $("#remdMachineProductCode").val("").trigger("change");

      $("#remdDispenserProductCode").val("").trigger("change");

      $("#remdMachineProductBrandId").val("").trigger("change");

      $("#remdDispenserProductBrandId").val("").trigger("change");

      $("#remdSupplierId").val("").trigger("change");

      $("#reAaProductTypeId").val("").trigger("change");

      $("#remdShopProvinceId").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#MachineDetailTable").DataTable();
      table.draw();
    },
    exportMachineDetail: function exportMachineDetail(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportMachineDetail",
        responseType: "arraybuffer",
        data: {
          DateInstallStart: self.remdDateInstallStart != null ? self.remdDateInstallStart.format("DD/MM/YYYY") : self.remdDateInstallStart,
          DateInstallEnd: self.remdDateInstallEnd != null ? self.remdDateInstallEnd.format("DD/MM/YYYY") : self.remdDateInstallEnd,
          ContractStartDate_Start: self.remdContractStartDate_Start != null ? self.remdContractStartDate_Start.format("DD/MM/YYYY") : self.remdContractStartDate_Start,
          ContractStartDate_End: self.remdContractStartDate_End != null ? self.remdContractStartDate_End.format("DD/MM/YYYY") : self.remdContractStartDate_End,
          ContractExpireDate_Start: self.remdContractExpireDate_Start != null ? self.remdContractExpireDate_Start.format("DD/MM/YYYY") : self.remdContractExpireDate_Start,
          ContractExpireDate_End: self.remdContractExpireDate_End != null ? self.remdContractExpireDate_End.format("DD/MM/YYYY") : self.remdContractExpireDate_End,
          AgentCode: self.remdAgentCode,
          Phase: self.remdPhase,
          Lot: self.remdLot,
          MachineProductCode: self.remdMachineProductCode,
          DispenserProductCode: self.remdDispenserProductCode,
          MachineProductBrandId: self.remdMachineProductBrandId,
          DispenserProductBrandId: self.remdDispenserProductBrandId,
          SupplierId: self.remdSupplierId,
          ShopProvinceId: self.remdShopProvinceId
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadremdAgentCodeOptions: function LoadremdAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.remdAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadremdMachineProductCodeOptions: function LoadremdMachineProductCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          productTypeId: 3,
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.remdMachineProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadremdDispenserProductCodeptions: function LoadremdDispenserProductCodeptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          productTypeId: 6,
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.remdDispenserProductCodeptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadremdDispenserProductBrandIdOptions: function LoadremdDispenserProductBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2BrandMachine", {
        params: {
          ProductType: 6,
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.remdDispenserProductBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadremdShopProvinceIdOptions: function LoadremdShopProvinceIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/MasterLocation/Select2SearchProvince", {
        all: true,
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.remdShopProvinceIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadremdSupplierIdOptions: function LoadremdSupplierIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.remdSupplierIdOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Vendors/Select2Vendor", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.remdSupplierIdOptions = [];
            data.forEach(function (element) {
              self.remdSupplierIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.remdSupplierIdOptions);
        }).catch(function (error) {});
      }
    },

    LoadremdPhaseOptions: function LoadremdPhaseOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterPhase/Select2Phase", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.remdPhaseOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadremdLotOptions: function LoadremdLotOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/MasterPhase/Select2Lot", {
        page: 1,
        Phases: self.remdPhase
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          //console.log("data", data);
          self.remdLotOptions = [];
          data.forEach(function (element) {
            self.remdLotOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadremdMachineProductBrandIdOptions: function LoadremdMachineProductBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2BrandMachine", {
        params: {
          page: 1,
          ProductType: [3],
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.remdMachineProductBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadremdAgentCodeOptions();
              self.LoadremdMachineProductCodeOptions();
              self.LoadremdDispenserProductCodeptions();
              self.LoadremdDispenserProductBrandIdOptions();
              self.LoadremdShopProvinceIdOptions();

              self.LoadremdPhaseOptions();
              self.LoadremdLotOptions();
              self.LoadremdMachineProductBrandIdOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.remdDateInstallStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.remdDateInstallStart).datepicker("update", !!self.remdDateInstallStart ? self.remdDateInstallStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.remdDateInstallStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.remdDateInstallEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.remdDateInstallEnd).datepicker("update", !!self.remdDateInstallEnd ? self.remdDateInstallEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.remdDateInstallEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.remdContractStartDate_Start).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.remdContractStartDate_Start).datepicker("update", !!self.remdContractStartDate_Start ? self.remdContractStartDate_Start.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.remdContractStartDate_Start = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.remdContractStartDate_End).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.remdContractStartDate_End).datepicker("update", !!self.remdContractStartDate_End ? self.remdContractStartDate_End.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.remdContractStartDate_End = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.remdContractExpireDate_Start).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.remdContractExpireDate_Start).datepicker("update", !!self.remdContractExpireDate_Start ? self.remdContractExpireDate_Start.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.remdContractExpireDate_Start = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.remdContractExpireDate_End).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.remdContractExpireDate_End).datepicker("update", !!self.remdContractExpireDate_End ? self.remdContractExpireDate_End.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.remdContractExpireDate_End = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#MachineDetailTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/MachineDetail",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      DateInstallStart: self.remdDateInstallStart != null ? self.remdDateInstallStart.format("DD/MM/YYYY") : self.remdDateInstallStart,
                      DateInstallEnd: self.remdDateInstallEnd != null ? self.remdDateInstallEnd.format("DD/MM/YYYY") : self.remdDateInstallEnd,
                      ContractStartDate_Start: self.remdContractStartDate_Start != null ? self.remdContractStartDate_Start.format("DD/MM/YYYY") : self.remdContractStartDate_Start,
                      ContractStartDate_End: self.remdContractStartDate_End != null ? self.remdContractStartDate_End.format("DD/MM/YYYY") : self.remdContractStartDate_End,
                      ContractExpireDate_Start: self.remdContractExpireDate_Start != null ? self.remdContractExpireDate_Start.format("DD/MM/YYYY") : self.remdContractExpireDate_Start,
                      ContractExpireDate_End: self.remdContractExpireDate_End != null ? self.remdContractExpireDate_End.format("DD/MM/YYYY") : self.remdContractExpireDate_End,
                      AgentCode: self.remdAgentCode,
                      Phase: self.remdPhase,
                      Lot: self.remdLot,
                      MachineProductCode: self.remdMachineProductCode,
                      DispenserProductCode: self.remdDispenserProductCode,
                      MachineProductBrandId: self.remdMachineProductBrandId,
                      DispenserProductBrandId: self.remdDispenserProductBrandId,
                      SupplierId: self.remdSupplierId,
                      ShopProvinceId: self.remdShopProvinceId,
                      IsInitial: self.reAaIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [100, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[1, "desc"]],
                columns: [{ data: "agentName", className: "text-center" }, { data: "agentCode", className: "text-center" }, { data: "phase", className: "text-center" }, { data: "lot", className: "text-center" }, { data: "supplierName", className: "text-center" }, { data: "machineProductName", className: "text-center" }, { data: "qtyCoil", className: "text-center" }, { data: "machineBarcodeOldNo", className: "text-center" }, { data: "machineProductBrandName", className: "text-center" }, { data: "dispenserProductName", className: "text-center" }, { data: "dispenserBarcodeOldNo", className: "text-center" }, { data: "dispenserProductBrandName", className: "text-center" }, { data: "dateInstallDay", className: "text-center" }, { data: "dateInstallMonth", className: "text-center" }, { data: "dateInstallYear", className: "text-center" }, { data: "contractStartDateString", className: "text-center" }, { data: "contractExpireDateString", className: "text-center" }, { data: "paymentInstallment", className: "text-center" }, { data: "shopName", className: "text-center" }, { data: "shopName2", className: "text-center" }, { data: "shopAddress", className: "text-center" }, { data: "shopTambonName", className: "text-center" }, { data: "shopProvinceName", className: "text-center" }, { data: "shopTelephone", className: "text-center" }, { data: "latitude", className: "text-center" }, { data: "longitude", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reAaIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    remdPhase: function remdPhase() {
      //console.log(this.remdPhase);
      this.LoadremdLotOptions();
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {
      AgentCodesMessages: "กรุณาเลือกตัวแทนจำหน่าย",
      AgentCodesMessagesStatus: false,
      reAllAgentCodes: [],
      reAgentCodes: [],
      reShopCodes: [],
      reShopCodes2: [],
      reDepartments: [],
      reStartDate: null,
      reEndDate: null,
      reShopTypeId: [],
      shmShopGroupId: [],
      shmShopPMType: [],
      reShopStatus: null,
      reProvinceId: null,
      reAmpherId: null,
      reReason: [],
      reInActiveStatus: true,
      reAgentCodesOptions: [],

      pmrSubAgentCodes: [],
      pmrSubAgentCodeOptions: [],
      pmrSubAgentShopCodes: [],
      pmrSubAgentShopCodesOptions: []

    }, _defineProperty(_ref, "reShopCodes", []), _defineProperty(_ref, "reShopCodesOptions", []), _defineProperty(_ref, "reShopCodes2Options", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Shop/Select2ShopAgentName2",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.reAgentCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "pmrSubAgentShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      //pmrSubAgentCodes
      ajax: {
        url: "/Api/Shop/SubShopOptionAlertReport",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.reAgentCodes,
            shopCodes: self.pmrSubAgentCodes,
            search: params.term,
            page: params.page || 1,
            all: true
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "pmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {

          var isAllAgent = false;
          if (self.reAgentCodes.indexOf("99999999") > -1) {
            isAllAgent = true;
            self.reAllAgentCodes = [];
            self.reAgentCodesOptions.forEach(function (element) {
              self.reAllAgentCodes.push(element.id);
            });
          } else {
            self.reAllAgentCodes = [];
          }

          var query = {
            agentCodes: isAllAgent ? self.reAllAgentCodes : self.reAgentCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reDepartmentsOptions", []), _defineProperty(_ref, "reReasonOptions", []), _defineProperty(_ref, "reShopTypeIdOptions", []), _defineProperty(_ref, "shmShopGroupIdOptions", []), _defineProperty(_ref, "shmShopPMTypeOptions", []), _defineProperty(_ref, "reShopStatusOptions", {
      placeholder: "ทั้งหมด",
      allowClear: true,
      data: [{ id: true, text: "ร้านเปิด", data: null }, { id: false, text: "ร้านปิด", data: null }]
    }), _defineProperty(_ref, "reProvinceIdOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/MasterLocation/Select2SearchProvince",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reAmpherIdOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/MasterLocation/Select2SearchAmpher",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            provinceId: self.reProvinceId,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reAgentCodes = [];
      self.reShopCodes = [];
      self.reShopCodes2 = [];
      self.reDepartments = [];
      self.reStartDate = null;
      self.reEndDate = null;
      self.reShopTypeId = [];
      self.shmShopGroupId = [];
      self.shmShopPMType = [];
      self.reShopStatus = null;
      self.reProvinceId = null;
      self.reAmpherId = null;
      self.reReason = [];
      self.pmrSubAgentCodes = [];
      self.pmrSubAgentCodeOptions = [];
      self.pmrSubAgentShopCodes = [];
      self.pmrSubAgentShopCodesOptions = [];

      $("#pmrSubAgentCodes").val("").trigger("change");

      $("#pmrSubAgentShopCodes").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#reShopCodes").val("").trigger("change");

      $("#reShopCodes2").val("").trigger("change");

      $("#reDepartments").val("").trigger("change");

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reShopTypeId").val("").trigger("change");

      $("#shmShopGroupId").val("").trigger("change");

      $("#shmShopPMType").val("").trigger("change");

      $("#reShopStatus").val("").trigger("change");

      $("#reProvinceId").val("").trigger("change");

      $("#reAmpherId").val("").trigger("change");

      $("#reReason").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      console.log("formSubmit");
      var self = this;

      e.preventDefault();
      table.draw();
    },
    exportMasterShop: function exportMasterShop(e) {
      e.preventDefault();
      var self = this;

      self.AgentCodesMessagesStatus = false;

      if (this.$root.canShow(["super_admin", "ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM"])) {
        if (self.reAgentCodes.length == 0) {
          self.AgentCodesMessagesStatus = true;
        }
      }

      var isAllAgent = false;
      if (self.reAgentCodes.indexOf("99999999") > -1) {
        isAllAgent = true;
        self.reAgentCodesOptions.forEach(function (element) {
          self.reAllAgentCodes.push(element.id);
        });
      } else {
        self.reAllAgentCodes = [];
      }
      if (self.AgentCodesMessagesStatus == false) {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
        });

        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: "post",
          url: "/Api/Report/ExportMasterShop",
          responseType: "arraybuffer",
          data: {
            AgentCode: isAllAgent ? self.reAllAgentCodes : self.reAgentCodes,
            ShopCode1: self.reShopCodes,
            ShopCode2: self.reShopCodes2,
            Department: self.reDepartments,
            ShopType: self.reShopTypeId,
            ShopGroup: self.shmShopGroupId,
            ShopPMType: self.shmShopPMType,
            Status: self.reShopStatus,
            ProvinceId: self.reProvinceId,
            AmperId: self.reAmpherId,
            SubAgentShopIds: self.pmrSubAgentShopCodes,
            SubAgentCodes: self.pmrSubAgentCodes,
            StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
            EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
            InActiveStatus: !self.reInActiveStatus,
            Reason: self.reReason
          }
        }).then(function (response) {
          if (response.status == "200") {
            var filename = "";
            var contentType = response.headers["content-type"];
            var disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            var fname = filename.split("RPT_")[1];

            //Save file
            var blob = new Blob([response.data], { type: contentType });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            // link.download = filename;
            link.download = "ข้อมูลร้านค้า_" + fname; //+ filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
          }
        }).catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }).then(function () {
          //self.formReset();
          KTApp.unblockPage();
        });
      }
      // else {
      //   self.AgentCodesMessagesStatus = true;
      //   return false;
      // }
    },
    SelectedAgentCodes: function SelectedAgentCodes(e) {
      var self = this;
      // self.reAgentCodes = [];
      // setTimeout(function() {
      //      alert(self.reAgentCodes);

      //      if(self.reAgentCodes.indexOf("99999999") > -1){

      //      self.reAgentCodesOptions.forEach((element) => {
      //       self.reAllAgentCodes.push(element.id);
      //       });

      //     }
      //     else{
      //       self.reAllAgentCodes = [];
      //     }

      //     alert(self.reAgentCodes);


      //   }, 100);
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      self.reAgentCodesOptions = [{ id: "", label: "Loading...", isDisabled: true }]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM", {
        province_id: [],
        department: self.reDepartments,
        agentCodes: [],
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          if (self.reDepartments.length == 0) {
            self.reAgentCodesOptions = [{ id: "99999999", label: "ทั้งหมด" }];
          } else {
            self.reAgentCodesOptions = [];
          }
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text,
              isDisabled: self.reAgentCodes[0] == "" ? true : false
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreDepartmentsOptions: function LoadreDepartmentsOptions(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.reDepartmentsOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reDepartmentsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreReasonOptions: function LoadreReasonOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select25Reason", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reReasonOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreShopTypeIdOptions: function LoadreShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadShopGroupIdOptions: function LoadShopGroupIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shmShopGroupIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadshmShopPMTypeOptions: function LoadshmShopPMTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Select2MasterShopTypePM", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shmShopPMTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreShopCodesOptions: function LoadreShopCodesOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;

      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        self.reShopCodesOptions = [];

        var inActiveStatus = null;
        if (self.reShopStatus == "true") inActiveStatus = false;else if (self.reShopStatus == "false") inActiveStatus = true;

        if (self.reAgentCodes.length > 0) {
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2BarButlerShop", {
            Page: 1,
            All: true,
            Search: searchQuery,
            AgentCodes: self.reAgentCodes,
            InActiveStatus: inActiveStatus
          }).then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reShopCodesOptions = [];
              data.forEach(function (element) {
                self.reShopCodesOptions.push({
                  id: element.id,
                  label: element.text
                });
              });
              callback(null, self.reShopCodesOptions);
            }
          }).catch(function (error) {});
        } else {
          console.log("else LoadreShopCodesOptions");
          self.reShopCodesOptions = [];
          callback(null, self.reShopCodesOptions);
        }
      }
    },

    updateValueAgentCodes: function updateValueAgentCodes(e) {
      this.reShopCodes = [];
      this.reShopCodesOptions = [];
      this.LoadreShopCodesOptions("ASYNC_SEARCH", "", null);
    },
    ClearAgentCodesOptions: function ClearAgentCodesOptions(e) {
      this.reAgentCodes = [];
    },
    FncreInActiveStatus: function FncreInActiveStatus(e) {
      // var options = [];
      $("#reShopStatus").html(null);
      if ($("#reInActiveStatus").is(":checked")) {
        $("#reShopStatus").select2({
          placeholder: "ทั้งหมด",
          allowClear: false,
          data: [{ id: true, text: "ร้านเปิด", data: null }]
        });
        this.reShopStatus = true;
      } else {
        $("#reShopStatus").select2({
          placeholder: "ทั้งหมด",
          allowClear: true,
          data: [{ id: true, text: "ร้านเปิด", data: null }, { id: false, text: "ร้านปิด", data: null }]
        });
        this.reShopStatus = true;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreAgentCodesOptions();
              self.LoadreDepartmentsOptions();
              self.LoadreReasonOptions();
              self.LoadreShopTypeIdOptions();
              self.LoadShopGroupIdOptions();
              self.LoadshmShopPMTypeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }
              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              // if( self.$root.canShow([ "ADMIN_PM", "AGENT_ADMIN_PM",  "COOL_SERVICE_PM", ]))

              $(_this.$refs.form).validate({
                rules: {
                  reAgentCodes: "required"
                },
                messages: {
                  reAgentCodes: "กรุณาเลือกตัวแทนจำหน่าย"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

              _this.$refs.reShopStatusSelect2.setSelectedData({
                id: true,
                text: "ร้านเปิด",
                data: null
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var ActionsOpenJob = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n    <a href=\"#\" @click.prevent=\"openJob\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E43\u0E1A\u0E07\u0E32\u0E19\u0E15\u0E49\u0E19\u0E17\u0E32\u0E07\">\n      <i class=\"la la-external-link\"></i>\n    </a>\n  ",
  methods: {
    openJob: function openJob() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });

      // Issue #35 (CR-Job-Stock 2026-06-03): WriteOff jobs ต้องเปิดหน้า View
      // ของ WriteOff โดยตรง (หน้า Edit generic ไม่รองรับ JobType นี้) — Job type
      // อื่นๆ ใช้ logic เดิม
      var rowData = this.data;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Jobs/GetJobId", {
        JobNumber: rowData.jobNumber
      }).then(function (response) {
        if (response.status == 200) {
          var url = rowData.jobTypeCode === "JOB_TYPE_WRITE_OFF_STOCK" ? "/Jobs/WriteOffStock/View/" + response.data : "/Jobs/Edit/" + response.data;
          window.open(url, "_blank");
        } else {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
        }
      }).catch(function (error) {
        // always executed
        KTApp.unblockPage();
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reOrderBy: null,
      reMmDateReq: null,
      reMmIsInitial: true,
      reMmBarcode: null,
      reMmDepartmentMaterialCode: [],
      reMmNFCCode: [],
      reMmTransactionDateStart: null,
      reMmTransactionDateEnd: null,

      reMmBarcodeOptions: {
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reMmDepartmentMaterialCodeOptions: [],
      reMmNFCCodeOptions: []
    };
  },
  computed: {
    IsShowDatePicker: function IsShowDatePicker() {
      var self = this;
      if (!self.reMmBarcode && !self.reMmDepartmentMaterialCode) {
        self.reMmTransactionDateStart = null;
        self.reMmTransactionDateEnd = null;

        $("#reMmTransactionDateStart").val("").trigger("change");

        $("#reMmTransactionDateEnd").val("").trigger("change");

        return true;
      }
      return false;
    }
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reMmBarcode = null;
      self.reMmDepartmentMaterialCode = [];
      self.reMmNFCCode = [];
      self.reMmTransactionDateStart = null;
      self.reMmTransactionDateEnd = null;

      $("#reMmBarcode").val("").trigger("change");

      $("#reMmDepartmentMaterialCode").val("").trigger("change");
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      if (!self.reMmBarcode && self.reMmDepartmentMaterialCode.length === 0 && !self.reMmTransactionDateStart && !self.reMmTransactionDateEnd) {
        Swal.fire('เกิดข้อผิดพลาด', 'กรุณาระบุเงื่อนไขรายงานอย่างน้อย 1 เงื่อนไข:<br>' + '1. BARCODE<br>' + '2. รหัสทรัพย์สิน(เบียร์สด)<br>' + '3. วันที่(เริ่มต้น) - วันที่(สิ้นสุด)', 'warning');
        return false;
      }

      if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
        return false;
      } else if (self.reMmTransactionDateStart && !self.reMmTransactionDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
        return false;
      }

      e.preventDefault();
      var table = $("#movementTable").DataTable();
      table.draw();
    },
    exportMovement: function exportMovement(e) {
      e.preventDefault();
      var self = this;

      if (!self.reMmBarcode && self.reMmDepartmentMaterialCode.length === 0 && !self.reMmTransactionDateStart && !self.reMmTransactionDateEnd) {
        Swal.fire('เกิดข้อผิดพลาด', 'กรุณาระบุเงื่อนไขรายงานอย่างน้อย 1 เงื่อนไข:<br>' + '1. BARCODE<br>' + '2. รหัสทรัพย์สิน(เบียร์สด)<br>' + '3. วันที่(เริ่มต้น) - วันที่(สิ้นสุด)', 'warning');
        return false;
      }

      if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
        return false;
      } else if (self.reMmTransactionDateStart && !self.reMmTransactionDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportMovement",
        responseType: "arraybuffer",
        data: {
          TransactionDateStart: self.reMmTransactionDateStart != null ? self.reMmTransactionDateStart.format("DD/MM/YYYY") : self.reMmTransactionDateStart,
          TransactionDateEnd: self.reMmTransactionDateEnd != null ? self.reMmTransactionDateEnd.format("DD/MM/YYYY") : self.reMmTransactionDateEnd,
          IsInitial: self.reMmIsInitial,
          Barcode: self.reMmBarcode,
          NFCCode: self.reMmNFCCode,
          DepartmentMaterialCode: self.reMmDepartmentMaterialCode,
          OrderByCollum: self.reOrderBy != null ? this.OrderName(self.reOrderBy[0][0]) : null,
          OrderBy: self.reOrderBy != null ? self.reOrderBy[0][1] : null
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        // Issue #59 (2026-06-10): responseType=arraybuffer → error.response.data
        //   เป็น ArrayBuffer (ไม่ใช่ JSON object) → ต้อง decode + parse ก่อน
        var msg = "เกิดข้อผิดพลาดขณะ Export";
        try {
          var raw = error && error.response && error.response.data;
          if (raw instanceof ArrayBuffer) {
            var text = new TextDecoder("utf-8").decode(new Uint8Array(raw));
            try {
              var parsed = JSON.parse(text);
              msg = parsed.Message || parsed.message || text || msg;
            } catch (e) {
              msg = text || msg;
            }
          } else if (raw && (raw.Message || raw.message)) {
            msg = raw.Message || raw.message;
          }
        } catch (e) {/* fallback to default msg */}
        Swal.fire("เกิดข้อผิดพลาด", msg, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    OrderName: function OrderName(e) {
      if (e == 0) {
        var collumName = 'TransactionDate';
      } else if (e == 1) {
        var collumName = 'TransactionDate';
      } else if (e == 2) {
        var collumName = 'BarcodeNoOld';
      } else if (e == 3) {
        var collumName = 'DepartmentMaterialCode';
      } else if (e == 4) {
        var collumName = 'ProductTypeName';
      } else if (e == 5) {
        var collumName = 'MaterialCode';
      } else if (e == 6) {
        var collumName = 'ProductBrandName';
      } else if (e == 7) {
        var collumName = 'JobNumber';
      } else if (e == 8) {
        var collumName = 'JobTypeName';
      } else if (e == 9) {
        var collumName = 'BarcodeStatusName';
      } else if (e == 10) {
        var collumName = 'OriginName';
      } else if (e == 11) {
        var collumName = 'DestinationName';
      } else if (e == 12) {
        var collumName = 'TransitCompanyName';
      } else if (e == 13) {
        var collumName = 'TransitCarReg';
      } else {
        var collumName = 'TransactionDate';
      }

      return collumName;
    },
    LoadreMmDepartmentMaterialCodeOptions: function LoadreMmDepartmentMaterialCodeOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.reMmDepartmentMaterialCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2DepartmentMaterial", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reMmDepartmentMaterialCodeOptions = [];
            data.forEach(function (element) {
              self.reMmDepartmentMaterialCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reMmDepartmentMaterialCodeOptions);
        }).catch(function (error) {});
      }
    },
    LoadreMmNFCCodeOptions: function LoadreMmNFCCodeOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.reMmNFCCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2NFC", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.reMmNFCCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reMmNFCCodeOptions);
        }).catch(function (error) {});
      }
    },

    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reMmDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reMmTransactionDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reMmTransactionDateStart = moment().set("date",1);
              $(self.$refs.reMmTransactionDateStart).datepicker("update", !!self.reMmTransactionDateStart ? self.reMmTransactionDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reMmTransactionDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reMmTransactionDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reMmTransactionDateEnd = moment().endOf('month');
              $(self.$refs.reMmTransactionDateEnd).datepicker("update", !!self.reMmTransactionDateEnd ? self.reMmTransactionDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reMmTransactionDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#movementTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/Movement",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      TransactionDateStart: self.reMmTransactionDateStart != null ? self.reMmTransactionDateStart.format("DD/MM/YYYY") : self.reMmTransactionDateStart,
                      TransactionDateEnd: self.reMmTransactionDateEnd != null ? self.reMmTransactionDateEnd.format("DD/MM/YYYY") : self.reMmTransactionDateEnd,
                      IsInitial: self.reMmIsInitial,
                      Barcode: self.reMmBarcode,
                      NFCCode: self.reMmNFCCode,
                      DepartmentMaterialCode: self.reMmDepartmentMaterialCode
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: self.reOrderBy = [[1, "desc"]],
                columns: [{
                  data: "transactionDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, {
                  data: "transactionDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.transactionDateString;
                  }
                }, { data: "barcodeNoOld", className: "text-center" }, { data: "departmentMaterialCode", className: "text-center" }, { data: "productTypeName", className: "text-center" }, {
                  data: "materialCode",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.materialCode + " " + full.materialName;
                  }
                }, { data: "productBrandName", className: "text-center" }, {
                  data: "jobNumber",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data + '<br><div class="actionsOpenJob"></div>';
                  }
                }, { data: "jobTypeName", className: "text-center" }, { data: "barcodeStatusName", className: "text-center" }, { data: "originName", className: "text-center" }, { data: "destinationName", className: "text-center" }, { data: "transitCompanyName", className: "text-center" }, { data: "transitCarReg", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reMmIsInitial = false;
                  self.reMmDateReq = moment().format("DD/MM/YYYY h:mm a");
                }
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.form, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.form);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionsOpenJob").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new ActionsOpenJob({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var simulateAsyncOperation = function simulateAsyncOperation(fn) {
  setTimeout(fn, 2000);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAaDateReq: null,
      reObjectivesCode: null,
      reStartDate: null,
      reEndDate: null,
      reIsInitial: true,
      reAgentCodes: [],
      reUserIds: [],
      reAgentCodesOptions: [],
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_MKT",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      reUserIdsOptions: [],
      // reUserIdsOptions: {
      //   placeholder: "กรุณาเลือกเจ้าหน้าที่",
      //   allowClear: false,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Users/Select2UserMkt",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reObjectivesCodeOptions: {
        placeholder: "กรุณาเลือก ประเภทงาน",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Report/Select2MktActivityType",
          data: function data(params) {
            var query = {
              search: "MKT_ACTIVITY_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reObjectivesCode = null;
      self.reAgentCodes = [];
      self.reUserIds = [];

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reObjectivesCode").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#reUserIds").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#NewShopOnOffPremiseTable").DataTable();
      table.draw();
    },
    exportQIGroupByAgent: function exportQIGroupByAgent(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportNewShopOnOffPremise",
        responseType: "arraybuffer",
        data: {
          StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
          EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
          AgentCodes: self.reAgentCodes,
          UserIds: self.reUserIds,
          ObjectivesCode: self.reObjectivesCode,
          IsInitial: self.reIsInitial
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_MKT", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    // LoadreUserIdsOptions: function(e) {
    //   var self = this;
    //   axios
    //     .post("/Api/Users/Select2UserMkt", {
    //       // search: params.term,
    //       page: 1,
    //       agentCodes: self.reAgentCodes,
    //     })
    //     .then(function(response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         self.reUserIdsOptions = [];
    //         data.forEach((element) => {
    //           self.reUserIdsOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function(error) {});
    // },
    LoadreUserIdsOptions: function LoadreUserIdsOptions(_ref) {
      var _this = this;

      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      if (action === "ASYNC_SEARCH") {
        simulateAsyncOperation(function () {
          var self = _this;
          var options = [];
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Users/Select2UserMkt", {
            // search: params.term,
            page: 1,
            search: searchQuery,
            agentCodes: self.reAgentCodes
          }).then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              // console.log(data)
              data.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.text
                });
              });
              callback(null, options);
            }
          }).catch(function (error) {});
        });
      }
    },

    reLoadreUserIdsOptions: function reLoadreUserIdsOptions() {
      this.$refs.reUserIds.trigger.searchQuery = null;
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this2;


              self.LoadreAgentCodesOptions();
              // self.LoadreUserIdsOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reEndDate = moment().endOf('month');
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#NewShopOnOffPremiseTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/NewShopOnOffPremise",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                      EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
                      AgentCodes: self.reAgentCodes,
                      UserIds: self.reUserIds,
                      ObjectivesCode: self.reObjectivesCode,
                      IsInitial: self.reIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[6, "desc"]],
                columns: [{
                  data: "activityDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "objectivesName", className: "text-center" }, { data: "userFullName", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "provinceName", className: "text-center" }, { data: "shopName", className: "text-center" }, {
                  data: "activityDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.activityDateString;
                  }
                }, { data: "productBrandName", className: "text-center" }, {
                  data: "qty",
                  className: "text-center",
                  render: function render(value) {
                    return self.$options.filters.currency(value, "", 0);
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this2.$refs.form).validate().settings.ignore = ":hidden";

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  watch: {
    reAgentCodes: function reAgentCodes() {
      //console.log(this.remdPhase);
      this.LoadreUserIdsOptions();
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAaDateReq: null,
      reStartDate: null,
      reEndDate: null,
      reDepartments: [],
      reAgentCodes: [],
      reIsInitial: true,
      reDepartmentsOptions: [],
      // reDepartmentsOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAgentCodesOptions: []
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reDepartments = [];
      self.reAgentCodes = [];

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reDepartments").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#5SByAgentTable").DataTable();
      table.draw();
    },
    LoadreDepartmentsOptions: function LoadreDepartmentsOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reDepartmentsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreDepartmentsOptions();
              self.LoadreAgentCodesOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#5SByAgentTable");

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/NotificationKPI",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                      EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
                      SalesArea: self.reDepartments,
                      AgentCodes: self.reAgentCodes,
                      IsInitial: self.reIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[2, "desc"]],
                columns: [{
                  data: "agentCode",
                  className: "text-center",
                  sortable: false,
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "agentName", className: "text-center" }, { data: "departments", className: "text-center" }, { data: "notificationNo", className: "text-center" }, { data: "createDateString", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {
      isExporting: false, // 2026-08-10: disable ปุ่ม Export ระหว่างประมวลผล (กันกดซ้ำ)
      rePMShopTypeId: [],
      shmShopGroupId: [],
      rePMProvinceId: null,
      rePMAmpherId: null,
      rePMShopName: null,
      reAaIsInitial: true,
      reAaDateReq: null,
      rePMAgentCode: [],
      rePMSubAgentCode: [],
      rePMRegion: [],
      rePMPMBrand: [],
      rePMShowImages: false, // CR-PM-ViewImage item 3: default ไม่ติ๊ก (ไม่แสดงรูป) — ไม่ cap, default 1 ของเดือน
      rePMDateStart: moment().startOf("month"), // item 3: default ไม่ติ๊ก = วันที่ 1 ของเดือนปัจจุบัน
      rePMDateEnd: moment(),
      rePMDateStartError: null,
      rePMDateEndError: null,
      rePMCreatedUserId: [],
      rePMNFC: [],
      rePMBarcode: null,
      reAaProductBrand: [],
      rePMMachineProductCode: [],
      rePMDisBarcode: null,
      rePMDispenserProductCode: [],
      rePMStatus: null,
      rePMBrand: []
    }, _defineProperty(_ref, "rePMBrand", []), _defineProperty(_ref, "rePMCreatedUserIdOptions", []), _defineProperty(_ref, "rePMBarcodeOptions", []), _defineProperty(_ref, "rePMMachineProductCodeOptions", []), _defineProperty(_ref, "rePMAgentCodeOptions", []), _defineProperty(_ref, "rePMRegionOptions", []), _defineProperty(_ref, "pmrSubAgentCodes", []), _defineProperty(_ref, "rePMSubAgentCodeOptions", []), _defineProperty(_ref, "pmrPmUserIdOptions", []), _defineProperty(_ref, "shmPMTypeId", []), _defineProperty(_ref, "shmPMTypeIdOptions", []), _defineProperty(_ref, "pmrPmUserIdOptions", {
      placeholder: "กรุณาเลือกผู้ดำเนินการ",
      allowClear: true,
      ajax: {
        url: "/Api/PM/Select2PmUser",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.rePMAgentCode,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "rePM3Options", {
      placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2Agent",
        type: "post",
        delay: 300,
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            province_id: [],
            department: [],
            AgentCodes: []
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      },
      templateResult: function templateResult(data) {
        return data.text;
      },
      language: {
        noResults: function noResults() {
          return "ไม่พบข้อมูลร้านค้า";
        }
      }
    }), _defineProperty(_ref, "rePMDisBarcodeOptions", []), _defineProperty(_ref, "rePMDispenserProductCodeOptions", []), _defineProperty(_ref, "rePMStatusOptions", {
      minimumResultsForSearch: -1,
      placeholder: "กรุณาเลือก Status",
      allowClear: true,
      data: [{
        id: false,
        text: "ร้านเปิด",
        data: null
      }, {
        id: true,
        text: "ร้านปิด",
        data: null
      }]
    }), _defineProperty(_ref, "rePMBrandOptions", []), _defineProperty(_ref, "rePMPMBrandOptions", []), _defineProperty(_ref, "rePMMachineType", []), _defineProperty(_ref, "rePMMachineOptions", [{
      id: "บริษัท",
      label: "บริษัท"
    }, {
      id: "เครื่องเช่า",
      label: "เครื่องเช่า"
    }, {
      id: "ส่วนบุคคล",
      label: "ส่วนบุคคล"
    }]), _defineProperty(_ref, "rePMDispenserType", []), _defineProperty(_ref, "rePMDispenserOptions", [{
      id: "บริษัท",
      label: "บริษัท"
    }, {
      id: "เครื่องเช่า",
      label: "เครื่องเช่า"
    }, {
      id: "ส่วนบุคคล",
      label: "ส่วนบุคคล"
    }]), _defineProperty(_ref, "rePMShopTypeIdOptions", []), _defineProperty(_ref, "shmShopGroupIdOptions", []), _defineProperty(_ref, "rePMProvinceIdOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/MasterLocation/Select2SearchProvince",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "rePMAmpherIdOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/MasterLocation/Select2SearchAmpher",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            provinceId: self.rePMProvinceId,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.rePMAgentCode = [];
      self.rePMRegion = [];
      self.rePMShowImages = false; // item 3: reset = ไม่ติ๊ก
      self.rePMDateStart = moment().startOf("month"); // item 3: default ไม่ติ๊ก = วันที่ 1 ของเดือน
      self.rePMDateEnd = moment();
      self.rePMCreatedUserId = [];
      self.rePMDateStartError = null;
      self.rePMDateEndError = null;
      self.rePMBarcode = null;
      self.rePMMachineProductCode = [];
      self.rePMDisBarcode = null;
      self.rePMDispenserProductCode = [];
      self.rePMStatus = null;
      self.rePMBrand = [];
      self.rePMPMBrand = [];
      self.rePMNFC = [];
      self.rePMMachineType = [];
      self.rePMDispenserType = [];
      self.rePMProvinceId = null;
      self.rePMAmpherId = null;
      self.rePMShopName = null;
      self.rePMShopTypeId = [];
      self.shmShopGroupId = [];
      self.rePMBarcode = null;
      self.shmPMTypeId = [];

      $("#rePMAmpherId").val("").trigger("change");

      $("#rePMProvinceId").val("").trigger("change");

      $("#rePMAgentCode").val("").trigger("change");

      $("#rePMRegion").val("").trigger("change");

      $("#rePM3").val("").trigger("change");

      $("#rePMCreatedUserId").val("").trigger("change");

      $("#reAaProductBrand").val("").trigger("change");

      $("#rePMMachineProductCode").val("").trigger("change");

      $("#rePMDispenserProductCode").val("").trigger("change");

      $("#rePMStatus").val("").trigger("change");

      $("#rePMBrand").val("").trigger("change");

      $("#rePMPMBrand").val("").trigger("change");

      // 2026-06-24 Bug fix: sync bootstrap-datepicker input DOM กับ Vue model
      //   เดิมตั้ง self.rePMDateStart = null แต่ datepicker ไม่ react → input ค้างค่าเดิม
      if (self.$refs.rePMDateStart) {
        $(self.$refs.rePMDateStart).datepicker("update", self.rePMDateStart.format("DD/MM/YYYY"));
      }
      if (self.$refs.rePMDateEnd) {
        $(self.$refs.rePMDateEnd).datepicker("update", self.rePMDateEnd.format("DD/MM/YYYY"));
      }

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();

      // 2026-06-24: required date validation (skip บน reset)
      if (innerText != "ล้างค่าทั้งหมด" && !self.validatePMDateRequired()) return;

      // 2026-08-25: ตัด confirm 180 วันออกตาม user → search ได้เลย (cap 7 วันตอนติ๊กแสดงรูปยังอยู่ใน validate)
      $("#pmTable").DataTable().draw();
    },

    // 2026-06-24: validate วันที่ทั้ง 2 ฟิลด์ — required
    //   อ่านค่าจาก input DOM โดยตรง — bootstrap-datepicker บางครั้ง changeDate event
    //   ไม่ทัน sync ลง Vue model ทำให้ self.rePMDateStart ยังเป็น null แม้ input มีค่า
    validatePMDateRequired: function validatePMDateRequired() {
      var self = this;
      // reset inline errors
      self.rePMDateStartError = null;
      self.rePMDateEndError = null;

      var startInputVal = self.$refs.rePMDateStart ? $(self.$refs.rePMDateStart).val().trim() : "";
      var endInputVal = self.$refs.rePMDateEnd ? $(self.$refs.rePMDateEnd).val().trim() : "";

      // Sync Vue model จาก DOM ถ้า out of sync (กัน .format() error ตอน DataTables ส่ง request)
      if (!self.rePMDateStart && startInputVal) {
        self.rePMDateStart = moment(startInputVal, "DD/MM/YYYY");
      }
      if (!self.rePMDateEnd && endInputVal) {
        self.rePMDateEnd = moment(endInputVal, "DD/MM/YYYY");
      }

      // item 2 (2026-08-24): required เฉพาะเมื่อ "แสดงรูปภาพ" (ติ๊ก) · ไม่ติ๊ก = วันที่ว่างได้ ไม่มี red → ใช้ confirm 180 วันแทน
      if (self.rePMShowImages) {
        var hasErr = false;
        if (!self.rePMDateStart) {
          self.rePMDateStartError = "กรุณาเลือกวันที่เริ่มต้น";
          hasErr = true;
        }
        if (!self.rePMDateEnd) {
          self.rePMDateEndError = "กรุณาเลือกวันที่สิ้นสุด";
          hasErr = true;
        }
        if (hasErr) return false;
      }

      // 2026-08-09: cap ช่วงไม่เกิน 7 วัน (checkDateRangeMax7 คืน true ถ้าไม่ติ๊ก)
      if (!self.checkDateRangeMax7()) return false;

      return true;
    },
    // 2026-08-09: เช็คช่วงไม่เกิน 7 วัน + alert — ใช้ทั้งตอน datechange และตอน validate (Generate/Export)
    checkDateRangeMax7: function checkDateRangeMax7() {
      var self = this;
      // item 3: cap 7 วัน เฉพาะเมื่อ "แสดงรูปภาพ" (ติ๊ก) · ไม่ติ๊ก = ไม่จำกัดวันที่
      if (!self.rePMShowImages) return true;
      if (!self.rePMDateStart || !self.rePMDateEnd) return true;
      var diffDays = moment(self.rePMDateEnd).startOf("day").diff(moment(self.rePMDateStart).startOf("day"), "days");
      if (diffDays > 7) {
        Swal.fire("แจ้งเตือน", "เลือกดูข้อมูลได้สูงสุดไม่เกิน 7 วัน เพื่อไม่ให้ส่งผลกระทบต่อการทำงานโดยรวมของระบบ กรุณาแก้ไขวันที่", "warning");
        return false;
      }
      return true;
    },
    // CR-PM-ViewImage item 3: toggle "แสดงรูปภาพ" → set default วันที่ตามโหมด
    onShowImagesChange: function onShowImagesChange() {
      var self = this;
      if (self.rePMShowImages) {
        self.rePMDateStart = moment().subtract(7, "days"); // แสดงรูป → ย้อนหลัง 7 วัน (+ cap 7 วัน)
      } else {
        self.rePMDateStart = moment().startOf("month"); // ไม่แสดงรูป → วันที่ 1 ของเดือน (ไม่ cap)
      }
      self.rePMDateEnd = moment();
      self.rePMDateStartError = null;
      self.rePMDateEndError = null;
      // A-01: sync ค่าเข้า datepicker UI (ไม่งั้น model เปลี่ยนแต่ input ค้างค่าเดิม) — pattern เดียวกับ formReset
      if (self.$refs.rePMDateStart) {
        $(self.$refs.rePMDateStart).datepicker("update", self.rePMDateStart.format("DD/MM/YYYY"));
      }
      if (self.$refs.rePMDateEnd) {
        $(self.$refs.rePMDateEnd).datepicker("update", self.rePMDateEnd.format("DD/MM/YYYY"));
      }
    },
    exportPM: function exportPM(e) {
      e.preventDefault();
      var self = this;

      // 2026-06-24: required date validation
      if (!self.validatePMDateRequired()) return;

      // CR-PM-2026 Perf: 2-stage progress message (image download phase อาจใช้เวลา 30-60s)
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังประมวลผลข้อมูล กรุณารอสักครู่..."
      });

      // Stage 2: switch ข้อความหลัง 8s (SQL ~3s + Excel write ~5s → เริ่ม download image)
      //   2026-09-01: ตั้ง timer เฉพาะเมื่อติ๊ก "รูปแบบแสดงรูปภาพ" — ไม่ติ๊ก = ไม่ฝังรูปใน Excel จึงไม่ควรขึ้น dialog ประมวลผลรูป
      var stage2Timer = self.rePMShowImages ? setTimeout(function () {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังประมวลผลรูปภาพ กรุณารอสักครู่..."
        });
      }, 8000) : null; // clearTimeout(null) = no-op → ท้าย axios ไม่ต้องแก้

      self.isExporting = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportPM",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.rePMAgentCode,
          SubAgentCode: self.rePMSubAgentCode,
          Department: self.rePMRegion,
          DateStart: self.rePMDateStart != null ? self.rePMDateStart.format("DD/MM/YYYY") : null,
          DateEnd: self.rePMDateEnd != null ? self.rePMDateEnd.format("DD/MM/YYYY") : null,
          ShowImages: self.rePMShowImages, // item 3: true=ฝัง thumbnail, false=data-only (คง link column)
          CreatedUserId: self.rePMCreatedUserId,
          NFCCode: self.rePMNFC,
          MachineBarcodeNo: self.rePMBarcode ? self.rePMBarcode.split(",").map(function (s) {
            return s.trim();
          }) : [],
          MachineProductCode: self.rePMMachineProductCode,
          DispenserBarcodeNo: self.rePMDisBarcode ? self.rePMDisBarcode.split(",").map(function (s) {
            return s.trim();
          }) : [],
          DispenserProductCode: self.rePMDispenserProductCode,
          InActive: self.rePMStatus,
          Brand: self.rePMBrand,
          PMBrand: self.rePMPMBrand,
          MachineType: self.rePMMachineType,
          DispenserType: self.rePMDispenserType,
          ShopTypeId: self.rePMShopTypeId,
          ShopGroupId: self.shmShopGroupId,
          ProvinceId: self.rePMProvinceId,
          AmpherId: self.rePMAmpherId,
          ShopName: self.rePMShopName,
          PMTypes: self.shmPMTypeId
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          var fname = filename.split("RPT_")[1];

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "รายงานข้อมูลการล้างเครื่องเบียร์สด(PM)_" + fname; //+ filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        clearTimeout(stage2Timer);
        KTApp.unblockPage();
        self.isExporting = false;
      });
    },
    // LoadrePMCreatedUserIdOptions: function(e) {
    //   var self = this;
    //   axios
    //     .get("/Api/Report/PM/UserNameOptions", {
    //       params: {
    //         page: 1,
    //         all: true,
    //       },
    //     })
    //     .then(function(response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         data.forEach((element) => {
    //           self.rePMCreatedUserIdOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function(error) {});
    // },

    LoadrePMBarcodeOptions: function LoadrePMBarcodeOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.rePMBarcodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2Barcode", {
          params: {
            page: 1,
            all: true,
            search: searchQuery,
            OnlyMachine: true
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.rePMBarcodeOptions = [];
            data.forEach(function (element) {
              self.rePMBarcodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.rePMBarcodeOptions);
        }).catch(function (error) {});
      }
    },

    LoadrePMMachineProductCodeOptions: function LoadrePMMachineProductCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          productTypeId: 3,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMMachineProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMSubAgentCodeOptions: function LoadrePMSubAgentCodeOptions(e) {
      var self = this;
      self.rePMSubAgentCodeOptions = [{ id: "", label: "Loading...", isDisabled: true }];
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2SubShopAgent", {
        agentCodes: self.rePMAgentCode,
        page: 1
      }).then(function (response) {

        if (response.status == 200) {
          self.rePMSubAgentCodeOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMSubAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMAgentCodeOptions: function LoadrePMAgentCodeOptions(e) {
      var self = this;
      self.rePMAgentCodeOptions = [{ id: "", label: "Loading...", isDisabled: true }];
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: self.rePMRegion,
        AgentCodes: [],
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          self.rePMAgentCodeOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMRegionOptions: function LoadrePMRegionOptions(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.rePMRegionOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMRegionOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMDisBarcodeOptions: function LoadrePMDisBarcodeOptions(_ref3) {
      var action = _ref3.action,
          searchQuery = _ref3.searchQuery,
          callback = _ref3.callback;

      var self = this;
      self.rePMDisBarcodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2Barcode", {
          params: {
            page: 1,
            all: true,
            search: searchQuery,
            OnlyDispenser: true
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.rePMDisBarcodeOptions = [];
            data.forEach(function (element) {
              self.rePMDisBarcodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.rePMDisBarcodeOptions);
        }).catch(function (error) {});
      }
    },

    LoadrePMDispenserProductCodeOptions: function LoadrePMDispenserProductCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          productTypeId: 6,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMDispenserProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMBrandOptions: function LoadrePMBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a //BrandOptions
      .get("/Api/Report/PM/ProductBrandOptions", {
        params: {
          page: 1,
          productTypeId: 6,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMPMBrandOptions: function LoadrePMPMBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a //PM/PMBrandOptions
      .get("/Api/Report/PM/ProductBrandOptions", {
        params: {
          page: 1,
          productTypeId: 6,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMPMBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    LoadShopTypeIdOptions: function LoadShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadPMTypeIdOptions: function LoadPMTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Select2MasterShopTypePM", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shmPMTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadShopGroupIdOptions: function LoadShopGroupIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shmShopGroupIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    onAmpherIdChange: function onAmpherIdChange() {
      $("#rePMAmpherId").val("").trigger("change");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              //self.LoadrePMCreatedUserIdOptions();

              self.LoadrePMMachineProductCodeOptions();
              self.LoadrePMAgentCodeOptions();
              self.LoadrePMRegionOptions();
              self.LoadrePMDispenserProductCodeOptions();
              self.LoadrePMBrandOptions();
              self.LoadrePMPMBrandOptions();
              self.LoadShopTypeIdOptions();
              self.LoadShopGroupIdOptions();
              self.LoadPMTypeIdOptions();

              self.rePMStatus = false;
              $("#rePMStatus").val("false").trigger("change");

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.rePMDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(_this.$refs.rePMDateStart).datepicker("setDate", _this.rePMDateStart.toDate());
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.rePMDateStart).datepicker("update", !!self.rePMDateStart ? self.rePMDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.rePMDateStart = e.dates.length != 0 ? moment(e.date) : null;
                self.checkDateRangeMax7();
              });

              $(self.$refs.rePMDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(_this.$refs.rePMDateEnd).datepicker("setDate", _this.rePMDateEnd.toDate());
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.rePMDateEnd).datepicker("update", !!self.rePMDateStart ? self.rePMDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.rePMDateEnd = e.dates.length != 0 ? moment(e.date) : null;
                self.checkDateRangeMax7();
              });

              table = $("#pmTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/PM",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var _jsonSearch;

                    var jsonSearch = (_jsonSearch = {
                      AgentCode: self.rePMAgentCode,
                      SubAgentCode: self.rePMSubAgentCode,
                      Department: self.rePMRegion,
                      DateStart: self.rePMDateStart != null ? self.rePMDateStart.format("DD/MM/YYYY") : null,
                      DateEnd: self.rePMDateEnd != null ? self.rePMDateEnd.format("DD/MM/YYYY") : null,
                      CreatedUserId: self.rePMCreatedUserId,
                      NFCCode: self.rePMNFC,
                      MachineBarcodeNo: self.rePMBarcode ? self.rePMBarcode.split(",").map(function (s) {
                        return s.trim();
                      }) : [],
                      MachineProductCode: self.rePMMachineProductCode,
                      DispenserBarcodeNo: self.rePMDisBarcode ? self.rePMDisBarcode.split(",").map(function (s) {
                        return s.trim();
                      }) : [],
                      DispenserProductCode: self.rePMDispenserProductCode,
                      InActive: self.rePMStatus,
                      Brand: self.rePMBrand,
                      PMBrand: self.rePMPMBrand,
                      MachineType: self.rePMMachineType,
                      DispenserType: self.rePMDispenserType,
                      IsInitial: self.reAaIsInitial
                    }, _defineProperty(_jsonSearch, "AgentCode", self.rePMAgentCode), _defineProperty(_jsonSearch, "ShopTypeId", self.rePMShopTypeId), _defineProperty(_jsonSearch, "ShopGroupId", self.shmShopGroupId), _defineProperty(_jsonSearch, "ProvinceId", self.rePMProvinceId), _defineProperty(_jsonSearch, "AmpherId", self.rePMAmpherId), _defineProperty(_jsonSearch, "ShopName", self.rePMShopName), _defineProperty(_jsonSearch, "PMTypes", self.shmPMTypeId), _jsonSearch);
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                // order: [[0, "desc"]],
                order: [[4, "desc"]],
                columns: [{ data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" }, {
                  data: "agentType",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.agentTypeName;
                  }
                }, { data: "department", className: "text-center" }, { data: "routePlanShopRunningNumber", className: "text-center" }, { data: "routeName", className: "text-center" }, { data: "createdUser", className: "text-center" }, { data: "shopCode", className: "text-center" }, {
                  data: "name1",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data.replace(/\s/g, '&nbsp;');
                  }
                }, {
                  data: "name2",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data.replace(/\s/g, '&nbsp;');
                  }
                }, {
                  data: "pmStartDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (full.agentType == "AGENT") return full.shopPMTypeName;else return full.subShopPMTypeName;
                  }
                }, { data: "shopTypeName", className: "text-center" }, { data: "shopGroupName", className: "text-center" },
                //  { data: "machineBarcodeNo", className: "text-center" },
                { data: "machineBarcodeNoOld", className: "text-center" }, { data: "machineProductName", className: "text-center" }, { data: "machineType", className: "text-center" },
                //{ data: "dispenserBarcodeNo", className: "text-center" },
                { data: "dispenserBarcodeNoOld", className: "text-center" }, { data: "dispenserProductName", className: "text-center" }, { data: "dispenserType", className: "text-center" }, { data: "brandString", className: "text-center" }, { data: "brandCount", className: "text-center" }, { data: "pmBrandString", className: "text-center" }, { data: "pmCount", className: "text-center" },
                // Issue #25: มาตรฐานการล้าง(วัน), วันที่ PM, วันที่ PM รอบถัดไป
                { data: "standardCleaningDays", className: "text-center" }, {
                  data: "pmStartDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.pmStartDateString;
                  }
                }, {
                  data: "nextPMDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data ? moment(data).format("DD/MM/YYYY") : "";
                  }
                }, {
                  // A-02: View & Download → เปิด gallery เดียวกับ Excel (mirror WritePMImageLink) — ไม่มีรูปครบ 3 = ไม่มี link
                  data: "cleanUpConnectFileInfoId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    var c = full.cleanUpConnectFileInfoId || "";
                    var d = full.cleanUpDisassembleFileInfoId || "";
                    var e = full.cleanUpExternalFileInfoId || "";
                    if (!c && !d && !e) return "";
                    var ids = [c, d, e].map(function (s) {
                      return encodeURIComponent(s);
                    }).join(",");
                    // redesign 2026-08-24: ร้านค้า = [code] name1 (name2 แยกไป shop2) + ตัวแทน/ประเภทเครื่อง-หัวจ่าย/BARCODE หัวจ่าย
                    var shop = ("[" + (full.shopCode || "") + "] " + (full.name1 || "")).trim();
                    // S1: machine bc/type + dispenser bc/type = group-aggregated (PMGalleryAggregate) → กด link row ไหนในกลุ่มก็ data ตรงกัน
                    var url = "/Api/File/ViewPMImages?ids=" + ids + "&shop=" + encodeURIComponent(shop) + "&barcode=" + encodeURIComponent(full.galleryMachineBarcode || "") + "&pmdate=" + encodeURIComponent(full.pmStartDateString || "") + "&user=" + encodeURIComponent(full.createdUser || "") + "&shop2=" + encodeURIComponent(("[" + (full.shopCode || "") + "] " + (full.name2 || "")).trim()) + "&agent=" + encodeURIComponent(full.agentName || "") + "&machinetype=" + encodeURIComponent(full.galleryMachineType || "") + "&dispenserbc=" + encodeURIComponent(full.galleryDispenserBarcodesCsv || "") + "&dispensertype=" + encodeURIComponent(full.galleryDispenserTypesCsv || "") + "&bsmid=" + encodeURIComponent(full.barcodeShopMappingId || ""); // I-3: gallery lookup Index → "ชุดที่ N"
                    return '<a href="' + url + '" target="_blank" style="color:#0563C1;font-weight:600;text-decoration:underline;">View &amp; Download</a>';
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reAaIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      reAaDateReq: null,
      reMonthCode: null,
      reAgentCodes: null,
      reUserId: null,
      reIsInitial: true,
      reDepartments: null,
      rePmaDateStart: null,
      rePmaDateEnd: null,
      reAgentCodesOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
              SalesAreaId: self.reDepartments
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      },
      reDepartmentsOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกเขตการขาย",
        allowClear: true,
        ajax: {
          url: "/Api/MasterSalesArea/FindOptions",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reUserIdOptions: {
        placeholder: "กรุณาเลือกชื่อช่าง",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Users/Select2User",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reMonthOptions: {
        placeholder: "กรุณาเลือก เดือน",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/PM/PMMonthlyOptions",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reMonthCode = null;
      self.reAgentCodes = null;
      self.reUserId = null;
      self.reDepartments = null;
      self.rePmaDateStart = null;
      self.rePmaDateEnd = null;

      $("#rePmaDateStart").val("").trigger("change");

      $("#rePmaDateEnd").val("").trigger("change");

      $("#reMonthCode").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#reUserId").val("").trigger("change");

      $("#reDepartments").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      e.preventDefault();
      var table = $("#MonthlyTable").DataTable();
      table.draw();
    },
    exportPMAlertSummary: function exportPMAlertSummary(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportPMAlertSummary",
        responseType: "arraybuffer",
        data: {
          IsInitial: false,
          SalesArea: self.reDepartments,
          Agentcode: self.reAgentCodes,
          StartDate: self.rePmaDateStart != null ? self.rePmaDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.rePmaDateEnd != null ? self.rePmaDateEnd.format("DD/MM/YYYY") : null
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    onDepartmentChange: function onDepartmentChange() {
      this.reAgentCodes = null;

      $("#reAgentCodes").val("").trigger("change");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.rePmaDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                //minDate: moment(), // Current day
                //maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateStart = moment().set("date",1);
              $(self.$refs.rePmaDateStart).datepicker("update", !!self.rePmaDateStart ? self.rePmaDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.rePmaDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.rePmaDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                //minDate: moment(), // Current day
                //maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateStart = moment().set("date",1);
              $(self.$refs.rePmaDateEnd).datepicker("update", !!self.rePmaDateEnd ? self.rePmaDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.rePmaDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#MonthlyTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/PMAlertSummary",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      IsInitial: self.reIsInitial,
                      SalesArea: self.reDepartments,
                      Agentcode: self.reAgentCodes,
                      StartDate: self.rePmaDateStart != null ? self.rePmaDateStart.format("DD/MM/YYYY") : null,
                      EndDate: self.rePmaDateEnd != null ? self.rePmaDateEnd.format("DD/MM/YYYY") : null
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[7, "desc"]],
                columns: [{
                  data: "department",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "salesAreaName", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "shopName", className: "text-center" }, { data: "shopName2", className: "text-center" }, {
                  data: "totalAlert",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data === null) {
                      return "0";
                    } else {
                      return data;
                    }
                  }
                }, {
                  data: "latestDateAlertString",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data === "") {
                      return "-";
                    } else {
                      return data;
                    }
                  }
                }, {
                  data: "totalChangeAlert",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data === null) {
                      return "0";
                    } else {
                      return data;
                    }
                  }
                }, {
                  data: "latestDateChangeAlertString",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data === "") {
                      return "-";
                    } else {
                      return data;
                    }
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  reMonthCode: "required"
                },
                messages: {
                  reMonthCode: "กรุณาเลือกเดือน"
                }
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {
      reAaDateReq: null,
      reMonthCode: null,
      reAgentCodes: null,
      reUserId: null,
      reIsInitial: true,
      reDepartments: null,
      reYear: null,

      pmrSubAgentCodes: null,
      pmrSubAgentCodeOptions: []

    }, _defineProperty(_ref, "pmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.reAgentCodes != null ? [self.reAgentCodes] : null,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reAgentCodesOptions", {
      placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2Agent",
        type: "post",
        delay: 300,
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            province_id: [],
            department: [],
            AgentCodes: [],
            SalesAreaId: self.reDepartments
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      },
      templateResult: function templateResult(data) {
        return data.text;
      },
      language: {
        noResults: function noResults() {
          return "ไม่พบข้อมูลร้านค้า";
        }
      }
    }), _defineProperty(_ref, "reDepartmentsOptions", {
      minimumResultsForSearch: -1,
      placeholder: "กรุณาเลือกเขตการขาย",
      allowClear: true,
      ajax: {
        url: "/Api/MasterSalesArea/FindOptions",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          };
          return query;
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reUserIdOptions", {
      placeholder: "กรุณาเลือกชื่อช่าง",
      allowClear: false,
      ajax: {
        type: "post",
        dataType: "json",
        contentType: "application/json",
        url: "/Api/Users/Select2UserGroupAgent2",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            agentCode: self.reAgentCodes,
            agentTypeCode: "AGENT"
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reSubAgentUserIdOptions", {
      placeholder: "กรุณาเลือกชื่อช่าง",
      allowClear: false,
      ajax: {
        type: "post",
        dataType: "json",
        contentType: "application/json",
        url: "/Api/Users/Select2UserGroupAgent2",
        data: function data(params) {
          var query = {
            search: params.term,
            page: params.page || 1,
            agentCode: self.reAgentCodes,
            subAgentCodes: self.reAgentCodes,
            agentTypeCode: "SUB_AGENT"
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref, "reMonthOptions", {
      placeholder: "กรุณาเลือกเดือน",
      allowClear: true,
      data: [{ id: "01", text: "January", data: null }, { id: "02", text: "February", data: null }, { id: "03", text: "March", data: null }, { id: "04", text: "April", data: null }, { id: "05", text: "May", data: null }, { id: "06", text: "June", data: null }, { id: "07", text: "July", data: null }, { id: "08", text: "August", data: null }, { id: "09", text: "September", data: null }, { id: "10", text: "October", data: null }, { id: "11", text: "November", data: null }, { id: "12", text: "December", data: null }]
    }), _defineProperty(_ref, "reYearOptions", {
      placeholder: "กรุณาเลือกปี",
      data: [
      // { id: new Date().getFullYear()+543, text: new Date().getFullYear()+543, data: null },
      // { id: new Date().getFullYear()+542, text: new Date().getFullYear()+542, data: null },
      // { id: new Date().getFullYear()+541, text: new Date().getFullYear()+541, data: null },
      // { id: new Date().getFullYear()+540, text: new Date().getFullYear()+540, data: null },
      // { id: new Date().getFullYear()+539, text: new Date().getFullYear()+539, data: null }
      {
        id: new Date().getFullYear(),
        text: new Date().getFullYear(),
        data: null
      }, {
        id: new Date().getFullYear() - 1,
        text: new Date().getFullYear() - 1,
        data: null
      }, {
        id: new Date().getFullYear() - 2,
        text: new Date().getFullYear() - 2,
        data: null
      }, {
        id: new Date().getFullYear() - 3,
        text: new Date().getFullYear() - 3,
        data: null
      }, {
        id: new Date().getFullYear() - 4,
        text: new Date().getFullYear() - 4,
        data: null
      }]
    }), _ref;
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reMonthCode = null;
      // self.reYear = null;
      self.reAgentCodes = null;
      self.reUserId = null;
      self.reDepartments = null;
      self.pmrSubAgentCodes = null;

      $("#reMonthCode").val("").trigger("change");

      // $("#reYear")
      //   .val("")
      //   .trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#pmrSubAgentCodes").val("").trigger("change");

      $("#reUserId").val("").trigger("change");

      $("#reDepartments").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.reMonthCode == null || self.reMonthCode == "" || self.reYear == null || self.reYear == "") {
        return false;
      }

      e.preventDefault();
      var table = $("#MonthlyTable").DataTable();
      table.draw();
    },
    onDepartmentChange: function onDepartmentChange() {
      this.reAgentCodes = null;

      $("#reAgentCodes").val("").trigger("change");

      this.pmrSubAgentCodes = null;

      $("#pmrSubAgentCodes").val("").trigger("change");
    },
    onReAgentCodesChange: function onReAgentCodesChange() {
      this.reUserId = null;

      $("#reUserId").val("").trigger("change");
    },
    onReSubAgentCodesChange: function onReSubAgentCodesChange() {
      this.reSubAgentUserId = null;

      $("#reSubAgentUserId").val("").trigger("change");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#MonthlyTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/PMMonthly",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      IsInitial: self.reIsInitial,
                      SalesArea: self.reDepartments,
                      Agentcode: self.reAgentCodes,
                      SubAgentCodes: self.pmrSubAgentCodes,
                      UserId: self.reUserId,
                      // DateCycle: self.reMonthCode,
                      DateCycle: self.reYear + "-" + self.reMonthCode
                      // Month: self.reMonthCode,
                      // Year: self.reYear,
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[6, "desc"]],
                columns: [{
                  data: "department",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "salesAreaName", className: "text-center" }, { data: "agenT_NAME", className: "text-center" }, {
                  data: "totalShop",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data === null) {
                      return "-";
                    } else {
                      return data;
                    }
                  }
                }, {
                  data: "totalPMAgent",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data === null) {
                      return "-";
                    } else {
                      return data;
                    }
                  }
                }, {
                  data: "alertNext",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data === 0) {
                      return "-";
                    } else {
                      return data;
                    }
                  }
                }, {
                  data: "alertBefore",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data === 0) {
                      return "-";
                    } else {
                      return data;
                    }
                  }
                }, {
                  data: "userName",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data === null) {
                      return "-";
                    } else {
                      return data;
                    }
                  }
                }, {
                  data: "totalPM",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data === null) {
                      return "-";
                    } else {
                      return data;
                    }
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  reMonthCode: "required",
                  reYear: "required"
                },
                messages: {
                  reMonthCode: "กรุณาเลือกเดือน",
                  reYear: "กรุณาเลือกปี"
                }
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref2;

    var self = this;
    var d = new Date();
    var current_month = d.getMonth() + 1;
    var current_year = d.getFullYear();

    return _ref2 = {
      AgentCodesMessages: "กรุณาเลือกตัวแทนจำหน่าย",
      AgentCodesMessagesStatus: false,
      reAaIsInitial: true,
      reDepartments: [],
      reAgentCodes: [],
      reShopTypeId: [],
      reType: null,
      reMonth: current_month,
      reYear: current_year,
      reShopStatus: '0',
      reProductBrandId: null,
      reUserIds: [],
      reUserIdsOptions: [],
      reUserStatus: null,
      brandHeaders: [],
      reDepartmentsOptions: [],

      reAgentCodesOptions: [],

      reShopCodes: [],
      reShopCodesOptions: [],

      pmrSubAgentCodes: [],
      pmrSubAgentCodeOptions: [],
      pmrSubAgentShopCodes: [],
      pmrSubAgentShopCodesOptions: [],

      rePMBrand: [],
      rePMBrandOptions: [],

      shmShopGroupId: [],
      shmShopGroupIdOptions: [],

      shmShopPMType: [],
      shmShopPMTypeOptions: [],

      rePMCreatedUserId: [],

      reActivityType: null,
      reActivityTypeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "0", text: "ไม่ทำ PM", data: null }, { id: "1", text: "ทำ PM", data: null }]
      },
      LoadreAPMCreatedUserIdOptions: function LoadreAPMCreatedUserIdOptions(_ref) {
        var action = _ref.action,
            searchQuery = _ref.searchQuery,
            callback = _ref.callback;

        if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
          var self = this;
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/AlertPM/UserOptions", {
            params: {
              page: 1,
              all: true
            }
          }).then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              var result = [];
              data.forEach(function (element) {
                result.push({
                  id: element.id,
                  label: element.text
                });
              });
            }
            callback(null, result);
          }).catch(function (error) {});
        }
      },

      LoadrePMCreatedUserIdOptions: {
        placeholder: "ชื่อ-สกุล ผู้ดำเนินการ ",
        allowClear: true,
        ajax: {
          url: "/Api/PM/Select2PmUser",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              agentCodes: self.rePMAgentCode,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      LoadshmShopPMTypeOptions: function LoadshmShopPMTypeOptions(e) {
        var self = this;
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Select2MasterShopTypePM", {
          params: {
            page: 1,
            all: true
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.shmShopPMTypeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
        }).catch(function (error) {});
      },
      LoadShopGroupIdOptions: function LoadShopGroupIdOptions(e) {
        var self = this;
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopGroup", {
          params: {
            page: 1,
            all: true
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.shmShopGroupIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
        }).catch(function (error) {});
      },
      reMonthOptions: {
        placeholder: "ทั้งหมด",
        allowClear: false,
        data: [{ id: "1", text: "January", data: null }, { id: "2", text: "February", data: null }, { id: "3", text: "March", data: null }, { id: "4", text: "April", data: null }, { id: "5", text: "May", data: null }, { id: "6", text: "June", data: null }, { id: "7", text: "July", data: null }, { id: "8", text: "August", data: null }, { id: "9", text: "September", data: null }, { id: "10", text: "October", data: null }, { id: "11", text: "November", data: null }, { id: "12", text: "December", data: null }]
      },
      reYearOptions: {
        placeholder: "กรุณาเลือก",
        data: [{
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }, {
          id: new Date().getFullYear() - 2,
          text: new Date().getFullYear() - 2,
          data: null
        }, {
          id: new Date().getFullYear() - 3,
          text: new Date().getFullYear() - 3,
          data: null
        }, {
          id: new Date().getFullYear() - 4,
          text: new Date().getFullYear() - 4,
          data: null
        }]
      },
      reShopStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "0", text: "ร้านเปิด", data: null }, { id: "1", text: "ร้านปิด", data: null }]
      },
      reUserStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "false", text: "ใช้งาน", data: null }, { id: "true", text: "ปิดใช้งาน", data: null }]
      },
      reProductBrandIdOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกแบรนด์สินค้า",
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reTypeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "PM", text: "PM", data: null }, { id: "QI", text: "QC", data: null }, { id: "MKT", text: "MKT", data: null }, { id: "MT", text: "MT", data: null }]
      }
    }, _defineProperty(_ref2, "pmrSubAgentShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      //pmrSubAgentCodes
      ajax: {
        url: "/Api/Shop/SubShopOptionAlertReport",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.reAgentCodes,
            shopCodes: self.pmrSubAgentCodes,
            search: params.term,
            page: params.page || 1,
            all: true
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref2, "pmrSubAgentCodeOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Report/Select2SubShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {

          var isAllAgent = false;
          if (self.reAgentCodes.indexOf("99999999") > -1) {
            isAllAgent = true;
            self.reAllAgentCodes = [];
            self.reAgentCodesOptions.forEach(function (element) {
              self.reAllAgentCodes.push(element.id);
            });
          } else {
            self.reAllAgentCodes = [];
          }

          var query = {
            agentCodes: isAllAgent ? self.reAllAgentCodes : self.reAgentCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _defineProperty(_ref2, "pmrShopCodesOptions", {
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Shop/Select2ShopAgent",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.reAgentCodes,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref2;
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      var d = new Date();
      var current_month = d.getMonth() + 1;
      var current_year = d.getFullYear();

      self.reDepartments = [];
      self.reAgentCodes = [];
      self.reShopTypeId = [];
      self.reMonth = current_month;
      self.reYear = current_year;
      self.reShopStatus = '0';
      self.reProductBrandId = null;
      self.reUserIds = [];
      self.reUserIdsOptions = [];
      self.reUserStatus = null;
      self.reShopCodes = [];
      self.pmrSubAgentCodes = [];
      self.pmrSubAgentShopCodes = [];
      self.rePMBrand = [];
      self.shmShopGroupId = [];
      self.shmShopPMType = [];
      self.rePMCreatedUserId = [];

      $("#reDepartments").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#reMonth").val(current_month).trigger("change");

      $("#reYear").val(current_year).trigger("change");

      $("#reShopStatus").val(self.reShopStatus).trigger("change");

      $("#rePMBrand").val("").trigger("change");

      $("#shmShopPMType").val("").trigger("change");

      $("#reShopStatus").val("").trigger("change");

      $("#rePMCreatedUserId").val("").trigger("change");

      $("#reUserStatus").val("").trigger("change");

      $("#reActivityType").val("").trigger("change");

      $("#pmrSubAgentCodes").val("").trigger("change");

      $("#pmrSubAgentShopCodes").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();

      var table = $("#SurveyTable").DataTable();
      table.draw();
    },
    exportMasterShop: function exportMasterShop(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportPMCalendar",
        responseType: "arraybuffer",
        data: {
          Year: self.reYear,
          Month: self.reMonth,
          AgentCode: self.reAgentCodes,
          ShopList: self.reShopCodes,
          SaleArea: self.reDepartments,
          ActivityType: self.reActivityType,
          SubAgentCode: self.pmrSubAgentCodes,
          SubAgentShopList: self.pmrSubAgentShopCodes,
          BrandList: self.rePMBrand,
          ShopStatus: self.reShopStatus,
          PMType: self.shmShopPMType,
          StatusTypeShop: self.shmShopGroupId,
          UserList: self.rePMCreatedUserId,
          UserStatus: self.reUserStatus
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          var fname = filename.split("RPT_")[1];

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "รายงานปฏิทินบันทึกงาน PM_" + fname; //+ filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    reLoadreAPMCreatedUserIdOptions: function reLoadreAPMCreatedUserIdOptions() {
      this.$refs.rePMCreatedUserId.trigger.searchQuery = null;
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    LoadreDepartmentsOptions: function LoadreDepartmentsOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reDepartmentsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      self.reAgentCodesOptions = [{ id: "", label: "Loading...", isDisabled: true }]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM", {
        province_id: [],
        department: self.reDepartments,
        agentCodes: [],
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          // if (self.reDepartments.length == 0) {
          //   self.reAgentCodesOptions = [{ id: "99999999", label: "ทั้งหมด" }];
          // } else {
          //   self.reAgentCodesOptions = [];
          // }
          self.reAgentCodesOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text,
              isDisabled: self.reAgentCodes[0] == "" ? true : false
            });
          });
        }
      }).catch(function (error) {});
    },
    updateValueAgentCodes: function updateValueAgentCodes(e) {
      this.reShopCodes = [];
      this.reShopCodesOptions = [];
      this.LoadreShopCodesOptions("ASYNC_SEARCH", "", null);
    },
    ClearAgentCodesOptions: function ClearAgentCodesOptions(e) {
      //this.reAgentCodes = [];
    },
    FncreInActiveStatus: function FncreInActiveStatus(e) {
      // var options = [];
      $("#reShopStatus").html(null);
      if ($("#reInActiveStatus").is(":checked")) {
        $("#reShopStatus").select2({
          placeholder: "ทั้งหมด",
          allowClear: false,
          data: [{ id: true, text: "ร้านเปิด", data: null }]
        });
        this.reShopStatus = true;
      } else {
        $("#reShopStatus").select2({
          placeholder: "ทั้งหมด",
          allowClear: true,
          data: [{ id: true, text: "ร้านเปิด", data: null }, { id: false, text: "ร้านปิด", data: null }]
        });
        this.reShopStatus = true;
      }
    },
    LoadrePMBrandOptions: function LoadrePMBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/PM/ProductBrandOptions", {
        //.get("/Api/Report/PM/BrandOptions", {
        params: {
          page: 1,
          productTypeId: 6,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMBrandOptions.push({
              id: element.data,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    PrevMonthClick: function PrevMonthClick(e) {
      var self = this;
      var currentDate = moment(self.reYear + '-' + self.reMonth + '-01');
      var prevMonth = moment(currentDate).add(-1, 'M');

      var d = new Date();
      var begin_year = d.getFullYear() - 4;

      if (self.reMonth + "-" + self.reYear == "1-" + begin_year) {
        Swal.fire("สิ้นสุดปีเริ่มต้น", "ข้อมูลถึงสิ้นปีเริ่มต้นแล้ว", "warning");
      } else {
        self.reYear = prevMonth.year();
        self.reMonth = prevMonth.month() + 1;

        $("#reMonth").val(prevMonth.month() + 1).trigger("change");

        $("#reYear").val(prevMonth.year()).trigger("change");

        this.formSubmit(e, "");
      }
    },
    NextMonthClick: function NextMonthClick(e) {
      var self = this;

      var d = new Date();
      var current_year = d.getFullYear();

      if (self.reMonth + "-" + self.reYear == "12-" + current_year) {
        Swal.fire("สิ้นสุดปีปัจจุบัน", "ข้อมูลถึงสิ้นปีปัจจุบันแล้ว", "warning");
      } else {
        var currentDate = moment(self.reYear + '-' + self.reMonth + '-01');
        var nextMonth = moment(currentDate).add(1, 'M');

        self.reYear = nextMonth.year();
        self.reMonth = nextMonth.month() + 1;

        $("#reMonth").val(self.reMonth).trigger("change");

        $("#reYear").val(self.reYear).trigger("change");

        this.formSubmit(e, "");
      }
    }

  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreDepartmentsOptions();
              self.LoadreAgentCodesOptions();
              self.LoadrePMBrandOptions();
              self.LoadShopGroupIdOptions();
              self.LoadshmShopPMTypeOptions();

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#SurveyTable");

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/PMCalendar",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      Year: self.reYear,
                      Month: self.reMonth,
                      AgentCode: self.reAgentCodes,
                      ShopList: self.reShopCodes,
                      SaleArea: self.reDepartments,
                      ActivityType: self.reActivityType,
                      SubAgentCode: self.pmrSubAgentCodes,
                      SubAgentShopList: self.pmrSubAgentShopCodes,
                      BrandList: self.rePMBrand,
                      ShopStatus: self.reShopStatus,
                      PMType: self.shmShopPMType,
                      StatusTypeShop: self.shmShopGroupId,
                      UserList: self.rePMCreatedUserId,
                      UserStatus: self.reUserStatus,
                      IsInitial: self.reAaIsInitial

                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[19, "desc"]],
                columns: [{ data: "agentTypeName", className: "text-center" }, {
                  data: "agentCode",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.shopTypeCode == "SHOP_SUB_AGENT" ? full.cusT_CODE : full.agentCode;
                  }
                }, {
                  data: "agentName",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.shopTypeCode == "SHOP_SUB_AGENT" ? full.shopName1 : full.agentName;
                  }
                }, { data: "shopTypeName", className: "text-center" }, { data: "department", className: "text-center" }, {
                  data: "cusT_CODE",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.shopTypeCode == "SHOP_SUB_AGENT" ? full.shoP_SUB_AGENT_CODE : full.cusT_CODE;
                  }
                }, {
                  data: "shopName1",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.shopTypeCode == "SHOP_SUB_AGENT" ? full.shoP_SUB_AGENT_SHOP_NAME : full.shopName1;
                  }
                }, {
                  data: "shopName2",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.shopTypeCode == "SHOP_SUB_AGENT" ? full.shoP_SUB_AGENT_SHOP_NAME2 : full.shopName2;
                  }
                }, { data: "shopGroupName", className: "text-center" }, { data: "shopPMTypeName", className: "text-center" }, { data: "address", className: "text-left" }, { data: "tumboL_NAME", className: "text-left" }, { data: "amphuR_NAME", className: "text-left" }, { data: "provincE_NAME", className: "text-left" }, { data: "zipCode", className: "text-center" }, { data: "changeDateString", className: "text-center" }, { data: "monthName", className: "text-center" }, { data: "year", className: "text-center" }, { data: "barcodeMappingBrands", className: "text-center" }, { data: "pmBrands", className: "text-center" }, { data: "fullName", className: "text-center" }, { data: "totalPM", className: "text-center" }, { data: "d01", className: "text-center" }, { data: "d02", className: "text-center" }, { data: "d03", className: "text-center" }, { data: "d04", className: "text-center" }, { data: "d05", className: "text-center" }, { data: "d06", className: "text-center" }, { data: "d07", className: "text-center" }, { data: "d08", className: "text-center" }, { data: "d09", className: "text-center" }, { data: "d10", className: "text-center" }, { data: "d11", className: "text-center" }, { data: "d12", className: "text-center" }, { data: "d13", className: "text-center" }, { data: "d14", className: "text-center" }, { data: "d15", className: "text-center" }, { data: "d16", className: "text-center" }, { data: "d17", className: "text-center" }, { data: "d18", className: "text-center" }, { data: "d19", className: "text-center" }, { data: "d20", className: "text-center" }, { data: "d21", className: "text-center" }, { data: "d22", className: "text-center" }, { data: "d23", className: "text-center" }, { data: "d24", className: "text-center" }, { data: "d25", className: "text-center" }, { data: "d26", className: "text-center" }, { data: "d27", className: "text-center" }, { data: "d28", className: "text-center" }, { data: "d29", className: "text-center" }, { data: "d30", className: "text-center" }, { data: "d31", className: "text-center" }],
                columnDefs: [{
                  targets: [7, 8, 9, 10] /* column index */
                  , orderable: false /* true or false */
                }],
                drawCallback: function drawCallback(settings) {
                  self.reAaIsInitial = false;
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      isShowFooter: false,
      reAaDateReq: null,
      reMonthCode: null,
      reDepartment: null,
      reAgentCode: null,
      reYear: null,
      reIsInitial: true,
      totalActRoutePlan: 0,
      totalEstRoutePlan: 0,
      totalPercentRoutePlan: 0,
      totalActAdhoc: 0,
      totalEstAdhoc: 0,
      totalPercentAdhoc: 0,
      //
      reAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
              SalesAreaId: self.reDepartment
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      },
      reDepartmentOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกเขตการขาย",
        allowClear: true,
        ajax: {
          url: "/Api/MasterSalesArea/FindOptions",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      // reMonthOptions: {
      //   placeholder: "กรุณาเลือก เดือน",
      //   allowClear: false,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/PM/PMRoutePlanOptions",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reMonthOptions: {
        placeholder: "กรุณาเลือกเดือน",
        allowClear: true,
        data: [{ id: "01", text: "January", data: null }, { id: "02", text: "February", data: null }, { id: "03", text: "March", data: null }, { id: "04", text: "April", data: null }, { id: "05", text: "May", data: null }, { id: "06", text: "June", data: null }, { id: "07", text: "July", data: null }, { id: "08", text: "August", data: null }, { id: "09", text: "September", data: null }, { id: "10", text: "October", data: null }, { id: "11", text: "November", data: null }, { id: "12", text: "December", data: null }]
      },
      reYearOptions: {
        placeholder: "กรุณาเลือกปี",
        data: [
        // { id: new Date().getFullYear()+543, text: new Date().getFullYear()+543, data: null },
        // { id: new Date().getFullYear()+542, text: new Date().getFullYear()+542, data: null },
        // { id: new Date().getFullYear()+541, text: new Date().getFullYear()+541, data: null },
        // { id: new Date().getFullYear()+540, text: new Date().getFullYear()+540, data: null },
        // { id: new Date().getFullYear()+539, text: new Date().getFullYear()+539, data: null }
        {
          id: new Date().getFullYear(),
          text: new Date().getFullYear(),
          data: null
        }, {
          id: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1,
          data: null
        }, {
          id: new Date().getFullYear() - 2,
          text: new Date().getFullYear() - 2,
          data: null
        }, {
          id: new Date().getFullYear() - 3,
          text: new Date().getFullYear() - 3,
          data: null
        }, {
          id: new Date().getFullYear() - 4,
          text: new Date().getFullYear() - 4,
          data: null
        }]
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reDepartment = null;
      self.reMonthCode = null;
      self.reAgentCode = null;
      self.reYear = null;

      $("#reAgentCode").val("").trigger("change");

      $("#reDepartment").val("").trigger("change");

      $("#reMonthCode").val("").trigger("change");

      $("#reYear").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#PMRoutePlanTable").DataTable();
      table.draw();
    },
    onDepartmentChange: function onDepartmentChange() {
      this.reAgentCode = null;

      $("#reAgentCode").val("").trigger("change");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reEndDate = moment().endOf('month');
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#PMRoutePlanTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/PMRoutePlan",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    self.isShowFooter = false;
                    self.totalActRoutePlan = 0;
                    self.totalEstRoutePlan = 0;
                    self.totalPercentRoutePlan = 0;
                    self.totalActAdhoc = 0;
                    self.totalEstAdhoc = 0;
                    self.totalPercentAdhoc = 0;

                    var jsonSearch = {
                      AgentCode: self.reAgentCode,
                      SalesArea: self.reDepartment,
                      Month: self.reMonthCode,
                      Year: self.reYear,
                      IsInitial: self.reIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[1, "asc"]],
                columns: [{
                  data: "department",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "department", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "month", className: "text-center" }, { data: "year", className: "text-center" }, { data: "estimateRoutePlan", className: "text-center" }, { data: "actualRoutePlan", className: "text-center" }, { data: "percentRoutePlan", className: "text-center" }, { data: "estimateAdhoc", className: "text-center" }, { data: "actualAdhoc", className: "text-center" }, { data: "percentAdhoc", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  var allPage = table.DataTable().page.info().pages;
                  var currentPage = table.DataTable().page.info().page + 1;

                  if (allPage == currentPage) {
                    self.isShowFooter = true;
                    self.totalActRoutePlan = settings.json.data[0].totalActRoutePlan;
                    self.totalEstRoutePlan = settings.json.data[0].totalEstRoutePlan;
                    self.totalPercentRoutePlan = settings.json.data[0].totalPercentRoutePlan;
                    self.totalActAdhoc = settings.json.data[0].totalActAdhoc;
                    self.totalEstAdhoc = settings.json.data[0].totalEstAdhoc;
                    self.totalPercentAdhoc = settings.json.data[0].totalPercentAdhoc;
                  }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;

    return {
      reAaDateReq: null,
      reStartDate: null,
      reEndDate: null,
      reDepartment: null,
      reAgentCode: null,
      reUserId: null,
      reIsInitial: true,
      reAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
              SalesAreaId: self.reDepartment
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      },
      reDepartmentOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกเขตการขาย",
        allowClear: true,
        ajax: {
          url: "/Api/MasterSalesArea/FindOptions",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reUserIdOptions: {
        placeholder: "กรุณาเลือกชื่อช่าง",
        allowClear: false,
        ajax: {
          type: "post",
          dataType: "json",
          contentType: "application/json",
          url: "/Api/Users/Select2UserGroupAgent2",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              agentCode: self.reAgentCode
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reAgentCode = null;
      self.reDepartment = null;
      self.reUserId = null;

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reAgentCode").val("").trigger("change");

      $("#reDepartment").val("").trigger("change");

      $("#reUserId").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#PMSpareTable").DataTable();
      table.draw();
    },
    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportPMSpare",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reAgentCode,
          SalesArea: self.reDepartment,
          UserId: self.reUserId,
          IsInitial: self.reIsInitial,
          MonthStart: self.reStartDate != null ? self.reStartDate.format("MM/YYYY") : self.reStartDate,
          MonthEnd: self.reEndDate != null ? self.reEndDate.format("MM/YYYY") : self.reEndDate
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    onDepartmentChange: function onDepartmentChange() {
      this.reAgentCode = null;

      $("#reAgentCode").val("").trigger("change");
    },
    onReAgentCodesChange: function onReAgentCodesChange() {
      this.reUserId = null;

      $("#reUserId").val("").trigger("change");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              /*$(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows,
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate)
                .datepicker(
                  "update",
                  !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
                )
                .on("changeDate", function(e) {
                  self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
                });*/

              $(self.$refs.reStartDate).datepicker({
                format: "mm/yyyy",
                viewMode: "months",
                minViewMode: "months",
                autoclose: true,
                clearBtn: true,
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                templates: arrows
              });
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              /*$(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows,
              });
              //self.reEndDate = moment().endOf('month');
              $(self.$refs.reEndDate)
                .datepicker(
                  "update",
                  !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
                )
                .on("changeDate", function(e) {
                  self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
                });*/

              $(self.$refs.reEndDate).datepicker({
                format: "mm/yyyy",
                viewMode: "months",
                minViewMode: "months",
                autoclose: true,
                clearBtn: true,
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                templates: arrows
              });
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#PMSpareTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/PMSpare",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      AgentCode: self.reAgentCode,
                      SalesArea: self.reDepartment,
                      UserId: self.reUserId,
                      IsInitial: self.reIsInitial,
                      MonthStart: self.reStartDate != null ? self.reStartDate.format("MM/YYYY") : null,
                      MonthEnd: self.reEndDate != null ? self.reEndDate.format("MM/YYYY") : null
                      /*StartDate:
                        self.reStartDate != null
                          ? self.reStartDate.format("DD/MM/YYYY")
                          : self.reStartDate,
                      EndDate:
                        self.reEndDate != null
                          ? self.reEndDate.format("DD/MM/YYYY")
                          : self.reEndDate,*/
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[3, "desc"]],
                columns: [{
                  data: "department",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "department", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "pmStartDateMonth", className: "text-center" }, { data: "pmStartDateYear", className: "text-center" },
                // {
                //   data: "pmStartDate",
                //   className: "text-center",
                //   render: function(data, type, full, meta) {
                //     return full.pmStartDateFormat;
                //   },
                // },
                { data: "materialName", className: "text-left" }, { data: "sumAmount", className: "text-center" }, { data: "fullName", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var _ref;

    var self = this;

    return _ref = {
      isExporting: false, // 2026-08-10: disable ปุ่ม Export ระหว่างประมวลผล (กันกดซ้ำ)
      rePMShopTypeId: [],
      shmShopGroupId: [],
      rePMShopName: null,
      reAaIsInitial: true,
      reAaDateReq: null,
      rePMAgentCode: [],
      rePMSubAgentCode: [],
      rePMAgentTypeCode: [],
      rePMRegion: [],
      rePMPMBrand: [],
      rePMShowImages: false, // CR-PM-ViewImage item 3: default ไม่ติ๊ก (ไม่แสดงรูป) — ไม่ cap, default 1 ของเดือน
      rePMDateStart: moment().startOf("month"), // item 3: default ไม่ติ๊ก = วันที่ 1 ของเดือนปัจจุบัน
      rePMDateEnd: moment(),
      rePMDateStartError: null,
      rePMDateEndError: null,
      rePMCreatedUserId: [],
      rePMNFC: [],
      rePMBarcode: null,
      reAaProductBrand: [],
      rePMMachineProductCode: [],
      //rePMDisBarcode: [],
      rePMDispenserProductCode: [],
      //rePMStatus: null,
      rePMBrand: [],
      rePMCreatedUserIdOptions: [],
      //rePMBarcodeOptions: [],
      rePMMachineProductCodeOptions: [],
      rePMAgentCodeOptions: [],
      rePMRegionOptions: [],

      pmrSubAgentCodes: [],
      rePMSubAgentCodeOptions: [],
      rePMTotDispenserOptions: [],
      rePMTotDispenser: [],
      rePMSurveyStatus: [],

      rePM3Options: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: []
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      },
      //rePMDisBarcodeOptions: [],
      rePMSurveyStatusOptions: [{
        id: "Y",
        label: "Survey PM เสร็จสิ้น"
      }, {
        id: "N",
        label: "ดำเนินการไม่สำเร็จ"
      }, {
        id: "P",
        label: "อยู่ระหว่างดำเนินการ"
      }, {
        id: "S",
        label: "ข้อมูลยังไม่สมบูรณ์"
      }]

    }, _defineProperty(_ref, "rePMTotDispenserOptions", [{
      id: "1",
      label: "1"
    }, {
      id: "2",
      label: "2"
    }, {
      id: "3",
      label: "3"
    }, {
      id: "4",
      label: "4"
    }, {
      id: "5",
      label: "5"
    }, {
      id: "6",
      label: "6"
    }, {
      id: "7",
      label: "7"
    }, {
      id: "8",
      label: "8"
    }, {
      id: "9",
      label: "9"
    }, {
      id: "10",
      label: "10"
    }]), _defineProperty(_ref, "rePMDispenserProductCodeOptions", []), _defineProperty(_ref, "rePMAgentTypeCodeOptions", [{
      id: "AGENT",
      label: "ตัวแทนจำหน่าย"
    }, {
      id: "SUB_AGENT",
      label: "ตัวแทนจำหน่ายย่อย"
    }]), _defineProperty(_ref, "rePMBrandOptions", []), _defineProperty(_ref, "rePMPMBrandOptions", []), _defineProperty(_ref, "rePMMachineType", []), _defineProperty(_ref, "rePMMachineOptions", [{
      id: "บริษัท",
      label: "บริษัท"
    }, {
      id: "เครื่องเช่า",
      label: "เครื่องเช่า"
    }, {
      id: "ส่วนบุคคล",
      label: "ส่วนบุคคล"
    }]), _defineProperty(_ref, "rePMDispenserType", []), _defineProperty(_ref, "rePMDispenserOptions", [{
      id: "บริษัท",
      label: "บริษัท"
    }, {
      id: "เครื่องเช่า",
      label: "เครื่องเช่า"
    }, {
      id: "ส่วนบุคคล",
      label: "ส่วนบุคคล"
    }]), _defineProperty(_ref, "rePMShopTypeIdOptions", []), _defineProperty(_ref, "shmShopGroupIdOptions", []), _defineProperty(_ref, "LoadrePMCreatedUserIdOptions", {
      placeholder: "ชื่อ-สกุลผู้ Survey ",
      allowClear: true,
      ajax: {
        url: "/Api/PM/Select2PmUser",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        data: function data(params) {
          var query = {
            agentCodes: self.rePMAgentCode,
            search: params.term,
            page: params.page || 1
          };
          return JSON.stringify(query);
        },
        processResults: function processResults(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function transport(params, success, failure) {
          params.beforeSend = function (request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    }), _ref;
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.rePMAgentCode = [];
      self.rePMRegion = [];
      self.rePMDateStart = moment().subtract(7, "days"); // 2026-08-09: default ย้อนหลัง 7 วัน (เหมือน PMCheckIn)
      self.rePMDateEnd = moment();
      self.rePMCreatedUserId = [];
      self.rePMDateStartError = null;
      self.rePMDateEndError = null;
      self.rePMBarcode = null;
      self.rePMMachineProductCode = [];
      //self.rePMDisBarcode = [];
      //self.rePMDispenserProductCode = [];
      //self.rePMStatus = null;
      self.rePMBrand = [];
      self.rePMPMBrand = [];
      self.rePMNFC = [];
      self.rePMMachineType = [];
      self.rePMDispenserType = [];
      self.rePMProvinceId = null;
      self.rePMAmpherId = null;
      self.rePMShopName = null;
      self.rePMShopTypeId = [];
      self.shmShopGroupId = [];
      self.rePMTotDispenser = [];

      self.rePMSubAgentCode = [];
      self.rePMAgentTypeCode = [];
      self.rePMShowImages = false; // item 3: reset = ไม่ติ๊ก
      self.rePMDateStart = moment().startOf("month"); // item 3: default ไม่ติ๊ก = วันที่ 1 ของเดือน
      self.rePMDateEnd = moment();
      $(self.$refs.rePMDateStart).datepicker("update", self.rePMDateStart.format("DD/MM/YYYY"));
      $(self.$refs.rePMDateEnd).datepicker("update", self.rePMDateEnd.format("DD/MM/YYYY"));
      self.rePMSurveyStatus = [];

      $("#rePMSurveyStatus").val("").trigger("change");

      $("#rePMTotDispenser").val("").trigger("change");

      $("#rePMSubAgentCode").val("").trigger("change");

      $("#rePMAgentTypeCode").val("").trigger("change");

      $("#rePMAgentCode").val("").trigger("change");

      $("#rePMRegion").val("").trigger("change");

      $("#rePM3").val("").trigger("change");

      $("#rePMCreatedUserId").val("").trigger("change");

      // $("#rePMBarcode")
      //   .val("")
      //   .trigger("change");

      $("#reAaProductBrand").val("").trigger("change");

      $("#rePMMachineProductCode").val("").trigger("change");

      //       $("#rePMDisBarcode")
      //         .val("")
      //         .trigger("change");
      // อ

      // $("#rePMStatus")
      //   .val("")
      //   .trigger("change");

      $("#rePMBrand").val("").trigger("change");

      $("#rePMPMBrand").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();

      if (innerText != "ล้างค่าทั้งหมด" && !self.validateDate()) return;

      // 2026-08-25: ตัด confirm 180 วันออกตาม user → search ได้เลย (cap 7 วันตอนติ๊กแสดงรูปยังอยู่ใน validateDate)
      $("#pmTable").DataTable().draw();
    },
    // item 2 (2026-08-24): required เฉพาะเมื่อ "แสดงรูปภาพ" (ติ๊ก) + cap 7 วัน · ไม่ติ๊ก = วันที่ว่างได้ (ไม่มี red) → ใช้ confirm 180 แทน
    validateDate: function validateDate() {
      var self = this;
      self.rePMDateStartError = null;
      self.rePMDateEndError = null;
      if (self.rePMShowImages) {
        var hasErr = false;
        if (!self.rePMDateStart) {
          self.rePMDateStartError = "กรุณาเลือกวันที่เริ่มต้น";
          hasErr = true;
        }
        if (!self.rePMDateEnd) {
          self.rePMDateEndError = "กรุณาเลือกวันที่สิ้นสุด";
          hasErr = true;
        }
        if (hasErr) return false;
      }
      // 2026-08-09: cap ช่วงไม่เกิน 7 วัน (checkDateRangeMax7 คืน true ถ้าไม่ติ๊ก)
      if (!self.checkDateRangeMax7()) return false;
      return true;
    },
    // 2026-08-09: เช็คช่วงไม่เกิน 7 วัน + alert — ใช้ทั้งตอน datechange และตอน validate (Generate/Export)
    checkDateRangeMax7: function checkDateRangeMax7() {
      var self = this;
      // item 3: cap 7 วัน เฉพาะเมื่อ "แสดงรูปภาพ" (ติ๊ก) · ไม่ติ๊ก = ไม่จำกัดวันที่
      if (!self.rePMShowImages) return true;
      if (!self.rePMDateStart || !self.rePMDateEnd) return true;
      var diffDays = moment(self.rePMDateEnd).startOf("day").diff(moment(self.rePMDateStart).startOf("day"), "days");
      if (diffDays > 7) {
        Swal.fire("แจ้งเตือน", "เลือกดูข้อมูลได้สูงสุดไม่เกิน 7 วัน เพื่อไม่ให้ส่งผลกระทบต่อการทำงานโดยรวมของระบบ กรุณาแก้ไขวันที่", "warning");
        return false;
      }
      return true;
    },
    // CR-PM-ViewImage item 3: toggle "แสดงรูปภาพ" → set default วันที่ตามโหมด + update datepicker
    onShowImagesChange: function onShowImagesChange() {
      var self = this;
      if (self.rePMShowImages) {
        self.rePMDateStart = moment().subtract(7, "days"); // แสดงรูป → ย้อนหลัง 7 วัน (+ cap 7 วัน)
      } else {
        self.rePMDateStart = moment().startOf("month"); // ไม่แสดงรูป → วันที่ 1 ของเดือน (ไม่ cap)
      }
      self.rePMDateEnd = moment();
      if (self.$refs.rePMDateStart) $(self.$refs.rePMDateStart).datepicker("update", self.rePMDateStart.format("DD/MM/YYYY"));
      if (self.$refs.rePMDateEnd) $(self.$refs.rePMDateEnd).datepicker("update", self.rePMDateEnd.format("DD/MM/YYYY"));
      self.rePMDateStartError = null;
      self.rePMDateEndError = null;
    },
    exportPM: function exportPM(e) {
      var _data;

      e.preventDefault();
      var self = this;

      // item 2 (2026-08-24): required (ถ้าติ๊กแสดงรูป) + cap 7 วัน
      if (!self.validateDate()) return;

      // CR-PM-2026 Perf: 2-stage progress message (image download phase อาจใช้เวลา 30-60s)
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังประมวลผลข้อมูล กรุณารอสักครู่..."
      });

      // Stage 2: switch ข้อความหลัง 8s (SQL ~3s + Excel write ~5s → เริ่ม download image)
      //   2026-09-01: ตั้ง timer เฉพาะเมื่อติ๊ก "รูปแบบแสดงรูปภาพ" — ไม่ติ๊ก = ไม่ฝังรูปใน Excel จึงไม่ควรขึ้น dialog ประมวลผลรูป
      var stage2Timer = self.rePMShowImages ? setTimeout(function () {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังประมวลผลรูปภาพ กรุณารอสักครู่..."
        });
      }, 8000) : null; // clearTimeout(null) = no-op → ท้าย axios ไม่ต้องแก้

      self.isExporting = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportPMSurvey",
        responseType: "arraybuffer",
        data: (_data = {
          AgentCode: self.rePMAgentCode,
          SubAgentCode: self.rePMSubAgentCode,
          AgentTypeCode: self.rePMAgentTypeCode,
          Department: self.rePMRegion,
          DateStart: self.rePMDateStart != null ? self.rePMDateStart.format("DD/MM/YYYY") : null,
          DateEnd: self.rePMDateEnd != null ? self.rePMDateEnd.format("DD/MM/YYYY") : null,
          ShowImages: self.rePMShowImages, // item 3: true=ฝัง thumbnail, false=data-only (คง link column)
          CreatedUserId: self.rePMCreatedUserId,
          MachineBarcodeNo: self.rePMBarcode,
          MachineProductCode: self.rePMMachineProductCode,
          DispenserBarcodeNo: self.rePMDisBarcode,
          DispenserProductCode: self.rePMDispenserProductCode,
          //InActive: self.rePMStatus,
          Brand: self.rePMBrand,
          PMBrand: self.rePMPMBrand,
          MachineType: self.rePMMachineType,
          DispenserType: self.rePMDispenserType,
          IsInitial: self.reAaIsInitial
        }, _defineProperty(_data, "AgentCode", self.rePMAgentCode), _defineProperty(_data, "ShopTypeId", self.rePMShopTypeId), _defineProperty(_data, "ShopGroupId", self.shmShopGroupId), _defineProperty(_data, "ShopName", self.rePMShopName), _defineProperty(_data, "WorkStatus", self.rePMSurveyStatus), _defineProperty(_data, "TotDispenserCleanUp", self.rePMTotDispenser), _data)
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          var fname = filename.split("RPT_")[1];

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "รายงานข้อมูลการ_Survey_PM_" + fname; //+ filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        clearTimeout(stage2Timer);
        KTApp.unblockPage();
        self.isExporting = false;
      });
    },
    LoadrePMMachineProductCodeOptions: function LoadrePMMachineProductCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          productTypeIds: "3,6",
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMMachineProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMSubAgentCodeOptions: function LoadrePMSubAgentCodeOptions(e) {
      var self = this;
      self.rePMSubAgentCodeOptions = [{ id: "", label: "Loading...", isDisabled: true }];
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2SubShopAgent", {
        agentCodes: self.rePMAgentCode,
        page: 1
      }).then(function (response) {

        if (response.status == 200) {
          self.rePMSubAgentCodeOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMSubAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMAgentCodeOptions: function LoadrePMAgentCodeOptions(e) {
      var self = this;
      self.rePMAgentCodeOptions = [{ id: "", label: "Loading...", isDisabled: true }];
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: self.rePMRegion,
        AgentCodes: [],
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          self.rePMAgentCodeOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMRegionOptions: function LoadrePMRegionOptions(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.rePMRegionOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMRegionOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    // LoadrePMDisBarcodeOptions({ action, searchQuery, callback }) {
    //   var self = this;
    //   self.rePMDisBarcodeOptions = [];
    //   if (action === ASYNC_SEARCH) {
    //     axios
    //       .get("/Api/Barcode/Select2Barcode", {
    //         params: {
    //           page: 1,
    //           all: true,
    //           search: searchQuery,
    //           OnlyDispenser: true,
    //         },
    //       })
    //       .then(function(response) {
    //         if (response.status == 200) {
    //           var data = response.data.results;
    //           self.rePMDisBarcodeOptions = [];
    //           data.forEach((element) => {
    //             self.rePMDisBarcodeOptions.push({
    //               id: element.id,
    //               label: element.text,
    //             });
    //           });
    //         }
    //         callback(null, self.rePMDisBarcodeOptions);
    //       })
    //       .catch(function(error) {});
    //   }
    // }, 
    LoadrePMBrandOptions: function LoadrePMBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/PM/ProductBrandOptions", {
        //.get("/Api/Report/PM/BrandOptions", {
        params: {
          page: 1,
          productTypeId: 6,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePMPMBrandOptions: function LoadrePMPMBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/PM/PMBrandOptions", {
        params: {
          page: 1,
          productTypeId: 6,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMPMBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    LoadShopTypeIdOptions: function LoadShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePMShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadShopGroupIdOptions: function LoadShopGroupIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.shmShopGroupIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
    // onAmpherIdChange: function() {
    //   $("#rePMAmpherId")
    //     .val("")
    //     .trigger("change");
    // },
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              //self.LoadrePMCreatedUserIdOptions();

              self.LoadrePMMachineProductCodeOptions();
              self.LoadrePMAgentCodeOptions();
              self.LoadrePMRegionOptions();
              self.LoadrePMBrandOptions();
              self.LoadrePMPMBrandOptions();
              self.LoadShopTypeIdOptions();
              self.LoadShopGroupIdOptions();

              // self.rePMStatus = false ;
              // $("#rePMStatus")
              //     .val("false")
              //     .trigger("change");


              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.rePMDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.rePMDateStart).datepicker("update", !!self.rePMDateStart ? self.rePMDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.rePMDateStart = e.dates.length != 0 ? moment(e.date) : null;
                self.checkDateRangeMax7();
              });
              $(_this.$refs.rePMDateStart).datepicker("setDate", _this.rePMDateStart.toDate());

              $(self.$refs.rePMDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reBcTransferJobCommitDateStart = moment().set("date",1);
              $(self.$refs.rePMDateEnd).datepicker("update", !!self.rePMDateStart ? self.rePMDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.rePMDateEnd = e.dates.length != 0 ? moment(e.date) : null;
                self.checkDateRangeMax7();
              });
              $(_this.$refs.rePMDateEnd).datepicker("setDate", _this.rePMDateEnd.toDate());

              table = $("#pmTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/PMSurvey",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var _jsonSearch;

                    var jsonSearch = (_jsonSearch = {
                      AgentCode: self.rePMAgentCode,
                      SubAgentCode: self.rePMSubAgentCode,
                      AgentTypeCode: self.rePMAgentTypeCode,
                      Department: self.rePMRegion,
                      DateStart: self.rePMDateStart != null ? self.rePMDateStart.format("DD/MM/YYYY") : null,
                      DateEnd: self.rePMDateEnd != null ? self.rePMDateEnd.format("DD/MM/YYYY") : null,
                      CreatedUserId: self.rePMCreatedUserId,
                      MachineBarcodeNo: self.rePMBarcode,
                      MachineProductCode: self.rePMMachineProductCode,
                      DispenserBarcodeNo: self.rePMDisBarcode,
                      DispenserProductCode: self.rePMDispenserProductCode,
                      //InActive: self.rePMStatus,
                      Brand: self.rePMBrand,
                      PMBrand: self.rePMPMBrand,
                      MachineType: self.rePMMachineType,
                      DispenserType: self.rePMDispenserType,
                      IsInitial: self.reAaIsInitial
                    }, _defineProperty(_jsonSearch, "AgentCode", self.rePMAgentCode), _defineProperty(_jsonSearch, "ShopTypeId", self.rePMShopTypeId), _defineProperty(_jsonSearch, "ShopGroupId", self.shmShopGroupId), _defineProperty(_jsonSearch, "ShopName", self.rePMShopName), _defineProperty(_jsonSearch, "WorkStatus", self.rePMSurveyStatus), _defineProperty(_jsonSearch, "TotDispenserCleanUp", self.rePMTotDispenser), _jsonSearch);
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                // order: [[0, "desc"]],
                order: [[4, "desc"]],
                columns: [{ data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" }, {
                  data: "agentType",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.agentTypeName;
                  }
                }, { data: "department", className: "text-center" },
                // { data: "pmStartDateString", className: "text-center" },
                {
                  data: "pmStartDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.pmStartDateString;
                  }
                },
                //{ data: "routePlanShopRunningNumber", className: "text-center" },
                { data: "routeName", className: "text-center" }, { data: "createdUser", className: "text-center" }, { data: "shopCode", className: "text-center" }, {
                  data: "name1",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data.replace(/\s/g, '&nbsp;');
                  }
                }, {
                  data: "name2",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return data.replace(/\s/g, '&nbsp;');
                  }
                }, { data: "machineBarcodeNoOldString", className: "text-center" }, { data: "machineProductNameString", className: "text-center" }, { data: "dispenserBarcodeNoOldString", className: "text-center" }, { data: "dispenserProductNameString", className: "text-center" }, { data: "otherBarcodeString", className: "text-center" }, { data: "pmBrandString", className: "text-center" }, { data: "brandCount", className: "text-center" }, { data: "workStatusDesc", className: "text-center" }, {
                  // A-02: View & Download → เปิด gallery Survey เดียวกับ Excel (mirror WritePMSurveyImageLink) — ไม่มีรูปเลย = ไม่มี link
                  data: "machineImageFileInfoIdsCsv",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    var escCsv = function escCsv(csv) {
                      return (csv || "").split(",").map(function (s) {
                        return s.trim();
                      }).filter(function (s) {
                        return s;
                      }).map(encodeURIComponent).join(",");
                    };
                    var machine = full.machineImageFileInfoIdsCsv || "";
                    var dispenser = full.dispenserImageFileInfoIdsCsv || "";
                    var other = full.otherImageFileInfoIdsCsv || "";
                    var connect = full.cleanUpConnectFileInfoId || "";
                    var disassemble = full.cleanUpDisassembleFileInfoId || "";
                    var external = full.cleanUpExternalFileInfoId || "";
                    if (!machine && !dispenser && !other && !connect && !disassemble && !external) return "";
                    // redesign 2026-08-24: ร้านค้า = [code] name1 (name2 แยกไป shop2) + ตัวแทน + caption ชื่อสินค้า ต่อรูป
                    var shop = ("[" + (full.shopCode || "") + "] " + (full.name1 || "")).trim();
                    var url = "/Api/File/ViewPMSurveyImages?machine=" + escCsv(machine) + "&dispenser=" + escCsv(dispenser) + "&other=" + escCsv(other) + "&connect=" + encodeURIComponent(connect) + "&disassemble=" + encodeURIComponent(disassemble) + "&external=" + encodeURIComponent(external) + "&shop=" + encodeURIComponent(shop) + "&barcode=" + encodeURIComponent(full.machineBarcodeNoOldString || "") + "&pmdate=" + encodeURIComponent(full.pmStartDateString || "") + "&user=" + encodeURIComponent(full.createdUser || "") + "&machinebc=" + escCsv(full.machineBarcodeNoOldString || "") + "&dispenserbc=" + escCsv(full.dispenserBarcodeNoOldString || "") + "&otherbc=" + escCsv(full.otherBarcodeString || "") + "&agent=" + encodeURIComponent(full.agentName || "") + "&shop2=" + encodeURIComponent(("[" + (full.shopCode || "") + "] " + (full.name2 || "")).trim()) + "&machinename=" + escCsv(full.machineProductNameString || "") + "&dispensername=" + escCsv(full.dispenserProductNameString || "");
                    return '<a href="' + url + '" target="_blank" style="color:#0563C1;font-weight:600;text-decoration:underline;">View &amp; Download</a>';
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reAaIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      LoadFrist: true,
      errors: [],
      columns: null,
      reOrderBy: null,
      reViewPermissionCode: null,
      reViewPermissionOptions: [],
      reDateReq: null,
      reIsInitial: true,
      reDateCycle: null,
      reStartDate: null,
      reEndDate: null,
      reBarcode: null,
      reProductTypeId: [],
      reProductTypeIdOptions: [],
      reProductCode: [],
      reProductCodeOptions: [],
      reProductBrandId: [],
      reProductBrandIdOptions: [],
      rePlantCode: [],
      rePlantCodeOptions: [],
      reAgentCode: [],
      reAgentCodeOptions: [],
      reSubAgentCode: [],
      reSubAgentCodeOptions: [],
      reShopCode: [],
      reShopCodeOptions: [],
      // reSaShopNameOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ShopQuery",
      //     data: function(params) {
      //       var query = {
      //         agentCode: self.reSaAgentCode,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reShopTypeId: [],
      reShopTypeIdOptions: [],
      reSalesAreaId: [],
      reSalesAreaIdOptions: [],
      reProvinceId: [],
      reProvinceIdOptions: [],
      reTransitId: [],
      reTransitIdOptions: [],
      reTransitType: [],
      reTransitTypeOptions: [],
      reScanUserId: [],
      reScanUserIdOptions: [],
      reTotalBarcode: 0,
      isLoadingOptions: true
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.reStartDate = null;
      self.reEndDate = null;
      self.reBarcode = null;
      self.reProductTypeId = [];
      self.reProductCode = [];
      self.reProductBrandId = [];
      self.rePlantCode = [];
      self.reAgentCode = [];
      self.reSubAgentCode = [];
      self.reShopCode = [];
      self.reSalesAreaId = [];
      self.reProvinceId = [];
      self.reTransitId = [];
      self.reTransitType = [];
      self.reScanUserId = [];

      $("#reStartDate").val("").trigger("change");
      $("#reEndDate").val("").trigger("change");
      $("#reBarcode").val("").trigger("change");
      $("#reProductTypeId").val("").trigger("change");
      $("#reProductCode").val("").trigger("change");
      $("#reProductBrandId").val("").trigger("change");
      $("#rePlantCode").val("").trigger("change");
      $("#reAgentCode").val("").trigger("change");
      $("#reSubAgentCode").val("").trigger("change");
      $("#reShopCode").val("").trigger("change");
      $("#reSalesAreaId").val("").trigger("change");
      $("#reProvinceId").val("").trigger("change");
      $("#reTransitId").val("").trigger("change");
      $("#reTransitType").val("").trigger("change");
      $("#reScanUserId").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formResetValue: function formResetValue(e) {
      var self = this;

      self.reStartDate = null;
      self.reEndDate = null;
      self.reBarcode = null;
      self.reProductTypeId = [];
      self.reProductCode = [];
      self.reProductBrandId = [];
      self.rePlantCode = [];
      self.reAgentCode = [];
      self.reSubAgentCode = [];
      self.reShopCode = [];
      self.reSalesAreaId = [];
      self.reProvinceId = [];
      self.reTransitId = [];
      self.reTransitType = [];
      self.reScanUserId = [];

      $("#reStartDate").val("").trigger("change");
      $("#reEndDate").val("").trigger("change");
      $("#reBarcode").val("").trigger("change");
      $("#reProductTypeId").val("").trigger("change");
      $("#reProductCode").val("").trigger("change");
      $("#reProductBrandId").val("").trigger("change");
      $("#rePlantCode").val("").trigger("change");
      $("#reAgentCode").val("").trigger("change");
      $("#reSubAgentCode").val("").trigger("change");
      $("#reShopCode").val("").trigger("change");
      $("#reSalesAreaId").val("").trigger("change");
      $("#reProvinceId").val("").trigger("change");
      $("#reTransitId").val("").trigger("change");
      $("#reTransitType").val("").trigger("change");
      $("#reScanUserId").val("").trigger("change");

      //this.formSubmit(e, "ล้างค่าทั้งหมด");
    },
    formSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var self, IsValidate, table;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;
                IsValidate = true;


                if (innerText == "ล้างค่าทั้งหมด") {
                  self.reIsInitial = true;
                } else {
                  self.errors = [];

                  // if (!self.reSalesAreaId || self.reSalesAreaId == undefined || self.reSalesAreaId == null || self.reSalesAreaId.length == 0) {
                  //   self.errors.push({ name: 'reSalesAreaId', text: 'กรุณาเลือกเขต' });
                  //   IsValidate = false;
                  // }

                  // if (!self.reProvinceId || self.reProvinceId == undefined || self.reProvinceId == null || self.reProvinceId.length == 0) {
                  //   self.errors.push({ name: 'reProvinceId', text: 'กรุณาเลือกจังหวัด' });
                  //   IsValidate = false;
                  // }

                  if (!self.reStartDate || self.reStartDate == undefined || self.reStartDate == null) {
                    self.errors.push({ name: 'reStartDate', text: 'กรุณาเลือกวันที่เริ่มต้น' });
                    IsValidate = false;
                  }

                  if (!self.reEndDate || self.reEndDate == undefined || self.reEndDate == null) {
                    self.errors.push({ name: 'reEndDate', text: 'กรุณาเลือกวันที่สิ้นสุด' });
                    IsValidate = false;
                  }
                  // if (!$(this.$refs.form).validate().form()) {
                  //   return false;
                  // }
                }

                if (!(IsValidate == true)) {
                  _context.next = 10;
                  break;
                }

                e.preventDefault();
                table = $("#PaymentProductTable").DataTable();
                _context.next = 8;
                return self.GenCollums(table, "submit");

              case 8:
                _context.next = 11;
                break;

              case 10:
                return _context.abrupt("return", IsValidate);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function formSubmit(_x) {
        return _ref.apply(this, arguments);
      }

      return formSubmit;
    }(),
    LoadrePlantCodeOptions: function LoadrePlantCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Plant/Select2Plant", {
        all: true,
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.rePlantCodeOptions = [];
          data.forEach(function (element) {
            self.rePlantCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreProductTypeIdOptions: function LoadreProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reProductTypeIdOptions = [];
          data.forEach(function (element) {
            self.reProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreProductCodeOptions: function LoadreProductCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reProductCodeOptions = [];
          data.forEach(function (element) {
            self.reProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreProductBrandIdOptions: function LoadreProductBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2ProductBrand", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reProductBrandIdOptions = [];
          data.forEach(function (element) {
            self.reProductBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodeOptions: function LoadreAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2AgentPaymentProduct", {
        SalesAreaId: self.reSalesAreaId,
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reAgentCodeOptions = [];
          data.forEach(function (element) {
            self.reAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreSubAgentCodeOptions: function LoadreSubAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2SubAgent", {
        SalesAreaId: self.reSalesAreaId,
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reSubAgentCodeOptions = [];
          data.forEach(function (element) {
            self.reSubAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreShopCodeOptions: _.debounce(function (_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      //this.$emit('activate', this.item)
      var self = this;
      if (action === "ASYNC_SEARCH") {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2ShopAgent", {
          Page: 1,
          All: true,
          Search: searchQuery,
          InActiveStatus: false,
          AgentCodes: self.reAgentCode,
          ShopCode: self.reSubAgentCode,
          RoleView: self.reViewPermissionCode
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reShopCodeOptions = [];
            data.forEach(function (element) {
              self.reShopCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
            callback(null, self.reShopCodeOptions);
          }
        }).catch(function (error) {});
      }
    }, 3000),
    resLoadreShopCodeOptions: function resLoadreShopCodeOptions() {
      this.$refs.reShopCode.trigger.searchQuery = null;
    },
    LoadreShopTypeIdOptions: function LoadreShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    // LoadreShopTypeIdOptions: function (e) {
    //   var self = this;
    //   axios
    //     .post("/Api/Report/Select2ShopAgentType", {
    //       page: 1,
    //       all: true,
    //       InActiveStatus: false,
    //       AgentCodes: self.reAgentCode,
    //       ShopCode: self.reSubAgentCode,
    //       RoleView: self.reViewPermissionCode
    //     })
    //     .then(function (response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         self.reShopTypeIdOptions = [];
    //         data.forEach((element) => {
    //           self.reShopTypeIdOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function (error) { });
    // },
    LoadreSalesAreaIdOptions: function LoadreSalesAreaIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/MasterSalesArea/Select2PaymentProduct", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reSalesAreaIdOptions = [];
          data.forEach(function (element) {
            self.reSalesAreaIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreProvinceIdOptions: function LoadreProvinceIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2PaymentProductProvince", {
        page: 1,
        all: true,
        salesAreaId: self.reSalesAreaId
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reProvinceIdOptions = [];
          data.forEach(function (element) {
            self.reProvinceIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTransitIdOptions: function LoadreTransitIdOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Transport/Select2Transport", {
        showVendorTransport: false,
        agentCodes: [],
        isShowPickup: false,
        page: 1,
        search: null,
        isShowAll: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reTransitIdOptions = [];
          data.forEach(function (element) {
            self.reTransitIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTransitTypeOptions: function LoadreTransitTypeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Transport/Select2TransportType", {
        showVendorTransport: false,
        agentCodes: [],
        isShowPickup: false,
        page: 1,
        search: null,
        isShowAll: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reTransitTypeOptions = [];
          data.forEach(function (element) {
            self.reTransitTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    reLoadreScanUserIdOptions: function reLoadreScanUserIdOptions() {
      this.$refs.reScanUserId.trigger.searchQuery = null;
    },
    LoadreScanUserIdOptions: function LoadreScanUserIdOptions(_ref3) {
      var callback = _ref3.callback;

      var self = this;
      self.reScanUserIdOptions = [];
      if (self.isLoadingOptions) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2ScanUser", {
          page: 1,
          search: null
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reScanUserIdOptions = [];
            data.forEach(function (element) {
              self.reScanUserIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
            self.isLoadingOptions = false;
          }
          callback(null, self.reScanUserIdOptions);
        });
      }
    },
    LoadreViewPermissionOptions: function LoadreViewPermissionOptions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ViewPermission", {}).then(function (response) {
                  if (response.status == 200) {
                    var data = response.data.results;
                    self.reViewPermissionOptions = [];
                    data.forEach(function (element) {
                      self.reViewPermissionOptions.push({
                        id: element.id,
                        label: element.text
                      });

                      if (element.data == "active") {
                        self.reViewPermissionCode = element.id;
                      }
                    });
                  }
                }).catch(function (error) {});

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    ChangeOptions: function ChangeOptions(type) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var self;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self = _this2;

                if (self.LoadFrist == false) {
                  if (type == "View") {
                    self.formResetValue();
                    self.LoadrePlantCodeOptions();
                    self.LoadreAgentCodeOptions();
                    self.LoadreSubAgentCodeOptions();
                    // self.LoadreShopCodeOptions();
                    self.LoadreSalesAreaIdOptions();
                    self.LoadreProvinceIdOptions();

                    // var table = $("#PaymentProductTable");
                    // await self.GenCollums(table);
                    // self.GetDataTable(table);
                    // self.LoadFrist = true;
                  } else if (type == "reSalesAreaId") {
                    self.LoadreProvinceIdOptions(); // จังหวัด
                    self.LoadreAgentCodeOptions(); // ตัวแทนจำหน่าย
                    self.LoadreSubAgentCodeOptions(); // ตัวแทนจำหน่ายย่อย
                    // self.LoadreShopCodeOptions(); // ร้านค้า
                  } else if (type == "reAgentCode") {
                    // self.LoadreShopCodeOptions();
                    //self.LoadreShopTypeIdOptions();
                  } else if (type == "reSubAgentCode") {
                    // self.LoadreShopCodeOptions();
                  } else if (type == "reShopCode") {
                    // self.LoadreShopCodeOptions();
                  }
                }

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    GenCollums: function GenCollums(table, action) {
      var self = this;
      self.columns = null;

      if (self.reViewPermissionCode == "AGENT_REPORT") {
        self.columns = [{ data: "jobId", className: "text-center", visible: false }, { data: "jobId", className: "text-center", visible: false }, {
          data: "agentCode",
          className: "text-center",
          render: function render(data, type, full, meta) {
            var t = table.DataTable();
            var page = t.page.info().start + 1;
            return page + meta.row;
          }
        },
        // { data: "plantCode", className: "text-center" },
        // { data: "plantName", className: "text-center" },
        // { data: "caR_REG", className: "text-center" },
        // { data: "companY_NAME", className: "text-center" },
        { data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "jobNumber", className: "text-center" }, { data: "cusT_CODE", className: "text-center" }, { data: "shopName", className: "text-center" }, { data: "shopName2", className: "text-center" }, { data: "shopTypeName", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "productCode", className: "text-center" }, { data: "productName", className: "text-center" }, { data: "productBrandName", className: "text-center" }, { data: "barcodeNoOld", className: "text-center" }, { data: "countBarcode", className: "text-center" }, { data: "scanDateString", className: "text-center" }, { data: "scanByUserName", className: "text-center" }];
      } else if (self.reViewPermissionCode == "SUB_AGENT_REPORT") {
        self.columns = [{
          data: "agentCode",
          className: "text-center",
          render: function render(data, type, full, meta) {
            var t = table.DataTable();
            var page = t.page.info().start + 1;
            return page + meta.row;
          }
        },
        // { data: "plantCode", className: "text-center" },
        // { data: "plantName", className: "text-center" },
        // { data: "caR_REG", className: "text-center" },
        // { data: "companY_NAME", className: "text-center" },
        { data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "cusT_CODE", className: "text-center" }, { data: "shopName", className: "text-center" }, { data: "jobNumber", className: "text-center" }, { data: "subAgentCode", className: "text-center" }, { data: "subAgentName", className: "text-center" }, { data: "subAgentName2", className: "text-center" }, { data: "shopTypeName", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "productCode", className: "text-center" }, { data: "productName", className: "text-center" }, { data: "productBrandName", className: "text-center" }, { data: "barcodeNoOld", className: "text-center" }, { data: "countBarcode", className: "text-center" }, { data: "scanDateString", className: "text-center" }, { data: "scanByUserName", className: "text-center" }];
      } else {
        self.columns = [{ data: "jobId", className: "text-center", visible: false }, { data: "jobId", className: "text-center", visible: false }, {
          data: "agentCode",
          className: "text-center",
          render: function render(data, type, full, meta) {
            var t = table.DataTable();
            var page = t.page.info().start + 1;
            return page + meta.row;
          }
        }, { data: "plantCode", className: "text-center" }, { data: "plantName", className: "text-center" }, { data: "jobNumber", className: "text-center" }, { data: "caR_REG", className: "text-center" }, { data: "companY_NAME", className: "text-center" }, { data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" },
        // { data: "cusT_CODE", className: "text-center" },
        // { data: "shopName", className: "text-center" },
        // { data: "shopTypeName", className: "text-center" },
        { data: "productTypeName", className: "text-center" }, { data: "productCode", className: "text-center" }, { data: "productName", className: "text-center" }, { data: "productBrandName", className: "text-center" }, { data: "barcodeNoOld", className: "text-center" }, { data: "countBarcode", className: "text-center" }, { data: "scanDateString", className: "text-center" }, { data: "scanByUserName", className: "text-center" }];
      }

      if (action == "submit") {
        table.clear();
        table.destroy();
        table = $("#PaymentProductTable");
        self.GetDataTable(table);
      }
    },
    GetDataTable: function GetDataTable(table) {
      var self = this;
      $.fn.dataTable.ext.errMode = 'none';
      table.DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/PaymentProduct",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function beforeSend(request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          },
          data: function data(d) {
            var jsonSearch = {
              IsInitial: self.reIsInitial,

              StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : null,

              EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : null,

              Barcode: self.reBarcode,
              ProductTypeId: self.reProductTypeId,
              ProductCode: self.reProductCode,
              ProductBrandId: self.reProductBrandId,
              PlantCode: self.rePlantCode,
              AgentCode: self.reAgentCode,
              SubAgentCode: self.reSubAgentCode,
              ShopCode: self.reShopCode,
              ShopTypeId: self.reShopTypeId,
              Region: self.reSalesAreaId,
              ProvinceId: self.reProvinceId,
              TransitId: self.reTransitId,
              TransitType: self.reTransitType,
              ScanUserId: self.reScanUserId,
              ViewPermissionCode: self.reViewPermissionCode
            };
            return JSON.stringify($.extend(d, jsonSearch));
          }
        },
        // DOM Layout settings
        dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
          // Issue 2 (2026-06-15): ตัด "(filtered from X total entries)" ออก
          //   เนื่องจาก backend ไม่ทำ unfiltered COUNT แล้ว
          infoFiltered: ""
        },
        // Order settings
        order: self.reOrderBy = [[17, "desc"]],
        columns: self.columns,
        drawCallback: function drawCallback(settings) {
          self.reIsInitial = false;
          self.reDateReq = moment().format("DD/MM/YYYY h:mm a");
          self.reTotalBarcode = 0;

          if (settings.json.data.length > 0) {
            var data = settings.json.data;
            data.forEach(function (element) {
              self.reTotalBarcode = self.reTotalBarcode + element.countBarcode;
            });
          }

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        }
      }).on("preXhr.dt", function () {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
        });
      }).on("xhr.dt", function () {
        KTApp.unblock(self.$refs.form);
      }).on("error.dt", function (e, settings, techNote, message) {
        __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
      }).on("draw.dt", function () {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });
    },

    ExportPaymentProduct: function ExportPaymentProduct(e) {
      e.preventDefault();
      var self = this;
      var IsValidate = true;
      self.errors = [];

      // if (!self.reSalesAreaId || self.reSalesAreaId == undefined || self.reSalesAreaId == null || self.reSalesAreaId.length == 0) {
      //   self.errors.push({ name: 'reSalesAreaId', text: 'กรุณาเลือกเขต' });
      //   IsValidate = false;
      // }

      // if (!self.reProvinceId || self.reProvinceId == undefined || self.reProvinceId == null || self.reProvinceId.length == 0) {
      //   self.errors.push({ name: 'reProvinceId', text: 'กรุณาเลือกจังหวัด' });
      //   IsValidate = false;
      // }

      if (!self.reStartDate || self.reStartDate == undefined || self.reStartDate == null) {
        self.errors.push({ name: 'reStartDate', text: 'กรุณาเลือกวันที่เริ่มต้น' });
        IsValidate = false;
      }

      if (!self.reEndDate || self.reEndDate == undefined || self.reEndDate == null) {
        self.errors.push({ name: 'reEndDate', text: 'กรุณาเลือกวันที่สิ้นสุด' });
        IsValidate = false;
      }

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      if (IsValidate == true) {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
        });

        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: "post",
          url: "/Api/Report/ExportPaymentProduct",
          responseType: "arraybuffer",
          data: {
            StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : null,

            EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : null,

            Barcode: self.reBarcode,
            ProductTypeId: self.reProductTypeId,
            ProductCode: self.reProductCode,
            ProductBrandId: self.reProductBrandId,
            PlantCode: self.rePlantCode,
            AgentCode: self.reAgentCode,
            SubAgentCode: self.reSubAgentCode,
            ShopCode: self.reShopCode,
            ShopTypeId: self.reShopTypeId,
            Region: self.reSalesAreaId,
            ProvinceId: self.reProvinceId,
            TransitId: self.reTransitId,
            TransitType: self.reTransitType,
            ScanUserId: self.reScanUserId,
            ViewPermissionCode: self.reViewPermissionCode
            // OrderByCollum: self.reOrderBy != null ? this.OrderName(self.reOrderBy[0][0]) : null,
            // OrderBy: self.reOrderBy != null ? self.reOrderBy[0][1] : null
          }
        }).then(function (response) {
          if (response.status == "200") {
            var filename = "";
            var contentType = response.headers["content-type"];
            var disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            var blob = new Blob([response.data], { type: contentType });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
          }
        }).catch(function (error) {
          // Issue 2 (2026-06-12): responseType=arraybuffer → error.response.data
          //   เป็น ArrayBuffer (ไม่ใช่ JSON object) → ต้อง decode + parse ก่อน
          //   ใช้สำหรับแสดง message จาก row-count guard (BadRequest)
          var msg = "เกิดข้อผิดพลาดขณะ Export";
          try {
            var raw = error && error.response && error.response.data;
            if (raw instanceof ArrayBuffer) {
              var text = new TextDecoder("utf-8").decode(new Uint8Array(raw));
              try {
                var parsed = JSON.parse(text);
                msg = parsed.Message || parsed.message || text || msg;
              } catch (e) {
                msg = text || msg;
              }
            } else if (raw && (raw.Message || raw.message)) {
              msg = raw.Message || raw.message;
            }
          } catch (e) {/* fallback to default msg */}
          Swal.fire("เกิดข้อผิดพลาด", msg, "error");
        }).then(function () {
          //self.formReset();
          KTApp.unblockPage();
        });
      }
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              self = _this3;
              _context4.next = 3;
              return self.LoadreViewPermissionOptions();

            case 3:
              self.LoadrePlantCodeOptions();
              self.LoadreProductTypeIdOptions();
              self.LoadreProductCodeOptions();
              self.LoadreProductBrandIdOptions();
              self.LoadreAgentCodeOptions();
              self.LoadreSubAgentCodeOptions();
              // self.LoadreShopCodeOptions();
              self.LoadreShopTypeIdOptions();
              self.LoadreSalesAreaIdOptions();
              self.LoadreProvinceIdOptions();
              self.LoadreTransitIdOptions();
              self.LoadreTransitTypeOptions();
              // self.LoadreScanUserIdOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reEndDate = moment().endOf('month');
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              table = $("#PaymentProductTable");
              _context4.next = 23;
              return self.GenCollums(table);

            case 23:
              self.GetDataTable(table);
              self.LoadFrist = false;

              // set validation rules
              $(_this3.$refs.form).validate({
                // rules: {
                //   // reSalesAreaId: "required",
                //   // reProvinceId: "required",
                //   reStartDate: "required",
                //   reEndDate: "required",
                // },
                // messages: {
                //   // reSalesAreaId: "กรุณาเลือกเขต",
                //   // reProvinceId: "กรุณาเลือกจังหวัด",
                //   reStartDate: "กรุณาเลือกวันที่เริ่มต้น",
                //   reEndDate: "กรุณาเลือกวันที่สิ้นสุด",
                // },
              });

              $(_this3.$refs.form).validate().settings.ignore = ":hidden";

            case 27:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this3);
    }))();
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      rePpIsInitial: true,
      rePpDateReq: null,
      rePpJobDateStart: null,
      rePpJobDateEnd: null,
      rePpJobNumber: null,
      rePpRemainingDays: null,
      rePpBarcode: null,
      rePpDepartmentMaterialCode: [],
      rePpNFC: [],
      rePpProductGroup: [],
      rePpProductType: [],
      rePpMaterialCode: [],
      rePpProductBrand: [],
      rePpPlant: [],
      rePpByUser: [],
      rePpBarcodeOptions: [],
      // rePpBarcodeOptions: {
      //   placeholder: "กรุณาเลือกBarcode",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2BarcodeAll",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpDepartmentMaterialCodeOptions: [],
      // rePpDepartmentMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสทรัพย์สินเบียร์สด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpNFCOptions: [],
      // rePpNFCOptions: {
      //   placeholder: "กรุณาเลือก NFCCode",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2NFC",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpProductGroupOptions: [],
      // rePpProductGroupOptions: {
      //   placeholder: "กรุณาเลือกหมวดสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpProductTypeOptions: [],
      // rePpProductTypeOptions: {
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpByUserOptions: [],
      // rePpByUserOptions: {
      //   placeholder: "กรุณาเลือกดำเนินการโดย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/ProduceProducts/Select2ByUser",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpPlantOptions: [],
      // rePpPlantOptions: {
      //   placeholder: "กรุณาเลือกโรงงานที่ผลิต",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/Select2SearchPlant",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpProductBrandOptions: [],
      // rePpProductBrandOptions: {
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePpMaterialCodeOptions: []
      // rePpMaterialCodeOptions: {
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.rePpJobDateStart = null;
      self.rePpJobDateEnd = null;
      self.rePpJobNumber = null;
      self.rePpRemainingDays = null;
      self.rePpBarcode = null;
      self.rePpDepartmentMaterialCode = [];
      self.rePpNFC = [];
      self.rePpProductGroup = [];
      self.rePpProductType = [];
      self.rePpMaterialCode = [];
      self.rePpProductBrand = [];
      self.rePpPlant = [];
      self.rePpByUser = [];

      $("#rePpJobDateStart").val("").trigger("change");

      $("#rePpJobDateEnd").val("").trigger("change");

      $("#rePpBarcode").val("").trigger("change");

      $("#rePpDepartmentMaterialCode").val("").trigger("change");

      $("#rePpProductGroup").val("").trigger("change");

      $("#rePpProductType").val("").trigger("change");

      $("#rePpMaterialCode").val("").trigger("change");

      $("#rePpProductBrand").val("").trigger("change");

      $("#rePpPlant").val("").trigger("change");

      $("#rePpByUser").val("").trigger("change");

      //this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      if (!self.rePpJobDateStart && self.rePpJobDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่เริ่มต้น", "warning");
        return false;
      } else if (self.rePpJobDateStart && !self.rePpJobDateEnd) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่สิ้นสุด", "warning");
        return false;
      }

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var status = null;
      // if(self.rePpDepartmentMaterialCode !=null){
      //   status = $("#rePpDepartmentMaterialCode").text();
      //   console
      // }

      e.preventDefault();
      var table = $("#produceProductTable").DataTable();
      table.draw();
    },
    exportProduceProducts: function exportProduceProducts(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportProduceProducts",
        responseType: "arraybuffer",
        data: {
          JobNumber: self.rePpJobNumber,
          JobDateStart: self.rePpJobDateStart != null ? self.rePpJobDateStart.format("DD/MM/YYYY") : self.rePpJobDateStart,
          JobDateEnd: self.rePpJobDateEnd != null ? self.rePpJobDateEnd.format("DD/MM/YYYY") : self.rePpJobDateEnd,
          RemainingDays: self.rePpRemainingDays,
          BarcodeNo: self.rePpBarcode,
          DepartmentMaterialCode: self.rePpDepartmentMaterialCode,
          NFCCode: self.rePpNFC,
          ProductGroup: self.rePpProductGroup,
          ProductType: self.rePpProductType,
          MaterialCode: self.rePpMaterialCode,
          ProductBrand: self.rePpProductBrand,
          ByUserId: self.rePpByUser,
          OriginPlantCode: self.rePpPlant,
          IsInitial: self.rePpIsInitial
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    // LoadrePpBarcodeOptions: function (e) {
    //   var self = this;
    //   axios
    //     .get("/Api/Barcode/Select2BarcodeAll", {
    //       params: {
    //         page: 1,
    //         all: true,
    //       },
    //     })
    //     .then(function (response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         data.forEach((element) => {
    //           self.rePpBarcodeOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function (error) { });
    // },
    LoadrePpDepartmentMaterialCodeOptions: function LoadrePpDepartmentMaterialCodeOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.rePpDepartmentMaterialCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2DepartmentMaterial", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.rePpDepartmentMaterialCodeOptions = [];
            data.forEach(function (element) {
              self.rePpDepartmentMaterialCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.rePpDepartmentMaterialCodeOptions);
        }).catch(function (error) {});
      }
    },
    LoadrePpNFCOptions: function LoadrePpNFCOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.rePpNFCOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2NFC", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.rePpNFCOptions = [];
            data.forEach(function (element) {
              self.rePpNFCOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.rePpNFCOptions);
        }).catch(function (error) {});
      }
    },

    LoadrePpProductGroupOptions: function LoadrePpProductGroupOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductGroup/Select2ProductGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePpProductGroupOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePpProductTypeOptions: function LoadrePpProductTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePpProductTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePpByUserOptions: function LoadrePpByUserOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/ProduceProducts/Select2ByUser", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePpByUserOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePpPlantOptions: function LoadrePpPlantOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Plant/Select2SearchPlant", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePpPlantOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePpProductBrandOptions: function LoadrePpProductBrandOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePpProductBrandOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePpMaterialCodeOptions: function LoadrePpMaterialCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePpMaterialCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              // self.LoadrePpBarcodeOptions();

              self.LoadrePpProductGroupOptions();
              self.LoadrePpProductTypeOptions();
              self.LoadrePpByUserOptions();
              self.LoadrePpPlantOptions();
              self.LoadrePpProductBrandOptions();
              self.LoadrePpMaterialCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.rePpDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.rePpJobDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.rePpJobDateStart).on("changeDate", function (e) {
                self.rePpJobDateStart = moment(e.date);
              });

              $(self.$refs.rePpJobDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.rePpJobDateEnd).on("changeDate", function (e) {
                self.rePpJobDateEnd = moment(e.date);
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#produceProductTable");
              // begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/ProduceProducts",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    self.isShowFooter = false;
                    self.TotalAmount = 0;

                    var jsonSearch = {
                      JobNumber: self.rePpJobNumber,
                      JobDateStart: self.rePpJobDateStart != null ? self.rePpJobDateStart.format("DD/MM/YYYY") : self.rePpJobDateStart,
                      JobDateEnd: self.rePpJobDateEnd != null ? self.rePpJobDateEnd.format("DD/MM/YYYY") : self.rePpJobDateEnd,
                      RemainingDays: self.rePpRemainingDays,
                      BarcodeNo: self.rePpBarcode,
                      DepartmentMaterialCode: self.rePpDepartmentMaterialCode,
                      NFCCode: self.rePpNFC,
                      ProductGroup: self.rePpProductGroup,
                      ProductType: self.rePpProductType,
                      MaterialCode: self.rePpMaterialCode,
                      ProductBrand: self.rePpProductBrand,
                      ByUserId: self.rePpByUser,
                      OriginPlantCode: self.rePpPlant,
                      IsInitial: self.rePpIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[2, "desc"]],
                columns: [{
                  data: "jobDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "jobNumber", className: "text-center" }, {
                  data: "jobDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.jobDateString;
                  }
                }, { data: "jobDateScanString", className: "text-center" }, { data: "monthScanString", className: "text-center" }, { data: "yearScan", className: "text-center" }, { data: "displayName", className: "text-center" }, { data: "originPlantName", className: "text-center" }, { data: "beerMonths", className: "text-center" }, {
                  data: "remainingDays",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data <= 0) {
                      return "หมดอายุ";
                    } else {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                  }
                }, {
                  data: "beerExpireDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.beerExpireDateString;
                  }
                }, { data: "barcodeNoOld", className: "text-center" }, { data: "departmentMaterialCode", className: "text-center" }, { data: "productGroupName", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "materialName", className: "text-center" }, { data: "productBrandName", className: "text-center" }],
                rowCallback: function rowCallback(row, data, index) {
                  if (data.remainingDays <= 0) {
                    $(row).find("td:eq(8)").css("color", "white");
                    $(row).find("td:eq(8)").css("background-color", "#EB355E");
                  }
                },
                //
                drawCallback: function drawCallback(settings) {
                  self.rePpIsInitial = false;
                  self.rePpDateReq = moment().format("DD/MM/YYYY h:mm a");

                  var allPage = table.DataTable().page.info().pages;
                  var currentPage = table.DataTable().page.info().page + 1;

                  if (allPage == currentPage) {
                    self.isShowFooter = true;
                    self.TotalAmount = settings.json.data[0].totalAmount;
                  }
                }
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.form, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.form);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      rePsIsInitial: true,
      rePsDateReq: null,
      rePsProductGroup: [],
      rePsProductType: [],
      rePsMaterialCode: [],
      rePsStatus: [],
      rePsPlantCode: [],
      rePsAgentCode: [],
      rePsForUserId: [],
      rePsData: [],

      rePsStatusOptions: [],

      // rePsStatusOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะ",
      //   //allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       console.log("rePsStatusOptions");
      //       console.log(data.results);
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsPlantCodeOptions: [],
      // rePsPlantCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกคลัง",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/Select2Plant",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         plantId: [],
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsAgentCodeOptions: [],
      // rePsAgentCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchAgentName",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: null,
      //         province_id: null,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsForUserIdOptions: [],
      // rePsForUserIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกพนักงาน",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/Select2PlantForUser",
      //     data: function(params) {
      //       var query = {
      //         isForUSer: true,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsProductGroupOptions: [],
      // rePsProductGroupOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsProductTypeOptions: [],
      // rePsProductTypeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePsMaterialCodeOptions: [],
      // rePsMaterialCodeOptions: {
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reViewPermissionCode: null,
      reViewPermissionOptions: [],
      reShop: [],
      reShopOptions: []
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.rePsProductGroup = [];
      self.rePsProductType = [];
      self.rePsMaterialCode = [];
      self.rePsStatus = [];
      self.rePsPlantCode = [];
      self.rePsAgentCode = [];
      self.rePsForUserId = [];
      self.reShop = [];

      $("#rePsProductGroup").val("").trigger("change");

      $("#rePsProductType").val("").trigger("change");

      $("#rePsMaterialCode").val("").trigger("change");

      $("#rePsStatus").val("").trigger("change");

      $("#rePsPlantCode").val("").trigger("change");

      $("#rePsAgentCode").val("").trigger("change");

      $("#rePsForUserId").val("").trigger("change");

      $("#reShop").val("").trigger("change");

      self.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#productStockTable").DataTable();
      table.draw();

      // KTApp.blockPage({
      //       opacity: 0.05,
      //       message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      // });

      // axios({
      // method: "post",
      // url: "/Api/Report/ProductStocks",
      // responseType: "application/json",
      // data: {
      //   ProductGroupId : self.rePsProductGroup,
      //   ProductTypeId : self.rePsProductType,
      //   MaterialCode : self.rePsMaterialCode,
      //   StatusCode : self.rePsStatus,
      //   PlantCode : self.rePsPlantCode,
      //   AgentCode :self.rePsAgentCode, //["1000001"],
      //   PlantUserId : self.rePsForUserId
      //   }
      // }).then(function(response) {
      //   if(response.status == "200"){
      //     self.rePsData = response.data.data;

      //     setTimeout(function() {

      //       var table = $("#productStockTable");
      //     var rows = table.find($("tr"));

      //     var colsLength = 3;//$(rows[0]).find($("td")).length;
      //     var removeLater = new Array();
      //     for(var i=0; i<colsLength; i++){
      //         var startIndex = 0;
      //         var lastIndex = 0;
      //         var startText = $($(rows[0]).find("td")[i]).text();
      //         //console.log($($(rows[0]).find("td")[i]));
      //         for(var j=1; j<rows.length; j++){
      //             var cRow =$(rows[j]);
      //             var cCol = $(cRow.find("td")[i]);
      //             var currentText = cCol.text();

      //             if(currentText==startText ){
      //                 removeLater.push(cCol);
      //                 lastIndex=j;
      //             }
      //             else{
      //                 var spanLength = lastIndex-startIndex;
      //                 if(spanLength>=1){
      //                     //console.log(lastIndex+" - "+startIndex)
      //                     //console.log($($(rows[startIndex]).find("td")[i]))
      //                     $($(rows[startIndex]).find("td")[i]).attr("rowspan",spanLength+1);
      //                 }

      //                 lastIndex = j;
      //                 startIndex = j;
      //                 startText = currentText;
      //             }

      //             //Set Row Total text bold
      //             if(startText.includes("Total")){
      //               $(rows[startIndex]).css('font-weight', 'bold');
      //             }
      //             if(i == 0 && startText.includes("Total")){
      //                 $(rows[startIndex]).css('background-color', '#bdd7ee');
      //                 $(rows[startIndex]).css('color', '#000000');
      //                 $(rows[startIndex]).find("td:eq(2)").text(' ');
      //                 $(rows[startIndex]).find("td:eq(1)").text(' ');
      //               }

      //              else if(i == 1 && startText.includes("Total")){
      //                 $(rows[startIndex]).css('background-color', '#F4B084');
      //                 $(rows[startIndex]).css('color', '#000000');
      //               }

      //              else if(i == 2 && startText.includes("Total")){
      //                 $(rows[startIndex]).css('background-color', '#FFF2CC');
      //                 $(rows[startIndex]).css('color', '#000000');
      //               }

      //         }

      //         //$(rows[lastIndex]).eq(i).before('<tr><td style="background-color:#bdd7ee ; color:#000000"><h5>' + startText + " Total " +'</h5></td></tr>');
      //         var spanLength = lastIndex-startIndex;
      //         if(spanLength>=1){
      //           //console.log(lastIndex+" - "+startIndex)
      //           //console.log($($(rows[startIndex]).find("td")[i]))
      //           $($(rows[startIndex]).find("td")[i]).attr("rowspan",spanLength+1);
      //           //$($(rows[startIndex]).find("td")[i]).before('<tr><td style="background-color:#bdd7ee ; color:#000000"><h5>' + startText + " Total " +'</h5></td></tr>');
      //         }

      //     }
      //     for(var i in removeLater){

      //         $(removeLater[i]).remove();
      //     }

      //     }, 50);

      //   }
      // }).catch(function(error) {
      //   Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      // }).then(function() {
      //   //self.formReset();
      //   KTApp.unblockPage();
      // });
    },
    exportProductStock: function exportProductStock(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportProductStocks",
        responseType: "arraybuffer",
        data: {
          ProductGroupId: self.rePsProductGroup,
          ProductTypeId: self.rePsProductType,
          MaterialCode: self.rePsMaterialCode,
          StatusCode: self.rePsStatus,
          PlantCode: self.rePsPlantCode,
          AgentCode: self.rePsAgentCode,
          PlantUserId: self.rePsForUserId,
          ViewPermissionCode: self.reViewPermissionCode,
          ShopCode: self.reShop
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadrePsPlantCodeOptions: function LoadrePsPlantCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Plant/Select2Plant", {
        plantId: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePsPlantCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePsAgentCodeOptions: function LoadrePsAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Agents/Select2SearchAgentName", {
        department: null,
        province_id: null,
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePsAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePsForUserIdOptions: function LoadrePsForUserIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Plant/Select2PlantForUser", {
        params: {
          isForUSer: true,
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePsForUserIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePsProductGroupOptions: function LoadrePsProductGroupOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductGroup/Select2ProductGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePsProductGroupOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePsProductTypeOptions: function LoadrePsProductTypeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePsProductTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePsMaterialCodeOptions: function LoadrePsMaterialCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePsMaterialCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadrePsStatusOptions: function LoadrePsStatusOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.rePsStatusOptions.push({
              id: element.id,
              label: element.text
            });
          });
          self.rePsStatus = ['PRODUCT_BARCODE_STATUS_READY'];
        }
      }).catch(function (error) {});
    },
    LoadreViewJobRetrieveOptions: function LoadreViewJobRetrieveOptions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var self;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ViewJobRetrieve", {}).then(function (response) {
                  if (response.status == 200) {
                    var data = response.data.results;
                    data.forEach(function (element) {
                      self.reViewPermissionOptions.push({
                        id: element.id,
                        label: element.text
                      });

                      if (element.data == "active") {
                        self.reViewPermissionCode = element.id;
                      }
                    });
                  }
                }).catch(function (error) {});

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    ChangeOptions: function ChangeOptions(type) {
      console.log("ChangeOptions");
      var self = this;
      if (self.LoadFrist == false) {
        if (type == "View") {
          self.formReset();
        }
      }
    },
    LoadShopOptions: function LoadShopOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2SubAgentStock", {
          page: 1,
          all: true,
          search: searchQuery
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reShopOptions = [];
            data.forEach(function (element) {
              self.reShopOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }

          callback(null, self.reShopOptions);
        }).catch(function (error) {});
      }
    },

    reLoadShopOptions: function reLoadShopOptions() {
      this.$refs.reShop.trigger.searchQuery = null;
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this2;


              self.LoadrePsPlantCodeOptions();
              self.LoadrePsAgentCodeOptions();
              self.LoadrePsForUserIdOptions();
              self.LoadrePsProductGroupOptions();
              self.LoadrePsProductTypeOptions();
              self.LoadrePsMaterialCodeOptions();
              self.LoadrePsStatusOptions();
              // self.$refs.rePsStatus.setSelectedData([
              //   { id: "PRODUCT_BARCODE_STATUS_READY", text: "พร้อมใช้งาน" }
              // ]);
              _context2.next = 10;
              return self.LoadreViewJobRetrieveOptions();

            case 10:
              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.rePsDateReq = moment().format("DD/MM/YYYY h:mm a");
              $.fn.dataTable.ext.errMode = 'none';
              table = $("#productStockTable");
              //begin first table

              table.DataTable({
                paging: false,
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/ProductStocks",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      IsInitial: self.rePsIsInitial,
                      ProductGroupId: self.rePsProductGroup,
                      ProductTypeId: self.rePsProductType,
                      MaterialCode: self.rePsMaterialCode,
                      StatusCode: self.rePsStatus,
                      PlantCode: self.rePsPlantCode,
                      AgentCode: self.rePsAgentCode,
                      PlantUserId: self.rePsForUserId,
                      ViewPermissionCode: self.reViewPermissionCode,
                      ShopCode: self.reShop
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                //orderFixed: [[0, 'asc'],[1, 'asc'],[2, 'asc'],[3, 'asc']],
                order: [[0, "desc"]],
                columns: [{
                  data: "locationName",
                  className: "text-center",
                  orderable: false,
                  width: "10%"
                }, {
                  data: "productGroupName",
                  className: "text-center",
                  orderable: false,
                  width: "10%"
                }, {
                  data: "productTypeName",
                  className: "text-center",
                  orderable: false,
                  width: "10%"
                }, {
                  data: "materialCode",
                  className: "text-center",
                  orderable: false,
                  width: "5%"
                }, {
                  data: "materialName",
                  className: "text-center",
                  orderable: false,
                  width: "15%"
                }, {
                  data: "singha",
                  className: "text-center",
                  orderable: false,
                  width: "5%",
                  render: function render(data, type, full, meta) {
                    if (data == 0) {
                      return "-";
                    } else {
                      return self.$options.filters.currency(data, "", 0);
                    }
                  }
                }, {
                  data: "leo",
                  className: "text-center",
                  orderable: false,
                  width: "5%",
                  render: function render(data, type, full, meta) {
                    if (data == 0) {
                      return "-";
                    } else {
                      return self.$options.filters.currency(data, "", 0);
                    }
                  }
                }, {
                  data: "asahi",
                  className: "text-center",
                  orderable: false,
                  width: "5%",
                  render: function render(data, type, full, meta) {
                    if (data == 0) {
                      return "-";
                    } else {
                      return self.$options.filters.currency(data, "", 0);
                    }
                  }
                }, {
                  data: "carlsberg",
                  className: "text-center",
                  orderable: false,
                  width: "5%",
                  render: function render(data, type, full, meta) {
                    if (data == 0) {
                      return "-";
                    } else {
                      return self.$options.filters.currency(data, "", 0);
                    }
                  }
                }, {
                  data: "kronenbourg",
                  className: "text-center",
                  orderable: false,
                  width: "5%",
                  render: function render(data, type, full, meta) {
                    if (data == 0) {
                      return "-";
                    } else {
                      return self.$options.filters.currency(data, "", 0);
                    }
                  }
                }, {
                  data: "kopper",
                  className: "text-center",
                  orderable: false,
                  width: "5%",
                  render: function render(data, type, full, meta) {
                    if (data == 0) {
                      return "-";
                    } else {
                      return self.$options.filters.currency(data, "", 0);
                    }
                  }
                }, {
                  data: "snowy",
                  className: "text-center",
                  orderable: false,
                  width: "5%",
                  render: function render(data, type, full, meta) {
                    if (data == 0) {
                      return "-";
                    } else {
                      return self.$options.filters.currency(data, "", 0);
                    }
                  }
                }, {
                  data: "fullMoon",
                  className: "text-center",
                  orderable: false,
                  width: "5%",
                  render: function render(data, type, full, meta) {
                    if (data == 0) {
                      return "-";
                    } else {
                      return self.$options.filters.currency(data, "", 0);
                    }
                  }
                }, {
                  data: "other",
                  className: "text-center",
                  orderable: false,
                  width: "5%",
                  render: function render(data, type, full, meta) {
                    if (data == 0) {
                      return "-";
                    } else {
                      return self.$options.filters.currency(data, "", 0);
                    }
                  }
                }, {
                  data: "grandTotal",
                  className: "text-center",
                  orderable: false,
                  width: "5%",
                  render: function render(data, type, full, meta) {
                    if (data == 0 && !full.locationName.includes("Total") && !full.productGroupName.includes("Total") && !full.productTypeName.includes("Total")) {
                      return '<span class="text-danger"> สต๊อกหมด</span>';
                    } else {
                      if (data == 0) {
                        return "-";
                      } else {
                        return self.$options.filters.currency(data, "", 0);
                      }
                    }
                  }
                }],
                rowCallback: function rowCallback(row, data, index) {
                  if (data.grandTotal < 0 && !data.locationName.includes("Total") && !data.productGroupName.includes("Total") && !data.productTypeName.includes("Total")) {
                    $(row).find("td:eq(14)").css("color", "white");
                    $(row).find("td:eq(14)").css("background-color", "#EB355E");
                  } else if (data.grandTotal < 0) {
                    $(row).find("td:eq(14)").css("color", "#EB355E");
                  }

                  // if (data.grandTotal < 0 && (data.locationName.includes("Total") || data.productGroupName.includes("Total") || data.productTypeName.includes("Total"))) {
                  //   $(row).find("td:eq(13)").css("color", "#EB355E");
                  // }

                  if (data.other < 0) {
                    $(row).find("td:eq(13)").css("color", "#EB355E");
                  }

                  if (data.fullMoon < 0) {
                    $(row).find("td:eq(12)").css("color", "#EB355E");
                  }

                  if (data.snowy < 0) {
                    $(row).find("td:eq(11)").css("color", "#EB355E");
                  }

                  if (data.kopper < 0) {
                    $(row).find("td:eq(10)").css("color", "#EB355E");
                  }

                  if (data.kronenbourg < 0) {
                    $(row).find("td:eq(9)").css("color", "#EB355E");
                  }

                  if (data.carlsberg < 0) {
                    $(row).find("td:eq(8)").css("color", "#EB355E");
                  }

                  if (data.asahi < 0) {
                    $(row).find("td:eq(7)").css("color", "#EB355E");
                  }

                  if (data.leo < 0) {
                    $(row).find("td:eq(6)").css("color", "#EB355E");
                  }

                  if (data.singha < 0) {
                    $(row).find("td:eq(5)").css("color", "#EB355E");
                  }

                  if (data.locationName.includes("Total")) {
                    // $(row)
                    //   .find("td:eq(0)").sty
                  }
                },
                drawCallback: function drawCallback(settings) {
                  self.rePsIsInitial = false;
                  self.rePsDateReq = moment().format("DD/MM/YYYY h:mm a");

                  if (settings.json.data.length === 0) {
                    return false;
                  }

                  var table = $("#productStockTable");
                  var rows = table.find($("tr"));

                  var colsLength = 3; //$(rows[0]).find($("td")).length;
                  var removeLater = new Array();
                  for (var i = 0; i < colsLength; i++) {
                    var startIndex = 0;
                    var lastIndex = 0;
                    var startText = $($(rows[0]).find("td")[i]).text();
                    //console.log($($(rows[0]).find("td")[i]));
                    for (var j = 1; j < rows.length; j++) {
                      var cRow = $(rows[j]);
                      var cCol = $(cRow.find("td")[i]);
                      var currentText = cCol.text();

                      if (currentText == startText) {
                        removeLater.push(cCol);
                        lastIndex = j;
                      } else {
                        var spanLength = lastIndex - startIndex;
                        if (spanLength >= 1) {
                          //console.log(lastIndex+" - "+startIndex)
                          //console.log($($(rows[startIndex]).find("td")[i]))
                          $($(rows[startIndex]).find("td")[i]).attr("rowspan", spanLength + 1);
                        }

                        lastIndex = j;
                        startIndex = j;
                        startText = currentText;
                      }

                      //Set Row Total text bold
                      if (startText.includes("Total")) {
                        $(rows[startIndex]).css("font-weight", "bold");
                      }
                      if (i == 0 && startText.includes("Total")) {
                        $(rows[startIndex]).css("background-color", "#bdd7ee");
                        $(rows[startIndex]).css("color", "#000000");
                        //$(rows[startIndex]).find("td:eq(0)").attr("colspan",3);
                        $(rows[startIndex]).find("td:eq(2)").text(" ");
                        $(rows[startIndex]).find("td:eq(1)").text(" ");
                      } else if (i == 1 && startText.includes("Total")) {
                        $(rows[startIndex]).css("background-color", "#F4B084");
                        $(rows[startIndex]).css("color", "#000000");
                      } else if (i == 2 && startText.includes("Total")) {
                        $(rows[startIndex]).css("background-color", "#FFF2CC");
                        $(rows[startIndex]).css("color", "#000000");
                      }
                    }

                    //$(rows[lastIndex]).eq(i).before('<tr><td style="background-color:#bdd7ee ; color:#000000"><h5>' + startText + " Total " +'</h5></td></tr>');
                    var spanLength = lastIndex - startIndex;
                    if (spanLength >= 1) {
                      //console.log(lastIndex+" - "+startIndex)
                      //console.log($($(rows[startIndex]).find("td")[i]))
                      $($(rows[startIndex]).find("td")[i]).attr("rowspan", spanLength + 1);
                      //$($(rows[startIndex]).find("td")[i]).before('<tr><td style="background-color:#bdd7ee ; color:#000000"><h5>' + startText + " Total " +'</h5></td></tr>');
                    }
                  }
                  for (var i in removeLater) {
                    $(removeLater[i]).remove();
                  }
                }
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.form, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.form);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this2.$refs.form).validate().settings.ignore = ":hidden";

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var simulateAsyncOperation = function simulateAsyncOperation(fn) {
  setTimeout(fn, 2000);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAaDateReq: null,
      reAverageScore: null,
      reStartDate: null,
      reEndDate: null,
      reIsInitial: true,
      reDepartments: [],
      reAgentCodes: [],
      reSubAgentCodes: [],
      reUserIds: [],
      reScores: [],
      reDepartmentsOptions: [],
      // reDepartmentsOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAgentCodesOptions: [],
      allAgentCodesOptions: [],
      reSubAgentCodesOptions: [],
      allSubAgentCodesOptions: [],
      SalerAreaId: [],
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_QI",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลตัวแทนจำหน่าย";
      //     },
      //   },
      // },
      reScoresOptions: [],
      // reScoresOptions: {
      //   placeholder: "กรุณาเลือกคะแนน QC",
      //   allowClear: false,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Variables/Options",
      //     data: function(params) {
      //       var query = {
      //         search: "QI_SCORE",
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reUserIdsOptions: [],
      reUserIdsOptionsData: []
      // reUserIdsOptions: {
      //   placeholder: "กรุณาเลือกเจ้าหน้าที่",
      //   allowClear: false,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Users/Select2UserQI",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reDepartments = [];
      self.SalerAreaId = [];
      self.reAgentCodes = [];
      self.reSubAgentCodes = [];
      self.reUserIds = [];
      self.reScores = [];
      self.reUserIdsOptions = [];
      self.reAverageScore = null;

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reDepartments").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#reUserIds").val("").trigger("change");

      $("#reScores").val("").trigger("change");

      self.LoadreAgentCodesOptions();
      self.LoadreSubAgentCodesOptions();

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#QIGroupByAgentTable").DataTable();
      table.draw();
    },
    exportQIGroupByAgent: function exportQIGroupByAgent(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportQIGroupByAgent",
        responseType: "arraybuffer",
        data: {
          StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
          EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
          Departments: self.reDepartments,
          AgentCodes: self.reAgentCodes,
          UserIds: self.reUserIds,
          Scores: self.reScores,
          SubAgentCodes: self.reSubAgentCodes,
          IsInitial: self.reIsInitial
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreDepartmentsOptions: function LoadreDepartmentsOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2QISalesArea", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reDepartmentsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2QIAgent", {
        AgentCodes: [],
        SalesAreaId: [],
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          var newOptions = [];
          data.forEach(function (element) {
            newOptions.push({
              id: element.id,
              label: element.text,
              salerAreaId: element.salesAreaId
            });
          });
          self.reAgentCodesOptions = newOptions;
          self.allAgentCodesOptions = newOptions;
        }
      }).catch(function (error) {});
    },
    LoadreScoresOptions: function LoadreScoresOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Variables/Options", {
        params: {
          search: "QI_SCORE",
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reScoresOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreUserIdsOptions: function LoadreUserIdsOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      if (action == "ASYNC_SEARCH") {
        simulateAsyncOperation(function () {
          __WEBPACK_IMPORTED_MODULE_3_axios___default()({
            method: "post",
            url: "/Api/Users/Select2QIGroupByAgent",
            data: {
              page: 1,
              search: searchQuery,
              SalesAreaIds: self.reDepartments,
              AgentCodes: self.reAgentCodes,
              all: true
            }
          }).then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reUserIdsOptions = [];
              data.forEach(function (element) {
                self.reUserIdsOptions.push({
                  id: element.id,
                  label: element.text
                });
              });
              callback(null, self.reUserIdsOptions);
            }
          }).catch(function (error) {});
        });
      }
    },

    reLoadreUserIdsOptions: function reLoadreUserIdsOptions() {
      this.$refs.reUserIds.trigger.searchQuery = null;
    },
    DepartmentSelect: function DepartmentSelect(e) {
      var _this = this;

      var self = this;
      this.SalerAreaId.push({ id: e.id });
      this.reAgentCodesOptions = [];
      this.SalerAreaId.forEach(function (value) {
        _this.allAgentCodesOptions.forEach(function (element) {
          if (element.salerAreaId == value.id) {
            _this.reAgentCodesOptions.push({
              id: element.id,
              label: element.label,
              salerAreaId: element.salerAreaId
            });
          }
        });
      });
      this.$nextTick(function () {
        self.LoadreSubAgentCodesOptions();
      });
    },
    DepartmentDeselect: function DepartmentDeselect(e) {
      var _this2 = this;

      var self = this;
      this.SalerAreaId = this.SalerAreaId.filter(function (value) {
        return value.id !== e.id;
      });
      if (this.SalerAreaId.length == 0) {
        this.reAgentCodesOptions = this.allAgentCodesOptions;
      } else {
        this.reAgentCodesOptions = [];
        this.SalerAreaId.forEach(function (value) {
          _this2.allAgentCodesOptions.forEach(function (element) {
            if (element.salerAreaId == value.id) {
              _this2.reAgentCodesOptions.push({
                id: element.id,
                label: element.label,
                salerAreaId: element.salerAreaId
              });
            }
          });
        });
      }
      this.$nextTick(function () {
        self.LoadreSubAgentCodesOptions();
      });
    },
    DepartmentClear: function DepartmentClear(e) {
      var self = this;
      this.reAgentCodesOptions = this.allAgentCodesOptions;
      this.SalerAreaId = [];
      this.$nextTick(function () {
        self.LoadreSubAgentCodesOptions();
      });
      return true;
    },
    AgentSelect: function AgentSelect(e) {
      var self = this;
      this.$nextTick(function () {
        self.LoadreSubAgentCodesOptions();
      });
    },
    AgentDeselect: function AgentDeselect(e) {
      var self = this;
      this.$nextTick(function () {
        self.LoadreSubAgentCodesOptions();
      });
    },
    AgentClear: function AgentClear(e) {
      var self = this;
      this.$nextTick(function () {
        self.LoadreSubAgentCodesOptions();
      });
      return true;
    },
    LoadreSubAgentCodesOptions: function LoadreSubAgentCodesOptions(e) {
      var self = this;
      console.log('[QIGroupByAgent] LoadreSubAgentCodesOptions called', {
        SalesAreaId: self.reDepartments,
        AgentCodes: self.reAgentCodes
      });
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2QISubAgent", {
        SalesAreaId: self.reDepartments,
        AgentCodes: self.reAgentCodes,
        page: 1,
        all: true
      }).then(function (response) {
        console.log('[QIGroupByAgent] Select2SubAgent response:', response.status, response.data);
        if (response.status == 200) {
          var data = response.data.results;
          self.reSubAgentCodesOptions = [];
          data.forEach(function (element) {
            self.reSubAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
          self.allSubAgentCodesOptions = self.reSubAgentCodesOptions;
        }
      }).catch(function (error) {
        console.error('[QIGroupByAgent] Select2SubAgent error:', error);
      });
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    // #18: Top scrollbar — inject เหนือ DataTables scroll container
    setupTopScrollbar: function setupTopScrollbar() {
      var scrollBody = document.querySelector('#QIGroupByAgentTable_wrapper .dataTables_scrollBody');
      var scrollHead = document.querySelector('#QIGroupByAgentTable_wrapper .dataTables_scrollHead');
      if (!scrollBody || !scrollHead) return;

      // สร้าง top scrollbar div
      var topScroll = document.createElement('div');
      topScroll.id = 'topScrollbar';
      topScroll.style.cssText = 'overflow-x: auto; overflow-y: hidden; height: 20px; margin-bottom: -1px;';
      var inner = document.createElement('div');
      inner.id = 'topScrollbarInner';
      inner.style.cssText = 'height: 1px;';
      topScroll.appendChild(inner);

      // แทรกเหนือ scrollHead (เหนือ column header)
      scrollHead.parentNode.insertBefore(topScroll, scrollHead);

      // Sync scroll ทั้งสองทาง
      var syncing = false;
      topScroll.addEventListener('scroll', function () {
        if (syncing) {
          syncing = false;return;
        }
        syncing = true;
        scrollBody.scrollLeft = topScroll.scrollLeft;
      });
      scrollBody.addEventListener('scroll', function () {
        if (syncing) {
          syncing = false;return;
        }
        syncing = true;
        topScroll.scrollLeft = scrollBody.scrollLeft;
      });

      this.syncTopScrollbar();
    },
    syncTopScrollbar: function syncTopScrollbar() {
      this.$nextTick(function () {
        var scrollBody = document.querySelector('#QIGroupByAgentTable_wrapper .dataTables_scrollBody');
        var inner = document.getElementById('topScrollbarInner');
        if (!scrollBody || !inner) return;
        inner.style.width = scrollBody.scrollWidth + 'px';
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, isAgentOrSubAgent, datePickerStartOpts, datePickerEndOpts, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this3;


              self.LoadreDepartmentsOptions();
              self.LoadreAgentCodesOptions();
              self.LoadreSubAgentCodesOptions();
              self.LoadreScoresOptions();
              // self.LoadreUserIdsOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              // #9: calendar min date = 01/01/<previous year>, apply only for AGENT_REPORT/SUB_AGENT_REPORT
              isAgentOrSubAgent = !self.$root.canShow(['super_admin']) && self.$root.canShow(['AGENT_REPORT', 'SUB_AGENT_REPORT']);
              datePickerStartOpts = {
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().toDate(), // Today
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              };

              if (isAgentOrSubAgent) {
                datePickerStartOpts.startDate = moment().subtract(1, "years").startOf("year").toDate(); // 01/01/<previous year>
              }
              $(self.$refs.reStartDate).datepicker(datePickerStartOpts);
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              datePickerEndOpts = {
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                endDate: moment().toDate(), // Today
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              };

              if (isAgentOrSubAgent) {
                datePickerEndOpts.startDate = moment().subtract(1, "years").startOf("year").toDate(); // 01/01/<previous year>
              }
              $(self.$refs.reEndDate).datepicker(datePickerEndOpts);
              //self.reEndDate = moment().endOf('month');
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#QIGroupByAgentTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/QIGroupByAgent",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                      EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
                      Departments: self.reDepartments,
                      AgentCodes: self.reAgentCodes,
                      UserIds: self.reUserIds,
                      Scores: self.reScores,
                      SubAgentCodes: self.reSubAgentCodes,
                      IsInitial: self.reIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[3, "desc"]],
                columns: [{
                  data: "createdDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "agentName", className: "text-center" }, { data: "subAgentName", className: "text-center" }, {
                  data: "createdDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.createdDateString;
                  }
                }, { data: "userFullName", className: "text-center" }, { data: "department", className: "text-center" }, {
                  data: "shopTypeCode",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.shopTypeCode == "SUB_AGENT" ? "ร้านค้าตัวแทนจำหน่ายย่อย" : "ร้านค้าตัวแทนจำหน่าย";
                  }
                }, { data: "shopName", className: "text-center" }, { data: "shopName2", className: "text-center" }, {
                  data: "totalScore",
                  className: "text-center",
                  render: function render(data, type, full, meat) {
                    if (full.totalScore == null) {
                      return "ไม่มีคะแนนประเมิน";
                    } else {
                      return full.totalScore;
                    }
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
                  self.reAverageScore = settings.json ? settings.json.averageScore : null;

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // #18: Sync top scrollbar width after DataTable redraw
                self.syncTopScrollbar();
              });

              // #18: Setup top scrollbar sync
              _this3.$nextTick(function () {
                self.setupTopScrollbar();
              });

              $(_this3.$refs.form).validate().settings.ignore = ":hidden";

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var simulateAsyncOperation = function simulateAsyncOperation(fn) {
    setTimeout(fn, 2000);
};

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
        Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
    },
    data: function data() {
        var self = this;
        var today = moment();
        //const startOfMonth = moment().subtract(1, 'year');
        var startOfMonth = moment().startOf('month'); // ต้นเดือน

        return {
            reAaDateReq: null,
            reDepartments: [],
            reUserIds: [],
            //isShowFooter: false,
            // reCheckInTotal: 0,
            // reNonCheckInTotal: 0,
            reStartDate: startOfMonth,
            reEndDate: today,
            reDepartmentsOptions: [],
            reIsInitial: true,
            shmShopGroupId: ["1"],
            shmShopGroupIdOptions: [],
            // reDepartmentsOptions: {
            //   minimumResultsForSearch: -1,
            //   placeholder: "กรุณาเลือกเขตการขาย",
            //   allowClear: true,
            //   ajax: {
            //     url: "/Api/Agents/Select2SearchDepartment",
            //     data: function(params) {
            //       var query = {
            //         search: params.term,
            //         page: params.page || 1,
            //       };
            //       return query;
            //     },
            //     processResults: function(data, params) {
            //       return {
            //         results: data.results,
            //         pagination: {
            //           more: data.more,
            //         },
            //       };
            //     },
            //     transport: function(params, success, failure) {
            //       params.beforeSend = function(request) {
            //         request.setRequestHeader(
            //           "Authorization",
            //           "Bearer " + self.$root.user.access_token
            //         );
            //       };
            //       var $request = $.ajax(params);
            //       $request.then(success);
            //       $request.fail(failure);
            //       return $request;
            //     },
            //   },
            // },
            reUserIdsOptions: []
            // reUserIdsOptions: {
            //   placeholder: "กรุณาเลือกเจ้าหน้าที่",
            //   allowClear: false,
            //   ajax: {
            //     delay: 300,
            //     url: "/Api/Users/Select2User",
            //     data: function(params) {
            //       var query = {
            //         search: params.term,
            //         page: params.page || 1,
            //       };
            //       return query;
            //     },
            //     processResults: function(data, params) {
            //       return {
            //         results: data.results,
            //         pagination: {
            //           more: data.more,
            //         },
            //       };
            //     },
            //     transport: function(params, success, failure) {
            //       params.beforeSend = function(request) {
            //         request.setRequestHeader(
            //           "Authorization",
            //           "Bearer " + self.$root.user.access_token
            //         );
            //       };
            //       var $request = $.ajax(params);
            //       $request.then(success);
            //       $request.fail(failure);
            //       return $request;
            //     },
            //   },
            // },
        };
    },
    computed: {},
    methods: {
        formReset: function formReset(e) {
            var self = this;
            self.reDepartments = [];
            self.reUserIds = [];
            self.shmShopGroupId = ["1"];

            // สร้างค่าเริ่มต้นย้อนหลัง 1 ปีจากวันนี้
            var today = moment();
            //const startOfMonth = moment().subtract(1, 'year'); // 🔹 ย้อน 1 ปี
            var startOfMonth = moment().startOf('month'); // ต้นปี

            self.reStartDate = startOfMonth;
            self.reEndDate = today;
            setTimeout(function () {
                $(self.$refs.reStartDate).datepicker("setDate", startOfMonth.toDate());

                $(self.$refs.reEndDate).datepicker("setDate", today.toDate());
            }, 50);

            $("#reDepartments").val("").trigger("change");

            $("#reUserIds").val("").trigger("change");

            //$("#reStartDate")
            //    .val("")
            //    .trigger("change");

            //$("#reEndDate")
            //    .val("")
            //    .trigger("change");

            $("#shmShopGroupId").val("").trigger("change");

            this.formSubmit(e);
        },
        formSubmit: function formSubmit(e) {
            var self = this;

            e.preventDefault();
            var table = $("#QIGroupByOfficerTable").DataTable();
            table.draw();
        },
        exportQIGroupByOfficer: function exportQIGroupByOfficer(e) {
            e.preventDefault();
            var self = this;

            if (!$(this.$refs.form).validate().form()) {
                return false;
            }

            KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
            });

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                method: "post",
                url: "/Api/Report/ExportQIGroupByOfficer",
                responseType: "arraybuffer",
                data: {
                    Departments: self.reDepartments,
                    UserIds: self.reUserIds,
                    StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                    EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
                    IsInitial: self.reIsInitial,
                    ShopGroupIds: self.shmShopGroupId
                }
            }).then(function (response) {
                if (response.status == "200") {
                    var filename = "";
                    var contentType = response.headers["content-type"];
                    var disposition = response.headers["content-disposition"];

                    //===Get Filename===
                    if (disposition && disposition.indexOf("attachment") !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, "");
                        }
                    }

                    //Save file
                    var blob = new Blob([response.data], { type: contentType });
                    var link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                } else if (response.status == "204") {
                    Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
                }
            }).catch(function (error) {
                Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }).then(function () {
                //self.formReset();
                KTApp.unblockPage();
            });
        },
        LoadreDepartmentsOptions: function LoadreDepartmentsOptions(e) {
            var self = this;
            // axios
            //   .get("/Api/Agents/Select2SearchDepartment", {
            //     params: {
            //       page: 1,
            //       all: true,
            //     },
            //   })
            //   .then(function(response) {
            //     if (response.status == 200) {
            //       var data = response.data.results;
            //       data.forEach((element) => {
            //         self.reDepartmentsOptions.push({
            //           id: element.id,
            //           label: element.text,
            //         });
            //       });
            //     }
            //   })
            //   .catch(function(error) {});
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
                params: {
                    page: 1,
                    all: true,
                    companyType: "COMPANY_PROFILE_TYPE_QI"
                }
            }).then(function (response) {
                if (response.status == 200) {
                    var data = response.data.results;
                    data.forEach(function (element) {
                        self.reDepartmentsOptions.push({
                            id: element.id,
                            label: element.text
                        });
                    });
                }
            }).catch(function (error) {});
        },
        LoadreUserIdsOptions: function LoadreUserIdsOptions(_ref) {
            var action = _ref.action,
                searchQuery = _ref.searchQuery,
                callback = _ref.callback;

            var self = this;

            if (action == "ASYNC_SEARCH") {
                simulateAsyncOperation(function () {
                    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
                        method: "post",
                        url: "/Api/Users/Select2QIGroupByOfficer",
                        data: {
                            page: 1,
                            search: searchQuery,
                            SalesAreaIds: self.reDepartments,
                            AgentCodes: [],
                            all: true
                        }
                    }).then(function (response) {
                        if (response.status == 200) {
                            var data = response.data.results;
                            self.reUserIdsOptions = [];
                            data.forEach(function (element) {
                                self.reUserIdsOptions.push({
                                    id: element.id,
                                    label: element.text
                                });
                            });
                            callback(null, self.reUserIdsOptions);
                        }
                    }).catch(function (error) {});
                });
            }
        },

        reLoadreUserIdsOptions: function reLoadreUserIdsOptions() {
            this.$refs.reUserIds.trigger.searchQuery = null;
        },
        ClearAfterselect: function ClearAfterselect() {
            $("[class=\"vue-treeselect__input\"]").val("");
        },
        LoadShopGroupIdOptions: function LoadShopGroupIdOptions(e) {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopGroup", {
                params: {
                    page: 1,
                    all: true
                }
            }).then(function (response) {
                if (response.status == 200) {
                    var data = response.data.results;
                    data.forEach(function (element) {
                        self.shmShopGroupIdOptions.push({
                            id: element.id,
                            label: element.text
                        });
                    });
                }
            }).catch(function (error) {});
        }
    },
    mounted: function mounted() {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var self, arrows, today, startOfMonth, table;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            self = _this;


                            self.LoadreDepartmentsOptions();
                            // self.LoadreUserIdsOptions();
                            self.LoadShopGroupIdOptions();
                            //self.shmShopGroupId = [1];

                            if (KTUtil.isRTL()) {
                                arrows = {
                                    leftArrow: '<i class="la la-angle-right"></i>',
                                    rightArrow: '<i class="la la-angle-left"></i>'
                                };
                            } else {
                                arrows = {
                                    leftArrow: '<i class="la la-angle-left"></i>',
                                    rightArrow: '<i class="la la-angle-right"></i>'
                                };
                            }

                            self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                            //====== กำหนดค่าเริ่มต้น วันที่ส่งซ่อม =======
                            // สร้างค่าเริ่มต้นย้อนหลัง 1 ปีจากวันนี้
                            today = moment();
                            //const startOfMonth = moment().subtract(1, 'year'); // 🔹 ย้อน 1 ปี

                            startOfMonth = moment().startOf('month'); // ต้นปี

                            // กำหนดค่า moment ให้ตัวแปรใน Vue (ถ้ามี)

                            self.reStartDate = startOfMonth;
                            self.reEndDate = today;

                            //=========== Start Date ===============
                            $(self.$refs.reStartDate).datepicker({
                                autoclose: true,
                                clearBtn: true,
                                format: "dd/mm/yyyy",
                                rtl: KTUtil.isRTL(),
                                //minDate: moment(), // Current day
                                maxDate: moment().add(30, "days"), // 30 days from the current day
                                orientation: "bottom left",
                                todayBtn: "linked",
                                todayHighlight: true,
                                templates: arrows
                            });
                            $(self.$refs.reStartDate).datepicker("update", startOfMonth.format("DD/MM/YYYY")).on("changeDate", function (e) {
                                if (e.dates && e.dates.length) {
                                    self.reStartDate = moment(e.date);
                                } else {
                                    self.reStartDate = null;
                                }
                            });
                            ////self.reStartDate = moment().set("date",1);
                            //$(self.$refs.reStartDate)
                            //  .datepicker(
                            //    "update",
                            //    !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
                            //  )
                            //  .on("changeDate", function(e) {
                            //    self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
                            //  });

                            //============= End Date ==============
                            $(self.$refs.reEndDate).datepicker({
                                autoclose: true,
                                clearBtn: true,
                                format: "dd/mm/yyyy",
                                rtl: KTUtil.isRTL(),
                                minDate: moment(), // Current day
                                maxDate: moment().add(30, "days"), // 30 days from the current day
                                orientation: "bottom left",
                                todayBtn: "linked",
                                todayHighlight: true,
                                templates: arrows
                            });
                            //self.reEndDate = moment().endOf('month');
                            $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
                            });

                            //=================================================

                            $.fn.dataTable.ext.errMode = 'none';
                            table = $("#QIGroupByOfficerTable");
                            //begin first table

                            table.DataTable({
                                autoWidth: true,
                                scrollY: "100%",
                                scrollX: true,
                                responsive: true,
                                processing: true,
                                serverSide: true,
                                searchDelay: 500,
                                ajax: {
                                    url: "/Api/Report/QIGroupByOfficer",
                                    type: "post",
                                    dataType: "json",
                                    contentType: "application/json",
                                    beforeSend: function beforeSend(request) {
                                        request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                                    },
                                    data: function data(d) {
                                        var jsonSearch = {
                                            Departments: self.reDepartments,
                                            UserIds: self.reUserIds,
                                            StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                                            EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
                                            IsInitial: self.reIsInitial,
                                            ShopGroupIds: self.shmShopGroupId
                                        };
                                        return JSON.stringify($.extend(d, jsonSearch));
                                    }
                                },
                                // DOM Layout settings
                                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n    <'row'<'col-sm-12'tr>>\n    <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                                lengthMenu: [30, 50, 100],

                                pageLength: 30,

                                language: {
                                    lengthMenu: "Display _MENU_"
                                },
                                // Order settings
                                order: [[1, "asc"]],
                                columns: [{
                                    data: "userFullName",
                                    className: "text-center",
                                    render: function render(data, type, full, meta) {
                                        var t = table.DataTable();
                                        var page = t.page.info().start + 1;
                                        return page + meta.row;
                                    }
                                }, { data: "userFullName", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "department", className: "text-center" }, {
                                    data: "checkInCount",
                                    className: "text-center",
                                    render: function render(value) {
                                        return self.$options.filters.currency(value, "", 0);
                                    }
                                }, {
                                    data: "nonCheckInCount",
                                    className: "text-center",
                                    render: function render(value) {
                                        return self.$options.filters.currency(value, "", 0);
                                    }
                                }],
                                drawCallback: function drawCallback(settings) {
                                    self.reIsInitial = false;
                                    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                                    var allPage = table.DataTable().page.info().pages;
                                    var currentPage = table.DataTable().page.info().page + 1;

                                    // self.isShowFooter = false;
                                    // self.reCheckInTotal = 0;
                                    // self.reNonCheckInTotal = 0;

                                    // if (allPage == currentPage) {
                                    //   self.isShowFooter = true;
                                    //   self.reCheckInTotal = settings.json.data[0].checkInTotal;
                                    //   self.reNonCheckInTotal = settings.json.data[0].nonCheckInTotal;
                                    // }
                                }
                            }).on("error.dt", function (e, settings, techNote, message) {
                                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
                            }).on("draw.dt", function () {
                                // var t = table.DataTable();
                                // var page = t.page.info().start + 1;
                                // t.column(0, {}).nodes().each( function (cell, i) {
                                //     cell.innerHTML = i+page;
                                // } );
                            });

                            $(_this.$refs.form).validate().settings.ignore = ":hidden";

                        case 17:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_DatatableWarning__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component


// import the styles


__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      isShowFooter: false,
      TotalAmount: 0,
      LoadFrist: true,
      errors: [],
      columns: null,
      reOrderBy: null,
      reViewPermissionCode: null,
      reViewPermissionOptions: [],
      reDateReq: null,
      reIsInitial: true,
      reDateCycle: null,
      reStartDate: null,
      reEndDate: null,
      reBarcode: null,
      reJobNumber: null,
      reProductTypeId: [],
      reProductTypeIdOptions: [],
      reProductCode: [],
      reProductCodeOptions: [],
      reProductBrandId: [],
      reProductBrandIdOptions: [],
      rePlantCode: [],
      rePlantCodeOptions: [],
      reAgentCode: [],
      reAgentCodeOptions: [],
      reShopCode: [],
      reShopCodeOptions: [],
      reShopTypeId: [],
      reShopTypeIdOptions: [],
      reTransitId: [],
      reTransitIdOptions: [],
      reTransitType: [],
      reTransitTypeOptions: [],
      reScanUserId: [],
      reScanUserIdOptions: [],
      reTotalBarcode: 0,
      selectedItems: [],
      options: [],
      isLoadingOptions: true
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.reStartDate = null;
      self.reEndDate = null;
      self.reBarcode = null;
      self.reProductTypeId = [];
      self.reProductCode = [];
      self.reProductBrandId = [];
      self.reJobNumber = null;
      self.rePlantCode = [];
      self.reAgentCode = [];
      self.reShopCode = [];
      self.reShopTypeId = [];
      self.reTransitId = [];
      self.reTransitType = [];
      self.reScanUserId = [];

      $("#reStartDate").val("").trigger("change");
      $("#reEndDate").val("").trigger("change");
      $("#reBarcode").val("").trigger("change");
      $("#reProductTypeId").val("").trigger("change");
      $("#reProductCode").val("").trigger("change");
      $("#reProductBrandId").val("").trigger("change");
      $("#reJobNumber").val("").trigger("change");
      $("#rePlantCode").val("").trigger("change");
      $("#reAgentCode").val("").trigger("change");
      $("#reShopCode").val("").trigger("change");
      $("#reShopTypeId").val("").trigger("change");
      $("#reTransitId").val("").trigger("change");
      $("#reTransitType").val("").trigger("change");
      $("#reScanUserId").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formResetValue: function formResetValue(e) {
      var self = this;

      self.reStartDate = null;
      self.reEndDate = null;
      self.reBarcode = null;
      self.reProductTypeId = [];
      self.reProductCode = [];
      self.reProductBrandId = [];
      self.reJobNumber = null;
      self.rePlantCode = [];
      self.reAgentCode = [];
      self.reShopCode = [];
      self.reShopTypeId = [];
      self.reTransitId = [];
      self.reTransitType = [];
      self.reScanUserId = [];

      $("#reStartDate").val("").trigger("change");
      $("#reEndDate").val("").trigger("change");
      $("#reBarcode").val("").trigger("change");
      $("#reProductTypeId").val("").trigger("change");
      $("#reProductCode").val("").trigger("change");
      $("#reProductBrandId").val("").trigger("change");
      $("#reJobNumber").val("").trigger("change");
      $("#rePlantCode").val("").trigger("change");
      $("#reAgentCode").val("").trigger("change");
      $("#reShopCode").val("").trigger("change");
      $("#reShopTypeId").val("").trigger("change");
      $("#reTransitId").val("").trigger("change");
      $("#reTransitType").val("").trigger("change");
      $("#reScanUserId").val("").trigger("change");

      //this.formSubmit(e, "ล้างค่าทั้งหมด");
    },
    formSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var self, IsValidate, table;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;
                IsValidate = true;


                if (innerText == "ล้างค่าทั้งหมด") {
                  self.reIsInitial = true;
                }

                e.preventDefault();

                if ($(this.$refs.form).validate().form()) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", false);

              case 6:
                table = $("#ReturnProductTable").DataTable();
                _context.next = 9;
                return self.GenCollums(table, "submit");

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function formSubmit(_x) {
        return _ref.apply(this, arguments);
      }

      return formSubmit;
    }(),
    LoadrePlantCodeOptions: function LoadrePlantCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Plant/Select2Plant", {
        all: true,
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.rePlantCodeOptions = [];
          data.forEach(function (element) {
            self.rePlantCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreProductTypeIdOptions: function LoadreProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reProductTypeIdOptions = [];
          data.forEach(function (element) {
            self.reProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreProductCodeOptions: function LoadreProductCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reProductCodeOptions = [];
          data.forEach(function (element) {
            self.reProductCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreProductBrandIdOptions: function LoadreProductBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2ProductBrand", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reProductBrandIdOptions = [];
          data.forEach(function (element) {
            self.reProductBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodeOptions: function LoadreAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2AgentPaymentProduct", {
        SalesAreaId: self.reSalesAreaId,
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reAgentCodeOptions = [];
          data.forEach(function (element) {
            self.reAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreSubAgentCodeOptions: function LoadreSubAgentCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2BarButlerShop", {
        SalesAreaId: self.reSalesAreaId,
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reSubAgentCodeOptions = [];
          data.forEach(function (element) {
            self.reSubAgentCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreShopCodeOptions: _.debounce(function (_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      //this.$emit('activate', this.item)
      var self = this;
      if (action === "ASYNC_SEARCH") {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2BarButlerShop", {
          Page: 1,
          All: true,
          Search: searchQuery,
          InActiveStatus: false,
          AgentCodes: self.reAgentCode,
          ShopCode: self.reSubAgentCode,
          RoleView: self.reViewPermissionCode
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reShopCodeOptions = [];
            data.forEach(function (element) {
              self.reShopCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
            callback(null, self.reShopCodeOptions);
          }
        }).catch(function (error) {});
      }
    }, 3000),
    resLoadreShopCodeOptions: function resLoadreShopCodeOptions() {
      this.$refs.reShopCode.trigger.searchQuery = null;
    },
    LoadreShopTypeIdOptions: function LoadreShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ShopType/Select2SearchShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    // LoadreShopTypeIdOptions: function (e) {
    //   var self = this;
    //   axios
    //     .post("/Api/Report/Select2ShopAgentType", {
    //       page: 1,
    //       all: true,
    //       InActiveStatus: false,
    //       AgentCodes: self.reAgentCode,
    //       ShopCode: self.reSubAgentCode,
    //       RoleView: self.reViewPermissionCode
    //     })
    //     .then(function (response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         self.reShopTypeIdOptions = [];
    //         data.forEach((element) => {
    //           self.reShopTypeIdOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function (error) { });
    // },
    LoadreSalesAreaIdOptions: function LoadreSalesAreaIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/MasterSalesArea/Select2PaymentProduct", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reSalesAreaIdOptions = [];
          data.forEach(function (element) {
            self.reSalesAreaIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreProvinceIdOptions: function LoadreProvinceIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2PaymentProductProvince", {
        page: 1,
        all: true,
        salesAreaId: self.reSalesAreaId
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reProvinceIdOptions = [];
          data.forEach(function (element) {
            self.reProvinceIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTransitIdOptions: function LoadreTransitIdOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Transport/Select2Transport", {
        showVendorTransport: false,
        agentCodes: [],
        isShowPickup: false,
        page: 1,
        search: null,
        isShowAll: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reTransitIdOptions = [];
          data.forEach(function (element) {
            self.reTransitIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTransitTypeOptions: function LoadreTransitTypeOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Transport/Select2TransportType", {
        showVendorTransport: false,
        agentCodes: [],
        isShowPickup: false,
        page: 1,
        search: null,
        isShowAll: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reTransitTypeOptions = [];
          data.forEach(function (element) {
            self.reTransitTypeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    reLoadreScanUserIdOptions: function reLoadreScanUserIdOptions() {
      this.$refs.reScanUserId.trigger.searchQuery = null;
    },
    LoadreScanUserIdOptions: function LoadreScanUserIdOptions(_ref3) {
      var callback = _ref3.callback;

      var self = this;
      self.reScanUserIdOptions = [];
      if (self.isLoadingOptions) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2ScanUser", {
          page: 1,
          search: null
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reScanUserIdOptions = [];
            data.forEach(function (element) {
              self.reScanUserIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
            self.isLoadingOptions = false;
          }
          callback(null, self.reScanUserIdOptions);
        });
      }
    },
    LoadreViewReturnProductOptions: function LoadreViewReturnProductOptions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ViewReturnProduct", {}).then(function (response) {
                  if (response.status == 200) {
                    var data = response.data.results;
                    data.forEach(function (element) {
                      self.reViewPermissionOptions.push({
                        id: element.id,
                        label: element.text
                      });

                      if (element.data == "active") {
                        self.reViewPermissionCode = element.id;
                      }
                    });
                  }
                }).catch(function (error) {});

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    ChangeOptions: function ChangeOptions(type) {
      var self = this;
      if (self.LoadFrist == false) {
        if (type == "View") {
          self.formResetValue();
          self.LoadrePlantCodeOptions();
          self.LoadreAgentCodeOptions();
          // self.LoadreSubAgentCodeOptions();
          // self.LoadreShopCodeOptions();
          // self.LoadreShopTypeIdOptions();
          // self.LoadreSalesAreaIdOptions();
          // self.LoadreProvinceIdOptions();
        } else if (type == "reSalesAreaId") {
          // self.LoadreProvinceIdOptions(); // จังหวัด
          self.LoadreAgentCodeOptions(); // ตัวแทนจำหน่าย
          self.LoadreSubAgentCodeOptions(); // ตัวแทนจำหน่ายย่อย
          // self.LoadreShopCodeOptions(); // ร้านค้า
          // self.LoadreShopTypeIdOptions(); // ประเภทร้านค้า
        } else if (type == "reAgentCode") {
          // self.LoadreShopCodeOptions();
          // self.LoadreShopTypeIdOptions();
        } else if (type == "reSubAgentCode") {
          // self.LoadreShopCodeOptions();
          // self.LoadreShopTypeIdOptions();
        } else if (type == "reShopCode") {
          // self.LoadreShopTypeIdOptions();
        }
      }
    },
    GenCollums: function GenCollums(table, action) {
      var self = this;
      self.columns = null;

      if (self.reViewPermissionCode == "AGENT_REPORT") {
        self.columns = [{
          data: "jobId",
          className: "text-center",
          render: function render(data, type, full, meta) {
            var t = table.DataTable();
            var page = t.page.info().start + 1;
            return page + meta.row;
          }
        }, {
          data: "jobDate",
          className: "text-center",
          render: function render(data, type, full, meta) {
            return full.jobDateString;
          }
        }, { data: "jobNumber", className: "text-center" }, { data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "cusT_CODE", className: "text-center" }, { data: "shopName", className: "text-center" }, { data: "shopTypeName", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "productCode", className: "text-center" }, { data: "productName", className: "text-center" }, { data: "productBrandName", className: "text-center" }, { data: "barcodeNoOld", className: "text-center" },
        // { data: "countBarcode", className: "text-center" },
        { data: "scanByUserName", className: "text-center" }, { data: "jobId", className: "text-center", visible: false }];
      } else {
        self.columns = [{
          data: "jobId",
          className: "text-center",
          render: function render(data, type, full, meta) {
            var t = table.DataTable();
            var page = t.page.info().start + 1;
            return page + meta.row;
          }
        }, {
          data: "jobDate",
          className: "text-center",
          render: function render(data, type, full, meta) {
            return full.jobDateString;
          }
        }, { data: "jobNumber", className: "text-center" }, { data: "plantCode", className: "text-center" }, { data: "plantName", className: "text-center" }, { data: "caR_REG", className: "text-center" }, { data: "companY_NAME", className: "text-center" }, { data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "productCode", className: "text-center" }, { data: "productName", className: "text-center" }, { data: "productBrandName", className: "text-center" }, { data: "barcodeNoOld", className: "text-center" },
        // { data: "countBarcode", className: "text-center" },
        { data: "scanByUserName", className: "text-center" }];
      }

      if (action == "submit") {
        table.clear();
        table.destroy();
        table = $("#ReturnProductTable");
        self.GetDataTable(table);
      }
    },
    GetDataTable: function GetDataTable(table) {
      var self = this;
      $.fn.dataTable.ext.errMode = 'none';
      table.DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/ReturnProduct",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function beforeSend(request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          },
          data: function data(d) {

            var jsonSearch = {
              IsInitial: self.reIsInitial,

              StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : null,

              EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : null,

              Barcode: self.reBarcode,
              ProductTypeId: self.reProductTypeId,
              ProductCode: self.reProductCode,
              ProductBrandId: self.reProductBrandId,
              PlantCode: self.rePlantCode,
              AgentCode: self.reAgentCode,
              ShopCode: self.reShopCode,
              ShopTypeId: self.reShopTypeId,
              TransitId: self.reTransitId,
              TransitType: self.reTransitType,
              ScanUserId: self.reScanUserId,
              ViewPermissionCode: self.reViewPermissionCode,
              JobNumber: self.reJobNumber
            };
            return JSON.stringify($.extend(d, jsonSearch));
          }
        },
        // DOM Layout settings
        dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_"
        },
        // Order settings
        order: [[1, "desc"]],
        columns: self.columns,
        drawCallback: function drawCallback(settings) {
          self.reIsInitial = false;
          self.reDateReq = moment().format("DD/MM/YYYY h:mm a");
          self.reTotalBarcode = 0;

          // if (settings.json.data.length > 0) {
          //   var data = settings.json.data;
          //   data.forEach((element) => {
          //     self.reTotalBarcode = self.reTotalBarcode + element.countBarcode;
          //   });
          // }

          var allPage = table.DataTable().page.info().pages;
          var currentPage = table.DataTable().page.info().page + 1;
          self.isShowFooter = false;
          if (allPage == currentPage) {
            self.isShowFooter = true;
            self.reTotalBarcode = settings.json.data[0].totalBarcode;
          }
        }
      }).on("preXhr.dt", function () {
        console.log("preXhr.dt");
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
        });
      }).on("xhr.dt", function () {
        console.log("xhr.dt");
        KTApp.unblock(self.$refs.form);
      }).on("error.dt", function (e, settings, techNote, message) {
        __WEBPACK_IMPORTED_MODULE_5__Shared_DatatableWarning__["a" /* default */].alert(techNote);
      }).on("draw.dt", function () {
        console.log("draw.dt");
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });
    },

    ExportReturnProduct: function ExportReturnProduct(e) {
      var self = this;
      e.preventDefault();

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportReturnProduct",
        responseType: "arraybuffer",
        data: {
          StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : null,

          EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : null,

          Barcode: self.reBarcode,
          ProductTypeId: self.reProductTypeId,
          ProductCode: self.reProductCode,
          ProductBrandId: self.reProductBrandId,
          PlantCode: self.rePlantCode,
          AgentCode: self.reAgentCode,
          ShopCode: self.reShopCode,
          ShopTypeId: self.reShopTypeId,
          TransitId: self.reTransitId,
          TransitType: self.reTransitType,
          ScanUserId: self.reScanUserId,
          ViewPermissionCode: self.reViewPermissionCode,
          JobNumber: self.reJobNumber
          // OrderByCollum: self.reOrderBy != null ? this.OrderName(self.reOrderBy[0][0]) : null,
          // OrderBy: self.reOrderBy != null ? self.reOrderBy[0][1] : null
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = _this2;


              self.LoadrePlantCodeOptions();
              self.LoadreProductTypeIdOptions();
              self.LoadreProductCodeOptions();
              self.LoadreProductBrandIdOptions();
              self.LoadreAgentCodeOptions();
              // self.LoadreShopCodeOptions();
              self.LoadreShopTypeIdOptions();
              self.LoadreTransitIdOptions();
              self.LoadreTransitTypeOptions();
              // self.LoadreScanUserIdOptions();
              _context3.next = 11;
              return self.LoadreViewReturnProductOptions();

            case 11:
              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reEndDate = moment().endOf('month');
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              table = $("#ReturnProductTable");
              _context3.next = 20;
              return self.GenCollums(table);

            case 20:
              self.GetDataTable(table);
              self.LoadFrist = false;

              // set validation rules
              $(_this2.$refs.form).validate({
                rules: {
                  reStartDate: "required",
                  reEndDate: "required"
                },
                messages: {
                  reStartDate: "กรุณากรอกวันที่เริ่มต้น",
                  reEndDate: "กรุณากรอกวันที่สิ้นสุด"
                }
              });

              $(_this2.$refs.form).validate().settings.ignore = ":hidden";

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reSaIsInitial: true,
      reSbsDateReq: null,
      reSaAgentCode: null,
      reSaShopTypeId: [],
      reSaShopName: [],
      reSaProductTypeId: [],
      reSaAssetCode: [],
      reSaBrandId: [],
      reSaProductTypeIdOptions: [],
      // reSaProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reSaBrandIdOptions: [],
      // reSaBrandIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reSaAssetCodeOptions: [],
      // reSaAssetCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reSaShopTypeIdOptions: [],
      // reSaShopTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ShopType",
      //     data: function(params) {
      //       var query = {
      //         agentCode: self.reSaAgentCode,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reSaShopNameOptions: [],
      // reSaShopNameOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ShopQuery",
      //     data: function(params) {
      //       var query = {
      //         agentCode: self.reSaAgentCode,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reSaAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: []
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.reSaAgentCode = null;
      self.reSaShopTypeId = [];
      self.reSaShopName = [];
      self.reSaProductTypeId = [];
      self.reSaAssetCode = [];
      self.reSaBrandId = [];

      // $("#reSaAgentCode")
      // .val("")
      // .trigger("change");

      $("#reSaAgentCode").empty().trigger("change");

      $("#reSaShopTypeId").val("").trigger("change");

      $("#reSaShopName").val("").trigger("change");

      $("#reSaProductTypeId").val("").trigger("change");

      $("#reSaAssetCode").val("").trigger("change");

      $("#reSaBrandId").val("").trigger("change");

      self.initSelectedAgent();
      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function formSubmit(e) {
      var innerText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var self = this;
      console.log(innerText);

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reSaIsInitial = true;
      } else {
        if (!$(this.$refs.form).validate().form()) {
          return false;
        }
      }

      e.preventDefault();
      var table = $("#shopAssetTable").DataTable();
      table.draw();
    },
    initSelectedAgent: function initSelectedAgent(e) {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/Select2Agent",
        data: {
          search: null,
          page: 1,
          province_id: [],
          department: [],
          AgentCodes: []
        }
      }).then(function (response) {
        console.log(response);
        if (response.status == 200) {
          self.$refs.reSaAgentCode.setSelectedData({
            id: response.data.results[0].id,
            text: response.data.results[0].text
          });
        } else {
          //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        //Swal.fire("เกิดข้อผิดพลาด", "", "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    OnChangeAgentCode: function OnChangeAgentCode(id, text, data, ref) {
      //this.LoadreSaShopNameOptions();
    },
    LoadreSaProductTypeIdOptions: function LoadreSaProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reSaProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreSaBrandIdOptions: function LoadreSaBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reSaBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreSaAssetCodeOptions: function LoadreSaAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reSaAssetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreSaShopTypeIdOptions: function LoadreSaShopTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ShopType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reSaShopTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreSaShopNameOptions: function LoadreSaShopNameOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.reSaShopNameOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ShopQuery", {
          params: {
            page: 1,
            agentCode: self.reSaAgentCode,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reSaShopNameOptions = [];
            data.forEach(function (element) {
              self.reSaShopNameOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reSaShopNameOptions);
        });
      }
    },

    reLoadSaShopNameOptions: function reLoadSaShopNameOptions() {
      this.$refs.reSaShopName.trigger.searchQuery = null;
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    ExportShopAssets: function ExportShopAssets(e) {
      e.preventDefault();
      var self = this;

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportShopAssets",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reSaIsInitial,
          AgentCode: self.reSaAgentCode,
          ShopTypeId: self.reSaShopTypeId,
          ShopName: self.reSaShopName,
          ProductTypeId: self.reSaProductTypeId,
          AssetCode: self.reSaAssetCode,
          BrandId: self.reSaBrandId
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreSaProductTypeIdOptions();
              self.LoadreSaBrandIdOptions();
              self.LoadreSaAssetCodeOptions();
              self.LoadreSaShopTypeIdOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reSbsDateReq = moment().format("DD/MM/YYYY h:mm a");
              self.initSelectedAgent();

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#shopAssetTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/ShopAssets",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      IsInitial: self.reSaIsInitial,
                      AgentCode: self.reSaAgentCode,
                      ShopTypeId: self.reSaShopTypeId,
                      ShopName: self.reSaShopName,
                      ProductTypeId: self.reSaProductTypeId,
                      AssetCode: self.reSaAssetCode,
                      BrandId: self.reSaBrandId
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[1, "desc"]],
                columns: [{
                  data: "agentCode",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "agentCode", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "shopTypeName", className: "text-center" }, { data: "shopCode", className: "text-center" }, { data: "shopName", className: "text-center" }, { data: "shopName2", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "assetCode", className: "text-center" }, { data: "assetName", className: "text-center" }, { data: "brandName", className: "text-center" }, {
                  data: "shopAssetAmount",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data != null || data != "" || data !== 0) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "salesUnit", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reSaIsInitial = false;
                  self.reSbsDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.form, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.form);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  reSaAgentCode: "required"
                },
                messages: {
                  reSaAgentCode: "กรุณาเลือกตัวแทนจำหน่าย"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reIsInitial: true,
      reAaDateReq: null,
      reStartDate: null,
      reEndDate: null,
      reSalesArea: [],
      reAgentCodes: [],
      bcClaimStatusCode: null,
      reSalesAreaOptions: [],
      reAgentCodesOptions: [],
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url:
      //       "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      bcClaimStatusCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function data(params) {
            var query = {
              search: "CLAIM_STATUS",
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reSalesArea = [];
      self.reAgentCodes = [];
      self.bcClaimStatusCode = null, $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reSalesArea").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#bcClaimStatusCode").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#StatusTable").DataTable();
      table.draw();
    },
    LoadreSalesAreaOptions: function LoadreSalesAreaOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reSalesAreaOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      self.reAgentCodesOptions = [{ id: "0", label: "Loading..." }];
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT", {
        province_id: [],
        department: [],
        AgentCodes: [],
        SalesAreaIds: self.reSalesArea,
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.reAgentCodesOptions = [];
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreAgentCodesOptions();
              self.LoadreSalesAreaOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#StatusTable");

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/StatusClaim",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                      EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
                      SalesArea: self.reSalesArea,
                      AgentCode: self.reAgentCodes,
                      ClaimStatus: self.bcClaimStatusCode,
                      IsInitial: self.reIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[1, "desc"]],
                columns: [{
                  data: "agentCode",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, {
                  data: "claimDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.claimDateString;
                  }
                }, { data: "salesAreaName", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "shopName", className: "text-center" }, { data: "shopName2", className: "text-center" }, { data: "barCodeNoOld", className: "text-center" }, { data: "departmentMaterialCode", className: "text-center" }, { data: "claimNumber", className: "text-center" }, { data: "approvalPerson", className: "text-center" }, { data: "productName", className: "text-center" }, { data: "weight", className: "text-center" }, { data: "problem", className: "text-center" }, { data: "problemDesc", className: "text-center" }, { data: "status", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reSnapshotDate: null,
      reSnapshotDateDisplay: "",
      reBarcodes: "",
      isInitial: true,
      dataTable: null,
      columnCount: 39
    };
  },
  mounted: function mounted() {
    this.initDatepicker();
    this.initDataTable();
    this.$nextTick(function () {
      this.setupTopScrollbar();
    });
  },

  methods: {
    initDatepicker: function initDatepicker() {
      var self = this;
      var arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>'
      };
      $(self.$refs.reSnapshotDate).datepicker({
        autoclose: true,
        clearBtn: true,
        format: "dd/mm/yyyy",
        rtl: KTUtil.isRTL(),
        endDate: moment().toDate(),
        orientation: "bottom left",
        todayBtn: "linked",
        todayHighlight: true,
        templates: arrows
      });
      $(self.$refs.reSnapshotDate).datepicker("update", null).on("changeDate", function (e) {
        self.reSnapshotDate = e.dates.length != 0 ? moment(e.date) : null;
      });
    },
    initDataTable: function initDataTable() {
      var self = this;
      $.fn.dataTable.ext.errMode = "none";
      self.dataTable = $("#snapshotTable").DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: false,
        serverSide: true,
        searching: false,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/StockBarcodeSnapshot",
          type: "POST",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function beforeSend(request) {
            request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
          },
          data: function data(d) {
            d.isInitial = self.isInitial;
            d.snapshotDate = self.reSnapshotDate ? self.reSnapshotDate.format("YYYY-MM-DD") : "";
            d.barcodes = self.reBarcodes;
            return JSON.stringify(d);
          },
          error: function error(xhr, _error, thrown) {
            KTApp.unblockPage();
            $('.dataTables_processing').hide();
            var msg = "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง";
            try {
              var resp = JSON.parse(xhr.responseText);
              if (resp && resp.error) msg = resp.error;
            } catch (e) {}
            Swal.fire("เกิดข้อผิดพลาด", msg, "error");
          }
        },
        dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n              <'row'<'col-sm-12'tr>>\n              <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
        lengthMenu: [50, 100, 200, 500],
        pageLength: 100,
        columns: [{ data: null, className: "text-center", render: function render(data, type, row, meta) {
            return meta.row + meta.settings._iDisplayStart + 1;
          } }, { data: "assetOwnerName", className: "text-center" }, { data: "barcodeStatusName", className: "text-center" }, { data: "barcodeNoOld", className: "text-center" }, { data: "departmentMaterialCode", className: "text-center" }, { data: "barcodeYear", className: "text-center" }, { data: "unitPrice", className: "text-right" }, { data: "accountMaterialCode", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "assetCode", className: "text-center" }, { data: "assetName", className: "text-center" }, { data: "finishedProductCode", className: "text-center" }, { data: "finishedProductName", className: "text-center" }, { data: "brandName", className: "text-center" }, { data: "finishedProductDate", className: "text-center" }, { data: "currentLocationCode", className: "text-center" }, { data: "currentLocationName", className: "text-center" }, { data: "currentLocationName2", className: "text-center" }, { data: "currentLocationType", className: "text-center" }, { data: "ownerTypeCode", className: "text-center" }, { data: "salesAreaName", className: "text-center" }, { data: "provinceId", className: "text-center" }, { data: "shopTypeName", className: "text-center" }, { data: "hostAgentCode", className: "text-center" }, { data: "hostAgentName", className: "text-center" }, { data: "headAgentCode", className: "text-center" }, { data: "hostAgentDepartment", className: "text-center" }, { data: "hostAgentSalesAreaId", className: "text-center" }, { data: "hostAgentProvinceId", className: "text-center" }, { data: "hostSubAgentCustCode", className: "text-center" }, { data: "hostSubAgentName", className: "text-center" }, { data: "hostSubAgentProvinceId", className: "text-center" }, { data: "latestActiveDate", className: "text-center" }, { data: "latestActivePMDate", className: "text-center" }, { data: "latestActiveDateType", className: "text-center" }, { data: "latestActiveDateStatus", className: "text-center" }, { data: "transitCompanyName", className: "text-center" }, { data: "latestCommitUserName", className: "text-center" }, { data: "onHoldDays", className: "text-center" }],
        order: [[3, "asc"]],
        language: {
          processing: "กำลังโหลด...",
          lengthMenu: "Display _MENU_",
          zeroRecords: "ไม่พบข้อมูล",
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "Showing 0 to 0 of 0 entries",
          infoFiltered: "(filtered from _MAX_ total entries)",
          paginate: { first: "First", last: "Last", next: "Next", previous: "Previous" }
        },
        drawCallback: function drawCallback() {
          self.isInitial = false;
          if (self.reSnapshotDate) {
            self.reSnapshotDateDisplay = self.reSnapshotDate.format("DD/MM/YYYY");
          }
          self.syncTopScrollbar();
        }
      });

      $("#snapshotTable").on("error.dt", function (e, settings, techNote, message) {
        console.error("DataTable error:", message);
      });
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var self = this;

      if (!self.reSnapshotDate) {
        Swal.fire("กรุณาเลือก Snapshot Date", "", "warning");
        return;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      self.isInitial = false;
      self.dataTable.ajax.reload(function () {
        KTApp.unblockPage();
      });
    },
    resetForm: function resetForm() {
      var self = this;
      self.reBarcodes = "";
      self.reSnapshotDate = null;
      self.reSnapshotDateDisplay = "";
      $(self.$refs.reSnapshotDate).datepicker("update", null);
      self.isInitial = true;
      self.dataTable.ajax.reload();
    },
    exportExcel: function exportExcel(e) {
      e.preventDefault();
      var self = this;

      if (!self.reSnapshotDate) {
        Swal.fire("กรุณาเลือก Snapshot Date", "", "warning");
        return;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/Report/ExportStockBarcodeSnapshot",
        responseType: "arraybuffer",
        data: {
          snapshotDate: self.reSnapshotDate.format("YYYY-MM-DD"),
          barcodes: self.reBarcodes,
          isInitial: false
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
        console.error("Export error:", error);
      }).then(function () {
        KTApp.unblockPage();
      });
    },

    // Top scrollbar (pattern from QCGroupByAgent)
    setupTopScrollbar: function setupTopScrollbar() {
      var self = this;
      var scrollBody = document.querySelector("#snapshotTable_wrapper .dataTables_scrollBody");
      var scrollHead = document.querySelector("#snapshotTable_wrapper .dataTables_scrollHead");
      if (!scrollBody || !scrollHead) return;

      var topScroll = document.createElement("div");
      topScroll.id = "snapshotTopScrollbar";
      topScroll.style.cssText = "overflow-x: auto; overflow-y: hidden; height: 20px; margin-bottom: -1px;";
      var inner = document.createElement("div");
      inner.id = "snapshotTopScrollbarInner";
      inner.style.cssText = "height: 1px;";
      topScroll.appendChild(inner);

      scrollHead.parentNode.insertBefore(topScroll, scrollHead);

      var syncing = false;
      topScroll.addEventListener("scroll", function () {
        if (syncing) {
          syncing = false;return;
        }
        syncing = true;
        scrollBody.scrollLeft = topScroll.scrollLeft;
      });
      scrollBody.addEventListener("scroll", function () {
        if (syncing) {
          syncing = false;return;
        }
        syncing = true;
        topScroll.scrollLeft = scrollBody.scrollLeft;
      });
      self.syncTopScrollbar();
    },
    syncTopScrollbar: function syncTopScrollbar() {
      this.$nextTick(function () {
        var scrollBody = document.querySelector("#snapshotTable_wrapper .dataTables_scrollBody");
        var inner = document.getElementById("snapshotTopScrollbarInner");
        if (!scrollBody || !inner) return;
        inner.style.width = scrollBody.scrollWidth + "px";
      });
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAaDateReq: null,
      reObjectivesCode: null,
      reStartDate: null,
      reEndDate: null,
      reAgentCodes: [],
      reUserIds: null,
      reAgentCodesOptions: [],
      reIsInitial: true,
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_MKT",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      reUserIdsOptions: {
        placeholder: "กรุณาเลือกเจ้าหน้าที่",
        allowClear: true,
        ajax: {
          delay: 300,
          method: "post",
          url: "/Api/Users/Select2UserMkt",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              agentCodes: self.reAgentCodes
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reObjectivesCodeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{
          id: "MKT_ACTIVITY_TYPE_SURVEY_ON_PREMISE",
          text: "ตรวจเยี่ยมร้าน On-premise",
          data: null
        }, {
          id: "MKT_ACTIVITY_TYPE_SURVEY_OFF_PREMISE",
          text: "ตรวจเยี่ยมร้าน Off-premise",
          data: null
        }]
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reObjectivesCode = null;
      self.reAgentCodes = [];
      self.reUserIds = null;

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reObjectivesCode").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#reUserIds").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#SurveyOnOffPremiseTable").DataTable();
      table.draw();
    },
    exportSurveyOnOffPremise: function exportSurveyOnOffPremise(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportMKTSurvey",
        responseType: "arraybuffer",
        data: {
          CheckInStartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
          CheckInEndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
          CreatedUserId: self.reUserIds,
          ObjectivesCode: self.reObjectivesCode,
          AgentCode: self.reAgentCodes,
          IsInitial: self.reIsInitial
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_MKT", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreAgentCodesOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reEndDate = moment().endOf('month');
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#SurveyOnOffPremiseTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/MKTSurvey",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      CheckInStartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                      CheckInEndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
                      CreatedUserId: self.reUserIds,
                      ObjectivesCode: self.reObjectivesCode,
                      AgentCode: self.reAgentCodes,
                      IsInitial: self.reIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[0, "asc"]],
                columns: [{
                  data: "activityHeaderId",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "objectivesName", className: "text-center" }, { data: "createdName", className: "text-center" }, { data: "agentName", className: "text-center" }, { data: "provinceName", className: "text-center", orderable: false }, { data: "shopName", className: "text-center" }, { data: "shopName2", className: "text-center" }, {
                  data: "checkIn",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.checkInString;
                  }
                }, { data: "timeUsage", className: "text-center" }, { data: "shopTypeName", className: "text-center" }, { data: "pgSaleItem", className: "text-center", orderable: false }, {
                  data: "pgSaleItemQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "saleItem", className: "text-center", orderable: false }, {
                  data: "saleItemQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "dispenser", className: "text-center", orderable: false }, {
                  data: "dispenserQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "tower", className: "text-center", orderable: false }, {
                  data: "towerQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "pitcher", className: "text-center", orderable: false }, {
                  data: "pitcherQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "glass", className: "text-center", orderable: false }, {
                  data: "glassQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "tables", className: "text-center", orderable: false }, {
                  data: "tableQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }, { data: "chair", className: "text-center", orderable: false }, {
                  data: "chairQty",
                  className: "text-center",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data != null) {
                      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                      return "";
                    }
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

                  // var allPage = table.DataTable().page.info().pages;
                  // var currentPage = table.DataTable().page.info().page +1;

                  // self.isShowFooter = false;
                  // self.TotalAmount = 0;

                  // if(allPage == currentPage){
                  //   self.isShowFooter = true;
                  //   self.TotalAmount = settings.json.data[0].totalAmount;
                  // }
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAaDateReq: null,
      reStartDate: null,
      reEndDate: null,
      reDepartments: [],
      reAgentCodes: [],
      headers: [],
      database: [],
      folderHead: [],
      reDepartmentsOptions: [],
      reIsInitial: true,
      reAgentCodesOptions: []
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reDepartments = [];
      self.reAgentCodes = [];
      self.headers = [];
      self.database = [];
      self.folderHead = [];

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reDepartments").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;
      self.headers = [];
      self.database = [];
      self.folderHead = [];
      e.preventDefault();
      var table = $("#5SByAgentTable").DataTable();
      table.draw();
    },
    getDataFromApi: function getDataFromApi(data) {
      var self = this;

      self.headers = [];
      self.database = [];
      self.folderHead = [];

      data.forEach(function (e) {
        e.item.forEach(function (o) {
          var chk = self.headers.includes(o.folderName);
          if (!chk) {
            self.headers.push(o.folderName);
          }
        });
      });
      self.headers = self.headers;
      self.database = data;

      self.database.forEach(function (o) {
        o.item.forEach(function (i) {
          self.folderHead.push(i.folderName);
        });
      });
    },

    LoadreDepartmentsOptions: function LoadreDepartmentsOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reDepartmentsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreDepartmentsOptions();
              self.LoadreAgentCodesOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#5SByAgentTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                ajax: {
                  url: "/Api/Report/TransactionView5S",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                      EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
                      SalesArea: self.reDepartments,
                      AgentCodes: self.reAgentCodes,
                      IsInitial: self.reIsInitial
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  },
                  complete: function complete(response, xhr, status) {
                    self.getDataFromApi(response.responseJSON.data);
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[2, "desc"]],
                columns: [{
                  data: "agentCode",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "agentName", className: "text-center" }, { data: "departments", className: "text-center" }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles




__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reTbIsShowDetail: false,
      reTbIsSelectAgent: false,
      reTbIsInitial: true,
      reTbDateReq: null,
      reTbOriginAgentCode: null,
      reTbDestinationShopCode: null,
      reTbDestinationShopName: null,
      reTbBarcode: null,
      reTbDepartmentMaterialCode: [],
      reTbNFCCode: [],
      reTbProductTypeId: [],
      reTbAssetCode: [],
      reTbBrandId: [],
      reTbOccupiedDays: null,
      reTbReturnStatus: null,
      reTbAgentName: "",
      reTbShopName: "",
      reTbShopTypeName: "",
      reTbAdress: "",
      reTbAmphur: "",
      reTbProvince: "",
      reTbTel: "",
      reTbContact: "",

      reTbOriginAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {

          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: []
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      },
      reTbDestinationShopCodeOptions: {
        placeholder: "กรุณาเลือกร้านค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopByAgent",
          data: function data(params) {
            var query = {
              agentCode: self.reTbOriginAgentCode,
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reTbDepartmentMaterialCodeOptions: [],
      // reTbDepartmentMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสสินทรัพย์",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbNFCCodeOptions: [],
      // reTbNFCCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกNFC",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2NFC",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbProductTypeIdOptions: [],
      // reTbProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbBrandIdOptions: [],
      // reTbBrandIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbAssetCodeOptions: [],
      // reTbAssetCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbReturnStatusOptions: {
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        data: [{
          id: "ยังไม่ได้ส่งคืน",
          text: "ยังไม่ได้ส่งคืน"
        }, {
          id: "ส่งคืนแล้ว",
          text: "ส่งคืนแล้ว"
        }]
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.reTbOriginAgentCode = null;
      self.reTbDestinationShopCode = null;
      self.reTbDestinationShopName = null;
      self.reTbBarcode = null;
      self.reTbDepartmentMaterialCode = [];
      self.reTbNFCCode = [];
      self.reTbProductTypeId = [];
      self.reTbAssetCode = [];
      self.reTbBrandId = [];
      self.reTbOccupiedDays = null;
      self.reTbReturnStatus = null;

      $("#reTbOriginAgentCode").empty().trigger("change");

      $("#reTbDestinationShopCode").empty().trigger("change");

      $("#reTbBarcode").val("").trigger("change");

      $("#reTbDepartmentMaterialCode").val("").trigger("change");

      $("#reTbProductTypeId").val("").trigger("change");

      $("#reTbAssetCode").val("").trigger("change");

      $("#reTbBrandId").val("").trigger("change");

      $("#reTbReturnStatus").val("").trigger("change");

      self.initSelectedAgent();
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (!self.reTbDestinationShopCode && !self.reTbDestinationShopName) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุร้านค้า", "warning");
        return false;
      } else if (self.reTbDestinationShopCode && self.reTbDestinationShopName) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุร้านค้าอย่างใดอย่างหนึ่ง", "warning");
        return false;
      }

      e.preventDefault();
      var table = $("#stockCardTable").DataTable();
      table.draw();
    },
    onOriginAgentCodeChange: function onOriginAgentCodeChange(id, text, data, ref) {
      var self = this;

      self.reTbDestinationShopCode = null;
      $("#reTbDestinationShopCode").empty().trigger("change");
    },
    initSelectedAgent: function initSelectedAgent(e) {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/Select2Agent",
        data: {
          search: null,
          page: 1,
          province_id: [],
          department: [],
          AgentCodes: []
        }
      }).then(function (response) {
        if (response.data != []) {
          self.$refs.reTbOriginAgentCode.setSelectedData({
            id: response.data.results[0].id,
            text: response.data.results[0].text
          });
        } else {
          //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    exportTransferBarcode: function exportTransferBarcode(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (!self.reTbDestinationShopCode && !self.reTbDestinationShopName) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุร้านค้า", "warning");
        return false;
      } else if (self.reTbDestinationShopCode && self.reTbDestinationShopName) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุร้านค้าอย่างใดอย่างหนึ่ง", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportTransferBarcode",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reTbIsInitial,
          OriginAgentCode: self.reTbOriginAgentCode,
          DestinationShopCode: self.reTbDestinationShopCode,
          Barcode: self.reTbBarcode,
          DepartmentMaterialCode: self.reTbDepartmentMaterialCode,
          NFCCode: self.reTbNFCCode,
          ProductTypeId: self.reTbProductTypeId,
          AssetCode: self.reTbAssetCode,
          BrandId: self.reTbBrandId,
          OccupiedDays: self.reTbOccupiedDays,
          ReturnStatus: self.reTbReturnStatus
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreTbDepartmentMaterialCodeOptions: function LoadreTbDepartmentMaterialCodeOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.reTbDepartmentMaterialCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2DepartmentMaterial", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTbDepartmentMaterialCodeOptions = [];
            data.forEach(function (element) {
              self.reTbDepartmentMaterialCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reTbDepartmentMaterialCodeOptions);
        }).catch(function (error) {});
      }
    },
    LoadreTbNFCCodeOptions: function LoadreTbNFCCodeOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.reTbNFCCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2NFC", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTbNFCCodeOptions = [];
            data.forEach(function (element) {
              self.reTbNFCCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reTbNFCCodeOptions);
        }).catch(function (error) {});
      }
    },

    LoadreTbProductTypeIdOptions: function LoadreTbProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTbBrandIdOptions: function LoadreTbBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTbAssetCodeOptions: function LoadreTbAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbAssetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreTbProductTypeIdOptions();
              self.LoadreTbBrandIdOptions();
              self.LoadreTbAssetCodeOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reTbDateReq = moment().format("DD/MM/YYYY h:mm a");
              self.initSelectedAgent();

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#stockCardTable");
              //begin first table

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/Report/TransferBarcode",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    self.reTbIsShowDetail = false;
                    var jsonSearch = {
                      IsInitial: self.reTbIsInitial,
                      OriginAgentCode: self.reTbOriginAgentCode,
                      DestinationShopCode: self.reTbDestinationShopCode,
                      DestinationShopName: self.reTbDestinationShopName,
                      Barcode: self.reTbBarcode,
                      DepartmentMaterialCode: self.reTbDepartmentMaterialCode,
                      NFCCode: self.reTbNFCCode,
                      ProductTypeId: self.reTbProductTypeId,
                      AssetCode: self.reTbAssetCode,
                      BrandId: self.reTbBrandId,
                      OccupiedDays: self.reTbOccupiedDays,
                      ReturnStatus: self.reTbReturnStatus
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [50, 100, 200, 500],

                pageLength: 100,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[9, "desc"]],
                columns: [{
                  data: "barcodeNo",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "barcodeNoOld", className: "text-center" }, { data: "departmentMaterialCode", className: "text-center" }, { data: "productTypeName", className: "text-center" }, { data: "assetCode", className: "text-center" }, { data: "assetName", className: "text-center" }, { data: "brandName", className: "text-center" }, {
                  data: "occupiedDays",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data) return data + " วัน";else return "0 วัน";
                  }
                }, {
                  data: "transactionDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.transactionDateString;
                  }
                }, { data: "returnTransactionDateString", className: "text-center" }, {
                  data: "returnStatus",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data == "ส่งคืนแล้ว") {
                      return '<span class="text-success"> ส่งคืนแล้ว</span>';
                    } else if (data == "ยังไม่ได้ส่งคืน") {
                      return '<span class="text-danger"> ยังไม่ได้ส่งคืน</span>';
                    }
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reTbIsInitial = false;
                  self.reTbDateReq = moment().format("DD/MM/YYYY h:mm a");

                  if (settings.json.data.length > 0) {
                    self.reTbIsShowDetail = true;

                    var data = settings.json.data[0].details;
                    self.reTbAgentName = data.agent;
                    self.reTbShopName = data.shopName2 == null || data.shopName2 == "" ? data.shop : data.shop + " (" + data.shopName2 + ")";
                    self.reTbShopTypeName = data.shopType;
                    self.reTbAdress = data.address;
                    self.reTbAmphur = data.amphur;
                    self.reTbProvince = data.province;
                    self.reTbTel = data.tel;
                    self.reTbContact = data.contactFullName;
                  }
                }
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.form, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.form);
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                // var t = table.DataTable();
                // var page = t.page.info().start + 1;
                // t.column(0, {}).nodes().each( function (cell, i) {
                //     cell.innerHTML = i+page;
                // } );
              });

              // set validation rules
              $(_this.$refs.form).validate({
                rules: {
                  reTbOriginAgentCode: "required"
                },
                messages: {
                  reTbOriginAgentCode: "กรุณาเลือกตัวแทนจำหน่าย"
                }
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reTbIsSelectAgent: false,
      reTbIsInitial: true,
      reTbOriginAgentCode: null,
      reTbDestinationShopCode: [],
      reTbDestinationShopName: null,
      reTbAmpherId: [],
      reTbBarcode: null,
      reTbDepartmentMaterialCode: [],
      reTbNFCCode: [],
      reTbProductTypeId: [],
      reTbAssetCode: [],
      reTbBrandId: [],
      reTbOccupiedDays: null,
      reTbReturnStatus: null,
      reTbAmpherIdOptions: [],
      reTbDestinationShopCodeOptions: [],
      reTbDestinationShopCodeOptionsData: [],
      // reTbAmpherIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterLocation/Select2SearchAmpher",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         agentCode: self.reTbOriginAgentCode,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },

      reTbOriginAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: []
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      },
      // reTbDestinationShopCodeOptions: {
      //   placeholder: "กรุณาเลือกร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Shop/Select2ShopByAgent",
      //     data: function(params) {
      //       var query = {
      //         agentCode: self.reTbOriginAgentCode,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbBarcodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reTbDepartmentMaterialCodeOptions: [],
      // reTbDepartmentMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสสินทรัพย์",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbNFCCodeOptions: [],
      // reTbNFCCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกNFC",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2NFC",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbProductTypeIdOptions: [],
      // reTbProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbBrandIdOptions: [],
      //  reTbBrandIdOptions: {
      //     minimumResultsForSearch: -1,
      //     placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //     ajax: {
      //       url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //       data: function(params) {
      //         var query = {
      //           search: params.term,
      //           page: params.page || 1,
      //         };
      //         return query;
      //       },
      //       processResults: function(data, params) {
      //         return {
      //           results: data.results,
      //           pagination: {
      //             more: data.more,
      //           },
      //         };
      //       },
      //       transport: function(params, success, failure) {
      //         params.beforeSend = function(request) {
      //           request.setRequestHeader(
      //             "Authorization",
      //             "Bearer " + self.$root.user.access_token
      //           );
      //         };
      //         var $request = $.ajax(params);
      //         $request.then(success);
      //         $request.fail(failure);
      //         return $request;
      //       },
      //     },
      //   },
      reTbAssetCodeOptions: [],
      // reTbAssetCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbReturnStatusOptions: {
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        data: [{
          id: "ยังไม่ได้ส่งคืน",
          text: "ยังไม่ได้ส่งคืน"
        }, {
          id: "ส่งคืนแล้ว",
          text: "ส่งคืนแล้ว"
        }]
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.reTbOriginAgentCode = null;
      self.reTbDestinationShopCode = [];
      self.reTbDestinationShopName = null;
      self.reTbBarcode = null;
      self.reTbDepartmentMaterialCode = [];
      self.reTbNFCCode = [];
      self.reTbProductTypeId = [];
      self.reTbAssetCode = [];
      self.reTbBrandId = [];
      self.reTbOccupiedDays = null;
      self.reTbReturnStatus = null;
      self.reTbAmpherId = [];

      $("#reTbAmpherId").empty().trigger("change");

      $("#reTbOriginAgentCode").empty().trigger("change");

      $("#reTbDestinationShopCode").empty().trigger("change");

      $("#reTbBarcode").val("").trigger("change");

      $("#reTbDepartmentMaterialCode").val("").trigger("change");

      $("#reTbProductTypeId").val("").trigger("change");

      $("#reTbAssetCode").val("").trigger("change");

      $("#reTbBrandId").val("").trigger("change");

      $("#reTbReturnStatus").val("").trigger("change");

      self.initSelectedAgent();
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if (self.reTbDestinationShopCode.length == 0 && !self.reTbDestinationShopName && self.reTbAmpherId.length == 0) {
        // Swal.fire(
        //   "เกิดข้อผิดพลาด",
        //   "กรุณาเลือกหรือระบุร้านค้าหรือเลือกอำเภอ",
        //   "warning"
        // );
        // return false;
      } else {
        var criterias = 0;
        if (self.reTbDestinationShopCode.length != 0) criterias++;
        if (self.reTbDestinationShopName) criterias++;
        if (self.reTbAmpherId.length != 0) criterias++;

        if (criterias > 1) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุร้านค้าหรือเลือกอำเภออย่างใดอย่างหนึ่ง", "warning");
          return false;
        }
      }

      e.preventDefault();
    },
    onOriginAgentCodeChange: function onOriginAgentCodeChange(id, text, data, ref) {
      var self = this;

      self.reTbDestinationShopCode = [];
      self.reTbAmpherId = [];
      self.LoadreTbAmpherIdOptions();
    },
    initSelectedAgent: function initSelectedAgent(e) {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/Select2Agent",
        data: {
          search: null,
          page: 1,
          province_id: [],
          department: [],
          AgentCodes: []
        }
      }).then(function (response) {
        if (response.data != []) {
          self.$refs.reTbOriginAgentCode.setSelectedData({
            id: response.data.results[0].id,
            text: response.data.results[0].text
          });
        } else {
          //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    exportTransferBarcode: function exportTransferBarcode(e) {
      e.preventDefault();
      var self = this;

      if (self.reTbOriginAgentCode.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุตัวแทนจำหน่าย", "warning");
        return false;
      }

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }
      if (self.reTbDestinationShopCode.length == 0 && !self.reTbDestinationShopName && self.reTbAmpherId.length == 0) {
        // Swal.fire(
        //   "เกิดข้อผิดพลาด",
        //   "กรุณาเลือกหรือระบุร้านค้าหรือเลือกอำเภอ",
        //   "warning"
        // );
        // return false;
      } else {
        var criterias = 0;
        if (self.reTbDestinationShopCode.length != 0) criterias++;
        if (self.reTbDestinationShopName) criterias++;
        if (self.reTbAmpherId.length != 0) criterias++;

        if (criterias > 1) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุร้านค้าหรือเลือกอำเภออย่างใดอย่างหนึ่ง", "warning");
          return false;
        }
      }

      if (self.reTbDestinationShopCode.length > 255) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกร้านค้าไม่เกิน 255 ร้านค้า", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportTransferBarcodeMultiple",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reTbIsInitial,
          OriginAgentCode: self.reTbOriginAgentCode,
          DestinationShopCode: self.reTbDestinationShopCode,
          AmpherId: self.reTbAmpherId,
          Barcode: self.reTbBarcode,
          DepartmentMaterialCode: self.reTbDepartmentMaterialCode,
          NFCCode: self.reTbNFCCode,
          ProductTypeId: self.reTbProductTypeId,
          AssetCode: self.reTbAssetCode,
          BrandId: self.reTbBrandId,
          OccupiedDays: self.reTbOccupiedDays,
          ReturnStatus: self.reTbReturnStatus,
          DestinationShopName: self.reTbDestinationShopName
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        // Swal.fire("เกิดข้อผิดพลาด", "จำนวนร้านค้าเกิน 255 รายการ", "error");
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreTbAmpherIdOptions: function LoadreTbAmpherIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/MasterLocation/Select2SearchAmpher", {
        agentCode: self.reTbOriginAgentCode,
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          self.reTbAmpherIdOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbAmpherIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    // LoadreTbDestinationShopCodeOptions({ action, searchQuery, callback }) {
    LoadreTbDestinationShopCodeOptions: function LoadreTbDestinationShopCodeOptions() {
      var inputdata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var self = this;
      if (inputdata) {
        if (inputdata.action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Shop/Select2ShopByAgent", {
            params: {
              agentCode: self.reTbOriginAgentCode,
              page: 1,
              all: true,
              search: inputdata.searchQuery
            }
          }).then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              var options = [];
              data.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.text
                });
              });
              inputdata.callback(null, options);
            }
          });
        }
      }
    },
    reLoadTbDestinationShopCodeOptions: function reLoadTbDestinationShopCodeOptions() {
      var inputdata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.$refs.reTbDestinationShopCode.trigger.searchQuery = null;
    },
    LoadreTbDepartmentMaterialCodeOptions: function LoadreTbDepartmentMaterialCodeOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.reTbDepartmentMaterialCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2DepartmentMaterial", {
          params: {
            agentCode: self.reTbOriginAgentCode,
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTbDepartmentMaterialCodeOptions = [];
            data.forEach(function (element) {
              self.reTbDepartmentMaterialCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reTbDepartmentMaterialCodeOptions);
        }).catch(function (error) {});
      }
    },
    LoadreTbNFCCodeOptions: function LoadreTbNFCCodeOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.reTbNFCCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2NFC", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTbNFCCodeOptions = [];
            data.forEach(function (element) {
              self.reTbNFCCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reTbNFCCodeOptions);
        }).catch(function (error) {});
      }
    },

    LoadreTbProductTypeIdOptions: function LoadreTbProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTbBrandIdOptions: function LoadreTbBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTbAssetCodeOptions: function LoadreTbAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbAssetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.initSelectedAgent();
              self.LoadreTbAmpherIdOptions();
              self.LoadreTbProductTypeIdOptions();
              self.LoadreTbBrandIdOptions();
              self.LoadreTbAssetCodeOptions();
              // self.LoadreTbDestinationShopCodeOptions();

              $(self.$refs.form).validate({
                ignore: ":hidden, .ignore",
                rules: {
                  reTbOriginAgentCode: "required"
                },
                messages: {
                  reTbOriginAgentCode: "กรุณาเลือกตัวแทนจำหน่าย"
                }
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reTbIsInitial: true,
      reTbOriginSubAgentCode: null,
      reTbDestinationShopCode: [],
      reTbAmpherId: [],
      reTbBarcode: null,
      reTbDepartmentMaterialCode: [],
      reTbProductTypeId: [],
      reTbAssetCode: [],
      reTbBrandId: [],
      reTbOccupiedDays: null,
      reTbReturnStatus: null,
      reTbAmpherIdOptions: [],
      reTbOriginSubAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่ายย่อย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              onlySubAgent: true,
              onlySubAgentReport: true
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        templateResult: function templateResult(data) {
          return data.text;
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลร้านค้า";
          }
        }
      },
      reTbBarcodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reTbDepartmentMaterialCodeOptions: [],
      reTbProductTypeIdOptions: [],
      reTbBrandIdOptions: [],
      reTbAssetCodeOptions: [],
      reTbReturnStatusOptions: {
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        data: [{
          id: "ยังไม่ได้ส่งคืน",
          text: "ยังไม่ได้ส่งคืน"
        }, {
          id: "ส่งคืนแล้ว",
          text: "ส่งคืนแล้ว"
        }]
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.reTbOriginSubAgentCode = null;
      self.reTbDestinationShopCode = [];
      self.reTbBarcode = null;
      self.reTbDepartmentMaterialCode = [];
      self.reTbProductTypeId = [];
      self.reTbAssetCode = [];
      self.reTbBrandId = [];
      self.reTbOccupiedDays = null;
      self.reTbReturnStatus = null;
      self.reTbAmpherId = [];

      $("#reTbAmpherId").empty().trigger("change");

      $("#reTbOriginSubAgentCode").empty().trigger("change");

      $("#reTbDestinationShopCode").empty().trigger("change");

      $("#reTbBarcode").val("").trigger("change");

      $("#reTbDepartmentMaterialCode").val("").trigger("change");

      $("#reTbProductTypeId").val("").trigger("change");

      $("#reTbAssetCode").val("").trigger("change");

      $("#reTbBrandId").val("").trigger("change");

      $("#reTbReturnStatus").val("").trigger("change");

      self.initSelectedSubAgent();
    },
    formSubmit: function formSubmit(e) {
      var self = this;
      e.preventDefault();
    },
    onOriginSubAgentCodeChange: function onOriginSubAgentCodeChange(id, text, data, ref) {
      var self = this;
      self.reTbDestinationShopCode = [];
      self.reTbAmpherId = [];
      self.LoadreTbAmpherIdOptions();
    },
    initSelectedSubAgent: function initSelectedSubAgent(e) {
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/Select2SubShopAgent",
        data: {
          search: null,
          page: 1,
          onlySubAgent: true,
          onlySubAgentReport: true
        }
      }).then(function (response) {
        if (response.data != []) {
          self.$refs.reTbOriginSubAgentCode.setSelectedData({
            id: response.data.results[0].id,
            text: response.data.results[0].text
          });
        } else {
          //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      }).catch(function (error) {
        //Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        // always executed
        KTApp.unblockPage();
      });
    },
    exportTransferBarcode: function exportTransferBarcode(e) {
      e.preventDefault();
      var self = this;
      if (self.reTbOriginSubAgentCode === null || self.reTbOriginSubAgentCode.length == 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุตัวแทนจำหน่ายย่อย", "warning");
        return false;
      }

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var criterias = 0;
      if (self.reTbDestinationShopCode.length != 0) criterias++;
      if (self.reTbAmpherId.length != 0) criterias++;

      if (criterias > 1) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกหรือระบุร้านค้าหรือเลือกอำเภออย่างใดอย่างหนึ่ง", "warning");
        return false;
      }

      if (self.reTbDestinationShopCode.length > 255) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกร้านค้าไม่เกิน 255 ร้านค้า", "warning");
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportTransferBarcodeSubAgent",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reTbIsInitial,
          OriginSubAgentCode: self.reTbOriginSubAgentCode,
          DestinationShopCode: self.reTbDestinationShopCode,
          AmpherId: self.reTbAmpherId,
          Barcode: self.reTbBarcode,
          DepartmentMaterialCode: self.reTbDepartmentMaterialCode,
          ProductTypeId: self.reTbProductTypeId,
          AssetCode: self.reTbAssetCode,
          BrandId: self.reTbBrandId,
          OccupiedDays: self.reTbOccupiedDays,
          ReturnStatus: self.reTbReturnStatus
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreTbAmpherIdOptions: function LoadreTbAmpherIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/MasterLocation/Select2SearchAmpher", {
        ShopCode: self.reTbOriginSubAgentCode || 0,
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          self.reTbAmpherIdOptions = [];
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbAmpherIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTbDestinationShopCodeOptions: function LoadreTbDestinationShopCodeOptions() {
      var inputdata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var self = this;
      if (inputdata) {
        if (inputdata.action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Barcode/Select2SupShop", {
            page: 1,
            all: true,
            search: inputdata.searchQuery,
            ShopId: self.reTbOriginSubAgentCode ? self.reTbOriginSubAgentCode.split(',').map(function (code) {
              return code.trim();
            }) : [],
            agentCodes: [],
            OnlySubAgentReport: true
          }).then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              var options = [];
              data.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.text
                });
              });
              inputdata.callback(null, options);
            }
          });
        }
      }
    },
    reLoadTbDestinationShopCodeOptions: function reLoadTbDestinationShopCodeOptions() {
      var inputdata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.$refs.reTbDestinationShopCode.trigger.searchQuery = null;
    },
    LoadreTbDepartmentMaterialCodeOptions: function LoadreTbDepartmentMaterialCodeOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.reTbDepartmentMaterialCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2DepartmentMaterial", {
          params: {
            agentCode: self.reTbOriginSubAgentCode,
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTbDepartmentMaterialCodeOptions = [];
            data.forEach(function (element) {
              self.reTbDepartmentMaterialCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reTbDepartmentMaterialCodeOptions);
        }).catch(function (error) {});
      }
    },

    LoadreTbProductTypeIdOptions: function LoadreTbProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTbBrandIdOptions: function LoadreTbBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTbAssetCodeOptions: function LoadreTbAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbAssetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              self.initSelectedSubAgent();
              self.LoadreTbAmpherIdOptions();
              self.LoadreTbProductTypeIdOptions();
              self.LoadreTbBrandIdOptions();
              self.LoadreTbAssetCodeOptions();
              // self.LoadreTbDestinationShopCodeOptions();

              $(self.$refs.form).validate({
                ignore: ":hidden, .ignore",
                rules: {
                  reTbOriginSubAgentCode: "required"
                },
                messages: {
                  reTbOriginSubAgentCode: "กรุณาเลือกตัวแทนจำหน่ายย่อย"
                }
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import "vue-collapsible-component/lib/vue-collapsible.css";
 //"vue-collapsible-component";
// import the component

// import the styles



// require("datatables.net-autofill-bs4");
// require("datatables.net-bs4");
// require("datatables.net-buttons-bs4");
// require("datatables.net-colreorder-bs4");
// require("datatables.net-fixedcolumns-bs4");
// require("datatables.net-fixedheader-bs4");
// require("datatables.net-keytable-bs4");
// require("datatables.net-responsive-bs4");
// require("datatables.net-rowgroup-bs4");
// require("datatables.net-rowreorder-bs4");
// require("datatables.net-scroller-bs4");
// require("datatables.net-select-bs4");
__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_4__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    var today = moment();
    //const lastYear = moment().subtract(1, 'year');
    var lastYear = moment().startOf('year'); // ต้นปี

    return {
      reTbsReturnStatus: null,
      reTbsBarcode: null,
      reTbsDepartmentMaterialCode: [],
      reTbsOriginPlantCode: [],
      reTbsProductTypeId: [],
      reTbsBrandId: [],
      reTbsSupplierSpareId: [],
      reTbsSpareUsedStatusId: [],
      reTbsAssetCode: [],
      reTbsReturnJobNumber: [],
      reBCurrentLocationShop: [],
      reTbsDestinationVendorId: [],
      reTbsTransferJobNumber: [],
      reTbsProductGroupId: [],

      reTbsOccupiedDaysStart: null,
      reTbsOccupiedDaysEnd: null,

      reTbsTransactionDateStart: lastYear,
      reTbsTransactionDateEnd: today,
      reTbsReturnTransactionDateStart: null,
      reTbsReturnTransactionDateEnd: null,

      reTbsReturnStatusOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        data: [{ id: "ยังไม่ได้ส่งคืน", text: "ยังไม่ได้ส่งคืน", data: null }, { id: "ส่งคืนแล้ว", text: "ส่งคืนแล้ว", data: null }]
      },
      reBBarcodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reTbsDepartmentMaterialCodeOptions: [],
      // reTbsDepartmentMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสสินทรัพย์เบียร์สด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsOriginPlantCodeOptions: [],
      // reTbsOriginPlantCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกคลังสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/PlantOptions",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsProductTypeIdOptions: [],
      // reTbsProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsBrandIdOptions: [],
      // reTbsBrandIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsAssetCodeOptions: [],
      // reTbsAssetCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsReturnJobNumberOptions: [],
      // reTbsReturnJobNumberOptions: {
      //   placeholder: "กรุณาเลือกเลขที่เอกสารรับคืนจาก Supplier",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ReturnJobNumber",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBCurrentLocationShopOptions: {
        placeholder: "กรุณาเลือกผู้ถือครอง(ร้านค้า)",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopByAgent",
          data: function data(params) {
            var query = {
              agentCode: null,
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      reTbsDestinationVendorIdOptions: [],
      // reTbsDestinationVendorIdOptions: {
      //   placeholder: "กรุณาเลือก Supplier",
      //   multipla: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Vendors/Select2Vendor",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsTransferJobNumberOptions: [],
      // reTbsTransferJobNumberOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเลขที่เอกสารส่งซ่อม Supplier",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2TransferJobNumber",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reTbsProductGroupIdOptions: [],
      // reTbsProductGroupIdOptions: {
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      supplierSpareOptions: [],
      spareUsedStatusOptions: []
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;

      self.reTbsReturnStatus = null;
      self.reTbsBarcode = null;
      self.reTbsDepartmentMaterialCode = [];
      self.reTbsOriginPlantCode = [];
      self.reTbsProductTypeId = [];
      self.reTbsBrandId = [];
      self.reTbsSupplierSpareId = [];
      self.reTbsSpareUsedStatusId = [];
      self.reTbsAssetCode = [];
      self.reTbsReturnJobNumber = [];
      self.reBCurrentLocationShop = [];
      self.reTbsDestinationVendorId = [];
      self.reTbsTransferJobNumber = [];
      self.reTbsProductGroupId = [];
      self.reTbsOccupiedDaysStart = null;
      self.reTbsOccupiedDaysEnd = null;
      //self.reTbsTransactionDateStart = null;
      //self.reTbsTransactionDateEnd = null;
      self.reTbsReturnTransactionDateStart = null;
      self.reTbsReturnTransactionDateEnd = null;

      // สร้างค่าเริ่มต้นย้อนหลัง 1 ปีจากวันนี้
      var today = moment();
      //const lastYear = moment().subtract(1, 'year'); // 🔹 ย้อน 1 ปี
      var lastYear = moment().startOf('year'); // ต้นปี

      // กำหนดค่า moment ให้ตัวแปรใน Vue (ถ้ามี)
      self.reTbsTransactionDateStart = lastYear;
      self.reTbsTransactionDateEnd = today;

      setTimeout(function () {
        //$(self.$refs.reTbsTransactionDateStart)
        //    .datepicker('setDate', lastYear.toDate())
        //    .trigger('changeDate');

        //$(self.$refs.reTbsTransactionDateEnd)
        //    .datepicker('setDate', today.toDate())
        //    .trigger('changeDate');

        //== แก้ปัญหา null ตอนโพสต์ ==
        $(self.$refs.reTbsTransactionDateStart).datepicker('setDate', lastYear.toDate());
        $(self.$refs.reTbsTransactionDateEnd).datepicker('setDate', today.toDate());
      }, 50); // ลองเริ่มที่ 50ms ถ้ายังไม่ขึ้น ลอง 100ms

      // 🔹 รอให้ Vue อัปเดต DOM เสร็จก่อน แล้วค่อย update datepicker
      //this.$nextTick(() => {
      //    $(self.$refs.reTbsTransactionDateStart)
      //        .datepicker('destroy')
      //        .datepicker({
      //            autoclose: true,
      //            clearBtn: true,
      //            format: "dd/mm/yyyy",
      //            orientation: "bottom left",
      //            todayBtn: "linked",
      //            todayHighlight: true,
      //            templates: arrows,
      //        })
      //        .datepicker('setDate', lastYear.toDate());

      //    $(self.$refs.reTbsTransactionDateEnd)
      //        .datepicker("setDate", today.toDate())
      //        .trigger('changeDate');
      //});

      $("#reTbsReturnStatus").val("").trigger("change");

      $("#reTbsBarcode").val("").trigger("change");

      $("#reTbsDepartmentMaterialCode").val("").trigger("change");

      $("#reTbsOriginPlantCode").val("").trigger("change");

      $("#reTbsProductTypeId").val("").trigger("change");

      $("#reTbsBrandId").val("").trigger("change");

      $("#reTbsSupplierSpareId").val("").trigger("change");

      $("#reTbsSpareUsedStatusId").val("").trigger("change");

      $("#reTbsAssetCode").val("").trigger("change");

      $("#reTbsReturnJobNumber").val("").trigger("change");

      $("#reTbsDestinationVendorId").val("").trigger("change");

      $("#reTbsTransferJobNumber").val("").trigger("change");

      $("#reTbsProductGroupId").val("").trigger("change");
    },
    isEmptyOrSpaces: function isEmptyOrSpaces(str) {
      return str === null || str.match(/^ *$/) !== null;
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#brandCountTable").DataTable();
      table.draw();
    },
    exportBarcodes: function exportBarcodes(e) {
      e.preventDefault();
      var self = this;

      if (self.reTbsOccupiedDaysStart !== null || self.reTbsOccupiedDaysEnd !== null) {
        if (self.reTbsOccupiedDaysStart === null && self.reTbsOccupiedDaysEnd !== null) {
          Swal.fire("กรุณาระบุ", "จำนวนวันคงค้าง(เริ่มต้น)", "warning");
          return false;
        } else if (self.reTbsOccupiedDaysStart !== null && self.reTbsOccupiedDaysEnd === null) {
          Swal.fire("กรุณาระบุ", "จำนวนวันคงค้าง(สิ้นสุด)", "warning");
          return false;
        }
      }

      if (self.reTbsTransactionDateStart !== null || self.reTbsTransactionDateEnd !== null) {
        if (self.reTbsTransactionDateStart === null && self.reTbsTransactionDateEnd !== null) {
          Swal.fire("กรุณาระบุ", "วันที่ส่งซ่อม(เริ่มต้น)", "warning");
          return false;
        } else if (self.reTbsTransactionDateStart !== null && self.reTbsTransactionDateEnd === null) {
          Swal.fire("กรุณาระบุ", "วันที่ส่งซ่อม(สิ้นสุด)", "warning");
          return false;
        }
      }

      if (self.reTbsReturnTransactionDateStart !== null || self.reTbsReturnTransactionDateEnd !== null) {
        if (self.reTbsReturnTransactionDateStart === null && self.reTbsReturnTransactionDateEnd !== null) {
          Swal.fire("กรุณาระบุ", "วันที่รับคืนจากการซ่อม(เริ่มต้น)", "warning");
          return false;
        } else if (self.reTbsReturnTransactionDateStart !== null && self.reTbsReturnTransactionDateEnd === null) {
          Swal.fire("กรุณาระบุ", "วันที่รับคืนจากการซ่อม(สิ้นสุด)", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportTransferBarcodeSupplier",
        responseType: "arraybuffer",
        data: {
          OriginPlantCode: self.reTbsOriginPlantCode,
          DestinationVendorId: self.reTbsDestinationVendorId,
          TransferJobNumber: self.reTbsTransferJobNumber,
          ReturnJobNumber: self.reTbsReturnJobNumber,
          BarcodeNo: self.reTbsBarcode,
          DepartmentMaterialCode: self.reTbsDepartmentMaterialCode,
          ProductGroupId: self.reTbsProductGroupId,
          ProductTypeId: self.reTbsProductTypeId,
          AssetCode: self.reTbsAssetCode,
          BrandId: self.reTbsBrandId,
          SupplierSpareId: self.reTbsSupplierSpareId,
          SpareUsedStatusId: self.reTbsSpareUsedStatusId,
          OccupiedDaysStart: self.reTbsOccupiedDaysStart,
          OccupiedDaysEnd: self.reTbsOccupiedDaysEnd,
          TransactionDateStart: self.reTbsTransactionDateStart != null ? self.reTbsTransactionDateStart.format("DD/MM/YYYY") : null,
          TransactionDateEnd: self.reTbsTransactionDateEnd != null ? self.reTbsTransactionDateEnd.format("DD/MM/YYYY") : null,
          ReturnTransactionDateStart: self.reTbsReturnTransactionDateStart != null ? self.reTbsReturnTransactionDateStart.format("DD/MM/YYYY") : null,
          ReturnTransactionDateEnd: self.reTbsReturnTransactionDateEnd != null ? self.reTbsReturnTransactionDateEnd.format("DD/MM/YYYY") : null,
          ReturnStatus: self.reTbsReturnStatus
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);

            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreTbsDepartmentMaterialCodeOptions: function LoadreTbsDepartmentMaterialCodeOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.reTbsDepartmentMaterialCodeOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Barcode/Select2DepartmentMaterial", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTbsDepartmentMaterialCodeOptions = [];
            data.forEach(function (element) {
              self.reTbsDepartmentMaterialCodeOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reTbsDepartmentMaterialCodeOptions);
        }).catch(function (error) {});
      }
    },

    LoadreTbsOriginPlantCodeOptions: function LoadreTbsOriginPlantCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Plant/PlantOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbsOriginPlantCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTbsProductTypeIdOptions: function LoadreTbsProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbsProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTbsBrandIdOptions: function LoadreTbsBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbsBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadSupplierSpareOptions: function LoadSupplierSpareOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2SearchSupplierSpareProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.supplierSpareOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadSpareUsedStatusOptions: function LoadSpareUsedStatusOptions(e) {
      var self = this;
      self.spareUsedStatusOptions.push({ id: 0, label: 'ยังไม่ระบุ' }, { id: 1, label: 'ระบุเรียบร้อย' });
    },

    LoadreTbsAssetCodeOptions: function LoadreTbsAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbsAssetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreTbsReturnJobNumberOptions: function LoadreTbsReturnJobNumberOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.reTbsReturnJobNumberOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2ReturnJobNumber", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.reTbsReturnJobNumberOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reTbsReturnJobNumberOptions);
        }).catch(function (error) {});
      }
    },
    LoadreTbsDestinationVendorIdOptions: function LoadreTbsDestinationVendorIdOptions(_ref3) {
      var action = _ref3.action,
          searchQuery = _ref3.searchQuery,
          callback = _ref3.callback;

      var self = this;
      self.reTbsDestinationVendorIdOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Vendors/Select2Vendor", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTbsDestinationVendorIdOptions = [];
            data.forEach(function (element) {
              self.reTbsDestinationVendorIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reTbsDestinationVendorIdOptions);
        });
      }
    },


    reLoadreTbsDestinationVendorIdOptions: function reLoadreTbsDestinationVendorIdOptions() {
      this.$refs.reTbsDestinationVendorId.trigger.searchQuery = null;
    },
    LoadreTbsTransferJobNumberOptions: function LoadreTbsTransferJobNumberOptions(_ref4) {
      var action = _ref4.action,
          searchQuery = _ref4.searchQuery,
          callback = _ref4.callback;

      var self = this;
      self.reTbsTransferJobNumberOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/Report/Select2TransferJobNumber", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTbsTransferJobNumberOptions = [];
            data.forEach(function (element) {
              self.reTbsTransferJobNumberOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.reTbsTransferJobNumberOptions);
        });
      }
    },

    LoadreTbsProductGroupIdOptions: function LoadreTbsProductGroupIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/ProductGroup/Select2ProductGroup", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reTbsProductGroupIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, today, lastYear;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreTbsOriginPlantCodeOptions();
              self.LoadreTbsProductTypeIdOptions();
              self.LoadreTbsBrandIdOptions();
              self.LoadreTbsAssetCodeOptions();

              self.LoadreTbsProductGroupIdOptions();

              self.LoadSupplierSpareOptions();
              self.LoadSpareUsedStatusOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reBcDateReq = moment().format("DD/MM/YYYY h:mm a");

              //====== กำหนดค่าเริ่มต้น วันที่ส่งซ่อม =======
              // สร้างค่าเริ่มต้นย้อนหลัง 1 ปีจากวันนี้
              today = moment();
              //const lastYear = moment().subtract(1, 'year'); // 🔹 ย้อน 1 ปี

              lastYear = moment().startOf('year'); // ต้นปี

              // กำหนดค่า moment ให้ตัวแปรใน Vue (ถ้ามี)

              self.reTbsTransactionDateStart = lastYear;
              self.reTbsTransactionDateEnd = today;

              $(self.$refs.reTbsTransactionDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                //startDate: moment().subtract(2, "years").toDate(), // ตัวอย่าง: อนุญาตย้อนหลัง 2 ปี
                //endDate: moment().add(30, "days").toDate(),
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              // อัปเดตค่าตั้งต้นใน datepicker เป็นย้อนหลัง 1 ปี
              $(self.$refs.reTbsTransactionDateStart).datepicker("update", lastYear.format("DD/MM/YYYY")).on("changeDate", function (e) {
                if (e.dates && e.dates.length) {
                  self.reTbsTransactionDateStart = moment(e.date);
                } else {
                  self.reTbsTransactionDateStart = null;
                }
              });

              ////self.reApLastActivityDateEnd = moment().endOf('month');
              //$(self.$refs.reTbsTransactionDateStart)
              //  .datepicker(
              //    "update",
              //    !!self.reTbsTransactionDateStart
              //      ? self.reTbsTransactionDateStart.format("DD/MM/YYYY")
              //      : null
              //  )
              //  .on("changeDate", function(e) {
              //    self.reTbsTransactionDateStart =
              //      e.dates.length != 0 ? moment(e.date) : null;
              //  });

              $(self.$refs.reTbsTransactionDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                //rtl: KTUtil.isRTL(),
                //minDate: moment(), // Current day
                //maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });

              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reTbsTransactionDateEnd).datepicker("update", today.format("DD/MM/YYYY")).on("changeDate", function (e) {
                if (e.dates && e.dates.length) {
                  self.reTbsTransactionDateEnd = moment(e.date);
                } else {
                  self.reTbsTransactionDateEnd = null;
                }

                //self.reTbsTransactionDateEnd = e.dates.length
                //    ? moment(e.date)
                //    : null;
              });

              //=====
              $(self.$refs.reTbsReturnTransactionDateStart).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reTbsReturnTransactionDateStart).datepicker("update", !!self.reTbsReturnTransactionDateStart ? self.reTbsReturnTransactionDateStart.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reTbsReturnTransactionDateStart = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reTbsReturnTransactionDateEnd).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reApLastActivityDateEnd = moment().endOf('month');
              $(self.$refs.reTbsReturnTransactionDateEnd).datepicker("update", !!self.reTbsReturnTransactionDateEnd ? self.reTbsReturnTransactionDateEnd.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reTbsReturnTransactionDateEnd = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import the component

// import the styles



__webpack_require__(15);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(9);

var ActionWarehouse65Score = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n    <a href=\"#\" @click.prevent=\"export65score\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E1A\u0E1A\u0E1B\u0E23\u0E30\u0E40\u0E21\u0E34\u0E19\u0E28\u0E39\u0E19\u0E22\u0E4C\u0E40\u0E1A\u0E35\u0E22\u0E23\u0E4C\u0E2A\u0E14 65 \u0E04\u0E30\u0E41\u0E19\u0E19\">\n      <i class=\"fas fa-file-export\"></i>\n    </a>\n  ",
  methods: {
    export65score: function export65score() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/Export65Score",
        responseType: "arraybuffer",
        data: {
          AgentCode: this.data.agentCode,
          AnswerId: this.data.answerId
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "ศูนย์เบียร์สด " + filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    }
  }
});

var Action17Score = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <span class=\"dropdown\">\n    <a  class=\" btn btn-sm btn-clean btn-icon btn-icon-md\"  data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" title=\"\u0E41\u0E1A\u0E1A\u0E15\u0E23\u0E27\u0E08 S+\">\n      <i class=\"fas fa-file-export\"></i>\n    </a>\n    <div class=\"dropdown-menu dropdown-primary\">\n    <a class=\"dropdown-item\" href=\"#\" @click.prevent=\"exportWarehouse('\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32')\" >\u0E41\u0E1A\u0E1A\u0E15\u0E23\u0E27\u0E08 S+ (\u0E04\u0E25\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32) 17.5 \u0E04\u0E30\u0E41\u0E19\u0E19</a>\n    <a class=\"dropdown-item\" href=\"#\" @click.prevent=\"exportWarehouse('\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19')\" >\u0E41\u0E1A\u0E1A\u0E15\u0E23\u0E27\u0E08 S+ (\u0E2A\u0E33\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19) 17.5 \u0E04\u0E30\u0E41\u0E19\u0E19</a>\n    </div>\n    </span>\n  ",
  methods: {
    exportWarehouse: function exportWarehouse(assessmentType) {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
      });
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportWarehouse17Score",
        responseType: "arraybuffer",
        data: {
          AgentCode: this.data.agentCode,
          AnswerId: this.data.answerId,
          AssessmentType: assessmentType
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = assessmentType + " " + filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_2__Shared_Select2__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;

    return {
      reAaDateReq: null,

      reStartDate: null,
      reEndDate: null,
      reDepartments: [],
      reAgentCodes: [],
      reGrade: null,
      reKeyword: null,
      reRole: null,
      reDepartmentsOptions: [],
      reIsInitial: true,
      // reDepartmentsOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAgentCodesOptions: [],
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      reGradeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกเกรด",
        allowClear: true,
        data: [{ id: "A", text: "A", data: null }, { id: "B", text: "B", data: null }, { id: "C", text: "C", data: null }, { id: "F", text: "F", data: null }]
      },
      reRoleOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกระดับผู้สำรวจ",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select25sRole",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reDepartments = [];
      self.reAgentCodes = [];
      self.reGrade = null;
      self.reKeyword = null;
      self.reRole = null;

      $("#reStartDate").val("").trigger("change");

      $("#reEndDate").val("").trigger("change");

      $("#reDepartments").val("").trigger("change");

      $("#reAgentCodes").val("").trigger("change");

      $("#reGrade").val("").trigger("change");

      $("#reRole").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#WarehouseScoreTable").DataTable();
      table.draw();
    },
    exportWarehouseScore: function exportWarehouseScore(e) {
      e.preventDefault();
      var self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: "post",
        url: "/Api/Report/ExportWarehouseScore",
        responseType: "arraybuffer",
        data: {
          StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
          EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
          SalesArea: self.reDepartments,
          AgentCode: self.reAgentCodes,
          Grade: self.reGrade,
          SearchKeyword: self.reKeyword,
          RoleCode: self.reRole,
          IsInitial: self.reIsInitial
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];

          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        //self.formReset();
        KTApp.unblockPage();
      });
    },
    LoadreDepartmentsOptions: function LoadreDepartmentsOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/Api/MasterSalesArea/FindOptions", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reDepartmentsOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadreAgentCodesOptions: function LoadreAgentCodesOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S", {
        province_id: [],
        department: [],
        AgentCodes: [],
        page: 1
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.reAgentCodesOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, arrows, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;


              self.LoadreDepartmentsOptions();
              self.LoadreAgentCodesOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }

              self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

              $(self.$refs.reStartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              //self.reStartDate = moment().set("date",1);
              $(self.$refs.reStartDate).datepicker("update", !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.reEndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.reEndDate).datepicker("update", !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $.fn.dataTable.ext.errMode = 'none';
              table = $("#WarehouseScoreTable");

              table.DataTable({
                autoWidth: true,
                scrollY: "100%",
                scrollX: true,
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,

                ajax: {
                  url: "/Api/Report/WarehouseScore",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    var jsonSearch = {
                      StartDate: self.reStartDate != null ? self.reStartDate.format("DD/MM/YYYY") : self.reStartDate,
                      EndDate: self.reEndDate != null ? self.reEndDate.format("DD/MM/YYYY") : self.reEndDate,
                      SalesArea: self.reDepartments,
                      AgentCode: self.reAgentCodes,
                      Grade: self.reGrade,
                      SearchKeyword: self.reKeyword,
                      RoleCode: self.reRole
                    };
                    return JSON.stringify($.extend(d, jsonSearch));
                  }
                },
                // DOM Layout settings
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n  \t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",

                lengthMenu: [30, 50, 100],

                pageLength: 30,

                language: {
                  lengthMenu: "Display _MENU_"
                },
                // Order settings
                order: [[5, "desc"]],
                columns: [{
                  data: "agentCode",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    var t = table.DataTable();
                    var page = t.page.info().start + 1;
                    return page + meta.row;
                  }
                }, { data: "agentName", className: "text-center" }, { data: "department", className: "text-center" }, {
                  data: "warehouse",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data == "") {
                      return "";
                    } else if (data != null) {
                      return full.warehouseString + '<div class="actionWarehouse65Score"></div>';
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "fiveS",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    if (data == "") {
                      return "";
                    } else if (data != null) {
                      return full.fiveSString + '<div class="action17Score"></div>';
                    } else {
                      return "";
                    }
                  }
                }, {
                  data: "totalScore",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.totalScoreString;
                  }
                }, { data: "grade", className: "text-center" }, { data: "fullName", className: "text-center" }, { data: "roleName", className: "text-center" }, {
                  data: "createDate",
                  className: "text-center",
                  render: function render(data, type, full, meta) {
                    return full.createDateString;
                  }
                }],
                drawCallback: function drawCallback(settings) {
                  self.reIsInitial = false;
                  self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
                }
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_6__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("draw.dt", function () {
                $(".actionWarehouse65Score").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new ActionWarehouse65Score({ data: { data: data }, parent: self }).$mount(el);
                  }
                });

                $(".action17Score").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new Action17Score({ data: { data: data }, parent: self }).$mount(el);
                  }
                });
              });

              $(_this.$refs.form).validate().settings.ignore = ":hidden";

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import the component

// import the styles


__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      StartDate: null,
      EndDate: null,
      OdOverMonth: null,
      OdPeriodRange: null,
      OdBarcode: null,
      OdProductTypeId: [],
      OdBrandId: [],
      OdFinishProductId: [],
      OdAssetCode: [],
      OdScanByUser: [],
      ViewPermissionCode: null,
      OdViewPermissionOptions: [],

      OdCurrentLocationPlant: [],
      OdCurrentLocationAgent: [],
      OdCurrentLocationSubAgent: [],
      OdCurrentLocationShop: [],
      OdCurrentLocationSubShop: [],
      OdCurrentLocationVendor: [],
      OdEmpId: [],
      OdProductTypeIdOptions: [],
      OdBrandIdOptions: [],
      OdFinishProductIdOptions: [],
      OdAssetCodeOptions: [],
      OdScanByUserOptions: [],
      OdCurrentLocationPlantOptions: [],
      OdCurrentLocationAgentOptions: [],
      OdCurrentLocationSubAgentOptions: [],
      OdCurrentLocationShopOptions: [],
      OdCurrentLocationSubShopOptions: [],
      OdCurrentLocationVendorOptions: [],
      OdEmpIdOptions: [],
      OdPeriodRangeOptions: []

    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.StartDate = null;
      self.EndDate = null;
      self.OdOverMonth = null;
      self.OdPeriodRange = null;
      self.OdBarcode = null;
      self.OdProductTypeId = [];
      self.OdBrandId = [];
      self.OdFinishProductId = [];
      self.OdAssetCode = [];
      self.OdScanByUser = [];
      self.OdCurrentLocationPlant = [];
      self.OdCurrentLocationAgent = [];
      self.OdCurrentLocationSubAgent = [];
      self.OdCurrentLocationShop = [];
      self.OdCurrentLocationSubShop = [];
      self.OdCurrentLocationVendor = [];
      self.OdEmpId = [];

      $("#StartDate").val("").trigger("change");
      $("#EndDate").val("").trigger("change");
      $("#OdOverMonth").val("").trigger("change");
      $("#OdPeriodRange").val("").trigger("change");
      $("#OdBarcode").val("").trigger("change");
      $("#OdProductTypeId").val("").trigger("change");
      $("#OdBrandId").val("").trigger("change");
      $("#OdFinishProductId").val("").trigger("change");
      $("#OdAssetCode").val("").trigger("change");
      $("#OdScanByUser").val("").trigger("change");
      $("#OdCurrentLocationPlant").val("").trigger("change");
      $("#OdCurrentLocationAgent").val("").trigger("change");
      $("#OdCurrentLocationSubAgent").val("").trigger("change");
      $("#OdCurrentLocationShop").val("").trigger("change");
      $("#OdCurrentLocationSubShop").val("").trigger("change");
      $("#OdCurrentLocationVendor").val("").trigger("change");
      $("#OdEmpId").val("").trigger("change");
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#brandCountTable").DataTable();
      table.draw();
    },
    exportOverdueAll: function exportOverdueAll(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      var curentShop = [];
      if (self.OdCurrentLocationSubAgent.length != 0 || self.OdCurrentLocationShop.length) {
        curentShop = self.OdCurrentLocationSubAgent.concat(self.OdCurrentLocationShop);
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/ReportOverdue/ExportBeforedueAll",
        responseType: "arraybuffer",
        data: {
          //StartDate: self.StartDate,
          //EndDate: self.EndDate,
          StartDate: self.StartDate != null ? self.StartDate.format("DD/MM/YYYY") : self.StartDate,
          EndDate: self.EndDate != null ? self.EndDate.format("DD/MM/YYYY") : self.EndDate,

          Barcode: self.OdBarcode,
          ProductTypeId: self.OdProductTypeId,
          ProductCode: self.OdAssetCode,
          BrandId: self.OdBrandId,
          FinishProductIds: self.OdFinishProductId,
          ViewPermissionCode: self.ViewPermissionCode,
          OdOverMonth: self.OdOverMonth != null ? self.OdOverMonth.format("MM/YYYY") : self.OdOverMonth,
          OdPeriodRange: self.OdPeriodRange,
          OdScanByUser: self.OdScanByUser,
          CurrentLocationPlant: self.OdCurrentLocationPlant,
          CurrentLocationAgent: self.OdCurrentLocationAgent,
          CurrentLocationSubAgent: self.OdCurrentLocationSubAgent,
          CurrentLocationShop: self.OdCurrentLocationShop,
          CurrentLocationSubShop: self.OdCurrentLocationSubShop,
          CurrentLocationVendor: self.OdCurrentLocationVendor,
          CurrentLocationEmp: self.OdEmpId
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },

    LoadOdProductTypeIdOptions: function LoadOdProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OdProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadOdBrandIdOptions: function LoadOdBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OdBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    reLoadOdFinishProductIdOptions: function reLoadOdFinishProductIdOptions() {
      this.$refs.OdFinishProductId.trigger.searchQuery = null;
    },
    LoadOdFinishProductIdOptions: function LoadOdFinishProductIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.OdFinishProductIdOptions = [];

      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/product/Select2ProductReport", {
          page: 1,
          all: true,
          search: searchQuery,
          productBrandIds: self.OdBrandId,
          productGroupIds: [14]
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdFinishProductIdOptions = [];
            data.forEach(function (element) {
              self.OdFinishProductIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdFinishProductIdOptions);
        });
      }
    },

    LoadOdAssetCodeOptions: function LoadOdAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true,
          excludeProductGroupId: 14
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OdAssetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadOdScanByUserOptions: function LoadOdScanByUserOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ReportOverdue/Select2OverdueAlertUserOption", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.OdScanByUserOptions = [];
          data.forEach(function (element) {
            self.OdScanByUserOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    LoadOdCurrentLocationPlantOptions: function LoadOdCurrentLocationPlantOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Plant/Select2Plant", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OdCurrentLocationPlantOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadOdCurrentLocationAgentOptions: function LoadOdCurrentLocationAgentOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Report/Select2Agent", {
        page: 1,
        province_id: [],
        department: [],
        AgentCodes: [],
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OdCurrentLocationAgentOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    reLoadOdCurrentLocationSubAgentOptions: function reLoadOdCurrentLocationSubAgentOptions() {
      this.$refs.OdCurrentLocationSubAgent.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationSubAgentOptions: function LoadOdCurrentLocationSubAgentOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.OdCurrentLocationSubAgentOptions = [];

      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Report/Select2SubShopAgent", {
          page: 1,
          onlySubAgent: true,
          all: true,
          search: searchQuery,
          agentCodes: self.OdCurrentLocationAgent,
          shopCodes: self.OdCurrentLocationShop
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdCurrentLocationSubAgentOptions = [];
            data.forEach(function (element) {
              self.OdCurrentLocationSubAgentOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdCurrentLocationSubAgentOptions);
        });
      }
    },

    reLoadOdCurrentLocationShopOptions: function reLoadOdCurrentLocationShopOptions() {
      this.$refs.OdCurrentLocationShop.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationShopOptions: function LoadOdCurrentLocationShopOptions(_ref3) {
      var action = _ref3.action,
          searchQuery = _ref3.searchQuery,
          callback = _ref3.callback;

      var self = this;
      self.OdCurrentLocationShopOptions = [];

      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Shop/Select2ShopByAgentAlerReport", {
          page: 1,
          all: true,
          agentCodes: self.OdCurrentLocationAgent,
          customerCode: self.OdCurrentLocationSubAgent,
          search: searchQuery
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdCurrentLocationShopOptions = [];
            data.forEach(function (element) {
              self.OdCurrentLocationShopOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdCurrentLocationShopOptions);
        });
      }
    },

    reLoadOdCurrentLocationSubShopOptions: function reLoadOdCurrentLocationSubShopOptions() {
      this.$refs.OdCurrentLocationSubShop.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationSubShopOptions: function LoadOdCurrentLocationSubShopOptions(_ref4) {
      var action = _ref4.action,
          searchQuery = _ref4.searchQuery,
          callback = _ref4.callback;

      var self = this;
      self.OdCurrentLocationSubShopOptions = [];
      var allShops = [];

      if (self.OdCurrentLocationSubAgent != null && self.OdCurrentLocationSubAgent.length > 0) {
        for (var i = 0, len = self.OdCurrentLocationSubAgent.length; i < len; ++i) {
          allShops.push(self.OdCurrentLocationSubAgent[i]);
        }
      }
      if (self.OdCurrentLocationShop != null && self.OdCurrentLocationShop.length > 0) {
        for (var i = 0, len = self.OdCurrentLocationShop.length; i < len; ++i) {
          allShops.push(self.OdCurrentLocationShop[i]);
        }
      }

      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Shop/SubShopOptionAlertReport", {

          page: 1,
          all: true,
          search: searchQuery,
          agentCodes: self.OdCurrentLocationAgent,
          shopCodes: allShops
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdCurrentLocationSubShopOptions = [];
            data.forEach(function (element) {
              self.OdCurrentLocationSubShopOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdCurrentLocationSubShopOptions);
        });
      }
    },

    reLoadOdCurrentLocationVendorOptions: function reLoadOdCurrentLocationVendorOptions() {
      this.$refs.OdCurrentLocationVendor.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationVendorOptions: function LoadOdCurrentLocationVendorOptions(_ref5) {
      var action = _ref5.action,
          searchQuery = _ref5.searchQuery,
          callback = _ref5.callback;

      var self = this;
      self.OdCurrentLocationVendorOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Vendors/Select2Vendor", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdCurrentLocationVendorOptions = [];
            data.forEach(function (element) {
              self.OdCurrentLocationVendorOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdCurrentLocationVendorOptions);
        }).catch(function (error) {});
      }
    },

    reLoadOdEmpIdOptions: function reLoadOdEmpIdOptions() {
      this.$refs.OdEmpId.trigger.searchQuery = null;
    },
    LoadOdEmpIdOptions: function LoadOdEmpIdOptions(_ref6) {
      var action = _ref6.action,
          searchQuery = _ref6.searchQuery,
          callback = _ref6.callback;

      var self = this;
      self.OdEmpIdOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Employee/Select2Employee", {
          params: { page: 1, all: true, search: searchQuery }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdEmpIdOptions = [];
            data.forEach(function (element) {
              self.OdEmpIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdEmpIdOptions);
        }).catch(function (error) {});
      }
    },
    LoadOdPeriodOptions: function LoadOdPeriodOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ReportOverdue/Select2PeriodOption", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.OdPeriodRangeOptions = [];
          data.forEach(function (element) {
            self.OdPeriodRangeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadOdViewReturnProductOptions: function LoadOdViewReturnProductOptions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var self;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Report/Select2ViewReturnProduct", { params: { search: '1' } }).then(function (response) {
                  if (response.status == 200) {
                    var data = response.data.results;
                    data.forEach(function (element) {
                      self.OdViewPermissionOptions.push({
                        id: element.id,
                        label: element.text
                      });
                      if (element.data == "active") {
                        self.ViewPermissionCode = element.id;
                      }
                    });
                  }
                }).catch(function (error) {});

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    ChangeOptions: function ChangeOptions(type) {
      var self = this;
      if (type == "View") {
        self.formReset();
      }
    },

    OdBrandIdDeSelect: function OdBrandIdDeSelect() {
      var self = this;
      self.OdFinishProductId = [];

      $("#OdFinishProductId").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    OdBrandIdClearAfterselect: function OdBrandIdClearAfterselect() {
      var self = this;
      self.OdFinishProductId = [];

      $("#OdFinishProductId").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    AgentClearAfterselect: function AgentClearAfterselect() {
      var self = this;
      self.OdCurrentLocationSubAgent = [];
      self.OdCurrentLocationShop = [];
      self.OdCurrentLocationSubShop = [];

      $("#OdCurrentLocationSubAgent").val("").trigger("change");
      $("#OdCurrentLocationShop").val("").trigger("change");
      $("#OdCurrentLocationSubShop").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    SubAgentClearAfterselect: function SubAgentClearAfterselect() {
      var self = this;
      self.OdCurrentLocationShop = [];
      self.OdCurrentLocationSubShop = [];

      $("#OdCurrentLocationShop").val("").trigger("change");
      $("#OdCurrentLocationSubShop").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    ShopClearAfterselect: function ShopClearAfterselect() {
      var self = this;
      self.OdCurrentLocationSubShop = [];
      $("#OdCurrentLocationSubShop").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },

    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, arrows;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this2;


              $(self.$refs.StartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.StartDate).datepicker("update", !!self.StartDate ? self.StartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.StartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.EndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.EndDate).datepicker("update", !!self.EndDate ? self.EndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.EndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.OdOverMonth).datepicker({
                format: "mm/yyyy",
                viewMode: "months",
                minViewMode: "months",
                autoclose: true,
                clearBtn: true,
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                templates: arrows
              });
              $(self.$refs.OdOverMonth).datepicker("update", !!self.OdOverMonth ? self.OdOverMonth.format("MM/YYYY") : null).on("changeDate", function (e) {
                self.OdOverMonth = e.dates.length != 0 ? moment(e.date) : null;
              });

              _context2.next = 9;
              return self.LoadOdViewReturnProductOptions();

            case 9:
              self.LoadOdProductTypeIdOptions();
              self.LoadOdBrandIdOptions();
              self.LoadOdAssetCodeOptions();
              self.LoadOdCurrentLocationPlantOptions();
              self.LoadOdCurrentLocationAgentOptions();
              //self.LoadOdCurrentLocationSubAgentOptions();
              self.LoadOdPeriodOptions();
              self.LoadOdScanByUserOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }
              $(_this2.$refs.form).validate().settings.ignore = ":hidden";

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import the component

// import the styles


__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_0__Shared_Select2__["a" /* default */],
    Collapsible: __WEBPACK_IMPORTED_MODULE_2__Shared_Collapsible__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      StartDate: null,
      EndDate: null,
      OdOverMonth: null,
      OdPeriodRange: null,
      OdBarcode: null,
      OdProductTypeId: [],
      OdBrandId: [],
      OdFinishProductId: [],
      OdAssetCode: [],
      OdScanByUser: [],
      ViewPermissionCode: null,
      OdViewPermissionOptions: [],

      OdCurrentLocationPlant: [],
      OdCurrentLocationAgent: [],
      OdCurrentLocationSubAgent: [],
      OdCurrentLocationShop: [],
      OdCurrentLocationSubShop: [],
      OdCurrentLocationVendor: [],
      OdEmpId: [],
      OdProductTypeIdOptions: [],
      OdBrandIdOptions: [],
      OdFinishProductIdOptions: [],
      OdAssetCodeOptions: [],
      OdScanByUserOptions: [],
      OdCurrentLocationPlantOptions: [],
      OdCurrentLocationAgentOptions: [],
      OdCurrentLocationSubAgentOptions: [],
      OdCurrentLocationShopOptions: [],
      OdCurrentLocationSubShopOptions: [],
      OdCurrentLocationVendorOptions: [],
      OdEmpIdOptions: [],
      OdPeriodRangeOptions: []

    };
  },
  computed: {},
  methods: {
    formReset: function formReset(e) {
      var self = this;
      self.StartDate = null;
      self.EndDate = null;
      self.OdOverMonth = null;
      self.OdPeriodRange = null;
      self.OdBarcode = null;
      self.OdProductTypeId = [];
      self.OdBrandId = [];
      self.OdFinishProductId = [];
      self.OdAssetCode = [];
      self.OdScanByUser = [];
      self.OdCurrentLocationPlant = [];
      self.OdCurrentLocationAgent = [];
      self.OdCurrentLocationSubAgent = [];
      self.OdCurrentLocationShop = [];
      self.OdCurrentLocationSubShop = [];
      self.OdCurrentLocationVendor = [];
      self.OdEmpId = [];

      $("#StartDate").val("").trigger("change");
      $("#EndDate").val("").trigger("change");
      $("#OdOverMonth").val("").trigger("change");
      $("#OdPeriodRange").val("").trigger("change");
      $("#OdBarcode").val("").trigger("change");
      $("#OdProductTypeId").val("").trigger("change");
      $("#OdBrandId").val("").trigger("change");
      $("#OdFinishProductId").val("").trigger("change");
      $("#OdAssetCode").val("").trigger("change");
      $("#OdScanByUser").val("").trigger("change");
      $("#OdCurrentLocationPlant").val("").trigger("change");
      $("#OdCurrentLocationAgent").val("").trigger("change");
      $("#OdCurrentLocationSubAgent").val("").trigger("change");
      $("#OdCurrentLocationShop").val("").trigger("change");
      $("#OdCurrentLocationSubShop").val("").trigger("change");
      $("#OdCurrentLocationVendor").val("").trigger("change");
      $("#OdEmpId").val("").trigger("change");
    },
    formSubmit: function formSubmit(e) {
      var self = this;

      e.preventDefault();
      var table = $("#brandCountTable").DataTable();
      table.draw();
    },
    exportOverdueAll: function exportOverdueAll(e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
      });

      var curentShop = [];
      if (self.OdCurrentLocationSubAgent.length != 0 || self.OdCurrentLocationShop.length) {
        curentShop = self.OdCurrentLocationSubAgent.concat(self.OdCurrentLocationShop);
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: "post",
        url: "/Api/ReportOverdue/ExportOverdueAll",
        responseType: "arraybuffer",
        data: {
          //StartDate: self.StartDate,
          //EndDate: self.EndDate,
          StartDate: self.StartDate != null ? self.StartDate.format("DD/MM/YYYY") : self.StartDate,
          EndDate: self.EndDate != null ? self.EndDate.format("DD/MM/YYYY") : self.EndDate,

          Barcode: self.OdBarcode,
          ProductTypeId: self.OdProductTypeId,
          ProductCode: self.OdAssetCode,
          BrandId: self.OdBrandId,
          FinishProductIds: self.OdFinishProductId,
          ViewPermissionCode: self.ViewPermissionCode,
          OdOverMonth: self.OdOverMonth != null ? self.OdOverMonth.format("MM/YYYY") : self.OdOverMonth,
          OdPeriodRange: self.OdPeriodRange,
          OdScanByUser: self.OdScanByUser,
          CurrentLocationPlant: self.OdCurrentLocationPlant,
          CurrentLocationAgent: self.OdCurrentLocationAgent,
          CurrentLocationSubAgent: self.OdCurrentLocationSubAgent,
          CurrentLocationShop: self.OdCurrentLocationShop,
          CurrentLocationSubShop: self.OdCurrentLocationSubShop,
          CurrentLocationVendor: self.OdCurrentLocationVendor,
          CurrentLocationEmp: self.OdEmpId
        }
      }).then(function (response) {
        if (response.status == "200") {
          var filename = "";
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลคงค้างเกินกำหนดหรือไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },

    LoadOdProductTypeIdOptions: function LoadOdProductTypeIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductType/Select2ProductType", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OdProductTypeIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadOdBrandIdOptions: function LoadOdBrandIdOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OdBrandIdOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    reLoadOdFinishProductIdOptions: function reLoadOdFinishProductIdOptions() {
      this.$refs.OdFinishProductId.trigger.searchQuery = null;
    },
    LoadOdFinishProductIdOptions: function LoadOdFinishProductIdOptions(_ref) {
      var action = _ref.action,
          searchQuery = _ref.searchQuery,
          callback = _ref.callback;

      var self = this;
      self.OdFinishProductIdOptions = [];

      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/product/Select2ProductReport", {
          page: 1,
          all: true,
          search: searchQuery,
          productBrandIds: self.OdBrandId,
          productGroupIds: [14]
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdFinishProductIdOptions = [];
            data.forEach(function (element) {
              self.OdFinishProductIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdFinishProductIdOptions);
        });
      }
    },

    LoadOdAssetCodeOptions: function LoadOdAssetCodeOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Product/Select2Product", {
        params: {
          page: 1,
          all: true,
          excludeProductGroupId: 14
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OdAssetCodeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadOdScanByUserOptions: function LoadOdScanByUserOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ReportOverdue/Select2OverdueAlertUserOption", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.OdScanByUserOptions = [];
          data.forEach(function (element) {
            self.OdScanByUserOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },

    LoadOdCurrentLocationPlantOptions: function LoadOdCurrentLocationPlantOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Plant/Select2Plant", {
        page: 1,
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OdCurrentLocationPlantOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadOdCurrentLocationAgentOptions: function LoadOdCurrentLocationAgentOptions(e) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Report/Select2Agent", {
        page: 1,
        province_id: [],
        department: [],
        AgentCodes: [],
        all: true
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          data.forEach(function (element) {
            self.OdCurrentLocationAgentOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    reLoadOdCurrentLocationSubAgentOptions: function reLoadOdCurrentLocationSubAgentOptions() {
      this.$refs.OdCurrentLocationSubAgent.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationSubAgentOptions: function LoadOdCurrentLocationSubAgentOptions(_ref2) {
      var action = _ref2.action,
          searchQuery = _ref2.searchQuery,
          callback = _ref2.callback;

      var self = this;
      self.OdCurrentLocationSubAgentOptions = [];

      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Report/Select2SubShopAgent", {
          page: 1,
          onlySubAgent: true,
          all: true,
          search: searchQuery,
          agentCodes: self.OdCurrentLocationAgent,
          shopCodes: self.OdCurrentLocationShop
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdCurrentLocationSubAgentOptions = [];
            data.forEach(function (element) {
              self.OdCurrentLocationSubAgentOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdCurrentLocationSubAgentOptions);
        });
      }
    },

    reLoadOdCurrentLocationShopOptions: function reLoadOdCurrentLocationShopOptions() {
      this.$refs.OdCurrentLocationShop.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationShopOptions: function LoadOdCurrentLocationShopOptions(_ref3) {
      var action = _ref3.action,
          searchQuery = _ref3.searchQuery,
          callback = _ref3.callback;

      var self = this;
      self.OdCurrentLocationShopOptions = [];

      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Shop/Select2ShopByAgentAlerReport", {
          page: 1,
          all: true,
          agentCodes: self.OdCurrentLocationAgent,
          customerCode: self.OdCurrentLocationSubAgent,
          search: searchQuery
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdCurrentLocationShopOptions = [];
            data.forEach(function (element) {
              self.OdCurrentLocationShopOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdCurrentLocationShopOptions);
        });
      }
    },

    reLoadOdCurrentLocationSubShopOptions: function reLoadOdCurrentLocationSubShopOptions() {
      this.$refs.OdCurrentLocationSubShop.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationSubShopOptions: function LoadOdCurrentLocationSubShopOptions(_ref4) {
      var action = _ref4.action,
          searchQuery = _ref4.searchQuery,
          callback = _ref4.callback;

      var self = this;
      self.OdCurrentLocationSubShopOptions = [];
      var allShops = [];

      if (self.OdCurrentLocationSubAgent != null && self.OdCurrentLocationSubAgent.length > 0) {
        for (var i = 0, len = self.OdCurrentLocationSubAgent.length; i < len; ++i) {
          allShops.push(self.OdCurrentLocationSubAgent[i]);
        }
      }
      if (self.OdCurrentLocationShop != null && self.OdCurrentLocationShop.length > 0) {
        for (var i = 0, len = self.OdCurrentLocationShop.length; i < len; ++i) {
          allShops.push(self.OdCurrentLocationShop[i]);
        }
      }

      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/Shop/SubShopOptionAlertReport", {

          page: 1,
          all: true,
          search: searchQuery,
          agentCodes: self.OdCurrentLocationAgent,
          shopCodes: allShops
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdCurrentLocationSubShopOptions = [];
            data.forEach(function (element) {
              self.OdCurrentLocationSubShopOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdCurrentLocationSubShopOptions);
        });
      }
    },

    reLoadOdCurrentLocationVendorOptions: function reLoadOdCurrentLocationVendorOptions() {
      this.$refs.OdCurrentLocationVendor.trigger.searchQuery = null;
    },
    LoadOdCurrentLocationVendorOptions: function LoadOdCurrentLocationVendorOptions(_ref5) {
      var action = _ref5.action,
          searchQuery = _ref5.searchQuery,
          callback = _ref5.callback;

      var self = this;
      self.OdCurrentLocationVendorOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Vendors/Select2Vendor", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdCurrentLocationVendorOptions = [];
            data.forEach(function (element) {
              self.OdCurrentLocationVendorOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdCurrentLocationVendorOptions);
        }).catch(function (error) {});
      }
    },

    reLoadOdEmpIdOptions: function reLoadOdEmpIdOptions() {
      this.$refs.OdEmpId.trigger.searchQuery = null;
    },
    LoadOdEmpIdOptions: function LoadOdEmpIdOptions(_ref6) {
      var action = _ref6.action,
          searchQuery = _ref6.searchQuery,
          callback = _ref6.callback;

      var self = this;
      self.OdEmpIdOptions = [];
      if (action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["ASYNC_SEARCH"]) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Employee/Select2Employee", {
          params: { page: 1, all: true, search: searchQuery }
        }).then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.OdEmpIdOptions = [];
            data.forEach(function (element) {
              self.OdEmpIdOptions.push({
                id: element.id,
                label: element.text
              });
            });
          }
          callback(null, self.OdEmpIdOptions);
        }).catch(function (error) {});
      }
    },
    LoadOdPeriodOptions: function LoadOdPeriodOptions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/ReportOverdue/Select2PeriodOption", {
        params: {
          page: 1,
          all: true
        }
      }).then(function (response) {
        if (response.status == 200) {
          var data = response.data.results;
          self.OdPeriodRangeOptions = [];
          data.forEach(function (element) {
            self.OdPeriodRangeOptions.push({
              id: element.id,
              label: element.text
            });
          });
        }
      }).catch(function (error) {});
    },
    LoadOdViewReturnProductOptions: function LoadOdViewReturnProductOptions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var self;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Report/Select2ViewReturnProduct", { params: { search: '1' } }).then(function (response) {
                  if (response.status == 200) {
                    var data = response.data.results;
                    data.forEach(function (element) {
                      self.OdViewPermissionOptions.push({
                        id: element.id,
                        label: element.text
                      });
                      if (element.data == "active") {
                        self.ViewPermissionCode = element.id;
                      }
                    });
                  }
                }).catch(function (error) {});

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    ChangeOptions: function ChangeOptions(type) {
      var self = this;
      if (type == "View") {
        self.formReset();
      }
    },

    OdBrandIdDeSelect: function OdBrandIdDeSelect() {
      var self = this;
      self.OdFinishProductId = [];

      $("#OdFinishProductId").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    OdBrandIdClearAfterselect: function OdBrandIdClearAfterselect() {
      var self = this;
      self.OdFinishProductId = [];

      $("#OdFinishProductId").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    AgentClearAfterselect: function AgentClearAfterselect() {
      var self = this;
      self.OdCurrentLocationSubAgent = [];
      self.OdCurrentLocationShop = [];
      self.OdCurrentLocationSubShop = [];

      $("#OdCurrentLocationSubAgent").val("").trigger("change");
      $("#OdCurrentLocationShop").val("").trigger("change");
      $("#OdCurrentLocationSubShop").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    SubAgentClearAfterselect: function SubAgentClearAfterselect() {
      var self = this;
      self.OdCurrentLocationShop = [];
      self.OdCurrentLocationSubShop = [];

      $("#OdCurrentLocationShop").val("").trigger("change");
      $("#OdCurrentLocationSubShop").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },
    ShopClearAfterselect: function ShopClearAfterselect() {
      var self = this;
      self.OdCurrentLocationSubShop = [];
      $("#OdCurrentLocationSubShop").val("").trigger("change");
      $("[class=\"vue-treeselect__input\"]").val("");
    },

    ClearAfterselect: function ClearAfterselect() {
      $("[class=\"vue-treeselect__input\"]").val("");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, arrows;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this2;


              $(self.$refs.StartDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.StartDate).datepicker("update", !!self.StartDate ? self.StartDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.StartDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.EndDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                minDate: moment(), // Current day
                maxDate: moment().add(30, "days"), // 30 days from the current day
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              $(self.$refs.EndDate).datepicker("update", !!self.EndDate ? self.EndDate.format("DD/MM/YYYY") : null).on("changeDate", function (e) {
                self.EndDate = e.dates.length != 0 ? moment(e.date) : null;
              });

              $(self.$refs.OdOverMonth).datepicker({
                format: "mm/yyyy",
                viewMode: "months",
                minViewMode: "months",
                autoclose: true,
                clearBtn: true,
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                templates: arrows
              });
              $(self.$refs.OdOverMonth).datepicker("update", !!self.OdOverMonth ? self.OdOverMonth.format("MM/YYYY") : null).on("changeDate", function (e) {
                self.OdOverMonth = e.dates.length != 0 ? moment(e.date) : null;
              });

              _context2.next = 9;
              return self.LoadOdViewReturnProductOptions();

            case 9:
              self.LoadOdProductTypeIdOptions();
              self.LoadOdBrandIdOptions();
              self.LoadOdAssetCodeOptions();
              self.LoadOdCurrentLocationPlantOptions();
              self.LoadOdCurrentLocationAgentOptions();
              //self.LoadOdCurrentLocationSubAgentOptions();
              self.LoadOdPeriodOptions();
              self.LoadOdScanByUserOptions();

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }
              $(_this2.$refs.form).validate().settings.ignore = ":hidden";

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    var currentYear = new Date().getFullYear();
    var authTransport = function authTransport(params, success, failure) {
      params.beforeSend = function (request) {
        request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
      };
      var $request = $.ajax(params);
      $request.then(success);
      $request.fail(failure);
      return $request;
    };

    return {
      isSaving: false,
      uidCounter: 1,
      rows: [], // seeded with one empty row in created()
      currentYear: currentYear,

      // Import (ตาม wireframe §1.2 — Import + Download Template อยู่หน้า Add)
      importFile: null,
      importFileName: "",
      lastImportRows: null,

      // เดือน (value = 1..12) — แสดง label เป็นตัวย่อ JAN–DEC ให้ตรงกับ Template/Import (#18 verify)
      monthOptions: [{ value: 1, text: "JAN" }, { value: 2, text: "FEB" }, { value: 3, text: "MAR" }, { value: 4, text: "APR" }, { value: 5, text: "MAY" }, { value: 6, text: "JUN" }, { value: 7, text: "JUL" }, { value: 8, text: "AUG" }, { value: 9, text: "SEP" }, { value: 10, text: "OCT" }, { value: 11, text: "NOV" }, { value: 12, text: "DEC" }],

      // R2-1 (spec B31): ย้อนหลัง 1 ปี + ปัจจุบัน + ล่วงหน้า 1 ปี = {cur-1, cur, cur+1} เรียงมาก→น้อย.
      // create/import ย้อนหลังได้ 1 ปี (กฎแก้ไขคงเดิม: ปีเก่า read-only). ตรงกับ BE import year-validate.
      yearOptions: [currentYear + 1, currentYear, currentYear - 1],

      // Plant Select2 (POST /Api/StockCoverDayTarget/Select2Plant, scoped + เฉพาะคลังที่ติ๊ก "ใช้งาน SCVD" — F6)
      plantOptions: {
        placeholder: "เลือก Plant",
        allowClear: true,
        ajax: {
          url: "/Api/StockCoverDayTarget/Select2Plant",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            return JSON.stringify({
              plantId: [],
              search: params.term || "",
              page: params.page || 1
            });
          },
          processResults: function processResults(data) {
            return {
              results: data.results,
              pagination: { more: data.more }
            };
          },
          transport: authTransport
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูล Plant";
          }
        }
      },

      // Product Select2 (GET /Api/Product/Select2Product?productGroupId=14&productTypeId=22)
      productOptions: {
        placeholder: "เลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          delay: 300,
          data: function data(params) {
            return {
              productGroupId: 14,
              productTypeId: 22,
              onlyStockCoverDays: true, // CR-StockCoverDays A3: เฉพาะ SKU ที่เปิดใช้งาน SCVD
              search: params.term || "",
              page: params.page || 1
            };
          },
          processResults: function processResults(data) {
            return {
              results: data.results,
              pagination: { more: data.more }
            };
          },
          transport: authTransport
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลสินค้า";
          }
        }
      }
    };
  },
  created: function created() {
    // QA BUG-12: หน้าเพิ่มข้อมูลเฉพาะสิทธิ์เขียน SCVD (Admin + Team · เงื่อนไขเดียวกับปุ่ม "เพิ่มข้อมูลตามเป้าหมาย" หน้า List)
    // Viewer เปิด URL ตรง → หน้า Unauthorized (route meta ยังรวม SCVD_VIEWER เพื่อไม่กระทบ identity-role gate เดิม)
    if (!this.$root.canShow([["SCVD_ADMIN", "COMPANY_PROFILE_TYPE_SCVD"], ["SCVD_TEAM_EDIT", "COMPANY_PROFILE_TYPE_SCVD"]])) {
      this.$router.replace({ path: "/Error/Unauthorized" });
      return;
    }
    // เริ่มต้นด้วย 1 แถวว่าง
    this.rows = [this.buildRow()];
  },
  mounted: function mounted() {
    // jQuery validate on the form ref (THAI messages via data-msg-required attributes)
    if (this.$refs.scvdForm) {
      $(this.$refs.scvdForm).validate({
        errorElement: "span",
        errorClass: "text-danger",
        highlight: function highlight(element) {
          $(element).addClass("is-invalid");
        },
        unhighlight: function unhighlight(element) {
          $(element).removeClass("is-invalid");
        }
      });
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.push("/StockCoverDays/List");
    },

    buildRow: function buildRow() {
      this.uidCounter++;
      return {
        _uid: this.uidCounter,
        _hasError: false,
        month: "",
        year: this.currentYear, // default = current year (no backdating)
        saleDays: "", // QA BUG-08: ไม่มีค่าเริ่มต้น — ผู้ใช้ต้องกรอกเอง (อยากได้ 0 ต้องพิมพ์ 0)
        plantCode: "",
        plantName: "",
        productCode: "",
        productName: "",
        bgStock: "",
        bgStockText: "",
        demand: "",
        demandText: "",
        supply: "",
        supplyText: "",
        scvd: null
      };
    },

    addRow: function addRow() {
      this.rows.push(this.buildRow());
    },

    removeRow: function removeRow(index) {
      var self = this;
      Swal.fire({
        title: "ยืนยันการลบ",
        text: "คุณต้องการลบรายการนี้หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ใช่, ลบ",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          self.rows.splice(index, 1);
        }
      });
    },

    findRow: function findRow(uid) {
      for (var i = 0; i < this.rows.length; i++) {
        if (this.rows[i]._uid === uid) return this.rows[i];
      }
      return null;
    },

    // Plant selected → set code + auto-fill name from option text (A3)
    onPlantChange: function onPlantChange(id, value, data, uid) {
      var row = this.findRow(uid);
      if (!row) return;
      if (data && data.length && data[0].id) {
        row.plantCode = data[0].id;
        row.plantName = data[0].text || "";
      } else {
        row.plantCode = "";
        row.plantName = "";
      }
    },

    // Product selected → set code + auto-fill name from option text (A3)
    onProductChange: function onProductChange(id, value, data, uid) {
      var row = this.findRow(uid);
      if (!row) return;
      if (data && data.length && data[0].id) {
        row.productCode = data[0].id;
        row.productName = data[0].text || "";
      } else {
        row.productCode = "";
        row.productName = "";
      }
    },

    // Integer-only keydown filter (no decimal, no minus)
    onIntKeydown: function onIntKeydown(event) {
      var allowedKeys = ["Backspace", "Delete", "Tab", "Escape", "Enter", "Home", "End", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
      if (allowedKeys.indexOf(event.key) !== -1) return;
      if ((event.ctrlKey || event.metaKey) && ["a", "c", "v", "x"].indexOf(event.key.toLowerCase()) !== -1) {
        return;
      }
      if (/^[0-9]$/.test(event.key)) return;
      event.preventDefault();
      // QA BUG-09/10/11: ไม่รับตัวอักษร/ค่าติดลบ — ค่าในช่องไม่เปลี่ยน แต่แจ้งผู้ใช้ (เดิมตัดทิ้งเงียบ ๆ)
      if (event.key && event.key.length === 1) {
        this.warnInvalidKey(event.key === "-" ? "ไม่รับค่าติดลบ กรุณากรอกตัวเลข 0 ขึ้นไป" : "กรุณากรอกเฉพาะตัวเลข");
      }
    },
    warnInvalidKey: function warnInvalidKey(message) {
      Swal.fire({
        toast: true,
        position: "top-end",
        type: "warning",
        title: message,
        showConfirmButton: false,
        timer: 2500
      });
    },

    onSaleDaysBlur: function onSaleDaysBlur(row, event) {
      var raw = (event.target.value || "").trim();
      // QA BUG-08/09/10: ช่องว่างคงว่าง (บังคับกรอกตอนบันทึก) · ค่าผิด (วางข้อความ/ติดลบ/เกิน 31) → แจ้งและล้างช่อง
      // ไม่แปลงค่าเองเงียบ ๆ
      if (raw === "") {
        row.saleDays = "";
      } else if (!/^\d+$/.test(raw)) {
        Swal.fire("ข้อมูลไม่ถูกต้อง", "จำนวนวันขายต้องเป็นตัวเลขจำนวนเต็มระหว่าง 0 ถึง 31", "warning");
        row.saleDays = "";
      } else if (parseInt(raw, 10) > 31) {
        Swal.fire("ข้อมูลไม่ถูกต้อง", "จำนวนวันขายต้องอยู่ระหว่าง 0 ถึง 31", "warning");
        row.saleDays = "";
      } else {
        row.saleDays = parseInt(raw, 10);
      }
      this.computeScvd(row);
    },

    // BG / Demand / Supply — reuse the project's en-US thousands format (mirror Detail.vue formatInt).
    // Source of truth = numeric row[field]; row[field+'Text'] is the formatted display twin.
    formatThousands: function formatThousands(v) {
      if (v === "" || v === null || v === undefined) return "";
      var n = parseInt(String(v).replace(/,/g, ""), 10);
      if (isNaN(n)) return "";
      return n.toLocaleString("en-US");
    },
    stripThousands: function stripThousands(v) {
      return String(v === null || v === undefined ? "" : v).replace(/,/g, "");
    },
    // focus → strip formatting back to a plain number for editing
    onNumFocus: function onNumFocus(row, field) {
      row[field + "Text"] = this.stripThousands(row[field + "Text"]);
    },
    // blur → parse, clamp >= 0, store numeric + formatted display, recompute SCVD
    onNumBlur: function onNumBlur(row, field) {
      var raw = this.stripThousands(row[field + "Text"]).trim();
      // QA BUG-08/11: ช่องว่างคงว่าง (บังคับกรอกตอนบันทึก) · ค่าผิด (วางข้อความ/ติดลบ) → แจ้งและล้างช่อง ไม่แปลงเอง
      if (raw !== "" && !/^\d+$/.test(raw)) {
        Swal.fire("ข้อมูลไม่ถูกต้อง", "กรุณากรอกเฉพาะตัวเลขจำนวนเต็ม 0 ขึ้นไป", "warning");
        raw = "";
      }
      var v = raw === "" ? "" : parseInt(raw, 10);
      row[field] = v;
      row[field + "Text"] = this.formatThousands(v);
      this.computeScvd(row);
    },

    // Live JS mirror of ScvdCalculator (F6): SaleDays==0 || Demand==0 → null; else round half-up 2dp
    computeScvd: function computeScvd(row) {
      var s = parseInt(row.saleDays, 10) || 0;
      var d = parseInt(row.demand, 10) || 0;
      var bg = parseInt(row.bgStock, 10) || 0;
      if (s === 0 || d === 0) {
        row.scvd = null;
        return;
      }
      var raw = bg * s / d;
      // half-up (values are non-negative → Math.round rounds .5 up = AwayFromZero)
      row.scvd = Math.round(raw * 100) / 100;
    },

    formatScvd: function formatScvd(value) {
      if (value === null || value === undefined) return "-";
      return Number(value).toFixed(2);
    },

    // IssueList #23: true if ANY (plant, year, product) group among the grid rows covers fewer than
    // 12 distinct months. Mirrors the backend group key (Plant×Product×Year). Rows missing a key part
    // are skipped — onSubmit's per-row required checks already blocked those before the confirm runs.
    hasIncompleteMonthGroup: function hasIncompleteMonthGroup() {
      var groups = {};
      for (var i = 0; i < this.rows.length; i++) {
        var r = this.rows[i];
        if (!r.plantCode || !r.productCode || !r.year || !r.month) continue;
        var key = r.plantCode + "|" + r.year + "|" + r.productCode;
        if (!groups[key]) groups[key] = {};
        groups[key][r.month] = true;
      }
      for (var k in groups) {
        if (Object.prototype.hasOwnProperty.call(groups, k)) {
          if (Object.keys(groups[k]).length < 12) return true;
        }
      }
      return false;
    },

    onSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var self, i, r, n, reqNums, q, fv, sd, rows;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;

                // reset previous row-error highlights

                self.rows.forEach(function (r) {
                  r._hasError = false;
                });

                // jQuery validate (native selects/inputs: month/year/saleDays)

                if (!(self.$refs.scvdForm && !$(self.$refs.scvdForm).valid())) {
                  _context.next = 5;
                  break;
                }

                // QA BUG-08: แจ้งเตือนรวม + ข้อความสีแดงใต้ช่องที่ขาด (jQuery validate)
                Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกข้อมูลในช่องที่มีเครื่องหมาย * ให้ครบ (ดูข้อความสีแดงใต้ช่องที่ยังไม่ได้กรอก)", "warning");
                return _context.abrupt("return");

              case 5:
                if (!(self.rows.length === 0)) {
                  _context.next = 8;
                  break;
                }

                Swal.fire("ข้อมูลไม่ครบ", "กรุณาเพิ่มอย่างน้อย 1 รายการ", "warning");
                return _context.abrupt("return");

              case 8:
                i = 0;

              case 9:
                if (!(i < self.rows.length)) {
                  _context.next = 51;
                  break;
                }

                r = self.rows[i];
                n = i + 1;

                if (r.month) {
                  _context.next = 16;
                  break;
                }

                r._hasError = true;
                Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือกเดือนในแถวที่ " + n, "warning");
                return _context.abrupt("return");

              case 16:
                if (r.year) {
                  _context.next = 20;
                  break;
                }

                r._hasError = true;
                Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือกปีในแถวที่ " + n, "warning");
                return _context.abrupt("return");

              case 20:
                if (r.plantCode) {
                  _context.next = 24;
                  break;
                }

                r._hasError = true;
                Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือกคลังสินค้าในแถวที่ " + n, "warning");
                return _context.abrupt("return");

              case 24:
                if (r.productCode) {
                  _context.next = 28;
                  break;
                }

                r._hasError = true;
                Swal.fire("ข้อมูลไม่ครบ", "กรุณาเลือกสินค้าในแถวที่ " + n, "warning");
                return _context.abrupt("return");

              case 28:
                if (!(r.saleDays === "" || r.saleDays === null || r.saleDays === undefined)) {
                  _context.next = 32;
                  break;
                }

                r._hasError = true;
                Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกจำนวนวันขายในแถวที่ " + n, "warning");
                return _context.abrupt("return");

              case 32:
                reqNums = [["bgStock", "จำนวน BG Stock"], ["demand", "จำนวน Demand"], ["supply", "จำนวน Supply"]];
                q = 0;

              case 34:
                if (!(q < reqNums.length)) {
                  _context.next = 43;
                  break;
                }

                fv = r[reqNums[q][0]];

                if (!(fv === "" || fv === null || fv === undefined)) {
                  _context.next = 40;
                  break;
                }

                r._hasError = true;
                Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอก" + reqNums[q][1] + "ในแถวที่ " + n, "warning");
                return _context.abrupt("return");

              case 40:
                q++;
                _context.next = 34;
                break;

              case 43:
                sd = parseInt(r.saleDays, 10);

                if (!(isNaN(sd) || sd < 0 || sd > 31)) {
                  _context.next = 48;
                  break;
                }

                r._hasError = true;
                Swal.fire("ข้อมูลไม่ถูกต้อง", "จำนวนวันขายในแถวที่ " + n + " ต้องอยู่ระหว่าง 0 ถึง 31", "warning");
                return _context.abrupt("return");

              case 48:
                i++;
                _context.next = 9;
                break;

              case 51:

                // R2-19: หน้า Create ใช้ modal เดียวให้ตรงกับหน้า Detail/Edit — ไม่เด้ง modal เตือน "เดือนไม่ครบ" แยก
                // ก่อนอีกต่อไป. การเตือน version n (needVersionConfirm) มาจาก BE (ดู doSave) และข้อความ carry-forward
                // เดือนที่เหลือ (IssueList #23: version = snapshot 12 เดือน · BE เติมเดือนที่ขาดจาก version ล่าสุด) จะถูก
                // "ต่อท้าย" modal version นั้นแทน เมื่อกรอกไม่ครบ → เหลือ pop-up เดียวในทุกกรณีที่เป็นข้อมูลซ้ำ.

                // Build flat rows in the StockCoverDayTargetImportRow shape (Scvd recomputed server-side).
                rows = self.rows.map(function (r, idx) {
                  return {
                    RowNumber: idx + 1,
                    Month: parseInt(r.month, 10),
                    Year: parseInt(r.year, 10),
                    SaleDays: parseInt(r.saleDays, 10) || 0,
                    PlantCode: r.plantCode,
                    PlantName: r.plantName,
                    ProductCode: r.productCode,
                    ProductName: r.productName,
                    BGStockLitre: parseInt(r.bgStock, 10) || 0,
                    DemandLitre: parseInt(r.demand, 10) || 0,
                    SupplyLitre: parseInt(r.supply, 10) || 0
                  };
                });
                _context.next = 54;
                return self.doSave(rows, false);

              case 54:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSubmit() {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }(),

    // Feed flat rows through the EXISTING Import-confirm pipeline (re-validate + C1 + versioning + write).
    // R2-19: two-phase — ส่ง confirmNewVersion=false ก่อน; ถ้า BE ตอบ needVersionConfirm (มี (คลัง+สินค้า+ปี)
    // ที่มีข้อมูลเดิม → จะบันทึกเป็นเวอร์ชันใหม่) แสดงข้อความจาก BE (pattern เดียวกับหน้า Detail/Edit ระบุเลข
    // เวอร์ชันที่จะบันทึก) แล้วส่งซ้ำด้วย confirmNewVersion=true เพื่อเขียนจริง.
    doSave: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(rows, confirmNewVersion) {
        var self, response, data, carryWarn, reCalcWarn, vConfirm, summary, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = this;
                _context2.prev = 1;

                self.isSaving = true;
                KTApp.blockPage({ opacity: 0.05, message: "กำลังบันทึกข้อมูล..." });

                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/ImportConfirm", { rows: rows, confirmNewVersion: !!confirmNewVersion }, {
                  headers: {
                    Authorization: "Bearer " + self.$root.user.access_token
                  }
                });

              case 6:
                response = _context2.sent;


                KTApp.unblockPage();
                self.isSaving = false;

                data = response.data || {};

                // R2-19: มีข้อมูลเดิม → BE ขอยืนยันสร้างเวอร์ชันใหม่ (ข้อความ pattern เดียวกับหน้า Detail/Edit)

                if (!(data.needVersionConfirm && !confirmNewVersion)) {
                  _context2.next = 20;
                  break;
                }

                // IssueList #23: ถ้ากรอกไม่ครบ 12 เดือน → BE เติมเดือนที่ขาดจาก Version ล่าสุด (carry-forward)
                // ต่อท้าย modal version นี้ (ไม่เด้ง pop-up แยก) เพื่อให้เหลือ modal เดียวเหมือนหน้า Edit
                carryWarn = self.hasIncompleteMonthGroup() ? "<br><br>ℹ️ บางเดือนไม่ได้กรอกข้อมูล — ระบบจะใช้ข้อมูลเดือนที่เหลือจาก Version ล่าสุด (ถ้ามี)" : "";
                // P5: การบันทึกปีปัจจุบันจะ re-calculate snapshot ของเดือนที่ปิดรอบแล้วในปีนี้

                reCalcWarn = self.rows.some(function (r) {
                  return parseInt(r.year, 10) === self.currentYear;
                }) ? "<br><br><b style='color:#b45309'>⚠️ ปีปัจจุบัน:</b> การบันทึกจะ<b>คำนวณ snapshot ของเดือนที่ปิดรอบแล้ว</b>ในปีนี้ใหม่ (re-calculate) โดยอัตโนมัติ" : "";
                _context2.next = 15;
                return Swal.fire({
                  title: "พบข้อมูลเดิม",
                  html: (data.message || "พบข้อมูลของสินค้านี้อยู่แล้ว ต้องการเพิ่มเป็น Version ใหม่ใช่หรือไม่?") + carryWarn + reCalcWarn,
                  type: "question",
                  showCancelButton: true,
                  confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ย้อนกลับแก้ไข"
                });

              case 15:
                vConfirm = _context2.sent;

                if (!vConfirm.value) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 19;
                return self.doSave(rows, true);

              case 19:
                return _context2.abrupt("return");

              case 20:
                if (!data.success) {
                  _context2.next = 27;
                  break;
                }

                // R2-23: สรุปข้อมูลที่บันทึก แยกราย plant + จำนวนสินค้า
                summary = self.buildImportSummary(rows);
                _context2.next = 24;
                return Swal.fire({
                  title: "บันทึกสำเร็จ",
                  html: "บันทึกข้อมูล Stock Cover Days เรียบร้อยแล้ว" + (summary.length ? "<br><br><div style='text-align:left;display:inline-block'>" + summary.join("<br>") + "</div>" : ""),
                  type: "success"
                });

              case 24:
                self.$router.push({
                  path: "/StockCoverDays/List",
                  query: { reload: Date.now() }
                });
                _context2.next = 29;
                break;

              case 27:
                // ASSUMPTION: /ImportConfirm returns a single message string (first failing row), not a
                // per-row error array. Best-effort: parse "แถวที่ N" to highlight the offending grid row.
                self.highlightErrorRow(data.message);
                Swal.fire("เกิดข้อผิดพลาด", data.message || "ไม่สามารถบันทึกข้อมูลได้", "error");

              case 29:
                _context2.next = 40;
                break;

              case 31:
                _context2.prev = 31;
                _context2.t0 = _context2["catch"](1);

                KTApp.unblockPage();
                self.isSaving = false;
                message = "ไม่สามารถบันทึกข้อมูลได้";

                if (_context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.message) {
                  message = _context2.t0.response.data.message;
                }
                if (_context2.t0.response && _context2.t0.response.status === 403) {
                  message = "คุณไม่มีสิทธิ์บันทึกข้อมูล กรุณาติดต่อผู้ดูแลระบบ"; // QA BUG-05
                }
                self.highlightErrorRow(message);
                Swal.fire("เกิดข้อผิดพลาด", message, "error");

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 31]]);
      }));

      function doSave(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return doSave;
    }(),

    // Best-effort: mark the grid row referenced by a server "แถวที่ N" message so the user can find it.
    highlightErrorRow: function highlightErrorRow(message) {
      if (!message) return;
      var m = String(message).match(/แถวที่\s*(\d+)/);
      if (m) {
        var idx = parseInt(m[1], 10) - 1;
        if (idx >= 0 && idx < this.rows.length) {
          this.rows[idx]._hasError = true;
        }
      }
    },
    // R2-23: สรุป rows ที่ import/บันทึก → รายการ "N.[plant] ชื่อคลัง X สินค้า" ต่อ plant (distinct product)
    // รองรับ key ทั้ง PascalCase (rows ที่สร้างฝั่ง client) และ camelCase (importRows จาก BE)
    buildImportSummary: function buildImportSummary(rows) {
      var groups = {};
      var order = [];
      (rows || []).forEach(function (r) {
        var pc = r.PlantCode != null ? r.PlantCode : r.plantCode;
        var pn = r.PlantName != null ? r.PlantName : r.plantName;
        var prod = r.ProductCode != null ? r.ProductCode : r.productCode;
        if (!pc) return;
        if (!groups[pc]) {
          groups[pc] = { name: pn || "", products: {} };order.push(pc);
        }
        if (prod != null && prod !== "") groups[pc].products[prod] = true;
      });
      return order.map(function (pc, i) {
        var g = groups[pc];
        var cnt = Object.keys(g.products).length;
        return i + 1 + ".[" + pc + "] " + (g.name || "") + " " + cnt + " สินค้า";
      });
    },

    // ── Import (ตาม wireframe §1.2 / §1.3) — validate → preview → confirm → เขียน DB ──
    downloadTemplate: function downloadTemplate() {
      var self = this;
      KTApp.blockPage({ opacity: 0.05, message: "กำลังสร้าง Template กรุณารอสักครู่..." });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/StockCoverDayTarget/DownloadTemplate", {
        responseType: "blob",
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement("a");
        link.href = url;
        var dTpl = new Date();
        var datePrefixTpl = dTpl.getFullYear() + "-" + ("0" + (dTpl.getMonth() + 1)).slice(-2) + "-" + ("0" + dTpl.getDate()).slice(-2);
        link.setAttribute("download", datePrefixTpl + "_StockCoverDays_Import_Template.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }).catch(function () {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดาวน์โหลด Template ได้", "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    showImportModal: function showImportModal() {
      this.resetImportForm();
      $("#importStockCoverDaysModal").modal("show");
    },
    resetImportForm: function resetImportForm() {
      this.importFile = null;
      this.importFileName = "";
      if (this.$refs.importFileInput) {
        this.$refs.importFileInput.value = "";
      }
    },
    onFileChange: function onFileChange(e) {
      var file = e.target.files[0];
      if (file) {
        var ext = file.name.split(".").pop().toLowerCase();
        if (ext !== "xlsx") {
          Swal.fire("ผิดพลาด", "กรุณาเลือกไฟล์ .xlsx เท่านั้น", "error");
          this.$refs.importFileInput.value = "";
          this.importFile = null;
          this.importFileName = "";
          return;
        }
        this.importFile = file;
        this.importFileName = file.name;
      } else {
        this.importFile = null;
        this.importFileName = "";
      }
    },
    // Step 1 — validate + preview (no DB write)
    submitImport: function submitImport() {
      if (!this.importFile) {
        Swal.fire("ผิดพลาด", "กรุณาเลือกไฟล์ Excel", "warning");
        return;
      }
      var self = this;
      var formData = new FormData();
      formData.append("file", this.importFile);
      KTApp.blockPage({ opacity: 0.05, message: "กำลังตรวจสอบข้อมูล กรุณารอสักครู่..." });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/Import", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then(function (response) {
        if (response.data.success) {
          $("#importStockCoverDaysModal").modal("hide");
          var preview = response.data.preview || {};
          var rows = response.data.importRows || [];
          var html = "<p>\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08 \u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32</p>";
          html += "<p>- \u0E08\u0E33\u0E19\u0E27\u0E19\u0E41\u0E16\u0E27\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14: " + (preview.totalRows || 0) + " \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23<br/>";
          html += "- \u0E01\u0E25\u0E38\u0E48\u0E21\u0E17\u0E35\u0E48\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E43\u0E2B\u0E21\u0E48 (Version 1): " + (preview.newGroupCount || 0) + " \u0E01\u0E25\u0E38\u0E48\u0E21<br/>";
          html += "- \u0E01\u0E25\u0E38\u0E48\u0E21\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27 (\u0E2A\u0E23\u0E49\u0E32\u0E07 Version \u0E43\u0E2B\u0E21\u0E48): " + (preview.existingGroupCount || 0) + " \u0E01\u0E25\u0E38\u0E48\u0E21</p>";
          // P5: importing any row for the CURRENT year re-calculates snapshots of already-closed months of this year.
          if (rows.some(function (r) {
            return parseInt(r.year != null ? r.year : r.Year, 10) === self.currentYear;
          })) {
            html += "<br><br><b style='color:#b45309'>⚠️ ปีปัจจุบัน:</b> การบันทึกจะ<b>คำนวณ snapshot ของเดือนที่ปิดรอบแล้ว</b>ในปีนี้ใหม่ (re-calculate) โดยอัตโนมัติ";
          }
          Swal.fire({
            title: "ยืนยันการนำเข้าข้อมูล",
            html: html,
            type: "info",
            showCancelButton: true,
            confirmButtonText: "ยืนยันนำเข้า",
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true
          }).then(function (result) {
            if (result.value) {
              self.confirmImport(rows);
            }
          });
        } else {
          self.lastImportRows = response.data.importRows || null;
          var errorHtml = "<p>" + (response.data.message || "นำเข้าข้อมูลไม่สำเร็จ") + "</p>";
          if (self.lastImportRows && self.lastImportRows.length > 0) {
            errorHtml += "<p>\u0E04\u0E25\u0E34\u0E01 <strong>\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 Error Detail</strong> \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14</p>";
          }
          Swal.fire({
            title: "นำเข้าข้อมูลไม่สำเร็จ",
            html: errorHtml,
            type: "error",
            showCancelButton: self.lastImportRows && self.lastImportRows.length > 0,
            confirmButtonText: "ตกลง",
            cancelButtonText: '<i class="fas fa-download"></i> ดาวน์โหลด Error Detail',
            cancelButtonColor: "#5867dd"
          }).then(function (result) {
            if (result.dismiss === Swal.DismissReason.cancel) {
              self.downloadErrorDetail();
            }
          });
        }
      }).catch(function (error) {
        var message = "เกิดข้อผิดพลาดในการนำเข้าข้อมูล";
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    // Step 2 — commit validated rows → กลับหน้า List เพื่อดูข้อมูลที่นำเข้า
    // R2-19: flow นำเข้า Excel มี dialog ยืนยันของตัวเองอยู่แล้ว (แสดงจำนวน "กลุ่มที่มีอยู่แล้ว (สร้าง Version ใหม่)"
    // + คำเตือน re-calculate ปีปัจจุบัน) ผู้ใช้ยืนยันไปแล้วในขั้นตอนนั้น → ส่ง confirmNewVersion=true เพื่อข้าม
    // version-confirm gate (ไม่ถามซ้ำ). การเตือนเวอร์ชัน n ผ่าน needVersionConfirm ใช้กับ flow กรอกมือ (doSave).
    confirmImport: function confirmImport(rows) {
      var self = this;
      KTApp.blockPage({ opacity: 0.05, message: "กำลังนำเข้าข้อมูล กรุณารอสักครู่..." });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/ImportConfirm", { rows: rows, confirmNewVersion: true }).then(function (response) {
        if (response.data.success) {
          // R2-23: สรุปข้อมูลที่นำเข้า แยกราย plant + จำนวนสินค้า
          var summary = self.buildImportSummary(rows);
          // R2-31: นับ "รายการ" เป็นจำนวนโรงงาน ให้ตรงกับรายการสรุปด้านล่าง
          Swal.fire({
            title: "สำเร็จ",
            html: "\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08 " + (summary.length || response.data.createdCount || 0) + " \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23" + (summary.length ? "<br><br><div style='text-align:left;display:inline-block'>" + summary.join("<br>") + "</div>" : ""),
            type: "success"
          }).then(function () {
            self.$router.push({ path: "/StockCoverDays/List", query: { reload: Date.now() } });
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        var message = "เกิดข้อผิดพลาดในการนำเข้าข้อมูล";
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    downloadErrorDetail: function downloadErrorDetail() {
      if (!this.lastImportRows || this.lastImportRows.length === 0) {
        Swal.fire("ผิดพลาด", "ไม่พบข้อมูลสำหรับ export", "warning");
        return;
      }
      KTApp.blockPage({ opacity: 0.05, message: "กำลังสร้างไฟล์ กรุณารอสักครู่..." });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/ExportErrors", { importRows: this.lastImportRows }, { responseType: "blob" }).then(function (response) {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement("a");
        link.href = url;
        var contentDisposition = response.headers["content-disposition"];
        var dErr = new Date();
        var datePrefixErr = dErr.getFullYear() + "-" + ("0" + (dErr.getMonth() + 1)).slice(-2) + "-" + ("0" + dErr.getDate()).slice(-2);
        var filename = datePrefixErr + "_StockCoverDays_ImportErrors.xlsx";
        if (contentDisposition) {
          var filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ""));
          }
        }
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }).catch(function (error) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดาวน์โหลดไฟล์ได้", "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    }
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */] },
  data: function data() {
    var self = this;
    var now = new Date();
    var currentYear = now.getFullYear();

    var authTransport = function authTransport(params, success, failure) {
      params.beforeSend = function (request) {
        request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
      };
      var $request = $.ajax(params);
      $request.then(success);
      $request.fail(failure);
      return $request;
    };

    return {
      isLoading: false,
      bulletPlant: "", // QA-07b: "" = ทุกคลัง (ในขอบเขตตัวกรองด้านบน)
      bulletSort: "asc", // QA BUG-07: asc = วิกฤตสุด → ล้นสุด (ค่าเริ่มต้น) · desc = ล้นสุด → วิกฤตสุด
      dashboard: null,

      // ── ② pie in-pie drill-down (D1): level 1 สถานะ → 2 คลัง → 3 สินค้า (ภายใน pie เท่านั้น) ──
      pieDrill: { level: 1, statusOrder: null, plantCode: null },

      // ── filters ──────────────────────────────────────────────
      filterMonth: now.getMonth() + 1,
      filterYear: currentYear,
      filterPlantCodes: [],
      filterProductCodes: [],
      filterBrandIds: [],
      filterUnit: "ลิตร",

      monthOptions: [{ value: 1, text: "January" }, { value: 2, text: "February" }, { value: 3, text: "March" }, { value: 4, text: "April" }, { value: 5, text: "May" }, { value: 6, text: "June" }, { value: 7, text: "July" }, { value: 8, text: "August" }, { value: 9, text: "September" }, { value: 10, text: "October" }, { value: 11, text: "November" }, { value: 12, text: "December" }],
      monthShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      yearOptions: [currentYear, currentYear - 1, currentYear - 2, currentYear - 3, currentYear - 4],

      // ── modals ───────────────────────────────────────────────
      showFormulaModal: false,
      showSetupModal: false,

      // ── ⑥ editor state ───────────────────────────────────────
      editLevels: [],
      editTargetScvd: 18,
      editLoading: false,
      editSaving: false,

      // ── session (บันทึกครั้งเดียว) override ────────────────────
      sessionCriteria: null,

      // ── Select2 options ──────────────────────────────────────
      plantOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        ajax: {
          url: "/Api/StockCoverDayTarget/Select2Plant",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            return JSON.stringify({ plantId: [], search: params.term || "", page: params.page || 1 });
          },
          processResults: function processResults(data) {
            return { results: data.results, pagination: { more: data.more } };
          },
          transport: authTransport
        },
        language: { noResults: function noResults() {
            return "ไม่พบข้อมูลคลัง";
          } }
      },
      productOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          delay: 300,
          data: function data(params) {
            return { productGroupId: 14, productTypeId: 22, onlyStockCoverDays: true, onlyHasScvdMaster: true, search: params.term || "", page: params.page || 1 }; // CR-StockCoverDays A3+C3: เฉพาะ SKU ที่เปิดใช้งาน SCVD + มีข้อมูล Master
          },
          processResults: function processResults(data) {
            return { results: data.results, pagination: { more: data.more } };
          },
          transport: authTransport
        },
        language: { noResults: function noResults() {
            return "ไม่พบข้อมูลสินค้า";
          } }
      },
      brandOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          delay: 300,
          data: function data(params) {
            return { search: params.term || "", page: params.page || 1 };
          },
          processResults: function processResults(data) {
            return { results: data.results, pagination: { more: data.more } };
          },
          transport: authTransport
        },
        language: { noResults: function noResults() {
            return "ไม่พบข้อมูลแบรนด์";
          } }
      }
    };
  },

  computed: {
    criteria: function criteria() {
      return this.dashboard ? this.dashboard.criteria : null;
    },
    criteriaLevels: function criteriaLevels() {
      if (this.dashboard && this.dashboard.criteria && this.dashboard.criteria.levels) {
        return this.dashboard.criteria.levels;
      }
      return [];
    },
    // QA-07b: ตัวเลือกคลังของกล่องกราฟเทียบ = คลังใน Heatmap (ตามตัวกรองด้านบน · ไม่ถูกกรองด้วย dropdown ในกล่อง)
    bulletPlantOptions: function bulletPlantOptions() {
      var hm = this.dashboard && this.dashboard.heatmap || [];
      return hm.map(function (p) {
        return { code: p.plantCode, name: p.plantName };
      });
    },
    monthName: function monthName() {
      var m = this.monthOptions.filter(function (o) {
        return o.value === Number(this.filterMonth);
      }, this)[0];
      return m ? m.text : "";
    },
    productChipText: function productChipText() {
      if (this.filterProductCodes.length) return this.filterProductCodes.length + " รายการ";
      if (this.dashboard && this.dashboard.pie) return "ทั้งหมด (" + this.dashboard.pie.totalSku + " SKU)";
      return "ทั้งหมด";
    },
    adminCanSaveDefault: function adminCanSaveDefault() {
      try {
        return this.$root.canShow([["SCVD_ADMIN", "COMPANY_PROFILE_TYPE_SCVD"]]);
      } catch (e) {
        return false;
      }
    },
    bulletByPlant: function bulletByPlant() {
      var groups = [];
      var index = {};
      (this.dashboard && this.dashboard.bullet ? this.dashboard.bullet : []).forEach(function (b) {
        var key = b.plantCode || "-";
        if (index[key] === undefined) {
          index[key] = groups.length;
          groups.push({ plantCode: key, plantName: b.plantName, items: [] });
        }
        groups[index[key]].items.push(b);
      });
      return groups;
    },
    bulletScaleVal: function bulletScaleVal() {
      var levels = this.criteriaLevels;
      var scale = 40;
      if (levels.length) {
        var last = levels[levels.length - 1];
        var lastFrom = last.fromDay || 0;
        var prevSpan = levels.length > 1 ? lastFrom - (levels[levels.length - 2].fromDay || 0) : 10;
        if (prevSpan < 5) prevSpan = 10;
        scale = lastFrom + Math.max(prevSpan, 10);
      }
      var maxMarker = 0;
      (this.dashboard && this.dashboard.bullet ? this.dashboard.bullet : []).forEach(function (b) {
        ["actualScvd", "targetScvd", "targetSimScvd"].forEach(function (k) {
          if (b[k] != null && b[k] > maxMarker) maxMarker = b[k];
        });
      });
      if (maxMarker * 1.05 > scale) scale = Math.ceil(maxMarker * 1.05);
      return scale || 40;
    },
    bulletZones: function bulletZones() {
      var scale = this.bulletScaleVal;
      var zones = [];
      this.criteriaLevels.forEach(function (lv) {
        var from = lv.fromDay || 0;
        var to = lv.toDay != null ? lv.toDay + 1 : scale;
        var left = from / scale * 100;
        var right = to / scale * 100;
        var w = Math.max(0, right - left);
        zones.push({
          name: lv.name,
          colorHex: lv.colorHex,
          widthPct: w,
          label: (lv.toDay != null ? lv.fromDay + "-" + lv.toDay : lv.fromDay + "+") + " วัน"
        });
      });
      return zones;
    },
    // D1: unified slice list ของ "ระดับ drill ปัจจุบัน" (level 1 สถานะ / 2 คลัง / 3 สินค้า)
    // — ทุกระดับ pre-loaded จาก payload เดียว (dashboard.pie.slices[].plants[].products[]).
    pieViewSlices: function pieViewSlices() {
      var pie = this.dashboard && this.dashboard.pie ? this.dashboard.pie : null;
      if (!pie) return [];
      var d = this.pieDrill;
      var self = this;

      if (d.level === 1) {
        return (pie.slices || []).map(function (s) {
          return { code: s.order, colorHex: s.colorHex, percent: s.percent, count: s.count, name: s.name, drillable: s.count > 0 };
        });
      }

      var status = (pie.slices || []).filter(function (s) {
        return s.order === d.statusOrder;
      })[0];
      if (!status) return [];

      if (d.level === 2) {
        var plants = status.plants || [];
        return plants.map(function (p, i) {
          return { code: p.plantCode, colorHex: self.pieShade(status.colorHex, i, plants.length), percent: p.percent, count: p.count, name: p.plantName, drillable: p.count > 0 };
        });
      }

      // level 3 — สินค้าในคลัง (leaf: ไม่ drill ต่อ)
      var plant = (status.plants || []).filter(function (p) {
        return p.plantCode === d.plantCode;
      })[0];
      if (!plant) return [];
      var products = plant.products || [];
      return products.map(function (pr, i) {
        return { code: pr.productCode, colorHex: self.pieShade(status.colorHex, i, products.length), percent: pr.percent, count: pr.count, name: pr.productName, scvd: pr.scvd, drillable: false };
      });
    },
    // #66: segments carry both the donut arc (dash/offset) AND the leader-line + %/ชื่อ label
    // geometry — ported from mockup_dashboard (Spec v3) renderLevel2 math so labels stay dynamic.
    pieSegments: function pieSegments() {
      var slices = this.pieViewSlices;
      var self = this;
      var cum = 0;
      var segs = [];
      slices.forEach(function (s, i) {
        var len = Number(s.percent) || 0;
        // midpoint บน stroke path: dashoffset=25 shift จุดเริ่ม arc ไปที่ stroke position 75
        var midStrokePos = (75 + cum + len / 2) % 100;
        var ang = midStrokePos / 100 * 2 * Math.PI; // มุมจากด้านบน (12 นาฬิกา) ตามเข็ม
        var sinA = Math.sin(ang),
            cosA = Math.cos(ang);
        var lx = 21 + 24 * sinA;
        var ly = 21 - 24 * cosA;
        var anchor = lx < 20 ? "end" : lx > 22 ? "start" : "middle";
        var nameY = ly < 18 ? ly - 2.6 : ly + 2.8; // ชื่ออยู่เหนือ % (ครึ่งบน) / ใต้ % (ครึ่งล่าง+กลาง)
        segs.push({
          index: i,
          colorHex: s.colorHex,
          drillable: s.drillable,
          dash: len + " " + (100 - len),
          offset: 25 - cum,
          showLabel: len > 0,
          pct: Math.round(len),
          name: self.pieShortName(s.name),
          labelColor: self.darken(s.colorHex, 0.35),
          lineX1: (21 + 21 * sinA).toFixed(2),
          lineY1: (21 - 21 * cosA).toFixed(2),
          lineX2: (21 + 23 * sinA).toFixed(2),
          lineY2: (21 - 23 * cosA).toFixed(2),
          lx: lx.toFixed(2),
          ly: ly.toFixed(2),
          nameY: nameY.toFixed(2),
          anchor: anchor
        });
        cum += len;
      });
      return segs;
    },
    pieCenterCount: function pieCenterCount() {
      return this.pieViewSlices.reduce(function (a, s) {
        return a + (Number(s.count) || 0);
      }, 0);
    },
    // D1: breadcrumb ทุกสถานะ › สถานะ › คลัง
    pieBreadcrumb: function pieBreadcrumb() {
      var pie = this.dashboard && this.dashboard.pie ? this.dashboard.pie : null;
      var d = this.pieDrill;
      var crumbs = [{ label: "ทุกสถานะ", level: 1 }];
      if (!pie) return crumbs;
      if (d.level >= 2 && d.statusOrder != null) {
        var st = (pie.slices || []).filter(function (s) {
          return s.order === d.statusOrder;
        })[0];
        if (st) crumbs.push({ label: st.name, level: 2 });
      }
      if (d.level >= 3 && d.plantCode != null) {
        var st2 = (pie.slices || []).filter(function (s) {
          return s.order === d.statusOrder;
        })[0];
        var pl = st2 && st2.plants ? st2.plants.filter(function (p) {
          return p.plantCode === d.plantCode;
        })[0] : null;
        if (pl) crumbs.push({ label: pl.plantName, level: 3 });
      }
      return crumbs;
    },
    // D1 level 3: หัวตาราง + แถวรายสินค้า (เรียง SCVD น้อย→มาก) ตาม mockup renderLevel3
    pieDrillStatusSlice: function pieDrillStatusSlice() {
      var pie = this.dashboard && this.dashboard.pie ? this.dashboard.pie : null;
      if (!pie) return null;
      var d = this.pieDrill;
      return (pie.slices || []).filter(function (s) {
        return s.order === d.statusOrder;
      })[0] || null;
    },
    pieDrillStatusName: function pieDrillStatusName() {
      return this.pieDrillStatusSlice ? this.pieDrillStatusSlice.name : "";
    },
    pieDrillStatusColor: function pieDrillStatusColor() {
      return this.pieDrillStatusSlice ? this.pieDrillStatusSlice.colorHex : "#374151";
    },
    pieDrillPlantName: function pieDrillPlantName() {
      var st = this.pieDrillStatusSlice;
      if (!st) return "";
      var pc = this.pieDrill.plantCode;
      var pl = (st.plants || []).filter(function (p) {
        return p.plantCode === pc;
      })[0];
      return pl ? pl.plantName : "";
    },
    pieLevel3Rows: function pieLevel3Rows() {
      if (this.pieDrill.level !== 3) return [];
      // pieViewSlices ที่ level 3 = สินค้า (มี scvd) → เรียง SCVD น้อย→มาก (null ไปท้าย)
      return this.pieViewSlices.slice().sort(function (a, b) {
        var av = a.scvd == null ? Infinity : Number(a.scvd);
        var bv = b.scvd == null ? Infinity : Number(b.scvd);
        return av - bv;
      });
    },
    currentMonthIndex: function currentMonthIndex() {
      var hm = this.dashboard ? this.dashboard.heatmap : null;
      if (hm && hm.length && hm[0].rows.length) {
        var months = hm[0].rows[0].months;
        for (var i = 0; i < months.length; i++) {
          if (months[i].isCurrentMonth) return months[i].month - 1;
        }
      }
      return new Date().getMonth();
    }
  },

  mounted: function mounted() {
    // D7: "บันทึกครั้งเดียว" = per-user/per-open-page เก็บใน memory เท่านั้น → reverts เมื่อ refresh (Dashboard.md §7.2)
    document.addEventListener("keydown", this.onKeydown);
    this.loadYears(); // #57: โหลดรายการปีแบบ dynamic (ตั้ง filterYear = latest)
    this.loadDashboard(); // #61: auto-load ทันทีเมื่อเข้าหน้า (ใช้ค่า filter เริ่มต้น)
  },

  // #61: auto-refresh เมื่อ filter ใด ๆ เปลี่ยน (debounce ~300ms กันยิง API ซ้ำถี่)
  watch: {
    filterMonth: function filterMonth() {
      this.debouncedLoad();
    },
    filterYear: function filterYear() {
      this.debouncedLoad();
    },
    filterUnit: function filterUnit() {
      this.debouncedLoad();
    },
    filterPlantCodes: {
      handler: function handler(codes) {
        // QA-07b: คลังที่เลือกในกล่องกราฟเทียบหลุดจากตัวกรองด้านบน → กลับเป็น "ทั้งหมด"
        if (this.bulletPlant && codes && codes.length && codes.indexOf(this.bulletPlant) === -1) this.bulletPlant = "";
        this.debouncedLoad();
      },
      deep: true
    },
    filterProductCodes: { handler: function handler() {
        this.debouncedLoad();
      }, deep: true },
    filterBrandIds: { handler: function handler() {
        this.debouncedLoad();
      }, deep: true }
  },

  beforeDestroy: function beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
    if (this._loadTimer) clearTimeout(this._loadTimer);
  },

  methods: {
    // ── data load ────────────────────────────────────────────
    buildPayload: function buildPayload() {
      return {
        month: Number(this.filterMonth),
        year: Number(this.filterYear),
        plantCodes: this.filterPlantCodes || [],
        productCodes: this.filterProductCodes || [],
        brandIds: (this.filterBrandIds || []).map(Number),
        unit: this.filterUnit,
        version: null,
        // P3 Simulation — session "what-if" config sent to server; applied to OPEN month only
        // (server ignores it for CLOSED months → frozen). null = no simulation.
        sessionLevels: this.sessionCriteria ? this.sessionCriteria.levels : null,
        sessionTargetScvd: this.sessionCriteria ? this.sessionCriteria.targetScvd : null,
        bulletSortDesc: this.bulletSort === "desc", // QA BUG-07
        bulletPlantCode: this.bulletPlant || null // QA-07b
      };
    },

    // #57: โหลดรายการปีแบบ dynamic จาก backend — mirror ReportAnalysis.loadVersions (auth + { success, data } envelope)
    loadYears: function loadYears() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/Dashboard/Years", {}, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var years = [];
        var latest = null;
        // รองรับทั้ง envelope { success, data: { years, latest } } (แบบ loadVersions) และ body ดิบ { years, latest }
        var body = response.data || {};
        var payload = body.data != null ? body.data : body;
        years = payload.years || [];
        latest = payload.latest;
        if (years.length) {
          self.yearOptions = years;
          // default = latest · fallback: ปีปัจจุบัน (ถ้าอยู่ในรายการ) → ไม่งั้นปีแรก (มากสุด)
          var cy = new Date().getFullYear();
          if (latest != null && years.indexOf(latest) !== -1) self.filterYear = latest;else if (years.indexOf(cy) !== -1) self.filterYear = cy;else self.filterYear = years[0];
        }
        // ถ้า endpoint ไม่คืนปี → คง yearOptions static เดิมไว้ (fallback)
      }).catch(function (error) {
        // ไม่บล็อกหน้า — คงรายการปี static เดิม
        console.error("โหลดรายการปีไม่สำเร็จ:", error);
      });
    },

    // #61: debounce สำหรับ auto-refresh เมื่อ filter ใด ๆ เปลี่ยน (กันยิง API ซ้ำถี่)
    debouncedLoad: function debouncedLoad() {
      var self = this;
      if (self._loadTimer) clearTimeout(self._loadTimer);
      self._loadTimer = setTimeout(function () {
        self._loadTimer = null;
        self.loadDashboard();
      }, 300);
    },

    loadDashboard: function loadDashboard() {
      var self = this;
      self.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/Dashboard/Search", self.buildPayload(), {
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        if (response.data && response.data.success && response.data.data) {
          var d = response.data.data;
          d.criteria = d.criteria || { targetScvd: 0, levels: [] };
          d.pie = d.pie || { totalSku: 0, noDataSku: 0, slices: [] };
          d.urgent = d.urgent || {
            tier1Count: 0, tier2Count: 0,
            tier1: { name: "", colorHex: "#ccc", actionText: "", cards: [], order: 1 },
            tier2: { name: "", colorHex: "#ccc", actionText: "", cards: [], order: 2 }
          };
          d.bullet = d.bullet || [];
          d.heatmap = d.heatmap || [];
          self.dashboard = d;
          self.pieDrill = { level: 1, statusOrder: null, plantCode: null }; // D1: กลับไป level 1 ทุกครั้งที่โหลดใหม่
          self.applySessionCriteriaOverride();
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data && response.data.message || "ไม่สามารถโหลดข้อมูลได้", "error");
        }
      }).catch(function (error) {
        var message = "เกิดข้อผิดพลาดในการโหลดข้อมูล";
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      }).then(function () {
        self.isLoading = false;
      });
    },

    // ── filters ──────────────────────────────────────────────
    applyProductFilter: function applyProductFilter(code, name) {
      // add option + select in the product Select2, then update model
      var $sel = $("#dbProductCodes");
      if ($sel.find("option[value='" + code + "']").length === 0) {
        $sel.append(new Option(name || code, code, true, true));
      }
      $sel.val([code]).trigger("change");
      this.filterProductCodes = [code];
    },
    cardClick: function cardClick(card) {
      this.applyProductFilter(card.productCode, card.productName);
      this.debouncedLoad(); // #61: reload (coalesced กับ filter watcher)
    },
    cellClick: function cellClick(row, cell) {
      this.filterMonth = cell.month;
      this.applyProductFilter(row.productCode, row.productName);
      this.debouncedLoad(); // #61: reload (coalesced กับ filter watcher)
    },

    // ── ② D1 pie drill-down (ภายใน pie เท่านั้น — ไม่กระทบ widget อื่น, Dashboard.md §4.2) ──
    drillInto: function drillInto(i) {
      var s = this.pieViewSlices[i];
      if (!s || !s.drillable) return;
      var d = this.pieDrill;
      if (d.level === 1) {
        this.pieDrill = { level: 2, statusOrder: s.code, plantCode: null }; // สถานะ → คลัง
      } else if (d.level === 2) {
        this.pieDrill = { level: 3, statusOrder: d.statusOrder, plantCode: s.code }; // คลัง → สินค้า
      }
      // level 3 = leaf (สินค้า) → ไม่ drill ต่อ
    },
    drillUp: function drillUp() {
      var d = this.pieDrill;
      if (d.level === 3) this.pieDrill = { level: 2, statusOrder: d.statusOrder, plantCode: null };else if (d.level === 2) this.pieDrill = { level: 1, statusOrder: null, plantCode: null };
    },
    drillToLevel: function drillToLevel(level) {
      var d = this.pieDrill;
      if (level === 1) this.pieDrill = { level: 1, statusOrder: null, plantCode: null };else if (level === 2) this.pieDrill = { level: 2, statusOrder: d.statusOrder, plantCode: null };
      // คลิก crumb ระดับปัจจุบัน (level 3) = คงเดิม
    },
    // แสดง SCVD ในตาราง L3: null → "-" · ทศนิยม 1 ตำแหน่ง (ตรง mockup s.scvd.toFixed(1))
    pieScvdText: function pieScvdText(v) {
      return v == null ? "-" : Number(v).toFixed(1);
    },
    // shade สีของสถานะ (tier) แยกแต่ละ คลัง/สินค้า ให้ยังผูกกับสีสถานะ (§ color rule)
    pieShade: function pieShade(baseHex, i, n) {
      if (!n || n <= 1) return baseHex;
      var amt = 0.1 + 0.6 * i / (n - 1); // ไล่เฉด 0.1 → 0.7 (อ่อนลง) ให้ชิ้นติดกันแยกออก
      return this.tint(baseHex, amt);
    },
    // #66: ย่อชื่อคลังสำหรับ label รอบโดนัท (ตัด prefix ให้ fit viewBox — ตรง mockup renderLevel2 shortName)
    pieShortName: function pieShortName(name) {
      if (!name) return "";
      return String(name).replace(/^โรงงาน/, "").replace(/^ศูนย์กระจายสินค้า/, "");
    },
    removeFilter: function removeFilter(which) {
      if (which === "plant") {
        this.filterPlantCodes = [];
        $("#dbPlantCodes").val(null).trigger("change");
      } else if (which === "product") {
        this.filterProductCodes = [];
        $("#dbProductCodes").val(null).trigger("change");
      } else if (which === "brand") {
        this.filterBrandIds = [];
        $("#dbBrandId").val(null).trigger("change");
      }
      this.debouncedLoad(); // #61: reload (coalesced กับ filter watcher)
    },
    clearFilters: function clearFilters() {
      var now = new Date();
      this.filterMonth = now.getMonth() + 1;
      this.filterYear = now.getFullYear();
      this.filterPlantCodes = [];
      this.filterProductCodes = [];
      this.filterBrandIds = [];
      this.bulletPlant = "";
      $("#dbPlantCodes").val(null).trigger("change");
      $("#dbProductCodes").val(null).trigger("change");
      $("#dbBrandId").val(null).trigger("change");
      this.debouncedLoad(); // #61: reload (coalesced กับ filter watcher)
    },

    // ── ⑤ / ⑥ modals ─────────────────────────────────────────
    openFormula: function openFormula() {
      this.showFormulaModal = true;
    },
    scrollToWidget: function scrollToWidget(id) {
      // R2-20: scroll to the section INSIDE the formula modal (native href="#id" made the SPA redirect to /#id)
      var el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    openSetup: function openSetup() {
      this.showSetupModal = true;
      this.loadThreshold();
    },
    onKeydown: function onKeydown(e) {
      if (e.key === "Escape") {
        this.showFormulaModal = false;
        this.showSetupModal = false;
      }
    },
    loadThreshold: function loadThreshold() {
      var self = this;
      self.editLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/StockCoverDayTarget/Threshold", {
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        var d = response.data && response.data.data ? response.data.data : null;
        if (d) {
          self.editTargetScvd = d.targetScvd;
          self.editLevels = (d.levels || []).map(function (lv) {
            return {
              order: lv.order,
              fromDay: lv.fromDay,
              toDay: lv.toDay,
              name: lv.name,
              colorHex: lv.colorHex,
              actionText: lv.actionText
            };
          });
          if (self.editLevels.length) self.editLevels[0].fromDay = 0; // #62: ระดับแรก "จากวัน" ล็อค = 0 เสมอ
        }
      }).catch(function () {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดเกณฑ์ได้", "error");
      }).then(function () {
        self.editLoading = false;
      });
    },
    addLevel: function addLevel() {
      if (this.editLevels.length >= 6) return;
      var last = this.editLevels[this.editLevels.length - 1];
      var newFrom = 0;
      if (last) {
        // ปิดช่วงของระดับสุดท้ายเดิม (∞) ให้เป็นตัวเลข เพื่อให้ต่อเนื่อง
        if (last.toDay == null) last.toDay = (last.fromDay || 0) + 3;
        newFrom = (last.toDay || 0) + 1;
      }
      this.editLevels.push({
        order: this.editLevels.length + 1,
        fromDay: newFrom,
        toDay: null,
        name: "",
        colorHex: "#cccccc",
        actionText: ""
      });
    },
    deleteLevel: function deleteLevel(i) {
      if (this.editLevels.length <= 3) return;
      this.editLevels.splice(i, 1);
      // renumber + ensure last = ∞
      for (var j = 0; j < this.editLevels.length; j++) {
        this.editLevels[j].order = j + 1;
      }this.editLevels[this.editLevels.length - 1].toDay = null;
      this.editLevels[0].fromDay = 0; // #62: ระดับแรก "จากวัน" ล็อค = 0 เสมอ
    },
    // #62: บล็อกอักขระที่ทำให้ไม่ใช่จำนวนเต็มไม่ติดลบ (. - + e E) ในช่อง "จากวัน"/"ถึงวัน"
    blockIntKeys: function blockIntKeys(e) {
      if ([".", "-", "+", "e", "E"].indexOf(e.key) !== -1) e.preventDefault();
    },
    normalizedLevels: function normalizedLevels() {
      var out = [];
      for (var i = 0; i < this.editLevels.length; i++) {
        var lv = this.editLevels[i];
        out.push({
          order: i + 1,
          fromDay: i === 0 ? 0 : Number(lv.fromDay) || 0,
          toDay: i === this.editLevels.length - 1 ? null : lv.toDay == null ? null : Number(lv.toDay),
          name: lv.name,
          colorHex: lv.colorHex,
          actionText: lv.actionText
        });
      }
      return out;
    },
    saveOnce: function saveOnce() {
      // D7 "บันทึกครั้งเดียว": in-memory เท่านั้น (per-user / per-open-page) — reverts เมื่อ refresh (ไม่เรียก API, ไม่กระทบผู้ใช้อื่น)
      var sc = { targetScvd: Number(this.editTargetScvd) || 0, levels: this.normalizedLevels() };
      this.sessionCriteria = sc;
      this.applySessionCriteriaOverride(); // instant client feedback (bullet/criteria)
      // P3: re-query so the server re-tiers the OPEN month (pie/urgent/heatmap) with the session config.
      // CLOSED months stay frozen (server ignores sessionLevels for them).
      this.loadDashboard();
      this.showSetupModal = false;
      Swal.fire({
        icon: "success",
        title: "บันทึกครั้งเดียว",
        text: "ใช้เกณฑ์นี้เฉพาะการดูของคุณในหน้านี้ (ไม่กระทบผู้ใช้อื่น/เดือนที่ปิดรอบแล้ว) — ค่าจะกลับเป็นค่าเริ่มต้นเมื่อรีเฟรชหน้า"
      });
    },
    saveDefault: function saveDefault() {
      var self = this;
      Swal.fire({
        icon: "warning",
        title: "บันทึกเป็นค่าเริ่มต้น (ทั้งบริษัท)",
        html: "เกณฑ์นี้จะมีผลกับ <b>ผู้ใช้ทุกคนในบริษัท</b> และจะแทนที่ค่าเดิมทั้งหมด<br>ยืนยันการบันทึกหรือไม่?",
        showCancelButton: true,
        confirmButtonText: "ยืนยันบันทึก",
        cancelButtonText: "ยกเลิก"
      }).then(function (res) {
        if (!res.value) return;
        self.editSaving = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/Threshold", { targetScvd: Number(self.editTargetScvd) || 0, levels: self.normalizedLevels() }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
          if (response.data && response.data.success) {
            // ค่าเริ่มต้นใหม่ = server → เคลียร์ session override (in-memory)
            self.sessionCriteria = null;
            self.showSetupModal = false;
            Swal.fire("สำเร็จ", response.data.message || "บันทึกเกณฑ์เป็นค่าเริ่มต้นสำเร็จ", "success");
            self.loadDashboard();
          } else {
            Swal.fire("ไม่สำเร็จ", response.data && response.data.message || "บันทึกไม่สำเร็จ", "error");
          }
        }).catch(function (error) {
          var message = "ไม่สามารถบันทึกได้";
          if (error.response && error.response.status === 403) message = "คุณไม่มีสิทธิ์บันทึกเป็นค่าเริ่มต้น (เฉพาะแอดมิน Stock Cover Days)";else if (error.response && error.response.data && error.response.data.message) message = error.response.data.message;
          Swal.fire("เกิดข้อผิดพลาด", message, "error");
        }).then(function () {
          self.editSaving = false;
        });
      });
    },
    applySessionCriteriaOverride: function applySessionCriteriaOverride() {
      if (!this.sessionCriteria || !this.dashboard) return;
      // P4: a CLOSED month is frozen — never let a lingering session config override its display.
      if (this.dashboard.isClosed) return;
      var sc = this.sessionCriteria;
      var c = this.dashboard.criteria || {};
      c.targetScvd = sc.targetScvd;
      c.levels = sc.levels;
      this.dashboard.criteria = c;
      // bullet purple marker (targetSim) = session target
      (this.dashboard.bullet || []).forEach(function (b) {
        b.targetSimScvd = sc.targetScvd;
      });
    },

    // ── display helpers ──────────────────────────────────────
    badgeLabel: function badgeLabel(lv) {
      return lv.toDay != null ? lv.fromDay + "-" + lv.toDay + " " + lv.name : lv.fromDay + "+ " + lv.name;
    },
    rangeForOrder: function rangeForOrder(order) {
      var lv = this.criteriaLevels.filter(function (x) {
        return x.order === order;
      })[0];
      if (!lv) return "";
      return (lv.toDay != null ? lv.fromDay + "–" + lv.toDay : lv.fromDay + "+") + " วัน";
    },
    tierName: function tierName(scvd) {
      if (scvd == null) return "ไม่มีข้อมูล";
      var v = Math.round(scvd);
      var lv = this.criteriaLevels.filter(function (x) {
        return v >= x.fromDay && (x.toDay == null || v <= x.toDay);
      })[0];
      return lv ? lv.name : "-";
    },
    fmt: function fmt(v) {
      if (v == null) return "0";
      return Math.round(v).toLocaleString("en-US");
    },
    scvdDisplay: function scvdDisplay(v) {
      if (v == null) return "-";
      return String(Math.round(v));
    },
    formatPct: function formatPct(v) {
      if (v == null) return "0";
      return Number(v).toFixed(1).replace(/\.0$/, "");
    },
    stockText: function stockText(item) {
      // BG Stock (ตามหน้างานจริง) ปัจจุบัน — ใช้ค่าจริงจาก backend (mirror bullet formula 1) ถ้ามี
      if (item.actualBgCurrentLitre != null) {
        var nv = item.netVolume != null ? Number(item.netVolume) : 0;
        var keg = nv > 0 ? Math.round(item.actualBgCurrentLitre / nv) : Math.round(item.actualBgCurrentLitre);
        return this.fmt(item.actualBgCurrentLitre) + " L (" + this.fmt(keg) + " ถัง)";
      }
      if (item.actualScvd == null) return "";
      var l = item.actualScvd * item.demandPerDayLitre;
      var k = item.actualScvd * item.demandPerDayKeg;
      return this.fmt(l) + " L (" + this.fmt(k) + " ถัง)";
    },
    trendInfo: function trendInfo(card) {
      var t = card.trend;
      var d = card.scvdDelta;
      var abs = d != null ? Math.abs(Math.round(d)) : null;
      if (t === "down") return { text: "▼ " + (abs != null ? abs + " วัน " : "") + "จากเดือนก่อน", cls: "down" };
      if (t === "up") return { text: "▲ " + (abs != null ? abs + " วัน " : "") + "(ดีขึ้น)", cls: "up" };
      if (t === "flat") return { text: "━ ไม่เปลี่ยน", cls: "stable" };
      return { text: "— ไม่มีข้อมูลเทียบ", cls: "stable" };
    },
    bulletPos: function bulletPos(val) {
      if (val == null) return null;
      var p = val / this.bulletScaleVal * 100;
      if (p < 0) p = 0;
      if (p > 100) p = 100;
      return p;
    },
    // ── ③ ส่วนต่างการวิเคราะห์ 3 รูปแบบ (Dashboard.md §③ · BRD §4.4.6) ──────────────
    // % วัดจาก Supply (action number) ไม่ใช่ Demand · แปลง ลิตร→ถัง per-SKU (NETVOLUME).
    // Raw inputs (ลิตร) มาจาก backend (mirror widget data) → คำนวณฝั่ง client เพื่อ recompute
    // สดเมื่อผู้ใช้ override Target SCVD (จำลอง) แบบ "บันทึกครั้งเดียว".
    gapRows: function gapRows(item) {
      var self = this;
      var nv = item.netVolume != null ? Number(item.netVolume) : 0;
      var qtyText = function qtyText(gapLitre) {
        var abs = Math.abs(gapLitre);
        var keg = nv > 0 ? Math.round(abs / nv) : Math.round(abs);
        return self.fmt(abs) + " L (" + self.fmt(keg) + " ถัง)";
      };
      // gap > 0 = ต่ำกว่าเป้า (ต้องผลิตเพิ่ม, แดง) · gap < 0 = สูงกว่าเป้า (น้ำเงิน) · 0 = ตรงเป้า (เขียว)
      var build = function build(gapLitre, denomLitre, mode) {
        if (gapLitre == null || denomLitre == null || denomLitre === 0) {
          return { text: "ไม่มีข้อมูลเพียงพอสำหรับเปรียบเทียบ", cls: "neutral" };
        }
        if (Math.round(Math.abs(gapLitre)) === 0) {
          return { text: "✅ ตรงตามเป้าหมาย — ไม่ต้องปรับ", cls: "ok" };
        }
        var pct = Math.abs(gapLitre) / Math.abs(denomLitre) * 100;
        var pctStr = pct.toFixed(1).replace(/\.0$/, "");
        var qty = qtyText(gapLitre);
        if (gapLitre > 0) {
          var verb = mode === 3 ? "ต้องปรับเพิ่มแผนผลิต" : "ต้องผลิตเพิ่ม";
          return { text: "🔻 ห่างจากเป้าหมาย " + pctStr + "% — " + verb + " " + qty, cls: "critical" };
        }
        var verb2 = mode === 3 ? "ต้องปรับลดแผนผลิต" : "ต้องระบายสต๊อก";
        return { text: "▲ สูงกว่าเป้าหมาย " + pctStr + "% — " + verb2 + " " + qty, cls: "planning" };
      };

      // raw inputs (ลิตร) จาก backend
      var tSupply = item.targetSupplyFullMonthLitre; // Supply (ตามเป้าหมาย) เต็มเดือน
      var tDemand = item.targetDemandFullMonthLitre; // Demand (ตามเป้าหมาย) เต็มเดือน
      var tBgStart = item.targetBgStartLitre; // BG Stock ต้นเดือน (ตามเป้าหมาย)
      var tSaleDays = item.targetSaleDaysFullMonth; // จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน
      var aSupplyCum = item.actualSupplyCumLitre; // Supply (ตามหน้างานจริง) สะสม
      var aBgCurrent = item.actualBgCurrentLitre; // BG Stock (ตามหน้างานจริง) ปัจจุบัน
      var tsim = item.targetSimScvd; // Target SCVD (จำลอง) — live session override

      // รูปแบบ 1: ส่วนต่าง Supply = Supply(เป้าหมาย)เต็มเดือน − Supply(จริง)สะสม ; % ÷ Supply(เป้าหมาย)
      var gap1 = null,
          denom1 = null;
      if (tSupply != null && aSupplyCum != null) {
        gap1 = tSupply - aSupplyCum;denom1 = tSupply;
      }

      // BG Stock ที่ต้องมี = Target SCVD × Demand(เป้าหมาย)เต็มเดือน ÷ วันขาย(เป้าหมาย)ทั้งเดือน (รูปแบบ 2/3)
      var bgNeeded = null;
      if (tsim != null && tDemand != null && tSaleDays != null && tSaleDays > 0) {
        bgNeeded = tsim * tDemand / tSaleDays;
      }
      // รูปแบบ 2: Supply ต้องเร่ง = BG ที่ต้องมี − BG(จริง)ปัจจุบัน ; % ÷ BG ที่ต้องมี
      var gap2 = null,
          denom2 = null;
      if (bgNeeded != null && aBgCurrent != null) {
        gap2 = bgNeeded - aBgCurrent;denom2 = bgNeeded;
      }
      // รูปแบบ 3: Supply ต้องปรับ = BG ที่ต้องมี − BG ต้นเดือน(เป้าหมาย) ; % ÷ BG ที่ต้องมี
      var gap3 = null,
          denom3 = null;
      if (bgNeeded != null && tBgStart != null) {
        gap3 = bgNeeded - tBgStart;denom3 = bgNeeded;
      }

      return [{ num: 1, fromCls: "mk-actual", fromText: "ข้อมูลตามหน้างานจริง", toCls: "mk-target-master", toText: "ข้อมูลตามเป้าหมาย", gap: build(gap1, denom1, 1) }, { num: 2, fromCls: "mk-actual", fromText: "ข้อมูลตามหน้างานจริง", toCls: "mk-target-scvd", toText: "Target SCVD (จำลอง)", gap: build(gap2, denom2, 2) }, { num: 3, fromCls: "mk-target-master", fromText: "ข้อมูลตามเป้าหมาย", toCls: "mk-target-scvd", toText: "Target SCVD (จำลอง)", gap: build(gap3, denom3, 3) }];
    },
    cellStyle: function cellStyle(cell) {
      if (cell.scvd == null || !cell.colorHex) {
        return { background: "#f3f4f6", color: "#9ca3af" };
      }
      return { background: cell.colorHex, color: this.textColor(cell.colorHex) };
    },

    // ── color helpers ────────────────────────────────────────
    parseHex: function parseHex(hex) {
      hex = (hex || "#cccccc").replace("#", "");
      if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      return {
        r: parseInt(hex.substring(0, 2), 16),
        g: parseInt(hex.substring(2, 4), 16),
        b: parseInt(hex.substring(4, 6), 16)
      };
    },
    toHex: function toHex(r, g, b) {
      var f = function f(n) {
        var s = Math.max(0, Math.min(255, Math.round(n))).toString(16);
        return s.length === 1 ? "0" + s : s;
      };
      return "#" + f(r) + f(g) + f(b);
    },
    mix: function mix(hex, targetHex, amount) {
      var a = this.parseHex(hex),
          b = this.parseHex(targetHex);
      return this.toHex(a.r + (b.r - a.r) * amount, a.g + (b.g - a.g) * amount, a.b + (b.b - a.b) * amount);
    },
    tint: function tint(hex, amount) {
      return this.mix(hex, "#ffffff", amount);
    },
    darken: function darken(hex, amount) {
      return this.mix(hex, "#000000", amount);
    },
    textColor: function textColor(hex) {
      var c = this.parseHex(hex);
      var lum = (0.299 * c.r + 0.587 * c.g + 0.114 * c.b) / 255;
      return lum > 0.62 ? "#1a1a1a" : "#ffffff";
    }
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    return {
      isLoading: false,
      isSaving: false,
      isExporting: false,
      errorMessage: "",
      detailData: null,
      cards: [],
      newCard: null,
      selectedVersion: "",
      selectedProduct: "",
      // Applied (Search-committed) filters — drive visibleCards; selected* are the pending dropdown values
      appliedVersion: "",
      appliedProduct: "",
      // R2-25: หน่วยแสดงผลหน้า View (ใช้เมื่อกดค้นหา เหมือน filter อื่น)
      selectedUnit: "ลิตร",
      appliedUnit: "ลิตร",
      // Import ข้อมูลตามเป้าหมาย(แก้ไข) state — mirrors StockCoverDaysCreate.vue import
      importEditFile: null,
      importEditFileName: "",
      lastImportEditRows: null,
      monthLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      measureRows: [{ key: "bgStockLitre", label: "BG Stock", cls: "scd-row-bg" }, { key: "demandLitre", label: "Demand", cls: "scd-row-demand" }, { key: "supplyLitre", label: "Supply", cls: "scd-row-supply" }],
      // Product Select2 (สินค้าสำเร็จรูป น้ำเบียร์) — reuse existing endpoint (A3/F4)
      productOptions: {
        placeholder: "เลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          data: function data(params) {
            return {
              search: params.term,
              page: params.page || 1,
              productGroupId: "14",
              productTypeId: "22",
              onlyStockCoverDays: true // CR-StockCoverDays A3: เฉพาะ SKU ที่เปิดใช้งาน SCVD
            };
          },
          processResults: function processResults(data) {
            return {
              results: data.results,
              pagination: { more: data.more }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  computed: {
    isViewMode: function isViewMode() {
      return this.$route.meta.isViewMode === true;
    },
    // R2-30 — เปิดจากแถว "ปิดใช้งาน" ในหน้า List (/View/{plant}/{year}?status=inactive) · ใช้เฉพาะโหมดดู
    isInactiveView: function isInactiveView() {
      return this.isViewMode && this.$route.query.status === "inactive";
    },
    // Editable = not view route AND server says year >= current year (M12/§1.5)
    canEdit: function canEdit() {
      return !this.isViewMode && this.hasWriteRole && !!this.detailData && this.detailData.isEditable === true;
    },
    // QA BUG-13: สิทธิ์เขียน SCVD = Admin + Team (เงื่อนไขเดียวกับหน้า List) · Viewer ไม่ผ่าน → ใช้ได้แค่หน้า View
    hasWriteRole: function hasWriteRole() {
      return this.$root.canShow([["SCVD_ADMIN", "COMPANY_PROFILE_TYPE_SCVD"], ["SCVD_TEAM_EDIT", "COMPANY_PROFILE_TYPE_SCVD"]]);
    },
    versionOptions: function versionOptions() {
      var set = {};
      this.cards.forEach(function (c) {
        set[c.version] = true;
      });
      return Object.keys(set).map(function (v) {
        return parseInt(v);
      }).sort(function (a, b) {
        return b - a;
      });
    },
    // Distinct products from the loaded cards (options for the ชื่อสินค้า filter)
    productFilterOptions: function productFilterOptions() {
      var seen = {};
      var list = [];
      this.cards.forEach(function (c) {
        if (!seen[c.productCode]) {
          seen[c.productCode] = true;
          list.push({ code: c.productCode, name: c.productName || "" });
        }
      });
      return list;
    },
    // #71: two-line edit-rule hint shown in the (i) tooltip. Rendered via v-html so the <br /> is a real
    // line break; keeps the exact wording incl. leading "*" on each line and quotes around เพิ่มข้อมูลตามเป้าหมาย.
    editHintHtml: function editHintHtml() {
      return '*แก้ไขตัวเลขย้อนหลังที่หน้า Master ได้ภายในปีเดียวกันเท่านั้น เช่น ปี 2026 แก้ไขย้อนหลังได้ภายใน 1/1/2026 - 31/12/2026 เท่านั้น<br />*จะเพิ่ม Version ใหม่จากการ Import ต้องไปเพิ่มที่หน้า "เพิ่มข้อมูลตามเป้าหมาย" แต่ถ้าจะสร้างจาก Web สามารถสร้างจากหน้านี้ได้เลย';
    },
    // Cards shown = applied (Search-committed) product AND version filters
    visibleCards: function visibleCards() {
      var p = this.appliedProduct;
      var v = this.appliedVersion;
      return this.cards.filter(function (c) {
        var okProduct = p === "" || p === null || String(c.productCode) === String(p);
        var okVersion = v === "" || v === null || String(c.version) === String(v);
        return okProduct && okVersion;
      }).sort(function (a, b) {
        // R2-12: group by product, show latest version first (version มาก→น้อย)
        if (String(a.productCode) !== String(b.productCode)) {
          return String(a.productCode) < String(b.productCode) ? -1 : 1;
        }
        return b.version - a.version;
      });
    }
  },
  // R2-26: เปลี่ยนตัวกรอง (ชื่อสินค้า / Version / หน่วย) แล้ว apply ทันที ไม่ต้องกดค้นหา
  //   (ปุ่มค้นหา/ล้างค่าทั้งหมดยังใช้ได้ · ตัวกรองมีผลแค่การแสดงผลฝั่งหน้าจอ ไม่ยิง API ใหม่)
  watch: {
    selectedProduct: function selectedProduct(v) {
      this.appliedProduct = v;
    },
    selectedVersion: function selectedVersion(v) {
      this.appliedVersion = v;
    },
    selectedUnit: function selectedUnit(v) {
      this.appliedUnit = v;
    }
  },
  mounted: function mounted() {
    // QA BUG-13: Viewer เปิด /Edit ตรง ๆ → พาไปหน้า View ทันที (ไม่แสดงช่องแก้ไข/ปุ่มบันทึก)
    if (!this.isViewMode && !this.hasWriteRole) {
      this.$router.replace({ path: "/StockCoverDays/View/" + this.$route.params.plantCode + "/" + this.$route.params.year });
    }
    this.loadDetail();
  },
  methods: {
    goBack: function goBack() {
      this.$router.push("/StockCoverDays/List");
    },

    loadDetail: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var self, plantCode, year, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;
                plantCode = self.$route.params.plantCode;
                year = self.$route.params.year;

                if (!(!plantCode || !year)) {
                  _context.next = 6;
                  break;
                }

                self.errorMessage = "ไม่พบข้อมูลคลังสินค้าหรือปี";
                return _context.abrupt("return");

              case 6:

                self.isLoading = true;
                self.errorMessage = "";
                _context.prev = 8;
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/StockCoverDayTarget/Detail", {
                  headers: { Authorization: "Bearer " + self.$root.user.access_token },
                  params: { plantCode: plantCode, year: year, status: self.isInactiveView ? "inactive" : undefined }
                });

              case 11:
                response = _context.sent;


                if (response.data && response.data.success && response.data.data) {
                  self.detailData = response.data.data;
                  self.cards = (self.detailData.cards || []).map(function (card) {
                    return {
                      productCode: card.productCode,
                      productName: card.productName || "",
                      version: card.version,
                      netVolume: card.netVolume || 0, // R2-25: ลิตรต่อถัง สำหรับแปลงหน่วย
                      isNew: false,
                      cells: self.buildCells(card.months)
                    };
                  });
                  self.newCard = null;
                  // reset filters so a fresh load shows all cards (spec default = ทั้งหมด)
                  self.selectedProduct = "";
                  self.selectedVersion = "";
                  self.appliedProduct = "";
                  self.appliedVersion = "";
                  self.selectedUnit = "ลิตร";
                  self.appliedUnit = "ลิตร";
                  // R2-28: เปิด /Edit ของปีที่แก้ไขไม่ได้ (ปีเก่า · isEditable=false) → พาไปหน้า View แทน
                  //   (View/Edit ใช้ component เดียวกัน · โหมดอิง $route.meta → สลับเป็นโหมดดูทันทีโดยไม่โหลดใหม่)
                  if (!self.isViewMode && self.detailData.isEditable === false) {
                    self.$router.replace({ path: "/StockCoverDays/View/" + plantCode + "/" + year });
                  }
                } else {
                  self.errorMessage = response.data && response.data.message || "ไม่สามารถโหลดข้อมูลได้";
                }
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](8);

                console.error("Error loading detail:", _context.t0);
                self.errorMessage = "เกิดข้อผิดพลาดในการโหลดข้อมูล";

              case 19:
                _context.prev = 19;

                self.isLoading = false;
                return _context.finish(19);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 15, 19, 22]]);
      }));

      function loadDetail() {
        return _ref.apply(this, arguments);
      }

      return loadDetail;
    }(),

    // Normalize a card's months into a fixed 12-slot array (M1: may be < 12 months)
    buildCells: function buildCells(months) {
      var map = {};
      (months || []).forEach(function (m) {
        map[m.month] = m;
      });
      var cells = [];
      for (var mo = 1; mo <= 12; mo++) {
        var s = map[mo];
        if (s) {
          cells.push({
            month: mo,
            exists: true,
            saleDays: s.saleDays,
            bgStockLitre: s.bgStockLitre,
            demandLitre: s.demandLitre,
            supplyLitre: s.supplyLitre,
            // formatted display twins the inputs bind to (numeric field stays source of truth)
            bgStockLitreText: this.formatInt(s.bgStockLitre),
            demandLitreText: this.formatInt(s.demandLitre),
            supplyLitreText: this.formatInt(s.supplyLitre),
            scvd: s.scvd,
            // IssueList #30: snapshot the loaded values → modified-only save (send/count only changed cells)
            _orig: { saleDays: s.saleDays, bgStockLitre: s.bgStockLitre, demandLitre: s.demandLitre, supplyLitre: s.supplyLitre }
          });
        } else {
          cells.push({
            month: mo,
            exists: false,
            saleDays: null,
            bgStockLitre: null,
            demandLitre: null,
            supplyLitre: null,
            bgStockLitreText: "",
            demandLitreText: "",
            supplyLitreText: "",
            scvd: null,
            _orig: { saleDays: null, bgStockLitre: null, demandLitre: null, supplyLitre: null }
          });
        }
      }
      return cells;
    },

    cellEditable: function cellEditable(card, cell) {
      if (card.isNew) return true;
      // IssueList #30: allow editing months that were not imported (cell.exists === false) too,
      // so the user can fill a previously-empty month and save it into the same version.
      return this.canEdit;
    },

    // ---- SCVD live preview (F6 mirror: AwayFromZero, 2dp; NULL when saleDays==0 || demand==0) ----
    scvdCompute: function scvdCompute(bg, demand, saleDays) {
      var b = this.toIntOrNull(bg);
      var d = this.toIntOrNull(demand);
      var s = this.toIntOrNull(saleDays);
      if (b === null || d === null || s === null) return null;
      if (s === 0 || d === 0) return null;
      var raw = b * s / d; // values >= 0 → Math.round = round-half-up = AwayFromZero
      return Math.round(raw * 100) / 100;
    },
    displayScvd: function displayScvd(card, cell) {
      if (this.cellEditable(card, cell)) {
        return this.scvdCompute(cell.bgStockLitre, cell.demandLitre, cell.saleDays);
      }
      return cell.scvd;
    },

    // ---- Numeric input guards (F5) ----
    onIntKeydown: function onIntKeydown(event) {
      var allowed = ["Backspace", "Delete", "Tab", "Escape", "Enter", "Home", "End", "ArrowLeft", "ArrowRight"];
      if (allowed.indexOf(event.key) !== -1) return;
      if ((event.ctrlKey || event.metaKey) && ["a", "c", "v", "x"].indexOf(event.key.toLowerCase()) !== -1) return;
      if (/^[0-9]$/.test(event.key)) return;
      event.preventDefault();
    },
    onSaleDaysBlur: function onSaleDaysBlur(cell) {
      if (this.isBlank(cell.saleDays)) {
        cell.saleDays = null;
        return;
      }
      var v = parseInt(cell.saleDays);
      if (isNaN(v) || v < 0) v = 0;
      if (v > 31) {
        Swal.fire("แจ้งเตือน", "จำนวนวันขายต้องอยู่ระหว่าง 0-31 วัน", "warning");
        v = 31;
      }
      cell.saleDays = v;
    },
    // BG / Demand / Supply — thousands-format on blur, strip on focus (mirror StockCoverDaysCreate.vue).
    // Source of truth = numeric cell[key]; cell[key+'Text'] is the formatted display twin the input binds to.
    stripThousands: function stripThousands(v) {
      return String(v === null || v === undefined ? "" : v).replace(/,/g, "");
    },
    formatThousands: function formatThousands(v) {
      // reuse formatInt (expects a comma-free value → strip first)
      return this.formatInt(this.stripThousands(v));
    },
    // focus → strip formatting back to plain digits for editing
    onMeasureFocus: function onMeasureFocus(cell, key) {
      cell[key + "Text"] = this.stripThousands(cell[key + "Text"]);
    },
    // blur → parse, clamp >= 0, store numeric (source of truth) + formatted display twin
    onMeasureBlur: function onMeasureBlur(cell, key) {
      var raw = this.stripThousands(cell[key + "Text"]).trim();
      if (raw === "") {
        cell[key] = null;
        cell[key + "Text"] = "";
        return;
      }
      var v = parseInt(raw, 10);
      if (isNaN(v) || v < 0) v = 0;
      cell[key] = v; // numeric — SCVD (displayScvd) + save payload (toInt) read this
      cell[key + "Text"] = this.formatInt(v); // formatted display twin
    },

    // ---- Add new (blank) card at top ----
    addNewCard: function addNewCard() {
      if (this.newCard) {
        Swal.fire("แจ้งเตือน", "กรุณาบันทึกข้อมูลที่เพิ่มก่อนหน้าให้เสร็จก่อน", "warning");
        return;
      }
      var cells = [];
      for (var m = 1; m <= 12; m++) {
        cells.push({
          month: m,
          exists: true,
          saleDays: null,
          bgStockLitre: null,
          demandLitre: null,
          supplyLitre: null,
          // formatted display twins (blank to start; numeric field stays source of truth)
          bgStockLitreText: "",
          demandLitreText: "",
          supplyLitreText: "",
          scvd: null
        });
      }
      this.newCard = { productCode: null, productName: "", version: null, isNew: true, cells: cells };
    },
    removeNewCard: function removeNewCard() {
      var self = this;
      Swal.fire({
        title: "ยกเลิกการเพิ่ม",
        text: "คุณต้องการยกเลิกการเพิ่มข้อมูลนี้หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ใช่",
        cancelButtonText: "ไม่"
      }).then(function (result) {
        if (result.value) {
          self.newCard = null;
        }
      });
    },
    onNewProductChange: function onNewProductChange(id, value, data) {
      if (!this.newCard) return;
      this.newCard.productCode = value;
      this.newCard.productName = data && data.length > 0 ? data[0].text : "";
    },

    // ---- Save new card → POST /Save (new version snapshot, M5 gate) ----
    saveNewCard: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self, months;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = this;

                if (self.newCard.productCode) {
                  _context2.next = 4;
                  break;
                }

                Swal.fire("กรุณากรอกข้อมูล", "กรุณาเลือกสินค้า", "warning");
                return _context2.abrupt("return");

              case 4:
                months = self.newCard.cells.filter(function (c) {
                  return self.hasCellData(c);
                }).map(function (c) {
                  return {
                    month: c.month,
                    saleDays: self.toInt(c.saleDays),
                    bgStockLitre: self.toInt(c.bgStockLitre),
                    demandLitre: self.toInt(c.demandLitre),
                    supplyLitre: self.toInt(c.supplyLitre)
                  };
                });

                if (!(months.length === 0)) {
                  _context2.next = 8;
                  break;
                }

                Swal.fire("กรุณากรอกข้อมูล", "กรุณากรอกข้อมูลอย่างน้อย 1 เดือน", "warning");
                return _context2.abrupt("return");

              case 8:
                _context2.next = 10;
                return self.postSave(months, false);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveNewCard() {
        return _ref2.apply(this, arguments);
      }

      return saveNewCard;
    }(),
    postSave: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(months, confirmNewVersion) {
        var self, payload, response, d, reCalcWarn, confirm, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self = this;
                payload = {
                  plantCode: self.detailData.plantCode,
                  year: parseInt(self.detailData.year),
                  confirmNewVersion: confirmNewVersion,
                  products: [{ productCode: self.newCard.productCode, months: months }]
                };
                _context3.prev = 2;

                self.isSaving = true;
                KTApp.blockPage({ opacity: 0.05, message: "กำลังบันทึกข้อมูล..." });
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/Save", payload, {
                  headers: { Authorization: "Bearer " + self.$root.user.access_token }
                });

              case 7:
                response = _context3.sent;

                KTApp.unblockPage();
                self.isSaving = false;

                d = response.data;

                if (!(d && d.needVersionConfirm)) {
                  _context3.next = 20;
                  break;
                }

                // P5: saving for the CURRENT year re-calculates snapshots of already-closed months of this year.
                reCalcWarn = parseInt(self.detailData.year, 10) === new Date().getFullYear() ? "<br><br><b style='color:#b45309'>⚠️ ปีปัจจุบัน:</b> การบันทึกจะ<b>คำนวณ snapshot ของเดือนที่ปิดรอบแล้ว</b>ในปีนี้ใหม่ (re-calculate) โดยอัตโนมัติ" : "";
                _context3.next = 15;
                return Swal.fire({
                  title: "พบข้อมูลเดิม",
                  html: (d.message || "พบข้อมูลของสินค้านี้อยู่แล้ว ต้องการเพิ่มเป็น Version ใหม่ใช่หรือไม่?") + reCalcWarn,
                  type: "question",
                  showCancelButton: true,
                  confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ย้อนกลับแก้ไข"
                });

              case 15:
                confirm = _context3.sent;

                if (!confirm.value) {
                  _context3.next = 19;
                  break;
                }

                _context3.next = 19;
                return self.postSave(months, true);

              case 19:
                return _context3.abrupt("return");

              case 20:
                if (!(d && d.success)) {
                  _context3.next = 29;
                  break;
                }

                _context3.next = 23;
                return Swal.fire("บันทึกสำเร็จ", d.message || "บันทึกข้อมูลเรียบร้อยแล้ว", "success");

              case 23:
                self.newCard = null;
                self.selectedVersion = "";
                _context3.next = 27;
                return self.loadDetail();

              case 27:
                _context3.next = 30;
                break;

              case 29:
                Swal.fire("เกิดข้อผิดพลาด", d && d.message || "ไม่สามารถบันทึกข้อมูลได้", "error");

              case 30:
                _context3.next = 41;
                break;

              case 32:
                _context3.prev = 32;
                _context3.t0 = _context3["catch"](2);

                KTApp.unblockPage();
                self.isSaving = false;
                console.error("Error saving:", _context3.t0);
                message = "ไม่สามารถบันทึกข้อมูลได้";

                if (_context3.t0.response && _context3.t0.response.data && _context3.t0.response.data.message) {
                  message = _context3.t0.response.data.message;
                }
                if (_context3.t0.response && _context3.t0.response.status === 403) {
                  message = "คุณไม่มีสิทธิ์บันทึกข้อมูล กรุณาติดต่อผู้ดูแลระบบ"; // QA BUG-05
                }
                Swal.fire("เกิดข้อผิดพลาด", message, "error");

              case 41:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 32]]);
      }));

      function postSave(_x, _x2) {
        return _ref3.apply(this, arguments);
      }

      return postSave;
    }(),

    // ---- Save in-place update → PUT /Update (B.6, no new version) ----
    saveUpdate: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var self, reCalcWarn, confirmResult, hasAnyValue, isComplete, isModified, badCell, payloadCards, changedCount, payload, response, message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = this;
                // P5: saving edits for the CURRENT year re-calculates snapshots of already-closed months of this year.

                reCalcWarn = parseInt(self.detailData.year, 10) === new Date().getFullYear() ? "<br><br><b style='color:#b45309'>⚠️ ปีปัจจุบัน:</b> การบันทึกจะ<b>คำนวณ snapshot ของเดือนที่ปิดรอบแล้ว</b>ในปีนี้ใหม่ (re-calculate) โดยอัตโนมัติ" : "";
                _context4.next = 4;
                return Swal.fire({
                  title: "ยืนยันการบันทึก",
                  html: "คุณต้องการบันทึกการแก้ไขข้อมูลนี้หรือไม่?" + reCalcWarn,
                  type: "question",
                  showCancelButton: true,
                  confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ยกเลิก"
                });

              case 4:
                confirmResult = _context4.sent;

                if (confirmResult.value) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return");

              case 7:

                // IssueList #30: MODIFIED-ONLY save. A cell is "modified" if it is a newly-filled empty month OR an
                // existing month whose value changed from what was loaded (_orig). Only modified cells are sent + counted.
                hasAnyValue = function hasAnyValue(c) {
                  return !self.isBlank(c.saleDays) || !self.isBlank(c.bgStockLitre) || !self.isBlank(c.demandLitre) || !self.isBlank(c.supplyLitre);
                };

                isComplete = function isComplete(c) {
                  return !self.isBlank(c.saleDays) && !self.isBlank(c.bgStockLitre) && !self.isBlank(c.demandLitre) && !self.isBlank(c.supplyLitre);
                };

                isModified = function isModified(c) {
                  if (!c.exists) return hasAnyValue(c); // new month → modified once the user fills anything
                  var o = c._orig || {};
                  return self.toInt(c.saleDays) !== self.toInt(o.saleDays) || self.toInt(c.bgStockLitre) !== self.toInt(o.bgStockLitre) || self.toInt(c.demandLitre) !== self.toInt(o.demandLitre) || self.toInt(c.supplyLitre) !== self.toInt(o.supplyLitre);
                };
                // every MODIFIED cell must have ALL fields filled (บังคับกรอกครบ) — partial new/edited month is rejected.


                badCell = null;

                self.cards.forEach(function (card) {
                  card.cells.forEach(function (c) {
                    if (!badCell && isModified(c) && !isComplete(c)) {
                      badCell = { p: card.productName || card.productCode, m: self.monthLabels[c.month - 1] };
                    }
                  });
                });

                if (!badCell) {
                  _context4.next = 15;
                  break;
                }

                Swal.fire("ข้อมูลไม่ครบ", "กรุณากรอกให้ครบทุกช่อง (จำนวนวันขาย / BG Stock / Demand / Supply) — สินค้า " + badCell.p + " เดือน " + badCell.m, "warning");
                return _context4.abrupt("return");

              case 15:
                payloadCards = self.cards.map(function (card) {
                  return {
                    productCode: card.productCode,
                    version: card.version,
                    months: card.cells.filter(isModified) // #30: only changed existing months + newly-filled months
                    .map(function (c) {
                      return {
                        month: c.month,
                        saleDays: self.toInt(c.saleDays),
                        bgStockLitre: self.toInt(c.bgStockLitre),
                        demandLitre: self.toInt(c.demandLitre),
                        supplyLitre: self.toInt(c.supplyLitre)
                      };
                    })
                  };
                }).filter(function (card) {
                  return card.months.length > 0; // drop products with no changes
                });

                // nothing changed → skip the API call

                changedCount = payloadCards.reduce(function (n, c) {
                  return n + c.months.length;
                }, 0);

                if (!(changedCount === 0)) {
                  _context4.next = 20;
                  break;
                }

                Swal.fire("ไม่มีการเปลี่ยนแปลง", "ไม่พบข้อมูลที่แก้ไข", "info");
                return _context4.abrupt("return");

              case 20:
                payload = {
                  plantCode: self.detailData.plantCode,
                  year: parseInt(self.detailData.year),
                  cards: payloadCards
                };
                _context4.prev = 21;

                self.isSaving = true;
                KTApp.blockPage({ opacity: 0.05, message: "กำลังบันทึกข้อมูล..." });
                _context4.next = 26;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/Api/StockCoverDayTarget/Update", payload, {
                  headers: { Authorization: "Bearer " + self.$root.user.access_token }
                });

              case 26:
                response = _context4.sent;

                KTApp.unblockPage();
                self.isSaving = false;

                if (!(response.data && response.data.success)) {
                  _context4.next = 36;
                  break;
                }

                _context4.next = 32;
                return Swal.fire("บันทึกสำเร็จ", response.data.message || "บันทึกข้อมูลเรียบร้อยแล้ว", "success");

              case 32:
                _context4.next = 34;
                return self.loadDetail();

              case 34:
                _context4.next = 37;
                break;

              case 36:
                Swal.fire("เกิดข้อผิดพลาด", response.data && response.data.message || "ไม่สามารถบันทึกข้อมูลได้", "error");

              case 37:
                _context4.next = 48;
                break;

              case 39:
                _context4.prev = 39;
                _context4.t0 = _context4["catch"](21);

                KTApp.unblockPage();
                self.isSaving = false;
                console.error("Error updating:", _context4.t0);
                message = "ไม่สามารถบันทึกข้อมูลได้";

                if (_context4.t0.response && _context4.t0.response.data && _context4.t0.response.data.message) {
                  message = _context4.t0.response.data.message;
                }
                if (_context4.t0.response && _context4.t0.response.status === 403) {
                  message = "คุณไม่มีสิทธิ์บันทึกข้อมูล กรุณาติดต่อผู้ดูแลระบบ"; // QA BUG-05
                }
                Swal.fire("เกิดข้อผิดพลาด", message, "error");

              case 48:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[21, 39]]);
      }));

      function saveUpdate() {
        return _ref4.apply(this, arguments);
      }

      return saveUpdate;
    }(),

    // ---- Delete a card (soft) → POST /Delete (grain product×version, A7) ----
    deleteCard: function deleteCard(card) {
      var self = this;
      Swal.fire({
        title: "ยืนยันการลบ",
        text: "คุณต้องการลบข้อมูล " + card.productName + " Version" + card.version + " หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ใช่, ลบ",
        cancelButtonText: "ยกเลิก"
      }).then(function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(result) {
          var response;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (result.value) {
                    _context5.next = 2;
                    break;
                  }

                  return _context5.abrupt("return");

                case 2:
                  _context5.prev = 2;

                  KTApp.blockPage({ opacity: 0.05, message: "กำลังลบข้อมูล..." });
                  _context5.next = 6;
                  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/Delete", {
                    plantCode: self.detailData.plantCode,
                    productCode: card.productCode,
                    year: parseInt(self.detailData.year),
                    version: card.version
                  }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } });

                case 6:
                  response = _context5.sent;

                  KTApp.unblockPage();

                  if (!(response.data && response.data.success)) {
                    _context5.next = 15;
                    break;
                  }

                  _context5.next = 11;
                  return Swal.fire("ลบสำเร็จ", response.data.message || "ลบข้อมูลเรียบร้อยแล้ว", "success");

                case 11:
                  _context5.next = 13;
                  return self.loadDetail();

                case 13:
                  _context5.next = 16;
                  break;

                case 15:
                  Swal.fire("เกิดข้อผิดพลาด", response.data && response.data.message || "ไม่สามารถลบข้อมูลได้", "error");

                case 16:
                  _context5.next = 23;
                  break;

                case 18:
                  _context5.prev = 18;
                  _context5.t0 = _context5["catch"](2);

                  KTApp.unblockPage();
                  console.error("Error deleting:", _context5.t0);
                  Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถลบข้อมูลได้", "error");

                case 23:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this, [[2, 18]]);
        }));

        return function (_x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    },

    // ---- Download(แก้ไข) → GET /Export (blob) F11 ----
    downloadExport: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var self, params, response, message;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                self = this;
                _context6.prev = 1;

                self.isExporting = true;
                params = new URLSearchParams();

                params.append("plantCode", self.detailData.plantCode);
                params.append("year", self.detailData.year);
                if (self.appliedVersion !== "") {
                  params.append("version", self.appliedVersion);
                }
                if (self.appliedProduct !== "") {
                  params.append("productCode", self.appliedProduct); // IssueList #27: match the on-screen product filter
                }
                params.append("forEdit", "true"); // IssueList #26: grey the read-only columns in the edit download

                _context6.next = 11;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/StockCoverDayTarget/Export?" + params.toString(), {
                  headers: { Authorization: "Bearer " + self.$root.user.access_token },
                  responseType: "blob"
                });

              case 11:
                response = _context6.sent;


                self.isExporting = false;
                self.downloadBlobResponse(response, "StockCoverDays_" + self.detailData.plantCode + "_" + self.detailData.year + "_edit.xlsx");
                _context6.next = 23;
                break;

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6["catch"](1);

                self.isExporting = false;
                console.error("Error exporting:", _context6.t0);
                message = "ไม่สามารถดาวน์โหลดข้อมูลได้";

                if (_context6.t0.response && _context6.t0.response.status === 404) {
                  message = "ไม่พบข้อมูลสำหรับดาวน์โหลด";
                }
                Swal.fire("เกิดข้อผิดพลาด", message, "error");

              case 23:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 16]]);
      }));

      function downloadExport() {
        return _ref6.apply(this, arguments);
      }

      return downloadExport;
    }(),

    // ---- Plain Export Excel (currently-shown data) → GET /Export (F11) ----
    exportExcel: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var self, params, response, message;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                self = this;
                _context7.prev = 1;

                self.isExporting = true;
                params = new URLSearchParams();

                params.append("plantCode", self.detailData.plantCode);
                params.append("year", self.detailData.year);
                if (self.appliedVersion !== "") {
                  params.append("version", self.appliedVersion);
                }
                // ASSUMPTION: F11 /Export accepts plantCode/year/version only (no productCode param in controller).
                // The product filter is applied client-side to the view; send productCode too so a future BE can honour it.
                if (self.appliedProduct !== "") {
                  params.append("productCode", self.appliedProduct);
                }
                // R2-25: Export ตามหน่วยที่เลือก (หน้า View) · หน้า Edit = ลิตร
                params.append("unit", self.isViewMode ? self.appliedUnit : "ลิตร");
                // R2-30: View ของแถวปิดใช้งาน → export เฉพาะรายการที่ปิดใช้งาน
                if (self.isInactiveView) {
                  params.append("status", "inactive");
                }
                _context7.next = 12;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/Api/StockCoverDayTarget/Export?" + params.toString(), {
                  headers: { Authorization: "Bearer " + self.$root.user.access_token },
                  responseType: "blob"
                });

              case 12:
                response = _context7.sent;

                self.isExporting = false;
                self.downloadBlobResponse(response, "StockCoverDays_" + self.detailData.plantCode + "_" + self.detailData.year + ".xlsx");
                _context7.next = 24;
                break;

              case 17:
                _context7.prev = 17;
                _context7.t0 = _context7["catch"](1);

                self.isExporting = false;
                console.error("Error exporting:", _context7.t0);
                message = "ไม่สามารถดาวน์โหลดข้อมูลได้";

                if (_context7.t0.response && _context7.t0.response.status === 404) {
                  message = "ไม่พบข้อมูลสำหรับดาวน์โหลด";
                }
                Swal.fire("เกิดข้อผิดพลาด", message, "error");

              case 24:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 17]]);
      }));

      function exportExcel() {
        return _ref7.apply(this, arguments);
      }

      return exportExcel;
    }(),

    // ---- Filters (ชื่อสินค้า + Version) — ค้นหา / ล้างค่าทั้งหมด (spec §4.2.5) ----
    applyFilters: function applyFilters() {
      this.appliedProduct = this.selectedProduct;
      this.appliedVersion = this.selectedVersion;
      this.appliedUnit = this.selectedUnit;
    },
    clearFilters: function clearFilters() {
      this.selectedProduct = "";
      this.selectedVersion = "";
      this.appliedProduct = "";
      this.appliedVersion = "";
      this.selectedUnit = "ลิตร";
      this.appliedUnit = "ลิตร";
    },
    // R2-25: ค่า BG/Demand/Supply ในหน่วยที่เลือก (เฉพาะหน้า View) — ค่าเก็บเป็นลิตร ·
    //   ถัง = ลิตร ÷ NETVOLUME ของสินค้า ปัดครึ่งขึ้นเป็นจำนวนเต็ม (ตรงกับ ScvdUnitConverter ฝั่ง BE)
    displayMeasure: function displayMeasure(card, litres) {
      if (!this.isViewMode || this.appliedUnit !== "ถัง") return litres;
      if (this.isBlank(litres)) return litres;
      var nv = Number(card && card.netVolume);
      if (!(nv > 0)) return litres;
      return Math.round(Number(litres) / nv);
    },

    // ---- Shared blob → file download (used by Export/ดาวโหลด/Error Detail) ----
    downloadBlobResponse: function downloadBlobResponse(response, fallbackName) {
      var filename = fallbackName;
      var contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        var match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1].replace(/['"]/g, ""));
        }
      }
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    },

    // ---- Import ข้อมูลตามเป้าหมาย(แก้ไข) — validate → preview → confirm (edit-mode only) ----
    // Mirrors StockCoverDaysCreate.vue import flow. Endpoints ImportEdit/ImportEditConfirm are
    // being built by BE (wire FE only). Error Detail reuses F9 /ExportErrors.
    showImportEditModal: function showImportEditModal() {
      this.resetImportEditForm();
      $("#importEditStockCoverDaysModal").modal("show");
    },
    resetImportEditForm: function resetImportEditForm() {
      this.importEditFile = null;
      this.importEditFileName = "";
      if (this.$refs.importEditFileInput) {
        this.$refs.importEditFileInput.value = "";
      }
    },
    onImportEditFileChange: function onImportEditFileChange(e) {
      var file = e.target.files[0];
      if (file) {
        var ext = file.name.split(".").pop().toLowerCase();
        if (ext !== "xlsx") {
          Swal.fire("ผิดพลาด", "กรุณาเลือกไฟล์ .xlsx เท่านั้น", "error");
          this.$refs.importEditFileInput.value = "";
          this.importEditFile = null;
          this.importEditFileName = "";
          return;
        }
        this.importEditFile = file;
        this.importEditFileName = file.name;
      } else {
        this.importEditFile = null;
        this.importEditFileName = "";
      }
    },
    // Step 1 — validate + preview (NO write) → POST /ImportEdit
    submitImportEdit: function submitImportEdit() {
      if (!this.importEditFile) {
        Swal.fire("ผิดพลาด", "กรุณาเลือกไฟล์ Excel", "warning");
        return;
      }
      var self = this;
      var formData = new FormData();
      formData.append("file", this.importEditFile);
      // ASSUMPTION: BE ImportEdit uses the loaded plant/year as the edit context — send them along.
      formData.append("plantCode", this.detailData.plantCode);
      formData.append("year", this.detailData.year);
      KTApp.blockPage({ opacity: 0.05, message: "กำลังตรวจสอบข้อมูล กรุณารอสักครู่..." });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/ImportEdit", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + self.$root.user.access_token
        }
      }).then(function (response) {
        if (response.data.success) {
          $("#importEditStockCoverDaysModal").modal("hide");
          var preview = response.data.preview || {};
          var rows = response.data.importRows || [];
          // ASSUMPTION: preview shape mirrors /Import; edit-count key may be updateCount (fallback existingGroupCount).
          var editCount = preview.updateCount != null ? preview.updateCount : preview.existingGroupCount || 0;
          var html = "<p>ตรวจสอบข้อมูลสำเร็จ พร้อมนำเข้า (แก้ไข)</p>";
          html += "<p>- จำนวนแถวทั้งหมด: " + (preview.totalRows || 0) + " รายการ<br/>";
          html += "- รายการที่จะแก้ไข: " + editCount + " กลุ่ม</p>";
          // P5: whole page is one plant+year; importing edits for the CURRENT year re-calculates
          // snapshots of already-closed months of this year.
          if (parseInt(self.detailData.year, 10) === new Date().getFullYear()) {
            html += "<br><br><b style='color:#b45309'>⚠️ ปีปัจจุบัน:</b> การบันทึกจะ<b>คำนวณ snapshot ของเดือนที่ปิดรอบแล้ว</b>ในปีนี้ใหม่ (re-calculate) โดยอัตโนมัติ";
          }
          Swal.fire({
            title: "ยืนยันการนำเข้าข้อมูล(แก้ไข)",
            html: html,
            type: "info",
            showCancelButton: true,
            confirmButtonText: "ยืนยันนำเข้า",
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true
          }).then(function (result) {
            if (result.value) {
              self.confirmImportEdit(rows);
            }
          });
        } else {
          self.lastImportEditRows = response.data.importRows || null;
          var errorHtml = "<p>" + (response.data.message || "นำเข้าข้อมูลไม่สำเร็จ") + "</p>";
          if (self.lastImportEditRows && self.lastImportEditRows.length > 0) {
            errorHtml += "<p>คลิก <strong>ดาวน์โหลด Error Detail</strong> เพื่อดูรายละเอียด</p>";
          }
          Swal.fire({
            title: "นำเข้าข้อมูลไม่สำเร็จ",
            html: errorHtml,
            type: "error",
            showCancelButton: self.lastImportEditRows && self.lastImportEditRows.length > 0,
            confirmButtonText: "ตกลง",
            cancelButtonText: '<i class="fas fa-download"></i> ดาวน์โหลด Error Detail',
            cancelButtonColor: "#5867dd"
          }).then(function (result) {
            if (result.dismiss === Swal.DismissReason.cancel) {
              self.downloadImportEditErrorDetail();
            }
          });
        }
      }).catch(function (error) {
        var message = "เกิดข้อผิดพลาดในการนำเข้าข้อมูล";
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    // Step 2 — commit validated rows → POST /ImportEditConfirm → reload detail
    confirmImportEdit: function confirmImportEdit(rows) {
      var self = this;
      KTApp.blockPage({ opacity: 0.05, message: "กำลังนำเข้าข้อมูล กรุณารอสักครู่..." });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/ImportEditConfirm", { rows: rows }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        if (response.data.success) {
          // ASSUMPTION: confirm returns updatedCount (fallback createdCount).
          var n = response.data.updatedCount != null ? response.data.updatedCount : response.data.createdCount || 0;
          Swal.fire({
            title: "สำเร็จ",
            html: "นำเข้าข้อมูล(แก้ไข)สำเร็จ " + n + " รายการ",
            type: "success"
          }).then(function () {
            self.loadDetail();
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        var message = "เกิดข้อผิดพลาดในการนำเข้าข้อมูล";
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },
    // Error Detail — F9 (edit) POST /ExportEditErrors → keeps Version + ID columns (IssueList #26)
    downloadImportEditErrorDetail: function downloadImportEditErrorDetail() {
      var self = this;
      if (!self.lastImportEditRows || self.lastImportEditRows.length === 0) {
        Swal.fire("ผิดพลาด", "ไม่พบข้อมูลสำหรับ export", "warning");
        return;
      }
      KTApp.blockPage({ opacity: 0.05, message: "กำลังสร้างไฟล์ กรุณารอสักครู่..." });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/ExportEditErrors", { importRows: self.lastImportEditRows }, { responseType: "blob", headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        self.downloadBlobResponse(response, "StockCoverDays_ImportEditErrors.xlsx");
      }).catch(function () {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดาวน์โหลดไฟล์ได้", "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },

    // ---- Helpers ----
    isBlank: function isBlank(v) {
      return v === "" || v === null || v === undefined;
    },
    isNumeric: function isNumeric(v) {
      return !this.isBlank(v) && !isNaN(v);
    },
    hasCellData: function hasCellData(cell) {
      return this.isNumeric(cell.saleDays) || this.isNumeric(cell.bgStockLitre) || this.isNumeric(cell.demandLitre) || this.isNumeric(cell.supplyLitre);
    },
    toInt: function toInt(v) {
      if (this.isBlank(v)) return 0;
      var n = parseInt(v);
      return isNaN(n) ? 0 : n;
    },
    toIntOrNull: function toIntOrNull(v) {
      if (this.isBlank(v)) return null;
      var n = parseInt(v);
      return isNaN(n) ? null : n;
    },
    formatInt: function formatInt(v) {
      if (this.isBlank(v)) return "";
      return Number(v).toLocaleString("en-US");
    },
    formatScvd: function formatScvd(v) {
      if (v === null || v === undefined) return "-";
      return Number(v).toFixed(2);
    }
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__ = __webpack_require__(24);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(11);
__webpack_require__(13);
__webpack_require__(9);

// Status toggle — active (green): click to deactivate. Grain = (plant, year).
var StatusActionsTrue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a v-if=\"canEdit\" href=\"#\" class=\"btn btn-sm btn-success\" @click.prevent=\"toggleStatus\">\n      <i class=\"fas fa-play\"></i> \u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n    <span v-else class=\"badge badge-success\">\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19</span>\n  </div>",
  props: ['canEdit'],
  methods: {
    toggleStatus: function toggleStatus() {
      toggleScvdStatus(this, "หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน");
    }
  }
});

var StatusActionsFalse = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a v-if=\"canEdit\" href=\"#\" class=\"btn btn-sm btn-danger\" @click.prevent=\"toggleStatus\">\n      <i class=\"fas fa-pause\"></i> \u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\n    </a>\n    <span v-else class=\"badge badge-danger\">\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19</span>\n  </div>",
  props: ['canEdit'],
  methods: {
    toggleStatus: function toggleStatus() {
      toggleScvdStatus(this, "หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน");
    }
  }
});

// Shared toggle handler — PUT /ToggleStatus with { plantCode, year, inActiveStatus } (R2-30: grain plant×year×สถานะ — List แยกแถว active/inactive)
function toggleScvdStatus(ctx, detailText) {
  var self = ctx;
  Swal.fire({
    title: "คำสั่งแก้ไขสถานะ",
    type: "warning",
    html: "กรุณายืนยันคำสั่งแก้ไขสถานะ " + detailText,
    showCancelButton: true,
    confirmButtonText: "ยืนยัน",
    cancelButtonText: "ยกเลิก",
    showLoaderOnConfirm: true
  }).then(function (result) {
    if (result.value) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังแก้ไขสถานะ กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/StockCoverDayTarget/ToggleStatus", { plantCode: self.data.plantCode, year: self.data.year, inActiveStatus: !self.data.isActive }, {
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token
        }
      }).then(function (response) {
        if (response.data.success) {
          self.$parent.reloadDataTable();
          Swal.fire("สำเร็จ", "ปรับปรุงสถานะการใช้งานสำเร็จ", "success");
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        var errorMsg = error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด";
        Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    }
  });
}

// List 🗑️ — soft-delete (ซ่อน) ทั้ง (plant, year) = ทุกสินค้า×version. Grain = plant×year (wireframe §1.1).
// หมายเหตุ: 🗑️ ราย card (สินค้า×version) อยู่ที่หน้า Detail แยกต่างหาก.
function deleteScvdPlantYear(ctx) {
  var self = ctx;
  Swal.fire({
    title: "ยืนยันการลบข้อมูล",
    type: "warning",
    html: "ต้องการซ่อน/ลบข้อมูลทั้งหมดของคลังนี้ (ทุกสินค้า/ทุกเวอร์ชันของปีนี้) ใช่หรือไม่?<br/>" + "<small class='text-muted'>เปิดกลับต้องติดต่อผู้ดูแลระบบ</small>",
    showCancelButton: true,
    confirmButtonText: "ยืนยันลบ",
    cancelButtonText: "ยกเลิก",
    showLoaderOnConfirm: true
  }).then(function (result) {
    if (result.value) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังลบข้อมูล กรุณารอสักครู่..."
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/StockCoverDayTarget/DeleteByPlantYear", { plantCode: self.data.plantCode, year: self.data.year, inActiveStatus: !self.data.isActive }, {
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token
        }
      }).then(function (response) {
        if (response.data.success) {
          self.$parent.reloadDataTable();
          Swal.fire("สำเร็จ", "ลบข้อมูลสำเร็จ", "success");
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      }).catch(function (error) {
        var errorMsg = error.response && error.response.data && error.response.data.message ? error.response.data.message : "เกิดข้อผิดพลาด";
        Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    }
  });
}

// Row actions — 🔍 View, ✏️ Edit, 🗑️ Delete (ซ่อนทั้ง plant×year). Delete ราย card อยู่หน้า Detail.
var StockCoverDaysActions = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: "\n  <div>\n    <a :href=\"viewUrl\" @click.prevent=\"viewTarget\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E14\u0E39\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\">\n      <i class=\"fas fa-search\"></i>\n    </a>\n    <a v-if=\"canEdit && !isPastYear && data.isActive\" :href=\"editUrl\" @click.prevent=\"editTarget\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\">\n      <i class=\"la la-edit\"></i>\n    </a>\n    <a v-if=\"canEdit\" href=\"#\" @click.prevent=\"deleteTarget\" class=\"btn btn-sm btn-clean btn-icon btn-icon-md\" title=\"\u0E0B\u0E48\u0E2D\u0E19/\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\">\n      <i class=\"la la-trash text-danger\"></i>\n    </a>\n  </div>",
  props: ['canEdit'],
  computed: {
    // R2-28: ปีที่ผ่านไปแล้วแก้ไขไม่ได้ (BE: IsEditable = Year >= ปีปัจจุบัน) → ซ่อนปุ่มแก้ไข · ปุ่มดู/ลบคงไว้
    isPastYear: function isPastYear() {
      return Number(this.data.year) < new Date().getFullYear();
    },
    // R2-18: real href so right-click → "open in new tab" lands on the View/Edit route (was href="#" → /#)
    viewUrl: function viewUrl() {
      return '/StockCoverDays/View/' + this.data.plantCode + '/' + this.data.year + (this.data.isActive ? '' : '?status=inactive');
    },
    editUrl: function editUrl() {
      return '/StockCoverDays/Edit/' + this.data.plantCode + '/' + this.data.year;
    }
  },
  methods: {
    viewTarget: function viewTarget() {
      // R2-30 — แถวปิดใช้งาน → View แสดงเฉพาะรายการที่ปิดใช้งาน
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/StockCoverDays/View/" + this.data.plantCode + "/" + this.data.year, query: this.data.isActive ? {} : { status: "inactive" } });
    },
    editTarget: function editTarget() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/StockCoverDays/Edit/" + this.data.plantCode + "/" + this.data.year });
    },
    deleteTarget: function deleteTarget() {
      deleteScvdPlantYear(this);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */]
  },
  computed: {
    // สิทธิ์แก้ไข — SCVD WRITE = Admin + Team (Viewer ไม่ผ่าน); super_admin ผ่านเสมอผ่าน canShow (AUTHORIZE_WRITE)
    canEdit: function canEdit() {
      return this.$root.canShow([["SCVD_ADMIN", "COMPANY_PROFILE_TYPE_SCVD"], ["SCVD_TEAM_EDIT", "COMPANY_PROFILE_TYPE_SCVD"]]);
    }
  },
  data: function data() {
    var self = this;
    // Year options: current year - 1, current year, current year + 1 (M14/B.3)
    var currentYear = new Date().getFullYear();
    var yearData = [{ id: (currentYear + 1).toString(), text: (currentYear + 1).toString() }, { id: currentYear.toString(), text: currentYear.toString() }, { id: (currentYear - 1).toString(), text: (currentYear - 1).toString() }];

    return {
      searchPlant: null,
      searchYear: currentYear.toString(), // Default: current year
      searchStatus: "1", // Default: ใช้งาน
      searchYearOptions: {
        placeholder: "เลือกปี",
        allowClear: true,
        data: yearData
      },
      statusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [{ id: "1", text: "ใช้งาน" }, { id: "0", text: "ไม่ใช้งาน" }]
      },
      // Plant Select2 — scoped ajax + เฉพาะคลังที่ติ๊ก "ใช้งาน SCVD" (F6, /Api/StockCoverDayTarget/Select2Plant)
      plantOptions: {
        placeholder: "เลือก คลังสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/StockCoverDayTarget/Select2Plant",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function processResults(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formReset: function formReset(e) {
      // ล้างค่าทั้งหมด = reset filter ค้นหา (ไม่ได้ลบข้อมูลจริง — M15)
      this.searchPlant = null;
      this.searchYear = null;
      this.searchStatus = null;
      $("#scvdList_plantKey").val("").trigger("change");
      $("#scvdList_yearKey").val("").trigger("change");
      $("#scvdList_statusKey").val("").trigger("change");
      this.formSubmit(e);
    },
    formSubmit: function formSubmit(e) {
      e.preventDefault();
      var table = $("#stockCoverDaysTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function reloadDataTable() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $("#stockCoverDaysTable").DataTable().ajax.reload(null, resetPaging);
    },
    goToCreate: function goToCreate() {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: "/StockCoverDays/Create" });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var self, currentYear, table;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;

              // Set default values for dropdowns

              _context.next = 3;
              return _this.$nextTick();

            case 3:
              currentYear = new Date().getFullYear();

              $("#scvdList_statusKey").val("1").trigger("change");
              $("#scvdList_yearKey").val(currentYear.toString()).trigger("change");

              $.fn.dataTable.ext.errMode = "none";
              table = $("#stockCoverDaysTable");

              table.DataTable({
                responsive: true,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                ajax: {
                  url: "/Api/StockCoverDayTarget/Search",
                  type: "post",
                  dataType: "json",
                  contentType: "application/json",
                  beforeSend: function beforeSend(request) {
                    request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
                  },
                  data: function data(d) {
                    return JSON.stringify($.extend(d, {
                      PlantCode: self.searchPlant,
                      Year: self.searchYear,
                      Status: self.searchStatus
                    }));
                  }
                },
                dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>\n        <'row'<'col-sm-12'tr>>\n        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
                lengthMenu: [50, 100, 200, 500],
                pageLength: 100,
                language: {
                  lengthMenu: "Display _MENU_"
                },
                order: [[0, "asc"], [2, "desc"]], // Plant (asc), then Year (desc)
                columns: [{ data: "plantName", className: "text-center", width: "15%" }, {
                  data: "products",
                  className: "text-left",
                  width: "30%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    if (data && data.length > 0) {
                      return data.map(function (p) {
                        return "[" + p.productCode + "] " + p.productName;
                      }).join("<br/>");
                    }
                    return "-";
                  }
                }, { data: "year", className: "text-center", width: "10%" }, {
                  data: "lastUpdatedDate",
                  className: "text-center",
                  width: "15%",
                  render: function render(data, type, full, meta) {
                    if (data) {
                      var d = new Date(data);
                      var day = String(d.getDate()).padStart(2, "0");
                      var month = String(d.getMonth() + 1).padStart(2, "0");
                      var year = d.getFullYear();
                      return day + "/" + month + "/" + year;
                    }
                    return "-";
                  }
                }, {
                  data: "isActive",
                  className: "text-center",
                  width: "15%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actionsStatus"></div>';
                  }
                }, {
                  data: "plantCode",
                  className: "text-center",
                  width: "15%",
                  orderable: false,
                  render: function render(data, type, full, meta) {
                    return '<div class="actions"></div>';
                  }
                }]
              }).on("preXhr.dt", function () {
                KTApp.block(self.$refs.searchForm, {
                  showOverlay: false,
                  opacity: 0.05,
                  message: "กำลังค้นหาข้อมูล กรุณารอสักครู่..."
                });
              }).on("error.dt", function (e, settings, techNote, message) {
                __WEBPACK_IMPORTED_MODULE_4__Shared_DatatableWarning__["a" /* default */].alert(techNote);
              }).on("xhr.dt", function () {
                KTApp.unblock(self.$refs.searchForm);
              }).on("draw.dt", function () {
                $(".actionsStatus").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    // isActive: true = Active, false = Inactive
                    if (data.isActive) {
                      new StatusActionsTrue({ data: { data: data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
                    } else {
                      new StatusActionsFalse({ data: { data: data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
                    }
                  }
                });
                $(".actions").each(function (i, el) {
                  var $dt = table.DataTable();
                  var $tr = $(el).parents("tr").first();
                  var data = $dt.row($tr).data();
                  if (data) {
                    new StockCoverDaysActions({ data: { data: data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
                  }
                });
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    var now = new Date();
    var currentYear = now.getFullYear();
    var authTransport = function authTransport(params, success, failure) {
      params.beforeSend = function (request) {
        request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
      };
      var $request = $.ajax(params);
      $request.then(success);
      $request.fail(failure);
      return $request;
    };

    return {
      isLoading: false,
      isExporting: false,
      report: null,

      // ── Filter state (§4) ─────────────────────────────────────────
      filterPlantCodes: [],
      filterProductCodes: [],
      filterBrandIds: [],
      filterUnit: "ลิตร",
      filterMonth: now.getMonth() + 1, // default = เดือนปัจจุบัน
      filterYear: currentYear, // default = ปีปัจจุบัน

      monthLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      // ปี: ย้อนหลังรวมปัจจุบัน 5 ปี (§4)
      yearOptions: [currentYear, currentYear - 1, currentYear - 2, currentYear - 3, currentYear - 4],

      // Plant Select2 — reuse the scoped endpoint the Master/Report Analysis pages use (F6)
      plantOptions: {
        placeholder: "เลือกคลัง",
        allowClear: true,
        ajax: {
          url: "/Api/StockCoverDayTarget/Select2Plant",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            return JSON.stringify({
              plantId: [],
              search: params.term || "",
              page: params.page || 1
            });
          },
          processResults: function processResults(data, params) {
            var results = data.results || [];
            // CR-SCVD #45(D): prepend a client-side "ทั้งหมด" option on the first
            // page (backend NormalizeSelection treats "ทั้งหมด" as "all คลัง").
            var term = (params && params.term ? params.term : "").toLowerCase();
            var firstPage = !params || !params.page || params.page === 1;
            if (firstPage && (term === "" || "ทั้งหมด".indexOf(term) !== -1)) {
              results = [{ id: "ทั้งหมด", text: "ทั้งหมด" }].concat(results);
            }
            return { results: results, pagination: { more: data.more } };
          },
          transport: authTransport
        },
        language: { noResults: function noResults() {
            return "ไม่พบข้อมูล Plant";
          } }
      },

      // Product Select2 — reuse the same endpoint (สินค้าสำเร็จรูป น้ำเบียร์) as the Master/RA pages
      productOptions: {
        placeholder: "เลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          delay: 300,
          data: function data(params) {
            return {
              productGroupId: 14,
              productTypeId: 22,
              onlyStockCoverDays: true, // CR-StockCoverDays A3: เฉพาะ SKU ที่เปิดใช้งาน SCVD
              onlyHasScvdMaster: true, // CR-StockCoverDays C3: แสดงเฉพาะสินค้าที่มีข้อมูล Master (StockCoverDay_Target)
              search: params.term || "",
              page: params.page || 1
            };
          },
          processResults: function processResults(data, params) {
            var results = data.results || [];
            // CR-SCVD #45(D): prepend a client-side "ทั้งหมด" option on the first
            // page (backend NormalizeSelection treats "ทั้งหมด" as "all สินค้า").
            var term = (params && params.term ? params.term : "").toLowerCase();
            var firstPage = !params || !params.page || params.page === 1;
            if (firstPage && (term === "" || "ทั้งหมด".indexOf(term) !== -1)) {
              results = [{ id: "ทั้งหมด", text: "ทั้งหมด" }].concat(results);
            }
            return { results: results, pagination: { more: data.more } };
          },
          transport: authTransport
        },
        language: { noResults: function noResults() {
            return "ไม่พบข้อมูลสินค้า";
          } }
      },

      // Brand Select2 — reuse the shared /Api/ProductBrand/Select2ProductBrand endpoint
      brandOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          delay: 300,
          data: function data(params) {
            return {
              search: params.term || "",
              page: params.page || 1
            };
          },
          processResults: function processResults(data) {
            return { results: data.results, pagination: { more: data.more } };
          },
          transport: authTransport
        },
        language: { noResults: function noResults() {
            return "ไม่พบข้อมูลแบรนด์";
          } }
      }
    };
  },
  methods: {
    buildPayload: function buildPayload() {
      return {
        PlantCodes: this.filterPlantCodes || [],
        ProductCodes: this.filterProductCodes || [],
        BrandIds: this.filterBrandIds || [],
        Unit: this.filterUnit,
        Month: parseInt(this.filterMonth, 10),
        Year: parseInt(this.filterYear, 10)
      };
    },

    // §4 บังคับ 4: คลัง / เดือน / ปี / ชื่อสินค้า (เดือน+ปี มี default อยู่แล้ว)
    validateRequired: function validateRequired() {
      if (!this.filterPlantCodes || this.filterPlantCodes.length === 0) {
        Swal.fire("กรุณาเลือกตัวกรอง", "กรุณาเลือกคลังสินค้า", "warning");
        return false;
      }
      if (!this.filterProductCodes || this.filterProductCodes.length === 0) {
        Swal.fire("กรุณาเลือกตัวกรอง", "กรุณาเลือกชื่อสินค้า", "warning");
        return false;
      }
      return true;
    },

    loadReport: function loadReport() {
      var self = this;
      if (!self.validateRequired()) return;
      self.isLoading = true;
      self.report = null;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/Report/Search", self.buildPayload(), {
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        if (response.data && response.data.success && response.data.data) {
          var d = response.data.data;
          d.groups = d.groups || [];
          d.grandTotal = d.grandTotal || { stockRemaining: 0, avgSalesPerDay: 0 };
          self.report = d;
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data && response.data.message || "ไม่สามารถโหลดข้อมูลได้", "error");
        }
      }).catch(function (error) {
        var message = "เกิดข้อผิดพลาดในการโหลดข้อมูล";
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      }).then(function () {
        self.isLoading = false;
      });
    },

    resetFilter: function resetFilter() {
      var now = new Date();
      this.filterPlantCodes = [];
      this.filterProductCodes = [];
      this.filterBrandIds = [];
      this.filterUnit = "ลิตร";
      this.filterMonth = now.getMonth() + 1;
      this.filterYear = now.getFullYear();
      $("#rptPlantCodes").val(null).trigger("change");
      $("#rptProductCodes").val(null).trigger("change");
      $("#rptBrandIds").val(null).trigger("change");
      this.report = null;
    },

    exportExcel: function exportExcel() {
      var self = this;
      if (!self.validateRequired()) return;
      self.isExporting = true;
      KTApp.blockPage({ opacity: 0.05, message: "กำลังสร้างไฟล์ กรุณารอสักครู่..." });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/StockCoverDayTarget/Report/Export",
        responseType: "arraybuffer",
        data: self.buildPayload(),
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        if (response.status === 200) {
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          var filename = "StockCoverDays_Report.xlsx";
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var m = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
            if (m != null && m[1]) filename = decodeURIComponent(m[1].replace(/['"]/g, ""));
          }
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (response.status === 204) {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function () {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดาวน์โหลดไฟล์ได้", "error");
      }).then(function () {
        self.isExporting = false;
        KTApp.unblockPage();
      });
    },

    formatNum: function formatNum(v) {
      if (v === null || v === undefined || v === "") return "";
      return Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatScvd: function formatScvd(v) {
      if (v === null || v === undefined || v === "" || v === "-") return "-";
      return Number(v).toFixed(0);
    },
    // J — พื้นหลังคอลัมน์สถานะตามสีของระดับเกณฑ์ (ColorHex). ไม่มีสถานะ → ไม่ระบายสี.
    statusStyle: function statusStyle(r) {
      if (!r || !r.colorHex) return {};
      return { backgroundColor: r.colorHex };
    },
    // K — สีตัวอักษรคอลัมน์แนวทางแก้ไข ตามสีของระดับเกณฑ์ (ColorHex) เดียวกับ J · ไม่มีพื้นหลัง. ไม่มีสถานะ → สีปกติ.
    actionStyle: function actionStyle(r) {
      if (!r || !r.colorHex) return {};
      return { color: r.colorHex };
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_1__Shared_Select2__["a" /* default */]
  },
  data: function data() {
    var self = this;
    var currentYear = new Date().getFullYear();
    var authTransport = function authTransport(params, success, failure) {
      params.beforeSend = function (request) {
        request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
      };
      var $request = $.ajax(params);
      $request.then(success);
      $request.fail(failure);
      return $request;
    };

    return {
      isLoading: false,
      isExporting: false,
      report: null,

      // ── Filter state ──────────────────────────────────────────────
      filterPlantCodes: [],
      filterProductCodes: [],
      filterBrandIds: [], // #72: brand filter — wired เข้า Search (BrandIds) → BE กรองสินค้าตามแบรนด์ (เหมือน Dashboard)
      filterUnit: "ลิตร",
      filterVersion: "", // "" = ล่าสุด (per-SKU)
      filterYear: currentYear,

      // ปี: ย้อนหลัง 5 ปี (รวมปีปัจจุบัน) + ล่วงหน้า 1 ปี (§3)
      yearOptions: [currentYear + 1, currentYear, currentYear - 1, currentYear - 2, currentYear - 3, currentYear - 4],
      // Version dropdown — โหลดรายการ version จริงของ key (plant/product/year) จาก endpoint ReportAnalysis/Versions (issue #33)
      versionOptions: [],

      monthLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      measureRows: [{ key: "bgStock", label: "BG Stock", cls: "scd-row-bg" }, { key: "demand", label: "Demand", cls: "scd-row-demand" }, { key: "supply", label: "Supply", cls: "scd-row-supply" }, { key: "scvd", label: "SCVD", cls: "scd-row-scvd" }],

      // Plant Select2 — reuse the same scoped endpoint the Master pages use (F6)
      plantOptions: {
        placeholder: "เลือกคลังสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/StockCoverDayTarget/Select2Plant",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            return JSON.stringify({
              plantId: [],
              search: params.term || "",
              page: params.page || 1
            });
          },
          processResults: function processResults(data) {
            return { results: data.results, pagination: { more: data.more } };
          },
          transport: authTransport
        },
        language: { noResults: function noResults() {
            return "ไม่พบข้อมูล Plant";
          } }
      },

      // Product Select2 — reuse the same endpoint (สินค้าสำเร็จรูป น้ำเบียร์) as the Master pages
      productOptions: {
        placeholder: "เลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          delay: 300,
          data: function data(params) {
            return {
              productGroupId: 14,
              productTypeId: 22,
              onlyStockCoverDays: true, // CR-StockCoverDays A3: เฉพาะ SKU ที่เปิดใช้งาน SCVD
              onlyHasScvdMaster: true, // CR-StockCoverDays C3: แสดงเฉพาะสินค้าที่มีข้อมูล Master (StockCoverDay_Target)
              search: params.term || "",
              page: params.page || 1
            };
          },
          processResults: function processResults(data) {
            return { results: data.results, pagination: { more: data.more } };
          },
          transport: authTransport
        },
        language: { noResults: function noResults() {
            return "ไม่พบข้อมูลสินค้า";
          } }
      },

      // Brand Select2 — reuse ProductBrand endpoint (เหมือน Dashboard) · #40: layout control เท่านั้น ยังไม่ wire เข้า filter (Open Question)
      brandOptions: {
        placeholder: "เลือกแบรนด์สินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          delay: 300,
          data: function data(params) {
            return { search: params.term || "", page: params.page || 1 };
          },
          processResults: function processResults(data) {
            return { results: data.results, pagination: { more: data.more } };
          },
          transport: authTransport
        },
        language: { noResults: function noResults() {
            return "ไม่พบข้อมูลแบรนด์";
          } }
      }
    };
  },
  computed: {
    plantSummary: function plantSummary() {
      if (!this.report || !this.report.plants || this.report.plants.length === 0) return "ทั้งหมด";
      return this.report.plants.map(function (p) {
        return "[" + p.plantCode + "] " + p.plantName;
      }).join(", ");
    },
    productSummary: function productSummary() {
      if (!this.report || !this.report.products || this.report.products.length === 0) return "ทั้งหมด";
      return this.report.products.map(function (p) {
        return p.productName + " [" + p.productCode + "]";
      }).join(", ");
    },
    // แบรนด์สินค้า (display-only) — TODO: bind brand from BE (issue #37)
    brandSummary: function brandSummary() {
      if (!this.report || !this.report.brands || this.report.brands.length === 0) return "ทั้งหมด";
      return this.report.brands.map(function (b) {
        if (b === null || b === undefined) return "";
        return b.brandName || b.name || b.brand || String(b);
      }).filter(function (n) {
        return n !== "";
      }).join(", ");
    },
    // ชื่อตาราง ① (แถวหัวเดือน) — รวม Version ถ้ามี
    // #41: แสดงชื่อ + Version ในแถวหัวเหลือง เสมอ (ใช้ resolvedVersions เมื่อเลือก "ล่าสุด")
    targetTitle: function targetTitle() {
      var base = "ข้อมูลตามเป้าหมาย";
      var r = this.report;
      if (!r) return base;
      if (r.version) return base + "(Version" + r.version + ")";
      var rv = r.resolvedVersions || [];
      if (rv.length === 1) return base + "(Version" + rv[0] + ")";
      if (rv.length > 1) return base + "(Version" + rv.join(",") + ")";
      return base;
    },
    // Current Date — ใช้ค่าจาก BE ถ้ามี มิฉะนั้นคำนวณฝั่ง client (วว/ดด/ปปปป)
    currentDateDisplay: function currentDateDisplay() {
      if (this.report && this.report.currentDate) return this.report.currentDate;
      return this.formatCurrentDate(new Date());
    },
    // Day of week (ภาษาไทย) — ใช้ค่าจาก BE ถ้ามี มิฉะนั้นคำนวณฝั่ง client
    dayOfWeekDisplay: function dayOfWeekDisplay() {
      if (this.report && this.report.dayOfWeek) return this.report.dayOfWeek;
      return this.thaiDayName(new Date());
    },
    // Version ข้อมูล (header ผลลัพธ์) — สะท้อน version จริงของรายงานที่โหลดมา (issue #38)
    //  • เลือก version เฉพาะ (report.version มีค่า)                → "Version{N}"
    //  • เลือก "ล่าสุด" → ใช้ report.resolvedVersions จาก Search:
    //      - 1 ค่า  → "Version{v} (ล่าสุด)"
    //      - >1 ค่า → "Version{v1},{v2},… (ล่าสุด)"
    //      - ว่าง/ไม่มี → "ล่าสุด"
    versionLabel: function versionLabel() {
      if (!this.report) return "";
      if (this.report.version) {
        return "Version" + this.report.version;
      }
      var resolved = this.report.resolvedVersions;
      if (resolved && resolved.length === 1) {
        return "Version" + resolved[0] + " (ล่าสุด)";
      }
      if (resolved && resolved.length > 1) {
        return "Version" + resolved.join(",") + " (ล่าสุด)";
      }
      return "ล่าสุด";
    }
  },
  methods: {
    buildPayload: function buildPayload() {
      return {
        PlantCodes: this.filterPlantCodes || [],
        ProductCodes: this.filterProductCodes || [],
        // #72: แบรนด์สินค้า → BrandIds (int[]) — BE resolve เป็นรหัสสินค้าแล้วกรอง (เหมือน Dashboard)
        BrandIds: (this.filterBrandIds || []).map(Number),
        Unit: this.filterUnit,
        Version: this.filterVersion === "" ? null : parseInt(this.filterVersion, 10),
        Year: parseInt(this.filterYear, 10)
      };
    },

    // โหลดรายการ Version จริงของ key ที่เลือก (plant/product/year) — issue #33
    // mirror การเรียก Search: base path/pattern + { success, data } envelope เดียวกัน
    loadVersions: function loadVersions(override) {
      var self = this;
      override = override || {};
      var reqYear = override.year !== undefined ? override.year : parseInt(self.filterYear, 10);
      var reqPlants = override.plantCodes !== undefined ? override.plantCodes : self.filterPlantCodes || [];
      var reqProducts = override.productCodes !== undefined ? override.productCodes : self.filterProductCodes || [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/ReportAnalysis/Versions", {
        Year: reqYear,
        PlantCodes: reqPlants,
        ProductCodes: reqProducts
      }, { headers: { Authorization: "Bearer " + self.$root.user.access_token } }).then(function (response) {
        var versions = [];
        if (response.data && response.data.success && response.data.data) {
          versions = response.data.data.versions || [];
        }
        self.versionOptions = versions;
        // ถ้า version ที่เลือกอยู่ไม่มีในรายการใหม่ → รีเซ็ตเป็น "ล่าสุด"
        if (self.filterVersion !== "" && versions.indexOf(parseInt(self.filterVersion, 10)) === -1) {
          self.filterVersion = "";
        }
      }).catch(function (error) {
        // ไม่บล็อกหน้า — fallback เหลือแค่ตัวเลือก "ล่าสุด"
        console.error("โหลดรายการ Version ไม่สำเร็จ:", error);
        self.versionOptions = [];
        self.filterVersion = "";
      });
    },

    loadReport: function loadReport() {
      var self = this;
      self.isLoading = true;
      self.report = null;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/Api/StockCoverDayTarget/ReportAnalysis/Search", self.buildPayload(), {
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        if (response.data && response.data.success && response.data.data) {
          var d = response.data.data;
          // defensive defaults
          d.saleDaysByMonth = d.saleDaysByMonth || [];
          d.targetRows = d.targetRows || [];
          d.actualRows = d.actualRows || [];
          d.targetTotal = d.targetTotal || { blocked: true, months: [] };
          d.actualTotal = d.actualTotal || { blocked: true, months: [] };
          d.plants = d.plants || [];
          d.products = d.products || [];
          self.report = d;
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data && response.data.message || "ไม่สามารถโหลดข้อมูลได้", "error");
        }
      }).catch(function (error) {
        var message = "เกิดข้อผิดพลาดในการโหลดข้อมูล";
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message;
        }
        Swal.fire("เกิดข้อผิดพลาด", message, "error");
      }).then(function () {
        self.isLoading = false;
      });
    },

    resetFilter: function resetFilter() {
      var self = this;
      var currentYear = new Date().getFullYear();
      this.filterPlantCodes = [];
      this.filterProductCodes = [];
      this.filterBrandIds = [];
      this.filterUnit = "ลิตร";
      this.filterVersion = "";
      this.filterYear = currentYear;
      $("#raPlantCodes").val(null).trigger("change");
      $("#raProductCodes").val(null).trigger("change");
      $("#raBrandIds").val(null).trigger("change");
      this.report = null;
      // #33: บังคับโหลด Version list กลับเป็นค่าเต็มของสถานะที่ล้างแล้ว
      // (ไม่พึ่ง watcher — กัน timing ของ <select2> ที่ value-watcher sync กลับ widget ถูก comment ไว้)
      this.$nextTick(function () {
        self.loadVersions({ plantCodes: [], productCodes: [], year: currentYear });
      });
    },

    exportExcel: function exportExcel() {
      var self = this;
      self.isExporting = true;
      KTApp.blockPage({ opacity: 0.05, message: "กำลังสร้างไฟล์ กรุณารอสักครู่..." });
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "post",
        url: "/Api/StockCoverDayTarget/ReportAnalysis/Export",
        responseType: "arraybuffer",
        data: self.buildPayload(),
        headers: { Authorization: "Bearer " + self.$root.user.access_token }
      }).then(function (response) {
        if (response.status === 200) {
          var contentType = response.headers["content-type"];
          var disposition = response.headers["content-disposition"];
          var filename = "StockCoverDays_ReportAnalysis.xlsx";
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var m = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
            if (m != null && m[1]) filename = decodeURIComponent(m[1].replace(/['"]/g, ""));
          }
          var blob = new Blob([response.data], { type: contentType });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (response.status === 204) {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบข้อมูลตามเงื่อนไขที่เลือก", "warning");
        }
      }).catch(function () {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดาวน์โหลดไฟล์ได้", "error");
      }).then(function () {
        self.isExporting = false;
        KTApp.unblockPage();
      });
    },

    // months array ของแถวรวม (ป้องกัน null)
    totalMonths: function totalMonths(total) {
      return total && total.months ? total.months : [];
    },
    // คอลัมน์ Total (เฉพาะ Demand/Supply) = ผลรวม 12 เดือน เฉพาะเดือนที่มีข้อมูล (hasData)
    measureTotal: function measureTotal(total, key) {
      var months = this.totalMonths(total);
      var sum = 0;
      for (var i = 0; i < months.length; i++) {
        var cell = months[i];
        if (cell && cell.hasData) {
          var v = cell[key];
          if (v !== null && v !== undefined && v !== "") sum += Number(v);
        }
      }
      return sum;
    },
    // BG/Demand/Supply = จำนวนเต็ม (#,##0) ตาม spec §2 · เฉพาะ SCVD = 2 ตำแหน่ง (formatScvd)
    formatNum: function formatNum(v) {
      if (v === null || v === undefined || v === "") return "";
      return Number(v).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },
    formatScvd: function formatScvd(v) {
      if (v === null || v === undefined) return "-";
      return Number(v).toFixed(2);
    },
    // วันที่ปัจจุบัน รูปแบบ วว/ดด/ปปปป
    formatCurrentDate: function formatCurrentDate(d) {
      var dd = ("0" + d.getDate()).slice(-2);
      var mm = ("0" + (d.getMonth() + 1)).slice(-2);
      return dd + "/" + mm + "/" + d.getFullYear();
    },
    // ชื่อวันในสัปดาห์ (ภาษาไทย)
    thaiDayName: function thaiDayName(d) {
      var days = ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"];
      return days[d.getDay()];
    }
  },
  // โหลดรายการ Version ครั้งแรกตามค่า filter เริ่มต้น (issue #33)
  mounted: function mounted() {
    this.loadVersions();
  },
  // โหลดรายการ Version ใหม่เมื่อ plant/product/year ที่เลือกเปลี่ยน (issue #33)
  watch: {
    filterPlantCodes: function filterPlantCodes() {
      this.loadVersions();
    },
    filterProductCodes: function filterProductCodes() {
      this.loadVersions();
    },
    filterYear: function filterYear() {
      this.loadVersions();
    }
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__riophae_vue_treeselect_dist_vue_treeselect_css__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// Issue #21 (§13): vue-treeselect for non-BARCODE product picker (Select2 broken when add 2+ rows in v-for)



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    select2: __WEBPACK_IMPORTED_MODULE_3__Shared_Select2__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a,
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default.a
  },
  data: function data() {
    var self = this;
    return {
      // ── Mode flags ─────────────────────────
      isEdit: false,
      isView: false,
      isEditable: true,
      jobNumber: "",
      jobStatus: "",
      isNoValidate: false,

      // ── Form fields ────────────────────────
      documentDate: null, // moment instance
      originLocationId: null,
      originLocationType: null,
      originData: null,
      // §2.3: destination = 4 levels (Plant/Agent/Shop/SubShop)
      destinationLocationId: null,
      destinationLocationType: null,
      destinationData: null,

      // ── Items (BARCODE-based) ──────────────
      // Each entry: { barcodeNo, materialCode, materialName, barcodeId? }
      scannedBarcodes: [],

      // ── §2.6: Items WITHOUT BARCODE ────────
      // Each entry: { _uid, jobItemId?, materialCode, materialName, quantity, remark }
      itemsWithoutBarcode: [],
      _nbUidCounter: 0,

      // ── Issue #18 (§13): job-level Remark (Job.Remark) ──
      remark: "",

      // ── Issue #19.3 (§13): per-group remark for BARCODE items (keyed by materialCode) ──
      barcodeGroupRemarks: {},

      // ── Issue #21 (§13): non-BARCODE products → vue-treeselect options (seeded by current selections so loadJob can display labels) ──
      nonBarcodeProductTreeOptions: [],

      // ── Scan input state ───────────────────
      scanForm: { barcode: "", isLoading: false },
      scanMessage: "",

      // ── Modal state ────────────────────────
      modalGroup: null,
      // Issue #9.2 (§13): client-side pagination state for BARCODE list modal
      modalPageSize: 100,
      modalCurrentPage: 1,

      // ── Attachments (Budget pattern: native input + /Api/File/FileUpload) ──
      uploadFiles: [],
      uploadingFile: false,

      // ── Select2 options (Origin — §2.2: 5 types Agent/SubDealer/Plant/Employee/Vendor) ─────────
      originLocationIdOptions: {
        placeholder: "กรุณาเลือกสถานที่ต้นทาง (ตัวแทน/ตัวแทนย่อย/คลัง/คลังพนักงาน/Supplier)",
        allowClear: true,
        ajax: {
          url: "/Api/WriteOffStockJobs/Select2Origin",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            return JSON.stringify({
              search: params.term || "",
              page: params.page || 1
            });
          },
          processResults: function processResults(data) {
            return {
              results: data.results,
              pagination: { more: data.more }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลสถานที่ต้นทาง";
          }
        }
      },

      // ── Select2 options (§2.6 non-BARCODE product picker) ──
      // Filter Master_Product where HasBarcode = false (reuse global /Api/Product/Select2Product + OnlyNoBarcode flag)
      nonBarcodeProductOptions: {
        placeholder: "เลือกสินค้า/ทรัพย์สิน (ไม่มี BARCODE)",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          delay: 300,
          data: function data(params) {
            return {
              search: params.term || "",
              page: params.page || 1,
              onlyNoBarcode: true
            };
          },
          processResults: function processResults(data) {
            return {
              results: data.results,
              pagination: { more: data.more }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบสินค้า/ทรัพย์สินที่ไม่มี BARCODE";
          }
        }
      },

      // ── Select2 options (Destination — §2.3 union L1+L2+L3+L4) ──
      destinationLocationIdOptions: {
        placeholder: "กรุณาเลือกสถานที่ปลายทาง (Destination)",
        allowClear: true,
        ajax: {
          url: "/Api/WriteOffStockJobs/Select2Destination",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function data(params) {
            return JSON.stringify({
              search: params.term || "",
              page: params.page || 1
            });
          },
          processResults: function processResults(data) {
            return {
              results: data.results,
              pagination: { more: data.more }
            };
          },
          transport: function transport(params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        },
        language: {
          noResults: function noResults() {
            return "ไม่พบข้อมูลสถานที่ปลายทาง";
          }
        }
      }
    };
  },

  computed: {
    /**
     * Group scannedBarcodes by materialCode for table display.
     * Returns: [{ materialCode, materialName, barcodes: [{ barcodeNo, barcodeId? }] }]
     */
    groupedItems: function groupedItems() {
      var map = {};
      var order = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.scannedBarcodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var bc = _step.value;

          if (!bc || !bc.materialCode) continue;
          if (!map[bc.materialCode]) {
            map[bc.materialCode] = {
              materialCode: bc.materialCode,
              materialName: bc.materialName || "",
              barcodes: []
            };
            order.push(bc.materialCode);
          }
          map[bc.materialCode].barcodes.push({
            barcodeNo: bc.barcodeNo,
            barcodeNoOld: bc.barcodeNoOld,
            barcodeId: bc.barcodeId || null,
            barcodeYear: bc.barcodeYear,
            unitPrice: bc.unitPrice,
            departmentMaterialCode: bc.departmentMaterialCode, // sourced from BARCODE if available (TBD: backend can add later)
            scanDate: bc.scanDate,
            scannedByName: bc.scannedByName
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return order.map(function (c) {
        return map[c];
      });
    },
    canSave: function canSave() {
      // Save: Create mode OR Edit mode while WAITING/IN_PROGRESS
      if (this.isView) return false;
      if (!this.isEdit) return true; // Create
      return this.isEditable && this.jobStatus === "JOB_STATUS_PENDING" // Issue #12 (§13): ระหว่างดำเนินการ
      ;
    },

    // ── Issue #9.2 (§13): modal pagination computed props ──
    modalTotalEntries: function modalTotalEntries() {
      return this.modalGroup && this.modalGroup.barcodes ? this.modalGroup.barcodes.length : 0;
    },
    modalTotalPages: function modalTotalPages() {
      var size = this.modalPageSize > 0 ? this.modalPageSize : 100;
      return Math.ceil(this.modalTotalEntries / size);
    },
    modalShowingFrom: function modalShowingFrom() {
      if (this.modalTotalEntries === 0) return 0;
      return (this.modalCurrentPage - 1) * this.modalPageSize + 1;
    },
    modalShowingTo: function modalShowingTo() {
      return Math.min(this.modalCurrentPage * this.modalPageSize, this.modalTotalEntries);
    },
    modalPagedBarcodes: function modalPagedBarcodes() {
      if (!this.modalGroup || !this.modalGroup.barcodes) return [];
      var start = (this.modalCurrentPage - 1) * this.modalPageSize;
      var end = start + this.modalPageSize;
      return this.modalGroup.barcodes.slice(start, end);
    }
  },
  methods: {
    // ── Helpers ────────────────────────────
    formatNumber: function formatNumber(n) {
      if (n == null) return "0";
      try {
        return Number(n).toLocaleString();
      } catch (e) {
        return String(n);
      }
    },

    // Issue #9 (§13): wrap moment in component method — Vue 2 template ไม่เห็น global moment
    //   (no ProvidePlugin / no Vue.prototype.$moment). Bug ก่อนหน้า: template เรียก moment(...) ตรงๆ →
    //   ReferenceError ใน render function → v-for แถวขาดทั้งหมด → modal เห็น "ไม่มีข้อมูล"
    formatScanDate: function formatScanDate(date) {
      if (!date) return "-";
      try {
        return moment(date).format("DD/MM/YYYY HH:mm:ss");
      } catch (e) {
        return String(date);
      }
    },


    // ── Destination handler — capture LocationType ─────
    onDestinationLocationChange: function onDestinationLocationChange(id, val, data) {
      this.destinationData = data && data.length ? data[0] : null;
      this.destinationLocationType = this.destinationData && this.destinationData.data ? this.destinationData.data.locationType || this.destinationData.data.LocationType : null;
    },


    // ── Origin/Destination handlers ────────
    onOriginLocationChange: function onOriginLocationChange(id, val, data) {
      // Reset scanned items when origin changes (different validation context)
      this.originData = data && data.length ? data[0] : null;
      this.originLocationType = this.originData && this.originData.data ? this.originData.data.type : null;

      // If user changes origin while items exist (non-view), warn + reset
      if (this.isEditable && this.scannedBarcodes.length > 0 && this.isEdit === false) {
        // Only confirm in Create mode; in Edit we keep but flag
        var self = this;
        Swal.fire({
          title: "เปลี่ยนสถานที่ต้นทาง",
          html: "การเปลี่ยนสถานที่ต้นทางจะล้างรายการ BARCODE ที่สแกนแล้วทั้งหมด ดำเนินการต่อหรือไม่?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก"
        }).then(function (result) {
          if (result.value) {
            self.scannedBarcodes = [];
          } else {
            // revert (best-effort)
          }
        });
      }
    },


    // ── BARCODE scan ───────────────────────
    // Issue #46 (2026-06-04): multi-barcode scan — split by newline, process each in sequence
    submitScan: function submitScan() {
      var self = this;
      var raw = (self.scanForm.barcode || "").trim();
      if (!raw) return;

      // Pre-validation: origin must be selected first
      if (!self.originLocationId) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกสถานที่ต้นทางก่อนสแกน BARCODE", "warning");
        return;
      }

      // Split multi-line input → array of barcode strings (dedupe within input)
      // 2026-06-24: รองรับ separators = comma, newline, space, tab
      //   /[,\s]+/ = comma หรือ whitespace (\s ครอบคลุม space, tab, \r, \n, \f, \v)
      var barcodes = raw.split(/[,\s]+/).map(function (s) {
        return (s || "").trim();
      }).filter(function (s) {
        return s.length > 0;
      });
      barcodes = barcodes.filter(function (b, i) {
        return barcodes.indexOf(b) === i;
      });
      if (barcodes.length === 0) return;

      self.scanForm.isLoading = true;
      KTApp.blockPage({ opacity: 0.05, message: "กำลังสแกน BARCODE..." });

      var results = { ok: 0, dup: [], invalid: [] };
      var promise = Promise.resolve();
      barcodes.forEach(function (code) {
        promise = promise.then(function () {
          // Duplicate check (client-side) — Issue #1: ผู้ใช้สแกน BarcodeNoOld
          var dup = self.scannedBarcodes.find(function (b) {
            return (b.barcodeNoOld || b.barcodeNo) === code;
          });
          if (dup) {
            results.dup.push(code);
            return null;
          }

          // §2.5.2: Both Create + Edit mode call backend Scan endpoint
          //   • Edit  → send jobId (backend loads job, checks IsNoValidate + origin)
          //   • Create → send originLocationType + originLocationId (no jobId — no IsNoValidate)
          var payload = { barcode: code };
          if (self.isEdit && self.$route.params.id) {
            payload.jobId = parseInt(self.$route.params.id);
          } else {
            payload.originLocationType = self.originLocationType;
            payload.originLocationId = self.originLocationId;
          }

          return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/WriteOffStockJobs/Scan", payload).then(function (response) {
            var data = response.data;
            if (data && data.valid && data.barcode) {
              // Issue #2/#9.3/#11 (§13): เก็บฟิลด์ที่ list modal ต้องแสดง
              self.scannedBarcodes.push({
                barcodeNo: data.barcode.barcodeNo,
                barcodeNoOld: data.barcode.barcodeNoOld,
                barcodeId: data.barcode.barcodeId,
                materialCode: data.barcode.materialCode,
                materialName: data.barcode.materialName,
                barcodeYear: data.barcode.barcodeYear,
                unitPrice: data.barcode.unitPrice,
                departmentMaterialCode: data.barcode.departmentMaterialCode,
                scanDate: data.barcode.scanDate,
                scannedByName: data.barcode.scannedByName,
                isNew: true
              });
              results.ok++;
            } else {
              var msg = data && data.errorMessage || "BARCODE ไม่ถูกต้อง";
              results.invalid.push(code + " (" + msg + ")");
            }
          }).catch(function (error) {
            var msg = error && error.response && error.response.data ? error.response.data.message || error.response.data.errorMessage || "สแกนไม่สำเร็จ" : "สแกนไม่สำเร็จ";
            results.invalid.push(code + " (" + msg + ")");
          });
        });
      });

      promise.then(function () {
        self.scanForm.isLoading = false;
        KTApp.unblockPage();
        self.scanForm.barcode = "";

        // Build summary message
        var parts = [];
        if (results.ok > 0) parts.push("สแกนสำเร็จ " + results.ok + " รายการ");
        if (results.dup.length > 0) parts.push("ซ้ำ " + results.dup.length + " รายการ: " + results.dup.join(", "));
        if (results.invalid.length > 0) parts.push("ไม่สำเร็จ " + results.invalid.length + " รายการ:<br>" + results.invalid.join("<br>"));
        self.scanMessage = parts.join(" | ");

        // Show error popup if any invalid
        if (results.invalid.length > 0 || results.dup.length > 0) {
          var swalType = results.ok > 0 ? "warning" : "error";
          Swal.fire({
            title: results.ok > 0 ? "บันทึกบางส่วน" : "ไม่สำเร็จ",
            html: parts.join("<br>"),
            type: swalType
          });
        }

        self.$nextTick(function () {
          if (self.$refs.scanInput) self.$refs.scanInput.focus();
        });
      });
    },


    // ── Item / barcode removal ─────────────
    onRemoveGroup: function onRemoveGroup(group) {
      var self = this;
      Swal.fire({
        title: "ยืนยันการลบรายการ",
        html: "ต้องการลบ BARCODE ทั้งหมด (" + group.barcodes.length + " รายการ) ของสินค้า <strong>" + group.materialName + "</strong> ใช่หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบ",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          self.scannedBarcodes = self.scannedBarcodes.filter(function (b) {
            return b.materialCode !== group.materialCode;
          });
        }
      });
    },
    onRemoveBarcode: function onRemoveBarcode(group, bcIndex) {
      var self = this;
      var bc = group.barcodes[bcIndex];
      if (!bc) return;
      // Issue #1/#2 (§13): use barcodeId (stable) for filtering — barcodeNoOld และ barcodeNo อาจซ้ำกัน edge case
      var bid = bc.barcodeId;
      var display = bc.barcodeNoOld || bc.barcodeNo || "-";
      // Issue #45 (§13, 2026-06-04): confirm dialog ก่อนลบ — pattern เดียวกับ onRemoveGroup/onRemoveNonBarcodeRow
      Swal.fire({
        title: "ยืนยันการลบรายการ",
        html: "ต้องการลบ BARCODE <strong>" + display + "</strong> ใช่หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบ",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          self.scannedBarcodes = self.scannedBarcodes.filter(function (x) {
            return bid ? x.barcodeId !== bid : (x.barcodeNoOld || x.barcodeNo) !== (bc.barcodeNoOld || bc.barcodeNo);
          });
        }
      });
    },


    // ── Modal actions ──────────────────────
    onShowBarcodeList: function onShowBarcodeList(group) {
      this.modalGroup = group;
      // Issue #9.2 (§13): reset to first page each time modal opens
      this.modalCurrentPage = 1;
      $(this.$refs.barcodeListModal).modal("show");
    },

    // ── Issue #9.2 (§13): modal pagination methods ──
    modalPrev: function modalPrev() {
      if (this.modalCurrentPage > 1) this.modalCurrentPage -= 1;
    },
    modalNext: function modalNext() {
      if (this.modalCurrentPage < this.modalTotalPages) this.modalCurrentPage += 1;
    },
    modalGoToPage: function modalGoToPage(n) {
      if (n >= 1 && n <= this.modalTotalPages) this.modalCurrentPage = n;
    },
    onModalPageSizeChange: function onModalPageSizeChange() {
      // Reset to page 1 when page size changes (avoid out-of-range pages)
      this.modalCurrentPage = 1;
    },


    // ── §2.6: Non-BARCODE row management ───
    onAddNonBarcodeRow: function onAddNonBarcodeRow() {
      this._nbUidCounter += 1;
      this.itemsWithoutBarcode.push({
        _uid: this._nbUidCounter,
        jobItemId: null,
        materialCode: null,
        materialName: null,
        quantity: 1,
        remark: ""
      });
    },
    onRemoveNonBarcodeRow: function onRemoveNonBarcodeRow(index) {
      var self = this;
      var row = self.itemsWithoutBarcode[index];
      if (!row) return;
      var label = row.materialName ? row.materialName + " [" + (row.materialCode || "") + "]" : "รายการที่ " + (index + 1);
      Swal.fire({
        title: "ยืนยันการลบรายการ",
        html: "ต้องการลบ <strong>" + label + "</strong> ใช่หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบ",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          self.itemsWithoutBarcode.splice(index, 1);
        }
      });
    },
    onNonBarcodeProductChange: function onNonBarcodeProductChange(row, id, val, data) {
      // Capture materialName so we can display + send to backend without an extra lookup
      if (data && data.length && data[0]) {
        row.materialCode = data[0].id || id;
        row.materialName = data[0].text || "";
      } else {
        row.materialCode = null;
        row.materialName = null;
      }
    },


    // ── Issue #21 (§13): vue-treeselect handlers (replace Select2 in v-for) ──
    onNonBarcodeTreeSelect: function onNonBarcodeTreeSelect(row, node) {
      // node = { id, label } when user picks an option
      if (node && node.id != null) {
        row.materialCode = node.id;
        // strip "[code]" suffix if present (label format "name [code]")
        var lbl = String(node.label || "");
        var m = lbl.match(/^(.*?)\s*\[[^\]]+\]\s*$/);
        row.materialName = m ? m[1] : lbl;
        // ensure option exists for re-render after refresh
        var has = (this.nonBarcodeProductTreeOptions || []).some(function (o) {
          return o && o.id === node.id;
        });
        if (!has) {
          this.nonBarcodeProductTreeOptions = (this.nonBarcodeProductTreeOptions || []).concat([{ id: node.id, label: node.label || String(node.id) }]);
        }
      }
    },
    onNonBarcodeTreeInput: function onNonBarcodeTreeInput(row, val) {
      // v-model emits input with new value (or null when cleared)
      if (val == null) {
        row.materialCode = null;
        row.materialName = null;
      } else {
        row.materialCode = val;
      }
    },

    // Issue #24 (§13 follow-up): pre-fetch สินค้าไม่มี BARCODE ทั้งหมดครั้งเดียวตอน mount
    //   pattern เดียวกับ ManageBorrowProducts.vue:736 — `?all=true` ดึงทั้งหมด ไม่ paginate
    //   ผลลัพธ์: dropdown แสดงครบทันที, ไม่มี label "(unknown)", ไม่มี loading lag
    loadAllNonBarcodeProducts: function loadAllNonBarcodeProducts() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/Product/Select2Product", {
        params: { all: true, onlyNoBarcode: true }
      }).then(function (response) {
        if (response && response.data && Array.isArray(response.data.results)) {
          // merge with existing (loadJob อาจ seed ก่อน mount-time fetch เสร็จ — เก็บ label ทั้ง 2 source)
          var existing = self.nonBarcodeProductTreeOptions || [];
          var byId = existing.reduce(function (acc, o) {
            if (o && o.id) acc[o.id] = true;return acc;
          }, {});
          response.data.results.forEach(function (r) {
            if (r && r.id != null && !byId[r.id]) {
              existing.push({ id: r.id, label: r.text });
              byId[r.id] = true;
            }
          });
          self.nonBarcodeProductTreeOptions = existing.slice();
        }
      }).catch(function () {
        // silent fail — user ยัง type search ใน treeselect เพื่อหาเองได้ในกรณีฉุกเฉิน
      });
    },


    // ── Issue #19.3 (§13): per-group remark setter (Vue.set so reactivity tracks new keys) ──
    onBarcodeGroupRemarkInput: function onBarcodeGroupRemarkInput(materialCode, value) {
      if (!materialCode) return;
      this.$set(this.barcodeGroupRemarks, materialCode, value);
    },


    // ── Attachment upload (Budget pattern: native input + axios → /Api/File/FileUpload → GCS) ──
    //   • ต่างจาก Plupload เดิม: ไฟล์ขึ้น GCS ทันทีตอนเลือก (ไม่รอ Save)
    //   • response.fileInfoId เก็บไว้ใน uploadFiles → ส่งใน payload Save
    handleFileSelect: function handleFileSelect(event) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var self, files, allowedTypes, i, file, base64Url, formData, response, msg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                files = event.target.files;

                if (!(!files || files.length === 0)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                allowedTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "image/jpeg", "image/jpg", "image/png"];
                i = 0;

              case 6:
                if (!(i < files.length)) {
                  _context.next = 39;
                  break;
                }

                file = files[i];

                if (!(allowedTypes.indexOf(file.type) < 0)) {
                  _context.next = 11;
                  break;
                }

                Swal.fire("ไฟล์ไม่ถูกต้อง", "กรุณาเลือกไฟล์ PDF, Word, Excel หรือรูปภาพเท่านั้น", "warning");
                return _context.abrupt("continue", 36);

              case 11:
                if (!(file.size > 10 * 1024 * 1024)) {
                  _context.next = 14;
                  break;
                }

                Swal.fire("ไฟล์ใหญ่เกินไป", "ไฟล์ " + file.name + " มีขนาดเกิน 10 MB", "warning");
                return _context.abrupt("continue", 36);

              case 14:
                _context.next = 16;
                return new Promise(function (resolve) {
                  var reader = new FileReader();
                  reader.onload = function (e) {
                    resolve(e.target.result);
                  };
                  reader.readAsDataURL(file);
                });

              case 16:
                base64Url = _context.sent;
                _context.prev = 17;

                self.uploadingFile = true;
                formData = new FormData();

                formData.append("File", file);
                formData.append("IsMaster", false);
                formData.append("FolderName", "Jobs"); // ใช้ folder Jobs (เหมือน AddAttachmentCommand เดิมของระบบ Job)

                _context.next = 25;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/File/FileUpload", formData, {
                  headers: { "Content-Type": "multipart/form-data" }
                });

              case 25:
                response = _context.sent;


                if (response && response.data) {
                  self.uploadFiles.push({
                    jobAttachmentId: null, // ไฟล์ใหม่
                    attachedId: null, // จะถูก set ตอน Save
                    fileInfoId: response.data.fileInfoId, // GCS object name
                    gridFsId: response.data.gridFsId, // GCS bucket name
                    fileName: file.name,
                    fileSize: file.size,
                    contentType: file.type,
                    documentName: file.name,
                    url: base64Url, // immediate preview (base64)
                    fileUrl: null, // proxy URL หลัง reload เท่านั้น
                    downloadUrl: response.data.fileUrl, // direct GCS URL (เก็บไว้ใน Attachment.DownloadUrl)
                    isNew: true,
                    sortOrder: self.uploadFiles.length + 1
                  });

                  Swal.fire({
                    type: "success",
                    title: "อัพโหลดสำเร็จ",
                    text: "อัพโหลดไฟล์ " + file.name + " เรียบร้อยแล้ว",
                    timer: 1500,
                    showConfirmButton: false
                  });
                }
                _context.next = 33;
                break;

              case 29:
                _context.prev = 29;
                _context.t0 = _context["catch"](17);
                msg = _context.t0 && _context.t0.response && _context.t0.response.data && _context.t0.response.data.Message ? _context.t0.response.data.Message : "ไม่สามารถอัพโหลดไฟล์ " + file.name + " ได้";

                Swal.fire("เกิดข้อผิดพลาด", msg, "error");

              case 33:
                _context.prev = 33;

                self.uploadingFile = false;
                return _context.finish(33);

              case 36:
                i++;
                _context.next = 6;
                break;

              case 39:

                // re-number กัน corner case + clear input เพื่อให้เลือกไฟล์เดิมซ้ำได้
                self.reassignSortOrder();
                event.target.value = "";

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[17, 29, 33, 36]]);
      }))();
    },
    onRemoveAttachment: function onRemoveAttachment(i) {
      var self = this;
      Swal.fire({
        title: "ยืนยันการลบ",
        text: "คุณต้องการลบไฟล์นี้หรือไม่?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "ลบ",
        cancelButtonText: "ยกเลิก"
      }).then(function (result) {
        if (result.value) {
          self.uploadFiles.splice(i, 1);
          self.reassignSortOrder();
          Swal.fire("ลบสำเร็จ!", "ลบไฟล์เรียบร้อยแล้ว", "success");
        }
      });
    },
    openPreview: function openPreview(fileURL) {
      if (fileURL) window.open(fileURL, "_blank");
    },

    // ── Attachment helpers (Budget-style — thumbnail + view + download + drag) ──
    isImageFile: function isImageFile(fileName) {
      if (!fileName) return false;
      var ext = fileName.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png", "gif", "bmp", "webp"].indexOf(ext) >= 0;
    },
    getFileIcon: function getFileIcon(fileName) {
      if (!fileName) return "fas fa-file";
      var ext = fileName.split(".").pop().toLowerCase();
      switch (ext) {
        case "pdf":
          return "fas fa-file-pdf text-danger";
        case "doc":
        case "docx":
          return "fas fa-file-word text-primary";
        case "xls":
        case "xlsx":
          return "fas fa-file-excel text-success";
        case "ppt":
        case "pptx":
          return "fas fa-file-powerpoint text-warning";
        case "zip":
        case "rar":
        case "7z":
          return "fas fa-file-archive text-muted";
        default:
          return "fas fa-file text-secondary";
      }
    },

    // เปิด preview ใน new tab — ใช้ proxy /Api/File/FileDownloadByte เสมอถ้ามี fileInfoId
    //   (private GCS bucket → direct URL จะ AccessDenied — Issue #4 §13)
    openFileInNewTab: function openFileInNewTab(file) {
      if (!file) return;
      if (file.fileInfoId) {
        var fileName = file.fileName || "download";
        var ext = fileName.split(".").pop().toLowerCase();
        var url = "/Api/File/FileDownloadByte?FileInfoId=" + encodeURIComponent(file.fileInfoId) + "&ContentType=" + encodeURIComponent(ext) + "&FileName=" + encodeURIComponent(fileName);
        window.open(url, "_blank");
      } else if (file.url) {
        // ไฟล์ใหม่ที่เพิ่ง upload — base64 data URI (preview ทันที)
        window.open(file.url, "_blank");
      } else if (file.fileUrl) {
        window.open(file.fileUrl, "_blank");
      }
    },

    // ดาวน์โหลด — ใช้ <a download> trigger (รองรับทั้งไฟล์เก่า/ใหม่)
    downloadFile: function downloadFile(file) {
      if (!file) return;
      var fileName = file.fileName || "download";
      var href;
      if (file.fileInfoId) {
        var ext = fileName.split(".").pop().toLowerCase();
        href = "/Api/File/FileDownloadByte?FileInfoId=" + encodeURIComponent(file.fileInfoId) + "&ContentType=" + encodeURIComponent(ext) + "&FileName=" + encodeURIComponent(fileName);
      } else if (file.url) {
        href = file.url;
      } else if (file.fileUrl) {
        href = file.fileUrl;
      } else {
        return;
      }
      var a = document.createElement("a");
      a.href = href;
      a.download = fileName;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    // หลัง drag — re-assign sortOrder ตาม index ใน array
    onFileDragEnd: function onFileDragEnd() {
      this.reassignSortOrder();
    },
    reassignSortOrder: function reassignSortOrder() {
      this.uploadFiles.forEach(function (file, index) {
        file.sortOrder = index + 1;
      });
    },


    // ── Validation (client-side) ───────────
    validateForm: function validateForm() {
      if (!this.documentDate) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่เอกสาร", "warning");
        return false;
      }
      if (!this.originLocationId) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกสถานที่ต้นทาง", "warning");
        return false;
      }
      if (!this.destinationLocationId || !this.destinationLocationType) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกสถานที่ปลายทาง", "warning");
        return false;
      }
      // §2.6: Issue #29 (2026-05-31) — เลิก required รายการสินค้าทั้ง Save + Close (Option A)
      // อนุญาตให้บันทึก/ปิดใบงานเปล่าได้ (ไม่มีทั้ง BARCODE และไม่มี non-BARCODE)
      // ทุก row ใน itemsWithoutBarcode ต้องมีทั้ง materialCode + quantity > 0 (กัน user เพิ่มแถวว่าง)
      var hasInvalidRow = (this.itemsWithoutBarcode || []).some(function (r) {
        return !r.materialCode || !(Number(r.quantity) > 0);
      });
      if (hasInvalidRow) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกสินค้าและกรอกจำนวน (>0) ในตารางสินค้าไม่มี BARCODE ให้ครบทุกแถว", "warning");
        return false;
      }
      // Issue #3 (§13): บังคับแนบไฟล์อย่างน้อย 1 ตั้งแต่ Save (ไม่รอ Close)
      if (!this.uploadFiles || this.uploadFiles.length === 0) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาแนบไฟล์เอกสารอย่างน้อย 1 ไฟล์", "warning");
        return false;
      }
      return true;
    },


    // ── Save (Create / Update) ─────────────
    onSaveClick: function onSaveClick() {
      var self = this;
      if (!self.validateForm()) return;

      // Issue #19.3 (§13): build per-group remark payload from current groupedItems (only groups with non-empty remark)
      var barcodeItemRemarks = self.groupedItems.map(function (g) {
        return {
          materialCode: g.materialCode,
          remark: self.barcodeGroupRemarks[g.materialCode] || ""
        };
      }).filter(function (r) {
        return r.materialCode;
      });

      var payload = {
        documentDate: self.documentDate.format("YYYY-MM-DD"),
        originLocationType: self.originLocationType,
        originLocationId: String(self.originLocationId),
        // §2.3: ส่ง type + id แทน DestinationShopId เดิม
        destinationLocationType: self.destinationLocationType,
        destinationLocationId: String(self.destinationLocationId),
        // Issue #18 (§13): หมายเหตุระดับใบงาน
        remark: self.remark || "",
        // Issue #1 (§13): ส่ง BarcodeNoOld (ที่ scan) ให้ backend resolve กลับมาเป็น row
        barcodes: self.scannedBarcodes.map(function (b) {
          return b.barcodeNoOld || b.barcodeNo;
        }),
        // Issue #19.3 (§13): หมายเหตุต่อกลุ่ม BARCODE (per MaterialCode)
        barcodeItemRemarks: barcodeItemRemarks,
        // §2.6: รายการสินค้าไม่มี BARCODE (กรอง row ว่างทิ้ง — handler จะ validate ซ้ำอีกที)
        itemsWithoutBarcode: (self.itemsWithoutBarcode || []).filter(function (r) {
          return r && r.materialCode && Number(r.quantity) > 0;
        }).map(function (r) {
          return {
            materialCode: r.materialCode,
            quantity: Number(r.quantity) || 0,
            remark: r.remark || ""
          };
        }),
        // Match existing Job pipeline: ส่ง {jobAttachmentId, reference, fileName, documentName} ต่อไฟล์
        //  • jobAttachmentId มีค่า → ไฟล์เก่า (Edit) — keep + (optionally) update DocumentName
        //  • jobAttachmentId ว่าง  → ไฟล์ใหม่ — handler ส่ง AddAttachmentCommand เพื่อ create Attachment row
        // ตัดไฟล์ที่ยัง preview ค้าง (ไม่มี reference) ออก กัน save ขยะ
        // Budget pattern: ไฟล์ใหม่มี fileInfoId (upload ขึ้น GCS แล้ว) / ไฟล์เก่ามี jobAttachmentId
        attachments: (self.uploadFiles || []).filter(function (f) {
          return f && (f.jobAttachmentId || f.fileInfoId);
        }).map(function (f, idx) {
          return {
            jobAttachmentId: f.jobAttachmentId || null,
            fileInfoId: f.fileInfoId || null,
            gridFsId: f.gridFsId || null,
            downloadUrl: f.downloadUrl || null,
            fileName: f.fileName || "",
            contentType: f.contentType || "",
            documentName: f.documentName || f.fileName || "",
            sortOrder: f.sortOrder && f.sortOrder > 0 ? f.sortOrder : idx + 1
          };
        })
      };

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      var router = self.$router;
      var req;
      if (self.isEdit && self.$route.params.id) {
        req = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/Api/WriteOffStockJobs/" + self.$route.params.id, payload);
      } else {
        req = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/Api/WriteOffStockJobs", payload);
      }
      req.then(function (response) {
        var data = response.data;
        if (data && data.status) {
          Swal.fire("สำเร็จ", data.message || "บันทึกข้อมูลสำเร็จ", "success").then(function () {
            router.push({ name: "JobSearch" });
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", data && data.message || "บันทึกไม่สำเร็จ", "error");
        }
      }).catch(function (error) {
        var msg = error && error.response && error.response.data ? error.response.data.message || "บันทึกไม่สำเร็จ" : "บันทึกไม่สำเร็จ";
        Swal.fire("เกิดข้อผิดพลาด", msg, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    },


    // ── Load existing job (Edit/View) ──────
    loadJob: function loadJob(jobId) {
      var self = this;
      KTApp.blockPage({ opacity: 0.05, message: "กำลังดึงข้อมูล กรุณารอสักครู่..." });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/Api/WriteOffStockJobs/" + jobId).then(function (response) {
        var data = response.data;
        if (!data) {
          Swal.fire("ไม่พบข้อมูล", "ไม่พบใบงานนี้", "error");
          return;
        }
        self.jobNumber = data.jobNumber || "";
        self.jobStatus = data.jobStatusCode || "";
        self.isNoValidate = !!data.isNoValidate;
        // Issue #18 (§13): หมายเหตุระดับใบงาน
        self.remark = data.remark || "";

        // Mode: View if status != PENDING (or explicit /View route), Edit otherwise
        // Issue #12 (§13): WriteOffStock active status = JOB_STATUS_PENDING (ระหว่างดำเนินการ)
        if (self.isView) {
          self.isEditable = false;
        } else {
          self.isEditable = self.jobStatus === "JOB_STATUS_PENDING";
        }

        // Document date
        if (data.documentDate) {
          self.documentDate = moment(data.documentDate);
          self.$nextTick(function () {
            if (self.$refs.documentDate) {
              $(self.$refs.documentDate).datepicker("update", self.documentDate.format("DD/MM/YYYY"));
            }
          });
        }

        // Origin (§2.2 — 2026-05-21 business correction: 5 types Agent/SubDealer/Plant/Employee/Vendor)
        //   set v-model immediately (eager) + Select2 display via setTimeout
        //   v-model ที่ตั้ง eager กัน scan validation fail (`if (!self.originLocationId)`)
        //   setTimeout 100ms ให้ jQuery Select2 พร้อมรับ setSelectedData (mount race fix)
        self.originLocationId = data.originLocationId;
        self.originLocationType = data.originLocationType;
        // Build display text รองรับ 5 types
        //   • Agent / Plant / SubDealer / Vendor → "[code] name" (backend ส่ง name มา prefix-less บางที — fallback id)
        //     (SubDealer = "[CUST_CODE] CUSTOMER_NAME (NAME2)" — backend pre-prefix แล้วใน originLocationName)
        //   • Employee → ใช้ originLocationName ตรงๆ ("คลังพนักงาน (First Last)")
        var origText;
        if (data.originLocationType === "Employee") {
          origText = data.originLocationName || data.originLocationId;
        } else if (data.originLocationName) {
          // ถ้า name มี "[" อยู่แล้ว (เช่น SubDealer) ก็ใช้ตามนั้น มิฉะนั้น prefix code
          origText = data.originLocationName.indexOf("[") === 0 ? data.originLocationName : "[" + data.originLocationId + "] " + data.originLocationName;
        } else {
          origText = data.originLocationId;
        }
        setTimeout(function () {
          if (self.$refs.originLocationId) {
            self.$refs.originLocationId.setSelectedData({
              id: data.originLocationId,
              text: origText,
              data: { type: data.originLocationType }
            });
          }
          // re-assert v-model in case Select2's change handler reset it via emit('input', null)
          self.originLocationId = data.originLocationId;
          self.originLocationType = data.originLocationType;
        }, 100);

        // Destination (§2.3 — 4 types) — same eager+setTimeout pattern
        if (data.destinationLocationId && data.destinationLocationType) {
          self.destinationLocationId = String(data.destinationLocationId);
          self.destinationLocationType = data.destinationLocationType;
          var destCode = data.destinationLocationCode || data.destinationLocationId;
          var destText = "[" + destCode + "] " + (data.destinationLocationName || "") + (data.destinationLocationName2 ? " (" + data.destinationLocationName2 + ")" : "");
          setTimeout(function () {
            if (self.$refs.destinationLocationId) {
              self.$refs.destinationLocationId.setSelectedData({
                id: String(data.destinationLocationId),
                text: destText,
                data: { locationType: data.destinationLocationType }
              });
            }
            self.destinationLocationId = String(data.destinationLocationId);
            self.destinationLocationType = data.destinationLocationType;
          }, 100);
        }

        // Items (BARCODE-by-BARCODE rows from backend)
        // Issue #2/#9.3/#11 (§13): map ทุกฟิลด์ที่ list modal ต้องแสดง
        self.scannedBarcodes = (data.items || []).map(function (it) {
          return {
            barcodeNo: it.barcodeNo,
            barcodeNoOld: it.barcodeNoOld,
            barcodeId: it.barcodeId,
            materialCode: it.materialCode,
            materialName: it.materialName,
            barcodeYear: it.barcodeYear,
            unitPrice: it.unitPrice,
            departmentMaterialCode: it.departmentMaterialCode, // Issue #11: รหัสทรัพย์สิน(เบียร์สด)
            scanDate: it.scanDate,
            scannedByName: it.scannedByName,
            isNew: false
          };
        });
        // Issue #19.3 (§13): restore per-group remark (same Remark per MaterialCode group)
        var groupRemarks = {};
        (data.items || []).forEach(function (it) {
          if (it && it.materialCode && it.remark && !groupRemarks[it.materialCode]) {
            groupRemarks[it.materialCode] = it.remark;
          }
        });
        self.barcodeGroupRemarks = groupRemarks;

        // §2.6: Items WITHOUT BARCODE — rebuild rows
        self.itemsWithoutBarcode = (data.itemsWithoutBarcode || []).map(function (it) {
          self._nbUidCounter += 1;
          return {
            _uid: self._nbUidCounter,
            jobItemId: it.jobItemId,
            materialCode: it.materialCode,
            materialName: it.materialName,
            quantity: it.quantity,
            remark: it.remark || ""
          };
        });
        // Issue #21 (§13): seed vue-treeselect options so the labels of preloaded materials render.
        //   vue-treeselect needs each value to exist as a node in :options/:default-options.
        //   Merge any preloaded selections into nonBarcodeProductTreeOptions (uniq by id).
        var existingIds = (self.nonBarcodeProductTreeOptions || []).reduce(function (acc, o) {
          if (o && o.id) acc[o.id] = true;
          return acc;
        }, {});
        var seeded = (self.nonBarcodeProductTreeOptions || []).slice();
        self.itemsWithoutBarcode.forEach(function (nb) {
          if (nb && nb.materialCode && !existingIds[nb.materialCode]) {
            seeded.push({
              id: nb.materialCode,
              label: nb.materialName ? nb.materialName + " [" + nb.materialCode + "]" : String(nb.materialCode)
            });
            existingIds[nb.materialCode] = true;
          }
        });
        self.nonBarcodeProductTreeOptions = seeded;

        // Attachments — Budget pattern: ไฟล์เก่ามี jobAttachmentId + fileInfoId (อยู่ใน GCS แล้ว)
        //   url ใช้ proxy endpoint /Api/File/FileDownloadByte (auth-aware) สำหรับ image preview ใน Edit/View
        self.uploadFiles = (data.attachments || []).slice().sort(function (a, b) {
          var sa = a.sortOrder || 0;
          var sb = b.sortOrder || 0;
          if (sa === 0 && sb === 0) return 0;
          if (sa === 0) return 1;
          if (sb === 0) return -1;
          return sa - sb;
        }).map(function (a, idx) {
          // image preview URL — ใช้ proxy endpoint (ไม่ใช่ direct GCS URL — bucket private)
          var ext = (a.fileName || "").split(".").pop().toLowerCase();
          var previewUrl = null;
          if (a.fileInfoId) {
            previewUrl = "/Api/File/FileDownloadByte?FileInfoId=" + encodeURIComponent(a.fileInfoId) + "&ContentType=" + encodeURIComponent(ext) + "&FileName=" + encodeURIComponent(a.fileName || "");
          }
          return {
            jobAttachmentId: a.jobAttachmentId || null,
            attachedId: a.attachedId,
            fileInfoId: a.fileInfoId || null,
            gridFsId: null, // ไฟล์เก่า — บันทึก bucket ใน DB แล้ว ไม่ต้องส่งกลับ
            documentName: a.documentName || a.fileName || "",
            fileName: a.fileName || "",
            contentType: a.contentType || "",
            fileSize: 0,
            url: previewUrl, // image preview ใน Edit/View
            fileUrl: previewUrl, // legacy (compat กับ existing code)
            downloadUrl: null, // direct GCS URL ไม่ใช้ (private bucket)
            isNew: false,
            sortOrder: a.sortOrder && a.sortOrder > 0 ? a.sortOrder : idx + 1
          };
        });
      }).catch(function (error) {
        var msg = error && error.response && error.response.data ? error.response.data.message || "ไม่สามารถโหลดข้อมูลได้" : "ไม่สามารถโหลดข้อมูลได้";
        Swal.fire("เกิดข้อผิดพลาด", msg, "error");
      }).then(function () {
        KTApp.unblockPage();
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var self, path, arrows;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = _this2;

              // Mode detection from route path

              path = self.$route && self.$route.path || "";

              if (path.indexOf("/Jobs/WriteOffStock/View/") >= 0) {
                self.isView = true;
                self.isEdit = true; // View loads existing job data
                self.isEditable = false;
              } else if (path.indexOf("/Jobs/WriteOffStock/Edit/") >= 0) {
                self.isEdit = true;
                self.isView = false;
              } else {
                self.isEdit = false;
                self.isView = false;
                self.isEditable = true;
              }

              // ── Datepicker init ─────────────────────

              if (KTUtil.isRTL()) {
                arrows = {
                  leftArrow: '<i class="la la-angle-right"></i>',
                  rightArrow: '<i class="la la-angle-left"></i>'
                };
              } else {
                arrows = {
                  leftArrow: '<i class="la la-angle-left"></i>',
                  rightArrow: '<i class="la la-angle-right"></i>'
                };
              }
              $(self.$refs.documentDate).datepicker({
                autoclose: true,
                clearBtn: true,
                format: "dd/mm/yyyy",
                rtl: KTUtil.isRTL(),
                orientation: "bottom left",
                todayBtn: "linked",
                todayHighlight: true,
                templates: arrows
              });
              if (!self.isEdit) {
                self.documentDate = moment();
                $(self.$refs.documentDate).datepicker("update", self.documentDate.format("DD/MM/YYYY"));
              }
              $(self.$refs.documentDate).on("changeDate", function (e) {
                self.documentDate = e.dates && e.dates.length ? moment(e.date) : null;
              });

              // ── Issue #24 (§13 follow-up): pre-fetch สินค้าไม่มี BARCODE ทั้งหมดครั้งเดียวตอน mount ──
              self.loadAllNonBarcodeProducts();

              // ── Load existing job for Edit/View ─────
              if (self.isEdit && self.$route.params.id) {
                self.loadJob(self.$route.params.id);
              }

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  watch: {
    // Issue #9.2 (§13): clamp current page if total pages shrinks (e.g., after delete)
    modalTotalPages: function modalTotalPages(val) {
      if (val > 0 && this.modalCurrentPage > val) {
        this.modalCurrentPage = val;
      } else if (val === 0) {
        this.modalCurrentPage = 1;
      }
    }
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Collapsible",
  data: function data() {
    return {
      open: this.isOpen,
      height: this.isOpen ? "auto" : "0px",
      overflow: this.open ? "visible" : "hidden",
      closeOnNextTick: false,
      transitioning: false
    };
  },

  props: {
    openLabel: {
      type: String,
      default: "Close me"
    },
    closedLabel: {
      type: String,
      default: "Open me"
    },
    transitionDuration: {
      type: String,
      default: "400ms"
    },
    transitionTimingFunction: {
      type: String,
      default: "ease"
    },
    transitionDelay: {
      type: String,
      default: "0s"
    },
    isOpen: {
      default: true,
      type: Boolean
    },
    onCollapse: {
      default: function _default() {},
      type: Function
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.onCollapse(!this.isOpen);
      this.open = !this.open;
      if (this.open) this.overflow = "visible";else this.overflow = "hidden";
    },
    handleEnd: function handleEnd() {
      if (this.height !== "0px") {
        this.height = "auto";
      }
      if (this.open) this.overflow = "visible";else this.overflow = "hidden";
      this.transitioning = false;
    }
  },
  watch: {
    open: function open(newVal, oldVal) {
      this.transitioning = true;
      this.height = this.$refs.inner.scrollHeight + "px";

      if (oldVal === true) {
        this.closeOnNextTick = true;
      }
    },
    isOpen: function isOpen(newVal) {
      this.open = newVal;
    }
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      window.setTimeout(function () {
        if (_this.closeOnNextTick) {
          _this.height = "0px";
          _this.closeOnNextTick = false;
        }
      });
    });
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var exports = {};

exports.alert = function (techNote) {
    if (techNote == 1) {
        return Swal.fire("เกิดข้อผิดพลาด", "การแสดงผลข้อมูลผิดพลาด", "error");
    } else if (techNote == 2) {
        return Swal.fire("เกิดข้อผิดพลาด", "การกำหนดข้อมูลให้ตารางไม่ถูกต้อง", "error");
    } else if (techNote == 3) {
        return Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถเริ่มต้นข้อมูลได้", "error");
    } else if (techNote == 4) {
        return Swal.fire("เกิดข้อผิดพลาด", "ข้อมูลบางคอลัมน์ผิดพลาดและไม่แสดงให้เห็น", "error");
    } else if (techNote == 5) {
        return Swal.fire("เกิดข้อผิดพลาด", "ไม่พบจำนวนข้อมูลรวม", "error");
    } else if (techNote == 6) {
        return Swal.fire("เกิดข้อผิดพลาด", "ข้อมูลบางคอลัมน์ไม่ถูกต้อง", "error");
    } else if (techNote == 7) {
        return Swal.fire("เกิดข้อผิดพลาด", "การเชื่อมต่อเซิร์ฟเวอร์ผิดพลาด", "error");
    }
};

/* harmony default export */ __webpack_exports__["a"] = (exports);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    refObj: [String, Number, Object],
    cssStyle: String,
    cssClass: {
      type: String,
      default: "form-control"
      //  form-control-sm
    },
    id: {
      type: String,
      required: true
    },
    name: String,
    value: String
  },
  mounted: function mounted() {
    var self = this;
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>'
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>'
      };
    }
    $(this.$refs.input).datepicker({
      rtl: KTUtil.isRTL(),
      todayHighlight: true,
      orientation: "bottom left",
      templates: arrows
    });
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedObject: null
    };
  },
  props: {
    refObj: [String, Number, Object],
    cssStyle: String,
    cssClass: {
      type: String,
      default: "form-control form-control-sm"
    },
    id: {
      type: [String, Array]
      // required: true
    },
    name: String,
    multiple: {
      type: Boolean,
      default: false
    },
    value: [String, Number, Array, Boolean],
    select2Options: {
      type: Object,
      required: true
    }
  },
  methods: {
    clearData: function clearData() {
      $(this.$refs.select).html("");
      this.$emit("input", this.value);
    },
    setSelectedData: function setSelectedData(data) {
      // create the option and append to Select2
      this.selectedObject = data;

      if (data) {
        var arrayOfData = [];

        if (Array.isArray(data)) {
          data = data.slice().sort(function (a, b) {
            return a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1;
          });
          arrayOfData = data;
        } else {
          arrayOfData.push(data);
        }

        for (var i = 0; i < arrayOfData.length; i++) {
          var optData = arrayOfData[i];
          var option = new Option(optData.text, optData.id, true, true);
          if ($("option[value=" + optData.id + "]", this.$refs.select).length == 0) {
            $(this.$refs.select).append(option);
          }
        }

        var selected = $.map(arrayOfData, function (optData, idx) {
          return optData.id;
        });

        // begin manage selectedObject
        var arrayOfObject = [];
        if (Array.isArray(this.selectedObject)) {
          arrayOfObject = this.selectedObject;
        } else {
          arrayOfObject.push(this.selectedObject);
        }
        this.selectedObject = null;
        // end manage selectedObject

        $(this.$refs.select).val(selected).trigger("change");

        // manually trigger the `select2:select` event
        // $(this.$refs.select)
        //   .trigger({
        //     type: "select2:select",
        //     params: {
        //       data: Array.isArray(data) ? arrayOfData : data
        //     }
        //   })
        //   .trigger("change");

        var data = $(this.$refs.select).select2("data");
        for (var _i = 0; _i < data.length; _i++) {
          var d = data[_i];
          // if (d.id == this.selectedObject.id) {
          //   $.extend(d, this.selectedObject);
          // }
          for (var j = 0; j < arrayOfObject.length; j++) {
            var obj = arrayOfObject[j];
            if (d.id == obj.id) {
              $.extend(d, obj);
              break;
            }
          }
        }
      }
    }
  },
  mounted: function mounted() {
    var self = this;
    $(this.$refs.select)
    // init select2
    .select2(this.select2Options).val(this.value).trigger("change")
    // emit event on change.
    .on("change", function () {
      if (self.$props.multiple === true) {
        var selected = $.map($("option:selected", self.$refs.select), function (opt, idx) {
          return $(opt).val();
        });
        self.$emit("input", selected);
      } else {
        self.$emit("input", this.value);
      }
    });

    self.$emit("select2mounted", this.$refs.select);
  },
  watch: {
    value: function value(_value) {
      // update value
      if (this.selectedObject) {
        var arrayOfObject = [];

        if (Array.isArray(this.selectedObject)) {
          arrayOfObject = this.selectedObject;
        } else {
          arrayOfObject.push(this.selectedObject);
        }

        var data = $(this.$refs.select).select2("data");
        for (var i = 0; i < data.length; i++) {
          var d = data[i];
          // if (d.id == this.selectedObject.id) {
          //   $.extend(d, this.selectedObject);
          // }
          for (var j = 0; j < arrayOfObject.length; j++) {
            var obj = arrayOfObject[j];
            if (d.id == obj.id) {
              $.extend(d, obj);
              break;
            }
          }
        }

        this.selectedObject = null;
      } else {
        // $(this.$refs.select)
        //   .val(value)
        //   .trigger("change");

        this.$emit("selectChange", this.id, this.value, $(this.$refs.select).select2("data"), this.refObj);
      }
    }
  },
  destroyed: function destroyed() {
    $(this.$refs.select).off().select2("destroy");
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1984)));

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1986)));

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1987)));

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1992)));

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bindProps = __webpack_require__(91);

var _simulateArrowDown = __webpack_require__(631);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var props = {
  bounds: {
    type: Object
  },
  defaultPlace: {
    type: String,
    default: ''
  },
  componentRestrictions: {
    type: Object,
    default: null
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  placeholder: {
    required: false,
    type: String
  },
  className: {
    required: false,
    type: String
  },
  label: {
    required: false,
    type: String,
    default: null
  },
  selectFirstOnEnter: {
    require: false,
    type: Boolean,
    default: false
  }
};

exports.default = {
  mounted: function mounted() {
    var _this = this;

    var input = this.$refs.input;

    // Allow default place to be set
    input.value = this.defaultPlace;
    this.$watch('defaultPlace', function () {
      input.value = _this.defaultPlace;
    });

    this.$gmapApiPromiseLazy().then(function () {
      var options = (0, _bindProps.getPropsValues)(_this, props);
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      _this.autoCompleter = new google.maps.places.Autocomplete(_this.$refs.input, options);

      var placeholder = props.placeholder,
          place = props.place,
          defaultPlace = props.defaultPlace,
          className = props.className,
          label = props.label,
          selectFirstOnEnter = props.selectFirstOnEnter,
          rest = _objectWithoutProperties(props, ['placeholder', 'place', 'defaultPlace', 'className', 'label', 'selectFirstOnEnter']); // eslint-disable-line


      (0, _bindProps.bindProps)(_this, _this.autoCompleter, rest);

      _this.autoCompleter.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.autoCompleter.getPlace());
      });
    });
  },
  created: function created() {
    console.warn('The PlaceInput class is deprecated! Please consider using the Autocomplete input instead'); // eslint-disable-line no-console
  },

  props: props
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(49);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(36);
var toAbsoluteIndex = __webpack_require__(76);
var toLength = __webpack_require__(32);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(69);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(37);
var toObject = __webpack_require__(36);
var IObject = __webpack_require__(86);
var toLength = __webpack_require__(32);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(37);
var isObject = __webpack_require__(29);
var invoke = __webpack_require__(456);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(34).f;
var create = __webpack_require__(70);
var redefineAll = __webpack_require__(74);
var ctx = __webpack_require__(51);
var anInstance = __webpack_require__(68);
var forOf = __webpack_require__(69);
var $iterDefine = __webpack_require__(118);
var step = __webpack_require__(459);
var setSpecies = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(33);
var fastKey = __webpack_require__(66).fastKey;
var validate = __webpack_require__(78);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(81);
var from = __webpack_require__(448);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(74);
var getWeak = __webpack_require__(66).getWeak;
var anObject = __webpack_require__(26);
var isObject = __webpack_require__(29);
var anInstance = __webpack_require__(68);
var forOf = __webpack_require__(69);
var createArrayMethod = __webpack_require__(55);
var $has = __webpack_require__(43);
var validate = __webpack_require__(78);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(95);
var isObject = __webpack_require__(29);
var toLength = __webpack_require__(32);
var ctx = __webpack_require__(51);
var IS_CONCAT_SPREADABLE = __webpack_require__(31)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(33) && !__webpack_require__(28)(function () {
  return Object.defineProperty(__webpack_require__(111)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 456 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(29);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(26);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(120);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 461 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 462 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(33);
var getKeys = __webpack_require__(72);
var gOPS = __webpack_require__(99);
var pIE = __webpack_require__(87);
var toObject = __webpack_require__(36);
var IObject = __webpack_require__(86);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(28)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(34);
var anObject = __webpack_require__(26);
var getKeys = __webpack_require__(72);

module.exports = __webpack_require__(33) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(46);
var gOPN = __webpack_require__(71).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(43);
var toIObject = __webpack_require__(46);
var arrayIndexOf = __webpack_require__(92)(false);
var IE_PROTO = __webpack_require__(125)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(33);
var getKeys = __webpack_require__(72);
var toIObject = __webpack_require__(46);
var isEnum = __webpack_require__(87).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(71);
var gOPS = __webpack_require__(99);
var anObject = __webpack_require__(26);
var Reflect = __webpack_require__(27).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(27).parseFloat;
var $trim = __webpack_require__(84).trim;

module.exports = 1 / $parseFloat(__webpack_require__(128) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(27).parseInt;
var $trim = __webpack_require__(84).trim;
var ws = __webpack_require__(128);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(26);
var isObject = __webpack_require__(29);
var newPromiseCapability = __webpack_require__(122);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 473 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(32);
var repeat = __webpack_require__(127);
var defined = __webpack_require__(56);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(53);
var toLength = __webpack_require__(32);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(31);


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(451);
var validate = __webpack_require__(78);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(93)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(123);
__webpack_require__(8)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(33) && /./g.flags != 'g') __webpack_require__(34).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(85)
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(451);
var validate = __webpack_require__(78);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(93)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(27);
var each = __webpack_require__(55)(0);
var redefine = __webpack_require__(40);
var meta = __webpack_require__(66);
var assign = __webpack_require__(463);
var weak = __webpack_require__(453);
var isObject = __webpack_require__(29);
var validate = __webpack_require__(78);
var NATIVE_WEAK_MAP = __webpack_require__(78);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(93)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(483);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1135);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 484 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80), __webpack_require__(633)(module)))

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(484),
    isSymbol = __webpack_require__(1143);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arDz = moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arDz;

})));


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arKw = moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arKw;

})));


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var arLy = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arLy;

})));


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arMa = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arMa;

})));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return arSa;

})));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;

})));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ar;

})));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return az;

})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return be;

})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bg;

})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bm = moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;

})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bn;

})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bo;

})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bs;

})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');

    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return cv;

})));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

})));


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return dv;

})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

})));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enSG = moment.defineLocale('en-SG', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enSG;

})));


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eo;

})));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

})));


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eu;

})));


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return fa;

})));


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minuttur',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaður',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

})));


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

})));


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



    var months = [
        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
    ];

    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];

    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];

    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];

    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné aig] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d mí',
            y: 'bliain',
            yy: '%d bliain'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ga;

})));


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

})));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

})));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka voran', 'ek vor'],
            'hh': [number + ' voranim', number + ' voram'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;

})));


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return gu;

})));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

})));


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return hi;

})));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var hyAm = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hyAm;

})));


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return id;

})));


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

})));


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var itCh = moment.defineLocale('it-ch', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return itCh;

})));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return jv;

})));


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

})));


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return kk;

})));


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

})));


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return kn;

})));


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    },
    months = [
        'کانونی دووەم',
        'شوبات',
        'ئازار',
        'نیسان',
        'ئایار',
        'حوزەیران',
        'تەمموز',
        'ئاب',
        'ئەیلوول',
        'تشرینی یەكەم',
        'تشرینی دووەم',
        'كانونی یەکەم'
    ];


    var ku = moment.defineLocale('ku', {
        months : months,
        monthsShort : months,
        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar : {
            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
            nextDay : '[به‌یانی كاتژمێر] LT',
            nextWeek : 'dddd [كاتژمێر] LT',
            lastDay : '[دوێنێ كاتژمێر] LT',
            lastWeek : 'dddd [كاتژمێر] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'له‌ %s',
            past : '%s',
            s : 'چه‌ند چركه‌یه‌ك',
            ss : 'چركه‌ %d',
            m : 'یه‌ك خوله‌ك',
            mm : '%d خوله‌ك',
            h : 'یه‌ك كاتژمێر',
            hh : '%d كاتژمێر',
            d : 'یه‌ك ڕۆژ',
            dd : '%d ڕۆژ',
            M : 'یه‌ك مانگ',
            MM : '%d مانگ',
            y : 'یه‌ك ساڵ',
            yy : '%d ساڵ'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ku;

})));


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кечээ саат] LT',
            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ky;

})));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

})));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

})));


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

})));


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

})));


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return me;

})));


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

})));


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return mk;

})));


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

})));


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;

})));


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return mr;

})));


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var msMy = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return msMy;

})));


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ms;

})));


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mt = moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;

})));


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return my;

})));


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

})));


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ne;

})));


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

})));


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return paIn;

})));


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ro;

})));


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    var sd = moment.defineLocale('sd', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;

})));


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

})));


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

})));


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

})));


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sl;

})));


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

})));


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return srCyrl;

})));


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sr;

})));


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

})));


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sw;

})));


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ta;

})));


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return te;

})));


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tet = moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;

})));


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;

})));


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tlPh = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;

})));


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate,
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

})));


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tr;

})));


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

})));


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzmLatn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzmLatn;

})));


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzm;

})));


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;

})));


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (m === true) {
            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uk;

})));


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    var ur = moment.defineLocale('ur', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;

})));


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uzLatn = moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uzLatn;

})));


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

})));


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var xPseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;

})));


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var yo = moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;

})));


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(7)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhTw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhTw;

})));


/***/ }),
/* 614 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 615 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * v-lazy-image v1.3.2
 * (c) 2019 Alex Jover Morales <alexjovermorales@gmail.com>
 * @license MIT
 */

(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.VLazyImage = {})));
}(this, (function (exports) { 'use strict';

var VLazyImageComponent = {
  props: {
    src: {
      type: String,
      required: true
    },
    srcPlaceholder: {
      type: String,
      default: ""
    },
    srcset: {
      type: String
    },
    intersectionOptions: {
      type: Object,
      default: function () { return ({}); }
    },
    usePicture: {
      type: Boolean,
      default: false
    }
  },
  inheritAttrs: false,
  data: function () { return ({ observer: null, intersected: false, loaded: false }); },
  computed: {
    srcImage: function srcImage() {
      return this.intersected ? this.src : this.srcPlaceholder;
    },
    srcsetImage: function srcsetImage() {
      return this.intersected && this.srcset ? this.srcset : false;
    }
  },
  methods: {
    load: function load() {
      if (this.$el.getAttribute("src") !== this.srcPlaceholder) {
        this.loaded = true;
        this.$emit("load");
      }
    }
  },
  render: function render(h) {
    var img = h("img", {
      attrs: {
        src: this.srcImage,
        srcset: this.srcsetImage
      },
      domProps: this.$attrs,
      class: {
        "v-lazy-image": true,
        "v-lazy-image-loaded": this.loaded
      },
      on: { load: this.load }
    });
    if (this.usePicture) {
      return h("picture", { on: { load: this.load } }, this.intersected ? [ this.$slots.default, img ] : [] );
    } else {
      return img;
    }
  },
  mounted: function mounted() {
    var this$1 = this;

    if ("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver(function (entries) {
        var image = entries[0];
        if (image.isIntersecting) {
          this$1.intersected = true;
          this$1.observer.disconnect();
          this$1.$emit("intersect");
        }
      }, this.intersectionOptions);
      this.observer.observe(this.$el);
    } else {
      console.error(
        "v-lazy-image: this browser doesn't support IntersectionObserver. Please use this polyfill to make it work https://github.com/w3c/IntersectionObserver/tree/master/polyfill."
      );
    }
  },
  destroyed: function destroyed() {
    this.observer.disconnect();
  }
};

var VLazyImagePlugin = {
  install: function (Vue, opts) {
    Vue.component("VLazyImage", VLazyImageComponent);
  }
};

exports['default'] = VLazyImageComponent;
exports.VLazyImagePlugin = VLazyImagePlugin;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentList_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a4ef065_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentList_vue__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1910)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a4ef065_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a4ef065_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemRow_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c3f5f6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemRow_vue__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1854)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79c3f5f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c3f5f6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79c3f5f6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentItemRow_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3608f566_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentItemRow_vue__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1791)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3608f566"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentItemRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3608f566_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentItemRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3608f566_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentItemRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproverItemRow_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_250677f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverItemRow_vue__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1770)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-250677f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproverItemRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_250677f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverItemRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_250677f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverItemRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BRTItemRow_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95785ed4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BRTItemRow_vue__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1873)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95785ed4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BRTItemRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95785ed4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BRTItemRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95785ed4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BRTItemRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemRow_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68880a56_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemRow_vue__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1963)
  __webpack_require__(1839)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68880a56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68880a56_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68880a56_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderItemRow_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_804026b0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderItemRow_vue__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1860)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-804026b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderItemRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_804026b0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderItemRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_804026b0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderItemRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageShop_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10756472_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageShop_vue__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1748)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10756472"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageShop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10756472_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageShop_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10756472_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageShop_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupplierList_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf686e0c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupplierList_vue__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1886)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf686e0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupplierList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf686e0c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupplierList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf686e0c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupplierList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentProfileCreateForm_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32acc412_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentProfileCreateForm_vue__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1788)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32acc412"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentProfileCreateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32acc412_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentProfileCreateForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32acc412_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentProfileCreateForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubAgentProfileCreateForm_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa6f5266_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubAgentProfileCreateForm_vue__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1880)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa6f5266"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubAgentProfileCreateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa6f5266_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubAgentProfileCreateForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa6f5266_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubAgentProfileCreateForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockAttachmentModal_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3ad584_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockAttachmentModal_vue__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1761)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d3ad584"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockAttachmentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3ad584_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockAttachmentModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3ad584_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockAttachmentModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @class MapElementMixin
 *
 * Extends components to include the following fields:
 *
 * @property $map        The Google map (valid only after the promise returns)
 *
 *
 * */
exports.default = {
  inject: {
    '$mapPromise': { default: 'abcdef' }
  },

  provide: function provide() {
    var _this = this;

    // Note: although this mixin is not "providing" anything,
    // components' expect the `$map` property to be present on the component.
    // In order for that to happen, this mixin must intercept the $mapPromise
    // .then(() =>) first before its component does so.
    //
    // Since a provide() on a mixin is executed before a provide() on the
    // component, putting this code in provide() ensures that the $map is
    // already set by the time the
    // component's provide() is called.
    this.$mapPromise.then(function (map) {
      _this.$map = map;
    });

    return {};
  }
};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TwoWayBindingWrapper;
/**
 * When you have two-way bindings, but the actual bound value will not equal
 * the value you initially passed in, then to avoid an infinite loop you
 * need to increment a counter every time you pass in a value, decrement the
 * same counter every time the bound value changed, but only bubble up
 * the event when the counter is zero.
 *
Example:

Let's say DrawingRecognitionCanvas is a deep-learning backed canvas
that, when given the name of an object (e.g. 'dog'), draws a dog.
But whenever the drawing on it changes, it also sends back its interpretation
of the image by way of the @newObjectRecognized event.

<input
  type="text"
  placeholder="an object, e.g. Dog, Cat, Frog"
  v-model="identifiedObject" />
<DrawingRecognitionCanvas
  :object="identifiedObject"
  @newObjectRecognized="identifiedObject = $event"
  />

new TwoWayBindingWrapper((increment, decrement, shouldUpdate) => {
  this.$watch('identifiedObject', () => {
    // new object passed in
    increment()
  })
  this.$deepLearningBackend.on('drawingChanged', () => {
    recognizeObject(this.$deepLearningBackend)
      .then((object) => {
        decrement()
        if (shouldUpdate()) {
          this.$emit('newObjectRecognized', object.name)
        }
      })
  })
})
 */
function TwoWayBindingWrapper(fn) {
  var counter = 0;

  fn(function () {
    counter += 1;
  }, function () {
    counter = Math.max(0, counter - 1);
  }, function () {
    return counter === 0;
  });
}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by amirnissim and can be seen here
// http://stackoverflow.com/a/11703018/2694653
// This has been ported to Vanilla.js by GuillaumeLeclerc
exports.default = function (input) {
  var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

  function addEventListenerWrapper(type, listener) {
    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
    // and then trigger the original listener.
    if (type === 'keydown') {
      var origListener = listener;
      listener = function (event) {
        var suggestionSelected = document.getElementsByClassName('pac-item-selected').length > 0;
        if (event.which === 13 && !suggestionSelected) {
          var simulatedEvent = document.createEvent('Event');
          simulatedEvent.keyCode = 40;
          simulatedEvent.which = 40;
          origListener.apply(input, [simulatedEvent]);
        }
        origListener.apply(input, [event]);
      };
    }
    _addEventListener.apply(input, [type, listener]);
  }

  input.addEventListener = addEventListenerWrapper;
  input.attachEvent = addEventListenerWrapper;
};

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1153));
	else if(typeof define === 'function' && define.amd)
		define(["sortablejs"], factory);
	else if(typeof exports === 'object')
		exports["vuedraggable"] = factory(require("sortablejs"));
	else
		root["vuedraggable"] = factory(root["Sortable"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_a352__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("5ca1");
var context = __webpack_require__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("5ca1");
var $includes = __webpack_require__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("9c6c")('includes');


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
var toObject = __webpack_require__("4bf8");
var IObject = __webpack_require__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a352":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c649":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return insertNodeAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return console; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeNode; });
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a481");
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);


function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }

  return global.console;
}

var console = getConsole();

function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var regex = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(regex, function (_, c) {
    return c ? c.toUpperCase() : "";
  });
});

function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f559":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__("f751");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

// EXTERNAL MODULE: ./src/util/helper.js
var helper = __webpack_require__("c649");

// CONCATENATED MODULE: ./src/vuedraggable.js












function buildAttribute(object, propName, value) {
  if (value === undefined) {
    return object;
  }

  object = object || {};
  object[propName] = value;
  return object;
}

function computeVmIndex(vnodes, element) {
  return vnodes.map(function (elt) {
    return elt.elm;
  }).indexOf(element);
}

function _computeIndexes(slots, children, isTransition, footerOffset) {
  if (!slots) {
    return [];
  }

  var elmFromNodes = slots.map(function (elt) {
    return elt.elm;
  });
  var footerIndex = children.length - footerOffset;

  var rawIndexes = _toConsumableArray(children).map(function (elt, idx) {
    return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
  });

  return isTransition ? rawIndexes.filter(function (ind) {
    return ind !== -1;
  }) : rawIndexes;
}

function emit(evtName, evtData) {
  var _this = this;

  this.$nextTick(function () {
    return _this.$emit(evtName.toLowerCase(), evtData);
  });
}

function delegateAndEmit(evtName) {
  var _this2 = this;

  return function (evtData) {
    if (_this2.realList !== null) {
      _this2["onDrag" + evtName](evtData);
    }

    emit.call(_this2, evtName, evtData);
  };
}

function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}

function vuedraggable_isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }

  var _slots = _slicedToArray(slots, 1),
      componentOptions = _slots[0].componentOptions;

  if (!componentOptions) {
    return false;
  }

  return isTransitionName(componentOptions.tag);
}

function getSlot(slot, scopedSlot, key) {
  return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : undefined);
}

function computeChildrenAndOffsets(children, slot, scopedSlot) {
  var headerOffset = 0;
  var footerOffset = 0;
  var header = getSlot(slot, scopedSlot, "header");

  if (header) {
    headerOffset = header.length;
    children = children ? [].concat(_toConsumableArray(header), _toConsumableArray(children)) : _toConsumableArray(header);
  }

  var footer = getSlot(slot, scopedSlot, "footer");

  if (footer) {
    footerOffset = footer.length;
    children = children ? [].concat(_toConsumableArray(children), _toConsumableArray(footer)) : _toConsumableArray(footer);
  }

  return {
    children: children,
    headerOffset: headerOffset,
    footerOffset: footerOffset
  };
}

function getComponentAttributes($attrs, componentData) {
  var attributes = null;

  var update = function update(name, value) {
    attributes = buildAttribute(attributes, name, value);
  };

  var attrs = Object.keys($attrs).filter(function (key) {
    return key === "id" || key.startsWith("data-");
  }).reduce(function (res, key) {
    res[key] = $attrs[key];
    return res;
  }, {});
  update("attrs", attrs);

  if (!componentData) {
    return attributes;
  }

  var on = componentData.on,
      props = componentData.props,
      componentDataAttrs = componentData.attrs;
  update("on", on);
  update("props", props);
  Object.assign(attributes.attrs, componentDataAttrs);
  return attributes;
}

var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function (evt) {
  return "on" + evt;
});
var draggingElement = null;
var props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  value: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: function _default(original) {
      return original;
    }
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
var draggableComponent = {
  name: "draggable",
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false
    };
  },
  render: function render(h) {
    var slots = this.$slots.default;
    this.transitionMode = vuedraggable_isTransition(slots);

    var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots),
        children = _computeChildrenAndOf.children,
        headerOffset = _computeChildrenAndOf.headerOffset,
        footerOffset = _computeChildrenAndOf.footerOffset;

    this.headerOffset = headerOffset;
    this.footerOffset = footerOffset;
    var attributes = getComponentAttributes(this.$attrs, this.componentData);
    return h(this.getTag(), attributes, children);
  },
  created: function created() {
    if (this.list !== null && this.value !== null) {
      helper["b" /* console */].error("Value and list props are mutually exclusive! Please set one or another.");
    }

    if (this.element !== "div") {
      helper["b" /* console */].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
    }

    if (this.options !== undefined) {
      helper["b" /* console */].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();

    if (this.noneFunctionalComponentMode && this.transitionMode) {
      throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
    }

    var optionsAdded = {};
    eventsListened.forEach(function (elt) {
      optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
    });
    eventsToEmit.forEach(function (elt) {
      optionsAdded["on" + elt] = emit.bind(_this3, elt);
    });
    var attributes = Object.keys(this.$attrs).reduce(function (res, key) {
      res[Object(helper["a" /* camelize */])(key)] = _this3.$attrs[key];
      return res;
    }, {});
    var options = Object.assign({}, this.options, attributes, optionsAdded, {
      onMove: function onMove(evt, originalEvent) {
        return _this3.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
    this.computeIndexes();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._sortable !== undefined) this._sortable.destroy();
  },
  computed: {
    rootContainer: function rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList: function realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    $attrs: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList: function realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional: function getIsFunctional() {
      var fnOptions = this._vnode.fnOptions;
      return fnOptions && fnOptions.functional;
    },
    getTag: function getTag() {
      return this.tag || this.element;
    },
    updateOptions: function updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        var value = Object(helper["a" /* camelize */])(property);

        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes: function getChildrenNodes() {
      if (this.noneFunctionalComponentMode) {
        return this.$children[0].$slots.default;
      }

      var rawNodes = this.$slots.default;
      return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
    },
    computeIndexes: function computeIndexes() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
      });
    },
    getUnderlyingVm: function getUnderlyingVm(htmlElt) {
      var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);

      if (index === -1) {
        //Edge case during move callback: related element might be
        //an element different from collection
        return null;
      }

      var element = this.realList[index];
      return {
        index: index,
        element: element
      };
    },
    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
      var vue = _ref.__vue__;

      if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
        if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0]) return vue.$children[0];
        return vue;
      }

      return vue.$parent;
    },
    emitChanges: function emitChanges(evt) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$emit("change", evt);
      });
    },
    alterList: function alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }

      var newList = _toConsumableArray(this.value);

      onList(newList);
      this.$emit("input", newList);
    },
    spliceList: function spliceList() {
      var _arguments = arguments;

      var spliceList = function spliceList(list) {
        return list.splice.apply(list, _toConsumableArray(_arguments));
      };

      this.alterList(spliceList);
    },
    updatePosition: function updatePosition(oldIndex, newIndex) {
      var updatePosition = function updatePosition(list) {
        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
      };

      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
      var to = _ref2.to,
          related = _ref2.related;
      var component = this.getUnderlyingPotencialDraggableComponent(to);

      if (!component) {
        return {
          component: component
        };
      }

      var list = component.realList;
      var context = {
        list: list,
        component: component
      };

      if (to !== related && list && component.getUnderlyingVm) {
        var destination = component.getUnderlyingVm(related);

        if (destination) {
          return Object.assign(destination, context);
        }
      }

      return context;
    },
    getVmIndex: function getVmIndex(domIndex) {
      var indexes = this.visibleIndexes;
      var numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent: function getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData: function resetTransitionData(index) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }

      var nodes = this.getChildrenNodes();
      nodes[index].data = null;
      var transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = undefined;
    },
    onDragStart: function onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd: function onDragAdd(evt) {
      var element = evt.item._underlying_vm_;

      if (element === undefined) {
        return;
      }

      Object(helper["d" /* removeNode */])(evt.item);
      var newIndex = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex, 0, element);
      this.computeIndexes();
      var added = {
        element: element,
        newIndex: newIndex
      };
      this.emitChanges({
        added: added
      });
    },
    onDragRemove: function onDragRemove(evt) {
      Object(helper["c" /* insertNodeAt */])(this.rootContainer, evt.item, evt.oldIndex);

      if (evt.pullMode === "clone") {
        Object(helper["d" /* removeNode */])(evt.clone);
        return;
      }

      var oldIndex = this.context.index;
      this.spliceList(oldIndex, 1);
      var removed = {
        element: this.context.element,
        oldIndex: oldIndex
      };
      this.resetTransitionData(oldIndex);
      this.emitChanges({
        removed: removed
      });
    },
    onDragUpdate: function onDragUpdate(evt) {
      Object(helper["d" /* removeNode */])(evt.item);
      Object(helper["c" /* insertNodeAt */])(evt.from, evt.item, evt.oldIndex);
      var oldIndex = this.context.index;
      var newIndex = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex, newIndex);
      var moved = {
        element: this.context.element,
        oldIndex: oldIndex,
        newIndex: newIndex
      };
      this.emitChanges({
        moved: moved
      });
    },
    updateProperty: function updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }

      var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
        return el.style["display"] !== "none";
      });

      var currentDOMIndex = domChildren.indexOf(evt.related);
      var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove: function onDragMove(evt, originalEvent) {
      var onMove = this.move;

      if (!onMove || !this.realList) {
        return true;
      }

      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
      var draggedContext = this.context;
      var futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, {
        futureIndex: futureIndex
      });
      var sendEvt = Object.assign({}, evt, {
        relatedContext: relatedContext,
        draggedContext: draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd: function onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    }
  }
};

if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("draggable", draggableComponent);
}

/* harmony default export */ var vuedraggable = (draggableComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (vuedraggable);



/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vuedraggable.umd.js.map

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_plugin_load_script__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__security__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_jstree__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_jstree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_jstree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_uuid__ = __webpack_require__(1983);
var _this7 = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_plugin_load_script__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_uuid__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("v-jstree", __WEBPACK_IMPORTED_MODULE_6_vue_jstree___default.a);

var globalData = {
    isAuthenticated: false,
    user: "",
    profiles: [],
    mgr: __WEBPACK_IMPORTED_MODULE_3__security__["a" /* default */],
    siteConfig: SiteConfig
};

// ISS-36 (CR-BudgetReport · QA BUG-01) หน้าแรกของ user ที่มีแต่สิทธิ์ Budget Approval
// "/" ผูกกับ Dashboard ที่ต้องมี role DASHBOARD — role ของ budget ไม่มี จึงเคยเด้ง /Error/Unauthorized
// เงื่อนไขสิทธิ์ใช้ชุดเดียวกับเมนู Budget Approval ใน App.vue · คนที่มี DASHBOARD ยังเข้า Dashboard ตามเดิม
var BUDGET_LANDING_PATH = "/BudgetPlan/Job";
var BUDGET_MENU_ROLES = [["BUDGET_PLAN_USER", "COMPANY_PROFILE_TYPE_BUDGET"], ["BUDGET_PLAN_REVIEWER", "COMPANY_PROFILE_TYPE_BUDGET"], ["BUDGET_PLAN_MANAGER", "COMPANY_PROFILE_TYPE_BUDGET"]];

var globalMethods = {
    /**
     * ISS-36: หน้าแรกแทน "/" ของ user ที่มีแต่สิทธิ์ Budget Approval — ไม่ใช่ user กลุ่มนี้คืน null
     * เรียกจาก 2 ที่: router.beforeEach (เข้า "/" ระหว่างใช้งาน / หลัง login)
     * และ App.vue mounted (เปิด "/" ใหม่ทั้งหน้า — router นำทางครั้งแรกก่อน beforeEach ถูกผูก)
     * โหลด user + profiles เองถ้ายังไม่มี เพราะทั้ง 2 จุดอาจถูกเรียกก่อน authenticate เสร็จ
     */
    budgetLandingPath: function budgetLandingPath() {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var user;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (_this.user) {
                                _context.next = 7;
                                break;
                            }

                            _context.next = 3;
                            return _this.getUser();

                        case 3:
                            user = _context.sent;

                            if (!(!user || user.expires_at <= __WEBPACK_IMPORTED_MODULE_5_moment___default()().unix())) {
                                _context.next = 6;
                                break;
                            }

                            return _context.abrupt("return", null);

                        case 6:
                            _this.user = user; // interceptor ของ axios ใช้ค่านี้แนบ token ให้ loadProfiles

                        case 7:
                            _context.next = 9;
                            return _this.loadProfiles();

                        case 9:
                            if (!(_this.canShow(["DASHBOARD"]) || !_this.canShowExSuperAdmin(BUDGET_MENU_ROLES))) {
                                _context.next = 11;
                                break;
                            }

                            return _context.abrupt("return", null);

                        case 11:
                            return _context.abrupt("return", BUDGET_LANDING_PATH);

                        case 12:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    authenticate: function authenticate(returnPath) {
        var _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var user;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this2.$root.getUser();

                        case 2:
                            user = _context2.sent;

                            if (!(user && user.expires_at > __WEBPACK_IMPORTED_MODULE_5_moment___default()().unix())) {
                                _context2.next = 8;
                                break;
                            }

                            _this2.isAuthenticated = true;
                            _this2.user = user;
                            _context2.next = 10;
                            break;

                        case 8:
                            _context2.next = 10;
                            return _this2.$root.signIn(returnPath);

                        case 10:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    getUser: function getUser() {
        var _this3 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            var user;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return _this3.mgr.getUser();

                        case 3:
                            user = _context3.sent;
                            return _context3.abrupt("return", user);

                        case 7:
                            _context3.prev = 7;
                            _context3.t0 = _context3["catch"](0);

                            console.log(_context3.t0);

                        case 10:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3, [[0, 7]]);
        }))();
    },
    loadProfiles: function loadProfiles() {
        var _this4 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            var response;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (!(_this4.profiles && _this4.profiles.length > 0)) {
                                _context4.next = 2;
                                break;
                            }

                            return _context4.abrupt("return", _this4.profiles);

                        case 2:
                            _context4.prev = 2;
                            _context4.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("/Api/CompanyProfile/GetMyProfiles");

                        case 5:
                            response = _context4.sent;

                            if (response.status == 200) {
                                _this4.profiles = response.data;
                            }
                            _context4.next = 12;
                            break;

                        case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4["catch"](2);

                            console.log("loadProfiles error", _context4.t0);

                        case 12:
                            return _context4.abrupt("return", _this4.profiles);

                        case 13:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[2, 9]]);
        }))();
    },
    signIn: function signIn(returnPath) {
        var _this5 = this;

        this.mgr.clearStaleState().then(function () {
            console.log("clearState success");
            returnPath ? _this5.mgr.signinRedirect({
                state: returnPath
            }) : _this5.mgr.signinRedirect();
        }).catch(function (e) {
            console.log("clearStateState error", e.message);
        });
    },
    signOut: function signOut() {
        this.mgr.clearStaleState().then(function () {
            console.log("clearState success");
        });

        return this.mgr.signoutRedirect();
    },
    canAccessPage: function canAccessPage(to) {
        var _this6 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            var user, excludeSuperAdmin, excludedProfileTypes, isSuperAdmin, profiles, p, requiredProfileTypes, _profiles, _p, i, role, j, req, _role, _j, _req;

            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (!(to.meta.requiredAuth && to.meta.requiredRoles && to.meta.requiredRoles.length > 0)) {
                                _context5.next = 59;
                                break;
                            }

                            _context5.next = 3;
                            return _this6.mgr.getUser();

                        case 3:
                            user = _context5.sent;


                            // Check if super_admin should be excluded from this route
                            excludeSuperAdmin = to.meta.excludeSuperAdmin === true;

                            // Check if user's profile type is excluded from this route
                            // (super_admin จะข้ามการเช็คนี้ — เห็นทุกหน้าเสมอ)

                            excludedProfileTypes = to.meta.excludedProfileTypes || [];
                            isSuperAdmin = Array.isArray(user.profile.role) ? user.profile.role.indexOf("super_admin") !== -1 : user.profile.role === "super_admin";

                            if (!(excludedProfileTypes.length > 0 && !isSuperAdmin)) {
                                _context5.next = 17;
                                break;
                            }

                            profiles = _this6.profiles;

                            if (!(profiles && Array.isArray(profiles))) {
                                _context5.next = 17;
                                break;
                            }

                            p = 0;

                        case 11:
                            if (!(p < profiles.length)) {
                                _context5.next = 17;
                                break;
                            }

                            if (!(excludedProfileTypes.indexOf(profiles[p].profileTypeCode) !== -1)) {
                                _context5.next = 14;
                                break;
                            }

                            return _context5.abrupt("return", false);

                        case 14:
                            p++;
                            _context5.next = 11;
                            break;

                        case 17:

                            // Allow access if user has any profile in requiredProfileTypes (independent of roles)
                            requiredProfileTypes = to.meta.requiredProfileTypes || [];

                            if (!(requiredProfileTypes.length > 0)) {
                                _context5.next = 28;
                                break;
                            }

                            _profiles = _this6.profiles;

                            if (!(_profiles && Array.isArray(_profiles))) {
                                _context5.next = 28;
                                break;
                            }

                            _p = 0;

                        case 22:
                            if (!(_p < _profiles.length)) {
                                _context5.next = 28;
                                break;
                            }

                            if (!(requiredProfileTypes.indexOf(_profiles[_p].profileTypeCode) !== -1)) {
                                _context5.next = 25;
                                break;
                            }

                            return _context5.abrupt("return", true);

                        case 25:
                            _p++;
                            _context5.next = 22;
                            break;

                        case 28:
                            if (!Array.isArray(user.profile.role)) {
                                _context5.next = 47;
                                break;
                            }

                            i = 0;

                        case 30:
                            if (!(i < user.profile.role.length)) {
                                _context5.next = 45;
                                break;
                            }

                            role = user.profile.role[i];

                            if (!(role === "super_admin" && !excludeSuperAdmin)) {
                                _context5.next = 34;
                                break;
                            }

                            return _context5.abrupt("return", true);

                        case 34:
                            j = 0;

                        case 35:
                            if (!(j < to.meta.requiredRoles.length)) {
                                _context5.next = 42;
                                break;
                            }

                            req = to.meta.requiredRoles[j];

                            if (!(role === req)) {
                                _context5.next = 39;
                                break;
                            }

                            return _context5.abrupt("return", true);

                        case 39:
                            j++;
                            _context5.next = 35;
                            break;

                        case 42:
                            i++;
                            _context5.next = 30;
                            break;

                        case 45:
                            _context5.next = 58;
                            break;

                        case 47:
                            _role = user.profile.role;

                            if (!(_role === "super_admin" && !excludeSuperAdmin)) {
                                _context5.next = 50;
                                break;
                            }

                            return _context5.abrupt("return", true);

                        case 50:
                            _j = 0;

                        case 51:
                            if (!(_j < to.meta.requiredRoles.length)) {
                                _context5.next = 58;
                                break;
                            }

                            _req = to.meta.requiredRoles[_j];

                            if (!(_role === _req)) {
                                _context5.next = 55;
                                break;
                            }

                            return _context5.abrupt("return", true);

                        case 55:
                            _j++;
                            _context5.next = 51;
                            break;

                        case 58:
                            return _context5.abrupt("return", false);

                        case 59:
                            return _context5.abrupt("return", true);

                        case 60:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, _this6);
        }))();
    },
    canShow: function canShow(roles) {
        var user = this.user;
        var profiles = this.profiles;
        if (user) {
            if (Array.isArray(roles)) {
                // กรณีส่งถามสิทธิ์เข้ามาเป็น array
                for (var i = 0; i < roles.length; i++) {
                    var req = roles[i];
                    if (Array.isArray(req)) {
                        if (Array.isArray(user.profile.role)) {
                            for (var j = 0; j < user.profile.role.length; j++) {
                                var role = user.profile.role[j];
                                if (role === "super_admin") {
                                    return true;
                                }
                            }
                        } else {
                            var _role2 = user.profile.role;
                            if (_role2 === "super_admin") {
                                return true;
                            }
                        }

                        // กรณีส่งถามสิทธิ์เข้ามาเป็น array ให้ตรวจสอบสิทธิ์จาก profiles โดยต้องตรวจสอบ type
                        // 0: role
                        // 1: type
                        for (var _j2 = 0; _j2 < profiles.length; _j2++) {
                            var profile = profiles[_j2];
                            if (profile.profileTypeCode == req[1]) {
                                for (var k = 0; k < profile.roles.length; k++) {
                                    var preq = profile.roles[k];
                                    if (preq == req[0]) {
                                        return true;
                                    }
                                }
                            }
                        }
                    } else if (typeof req === "string") {
                        // กรณีส่งถามสิทธิ์เข้ามาเป็น string ให้ตรวจสอบสิทธิ์จาก user role โดยไม่ต้องตรวจสอบ type
                        if (Array.isArray(user.profile.role)) {
                            for (var _j3 = 0; _j3 < user.profile.role.length; _j3++) {
                                var _role3 = user.profile.role[_j3];
                                if (_role3 === "super_admin") {
                                    return true;
                                } else if (_role3 === req) {
                                    return true;
                                }
                            }
                        } else {
                            var _role4 = user.profile.role;
                            if (_role4 === "super_admin") {
                                return true;
                            } else if (_role4 === req) {
                                return true;
                            }
                        }
                    }
                }

                // if (Array.isArray(user.profile.role)) {
                //   for (let i = 0; i < user.profile.role.length; i++) {
                //     const role = user.profile.role[i];
                //     if (role === "super_admin") {
                //       return true;
                //     }

                //     for (let j = 0; j < roles.length; j++) {
                //       const req = roles[j];
                //       if (role === req) {
                //         return true;
                //       }
                //     }
                //   }
                // } else {
                //   const role = user.profile.role;
                //   if (role === "super_admin") {
                //     return true;
                //   }

                //   for (let j = 0; j < roles.length; j++) {
                //     const req = roles[j];
                //     if (role === req) {
                //       return true;
                //     }
                //   }
                // }
            } else if (typeof roles === "string") {
                // กรณีส่งถามสิทธิ์เข้ามาเป็น string ให้ตรวจสอบสิทธิ์จาก user role โดยไม่ต้องตรวจสอบ type
                if (Array.isArray(user.profile.role)) {
                    for (var _i = 0; _i < user.profile.role.length; _i++) {
                        var _role5 = user.profile.role[_i];
                        if (_role5 === "super_admin") {
                            return true;
                        } else if (_role5 === roles) {
                            return true;
                        }
                    }
                } else {
                    var _role6 = user.profile.role;
                    if (_role6 === "super_admin") {
                        return true;
                    } else if (_role6 === roles) {
                        return true;
                    }
                }
            }
        }
        return false;
    },
    canShowExSuperAdmin: function canShowExSuperAdmin(roles) {
        var user = this.user;
        var profiles = this.profiles;
        if (user) {
            if (Array.isArray(roles)) {
                // กรณีส่งถามสิทธิ์เข้ามาเป็น array
                for (var i = 0; i < roles.length; i++) {
                    var req = roles[i];
                    if (Array.isArray(req)) {
                        // กรณีส่งถามสิทธิ์เข้ามาเป็น array ให้ตรวจสอบสิทธิ์จาก profiles โดยต้องตรวจสอบ type
                        // 0: role
                        // 1: type
                        for (var j = 0; j < profiles.length; j++) {
                            var profile = profiles[j];
                            if (profile.profileTypeCode == req[1]) {
                                for (var k = 0; k < profile.roles.length; k++) {
                                    var preq = profile.roles[k];
                                    if (preq == req[0]) {
                                        return true;
                                    }
                                }
                            }
                        }
                    } else if (typeof req === "string") {
                        // กรณีส่งถามสิทธิ์เข้ามาเป็น string ให้ตรวจสอบสิทธิ์จาก user role โดยไม่ต้องตรวจสอบ type
                        if (Array.isArray(user.profile.role)) {
                            for (var _j4 = 0; _j4 < user.profile.role.length; _j4++) {
                                var role = user.profile.role[_j4];
                                if (role === req) {
                                    return true;
                                }
                            }
                        } else {
                            var _role7 = user.profile.role;
                            if (_role7 === req) {
                                return true;
                            }
                        }
                    }
                }
            } else if (typeof roles === "string") {
                // กรณีส่งถามสิทธิ์เข้ามาเป็น string ให้ตรวจสอบสิทธิ์จาก user role โดยไม่ต้องตรวจสอบ type
                if (Array.isArray(user.profile.role)) {
                    for (var _i2 = 0; _i2 < user.profile.role.length; _i2++) {
                        var _role8 = user.profile.role[_i2];
                        if (_role8 === roles) {
                            return true;
                        }
                    }
                } else {
                    var _role9 = user.profile.role;
                    if (_role9 === roles) {
                        return true;
                    }
                }
            }
        }
        return false;
    },

    /**
     * Check if user has Budget Plan profile (any role: USER, REVIEWER, MANAGER)
     * Used to hide menus from Budget Plan profile users
     * Note: super_admin users always return false to see all menus
     */
    hasBudgetPlanProfile: function hasBudgetPlanProfile() {
        // super_admin should see all menus regardless of company profiles
        // Handle both array and string cases for role
        if (this.user && this.user.profile) {
            var role = this.user.profile.role;
            if (Array.isArray(role)) {
                for (var i = 0; i < role.length; i++) {
                    if (role[i] === 'super_admin') {
                        return false;
                    }
                }
            } else if (role === 'super_admin') {
                return false;
            }
        }

        var profiles = this.profiles;
        if (profiles && Array.isArray(profiles)) {
            for (var j = 0; j < profiles.length; j++) {
                var profile = profiles[j];
                if (profile.profileTypeCode === 'COMPANY_PROFILE_TYPE_BUDGET') {
                    return true;
                }
            }
        }
        return false;
    },

    /**
     * CR-FormSummaryStock: ตรวจว่า user ผูกโปรไฟล์ "พิมพ์เอกสารสรุปข้อมูล" ไว้หรือไม่
     *
     * ตาม requirement: ผู้ที่มีสิทธิ์ "ผู้ดูแลระบบ" ทั่วไปแต่ยังไม่ได้ผูกโปรไฟล์นี้ จะไม่เห็นเมนู
     * -> super_admin ก็ไม่ bypass (ต่างจาก hasBudgetPlanProfile ที่ return false ให้ super_admin)
     */
    hasFormSummaryStockProfile: function hasFormSummaryStockProfile() {
        var profiles = this.profiles;
        if (profiles && Array.isArray(profiles)) {
            for (var j = 0; j < profiles.length; j++) {
                if (profiles[j].profileTypeCode === 'COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK') {
                    return true;
                }
            }
        }
        return false;
    },

    /**
     * Check if user has BR (factory) profile
     * Used to hide menus from BR factory admin users
     * Note: super_admin users always return false to see all menus
     */
    hasBrProfile: function hasBrProfile() {
        if (this.user && this.user.profile) {
            var role = this.user.profile.role;
            if (Array.isArray(role)) {
                for (var i = 0; i < role.length; i++) {
                    if (role[i] === 'super_admin') {
                        return false;
                    }
                }
            } else if (role === 'super_admin') {
                return false;
            }
        }

        var profiles = this.profiles;
        if (profiles && Array.isArray(profiles)) {
            for (var j = 0; j < profiles.length; j++) {
                if (profiles[j].profileTypeCode === 'COMPANY_PROFILE_TYPE_BR') {
                    return true;
                }
            }
        }
        return false;
    },

    /**
     * Check if user has Agent (ตัวแทนจำหน่าย) profile (any role under COMPANY_PROFILE_TYPE_AGENT)
     * Used to grant access to agent-side score reports without requiring a specific role
     */
    hasAgentProfile: function hasAgentProfile() {
        var profiles = this.profiles;
        if (profiles && Array.isArray(profiles)) {
            for (var j = 0; j < profiles.length; j++) {
                if (profiles[j].profileTypeCode === 'COMPANY_PROFILE_TYPE_AGENT') {
                    return true;
                }
            }
        }
        return false;
    },

    /**
     * Check if user has Stock Cover Days (Profile 13) company profile.
     * G6 (spec sheet7): ต้องมี Profile 13 ถึงจะเห็นเมนู SCVD — ใช้กับ super_admin ด้วย (ไม่ bypass).
     */
    hasScvdProfile: function hasScvdProfile() {
        var profiles = this.profiles;
        if (profiles && Array.isArray(profiles)) {
            for (var j = 0; j < profiles.length; j++) {
                if (profiles[j].profileTypeCode === 'COMPANY_PROFILE_TYPE_SCVD') {
                    return true;
                }
            }
        }
        return false;
    },

    /**
     * Check if user has at least one CompanyProfile
     * Used to hide agent-score sections from users with no company profile mapping
     * Note: super_admin returns true so the section stays visible for them
     */
    hasAnyCompanyProfile: function hasAnyCompanyProfile() {

        var profiles = this.profiles;
        var ret = profiles && Array.isArray(profiles) && profiles.length > 0;

        return ret;
    }
};

var v = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: "#app",
    template: "<div><router-view></router-view></div>",
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    data: globalData,
    methods: globalMethods
});

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(to, from, next) {
        var app, is_super_admin, role, i, landing;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        app = __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].app.$data || {
                            isAuthenticated: false
                        };
                        _context7.next = 3;
                        return v.loadProfiles();

                    case 3:
                        is_super_admin = false;

                        if (!(v.user && v.user.profile)) {
                            _context7.next = 15;
                            break;
                        }

                        role = v.user.profile.role;

                        if (!Array.isArray(role)) {
                            _context7.next = 15;
                            break;
                        }

                        i = 0;

                    case 8:
                        if (!(i < role.length)) {
                            _context7.next = 15;
                            break;
                        }

                        if (!(role[i] === 'super_admin')) {
                            _context7.next = 12;
                            break;
                        }

                        is_super_admin = true;
                        return _context7.abrupt("break", 15);

                    case 12:
                        i++;
                        _context7.next = 8;
                        break;

                    case 15:
                        if (!app.isAuthenticated) {
                            _context7.next = 38;
                            break;
                        }

                        if (!(!is_super_admin && to.path === "/" && v.canShowExSuperAdmin(["AGENT_REPORT", "BR_REPORT"]) && !v.hasBrProfile())) {
                            _context7.next = 19;
                            break;
                        }

                        next("/AgentScoreDashboard");
                        return _context7.abrupt("return");

                    case 19:
                        if (!(!is_super_admin && to.path === "/" && !v.canShowExSuperAdmin(["DASHBOARD"]) && v.canShowExSuperAdmin(["SCVD_ADMIN", "SCVD_TEAM_EDIT", "SCVD_VIEWER"]))) {
                            _context7.next = 22;
                            break;
                        }

                        next("/StockCoverDays/Dashboard");
                        return _context7.abrupt("return");

                    case 22:
                        if (!(!is_super_admin && to.path === "/")) {
                            _context7.next = 29;
                            break;
                        }

                        _context7.next = 25;
                        return v.budgetLandingPath();

                    case 25:
                        landing = _context7.sent;

                        if (!landing) {
                            _context7.next = 29;
                            break;
                        }

                        next(landing);
                        return _context7.abrupt("return");

                    case 29:
                        _context7.next = 31;
                        return v.canAccessPage(to);

                    case 31:
                        if (!_context7.sent) {
                            _context7.next = 35;
                            break;
                        }

                        next();
                        _context7.next = 36;
                        break;

                    case 35:
                        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
                            path: "/Error/Unauthorized"
                        });

                    case 36:
                        _context7.next = 49;
                        break;

                    case 38:
                        if (!to.matched.some(function (record) {
                            return record.meta.requiredAuth;
                        })) {
                            _context7.next = 42;
                            break;
                        }

                        //authentication is required. Trigger the sign in process, including the return URI
                        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].app.authenticate(to.path).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                            var _landing;

                            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                                while (1) {
                                    switch (_context6.prev = _context6.next) {
                                        case 0:
                                            _context6.next = 2;
                                            return v.loadProfiles();

                                        case 2:
                                            if (!(!is_super_admin && to.path === "/" && v.canShowExSuperAdmin(["AGENT_REPORT", "BR_REPORT"]) && !v.hasBrProfile())) {
                                                _context6.next = 5;
                                                break;
                                            }

                                            next("/AgentScoreDashboard");
                                            return _context6.abrupt("return");

                                        case 5:
                                            if (!(!is_super_admin && to.path === "/" && !v.canShowExSuperAdmin(["DASHBOARD"]) && v.canShowExSuperAdmin(["SCVD_ADMIN", "SCVD_TEAM_EDIT", "SCVD_VIEWER"]))) {
                                                _context6.next = 8;
                                                break;
                                            }

                                            next("/StockCoverDays/Dashboard");
                                            return _context6.abrupt("return");

                                        case 8:
                                            if (!(!is_super_admin && to.path === "/")) {
                                                _context6.next = 15;
                                                break;
                                            }

                                            _context6.next = 11;
                                            return v.budgetLandingPath();

                                        case 11:
                                            _landing = _context6.sent;

                                            if (!_landing) {
                                                _context6.next = 15;
                                                break;
                                            }

                                            next(_landing);
                                            return _context6.abrupt("return");

                                        case 15:
                                            _context6.next = 17;
                                            return v.canAccessPage(to);

                                        case 17:
                                            if (!_context6.sent) {
                                                _context6.next = 21;
                                                break;
                                            }

                                            next();
                                            _context6.next = 22;
                                            break;

                                        case 21:
                                            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
                                                path: "/Error/Unauthorized"
                                            });

                                        case 22:
                                        case "end":
                                            return _context6.stop();
                                    }
                                }
                            }, _callee6, _this7);
                        })));
                        _context7.next = 49;
                        break;

                    case 42:
                        _context7.next = 44;
                        return v.canAccessPage(to);

                    case 44:
                        if (!_context7.sent) {
                            _context7.next = 48;
                            break;
                        }

                        next();
                        _context7.next = 49;
                        break;

                    case 48:
                        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
                            path: "/Error/Unauthorized"
                        });

                    case 49:
                    case "end":
                        return _context7.stop();
                }
            }
        }, _callee7, _this7);
    }));

    return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}());

// CR-StockCoverDays — /Monitoring email gate: identity email must be in AppSettings.MonitorEmail
// (server-verified via /Api/Monitor/access_check). Not a monitor → redirect home. Result cached on $root.
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(to, from, next) {
        var res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        if (to.matched.some(function (r) {
                            return r.meta && r.meta.requiredMonitorEmail;
                        })) {
                            _context8.next = 3;
                            break;
                        }

                        next();
                        return _context8.abrupt("return");

                    case 3:
                        _context8.prev = 3;

                        if (!(v.$root.isMonitor === undefined || v.$root.isMonitor === null)) {
                            _context8.next = 9;
                            break;
                        }

                        _context8.next = 7;
                        return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("/Api/Monitor/access_check");

                    case 7:
                        res = _context8.sent;

                        v.$root.isMonitor = !!(res.data && res.data.isMonitor);

                    case 9:
                        _context8.next = 14;
                        break;

                    case 11:
                        _context8.prev = 11;
                        _context8.t0 = _context8["catch"](3);

                        v.$root.isMonitor = false;

                    case 14:
                        if (v.$root.isMonitor) next();else next("/");

                    case 15:
                    case "end":
                        return _context8.stop();
                }
            }
        }, _callee8, _this7, [[3, 11]]);
    }));

    return function (_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
    };
}());

__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.request.use(function (config) {
    var user = v.$root.user;
    if (user) {
        var authToken = user.access_token;
        if (authToken) {
            config.headers.Authorization = "Bearer " + authToken;
        }
    }
    return config;
}, function (err) {
    //What do you want to do when a call fails?
});

__WEBPACK_IMPORTED_MODULE_3__security__["a" /* default */].events.addUserLoaded(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return v.$root.getUser();

                case 2:
                    v.$root.user = _context9.sent;

                case 3:
                case "end":
                    return _context9.stop();
            }
        }
    }, _callee9, this);
}))
// console.log("UserLoaded (New Token)", v.$root.user.access_token);
);

__WEBPACK_IMPORTED_MODULE_3__security__["a" /* default */].events.addAccessTokenExpired(function () {
    console.log("AccessTokenExpired");
});

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(865);

__webpack_require__(663);

__webpack_require__(666);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 636 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(142);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 638 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 640 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 641 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 642 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(636);

var iterableToArrayLimit = __webpack_require__(640);

var unsupportedIterableToArray = __webpack_require__(143);

var nonIterableRest = __webpack_require__(641);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(637);

var iterableToArray = __webpack_require__(639);

var unsupportedIterableToArray = __webpack_require__(143);

var nonIterableSpread = __webpack_require__(642);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 645 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);
var bind = __webpack_require__(150);
var Axios = __webpack_require__(648);
var mergeConfig = __webpack_require__(148);
var defaults = __webpack_require__(149);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(145);
axios.CancelToken = __webpack_require__(647);
axios.isCancel = __webpack_require__(146);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(660);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(145);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);
var buildURL = __webpack_require__(151);
var InterceptorManager = __webpack_require__(649);
var dispatchRequest = __webpack_require__(650);
var mergeConfig = __webpack_require__(148);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);
  config.method = config.method ? config.method.toLowerCase() : 'get';

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);
var transformData = __webpack_require__(653);
var isCancel = __webpack_require__(146);
var defaults = __webpack_require__(149);
var isAbsoluteURL = __webpack_require__(656);
var combineURLs = __webpack_require__(654);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(147);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 661 */
/***/ (function(module, exports) {

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/

module.exports = function mergeJSXProps (objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp
    for (key in b) {
      aa = a[key]
      bb = b[key]
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa
            a[key] = aa = {}
            aa[temp] = true
          }
          if (typeof bb === 'string') {
            temp = bb
            b[key] = bb = {}
            bb[temp] = true
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey])
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb)
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb)
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey]
          }
        }
      } else {
        a[key] = b[key]
      }
    }
    return a
  }, {})
}

function mergeFn (a, b) {
  return function () {
    a && a.apply(this, arguments)
    b && b.apply(this, arguments)
  }
}


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_oidc_client__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_oidc_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_oidc_client__);


// console.log(process.env.SCOPES);

var mgr = new __WEBPACK_IMPORTED_MODULE_0_oidc_client___default.a.UserManager({
    authority: "https://draught-sit.boonrawd.co.th",
    client_id: "draught.backoffice.ictsso",
    redirect_uri: "https://draught-sit.boonrawd.co.th" + "/Callback",
    response_type: "code",
    scope: "openid profile draught",
    post_logout_redirect_uri: "https://draught-sit.boonrawd.co.th",
    automaticSilentRenew: true,
    silent_redirect_uri: "https://draught-sit.boonrawd.co.th" + "/Account/SilentRenew",
    accessTokenExpiringNotificationTime: 10,
    userStore: new __WEBPACK_IMPORTED_MODULE_0_oidc_client___default.a.WebStorageStateStore({
        store: window.localStorage
    })
});

// Oidc.Log.logger = console;
// Oidc.Log.level = Oidc.Log.INFO;

/* harmony default export */ __webpack_exports__["a"] = (mgr);

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Datepicker for Bootstrap v1.9.0 (https://github.com/uxsolutions/bootstrap-datepicker)
 *
 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
 */

(function(factory){
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        factory(require('jquery'));
    } else {
        factory(jQuery);
    }
}(function($, undefined){
	function UTCDate(){
		return new Date(Date.UTC.apply(Date, arguments));
	}
	function UTCToday(){
		var today = new Date();
		return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
	}
	function isUTCEquals(date1, date2) {
		return (
			date1.getUTCFullYear() === date2.getUTCFullYear() &&
			date1.getUTCMonth() === date2.getUTCMonth() &&
			date1.getUTCDate() === date2.getUTCDate()
		);
	}
	function alias(method, deprecationMsg){
		return function(){
			if (deprecationMsg !== undefined) {
				$.fn.datepicker.deprecated(deprecationMsg);
			}

			return this[method].apply(this, arguments);
		};
	}
	function isValidDate(d) {
		return d && !isNaN(d.getTime());
	}

	var DateArray = (function(){
		var extras = {
			get: function(i){
				return this.slice(i)[0];
			},
			contains: function(d){
				// Array.indexOf is not cross-browser;
				// $.inArray doesn't work with Dates
				var val = d && d.valueOf();
				for (var i=0, l=this.length; i < l; i++)
          // Use date arithmetic to allow dates with different times to match
          if (0 <= this[i].valueOf() - val && this[i].valueOf() - val < 1000*60*60*24)
						return i;
				return -1;
			},
			remove: function(i){
				this.splice(i,1);
			},
			replace: function(new_array){
				if (!new_array)
					return;
				if (!$.isArray(new_array))
					new_array = [new_array];
				this.clear();
				this.push.apply(this, new_array);
			},
			clear: function(){
				this.length = 0;
			},
			copy: function(){
				var a = new DateArray();
				a.replace(this);
				return a;
			}
		};

		return function(){
			var a = [];
			a.push.apply(a, arguments);
			$.extend(a, extras);
			return a;
		};
	})();


	// Picker object

	var Datepicker = function(element, options){
		$.data(element, 'datepicker', this);

		this._events = [];
		this._secondaryEvents = [];

		this._process_options(options);

		this.dates = new DateArray();
		this.viewDate = this.o.defaultViewDate;
		this.focusDate = null;

		this.element = $(element);
		this.isInput = this.element.is('input');
		this.inputField = this.isInput ? this.element : this.element.find('input');
		this.component = this.element.hasClass('date') ? this.element.find('.add-on, .input-group-addon, .input-group-append, .input-group-prepend, .btn') : false;
		if (this.component && this.component.length === 0)
			this.component = false;
		this.isInline = !this.component && this.element.is('div');

		this.picker = $(DPGlobal.template);

		// Checking templates and inserting
		if (this._check_template(this.o.templates.leftArrow)) {
			this.picker.find('.prev').html(this.o.templates.leftArrow);
		}

		if (this._check_template(this.o.templates.rightArrow)) {
			this.picker.find('.next').html(this.o.templates.rightArrow);
		}

		this._buildEvents();
		this._attachEvents();

		if (this.isInline){
			this.picker.addClass('datepicker-inline').appendTo(this.element);
		}
		else {
			this.picker.addClass('datepicker-dropdown dropdown-menu');
		}

		if (this.o.rtl){
			this.picker.addClass('datepicker-rtl');
		}

		if (this.o.calendarWeeks) {
			this.picker.find('.datepicker-days .datepicker-switch, thead .datepicker-title, tfoot .today, tfoot .clear')
				.attr('colspan', function(i, val){
					return Number(val) + 1;
				});
		}

		this._process_options({
			startDate: this._o.startDate,
			endDate: this._o.endDate,
			daysOfWeekDisabled: this.o.daysOfWeekDisabled,
			daysOfWeekHighlighted: this.o.daysOfWeekHighlighted,
			datesDisabled: this.o.datesDisabled
		});

		this._allow_update = false;
		this.setViewMode(this.o.startView);
		this._allow_update = true;

		this.fillDow();
		this.fillMonths();

		this.update();

		if (this.isInline){
			this.show();
		}
	};

	Datepicker.prototype = {
		constructor: Datepicker,

		_resolveViewName: function(view){
			$.each(DPGlobal.viewModes, function(i, viewMode){
				if (view === i || $.inArray(view, viewMode.names) !== -1){
					view = i;
					return false;
				}
			});

			return view;
		},

		_resolveDaysOfWeek: function(daysOfWeek){
			if (!$.isArray(daysOfWeek))
				daysOfWeek = daysOfWeek.split(/[,\s]*/);
			return $.map(daysOfWeek, Number);
		},

		_check_template: function(tmp){
			try {
				// If empty
				if (tmp === undefined || tmp === "") {
					return false;
				}
				// If no html, everything ok
				if ((tmp.match(/[<>]/g) || []).length <= 0) {
					return true;
				}
				// Checking if html is fine
				var jDom = $(tmp);
				return jDom.length > 0;
			}
			catch (ex) {
				return false;
			}
		},

		_process_options: function(opts){
			// Store raw options for reference
			this._o = $.extend({}, this._o, opts);
			// Processed options
			var o = this.o = $.extend({}, this._o);

			// Check if "de-DE" style date is available, if not language should
			// fallback to 2 letter code eg "de"
			var lang = o.language;
			if (!dates[lang]){
				lang = lang.split('-')[0];
				if (!dates[lang])
					lang = defaults.language;
			}
			o.language = lang;

			// Retrieve view index from any aliases
			o.startView = this._resolveViewName(o.startView);
			o.minViewMode = this._resolveViewName(o.minViewMode);
			o.maxViewMode = this._resolveViewName(o.maxViewMode);

			// Check view is between min and max
			o.startView = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, o.startView));

			// true, false, or Number > 0
			if (o.multidate !== true){
				o.multidate = Number(o.multidate) || false;
				if (o.multidate !== false)
					o.multidate = Math.max(0, o.multidate);
			}
			o.multidateSeparator = String(o.multidateSeparator);

			o.weekStart %= 7;
			o.weekEnd = (o.weekStart + 6) % 7;

			var format = DPGlobal.parseFormat(o.format);
			if (o.startDate !== -Infinity){
				if (!!o.startDate){
					if (o.startDate instanceof Date)
						o.startDate = this._local_to_utc(this._zero_time(o.startDate));
					else
						o.startDate = DPGlobal.parseDate(o.startDate, format, o.language, o.assumeNearbyYear);
				}
				else {
					o.startDate = -Infinity;
				}
			}
			if (o.endDate !== Infinity){
				if (!!o.endDate){
					if (o.endDate instanceof Date)
						o.endDate = this._local_to_utc(this._zero_time(o.endDate));
					else
						o.endDate = DPGlobal.parseDate(o.endDate, format, o.language, o.assumeNearbyYear);
				}
				else {
					o.endDate = Infinity;
				}
			}

			o.daysOfWeekDisabled = this._resolveDaysOfWeek(o.daysOfWeekDisabled||[]);
			o.daysOfWeekHighlighted = this._resolveDaysOfWeek(o.daysOfWeekHighlighted||[]);

			o.datesDisabled = o.datesDisabled||[];
			if (!$.isArray(o.datesDisabled)) {
				o.datesDisabled = o.datesDisabled.split(',');
			}
			o.datesDisabled = $.map(o.datesDisabled, function(d){
				return DPGlobal.parseDate(d, format, o.language, o.assumeNearbyYear);
			});

			var plc = String(o.orientation).toLowerCase().split(/\s+/g),
				_plc = o.orientation.toLowerCase();
			plc = $.grep(plc, function(word){
				return /^auto|left|right|top|bottom$/.test(word);
			});
			o.orientation = {x: 'auto', y: 'auto'};
			if (!_plc || _plc === 'auto')
				; // no action
			else if (plc.length === 1){
				switch (plc[0]){
					case 'top':
					case 'bottom':
						o.orientation.y = plc[0];
						break;
					case 'left':
					case 'right':
						o.orientation.x = plc[0];
						break;
				}
			}
			else {
				_plc = $.grep(plc, function(word){
					return /^left|right$/.test(word);
				});
				o.orientation.x = _plc[0] || 'auto';

				_plc = $.grep(plc, function(word){
					return /^top|bottom$/.test(word);
				});
				o.orientation.y = _plc[0] || 'auto';
			}
			if (o.defaultViewDate instanceof Date || typeof o.defaultViewDate === 'string') {
				o.defaultViewDate = DPGlobal.parseDate(o.defaultViewDate, format, o.language, o.assumeNearbyYear);
			} else if (o.defaultViewDate) {
				var year = o.defaultViewDate.year || new Date().getFullYear();
				var month = o.defaultViewDate.month || 0;
				var day = o.defaultViewDate.day || 1;
				o.defaultViewDate = UTCDate(year, month, day);
			} else {
				o.defaultViewDate = UTCToday();
			}
		},
		_applyEvents: function(evs){
			for (var i=0, el, ch, ev; i < evs.length; i++){
				el = evs[i][0];
				if (evs[i].length === 2){
					ch = undefined;
					ev = evs[i][1];
				} else if (evs[i].length === 3){
					ch = evs[i][1];
					ev = evs[i][2];
				}
				el.on(ev, ch);
			}
		},
		_unapplyEvents: function(evs){
			for (var i=0, el, ev, ch; i < evs.length; i++){
				el = evs[i][0];
				if (evs[i].length === 2){
					ch = undefined;
					ev = evs[i][1];
				} else if (evs[i].length === 3){
					ch = evs[i][1];
					ev = evs[i][2];
				}
				el.off(ev, ch);
			}
		},
		_buildEvents: function(){
            var events = {
                keyup: $.proxy(function(e){
                    if ($.inArray(e.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) === -1)
                        this.update();
                }, this),
                keydown: $.proxy(this.keydown, this),
                paste: $.proxy(this.paste, this)
            };

            if (this.o.showOnFocus === true) {
                events.focus = $.proxy(this.show, this);
            }

            if (this.isInput) { // single input
                this._events = [
                    [this.element, events]
                ];
            }
            // component: input + button
            else if (this.component && this.inputField.length) {
                this._events = [
                    // For components that are not readonly, allow keyboard nav
                    [this.inputField, events],
                    [this.component, {
                        click: $.proxy(this.show, this)
                    }]
                ];
            }
			else {
				this._events = [
					[this.element, {
						click: $.proxy(this.show, this),
						keydown: $.proxy(this.keydown, this)
					}]
				];
			}
			this._events.push(
				// Component: listen for blur on element descendants
				[this.element, '*', {
					blur: $.proxy(function(e){
						this._focused_from = e.target;
					}, this)
				}],
				// Input: listen for blur on element
				[this.element, {
					blur: $.proxy(function(e){
						this._focused_from = e.target;
					}, this)
				}]
			);

			if (this.o.immediateUpdates) {
				// Trigger input updates immediately on changed year/month
				this._events.push([this.element, {
					'changeYear changeMonth': $.proxy(function(e){
						this.update(e.date);
					}, this)
				}]);
			}

			this._secondaryEvents = [
				[this.picker, {
					click: $.proxy(this.click, this)
				}],
				[this.picker, '.prev, .next', {
					click: $.proxy(this.navArrowsClick, this)
				}],
				[this.picker, '.day:not(.disabled)', {
					click: $.proxy(this.dayCellClick, this)
				}],
				[$(window), {
					resize: $.proxy(this.place, this)
				}],
				[$(document), {
					'mousedown touchstart': $.proxy(function(e){
						// Clicked outside the datepicker, hide it
						if (!(
							this.element.is(e.target) ||
							this.element.find(e.target).length ||
							this.picker.is(e.target) ||
							this.picker.find(e.target).length ||
							this.isInline
						)){
							this.hide();
						}
					}, this)
				}]
			];
		},
		_attachEvents: function(){
			this._detachEvents();
			this._applyEvents(this._events);
		},
		_detachEvents: function(){
			this._unapplyEvents(this._events);
		},
		_attachSecondaryEvents: function(){
			this._detachSecondaryEvents();
			this._applyEvents(this._secondaryEvents);
		},
		_detachSecondaryEvents: function(){
			this._unapplyEvents(this._secondaryEvents);
		},
		_trigger: function(event, altdate){
			var date = altdate || this.dates.get(-1),
				local_date = this._utc_to_local(date);

			this.element.trigger({
				type: event,
				date: local_date,
				viewMode: this.viewMode,
				dates: $.map(this.dates, this._utc_to_local),
				format: $.proxy(function(ix, format){
					if (arguments.length === 0){
						ix = this.dates.length - 1;
						format = this.o.format;
					} else if (typeof ix === 'string'){
						format = ix;
						ix = this.dates.length - 1;
					}
					format = format || this.o.format;
					var date = this.dates.get(ix);
					return DPGlobal.formatDate(date, format, this.o.language);
				}, this)
			});
		},

		show: function(){
			if (this.inputField.is(':disabled') || (this.inputField.prop('readonly') && this.o.enableOnReadonly === false))
				return;
			if (!this.isInline)
				this.picker.appendTo(this.o.container);
			this.place();
			this.picker.show();
			this._attachSecondaryEvents();
			this._trigger('show');
			if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document) && this.o.disableTouchKeyboard) {
				$(this.element).blur();
			}
			return this;
		},

		hide: function(){
			if (this.isInline || !this.picker.is(':visible'))
				return this;
			this.focusDate = null;
			this.picker.hide().detach();
			this._detachSecondaryEvents();
			this.setViewMode(this.o.startView);

			if (this.o.forceParse && this.inputField.val())
				this.setValue();
			this._trigger('hide');
			return this;
		},

		destroy: function(){
			this.hide();
			this._detachEvents();
			this._detachSecondaryEvents();
			this.picker.remove();
			delete this.element.data().datepicker;
			if (!this.isInput){
				delete this.element.data().date;
			}
			return this;
		},

		paste: function(e){
			var dateString;
			if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.types
				&& $.inArray('text/plain', e.originalEvent.clipboardData.types) !== -1) {
				dateString = e.originalEvent.clipboardData.getData('text/plain');
			} else if (window.clipboardData) {
				dateString = window.clipboardData.getData('Text');
			} else {
				return;
			}
			this.setDate(dateString);
			this.update();
			e.preventDefault();
		},

		_utc_to_local: function(utc){
			if (!utc) {
				return utc;
			}

			var local = new Date(utc.getTime() + (utc.getTimezoneOffset() * 60000));

			if (local.getTimezoneOffset() !== utc.getTimezoneOffset()) {
				local = new Date(utc.getTime() + (local.getTimezoneOffset() * 60000));
			}

			return local;
		},
		_local_to_utc: function(local){
			return local && new Date(local.getTime() - (local.getTimezoneOffset()*60000));
		},
		_zero_time: function(local){
			return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
		},
		_zero_utc_time: function(utc){
			return utc && UTCDate(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
		},

		getDates: function(){
			return $.map(this.dates, this._utc_to_local);
		},

		getUTCDates: function(){
			return $.map(this.dates, function(d){
				return new Date(d);
			});
		},

		getDate: function(){
			return this._utc_to_local(this.getUTCDate());
		},

		getUTCDate: function(){
			var selected_date = this.dates.get(-1);
			if (selected_date !== undefined) {
				return new Date(selected_date);
			} else {
				return null;
			}
		},

		clearDates: function(){
			this.inputField.val('');
			this.update();
			this._trigger('changeDate');

			if (this.o.autoclose) {
				this.hide();
			}
		},

		setDates: function(){
			var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
			this.update.apply(this, args);
			this._trigger('changeDate');
			this.setValue();
			return this;
		},

		setUTCDates: function(){
			var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
			this.setDates.apply(this, $.map(args, this._utc_to_local));
			return this;
		},

		setDate: alias('setDates'),
		setUTCDate: alias('setUTCDates'),
		remove: alias('destroy', 'Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead'),

		setValue: function(){
			var formatted = this.getFormattedDate();
			this.inputField.val(formatted);
			return this;
		},

		getFormattedDate: function(format){
			if (format === undefined)
				format = this.o.format;

			var lang = this.o.language;
			return $.map(this.dates, function(d){
				return DPGlobal.formatDate(d, format, lang);
			}).join(this.o.multidateSeparator);
		},

		getStartDate: function(){
			return this.o.startDate;
		},

		setStartDate: function(startDate){
			this._process_options({startDate: startDate});
			this.update();
			this.updateNavArrows();
			return this;
		},

		getEndDate: function(){
			return this.o.endDate;
		},

		setEndDate: function(endDate){
			this._process_options({endDate: endDate});
			this.update();
			this.updateNavArrows();
			return this;
		},

		setDaysOfWeekDisabled: function(daysOfWeekDisabled){
			this._process_options({daysOfWeekDisabled: daysOfWeekDisabled});
			this.update();
			return this;
		},

		setDaysOfWeekHighlighted: function(daysOfWeekHighlighted){
			this._process_options({daysOfWeekHighlighted: daysOfWeekHighlighted});
			this.update();
			return this;
		},

		setDatesDisabled: function(datesDisabled){
			this._process_options({datesDisabled: datesDisabled});
			this.update();
			return this;
		},

		place: function(){
			if (this.isInline)
				return this;
			var calendarWidth = this.picker.outerWidth(),
				calendarHeight = this.picker.outerHeight(),
				visualPadding = 10,
				container = $(this.o.container),
				windowWidth = container.width(),
				scrollTop = this.o.container === 'body' ? $(document).scrollTop() : container.scrollTop(),
				appendOffset = container.offset();

			var parentsZindex = [0];
			this.element.parents().each(function(){
				var itemZIndex = $(this).css('z-index');
				if (itemZIndex !== 'auto' && Number(itemZIndex) !== 0) parentsZindex.push(Number(itemZIndex));
			});
			var zIndex = Math.max.apply(Math, parentsZindex) + this.o.zIndexOffset;
			var offset = this.component ? this.component.parent().offset() : this.element.offset();
			var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
			var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
			var left = offset.left - appendOffset.left;
			var top = offset.top - appendOffset.top;

			if (this.o.container !== 'body') {
				top += scrollTop;
			}

			this.picker.removeClass(
				'datepicker-orient-top datepicker-orient-bottom '+
				'datepicker-orient-right datepicker-orient-left'
			);

			if (this.o.orientation.x !== 'auto'){
				this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
				if (this.o.orientation.x === 'right')
					left -= calendarWidth - width;
			}
			// auto x orientation is best-placement: if it crosses a window
			// edge, fudge it sideways
			else {
				if (offset.left < 0) {
					// component is outside the window on the left side. Move it into visible range
					this.picker.addClass('datepicker-orient-left');
					left -= offset.left - visualPadding;
				} else if (left + calendarWidth > windowWidth) {
					// the calendar passes the widow right edge. Align it to component right side
					this.picker.addClass('datepicker-orient-right');
					left += width - calendarWidth;
				} else {
					if (this.o.rtl) {
						// Default to right
						this.picker.addClass('datepicker-orient-right');
					} else {
						// Default to left
						this.picker.addClass('datepicker-orient-left');
					}
				}
			}

			// auto y orientation is best-situation: top or bottom, no fudging,
			// decision based on which shows more of the calendar
			var yorient = this.o.orientation.y,
				top_overflow;
			if (yorient === 'auto'){
				top_overflow = -scrollTop + top - calendarHeight;
				yorient = top_overflow < 0 ? 'bottom' : 'top';
			}

			this.picker.addClass('datepicker-orient-' + yorient);
			if (yorient === 'top')
				top -= calendarHeight + parseInt(this.picker.css('padding-top'));
			else
				top += height;

			if (this.o.rtl) {
				var right = windowWidth - (left + width);
				this.picker.css({
					top: top,
					right: right,
					zIndex: zIndex
				});
			} else {
				this.picker.css({
					top: top,
					left: left,
					zIndex: zIndex
				});
			}
			return this;
		},

		_allow_update: true,
		update: function(){
			if (!this._allow_update)
				return this;

			var oldDates = this.dates.copy(),
				dates = [],
				fromArgs = false;
			if (arguments.length){
				$.each(arguments, $.proxy(function(i, date){
					if (date instanceof Date)
						date = this._local_to_utc(date);
					dates.push(date);
				}, this));
				fromArgs = true;
			} else {
				dates = this.isInput
						? this.element.val()
						: this.element.data('date') || this.inputField.val();
				if (dates && this.o.multidate)
					dates = dates.split(this.o.multidateSeparator);
				else
					dates = [dates];
				delete this.element.data().date;
			}

			dates = $.map(dates, $.proxy(function(date){
				return DPGlobal.parseDate(date, this.o.format, this.o.language, this.o.assumeNearbyYear);
			}, this));
			dates = $.grep(dates, $.proxy(function(date){
				return (
					!this.dateWithinRange(date) ||
					!date
				);
			}, this), true);
			this.dates.replace(dates);

			if (this.o.updateViewDate) {
				if (this.dates.length)
					this.viewDate = new Date(this.dates.get(-1));
				else if (this.viewDate < this.o.startDate)
					this.viewDate = new Date(this.o.startDate);
				else if (this.viewDate > this.o.endDate)
					this.viewDate = new Date(this.o.endDate);
				else
					this.viewDate = this.o.defaultViewDate;
			}

			if (fromArgs){
				// setting date by clicking
				this.setValue();
				this.element.change();
			}
			else if (this.dates.length){
				// setting date by typing
				if (String(oldDates) !== String(this.dates) && fromArgs) {
					this._trigger('changeDate');
					this.element.change();
				}
			}
			if (!this.dates.length && oldDates.length) {
				this._trigger('clearDate');
				this.element.change();
			}

			this.fill();
			return this;
		},

		fillDow: function(){
      if (this.o.showWeekDays) {
			var dowCnt = this.o.weekStart,
				html = '<tr>';
			if (this.o.calendarWeeks){
				html += '<th class="cw">&#160;</th>';
			}
			while (dowCnt < this.o.weekStart + 7){
				html += '<th class="dow';
        if ($.inArray(dowCnt, this.o.daysOfWeekDisabled) !== -1)
          html += ' disabled';
        html += '">'+dates[this.o.language].daysMin[(dowCnt++)%7]+'</th>';
			}
			html += '</tr>';
			this.picker.find('.datepicker-days thead').append(html);
      }
		},

		fillMonths: function(){
      var localDate = this._utc_to_local(this.viewDate);
			var html = '';
			var focused;
			for (var i = 0; i < 12; i++){
				focused = localDate && localDate.getMonth() === i ? ' focused' : '';
				html += '<span class="month' + focused + '">' + dates[this.o.language].monthsShort[i] + '</span>';
			}
			this.picker.find('.datepicker-months td').html(html);
		},

		setRange: function(range){
			if (!range || !range.length)
				delete this.range;
			else
				this.range = $.map(range, function(d){
					return d.valueOf();
				});
			this.fill();
		},

		getClassNames: function(date){
			var cls = [],
				year = this.viewDate.getUTCFullYear(),
				month = this.viewDate.getUTCMonth(),
				today = UTCToday();
			if (date.getUTCFullYear() < year || (date.getUTCFullYear() === year && date.getUTCMonth() < month)){
				cls.push('old');
			} else if (date.getUTCFullYear() > year || (date.getUTCFullYear() === year && date.getUTCMonth() > month)){
				cls.push('new');
			}
			if (this.focusDate && date.valueOf() === this.focusDate.valueOf())
				cls.push('focused');
			// Compare internal UTC date with UTC today, not local today
			if (this.o.todayHighlight && isUTCEquals(date, today)) {
				cls.push('today');
			}
			if (this.dates.contains(date) !== -1)
				cls.push('active');
			if (!this.dateWithinRange(date)){
				cls.push('disabled');
			}
			if (this.dateIsDisabled(date)){
				cls.push('disabled', 'disabled-date');
			}
			if ($.inArray(date.getUTCDay(), this.o.daysOfWeekHighlighted) !== -1){
				cls.push('highlighted');
			}

			if (this.range){
				if (date > this.range[0] && date < this.range[this.range.length-1]){
					cls.push('range');
				}
				if ($.inArray(date.valueOf(), this.range) !== -1){
					cls.push('selected');
				}
				if (date.valueOf() === this.range[0]){
          cls.push('range-start');
        }
        if (date.valueOf() === this.range[this.range.length-1]){
          cls.push('range-end');
        }
			}
			return cls;
		},

		_fill_yearsView: function(selector, cssClass, factor, year, startYear, endYear, beforeFn){
			var html = '';
			var step = factor / 10;
			var view = this.picker.find(selector);
			var startVal = Math.floor(year / factor) * factor;
			var endVal = startVal + step * 9;
			var focusedVal = Math.floor(this.viewDate.getFullYear() / step) * step;
			var selected = $.map(this.dates, function(d){
				return Math.floor(d.getUTCFullYear() / step) * step;
			});

			var classes, tooltip, before;
			for (var currVal = startVal - step; currVal <= endVal + step; currVal += step) {
				classes = [cssClass];
				tooltip = null;

				if (currVal === startVal - step) {
					classes.push('old');
				} else if (currVal === endVal + step) {
					classes.push('new');
				}
				if ($.inArray(currVal, selected) !== -1) {
					classes.push('active');
				}
				if (currVal < startYear || currVal > endYear) {
					classes.push('disabled');
				}
				if (currVal === focusedVal) {
				  classes.push('focused');
        }

				if (beforeFn !== $.noop) {
					before = beforeFn(new Date(currVal, 0, 1));
					if (before === undefined) {
						before = {};
					} else if (typeof before === 'boolean') {
						before = {enabled: before};
					} else if (typeof before === 'string') {
						before = {classes: before};
					}
					if (before.enabled === false) {
						classes.push('disabled');
					}
					if (before.classes) {
						classes = classes.concat(before.classes.split(/\s+/));
					}
					if (before.tooltip) {
						tooltip = before.tooltip;
					}
				}

				html += '<span class="' + classes.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + currVal + '</span>';
			}

			view.find('.datepicker-switch').text(startVal + '-' + endVal);
			view.find('td').html(html);
		},

		fill: function(){
			var d = new Date(this.viewDate),
				year = d.getUTCFullYear(),
				month = d.getUTCMonth(),
				startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
				startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
				endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
				endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
				todaytxt = dates[this.o.language].today || dates['en'].today || '',
				cleartxt = dates[this.o.language].clear || dates['en'].clear || '',
        titleFormat = dates[this.o.language].titleFormat || dates['en'].titleFormat,
        todayDate = UTCToday(),
        titleBtnVisible = (this.o.todayBtn === true || this.o.todayBtn === 'linked') && todayDate >= this.o.startDate && todayDate <= this.o.endDate && !this.weekOfDateIsDisabled(todayDate),
				tooltip,
				before;
			if (isNaN(year) || isNaN(month))
				return;
			this.picker.find('.datepicker-days .datepicker-switch')
						.text(DPGlobal.formatDate(d, titleFormat, this.o.language));
			this.picker.find('tfoot .today')
						.text(todaytxt)
            .css('display', titleBtnVisible ? 'table-cell' : 'none');
			this.picker.find('tfoot .clear')
						.text(cleartxt)
						.css('display', this.o.clearBtn === true ? 'table-cell' : 'none');
			this.picker.find('thead .datepicker-title')
						.text(this.o.title)
						.css('display', typeof this.o.title === 'string' && this.o.title !== '' ? 'table-cell' : 'none');
			this.updateNavArrows();
			this.fillMonths();
			var prevMonth = UTCDate(year, month, 0),
				day = prevMonth.getUTCDate();
			prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7)%7);
			var nextMonth = new Date(prevMonth);
			if (prevMonth.getUTCFullYear() < 100){
        nextMonth.setUTCFullYear(prevMonth.getUTCFullYear());
      }
			nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
			nextMonth = nextMonth.valueOf();
			var html = [];
			var weekDay, clsName;
			while (prevMonth.valueOf() < nextMonth){
				weekDay = prevMonth.getUTCDay();
				if (weekDay === this.o.weekStart){
					html.push('<tr>');
					if (this.o.calendarWeeks){
						// ISO 8601: First week contains first thursday.
						// ISO also states week starts on Monday, but we can be more abstract here.
						var
							// Start of current week: based on weekstart/current date
							ws = new Date(+prevMonth + (this.o.weekStart - weekDay - 7) % 7 * 864e5),
							// Thursday of this week
							th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 864e5),
							// First Thursday of year, year from thursday
							yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay()) % 7 * 864e5),
							// Calendar week: ms between thursdays, div ms per day, div 7 days
							calWeek = (th - yth) / 864e5 / 7 + 1;
						html.push('<td class="cw">'+ calWeek +'</td>');
					}
				}
				clsName = this.getClassNames(prevMonth);
				clsName.push('day');

				var content = prevMonth.getUTCDate();

				if (this.o.beforeShowDay !== $.noop){
					before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
					if (before === undefined)
						before = {};
					else if (typeof before === 'boolean')
						before = {enabled: before};
					else if (typeof before === 'string')
						before = {classes: before};
					if (before.enabled === false)
						clsName.push('disabled');
					if (before.classes)
						clsName = clsName.concat(before.classes.split(/\s+/));
					if (before.tooltip)
						tooltip = before.tooltip;
					if (before.content)
						content = before.content;
				}

				//Check if uniqueSort exists (supported by jquery >=1.12 and >=2.2)
				//Fallback to unique function for older jquery versions
				if ($.isFunction($.uniqueSort)) {
					clsName = $.uniqueSort(clsName);
				} else {
					clsName = $.unique(clsName);
				}

				html.push('<td class="'+clsName.join(' ')+'"' + (tooltip ? ' title="'+tooltip+'"' : '') + ' data-date="' + prevMonth.getTime().toString() + '">' + content + '</td>');
				tooltip = null;
				if (weekDay === this.o.weekEnd){
					html.push('</tr>');
				}
				prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
			}
			this.picker.find('.datepicker-days tbody').html(html.join(''));

			var monthsTitle = dates[this.o.language].monthsTitle || dates['en'].monthsTitle || 'Months';
			var months = this.picker.find('.datepicker-months')
						.find('.datepicker-switch')
							.text(this.o.maxViewMode < 2 ? monthsTitle : year)
							.end()
						.find('tbody span').removeClass('active');

			$.each(this.dates, function(i, d){
				if (d.getUTCFullYear() === year)
					months.eq(d.getUTCMonth()).addClass('active');
			});

			if (year < startYear || year > endYear){
				months.addClass('disabled');
			}
			if (year === startYear){
				months.slice(0, startMonth).addClass('disabled');
			}
			if (year === endYear){
				months.slice(endMonth+1).addClass('disabled');
			}

			if (this.o.beforeShowMonth !== $.noop){
				var that = this;
				$.each(months, function(i, month){
          var moDate = new Date(year, i, 1);
          var before = that.o.beforeShowMonth(moDate);
					if (before === undefined)
						before = {};
					else if (typeof before === 'boolean')
						before = {enabled: before};
					else if (typeof before === 'string')
						before = {classes: before};
					if (before.enabled === false && !$(month).hasClass('disabled'))
					    $(month).addClass('disabled');
					if (before.classes)
					    $(month).addClass(before.classes);
					if (before.tooltip)
					    $(month).prop('title', before.tooltip);
				});
			}

			// Generating decade/years picker
			this._fill_yearsView(
				'.datepicker-years',
				'year',
				10,
				year,
				startYear,
				endYear,
				this.o.beforeShowYear
			);

			// Generating century/decades picker
			this._fill_yearsView(
				'.datepicker-decades',
				'decade',
				100,
				year,
				startYear,
				endYear,
				this.o.beforeShowDecade
			);

			// Generating millennium/centuries picker
			this._fill_yearsView(
				'.datepicker-centuries',
				'century',
				1000,
				year,
				startYear,
				endYear,
				this.o.beforeShowCentury
			);
		},

		updateNavArrows: function(){
			if (!this._allow_update)
				return;

			var d = new Date(this.viewDate),
				year = d.getUTCFullYear(),
				month = d.getUTCMonth(),
				startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
				startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
				endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
				endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
				prevIsDisabled,
				nextIsDisabled,
				factor = 1;
			switch (this.viewMode){
				case 4:
					factor *= 10;
					/* falls through */
				case 3:
					factor *= 10;
					/* falls through */
				case 2:
					factor *= 10;
					/* falls through */
				case 1:
					prevIsDisabled = Math.floor(year / factor) * factor <= startYear;
					nextIsDisabled = Math.floor(year / factor) * factor + factor > endYear;
					break;
				case 0:
					prevIsDisabled = year <= startYear && month <= startMonth;
					nextIsDisabled = year >= endYear && month >= endMonth;
					break;
			}

			this.picker.find('.prev').toggleClass('disabled', prevIsDisabled);
			this.picker.find('.next').toggleClass('disabled', nextIsDisabled);
		},

		click: function(e){
			e.preventDefault();
			e.stopPropagation();

			var target, dir, day, year, month;
			target = $(e.target);

			// Clicked on the switch
			if (target.hasClass('datepicker-switch') && this.viewMode !== this.o.maxViewMode){
				this.setViewMode(this.viewMode + 1);
			}

			// Clicked on today button
			if (target.hasClass('today') && !target.hasClass('day')){
				this.setViewMode(0);
				this._setDate(UTCToday(), this.o.todayBtn === 'linked' ? null : 'view');
			}

			// Clicked on clear button
			if (target.hasClass('clear')){
				this.clearDates();
			}

			if (!target.hasClass('disabled')){
				// Clicked on a month, year, decade, century
				if (target.hasClass('month')
						|| target.hasClass('year')
						|| target.hasClass('decade')
						|| target.hasClass('century')) {
					this.viewDate.setUTCDate(1);

					day = 1;
					if (this.viewMode === 1){
						month = target.parent().find('span').index(target);
						year = this.viewDate.getUTCFullYear();
						this.viewDate.setUTCMonth(month);
					} else {
						month = 0;
						year = Number(target.text());
						this.viewDate.setUTCFullYear(year);
					}

					this._trigger(DPGlobal.viewModes[this.viewMode - 1].e, this.viewDate);

					if (this.viewMode === this.o.minViewMode){
						this._setDate(UTCDate(year, month, day));
					} else {
						this.setViewMode(this.viewMode - 1);
						this.fill();
					}
				}
			}

			if (this.picker.is(':visible') && this._focused_from){
				this._focused_from.focus();
			}
			delete this._focused_from;
		},

		dayCellClick: function(e){
			var $target = $(e.currentTarget);
			var timestamp = $target.data('date');
			var date = new Date(timestamp);

			if (this.o.updateViewDate) {
				if (date.getUTCFullYear() !== this.viewDate.getUTCFullYear()) {
					this._trigger('changeYear', this.viewDate);
				}

				if (date.getUTCMonth() !== this.viewDate.getUTCMonth()) {
					this._trigger('changeMonth', this.viewDate);
				}
			}
			this._setDate(date);
		},

		// Clicked on prev or next
		navArrowsClick: function(e){
			var $target = $(e.currentTarget);
			var dir = $target.hasClass('prev') ? -1 : 1;
			if (this.viewMode !== 0){
				dir *= DPGlobal.viewModes[this.viewMode].navStep * 12;
			}
			this.viewDate = this.moveMonth(this.viewDate, dir);
			this._trigger(DPGlobal.viewModes[this.viewMode].e, this.viewDate);
			this.fill();
		},

		_toggle_multidate: function(date){
			var ix = this.dates.contains(date);
			if (!date){
				this.dates.clear();
			}

			if (ix !== -1){
				if (this.o.multidate === true || this.o.multidate > 1 || this.o.toggleActive){
					this.dates.remove(ix);
				}
			} else if (this.o.multidate === false) {
				this.dates.clear();
				this.dates.push(date);
			}
			else {
				this.dates.push(date);
			}

			if (typeof this.o.multidate === 'number')
				while (this.dates.length > this.o.multidate)
					this.dates.remove(0);
		},

		_setDate: function(date, which){
			if (!which || which === 'date')
				this._toggle_multidate(date && new Date(date));
			if ((!which && this.o.updateViewDate) || which === 'view')
				this.viewDate = date && new Date(date);

			this.fill();
			this.setValue();
			if (!which || which !== 'view') {
				this._trigger('changeDate');
			}
			this.inputField.trigger('change');
			if (this.o.autoclose && (!which || which === 'date')){
				this.hide();
			}
		},

		moveDay: function(date, dir){
			var newDate = new Date(date);
			newDate.setUTCDate(date.getUTCDate() + dir);

			return newDate;
		},

		moveWeek: function(date, dir){
			return this.moveDay(date, dir * 7);
		},

		moveMonth: function(date, dir){
			if (!isValidDate(date))
				return this.o.defaultViewDate;
			if (!dir)
				return date;
			var new_date = new Date(date.valueOf()),
				day = new_date.getUTCDate(),
				month = new_date.getUTCMonth(),
				mag = Math.abs(dir),
				new_month, test;
			dir = dir > 0 ? 1 : -1;
			if (mag === 1){
				test = dir === -1
					// If going back one month, make sure month is not current month
					// (eg, Mar 31 -> Feb 31 == Feb 28, not Mar 02)
					? function(){
						return new_date.getUTCMonth() === month;
					}
					// If going forward one month, make sure month is as expected
					// (eg, Jan 31 -> Feb 31 == Feb 28, not Mar 02)
					: function(){
						return new_date.getUTCMonth() !== new_month;
					};
				new_month = month + dir;
				new_date.setUTCMonth(new_month);
				// Dec -> Jan (12) or Jan -> Dec (-1) -- limit expected date to 0-11
				new_month = (new_month + 12) % 12;
			}
			else {
				// For magnitudes >1, move one month at a time...
				for (var i=0; i < mag; i++)
					// ...which might decrease the day (eg, Jan 31 to Feb 28, etc)...
					new_date = this.moveMonth(new_date, dir);
				// ...then reset the day, keeping it in the new month
				new_month = new_date.getUTCMonth();
				new_date.setUTCDate(day);
				test = function(){
					return new_month !== new_date.getUTCMonth();
				};
			}
			// Common date-resetting loop -- if date is beyond end of month, make it
			// end of month
			while (test()){
				new_date.setUTCDate(--day);
				new_date.setUTCMonth(new_month);
			}
			return new_date;
		},

		moveYear: function(date, dir){
			return this.moveMonth(date, dir*12);
		},

		moveAvailableDate: function(date, dir, fn){
			do {
				date = this[fn](date, dir);

				if (!this.dateWithinRange(date))
					return false;

				fn = 'moveDay';
			}
			while (this.dateIsDisabled(date));

			return date;
		},

		weekOfDateIsDisabled: function(date){
			return $.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1;
		},

		dateIsDisabled: function(date){
			return (
				this.weekOfDateIsDisabled(date) ||
				$.grep(this.o.datesDisabled, function(d){
					return isUTCEquals(date, d);
				}).length > 0
			);
		},

		dateWithinRange: function(date){
			return date >= this.o.startDate && date <= this.o.endDate;
		},

		keydown: function(e){
			if (!this.picker.is(':visible')){
				if (e.keyCode === 40 || e.keyCode === 27) { // allow down to re-show picker
					this.show();
					e.stopPropagation();
        }
				return;
			}
			var dateChanged = false,
				dir, newViewDate,
				focusDate = this.focusDate || this.viewDate;
			switch (e.keyCode){
				case 27: // escape
					if (this.focusDate){
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.fill();
					}
					else
						this.hide();
					e.preventDefault();
					e.stopPropagation();
					break;
				case 37: // left
				case 38: // up
				case 39: // right
				case 40: // down
					if (!this.o.keyboardNavigation || this.o.daysOfWeekDisabled.length === 7)
						break;
					dir = e.keyCode === 37 || e.keyCode === 38 ? -1 : 1;
          if (this.viewMode === 0) {
  					if (e.ctrlKey){
  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');

  						if (newViewDate)
  							this._trigger('changeYear', this.viewDate);
  					} else if (e.shiftKey){
  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');

  						if (newViewDate)
  							this._trigger('changeMonth', this.viewDate);
  					} else if (e.keyCode === 37 || e.keyCode === 39){
  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveDay');
  					} else if (!this.weekOfDateIsDisabled(focusDate)){
  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveWeek');
  					}
          } else if (this.viewMode === 1) {
            if (e.keyCode === 38 || e.keyCode === 40) {
              dir = dir * 4;
            }
            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
          } else if (this.viewMode === 2) {
            if (e.keyCode === 38 || e.keyCode === 40) {
              dir = dir * 4;
            }
            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
          }
					if (newViewDate){
						this.focusDate = this.viewDate = newViewDate;
						this.setValue();
						this.fill();
						e.preventDefault();
					}
					break;
				case 13: // enter
					if (!this.o.forceParse)
						break;
					focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
					if (this.o.keyboardNavigation) {
						this._toggle_multidate(focusDate);
						dateChanged = true;
					}
					this.focusDate = null;
					this.viewDate = this.dates.get(-1) || this.viewDate;
					this.setValue();
					this.fill();
					if (this.picker.is(':visible')){
						e.preventDefault();
						e.stopPropagation();
						if (this.o.autoclose)
							this.hide();
					}
					break;
				case 9: // tab
					this.focusDate = null;
					this.viewDate = this.dates.get(-1) || this.viewDate;
					this.fill();
					this.hide();
					break;
			}
			if (dateChanged){
				if (this.dates.length)
					this._trigger('changeDate');
				else
					this._trigger('clearDate');
				this.inputField.trigger('change');
			}
		},

		setViewMode: function(viewMode){
			this.viewMode = viewMode;
			this.picker
				.children('div')
				.hide()
				.filter('.datepicker-' + DPGlobal.viewModes[this.viewMode].clsName)
					.show();
			this.updateNavArrows();
      this._trigger('changeViewMode', new Date(this.viewDate));
		}
	};

	var DateRangePicker = function(element, options){
		$.data(element, 'datepicker', this);
		this.element = $(element);
		this.inputs = $.map(options.inputs, function(i){
			return i.jquery ? i[0] : i;
		});
		delete options.inputs;

		this.keepEmptyValues = options.keepEmptyValues;
		delete options.keepEmptyValues;

		datepickerPlugin.call($(this.inputs), options)
			.on('changeDate', $.proxy(this.dateUpdated, this));

		this.pickers = $.map(this.inputs, function(i){
			return $.data(i, 'datepicker');
		});
		this.updateDates();
	};
	DateRangePicker.prototype = {
		updateDates: function(){
			this.dates = $.map(this.pickers, function(i){
				return i.getUTCDate();
			});
			this.updateRanges();
		},
		updateRanges: function(){
			var range = $.map(this.dates, function(d){
				return d.valueOf();
			});
			$.each(this.pickers, function(i, p){
				p.setRange(range);
			});
		},
		clearDates: function(){
			$.each(this.pickers, function(i, p){
				p.clearDates();
			});
		},
		dateUpdated: function(e){
			// `this.updating` is a workaround for preventing infinite recursion
			// between `changeDate` triggering and `setUTCDate` calling.  Until
			// there is a better mechanism.
			if (this.updating)
				return;
			this.updating = true;

			var dp = $.data(e.target, 'datepicker');

			if (dp === undefined) {
				return;
			}

			var new_date = dp.getUTCDate(),
				keep_empty_values = this.keepEmptyValues,
				i = $.inArray(e.target, this.inputs),
				j = i - 1,
				k = i + 1,
				l = this.inputs.length;
			if (i === -1)
				return;

			$.each(this.pickers, function(i, p){
				if (!p.getUTCDate() && (p === dp || !keep_empty_values))
					p.setUTCDate(new_date);
			});

			if (new_date < this.dates[j]){
				// Date being moved earlier/left
				while (j >= 0 && new_date < this.dates[j]){
					this.pickers[j--].setUTCDate(new_date);
				}
			} else if (new_date > this.dates[k]){
				// Date being moved later/right
				while (k < l && new_date > this.dates[k]){
					this.pickers[k++].setUTCDate(new_date);
				}
			}
			this.updateDates();

			delete this.updating;
		},
		destroy: function(){
			$.map(this.pickers, function(p){ p.destroy(); });
			$(this.inputs).off('changeDate', this.dateUpdated);
			delete this.element.data().datepicker;
		},
		remove: alias('destroy', 'Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead')
	};

	function opts_from_el(el, prefix){
		// Derive options from element data-attrs
		var data = $(el).data(),
			out = {}, inkey,
			replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
		prefix = new RegExp('^' + prefix.toLowerCase());
		function re_lower(_,a){
			return a.toLowerCase();
		}
		for (var key in data)
			if (prefix.test(key)){
				inkey = key.replace(replace, re_lower);
				out[inkey] = data[key];
			}
		return out;
	}

	function opts_from_locale(lang){
		// Derive options from locale plugins
		var out = {};
		// Check if "de-DE" style date is available, if not language should
		// fallback to 2 letter code eg "de"
		if (!dates[lang]){
			lang = lang.split('-')[0];
			if (!dates[lang])
				return;
		}
		var d = dates[lang];
		$.each(locale_opts, function(i,k){
			if (k in d)
				out[k] = d[k];
		});
		return out;
	}

	var old = $.fn.datepicker;
	var datepickerPlugin = function(option){
		var args = Array.apply(null, arguments);
		args.shift();
		var internal_return;
		this.each(function(){
			var $this = $(this),
				data = $this.data('datepicker'),
				options = typeof option === 'object' && option;
			if (!data){
				var elopts = opts_from_el(this, 'date'),
					// Preliminary otions
					xopts = $.extend({}, defaults, elopts, options),
					locopts = opts_from_locale(xopts.language),
					// Options priority: js args, data-attrs, locales, defaults
					opts = $.extend({}, defaults, locopts, elopts, options);
				if ($this.hasClass('input-daterange') || opts.inputs){
					$.extend(opts, {
						inputs: opts.inputs || $this.find('input').toArray()
					});
					data = new DateRangePicker(this, opts);
				}
				else {
					data = new Datepicker(this, opts);
				}
				$this.data('datepicker', data);
			}
			if (typeof option === 'string' && typeof data[option] === 'function'){
				internal_return = data[option].apply(data, args);
			}
		});

		if (
			internal_return === undefined ||
			internal_return instanceof Datepicker ||
			internal_return instanceof DateRangePicker
		)
			return this;

		if (this.length > 1)
			throw new Error('Using only allowed for the collection of a single element (' + option + ' function)');
		else
			return internal_return;
	};
	$.fn.datepicker = datepickerPlugin;

	var defaults = $.fn.datepicker.defaults = {
		assumeNearbyYear: false,
		autoclose: false,
		beforeShowDay: $.noop,
		beforeShowMonth: $.noop,
		beforeShowYear: $.noop,
		beforeShowDecade: $.noop,
		beforeShowCentury: $.noop,
		calendarWeeks: false,
		clearBtn: false,
		toggleActive: false,
		daysOfWeekDisabled: [],
		daysOfWeekHighlighted: [],
		datesDisabled: [],
		endDate: Infinity,
		forceParse: true,
		format: 'mm/dd/yyyy',
		keepEmptyValues: false,
		keyboardNavigation: true,
		language: 'en',
		minViewMode: 0,
		maxViewMode: 4,
		multidate: false,
		multidateSeparator: ',',
		orientation: "auto",
		rtl: false,
		startDate: -Infinity,
		startView: 0,
		todayBtn: false,
		todayHighlight: false,
		updateViewDate: true,
		weekStart: 0,
		disableTouchKeyboard: false,
		enableOnReadonly: true,
		showOnFocus: true,
		zIndexOffset: 10,
		container: 'body',
		immediateUpdates: false,
		title: '',
		templates: {
			leftArrow: '&#x00AB;',
			rightArrow: '&#x00BB;'
		},
    showWeekDays: true
	};
	var locale_opts = $.fn.datepicker.locale_opts = [
		'format',
		'rtl',
		'weekStart'
	];
	$.fn.datepicker.Constructor = Datepicker;
	var dates = $.fn.datepicker.dates = {
		en: {
			days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
			daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
			months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			today: "Today",
			clear: "Clear",
			titleFormat: "MM yyyy"
		}
	};

	var DPGlobal = {
		viewModes: [
			{
				names: ['days', 'month'],
				clsName: 'days',
				e: 'changeMonth'
			},
			{
				names: ['months', 'year'],
				clsName: 'months',
				e: 'changeYear',
				navStep: 1
			},
			{
				names: ['years', 'decade'],
				clsName: 'years',
				e: 'changeDecade',
				navStep: 10
			},
			{
				names: ['decades', 'century'],
				clsName: 'decades',
				e: 'changeCentury',
				navStep: 100
			},
			{
				names: ['centuries', 'millennium'],
				clsName: 'centuries',
				e: 'changeMillennium',
				navStep: 1000
			}
		],
		validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
		nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
		parseFormat: function(format){
			if (typeof format.toValue === 'function' && typeof format.toDisplay === 'function')
                return format;
            // IE treats \0 as a string end in inputs (truncating the value),
			// so it's a bad format delimiter, anyway
			var separators = format.replace(this.validParts, '\0').split('\0'),
				parts = format.match(this.validParts);
			if (!separators || !separators.length || !parts || parts.length === 0){
				throw new Error("Invalid date format.");
			}
			return {separators: separators, parts: parts};
		},
		parseDate: function(date, format, language, assumeNearby){
			if (!date)
				return undefined;
			if (date instanceof Date)
				return date;
			if (typeof format === 'string')
				format = DPGlobal.parseFormat(format);
			if (format.toValue)
				return format.toValue(date, format, language);
			var fn_map = {
					d: 'moveDay',
					m: 'moveMonth',
					w: 'moveWeek',
					y: 'moveYear'
				},
				dateAliases = {
					yesterday: '-1d',
					today: '+0d',
					tomorrow: '+1d'
				},
				parts, part, dir, i, fn;
			if (date in dateAliases){
				date = dateAliases[date];
			}
			if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/i.test(date)){
				parts = date.match(/([\-+]\d+)([dmwy])/gi);
				date = new Date();
				for (i=0; i < parts.length; i++){
					part = parts[i].match(/([\-+]\d+)([dmwy])/i);
					dir = Number(part[1]);
					fn = fn_map[part[2].toLowerCase()];
					date = Datepicker.prototype[fn](date, dir);
				}
				return Datepicker.prototype._zero_utc_time(date);
			}

			parts = date && date.match(this.nonpunctuation) || [];

			function applyNearbyYear(year, threshold){
				if (threshold === true)
					threshold = 10;

				// if year is 2 digits or less, than the user most likely is trying to get a recent century
				if (year < 100){
					year += 2000;
					// if the new year is more than threshold years in advance, use last century
					if (year > ((new Date()).getFullYear()+threshold)){
						year -= 100;
					}
				}

				return year;
			}

			var parsed = {},
				setters_order = ['yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
				setters_map = {
					yyyy: function(d,v){
						return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
					},
					m: function(d,v){
						if (isNaN(d))
							return d;
						v -= 1;
						while (v < 0) v += 12;
						v %= 12;
						d.setUTCMonth(v);
						while (d.getUTCMonth() !== v)
							d.setUTCDate(d.getUTCDate()-1);
						return d;
					},
					d: function(d,v){
						return d.setUTCDate(v);
					}
				},
				val, filtered;
			setters_map['yy'] = setters_map['yyyy'];
			setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
			setters_map['dd'] = setters_map['d'];
			date = UTCToday();
			var fparts = format.parts.slice();
			// Remove noop parts
			if (parts.length !== fparts.length){
				fparts = $(fparts).filter(function(i,p){
					return $.inArray(p, setters_order) !== -1;
				}).toArray();
			}
			// Process remainder
			function match_part(){
				var m = this.slice(0, parts[i].length),
					p = parts[i].slice(0, m.length);
				return m.toLowerCase() === p.toLowerCase();
			}
			if (parts.length === fparts.length){
				var cnt;
				for (i=0, cnt = fparts.length; i < cnt; i++){
					val = parseInt(parts[i], 10);
					part = fparts[i];
					if (isNaN(val)){
						switch (part){
							case 'MM':
								filtered = $(dates[language].months).filter(match_part);
								val = $.inArray(filtered[0], dates[language].months) + 1;
								break;
							case 'M':
								filtered = $(dates[language].monthsShort).filter(match_part);
								val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
								break;
						}
					}
					parsed[part] = val;
				}
				var _date, s;
				for (i=0; i < setters_order.length; i++){
					s = setters_order[i];
					if (s in parsed && !isNaN(parsed[s])){
						_date = new Date(date);
						setters_map[s](_date, parsed[s]);
						if (!isNaN(_date))
							date = _date;
					}
				}
			}
			return date;
		},
		formatDate: function(date, format, language){
			if (!date)
				return '';
			if (typeof format === 'string')
				format = DPGlobal.parseFormat(format);
			if (format.toDisplay)
                return format.toDisplay(date, format, language);
            var val = {
				d: date.getUTCDate(),
				D: dates[language].daysShort[date.getUTCDay()],
				DD: dates[language].days[date.getUTCDay()],
				m: date.getUTCMonth() + 1,
				M: dates[language].monthsShort[date.getUTCMonth()],
				MM: dates[language].months[date.getUTCMonth()],
				yy: date.getUTCFullYear().toString().substring(2),
				yyyy: date.getUTCFullYear()
			};
			val.dd = (val.d < 10 ? '0' : '') + val.d;
			val.mm = (val.m < 10 ? '0' : '') + val.m;
			date = [];
			var seps = $.extend([], format.separators);
			for (var i=0, cnt = format.parts.length; i <= cnt; i++){
				if (seps.length)
					date.push(seps.shift());
				date.push(val[format.parts[i]]);
			}
			return date.join('');
		},
		headTemplate: '<thead>'+
			              '<tr>'+
			                '<th colspan="7" class="datepicker-title"></th>'+
			              '</tr>'+
							'<tr>'+
								'<th class="prev">'+defaults.templates.leftArrow+'</th>'+
								'<th colspan="5" class="datepicker-switch"></th>'+
								'<th class="next">'+defaults.templates.rightArrow+'</th>'+
							'</tr>'+
						'</thead>',
		contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
		footTemplate: '<tfoot>'+
							'<tr>'+
								'<th colspan="7" class="today"></th>'+
							'</tr>'+
							'<tr>'+
								'<th colspan="7" class="clear"></th>'+
							'</tr>'+
						'</tfoot>'
	};
	DPGlobal.template = '<div class="datepicker">'+
							'<div class="datepicker-days">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									'<tbody></tbody>'+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
							'<div class="datepicker-months">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									DPGlobal.contTemplate+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
							'<div class="datepicker-years">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									DPGlobal.contTemplate+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
							'<div class="datepicker-decades">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									DPGlobal.contTemplate+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
							'<div class="datepicker-centuries">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									DPGlobal.contTemplate+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
						'</div>';

	$.fn.datepicker.DPGlobal = DPGlobal;


	/* DATEPICKER NO CONFLICT
	* =================== */

	$.fn.datepicker.noConflict = function(){
		$.fn.datepicker = old;
		return this;
	};

	/* DATEPICKER VERSION
	 * =================== */
	$.fn.datepicker.version = '1.9.0';

	$.fn.datepicker.deprecated = function(msg){
		var console = window.console;
		if (console && console.warn) {
			console.warn('DEPRECATED: ' + msg);
		}
	};


	/* DATEPICKER DATA-API
	* ================== */

	$(document).on(
		'focus.datepicker.data-api click.datepicker.data-api',
		'[data-provide="datepicker"]',
		function(e){
			var $this = $(this);
			if ($this.data('datepicker'))
				return;
			e.preventDefault();
			// component click requires us to explicitly show it
			datepickerPlugin.call($this, 'show');
		}
	);
	$(function(){
		datepickerPlugin.call($('[data-provide="datepicker-inline"]'));
	});

}));


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Chart.js v2.8.0
 * https://www.chartjs.org
 * (c) 2019 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(7); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

/* MIT license */

var conversions = {
  rgb2hsl: rgb2hsl,
  rgb2hsv: rgb2hsv,
  rgb2hwb: rgb2hwb,
  rgb2cmyk: rgb2cmyk,
  rgb2keyword: rgb2keyword,
  rgb2xyz: rgb2xyz,
  rgb2lab: rgb2lab,
  rgb2lch: rgb2lch,

  hsl2rgb: hsl2rgb,
  hsl2hsv: hsl2hsv,
  hsl2hwb: hsl2hwb,
  hsl2cmyk: hsl2cmyk,
  hsl2keyword: hsl2keyword,

  hsv2rgb: hsv2rgb,
  hsv2hsl: hsv2hsl,
  hsv2hwb: hsv2hwb,
  hsv2cmyk: hsv2cmyk,
  hsv2keyword: hsv2keyword,

  hwb2rgb: hwb2rgb,
  hwb2hsl: hwb2hsl,
  hwb2hsv: hwb2hsv,
  hwb2cmyk: hwb2cmyk,
  hwb2keyword: hwb2keyword,

  cmyk2rgb: cmyk2rgb,
  cmyk2hsl: cmyk2hsl,
  cmyk2hsv: cmyk2hsv,
  cmyk2hwb: cmyk2hwb,
  cmyk2keyword: cmyk2keyword,

  keyword2rgb: keyword2rgb,
  keyword2hsl: keyword2hsl,
  keyword2hsv: keyword2hsv,
  keyword2hwb: keyword2hwb,
  keyword2cmyk: keyword2cmyk,
  keyword2lab: keyword2lab,
  keyword2xyz: keyword2xyz,

  xyz2rgb: xyz2rgb,
  xyz2lab: xyz2lab,
  xyz2lch: xyz2lch,

  lab2xyz: lab2xyz,
  lab2rgb: lab2rgb,
  lab2lch: lab2lch,

  lch2lab: lch2lab,
  lch2xyz: lch2xyz,
  lch2rgb: lch2rgb
};


function rgb2hsl(rgb) {
  var r = rgb[0]/255,
      g = rgb[1]/255,
      b = rgb[2]/255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, l;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g)/ delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  l = (min + max) / 2;

  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);

  return [h, s * 100, l * 100];
}

function rgb2hsv(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, v;

  if (max == 0)
    s = 0;
  else
    s = (delta/max * 1000)/10;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  v = ((max / 255) * 1000) / 10;

  return [h, s, v];
}

function rgb2hwb(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      h = rgb2hsl(rgb)[0],
      w = 1/255 * Math.min(r, Math.min(g, b)),
      b = 1 - 1/255 * Math.max(r, Math.max(g, b));

  return [h, w * 100, b * 100];
}

function rgb2cmyk(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255,
      c, m, y, k;

  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k) || 0;
  m = (1 - g - k) / (1 - k) || 0;
  y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
}

function rgb2keyword(rgb) {
  return reverseKeywords[JSON.stringify(rgb)];
}

function rgb2xyz(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  // assume sRGB
  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

  return [x * 100, y *100, z * 100];
}

function rgb2lab(rgb) {
  var xyz = rgb2xyz(rgb),
        x = xyz[0],
        y = xyz[1],
        z = xyz[2],
        l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function rgb2lch(args) {
  return lab2lch(rgb2lab(args));
}

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

function hsl2hsv(hsl) {
  var h = hsl[0],
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      sv, v;

  if(l === 0) {
      // no need to do calc on black
      // also avoids divide by 0 error
      return [0, 0, 0];
  }

  l *= 2;
  s *= (l <= 1) ? l : 2 - l;
  v = (l + s) / 2;
  sv = (2 * s) / (l + s);
  return [h, sv * 100, v * 100];
}

function hsl2hwb(args) {
  return rgb2hwb(hsl2rgb(args));
}

function hsl2cmyk(args) {
  return rgb2cmyk(hsl2rgb(args));
}

function hsl2keyword(args) {
  return rgb2keyword(hsl2rgb(args));
}


function hsv2rgb(hsv) {
  var h = hsv[0] / 60,
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      hi = Math.floor(h) % 6;

  var f = h - Math.floor(h),
      p = 255 * v * (1 - s),
      q = 255 * v * (1 - (s * f)),
      t = 255 * v * (1 - (s * (1 - f))),
      v = 255 * v;

  switch(hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
}

function hsv2hsl(hsv) {
  var h = hsv[0],
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      sl, l;

  l = (2 - s) * v;
  sl = s * v;
  sl /= (l <= 1) ? l : 2 - l;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
}

function hsv2hwb(args) {
  return rgb2hwb(hsv2rgb(args))
}

function hsv2cmyk(args) {
  return rgb2cmyk(hsv2rgb(args));
}

function hsv2keyword(args) {
  return rgb2keyword(hsv2rgb(args));
}

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
function hwb2rgb(hwb) {
  var h = hwb[0] / 360,
      wh = hwb[1] / 100,
      bl = hwb[2] / 100,
      ratio = wh + bl,
      i, v, f, n;

  // wh + bl cant be > 1
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }

  i = Math.floor(6 * h);
  v = 1 - bl;
  f = 6 * h - i;
  if ((i & 0x01) != 0) {
    f = 1 - f;
  }
  n = wh + f * (v - wh);  // linear interpolation

  switch (i) {
    default:
    case 6:
    case 0: r = v; g = n; b = wh; break;
    case 1: r = n; g = v; b = wh; break;
    case 2: r = wh; g = v; b = n; break;
    case 3: r = wh; g = n; b = v; break;
    case 4: r = n; g = wh; b = v; break;
    case 5: r = v; g = wh; b = n; break;
  }

  return [r * 255, g * 255, b * 255];
}

function hwb2hsl(args) {
  return rgb2hsl(hwb2rgb(args));
}

function hwb2hsv(args) {
  return rgb2hsv(hwb2rgb(args));
}

function hwb2cmyk(args) {
  return rgb2cmyk(hwb2rgb(args));
}

function hwb2keyword(args) {
  return rgb2keyword(hwb2rgb(args));
}

function cmyk2rgb(cmyk) {
  var c = cmyk[0] / 100,
      m = cmyk[1] / 100,
      y = cmyk[2] / 100,
      k = cmyk[3] / 100,
      r, g, b;

  r = 1 - Math.min(1, c * (1 - k) + k);
  g = 1 - Math.min(1, m * (1 - k) + k);
  b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
}

function cmyk2hsl(args) {
  return rgb2hsl(cmyk2rgb(args));
}

function cmyk2hsv(args) {
  return rgb2hsv(cmyk2rgb(args));
}

function cmyk2hwb(args) {
  return rgb2hwb(cmyk2rgb(args));
}

function cmyk2keyword(args) {
  return rgb2keyword(cmyk2rgb(args));
}


function xyz2rgb(xyz) {
  var x = xyz[0] / 100,
      y = xyz[1] / 100,
      z = xyz[2] / 100,
      r, g, b;

  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

  // assume sRGB
  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
    : r = (r * 12.92);

  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
    : g = (g * 12.92);

  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
    : b = (b * 12.92);

  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);

  return [r * 255, g * 255, b * 255];
}

function xyz2lab(xyz) {
  var x = xyz[0],
      y = xyz[1],
      z = xyz[2],
      l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function xyz2lch(args) {
  return lab2lch(xyz2lab(args));
}

function lab2xyz(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      x, y, z, y2;

  if (l <= 8) {
    y = (l * 100) / 903.3;
    y2 = (7.787 * (y / 100)) + (16 / 116);
  } else {
    y = 100 * Math.pow((l + 16) / 116, 3);
    y2 = Math.pow(y / 100, 1/3);
  }

  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);

  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);

  return [x, y, z];
}

function lab2lch(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      hr, h, c;

  hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  c = Math.sqrt(a * a + b * b);
  return [l, c, h];
}

function lab2rgb(args) {
  return xyz2rgb(lab2xyz(args));
}

function lch2lab(lch) {
  var l = lch[0],
      c = lch[1],
      h = lch[2],
      a, b, hr;

  hr = h / 360 * 2 * Math.PI;
  a = c * Math.cos(hr);
  b = c * Math.sin(hr);
  return [l, a, b];
}

function lch2xyz(args) {
  return lab2xyz(lch2lab(args));
}

function lch2rgb(args) {
  return lab2rgb(lch2lab(args));
}

function keyword2rgb(keyword) {
  return cssKeywords[keyword];
}

function keyword2hsl(args) {
  return rgb2hsl(keyword2rgb(args));
}

function keyword2hsv(args) {
  return rgb2hsv(keyword2rgb(args));
}

function keyword2hwb(args) {
  return rgb2hwb(keyword2rgb(args));
}

function keyword2cmyk(args) {
  return rgb2cmyk(keyword2rgb(args));
}

function keyword2lab(args) {
  return rgb2lab(keyword2rgb(args));
}

function keyword2xyz(args) {
  return rgb2xyz(keyword2rgb(args));
}

var cssKeywords = {
  aliceblue:  [240,248,255],
  antiquewhite: [250,235,215],
  aqua: [0,255,255],
  aquamarine: [127,255,212],
  azure:  [240,255,255],
  beige:  [245,245,220],
  bisque: [255,228,196],
  black:  [0,0,0],
  blanchedalmond: [255,235,205],
  blue: [0,0,255],
  blueviolet: [138,43,226],
  brown:  [165,42,42],
  burlywood:  [222,184,135],
  cadetblue:  [95,158,160],
  chartreuse: [127,255,0],
  chocolate:  [210,105,30],
  coral:  [255,127,80],
  cornflowerblue: [100,149,237],
  cornsilk: [255,248,220],
  crimson:  [220,20,60],
  cyan: [0,255,255],
  darkblue: [0,0,139],
  darkcyan: [0,139,139],
  darkgoldenrod:  [184,134,11],
  darkgray: [169,169,169],
  darkgreen:  [0,100,0],
  darkgrey: [169,169,169],
  darkkhaki:  [189,183,107],
  darkmagenta:  [139,0,139],
  darkolivegreen: [85,107,47],
  darkorange: [255,140,0],
  darkorchid: [153,50,204],
  darkred:  [139,0,0],
  darksalmon: [233,150,122],
  darkseagreen: [143,188,143],
  darkslateblue:  [72,61,139],
  darkslategray:  [47,79,79],
  darkslategrey:  [47,79,79],
  darkturquoise:  [0,206,209],
  darkviolet: [148,0,211],
  deeppink: [255,20,147],
  deepskyblue:  [0,191,255],
  dimgray:  [105,105,105],
  dimgrey:  [105,105,105],
  dodgerblue: [30,144,255],
  firebrick:  [178,34,34],
  floralwhite:  [255,250,240],
  forestgreen:  [34,139,34],
  fuchsia:  [255,0,255],
  gainsboro:  [220,220,220],
  ghostwhite: [248,248,255],
  gold: [255,215,0],
  goldenrod:  [218,165,32],
  gray: [128,128,128],
  green:  [0,128,0],
  greenyellow:  [173,255,47],
  grey: [128,128,128],
  honeydew: [240,255,240],
  hotpink:  [255,105,180],
  indianred:  [205,92,92],
  indigo: [75,0,130],
  ivory:  [255,255,240],
  khaki:  [240,230,140],
  lavender: [230,230,250],
  lavenderblush:  [255,240,245],
  lawngreen:  [124,252,0],
  lemonchiffon: [255,250,205],
  lightblue:  [173,216,230],
  lightcoral: [240,128,128],
  lightcyan:  [224,255,255],
  lightgoldenrodyellow: [250,250,210],
  lightgray:  [211,211,211],
  lightgreen: [144,238,144],
  lightgrey:  [211,211,211],
  lightpink:  [255,182,193],
  lightsalmon:  [255,160,122],
  lightseagreen:  [32,178,170],
  lightskyblue: [135,206,250],
  lightslategray: [119,136,153],
  lightslategrey: [119,136,153],
  lightsteelblue: [176,196,222],
  lightyellow:  [255,255,224],
  lime: [0,255,0],
  limegreen:  [50,205,50],
  linen:  [250,240,230],
  magenta:  [255,0,255],
  maroon: [128,0,0],
  mediumaquamarine: [102,205,170],
  mediumblue: [0,0,205],
  mediumorchid: [186,85,211],
  mediumpurple: [147,112,219],
  mediumseagreen: [60,179,113],
  mediumslateblue:  [123,104,238],
  mediumspringgreen:  [0,250,154],
  mediumturquoise:  [72,209,204],
  mediumvioletred:  [199,21,133],
  midnightblue: [25,25,112],
  mintcream:  [245,255,250],
  mistyrose:  [255,228,225],
  moccasin: [255,228,181],
  navajowhite:  [255,222,173],
  navy: [0,0,128],
  oldlace:  [253,245,230],
  olive:  [128,128,0],
  olivedrab:  [107,142,35],
  orange: [255,165,0],
  orangered:  [255,69,0],
  orchid: [218,112,214],
  palegoldenrod:  [238,232,170],
  palegreen:  [152,251,152],
  paleturquoise:  [175,238,238],
  palevioletred:  [219,112,147],
  papayawhip: [255,239,213],
  peachpuff:  [255,218,185],
  peru: [205,133,63],
  pink: [255,192,203],
  plum: [221,160,221],
  powderblue: [176,224,230],
  purple: [128,0,128],
  rebeccapurple: [102, 51, 153],
  red:  [255,0,0],
  rosybrown:  [188,143,143],
  royalblue:  [65,105,225],
  saddlebrown:  [139,69,19],
  salmon: [250,128,114],
  sandybrown: [244,164,96],
  seagreen: [46,139,87],
  seashell: [255,245,238],
  sienna: [160,82,45],
  silver: [192,192,192],
  skyblue:  [135,206,235],
  slateblue:  [106,90,205],
  slategray:  [112,128,144],
  slategrey:  [112,128,144],
  snow: [255,250,250],
  springgreen:  [0,255,127],
  steelblue:  [70,130,180],
  tan:  [210,180,140],
  teal: [0,128,128],
  thistle:  [216,191,216],
  tomato: [255,99,71],
  turquoise:  [64,224,208],
  violet: [238,130,238],
  wheat:  [245,222,179],
  white:  [255,255,255],
  whitesmoke: [245,245,245],
  yellow: [255,255,0],
  yellowgreen:  [154,205,50]
};

var reverseKeywords = {};
for (var key in cssKeywords) {
  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
}

var convert = function() {
   return new Converter();
};

for (var func in conversions) {
  // export Raw versions
  convert[func + "Raw"] =  (function(func) {
    // accept array or plain args
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      return conversions[func](arg);
    }
  })(func);

  var pair = /(\w+)2(\w+)/.exec(func),
      from = pair[1],
      to = pair[2];

  // export rgb2hsl and ["rgb"]["hsl"]
  convert[from] = convert[from] || {};

  convert[from][to] = convert[func] = (function(func) { 
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      
      var val = conversions[func](arg);
      if (typeof val == "string" || val === undefined)
        return val; // keyword

      for (var i = 0; i < val.length; i++)
        val[i] = Math.round(val[i]);
      return val;
    }
  })(func);
}


/* Converter does lazy conversion and caching */
var Converter = function() {
   this.convs = {};
};

/* Either get the values for a space or
  set the values for a space, depending on args */
Converter.prototype.routeSpace = function(space, args) {
   var values = args[0];
   if (values === undefined) {
      // color.rgb()
      return this.getValues(space);
   }
   // color.rgb(10, 10, 10)
   if (typeof values == "number") {
      values = Array.prototype.slice.call(args);        
   }

   return this.setValues(space, values);
};
  
/* Set the values for a space, invalidating cache */
Converter.prototype.setValues = function(space, values) {
   this.space = space;
   this.convs = {};
   this.convs[space] = values;
   return this;
};

/* Get the values for a space. If there's already
  a conversion for the space, fetch it, otherwise
  compute it */
Converter.prototype.getValues = function(space) {
   var vals = this.convs[space];
   if (!vals) {
      var fspace = this.space,
          from = this.convs[fspace];
      vals = convert[fspace][space](from);

      this.convs[space] = vals;
   }
  return vals;
};

["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
   Converter.prototype[space] = function(vals) {
      return this.routeSpace(space, arguments);
   };
});

var colorConvert = convert;

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName) {
   reverseNames[colorName[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: function(target) {
		var setFn = function(value, key) {
			target[key] = value;
		};
		for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
			helpers.each(arguments[i], setFn);
		}
		return target;
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		default:
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index) {
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
			}
			if (value !== undefined) {
				return value;
			}
		}
	}
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.clone(me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = model;
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$2 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$2.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$2.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();

		if (meta.xAxisID === null || !(meta.xAxisID in me.chart.scales)) {
			meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in me.chart.scales)) {
			meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this.update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

var element_arc = core_element.extend({
	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var	angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += 2.0 * Math.PI;
			}
			while (angle > endAngle) {
				angle -= 2.0 * Math.PI;
			}
			while (angle < startAngle) {
				angle += 2.0 * Math.PI;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var sA = vm.startAngle;
		var eA = vm.endAngle;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var angleMargin;

		ctx.save();

		ctx.beginPath();
		ctx.arc(vm.x, vm.y, Math.max(vm.outerRadius - pixelMargin, 0), sA, eA);
		ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
		ctx.closePath();

		ctx.fillStyle = vm.backgroundColor;
		ctx.fill();

		if (vm.borderWidth) {
			if (vm.borderAlign === 'inner') {
				// Draw an inner border by cliping the arc and drawing a double-width border
				// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
				ctx.beginPath();
				angleMargin = pixelMargin / vm.outerRadius;
				ctx.arc(vm.x, vm.y, vm.outerRadius, sA - angleMargin, eA + angleMargin);
				if (vm.innerRadius > pixelMargin) {
					angleMargin = pixelMargin / vm.innerRadius;
					ctx.arc(vm.x, vm.y, vm.innerRadius - pixelMargin, eA + angleMargin, sA - angleMargin, true);
				} else {
					ctx.arc(vm.x, vm.y, pixelMargin, eA + Math.PI / 2, sA - Math.PI / 2);
				}
				ctx.closePath();
				ctx.clip();

				ctx.beginPath();
				ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
				ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
				ctx.closePath();

				ctx.lineWidth = vm.borderWidth * 2;
				ctx.lineJoin = 'round';
			} else {
				ctx.lineWidth = vm.borderWidth;
				ctx.lineJoin = 'bevel';
			}

			ctx.strokeStyle = vm.borderColor;
			ctx.stroke();
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var index, current, previous, currentVM;

		// If we are looping, adding the first point again
		if (me._loop && points.length) {
			points.push(points[0]);
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();
		lastDrawnIndex = -1;

		for (index = 0; index < points.length; ++index) {
			current = points[index];
			previous = helpers$1.previousItem(points, index);
			currentVM = current._view;

			// First point moves to it's starting position no matter what
			if (index === 0) {
				if (!currentVM.skip) {
					ctx.moveTo(currentVM.x, currentVM.y);
					lastDrawnIndex = index;
				}
			} else {
				previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers$1.canvas.lineTo(ctx, previous._view, current._view);
					}
					lastDrawnIndex = index;
				}
			}
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			categoryPercentage: 0.8,
			barPercentage: 0.9,
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale.isHorizontal() ? scale.width : scale.height;
	var ticks = scale.getTicks();
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, curr - prev) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = ruler.min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	initialize: function() {
		var me = this;
		var meta;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		me._updateElementGeometry(rectangle, index, reset);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var chart = me.chart;
		var scale = me._getIndexScale();
		var stacked = scale.options.stacked;
		var ilen = last === undefined ? chart.data.datasets.length : last + 1;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = chart.getDatasetMeta(i);
			if (meta.bar && chart.isDatasetVisible(i) &&
				(stacked === false ||
				(stacked === true && stacks.indexOf(meta.stack) === -1) ||
				(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
				stacks.push(meta.stack);
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var stackCount = me.getStackCount();
		var datasetIndex = me.index;
		var isHorizontal = scale.isHorizontal();
		var start = isHorizontal ? scale.left : scale.top;
		var end = start + (isHorizontal ? scale.width : scale.height);
		var pixels = [];
		var i, ilen, min;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, datasetIndex));
		}

		min = helpers$1.isNullOrUndef(scale.options.barThickness)
			? computeMinSampleSize(scale, pixels)
			: -1;

		return {
			min: min,
			pixels: pixels,
			start: start,
			end: end,
			stackCount: stackCount,
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index) {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var value = +scale.getRightValue(datasets[datasetIndex].data[index]);
		var minBarLength = scale.options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = meta.stack;
		var start = 0;
		var i, imeta, ivalue, base, head, size;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < datasetIndex; ++i) {
				imeta = chart.getDatasetMeta(i);

				if (imeta.bar &&
					imeta.stack === stack &&
					imeta.controller._getValueScaleId() === scale.id &&
					chart.isDatasetVisible(i)) {

					ivalue = +scale.getRightValue(datasets[i].data[index]);
					if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + value);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (value >= 0 && !isHorizontal || value < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler) {
		var me = this;
		var options = ruler.scale.options;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			helpers$1.valueOrDefault(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			if (!isNaN(scale.getRightValue(dataset.data[i]))) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveElementOptions: function(rectangle, index) {
		var me = this;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var dataset = datasets[me.index];
		var custom = rectangle.custom || {};
		var options = chart.options.elements.rectangle;
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var keys = [
			'backgroundColor',
			'borderColor',
			'borderSkipped',
			'borderWidth'
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$1([
				custom[key],
				dataset[key],
				options[key]
			], context, index);
		}

		return values;
	}
});

var valueOrDefault$3 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$3(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$3(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$3(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var dataset = datasets[me.index];
		var custom = point.custom || {};
		var options = chart.options.elements.point;
		var data = dataset.data[index];
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var keys = [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
			'hoverRadius',
			'hitRadius',
			'pointStyle',
			'rotation'
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$2([
				custom[key],
				dataset[key],
				options[key]
			], context, index);
		}

		// Custom radius resolution
		values.radius = resolve$2([
			custom.radius,
			data ? data.r : undefined,
			dataset.radius,
			options.radius
		], context, index);

		return values;
	}
});

var resolve$3 = helpers$1.options.resolve;
var valueOrDefault$4 = helpers$1.valueOrDefault;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc && arc.custom || {};
						var arcOpts = chart.options.elements.arc;
						var fill = resolve$3([custom.backgroundColor, ds.backgroundColor, arcOpts.backgroundColor], undefined, i);
						var stroke = resolve$3([custom.borderColor, ds.borderColor, arcOpts.borderColor], undefined, i);
						var bw = resolve$3([custom.borderWidth, ds.borderWidth, arcOpts.borderWidth], undefined, i);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: Math.PI * -0.5,

	// The total circumference of the chart.
	circumference: Math.PI * 2.0,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var availableWidth = chartArea.right - chartArea.left;
		var availableHeight = chartArea.bottom - chartArea.top;
		var minSize = Math.min(availableWidth, availableHeight);
		var offset = {x: 0, y: 0};
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutoutPercentage = opts.cutoutPercentage;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var i, ilen;

		// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
		if (circumference < Math.PI * 2.0) {
			var startAngle = opts.rotation % (Math.PI * 2.0);
			startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
			var endAngle = startAngle + circumference;
			var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
			var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
			var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
			var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
			var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
			var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
			var cutout = cutoutPercentage / 100.0;
			var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
			var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
			var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
			minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
			offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
		chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offset.x * chart.outerRadius;
		chart.offsetY = offset.y * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return (Math.PI * 2.0) * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			options = controller ? controller._resolveElementOptions(arc, i) : arc._options;
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_resolveElementOptions: function(arc, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = arc.custom || {};
		var options = chart.options.elements.arc;
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var keys = [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$3([
				custom[key],
				dataset[key],
				options[key]
			], context, index);
		}

		return values;
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$4(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			categoryPercentage: 0.8,
			barPercentage: 0.9,
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;
var resolve$4 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function lineEnabled(dataset, options) {
	return valueOrDefault$5(dataset.showLine, options.showLines);
}

var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.getScaleForId(meta.yAxisID);
		var dataset = me.getDataset();
		var showLine = lineEnabled(dataset, me.chart.options);
		var i, ilen;

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}

			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveLineOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var yScale = me.getScaleForId(meta.yAxisID);
		var xScale = me.getScaleForId(meta.xAxisID);
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolvePointOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$5(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolvePointOptions: function(element, index) {
		var me = this;
		var chart = me.chart;
		var dataset = chart.data.datasets[me.index];
		var custom = element.custom || {};
		var options = chart.options.elements.point;
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var ELEMENT_OPTIONS = {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		};
		var keys = Object.keys(ELEMENT_OPTIONS);

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$4([
				custom[key],
				dataset[ELEMENT_OPTIONS[key]],
				dataset[key],
				options[key]
			], context, index);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveLineOptions: function(element) {
		var me = this;
		var chart = me.chart;
		var dataset = chart.data.datasets[me.index];
		var custom = element.custom || {};
		var options = chart.options;
		var elementOptions = options.elements.line;
		var values = {};
		var i, ilen, key;

		var keys = [
			'backgroundColor',
			'borderWidth',
			'borderColor',
			'borderCapStyle',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'fill',
			'cubicInterpolationMode'
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$4([
				custom[key],
				dataset[key],
				elementOptions[key]
			]);
		}

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$5(dataset.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$5(dataset.lineTension, elementOptions.tension);
		values.steppedLine = resolve$4([custom.steppedLine, dataset.steppedLine, elementOptions.stepped]);

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var yScale = me.getScaleForId(meta.yAxisID);
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta;

		if (yScale.options.stacked) {
			for (i = 0; i < datasetIndex; i++) {
				ds = chart.data.datasets[i];
				dsMeta = chart.getDatasetMeta(i);
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
					var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			var rightValue = Number(yScale.getRightValue(value));
			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}

		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var ilen = points.length;
		var halfBorderWidth;
		var i = 0;

		if (lineEnabled(me.getDataset(), chart.options)) {
			halfBorderWidth = (meta.dataset._model.borderWidth || 0) / 2;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: area.left,
				right: area.right,
				top: area.top - halfBorderWidth,
				bottom: area.bottom + halfBorderWidth
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$5(options.hoverRadius, options.radius);
	},
});

var resolve$5 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc.custom || {};
						var arcOpts = chart.options.elements.arc;
						var fill = resolve$5([custom.backgroundColor, ds.backgroundColor, arcOpts.backgroundColor], undefined, i);
						var stroke = resolve$5([custom.borderColor, ds.borderColor, arcOpts.borderColor], undefined, i);
						var bw = resolve$5([custom.borderWidth, ds.borderWidth, arcOpts.borderWidth], undefined, i);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_resolveElementOptions: function(arc, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = arc.custom || {};
		var options = chart.options.elements.arc;
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var keys = [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$5([
				custom[key],
				dataset[key],
				options[key]
			], context, index);
		}

		return values;
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$5([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$6 = helpers$1.options.resolve;

core_defaults._set('radar', {
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var dataset = me.getDataset();
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
			dataset.lineTension = dataset.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveLineOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolvePointOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolvePointOptions: function(element, index) {
		var me = this;
		var chart = me.chart;
		var dataset = chart.data.datasets[me.index];
		var custom = element.custom || {};
		var options = chart.options.elements.point;
		var values = {};
		var i, ilen, key;

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		var ELEMENT_OPTIONS = {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		};
		var keys = Object.keys(ELEMENT_OPTIONS);

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$6([
				custom[key],
				dataset[ELEMENT_OPTIONS[key]],
				dataset[key],
				options[key]
			], context, index);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveLineOptions: function(element) {
		var me = this;
		var chart = me.chart;
		var dataset = chart.data.datasets[me.index];
		var custom = element.custom || {};
		var options = chart.options.elements.line;
		var values = {};
		var i, ilen, key;

		var keys = [
			'backgroundColor',
			'borderWidth',
			'borderColor',
			'borderCapStyle',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'fill'
		];

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			values[key] = resolve$6([
				custom[key],
				dataset[key],
				options[key]
			]);
		}

		values.tension = valueOrDefault$6(dataset.lineTension, options.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	showLines: false,

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var datasets = chart.data.datasets;
	var meta, i, j, ilen, jlen;

	for (i = 0, ilen = datasets.length; i < ilen; ++i) {
		if (!chart.isDatasetVisible(i)) {
			continue;
		}

		meta = chart.getDatasetMeta(i);
		for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
			var element = meta.data[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart.data.datasets.forEach(function(dataset, datasetIndex) {
		if (chart.isDatasetVisible(datasetIndex)) {
			var meta = chart.getDatasetMeta(datasetIndex);
			var element = meta.data[items[0]._index];

			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.position === position;
	});
}

function sortByWeight(array, reverse) {
	array.forEach(function(v, i) {
		v._tmpIndex_ = i;
		return v;
	});
	array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0._tmpIndex_ - v1._tmpIndex_ :
			v0.weight - v1.weight;
	});
	array.forEach(function(v) {
		delete v._tmpIndex_;
	});
}

function findMaxPadding(boxes) {
	var top = 0;
	var left = 0;
	var bottom = 0;
	var right = 0;
	helpers$1.each(boxes, function(box) {
		if (box.getPadding) {
			var boxPadding = box.getPadding();
			top = Math.max(top, boxPadding.top);
			left = Math.max(left, boxPadding.left);
			bottom = Math.max(bottom, boxPadding.bottom);
			right = Math.max(right, boxPadding.right);
		}
	});
	return {
		top: top,
		left: left,
		bottom: bottom,
		right: right
	};
}

function addSizeByPosition(boxes, size) {
	helpers$1.each(boxes, function(box) {
		size[box.position] += box.isHorizontal() ? box.height : box.width;
	});
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);
		var leftPadding = padding.left;
		var rightPadding = padding.right;
		var topPadding = padding.top;
		var bottomPadding = padding.bottom;

		var leftBoxes = filterByPosition(chart.boxes, 'left');
		var rightBoxes = filterByPosition(chart.boxes, 'right');
		var topBoxes = filterByPosition(chart.boxes, 'top');
		var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
		var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

		// Sort boxes by weight. A higher weight is further away from the chart area
		sortByWeight(leftBoxes, true);
		sortByWeight(rightBoxes, false);
		sortByWeight(topBoxes, true);
		sortByWeight(bottomBoxes, false);

		var verticalBoxes = leftBoxes.concat(rightBoxes);
		var horizontalBoxes = topBoxes.concat(bottomBoxes);
		var outerBoxes = verticalBoxes.concat(horizontalBoxes);

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//
		// What we do to find the best sizing, we do the following
		// 1. Determine the minimum size of the chart area.
		// 2. Split the remaining width equally between each vertical axis
		// 3. Split the remaining height equally between each horizontal axis
		// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
		// 5. Adjust the sizes of each axis based on it's minimum reported size.
		// 6. Refit each axis
		// 7. Position each axis in the final location
		// 8. Tell the chart the final location of the chart area
		// 9. Tell any axes that overlay the chart area the positions of the chart area

		// Step 1
		var chartWidth = width - leftPadding - rightPadding;
		var chartHeight = height - topPadding - bottomPadding;
		var chartAreaWidth = chartWidth / 2; // min 50%

		// Step 2
		var verticalBoxWidth = (width - chartAreaWidth) / verticalBoxes.length;

		// Step 3
		// TODO re-limit horizontal axis height (this limit has affected only padding calculation since PR 1837)
		// var horizontalBoxHeight = (height - chartAreaHeight) / horizontalBoxes.length;

		// Step 4
		var maxChartAreaWidth = chartWidth;
		var maxChartAreaHeight = chartHeight;
		var outerBoxSizes = {top: topPadding, left: leftPadding, bottom: bottomPadding, right: rightPadding};
		var minBoxSizes = [];
		var maxPadding;

		function getMinimumBoxSize(box) {
			var minSize;
			var isHorizontal = box.isHorizontal();

			if (isHorizontal) {
				minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2);
				maxChartAreaHeight -= minSize.height;
			} else {
				minSize = box.update(verticalBoxWidth, maxChartAreaHeight);
				maxChartAreaWidth -= minSize.width;
			}

			minBoxSizes.push({
				horizontal: isHorizontal,
				width: minSize.width,
				box: box,
			});
		}

		helpers$1.each(outerBoxes, getMinimumBoxSize);

		// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
		maxPadding = findMaxPadding(outerBoxes);

		// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
		// be if the axes are drawn at their minimum sizes.
		// Steps 5 & 6

		// Function to fit a box
		function fitBox(box) {
			var minBoxSize = helpers$1.findNextWhere(minBoxSizes, function(minBox) {
				return minBox.box === box;
			});

			if (minBoxSize) {
				if (minBoxSize.horizontal) {
					var scaleMargin = {
						left: Math.max(outerBoxSizes.left, maxPadding.left),
						right: Math.max(outerBoxSizes.right, maxPadding.right),
						top: 0,
						bottom: 0
					};

					// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
					// on the margin. Sometimes they need to increase in size slightly
					box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
				} else {
					box.update(minBoxSize.width, maxChartAreaHeight);
				}
			}
		}

		// Update, and calculate the left and right margins for the horizontal boxes
		helpers$1.each(verticalBoxes, fitBox);
		addSizeByPosition(verticalBoxes, outerBoxSizes);

		// Set the Left and Right margins for the horizontal boxes
		helpers$1.each(horizontalBoxes, fitBox);
		addSizeByPosition(horizontalBoxes, outerBoxSizes);

		function finalFitVerticalBox(box) {
			var minBoxSize = helpers$1.findNextWhere(minBoxSizes, function(minSize) {
				return minSize.box === box;
			});

			var scaleMargin = {
				left: 0,
				right: 0,
				top: outerBoxSizes.top,
				bottom: outerBoxSizes.bottom
			};

			if (minBoxSize) {
				box.update(minBoxSize.width, maxChartAreaHeight, scaleMargin);
			}
		}

		// Let the left layout know the final margin
		helpers$1.each(verticalBoxes, finalFitVerticalBox);

		// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
		outerBoxSizes = {top: topPadding, left: leftPadding, bottom: bottomPadding, right: rightPadding};
		addSizeByPosition(outerBoxes, outerBoxSizes);

		// We may be adding some padding to account for rotated x axis labels
		var leftPaddingAddition = Math.max(maxPadding.left - outerBoxSizes.left, 0);
		outerBoxSizes.left += leftPaddingAddition;
		outerBoxSizes.right += Math.max(maxPadding.right - outerBoxSizes.right, 0);

		var topPaddingAddition = Math.max(maxPadding.top - outerBoxSizes.top, 0);
		outerBoxSizes.top += topPaddingAddition;
		outerBoxSizes.bottom += Math.max(maxPadding.bottom - outerBoxSizes.bottom, 0);

		// Figure out if our chart area changed. This would occur if the dataset layout label rotation
		// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
		// without calling `fit` again
		var newMaxChartAreaHeight = height - outerBoxSizes.top - outerBoxSizes.bottom;
		var newMaxChartAreaWidth = width - outerBoxSizes.left - outerBoxSizes.right;

		if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
			helpers$1.each(verticalBoxes, function(box) {
				box.height = newMaxChartAreaHeight;
			});

			helpers$1.each(horizontalBoxes, function(box) {
				if (!box.fullWidth) {
					box.width = newMaxChartAreaWidth;
				}
			});

			maxChartAreaHeight = newMaxChartAreaHeight;
			maxChartAreaWidth = newMaxChartAreaWidth;
		}

		// Step 7 - Position the boxes
		var left = leftPadding + leftPaddingAddition;
		var top = topPadding + topPaddingAddition;

		function placeBox(box) {
			if (box.isHorizontal()) {
				box.left = box.fullWidth ? leftPadding : outerBoxSizes.left;
				box.right = box.fullWidth ? width - rightPadding : outerBoxSizes.left + maxChartAreaWidth;
				box.top = top;
				box.bottom = top + box.height;

				// Move to next point
				top = box.bottom;

			} else {

				box.left = left;
				box.right = left + box.width;
				box.top = outerBoxSizes.top;
				box.bottom = outerBoxSizes.top + maxChartAreaHeight;

				// Move to next point
				left = box.right;
			}
		}

		helpers$1.each(leftBoxes.concat(topBoxes), placeBox);

		// Account for chart width and height
		left += maxChartAreaWidth;
		top += maxChartAreaHeight;

		helpers$1.each(rightBoxes, placeBox);
		helpers$1.each(bottomBoxes, placeBox);

		// Step 8
		chart.chartArea = {
			left: outerBoxSizes.left,
			top: outerBoxSizes.top,
			right: outerBoxSizes.left + maxChartAreaWidth,
			bottom: outerBoxSizes.top + maxChartAreaHeight
		};

		// Step 9
		helpers$1.each(chartAreaBoxes, function(box) {
			box.left = chart.chartArea.left;
			box.top = chart.chartArea.top;
			box.right = chart.chartArea.right;
			box.bottom = chart.chartArea.bottom;

			box.update(maxChartAreaWidth, maxChartAreaHeight);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
default: platform_dom
});

function getCjsExportFromNamespace (n) {
	return n && n.default || n;
}

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

function injectCSS(platform, css) {
	// https://stackoverflow.com/q/3922139
	var style = platform._style || document.createElement('style');
	if (!platform._style) {
		platform._style = style;
		css = '/* Chart.js */\n' + css;
		style.setAttribute('type', 'text/css');
		document.getElementsByTagName('head')[0].appendChild(style);
	}

	style.appendChild(document.createTextNode(css));
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * @private
	 */
	_ensureLoaded: function() {
		if (this._loaded) {
			return;
		}

		this._loaded = true;

		// https://github.com/chartjs/Chart.js/issues/5208
		if (!this.disableCSSInjection) {
			injectCSS(this, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// Load platform resources on first chart creation, to make possible to change
		// platform options after importing the library (e.g. `disableCSSInjection`).
		this._ensureLoaded();

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge({}, [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$7(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$7(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$7(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$7(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$7(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$7(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$7(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$7(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$7(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$3 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;

		if (title.length) {
			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = vm._titleAlign;
			ctx.textBaseline = 'top';

			var titleFontSize = vm.titleFontSize;
			var titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			var i, len;
			for (i = 0, len = title.length; i < len; ++i) {
				ctx.fillText(title[i], pt.x, pt.y);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === title.length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var labelColors = vm.labelColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
		var textColor;

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'top';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlign);

		// Before Body
		var fillLineOfText = function(line) {
			ctx.fillText(line, pt.x + xLinePadding, pt.y);
			pt.y += bodyFontSize + bodySpacing;
		};

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlign !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		helpers$1.each(body, function(bodyItem, i) {
			textColor = vm.labelTextColors[i];
			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			helpers$1.each(bodyItem.lines, function(line) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(colorX, pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors[i].borderColor;
					ctx.strokeRect(colorX, pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors[i].backgroundColor;
					ctx.fillRect(colorX + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(line);
			});

			helpers$1.each(bodyItem.after, fillLineOfText);
		});

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;

		if (footer.length) {
			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = vm._footerAlign;
			ctx.textBaseline = 'top';

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			helpers$1.each(footer, function(line) {
				ctx.fillText(line, pt.x, pt.y);
				pt.y += vm.footerFontSize + vm.footerSpacing;
			});
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$3;
core_tooltip.positioners = positioners_1;

var valueOrDefault$8 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$8(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || {};
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || {};

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		// Make sure scales have IDs and are built before we build any controllers.
		me.ensureScalesHaveIDs();
		me.buildOrUpdateScales();
		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$8(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];

		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			var meta = me.getDatasetMeta(datasetIndex);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(datasetIndex);
				meta = me.getDatasetMeta(datasetIndex);
			}
			meta.type = type;

			if (meta.controller) {
				meta.controller.updateIndex(datasetIndex);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, datasetIndex);
				newControllers.push(meta.controller);
			}
		}, me);

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
		}, me);

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller.update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$8(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Draw all the scales
		helpers$1.each(me.boxes, function(box) {
			box.draw(me.chartArea);
		}, me);

		me.drawDatasets(easingValue);
		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		// Draw datasets reversed to support proper line stacking
		for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
			if (me.isDatasetVisible(i)) {
				me.drawDataset(i, easingValue);
			}
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(index, easingValue) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[method](element);
			}
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.log10 = Math.log10 ?
		function(x) {
			return Math.log10(x);
		} :
		function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);

			return isPowerOf10 ? powerOf10 : exponent;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		helpers$1.each(arrayOfThings, function(thing) {
			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				helpers$1.each(thing, function(nestedThing) {
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				});
			}
		});

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (var i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					tickString = tickValue.toExponential(Math.floor(logTick) - Math.floor(logDelta));
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var valueOrDefault$9 = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0, 0, 0, 0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

function labelsFromTicks(ticks) {
	var labels = [];
	var i, ilen;

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		labels.push(ticks[i].label);
	}

	return labels;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var lineValue = scale.getPixelForTick(index);

	if (offsetGridLines) {
		if (scale.getTicks().length === 1) {
			lineValue -= scale.isHorizontal() ?
				Math.max(lineValue - scale.left, scale.right - lineValue) :
				Math.max(lineValue - scale.top, scale.bottom - lineValue);
		} else if (index === 0) {
			lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
		}
	}
	return lineValue;
}

function computeTextSize(context, tick, font) {
	return helpers$1.isArray(tick) ?
		helpers$1.longestText(context, font, tick) :
		context.measureText(tick).width;
}

var core_scale = core_element.extend({
	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	mergeTicksOptions: function() {
		var ticks = this.options.ticks;
		if (ticks.minor === false) {
			ticks.minor = {
				display: false
			};
		}
		if (ticks.major === false) {
			ticks.major = {
				display: false
			};
		}
		for (var key in ticks) {
			if (key !== 'major' && key !== 'minor') {
				if (typeof ticks.minor[key] === 'undefined') {
					ticks.minor[key] = ticks[key];
				}
				if (typeof ticks.major[key] === 'undefined') {
					ticks.major[key] = ticks[key];
				}
			}
		}
	},
	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var i, ilen, labels, label, ticks, tick;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = labels.length; i < ilen; ++i) {
			label = labels[i];
			tick = ticks[i];
			if (!tick) {
				ticks.push(tick = {
					label: label,
					major: false
				});
			} else {
				tick.label = label;
			}
		}

		me._ticks = ticks;

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();
		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (helpers$1.isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var context = me.ctx;
		var tickOpts = me.options.ticks;
		var labels = labelsFromTicks(me._ticks);

		// Get the width of each grid by calculating the difference
		// between x offsets between 0 and 1.
		var tickFont = helpers$1.options._parseFont(tickOpts);
		context.font = tickFont.string;

		var labelRotation = tickOpts.minRotation || 0;

		if (labels.length && me.options.display && me.isHorizontal()) {
			var originalLabelWidth = helpers$1.longestText(context, tickFont.string, labels, me.longestTextCache);
			var labelWidth = originalLabelWidth;
			var cosRotation, sinRotation;

			// Allow 3 pixels x2 padding either side for label readability
			var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

			// Max label rotation can be set or default to 90 - also act as a loop counter
			while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
				var angleRadians = helpers$1.toRadians(labelRotation);
				cosRotation = Math.cos(angleRadians);
				sinRotation = Math.sin(angleRadians);

				if (sinRotation * originalLabelWidth > me.maxHeight) {
					// go back one step
					labelRotation--;
					break;
				}

				labelRotation++;
				labelWidth = cosRotation * originalLabelWidth;
			}
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var labels = labelsFromTicks(me._ticks);

		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var position = opts.position;
		var isHorizontal = me.isHorizontal();

		var parseFont = helpers$1.options._parseFont;
		var tickFont = parseFont(tickOpts);
		var tickMarkLength = opts.gridLines.tickMarkLength;

		// Width
		if (isHorizontal) {
			// subtract the margins to line up with the chartArea if we are a full width scale
			minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
		} else {
			minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
		}

		// height
		if (isHorizontal) {
			minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
		} else {
			minSize.height = me.maxHeight; // fill all the height
		}

		// Are we showing a title for the scale?
		if (scaleLabelOpts.display && display) {
			var scaleLabelFont = parseFont(scaleLabelOpts);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabelOpts.padding);
			var deltaHeight = scaleLabelFont.lineHeight + scaleLabelPadding.height;

			if (isHorizontal) {
				minSize.height += deltaHeight;
			} else {
				minSize.width += deltaHeight;
			}
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var largestTextWidth = helpers$1.longestText(me.ctx, tickFont.string, labels, me.longestTextCache);
			var tallestLabelHeightInLines = helpers$1.numberOfLabelLines(labels);
			var lineSpace = tickFont.size * 0.5;
			var tickPadding = me.options.ticks.padding;

			// Store max number of lines and widest label for _autoSkip
			me._maxLabelLines = tallestLabelHeightInLines;
			me.longestLabelWidth = largestTextWidth;

			if (isHorizontal) {
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				// TODO - improve this calculation
				var labelHeight = (sinRotation * largestTextWidth)
					+ (tickFont.lineHeight * tallestLabelHeightInLines)
					+ lineSpace; // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				me.ctx.font = tickFont.string;
				var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.string);
				var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.string);
				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(labels.length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (me.labelRotation !== 0) {
					paddingLeft = position === 'bottom' ? (cosRotation * firstLabelWidth) : (cosRotation * lineSpace);
					paddingRight = position === 'bottom' ? (cosRotation * lineSpace) : (cosRotation * lastLabelWidth);
				} else {
					paddingLeft = firstLabelWidth / 2;
					paddingRight = lastLabelWidth / 2;
				}
				me.paddingLeft = Math.max(paddingLeft - offsetLeft, 0) + 3; // add 3 px to move away from canvas edges
				me.paddingRight = Math.max(paddingRight - offsetRight, 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				if (tickOpts.mirror) {
					largestTextWidth = 0;
				} else {
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					largestTextWidth += tickPadding + lineSpace;
				}

				minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);

				me.paddingTop = tickFont.size / 2;
				me.paddingBottom = tickFont.size / 2;
			}
		}

		me.handleMargins();

		me.width = minSize.width;
		me.height = minSize.height;
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
			me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
			me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
			me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},
	isFullWidth: function() {
		return (this.options.fullWidth);
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (helpers$1.isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}
		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		if (me.isHorizontal()) {
			var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
			var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var pixel = (tickWidth * index) + me.paddingLeft;

			if (offset) {
				pixel += tickWidth / 2;
			}

			var finalVal = me.left + pixel;
			finalVal += me.isFullWidth() ? me.margins.left : 0;
			return finalVal;
		}
		var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
		return me.top + (index * (innerHeight / (me._ticks.length - 1)));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;
		if (me.isHorizontal()) {
			var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
			var valueOffset = (innerWidth * decimal) + me.paddingLeft;

			var finalVal = me.left + valueOffset;
			finalVal += me.isFullWidth() ? me.margins.left : 0;
			return finalVal;
		}
		return me.top + (decimal * me.height);
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		var optionTicks = me.options.ticks.minor;
		var tickCount = ticks.length;
		var skipRatio = false;
		var maxTicks = optionTicks.maxTicksLimit;

		// Total space needed to display all ticks. First and last ticks are
		// drawn as their center at end of axis, so tickCount-1
		var ticksLength = me._tickSize() * (tickCount - 1);

		// Axis length
		var axisLength = isHorizontal
			? me.width - (me.paddingLeft + me.paddingRight)
			: me.height - (me.paddingTop + me.PaddingBottom);

		var result = [];
		var i, tick;

		if (ticksLength > axisLength) {
			skipRatio = 1 + Math.floor(ticksLength / axisLength);
		}

		// if they defined a max number of optionTicks,
		// increase skipRatio until that number is met
		if (tickCount > maxTicks) {
			skipRatio = Math.max(skipRatio, 1 + Math.floor(tickCount / maxTicks));
		}

		for (i = 0; i < tickCount; i++) {
			tick = ticks[i];

			if (skipRatio > 1 && i % skipRatio > 0) {
				// leave tick in place but make sure it's not displayed (#4635)
				delete tick.label;
			}
			result.push(tick);
		}
		return result;
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var isHorizontal = me.isHorizontal();
		var optionTicks = me.options.ticks.minor;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var padding = optionTicks.autoSkipPadding || 0;
		var w = (me.longestLabelWidth + padding) || 0;

		var tickFont = helpers$1.options._parseFont(optionTicks);
		var h = (me._maxLabelLines * tickFont.lineHeight + padding) || 0;

		// Calculate space needed for 1 tick in axis direction.
		return isHorizontal
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * Actually draw the scale on the canvas
	 * @param {object} chartArea - the area of the chart to draw full grid lines on
	 */
	draw: function(chartArea) {
		var me = this;
		var options = me.options;

		if (!me._isVisible()) {
			return;
		}

		var chart = me.chart;
		var context = me.ctx;
		var globalDefaults = core_defaults.global;
		var defaultFontColor = globalDefaults.defaultFontColor;
		var optionTicks = options.ticks.minor;
		var optionMajorTicks = options.ticks.major || optionTicks;
		var gridLines = options.gridLines;
		var scaleLabel = options.scaleLabel;
		var position = options.position;

		var isRotated = me.labelRotation !== 0;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();

		var parseFont = helpers$1.options._parseFont;
		var ticks = optionTicks.display && optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
		var tickFontColor = valueOrDefault$9(optionTicks.fontColor, defaultFontColor);
		var tickFont = parseFont(optionTicks);
		var lineHeight = tickFont.lineHeight;
		var majorTickFontColor = valueOrDefault$9(optionMajorTicks.fontColor, defaultFontColor);
		var majorTickFont = parseFont(optionMajorTicks);
		var tickPadding = optionTicks.padding;
		var labelOffset = optionTicks.labelOffset;

		var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

		var scaleLabelFontColor = valueOrDefault$9(scaleLabel.fontColor, defaultFontColor);
		var scaleLabelFont = parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var labelRotationRadians = helpers$1.toRadians(me.labelRotation);

		var itemsToDraw = [];

		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var alignPixel = helpers$1._alignPixel;
		var borderValue, tickStart, tickEnd;

		if (position === 'top') {
			borderValue = alignPixel(chart, me.bottom, axisWidth);
			tickStart = me.bottom - tl;
			tickEnd = borderValue - axisWidth / 2;
		} else if (position === 'bottom') {
			borderValue = alignPixel(chart, me.top, axisWidth);
			tickStart = borderValue + axisWidth / 2;
			tickEnd = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignPixel(chart, me.right, axisWidth);
			tickStart = me.right - tl;
			tickEnd = borderValue - axisWidth / 2;
		} else {
			borderValue = alignPixel(chart, me.left, axisWidth);
			tickStart = borderValue + axisWidth / 2;
			tickEnd = me.left + tl;
		}

		var epsilon = 0.0000001; // 0.0000001 is margin in pixels for Accumulated error.

		helpers$1.each(ticks, function(tick, index) {
			// autoskipper skipped this tick (#4635)
			if (helpers$1.isNullOrUndef(tick.label)) {
				return;
			}

			var label = tick.label;
			var lineWidth, lineColor, borderDash, borderDashOffset;
			if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, index);
				lineColor = valueAtIndexOrDefault(gridLines.color, index);
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			// Common properties
			var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY, textOffset, textAlign;
			var labelCount = helpers$1.isArray(label) ? label.length : 1;
			var lineValue = getPixelForGridLine(me, index, gridLines.offsetGridLines);

			if (isHorizontal) {
				var labelYOffset = tl + tickPadding;

				if (lineValue < me.left - epsilon) {
					lineColor = 'rgba(0,0,0,0)';
				}

				tx1 = tx2 = x1 = x2 = alignPixel(chart, lineValue, lineWidth);
				ty1 = tickStart;
				ty2 = tickEnd;
				labelX = me.getPixelForTick(index) + labelOffset; // x values for optionTicks (need to consider offsetLabel option)

				if (position === 'top') {
					y1 = alignPixel(chart, chartArea.top, axisWidth) + axisWidth / 2;
					y2 = chartArea.bottom;
					textOffset = ((!isRotated ? 0.5 : 1) - labelCount) * lineHeight;
					textAlign = !isRotated ? 'center' : 'left';
					labelY = me.bottom - labelYOffset;
				} else {
					y1 = chartArea.top;
					y2 = alignPixel(chart, chartArea.bottom, axisWidth) - axisWidth / 2;
					textOffset = (!isRotated ? 0.5 : 0) * lineHeight;
					textAlign = !isRotated ? 'center' : 'right';
					labelY = me.top + labelYOffset;
				}
			} else {
				var labelXOffset = (isMirrored ? 0 : tl) + tickPadding;

				if (lineValue < me.top - epsilon) {
					lineColor = 'rgba(0,0,0,0)';
				}

				tx1 = tickStart;
				tx2 = tickEnd;
				ty1 = ty2 = y1 = y2 = alignPixel(chart, lineValue, lineWidth);
				labelY = me.getPixelForTick(index) + labelOffset;
				textOffset = (1 - labelCount) * lineHeight / 2;

				if (position === 'left') {
					x1 = alignPixel(chart, chartArea.left, axisWidth) + axisWidth / 2;
					x2 = chartArea.right;
					textAlign = isMirrored ? 'left' : 'right';
					labelX = me.right - labelXOffset;
				} else {
					x1 = chartArea.left;
					x2 = alignPixel(chart, chartArea.right, axisWidth) - axisWidth / 2;
					textAlign = isMirrored ? 'right' : 'left';
					labelX = me.left + labelXOffset;
				}
			}

			itemsToDraw.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				labelX: labelX,
				labelY: labelY,
				glWidth: lineWidth,
				glColor: lineColor,
				glBorderDash: borderDash,
				glBorderDashOffset: borderDashOffset,
				rotation: -1 * labelRotationRadians,
				label: label,
				major: tick.major,
				textOffset: textOffset,
				textAlign: textAlign
			});
		});

		// Draw all of the tick labels, tick marks, and grid lines at the correct places
		helpers$1.each(itemsToDraw, function(itemToDraw) {
			var glWidth = itemToDraw.glWidth;
			var glColor = itemToDraw.glColor;

			if (gridLines.display && glWidth && glColor) {
				context.save();
				context.lineWidth = glWidth;
				context.strokeStyle = glColor;
				if (context.setLineDash) {
					context.setLineDash(itemToDraw.glBorderDash);
					context.lineDashOffset = itemToDraw.glBorderDashOffset;
				}

				context.beginPath();

				if (gridLines.drawTicks) {
					context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
					context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
				}

				if (gridLines.drawOnChartArea) {
					context.moveTo(itemToDraw.x1, itemToDraw.y1);
					context.lineTo(itemToDraw.x2, itemToDraw.y2);
				}

				context.stroke();
				context.restore();
			}

			if (optionTicks.display) {
				// Make sure we draw text in the correct color and font
				context.save();
				context.translate(itemToDraw.labelX, itemToDraw.labelY);
				context.rotate(itemToDraw.rotation);
				context.font = itemToDraw.major ? majorTickFont.string : tickFont.string;
				context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
				context.textBaseline = 'middle';
				context.textAlign = itemToDraw.textAlign;

				var label = itemToDraw.label;
				var y = itemToDraw.textOffset;
				if (helpers$1.isArray(label)) {
					for (var i = 0; i < label.length; ++i) {
						// We just make sure the multiline element is a string here..
						context.fillText('' + label[i], 0, y);
						y += lineHeight;
					}
				} else {
					context.fillText(label, 0, y);
				}
				context.restore();
			}
		});

		if (scaleLabel.display) {
			// Draw the scale label
			var scaleLabelX;
			var scaleLabelY;
			var rotation = 0;
			var halfLineHeight = scaleLabelFont.lineHeight / 2;

			if (isHorizontal) {
				scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
				scaleLabelY = position === 'bottom'
					? me.bottom - halfLineHeight - scaleLabelPadding.bottom
					: me.top + halfLineHeight + scaleLabelPadding.top;
			} else {
				var isLeft = position === 'left';
				scaleLabelX = isLeft
					? me.left + halfLineHeight + scaleLabelPadding.top
					: me.right - halfLineHeight - scaleLabelPadding.top;
				scaleLabelY = me.top + ((me.bottom - me.top) / 2);
				rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
			}

			context.save();
			context.translate(scaleLabelX, scaleLabelY);
			context.rotate(rotation);
			context.textAlign = 'center';
			context.textBaseline = 'middle';
			context.fillStyle = scaleLabelFontColor; // render in correct colour
			context.font = scaleLabelFont.string;
			context.fillText(scaleLabel.labelString, 0, 0);
			context.restore();
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, ticks.length - 1, 0);
			var x1, x2, y1, y2;

			if (isHorizontal) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			context.lineWidth = axisWidth;
			context.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			context.beginPath();
			context.moveTo(x1, y1);
			context.lineTo(x2, y2);
			context.stroke();
		}
	}
});

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	/**
	* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
	* else fall back to data.labels
	* @private
	*/
	getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
	},

	determineDataLimits: function() {
		var me = this;
		var labels = me.getLabels();
		me.minIndex = 0;
		me.maxIndex = labels.length - 1;
		var findIndex;

		if (me.options.ticks.min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(me.options.ticks.min);
			me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
		}

		if (me.options.ticks.max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(me.options.ticks.max);
			me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
		}

		me.min = labels[me.minIndex];
		me.max = labels[me.maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me.getLabels();
		// If we are viewing some subset of labels, slice the original array
		me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me.ticks[index - me.minIndex];
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index) {
		var me = this;
		var offset = me.options.offset;
		// 1 is added because we need the length but we have the indexes
		var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		var valueCategory;
		if (value !== undefined && value !== null) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			var labels = me.getLabels();
			value = valueCategory || value;
			var idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
		}

		if (me.isHorizontal()) {
			var valueWidth = me.width / offsetAmt;
			var widthOffset = (valueWidth * (index - me.minIndex));

			if (offset) {
				widthOffset += (valueWidth / 2);
			}

			return me.left + widthOffset;
		}
		var valueHeight = me.height / offsetAmt;
		var heightOffset = (valueHeight * (index - me.minIndex));

		if (offset) {
			heightOffset += (valueHeight / 2);
		}

		return me.top + heightOffset;
	},

	getPixelForTick: function(index) {
		return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offset = me.options.offset;
		var value;
		var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
		var horz = me.isHorizontal();
		var valueDimension = (horz ? me.width : me.height) / offsetAmt;

		pixel -= horz ? me.left : me.top;

		if (offset) {
			pixel -= (valueDimension / 2);
		}

		if (pixel <= 0) {
			value = 0;
		} else {
			value = Math.round(pixel / valueDimension);
		}

		return value + me.minIndex;
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef(min) && isNullOrUndef(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var data = chart.data;
		var datasets = data.datasets;
		var isHorizontal = me.isHorizontal();
		var DEFAULT_MIN = 0;
		var DEFAULT_MAX = 1;

		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}

		// First Calculate the range
		me.min = null;
		me.max = null;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			helpers$1.each(datasets, function(dataset, datasetIndex) {
				if (hasStacks) {
					return;
				}

				var meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
				}
			});
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			helpers$1.each(datasets, function(dataset, datasetIndex) {
				var meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (valuesPerStack[key] === undefined) {
					valuesPerStack[key] = {
						positiveValues: [],
						negativeValues: []
					};
				}

				// Store these per type
				var positiveValues = valuesPerStack[key].positiveValues;
				var negativeValues = valuesPerStack[key].negativeValues;

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						positiveValues[index] = positiveValues[index] || 0;
						negativeValues[index] = negativeValues[index] || 0;

						if (opts.relativePoints) {
							positiveValues[index] = 100;
						} else if (value < 0) {
							negativeValues[index] += value;
						} else {
							positiveValues[index] += value;
						}
					});
				}
			});

			helpers$1.each(valuesPerStack, function(valuesForType) {
				var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
				var minVal = helpers$1.min(values);
				var maxVal = helpers$1.max(values);
				me.min = me.min === null ? minVal : Math.min(me.min, minVal);
				me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
			});

		} else {
			helpers$1.each(datasets, function(dataset, datasetIndex) {
				var meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						if (me.min === null) {
							me.min = value;
						} else if (value < me.min) {
							me.min = value;
						}

						if (me.max === null) {
							me.max = value;
						} else if (value > me.max) {
							me.max = value;
						}
					});
				}
			});
		}

		me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		this.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		// This must be called after fit has been run so that
		// this.left, this.top, this.right, and this.bottom have been defined
		var me = this;
		var start = me.start;

		var rightValue = +me.getRightValue(value);
		var pixel;
		var range = me.end - start;

		if (me.isHorizontal()) {
			pixel = me.left + (me.width / range * (rightValue - start));
		} else {
			pixel = me.bottom - (me.height / range * (rightValue - start));
		}
		return pixel;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		var innerDimension = isHorizontal ? me.width : me.height;
		var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
		return me.start + ((me.end - me.start) * offset);
	},

	getPixelForTick: function(index) {
		return this.getPixelForValue(this.ticksAsNumbers[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$a = helpers$1.valueOrDefault;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$a(generationOptions.min, Math.pow(10, Math.floor(helpers$1.log10(dataRange.min))));

	var endExp = Math.floor(helpers$1.log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(helpers$1.log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(helpers$1.log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$a(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var data = chart.data;
		var datasets = data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}

		// Calculate Range
		me.min = null;
		me.max = null;
		me.minNotZero = null;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			helpers$1.each(datasets, function(dataset, datasetIndex) {
				if (hasStacks) {
					return;
				}

				var meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
				}
			});
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			helpers$1.each(datasets, function(dataset, datasetIndex) {
				var meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					helpers$1.each(dataset.data, function(rawValue, index) {
						var values = valuesPerStack[key];
						var value = +me.getRightValue(rawValue);
						// invalid, hidden and negative values are ignored
						if (isNaN(value) || meta.data[index].hidden || value < 0) {
							return;
						}
						values[index] = values[index] || 0;
						values[index] += value;
					});
				}
			});

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				}
			});

		} else {
			helpers$1.each(datasets, function(dataset, datasetIndex) {
				var meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						// invalid, hidden and negative values are ignored
						if (isNaN(value) || meta.data[index].hidden || value < 0) {
							return;
						}

						if (me.min === null) {
							me.min = value;
						} else if (value < me.min) {
							me.min = value;
						}

						if (me.max === null) {
							me.max = value;
						} else if (value > me.max) {
							me.max = value;
						}

						if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
							me.minNotZero = value;
						}
					});
				}
			});
		}

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(helpers$1.log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(helpers$1.log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(helpers$1.log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(helpers$1.log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(helpers$1.log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		return this.getPixelForValue(this.tickValues[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(helpers$1.log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	getPixelForValue: function(value) {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = tickOpts.reverse;
		var log10 = helpers$1.log10;
		var firstTickValue = me._getFirstTickValue(me.minNotZero);
		var offset = 0;
		var innerDimension, pixel, start, end, sign;

		value = +me.getRightValue(value);
		if (reverse) {
			start = me.end;
			end = me.start;
			sign = -1;
		} else {
			start = me.start;
			end = me.end;
			sign = 1;
		}
		if (me.isHorizontal()) {
			innerDimension = me.width;
			pixel = reverse ? me.right : me.left;
		} else {
			innerDimension = me.height;
			sign *= -1; // invert, since the upper-left corner of the canvas is at pixel (0, 0)
			pixel = reverse ? me.top : me.bottom;
		}
		if (value !== start) {
			if (start === 0) { // include zero tick
				offset = valueOrDefault$a(tickOpts.fontSize, core_defaults.global.defaultFontSize);
				innerDimension -= offset;
				start = firstTickValue;
			}
			if (value !== 0) {
				offset += innerDimension / (log10(end) - log10(start)) * (log10(value) - log10(start));
			}
			pixel += sign * offset;
		}
		return pixel;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = tickOpts.reverse;
		var log10 = helpers$1.log10;
		var firstTickValue = me._getFirstTickValue(me.minNotZero);
		var innerDimension, start, end, value;

		if (reverse) {
			start = me.end;
			end = me.start;
		} else {
			start = me.start;
			end = me.end;
		}
		if (me.isHorizontal()) {
			innerDimension = me.width;
			value = reverse ? me.right - pixel : pixel - me.left;
		} else {
			innerDimension = me.height;
			value = reverse ? pixel - me.top : me.bottom - pixel;
		}
		if (value !== start) {
			if (start === 0) { // include zero tick
				var offset = valueOrDefault$a(tickOpts.fontSize, core_defaults.global.defaultFontSize);
				value -= offset;
				innerDimension -= offset;
				start = firstTickValue;
			}
			value *= log10(end) - log10(start);
			value /= innerDimension;
			value = Math.pow(10, log10(start) + value);
		}
		return value;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$b = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$7 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0, 0, 0, 0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getValueCount(scale) {
	var opts = scale.options;
	return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
}

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$b(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = getValueCount(scale);
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i] || '');
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var angleLineOpts = opts.angleLines;
	var gridLineOpts = opts.gridLines;
	var pointLabelOpts = opts.pointLabels;
	var lineWidth = valueOrDefault$b(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
	var lineColor = valueOrDefault$b(angleLineOpts.color, gridLineOpts.color);
	var tickBackdropHeight = getTickBackdropHeight(opts);

	ctx.save();
	ctx.lineWidth = lineWidth;
	ctx.strokeStyle = lineColor;
	if (ctx.setLineDash) {
		ctx.setLineDash(resolve$7([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
		ctx.lineDashOffset = resolve$7([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
	}

	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

	// Point Label Font
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = getValueCount(scale) - 1; i >= 0; i--) {
		if (angleLineOpts.display && lineWidth && lineColor) {
			var outerPosition = scale.getPointPosition(i, outerDistance);
			ctx.beginPath();
			ctx.moveTo(scale.xCenter, scale.yCenter);
			ctx.lineTo(outerPosition.x, outerPosition.y);
			ctx.stroke();
		}

		if (pointLabelOpts.display) {
			// Extra pixels out for some label spacing
			var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
			var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

			// Keep this in loop since we may support array properties here
			var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
			ctx.fillStyle = pointLabelFontColor;

			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians);
			ctx.textAlign = getTextAlignForAngle(angle);
			adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
			fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.lineHeight);
		}
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = getValueCount(scale);
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var angleMultiplier = (Math.PI * 2) / getValueCount(this);
		var startAngle = this.chart.options && this.chart.options.startAngle ?
			this.chart.options.startAngle :
			0;

		var startAngleRadians = startAngle * Math.PI * 2 / 360;

		// Start from the top instead of right, so remove a quarter of the circle
		return index * angleMultiplier + startAngleRadians;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (value === null) {
			return 0; // null always in center
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	draw: function() {
		var me = this;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var tickOpts = opts.ticks;

		if (opts.display) {
			var ctx = me.ctx;
			var startAngle = this.getIndexAngle(0);
			var tickFont = helpers$1.options._parseFont(tickOpts);

			if (opts.angleLines.display || opts.pointLabels.display) {
				drawPointLabels(me);
			}

			helpers$1.each(me.ticks, function(label, index) {
				// Don't draw a centre value (if it is minimum)
				if (index > 0 || tickOpts.reverse) {
					var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

					// Draw circular lines around the scale
					if (gridLineOpts.display && index !== 0) {
						drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
					}

					if (tickOpts.display) {
						var tickFontColor = valueOrDefault$b(tickOpts.fontColor, core_defaults.global.defaultFontColor);
						ctx.font = tickFont.string;

						ctx.save();
						ctx.translate(me.xCenter, me.yCenter);
						ctx.rotate(startAngle);

						if (tickOpts.showLabelBackdrop) {
							var labelWidth = ctx.measureText(label).width;
							ctx.fillStyle = tickOpts.backdropColor;
							ctx.fillRect(
								-labelWidth / 2 - tickOpts.backdropPaddingX,
								-yCenterOffset - tickFont.size / 2 - tickOpts.backdropPaddingY,
								labelWidth + tickOpts.backdropPaddingX * 2,
								tickFont.size + tickOpts.backdropPaddingY * 2
							);
						}

						ctx.textAlign = 'center';
						ctx.textBaseline = 'middle';
						ctx.fillStyle = tickFontColor;
						ctx.fillText(label, 0, -yCenterOffset);
						ctx.restore();
					}
				}
			});
		}
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var valueOrDefault$c = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
	},
	second: {
		common: true,
		size: 1000,
		steps: [1, 2, 5, 10, 15, 30]
	},
	minute: {
		common: true,
		size: 60000,
		steps: [1, 2, 5, 10, 15, 30]
	},
	hour: {
		common: true,
		size: 3600000,
		steps: [1, 2, 3, 6, 12]
	},
	day: {
		common: true,
		size: 86400000,
		steps: [1, 2, 5]
	},
	week: {
		common: false,
		size: 604800000,
		steps: [1, 2, 3, 4]
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: [1, 2, 3]
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: [1, 2, 3, 4]
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
 */
function determineStepSize(min, max, unit, capacity) {
	var range = max - min;
	var interval = INTERVALS[unit];
	var milliseconds = interval.size;
	var steps = interval.steps;
	var i, ilen, factor;

	if (!steps) {
		return Math.ceil(range / (capacity * milliseconds));
	}

	for (i = 0, ilen = steps.length; i < ilen; ++i) {
		factor = steps[i];
		if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
			break;
		}
	}

	return factor;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, ticks, minUnit, min, max) {
	var ilen = UNITS.length;
	var i, unit;

	for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= ticks.length) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var major = determineMajorUnit(minor);
	var stepSize = valueOrDefault$c(timeOpts.stepSize, timeOpts.unitStepSize);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var majorTicksEnabled = options.ticks.major.enabled;
	var interval = INTERVALS[minor];
	var first = min;
	var last = max;
	var ticks = [];
	var time;

	if (!stepSize) {
		stepSize = determineStepSize(min, max, minor, capacity);
	}

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
		last = +adapter.startOf(last, 'isoWeek', weekday);
	}

	// Align first/last ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);
	last = +adapter.startOf(last, weekday ? 'day' : minor);

	// Make sure that the last tick include max
	if (last < max) {
		last = +adapter.add(last, 1, minor);
	}

	time = first;

	if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
		// Align the first tick on the previous `minor` unit aligned on the `major` unit:
		// we first aligned time on the previous `major` unit then add the number of full
		// stepSize there is between first and the previous major time.
		time = +adapter.startOf(time, major);
		time = +adapter.add(time, ~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
	}

	for (; time < last; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(+time);
	}

	ticks.push(+time);

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		if (!options.time.min) {
			first = interpolate$1(table, 'time', ticks[0], 'pos');
			if (ticks.length === 1) {
				start = 1 - first;
			} else {
				start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
			}
		}
		if (!options.time.max) {
			last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
			if (ticks.length === 1) {
				end = last;
			} else {
				end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
			}
		}
	}

	return {start: start, end: end};
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var i, ilen, value, major;

	for (i = 0, ilen = values.length; i < ilen; ++i) {
		value = values[i];
		major = majorUnit ? value === +scale._adapter.startOf(value, majorUnit) : false;

		ticks.push({
			value: value,
			major: major
		});
	}

	return ticks;
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from https://momentjs.com/docs/#/parsing/string-format/
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		if (time.format) {
			console.warn('options.time.format is deprecated and replaced by options.time.parser.');
		}

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var timeOpts = me.options.time;
		var unit = timeOpts.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp;
		var dataLabels = chart.data.labels || [];

		// Convert labels to timestamps
		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		// Convert data to timestamps
		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					for (j = 0, jlen = labels.length; j < jlen; ++j) {
						timestamps.push(labels[j]);
					}
					datasets[i] = labels.slice(0);
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			// Sort labels **after** data have been converted
			labels = arrayUnique(labels).sort(sorter);
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = arrayUnique(timestamps).sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, timeOpts.min) || min;
		max = parse(me, timeOpts.max) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._horizontal = me.isHorizontal();
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var timeOpts = options.time;
		var timestamps = [];
		var ticks = [];
		var i, ilen, timestamp;

		switch (options.ticks.source) {
		case 'data':
			timestamps = me._timestamps.data;
			break;
		case 'labels':
			timestamps = me._timestamps.labels;
			break;
		case 'auto':
		default:
			timestamps = generate(me, min, max, me.getLabelCapacity(min), options);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, timeOpts.min) || min;
		max = parse(me, timeOpts.max) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		me._unit = timeOpts.unit || determineUnitForFormatting(me, ticks, timeOpts.minUnit, me.min, me.max);
		me._majorUnit = determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (options.ticks.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var majorTime = +adapter.startOf(time, majorUnit);
		var majorTickOpts = options.ticks.major;
		var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var tickOpts = major ? majorTickOpts : options.ticks.minor;
		var formatter = valueOrDefault$c(tickOpts.callback, tickOpts.userCallback);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var isReverse = me.options.ticks.reverse;
		var size = me._horizontal ? me.width : me.height;
		var start = me._horizontal ? isReverse ? me.right : me.left : isReverse ? me.bottom : me.top;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		var offset = size * (me._offsets.start + pos) / (me._offsets.start + 1 + me._offsets.end);

		return isReverse ? start - offset : start + offset;
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var size = me._horizontal ? me.width : me.height;
		var start = me._horizontal ? me.left : me.top;
		var pos = (size ? (pixel - start) / size : 0) * (me._offsets.start + 1 + me._offsets.start) - me._offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(ticksOpts.maxRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$c(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;

		// pick the longest format (milliseconds) for guestimation
		var format = me.options.time.displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, [], format);
		var tickLabelWidth = me.getLabelWidth(exampleLabel);
		var innerWidth = me.isHorizontal() ? me.width : me.height;
		var capacity = Math.floor(innerWidth / tickLabelWidth);

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment.duration(moment(max).diff(moment(min))).as(unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePosition) {
		target = scale.getBasePosition();
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1;

	ctx.beginPath();

	for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetDraw: function(chart, args) {
		var meta = args.meta.$filler;
		if (!meta) {
			return;
		}

		var ctx = chart.ctx;
		var el = meta.el;
		var view = el._view;
		var points = el._children || [];
		var mapper = meta.mapper;
		var color = view.backgroundColor || core_defaults.global.defaultColor;

		if (mapper && color && points.length) {
			helpers$1.canvas.clipArea(ctx, chart.chartArea);
			doFill(ctx, points, mapper, view, color, el._loop);
			helpers$1.canvas.unclipArea(ctx);
		}
	}
};

var noop$1 = helpers$1.noop;
var valueOrDefault$d = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var data = chart.data;
				return helpers$1.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
					return {
						text: dataset.label,
						fillStyle: (!helpers$1.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
						hidden: !chart.isDatasetVisible(i),
						lineCap: dataset.borderCapStyle,
						lineDash: dataset.borderDash,
						lineDashOffset: dataset.borderDashOffset,
						lineJoin: dataset.borderJoinStyle,
						lineWidth: dataset.borderWidth,
						strokeStyle: dataset.borderColor,
						pointStyle: dataset.pointStyle,

						// Below is extra data used for toggling the datasets
						datasetIndex: i
					};
				}, this) : [];
			}
		}
	},

	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');
		for (var i = 0; i < chart.data.datasets.length; i++) {
			text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
			if (chart.data.datasets[i].label) {
				text.push(chart.data.datasets[i].label);
			}
			text.push('</li>');
		}
		text.push('</ul>');
		return text.join('');
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		helpers$1.extend(this, config);

		// Contains hit boxes for each dataset (in dataset order)
		this.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		this._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		this.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (display) {
			ctx.font = labelFont.string;

			if (isHorizontal) {
				// Labels

				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = 0;

				ctx.textAlign = 'left';
				ctx.textBaseline = 'top';

				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					if (i === 0 || lineWidths[lineWidths.length - 1] + width + labelOpts.padding > minSize.width) {
						totalHeight += fontSize + labelOpts.padding;
						lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = labelOpts.padding;
					}

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};

					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});

				minSize.height += totalHeight;

			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
				var itemHeight = fontSize + vPadding;

				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					// If too tall, go to new column
					if (i > 0 && currentColHeight + itemHeight > minSize.height - vPadding) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width

						currentColWidth = 0;
						currentColHeight = 0;
					}

					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += itemHeight;

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});

				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				minSize.width += totalWidth;
			}
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (opts.display) {
			var ctx = me.ctx;
			var fontColor = valueOrDefault$d(labelOpts.fontColor, globalDefaults.defaultFontColor);
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
			var cursor;

			// Canvas setup
			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont.string;

			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;

			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}

				// Set the ctx for the box
				ctx.save();

				var lineWidth = valueOrDefault$d(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.fillStyle = valueOrDefault$d(legendItem.fillStyle, defaultColor);
				ctx.lineCap = valueOrDefault$d(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault$d(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault$d(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = valueOrDefault$d(legendItem.strokeStyle, defaultColor);

				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault$d(legendItem.lineDash, lineDefault.borderDash));
				}

				if (opts.labels && opts.labels.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = boxWidth * Math.SQRT2 / 2;
					var centerX = x + boxWidth / 2;
					var centerY = y + fontSize / 2;

					// Draw pointStyle as legend symbol
					helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
				} else {
					// Draw box as legend symbol
					if (lineWidth !== 0) {
						ctx.strokeRect(x, y, boxWidth, fontSize);
					}
					ctx.fillRect(x, y, boxWidth, fontSize);
				}

				ctx.restore();
			};
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = boxWidth + halfFontSize + x;
				var yMiddle = y + halfFontSize;

				ctx.fillText(legendItem.text, xLeft, yMiddle);

				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(xLeft + textWidth, yMiddle);
					ctx.stroke();
				}
			};

			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + ((legendWidth - lineWidths[0]) / 2) + labelOpts.padding,
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + labelOpts.padding,
					line: 0
				};
			}

			var itemHeight = fontSize + labelOpts.padding;
			helpers$1.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;

				// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
				// instead of me.right and me.bottom because me.width and me.height
				// may have been changed since me.minSize was calculated
				if (isHorizontal) {
					if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2) + labelOpts.padding;
					}
				} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					y = cursor.y = me.top + labelOpts.padding;
					cursor.line++;
				}

				drawLegendBox(x, y, legendItem);

				hitboxes[i].left = x;
				hitboxes[i].top = y;

				// Fill the actual label
				fillText(x, y, legendItem, textWidth);

				if (isHorizontal) {
					cursor.x += width + labelOpts.padding;
				} else {
					cursor.y += itemHeight;
				}

			});
		}
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var display = opts.display;
		var minSize = me.minSize;
		var lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		var fontOpts = helpers$1.options._parseFont(opts);
		var textSize = display ? (lineCount * fontOpts.lineHeight) + (opts.padding * 2) : 0;

		if (me.isHorizontal()) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = textSize;
		} else {
			minSize.width = textSize;
			minSize.height = me.maxHeight; // fill all the height
		}

		me.width = minSize.width;
		me.height = minSize.height;

	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (opts.display) {
			var fontOpts = helpers$1.options._parseFont(opts);
			var lineHeight = fontOpts.lineHeight;
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;

			ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
			ctx.font = fontOpts.string;

			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}

			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			var text = opts.text;
			if (helpers$1.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}

			ctx.restore();
		}
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers(core_controller);

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(673);
module.exports = __webpack_require__(50).RegExp.escape;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);
var isArray = __webpack_require__(95);
var SPECIES = __webpack_require__(31)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(28);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(58);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(72);
var gOPS = __webpack_require__(99);
var pIE = __webpack_require__(87);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(88)('native-function-to-string', Function.toString);


/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(8);
var $re = __webpack_require__(672)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(8);

$export($export.P, 'Array', { copyWithin: __webpack_require__(447) });

__webpack_require__(64)('copyWithin');


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $every = __webpack_require__(55)(4);

$export($export.P + $export.F * !__webpack_require__(52)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(8);

$export($export.P, 'Array', { fill: __webpack_require__(108) });

__webpack_require__(64)('fill');


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $filter = __webpack_require__(55)(2);

$export($export.P + $export.F * !__webpack_require__(52)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(8);
var $find = __webpack_require__(55)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(64)(KEY);


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(8);
var $find = __webpack_require__(55)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(64)(KEY);


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $forEach = __webpack_require__(55)(0);
var STRICT = __webpack_require__(52)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(51);
var $export = __webpack_require__(8);
var toObject = __webpack_require__(36);
var call = __webpack_require__(458);
var isArrayIter = __webpack_require__(116);
var toLength = __webpack_require__(32);
var createProperty = __webpack_require__(110);
var getIterFn = __webpack_require__(132);

$export($export.S + $export.F * !__webpack_require__(97)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $indexOf = __webpack_require__(92)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(52)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(8);

$export($export.S, 'Array', { isArray: __webpack_require__(95) });


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(8);
var toIObject = __webpack_require__(46);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(86) != Object || !__webpack_require__(52)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toIObject = __webpack_require__(46);
var toInteger = __webpack_require__(53);
var toLength = __webpack_require__(32);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(52)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $map = __webpack_require__(55)(1);

$export($export.P + $export.F * !__webpack_require__(52)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var createProperty = __webpack_require__(110);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(28)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $reduce = __webpack_require__(449);

$export($export.P + $export.F * !__webpack_require__(52)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $reduce = __webpack_require__(449);

$export($export.P + $export.F * !__webpack_require__(52)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var html = __webpack_require__(114);
var cof = __webpack_require__(49);
var toAbsoluteIndex = __webpack_require__(76);
var toLength = __webpack_require__(32);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(28)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $some = __webpack_require__(55)(3);

$export($export.P + $export.F * !__webpack_require__(52)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var aFunction = __webpack_require__(37);
var toObject = __webpack_require__(36);
var fails = __webpack_require__(28);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(52)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75)('Array');


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(8);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(8);
var toISOString = __webpack_require__(668);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(58);

$export($export.P + $export.F * __webpack_require__(28)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(31)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(39)(proto, TO_PRIMITIVE, __webpack_require__(669));


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(40)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(8);

$export($export.P, 'Function', { bind: __webpack_require__(450) });


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(45);
var HAS_INSTANCE = __webpack_require__(31)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(34).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(34).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(33) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(8);
var log1p = __webpack_require__(461);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(8);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(8);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(8);
var sign = __webpack_require__(120);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(8);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(8);
var $expm1 = __webpack_require__(119);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', { fround: __webpack_require__(460) });


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(8);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(8);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(28)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', { log1p: __webpack_require__(461) });


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', { sign: __webpack_require__(120) });


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(8);
var expm1 = __webpack_require__(119);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(28)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(8);
var expm1 = __webpack_require__(119);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(27);
var has = __webpack_require__(43);
var cof = __webpack_require__(49);
var inheritIfRequired = __webpack_require__(115);
var toPrimitive = __webpack_require__(58);
var fails = __webpack_require__(28);
var gOPN = __webpack_require__(71).f;
var gOPD = __webpack_require__(44).f;
var dP = __webpack_require__(34).f;
var $trim = __webpack_require__(84).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(70)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(33) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(40)(global, NUMBER, $Number);
}


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(8);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(8);
var _isFinite = __webpack_require__(27).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(8);

$export($export.S, 'Number', { isInteger: __webpack_require__(457) });


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(8);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(8);
var isInteger = __webpack_require__(457);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(8);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(8);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseFloat = __webpack_require__(469);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseInt = __webpack_require__(470);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toInteger = __webpack_require__(53);
var aNumberValue = __webpack_require__(446);
var repeat = __webpack_require__(127);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(28)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $fails = __webpack_require__(28);
var aNumberValue = __webpack_require__(446);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(8);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(463) });


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(70) });


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperties: __webpack_require__(464) });


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperty: __webpack_require__(34).f });


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(29);
var meta = __webpack_require__(66).onFreeze;

__webpack_require__(57)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(46);
var $getOwnPropertyDescriptor = __webpack_require__(44).f;

__webpack_require__(57)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(57)('getOwnPropertyNames', function () {
  return __webpack_require__(465).f;
});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(36);
var $getPrototypeOf = __webpack_require__(45);

__webpack_require__(57)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(29);

__webpack_require__(57)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(29);

__webpack_require__(57)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(29);

__webpack_require__(57)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(8);
$export($export.S, 'Object', { is: __webpack_require__(473) });


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(36);
var $keys = __webpack_require__(72);

__webpack_require__(57)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(29);
var meta = __webpack_require__(66).onFreeze;

__webpack_require__(57)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(29);
var meta = __webpack_require__(66).onFreeze;

__webpack_require__(57)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(8);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(124).set });


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(81);
var test = {};
test[__webpack_require__(31)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(40)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseFloat = __webpack_require__(469);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseInt = __webpack_require__(470);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(65);
var global = __webpack_require__(27);
var ctx = __webpack_require__(51);
var classof = __webpack_require__(81);
var $export = __webpack_require__(8);
var isObject = __webpack_require__(29);
var aFunction = __webpack_require__(37);
var anInstance = __webpack_require__(68);
var forOf = __webpack_require__(69);
var speciesConstructor = __webpack_require__(89);
var task = __webpack_require__(129).set;
var microtask = __webpack_require__(121)();
var newPromiseCapabilityModule = __webpack_require__(122);
var perform = __webpack_require__(471);
var userAgent = __webpack_require__(105);
var promiseResolve = __webpack_require__(472);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(31)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(74)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(83)($Promise, PROMISE);
__webpack_require__(75)(PROMISE);
Wrapper = __webpack_require__(50)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(97)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(8);
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(26);
var rApply = (__webpack_require__(27).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(28)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(8);
var create = __webpack_require__(70);
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(26);
var isObject = __webpack_require__(29);
var fails = __webpack_require__(28);
var bind = __webpack_require__(450);
var rConstruct = (__webpack_require__(27).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(34);
var $export = __webpack_require__(8);
var anObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(58);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(28)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(8);
var gOPD = __webpack_require__(44).f;
var anObject = __webpack_require__(26);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(8);
var anObject = __webpack_require__(26);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(117)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(44);
var $export = __webpack_require__(8);
var anObject = __webpack_require__(26);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(8);
var getProto = __webpack_require__(45);
var anObject = __webpack_require__(26);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(44);
var getPrototypeOf = __webpack_require__(45);
var has = __webpack_require__(43);
var $export = __webpack_require__(8);
var isObject = __webpack_require__(29);
var anObject = __webpack_require__(26);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(8);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(8);
var anObject = __webpack_require__(26);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(8);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(468) });


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(8);
var anObject = __webpack_require__(26);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(8);
var setProto = __webpack_require__(124);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(34);
var gOPD = __webpack_require__(44);
var getPrototypeOf = __webpack_require__(45);
var has = __webpack_require__(43);
var $export = __webpack_require__(8);
var createDesc = __webpack_require__(73);
var anObject = __webpack_require__(26);
var isObject = __webpack_require__(29);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(27);
var inheritIfRequired = __webpack_require__(115);
var dP = __webpack_require__(34).f;
var gOPN = __webpack_require__(71).f;
var isRegExp = __webpack_require__(96);
var $flags = __webpack_require__(85);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(33) && (!CORRECT_NEW || __webpack_require__(28)(function () {
  re2[__webpack_require__(31)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(40)(global, 'RegExp', $RegExp);
}

__webpack_require__(75)('RegExp');


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(26);
var toLength = __webpack_require__(32);
var advanceStringIndex = __webpack_require__(107);
var regExpExec = __webpack_require__(100);

// @@match logic
__webpack_require__(94)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(26);
var toObject = __webpack_require__(36);
var toLength = __webpack_require__(32);
var toInteger = __webpack_require__(53);
var advanceStringIndex = __webpack_require__(107);
var regExpExec = __webpack_require__(100);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(94)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(26);
var sameValue = __webpack_require__(473);
var regExpExec = __webpack_require__(100);

// @@search logic
__webpack_require__(94)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(96);
var anObject = __webpack_require__(26);
var speciesConstructor = __webpack_require__(89);
var advanceStringIndex = __webpack_require__(107);
var toLength = __webpack_require__(32);
var callRegExpExec = __webpack_require__(100);
var regexpExec = __webpack_require__(123);
var fails = __webpack_require__(28);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(94)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(479);
var anObject = __webpack_require__(26);
var $flags = __webpack_require__(85);
var DESCRIPTORS = __webpack_require__(33);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(40)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(28)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(41)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(41)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(41)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(41)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $at = __webpack_require__(103)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(8);
var toLength = __webpack_require__(32);
var context = __webpack_require__(126);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(113)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(41)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(41)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(41)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var toAbsoluteIndex = __webpack_require__(76);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(8);
var context = __webpack_require__(126);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(113)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(41)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(103)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(118)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(41)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var toIObject = __webpack_require__(46);
var toLength = __webpack_require__(32);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(127)
});


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(41)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(8);
var toLength = __webpack_require__(32);
var context = __webpack_require__(126);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(113)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(41)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(41)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(41)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(84)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(27);
var has = __webpack_require__(43);
var DESCRIPTORS = __webpack_require__(33);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(40);
var META = __webpack_require__(66).KEY;
var $fails = __webpack_require__(28);
var shared = __webpack_require__(88);
var setToStringTag = __webpack_require__(83);
var uid = __webpack_require__(77);
var wks = __webpack_require__(31);
var wksExt = __webpack_require__(476);
var wksDefine = __webpack_require__(131);
var enumKeys = __webpack_require__(670);
var isArray = __webpack_require__(95);
var anObject = __webpack_require__(26);
var isObject = __webpack_require__(29);
var toObject = __webpack_require__(36);
var toIObject = __webpack_require__(46);
var toPrimitive = __webpack_require__(58);
var createDesc = __webpack_require__(73);
var _create = __webpack_require__(70);
var gOPNExt = __webpack_require__(465);
var $GOPD = __webpack_require__(44);
var $GOPS = __webpack_require__(99);
var $DP = __webpack_require__(34);
var $keys = __webpack_require__(72);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(71).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(87).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(65)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(39)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $typed = __webpack_require__(104);
var buffer = __webpack_require__(130);
var anObject = __webpack_require__(26);
var toAbsoluteIndex = __webpack_require__(76);
var toLength = __webpack_require__(32);
var isObject = __webpack_require__(29);
var ArrayBuffer = __webpack_require__(27).ArrayBuffer;
var speciesConstructor = __webpack_require__(89);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(28)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(75)(ARRAY_BUFFER);


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
$export($export.G + $export.W + $export.F * !__webpack_require__(104).ABV, {
  DataView: __webpack_require__(130).DataView
});


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(453);
var validate = __webpack_require__(78);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(93)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(8);
var flattenIntoArray = __webpack_require__(454);
var toObject = __webpack_require__(36);
var toLength = __webpack_require__(32);
var aFunction = __webpack_require__(37);
var arraySpeciesCreate = __webpack_require__(109);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(64)('flatMap');


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(8);
var flattenIntoArray = __webpack_require__(454);
var toObject = __webpack_require__(36);
var toLength = __webpack_require__(32);
var toInteger = __webpack_require__(53);
var arraySpeciesCreate = __webpack_require__(109);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(64)('flatten');


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(8);
var $includes = __webpack_require__(92)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(64)('includes');


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(8);
var microtask = __webpack_require__(121)();
var process = __webpack_require__(27).process;
var isNode = __webpack_require__(49)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(8);
var cof = __webpack_require__(49);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(8);

$export($export.G, { global: __webpack_require__(27) });


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(101)('Map');


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(102)('Map');


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(8);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(452)('Map') });


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);
var scale = __webpack_require__(462);
var fround = __webpack_require__(460);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', { scale: __webpack_require__(462) });


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(8);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(36);
var aFunction = __webpack_require__(37);
var $defineProperty = __webpack_require__(34);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(33) && $export($export.P + __webpack_require__(98), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(36);
var aFunction = __webpack_require__(37);
var $defineProperty = __webpack_require__(34);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(33) && $export($export.P + __webpack_require__(98), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(8);
var $entries = __webpack_require__(467)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(8);
var ownKeys = __webpack_require__(468);
var toIObject = __webpack_require__(46);
var gOPD = __webpack_require__(44);
var createProperty = __webpack_require__(110);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(58);
var getPrototypeOf = __webpack_require__(45);
var getOwnPropertyDescriptor = __webpack_require__(44).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(33) && $export($export.P + __webpack_require__(98), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(58);
var getPrototypeOf = __webpack_require__(45);
var getOwnPropertyDescriptor = __webpack_require__(44).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(33) && $export($export.P + __webpack_require__(98), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(8);
var $values = __webpack_require__(467)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(8);
var global = __webpack_require__(27);
var core = __webpack_require__(50);
var microtask = __webpack_require__(121)();
var OBSERVABLE = __webpack_require__(31)('observable');
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(26);
var anInstance = __webpack_require__(68);
var redefineAll = __webpack_require__(74);
var hide = __webpack_require__(39);
var forOf = __webpack_require__(69);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(75)('Observable');


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(8);
var core = __webpack_require__(50);
var global = __webpack_require__(27);
var speciesConstructor = __webpack_require__(89);
var promiseResolve = __webpack_require__(472);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(122);
var perform = __webpack_require__(471);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(26);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(26);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(480);
var from = __webpack_require__(448);
var metadata = __webpack_require__(60);
var anObject = __webpack_require__(26);
var getPrototypeOf = __webpack_require__(45);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(26);
var getPrototypeOf = __webpack_require__(45);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(26);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(26);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(26);
var getPrototypeOf = __webpack_require__(45);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(26);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(60);
var anObject = __webpack_require__(26);
var aFunction = __webpack_require__(37);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(101)('Set');


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(102)('Set');


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(8);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(452)('Set') });


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(8);
var $at = __webpack_require__(103)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(8);
var defined = __webpack_require__(56);
var toLength = __webpack_require__(32);
var isRegExp = __webpack_require__(96);
var getFlags = __webpack_require__(85);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(117)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(8);
var $pad = __webpack_require__(474);
var userAgent = __webpack_require__(105);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(8);
var $pad = __webpack_require__(474);
var userAgent = __webpack_require__(105);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(84)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(84)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(131)('asyncIterator');


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(131)('observable');


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(8);

$export($export.S, 'System', { global: __webpack_require__(27) });


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(101)('WeakMap');


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(102)('WeakMap');


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(101)('WeakSet');


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(102)('WeakSet');


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(133);
var getKeys = __webpack_require__(72);
var redefine = __webpack_require__(40);
var global = __webpack_require__(27);
var hide = __webpack_require__(39);
var Iterators = __webpack_require__(82);
var wks = __webpack_require__(31);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $task = __webpack_require__(129);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(27);
var $export = __webpack_require__(8);
var userAgent = __webpack_require__(105);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(793);
__webpack_require__(732);
__webpack_require__(734);
__webpack_require__(733);
__webpack_require__(736);
__webpack_require__(738);
__webpack_require__(743);
__webpack_require__(737);
__webpack_require__(735);
__webpack_require__(745);
__webpack_require__(744);
__webpack_require__(740);
__webpack_require__(741);
__webpack_require__(739);
__webpack_require__(731);
__webpack_require__(742);
__webpack_require__(746);
__webpack_require__(747);
__webpack_require__(699);
__webpack_require__(701);
__webpack_require__(700);
__webpack_require__(749);
__webpack_require__(748);
__webpack_require__(719);
__webpack_require__(729);
__webpack_require__(730);
__webpack_require__(720);
__webpack_require__(721);
__webpack_require__(722);
__webpack_require__(723);
__webpack_require__(724);
__webpack_require__(725);
__webpack_require__(726);
__webpack_require__(727);
__webpack_require__(728);
__webpack_require__(702);
__webpack_require__(703);
__webpack_require__(704);
__webpack_require__(705);
__webpack_require__(706);
__webpack_require__(707);
__webpack_require__(708);
__webpack_require__(709);
__webpack_require__(710);
__webpack_require__(711);
__webpack_require__(712);
__webpack_require__(713);
__webpack_require__(714);
__webpack_require__(715);
__webpack_require__(716);
__webpack_require__(717);
__webpack_require__(718);
__webpack_require__(780);
__webpack_require__(785);
__webpack_require__(792);
__webpack_require__(783);
__webpack_require__(775);
__webpack_require__(776);
__webpack_require__(781);
__webpack_require__(786);
__webpack_require__(788);
__webpack_require__(771);
__webpack_require__(772);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(782);
__webpack_require__(784);
__webpack_require__(787);
__webpack_require__(789);
__webpack_require__(790);
__webpack_require__(791);
__webpack_require__(694);
__webpack_require__(696);
__webpack_require__(695);
__webpack_require__(698);
__webpack_require__(697);
__webpack_require__(683);
__webpack_require__(681);
__webpack_require__(687);
__webpack_require__(684);
__webpack_require__(690);
__webpack_require__(692);
__webpack_require__(680);
__webpack_require__(686);
__webpack_require__(677);
__webpack_require__(691);
__webpack_require__(675);
__webpack_require__(689);
__webpack_require__(688);
__webpack_require__(682);
__webpack_require__(685);
__webpack_require__(674);
__webpack_require__(676);
__webpack_require__(679);
__webpack_require__(678);
__webpack_require__(693);
__webpack_require__(133);
__webpack_require__(765);
__webpack_require__(478);
__webpack_require__(770);
__webpack_require__(479);
__webpack_require__(766);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(769);
__webpack_require__(750);
__webpack_require__(477);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(805);
__webpack_require__(794);
__webpack_require__(795);
__webpack_require__(800);
__webpack_require__(803);
__webpack_require__(804);
__webpack_require__(798);
__webpack_require__(801);
__webpack_require__(799);
__webpack_require__(802);
__webpack_require__(796);
__webpack_require__(797);
__webpack_require__(751);
__webpack_require__(752);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(758);
__webpack_require__(756);
__webpack_require__(757);
__webpack_require__(759);
__webpack_require__(760);
__webpack_require__(761);
__webpack_require__(762);
__webpack_require__(764);
__webpack_require__(763);
__webpack_require__(808);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(849);
__webpack_require__(852);
__webpack_require__(851);
__webpack_require__(853);
__webpack_require__(854);
__webpack_require__(850);
__webpack_require__(855);
__webpack_require__(856);
__webpack_require__(830);
__webpack_require__(833);
__webpack_require__(829);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(831);
__webpack_require__(832);
__webpack_require__(814);
__webpack_require__(848);
__webpack_require__(813);
__webpack_require__(847);
__webpack_require__(859);
__webpack_require__(861);
__webpack_require__(812);
__webpack_require__(846);
__webpack_require__(858);
__webpack_require__(860);
__webpack_require__(811);
__webpack_require__(857);
__webpack_require__(810);
__webpack_require__(815);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(821);
__webpack_require__(820);
__webpack_require__(822);
__webpack_require__(823);
__webpack_require__(824);
__webpack_require__(826);
__webpack_require__(825);
__webpack_require__(835);
__webpack_require__(836);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(840);
__webpack_require__(839);
__webpack_require__(842);
__webpack_require__(841);
__webpack_require__(843);
__webpack_require__(844);
__webpack_require__(845);
__webpack_require__(809);
__webpack_require__(834);
__webpack_require__(864);
__webpack_require__(863);
__webpack_require__(862);
module.exports = __webpack_require__(50);


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".fss-act{border-radius:50%;display:inline-flex;align-items:center;justify-content:center;border:none;padding:0;cursor:pointer;transition:all .15s ease}.fss-act,.fss-act:focus,.fss-act:hover{color:#fff;text-decoration:none}.fss-act.fss-act--disabled,.fss-act:disabled{background:#d1d5db;color:#6b7280;box-shadow:none;cursor:not-allowed}.fss-act.fss-act--disabled:hover,.fss-act:disabled:hover{transform:none}.fss-act--sm{width:28px;height:28px;font-size:14px}.fss-act--md{width:36px;height:36px;font-size:18px}.fss-act--lg{width:44px;height:44px;font-size:20px}.fss-act--blue{background:#2563eb;box-shadow:0 2px 6px -1px rgba(37,99,235,.35)}.fss-act--green{background:#10b981;box-shadow:0 2px 6px -1px rgba(16,185,129,.35)}.fss-act--red{background:#ef4444;box-shadow:0 2px 6px -1px rgba(239,68,68,.35)}.fss-act--orange{background:#f59e0b;box-shadow:0 2px 6px -1px rgba(245,158,11,.35)}.fss-act:not(:disabled):not(.fss-act--disabled):hover{transform:translateY(-1px)}.fss-act--blue:not(:disabled):hover{background:#1d4ed8;box-shadow:0 4px 10px -2px rgba(37,99,235,.5)}.fss-act--green:not(:disabled):hover{background:#059669;box-shadow:0 4px 10px -2px rgba(16,185,129,.5)}.fss-act--red:not(:disabled):hover{background:#dc2626;box-shadow:0 4px 10px -2px rgba(239,68,68,.5)}.fss-act--orange:not(:disabled):hover{background:#d97706;box-shadow:0 4px 10px -2px rgba(245,158,11,.5)}.btn.fss-btn,.btn.fss-btn:active,.btn.fss-btn:focus,.btn.fss-btn:hover{color:#fff;border-color:transparent}.btn.fss-btn--orange{background:#f59e0b;box-shadow:0 2px 6px -1px rgba(245,158,11,.35)}.btn.fss-btn--green{background:#10b981;box-shadow:0 2px 6px -1px rgba(16,185,129,.35)}.btn.fss-btn--red{background:#ef4444;box-shadow:0 2px 6px -1px rgba(239,68,68,.35)}.btn.fss-btn--orange:active,.btn.fss-btn--orange:hover{background:#d97706}.btn.fss-btn--green:active,.btn.fss-btn--green:hover{background:#059669}.btn.fss-btn--red:active,.btn.fss-btn--red:hover{background:#dc2626}.btn.fss-btn--disabled,.btn.fss-btn--disabled:active,.btn.fss-btn--disabled:focus,.btn.fss-btn--disabled:hover{background:#d1d5db;color:#6b7280;box-shadow:none;cursor:not-allowed}.fss-act-group{gap:6px;white-space:nowrap}.fss-act-group,.fss-act-pill{display:inline-flex;align-items:center}.fss-act-pill{gap:10px;padding:10px 20px;border-radius:999px;background:#10b981;color:#fff;border:none;cursor:pointer;font-size:14px;font-weight:600;transition:all .15s ease;box-shadow:0 2px 8px -1px rgba(16,185,129,.4)}.fss-act-pill:hover:not(:disabled){background:#059669;color:#fff;transform:translateY(-1px);box-shadow:0 4px 12px -2px rgba(16,185,129,.55)}.fss-act-pill:disabled{background:#d1d5db;box-shadow:none;cursor:not-allowed}.fss-stepper{display:flex;align-items:stretch;gap:0;padding:4px 0}.fss-step{flex:1;background:#fff;border:1.5px solid #e5e7eb;border-radius:14px;padding:18px 20px;display:flex;align-items:center;gap:14px;transition:all .25s ease}.fss-step--done{border-color:#10b981;background:#f0fdf4}.fss-step--active{border-color:#2563eb;border-width:2px;background:#eff6ff;box-shadow:0 8px 20px -6px rgba(37,99,235,.25),0 2px 6px -2px rgba(37,99,235,.1);transform:translateY(-2px)}.fss-step__badge{width:44px;height:44px;border-radius:12px;background:#f3f4f6;color:#9ca3af;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:700;position:relative;flex-shrink:0;transition:all .2s}.fss-step--done .fss-step__badge{background:#10b981;color:#fff;box-shadow:0 4px 10px -2px rgba(16,185,129,.35)}.fss-step--active .fss-step__badge{background:#2563eb;color:#fff;box-shadow:0 4px 12px -2px rgba(37,99,235,.4)}.fss-step--active .fss-step__badge:before{content:\"\";position:absolute;inset:-5px;border-radius:15px;border:2px solid transparent;border-top-color:#2563eb;border-right-color:#2563eb;animation:fssStepSpin 1.6s linear infinite;opacity:.55}@keyframes fssStepSpin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@media (prefers-reduced-motion:reduce){.fss-step--active .fss-step__badge:before{animation:none}}.fss-step__title{font-size:17px;font-weight:700;color:#9ca3af;line-height:1.3;transition:color .2s}.fss-step--active .fss-step__title{color:#2563eb}.fss-step--done .fss-step__title{color:#059669}.fss-connector{flex:0 0 28px;position:relative;display:flex;align-items:center;justify-content:center;min-height:80px}.fss-connector:before{content:\"\";position:absolute;top:50%;left:0;right:0;height:2px;background:#e5e7eb;border-radius:1px}.fss-connector--done:before{background:linear-gradient(90deg,#10b981,#2563eb);height:3px}.fss-connector--all-done:before{background:#10b981;height:3px}@media (max-width:900px){.fss-stepper{flex-direction:column;gap:4px}.fss-connector{min-height:20px;flex:0 0 20px}.fss-connector:before{top:0;bottom:0;left:50%;right:auto;width:2px;height:100%}}", ""]);

// exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "/*!\n * vue-treeselect v0.4.0 | (c) 2017-2019 Riophae Lee\n * Released under the MIT License.\n * https://vue-treeselect.js.org/\n */.vue-treeselect-helper-hide{display:none}.vue-treeselect-helper-zoom-effect-off{transform:none!important}@keyframes vue-treeselect-animation-fade-in{0%{opacity:0}}@keyframes vue-treeselect-animation-bounce{0%,to{transform:scale(0)}50%{transform:scale(1)}}@keyframes vue-treeselect-animation-rotate{to{transform:rotate(1turn)}}.vue-treeselect__multi-value-item--transition-enter-active,.vue-treeselect__multi-value-item--transition-leave-active{transition-duration:.2s;transition-property:transform,opacity}.vue-treeselect__multi-value-item--transition-enter-active{transition-timing-function:cubic-bezier(.075,.82,.165,1)}.vue-treeselect__multi-value-item--transition-leave-active{transition-timing-function:cubic-bezier(.215,.61,.355,1);position:absolute}.vue-treeselect__multi-value-item--transition-enter,.vue-treeselect__multi-value-item--transition-leave-to{transform:scale(.7);opacity:0}.vue-treeselect__multi-value-item--transition-move{transition:transform .2s cubic-bezier(.165,.84,.44,1)}.vue-treeselect{position:relative;text-align:left}[dir=rtl] .vue-treeselect{text-align:right}.vue-treeselect div,.vue-treeselect span{box-sizing:border-box}.vue-treeselect svg{fill:currentColor}.vue-treeselect__control{padding-left:5px;padding-right:5px;display:table;table-layout:fixed;width:100%;height:36px;border:1px solid #ddd;border-radius:5px;background:#fff;transition-duration:.2s;transition-property:border-color,box-shadow,width,height,background-color,opacity;transition-timing-function:cubic-bezier(.215,.61,.355,1)}.vue-treeselect:not(.vue-treeselect--disabled):not(.vue-treeselect--focused) .vue-treeselect__control:hover{border-color:#cfcfcf}.vue-treeselect--focused:not(.vue-treeselect--open) .vue-treeselect__control{border-color:#039be5;box-shadow:0 0 0 3px rgba(3,155,229,.1)}.vue-treeselect--disabled .vue-treeselect__control{background-color:#f9f9f9}.vue-treeselect--open .vue-treeselect__control{border-color:#cfcfcf}.vue-treeselect--open.vue-treeselect--open-below .vue-treeselect__control{border-bottom-left-radius:0;border-bottom-right-radius:0}.vue-treeselect--open.vue-treeselect--open-above .vue-treeselect__control{border-top-left-radius:0;border-top-right-radius:0}.vue-treeselect__multi-value,.vue-treeselect__value-container{width:100%;vertical-align:middle}.vue-treeselect__value-container{display:table-cell;position:relative}.vue-treeselect--searchable:not(.vue-treeselect--disabled) .vue-treeselect__value-container{cursor:text}.vue-treeselect__multi-value{display:inline-block}.vue-treeselect--has-value .vue-treeselect__multi-value{margin-bottom:5px}.vue-treeselect__placeholder,.vue-treeselect__single-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-left:5px;padding-right:5px;position:absolute;top:0;right:0;bottom:0;left:0;line-height:34px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none}.vue-treeselect__placeholder{color:#bdbdbd}.vue-treeselect__single-value{color:#333}.vue-treeselect--focused.vue-treeselect--searchable .vue-treeselect__single-value{color:#bdbdbd}.vue-treeselect--disabled .vue-treeselect__single-value{position:static}.vue-treeselect__multi-value-item-container{display:inline-block;padding-top:5px;padding-right:5px;vertical-align:top}[dir=rtl] .vue-treeselect__multi-value-item-container{padding-right:0;padding-left:5px}.vue-treeselect__multi-value-item{display:inline-table;padding:2px 0;border:1px solid transparent;border-radius:2px;font-size:12px;vertical-align:top}.vue-treeselect:not(.vue-treeselect--disabled) .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-disabled):hover .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-new) .vue-treeselect__multi-value-item:not(.vue-treeselect__multi-value-item-new):hover,.vue-treeselect__multi-value-item{cursor:pointer;background:#e3f2fd;color:#039be5}.vue-treeselect__multi-value-item.vue-treeselect__multi-value-item-disabled{cursor:default;background:#f5f5f5;color:#757575}.vue-treeselect--disabled .vue-treeselect__multi-value-item{cursor:default;background:#fff;border-color:#e5e5e5;color:#555}.vue-treeselect__multi-value-item.vue-treeselect__multi-value-item-new,.vue-treeselect__multi-value-item.vue-treeselect__multi-value-item-new:hover{background:#e8f5e9}.vue-treeselect__multi-value-label,.vue-treeselect__value-remove{display:table-cell;padding:0 5px;vertical-align:middle}.vue-treeselect__value-remove{color:#039be5;padding-left:5px;border-left:1px solid #fff;line-height:0}[dir=rtl] .vue-treeselect__value-remove{border-left:0 none;border-right:1px solid #fff}.vue-treeselect__multi-value-item:hover .vue-treeselect__value-remove{color:#e53935}.vue-treeselect--disabled .vue-treeselect__value-remove,.vue-treeselect__multi-value-item-disabled .vue-treeselect__value-remove{display:none}.vue-treeselect__value-remove>svg{width:6px;height:6px}.vue-treeselect__multi-value-label{padding-right:5px;white-space:pre-line;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.vue-treeselect__limit-tip{display:inline-block;padding-top:5px;padding-right:5px;vertical-align:top}[dir=rtl] .vue-treeselect__limit-tip{padding-right:0;padding-left:5px}.vue-treeselect__limit-tip-text{cursor:default;display:block;margin:2px 0;padding:1px 0;color:#bdbdbd;font-size:12px;font-weight:600}.vue-treeselect__input-container{display:block;max-width:100%;outline:none}.vue-treeselect--single .vue-treeselect__input-container{font-size:inherit;height:100%}.vue-treeselect--multi .vue-treeselect__input-container{display:inline-block;font-size:12px;vertical-align:top}.vue-treeselect--searchable .vue-treeselect__input-container{padding-left:5px;padding-right:5px}.vue-treeselect--searchable.vue-treeselect--multi.vue-treeselect--has-value .vue-treeselect__input-container{padding-top:5px;padding-left:0}[dir=rtl] .vue-treeselect--searchable.vue-treeselect--multi.vue-treeselect--has-value .vue-treeselect__input-container{padding-left:5px;padding-right:0}.vue-treeselect--disabled .vue-treeselect__input-container{display:none}.vue-treeselect__input,.vue-treeselect__sizer{margin:0;line-height:inherit;font-family:inherit;font-size:inherit}.vue-treeselect__input{max-width:100%;margin:0;padding:0;border:0;outline:none;box-sizing:content-box;box-shadow:none;background:none transparent;line-height:1;vertical-align:middle}.vue-treeselect__input::-ms-clear{display:none}.vue-treeselect--single .vue-treeselect__input{width:100%;height:100%}.vue-treeselect--multi .vue-treeselect__input{padding-top:3px;padding-bottom:3px}.vue-treeselect--has-value .vue-treeselect__input{line-height:inherit;vertical-align:top}.vue-treeselect__sizer{position:absolute;top:0;left:0;visibility:hidden;height:0;overflow:scroll;white-space:pre}.vue-treeselect__x-container{display:table-cell;vertical-align:middle;width:20px;text-align:center;line-height:0;cursor:pointer;color:#ccc;animation:.2s vue-treeselect-animation-fade-in cubic-bezier(.075,.82,.165,1)}.vue-treeselect__x-container:hover{color:#e53935}.vue-treeselect__x{width:8px;height:8px}.vue-treeselect__control-arrow-container{display:table-cell;vertical-align:middle;width:20px;text-align:center;line-height:0;cursor:pointer}.vue-treeselect--disabled .vue-treeselect__control-arrow-container{cursor:default}.vue-treeselect__control-arrow{width:9px;height:9px;color:#ccc}.vue-treeselect:not(.vue-treeselect--disabled) .vue-treeselect__control-arrow-container:hover .vue-treeselect__control-arrow{color:#616161}.vue-treeselect--disabled .vue-treeselect__control-arrow{opacity:.35}.vue-treeselect__control-arrow--rotated{transform:rotate(180deg)}.vue-treeselect__menu-container{position:absolute;left:0;width:100%;overflow:visible;transition:0s}.vue-treeselect--open-below:not(.vue-treeselect--append-to-body) .vue-treeselect__menu-container{top:100%}.vue-treeselect--open-above:not(.vue-treeselect--append-to-body) .vue-treeselect__menu-container{bottom:100%}.vue-treeselect__menu{cursor:default;padding-top:5px;padding-bottom:5px;display:block;position:absolute;overflow-x:hidden;overflow-y:auto;width:auto;border:1px solid #cfcfcf;background:#fff;line-height:180%;-webkit-overflow-scrolling:touch}.vue-treeselect--open-below .vue-treeselect__menu{border-bottom-left-radius:5px;border-bottom-right-radius:5px;top:0;margin-top:-1px;border-top-color:#f2f2f2;box-shadow:0 1px 0 rgba(0,0,0,.06)}.vue-treeselect--open-above .vue-treeselect__menu{border-top-left-radius:5px;border-top-right-radius:5px;bottom:0;margin-bottom:-1px;border-bottom-color:#f2f2f2}.vue-treeselect__indent-level-0 .vue-treeselect__option{padding-left:5px}[dir=rtl] .vue-treeselect__indent-level-0 .vue-treeselect__option{padding-left:5px;padding-right:5px}.vue-treeselect__indent-level-0 .vue-treeselect__tip{padding-left:25px}[dir=rtl] .vue-treeselect__indent-level-0 .vue-treeselect__tip{padding-left:5px;padding-right:25px}.vue-treeselect__indent-level-1 .vue-treeselect__option{padding-left:25px}[dir=rtl] .vue-treeselect__indent-level-1 .vue-treeselect__option{padding-left:5px;padding-right:25px}.vue-treeselect__indent-level-1 .vue-treeselect__tip{padding-left:45px}[dir=rtl] .vue-treeselect__indent-level-1 .vue-treeselect__tip{padding-left:5px;padding-right:45px}.vue-treeselect__indent-level-2 .vue-treeselect__option{padding-left:45px}[dir=rtl] .vue-treeselect__indent-level-2 .vue-treeselect__option{padding-left:5px;padding-right:45px}.vue-treeselect__indent-level-2 .vue-treeselect__tip{padding-left:65px}[dir=rtl] .vue-treeselect__indent-level-2 .vue-treeselect__tip{padding-left:5px;padding-right:65px}.vue-treeselect__indent-level-3 .vue-treeselect__option{padding-left:65px}[dir=rtl] .vue-treeselect__indent-level-3 .vue-treeselect__option{padding-left:5px;padding-right:65px}.vue-treeselect__indent-level-3 .vue-treeselect__tip{padding-left:85px}[dir=rtl] .vue-treeselect__indent-level-3 .vue-treeselect__tip{padding-left:5px;padding-right:85px}.vue-treeselect__indent-level-4 .vue-treeselect__option{padding-left:85px}[dir=rtl] .vue-treeselect__indent-level-4 .vue-treeselect__option{padding-left:5px;padding-right:85px}.vue-treeselect__indent-level-4 .vue-treeselect__tip{padding-left:105px}[dir=rtl] .vue-treeselect__indent-level-4 .vue-treeselect__tip{padding-left:5px;padding-right:105px}.vue-treeselect__indent-level-5 .vue-treeselect__option{padding-left:105px}[dir=rtl] .vue-treeselect__indent-level-5 .vue-treeselect__option{padding-left:5px;padding-right:105px}.vue-treeselect__indent-level-5 .vue-treeselect__tip{padding-left:125px}[dir=rtl] .vue-treeselect__indent-level-5 .vue-treeselect__tip{padding-left:5px;padding-right:125px}.vue-treeselect__indent-level-6 .vue-treeselect__option{padding-left:125px}[dir=rtl] .vue-treeselect__indent-level-6 .vue-treeselect__option{padding-left:5px;padding-right:125px}.vue-treeselect__indent-level-6 .vue-treeselect__tip{padding-left:145px}[dir=rtl] .vue-treeselect__indent-level-6 .vue-treeselect__tip{padding-left:5px;padding-right:145px}.vue-treeselect__indent-level-7 .vue-treeselect__option{padding-left:145px}[dir=rtl] .vue-treeselect__indent-level-7 .vue-treeselect__option{padding-left:5px;padding-right:145px}.vue-treeselect__indent-level-7 .vue-treeselect__tip{padding-left:165px}[dir=rtl] .vue-treeselect__indent-level-7 .vue-treeselect__tip{padding-left:5px;padding-right:165px}.vue-treeselect__indent-level-8 .vue-treeselect__option{padding-left:165px}[dir=rtl] .vue-treeselect__indent-level-8 .vue-treeselect__option{padding-left:5px;padding-right:165px}.vue-treeselect__indent-level-8 .vue-treeselect__tip{padding-left:185px}[dir=rtl] .vue-treeselect__indent-level-8 .vue-treeselect__tip{padding-left:5px;padding-right:185px}.vue-treeselect__option{padding-left:5px;padding-right:5px;display:table;table-layout:fixed;width:100%}.vue-treeselect__option--highlight{background:#f5f5f5}.vue-treeselect--single .vue-treeselect__option--selected{background:#e3f2fd;font-weight:600}.vue-treeselect--single .vue-treeselect__option--selected:hover{background:#e3f2fd}.vue-treeselect__option--hide{display:none}.vue-treeselect__option-arrow-container,.vue-treeselect__option-arrow-placeholder{display:table-cell;vertical-align:middle;width:20px;text-align:center;line-height:0}.vue-treeselect__option-arrow-container{cursor:pointer}.vue-treeselect__option-arrow{display:inline-block;width:9px;height:9px;color:#ccc;vertical-align:middle;transition:transform .2s cubic-bezier(.19,1,.22,1);transform:rotate(-90deg)}[dir=rtl] .vue-treeselect__option-arrow{transform:rotate(90deg)}.vue-treeselect--branch-nodes-disabled .vue-treeselect__option:hover .vue-treeselect__option-arrow,.vue-treeselect__option-arrow-container:hover .vue-treeselect__option-arrow{color:#616161}.vue-treeselect__option-arrow--rotated,[dir=rtl] .vue-treeselect__option-arrow--rotated{transform:rotate(0)}.vue-treeselect__option-arrow--rotated.vue-treeselect__option-arrow--prepare-enter{transform:rotate(-90deg)!important}[dir=rtl] .vue-treeselect__option-arrow--rotated.vue-treeselect__option-arrow--prepare-enter{transform:rotate(90deg)!important}.vue-treeselect__label-container{display:table-cell;vertical-align:middle;cursor:pointer;display:table;width:100%;table-layout:fixed;color:inherit}.vue-treeselect__option--disabled .vue-treeselect__label-container{cursor:not-allowed;color:rgba(0,0,0,.25)}.vue-treeselect__checkbox-container{display:table-cell;width:20px;min-width:20px;height:100%;text-align:center;vertical-align:middle}.vue-treeselect__checkbox{display:block;margin:auto;width:12px;height:12px;border-width:1px;border-style:solid;border-radius:2px;position:relative;transition:all .2s cubic-bezier(.075,.82,.165,1)}.vue-treeselect__check-mark,.vue-treeselect__minus-mark{display:block;position:absolute;left:1px;top:1px;background-repeat:no-repeat;opacity:0;transition:all .2s ease}.vue-treeselect__minus-mark{width:8px;height:8px;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIAgMAAAC5YVYYAAAACVBMVEUAAAD///////9zeKVjAAAAAnRSTlMAuLMp9oYAAAAPSURBVAjXY4CDrJUgBAMAGaECJ9dz3BAAAAAASUVORK5CYII=);background-size:8px 8px}@media (-webkit-min-device-pixel-ratio:1.5),(min-resolution:1.5dppx){.vue-treeselect__minus-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAADFBMVEUAAAD///////////84wDuoAAAAA3RSTlMAyTzPIdReAAAAGUlEQVQI12PAD+b///+Nof7//79gAsLFCwAx/w4blADeeQAAAABJRU5ErkJggg==)}}@media (-webkit-min-device-pixel-ratio:2),(min-resolution:192dpi){.vue-treeselect__minus-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAADFBMVEUAAAD///////////84wDuoAAAAA3RSTlMAyTzPIdReAAAAGUlEQVQI12PAD+b///+Nof7//79gAsLFCwAx/w4blADeeQAAAABJRU5ErkJggg==)}}@media (-webkit-min-device-pixel-ratio:3),(min-resolution:288dpi){.vue-treeselect__minus-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAD1BMVEUAAAD///////////////+PQt5oAAAABHRSTlMAy2EFIuWxUgAAACRJREFUGNNjGBBgJOICBY7KDCoucODEAJSAS6FwUJShGjAQAADBPRGrK2/FhgAAAABJRU5ErkJggg==)}}.vue-treeselect__checkbox--indeterminate>.vue-treeselect__minus-mark{opacity:1}.vue-treeselect__checkbox--disabled .vue-treeselect__minus-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIAgMAAAC5YVYYAAAACVBMVEUAAADi4uLh4eHOxeSRAAAAAnRSTlMAuLMp9oYAAAAPSURBVAjXY4CDrJUgBAMAGaECJ9dz3BAAAAAASUVORK5CYII=)}@media (-webkit-min-device-pixel-ratio:1.5),(min-resolution:1.5dppx){.vue-treeselect__checkbox--disabled .vue-treeselect__minus-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAADFBMVEUAAADi4uLi4uLh4eE5RQaIAAAAA3RSTlMAyTzPIdReAAAAGUlEQVQI12PAD+b///+Nof7//79gAsLFCwAx/w4blADeeQAAAABJRU5ErkJggg==)}}@media (-webkit-min-device-pixel-ratio:2),(min-resolution:192dpi){.vue-treeselect__checkbox--disabled .vue-treeselect__minus-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAADFBMVEUAAADi4uLi4uLh4eE5RQaIAAAAA3RSTlMAyTzPIdReAAAAGUlEQVQI12PAD+b///+Nof7//79gAsLFCwAx/w4blADeeQAAAABJRU5ErkJggg==)}}@media (-webkit-min-device-pixel-ratio:3),(min-resolution:288dpi){.vue-treeselect__checkbox--disabled .vue-treeselect__minus-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAD1BMVEUAAADh4eHg4ODNzc3h4eEYfw2wAAAABHRSTlMAy2EFIuWxUgAAACRJREFUGNNjGBBgJOICBY7KDCoucODEAJSAS6FwUJShGjAQAADBPRGrK2/FhgAAAABJRU5ErkJggg==)}}.vue-treeselect__check-mark{width:8px;height:8px;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAQlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////8IX9KGAAAAFXRSTlMA8u24NxILB+Tawb6jiH1zRz0xIQIIP3GUAAAAMklEQVQI1y3FtQEAMQDDQD+EGbz/qkEVOpyEOP6PudKjZNSXn4Jm2CKRdBKzSLsFWl8fMG0Bl6Jk1rMAAAAASUVORK5CYII=);background-size:8px 8px;transform:scaleY(.125)}@media (-webkit-min-device-pixel-ratio:1.5),(min-resolution:1.5dppx){.vue-treeselect__check-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAYFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////98JRy6AAAAH3RSTlMAzu4sDenl38fBvo1OMyIdEQrj1cSihX5hYFpHNycIcQOASAAAAF9JREFUGNN9zEcOgDAMRFHTS0LvNfe/JRmHKAIJ/mqeLJn+k9uDtaeUeFnFziGsBucUTirrprfe81RqZ3Bb6hPWeuZwDFOHyf+ig9CCzQ7INBn7bG5kF+QSt13BHNJnF7AaCT4Y+CW7AAAAAElFTkSuQmCC)}}@media (-webkit-min-device-pixel-ratio:2),(min-resolution:192dpi){.vue-treeselect__check-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAYFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////98JRy6AAAAH3RSTlMAzu4sDenl38fBvo1OMyIdEQrj1cSihX5hYFpHNycIcQOASAAAAF9JREFUGNN9zEcOgDAMRFHTS0LvNfe/JRmHKAIJ/mqeLJn+k9uDtaeUeFnFziGsBucUTirrprfe81RqZ3Bb6hPWeuZwDFOHyf+ig9CCzQ7INBn7bG5kF+QSt13BHNJnF7AaCT4Y+CW7AAAAAElFTkSuQmCC)}}@media (-webkit-min-device-pixel-ratio:3),(min-resolution:288dpi){.vue-treeselect__check-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAWlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////9ZMre9AAAAHXRSTlMA/PiJhGNI9XlEHJB/b2ldV08+Oibk49vPp6QhAYgGBuwAAACCSURBVCjPrdHdDoIwDAXgTWAqCigo/+f9X5OwnoUwtis4V92XNWladUl+rzQPeQJAN2EHxoOnsPn7/oYk8fxBv08Rr/deOH/aZ2Nm8ZJ+s573QGfWKnNuZGzWm3+lv2V3pcU1XQ385/yjmBoM3Z+dXvlbYLLD3ujhTaOM3KaIXvNkFkuSEvYy1LqOAAAAAElFTkSuQmCC)}}.vue-treeselect__checkbox--checked>.vue-treeselect__check-mark{opacity:1;transform:scaleY(1)}.vue-treeselect__checkbox--disabled .vue-treeselect__check-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAP1BMVEUAAADj4+Pf39/h4eHh4eHh4eHk5OTh4eHg4ODi4uLh4eHh4eHg4ODh4eHh4eHg4ODh4eHh4eHp6en////h4eFqcyvUAAAAFHRSTlMAOQfy7bgS5NrBvqOIfXNHMSELAgQ/iFsAAAA2SURBVAjXY4AANjYIzcjMAaVFuBkY+RkEWERYmRjYRXjANAOfiIgIFxNIAa8IpxBEi6AwiAQAK2MBd7xY8csAAAAASUVORK5CYII=)}@media (-webkit-min-device-pixel-ratio:1.5),(min-resolution:1.5dppx){.vue-treeselect__checkbox--disabled .vue-treeselect__check-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAXVBMVEUAAADh4eHh4eHh4eHi4uLb29vh4eHh4eHh4eHh4eHh4eHh4eHh4eHi4uLi4uLj4+Pi4uLk5OTo6Ojh4eHh4eHi4uLg4ODg4ODh4eHg4ODh4eHf39/g4OD////h4eEzIk+wAAAAHnRSTlMAzu6/LA3p5eLZx8ONTjYiHRIKooV+YWBaRzEnCANnm5rnAAAAZElEQVQY033P2wqAIAyA4VWaaWrnc/n+j5mbhBjUf7WPoTD47TJb4i5zTr/sRDRHuyFaoWX7uK/RlbctlPEuyI1f4WY9yQINEkf6rzzo8YIzmUFoCs7J1EjeIaa9bXIEmzl8dgOZEAj/+2IvzAAAAABJRU5ErkJggg==)}}@media (-webkit-min-device-pixel-ratio:2),(min-resolution:192dpi){.vue-treeselect__checkbox--disabled .vue-treeselect__check-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAXVBMVEUAAADh4eHh4eHh4eHi4uLb29vh4eHh4eHh4eHh4eHh4eHh4eHh4eHi4uLi4uLj4+Pi4uLk5OTo6Ojh4eHh4eHi4uLg4ODg4ODh4eHg4ODh4eHf39/g4OD////h4eEzIk+wAAAAHnRSTlMAzu6/LA3p5eLZx8ONTjYiHRIKooV+YWBaRzEnCANnm5rnAAAAZElEQVQY033P2wqAIAyA4VWaaWrnc/n+j5mbhBjUf7WPoTD47TJb4i5zTr/sRDRHuyFaoWX7uK/RlbctlPEuyI1f4WY9yQINEkf6rzzo8YIzmUFoCs7J1EjeIaa9bXIEmzl8dgOZEAj/+2IvzAAAAABJRU5ErkJggg==)}}@media (-webkit-min-device-pixel-ratio:3),(min-resolution:288dpi){.vue-treeselect__checkbox--disabled .vue-treeselect__check-mark{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAUVBMVEUAAADh4eHh4eHh4eHh4eHi4uLi4uLh4eHh4eHh4eHf39/j4+Ph4eHh4eHh4eHg4ODi4uLh4eHh4eHi4uLh4eHh4eHh4eHh4eHh4eH////h4eF3FMFTAAAAGnRSTlMA+/eJhGhfSHE9JBzz5KaQf3pXT0Xbz0I5AYDw8F0AAAB+SURBVCjPrdHbDoMgEEVRKAii1dZe9fz/hxplTiKIT7qfYCWTEEZdUvOwbckNAD2WHeh3brHW5f5EzGQ+iN+b1Gt6KPvtv16Dn6JX9M9ya3/A1yfu5dlyduL6Hec7mXY6ddXLPP2lpABGZ8PWXfYLTJxZekVhhl7eTX24zZPNKXoRC7zQLjUAAAAASUVORK5CYII=)}}.vue-treeselect__checkbox--unchecked{border-color:#e0e0e0;background:#fff}.vue-treeselect__label-container:hover .vue-treeselect__checkbox--unchecked{border-color:#039be5;background:#fff}.vue-treeselect__checkbox--checked,.vue-treeselect__checkbox--indeterminate,.vue-treeselect__label-container:hover .vue-treeselect__checkbox--checked,.vue-treeselect__label-container:hover .vue-treeselect__checkbox--indeterminate{border-color:#039be5;background:#039be5}.vue-treeselect__checkbox--disabled,.vue-treeselect__label-container:hover .vue-treeselect__checkbox--disabled{border-color:#e0e0e0;background-color:#f7f7f7}.vue-treeselect__label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:table-cell;padding-left:5px;max-width:100%;vertical-align:middle;cursor:inherit}[dir=rtl] .vue-treeselect__label{padding-left:0;padding-right:5px}.vue-treeselect__count{margin-left:5px;font-weight:400;opacity:.6}[dir=rtl] .vue-treeselect__count{margin-left:0;margin-right:5px}.vue-treeselect__tip{padding-left:5px;padding-right:5px;display:table;table-layout:fixed;width:100%;color:#757575}.vue-treeselect__tip-text{display:table-cell;vertical-align:middle;padding-left:5px;padding-right:5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%;font-size:12px}.vue-treeselect__error-tip .vue-treeselect__retry{cursor:pointer;margin-left:5px;font-style:normal;font-weight:600;text-decoration:none;color:#039be5}[dir=rtl] .vue-treeselect__error-tip .vue-treeselect__retry{margin-left:0;margin-right:5px}.vue-treeselect__icon-container{display:table-cell;vertical-align:middle;width:20px;text-align:center;line-height:0}.vue-treeselect--single .vue-treeselect__icon-container{padding-left:5px}[dir=rtl] .vue-treeselect--single .vue-treeselect__icon-container{padding-left:0;padding-right:5px}.vue-treeselect__icon-warning{display:block;margin:auto;border-radius:50%;position:relative;width:12px;height:12px;background:#fb8c00}.vue-treeselect__icon-warning:after{display:block;position:absolute;content:\"\";left:5px;top:2.5px;width:2px;height:1px;border:0 solid #fff;border-top-width:5px;border-bottom-width:1px}.vue-treeselect__icon-error{display:block;margin:auto;border-radius:50%;position:relative;width:12px;height:12px;background:#e53935}.vue-treeselect__icon-error:after,.vue-treeselect__icon-error:before{display:block;position:absolute;content:\"\";background:#fff;transform:rotate(45deg)}.vue-treeselect__icon-error:before{width:6px;height:2px;left:3px;top:5px}.vue-treeselect__icon-error:after{width:2px;height:6px;left:5px;top:3px}.vue-treeselect__icon-loader{display:block;margin:auto;position:relative;width:12px;height:12px;text-align:center;animation:1.6s vue-treeselect-animation-rotate linear infinite}.vue-treeselect__icon-loader:after,.vue-treeselect__icon-loader:before{border-radius:50%;position:absolute;content:\"\";left:0;top:0;display:block;width:100%;height:100%;opacity:.6;animation:1.6s vue-treeselect-animation-bounce ease-in-out infinite}.vue-treeselect__icon-loader:before{background:#039be5}.vue-treeselect__icon-loader:after{background:#b3e5fc;animation-delay:-.8s}.vue-treeselect__menu-placeholder{display:none}.vue-treeselect__portal-target{position:absolute;display:block;left:0;top:0;height:0;width:0;padding:0;margin:0;border:0;overflow:visible;box-sizing:border-box}", ""]);

// exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "table.dataTable{clear:both;margin-top:6px!important;margin-bottom:6px!important;max-width:none!important;border-collapse:separate!important;border-spacing:0}table.dataTable td,table.dataTable th{box-sizing:content-box}table.dataTable td.dataTables_empty,table.dataTable th.dataTables_empty{text-align:center}table.dataTable.nowrap td,table.dataTable.nowrap th{white-space:nowrap}div.dataTables_wrapper div.dataTables_length label{font-weight:400;text-align:left;white-space:nowrap}div.dataTables_wrapper div.dataTables_length select{width:auto;display:inline-block}div.dataTables_wrapper div.dataTables_filter{text-align:right}div.dataTables_wrapper div.dataTables_filter label{font-weight:400;white-space:nowrap;text-align:left}div.dataTables_wrapper div.dataTables_filter input{margin-left:.5em;display:inline-block;width:auto}div.dataTables_wrapper div.dataTables_info{padding-top:.85em;white-space:nowrap}div.dataTables_wrapper div.dataTables_paginate{margin:0;white-space:nowrap;text-align:right}div.dataTables_wrapper div.dataTables_paginate ul.pagination{margin:2px 0;white-space:nowrap;justify-content:flex-end}div.dataTables_wrapper div.dataTables_processing{position:absolute;top:50%;left:50%;width:200px;margin-left:-100px;margin-top:-26px;text-align:center;padding:1em 0}table.dataTable thead>tr>td.sorting,table.dataTable thead>tr>td.sorting_asc,table.dataTable thead>tr>td.sorting_desc,table.dataTable thead>tr>th.sorting,table.dataTable thead>tr>th.sorting_asc,table.dataTable thead>tr>th.sorting_desc{padding-right:30px}table.dataTable thead>tr>td:active,table.dataTable thead>tr>th:active{outline:none}table.dataTable thead .sorting,table.dataTable thead .sorting_asc,table.dataTable thead .sorting_asc_disabled,table.dataTable thead .sorting_desc,table.dataTable thead .sorting_desc_disabled{cursor:pointer;position:relative}table.dataTable thead .sorting:after,table.dataTable thead .sorting:before,table.dataTable thead .sorting_asc:after,table.dataTable thead .sorting_asc:before,table.dataTable thead .sorting_asc_disabled:after,table.dataTable thead .sorting_asc_disabled:before,table.dataTable thead .sorting_desc:after,table.dataTable thead .sorting_desc:before,table.dataTable thead .sorting_desc_disabled:after,table.dataTable thead .sorting_desc_disabled:before{position:absolute;bottom:.9em;display:block;opacity:.3}table.dataTable thead .sorting:before,table.dataTable thead .sorting_asc:before,table.dataTable thead .sorting_asc_disabled:before,table.dataTable thead .sorting_desc:before,table.dataTable thead .sorting_desc_disabled:before{right:1em;content:\"\\2191\"}table.dataTable thead .sorting:after,table.dataTable thead .sorting_asc:after,table.dataTable thead .sorting_asc_disabled:after,table.dataTable thead .sorting_desc:after,table.dataTable thead .sorting_desc_disabled:after{right:.5em;content:\"\\2193\"}table.dataTable thead .sorting_asc:before,table.dataTable thead .sorting_desc:after{opacity:1}table.dataTable thead .sorting_asc_disabled:before,table.dataTable thead .sorting_desc_disabled:after{opacity:0}div.dataTables_scrollHead table.dataTable{margin-bottom:0!important}div.dataTables_scrollBody table{border-top:none;margin-top:0!important;margin-bottom:0!important}div.dataTables_scrollBody table thead .sorting:after,div.dataTables_scrollBody table thead .sorting:before,div.dataTables_scrollBody table thead .sorting_asc:after,div.dataTables_scrollBody table thead .sorting_asc:before,div.dataTables_scrollBody table thead .sorting_desc:after,div.dataTables_scrollBody table thead .sorting_desc:before{display:none}div.dataTables_scrollBody table tbody tr:first-child td,div.dataTables_scrollBody table tbody tr:first-child th{border-top:none}div.dataTables_scrollFoot>.dataTables_scrollFootInner{box-sizing:content-box}div.dataTables_scrollFoot>.dataTables_scrollFootInner>table{margin-top:0!important;border-top:none}@media screen and (max-width:767px){div.dataTables_wrapper div.dataTables_filter,div.dataTables_wrapper div.dataTables_info,div.dataTables_wrapper div.dataTables_length,div.dataTables_wrapper div.dataTables_paginate{text-align:center}}table.dataTable.table-sm>thead>tr>th{padding-right:20px}table.dataTable.table-sm .sorting:before,table.dataTable.table-sm .sorting_asc:before,table.dataTable.table-sm .sorting_desc:before{top:5px;right:.85em}table.dataTable.table-sm .sorting:after,table.dataTable.table-sm .sorting_asc:after,table.dataTable.table-sm .sorting_desc:after{top:5px}table.table-bordered.dataTable td,table.table-bordered.dataTable th{border-left-width:0}table.table-bordered.dataTable td:last-child,table.table-bordered.dataTable th:last-child{border-right-width:0}div.dataTables_scrollHead table.table-bordered,table.table-bordered.dataTable tbody td,table.table-bordered.dataTable tbody th{border-bottom-width:0}div.table-responsive>div.dataTables_wrapper>div.row{margin:0}div.table-responsive>div.dataTables_wrapper>div.row>div[class^=col-]:first-child{padding-left:0}div.table-responsive>div.dataTables_wrapper>div.row>div[class^=col-]:last-child{padding-right:0}", ""]);

// exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "table.dataTable tr.dtrg-group td{background-color:#e0e0e0}table.dataTable tr.dtrg-group.dtrg-level-0 td{font-weight:700}table.dataTable tr.dtrg-group.dtrg-level-1 td,table.dataTable tr.dtrg-group.dtrg-level-2 td{background-color:#f0f0f0;padding-top:.25em;padding-bottom:.25em;padding-left:2em;font-size:.9em}table.dataTable tr.dtrg-group.dtrg-level-2 td{background-color:#f3f3f3}", ""]);

// exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".btn.btn-icon[data-v-01bcfb02]{height:1.8rem;width:1.8rem}.btn [class*=\" fa-\"][data-v-01bcfb02]{font-size:.8rem}.border-dashed[data-v-01bcfb02]{border:1px dashed;height:140px}", ""]);

// exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".table td[data-v-055ba9d0]{padding:.1rem;vertical-align:middle}.table th[data-v-055ba9d0]{padding:.5rem;vertical-align:middle}", ""]);

// exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".label-required[data-v-0c834482]:after{content:\" *\";color:#f4516c;font-weight:600}", ""]);

// exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".table-responsive[data-v-159827c8]{overflow-x:auto}.bgPlant[data-v-159827c8]{background-color:#ffd966}.bgAgent[data-v-159827c8]{background-color:#dae9f8}", ""]);

// exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".border-dashed[data-v-164e5362]{border:1px dashed;height:140px}", ""]);

// exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".table-approvers td[data-v-18ce0fba]{vertical-align:middle}", ""]);

// exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".table td[data-v-1a395578]{padding:.1rem;vertical-align:middle}.table th[data-v-1a395578]{padding:.5rem;vertical-align:middle}.sub-modal-content[data-v-1a395578]{background-color:#f0f8ff;border:2px solid #007bff;box-shadow:0 0 20px rgba(0,123,255,.4);border-radius:8px}", ""]);

// exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".fss-attach__counter[data-v-1d3ad584]{font-size:1.1rem}.fss-attach__dropzone[data-v-1d3ad584]{border:2px dashed #d1d7e2;border-radius:4px;padding:24px 16px;text-align:center;cursor:pointer;background-color:#f7f8fa;transition:border-color .15s ease-in-out,background-color .15s ease-in-out}.fss-attach__dropzone[data-v-1d3ad584]:hover{border-color:#5d78ff}.fss-attach__dropzone--over[data-v-1d3ad584]{border-color:#5d78ff;background-color:#eef1ff}.fss-attach__dropzone--disabled[data-v-1d3ad584]{cursor:not-allowed;opacity:.6}.fss-attach__dropzone-icon[data-v-1d3ad584]{font-size:2rem;color:#5d78ff;display:block;margin-bottom:8px}.fss-attach__dropzone-title[data-v-1d3ad584]{font-weight:500}.fss-attach__dropzone-hint[data-v-1d3ad584]{font-size:.9rem;color:#74788d;margin-top:4px}.fss-attach__input[data-v-1d3ad584]{display:none}.fss-attach__filename[data-v-1d3ad584]{word-break:break-all}.fss-attach__notice[data-v-1d3ad584]{margin-top:2px;color:#fd397a;font-size:.8rem}", ""]);

// exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".form-group[data-v-2b3817b2]{margin-bottom:.6rem}label[data-v-2b3817b2]{margin-bottom:.1rem}", ""]);

// exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".table[data-v-530f4a3f]{table-layout:auto;overflow-x:scroll}.tbody td[data-v-530f4a3f]{width:auto;overflow-x:scroll}", ""]);

// exports


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "input[type=file][data-v-5cfa27ae]{cursor:pointer}#PreviewTable td[data-v-5cfa27ae],td.border_single[data-v-5cfa27ae]{border:1px solid red}", ""]);

// exports


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".alert[data-v-6ec54a0a]{display:block}.alert>i[data-v-6ec54a0a]{margin-right:.35rem}.fss-action-group[data-v-6ec54a0a]{display:inline-flex;flex-wrap:nowrap;align-items:stretch;justify-content:flex-end;max-width:100%}.fss-action-group>.btn[data-v-6ec54a0a]{flex-shrink:0;white-space:nowrap}.fss-signature-btn[data-v-6ec54a0a]{display:inline-flex;align-items:center;gap:8px}.fss-signature-thumb[data-v-6ec54a0a]{height:24px;max-width:96px;object-fit:contain;background:#fff;border:1px solid #145a34;border-radius:3px;padding:1px 3px;vertical-align:middle}.fss-branch-line[data-v-6ec54a0a]{margin-top:.25rem;color:#74788d;font-size:.85rem;font-weight:400}.fss-post-save-note[data-v-6ec54a0a]{margin:.5rem 0 .75rem;padding:.5rem .75rem;border-left:3px solid #5d78ff;background-color:#f2f3f8;color:#6c7293;font-size:.9rem}.fss-filter-text[data-v-6ec54a0a]{padding:.5rem .75rem;background-color:#f7f8fa;border-radius:4px}.fss-filter-table[data-v-6ec54a0a]{margin-bottom:0}.fss-filter-table__label[data-v-6ec54a0a]{width:12rem;font-weight:600;color:#6c7293}.fss-total-row[data-v-6ec54a0a]{background-color:#f7f8fa}.fss-detail-row>td[data-v-6ec54a0a]{background-color:#fafbfc}.fss-detail[data-v-6ec54a0a]{padding:.5rem .25rem}.fss-detail__title[data-v-6ec54a0a]{margin-bottom:.5rem;font-weight:600;color:#6c7293}.fss-summary[data-v-6ec54a0a]{margin-top:1rem;padding:1rem 1.25rem;background-color:#f7f8fa;border-radius:4px}.fss-summary__row[data-v-6ec54a0a]{display:flex;justify-content:space-between;align-items:baseline;padding:.25rem 0}.fss-summary__label[data-v-6ec54a0a]{color:#6c7293;margin-right:1rem}.fss-summary__value[data-v-6ec54a0a]{font-weight:600;text-align:right}", ""]);

// exports


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".collapsible[data-v-6fa30bc0]{background-color:#eee;color:#444;cursor:pointer;padding:18px;width:100%;border:none;text-align:left;outline:none;font-size:15px}.active[data-v-6fa30bc0],.collapsible[data-v-6fa30bc0]:hover{background-color:#ccc}.content[data-v-6fa30bc0]{padding:0 18px;display:none;overflow:hidden;background-color:#f1f1f1}", ""]);

// exports


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".btn-danger[data-v-79c3f5f6]{color:#fff;background-color:#fa6999;border-color:#fa6999}.btn-danger[data-v-79c3f5f6]:hover{color:#fff;background-color:#fd1361;border-color:#fd1361}", ""]);

// exports


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".fss-detail__notfound[data-v-80be5af4]{text-align:center;padding:48px 20px}.fss-detail__notfound-icon[data-v-80be5af4]{font-size:48px;color:#d1d5db;margin-bottom:16px;display:block}.fss-detail__notfound-title[data-v-80be5af4]{font-size:20px;font-weight:700;color:#374151;margin-bottom:8px}.fss-detail__notfound-text[data-v-80be5af4]{color:#6b7280;font-size:14px}.fss-detail__notfound-doc[data-v-80be5af4]{margin-top:6px;color:#9ca3af;font-size:13px}.fss-detail__excel-group[data-v-80be5af4]{display:inline-flex;flex-direction:column;align-items:center;vertical-align:top}.fss-detail__expire-under[data-v-80be5af4]{margin-top:4px;white-space:nowrap}.fss-signature-thumb[data-v-80be5af4]{height:28px;max-width:96px;object-fit:contain;background:#fff;border:1px solid #ebedf2;border-radius:3px;padding:1px 3px;vertical-align:middle}.fss-branch-line[data-v-80be5af4]{margin-top:.25rem;color:#74788d;font-size:.85rem;font-weight:400}.fss-excel-note[data-v-80be5af4]{margin-top:.5rem;color:#74788d;font-size:.85rem}.fss-expire-line[data-v-80be5af4]{display:inline-block;margin-right:.75rem;font-size:.8rem;white-space:nowrap;vertical-align:middle}.fss-expire-warn[data-v-80be5af4]{color:#fd397a;font-weight:500}.fss-expire-date[data-v-80be5af4]{color:#48465b}.fss-readonly[data-v-80be5af4]{min-height:2.5rem}.fss-filter-text[data-v-80be5af4],.fss-readonly[data-v-80be5af4]{padding:.5rem .75rem;background-color:#f7f8fa;border-radius:4px}.fss-filter-table[data-v-80be5af4]{margin-bottom:0}.fss-filter-table__label[data-v-80be5af4]{width:12rem;font-weight:600;color:#6c7293}.fss-total-row[data-v-80be5af4]{background-color:#f7f8fa}.fss-detail-row>td[data-v-80be5af4]{background-color:#fafbfc}.fss-detail-box[data-v-80be5af4]{padding:.5rem .25rem}.fss-detail-box__title[data-v-80be5af4]{margin-bottom:.5rem;font-weight:600;color:#6c7293}.fss-summary[data-v-80be5af4]{margin-top:1rem;padding:1rem 1.25rem;background-color:#f7f8fa;border-radius:4px}.fss-summary__row[data-v-80be5af4]{display:flex;justify-content:space-between;align-items:baseline;padding:.25rem 0}.fss-summary__label[data-v-80be5af4]{color:#6c7293;margin-right:1rem}.fss-summary__value[data-v-80be5af4]{font-weight:600;text-align:right}", ""]);

// exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".card-header[data-v-82c7f432]{padding:.75rem 1rem}.badge-lg[data-v-82c7f432]{font-size:1.1rem;padding:.5rem 1rem}#itemsTable td[data-v-82c7f432],#itemsTable th[data-v-82c7f432]{vertical-align:middle}#itemsTable input.form-control-sm[data-v-82c7f432]{padding:.25rem .5rem;font-size:.875rem}#itemsTable tfoot td[data-v-82c7f432]{padding:.75rem}", ""]);

// exports


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress[data-v-906b5640]{width:100%;background-color:#ddd}.myBar[data-v-906b5640]{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-beerclaim[data-v-906b5640]{position:absolute;top:5px;right:20px}.btm-delete-img-beerclaim[data-v-906b5640]{position:absolute;top:5px;right:70px}.btm-remove-img-beerclaim[data-v-906b5640]{position:absolute;top:5px;right:20px}.select2-dropdown[data-v-906b5640],.select2[data-v-906b5640]{font-size:1.2rem}@media (max-width:425px){.m-body .m-content[data-v-906b5640]{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2[data-v-906b5640]{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body[data-v-906b5640]{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "input[type=file][data-v-91d3e078]{cursor:pointer}td.border_single[data-v-91d3e078]{border:1px solid red}", ""]);

// exports


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "input[type=file][data-v-b5589de2]{cursor:pointer}td.border_single[data-v-b5589de2]{border:1px solid red}", ""]);

// exports


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".btn-group-sm>.btn [class*=\" la-\"][data-v-f3b5a4ba],.btn-group-sm>.btn [class^=la-][data-v-f3b5a4ba],.btn.btn-icon.btn-icon-md [class*=\" flaticon2-\"][data-v-f3b5a4ba],.btn.btn-icon.btn-icon-md [class*=\" flaticon-\"][data-v-f3b5a4ba],.btn.btn-icon.btn-icon-md [class^=flaticon2-][data-v-f3b5a4ba],.btn.btn-icon.btn-icon-md [class^=flaticon-][data-v-f3b5a4ba],.btn.btn-sm [class*=\" la-\"][data-v-f3b5a4ba],.btn.btn-sm [class^=la-][data-v-f3b5a4ba]{font-size:1rem!important}", ""]);

// exports


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".fss-preview__search[data-v-f3d645ce]{margin-bottom:.75rem}.fss-preview__search-count[data-v-f3d645ce]{margin-top:.35rem;color:#74788d;font-size:.9rem}.alert[data-v-f3d645ce]{display:block}.alert>i[data-v-f3d645ce]{margin-right:.35rem}.fss-action-group[data-v-f3d645ce]{display:inline-flex;flex-wrap:nowrap;align-items:stretch;justify-content:flex-end;max-width:100%}.fss-action-group>.btn[data-v-f3d645ce]{flex-shrink:0;white-space:nowrap}.fss-signature-btn[data-v-f3d645ce]{display:inline-flex;align-items:center;gap:8px}.fss-signature-thumb[data-v-f3d645ce]{height:24px;max-width:96px;object-fit:contain;background:#fff;border:1px solid #145a34;border-radius:3px;padding:1px 3px;vertical-align:middle}.fss-signature-scope[data-v-f3d645ce]{display:inline-block;padding:2px 8px;border-radius:3px;background-color:hsla(0,0%,100%,.22);color:inherit;font-size:.8rem;white-space:nowrap;vertical-align:middle}.fss-filter-text[data-v-f3d645ce]{padding:.5rem .75rem;background-color:#f7f8fa;border-radius:4px}.fss-filter-table[data-v-f3d645ce]{margin-bottom:0}.fss-filter-table__label[data-v-f3d645ce]{width:12rem;font-weight:600;color:#6c7293}.fss-total-row[data-v-f3d645ce]{background-color:#f7f8fa}.fss-branch-line[data-v-f3d645ce]{margin-top:.25rem;color:#74788d;font-size:.85rem;font-weight:400}.fss-export-box[data-v-f3d645ce]{display:flex;flex-direction:column;align-items:flex-end;margin-top:1rem;padding:.75rem 1rem;background-color:#f7f8fa;border-radius:4px}.fss-export-box__note[data-v-f3d645ce]{margin-top:.4rem;text-align:right}.fss-detail-row>td[data-v-f3d645ce]{background-color:#fafbfc}.fss-detail[data-v-f3d645ce]{padding:.5rem .25rem}.fss-detail__title[data-v-f3d645ce]{margin-bottom:.5rem;font-weight:600;color:#6c7293}.fss-skip-sep>td[data-v-f3d645ce]{background-color:#f7f8fa;font-weight:600;color:#6c7293}.fss-skip-row[data-v-f3d645ce]{color:#a2a5b9}.fss-failed-note[data-v-f3d645ce],.fss-failed-sep>td[data-v-f3d645ce]{color:#c62828}.fss-failed-ref[data-v-f3d645ce]{color:#a2a5b9;font-size:.85rem;margin-left:.25rem}", ""]);

// exports


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "input[type=file][data-v-fbd28f7a]{cursor:pointer}td.border_single[data-v-fbd28f7a]{border:1px solid red}", ""]);

// exports


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".kt-aside-menu .kt-menu__item.fss-menu>.kt-menu__link .kt-menu__link-icon>i{color:#ffc107!important}.kt-aside-menu .kt-menu__item.fss-menu>.kt-menu__link:hover .kt-menu__link-icon>i{color:#ff7300!important}.swal2-container,html.swal2-shown{overflow-y:auto!important;height:auto!important}.label-required:before{content:\"\";border-left:2px solid #c00;margin-right:5px}.label-warning:before{content:\"\";border-left:2px solid #e4af00;margin-right:5px}th.sorting_disabled{padding-right:0!important}.my-style{display:flex;flex-direction:row;flex-wrap:nowrap;text-align:left;font-size:13px;margin:0 5px 5px;margin-bottom:5px;align-items:center;justify-content:center;background:#ffb648;border:2px solid #f3a734}.my-style,.my-style>div{box-sizing:border-box}.my-style .my-style-icon{flex:0 1 auto;color:#ffb648;font-size:32px;padding:0 10px}.my-style .my-style-close{flex:0 1 auto;padding:0 20px;font-size:16px;opacity:.2;cursor:pointer}.my-style .my-style-close:hover{opacity:.8}.my-style .my-style-content{padding:10px;flex:1 0 auto}.my-style .my-style-content .my-style-title{letter-spacing:1px;text-transform:uppercase;font-size:14px;font-weight:600}.vue-treeselect__control{padding-left:5px;padding-right:5px;display:table;table-layout:fixed;width:100%;height:41.5px;border:1px solid #ebedf2;border-radius:5px;background:#fff;transition-duration:.2s;transition-property:border-color,box-shadow,width,height,background-color,opacity;transition-timing-function:cubic-bezier(.215,.61,.355,1)}.vue-treeselect__multi-value-item{cursor:pointer;display:inline-table;background:#ebedf2;padding:2px 0;border:1px solid transparent;border-radius:2px;color:#a7abc3;font-size:15px;vertical-align:top}.vue-treeselect__value-remove{color:#a7abc3;padding-left:5px;border-left:1px solid #fff;line-height:0}.vue-treeselect__limit-tip-text{cursor:default;display:block;margin:2px 0;padding:1px 0;color:#bdbdbd;font-size:15px;font-weight:600}.vue-treeselect--multi .vue-treeselect__input-container{display:inline-block;font-size:15px;vertical-align:top}.vue-treeselect__checkbox{display:none;margin:auto;width:12px;height:12px;border-width:1px;border-style:solid;border-radius:2px;position:relative;transition:all .2s cubic-bezier(.075,.82,.165,1)}.vue-treeselect__tip-text{display:table-cell;vertical-align:middle;padding-left:5px;padding-right:5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%;font-size:15px}.Collapsible__content[data-v-545f03a3]{overflow:hidden}.Collapsible__contentInner[data-v-545f03a3]{height:auto}.Collapsible__trigger[data-v-545f03a3]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;background:transparent;border-radius:0;font-family:inherit;font-size:inherit;font-style:inherit;text-align:inherit;color:inherit;padding:0;margin:0;display:block;width:100%;cursor:pointer}", ""]);

// exports


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".select2,.select2-dropdown{font-size:1rem!important}td.dt-control{cursor:pointer}td.dt-control:before{content:\"+\";display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border:1.5px solid #5d78ff;border-radius:50%;font-size:14px;font-weight:700;color:#5d78ff;margin-right:5px;line-height:1}tr.shown td.dt-control:before{content:\"\\2212\"}", ""]);

// exports


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".select2,.select2-dropdown{font-size:1rem!important}", ""]);

// exports


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".table thead td,.table thead th{vertical-align:middle!important}", ""]);

// exports


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".v-lazy-image{filter:blur(10px);transition:filter .7s}.v-lazy-image-loaded{filter:blur(0)}.select2,.select2-dropdown{font-size:1rem!important}", ""]);

// exports


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-agent{position:absolute;top:5px;right:20px}.btm-delete-img-agent{position:absolute;top:5px;right:70px}.btm-remove-img-agent{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}.select2,.select2-dropdown{font-size:1rem}", ""]);

// exports


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-plant{position:absolute;top:5px;right:20px}.btm-delete-img-plant{position:absolute;top:5px;right:70px}.btm-remove-img-plant{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-plant{position:absolute;top:5px;right:20px}.btm-delete-img-plant{position:absolute;top:5px;right:70px}.btm-remove-img-plant{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-plant{position:absolute;top:5px;right:20px}.btm-delete-img-plant{position:absolute;top:5px;right:70px}.btm-remove-img-plant{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-plant{position:absolute;top:5px;right:20px}.btm-delete-img-plant{position:absolute;top:5px;right:70px}.btm-remove-img-plant{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-plant{position:absolute;top:5px;right:20px}.btm-delete-img-plant{position:absolute;top:5px;right:70px}.btm-remove-img-plant{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-plant{position:absolute;top:5px;right:20px}.btm-delete-img-plant{position:absolute;top:5px;right:70px}.btm-remove-img-plant{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-plant{position:absolute;top:5px;right:20px}.btm-delete-img-plant{position:absolute;top:5px;right:70px}.btm-remove-img-plant{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-plant{position:absolute;top:5px;right:20px}.btm-delete-img-plant{position:absolute;top:5px;right:70px}.btm-remove-img-plant{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-shop{position:absolute;top:5px;right:20px}.btm-delete-img-shop{position:absolute;top:5px;right:70px}.btm-remove-img-shop{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-plant{position:absolute;top:5px;right:20px}.btm-delete-img-plant{position:absolute;top:5px;right:70px}.btm-remove-img-plant{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-plant{position:absolute;top:5px;right:20px}.btm-delete-img-plant{position:absolute;top:5px;right:70px}.btm-remove-img-plant{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btn-reload-img-vendor{position:absolute;top:5px;right:20px}.btn-delete-img-vendor{position:absolute;top:5px;right:70px}.btn-remove-img-vendor{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-user{position:absolute;top:5px;right:20px}.btm-delete-img-user{position:absolute;top:5px;right:70px}.btm-remove-img-user{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#myProgress{width:100%;background-color:#ddd}.myBar{width:10%;height:30px;background-color:#4caf50;text-align:center;line-height:30px;color:#fff}.btm-reload-img-user{position:absolute;top:5px;right:20px}.btm-delete-img-user{position:absolute;top:5px;right:70px}.btm-remove-img-user{position:absolute;top:5px;right:20px}.select2,.select2-dropdown{font-size:1.2rem}@media (max-width:425px){.m-body .m-content{padding:20px 5px}}@media (max-width:1200px){.m-wizard.m-wizard--2{margin-top:8rem!important}#activity_wizard .m-wizard__form .m-form .m-portlet__body{padding:2.2rem 0!important}}", ""]);

// exports


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "td.dt-control{cursor:pointer}td.dt-control:before{content:\"+\";display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border:1.5px solid #5d78ff;border-radius:50%;font-size:14px;font-weight:700;color:#5d78ff;margin-right:5px;line-height:1}tr.shown td.dt-control:before{content:\"\\2212\"}", ""]);

// exports


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "td.dt-control{cursor:pointer}td.dt-control:before{content:\"+\";display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border:1.5px solid #5d78ff;border-radius:50%;font-size:14px;font-weight:700;color:#5d78ff;margin-right:5px;line-height:1}tr.shown td.dt-control:before{content:\"\\2212\"}", ""]);

// exports


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".select2,.select2-dropdown{font-size:1rem!important}#formSummaryStockTable>tbody>tr>td:last-child,#formSummaryStockTable>thead>tr>th:last-child{width:230px;min-width:230px;max-width:230px}#formSummaryStockTable>tbody>tr>td:nth-child(3){padding-left:12px}#formSummaryStockTable .fss-actions{display:flex;flex-wrap:nowrap;justify-content:center;align-items:center}#formSummaryStockTable .fss-action-btn{margin:2px;padding:4px 10px;font-size:.85rem;line-height:1.2;white-space:nowrap}#formSummaryStockTable .fss-expire-line{font-size:.8rem;white-space:nowrap;margin-top:2px}#formSummaryStockTable .fss-expire-warn{color:#fd397a;font-weight:500}#formSummaryStockTable .fss-expire-date{color:#48465b}", ""]);

// exports


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#WarehouseScoreTable tr{height:100px}", ""]);

// exports


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".select2,.select2-dropdown{font-size:1rem!important}", ""]);

// exports


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".select2,.select2-dropdown{font-size:1rem!important}", ""]);

// exports


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".select2,.select2-dropdown{font-size:1rem!important}", ""]);

// exports


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".fss-result__summary[data-v-14b1f502]{background-color:#f7f8fa;border:1px solid #ebedf2;border-radius:4px;padding:1rem 1.25rem;margin-bottom:1rem}.fss-result__headline[data-v-14b1f502]{background-color:#28a745;color:#fff;padding:8px 14px;border-radius:4px;font-size:1.1rem}.fss-result__count[data-v-14b1f502]{margin:0 .15rem}.fss-result__filter[data-v-14b1f502]{margin-bottom:1rem}.fss-filter-table[data-v-14b1f502]{margin-bottom:0}.fss-filter-table__label[data-v-14b1f502]{width:12rem;font-weight:600;color:#6c7293}.fss-total-row[data-v-14b1f502]{background-color:#f7f8fa}.fss-branch-line[data-v-14b1f502]{margin-top:.25rem;color:#74788d;font-size:.85rem;font-weight:400}.fss-detail-row>td[data-v-14b1f502]{background-color:#fafbfc}.fss-detail[data-v-14b1f502]{padding:.5rem .25rem}.fss-detail__title[data-v-14b1f502]{margin-bottom:.5rem;font-weight:600;color:#6c7293}.fss-result__bulk[data-v-14b1f502]{margin-bottom:1rem}.fss-result__bulk-note[data-v-14b1f502]{display:block;margin-top:.5rem;color:#74788d;font-size:.9rem}.fss-result__search[data-v-14b1f502]{display:flex;align-items:center;flex-wrap:wrap;margin-bottom:.75rem}.fss-result__search-box[data-v-14b1f502]{width:100%}.fss-result__search-count[data-v-14b1f502]{margin-left:.75rem;color:#74788d;font-size:.9rem}.fss-result__empty[data-v-14b1f502]{color:#74788d;font-style:italic}.fss-result__doc-link[data-v-14b1f502]{color:#5867dd;font-weight:600;text-decoration:underline}.fss-result__doc-link[data-v-14b1f502]:hover{color:#3f51b5}.fss-result__once[data-v-14b1f502]{display:flex;align-items:flex-start;background-color:#fff4de;border:1px solid #ffd77a;border-left:4px solid #ffb822;border-radius:4px;padding:.75rem .9rem;margin-top:1rem;color:#48465b;font-size:.95rem}.fss-result__once i[data-v-14b1f502]{color:#ffb822;margin-right:.6rem;margin-top:.15rem}", ""]);

// exports


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".readonly-field[data-v-2f9bb3dc]{background-color:#e9ecef!important;cursor:not-allowed}.table-sm td[data-v-2f9bb3dc],.table-sm th[data-v-2f9bb3dc]{padding:.35rem;vertical-align:middle}.scvd-flat-grid[data-v-2f9bb3dc]{min-width:1200px}", ""]);

// exports


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".fss-progress__timer[data-v-32d44a3c]{margin-left:auto;align-self:center;font-variant-numeric:tabular-nums;font-weight:600;font-size:1.1rem;letter-spacing:.5px;white-space:nowrap}.fss-progress__headline[data-v-32d44a3c]{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:.5rem}.fss-progress__counter[data-v-32d44a3c]{font-size:1.15rem;font-weight:600}.fss-progress__percent[data-v-32d44a3c]{font-size:1.35rem;font-weight:700}.fss-progress__bar[data-v-32d44a3c]{height:1.25rem}.fss-progress__current[data-v-32d44a3c]{margin-top:.75rem;color:#5867dd}.fss-progress__stats[data-v-32d44a3c]{margin-top:.75rem;display:flex;flex-wrap:wrap}.fss-progress__stat[data-v-32d44a3c]{margin-right:1.25rem;font-size:.95rem}.fss-progress__stat--ok[data-v-32d44a3c]{color:#0abb87}.fss-progress__stat--skip[data-v-32d44a3c]{color:#74788d}.fss-progress__stat--fail[data-v-32d44a3c]{color:#fd397a}.fss-progress__log[data-v-32d44a3c]{margin-top:1rem;max-height:260px;overflow-y:auto;border:1px solid #ebedf2;border-radius:4px;padding:.5rem .75rem;background-color:#fafbfc}.fss-progress__row[data-v-32d44a3c]{display:flex;align-items:baseline;padding:.2rem 0;font-size:.92rem}.fss-progress__row--ok .fss-progress__icon[data-v-32d44a3c]{color:#0abb87}.fss-progress__row--skip .fss-progress__icon[data-v-32d44a3c]{color:#a7abc3}.fss-progress__row--fail .fss-progress__icon[data-v-32d44a3c]{color:#fd397a}.fss-progress__icon[data-v-32d44a3c]{width:1.4rem;font-weight:700}.fss-progress__seq[data-v-32d44a3c]{width:2.2rem;color:#74788d}.fss-progress__name[data-v-32d44a3c]{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.fss-progress__note[data-v-32d44a3c]{margin-left:.75rem;color:#74788d;white-space:nowrap}.fss-progress__empty[data-v-32d44a3c]{color:#a7abc3;text-align:center;padding:1rem 0}.fss-progress__result[data-v-32d44a3c]{margin-top:1rem;margin-bottom:0}.fss-progress__cancelling[data-v-32d44a3c]{margin-top:.75rem;color:#ffb822}.fss-progress--error[data-v-32d44a3c]{background-color:#fff4e0;border:1px solid #ffd79a}.fss-progress--error .modal-header[data-v-32d44a3c]{background-color:#ffe7c2;border-bottom-color:#ffd79a;color:#8a5a00}.fss-progress--error .modal-footer[data-v-32d44a3c]{border-top-color:#ffd79a}.fss-progress__error[data-v-32d44a3c]{margin-top:1rem;padding:.9rem 1rem;border:1px solid #ffd79a;border-left:4px solid #ffb822;border-radius:4px;background-color:#fffaf0}.fss-progress__error-stat[data-v-32d44a3c]{color:#0abb87;font-weight:600}.fss-progress__error-agent[data-v-32d44a3c]{margin-top:.35rem;color:#fd397a;font-weight:600}.fss-progress__error-ref[data-v-32d44a3c]{margin-top:.35rem;color:#74788d;font-size:.9rem}.fss-progress__error-ref code[data-v-32d44a3c]{color:#48465b;background-color:#f2f3f8;padding:1px 6px;border-radius:3px}.fss-progress__error-detail-btn[data-v-32d44a3c]{margin-top:.75rem;background-color:#ebf3fc;color:#3b7ddd;border:1px solid #3b7ddd;font-weight:600}.fss-progress__error-detail-btn[data-v-32d44a3c]:focus,.fss-progress__error-detail-btn[data-v-32d44a3c]:hover{background-color:#d5e5f8;color:#3b7ddd}.fss-progress__error-choose[data-v-32d44a3c]{margin-top:.9rem;color:#48465b;font-weight:600}.fss-error-action[data-v-32d44a3c]{display:block;width:100%;text-align:left;border:2px solid #e0e7ef;border-radius:6px;padding:12px 14px;margin:8px 0;background-color:#fff;cursor:pointer;transition:background-color .15s,border-color .15s}.fss-error-action[data-v-32d44a3c]:disabled{opacity:.6;cursor:default}.fss-error-action__title[data-v-32d44a3c]{display:block;font-weight:600;font-size:.95rem;margin-bottom:4px}.fss-error-action__title i[data-v-32d44a3c]{margin-right:8px}.fss-error-action__desc[data-v-32d44a3c]{display:block;margin-left:24px;color:#74788d;font-size:.85rem;line-height:1.5;white-space:normal}.fss-error-action--resume[data-v-32d44a3c]{border-color:#28a745;background-color:#f1faf3}.fss-error-action--resume[data-v-32d44a3c]:hover:not(:disabled){background-color:#daf3df}.fss-error-action--resume .fss-error-action__title[data-v-32d44a3c]{color:#217346}.fss-error-action--skip[data-v-32d44a3c]{border-color:#5867dd;background-color:#f4f5fd}.fss-error-action--skip[data-v-32d44a3c]:hover:not(:disabled){background-color:#e3e6fa}.fss-error-action--skip .fss-error-action__title[data-v-32d44a3c]{color:#3f4bb8}", ""]);

// exports


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".monitoring-card-link[data-v-34b7a5ce]{display:block;text-decoration:none;color:inherit}.monitoring-card-link[data-v-34b7a5ce]:hover{text-decoration:none}.monitoring-card[data-v-34b7a5ce]{cursor:pointer;transition:transform .15s ease,box-shadow .15s ease;border:1px solid #ebedf2}.monitoring-card[data-v-34b7a5ce]:hover{transform:translateY(-3px);box-shadow:0 .5rem 1rem rgba(0,0,0,.1);border-color:#5867dd}.monitoring-card-icon[data-v-34b7a5ce]{padding-top:10px}.monitoring-card-title[data-v-34b7a5ce]{font-weight:500;color:#48465b}.monitoring-card-desc[data-v-34b7a5ce]{font-size:.9rem}", ""]);

// exports


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".card[data-v-3f5f4284]{box-shadow:0 2px 4px rgba(0,0,0,.1)}.card-header[data-v-3f5f4284]{padding:.5rem 1rem}.scd-matrix[data-v-3f5f4284]{min-width:900px}.scd-matrix td[data-v-3f5f4284],.scd-matrix th[data-v-3f5f4284]{padding:.25rem .35rem;vertical-align:middle;white-space:nowrap}.scd-label[data-v-3f5f4284]{width:130px;text-align:left;font-weight:600}.scd-input[data-v-3f5f4284]{min-width:56px;padding:.15rem .25rem}.scd-row-saledays[data-v-3f5f4284]{background-color:#d9d9d9}.scd-row-months[data-v-3f5f4284]{background-color:#ffe599}.scd-row-bg[data-v-3f5f4284]{background-color:#cfe2f3}.scd-row-demand[data-v-3f5f4284]{background-color:#d9ead3}.scd-row-supply[data-v-3f5f4284]{background-color:#ead1dc}.scd-row-scvd[data-v-3f5f4284]{background-color:#d9d2e9}.scd-hint[data-v-3f5f4284]{position:relative;display:inline-block}.scd-hint-text[data-v-3f5f4284]{display:none;position:absolute;top:100%;left:0;z-index:1000;min-width:320px;max-width:560px;margin-top:6px;padding:8px 12px;background-color:#333;color:#fff;font-size:.85rem;font-weight:400;line-height:1.5;white-space:normal;text-align:left;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.25)}.scd-hint:focus-within .scd-hint-text[data-v-3f5f4284],.scd-hint:hover .scd-hint-text[data-v-3f5f4284]{display:block}", ""]);

// exports


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".scd-report[data-v-449a8e25]{min-width:1100px}.scd-report td[data-v-449a8e25],.scd-report th[data-v-449a8e25]{padding:.35rem .5rem;vertical-align:middle;white-space:nowrap}.scd-report thead th[data-v-449a8e25]{background-color:#d9ead3;text-align:center;vertical-align:middle}.scd-status-cell[data-v-449a8e25]{font-weight:600}.scd-total-row td[data-v-449a8e25]{background-color:#f2f2f2;font-weight:600}.scd-grand-total-row td[data-v-449a8e25]{background-color:#d0cece;font-weight:700}", ""]);

// exports


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".monitoring-card-link[data-v-463c4600]{display:block;text-decoration:none;color:inherit}.monitoring-card-link[data-v-463c4600]:hover{text-decoration:none}.monitoring-card[data-v-463c4600]{cursor:pointer;transition:transform .15s ease,box-shadow .15s ease;border:1px solid #ebedf2}.monitoring-card[data-v-463c4600]:hover{transform:translateY(-3px);box-shadow:0 .5rem 1rem rgba(0,0,0,.1);border-color:#5867dd}.monitoring-card-icon[data-v-463c4600]{padding-top:10px}.monitoring-card-title[data-v-463c4600]{font-weight:500;color:#48465b}.monitoring-card-desc[data-v-463c4600]{font-size:.9rem}", ""]);

// exports


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".scvd-dashboard[data-v-4bd97ad2]{font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Sarabun,Tahoma,Arial,sans-serif;color:#1a1a1a;font-size:14px}.scvd-container[data-v-4bd97ad2]{background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 0 20px rgba(0,0,0,.05)}.scvd-header[data-v-4bd97ad2]{background:linear-gradient(135deg,#ffdb00,#f4c800);color:#58595b;padding:14px 24px;display:flex;justify-content:space-between;align-items:center}.scvd-header h1[data-v-4bd97ad2]{font-size:22px;font-weight:700;margin:0}.scvd-header .subtitle[data-v-4bd97ad2]{font-size:12.5px;opacity:.8;margin-top:2px}.scvd-header .meta[data-v-4bd97ad2]{font-size:11px;color:rgba(0,0,0,.7);text-align:right;display:flex;flex-direction:column;align-items:flex-end;gap:3px}.scvd-header .sync-status[data-v-4bd97ad2]{display:inline-flex;align-items:center;gap:5px;background:rgba(0,0,0,.06);padding:2px 8px;border-radius:10px;font-size:10px}.scvd-header .sync-dot[data-v-4bd97ad2]{width:6px;height:6px;border-radius:50%;background:#22c55e;box-shadow:0 0 4px #22c55e}.setup-collapsed[data-v-4bd97ad2]{background:#fffdf0;padding:10px 24px;border-bottom:1px solid #f0e0a0;display:flex;justify-content:space-between;align-items:center;gap:12px}.criteria-summary[data-v-4bd97ad2]{display:flex;align-items:center;gap:8px;font-size:12px;flex-wrap:wrap}.criteria-badge[data-v-4bd97ad2]{padding:3px 10px;border-radius:12px;font-size:11px;font-weight:500}.target-badge[data-v-4bd97ad2]{padding:3px 10px;border-radius:12px;background:#f3e8ff;color:#7e22ce;font-weight:600;font-size:11px}.btn-edit[data-v-4bd97ad2]{padding:6px 14px;background:#fff;border:1px solid #cbd5e1;border-radius:6px;font-size:11px;cursor:pointer;color:#64748b;font-weight:500;white-space:nowrap}.btn-edit[data-v-4bd97ad2]:hover{background:#f8fafc}.filter-bar[data-v-4bd97ad2]{padding:16px 24px;background:#fff;border-bottom:1px solid #e5e7eb;display:flex;gap:14px;align-items:flex-end;flex-wrap:wrap}.filter-group[data-v-4bd97ad2]{display:flex;flex-direction:column;gap:4px;min-width:120px}.filter-group label[data-v-4bd97ad2]{font-size:11px;color:#6b7280;font-weight:500}.scvd-select[data-v-4bd97ad2]{padding:8px 12px;border:1px solid #d1d5db;border-radius:6px;background:#fff;font-size:13px;color:#1a1a1a;cursor:pointer;height:36px}.btn-primary-apply[data-v-4bd97ad2]{height:36px;padding:0 16px;background:#58595b;color:#fff;border:none;border-radius:6px;font-size:13px;font-weight:600;cursor:pointer}.btn-primary-apply[data-v-4bd97ad2]:hover{background:#3d3e40}.btn-formula[data-v-4bd97ad2]{height:36px;margin-left:auto;padding:0 14px;background:hsla(0,0%,100%,.85);border:1px solid rgba(0,0,0,.15);border-radius:6px;cursor:pointer;font-size:12px;font-weight:600;color:#1a1a1a}.btn-formula[data-v-4bd97ad2]:hover{background:#fff;box-shadow:0 2px 6px rgba(0,0,0,.1)}.active-filter-strip[data-v-4bd97ad2]{padding:10px 24px;background:#eef2ff;border-bottom:1px solid #c7d2fe;display:flex;align-items:center;gap:10px;font-size:12px;color:#4338ca;flex-wrap:wrap}.filter-strip-label[data-v-4bd97ad2]{font-weight:600}.filter-chip[data-v-4bd97ad2]{padding:4px 6px 4px 12px;background:#fff;border:1px solid #c7d2fe;border-radius:16px;display:inline-flex;align-items:center;gap:6px;font-weight:500;color:#1a1a1a}.filter-chip .remove-chip[data-v-4bd97ad2]{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;background:#f3f4f6;border-radius:50%;color:#6b7280;font-weight:700;cursor:pointer;font-size:12px}.filter-chip .remove-chip[data-v-4bd97ad2]:hover{background:#e5e7eb}.btn-clear-filter[data-v-4bd97ad2]{margin-left:auto;padding:4px 10px;background:transparent;border:1px solid #a5b4fc;border-radius:4px;font-size:11px;color:#4338ca;cursor:pointer}.scvd-loading[data-v-4bd97ad2]{text-align:center;padding:60px 20px;color:#6b7280}.scvd-empty-block[data-v-4bd97ad2]{text-align:center;padding:30px 20px;color:#94a3b8;background:#f8fafc;border:1px dashed #cbd5e1;border-radius:8px}.dashboard[data-v-4bd97ad2]{padding:20px 24px 36px;background:#f5f7fa;display:flex;flex-direction:column;gap:20px}.row-2col[data-v-4bd97ad2]{display:grid;grid-template-columns:3fr 2fr;gap:20px}@media (max-width:1100px){.row-2col[data-v-4bd97ad2]{grid-template-columns:1fr}}.widget[data-v-4bd97ad2]{background:#fff;border-radius:12px;box-shadow:0 1px 3px rgba(0,0,0,.05);padding:20px;border:1px solid #f0f0f0}.widget-header[data-v-4bd97ad2]{display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;padding-bottom:12px;border-bottom:1px solid #f0f0f0;gap:12px}.widget-title[data-v-4bd97ad2]{font-size:15px;font-weight:700;color:#1a1a1a}.widget-hint[data-v-4bd97ad2]{font-size:11px;color:#6b7280;font-style:italic}.bullet-toolbar[data-v-4bd97ad2]{display:flex;align-items:center;gap:10px;flex-wrap:nowrap;justify-content:flex-end;flex-shrink:0}.bullet-sort[data-v-4bd97ad2]{width:auto;min-width:0}.bullet-header-wrap .widget-title[data-v-4bd97ad2]{flex:1 1 auto;min-width:0}@media (max-width:1200px){.bullet-toolbar[data-v-4bd97ad2]{flex-wrap:wrap}.bullet-toolbar .widget-hint[data-v-4bd97ad2]{display:none}}.alert-summary[data-v-4bd97ad2]{display:flex;gap:12px;margin-bottom:14px}.alert-summary-item[data-v-4bd97ad2]{flex:1;padding:10px 14px;border-radius:8px;display:flex;flex-direction:column;gap:8px}.alert-summary-top[data-v-4bd97ad2]{display:flex;justify-content:space-between;align-items:center}.alert-summary-count-row[data-v-4bd97ad2]{display:flex;align-items:baseline;gap:6px}.alert-summary-count[data-v-4bd97ad2]{font-size:24px;font-weight:800;line-height:1;color:#1a1a1a}.alert-summary-unit[data-v-4bd97ad2]{font-size:13px;font-weight:700;color:#1a1a1a}.alert-summary-desc[data-v-4bd97ad2]{font-size:10px;color:#6b7280;margin-top:3px}.alert-summary-label[data-v-4bd97ad2]{font-size:11px;color:#4b5563;font-weight:500;text-align:right}.alert-summary-guidance[data-v-4bd97ad2]{font-size:11.5px;font-weight:600;padding:7px 10px;background:hsla(0,0%,100%,.7);border-radius:5px;line-height:1.4}.alert-grid[data-v-4bd97ad2]{display:grid;grid-template-columns:1fr 1fr;gap:10px;align-items:start}.alert-column[data-v-4bd97ad2]{display:flex;flex-direction:column;gap:10px;max-height:640px;overflow-y:auto}.alert-empty-state[data-v-4bd97ad2]{padding:40px 20px;text-align:center;color:#94a3b8;font-size:13px;background:#f8fafc;border:1px dashed #cbd5e1;border-radius:8px;min-height:120px;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:8px}.alert-empty-state .empty-emoji[data-v-4bd97ad2]{font-size:24px}.alert-card[data-v-4bd97ad2]{background:#fff;border:1px solid #e5e7eb;border-left:4px solid #ccc;border-radius:8px;padding:6px 12px;cursor:pointer;transition:all .15s}.alert-card[data-v-4bd97ad2]:hover{transform:translateY(-2px);box-shadow:0 6px 16px rgba(0,0,0,.1);border-color:#d1d5db}.alert-card-top[data-v-4bd97ad2]{display:flex;justify-content:space-between;align-items:center;margin-bottom:2px}.alert-status[data-v-4bd97ad2]{font-size:9.5px;font-weight:700;padding:2px 8px;border-radius:4px}.alert-trend[data-v-4bd97ad2]{font-size:10.5px;font-weight:600;display:flex;align-items:center;gap:2px}.alert-trend.down[data-v-4bd97ad2]{color:#b04747}.alert-trend.up[data-v-4bd97ad2]{color:#2c6b3d}.alert-trend.stable[data-v-4bd97ad2]{color:#6b7280}.alert-sku[data-v-4bd97ad2]{font-size:14px;font-weight:700;color:#1a1a1a;margin-bottom:1px}.alert-warehouse[data-v-4bd97ad2]{font-size:11px;color:#6b7280;margin-bottom:2px}.alert-metric-row[data-v-4bd97ad2]{display:flex;justify-content:space-between;align-items:flex-end;padding-top:3px;border-top:1px dashed #f0f0f0}.alert-metric-left[data-v-4bd97ad2]{display:flex;align-items:baseline;gap:4px;flex-wrap:wrap}.alert-value[data-v-4bd97ad2]{font-size:28px;font-weight:800;line-height:1}.alert-unit[data-v-4bd97ad2]{font-size:12px;color:#6b7280}.alert-metric-label[data-v-4bd97ad2]{font-size:9.5px;color:#9ca3af;font-style:italic;width:100%;display:block}.alert-target[data-v-4bd97ad2]{font-size:10.5px;color:#6b7280;text-align:right;line-height:1.35}.alert-target-src[data-v-4bd97ad2]{font-size:9px;color:#9ca3af}.pie-container[data-v-4bd97ad2]{display:flex;flex-direction:column;align-items:stretch;gap:14px}.pie-svg[data-v-4bd97ad2]{width:100%;max-width:340px;height:auto;margin:0 auto;display:block}.pie-slice-clickable[data-v-4bd97ad2]{transition:all .15s}.pie-slice-clickable:hover circle[data-v-4bd97ad2]{stroke-width:12;filter:brightness(1.08)}.pie-slice-clickable:hover text[data-v-4bd97ad2]{font-size:3.6}.pie-legend[data-v-4bd97ad2]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;gap:8px 16px;padding:12px 14px;background:#f9fafb;border-radius:6px;font-size:11.5px;border:1px solid #f0f0f0}.pie-legend-item[data-v-4bd97ad2]{display:flex;align-items:center;gap:6px;padding:3px 6px;border-radius:4px;white-space:nowrap}.pie-color-box[data-v-4bd97ad2]{width:12px;height:12px;border-radius:3px;flex-shrink:0}.pie-legend-item strong[data-v-4bd97ad2]{color:#1a1a1a;font-weight:700;min-width:30px}.pie-legend-item-desc[data-v-4bd97ad2]{color:#6b7280;font-size:11px}.pie-legend-item.clickable[data-v-4bd97ad2]{cursor:pointer}.pie-legend-item.clickable[data-v-4bd97ad2]:hover{background:#eef2ff}.pie-legend-drill[data-v-4bd97ad2]{color:#4338ca;font-weight:700}.pie-nodata-note[data-v-4bd97ad2]{font-size:10.5px;color:#9ca3af;text-align:center;font-style:italic}.pie-drill-bar[data-v-4bd97ad2]{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:6px;flex-wrap:wrap}.pie-crumbs[data-v-4bd97ad2]{display:flex;align-items:center;gap:4px;font-size:11.5px;flex-wrap:wrap}.pie-crumb[data-v-4bd97ad2]{color:#4338ca;cursor:pointer;padding:2px 8px;border-radius:12px;background:#eef2ff;border:1px solid #c7d2fe;font-weight:600}.pie-crumb[data-v-4bd97ad2]:hover{background:#e0e7ff}.pie-crumb.active[data-v-4bd97ad2]{color:#1a1a1a;background:#ffdb00;border-color:#f4c800;cursor:default}.pie-crumb-sep[data-v-4bd97ad2]{color:#94a3b8;font-weight:700}.pie-back-btn[data-v-4bd97ad2]{padding:3px 10px;background:#fff;border:1px solid #cbd5e1;border-radius:6px;font-size:11px;color:#475569;cursor:pointer;font-weight:600;white-space:nowrap}.pie-back-btn[data-v-4bd97ad2]:hover{background:#f1f5f9}.bullet-warehouse[data-v-4bd97ad2]{margin-bottom:20px}.bullet-warehouse[data-v-4bd97ad2]:last-child{margin-bottom:0}.bullet-warehouse-title[data-v-4bd97ad2]{font-size:13.5px;font-weight:700;color:#1a1a1a;margin-bottom:6px;padding-bottom:6px;border-bottom:2px solid #ffdb00}.bullet-row[data-v-4bd97ad2]{padding:14px 12px 12px;border-bottom:1px solid #f0f0f0;border-radius:6px;cursor:pointer}.bullet-row[data-v-4bd97ad2]:hover{background:#fafbfc}.bullet-row[data-v-4bd97ad2]:last-child{border-bottom:none}.bullet-header[data-v-4bd97ad2]{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px;gap:12px}.bullet-sku-info[data-v-4bd97ad2]{display:flex;align-items:center;gap:10px}.bullet-sku[data-v-4bd97ad2]{font-size:14px;font-weight:700;color:#1a1a1a}.bullet-badge[data-v-4bd97ad2]{padding:2px 8px;border-radius:10px;font-size:10px;font-weight:700}.bullet-demand[data-v-4bd97ad2]{font-size:11px;color:#6b7280;text-align:right;line-height:1.4}.bullet-chart-wrapper[data-v-4bd97ad2]{padding:104px 0 24px;position:relative}.bullet-chart[data-v-4bd97ad2]{position:relative;height:28px;display:flex;border-radius:4px}.bullet-zone[data-v-4bd97ad2]{height:100%;display:flex;align-items:center;justify-content:center;font-size:9px;color:rgba(0,0,0,.55);font-weight:600;overflow:hidden}.bullet-zone[data-v-4bd97ad2]:first-child{border-radius:4px 0 0 4px}.bullet-zone[data-v-4bd97ad2]:last-child{border-radius:0 4px 4px 0}.bullet-actual[data-v-4bd97ad2]{position:absolute;top:6px;left:0;height:16px;background:#0891b2;border-radius:3px;z-index:5;box-shadow:0 1px 3px rgba(0,0,0,.2)}.bullet-marker[data-v-4bd97ad2]{position:absolute;top:-6px;width:3px;height:40px;z-index:6}.bullet-marker.target-master[data-v-4bd97ad2]{background:#1d4ed8;height:82px;top:-54px}.bullet-marker.target-scvd[data-v-4bd97ad2]{background:#7e22ce;height:112px;top:-84px}.bullet-marker-label[data-v-4bd97ad2]{position:absolute;transform:translateX(-50%);font-size:10px;font-weight:700;white-space:nowrap;text-align:center;padding:3px 10px;border-radius:3px;color:#fff;z-index:7;box-shadow:0 2px 4px rgba(0,0,0,.15)}.bullet-marker-label.actual[data-v-4bd97ad2]{background:#0891b2;top:-34px}.bullet-marker-label.actual[data-v-4bd97ad2]:after{content:\"\";position:absolute;left:50%;top:22px;width:3px;height:40px;background:#0891b2;transform:translateX(-50%);z-index:4}.bullet-marker-label.target-master[data-v-4bd97ad2]{background:#1d4ed8;top:-58px}.bullet-marker-label.target-scvd[data-v-4bd97ad2]{background:#7e22ce;top:-88px}.bullet-gap-box[data-v-4bd97ad2]{border-left:3px solid #ccc;padding:10px 14px;margin-top:6px;border-radius:4px}.bullet-gap-title[data-v-4bd97ad2]{font-weight:700;margin-bottom:6px;color:#1a1a1a;font-size:11.5px}.bullet-gap-row[data-v-4bd97ad2]{display:flex;gap:10px;padding:4px 0;color:#4b5563;font-size:12px;align-items:center;flex-wrap:wrap}.bullet-gap-label[data-v-4bd97ad2]{color:#6b7280;min-width:260px;flex-shrink:0}.bullet-gap-value[data-v-4bd97ad2]{font-weight:700}.bullet-gap-value.critical[data-v-4bd97ad2]{color:#b04747}.bullet-gap-value.planning[data-v-4bd97ad2]{color:#1d4ed8}.bullet-gap-value.ok[data-v-4bd97ad2]{color:#2c6b3d}.bullet-gap-value.neutral[data-v-4bd97ad2]{color:#4b5563}.mk-actual[data-v-4bd97ad2],.mk-target-master[data-v-4bd97ad2],.mk-target-scvd[data-v-4bd97ad2]{color:#fff;font-weight:700;padding:2px 8px;border-radius:3px;display:inline-block;line-height:1.4}.mk-actual[data-v-4bd97ad2]{background:#0891b2}.mk-target-master[data-v-4bd97ad2]{background:#1d4ed8}.mk-target-scvd[data-v-4bd97ad2]{background:#7e22ce}.gap-num[data-v-4bd97ad2]{display:inline-block;background:gray;color:#fff;width:20px;height:20px;line-height:20px;text-align:center;border-radius:3px;font-size:12px;font-weight:700;vertical-align:middle}.heatmap-warehouse[data-v-4bd97ad2]{margin-bottom:24px}.heatmap-warehouse[data-v-4bd97ad2]:last-child{margin-bottom:0}.heatmap-warehouse-title[data-v-4bd97ad2]{font-size:13.5px;font-weight:700;color:#1a1a1a;margin-bottom:10px;padding-bottom:6px;border-bottom:2px solid #ffdb00;display:flex;align-items:center;gap:6px;justify-content:space-between;flex-wrap:wrap}.heatmap-warehouse-meta[data-v-4bd97ad2]{font-size:11px;color:#6b7280;font-weight:500}.heatmap-scroll[data-v-4bd97ad2]{overflow-x:auto}.heatmap-table[data-v-4bd97ad2]{width:100%;border-collapse:separate;border-spacing:3px;font-size:11px;min-width:720px}.heatmap-table th[data-v-4bd97ad2]{font-weight:500;color:#6b7280;padding:4px;text-align:center;font-size:10.5px}.heatmap-table th.sku-header[data-v-4bd97ad2]{text-align:left;width:200px;padding-left:6px;color:#1a1a1a;font-weight:600;font-size:11px}.heatmap-table th.current-month[data-v-4bd97ad2]{background:#ffdb00;color:#1a1a1a;border-radius:4px;font-weight:700}.heatmap-sku-cell[data-v-4bd97ad2]{padding-left:6px;font-weight:500;color:#1a1a1a;text-align:left;font-size:11.5px;background:#f9fafb;border-radius:4px;white-space:nowrap}.heatmap-cell[data-v-4bd97ad2]{padding:10px 2px;text-align:center;border-radius:4px;font-size:10px;font-weight:700;cursor:pointer;transition:transform .1s;min-width:34px}.heatmap-cell[data-v-4bd97ad2]:hover{transform:scale(1.12);box-shadow:0 3px 10px rgba(0,0,0,.2)}.heatmap-cell.current-col[data-v-4bd97ad2]{outline:2px solid #f59e0b;outline-offset:-2px}.heatmap-legend[data-v-4bd97ad2]{display:flex;justify-content:center;gap:16px;margin-top:14px;padding-top:12px;border-top:1px solid #f0f0f0;font-size:10.5px;flex-wrap:wrap}.heatmap-legend-item[data-v-4bd97ad2]{display:flex;align-items:center;gap:5px;color:#4b5563}.heatmap-legend-swatch[data-v-4bd97ad2]{width:14px;height:14px;border-radius:3px}.scvd-modal-overlay[data-v-4bd97ad2]{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.55);z-index:1050;display:flex;justify-content:center;align-items:center}.scvd-modal[data-v-4bd97ad2]{background:#fff;border-radius:12px;width:860px;max-width:92vw;max-height:88vh;overflow:hidden;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,.3)}.scvd-modal-header[data-v-4bd97ad2]{padding:16px 24px;border-bottom:1px solid #e5e7eb;display:flex;justify-content:space-between;align-items:center;background:linear-gradient(135deg,#ffdb00,#f4c800)}.scvd-modal-header h2[data-v-4bd97ad2]{font-size:17px;font-weight:700;color:#1a1a1a;margin:0}.scvd-modal-header .modal-subtitle[data-v-4bd97ad2]{font-size:11.5px;color:rgba(0,0,0,.7);margin-top:3px}.scvd-modal-close[data-v-4bd97ad2]{background:rgba(0,0,0,.08);border:none;font-size:18px;cursor:pointer;color:#1a1a1a;width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0}.scvd-modal-close[data-v-4bd97ad2]:hover{background:rgba(0,0,0,.18)}.scvd-modal-body[data-v-4bd97ad2]{overflow-y:auto;padding:22px 24px;background:#fafbfc}.formula-section[data-v-4bd97ad2]{margin-bottom:16px;padding:14px 16px;background:#fff;border-radius:8px;border:1px solid #e5e7eb;border-left:4px solid #ffdb00}.formula-section[data-v-4bd97ad2]:last-child{margin-bottom:0}.formula-title[data-v-4bd97ad2]{font-size:14px;font-weight:700;color:#1a1a1a;margin-bottom:8px;display:flex;align-items:center;gap:6px}.formula-number[data-v-4bd97ad2]{background:#ffdb00;color:#1a1a1a;width:22px;height:22px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:12px;font-weight:800;flex-shrink:0}.formula-code[data-v-4bd97ad2]{font-family:Consolas,Courier New,monospace;background:#f8fafc;color:#0f172a;border:1px solid #e2e8f0;border-left:4px solid #58595b;padding:14px 18px;border-radius:6px;font-size:13px;line-height:2;margin:8px 0;white-space:pre-wrap;overflow-x:auto}.formula-example[data-v-4bd97ad2]{font-size:12px;color:#4b5563;padding:10px 14px;background:#f0fdf4;border-radius:5px;margin-top:8px;border-left:3px solid #22c55e;line-height:1.8}.formula-example b[data-v-4bd97ad2]{color:#1a1a1a}.formula-source[data-v-4bd97ad2]{font-size:11px;color:#6b7280;font-style:italic;margin-top:6px;padding-left:4px;line-height:1.6}.formula-important[data-v-4bd97ad2]{font-size:11.5px;color:#7f1d1d;background:#fef2f2;padding:8px 12px;border-radius:4px;margin-top:6px;border-left:3px solid #ff6b6b;line-height:1.5}.formula-location[data-v-4bd97ad2]{background:#eff6ff;border-left:3px solid #3b82f6;padding:8px 12px;border-radius:4px;font-size:12px;color:#1e40af;margin-bottom:10px;font-weight:500;line-height:1.5}.formula-visual[data-v-4bd97ad2]{background:#f8fafc;padding:14px;border-radius:6px;margin:8px 0;border:1px dashed #cbd5e1}.formula-visual-label[data-v-4bd97ad2]{font-size:10.5px;color:#6b7280;font-weight:600;margin-bottom:8px;text-transform:uppercase;letter-spacing:.5px}.visual-mockup[data-v-4bd97ad2]{background:#fff;border:1px solid #d1d5db;border-radius:8px;padding:12px 14px;font-size:11px;box-shadow:0 1px 3px rgba(0,0,0,.08);margin-bottom:8px}.visual-mockup[data-v-4bd97ad2]:last-child{margin-bottom:0}.visual-highlight[data-v-4bd97ad2]{background:#fef3c7;outline:2px solid #fbbf24;border-radius:3px;padding:1px 5px;font-weight:700;color:#78350f;display:inline-block}.visual-arrow[data-v-4bd97ad2]{color:#dc2626;font-weight:700;font-size:11px;margin-left:4px}.widget-group[data-v-4bd97ad2]{margin-bottom:26px}.widget-group[data-v-4bd97ad2]:last-child{margin-bottom:0}.widget-group-title[data-v-4bd97ad2]{font-size:15px;font-weight:800;color:#fff;background:linear-gradient(135deg,#1a1a1a,#4b5563);padding:12px 18px;border-radius:8px 8px 0 0;display:flex;align-items:center;gap:8px;scroll-margin-top:10px}.widget-group-body[data-v-4bd97ad2]{background:#fef9e7;border:1px solid #fbbf24;border-top:none;padding:14px;border-radius:0 0 8px 8px}.widget-group-body .formula-section[data-v-4bd97ad2]{background:#fff;border-left:3px solid #ffdb00}.modal-toc[data-v-4bd97ad2]{background:linear-gradient(135deg,#fef9e7,#fff8dc);border:1px solid #fbbf24;border-radius:8px;padding:14px 16px;margin-bottom:20px}.modal-toc-title[data-v-4bd97ad2]{font-size:12px;font-weight:700;color:#7c2d12;margin-bottom:8px;display:flex;align-items:center;gap:6px}.modal-toc-list[data-v-4bd97ad2]{display:grid;grid-template-columns:1fr 1fr;gap:6px}.modal-toc-item[data-v-4bd97ad2]{padding:6px 10px;background:#fff;border:1px solid #fde68a;border-radius:5px;font-size:12px;color:#1a1a1a;text-decoration:none;cursor:pointer;transition:all .15s;display:flex;align-items:center;gap:6px}.modal-toc-item[data-v-4bd97ad2]:hover{background:#fef3c7;border-color:#f59e0b;transform:translateX(2px)}.gap-forms-container[data-v-4bd97ad2]{display:flex;flex-direction:column;gap:12px;margin:10px 0}.gap-form-card[data-v-4bd97ad2]{border-radius:8px;padding:14px 18px;border-left:5px solid;box-shadow:0 1px 3px rgba(0,0,0,.05)}.gap-form-1[data-v-4bd97ad2]{background:linear-gradient(135deg,#fef2f2,#fff5f5);border-left-color:#ff6b6b}.gap-form-2[data-v-4bd97ad2]{background:linear-gradient(135deg,#faf5ff,#fdf4ff);border-left-color:#a855f7}.gap-form-3[data-v-4bd97ad2]{background:linear-gradient(135deg,#eff6ff,#f0f9ff);border-left-color:#3b82f6}.gap-form-header[data-v-4bd97ad2]{font-weight:800;font-size:13.5px;margin-bottom:4px;display:flex;align-items:center;gap:8px;flex-wrap:wrap}.gap-form-1 .gap-form-header[data-v-4bd97ad2]{color:#b04747}.gap-form-2 .gap-form-header[data-v-4bd97ad2]{color:#7e22ce}.gap-form-3 .gap-form-header[data-v-4bd97ad2]{color:#1d4ed8}.gap-form-badge[data-v-4bd97ad2]{background:#fff;padding:2px 8px;border-radius:10px;font-size:10px;font-weight:700}.gap-form-question[data-v-4bd97ad2]{font-size:11.5px;font-style:italic;color:#4b5563;margin-bottom:10px;padding-left:4px;line-height:1.5}.gap-form-formula[data-v-4bd97ad2]{background:#fff;padding:12px 16px;border-radius:6px;font-family:Consolas,Courier New,monospace;font-size:12px;line-height:2;margin-bottom:8px;white-space:pre-wrap;border:1px solid #e5e7eb;color:#1e293b;overflow-x:auto}.gap-form-example[data-v-4bd97ad2]{font-size:11.5px;color:#1e293b;padding:8px 12px;background:hsla(0,0%,100%,.7);border-radius:5px;line-height:1.7}.gap-form-example b[data-v-4bd97ad2]{font-weight:700}.bullet-gap-subnote[data-v-4bd97ad2]{font-weight:500;color:#94a3b8;font-size:10px}.alert-top-left[data-v-4bd97ad2]{display:flex;align-items:center;gap:6px}.status-swatch[data-v-4bd97ad2]{display:inline-block;width:10px;height:10px;border-radius:2px;margin-right:5px;vertical-align:middle;flex-shrink:0}.info-tooltip[data-v-4bd97ad2]{position:relative;display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;background:#cbd5e1;color:#475569;border-radius:50%;font-size:12px;font-weight:700;margin-left:8px;cursor:help;user-select:none;vertical-align:middle}.info-tooltip[data-v-4bd97ad2]:hover{background:#ffdb00;color:#58595b}.info-tooltip[data-v-4bd97ad2]:after{content:attr(data-tip);top:calc(100% + 8px);left:0;background:#1f2937;color:#fff;padding:10px 14px;border-radius:6px;font-size:12px;font-weight:400;font-style:normal;line-height:1.5;white-space:normal;width:max-content;max-width:340px;box-shadow:0 6px 18px rgba(0,0,0,.22)}.info-tooltip[data-v-4bd97ad2]:after,.info-tooltip[data-v-4bd97ad2]:before{position:absolute;z-index:100;opacity:0;visibility:hidden;transition:opacity .15s,visibility .15s;pointer-events:none}.info-tooltip[data-v-4bd97ad2]:before{content:\"\";top:calc(100% + 3px);left:12px;border:5px solid transparent;border-bottom-color:#1f2937}.info-tooltip[data-v-4bd97ad2]:hover:after,.info-tooltip[data-v-4bd97ad2]:hover:before{opacity:1;visibility:visible}.setup-modal-body[data-v-4bd97ad2]{overflow-y:auto;padding:0;background:#fafbfc}.setup-info-bar[data-v-4bd97ad2]{background:#e8f4fd;border-left:4px solid #2b8dd6;padding:12px 22px;font-size:13px;color:#444}.setup-warning-bar[data-v-4bd97ad2]{background:#fff4e6;border-left:4px solid #e3552c;padding:12px 22px;font-size:13px;color:#444}.setup-section[data-v-4bd97ad2]{padding:18px 24px;border-bottom:1px solid #eaeaea}.setup-section-title[data-v-4bd97ad2]{font-size:15px;font-weight:700;color:#58595b;margin-bottom:14px;display:flex;align-items:center;gap:8px}table.threshold[data-v-4bd97ad2]{width:100%;border-collapse:collapse;font-size:13px}table.threshold th[data-v-4bd97ad2]{background:#58595b;color:#fff;padding:10px 8px;text-align:center;font-weight:400;font-size:13px}table.threshold td[data-v-4bd97ad2]{padding:8px;border-bottom:1px solid #eaeaea;text-align:center;vertical-align:middle}table.threshold input[type=number][data-v-4bd97ad2],table.threshold input[type=text][data-v-4bd97ad2],table.threshold textarea[data-v-4bd97ad2]{padding:6px 8px;border:1px solid #cfd4d9;border-radius:4px;font-size:13px;width:100%;font-family:inherit}table.threshold textarea[data-v-4bd97ad2]{resize:vertical;min-height:40px}.color-picker[data-v-4bd97ad2]{width:30px;height:30px;border:2px solid #fff;border-radius:50%;box-shadow:0 0 0 1px #cfd4d9;padding:0;cursor:pointer;background:#fff;vertical-align:middle}.color-picker[data-v-4bd97ad2]::-webkit-color-swatch-wrapper{padding:0}.color-picker[data-v-4bd97ad2]::-webkit-color-swatch{border:none;border-radius:50%}.color-picker[data-v-4bd97ad2]::-moz-color-swatch{border:none;border-radius:50%}.btn-tdelete[data-v-4bd97ad2]{background:transparent;border:1px solid #d0d0d0;color:#b04747;padding:5px 10px;border-radius:4px;cursor:pointer;font-size:13px}.btn-tdelete[data-v-4bd97ad2]:hover:not(:disabled){background:#ffe0e0}.btn-tdelete[data-v-4bd97ad2]:disabled{opacity:.4;cursor:not-allowed}.btn-tadd[data-v-4bd97ad2]{background:#fff;border:2px dashed #58595b;color:#58595b;padding:10px 20px;border-radius:6px;cursor:pointer;margin-top:12px;font-size:14px;display:block;width:100%}.btn-tadd[data-v-4bd97ad2]:disabled{opacity:.4;cursor:not-allowed}.note-below[data-v-4bd97ad2]{margin-top:10px;font-size:12px;color:#777;font-style:italic}.target-row[data-v-4bd97ad2]{display:flex;align-items:center;gap:15px;font-size:15px;color:#444}.target-input[data-v-4bd97ad2]{padding:8px 12px;border:2px solid #ffdb00;border-radius:6px;font-size:16px;font-weight:700;width:100px;text-align:center;font-family:inherit}.setup-footer[data-v-4bd97ad2]{padding:16px 24px;background:#f8f9fa;display:flex;justify-content:flex-end;gap:12px;border-top:1px solid #e5e7eb}.btn-sf[data-v-4bd97ad2]{padding:12px 24px;border:none;border-radius:6px;cursor:pointer;font-family:inherit;font-size:14px;font-weight:700}.btn-sf[data-v-4bd97ad2]:disabled{opacity:.6;cursor:not-allowed}.btn-sf-primary[data-v-4bd97ad2]{background:#58595b;color:#fff}.btn-sf-primary[data-v-4bd97ad2]:hover:not(:disabled){background:#3d3e40}.btn-sf-warning[data-v-4bd97ad2]{background:#ffdb00;color:#58595b}.btn-sf-warning[data-v-4bd97ad2]:hover:not(:disabled){background:#e6c500}.badge-lock[data-v-4bd97ad2]{display:inline-block;background:rgba(0,0,0,.15);border-radius:4px;padding:2px 6px;font-size:11px;margin-left:4px}", ""]);

// exports


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".card[data-v-5a063a94]{box-shadow:0 2px 4px rgba(0,0,0,.1)}.card-header[data-v-5a063a94]{padding:.5rem 1rem}.scd-summary[data-v-5a063a94]{display:flex;flex-wrap:wrap}.scd-summary-col[data-v-5a063a94]{flex:0 0 50%;max-width:50%}@media (max-width:767px){.scd-summary-col[data-v-5a063a94]{flex:0 0 100%;max-width:100%}}.scd-summary div[data-v-5a063a94]{padding:2px 0}.scd-matrix[data-v-5a063a94]{min-width:958px;table-layout:fixed}.scd-matrix td[data-v-5a063a94],.scd-matrix th[data-v-5a063a94]{padding:.25rem .35rem;vertical-align:middle;white-space:nowrap}.scd-col-label[data-v-5a063a94]{width:140px}.scd-col-month[data-v-5a063a94]{width:62px}.scd-col-total[data-v-5a063a94]{width:74px}.scd-label[data-v-5a063a94]{width:140px;text-align:center;font-weight:600}.scd-row-saledays[data-v-5a063a94]{background-color:#d9d9d9}.scd-row-months[data-v-5a063a94]{background-color:#ffe599}.scd-row-bg[data-v-5a063a94]{background-color:#cfe2f3}.scd-row-demand[data-v-5a063a94]{background-color:#d9ead3}.scd-row-supply[data-v-5a063a94]{background-color:#ead1dc}.scd-row-scvd[data-v-5a063a94]{background-color:#d9d2e9}.scd-col-total-cell[data-v-5a063a94]{background-color:#d9d9d9}.scd-total-card[data-v-5a063a94]{border:2px solid #b0bec5}.scd-total-card .card-header[data-v-5a063a94]{background-color:#eceff1!important}", ""]);

// exports


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".label-required[data-v-61f44978]:after{content:\" *\";color:#f44}", ""]);

// exports


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".trigger-card[data-v-66045d9c]{border:1px solid #ebedf2;border-radius:6px;padding:12px;height:100%;display:flex;flex-direction:column}.trigger-card.safe[data-v-66045d9c]{border-color:#b3d4ff;background:#f5faff}.trigger-card.warn[data-v-66045d9c]{border-color:#ffe0a3;background:#fffaf0}.trigger-card.danger[data-v-66045d9c]{border-color:#ffc2c2;background:#fff5f5}.tc-head[data-v-66045d9c]{display:flex;align-items:center;font-weight:600;margin-bottom:6px}.tc-name[data-v-66045d9c]{margin-left:8px}.tc-desc[data-v-66045d9c]{font-size:.85rem;color:#74788d;min-height:38px;margin-bottom:6px}.tc-risk[data-v-66045d9c]{font-size:.78rem;font-weight:600;margin-bottom:10px}.tc-risk.safe[data-v-66045d9c]{color:#0b7285}.tc-risk.warn[data-v-66045d9c]{color:#b7791f}.tc-risk.danger[data-v-66045d9c]{color:#c53030}.tc-blocked[data-v-66045d9c]{background:#fff5f5;border:1px dashed #fc8181;color:#c53030;font-size:.78rem;border-radius:4px;padding:5px 8px;margin-bottom:8px}.raw-json[data-v-66045d9c]{background:#1e1e1e;color:#d4d4d4;padding:12px;border-radius:4px;font-size:12px;max-height:420px;overflow:auto}.modal-overlay[data-v-66045d9c]{position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:1050}.modal-box[data-v-66045d9c]{background:#fff;border-radius:6px;display:flex;flex-direction:column}.confirm-box[data-v-66045d9c]{width:90vw;max-width:560px}.modal-header[data-v-66045d9c]{padding:12px 20px;border-bottom:1px solid #eee;display:flex;align-items:center;justify-content:space-between}.modal-body[data-v-66045d9c]{padding:20px}.modal-footer[data-v-66045d9c]{padding:12px 20px;border-top:1px solid #eee;display:flex;justify-content:flex-end}.modal-footer .btn+.btn[data-v-66045d9c]{margin-left:8px}", ""]);

// exports


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".fss-sig__staged[data-v-67d77557]{margin-top:10px;margin-bottom:0;padding:10px 12px;font-size:12.5px;line-height:1.6;display:flex;align-items:flex-start;flex-wrap:wrap;gap:8px}.fss-sig__staged>i[data-v-67d77557]{flex:0 0 auto;margin-top:2px}.fss-sig__staged>span[data-v-67d77557]{flex:1 1 220px;min-width:0}.fss-sig__delete-row[data-v-67d77557]{display:flex;align-items:center;gap:8px;margin-top:10px}.fss-sig__delete-label[data-v-67d77557]{font-size:12px}.fss-sig__save-default[data-v-67d77557]{background:#e3552c;border-color:#e3552c;color:#fff}.fss-sig__save-default[data-v-67d77557]:focus:not(:disabled),.fss-sig__save-default[data-v-67d77557]:hover:not(:disabled){background:#c8461f;border-color:#c8461f;color:#fff}.fss-sig__save-default[data-v-67d77557]:disabled{background:#e9a992;border-color:#e9a992;color:#fff;cursor:not-allowed}.alert[data-v-67d77557]{display:block}.alert>i[data-v-67d77557]{margin-right:.35rem}.fss-sig__header[data-v-67d77557]{background-color:#5d78ff;color:#fff}.fss-sig__header .modal-title[data-v-67d77557]{color:#fff}.fss-sig__header .close[data-v-67d77557],.fss-sig__header .close span[data-v-67d77557]{color:#fff;opacity:.85;text-shadow:none}.fss-sig__header .close[data-v-67d77557]:hover{opacity:1}.fss-sig__header-doc[data-v-67d77557]{color:hsla(0,0%,100%,.85);font-size:.85rem}.fss-sig__alert[data-v-67d77557]{margin-bottom:1rem}.fss-sig__tabs[data-v-67d77557]{margin-bottom:0}.fss-sig__tab-badge[data-v-67d77557]{margin-left:.35rem;vertical-align:middle}.fss-sig__content[data-v-67d77557]{border:1px solid #ebedf2;border-top:0;padding:1.25rem}.fss-sig__notice[data-v-67d77557]{margin-bottom:1rem}.fss-sig__frame-caption[data-v-67d77557]{font-size:.85rem;color:#74788d;margin-bottom:.35rem}.fss-sig__zoom-note[data-v-67d77557]{color:#5d78ff}.fss-sig__preview[data-v-67d77557]{display:flex;align-items:center;justify-content:center;min-height:160px;border:1px dashed #d1d7e2;border-radius:4px;background-color:#fff;padding:.75rem 0;overflow:hidden}.fss-sig__filecard[data-v-67d77557]{border:1px solid #ebedf2;border-radius:4px;padding:.85rem;height:100%}.fss-sig__filecard-title[data-v-67d77557]{font-weight:500;color:#48465b;margin-bottom:.5rem}.fss-sig__filename[data-v-67d77557]{word-break:break-all}.fss-sig__meta[data-v-67d77557]{margin-top:.4rem;font-size:.9rem}.fss-sig__delete[data-v-67d77557]{margin-top:.85rem;white-space:normal}.fss-sig__dropzone[data-v-67d77557]{margin-top:1.25rem;border:2px dashed #d1d7e2;border-radius:4px;padding:20px 16px;text-align:center;cursor:pointer;background-color:#f7f8fa;transition:border-color .15s ease-in-out,background-color .15s ease-in-out}.fss-sig__dropzone[data-v-67d77557]:hover{border-color:#5d78ff}.fss-sig__dropzone--danger[data-v-67d77557]:hover{border-color:#fd397a}.fss-sig__dropzone--over[data-v-67d77557]{border-color:#5d78ff;background-color:#eef1ff}.fss-sig__dropzone--danger.fss-sig__dropzone--over[data-v-67d77557]{border-color:#fd397a;background-color:#ffeef4}.fss-sig__dropzone--disabled[data-v-67d77557]{cursor:not-allowed;opacity:.6}.fss-sig__dropzone-icon[data-v-67d77557]{font-size:2rem;color:#5d78ff;display:block;margin-bottom:8px}.fss-sig__dropzone--danger .fss-sig__dropzone-icon[data-v-67d77557]{color:#fd397a}.fss-sig__dropzone-title[data-v-67d77557]{font-weight:500;margin-bottom:8px}.fss-sig__rules[data-v-67d77557]{margin-top:.5rem;font-size:.9rem}.fss-sig__lock-note[data-v-67d77557]{margin-top:1rem;margin-bottom:0;font-size:.9rem}.fss-sig__readonly[data-v-67d77557]{margin-top:.75rem;font-size:.9rem}.fss-sig__file[data-v-67d77557]{display:none}.fss-sig__zoom[data-v-67d77557]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1060;display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:rgba(0,0,0,.75);cursor:zoom-out}.fss-sig__zoom-image[data-v-67d77557]{max-width:92%;max-height:82%;background-color:#fff;padding:8px;border-radius:4px}.fss-sig__zoom-close[data-v-67d77557]{margin-top:.75rem;color:#fff;font-size:.9rem}", ""]);

// exports


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".modal-overlay[data-v-7b5131b7]{position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:1050}.modal-box[data-v-7b5131b7]{background:#fff;width:90vw;max-width:1200px;max-height:85vh;border-radius:6px;display:flex;flex-direction:column}.modal-header[data-v-7b5131b7]{padding:12px 20px;border-bottom:1px solid #eee;display:flex;justify-content:space-between;align-items:center}.modal-body[data-v-7b5131b7]{padding:16px 20px;overflow-y:auto}.card-body h4[data-v-7b5131b7]{font-size:1.5rem}.row-clickable[data-v-7b5131b7]{cursor:pointer;transition:background-color .15s ease}.row-clickable[data-v-7b5131b7]:hover{background-color:#eef6ff!important}.col-jobname[data-v-7b5131b7]{max-width:240px;word-break:break-word}.switch[data-v-7b5131b7]{position:relative;display:inline-block;width:38px;height:20px;margin:0}.switch input[data-v-7b5131b7]{opacity:0;width:0;height:0}.slider[data-v-7b5131b7]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#bbb;border-radius:20px;transition:.2s}.slider[data-v-7b5131b7]:before{position:absolute;content:\"\";height:14px;width:14px;left:3px;bottom:3px;background-color:#fff;border-radius:50%;transition:.2s}.switch input:checked+.slider[data-v-7b5131b7]{background-color:#28a745}.switch input:checked+.slider[data-v-7b5131b7]:before{transform:translateX(18px)}.switch input:disabled+.slider[data-v-7b5131b7]{opacity:.5;cursor:wait}", ""]);

// exports


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".score-box[data-v-7f42fada]{width:100px;height:100px;border:1px solid #5867dd;border-radius:0;display:flex;align-items:center;justify-content:center}.score-box--green[data-v-7f42fada],.score-box--red[data-v-7f42fada]{border-color:#ccc}.score-value[data-v-7f42fada]{font-size:3.5rem;font-weight:700;font-family:inherit}.info-hint[data-v-7f42fada]{position:relative;display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;margin-left:6px;background-color:#5d9cec;color:#fff;border-radius:5px;font-size:.75rem;font-weight:700;font-style:normal;font-family:Georgia,Times New Roman,serif;line-height:1;vertical-align:middle;cursor:pointer}.info-hint[data-v-7f42fada]:after{content:attr(data-tooltip);bottom:calc(100% + 8px);width:260px;background-color:#333;color:#fff;padding:8px 12px;border-radius:6px;font-size:.8rem;font-weight:400;font-style:normal;font-family:inherit;line-height:1.4;white-space:normal;text-align:left}.info-hint[data-v-7f42fada]:after,.info-hint[data-v-7f42fada]:before{position:absolute;left:50%;transform:translateX(-50%);z-index:1000;opacity:0;visibility:hidden;pointer-events:none}.info-hint[data-v-7f42fada]:before{content:\"\";bottom:calc(100% + 2px);border:6px solid transparent;border-top-color:#333}.info-hint[data-v-7f42fada]:hover:after,.info-hint[data-v-7f42fada]:hover:before{opacity:1;visibility:visible}", ""]);

// exports


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".Collapsible__content[data-v-98a2b5c4]{overflow:hidden}.Collapsible__contentInner[data-v-98a2b5c4]{height:auto}.Collapsible__trigger[data-v-98a2b5c4]{appearance:none;border:0;background:transparent;border-radius:0;font-family:inherit;font-size:inherit;font-style:inherit;text-align:inherit;color:inherit;padding:0;margin:0;display:block;width:100%;cursor:pointer}", ""]);

// exports


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".card[data-v-ac1b8a84]{box-shadow:0 2px 4px rgba(0,0,0,.1)}.card-header[data-v-ac1b8a84]{padding:.75rem 1rem}.card-header h5[data-v-ac1b8a84],.card-header h6[data-v-ac1b8a84]{margin-bottom:0}.ml-3[data-v-ac1b8a84]{margin-left:1.5rem!important}.table-sm td[data-v-ac1b8a84],.table-sm th[data-v-ac1b8a84]{padding:.4rem;vertical-align:middle}.badge[data-v-ac1b8a84]{font-size:.85em}.readonly-field[data-v-ac1b8a84]{background-color:#e9ecef!important;cursor:not-allowed}.summary-box[data-v-ac1b8a84]{font-size:.9rem;margin-top:1.5rem}.summary-box .d-flex[data-v-ac1b8a84]{padding:.25rem 0}", ""]);

// exports


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".card[data-v-ced9fe32]{box-shadow:0 2px 4px rgba(0,0,0,.1)}.card-header[data-v-ced9fe32]{padding:.75rem 1rem}.card-header h5[data-v-ced9fe32]{margin-bottom:0}.form-group[data-v-ced9fe32]{margin-bottom:.5rem}.form-group label[data-v-ced9fe32]{margin-bottom:.25rem;display:block}.form-group p[data-v-ced9fe32]{margin-bottom:0}", ""]);

// exports


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".fss-pdfsig[data-v-eeef6aea]{--fss-pdf-scale:1;position:relative;width:calc(126pt * var(--fss-pdf-scale));height:calc(101pt * var(--fss-pdf-scale));margin:0 auto;background-color:#fff;color:#000;font-family:Singha Water TH,Singha Water TH BIRT,TH Sarabun New,Sarabun,sans-serif;font-weight:400}.fss-pdfsig>[data-v-eeef6aea]{position:absolute;left:50%;transform:translateX(-50%)}.fss-pdfsig__sign[data-v-eeef6aea]{top:0;width:calc(79.2pt * var(--fss-pdf-scale));height:calc(39.6pt * var(--fss-pdf-scale));display:flex;align-items:center;justify-content:center}.fss-pdfsig__image[data-v-eeef6aea]{display:block;width:100%;height:100%;cursor:zoom-in}.fss-pdfsig__empty[data-v-eeef6aea]{color:#a7abc3;font-size:.9rem;white-space:nowrap}.fss-pdfsig__barcode[data-v-eeef6aea]{top:calc(41.9pt * var(--fss-pdf-scale));width:calc(126pt * var(--fss-pdf-scale));height:calc(34.8pt * var(--fss-pdf-scale))}.fss-pdfsig__text[data-v-eeef6aea]{font-size:calc(11pt * var(--fss-pdf-scale));line-height:calc(11.9pt * var(--fss-pdf-scale));height:calc(11.9pt * var(--fss-pdf-scale));white-space:nowrap;text-align:center}.fss-pdfsig__dots[data-v-eeef6aea]{top:calc(73.4pt * var(--fss-pdf-scale));width:calc(121.4pt * var(--fss-pdf-scale));overflow:hidden;text-align:left}.fss-pdfsig__by[data-v-eeef6aea]{top:calc(88.7pt * var(--fss-pdf-scale))}", ""]);

// exports


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".vendor-usage-scroll[data-v-f667fd82]{max-height:65vh;overflow:auto}.vendor-usage-table[data-v-f667fd82]{font-size:13px;table-layout:fixed}.vendor-usage-table td[data-v-f667fd82]{word-wrap:break-word}.vendor-usage-table thead th.sortable-th[data-v-f667fd82]{cursor:pointer;user-select:none;position:sticky}.vendor-usage-table thead th .sort-icon[data-v-f667fd82]{position:absolute;right:8px;top:50%;transform:translateY(-50%);font-size:.85rem;letter-spacing:-2px;color:hsla(0,0%,100%,.4)}.vendor-usage-table thead th .sort-icon .active[data-v-f667fd82]{color:#fff}.vendor-usage-table thead th[data-v-f667fd82]{position:sticky;top:0;z-index:2;background-color:#44546a;color:#fff;vertical-align:middle;font-weight:600;border:1px solid #b6bfcc;padding-top:.3rem;padding-bottom:.3rem;height:31px}.vendor-usage-table td[data-v-f667fd82]{vertical-align:top;border:none;border-left:1px solid #b6bfcc;border-right:1px solid #b6bfcc}.vendor-usage-table tbody tr.block-start:not(.vendor-start) td[data-v-f667fd82]:not(:first-child){border-top:1px solid #b6bfcc}.vendor-usage-table tbody tr.vendor-start td[data-v-f667fd82]{border-top:2px solid #8d99ab}.vendor-usage-table tbody td[data-v-f667fd82]:first-child{border-left:1px solid #b6bfcc}.vendor-usage-table tbody td[data-v-f667fd82]:last-child{border-right:1px solid #b6bfcc}.vendor-usage-table .grand-total-row td[data-v-f667fd82]{border-top:2px solid #44546a;border-bottom:2px solid #44546a;background-color:#d9e1f2}.vendor-usage-table tbody .grand-total-row td[data-v-f667fd82]:first-child{border-left:2px solid #44546a}.vendor-usage-table tbody .grand-total-row td[data-v-f667fd82]:last-child{border-right:2px solid #44546a}.vendor-usage-table tbody .grand-total-row td[data-v-f667fd82]:first-child{border-right:none}.vendor-usage-table tbody .grand-total-row td[data-v-f667fd82]:nth-child(2){border-left:none}.pre-line[data-v-f667fd82]{white-space:pre-line}", ""]);

// exports


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".stock-item-td{color:#6c7293}", ""]);

// exports


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".stock-item-td{color:#6c7293}", ""]);

// exports


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".TH{background:#ccc!important;text-align:center!important;font-weight:700!important;font-family:Noto Sans Thai UI;vertical-align:middle!important}.TH,.THMAC{font-size:16px!important}.THMAC{background:#c6e7ff!important}.THSYS{background:#ffe8cd!important}.THSYS,.THTOT{font-size:16px!important}.THTOT{background:#c9c9c9!important}#agentScore tbody td,#agentScore tbody td a,.TITLE{font-size:14px!important}.MAC{background:#e8f9ff!important}.MAC a{color:#0070c0!important}.SYS a{color:#bf8f00!important}.SYS{background:#f8f2e5!important}.TOT{background:#eee!important}#agentScore.table-bordered td,#agentScore.table-bordered th{border:1px solid #c2c2c2!important}#agentScore{border-collapse:separate!important;border-spacing:0}#agentScore thead th{position:sticky!important;top:0;z-index:10;background-clip:padding-box}#agentScore thead tr:nth-child(2) th{top:40px}#agentScore td .approved-icon{color:#00a651;display:block;font-size:.9em;line-height:1;margin-bottom:2px}#agentScore thead tr:first-child th{top:0;height:50px;padding:6px 8px}#agentScore thead tr:nth-child(2) th{top:50px;padding:6px 8px;height:50px}", ""]);

// exports


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "td{font-size:14.5px!important}.input-group-append>.input-group-text,td.form-group>input[type=number],td>.select2-container--default .select2-selection--single .select2-selection__rendered{padding-left:5px!important;padding-right:5px!important}@media print{@page{size:A4 landscape;margin-left:15px;margin-right:15px}body{transform:scale(.73)!important;transform-origin:top left!important;min-width:2250px!important;height:200%!important}}", ""]);

// exports


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "td{font-size:14.5px!important}.input-group-append>.input-group-text,td.form-group>input[type=number],td>.select2-container--default .select2-selection--single .select2-selection__rendered{padding-left:5px!important;padding-right:5px!important}@media print{@page{size:A4 landscape;margin-top:20px;margin-bottom:20px;margin-left:15px;margin-right:15px}body{transform:scale(.73)!important;transform-origin:top left!important;min-width:2250px!important;overflow-y:scroll!important}}", ""]);

// exports


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "td{font-size:14.5px!important}.input-group-append>.input-group-text,td.form-group>input[type=number],td>.select2-container--default .select2-selection--single .select2-selection__rendered{padding-left:5px!important;padding-right:5px!important}@media print{@page{size:A4 landscape;margin-top:20px;margin-bottom:20px;margin-left:15px;margin-right:15px}body{transform:scale(.73)!important;transform-origin:top left!important;min-width:2250px!important;overflow-y:scroll!important}}", ""]);

// exports


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".select2-container--default.select2-container--disabled .select2-selection--multiple,.select2-container--default.select2-container--disabled .select2-selection--single{background:#fff;border-color:#ebedf2}", ""]);

// exports


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".invalid-treeselect .vue-treeselect__control{border:1px solid #fd397a!important;border-radius:4px}", ""]);

// exports


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".bg-danger-duplicated{background-color:#f85c5c1a!important}", ""]);

// exports


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".stock-item-td{color:#6c7293}", ""]);

// exports


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".QiSubProductTypeSelect+.select2-container{margin-left:28px!important;width:60%!important}.QiSubProductTypeSelect{display:none!important}", ""]);

// exports


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".stock-item-td{color:#6c7293}", ""]);

// exports


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".stock-item-td{color:#6c7293}", ""]);

// exports


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".stock-item-td{color:#6c7293}", ""]);

// exports


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".stock-item-td{color:#6c7293}", ""]);

// exports


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".stock-item-td{color:#6c7293}", ""]);

// exports


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".stock-item-td{color:#6c7293}", ""]);

// exports


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".border-dashed{border:1px dashed;height:140px}", ""]);

// exports


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".select2-container{width:100%!important}", ""]);

// exports


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".border-dashed{border:1px dashed;height:140px}", ""]);

// exports


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#agentScoreReport .TH{background:#ccc!important;text-align:center!important;font-size:16px!important;font-weight:700!important;font-family:Noto Sans Thai UI;vertical-align:middle!important}#agentScoreReport .THMAC{background:#c6e7ff!important}#agentScoreReport .THSYS{background:#ffe8cd!important}#agentScoreReport .THTOT{background:#c9c9c9!important}#agentScoreReport .TITLE,#agentScoreReport tbody td,#agentScoreReport tbody td a{font-size:14px!important}#agentScoreReport .MAC{background:#e8f9ff!important}#agentScoreReport .SYS{background:#f8f2e5!important}#agentScoreReport .TOT{background:#eee!important}#agentScoreReport.table-bordered td,#agentScoreReport.table-bordered th{border:1px solid #c2c2c2!important}#agentScoreReport{border-collapse:separate!important;border-spacing:0}#agentScoreReport thead th{position:sticky!important;top:0;z-index:10;background-clip:padding-box}#agentScoreReport thead tr:first-child th{top:0}#agentScoreReport thead tr:nth-child(2) th{top:40px}#agentScore thead tr:first-child th{top:0;height:50px;padding:6px 8px}#agentScore thead tr:nth-child(2) th{top:50px;padding:6px 8px;height:50px}", ""]);

// exports


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".header-full{background-color:#fff2c6!important}.header-empty,.header-full{color:#000!important;font-size:.9em!important}.header-empty{background-color:#c2e2fa!important}.header-transit{background-color:#d4bee4!important;color:#000!important;font-size:.9em!important}.sub-header{font-size:.6em!important}.sub-header-1{color:#00b050!important}.sub-header-2{color:#806000!important}.sub-header-3{color:#c65911!important}.sub-header-4{color:#e62727!important}.group-header{background-color:#ddd!important;font-weight:700}.group-header td.td-header{background-color:#f4f4f4!important;font-weight:700}.hide-empty-sub .col-empty-sub,.hide-empty-sub .header-empty,.hide-full-sub .col-full-sub,.hide-full-sub .header-full,.hide-transit-sub .col-transit-sub,.hide-transit-sub .header-transit{display:none!important}.dataTables_scrollBody{overflow-x:auto!important}.group-footer-sub td.td-footer{background-color:#f1efef!important;font-weight:700;padding-left:0!important}", ""]);

// exports


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".group-header{background-color:#ddd!important;font-weight:700}.group-footer,.group-header td.td-header{background-color:#f4f4f4!important;font-weight:700}.group-footer-sub td.td-footer{background-color:#f1efef!important;font-weight:700;padding-left:0!important;font-size:15px!important}.group-footer td.td-footer{background-color:#ddd!important;font-weight:700;padding-left:0!important}.jas-bg-red{background-color:#fbefef!important}.jas-bg-red-strong{background-color:#f9dfdf!important}.jas-bg-green{background-color:#e2efda!important}.jas-bg-gray{background-color:#d9d9d9!important}", ""]);

// exports


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".group-header{background-color:#ddd!important;font-weight:700}.group-header td.td-header{background-color:#f4f4f4!important;font-weight:700}.group-footer-sub td.td-footer{background-color:#f1efef!important;font-weight:700;padding-left:0!important}.bg-red{background-color:#fce4d6!important;color:#c00000!important}.bg-green{background-color:#cfc!important;color:#0abb87!important}.bg-yellow{background-color:#fffde1!important}.criteria-section .col-label{display:inline-block;font-weight:700;margin-right:2rem}.criteria-section .product-title{margin-top:.5rem;margin-bottom:.25rem}.criteria-section .season-title{font-weight:700;margin-bottom:.25rem}.criteria-section .season-title.high{color:#0abb87}.criteria-section .season-title.low{color:#c00000}.criteria-section .criteria-box{background:#0f2544;color:#fff;padding:10px 14px;border-radius:4px}.criteria-section .criteria-row{display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;padding:3px 0}.criteria-section .criteria-row:first-child span{color:#7fe0ff}.criteria-section .criteria-row:nth-child(2) span,.criteria-section .criteria-row:nth-child(3) span{color:#ff6b6b}", ""]);

// exports


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".group-header{background-color:#ddd!important;font-weight:700}.group-header td.td-header{background-color:#f4f4f4!important;font-weight:700}.group-footer-sub td.td-footer{background-color:#f1efef!important;font-weight:700;padding-left:0!important}.bg-red{background-color:#fce4d6!important;color:#c00000!important}.bg-green{background-color:#cfc!important;color:#0abb87!important}.bg-yellow{background-color:#fffde1!important}.criteria-section .col-label{display:inline-block;font-weight:700;margin-right:2rem}.criteria-section .product-title{margin-top:.5rem;margin-bottom:.25rem}.criteria-section .season-title{font-weight:700;margin-bottom:.25rem}.criteria-section .season-title.high{color:#0abb87}.criteria-section .season-title.low{color:#c00000}.criteria-section .criteria-box{background:#0f2544;color:#fff;padding:10px 14px;border-radius:4px}.criteria-section .criteria-row{display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;padding:3px 0}.criteria-section .criteria-row:first-child span{color:#7fe0ff}.criteria-section .criteria-row:nth-child(2) span,.criteria-section .criteria-row:nth-child(3) span{color:#ff6b6b}", ""]);

// exports


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".vue-map-container{position:relative}.vue-map-container .vue-map{left:0;right:0;top:0;bottom:0;position:absolute}.vue-map-hidden{display:none}", ""]);

// exports


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".vue-street-view-pano-container{position:relative}.vue-street-view-pano-container .vue-street-view-pano{left:0;right:0;top:0;bottom:0;position:absolute}", ""]);

// exports


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! AutoFill 2.3.3
 * ©2008-2018 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     AutoFill
 * @description Add Excel like click and drag auto-fill options to DataTables
 * @version     2.3.3
 * @file        dataTables.autoFill.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     www.sprymedia.co.uk/contact
 * @copyright   Copyright 2010-2018 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */
(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


var _instance = 0;

/** 
 * AutoFill provides Excel like auto-fill features for a DataTable
 *
 * @class AutoFill
 * @constructor
 * @param {object} oTD DataTables settings object
 * @param {object} oConfig Configuration object for AutoFill
 */
var AutoFill = function( dt, opts )
{
	if ( ! DataTable.versionCheck || ! DataTable.versionCheck( '1.10.8' ) ) {
		throw( "Warning: AutoFill requires DataTables 1.10.8 or greater");
	}

	// User and defaults configuration object
	this.c = $.extend( true, {},
		DataTable.defaults.autoFill,
		AutoFill.defaults,
		opts
	);

	/**
	 * @namespace Settings object which contains customisable information for AutoFill instance
	 */
	this.s = {
		/** @type {DataTable.Api} DataTables' API instance */
		dt: new DataTable.Api( dt ),

		/** @type {String} Unique namespace for events attached to the document */
		namespace: '.autoFill'+(_instance++),

		/** @type {Object} Cached dimension information for use in the mouse move event handler */
		scroll: {},

		/** @type {integer} Interval object used for smooth scrolling */
		scrollInterval: null,

		handle: {
			height: 0,
			width: 0
		},

		/**
		 * Enabled setting
		 * @type {Boolean}
		 */
		enabled: false
	};


	/**
	 * @namespace Common and useful DOM elements for the class instance
	 */
	this.dom = {
		/** @type {jQuery} AutoFill handle */
		handle: $('<div class="dt-autofill-handle"/>'),

		/**
		 * @type {Object} Selected cells outline - Need to use 4 elements,
		 *   otherwise the mouse over if you back into the selected rectangle
		 *   will be over that element, rather than the cells!
		 */
		select: {
			top:    $('<div class="dt-autofill-select top"/>'),
			right:  $('<div class="dt-autofill-select right"/>'),
			bottom: $('<div class="dt-autofill-select bottom"/>'),
			left:   $('<div class="dt-autofill-select left"/>')
		},

		/** @type {jQuery} Fill type chooser background */
		background: $('<div class="dt-autofill-background"/>'),

		/** @type {jQuery} Fill type chooser */
		list: $('<div class="dt-autofill-list">'+this.s.dt.i18n('autoFill.info', '')+'<ul/></div>'),

		/** @type {jQuery} DataTables scrolling container */
		dtScroll: null,

		/** @type {jQuery} Offset parent element */
		offsetParent: null
	};


	/* Constructor logic */
	this._constructor();
};



$.extend( AutoFill.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Public methods (exposed via the DataTables API below)
	 */
	enabled: function ()
	{
		return this.s.enabled;
	},


	enable: function ( flag )
	{
		var that = this;

		if ( flag === false ) {
			return this.disable();
		}

		this.s.enabled = true;

		this._focusListener();

		this.dom.handle.on( 'mousedown', function (e) {
			that._mousedown( e );
			return false;
		} );

		return this;
	},

	disable: function ()
	{
		this.s.enabled = false;

		this._focusListenerRemove();

		return this;
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */

	/**
	 * Initialise the RowReorder instance
	 *
	 * @private
	 */
	_constructor: function ()
	{
		var that = this;
		var dt = this.s.dt;
		var dtScroll = $('div.dataTables_scrollBody', this.s.dt.table().container());

		// Make the instance accessible to the API
		dt.settings()[0].autoFill = this;

		if ( dtScroll.length ) {
			this.dom.dtScroll = dtScroll;

			// Need to scroll container to be the offset parent
			if ( dtScroll.css('position') === 'static' ) {
				dtScroll.css( 'position', 'relative' );
			}
		}

		if ( this.c.enable !== false ) {
			this.enable();
		}

		dt.on( 'destroy.autoFill', function () {
			that._focusListenerRemove();
		} );
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */

	/**
	 * Display the AutoFill drag handle by appending it to a table cell. This
	 * is the opposite of the _detach method.
	 *
	 * @param  {node} node TD/TH cell to insert the handle into
	 * @private
	 */
	_attach: function ( node )
	{
		var dt = this.s.dt;
		var idx = dt.cell( node ).index();
		var handle = this.dom.handle;
		var handleDim = this.s.handle;

		if ( ! idx || dt.columns( this.c.columns ).indexes().indexOf( idx.column ) === -1 ) {
			this._detach();
			return;
		}

		if ( ! this.dom.offsetParent ) {
			// We attach to the table's offset parent
			this.dom.offsetParent = $( dt.table().node() ).offsetParent();
		}

		if ( ! handleDim.height || ! handleDim.width ) {
			// Append to document so we can get its size. Not expecting it to
			// change during the life time of the page
			handle.appendTo( 'body' );
			handleDim.height = handle.outerHeight();
			handleDim.width = handle.outerWidth();
		}

		// Might need to go through multiple offset parents
		var offset = this._getPosition( node, this.dom.offsetParent );

		this.dom.attachedTo = node;
		handle
			.css( {
				top: offset.top + node.offsetHeight - handleDim.height,
				left: offset.left + node.offsetWidth - handleDim.width
			} )
			.appendTo( this.dom.offsetParent );
	},


	/**
	 * Determine can the fill type should be. This can be automatic, or ask the
	 * end user.
	 *
	 * @param {array} cells Information about the selected cells from the key
	 *     up function
	 * @private
	 */
	_actionSelector: function ( cells )
	{
		var that = this;
		var dt = this.s.dt;
		var actions = AutoFill.actions;
		var available = [];

		// "Ask" each plug-in if it wants to handle this data
		$.each( actions, function ( key, action ) {
			if ( action.available( dt, cells ) ) {
				available.push( key );
			}
		} );

		if ( available.length === 1 && this.c.alwaysAsk === false ) {
			// Only one action available - enact it immediately
			var result = actions[ available[0] ].execute( dt, cells );
			this._update( result, cells );
		}
		else {
			// Multiple actions available - ask the end user what they want to do
			var list = this.dom.list.children('ul').empty();

			// Add a cancel option
			available.push( 'cancel' );

			$.each( available, function ( i, name ) {
				list.append( $('<li/>')
					.append(
						'<div class="dt-autofill-question">'+
							actions[ name ].option( dt, cells )+
						'<div>'
					)
					.append( $('<div class="dt-autofill-button">' )
						.append( $('<button class="'+AutoFill.classes.btn+'">'+dt.i18n('autoFill.button', '&gt;')+'</button>')
							.on( 'click', function () {
								var result = actions[ name ].execute(
									dt, cells, $(this).closest('li')
								);
								that._update( result, cells );

								that.dom.background.remove();
								that.dom.list.remove();
							} )
						)
					)
				);
			} );

			this.dom.background.appendTo( 'body' );
			this.dom.list.appendTo( 'body' );

			this.dom.list.css( 'margin-top', this.dom.list.outerHeight()/2 * -1 );
		}
	},


	/**
	 * Remove the AutoFill handle from the document
	 *
	 * @private
	 */
	_detach: function ()
	{
		this.dom.attachedTo = null;
		this.dom.handle.detach();
	},


	/**
	 * Draw the selection outline by calculating the range between the start
	 * and end cells, then placing the highlighting elements to draw a rectangle
	 *
	 * @param  {node}   target End cell
	 * @param  {object} e      Originating event
	 * @private
	 */
	_drawSelection: function ( target, e )
	{
		// Calculate boundary for start cell to this one
		var dt = this.s.dt;
		var start = this.s.start;
		var startCell = $(this.dom.start);
		var end = {
			row: this.c.vertical ?
				dt.rows( { page: 'current' } ).nodes().indexOf( target.parentNode ) :
				start.row,
			column: this.c.horizontal ?
				$(target).index() :
				start.column
		};
		var colIndx = dt.column.index( 'toData', end.column );
		var endRow =  dt.row( ':eq('+end.row+')', { page: 'current' } ); // Workaround for M581
		var endCell = $( dt.cell( endRow.index(), colIndx ).node() );

		// Be sure that is a DataTables controlled cell
		if ( ! dt.cell( endCell ).any() ) {
			return;
		}

		// if target is not in the columns available - do nothing
		if ( dt.columns( this.c.columns ).indexes().indexOf( colIndx ) === -1 ) {
			return;
		}

		this.s.end = end;

		var top, bottom, left, right, height, width;

		top    = start.row    < end.row    ? startCell : endCell;
		bottom = start.row    < end.row    ? endCell   : startCell;
		left   = start.column < end.column ? startCell : endCell;
		right  = start.column < end.column ? endCell   : startCell;

		top    = this._getPosition( top.get(0) ).top;
		left   = this._getPosition( left.get(0) ).left;
		height = this._getPosition( bottom.get(0) ).top + bottom.outerHeight() - top;
		width  = this._getPosition( right.get(0) ).left + right.outerWidth() - left;

		var select = this.dom.select;
		select.top.css( {
			top: top,
			left: left,
			width: width
		} );

		select.left.css( {
			top: top,
			left: left,
			height: height
		} );

		select.bottom.css( {
			top: top + height,
			left: left,
			width: width
		} );

		select.right.css( {
			top: top,
			left: left + width,
			height: height
		} );
	},


	/**
	 * Use the Editor API to perform an update based on the new data for the
	 * cells
	 *
	 * @param {array} cells Information about the selected cells from the key
	 *     up function
	 * @private
	 */
	_editor: function ( cells )
	{
		var dt = this.s.dt;
		var editor = this.c.editor;

		if ( ! editor ) {
			return;
		}

		// Build the object structure for Editor's multi-row editing
		var idValues = {};
		var nodes = [];
		var fields = editor.fields();

		for ( var i=0, ien=cells.length ; i<ien ; i++ ) {
			for ( var j=0, jen=cells[i].length ; j<jen ; j++ ) {
				var cell = cells[i][j];

				// Determine the field name for the cell being edited
				var col = dt.settings()[0].aoColumns[ cell.index.column ];
				var fieldName = col.editField;

				if ( fieldName === undefined ) {
					var dataSrc = col.mData;

					// dataSrc is the `field.data` property, but we need to set
					// using the field name, so we need to translate from the
					// data to the name
					for ( var k=0, ken=fields.length ; k<ken ; k++ ) {
						var field = editor.field( fields[k] );

						if ( field.dataSrc() === dataSrc ) {
							fieldName = field.name();
							break;
						}
					}
				}

				if ( ! fieldName ) {
					throw 'Could not automatically determine field data. '+
						'Please see https://datatables.net/tn/11';
				}

				if ( ! idValues[ fieldName ] ) {
					idValues[ fieldName ] = {};
				}

				var id = dt.row( cell.index.row ).id();
				idValues[ fieldName ][ id ] = cell.set;

				// Keep a list of cells so we can activate the bubble editing
				// with them
				nodes.push( cell.index );
			}
		}

		// Perform the edit using bubble editing as it allows us to specify
		// the cells to be edited, rather than using full rows
		editor
			.bubble( nodes, false )
			.multiSet( idValues )
			.submit();
	},


	/**
	 * Emit an event on the DataTable for listeners
	 *
	 * @param  {string} name Event name
	 * @param  {array} args Event arguments
	 * @private
	 */
	_emitEvent: function ( name, args )
	{
		this.s.dt.iterator( 'table', function ( ctx, i ) {
			$(ctx.nTable).triggerHandler( name+'.dt', args );
		} );
	},


	/**
	 * Attach suitable listeners (based on the configuration) that will attach
	 * and detach the AutoFill handle in the document.
	 *
	 * @private
	 */
	_focusListener: function ()
	{
		var that = this;
		var dt = this.s.dt;
		var namespace = this.s.namespace;
		var focus = this.c.focus !== null ?
			this.c.focus :
			dt.init().keys || dt.settings()[0].keytable ?
				'focus' :
				'hover';

		// All event listeners attached here are removed in the `destroy`
		// callback in the constructor
		if ( focus === 'focus' ) {
			dt
				.on( 'key-focus.autoFill', function ( e, dt, cell ) {
					that._attach( cell.node() );
				} )
				.on( 'key-blur.autoFill', function ( e, dt, cell ) {
					that._detach();
				} );
		}
		else if ( focus === 'click' ) {
			$(dt.table().body()).on( 'click'+namespace, 'td, th', function (e) {
				that._attach( this );
			} );

			$(document.body).on( 'click'+namespace, function (e) {
				if ( ! $(e.target).parents().filter( dt.table().body() ).length ) {
					that._detach();
				}
			} );
		}
		else {
			$(dt.table().body())
				.on( 'mouseenter'+namespace, 'td, th', function (e) {
					that._attach( this );
				} )
				.on( 'mouseleave'+namespace, function (e) {
					if ( $(e.relatedTarget).hasClass('dt-autofill-handle') ) {
						return;
					}

					that._detach();
				} );
		}
	},


	_focusListenerRemove: function ()
	{
		var dt = this.s.dt;

		dt.off( '.autoFill' );
		$(dt.table().body()).off( this.s.namespace );
		$(document.body).off( this.s.namespace );
	},


	/**
	 * Get the position of a node, relative to another, including any scrolling
	 * offsets.
	 * @param  {Node}   node         Node to get the position of
	 * @param  {jQuery} targetParent Node to use as the parent
	 * @return {object}              Offset calculation
	 * @private
	 */
	_getPosition: function ( node, targetParent )
	{
		var
			currNode = node,
			currOffsetParent,
			top = 0,
			left = 0;

		if ( ! targetParent ) {
			targetParent = $( $( this.s.dt.table().node() )[0].offsetParent );
		}

		do {
			// Don't use jQuery().position() the behaviour changes between 1.x and 3.x for
			// tables
			var positionTop = currNode.offsetTop;
			var positionLeft = currNode.offsetLeft;

			// jQuery doesn't give a `table` as the offset parent oddly, so use DOM directly
			currOffsetParent = $( currNode.offsetParent );

			top += positionTop + currOffsetParent.scrollTop();
			left += positionLeft + currOffsetParent.scrollLeft();

			top += parseInt( currOffsetParent.css('margin-top') ) * 1;
			top += parseInt( currOffsetParent.css('border-top-width') ) * 1;

			// Emergency fall back. Shouldn't happen, but just in case!
			if ( currNode.nodeName.toLowerCase() === 'body' ) {
				break;
			}

			currNode = currOffsetParent.get(0); // for next loop
		}
		while ( currOffsetParent.get(0) !== targetParent.get(0) )

		return {
			top: top,
			left: left
		};
	},


	/**
	 * Start mouse drag - selects the start cell
	 *
	 * @param  {object} e Mouse down event
	 * @private
	 */
	_mousedown: function ( e )
	{
		var that = this;
		var dt = this.s.dt;

		this.dom.start = this.dom.attachedTo;
		this.s.start = {
			row: dt.rows( { page: 'current' } ).nodes().indexOf( $(this.dom.start).parent()[0] ),
			column: $(this.dom.start).index()
		};

		$(document.body)
			.on( 'mousemove.autoFill', function (e) {
				that._mousemove( e );
			} )
			.on( 'mouseup.autoFill', function (e) {
				that._mouseup( e );
			} );

		var select = this.dom.select;
		var offsetParent = $( dt.table().node() ).offsetParent();
		select.top.appendTo( offsetParent );
		select.left.appendTo( offsetParent );
		select.right.appendTo( offsetParent );
		select.bottom.appendTo( offsetParent );

		this._drawSelection( this.dom.start, e );

		this.dom.handle.css( 'display', 'none' );

		// Cache scrolling information so mouse move doesn't need to read.
		// This assumes that the window and DT scroller will not change size
		// during an AutoFill drag, which I think is a fair assumption
		var scrollWrapper = this.dom.dtScroll;
		this.s.scroll = {
			windowHeight: $(window).height(),
			windowWidth:  $(window).width(),
			dtTop:        scrollWrapper ? scrollWrapper.offset().top : null,
			dtLeft:       scrollWrapper ? scrollWrapper.offset().left : null,
			dtHeight:     scrollWrapper ? scrollWrapper.outerHeight() : null,
			dtWidth:      scrollWrapper ? scrollWrapper.outerWidth() : null
		};
	},


	/**
	 * Mouse drag - selects the end cell and update the selection display for
	 * the end user
	 *
	 * @param  {object} e Mouse move event
	 * @private
	 */
	_mousemove: function ( e )
	{	
		var that = this;
		var dt = this.s.dt;
		var name = e.target.nodeName.toLowerCase();
		if ( name !== 'td' && name !== 'th' ) {
			return;
		}

		this._drawSelection( e.target, e );
		this._shiftScroll( e );
	},


	/**
	 * End mouse drag - perform the update actions
	 *
	 * @param  {object} e Mouse up event
	 * @private
	 */
	_mouseup: function ( e )
	{
		$(document.body).off( '.autoFill' );

		var that = this;
		var dt = this.s.dt;
		var select = this.dom.select;
		select.top.remove();
		select.left.remove();
		select.right.remove();
		select.bottom.remove();

		this.dom.handle.css( 'display', 'block' );

		// Display complete - now do something useful with the selection!
		var start = this.s.start;
		var end = this.s.end;

		// Haven't selected multiple cells, so nothing to do
		if ( start.row === end.row && start.column === end.column ) {
			return;
		}

		var startDt = dt.cell( ':eq('+start.row+')', start.column+':visible', {page:'current'} );

		// If Editor is active inside this cell (inline editing) we need to wait for Editor to
		// submit and then we can loop back and trigger the fill.
		if ( $('div.DTE', startDt.node()).length ) {
			var editor = dt.editor();

			editor
				.on( 'submitSuccess.dtaf close.dtaf', function () {
					editor.off( '.dtaf');

					setTimeout( function () {
						that._mouseup( e );
					}, 100 );
				} )
				.on( 'submitComplete.dtaf preSubmitCancelled.dtaf close.dtaf', function () {
					editor.off( '.dtaf');
				} );

			// Make the current input submit
			editor.submit();

			return;
		}

		// Build a matrix representation of the selected rows
		var rows       = this._range( start.row, end.row );
		var columns    = this._range( start.column, end.column );
		var selected   = [];
		var dtSettings = dt.settings()[0];
		var dtColumns  = dtSettings.aoColumns;

		// Can't use Array.prototype.map as IE8 doesn't support it
		// Can't use $.map as jQuery flattens 2D arrays
		// Need to use a good old fashioned for loop
		for ( var rowIdx=0 ; rowIdx<rows.length ; rowIdx++ ) {
			selected.push(
				$.map( columns, function (column) {
					var row = dt.row( ':eq('+rows[rowIdx]+')', {page:'current'} ); // Workaround for M581
					var cell = dt.cell( row.index(), column+':visible' );
					var data = cell.data();
					var cellIndex = cell.index();
					var editField = dtColumns[ cellIndex.column ].editField;

					if ( editField !== undefined ) {
						data = dtSettings.oApi._fnGetObjectDataFn( editField )( dt.row( cellIndex.row ).data() );
					}

					return {
						cell:  cell,
						data:  data,
						label: cell.data(),
						index: cellIndex
					};
				} )
			);
		}

		this._actionSelector( selected );
		
		// Stop shiftScroll
		clearInterval( this.s.scrollInterval );
		this.s.scrollInterval = null;
	},


	/**
	 * Create an array with a range of numbers defined by the start and end
	 * parameters passed in (inclusive!).
	 * 
	 * @param  {integer} start Start
	 * @param  {integer} end   End
	 * @private
	 */
	_range: function ( start, end )
	{
		var out = [];
		var i;

		if ( start <= end ) {
			for ( i=start ; i<=end ; i++ ) {
				out.push( i );
			}
		}
		else {
			for ( i=start ; i>=end ; i-- ) {
				out.push( i );
			}
		}

		return out;
	},


	/**
	 * Move the window and DataTables scrolling during a drag to scroll new
	 * content into view. This is done by proximity to the edge of the scrolling
	 * container of the mouse - for example near the top edge of the window
	 * should scroll up. This is a little complicated as there are two elements
	 * that can be scrolled - the window and the DataTables scrolling view port
	 * (if scrollX and / or scrollY is enabled).
	 *
	 * @param  {object} e Mouse move event object
	 * @private
	 */
	_shiftScroll: function ( e )
	{
		var that = this;
		var dt = this.s.dt;
		var scroll = this.s.scroll;
		var runInterval = false;
		var scrollSpeed = 5;
		var buffer = 65;
		var
			windowY = e.pageY - document.body.scrollTop,
			windowX = e.pageX - document.body.scrollLeft,
			windowVert, windowHoriz,
			dtVert, dtHoriz;

		// Window calculations - based on the mouse position in the window,
		// regardless of scrolling
		if ( windowY < buffer ) {
			windowVert = scrollSpeed * -1;
		}
		else if ( windowY > scroll.windowHeight - buffer ) {
			windowVert = scrollSpeed;
		}

		if ( windowX < buffer ) {
			windowHoriz = scrollSpeed * -1;
		}
		else if ( windowX > scroll.windowWidth - buffer ) {
			windowHoriz = scrollSpeed;
		}

		// DataTables scrolling calculations - based on the table's position in
		// the document and the mouse position on the page
		if ( scroll.dtTop !== null && e.pageY < scroll.dtTop + buffer ) {
			dtVert = scrollSpeed * -1;
		}
		else if ( scroll.dtTop !== null && e.pageY > scroll.dtTop + scroll.dtHeight - buffer ) {
			dtVert = scrollSpeed;
		}

		if ( scroll.dtLeft !== null && e.pageX < scroll.dtLeft + buffer ) {
			dtHoriz = scrollSpeed * -1;
		}
		else if ( scroll.dtLeft !== null && e.pageX > scroll.dtLeft + scroll.dtWidth - buffer ) {
			dtHoriz = scrollSpeed;
		}

		// This is where it gets interesting. We want to continue scrolling
		// without requiring a mouse move, so we need an interval to be
		// triggered. The interval should continue until it is no longer needed,
		// but it must also use the latest scroll commands (for example consider
		// that the mouse might move from scrolling up to scrolling left, all
		// with the same interval running. We use the `scroll` object to "pass"
		// this information to the interval. Can't use local variables as they
		// wouldn't be the ones that are used by an already existing interval!
		if ( windowVert || windowHoriz || dtVert || dtHoriz ) {
			scroll.windowVert = windowVert;
			scroll.windowHoriz = windowHoriz;
			scroll.dtVert = dtVert;
			scroll.dtHoriz = dtHoriz;
			runInterval = true;
		}
		else if ( this.s.scrollInterval ) {
			// Don't need to scroll - remove any existing timer
			clearInterval( this.s.scrollInterval );
			this.s.scrollInterval = null;
		}

		// If we need to run the interval to scroll and there is no existing
		// interval (if there is an existing one, it will continue to run)
		if ( ! this.s.scrollInterval && runInterval ) {
			this.s.scrollInterval = setInterval( function () {
				// Don't need to worry about setting scroll <0 or beyond the
				// scroll bound as the browser will just reject that.
				if ( scroll.windowVert ) {
					document.body.scrollTop += scroll.windowVert;
				}
				if ( scroll.windowHoriz ) {
					document.body.scrollLeft += scroll.windowHoriz;
				}

				// DataTables scrolling
				if ( scroll.dtVert || scroll.dtHoriz ) {
					var scroller = that.dom.dtScroll[0];

					if ( scroll.dtVert ) {
						scroller.scrollTop += scroll.dtVert;
					}
					if ( scroll.dtHoriz ) {
						scroller.scrollLeft += scroll.dtHoriz;
					}
				}
			}, 20 );
		}
	},


	/**
	 * Update the DataTable after the user has selected what they want to do
	 *
	 * @param  {false|undefined} result Return from the `execute` method - can
	 *   be false internally to do nothing. This is not documented for plug-ins
	 *   and is used only by the cancel option.
	 * @param {array} cells Information about the selected cells from the key
	 *     up function, argumented with the set values
	 * @private
	 */
	_update: function ( result, cells )
	{
		// Do nothing on `false` return from an execute function
		if ( result === false ) {
			return;
		}

		var dt = this.s.dt;
		var cell;
		var columns = dt.columns( this.c.columns ).indexes();

		// Potentially allow modifications to the cells matrix
		this._emitEvent( 'preAutoFill', [ dt, cells ] );

		this._editor( cells );

		// Automatic updates are not performed if `update` is null and the
		// `editor` parameter is passed in - the reason being that Editor will
		// update the data once submitted
		var update = this.c.update !== null ?
			this.c.update :
			this.c.editor ?
				false :
				true;

		if ( update ) {
			for ( var i=0, ien=cells.length ; i<ien ; i++ ) {
				for ( var j=0, jen=cells[i].length ; j<jen ; j++ ) {
					cell = cells[i][j];

					if ( columns.indexOf(cell.index.column) !== -1 ) {
						cell.cell.data( cell.set );
					}
				}
			}

			dt.draw(false);
		}

		this._emitEvent( 'autoFill', [ dt, cells ] );
	}
} );


/**
 * AutoFill actions. The options here determine how AutoFill will fill the data
 * in the table when the user has selected a range of cells. Please see the
 * documentation on the DataTables site for full details on how to create plug-
 * ins.
 *
 * @type {Object}
 */
AutoFill.actions = {
	increment: {
		available: function ( dt, cells ) {
			var d = cells[0][0].label;

			// is numeric test based on jQuery's old `isNumeric` function
			return !isNaN( d - parseFloat( d ) );
		},

		option: function ( dt, cells ) {
			return dt.i18n(
				'autoFill.increment',
				'Increment / decrement each cell by: <input type="number" value="1">'
			);
		},

		execute: function ( dt, cells, node ) {
			var value = cells[0][0].data * 1;
			var increment = $('input', node).val() * 1;

			for ( var i=0, ien=cells.length ; i<ien ; i++ ) {
				for ( var j=0, jen=cells[i].length ; j<jen ; j++ ) {
					cells[i][j].set = value;

					value += increment;
				}
			}
		}
	},

	fill: {
		available: function ( dt, cells ) {
			return true;
		},

		option: function ( dt, cells ) {
			return dt.i18n('autoFill.fill', 'Fill all cells with <i>'+cells[0][0].label+'</i>' );
		},

		execute: function ( dt, cells, node ) {
			var value = cells[0][0].data;

			for ( var i=0, ien=cells.length ; i<ien ; i++ ) {
				for ( var j=0, jen=cells[i].length ; j<jen ; j++ ) {
					cells[i][j].set = value;
				}
			}
		}
	},

	fillHorizontal: {
		available: function ( dt, cells ) {
			return cells.length > 1 && cells[0].length > 1;
		},

		option: function ( dt, cells ) {
			return dt.i18n('autoFill.fillHorizontal', 'Fill cells horizontally' );
		},

		execute: function ( dt, cells, node ) {
			for ( var i=0, ien=cells.length ; i<ien ; i++ ) {
				for ( var j=0, jen=cells[i].length ; j<jen ; j++ ) {
					cells[i][j].set = cells[i][0].data;
				}
			}
		}
	},

	fillVertical: {
		available: function ( dt, cells ) {
			return cells.length > 1 && cells[0].length > 1;
		},

		option: function ( dt, cells ) {
			return dt.i18n('autoFill.fillVertical', 'Fill cells vertically' );
		},

		execute: function ( dt, cells, node ) {
			for ( var i=0, ien=cells.length ; i<ien ; i++ ) {
				for ( var j=0, jen=cells[i].length ; j<jen ; j++ ) {
					cells[i][j].set = cells[0][j].data;
				}
			}
		}
	},

	// Special type that does not make itself available, but is added
	// automatically by AutoFill if a multi-choice list is shown. This allows
	// sensible code reuse
	cancel: {
		available: function () {
			return false;
		},

		option: function ( dt ) {
			return dt.i18n('autoFill.cancel', 'Cancel' );
		},

		execute: function () {
			return false;
		}
	}
};


/**
 * AutoFill version
 * 
 * @static
 * @type      String
 */
AutoFill.version = '2.3.3';


/**
 * AutoFill defaults
 * 
 * @namespace
 */
AutoFill.defaults = {
	/** @type {Boolean} Ask user what they want to do, even for a single option */
	alwaysAsk: false,

	/** @type {string|null} What will trigger a focus */
	focus: null, // focus, click, hover

	/** @type {column-selector} Columns to provide auto fill for */
	columns: '', // all

	/** @type {Boolean} Enable AutoFill on load */
	enable: true,

	/** @type {boolean|null} Update the cells after a drag */
	update: null, // false is editor given, true otherwise

	/** @type {DataTable.Editor} Editor instance for automatic submission */
	editor: null,

	/** @type {boolean} Enable vertical fill */
	vertical: true,

	/** @type {boolean} Enable horizontal fill */
	horizontal: true
};


/**
 * Classes used by AutoFill that are configurable
 * 
 * @namespace
 */
AutoFill.classes = {
	/** @type {String} Class used by the selection button */
	btn: 'btn'
};


/*
 * API
 */
var Api = $.fn.dataTable.Api;

// Doesn't do anything - Not documented
Api.register( 'autoFill()', function () {
	return this;
} );

Api.register( 'autoFill().enabled()', function () {
	var ctx = this.context[0];

	return ctx.autoFill ?
		ctx.autoFill.enabled() :
		false;
} );

Api.register( 'autoFill().enable()', function ( flag ) {
	return this.iterator( 'table', function ( ctx ) {
		if ( ctx.autoFill ) {
			ctx.autoFill.enable( flag );
		}
	} );
} );

Api.register( 'autoFill().disable()', function () {
	return this.iterator( 'table', function ( ctx ) {
		if ( ctx.autoFill ) {
			ctx.autoFill.disable();
		}
	} );
} );


// Attach a listener to the document which listens for DataTables initialisation
// events so we can automatically initialise
$(document).on( 'preInit.dt.autofill', function (e, settings, json) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	var init = settings.oInit.autoFill;
	var defaults = DataTable.defaults.autoFill;

	if ( init || defaults ) {
		var opts = $.extend( {}, init, defaults );

		if ( init !== false ) {
			new AutoFill( settings, opts  );
		}
	}
} );


// Alias for access
DataTable.AutoFill = AutoFill;
DataTable.AutoFill = AutoFill;


return AutoFill;
}));


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Buttons for DataTables 1.5.6
 * ©2016-2019 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


// Used for namespacing events added to the document by each instance, so they
// can be removed on destroy
var _instCounter = 0;

// Button namespacing counter for namespacing events on individual buttons
var _buttonCounter = 0;

var _dtButtons = DataTable.ext.buttons;

/**
 * [Buttons description]
 * @param {[type]}
 * @param {[type]}
 */
var Buttons = function( dt, config )
{
	// If not created with a `new` keyword then we return a wrapper function that
	// will take the settings object for a DT. This allows easy use of new instances
	// with the `layout` option - e.g. `topLeft: $.fn.dataTable.Buttons( ... )`.
	if ( !(this instanceof Buttons) ) {
		return function (settings) {
			return new Buttons( settings, dt ).container();
		};
	}

	// If there is no config set it to an empty object
	if ( typeof( config ) === 'undefined' ) {
		config = {};	
	}
	
	// Allow a boolean true for defaults
	if ( config === true ) {
		config = {};
	}

	// For easy configuration of buttons an array can be given
	if ( $.isArray( config ) ) {
		config = { buttons: config };
	}

	this.c = $.extend( true, {}, Buttons.defaults, config );

	// Don't want a deep copy for the buttons
	if ( config.buttons ) {
		this.c.buttons = config.buttons;
	}

	this.s = {
		dt: new DataTable.Api( dt ),
		buttons: [],
		listenKeys: '',
		namespace: 'dtb'+(_instCounter++)
	};

	this.dom = {
		container: $('<'+this.c.dom.container.tag+'/>')
			.addClass( this.c.dom.container.className )
	};

	this._constructor();
};


$.extend( Buttons.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Public methods
	 */

	/**
	 * Get the action of a button
	 * @param  {int|string} Button index
	 * @return {function}
	 *//**
	 * Set the action of a button
	 * @param  {node} node Button element
	 * @param  {function} action Function to set
	 * @return {Buttons} Self for chaining
	 */
	action: function ( node, action )
	{
		var button = this._nodeToButton( node );

		if ( action === undefined ) {
			return button.conf.action;
		}

		button.conf.action = action;

		return this;
	},

	/**
	 * Add an active class to the button to make to look active or get current
	 * active state.
	 * @param  {node} node Button element
	 * @param  {boolean} [flag] Enable / disable flag
	 * @return {Buttons} Self for chaining or boolean for getter
	 */
	active: function ( node, flag ) {
		var button = this._nodeToButton( node );
		var klass = this.c.dom.button.active;
		var jqNode = $(button.node);

		if ( flag === undefined ) {
			return jqNode.hasClass( klass );
		}

		jqNode.toggleClass( klass, flag === undefined ? true : flag );

		return this;
	},

	/**
	 * Add a new button
	 * @param {object} config Button configuration object, base string name or function
	 * @param {int|string} [idx] Button index for where to insert the button
	 * @return {Buttons} Self for chaining
	 */
	add: function ( config, idx )
	{
		var buttons = this.s.buttons;

		if ( typeof idx === 'string' ) {
			var split = idx.split('-');
			var base = this.s;

			for ( var i=0, ien=split.length-1 ; i<ien ; i++ ) {
				base = base.buttons[ split[i]*1 ];
			}

			buttons = base.buttons;
			idx = split[ split.length-1 ]*1;
		}

		this._expandButton( buttons, config, false, idx );
		this._draw();

		return this;
	},

	/**
	 * Get the container node for the buttons
	 * @return {jQuery} Buttons node
	 */
	container: function ()
	{
		return this.dom.container;
	},

	/**
	 * Disable a button
	 * @param  {node} node Button node
	 * @return {Buttons} Self for chaining
	 */
	disable: function ( node ) {
		var button = this._nodeToButton( node );

		$(button.node).addClass( this.c.dom.button.disabled );

		return this;
	},

	/**
	 * Destroy the instance, cleaning up event handlers and removing DOM
	 * elements
	 * @return {Buttons} Self for chaining
	 */
	destroy: function ()
	{
		// Key event listener
		$('body').off( 'keyup.'+this.s.namespace );

		// Individual button destroy (so they can remove their own events if
		// needed). Take a copy as the array is modified by `remove`
		var buttons = this.s.buttons.slice();
		var i, ien;
		
		for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
			this.remove( buttons[i].node );
		}

		// Container
		this.dom.container.remove();

		// Remove from the settings object collection
		var buttonInsts = this.s.dt.settings()[0];

		for ( i=0, ien=buttonInsts.length ; i<ien ; i++ ) {
			if ( buttonInsts.inst === this ) {
				buttonInsts.splice( i, 1 );
				break;
			}
		}

		return this;
	},

	/**
	 * Enable / disable a button
	 * @param  {node} node Button node
	 * @param  {boolean} [flag=true] Enable / disable flag
	 * @return {Buttons} Self for chaining
	 */
	enable: function ( node, flag )
	{
		if ( flag === false ) {
			return this.disable( node );
		}

		var button = this._nodeToButton( node );
		$(button.node).removeClass( this.c.dom.button.disabled );

		return this;
	},

	/**
	 * Get the instance name for the button set selector
	 * @return {string} Instance name
	 */
	name: function ()
	{
		return this.c.name;
	},

	/**
	 * Get a button's node of the buttons container if no button is given
	 * @param  {node} [node] Button node
	 * @return {jQuery} Button element, or container
	 */
	node: function ( node )
	{
		if ( ! node ) {
			return this.dom.container;
		}

		var button = this._nodeToButton( node );
		return $(button.node);
	},

	/**
	 * Set / get a processing class on the selected button
	 * @param  {boolean} flag true to add, false to remove, undefined to get
	 * @return {boolean|Buttons} Getter value or this if a setter.
	 */
	processing: function ( node, flag )
	{
		var button = this._nodeToButton( node );

		if ( flag === undefined ) {
			return $(button.node).hasClass( 'processing' );
		}

		$(button.node).toggleClass( 'processing', flag );

		return this;
	},

	/**
	 * Remove a button.
	 * @param  {node} node Button node
	 * @return {Buttons} Self for chaining
	 */
	remove: function ( node )
	{
		var button = this._nodeToButton( node );
		var host = this._nodeToHost( node );
		var dt = this.s.dt;

		// Remove any child buttons first
		if ( button.buttons.length ) {
			for ( var i=button.buttons.length-1 ; i>=0 ; i-- ) {
				this.remove( button.buttons[i].node );
			}
		}

		// Allow the button to remove event handlers, etc
		if ( button.conf.destroy ) {
			button.conf.destroy.call( dt.button(node), dt, $(node), button.conf );
		}

		this._removeKey( button.conf );

		$(button.node).remove();

		var idx = $.inArray( button, host );
		host.splice( idx, 1 );

		return this;
	},

	/**
	 * Get the text for a button
	 * @param  {int|string} node Button index
	 * @return {string} Button text
	 *//**
	 * Set the text for a button
	 * @param  {int|string|function} node Button index
	 * @param  {string} label Text
	 * @return {Buttons} Self for chaining
	 */
	text: function ( node, label )
	{
		var button = this._nodeToButton( node );
		var buttonLiner = this.c.dom.collection.buttonLiner;
		var linerTag = button.inCollection && buttonLiner && buttonLiner.tag ?
			buttonLiner.tag :
			this.c.dom.buttonLiner.tag;
		var dt = this.s.dt;
		var jqNode = $(button.node);
		var text = function ( opt ) {
			return typeof opt === 'function' ?
				opt( dt, jqNode, button.conf ) :
				opt;
		};

		if ( label === undefined ) {
			return text( button.conf.text );
		}

		button.conf.text = label;

		if ( linerTag ) {
			jqNode.children( linerTag ).html( text(label) );
		}
		else {
			jqNode.html( text(label) );
		}

		return this;
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */

	/**
	 * Buttons constructor
	 * @private
	 */
	_constructor: function ()
	{
		var that = this;
		var dt = this.s.dt;
		var dtSettings = dt.settings()[0];
		var buttons =  this.c.buttons;

		if ( ! dtSettings._buttons ) {
			dtSettings._buttons = [];
		}

		dtSettings._buttons.push( {
			inst: this,
			name: this.c.name
		} );

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			this.add( buttons[i] );
		}

		dt.on( 'destroy', function ( e, settings ) {
			if ( settings === dtSettings ) {
				that.destroy();
			}
		} );

		// Global key event binding to listen for button keys
		$('body').on( 'keyup.'+this.s.namespace, function ( e ) {
			if ( ! document.activeElement || document.activeElement === document.body ) {
				// SUse a string of characters for fast lookup of if we need to
				// handle this
				var character = String.fromCharCode(e.keyCode).toLowerCase();

				if ( that.s.listenKeys.toLowerCase().indexOf( character ) !== -1 ) {
					that._keypress( character, e );
				}
			}
		} );
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */

	/**
	 * Add a new button to the key press listener
	 * @param {object} conf Resolved button configuration object
	 * @private
	 */
	_addKey: function ( conf )
	{
		if ( conf.key ) {
			this.s.listenKeys += $.isPlainObject( conf.key ) ?
				conf.key.key :
				conf.key;
		}
	},

	/**
	 * Insert the buttons into the container. Call without parameters!
	 * @param  {node} [container] Recursive only - Insert point
	 * @param  {array} [buttons] Recursive only - Buttons array
	 * @private
	 */
	_draw: function ( container, buttons )
	{
		if ( ! container ) {
			container = this.dom.container;
			buttons = this.s.buttons;
		}

		container.children().detach();

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			container.append( buttons[i].inserter );
			container.append( ' ' );

			if ( buttons[i].buttons && buttons[i].buttons.length ) {
				this._draw( buttons[i].collection, buttons[i].buttons );
			}
		}
	},

	/**
	 * Create buttons from an array of buttons
	 * @param  {array} attachTo Buttons array to attach to
	 * @param  {object} button Button definition
	 * @param  {boolean} inCollection true if the button is in a collection
	 * @private
	 */
	_expandButton: function ( attachTo, button, inCollection, attachPoint )
	{
		var dt = this.s.dt;
		var buttonCounter = 0;
		var buttons = ! $.isArray( button ) ?
			[ button ] :
			button;

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			var conf = this._resolveExtends( buttons[i] );

			if ( ! conf ) {
				continue;
			}

			// If the configuration is an array, then expand the buttons at this
			// point
			if ( $.isArray( conf ) ) {
				this._expandButton( attachTo, conf, inCollection, attachPoint );
				continue;
			}

			var built = this._buildButton( conf, inCollection );
			if ( ! built ) {
				continue;
			}

			if ( attachPoint !== undefined ) {
				attachTo.splice( attachPoint, 0, built );
				attachPoint++;
			}
			else {
				attachTo.push( built );
			}

			if ( built.conf.buttons ) {
				var collectionDom = this.c.dom.collection;
				built.collection = $('<'+collectionDom.tag+'/>')
					.addClass( collectionDom.className )
					.attr( 'role', 'menu' ) ;
				built.conf._collection = built.collection;

				this._expandButton( built.buttons, built.conf.buttons, true, attachPoint );
			}

			// init call is made here, rather than buildButton as it needs to
			// be selectable, and for that it needs to be in the buttons array
			if ( conf.init ) {
				conf.init.call( dt.button( built.node ), dt, $(built.node), conf );
			}

			buttonCounter++;
		}
	},

	/**
	 * Create an individual button
	 * @param  {object} config            Resolved button configuration
	 * @param  {boolean} inCollection `true` if a collection button
	 * @return {jQuery} Created button node (jQuery)
	 * @private
	 */
	_buildButton: function ( config, inCollection )
	{
		var buttonDom = this.c.dom.button;
		var linerDom = this.c.dom.buttonLiner;
		var collectionDom = this.c.dom.collection;
		var dt = this.s.dt;
		var text = function ( opt ) {
			return typeof opt === 'function' ?
				opt( dt, button, config ) :
				opt;
		};

		if ( inCollection && collectionDom.button ) {
			buttonDom = collectionDom.button;
		}

		if ( inCollection && collectionDom.buttonLiner ) {
			linerDom = collectionDom.buttonLiner;
		}

		// Make sure that the button is available based on whatever requirements
		// it has. For example, Flash buttons require Flash
		if ( config.available && ! config.available( dt, config ) ) {
			return false;
		}

		var action = function ( e, dt, button, config ) {
			config.action.call( dt.button( button ), e, dt, button, config );

			$(dt.table().node()).triggerHandler( 'buttons-action.dt', [
				dt.button( button ), dt, button, config 
			] );
		};

		var tag = config.tag || buttonDom.tag;
		var clickBlurs = config.clickBlurs === undefined ? true : config.clickBlurs
		var button = $('<'+tag+'/>')
			.addClass( buttonDom.className )
			.attr( 'tabindex', this.s.dt.settings()[0].iTabIndex )
			.attr( 'aria-controls', this.s.dt.table().node().id )
			.on( 'click.dtb', function (e) {
				e.preventDefault();

				if ( ! button.hasClass( buttonDom.disabled ) && config.action ) {
					action( e, dt, button, config );
				}
				if( clickBlurs ) {
					button.blur();
				}
			} )
			.on( 'keyup.dtb', function (e) {
				if ( e.keyCode === 13 ) {
					if ( ! button.hasClass( buttonDom.disabled ) && config.action ) {
						action( e, dt, button, config );
					}
				}
			} );

		// Make `a` tags act like a link
		if ( tag.toLowerCase() === 'a' ) {
			button.attr( 'href', '#' );
		}

		// Button tags should have `type=button` so they don't have any default behaviour
		if ( tag.toLowerCase() === 'button' ) {
			button.attr( 'type', 'button' );
		}

		if ( linerDom.tag ) {
			var liner = $('<'+linerDom.tag+'/>')
				.html( text( config.text ) )
				.addClass( linerDom.className );

			if ( linerDom.tag.toLowerCase() === 'a' ) {
				liner.attr( 'href', '#' );
			}

			button.append( liner );
		}
		else {
			button.html( text( config.text ) );
		}

		if ( config.enabled === false ) {
			button.addClass( buttonDom.disabled );
		}

		if ( config.className ) {
			button.addClass( config.className );
		}

		if ( config.titleAttr ) {
			button.attr( 'title', text( config.titleAttr ) );
		}

		if ( config.attr ) {
			button.attr( config.attr );
		}

		if ( ! config.namespace ) {
			config.namespace = '.dt-button-'+(_buttonCounter++);
		}

		var buttonContainer = this.c.dom.buttonContainer;
		var inserter;
		if ( buttonContainer && buttonContainer.tag ) {
			inserter = $('<'+buttonContainer.tag+'/>')
				.addClass( buttonContainer.className )
				.append( button );
		}
		else {
			inserter = button;
		}

		this._addKey( config );

		// Style integration callback for DOM manipulation
		// Note that this is _not_ documented. It is currently
		// for style integration only
		if( this.c.buttonCreated ) {
			inserter = this.c.buttonCreated( config, inserter );
		}

		return {
			conf:         config,
			node:         button.get(0),
			inserter:     inserter,
			buttons:      [],
			inCollection: inCollection,
			collection:   null
		};
	},

	/**
	 * Get the button object from a node (recursive)
	 * @param  {node} node Button node
	 * @param  {array} [buttons] Button array, uses base if not defined
	 * @return {object} Button object
	 * @private
	 */
	_nodeToButton: function ( node, buttons )
	{
		if ( ! buttons ) {
			buttons = this.s.buttons;
		}

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			if ( buttons[i].node === node ) {
				return buttons[i];
			}

			if ( buttons[i].buttons.length ) {
				var ret = this._nodeToButton( node, buttons[i].buttons );

				if ( ret ) {
					return ret;
				}
			}
		}
	},

	/**
	 * Get container array for a button from a button node (recursive)
	 * @param  {node} node Button node
	 * @param  {array} [buttons] Button array, uses base if not defined
	 * @return {array} Button's host array
	 * @private
	 */
	_nodeToHost: function ( node, buttons )
	{
		if ( ! buttons ) {
			buttons = this.s.buttons;
		}

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			if ( buttons[i].node === node ) {
				return buttons;
			}

			if ( buttons[i].buttons.length ) {
				var ret = this._nodeToHost( node, buttons[i].buttons );

				if ( ret ) {
					return ret;
				}
			}
		}
	},

	/**
	 * Handle a key press - determine if any button's key configured matches
	 * what was typed and trigger the action if so.
	 * @param  {string} character The character pressed
	 * @param  {object} e Key event that triggered this call
	 * @private
	 */
	_keypress: function ( character, e )
	{
		// Check if this button press already activated on another instance of Buttons
		if ( e._buttonsHandled ) {
			return;
		}

		var run = function ( conf, node ) {
			if ( ! conf.key ) {
				return;
			}

			if ( conf.key === character ) {
				e._buttonsHandled = true;
				$(node).click();
			}
			else if ( $.isPlainObject( conf.key ) ) {
				if ( conf.key.key !== character ) {
					return;
				}

				if ( conf.key.shiftKey && ! e.shiftKey ) {
					return;
				}

				if ( conf.key.altKey && ! e.altKey ) {
					return;
				}

				if ( conf.key.ctrlKey && ! e.ctrlKey ) {
					return;
				}

				if ( conf.key.metaKey && ! e.metaKey ) {
					return;
				}

				// Made it this far - it is good
				e._buttonsHandled = true;
				$(node).click();
			}
		};

		var recurse = function ( a ) {
			for ( var i=0, ien=a.length ; i<ien ; i++ ) {
				run( a[i].conf, a[i].node );

				if ( a[i].buttons.length ) {
					recurse( a[i].buttons );
				}
			}
		};

		recurse( this.s.buttons );
	},

	/**
	 * Remove a key from the key listener for this instance (to be used when a
	 * button is removed)
	 * @param  {object} conf Button configuration
	 * @private
	 */
	_removeKey: function ( conf )
	{
		if ( conf.key ) {
			var character = $.isPlainObject( conf.key ) ?
				conf.key.key :
				conf.key;

			// Remove only one character, as multiple buttons could have the
			// same listening key
			var a = this.s.listenKeys.split('');
			var idx = $.inArray( character, a );
			a.splice( idx, 1 );
			this.s.listenKeys = a.join('');
		}
	},

	/**
	 * Resolve a button configuration
	 * @param  {string|function|object} conf Button config to resolve
	 * @return {object} Button configuration
	 * @private
	 */
	_resolveExtends: function ( conf )
	{
		var dt = this.s.dt;
		var i, ien;
		var toConfObject = function ( base ) {
			var loop = 0;

			// Loop until we have resolved to a button configuration, or an
			// array of button configurations (which will be iterated
			// separately)
			while ( ! $.isPlainObject(base) && ! $.isArray(base) ) {
				if ( base === undefined ) {
					return;
				}

				if ( typeof base === 'function' ) {
					base = base( dt, conf );

					if ( ! base ) {
						return false;
					}
				}
				else if ( typeof base === 'string' ) {
					if ( ! _dtButtons[ base ] ) {
						throw 'Unknown button type: '+base;
					}

					base = _dtButtons[ base ];
				}

				loop++;
				if ( loop > 30 ) {
					// Protect against misconfiguration killing the browser
					throw 'Buttons: Too many iterations';
				}
			}

			return $.isArray( base ) ?
				base :
				$.extend( {}, base );
		};

		conf = toConfObject( conf );

		while ( conf && conf.extend ) {
			// Use `toConfObject` in case the button definition being extended
			// is itself a string or a function
			if ( ! _dtButtons[ conf.extend ] ) {
				throw 'Cannot extend unknown button type: '+conf.extend;
			}

			var objArray = toConfObject( _dtButtons[ conf.extend ] );
			if ( $.isArray( objArray ) ) {
				return objArray;
			}
			else if ( ! objArray ) {
				// This is a little brutal as it might be possible to have a
				// valid button without the extend, but if there is no extend
				// then the host button would be acting in an undefined state
				return false;
			}

			// Stash the current class name
			var originalClassName = objArray.className;

			conf = $.extend( {}, objArray, conf );

			// The extend will have overwritten the original class name if the
			// `conf` object also assigned a class, but we want to concatenate
			// them so they are list that is combined from all extended buttons
			if ( originalClassName && conf.className !== originalClassName ) {
				conf.className = originalClassName+' '+conf.className;
			}

			// Buttons to be added to a collection  -gives the ability to define
			// if buttons should be added to the start or end of a collection
			var postfixButtons = conf.postfixButtons;
			if ( postfixButtons ) {
				if ( ! conf.buttons ) {
					conf.buttons = [];
				}

				for ( i=0, ien=postfixButtons.length ; i<ien ; i++ ) {
					conf.buttons.push( postfixButtons[i] );
				}

				conf.postfixButtons = null;
			}

			var prefixButtons = conf.prefixButtons;
			if ( prefixButtons ) {
				if ( ! conf.buttons ) {
					conf.buttons = [];
				}

				for ( i=0, ien=prefixButtons.length ; i<ien ; i++ ) {
					conf.buttons.splice( i, 0, prefixButtons[i] );
				}

				conf.prefixButtons = null;
			}

			// Although we want the `conf` object to overwrite almost all of
			// the properties of the object being extended, the `extend`
			// property should come from the object being extended
			conf.extend = objArray.extend;
		}

		return conf;
	}
} );



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Statics
 */

/**
 * Show / hide a background layer behind a collection
 * @param  {boolean} Flag to indicate if the background should be shown or
 *   hidden 
 * @param  {string} Class to assign to the background
 * @static
 */
Buttons.background = function ( show, className, fade, insertPoint ) {
	if ( fade === undefined ) {
		fade = 400;
	}
	if ( ! insertPoint ) {
		insertPoint = document.body;
	}

	if ( show ) {
		$('<div/>')
			.addClass( className )
			.css( 'display', 'none' )
			.insertAfter( insertPoint )
			.stop()
			.fadeIn( fade );
	}
	else {
		$('div.'+className)
			.stop()
			.fadeOut( fade, function () {
				$(this)
					.removeClass( className )
					.remove();
			} );
	}
};

/**
 * Instance selector - select Buttons instances based on an instance selector
 * value from the buttons assigned to a DataTable. This is only useful if
 * multiple instances are attached to a DataTable.
 * @param  {string|int|array} Instance selector - see `instance-selector`
 *   documentation on the DataTables site
 * @param  {array} Button instance array that was attached to the DataTables
 *   settings object
 * @return {array} Buttons instances
 * @static
 */
Buttons.instanceSelector = function ( group, buttons )
{
	if ( ! group ) {
		return $.map( buttons, function ( v ) {
			return v.inst;
		} );
	}

	var ret = [];
	var names = $.map( buttons, function ( v ) {
		return v.name;
	} );

	// Flatten the group selector into an array of single options
	var process = function ( input ) {
		if ( $.isArray( input ) ) {
			for ( var i=0, ien=input.length ; i<ien ; i++ ) {
				process( input[i] );
			}
			return;
		}

		if ( typeof input === 'string' ) {
			if ( input.indexOf( ',' ) !== -1 ) {
				// String selector, list of names
				process( input.split(',') );
			}
			else {
				// String selector individual name
				var idx = $.inArray( $.trim(input), names );

				if ( idx !== -1 ) {
					ret.push( buttons[ idx ].inst );
				}
			}
		}
		else if ( typeof input === 'number' ) {
			// Index selector
			ret.push( buttons[ input ].inst );
		}
	};
	
	process( group );

	return ret;
};

/**
 * Button selector - select one or more buttons from a selector input so some
 * operation can be performed on them.
 * @param  {array} Button instances array that the selector should operate on
 * @param  {string|int|node|jQuery|array} Button selector - see
 *   `button-selector` documentation on the DataTables site
 * @return {array} Array of objects containing `inst` and `idx` properties of
 *   the selected buttons so you know which instance each button belongs to.
 * @static
 */
Buttons.buttonSelector = function ( insts, selector )
{
	var ret = [];
	var nodeBuilder = function ( a, buttons, baseIdx ) {
		var button;
		var idx;

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			button = buttons[i];

			if ( button ) {
				idx = baseIdx !== undefined ?
					baseIdx+i :
					i+'';

				a.push( {
					node: button.node,
					name: button.conf.name,
					idx:  idx
				} );

				if ( button.buttons ) {
					nodeBuilder( a, button.buttons, idx+'-' );
				}
			}
		}
	};

	var run = function ( selector, inst ) {
		var i, ien;
		var buttons = [];
		nodeBuilder( buttons, inst.s.buttons );

		var nodes = $.map( buttons, function (v) {
			return v.node;
		} );

		if ( $.isArray( selector ) || selector instanceof $ ) {
			for ( i=0, ien=selector.length ; i<ien ; i++ ) {
				run( selector[i], inst );
			}
			return;
		}

		if ( selector === null || selector === undefined || selector === '*' ) {
			// Select all
			for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
				ret.push( {
					inst: inst,
					node: buttons[i].node
				} );
			}
		}
		else if ( typeof selector === 'number' ) {
			// Main button index selector
			ret.push( {
				inst: inst,
				node: inst.s.buttons[ selector ].node
			} );
		}
		else if ( typeof selector === 'string' ) {
			if ( selector.indexOf( ',' ) !== -1 ) {
				// Split
				var a = selector.split(',');

				for ( i=0, ien=a.length ; i<ien ; i++ ) {
					run( $.trim(a[i]), inst );
				}
			}
			else if ( selector.match( /^\d+(\-\d+)*$/ ) ) {
				// Sub-button index selector
				var indexes = $.map( buttons, function (v) {
					return v.idx;
				} );

				ret.push( {
					inst: inst,
					node: buttons[ $.inArray( selector, indexes ) ].node
				} );
			}
			else if ( selector.indexOf( ':name' ) !== -1 ) {
				// Button name selector
				var name = selector.replace( ':name', '' );

				for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
					if ( buttons[i].name === name ) {
						ret.push( {
							inst: inst,
							node: buttons[i].node
						} );
					}
				}
			}
			else {
				// jQuery selector on the nodes
				$( nodes ).filter( selector ).each( function () {
					ret.push( {
						inst: inst,
						node: this
					} );
				} );
			}
		}
		else if ( typeof selector === 'object' && selector.nodeName ) {
			// Node selector
			var idx = $.inArray( selector, nodes );

			if ( idx !== -1 ) {
				ret.push( {
					inst: inst,
					node: nodes[ idx ]
				} );
			}
		}
	};


	for ( var i=0, ien=insts.length ; i<ien ; i++ ) {
		var inst = insts[i];

		run( selector, inst );
	}

	return ret;
};


/**
 * Buttons defaults. For full documentation, please refer to the docs/option
 * directory or the DataTables site.
 * @type {Object}
 * @static
 */
Buttons.defaults = {
	buttons: [ 'copy', 'excel', 'csv', 'pdf', 'print' ],
	name: 'main',
	tabIndex: 0,
	dom: {
		container: {
			tag: 'div',
			className: 'dt-buttons'
		},
		collection: {
			tag: 'div',
			className: 'dt-button-collection'
		},
		button: {
			// Flash buttons will not work with `<button>` in IE - it has to be `<a>`
			tag: 'ActiveXObject' in window ?
				'a' :
				'button',
			className: 'dt-button',
			active: 'active',
			disabled: 'disabled'
		},
		buttonLiner: {
			tag: 'span',
			className: ''
		}
	}
};

/**
 * Version information
 * @type {string}
 * @static
 */
Buttons.version = '1.5.6';


$.extend( _dtButtons, {
	collection: {
		text: function ( dt ) {
			return dt.i18n( 'buttons.collection', 'Collection' );
		},
		className: 'buttons-collection',
		init: function ( dt, button, config ) {
			button.attr( 'aria-expanded', false );
		},
		action: function ( e, dt, button, config ) {
			var close = function () {
				dt.buttons( '[aria-haspopup="true"][aria-expanded="true"]' ).nodes().each( function() {
					var collection = $(this).siblings('.dt-button-collection');

					if ( collection.length ) {
						collection.stop().fadeOut( config.fade, function () {
							collection.detach();
						} );
					}

					$(this).attr( 'aria-expanded', 'false' );
				});

				$('div.dt-button-background').off( 'click.dtb-collection' );
				Buttons.background( false, config.backgroundClassName, config.fade, insertPoint );

				$('body').off( '.dtb-collection' );
				dt.off( 'buttons-action.b-internal' );
			};

			var wasExpanded = button.attr( 'aria-expanded' ) === 'true';

			close();

			if (!wasExpanded) {
				var host = button;
				var collectionParent = $(button).parents('div.dt-button-collection');
				var hostPosition = host.position();
				var tableContainer = $( dt.table().container() );
				var multiLevel = false;
				var insertPoint = host;

				button.attr( 'aria-expanded', 'true' );

				// Remove any old collection
				if ( collectionParent.length ) {
					multiLevel = $('.dt-button-collection').position();
					insertPoint = collectionParent;
					$('body').trigger( 'click.dtb-collection' );
				}

				if ( insertPoint.parents('body')[0] !== document.body ) {
					insertPoint = document.body.lastChild;
				}

				config._collection.find('.dt-button-collection-title').remove();
				config._collection.prepend('<div class="dt-button-collection-title">'+config.collectionTitle+'</div>');

				config._collection
					.addClass( config.collectionLayout )
					.css( 'display', 'none' )
					.insertAfter( insertPoint )
					.stop()
					.fadeIn( config.fade );

				var position = config._collection.css( 'position' );

				if ( multiLevel && position === 'absolute' ) {
					config._collection.css( {
						top: multiLevel.top,
						left: multiLevel.left
					} );
				}
				else if ( position === 'absolute' ) {
					config._collection.css( {
						top: hostPosition.top + host.outerHeight(),
						left: hostPosition.left
					} );

					// calculate overflow when positioned beneath
					var tableBottom = tableContainer.offset().top + tableContainer.height();
					var listBottom = hostPosition.top + host.outerHeight() + config._collection.outerHeight();
					var bottomOverflow = listBottom - tableBottom;

					// calculate overflow when positioned above
					var listTop = hostPosition.top - config._collection.outerHeight();
					var tableTop = tableContainer.offset().top;
					var topOverflow = tableTop - listTop;

					// if bottom overflow is larger, move to the top because it fits better, or if dropup is requested
					if (bottomOverflow > topOverflow || config.dropup) {
						config._collection.css( 'top', hostPosition.top - config._collection.outerHeight() - 5);
					}

					// Right alignment is enabled on a class, e.g. bootstrap:
					// $.fn.dataTable.Buttons.defaults.dom.collection.className += " dropdown-menu-right"; 
					if ( config._collection.hasClass( config.rightAlignClassName ) ) {
						config._collection.css( 'left', hostPosition.left + host.outerWidth() - config._collection.outerWidth() );
					}

					// Right alignment in table container
					var listRight = hostPosition.left + config._collection.outerWidth();
					var tableRight = tableContainer.offset().left + tableContainer.width();
					if ( listRight > tableRight ) {
						config._collection.css( 'left', hostPosition.left - ( listRight - tableRight ) );
					}

					// Right alignment to window
					var listOffsetRight = host.offset().left + config._collection.outerWidth();
					if ( listOffsetRight > $(window).width() ) {
						config._collection.css( 'left', hostPosition.left - (listOffsetRight-$(window).width()) );
					}
				}
				else {
					// Fix position - centre on screen
					var top = config._collection.height() / 2;
					if ( top > $(window).height() / 2 ) {
						top = $(window).height() / 2;
					}

					config._collection.css( 'marginTop', top*-1 );
				}

				if ( config.background ) {
					Buttons.background( true, config.backgroundClassName, config.fade, insertPoint );
				}

				// Need to break the 'thread' for the collection button being
				// activated by a click - it would also trigger this event
				setTimeout( function () {
					// This is bonkers, but if we don't have a click listener on the
					// background element, iOS Safari will ignore the body click
					// listener below. An empty function here is all that is
					// required to make it work...
					$('div.dt-button-background').on( 'click.dtb-collection', function () {} );

					$('body')
						.on( 'click.dtb-collection', function (e) {
							// andSelf is deprecated in jQ1.8, but we want 1.7 compat
							var back = $.fn.addBack ? 'addBack' : 'andSelf';

							if ( ! $(e.target).parents()[back]().filter( config._collection ).length ) {
								close();
							}
						} )
						.on( 'keyup.dtb-collection', function (e) {
							if ( e.keyCode === 27 ) {
								close();
							}
						} );

					if ( config.autoClose ) {
						dt.on( 'buttons-action.b-internal', function () {
							close();
						} );
					}
				}, 10 );
			}
		},
		background: true,
		collectionLayout: '',
		collectionTitle: '',
		backgroundClassName: 'dt-button-background',
		rightAlignClassName: 'dt-button-right',
		autoClose: false,
		fade: 400,
		attr: {
			'aria-haspopup': true
		}
	},
	copy: function ( dt, conf ) {
		if ( _dtButtons.copyHtml5 ) {
			return 'copyHtml5';
		}
		if ( _dtButtons.copyFlash && _dtButtons.copyFlash.available( dt, conf ) ) {
			return 'copyFlash';
		}
	},
	csv: function ( dt, conf ) {
		// Common option that will use the HTML5 or Flash export buttons
		if ( _dtButtons.csvHtml5 && _dtButtons.csvHtml5.available( dt, conf ) ) {
			return 'csvHtml5';
		}
		if ( _dtButtons.csvFlash && _dtButtons.csvFlash.available( dt, conf ) ) {
			return 'csvFlash';
		}
	},
	excel: function ( dt, conf ) {
		// Common option that will use the HTML5 or Flash export buttons
		if ( _dtButtons.excelHtml5 && _dtButtons.excelHtml5.available( dt, conf ) ) {
			return 'excelHtml5';
		}
		if ( _dtButtons.excelFlash && _dtButtons.excelFlash.available( dt, conf ) ) {
			return 'excelFlash';
		}
	},
	pdf: function ( dt, conf ) {
		// Common option that will use the HTML5 or Flash export buttons
		if ( _dtButtons.pdfHtml5 && _dtButtons.pdfHtml5.available( dt, conf ) ) {
			return 'pdfHtml5';
		}
		if ( _dtButtons.pdfFlash && _dtButtons.pdfFlash.available( dt, conf ) ) {
			return 'pdfFlash';
		}
	},
	pageLength: function ( dt ) {
		var lengthMenu = dt.settings()[0].aLengthMenu;
		var vals = $.isArray( lengthMenu[0] ) ? lengthMenu[0] : lengthMenu;
		var lang = $.isArray( lengthMenu[0] ) ? lengthMenu[1] : lengthMenu;
		var text = function ( dt ) {
			return dt.i18n( 'buttons.pageLength', {
				"-1": 'Show all rows',
				_:    'Show %d rows'
			}, dt.page.len() );
		};

		return {
			extend: 'collection',
			text: text,
			className: 'buttons-page-length',
			autoClose: true,
			buttons: $.map( vals, function ( val, i ) {
				return {
					text: lang[i],
					className: 'button-page-length',
					action: function ( e, dt ) {
						dt.page.len( val ).draw();
					},
					init: function ( dt, node, conf ) {
						var that = this;
						var fn = function () {
							that.active( dt.page.len() === val );
						};

						dt.on( 'length.dt'+conf.namespace, fn );
						fn();
					},
					destroy: function ( dt, node, conf ) {
						dt.off( 'length.dt'+conf.namespace );
					}
				};
			} ),
			init: function ( dt, node, conf ) {
				var that = this;
				dt.on( 'length.dt'+conf.namespace, function () {
					that.text( conf.text );
				} );
			},
			destroy: function ( dt, node, conf ) {
				dt.off( 'length.dt'+conf.namespace );
			}
		};
	}
} );


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables API
 *
 * For complete documentation, please refer to the docs/api directory or the
 * DataTables site
 */

// Buttons group and individual button selector
DataTable.Api.register( 'buttons()', function ( group, selector ) {
	// Argument shifting
	if ( selector === undefined ) {
		selector = group;
		group = undefined;
	}

	this.selector.buttonGroup = group;

	var res = this.iterator( true, 'table', function ( ctx ) {
		if ( ctx._buttons ) {
			return Buttons.buttonSelector(
				Buttons.instanceSelector( group, ctx._buttons ),
				selector
			);
		}
	}, true );

	res._groupSelector = group;
	return res;
} );

// Individual button selector
DataTable.Api.register( 'button()', function ( group, selector ) {
	// just run buttons() and truncate
	var buttons = this.buttons( group, selector );

	if ( buttons.length > 1 ) {
		buttons.splice( 1, buttons.length );
	}

	return buttons;
} );

// Active buttons
DataTable.Api.registerPlural( 'buttons().active()', 'button().active()', function ( flag ) {
	if ( flag === undefined ) {
		return this.map( function ( set ) {
			return set.inst.active( set.node );
		} );
	}

	return this.each( function ( set ) {
		set.inst.active( set.node, flag );
	} );
} );

// Get / set button action
DataTable.Api.registerPlural( 'buttons().action()', 'button().action()', function ( action ) {
	if ( action === undefined ) {
		return this.map( function ( set ) {
			return set.inst.action( set.node );
		} );
	}

	return this.each( function ( set ) {
		set.inst.action( set.node, action );
	} );
} );

// Enable / disable buttons
DataTable.Api.register( ['buttons().enable()', 'button().enable()'], function ( flag ) {
	return this.each( function ( set ) {
		set.inst.enable( set.node, flag );
	} );
} );

// Disable buttons
DataTable.Api.register( ['buttons().disable()', 'button().disable()'], function () {
	return this.each( function ( set ) {
		set.inst.disable( set.node );
	} );
} );

// Get button nodes
DataTable.Api.registerPlural( 'buttons().nodes()', 'button().node()', function () {
	var jq = $();

	// jQuery will automatically reduce duplicates to a single entry
	$( this.each( function ( set ) {
		jq = jq.add( set.inst.node( set.node ) );
	} ) );

	return jq;
} );

// Get / set button processing state
DataTable.Api.registerPlural( 'buttons().processing()', 'button().processing()', function ( flag ) {
	if ( flag === undefined ) {
		return this.map( function ( set ) {
			return set.inst.processing( set.node );
		} );
	}

	return this.each( function ( set ) {
		set.inst.processing( set.node, flag );
	} );
} );

// Get / set button text (i.e. the button labels)
DataTable.Api.registerPlural( 'buttons().text()', 'button().text()', function ( label ) {
	if ( label === undefined ) {
		return this.map( function ( set ) {
			return set.inst.text( set.node );
		} );
	}

	return this.each( function ( set ) {
		set.inst.text( set.node, label );
	} );
} );

// Trigger a button's action
DataTable.Api.registerPlural( 'buttons().trigger()', 'button().trigger()', function () {
	return this.each( function ( set ) {
		set.inst.node( set.node ).trigger( 'click' );
	} );
} );

// Get the container elements
DataTable.Api.registerPlural( 'buttons().containers()', 'buttons().container()', function () {
	var jq = $();
	var groupSelector = this._groupSelector;

	// We need to use the group selector directly, since if there are no buttons
	// the result set will be empty
	this.iterator( true, 'table', function ( ctx ) {
		if ( ctx._buttons ) {
			var insts = Buttons.instanceSelector( groupSelector, ctx._buttons );

			for ( var i=0, ien=insts.length ; i<ien ; i++ ) {
				jq = jq.add( insts[i].container() );
			}
		}
	} );

	return jq;
} );

// Add a new button
DataTable.Api.register( 'button().add()', function ( idx, conf ) {
	var ctx = this.context;

	// Don't use `this` as it could be empty - select the instances directly
	if ( ctx.length ) {
		var inst = Buttons.instanceSelector( this._groupSelector, ctx[0]._buttons );

		if ( inst.length ) {
			inst[0].add( conf, idx );
		}
	}

	return this.button( this._groupSelector, idx );
} );

// Destroy the button sets selected
DataTable.Api.register( 'buttons().destroy()', function () {
	this.pluck( 'inst' ).unique().each( function ( inst ) {
		inst.destroy();
	} );

	return this;
} );

// Remove a button
DataTable.Api.registerPlural( 'buttons().remove()', 'buttons().remove()', function () {
	this.each( function ( set ) {
		set.inst.remove( set.node );
	} );

	return this;
} );

// Information box that can be used by buttons
var _infoTimer;
DataTable.Api.register( 'buttons.info()', function ( title, message, time ) {
	var that = this;

	if ( title === false ) {
		$('#datatables_buttons_info').fadeOut( function () {
			$(this).remove();
		} );
		clearTimeout( _infoTimer );
		_infoTimer = null;

		return this;
	}

	if ( _infoTimer ) {
		clearTimeout( _infoTimer );
	}

	if ( $('#datatables_buttons_info').length ) {
		$('#datatables_buttons_info').remove();
	}

	title = title ? '<h2>'+title+'</h2>' : '';

	$('<div id="datatables_buttons_info" class="dt-button-info"/>')
		.html( title )
		.append( $('<div/>')[ typeof message === 'string' ? 'html' : 'append' ]( message ) )
		.css( 'display', 'none' )
		.appendTo( 'body' )
		.fadeIn();

	if ( time !== undefined && time !== 0 ) {
		_infoTimer = setTimeout( function () {
			that.buttons.info( false );
		}, time );
	}

	return this;
} );

// Get data from the table for export - this is common to a number of plug-in
// buttons so it is included in the Buttons core library
DataTable.Api.register( 'buttons.exportData()', function ( options ) {
	if ( this.context.length ) {
		return _exportData( new DataTable.Api( this.context[0] ), options );
	}
} );

// Get information about the export that is common to many of the export data
// types (DRY)
DataTable.Api.register( 'buttons.exportInfo()', function ( conf ) {
	if ( ! conf ) {
		conf = {};
	}

	return {
		filename: _filename( conf ),
		title: _title( conf ),
		messageTop: _message(this, conf.message || conf.messageTop, 'top'),
		messageBottom: _message(this, conf.messageBottom, 'bottom')
	};
} );



/**
 * Get the file name for an exported file.
 *
 * @param {object}	config Button configuration
 * @param {boolean} incExtension Include the file name extension
 */
var _filename = function ( config )
{
	// Backwards compatibility
	var filename = config.filename === '*' && config.title !== '*' && config.title !== undefined && config.title !== null && config.title !== '' ?
		config.title :
		config.filename;

	if ( typeof filename === 'function' ) {
		filename = filename();
	}

	if ( filename === undefined || filename === null ) {
		return null;
	}

	if ( filename.indexOf( '*' ) !== -1 ) {
		filename = $.trim( filename.replace( '*', $('head > title').text() ) );
	}

	// Strip characters which the OS will object to
	filename = filename.replace(/[^a-zA-Z0-9_\u00A1-\uFFFF\.,\-_ !\(\)]/g, "");

	var extension = _stringOrFunction( config.extension );
	if ( ! extension ) {
		extension = '';
	}

	return filename + extension;
};

/**
 * Simply utility method to allow parameters to be given as a function
 *
 * @param {undefined|string|function} option Option
 * @return {null|string} Resolved value
 */
var _stringOrFunction = function ( option )
{
	if ( option === null || option === undefined ) {
		return null;
	}
	else if ( typeof option === 'function' ) {
		return option();
	}
	return option;
};

/**
 * Get the title for an exported file.
 *
 * @param {object} config	Button configuration
 */
var _title = function ( config )
{
	var title = _stringOrFunction( config.title );

	return title === null ?
		null : title.indexOf( '*' ) !== -1 ?
			title.replace( '*', $('head > title').text() || 'Exported data' ) :
			title;
};

var _message = function ( dt, option, position )
{
	var message = _stringOrFunction( option );
	if ( message === null ) {
		return null;
	}

	var caption = $('caption', dt.table().container()).eq(0);
	if ( message === '*' ) {
		var side = caption.css( 'caption-side' );
		if ( side !== position ) {
			return null;
		}

		return caption.length ?
			caption.text() :
			'';
	}

	return message;
};







var _exportTextarea = $('<textarea/>')[0];
var _exportData = function ( dt, inOpts )
{
	var config = $.extend( true, {}, {
		rows:           null,
		columns:        '',
		modifier:       {
			search: 'applied',
			order:  'applied'
		},
		orthogonal:     'display',
		stripHtml:      true,
		stripNewlines:  true,
		decodeEntities: true,
		trim:           true,
		format:         {
			header: function ( d ) {
				return strip( d );
			},
			footer: function ( d ) {
				return strip( d );
			},
			body: function ( d ) {
				return strip( d );
			}
		},
		customizeData: null
	}, inOpts );

	var strip = function ( str ) {
		if ( typeof str !== 'string' ) {
			return str;
		}

		// Always remove script tags
		str = str.replace( /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '' );

		// Always remove comments
		str = str.replace( /<!\-\-.*?\-\->/g, '' );

		if ( config.stripHtml ) {
			str = str.replace( /<[^>]*>/g, '' );
		}

		if ( config.trim ) {
			str = str.replace( /^\s+|\s+$/g, '' );
		}

		if ( config.stripNewlines ) {
			str = str.replace( /\n/g, ' ' );
		}

		if ( config.decodeEntities ) {
			_exportTextarea.innerHTML = str;
			str = _exportTextarea.value;
		}

		return str;
	};


	var header = dt.columns( config.columns ).indexes().map( function (idx) {
		var el = dt.column( idx ).header();
		return config.format.header( el.innerHTML, idx, el );
	} ).toArray();

	var footer = dt.table().footer() ?
		dt.columns( config.columns ).indexes().map( function (idx) {
			var el = dt.column( idx ).footer();
			return config.format.footer( el ? el.innerHTML : '', idx, el );
		} ).toArray() :
		null;
	
	// If Select is available on this table, and any rows are selected, limit the export
	// to the selected rows. If no rows are selected, all rows will be exported. Specify
	// a `selected` modifier to control directly.
	var modifier = $.extend( {}, config.modifier );
	if ( dt.select && typeof dt.select.info === 'function' && modifier.selected === undefined ) {
		if ( dt.rows( config.rows, $.extend( { selected: true }, modifier ) ).any() ) {
			$.extend( modifier, { selected: true } )
		}
	}

	var rowIndexes = dt.rows( config.rows, modifier ).indexes().toArray();
	var selectedCells = dt.cells( rowIndexes, config.columns );
	var cells = selectedCells
		.render( config.orthogonal )
		.toArray();
	var cellNodes = selectedCells
		.nodes()
		.toArray();

	var columns = header.length;
	var rows = columns > 0 ? cells.length / columns : 0;
	var body = [];
	var cellCounter = 0;

	for ( var i=0, ien=rows ; i<ien ; i++ ) {
		var row = [ columns ];

		for ( var j=0 ; j<columns ; j++ ) {
			row[j] = config.format.body( cells[ cellCounter ], i, j, cellNodes[ cellCounter ] );
			cellCounter++;
		}

		body[i] = row;
	}

	var data = {
		header: header,
		footer: footer,
		body:   body
	};

	if ( config.customizeData ) {
		config.customizeData( data );
	}

	return data;
};


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables interface
 */

// Attach to DataTables objects for global access
$.fn.dataTable.Buttons = Buttons;
$.fn.DataTable.Buttons = Buttons;



// DataTables creation - check if the buttons have been defined for this table,
// they will have been if the `B` option was used in `dom`, otherwise we should
// create the buttons instance here so they can be inserted into the document
// using the API. Listen for `init` for compatibility with pre 1.10.10, but to
// be removed in future.
$(document).on( 'init.dt plugin-init.dt', function (e, settings) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	var opts = settings.oInit.buttons || DataTable.defaults.buttons;

	if ( opts && ! settings._buttons ) {
		new Buttons( settings, opts ).container();
	}
} );

function _init ( settings ) {
	var api = new DataTable.Api( settings );
	var opts = api.init().buttons || DataTable.defaults.buttons;

	return new Buttons( api, opts ).container();
}

// DataTables `dom` feature option
DataTable.ext.feature.push( {
	fnInit: _init,
	cFeature: "B"
} );

// DataTables 2 layout feature
if ( DataTable.ext.features ) {
	DataTable.ext.features.register( 'buttons', _init );
}


return Buttons;
}));


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! ColReorder 1.5.1
 * ©2010-2018 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     ColReorder
 * @description Provide the ability to reorder columns in a DataTable
 * @version     1.5.1
 * @file        dataTables.colReorder.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     www.sprymedia.co.uk/contact
 * @copyright   Copyright 2010-2018 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */
(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


/**
 * Switch the key value pairing of an index array to be value key (i.e. the old value is now the
 * key). For example consider [ 2, 0, 1 ] this would be returned as [ 1, 2, 0 ].
 *  @method  fnInvertKeyValues
 *  @param   array aIn Array to switch around
 *  @returns array
 */
function fnInvertKeyValues( aIn )
{
	var aRet=[];
	for ( var i=0, iLen=aIn.length ; i<iLen ; i++ )
	{
		aRet[ aIn[i] ] = i;
	}
	return aRet;
}


/**
 * Modify an array by switching the position of two elements
 *  @method  fnArraySwitch
 *  @param   array aArray Array to consider, will be modified by reference (i.e. no return)
 *  @param   int iFrom From point
 *  @param   int iTo Insert point
 *  @returns void
 */
function fnArraySwitch( aArray, iFrom, iTo )
{
	var mStore = aArray.splice( iFrom, 1 )[0];
	aArray.splice( iTo, 0, mStore );
}


/**
 * Switch the positions of nodes in a parent node (note this is specifically designed for
 * table rows). Note this function considers all element nodes under the parent!
 *  @method  fnDomSwitch
 *  @param   string sTag Tag to consider
 *  @param   int iFrom Element to move
 *  @param   int Point to element the element to (before this point), can be null for append
 *  @returns void
 */
function fnDomSwitch( nParent, iFrom, iTo )
{
	var anTags = [];
	for ( var i=0, iLen=nParent.childNodes.length ; i<iLen ; i++ )
	{
		if ( nParent.childNodes[i].nodeType == 1 )
		{
			anTags.push( nParent.childNodes[i] );
		}
	}
	var nStore = anTags[ iFrom ];

	if ( iTo !== null )
	{
		nParent.insertBefore( nStore, anTags[iTo] );
	}
	else
	{
		nParent.appendChild( nStore );
	}
}


/**
 * Plug-in for DataTables which will reorder the internal column structure by taking the column
 * from one position (iFrom) and insert it into a given point (iTo).
 *  @method  $.fn.dataTableExt.oApi.fnColReorder
 *  @param   object oSettings DataTables settings object - automatically added by DataTables!
 *  @param   int iFrom Take the column to be repositioned from this point
 *  @param   int iTo and insert it into this point
 *  @param   bool drop Indicate if the reorder is the final one (i.e. a drop)
 *    not a live reorder
 *  @param   bool invalidateRows speeds up processing if false passed
 *  @returns void
 */
$.fn.dataTableExt.oApi.fnColReorder = function ( oSettings, iFrom, iTo, drop, invalidateRows )
{
	var i, iLen, j, jLen, jen, iCols=oSettings.aoColumns.length, nTrs, oCol;
	var attrMap = function ( obj, prop, mapping ) {
		if ( ! obj[ prop ] || typeof obj[ prop ] === 'function' ) {
			return;
		}

		var a = obj[ prop ].split('.');
		var num = a.shift();

		if ( isNaN( num*1 ) ) {
			return;
		}

		obj[ prop ] = mapping[ num*1 ]+'.'+a.join('.');
	};

	/* Sanity check in the input */
	if ( iFrom == iTo )
	{
		/* Pointless reorder */
		return;
	}

	if ( iFrom < 0 || iFrom >= iCols )
	{
		this.oApi._fnLog( oSettings, 1, "ColReorder 'from' index is out of bounds: "+iFrom );
		return;
	}

	if ( iTo < 0 || iTo >= iCols )
	{
		this.oApi._fnLog( oSettings, 1, "ColReorder 'to' index is out of bounds: "+iTo );
		return;
	}

	/*
	 * Calculate the new column array index, so we have a mapping between the old and new
	 */
	var aiMapping = [];
	for ( i=0, iLen=iCols ; i<iLen ; i++ )
	{
		aiMapping[i] = i;
	}
	fnArraySwitch( aiMapping, iFrom, iTo );
	var aiInvertMapping = fnInvertKeyValues( aiMapping );


	/*
	 * Convert all internal indexing to the new column order indexes
	 */
	/* Sorting */
	for ( i=0, iLen=oSettings.aaSorting.length ; i<iLen ; i++ )
	{
		oSettings.aaSorting[i][0] = aiInvertMapping[ oSettings.aaSorting[i][0] ];
	}

	/* Fixed sorting */
	if ( oSettings.aaSortingFixed !== null )
	{
		for ( i=0, iLen=oSettings.aaSortingFixed.length ; i<iLen ; i++ )
		{
			oSettings.aaSortingFixed[i][0] = aiInvertMapping[ oSettings.aaSortingFixed[i][0] ];
		}
	}

	/* Data column sorting (the column which the sort for a given column should take place on) */
	for ( i=0, iLen=iCols ; i<iLen ; i++ )
	{
		oCol = oSettings.aoColumns[i];
		for ( j=0, jLen=oCol.aDataSort.length ; j<jLen ; j++ )
		{
			oCol.aDataSort[j] = aiInvertMapping[ oCol.aDataSort[j] ];
		}

		// Update the column indexes
		oCol.idx = aiInvertMapping[ oCol.idx ];
	}

	// Update 1.10 optimised sort class removal variable
	$.each( oSettings.aLastSort, function (i, val) {
		oSettings.aLastSort[i].src = aiInvertMapping[ val.src ];
	} );

	/* Update the Get and Set functions for each column */
	for ( i=0, iLen=iCols ; i<iLen ; i++ )
	{
		oCol = oSettings.aoColumns[i];

		if ( typeof oCol.mData == 'number' ) {
			oCol.mData = aiInvertMapping[ oCol.mData ];
		}
		else if ( $.isPlainObject( oCol.mData ) ) {
			// HTML5 data sourced
			attrMap( oCol.mData, '_',      aiInvertMapping );
			attrMap( oCol.mData, 'filter', aiInvertMapping );
			attrMap( oCol.mData, 'sort',   aiInvertMapping );
			attrMap( oCol.mData, 'type',   aiInvertMapping );
		}
	}

	/*
	 * Move the DOM elements
	 */
	if ( oSettings.aoColumns[iFrom].bVisible )
	{
		/* Calculate the current visible index and the point to insert the node before. The insert
		 * before needs to take into account that there might not be an element to insert before,
		 * in which case it will be null, and an appendChild should be used
		 */
		var iVisibleIndex = this.oApi._fnColumnIndexToVisible( oSettings, iFrom );
		var iInsertBeforeIndex = null;

		i = iTo < iFrom ? iTo : iTo + 1;
		while ( iInsertBeforeIndex === null && i < iCols )
		{
			iInsertBeforeIndex = this.oApi._fnColumnIndexToVisible( oSettings, i );
			i++;
		}

		/* Header */
		nTrs = oSettings.nTHead.getElementsByTagName('tr');
		for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
		{
			fnDomSwitch( nTrs[i], iVisibleIndex, iInsertBeforeIndex );
		}

		/* Footer */
		if ( oSettings.nTFoot !== null )
		{
			nTrs = oSettings.nTFoot.getElementsByTagName('tr');
			for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
			{
				fnDomSwitch( nTrs[i], iVisibleIndex, iInsertBeforeIndex );
			}
		}

		/* Body */
		for ( i=0, iLen=oSettings.aoData.length ; i<iLen ; i++ )
		{
			if ( oSettings.aoData[i].nTr !== null )
			{
				fnDomSwitch( oSettings.aoData[i].nTr, iVisibleIndex, iInsertBeforeIndex );
			}
		}
	}

	/*
	 * Move the internal array elements
	 */
	/* Columns */
	fnArraySwitch( oSettings.aoColumns, iFrom, iTo );

	// regenerate the get / set functions
	for ( i=0, iLen=iCols ; i<iLen ; i++ ) {
		oSettings.oApi._fnColumnOptions( oSettings, i, {} );
	}

	/* Search columns */
	fnArraySwitch( oSettings.aoPreSearchCols, iFrom, iTo );

	/* Array array - internal data anodes cache */
	for ( i=0, iLen=oSettings.aoData.length ; i<iLen ; i++ )
	{
		var data = oSettings.aoData[i];
		var cells = data.anCells;

		if ( cells ) {
			fnArraySwitch( cells, iFrom, iTo );

			// Longer term, should this be moved into the DataTables' invalidate
			// methods?
			for ( j=0, jen=cells.length ; j<jen ; j++ ) {
				if ( cells[j] && cells[j]._DT_CellIndex ) {
					cells[j]._DT_CellIndex.column = j;
				}
			}
		}

		// For DOM sourced data, the invalidate will reread the cell into
		// the data array, but for data sources as an array, they need to
		// be flipped
		if ( data.src !== 'dom' && $.isArray( data._aData ) ) {
			fnArraySwitch( data._aData, iFrom, iTo );
		}
	}

	/* Reposition the header elements in the header layout array */
	for ( i=0, iLen=oSettings.aoHeader.length ; i<iLen ; i++ )
	{
		fnArraySwitch( oSettings.aoHeader[i], iFrom, iTo );
	}

	if ( oSettings.aoFooter !== null )
	{
		for ( i=0, iLen=oSettings.aoFooter.length ; i<iLen ; i++ )
		{
			fnArraySwitch( oSettings.aoFooter[i], iFrom, iTo );
		}
	}

	if ( invalidateRows || invalidateRows === undefined )
	{
		$.fn.dataTable.Api( oSettings ).rows().invalidate();
	}

	/*
	 * Update DataTables' event handlers
	 */

	/* Sort listener */
	for ( i=0, iLen=iCols ; i<iLen ; i++ )
	{
		$(oSettings.aoColumns[i].nTh).off('.DT');
		this.oApi._fnSortAttachListener( oSettings, oSettings.aoColumns[i].nTh, i );
	}


	/* Fire an event so other plug-ins can update */
	$(oSettings.oInstance).trigger( 'column-reorder.dt', [ oSettings, {
		from: iFrom,
		to: iTo,
		mapping: aiInvertMapping,
		drop: drop,

		// Old style parameters for compatibility
		iFrom: iFrom,
		iTo: iTo,
		aiInvertMapping: aiInvertMapping
	} ] );
};

/**
 * ColReorder provides column visibility control for DataTables
 * @class ColReorder
 * @constructor
 * @param {object} dt DataTables settings object
 * @param {object} opts ColReorder options
 */
var ColReorder = function( dt, opts )
{
	var settings = new $.fn.dataTable.Api( dt ).settings()[0];

	// Ensure that we can't initialise on the same table twice
	if ( settings._colReorder ) {
		return settings._colReorder;
	}

	// Allow the options to be a boolean for defaults
	if ( opts === true ) {
		opts = {};
	}

	// Convert from camelCase to Hungarian, just as DataTables does
	var camelToHungarian = $.fn.dataTable.camelToHungarian;
	if ( camelToHungarian ) {
		camelToHungarian( ColReorder.defaults, ColReorder.defaults, true );
		camelToHungarian( ColReorder.defaults, opts || {} );
	}


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Public class variables
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

	/**
	 * @namespace Settings object which contains customisable information for ColReorder instance
	 */
	this.s = {
		/**
		 * DataTables settings object
		 *  @property dt
		 *  @type     Object
		 *  @default  null
		 */
		"dt": null,

		/**
		 * Enable flag
		 *  @property dt
		 *  @type     Object
		 *  @default  null
		 */
		"enable": null,

		/**
		 * Initialisation object used for this instance
		 *  @property init
		 *  @type     object
		 *  @default  {}
		 */
		"init": $.extend( true, {}, ColReorder.defaults, opts ),

		/**
		 * Number of columns to fix (not allow to be reordered)
		 *  @property fixed
		 *  @type     int
		 *  @default  0
		 */
		"fixed": 0,

		/**
		 * Number of columns to fix counting from right (not allow to be reordered)
		 *  @property fixedRight
		 *  @type     int
		 *  @default  0
		 */
		"fixedRight": 0,

		/**
		 * Callback function for once the reorder has been done
		 *  @property reorderCallback
		 *  @type     function
		 *  @default  null
		 */
		"reorderCallback": null,

		/**
		 * @namespace Information used for the mouse drag
		 */
		"mouse": {
			"startX": -1,
			"startY": -1,
			"offsetX": -1,
			"offsetY": -1,
			"target": -1,
			"targetIndex": -1,
			"fromIndex": -1
		},

		/**
		 * Information which is used for positioning the insert cusor and knowing where to do the
		 * insert. Array of objects with the properties:
		 *   x: x-axis position
		 *   to: insert point
		 *  @property aoTargets
		 *  @type     array
		 *  @default  []
		 */
		"aoTargets": []
	};


	/**
	 * @namespace Common and useful DOM elements for the class instance
	 */
	this.dom = {
		/**
		 * Dragging element (the one the mouse is moving)
		 *  @property drag
		 *  @type     element
		 *  @default  null
		 */
		"drag": null,

		/**
		 * The insert cursor
		 *  @property pointer
		 *  @type     element
		 *  @default  null
		 */
		"pointer": null
	};

	/* Constructor logic */
	this.s.enable = this.s.init.bEnable;
	this.s.dt = settings;
	this.s.dt._colReorder = this;
	this._fnConstruct();

	return this;
};



$.extend( ColReorder.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Public methods
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

	/**
	 * Enable / disable end user interaction
	 */
	fnEnable: function ( flag )
	{
		if ( flag === false ) {
			return fnDisable();
		}

		this.s.enable = true;
	},

	/**
	 * Disable end user interaction
	 */
	fnDisable: function ()
	{
		this.s.enable = false;
	},

	/**
	 * Reset the column ordering to the original ordering that was detected on
	 * start up.
	 *  @return {this} Returns `this` for chaining.
	 *
	 *  @example
	 *    // DataTables initialisation with ColReorder
	 *    var table = $('#example').dataTable( {
	 *        "sDom": 'Rlfrtip'
	 *    } );
	 *
	 *    // Add click event to a button to reset the ordering
	 *    $('#resetOrdering').click( function (e) {
	 *        e.preventDefault();
	 *        $.fn.dataTable.ColReorder( table ).fnReset();
	 *    } );
	 */
	"fnReset": function ()
	{
		this._fnOrderColumns( this.fnOrder() );

		return this;
	},

	/**
	 * `Deprecated` - Get the current order of the columns, as an array.
	 *  @return {array} Array of column identifiers
	 *  @deprecated `fnOrder` should be used in preference to this method.
	 *      `fnOrder` acts as a getter/setter.
	 */
	"fnGetCurrentOrder": function ()
	{
		return this.fnOrder();
	},

	/**
	 * Get the current order of the columns, as an array. Note that the values
	 * given in the array are unique identifiers for each column. Currently
	 * these are the original ordering of the columns that was detected on
	 * start up, but this could potentially change in future.
	 *  @return {array} Array of column identifiers
	 *
	 *  @example
	 *    // Get column ordering for the table
	 *    var order = $.fn.dataTable.ColReorder( dataTable ).fnOrder();
	 *//**
	 * Set the order of the columns, from the positions identified in the
	 * ordering array given. Note that ColReorder takes a brute force approach
	 * to reordering, so it is possible multiple reordering events will occur
	 * before the final order is settled upon.
	 *  @param {array} [set] Array of column identifiers in the new order. Note
	 *    that every column must be included, uniquely, in this array.
	 *  @return {this} Returns `this` for chaining.
	 *
	 *  @example
	 *    // Swap the first and second columns
	 *    $.fn.dataTable.ColReorder( dataTable ).fnOrder( [1, 0, 2, 3, 4] );
	 *
	 *  @example
	 *    // Move the first column to the end for the table `#example`
	 *    var curr = $.fn.dataTable.ColReorder( '#example' ).fnOrder();
	 *    var first = curr.shift();
	 *    curr.push( first );
	 *    $.fn.dataTable.ColReorder( '#example' ).fnOrder( curr );
	 *
	 *  @example
	 *    // Reverse the table's order
	 *    $.fn.dataTable.ColReorder( '#example' ).fnOrder(
	 *      $.fn.dataTable.ColReorder( '#example' ).fnOrder().reverse()
	 *    );
	 */
	"fnOrder": function ( set, original )
	{
		var a = [], i, ien, j, jen;
		var columns = this.s.dt.aoColumns;

		if ( set === undefined ){
			for ( i=0, ien=columns.length ; i<ien ; i++ ) {
				a.push( columns[i]._ColReorder_iOrigCol );
			}

			return a;
		}

		// The order given is based on the original indexes, rather than the
		// existing ones, so we need to translate from the original to current
		// before then doing the order
		if ( original ) {
			var order = this.fnOrder();

			for ( i=0, ien=set.length ; i<ien ; i++ ) {
				a.push( $.inArray( set[i], order ) );
			}

			set = a;
		}

		this._fnOrderColumns( fnInvertKeyValues( set ) );

		return this;
	},


	/**
	 * Convert from the original column index, to the original
	 *
	 * @param  {int|array} idx Index(es) to convert
	 * @param  {string} dir Transpose direction - `fromOriginal` / `toCurrent`
	 *   or `'toOriginal` / `fromCurrent`
	 * @return {int|array}     Converted values
	 */
	fnTranspose: function ( idx, dir )
	{
		if ( ! dir ) {
			dir = 'toCurrent';
		}

		var order = this.fnOrder();
		var columns = this.s.dt.aoColumns;

		if ( dir === 'toCurrent' ) {
			// Given an original index, want the current
			return ! $.isArray( idx ) ?
				$.inArray( idx, order ) :
				$.map( idx, function ( index ) {
					return $.inArray( index, order );
				} );
		}
		else {
			// Given a current index, want the original
			return ! $.isArray( idx ) ?
				columns[idx]._ColReorder_iOrigCol :
				$.map( idx, function ( index ) {
					return columns[index]._ColReorder_iOrigCol;
				} );
		}
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods (they are of course public in JS, but recommended as private)
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

	/**
	 * Constructor logic
	 *  @method  _fnConstruct
	 *  @returns void
	 *  @private
	 */
	"_fnConstruct": function ()
	{
		var that = this;
		var iLen = this.s.dt.aoColumns.length;
		var table = this.s.dt.nTable;
		var i;

		/* Columns discounted from reordering - counting left to right */
		if ( this.s.init.iFixedColumns )
		{
			this.s.fixed = this.s.init.iFixedColumns;
		}

		if ( this.s.init.iFixedColumnsLeft )
		{
			this.s.fixed = this.s.init.iFixedColumnsLeft;
		}

		/* Columns discounted from reordering - counting right to left */
		this.s.fixedRight = this.s.init.iFixedColumnsRight ?
			this.s.init.iFixedColumnsRight :
			0;

		/* Drop callback initialisation option */
		if ( this.s.init.fnReorderCallback )
		{
			this.s.reorderCallback = this.s.init.fnReorderCallback;
		}

		/* Add event handlers for the drag and drop, and also mark the original column order */
		for ( i = 0; i < iLen; i++ )
		{
			if ( i > this.s.fixed-1 && i < iLen - this.s.fixedRight )
			{
				this._fnMouseListener( i, this.s.dt.aoColumns[i].nTh );
			}

			/* Mark the original column order for later reference */
			this.s.dt.aoColumns[i]._ColReorder_iOrigCol = i;
		}

		/* State saving */
		this.s.dt.oApi._fnCallbackReg( this.s.dt, 'aoStateSaveParams', function (oS, oData) {
			that._fnStateSave.call( that, oData );
		}, "ColReorder_State" );

		/* An initial column order has been specified */
		var aiOrder = null;
		if ( this.s.init.aiOrder )
		{
			aiOrder = this.s.init.aiOrder.slice();
		}

		/* State loading, overrides the column order given */
		if ( this.s.dt.oLoadedState && typeof this.s.dt.oLoadedState.ColReorder != 'undefined' &&
		  this.s.dt.oLoadedState.ColReorder.length == this.s.dt.aoColumns.length )
		{
			aiOrder = this.s.dt.oLoadedState.ColReorder;
		}

		/* If we have an order to apply - do so */
		if ( aiOrder )
		{
			/* We might be called during or after the DataTables initialisation. If before, then we need
			 * to wait until the draw is done, if after, then do what we need to do right away
			 */
			if ( !that.s.dt._bInitComplete )
			{
				var bDone = false;
				$(table).on( 'draw.dt.colReorder', function () {
					if ( !that.s.dt._bInitComplete && !bDone )
					{
						bDone = true;
						var resort = fnInvertKeyValues( aiOrder );
						that._fnOrderColumns.call( that, resort );
					}
				} );
			}
			else
			{
				var resort = fnInvertKeyValues( aiOrder );
				that._fnOrderColumns.call( that, resort );
			}
		}
		else {
			this._fnSetColumnIndexes();
		}

		// Destroy clean up
		$(table).on( 'destroy.dt.colReorder', function () {
			$(table).off( 'destroy.dt.colReorder draw.dt.colReorder' );

			$.each( that.s.dt.aoColumns, function (i, column) {
				$(column.nTh).off('.ColReorder');
				$(column.nTh).removeAttr('data-column-index');
			} );

			that.s.dt._colReorder = null;
			that.s = null;
		} );
	},


	/**
	 * Set the column order from an array
	 *  @method  _fnOrderColumns
	 *  @param   array a An array of integers which dictate the column order that should be applied
	 *  @returns void
	 *  @private
	 */
	"_fnOrderColumns": function ( a )
	{
		var changed = false;

		if ( a.length != this.s.dt.aoColumns.length )
		{
			this.s.dt.oInstance.oApi._fnLog( this.s.dt, 1, "ColReorder - array reorder does not "+
				"match known number of columns. Skipping." );
			return;
		}

		for ( var i=0, iLen=a.length ; i<iLen ; i++ )
		{
			var currIndex = $.inArray( i, a );
			if ( i != currIndex )
			{
				/* Reorder our switching array */
				fnArraySwitch( a, currIndex, i );

				/* Do the column reorder in the table */
				this.s.dt.oInstance.fnColReorder( currIndex, i, true, false );

				changed = true;
			}
		}

		this._fnSetColumnIndexes();

		// Has anything actually changed? If not, then nothing else to do
		if ( ! changed ) {
			return;
		}

		$.fn.dataTable.Api( this.s.dt ).rows().invalidate();

		/* When scrolling we need to recalculate the column sizes to allow for the shift */
		if ( this.s.dt.oScroll.sX !== "" || this.s.dt.oScroll.sY !== "" )
		{
			this.s.dt.oInstance.fnAdjustColumnSizing( false );
		}

		/* Save the state */
		this.s.dt.oInstance.oApi._fnSaveState( this.s.dt );

		if ( this.s.reorderCallback !== null )
		{
			this.s.reorderCallback.call( this );
		}
	},


	/**
	 * Because we change the indexes of columns in the table, relative to their starting point
	 * we need to reorder the state columns to what they are at the starting point so we can
	 * then rearrange them again on state load!
	 *  @method  _fnStateSave
	 *  @param   object oState DataTables state
	 *  @returns string JSON encoded cookie string for DataTables
	 *  @private
	 */
	"_fnStateSave": function ( oState )
	{
		var i, iLen, aCopy, iOrigColumn;
		var oSettings = this.s.dt;
		var columns = oSettings.aoColumns;

		oState.ColReorder = [];

		/* Sorting */
		if ( oState.aaSorting ) {
			// 1.10.0-
			for ( i=0 ; i<oState.aaSorting.length ; i++ ) {
				oState.aaSorting[i][0] = columns[ oState.aaSorting[i][0] ]._ColReorder_iOrigCol;
			}

			var aSearchCopy = $.extend( true, [], oState.aoSearchCols );

			for ( i=0, iLen=columns.length ; i<iLen ; i++ )
			{
				iOrigColumn = columns[i]._ColReorder_iOrigCol;

				/* Column filter */
				oState.aoSearchCols[ iOrigColumn ] = aSearchCopy[i];

				/* Visibility */
				oState.abVisCols[ iOrigColumn ] = columns[i].bVisible;

				/* Column reordering */
				oState.ColReorder.push( iOrigColumn );
			}
		}
		else if ( oState.order ) {
			// 1.10.1+
			for ( i=0 ; i<oState.order.length ; i++ ) {
				oState.order[i][0] = columns[ oState.order[i][0] ]._ColReorder_iOrigCol;
			}

			var stateColumnsCopy = $.extend( true, [], oState.columns );

			for ( i=0, iLen=columns.length ; i<iLen ; i++ )
			{
				iOrigColumn = columns[i]._ColReorder_iOrigCol;

				/* Columns */
				oState.columns[ iOrigColumn ] = stateColumnsCopy[i];

				/* Column reordering */
				oState.ColReorder.push( iOrigColumn );
			}
		}
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Mouse drop and drag
	 */

	/**
	 * Add a mouse down listener to a particluar TH element
	 *  @method  _fnMouseListener
	 *  @param   int i Column index
	 *  @param   element nTh TH element clicked on
	 *  @returns void
	 *  @private
	 */
	"_fnMouseListener": function ( i, nTh )
	{
		var that = this;
		$(nTh)
			.on( 'mousedown.ColReorder', function (e) {
				if ( that.s.enable ) {
					that._fnMouseDown.call( that, e, nTh );
				}
			} )
			.on( 'touchstart.ColReorder', function (e) {
				if ( that.s.enable ) {
					that._fnMouseDown.call( that, e, nTh );
				}
			} );
	},


	/**
	 * Mouse down on a TH element in the table header
	 *  @method  _fnMouseDown
	 *  @param   event e Mouse event
	 *  @param   element nTh TH element to be dragged
	 *  @returns void
	 *  @private
	 */
	"_fnMouseDown": function ( e, nTh )
	{
		var that = this;

		/* Store information about the mouse position */
		var target = $(e.target).closest('th, td');
		var offset = target.offset();
		var idx = parseInt( $(nTh).attr('data-column-index'), 10 );

		if ( idx === undefined ) {
			return;
		}

		this.s.mouse.startX = this._fnCursorPosition( e, 'pageX' );
		this.s.mouse.startY = this._fnCursorPosition( e, 'pageY' );
		this.s.mouse.offsetX = this._fnCursorPosition( e, 'pageX' ) - offset.left;
		this.s.mouse.offsetY = this._fnCursorPosition( e, 'pageY' ) - offset.top;
		this.s.mouse.target = this.s.dt.aoColumns[ idx ].nTh;//target[0];
		this.s.mouse.targetIndex = idx;
		this.s.mouse.fromIndex = idx;

		this._fnRegions();

		/* Add event handlers to the document */
		$(document)
			.on( 'mousemove.ColReorder touchmove.ColReorder', function (e) {
				that._fnMouseMove.call( that, e );
			} )
			.on( 'mouseup.ColReorder touchend.ColReorder', function (e) {
				that._fnMouseUp.call( that, e );
			} );
	},


	/**
	 * Deal with a mouse move event while dragging a node
	 *  @method  _fnMouseMove
	 *  @param   event e Mouse event
	 *  @returns void
	 *  @private
	 */
	"_fnMouseMove": function ( e )
	{
		var that = this;

		if ( this.dom.drag === null )
		{
			/* Only create the drag element if the mouse has moved a specific distance from the start
			 * point - this allows the user to make small mouse movements when sorting and not have a
			 * possibly confusing drag element showing up
			 */
			if ( Math.pow(
				Math.pow(this._fnCursorPosition( e, 'pageX') - this.s.mouse.startX, 2) +
				Math.pow(this._fnCursorPosition( e, 'pageY') - this.s.mouse.startY, 2), 0.5 ) < 5 )
			{
				return;
			}
			this._fnCreateDragNode();
		}

		/* Position the element - we respect where in the element the click occured */
		this.dom.drag.css( {
			left: this._fnCursorPosition( e, 'pageX' ) - this.s.mouse.offsetX,
			top: this._fnCursorPosition( e, 'pageY' ) - this.s.mouse.offsetY
		} );

		/* Based on the current mouse position, calculate where the insert should go */
		var bSet = false;
		var lastToIndex = this.s.mouse.toIndex;

		for ( var i=1, iLen=this.s.aoTargets.length ; i<iLen ; i++ )
		{
			if ( this._fnCursorPosition(e, 'pageX') < this.s.aoTargets[i-1].x + ((this.s.aoTargets[i].x-this.s.aoTargets[i-1].x)/2) )
			{
				this.dom.pointer.css( 'left', this.s.aoTargets[i-1].x );
				this.s.mouse.toIndex = this.s.aoTargets[i-1].to;
				bSet = true;
				break;
			}
		}

		// The insert element wasn't positioned in the array (less than
		// operator), so we put it at the end
		if ( !bSet )
		{
			this.dom.pointer.css( 'left', this.s.aoTargets[this.s.aoTargets.length-1].x );
			this.s.mouse.toIndex = this.s.aoTargets[this.s.aoTargets.length-1].to;
		}

		// Perform reordering if realtime updating is on and the column has moved
		if ( this.s.init.bRealtime && lastToIndex !== this.s.mouse.toIndex ) {
			this.s.dt.oInstance.fnColReorder( this.s.mouse.fromIndex, this.s.mouse.toIndex );
			this.s.mouse.fromIndex = this.s.mouse.toIndex;

			// Not great for performance, but required to keep everything in alignment
			if ( this.s.dt.oScroll.sX !== "" || this.s.dt.oScroll.sY !== "" )
			{
				this.s.dt.oInstance.fnAdjustColumnSizing( false );
			}

			this._fnRegions();
		}
	},


	/**
	 * Finish off the mouse drag and insert the column where needed
	 *  @method  _fnMouseUp
	 *  @param   event e Mouse event
	 *  @returns void
	 *  @private
	 */
	"_fnMouseUp": function ( e )
	{
		var that = this;

		$(document).off( '.ColReorder' );

		if ( this.dom.drag !== null )
		{
			/* Remove the guide elements */
			this.dom.drag.remove();
			this.dom.pointer.remove();
			this.dom.drag = null;
			this.dom.pointer = null;

			/* Actually do the reorder */
			this.s.dt.oInstance.fnColReorder( this.s.mouse.fromIndex, this.s.mouse.toIndex, true );
			this._fnSetColumnIndexes();

			/* When scrolling we need to recalculate the column sizes to allow for the shift */
			if ( this.s.dt.oScroll.sX !== "" || this.s.dt.oScroll.sY !== "" )
			{
				this.s.dt.oInstance.fnAdjustColumnSizing( false );
			}

			/* Save the state */
			this.s.dt.oInstance.oApi._fnSaveState( this.s.dt );

			if ( this.s.reorderCallback !== null )
			{
				this.s.reorderCallback.call( this );
			}
		}
	},


	/**
	 * Calculate a cached array with the points of the column inserts, and the
	 * 'to' points
	 *  @method  _fnRegions
	 *  @returns void
	 *  @private
	 */
	"_fnRegions": function ()
	{
		var aoColumns = this.s.dt.aoColumns;

		this.s.aoTargets.splice( 0, this.s.aoTargets.length );

		this.s.aoTargets.push( {
			"x":  $(this.s.dt.nTable).offset().left,
			"to": 0
		} );

		var iToPoint = 0;
		var total = this.s.aoTargets[0].x;

		for ( var i=0, iLen=aoColumns.length ; i<iLen ; i++ )
		{
			/* For the column / header in question, we want it's position to remain the same if the
			 * position is just to it's immediate left or right, so we only increment the counter for
			 * other columns
			 */
			if ( i != this.s.mouse.fromIndex )
			{
				iToPoint++;
			}

			if ( aoColumns[i].bVisible && aoColumns[i].nTh.style.display !=='none' )
			{
				total += $(aoColumns[i].nTh).outerWidth();

				this.s.aoTargets.push( {
					"x":  total,
					"to": iToPoint
				} );
			}
		}

		/* Disallow columns for being reordered by drag and drop, counting right to left */
		if ( this.s.fixedRight !== 0 )
		{
			this.s.aoTargets.splice( this.s.aoTargets.length - this.s.fixedRight );
		}

		/* Disallow columns for being reordered by drag and drop, counting left to right */
		if ( this.s.fixed !== 0 )
		{
			this.s.aoTargets.splice( 0, this.s.fixed );
		}
	},


	/**
	 * Copy the TH element that is being drags so the user has the idea that they are actually
	 * moving it around the page.
	 *  @method  _fnCreateDragNode
	 *  @returns void
	 *  @private
	 */
	"_fnCreateDragNode": function ()
	{
		var scrolling = this.s.dt.oScroll.sX !== "" || this.s.dt.oScroll.sY !== "";

		var origCell = this.s.dt.aoColumns[ this.s.mouse.targetIndex ].nTh;
		var origTr = origCell.parentNode;
		var origThead = origTr.parentNode;
		var origTable = origThead.parentNode;
		var cloneCell = $(origCell).clone();

		// This is a slightly odd combination of jQuery and DOM, but it is the
		// fastest and least resource intensive way I could think of cloning
		// the table with just a single header cell in it.
		this.dom.drag = $(origTable.cloneNode(false))
			.addClass( 'DTCR_clonedTable' )
			.append(
				$(origThead.cloneNode(false)).append(
					$(origTr.cloneNode(false)).append(
						cloneCell[0]
					)
				)
			)
			.css( {
				position: 'absolute',
				top: 0,
				left: 0,
				width: $(origCell).outerWidth(),
				height: $(origCell).outerHeight()
			} )
			.appendTo( 'body' );

		this.dom.pointer = $('<div></div>')
			.addClass( 'DTCR_pointer' )
			.css( {
				position: 'absolute',
				top: scrolling ?
					$('div.dataTables_scroll', this.s.dt.nTableWrapper).offset().top :
					$(this.s.dt.nTable).offset().top,
				height : scrolling ?
					$('div.dataTables_scroll', this.s.dt.nTableWrapper).height() :
					$(this.s.dt.nTable).height()
			} )
			.appendTo( 'body' );
	},


	/**
	 * Add a data attribute to the column headers, so we know the index of
	 * the row to be reordered. This allows fast detection of the index, and
	 * for this plug-in to work with FixedHeader which clones the nodes.
	 *  @private
	 */
	"_fnSetColumnIndexes": function ()
	{
		$.each( this.s.dt.aoColumns, function (i, column) {
			$(column.nTh).attr('data-column-index', i);
		} );
	},


	/**
	 * Get cursor position regardless of mouse or touch input
	 * @param  {Event}  e    jQuery Event
	 * @param  {string} prop Property to get
	 * @return {number}      Value
	 */
	_fnCursorPosition: function ( e, prop ) {
		if ( e.type.indexOf('touch') !== -1 ) {
			return e.originalEvent.touches[0][ prop ];
		}
		return e[ prop ];
	}
} );





/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Static parameters
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */


/**
 * ColReorder default settings for initialisation
 *  @namespace
 *  @static
 */
ColReorder.defaults = {
	/**
	 * Predefined ordering for the columns that will be applied automatically
	 * on initialisation. If not specified then the order that the columns are
	 * found to be in the HTML is the order used.
	 *  @type array
	 *  @default null
	 *  @static
	 */
	aiOrder: null,

	/**
	 * ColReorder enable on initialisation
	 *  @type boolean
	 *  @default true
	 *  @static
	 */
	bEnable: true,

	/**
	 * Redraw the table's column ordering as the end user draws the column
	 * (`true`) or wait until the mouse is released (`false` - default). Note
	 * that this will perform a redraw on each reordering, which involves an
	 * Ajax request each time if you are using server-side processing in
	 * DataTables.
	 *  @type boolean
	 *  @default false
	 *  @static
	 */
	bRealtime: true,

	/**
	 * Indicate how many columns should be fixed in position (counting from the
	 * left). This will typically be 1 if used, but can be as high as you like.
	 *  @type int
	 *  @default 0
	 *  @static
	 */
	iFixedColumnsLeft: 0,

	/**
	 * As `iFixedColumnsRight` but counting from the right.
	 *  @type int
	 *  @default 0
	 *  @static
	 */
	iFixedColumnsRight: 0,

	/**
	 * Callback function that is fired when columns are reordered. The `column-
	 * reorder` event is preferred over this callback
	 *  @type function():void
	 *  @default null
	 *  @static
	 */
	fnReorderCallback: null
};



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Constants
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/**
 * ColReorder version
 *  @constant  version
 *  @type      String
 *  @default   As code
 */
ColReorder.version = "1.5.1";



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables interfaces
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

// Expose
$.fn.dataTable.ColReorder = ColReorder;
$.fn.DataTable.ColReorder = ColReorder;


// Register a new feature with DataTables
if ( typeof $.fn.dataTable == "function" &&
     typeof $.fn.dataTableExt.fnVersionCheck == "function" &&
     $.fn.dataTableExt.fnVersionCheck('1.10.8') )
{
	$.fn.dataTableExt.aoFeatures.push( {
		"fnInit": function( settings ) {
			var table = settings.oInstance;

			if ( ! settings._colReorder ) {
				var dtInit = settings.oInit;
				var opts = dtInit.colReorder || dtInit.oColReorder || {};

				new ColReorder( settings, opts );
			}
			else {
				table.oApi._fnLog( settings, 1, "ColReorder attempted to initialise twice. Ignoring second" );
			}

			return null; /* No node for DataTables to insert */
		},
		"cFeature": "R",
		"sFeature": "ColReorder"
	} );
}
else {
	alert( "Warning: ColReorder requires DataTables 1.10.8 or greater - www.datatables.net/download");
}


// Attach a listener to the document which listens for DataTables initialisation
// events so we can automatically initialise
$(document).on( 'preInit.dt.colReorder', function (e, settings) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	var init = settings.oInit.colReorder;
	var defaults = DataTable.defaults.colReorder;

	if ( init || defaults ) {
		var opts = $.extend( {}, init, defaults );

		if ( init !== false ) {
			new ColReorder( settings, opts  );
		}
	}
} );


// API augmentation
$.fn.dataTable.Api.register( 'colReorder.reset()', function () {
	return this.iterator( 'table', function ( ctx ) {
		ctx._colReorder.fnReset();
	} );
} );

$.fn.dataTable.Api.register( 'colReorder.order()', function ( set, original ) {
	if ( set ) {
		return this.iterator( 'table', function ( ctx ) {
			ctx._colReorder.fnOrder( set, original );
		} );
	}

	return this.context.length ?
		this.context[0]._colReorder.fnOrder() :
		null;
} );

$.fn.dataTable.Api.register( 'colReorder.transpose()', function ( idx, dir ) {
	return this.context.length && this.context[0]._colReorder ?
		this.context[0]._colReorder.fnTranspose( idx, dir ) :
		idx;
} );

$.fn.dataTable.Api.register( 'colReorder.move()', function( from, to, drop, invalidateRows ) {
	if (this.context.length) {
		this.context[0]._colReorder.s.dt.oInstance.fnColReorder( from, to, drop, invalidateRows );
	}
	return this;
} );

$.fn.dataTable.Api.register( 'colReorder.enable()', function( flag ) {
	return this.iterator( 'table', function ( ctx ) {
		if ( ctx._colReorder ) {
			ctx._colReorder.fnEnable( flag );
		}
	} );
} );

$.fn.dataTable.Api.register( 'colReorder.disable()', function() {
	return this.iterator( 'table', function ( ctx ) {
		if ( ctx._colReorder ) {
			ctx._colReorder.fnDisable();
		}
	} );
} );


return ColReorder;
}));


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! FixedColumns 3.2.6
 * ©2010-2018 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     FixedColumns
 * @description Freeze columns in place on a scrolling DataTable
 * @version     3.2.6
 * @file        dataTables.fixedColumns.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     www.sprymedia.co.uk/contact
 * @copyright   Copyright 2010-2018 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */
(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;
var _firefoxScroll;

/**
 * When making use of DataTables' x-axis scrolling feature, you may wish to
 * fix the left most column in place. This plug-in for DataTables provides
 * exactly this option (note for non-scrolling tables, please use the
 * FixedHeader plug-in, which can fix headers and footers). Key
 * features include:
 *
 * * Freezes the left or right most columns to the side of the table
 * * Option to freeze two or more columns
 * * Full integration with DataTables' scrolling options
 * * Speed - FixedColumns is fast in its operation
 *
 *  @class
 *  @constructor
 *  @global
 *  @param {object} dt DataTables instance. With DataTables 1.10 this can also
 *    be a jQuery collection, a jQuery selector, DataTables API instance or
 *    settings object.
 *  @param {object} [init={}] Configuration object for FixedColumns. Options are
 *    defined by {@link FixedColumns.defaults}
 *
 *  @requires jQuery 1.7+
 *  @requires DataTables 1.8.0+
 *
 *  @example
 *      var table = $('#example').dataTable( {
 *        "scrollX": "100%"
 *      } );
 *      new $.fn.dataTable.fixedColumns( table );
 */
var FixedColumns = function ( dt, init ) {
	var that = this;

	/* Sanity check - you just know it will happen */
	if ( ! ( this instanceof FixedColumns ) ) {
		alert( "FixedColumns warning: FixedColumns must be initialised with the 'new' keyword." );
		return;
	}

	if ( init === undefined || init === true ) {
		init = {};
	}

	// Use the DataTables Hungarian notation mapping method, if it exists to
	// provide forwards compatibility for camel case variables
	var camelToHungarian = $.fn.dataTable.camelToHungarian;
	if ( camelToHungarian ) {
		camelToHungarian( FixedColumns.defaults, FixedColumns.defaults, true );
		camelToHungarian( FixedColumns.defaults, init );
	}

	// v1.10 allows the settings object to be got form a number of sources
	var dtSettings = new $.fn.dataTable.Api( dt ).settings()[0];

	/**
	 * Settings object which contains customisable information for FixedColumns instance
	 * @namespace
	 * @extends FixedColumns.defaults
	 * @private
	 */
	this.s = {
		/**
		 * DataTables settings objects
		 *  @type     object
		 *  @default  Obtained from DataTables instance
		 */
		"dt": dtSettings,

		/**
		 * Number of columns in the DataTable - stored for quick access
		 *  @type     int
		 *  @default  Obtained from DataTables instance
		 */
		"iTableColumns": dtSettings.aoColumns.length,

		/**
		 * Original outer widths of the columns as rendered by DataTables - used to calculate
		 * the FixedColumns grid bounding box
		 *  @type     array.<int>
		 *  @default  []
		 */
		"aiOuterWidths": [],

		/**
		 * Original inner widths of the columns as rendered by DataTables - used to apply widths
		 * to the columns
		 *  @type     array.<int>
		 *  @default  []
		 */
		"aiInnerWidths": [],


		/**
		 * Is the document layout right-to-left
		 * @type boolean
		 */
		rtl: $(dtSettings.nTable).css('direction') === 'rtl'
	};


	/**
	 * DOM elements used by the class instance
	 * @namespace
	 * @private
	 *
	 */
	this.dom = {
		/**
		 * DataTables scrolling element
		 *  @type     node
		 *  @default  null
		 */
		"scroller": null,

		/**
		 * DataTables header table
		 *  @type     node
		 *  @default  null
		 */
		"header": null,

		/**
		 * DataTables body table
		 *  @type     node
		 *  @default  null
		 */
		"body": null,

		/**
		 * DataTables footer table
		 *  @type     node
		 *  @default  null
		 */
		"footer": null,

		/**
		 * Display grid elements
		 * @namespace
		 */
		"grid": {
			/**
			 * Grid wrapper. This is the container element for the 3x3 grid
			 *  @type     node
			 *  @default  null
			 */
			"wrapper": null,

			/**
			 * DataTables scrolling element. This element is the DataTables
			 * component in the display grid (making up the main table - i.e.
			 * not the fixed columns).
			 *  @type     node
			 *  @default  null
			 */
			"dt": null,

			/**
			 * Left fixed column grid components
			 * @namespace
			 */
			"left": {
				"wrapper": null,
				"head": null,
				"body": null,
				"foot": null
			},

			/**
			 * Right fixed column grid components
			 * @namespace
			 */
			"right": {
				"wrapper": null,
				"head": null,
				"body": null,
				"foot": null
			}
		},

		/**
		 * Cloned table nodes
		 * @namespace
		 */
		"clone": {
			/**
			 * Left column cloned table nodes
			 * @namespace
			 */
			"left": {
				/**
				 * Cloned header table
				 *  @type     node
				 *  @default  null
				 */
				"header": null,

				/**
				 * Cloned body table
				 *  @type     node
				 *  @default  null
				 */
				"body": null,

				/**
				 * Cloned footer table
				 *  @type     node
				 *  @default  null
				 */
				"footer": null
			},

			/**
			 * Right column cloned table nodes
			 * @namespace
			 */
			"right": {
				/**
				 * Cloned header table
				 *  @type     node
				 *  @default  null
				 */
				"header": null,

				/**
				 * Cloned body table
				 *  @type     node
				 *  @default  null
				 */
				"body": null,

				/**
				 * Cloned footer table
				 *  @type     node
				 *  @default  null
				 */
				"footer": null
			}
		}
	};

	if ( dtSettings._oFixedColumns ) {
		throw 'FixedColumns already initialised on this table';
	}

	/* Attach the instance to the DataTables instance so it can be accessed easily */
	dtSettings._oFixedColumns = this;

	/* Let's do it */
	if ( ! dtSettings._bInitComplete )
	{
		dtSettings.oApi._fnCallbackReg( dtSettings, 'aoInitComplete', function () {
			that._fnConstruct( init );
		}, 'FixedColumns' );
	}
	else
	{
		this._fnConstruct( init );
	}
};



$.extend( FixedColumns.prototype , {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Public methods
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

	/**
	 * Update the fixed columns - including headers and footers. Note that FixedColumns will
	 * automatically update the display whenever the host DataTable redraws.
	 *  @returns {void}
	 *  @example
	 *      var table = $('#example').dataTable( {
	 *          "scrollX": "100%"
	 *      } );
	 *      var fc = new $.fn.dataTable.fixedColumns( table );
	 *
	 *      // at some later point when the table has been manipulated....
	 *      fc.fnUpdate();
	 */
	"fnUpdate": function ()
	{
		this._fnDraw( true );
	},


	/**
	 * Recalculate the resizes of the 3x3 grid that FixedColumns uses for display of the table.
	 * This is useful if you update the width of the table container. Note that FixedColumns will
	 * perform this function automatically when the window.resize event is fired.
	 *  @returns {void}
	 *  @example
	 *      var table = $('#example').dataTable( {
	 *          "scrollX": "100%"
	 *      } );
	 *      var fc = new $.fn.dataTable.fixedColumns( table );
	 *
	 *      // Resize the table container and then have FixedColumns adjust its layout....
	 *      $('#content').width( 1200 );
	 *      fc.fnRedrawLayout();
	 */
	"fnRedrawLayout": function ()
	{
		this._fnColCalc();
		this._fnGridLayout();
		this.fnUpdate();
	},


	/**
	 * Mark a row such that it's height should be recalculated when using 'semiauto' row
	 * height matching. This function will have no effect when 'none' or 'auto' row height
	 * matching is used.
	 *  @param   {Node} nTr TR element that should have it's height recalculated
	 *  @returns {void}
	 *  @example
	 *      var table = $('#example').dataTable( {
	 *          "scrollX": "100%"
	 *      } );
	 *      var fc = new $.fn.dataTable.fixedColumns( table );
	 *
	 *      // manipulate the table - mark the row as needing an update then update the table
	 *      // this allows the redraw performed by DataTables fnUpdate to recalculate the row
	 *      // height
	 *      fc.fnRecalculateHeight();
	 *      table.fnUpdate( $('#example tbody tr:eq(0)')[0], ["insert date", 1, 2, 3 ... ]);
	 */
	"fnRecalculateHeight": function ( nTr )
	{
		delete nTr._DTTC_iHeight;
		nTr.style.height = 'auto';
	},


	/**
	 * Set the height of a given row - provides cross browser compatibility
	 *  @param   {Node} nTarget TR element that should have it's height recalculated
	 *  @param   {int} iHeight Height in pixels to set
	 *  @returns {void}
	 *  @example
	 *      var table = $('#example').dataTable( {
	 *          "scrollX": "100%"
	 *      } );
	 *      var fc = new $.fn.dataTable.fixedColumns( table );
	 *
	 *      // You may want to do this after manipulating a row in the fixed column
	 *      fc.fnSetRowHeight( $('#example tbody tr:eq(0)')[0], 50 );
	 */
	"fnSetRowHeight": function ( nTarget, iHeight )
	{
		nTarget.style.height = iHeight+"px";
	},


	/**
	 * Get data index information about a row or cell in the table body.
	 * This function is functionally identical to fnGetPosition in DataTables,
	 * taking the same parameter (TH, TD or TR node) and returning exactly the
	 * the same information (data index information). THe difference between
	 * the two is that this method takes into account the fixed columns in the
	 * table, so you can pass in nodes from the master table, or the cloned
	 * tables and get the index position for the data in the main table.
	 *  @param {node} node TR, TH or TD element to get the information about
	 *  @returns {int} If nNode is given as a TR, then a single index is 
	 *    returned, or if given as a cell, an array of [row index, column index
	 *    (visible), column index (all)] is given.
	 */
	"fnGetPosition": function ( node )
	{
		var idx;
		var inst = this.s.dt.oInstance;

		if ( ! $(node).parents('.DTFC_Cloned').length )
		{
			// Not in a cloned table
			return inst.fnGetPosition( node );
		}
		else
		{
			// Its in the cloned table, so need to look up position
			if ( node.nodeName.toLowerCase() === 'tr' ) {
				idx = $(node).index();
				return inst.fnGetPosition( $('tr', this.s.dt.nTBody)[ idx ] );
			}
			else
			{
				var colIdx = $(node).index();
				idx = $(node.parentNode).index();
				var row = inst.fnGetPosition( $('tr', this.s.dt.nTBody)[ idx ] );

				return [
					row,
					colIdx,
					inst.oApi._fnVisibleToColumnIndex( this.s.dt, colIdx )
				];
			}
		}
	},



	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods (they are of course public in JS, but recommended as private)
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

	/**
	 * Initialisation for FixedColumns
	 *  @param   {Object} oInit User settings for initialisation
	 *  @returns {void}
	 *  @private
	 */
	"_fnConstruct": function ( oInit )
	{
		var i, iLen, iWidth,
			that = this;

		/* Sanity checking */
		if ( typeof this.s.dt.oInstance.fnVersionCheck != 'function' ||
		     this.s.dt.oInstance.fnVersionCheck( '1.8.0' ) !== true )
		{
			alert( "FixedColumns "+FixedColumns.VERSION+" required DataTables 1.8.0 or later. "+
				"Please upgrade your DataTables installation" );
			return;
		}

		if ( this.s.dt.oScroll.sX === "" )
		{
			this.s.dt.oInstance.oApi._fnLog( this.s.dt, 1, "FixedColumns is not needed (no "+
				"x-scrolling in DataTables enabled), so no action will be taken. Use 'FixedHeader' for "+
				"column fixing when scrolling is not enabled" );
			return;
		}

		/* Apply the settings from the user / defaults */
		this.s = $.extend( true, this.s, FixedColumns.defaults, oInit );

		/* Set up the DOM as we need it and cache nodes */
		var classes = this.s.dt.oClasses;
		this.dom.grid.dt = $(this.s.dt.nTable).parents('div.'+classes.sScrollWrapper)[0];
		this.dom.scroller = $('div.'+classes.sScrollBody, this.dom.grid.dt )[0];

		/* Set up the DOM that we want for the fixed column layout grid */
		this._fnColCalc();
		this._fnGridSetup();

		/* Event handlers */
		var mouseController;
		var mouseDown = false;

		// When the mouse is down (drag scroll) the mouse controller cannot
		// change, as the browser keeps the original element as the scrolling one
		$(this.s.dt.nTableWrapper).on( 'mousedown.DTFC', function (e) {
			if ( e.button === 0 ) {
				mouseDown = true;

				$(document).one( 'mouseup', function () {
					mouseDown = false;
				} );
			}
		} );

		// When the body is scrolled - scroll the left and right columns
		$(this.dom.scroller)
			.on( 'mouseover.DTFC touchstart.DTFC', function () {
				if ( ! mouseDown ) {
					mouseController = 'main';
				}
			} )
			.on( 'scroll.DTFC', function (e) {
				if ( ! mouseController && e.originalEvent ) {
					mouseController = 'main';
				}

				if ( mouseController === 'main' ) {
					if ( that.s.iLeftColumns > 0 ) {
						that.dom.grid.left.liner.scrollTop = that.dom.scroller.scrollTop;
					}
					if ( that.s.iRightColumns > 0 ) {
						that.dom.grid.right.liner.scrollTop = that.dom.scroller.scrollTop;
					}
				}
			} );

		var wheelType = 'onwheel' in document.createElement('div') ?
			'wheel.DTFC' :
			'mousewheel.DTFC';

		if ( that.s.iLeftColumns > 0 ) {
			// When scrolling the left column, scroll the body and right column
			$(that.dom.grid.left.liner)
				.on( 'mouseover.DTFC touchstart.DTFC', function () {
					if ( ! mouseDown ) {
						mouseController = 'left';
					}
				} )
				.on( 'scroll.DTFC', function ( e ) {
					if ( ! mouseController && e.originalEvent ) {
						mouseController = 'left';
					}

					if ( mouseController === 'left' ) {
						that.dom.scroller.scrollTop = that.dom.grid.left.liner.scrollTop;
						if ( that.s.iRightColumns > 0 ) {
							that.dom.grid.right.liner.scrollTop = that.dom.grid.left.liner.scrollTop;
						}
					}
				} )
				.on( wheelType, function(e) {
					// Pass horizontal scrolling through
					var xDelta = e.type === 'wheel' ?
						-e.originalEvent.deltaX :
						e.originalEvent.wheelDeltaX;
					that.dom.scroller.scrollLeft -= xDelta;
				} );
		}

		if ( that.s.iRightColumns > 0 ) {
			// When scrolling the right column, scroll the body and the left column
			$(that.dom.grid.right.liner)
				.on( 'mouseover.DTFC touchstart.DTFC', function () {
					if ( ! mouseDown ) {
						mouseController = 'right';
					}
				} )
				.on( 'scroll.DTFC', function ( e ) {
					if ( ! mouseController && e.originalEvent ) {
						mouseController = 'right';
					}

					if ( mouseController === 'right' ) {
						that.dom.scroller.scrollTop = that.dom.grid.right.liner.scrollTop;
						if ( that.s.iLeftColumns > 0 ) {
							that.dom.grid.left.liner.scrollTop = that.dom.grid.right.liner.scrollTop;
						}
					}
				} )
				.on( wheelType, function(e) {
					// Pass horizontal scrolling through
					var xDelta = e.type === 'wheel' ?
						-e.originalEvent.deltaX :
						e.originalEvent.wheelDeltaX;
					that.dom.scroller.scrollLeft -= xDelta;
				} );
		}

		$(window).on( 'resize.DTFC', function () {
			that._fnGridLayout.call( that );
		} );

		var bFirstDraw = true;
		var jqTable = $(this.s.dt.nTable);

		jqTable
			.on( 'draw.dt.DTFC', function () {
				that._fnColCalc();
				that._fnDraw.call( that, bFirstDraw );
				bFirstDraw = false;
			} )
			.on( 'column-sizing.dt.DTFC', function () {
				that._fnColCalc();
				that._fnGridLayout( that );
			} )
			.on( 'column-visibility.dt.DTFC', function ( e, settings, column, vis, recalc ) {
				if ( recalc === undefined || recalc ) {
					that._fnColCalc();
					that._fnGridLayout( that );
					that._fnDraw( true );
				}
			} )
			.on( 'select.dt.DTFC deselect.dt.DTFC', function ( e, dt, type, indexes ) {
				if ( e.namespace === 'dt' ) {
					that._fnDraw( false );
				}
			} )
			.on( 'destroy.dt.DTFC', function () {
				jqTable.off( '.DTFC' );

				$(that.dom.scroller).off( '.DTFC' );
				$(window).off( '.DTFC' );
				$(that.s.dt.nTableWrapper).off( '.DTFC' );

				$(that.dom.grid.left.liner).off( '.DTFC '+wheelType );
				$(that.dom.grid.left.wrapper).remove();

				$(that.dom.grid.right.liner).off( '.DTFC '+wheelType );
				$(that.dom.grid.right.wrapper).remove();
			} );

		/* Get things right to start with - note that due to adjusting the columns, there must be
		 * another redraw of the main table. It doesn't need to be a full redraw however.
		 */
		this._fnGridLayout();
		this.s.dt.oInstance.fnDraw(false);
	},


	/**
	 * Calculate the column widths for the grid layout
	 *  @returns {void}
	 *  @private
	 */
	"_fnColCalc": function ()
	{
		var that = this;
		var iLeftWidth = 0;
		var iRightWidth = 0;

		this.s.aiInnerWidths = [];
		this.s.aiOuterWidths = [];

		$.each( this.s.dt.aoColumns, function (i, col) {
			var th = $(col.nTh);
			var border;

			if ( ! th.filter(':visible').length ) {
				that.s.aiInnerWidths.push( 0 );
				that.s.aiOuterWidths.push( 0 );
			}
			else
			{
				// Inner width is used to assign widths to cells
				// Outer width is used to calculate the container
				var iWidth = th.outerWidth();

				// When working with the left most-cell, need to add on the
				// table's border to the outerWidth, since we need to take
				// account of it, but it isn't in any cell
				if ( that.s.aiOuterWidths.length === 0 ) {
					border = $(that.s.dt.nTable).css('border-left-width');
					iWidth += typeof border === 'string' && border.indexOf('px') === -1 ?
						1 :
						parseInt( border, 10 );
				}

				// Likewise with the final column on the right
				if ( that.s.aiOuterWidths.length === that.s.dt.aoColumns.length-1 ) {
					border = $(that.s.dt.nTable).css('border-right-width');
					iWidth += typeof border === 'string' && border.indexOf('px') === -1 ?
						1 :
						parseInt( border, 10 );
				}

				that.s.aiOuterWidths.push( iWidth );
				that.s.aiInnerWidths.push( th.width() );

				if ( i < that.s.iLeftColumns )
				{
					iLeftWidth += iWidth;
				}

				if ( that.s.iTableColumns-that.s.iRightColumns <= i )
				{
					iRightWidth += iWidth;
				}
			}
		} );

		this.s.iLeftWidth = iLeftWidth;
		this.s.iRightWidth = iRightWidth;
	},


	/**
	 * Set up the DOM for the fixed column. The way the layout works is to create a 1x3 grid
	 * for the left column, the DataTable (for which we just reuse the scrolling element DataTable
	 * puts into the DOM) and the right column. In each of he two fixed column elements there is a
	 * grouping wrapper element and then a head, body and footer wrapper. In each of these we then
	 * place the cloned header, body or footer tables. This effectively gives as 3x3 grid structure.
	 *  @returns {void}
	 *  @private
	 */
	"_fnGridSetup": function ()
	{
		var that = this;
		var oOverflow = this._fnDTOverflow();
		var block;

		this.dom.body = this.s.dt.nTable;
		this.dom.header = this.s.dt.nTHead.parentNode;
		this.dom.header.parentNode.parentNode.style.position = "relative";

		var nSWrapper =
			$('<div class="DTFC_ScrollWrapper" style="position:relative; clear:both;">'+
				'<div class="DTFC_LeftWrapper" style="position:absolute; top:0; left:0;" aria-hidden="true">'+
					'<div class="DTFC_LeftHeadWrapper" style="position:relative; top:0; left:0; overflow:hidden;"></div>'+
					'<div class="DTFC_LeftBodyWrapper" style="position:relative; top:0; left:0; overflow:hidden;">'+
						'<div class="DTFC_LeftBodyLiner" style="position:relative; top:0; left:0; overflow-y:scroll;"></div>'+
					'</div>'+
					'<div class="DTFC_LeftFootWrapper" style="position:relative; top:0; left:0; overflow:hidden;"></div>'+
				'</div>'+
				'<div class="DTFC_RightWrapper" style="position:absolute; top:0; right:0;" aria-hidden="true">'+
					'<div class="DTFC_RightHeadWrapper" style="position:relative; top:0; left:0;">'+
						'<div class="DTFC_RightHeadBlocker DTFC_Blocker" style="position:absolute; top:0; bottom:0;"></div>'+
					'</div>'+
					'<div class="DTFC_RightBodyWrapper" style="position:relative; top:0; left:0; overflow:hidden;">'+
						'<div class="DTFC_RightBodyLiner" style="position:relative; top:0; left:0; overflow-y:scroll;"></div>'+
					'</div>'+
					'<div class="DTFC_RightFootWrapper" style="position:relative; top:0; left:0;">'+
						'<div class="DTFC_RightFootBlocker DTFC_Blocker" style="position:absolute; top:0; bottom:0;"></div>'+
					'</div>'+
				'</div>'+
			'</div>')[0];
		var nLeft = nSWrapper.childNodes[0];
		var nRight = nSWrapper.childNodes[1];

		this.dom.grid.dt.parentNode.insertBefore( nSWrapper, this.dom.grid.dt );
		nSWrapper.appendChild( this.dom.grid.dt );

		this.dom.grid.wrapper = nSWrapper;

		if ( this.s.iLeftColumns > 0 )
		{
			this.dom.grid.left.wrapper = nLeft;
			this.dom.grid.left.head = nLeft.childNodes[0];
			this.dom.grid.left.body = nLeft.childNodes[1];
			this.dom.grid.left.liner = $('div.DTFC_LeftBodyLiner', nSWrapper)[0];

			nSWrapper.appendChild( nLeft );
		}

		if ( this.s.iRightColumns > 0 )
		{
			this.dom.grid.right.wrapper = nRight;
			this.dom.grid.right.head = nRight.childNodes[0];
			this.dom.grid.right.body = nRight.childNodes[1];
			this.dom.grid.right.liner = $('div.DTFC_RightBodyLiner', nSWrapper)[0];

			nRight.style.right = oOverflow.bar+"px";

			block = $('div.DTFC_RightHeadBlocker', nSWrapper)[0];
			block.style.width = oOverflow.bar+"px";
			block.style.right = -oOverflow.bar+"px";
			this.dom.grid.right.headBlock = block;

			block = $('div.DTFC_RightFootBlocker', nSWrapper)[0];
			block.style.width = oOverflow.bar+"px";
			block.style.right = -oOverflow.bar+"px";
			this.dom.grid.right.footBlock = block;

			nSWrapper.appendChild( nRight );
		}

		if ( this.s.dt.nTFoot )
		{
			this.dom.footer = this.s.dt.nTFoot.parentNode;
			if ( this.s.iLeftColumns > 0 )
			{
				this.dom.grid.left.foot = nLeft.childNodes[2];
			}
			if ( this.s.iRightColumns > 0 )
			{
				this.dom.grid.right.foot = nRight.childNodes[2];
			}
		}

		// RTL support - swap the position of the left and right columns (#48)
		if ( this.s.rtl ) {
			$('div.DTFC_RightHeadBlocker', nSWrapper).css( {
				left: -oOverflow.bar+'px',
				right: ''
			} );
		}
	},


	/**
	 * Style and position the grid used for the FixedColumns layout
	 *  @returns {void}
	 *  @private
	 */
	"_fnGridLayout": function ()
	{
		var that = this;
		var oGrid = this.dom.grid;
		var iWidth = $(oGrid.wrapper).width();
		var iBodyHeight = this.s.dt.nTable.parentNode.offsetHeight;
		var iFullHeight = this.s.dt.nTable.parentNode.parentNode.offsetHeight;
		var oOverflow = this._fnDTOverflow();
		var iLeftWidth = this.s.iLeftWidth;
		var iRightWidth = this.s.iRightWidth;
		var rtl = $(this.dom.body).css('direction') === 'rtl';
		var wrapper;
		var scrollbarAdjust = function ( node, width ) {
			if ( ! oOverflow.bar ) {
				// If there is no scrollbar (Macs) we need to hide the auto scrollbar
				node.style.width = (width+20)+"px";
				node.style.paddingRight = "20px";
				node.style.boxSizing = "border-box";
			}
			else if ( that._firefoxScrollError() ) {
				// See the above function for why this is required
				if ( $(node).height() > 34 ) {
					node.style.width = (width+oOverflow.bar)+"px";
				}
			}
			else {
				// Otherwise just overflow by the scrollbar
				node.style.width = (width+oOverflow.bar)+"px";
			}
		};

		// When x scrolling - don't paint the fixed columns over the x scrollbar
		if ( oOverflow.x )
		{
			iBodyHeight -= oOverflow.bar;
		}

		oGrid.wrapper.style.height = iFullHeight+"px";

		if ( this.s.iLeftColumns > 0 )
		{
			wrapper = oGrid.left.wrapper;
			wrapper.style.width = iLeftWidth+'px';
			wrapper.style.height = '1px';

			// Swap the position of the left and right columns for rtl (#48)
			// This is always up against the edge, scrollbar on the far side
			if ( rtl ) {
				wrapper.style.left = '';
				wrapper.style.right = 0;
			}
			else {
				wrapper.style.left = 0;
				wrapper.style.right = '';
			}

			oGrid.left.body.style.height = iBodyHeight+"px";
			if ( oGrid.left.foot ) {
				oGrid.left.foot.style.top = (oOverflow.x ? oOverflow.bar : 0)+"px"; // shift footer for scrollbar
			}

			scrollbarAdjust( oGrid.left.liner, iLeftWidth );
			oGrid.left.liner.style.height = iBodyHeight+"px";
			oGrid.left.liner.style.maxHeight = iBodyHeight+"px";
		}

		if ( this.s.iRightColumns > 0 )
		{
			wrapper = oGrid.right.wrapper;
			wrapper.style.width = iRightWidth+'px';
			wrapper.style.height = '1px';

			// Need to take account of the vertical scrollbar
			if ( this.s.rtl ) {
				wrapper.style.left = oOverflow.y ? oOverflow.bar+'px' : 0;
				wrapper.style.right = '';
			}
			else {
				wrapper.style.left = '';
				wrapper.style.right = oOverflow.y ? oOverflow.bar+'px' : 0;
			}

			oGrid.right.body.style.height = iBodyHeight+"px";
			if ( oGrid.right.foot ) {
				oGrid.right.foot.style.top = (oOverflow.x ? oOverflow.bar : 0)+"px";
			}

			scrollbarAdjust( oGrid.right.liner, iRightWidth );
			oGrid.right.liner.style.height = iBodyHeight+"px";
			oGrid.right.liner.style.maxHeight = iBodyHeight+"px";

			oGrid.right.headBlock.style.display = oOverflow.y ? 'block' : 'none';
			oGrid.right.footBlock.style.display = oOverflow.y ? 'block' : 'none';
		}
	},


	/**
	 * Get information about the DataTable's scrolling state - specifically if the table is scrolling
	 * on either the x or y axis, and also the scrollbar width.
	 *  @returns {object} Information about the DataTables scrolling state with the properties:
	 *    'x', 'y' and 'bar'
	 *  @private
	 */
	"_fnDTOverflow": function ()
	{
		var nTable = this.s.dt.nTable;
		var nTableScrollBody = nTable.parentNode;
		var out = {
			"x": false,
			"y": false,
			"bar": this.s.dt.oScroll.iBarWidth
		};

		if ( nTable.offsetWidth > nTableScrollBody.clientWidth )
		{
			out.x = true;
		}

		if ( nTable.offsetHeight > nTableScrollBody.clientHeight )
		{
			out.y = true;
		}

		return out;
	},


	/**
	 * Clone and position the fixed columns
	 *  @returns {void}
	 *  @param   {Boolean} bAll Indicate if the header and footer should be updated as well (true)
	 *  @private
	 */
	"_fnDraw": function ( bAll )
	{
		this._fnGridLayout();
		this._fnCloneLeft( bAll );
		this._fnCloneRight( bAll );

		/* Draw callback function */
		if ( this.s.fnDrawCallback !== null )
		{
			this.s.fnDrawCallback.call( this, this.dom.clone.left, this.dom.clone.right );
		}

		/* Event triggering */
		$(this).trigger( 'draw.dtfc', {
			"leftClone": this.dom.clone.left,
			"rightClone": this.dom.clone.right
		} );
	},


	/**
	 * Clone the right columns
	 *  @returns {void}
	 *  @param   {Boolean} bAll Indicate if the header and footer should be updated as well (true)
	 *  @private
	 */
	"_fnCloneRight": function ( bAll )
	{
		if ( this.s.iRightColumns <= 0 ) {
			return;
		}

		var that = this,
			i, jq,
			aiColumns = [];

		for ( i=this.s.iTableColumns-this.s.iRightColumns ; i<this.s.iTableColumns ; i++ ) {
			if ( this.s.dt.aoColumns[i].bVisible ) {
				aiColumns.push( i );
			}
		}

		this._fnClone( this.dom.clone.right, this.dom.grid.right, aiColumns, bAll );
	},


	/**
	 * Clone the left columns
	 *  @returns {void}
	 *  @param   {Boolean} bAll Indicate if the header and footer should be updated as well (true)
	 *  @private
	 */
	"_fnCloneLeft": function ( bAll )
	{
		if ( this.s.iLeftColumns <= 0 ) {
			return;
		}

		var that = this,
			i, jq,
			aiColumns = [];

		for ( i=0 ; i<this.s.iLeftColumns ; i++ ) {
			if ( this.s.dt.aoColumns[i].bVisible ) {
				aiColumns.push( i );
			}
		}

		this._fnClone( this.dom.clone.left, this.dom.grid.left, aiColumns, bAll );
	},


	/**
	 * Make a copy of the layout object for a header or footer element from DataTables. Note that
	 * this method will clone the nodes in the layout object.
	 *  @returns {Array} Copy of the layout array
	 *  @param   {Object} aoOriginal Layout array from DataTables (aoHeader or aoFooter)
	 *  @param   {Object} aiColumns Columns to copy
	 *  @param   {boolean} events Copy cell events or not
	 *  @private
	 */
	"_fnCopyLayout": function ( aoOriginal, aiColumns, events )
	{
		var aReturn = [];
		var aClones = [];
		var aCloned = [];

		for ( var i=0, iLen=aoOriginal.length ; i<iLen ; i++ )
		{
			var aRow = [];
			aRow.nTr = $(aoOriginal[i].nTr).clone(events, false)[0];

			for ( var j=0, jLen=this.s.iTableColumns ; j<jLen ; j++ )
			{
				if ( $.inArray( j, aiColumns ) === -1 )
				{
					continue;
				}

				var iCloned = $.inArray( aoOriginal[i][j].cell, aCloned );
				if ( iCloned === -1 )
				{
					var nClone = $(aoOriginal[i][j].cell).clone(events, false)[0];
					aClones.push( nClone );
					aCloned.push( aoOriginal[i][j].cell );

					aRow.push( {
						"cell": nClone,
						"unique": aoOriginal[i][j].unique
					} );
				}
				else
				{
					aRow.push( {
						"cell": aClones[ iCloned ],
						"unique": aoOriginal[i][j].unique
					} );
				}
			}

			aReturn.push( aRow );
		}

		return aReturn;
	},


	/**
	 * Clone the DataTable nodes and place them in the DOM (sized correctly)
	 *  @returns {void}
	 *  @param   {Object} oClone Object containing the header, footer and body cloned DOM elements
	 *  @param   {Object} oGrid Grid object containing the display grid elements for the cloned
	 *                    column (left or right)
	 *  @param   {Array} aiColumns Column indexes which should be operated on from the DataTable
	 *  @param   {Boolean} bAll Indicate if the header and footer should be updated as well (true)
	 *  @private
	 */
	"_fnClone": function ( oClone, oGrid, aiColumns, bAll )
	{
		var that = this,
			i, iLen, j, jLen, jq, nTarget, iColumn, nClone, iIndex, aoCloneLayout,
			jqCloneThead, aoFixedHeader,
			dt = this.s.dt;

		/*
		 * Header
		 */
		if ( bAll )
		{
			$(oClone.header).remove();

			oClone.header = $(this.dom.header).clone(true, false)[0];
			oClone.header.className += " DTFC_Cloned";
			oClone.header.style.width = "100%";
			oGrid.head.appendChild( oClone.header );

			/* Copy the DataTables layout cache for the header for our floating column */
			aoCloneLayout = this._fnCopyLayout( dt.aoHeader, aiColumns, true );
			jqCloneThead = $('>thead', oClone.header);
			jqCloneThead.empty();

			/* Add the created cloned TR elements to the table */
			for ( i=0, iLen=aoCloneLayout.length ; i<iLen ; i++ )
			{
				jqCloneThead[0].appendChild( aoCloneLayout[i].nTr );
			}

			/* Use the handy _fnDrawHead function in DataTables to do the rowspan/colspan
			 * calculations for us
			 */
			dt.oApi._fnDrawHead( dt, aoCloneLayout, true );
		}
		else
		{
			/* To ensure that we copy cell classes exactly, regardless of colspan, multiple rows
			 * etc, we make a copy of the header from the DataTable again, but don't insert the
			 * cloned cells, just copy the classes across. To get the matching layout for the
			 * fixed component, we use the DataTables _fnDetectHeader method, allowing 1:1 mapping
			 */
			aoCloneLayout = this._fnCopyLayout( dt.aoHeader, aiColumns, false );
			aoFixedHeader=[];

			dt.oApi._fnDetectHeader( aoFixedHeader, $('>thead', oClone.header)[0] );

			for ( i=0, iLen=aoCloneLayout.length ; i<iLen ; i++ )
			{
				for ( j=0, jLen=aoCloneLayout[i].length ; j<jLen ; j++ )
				{
					aoFixedHeader[i][j].cell.className = aoCloneLayout[i][j].cell.className;

					// If jQuery UI theming is used we need to copy those elements as well
					$('span.DataTables_sort_icon', aoFixedHeader[i][j].cell).each( function () {
						this.className = $('span.DataTables_sort_icon', aoCloneLayout[i][j].cell)[0].className;
					} );
				}
			}
		}
		this._fnEqualiseHeights( 'thead', this.dom.header, oClone.header );

		/*
		 * Body
		 */
		if ( this.s.sHeightMatch == 'auto' )
		{
			/* Remove any heights which have been applied already and let the browser figure it out */
			$('>tbody>tr', that.dom.body).css('height', 'auto');
		}

		if ( oClone.body !== null )
		{
			$(oClone.body).remove();
			oClone.body = null;
		}

		oClone.body = $(this.dom.body).clone(true)[0];
		oClone.body.className += " DTFC_Cloned";
		oClone.body.style.paddingBottom = dt.oScroll.iBarWidth+"px";
		oClone.body.style.marginBottom = (dt.oScroll.iBarWidth*2)+"px"; /* For IE */
		if ( oClone.body.getAttribute('id') !== null )
		{
			oClone.body.removeAttribute('id');
		}

		$('>thead>tr', oClone.body).empty();
		$('>tfoot', oClone.body).remove();

		var nBody = $('tbody', oClone.body)[0];
		$(nBody).empty();
		if ( dt.aiDisplay.length > 0 )
		{
			/* Copy the DataTables' header elements to force the column width in exactly the
			 * same way that DataTables does it - have the header element, apply the width and
			 * colapse it down
			 */
			var nInnerThead = $('>thead>tr', oClone.body)[0];
			for ( iIndex=0 ; iIndex<aiColumns.length ; iIndex++ )
			{
				iColumn = aiColumns[iIndex];

				nClone = $(dt.aoColumns[iColumn].nTh).clone(true)[0];
				nClone.innerHTML = "";

				var oStyle = nClone.style;
				oStyle.paddingTop = "0";
				oStyle.paddingBottom = "0";
				oStyle.borderTopWidth = "0";
				oStyle.borderBottomWidth = "0";
				oStyle.height = 0;
				oStyle.width = that.s.aiInnerWidths[iColumn]+"px";

				nInnerThead.appendChild( nClone );
			}

			/* Add in the tbody elements, cloning form the master table */
			$('>tbody>tr', that.dom.body).each( function (z) {
				var i = that.s.dt.oFeatures.bServerSide===false ?
					that.s.dt.aiDisplay[ that.s.dt._iDisplayStart+z ] : z;
				var aTds = that.s.dt.aoData[ i ].anCells || $(this).children('td, th');

				var n = this.cloneNode(false);
				n.removeAttribute('id');
				n.setAttribute( 'data-dt-row', i );

				for ( iIndex=0 ; iIndex<aiColumns.length ; iIndex++ )
				{
					iColumn = aiColumns[iIndex];

					if ( aTds.length > 0 )
					{
						nClone = $( aTds[iColumn] ).clone(true, true)[0];
						nClone.removeAttribute( 'id' );
						nClone.setAttribute( 'data-dt-row', i );
						nClone.setAttribute( 'data-dt-column', iColumn );
						n.appendChild( nClone );
					}
				}
				nBody.appendChild( n );
			} );
		}
		else
		{
			$('>tbody>tr', that.dom.body).each( function (z) {
				nClone = this.cloneNode(true);
				nClone.className += ' DTFC_NoData';
				$('td', nClone).html('');
				nBody.appendChild( nClone );
			} );
		}

		oClone.body.style.width = "100%";
		oClone.body.style.margin = "0";
		oClone.body.style.padding = "0";

		// Interop with Scroller - need to use a height forcing element in the
		// scrolling area in the same way that Scroller does in the body scroll.
		if ( dt.oScroller !== undefined )
		{
			var scrollerForcer = dt.oScroller.dom.force;

			if ( ! oGrid.forcer ) {
				oGrid.forcer = scrollerForcer.cloneNode( true );
				oGrid.liner.appendChild( oGrid.forcer );
			}
			else {
				oGrid.forcer.style.height = scrollerForcer.style.height;
			}
		}

		oGrid.liner.appendChild( oClone.body );

		this._fnEqualiseHeights( 'tbody', that.dom.body, oClone.body );

		/*
		 * Footer
		 */
		if ( dt.nTFoot !== null )
		{
			if ( bAll )
			{
				if ( oClone.footer !== null )
				{
					oClone.footer.parentNode.removeChild( oClone.footer );
				}
				oClone.footer = $(this.dom.footer).clone(true, true)[0];
				oClone.footer.className += " DTFC_Cloned";
				oClone.footer.style.width = "100%";
				oGrid.foot.appendChild( oClone.footer );

				/* Copy the footer just like we do for the header */
				aoCloneLayout = this._fnCopyLayout( dt.aoFooter, aiColumns, true );
				var jqCloneTfoot = $('>tfoot', oClone.footer);
				jqCloneTfoot.empty();

				for ( i=0, iLen=aoCloneLayout.length ; i<iLen ; i++ )
				{
					jqCloneTfoot[0].appendChild( aoCloneLayout[i].nTr );
				}
				dt.oApi._fnDrawHead( dt, aoCloneLayout, true );
			}
			else
			{
				aoCloneLayout = this._fnCopyLayout( dt.aoFooter, aiColumns, false );
				var aoCurrFooter=[];

				dt.oApi._fnDetectHeader( aoCurrFooter, $('>tfoot', oClone.footer)[0] );

				for ( i=0, iLen=aoCloneLayout.length ; i<iLen ; i++ )
				{
					for ( j=0, jLen=aoCloneLayout[i].length ; j<jLen ; j++ )
					{
						aoCurrFooter[i][j].cell.className = aoCloneLayout[i][j].cell.className;
					}
				}
			}
			this._fnEqualiseHeights( 'tfoot', this.dom.footer, oClone.footer );
		}

		/* Equalise the column widths between the header footer and body - body get's priority */
		var anUnique = dt.oApi._fnGetUniqueThs( dt, $('>thead', oClone.header)[0] );
		$(anUnique).each( function (i) {
			iColumn = aiColumns[i];
			this.style.width = that.s.aiInnerWidths[iColumn]+"px";
		} );

		if ( that.s.dt.nTFoot !== null )
		{
			anUnique = dt.oApi._fnGetUniqueThs( dt, $('>tfoot', oClone.footer)[0] );
			$(anUnique).each( function (i) {
				iColumn = aiColumns[i];
				this.style.width = that.s.aiInnerWidths[iColumn]+"px";
			} );
		}
	},


	/**
	 * From a given table node (THEAD etc), get a list of TR direct child elements
	 *  @param   {Node} nIn Table element to search for TR elements (THEAD, TBODY or TFOOT element)
	 *  @returns {Array} List of TR elements found
	 *  @private
	 */
	"_fnGetTrNodes": function ( nIn )
	{
		var aOut = [];
		for ( var i=0, iLen=nIn.childNodes.length ; i<iLen ; i++ )
		{
			if ( nIn.childNodes[i].nodeName.toUpperCase() == "TR" )
			{
				aOut.push( nIn.childNodes[i] );
			}
		}
		return aOut;
	},


	/**
	 * Equalise the heights of the rows in a given table node in a cross browser way
	 *  @returns {void}
	 *  @param   {String} nodeName Node type - thead, tbody or tfoot
	 *  @param   {Node} original Original node to take the heights from
	 *  @param   {Node} clone Copy the heights to
	 *  @private
	 */
	"_fnEqualiseHeights": function ( nodeName, original, clone )
	{
		if ( this.s.sHeightMatch == 'none' && nodeName !== 'thead' && nodeName !== 'tfoot' )
		{
			return;
		}

		var that = this,
			i, iLen, iHeight, iHeight2, iHeightOriginal, iHeightClone,
			rootOriginal = original.getElementsByTagName(nodeName)[0],
			rootClone    = clone.getElementsByTagName(nodeName)[0],
			jqBoxHack    = $('>'+nodeName+'>tr:eq(0)', original).children(':first'),
			iBoxHack     = jqBoxHack.outerHeight() - jqBoxHack.height(),
			anOriginal   = this._fnGetTrNodes( rootOriginal ),
			anClone      = this._fnGetTrNodes( rootClone ),
			heights      = [];

		for ( i=0, iLen=anClone.length ; i<iLen ; i++ )
		{
			iHeightOriginal = anOriginal[i].offsetHeight;
			iHeightClone = anClone[i].offsetHeight;
			iHeight = iHeightClone > iHeightOriginal ? iHeightClone : iHeightOriginal;

			if ( this.s.sHeightMatch == 'semiauto' )
			{
				anOriginal[i]._DTTC_iHeight = iHeight;
			}

			heights.push( iHeight );
		}

		for ( i=0, iLen=anClone.length ; i<iLen ; i++ )
		{
			anClone[i].style.height = heights[i]+"px";
			anOriginal[i].style.height = heights[i]+"px";
		}
	},

	/**
	 * Determine if the UA suffers from Firefox's overflow:scroll scrollbars
	 * not being shown bug.
	 *
	 * Firefox doesn't draw scrollbars, even if it is told to using
	 * overflow:scroll, if the div is less than 34px height. See bugs 292284 and
	 * 781885. Using UA detection here since this is particularly hard to detect
	 * using objects - its a straight up rendering error in Firefox.
	 *
	 * @return {boolean} True if Firefox error is present, false otherwise
	 */
	_firefoxScrollError: function () {
		if ( _firefoxScroll === undefined ) {
			var test = $('<div/>')
				.css( {
					position: 'absolute',
					top: 0,
					left: 0,
					height: 10,
					width: 50,
					overflow: 'scroll'
				} )
				.appendTo( 'body' );

			// Make sure this doesn't apply on Macs with 0 width scrollbars
			_firefoxScroll = (
				test[0].clientWidth === test[0].offsetWidth && this._fnDTOverflow().bar !== 0
			);

			test.remove();
		}

		return _firefoxScroll;
	}
} );



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Statics
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/**
 * FixedColumns default settings for initialisation
 *  @name FixedColumns.defaults
 *  @namespace
 *  @static
 */
FixedColumns.defaults = /** @lends FixedColumns.defaults */{
	/**
	 * Number of left hand columns to fix in position
	 *  @type     int
	 *  @default  1
	 *  @static
	 *  @example
	 *      var  = $('#example').dataTable( {
	 *          "scrollX": "100%"
	 *      } );
	 *      new $.fn.dataTable.fixedColumns( table, {
	 *          "leftColumns": 2
	 *      } );
	 */
	"iLeftColumns": 1,

	/**
	 * Number of right hand columns to fix in position
	 *  @type     int
	 *  @default  0
	 *  @static
	 *  @example
	 *      var table = $('#example').dataTable( {
	 *          "scrollX": "100%"
	 *      } );
	 *      new $.fn.dataTable.fixedColumns( table, {
	 *          "rightColumns": 1
	 *      } );
	 */
	"iRightColumns": 0,

	/**
	 * Draw callback function which is called when FixedColumns has redrawn the fixed assets
	 *  @type     function(object, object):void
	 *  @default  null
	 *  @static
	 *  @example
	 *      var table = $('#example').dataTable( {
	 *          "scrollX": "100%"
	 *      } );
	 *      new $.fn.dataTable.fixedColumns( table, {
	 *          "drawCallback": function () {
	 *	            alert( "FixedColumns redraw" );
	 *	        }
	 *      } );
	 */
	"fnDrawCallback": null,

	/**
	 * Height matching algorthim to use. This can be "none" which will result in no height
	 * matching being applied by FixedColumns (height matching could be forced by CSS in this
	 * case), "semiauto" whereby the height calculation will be performed once, and the result
	 * cached to be used again (fnRecalculateHeight can be used to force recalculation), or
	 * "auto" when height matching is performed on every draw (slowest but must accurate)
	 *  @type     string
	 *  @default  semiauto
	 *  @static
	 *  @example
	 *      var table = $('#example').dataTable( {
	 *          "scrollX": "100%"
	 *      } );
	 *      new $.fn.dataTable.fixedColumns( table, {
	 *          "heightMatch": "auto"
	 *      } );
	 */
	"sHeightMatch": "semiauto"
};




/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Constants
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/**
 * FixedColumns version
 *  @name      FixedColumns.version
 *  @type      String
 *  @default   See code
 *  @static
 */
FixedColumns.version = "3.2.6";



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables API integration
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

DataTable.Api.register( 'fixedColumns()', function () {
	return this;
} );

DataTable.Api.register( 'fixedColumns().update()', function () {
	return this.iterator( 'table', function ( ctx ) {
		if ( ctx._oFixedColumns ) {
			ctx._oFixedColumns.fnUpdate();
		}
	} );
} );

DataTable.Api.register( 'fixedColumns().relayout()', function () {
	return this.iterator( 'table', function ( ctx ) {
		if ( ctx._oFixedColumns ) {
			ctx._oFixedColumns.fnRedrawLayout();
		}
	} );
} );

DataTable.Api.register( 'rows().recalcHeight()', function () {
	return this.iterator( 'row', function ( ctx, idx ) {
		if ( ctx._oFixedColumns ) {
			ctx._oFixedColumns.fnRecalculateHeight( this.row(idx).node() );
		}
	} );
} );

DataTable.Api.register( 'fixedColumns().rowIndex()', function ( row ) {
	row = $(row);

	return row.parents('.DTFC_Cloned').length ?
		this.rows( { page: 'current' } ).indexes()[ row.index() ] :
		this.row( row ).index();
} );

DataTable.Api.register( 'fixedColumns().cellIndex()', function ( cell ) {
	cell = $(cell);

	if ( cell.parents('.DTFC_Cloned').length ) {
		var rowClonedIdx = cell.parent().index();
		var rowIdx = this.rows( { page: 'current' } ).indexes()[ rowClonedIdx ];
		var columnIdx;

		if ( cell.parents('.DTFC_LeftWrapper').length ) {
			columnIdx = cell.index();
		}
		else {
			var columns = this.columns().flatten().length;
			columnIdx = columns - this.context[0]._oFixedColumns.s.iRightColumns + cell.index();
		}

		return {
			row: rowIdx,
			column: this.column.index( 'toData', columnIdx ),
			columnVisible: columnIdx
		};
	}
	else {
		return this.cell( cell ).index();
	}
} );




/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Initialisation
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

// Attach a listener to the document which listens for DataTables initialisation
// events so we can automatically initialise
$(document).on( 'init.dt.fixedColumns', function (e, settings) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	var init = settings.oInit.fixedColumns;
	var defaults = DataTable.defaults.fixedColumns;

	if ( init || defaults ) {
		var opts = $.extend( {}, init, defaults );

		if ( init !== false ) {
			new FixedColumns( settings, opts );
		}
	}
} );



// Make FixedColumns accessible from the DataTables instance
$.fn.dataTable.FixedColumns = FixedColumns;
$.fn.DataTable.FixedColumns = FixedColumns;

return FixedColumns;
}));


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! FixedHeader 3.1.5
 * ©2009-2018 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     FixedHeader
 * @description Fix a table's header or footer, so it is always visible while
 *              scrolling
 * @version     3.1.5
 * @file        dataTables.fixedHeader.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     www.sprymedia.co.uk/contact
 * @copyright   Copyright 2009-2018 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


var _instCounter = 0;

var FixedHeader = function ( dt, config ) {
	// Sanity check - you just know it will happen
	if ( ! (this instanceof FixedHeader) ) {
		throw "FixedHeader must be initialised with the 'new' keyword.";
	}

	// Allow a boolean true for defaults
	if ( config === true ) {
		config = {};
	}

	dt = new DataTable.Api( dt );

	this.c = $.extend( true, {}, FixedHeader.defaults, config );

	this.s = {
		dt: dt,
		position: {
			theadTop: 0,
			tbodyTop: 0,
			tfootTop: 0,
			tfootBottom: 0,
			width: 0,
			left: 0,
			tfootHeight: 0,
			theadHeight: 0,
			windowHeight: $(window).height(),
			visible: true
		},
		headerMode: null,
		footerMode: null,
		autoWidth: dt.settings()[0].oFeatures.bAutoWidth,
		namespace: '.dtfc'+(_instCounter++),
		scrollLeft: {
			header: -1,
			footer: -1
		},
		enable: true
	};

	this.dom = {
		floatingHeader: null,
		thead: $(dt.table().header()),
		tbody: $(dt.table().body()),
		tfoot: $(dt.table().footer()),
		header: {
			host: null,
			floating: null,
			placeholder: null
		},
		footer: {
			host: null,
			floating: null,
			placeholder: null
		}
	};

	this.dom.header.host = this.dom.thead.parent();
	this.dom.footer.host = this.dom.tfoot.parent();

	var dtSettings = dt.settings()[0];
	if ( dtSettings._fixedHeader ) {
		throw "FixedHeader already initialised on table "+dtSettings.nTable.id;
	}

	dtSettings._fixedHeader = this;

	this._constructor();
};


/*
 * Variable: FixedHeader
 * Purpose:  Prototype for FixedHeader
 * Scope:    global
 */
$.extend( FixedHeader.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * API methods
	 */
	
	/**
	 * Enable / disable the fixed elements
	 *
	 * @param  {boolean} enable `true` to enable, `false` to disable
	 */
	enable: function ( enable )
	{
		this.s.enable = enable;

		if ( this.c.header ) {
			this._modeChange( 'in-place', 'header', true );
		}

		if ( this.c.footer && this.dom.tfoot.length ) {
			this._modeChange( 'in-place', 'footer', true );
		}

		this.update();
	},
	
	/**
	 * Set header offset 
	 *
	 * @param  {int} new value for headerOffset
	 */
	headerOffset: function ( offset )
	{
		if ( offset !== undefined ) {
			this.c.headerOffset = offset;
			this.update();
		}

		return this.c.headerOffset;
	},
	
	/**
	 * Set footer offset
	 *
	 * @param  {int} new value for footerOffset
	 */
	footerOffset: function ( offset )
	{
		if ( offset !== undefined ) {
			this.c.footerOffset = offset;
			this.update();
		}

		return this.c.footerOffset;
	},

	
	/**
	 * Recalculate the position of the fixed elements and force them into place
	 */
	update: function ()
	{
		this._positions();
		this._scroll( true );
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */
	
	/**
	 * FixedHeader constructor - adding the required event listeners and
	 * simple initialisation
	 *
	 * @private
	 */
	_constructor: function ()
	{
		var that = this;
		var dt = this.s.dt;

		$(window)
			.on( 'scroll'+this.s.namespace, function () {
				that._scroll();
			} )
			.on( 'resize'+this.s.namespace, DataTable.util.throttle( function () {
				that.s.position.windowHeight = $(window).height();
				that.update();
			}, 50 ) );

		var autoHeader = $('.fh-fixedHeader');
		if ( ! this.c.headerOffset && autoHeader.length ) {
			this.c.headerOffset = autoHeader.outerHeight();
		}

		var autoFooter = $('.fh-fixedFooter');
		if ( ! this.c.footerOffset && autoFooter.length ) {
			this.c.footerOffset = autoFooter.outerHeight();
		}

		dt.on( 'column-reorder.dt.dtfc column-visibility.dt.dtfc draw.dt.dtfc column-sizing.dt.dtfc responsive-display.dt.dtfc', function () {
			that.update();
		} );

		dt.on( 'destroy.dtfc', function () {
			if ( that.c.header ) {
				that._modeChange( 'in-place', 'header', true );
			}

			if ( that.c.footer && that.dom.tfoot.length ) {
				that._modeChange( 'in-place', 'footer', true );
			}

			dt.off( '.dtfc' );
			$(window).off( that.s.namespace );
		} );

		this._positions();
		this._scroll();
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */

	/**
	 * Clone a fixed item to act as a place holder for the original element
	 * which is moved into a clone of the table element, and moved around the
	 * document to give the fixed effect.
	 *
	 * @param  {string}  item  'header' or 'footer'
	 * @param  {boolean} force Force the clone to happen, or allow automatic
	 *   decision (reuse existing if available)
	 * @private
	 */
	_clone: function ( item, force )
	{
		var dt = this.s.dt;
		var itemDom = this.dom[ item ];
		var itemElement = item === 'header' ?
			this.dom.thead :
			this.dom.tfoot;

		if ( ! force && itemDom.floating ) {
			// existing floating element - reuse it
			itemDom.floating.removeClass( 'fixedHeader-floating fixedHeader-locked' );
		}
		else {
			if ( itemDom.floating ) {
				itemDom.placeholder.remove();
				this._unsize( item );
				itemDom.floating.children().detach();
				itemDom.floating.remove();
			}

			itemDom.floating = $( dt.table().node().cloneNode( false ) )
				.css( 'table-layout', 'fixed' )
				.attr( 'aria-hidden', 'true' )
				.removeAttr( 'id' )
				.append( itemElement )
				.appendTo( 'body' );

			// Insert a fake thead/tfoot into the DataTable to stop it jumping around
			itemDom.placeholder = itemElement.clone( false )
			itemDom.placeholder
				.find( '*[id]' )
				.removeAttr( 'id' );

			itemDom.host.prepend( itemDom.placeholder );

			// Clone widths
			this._matchWidths( itemDom.placeholder, itemDom.floating );
		}
	},

	/**
	 * Copy widths from the cells in one element to another. This is required
	 * for the footer as the footer in the main table takes its sizes from the
	 * header columns. That isn't present in the footer so to have it still
	 * align correctly, the sizes need to be copied over. It is also required
	 * for the header when auto width is not enabled
	 *
	 * @param  {jQuery} from Copy widths from
	 * @param  {jQuery} to   Copy widths to
	 * @private
	 */
	_matchWidths: function ( from, to ) {
		var get = function ( name ) {
			return $(name, from)
				.map( function () {
					return $(this).width();
				} ).toArray();
		};

		var set = function ( name, toWidths ) {
			$(name, to).each( function ( i ) {
				$(this).css( {
					width: toWidths[i],
					minWidth: toWidths[i]
				} );
			} );
		};

		var thWidths = get( 'th' );
		var tdWidths = get( 'td' );

		set( 'th', thWidths );
		set( 'td', tdWidths );
	},

	/**
	 * Remove assigned widths from the cells in an element. This is required
	 * when inserting the footer back into the main table so the size is defined
	 * by the header columns and also when auto width is disabled in the
	 * DataTable.
	 *
	 * @param  {string} item The `header` or `footer`
	 * @private
	 */
	_unsize: function ( item ) {
		var el = this.dom[ item ].floating;

		if ( el && (item === 'footer' || (item === 'header' && ! this.s.autoWidth)) ) {
			$('th, td', el).css( {
				width: '',
				minWidth: ''
			} );
		}
		else if ( el && item === 'header' ) {
			$('th, td', el).css( 'min-width', '' );
		}
	},

	/**
	 * Reposition the floating elements to take account of horizontal page
	 * scroll
	 *
	 * @param  {string} item       The `header` or `footer`
	 * @param  {int}    scrollLeft Document scrollLeft
	 * @private
	 */
	_horizontal: function ( item, scrollLeft )
	{
		var itemDom = this.dom[ item ];
		var position = this.s.position;
		var lastScrollLeft = this.s.scrollLeft;

		if ( itemDom.floating && lastScrollLeft[ item ] !== scrollLeft ) {
			itemDom.floating.css( 'left', position.left - scrollLeft );

			lastScrollLeft[ item ] = scrollLeft;
		}
	},

	/**
	 * Change from one display mode to another. Each fixed item can be in one
	 * of:
	 *
	 * * `in-place` - In the main DataTable
	 * * `in` - Floating over the DataTable
	 * * `below` - (Header only) Fixed to the bottom of the table body
	 * * `above` - (Footer only) Fixed to the top of the table body
	 * 
	 * @param  {string}  mode        Mode that the item should be shown in
	 * @param  {string}  item        'header' or 'footer'
	 * @param  {boolean} forceChange Force a redraw of the mode, even if already
	 *     in that mode.
	 * @private
	 */
	_modeChange: function ( mode, item, forceChange )
	{
		var dt = this.s.dt;
		var itemDom = this.dom[ item ];
		var position = this.s.position;

		// Record focus. Browser's will cause input elements to loose focus if
		// they are inserted else where in the doc
		var tablePart = this.dom[ item==='footer' ? 'tfoot' : 'thead' ];
		var focus = $.contains( tablePart[0], document.activeElement ) ?
			document.activeElement :
			null;
		
		if ( focus ) {
			focus.blur();
		}

		if ( mode === 'in-place' ) {
			// Insert the header back into the table's real header
			if ( itemDom.placeholder ) {
				itemDom.placeholder.remove();
				itemDom.placeholder = null;
			}

			this._unsize( item );

			if ( item === 'header' ) {
				itemDom.host.prepend( tablePart );
			}
			else {
				itemDom.host.append( tablePart );
			}

			if ( itemDom.floating ) {
				itemDom.floating.remove();
				itemDom.floating = null;
			}
		}
		else if ( mode === 'in' ) {
			// Remove the header from the read header and insert into a fixed
			// positioned floating table clone
			this._clone( item, forceChange );

			itemDom.floating
				.addClass( 'fixedHeader-floating' )
				.css( item === 'header' ? 'top' : 'bottom', this.c[item+'Offset'] )
				.css( 'left', position.left+'px' )
				.css( 'width', position.width+'px' );

			if ( item === 'footer' ) {
				itemDom.floating.css( 'top', '' );
			}
		}
		else if ( mode === 'below' ) { // only used for the header
			// Fix the position of the floating header at base of the table body
			this._clone( item, forceChange );

			itemDom.floating
				.addClass( 'fixedHeader-locked' )
				.css( 'top', position.tfootTop - position.theadHeight )
				.css( 'left', position.left+'px' )
				.css( 'width', position.width+'px' );
		}
		else if ( mode === 'above' ) { // only used for the footer
			// Fix the position of the floating footer at top of the table body
			this._clone( item, forceChange );

			itemDom.floating
				.addClass( 'fixedHeader-locked' )
				.css( 'top', position.tbodyTop )
				.css( 'left', position.left+'px' )
				.css( 'width', position.width+'px' );
		}

		// Restore focus if it was lost
		if ( focus && focus !== document.activeElement ) {
			setTimeout( function () {
				focus.focus();
			}, 10 );
		}

		this.s.scrollLeft.header = -1;
		this.s.scrollLeft.footer = -1;
		this.s[item+'Mode'] = mode;
	},

	/**
	 * Cache the positional information that is required for the mode
	 * calculations that FixedHeader performs.
	 *
	 * @private
	 */
	_positions: function ()
	{
		var dt = this.s.dt;
		var table = dt.table();
		var position = this.s.position;
		var dom = this.dom;
		var tableNode = $(table.node());

		// Need to use the header and footer that are in the main table,
		// regardless of if they are clones, since they hold the positions we
		// want to measure from
		var thead = tableNode.children('thead');
		var tfoot = tableNode.children('tfoot');
		var tbody = dom.tbody;

		position.visible = tableNode.is(':visible');
		position.width = tableNode.outerWidth();
		position.left = tableNode.offset().left;
		position.theadTop = thead.offset().top;
		position.tbodyTop = tbody.offset().top;
		position.theadHeight = position.tbodyTop - position.theadTop;

		if ( tfoot.length ) {
			position.tfootTop = tfoot.offset().top;
			position.tfootBottom = position.tfootTop + tfoot.outerHeight();
			position.tfootHeight = position.tfootBottom - position.tfootTop;
		}
		else {
			position.tfootTop = position.tbodyTop + tbody.outerHeight();
			position.tfootBottom = position.tfootTop;
			position.tfootHeight = position.tfootTop;
		}
	},


	/**
	 * Mode calculation - determine what mode the fixed items should be placed
	 * into.
	 *
	 * @param  {boolean} forceChange Force a redraw of the mode, even if already
	 *     in that mode.
	 * @private
	 */
	_scroll: function ( forceChange )
	{
		var windowTop = $(document).scrollTop();
		var windowLeft = $(document).scrollLeft();
		var position = this.s.position;
		var headerMode, footerMode;

		if ( ! this.s.enable ) {
			return;
		}

		if ( this.c.header ) {
			if ( ! position.visible || windowTop <= position.theadTop - this.c.headerOffset ) {
				headerMode = 'in-place';
			}
			else if ( windowTop <= position.tfootTop - position.theadHeight - this.c.headerOffset ) {
				headerMode = 'in';
			}
			else {
				headerMode = 'below';
			}

			if ( forceChange || headerMode !== this.s.headerMode ) {
				this._modeChange( headerMode, 'header', forceChange );
			}

			this._horizontal( 'header', windowLeft );
		}

		if ( this.c.footer && this.dom.tfoot.length ) {
			if ( ! position.visible || windowTop + position.windowHeight >= position.tfootBottom + this.c.footerOffset ) {
				footerMode = 'in-place';
			}
			else if ( position.windowHeight + windowTop > position.tbodyTop + position.tfootHeight + this.c.footerOffset ) {
				footerMode = 'in';
			}
			else {
				footerMode = 'above';
			}

			if ( forceChange || footerMode !== this.s.footerMode ) {
				this._modeChange( footerMode, 'footer', forceChange );
			}

			this._horizontal( 'footer', windowLeft );
		}
	}
} );


/**
 * Version
 * @type {String}
 * @static
 */
FixedHeader.version = "3.1.5";

/**
 * Defaults
 * @type {Object}
 * @static
 */
FixedHeader.defaults = {
	header: true,
	footer: false,
	headerOffset: 0,
	footerOffset: 0
};


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables interfaces
 */

// Attach for constructor access
$.fn.dataTable.FixedHeader = FixedHeader;
$.fn.DataTable.FixedHeader = FixedHeader;


// DataTables creation - check if the FixedHeader option has been defined on the
// table and if so, initialise
$(document).on( 'init.dt.dtfh', function (e, settings, json) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	var init = settings.oInit.fixedHeader;
	var defaults = DataTable.defaults.fixedHeader;

	if ( (init || defaults) && ! settings._fixedHeader ) {
		var opts = $.extend( {}, defaults, init );

		if ( init !== false ) {
			new FixedHeader( settings, opts );
		}
	}
} );

// DataTables API methods
DataTable.Api.register( 'fixedHeader()', function () {} );

DataTable.Api.register( 'fixedHeader.adjust()', function () {
	return this.iterator( 'table', function ( ctx ) {
		var fh = ctx._fixedHeader;

		if ( fh ) {
			fh.update();
		}
	} );
} );

DataTable.Api.register( 'fixedHeader.enable()', function ( flag ) {
	return this.iterator( 'table', function ( ctx ) {
		var fh = ctx._fixedHeader;

		flag = ( flag !== undefined ? flag : true );
		if ( fh && flag !== fh.s.enable ) {
			fh.enable( flag );
		}
	} );
} );

DataTable.Api.register( 'fixedHeader.disable()', function ( ) {
	return this.iterator( 'table', function ( ctx ) {
		var fh = ctx._fixedHeader;

		if ( fh && fh.s.enable ) {
			fh.enable( false );
		}
	} );
} );

$.each( ['header', 'footer'], function ( i, el ) {
	DataTable.Api.register( 'fixedHeader.'+el+'Offset()', function ( offset ) {
		var ctx = this.context;

		if ( offset === undefined ) {
			return ctx.length && ctx[0]._fixedHeader ?
				ctx[0]._fixedHeader[el +'Offset']() :
				undefined;
		}

		return this.iterator( 'table', function ( ctx ) {
			var fh = ctx._fixedHeader;

			if ( fh ) {
				fh[ el +'Offset' ]( offset );
			}
		} );
	} );
} );


return FixedHeader;
}));


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! KeyTable 2.5.0
 * ©2009-2018 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     KeyTable
 * @description Spreadsheet like keyboard navigation for DataTables
 * @version     2.5.0
 * @file        dataTables.keyTable.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     www.sprymedia.co.uk/contact
 * @copyright   Copyright 2009-2018 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


var KeyTable = function ( dt, opts ) {
	// Sanity check that we are using DataTables 1.10 or newer
	if ( ! DataTable.versionCheck || ! DataTable.versionCheck( '1.10.8' ) ) {
		throw 'KeyTable requires DataTables 1.10.8 or newer';
	}

	// User and defaults configuration object
	this.c = $.extend( true, {},
		DataTable.defaults.keyTable,
		KeyTable.defaults,
		opts
	);

	// Internal settings
	this.s = {
		/** @type {DataTable.Api} DataTables' API instance */
		dt: new DataTable.Api( dt ),

		enable: true,

		/** @type {bool} Flag for if a draw is triggered by focus */
		focusDraw: false,

		/** @type {bool} Flag to indicate when waiting for a draw to happen.
		  *   Will ignore key presses at this point
		  */
		waitingForDraw: false,

		/** @type {object} Information about the last cell that was focused */
		lastFocus: null
	};

	// DOM items
	this.dom = {

	};

	// Check if row reorder has already been initialised on this table
	var settings = this.s.dt.settings()[0];
	var exisiting = settings.keytable;
	if ( exisiting ) {
		return exisiting;
	}

	settings.keytable = this;
	this._constructor();
};


$.extend( KeyTable.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * API methods for DataTables API interface
	 */

	/**
	 * Blur the table's cell focus
	 */
	blur: function ()
	{
		this._blur();
	},

	/**
	 * Enable cell focus for the table
	 *
	 * @param  {string} state Can be `true`, `false` or `-string navigation-only`
	 */
	enable: function ( state )
	{
		this.s.enable = state;
	},

	/**
	 * Focus on a cell
	 * @param  {integer} row    Row index
	 * @param  {integer} column Column index
	 */
	focus: function ( row, column )
	{
		this._focus( this.s.dt.cell( row, column ) );
	},

	/**
	 * Is the cell focused
	 * @param  {object} cell Cell index to check
	 * @returns {boolean} true if focused, false otherwise
	 */
	focused: function ( cell )
	{
		var lastFocus = this.s.lastFocus;

		if ( ! lastFocus ) {
			return false;
		}

		var lastIdx = this.s.lastFocus.cell.index();
		return cell.row === lastIdx.row && cell.column === lastIdx.column;
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */

	/**
	 * Initialise the KeyTable instance
	 *
	 * @private
	 */
	_constructor: function ()
	{
		this._tabInput();

		var that = this;
		var dt = this.s.dt;
		var table = $( dt.table().node() );

		// Need to be able to calculate the cell positions relative to the table
		if ( table.css('position') === 'static' ) {
			table.css( 'position', 'relative' );
		}

		// Click to focus
		$( dt.table().body() ).on( 'click.keyTable', 'th, td', function (e) {
			if ( that.s.enable === false ) {
				return;
			}

			var cell = dt.cell( this );

			if ( ! cell.any() ) {
				return;
			}

			that._focus( cell, null, false, e );
		} );

		// Key events
		$( document ).on( 'keydown.keyTable', function (e) {
			that._key( e );
		} );

		// Click blur
		if ( this.c.blurable ) {
			$( document ).on( 'mousedown.keyTable', function ( e ) {
				// Click on the search input will blur focus
				if ( $(e.target).parents( '.dataTables_filter' ).length ) {
					that._blur();
				}

				// If the click was inside the DataTables container, don't blur
				if ( $(e.target).parents().filter( dt.table().container() ).length ) {
					return;
				}

				// Don't blur in Editor form
				if ( $(e.target).parents('div.DTE').length ) {
					return;
				}

				// Or an Editor date input
				if ( $(e.target).parents('div.editor-datetime').length ) {
					return;
				}

				//If the click was inside the fixed columns container, don't blur
				if ( $(e.target).parents().filter('.DTFC_Cloned').length ) {
					return;
				}

				that._blur();
			} );
		}

		if ( this.c.editor ) {
			var editor = this.c.editor;

			// Need to disable KeyTable when the main editor is shown
			editor.on( 'open.keyTableMain', function (e, mode, action) {
				if ( mode !== 'inline' && that.s.enable ) {
					that.enable( false );

					editor.one( 'close.keyTable', function () {
						that.enable( true );
					} );
				}
			} );

			if ( this.c.editOnFocus ) {
				dt.on( 'key-focus.keyTable key-refocus.keyTable', function ( e, dt, cell, orig ) {
					that._editor( null, orig, true );
				} );
			}

			// Activate Editor when a key is pressed (will be ignored, if
			// already active).
			dt.on( 'key.keyTable', function ( e, dt, key, cell, orig ) {
				that._editor( key, orig, false );
			} );

			// Active editing on double click - it will already have focus from
			// the click event handler above
			$( dt.table().body() ).on( 'dblclick.keyTable', 'th, td', function (e) {
				if ( that.s.enable === false ) {
					return;
				}

				var cell = dt.cell( this );

				if ( ! cell.any() ) {
					return;
				}

				that._editor( null, e, true );
			} );
		}

		// Stave saving
		if ( dt.settings()[0].oFeatures.bStateSave ) {
			dt.on( 'stateSaveParams.keyTable', function (e, s, d) {
				d.keyTable = that.s.lastFocus ?
					that.s.lastFocus.cell.index() :
					null;
			} );
		}

		// Redraw - retain focus on the current cell
		dt.on( 'draw.keyTable', function (e) {
			if ( that.s.focusDraw ) {
				return;
			}

			var lastFocus = that.s.lastFocus;

			if ( lastFocus && lastFocus.node && $(lastFocus.node).closest('body') === document.body ) {
				var relative = that.s.lastFocus.relative;
				var info = dt.page.info();
				var row = relative.row + info.start;

				if ( info.recordsDisplay === 0 ) {
					return;
				}

				// Reverse if needed
				if ( row >= info.recordsDisplay ) {
					row = info.recordsDisplay - 1;
				}

				that._focus( row, relative.column, true, e );
			}
		} );

		// Clipboard support
		if ( this.c.clipboard ) {
			this._clipboard();
		}

		dt.on( 'destroy.keyTable', function () {
			dt.off( '.keyTable' );
			$( dt.table().body() ).off( 'click.keyTable', 'th, td' );
			$( document )
				.off( 'keydown.keyTable' )
				.off( 'click.keyTable' )
				.off( 'copy.keyTable' )
				.off( 'paste.keyTable' );
		} );

		// Initial focus comes from state or options
		var state = dt.state.loaded();

		if ( state && state.keyTable ) {
			// Wait until init is done
			dt.one( 'init', function () {
				var cell = dt.cell( state.keyTable );

				// Ensure that the saved cell still exists
				if ( cell.any() ) {
					cell.focus();
				}
			} );
		}
		else if ( this.c.focus ) {
			dt.cell( this.c.focus ).focus();
		}
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */

	/**
	 * Blur the control
	 *
	 * @private
	 */
	_blur: function ()
	{
		if ( ! this.s.enable || ! this.s.lastFocus ) {
			return;
		}

		var cell = this.s.lastFocus.cell;

		$( cell.node() ).removeClass( this.c.className );
		this.s.lastFocus = null;

		this._updateFixedColumns(cell.index().column);

		this._emitEvent( 'key-blur', [ this.s.dt, cell ] );
	},


	/**
	 * Clipboard interaction handlers
	 *
	 * @private
	 */
	_clipboard: function () {
		var dt = this.s.dt;
		var that = this;

		// IE8 doesn't support getting selected text
		if ( ! window.getSelection ) {
			return;
		}

		$(document).on( 'copy.keyTable', function (ejq) {
			var e = ejq.originalEvent;
			var selection = window.getSelection().toString();
			var focused = that.s.lastFocus;

			// Only copy cell text to clipboard if there is no other selection
			// and there is a focused cell
			if ( ! selection && focused ) {
				e.clipboardData.setData(
					'text/plain',
					focused.cell.render( that.c.clipboardOrthogonal )
				);
				e.preventDefault();
			}
		} );

		$(document).on( 'paste.keyTable', function (ejq) {
			var e = ejq.originalEvent;
			var focused = that.s.lastFocus;
			var activeEl = document.activeElement;
			var editor = that.c.editor;
			var pastedText;

			if ( focused && (! activeEl || activeEl.nodeName.toLowerCase() === 'body') ) {
				e.preventDefault();

				if ( window.clipboardData && window.clipboardData.getData ) {
					// IE
					pastedText = window.clipboardData.getData('Text');
				}
				else if ( e.clipboardData && e.clipboardData.getData ) {
					// Everything else
					pastedText = e.clipboardData.getData('text/plain');
				}

				if ( editor ) {
					// Got Editor - need to activate inline editing,
					// set the value and submit
					editor
						.inline( focused.cell.index() )
						.set( editor.displayed()[0], pastedText )
						.submit();
				}
				else {
					// No editor, so just dump the data in
					focused.cell.data( pastedText );
					dt.draw(false);
				}
			}
		} );
	},


	/**
	 * Get an array of the column indexes that KeyTable can operate on. This
	 * is a merge of the user supplied columns and the visible columns.
	 *
	 * @private
	 */
	_columns: function ()
	{
		var dt = this.s.dt;
		var user = dt.columns( this.c.columns ).indexes();
		var out = [];

		dt.columns( ':visible' ).every( function (i) {
			if ( user.indexOf( i ) !== -1 ) {
				out.push( i );
			}
		} );

		return out;
	},


	/**
	 * Perform excel like navigation for Editor by triggering an edit on key
	 * press
	 *
	 * @param  {integer} key Key code for the pressed key
	 * @param  {object} orig Original event
	 * @private
	 */
	_editor: function ( key, orig, hardEdit )
	{
		var that = this;
		var dt = this.s.dt;
		var editor = this.c.editor;
		var editCell = this.s.lastFocus.cell;

		// Do nothing if there is already an inline edit in this cell
		if ( $('div.DTE', editCell.node()).length ) {
			return;
		}

		// Don't activate Editor on control key presses
		if ( key !== null && (
			(key >= 0x00 && key <= 0x09) ||
			key === 0x0b ||
			key === 0x0c ||
			(key >= 0x0e && key <= 0x1f) ||
			(key >= 0x70 && key <= 0x7b) ||
			(key >= 0x7f && key <= 0x9f)
		) ) {
			return;
		}

		orig.stopPropagation();

		// Return key should do nothing - for textareas it would empty the
		// contents
		if ( key === 13 ) {
			orig.preventDefault();
		}

		var editInline = function () {
			editor
				.one( 'open.keyTable', function () {
					// Remove cancel open
					editor.off( 'cancelOpen.keyTable' );

					// Excel style - select all text
					if ( ! hardEdit ) {
						$('div.DTE_Field_InputControl input, div.DTE_Field_InputControl textarea').select();
					}

					// Reduce the keys the Keys listens for
					dt.keys.enable( hardEdit ? 'tab-only' : 'navigation-only' );

					// On blur of the navigation submit
					dt.on( 'key-blur.editor', function () {
						if ( editor.displayed() ) {
							editor.submit();
						}
					} );

					// Highlight the cell a different colour on full edit
					if ( hardEdit ) {
						$( dt.table().container() ).addClass('dtk-focus-alt');
					}

					editor.on( 'submitUnsuccessful.keyTable', function () {
						that._focus( editCell, null, false );
					} );

					// Restore full key navigation on close
					editor.one( 'close', function () {
						dt.keys.enable( true );
						dt.off( 'key-blur.editor' );
						editor.off( '.keyTable' );
						$( dt.table().container() ).removeClass('dtk-focus-alt');
					} );
				} )
				.one( 'cancelOpen.keyTable', function () {
					// `preOpen` can cancel the display of the form, so it
					// might be that the open event handler isn't needed
					editor.off( '.keyTable' );
				} )
				.inline( editCell.index() );
		};

		// Editor 1.7 listens for `return` on keyup, so if return is the trigger
		// key, we need to wait for `keyup` otherwise Editor would just submit
		// the content triggered by this keypress.
		if ( key === 13 ) {
			hardEdit = true;

			$(document).one( 'keyup', function () { // immediately removed
				editInline();
			} );
		}
		else {
			editInline();
		}
	},


	/**
	 * Emit an event on the DataTable for listeners
	 *
	 * @param  {string} name Event name
	 * @param  {array} args Event arguments
	 * @private
	 */
	_emitEvent: function ( name, args )
	{
		this.s.dt.iterator( 'table', function ( ctx, i ) {
			$(ctx.nTable).triggerHandler( name, args );
		} );
	},


	/**
	 * Focus on a particular cell, shifting the table's paging if required
	 *
	 * @param  {DataTables.Api|integer} row Can be given as an API instance that
	 *   contains the cell to focus or as an integer. As the latter it is the
	 *   visible row index (from the whole data set) - NOT the data index
	 * @param  {integer} [column] Not required if a cell is given as the first
	 *   parameter. Otherwise this is the column data index for the cell to
	 *   focus on
	 * @param {boolean} [shift=true] Should the viewport be moved to show cell
	 * @private
	 */
	_focus: function ( row, column, shift, originalEvent )
	{
		var that = this;
		var dt = this.s.dt;
		var pageInfo = dt.page.info();
		var lastFocus = this.s.lastFocus;

		if ( ! originalEvent) {
			originalEvent = null;
		}

		if ( ! this.s.enable ) {
			return;
		}

		if ( typeof row !== 'number' ) {
			// Its an API instance - check that there is actually a row
			if ( ! row.any() ) {
				return;
			}

			// Convert the cell to a row and column
			var index = row.index();
			column = index.column;
			row = dt
				.rows( { filter: 'applied', order: 'applied' } )
				.indexes()
				.indexOf( index.row );
			
			// Don't focus rows that were filtered out.
			if ( row < 0 ) {
				return;
			}

			// For server-side processing normalise the row by adding the start
			// point, since `rows().indexes()` includes only rows that are
			// available at the client-side
			if ( pageInfo.serverSide ) {
				row += pageInfo.start;
			}
		}

		// Is the row on the current page? If not, we need to redraw to show the
		// page
		if ( pageInfo.length !== -1 && (row < pageInfo.start || row >= pageInfo.start+pageInfo.length) ) {
			this.s.focusDraw = true;
			this.s.waitingForDraw = true;

			dt
				.one( 'draw', function () {
					that.s.focusDraw = false;
					that.s.waitingForDraw = false;
					that._focus( row, column, undefined, originalEvent );
				} )
				.page( Math.floor( row / pageInfo.length ) )
				.draw( false );

			return;
		}

		// In the available columns?
		if ( $.inArray( column, this._columns() ) === -1 ) {
			return;
		}

		// De-normalise the server-side processing row, so we select the row
		// in its displayed position
		if ( pageInfo.serverSide ) {
			row -= pageInfo.start;
		}

		// Get the cell from the current position - ignoring any cells which might
		// not have been rendered (therefore can't use `:eq()` selector).
		var cells = dt.cells( null, column, {search: 'applied', order: 'applied'} ).flatten();
		var cell = dt.cell( cells[ row ] );

		if ( lastFocus ) {
			// Don't trigger a refocus on the same cell
			if ( lastFocus.node === cell.node() ) {
				this._emitEvent( 'key-refocus', [ this.s.dt, cell, originalEvent || null ] );
				return;
			}

			// Otherwise blur the old focus
			this._blur();
		}

		var node = $( cell.node() );
		node.addClass( this.c.className );

		this._updateFixedColumns(column);

		// Shift viewpoint and page to make cell visible
		if ( shift === undefined || shift === true ) {
			this._scroll( $(window), $(document.body), node, 'offset' );

			var bodyParent = dt.table().body().parentNode;
			if ( bodyParent !== dt.table().header().parentNode ) {
				var parent = $(bodyParent.parentNode);

				this._scroll( parent, parent, node, 'position' );
			}
		}

		// Event and finish
		this.s.lastFocus = {
			cell: cell,
			node: cell.node(),
			relative: {
				row: dt.rows( { page: 'current' } ).indexes().indexOf( cell.index().row ),
				column: cell.index().column
			}
		};

		this._emitEvent( 'key-focus', [ this.s.dt, cell, originalEvent || null ] );
		dt.state.save();
	},


	/**
	 * Handle key press
	 *
	 * @param  {object} e Event
	 * @private
	 */
	_key: function ( e )
	{
		// If we are waiting for a draw to happen from another key event, then
		// do nothing for this new key press.
		if ( this.s.waitingForDraw ) {
			e.preventDefault();
			return;
		}

		var enable = this.s.enable;
		var navEnable = enable === true || enable === 'navigation-only';
		if ( ! enable ) {
			return;
		}

		if ( (e.keyCode === 0 || e.ctrlKey || e.metaKey || e.altKey) && !(e.ctrlKey && e.altKey) ) {
			return;
		}

		// If not focused, then there is no key action to take
		var lastFocus = this.s.lastFocus;
		if ( ! lastFocus ) {
			return;
		}

		var that = this;
		var dt = this.s.dt;
		var scrolling = this.s.dt.settings()[0].oScroll.sY ? true : false;

		// If we are not listening for this key, do nothing
		if ( this.c.keys && $.inArray( e.keyCode, this.c.keys ) === -1 ) {
			return;
		}

		switch( e.keyCode ) {
			case 9: // tab
				// `enable` can be tab-only
				this._shift( e, e.shiftKey ? 'left' : 'right', true );
				break;

			case 27: // esc
				if ( this.s.blurable && enable === true ) {
					this._blur();
				}
				break;

			case 33: // page up (previous page)
			case 34: // page down (next page)
				if ( navEnable && !scrolling ) {
					e.preventDefault();

					dt
						.page( e.keyCode === 33 ? 'previous' : 'next' )
						.draw( false );
				}
				break;

			case 35: // end (end of current page)
			case 36: // home (start of current page)
				if ( navEnable ) {
					e.preventDefault();
					var indexes = dt.cells( {page: 'current'} ).indexes();
					var colIndexes = this._columns();

					this._focus( dt.cell(
						indexes[ e.keyCode === 35 ? indexes.length-1 : colIndexes[0] ]
					), null, true, e );
				}
				break;

			case 37: // left arrow
				if ( navEnable ) {
					this._shift( e, 'left' );
				}
				break;

			case 38: // up arrow
				if ( navEnable ) {
					this._shift( e, 'up' );
				}
				break;

			case 39: // right arrow
				if ( navEnable ) {
					this._shift( e, 'right' );
				}
				break;

			case 40: // down arrow
				if ( navEnable ) {
					this._shift( e, 'down' );
				}
				break;

			default:
				// Everything else - pass through only when fully enabled
				if ( enable === true ) {
					this._emitEvent( 'key', [ dt, e.keyCode, this.s.lastFocus.cell, e ] );
				}
				break;
		}
	},


	/**
	 * Scroll a container to make a cell visible in it. This can be used for
	 * both DataTables scrolling and native window scrolling.
	 *
	 * @param  {jQuery} container Scrolling container
	 * @param  {jQuery} scroller  Item being scrolled
	 * @param  {jQuery} cell      Cell in the scroller
	 * @param  {string} posOff    `position` or `offset` - which to use for the
	 *   calculation. `offset` for the document, otherwise `position`
	 * @private
	 */
	_scroll: function ( container, scroller, cell, posOff )
	{
		var offset = cell[posOff]();
		var height = cell.outerHeight();
		var width = cell.outerWidth();

		var scrollTop = scroller.scrollTop();
		var scrollLeft = scroller.scrollLeft();
		var containerHeight = container.height();
		var containerWidth = container.width();

		// If Scroller is being used, the table can be `position: absolute` and that
		// needs to be taken account of in the offset. If no Scroller, this will be 0
		if ( posOff === 'position' ) {
			offset.top += parseInt( cell.closest('table').css('top'), 10 );
		}

		// Top correction
		if ( offset.top < scrollTop ) {
			scroller.scrollTop( offset.top );
		}

		// Left correction
		if ( offset.left < scrollLeft ) {
			scroller.scrollLeft( offset.left );
		}

		// Bottom correction
		if ( offset.top + height > scrollTop + containerHeight && height < containerHeight ) {
			scroller.scrollTop( offset.top + height - containerHeight );
		}

		// Right correction
		if ( offset.left + width > scrollLeft + containerWidth && width < containerWidth ) {
			scroller.scrollLeft( offset.left + width - containerWidth );
		}
	},


	/**
	 * Calculate a single offset movement in the table - up, down, left and
	 * right and then perform the focus if possible
	 *
	 * @param  {object}  e           Event object
	 * @param  {string}  direction   Movement direction
	 * @param  {boolean} keyBlurable `true` if the key press can result in the
	 *   table being blurred. This is so arrow keys won't blur the table, but
	 *   tab will.
	 * @private
	 */
	_shift: function ( e, direction, keyBlurable )
	{
		var that         = this;
		var dt           = this.s.dt;
		var pageInfo     = dt.page.info();
		var rows         = pageInfo.recordsDisplay;
		var currentCell  = this.s.lastFocus.cell;
		var columns      = this._columns();

		if ( ! currentCell ) {
			return;
		}

		var currRow = dt
			.rows( { filter: 'applied', order: 'applied' } )
			.indexes()
			.indexOf( currentCell.index().row );

		// When server-side processing, `rows().indexes()` only gives the rows
		// that are available at the client-side, so we need to normalise the
		// row's current position by the display start point
		if ( pageInfo.serverSide ) {
			currRow += pageInfo.start;
		}

		var currCol = dt
			.columns( columns )
			.indexes()
			.indexOf( currentCell.index().column );

		var
			row = currRow,
			column = columns[ currCol ]; // row is the display, column is an index

		if ( direction === 'right' ) {
			if ( currCol >= columns.length - 1 ) {
				row++;
				column = columns[0];
			}
			else {
				column = columns[ currCol+1 ];
			}
		}
		else if ( direction === 'left' ) {
			if ( currCol === 0 ) {
				row--;
				column = columns[ columns.length - 1 ];
			}
			else {
				column = columns[ currCol-1 ];
			}
		}
		else if ( direction === 'up' ) {
			row--;
		}
		else if ( direction === 'down' ) {
			row++;
		}

		if ( row >= 0 && row < rows && $.inArray( column, columns ) !== -1
		) {
			e.preventDefault();

			this._focus( row, column, true, e );
		}
		else if ( ! keyBlurable || ! this.c.blurable ) {
			// No new focus, but if the table isn't blurable, then don't loose
			// focus
			e.preventDefault();
		}
		else {
			this._blur();
		}
	},


	/**
	 * Create a hidden input element that can receive focus on behalf of the
	 * table
	 *
	 * @private
	 */
	_tabInput: function ()
	{
		var that = this;
		var dt = this.s.dt;
		var tabIndex = this.c.tabIndex !== null ?
			this.c.tabIndex :
			dt.settings()[0].iTabIndex;

		if ( tabIndex == -1 ) {
			return;
		}

		var div = $('<div><input type="text" tabindex="'+tabIndex+'"/></div>')
			.css( {
				position: 'absolute',
				height: 1,
				width: 0,
				overflow: 'hidden'
			} )
			.insertBefore( dt.table().node() );

		div.children().on( 'focus', function (e) {
			if ( dt.cell(':eq(0)', {page: 'current'}).any() ) {
				that._focus( dt.cell(':eq(0)', '0:visible', {page: 'current'}), null, true, e );
			}
		} );
	},

	/**
	 * Update fixed columns if they are enabled and if the cell we are
	 * focusing is inside a fixed column
	 * @param  {integer} column Index of the column being changed
	 * @private
	 */
	_updateFixedColumns: function( column )
	{
		var dt = this.s.dt;
		var settings = dt.settings()[0];

		if ( settings._oFixedColumns ) {
			var leftCols = settings._oFixedColumns.s.iLeftColumns;
			var rightCols = settings.aoColumns.length - settings._oFixedColumns.s.iRightColumns;

			if (column < leftCols || column >= rightCols) {
				dt.fixedColumns().update();
			}
		}
	}
} );


/**
 * KeyTable default settings for initialisation
 *
 * @namespace
 * @name KeyTable.defaults
 * @static
 */
KeyTable.defaults = {
	/**
	 * Can focus be removed from the table
	 * @type {Boolean}
	 */
	blurable: true,

	/**
	 * Class to give to the focused cell
	 * @type {String}
	 */
	className: 'focus',

	/**
	 * Enable or disable clipboard support
	 * @type {Boolean}
	 */
	clipboard: true,

	/**
	 * Orthogonal data that should be copied to clipboard
	 * @type {string}
	 */
	clipboardOrthogonal: 'display',

	/**
	 * Columns that can be focused. This is automatically merged with the
	 * visible columns as only visible columns can gain focus.
	 * @type {String}
	 */
	columns: '', // all

	/**
	 * Editor instance to automatically perform Excel like navigation
	 * @type {Editor}
	 */
	editor: null,

	/**
	 * Trigger editing immediately on focus
	 * @type {boolean}
	 */
	editOnFocus: false,

	/**
	 * Select a cell to automatically select on start up. `null` for no
	 * automatic selection
	 * @type {cell-selector}
	 */
	focus: null,

	/**
	 * Array of keys to listen for
	 * @type {null|array}
	 */
	keys: null,

	/**
	 * Tab index for where the table should sit in the document's tab flow
	 * @type {integer|null}
	 */
	tabIndex: null
};



KeyTable.version = "2.5.0";


$.fn.dataTable.KeyTable = KeyTable;
$.fn.DataTable.KeyTable = KeyTable;


DataTable.Api.register( 'cell.blur()', function () {
	return this.iterator( 'table', function (ctx) {
		if ( ctx.keytable ) {
			ctx.keytable.blur();
		}
	} );
} );

DataTable.Api.register( 'cell().focus()', function () {
	return this.iterator( 'cell', function (ctx, row, column) {
		if ( ctx.keytable ) {
			ctx.keytable.focus( row, column );
		}
	} );
} );

DataTable.Api.register( 'keys.disable()', function () {
	return this.iterator( 'table', function (ctx) {
		if ( ctx.keytable ) {
			ctx.keytable.enable( false );
		}
	} );
} );

DataTable.Api.register( 'keys.enable()', function ( opts ) {
	return this.iterator( 'table', function (ctx) {
		if ( ctx.keytable ) {
			ctx.keytable.enable( opts === undefined ? true : opts );
		}
	} );
} );

// Cell selector
DataTable.ext.selector.cell.push( function ( settings, opts, cells ) {
	var focused = opts.focused;
	var kt = settings.keytable;
	var out = [];

	if ( ! kt || focused === undefined ) {
		return cells;
	}

	for ( var i=0, ien=cells.length ; i<ien ; i++ ) {
		if ( (focused === true &&  kt.focused( cells[i] ) ) ||
			 (focused === false && ! kt.focused( cells[i] ) )
		) {
			out.push( cells[i] );
		}
	}

	return out;
} );


// Attach a listener to the document which listens for DataTables initialisation
// events so we can automatically initialise
$(document).on( 'preInit.dt.dtk', function (e, settings, json) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	var init = settings.oInit.keys;
	var defaults = DataTable.defaults.keys;

	if ( init || defaults ) {
		var opts = $.extend( {}, defaults, init );

		if ( init !== false ) {
			new KeyTable( settings, opts  );
		}
	}
} );


return KeyTable;
}));


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Responsive 2.2.3
 * 2014-2018 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     Responsive
 * @description Responsive tables plug-in for DataTables
 * @version     2.2.3
 * @file        dataTables.responsive.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     www.sprymedia.co.uk/contact
 * @copyright   Copyright 2014-2018 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */
(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


/**
 * Responsive is a plug-in for the DataTables library that makes use of
 * DataTables' ability to change the visibility of columns, changing the
 * visibility of columns so the displayed columns fit into the table container.
 * The end result is that complex tables will be dynamically adjusted to fit
 * into the viewport, be it on a desktop, tablet or mobile browser.
 *
 * Responsive for DataTables has two modes of operation, which can used
 * individually or combined:
 *
 * * Class name based control - columns assigned class names that match the
 *   breakpoint logic can be shown / hidden as required for each breakpoint.
 * * Automatic control - columns are automatically hidden when there is no
 *   room left to display them. Columns removed from the right.
 *
 * In additional to column visibility control, Responsive also has built into
 * options to use DataTables' child row display to show / hide the information
 * from the table that has been hidden. There are also two modes of operation
 * for this child row display:
 *
 * * Inline - when the control element that the user can use to show / hide
 *   child rows is displayed inside the first column of the table.
 * * Column - where a whole column is dedicated to be the show / hide control.
 *
 * Initialisation of Responsive is performed by:
 *
 * * Adding the class `responsive` or `dt-responsive` to the table. In this case
 *   Responsive will automatically be initialised with the default configuration
 *   options when the DataTable is created.
 * * Using the `responsive` option in the DataTables configuration options. This
 *   can also be used to specify the configuration options, or simply set to
 *   `true` to use the defaults.
 *
 *  @class
 *  @param {object} settings DataTables settings object for the host table
 *  @param {object} [opts] Configuration options
 *  @requires jQuery 1.7+
 *  @requires DataTables 1.10.3+
 *
 *  @example
 *      $('#example').DataTable( {
 *        responsive: true
 *      } );
 *    } );
 */
var Responsive = function ( settings, opts ) {
	// Sanity check that we are using DataTables 1.10 or newer
	if ( ! DataTable.versionCheck || ! DataTable.versionCheck( '1.10.10' ) ) {
		throw 'DataTables Responsive requires DataTables 1.10.10 or newer';
	}

	this.s = {
		dt: new DataTable.Api( settings ),
		columns: [],
		current: []
	};

	// Check if responsive has already been initialised on this table
	if ( this.s.dt.settings()[0].responsive ) {
		return;
	}

	// details is an object, but for simplicity the user can give it as a string
	// or a boolean
	if ( opts && typeof opts.details === 'string' ) {
		opts.details = { type: opts.details };
	}
	else if ( opts && opts.details === false ) {
		opts.details = { type: false };
	}
	else if ( opts && opts.details === true ) {
		opts.details = { type: 'inline' };
	}

	this.c = $.extend( true, {}, Responsive.defaults, DataTable.defaults.responsive, opts );
	settings.responsive = this;
	this._constructor();
};

$.extend( Responsive.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */

	/**
	 * Initialise the Responsive instance
	 *
	 * @private
	 */
	_constructor: function ()
	{
		var that = this;
		var dt = this.s.dt;
		var dtPrivateSettings = dt.settings()[0];
		var oldWindowWidth = $(window).width();

		dt.settings()[0]._responsive = this;

		// Use DataTables' throttle function to avoid processor thrashing on
		// resize
		$(window).on( 'resize.dtr orientationchange.dtr', DataTable.util.throttle( function () {
			// iOS has a bug whereby resize can fire when only scrolling
			// See: http://stackoverflow.com/questions/8898412
			var width = $(window).width();

			if ( width !== oldWindowWidth ) {
				that._resize();
				oldWindowWidth = width;
			}
		} ) );

		// DataTables doesn't currently trigger an event when a row is added, so
		// we need to hook into its private API to enforce the hidden rows when
		// new data is added
		dtPrivateSettings.oApi._fnCallbackReg( dtPrivateSettings, 'aoRowCreatedCallback', function (tr, data, idx) {
			if ( $.inArray( false, that.s.current ) !== -1 ) {
				$('>td, >th', tr).each( function ( i ) {
					var idx = dt.column.index( 'toData', i );

					if ( that.s.current[idx] === false ) {
						$(this).css('display', 'none');
					}
				} );
			}
		} );

		// Destroy event handler
		dt.on( 'destroy.dtr', function () {
			dt.off( '.dtr' );
			$( dt.table().body() ).off( '.dtr' );
			$(window).off( 'resize.dtr orientationchange.dtr' );

			// Restore the columns that we've hidden
			$.each( that.s.current, function ( i, val ) {
				if ( val === false ) {
					that._setColumnVis( i, true );
				}
			} );
		} );

		// Reorder the breakpoints array here in case they have been added out
		// of order
		this.c.breakpoints.sort( function (a, b) {
			return a.width < b.width ? 1 :
				a.width > b.width ? -1 : 0;
		} );

		this._classLogic();
		this._resizeAuto();

		// Details handler
		var details = this.c.details;

		if ( details.type !== false ) {
			that._detailsInit();

			// DataTables will trigger this event on every column it shows and
			// hides individually
			dt.on( 'column-visibility.dtr', function () {
				// Use a small debounce to allow multiple columns to be set together
				if ( that._timer ) {
					clearTimeout( that._timer );
				}

				that._timer = setTimeout( function () {
					that._timer = null;

					that._classLogic();
					that._resizeAuto();
					that._resize();

					that._redrawChildren();
				}, 100 );
			} );

			// Redraw the details box on each draw which will happen if the data
			// has changed. This is used until DataTables implements a native
			// `updated` event for rows
			dt.on( 'draw.dtr', function () {
				that._redrawChildren();
			} );

			$(dt.table().node()).addClass( 'dtr-'+details.type );
		}

		dt.on( 'column-reorder.dtr', function (e, settings, details) {
			that._classLogic();
			that._resizeAuto();
			that._resize();
		} );

		// Change in column sizes means we need to calc
		dt.on( 'column-sizing.dtr', function () {
			that._resizeAuto();
			that._resize();
		});

		// On Ajax reload we want to reopen any child rows which are displayed
		// by responsive
		dt.on( 'preXhr.dtr', function () {
			var rowIds = [];
			dt.rows().every( function () {
				if ( this.child.isShown() ) {
					rowIds.push( this.id(true) );
				}
			} );

			dt.one( 'draw.dtr', function () {
				that._resizeAuto();
				that._resize();

				dt.rows( rowIds ).every( function () {
					that._detailsDisplay( this, false );
				} );
			} );
		});

		dt.on( 'init.dtr', function (e, settings, details) {
			that._resizeAuto();
			that._resize();

			// If columns were hidden, then DataTables needs to adjust the
			// column sizing
			if ( $.inArray( false, that.s.current ) ) {
				dt.columns.adjust();
			}
		} );

		// First pass - draw the table for the current viewport size
		this._resize();
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */

	/**
	 * Calculate the visibility for the columns in a table for a given
	 * breakpoint. The result is pre-determined based on the class logic if
	 * class names are used to control all columns, but the width of the table
	 * is also used if there are columns which are to be automatically shown
	 * and hidden.
	 *
	 * @param  {string} breakpoint Breakpoint name to use for the calculation
	 * @return {array} Array of boolean values initiating the visibility of each
	 *   column.
	 *  @private
	 */
	_columnsVisiblity: function ( breakpoint )
	{
		var dt = this.s.dt;
		var columns = this.s.columns;
		var i, ien;

		// Create an array that defines the column ordering based first on the
		// column's priority, and secondly the column index. This allows the
		// columns to be removed from the right if the priority matches
		var order = columns
			.map( function ( col, idx ) {
				return {
					columnIdx: idx,
					priority: col.priority
				};
			} )
			.sort( function ( a, b ) {
				if ( a.priority !== b.priority ) {
					return a.priority - b.priority;
				}
				return a.columnIdx - b.columnIdx;
			} );

		// Class logic - determine which columns are in this breakpoint based
		// on the classes. If no class control (i.e. `auto`) then `-` is used
		// to indicate this to the rest of the function
		var display = $.map( columns, function ( col, i ) {
			if ( dt.column(i).visible() === false ) {
				return 'not-visible';
			}
			return col.auto && col.minWidth === null ?
				false :
				col.auto === true ?
					'-' :
					$.inArray( breakpoint, col.includeIn ) !== -1;
		} );

		// Auto column control - first pass: how much width is taken by the
		// ones that must be included from the non-auto columns
		var requiredWidth = 0;
		for ( i=0, ien=display.length ; i<ien ; i++ ) {
			if ( display[i] === true ) {
				requiredWidth += columns[i].minWidth;
			}
		}

		// Second pass, use up any remaining width for other columns. For
		// scrolling tables we need to subtract the width of the scrollbar. It
		// may not be requires which makes this sub-optimal, but it would
		// require another full redraw to make complete use of those extra few
		// pixels
		var scrolling = dt.settings()[0].oScroll;
		var bar = scrolling.sY || scrolling.sX ? scrolling.iBarWidth : 0;
		var widthAvailable = dt.table().container().offsetWidth - bar;
		var usedWidth = widthAvailable - requiredWidth;

		// Control column needs to always be included. This makes it sub-
		// optimal in terms of using the available with, but to stop layout
		// thrashing or overflow. Also we need to account for the control column
		// width first so we know how much width is available for the other
		// columns, since the control column might not be the first one shown
		for ( i=0, ien=display.length ; i<ien ; i++ ) {
			if ( columns[i].control ) {
				usedWidth -= columns[i].minWidth;
			}
		}

		// Allow columns to be shown (counting by priority and then right to
		// left) until we run out of room
		var empty = false;
		for ( i=0, ien=order.length ; i<ien ; i++ ) {
			var colIdx = order[i].columnIdx;

			if ( display[colIdx] === '-' && ! columns[colIdx].control && columns[colIdx].minWidth ) {
				// Once we've found a column that won't fit we don't let any
				// others display either, or columns might disappear in the
				// middle of the table
				if ( empty || usedWidth - columns[colIdx].minWidth < 0 ) {
					empty = true;
					display[colIdx] = false;
				}
				else {
					display[colIdx] = true;
				}

				usedWidth -= columns[colIdx].minWidth;
			}
		}

		// Determine if the 'control' column should be shown (if there is one).
		// This is the case when there is a hidden column (that is not the
		// control column). The two loops look inefficient here, but they are
		// trivial and will fly through. We need to know the outcome from the
		// first , before the action in the second can be taken
		var showControl = false;

		for ( i=0, ien=columns.length ; i<ien ; i++ ) {
			if ( ! columns[i].control && ! columns[i].never && display[i] === false ) {
				showControl = true;
				break;
			}
		}

		for ( i=0, ien=columns.length ; i<ien ; i++ ) {
			if ( columns[i].control ) {
				display[i] = showControl;
			}

			// Replace not visible string with false from the control column detection above
			if ( display[i] === 'not-visible' ) {
				display[i] = false;
			}
		}

		// Finally we need to make sure that there is at least one column that
		// is visible
		if ( $.inArray( true, display ) === -1 ) {
			display[0] = true;
		}

		return display;
	},


	/**
	 * Create the internal `columns` array with information about the columns
	 * for the table. This includes determining which breakpoints the column
	 * will appear in, based upon class names in the column, which makes up the
	 * vast majority of this method.
	 *
	 * @private
	 */
	_classLogic: function ()
	{
		var that = this;
		var calc = {};
		var breakpoints = this.c.breakpoints;
		var dt = this.s.dt;
		var columns = dt.columns().eq(0).map( function (i) {
			var column = this.column(i);
			var className = column.header().className;
			var priority = dt.settings()[0].aoColumns[i].responsivePriority;

			if ( priority === undefined ) {
				var dataPriority = $(column.header()).data('priority');

				priority = dataPriority !== undefined ?
					dataPriority * 1 :
					10000;
			}

			return {
				className: className,
				includeIn: [],
				auto:      false,
				control:   false,
				never:     className.match(/\bnever\b/) ? true : false,
				priority:  priority
			};
		} );

		// Simply add a breakpoint to `includeIn` array, ensuring that there are
		// no duplicates
		var add = function ( colIdx, name ) {
			var includeIn = columns[ colIdx ].includeIn;

			if ( $.inArray( name, includeIn ) === -1 ) {
				includeIn.push( name );
			}
		};

		var column = function ( colIdx, name, operator, matched ) {
			var size, i, ien;

			if ( ! operator ) {
				columns[ colIdx ].includeIn.push( name );
			}
			else if ( operator === 'max-' ) {
				// Add this breakpoint and all smaller
				size = that._find( name ).width;

				for ( i=0, ien=breakpoints.length ; i<ien ; i++ ) {
					if ( breakpoints[i].width <= size ) {
						add( colIdx, breakpoints[i].name );
					}
				}
			}
			else if ( operator === 'min-' ) {
				// Add this breakpoint and all larger
				size = that._find( name ).width;

				for ( i=0, ien=breakpoints.length ; i<ien ; i++ ) {
					if ( breakpoints[i].width >= size ) {
						add( colIdx, breakpoints[i].name );
					}
				}
			}
			else if ( operator === 'not-' ) {
				// Add all but this breakpoint
				for ( i=0, ien=breakpoints.length ; i<ien ; i++ ) {
					if ( breakpoints[i].name.indexOf( matched ) === -1 ) {
						add( colIdx, breakpoints[i].name );
					}
				}
			}
		};

		// Loop over each column and determine if it has a responsive control
		// class
		columns.each( function ( col, i ) {
			var classNames = col.className.split(' ');
			var hasClass = false;

			// Split the class name up so multiple rules can be applied if needed
			for ( var k=0, ken=classNames.length ; k<ken ; k++ ) {
				var className = $.trim( classNames[k] );

				if ( className === 'all' ) {
					// Include in all
					hasClass = true;
					col.includeIn = $.map( breakpoints, function (a) {
						return a.name;
					} );
					return;
				}
				else if ( className === 'none' || col.never ) {
					// Include in none (default) and no auto
					hasClass = true;
					return;
				}
				else if ( className === 'control' ) {
					// Special column that is only visible, when one of the other
					// columns is hidden. This is used for the details control
					hasClass = true;
					col.control = true;
					return;
				}

				$.each( breakpoints, function ( j, breakpoint ) {
					// Does this column have a class that matches this breakpoint?
					var brokenPoint = breakpoint.name.split('-');
					var re = new RegExp( '(min\\-|max\\-|not\\-)?('+brokenPoint[0]+')(\\-[_a-zA-Z0-9])?' );
					var match = className.match( re );

					if ( match ) {
						hasClass = true;

						if ( match[2] === brokenPoint[0] && match[3] === '-'+brokenPoint[1] ) {
							// Class name matches breakpoint name fully
							column( i, breakpoint.name, match[1], match[2]+match[3] );
						}
						else if ( match[2] === brokenPoint[0] && ! match[3] ) {
							// Class name matched primary breakpoint name with no qualifier
							column( i, breakpoint.name, match[1], match[2] );
						}
					}
				} );
			}

			// If there was no control class, then automatic sizing is used
			if ( ! hasClass ) {
				col.auto = true;
			}
		} );

		this.s.columns = columns;
	},


	/**
	 * Show the details for the child row
	 *
	 * @param  {DataTables.Api} row    API instance for the row
	 * @param  {boolean}        update Update flag
	 * @private
	 */
	_detailsDisplay: function ( row, update )
	{
		var that = this;
		var dt = this.s.dt;
		var details = this.c.details;

		if ( details && details.type !== false ) {
			var res = details.display( row, update, function () {
				return details.renderer(
					dt, row[0], that._detailsObj(row[0])
				);
			} );

			if ( res === true || res === false ) {
				$(dt.table().node()).triggerHandler( 'responsive-display.dt', [dt, row, res, update] );
			}
		}
	},


	/**
	 * Initialisation for the details handler
	 *
	 * @private
	 */
	_detailsInit: function ()
	{
		var that    = this;
		var dt      = this.s.dt;
		var details = this.c.details;

		// The inline type always uses the first child as the target
		if ( details.type === 'inline' ) {
			details.target = 'td:first-child, th:first-child';
		}

		// Keyboard accessibility
		dt.on( 'draw.dtr', function () {
			that._tabIndexes();
		} );
		that._tabIndexes(); // Initial draw has already happened

		$( dt.table().body() ).on( 'keyup.dtr', 'td, th', function (e) {
			if ( e.keyCode === 13 && $(this).data('dtr-keyboard') ) {
				$(this).click();
			}
		} );

		// type.target can be a string jQuery selector or a column index
		var target   = details.target;
		var selector = typeof target === 'string' ? target : 'td, th';

		// Click handler to show / hide the details rows when they are available
		$( dt.table().body() )
			.on( 'click.dtr mousedown.dtr mouseup.dtr', selector, function (e) {
				// If the table is not collapsed (i.e. there is no hidden columns)
				// then take no action
				if ( ! $(dt.table().node()).hasClass('collapsed' ) ) {
					return;
				}

				// Check that the row is actually a DataTable's controlled node
				if ( $.inArray( $(this).closest('tr').get(0), dt.rows().nodes().toArray() ) === -1 ) {
					return;
				}

				// For column index, we determine if we should act or not in the
				// handler - otherwise it is already okay
				if ( typeof target === 'number' ) {
					var targetIdx = target < 0 ?
						dt.columns().eq(0).length + target :
						target;

					if ( dt.cell( this ).index().column !== targetIdx ) {
						return;
					}
				}

				// $().closest() includes itself in its check
				var row = dt.row( $(this).closest('tr') );

				// Check event type to do an action
				if ( e.type === 'click' ) {
					// The renderer is given as a function so the caller can execute it
					// only when they need (i.e. if hiding there is no point is running
					// the renderer)
					that._detailsDisplay( row, false );
				}
				else if ( e.type === 'mousedown' ) {
					// For mouse users, prevent the focus ring from showing
					$(this).css('outline', 'none');
				}
				else if ( e.type === 'mouseup' ) {
					// And then re-allow at the end of the click
					$(this).blur().css('outline', '');
				}
			} );
	},


	/**
	 * Get the details to pass to a renderer for a row
	 * @param  {int} rowIdx Row index
	 * @private
	 */
	_detailsObj: function ( rowIdx )
	{
		var that = this;
		var dt = this.s.dt;

		return $.map( this.s.columns, function( col, i ) {
			// Never and control columns should not be passed to the renderer
			if ( col.never || col.control ) {
				return;
			}

			return {
				title:       dt.settings()[0].aoColumns[ i ].sTitle,
				data:        dt.cell( rowIdx, i ).render( that.c.orthogonal ),
				hidden:      dt.column( i ).visible() && !that.s.current[ i ],
				columnIndex: i,
				rowIndex:    rowIdx
			};
		} );
	},


	/**
	 * Find a breakpoint object from a name
	 *
	 * @param  {string} name Breakpoint name to find
	 * @return {object}      Breakpoint description object
	 * @private
	 */
	_find: function ( name )
	{
		var breakpoints = this.c.breakpoints;

		for ( var i=0, ien=breakpoints.length ; i<ien ; i++ ) {
			if ( breakpoints[i].name === name ) {
				return breakpoints[i];
			}
		}
	},


	/**
	 * Re-create the contents of the child rows as the display has changed in
	 * some way.
	 *
	 * @private
	 */
	_redrawChildren: function ()
	{
		var that = this;
		var dt = this.s.dt;

		dt.rows( {page: 'current'} ).iterator( 'row', function ( settings, idx ) {
			var row = dt.row( idx );

			that._detailsDisplay( dt.row( idx ), true );
		} );
	},


	/**
	 * Alter the table display for a resized viewport. This involves first
	 * determining what breakpoint the window currently is in, getting the
	 * column visibilities to apply and then setting them.
	 *
	 * @private
	 */
	_resize: function ()
	{
		var that = this;
		var dt = this.s.dt;
		var width = $(window).width();
		var breakpoints = this.c.breakpoints;
		var breakpoint = breakpoints[0].name;
		var columns = this.s.columns;
		var i, ien;
		var oldVis = this.s.current.slice();

		// Determine what breakpoint we are currently at
		for ( i=breakpoints.length-1 ; i>=0 ; i-- ) {
			if ( width <= breakpoints[i].width ) {
				breakpoint = breakpoints[i].name;
				break;
			}
		}
		
		// Show the columns for that break point
		var columnsVis = this._columnsVisiblity( breakpoint );
		this.s.current = columnsVis;

		// Set the class before the column visibility is changed so event
		// listeners know what the state is. Need to determine if there are
		// any columns that are not visible but can be shown
		var collapsedClass = false;
		for ( i=0, ien=columns.length ; i<ien ; i++ ) {
			if ( columnsVis[i] === false && ! columns[i].never && ! columns[i].control && ! dt.column(i).visible() === false ) {
				collapsedClass = true;
				break;
			}
		}

		$( dt.table().node() ).toggleClass( 'collapsed', collapsedClass );

		var changed = false;
		var visible = 0;

		dt.columns().eq(0).each( function ( colIdx, i ) {
			if ( columnsVis[i] === true ) {
				visible++;
			}

			if ( columnsVis[i] !== oldVis[i] ) {
				changed = true;
				that._setColumnVis( colIdx, columnsVis[i] );
			}
		} );

		if ( changed ) {
			this._redrawChildren();

			// Inform listeners of the change
			$(dt.table().node()).trigger( 'responsive-resize.dt', [dt, this.s.current] );

			// If no records, update the "No records" display element
			if ( dt.page.info().recordsDisplay === 0 ) {
				$('td', dt.table().body()).eq(0).attr('colspan', visible);
			}
		}
	},


	/**
	 * Determine the width of each column in the table so the auto column hiding
	 * has that information to work with. This method is never going to be 100%
	 * perfect since column widths can change slightly per page, but without
	 * seriously compromising performance this is quite effective.
	 *
	 * @private
	 */
	_resizeAuto: function ()
	{
		var dt = this.s.dt;
		var columns = this.s.columns;

		// Are we allowed to do auto sizing?
		if ( ! this.c.auto ) {
			return;
		}

		// Are there any columns that actually need auto-sizing, or do they all
		// have classes defined
		if ( $.inArray( true, $.map( columns, function (c) { return c.auto; } ) ) === -1 ) {
			return;
		}

		// Need to restore all children. They will be reinstated by a re-render
		if ( ! $.isEmptyObject( _childNodeStore ) ) {
			$.each( _childNodeStore, function ( key ) {
				var idx = key.split('-');

				_childNodesRestore( dt, idx[0]*1, idx[1]*1 );
			} );
		}

		// Clone the table with the current data in it
		var tableWidth   = dt.table().node().offsetWidth;
		var columnWidths = dt.columns;
		var clonedTable  = dt.table().node().cloneNode( false );
		var clonedHeader = $( dt.table().header().cloneNode( false ) ).appendTo( clonedTable );
		var clonedBody   = $( dt.table().body() ).clone( false, false ).empty().appendTo( clonedTable ); // use jQuery because of IE8

		// Header
		var headerCells = dt.columns()
			.header()
			.filter( function (idx) {
				return dt.column(idx).visible();
			} )
			.to$()
			.clone( false )
			.css( 'display', 'table-cell' )
			.css( 'min-width', 0 );

		// Body rows - we don't need to take account of DataTables' column
		// visibility since we implement our own here (hence the `display` set)
		$(clonedBody)
			.append( $(dt.rows( { page: 'current' } ).nodes()).clone( false ) )
			.find( 'th, td' ).css( 'display', '' );

		// Footer
		var footer = dt.table().footer();
		if ( footer ) {
			var clonedFooter = $( footer.cloneNode( false ) ).appendTo( clonedTable );
			var footerCells = dt.columns()
				.footer()
				.filter( function (idx) {
					return dt.column(idx).visible();
				} )
				.to$()
				.clone( false )
				.css( 'display', 'table-cell' );

			$('<tr/>')
				.append( footerCells )
				.appendTo( clonedFooter );
		}

		$('<tr/>')
			.append( headerCells )
			.appendTo( clonedHeader );

		// In the inline case extra padding is applied to the first column to
		// give space for the show / hide icon. We need to use this in the
		// calculation
		if ( this.c.details.type === 'inline' ) {
			$(clonedTable).addClass( 'dtr-inline collapsed' );
		}
		
		// It is unsafe to insert elements with the same name into the DOM
		// multiple times. For example, cloning and inserting a checked radio
		// clears the chcecked state of the original radio.
		$( clonedTable ).find( '[name]' ).removeAttr( 'name' );

		// A position absolute table would take the table out of the flow of
		// our container element, bypassing the height and width (Scroller)
		$( clonedTable ).css( 'position', 'relative' )
		
		var inserted = $('<div/>')
			.css( {
				width: 1,
				height: 1,
				overflow: 'hidden',
				clear: 'both'
			} )
			.append( clonedTable );

		inserted.insertBefore( dt.table().node() );

		// The cloned header now contains the smallest that each column can be
		headerCells.each( function (i) {
			var idx = dt.column.index( 'fromVisible', i );
			columns[ idx ].minWidth =  this.offsetWidth || 0;
		} );

		inserted.remove();
	},

	/**
	 * Set a column's visibility.
	 *
	 * We don't use DataTables' column visibility controls in order to ensure
	 * that column visibility can Responsive can no-exist. Since only IE8+ is
	 * supported (and all evergreen browsers of course) the control of the
	 * display attribute works well.
	 *
	 * @param {integer} col      Column index
	 * @param {boolean} showHide Show or hide (true or false)
	 * @private
	 */
	_setColumnVis: function ( col, showHide )
	{
		var dt = this.s.dt;
		var display = showHide ? '' : 'none'; // empty string will remove the attr

		$( dt.column( col ).header() ).css( 'display', display );
		$( dt.column( col ).footer() ).css( 'display', display );
		dt.column( col ).nodes().to$().css( 'display', display );

		// If the are child nodes stored, we might need to reinsert them
		if ( ! $.isEmptyObject( _childNodeStore ) ) {
			dt.cells( null, col ).indexes().each( function (idx) {
				_childNodesRestore( dt, idx.row, idx.column );
			} );
		}
	},


	/**
	 * Update the cell tab indexes for keyboard accessibility. This is called on
	 * every table draw - that is potentially inefficient, but also the least
	 * complex option given that column visibility can change on the fly. Its a
	 * shame user-focus was removed from CSS 3 UI, as it would have solved this
	 * issue with a single CSS statement.
	 *
	 * @private
	 */
	_tabIndexes: function ()
	{
		var dt = this.s.dt;
		var cells = dt.cells( { page: 'current' } ).nodes().to$();
		var ctx = dt.settings()[0];
		var target = this.c.details.target;

		cells.filter( '[data-dtr-keyboard]' ).removeData( '[data-dtr-keyboard]' );

		if ( typeof target === 'number' ) {
			dt.cells( null, target, { page: 'current' } ).nodes().to$()
				.attr( 'tabIndex', ctx.iTabIndex )
				.data( 'dtr-keyboard', 1 );
		}
		else {
			// This is a bit of a hack - we need to limit the selected nodes to just
			// those of this table
			if ( target === 'td:first-child, th:first-child' ) {
				target = '>td:first-child, >th:first-child';
			}

			$( target, dt.rows( { page: 'current' } ).nodes() )
				.attr( 'tabIndex', ctx.iTabIndex )
				.data( 'dtr-keyboard', 1 );
		}
	}
} );


/**
 * List of default breakpoints. Each item in the array is an object with two
 * properties:
 *
 * * `name` - the breakpoint name.
 * * `width` - the breakpoint width
 *
 * @name Responsive.breakpoints
 * @static
 */
Responsive.breakpoints = [
	{ name: 'desktop',  width: Infinity },
	{ name: 'tablet-l', width: 1024 },
	{ name: 'tablet-p', width: 768 },
	{ name: 'mobile-l', width: 480 },
	{ name: 'mobile-p', width: 320 }
];


/**
 * Display methods - functions which define how the hidden data should be shown
 * in the table.
 *
 * @namespace
 * @name Responsive.defaults
 * @static
 */
Responsive.display = {
	childRow: function ( row, update, render ) {
		if ( update ) {
			if ( $(row.node()).hasClass('parent') ) {
				row.child( render(), 'child' ).show();

				return true;
			}
		}
		else {
			if ( ! row.child.isShown()  ) {
				row.child( render(), 'child' ).show();
				$( row.node() ).addClass( 'parent' );

				return true;
			}
			else {
				row.child( false );
				$( row.node() ).removeClass( 'parent' );

				return false;
			}
		}
	},

	childRowImmediate: function ( row, update, render ) {
		if ( (! update && row.child.isShown()) || ! row.responsive.hasHidden() ) {
			// User interaction and the row is show, or nothing to show
			row.child( false );
			$( row.node() ).removeClass( 'parent' );

			return false;
		}
		else {
			// Display
			row.child( render(), 'child' ).show();
			$( row.node() ).addClass( 'parent' );

			return true;
		}
	},

	// This is a wrapper so the modal options for Bootstrap and jQuery UI can
	// have options passed into them. This specific one doesn't need to be a
	// function but it is for consistency in the `modal` name
	modal: function ( options ) {
		return function ( row, update, render ) {
			if ( ! update ) {
				// Show a modal
				var close = function () {
					modal.remove(); // will tidy events for us
					$(document).off( 'keypress.dtr' );
				};

				var modal = $('<div class="dtr-modal"/>')
					.append( $('<div class="dtr-modal-display"/>')
						.append( $('<div class="dtr-modal-content"/>')
							.append( render() )
						)
						.append( $('<div class="dtr-modal-close">&times;</div>' )
							.click( function () {
								close();
							} )
						)
					)
					.append( $('<div class="dtr-modal-background"/>')
						.click( function () {
							close();
						} )
					)
					.appendTo( 'body' );

				$(document).on( 'keyup.dtr', function (e) {
					if ( e.keyCode === 27 ) {
						e.stopPropagation();

						close();
					}
				} );
			}
			else {
				$('div.dtr-modal-content')
					.empty()
					.append( render() );
			}

			if ( options && options.header ) {
				$('div.dtr-modal-content').prepend(
					'<h2>'+options.header( row )+'</h2>'
				);
			}
		};
	}
};


var _childNodeStore = {};

function _childNodes( dt, row, col ) {
	var name = row+'-'+col;

	if ( _childNodeStore[ name ] ) {
		return _childNodeStore[ name ];
	}

	// https://jsperf.com/childnodes-array-slice-vs-loop
	var nodes = [];
	var children = dt.cell( row, col ).node().childNodes;
	for ( var i=0, ien=children.length ; i<ien ; i++ ) {
		nodes.push( children[i] );
	}

	_childNodeStore[ name ] = nodes;

	return nodes;
}

function _childNodesRestore( dt, row, col ) {
	var name = row+'-'+col;

	if ( ! _childNodeStore[ name ] ) {
		return;
	}

	var node = dt.cell( row, col ).node();
	var store = _childNodeStore[ name ];
	var parent = store[0].parentNode;
	var parentChildren = parent.childNodes;
	var a = [];

	for ( var i=0, ien=parentChildren.length ; i<ien ; i++ ) {
		a.push( parentChildren[i] );
	}

	for ( var j=0, jen=a.length ; j<jen ; j++ ) {
		node.appendChild( a[j] );
	}

	_childNodeStore[ name ] = undefined;
}


/**
 * Display methods - functions which define how the hidden data should be shown
 * in the table.
 *
 * @namespace
 * @name Responsive.defaults
 * @static
 */
Responsive.renderer = {
	listHiddenNodes: function () {
		return function ( api, rowIdx, columns ) {
			var ul = $('<ul data-dtr-index="'+rowIdx+'" class="dtr-details"/>');
			var found = false;

			var data = $.each( columns, function ( i, col ) {
				if ( col.hidden ) {
					$(
						'<li data-dtr-index="'+col.columnIndex+'" data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
							'<span class="dtr-title">'+
								col.title+
							'</span> '+
						'</li>'
					)
						.append( $('<span class="dtr-data"/>').append( _childNodes( api, col.rowIndex, col.columnIndex ) ) )// api.cell( col.rowIndex, col.columnIndex ).node().childNodes ) )
						.appendTo( ul );

					found = true;
				}
			} );

			return found ?
				ul :
				false;
		};
	},

	listHidden: function () {
		return function ( api, rowIdx, columns ) {
			var data = $.map( columns, function ( col ) {
				return col.hidden ?
					'<li data-dtr-index="'+col.columnIndex+'" data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
						'<span class="dtr-title">'+
							col.title+
						'</span> '+
						'<span class="dtr-data">'+
							col.data+
						'</span>'+
					'</li>' :
					'';
			} ).join('');

			return data ?
				$('<ul data-dtr-index="'+rowIdx+'" class="dtr-details"/>').append( data ) :
				false;
		}
	},

	tableAll: function ( options ) {
		options = $.extend( {
			tableClass: ''
		}, options );

		return function ( api, rowIdx, columns ) {
			var data = $.map( columns, function ( col ) {
				return '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
						'<td>'+col.title+':'+'</td> '+
						'<td>'+col.data+'</td>'+
					'</tr>';
			} ).join('');

			return $('<table class="'+options.tableClass+' dtr-details" width="100%"/>').append( data );
		}
	}
};

/**
 * Responsive default settings for initialisation
 *
 * @namespace
 * @name Responsive.defaults
 * @static
 */
Responsive.defaults = {
	/**
	 * List of breakpoints for the instance. Note that this means that each
	 * instance can have its own breakpoints. Additionally, the breakpoints
	 * cannot be changed once an instance has been creased.
	 *
	 * @type {Array}
	 * @default Takes the value of `Responsive.breakpoints`
	 */
	breakpoints: Responsive.breakpoints,

	/**
	 * Enable / disable auto hiding calculations. It can help to increase
	 * performance slightly if you disable this option, but all columns would
	 * need to have breakpoint classes assigned to them
	 *
	 * @type {Boolean}
	 * @default  `true`
	 */
	auto: true,

	/**
	 * Details control. If given as a string value, the `type` property of the
	 * default object is set to that value, and the defaults used for the rest
	 * of the object - this is for ease of implementation.
	 *
	 * The object consists of the following properties:
	 *
	 * * `display` - A function that is used to show and hide the hidden details
	 * * `renderer` - function that is called for display of the child row data.
	 *   The default function will show the data from the hidden columns
	 * * `target` - Used as the selector for what objects to attach the child
	 *   open / close to
	 * * `type` - `false` to disable the details display, `inline` or `column`
	 *   for the two control types
	 *
	 * @type {Object|string}
	 */
	details: {
		display: Responsive.display.childRow,

		renderer: Responsive.renderer.listHidden(),

		target: 0,

		type: 'inline'
	},

	/**
	 * Orthogonal data request option. This is used to define the data type
	 * requested when Responsive gets the data to show in the child row.
	 *
	 * @type {String}
	 */
	orthogonal: 'display'
};


/*
 * API
 */
var Api = $.fn.dataTable.Api;

// Doesn't do anything - work around for a bug in DT... Not documented
Api.register( 'responsive()', function () {
	return this;
} );

Api.register( 'responsive.index()', function ( li ) {
	li = $(li);

	return {
		column: li.data('dtr-index'),
		row:    li.parent().data('dtr-index')
	};
} );

Api.register( 'responsive.rebuild()', function () {
	return this.iterator( 'table', function ( ctx ) {
		if ( ctx._responsive ) {
			ctx._responsive._classLogic();
		}
	} );
} );

Api.register( 'responsive.recalc()', function () {
	return this.iterator( 'table', function ( ctx ) {
		if ( ctx._responsive ) {
			ctx._responsive._resizeAuto();
			ctx._responsive._resize();
		}
	} );
} );

Api.register( 'responsive.hasHidden()', function () {
	var ctx = this.context[0];

	return ctx._responsive ?
		$.inArray( false, ctx._responsive.s.current ) !== -1 :
		false;
} );

Api.registerPlural( 'columns().responsiveHidden()', 'column().responsiveHidden()', function () {
	return this.iterator( 'column', function ( settings, column ) {
		return settings._responsive ?
			settings._responsive.s.current[ column ] :
			false;
	}, 1 );
} );


/**
 * Version information
 *
 * @name Responsive.version
 * @static
 */
Responsive.version = '2.2.3';


$.fn.dataTable.Responsive = Responsive;
$.fn.DataTable.Responsive = Responsive;

// Attach a listener to the document which listens for DataTables initialisation
// events so we can automatically initialise
$(document).on( 'preInit.dt.dtr', function (e, settings, json) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	if ( $(settings.nTable).hasClass( 'responsive' ) ||
		 $(settings.nTable).hasClass( 'dt-responsive' ) ||
		 settings.oInit.responsive ||
		 DataTable.defaults.responsive
	) {
		var init = settings.oInit.responsive;

		if ( init !== false ) {
			new Responsive( settings, $.isPlainObject( init ) ? init : {}  );
		}
	}
} );


return Responsive;
}));


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! RowGroup 1.1.0
 * ©2017-2018 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     RowGroup
 * @description RowGrouping for DataTables
 * @version     1.1.0
 * @file        dataTables.rowGroup.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     datatables.net
 * @copyright   Copyright 2017-2018 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


var RowGroup = function ( dt, opts ) {
	// Sanity check that we are using DataTables 1.10 or newer
	if ( ! DataTable.versionCheck || ! DataTable.versionCheck( '1.10.8' ) ) {
		throw 'RowGroup requires DataTables 1.10.8 or newer';
	}

	// User and defaults configuration object
	this.c = $.extend( true, {},
		DataTable.defaults.rowGroup,
		RowGroup.defaults,
		opts
	);

	// Internal settings
	this.s = {
		dt: new DataTable.Api( dt )
	};

	// DOM items
	this.dom = {

	};

	// Check if row grouping has already been initialised on this table
	var settings = this.s.dt.settings()[0];
	var existing = settings.rowGroup;
	if ( existing ) {
		return existing;
	}

	settings.rowGroup = this;
	this._constructor();
};


$.extend( RowGroup.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * API methods for DataTables API interface
	 */

	/**
	 * Get/set the grouping data source - need to call draw after this is
	 * executed as a setter
	 * @returns string~RowGroup
	 */
	dataSrc: function ( val )
	{
		if ( val === undefined ) {
			return this.c.dataSrc;
		}

		var dt = this.s.dt;

		this.c.dataSrc = val;

		$(dt.table().node()).triggerHandler( 'rowgroup-datasrc.dt', [ dt, val ] );

		return this;
	},

	/**
	 * Disable - need to call draw after this is executed
	 * @returns RowGroup
	 */
	disable: function ()
	{
		this.c.enable = false;
		return this;
	},

	/**
	 * Enable - need to call draw after this is executed
	 * @returns RowGroup
	 */
	enable: function ( flag )
	{
		if ( flag === false ) {
			return this.disable();
		}

		this.c.enable = true;
		return this;
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */
	_constructor: function ()
	{
		var that = this;
		var dt = this.s.dt;

		dt.on( 'draw.dtrg', function () {
			if ( that.c.enable ) {
				that._draw();
			}
		} );

		dt.on( 'column-visibility.dt.dtrg responsive-resize.dt.dtrg', function () {
			that._adjustColspan();
		} );

		dt.on( 'destroy', function () {
			dt.off( '.dtrg' );
		} );

		dt.on('responsive-resize.dt', function () {
			that._adjustColspan();
		})
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */

	/**
	 * Adjust column span when column visibility changes
	 * @private
	 */
	_adjustColspan: function ()
	{
		$( 'tr.'+this.c.className, this.s.dt.table().body() ).find('td')
			.attr( 'colspan', this._colspan() );
	},

	/**
	 * Get the number of columns that a grouping row should span
	 * @private
	 */
	_colspan: function ()
	{
		return this.s.dt.columns().visible().reduce( function (a, b) {
			return a + b;
		}, 0 );
	},


	/**
	 * Update function that is called whenever we need to draw the grouping rows.
	 * This is basically a bootstrap for the self iterative _group and _groupDisplay
	 * methods
	 * @private
	 */
	_draw: function ()
	{
		var dt = this.s.dt;
		var groupedRows = this._group( 0, dt.rows( { page: 'current' } ).indexes() );

		this._groupDisplay( 0, groupedRows );
	},

	/**
	 * Get the grouping information from a data set (index) of rows
	 * @param {number} level Nesting level
	 * @param {DataTables.Api} rows API of the rows to consider for this group
	 * @returns {object[]} Nested grouping information - it is structured like this:
	 *	{
	 *		dataPoint: 'Edinburgh',
	 *		rows: [ 1,2,3,4,5,6,7 ],
	 *		children: [ {
	 *			dataPoint: 'developer'
	 *			rows: [ 1, 2, 3 ]
	 *		},
	 *		{
	 *			dataPoint: 'support',
	 *			rows: [ 4, 5, 6, 7 ]
	 *		} ]
	 *	}
	 * @private
	 */
	_group: function ( level, rows ) {
		var fns = $.isArray( this.c.dataSrc ) ? this.c.dataSrc : [ this.c.dataSrc ];
		var fn = DataTable.ext.oApi._fnGetObjectDataFn( fns[ level ] );
		var dt = this.s.dt;
		var group, last;
		var data = [];

		for ( var i=0, ien=rows.length ; i<ien ; i++ ) {
			var rowIndex = rows[i];
			var rowData = dt.row( rowIndex ).data();
			var group = fn( rowData );

			if ( group === null || group === undefined ) {
				group = that.c.emptyDataGroup;
			}
			
			if ( last === undefined || group !== last ) {
				data.push( {
					dataPoint: group,
					rows: []
				} );

				last = group;
			}

			data[ data.length-1 ].rows.push( rowIndex );
		}

		if ( fns[ level+1 ] !== undefined ) {
			for ( var i=0, ien=data.length ; i<ien ; i++ ) {
				data[i].children = this._group( level+1, data[i].rows );
			}
		}

		return data;
	},

	/**
	 * Row group display - insert the rows into the document
	 * @param {number} level Nesting level
	 * @param {object[]} groups Takes the nested array from `_group`
	 * @private
	 */
	_groupDisplay: function ( level, groups )
	{
		var dt = this.s.dt;
		var display;
	
		for ( var i=0, ien=groups.length ; i<ien ; i++ ) {
			var group = groups[i];
			var groupName = group.dataPoint;
			var row;
			var rows = group.rows;

			if ( this.c.startRender ) {
				display = this.c.startRender.call( this, dt.rows(rows), groupName, level );
				row = this._rowWrap( display, this.c.startClassName, level );

				if ( row ) {
					row.insertBefore( dt.row( rows[0] ).node() );
				}
			}

			if ( this.c.endRender ) {
				display = this.c.endRender.call( this, dt.rows(rows), groupName, level );
				row = this._rowWrap( display, this.c.endClassName, level );

				if ( row ) {
					row.insertAfter( dt.row( rows[ rows.length-1 ] ).node() );
				}
			}

			if ( group.children ) {
				this._groupDisplay( level+1, group.children );
			}
		}
	},

	/**
	 * Take a rendered value from an end user and make it suitable for display
	 * as a row, by wrapping it in a row, or detecting that it is a row.
	 * @param {node|jQuery|string} display Display value
	 * @param {string} className Class to add to the row
	 * @param {array} group
	 * @param {number} group level
	 * @private
	 */
	_rowWrap: function ( display, className, level )
	{
		var row;
		
		if ( display === null || display === '' ) {
			display = this.c.emptyDataGroup;
		}

		if ( display === undefined ) {
			return null;
		}
		
		if ( typeof display === 'object' && display.nodeName && display.nodeName.toLowerCase() === 'tr') {
			row = $(display);
		}
		else if (display instanceof $ && display.length && display[0].nodeName.toLowerCase() === 'tr') {
			row = display;
		}
		else {
			row = $('<tr/>')
				.append(
					$('<td/>')
						.attr( 'colspan', this._colspan() )
						.append( display  )
				);
		}

		return row
			.addClass( this.c.className )
			.addClass( className )
			.addClass( 'dtrg-level-'+level );
	}
} );


/**
 * RowGroup default settings for initialisation
 *
 * @namespace
 * @name RowGroup.defaults
 * @static
 */
RowGroup.defaults = {
	/**
	 * Class to apply to grouping rows - applied to both the start and
	 * end grouping rows.
	 * @type string
	 */
	className: 'dtrg-group',

	/**
	 * Data property from which to read the grouping information
	 * @type string|integer|array
	 */
	dataSrc: 0,

	/**
	 * Text to show if no data is found for a group
	 * @type string
	 */
	emptyDataGroup: 'No group',

	/**
	 * Initial enablement state
	 * @boolean
	 */
	enable: true,

	/**
	 * Class name to give to the end grouping row
	 * @type string
	 */
	endClassName: 'dtrg-end',

	/**
	 * End grouping label function
	 * @function
	 */
	endRender: null,

	/**
	 * Class name to give to the start grouping row
	 * @type string
	 */
	startClassName: 'dtrg-start',

	/**
	 * Start grouping label function
	 * @function
	 */
	startRender: function ( rows, group ) {
		return group;
	}
};


RowGroup.version = "1.1.0";


$.fn.dataTable.RowGroup = RowGroup;
$.fn.DataTable.RowGroup = RowGroup;


DataTable.Api.register( 'rowGroup()', function () {
	return this;
} );

DataTable.Api.register( 'rowGroup().disable()', function () {
	return this.iterator( 'table', function (ctx) {
		if ( ctx.rowGroup ) {
			ctx.rowGroup.enable( false );
		}
	} );
} );

DataTable.Api.register( 'rowGroup().enable()', function ( opts ) {
	return this.iterator( 'table', function (ctx) {
		if ( ctx.rowGroup ) {
			ctx.rowGroup.enable( opts === undefined ? true : opts );
		}
	} );
} );

DataTable.Api.register( 'rowGroup().dataSrc()', function ( val ) {
	if ( val === undefined ) {
		return this.context[0].rowGroup.dataSrc();
	}

	return this.iterator( 'table', function (ctx) {
		if ( ctx.rowGroup ) {
			ctx.rowGroup.dataSrc( val );
		}
	} );
} );


// Attach a listener to the document which listens for DataTables initialisation
// events so we can automatically initialise
$(document).on( 'preInit.dt.dtrg', function (e, settings, json) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	var init = settings.oInit.rowGroup;
	var defaults = DataTable.defaults.rowGroup;

	if ( init || defaults ) {
		var opts = $.extend( {}, defaults, init );

		if ( init !== false ) {
			new RowGroup( settings, opts  );
		}
	}
} );


return RowGroup;

}));


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! RowReorder 1.2.5
 * 2015-2018 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     RowReorder
 * @description Row reordering extension for DataTables
 * @version     1.2.5
 * @file        dataTables.rowReorder.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     www.sprymedia.co.uk/contact
 * @copyright   Copyright 2015-2018 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


/**
 * RowReorder provides the ability in DataTables to click and drag rows to
 * reorder them. When a row is dropped the data for the rows effected will be
 * updated to reflect the change. Normally this data point should also be the
 * column being sorted upon in the DataTable but this does not need to be the
 * case. RowReorder implements a "data swap" method - so the rows being
 * reordered take the value of the data point from the row that used to occupy
 * the row's new position.
 *
 * Initialisation is done by either:
 *
 * * `rowReorder` parameter in the DataTable initialisation object
 * * `new $.fn.dataTable.RowReorder( table, opts )` after DataTables
 *   initialisation.
 * 
 *  @class
 *  @param {object} settings DataTables settings object for the host table
 *  @param {object} [opts] Configuration options
 *  @requires jQuery 1.7+
 *  @requires DataTables 1.10.7+
 */
var RowReorder = function ( dt, opts ) {
	// Sanity check that we are using DataTables 1.10 or newer
	if ( ! DataTable.versionCheck || ! DataTable.versionCheck( '1.10.8' ) ) {
		throw 'DataTables RowReorder requires DataTables 1.10.8 or newer';
	}

	// User and defaults configuration object
	this.c = $.extend( true, {},
		DataTable.defaults.rowReorder,
		RowReorder.defaults,
		opts
	);

	// Internal settings
	this.s = {
		/** @type {integer} Scroll body top cache */
		bodyTop: null,

		/** @type {DataTable.Api} DataTables' API instance */
		dt: new DataTable.Api( dt ),

		/** @type {function} Data fetch function */
		getDataFn: DataTable.ext.oApi._fnGetObjectDataFn( this.c.dataSrc ),

		/** @type {array} Pixel positions for row insertion calculation */
		middles: null,

		/** @type {Object} Cached dimension information for use in the mouse move event handler */
		scroll: {},

		/** @type {integer} Interval object used for smooth scrolling */
		scrollInterval: null,

		/** @type {function} Data set function */
		setDataFn: DataTable.ext.oApi._fnSetObjectDataFn( this.c.dataSrc ),

		/** @type {Object} Mouse down information */
		start: {
			top: 0,
			left: 0,
			offsetTop: 0,
			offsetLeft: 0,
			nodes: []
		},

		/** @type {integer} Window height cached value */
		windowHeight: 0,

		/** @type {integer} Document outer height cached value */
		documentOuterHeight: 0,

		/** @type {integer} DOM clone outer height cached value */
		domCloneOuterHeight: 0
	};

	// DOM items
	this.dom = {
		/** @type {jQuery} Cloned row being moved around */
		clone: null,

		/** @type {jQuery} DataTables scrolling container */
		dtScroll: $('div.dataTables_scrollBody', this.s.dt.table().container())
	};

	// Check if row reorder has already been initialised on this table
	var settings = this.s.dt.settings()[0];
	var exisiting = settings.rowreorder;
	if ( exisiting ) {
		return exisiting;
	}

	settings.rowreorder = this;
	this._constructor();
};


$.extend( RowReorder.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */

	/**
	 * Initialise the RowReorder instance
	 *
	 * @private
	 */
	_constructor: function ()
	{
		var that = this;
		var dt = this.s.dt;
		var table = $( dt.table().node() );

		// Need to be able to calculate the row positions relative to the table
		if ( table.css('position') === 'static' ) {
			table.css( 'position', 'relative' );
		}

		// listen for mouse down on the target column - we have to implement
		// this rather than using HTML5 drag and drop as drag and drop doesn't
		// appear to work on table rows at this time. Also mobile browsers are
		// not supported.
		// Use `table().container()` rather than just the table node for IE8 -
		// otherwise it only works once...
		$(dt.table().container()).on( 'mousedown.rowReorder touchstart.rowReorder', this.c.selector, function (e) {
			if ( ! that.c.enable ) {
				return;
			}

			// Ignore excluded children of the selector
			if ( $(e.target).is(that.c.excludedChildren) ) {
				return true;
			}

			var tr = $(this).closest('tr');
			var row = dt.row( tr );

			// Double check that it is a DataTable row
			if ( row.any() ) {
				that._emitEvent( 'pre-row-reorder', {
					node: row.node(),
					index: row.index()
				} );

				that._mouseDown( e, tr );
				return false;
			}
		} );

		dt.on( 'destroy.rowReorder', function () {
			$(dt.table().container()).off( '.rowReorder' );
			dt.off( '.rowReorder' );
		} );
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */
	
	/**
	 * Cache the measurements that RowReorder needs in the mouse move handler
	 * to attempt to speed things up, rather than reading from the DOM.
	 *
	 * @private
	 */
	_cachePositions: function ()
	{
		var dt = this.s.dt;

		// Frustratingly, if we add `position:relative` to the tbody, the
		// position is still relatively to the parent. So we need to adjust
		// for that
		var headerHeight = $( dt.table().node() ).find('thead').outerHeight();

		// Need to pass the nodes through jQuery to get them in document order,
		// not what DataTables thinks it is, since we have been altering the
		// order
		var nodes = $.unique( dt.rows( { page: 'current' } ).nodes().toArray() );
		var tops = $.map( nodes, function ( node, i ) {
			return $(node).position().top - headerHeight;
		} );

		var middles = $.map( tops, function ( top, i ) {
			return tops.length < i-1 ?
				(top + tops[i+1]) / 2 :
				(top + top + $( dt.row( ':last-child' ).node() ).outerHeight() ) / 2;
		} );

		this.s.middles = middles;
		this.s.bodyTop = $( dt.table().body() ).offset().top;
		this.s.windowHeight = $(window).height();
		this.s.documentOuterHeight = $(document).outerHeight();
	},


	/**
	 * Clone a row so it can be floated around the screen
	 *
	 * @param  {jQuery} target Node to be cloned
	 * @private
	 */
	_clone: function ( target )
	{
		var dt = this.s.dt;
		var clone = $( dt.table().node().cloneNode(false) )
			.addClass( 'dt-rowReorder-float' )
			.append('<tbody/>')
			.append( target.clone( false ) );

		// Match the table and column widths - read all sizes before setting
		// to reduce reflows
		var tableWidth = target.outerWidth();
		var tableHeight = target.outerHeight();
		var sizes = target.children().map( function () {
			return $(this).width();
		} );

		clone
			.width( tableWidth )
			.height( tableHeight )
			.find('tr').children().each( function (i) {
				this.style.width = sizes[i]+'px';
			} );

		// Insert into the document to have it floating around
		clone.appendTo( 'body' );

		this.dom.clone = clone;
		this.s.domCloneOuterHeight = clone.outerHeight();
	},


	/**
	 * Update the cloned item's position in the document
	 *
	 * @param  {object} e Event giving the mouse's position
	 * @private
	 */
	_clonePosition: function ( e )
	{
		var start = this.s.start;
		var topDiff = this._eventToPage( e, 'Y' ) - start.top;
		var leftDiff = this._eventToPage( e, 'X' ) - start.left;
		var snap = this.c.snapX;
		var left;
		var top = topDiff + start.offsetTop;

		if ( snap === true ) {
			left = start.offsetLeft;
		}
		else if ( typeof snap === 'number' ) {
			left = start.offsetLeft + snap;
		}
		else {
			left = leftDiff + start.offsetLeft;
		}

		if(top < 0) {
			top = 0
		}
		else if(top + this.s.domCloneOuterHeight > this.s.documentOuterHeight) {
			top = this.s.documentOuterHeight - this.s.domCloneOuterHeight;
		}

		this.dom.clone.css( {
			top: top,
			left: left
		} );
	},


	/**
	 * Emit an event on the DataTable for listeners
	 *
	 * @param  {string} name Event name
	 * @param  {array} args Event arguments
	 * @private
	 */
	_emitEvent: function ( name, args )
	{
		this.s.dt.iterator( 'table', function ( ctx, i ) {
			$(ctx.nTable).triggerHandler( name+'.dt', args );
		} );
	},


	/**
	 * Get pageX/Y position from an event, regardless of if it is a mouse or
	 * touch event.
	 *
	 * @param  {object} e Event
	 * @param  {string} pos X or Y (must be a capital)
	 * @private
	 */
	_eventToPage: function ( e, pos )
	{
		if ( e.type.indexOf( 'touch' ) !== -1 ) {
			return e.originalEvent.touches[0][ 'page'+pos ];
		}

		return e[ 'page'+pos ];
	},


	/**
	 * Mouse down event handler. Read initial positions and add event handlers
	 * for the move.
	 *
	 * @param  {object} e      Mouse event
	 * @param  {jQuery} target TR element that is to be moved
	 * @private
	 */
	_mouseDown: function ( e, target )
	{
		var that = this;
		var dt = this.s.dt;
		var start = this.s.start;

		var offset = target.offset();
		start.top = this._eventToPage( e, 'Y' );
		start.left = this._eventToPage( e, 'X' );
		start.offsetTop = offset.top;
		start.offsetLeft = offset.left;
		start.nodes = $.unique( dt.rows( { page: 'current' } ).nodes().toArray() );

		this._cachePositions();
		this._clone( target );
		this._clonePosition( e );

		this.dom.target = target;
		target.addClass( 'dt-rowReorder-moving' );

		$( document )
			.on( 'mouseup.rowReorder touchend.rowReorder', function (e) {
				that._mouseUp(e);
			} )
			.on( 'mousemove.rowReorder touchmove.rowReorder', function (e) {
				that._mouseMove(e);
			} );

		// Check if window is x-scrolling - if not, disable it for the duration
		// of the drag
		if ( $(window).width() === $(document).width() ) {
			$(document.body).addClass( 'dt-rowReorder-noOverflow' );
		}

		// Cache scrolling information so mouse move doesn't need to read.
		// This assumes that the window and DT scroller will not change size
		// during an row drag, which I think is a fair assumption
		var scrollWrapper = this.dom.dtScroll;
		this.s.scroll = {
			windowHeight: $(window).height(),
			windowWidth:  $(window).width(),
			dtTop:        scrollWrapper.length ? scrollWrapper.offset().top : null,
			dtLeft:       scrollWrapper.length ? scrollWrapper.offset().left : null,
			dtHeight:     scrollWrapper.length ? scrollWrapper.outerHeight() : null,
			dtWidth:      scrollWrapper.length ? scrollWrapper.outerWidth() : null
		};
	},


	/**
	 * Mouse move event handler - move the cloned row and shuffle the table's
	 * rows if required.
	 *
	 * @param  {object} e Mouse event
	 * @private
	 */
	_mouseMove: function ( e )
	{
		this._clonePosition( e );

		// Transform the mouse position into a position in the table's body
		var bodyY = this._eventToPage( e, 'Y' ) - this.s.bodyTop;
		var middles = this.s.middles;
		var insertPoint = null;
		var dt = this.s.dt;
		var body = dt.table().body();

		// Determine where the row should be inserted based on the mouse
		// position
		for ( var i=0, ien=middles.length ; i<ien ; i++ ) {
			if ( bodyY < middles[i] ) {
				insertPoint = i;
				break;
			}
		}

		if ( insertPoint === null ) {
			insertPoint = middles.length;
		}

		// Perform the DOM shuffle if it has changed from last time
		if ( this.s.lastInsert === null || this.s.lastInsert !== insertPoint ) {
			if ( insertPoint === 0 ) {
				this.dom.target.prependTo( body );
			}
			else {
				var nodes = $.unique( dt.rows( { page: 'current' } ).nodes().toArray() );

				if ( insertPoint > this.s.lastInsert ) {
					this.dom.target.insertAfter( nodes[ insertPoint-1 ] );
				}
				else {
					this.dom.target.insertBefore( nodes[ insertPoint ] );
				}
			}

			this._cachePositions();

			this.s.lastInsert = insertPoint;
		}

		this._shiftScroll( e );
	},


	/**
	 * Mouse up event handler - release the event handlers and perform the
	 * table updates
	 *
	 * @param  {object} e Mouse event
	 * @private
	 */
	_mouseUp: function ( e )
	{
		var that = this;
		var dt = this.s.dt;
		var i, ien;
		var dataSrc = this.c.dataSrc;

		this.dom.clone.remove();
		this.dom.clone = null;

		this.dom.target.removeClass( 'dt-rowReorder-moving' );
		//this.dom.target = null;

		$(document).off( '.rowReorder' );
		$(document.body).removeClass( 'dt-rowReorder-noOverflow' );

		clearInterval( this.s.scrollInterval );
		this.s.scrollInterval = null;

		// Calculate the difference
		var startNodes = this.s.start.nodes;
		var endNodes = $.unique( dt.rows( { page: 'current' } ).nodes().toArray() );
		var idDiff = {};
		var fullDiff = [];
		var diffNodes = [];
		var getDataFn = this.s.getDataFn;
		var setDataFn = this.s.setDataFn;

		for ( i=0, ien=startNodes.length ; i<ien ; i++ ) {
			if ( startNodes[i] !== endNodes[i] ) {
				var id = dt.row( endNodes[i] ).id();
				var endRowData = dt.row( endNodes[i] ).data();
				var startRowData = dt.row( startNodes[i] ).data();

				if ( id ) {
					idDiff[ id ] = getDataFn( startRowData );
				}

				fullDiff.push( {
					node: endNodes[i],
					oldData: getDataFn( endRowData ),
					newData: getDataFn( startRowData ),
					newPosition: i,
					oldPosition: $.inArray( endNodes[i], startNodes )
				} );

				diffNodes.push( endNodes[i] );
			}
		}
		
		// Create event args
		var eventArgs = [ fullDiff, {
			dataSrc:    dataSrc,
			nodes:      diffNodes,
			values:     idDiff,
			triggerRow: dt.row( this.dom.target )
		} ];
		
		// Emit event
		this._emitEvent( 'row-reorder', eventArgs );

		var update = function () {
			if ( that.c.update ) {
				for ( i=0, ien=fullDiff.length ; i<ien ; i++ ) {
					var row = dt.row( fullDiff[i].node );
					var rowData = row.data();

					setDataFn( rowData, fullDiff[i].newData );

					// Invalidate the cell that has the same data source as the dataSrc
					dt.columns().every( function () {
						if ( this.dataSrc() === dataSrc ) {
							dt.cell( fullDiff[i].node, this.index() ).invalidate( 'data' );
						}
					} );
				}

				// Trigger row reordered event
				that._emitEvent( 'row-reordered', eventArgs );

				dt.draw( false );
			}
		};

		// Editor interface
		if ( this.c.editor ) {
			// Disable user interaction while Editor is submitting
			this.c.enable = false;

			this.c.editor
				.edit(
					diffNodes,
					false,
					$.extend( {submit: 'changed'}, this.c.formOptions )
				)
				.multiSet( dataSrc, idDiff )
				.one( 'preSubmitCancelled.rowReorder', function () {
					that.c.enable = true;
					that.c.editor.off( '.rowReorder' );
					dt.draw( false );
				} )
				.one( 'submitUnsuccessful.rowReorder', function () {
					dt.draw( false );
				} )
				.one( 'submitSuccess.rowReorder', function () {
					update();
				} )
				.one( 'submitComplete', function () {
					that.c.enable = true;
					that.c.editor.off( '.rowReorder' );
				} )
				.submit();
		}
		else {
			update();
		}
	},


	/**
	 * Move the window and DataTables scrolling during a drag to scroll new
	 * content into view.
	 *
	 * This matches the `_shiftScroll` method used in AutoFill, but only
	 * horizontal scrolling is considered here.
	 *
	 * @param  {object} e Mouse move event object
	 * @private
	 */
	_shiftScroll: function ( e )
	{
		var that = this;
		var dt = this.s.dt;
		var scroll = this.s.scroll;
		var runInterval = false;
		var scrollSpeed = 5;
		var buffer = 65;
		var
			windowY = e.pageY - document.body.scrollTop,
			windowVert,
			dtVert;

		// Window calculations - based on the mouse position in the window,
		// regardless of scrolling
		if ( windowY < buffer ) {
			windowVert = scrollSpeed * -1;
		}
		else if ( windowY > scroll.windowHeight - buffer ) {
			windowVert = scrollSpeed;
		}

		// DataTables scrolling calculations - based on the table's position in
		// the document and the mouse position on the page
		if ( scroll.dtTop !== null && e.pageY < scroll.dtTop + buffer ) {
			dtVert = scrollSpeed * -1;
		}
		else if ( scroll.dtTop !== null && e.pageY > scroll.dtTop + scroll.dtHeight - buffer ) {
			dtVert = scrollSpeed;
		}

		// This is where it gets interesting. We want to continue scrolling
		// without requiring a mouse move, so we need an interval to be
		// triggered. The interval should continue until it is no longer needed,
		// but it must also use the latest scroll commands (for example consider
		// that the mouse might move from scrolling up to scrolling left, all
		// with the same interval running. We use the `scroll` object to "pass"
		// this information to the interval. Can't use local variables as they
		// wouldn't be the ones that are used by an already existing interval!
		if ( windowVert || dtVert ) {
			scroll.windowVert = windowVert;
			scroll.dtVert = dtVert;
			runInterval = true;
		}
		else if ( this.s.scrollInterval ) {
			// Don't need to scroll - remove any existing timer
			clearInterval( this.s.scrollInterval );
			this.s.scrollInterval = null;
		}

		// If we need to run the interval to scroll and there is no existing
		// interval (if there is an existing one, it will continue to run)
		if ( ! this.s.scrollInterval && runInterval ) {
			this.s.scrollInterval = setInterval( function () {
				// Don't need to worry about setting scroll <0 or beyond the
				// scroll bound as the browser will just reject that.
				if ( scroll.windowVert ) {
					document.body.scrollTop += scroll.windowVert;
				}

				// DataTables scrolling
				if ( scroll.dtVert ) {
					var scroller = that.dom.dtScroll[0];

					if ( scroll.dtVert ) {
						scroller.scrollTop += scroll.dtVert;
					}
				}
			}, 20 );
		}
	}
} );



/**
 * RowReorder default settings for initialisation
 *
 * @namespace
 * @name RowReorder.defaults
 * @static
 */
RowReorder.defaults = {
	/**
	 * Data point in the host row's data source object for where to get and set
	 * the data to reorder. This will normally also be the sorting column.
	 *
	 * @type {Number}
	 */
	dataSrc: 0,

	/**
	 * Editor instance that will be used to perform the update
	 *
	 * @type {DataTable.Editor}
	 */
	editor: null,

	/**
	 * Enable / disable RowReorder's user interaction
	 * @type {Boolean}
	 */
	enable: true,

	/**
	 * Form options to pass to Editor when submitting a change in the row order.
	 * See the Editor `from-options` object for details of the options
	 * available.
	 * @type {Object}
	 */
	formOptions: {},

	/**
	 * Drag handle selector. This defines the element that when dragged will
	 * reorder a row.
	 *
	 * @type {String}
	 */
	selector: 'td:first-child',

	/**
	 * Optionally lock the dragged row's x-position. This can be `true` to
	 * fix the position match the host table's, `false` to allow free movement
	 * of the row, or a number to define an offset from the host table.
	 *
	 * @type {Boolean|number}
	 */
	snapX: false,

	/**
	 * Update the table's data on drop
	 *
	 * @type {Boolean}
	 */
	update: true,

	/**
	 * Selector for children of the drag handle selector that mouseDown events
	 * will be passed through to and drag will not activate
	 *
	 * @type {String}
	 */
	excludedChildren: 'a'
};


/*
 * API
 */
var Api = $.fn.dataTable.Api;

// Doesn't do anything - work around for a bug in DT... Not documented
Api.register( 'rowReorder()', function () {
	return this;
} );

Api.register( 'rowReorder.enable()', function ( toggle ) {
	if ( toggle === undefined ) {
		toggle = true;
	}

	return this.iterator( 'table', function ( ctx ) {
		if ( ctx.rowreorder ) {
			ctx.rowreorder.c.enable = toggle;
		}
	} );
} );

Api.register( 'rowReorder.disable()', function () {
	return this.iterator( 'table', function ( ctx ) {
		if ( ctx.rowreorder ) {
			ctx.rowreorder.c.enable = false;
		}
	} );
} );


/**
 * Version information
 *
 * @name RowReorder.version
 * @static
 */
RowReorder.version = '1.2.5';


$.fn.dataTable.RowReorder = RowReorder;
$.fn.DataTable.RowReorder = RowReorder;

// Attach a listener to the document which listens for DataTables initialisation
// events so we can automatically initialise
$(document).on( 'init.dt.dtr', function (e, settings, json) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	var init = settings.oInit.rowReorder;
	var defaults = DataTable.defaults.rowReorder;

	if ( init || defaults ) {
		var opts = $.extend( {}, init, defaults );

		if ( init !== false ) {
			new RowReorder( settings, opts  );
		}
	}
} );


return RowReorder;
}));


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Scroller 1.5.1
 * ©2011-2018 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     Scroller
 * @description Virtual rendering for DataTables
 * @version     1.5.1
 * @file        dataTables.scroller.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     www.sprymedia.co.uk/contact
 * @copyright   Copyright 2011-2018 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */

(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


/**
 * Scroller is a virtual rendering plug-in for DataTables which allows large
 * datasets to be drawn on screen every quickly. What the virtual rendering means
 * is that only the visible portion of the table (and a bit to either side to make
 * the scrolling smooth) is drawn, while the scrolling container gives the
 * visual impression that the whole table is visible. This is done by making use
 * of the pagination abilities of DataTables and moving the table around in the
 * scrolling container DataTables adds to the page. The scrolling container is
 * forced to the height it would be for the full table display using an extra
 * element.
 *
 * Note that rows in the table MUST all be the same height. Information in a cell
 * which expands on to multiple lines will cause some odd behaviour in the scrolling.
 *
 * Scroller is initialised by simply including the letter 'S' in the sDom for the
 * table you want to have this feature enabled on. Note that the 'S' must come
 * AFTER the 't' parameter in `dom`.
 *
 * Key features include:
 *   <ul class="limit_length">
 *     <li>Speed! The aim of Scroller for DataTables is to make rendering large data sets fast</li>
 *     <li>Full compatibility with deferred rendering in DataTables for maximum speed</li>
 *     <li>Display millions of rows</li>
 *     <li>Integration with state saving in DataTables (scrolling position is saved)</li>
 *     <li>Easy to use</li>
 *   </ul>
 *
 *  @class
 *  @constructor
 *  @global
 *  @param {object} dt DataTables settings object or API instance
 *  @param {object} [opts={}] Configuration object for FixedColumns. Options 
 *    are defined by {@link Scroller.defaults}
 *
 *  @requires jQuery 1.7+
 *  @requires DataTables 1.10.0+
 *
 *  @example
 *    $(document).ready(function() {
 *        $('#example').DataTable( {
 *            "scrollY": "200px",
 *            "ajax": "media/dataset/large.txt",
 *            "dom": "frtiS",
 *            "deferRender": true
 *        } );
 *    } );
 */
var Scroller = function ( dt, opts ) {
	/* Sanity check - you just know it will happen */
	if ( ! (this instanceof Scroller) ) {
		alert( "Scroller warning: Scroller must be initialised with the 'new' keyword." );
		return;
	}

	if ( opts === undefined ) {
		opts = {};
	}

	var dtApi = $.fn.dataTable.Api( dt );

	/**
	 * Settings object which contains customisable information for the Scroller instance
	 * @namespace
	 * @private
	 * @extends Scroller.defaults
	 */
	this.s = {
		/**
		 * DataTables settings object
		 *  @type     object
		 *  @default  Passed in as first parameter to constructor
		 */
		"dt": dtApi.settings()[0],

		/**
		 * DataTables API instance
		 *  @type     DataTable.Api
		 */
		"dtApi": dtApi,

		/**
		 * Pixel location of the top of the drawn table in the viewport
		 *  @type     int
		 *  @default  0
		 */
		"tableTop": 0,

		/**
		 * Pixel location of the bottom of the drawn table in the viewport
		 *  @type     int
		 *  @default  0
		 */
		"tableBottom": 0,

		/**
		 * Pixel location of the boundary for when the next data set should be loaded and drawn
		 * when scrolling up the way.
		 *  @type     int
		 *  @default  0
		 *  @private
		 */
		"redrawTop": 0,

		/**
		 * Pixel location of the boundary for when the next data set should be loaded and drawn
		 * when scrolling down the way. Note that this is actually calculated as the offset from
		 * the top.
		 *  @type     int
		 *  @default  0
		 *  @private
		 */
		"redrawBottom": 0,

		/**
		 * Auto row height or not indicator
		 *  @type     bool
		 *  @default  0
		 */
		"autoHeight": true,

		/**
		 * Number of rows calculated as visible in the visible viewport
		 *  @type     int
		 *  @default  0
		 */
		"viewportRows": 0,

		/**
		 * setTimeout reference for state saving, used when state saving is enabled in the DataTable
		 * and when the user scrolls the viewport in order to stop the cookie set taking too much
		 * CPU!
		 *  @type     int
		 *  @default  0
		 */
		"stateTO": null,

		/**
		 * setTimeout reference for the redraw, used when server-side processing is enabled in the
		 * DataTables in order to prevent DoSing the server
		 *  @type     int
		 *  @default  null
		 */
		"drawTO": null,

		heights: {
			jump: null,
			page: null,
			virtual: null,
			scroll: null,

			/**
			 * Height of rows in the table
			 *  @type     int
			 *  @default  0
			 */
			row: null,

			/**
			 * Pixel height of the viewport
			 *  @type     int
			 *  @default  0
			 */
			viewport: null
		},

		topRowFloat: 0,
		scrollDrawDiff: null,
		loaderVisible: false,
		forceReposition: false
	};

	// @todo The defaults should extend a `c` property and the internal settings
	// only held in the `s` property. At the moment they are mixed
	this.s = $.extend( this.s, Scroller.oDefaults, opts );

	// Workaround for row height being read from height object (see above comment)
	this.s.heights.row = this.s.rowHeight;

	/**
	 * DOM elements used by the class instance
	 * @private
	 * @namespace
	 *
	 */
	this.dom = {
		"force":    document.createElement('div'),
		"scroller": null,
		"table":    null,
		"loader":   null
	};

	// Attach the instance to the DataTables instance so it can be accessed in
	// future. Don't initialise Scroller twice on the same table
	if ( this.s.dt.oScroller ) {
		return;
	}

	this.s.dt.oScroller = this;

	/* Let's do it */
	this._fnConstruct();
};



$.extend( Scroller.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Public methods
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

	/**
	 * Calculate the pixel position from the top of the scrolling container for
	 * a given row
	 *  @param {int} iRow Row number to calculate the position of
	 *  @returns {int} Pixels
	 *  @example
	 *    $(document).ready(function() {
	 *      $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "sAjaxSource": "media/dataset/large.txt",
	 *        "sDom": "frtiS",
	 *        "bDeferRender": true,
	 *        "fnInitComplete": function (o) {
	 *          // Find where row 25 is
	 *          alert( o.oScroller.fnRowToPixels( 25 ) );
	 *        }
	 *      } );
	 *    } );
	 */
	"fnRowToPixels": function ( rowIdx, intParse, virtual )
	{
		var pixels;
		var diff = rowIdx - this.s.baseRowTop;

		if ( virtual ) {
			pixels = this._domain( 'virtualToPhysical', this.s.baseScrollTop );
			pixels += diff * this.s.heights.row;
		}
		else {
			pixels = this.s.baseScrollTop;
			pixels += diff * this.s.heights.row;
		}

		return intParse || intParse === undefined ?
			parseInt( pixels, 10 ) :
			pixels;
	},


	/**
	 * Calculate the row number that will be found at the given pixel position
	 * (y-scroll).
	 *
	 * Please note that when the height of the full table exceeds 1 million
	 * pixels, Scroller switches into a non-linear mode for the scrollbar to fit
	 * all of the records into a finite area, but this function returns a linear
	 * value (relative to the last non-linear positioning).
	 *  @param {int} iPixels Offset from top to calculate the row number of
	 *  @param {int} [intParse=true] If an integer value should be returned
	 *  @param {int} [virtual=false] Perform the calculations in the virtual domain
	 *  @returns {int} Row index
	 *  @example
	 *    $(document).ready(function() {
	 *      $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "sAjaxSource": "media/dataset/large.txt",
	 *        "sDom": "frtiS",
	 *        "bDeferRender": true,
	 *        "fnInitComplete": function (o) {
	 *          // Find what row number is at 500px
	 *          alert( o.oScroller.fnPixelsToRow( 500 ) );
	 *        }
	 *      } );
	 *    } );
	 */
	"fnPixelsToRow": function ( pixels, intParse, virtual )
	{
		var diff = pixels - this.s.baseScrollTop;
		var row = virtual ?
			(this._domain( 'physicalToVirtual', this.s.baseScrollTop ) + diff) / this.s.heights.row :
			( diff / this.s.heights.row ) + this.s.baseRowTop;

		return intParse || intParse === undefined ?
			parseInt( row, 10 ) :
			row;
	},


	/**
	 * Calculate the row number that will be found at the given pixel position (y-scroll)
	 *  @param {int} iRow Row index to scroll to
	 *  @param {bool} [bAnimate=true] Animate the transition or not
	 *  @returns {void}
	 *  @example
	 *    $(document).ready(function() {
	 *      $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "sAjaxSource": "media/dataset/large.txt",
	 *        "sDom": "frtiS",
	 *        "bDeferRender": true,
	 *        "fnInitComplete": function (o) {
	 *          // Immediately scroll to row 1000
	 *          o.oScroller.fnScrollToRow( 1000 );
	 *        }
	 *      } );
	 *     
	 *      // Sometime later on use the following to scroll to row 500...
	 *          var oSettings = $('#example').dataTable().fnSettings();
	 *      oSettings.oScroller.fnScrollToRow( 500 );
	 *    } );
	 */
	"fnScrollToRow": function ( iRow, bAnimate )
	{
		var that = this;
		var ani = false;
		var px = this.fnRowToPixels( iRow );

		// We need to know if the table will redraw or not before doing the
		// scroll. If it will not redraw, then we need to use the currently
		// displayed table, and scroll with the physical pixels. Otherwise, we
		// need to calculate the table's new position from the virtual
		// transform.
		var preRows = ((this.s.displayBuffer-1)/2) * this.s.viewportRows;
		var drawRow = iRow - preRows;
		if ( drawRow < 0 ) {
			drawRow = 0;
		}

		if ( (px > this.s.redrawBottom || px < this.s.redrawTop) && this.s.dt._iDisplayStart !== drawRow ) {
			ani = true;
			px = this._domain( 'virtualToPhysical', iRow * this.s.heights.row );

			// If we need records outside the current draw region, but the new
			// scrolling position is inside that (due to the non-linear nature
			// for larger numbers of records), we need to force position update.
			if ( this.s.redrawTop < px && px < this.s.redrawBottom ) {
				this.s.forceReposition = true;
				bAnimate = false;
			}
		}

		if ( typeof bAnimate == 'undefined' || bAnimate )
		{
			this.s.ani = ani;
			$(this.dom.scroller).animate( {
				"scrollTop": px
			}, function () {
				// This needs to happen after the animation has completed and
				// the final scroll event fired
				setTimeout( function () {
					that.s.ani = false;
				}, 25 );
			} );
		}
		else
		{
			$(this.dom.scroller).scrollTop( px );
		}
	},


	/**
	 * Calculate and store information about how many rows are to be displayed
	 * in the scrolling viewport, based on current dimensions in the browser's
	 * rendering. This can be particularly useful if the table is initially
	 * drawn in a hidden element - for example in a tab.
	 *  @param {bool} [bRedraw=true] Redraw the table automatically after the recalculation, with
	 *    the new dimensions forming the basis for the draw.
	 *  @returns {void}
	 *  @example
	 *    $(document).ready(function() {
	 *      // Make the example container hidden to throw off the browser's sizing
	 *      document.getElementById('container').style.display = "none";
	 *      var oTable = $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "sAjaxSource": "media/dataset/large.txt",
	 *        "sDom": "frtiS",
	 *        "bDeferRender": true,
	 *        "fnInitComplete": function (o) {
	 *          // Immediately scroll to row 1000
	 *          o.oScroller.fnScrollToRow( 1000 );
	 *        }
	 *      } );
	 *     
	 *      setTimeout( function () {
	 *        // Make the example container visible and recalculate the scroller sizes
	 *        document.getElementById('container').style.display = "block";
	 *        oTable.fnSettings().oScroller.fnMeasure();
	 *      }, 3000 );
	 */
	"fnMeasure": function ( bRedraw )
	{
		if ( this.s.autoHeight )
		{
			this._fnCalcRowHeight();
		}

		var heights = this.s.heights;

		if ( heights.row ) {
			heights.viewport = $.contains(document, this.dom.scroller) ?
				$(this.dom.scroller).height() :
				this._parseHeight($(this.dom.scroller).css('height'));

			// If collapsed (no height) use the max-height parameter
			if ( ! heights.viewport ) {
				heights.viewport = this._parseHeight($(this.dom.scroller).css('max-height'));
			}

			this.s.viewportRows = parseInt( heights.viewport / heights.row, 10 )+1;
			this.s.dt._iDisplayLength = this.s.viewportRows * this.s.displayBuffer;
		}

		if ( bRedraw === undefined || bRedraw )
		{
			this.s.dt.oInstance.fnDraw( false );
		}
	},


	/**
	 * Get information about current displayed record range. This corresponds to
	 * the information usually displayed in the "Info" block of the table.
	 *
	 * @returns {object} info as an object:
	 *  {
	 *      start: {int}, // the 0-indexed record at the top of the viewport
	 *      end:   {int}, // the 0-indexed record at the bottom of the viewport
	 *  }
	*/
	"fnPageInfo": function()
	{
		var 
			dt = this.s.dt,
			iScrollTop = this.dom.scroller.scrollTop,
			iTotal = dt.fnRecordsDisplay(),
			iPossibleEnd = Math.ceil(this.fnPixelsToRow(iScrollTop + this.s.heights.viewport, false, this.s.ani));

		return {
			start: Math.floor(this.fnPixelsToRow(iScrollTop, false, this.s.ani)),
			end: iTotal < iPossibleEnd ? iTotal-1 : iPossibleEnd-1
		};
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods (they are of course public in JS, but recommended as private)
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

	/**
	 * Initialisation for Scroller
	 *  @returns {void}
	 *  @private
	 */
	"_fnConstruct": function ()
	{
		var that = this;
		var dt = this.s.dtApi;

		/* Sanity check */
		if ( !this.s.dt.oFeatures.bPaginate ) {
			this.s.dt.oApi._fnLog( this.s.dt, 0, 'Pagination must be enabled for Scroller' );
			return;
		}

		/* Insert a div element that we can use to force the DT scrolling container to
		 * the height that would be required if the whole table was being displayed
		 */
		this.dom.force.style.position = "relative";
		this.dom.force.style.top = "0px";
		this.dom.force.style.left = "0px";
		this.dom.force.style.width = "1px";

		this.dom.scroller = $('div.'+this.s.dt.oClasses.sScrollBody, this.s.dt.nTableWrapper)[0];
		this.dom.scroller.appendChild( this.dom.force );
		this.dom.scroller.style.position = "relative";

		this.dom.table = $('>table', this.dom.scroller)[0];
		this.dom.table.style.position = "absolute";
		this.dom.table.style.top = "0px";
		this.dom.table.style.left = "0px";

		// Add class to 'announce' that we are a Scroller table
		$(dt.table().container()).addClass('DTS');

		// Add a 'loading' indicator
		if ( this.s.loadingIndicator )
		{
			this.dom.loader = $('<div class="dataTables_processing DTS_Loading">'+this.s.dt.oLanguage.sLoadingRecords+'</div>')
				.css('display', 'none');

			$(this.dom.scroller.parentNode)
				.css('position', 'relative')
				.append( this.dom.loader );
		}

		/* Initial size calculations */
		if ( this.s.heights.row && this.s.heights.row != 'auto' )
		{
			this.s.autoHeight = false;
		}
		this.fnMeasure( false );

		// Scrolling callback to see if a page change is needed - use a throttled
		// function for the save save callback so we aren't hitting it on every
		// scroll
		this.s.ingnoreScroll = true;
		this.s.stateSaveThrottle = this.s.dt.oApi._fnThrottle( function () {
			that.s.dtApi.state.save();
		}, 500 );
		$(this.dom.scroller).on( 'scroll.dt-scroller', function (e) {
			that._fnScroll.call( that );
		} );

		// In iOS we catch the touchstart event in case the user tries to scroll
		// while the display is already scrolling
		$(this.dom.scroller).on('touchstart.dt-scroller', function () {
			that._fnScroll.call( that );
		} );

		// On resize, update the information element, since the number of rows shown might change
		$(window).on( 'resize.dt-scroller', function () {
			that.fnMeasure( false );
			that._fnInfo();
		} );

		// Add a state saving parameter to the DT state saving so we can restore the exact
		// position of the scrolling. Slightly surprisingly the scroll position isn't actually
		// stored, but rather tha base units which are needed to calculate it. This allows for
		// virtual scrolling as well.
		var initialStateSave = true;
		var loadedState = dt.state.loaded();

		dt.on( 'stateSaveParams.scroller', function ( e, settings, data ) {
			// Need to used the saved position on init
			data.scroller = {
				topRow: initialStateSave && loadedState && loadedState.scroller ?
					loadedState.scroller.topRow :
					that.s.topRowFloat,
				baseScrollTop: that.s.baseScrollTop,
				baseRowTop: that.s.baseRowTop
			};

			initialStateSave = false;
		} );

		if ( loadedState && loadedState.scroller ) {
			this.s.topRowFloat = loadedState.scroller.topRow;
			this.s.baseScrollTop = loadedState.scroller.baseScrollTop;
			this.s.baseRowTop = loadedState.scroller.baseRowTop;
		}

		dt.on( 'init.scroller', function () {
			that.fnMeasure( false );

			that._fnDrawCallback();

			// Update the scroller when the DataTable is redrawn
			dt.on( 'draw.scroller', function () {
				that._fnDrawCallback();
			});
		} );

		// Set height before the draw happens, allowing everything else to update
		// on draw complete without worry for roder.
		dt.on( 'preDraw.dt.scroller', function () {
			that._fnScrollForce();
		} );

		// Destructor
		dt.on( 'destroy.scroller', function () {
			$(window).off( 'resize.dt-scroller' );
			$(that.dom.scroller).off('.dt-scroller');
			$(that.s.dt.nTable).off( '.scroller' );

			$(that.s.dt.nTableWrapper).removeClass('DTS');
			$('div.DTS_Loading', that.dom.scroller.parentNode).remove();

			that.dom.table.style.position = "";
			that.dom.table.style.top = "";
			that.dom.table.style.left = "";
		} );
	},


	/**
	 * Scrolling function - fired whenever the scrolling position is changed.
	 * This method needs to use the stored values to see if the table should be
	 * redrawn as we are moving towards the end of the information that is
	 * currently drawn or not. If needed, then it will redraw the table based on
	 * the new position.
	 *  @returns {void}
	 *  @private
	 */
	"_fnScroll": function ()
	{
		var
			that = this,
			heights = this.s.heights,
			iScrollTop = this.dom.scroller.scrollTop,
			iTopRow;

		if ( this.s.skip ) {
			return;
		}

		if ( this.s.ingnoreScroll ) {
			return;
		}

		/* If the table has been sorted or filtered, then we use the redraw that
		 * DataTables as done, rather than performing our own
		 */
		if ( this.s.dt.bFiltered || this.s.dt.bSorted ) {
			this.s.lastScrollTop = 0;
			return;
		}

		/* Update the table's information display for what is now in the viewport */
		this._fnInfo();

		/* We don't want to state save on every scroll event - that's heavy
		 * handed, so use a timeout to update the state saving only when the
		 * scrolling has finished
		 */
		clearTimeout( this.s.stateTO );
		this.s.stateTO = setTimeout( function () {
			that.s.dtApi.state.save();
		}, 250 );

		/* Check if the scroll point is outside the trigger boundary which would required
		 * a DataTables redraw
		 */
		if ( this.s.forceReposition || iScrollTop < this.s.redrawTop || iScrollTop > this.s.redrawBottom ) {

			var preRows = Math.ceil( ((this.s.displayBuffer-1)/2) * this.s.viewportRows );

			iTopRow = parseInt(this._domain( 'physicalToVirtual', iScrollTop ) / heights.row, 10) - preRows;
			this.s.topRowFloat = this._domain( 'physicalToVirtual', iScrollTop ) / heights.row;
			this.s.forceReposition = false;

			if ( iTopRow <= 0 ) {
				/* At the start of the table */
				iTopRow = 0;
			}
			else if ( iTopRow + this.s.dt._iDisplayLength > this.s.dt.fnRecordsDisplay() ) {
				/* At the end of the table */
				iTopRow = this.s.dt.fnRecordsDisplay() - this.s.dt._iDisplayLength;
				if ( iTopRow < 0 ) {
					iTopRow = 0;
				}
			}
			else if ( iTopRow % 2 !== 0 ) {
				// For the row-striping classes (odd/even) we want only to start
				// on evens otherwise the stripes will change between draws and
				// look rubbish
				iTopRow++;
			}

			if ( iTopRow != this.s.dt._iDisplayStart ) {
				/* Cache the new table position for quick lookups */
				this.s.tableTop = $(this.s.dt.nTable).offset().top;
				this.s.tableBottom = $(this.s.dt.nTable).height() + this.s.tableTop;

				var draw =  function () {
					if ( that.s.scrollDrawReq === null ) {
						that.s.scrollDrawReq = iScrollTop;
					}

					that.s.dt._iDisplayStart = iTopRow;
					that.s.dt.oApi._fnDraw( that.s.dt );
				};

				/* Do the DataTables redraw based on the calculated start point - note that when
				 * using server-side processing we introduce a small delay to not DoS the server...
				 */
				if ( this.s.dt.oFeatures.bServerSide ) {
					clearTimeout( this.s.drawTO );
					this.s.drawTO = setTimeout( draw, this.s.serverWait );
				}
				else {
					draw();
				}

				if ( this.dom.loader && ! this.s.loaderVisible ) {
					this.dom.loader.css( 'display', 'block' );
					this.s.loaderVisible = true;
				}
			}
		}
		else {
			this.s.topRowFloat = this.fnPixelsToRow( iScrollTop, false, true );
		}

		this.s.lastScrollTop = iScrollTop;
		this.s.stateSaveThrottle();
	},


	/**
	 * Convert from one domain to another. The physical domain is the actual
	 * pixel count on the screen, while the virtual is if we had browsers which
	 * had scrolling containers of infinite height (i.e. the absolute value)
	 *
	 *  @param {string} dir Domain transform direction, `virtualToPhysical` or
	 *    `physicalToVirtual` 
	 *  @returns {number} Calculated transform
	 *  @private
	 */
	_domain: function ( dir, val )
	{
		var heights = this.s.heights;
		var coeff;

		// If the virtual and physical height match, then we use a linear
		// transform between the two, allowing the scrollbar to be linear
		if ( heights.virtual === heights.scroll ) {
			return val;
		}

		// Otherwise, we want a non-linear scrollbar to take account of the
		// redrawing regions at the start and end of the table, otherwise these
		// can stutter badly - on large tables 30px (for example) scroll might
		// be hundreds of rows, so the table would be redrawing every few px at
		// the start and end. Use a simple quadratic to stop this. It does mean
		// the scrollbar is non-linear, but with such massive data sets, the
		// scrollbar is going to be a best guess anyway
		var xMax = (heights.scroll - heights.viewport) / 2;
		var yMax = (heights.virtual - heights.viewport) / 2;

		coeff = yMax / ( xMax * xMax );

		if ( dir === 'virtualToPhysical' ) {
			if ( val < yMax ) {
				return Math.pow(val / coeff, 0.5);
			}
			else {
				val = (yMax*2) - val;
				return val < 0 ?
					heights.scroll :
					(xMax*2) - Math.pow(val / coeff, 0.5);
			}
		}
		else if ( dir === 'physicalToVirtual' ) {
			if ( val < xMax ) {
				return val * val * coeff;
			}
			else {
				val = (xMax*2) - val;
				return val < 0 ?
					heights.virtual :
					(yMax*2) - (val * val * coeff);
			}
		}
	},

	/**
	 * Parse CSS height property string as number
	 *
	 * An attempt is made to parse the string as a number. Currently supported units are 'px',
	 * 'vh', and 'rem'. 'em' is partially supported; it works as long as the parent element's
	 * font size matches the body element. Zero is returned for unrecognized strings.
	 *  @param {string} cssHeight CSS height property string
	 *  @returns {number} height
	 *  @private
	 */
	_parseHeight: function(cssHeight) {
		var height;
		var matches = /^([+-]?(?:\d+(?:\.\d+)?|\.\d+))(px|em|rem|vh)$/.exec(cssHeight);

		if (matches === null) {
			return 0;
		}

		var value = parseFloat(matches[1]);
		var unit = matches[2];

		if ( unit === 'px' ) {
			height = value;
		}
		else if ( unit === 'vh' ) {
			height = ( value / 100 ) * $(window).height();
		}
		else if ( unit === 'rem' ) {
			height = value * parseFloat($(':root').css('font-size'));
		}
		else if ( unit === 'em' ) {
			height = value * parseFloat($('body').css('font-size'));
		}

		return height ?
			height :
			0;
	},


	/**
	 * Draw callback function which is fired when the DataTable is redrawn. The main function of
	 * this method is to position the drawn table correctly the scrolling container for the rows
	 * that is displays as a result of the scrolling position.
	 *  @returns {void}
	 *  @private
	 */
	"_fnDrawCallback": function ()
	{
		var
			that = this,
			heights = this.s.heights,
			iScrollTop = this.dom.scroller.scrollTop,
			iActualScrollTop = iScrollTop,
			iScrollBottom = iScrollTop + heights.viewport,
			iTableHeight = $(this.s.dt.nTable).height(),
			displayStart = this.s.dt._iDisplayStart,
			displayLen = this.s.dt._iDisplayLength,
			displayEnd = this.s.dt.fnRecordsDisplay();

		// Disable the scroll event listener while we are updating the DOM
		this.s.skip = true;

		// If paging is reset
		if ( (this.s.dt.bSorted || this.s.dt.bFiltered) && displayStart === 0 ) {
			this.s.topRowFloat = 0;
		}

		// Reposition the scrolling for the updated virtual position if needed
		if ( displayStart === 0 ) {
			// Linear calculation at the top of the table
			iScrollTop = this.s.topRowFloat * heights.row;
		}
		else if ( displayStart + displayLen >= displayEnd ) {
			// Linear calculation that the bottom as well
			iScrollTop = heights.scroll - ((displayEnd - this.s.topRowFloat) * heights.row);
		}
		else {
			// Domain scaled in the middle
			iScrollTop = this._domain( 'virtualToPhysical', this.s.topRowFloat * heights.row );
		}

		this.dom.scroller.scrollTop = iScrollTop;

		// Store positional information so positional calculations can be based
		// upon the current table draw position
		this.s.baseScrollTop = iScrollTop;
		this.s.baseRowTop = this.s.topRowFloat;

		// Position the table in the virtual scroller
		var tableTop = iScrollTop - ((this.s.topRowFloat - displayStart) * heights.row);
		if ( displayStart === 0 ) {
			tableTop = 0;
		}
		else if ( displayStart + displayLen >= displayEnd ) {
			tableTop = heights.scroll - iTableHeight;
		}

		this.dom.table.style.top = tableTop+'px';

		/* Cache some information for the scroller */
		this.s.tableTop = tableTop;
		this.s.tableBottom = iTableHeight + this.s.tableTop;

		// Calculate the boundaries for where a redraw will be triggered by the
		// scroll event listener
		var boundaryPx = (iScrollTop - this.s.tableTop) * this.s.boundaryScale;
		this.s.redrawTop = iScrollTop - boundaryPx;
		this.s.redrawBottom = iScrollTop + boundaryPx > heights.scroll - heights.viewport - heights.row ?
			heights.scroll - heights.viewport - heights.row :
			iScrollTop + boundaryPx;

		this.s.skip = false;

		// Restore the scrolling position that was saved by DataTable's state
		// saving Note that this is done on the second draw when data is Ajax
		// sourced, and the first draw when DOM soured
		if ( this.s.dt.oFeatures.bStateSave && this.s.dt.oLoadedState !== null &&
			 typeof this.s.dt.oLoadedState.iScroller != 'undefined' )
		{
			// A quirk of DataTables is that the draw callback will occur on an
			// empty set if Ajax sourced, but not if server-side processing.
			var ajaxSourced = (this.s.dt.sAjaxSource || that.s.dt.ajax) && ! this.s.dt.oFeatures.bServerSide ?
				true :
				false;

			if ( ( ajaxSourced && this.s.dt.iDraw == 2) ||
			     (!ajaxSourced && this.s.dt.iDraw == 1) )
			{
				setTimeout( function () {
					$(that.dom.scroller).scrollTop( that.s.dt.oLoadedState.iScroller );
					that.s.redrawTop = that.s.dt.oLoadedState.iScroller - (heights.viewport/2);

					// In order to prevent layout thrashing we need another
					// small delay
					setTimeout( function () {
						that.s.ingnoreScroll = false;
					}, 0 );
				}, 0 );
			}
		}
		else {
			that.s.ingnoreScroll = false;
		}

		// Because of the order of the DT callbacks, the info update will
		// take precedence over the one we want here. So a 'thread' break is
		// needed.  Only add the thread break if bInfo is set
		if ( this.s.dt.oFeatures.bInfo ) {
			setTimeout( function () {
				that._fnInfo.call( that );
			}, 0 );
		}

		// Hide the loading indicator
		if ( this.dom.loader && this.s.loaderVisible ) {
			this.dom.loader.css( 'display', 'none' );
			this.s.loaderVisible = false;
		}
	},


	/**
	 * Force the scrolling container to have height beyond that of just the
	 * table that has been drawn so the user can scroll the whole data set.
	 *
	 * Note that if the calculated required scrolling height exceeds a maximum
	 * value (1 million pixels - hard-coded) the forcing element will be set
	 * only to that maximum value and virtual / physical domain transforms will
	 * be used to allow Scroller to display tables of any number of records.
	 *  @returns {void}
	 *  @private
	 */
	_fnScrollForce: function ()
	{
		var heights = this.s.heights;
		var max = 1000000;

		heights.virtual = heights.row * this.s.dt.fnRecordsDisplay();
		heights.scroll = heights.virtual;

		if ( heights.scroll > max ) {
			heights.scroll = max;
		}

		// Minimum height so there is always a row visible (the 'no rows found'
		// if reduced to zero filtering)
		this.dom.force.style.height = heights.scroll > this.s.heights.row ?
			heights.scroll+'px' :
			this.s.heights.row+'px';
	},


	/**
	 * Automatic calculation of table row height. This is just a little tricky here as using
	 * initialisation DataTables has tale the table out of the document, so we need to create
	 * a new table and insert it into the document, calculate the row height and then whip the
	 * table out.
	 *  @returns {void}
	 *  @private
	 */
	"_fnCalcRowHeight": function ()
	{
		var dt = this.s.dt;
		var origTable = dt.nTable;
		var nTable = origTable.cloneNode( false );
		var tbody = $('<tbody/>').appendTo( nTable );
		var container = $(
			'<div class="'+dt.oClasses.sWrapper+' DTS">'+
				'<div class="'+dt.oClasses.sScrollWrapper+'">'+
					'<div class="'+dt.oClasses.sScrollBody+'"></div>'+
				'</div>'+
			'</div>'
		);

		// Want 3 rows in the sizing table so :first-child and :last-child
		// CSS styles don't come into play - take the size of the middle row
		$('tbody tr:lt(4)', origTable).clone().appendTo( tbody );
		while( $('tr', tbody).length < 3 ) {
			tbody.append( '<tr><td>&nbsp;</td></tr>' );
		}

		$('div.'+dt.oClasses.sScrollBody, container).append( nTable );

		// If initialised using `dom`, use the holding element as the insert point
		var insertEl = this.s.dt.nHolding || origTable.parentNode;

		if ( ! $(insertEl).is(':visible') ) {
			insertEl = 'body';
		}

		container.appendTo( insertEl );
		this.s.heights.row = $('tr', tbody).eq(1).outerHeight();

		container.remove();
	},


	/**
	 * Update any information elements that are controlled by the DataTable based on the scrolling
	 * viewport and what rows are visible in it. This function basically acts in the same way as
	 * _fnUpdateInfo in DataTables, and effectively replaces that function.
	 *  @returns {void}
	 *  @private
	 */
	"_fnInfo": function ()
	{
		if ( !this.s.dt.oFeatures.bInfo )
		{
			return;
		}

		var
			dt = this.s.dt,
			language = dt.oLanguage,
			iScrollTop = this.dom.scroller.scrollTop,
			iStart = Math.floor( this.fnPixelsToRow(iScrollTop, false, this.s.ani)+1 ),
			iMax = dt.fnRecordsTotal(),
			iTotal = dt.fnRecordsDisplay(),
			iPossibleEnd = Math.ceil( this.fnPixelsToRow(iScrollTop+this.s.heights.viewport, false, this.s.ani) ),
			iEnd = iTotal < iPossibleEnd ? iTotal : iPossibleEnd,
			sStart = dt.fnFormatNumber( iStart ),
			sEnd = dt.fnFormatNumber( iEnd ),
			sMax = dt.fnFormatNumber( iMax ),
			sTotal = dt.fnFormatNumber( iTotal ),
			sOut;

		if ( dt.fnRecordsDisplay() === 0 &&
			   dt.fnRecordsDisplay() == dt.fnRecordsTotal() )
		{
			/* Empty record set */
			sOut = language.sInfoEmpty+ language.sInfoPostFix;
		}
		else if ( dt.fnRecordsDisplay() === 0 )
		{
			/* Empty record set after filtering */
			sOut = language.sInfoEmpty +' '+
				language.sInfoFiltered.replace('_MAX_', sMax)+
					language.sInfoPostFix;
		}
		else if ( dt.fnRecordsDisplay() == dt.fnRecordsTotal() )
		{
			/* Normal record set */
			sOut = language.sInfo.
					replace('_START_', sStart).
					replace('_END_',   sEnd).
					replace('_MAX_',   sMax).
					replace('_TOTAL_', sTotal)+
				language.sInfoPostFix;
		}
		else
		{
			/* Record set after filtering */
			sOut = language.sInfo.
					replace('_START_', sStart).
					replace('_END_',   sEnd).
					replace('_MAX_',   sMax).
					replace('_TOTAL_', sTotal) +' '+
				language.sInfoFiltered.replace(
					'_MAX_',
					dt.fnFormatNumber(dt.fnRecordsTotal())
				)+
				language.sInfoPostFix;
		}

		var callback = language.fnInfoCallback;
		if ( callback ) {
			sOut = callback.call( dt.oInstance,
				dt, iStart, iEnd, iMax, iTotal, sOut
			);
		}

		var n = dt.aanFeatures.i;
		if ( typeof n != 'undefined' )
		{
			for ( var i=0, iLen=n.length ; i<iLen ; i++ )
			{
				$(n[i]).html( sOut );
			}
		}

		// DT doesn't actually (yet) trigger this event, but it will in future
		$(dt.nTable).triggerHandler( 'info.dt' );
	}
} );



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Statics
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */


/**
 * Scroller default settings for initialisation
 *  @namespace
 *  @name Scroller.defaults
 *  @static
 */
Scroller.defaults = /** @lends Scroller.defaults */{
	/**
	 * Indicate if Scroller show show trace information on the console or not. This can be
	 * useful when debugging Scroller or if just curious as to what it is doing, but should
	 * be turned off for production.
	 *  @type     bool
	 *  @default  false
	 *  @static
	 *  @example
	 *    var oTable = $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "sDom": "frtiS",
	 *        "bDeferRender": true,
	 *        "oScroller": {
	 *          "trace": true
	 *        }
	 *    } );
	 */
	"trace": false,

	/**
	 * Scroller will attempt to automatically calculate the height of rows for it's internal
	 * calculations. However the height that is used can be overridden using this parameter.
	 *  @type     int|string
	 *  @default  auto
	 *  @static
	 *  @example
	 *    var oTable = $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "sDom": "frtiS",
	 *        "bDeferRender": true,
	 *        "oScroller": {
	 *          "rowHeight": 30
	 *        }
	 *    } );
	 */
	"rowHeight": "auto",

	/**
	 * When using server-side processing, Scroller will wait a small amount of time to allow
	 * the scrolling to finish before requesting more data from the server. This prevents
	 * you from DoSing your own server! The wait time can be configured by this parameter.
	 *  @type     int
	 *  @default  200
	 *  @static
	 *  @example
	 *    var oTable = $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "sDom": "frtiS",
	 *        "bDeferRender": true,
	 *        "oScroller": {
	 *          "serverWait": 100
	 *        }
	 *    } );
	 */
	"serverWait": 200,

	/**
	 * The display buffer is what Scroller uses to calculate how many rows it should pre-fetch
	 * for scrolling. Scroller automatically adjusts DataTables' display length to pre-fetch
	 * rows that will be shown in "near scrolling" (i.e. just beyond the current display area).
	 * The value is based upon the number of rows that can be displayed in the viewport (i.e.
	 * a value of 1), and will apply the display range to records before before and after the
	 * current viewport - i.e. a factor of 3 will allow Scroller to pre-fetch 1 viewport's worth
	 * of rows before the current viewport, the current viewport's rows and 1 viewport's worth
	 * of rows after the current viewport. Adjusting this value can be useful for ensuring
	 * smooth scrolling based on your data set.
	 *  @type     int
	 *  @default  7
	 *  @static
	 *  @example
	 *    var oTable = $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "sDom": "frtiS",
	 *        "bDeferRender": true,
	 *        "oScroller": {
	 *          "displayBuffer": 10
	 *        }
	 *    } );
	 */
	"displayBuffer": 9,

	/**
	 * Scroller uses the boundary scaling factor to decide when to redraw the table - which it
	 * typically does before you reach the end of the currently loaded data set (in order to
	 * allow the data to look continuous to a user scrolling through the data). If given as 0
	 * then the table will be redrawn whenever the viewport is scrolled, while 1 would not
	 * redraw the table until the currently loaded data has all been shown. You will want
	 * something in the middle - the default factor of 0.5 is usually suitable.
	 *  @type     float
	 *  @default  0.5
	 *  @static
	 *  @example
	 *    var oTable = $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "sDom": "frtiS",
	 *        "bDeferRender": true,
	 *        "oScroller": {
	 *          "boundaryScale": 0.75
	 *        }
	 *    } );
	 */
	"boundaryScale": 0.5,

	/**
	 * Show (or not) the loading element in the background of the table. Note that you should
	 * include the dataTables.scroller.css file for this to be displayed correctly.
	 *  @type     boolean
	 *  @default  false
	 *  @static
	 *  @example
	 *    var oTable = $('#example').dataTable( {
	 *        "sScrollY": "200px",
	 *        "sDom": "frtiS",
	 *        "bDeferRender": true,
	 *        "oScroller": {
	 *          "loadingIndicator": true
	 *        }
	 *    } );
	 */
	"loadingIndicator": false
};

Scroller.oDefaults = Scroller.defaults;



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Constants
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/**
 * Scroller version
 *  @type      String
 *  @default   See code
 *  @name      Scroller.version
 *  @static
 */
Scroller.version = "1.5.1";



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Initialisation
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

// Legacy `dom` parameter initialisation support
if ( typeof $.fn.dataTable == "function" &&
     typeof $.fn.dataTableExt.fnVersionCheck == "function" &&
     $.fn.dataTableExt.fnVersionCheck('1.10.0') )
{
	$.fn.dataTableExt.aoFeatures.push( {
		"fnInit": function( oDTSettings ) {
			var init = oDTSettings.oInit;
			var opts = init.scroller || init.oScroller || {};
			
			new Scroller( oDTSettings, opts );
		},
		"cFeature": "S",
		"sFeature": "Scroller"
	} );
}
else
{
	alert( "Warning: Scroller requires DataTables 1.10.0 or greater - www.datatables.net/download");
}

// Attach a listener to the document which listens for DataTables initialisation
// events so we can automatically initialise
$(document).on( 'preInit.dt.dtscroller', function (e, settings) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	var init = settings.oInit.scroller;
	var defaults = DataTable.defaults.scroller;

	if ( init || defaults ) {
		var opts = $.extend( {}, init, defaults );

		if ( init !== false ) {
			new Scroller( settings, opts  );
		}
	}
} );


// Attach Scroller to DataTables so it can be accessed as an 'extra'
$.fn.dataTable.Scroller = Scroller;
$.fn.DataTable.Scroller = Scroller;


// DataTables 1.10 API method aliases
var Api = $.fn.dataTable.Api;

Api.register( 'scroller()', function () {
	return this;
} );

// Undocumented and deprecated - is it actually useful at all?
Api.register( 'scroller().rowToPixels()', function ( rowIdx, intParse, virtual ) {
	var ctx = this.context;

	if ( ctx.length && ctx[0].oScroller ) {
		return ctx[0].oScroller.fnRowToPixels( rowIdx, intParse, virtual );
	}
	// undefined
} );

// Undocumented and deprecated - is it actually useful at all?
Api.register( 'scroller().pixelsToRow()', function ( pixels, intParse, virtual ) {
	var ctx = this.context;

	if ( ctx.length && ctx[0].oScroller ) {
		return ctx[0].oScroller.fnPixelsToRow( pixels, intParse, virtual );
	}
	// undefined
} );

// `scroller().scrollToRow()` is undocumented and deprecated. Use `scroller.toPosition()
Api.register( ['scroller().scrollToRow()', 'scroller.toPosition()'], function ( idx, ani ) {
	this.iterator( 'table', function ( ctx ) {
		if ( ctx.oScroller ) {
			ctx.oScroller.fnScrollToRow( idx, ani );
		}
	} );

	return this;
} );

Api.register( 'row().scrollTo()', function ( ani ) {
	var that = this;

	this.iterator( 'row', function ( ctx, rowIdx ) {
		if ( ctx.oScroller ) {
			var displayIdx = that
				.rows( { order: 'applied', search: 'applied' } )
				.indexes()
				.indexOf( rowIdx );

			ctx.oScroller.fnScrollToRow( displayIdx, ani );
		}
	} );

	return this;
} );

Api.register( 'scroller.measure()', function ( redraw ) {
	this.iterator( 'table', function ( ctx ) {
		if ( ctx.oScroller ) {
			ctx.oScroller.fnMeasure( redraw );
		}
	} );

	return this;
} );

Api.register( 'scroller.page()', function() {
	var ctx = this.context;

	if ( ctx.length && ctx[0].oScroller ) {
		return ctx[0].oScroller.fnPageInfo();
	}
	// undefined
} );

return Scroller;
}));


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Select for DataTables 1.3.0
 * 2015-2018 SpryMedia Ltd - datatables.net/license/mit
 */

/**
 * @summary     Select for DataTables
 * @description A collection of API methods, events and buttons for DataTables
 *   that provides selection options of the items in a DataTable
 * @version     1.3.0
 * @file        dataTables.select.js
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     datatables.net/forums
 * @copyright   Copyright 2015-2018 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net/extensions/select
 */
(function( factory ){
	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


// Version information for debugger
DataTable.select = {};

DataTable.select.version = '1.3.0';

DataTable.select.init = function ( dt ) {
	var ctx = dt.settings()[0];
	var init = ctx.oInit.select;
	var defaults = DataTable.defaults.select;
	var opts = init === undefined ?
		defaults :
		init;

	// Set defaults
	var items = 'row';
	var style = 'api';
	var blurable = false;
	var info = true;
	var selector = 'td, th';
	var className = 'selected';
	var setStyle = false;

	ctx._select = {};

	// Initialisation customisations
	if ( opts === true ) {
		style = 'os';
		setStyle = true;
	}
	else if ( typeof opts === 'string' ) {
		style = opts;
		setStyle = true;
	}
	else if ( $.isPlainObject( opts ) ) {
		if ( opts.blurable !== undefined ) {
			blurable = opts.blurable;
		}

		if ( opts.info !== undefined ) {
			info = opts.info;
		}

		if ( opts.items !== undefined ) {
			items = opts.items;
		}

		if ( opts.style !== undefined ) {
			style = opts.style;
			setStyle = true;
		}
		else {
			style = 'os';
			setStyle = true;
		}

		if ( opts.selector !== undefined ) {
			selector = opts.selector;
		}

		if ( opts.className !== undefined ) {
			className = opts.className;
		}
	}

	dt.select.selector( selector );
	dt.select.items( items );
	dt.select.style( style );
	dt.select.blurable( blurable );
	dt.select.info( info );
	ctx._select.className = className;


	// Sort table based on selected rows. Requires Select Datatables extension
	$.fn.dataTable.ext.order['select-checkbox'] = function ( settings, col ) {
		return this.api().column( col, {order: 'index'} ).nodes().map( function ( td ) {
			if ( settings._select.items === 'row' ) {
				return $( td ).parent().hasClass( settings._select.className );
			} else if ( settings._select.items === 'cell' ) {
				return $( td ).hasClass( settings._select.className );
			}
			return false;
		});
	};

	// If the init options haven't enabled select, but there is a selectable
	// class name, then enable
	if ( ! setStyle && $( dt.table().node() ).hasClass( 'selectable' ) ) {
		dt.select.style( 'os' );
	}
};

/*

Select is a collection of API methods, event handlers, event emitters and
buttons (for the `Buttons` extension) for DataTables. It provides the following
features, with an overview of how they are implemented:

## Selection of rows, columns and cells. Whether an item is selected or not is
   stored in:

* rows: a `_select_selected` property which contains a boolean value of the
  DataTables' `aoData` object for each row
* columns: a `_select_selected` property which contains a boolean value of the
  DataTables' `aoColumns` object for each column
* cells: a `_selected_cells` property which contains an array of boolean values
  of the `aoData` object for each row. The array is the same length as the
  columns array, with each element of it representing a cell.

This method of using boolean flags allows Select to operate when nodes have not
been created for rows / cells (DataTables' defer rendering feature).

## API methods

A range of API methods are available for triggering selection and de-selection
of rows. Methods are also available to configure the selection events that can
be triggered by an end user (such as which items are to be selected). To a large
extent, these of API methods *is* Select. It is basically a collection of helper
functions that can be used to select items in a DataTable.

Configuration of select is held in the object `_select` which is attached to the
DataTables settings object on initialisation. Select being available on a table
is not optional when Select is loaded, but its default is for selection only to
be available via the API - so the end user wouldn't be able to select rows
without additional configuration.

The `_select` object contains the following properties:

```
{
	items:string     - Can be `rows`, `columns` or `cells`. Defines what item 
	                   will be selected if the user is allowed to activate row
	                   selection using the mouse.
	style:string     - Can be `none`, `single`, `multi` or `os`. Defines the
	                   interaction style when selecting items
	blurable:boolean - If row selection can be cleared by clicking outside of
	                   the table
	info:boolean     - If the selection summary should be shown in the table
	                   information elements
}
```

In addition to the API methods, Select also extends the DataTables selector
options for rows, columns and cells adding a `selected` option to the selector
options object, allowing the developer to select only selected items or
unselected items.

## Mouse selection of items

Clicking on items can be used to select items. This is done by a simple event
handler that will select the items using the API methods.

 */


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Local functions
 */

/**
 * Add one or more cells to the selection when shift clicking in OS selection
 * style cell selection.
 *
 * Cell range is more complicated than row and column as we want to select
 * in the visible grid rather than by index in sequence. For example, if you
 * click first in cell 1-1 and then shift click in 2-2 - cells 1-2 and 2-1
 * should also be selected (and not 1-3, 1-4. etc)
 * 
 * @param  {DataTable.Api} dt   DataTable
 * @param  {object}        idx  Cell index to select to
 * @param  {object}        last Cell index to select from
 * @private
 */
function cellRange( dt, idx, last )
{
	var indexes;
	var columnIndexes;
	var rowIndexes;
	var selectColumns = function ( start, end ) {
		if ( start > end ) {
			var tmp = end;
			end = start;
			start = tmp;
		}
		
		var record = false;
		return dt.columns( ':visible' ).indexes().filter( function (i) {
			if ( i === start ) {
				record = true;
			}
			
			if ( i === end ) { // not else if, as start might === end
				record = false;
				return true;
			}

			return record;
		} );
	};

	var selectRows = function ( start, end ) {
		var indexes = dt.rows( { search: 'applied' } ).indexes();

		// Which comes first - might need to swap
		if ( indexes.indexOf( start ) > indexes.indexOf( end ) ) {
			var tmp = end;
			end = start;
			start = tmp;
		}

		var record = false;
		return indexes.filter( function (i) {
			if ( i === start ) {
				record = true;
			}
			
			if ( i === end ) {
				record = false;
				return true;
			}

			return record;
		} );
	};

	if ( ! dt.cells( { selected: true } ).any() && ! last ) {
		// select from the top left cell to this one
		columnIndexes = selectColumns( 0, idx.column );
		rowIndexes = selectRows( 0 , idx.row );
	}
	else {
		// Get column indexes between old and new
		columnIndexes = selectColumns( last.column, idx.column );
		rowIndexes = selectRows( last.row , idx.row );
	}

	indexes = dt.cells( rowIndexes, columnIndexes ).flatten();

	if ( ! dt.cells( idx, { selected: true } ).any() ) {
		// Select range
		dt.cells( indexes ).select();
	}
	else {
		// Deselect range
		dt.cells( indexes ).deselect();
	}
}

/**
 * Disable mouse selection by removing the selectors
 *
 * @param {DataTable.Api} dt DataTable to remove events from
 * @private
 */
function disableMouseSelection( dt )
{
	var ctx = dt.settings()[0];
	var selector = ctx._select.selector;

	$( dt.table().container() )
		.off( 'mousedown.dtSelect', selector )
		.off( 'mouseup.dtSelect', selector )
		.off( 'click.dtSelect', selector );

	$('body').off( 'click.dtSelect' + dt.table().node().id );
}

/**
 * Attach mouse listeners to the table to allow mouse selection of items
 *
 * @param {DataTable.Api} dt DataTable to remove events from
 * @private
 */
function enableMouseSelection ( dt )
{
	var container = $( dt.table().container() );
	var ctx = dt.settings()[0];
	var selector = ctx._select.selector;
	var matchSelection;

	container
		.on( 'mousedown.dtSelect', selector, function(e) {
			// Disallow text selection for shift clicking on the table so multi
			// element selection doesn't look terrible!
			if ( e.shiftKey || e.metaKey || e.ctrlKey ) {
				container
					.css( '-moz-user-select', 'none' )
					.one('selectstart.dtSelect', selector, function () {
						return false;
					} );
			}

			if ( window.getSelection ) {
				matchSelection = window.getSelection();
			}
		} )
		.on( 'mouseup.dtSelect', selector, function() {
			// Allow text selection to occur again, Mozilla style (tested in FF
			// 35.0.1 - still required)
			container.css( '-moz-user-select', '' );
		} )
		.on( 'click.dtSelect', selector, function ( e ) {
			var items = dt.select.items();
			var idx;

			// If text was selected (click and drag), then we shouldn't change
			// the row's selected state
			if ( matchSelection ) {
				var selection = window.getSelection();

				// If the element that contains the selection is not in the table, we can ignore it
				// This can happen if the developer selects text from the click event
				if ( ! selection.anchorNode || $(selection.anchorNode).closest('table')[0] === dt.table().node() ) {
					if ( selection !== matchSelection ) {
						return;
					}
				}
			}

			var ctx = dt.settings()[0];
			var wrapperClass = $.trim(dt.settings()[0].oClasses.sWrapper).replace(/ +/g, '.');

			// Ignore clicks inside a sub-table
			if ( $(e.target).closest('div.'+wrapperClass)[0] != dt.table().container() ) {
				return;
			}

			var cell = dt.cell( $(e.target).closest('td, th') );

			// Check the cell actually belongs to the host DataTable (so child
			// rows, etc, are ignored)
			if ( ! cell.any() ) {
				return;
			}

			var event = $.Event('user-select.dt');
			eventTrigger( dt, event, [ items, cell, e ] );

			if ( event.isDefaultPrevented() ) {
				return;
			}

			var cellIndex = cell.index();
			if ( items === 'row' ) {
				idx = cellIndex.row;
				typeSelect( e, dt, ctx, 'row', idx );
			}
			else if ( items === 'column' ) {
				idx = cell.index().column;
				typeSelect( e, dt, ctx, 'column', idx );
			}
			else if ( items === 'cell' ) {
				idx = cell.index();
				typeSelect( e, dt, ctx, 'cell', idx );
			}

			ctx._select_lastCell = cellIndex;
		} );

	// Blurable
	$('body').on( 'click.dtSelect' + dt.table().node().id, function ( e ) {
		if ( ctx._select.blurable ) {
			// If the click was inside the DataTables container, don't blur
			if ( $(e.target).parents().filter( dt.table().container() ).length ) {
				return;
			}

			// Ignore elements which have been removed from the DOM (i.e. paging
			// buttons)
			if ( $(e.target).parents('html').length === 0 ) {
			 	return;
			}

			// Don't blur in Editor form
			if ( $(e.target).parents('div.DTE').length ) {
				return;
			}

			clear( ctx, true );
		}
	} );
}

/**
 * Trigger an event on a DataTable
 *
 * @param {DataTable.Api} api      DataTable to trigger events on
 * @param  {boolean}      selected true if selected, false if deselected
 * @param  {string}       type     Item type acting on
 * @param  {boolean}      any      Require that there are values before
 *     triggering
 * @private
 */
function eventTrigger ( api, type, args, any )
{
	if ( any && ! api.flatten().length ) {
		return;
	}

	if ( typeof type === 'string' ) {
		type = type +'.dt';
	}

	args.unshift( api );

	$(api.table().node()).trigger( type, args );
}

/**
 * Update the information element of the DataTable showing information about the
 * items selected. This is done by adding tags to the existing text
 * 
 * @param {DataTable.Api} api DataTable to update
 * @private
 */
function info ( api )
{
	var ctx = api.settings()[0];

	if ( ! ctx._select.info || ! ctx.aanFeatures.i ) {
		return;
	}

	if ( api.select.style() === 'api' ) {
		return;
	}

	var rows    = api.rows( { selected: true } ).flatten().length;
	var columns = api.columns( { selected: true } ).flatten().length;
	var cells   = api.cells( { selected: true } ).flatten().length;

	var add = function ( el, name, num ) {
		el.append( $('<span class="select-item"/>').append( api.i18n(
			'select.'+name+'s',
			{ _: '%d '+name+'s selected', 0: '', 1: '1 '+name+' selected' },
			num
		) ) );
	};

	// Internal knowledge of DataTables to loop over all information elements
	$.each( ctx.aanFeatures.i, function ( i, el ) {
		el = $(el);

		var output  = $('<span class="select-info"/>');
		add( output, 'row', rows );
		add( output, 'column', columns );
		add( output, 'cell', cells  );

		var exisiting = el.children('span.select-info');
		if ( exisiting.length ) {
			exisiting.remove();
		}

		if ( output.text() !== '' ) {
			el.append( output );
		}
	} );
}

/**
 * Initialisation of a new table. Attach event handlers and callbacks to allow
 * Select to operate correctly.
 *
 * This will occur _after_ the initial DataTables initialisation, although
 * before Ajax data is rendered, if there is ajax data
 *
 * @param  {DataTable.settings} ctx Settings object to operate on
 * @private
 */
function init ( ctx ) {
	var api = new DataTable.Api( ctx );

	// Row callback so that classes can be added to rows and cells if the item
	// was selected before the element was created. This will happen with the
	// `deferRender` option enabled.
	// 
	// This method of attaching to `aoRowCreatedCallback` is a hack until
	// DataTables has proper events for row manipulation If you are reviewing
	// this code to create your own plug-ins, please do not do this!
	ctx.aoRowCreatedCallback.push( {
		fn: function ( row, data, index ) {
			var i, ien;
			var d = ctx.aoData[ index ];

			// Row
			if ( d._select_selected ) {
				$( row ).addClass( ctx._select.className );
			}

			// Cells and columns - if separated out, we would need to do two
			// loops, so it makes sense to combine them into a single one
			for ( i=0, ien=ctx.aoColumns.length ; i<ien ; i++ ) {
				if ( ctx.aoColumns[i]._select_selected || (d._selected_cells && d._selected_cells[i]) ) {
					$(d.anCells[i]).addClass( ctx._select.className );
				}
			}
		},
		sName: 'select-deferRender'
	} );

	// On Ajax reload we want to reselect all rows which are currently selected,
	// if there is an rowId (i.e. a unique value to identify each row with)
	api.on( 'preXhr.dt.dtSelect', function () {
		// note that column selection doesn't need to be cached and then
		// reselected, as they are already selected
		var rows = api.rows( { selected: true } ).ids( true ).filter( function ( d ) {
			return d !== undefined;
		} );

		var cells = api.cells( { selected: true } ).eq(0).map( function ( cellIdx ) {
			var id = api.row( cellIdx.row ).id( true );
			return id ?
				{ row: id, column: cellIdx.column } :
				undefined;
		} ).filter( function ( d ) {
			return d !== undefined;
		} );

		// On the next draw, reselect the currently selected items
		api.one( 'draw.dt.dtSelect', function () {
			api.rows( rows ).select();

			// `cells` is not a cell index selector, so it needs a loop
			if ( cells.any() ) {
				cells.each( function ( id ) {
					api.cells( id.row, id.column ).select();
				} );
			}
		} );
	} );

	// Update the table information element with selected item summary
	api.on( 'draw.dtSelect.dt select.dtSelect.dt deselect.dtSelect.dt info.dt', function () {
		info( api );
	} );

	// Clean up and release
	api.on( 'destroy.dtSelect', function () {
		disableMouseSelection( api );
		api.off( '.dtSelect' );
	} );
}

/**
 * Add one or more items (rows or columns) to the selection when shift clicking
 * in OS selection style
 *
 * @param  {DataTable.Api} dt   DataTable
 * @param  {string}        type Row or column range selector
 * @param  {object}        idx  Item index to select to
 * @param  {object}        last Item index to select from
 * @private
 */
function rowColumnRange( dt, type, idx, last )
{
	// Add a range of rows from the last selected row to this one
	var indexes = dt[type+'s']( { search: 'applied' } ).indexes();
	var idx1 = $.inArray( last, indexes );
	var idx2 = $.inArray( idx, indexes );

	if ( ! dt[type+'s']( { selected: true } ).any() && idx1 === -1 ) {
		// select from top to here - slightly odd, but both Windows and Mac OS
		// do this
		indexes.splice( $.inArray( idx, indexes )+1, indexes.length );
	}
	else {
		// reverse so we can shift click 'up' as well as down
		if ( idx1 > idx2 ) {
			var tmp = idx2;
			idx2 = idx1;
			idx1 = tmp;
		}

		indexes.splice( idx2+1, indexes.length );
		indexes.splice( 0, idx1 );
	}

	if ( ! dt[type]( idx, { selected: true } ).any() ) {
		// Select range
		dt[type+'s']( indexes ).select();
	}
	else {
		// Deselect range - need to keep the clicked on row selected
		indexes.splice( $.inArray( idx, indexes ), 1 );
		dt[type+'s']( indexes ).deselect();
	}
}

/**
 * Clear all selected items
 *
 * @param  {DataTable.settings} ctx Settings object of the host DataTable
 * @param  {boolean} [force=false] Force the de-selection to happen, regardless
 *     of selection style
 * @private
 */
function clear( ctx, force )
{
	if ( force || ctx._select.style === 'single' ) {
		var api = new DataTable.Api( ctx );
		
		api.rows( { selected: true } ).deselect();
		api.columns( { selected: true } ).deselect();
		api.cells( { selected: true } ).deselect();
	}
}

/**
 * Select items based on the current configuration for style and items.
 *
 * @param  {object}             e    Mouse event object
 * @param  {DataTables.Api}     dt   DataTable
 * @param  {DataTable.settings} ctx  Settings object of the host DataTable
 * @param  {string}             type Items to select
 * @param  {int|object}         idx  Index of the item to select
 * @private
 */
function typeSelect ( e, dt, ctx, type, idx )
{
	var style = dt.select.style();
	var isSelected = dt[type]( idx, { selected: true } ).any();

	if ( style === 'os' ) {
		if ( e.ctrlKey || e.metaKey ) {
			// Add or remove from the selection
			dt[type]( idx ).select( ! isSelected );
		}
		else if ( e.shiftKey ) {
			if ( type === 'cell' ) {
				cellRange( dt, idx, ctx._select_lastCell || null );
			}
			else {
				rowColumnRange( dt, type, idx, ctx._select_lastCell ?
					ctx._select_lastCell[type] :
					null
				);
			}
		}
		else {
			// No cmd or shift click - deselect if selected, or select
			// this row only
			var selected = dt[type+'s']( { selected: true } );

			if ( isSelected && selected.flatten().length === 1 ) {
				dt[type]( idx ).deselect();
			}
			else {
				selected.deselect();
				dt[type]( idx ).select();
			}
		}
	} else if ( style == 'multi+shift' ) {
		if ( e.shiftKey ) {
			if ( type === 'cell' ) {
				cellRange( dt, idx, ctx._select_lastCell || null );
			}
			else {
				rowColumnRange( dt, type, idx, ctx._select_lastCell ?
					ctx._select_lastCell[type] :
					null
				);
			}
		}
		else {
			dt[ type ]( idx ).select( ! isSelected );
		}
	}
	else {
		dt[ type ]( idx ).select( ! isSelected );
	}
}



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables selectors
 */

// row and column are basically identical just assigned to different properties
// and checking a different array, so we can dynamically create the functions to
// reduce the code size
$.each( [
	{ type: 'row', prop: 'aoData' },
	{ type: 'column', prop: 'aoColumns' }
], function ( i, o ) {
	DataTable.ext.selector[ o.type ].push( function ( settings, opts, indexes ) {
		var selected = opts.selected;
		var data;
		var out = [];

		if ( selected !== true && selected !== false ) {
			return indexes;
		}

		for ( var i=0, ien=indexes.length ; i<ien ; i++ ) {
			data = settings[ o.prop ][ indexes[i] ];

			if ( (selected === true && data._select_selected === true) ||
			     (selected === false && ! data._select_selected )
			) {
				out.push( indexes[i] );
			}
		}

		return out;
	} );
} );

DataTable.ext.selector.cell.push( function ( settings, opts, cells ) {
	var selected = opts.selected;
	var rowData;
	var out = [];

	if ( selected === undefined ) {
		return cells;
	}

	for ( var i=0, ien=cells.length ; i<ien ; i++ ) {
		rowData = settings.aoData[ cells[i].row ];

		if ( (selected === true && rowData._selected_cells && rowData._selected_cells[ cells[i].column ] === true) ||
		     (selected === false && ( ! rowData._selected_cells || ! rowData._selected_cells[ cells[i].column ] ) )
		) {
			out.push( cells[i] );
		}
	}

	return out;
} );



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables API
 *
 * For complete documentation, please refer to the docs/api directory or the
 * DataTables site
 */

// Local variables to improve compression
var apiRegister = DataTable.Api.register;
var apiRegisterPlural = DataTable.Api.registerPlural;

apiRegister( 'select()', function () {
	return this.iterator( 'table', function ( ctx ) {
		DataTable.select.init( new DataTable.Api( ctx ) );
	} );
} );

apiRegister( 'select.blurable()', function ( flag ) {
	if ( flag === undefined ) {
		return this.context[0]._select.blurable;
	}

	return this.iterator( 'table', function ( ctx ) {
		ctx._select.blurable = flag;
	} );
} );

apiRegister( 'select.info()', function ( flag ) {
	if ( info === undefined ) {
		return this.context[0]._select.info;
	}

	return this.iterator( 'table', function ( ctx ) {
		ctx._select.info = flag;
	} );
} );

apiRegister( 'select.items()', function ( items ) {
	if ( items === undefined ) {
		return this.context[0]._select.items;
	}

	return this.iterator( 'table', function ( ctx ) {
		ctx._select.items = items;

		eventTrigger( new DataTable.Api( ctx ), 'selectItems', [ items ] );
	} );
} );

// Takes effect from the _next_ selection. None disables future selection, but
// does not clear the current selection. Use the `deselect` methods for that
apiRegister( 'select.style()', function ( style ) {
	if ( style === undefined ) {
		return this.context[0]._select.style;
	}

	return this.iterator( 'table', function ( ctx ) {
		ctx._select.style = style;

		if ( ! ctx._select_init ) {
			init( ctx );
		}

		// Add / remove mouse event handlers. They aren't required when only
		// API selection is available
		var dt = new DataTable.Api( ctx );
		disableMouseSelection( dt );
		
		if ( style !== 'api' ) {
			enableMouseSelection( dt );
		}

		eventTrigger( new DataTable.Api( ctx ), 'selectStyle', [ style ] );
	} );
} );

apiRegister( 'select.selector()', function ( selector ) {
	if ( selector === undefined ) {
		return this.context[0]._select.selector;
	}

	return this.iterator( 'table', function ( ctx ) {
		disableMouseSelection( new DataTable.Api( ctx ) );

		ctx._select.selector = selector;

		if ( ctx._select.style !== 'api' ) {
			enableMouseSelection( new DataTable.Api( ctx ) );
		}
	} );
} );



apiRegisterPlural( 'rows().select()', 'row().select()', function ( select ) {
	var api = this;

	if ( select === false ) {
		return this.deselect();
	}

	this.iterator( 'row', function ( ctx, idx ) {
		clear( ctx );

		ctx.aoData[ idx ]._select_selected = true;
		$( ctx.aoData[ idx ].nTr ).addClass( ctx._select.className );
	} );

	this.iterator( 'table', function ( ctx, i ) {
		eventTrigger( api, 'select', [ 'row', api[i] ], true );
	} );

	return this;
} );

apiRegisterPlural( 'columns().select()', 'column().select()', function ( select ) {
	var api = this;

	if ( select === false ) {
		return this.deselect();
	}

	this.iterator( 'column', function ( ctx, idx ) {
		clear( ctx );

		ctx.aoColumns[ idx ]._select_selected = true;

		var column = new DataTable.Api( ctx ).column( idx );

		$( column.header() ).addClass( ctx._select.className );
		$( column.footer() ).addClass( ctx._select.className );

		column.nodes().to$().addClass( ctx._select.className );
	} );

	this.iterator( 'table', function ( ctx, i ) {
		eventTrigger( api, 'select', [ 'column', api[i] ], true );
	} );

	return this;
} );

apiRegisterPlural( 'cells().select()', 'cell().select()', function ( select ) {
	var api = this;

	if ( select === false ) {
		return this.deselect();
	}

	this.iterator( 'cell', function ( ctx, rowIdx, colIdx ) {
		clear( ctx );

		var data = ctx.aoData[ rowIdx ];

		if ( data._selected_cells === undefined ) {
			data._selected_cells = [];
		}

		data._selected_cells[ colIdx ] = true;

		if ( data.anCells ) {
			$( data.anCells[ colIdx ] ).addClass( ctx._select.className );
		}
	} );

	this.iterator( 'table', function ( ctx, i ) {
		eventTrigger( api, 'select', [ 'cell', api[i] ], true );
	} );

	return this;
} );


apiRegisterPlural( 'rows().deselect()', 'row().deselect()', function () {
	var api = this;

	this.iterator( 'row', function ( ctx, idx ) {
		ctx.aoData[ idx ]._select_selected = false;
		$( ctx.aoData[ idx ].nTr ).removeClass( ctx._select.className );
	} );

	this.iterator( 'table', function ( ctx, i ) {
		eventTrigger( api, 'deselect', [ 'row', api[i] ], true );
	} );

	return this;
} );

apiRegisterPlural( 'columns().deselect()', 'column().deselect()', function () {
	var api = this;

	this.iterator( 'column', function ( ctx, idx ) {
		ctx.aoColumns[ idx ]._select_selected = false;

		var api = new DataTable.Api( ctx );
		var column = api.column( idx );

		$( column.header() ).removeClass( ctx._select.className );
		$( column.footer() ).removeClass( ctx._select.className );

		// Need to loop over each cell, rather than just using
		// `column().nodes()` as cells which are individually selected should
		// not have the `selected` class removed from them
		api.cells( null, idx ).indexes().each( function (cellIdx) {
			var data = ctx.aoData[ cellIdx.row ];
			var cellSelected = data._selected_cells;

			if ( data.anCells && (! cellSelected || ! cellSelected[ cellIdx.column ]) ) {
				$( data.anCells[ cellIdx.column  ] ).removeClass( ctx._select.className );
			}
		} );
	} );

	this.iterator( 'table', function ( ctx, i ) {
		eventTrigger( api, 'deselect', [ 'column', api[i] ], true );
	} );

	return this;
} );

apiRegisterPlural( 'cells().deselect()', 'cell().deselect()', function () {
	var api = this;

	this.iterator( 'cell', function ( ctx, rowIdx, colIdx ) {
		var data = ctx.aoData[ rowIdx ];

		data._selected_cells[ colIdx ] = false;

		// Remove class only if the cells exist, and the cell is not column
		// selected, in which case the class should remain (since it is selected
		// in the column)
		if ( data.anCells && ! ctx.aoColumns[ colIdx ]._select_selected ) {
			$( data.anCells[ colIdx ] ).removeClass( ctx._select.className );
		}
	} );

	this.iterator( 'table', function ( ctx, i ) {
		eventTrigger( api, 'deselect', [ 'cell', api[i] ], true );
	} );

	return this;
} );



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Buttons
 */
function i18n( label, def ) {
	return function (dt) {
		return dt.i18n( 'buttons.'+label, def );
	};
}

// Common events with suitable namespaces
function namespacedEvents ( config ) {
	var unique = config._eventNamespace;

	return 'draw.dt.DT'+unique+' select.dt.DT'+unique+' deselect.dt.DT'+unique;
}

function enabled ( dt, config ) {
	if ( $.inArray( 'rows', config.limitTo ) !== -1 && dt.rows( { selected: true } ).any() ) {
		return true;
	}

	if ( $.inArray( 'columns', config.limitTo ) !== -1 && dt.columns( { selected: true } ).any() ) {
		return true;
	}

	if ( $.inArray( 'cells', config.limitTo ) !== -1 && dt.cells( { selected: true } ).any() ) {
		return true;
	}

	return false;
}

var _buttonNamespace = 0;

$.extend( DataTable.ext.buttons, {
	selected: {
		text: i18n( 'selected', 'Selected' ),
		className: 'buttons-selected',
		limitTo: [ 'rows', 'columns', 'cells' ],
		init: function ( dt, node, config ) {
			var that = this;
			config._eventNamespace = '.select'+(_buttonNamespace++);

			// .DT namespace listeners are removed by DataTables automatically
			// on table destroy
			dt.on( namespacedEvents(config), function () {
				that.enable( enabled(dt, config) );
			} );

			this.disable();
		},
		destroy: function ( dt, node, config ) {
			dt.off( config._eventNamespace );
		}
	},
	selectedSingle: {
		text: i18n( 'selectedSingle', 'Selected single' ),
		className: 'buttons-selected-single',
		init: function ( dt, node, config ) {
			var that = this;
			config._eventNamespace = '.select'+(_buttonNamespace++);

			dt.on( namespacedEvents(config), function () {
				var count = dt.rows( { selected: true } ).flatten().length +
				            dt.columns( { selected: true } ).flatten().length +
				            dt.cells( { selected: true } ).flatten().length;

				that.enable( count === 1 );
			} );

			this.disable();
		},
		destroy: function ( dt, node, config ) {
			dt.off( config._eventNamespace );
		}
	},
	selectAll: {
		text: i18n( 'selectAll', 'Select all' ),
		className: 'buttons-select-all',
		action: function () {
			var items = this.select.items();
			this[ items+'s' ]().select();
		}
	},
	selectNone: {
		text: i18n( 'selectNone', 'Deselect all' ),
		className: 'buttons-select-none',
		action: function () {
			clear( this.settings()[0], true );
		},
		init: function ( dt, node, config ) {
			var that = this;
			config._eventNamespace = '.select'+(_buttonNamespace++);

			dt.on( namespacedEvents(config), function () {
				var count = dt.rows( { selected: true } ).flatten().length +
				            dt.columns( { selected: true } ).flatten().length +
				            dt.cells( { selected: true } ).flatten().length;

				that.enable( count > 0 );
			} );

			this.disable();
		},
		destroy: function ( dt, node, config ) {
			dt.off( config._eventNamespace );
		}
	}
} );

$.each( [ 'Row', 'Column', 'Cell' ], function ( i, item ) {
	var lc = item.toLowerCase();

	DataTable.ext.buttons[ 'select'+item+'s' ] = {
		text: i18n( 'select'+item+'s', 'Select '+lc+'s' ),
		className: 'buttons-select-'+lc+'s',
		action: function () {
			this.select.items( lc );
		},
		init: function ( dt ) {
			var that = this;

			dt.on( 'selectItems.dt.DT', function ( e, ctx, items ) {
				that.active( items === lc );
			} );
		}
	};
} );



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Initialisation
 */

// DataTables creation - check if select has been defined in the options. Note
// this required that the table be in the document! If it isn't then something
// needs to trigger this method unfortunately. The next major release of
// DataTables will rework the events and address this.
$(document).on( 'preInit.dt.dtSelect', function (e, ctx) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	DataTable.select.init( new DataTable.Api( ctx ) );
} );


return DataTable.select;
}));


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function fuzzysearch (needle, haystack) {
  var tlen = haystack.length;
  var qlen = needle.length;
  if (qlen > tlen) {
    return false;
  }
  if (qlen === tlen) {
    return needle === haystack;
  }
  outer: for (var i = 0, j = 0; i < qlen; i++) {
    var nch = needle.charCodeAt(i);
    while (j < tlen) {
      if (haystack.charCodeAt(j++) === nch) {
        continue outer;
      }
    }
    return false;
  }
  return true;
}

module.exports = fuzzysearch;


/***/ }),
/* 1132 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 1133 */
/***/ (function(module, exports) {

module.exports = isPromise;
module.exports.default = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(482),
    getRawTag = __webpack_require__(1136),
    objectToString = __webpack_require__(1137);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(482);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1137 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(1149);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

module.exports = before;


/***/ }),
/* 1139 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(484),
    now = __webpack_require__(1146),
    toNumber = __webpack_require__(486);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1141 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1142 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1134),
    isObjectLike = __webpack_require__(1142);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 1144 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 1145 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(483);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var before = __webpack_require__(1138);

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

module.exports = once;


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(486);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1148);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 487,
	"./af.js": 487,
	"./ar": 494,
	"./ar-dz": 488,
	"./ar-dz.js": 488,
	"./ar-kw": 489,
	"./ar-kw.js": 489,
	"./ar-ly": 490,
	"./ar-ly.js": 490,
	"./ar-ma": 491,
	"./ar-ma.js": 491,
	"./ar-sa": 492,
	"./ar-sa.js": 492,
	"./ar-tn": 493,
	"./ar-tn.js": 493,
	"./ar.js": 494,
	"./az": 495,
	"./az.js": 495,
	"./be": 496,
	"./be.js": 496,
	"./bg": 497,
	"./bg.js": 497,
	"./bm": 498,
	"./bm.js": 498,
	"./bn": 499,
	"./bn.js": 499,
	"./bo": 500,
	"./bo.js": 500,
	"./br": 501,
	"./br.js": 501,
	"./bs": 502,
	"./bs.js": 502,
	"./ca": 503,
	"./ca.js": 503,
	"./cs": 504,
	"./cs.js": 504,
	"./cv": 505,
	"./cv.js": 505,
	"./cy": 506,
	"./cy.js": 506,
	"./da": 507,
	"./da.js": 507,
	"./de": 510,
	"./de-at": 508,
	"./de-at.js": 508,
	"./de-ch": 509,
	"./de-ch.js": 509,
	"./de.js": 510,
	"./dv": 511,
	"./dv.js": 511,
	"./el": 512,
	"./el.js": 512,
	"./en-SG": 513,
	"./en-SG.js": 513,
	"./en-au": 514,
	"./en-au.js": 514,
	"./en-ca": 515,
	"./en-ca.js": 515,
	"./en-gb": 516,
	"./en-gb.js": 516,
	"./en-ie": 517,
	"./en-ie.js": 517,
	"./en-il": 518,
	"./en-il.js": 518,
	"./en-nz": 519,
	"./en-nz.js": 519,
	"./eo": 520,
	"./eo.js": 520,
	"./es": 523,
	"./es-do": 521,
	"./es-do.js": 521,
	"./es-us": 522,
	"./es-us.js": 522,
	"./es.js": 523,
	"./et": 524,
	"./et.js": 524,
	"./eu": 525,
	"./eu.js": 525,
	"./fa": 526,
	"./fa.js": 526,
	"./fi": 527,
	"./fi.js": 527,
	"./fo": 528,
	"./fo.js": 528,
	"./fr": 531,
	"./fr-ca": 529,
	"./fr-ca.js": 529,
	"./fr-ch": 530,
	"./fr-ch.js": 530,
	"./fr.js": 531,
	"./fy": 532,
	"./fy.js": 532,
	"./ga": 533,
	"./ga.js": 533,
	"./gd": 534,
	"./gd.js": 534,
	"./gl": 535,
	"./gl.js": 535,
	"./gom-latn": 536,
	"./gom-latn.js": 536,
	"./gu": 537,
	"./gu.js": 537,
	"./he": 538,
	"./he.js": 538,
	"./hi": 539,
	"./hi.js": 539,
	"./hr": 540,
	"./hr.js": 540,
	"./hu": 541,
	"./hu.js": 541,
	"./hy-am": 542,
	"./hy-am.js": 542,
	"./id": 543,
	"./id.js": 543,
	"./is": 544,
	"./is.js": 544,
	"./it": 546,
	"./it-ch": 545,
	"./it-ch.js": 545,
	"./it.js": 546,
	"./ja": 547,
	"./ja.js": 547,
	"./jv": 548,
	"./jv.js": 548,
	"./ka": 549,
	"./ka.js": 549,
	"./kk": 550,
	"./kk.js": 550,
	"./km": 551,
	"./km.js": 551,
	"./kn": 552,
	"./kn.js": 552,
	"./ko": 553,
	"./ko.js": 553,
	"./ku": 554,
	"./ku.js": 554,
	"./ky": 555,
	"./ky.js": 555,
	"./lb": 556,
	"./lb.js": 556,
	"./lo": 557,
	"./lo.js": 557,
	"./lt": 558,
	"./lt.js": 558,
	"./lv": 559,
	"./lv.js": 559,
	"./me": 560,
	"./me.js": 560,
	"./mi": 561,
	"./mi.js": 561,
	"./mk": 562,
	"./mk.js": 562,
	"./ml": 563,
	"./ml.js": 563,
	"./mn": 564,
	"./mn.js": 564,
	"./mr": 565,
	"./mr.js": 565,
	"./ms": 567,
	"./ms-my": 566,
	"./ms-my.js": 566,
	"./ms.js": 567,
	"./mt": 568,
	"./mt.js": 568,
	"./my": 569,
	"./my.js": 569,
	"./nb": 570,
	"./nb.js": 570,
	"./ne": 571,
	"./ne.js": 571,
	"./nl": 573,
	"./nl-be": 572,
	"./nl-be.js": 572,
	"./nl.js": 573,
	"./nn": 574,
	"./nn.js": 574,
	"./pa-in": 575,
	"./pa-in.js": 575,
	"./pl": 576,
	"./pl.js": 576,
	"./pt": 578,
	"./pt-br": 577,
	"./pt-br.js": 577,
	"./pt.js": 578,
	"./ro": 579,
	"./ro.js": 579,
	"./ru": 580,
	"./ru.js": 580,
	"./sd": 581,
	"./sd.js": 581,
	"./se": 582,
	"./se.js": 582,
	"./si": 583,
	"./si.js": 583,
	"./sk": 584,
	"./sk.js": 584,
	"./sl": 585,
	"./sl.js": 585,
	"./sq": 586,
	"./sq.js": 586,
	"./sr": 588,
	"./sr-cyrl": 587,
	"./sr-cyrl.js": 587,
	"./sr.js": 588,
	"./ss": 589,
	"./ss.js": 589,
	"./sv": 590,
	"./sv.js": 590,
	"./sw": 591,
	"./sw.js": 591,
	"./ta": 592,
	"./ta.js": 592,
	"./te": 593,
	"./te.js": 593,
	"./tet": 594,
	"./tet.js": 594,
	"./tg": 595,
	"./tg.js": 595,
	"./th": 596,
	"./th.js": 596,
	"./tl-ph": 597,
	"./tl-ph.js": 597,
	"./tlh": 598,
	"./tlh.js": 598,
	"./tr": 599,
	"./tr.js": 599,
	"./tzl": 600,
	"./tzl.js": 600,
	"./tzm": 602,
	"./tzm-latn": 601,
	"./tzm-latn.js": 601,
	"./tzm.js": 602,
	"./ug-cn": 603,
	"./ug-cn.js": 603,
	"./uk": 604,
	"./uk.js": 604,
	"./ur": 605,
	"./ur.js": 605,
	"./uz": 607,
	"./uz-latn": 606,
	"./uz-latn.js": 606,
	"./uz.js": 607,
	"./vi": 608,
	"./vi.js": 608,
	"./x-pseudo": 609,
	"./x-pseudo.js": 609,
	"./yo": 610,
	"./yo.js": 610,
	"./zh-cn": 611,
	"./zh-cn.js": 611,
	"./zh-hk": 612,
	"./zh-hk.js": 612,
	"./zh-tw": 613,
	"./zh-tw.js": 613
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1150;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

!function webpackUniversalModuleDefinition(e,t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var r=t();for(var n in r)("object"==typeof exports?exports:e)[n]=r[n]}}(this,function(){return function(e){var t={};function __webpack_require__(r){if(t[r])return t[r].exports;var n=t[r]={i:r,l:!1,exports:{}};return e[r].call(n.exports,n,n.exports,__webpack_require__),n.l=!0,n.exports}return __webpack_require__.m=e,__webpack_require__.c=t,__webpack_require__.d=function(e,t,r){__webpack_require__.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},__webpack_require__.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},__webpack_require__.t=function(e,t){if(1&t&&(e=__webpack_require__(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(__webpack_require__.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)__webpack_require__.d(r,n,function(t){return e[t]}.bind(null,n));return r},__webpack_require__.n=function(e){var t=e&&e.__esModule?function getDefault(){return e.default}:function getModuleExports(){return e};return __webpack_require__.d(t,"a",t),t},__webpack_require__.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=22)}([function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}();var i={debug:function debug(){},info:function info(){},warn:function warn(){},error:function error(){}},o=void 0,s=void 0;(t.Log=function(){function Log(){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,Log)}return Log.reset=function reset(){s=3,o=i},Log.debug=function debug(){if(s>=4){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];o.debug.apply(o,Array.from(t))}},Log.info=function info(){if(s>=3){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];o.info.apply(o,Array.from(t))}},Log.warn=function warn(){if(s>=2){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];o.warn.apply(o,Array.from(t))}},Log.error=function error(){if(s>=1){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];o.error.apply(o,Array.from(t))}},n(Log,null,[{key:"NONE",get:function get(){return 0}},{key:"ERROR",get:function get(){return 1}},{key:"WARN",get:function get(){return 2}},{key:"INFO",get:function get(){return 3}},{key:"DEBUG",get:function get(){return 4}},{key:"level",get:function get(){return s},set:function set(e){if(!(0<=e&&e<=4))throw new Error("Invalid log level");s=e}},{key:"logger",get:function get(){return o},set:function set(e){if(!e.debug&&e.info&&(e.debug=e.info),!(e.debug&&e.info&&e.warn&&e.error))throw new Error("Invalid logger");o=e}}]),Log}()).reset()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}();var i={setInterval:function(e){function setInterval(t,r){return e.apply(this,arguments)}return setInterval.toString=function(){return e.toString()},setInterval}(function(e,t){return setInterval(e,t)}),clearInterval:function(e){function clearInterval(t){return e.apply(this,arguments)}return clearInterval.toString=function(){return e.toString()},clearInterval}(function(e){return clearInterval(e)})},o=!1,s=null;t.Global=function(){function Global(){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,Global)}return Global._testing=function _testing(){o=!0},Global.setXMLHttpRequest=function setXMLHttpRequest(e){s=e},n(Global,null,[{key:"location",get:function get(){if(!o)return location}},{key:"localStorage",get:function get(){if(!o&&"undefined"!=typeof window)return localStorage}},{key:"sessionStorage",get:function get(){if(!o&&"undefined"!=typeof window)return sessionStorage}},{key:"XMLHttpRequest",get:function get(){if(!o&&"undefined"!=typeof window)return s||XMLHttpRequest}},{key:"timer",get:function get(){if(!o)return i}}]),Global}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.MetadataService=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0),o=r(7);t.MetadataService=function(){function MetadataService(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.JsonService;if(function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,MetadataService),!e)throw i.Log.error("MetadataService: No settings passed to MetadataService"),new Error("settings");this._settings=e,this._jsonService=new t(["application/jwk-set+json"])}return MetadataService.prototype.getMetadata=function getMetadata(){var e=this;return this._settings.metadata?(i.Log.debug("MetadataService.getMetadata: Returning metadata from settings"),Promise.resolve(this._settings.metadata)):this.metadataUrl?(i.Log.debug("MetadataService.getMetadata: getting metadata from",this.metadataUrl),this._jsonService.getJson(this.metadataUrl).then(function(t){return i.Log.debug("MetadataService.getMetadata: json received"),e._settings.metadata=t,t})):(i.Log.error("MetadataService.getMetadata: No authority or metadataUrl configured on settings"),Promise.reject(new Error("No authority or metadataUrl configured on settings")))},MetadataService.prototype.getIssuer=function getIssuer(){return this._getMetadataProperty("issuer")},MetadataService.prototype.getAuthorizationEndpoint=function getAuthorizationEndpoint(){return this._getMetadataProperty("authorization_endpoint")},MetadataService.prototype.getUserInfoEndpoint=function getUserInfoEndpoint(){return this._getMetadataProperty("userinfo_endpoint")},MetadataService.prototype.getTokenEndpoint=function getTokenEndpoint(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];return this._getMetadataProperty("token_endpoint",e)},MetadataService.prototype.getCheckSessionIframe=function getCheckSessionIframe(){return this._getMetadataProperty("check_session_iframe",!0)},MetadataService.prototype.getEndSessionEndpoint=function getEndSessionEndpoint(){return this._getMetadataProperty("end_session_endpoint",!0)},MetadataService.prototype.getRevocationEndpoint=function getRevocationEndpoint(){return this._getMetadataProperty("revocation_endpoint",!0)},MetadataService.prototype.getKeysEndpoint=function getKeysEndpoint(){return this._getMetadataProperty("jwks_uri",!0)},MetadataService.prototype._getMetadataProperty=function _getMetadataProperty(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return i.Log.debug("MetadataService.getMetadataProperty for: "+e),this.getMetadata().then(function(r){if(i.Log.debug("MetadataService.getMetadataProperty: metadata recieved"),void 0===r[e]){if(!0===t)return void i.Log.warn("MetadataService.getMetadataProperty: Metadata does not contain optional property "+e);throw i.Log.error("MetadataService.getMetadataProperty: Metadata does not contain property "+e),new Error("Metadata does not contain property "+e)}return r[e]})},MetadataService.prototype.getSigningKeys=function getSigningKeys(){var e=this;return this._settings.signingKeys?(i.Log.debug("MetadataService.getSigningKeys: Returning signingKeys from settings"),Promise.resolve(this._settings.signingKeys)):this._getMetadataProperty("jwks_uri").then(function(t){return i.Log.debug("MetadataService.getSigningKeys: jwks_uri received",t),e._jsonService.getJson(t).then(function(t){if(i.Log.debug("MetadataService.getSigningKeys: key set received",t),!t.keys)throw i.Log.error("MetadataService.getSigningKeys: Missing keys on keyset"),new Error("Missing keys on keyset");return e._settings.signingKeys=t.keys,e._settings.signingKeys})})},n(MetadataService,[{key:"metadataUrl",get:function get(){return this._metadataUrl||(this._settings.metadataUrl?this._metadataUrl=this._settings.metadataUrl:(this._metadataUrl=this._settings.authority,this._metadataUrl&&this._metadataUrl.indexOf(".well-known/openid-configuration")<0&&("/"!==this._metadataUrl[this._metadataUrl.length-1]&&(this._metadataUrl+="/"),this._metadataUrl+=".well-known/openid-configuration"))),this._metadataUrl}}]),MetadataService}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.UrlUtility=void 0;var n=r(0),i=r(1);t.UrlUtility=function(){function UrlUtility(){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,UrlUtility)}return UrlUtility.addQueryParam=function addQueryParam(e,t,r){return e.indexOf("?")<0&&(e+="?"),"?"!==e[e.length-1]&&(e+="&"),e+=encodeURIComponent(t),e+="=",e+=encodeURIComponent(r)},UrlUtility.parseUrlFragment=function parseUrlFragment(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"#",r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.Global;"string"!=typeof e&&(e=r.location.href);var o=e.lastIndexOf(t);o>=0&&(e=e.substr(o+1)),"?"===t&&(o=e.indexOf("#"))>=0&&(e=e.substr(0,o));for(var s,a={},u=/([^&=]+)=([^&]*)/g,c=0;s=u.exec(e);)if(a[decodeURIComponent(s[1])]=decodeURIComponent(s[2]),c++>50)return n.Log.error("UrlUtility.parseUrlFragment: response exceeded expected number of parameters",e),{error:"Response exceeded expected number of parameters"};for(var h in a)return a;return{}},UrlUtility}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.JoseUtil=void 0;var n=r(25),i=function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}(r(32));t.JoseUtil=(0,i.default)({jws:n.jws,KeyUtil:n.KeyUtil,X509:n.X509,crypto:n.crypto,hextob64u:n.hextob64u,b64tohex:n.b64tohex,AllowedSigningAlgs:n.AllowedSigningAlgs})},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.OidcClientSettings=void 0;var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),o=r(0),s=r(6),a=r(23),u=r(2);var c="id_token",h="openid",l=900,f=300;t.OidcClientSettings=function(){function OidcClientSettings(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.authority,r=e.metadataUrl,i=e.metadata,o=e.signingKeys,g=e.client_id,p=e.client_secret,d=e.response_type,v=void 0===d?c:d,y=e.scope,m=void 0===y?h:y,_=e.redirect_uri,S=e.post_logout_redirect_uri,b=e.prompt,F=e.display,w=e.max_age,E=e.ui_locales,x=e.acr_values,C=e.resource,k=e.response_mode,A=e.filterProtocolClaims,P=void 0===A||A,I=e.loadUserInfo,B=void 0===I||I,R=e.staleStateAge,T=void 0===R?l:R,U=e.clockSkew,D=void 0===U?f:U,M=e.userInfoJwtIssuer,L=void 0===M?"OP":M,N=e.stateStore,O=void 0===N?new s.WebStorageStateStore:N,H=e.ResponseValidatorCtor,j=void 0===H?a.ResponseValidator:H,K=e.MetadataServiceCtor,V=void 0===K?u.MetadataService:K,q=e.extraQueryParams,W=void 0===q?{}:q;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,OidcClientSettings),this._authority=t,this._metadataUrl=r,this._metadata=i,this._signingKeys=o,this._client_id=g,this._client_secret=p,this._response_type=v,this._scope=m,this._redirect_uri=_,this._post_logout_redirect_uri=S,this._prompt=b,this._display=F,this._max_age=w,this._ui_locales=E,this._acr_values=x,this._resource=C,this._response_mode=k,this._filterProtocolClaims=!!P,this._loadUserInfo=!!B,this._staleStateAge=T,this._clockSkew=D,this._userInfoJwtIssuer=L,this._stateStore=O,this._validator=new j(this),this._metadataService=new V(this),this._extraQueryParams="object"===(void 0===W?"undefined":n(W))?W:{}}return i(OidcClientSettings,[{key:"client_id",get:function get(){return this._client_id},set:function set(e){if(this._client_id)throw o.Log.error("OidcClientSettings.set_client_id: client_id has already been assigned."),new Error("client_id has already been assigned.");this._client_id=e}},{key:"client_secret",get:function get(){return this._client_secret}},{key:"response_type",get:function get(){return this._response_type}},{key:"scope",get:function get(){return this._scope}},{key:"redirect_uri",get:function get(){return this._redirect_uri}},{key:"post_logout_redirect_uri",get:function get(){return this._post_logout_redirect_uri}},{key:"prompt",get:function get(){return this._prompt}},{key:"display",get:function get(){return this._display}},{key:"max_age",get:function get(){return this._max_age}},{key:"ui_locales",get:function get(){return this._ui_locales}},{key:"acr_values",get:function get(){return this._acr_values}},{key:"resource",get:function get(){return this._resource}},{key:"response_mode",get:function get(){return this._response_mode}},{key:"authority",get:function get(){return this._authority},set:function set(e){if(this._authority)throw o.Log.error("OidcClientSettings.set_authority: authority has already been assigned."),new Error("authority has already been assigned.");this._authority=e}},{key:"metadataUrl",get:function get(){return this._metadataUrl||(this._metadataUrl=this.authority,this._metadataUrl&&this._metadataUrl.indexOf(".well-known/openid-configuration")<0&&("/"!==this._metadataUrl[this._metadataUrl.length-1]&&(this._metadataUrl+="/"),this._metadataUrl+=".well-known/openid-configuration")),this._metadataUrl}},{key:"metadata",get:function get(){return this._metadata},set:function set(e){this._metadata=e}},{key:"signingKeys",get:function get(){return this._signingKeys},set:function set(e){this._signingKeys=e}},{key:"filterProtocolClaims",get:function get(){return this._filterProtocolClaims}},{key:"loadUserInfo",get:function get(){return this._loadUserInfo}},{key:"staleStateAge",get:function get(){return this._staleStateAge}},{key:"clockSkew",get:function get(){return this._clockSkew}},{key:"userInfoJwtIssuer",get:function get(){return this._userInfoJwtIssuer}},{key:"stateStore",get:function get(){return this._stateStore}},{key:"validator",get:function get(){return this._validator}},{key:"metadataService",get:function get(){return this._metadataService}},{key:"extraQueryParams",get:function get(){return this._extraQueryParams},set:function set(e){"object"===(void 0===e?"undefined":n(e))?this._extraQueryParams=e:this._extraQueryParams={}}}]),OidcClientSettings}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.WebStorageStateStore=void 0;var n=r(0),i=r(1);t.WebStorageStateStore=function(){function WebStorageStateStore(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.prefix,r=void 0===t?"oidc.":t,n=e.store,o=void 0===n?i.Global.localStorage:n;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,WebStorageStateStore),this._store=o,this._prefix=r}return WebStorageStateStore.prototype.set=function set(e,t){return n.Log.debug("WebStorageStateStore.set",e),e=this._prefix+e,this._store.setItem(e,t),Promise.resolve()},WebStorageStateStore.prototype.get=function get(e){n.Log.debug("WebStorageStateStore.get",e),e=this._prefix+e;var t=this._store.getItem(e);return Promise.resolve(t)},WebStorageStateStore.prototype.remove=function remove(e){n.Log.debug("WebStorageStateStore.remove",e),e=this._prefix+e;var t=this._store.getItem(e);return this._store.removeItem(e),Promise.resolve(t)},WebStorageStateStore.prototype.getAllKeys=function getAllKeys(){n.Log.debug("WebStorageStateStore.getAllKeys");for(var e=[],t=0;t<this._store.length;t++){var r=this._store.key(t);0===r.indexOf(this._prefix)&&e.push(r.substr(this._prefix.length))}return Promise.resolve(e)},WebStorageStateStore}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.JsonService=void 0;var n=r(0),i=r(1);t.JsonService=function(){function JsonService(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i.Global.XMLHttpRequest,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,JsonService),e&&Array.isArray(e)?this._contentTypes=e.slice():this._contentTypes=[],this._contentTypes.push("application/json"),r&&this._contentTypes.push("application/jwt"),this._XMLHttpRequest=t,this._jwtHandler=r}return JsonService.prototype.getJson=function getJson(e,t){var r=this;if(!e)throw n.Log.error("JsonService.getJson: No url passed"),new Error("url");return n.Log.debug("JsonService.getJson, url: ",e),new Promise(function(i,o){var s=new r._XMLHttpRequest;s.open("GET",e);var a=r._contentTypes,u=r._jwtHandler;s.onload=function(){if(n.Log.debug("JsonService.getJson: HTTP response received, status",s.status),200===s.status){var t=s.getResponseHeader("Content-Type");if(t){var r=a.find(function(e){if(t.startsWith(e))return!0});if("application/jwt"==r)return void u(s).then(i,o);if(r)try{return void i(JSON.parse(s.responseText))}catch(e){return n.Log.error("JsonService.getJson: Error parsing JSON response",e.message),void o(e)}}o(Error("Invalid response Content-Type: "+t+", from URL: "+e))}else o(Error(s.statusText+" ("+s.status+")"))},s.onerror=function(){n.Log.error("JsonService.getJson: network error"),o(Error("Network Error"))},t&&(n.Log.debug("JsonService.getJson: token passed, setting Authorization header"),s.setRequestHeader("Authorization","Bearer "+t)),s.send()})},JsonService.prototype.postForm=function postForm(e,t){var r=this;if(!e)throw n.Log.error("JsonService.postForm: No url passed"),new Error("url");return n.Log.debug("JsonService.postForm, url: ",e),new Promise(function(i,o){var s=new r._XMLHttpRequest;s.open("POST",e);var a=r._contentTypes;s.onload=function(){if(n.Log.debug("JsonService.postForm: HTTP response received, status",s.status),200!==s.status){if(400===s.status)if(r=s.getResponseHeader("Content-Type"))if(a.find(function(e){if(r.startsWith(e))return!0}))try{var t=JSON.parse(s.responseText);if(t&&t.error)return n.Log.error("JsonService.postForm: Error from server: ",t.error),void o(new Error(t.error))}catch(e){return n.Log.error("JsonService.postForm: Error parsing JSON response",e.message),void o(e)}o(Error(s.statusText+" ("+s.status+")"))}else{var r;if((r=s.getResponseHeader("Content-Type"))&&a.find(function(e){if(r.startsWith(e))return!0}))try{return void i(JSON.parse(s.responseText))}catch(e){return n.Log.error("JsonService.postForm: Error parsing JSON response",e.message),void o(e)}o(Error("Invalid response Content-Type: "+r+", from URL: "+e))}},s.onerror=function(){n.Log.error("JsonService.postForm: network error"),o(Error("Network Error"))};var u="";for(var c in t){var h=t[c];h&&(u.length>0&&(u+="&"),u+=encodeURIComponent(c),u+="=",u+=encodeURIComponent(h))}s.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),s.send(u)})},JsonService}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.State=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0),o=function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}(r(14));t.State=function(){function State(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.id,r=e.data,n=e.created;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,State),this._id=t||(0,o.default)(),this._data=r,this._created="number"==typeof n&&n>0?n:parseInt(Date.now()/1e3)}return State.prototype.toStorageString=function toStorageString(){return i.Log.debug("State.toStorageString"),JSON.stringify({id:this.id,data:this.data,created:this.created})},State.fromStorageString=function fromStorageString(e){return i.Log.debug("State.fromStorageString"),new State(JSON.parse(e))},State.clearStaleState=function clearStaleState(e,t){var r=Date.now()/1e3-t;return e.getAllKeys().then(function(t){i.Log.debug("State.clearStaleState: got keys",t);for(var n=[],o=function _loop(o){var s=t[o];a=e.get(s).then(function(t){var n=!1;if(t)try{var o=State.fromStorageString(t);i.Log.debug("State.clearStaleState: got item from key: ",s,o.created),o.created<=r&&(n=!0)}catch(e){i.Log.error("State.clearStaleState: Error parsing state for key",s,e.message),n=!0}else i.Log.debug("State.clearStaleState: no item in storage for key: ",s),n=!0;if(n)return i.Log.debug("State.clearStaleState: removed item for key: ",s),e.remove(s)}),n.push(a)},s=0;s<t.length;s++){var a;o(s)}return i.Log.debug("State.clearStaleState: waiting on promise count:",n.length),Promise.all(n)})},n(State,[{key:"id",get:function get(){return this._id}},{key:"data",get:function get(){return this._data}},{key:"created",get:function get(){return this._created}}]),State}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.OidcClient=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0),o=r(5),s=r(11),a=r(12),u=r(36),c=r(37),h=r(38),l=r(13),f=r(8);t.OidcClient=function(){function OidcClient(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,OidcClient),e instanceof o.OidcClientSettings?this._settings=e:this._settings=new o.OidcClientSettings(e)}return OidcClient.prototype.createSigninRequest=function createSigninRequest(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.response_type,n=t.scope,o=t.redirect_uri,s=t.data,u=t.state,c=t.prompt,h=t.display,l=t.max_age,f=t.ui_locales,g=t.id_token_hint,p=t.login_hint,d=t.acr_values,v=t.resource,y=t.request,m=t.request_uri,_=t.response_mode,S=t.extraQueryParams,b=arguments[1];i.Log.debug("OidcClient.createSigninRequest");var F=this._settings.client_id;r=r||this._settings.response_type,n=n||this._settings.scope,o=o||this._settings.redirect_uri,c=c||this._settings.prompt,h=h||this._settings.display,l=l||this._settings.max_age,f=f||this._settings.ui_locales,d=d||this._settings.acr_values,v=v||this._settings.resource,_=_||this._settings.response_mode,S=S||this._settings.extraQueryParams;var w=this._settings.authority;return a.SigninRequest.isCode(r)&&"code"!==r?Promise.reject(new Error("OpenID Connect hybrid flow is not supported")):this._metadataService.getAuthorizationEndpoint().then(function(t){i.Log.debug("OidcClient.createSigninRequest: Received authorization endpoint",t);var E=new a.SigninRequest({url:t,client_id:F,redirect_uri:o,response_type:r,scope:n,data:s||u,authority:w,prompt:c,display:h,max_age:l,ui_locales:f,id_token_hint:g,login_hint:p,acr_values:d,resource:v,request:y,request_uri:m,extraQueryParams:S,response_mode:_}),x=E.state;return(b=b||e._stateStore).set(x.id,x.toStorageString()).then(function(){return E})})},OidcClient.prototype.processSigninResponse=function processSigninResponse(e,t){var r=this;i.Log.debug("OidcClient.processSigninResponse");var n="query"===this._settings.response_mode||!this._settings.response_mode&&a.SigninRequest.isCode(this._settings.response_type)?"?":"#",o=new u.SigninResponse(e,n);return o.state?(t=t||this._stateStore).remove(o.state).then(function(e){if(!e)throw i.Log.error("OidcClient.processSigninResponse: No matching state found in storage"),new Error("No matching state found in storage");var t=l.SigninState.fromStorageString(e);return i.Log.debug("OidcClient.processSigninResponse: Received state from storage; validating response"),r._validator.validateSigninResponse(t,o)}):(i.Log.error("OidcClient.processSigninResponse: No state in response"),Promise.reject(new Error("No state in response")))},OidcClient.prototype.createSignoutRequest=function createSignoutRequest(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.id_token_hint,n=t.data,o=t.state,s=t.post_logout_redirect_uri,a=t.extraQueryParams,u=arguments[1];return i.Log.debug("OidcClient.createSignoutRequest"),s=s||this._settings.post_logout_redirect_uri,a=a||this._settings.extraQueryParams,this._metadataService.getEndSessionEndpoint().then(function(t){if(!t)throw i.Log.error("OidcClient.createSignoutRequest: No end session endpoint url returned"),new Error("no end session endpoint");i.Log.debug("OidcClient.createSignoutRequest: Received end session endpoint",t);var h=new c.SignoutRequest({url:t,id_token_hint:r,post_logout_redirect_uri:s,data:n||o,extraQueryParams:a}),l=h.state;return l&&(i.Log.debug("OidcClient.createSignoutRequest: Signout request has state to persist"),(u=u||e._stateStore).set(l.id,l.toStorageString())),h})},OidcClient.prototype.processSignoutResponse=function processSignoutResponse(e,t){var r=this;i.Log.debug("OidcClient.processSignoutResponse");var n=new h.SignoutResponse(e);if(!n.state)return i.Log.debug("OidcClient.processSignoutResponse: No state in response"),n.error?(i.Log.warn("OidcClient.processSignoutResponse: Response was error: ",n.error),Promise.reject(new s.ErrorResponse(n))):Promise.resolve(n);var o=n.state;return(t=t||this._stateStore).remove(o).then(function(e){if(!e)throw i.Log.error("OidcClient.processSignoutResponse: No matching state found in storage"),new Error("No matching state found in storage");var t=f.State.fromStorageString(e);return i.Log.debug("OidcClient.processSignoutResponse: Received state from storage; validating response"),r._validator.validateSignoutResponse(t,n)})},OidcClient.prototype.clearStaleState=function clearStaleState(e){return i.Log.debug("OidcClient.clearStaleState"),e=e||this._stateStore,f.State.clearStaleState(e,this.settings.staleStateAge)},n(OidcClient,[{key:"_stateStore",get:function get(){return this.settings.stateStore}},{key:"_validator",get:function get(){return this.settings.validator}},{key:"_metadataService",get:function get(){return this.settings.metadataService}},{key:"settings",get:function get(){return this._settings}},{key:"metadataService",get:function get(){return this._metadataService}}]),OidcClient}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.TokenClient=void 0;var n=r(7),i=r(2),o=r(0);t.TokenClient=function(){function TokenClient(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:n.JsonService,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.MetadataService;if(function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,TokenClient),!e)throw o.Log.error("TokenClient.ctor: No settings passed"),new Error("settings");this._settings=e,this._jsonService=new t,this._metadataService=new r(this._settings)}return TokenClient.prototype.exchangeCode=function exchangeCode(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return t.grant_type=t.grant_type||"authorization_code",t.client_id=t.client_id||this._settings.client_id,t.redirect_uri=t.redirect_uri||this._settings.redirect_uri,t.code?t.redirect_uri?t.code_verifier?t.client_id?this._metadataService.getTokenEndpoint(!1).then(function(r){return o.Log.debug("TokenClient.exchangeCode: Received token endpoint"),e._jsonService.postForm(r,t).then(function(e){return o.Log.debug("TokenClient.exchangeCode: response received"),e})}):(o.Log.error("TokenClient.exchangeCode: No client_id passed"),Promise.reject(new Error("A client_id is required"))):(o.Log.error("TokenClient.exchangeCode: No code_verifier passed"),Promise.reject(new Error("A code_verifier is required"))):(o.Log.error("TokenClient.exchangeCode: No redirect_uri passed"),Promise.reject(new Error("A redirect_uri is required"))):(o.Log.error("TokenClient.exchangeCode: No code passed"),Promise.reject(new Error("A code is required")))},TokenClient.prototype.exchangeRefreshToken=function exchangeRefreshToken(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return t.grant_type=t.grant_type||"refresh_token",t.client_id=t.client_id||this._settings.client_id,t.refresh_token?t.client_id?this._metadataService.getTokenEndpoint(!1).then(function(r){return o.Log.debug("TokenClient.exchangeRefreshToken: Received token endpoint"),e._jsonService.postForm(r,t).then(function(e){return o.Log.debug("TokenClient.exchangeRefreshToken: response received"),e})}):(o.Log.error("TokenClient.exchangeRefreshToken: No client_id passed"),Promise.reject(new Error("A client_id is required"))):(o.Log.error("TokenClient.exchangeRefreshToken: No refresh_token passed"),Promise.reject(new Error("A refresh_token is required")))},TokenClient}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.ErrorResponse=void 0;var n=r(0);t.ErrorResponse=function(e){function ErrorResponse(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.error,i=t.error_description,o=t.error_uri,s=t.state;if(function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,ErrorResponse),!r)throw n.Log.error("No error passed to ErrorResponse"),new Error("error");var a=function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,e.call(this,i||r));return a.name="ErrorResponse",a.error=r,a.error_description=i,a.error_uri=o,a.state=s,a}return function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(ErrorResponse,e),ErrorResponse}(Error)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.SigninRequest=void 0;var n=r(0),i=r(3),o=r(13);t.SigninRequest=function(){function SigninRequest(e){var t=e.url,r=e.client_id,s=e.redirect_uri,a=e.response_type,u=e.scope,c=e.authority,h=e.data,l=e.prompt,f=e.display,g=e.max_age,p=e.ui_locales,d=e.id_token_hint,v=e.login_hint,y=e.acr_values,m=e.resource,_=e.response_mode,S=e.request,b=e.request_uri,F=e.extraQueryParams;if(function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,SigninRequest),!t)throw n.Log.error("SigninRequest.ctor: No url passed"),new Error("url");if(!r)throw n.Log.error("SigninRequest.ctor: No client_id passed"),new Error("client_id");if(!s)throw n.Log.error("SigninRequest.ctor: No redirect_uri passed"),new Error("redirect_uri");if(!a)throw n.Log.error("SigninRequest.ctor: No response_type passed"),new Error("response_type");if(!u)throw n.Log.error("SigninRequest.ctor: No scope passed"),new Error("scope");if(!c)throw n.Log.error("SigninRequest.ctor: No authority passed"),new Error("authority");var w=SigninRequest.isOidc(a),E=SigninRequest.isCode(a);this.state=new o.SigninState({nonce:w,data:h,client_id:r,authority:c,redirect_uri:s,code_verifier:E}),t=i.UrlUtility.addQueryParam(t,"client_id",r),t=i.UrlUtility.addQueryParam(t,"redirect_uri",s),t=i.UrlUtility.addQueryParam(t,"response_type",a),t=i.UrlUtility.addQueryParam(t,"scope",u),t=i.UrlUtility.addQueryParam(t,"state",this.state.id),w&&(t=i.UrlUtility.addQueryParam(t,"nonce",this.state.nonce)),E&&(t=i.UrlUtility.addQueryParam(t,"code_challenge",this.state.code_challenge),t=i.UrlUtility.addQueryParam(t,"code_challenge_method","S256"));var x={prompt:l,display:f,max_age:g,ui_locales:p,id_token_hint:d,login_hint:v,acr_values:y,resource:m,request:S,request_uri:b,response_mode:_};for(var C in x)x[C]&&(t=i.UrlUtility.addQueryParam(t,C,x[C]));for(var k in F)t=i.UrlUtility.addQueryParam(t,k,F[k]);this.url=t}return SigninRequest.isOidc=function isOidc(e){return!!e.split(/\s+/g).filter(function(e){return"id_token"===e})[0]},SigninRequest.isOAuth=function isOAuth(e){return!!e.split(/\s+/g).filter(function(e){return"token"===e})[0]},SigninRequest.isCode=function isCode(e){return!!e.split(/\s+/g).filter(function(e){return"code"===e})[0]},SigninRequest}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.SigninState=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0),o=r(8),s=r(4),a=function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}(r(14));t.SigninState=function(e){function SigninState(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.nonce,n=t.authority,i=t.client_id,o=t.redirect_uri,u=t.code_verifier;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,SigninState);var c=function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,e.call(this,arguments[0]));if(!0===r?c._nonce=(0,a.default)():r&&(c._nonce=r),!0===u?c._code_verifier=(0,a.default)()+(0,a.default)()+(0,a.default)():u&&(c._code_verifier=u),c.code_verifier){var h=s.JoseUtil.hashString(c.code_verifier,"SHA256");c._code_challenge=s.JoseUtil.hexToBase64Url(h)}return c._redirect_uri=o,c._authority=n,c._client_id=i,c}return function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(SigninState,e),SigninState.prototype.toStorageString=function toStorageString(){return i.Log.debug("SigninState.toStorageString"),JSON.stringify({id:this.id,data:this.data,created:this.created,nonce:this.nonce,code_verifier:this.code_verifier,redirect_uri:this.redirect_uri,authority:this.authority,client_id:this.client_id})},SigninState.fromStorageString=function fromStorageString(e){return i.Log.debug("SigninState.fromStorageString"),new SigninState(JSON.parse(e))},n(SigninState,[{key:"nonce",get:function get(){return this._nonce}},{key:"authority",get:function get(){return this._authority}},{key:"client_id",get:function get(){return this._client_id}},{key:"redirect_uri",get:function get(){return this._redirect_uri}},{key:"code_verifier",get:function get(){return this._code_verifier}},{key:"code_challenge",get:function get(){return this._code_challenge}}]),SigninState}(o.State)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function random(){return(0,n.default)().replace(/-/g,"")};var n=function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}(r(33));e.exports=t.default},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.User=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0);t.User=function(){function User(e){var t=e.id_token,r=e.session_state,n=e.access_token,i=e.refresh_token,o=e.token_type,s=e.scope,a=e.profile,u=e.expires_at,c=e.state;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,User),this.id_token=t,this.session_state=r,this.access_token=n,this.refresh_token=i,this.token_type=o,this.scope=s,this.profile=a,this.expires_at=u,this.state=c}return User.prototype.toStorageString=function toStorageString(){return i.Log.debug("User.toStorageString"),JSON.stringify({id_token:this.id_token,session_state:this.session_state,access_token:this.access_token,refresh_token:this.refresh_token,token_type:this.token_type,scope:this.scope,profile:this.profile,expires_at:this.expires_at})},User.fromStorageString=function fromStorageString(e){return i.Log.debug("User.fromStorageString"),new User(JSON.parse(e))},n(User,[{key:"expires_in",get:function get(){if(this.expires_at){var e=parseInt(Date.now()/1e3);return this.expires_at-e}},set:function set(e){var t=parseInt(e);if("number"==typeof t&&t>0){var r=parseInt(Date.now()/1e3);this.expires_at=r+t}}},{key:"expired",get:function get(){var e=this.expires_in;if(void 0!==e)return e<=0}},{key:"scopes",get:function get(){return(this.scope||"").split(" ")}}]),User}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.AccessTokenEvents=void 0;var n=r(0),i=r(48);var o=60;t.AccessTokenEvents=function(){function AccessTokenEvents(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.accessTokenExpiringNotificationTime,r=void 0===t?o:t,n=e.accessTokenExpiringTimer,s=void 0===n?new i.Timer("Access token expiring"):n,a=e.accessTokenExpiredTimer,u=void 0===a?new i.Timer("Access token expired"):a;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,AccessTokenEvents),this._accessTokenExpiringNotificationTime=r,this._accessTokenExpiring=s,this._accessTokenExpired=u}return AccessTokenEvents.prototype.load=function load(e){if(e.access_token&&void 0!==e.expires_in){var t=e.expires_in;if(n.Log.debug("AccessTokenEvents.load: access token present, remaining duration:",t),t>0){var r=t-this._accessTokenExpiringNotificationTime;r<=0&&(r=1),n.Log.debug("AccessTokenEvents.load: registering expiring timer in:",r),this._accessTokenExpiring.init(r)}else n.Log.debug("AccessTokenEvents.load: canceling existing expiring timer becase we're past expiration."),this._accessTokenExpiring.cancel();var i=t+1;n.Log.debug("AccessTokenEvents.load: registering expired timer in:",i),this._accessTokenExpired.init(i)}else this._accessTokenExpiring.cancel(),this._accessTokenExpired.cancel()},AccessTokenEvents.prototype.unload=function unload(){n.Log.debug("AccessTokenEvents.unload: canceling existing access token timers"),this._accessTokenExpiring.cancel(),this._accessTokenExpired.cancel()},AccessTokenEvents.prototype.addAccessTokenExpiring=function addAccessTokenExpiring(e){this._accessTokenExpiring.addHandler(e)},AccessTokenEvents.prototype.removeAccessTokenExpiring=function removeAccessTokenExpiring(e){this._accessTokenExpiring.removeHandler(e)},AccessTokenEvents.prototype.addAccessTokenExpired=function addAccessTokenExpired(e){this._accessTokenExpired.addHandler(e)},AccessTokenEvents.prototype.removeAccessTokenExpired=function removeAccessTokenExpired(e){this._accessTokenExpired.removeHandler(e)},AccessTokenEvents}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.Event=void 0;var n=r(0);t.Event=function(){function Event(e){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,Event),this._name=e,this._callbacks=[]}return Event.prototype.addHandler=function addHandler(e){this._callbacks.push(e)},Event.prototype.removeHandler=function removeHandler(e){var t=this._callbacks.findIndex(function(t){return t===e});t>=0&&this._callbacks.splice(t,1)},Event.prototype.raise=function raise(){n.Log.debug("Event: Raising event: "+this._name);for(var e=0;e<this._callbacks.length;e++){var t;(t=this._callbacks)[e].apply(t,arguments)}},Event}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.SessionMonitor=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0),o=r(19);t.SessionMonitor=function(){function SessionMonitor(e){var t=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.CheckSessionIFrame;if(function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,SessionMonitor),!e)throw i.Log.error("SessionMonitor.ctor: No user manager passed to SessionMonitor"),new Error("userManager");this._userManager=e,this._CheckSessionIFrameCtor=r,this._userManager.events.addUserLoaded(this._start.bind(this)),this._userManager.events.addUserUnloaded(this._stop.bind(this)),this._userManager.getUser().then(function(e){e&&t._start(e)}).catch(function(e){i.Log.error("SessionMonitor ctor: error from getUser:",e.message)})}return SessionMonitor.prototype._start=function _start(e){var t=this,r=e.session_state;r&&(this._sub=e.profile.sub,this._sid=e.profile.sid,i.Log.debug("SessionMonitor._start: session_state:",r,", sub:",this._sub),this._checkSessionIFrame?this._checkSessionIFrame.start(r):this._metadataService.getCheckSessionIframe().then(function(e){if(e){i.Log.debug("SessionMonitor._start: Initializing check session iframe");var n=t._client_id,o=t._checkSessionInterval,s=t._stopCheckSessionOnError;t._checkSessionIFrame=new t._CheckSessionIFrameCtor(t._callback.bind(t),n,e,o,s),t._checkSessionIFrame.load().then(function(){t._checkSessionIFrame.start(r)})}else i.Log.warn("SessionMonitor._start: No check session iframe found in the metadata")}).catch(function(e){i.Log.error("SessionMonitor._start: Error from getCheckSessionIframe:",e.message)}))},SessionMonitor.prototype._stop=function _stop(){this._sub=null,this._sid=null,this._checkSessionIFrame&&(i.Log.debug("SessionMonitor._stop"),this._checkSessionIFrame.stop())},SessionMonitor.prototype._callback=function _callback(){var e=this;this._userManager.querySessionStatus().then(function(t){var r=!0;t?t.sub===e._sub?(r=!1,e._checkSessionIFrame.start(t.session_state),t.sid===e._sid?i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:",t.session_state):(i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:",t.session_state),e._userManager.events._raiseUserSessionChanged())):i.Log.debug("SessionMonitor._callback: Different subject signed into OP:",t.sub):i.Log.debug("SessionMonitor._callback: Subject no longer signed into OP"),r&&(i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed out event"),e._userManager.events._raiseUserSignedOut())}).catch(function(t){i.Log.debug("SessionMonitor._callback: Error calling queryCurrentSigninSession; raising signed out event",t.message),e._userManager.events._raiseUserSignedOut()})},n(SessionMonitor,[{key:"_settings",get:function get(){return this._userManager.settings}},{key:"_metadataService",get:function get(){return this._userManager.metadataService}},{key:"_client_id",get:function get(){return this._settings.client_id}},{key:"_checkSessionInterval",get:function get(){return this._settings.checkSessionInterval}},{key:"_stopCheckSessionOnError",get:function get(){return this._settings.stopCheckSessionOnError}}]),SessionMonitor}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.CheckSessionIFrame=void 0;var n=r(0);var i=2e3;t.CheckSessionIFrame=function(){function CheckSessionIFrame(e,t,r,n){var o=!(arguments.length>4&&void 0!==arguments[4])||arguments[4];!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,CheckSessionIFrame),this._callback=e,this._client_id=t,this._url=r,this._interval=n||i,this._stopOnError=o;var s=r.indexOf("/",r.indexOf("//")+2);this._frame_origin=r.substr(0,s),this._frame=window.document.createElement("iframe"),this._frame.style.visibility="hidden",this._frame.style.position="absolute",this._frame.style.display="none",this._frame.style.width=0,this._frame.style.height=0,this._frame.src=r}return CheckSessionIFrame.prototype.load=function load(){var e=this;return new Promise(function(t){e._frame.onload=function(){t()},window.document.body.appendChild(e._frame),e._boundMessageEvent=e._message.bind(e),window.addEventListener("message",e._boundMessageEvent,!1)})},CheckSessionIFrame.prototype._message=function _message(e){e.origin===this._frame_origin&&e.source===this._frame.contentWindow&&("error"===e.data?(n.Log.error("CheckSessionIFrame: error message from check session op iframe"),this._stopOnError&&this.stop()):"changed"===e.data?(n.Log.debug("CheckSessionIFrame: changed message from check session op iframe"),this.stop(),this._callback()):n.Log.debug("CheckSessionIFrame: "+e.data+" message from check session op iframe"))},CheckSessionIFrame.prototype.start=function start(e){var t=this;if(this._session_state!==e){n.Log.debug("CheckSessionIFrame.start"),this.stop(),this._session_state=e;var r=function send(){t._frame.contentWindow.postMessage(t._client_id+" "+t._session_state,t._frame_origin)};r(),this._timer=window.setInterval(r,this._interval)}},CheckSessionIFrame.prototype.stop=function stop(){this._session_state=null,this._timer&&(n.Log.debug("CheckSessionIFrame.stop"),window.clearInterval(this._timer),this._timer=null)},CheckSessionIFrame}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.TokenRevocationClient=void 0;var n=r(0),i=r(2),o=r(1);t.TokenRevocationClient=function(){function TokenRevocationClient(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.Global.XMLHttpRequest,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.MetadataService;if(function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,TokenRevocationClient),!e)throw n.Log.error("TokenRevocationClient.ctor: No settings provided"),new Error("No settings provided.");this._settings=e,this._XMLHttpRequestCtor=t,this._metadataService=new r(this._settings)}return TokenRevocationClient.prototype.revoke=function revoke(e,t){var r=this,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"access_token";if(!e)throw n.Log.error("TokenRevocationClient.revoke: No token provided"),new Error("No token provided.");if("access_token"!==i&&"refresh_token"!=i)throw n.Log.error("TokenRevocationClient.revoke: Invalid token type"),new Error("Invalid token type.");return this._metadataService.getRevocationEndpoint().then(function(o){if(o){n.Log.debug("TokenRevocationClient.revoke: Revoking "+i);var s=r._settings.client_id,a=r._settings.client_secret;return r._revoke(o,s,a,e,i)}if(t)throw n.Log.error("TokenRevocationClient.revoke: Revocation not supported"),new Error("Revocation not supported")})},TokenRevocationClient.prototype._revoke=function _revoke(e,t,r,i,o){var s=this;return new Promise(function(a,u){var c=new s._XMLHttpRequestCtor;c.open("POST",e),c.onload=function(){n.Log.debug("TokenRevocationClient.revoke: HTTP response received, status",c.status),200===c.status?a():u(Error(c.statusText+" ("+c.status+")"))},c.onerror=function(){n.Log.debug("TokenRevocationClient.revoke: Network Error."),u("Network Error")};var h="client_id="+encodeURIComponent(t);r&&(h+="&client_secret="+encodeURIComponent(r)),h+="&token_type_hint="+encodeURIComponent(o),h+="&token="+encodeURIComponent(i),c.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),c.send(h)})},TokenRevocationClient}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.CordovaPopupWindow=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0);var o="location=no,toolbar=no,zoom=no",s="_blank";t.CordovaPopupWindow=function(){function CordovaPopupWindow(e){var t=this;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,CordovaPopupWindow),this._promise=new Promise(function(e,r){t._resolve=e,t._reject=r}),this.features=e.popupWindowFeatures||o,this.target=e.popupWindowTarget||s,this.redirect_uri=e.startUrl,i.Log.debug("CordovaPopupWindow.ctor: redirect_uri: "+this.redirect_uri)}return CordovaPopupWindow.prototype._isInAppBrowserInstalled=function _isInAppBrowserInstalled(e){return["cordova-plugin-inappbrowser","cordova-plugin-inappbrowser.inappbrowser","org.apache.cordova.inappbrowser"].some(function(t){return e.hasOwnProperty(t)})},CordovaPopupWindow.prototype.navigate=function navigate(e){if(e&&e.url){if(!window.cordova)return this._error("cordova is undefined");var t=window.cordova.require("cordova/plugin_list").metadata;if(!1===this._isInAppBrowserInstalled(t))return this._error("InAppBrowser plugin not found");this._popup=cordova.InAppBrowser.open(e.url,this.target,this.features),this._popup?(i.Log.debug("CordovaPopupWindow.navigate: popup successfully created"),this._exitCallbackEvent=this._exitCallback.bind(this),this._loadStartCallbackEvent=this._loadStartCallback.bind(this),this._popup.addEventListener("exit",this._exitCallbackEvent,!1),this._popup.addEventListener("loadstart",this._loadStartCallbackEvent,!1)):this._error("Error opening popup window")}else this._error("No url provided");return this.promise},CordovaPopupWindow.prototype._loadStartCallback=function _loadStartCallback(e){0===e.url.indexOf(this.redirect_uri)&&this._success({url:e.url})},CordovaPopupWindow.prototype._exitCallback=function _exitCallback(e){this._error(e)},CordovaPopupWindow.prototype._success=function _success(e){this._cleanup(),i.Log.debug("CordovaPopupWindow: Successful response from cordova popup window"),this._resolve(e)},CordovaPopupWindow.prototype._error=function _error(e){this._cleanup(),i.Log.error(e),this._reject(new Error(e))},CordovaPopupWindow.prototype.close=function close(){this._cleanup()},CordovaPopupWindow.prototype._cleanup=function _cleanup(){this._popup&&(i.Log.debug("CordovaPopupWindow: cleaning up popup"),this._popup.removeEventListener("exit",this._exitCallbackEvent,!1),this._popup.removeEventListener("loadstart",this._loadStartCallbackEvent,!1),this._popup.close()),this._popup=null},n(CordovaPopupWindow,[{key:"promise",get:function get(){return this._promise}}]),CordovaPopupWindow}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=r(0),i=r(9),o=r(5),s=r(6),a=r(39),u=r(40),c=r(16),h=r(2),l=r(50),f=r(51),g=r(19),p=r(20),d=r(18),v=r(1),y=r(15);t.default={Log:n.Log,OidcClient:i.OidcClient,OidcClientSettings:o.OidcClientSettings,WebStorageStateStore:s.WebStorageStateStore,InMemoryWebStorage:a.InMemoryWebStorage,UserManager:u.UserManager,AccessTokenEvents:c.AccessTokenEvents,MetadataService:h.MetadataService,CordovaPopupNavigator:l.CordovaPopupNavigator,CordovaIFrameNavigator:f.CordovaIFrameNavigator,CheckSessionIFrame:g.CheckSessionIFrame,TokenRevocationClient:p.TokenRevocationClient,SessionMonitor:d.SessionMonitor,Global:v.Global,User:y.User},e.exports=t.default},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.ResponseValidator=void 0;var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=r(0),o=r(2),s=r(24),a=r(10),u=r(11),c=r(4);var h=["nonce","at_hash","iat","nbf","exp","aud","iss","c_hash"];t.ResponseValidator=function(){function ResponseValidator(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.MetadataService,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:s.UserInfoService,n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:c.JoseUtil,u=arguments.length>4&&void 0!==arguments[4]?arguments[4]:a.TokenClient;if(function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,ResponseValidator),!e)throw i.Log.error("ResponseValidator.ctor: No settings passed to ResponseValidator"),new Error("settings");this._settings=e,this._metadataService=new t(this._settings),this._userInfoService=new r(this._settings),this._joseUtil=n,this._tokenClient=new u(this._settings)}return ResponseValidator.prototype.validateSigninResponse=function validateSigninResponse(e,t){var r=this;return i.Log.debug("ResponseValidator.validateSigninResponse"),this._processSigninParams(e,t).then(function(t){return i.Log.debug("ResponseValidator.validateSigninResponse: state processed"),r._validateTokens(e,t).then(function(e){return i.Log.debug("ResponseValidator.validateSigninResponse: tokens validated"),r._processClaims(e).then(function(e){return i.Log.debug("ResponseValidator.validateSigninResponse: claims processed"),e})})})},ResponseValidator.prototype.validateSignoutResponse=function validateSignoutResponse(e,t){return e.id!==t.state?(i.Log.error("ResponseValidator.validateSignoutResponse: State does not match"),Promise.reject(new Error("State does not match"))):(i.Log.debug("ResponseValidator.validateSignoutResponse: state validated"),t.state=e.data,t.error?(i.Log.warn("ResponseValidator.validateSignoutResponse: Response was error",t.error),Promise.reject(new u.ErrorResponse(t))):Promise.resolve(t))},ResponseValidator.prototype._processSigninParams=function _processSigninParams(e,t){if(e.id!==t.state)return i.Log.error("ResponseValidator._processSigninParams: State does not match"),Promise.reject(new Error("State does not match"));if(!e.client_id)return i.Log.error("ResponseValidator._processSigninParams: No client_id on state"),Promise.reject(new Error("No client_id on state"));if(!e.authority)return i.Log.error("ResponseValidator._processSigninParams: No authority on state"),Promise.reject(new Error("No authority on state"));if(this._settings.authority){if(this._settings.authority&&this._settings.authority!==e.authority)return i.Log.error("ResponseValidator._processSigninParams: authority mismatch on settings vs. signin state"),Promise.reject(new Error("authority mismatch on settings vs. signin state"))}else this._settings.authority=e.authority;if(this._settings.client_id){if(this._settings.client_id&&this._settings.client_id!==e.client_id)return i.Log.error("ResponseValidator._processSigninParams: client_id mismatch on settings vs. signin state"),Promise.reject(new Error("client_id mismatch on settings vs. signin state"))}else this._settings.client_id=e.client_id;return i.Log.debug("ResponseValidator._processSigninParams: state validated"),t.state=e.data,t.error?(i.Log.warn("ResponseValidator._processSigninParams: Response was error",t.error),Promise.reject(new u.ErrorResponse(t))):e.nonce&&!t.id_token?(i.Log.error("ResponseValidator._processSigninParams: Expecting id_token in response"),Promise.reject(new Error("No id_token in response"))):!e.nonce&&t.id_token?(i.Log.error("ResponseValidator._processSigninParams: Not expecting id_token in response"),Promise.reject(new Error("Unexpected id_token in response"))):e.code_verifier&&!t.code?(i.Log.error("ResponseValidator._processSigninParams: Expecting code in response"),Promise.reject(new Error("No code in response"))):!e.code_verifier&&t.code?(i.Log.error("ResponseValidator._processSigninParams: Not expecting code in response"),Promise.reject(new Error("Unexpected code in response"))):Promise.resolve(t)},ResponseValidator.prototype._processClaims=function _processClaims(e){var t=this;if(e.isOpenIdConnect){if(i.Log.debug("ResponseValidator._processClaims: response is OIDC, processing claims"),e.profile=this._filterProtocolClaims(e.profile),this._settings.loadUserInfo&&e.access_token)return i.Log.debug("ResponseValidator._processClaims: loading user info"),this._userInfoService.getClaims(e.access_token).then(function(r){return i.Log.debug("ResponseValidator._processClaims: user info claims received from user info endpoint"),r.sub!==e.profile.sub?(i.Log.error("ResponseValidator._processClaims: sub from user info endpoint does not match sub in access_token"),Promise.reject(new Error("sub from user info endpoint does not match sub in access_token"))):(e.profile=t._mergeClaims(e.profile,r),i.Log.debug("ResponseValidator._processClaims: user info claims received, updated profile:",e.profile),e)});i.Log.debug("ResponseValidator._processClaims: not loading user info")}else i.Log.debug("ResponseValidator._processClaims: response is not OIDC, not processing claims");return Promise.resolve(e)},ResponseValidator.prototype._mergeClaims=function _mergeClaims(e,t){var r=Object.assign({},e);for(var i in t){var o=t[i];Array.isArray(o)||(o=[o]);for(var s=0;s<o.length;s++){var a=o[s];r[i]?Array.isArray(r[i])?r[i].indexOf(a)<0&&r[i].push(a):r[i]!==a&&("object"===(void 0===a?"undefined":n(a))?r[i]=this._mergeClaims(r[i],a):r[i]=[r[i],a]):r[i]=a}}return r},ResponseValidator.prototype._filterProtocolClaims=function _filterProtocolClaims(e){i.Log.debug("ResponseValidator._filterProtocolClaims, incoming claims:",e);var t=Object.assign({},e);return this._settings._filterProtocolClaims?(h.forEach(function(e){delete t[e]}),i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims filtered",t)):i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims not filtered"),t},ResponseValidator.prototype._validateTokens=function _validateTokens(e,t){return t.code?(i.Log.debug("ResponseValidator._validateTokens: Validating code"),this._processCode(e,t)):t.id_token?t.access_token?(i.Log.debug("ResponseValidator._validateTokens: Validating id_token and access_token"),this._validateIdTokenAndAccessToken(e,t)):(i.Log.debug("ResponseValidator._validateTokens: Validating id_token"),this._validateIdToken(e,t)):(i.Log.debug("ResponseValidator._validateTokens: No code to process or id_token to validate"),Promise.resolve(t))},ResponseValidator.prototype._processCode=function _processCode(e,t){var r=this,n={client_id:e.client_id,client_secret:this._settings.client_secret,code:t.code,redirect_uri:e.redirect_uri,code_verifier:e.code_verifier};return this._tokenClient.exchangeCode(n).then(function(n){for(var o in n)t[o]=n[o];return t.id_token?(i.Log.debug("ResponseValidator._processCode: token response successful, processing id_token"),r._validateIdTokenAttributes(e,t)):(i.Log.debug("ResponseValidator._processCode: token response successful, returning response"),t)})},ResponseValidator.prototype._validateIdTokenAttributes=function _validateIdTokenAttributes(e,t){var r=this;return this._metadataService.getIssuer().then(function(n){var o=e.client_id,s=r._settings.clockSkew;return i.Log.debug("ResponseValidator._validateIdTokenAttributes: Validaing JWT attributes; using clock skew (in seconds) of: ",s),r._joseUtil.validateJwtAttributes(t.id_token,n,o,s).then(function(r){return e.nonce&&e.nonce!==r.nonce?(i.Log.error("ResponseValidator._validateIdTokenAttributes: Invalid nonce in id_token"),Promise.reject(new Error("Invalid nonce in id_token"))):r.sub?(t.profile=r,t):(i.Log.error("ResponseValidator._validateIdTokenAttributes: No sub present in id_token"),Promise.reject(new Error("No sub present in id_token")))})})},ResponseValidator.prototype._validateIdTokenAndAccessToken=function _validateIdTokenAndAccessToken(e,t){var r=this;return this._validateIdToken(e,t).then(function(e){return r._validateAccessToken(e)})},ResponseValidator.prototype._validateIdToken=function _validateIdToken(e,t){var r=this;if(!e.nonce)return i.Log.error("ResponseValidator._validateIdToken: No nonce on state"),Promise.reject(new Error("No nonce on state"));var n=this._joseUtil.parseJwt(t.id_token);if(!n||!n.header||!n.payload)return i.Log.error("ResponseValidator._validateIdToken: Failed to parse id_token",n),Promise.reject(new Error("Failed to parse id_token"));if(e.nonce!==n.payload.nonce)return i.Log.error("ResponseValidator._validateIdToken: Invalid nonce in id_token"),Promise.reject(new Error("Invalid nonce in id_token"));var o=n.header.kid;return this._metadataService.getIssuer().then(function(s){return i.Log.debug("ResponseValidator._validateIdToken: Received issuer"),r._metadataService.getSigningKeys().then(function(a){if(!a)return i.Log.error("ResponseValidator._validateIdToken: No signing keys from metadata"),Promise.reject(new Error("No signing keys from metadata"));i.Log.debug("ResponseValidator._validateIdToken: Received signing keys");var u=void 0;if(o)u=a.filter(function(e){return e.kid===o})[0];else{if((a=r._filterByAlg(a,n.header.alg)).length>1)return i.Log.error("ResponseValidator._validateIdToken: No kid found in id_token and more than one key found in metadata"),Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));u=a[0]}if(!u)return i.Log.error("ResponseValidator._validateIdToken: No key matching kid or alg found in signing keys"),Promise.reject(new Error("No key matching kid or alg found in signing keys"));var c=e.client_id,h=r._settings.clockSkew;return i.Log.debug("ResponseValidator._validateIdToken: Validaing JWT; using clock skew (in seconds) of: ",h),r._joseUtil.validateJwt(t.id_token,u,s,c,h).then(function(){return i.Log.debug("ResponseValidator._validateIdToken: JWT validation successful"),n.payload.sub?(t.profile=n.payload,t):(i.Log.error("ResponseValidator._validateIdToken: No sub present in id_token"),Promise.reject(new Error("No sub present in id_token")))})})})},ResponseValidator.prototype._filterByAlg=function _filterByAlg(e,t){var r=null;if(t.startsWith("RS"))r="RSA";else if(t.startsWith("PS"))r="PS";else{if(!t.startsWith("ES"))return i.Log.debug("ResponseValidator._filterByAlg: alg not supported: ",t),[];r="EC"}return i.Log.debug("ResponseValidator._filterByAlg: Looking for keys that match kty: ",r),e=e.filter(function(e){return e.kty===r}),i.Log.debug("ResponseValidator._filterByAlg: Number of keys that match kty: ",r,e.length),e},ResponseValidator.prototype._validateAccessToken=function _validateAccessToken(e){if(!e.profile)return i.Log.error("ResponseValidator._validateAccessToken: No profile loaded from id_token"),Promise.reject(new Error("No profile loaded from id_token"));if(!e.profile.at_hash)return i.Log.error("ResponseValidator._validateAccessToken: No at_hash in id_token"),Promise.reject(new Error("No at_hash in id_token"));if(!e.id_token)return i.Log.error("ResponseValidator._validateAccessToken: No id_token"),Promise.reject(new Error("No id_token"));var t=this._joseUtil.parseJwt(e.id_token);if(!t||!t.header)return i.Log.error("ResponseValidator._validateAccessToken: Failed to parse id_token",t),Promise.reject(new Error("Failed to parse id_token"));var r=t.header.alg;if(!r||5!==r.length)return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:",r),Promise.reject(new Error("Unsupported alg: "+r));var n=r.substr(2,3);if(!n)return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:",r,n),Promise.reject(new Error("Unsupported alg: "+r));if(256!==(n=parseInt(n))&&384!==n&&512!==n)return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:",r,n),Promise.reject(new Error("Unsupported alg: "+r));var o="sha"+n,s=this._joseUtil.hashString(e.access_token,o);if(!s)return i.Log.error("ResponseValidator._validateAccessToken: access_token hash failed:",o),Promise.reject(new Error("Failed to validate at_hash"));var a=s.substr(0,s.length/2),u=this._joseUtil.hexToBase64Url(a);return u!==e.profile.at_hash?(i.Log.error("ResponseValidator._validateAccessToken: Failed to validate at_hash",u,e.profile.at_hash),Promise.reject(new Error("Failed to validate at_hash"))):(i.Log.debug("ResponseValidator._validateAccessToken: success"),Promise.resolve(e))},ResponseValidator}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.UserInfoService=void 0;var n=r(7),i=r(2),o=r(0),s=r(4);t.UserInfoService=function(){function UserInfoService(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:n.JsonService,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.MetadataService,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:s.JoseUtil;if(function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,UserInfoService),!e)throw o.Log.error("UserInfoService.ctor: No settings passed"),new Error("settings");this._settings=e,this._jsonService=new t(void 0,void 0,this._getClaimsFromJwt.bind(this)),this._metadataService=new r(this._settings),this._joseUtil=a}return UserInfoService.prototype.getClaims=function getClaims(e){var t=this;return e?this._metadataService.getUserInfoEndpoint().then(function(r){return o.Log.debug("UserInfoService.getClaims: received userinfo url",r),t._jsonService.getJson(r,e).then(function(e){return o.Log.debug("UserInfoService.getClaims: claims received",e),e})}):(o.Log.error("UserInfoService.getClaims: No token passed"),Promise.reject(new Error("A token is required")))},UserInfoService.prototype._getClaimsFromJwt=function _getClaimsFromJwt(e){var t=this;try{var r=this._joseUtil.parseJwt(e.responseText);if(!r||!r.header||!r.payload)return o.Log.error("UserInfoService._getClaimsFromJwt: Failed to parse JWT",r),Promise.reject(new Error("Failed to parse id_token"));var n=r.header.kid,i=void 0;switch(this._settings.userInfoJwtIssuer){case"OP":i=this._metadataService.getIssuer();break;case"ANY":i=Promise.resolve(r.payload.iss);break;default:i=Promise.resolve(this._settings.userInfoJwtIssuer)}return i.then(function(i){return o.Log.debug("UserInfoService._getClaimsFromJwt: Received issuer:"+i),t._metadataService.getSigningKeys().then(function(s){if(!s)return o.Log.error("UserInfoService._getClaimsFromJwt: No signing keys from metadata"),Promise.reject(new Error("No signing keys from metadata"));o.Log.debug("UserInfoService._getClaimsFromJwt: Received signing keys");var a=void 0;if(n)a=s.filter(function(e){return e.kid===n})[0];else{if((s=t._filterByAlg(s,r.header.alg)).length>1)return o.Log.error("UserInfoService._getClaimsFromJwt: No kid found in id_token and more than one key found in metadata"),Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));a=s[0]}if(!a)return o.Log.error("UserInfoService._getClaimsFromJwt: No key matching kid or alg found in signing keys"),Promise.reject(new Error("No key matching kid or alg found in signing keys"));var u=t._settings.client_id,c=t._settings.clockSkew;return o.Log.debug("UserInfoService._getClaimsFromJwt: Validaing JWT; using clock skew (in seconds) of: ",c),t._joseUtil.validateJwt(e.responseText,a,i,u,c,void 0,!0).then(function(){return o.Log.debug("UserInfoService._getClaimsFromJwt: JWT validation successful"),r.payload})})})}catch(e){return o.Log.error("UserInfoService._getClaimsFromJwt: Error parsing JWT response",e.message),void reject(e)}},UserInfoService.prototype._filterByAlg=function _filterByAlg(e,t){var r=null;if(t.startsWith("RS"))r="RSA";else if(t.startsWith("PS"))r="PS";else{if(!t.startsWith("ES"))return o.Log.debug("UserInfoService._filterByAlg: alg not supported: ",t),[];r="EC"}return o.Log.debug("UserInfoService._filterByAlg: Looking for keys that match kty: ",r),e=e.filter(function(e){return e.kty===r}),o.Log.debug("UserInfoService._filterByAlg: Number of keys that match kty: ",r,e.length),e},UserInfoService}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.AllowedSigningAlgs=t.b64tohex=t.hextob64u=t.crypto=t.X509=t.KeyUtil=t.jws=void 0;var n=r(26);t.jws=n.jws,t.KeyUtil=n.KEYUTIL,t.X509=n.X509,t.crypto=n.crypto,t.hextob64u=n.hextob64u,t.b64tohex=n.b64tohex,t.AllowedSigningAlgs=["RS256","RS384","RS512","PS256","PS384","PS512","ES256","ES384","ES512"]},function(e,t,r){"use strict";(function(n){Object.defineProperty(t,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u={userAgent:!1},p={};
/*!
Copyright (c) 2011, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.com/yui/license.html
version: 2.9.0
*/
if(void 0===v)var v={};v.lang={extend:function extend(t,r,n){if(!r||!t)throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included.");var i=function d(){};if(i.prototype=r.prototype,t.prototype=new i,t.prototype.constructor=t,t.superclass=r.prototype,r.prototype.constructor==Object.prototype.constructor&&(r.prototype.constructor=r),n){var o;for(o in n)t.prototype[o]=n[o];var s=function e(){},a=["toString","valueOf"];try{/MSIE/.test(u.userAgent)&&(s=function e(t,r){for(o=0;o<a.length;o+=1){var n=a[o],i=r[n];"function"==typeof i&&i!=Object.prototype[n]&&(t[n]=i)}})}catch(e){}s(t.prototype,n)}}};
/*! CryptoJS v3.1.2 core-fix.js
 * code.google.com/p/crypto-js
 * (c) 2009-2013 by Jeff Mott. All rights reserved.
 * code.google.com/p/crypto-js/wiki/License
 * THIS IS FIX of 'core.js' to fix Hmac issue.
 * https://code.google.com/p/crypto-js/issues/detail?id=84
 * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
 */
var y=y||function(e,t){var r={},n=r.lib={},i=n.Base=function(){function n(){}return{extend:function extend(e){n.prototype=this;var t=new n;return e&&t.mixIn(e),t.hasOwnProperty("init")||(t.init=function(){t.$super.init.apply(this,arguments)}),t.init.prototype=t,t.$super=this,t},create:function create(){var e=this.extend();return e.init.apply(e,arguments),e},init:function init(){},mixIn:function mixIn(e){for(var t in e)e.hasOwnProperty(t)&&(this[t]=e[t]);e.hasOwnProperty("toString")&&(this.toString=e.toString)},clone:function clone(){return this.init.prototype.extend(this)}}}(),o=n.WordArray=i.extend({init:function init(e,t){e=this.words=e||[],this.sigBytes=void 0!=t?t:4*e.length},toString:function toString(e){return(e||a).stringify(this)},concat:function concat(e){var t=this.words,r=e.words,n=this.sigBytes,i=e.sigBytes;if(this.clamp(),n%4)for(var o=0;o<i;o++){var s=r[o>>>2]>>>24-o%4*8&255;t[n+o>>>2]|=s<<24-(n+o)%4*8}else for(o=0;o<i;o+=4)t[n+o>>>2]=r[o>>>2];return this.sigBytes+=i,this},clamp:function clamp(){var t=this.words,r=this.sigBytes;t[r>>>2]&=4294967295<<32-r%4*8,t.length=e.ceil(r/4)},clone:function clone(){var e=i.clone.call(this);return e.words=this.words.slice(0),e},random:function random(t){for(var r=[],n=0;n<t;n+=4)r.push(4294967296*e.random()|0);return new o.init(r,t)}}),s=r.enc={},a=s.Hex={stringify:function stringify(e){for(var t=e.words,r=e.sigBytes,n=[],i=0;i<r;i++){var o=t[i>>>2]>>>24-i%4*8&255;n.push((o>>>4).toString(16)),n.push((15&o).toString(16))}return n.join("")},parse:function parse(e){for(var t=e.length,r=[],n=0;n<t;n+=2)r[n>>>3]|=parseInt(e.substr(n,2),16)<<24-n%8*4;return new o.init(r,t/2)}},u=s.Latin1={stringify:function stringify(e){for(var t=e.words,r=e.sigBytes,n=[],i=0;i<r;i++){var o=t[i>>>2]>>>24-i%4*8&255;n.push(String.fromCharCode(o))}return n.join("")},parse:function parse(e){for(var t=e.length,r=[],n=0;n<t;n++)r[n>>>2]|=(255&e.charCodeAt(n))<<24-n%4*8;return new o.init(r,t)}},c=s.Utf8={stringify:function stringify(e){try{return decodeURIComponent(escape(u.stringify(e)))}catch(e){throw new Error("Malformed UTF-8 data")}},parse:function parse(e){return u.parse(unescape(encodeURIComponent(e)))}},h=n.BufferedBlockAlgorithm=i.extend({reset:function reset(){this._data=new o.init,this._nDataBytes=0},_append:function _append(e){"string"==typeof e&&(e=c.parse(e)),this._data.concat(e),this._nDataBytes+=e.sigBytes},_process:function _process(t){var r=this._data,n=r.words,i=r.sigBytes,s=this.blockSize,a=i/(4*s),u=(a=t?e.ceil(a):e.max((0|a)-this._minBufferSize,0))*s,c=e.min(4*u,i);if(u){for(var h=0;h<u;h+=s)this._doProcessBlock(n,h);var l=n.splice(0,u);r.sigBytes-=c}return new o.init(l,c)},clone:function clone(){var e=i.clone.call(this);return e._data=this._data.clone(),e},_minBufferSize:0}),l=(n.Hasher=h.extend({cfg:i.extend(),init:function init(e){this.cfg=this.cfg.extend(e),this.reset()},reset:function reset(){h.reset.call(this),this._doReset()},update:function update(e){return this._append(e),this._process(),this},finalize:function finalize(e){return e&&this._append(e),this._doFinalize()},blockSize:16,_createHelper:function _createHelper(e){return function(t,r){return new e.init(r).finalize(t)}},_createHmacHelper:function _createHmacHelper(e){return function(t,r){return new l.HMAC.init(e,r).finalize(t)}}}),r.algo={});return r}(Math);!function(e){var t,r=(t=y).lib,n=r.Base,i=r.WordArray;(t=t.x64={}).Word=n.extend({init:function init(e,t){this.high=e,this.low=t}}),t.WordArray=n.extend({init:function init(e,t){e=this.words=e||[],this.sigBytes=void 0!=t?t:8*e.length},toX32:function toX32(){for(var e=this.words,t=e.length,r=[],n=0;n<t;n++){var o=e[n];r.push(o.high),r.push(o.low)}return i.create(r,this.sigBytes)},clone:function clone(){for(var e=n.clone.call(this),t=e.words=this.words.slice(0),r=t.length,i=0;i<r;i++)t[i]=t[i].clone();return e}})}(),function(){var e=y,t=e.lib.WordArray;e.enc.Base64={stringify:function stringify(e){var t=e.words,r=e.sigBytes,n=this._map;e.clamp(),e=[];for(var i=0;i<r;i+=3)for(var o=(t[i>>>2]>>>24-i%4*8&255)<<16|(t[i+1>>>2]>>>24-(i+1)%4*8&255)<<8|t[i+2>>>2]>>>24-(i+2)%4*8&255,s=0;4>s&&i+.75*s<r;s++)e.push(n.charAt(o>>>6*(3-s)&63));if(t=n.charAt(64))for(;e.length%4;)e.push(t);return e.join("")},parse:function parse(e){var r=e.length,n=this._map;(i=n.charAt(64))&&(-1!=(i=e.indexOf(i))&&(r=i));for(var i=[],o=0,s=0;s<r;s++)if(s%4){var a=n.indexOf(e.charAt(s-1))<<s%4*2,u=n.indexOf(e.charAt(s))>>>6-s%4*2;i[o>>>2]|=(a|u)<<24-o%4*8,o++}return t.create(i,o)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}}(),function(e){for(var t=y,r=(i=t.lib).WordArray,n=i.Hasher,i=t.algo,o=[],s=[],a=function u(e){return 4294967296*(e-(0|e))|0},u=2,c=0;64>c;){var h;e:{h=u;for(var l=e.sqrt(h),f=2;f<=l;f++)if(!(h%f)){h=!1;break e}h=!0}h&&(8>c&&(o[c]=a(e.pow(u,.5))),s[c]=a(e.pow(u,1/3)),c++),u++}var g=[];i=i.SHA256=n.extend({_doReset:function _doReset(){this._hash=new r.init(o.slice(0))},_doProcessBlock:function _doProcessBlock(e,t){for(var r=this._hash.words,n=r[0],i=r[1],o=r[2],a=r[3],u=r[4],c=r[5],h=r[6],l=r[7],f=0;64>f;f++){if(16>f)g[f]=0|e[t+f];else{var p=g[f-15],d=g[f-2];g[f]=((p<<25|p>>>7)^(p<<14|p>>>18)^p>>>3)+g[f-7]+((d<<15|d>>>17)^(d<<13|d>>>19)^d>>>10)+g[f-16]}p=l+((u<<26|u>>>6)^(u<<21|u>>>11)^(u<<7|u>>>25))+(u&c^~u&h)+s[f]+g[f],d=((n<<30|n>>>2)^(n<<19|n>>>13)^(n<<10|n>>>22))+(n&i^n&o^i&o),l=h,h=c,c=u,u=a+p|0,a=o,o=i,i=n,n=p+d|0}r[0]=r[0]+n|0,r[1]=r[1]+i|0,r[2]=r[2]+o|0,r[3]=r[3]+a|0,r[4]=r[4]+u|0,r[5]=r[5]+c|0,r[6]=r[6]+h|0,r[7]=r[7]+l|0},_doFinalize:function _doFinalize(){var t=this._data,r=t.words,n=8*this._nDataBytes,i=8*t.sigBytes;return r[i>>>5]|=128<<24-i%32,r[14+(i+64>>>9<<4)]=e.floor(n/4294967296),r[15+(i+64>>>9<<4)]=n,t.sigBytes=4*r.length,this._process(),this._hash},clone:function clone(){var e=n.clone.call(this);return e._hash=this._hash.clone(),e}});t.SHA256=n._createHelper(i),t.HmacSHA256=n._createHmacHelper(i)}(Math),function(){function a(){return r.create.apply(r,arguments)}for(var e=y,t=e.lib.Hasher,r=(i=e.x64).Word,n=i.WordArray,i=e.algo,o=[a(1116352408,3609767458),a(1899447441,602891725),a(3049323471,3964484399),a(3921009573,2173295548),a(961987163,4081628472),a(1508970993,3053834265),a(2453635748,2937671579),a(2870763221,3664609560),a(3624381080,2734883394),a(310598401,1164996542),a(607225278,1323610764),a(1426881987,3590304994),a(1925078388,4068182383),a(2162078206,991336113),a(2614888103,633803317),a(3248222580,3479774868),a(3835390401,2666613458),a(4022224774,944711139),a(264347078,2341262773),a(604807628,2007800933),a(770255983,1495990901),a(1249150122,1856431235),a(1555081692,3175218132),a(1996064986,2198950837),a(2554220882,3999719339),a(2821834349,766784016),a(2952996808,2566594879),a(3210313671,3203337956),a(3336571891,1034457026),a(3584528711,2466948901),a(113926993,3758326383),a(338241895,168717936),a(666307205,1188179964),a(773529912,1546045734),a(1294757372,1522805485),a(1396182291,2643833823),a(1695183700,2343527390),a(1986661051,1014477480),a(2177026350,1206759142),a(2456956037,344077627),a(2730485921,1290863460),a(2820302411,3158454273),a(3259730800,3505952657),a(3345764771,106217008),a(3516065817,3606008344),a(3600352804,1432725776),a(4094571909,1467031594),a(275423344,851169720),a(430227734,3100823752),a(506948616,1363258195),a(659060556,3750685593),a(883997877,3785050280),a(958139571,3318307427),a(1322822218,3812723403),a(1537002063,2003034995),a(1747873779,3602036899),a(1955562222,1575990012),a(2024104815,1125592928),a(2227730452,2716904306),a(2361852424,442776044),a(2428436474,593698344),a(2756734187,3733110249),a(3204031479,2999351573),a(3329325298,3815920427),a(3391569614,3928383900),a(3515267271,566280711),a(3940187606,3454069534),a(4118630271,4000239992),a(116418474,1914138554),a(174292421,2731055270),a(289380356,3203993006),a(460393269,320620315),a(685471733,587496836),a(852142971,1086792851),a(1017036298,365543100),a(1126000580,2618297676),a(1288033470,3409855158),a(1501505948,4234509866),a(1607167915,987167468),a(1816402316,1246189591)],s=[],u=0;80>u;u++)s[u]=a();i=i.SHA512=t.extend({_doReset:function _doReset(){this._hash=new n.init([new r.init(1779033703,4089235720),new r.init(3144134277,2227873595),new r.init(1013904242,4271175723),new r.init(2773480762,1595750129),new r.init(1359893119,2917565137),new r.init(2600822924,725511199),new r.init(528734635,4215389547),new r.init(1541459225,327033209)])},_doProcessBlock:function _doProcessBlock(e,t){for(var r=(l=this._hash.words)[0],n=l[1],i=l[2],a=l[3],u=l[4],c=l[5],h=l[6],l=l[7],f=r.high,g=r.low,p=n.high,d=n.low,v=i.high,y=i.low,m=a.high,_=a.low,S=u.high,b=u.low,F=c.high,w=c.low,E=h.high,x=h.low,C=l.high,k=l.low,A=f,P=g,I=p,B=d,R=v,T=y,U=m,D=_,M=S,L=b,N=F,O=w,H=E,j=x,K=C,V=k,q=0;80>q;q++){var W=s[q];if(16>q)var J=W.high=0|e[t+2*q],z=W.low=0|e[t+2*q+1];else{J=((z=(J=s[q-15]).high)>>>1|(Y=J.low)<<31)^(z>>>8|Y<<24)^z>>>7;var Y=(Y>>>1|z<<31)^(Y>>>8|z<<24)^(Y>>>7|z<<25),G=((z=(G=s[q-2]).high)>>>19|(X=G.low)<<13)^(z<<3|X>>>29)^z>>>6,X=(X>>>19|z<<13)^(X<<3|z>>>29)^(X>>>6|z<<26),Q=(z=s[q-7]).high,$=(Z=s[q-16]).high,Z=Z.low;J=(J=(J=J+Q+((z=Y+z.low)>>>0<Y>>>0?1:0))+G+((z=z+X)>>>0<X>>>0?1:0))+$+((z=z+Z)>>>0<Z>>>0?1:0);W.high=J,W.low=z}Q=M&N^~M&H,Z=L&O^~L&j,W=A&I^A&R^I&R;var ee=P&B^P&T^B&T,te=(Y=(A>>>28|P<<4)^(A<<30|P>>>2)^(A<<25|P>>>7),G=(P>>>28|A<<4)^(P<<30|A>>>2)^(P<<25|A>>>7),(X=o[q]).high),re=X.low;$=($=($=($=K+((M>>>14|L<<18)^(M>>>18|L<<14)^(M<<23|L>>>9))+((X=V+((L>>>14|M<<18)^(L>>>18|M<<14)^(L<<23|M>>>9)))>>>0<V>>>0?1:0))+Q+((X=X+Z)>>>0<Z>>>0?1:0))+te+((X=X+re)>>>0<re>>>0?1:0))+J+((X=X+z)>>>0<z>>>0?1:0),W=Y+W+((z=G+ee)>>>0<G>>>0?1:0),K=H,V=j,H=N,j=O,N=M,O=L,M=U+$+((L=D+X|0)>>>0<D>>>0?1:0)|0,U=R,D=T,R=I,T=B,I=A,B=P,A=$+W+((P=X+z|0)>>>0<X>>>0?1:0)|0}g=r.low=g+P,r.high=f+A+(g>>>0<P>>>0?1:0),d=n.low=d+B,n.high=p+I+(d>>>0<B>>>0?1:0),y=i.low=y+T,i.high=v+R+(y>>>0<T>>>0?1:0),_=a.low=_+D,a.high=m+U+(_>>>0<D>>>0?1:0),b=u.low=b+L,u.high=S+M+(b>>>0<L>>>0?1:0),w=c.low=w+O,c.high=F+N+(w>>>0<O>>>0?1:0),x=h.low=x+j,h.high=E+H+(x>>>0<j>>>0?1:0),k=l.low=k+V,l.high=C+K+(k>>>0<V>>>0?1:0)},_doFinalize:function _doFinalize(){var e=this._data,t=e.words,r=8*this._nDataBytes,n=8*e.sigBytes;return t[n>>>5]|=128<<24-n%32,t[30+(n+128>>>10<<5)]=Math.floor(r/4294967296),t[31+(n+128>>>10<<5)]=r,e.sigBytes=4*t.length,this._process(),this._hash.toX32()},clone:function clone(){var e=t.clone.call(this);return e._hash=this._hash.clone(),e},blockSize:32}),e.SHA512=t._createHelper(i),e.HmacSHA512=t._createHmacHelper(i)}(),function(){var e=y,t=(i=e.x64).Word,r=i.WordArray,n=(i=e.algo).SHA512,i=i.SHA384=n.extend({_doReset:function _doReset(){this._hash=new r.init([new t.init(3418070365,3238371032),new t.init(1654270250,914150663),new t.init(2438529370,812702999),new t.init(355462360,4144912697),new t.init(1731405415,4290775857),new t.init(2394180231,1750603025),new t.init(3675008525,1694076839),new t.init(1203062813,3204075428)])},_doFinalize:function _doFinalize(){var e=n._doFinalize.call(this);return e.sigBytes-=16,e}});e.SHA384=n._createHelper(i),e.HmacSHA384=n._createHmacHelper(i)}();
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
var _,S="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",F="=";function hex2b64(e){var t,r,n="";for(t=0;t+3<=e.length;t+=3)r=parseInt(e.substring(t,t+3),16),n+=S.charAt(r>>6)+S.charAt(63&r);if(t+1==e.length?(r=parseInt(e.substring(t,t+1),16),n+=S.charAt(r<<2)):t+2==e.length&&(r=parseInt(e.substring(t,t+2),16),n+=S.charAt(r>>2)+S.charAt((3&r)<<4)),F)for(;(3&n.length)>0;)n+=F;return n}function b64tohex(e){var t,r,n,i="",o=0;for(t=0;t<e.length&&e.charAt(t)!=F;++t)(n=S.indexOf(e.charAt(t)))<0||(0==o?(i+=int2char(n>>2),r=3&n,o=1):1==o?(i+=int2char(r<<2|n>>4),r=15&n,o=2):2==o?(i+=int2char(r),i+=int2char(n>>2),r=3&n,o=3):(i+=int2char(r<<2|n>>4),i+=int2char(15&n),o=0));return 1==o&&(i+=int2char(r<<2)),i}function b64toBA(e){var t,r=b64tohex(e),n=new Array;for(t=0;2*t<r.length;++t)n[t]=parseInt(r.substring(2*t,2*t+2),16);return n}function BigInteger(e,t,r){null!=e&&("number"==typeof e?this.fromNumber(e,t,r):null==t&&"string"!=typeof e?this.fromString(e,256):this.fromString(e,t))}function nbi(){return new BigInteger(null)}"Microsoft Internet Explorer"==u.appName?(BigInteger.prototype.am=function am2(e,t,r,n,i,o){for(var s=32767&t,a=t>>15;--o>=0;){var u=32767&this[e],c=this[e++]>>15,h=a*u+c*s;i=((u=s*u+((32767&h)<<15)+r[n]+(1073741823&i))>>>30)+(h>>>15)+a*c+(i>>>30),r[n++]=1073741823&u}return i},_=30):"Netscape"!=u.appName?(BigInteger.prototype.am=function am1(e,t,r,n,i,o){for(;--o>=0;){var s=t*this[e++]+r[n]+i;i=Math.floor(s/67108864),r[n++]=67108863&s}return i},_=26):(BigInteger.prototype.am=function am3(e,t,r,n,i,o){for(var s=16383&t,a=t>>14;--o>=0;){var u=16383&this[e],c=this[e++]>>14,h=a*u+c*s;i=((u=s*u+((16383&h)<<14)+r[n]+i)>>28)+(h>>14)+a*c,r[n++]=268435455&u}return i},_=28),BigInteger.prototype.DB=_,BigInteger.prototype.DM=(1<<_)-1,BigInteger.prototype.DV=1<<_;BigInteger.prototype.FV=Math.pow(2,52),BigInteger.prototype.F1=52-_,BigInteger.prototype.F2=2*_-52;var w,E,C="0123456789abcdefghijklmnopqrstuvwxyz",P=new Array;for(w="0".charCodeAt(0),E=0;E<=9;++E)P[w++]=E;for(w="a".charCodeAt(0),E=10;E<36;++E)P[w++]=E;for(w="A".charCodeAt(0),E=10;E<36;++E)P[w++]=E;function int2char(e){return C.charAt(e)}function intAt(e,t){var r=P[e.charCodeAt(t)];return null==r?-1:r}function nbv(e){var t=nbi();return t.fromInt(e),t}function nbits(e){var t,r=1;return 0!=(t=e>>>16)&&(e=t,r+=16),0!=(t=e>>8)&&(e=t,r+=8),0!=(t=e>>4)&&(e=t,r+=4),0!=(t=e>>2)&&(e=t,r+=2),0!=(t=e>>1)&&(e=t,r+=1),r}function Classic(e){this.m=e}function Montgomery(e){this.m=e,this.mp=e.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<e.DB-15)-1,this.mt2=2*e.t}function op_and(e,t){return e&t}function op_or(e,t){return e|t}function op_xor(e,t){return e^t}function op_andnot(e,t){return e&~t}function lbit(e){if(0==e)return-1;var t=0;return 0==(65535&e)&&(e>>=16,t+=16),0==(255&e)&&(e>>=8,t+=8),0==(15&e)&&(e>>=4,t+=4),0==(3&e)&&(e>>=2,t+=2),0==(1&e)&&++t,t}function cbit(e){for(var t=0;0!=e;)e&=e-1,++t;return t}function NullExp(){}function nNop(e){return e}function Barrett(e){this.r2=nbi(),this.q3=nbi(),BigInteger.ONE.dlShiftTo(2*e.t,this.r2),this.mu=this.r2.divide(e),this.m=e}Classic.prototype.convert=function cConvert(e){return e.s<0||e.compareTo(this.m)>=0?e.mod(this.m):e},Classic.prototype.revert=function cRevert(e){return e},Classic.prototype.reduce=function cReduce(e){e.divRemTo(this.m,null,e)},Classic.prototype.mulTo=function cMulTo(e,t,r){e.multiplyTo(t,r),this.reduce(r)},Classic.prototype.sqrTo=function cSqrTo(e,t){e.squareTo(t),this.reduce(t)},Montgomery.prototype.convert=function montConvert(e){var t=nbi();return e.abs().dlShiftTo(this.m.t,t),t.divRemTo(this.m,null,t),e.s<0&&t.compareTo(BigInteger.ZERO)>0&&this.m.subTo(t,t),t},Montgomery.prototype.revert=function montRevert(e){var t=nbi();return e.copyTo(t),this.reduce(t),t},Montgomery.prototype.reduce=function montReduce(e){for(;e.t<=this.mt2;)e[e.t++]=0;for(var t=0;t<this.m.t;++t){var r=32767&e[t],n=r*this.mpl+((r*this.mph+(e[t]>>15)*this.mpl&this.um)<<15)&e.DM;for(e[r=t+this.m.t]+=this.m.am(0,n,e,t,0,this.m.t);e[r]>=e.DV;)e[r]-=e.DV,e[++r]++}e.clamp(),e.drShiftTo(this.m.t,e),e.compareTo(this.m)>=0&&e.subTo(this.m,e)},Montgomery.prototype.mulTo=function montMulTo(e,t,r){e.multiplyTo(t,r),this.reduce(r)},Montgomery.prototype.sqrTo=function montSqrTo(e,t){e.squareTo(t),this.reduce(t)},BigInteger.prototype.copyTo=function bnpCopyTo(e){for(var t=this.t-1;t>=0;--t)e[t]=this[t];e.t=this.t,e.s=this.s},BigInteger.prototype.fromInt=function bnpFromInt(e){this.t=1,this.s=e<0?-1:0,e>0?this[0]=e:e<-1?this[0]=e+this.DV:this.t=0},BigInteger.prototype.fromString=function bnpFromString(e,t){var r;if(16==t)r=4;else if(8==t)r=3;else if(256==t)r=8;else if(2==t)r=1;else if(32==t)r=5;else{if(4!=t)return void this.fromRadix(e,t);r=2}this.t=0,this.s=0;for(var n=e.length,i=!1,o=0;--n>=0;){var s=8==r?255&e[n]:intAt(e,n);s<0?"-"==e.charAt(n)&&(i=!0):(i=!1,0==o?this[this.t++]=s:o+r>this.DB?(this[this.t-1]|=(s&(1<<this.DB-o)-1)<<o,this[this.t++]=s>>this.DB-o):this[this.t-1]|=s<<o,(o+=r)>=this.DB&&(o-=this.DB))}8==r&&0!=(128&e[0])&&(this.s=-1,o>0&&(this[this.t-1]|=(1<<this.DB-o)-1<<o)),this.clamp(),i&&BigInteger.ZERO.subTo(this,this)},BigInteger.prototype.clamp=function bnpClamp(){for(var e=this.s&this.DM;this.t>0&&this[this.t-1]==e;)--this.t},BigInteger.prototype.dlShiftTo=function bnpDLShiftTo(e,t){var r;for(r=this.t-1;r>=0;--r)t[r+e]=this[r];for(r=e-1;r>=0;--r)t[r]=0;t.t=this.t+e,t.s=this.s},BigInteger.prototype.drShiftTo=function bnpDRShiftTo(e,t){for(var r=e;r<this.t;++r)t[r-e]=this[r];t.t=Math.max(this.t-e,0),t.s=this.s},BigInteger.prototype.lShiftTo=function bnpLShiftTo(e,t){var r,n=e%this.DB,i=this.DB-n,o=(1<<i)-1,s=Math.floor(e/this.DB),a=this.s<<n&this.DM;for(r=this.t-1;r>=0;--r)t[r+s+1]=this[r]>>i|a,a=(this[r]&o)<<n;for(r=s-1;r>=0;--r)t[r]=0;t[s]=a,t.t=this.t+s+1,t.s=this.s,t.clamp()},BigInteger.prototype.rShiftTo=function bnpRShiftTo(e,t){t.s=this.s;var r=Math.floor(e/this.DB);if(r>=this.t)t.t=0;else{var n=e%this.DB,i=this.DB-n,o=(1<<n)-1;t[0]=this[r]>>n;for(var s=r+1;s<this.t;++s)t[s-r-1]|=(this[s]&o)<<i,t[s-r]=this[s]>>n;n>0&&(t[this.t-r-1]|=(this.s&o)<<i),t.t=this.t-r,t.clamp()}},BigInteger.prototype.subTo=function bnpSubTo(e,t){for(var r=0,n=0,i=Math.min(e.t,this.t);r<i;)n+=this[r]-e[r],t[r++]=n&this.DM,n>>=this.DB;if(e.t<this.t){for(n-=e.s;r<this.t;)n+=this[r],t[r++]=n&this.DM,n>>=this.DB;n+=this.s}else{for(n+=this.s;r<e.t;)n-=e[r],t[r++]=n&this.DM,n>>=this.DB;n-=e.s}t.s=n<0?-1:0,n<-1?t[r++]=this.DV+n:n>0&&(t[r++]=n),t.t=r,t.clamp()},BigInteger.prototype.multiplyTo=function bnpMultiplyTo(e,t){var r=this.abs(),n=e.abs(),i=r.t;for(t.t=i+n.t;--i>=0;)t[i]=0;for(i=0;i<n.t;++i)t[i+r.t]=r.am(0,n[i],t,i,0,r.t);t.s=0,t.clamp(),this.s!=e.s&&BigInteger.ZERO.subTo(t,t)},BigInteger.prototype.squareTo=function bnpSquareTo(e){for(var t=this.abs(),r=e.t=2*t.t;--r>=0;)e[r]=0;for(r=0;r<t.t-1;++r){var n=t.am(r,t[r],e,2*r,0,1);(e[r+t.t]+=t.am(r+1,2*t[r],e,2*r+1,n,t.t-r-1))>=t.DV&&(e[r+t.t]-=t.DV,e[r+t.t+1]=1)}e.t>0&&(e[e.t-1]+=t.am(r,t[r],e,2*r,0,1)),e.s=0,e.clamp()},BigInteger.prototype.divRemTo=function bnpDivRemTo(e,t,r){var n=e.abs();if(!(n.t<=0)){var i=this.abs();if(i.t<n.t)return null!=t&&t.fromInt(0),void(null!=r&&this.copyTo(r));null==r&&(r=nbi());var o=nbi(),s=this.s,a=e.s,u=this.DB-nbits(n[n.t-1]);u>0?(n.lShiftTo(u,o),i.lShiftTo(u,r)):(n.copyTo(o),i.copyTo(r));var c=o.t,h=o[c-1];if(0!=h){var l=h*(1<<this.F1)+(c>1?o[c-2]>>this.F2:0),f=this.FV/l,g=(1<<this.F1)/l,p=1<<this.F2,d=r.t,v=d-c,y=null==t?nbi():t;for(o.dlShiftTo(v,y),r.compareTo(y)>=0&&(r[r.t++]=1,r.subTo(y,r)),BigInteger.ONE.dlShiftTo(c,y),y.subTo(o,o);o.t<c;)o[o.t++]=0;for(;--v>=0;){var m=r[--d]==h?this.DM:Math.floor(r[d]*f+(r[d-1]+p)*g);if((r[d]+=o.am(0,m,r,v,0,c))<m)for(o.dlShiftTo(v,y),r.subTo(y,r);r[d]<--m;)r.subTo(y,r)}null!=t&&(r.drShiftTo(c,t),s!=a&&BigInteger.ZERO.subTo(t,t)),r.t=c,r.clamp(),u>0&&r.rShiftTo(u,r),s<0&&BigInteger.ZERO.subTo(r,r)}}},BigInteger.prototype.invDigit=function bnpInvDigit(){if(this.t<1)return 0;var e=this[0];if(0==(1&e))return 0;var t=3&e;return(t=(t=(t=(t=t*(2-(15&e)*t)&15)*(2-(255&e)*t)&255)*(2-((65535&e)*t&65535))&65535)*(2-e*t%this.DV)%this.DV)>0?this.DV-t:-t},BigInteger.prototype.isEven=function bnpIsEven(){return 0==(this.t>0?1&this[0]:this.s)},BigInteger.prototype.exp=function bnpExp(e,t){if(e>4294967295||e<1)return BigInteger.ONE;var r=nbi(),n=nbi(),i=t.convert(this),o=nbits(e)-1;for(i.copyTo(r);--o>=0;)if(t.sqrTo(r,n),(e&1<<o)>0)t.mulTo(n,i,r);else{var s=r;r=n,n=s}return t.revert(r)},BigInteger.prototype.toString=function bnToString(e){if(this.s<0)return"-"+this.negate().toString(e);var t;if(16==e)t=4;else if(8==e)t=3;else if(2==e)t=1;else if(32==e)t=5;else{if(4!=e)return this.toRadix(e);t=2}var r,n=(1<<t)-1,i=!1,o="",s=this.t,a=this.DB-s*this.DB%t;if(s-- >0)for(a<this.DB&&(r=this[s]>>a)>0&&(i=!0,o=int2char(r));s>=0;)a<t?(r=(this[s]&(1<<a)-1)<<t-a,r|=this[--s]>>(a+=this.DB-t)):(r=this[s]>>(a-=t)&n,a<=0&&(a+=this.DB,--s)),r>0&&(i=!0),i&&(o+=int2char(r));return i?o:"0"},BigInteger.prototype.negate=function bnNegate(){var e=nbi();return BigInteger.ZERO.subTo(this,e),e},BigInteger.prototype.abs=function bnAbs(){return this.s<0?this.negate():this},BigInteger.prototype.compareTo=function bnCompareTo(e){var t=this.s-e.s;if(0!=t)return t;var r=this.t;if(0!=(t=r-e.t))return this.s<0?-t:t;for(;--r>=0;)if(0!=(t=this[r]-e[r]))return t;return 0},BigInteger.prototype.bitLength=function bnBitLength(){return this.t<=0?0:this.DB*(this.t-1)+nbits(this[this.t-1]^this.s&this.DM)},BigInteger.prototype.mod=function bnMod(e){var t=nbi();return this.abs().divRemTo(e,null,t),this.s<0&&t.compareTo(BigInteger.ZERO)>0&&e.subTo(t,t),t},BigInteger.prototype.modPowInt=function bnModPowInt(e,t){var r;return r=e<256||t.isEven()?new Classic(t):new Montgomery(t),this.exp(e,r)},BigInteger.ZERO=nbv(0),BigInteger.ONE=nbv(1),NullExp.prototype.convert=nNop,NullExp.prototype.revert=nNop,NullExp.prototype.mulTo=function nMulTo(e,t,r){e.multiplyTo(t,r)},NullExp.prototype.sqrTo=function nSqrTo(e,t){e.squareTo(t)},Barrett.prototype.convert=function barrettConvert(e){if(e.s<0||e.t>2*this.m.t)return e.mod(this.m);if(e.compareTo(this.m)<0)return e;var t=nbi();return e.copyTo(t),this.reduce(t),t},Barrett.prototype.revert=function barrettRevert(e){return e},Barrett.prototype.reduce=function barrettReduce(e){for(e.drShiftTo(this.m.t-1,this.r2),e.t>this.m.t+1&&(e.t=this.m.t+1,e.clamp()),this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3),this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);e.compareTo(this.r2)<0;)e.dAddOffset(1,this.m.t+1);for(e.subTo(this.r2,e);e.compareTo(this.m)>=0;)e.subTo(this.m,e)},Barrett.prototype.mulTo=function barrettMulTo(e,t,r){e.multiplyTo(t,r),this.reduce(r)},Barrett.prototype.sqrTo=function barrettSqrTo(e,t){e.squareTo(t),this.reduce(t)};var I=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997],R=(1<<26)/I[I.length-1];
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function Arcfour(){this.i=0,this.j=0,this.S=new Array}BigInteger.prototype.chunkSize=function bnpChunkSize(e){return Math.floor(Math.LN2*this.DB/Math.log(e))},BigInteger.prototype.toRadix=function bnpToRadix(e){if(null==e&&(e=10),0==this.signum()||e<2||e>36)return"0";var t=this.chunkSize(e),r=Math.pow(e,t),n=nbv(r),i=nbi(),o=nbi(),s="";for(this.divRemTo(n,i,o);i.signum()>0;)s=(r+o.intValue()).toString(e).substr(1)+s,i.divRemTo(n,i,o);return o.intValue().toString(e)+s},BigInteger.prototype.fromRadix=function bnpFromRadix(e,t){this.fromInt(0),null==t&&(t=10);for(var r=this.chunkSize(t),n=Math.pow(t,r),i=!1,o=0,s=0,a=0;a<e.length;++a){var u=intAt(e,a);u<0?"-"==e.charAt(a)&&0==this.signum()&&(i=!0):(s=t*s+u,++o>=r&&(this.dMultiply(n),this.dAddOffset(s,0),o=0,s=0))}o>0&&(this.dMultiply(Math.pow(t,o)),this.dAddOffset(s,0)),i&&BigInteger.ZERO.subTo(this,this)},BigInteger.prototype.fromNumber=function bnpFromNumber(e,t,r){if("number"==typeof t)if(e<2)this.fromInt(1);else for(this.fromNumber(e,r),this.testBit(e-1)||this.bitwiseTo(BigInteger.ONE.shiftLeft(e-1),op_or,this),this.isEven()&&this.dAddOffset(1,0);!this.isProbablePrime(t);)this.dAddOffset(2,0),this.bitLength()>e&&this.subTo(BigInteger.ONE.shiftLeft(e-1),this);else{var n=new Array,i=7&e;n.length=1+(e>>3),t.nextBytes(n),i>0?n[0]&=(1<<i)-1:n[0]=0,this.fromString(n,256)}},BigInteger.prototype.bitwiseTo=function bnpBitwiseTo(e,t,r){var n,i,o=Math.min(e.t,this.t);for(n=0;n<o;++n)r[n]=t(this[n],e[n]);if(e.t<this.t){for(i=e.s&this.DM,n=o;n<this.t;++n)r[n]=t(this[n],i);r.t=this.t}else{for(i=this.s&this.DM,n=o;n<e.t;++n)r[n]=t(i,e[n]);r.t=e.t}r.s=t(this.s,e.s),r.clamp()},BigInteger.prototype.changeBit=function bnpChangeBit(e,t){var r=BigInteger.ONE.shiftLeft(e);return this.bitwiseTo(r,t,r),r},BigInteger.prototype.addTo=function bnpAddTo(e,t){for(var r=0,n=0,i=Math.min(e.t,this.t);r<i;)n+=this[r]+e[r],t[r++]=n&this.DM,n>>=this.DB;if(e.t<this.t){for(n+=e.s;r<this.t;)n+=this[r],t[r++]=n&this.DM,n>>=this.DB;n+=this.s}else{for(n+=this.s;r<e.t;)n+=e[r],t[r++]=n&this.DM,n>>=this.DB;n+=e.s}t.s=n<0?-1:0,n>0?t[r++]=n:n<-1&&(t[r++]=this.DV+n),t.t=r,t.clamp()},BigInteger.prototype.dMultiply=function bnpDMultiply(e){this[this.t]=this.am(0,e-1,this,0,0,this.t),++this.t,this.clamp()},BigInteger.prototype.dAddOffset=function bnpDAddOffset(e,t){if(0!=e){for(;this.t<=t;)this[this.t++]=0;for(this[t]+=e;this[t]>=this.DV;)this[t]-=this.DV,++t>=this.t&&(this[this.t++]=0),++this[t]}},BigInteger.prototype.multiplyLowerTo=function bnpMultiplyLowerTo(e,t,r){var n,i=Math.min(this.t+e.t,t);for(r.s=0,r.t=i;i>0;)r[--i]=0;for(n=r.t-this.t;i<n;++i)r[i+this.t]=this.am(0,e[i],r,i,0,this.t);for(n=Math.min(e.t,t);i<n;++i)this.am(0,e[i],r,i,0,t-i);r.clamp()},BigInteger.prototype.multiplyUpperTo=function bnpMultiplyUpperTo(e,t,r){--t;var n=r.t=this.t+e.t-t;for(r.s=0;--n>=0;)r[n]=0;for(n=Math.max(t-this.t,0);n<e.t;++n)r[this.t+n-t]=this.am(t-n,e[n],r,0,0,this.t+n-t);r.clamp(),r.drShiftTo(1,r)},BigInteger.prototype.modInt=function bnpModInt(e){if(e<=0)return 0;var t=this.DV%e,r=this.s<0?e-1:0;if(this.t>0)if(0==t)r=this[0]%e;else for(var n=this.t-1;n>=0;--n)r=(t*r+this[n])%e;return r},BigInteger.prototype.millerRabin=function bnpMillerRabin(e){var t=this.subtract(BigInteger.ONE),r=t.getLowestSetBit();if(r<=0)return!1;var n=t.shiftRight(r);(e=e+1>>1)>I.length&&(e=I.length);for(var i=nbi(),o=0;o<e;++o){i.fromInt(I[Math.floor(Math.random()*I.length)]);var s=i.modPow(n,this);if(0!=s.compareTo(BigInteger.ONE)&&0!=s.compareTo(t)){for(var a=1;a++<r&&0!=s.compareTo(t);)if(0==(s=s.modPowInt(2,this)).compareTo(BigInteger.ONE))return!1;if(0!=s.compareTo(t))return!1}}return!0},BigInteger.prototype.clone=
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function bnClone(){var e=nbi();return this.copyTo(e),e},BigInteger.prototype.intValue=function bnIntValue(){if(this.s<0){if(1==this.t)return this[0]-this.DV;if(0==this.t)return-1}else{if(1==this.t)return this[0];if(0==this.t)return 0}return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0]},BigInteger.prototype.byteValue=function bnByteValue(){return 0==this.t?this.s:this[0]<<24>>24},BigInteger.prototype.shortValue=function bnShortValue(){return 0==this.t?this.s:this[0]<<16>>16},BigInteger.prototype.signum=function bnSigNum(){return this.s<0?-1:this.t<=0||1==this.t&&this[0]<=0?0:1},BigInteger.prototype.toByteArray=function bnToByteArray(){var e=this.t,t=new Array;t[0]=this.s;var r,n=this.DB-e*this.DB%8,i=0;if(e-- >0)for(n<this.DB&&(r=this[e]>>n)!=(this.s&this.DM)>>n&&(t[i++]=r|this.s<<this.DB-n);e>=0;)n<8?(r=(this[e]&(1<<n)-1)<<8-n,r|=this[--e]>>(n+=this.DB-8)):(r=this[e]>>(n-=8)&255,n<=0&&(n+=this.DB,--e)),0!=(128&r)&&(r|=-256),0==i&&(128&this.s)!=(128&r)&&++i,(i>0||r!=this.s)&&(t[i++]=r);return t},BigInteger.prototype.equals=function bnEquals(e){return 0==this.compareTo(e)},BigInteger.prototype.min=function bnMin(e){return this.compareTo(e)<0?this:e},BigInteger.prototype.max=function bnMax(e){return this.compareTo(e)>0?this:e},BigInteger.prototype.and=function bnAnd(e){var t=nbi();return this.bitwiseTo(e,op_and,t),t},BigInteger.prototype.or=function bnOr(e){var t=nbi();return this.bitwiseTo(e,op_or,t),t},BigInteger.prototype.xor=function bnXor(e){var t=nbi();return this.bitwiseTo(e,op_xor,t),t},BigInteger.prototype.andNot=function bnAndNot(e){var t=nbi();return this.bitwiseTo(e,op_andnot,t),t},BigInteger.prototype.not=function bnNot(){for(var e=nbi(),t=0;t<this.t;++t)e[t]=this.DM&~this[t];return e.t=this.t,e.s=~this.s,e},BigInteger.prototype.shiftLeft=function bnShiftLeft(e){var t=nbi();return e<0?this.rShiftTo(-e,t):this.lShiftTo(e,t),t},BigInteger.prototype.shiftRight=function bnShiftRight(e){var t=nbi();return e<0?this.lShiftTo(-e,t):this.rShiftTo(e,t),t},BigInteger.prototype.getLowestSetBit=function bnGetLowestSetBit(){for(var e=0;e<this.t;++e)if(0!=this[e])return e*this.DB+lbit(this[e]);return this.s<0?this.t*this.DB:-1},BigInteger.prototype.bitCount=function bnBitCount(){for(var e=0,t=this.s&this.DM,r=0;r<this.t;++r)e+=cbit(this[r]^t);return e},BigInteger.prototype.testBit=function bnTestBit(e){var t=Math.floor(e/this.DB);return t>=this.t?0!=this.s:0!=(this[t]&1<<e%this.DB)},BigInteger.prototype.setBit=function bnSetBit(e){return this.changeBit(e,op_or)},BigInteger.prototype.clearBit=function bnClearBit(e){return this.changeBit(e,op_andnot)},BigInteger.prototype.flipBit=function bnFlipBit(e){return this.changeBit(e,op_xor)},BigInteger.prototype.add=function bnAdd(e){var t=nbi();return this.addTo(e,t),t},BigInteger.prototype.subtract=function bnSubtract(e){var t=nbi();return this.subTo(e,t),t},BigInteger.prototype.multiply=function bnMultiply(e){var t=nbi();return this.multiplyTo(e,t),t},BigInteger.prototype.divide=function bnDivide(e){var t=nbi();return this.divRemTo(e,t,null),t},BigInteger.prototype.remainder=function bnRemainder(e){var t=nbi();return this.divRemTo(e,null,t),t},BigInteger.prototype.divideAndRemainder=function bnDivideAndRemainder(e){var t=nbi(),r=nbi();return this.divRemTo(e,t,r),new Array(t,r)},BigInteger.prototype.modPow=function bnModPow(e,t){var r,n,i=e.bitLength(),o=nbv(1);if(i<=0)return o;r=i<18?1:i<48?3:i<144?4:i<768?5:6,n=i<8?new Classic(t):t.isEven()?new Barrett(t):new Montgomery(t);var s=new Array,a=3,u=r-1,c=(1<<r)-1;if(s[1]=n.convert(this),r>1){var h=nbi();for(n.sqrTo(s[1],h);a<=c;)s[a]=nbi(),n.mulTo(h,s[a-2],s[a]),a+=2}var l,f,g=e.t-1,p=!0,d=nbi();for(i=nbits(e[g])-1;g>=0;){for(i>=u?l=e[g]>>i-u&c:(l=(e[g]&(1<<i+1)-1)<<u-i,g>0&&(l|=e[g-1]>>this.DB+i-u)),a=r;0==(1&l);)l>>=1,--a;if((i-=a)<0&&(i+=this.DB,--g),p)s[l].copyTo(o),p=!1;else{for(;a>1;)n.sqrTo(o,d),n.sqrTo(d,o),a-=2;a>0?n.sqrTo(o,d):(f=o,o=d,d=f),n.mulTo(d,s[l],o)}for(;g>=0&&0==(e[g]&1<<i);)n.sqrTo(o,d),f=o,o=d,d=f,--i<0&&(i=this.DB-1,--g)}return n.revert(o)},BigInteger.prototype.modInverse=function bnModInverse(e){var t=e.isEven();if(this.isEven()&&t||0==e.signum())return BigInteger.ZERO;for(var r=e.clone(),n=this.clone(),i=nbv(1),o=nbv(0),s=nbv(0),a=nbv(1);0!=r.signum();){for(;r.isEven();)r.rShiftTo(1,r),t?(i.isEven()&&o.isEven()||(i.addTo(this,i),o.subTo(e,o)),i.rShiftTo(1,i)):o.isEven()||o.subTo(e,o),o.rShiftTo(1,o);for(;n.isEven();)n.rShiftTo(1,n),t?(s.isEven()&&a.isEven()||(s.addTo(this,s),a.subTo(e,a)),s.rShiftTo(1,s)):a.isEven()||a.subTo(e,a),a.rShiftTo(1,a);r.compareTo(n)>=0?(r.subTo(n,r),t&&i.subTo(s,i),o.subTo(a,o)):(n.subTo(r,n),t&&s.subTo(i,s),a.subTo(o,a))}return 0!=n.compareTo(BigInteger.ONE)?BigInteger.ZERO:a.compareTo(e)>=0?a.subtract(e):a.signum()<0?(a.addTo(e,a),a.signum()<0?a.add(e):a):a},BigInteger.prototype.pow=function bnPow(e){return this.exp(e,new NullExp)},BigInteger.prototype.gcd=function bnGCD(e){var t=this.s<0?this.negate():this.clone(),r=e.s<0?e.negate():e.clone();if(t.compareTo(r)<0){var n=t;t=r,r=n}var i=t.getLowestSetBit(),o=r.getLowestSetBit();if(o<0)return t;for(i<o&&(o=i),o>0&&(t.rShiftTo(o,t),r.rShiftTo(o,r));t.signum()>0;)(i=t.getLowestSetBit())>0&&t.rShiftTo(i,t),(i=r.getLowestSetBit())>0&&r.rShiftTo(i,r),t.compareTo(r)>=0?(t.subTo(r,t),t.rShiftTo(1,t)):(r.subTo(t,r),r.rShiftTo(1,r));return o>0&&r.lShiftTo(o,r),r},BigInteger.prototype.isProbablePrime=function bnIsProbablePrime(e){var t,r=this.abs();if(1==r.t&&r[0]<=I[I.length-1]){for(t=0;t<I.length;++t)if(r[0]==I[t])return!0;return!1}if(r.isEven())return!1;for(t=1;t<I.length;){for(var n=I[t],i=t+1;i<I.length&&n<R;)n*=I[i++];for(n=r.modInt(n);t<i;)if(n%I[t++]==0)return!1}return r.millerRabin(e)},BigInteger.prototype.square=function bnSquare(){var e=nbi();return this.squareTo(e),e},Arcfour.prototype.init=function ARC4init(e){var t,r,n;for(t=0;t<256;++t)this.S[t]=t;for(r=0,t=0;t<256;++t)r=r+this.S[t]+e[t%e.length]&255,n=this.S[t],this.S[t]=this.S[r],this.S[r]=n;this.i=0,this.j=0},Arcfour.prototype.next=function ARC4next(){var e;return this.i=this.i+1&255,this.j=this.j+this.S[this.i]&255,e=this.S[this.i],this.S[this.i]=this.S[this.j],this.S[this.j]=e,this.S[e+this.S[this.i]&255]};var T,U,D,M=256;
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */function rng_seed_time(){!function rng_seed_int(e){U[D++]^=255&e,U[D++]^=e>>8&255,U[D++]^=e>>16&255,U[D++]^=e>>24&255,D>=M&&(D-=M)}((new Date).getTime())}if(null==U){var L;if(U=new Array,D=0,void 0!==p&&(void 0!==p.crypto||void 0!==p.msCrypto)){var N=p.crypto||p.msCrypto;if(N.getRandomValues){var O=new Uint8Array(32);for(N.getRandomValues(O),L=0;L<32;++L)U[D++]=O[L]}else if("Netscape"==u.appName&&u.appVersion<"5"){var H=p.crypto.random(32);for(L=0;L<H.length;++L)U[D++]=255&H.charCodeAt(L)}}for(;D<M;)L=Math.floor(65536*Math.random()),U[D++]=L>>>8,U[D++]=255&L;D=0,rng_seed_time()}function rng_get_byte(){if(null==T){for(rng_seed_time(),(T=function prng_newstate(){return new Arcfour}()).init(U),D=0;D<U.length;++D)U[D]=0;D=0}return T.next()}function SecureRandom(){}
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function parseBigInt(e,t){return new BigInteger(e,t)}function oaep_mgf1_arr(e,t,r){for(var n="",i=0;n.length<t;)n+=r(String.fromCharCode.apply(String,e.concat([(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i]))),i+=1;return n}function RSAKey(){this.n=null,this.e=0,this.d=null,this.p=null,this.q=null,this.dmp1=null,this.dmq1=null,this.coeff=null}
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function ECFieldElementFp(e,t){this.x=t,this.q=e}function ECPointFp(e,t,r,n){this.curve=e,this.x=t,this.y=r,this.z=null==n?BigInteger.ONE:n,this.zinv=null}function ECCurveFp(e,t,r){this.q=e,this.a=this.fromBigInteger(t),this.b=this.fromBigInteger(r),this.infinity=new ECPointFp(this,null,null)}SecureRandom.prototype.nextBytes=function rng_get_bytes(e){var t;for(t=0;t<e.length;++t)e[t]=rng_get_byte()},RSAKey.prototype.doPublic=function RSADoPublic(e){return e.modPowInt(this.e,this.n)},RSAKey.prototype.setPublic=function RSASetPublic(e,t){if(this.isPublic=!0,this.isPrivate=!1,"string"!=typeof e)this.n=e,this.e=t;else{if(!(null!=e&&null!=t&&e.length>0&&t.length>0))throw"Invalid RSA public key";this.n=parseBigInt(e,16),this.e=parseInt(t,16)}},RSAKey.prototype.encrypt=function RSAEncrypt(e){var t=function pkcs1pad2(e,t){if(t<e.length+11)throw"Message too long for RSA";for(var r=new Array,n=e.length-1;n>=0&&t>0;){var i=e.charCodeAt(n--);i<128?r[--t]=i:i>127&&i<2048?(r[--t]=63&i|128,r[--t]=i>>6|192):(r[--t]=63&i|128,r[--t]=i>>6&63|128,r[--t]=i>>12|224)}r[--t]=0;for(var o=new SecureRandom,s=new Array;t>2;){for(s[0]=0;0==s[0];)o.nextBytes(s);r[--t]=s[0]}return r[--t]=2,r[--t]=0,new BigInteger(r)}(e,this.n.bitLength()+7>>3);if(null==t)return null;var r=this.doPublic(t);if(null==r)return null;var n=r.toString(16);return 0==(1&n.length)?n:"0"+n},RSAKey.prototype.encryptOAEP=function RSAEncryptOAEP(e,t,r){var n=function oaep_pad(e,t,r,n){var i=V.crypto.MessageDigest,o=V.crypto.Util,s=null;if(r||(r="sha1"),"string"==typeof r&&(s=i.getCanonicalAlgName(r),n=i.getHashLength(s),r=function f(e){return hextorstr(o.hashHex(rstrtohex(e),s))}),e.length+2*n+2>t)throw"Message too long for RSA";var a,u="";for(a=0;a<t-e.length-2*n-2;a+=1)u+="\0";var c=r("")+u+""+e,h=new Array(n);(new SecureRandom).nextBytes(h);var l=oaep_mgf1_arr(h,c.length,r),g=[];for(a=0;a<c.length;a+=1)g[a]=c.charCodeAt(a)^l.charCodeAt(a);var p=oaep_mgf1_arr(g,h.length,r),d=[0];for(a=0;a<h.length;a+=1)d[a+1]=h[a]^p.charCodeAt(a);return new BigInteger(d.concat(g))}(e,this.n.bitLength()+7>>3,t,r);if(null==n)return null;var i=this.doPublic(n);if(null==i)return null;var o=i.toString(16);return 0==(1&o.length)?o:"0"+o},RSAKey.prototype.type="RSA",ECFieldElementFp.prototype.equals=function feFpEquals(e){return e==this||this.q.equals(e.q)&&this.x.equals(e.x)},ECFieldElementFp.prototype.toBigInteger=function feFpToBigInteger(){return this.x},ECFieldElementFp.prototype.negate=function feFpNegate(){return new ECFieldElementFp(this.q,this.x.negate().mod(this.q))},ECFieldElementFp.prototype.add=function feFpAdd(e){return new ECFieldElementFp(this.q,this.x.add(e.toBigInteger()).mod(this.q))},ECFieldElementFp.prototype.subtract=function feFpSubtract(e){return new ECFieldElementFp(this.q,this.x.subtract(e.toBigInteger()).mod(this.q))},ECFieldElementFp.prototype.multiply=function feFpMultiply(e){return new ECFieldElementFp(this.q,this.x.multiply(e.toBigInteger()).mod(this.q))},ECFieldElementFp.prototype.square=function feFpSquare(){return new ECFieldElementFp(this.q,this.x.square().mod(this.q))},ECFieldElementFp.prototype.divide=function feFpDivide(e){return new ECFieldElementFp(this.q,this.x.multiply(e.toBigInteger().modInverse(this.q)).mod(this.q))},ECPointFp.prototype.getX=function pointFpGetX(){return null==this.zinv&&(this.zinv=this.z.modInverse(this.curve.q)),this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q))},ECPointFp.prototype.getY=function pointFpGetY(){return null==this.zinv&&(this.zinv=this.z.modInverse(this.curve.q)),this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q))},ECPointFp.prototype.equals=function pointFpEquals(e){return e==this||(this.isInfinity()?e.isInfinity():e.isInfinity()?this.isInfinity():!!e.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(e.z)).mod(this.curve.q).equals(BigInteger.ZERO)&&e.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(e.z)).mod(this.curve.q).equals(BigInteger.ZERO))},ECPointFp.prototype.isInfinity=function pointFpIsInfinity(){return null==this.x&&null==this.y||this.z.equals(BigInteger.ZERO)&&!this.y.toBigInteger().equals(BigInteger.ZERO)},ECPointFp.prototype.negate=function pointFpNegate(){return new ECPointFp(this.curve,this.x,this.y.negate(),this.z)},ECPointFp.prototype.add=function pointFpAdd(e){if(this.isInfinity())return e;if(e.isInfinity())return this;var t=e.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(e.z)).mod(this.curve.q),r=e.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(e.z)).mod(this.curve.q);if(BigInteger.ZERO.equals(r))return BigInteger.ZERO.equals(t)?this.twice():this.curve.getInfinity();var n=new BigInteger("3"),i=this.x.toBigInteger(),o=this.y.toBigInteger(),s=(e.x.toBigInteger(),e.y.toBigInteger(),r.square()),a=s.multiply(r),u=i.multiply(s),c=t.square().multiply(this.z),h=c.subtract(u.shiftLeft(1)).multiply(e.z).subtract(a).multiply(r).mod(this.curve.q),l=u.multiply(n).multiply(t).subtract(o.multiply(a)).subtract(c.multiply(t)).multiply(e.z).add(t.multiply(a)).mod(this.curve.q),f=a.multiply(this.z).multiply(e.z).mod(this.curve.q);return new ECPointFp(this.curve,this.curve.fromBigInteger(h),this.curve.fromBigInteger(l),f)},ECPointFp.prototype.twice=function pointFpTwice(){if(this.isInfinity())return this;if(0==this.y.toBigInteger().signum())return this.curve.getInfinity();var e=new BigInteger("3"),t=this.x.toBigInteger(),r=this.y.toBigInteger(),n=r.multiply(this.z),i=n.multiply(r).mod(this.curve.q),o=this.curve.a.toBigInteger(),s=t.square().multiply(e);BigInteger.ZERO.equals(o)||(s=s.add(this.z.square().multiply(o)));var a=(s=s.mod(this.curve.q)).square().subtract(t.shiftLeft(3).multiply(i)).shiftLeft(1).multiply(n).mod(this.curve.q),u=s.multiply(e).multiply(t).subtract(i.shiftLeft(1)).shiftLeft(2).multiply(i).subtract(s.square().multiply(s)).mod(this.curve.q),c=n.square().multiply(n).shiftLeft(3).mod(this.curve.q);return new ECPointFp(this.curve,this.curve.fromBigInteger(a),this.curve.fromBigInteger(u),c)},ECPointFp.prototype.multiply=function pointFpMultiply(e){if(this.isInfinity())return this;if(0==e.signum())return this.curve.getInfinity();var t,r=e,n=r.multiply(new BigInteger("3")),i=this.negate(),o=this;for(t=n.bitLength()-2;t>0;--t){o=o.twice();var s=n.testBit(t);s!=r.testBit(t)&&(o=o.add(s?this:i))}return o},ECPointFp.prototype.multiplyTwo=function pointFpMultiplyTwo(e,t,r){var n;n=e.bitLength()>r.bitLength()?e.bitLength()-1:r.bitLength()-1;for(var i=this.curve.getInfinity(),o=this.add(t);n>=0;)i=i.twice(),e.testBit(n)?i=r.testBit(n)?i.add(o):i.add(this):r.testBit(n)&&(i=i.add(t)),--n;return i},ECCurveFp.prototype.getQ=function curveFpGetQ(){return this.q},ECCurveFp.prototype.getA=function curveFpGetA(){return this.a},ECCurveFp.prototype.getB=function curveFpGetB(){return this.b},ECCurveFp.prototype.equals=function curveFpEquals(e){return e==this||this.q.equals(e.q)&&this.a.equals(e.a)&&this.b.equals(e.b)},ECCurveFp.prototype.getInfinity=function curveFpGetInfinity(){return this.infinity},ECCurveFp.prototype.fromBigInteger=function curveFpFromBigInteger(e){return new ECFieldElementFp(this.q,e)},ECCurveFp.prototype.decodePointHex=function curveFpDecodePointHex(e){switch(parseInt(e.substr(0,2),16)){case 0:return this.infinity;case 2:case 3:return null;case 4:case 6:case 7:var t=(e.length-2)/2,r=e.substr(2,t),n=e.substr(t+2,t);return new ECPointFp(this,this.fromBigInteger(new BigInteger(r,16)),this.fromBigInteger(new BigInteger(n,16)));default:return null}},
/*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
 */
ECFieldElementFp.prototype.getByteLength=function(){return Math.floor((this.toBigInteger().bitLength()+7)/8)},ECPointFp.prototype.getEncoded=function(e){var t=function d(e,t){var r=e.toByteArrayUnsigned();if(t<r.length)r=r.slice(r.length-t);else for(;t>r.length;)r.unshift(0);return r},r=this.getX().toBigInteger(),n=this.getY().toBigInteger(),i=t(r,32);return e?n.isEven()?i.unshift(2):i.unshift(3):(i.unshift(4),i=i.concat(t(n,32))),i},ECPointFp.decodeFrom=function(e,t){t[0];var r=t.length-1,n=t.slice(1,1+r/2),i=t.slice(1+r/2,1+r);n.unshift(0),i.unshift(0);var o=new BigInteger(n),s=new BigInteger(i);return new ECPointFp(e,e.fromBigInteger(o),e.fromBigInteger(s))},ECPointFp.decodeFromHex=function(e,t){t.substr(0,2);var r=t.length-2,n=t.substr(2,r/2),i=t.substr(2+r/2,r/2),o=new BigInteger(n,16),s=new BigInteger(i,16);return new ECPointFp(e,e.fromBigInteger(o),e.fromBigInteger(s))},ECPointFp.prototype.add2D=function(e){if(this.isInfinity())return e;if(e.isInfinity())return this;if(this.x.equals(e.x))return this.y.equals(e.y)?this.twice():this.curve.getInfinity();var t=e.x.subtract(this.x),r=e.y.subtract(this.y).divide(t),n=r.square().subtract(this.x).subtract(e.x),i=r.multiply(this.x.subtract(n)).subtract(this.y);return new ECPointFp(this.curve,n,i)},ECPointFp.prototype.twice2D=function(){if(this.isInfinity())return this;if(0==this.y.toBigInteger().signum())return this.curve.getInfinity();var e=this.curve.fromBigInteger(BigInteger.valueOf(2)),t=this.curve.fromBigInteger(BigInteger.valueOf(3)),r=this.x.square().multiply(t).add(this.curve.a).divide(this.y.multiply(e)),n=r.square().subtract(this.x.multiply(e)),i=r.multiply(this.x.subtract(n)).subtract(this.y);return new ECPointFp(this.curve,n,i)},ECPointFp.prototype.multiply2D=function(e){if(this.isInfinity())return this;if(0==e.signum())return this.curve.getInfinity();var t,r=e,n=r.multiply(new BigInteger("3")),i=this.negate(),o=this;for(t=n.bitLength()-2;t>0;--t){o=o.twice();var s=n.testBit(t);s!=r.testBit(t)&&(o=o.add2D(s?this:i))}return o},ECPointFp.prototype.isOnCurve=function(){var e=this.getX().toBigInteger(),t=this.getY().toBigInteger(),r=this.curve.getA().toBigInteger(),n=this.curve.getB().toBigInteger(),i=this.curve.getQ(),o=t.multiply(t).mod(i),s=e.multiply(e).multiply(e).add(r.multiply(e)).add(n).mod(i);return o.equals(s)},ECPointFp.prototype.toString=function(){return"("+this.getX().toBigInteger().toString()+","+this.getY().toBigInteger().toString()+")"},ECPointFp.prototype.validate=function(){var e=this.curve.getQ();if(this.isInfinity())throw new Error("Point is at infinity.");var t=this.getX().toBigInteger(),r=this.getY().toBigInteger();if(t.compareTo(BigInteger.ONE)<0||t.compareTo(e.subtract(BigInteger.ONE))>0)throw new Error("x coordinate out of bounds");if(r.compareTo(BigInteger.ONE)<0||r.compareTo(e.subtract(BigInteger.ONE))>0)throw new Error("y coordinate out of bounds");if(!this.isOnCurve())throw new Error("Point is not on the curve.");if(this.multiply(e).isInfinity())throw new Error("Point is not a scalar multiple of G.");return!0};
/*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
 */
var K=function(){var e=new RegExp('(?:false|true|null|[\\{\\}\\[\\]]|(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)|(?:"(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))*"))',"g"),t=new RegExp("\\\\(?:([^u])|u(.{4}))","g"),r={'"':'"',"/":"/","\\":"\\",b:"\b",f:"\f",n:"\n",r:"\r",t:"\t"};function h(e,t,n){return t?r[t]:String.fromCharCode(parseInt(n,16))}var n=new String(""),o=(Object,Array,Object.hasOwnProperty);return function(r,a){var u,c,l=r.match(e),f=l[0],g=!1;"{"===f?u={}:"["===f?u=[]:(u=[],g=!0);for(var p=[u],d=1-g,v=l.length;d<v;++d){var y;switch((f=l[d]).charCodeAt(0)){default:(y=p[0])[c||y.length]=+f,c=void 0;break;case 34:if(-1!==(f=f.substring(1,f.length-1)).indexOf("\\")&&(f=f.replace(t,h)),y=p[0],!c){if(!(y instanceof Array)){c=f||n;break}c=y.length}y[c]=f,c=void 0;break;case 91:y=p[0],p.unshift(y[c||y.length]=[]),c=void 0;break;case 93:p.shift();break;case 102:(y=p[0])[c||y.length]=!1,c=void 0;break;case 110:(y=p[0])[c||y.length]=null,c=void 0;break;case 116:(y=p[0])[c||y.length]=!0,c=void 0;break;case 123:y=p[0],p.unshift(y[c||y.length]={}),c=void 0;break;case 125:p.shift()}}if(g){if(1!==p.length)throw new Error;u=u[0]}else if(p.length)throw new Error;if(a){u=function s(e,t){var r=e[t];if(r&&"object"===(void 0===r?"undefined":i(r))){var n=null;for(var u in r)if(o.call(r,u)&&r!==e){var c=s(r,u);void 0!==c?r[u]=c:(n||(n=[]),n.push(u))}if(n)for(var h=n.length;--h>=0;)delete r[n[h]]}return a.call(e,t,r)}({"":u},"")}return u}}();void 0!==V&&V||(t.KJUR=V={}),void 0!==V.asn1&&V.asn1||(V.asn1={}),V.asn1.ASN1Util=new function(){this.integerToByteHex=function(e){var t=e.toString(16);return t.length%2==1&&(t="0"+t),t},this.bigIntToMinTwosComplementsHex=function(e){var t=e.toString(16);if("-"!=t.substr(0,1))t.length%2==1?t="0"+t:t.match(/^[0-7]/)||(t="00"+t);else{var r=t.substr(1).length;r%2==1?r+=1:t.match(/^[0-7]/)||(r+=2);for(var n="",i=0;i<r;i++)n+="f";t=new BigInteger(n,16).xor(e).add(BigInteger.ONE).toString(16).replace(/^-/,"")}return t},this.getPEMStringFromHex=function(e,t){return hextopem(e,t)},this.newObject=function(e){var t=V.asn1,r=t.DERBoolean,n=t.DERInteger,i=t.DERBitString,o=t.DEROctetString,s=t.DERNull,a=t.DERObjectIdentifier,u=t.DEREnumerated,c=t.DERUTF8String,h=t.DERNumericString,l=t.DERPrintableString,f=t.DERTeletexString,g=t.DERIA5String,p=t.DERUTCTime,d=t.DERGeneralizedTime,v=t.DERSequence,y=t.DERSet,m=t.DERTaggedObject,_=t.ASN1Util.newObject,S=Object.keys(e);if(1!=S.length)throw"key of param shall be only one.";var b=S[0];if(-1==":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":"+b+":"))throw"undefined key: "+b;if("bool"==b)return new r(e[b]);if("int"==b)return new n(e[b]);if("bitstr"==b)return new i(e[b]);if("octstr"==b)return new o(e[b]);if("null"==b)return new s(e[b]);if("oid"==b)return new a(e[b]);if("enum"==b)return new u(e[b]);if("utf8str"==b)return new c(e[b]);if("numstr"==b)return new h(e[b]);if("prnstr"==b)return new l(e[b]);if("telstr"==b)return new f(e[b]);if("ia5str"==b)return new g(e[b]);if("utctime"==b)return new p(e[b]);if("gentime"==b)return new d(e[b]);if("seq"==b){for(var F=e[b],w=[],E=0;E<F.length;E++){var x=_(F[E]);w.push(x)}return new v({array:w})}if("set"==b){for(F=e[b],w=[],E=0;E<F.length;E++){x=_(F[E]);w.push(x)}return new y({array:w})}if("tag"==b){var C=e[b];if("[object Array]"===Object.prototype.toString.call(C)&&3==C.length){var k=_(C[2]);return new m({tag:C[0],explicit:C[1],obj:k})}var A={};if(void 0!==C.explicit&&(A.explicit=C.explicit),void 0!==C.tag&&(A.tag=C.tag),void 0===C.obj)throw"obj shall be specified for 'tag'.";return A.obj=_(C.obj),new m(A)}},this.jsonToASN1HEX=function(e){return this.newObject(e).getEncodedHex()}},V.asn1.ASN1Util.oidHexToInt=function(e){for(var t="",r=parseInt(e.substr(0,2),16),n=(t=Math.floor(r/40)+"."+r%40,""),i=2;i<e.length;i+=2){var o=("00000000"+parseInt(e.substr(i,2),16).toString(2)).slice(-8);if(n+=o.substr(1,7),"0"==o.substr(0,1))t=t+"."+new BigInteger(n,2).toString(10),n=""}return t},V.asn1.ASN1Util.oidIntToHex=function(e){var t=function e(t){var r=t.toString(16);return 1==r.length&&(r="0"+r),r},r=function d(e){var r="",n=new BigInteger(e,10).toString(2),i=7-n.length%7;7==i&&(i=0);for(var o="",s=0;s<i;s++)o+="0";n=o+n;for(s=0;s<n.length-1;s+=7){var a=n.substr(s,7);s!=n.length-7&&(a="1"+a),r+=t(parseInt(a,2))}return r};if(!e.match(/^[0-9.]+$/))throw"malformed oid string: "+e;var n="",i=e.split("."),o=40*parseInt(i[0])+parseInt(i[1]);n+=t(o),i.splice(0,2);for(var s=0;s<i.length;s++)n+=r(i[s]);return n},V.asn1.ASN1Object=function(){this.getLengthHexFromValue=function(){if(void 0===this.hV||null==this.hV)throw"this.hV is null or undefined.";if(this.hV.length%2==1)throw"value hex must be even length: n="+"".length+",v="+this.hV;var e=this.hV.length/2,t=e.toString(16);if(t.length%2==1&&(t="0"+t),e<128)return t;var r=t.length/2;if(r>15)throw"ASN.1 length too long to represent by 8x: n = "+e.toString(16);return(128+r).toString(16)+t},this.getEncodedHex=function(){return(null==this.hTLV||this.isModified)&&(this.hV=this.getFreshValueHex(),this.hL=this.getLengthHexFromValue(),this.hTLV=this.hT+this.hL+this.hV,this.isModified=!1),this.hTLV},this.getValueHex=function(){return this.getEncodedHex(),this.hV},this.getFreshValueHex=function(){return""}},V.asn1.DERAbstractString=function(e){V.asn1.DERAbstractString.superclass.constructor.call(this);this.getString=function(){return this.s},this.setString=function(e){this.hTLV=null,this.isModified=!0,this.s=e,this.hV=utf8tohex(this.s).toLowerCase()},this.setStringHex=function(e){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=e},this.getFreshValueHex=function(){return this.hV},void 0!==e&&("string"==typeof e?this.setString(e):void 0!==e.str?this.setString(e.str):void 0!==e.hex&&this.setStringHex(e.hex))},v.lang.extend(V.asn1.DERAbstractString,V.asn1.ASN1Object),V.asn1.DERAbstractTime=function(e){V.asn1.DERAbstractTime.superclass.constructor.call(this);this.localDateToUTC=function(e){return utc=e.getTime()+6e4*e.getTimezoneOffset(),new Date(utc)},this.formatDate=function(e,t,r){var n=this.zeroPadding,i=this.localDateToUTC(e),o=String(i.getFullYear());"utc"==t&&(o=o.substr(2,2));var s=o+n(String(i.getMonth()+1),2)+n(String(i.getDate()),2)+n(String(i.getHours()),2)+n(String(i.getMinutes()),2)+n(String(i.getSeconds()),2);if(!0===r){var a=i.getMilliseconds();if(0!=a){var u=n(String(a),3);s=s+"."+(u=u.replace(/[0]+$/,""))}}return s+"Z"},this.zeroPadding=function(e,t){return e.length>=t?e:new Array(t-e.length+1).join("0")+e},this.getString=function(){return this.s},this.setString=function(e){this.hTLV=null,this.isModified=!0,this.s=e,this.hV=stohex(e)},this.setByDateValue=function(e,t,r,n,i,o){var s=new Date(Date.UTC(e,t-1,r,n,i,o,0));this.setByDate(s)},this.getFreshValueHex=function(){return this.hV}},v.lang.extend(V.asn1.DERAbstractTime,V.asn1.ASN1Object),V.asn1.DERAbstractStructured=function(e){V.asn1.DERAbstractString.superclass.constructor.call(this);this.setByASN1ObjectArray=function(e){this.hTLV=null,this.isModified=!0,this.asn1Array=e},this.appendASN1Object=function(e){this.hTLV=null,this.isModified=!0,this.asn1Array.push(e)},this.asn1Array=new Array,void 0!==e&&void 0!==e.array&&(this.asn1Array=e.array)},v.lang.extend(V.asn1.DERAbstractStructured,V.asn1.ASN1Object),V.asn1.DERBoolean=function(){V.asn1.DERBoolean.superclass.constructor.call(this),this.hT="01",this.hTLV="0101ff"},v.lang.extend(V.asn1.DERBoolean,V.asn1.ASN1Object),V.asn1.DERInteger=function(e){V.asn1.DERInteger.superclass.constructor.call(this),this.hT="02",this.setByBigInteger=function(e){this.hTLV=null,this.isModified=!0,this.hV=V.asn1.ASN1Util.bigIntToMinTwosComplementsHex(e)},this.setByInteger=function(e){var t=new BigInteger(String(e),10);this.setByBigInteger(t)},this.setValueHex=function(e){this.hV=e},this.getFreshValueHex=function(){return this.hV},void 0!==e&&(void 0!==e.bigint?this.setByBigInteger(e.bigint):void 0!==e.int?this.setByInteger(e.int):"number"==typeof e?this.setByInteger(e):void 0!==e.hex&&this.setValueHex(e.hex))},v.lang.extend(V.asn1.DERInteger,V.asn1.ASN1Object),V.asn1.DERBitString=function(e){if(void 0!==e&&void 0!==e.obj){var t=V.asn1.ASN1Util.newObject(e.obj);e.hex="00"+t.getEncodedHex()}V.asn1.DERBitString.superclass.constructor.call(this),this.hT="03",this.setHexValueIncludingUnusedBits=function(e){this.hTLV=null,this.isModified=!0,this.hV=e},this.setUnusedBitsAndHexValue=function(e,t){if(e<0||7<e)throw"unused bits shall be from 0 to 7: u = "+e;var r="0"+e;this.hTLV=null,this.isModified=!0,this.hV=r+t},this.setByBinaryString=function(e){var t=8-(e=e.replace(/0+$/,"")).length%8;8==t&&(t=0);for(var r=0;r<=t;r++)e+="0";var n="";for(r=0;r<e.length-1;r+=8){var i=e.substr(r,8),o=parseInt(i,2).toString(16);1==o.length&&(o="0"+o),n+=o}this.hTLV=null,this.isModified=!0,this.hV="0"+t+n},this.setByBooleanArray=function(e){for(var t="",r=0;r<e.length;r++)1==e[r]?t+="1":t+="0";this.setByBinaryString(t)},this.newFalseArray=function(e){for(var t=new Array(e),r=0;r<e;r++)t[r]=!1;return t},this.getFreshValueHex=function(){return this.hV},void 0!==e&&("string"==typeof e&&e.toLowerCase().match(/^[0-9a-f]+$/)?this.setHexValueIncludingUnusedBits(e):void 0!==e.hex?this.setHexValueIncludingUnusedBits(e.hex):void 0!==e.bin?this.setByBinaryString(e.bin):void 0!==e.array&&this.setByBooleanArray(e.array))},v.lang.extend(V.asn1.DERBitString,V.asn1.ASN1Object),V.asn1.DEROctetString=function(e){if(void 0!==e&&void 0!==e.obj){var t=V.asn1.ASN1Util.newObject(e.obj);e.hex=t.getEncodedHex()}V.asn1.DEROctetString.superclass.constructor.call(this,e),this.hT="04"},v.lang.extend(V.asn1.DEROctetString,V.asn1.DERAbstractString),V.asn1.DERNull=function(){V.asn1.DERNull.superclass.constructor.call(this),this.hT="05",this.hTLV="0500"},v.lang.extend(V.asn1.DERNull,V.asn1.ASN1Object),V.asn1.DERObjectIdentifier=function(e){var t=function b(e){var t=e.toString(16);return 1==t.length&&(t="0"+t),t},r=function a(e){var r="",n=new BigInteger(e,10).toString(2),i=7-n.length%7;7==i&&(i=0);for(var o="",s=0;s<i;s++)o+="0";n=o+n;for(s=0;s<n.length-1;s+=7){var u=n.substr(s,7);s!=n.length-7&&(u="1"+u),r+=t(parseInt(u,2))}return r};V.asn1.DERObjectIdentifier.superclass.constructor.call(this),this.hT="06",this.setValueHex=function(e){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=e},this.setValueOidString=function(e){if(!e.match(/^[0-9.]+$/))throw"malformed oid string: "+e;var n="",i=e.split("."),o=40*parseInt(i[0])+parseInt(i[1]);n+=t(o),i.splice(0,2);for(var s=0;s<i.length;s++)n+=r(i[s]);this.hTLV=null,this.isModified=!0,this.s=null,this.hV=n},this.setValueName=function(e){var t=V.asn1.x509.OID.name2oid(e);if(""===t)throw"DERObjectIdentifier oidName undefined: "+e;this.setValueOidString(t)},this.getFreshValueHex=function(){return this.hV},void 0!==e&&("string"==typeof e?e.match(/^[0-2].[0-9.]+$/)?this.setValueOidString(e):this.setValueName(e):void 0!==e.oid?this.setValueOidString(e.oid):void 0!==e.hex?this.setValueHex(e.hex):void 0!==e.name&&this.setValueName(e.name))},v.lang.extend(V.asn1.DERObjectIdentifier,V.asn1.ASN1Object),V.asn1.DEREnumerated=function(e){V.asn1.DEREnumerated.superclass.constructor.call(this),this.hT="0a",this.setByBigInteger=function(e){this.hTLV=null,this.isModified=!0,this.hV=V.asn1.ASN1Util.bigIntToMinTwosComplementsHex(e)},this.setByInteger=function(e){var t=new BigInteger(String(e),10);this.setByBigInteger(t)},this.setValueHex=function(e){this.hV=e},this.getFreshValueHex=function(){return this.hV},void 0!==e&&(void 0!==e.int?this.setByInteger(e.int):"number"==typeof e?this.setByInteger(e):void 0!==e.hex&&this.setValueHex(e.hex))},v.lang.extend(V.asn1.DEREnumerated,V.asn1.ASN1Object),V.asn1.DERUTF8String=function(e){V.asn1.DERUTF8String.superclass.constructor.call(this,e),this.hT="0c"},v.lang.extend(V.asn1.DERUTF8String,V.asn1.DERAbstractString),V.asn1.DERNumericString=function(e){V.asn1.DERNumericString.superclass.constructor.call(this,e),this.hT="12"},v.lang.extend(V.asn1.DERNumericString,V.asn1.DERAbstractString),V.asn1.DERPrintableString=function(e){V.asn1.DERPrintableString.superclass.constructor.call(this,e),this.hT="13"},v.lang.extend(V.asn1.DERPrintableString,V.asn1.DERAbstractString),V.asn1.DERTeletexString=function(e){V.asn1.DERTeletexString.superclass.constructor.call(this,e),this.hT="14"},v.lang.extend(V.asn1.DERTeletexString,V.asn1.DERAbstractString),V.asn1.DERIA5String=function(e){V.asn1.DERIA5String.superclass.constructor.call(this,e),this.hT="16"},v.lang.extend(V.asn1.DERIA5String,V.asn1.DERAbstractString),V.asn1.DERUTCTime=function(e){V.asn1.DERUTCTime.superclass.constructor.call(this,e),this.hT="17",this.setByDate=function(e){this.hTLV=null,this.isModified=!0,this.date=e,this.s=this.formatDate(this.date,"utc"),this.hV=stohex(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"utc"),this.hV=stohex(this.s)),this.hV},void 0!==e&&(void 0!==e.str?this.setString(e.str):"string"==typeof e&&e.match(/^[0-9]{12}Z$/)?this.setString(e):void 0!==e.hex?this.setStringHex(e.hex):void 0!==e.date&&this.setByDate(e.date))},v.lang.extend(V.asn1.DERUTCTime,V.asn1.DERAbstractTime),V.asn1.DERGeneralizedTime=function(e){V.asn1.DERGeneralizedTime.superclass.constructor.call(this,e),this.hT="18",this.withMillis=!1,this.setByDate=function(e){this.hTLV=null,this.isModified=!0,this.date=e,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=stohex(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=stohex(this.s)),this.hV},void 0!==e&&(void 0!==e.str?this.setString(e.str):"string"==typeof e&&e.match(/^[0-9]{14}Z$/)?this.setString(e):void 0!==e.hex?this.setStringHex(e.hex):void 0!==e.date&&this.setByDate(e.date),!0===e.millis&&(this.withMillis=!0))},v.lang.extend(V.asn1.DERGeneralizedTime,V.asn1.DERAbstractTime),V.asn1.DERSequence=function(e){V.asn1.DERSequence.superclass.constructor.call(this,e),this.hT="30",this.getFreshValueHex=function(){for(var e="",t=0;t<this.asn1Array.length;t++){e+=this.asn1Array[t].getEncodedHex()}return this.hV=e,this.hV}},v.lang.extend(V.asn1.DERSequence,V.asn1.DERAbstractStructured),V.asn1.DERSet=function(e){V.asn1.DERSet.superclass.constructor.call(this,e),this.hT="31",this.sortFlag=!0,this.getFreshValueHex=function(){for(var e=new Array,t=0;t<this.asn1Array.length;t++){var r=this.asn1Array[t];e.push(r.getEncodedHex())}return 1==this.sortFlag&&e.sort(),this.hV=e.join(""),this.hV},void 0!==e&&void 0!==e.sortflag&&0==e.sortflag&&(this.sortFlag=!1)},v.lang.extend(V.asn1.DERSet,V.asn1.DERAbstractStructured),V.asn1.DERTaggedObject=function(e){V.asn1.DERTaggedObject.superclass.constructor.call(this),this.hT="a0",this.hV="",this.isExplicit=!0,this.asn1Object=null,this.setASN1Object=function(e,t,r){this.hT=t,this.isExplicit=e,this.asn1Object=r,this.isExplicit?(this.hV=this.asn1Object.getEncodedHex(),this.hTLV=null,this.isModified=!0):(this.hV=null,this.hTLV=r.getEncodedHex(),this.hTLV=this.hTLV.replace(/^../,t),this.isModified=!1)},this.getFreshValueHex=function(){return this.hV},void 0!==e&&(void 0!==e.tag&&(this.hT=e.tag),void 0!==e.explicit&&(this.isExplicit=e.explicit),void 0!==e.obj&&(this.asn1Object=e.obj,this.setASN1Object(this.isExplicit,this.hT,this.asn1Object)))},v.lang.extend(V.asn1.DERTaggedObject,V.asn1.ASN1Object);var V,q,W,J=new function(){};function stoBA(e){for(var t=new Array,r=0;r<e.length;r++)t[r]=e.charCodeAt(r);return t}function BAtos(e){for(var t="",r=0;r<e.length;r++)t+=String.fromCharCode(e[r]);return t}function BAtohex(e){for(var t="",r=0;r<e.length;r++){var n=e[r].toString(16);1==n.length&&(n="0"+n),t+=n}return t}function stohex(e){return BAtohex(stoBA(e))}function b64tob64u(e){return e=(e=(e=e.replace(/\=/g,"")).replace(/\+/g,"-")).replace(/\//g,"_")}function b64utob64(e){return e.length%4==2?e+="==":e.length%4==3&&(e+="="),e=(e=e.replace(/-/g,"+")).replace(/_/g,"/")}function hextob64u(e){return e.length%2==1&&(e="0"+e),b64tob64u(hex2b64(e))}function b64utohex(e){return b64tohex(b64utob64(e))}function utf8tohex(e){return uricmptohex(encodeURIComponentAll(e))}function hextoutf8(e){return decodeURIComponent(hextouricmp(e))}function hextorstr(e){for(var t="",r=0;r<e.length-1;r+=2)t+=String.fromCharCode(parseInt(e.substr(r,2),16));return t}function rstrtohex(e){for(var t="",r=0;r<e.length;r++)t+=("0"+e.charCodeAt(r).toString(16)).slice(-2);return t}function hextob64(e){return hex2b64(e)}function hextob64nl(e){var t=hextob64(e).replace(/(.{64})/g,"$1\r\n");return t=t.replace(/\r\n$/,"")}function b64nltohex(e){return b64tohex(e.replace(/[^0-9A-Za-z\/+=]*/g,""))}function hextopem(e,t){return"-----BEGIN "+t+"-----\r\n"+hextob64nl(e)+"\r\n-----END "+t+"-----\r\n"}function pemtohex(e,t){if(-1==e.indexOf("-----BEGIN "))throw"can't find PEM header: "+t;return b64nltohex(e=void 0!==t?(e=e.replace("-----BEGIN "+t+"-----","")).replace("-----END "+t+"-----",""):(e=e.replace(/-----BEGIN [^-]+-----/,"")).replace(/-----END [^-]+-----/,""))}function zulutomsec(e){var t,r,n,i,o,s,a,u,c,h,l;if(l=e.match(/^(\d{2}|\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/))return u=l[1],t=parseInt(u),2===u.length&&(50<=t&&t<100?t=1900+t:0<=t&&t<50&&(t=2e3+t)),r=parseInt(l[2])-1,n=parseInt(l[3]),i=parseInt(l[4]),o=parseInt(l[5]),s=parseInt(l[6]),a=0,""!==(c=l[7])&&(h=(c.substr(1)+"00").substr(0,3),a=parseInt(h)),Date.UTC(t,r,n,i,o,s,a);throw"unsupported zulu format: "+e}function zulutosec(e){return~~(zulutomsec(e)/1e3)}function uricmptohex(e){return e.replace(/%/g,"")}function hextouricmp(e){return e.replace(/(..)/g,"%$1")}function ipv6tohex(e){var t="malformed IPv6 address";if(!e.match(/^[0-9A-Fa-f:]+$/))throw t;var r=(e=e.toLowerCase()).split(":").length-1;if(r<2)throw t;var n=":".repeat(7-r+2),i=(e=e.replace("::",n)).split(":");if(8!=i.length)throw t;for(var o=0;o<8;o++)i[o]=("0000"+i[o]).slice(-4);return i.join("")}function hextoipv6(e){if(!e.match(/^[0-9A-Fa-f]{32}$/))throw"malformed IPv6 address octet";for(var t=(e=e.toLowerCase()).match(/.{1,4}/g),r=0;r<8;r++)t[r]=t[r].replace(/^0+/,""),""==t[r]&&(t[r]="0");var n=(e=":"+t.join(":")+":").match(/:(0:){2,}/g);if(null===n)return e.slice(1,-1);var i="";for(r=0;r<n.length;r++)n[r].length>i.length&&(i=n[r]);return(e=e.replace(i,"::")).slice(1,-1)}function hextoip(e){var t="malformed hex value";if(!e.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/))throw t;if(8!=e.length)return 32==e.length?hextoipv6(e):e;try{return parseInt(e.substr(0,2),16)+"."+parseInt(e.substr(2,2),16)+"."+parseInt(e.substr(4,2),16)+"."+parseInt(e.substr(6,2),16)}catch(e){throw t}}function encodeURIComponentAll(e){for(var t=encodeURIComponent(e),r="",n=0;n<t.length;n++)"%"==t[n]?(r+=t.substr(n,3),n+=2):r=r+"%"+stohex(t[n]);return r}function hextoposhex(e){return e.length%2==1?"0"+e:e.substr(0,1)>"7"?"00"+e:e}J.getLblen=function(e,t){if("8"!=e.substr(t+2,1))return 1;var r=parseInt(e.substr(t+3,1));return 0==r?-1:0<r&&r<10?r+1:-2},J.getL=function(e,t){var r=J.getLblen(e,t);return r<1?"":e.substr(t+2,2*r)},J.getVblen=function(e,t){var r;return""==(r=J.getL(e,t))?-1:("8"===r.substr(0,1)?new BigInteger(r.substr(2),16):new BigInteger(r,16)).intValue()},J.getVidx=function(e,t){var r=J.getLblen(e,t);return r<0?r:t+2*(r+1)},J.getV=function(e,t){var r=J.getVidx(e,t),n=J.getVblen(e,t);return e.substr(r,2*n)},J.getTLV=function(e,t){return e.substr(t,2)+J.getL(e,t)+J.getV(e,t)},J.getNextSiblingIdx=function(e,t){return J.getVidx(e,t)+2*J.getVblen(e,t)},J.getChildIdx=function(e,t){var r=J,n=new Array,i=r.getVidx(e,t);"03"==e.substr(t,2)?n.push(i+2):n.push(i);for(var o=r.getVblen(e,t),s=i,a=0;;){var u=r.getNextSiblingIdx(e,s);if(null==u||u-i>=2*o)break;if(a>=200)break;n.push(u),s=u,a++}return n},J.getNthChildIdx=function(e,t,r){return J.getChildIdx(e,t)[r]},J.getIdxbyList=function(e,t,r,n){var i,o,s=J;if(0==r.length){if(void 0!==n&&e.substr(t,2)!==n)throw"checking tag doesn't match: "+e.substr(t,2)+"!="+n;return t}return i=r.shift(),o=s.getChildIdx(e,t),s.getIdxbyList(e,o[i],r,n)},J.getTLVbyList=function(e,t,r,n){var i=J,o=i.getIdxbyList(e,t,r);if(void 0===o)throw"can't find nthList object";if(void 0!==n&&e.substr(o,2)!=n)throw"checking tag doesn't match: "+e.substr(o,2)+"!="+n;return i.getTLV(e,o)},J.getVbyList=function(e,t,r,n,i){var o,s,a=J;if(void 0===(o=a.getIdxbyList(e,t,r,n)))throw"can't find nthList object";return s=a.getV(e,o),!0===i&&(s=s.substr(2)),s},J.hextooidstr=function(e){var t=function h(e,t){return e.length>=t?e:new Array(t-e.length+1).join("0")+e},r=[],n=e.substr(0,2),i=parseInt(n,16);r[0]=new String(Math.floor(i/40)),r[1]=new String(i%40);for(var o=e.substr(2),s=[],a=0;a<o.length/2;a++)s.push(parseInt(o.substr(2*a,2),16));var u=[],c="";for(a=0;a<s.length;a++)128&s[a]?c+=t((127&s[a]).toString(2),7):(c+=t((127&s[a]).toString(2),7),u.push(new String(parseInt(c,2))),c="");var h=r.join(".");return u.length>0&&(h=h+"."+u.join(".")),h},J.dump=function(e,t,r,n){var i=J,o=i.getV,s=i.dump,a=i.getChildIdx,u=e;e instanceof V.asn1.ASN1Object&&(u=e.getEncodedHex());var c=function q(e,t){return e.length<=2*t?e:e.substr(0,t)+"..(total "+e.length/2+"bytes).."+e.substr(e.length-t,t)};void 0===t&&(t={ommit_long_octet:32}),void 0===r&&(r=0),void 0===n&&(n="");var h=t.ommit_long_octet;if("01"==u.substr(r,2))return"00"==(l=o(u,r))?n+"BOOLEAN FALSE\n":n+"BOOLEAN TRUE\n";if("02"==u.substr(r,2))return n+"INTEGER "+c(l=o(u,r),h)+"\n";if("03"==u.substr(r,2))return n+"BITSTRING "+c(l=o(u,r),h)+"\n";if("04"==u.substr(r,2)){var l=o(u,r);if(i.isASN1HEX(l)){var f=n+"OCTETSTRING, encapsulates\n";return f+=s(l,t,0,n+"  ")}return n+"OCTETSTRING "+c(l,h)+"\n"}if("05"==u.substr(r,2))return n+"NULL\n";if("06"==u.substr(r,2)){var g=o(u,r),p=V.asn1.ASN1Util.oidHexToInt(g),d=V.asn1.x509.OID.oid2name(p),v=p.replace(/\./g," ");return""!=d?n+"ObjectIdentifier "+d+" ("+v+")\n":n+"ObjectIdentifier ("+v+")\n"}if("0c"==u.substr(r,2))return n+"UTF8String '"+hextoutf8(o(u,r))+"'\n";if("13"==u.substr(r,2))return n+"PrintableString '"+hextoutf8(o(u,r))+"'\n";if("14"==u.substr(r,2))return n+"TeletexString '"+hextoutf8(o(u,r))+"'\n";if("16"==u.substr(r,2))return n+"IA5String '"+hextoutf8(o(u,r))+"'\n";if("17"==u.substr(r,2))return n+"UTCTime "+hextoutf8(o(u,r))+"\n";if("18"==u.substr(r,2))return n+"GeneralizedTime "+hextoutf8(o(u,r))+"\n";if("30"==u.substr(r,2)){if("3000"==u.substr(r,4))return n+"SEQUENCE {}\n";f=n+"SEQUENCE\n";var y=t;if((2==(S=a(u,r)).length||3==S.length)&&"06"==u.substr(S[0],2)&&"04"==u.substr(S[S.length-1],2)){d=i.oidname(o(u,S[0]));var m=JSON.parse(JSON.stringify(t));m.x509ExtName=d,y=m}for(var _=0;_<S.length;_++)f+=s(u,y,S[_],n+"  ");return f}if("31"==u.substr(r,2)){f=n+"SET\n";var S=a(u,r);for(_=0;_<S.length;_++)f+=s(u,t,S[_],n+"  ");return f}var b=parseInt(u.substr(r,2),16);if(0!=(128&b)){var F=31&b;if(0!=(32&b)){var f=n+"["+F+"]\n";for(S=a(u,r),_=0;_<S.length;_++)f+=s(u,t,S[_],n+"  ");return f}return"68747470"==(l=o(u,r)).substr(0,8)&&(l=hextoutf8(l)),"subjectAltName"===t.x509ExtName&&2==F&&(l=hextoutf8(l)),f=n+"["+F+"] "+l+"\n"}return n+"UNKNOWN("+u.substr(r,2)+") "+o(u,r)+"\n"},J.isASN1HEX=function(e){var t=J;if(e.length%2==1)return!1;var r=t.getVblen(e,0),n=e.substr(0,2),i=t.getL(e,0);return e.length-n.length-i.length==2*r},J.oidname=function(e){var t=V.asn1;V.lang.String.isHex(e)&&(e=t.ASN1Util.oidHexToInt(e));var r=t.x509.OID.oid2name(e);return""===r&&(r=e),r},void 0!==V&&V||(t.KJUR=V={}),void 0!==V.lang&&V.lang||(V.lang={}),V.lang.String=function(){},"function"==typeof n?(t.utf8tob64u=q=function utf8tob64u(e){return b64tob64u(new n(e,"utf8").toString("base64"))},t.b64utoutf8=W=function b64utoutf8(e){return new n(b64utob64(e),"base64").toString("utf8")}):(t.utf8tob64u=q=function utf8tob64u(e){return hextob64u(uricmptohex(encodeURIComponentAll(e)))},t.b64utoutf8=W=function b64utoutf8(e){return decodeURIComponent(hextouricmp(b64utohex(e)))}),V.lang.String.isInteger=function(e){return!!e.match(/^[0-9]+$/)||!!e.match(/^-[0-9]+$/)},V.lang.String.isHex=function(e){return!(e.length%2!=0||!e.match(/^[0-9a-f]+$/)&&!e.match(/^[0-9A-F]+$/))},V.lang.String.isBase64=function(e){return!(!(e=e.replace(/\s+/g,"")).match(/^[0-9A-Za-z+\/]+={0,3}$/)||e.length%4!=0)},V.lang.String.isBase64URL=function(e){return!e.match(/[+/=]/)&&(e=b64utob64(e),V.lang.String.isBase64(e))},V.lang.String.isIntegerArray=function(e){return!!(e=e.replace(/\s+/g,"")).match(/^\[[0-9,]+\]$/)};void 0!==V&&V||(t.KJUR=V={}),void 0!==V.crypto&&V.crypto||(V.crypto={}),V.crypto.Util=new function(){this.DIGESTINFOHEAD={sha1:"3021300906052b0e03021a05000414",sha224:"302d300d06096086480165030402040500041c",sha256:"3031300d060960864801650304020105000420",sha384:"3041300d060960864801650304020205000430",sha512:"3051300d060960864801650304020305000440",md2:"3020300c06082a864886f70d020205000410",md5:"3020300c06082a864886f70d020505000410",ripemd160:"3021300906052b2403020105000414"},this.DEFAULTPROVIDER={md5:"cryptojs",sha1:"cryptojs",sha224:"cryptojs",sha256:"cryptojs",sha384:"cryptojs",sha512:"cryptojs",ripemd160:"cryptojs",hmacmd5:"cryptojs",hmacsha1:"cryptojs",hmacsha224:"cryptojs",hmacsha256:"cryptojs",hmacsha384:"cryptojs",hmacsha512:"cryptojs",hmacripemd160:"cryptojs",MD5withRSA:"cryptojs/jsrsa",SHA1withRSA:"cryptojs/jsrsa",SHA224withRSA:"cryptojs/jsrsa",SHA256withRSA:"cryptojs/jsrsa",SHA384withRSA:"cryptojs/jsrsa",SHA512withRSA:"cryptojs/jsrsa",RIPEMD160withRSA:"cryptojs/jsrsa",MD5withECDSA:"cryptojs/jsrsa",SHA1withECDSA:"cryptojs/jsrsa",SHA224withECDSA:"cryptojs/jsrsa",SHA256withECDSA:"cryptojs/jsrsa",SHA384withECDSA:"cryptojs/jsrsa",SHA512withECDSA:"cryptojs/jsrsa",RIPEMD160withECDSA:"cryptojs/jsrsa",SHA1withDSA:"cryptojs/jsrsa",SHA224withDSA:"cryptojs/jsrsa",SHA256withDSA:"cryptojs/jsrsa",MD5withRSAandMGF1:"cryptojs/jsrsa",SHA1withRSAandMGF1:"cryptojs/jsrsa",SHA224withRSAandMGF1:"cryptojs/jsrsa",SHA256withRSAandMGF1:"cryptojs/jsrsa",SHA384withRSAandMGF1:"cryptojs/jsrsa",SHA512withRSAandMGF1:"cryptojs/jsrsa",RIPEMD160withRSAandMGF1:"cryptojs/jsrsa"},this.CRYPTOJSMESSAGEDIGESTNAME={md5:y.algo.MD5,sha1:y.algo.SHA1,sha224:y.algo.SHA224,sha256:y.algo.SHA256,sha384:y.algo.SHA384,sha512:y.algo.SHA512,ripemd160:y.algo.RIPEMD160},this.getDigestInfoHex=function(e,t){if(void 0===this.DIGESTINFOHEAD[t])throw"alg not supported in Util.DIGESTINFOHEAD: "+t;return this.DIGESTINFOHEAD[t]+e},this.getPaddedDigestInfoHex=function(e,t,r){var n=this.getDigestInfoHex(e,t),i=r/4;if(n.length+22>i)throw"key is too short for SigAlg: keylen="+r+","+t;for(var o="0001",s="00"+n,a="",u=i-o.length-s.length,c=0;c<u;c+=2)a+="ff";return o+a+s},this.hashString=function(e,t){return new V.crypto.MessageDigest({alg:t}).digestString(e)},this.hashHex=function(e,t){return new V.crypto.MessageDigest({alg:t}).digestHex(e)},this.sha1=function(e){return new V.crypto.MessageDigest({alg:"sha1",prov:"cryptojs"}).digestString(e)},this.sha256=function(e){return new V.crypto.MessageDigest({alg:"sha256",prov:"cryptojs"}).digestString(e)},this.sha256Hex=function(e){return new V.crypto.MessageDigest({alg:"sha256",prov:"cryptojs"}).digestHex(e)},this.sha512=function(e){return new V.crypto.MessageDigest({alg:"sha512",prov:"cryptojs"}).digestString(e)},this.sha512Hex=function(e){return new V.crypto.MessageDigest({alg:"sha512",prov:"cryptojs"}).digestHex(e)}},V.crypto.Util.md5=function(e){return new V.crypto.MessageDigest({alg:"md5",prov:"cryptojs"}).digestString(e)},V.crypto.Util.ripemd160=function(e){return new V.crypto.MessageDigest({alg:"ripemd160",prov:"cryptojs"}).digestString(e)},V.crypto.Util.SECURERANDOMGEN=new SecureRandom,V.crypto.Util.getRandomHexOfNbytes=function(e){var t=new Array(e);return V.crypto.Util.SECURERANDOMGEN.nextBytes(t),BAtohex(t)},V.crypto.Util.getRandomBigIntegerOfNbytes=function(e){return new BigInteger(V.crypto.Util.getRandomHexOfNbytes(e),16)},V.crypto.Util.getRandomHexOfNbits=function(e){var t=e%8,r=new Array((e-t)/8+1);return V.crypto.Util.SECURERANDOMGEN.nextBytes(r),r[0]=(255<<t&255^255)&r[0],BAtohex(r)},V.crypto.Util.getRandomBigIntegerOfNbits=function(e){return new BigInteger(V.crypto.Util.getRandomHexOfNbits(e),16)},V.crypto.Util.getRandomBigIntegerZeroToMax=function(e){for(var t=e.bitLength();;){var r=V.crypto.Util.getRandomBigIntegerOfNbits(t);if(-1!=e.compareTo(r))return r}},V.crypto.Util.getRandomBigIntegerMinToMax=function(e,t){var r=e.compareTo(t);if(1==r)throw"biMin is greater than biMax";if(0==r)return e;var n=t.subtract(e);return V.crypto.Util.getRandomBigIntegerZeroToMax(n).add(e)},V.crypto.MessageDigest=function(e){this.setAlgAndProvider=function(e,t){if(null!==(e=V.crypto.MessageDigest.getCanonicalAlgName(e))&&void 0===t&&(t=V.crypto.Util.DEFAULTPROVIDER[e]),-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(e)&&"cryptojs"==t){try{this.md=V.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[e].create()}catch(t){throw"setAlgAndProvider hash alg set fail alg="+e+"/"+t}this.updateString=function(e){this.md.update(e)},this.updateHex=function(e){var t=y.enc.Hex.parse(e);this.md.update(t)},this.digest=function(){return this.md.finalize().toString(y.enc.Hex)},this.digestString=function(e){return this.updateString(e),this.digest()},this.digestHex=function(e){return this.updateHex(e),this.digest()}}if(-1!=":sha256:".indexOf(e)&&"sjcl"==t){try{this.md=new sjcl.hash.sha256}catch(t){throw"setAlgAndProvider hash alg set fail alg="+e+"/"+t}this.updateString=function(e){this.md.update(e)},this.updateHex=function(e){var t=sjcl.codec.hex.toBits(e);this.md.update(t)},this.digest=function(){var e=this.md.finalize();return sjcl.codec.hex.fromBits(e)},this.digestString=function(e){return this.updateString(e),this.digest()},this.digestHex=function(e){return this.updateHex(e),this.digest()}}},this.updateString=function(e){throw"updateString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.updateHex=function(e){throw"updateHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digest=function(){throw"digest() not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digestString=function(e){throw"digestString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digestHex=function(e){throw"digestHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName},void 0!==e&&void 0!==e.alg&&(this.algName=e.alg,void 0===e.prov&&(this.provName=V.crypto.Util.DEFAULTPROVIDER[this.algName]),this.setAlgAndProvider(this.algName,this.provName))},V.crypto.MessageDigest.getCanonicalAlgName=function(e){return"string"==typeof e&&(e=(e=e.toLowerCase()).replace(/-/,"")),e},V.crypto.MessageDigest.getHashLength=function(e){var t=V.crypto.MessageDigest,r=t.getCanonicalAlgName(e);if(void 0===t.HASHLENGTH[r])throw"not supported algorithm: "+e;return t.HASHLENGTH[r]},V.crypto.MessageDigest.HASHLENGTH={md5:16,sha1:20,sha224:28,sha256:32,sha384:48,sha512:64,ripemd160:20},V.crypto.Mac=function(e){this.setAlgAndProvider=function(e,t){if(null==(e=e.toLowerCase())&&(e="hmacsha1"),"hmac"!=(e=e.toLowerCase()).substr(0,4))throw"setAlgAndProvider unsupported HMAC alg: "+e;void 0===t&&(t=V.crypto.Util.DEFAULTPROVIDER[e]),this.algProv=e+"/"+t;var r=e.substr(4);if(-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(r)&&"cryptojs"==t){try{var n=V.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[r];this.mac=y.algo.HMAC.create(n,this.pass)}catch(e){throw"setAlgAndProvider hash alg set fail hashAlg="+r+"/"+e}this.updateString=function(e){this.mac.update(e)},this.updateHex=function(e){var t=y.enc.Hex.parse(e);this.mac.update(t)},this.doFinal=function(){return this.mac.finalize().toString(y.enc.Hex)},this.doFinalString=function(e){return this.updateString(e),this.doFinal()},this.doFinalHex=function(e){return this.updateHex(e),this.doFinal()}}},this.updateString=function(e){throw"updateString(str) not supported for this alg/prov: "+this.algProv},this.updateHex=function(e){throw"updateHex(hex) not supported for this alg/prov: "+this.algProv},this.doFinal=function(){throw"digest() not supported for this alg/prov: "+this.algProv},this.doFinalString=function(e){throw"digestString(str) not supported for this alg/prov: "+this.algProv},this.doFinalHex=function(e){throw"digestHex(hex) not supported for this alg/prov: "+this.algProv},this.setPassword=function(e){if("string"==typeof e){var t=e;return e.length%2!=1&&e.match(/^[0-9A-Fa-f]+$/)||(t=rstrtohex(e)),void(this.pass=y.enc.Hex.parse(t))}if("object"!=(void 0===e?"undefined":i(e)))throw"KJUR.crypto.Mac unsupported password type: "+e;t=null;if(void 0!==e.hex){if(e.hex.length%2!=0||!e.hex.match(/^[0-9A-Fa-f]+$/))throw"Mac: wrong hex password: "+e.hex;t=e.hex}if(void 0!==e.utf8&&(t=utf8tohex(e.utf8)),void 0!==e.rstr&&(t=rstrtohex(e.rstr)),void 0!==e.b64&&(t=b64tohex(e.b64)),void 0!==e.b64u&&(t=b64utohex(e.b64u)),null==t)throw"KJUR.crypto.Mac unsupported password type: "+e;this.pass=y.enc.Hex.parse(t)},void 0!==e&&(void 0!==e.pass&&this.setPassword(e.pass),void 0!==e.alg&&(this.algName=e.alg,void 0===e.prov&&(this.provName=V.crypto.Util.DEFAULTPROVIDER[this.algName]),this.setAlgAndProvider(this.algName,this.provName)))},V.crypto.Signature=function(e){var t=null;if(this._setAlgNames=function(){var e=this.algName.match(/^(.+)with(.+)$/);e&&(this.mdAlgName=e[1].toLowerCase(),this.pubkeyAlgName=e[2].toLowerCase())},this._zeroPaddingOfSignature=function(e,t){for(var r="",n=t/4-e.length,i=0;i<n;i++)r+="0";return r+e},this.setAlgAndProvider=function(e,t){if(this._setAlgNames(),"cryptojs/jsrsa"!=t)throw"provider not supported: "+t;if(-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName)){try{this.md=new V.crypto.MessageDigest({alg:this.mdAlgName})}catch(e){throw"setAlgAndProvider hash alg set fail alg="+this.mdAlgName+"/"+e}this.init=function(e,t){var r=null;try{r=void 0===t?z.getKey(e):z.getKey(e,t)}catch(e){throw"init failed:"+e}if(!0===r.isPrivate)this.prvKey=r,this.state="SIGN";else{if(!0!==r.isPublic)throw"init failed.:"+r;this.pubKey=r,this.state="VERIFY"}},this.updateString=function(e){this.md.updateString(e)},this.updateHex=function(e){this.md.updateHex(e)},this.sign=function(){if(this.sHashHex=this.md.digest(),void 0!==this.ecprvhex&&void 0!==this.eccurvename){var e=new V.crypto.ECDSA({curve:this.eccurvename});this.hSign=e.signHex(this.sHashHex,this.ecprvhex)}else if(this.prvKey instanceof RSAKey&&"rsaandmgf1"===this.pubkeyAlgName)this.hSign=this.prvKey.signWithMessageHashPSS(this.sHashHex,this.mdAlgName,this.pssSaltLen);else if(this.prvKey instanceof RSAKey&&"rsa"===this.pubkeyAlgName)this.hSign=this.prvKey.signWithMessageHash(this.sHashHex,this.mdAlgName);else if(this.prvKey instanceof V.crypto.ECDSA)this.hSign=this.prvKey.signWithMessageHash(this.sHashHex);else{if(!(this.prvKey instanceof V.crypto.DSA))throw"Signature: unsupported private key alg: "+this.pubkeyAlgName;this.hSign=this.prvKey.signWithMessageHash(this.sHashHex)}return this.hSign},this.signString=function(e){return this.updateString(e),this.sign()},this.signHex=function(e){return this.updateHex(e),this.sign()},this.verify=function(e){if(this.sHashHex=this.md.digest(),void 0!==this.ecpubhex&&void 0!==this.eccurvename)return new V.crypto.ECDSA({curve:this.eccurvename}).verifyHex(this.sHashHex,e,this.ecpubhex);if(this.pubKey instanceof RSAKey&&"rsaandmgf1"===this.pubkeyAlgName)return this.pubKey.verifyWithMessageHashPSS(this.sHashHex,e,this.mdAlgName,this.pssSaltLen);if(this.pubKey instanceof RSAKey&&"rsa"===this.pubkeyAlgName)return this.pubKey.verifyWithMessageHash(this.sHashHex,e);if(void 0!==V.crypto.ECDSA&&this.pubKey instanceof V.crypto.ECDSA)return this.pubKey.verifyWithMessageHash(this.sHashHex,e);if(void 0!==V.crypto.DSA&&this.pubKey instanceof V.crypto.DSA)return this.pubKey.verifyWithMessageHash(this.sHashHex,e);throw"Signature: unsupported public key alg: "+this.pubkeyAlgName}}},this.init=function(e,t){throw"init(key, pass) not supported for this alg:prov="+this.algProvName},this.updateString=function(e){throw"updateString(str) not supported for this alg:prov="+this.algProvName},this.updateHex=function(e){throw"updateHex(hex) not supported for this alg:prov="+this.algProvName},this.sign=function(){throw"sign() not supported for this alg:prov="+this.algProvName},this.signString=function(e){throw"digestString(str) not supported for this alg:prov="+this.algProvName},this.signHex=function(e){throw"digestHex(hex) not supported for this alg:prov="+this.algProvName},this.verify=function(e){throw"verify(hSigVal) not supported for this alg:prov="+this.algProvName},this.initParams=e,void 0!==e&&(void 0!==e.alg&&(this.algName=e.alg,void 0===e.prov?this.provName=V.crypto.Util.DEFAULTPROVIDER[this.algName]:this.provName=e.prov,this.algProvName=this.algName+":"+this.provName,this.setAlgAndProvider(this.algName,this.provName),this._setAlgNames()),void 0!==e.psssaltlen&&(this.pssSaltLen=e.psssaltlen),void 0!==e.prvkeypem)){if(void 0!==e.prvkeypas)throw"both prvkeypem and prvkeypas parameters not supported";try{t=z.getKey(e.prvkeypem);this.init(t)}catch(e){throw"fatal error to load pem private key: "+e}}},V.crypto.Cipher=function(e){},V.crypto.Cipher.encrypt=function(e,t,r){if(t instanceof RSAKey&&t.isPublic){var n=V.crypto.Cipher.getAlgByKeyAndName(t,r);if("RSA"===n)return t.encrypt(e);if("RSAOAEP"===n)return t.encryptOAEP(e,"sha1");var i=n.match(/^RSAOAEP(\d+)$/);if(null!==i)return t.encryptOAEP(e,"sha"+i[1]);throw"Cipher.encrypt: unsupported algorithm for RSAKey: "+r}throw"Cipher.encrypt: unsupported key or algorithm"},V.crypto.Cipher.decrypt=function(e,t,r){if(t instanceof RSAKey&&t.isPrivate){var n=V.crypto.Cipher.getAlgByKeyAndName(t,r);if("RSA"===n)return t.decrypt(e);if("RSAOAEP"===n)return t.decryptOAEP(e,"sha1");var i=n.match(/^RSAOAEP(\d+)$/);if(null!==i)return t.decryptOAEP(e,"sha"+i[1]);throw"Cipher.decrypt: unsupported algorithm for RSAKey: "+r}throw"Cipher.decrypt: unsupported key or algorithm"},V.crypto.Cipher.getAlgByKeyAndName=function(e,t){if(e instanceof RSAKey){if(-1!=":RSA:RSAOAEP:RSAOAEP224:RSAOAEP256:RSAOAEP384:RSAOAEP512:".indexOf(t))return t;if(null===t||void 0===t)return"RSA";throw"getAlgByKeyAndName: not supported algorithm name for RSAKey: "+t}throw"getAlgByKeyAndName: not supported algorithm name: "+t},V.crypto.OID=new function(){this.oidhex2name={"2a864886f70d010101":"rsaEncryption","2a8648ce3d0201":"ecPublicKey","2a8648ce380401":"dsa","2a8648ce3d030107":"secp256r1","2b8104001f":"secp192k1","2b81040021":"secp224r1","2b8104000a":"secp256k1","2b81040023":"secp521r1","2b81040022":"secp384r1","2a8648ce380403":"SHA1withDSA","608648016503040301":"SHA224withDSA","608648016503040302":"SHA256withDSA"}},void 0!==V&&V||(t.KJUR=V={}),void 0!==V.crypto&&V.crypto||(V.crypto={}),V.crypto.ECDSA=function(e){var t=new SecureRandom;this.type="EC",this.isPrivate=!1,this.isPublic=!1,this.getBigRandom=function(e){return new BigInteger(e.bitLength(),t).mod(e.subtract(BigInteger.ONE)).add(BigInteger.ONE)},this.setNamedCurve=function(e){this.ecparams=V.crypto.ECParameterDB.getByName(e),this.prvKeyHex=null,this.pubKeyHex=null,this.curveName=e},this.setPrivateKeyHex=function(e){this.isPrivate=!0,this.prvKeyHex=e},this.setPublicKeyHex=function(e){this.isPublic=!0,this.pubKeyHex=e},this.getPublicKeyXYHex=function(){var e=this.pubKeyHex;if("04"!==e.substr(0,2))throw"this method supports uncompressed format(04) only";var t=this.ecparams.keylen/4;if(e.length!==2+2*t)throw"malformed public key hex length";var r={};return r.x=e.substr(2,t),r.y=e.substr(2+t),r},this.getShortNISTPCurveName=function(){var e=this.curveName;return"secp256r1"===e||"NIST P-256"===e||"P-256"===e||"prime256v1"===e?"P-256":"secp384r1"===e||"NIST P-384"===e||"P-384"===e?"P-384":null},this.generateKeyPairHex=function(){var e=this.ecparams.n,t=this.getBigRandom(e),r=this.ecparams.G.multiply(t),n=r.getX().toBigInteger(),i=r.getY().toBigInteger(),o=this.ecparams.keylen/4,s=("0000000000"+t.toString(16)).slice(-o),a="04"+("0000000000"+n.toString(16)).slice(-o)+("0000000000"+i.toString(16)).slice(-o);return this.setPrivateKeyHex(s),this.setPublicKeyHex(a),{ecprvhex:s,ecpubhex:a}},this.signWithMessageHash=function(e){return this.signHex(e,this.prvKeyHex)},this.signHex=function(e,t){var r=new BigInteger(t,16),n=this.ecparams.n,i=new BigInteger(e,16);do{var o=this.getBigRandom(n),s=this.ecparams.G.multiply(o).getX().toBigInteger().mod(n)}while(s.compareTo(BigInteger.ZERO)<=0);var a=o.modInverse(n).multiply(i.add(r.multiply(s))).mod(n);return V.crypto.ECDSA.biRSSigToASN1Sig(s,a)},this.sign=function(e,t){var r=t,n=this.ecparams.n,i=BigInteger.fromByteArrayUnsigned(e);do{var o=this.getBigRandom(n),s=this.ecparams.G.multiply(o).getX().toBigInteger().mod(n)}while(s.compareTo(BigInteger.ZERO)<=0);var a=o.modInverse(n).multiply(i.add(r.multiply(s))).mod(n);return this.serializeSig(s,a)},this.verifyWithMessageHash=function(e,t){return this.verifyHex(e,t,this.pubKeyHex)},this.verifyHex=function(e,t,r){var n,i,o,s=V.crypto.ECDSA.parseSigHex(t);n=s.r,i=s.s,o=ECPointFp.decodeFromHex(this.ecparams.curve,r);var a=new BigInteger(e,16);return this.verifyRaw(a,n,i,o)},this.verify=function(e,t,r){var n,o,s;if(Bitcoin.Util.isArray(t)){var a=this.parseSig(t);n=a.r,o=a.s}else{if("object"!==(void 0===t?"undefined":i(t))||!t.r||!t.s)throw"Invalid value for signature";n=t.r,o=t.s}if(r instanceof ECPointFp)s=r;else{if(!Bitcoin.Util.isArray(r))throw"Invalid format for pubkey value, must be byte array or ECPointFp";s=ECPointFp.decodeFrom(this.ecparams.curve,r)}var u=BigInteger.fromByteArrayUnsigned(e);return this.verifyRaw(u,n,o,s)},this.verifyRaw=function(e,t,r,n){var i=this.ecparams.n,o=this.ecparams.G;if(t.compareTo(BigInteger.ONE)<0||t.compareTo(i)>=0)return!1;if(r.compareTo(BigInteger.ONE)<0||r.compareTo(i)>=0)return!1;var s=r.modInverse(i),a=e.multiply(s).mod(i),u=t.multiply(s).mod(i);return o.multiply(a).add(n.multiply(u)).getX().toBigInteger().mod(i).equals(t)},this.serializeSig=function(e,t){var r=e.toByteArraySigned(),n=t.toByteArraySigned(),i=[];return i.push(2),i.push(r.length),(i=i.concat(r)).push(2),i.push(n.length),(i=i.concat(n)).unshift(i.length),i.unshift(48),i},this.parseSig=function(e){var t;if(48!=e[0])throw new Error("Signature not a valid DERSequence");if(2!=e[t=2])throw new Error("First element in signature must be a DERInteger");var r=e.slice(t+2,t+2+e[t+1]);if(2!=e[t+=2+e[t+1]])throw new Error("Second element in signature must be a DERInteger");var n=e.slice(t+2,t+2+e[t+1]);return t+=2+e[t+1],{r:BigInteger.fromByteArrayUnsigned(r),s:BigInteger.fromByteArrayUnsigned(n)}},this.parseSigCompact=function(e){if(65!==e.length)throw"Signature has the wrong length";var t=e[0]-27;if(t<0||t>7)throw"Invalid signature type";var r=this.ecparams.n;return{r:BigInteger.fromByteArrayUnsigned(e.slice(1,33)).mod(r),s:BigInteger.fromByteArrayUnsigned(e.slice(33,65)).mod(r),i:t}},this.readPKCS5PrvKeyHex=function(e){var t,r,n,i=J,o=V.crypto.ECDSA.getName,s=i.getVbyList;if(!1===i.isASN1HEX(e))throw"not ASN.1 hex string";try{t=s(e,0,[2,0],"06"),r=s(e,0,[1],"04");try{n=s(e,0,[3,0],"03").substr(2)}catch(e){}}catch(e){throw"malformed PKCS#1/5 plain ECC private key"}if(this.curveName=o(t),void 0===this.curveName)throw"unsupported curve name";this.setNamedCurve(this.curveName),this.setPublicKeyHex(n),this.setPrivateKeyHex(r),this.isPublic=!1},this.readPKCS8PrvKeyHex=function(e){var t,r,n,i=J,o=V.crypto.ECDSA.getName,s=i.getVbyList;if(!1===i.isASN1HEX(e))throw"not ASN.1 hex string";try{s(e,0,[1,0],"06"),t=s(e,0,[1,1],"06"),r=s(e,0,[2,0,1],"04");try{n=s(e,0,[2,0,2,0],"03").substr(2)}catch(e){}}catch(e){throw"malformed PKCS#8 plain ECC private key"}if(this.curveName=o(t),void 0===this.curveName)throw"unsupported curve name";this.setNamedCurve(this.curveName),this.setPublicKeyHex(n),this.setPrivateKeyHex(r),this.isPublic=!1},this.readPKCS8PubKeyHex=function(e){var t,r,n=J,i=V.crypto.ECDSA.getName,o=n.getVbyList;if(!1===n.isASN1HEX(e))throw"not ASN.1 hex string";try{o(e,0,[0,0],"06"),t=o(e,0,[0,1],"06"),r=o(e,0,[1],"03").substr(2)}catch(e){throw"malformed PKCS#8 ECC public key"}if(this.curveName=i(t),null===this.curveName)throw"unsupported curve name";this.setNamedCurve(this.curveName),this.setPublicKeyHex(r)},this.readCertPubKeyHex=function(e,t){5!==t&&(t=6);var r,n,i=J,o=V.crypto.ECDSA.getName,s=i.getVbyList;if(!1===i.isASN1HEX(e))throw"not ASN.1 hex string";try{r=s(e,0,[0,t,0,1],"06"),n=s(e,0,[0,t,1],"03").substr(2)}catch(e){throw"malformed X.509 certificate ECC public key"}if(this.curveName=o(r),null===this.curveName)throw"unsupported curve name";this.setNamedCurve(this.curveName),this.setPublicKeyHex(n)},void 0!==e&&void 0!==e.curve&&(this.curveName=e.curve),void 0===this.curveName&&(this.curveName="secp256r1"),this.setNamedCurve(this.curveName),void 0!==e&&(void 0!==e.prv&&this.setPrivateKeyHex(e.prv),void 0!==e.pub&&this.setPublicKeyHex(e.pub))},V.crypto.ECDSA.parseSigHex=function(e){var t=V.crypto.ECDSA.parseSigHexInHexRS(e);return{r:new BigInteger(t.r,16),s:new BigInteger(t.s,16)}},V.crypto.ECDSA.parseSigHexInHexRS=function(e){var t=J,r=t.getChildIdx,n=t.getV;if("30"!=e.substr(0,2))throw"signature is not a ASN.1 sequence";var i=r(e,0);if(2!=i.length)throw"number of signature ASN.1 sequence elements seem wrong";var o=i[0],s=i[1];if("02"!=e.substr(o,2))throw"1st item of sequene of signature is not ASN.1 integer";if("02"!=e.substr(s,2))throw"2nd item of sequene of signature is not ASN.1 integer";return{r:n(e,o),s:n(e,s)}},V.crypto.ECDSA.asn1SigToConcatSig=function(e){var t=V.crypto.ECDSA.parseSigHexInHexRS(e),r=t.r,n=t.s;if("00"==r.substr(0,2)&&r.length%32==2&&(r=r.substr(2)),"00"==n.substr(0,2)&&n.length%32==2&&(n=n.substr(2)),r.length%32==30&&(r="00"+r),n.length%32==30&&(n="00"+n),r.length%32!=0)throw"unknown ECDSA sig r length error";if(n.length%32!=0)throw"unknown ECDSA sig s length error";return r+n},V.crypto.ECDSA.concatSigToASN1Sig=function(e){if(e.length/2*8%128!=0)throw"unknown ECDSA concatinated r-s sig  length error";var t=e.substr(0,e.length/2),r=e.substr(e.length/2);return V.crypto.ECDSA.hexRSSigToASN1Sig(t,r)},V.crypto.ECDSA.hexRSSigToASN1Sig=function(e,t){var r=new BigInteger(e,16),n=new BigInteger(t,16);return V.crypto.ECDSA.biRSSigToASN1Sig(r,n)},V.crypto.ECDSA.biRSSigToASN1Sig=function(e,t){var r=V.asn1,n=new r.DERInteger({bigint:e}),i=new r.DERInteger({bigint:t});return new r.DERSequence({array:[n,i]}).getEncodedHex()},V.crypto.ECDSA.getName=function(e){return"2a8648ce3d030107"===e?"secp256r1":"2b8104000a"===e?"secp256k1":"2b81040022"===e?"secp384r1":-1!=="|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(e)?"secp256r1":-1!=="|secp256k1|".indexOf(e)?"secp256k1":-1!=="|secp384r1|NIST P-384|P-384|".indexOf(e)?"secp384r1":null},void 0!==V&&V||(t.KJUR=V={}),void 0!==V.crypto&&V.crypto||(V.crypto={}),V.crypto.ECParameterDB=new function(){var e={},t={};function a(e){return new BigInteger(e,16)}this.getByName=function(r){var n=r;if(void 0!==t[n]&&(n=t[r]),void 0!==e[n])return e[n];throw"unregistered EC curve name: "+n},this.regist=function(r,n,i,o,s,u,c,h,l,f,g,p){e[r]={};var d=a(i),v=a(o),y=a(s),m=a(u),_=a(c),S=new ECCurveFp(d,v,y),b=S.decodePointHex("04"+h+l);e[r].name=r,e[r].keylen=n,e[r].curve=S,e[r].G=b,e[r].n=m,e[r].h=_,e[r].oid=g,e[r].info=p;for(var F=0;F<f.length;F++)t[f[F]]=r}},V.crypto.ECParameterDB.regist("secp128r1",128,"FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC","E87579C11079F43DD824993C2CEE5ED3","FFFFFFFE0000000075A30D1B9038A115","1","161FF7528B899B2D0C28607CA52C5B86","CF5AC8395BAFEB13C02DA292DDED7A83",[],"","secp128r1 : SECG curve over a 128 bit prime field"),V.crypto.ECParameterDB.regist("secp160k1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73","0","7","0100000000000000000001B8FA16DFAB9ACA16B6B3","1","3B4C382CE37AA192A4019E763036F4F5DD4D7EBB","938CF935318FDCED6BC28286531733C3F03C4FEE",[],"","secp160k1 : SECG curve over a 160 bit prime field"),V.crypto.ECParameterDB.regist("secp160r1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC","1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45","0100000000000000000001F4C8F927AED3CA752257","1","4A96B5688EF573284664698968C38BB913CBFC82","23A628553168947D59DCC912042351377AC5FB32",[],"","secp160r1 : SECG curve over a 160 bit prime field"),V.crypto.ECParameterDB.regist("secp192k1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37","0","3","FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D","1","DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D","9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D",[]),V.crypto.ECParameterDB.regist("secp192r1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC","64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1","FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831","1","188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012","07192B95FFC8DA78631011ED6B24CDD573F977A11E794811",[]),V.crypto.ECParameterDB.regist("secp224r1",224,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE","B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4","FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D","1","B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21","BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34",[]),V.crypto.ECParameterDB.regist("secp256k1",256,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F","0","7","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141","1","79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798","483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8",[]),V.crypto.ECParameterDB.regist("secp256r1",256,"FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC","5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B","FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551","1","6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296","4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5",["NIST P-256","P-256","prime256v1"]),V.crypto.ECParameterDB.regist("secp384r1",384,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC","B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973","1","AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7","3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f",["NIST P-384","P-384"]),V.crypto.ECParameterDB.regist("secp521r1",521,"1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC","051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409","1","C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66","011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650",["NIST P-521","P-521"]);var z=function(){var t=function d(e,t,n){return r(y.AES,e,t,n)},r=function k(e,t,r,n){var i=y.enc.Hex.parse(t),o=y.enc.Hex.parse(r),s=y.enc.Hex.parse(n),a={};a.key=o,a.iv=s,a.ciphertext=i;var u=e.decrypt(a,o,{iv:s});return y.enc.Hex.stringify(u)},n=function l(e,t,r){return i(y.AES,e,t,r)},i=function g(e,t,r,n){var i=y.enc.Hex.parse(t),o=y.enc.Hex.parse(r),s=y.enc.Hex.parse(n),a=e.encrypt(i,o,{iv:s}),u=y.enc.Hex.parse(a.toString());return y.enc.Base64.stringify(u)},s={"AES-256-CBC":{proc:t,eproc:n,keylen:32,ivlen:16},"AES-192-CBC":{proc:t,eproc:n,keylen:24,ivlen:16},"AES-128-CBC":{proc:t,eproc:n,keylen:16,ivlen:16},"DES-EDE3-CBC":{proc:function e(t,n,i){return r(y.TripleDES,t,n,i)},eproc:function o(e,t,r){return i(y.TripleDES,e,t,r)},keylen:24,ivlen:8},"DES-CBC":{proc:function a(e,t,n){return r(y.DES,e,t,n)},eproc:function f(e,t,r){return i(y.DES,e,t,r)},keylen:8,ivlen:8}},u=function n(e){var t={},r=e.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)","m"));r&&(t.cipher=r[1],t.ivsalt=r[2]);var i=e.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));i&&(t.type=i[1]);var o=-1,s=0;-1!=e.indexOf("\r\n\r\n")&&(o=e.indexOf("\r\n\r\n"),s=2),-1!=e.indexOf("\n\n")&&(o=e.indexOf("\n\n"),s=1);var a=e.indexOf("-----END");if(-1!=o&&-1!=a){var u=e.substring(o+2*s,a-s);u=u.replace(/\s+/g,""),t.data=u}return t},c=function j(e,t,r){for(var n=r.substring(0,16),i=y.enc.Hex.parse(n),o=y.enc.Utf8.parse(t),a=s[e].keylen+s[e].ivlen,u="",c=null;;){var h=y.algo.MD5.create();if(null!=c&&h.update(c),h.update(o),h.update(i),c=h.finalize(),(u+=y.enc.Hex.stringify(c)).length>=2*a)break}var l={};return l.keyhex=u.substr(0,2*s[e].keylen),l.ivhex=u.substr(2*s[e].keylen,2*s[e].ivlen),l},g=function b(e,t,r,n){var i=y.enc.Base64.parse(e),o=y.enc.Hex.stringify(i);return(0,s[t].proc)(o,r,n)};return{version:"1.0.0",parsePKCS5PEM:function parsePKCS5PEM(e){return u(e)},getKeyAndUnusedIvByPasscodeAndIvsalt:function getKeyAndUnusedIvByPasscodeAndIvsalt(e,t,r){return c(e,t,r)},decryptKeyB64:function decryptKeyB64(e,t,r,n){return g(e,t,r,n)},getDecryptedKeyHex:function getDecryptedKeyHex(e,t){var r=u(e),n=(r.type,r.cipher),i=r.ivsalt,o=r.data,s=c(n,t,i).keyhex;return g(o,n,s,i)},getEncryptedPKCS5PEMFromPrvKeyHex:function getEncryptedPKCS5PEMFromPrvKeyHex(e,t,r,n,i){var o="";if(void 0!==n&&null!=n||(n="AES-256-CBC"),void 0===s[n])throw"KEYUTIL unsupported algorithm: "+n;void 0!==i&&null!=i||(i=function m(e){var t=y.lib.WordArray.random(e);return y.enc.Hex.stringify(t)}(s[n].ivlen).toUpperCase());var a=function h(e,t,r,n){return(0,s[t].eproc)(e,r,n)}(t,n,c(n,r,i).keyhex,i);o="-----BEGIN "+e+" PRIVATE KEY-----\r\n";return o+="Proc-Type: 4,ENCRYPTED\r\n",o+="DEK-Info: "+n+","+i+"\r\n",o+="\r\n",o+=a.replace(/(.{64})/g,"$1\r\n"),o+="\r\n-----END "+e+" PRIVATE KEY-----\r\n"},parseHexOfEncryptedPKCS8:function parseHexOfEncryptedPKCS8(e){var t=J,r=t.getChildIdx,n=t.getV,i={},o=r(e,0);if(2!=o.length)throw"malformed format: SEQUENCE(0).items != 2: "+o.length;i.ciphertext=n(e,o[1]);var s=r(e,o[0]);if(2!=s.length)throw"malformed format: SEQUENCE(0.0).items != 2: "+s.length;if("2a864886f70d01050d"!=n(e,s[0]))throw"this only supports pkcs5PBES2";var a=r(e,s[1]);if(2!=s.length)throw"malformed format: SEQUENCE(0.0.1).items != 2: "+a.length;var u=r(e,a[1]);if(2!=u.length)throw"malformed format: SEQUENCE(0.0.1.1).items != 2: "+u.length;if("2a864886f70d0307"!=n(e,u[0]))throw"this only supports TripleDES";i.encryptionSchemeAlg="TripleDES",i.encryptionSchemeIV=n(e,u[1]);var c=r(e,a[0]);if(2!=c.length)throw"malformed format: SEQUENCE(0.0.1.0).items != 2: "+c.length;if("2a864886f70d01050c"!=n(e,c[0]))throw"this only supports pkcs5PBKDF2";var h=r(e,c[1]);if(h.length<2)throw"malformed format: SEQUENCE(0.0.1.0.1).items < 2: "+h.length;i.pbkdf2Salt=n(e,h[0]);var l=n(e,h[1]);try{i.pbkdf2Iter=parseInt(l,16)}catch(e){throw"malformed format pbkdf2Iter: "+l}return i},getPBKDF2KeyHexFromParam:function getPBKDF2KeyHexFromParam(e,t){var r=y.enc.Hex.parse(e.pbkdf2Salt),n=e.pbkdf2Iter,i=y.PBKDF2(t,r,{keySize:6,iterations:n});return y.enc.Hex.stringify(i)},_getPlainPKCS8HexFromEncryptedPKCS8PEM:function _getPlainPKCS8HexFromEncryptedPKCS8PEM(e,t){var r=pemtohex(e,"ENCRYPTED PRIVATE KEY"),n=this.parseHexOfEncryptedPKCS8(r),i=z.getPBKDF2KeyHexFromParam(n,t),o={};o.ciphertext=y.enc.Hex.parse(n.ciphertext);var s=y.enc.Hex.parse(i),a=y.enc.Hex.parse(n.encryptionSchemeIV),u=y.TripleDES.decrypt(o,s,{iv:a});return y.enc.Hex.stringify(u)},getKeyFromEncryptedPKCS8PEM:function getKeyFromEncryptedPKCS8PEM(e,t){var r=this._getPlainPKCS8HexFromEncryptedPKCS8PEM(e,t);return this.getKeyFromPlainPrivatePKCS8Hex(r)},parsePlainPrivatePKCS8Hex:function parsePlainPrivatePKCS8Hex(e){var t=J,r=t.getChildIdx,n=t.getV,i={algparam:null};if("30"!=e.substr(0,2))throw"malformed plain PKCS8 private key(code:001)";var o=r(e,0);if(3!=o.length)throw"malformed plain PKCS8 private key(code:002)";if("30"!=e.substr(o[1],2))throw"malformed PKCS8 private key(code:003)";var s=r(e,o[1]);if(2!=s.length)throw"malformed PKCS8 private key(code:004)";if("06"!=e.substr(s[0],2))throw"malformed PKCS8 private key(code:005)";if(i.algoid=n(e,s[0]),"06"==e.substr(s[1],2)&&(i.algparam=n(e,s[1])),"04"!=e.substr(o[2],2))throw"malformed PKCS8 private key(code:006)";return i.keyidx=t.getVidx(e,o[2]),i},getKeyFromPlainPrivatePKCS8PEM:function getKeyFromPlainPrivatePKCS8PEM(e){var t=pemtohex(e,"PRIVATE KEY");return this.getKeyFromPlainPrivatePKCS8Hex(t)},getKeyFromPlainPrivatePKCS8Hex:function getKeyFromPlainPrivatePKCS8Hex(e){var t,r=this.parsePlainPrivatePKCS8Hex(e);if("2a864886f70d010101"==r.algoid)t=new RSAKey;else if("2a8648ce380401"==r.algoid)t=new V.crypto.DSA;else{if("2a8648ce3d0201"!=r.algoid)throw"unsupported private key algorithm";t=new V.crypto.ECDSA}return t.readPKCS8PrvKeyHex(e),t},_getKeyFromPublicPKCS8Hex:function _getKeyFromPublicPKCS8Hex(e){var t,r=J.getVbyList(e,0,[0,0],"06");if("2a864886f70d010101"===r)t=new RSAKey;else if("2a8648ce380401"===r)t=new V.crypto.DSA;else{if("2a8648ce3d0201"!==r)throw"unsupported PKCS#8 public key hex";t=new V.crypto.ECDSA}return t.readPKCS8PubKeyHex(e),t},parsePublicRawRSAKeyHex:function parsePublicRawRSAKeyHex(e){var t=J,r=t.getChildIdx,n=t.getV,i={};if("30"!=e.substr(0,2))throw"malformed RSA key(code:001)";var o=r(e,0);if(2!=o.length)throw"malformed RSA key(code:002)";if("02"!=e.substr(o[0],2))throw"malformed RSA key(code:003)";if(i.n=n(e,o[0]),"02"!=e.substr(o[1],2))throw"malformed RSA key(code:004)";return i.e=n(e,o[1]),i},parsePublicPKCS8Hex:function parsePublicPKCS8Hex(e){var t=J,r=t.getChildIdx,n=t.getV,i={algparam:null},o=r(e,0);if(2!=o.length)throw"outer DERSequence shall have 2 elements: "+o.length;var s=o[0];if("30"!=e.substr(s,2))throw"malformed PKCS8 public key(code:001)";var a=r(e,s);if(2!=a.length)throw"malformed PKCS8 public key(code:002)";if("06"!=e.substr(a[0],2))throw"malformed PKCS8 public key(code:003)";if(i.algoid=n(e,a[0]),"06"==e.substr(a[1],2)?i.algparam=n(e,a[1]):"30"==e.substr(a[1],2)&&(i.algparam={},i.algparam.p=t.getVbyList(e,a[1],[0],"02"),i.algparam.q=t.getVbyList(e,a[1],[1],"02"),i.algparam.g=t.getVbyList(e,a[1],[2],"02")),"03"!=e.substr(o[1],2))throw"malformed PKCS8 public key(code:004)";return i.key=n(e,o[1]).substr(2),i}}}();z.getKey=function(e,t,r){var n=(v=J).getChildIdx,i=(v.getV,v.getVbyList),o=V.crypto,s=o.ECDSA,a=o.DSA,u=RSAKey,c=pemtohex,h=z;if(void 0!==u&&e instanceof u)return e;if(void 0!==s&&e instanceof s)return e;if(void 0!==a&&e instanceof a)return e;if(void 0!==e.curve&&void 0!==e.xy&&void 0===e.d)return new s({pub:e.xy,curve:e.curve});if(void 0!==e.curve&&void 0!==e.d)return new s({prv:e.d,curve:e.curve});if(void 0===e.kty&&void 0!==e.n&&void 0!==e.e&&void 0===e.d)return(k=new u).setPublic(e.n,e.e),k;if(void 0===e.kty&&void 0!==e.n&&void 0!==e.e&&void 0!==e.d&&void 0!==e.p&&void 0!==e.q&&void 0!==e.dp&&void 0!==e.dq&&void 0!==e.co&&void 0===e.qi)return(k=new u).setPrivateEx(e.n,e.e,e.d,e.p,e.q,e.dp,e.dq,e.co),k;if(void 0===e.kty&&void 0!==e.n&&void 0!==e.e&&void 0!==e.d&&void 0===e.p)return(k=new u).setPrivate(e.n,e.e,e.d),k;if(void 0!==e.p&&void 0!==e.q&&void 0!==e.g&&void 0!==e.y&&void 0===e.x)return(k=new a).setPublic(e.p,e.q,e.g,e.y),k;if(void 0!==e.p&&void 0!==e.q&&void 0!==e.g&&void 0!==e.y&&void 0!==e.x)return(k=new a).setPrivate(e.p,e.q,e.g,e.y,e.x),k;if("RSA"===e.kty&&void 0!==e.n&&void 0!==e.e&&void 0===e.d)return(k=new u).setPublic(b64utohex(e.n),b64utohex(e.e)),k;if("RSA"===e.kty&&void 0!==e.n&&void 0!==e.e&&void 0!==e.d&&void 0!==e.p&&void 0!==e.q&&void 0!==e.dp&&void 0!==e.dq&&void 0!==e.qi)return(k=new u).setPrivateEx(b64utohex(e.n),b64utohex(e.e),b64utohex(e.d),b64utohex(e.p),b64utohex(e.q),b64utohex(e.dp),b64utohex(e.dq),b64utohex(e.qi)),k;if("RSA"===e.kty&&void 0!==e.n&&void 0!==e.e&&void 0!==e.d)return(k=new u).setPrivate(b64utohex(e.n),b64utohex(e.e),b64utohex(e.d)),k;if("EC"===e.kty&&void 0!==e.crv&&void 0!==e.x&&void 0!==e.y&&void 0===e.d){var l=(C=new s({curve:e.crv})).ecparams.keylen/4,f="04"+("0000000000"+b64utohex(e.x)).slice(-l)+("0000000000"+b64utohex(e.y)).slice(-l);return C.setPublicKeyHex(f),C}if("EC"===e.kty&&void 0!==e.crv&&void 0!==e.x&&void 0!==e.y&&void 0!==e.d){l=(C=new s({curve:e.crv})).ecparams.keylen/4,f="04"+("0000000000"+b64utohex(e.x)).slice(-l)+("0000000000"+b64utohex(e.y)).slice(-l);var g=("0000000000"+b64utohex(e.d)).slice(-l);return C.setPublicKeyHex(f),C.setPrivateKeyHex(g),C}if("pkcs5prv"===r){var p,d=e,v=J;if(9===(p=n(d,0)).length)(k=new u).readPKCS5PrvKeyHex(d);else if(6===p.length)(k=new a).readPKCS5PrvKeyHex(d);else{if(!(p.length>2&&"04"===d.substr(p[1],2)))throw"unsupported PKCS#1/5 hexadecimal key";(k=new s).readPKCS5PrvKeyHex(d)}return k}if("pkcs8prv"===r)return k=h.getKeyFromPlainPrivatePKCS8Hex(e);if("pkcs8pub"===r)return h._getKeyFromPublicPKCS8Hex(e);if("x509pub"===r)return X509.getPublicKeyFromCertHex(e);if(-1!=e.indexOf("-END CERTIFICATE-",0)||-1!=e.indexOf("-END X509 CERTIFICATE-",0)||-1!=e.indexOf("-END TRUSTED CERTIFICATE-",0))return X509.getPublicKeyFromCertPEM(e);if(-1!=e.indexOf("-END PUBLIC KEY-")){var y=pemtohex(e,"PUBLIC KEY");return h._getKeyFromPublicPKCS8Hex(y)}if(-1!=e.indexOf("-END RSA PRIVATE KEY-")&&-1==e.indexOf("4,ENCRYPTED")){var m=c(e,"RSA PRIVATE KEY");return h.getKey(m,null,"pkcs5prv")}if(-1!=e.indexOf("-END DSA PRIVATE KEY-")&&-1==e.indexOf("4,ENCRYPTED")){var _=i(I=c(e,"DSA PRIVATE KEY"),0,[1],"02"),S=i(I,0,[2],"02"),b=i(I,0,[3],"02"),F=i(I,0,[4],"02"),w=i(I,0,[5],"02");return(k=new a).setPrivate(new BigInteger(_,16),new BigInteger(S,16),new BigInteger(b,16),new BigInteger(F,16),new BigInteger(w,16)),k}if(-1!=e.indexOf("-END PRIVATE KEY-"))return h.getKeyFromPlainPrivatePKCS8PEM(e);if(-1!=e.indexOf("-END RSA PRIVATE KEY-")&&-1!=e.indexOf("4,ENCRYPTED")){var E=h.getDecryptedKeyHex(e,t),x=new RSAKey;return x.readPKCS5PrvKeyHex(E),x}if(-1!=e.indexOf("-END EC PRIVATE KEY-")&&-1!=e.indexOf("4,ENCRYPTED")){var C,k=i(I=h.getDecryptedKeyHex(e,t),0,[1],"04"),A=i(I,0,[2,0],"06"),P=i(I,0,[3,0],"03").substr(2);if(void 0===V.crypto.OID.oidhex2name[A])throw"undefined OID(hex) in KJUR.crypto.OID: "+A;return(C=new s({curve:V.crypto.OID.oidhex2name[A]})).setPublicKeyHex(P),C.setPrivateKeyHex(k),C.isPublic=!1,C}if(-1!=e.indexOf("-END DSA PRIVATE KEY-")&&-1!=e.indexOf("4,ENCRYPTED")){var I;_=i(I=h.getDecryptedKeyHex(e,t),0,[1],"02"),S=i(I,0,[2],"02"),b=i(I,0,[3],"02"),F=i(I,0,[4],"02"),w=i(I,0,[5],"02");return(k=new a).setPrivate(new BigInteger(_,16),new BigInteger(S,16),new BigInteger(b,16),new BigInteger(F,16),new BigInteger(w,16)),k}if(-1!=e.indexOf("-END ENCRYPTED PRIVATE KEY-"))return h.getKeyFromEncryptedPKCS8PEM(e,t);throw"not supported argument"},z.generateKeypair=function(e,t){if("RSA"==e){var r=t;(s=new RSAKey).generate(r,"10001"),s.isPrivate=!0,s.isPublic=!0;var n=new RSAKey,i=s.n.toString(16),o=s.e.toString(16);return n.setPublic(i,o),n.isPrivate=!1,n.isPublic=!0,(a={}).prvKeyObj=s,a.pubKeyObj=n,a}if("EC"==e){var s,a,u=t,c=new V.crypto.ECDSA({curve:u}).generateKeyPairHex();return(s=new V.crypto.ECDSA({curve:u})).setPublicKeyHex(c.ecpubhex),s.setPrivateKeyHex(c.ecprvhex),s.isPrivate=!0,s.isPublic=!1,(n=new V.crypto.ECDSA({curve:u})).setPublicKeyHex(c.ecpubhex),n.isPrivate=!1,n.isPublic=!0,(a={}).prvKeyObj=s,a.pubKeyObj=n,a}throw"unknown algorithm: "+e},z.getPEM=function(e,t,r,n,i,s){var a=V,u=a.asn1,c=u.DERObjectIdentifier,h=u.DERInteger,l=u.ASN1Util.newObject,f=u.x509.SubjectPublicKeyInfo,g=a.crypto,p=g.DSA,d=g.ECDSA,v=RSAKey;function A(e){return l({seq:[{int:0},{int:{bigint:e.n}},{int:e.e},{int:{bigint:e.d}},{int:{bigint:e.p}},{int:{bigint:e.q}},{int:{bigint:e.dmp1}},{int:{bigint:e.dmq1}},{int:{bigint:e.coeff}}]})}function B(e){return l({seq:[{int:1},{octstr:{hex:e.prvKeyHex}},{tag:["a0",!0,{oid:{name:e.curveName}}]},{tag:["a1",!0,{bitstr:{hex:"00"+e.pubKeyHex}}]}]})}function x(e){return l({seq:[{int:0},{int:{bigint:e.p}},{int:{bigint:e.q}},{int:{bigint:e.g}},{int:{bigint:e.y}},{int:{bigint:e.x}}]})}if((void 0!==v&&e instanceof v||void 0!==p&&e instanceof p||void 0!==d&&e instanceof d)&&1==e.isPublic&&(void 0===t||"PKCS8PUB"==t))return hextopem(b=new f(e).getEncodedHex(),"PUBLIC KEY");if("PKCS1PRV"==t&&void 0!==v&&e instanceof v&&(void 0===r||null==r)&&1==e.isPrivate)return hextopem(b=A(e).getEncodedHex(),"RSA PRIVATE KEY");if("PKCS1PRV"==t&&void 0!==d&&e instanceof d&&(void 0===r||null==r)&&1==e.isPrivate){var m=new c({name:e.curveName}).getEncodedHex(),_=B(e).getEncodedHex(),S="";return S+=hextopem(m,"EC PARAMETERS"),S+=hextopem(_,"EC PRIVATE KEY")}if("PKCS1PRV"==t&&void 0!==p&&e instanceof p&&(void 0===r||null==r)&&1==e.isPrivate)return hextopem(b=x(e).getEncodedHex(),"DSA PRIVATE KEY");if("PKCS5PRV"==t&&void 0!==v&&e instanceof v&&void 0!==r&&null!=r&&1==e.isPrivate){var b=A(e).getEncodedHex();return void 0===n&&(n="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA",b,r,n,s)}if("PKCS5PRV"==t&&void 0!==d&&e instanceof d&&void 0!==r&&null!=r&&1==e.isPrivate){b=B(e).getEncodedHex();return void 0===n&&(n="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("EC",b,r,n,s)}if("PKCS5PRV"==t&&void 0!==p&&e instanceof p&&void 0!==r&&null!=r&&1==e.isPrivate){b=x(e).getEncodedHex();return void 0===n&&(n="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA",b,r,n,s)}var F=function o(e,t){var r=w(e,t);return new l({seq:[{seq:[{oid:{name:"pkcs5PBES2"}},{seq:[{seq:[{oid:{name:"pkcs5PBKDF2"}},{seq:[{octstr:{hex:r.pbkdf2Salt}},{int:r.pbkdf2Iter}]}]},{seq:[{oid:{name:"des-EDE3-CBC"}},{octstr:{hex:r.encryptionSchemeIV}}]}]}]},{octstr:{hex:r.ciphertext}}]}).getEncodedHex()},w=function c(e,t){var r=y.lib.WordArray.random(8),n=y.lib.WordArray.random(8),i=y.PBKDF2(t,r,{keySize:6,iterations:100}),o=y.enc.Hex.parse(e),s=y.TripleDES.encrypt(o,i,{iv:n})+"",a={};return a.ciphertext=s,a.pbkdf2Salt=y.enc.Hex.stringify(r),a.pbkdf2Iter=100,a.encryptionSchemeAlg="DES-EDE3-CBC",a.encryptionSchemeIV=y.enc.Hex.stringify(n),a};if("PKCS8PRV"==t&&void 0!=v&&e instanceof v&&1==e.isPrivate){var E=A(e).getEncodedHex();b=l({seq:[{int:0},{seq:[{oid:{name:"rsaEncryption"}},{null:!0}]},{octstr:{hex:E}}]}).getEncodedHex();return void 0===r||null==r?hextopem(b,"PRIVATE KEY"):hextopem(_=F(b,r),"ENCRYPTED PRIVATE KEY")}if("PKCS8PRV"==t&&void 0!==d&&e instanceof d&&1==e.isPrivate){E=new l({seq:[{int:1},{octstr:{hex:e.prvKeyHex}},{tag:["a1",!0,{bitstr:{hex:"00"+e.pubKeyHex}}]}]}).getEncodedHex(),b=l({seq:[{int:0},{seq:[{oid:{name:"ecPublicKey"}},{oid:{name:e.curveName}}]},{octstr:{hex:E}}]}).getEncodedHex();return void 0===r||null==r?hextopem(b,"PRIVATE KEY"):hextopem(_=F(b,r),"ENCRYPTED PRIVATE KEY")}if("PKCS8PRV"==t&&void 0!==p&&e instanceof p&&1==e.isPrivate){E=new h({bigint:e.x}).getEncodedHex(),b=l({seq:[{int:0},{seq:[{oid:{name:"dsa"}},{seq:[{int:{bigint:e.p}},{int:{bigint:e.q}},{int:{bigint:e.g}}]}]},{octstr:{hex:E}}]}).getEncodedHex();return void 0===r||null==r?hextopem(b,"PRIVATE KEY"):hextopem(_=F(b,r),"ENCRYPTED PRIVATE KEY")}throw"unsupported object nor format"},z.getKeyFromCSRPEM=function(e){var t=pemtohex(e,"CERTIFICATE REQUEST");return z.getKeyFromCSRHex(t)},z.getKeyFromCSRHex=function(e){var t=z.parseCSRHex(e);return z.getKey(t.p8pubkeyhex,null,"pkcs8pub")},z.parseCSRHex=function(e){var t=J,r=t.getChildIdx,n=t.getTLV,i={},o=e;if("30"!=o.substr(0,2))throw"malformed CSR(code:001)";var s=r(o,0);if(s.length<1)throw"malformed CSR(code:002)";if("30"!=o.substr(s[0],2))throw"malformed CSR(code:003)";var a=r(o,s[0]);if(a.length<3)throw"malformed CSR(code:004)";return i.p8pubkeyhex=n(o,a[2]),i},z.getJWKFromKey=function(e){var t={};if(e instanceof RSAKey&&e.isPrivate)return t.kty="RSA",t.n=hextob64u(e.n.toString(16)),t.e=hextob64u(e.e.toString(16)),t.d=hextob64u(e.d.toString(16)),t.p=hextob64u(e.p.toString(16)),t.q=hextob64u(e.q.toString(16)),t.dp=hextob64u(e.dmp1.toString(16)),t.dq=hextob64u(e.dmq1.toString(16)),t.qi=hextob64u(e.coeff.toString(16)),t;if(e instanceof RSAKey&&e.isPublic)return t.kty="RSA",t.n=hextob64u(e.n.toString(16)),t.e=hextob64u(e.e.toString(16)),t;if(e instanceof V.crypto.ECDSA&&e.isPrivate){if("P-256"!==(n=e.getShortNISTPCurveName())&&"P-384"!==n)throw"unsupported curve name for JWT: "+n;var r=e.getPublicKeyXYHex();return t.kty="EC",t.crv=n,t.x=hextob64u(r.x),t.y=hextob64u(r.y),t.d=hextob64u(e.prvKeyHex),t}if(e instanceof V.crypto.ECDSA&&e.isPublic){var n;if("P-256"!==(n=e.getShortNISTPCurveName())&&"P-384"!==n)throw"unsupported curve name for JWT: "+n;r=e.getPublicKeyXYHex();return t.kty="EC",t.crv=n,t.x=hextob64u(r.x),t.y=hextob64u(r.y),t}throw"not supported key object"},RSAKey.getPosArrayOfChildrenFromHex=function(e){return J.getChildIdx(e,0)},RSAKey.getHexValueArrayOfChildrenFromHex=function(e){var t,r=J.getV,n=r(e,(t=RSAKey.getPosArrayOfChildrenFromHex(e))[0]),i=r(e,t[1]),o=r(e,t[2]),s=r(e,t[3]),a=r(e,t[4]),u=r(e,t[5]),c=r(e,t[6]),h=r(e,t[7]),l=r(e,t[8]);return(t=new Array).push(n,i,o,s,a,u,c,h,l),t},RSAKey.prototype.readPrivateKeyFromPEMString=function(e){var t=pemtohex(e),r=RSAKey.getHexValueArrayOfChildrenFromHex(t);this.setPrivateEx(r[1],r[2],r[3],r[4],r[5],r[6],r[7],r[8])},RSAKey.prototype.readPKCS5PrvKeyHex=function(e){var t=RSAKey.getHexValueArrayOfChildrenFromHex(e);this.setPrivateEx(t[1],t[2],t[3],t[4],t[5],t[6],t[7],t[8])},RSAKey.prototype.readPKCS8PrvKeyHex=function(e){var t,r,n,i,o,s,a,u,c=J,h=c.getVbyList;if(!1===c.isASN1HEX(e))throw"not ASN.1 hex string";try{t=h(e,0,[2,0,1],"02"),r=h(e,0,[2,0,2],"02"),n=h(e,0,[2,0,3],"02"),i=h(e,0,[2,0,4],"02"),o=h(e,0,[2,0,5],"02"),s=h(e,0,[2,0,6],"02"),a=h(e,0,[2,0,7],"02"),u=h(e,0,[2,0,8],"02")}catch(e){throw"malformed PKCS#8 plain RSA private key"}this.setPrivateEx(t,r,n,i,o,s,a,u)},RSAKey.prototype.readPKCS5PubKeyHex=function(e){var t=J,r=t.getV;if(!1===t.isASN1HEX(e))throw"keyHex is not ASN.1 hex string";var n=t.getChildIdx(e,0);if(2!==n.length||"02"!==e.substr(n[0],2)||"02"!==e.substr(n[1],2))throw"wrong hex for PKCS#5 public key";var i=r(e,n[0]),o=r(e,n[1]);this.setPublic(i,o)},RSAKey.prototype.readPKCS8PubKeyHex=function(e){var t=J;if(!1===t.isASN1HEX(e))throw"not ASN.1 hex string";if("06092a864886f70d010101"!==t.getTLVbyList(e,0,[0,0]))throw"not PKCS8 RSA public key";var r=t.getTLVbyList(e,0,[1,0]);this.readPKCS5PubKeyHex(r)},RSAKey.prototype.readCertPubKeyHex=function(e,t){var r,n;(r=new X509).readCertHex(e),n=r.getPublicKeyHex(),this.readPKCS8PubKeyHex(n)};var Y=new RegExp("");function _zeroPaddingOfSignature(e,t){for(var r="",n=t/4-e.length,i=0;i<n;i++)r+="0";return r+e}function pss_mgf1_str(e,t,r){for(var n="",i=0;n.length<t;)n+=hextorstr(r(rstrtohex(e+String.fromCharCode.apply(String,[(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i])))),i+=1;return n}function _rsasign_getAlgNameAndHashFromHexDisgestInfo(e){for(var t in V.crypto.Util.DIGESTINFOHEAD){var r=V.crypto.Util.DIGESTINFOHEAD[t],n=r.length;if(e.substring(0,n)==r)return[t,e.substring(n)]}return[]}function X509(){var e=J,t=e.getChildIdx,r=e.getV,n=e.getTLV,i=e.getVbyList,o=e.getTLVbyList,s=e.getIdxbyList,a=e.getVidx,u=e.oidname,c=X509,h=pemtohex;this.hex=null,this.version=0,this.foffset=0,this.aExtInfo=null,this.getVersion=function(){return null===this.hex||0!==this.version?this.version:"a003020102"!==o(this.hex,0,[0,0])?(this.version=1,this.foffset=-1,1):(this.version=3,3)},this.getSerialNumberHex=function(){return i(this.hex,0,[0,1+this.foffset],"02")},this.getSignatureAlgorithmField=function(){return u(i(this.hex,0,[0,2+this.foffset,0],"06"))},this.getIssuerHex=function(){return o(this.hex,0,[0,3+this.foffset],"30")},this.getIssuerString=function(){return c.hex2dn(this.getIssuerHex())},this.getSubjectHex=function(){return o(this.hex,0,[0,5+this.foffset],"30")},this.getSubjectString=function(){return c.hex2dn(this.getSubjectHex())},this.getNotBefore=function(){var e=i(this.hex,0,[0,4+this.foffset,0]);return e=e.replace(/(..)/g,"%$1"),e=decodeURIComponent(e)},this.getNotAfter=function(){var e=i(this.hex,0,[0,4+this.foffset,1]);return e=e.replace(/(..)/g,"%$1"),e=decodeURIComponent(e)},this.getPublicKeyHex=function(){return e.getTLVbyList(this.hex,0,[0,6+this.foffset],"30")},this.getPublicKeyIdx=function(){return s(this.hex,0,[0,6+this.foffset],"30")},this.getPublicKeyContentIdx=function(){var e=this.getPublicKeyIdx();return s(this.hex,e,[1,0],"30")},this.getPublicKey=function(){return z.getKey(this.getPublicKeyHex(),null,"pkcs8pub")},this.getSignatureAlgorithmName=function(){return u(i(this.hex,0,[1,0],"06"))},this.getSignatureValueHex=function(){return i(this.hex,0,[2],"03",!0)},this.verifySignature=function(e){var t=this.getSignatureAlgorithmName(),r=this.getSignatureValueHex(),n=o(this.hex,0,[0],"30"),i=new V.crypto.Signature({alg:t});return i.init(e),i.updateHex(n),i.verify(r)},this.parseExt=function(){if(3!==this.version)return-1;var r=s(this.hex,0,[0,7,0],"30"),n=t(this.hex,r);this.aExtInfo=new Array;for(var o=0;o<n.length;o++){var u={critical:!1},c=0;3===t(this.hex,n[o]).length&&(u.critical=!0,c=1),u.oid=e.hextooidstr(i(this.hex,n[o],[0],"06"));var h=s(this.hex,n[o],[1+c]);u.vidx=a(this.hex,h),this.aExtInfo.push(u)}},this.getExtInfo=function(e){var t=this.aExtInfo,r=e;if(e.match(/^[0-9.]+$/)||(r=V.asn1.x509.OID.name2oid(e)),""!==r)for(var n=0;n<t.length;n++)if(t[n].oid===r)return t[n]},this.getExtBasicConstraints=function(){var e=this.getExtInfo("basicConstraints");if(void 0===e)return e;var t=r(this.hex,e.vidx);if(""===t)return{};if("0101ff"===t)return{cA:!0};if("0101ff02"===t.substr(0,8)){var n=r(t,6);return{cA:!0,pathLen:parseInt(n,16)}}throw"basicConstraints parse error"},this.getExtKeyUsageBin=function(){var e=this.getExtInfo("keyUsage");if(void 0===e)return"";var t=r(this.hex,e.vidx);if(t.length%2!=0||t.length<=2)throw"malformed key usage value";var n=parseInt(t.substr(0,2)),i=parseInt(t.substr(2),16).toString(2);return i.substr(0,i.length-n)},this.getExtKeyUsageString=function(){for(var e=this.getExtKeyUsageBin(),t=new Array,r=0;r<e.length;r++)"1"==e.substr(r,1)&&t.push(X509.KEYUSAGE_NAME[r]);return t.join(",")},this.getExtSubjectKeyIdentifier=function(){var e=this.getExtInfo("subjectKeyIdentifier");return void 0===e?e:r(this.hex,e.vidx)},this.getExtAuthorityKeyIdentifier=function(){var e=this.getExtInfo("authorityKeyIdentifier");if(void 0===e)return e;for(var i={},o=n(this.hex,e.vidx),s=t(o,0),a=0;a<s.length;a++)"80"===o.substr(s[a],2)&&(i.kid=r(o,s[a]));return i},this.getExtExtKeyUsageName=function(){var e=this.getExtInfo("extKeyUsage");if(void 0===e)return e;var i=new Array,o=n(this.hex,e.vidx);if(""===o)return i;for(var s=t(o,0),a=0;a<s.length;a++)i.push(u(r(o,s[a])));return i},this.getExtSubjectAltName=function(){for(var e=this.getExtSubjectAltName2(),t=new Array,r=0;r<e.length;r++)"DNS"===e[r][0]&&t.push(e[r][1]);return t},this.getExtSubjectAltName2=function(){var e,i,o,s=this.getExtInfo("subjectAltName");if(void 0===s)return s;for(var a=new Array,u=n(this.hex,s.vidx),c=t(u,0),h=0;h<c.length;h++)o=u.substr(c[h],2),e=r(u,c[h]),"81"===o&&(i=hextoutf8(e),a.push(["MAIL",i])),"82"===o&&(i=hextoutf8(e),a.push(["DNS",i])),"84"===o&&(i=X509.hex2dn(e,0),a.push(["DN",i])),"86"===o&&(i=hextoutf8(e),a.push(["URI",i])),"87"===o&&(i=hextoip(e),a.push(["IP",i]));return a},this.getExtCRLDistributionPointsURI=function(){var e=this.getExtInfo("cRLDistributionPoints");if(void 0===e)return e;for(var r=new Array,n=t(this.hex,e.vidx),o=0;o<n.length;o++)try{var s=hextoutf8(i(this.hex,n[o],[0,0,0],"86"));r.push(s)}catch(e){}return r},this.getExtAIAInfo=function(){var e=this.getExtInfo("authorityInfoAccess");if(void 0===e)return e;for(var r={ocsp:[],caissuer:[]},n=t(this.hex,e.vidx),o=0;o<n.length;o++){var s=i(this.hex,n[o],[0],"06"),a=i(this.hex,n[o],[1],"86");"2b06010505073001"===s&&r.ocsp.push(hextoutf8(a)),"2b06010505073002"===s&&r.caissuer.push(hextoutf8(a))}return r},this.getExtCertificatePolicies=function(){var e=this.getExtInfo("certificatePolicies");if(void 0===e)return e;for(var o=n(this.hex,e.vidx),s=[],a=t(o,0),c=0;c<a.length;c++){var h={},l=t(o,a[c]);if(h.id=u(r(o,l[0])),2===l.length)for(var f=t(o,l[1]),g=0;g<f.length;g++){var p=i(o,f[g],[0],"06");"2b06010505070201"===p?h.cps=hextoutf8(i(o,f[g],[1])):"2b06010505070202"===p&&(h.unotice=hextoutf8(i(o,f[g],[1,0])))}s.push(h)}return s},this.readCertPEM=function(e){this.readCertHex(h(e))},this.readCertHex=function(e){this.hex=e,this.getVersion();try{s(this.hex,0,[0,7],"a3"),this.parseExt()}catch(e){}},this.getInfo=function(){var e,t,r;if(e="Basic Fields\n",e+="  serial number: "+this.getSerialNumberHex()+"\n",e+="  signature algorithm: "+this.getSignatureAlgorithmField()+"\n",e+="  issuer: "+this.getIssuerString()+"\n",e+="  notBefore: "+this.getNotBefore()+"\n",e+="  notAfter: "+this.getNotAfter()+"\n",e+="  subject: "+this.getSubjectString()+"\n",e+="  subject public key info: \n",e+="    key algorithm: "+(t=this.getPublicKey()).type+"\n","RSA"===t.type&&(e+="    n="+hextoposhex(t.n.toString(16)).substr(0,16)+"...\n",e+="    e="+hextoposhex(t.e.toString(16))+"\n"),void 0!==(r=this.aExtInfo)&&null!==r){e+="X509v3 Extensions:\n";for(var n=0;n<r.length;n++){var i=r[n],o=V.asn1.x509.OID.oid2name(i.oid);""===o&&(o=i.oid);var s="";if(!0===i.critical&&(s="CRITICAL"),e+="  "+o+" "+s+":\n","basicConstraints"===o){var a=this.getExtBasicConstraints();void 0===a.cA?e+="    {}\n":(e+="    cA=true",void 0!==a.pathLen&&(e+=", pathLen="+a.pathLen),e+="\n")}else if("keyUsage"===o)e+="    "+this.getExtKeyUsageString()+"\n";else if("subjectKeyIdentifier"===o)e+="    "+this.getExtSubjectKeyIdentifier()+"\n";else if("authorityKeyIdentifier"===o){var u=this.getExtAuthorityKeyIdentifier();void 0!==u.kid&&(e+="    kid="+u.kid+"\n")}else{if("extKeyUsage"===o)e+="    "+this.getExtExtKeyUsageName().join(", ")+"\n";else if("subjectAltName"===o)e+="    "+this.getExtSubjectAltName2()+"\n";else if("cRLDistributionPoints"===o)e+="    "+this.getExtCRLDistributionPointsURI()+"\n";else if("authorityInfoAccess"===o){var c=this.getExtAIAInfo();void 0!==c.ocsp&&(e+="    ocsp: "+c.ocsp.join(",")+"\n"),void 0!==c.caissuer&&(e+="    caissuer: "+c.caissuer.join(",")+"\n")}else if("certificatePolicies"===o)for(var h=this.getExtCertificatePolicies(),l=0;l<h.length;l++)void 0!==h[l].id&&(e+="    policy oid: "+h[l].id+"\n"),void 0!==h[l].cps&&(e+="    cps: "+h[l].cps+"\n")}}}return e+="signature algorithm: "+this.getSignatureAlgorithmName()+"\n",e+="signature: "+this.getSignatureValueHex().substr(0,16)+"...\n"}}Y.compile("[^0-9a-f]","gi"),RSAKey.prototype.sign=function(e,t){var r=function b(e){return V.crypto.Util.hashString(e,t)}(e);return this.signWithMessageHash(r,t)},RSAKey.prototype.signWithMessageHash=function(e,t){var r=parseBigInt(V.crypto.Util.getPaddedDigestInfoHex(e,t,this.n.bitLength()),16);return _zeroPaddingOfSignature(this.doPrivate(r).toString(16),this.n.bitLength())},RSAKey.prototype.signPSS=function(e,t,r){var n=function c(e){return V.crypto.Util.hashHex(e,t)}(rstrtohex(e));return void 0===r&&(r=-1),this.signWithMessageHashPSS(n,t,r)},RSAKey.prototype.signWithMessageHashPSS=function(e,t,r){var n,i=hextorstr(e),s=i.length,a=this.n.bitLength()-1,u=Math.ceil(a/8),c=function o(e){return V.crypto.Util.hashHex(e,t)};if(-1===r||void 0===r)r=s;else if(-2===r)r=u-s-2;else if(r<-2)throw"invalid salt length";if(u<s+r+2)throw"data too long";var h="";r>0&&(h=new Array(r),(new SecureRandom).nextBytes(h),h=String.fromCharCode.apply(String,h));var l=hextorstr(c(rstrtohex("\0\0\0\0\0\0\0\0"+i+h))),f=[];for(n=0;n<u-r-s-2;n+=1)f[n]=0;var g=String.fromCharCode.apply(String,f)+""+h,p=pss_mgf1_str(l,g.length,c),d=[];for(n=0;n<g.length;n+=1)d[n]=g.charCodeAt(n)^p.charCodeAt(n);var v=65280>>8*u-a&255;for(d[0]&=~v,n=0;n<s;n++)d.push(l.charCodeAt(n));return d.push(188),_zeroPaddingOfSignature(this.doPrivate(new BigInteger(d)).toString(16),this.n.bitLength())},RSAKey.prototype.verify=function(e,t){var r=parseBigInt(t=(t=t.replace(Y,"")).replace(/[ \n]+/g,""),16);if(r.bitLength()>this.n.bitLength())return 0;var n=_rsasign_getAlgNameAndHashFromHexDisgestInfo(this.doPublic(r).toString(16).replace(/^1f+00/,""));if(0==n.length)return!1;var i=n[0];return n[1]==function a(e){return V.crypto.Util.hashString(e,i)}(e)},RSAKey.prototype.verifyWithMessageHash=function(e,t){var r=parseBigInt(t=(t=t.replace(Y,"")).replace(/[ \n]+/g,""),16);if(r.bitLength()>this.n.bitLength())return 0;var n=_rsasign_getAlgNameAndHashFromHexDisgestInfo(this.doPublic(r).toString(16).replace(/^1f+00/,""));if(0==n.length)return!1;n[0];return n[1]==e},RSAKey.prototype.verifyPSS=function(t,r,n,i){var o=function e(t){return V.crypto.Util.hashHex(t,n)}(rstrtohex(t));return void 0===i&&(i=-1),this.verifyWithMessageHashPSS(o,r,n,i)},RSAKey.prototype.verifyWithMessageHashPSS=function(e,t,n,i){var o=new BigInteger(t,16);if(o.bitLength()>this.n.bitLength())return!1;var s,a=function r(e){return V.crypto.Util.hashHex(e,n)},u=hextorstr(e),c=u.length,h=this.n.bitLength()-1,l=Math.ceil(h/8);if(-1===i||void 0===i)i=c;else if(-2===i)i=l-c-2;else if(i<-2)throw"invalid salt length";if(l<c+i+2)throw"data too long";var f=this.doPublic(o).toByteArray();for(s=0;s<f.length;s+=1)f[s]&=255;for(;f.length<l;)f.unshift(0);if(188!==f[l-1])throw"encoded message does not end in 0xbc";var g=(f=String.fromCharCode.apply(String,f)).substr(0,l-c-1),p=f.substr(g.length,c),d=65280>>8*l-h&255;if(0!=(g.charCodeAt(0)&d))throw"bits beyond keysize not zero";var v=pss_mgf1_str(p,g.length,a),y=[];for(s=0;s<g.length;s+=1)y[s]=g.charCodeAt(s)^v.charCodeAt(s);y[0]&=~d;var m=l-c-i-2;for(s=0;s<m;s+=1)if(0!==y[s])throw"leftmost octets not zero";if(1!==y[m])throw"0x01 marker not found";return p===hextorstr(a(rstrtohex("\0\0\0\0\0\0\0\0"+u+String.fromCharCode.apply(String,y.slice(-i)))))},RSAKey.SALT_LEN_HLEN=-1,RSAKey.SALT_LEN_MAX=-2,RSAKey.SALT_LEN_RECOVER=-2,X509.hex2dn=function(e,t){if(void 0===t&&(t=0),"30"!==e.substr(t,2))throw"malformed DN";for(var r=new Array,n=J.getChildIdx(e,t),i=0;i<n.length;i++)r.push(X509.hex2rdn(e,n[i]));return"/"+(r=r.map(function(e){return e.replace("/","\\/")})).join("/")},X509.hex2rdn=function(e,t){if(void 0===t&&(t=0),"31"!==e.substr(t,2))throw"malformed RDN";for(var r=new Array,n=J.getChildIdx(e,t),i=0;i<n.length;i++)r.push(X509.hex2attrTypeValue(e,n[i]));return(r=r.map(function(e){return e.replace("+","\\+")})).join("+")},X509.hex2attrTypeValue=function(e,t){var r=J,n=r.getV;if(void 0===t&&(t=0),"30"!==e.substr(t,2))throw"malformed attribute type and value";var i=r.getChildIdx(e,t);2!==i.length||e.substr(i[0],2);var o=n(e,i[0]),s=V.asn1.ASN1Util.oidHexToInt(o);return V.asn1.x509.OID.oid2atype(s)+"="+hextorstr(n(e,i[1]))},X509.getPublicKeyFromCertHex=function(e){var t=new X509;return t.readCertHex(e),t.getPublicKey()},X509.getPublicKeyFromCertPEM=function(e){var t=new X509;return t.readCertPEM(e),t.getPublicKey()},X509.getPublicKeyInfoPropOfCertPEM=function(e){var t,r,n=J.getVbyList,i={};return i.algparam=null,(t=new X509).readCertPEM(e),r=t.getPublicKeyHex(),i.keyhex=n(r,0,[1],"03").substr(2),i.algoid=n(r,0,[0,0],"06"),"2a8648ce3d0201"===i.algoid&&(i.algparam=n(r,0,[0,1],"06")),i},X509.KEYUSAGE_NAME=["digitalSignature","nonRepudiation","keyEncipherment","dataEncipherment","keyAgreement","keyCertSign","cRLSign","encipherOnly","decipherOnly"],void 0!==V&&V||(t.KJUR=V={}),void 0!==V.jws&&V.jws||(V.jws={}),V.jws.JWS=function(){var e=V.jws.JWS.isSafeJSONString;this.parseJWS=function(t,r){if(void 0===this.parsedJWS||!r&&void 0===this.parsedJWS.sigvalH){var n=t.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);if(null==n)throw"JWS signature is not a form of 'Head.Payload.SigValue'.";var i=n[1],o=n[2],s=n[3],a=i+"."+o;if(this.parsedJWS={},this.parsedJWS.headB64U=i,this.parsedJWS.payloadB64U=o,this.parsedJWS.sigvalB64U=s,this.parsedJWS.si=a,!r){var u=b64utohex(s),c=parseBigInt(u,16);this.parsedJWS.sigvalH=u,this.parsedJWS.sigvalBI=c}var h=W(i),l=W(o);if(this.parsedJWS.headS=h,this.parsedJWS.payloadS=l,!e(h,this.parsedJWS,"headP"))throw"malformed JSON string for JWS Head: "+h}}},V.jws.JWS.sign=function(e,t,r,n,o){var s,a,u,c=V,h=c.jws.JWS,l=h.readSafeJSONString,f=h.isSafeJSONString,g=c.crypto,p=(g.ECDSA,g.Mac),d=g.Signature,v=JSON;if("string"!=typeof t&&"object"!=(void 0===t?"undefined":i(t)))throw"spHeader must be JSON string or object: "+t;if("object"==(void 0===t?"undefined":i(t))&&(a=t,s=v.stringify(a)),"string"==typeof t){if(!f(s=t))throw"JWS Head is not safe JSON string: "+s;a=l(s)}if(u=r,"object"==(void 0===r?"undefined":i(r))&&(u=v.stringify(r)),""!=e&&null!=e||void 0===a.alg||(e=a.alg),""!=e&&null!=e&&void 0===a.alg&&(a.alg=e,s=v.stringify(a)),e!==a.alg)throw"alg and sHeader.alg doesn't match: "+e+"!="+a.alg;var y=null;if(void 0===h.jwsalg2sigalg[e])throw"unsupported alg name: "+e;y=h.jwsalg2sigalg[e];var m=q(s)+"."+q(u),_="";if("Hmac"==y.substr(0,4)){if(void 0===n)throw"mac key shall be specified for HS* alg";var S=new p({alg:y,prov:"cryptojs",pass:n});S.updateString(m),_=S.doFinal()}else{var b;if(-1!=y.indexOf("withECDSA"))(b=new d({alg:y})).init(n,o),b.updateString(m),hASN1Sig=b.sign(),_=V.crypto.ECDSA.asn1SigToConcatSig(hASN1Sig);else if("none"!=y)(b=new d({alg:y})).init(n,o),b.updateString(m),_=b.sign()}return m+"."+hextob64u(_)},V.jws.JWS.verify=function(e,t,r){var n,o=V,s=o.jws.JWS,a=s.readSafeJSONString,u=o.crypto,c=u.ECDSA,h=u.Mac,l=u.Signature;void 0!==i(RSAKey)&&(n=RSAKey);var f=e.split(".");if(3!==f.length)return!1;var g=f[0]+"."+f[1],p=b64utohex(f[2]),d=a(W(f[0])),v=null,y=null;if(void 0===d.alg)throw"algorithm not specified in header";if((y=(v=d.alg).substr(0,2),null!=r&&"[object Array]"===Object.prototype.toString.call(r)&&r.length>0)&&-1==(":"+r.join(":")+":").indexOf(":"+v+":"))throw"algorithm '"+v+"' not accepted in the list";if("none"!=v&&null===t)throw"key shall be specified to verify.";if("string"==typeof t&&-1!=t.indexOf("-----BEGIN ")&&(t=z.getKey(t)),!("RS"!=y&&"PS"!=y||t instanceof n))throw"key shall be a RSAKey obj for RS* and PS* algs";if("ES"==y&&!(t instanceof c))throw"key shall be a ECDSA obj for ES* algs";var m=null;if(void 0===s.jwsalg2sigalg[d.alg])throw"unsupported alg name: "+v;if("none"==(m=s.jwsalg2sigalg[v]))throw"not supported";if("Hmac"==m.substr(0,4)){if(void 0===t)throw"hexadecimal key shall be specified for HMAC";var _=new h({alg:m,pass:t});return _.updateString(g),p==_.doFinal()}if(-1!=m.indexOf("withECDSA")){var S,b=null;try{b=c.concatSigToASN1Sig(p)}catch(e){return!1}return(S=new l({alg:m})).init(t),S.updateString(g),S.verify(b)}return(S=new l({alg:m})).init(t),S.updateString(g),S.verify(p)},V.jws.JWS.parse=function(e){var t,r,n,i=e.split("."),o={};if(2!=i.length&&3!=i.length)throw"malformed sJWS: wrong number of '.' splitted elements";return t=i[0],r=i[1],3==i.length&&(n=i[2]),o.headerObj=V.jws.JWS.readSafeJSONString(W(t)),o.payloadObj=V.jws.JWS.readSafeJSONString(W(r)),o.headerPP=JSON.stringify(o.headerObj,null,"  "),null==o.payloadObj?o.payloadPP=W(r):o.payloadPP=JSON.stringify(o.payloadObj,null,"  "),void 0!==n&&(o.sigHex=b64utohex(n)),o},V.jws.JWS.verifyJWT=function(e,t,r){var n=V.jws,o=n.JWS,s=o.readSafeJSONString,a=o.inArray,u=o.includedArray,c=e.split("."),h=c[0],l=c[1],f=(b64utohex(c[2]),s(W(h))),g=s(W(l));if(void 0===f.alg)return!1;if(void 0===r.alg)throw"acceptField.alg shall be specified";if(!a(f.alg,r.alg))return!1;if(void 0!==g.iss&&"object"===i(r.iss)&&!a(g.iss,r.iss))return!1;if(void 0!==g.sub&&"object"===i(r.sub)&&!a(g.sub,r.sub))return!1;if(void 0!==g.aud&&"object"===i(r.aud))if("string"==typeof g.aud){if(!a(g.aud,r.aud))return!1}else if("object"==i(g.aud)&&!u(g.aud,r.aud))return!1;var p=n.IntDate.getNow();return void 0!==r.verifyAt&&"number"==typeof r.verifyAt&&(p=r.verifyAt),void 0!==r.gracePeriod&&"number"==typeof r.gracePeriod||(r.gracePeriod=0),!(void 0!==g.exp&&"number"==typeof g.exp&&g.exp+r.gracePeriod<p)&&(!(void 0!==g.nbf&&"number"==typeof g.nbf&&p<g.nbf-r.gracePeriod)&&(!(void 0!==g.iat&&"number"==typeof g.iat&&p<g.iat-r.gracePeriod)&&((void 0===g.jti||void 0===r.jti||g.jti===r.jti)&&!!o.verify(e,t,r.alg))))},V.jws.JWS.includedArray=function(e,t){var r=V.jws.JWS.inArray;if(null===e)return!1;if("object"!==(void 0===e?"undefined":i(e)))return!1;if("number"!=typeof e.length)return!1;for(var n=0;n<e.length;n++)if(!r(e[n],t))return!1;return!0},V.jws.JWS.inArray=function(e,t){if(null===t)return!1;if("object"!==(void 0===t?"undefined":i(t)))return!1;if("number"!=typeof t.length)return!1;for(var r=0;r<t.length;r++)if(t[r]==e)return!0;return!1},V.jws.JWS.jwsalg2sigalg={HS256:"HmacSHA256",HS384:"HmacSHA384",HS512:"HmacSHA512",RS256:"SHA256withRSA",RS384:"SHA384withRSA",RS512:"SHA512withRSA",ES256:"SHA256withECDSA",ES384:"SHA384withECDSA",PS256:"SHA256withRSAandMGF1",PS384:"SHA384withRSAandMGF1",PS512:"SHA512withRSAandMGF1",none:"none"},V.jws.JWS.isSafeJSONString=function(e,t,r){var n=null;try{return"object"!=(void 0===(n=K(e))?"undefined":i(n))?0:n.constructor===Array?0:(t&&(t[r]=n),1)}catch(e){return 0}},V.jws.JWS.readSafeJSONString=function(e){var t=null;try{return"object"!=(void 0===(t=K(e))?"undefined":i(t))?null:t.constructor===Array?null:t}catch(e){return null}},V.jws.JWS.getEncodedSignatureValueFromJWS=function(e){var t=e.match(/^[^.]+\.[^.]+\.([^.]+)$/);if(null==t)throw"JWS signature is not a form of 'Head.Payload.SigValue'.";return t[1]},V.jws.JWS.getJWKthumbprint=function(e){if("RSA"!==e.kty&&"EC"!==e.kty&&"oct"!==e.kty)throw"unsupported algorithm for JWK Thumprint";var t="{";if("RSA"===e.kty){if("string"!=typeof e.n||"string"!=typeof e.e)throw"wrong n and e value for RSA key";t+='"e":"'+e.e+'",',t+='"kty":"'+e.kty+'",',t+='"n":"'+e.n+'"}'}else if("EC"===e.kty){if("string"!=typeof e.crv||"string"!=typeof e.x||"string"!=typeof e.y)throw"wrong crv, x and y value for EC key";t+='"crv":"'+e.crv+'",',t+='"kty":"'+e.kty+'",',t+='"x":"'+e.x+'",',t+='"y":"'+e.y+'"}'}else if("oct"===e.kty){if("string"!=typeof e.k)throw"wrong k value for oct(symmetric) key";t+='"kty":"'+e.kty+'",',t+='"k":"'+e.k+'"}'}var r=rstrtohex(t);return hextob64u(V.crypto.Util.hashHex(r,"sha256"))},V.jws.IntDate={},V.jws.IntDate.get=function(e){var t=V.jws.IntDate,r=t.getNow,n=t.getZulu;if("now"==e)return r();if("now + 1hour"==e)return r()+3600;if("now + 1day"==e)return r()+86400;if("now + 1month"==e)return r()+2592e3;if("now + 1year"==e)return r()+31536e3;if(e.match(/Z$/))return n(e);if(e.match(/^[0-9]+$/))return parseInt(e);throw"unsupported format: "+e},V.jws.IntDate.getZulu=function(e){return zulutosec(e)},V.jws.IntDate.getNow=function(){return~~(new Date/1e3)},V.jws.IntDate.intDate2UTCString=function(e){return new Date(1e3*e).toUTCString()},V.jws.IntDate.intDate2Zulu=function(e){var t=new Date(1e3*e);return("0000"+t.getUTCFullYear()).slice(-4)+("00"+(t.getUTCMonth()+1)).slice(-2)+("00"+t.getUTCDate()).slice(-2)+("00"+t.getUTCHours()).slice(-2)+("00"+t.getUTCMinutes()).slice(-2)+("00"+t.getUTCSeconds()).slice(-2)+"Z"},t.SecureRandom=SecureRandom,t.rng_seed_time=rng_seed_time,t.BigInteger=BigInteger,t.RSAKey=RSAKey;var G=V.crypto.EDSA;t.EDSA=G;var X=V.crypto.DSA;t.DSA=X;var Q=V.crypto.Signature;t.Signature=Q;var $=V.crypto.MessageDigest;t.MessageDigest=$;var Z=V.crypto.Mac;t.Mac=Z;var ee=V.crypto.Cipher;t.Cipher=ee,t.KEYUTIL=z,t.ASN1HEX=J,t.X509=X509,t.CryptoJS=y,t.b64tohex=b64tohex,t.b64toBA=b64toBA,t.stoBA=stoBA,t.BAtos=BAtos,t.BAtohex=BAtohex,t.stohex=stohex,t.stob64=function stob64(e){return hex2b64(stohex(e))},t.stob64u=function stob64u(e){return b64tob64u(hex2b64(stohex(e)))},t.b64utos=function b64utos(e){return BAtos(b64toBA(b64utob64(e)))},t.b64tob64u=b64tob64u,t.b64utob64=b64utob64,t.hex2b64=hex2b64,t.hextob64u=hextob64u,t.b64utohex=b64utohex,t.utf8tob64u=q,t.b64utoutf8=W,t.utf8tob64=function utf8tob64(e){return hex2b64(uricmptohex(encodeURIComponentAll(e)))},t.b64toutf8=function b64toutf8(e){return decodeURIComponent(hextouricmp(b64tohex(e)))},t.utf8tohex=utf8tohex,t.hextoutf8=hextoutf8,t.hextorstr=hextorstr,t.rstrtohex=rstrtohex,t.hextob64=hextob64,t.hextob64nl=hextob64nl,t.b64nltohex=b64nltohex,t.hextopem=hextopem,t.pemtohex=pemtohex,t.hextoArrayBuffer=function hextoArrayBuffer(e){if(e.length%2!=0)throw"input is not even length";if(null==e.match(/^[0-9A-Fa-f]+$/))throw"input is not hexadecimal";for(var t=new ArrayBuffer(e.length/2),r=new DataView(t),n=0;n<e.length/2;n++)r.setUint8(n,parseInt(e.substr(2*n,2),16));return t},t.ArrayBuffertohex=function ArrayBuffertohex(e){for(var t="",r=new DataView(e),n=0;n<e.byteLength;n++)t+=("00"+r.getUint8(n).toString(16)).slice(-2);return t},t.zulutomsec=zulutomsec,t.zulutosec=zulutosec,t.zulutodate=function zulutodate(e){return new Date(zulutomsec(e))},t.datetozulu=function datetozulu(e,t,r){var n,i=e.getUTCFullYear();if(t){if(i<1950||2049<i)throw"not proper year for UTCTime: "+i;n=(""+i).slice(-2)}else n=("000"+i).slice(-4);if(n+=("0"+(e.getUTCMonth()+1)).slice(-2),n+=("0"+e.getUTCDate()).slice(-2),n+=("0"+e.getUTCHours()).slice(-2),n+=("0"+e.getUTCMinutes()).slice(-2),n+=("0"+e.getUTCSeconds()).slice(-2),r){var o=e.getUTCMilliseconds();0!==o&&(n+="."+(o=(o=("00"+o).slice(-3)).replace(/0+$/g,"")))}return n+="Z"},t.uricmptohex=uricmptohex,t.hextouricmp=hextouricmp,t.ipv6tohex=ipv6tohex,t.hextoipv6=hextoipv6,t.hextoip=hextoip,t.iptohex=function iptohex(e){var t="malformed IP address";if(!(e=e.toLowerCase(e)).match(/^[0-9.]+$/)){if(e.match(/^[0-9a-f:]+$/)&&-1!==e.indexOf(":"))return ipv6tohex(e);throw t}var r=e.split(".");if(4!==r.length)throw t;var n="";try{for(var i=0;i<4;i++)n+=("0"+parseInt(r[i]).toString(16)).slice(-2);return n}catch(e){throw t}},t.encodeURIComponentAll=encodeURIComponentAll,t.newline_toUnix=function newline_toUnix(e){return e=e.replace(/\r\n/gm,"\n")},t.newline_toDos=function newline_toDos(e){return e=(e=e.replace(/\r\n/gm,"\n")).replace(/\n/gm,"\r\n")},t.hextoposhex=hextoposhex,t.intarystrtohex=function intarystrtohex(e){e=(e=(e=e.replace(/^\s*\[\s*/,"")).replace(/\s*\]\s*$/,"")).replace(/\s*/g,"");try{return e.split(/,/).map(function(e,t,r){var n=parseInt(e);if(n<0||255<n)throw"integer not in range 0-255";return("00"+n.toString(16)).slice(-2)}).join("")}catch(e){throw"malformed integer array string: "+e}},t.strdiffidx=function strdiffidx(e,t){var r=e.length;e.length>t.length&&(r=t.length);for(var n=0;n<r;n++)if(e.charCodeAt(n)!=t.charCodeAt(n))return n;return e.length!=t.length?r:-1},t.KJUR=V;var te=V.crypto;t.crypto=te;var re=V.asn1;t.asn1=re;var ne=V.jws;t.jws=ne;var ie=V.lang;t.lang=ie}).call(this,r(27).Buffer)},function(e,t,r){"use strict";(function(e){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var n=r(29),i=r(30),o=r(31);function kMaxLength(){return Buffer.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function createBuffer(e,t){if(kMaxLength()<t)throw new RangeError("Invalid typed array length");return Buffer.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(t)).__proto__=Buffer.prototype:(null===e&&(e=new Buffer(t)),e.length=t),e}function Buffer(e,t,r){if(!(Buffer.TYPED_ARRAY_SUPPORT||this instanceof Buffer))return new Buffer(e,t,r);if("number"==typeof e){if("string"==typeof t)throw new Error("If encoding is specified then the first argument must be a string");return allocUnsafe(this,e)}return from(this,e,t,r)}function from(e,t,r,n){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer?function fromArrayBuffer(e,t,r,n){if(t.byteLength,r<0||t.byteLength<r)throw new RangeError("'offset' is out of bounds");if(t.byteLength<r+(n||0))throw new RangeError("'length' is out of bounds");t=void 0===r&&void 0===n?new Uint8Array(t):void 0===n?new Uint8Array(t,r):new Uint8Array(t,r,n);Buffer.TYPED_ARRAY_SUPPORT?(e=t).__proto__=Buffer.prototype:e=fromArrayLike(e,t);return e}(e,t,r,n):"string"==typeof t?function fromString(e,t,r){"string"==typeof r&&""!==r||(r="utf8");if(!Buffer.isEncoding(r))throw new TypeError('"encoding" must be a valid string encoding');var n=0|byteLength(t,r),i=(e=createBuffer(e,n)).write(t,r);i!==n&&(e=e.slice(0,i));return e}(e,t,r):function fromObject(e,t){if(Buffer.isBuffer(t)){var r=0|checked(t.length);return 0===(e=createBuffer(e,r)).length?e:(t.copy(e,0,0,r),e)}if(t){if("undefined"!=typeof ArrayBuffer&&t.buffer instanceof ArrayBuffer||"length"in t)return"number"!=typeof t.length||function isnan(e){return e!=e}(t.length)?createBuffer(e,0):fromArrayLike(e,t);if("Buffer"===t.type&&o(t.data))return fromArrayLike(e,t.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(e,t)}function assertSize(e){if("number"!=typeof e)throw new TypeError('"size" argument must be a number');if(e<0)throw new RangeError('"size" argument must not be negative')}function allocUnsafe(e,t){if(assertSize(t),e=createBuffer(e,t<0?0:0|checked(t)),!Buffer.TYPED_ARRAY_SUPPORT)for(var r=0;r<t;++r)e[r]=0;return e}function fromArrayLike(e,t){var r=t.length<0?0:0|checked(t.length);e=createBuffer(e,r);for(var n=0;n<r;n+=1)e[n]=255&t[n];return e}function checked(e){if(e>=kMaxLength())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+kMaxLength().toString(16)+" bytes");return 0|e}function byteLength(e,t){if(Buffer.isBuffer(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var r=e.length;if(0===r)return 0;for(var n=!1;;)switch(t){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":case void 0:return utf8ToBytes(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return base64ToBytes(e).length;default:if(n)return utf8ToBytes(e).length;t=(""+t).toLowerCase(),n=!0}}function swap(e,t,r){var n=e[t];e[t]=e[r],e[r]=n}function bidirectionalIndexOf(e,t,r,n,i){if(0===e.length)return-1;if("string"==typeof r?(n=r,r=0):r>2147483647?r=2147483647:r<-2147483648&&(r=-2147483648),r=+r,isNaN(r)&&(r=i?0:e.length-1),r<0&&(r=e.length+r),r>=e.length){if(i)return-1;r=e.length-1}else if(r<0){if(!i)return-1;r=0}if("string"==typeof t&&(t=Buffer.from(t,n)),Buffer.isBuffer(t))return 0===t.length?-1:arrayIndexOf(e,t,r,n,i);if("number"==typeof t)return t&=255,Buffer.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(e,t,r):Uint8Array.prototype.lastIndexOf.call(e,t,r):arrayIndexOf(e,[t],r,n,i);throw new TypeError("val must be string, number or Buffer")}function arrayIndexOf(e,t,r,n,i){var o,s=1,a=e.length,u=t.length;if(void 0!==n&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(e.length<2||t.length<2)return-1;s=2,a/=2,u/=2,r/=2}function read(e,t){return 1===s?e[t]:e.readUInt16BE(t*s)}if(i){var c=-1;for(o=r;o<a;o++)if(read(e,o)===read(t,-1===c?0:o-c)){if(-1===c&&(c=o),o-c+1===u)return c*s}else-1!==c&&(o-=o-c),c=-1}else for(r+u>a&&(r=a-u),o=r;o>=0;o--){for(var h=!0,l=0;l<u;l++)if(read(e,o+l)!==read(t,l)){h=!1;break}if(h)return o}return-1}function hexWrite(e,t,r,n){r=Number(r)||0;var i=e.length-r;n?(n=Number(n))>i&&(n=i):n=i;var o=t.length;if(o%2!=0)throw new TypeError("Invalid hex string");n>o/2&&(n=o/2);for(var s=0;s<n;++s){var a=parseInt(t.substr(2*s,2),16);if(isNaN(a))return s;e[r+s]=a}return s}function utf8Write(e,t,r,n){return blitBuffer(utf8ToBytes(t,e.length-r),e,r,n)}function asciiWrite(e,t,r,n){return blitBuffer(function asciiToBytes(e){for(var t=[],r=0;r<e.length;++r)t.push(255&e.charCodeAt(r));return t}(t),e,r,n)}function latin1Write(e,t,r,n){return asciiWrite(e,t,r,n)}function base64Write(e,t,r,n){return blitBuffer(base64ToBytes(t),e,r,n)}function ucs2Write(e,t,r,n){return blitBuffer(function utf16leToBytes(e,t){for(var r,n,i,o=[],s=0;s<e.length&&!((t-=2)<0);++s)r=e.charCodeAt(s),n=r>>8,i=r%256,o.push(i),o.push(n);return o}(t,e.length-r),e,r,n)}function base64Slice(e,t,r){return 0===t&&r===e.length?n.fromByteArray(e):n.fromByteArray(e.slice(t,r))}function utf8Slice(e,t,r){r=Math.min(e.length,r);for(var n=[],i=t;i<r;){var o,a,u,c,h=e[i],l=null,f=h>239?4:h>223?3:h>191?2:1;if(i+f<=r)switch(f){case 1:h<128&&(l=h);break;case 2:128==(192&(o=e[i+1]))&&(c=(31&h)<<6|63&o)>127&&(l=c);break;case 3:o=e[i+1],a=e[i+2],128==(192&o)&&128==(192&a)&&(c=(15&h)<<12|(63&o)<<6|63&a)>2047&&(c<55296||c>57343)&&(l=c);break;case 4:o=e[i+1],a=e[i+2],u=e[i+3],128==(192&o)&&128==(192&a)&&128==(192&u)&&(c=(15&h)<<18|(63&o)<<12|(63&a)<<6|63&u)>65535&&c<1114112&&(l=c)}null===l?(l=65533,f=1):l>65535&&(l-=65536,n.push(l>>>10&1023|55296),l=56320|1023&l),n.push(l),i+=f}return function decodeCodePointsArray(e){var t=e.length;if(t<=s)return String.fromCharCode.apply(String,e);var r="",n=0;for(;n<t;)r+=String.fromCharCode.apply(String,e.slice(n,n+=s));return r}(n)}t.Buffer=Buffer,t.SlowBuffer=function SlowBuffer(e){+e!=e&&(e=0);return Buffer.alloc(+e)},t.INSPECT_MAX_BYTES=50,Buffer.TYPED_ARRAY_SUPPORT=void 0!==e.TYPED_ARRAY_SUPPORT?e.TYPED_ARRAY_SUPPORT:function typedArraySupport(){try{var e=new Uint8Array(1);return e.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===e.foo()&&"function"==typeof e.subarray&&0===e.subarray(1,1).byteLength}catch(e){return!1}}(),t.kMaxLength=kMaxLength(),Buffer.poolSize=8192,Buffer._augment=function(e){return e.__proto__=Buffer.prototype,e},Buffer.from=function(e,t,r){return from(null,e,t,r)},Buffer.TYPED_ARRAY_SUPPORT&&(Buffer.prototype.__proto__=Uint8Array.prototype,Buffer.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&Buffer[Symbol.species]===Buffer&&Object.defineProperty(Buffer,Symbol.species,{value:null,configurable:!0})),Buffer.alloc=function(e,t,r){return function alloc(e,t,r,n){return assertSize(t),t<=0?createBuffer(e,t):void 0!==r?"string"==typeof n?createBuffer(e,t).fill(r,n):createBuffer(e,t).fill(r):createBuffer(e,t)}(null,e,t,r)},Buffer.allocUnsafe=function(e){return allocUnsafe(null,e)},Buffer.allocUnsafeSlow=function(e){return allocUnsafe(null,e)},Buffer.isBuffer=function isBuffer(e){return!(null==e||!e._isBuffer)},Buffer.compare=function compare(e,t){if(!Buffer.isBuffer(e)||!Buffer.isBuffer(t))throw new TypeError("Arguments must be Buffers");if(e===t)return 0;for(var r=e.length,n=t.length,i=0,o=Math.min(r,n);i<o;++i)if(e[i]!==t[i]){r=e[i],n=t[i];break}return r<n?-1:n<r?1:0},Buffer.isEncoding=function isEncoding(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},Buffer.concat=function concat(e,t){if(!o(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return Buffer.alloc(0);var r;if(void 0===t)for(t=0,r=0;r<e.length;++r)t+=e[r].length;var n=Buffer.allocUnsafe(t),i=0;for(r=0;r<e.length;++r){var s=e[r];if(!Buffer.isBuffer(s))throw new TypeError('"list" argument must be an Array of Buffers');s.copy(n,i),i+=s.length}return n},Buffer.byteLength=byteLength,Buffer.prototype._isBuffer=!0,Buffer.prototype.swap16=function swap16(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var t=0;t<e;t+=2)swap(this,t,t+1);return this},Buffer.prototype.swap32=function swap32(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var t=0;t<e;t+=4)swap(this,t,t+3),swap(this,t+1,t+2);return this},Buffer.prototype.swap64=function swap64(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var t=0;t<e;t+=8)swap(this,t,t+7),swap(this,t+1,t+6),swap(this,t+2,t+5),swap(this,t+3,t+4);return this},Buffer.prototype.toString=function toString(){var e=0|this.length;return 0===e?"":0===arguments.length?utf8Slice(this,0,e):function slowToString(e,t,r){var n=!1;if((void 0===t||t<0)&&(t=0),t>this.length)return"";if((void 0===r||r>this.length)&&(r=this.length),r<=0)return"";if((r>>>=0)<=(t>>>=0))return"";for(e||(e="utf8");;)switch(e){case"hex":return hexSlice(this,t,r);case"utf8":case"utf-8":return utf8Slice(this,t,r);case"ascii":return asciiSlice(this,t,r);case"latin1":case"binary":return latin1Slice(this,t,r);case"base64":return base64Slice(this,t,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return utf16leSlice(this,t,r);default:if(n)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),n=!0}}.apply(this,arguments)},Buffer.prototype.equals=function equals(e){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e||0===Buffer.compare(this,e)},Buffer.prototype.inspect=function inspect(){var e="",r=t.INSPECT_MAX_BYTES;return this.length>0&&(e=this.toString("hex",0,r).match(/.{2}/g).join(" "),this.length>r&&(e+=" ... ")),"<Buffer "+e+">"},Buffer.prototype.compare=function compare(e,t,r,n,i){if(!Buffer.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(void 0===t&&(t=0),void 0===r&&(r=e?e.length:0),void 0===n&&(n=0),void 0===i&&(i=this.length),t<0||r>e.length||n<0||i>this.length)throw new RangeError("out of range index");if(n>=i&&t>=r)return 0;if(n>=i)return-1;if(t>=r)return 1;if(t>>>=0,r>>>=0,n>>>=0,i>>>=0,this===e)return 0;for(var o=i-n,s=r-t,a=Math.min(o,s),u=this.slice(n,i),c=e.slice(t,r),h=0;h<a;++h)if(u[h]!==c[h]){o=u[h],s=c[h];break}return o<s?-1:s<o?1:0},Buffer.prototype.includes=function includes(e,t,r){return-1!==this.indexOf(e,t,r)},Buffer.prototype.indexOf=function indexOf(e,t,r){return bidirectionalIndexOf(this,e,t,r,!0)},Buffer.prototype.lastIndexOf=function lastIndexOf(e,t,r){return bidirectionalIndexOf(this,e,t,r,!1)},Buffer.prototype.write=function write(e,t,r,n){if(void 0===t)n="utf8",r=this.length,t=0;else if(void 0===r&&"string"==typeof t)n=t,r=this.length,t=0;else{if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t|=0,isFinite(r)?(r|=0,void 0===n&&(n="utf8")):(n=r,r=void 0)}var i=this.length-t;if((void 0===r||r>i)&&(r=i),e.length>0&&(r<0||t<0)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");n||(n="utf8");for(var o=!1;;)switch(n){case"hex":return hexWrite(this,e,t,r);case"utf8":case"utf-8":return utf8Write(this,e,t,r);case"ascii":return asciiWrite(this,e,t,r);case"latin1":case"binary":return latin1Write(this,e,t,r);case"base64":return base64Write(this,e,t,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ucs2Write(this,e,t,r);default:if(o)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),o=!0}},Buffer.prototype.toJSON=function toJSON(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var s=4096;function asciiSlice(e,t,r){var n="";r=Math.min(e.length,r);for(var i=t;i<r;++i)n+=String.fromCharCode(127&e[i]);return n}function latin1Slice(e,t,r){var n="";r=Math.min(e.length,r);for(var i=t;i<r;++i)n+=String.fromCharCode(e[i]);return n}function hexSlice(e,t,r){var n=e.length;(!t||t<0)&&(t=0),(!r||r<0||r>n)&&(r=n);for(var i="",o=t;o<r;++o)i+=toHex(e[o]);return i}function utf16leSlice(e,t,r){for(var n=e.slice(t,r),i="",o=0;o<n.length;o+=2)i+=String.fromCharCode(n[o]+256*n[o+1]);return i}function checkOffset(e,t,r){if(e%1!=0||e<0)throw new RangeError("offset is not uint");if(e+t>r)throw new RangeError("Trying to access beyond buffer length")}function checkInt(e,t,r,n,i,o){if(!Buffer.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>i||t<o)throw new RangeError('"value" argument is out of bounds');if(r+n>e.length)throw new RangeError("Index out of range")}function objectWriteUInt16(e,t,r,n){t<0&&(t=65535+t+1);for(var i=0,o=Math.min(e.length-r,2);i<o;++i)e[r+i]=(t&255<<8*(n?i:1-i))>>>8*(n?i:1-i)}function objectWriteUInt32(e,t,r,n){t<0&&(t=4294967295+t+1);for(var i=0,o=Math.min(e.length-r,4);i<o;++i)e[r+i]=t>>>8*(n?i:3-i)&255}function checkIEEE754(e,t,r,n,i,o){if(r+n>e.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("Index out of range")}function writeFloat(e,t,r,n,o){return o||checkIEEE754(e,0,r,4),i.write(e,t,r,n,23,4),r+4}function writeDouble(e,t,r,n,o){return o||checkIEEE754(e,0,r,8),i.write(e,t,r,n,52,8),r+8}Buffer.prototype.slice=function slice(e,t){var r,n=this.length;if(e=~~e,t=void 0===t?n:~~t,e<0?(e+=n)<0&&(e=0):e>n&&(e=n),t<0?(t+=n)<0&&(t=0):t>n&&(t=n),t<e&&(t=e),Buffer.TYPED_ARRAY_SUPPORT)(r=this.subarray(e,t)).__proto__=Buffer.prototype;else{var i=t-e;r=new Buffer(i,void 0);for(var o=0;o<i;++o)r[o]=this[o+e]}return r},Buffer.prototype.readUIntLE=function readUIntLE(e,t,r){e|=0,t|=0,r||checkOffset(e,t,this.length);for(var n=this[e],i=1,o=0;++o<t&&(i*=256);)n+=this[e+o]*i;return n},Buffer.prototype.readUIntBE=function readUIntBE(e,t,r){e|=0,t|=0,r||checkOffset(e,t,this.length);for(var n=this[e+--t],i=1;t>0&&(i*=256);)n+=this[e+--t]*i;return n},Buffer.prototype.readUInt8=function readUInt8(e,t){return t||checkOffset(e,1,this.length),this[e]},Buffer.prototype.readUInt16LE=function readUInt16LE(e,t){return t||checkOffset(e,2,this.length),this[e]|this[e+1]<<8},Buffer.prototype.readUInt16BE=function readUInt16BE(e,t){return t||checkOffset(e,2,this.length),this[e]<<8|this[e+1]},Buffer.prototype.readUInt32LE=function readUInt32LE(e,t){return t||checkOffset(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},Buffer.prototype.readUInt32BE=function readUInt32BE(e,t){return t||checkOffset(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},Buffer.prototype.readIntLE=function readIntLE(e,t,r){e|=0,t|=0,r||checkOffset(e,t,this.length);for(var n=this[e],i=1,o=0;++o<t&&(i*=256);)n+=this[e+o]*i;return n>=(i*=128)&&(n-=Math.pow(2,8*t)),n},Buffer.prototype.readIntBE=function readIntBE(e,t,r){e|=0,t|=0,r||checkOffset(e,t,this.length);for(var n=t,i=1,o=this[e+--n];n>0&&(i*=256);)o+=this[e+--n]*i;return o>=(i*=128)&&(o-=Math.pow(2,8*t)),o},Buffer.prototype.readInt8=function readInt8(e,t){return t||checkOffset(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},Buffer.prototype.readInt16LE=function readInt16LE(e,t){t||checkOffset(e,2,this.length);var r=this[e]|this[e+1]<<8;return 32768&r?4294901760|r:r},Buffer.prototype.readInt16BE=function readInt16BE(e,t){t||checkOffset(e,2,this.length);var r=this[e+1]|this[e]<<8;return 32768&r?4294901760|r:r},Buffer.prototype.readInt32LE=function readInt32LE(e,t){return t||checkOffset(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},Buffer.prototype.readInt32BE=function readInt32BE(e,t){return t||checkOffset(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},Buffer.prototype.readFloatLE=function readFloatLE(e,t){return t||checkOffset(e,4,this.length),i.read(this,e,!0,23,4)},Buffer.prototype.readFloatBE=function readFloatBE(e,t){return t||checkOffset(e,4,this.length),i.read(this,e,!1,23,4)},Buffer.prototype.readDoubleLE=function readDoubleLE(e,t){return t||checkOffset(e,8,this.length),i.read(this,e,!0,52,8)},Buffer.prototype.readDoubleBE=function readDoubleBE(e,t){return t||checkOffset(e,8,this.length),i.read(this,e,!1,52,8)},Buffer.prototype.writeUIntLE=function writeUIntLE(e,t,r,n){(e=+e,t|=0,r|=0,n)||checkInt(this,e,t,r,Math.pow(2,8*r)-1,0);var i=1,o=0;for(this[t]=255&e;++o<r&&(i*=256);)this[t+o]=e/i&255;return t+r},Buffer.prototype.writeUIntBE=function writeUIntBE(e,t,r,n){(e=+e,t|=0,r|=0,n)||checkInt(this,e,t,r,Math.pow(2,8*r)-1,0);var i=r-1,o=1;for(this[t+i]=255&e;--i>=0&&(o*=256);)this[t+i]=e/o&255;return t+r},Buffer.prototype.writeUInt8=function writeUInt8(e,t,r){return e=+e,t|=0,r||checkInt(this,e,t,1,255,0),Buffer.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[t]=255&e,t+1},Buffer.prototype.writeUInt16LE=function writeUInt16LE(e,t,r){return e=+e,t|=0,r||checkInt(this,e,t,2,65535,0),Buffer.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):objectWriteUInt16(this,e,t,!0),t+2},Buffer.prototype.writeUInt16BE=function writeUInt16BE(e,t,r){return e=+e,t|=0,r||checkInt(this,e,t,2,65535,0),Buffer.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):objectWriteUInt16(this,e,t,!1),t+2},Buffer.prototype.writeUInt32LE=function writeUInt32LE(e,t,r){return e=+e,t|=0,r||checkInt(this,e,t,4,4294967295,0),Buffer.TYPED_ARRAY_SUPPORT?(this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e):objectWriteUInt32(this,e,t,!0),t+4},Buffer.prototype.writeUInt32BE=function writeUInt32BE(e,t,r){return e=+e,t|=0,r||checkInt(this,e,t,4,4294967295,0),Buffer.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):objectWriteUInt32(this,e,t,!1),t+4},Buffer.prototype.writeIntLE=function writeIntLE(e,t,r,n){if(e=+e,t|=0,!n){var i=Math.pow(2,8*r-1);checkInt(this,e,t,r,i-1,-i)}var o=0,s=1,a=0;for(this[t]=255&e;++o<r&&(s*=256);)e<0&&0===a&&0!==this[t+o-1]&&(a=1),this[t+o]=(e/s>>0)-a&255;return t+r},Buffer.prototype.writeIntBE=function writeIntBE(e,t,r,n){if(e=+e,t|=0,!n){var i=Math.pow(2,8*r-1);checkInt(this,e,t,r,i-1,-i)}var o=r-1,s=1,a=0;for(this[t+o]=255&e;--o>=0&&(s*=256);)e<0&&0===a&&0!==this[t+o+1]&&(a=1),this[t+o]=(e/s>>0)-a&255;return t+r},Buffer.prototype.writeInt8=function writeInt8(e,t,r){return e=+e,t|=0,r||checkInt(this,e,t,1,127,-128),Buffer.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[t]=255&e,t+1},Buffer.prototype.writeInt16LE=function writeInt16LE(e,t,r){return e=+e,t|=0,r||checkInt(this,e,t,2,32767,-32768),Buffer.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):objectWriteUInt16(this,e,t,!0),t+2},Buffer.prototype.writeInt16BE=function writeInt16BE(e,t,r){return e=+e,t|=0,r||checkInt(this,e,t,2,32767,-32768),Buffer.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):objectWriteUInt16(this,e,t,!1),t+2},Buffer.prototype.writeInt32LE=function writeInt32LE(e,t,r){return e=+e,t|=0,r||checkInt(this,e,t,4,2147483647,-2147483648),Buffer.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24):objectWriteUInt32(this,e,t,!0),t+4},Buffer.prototype.writeInt32BE=function writeInt32BE(e,t,r){return e=+e,t|=0,r||checkInt(this,e,t,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),Buffer.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):objectWriteUInt32(this,e,t,!1),t+4},Buffer.prototype.writeFloatLE=function writeFloatLE(e,t,r){return writeFloat(this,e,t,!0,r)},Buffer.prototype.writeFloatBE=function writeFloatBE(e,t,r){return writeFloat(this,e,t,!1,r)},Buffer.prototype.writeDoubleLE=function writeDoubleLE(e,t,r){return writeDouble(this,e,t,!0,r)},Buffer.prototype.writeDoubleBE=function writeDoubleBE(e,t,r){return writeDouble(this,e,t,!1,r)},Buffer.prototype.copy=function copy(e,t,r,n){if(r||(r=0),n||0===n||(n=this.length),t>=e.length&&(t=e.length),t||(t=0),n>0&&n<r&&(n=r),n===r)return 0;if(0===e.length||0===this.length)return 0;if(t<0)throw new RangeError("targetStart out of bounds");if(r<0||r>=this.length)throw new RangeError("sourceStart out of bounds");if(n<0)throw new RangeError("sourceEnd out of bounds");n>this.length&&(n=this.length),e.length-t<n-r&&(n=e.length-t+r);var i,o=n-r;if(this===e&&r<t&&t<n)for(i=o-1;i>=0;--i)e[i+t]=this[i+r];else if(o<1e3||!Buffer.TYPED_ARRAY_SUPPORT)for(i=0;i<o;++i)e[i+t]=this[i+r];else Uint8Array.prototype.set.call(e,this.subarray(r,r+o),t);return o},Buffer.prototype.fill=function fill(e,t,r,n){if("string"==typeof e){if("string"==typeof t?(n=t,t=0,r=this.length):"string"==typeof r&&(n=r,r=this.length),1===e.length){var i=e.charCodeAt(0);i<256&&(e=i)}if(void 0!==n&&"string"!=typeof n)throw new TypeError("encoding must be a string");if("string"==typeof n&&!Buffer.isEncoding(n))throw new TypeError("Unknown encoding: "+n)}else"number"==typeof e&&(e&=255);if(t<0||this.length<t||this.length<r)throw new RangeError("Out of range index");if(r<=t)return this;var o;if(t>>>=0,r=void 0===r?this.length:r>>>0,e||(e=0),"number"==typeof e)for(o=t;o<r;++o)this[o]=e;else{var s=Buffer.isBuffer(e)?e:utf8ToBytes(new Buffer(e,n).toString()),a=s.length;for(o=0;o<r-t;++o)this[o+t]=s[o%a]}return this};var a=/[^+\/0-9A-Za-z-_]/g;function toHex(e){return e<16?"0"+e.toString(16):e.toString(16)}function utf8ToBytes(e,t){var r;t=t||1/0;for(var n=e.length,i=null,o=[],s=0;s<n;++s){if((r=e.charCodeAt(s))>55295&&r<57344){if(!i){if(r>56319){(t-=3)>-1&&o.push(239,191,189);continue}if(s+1===n){(t-=3)>-1&&o.push(239,191,189);continue}i=r;continue}if(r<56320){(t-=3)>-1&&o.push(239,191,189),i=r;continue}r=65536+(i-55296<<10|r-56320)}else i&&(t-=3)>-1&&o.push(239,191,189);if(i=null,r<128){if((t-=1)<0)break;o.push(r)}else if(r<2048){if((t-=2)<0)break;o.push(r>>6|192,63&r|128)}else if(r<65536){if((t-=3)<0)break;o.push(r>>12|224,r>>6&63|128,63&r|128)}else{if(!(r<1114112))throw new Error("Invalid code point");if((t-=4)<0)break;o.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128)}}return o}function base64ToBytes(e){return n.toByteArray(function base64clean(e){if((e=function stringtrim(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")}(e).replace(a,"")).length<2)return"";for(;e.length%4!=0;)e+="=";return e}(e))}function blitBuffer(e,t,r,n){for(var i=0;i<n&&!(i+r>=t.length||i>=e.length);++i)t[i+r]=e[i];return i}}).call(this,r(28))},function(e,t){var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(e){"object"==typeof window&&(r=window)}e.exports=r},function(e,t,r){"use strict";t.byteLength=function byteLength(e){var t=getLens(e),r=t[0],n=t[1];return 3*(r+n)/4-n},t.toByteArray=function toByteArray(e){for(var t,r=getLens(e),n=r[0],s=r[1],a=new o(function _byteLength(e,t,r){return 3*(t+r)/4-r}(0,n,s)),u=0,c=s>0?n-4:n,h=0;h<c;h+=4)t=i[e.charCodeAt(h)]<<18|i[e.charCodeAt(h+1)]<<12|i[e.charCodeAt(h+2)]<<6|i[e.charCodeAt(h+3)],a[u++]=t>>16&255,a[u++]=t>>8&255,a[u++]=255&t;2===s&&(t=i[e.charCodeAt(h)]<<2|i[e.charCodeAt(h+1)]>>4,a[u++]=255&t);1===s&&(t=i[e.charCodeAt(h)]<<10|i[e.charCodeAt(h+1)]<<4|i[e.charCodeAt(h+2)]>>2,a[u++]=t>>8&255,a[u++]=255&t);return a},t.fromByteArray=function fromByteArray(e){for(var t,r=e.length,i=r%3,o=[],s=0,a=r-i;s<a;s+=16383)o.push(encodeChunk(e,s,s+16383>a?a:s+16383));1===i?(t=e[r-1],o.push(n[t>>2]+n[t<<4&63]+"==")):2===i&&(t=(e[r-2]<<8)+e[r-1],o.push(n[t>>10]+n[t>>4&63]+n[t<<2&63]+"="));return o.join("")};for(var n=[],i=[],o="undefined"!=typeof Uint8Array?Uint8Array:Array,s="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",a=0,u=s.length;a<u;++a)n[a]=s[a],i[s.charCodeAt(a)]=a;function getLens(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var r=e.indexOf("=");return-1===r&&(r=t),[r,r===t?0:4-r%4]}function tripletToBase64(e){return n[e>>18&63]+n[e>>12&63]+n[e>>6&63]+n[63&e]}function encodeChunk(e,t,r){for(var n,i=[],o=t;o<r;o+=3)n=(e[o]<<16&16711680)+(e[o+1]<<8&65280)+(255&e[o+2]),i.push(tripletToBase64(n));return i.join("")}i["-".charCodeAt(0)]=62,i["_".charCodeAt(0)]=63},function(e,t){t.read=function(e,t,r,n,i){var o,s,a=8*i-n-1,u=(1<<a)-1,c=u>>1,h=-7,l=r?i-1:0,f=r?-1:1,g=e[t+l];for(l+=f,o=g&(1<<-h)-1,g>>=-h,h+=a;h>0;o=256*o+e[t+l],l+=f,h-=8);for(s=o&(1<<-h)-1,o>>=-h,h+=n;h>0;s=256*s+e[t+l],l+=f,h-=8);if(0===o)o=1-c;else{if(o===u)return s?NaN:1/0*(g?-1:1);s+=Math.pow(2,n),o-=c}return(g?-1:1)*s*Math.pow(2,o-n)},t.write=function(e,t,r,n,i,o){var s,a,u,c=8*o-i-1,h=(1<<c)-1,l=h>>1,f=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,g=n?0:o-1,p=n?1:-1,d=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(a=isNaN(t)?1:0,s=h):(s=Math.floor(Math.log(t)/Math.LN2),t*(u=Math.pow(2,-s))<1&&(s--,u*=2),(t+=s+l>=1?f/u:f*Math.pow(2,1-l))*u>=2&&(s++,u/=2),s+l>=h?(a=0,s=h):s+l>=1?(a=(t*u-1)*Math.pow(2,i),s+=l):(a=t*Math.pow(2,l-1)*Math.pow(2,i),s=0));i>=8;e[r+g]=255&a,g+=p,a/=256,i-=8);for(s=s<<i|a,c+=i;c>0;e[r+g]=255&s,g+=p,s/=256,c-=8);e[r+g-p]|=128*d}},function(e,t){var r={}.toString;e.exports=Array.isArray||function(e){return"[object Array]"==r.call(e)}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function getJoseUtil(e){var t=e.jws,r=e.KeyUtil,i=e.X509,o=e.crypto,s=e.hextob64u,a=e.b64tohex,u=e.AllowedSigningAlgs;return function(){function JoseUtil(){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,JoseUtil)}return JoseUtil.parseJwt=function parseJwt(e){n.Log.debug("JoseUtil.parseJwt");try{var r=t.JWS.parse(e);return{header:r.headerObj,payload:r.payloadObj}}catch(e){n.Log.error(e)}},JoseUtil.validateJwt=function validateJwt(e,t,o,s,u,c,h){n.Log.debug("JoseUtil.validateJwt");try{if("RSA"===t.kty)if(t.e&&t.n)t=r.getKey(t);else{if(!t.x5c||!t.x5c.length)return n.Log.error("JoseUtil.validateJwt: RSA key missing key material",t),Promise.reject(new Error("RSA key missing key material"));var l=a(t.x5c[0]);t=i.getPublicKeyFromCertHex(l)}else{if("EC"!==t.kty)return n.Log.error("JoseUtil.validateJwt: Unsupported key type",t&&t.kty),Promise.reject(new Error(t.kty));if(!(t.crv&&t.x&&t.y))return n.Log.error("JoseUtil.validateJwt: EC key missing key material",t),Promise.reject(new Error("EC key missing key material"));t=r.getKey(t)}return JoseUtil._validateJwt(e,t,o,s,u,c,h)}catch(e){return n.Log.error(e&&e.message||e),Promise.reject("JWT validation failed")}},JoseUtil.validateJwtAttributes=function validateJwtAttributes(e,t,r,i,o,s){i||(i=0),o||(o=parseInt(Date.now()/1e3));var a=JoseUtil.parseJwt(e).payload;if(!a.iss)return n.Log.error("JoseUtil._validateJwt: issuer was not provided"),Promise.reject(new Error("issuer was not provided"));if(a.iss!==t)return n.Log.error("JoseUtil._validateJwt: Invalid issuer in token",a.iss),Promise.reject(new Error("Invalid issuer in token: "+a.iss));if(!a.aud)return n.Log.error("JoseUtil._validateJwt: aud was not provided"),Promise.reject(new Error("aud was not provided"));var u=a.aud===r||Array.isArray(a.aud)&&a.aud.indexOf(r)>=0;if(!u)return n.Log.error("JoseUtil._validateJwt: Invalid audience in token",a.aud),Promise.reject(new Error("Invalid audience in token: "+a.aud));if(a.azp&&a.azp!==r)return n.Log.error("JoseUtil._validateJwt: Invalid azp in token",a.azp),Promise.reject(new Error("Invalid azp in token: "+a.azp));if(!s){var c=o+i,h=o-i;if(!a.iat)return n.Log.error("JoseUtil._validateJwt: iat was not provided"),Promise.reject(new Error("iat was not provided"));if(c<a.iat)return n.Log.error("JoseUtil._validateJwt: iat is in the future",a.iat),Promise.reject(new Error("iat is in the future: "+a.iat));if(a.nbf&&c<a.nbf)return n.Log.error("JoseUtil._validateJwt: nbf is in the future",a.nbf),Promise.reject(new Error("nbf is in the future: "+a.nbf));if(!a.exp)return n.Log.error("JoseUtil._validateJwt: exp was not provided"),Promise.reject(new Error("exp was not provided"));if(a.exp<h)return n.Log.error("JoseUtil._validateJwt: exp is in the past",a.exp),Promise.reject(new Error("exp is in the past:"+a.exp))}return Promise.resolve(a)},JoseUtil._validateJwt=function _validateJwt(e,r,i,o,s,a,c){return JoseUtil.validateJwtAttributes(e,i,o,s,a,c).then(function(i){try{return t.JWS.verify(e,r,u)?i:(n.Log.error("JoseUtil._validateJwt: signature validation failed"),Promise.reject(new Error("signature validation failed")))}catch(e){return n.Log.error(e&&e.message||e),Promise.reject(new Error("signature validation failed"))}})},JoseUtil.hashString=function hashString(e,t){try{return o.Util.hashString(e,t)}catch(e){n.Log.error(e)}},JoseUtil.hexToBase64Url=function hexToBase64Url(e){try{return s(e)}catch(e){n.Log.error(e)}},JoseUtil}()};var n=r(0);e.exports=t.default},function(e,t,r){var n=r(34),i=r(35);e.exports=function v4(e,t,r){var o=t&&r||0;"string"==typeof e&&(t="binary"===e?new Array(16):null,e=null);var s=(e=e||{}).random||(e.rng||n)();if(s[6]=15&s[6]|64,s[8]=63&s[8]|128,t)for(var a=0;a<16;++a)t[o+a]=s[a];return t||i(s)}},function(e,t){var r="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(r){var n=new Uint8Array(16);e.exports=function whatwgRNG(){return r(n),n}}else{var i=new Array(16);e.exports=function mathRNG(){for(var e,t=0;t<16;t++)0==(3&t)&&(e=4294967296*Math.random()),i[t]=e>>>((3&t)<<3)&255;return i}}},function(e,t){for(var r=[],n=0;n<256;++n)r[n]=(n+256).toString(16).substr(1);e.exports=function bytesToUuid(e,t){var n=t||0,i=r;return[i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],"-",i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]],i[e[n++]]].join("")}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.SigninResponse=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(3);t.SigninResponse=function(){function SigninResponse(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"#";!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,SigninResponse);var r=i.UrlUtility.parseUrlFragment(e,t);this.error=r.error,this.error_description=r.error_description,this.error_uri=r.error_uri,this.code=r.code,this.state=r.state,this.id_token=r.id_token,this.session_state=r.session_state,this.access_token=r.access_token,this.token_type=r.token_type,this.scope=r.scope,this.profile=void 0,this.expires_in=r.expires_in}return n(SigninResponse,[{key:"expires_in",get:function get(){if(this.expires_at){var e=parseInt(Date.now()/1e3);return this.expires_at-e}},set:function set(e){var t=parseInt(e);if("number"==typeof t&&t>0){var r=parseInt(Date.now()/1e3);this.expires_at=r+t}}},{key:"expired",get:function get(){var e=this.expires_in;if(void 0!==e)return e<=0}},{key:"scopes",get:function get(){return(this.scope||"").split(" ")}},{key:"isOpenIdConnect",get:function get(){return this.scopes.indexOf("openid")>=0||!!this.id_token}}]),SigninResponse}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.SignoutRequest=void 0;var n=r(0),i=r(3),o=r(8);t.SignoutRequest=function SignoutRequest(e){var t=e.url,r=e.id_token_hint,s=e.post_logout_redirect_uri,a=e.data,u=e.extraQueryParams;if(function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,SignoutRequest),!t)throw n.Log.error("SignoutRequest.ctor: No url passed"),new Error("url");for(var c in r&&(t=i.UrlUtility.addQueryParam(t,"id_token_hint",r)),s&&(t=i.UrlUtility.addQueryParam(t,"post_logout_redirect_uri",s),a&&(this.state=new o.State({data:a}),t=i.UrlUtility.addQueryParam(t,"state",this.state.id))),u)t=i.UrlUtility.addQueryParam(t,c,u[c]);this.url=t}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.SignoutResponse=void 0;var n=r(3);t.SignoutResponse=function SignoutResponse(e){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,SignoutResponse);var t=n.UrlUtility.parseUrlFragment(e,"?");this.error=t.error,this.error_description=t.error_description,this.error_uri=t.error_uri,this.state=t.state}},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.InMemoryWebStorage=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0);t.InMemoryWebStorage=function(){function InMemoryWebStorage(){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,InMemoryWebStorage),this._data={}}return InMemoryWebStorage.prototype.getItem=function getItem(e){return i.Log.debug("InMemoryWebStorage.getItem",e),this._data[e]},InMemoryWebStorage.prototype.setItem=function setItem(e,t){i.Log.debug("InMemoryWebStorage.setItem",e),this._data[e]=t},InMemoryWebStorage.prototype.removeItem=function removeItem(e){i.Log.debug("InMemoryWebStorage.removeItem",e),delete this._data[e]},InMemoryWebStorage.prototype.key=function key(e){return Object.getOwnPropertyNames(this._data)[e]},n(InMemoryWebStorage,[{key:"length",get:function get(){return Object.getOwnPropertyNames(this._data).length}}]),InMemoryWebStorage}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.UserManager=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0),o=r(9),s=r(41),a=r(15),u=r(47),c=r(49),h=r(18),l=r(20),f=r(10),g=r(4);t.UserManager=function(e){function UserManager(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:c.SilentRenewService,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:h.SessionMonitor,o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:l.TokenRevocationClient,a=arguments.length>4&&void 0!==arguments[4]?arguments[4]:f.TokenClient,p=arguments.length>5&&void 0!==arguments[5]?arguments[5]:g.JoseUtil;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,UserManager),t instanceof s.UserManagerSettings||(t=new s.UserManagerSettings(t));var d=function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,e.call(this,t));return d._events=new u.UserManagerEvents(t),d._silentRenewService=new r(d),d.settings.automaticSilentRenew&&(i.Log.debug("UserManager.ctor: automaticSilentRenew is configured, setting up silent renew"),d.startSilentRenew()),d.settings.monitorSession&&(i.Log.debug("UserManager.ctor: monitorSession is configured, setting up session monitor"),d._sessionMonitor=new n(d)),d._tokenRevocationClient=new o(d._settings),d._tokenClient=new a(d._settings),d._joseUtil=p,d}return function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(UserManager,e),UserManager.prototype.getUser=function getUser(){var e=this;return this._loadUser().then(function(t){return t?(i.Log.info("UserManager.getUser: user loaded"),e._events.load(t,!1),t):(i.Log.info("UserManager.getUser: user not found in storage"),null)})},UserManager.prototype.removeUser=function removeUser(){var e=this;return this.storeUser(null).then(function(){i.Log.info("UserManager.removeUser: user removed from storage"),e._events.unload()})},UserManager.prototype.signinRedirect=function signinRedirect(e){return this._signinStart(e,this._redirectNavigator).then(function(){i.Log.info("UserManager.signinRedirect: successful")})},UserManager.prototype.signinRedirectCallback=function signinRedirectCallback(e){return this._signinEnd(e||this._redirectNavigator.url).then(function(e){return e&&(e.profile&&e.profile.sub?i.Log.info("UserManager.signinRedirectCallback: successful, signed in sub: ",e.profile.sub):i.Log.info("UserManager.signinRedirectCallback: no sub")),e})},UserManager.prototype.signinPopup=function signinPopup(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.redirect_uri||this.settings.popup_redirect_uri||this.settings.redirect_uri;return t?(e.redirect_uri=t,e.display="popup",this._signin(e,this._popupNavigator,{startUrl:t,popupWindowFeatures:e.popupWindowFeatures||this.settings.popupWindowFeatures,popupWindowTarget:e.popupWindowTarget||this.settings.popupWindowTarget}).then(function(e){return e&&(e.profile&&e.profile.sub?i.Log.info("UserManager.signinPopup: signinPopup successful, signed in sub: ",e.profile.sub):i.Log.info("UserManager.signinPopup: no sub")),e})):(i.Log.error("UserManager.signinPopup: No popup_redirect_uri or redirect_uri configured"),Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured")))},UserManager.prototype.signinPopupCallback=function signinPopupCallback(e){return this._signinCallback(e,this._popupNavigator).then(function(e){return e&&(e.profile&&e.profile.sub?i.Log.info("UserManager.signinPopupCallback: successful, signed in sub: ",e.profile.sub):i.Log.info("UserManager.signinPopupCallback: no sub")),e}).catch(function(e){i.Log.error(e.message)})},UserManager.prototype.signinSilent=function signinSilent(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this._loadUser().then(function(r){return r&&r.refresh_token?(t.refresh_token=r.refresh_token,e._useRefreshToken(t)):(t.id_token_hint=t.id_token_hint||e.settings.includeIdTokenInSilentRenew&&r&&r.id_token,e._signinSilentIframe(t))})},UserManager.prototype._useRefreshToken=function _useRefreshToken(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this._tokenClient.exchangeRefreshToken(t).then(function(t){return t?t.access_token?e._loadUser().then(function(r){if(r){var n=Promise.resolve();return t.id_token&&(n=e._validateIdTokenFromTokenRefreshToken(r.profile,t.id_token)),n.then(function(){return i.Log.debug("UserManager._useRefreshToken: refresh token response success"),r.access_token=t.access_token,r.refresh_token=t.refresh_token||r.refresh_token,r.expires_in=t.expires_in,e.storeUser(r).then(function(){return e._events.load(r),r})})}return null}):(i.Log.error("UserManager._useRefreshToken: No access token returned from token endpoint"),Promise.reject("No access token returned from token endpoint")):(i.Log.error("UserManager._useRefreshToken: No response returned from token endpoint"),Promise.reject("No response returned from token endpoint"))})},UserManager.prototype._validateIdTokenFromTokenRefreshToken=function _validateIdTokenFromTokenRefreshToken(e,t){var r=this;return this._metadataService.getIssuer().then(function(n){return r._joseUtil.validateJwtAttributes(t,n,r._settings.client_id,r._settings.clockSkew).then(function(t){return t?t.sub!==e.sub?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: sub in id_token does not match current sub"),Promise.reject(new Error("sub in id_token does not match current sub"))):t.auth_time&&t.auth_time!==e.auth_time?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: auth_time in id_token does not match original auth_time"),Promise.reject(new Error("auth_time in id_token does not match original auth_time"))):t.azp&&t.azp!==e.azp?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp in id_token does not match original azp"),Promise.reject(new Error("azp in id_token does not match original azp"))):!t.azp&&e.azp?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp not in id_token, but present in original id_token"),Promise.reject(new Error("azp not in id_token, but present in original id_token"))):void 0:(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: Failed to validate id_token"),Promise.reject(new Error("Failed to validate id_token")))})})},UserManager.prototype._signinSilentIframe=function _signinSilentIframe(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.redirect_uri||this.settings.silent_redirect_uri;return t?(e.redirect_uri=t,e.prompt=e.prompt||"none",this._signin(e,this._iframeNavigator,{startUrl:t,silentRequestTimeout:e.silentRequestTimeout||this.settings.silentRequestTimeout}).then(function(e){return e&&(e.profile&&e.profile.sub?i.Log.info("UserManager.signinSilent: successful, signed in sub: ",e.profile.sub):i.Log.info("UserManager.signinSilent: no sub")),e})):(i.Log.error("UserManager.signinSilent: No silent_redirect_uri configured"),Promise.reject(new Error("No silent_redirect_uri configured")))},UserManager.prototype.signinSilentCallback=function signinSilentCallback(e){return this._signinCallback(e,this._iframeNavigator).then(function(e){return e&&(e.profile&&e.profile.sub?i.Log.info("UserManager.signinSilentCallback: successful, signed in sub: ",e.profile.sub):i.Log.info("UserManager.signinSilentCallback: no sub")),e})},UserManager.prototype.querySessionStatus=function querySessionStatus(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.redirect_uri||this.settings.silent_redirect_uri;return r?(t.redirect_uri=r,t.prompt="none",t.response_type=t.response_type||this.settings.query_status_response_type,t.scope="openid",this._signinStart(t,this._iframeNavigator,{startUrl:r,silentRequestTimeout:t.silentRequestTimeout||this.settings.silentRequestTimeout}).then(function(t){return e.processSigninResponse(t.url).then(function(e){if(i.Log.debug("UserManager.querySessionStatus: got signin response"),e.session_state&&e.profile.sub)return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for sub: ",e.profile.sub),{session_state:e.session_state,sub:e.profile.sub,sid:e.profile.sid};i.Log.info("querySessionStatus successful, user not authenticated")})})):(i.Log.error("UserManager.querySessionStatus: No silent_redirect_uri configured"),Promise.reject(new Error("No silent_redirect_uri configured")))},UserManager.prototype._signin=function _signin(e,t){var r=this,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this._signinStart(e,t,n).then(function(e){return r._signinEnd(e.url)})},UserManager.prototype._signinStart=function _signinStart(e,t){var r=this,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return t.prepare(n).then(function(t){return i.Log.debug("UserManager._signinStart: got navigator window handle"),r.createSigninRequest(e).then(function(e){return i.Log.debug("UserManager._signinStart: got signin request"),n.url=e.url,n.id=e.state.id,t.navigate(n)}).catch(function(e){throw t.close&&(i.Log.debug("UserManager._signinStart: Error after preparing navigator, closing navigator window"),t.close()),e})})},UserManager.prototype._signinEnd=function _signinEnd(e){var t=this;return this.processSigninResponse(e).then(function(e){i.Log.debug("UserManager._signinEnd: got signin response");var r=new a.User(e);return t.storeUser(r).then(function(){return i.Log.debug("UserManager._signinEnd: user stored"),t._events.load(r),r})})},UserManager.prototype._signinCallback=function _signinCallback(e,t){return i.Log.debug("UserManager._signinCallback"),t.callback(e)},UserManager.prototype.signoutRedirect=function signoutRedirect(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.post_logout_redirect_uri||this.settings.post_logout_redirect_uri;return t&&(e.post_logout_redirect_uri=t),this._signoutStart(e,this._redirectNavigator).then(function(){i.Log.info("UserManager.signoutRedirect: successful")})},UserManager.prototype.signoutRedirectCallback=function signoutRedirectCallback(e){return this._signoutEnd(e||this._redirectNavigator.url).then(function(e){return i.Log.info("UserManager.signoutRedirectCallback: successful"),e})},UserManager.prototype.signoutPopup=function signoutPopup(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.post_logout_redirect_uri||this.settings.popup_post_logout_redirect_uri||this.settings.post_logout_redirect_uri;return e.post_logout_redirect_uri=t,e.display="popup",e.post_logout_redirect_uri&&(e.state=e.state||{}),this._signout(e,this._popupNavigator,{startUrl:t,popupWindowFeatures:e.popupWindowFeatures||this.settings.popupWindowFeatures,popupWindowTarget:e.popupWindowTarget||this.settings.popupWindowTarget}).then(function(){i.Log.info("UserManager.signoutPopup: successful")})},UserManager.prototype.signoutPopupCallback=function signoutPopupCallback(e,t){void 0===t&&"boolean"==typeof e&&(t=e,e=null);return this._popupNavigator.callback(e,t,"?").then(function(){i.Log.info("UserManager.signoutPopupCallback: successful")})},UserManager.prototype._signout=function _signout(e,t){var r=this,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this._signoutStart(e,t,n).then(function(e){return r._signoutEnd(e.url)})},UserManager.prototype._signoutStart=function _signoutStart(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=this,r=arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return r.prepare(n).then(function(r){return i.Log.debug("UserManager._signoutStart: got navigator window handle"),t._loadUser().then(function(o){return i.Log.debug("UserManager._signoutStart: loaded current user from storage"),(t._settings.revokeAccessTokenOnSignout?t._revokeInternal(o):Promise.resolve()).then(function(){var s=e.id_token_hint||o&&o.id_token;return s&&(i.Log.debug("UserManager._signoutStart: Setting id_token into signout request"),e.id_token_hint=s),t.removeUser().then(function(){return i.Log.debug("UserManager._signoutStart: user removed, creating signout request"),t.createSignoutRequest(e).then(function(e){return i.Log.debug("UserManager._signoutStart: got signout request"),n.url=e.url,e.state&&(n.id=e.state.id),r.navigate(n)})})})}).catch(function(e){throw r.close&&(i.Log.debug("UserManager._signoutStart: Error after preparing navigator, closing navigator window"),r.close()),e})})},UserManager.prototype._signoutEnd=function _signoutEnd(e){return this.processSignoutResponse(e).then(function(e){return i.Log.debug("UserManager._signoutEnd: got signout response"),e})},UserManager.prototype.revokeAccessToken=function revokeAccessToken(){var e=this;return this._loadUser().then(function(t){return e._revokeInternal(t,!0).then(function(r){if(r)return i.Log.debug("UserManager.revokeAccessToken: removing token properties from user and re-storing"),t.access_token=null,t.refresh_token=null,t.expires_at=null,t.token_type=null,e.storeUser(t).then(function(){i.Log.debug("UserManager.revokeAccessToken: user stored"),e._events.load(t)})})}).then(function(){i.Log.info("UserManager.revokeAccessToken: access token revoked successfully")})},UserManager.prototype._revokeInternal=function _revokeInternal(e,t){var r=this;if(e){var n=e.access_token,o=e.refresh_token;return this._revokeAccessTokenInternal(n,t).then(function(e){return r._revokeRefreshTokenInternal(o,t).then(function(t){return e||t||i.Log.debug("UserManager.revokeAccessToken: no need to revoke due to no token(s), or JWT format"),e||t})})}return Promise.resolve(!1)},UserManager.prototype._revokeAccessTokenInternal=function _revokeAccessTokenInternal(e,t){return!e||e.indexOf(".")>=0?Promise.resolve(!1):this._tokenRevocationClient.revoke(e,t).then(function(){return!0})},UserManager.prototype._revokeRefreshTokenInternal=function _revokeRefreshTokenInternal(e,t){return e?this._tokenRevocationClient.revoke(e,t,"refresh_token").then(function(){return!0}):Promise.resolve(!1)},UserManager.prototype.startSilentRenew=function startSilentRenew(){this._silentRenewService.start()},UserManager.prototype.stopSilentRenew=function stopSilentRenew(){this._silentRenewService.stop()},UserManager.prototype._loadUser=function _loadUser(){return this._userStore.get(this._userStoreKey).then(function(e){return e?(i.Log.debug("UserManager._loadUser: user storageString loaded"),a.User.fromStorageString(e)):(i.Log.debug("UserManager._loadUser: no user storageString"),null)})},UserManager.prototype.storeUser=function storeUser(e){if(e){i.Log.debug("UserManager.storeUser: storing user");var t=e.toStorageString();return this._userStore.set(this._userStoreKey,t)}return i.Log.debug("storeUser.storeUser: removing user"),this._userStore.remove(this._userStoreKey)},n(UserManager,[{key:"_redirectNavigator",get:function get(){return this.settings.redirectNavigator}},{key:"_popupNavigator",get:function get(){return this.settings.popupNavigator}},{key:"_iframeNavigator",get:function get(){return this.settings.iframeNavigator}},{key:"_userStore",get:function get(){return this.settings.userStore}},{key:"events",get:function get(){return this._events}},{key:"_userStoreKey",get:function get(){return"user:"+this.settings.authority+":"+this.settings.client_id}}]),UserManager}(o.OidcClient)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.UserManagerSettings=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=(r(0),r(5)),o=r(42),s=r(43),a=r(45),u=r(6),c=r(1),h=r(12);var l=60,f=2e3;t.UserManagerSettings=function(e){function UserManagerSettings(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.popup_redirect_uri,n=t.popup_post_logout_redirect_uri,i=t.popupWindowFeatures,g=t.popupWindowTarget,p=t.silent_redirect_uri,d=t.silentRequestTimeout,v=t.automaticSilentRenew,y=void 0!==v&&v,m=t.includeIdTokenInSilentRenew,_=void 0===m||m,S=t.monitorSession,b=void 0===S||S,F=t.checkSessionInterval,w=void 0===F?f:F,E=t.stopCheckSessionOnError,x=void 0===E||E,C=t.query_status_response_type,k=t.revokeAccessTokenOnSignout,A=void 0!==k&&k,P=t.accessTokenExpiringNotificationTime,I=void 0===P?l:P,B=t.redirectNavigator,R=void 0===B?new o.RedirectNavigator:B,T=t.popupNavigator,U=void 0===T?new s.PopupNavigator:T,D=t.iframeNavigator,M=void 0===D?new a.IFrameNavigator:D,L=t.userStore,N=void 0===L?new u.WebStorageStateStore({store:c.Global.sessionStorage}):L;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,UserManagerSettings);var O=function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,e.call(this,arguments[0]));return O._popup_redirect_uri=r,O._popup_post_logout_redirect_uri=n,O._popupWindowFeatures=i,O._popupWindowTarget=g,O._silent_redirect_uri=p,O._silentRequestTimeout=d,O._automaticSilentRenew=y,O._includeIdTokenInSilentRenew=_,O._accessTokenExpiringNotificationTime=I,O._monitorSession=b,O._checkSessionInterval=w,O._stopCheckSessionOnError=x,C?O._query_status_response_type=C:arguments[0]&&arguments[0].response_type?O._query_status_response_type=h.SigninRequest.isOidc(arguments[0].response_type)?"id_token":"code":O._query_status_response_type="id_token",O._revokeAccessTokenOnSignout=A,O._redirectNavigator=R,O._popupNavigator=U,O._iframeNavigator=M,O._userStore=N,O}return function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(UserManagerSettings,e),n(UserManagerSettings,[{key:"popup_redirect_uri",get:function get(){return this._popup_redirect_uri}},{key:"popup_post_logout_redirect_uri",get:function get(){return this._popup_post_logout_redirect_uri}},{key:"popupWindowFeatures",get:function get(){return this._popupWindowFeatures}},{key:"popupWindowTarget",get:function get(){return this._popupWindowTarget}},{key:"silent_redirect_uri",get:function get(){return this._silent_redirect_uri}},{key:"silentRequestTimeout",get:function get(){return this._silentRequestTimeout}},{key:"automaticSilentRenew",get:function get(){return this._automaticSilentRenew}},{key:"includeIdTokenInSilentRenew",get:function get(){return this._includeIdTokenInSilentRenew}},{key:"accessTokenExpiringNotificationTime",get:function get(){return this._accessTokenExpiringNotificationTime}},{key:"monitorSession",get:function get(){return this._monitorSession}},{key:"checkSessionInterval",get:function get(){return this._checkSessionInterval}},{key:"stopCheckSessionOnError",get:function get(){return this._stopCheckSessionOnError}},{key:"query_status_response_type",get:function get(){return this._query_status_response_type}},{key:"revokeAccessTokenOnSignout",get:function get(){return this._revokeAccessTokenOnSignout}},{key:"redirectNavigator",get:function get(){return this._redirectNavigator}},{key:"popupNavigator",get:function get(){return this._popupNavigator}},{key:"iframeNavigator",get:function get(){return this._iframeNavigator}},{key:"userStore",get:function get(){return this._userStore}}]),UserManagerSettings}(i.OidcClientSettings)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.RedirectNavigator=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0);t.RedirectNavigator=function(){function RedirectNavigator(){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,RedirectNavigator)}return RedirectNavigator.prototype.prepare=function prepare(){return Promise.resolve(this)},RedirectNavigator.prototype.navigate=function navigate(e){return e&&e.url?(window.location=e.url,Promise.resolve()):(i.Log.error("RedirectNavigator.navigate: No url provided"),Promise.reject(new Error("No url provided")))},n(RedirectNavigator,[{key:"url",get:function get(){return window.location.href}}]),RedirectNavigator}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.PopupNavigator=void 0;var n=r(0),i=r(44);t.PopupNavigator=function(){function PopupNavigator(){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,PopupNavigator)}return PopupNavigator.prototype.prepare=function prepare(e){var t=new i.PopupWindow(e);return Promise.resolve(t)},PopupNavigator.prototype.callback=function callback(e,t,r){n.Log.debug("PopupNavigator.callback");try{return i.PopupWindow.notifyOpener(e,t,r),Promise.resolve()}catch(e){return Promise.reject(e)}},PopupNavigator}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.PopupWindow=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0),o=r(3);var s=500,a="location=no,toolbar=no,width=500,height=500,left=100,top=100;",u="_blank";t.PopupWindow=function(){function PopupWindow(e){var t=this;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,PopupWindow),this._promise=new Promise(function(e,r){t._resolve=e,t._reject=r});var r=e.popupWindowTarget||u,n=e.popupWindowFeatures||a;this._popup=window.open("",r,n),this._popup&&(i.Log.debug("PopupWindow.ctor: popup successfully created"),this._checkForPopupClosedTimer=window.setInterval(this._checkForPopupClosed.bind(this),s))}return PopupWindow.prototype.navigate=function navigate(e){return this._popup?e&&e.url?(i.Log.debug("PopupWindow.navigate: Setting URL in popup"),this._id=e.id,this._id&&(window["popupCallback_"+e.id]=this._callback.bind(this)),this._popup.focus(),this._popup.window.location=e.url):(this._error("PopupWindow.navigate: no url provided"),this._error("No url provided")):this._error("PopupWindow.navigate: Error opening popup window"),this.promise},PopupWindow.prototype._success=function _success(e){i.Log.debug("PopupWindow.callback: Successful response from popup window"),this._cleanup(),this._resolve(e)},PopupWindow.prototype._error=function _error(e){i.Log.error("PopupWindow.error: ",e),this._cleanup(),this._reject(new Error(e))},PopupWindow.prototype.close=function close(){this._cleanup(!1)},PopupWindow.prototype._cleanup=function _cleanup(e){i.Log.debug("PopupWindow.cleanup"),window.clearInterval(this._checkForPopupClosedTimer),this._checkForPopupClosedTimer=null,delete window["popupCallback_"+this._id],this._popup&&!e&&this._popup.close(),this._popup=null},PopupWindow.prototype._checkForPopupClosed=function _checkForPopupClosed(){this._popup&&!this._popup.closed||this._error("Popup window closed")},PopupWindow.prototype._callback=function _callback(e,t){this._cleanup(t),e?(i.Log.debug("PopupWindow.callback success"),this._success({url:e})):(i.Log.debug("PopupWindow.callback: Invalid response from popup"),this._error("Invalid response from popup"))},PopupWindow.notifyOpener=function notifyOpener(e,t,r){if(window.opener){if(e=e||window.location.href){var n=o.UrlUtility.parseUrlFragment(e,r);if(n.state){var s="popupCallback_"+n.state,a=window.opener[s];a?(i.Log.debug("PopupWindow.notifyOpener: passing url message to opener"),a(e,t)):i.Log.warn("PopupWindow.notifyOpener: no matching callback found on opener")}else i.Log.warn("PopupWindow.notifyOpener: no state found in response url")}}else i.Log.warn("PopupWindow.notifyOpener: no window.opener. Can't complete notification.")},n(PopupWindow,[{key:"promise",get:function get(){return this._promise}}]),PopupWindow}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.IFrameNavigator=void 0;var n=r(0),i=r(46);t.IFrameNavigator=function(){function IFrameNavigator(){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,IFrameNavigator)}return IFrameNavigator.prototype.prepare=function prepare(e){var t=new i.IFrameWindow(e);return Promise.resolve(t)},IFrameNavigator.prototype.callback=function callback(e){n.Log.debug("IFrameNavigator.callback");try{return i.IFrameWindow.notifyParent(e),Promise.resolve()}catch(e){return Promise.reject(e)}},IFrameNavigator}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.IFrameWindow=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0);t.IFrameWindow=function(){function IFrameWindow(e){var t=this;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,IFrameWindow),this._promise=new Promise(function(e,r){t._resolve=e,t._reject=r}),this._boundMessageEvent=this._message.bind(this),window.addEventListener("message",this._boundMessageEvent,!1),this._frame=window.document.createElement("iframe"),this._frame.style.visibility="hidden",this._frame.style.position="absolute",this._frame.style.display="none",this._frame.style.width=0,this._frame.style.height=0,window.document.body.appendChild(this._frame)}return IFrameWindow.prototype.navigate=function navigate(e){if(e&&e.url){var t=e.silentRequestTimeout||1e4;i.Log.debug("IFrameWindow.navigate: Using timeout of:",t),this._timer=window.setTimeout(this._timeout.bind(this),t),this._frame.src=e.url}else this._error("No url provided");return this.promise},IFrameWindow.prototype._success=function _success(e){this._cleanup(),i.Log.debug("IFrameWindow: Successful response from frame window"),this._resolve(e)},IFrameWindow.prototype._error=function _error(e){this._cleanup(),i.Log.error(e),this._reject(new Error(e))},IFrameWindow.prototype.close=function close(){this._cleanup()},IFrameWindow.prototype._cleanup=function _cleanup(){this._frame&&(i.Log.debug("IFrameWindow: cleanup"),window.removeEventListener("message",this._boundMessageEvent,!1),window.clearTimeout(this._timer),window.document.body.removeChild(this._frame),this._timer=null,this._frame=null,this._boundMessageEvent=null)},IFrameWindow.prototype._timeout=function _timeout(){i.Log.debug("IFrameWindow.timeout"),this._error("Frame window timed out")},IFrameWindow.prototype._message=function _message(e){if(i.Log.debug("IFrameWindow.message"),this._timer&&e.origin===this._origin&&e.source===this._frame.contentWindow){var t=e.data;t?this._success({url:t}):this._error("Invalid response from frame")}},IFrameWindow.notifyParent=function notifyParent(e){i.Log.debug("IFrameWindow.notifyParent"),window.frameElement&&(e=e||window.location.href)&&(i.Log.debug("IFrameWindow.notifyParent: posting url message to parent"),window.parent.postMessage(e,location.protocol+"//"+location.host))},n(IFrameWindow,[{key:"promise",get:function get(){return this._promise}},{key:"_origin",get:function get(){return location.protocol+"//"+location.host}}]),IFrameWindow}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.UserManagerEvents=void 0;var n=r(0),i=r(16),o=r(17);t.UserManagerEvents=function(e){function UserManagerEvents(t){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,UserManagerEvents);var r=function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,e.call(this,t));return r._userLoaded=new o.Event("User loaded"),r._userUnloaded=new o.Event("User unloaded"),r._silentRenewError=new o.Event("Silent renew error"),r._userSignedOut=new o.Event("User signed out"),r._userSessionChanged=new o.Event("User session changed"),r}return function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(UserManagerEvents,e),UserManagerEvents.prototype.load=function load(t){var r=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];n.Log.debug("UserManagerEvents.load"),e.prototype.load.call(this,t),r&&this._userLoaded.raise(t)},UserManagerEvents.prototype.unload=function unload(){n.Log.debug("UserManagerEvents.unload"),e.prototype.unload.call(this),this._userUnloaded.raise()},UserManagerEvents.prototype.addUserLoaded=function addUserLoaded(e){this._userLoaded.addHandler(e)},UserManagerEvents.prototype.removeUserLoaded=function removeUserLoaded(e){this._userLoaded.removeHandler(e)},UserManagerEvents.prototype.addUserUnloaded=function addUserUnloaded(e){this._userUnloaded.addHandler(e)},UserManagerEvents.prototype.removeUserUnloaded=function removeUserUnloaded(e){this._userUnloaded.removeHandler(e)},UserManagerEvents.prototype.addSilentRenewError=function addSilentRenewError(e){this._silentRenewError.addHandler(e)},UserManagerEvents.prototype.removeSilentRenewError=function removeSilentRenewError(e){this._silentRenewError.removeHandler(e)},UserManagerEvents.prototype._raiseSilentRenewError=function _raiseSilentRenewError(e){n.Log.debug("UserManagerEvents._raiseSilentRenewError",e.message),this._silentRenewError.raise(e)},UserManagerEvents.prototype.addUserSignedOut=function addUserSignedOut(e){this._userSignedOut.addHandler(e)},UserManagerEvents.prototype.removeUserSignedOut=function removeUserSignedOut(e){this._userSignedOut.removeHandler(e)},UserManagerEvents.prototype._raiseUserSignedOut=function _raiseUserSignedOut(e){n.Log.debug("UserManagerEvents._raiseUserSignedOut"),this._userSignedOut.raise(e)},UserManagerEvents.prototype.addUserSessionChanged=function addUserSessionChanged(e){this._userSessionChanged.addHandler(e)},UserManagerEvents.prototype.removeUserSessionChanged=function removeUserSessionChanged(e){this._userSessionChanged.removeHandler(e)},UserManagerEvents.prototype._raiseUserSessionChanged=function _raiseUserSessionChanged(e){n.Log.debug("UserManagerEvents._raiseUserSessionChanged"),this._userSessionChanged.raise(e)},UserManagerEvents}(i.AccessTokenEvents)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.Timer=void 0;var n=function(){function defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(e,t,r){return t&&defineProperties(e.prototype,t),r&&defineProperties(e,r),e}}(),i=r(0),o=r(1),s=r(17);t.Timer=function(e){function Timer(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.Global.timer,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,Timer);var i=function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,e.call(this,t));return i._timer=r,i._nowFunc=n||function(){return Date.now()/1e3},i}return function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(Timer,e),Timer.prototype.init=function init(e){e<=0&&(e=1),e=parseInt(e);var t=this.now+e;if(this.expiration===t&&this._timerHandle)i.Log.debug("Timer.init timer "+this._name+" skipping initialization since already initialized for expiration:",this.expiration);else{this.cancel(),i.Log.debug("Timer.init timer "+this._name+" for duration:",e),this._expiration=t;var r=5;e<r&&(r=e),this._timerHandle=this._timer.setInterval(this._callback.bind(this),1e3*r)}},Timer.prototype.cancel=function cancel(){this._timerHandle&&(i.Log.debug("Timer.cancel: ",this._name),this._timer.clearInterval(this._timerHandle),this._timerHandle=null)},Timer.prototype._callback=function _callback(){var t=this._expiration-this.now;i.Log.debug("Timer.callback; "+this._name+" timer expires in:",t),this._expiration<=this.now&&(this.cancel(),e.prototype.raise.call(this))},n(Timer,[{key:"now",get:function get(){return parseInt(this._nowFunc())}},{key:"expiration",get:function get(){return this._expiration}}]),Timer}(s.Event)},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.SilentRenewService=void 0;var n=r(0);t.SilentRenewService=function(){function SilentRenewService(e){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,SilentRenewService),this._userManager=e}return SilentRenewService.prototype.start=function start(){this._callback||(this._callback=this._tokenExpiring.bind(this),this._userManager.events.addAccessTokenExpiring(this._callback),this._userManager.getUser().then(function(e){}).catch(function(e){n.Log.error("SilentRenewService.start: Error from getUser:",e.message)}))},SilentRenewService.prototype.stop=function stop(){this._callback&&(this._userManager.events.removeAccessTokenExpiring(this._callback),delete this._callback)},SilentRenewService.prototype._tokenExpiring=function _tokenExpiring(){var e=this;this._userManager.signinSilent().then(function(e){n.Log.debug("SilentRenewService._tokenExpiring: Silent token renewal successful")},function(t){n.Log.error("SilentRenewService._tokenExpiring: Error from signinSilent:",t.message),e._userManager.events._raiseSilentRenewError(t)})},SilentRenewService}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.CordovaPopupNavigator=void 0;var n=r(21);t.CordovaPopupNavigator=function(){function CordovaPopupNavigator(){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,CordovaPopupNavigator)}return CordovaPopupNavigator.prototype.prepare=function prepare(e){var t=new n.CordovaPopupWindow(e);return Promise.resolve(t)},CordovaPopupNavigator}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.CordovaIFrameNavigator=void 0;var n=r(21);t.CordovaIFrameNavigator=function(){function CordovaIFrameNavigator(){!function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,CordovaIFrameNavigator)}return CordovaIFrameNavigator.prototype.prepare=function prepare(e){e.popupWindowFeatures="hidden=yes";var t=new n.CordovaPopupWindow(e);return Promise.resolve(t)},CordovaIFrameNavigator}()}])});

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80), __webpack_require__(614)))

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiDrag", function() { return MultiDragPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sortable", function() { return Sortable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swap", function() { return SwapPlugin; });
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var version = "1.10.2";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !!
    /*@__PURE__*/
    navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, ["evt"]);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    if (lastChild(sortable)) return;
    var rect = getRect(sortable),
        threshold = sortable[expando].options.emptyInsertThreshold,
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // assign target only if condition is true


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ __webpack_exports__["default"] = (Sortable);



/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1152);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html


function f(s, x, y, z) {
  switch (s) {
    case 0: return (x & y) ^ (~x & z);
    case 1: return x ^ y ^ z;
    case 2: return (x & y) ^ (x & z) ^ (y & z);
    case 3: return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return (x << n) | (x>>> (32 - n));
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof(bytes) == 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
    bytes = new Array(msg.length);
    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
  }

  bytes.push(0x80);

  var l = bytes.length/4 + 2;
  var N = Math.ceil(l/16);
  var M = new Array(N);

  for (var i=0; i<N; i++) {
    M[i] = new Array(16);
    for (var j=0; j<16; j++) {
      M[i][j] =
        bytes[i * 64 + j * 4] << 24 |
        bytes[i * 64 + j * 4 + 1] << 16 |
        bytes[i * 64 + j * 4 + 2] << 8 |
        bytes[i * 64 + j * 4 + 3];
    }
  }

  M[N - 1][14] = ((bytes.length - 1) * 8) /
    Math.pow(2, 32); M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = ((bytes.length - 1) * 8) & 0xffffffff;

  for (var i=0; i<N; i++) {
    var W = new Array(80);

    for (var t=0; t<16; t++) W[t] = M[i][t];
    for (var t=16; t<80; t++) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var t=0; t<80; t++) {
      var s = Math.floor(t/20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = (H[0] + a) >>> 0;
    H[1] = (H[1] + b) >>> 0;
    H[2] = (H[2] + c) >>> 0;
    H[3] = (H[3] + d) >>> 0;
    H[4] = (H[4] + e) >>> 0;
  }

  return [
    H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff,
    H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff,
    H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff,
    H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff,
    H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff
  ];
}

module.exports = sha1;


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var bytesToUuid = __webpack_require__(134);

function uuidToBytes(uuid) {
  // Note: We assume we're being passed a valid uuid string
  var bytes = [];
  uuid.replace(/[a-fA-F0-9]{2}/g, function(hex) {
    bytes.push(parseInt(hex, 16));
  });

  return bytes;
}

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape
  var bytes = new Array(str.length);
  for (var i = 0; i < str.length; i++) {
    bytes[i] = str.charCodeAt(i);
  }
  return bytes;
}

module.exports = function(name, version, hashfunc) {
  var generateUUID = function(value, namespace, buf, offset) {
    var off = buf && offset || 0;

    if (typeof(value) == 'string') value = stringToBytes(value);
    if (typeof(namespace) == 'string') namespace = uuidToBytes(namespace);

    if (!Array.isArray(value)) throw TypeError('value must be an array of bytes');
    if (!Array.isArray(namespace) || namespace.length !== 16) throw TypeError('namespace must be uuid string or an Array of 16 byte values');

    // Per 4.3
    var bytes = hashfunc(namespace.concat(value));
    bytes[6] = (bytes[6] & 0x0f) | version;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    if (buf) {
      for (var idx = 0; idx < 16; ++idx) {
        buf[off+idx] = bytes[idx];
      }
    }

    return buf || bytesToUuid(bytes);
  };

  // Function#name is not settable on some platforms (#270)
  try {
    generateUUID.name = name;
  } catch (err) {
  }

  // Pre-defined namespaces, per Appendix C
  generateUUID.DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
  generateUUID.URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';

  return generateUUID;
};


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(615);
var bytesToUuid = __webpack_require__(134);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(615);
var bytesToUuid = __webpack_require__(134);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var v35 = __webpack_require__(1156);
var sha1 = __webpack_require__(1155);
module.exports = v35('v5', 0x50, sha1);


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * vue-breadcrumbs v1.2.0
 * (c) 2018 Sam Turrell
 * Released under the MIT License.
 */


function install(Vue, options) {
  function getMatchedRoutes(routes) {
    // Convert to an array if Vue 1.x
    if (parseFloat(Vue.version) < 2) {
      routes = Object.keys(routes).filter(function (key) {
        return !isNaN(key);
      }).map(function (key) {
        return routes[key];
      });
    }

    return routes;
  }

  // Add the $breadcrumbs property to the Vue instance
  Object.defineProperty(Vue.prototype, '$breadcrumbs', {
    get: function get() {
      var crumbs = [];

      var matched = getMatchedRoutes(this.$route.matched);

      matched.forEach(function (route) {
        // Backwards compatibility
        var hasBreadcrumb = parseFloat(Vue.version) < 2 ? route.handler && route.handler.breadcrumb : route.meta && route.meta.breadcrumb;

        if (hasBreadcrumb) {
          crumbs.push(route);
        }
      });

      return crumbs;
    }
  });

  var defaults = {
    registerComponent: true,

    methods: {
      // Return the correct prop data
      linkProp: function linkProp(crumb) {
        // If it's a named route, we'll base the route
        // off of that instead
        if (crumb.name || crumb.handler && crumb.handler.name) {
          return {
            name: crumb.name || crumb.handler.name,
            params: this.$route.params
          };
        }

        return {
          path: crumb.handler && crumb.handler.fullPath ? crumb.handler.fullPath : crumb.path,
          params: this.$route.params
        };
      }
    },

    filters: {
      // Display the correct breadcrumb text
      // depending on the Vue version
      crumbText: function crumbText(crumb) {
        return parseFloat(Vue.version) < 2 ? crumb.handler.breadcrumb : crumb.meta.breadcrumb;
      }
    },

    template: '<nav class="breadcrumbs" v-if="$breadcrumbs.length"> ' + '<ul> ' + '<li v-for="crumb in $breadcrumbs"> ' + '<router-link :to="linkProp(crumb)">{{ crumb | crumbText }}</router-link> ' + '</li> ' + '</ul> ' + '</nav>'
  };

  options = Object.assign(defaults, options);

  // Add a default breadcrumbs component
  if (options.registerComponent) {
    Vue.component('breadcrumbs', options);
  }
}

var index = {
  install: install,
  version: '0.3.1'
};

module.exports = index;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,A){ true?module.exports=A():"function"==typeof define&&define.amd?define("vue-jstree",[],A):"object"==typeof exports?exports["vue-jstree"]=A():e["vue-jstree"]=A()}(this,function(){return function(e){function A(r){if(t[r])return t[r].exports;var n=t[r]={i:r,l:!1,exports:{}};return e[r].call(n.exports,n,n.exports,A),n.l=!0,n.exports}var t={};return A.m=e,A.c=t,A.i=function(e){return e},A.d=function(e,t,r){A.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:r})},A.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return A.d(t,"a",t),t},A.o=function(e,A){return Object.prototype.hasOwnProperty.call(e,A)},A.p="dist/",A(A.s=4)}([function(e,A){e.exports=function(e,A,t,r,n){var o,a=e=e||{},l=typeof e.default;"object"!==l&&"function"!==l||(o=e,a=e.default);var i="function"==typeof a?a.options:a;A&&(i.render=A.render,i.staticRenderFns=A.staticRenderFns),r&&(i._scopeId=r);var d;if(n?(d=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),t&&t.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(n)},i._ssrRegister=d):t&&(d=t),d){var g=i.functional,s=g?i.render:i.beforeCreate;g?i.render=function(e,A){return d.call(A),s(e,A)}:i.beforeCreate=s?[].concat(s,d):[d]}return{esModule:o,exports:a,options:i}}},function(e,A,t){function r(e){t(10)}var n=t(0)(t(3),t(9),r,null,null);e.exports=n.exports},function(e,A,t){"use strict";function r(e,A,t){return A in e?Object.defineProperty(e,A,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[A]=t,e}Object.defineProperty(A,"__esModule",{value:!0}),A.default={name:"TreeItem",props:{data:{type:Object,required:!0},textFieldName:{type:String},valueFieldName:{type:String},childrenFieldName:{type:String},itemEvents:{type:Object},wholeRow:{type:Boolean,default:!1},showCheckbox:{type:Boolean,default:!1},allowTransition:{type:Boolean,default:!0},height:{type:Number,default:24},parentItem:{type:Array},draggable:{type:Boolean,default:!1},dragOverBackgroundColor:{type:String},onItemClick:{type:Function,default:function(){return!1}},onItemToggle:{type:Function,default:function(){return!1}},onItemDragStart:{type:Function,default:function(){return!1}},onItemDragEnd:{type:Function,default:function(){return!1}},onItemDrop:{type:Function,default:function(){return!1}},klass:String},data:function(){return{isHover:!1,isDragEnter:!1,model:this.data,maxHeight:0,events:{}}},watch:{isDragEnter:function(e){this.$el.style.backgroundColor=e?this.dragOverBackgroundColor:"inherit"},data:function(e){this.model=e},"model.opened":{handler:function(e,A){this.onItemToggle(this,this.model),this.handleGroupMaxHeight()},deep:!0}},computed:{isFolder:function(){return this.model[this.childrenFieldName]&&this.model[this.childrenFieldName].length},classes:function(){return[{"tree-node":!0},{"tree-open":this.model.opened},{"tree-closed":!this.model.opened},{"tree-leaf":!this.isFolder},{"tree-loading":!!this.model.loading},{"tree-drag-enter":this.isDragEnter},r({},this.klass,!!this.klass)]},anchorClasses:function(){return[{"tree-anchor":!0},{"tree-disabled":this.model.disabled},{"tree-selected":this.model.selected},{"tree-hovered":this.isHover}]},wholeRowClasses:function(){return[{"tree-wholerow":!0},{"tree-wholerow-clicked":this.model.selected},{"tree-wholerow-hovered":this.isHover}]},themeIconClasses:function(){return[{"tree-icon":!0},{"tree-themeicon":!0},r({},this.model.icon,!!this.model.icon),{"tree-themeicon-custom":!!this.model.icon}]},isWholeRow:function(){if(this.wholeRow)return void 0===this.$parent.model||!0===this.$parent.model.opened},groupStyle:function(){return{position:this.model.opened?"":"relative","max-height":this.allowTransition?this.maxHeight+"px":"","transition-duration":this.allowTransition?300*Math.ceil(this.model[this.childrenFieldName].length/100)+"ms":"","transition-property":this.allowTransition?"max-height":"",display:this.allowTransition?"block":this.model.opened?"block":"none"}}},methods:{handleItemToggle:function(e){this.isFolder&&(this.model.opened=!this.model.opened,this.onItemToggle(this,this.model))},handleGroupMaxHeight:function(){if(this.allowTransition){var e=0,A=0;if(this.model.opened){e=this.$children.length;var t=!0,r=!1,n=void 0;try{for(var o,a=this.$children[Symbol.iterator]();!(t=(o=a.next()).done);t=!0){A+=o.value.maxHeight}}catch(e){r=!0,n=e}finally{try{!t&&a.return&&a.return()}finally{if(r)throw n}}}this.maxHeight=e*this.height+A,"tree-item"===this.$parent.$options._componentTag&&this.$parent.handleGroupMaxHeight()}},handleItemClick:function(e){this.model.disabled||(this.model.selected=!this.model.selected,this.onItemClick(this,this.model,e))},handleItemMouseOver:function(){this.isHover=!0},handleItemMouseOut:function(){this.isHover=!1},handleItemDrop:function(e,A,t){this.$el.style.backgroundColor="inherit",this.onItemDrop(e,A,t)}},created:function(){var e=this,A=this,t={click:this.handleItemClick,mouseover:this.handleItemMouseOver,mouseout:this.handleItemMouseOut};for(var r in this.itemEvents)!function(r){var n=e.itemEvents[r];if(t.hasOwnProperty(r)){var o=t[r];t[r]=function(e){o(A,A.model,e),n(A,A.model,e)}}else t[r]=function(e){n(A,A.model,e)}}(r);this.events=t},mounted:function(){this.handleGroupMaxHeight()}}},function(e,A,t){"use strict";function r(e,A,t){return A in e?Object.defineProperty(e,A,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[A]=t,e}Object.defineProperty(A,"__esModule",{value:!0});var n=t(7),o=t.n(n),a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},l=0;A.default={name:"VJstree",props:{data:{type:Array},size:{type:String,validator:function(e){return["large","small"].indexOf(e)>-1}},showCheckbox:{type:Boolean,default:!1},wholeRow:{type:Boolean,default:!1},noDots:{type:Boolean,default:!1},collapse:{type:Boolean,default:!1},multiple:{type:Boolean,default:!1},allowBatch:{type:Boolean,default:!1},allowTransition:{type:Boolean,default:!0},textFieldName:{type:String,default:"text"},valueFieldName:{type:String,default:"value"},childrenFieldName:{type:String,default:"children"},itemEvents:{type:Object,default:function(){return{}}},async:{type:Function},loadingText:{type:String,default:"Loading..."},draggable:{type:Boolean,default:!1},dragOverBackgroundColor:{type:String,default:"#C9FDC9"},klass:String},data:function(){return{draggedItem:void 0,draggedElm:void 0}},computed:{classes:function(){return[{tree:!0},{"tree-default":!this.size},r({},"tree-default-"+this.size,!!this.size),{"tree-checkbox-selection":!!this.showCheckbox},r({},this.klass,!!this.klass)]},containerClasses:function(){return[{"tree-container-ul":!0},{"tree-children":!0},{"tree-wholerow-ul":!!this.wholeRow},{"tree-no-dots":!!this.noDots}]},sizeHeight:function(){switch(this.size){case"large":return 32;case"small":return 18;default:return 24}}},methods:{initializeData:function(e){if(e&&e.length>0)for(var A in e){var t=this.initializeDataItem(e[A]);e[A]=t,this.initializeData(e[A][this.childrenFieldName])}},initializeDataItem:function(e){function A(e,A,t,r,n){this.id=e.id||l++,this[A]=e[A]||"",this[t]=e[t]||e[A],this.icon=e.icon||"",this.opened=e.opened||n,this.selected=e.selected||!1,this.disabled=e.disabled||!1,this.loading=e.loading||!1,this[r]=e[r]||[]}var t=Object.assign(new A(e,this.textFieldName,this.valueFieldName,this.childrenFieldName,this.collapse),e),r=this;return t.addBefore=function(e,A){var n=r.initializeDataItem(e),o=A.parentItem.findIndex(function(e){return e.id===t.id});A.parentItem.splice(o,0,n)},t.addAfter=function(e,A){var n=r.initializeDataItem(e),o=A.parentItem.findIndex(function(e){return e.id===t.id})+1;A.parentItem.splice(o,0,n)},t.addChild=function(e){var A=r.initializeDataItem(e);t.opened=!0,t[r.childrenFieldName].push(A)},t.openChildren=function(){t.opened=!0,r.handleRecursionNodeChildren(t,function(e){e.opened=!0})},t.closeChildren=function(){t.opened=!1,r.handleRecursionNodeChildren(t,function(e){e.opened=!1})},t},initializeLoading:function(){var e={};return e[this.textFieldName]=this.loadingText,e.disabled=!0,e.loading=!0,this.initializeDataItem(e)},handleRecursionNodeChilds:function(e,A){if(!1!==A(e)&&e.$children&&e.$children.length>0){var t=!0,r=!1,n=void 0;try{for(var o,a=e.$children[Symbol.iterator]();!(t=(o=a.next()).done);t=!0){var l=o.value;l.disabled||this.handleRecursionNodeChilds(l,A)}}catch(e){r=!0,n=e}finally{try{!t&&a.return&&a.return()}finally{if(r)throw n}}}},handleRecursionNodeChildren:function(e,A){if(!1!==A(e)&&e[this.childrenFieldName]&&e[this.childrenFieldName].length>0){var t=!0,r=!1,n=void 0;try{for(var o,a=e[this.childrenFieldName][Symbol.iterator]();!(t=(o=a.next()).done);t=!0){var l=o.value;this.handleRecursionNodeChildren(l,A)}}catch(e){r=!0,n=e}finally{try{!t&&a.return&&a.return()}finally{if(r)throw n}}}},onItemClick:function(e,A,t){this.multiple?this.allowBatch&&this.handleBatchSelectItems(e,A):this.handleSingleSelectItems(e,A),this.$emit("item-click",e,A,t)},handleSingleSelectItems:function(e,A){this.handleRecursionNodeChilds(this,function(e){e.model&&(e.model.selected=!1)}),e.model.selected=!0},handleBatchSelectItems:function(e,A){this.handleRecursionNodeChilds(e,function(A){A.model.disabled||(A.model.selected=e.model.selected)})},onItemToggle:function(e,A,t){e.model.opened&&this.handleAsyncLoad(e.model[this.childrenFieldName],e,A),this.$emit("item-toggle",e,A,t)},handleAsyncLoad:function(e,A,t){var r=this;this.async&&e[0].loading&&this.async(A,function(t){if(t.length>0)for(var n in t){t[n].isLeaf||"object"!==a(t[n][r.childrenFieldName])&&(t[n][r.childrenFieldName]=[r.initializeLoading()]);var o=r.initializeDataItem(t[n]);r.$set(e,n,o)}else A.model[r.childrenFieldName]=[]})},onItemDragStart:function(e,A,t){if(!this.draggable||t.dragDisabled)return!1;e.dataTransfer.effectAllowed="move",e.dataTransfer.setData("text",null),this.draggedElm=e.target,this.draggedItem={item:t,parentItem:A.parentItem,index:A.parentItem.findIndex(function(e){return e.id===t.id})},this.$emit("item-drag-start",A,t,e)},onItemDragEnd:function(e,A,t){this.draggedItem=void 0,this.draggedElm=void 0,this.$emit("item-drag-end",A,t,e)},onItemDrop:function(e,A,t){var r=this;if(!this.draggable||t.dropDisabled)return!1;if(this.$emit("item-drop-before",A,t,this.draggedItem?this.draggedItem.item:void 0,e),this.draggedElm&&this.draggedElm!==e.target&&!this.draggedElm.contains(e.target)&&this.draggedItem){if(this.draggedItem.parentItem===t[this.childrenFieldName]||this.draggedItem.item===t||t[this.childrenFieldName]&&-1!==t[this.childrenFieldName].findIndex(function(e){return e.id===r.draggedItem.item.id}))return;t[this.childrenFieldName]?t[this.childrenFieldName].push(this.draggedItem.item):t[this.childrenFieldName]=[this.draggedItem.item],t.opened=!0;var n=this.draggedItem;this.$nextTick(function(){n.parentItem.splice(n.index,1)}),this.$emit("item-drop",A,t,n.item,e)}}},created:function(){this.initializeData(this.data)},mounted:function(){this.async&&(this.$set(this.data,0,this.initializeLoading()),this.handleAsyncLoad(this.data,this))},components:{TreeItem:o.a}}},function(e,A,t){"use strict";Object.defineProperty(A,"__esModule",{value:!0});var r=t(1),n=t.n(r);n.a.install=function(e){e.component(n.a.name,n.a)},"undefined"!=typeof window&&window.Vue&&window.Vue.use(n.a),A.default=n.a},function(e,A,t){A=e.exports=t(6)(),A.push([e.i,'.tree-children,.tree-container-ul,.tree-node{display:block;margin:0;padding:0;list-style-type:none;list-style-image:none}.tree-children{overflow:hidden}.tree-anchor,.tree-node{white-space:nowrap}.tree-anchor{display:inline-block;color:#000;padding:0 4px 0 1px;margin:0;vertical-align:top;font-size:14px;cursor:pointer}.tree-anchor:focus{outline:0}.tree-anchor,.tree-anchor:active,.tree-anchor:hover,.tree-anchor:link,.tree-anchor:visited{text-decoration:none;color:inherit}.tree-icon,.tree-icon:empty{display:inline-block;text-decoration:none;margin:0;padding:0;vertical-align:top;text-align:center}.tree-ocl{cursor:pointer}.tree-leaf>.tree-ocl{cursor:default}.tree-anchor>.tree-themeicon{margin-right:2px}.tree-anchor>.tree-themeicon-hidden,.tree-hidden,.tree-no-icons .tree-themeicon,.tree-node.tree-hidden{display:none}.tree-rtl .tree-anchor{padding:0 1px 0 4px}.tree-rtl .tree-anchor>.tree-themeicon{margin-left:2px;margin-right:0}.tree-rtl .tree-node{margin-left:0}.tree-rtl .tree-container-ul>.tree-node{margin-right:0}.tree-wholerow-ul{position:relative;display:inline-block;min-width:100%}.tree-wholerow-ul .tree-leaf>.tree-ocl{cursor:pointer}.tree-wholerow-ul .tree-anchor,.tree-wholerow-ul .tree-icon{position:relative}.tree-wholerow-ul .tree-wholerow{width:100%;cursor:pointer;z-index:-1;position:absolute;left:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.tree{text-align:left}.tree-default .tree-icon,.tree-default .tree-node{background-repeat:no-repeat;background-color:transparent}.tree-default .tree-anchor,.tree-default .tree-animated,.tree-default .tree-wholerow{transition:background-color .15s,box-shadow .15s}.tree-default .tree-context,.tree-default .tree-hovered{background:#eee;border:0;box-shadow:none}.tree-default .tree-selected{background:#e1e1e1;border:0;box-shadow:none}.tree-default .tree-no-icons .tree-anchor>.tree-themeicon{display:none}.tree-default .tree-disabled{color:#666}.tree-default .tree-disabled.tree-hovered{box-shadow:none}.tree-default .tree-disabled>.tree-icon{opacity:.8;filter:url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'tree-grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#tree-grayscale");filter:gray;-webkit-filter:grayscale(100%)}.tree-default .tree-search{font-style:italic;color:#8b0000;font-weight:700}.tree-default .tree-no-checkboxes .tree-checkbox{display:none!important}.tree-default.tree-checkbox-no-clicked .tree-selected{background:transparent;box-shadow:none}.tree-default.tree-checkbox-no-clicked .tree-selected.tree-hovered{background:#eee}.tree-default.tree-checkbox-no-clicked>.tree-wholerow-ul .tree-wholerow-clicked{background:transparent}.tree-default.tree-checkbox-no-clicked>.tree-wholerow-ul .tree-wholerow-clicked.tree-wholerow-hovered{background:#eee}.tree-default>.tree-striped{min-width:100%;display:inline-block;background:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAkCAMAAAB/qqA+AAAABlBMVEUAAAAAAAClZ7nPAAAAAnRSTlMNAMM9s3UAAAAXSURBVHjajcEBAQAAAIKg/H/aCQZ70AUBjAATb6YPDgAAAABJRU5ErkJggg==") 0 0 repeat}.tree-default>.tree-wholerow-ul .tree-hovered,.tree-default>.tree-wholerow-ul .tree-selected{background:transparent;box-shadow:none;border-radius:0}.tree-default .tree-wholerow{box-sizing:border-box}.tree-default .tree-wholerow-hovered{background:#eee}.tree-default .tree-wholerow-clicked{background:#e1e1e1}.tree-default .tree-node{min-height:24px;line-height:24px;margin-left:30px;min-width:24px}.tree-default .tree-anchor,.tree-default .tree-icon{line-height:24px;height:24px}.tree-default .tree-icon{width:24px}.tree-default .tree-icon:empty{width:24px;height:24px;line-height:24px}.tree-default.tree-rtl .tree-node{margin-right:24px}.tree-default .tree-wholerow{height:24px}.tree-default .tree-icon,.tree-default .tree-node{background-image:url("data:image/png;base64,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")}.tree-default .tree-node{background-position:-292px -4px;background-repeat:repeat-y}.tree-default .tree-last{background:transparent}.tree-default .tree-open>.tree-ocl{background-position:-132px -4px}.tree-default .tree-closed>.tree-ocl{background-position:-100px -4px}.tree-default .tree-leaf>.tree-ocl{background-position:-68px -4px}.tree-default .tree-themeicon{background-position:-260px -4px}.tree-default>.tree-no-dots .tree-leaf>.tree-ocl,.tree-default>.tree-no-dots .tree-node{background:transparent}.tree-default>.tree-no-dots .tree-open>.tree-ocl{background-position:-36px -4px}.tree-default>.tree-no-dots .tree-closed>.tree-ocl{background-position:-4px -4px}.tree-default .tree-disabled,.tree-default .tree-disabled.tree-hovered{background:transparent}.tree-default .tree-disabled.tree-selected{background:#efefef}.tree-default .tree-checkbox{background-position:-164px -4px}.tree-default .tree-checkbox:hover{background-position:-164px -36px}.tree-default.tree-checkbox-selection .tree-selected>.tree-checkbox,.tree-default .tree-checked>.tree-checkbox{background-position:-228px -4px}.tree-default.tree-checkbox-selection .tree-selected>.tree-checkbox:hover,.tree-default .tree-checked>.tree-checkbox:hover{background-position:-228px -36px}.tree-default .tree-anchor>.tree-undetermined{background-position:-196px -4px}.tree-default .tree-anchor>.tree-undetermined:hover{background-position:-196px -36px}.tree-default .tree-checkbox-disabled{opacity:.8;filter:url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'tree-grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#tree-grayscale");filter:gray;-webkit-filter:grayscale(100%)}.tree-default>.tree-striped{background-size:auto 48px}.tree-default.tree-rtl .tree-node{background-position:100% 1px;background-repeat:repeat-y}.tree-default.tree-rtl .tree-open>.tree-ocl{background-position:-132px -36px}.tree-default.tree-rtl .tree-closed>.tree-ocl{background-position:-100px -36px}.tree-default.tree-rtl .tree-leaf>.tree-ocl{background-position:-68px -36px}.tree-default.tree-rtl>.tree-no-dots .tree-leaf>.tree-ocl,.tree-default.tree-rtl>.tree-no-dots .tree-node{background:transparent}.tree-default.tree-rtl>.tree-no-dots .tree-open>.tree-ocl{background-position:-36px -36px}.tree-default.tree-rtl>.tree-no-dots .tree-closed>.tree-ocl{background-position:-4px -36px}.tree-default .tree-themeicon-custom{background-color:transparent;background-image:none;background-position:0 0}.tree-default .tree-node.tree-loading{background:none}.tree-default>.tree-container-ul .tree-loading>.tree-ocl{background:url("data:image/gif;base64,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") 50% no-repeat}.tree-default .tree-file{background:url("data:image/png;base64,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") -100px -68px no-repeat}.tree-default .tree-folder{background:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAABgCAYAAABsS6soAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAACbBJREFUeNrsnX+IHFcBx9/szaZerrU/rmpCcmmLAVuFinjFhFLECmf+EEVrWlNThNo/iiBEaJSribW1EjSSNEY9/6iKxBZK8Q+10nSxAckfScmJtZAm1fzRJA2pUm1yOe9wd3bH9+Zuzunc3GV3frw3O+/zCY+5mbvL25l9893Pe/NuxvF9X4AQjuP0/DsjI2v8s2fPOaZecxXrpz2Wu82XCdX+zpx5I9NOODS4ajSGqkB7pM3rbC81mkG2TyDqhyp9+OgsZWh/GCAGiAHS5o0c+zzOOQwQA8MAgfMPA8QAMUDAADFADAwDBM4/DBADxAABA8QAMTAMEDj/MEAMsB8NsNFopG6kY2Njmd/YqtaPAQrhdvuDo6OjPdc0OTmZW6oUXX+aA7lu3drMM9E59l2fyGmCg/ozcupP96yXi+/L8vnYt34ny/j6jz/zqmEDzNTO3KIadZqTpuz1x9ERfpF97yWwKlc/GONpWW5L2P4ZWW6U5cOmXlgef4bp8v6mR5cBQnnoxqrS2FqJuW2Z790qDXGTtMCDVhjgUqaVd3enXzAdfsq0ejEzqD7j4+Pndu3atUZjlc/LEIwHkSfL72V5UIbjP8tsgFwFzmiAHAUoUfj9Wy7WGKjaSRCrz6kA1GCABKCtBggQCb9pubiuZC/r0SL/c2NjgPELDNF1Hd3h5S5w6OyOh2OAaZdpu71Lrce7wzrqjx37wusn6MaDpezmRrfNysWV8e1Vx9gYYDRk5sPISToBiiIp5EyMh4Uncdplyn3vep+Lrj/r8YFsQajCTi6bcnXQtvDLywDpAgP0ETHzU4sVNoZfxADNB6CyAtNXI7kaCjaGoK3hVxoDtHUKTBkg9AlBW8MvLwNkIjRAD5RpkrPN4ZeXAfYUgDr+vKzM9Rved6vrB2O8IcvalL+7Q4MB6rkKbLqra3NXm2Of740FqL8n7pflJ7IMX+bnrp1fvj2/VH8e97OyGyC3wwKwlH6/HRbPBQYAawMwj9fMPEAA6Eu4IzQAYIAYIABggBggAGg0MNNggACAAWKAAIABYoBaMX1XaNvrBwwQAwQADBADxMAwQMAAMUAAwAAxQAwMAwQMEAMEAAwQA8TAMEDAADFAAAwQAwQMDAMEDBCglDQaDU/M3fo8LJcVg7CMjY25OdSf+iSR9TtlrT8vA3zoG9/yRz9yqzj599fFqdPnxfobVgfbjx9/RTz7zFOFambW/Oq6caR5Hkeet1I3Xf9yBqTjQd+WH39H1t9LbyUISll/J8f9Fyn2X1Sl/uVY//4R8dwfjwTB981tD4jHHp97WNMVV75HhwHqeSZIrw26iAcYma4/CR3hl6ZBF/EQI4P1O5p/DxLY+pVtiefUi4cOz3+1emFbGH7qd3798ycKeR+0PxUOzBmg5ZQmALv5EKjyE/QOPLl30ba254kLF6fEj3/6pDh16uqFn7v7i1sLtcA8DDDzRRCbH1Wp2wBtO9mgdyYmJgqvY+Bjv31HWXH7H8Tw8HXa9zUPA+QqcA4GyFGAMrB//34xPT1tzf7mcRWYLnCfGyCAYt++faLZbFq1z8bGAOPd3ui6jiuvy3W709YfjuWlXeZhkt3+//Fub3Q97ZW/LPXHjj9pVCC7d+8Oltu3b1/YtnfvXuF53qLtlhigvqvASSEzH0aOzsafFHLqpMxSf3iSp13mZZLd/P/R/cy631nrB3NBqMJuz549ot1uWxd+Rg0QAMygQi60wHCpO/zaL302cfv09JQdBlhGI8BKwMYQ1Bl+8/P5lhx+WjU8FCz/+pdj4r4Hvh5MgQm3VdYAdYz5AcEPySGou9v73R3bFm3b+fgTQdDdvvHBYH3Llh+JV08eEJ+88w7xhbs2ix/+4HvVNkCAgknb0HOfolSmeZcmxvxuuunGRe/D5nu+5A+t3SRefvm4+M/sYTE0eIf44M33iRcPHRDXvPva6hig6UnPtk+6Nn3yGay/NAEIi9n6tS3i2V8ejHSFD4vTp18PusAXpt4urN48DJC7wUDp4W4w5b4bjNGuQcb8IgABLKXfA1AZYNZpaAQgAAForQHyt8AA0LcGmPlDAAMEwAAxQAAADBAAMEAMEAAAAwQADBADBADAAAEAA8QAAQAwQADAADFAAAAMEAAwQAwQAAADBAAMEAMEAMAA+4+64wxG11u+P6ut7qGB9z780I6vJn2v0Wj87ciRI0/zDgEGWNEA/O8ttwQv9ooTJ5wsP5Mp/FbWrvJmOteodXdl7YKY6VzSFYIbN268V4bcU/HtszOz4uLURTExMfGo5Duc2mBDAOZxR+hCusCjv3F8VYoOwm6354kKv7fe+tdrqohm7UOefB/iVqiTtueJmdlZIV+PkOH3iIQABCvI46lwuQdgkcEXtbp42EXXi7C/AGl/ruuuUV++8OeD4s03/3FIrZsMwZrrivoKN3hS0NSlKfHtnTsJQbCCPMYAcw3AaPhN3uUXEkJJIagl/GL86rlflCIE1c4OvWulGLlhRJw5c1acOPma2Lz57kfq9fonOEUAA1ye3B6MriP8oiFnMvyiIahQIbhq1fvuFCs6F2QIFn1hZNGzUJUFrhwcFCPrRoTX9AIjHB0dXc0pAhYYYKZzvusADAMuKdx0hl9SCJoIv6QQvP764Q/IA3qpMNtbYtRabR1w6+Lqq+rBmCCPA4dIm8EA8+wCx8f4TIRf3PyS1ivanH3R8TtLdYUVA9IGVQGwxAD1BGA03MLQK0P4LXdhRAdf/vT94lMf3SRUFziYFlMgbn1AHXA/7AeHZe4Lf3EaAlQY7QaYFIJlCD9TIRgNP8/zzhU9J9CR/3yVdNIB/XZb+LK7q0qn0xbtdmeu+zsHnWDAAIvoAsfDrgzmZyIE4+EnO51niwy/DRs2BJPWZcj57Y4X9ITbal0Wv6O8cK5nrELQxwEBAywmAKOhpzP8lgq7brbnhjS8wPQkOsNPcfTo0SDUW03PaTZbotXyhKxbeHLZbLVkkUu5XZWODElOD8AAL0/q0XIT4ddNwBUdgmqcT13tDb92PaHtT+GkAfqtTqtWi39uOfMCGI4QNjFAwAALDUAbUUGn5vktTHWZ6Wi9GUK73Vbz/ZyOGgOUiefLLxynFkx1GKjXAp9XLUJNiQGwxAD1zAOE/4egqbqPHTt2/uEdj6nAU77nB3O81BhgcFMLNR3QXxj/m5ycPM+7BRjg8nA7rPBA9MGEUflpFdyNpu66ouV5wnVdZ67/Oxd7XnTsT41XCjHLOwtVNsCsd4MhAPsoAAHgnXBHaACw1gDpAmOAABggBggAGCAGiAECYIAYIABggBggAEAC/xNgABT+eKeUWyLUAAAAAElFTkSuQmCC") -260px -4px no-repeat}.tree-default>.tree-container-ul>.tree-node{margin-left:0;margin-right:0}.tree-default .tree-ellipsis{overflow:hidden}.tree-default .tree-ellipsis .tree-anchor{width:calc(100% - 29px);text-overflow:ellipsis;overflow:hidden}.tree-default .tree-ellipsis.tree-no-icons .tree-anchor{width:calc(100% - 5px)}.tree-default.tree-rtl .tree-node{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAACAQMAAAB49I5GAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjAAMOBgAAGAAJMwQHdQAAAABJRU5ErkJggg==")}.tree-default.tree-rtl .tree-last{background:transparent}.tree-default-small .tree-node{min-height:18px;line-height:18px;margin-left:24px;min-width:18px}.tree-default-small .tree-anchor{line-height:18px;height:18px}.tree-default-small .tree-icon,.tree-default-small .tree-icon:empty{width:18px;height:18px;line-height:18px}.tree-default-small.tree-rtl .tree-node{margin-right:18px}.tree-default-small .tree-wholerow{height:18px}.tree-default-small .tree-icon,.tree-default-small .tree-node{background-image:url("data:image/png;base64,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")}.tree-default-small .tree-node{background-position:-295px -7px;background-repeat:repeat-y}.tree-default-small .tree-last{background:transparent}.tree-default-small .tree-open>.tree-ocl{background-position:-135px -7px}.tree-default-small .tree-closed>.tree-ocl{background-position:-103px -7px}.tree-default-small .tree-leaf>.tree-ocl{background-position:-71px -7px}.tree-default-small .tree-themeicon{background-position:-263px -7px}.tree-default-small>.tree-no-dots .tree-leaf>.tree-ocl,.tree-default-small>.tree-no-dots .tree-node{background:transparent}.tree-default-small>.tree-no-dots .tree-open>.tree-ocl{background-position:-39px -7px}.tree-default-small>.tree-no-dots .tree-closed>.tree-ocl{background-position:-7px -7px}.tree-default-small .tree-disabled,.tree-default-small .tree-disabled.tree-hovered{background:transparent}.tree-default-small .tree-disabled.tree-selected{background:#efefef}.tree-default-small .tree-checkbox{background-position:-167px -7px}.tree-default-small .tree-checkbox:hover{background-position:-167px -39px}.tree-default-small.tree-checkbox-selection .tree-selected>.tree-checkbox,.tree-default-small .tree-checked>.tree-checkbox{background-position:-231px -7px}.tree-default-small.tree-checkbox-selection .tree-selected>.tree-checkbox:hover,.tree-default-small .tree-checked>.tree-checkbox:hover{background-position:-231px -39px}.tree-default-small .tree-anchor>.tree-undetermined{background-position:-199px -7px}.tree-default-small .tree-anchor>.tree-undetermined:hover{background-position:-199px -39px}.tree-default-small .tree-checkbox-disabled{opacity:.8;filter:url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'tree-grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#tree-grayscale");filter:gray;-webkit-filter:grayscale(100%)}.tree-default-small>.tree-striped{background-size:auto 36px}.tree-default-small.tree-rtl .tree-node{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAACAQMAAAB49I5GAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjAAMOBgAAGAAJMwQHdQAAAABJRU5ErkJggg==");background-position:100% 1px;background-repeat:repeat-y}.tree-default-small.tree-rtl .tree-open>.tree-ocl{background-position:-135px -39px}.tree-default-small.tree-rtl .tree-closed>.tree-ocl{background-position:-103px -39px}.tree-default-small.tree-rtl .tree-leaf>.tree-ocl{background-position:-71px -39px}.tree-default-small.tree-rtl>.tree-no-dots .tree-leaf>.tree-ocl,.tree-default-small.tree-rtl>.tree-no-dots .tree-node{background:transparent}.tree-default-small.tree-rtl>.tree-no-dots .tree-open>.tree-ocl{background-position:-39px -39px}.tree-default-small.tree-rtl>.tree-no-dots .tree-closed>.tree-ocl{background-position:-7px -39px}.tree-default-small .tree-themeicon-custom{background-color:transparent;background-image:none;background-position:0 0}.tree-default-small .tree-node.tree-loading{background:none}.tree-default-small>.tree-container-ul .tree-loading>.tree-ocl{background:url("data:image/gif;base64,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") 50% no-repeat}.tree-default-small .tree-file{background:url("data:image/png;base64,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") -103px -71px no-repeat}.tree-default-small .tree-folder{background:url("data:image/png;base64,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") -263px -7px no-repeat}.tree-default-small>.tree-container-ul>.tree-node{margin-left:0;margin-right:0}.tree-default-small .tree-ellipsis{overflow:hidden}.tree-default-small .tree-ellipsis .tree-anchor{width:calc(100% - 23px);text-overflow:ellipsis;overflow:hidden}.tree-default-small .tree-ellipsis.tree-no-icons .tree-anchor{width:calc(100% - 5px)}.tree-default-small.tree-rtl .tree-node{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAACAQMAAABv1h6PAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjAAMHBgAAiABBI4gz9AAAAABJRU5ErkJggg==")}.tree-default-small.tree-rtl .tree-last{background:transparent}.tree-default-large .tree-node{min-height:32px;line-height:32px;margin-left:38px;min-width:32px}.tree-default-large .tree-anchor{line-height:32px;height:32px}.tree-default-large .tree-icon,.tree-default-large .tree-icon:empty{width:32px;height:32px;line-height:32px}.tree-default-large.tree-rtl .tree-node{margin-right:32px}.tree-default-large .tree-wholerow{height:32px}.tree-default-large .tree-icon,.tree-default-large .tree-node{background-image:url("data:image/png;base64,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")}.tree-default-large .tree-node{background-position:-288px 0;background-repeat:repeat-y}.tree-default-large .tree-last{background:transparent}.tree-default-large .tree-open>.tree-ocl{background-position:-128px 0}.tree-default-large .tree-closed>.tree-ocl{background-position:-96px 0}.tree-default-large .tree-leaf>.tree-ocl{background-position:-64px 0}.tree-default-large .tree-themeicon{background-position:-256px 0}.tree-default-large>.tree-no-dots .tree-leaf>.tree-ocl,.tree-default-large>.tree-no-dots .tree-node{background:transparent}.tree-default-large>.tree-no-dots .tree-open>.tree-ocl{background-position:-32px 0}.tree-default-large>.tree-no-dots .tree-closed>.tree-ocl{background-position:0 0}.tree-default-large .tree-disabled,.tree-default-large .tree-disabled.tree-hovered{background:transparent}.tree-default-large .tree-disabled.tree-selected{background:#efefef}.tree-default-large .tree-checkbox{background-position:-160px 0}.tree-default-large .tree-checkbox:hover{background-position:-160px -32px}.tree-default-large.tree-checkbox-selection .tree-selected>.tree-checkbox,.tree-default-large .tree-checked>.tree-checkbox{background-position:-224px 0}.tree-default-large.tree-checkbox-selection .tree-selected>.tree-checkbox:hover,.tree-default-large .tree-checked>.tree-checkbox:hover{background-position:-224px -32px}.tree-default-large .tree-anchor>.tree-undetermined{background-position:-192px 0}.tree-default-large .tree-anchor>.tree-undetermined:hover{background-position:-192px -32px}.tree-default-large .tree-checkbox-disabled{opacity:.8;filter:url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'tree-grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#tree-grayscale");filter:gray;-webkit-filter:grayscale(100%)}.tree-default-large>.tree-striped{background-size:auto 64px}.tree-default-large.tree-rtl .tree-node{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAACAQMAAAB49I5GAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjAAMOBgAAGAAJMwQHdQAAAABJRU5ErkJggg==");background-position:100% 1px;background-repeat:repeat-y}.tree-default-large.tree-rtl .tree-open>.tree-ocl{background-position:-128px -32px}.tree-default-large.tree-rtl .tree-closed>.tree-ocl{background-position:-96px -32px}.tree-default-large.tree-rtl .tree-leaf>.tree-ocl{background-position:-64px -32px}.tree-default-large.tree-rtl>.tree-no-dots .tree-leaf>.tree-ocl,.tree-default-large.tree-rtl>.tree-no-dots .tree-node{background:transparent}.tree-default-large.tree-rtl>.tree-no-dots .tree-open>.tree-ocl{background-position:-32px -32px}.tree-default-large.tree-rtl>.tree-no-dots .tree-closed>.tree-ocl{background-position:0 -32px}.tree-default-large .tree-themeicon-custom{background-color:transparent;background-image:none;background-position:0 0}.tree-default-large .tree-node.tree-loading{background:none}.tree-default-large>.tree-container-ul .tree-loading>.tree-ocl{background:url("data:image/gif;base64,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") 50% no-repeat}.tree-default-large .tree-file{background:url("data:image/png;base64,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") -96px -64px no-repeat}.tree-default-large .tree-folder{background:url("data:image/png;base64,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") -256px 0 no-repeat}.tree-default-large>.tree-container-ul>.tree-node{margin-left:0;margin-right:0}.tree-default-large .tree-ellipsis{overflow:hidden}.tree-default-large .tree-ellipsis .tree-anchor{width:calc(100% - 37px);text-overflow:ellipsis;overflow:hidden}.tree-default-large .tree-ellipsis.tree-no-icons .tree-anchor{width:calc(100% - 5px)}.tree-default-large.tree-rtl .tree-node{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAACAQMAAAAD0EyKAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjgIIGBgABCgCBvVLXcAAAAABJRU5ErkJggg==")}.tree-default-large.tree-rtl .tree-last{background:transparent}',""])},function(e,A){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],A=0;A<this.length;A++){var t=this[A];t[2]?e.push("@media "+t[2]+"{"+t[1]+"}"):e.push(t[1])}return e.join("")},e.i=function(A,t){"string"==typeof A&&(A=[[null,A,""]]);for(var r={},n=0;n<this.length;n++){var o=this[n][0];"number"==typeof o&&(r[o]=!0)}for(n=0;n<A.length;n++){var a=A[n];"number"==typeof a[0]&&r[a[0]]||(t&&!a[2]?a[2]=t:t&&(a[2]="("+a[2]+") and ("+t+")"),e.push(a))}},e}},function(e,A,t){var r=t(0)(t(2),t(8),null,null,null);e.exports=r.exports},function(e,A){e.exports={render:function(){var e=this,A=e.$createElement,t=e._self._c||A;return t("li",{class:e.classes,attrs:{role:"treeitem",draggable:e.draggable},on:{dragstart:function(A){A.stopPropagation(),e.onItemDragStart(A,e._self,e._self.model)},dragend:function(A){A.stopPropagation(),A.preventDefault(),e.onItemDragEnd(A,e._self,e._self.model)},dragover:function(A){A.stopPropagation(),A.preventDefault(),e.isDragEnter=!0},dragenter:function(A){A.stopPropagation(),A.preventDefault(),e.isDragEnter=!0},dragleave:function(A){A.stopPropagation(),A.preventDefault(),e.isDragEnter=!1},drop:function(A){A.stopPropagation(),A.preventDefault(),e.handleItemDrop(A,e._self,e._self.model)}}},[e.isWholeRow?t("div",{class:e.wholeRowClasses,attrs:{role:"presentation"}},[e._v(" ")]):e._e(),e._v(" "),t("i",{staticClass:"tree-icon tree-ocl",attrs:{role:"presentation"},on:{click:e.handleItemToggle}}),e._v(" "),t("div",e._g({class:e.anchorClasses},e.events),[e.showCheckbox&&!e.model.loading?t("i",{staticClass:"tree-icon tree-checkbox",attrs:{role:"presentation"}}):e._e(),e._v(" "),e._t("default",[e.model.loading?e._e():t("i",{class:e.themeIconClasses,attrs:{role:"presentation"}}),e._v(" "),t("span",{domProps:{innerHTML:e._s(e.model[e.textFieldName])}})],{vm:this,model:e.model})],2),e._v(" "),e.isFolder?t("ul",{ref:"group",staticClass:"tree-children",style:e.groupStyle,attrs:{role:"group"}},e._l(e.model[e.childrenFieldName],function(A,r){return t("tree-item",{key:r,attrs:{data:A,"text-field-name":e.textFieldName,"value-field-name":e.valueFieldName,"children-field-name":e.childrenFieldName,"item-events":e.itemEvents,"whole-row":e.wholeRow,"show-checkbox":e.showCheckbox,"allow-transition":e.allowTransition,height:e.height,"parent-item":e.model[e.childrenFieldName],draggable:e.draggable,"drag-over-background-color":e.dragOverBackgroundColor,"on-item-click":e.onItemClick,"on-item-toggle":e.onItemToggle,"on-item-drag-start":e.onItemDragStart,"on-item-drag-end":e.onItemDragEnd,"on-item-drop":e.onItemDrop,klass:r===e.model[e.childrenFieldName].length-1?"tree-last":""},scopedSlots:e._u([{key:"default",fn:function(A){return[e._t("default",[e.model.loading?e._e():t("i",{class:A.vm.themeIconClasses,attrs:{role:"presentation"}}),e._v(" "),t("span",{domProps:{innerHTML:e._s(A.model[e.textFieldName])}})],{vm:A.vm,model:A.model})]}}])})})):e._e()])},staticRenderFns:[]}},function(e,A){e.exports={render:function(){var e=this,A=e.$createElement,t=e._self._c||A;return t("div",{class:e.classes,attrs:{role:"tree",onselectstart:"return false"}},[t("ul",{class:e.containerClasses,attrs:{role:"group"}},e._l(e.data,function(A,r){return t("tree-item",{key:r,attrs:{data:A,"text-field-name":e.textFieldName,"value-field-name":e.valueFieldName,"children-field-name":e.childrenFieldName,"item-events":e.itemEvents,"whole-row":e.wholeRow,"show-checkbox":e.showCheckbox,"allow-transition":e.allowTransition,height:e.sizeHeight,"parent-item":e.data,draggable:e.draggable,"drag-over-background-color":e.dragOverBackgroundColor,"on-item-click":e.onItemClick,"on-item-toggle":e.onItemToggle,"on-item-drag-start":e.onItemDragStart,"on-item-drag-end":e.onItemDragEnd,"on-item-drop":e.onItemDrop,klass:r===e.data.length-1?"tree-last":""},scopedSlots:e._u([{key:"default",fn:function(A){return[e._t("default",[A.model.loading?e._e():t("i",{class:A.vm.themeIconClasses,attrs:{role:"presentation"}}),e._v(" "),t("span",{domProps:{innerHTML:e._s(A.model[e.textFieldName])}})],{vm:A.vm,model:A.model})]}}])})}))])},staticRenderFns:[]}},function(e,A,t){var r=t(5);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);t(11)("134662b0",r,!0,{})},function(e,A,t){function r(e){for(var A=0;A<e.length;A++){var t=e[A],r=g[t.id];if(r){r.refs++;for(var n=0;n<r.parts.length;n++)r.parts[n](t.parts[n]);for(;n<t.parts.length;n++)r.parts.push(o(t.parts[n]));r.parts.length>t.parts.length&&(r.parts.length=t.parts.length)}else{for(var a=[],n=0;n<t.parts.length;n++)a.push(o(t.parts[n]));g[t.id]={id:t.id,refs:1,parts:a}}}}function n(){var e=document.createElement("style");return e.type="text/css",s.appendChild(e),e}function o(e){var A,t,r=document.querySelector("style["+m+'~="'+e.id+'"]');if(r){if(f)return h;r.parentNode.removeChild(r)}if(B){var o=u++;r=c||(c=n()),A=a.bind(null,r,o,!1),t=a.bind(null,r,o,!0)}else r=n(),A=l.bind(null,r),t=function(){r.parentNode.removeChild(r)};return A(e),function(r){if(r){if(r.css===e.css&&r.media===e.media&&r.sourceMap===e.sourceMap)return;A(e=r)}else t()}}function a(e,A,t,r){var n=t?"":r.css;if(e.styleSheet)e.styleSheet.cssText=w(A,n);else{var o=document.createTextNode(n),a=e.childNodes;a[A]&&e.removeChild(a[A]),a.length?e.insertBefore(o,a[A]):e.appendChild(o)}}function l(e,A){var t=A.css,r=A.media,n=A.sourceMap;if(r&&e.setAttribute("media",r),p.ssrId&&e.setAttribute(m,A.id),n&&(t+="\n/*# sourceURL="+n.sources[0]+" */",t+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(n))))+" */"),e.styleSheet)e.styleSheet.cssText=t;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(t))}}var i="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!i)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var d=t(12),g={},s=i&&(document.head||document.getElementsByTagName("head")[0]),c=null,u=0,f=!1,h=function(){},p=null,m="data-vue-ssr-id",B="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());e.exports=function(e,A,t,n){f=t,p=n||{};var o=d(e,A);return r(o),function(A){for(var t=[],n=0;n<o.length;n++){var a=o[n],l=g[a.id];l.refs--,t.push(l)}A?(o=d(e,A),r(o)):o=[];for(var n=0;n<t.length;n++){var l=t[n];if(0===l.refs){for(var i=0;i<l.parts.length;i++)l.parts[i]();delete g[l.id]}}}};var w=function(){var e=[];return function(A,t){return e[A]=t,e.filter(Boolean).join("\n")}}()},function(e,A){e.exports=function(e,A){for(var t=[],r={},n=0;n<A.length;n++){var o=A[n],a=o[0],l=o[1],i=o[2],d=o[3],g={id:e+":"+n,css:l,media:i,sourceMap:d};r[a]?r[a].parts.push(g):t.push(r[a]={id:a,parts:[g]})}return t}}])});
//# sourceMappingURL=vue-jstree.js.map

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(152);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f29dba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1906)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f29dba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f29dba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateSubFolderELearningModal_vue__ = __webpack_require__(153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43781e9c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateSubFolderELearningModal_vue__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1804)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43781e9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateSubFolderELearningModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43781e9c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateSubFolderELearningModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43781e9c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateSubFolderELearningModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetialsELearning_vue__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a820e282_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetialsELearning_vue__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1955)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetialsELearning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a820e282_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetialsELearning_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a820e282_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetialsELearning_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FolderELearningModal_vue__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0cf6e74_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FolderELearningModal_vue__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1898)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0cf6e74"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FolderELearningModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0cf6e74_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FolderELearningModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0cf6e74_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FolderELearningModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageELearning_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ed133a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageELearning_vue__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1742)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08ed133a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageELearning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ed133a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageELearning_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ed133a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageELearning_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateELearning_vue__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6882d6b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateELearning_vue__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1956)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateELearning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6882d6b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateELearning_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6882d6b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateELearning_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertPM_vue__ = __webpack_require__(158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3817b2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertPM_vue__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1780)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b3817b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertPM_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3817b2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertPM_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3817b2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertPM_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobIssue_vue__ = __webpack_require__(159);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01056d89_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobIssue_vue__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1732)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01056d89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobIssue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01056d89_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobIssue_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01056d89_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobIssue_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterShopByBrand_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_310a6330_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterShopByBrand_vue__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1784)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-310a6330"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterShopByBrand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_310a6330_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterShopByBrand_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_310a6330_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterShopByBrand_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Survey_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57894183_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Survey_vue__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1823)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57894183"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Survey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57894183_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Survey_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57894183_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Survey_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentScoreList_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24fb1b31_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentScoreList_vue__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1957)
  __webpack_require__(1931)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentScoreList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24fb1b31_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentScoreList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24fb1b31_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentScoreList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBeerClaim_vue__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f022e1d2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBeerClaim_vue__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1897)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f022e1d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBeerClaim_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f022e1d2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBeerClaim_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f022e1d2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBeerClaim_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBeerClaimItem_vue__ = __webpack_require__(164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01bcfb02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBeerClaimItem_vue__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1734)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01bcfb02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBeerClaimItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01bcfb02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBeerClaimItem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01bcfb02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBeerClaimItem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyzeSpecifyForm_vue__ = __webpack_require__(165);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_906b5640_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyzeSpecifyForm_vue__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1870)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-906b5640"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyzeSpecifyForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_906b5640_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyzeSpecifyForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_906b5640_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyzeSpecifyForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproveBeerClaim_vue__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64632307_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveBeerClaim_vue__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1835)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64632307"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproveBeerClaim_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64632307_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveBeerClaim_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64632307_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveBeerClaim_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BeerClaimDetail_vue__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53176d34_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BeerClaimDetail_vue__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1818)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53176d34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BeerClaimDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53176d34_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BeerClaimDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53176d34_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BeerClaimDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BeerClaimItemDetail_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164e5362_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BeerClaimItemDetail_vue__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1756)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-164e5362"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BeerClaimItemDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164e5362_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BeerClaimItemDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_164e5362_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BeerClaimItemDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitBeerClaim_vue__ = __webpack_require__(169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f689224_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitBeerClaim_vue__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1859)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f689224"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitBeerClaim_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f689224_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitBeerClaim_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f689224_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitBeerClaim_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConcludeApproveBeerClaim_vue__ = __webpack_require__(170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bca7cf1e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConcludeApproveBeerClaim_vue__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1884)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bca7cf1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConcludeApproveBeerClaim_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bca7cf1e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConcludeApproveBeerClaim_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bca7cf1e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConcludeApproveBeerClaim_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBeerClaim_vue__ = __webpack_require__(171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed72376_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBeerClaim_vue__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1812)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ed72376"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBeerClaim_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed72376_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBeerClaim_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed72376_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBeerClaim_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultBeerClaim_vue__ = __webpack_require__(172);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa5e34a2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultBeerClaim_vue__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1902)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa5e34a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultBeerClaim_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa5e34a2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultBeerClaim_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa5e34a2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultBeerClaim_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBeerClaim_vue__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3b5a4ba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBeerClaim_vue__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1899)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3b5a4ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBeerClaim_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3b5a4ba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBeerClaim_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3b5a4ba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBeerClaim_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateBorrowProduct_vue__ = __webpack_require__(174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e8e5d2e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateBorrowProduct_vue__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1958)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateBorrowProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e8e5d2e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateBorrowProduct_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e8e5d2e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateBorrowProduct_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetialBorrowProduct_vue__ = __webpack_require__(175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43efba81_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetialBorrowProduct_vue__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1959)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetialBorrowProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43efba81_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetialBorrowProduct_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43efba81_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetialBorrowProduct_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobBorrowProduct_vue__ = __webpack_require__(176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7653d356_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProduct_vue__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1850)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7653d356"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobBorrowProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7653d356_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProduct_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7653d356_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProduct_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobBorrowProductReturn_vue__ = __webpack_require__(177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364d3ede_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProductReturn_vue__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1792)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-364d3ede"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobBorrowProductReturn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364d3ede_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProductReturn_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364d3ede_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProductReturn_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobBorrowProductReturnItemRow_vue__ = __webpack_require__(178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530f4a3f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProductReturnItemRow_vue__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1817)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-530f4a3f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobBorrowProductReturnItemRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530f4a3f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProductReturnItemRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530f4a3f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProductReturnItemRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobBorrowProductRow_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62a47d3a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProductRow_vue__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1831)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62a47d3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobBorrowProductRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62a47d3a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProductRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62a47d3a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobBorrowProductRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageBorrowProducts_vue__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_329946f3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageBorrowProducts_vue__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1787)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-329946f3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageBorrowProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_329946f3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageBorrowProducts_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_329946f3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageBorrowProducts_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PictureModal_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de2c442a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PictureModal_vue__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PictureModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de2c442a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PictureModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de2c442a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PictureModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateBorrowProduct_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9faed540_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateBorrowProduct_vue__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1960)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateBorrowProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9faed540_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateBorrowProduct_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9faed540_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateBorrowProduct_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproveGroupForm_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18ce0fba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveGroupForm_vue__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1759)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18ce0fba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproveGroupForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18ce0fba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveGroupForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18ce0fba_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveGroupForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproveGroupList_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d24cf56_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveGroupList_vue__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1842)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d24cf56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproveGroupList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d24cf56_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveGroupList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d24cf56_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproveGroupList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetJob_vue__ = __webpack_require__(186);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3601c7da_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetJob_vue__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1790)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3601c7da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetJob_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3601c7da_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetJob_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3601c7da_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetJob_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanCreate_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac1b8a84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanCreate_vue__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1951)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac1b8a84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac1b8a84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac1b8a84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanDetail_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ced9fe32_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanDetail_vue__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1952)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ced9fe32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ced9fe32_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ced9fe32_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanGroupApprove_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5fa4a9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanGroupApprove_vue__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanGroupApprove_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5fa4a9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanGroupApprove_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5fa4a9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanGroupApprove_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanJobCreate_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82c7f432_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanJobCreate_vue__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1863)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-82c7f432"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanJobCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82c7f432_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanJobCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82c7f432_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanJobCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanJobList_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77a3b3be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanJobList_vue__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1907)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanJobList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77a3b3be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanJobList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77a3b3be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanJobList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanList_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e641003_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanList_vue__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1908)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e641003_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e641003_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanMonitoring_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_463c4600_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanMonitoring_vue__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1941)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-463c4600"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanMonitoring_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_463c4600_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanMonitoring_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_463c4600_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanMonitoring_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanMonitoringBiSnapData_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4485dcf8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanMonitoringBiSnapData_vue__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanMonitoringBiSnapData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4485dcf8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanMonitoringBiSnapData_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4485dcf8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanMonitoringBiSnapData_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanMonitoringSendApprovalGroup_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea3e589a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanMonitoringSendApprovalGroup_vue__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetPlanMonitoringSendApprovalGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea3e589a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanMonitoringSendApprovalGroup_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea3e589a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetPlanMonitoringSendApprovalGroup_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GLTypeSelect_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7746c0cd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GLTypeSelect_vue__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GLTypeSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7746c0cd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GLTypeSelect_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7746c0cd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GLTypeSelect_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VendorUsageReport_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f667fd82_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VendorUsageReport_vue__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1954)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f667fd82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VendorUsageReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f667fd82_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VendorUsageReport_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f667fd82_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VendorUsageReport_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callback_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_313e11eb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callback_vue__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_313e11eb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callback_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_313e11eb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callback_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentScoreDashboard_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f42fada_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentScoreDashboard_vue__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1949)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f42fada"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentScoreDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f42fada_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentScoreDashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f42fada_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentScoreDashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd9bfa6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd9bfa6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd9bfa6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyRouteView_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea81b89e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyRouteView_vue__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyRouteView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea81b89e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyRouteView_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea81b89e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyRouteView_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unauthorized_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a395632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unauthorized_vue__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unauthorized_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a395632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unauthorized_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a395632_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unauthorized_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobAddSpareProductList_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055ba9d0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAddSpareProductList_vue__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1736)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-055ba9d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobAddSpareProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055ba9d0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAddSpareProductList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055ba9d0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAddSpareProductList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobAddSpareUsedList_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a395578_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAddSpareUsedList_vue__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1760)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a395578"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobAddSpareUsedList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a395578_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAddSpareUsedList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a395578_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAddSpareUsedList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobCNForm_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80901c24_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobCNForm_vue__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1861)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-80901c24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobCNForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80901c24_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobCNForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80901c24_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobCNForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobCNItemRow_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61257f15_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobCNItemRow_vue__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1829)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61257f15"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobCNItemRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61257f15_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobCNItemRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61257f15_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobCNItemRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobForm_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0652c250_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobForm_vue__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1739)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0652c250"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0652c250_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0652c250_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobImportBarcodeForm_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20bdb1d1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobImportBarcodeForm_vue__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1765)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20bdb1d1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobImportBarcodeForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20bdb1d1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobImportBarcodeForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20bdb1d1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobImportBarcodeForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobItemRow_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5166ee6a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobItemRow_vue__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1816)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5166ee6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobItemRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5166ee6a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobItemRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5166ee6a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobItemRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobList_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e6ee0ba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobList_vue__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1961)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e6ee0ba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e6ee0ba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobRefDocumentRow_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78b78254_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRefDocumentRow_vue__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1852)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78b78254"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobRefDocumentRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78b78254_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRefDocumentRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78b78254_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRefDocumentRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobRefInvoiceRow_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e38d345_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRefInvoiceRow_vue__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1799)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e38d345"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobRefInvoiceRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e38d345_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRefInvoiceRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e38d345_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRefInvoiceRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobRefJobRow_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0169d98e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRefJobRow_vue__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1733)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0169d98e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobRefJobRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0169d98e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRefJobRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0169d98e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRefJobRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessoriesDilapidated_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fd0186e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessoriesDilapidated_vue__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessoriesDilapidated_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fd0186e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessoriesDilapidated_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fd0186e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessoriesDilapidated_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessoriesLost_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6458df5a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessoriesLost_vue__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessoriesLost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6458df5a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessoriesLost_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6458df5a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessoriesLost_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DamageMach_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1775da24_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DamageMach_vue__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DamageMach_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1775da24_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DamageMach_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1775da24_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DamageMach_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LostMach_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb26b14_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LostMach_vue__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LostMach_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb26b14_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LostMach_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb26b14_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LostMach_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LostTank_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4cbfec6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LostTank_vue__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LostTank_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4cbfec6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LostTank_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4cbfec6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LostTank_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductCycle_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b44d10e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductCycle_vue__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1909)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductCycle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b44d10e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductCycle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b44d10e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductCycle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDilapidated_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47f1dd48_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDilapidated_vue__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDilapidated_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47f1dd48_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDilapidated_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47f1dd48_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDilapidated_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductExpire_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c296aaa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductExpire_vue__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductExpire_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c296aaa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductExpire_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c296aaa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductExpire_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductItemCalRow_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1242e310_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItemCalRow_vue__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1750)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1242e310"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductItemCalRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1242e310_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItemCalRow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1242e310_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductItemCalRow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductLost_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_522a89e5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLost_vue__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductLost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_522a89e5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLost_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_522a89e5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLost_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSlow_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd6518e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSlow_vue__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSlow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd6518e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSlow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd6518e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSlow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListMachine_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114669b8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListMachine_vue__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1749)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-114669b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListMachine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114669b8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListMachine_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114669b8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListMachine_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMachinePayment_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc5a2b38_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMachinePayment_vue__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1888)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc5a2b38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentMachinePayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc5a2b38_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMachinePayment_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc5a2b38_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMachinePayment_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SaveBillingMachinePayment_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37cd21d5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SaveBillingMachinePayment_vue__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1794)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37cd21d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SaveBillingMachinePayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37cd21d5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SaveBillingMachinePayment_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37cd21d5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SaveBillingMachinePayment_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingApproveDetail_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d7d640_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingApproveDetail_vue__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1805)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44d7d640"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingApproveDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d7d640_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingApproveDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d7d640_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingApproveDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingDetail_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5660c1a9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingDetail_vue__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1821)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5660c1a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5660c1a9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5660c1a9_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingList_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0cd5758_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingList_vue__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1877)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0cd5758"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketingList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0cd5758_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0cd5758_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketingList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentCreate_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_213649d8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentCreate_vue__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1767)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-213649d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_213649d8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_213649d8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentCreateExcel_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a500d3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentCreateExcel_vue__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1758)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18a500d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentCreateExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a500d3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentCreateExcel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a500d3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentCreateExcel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentUpdate_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fdf21ce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUpdate_vue__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1911)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fdf21ce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fdf21ce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b8adcc9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b8adcc9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b8adcc9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62633de0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62633de0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62633de0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMList_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60faa189_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMList_vue__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1828)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60faa189"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60faa189_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60faa189_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproverAgentInfo_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da947c2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverAgentInfo_vue__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproverAgentInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da947c2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverAgentInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da947c2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverAgentInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproverEmployeeInfo_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a42448_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverEmployeeInfo_vue__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproverEmployeeInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a42448_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverEmployeeInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a42448_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverEmployeeInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproverList_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60228680_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverList_vue__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1827)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60228680"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproverList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60228680_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60228680_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproverUserInfo_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_988d125c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverUserInfo_vue__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApproverUserInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_988d125c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverUserInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_988d125c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApproverUserInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateApprover_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05b564a6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateApprover_vue__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1738)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05b564a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateApprover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05b564a6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateApprover_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05b564a6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateApprover_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateApprover_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea106f0c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateApprover_vue__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1896)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea106f0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateApprover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea106f0c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateApprover_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea106f0c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateApprover_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateBarcode_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63f85987_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateBarcode_vue__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1834)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63f85987"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63f85987_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateBarcode_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63f85987_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateBarcode_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailBarcode_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04f60d90_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailBarcode_vue__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04f60d90_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailBarcode_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04f60d90_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailBarcode_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadBarcode_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad3110bc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadBarcode_vue__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1881)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad3110bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad3110bc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadBarcode_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad3110bc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadBarcode_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBarcode_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c61426ee_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBarcode_vue__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1962)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c61426ee_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBarcode_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c61426ee_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBarcode_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportBarcode_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbd28f7a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportBarcode_vue__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1904)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fbd28f7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbd28f7a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportBarcode_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbd28f7a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportBarcode_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageBarcode_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab04fa8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageBarcode_vue__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1797)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ab04fa8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab04fa8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageBarcode_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab04fa8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageBarcode_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TemplateBarcode_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bc848a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TemplateBarcode_vue__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1743)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bc848a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TemplateBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bc848a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TemplateBarcode_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bc848a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TemplateBarcode_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateBarcode_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_371a26c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateBarcode_vue__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1793)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-371a26c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_371a26c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateBarcode_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_371a26c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateBarcode_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandCreate_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d986beb2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandCreate_vue__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d986beb2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d986beb2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandExportModal_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a99004d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandExportModal_vue__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1779)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a99004d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandExportModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a99004d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandExportModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a99004d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandExportModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandList_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ff5a34_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandList_vue__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1808)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48ff5a34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ff5a34_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ff5a34_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandUpdate_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29e5ebba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandUpdate_vue__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29e5ebba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29e5ebba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyProfileCreate_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77fa6799_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfileCreate_vue__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1851)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77fa6799"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyProfileCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77fa6799_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfileCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77fa6799_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfileCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyProfileList_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6988e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfileList_vue__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1809)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b6988e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyProfileList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6988e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfileList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6988e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfileList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyProfileUpdate_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b71eb5e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfileUpdate_vue__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1874)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b71eb5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyProfileUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b71eb5e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfileUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b71eb5e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyProfileUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactCreate_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617aae21_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactCreate_vue__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1830)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-617aae21"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617aae21_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_617aae21_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactList_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2622ddaa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactList_vue__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1774)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2622ddaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2622ddaa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2622ddaa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUpdate_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_140130bc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUpdate_vue__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1753)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-140130bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_140130bc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_140130bc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoldingCreate_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0b42ae6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingCreate_vue__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1876)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0b42ae6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoldingCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0b42ae6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0b42ae6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoldingExportModal_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24dfcb92_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingExportModal_vue__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1769)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24dfcb92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoldingExportModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24dfcb92_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingExportModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24dfcb92_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingExportModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoldingImportModal_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cfa27ae_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingImportModal_vue__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1825)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cfa27ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoldingImportModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cfa27ae_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingImportModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cfa27ae_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingImportModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoldingList_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65c57d99_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingList_vue__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1837)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65c57d99"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoldingList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65c57d99_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65c57d99_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoldingUpdate_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d389ad7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingUpdate_vue__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1857)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d389ad7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HoldingUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d389ad7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d389ad7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HoldingUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadMachineTransaction_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a56f58c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadMachineTransaction_vue__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1796)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a56f58c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadMachineTransaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a56f58c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadMachineTransaction_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a56f58c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadMachineTransaction_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportMachineTransaction_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5589de2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportMachineTransaction_vue__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1882)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5589de2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportMachineTransaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5589de2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportMachineTransaction_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5589de2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportMachineTransaction_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageMachineTransaction_vue__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_065fc45c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageMachineTransaction_vue__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1740)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-065fc45c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageMachineTransaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_065fc45c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageMachineTransaction_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_065fc45c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageMachineTransaction_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterProductUnitPriceCreate_vue__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b2d11e2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterProductUnitPriceCreate_vue__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1912)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterProductUnitPriceCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b2d11e2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterProductUnitPriceCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b2d11e2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterProductUnitPriceCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterProductUnitPriceList_vue__ = __webpack_require__(277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4216b17e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterProductUnitPriceList_vue__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1802)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4216b17e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterProductUnitPriceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4216b17e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterProductUnitPriceList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4216b17e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterProductUnitPriceList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterProductUnitPriceUpdate_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28142292_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterProductUnitPriceUpdate_vue__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1913)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterProductUnitPriceUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28142292_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterProductUnitPriceUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28142292_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterProductUnitPriceUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderCreate_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0535de92_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderCreate_vue__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0535de92_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0535de92_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetail_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eff3bd00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetail_vue__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1964)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eff3bd00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eff3bd00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderList_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86744922_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderList_vue__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1865)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86744922"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86744922_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86744922_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderUpdate_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7944582f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderUpdate_vue__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7944582f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7944582f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverdueSettingCreate_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c9aa6e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueSettingCreate_vue__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1914)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverdueSettingCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c9aa6e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueSettingCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c9aa6e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueSettingCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverdueSettingList_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86592974_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueSettingList_vue__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1864)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86592974"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverdueSettingList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86592974_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueSettingList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86592974_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueSettingList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverdueSettingUpdate_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c445d32_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueSettingUpdate_vue__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1915)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverdueSettingUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c445d32_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueSettingUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c445d32_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueSettingUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadPhase_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_159a569c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadPhase_vue__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1755)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-159a569c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadPhase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_159a569c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadPhase_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_159a569c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadPhase_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportPhase_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91d3e078_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportPhase_vue__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1871)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-91d3e078"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportPhase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91d3e078_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportPhase_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91d3e078_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportPhase_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagePhase_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4740d1a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagePhase_vue__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1807)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4740d1a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManagePhase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4740d1a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagePhase_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4740d1a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManagePhase_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlantCreate_vue__ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308090c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlantCreate_vue__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlantCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308090c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlantCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308090c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlantCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlantList_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e64fee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlantList_vue__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1833)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62e64fee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlantList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e64fee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlantList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e64fee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlantList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlantUpdate_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73f7962d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlantUpdate_vue__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1916)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlantUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73f7962d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlantUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73f7962d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlantUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProduct_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d0bdc0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProduct_vue__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d0bdc0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProduct_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d0bdc0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProduct_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetail_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23c02fa7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetail_vue__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23c02fa7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23c02fa7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26bc5279_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1775)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26bc5279"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26bc5279_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26bc5279_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductUpdate_vue__ = __webpack_require__(296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00fea4a1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductUpdate_vue__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1965)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00fea4a1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00fea4a1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductBrandCreate_vue__ = __webpack_require__(297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388431b9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductBrandCreate_vue__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductBrandCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388431b9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductBrandCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388431b9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductBrandCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductBrandList_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_312c8fc4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductBrandList_vue__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1785)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-312c8fc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductBrandList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_312c8fc4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductBrandList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_312c8fc4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductBrandList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductBrandUpdate_vue__ = __webpack_require__(299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37c12916_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductBrandUpdate_vue__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductBrandUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37c12916_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductBrandUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37c12916_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductBrandUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoleForm_vue__ = __webpack_require__(300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae7990c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoleForm_vue__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1856)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ae7990c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoleForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae7990c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoleForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae7990c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoleForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoleList_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce074f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoleList_vue__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1824)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ce074f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoleList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce074f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoleList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce074f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoleList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesAreaCreate_vue__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8753a386_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesAreaCreate_vue__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1917)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesAreaCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8753a386_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesAreaCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8753a386_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesAreaCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesAreaList_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a3d2f71_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesAreaList_vue__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1841)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a3d2f71"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesAreaList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a3d2f71_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesAreaList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a3d2f71_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesAreaList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesAreaUpdate_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac06da16_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesAreaUpdate_vue__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1918)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesAreaUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac06da16_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesAreaUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac06da16_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesAreaUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageSetting_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_672e95ea_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageSetting_vue__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageSetting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_672e95ea_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageSetting_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_672e95ea_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageSetting_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateShop_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0b43ba2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateShop_vue__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1919)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateShop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0b43ba2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateShop_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0b43ba2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateShop_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditShop_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8badecba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditShop_vue__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1920)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditShop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8badecba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditShop_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8badecba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditShop_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailShopChangeRequest_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8ea3310_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailShopChangeRequest_vue__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1892)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d8ea3310"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailShopChangeRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8ea3310_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailShopChangeRequest_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8ea3310_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailShopChangeRequest_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageShopChangeRequest_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0583b188_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageShopChangeRequest_vue__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1737)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0583b188"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageShopChangeRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0583b188_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageShopChangeRequest_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0583b188_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageShopChangeRequest_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateShopSubAgent_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_965ec6f4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateShopSubAgent_vue__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1921)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateShopSubAgent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_965ec6f4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateShopSubAgent_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_965ec6f4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateShopSubAgent_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditShopSubAgent_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2cc5ea2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditShopSubAgent_vue__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1922)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditShopSubAgent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2cc5ea2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditShopSubAgent_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2cc5ea2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditShopSubAgent_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageShopSubAgent_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04697248_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageShopSubAgent_vue__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1735)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04697248"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageShopSubAgent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04697248_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageShopSubAgent_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04697248_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageShopSubAgent_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupplierUpdate_vue__ = __webpack_require__(315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153ac60a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupplierUpdate_vue__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1923)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupplierUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153ac60a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupplierUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153ac60a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupplierUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTransport_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b03a71a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTransport_vue__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTransport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b03a71a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTransport_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b03a71a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTransport_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditTransport_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219aac06_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditTransport_vue__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditTransport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219aac06_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditTransport_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_219aac06_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditTransport_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageTransport_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f69d9d6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageTransport_vue__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1814)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f69d9d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageTransport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f69d9d6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageTransport_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f69d9d6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageTransport_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentUserCreate_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1296a376_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUserCreate_vue__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1751)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1296a376"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentUserCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1296a376_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUserCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1296a376_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUserCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentUserList_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9ae5258_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUserList_vue__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentUserList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9ae5258_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUserList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9ae5258_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUserList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentUserUpdate_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_259c8133_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUserUpdate_vue__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1772)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-259c8133"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentUserUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_259c8133_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUserUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_259c8133_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentUserUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserChangePassword_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c1969a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserChangePassword_vue__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1768)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21c1969a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c1969a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserChangePassword_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c1969a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserChangePassword_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCreate_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9af5c1f8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCreate_vue__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1924)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9af5c1f8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9af5c1f8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_886f9d50_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserList_vue__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1866)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-886f9d50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_886f9d50_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_886f9d50_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserUpdate_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fd39506_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserUpdate_vue__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1925)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fd39506_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserUpdate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fd39506_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserUpdate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringClearImage_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66045d9c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringClearImage_vue__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1946)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66045d9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringClearImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66045d9c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringClearImage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66045d9c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringClearImage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringHub_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b7a5ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringHub_vue__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1938)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34b7a5ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringHub_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b7a5ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringHub_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b7a5ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringHub_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringScheduledJobs_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b5131b7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringScheduledJobs_vue__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1948)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b5131b7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringScheduledJobs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b5131b7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringScheduledJobs_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b5131b7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringScheduledJobs_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringScvd_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a3b1424_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringScvd_vue__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringScvd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a3b1424_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringScvd_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a3b1424_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringScvd_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringSendEmailReportAgent_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61f44978_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringSendEmailReportAgent_vue__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1945)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61f44978"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonitoringSendEmailReportAgent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61f44978_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringSendEmailReportAgent_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61f44978_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonitoringSendEmailReportAgent_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPMRoutePlan_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac1bb32_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPMRoutePlan_vue__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1867)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ac1bb32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPMRoutePlan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac1bb32_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPMRoutePlan_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac1bb32_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPMRoutePlan_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarcodeMappingDetail_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ddcfb49_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarcodeMappingDetail_vue__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1966)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarcodeMappingDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ddcfb49_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarcodeMappingDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ddcfb49_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarcodeMappingDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPMRoutePlan_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25646d2f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPMRoutePlan_vue__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1771)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25646d2f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPMRoutePlan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25646d2f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPMRoutePlan_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25646d2f_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPMRoutePlan_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MTDetail_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d1e8c4c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MTDetail_vue__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1967)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MTDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d1e8c4c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MTDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d1e8c4c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MTDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMDetail_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4aa29c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMDetail_vue__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1968)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4aa29c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4aa29c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMSurveyBarcodeMappingDetail_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a326f1d8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSurveyBarcodeMappingDetail_vue__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1969)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMSurveyBarcodeMappingDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a326f1d8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSurveyBarcodeMappingDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a326f1d8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSurveyBarcodeMappingDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMSurveyDetail_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d75fc478_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSurveyDetail_vue__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1970)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMSurveyDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d75fc478_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSurveyDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d75fc478_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSurveyDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PictureModal_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a63f78e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PictureModal_vue__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PictureModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a63f78e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PictureModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a63f78e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PictureModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchCheckIn_vue__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_473cbf63_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchCheckIn_vue__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1926)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchCheckIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_473cbf63_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchCheckIn_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_473cbf63_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchCheckIn_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchPMRoutePlan_vue__ = __webpack_require__(343);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3005f5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchPMRoutePlan_vue__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1747)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f3005f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchPMRoutePlan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3005f5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchPMRoutePlan_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f3005f5_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchPMRoutePlan_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchSurveyCheckIn_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_338a21c2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchSurveyCheckIn_vue__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1927)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchSurveyCheckIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_338a21c2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchSurveyCheckIn_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_338a21c2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchSurveyCheckIn_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyPictureModal_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee3ee464_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyPictureModal_vue__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyPictureModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee3ee464_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyPictureModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee3ee464_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyPictureModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockCreate_vue__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c834482_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockCreate_vue__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1745)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c834482"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c834482_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c834482_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockDetail_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80be5af4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockDetail_vue__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1862)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-80be5af4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80be5af4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80be5af4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockGroupPreview_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3d645ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockGroupPreview_vue__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1900)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3d645ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockGroupPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3d645ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockGroupPreview_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3d645ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockGroupPreview_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockGroupResult_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14b1f502_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockGroupResult_vue__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1933)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14b1f502"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockGroupResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14b1f502_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockGroupResult_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14b1f502_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockGroupResult_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockList_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_278ad99e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockList_vue__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1928)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_278ad99e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_278ad99e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockPreview_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec54a0a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockPreview_vue__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1844)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ec54a0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec54a0a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockPreview_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec54a0a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockPreview_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockSignaturePdfPreview_vue__ = __webpack_require__(355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeef6aea_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockSignaturePdfPreview_vue__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1953)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eeef6aea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummaryStockSignaturePdfPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeef6aea_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockSignaturePdfPreview_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeef6aea_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummaryStockSignaturePdfPreview_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckInDetail_vue__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f85ce8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckInDetail_vue__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1971)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckInDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f85ce8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckInDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f85ce8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckInDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckInList_vue__ = __webpack_require__(357);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f43069f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckInList_vue__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1901)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f43069f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckInList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f43069f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckInList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f43069f4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckInList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PictureModal_vue__ = __webpack_require__(358);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ecebec8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PictureModal_vue__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PictureModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ecebec8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PictureModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ecebec8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PictureModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIJobDetail_vue__ = __webpack_require__(359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b3b6e0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobDetail_vue__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1972)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIJobDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b3b6e0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b3b6e0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIJobEditDrawback_vue__ = __webpack_require__(360);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528f8cdb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobEditDrawback_vue__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIJobEditDrawback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528f8cdb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobEditDrawback_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528f8cdb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobEditDrawback_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIJobEditRepair_vue__ = __webpack_require__(361);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89db78ee_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobEditRepair_vue__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIJobEditRepair_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89db78ee_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobEditRepair_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89db78ee_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobEditRepair_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIJobList_vue__ = __webpack_require__(362);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a28b72a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobList_vue__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1879)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a28b72a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIJobList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a28b72a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a28b72a8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIJobList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIRecvBorrow_vue__ = __webpack_require__(363);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_743362b4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIRecvBorrow_vue__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1973)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIRecvBorrow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_743362b4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIRecvBorrow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_743362b4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIRecvBorrow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIRecvDetail_vue__ = __webpack_require__(364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8a47b98_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIRecvDetail_vue__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1974)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIRecvDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8a47b98_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIRecvDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8a47b98_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIRecvDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIRecvList_vue__ = __webpack_require__(365);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0d6dd6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIRecvList_vue__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1878)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0d6dd6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIRecvList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0d6dd6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIRecvList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0d6dd6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIRecvList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIStockList_vue__ = __webpack_require__(366);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5a989a6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIStockList_vue__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1891)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5a989a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIStockList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5a989a6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIStockList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5a989a6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIStockList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportChecker_vue__ = __webpack_require__(367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9da9e26a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportChecker_vue__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1875)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9da9e26a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportChecker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9da9e26a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportChecker_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9da9e26a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportChecker_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportDrawback_vue__ = __webpack_require__(368);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_450e4e34_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportDrawback_vue__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1806)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-450e4e34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportDrawback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_450e4e34_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportDrawback_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_450e4e34_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportDrawback_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportQISummary_vue__ = __webpack_require__(369);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50e5deac_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportQISummary_vue__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1815)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50e5deac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportQISummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50e5deac_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportQISummary_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50e5deac_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportQISummary_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportRepairSum_vue__ = __webpack_require__(370);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_159827c8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportRepairSum_vue__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1754)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-159827c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportRepairSum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_159827c8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportRepairSum_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_159827c8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportRepairSum_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportRepairUsage_vue__ = __webpack_require__(371);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25daaade_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportRepairUsage_vue__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1773)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25daaade"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportRepairUsage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25daaade_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportRepairUsage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25daaade_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportRepairUsage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportSparePartsStock_vue__ = __webpack_require__(372);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66ca1833_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportSparePartsStock_vue__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1838)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66ca1833"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportSparePartsStock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66ca1833_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportSparePartsStock_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66ca1833_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportSparePartsStock_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportSparePartsUsed_vue__ = __webpack_require__(373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1b0f41_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportSparePartsUsed_vue__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1795)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a1b0f41"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportSparePartsUsed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1b0f41_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportSparePartsUsed_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1b0f41_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportSparePartsUsed_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportStockPending_vue__ = __webpack_require__(374);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5553e2d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportStockPending_vue__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1820)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5553e2d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportStockPending_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5553e2d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportStockPending_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5553e2d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportStockPending_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentAssets_vue__ = __webpack_require__(375);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_699227a1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentAssets_vue__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1840)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-699227a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentAssets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_699227a1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentAssets_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_699227a1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentAssets_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentScoreEvaluationReport_vue__ = __webpack_require__(376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6df5a1b0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentScoreEvaluationReport_vue__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1975)
  __webpack_require__(1932)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentScoreEvaluationReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6df5a1b0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentScoreEvaluationReport_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6df5a1b0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentScoreEvaluationReport_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentStockOverdue_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1f15f8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentStockOverdue_vue__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1976)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgentStockOverdue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1f15f8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentStockOverdue_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1f15f8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgentStockOverdue_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AmountBeerClaim_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bccf216_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AmountBeerClaim_vue__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1869)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8bccf216"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AmountBeerClaim_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bccf216_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AmountBeerClaim_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bccf216_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AmountBeerClaim_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetProducts_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa30bc0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetProducts_vue__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1846)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fa30bc0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssetProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa30bc0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetProducts_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa30bc0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssetProducts_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AverageBarcode_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78de7d62_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AverageBarcode_vue__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1853)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78de7d62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AverageBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78de7d62_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AverageBarcode_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78de7d62_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AverageBarcode_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarButlerByBrand_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d15b565_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarButlerByBrand_vue__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1811)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d15b565"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarButlerByBrand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d15b565_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarButlerByBrand_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d15b565_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarButlerByBrand_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarcodeMappingReport_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c33a0ee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarcodeMappingReport_vue__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1782)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c33a0ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarcodeMappingReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c33a0ee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarcodeMappingReport_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c33a0ee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarcodeMappingReport_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarcodeStatus_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbbda580_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarcodeStatus_vue__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1903)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fbbda580"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarcodeStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbbda580_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarcodeStatus_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbbda580_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarcodeStatus_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Barcodes_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dde2fd7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Barcodes_vue__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1843)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dde2fd7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Barcodes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dde2fd7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Barcodes_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dde2fd7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Barcodes_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Borrow_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d47cda1e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Borrow_vue__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1889)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d47cda1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Borrow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d47cda1e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Borrow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d47cda1e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Borrow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandCount_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b3a51d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandCount_vue__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1868)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b3a51d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandCount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b3a51d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandCount_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b3a51d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandCount_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandCountBarcodeModal_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e433885e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandCountBarcodeModal_vue__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1894)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e433885e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandCountBarcodeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e433885e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandCountBarcodeModal_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e433885e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrandCountBarcodeModal_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CostBeerClaim_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348f1560_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CostBeerClaim_vue__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1789)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-348f1560"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CostBeerClaim_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348f1560_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CostBeerClaim_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348f1560_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CostBeerClaim_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluateView5S_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6e018c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluateView5S_vue__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1883)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6e018c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EvaluateView5S_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6e018c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluateView5S_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6e018c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EvaluateView5S_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventAndFood_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee6be85_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventAndFood_vue__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1764)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ee6be85"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventAndFood_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee6be85_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventAndFood_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee6be85_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventAndFood_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FixedProducts_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e738e70_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FixedProducts_vue__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1763)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e738e70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FixedProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e738e70_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FixedProducts_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e738e70_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FixedProducts_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoice_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7046a085_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoice_vue__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1848)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7046a085"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7046a085_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoice_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7046a085_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoice_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobAgentAuditStock_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcb560fa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAgentAuditStock_vue__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1977)
  __webpack_require__(1893)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dcb560fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobAgentAuditStock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcb560fa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAgentAuditStock_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcb560fa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAgentAuditStock_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobAgentScore_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_941dcc0c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAgentScore_vue__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1872)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-941dcc0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobAgentScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_941dcc0c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAgentScore_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_941dcc0c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobAgentScore_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobRetrieve_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64f05fdc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRetrieve_vue__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1836)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64f05fdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobRetrieve_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64f05fdc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRetrieve_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64f05fdc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobRetrieve_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KegRotationScore_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376b7de0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KegRotationScore_vue__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1978)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KegRotationScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376b7de0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KegRotationScore_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376b7de0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KegRotationScore_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KegRotationScoreAgent_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2f8fcc2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KegRotationScoreAgent_vue__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1979)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KegRotationScoreAgent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2f8fcc2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KegRotationScoreAgent_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2f8fcc2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KegRotationScoreAgent_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaseMachine_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d6dce18_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaseMachine_vue__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1858)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d6dce18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeaseMachine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d6dce18_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaseMachine_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d6dce18_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeaseMachine_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MTMonthly_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20eb5322_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MTMonthly_vue__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1766)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20eb5322"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MTMonthly_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20eb5322_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MTMonthly_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20eb5322_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MTMonthly_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MachineDetail_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741c1db8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MachineDetail_vue__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1849)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-741c1db8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MachineDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741c1db8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MachineDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741c1db8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MachineDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterShopOnOff_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f139e3e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterShopOnOff_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1800)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f139e3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterShopOnOff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f139e3e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterShopOnOff_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f139e3e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterShopOnOff_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Movement_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f36d560_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Movement_vue__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1826)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f36d560"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Movement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f36d560_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Movement_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f36d560_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Movement_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewShopOnOffPremise_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29bf4e6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewShopOnOffPremise_vue__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1777)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29bf4e6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewShopOnOffPremise_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29bf4e6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewShopOnOffPremise_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29bf4e6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewShopOnOffPremise_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationKPI_vue__ = __webpack_require__(404);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7044ed02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationKPI_vue__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1847)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7044ed02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationKPI_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7044ed02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationKPI_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7044ed02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationKPI_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PM_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c507b96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PM_vue__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1798)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c507b96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PM_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c507b96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PM_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c507b96_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PM_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMAlertSummary_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31399710_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMAlertSummary_vue__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1786)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31399710"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMAlertSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31399710_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMAlertSummary_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31399710_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMAlertSummary_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMMonthly_vue__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd1bd60_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMMonthly_vue__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1746)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0dd1bd60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMMonthly_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd1bd60_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMMonthly_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd1bd60_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMMonthly_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMOperationReport_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d50a3d24_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMOperationReport_vue__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1890)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d50a3d24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMOperationReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d50a3d24_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMOperationReport_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d50a3d24_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMOperationReport_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMRoutePlan_vue__ = __webpack_require__(409);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c50ddc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMRoutePlan_vue__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1752)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13c50ddc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMRoutePlan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c50ddc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMRoutePlan_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c50ddc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMRoutePlan_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMSpare_vue__ = __webpack_require__(410);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56d5d402_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSpare_vue__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1822)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56d5d402"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMSpare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56d5d402_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSpare_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56d5d402_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSpare_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMSurvey_vue__ = __webpack_require__(411);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd94c656_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSurvey_vue__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1885)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd94c656"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PMSurvey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd94c656_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSurvey_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd94c656_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PMSurvey_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentProduct_vue__ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e71eca6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentProduct_vue__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1895)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e71eca6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e71eca6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentProduct_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e71eca6e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentProduct_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProduceProducts_vue__ = __webpack_require__(413);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0805f1dd_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProduceProducts_vue__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1741)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0805f1dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProduceProducts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0805f1dd_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProduceProducts_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0805f1dd_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProduceProducts_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductStocks_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3c2fe0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductStocks_vue__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1781)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b3c2fe0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductStocks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3c2fe0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductStocks_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b3c2fe0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductStocks_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIGroupByAgent_vue__ = __webpack_require__(415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_176f22ef_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIGroupByAgent_vue__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1757)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-176f22ef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIGroupByAgent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_176f22ef_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIGroupByAgent_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_176f22ef_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIGroupByAgent_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIGroupByOfficer_vue__ = __webpack_require__(416);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c742f556_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIGroupByOfficer_vue__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1887)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c742f556"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QIGroupByOfficer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c742f556_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIGroupByOfficer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c742f556_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QIGroupByOfficer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnProduct_vue__ = __webpack_require__(417);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26cdf922_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnProduct_vue__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1776)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26cdf922"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReturnProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26cdf922_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnProduct_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26cdf922_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReturnProduct_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShopAssets_vue__ = __webpack_require__(418);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1ec8cb_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShopAssets_vue__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1744)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c1ec8cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShopAssets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1ec8cb_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShopAssets_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1ec8cb_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShopAssets_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusBeerClaimMonthly_vue__ = __webpack_require__(419);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d06456c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusBeerClaimMonthly_vue__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1810)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d06456c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusBeerClaimMonthly_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d06456c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusBeerClaimMonthly_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d06456c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusBeerClaimMonthly_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockBarcodeSnapshot_vue__ = __webpack_require__(420);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130d82d0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockBarcodeSnapshot_vue__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockBarcodeSnapshot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130d82d0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockBarcodeSnapshot_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130d82d0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockBarcodeSnapshot_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyOnOffPremise_vue__ = __webpack_require__(421);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53fea44d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyOnOffPremise_vue__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1819)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53fea44d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyOnOffPremise_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53fea44d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyOnOffPremise_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53fea44d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyOnOffPremise_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionView5S_vue__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f323164_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionView5S_vue__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1801)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f323164"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionView5S_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f323164_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionView5S_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f323164_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionView5S_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferBarcode_vue__ = __webpack_require__(423);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e788fc4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcode_vue__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1783)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e788fc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e788fc4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcode_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e788fc4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcode_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferBarcodeMultiple_vue__ = __webpack_require__(424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e4dd84a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcodeMultiple_vue__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1762)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e4dd84a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferBarcodeMultiple_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e4dd84a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcodeMultiple_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e4dd84a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcodeMultiple_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferBarcodeSubAgent_vue__ = __webpack_require__(425);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b310da_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcodeSubAgent_vue__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1832)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62b310da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferBarcodeSubAgent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b310da_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcodeSubAgent_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b310da_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcodeSubAgent_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferBarcodeSupplier_vue__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43415211_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcodeSupplier_vue__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1803)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43415211"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferBarcodeSupplier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43415211_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcodeSupplier_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43415211_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferBarcodeSupplier_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WarehouseScore_vue__ = __webpack_require__(427);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4b17a28_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WarehouseScore_vue__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1929)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WarehouseScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4b17a28_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WarehouseScore_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4b17a28_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WarehouseScore_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BeforeDue_vue__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae5df6a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BeforeDue_vue__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1855)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ae5df6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BeforeDue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae5df6a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BeforeDue_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae5df6a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BeforeDue_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverdueAll_vue__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f332628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueAll_vue__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1813)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f332628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OverdueAll_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f332628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueAll_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f332628_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OverdueAll_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysCreate_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f9bb3dc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysCreate_vue__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1936)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f9bb3dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f9bb3dc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysCreate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f9bb3dc_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysCreate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysDashboard_vue__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bd97ad2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysDashboard_vue__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1942)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bd97ad2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bd97ad2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysDashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bd97ad2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysDashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysDetail_vue__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f5f4284_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysDetail_vue__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1939)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f5f4284"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f5f4284_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f5f4284_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysList_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5d61816_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysList_vue__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1930)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5d61816_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5d61816_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysReport_vue__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449a8e25_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysReport_vue__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1940)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-449a8e25"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449a8e25_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysReport_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449a8e25_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysReport_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysReportAnalysis_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a063a94_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysReportAnalysis_vue__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1944)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a063a94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockCoverDaysReportAnalysis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a063a94_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysReportAnalysis_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a063a94_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockCoverDaysReportAnalysis_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WriteOffStockJobForm_vue__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ab4fa4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WriteOffStockJobForm_vue__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1935)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ab4fa4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WriteOffStockJobForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ab4fa4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WriteOffStockJobForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ab4fa4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WriteOffStockJobForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__(441);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__(442);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__(443);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1980)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__(444);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(0);
function injectStyle (context) {
  __webpack_require__(1981)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสสินค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.PruMaterialCode))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PruProductDesc_th2),expression:"PruProductDesc_th2"}],staticClass:"form-control",attrs:{"type":"text","id":"PruProductDesc_th2","name":"PruProductDesc_th2"},domProps:{"value":(_vm.PruProductDesc_th2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.PruProductDesc_th2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('select2',{ref:"PruProductBrandIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'PruProductBrandId',"name":'PruProductBrandId',"select2-options":_vm.PruProductBrandIdOptions},model:{value:(_vm.PruProductBrandId),callback:function ($$v) {_vm.PruProductBrandId=$$v},expression:"PruProductBrandId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("หมวดหมู่:")]),_vm._v(" "),_c('select2',{ref:"PruProductGroupIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'PruProductGroupId',"name":'PruProductGroupId',"select2-options":_vm.PruProductGroupIdOptions},on:{"selectChange":_vm.PruProductGroupChange},model:{value:(_vm.PruProductGroupId),callback:function ($$v) {_vm.PruProductGroupId=$$v},expression:"PruProductGroupId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('select2',{ref:"PruProductTypeIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'PruProductTypeId',"name":'PruProductTypeId',"select2-options":_vm.PruProductTypeIdOptions},model:{value:(_vm.PruProductTypeId),callback:function ($$v) {_vm.PruProductTypeId=$$v},expression:"PruProductTypeId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("หน่วยนับ:")]),_vm._v(" "),_c('select2',{ref:"PruUnitIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'PruUnitId',"name":'PruUnitId',"select2-options":_vm.PruUnitIdOptions},model:{value:(_vm.PruUnitId),callback:function ($$v) {_vm.PruUnitId=$$v},expression:"PruUnitId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ราคากลาง:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 col-sm-8"},[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: _vm.locale, currency: _vm.currency }),expression:"{ locale, currency }"}],staticClass:"form-control",attrs:{"id":"PruInitialPrice","name":"PruInitialPrice","auto-decimal-mode:true":"","placeholder":"ราคากลาง"},model:{value:(_vm.PruInitialPrice),callback:function ($$v) {_vm.PruInitialPrice=$$v},expression:"PruInitialPrice"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block col-xl-2",attrs:{"type":"button","id":"btnUsePruAvgPrice"},on:{"click":_vm.onUsePruAvgPriceClick}},[_vm._v("\n                    ใช้ราคาเฉลี่ย\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ราคาเฉลี่ย:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm._f("currency")(_vm.PruAvgPrice,"฿", 2)))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(
                _vm.PruMaterialType == '3' ||
                  _vm.PruMaterialType == '6' ||
                  _vm.PruMaterialType == '27'
              )?_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หัวจ่าย:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PruIsBarButler),expression:"PruIsBarButler"}],staticClass:"form-check-input",attrs:{"id":"PruIsBarButler","name":"PruIsBarButler","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.PruIsBarButler)?_vm._i(_vm.PruIsBarButler,null)>-1:(_vm.PruIsBarButler)},on:{"change":function($event){var $$a=_vm.PruIsBarButler,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.PruIsBarButler=$$a.concat([$$v]))}else{$$i>-1&&(_vm.PruIsBarButler=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.PruIsBarButler=$$c}}}}),_vm._v("\n                    มีหัวจ่ายในตัว\n                    "),_c('span')])])])]):_vm._e(),_vm._v(" "),(
                (_vm.PruMaterialType == '3' && _vm.PruIsBarButler == true) ||
                  _vm.PruMaterialType == '6' ||
                  (_vm.PruMaterialType == '27' && _vm.PruIsBarButler == true)
              )?_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จำนวนหัวจ่าย:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PruBarButlerQty),expression:"PruBarButlerQty"}],staticClass:"form-control",attrs:{"type":"number","id":"PruBarButlerQty","name":"PruBarButlerQty","min":"0","max":"10000"},domProps:{"value":(_vm.PruBarButlerQty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.PruBarButlerQty=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสบาร์โค้ด:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PruHasBarcode),expression:"PruHasBarcode"}],staticClass:"form-check-input",attrs:{"id":"PruHasBarcode","name":"PruHasBarcode","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.PruHasBarcode)?_vm._i(_vm.PruHasBarcode,null)>-1:(_vm.PruHasBarcode)},on:{"change":function($event){var $$a=_vm.PruHasBarcode,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.PruHasBarcode=$$a.concat([$$v]))}else{$$i>-1&&(_vm.PruHasBarcode=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.PruHasBarcode=$$c}}}}),_vm._v("\n                    มีข้อมูล BARCODE\n                    "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้าสำหรับใบHold(รับคืน):")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PruIsForJobHold),expression:"PruIsForJobHold"}],staticClass:"form-check-input",attrs:{"id":"PruIsForJobHold","name":"PruIsForJobHold","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.PruIsForJobHold)?_vm._i(_vm.PruIsForJobHold,null)>-1:(_vm.PruIsForJobHold)},on:{"change":function($event){var $$a=_vm.PruIsForJobHold,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.PruIsForJobHold=$$a.concat([$$v]))}else{$$i>-1&&(_vm.PruIsForJobHold=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.PruIsForJobHold=$$c}}}}),_vm._v("\n                    เปิดใช้งาน\n                    "),_c('span')])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ใช้งาน Stock Cover Days:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PruUseStockCoverDays),expression:"PruUseStockCoverDays"}],staticClass:"form-check-input",attrs:{"id":"PruUseStockCoverDays","name":"PruUseStockCoverDays","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.PruUseStockCoverDays)?_vm._i(_vm.PruUseStockCoverDays,null)>-1:(_vm.PruUseStockCoverDays)},on:{"change":function($event){var $$a=_vm.PruUseStockCoverDays,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.PruUseStockCoverDays=$$a.concat([$$v]))}else{$$i>-1&&(_vm.PruUseStockCoverDays=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.PruUseStockCoverDays=$$c}}}}),_vm._v("\n                    เปิดใช้งาน\n                    "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทอะไหล่งาน PM:")]),_vm._v(" "),_c('select2',{ref:"PruPMSpareSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'PruPMSpare',"name":'PruPMSpare',"select2-options":_vm.PruPMSpareOptions},model:{value:(_vm.PruPMSpare),callback:function ($$v) {_vm.PruPMSpare=$$v},expression:"PruPMSpare"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตั้งค่าสินค้าสำหรับใช้งานช่างซ่อมบำรุง:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isSpareOrMachine),expression:"isSpareOrMachine"}],staticClass:"form-check-input",attrs:{"id":"isSpareOrMachine","name":"isSpareOrMachine","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isSpareOrMachine)?_vm._i(_vm.isSpareOrMachine,null)>-1:(_vm.isSpareOrMachine)},on:{"change":[function($event){var $$a=_vm.isSpareOrMachine,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isSpareOrMachine=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isSpareOrMachine=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isSpareOrMachine=$$c}},_vm.onSpareOrMachineChange]}}),_vm._v("\n                          ประเภทเครื่องเบียร์สด/อุปกรณ์ ใช้สำหรับใบงานประเมินสภาพและใบงานซ่อมอุปกรณ์เบียร์สด\n                          "),_c('span')]),_vm._v(" "),_c('label',{staticClass:"text-danger",staticStyle:{"margin-left":"28px"}},[_vm._v("\n                          *การเลือกประเภทมีผลต่อการแสดงแบบฟอร์มในใบงาน\n                      ")]),_vm._v(" "),_c('select2',{ref:"QiSubProductTypeSelect2",staticClass:"form-control m-select2 QiSubProductTypeSelect",attrs:{"id":"QiSubProductType","name":"QiSubProductType","select2-options":_vm.QiSubProductTypeOptions},on:{"selectChange":function($event){return _vm.onSubProductTypeChange(_vm.QiSubProductType)}},model:{value:(_vm.QiSubProductType),callback:function ($$v) {_vm.QiSubProductType=$$v},expression:"QiSubProductType"}})],1),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.IsQiSpare),expression:"IsQiSpare"}],staticClass:"form-check-input",attrs:{"id":"IsQiSpare","name":"IsQiSpare","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.IsQiSpare)?_vm._i(_vm.IsQiSpare,null)>-1:(_vm.IsQiSpare)},on:{"change":function($event){var $$a=_vm.IsQiSpare,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.IsQiSpare=$$a.concat([$$v]))}else{$$i>-1&&(_vm.IsQiSpare=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.IsQiSpare=$$c}}}}),_vm._v("\n                          อะไหล่ช่างซ่อมบำรุง\n                          "),_c('span')])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.IsSupplierSpare),expression:"IsSupplierSpare"}],staticClass:"form-check-input",attrs:{"id":"IsSupplierSpare","name":"IsSupplierSpare","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.IsSupplierSpare)?_vm._i(_vm.IsSupplierSpare,null)>-1:(_vm.IsSupplierSpare)},on:{"change":function($event){var $$a=_vm.IsSupplierSpare,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.IsSupplierSpare=$$a.concat([$$v]))}else{$$i>-1&&(_vm.IsSupplierSpare=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.IsSupplierSpare=$$c}}}}),_vm._v("\n                          อะไหล่ซัพพลายเออร์\n                          "),_c('span')])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button"},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("รูป\n                ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-img"}},_vm._l((_vm.FileUpload),function(image){return (image.isLoaded)?_c('div',{key:image.pictureId,staticClass:"col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap",attrs:{"id":image.pictureId}},[_c('img',{staticClass:"img-plant -avatar js-avatar-me img-thumbnail card-img-top",attrs:{"src":image.urlImg},on:{"error":function($event){return _vm.handleImageError(image)},"load":function($event){return _vm.handleImageLoad(image)}}}),_vm._v(" "),_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","top":"10px","right":"20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeImage(image.pictureId)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})])]):_vm._e()}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PruInActiveStatus),expression:"PruInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"PruInActiveStatus","name":"PruInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.PruInActiveStatus)?_vm._i(_vm.PruInActiveStatus,null)>-1:(_vm.PruInActiveStatus)},on:{"change":function($event){var $$a=_vm.PruInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.PruInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.PruInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.PruInActiveStatus=$$c}}}}),_vm._v("\n                    เปิดใช้งาน\n                    "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("รูปภาพ:"),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                    (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน\n                    10Mb.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])}]


/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/AdminReport/JobIssue'),expression:"$route.path == '/AdminReport/JobIssue'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJIAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadreJIAgentCodesOptions},model:{value:(_vm.reJIAgentCodes),callback:function ($$v) {_vm.reJIAgentCodes=$$v},expression:"reJIAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJIDepartmentsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJIDepartments),callback:function ($$v) {_vm.reJIDepartments=$$v},expression:"reJIDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJIStatusOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJIStatus),callback:function ($$v) {_vm.reJIStatus=$$v},expression:"reJIStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันทีเปิดใบงาน(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reJIDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reJIDateStart","name":"reJIDateStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันทีเปิดใบงาน(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reJIDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reJIDateEnd","name":"reJIDateEnd"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้แจ้งปัญหา:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJICreatedUserOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJICreatedUser),callback:function ($$v) {_vm.reJICreatedUser=$$v},expression:"reJICreatedUser"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ปิดใบงาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJICloseUserOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJICloseUser),callback:function ($$v) {_vm.reJICloseUser=$$v},expression:"reJICloseUser"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportMasterShop}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"JobIssueTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"20"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่ใบแจ้งปัญหา")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รายละเอียดปัญหา")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะของใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้แจ้งปัญหา")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้ปิดใบงาน")])])}]


/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[(_vm.showHeader)?_c('td',{staticClass:"text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"form-group text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_vm._v("\n    "+_vm._s(_vm.item.jobNumber)+"\n    "),_c('br'),_vm._v("\n    "+_vm._s(_vm.item.jobTypeName)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"form-group text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_vm._v(_vm._s(_vm.item.jobDate))]):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"form-group text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_vm._v(_vm._s(_vm.item.originLocationName))]):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"form-group text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_vm._v(_vm._s(_vm.item.destinationLocationName))]):_vm._e(),_vm._v(" "),(_vm.item.items.length > 0)?[_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(_vm.item.items[_vm.itemIndex].materialCode)+" "+_vm._s(_vm.item.items[_vm.itemIndex].materialName))]),_vm._v(" "),_c('td',{staticClass:"text-right align-middle"},[_vm._v(_vm._s(_vm.item.items[_vm.itemIndex].checkedQuantity)+"/"+_vm._s(_vm.item.items[_vm.itemIndex].quantity))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(_vm.item.items[_vm.itemIndex].baseUnit))])]:[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])],_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}}):_vm._e()],2)}
var staticRenderFns = []


/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"addClaimItemModal","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{ref:"formItem",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'),expression:"this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"}]},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                    รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ:\n                  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชนิดเครื่อง:")]),_vm._v(" "),_c('select2',{ref:"bciMachineTypeCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"bciMachineTypeCode","name":"bciMachineTypeCode","select2-options":_vm.bciMachineTypeCodeOptions},on:{"selectChange":_vm.onMachineTypeCodeChange},model:{value:(_vm.bciMachineTypeCode),callback:function ($$v) {_vm.bciMachineTypeCode=$$v},expression:"bciMachineTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("BARCODE (เครื่องเบียร์สด):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciMachineBarcode),expression:"bciMachineBarcode"}],staticClass:"form-control",attrs:{"id":"bciMachineBarcode","name":"bciMachineBarcode","type":"text","maxlength":"50","placeholder":"BARCODE (เครื่องเบียร์สด)","disabled":_vm.IsDisabledMachineBarcode},domProps:{"value":(_vm.bciMachineBarcode)},on:{"blur":function($event){return _vm.onBlurBarcode(true)},"input":function($event){if($event.target.composing){ return; }_vm.bciMachineBarcode=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทเครื่องเบียร์สด:")]),_vm._v(" "),_c('select2',{ref:"bciMachineCategorySelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"bciMachineCategory","name":"bciMachineCategory","select2-options":_vm.bciMachineCategoryOptions,"disabled":_vm.IsDisabled},model:{value:(_vm.bciMachineCategory),callback:function ($$v) {_vm.bciMachineCategory=$$v},expression:"bciMachineCategory"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ปริมาณแรงดัน Co2 (PSI./BAR):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciPressure),expression:"bciPressure"}],staticClass:"form-control",attrs:{"id":"bciPressure","name":"bciPressure","type":"number","min":"0","placeholder":"ปริมาณแรงดัน Co2"},domProps:{"value":(_vm.bciPressure)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciPressure=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อุณหภูมิน้ำในเครื่อง (องศาเซลเซียส):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciTemperature),expression:"bciTemperature"}],staticClass:"form-control",attrs:{"id":"bciTemperature","name":"bciTemperature","type":"number","min":"0","placeholder":"อุณหภูมิน้ำในเครื่อง"},domProps:{"value":(_vm.bciTemperature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciTemperature=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันล้างเครื่องล่าสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bciPMDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bciPMDate","name":"bciPMDate","disabled":_vm.IsDisabledDate}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่จัมพ์ถัง:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bciJumpDate",staticClass:"form-control",attrs:{"readonly":"","disabled":_vm.isEdit,"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bciJumpDate","name":"bciJumpDate"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'),expression:"this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"}]},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                    รายละเอียด การใช้งาน และการบำรุงรักษา:\n                  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("มาตรฐานติดตั้ง:")]),_vm._v(" "),_c('select2',{ref:"bciStandardInstallCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"bciStandardInstallCode","name":"bciStandardInstallCode","select2-options":_vm.bciStandardInstallCodeOptions},on:{"selectChange":_vm.onStandardInstallCodeChange},model:{value:(_vm.bciStandardInstallCode),callback:function ($$v) {_vm.bciStandardInstallCode=$$v},expression:"bciStandardInstallCode"}})],1)])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                    รายละเอียด สินค้าเบียร์สด:\n                  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciProductBrand),expression:"bciProductBrand"}],staticClass:"form-control",attrs:{"id":"bciProductBrand","name":"bciProductBrand","type":"text","maxlength":"450","placeholder":"แบรนด์สินค้า","disabled":""},domProps:{"value":(_vm.bciProductBrand)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciProductBrand=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('select2',{ref:"bciMaterialCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"bciMaterialCode","name":"bciMaterialCode","select2-options":_vm.bciMaterialCodeOptions},on:{"selectChange":_vm.onMaterialCodeChange},model:{value:(_vm.bciMaterialCode),callback:function ($$v) {_vm.bciMaterialCode=$$v},expression:"bciMaterialCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("BARCODE (ถัง):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciBarcode),expression:"bciBarcode"}],staticClass:"form-control",attrs:{"id":"bciBarcode","name":"bciBarcode","type":"text","maxlength":"50","placeholder":"BARCODE (ถัง)","disabled":_vm.IsDisabledBarcode},domProps:{"value":(_vm.bciBarcode)},on:{"blur":function($event){return _vm.onBlurBarcode(false)},"input":function($event){if($event.target.composing){ return; }_vm.bciBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันผลิตข้างถัง:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bciManufacturingDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bciManufacturingDate","name":"bciManufacturingDate","disabled":_vm.IsDisabledDate}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("น้ำหนักรวมถัง (กิโลกรัม):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciWeight),expression:"bciWeight"}],staticClass:"form-control",attrs:{"id":"bciWeight","name":"bciWeight","type":"number","min":"0","placeholder":"น้ำหนักรวมถัง"},domProps:{"value":(_vm.bciWeight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciWeight=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เลขที่ Invoice :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciInvoice),expression:"bciInvoice"}],staticClass:"form-control",attrs:{"id":"bciInvoice","name":"bciInvoice","type":"text","maxlength":"450","placeholder":"เลขที่ Invoice"},domProps:{"value":(_vm.bciInvoice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciInvoice=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่สินค้าเข้าตัวแทนจำหน่าย:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bciAgentReceivedDate",staticClass:"form-control",attrs:{"readonly":"","disabled":_vm.isEdit,"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bciAgentReceivedDate","name":"bciAgentReceivedDate"}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                          this.$parent.abcClaimTypeCode ==
                            'BEER_CLAIM_TYPE_SHOP'
                        ),expression:"\n                          this.$parent.abcClaimTypeCode ==\n                            'BEER_CLAIM_TYPE_SHOP'\n                        "}],staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่สินค้าเข้าร้านค้า:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bciShopReceivedDate",staticClass:"form-control",attrs:{"readonly":"","disabled":_vm.isEdit,"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bciShopReceivedDate","name":"bciShopReceivedDate"}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายละเอียด ปัญหาที่พบ:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ปัญหาที่พบ:")]),_vm._v(" "),_c('select2',{ref:"bciProblemTypeCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"bciProblemTypeCode","name":"bciProblemTypeCode","select2-options":_vm.bciProblemTypeCodeOptions,"disabled":_vm.IsDisabledProblemTypeCode},on:{"selectChange":_vm.onProblemTypeCodeChange},model:{value:(_vm.bciProblemTypeCode),callback:function ($$v) {_vm.bciProblemTypeCode=$$v},expression:"bciProblemTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลรูปภาพ:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"p-1 d-flex flex-column justify-content-center align-items-center border-dashed"},[_c('input',{ref:"fileInput1",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/x-png,image/jpeg"},on:{"change":function($event){return _vm.handleFileUpload($event, 0)}}}),_vm._v(" "),(_vm.uploadFiles[0])?_c('img',{staticStyle:{"object-fit":"contain","width":"100%","height":"100%"},attrs:{"src":_vm.uploadFiles[0].fileURL},on:{"click":function($event){return _vm.showModal(_vm.uploadFiles[0].fileURL)}}}):_vm._e(),_vm._v(" "),(_vm.uploadFiles[0])?_c('button',{staticClass:"btn btn-danger btn-circle btn-icon",staticStyle:{"position":"absolute","transform":"translate(220%, -170%)"},attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteImage(0)}}},[_c('i',{staticClass:"fas fa-trash"})]):_c('button',{staticClass:"btn btn-primary btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.fileInput1.click()}}},[_c('i',{staticClass:"fas fa-plus"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"p-1 d-flex flex-column justify-content-center align-items-center border-dashed"},[_c('input',{ref:"fileInput1",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/x-png,image/jpeg"},on:{"change":function($event){return _vm.handleFileUpload($event, 1)}}}),_vm._v(" "),(_vm.uploadFiles[1])?_c('img',{staticStyle:{"object-fit":"contain","width":"100%","height":"100%"},attrs:{"src":_vm.uploadFiles[1].fileURL},on:{"click":function($event){return _vm.showModal(_vm.uploadFiles[1].fileURL)}}}):_vm._e(),_vm._v(" "),(_vm.uploadFiles[1])?_c('button',{staticClass:"btn btn-danger btn-circle btn-icon",staticStyle:{"position":"absolute","transform":"translate(220%, -170%)"},attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteImage(1)}}},[_c('i',{staticClass:"fas fa-trash"})]):_c('button',{staticClass:"btn btn-primary btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.fileInput1.click()}}},[_c('i',{staticClass:"fas fa-plus"})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"imageModal","tabindex":"-1","role":"dialog","aria-labelledby":"imageModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("รูปภาพ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticStyle:{"max-width":"90%","max-height":"90%","margin":"0 auto","display":"block"},attrs:{"src":_vm.modalImageURL}}),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_vm._m(5)])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รายละเอียดของปัญหา:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciProblemDesc),expression:"bciProblemDesc"}],staticClass:"form-control",attrs:{"placeholder":"รายละเอียดของปัญหา","id":"bciProblemDesc","name":"bciProblemDesc","rows":"5"},domProps:{"value":(_vm.bciProblemDesc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciProblemDesc=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])])])])]),_vm._v(" "),_vm._m(6)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"modal-title"},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n            ")])])}]


/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('select2',{ref:"odMaterialCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"odMaterialCode","name":"odMaterialCode","select2-options":_vm.odMaterialCodeOptions},on:{"selectChange":_vm.onMaterialCodeChange},model:{value:(_vm.odMaterialCode),callback:function ($$v) {_vm.odMaterialCode=$$v},expression:"odMaterialCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทของการกระจายสินค้า:")]),_vm._v(" "),_c('select2',{ref:"odTranTypeCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"odTranTypeCode","name":"odTranTypeCode","select2-options":_vm.odTranTypeCodeOptions},on:{"selectChange":_vm.odTranTypeCodeChange},model:{value:(_vm.odTranTypeCode),callback:function ($$v) {_vm.odTranTypeCode=$$v},expression:"odTranTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("จำนวนวันแจ้งเตือนก่อนครบกำหนด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odDayBeforeAlert),expression:"odDayBeforeAlert"}],staticClass:"form-control",attrs:{"id":"odDayBeforeAlert","name":"odDayBeforeAlert","type":"number","min":"0","placeholder":"จำนวนวัน"},domProps:{"value":(_vm.odDayBeforeAlert)},on:{"input":function($event){if($event.target.composing){ return; }_vm.odDayBeforeAlert=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("จำนวนวันครบกำหนด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odDayAlert),expression:"odDayAlert"}],staticClass:"form-control",attrs:{"id":"odDayAlert","name":"odDayAlert","type":"number","min":"0","placeholder":"จำนวนวัน"},domProps:{"value":(_vm.odDayAlert)},on:{"input":function($event){if($event.target.composing){ return; }_vm.odDayAlert=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่มีผล:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"odEffectiveDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"odEffectiveDate","name":"odEffectiveDate"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จำนวนเงินค่าเช่า กรณีเกินกำหนด (วันละ):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odRentalPrice),expression:"odRentalPrice"}],staticClass:"form-control",attrs:{"id":"odRentalPrice","name":"odRentalPrice","type":"number","min":"0.00","placeholder":"จำนวนเงินค่าเช่า(บาท)"},domProps:{"value":(_vm.odRentalPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.odRentalPrice=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odInActiveStatus),expression:"odInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"odInActiveStatus","name":"odInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.odInActiveStatus)?_vm._i(_vm.odInActiveStatus,null)>-1:(_vm.odInActiveStatus)},on:{"change":function($event){var $$a=_vm.odInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.odInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.odInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.odInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/ManageShopSubAgent'),expression:"$route.path == '/Master/ManageShopSubAgent'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sumKeyword),expression:"sumKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจากชื่อร้านค้า ชื่อร้านค้า 2 ชื่อผู้ติดต่อ เจ้าหน้าที่ดูแล โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ชื่อร้านค้า 1, ชื่อร้านค้า 2"},domProps:{"value":(_vm.sumKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sumKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"sumInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'sumInActiveStatus',"name":'sumInActiveStatus',"select2-options":_vm.sumInActiveStatusOptions},model:{value:(_vm.sumInActiveStatus),callback:function ($$v) {_vm.sumInActiveStatus=$$v},expression:"sumInActiveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.sumShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.sumShopTypeId),callback:function ($$v) {_vm.sumShopTypeId=$$v},expression:"sumShopTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmShopGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmShopGroupId),callback:function ($$v) {_vm.shmShopGroupId=$$v},expression:"shmShopGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"sumProvinceIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'sumProvinceId',"name":'sumProvinceId',"select2-options":_vm.sumProvinceIdOptions},on:{"selectChange":_vm.onAmpherIdChange},model:{value:(_vm.sumProvinceId),callback:function ($$v) {_vm.sumProvinceId=$$v},expression:"sumProvinceId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"sumAmpherIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'sumAmpherId',"name":'sumAmpherId',"select2-options":_vm.sumAmpherIdOptions},model:{value:(_vm.sumAmpherId),callback:function ($$v) {_vm.sumAmpherId=$$v},expression:"sumAmpherId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย :")]),_vm._v(" "),_c('treeselect',{ref:"sumSubShopAgent",attrs:{"id":"sumSubShopAgent","async":true,"multiple":true,"load-options":_vm.LoadSumSubShopAgentOptions,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadSumSubShopAgentOptions},model:{value:(_vm.sumSubShopAgent),callback:function ($$v) {_vm.sumSubShopAgent=$$v},expression:"sumSubShopAgent"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportShopSubAgent}},[_vm._m(1)]),_vm._v(" "),(
                  this.$root.canShow([
                    'MANAGE_MASTER',
                    'MANAGE_SHOP_SUB_AGENT' ])
                )?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManageShopSubAgent/Add","tag":"button","title":"เพิ่ม"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่ม\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(2)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"subAgentTable"}},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้ดูแลร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้ดูแลร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ที่อยู่")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("อีเมล")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เบอร์โทร")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อผู้ติดต่อ")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("เจ้าหน้าที่ดูแล (ตัวแทน)")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("เจ้าหน้าที่ดูแล (boonrawd)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("อำเภอ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Latitude")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Longitude")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"Modal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสคลังสินค้า:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อคลังสินค้า:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผู้จำหน่าย (Supplier):")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัส SAP:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัส NFC:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสบาร์โค้ด:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสทรัพย์สิน (เบิยร์สด):")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสทรัพย์สิน (บัญชี):")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับเข้า:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"date","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ผลิต:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"date","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จำนวนวันที่รับประกัน:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุดการรับประกัน:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"date","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จำนวนวันที่อยู่ในคลังสินค้า:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("มูลค่าสินค้า:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อายุสินค้า:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รูปภาพ:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"file","value":""}})])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n          ")])])}]


/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"SearchDetailModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbBarcodeOld),expression:"dbBarcodeOld"}],staticClass:"form-control",attrs:{"id":"dbBarcodeOld","type":"text","readonly":""},domProps:{"value":(_vm.dbBarcodeOld)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbBarcodeOld=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbAssetOwner),expression:"dbAssetOwner"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dbAssetOwner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbAssetOwner=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ปี(สินค้า):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbBarcodeYear),expression:"dbBarcodeYear"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dbBarcodeYear)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbBarcodeYear=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("รหัสทรัพย์สิน(บัญชี):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbAssetCode),expression:"dbAssetCode"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dbAssetCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbAssetCode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("BARCODE COOLING:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbBarcodeCL),expression:"dbBarcodeCL"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dbBarcodeCL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbBarcodeCL=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("รหัสสินค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbMaterial),expression:"dbMaterial"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dbMaterial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbMaterial=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbProduct),expression:"dbProduct"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dbProduct)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbProduct=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("เจ้าของทรัพย์สิน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbOwner),expression:"dbOwner"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dbOwner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbOwner=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("Supplier:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbSupplier),expression:"dbSupplier"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dbSupplier)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbSupplier=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbStartDate),expression:"dbStartDate"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dbStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbStartDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ระยะเวลาประกัน(วัน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbLongDate),expression:"dbLongDate"}],staticClass:"form-control",attrs:{"id":"dbLongDate","type":"text","readonly":""},domProps:{"value":(_vm.dbLongDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbLongDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("อายุของทรัพย์สิน(วัน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbExprie),expression:"dbExprie"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dbExprie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbExprie=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("สถานะทรัพย์สินเช่า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbLeasedAssets),expression:"dbLeasedAssets"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.dbLeasedAssets)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbLeasedAssets=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("รหัสอ้างอิง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbRefcode),expression:"dbRefcode"}],staticClass:"form-control",attrs:{"id":"dbRefcode","type":"text","readonly":""},domProps:{"value":(_vm.dbRefcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbRefcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbProductType),expression:"dbProductType"}],staticClass:"form-control",attrs:{"id":"dbProductType","type":"text","readonly":""},domProps:{"value":(_vm.dbProductType)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbProductType=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("สินค้าพร้อมขาย:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dbBeerDetail),expression:"dbBeerDetail"}],staticClass:"form-control",attrs:{"id":"dbBeerDetail","type":"text","readonly":""},domProps:{"value":(_vm.dbBeerDetail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dbBeerDetail=$event.target.value}}})])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12 mt-3"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"detailTable"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("วันที่")]),_vm._v(" "),_c('th',[_vm._v("หมายเลข Job")]),_vm._v(" "),_c('th',[_vm._v("ที่ตั้ง")]),_vm._v(" "),_c('th',[_vm._v("สถานะ")]),_vm._v(" "),_c('th',[_vm._v("สแกนโดย")]),_vm._v(" "),_c('th',[_vm._v("วันที่สแกน")]),_vm._v(" "),_c('th',[_vm._v("ประเภทใบงาน")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")])])}]


/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Invoice No :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odcInvoiceNo),expression:"odcInvoiceNo"}],staticClass:"form-control",attrs:{"id":"odcInvoiceNo","name":"odcInvoiceNo","type":"text","maxlength":"450","placeholder":"Invoice No."},domProps:{"value":(_vm.odcInvoiceNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.odcInvoiceNo=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Invoice Date :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"odcInvoiceDate",staticClass:"form-control",attrs:{"type":"text","id":"odcInvoiceDate","name":"odcInvoiceDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Supplier :")]),_vm._v(" "),_c('select2',{ref:"odcSupplierSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'odcSupplier',"name":'odcSupplier',"select2-options":_vm.odcSupplierOptions},model:{value:(_vm.odcSupplier),callback:function ($$v) {_vm.odcSupplier=$$v},expression:"odcSupplier"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แนบไฟล์:")]),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button","id":"uploader-order","data-ref":_vm.uuid}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("ไฟล์\n              ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-file"}})])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"1440px"}},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.odcitems == null || _vm.odcitems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.odcitems),function(item,i){return [_c('order-item-row',{key:i,ref:"jobItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"9"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])])])])])])])])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(4)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("รหัส/ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ราคา")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("รวม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("งบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("โควต้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"spareProductList",staticClass:"modal fade",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-l",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},_vm._l((_vm.items),function(group,index){return _c('div',{key:index,staticClass:"mb-4"},[_c('h5',{staticClass:"text-primary mb-2"},[_vm._v("ชื่อสินค้า : "+_vm._s(group.materialName)+" ["+_vm._s(group.materialCode)+"]")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"80px","text-align":"center"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.getBarcodeHeader(group)))]),_vm._v(" "),_c('th',{staticStyle:{"width":"150px","text-align":"center"}},[_vm._v("ระบุรายการอะไหล่")])])]),_vm._v(" "),_c('tbody',_vm._l((group.barcodeSpareUseds),function(barcode,i){return _c('tr',{key:i},[_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(i+1))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(barcode.barcodeNoOld))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"title":"ระบุรายการอะไหล่"},on:{"click":function($event){return _vm.openSparePartModal(group,barcode)}}},[_c('i',{staticClass:"fa fa-wrench",staticStyle:{"color":"#a7abc3"},attrs:{"aria-hidden":"true"}})])])])}),0)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isSpareAdded),expression:"isSpareAdded"}],staticClass:"form-check-input",attrs:{"id":"isSpareAdded","name":"isSpareAdded","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isSpareAdded)?_vm._i(_vm.isSpareAdded,null)>-1:(_vm.isSpareAdded)},on:{"change":function($event){var $$a=_vm.isSpareAdded,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isSpareAdded=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isSpareAdded=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isSpareAdded=$$c}}}}),_vm._v("\n                                            เพิ่มอะไหล่เรียบร้อยแล้ว\n                                            "),_c('span')])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){$event.preventDefault();return _vm.btnAddSpareParts()}}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล")])])])])])]),_vm._v(" "),_c('spare-part-used-list',{ref:"sparePartUsedList",attrs:{"barcode":_vm.selectedBarcode,"spare-parts":_vm.selectedBarcode && _vm.selectedBarcode.spareParts || []},on:{"save":_vm.handleSparePartSave}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',[_vm._v("ระบุอะไหล่ซัพพลายเออร์")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ")])}]


/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/ManageShopChangeRequest'),expression:"$route.path == '/Master/ManageShopChangeRequest'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.shcmKeyword),expression:"shcmKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก รหัส ชื่อร้านค้า เจ้าหน้าที่ดูแล โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ชื่อร้านค้า 1, ชื่อร้านค้า 2"},domProps:{"value":(_vm.shcmKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.shcmKeyword=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"clear-on-select":true,"options":_vm.shcmShopTypeIdOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shcmShopTypeId),callback:function ($$v) {_vm.shcmShopTypeId=$$v},expression:"shcmShopTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"shcmProvinceIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'shcmProvinceId',"name":'shcmProvinceId',"select2-options":_vm.shcmProvinceIdOptions},on:{"selectChange":_vm.onAmpherIdChange},model:{value:(_vm.shcmProvinceId),callback:function ($$v) {_vm.shcmProvinceId=$$v},expression:"shcmProvinceId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"shcmAmpherIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'shcmAmpherId',"name":'shcmAmpherId',"select2-options":_vm.shcmAmpherIdOptions},model:{value:(_vm.shcmAmpherId),callback:function ($$v) {_vm.shcmAmpherId=$$v},expression:"shcmAmpherId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"shcmApproveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'shcmApproveStatus',"name":'shcmApproveStatus',"select2-options":_vm.shcmApproveStatusOptions},model:{value:(_vm.shcmApproveStatus),callback:function ($$v) {_vm.shcmApproveStatus=$$v},expression:"shcmApproveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("จัดการขอแก้ไขข้อมูลร้านค้า")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"shopChangeRequestTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้ร้องขอแก้ไข")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่ส่งคำขอ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อกลุ่ม:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.caApproveGroup),expression:"caApproveGroup"}],staticClass:"form-control",attrs:{"id":"caApproveGroup","name":"caApproveGroup","type":"text","maxlength":"450","placeholder":"ชื่อกลุ่มอนุมัติ"},domProps:{"value":(_vm.caApproveGroup)},on:{"input":function($event){if($event.target.composing){ return; }_vm.caApproveGroup=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 table-responsive",attrs:{"id":"AddAgent"}},[_c('label',[_vm._v("ตัวแทนจำหน่าย (Agent)")]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.aItems == null || _vm.aItems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"4"}},[_vm._v("คลิก + เพื่อเพิ่มรายการใหม่")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.aItems),function(item,i){return [_c('a-item-row',{key:i,ref:"aItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveAItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddAItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                      ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 table-responsive",attrs:{"id":"AddAgent"}},[_c('label',[_vm._v("พนักงาน (BRT)")]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.brtItems == null || _vm.brtItems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"4"}},[_vm._v("คลิก + เพื่อเพิ่มรายการใหม่")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.brtItems),function(item,i){return [_c('brt-item-row',{key:i,ref:"brtItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveBRTItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddBrtItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                      ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 table-responsive",attrs:{"id":"AddAgent"}},[_c('label',[_vm._v("ลำดับการอนุมัติ")]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(3),_vm._v(" "),_c('tbody',[(_vm.apItems == null || _vm.apItems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"7"}},[_vm._v("คลิก + เพื่อเพิ่มรายการใหม่")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.apItems),function(item,i){return [_c('ap-item-row',{key:i,ref:"apItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveAPItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"7"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddapItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                      ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมายเหตุ:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.caRemark),expression:"caRemark"}],staticClass:"form-control",attrs:{"placeholder":"หมายเหตุ","rows":"5"},domProps:{"value":(_vm.caRemark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.caRemark=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.caInActiveStatus),expression:"caInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"caInActiveStatus","id":"caInActiveStatus"},domProps:{"checked":Array.isArray(_vm.caInActiveStatus)?_vm._i(_vm.caInActiveStatus,null)>-1:(_vm.caInActiveStatus)},on:{"change":function($event){var $$a=_vm.caInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.caInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.caInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.caInActiveStatus=$$c}}}}),_vm._v("\n                    เปิดใช้งาน\n                    "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_vm._m(4)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"2%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%"}},[_vm._v("เครื่องมือ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"2%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("พนักงาน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%"}},[_vm._v("เครื่องมือ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"2%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("พนักงาน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"5%"}},[_vm._v("ลำดับอนุมัติ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%"}},[_vm._v("สิทธิ์การแก้ไข")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%"}},[_vm._v("มีสิทธิ์การอนุมัติ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"5%"}},[_vm._v("เครื่องมือ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])}]


/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--last kt-portlet--head-lg kt-portlet--responsive-mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),(_vm.isEdit)?_c('h3',{staticClass:"kt-portlet__head-title"},[_c('p',{staticClass:"mt-2 mb-0"},[_vm._v("\n              แก้ไขใบงาน\n              "),_c('strong',[_vm._v("ประเภท"+_vm._s(_vm.jobTypeName))]),_vm._v(" เลขที่\n              "),_c('strong',[_vm._v(_vm._s(_vm.jobNumber))])]),_vm._v(" "),(!_vm.isEditable)?_c('p',{staticClass:"text-danger mt-2 mb-0"},[_c('i',{staticClass:"flaticon-alert"}),_vm._v("\n              ใบงานนี้ไม่สามารถแก้ไขได้เนื่องจากได้ถูกนำไปใช้งานหรือสแกนบาร์โค้ดแล้ว\n              "),_c('u',[_vm._v("ต้องลบและสร้างใหม่เท่านั้น")]),_vm._v("เพื่อล้างรายการบาร์โค้ดที่ถูกสแกนแล้ว\n            ")]):_vm._e(),_vm._v(" "),(_vm.fromJobNumber)?_c('p',{staticClass:"text-info mt-2 mb-2"},[_c('i',{staticClass:"flaticon-questions-circular-button"}),_vm._v("\n              อ้างอิงใบงานต้นทาง\n              "),_c('strong',[_vm._v(_vm._s(_vm.fromJobNumber))]),_vm._v("\n              (ประเภท"+_vm._s(_vm.fromJobTypeName)+")\n            ")]):_vm._e()]):_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            เปิดใบงาน\n            "),_c('strong',[_vm._v("ประเภท"+_vm._s(_vm.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('button',{staticClass:"btn btn-sm btn-clean kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("กลับ")])]),_vm._v(" "),(_vm.isEditable)?_c('button',{staticClass:"btn btn-sm btn-primary kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("บันทึกข้อมูล")])]):_vm._e(),_vm._v(" "),(_vm.canCommit())?_c('button',{staticClass:"btn btn-sm btn-success kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.commit($event)}}},[_c('i',{staticClass:"fa fa-archive"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("ปิดใบงาน")])]):_vm._e(),_vm._v(" "),(_vm.hasApproveProcess)?_c('button',{staticClass:"btn btn-sm btn-success kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.approvalProcess(true)}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("อนุมัติ")])]):_vm._e(),_vm._v(" "),(_vm.hasApproveProcess)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.approvalProcess(false)}}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("ไม่อนุมัติ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"jobForm",staticClass:"kt-form",attrs:{"autocomplete":"off","id":"jobForm"},on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("ข้อมูลพื้นฐาน:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่เอกสาร (วว/ดด/ปปปป):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobDate",staticClass:"form-control",attrs:{"disabled":_vm.isEdit,"readonly":"","type":"text","placeholder":"วันที่เอกสาร (วว/ดด/ปปปป)","id":"jobDate","name":"jobDate"}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),(
                    _vm.isShowOnJobTypes([
                      'RETRIEVE_NEW_ITEM',
                      'PRODUCE',
                      'DESTROY',
                      'TRANSFER_TO_AGENT',
                      'RETRIEVE_ITEM',
                      'REPAIR',
                      'REPAIR_SUPPLIER',
                      'RETURN_SUPPLIER',
                      'TRANSFER_TO_SHOP',
                      'PICKUP',
                      'RETURN',
                      'RETURN_ADHOC',
                      'EXCHANGE',
                      'BORROW',
                      'HOLD_CHECKER',
                      'NEW_SHOP',
                      'PM_CHECK',
                      'EDIT_NFC',
                      'INSPECTIONS_AND_BORROW_PROPERTY',
                      'BEER_CLAIM',
                      'QI_NO_EQUIPMENT',
                      'TYPING_BARCODE',
                      'QI_LESS_THAN_61',
                      'EDIT_SHOP',
                       'AUDIT_STOCK',
                      'TRANSFER_TO_MULTI_SHOP'
                    ])
                  )?_c('div',{staticClass:"col-sm-6 col-md-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สถานที่ต้นทาง (Origin):")]),_vm._v(" "),_c('select2',{ref:"originLocationId",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control',"id":'originLocationId',"name":'originLocationId',"select2-options":_vm.originLocationIdOptions},on:{"selectChange":_vm.onOriginLocationChange},model:{value:(_vm.originLocationId),callback:function ($$v) {_vm.originLocationId=$$v},expression:"originLocationId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"}),_vm._v(" "),(
                        _vm.isShowOnJobTypes([
                          'TRANSFER_TO_AGENT',
                          'TRANSFER_TO_SHOP',
                          'TRANSFER_TO_MULTI_SHOP',
                          'EXCHANGE',
                          'BORROW', 
                          ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_AGENT'],
                          ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_SHOP'],
                          ['RETRIEVE_ITEM', 'JOB_TYPE_EXCHANGE'],
                          ['RETRIEVE_ITEM', 'JOB_TYPE_BORROW'] ])
                      )?_c('label',{staticClass:"kt-checkbox kt-checkbox--brand"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pickupAtOrigin),expression:"pickupAtOrigin"}],attrs:{"type":"checkbox","disabled":!_vm.isEditable || !_vm.canPickupAtOriginMultiShop || _vm.isSubAgentOrShop},domProps:{"value":true,"checked":Array.isArray(_vm.pickupAtOrigin)?_vm._i(_vm.pickupAtOrigin,true)>-1:(_vm.pickupAtOrigin)},on:{"change":function($event){var $$a=_vm.pickupAtOrigin,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.pickupAtOrigin=$$a.concat([$$v]))}else{$$i>-1&&(_vm.pickupAtOrigin=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.pickupAtOrigin=$$c}}}}),_vm._v("\n\n                                ลูกค้ามารับสินค้าเอง\n                                "),(!_vm.isShowOnJobTypes('EXCHANGE'))?[_vm._v("\n                                    (ปลายทางต้องมีเพียงรายเดียวเท่านั้น)\n                                ")]:_vm._e(),_vm._v(" "),_c('span')],2):_vm._e(),_vm._v(" "),(_vm.isShowOnJobTypes('EXCHANGE'))?_c('br'):_vm._e(),_vm._v(" "),(
                        _vm.isShowOnJobTypes([
                          'TRANSFER_TO_SHOP', ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_SHOP'],
                          'RETURN', ['RETRIEVE_ITEM', 'JOB_TYPE_RETURN'],
                          'EXCHANGE', ['RETRIEVE_ITEM', 'JOB_TYPE_EXCHANGE'],
                          'PICKUP' ]) &&
                          _vm.originData &&
                          !_vm.originData.data.noSML &&
                          _vm.originData.data.locationType == 'AGENT'
                      )?_c('label',{staticClass:"kt-checkbox kt-checkbox--danger"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.noUseSML),expression:"noUseSML"}],attrs:{"type":"checkbox","disabled":!_vm.isEditable},domProps:{"value":true,"checked":Array.isArray(_vm.noUseSML)?_vm._i(_vm.noUseSML,true)>-1:(_vm.noUseSML)},on:{"change":function($event){var $$a=_vm.noUseSML,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.noUseSML=$$a.concat([$$v]))}else{$$i>-1&&(_vm.noUseSML=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.noUseSML=$$c}}}}),_vm._v("\n                                ไม่อ้างอิงข้อมูลระบบ SML\n                                "),_c('span')]):_vm._e(),_vm._v(" "),(_vm.isShowOnJobTypes('PICKUP'))?_c('br'):_vm._e(),_vm._v(" "),(
                        _vm.isShowOnJobTypes([
                          'PICKUP' ]) &&
                          _vm.originData &&
                          _vm.originData.data.locationType == 'AGENT' &&
                          _vm.originData.data.isPreviousBalance == true
                      )?_c('label',{staticClass:"kt-checkbox kt-checkbox--danger"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isPreviousBalance),expression:"isPreviousBalance"}],attrs:{"type":"checkbox","disabled":(!_vm.isEditable || !_vm.isEditableTypePICKUP)},domProps:{"value":true,"checked":Array.isArray(_vm.isPreviousBalance)?_vm._i(_vm.isPreviousBalance,true)>-1:(_vm.isPreviousBalance)},on:{"change":function($event){var $$a=_vm.isPreviousBalance,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isPreviousBalance=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isPreviousBalance=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isPreviousBalance=$$c}}}}),_vm._v("\n                                ยกยอดสินค้าในใบงานเร่ขายไปวันถัดไป\n                                "),_c('span')]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(
                    _vm.isShowOnJobTypes([
                      'RETRIEVE_ITEM',
                      'REPAIR_SUPPLIER',
                      'RETURN_SUPPLIER',
                      'RETURN',
                      'EXCHANGE',
                      'BEER_CLAIM'
                    ]) ||
                      (_vm.$route.meta.jobType == 'BORROW' && !_vm.pickupAtOrigin) ||
                      (_vm.$route.meta.jobType == 'TRANSFER_TO_SHOP' && _vm.originData && _vm.originData.data.locationType == 'SHOP') ||
                      (_vm.$route.meta.jobType == 'TRANSFER_TO_SHOP' && _vm.originData && (_vm.originData.data.noSML || _vm.noUseSML))
                  )?_c('div',{staticClass:"col-sm-6 col-md-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สถานที่ปลายทาง (Destination): ")]),_vm._v(" "),_c('select2',{ref:"destinationLocationId",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control',"id":'destinationLocationId',"name":'destinationLocationId',"select2-options":_vm.destinationLocationIdOptions},on:{"selectChange":_vm.onDestinationLocationChange},model:{value:(_vm.destinationLocationId),callback:function ($$v) {_vm.destinationLocationId=$$v},expression:"destinationLocationId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]):_vm._e(),_vm._v(" "),(
                        _vm.isShowOnJobTypes([
                          'TRANSFER_TO_MULTI_SHOP',
                          ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_MULTI_SHOP'] ])
                      )?_c('div',{staticClass:"col-sm-6 col-md-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รถสำหรับขนส่งสินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('select2',{ref:"transitId",attrs:{"disabled":_vm.jobStatus != 'JOB_STATUS_WAITING' && _vm.jobStatus != 'JOB_STATUS_PENDING' && _vm.jobStatus != 'JOB_STATUS_PICKUP',"css-style":'width: 100%;',"css-class":'form-control',"id":'transitId',"name":'transitId',"select2-options":_vm.transportOptions},on:{"selectChange":_vm.onTransitIdChange},model:{value:(_vm.transitId),callback:function ($$v) {_vm.transitId=$$v},expression:"transitId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]):_vm._e(),_vm._v(" "),(
                      _vm.isShowOnJobTypes([
                        'TRANSFER_TO_SHOP',
                        'RETURN',
                        'EXCHANGE',
                        'PICKUP',
                        'TRANSFER_TO_MULTI_SHOP'
                      ])
                    )?_c('div',{staticClass:"col-sm-6 col-md-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เลือก User:")]),_vm._v(" "),_c('select2',{ref:"userIds",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control',"id":'userIds',"name":'userIds',"select2-options":_vm.userIdsOptions,"multiple":true},model:{value:(_vm.userIds),callback:function ($$v) {_vm.userIds=$$v},expression:"userIds"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]):_vm._e(),_vm._v(" "),(_vm.isShowOnJobTypes(['PRODUCE']))?_c('div',{staticClass:"col-sm-6 col-md-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สินค้าที่ต้องการผลิต:")]),_vm._v(" "),_c('select2',{ref:"finishedProductCode",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'finishedProductCode',"name":'finishedProductCode',"select2-options":_vm.finishedProductCodeOptions},model:{value:(_vm.finishedProductCode),callback:function ($$v) {_vm.finishedProductCode=$$v},expression:"finishedProductCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]):_vm._e(),_vm._v(" "),(
                    _vm.isShowOnJobTypes([
                      'TRANSFER_TO_AGENT',
                      ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_AGENT'],
                      'RETURN',
                      ['RETRIEVE_ITEM', 'JOB_TYPE_RETURN'],
                      'EXCHANGE',
                      ['RETRIEVE_ITEM', 'JOB_TYPE_EXCHANGE'],
                      'BORROW',
                      ['RETRIEVE_ITEM', 'JOB_TYPE_BORROW'] ])
                  )?_c('div',{staticClass:"col-sm-6 col-md-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รถสำหรับขนส่งสินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('select2',{ref:"transitId",attrs:{"disabled":_vm.jobStatus != 'JOB_STATUS_WAITING' && _vm.jobStatus != 'JOB_STATUS_PENDING' && _vm.jobStatus != 'JOB_STATUS_PICKUP',"css-style":'width: 100%;',"css-class":'form-control',"id":'transitId',"name":'transitId',"select2-options":_vm.transportOptions},on:{"selectChange":_vm.onTransitIdChange},model:{value:(_vm.transitId),callback:function ($$v) {_vm.transitId=$$v},expression:"transitId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]):_vm._e(),_vm._v(" "),(_vm.transitId2)?_c('div',{staticClass:"col-sm-6 col-md-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รถสำหรับขนส่งสินค้า/ทรัพย์สิน ณ จุดรับ:")]),_vm._v(" "),_c('select2',{ref:"transitId2",attrs:{"disabled":"","css-style":'width: 100%;',"css-class":'form-control',"id":'transitId2',"name":'transitId2',"select2-options":_vm.transportOptions},model:{value:(_vm.transitId2),callback:function ($$v) {_vm.transitId2=$$v},expression:"transitId2"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]):_vm._e()])])]),_vm._v(" "),(_vm.isEditable && _vm.isShowOnJobTypes(['TRANSFER_TO_MULTI_SHOP']))?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"kt-section__body"},[_vm._l((_vm.jobDestinations),function(destination,destIndex){return _c('div',{key:destination._uid},[(destIndex > 0)?_c('hr',{staticStyle:{"border-top":"1px solid #e0e0e0","margin":"20px 0"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-sm-12 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("\n                        สถานที่ปลายทาง (Destination):\n                      ")]),_vm._v(" "),_c('select2',{ref:'destinationLocationId_' + destIndex,refInFor:true,attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control required',"id":'destinationLocationId_' + destIndex,"name":'destinationLocationId_' + destIndex,"select2-options":_vm.destinationLocationIdOptions,"data-msg-required":'กรุณาเลือกสถานที่ปลายทาง (Destination)'},on:{"selectChange":function (id, val, data, ref) { return _vm.onMultiDestinationChange(id, val, data, ref, destIndex); }},model:{value:(destination.destinationLocationId),callback:function ($$v) {_vm.$set(destination, "destinationLocationId", $$v)},expression:"destination.destinationLocationId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),(_vm.isEditable && _vm.jobDestinations.length > 1)?_c('div',{staticClass:"col-sm-12 col-md-6 text-right"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label d-none d-md-block"},[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.onRemoveDestinationClick(destIndex)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" ลบร้านค้านี้\n                      ")])])]):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(2,true),_vm._v(" "),_c('tbody',[(!destination.items || destination.items.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"6"}},[_vm._v("\n                            คลิก + เพื่อเพิ่มรายการใหม่\n                          ")])]):_vm._e(),_vm._v(" "),_vm._l((destination.items),function(item,itemIndex){return [_c('job-item-row',{key:'dest-' + destIndex + '-item-' + itemIndex,ref:'jobItems_' + destIndex + '_' + itemIndex,refInFor:true,attrs:{"rowIndex":itemIndex,"item":item,"isEditable":_vm.isEditable && !item.isDisabled,"isEdit":_vm.isEdit,"jobType":_vm.$route.meta.jobType,"originLocationId":_vm.originLocationId,"originData":_vm.originData,"noUseSML":_vm.noUseSML,"parentJobType":_vm.parentJobType},on:{"removeItem":function (idx) { return _vm.onRemoveMultiShopItemClick(destIndex, idx); },"showBarcode":_vm.onShowBarcodeClick}})]})],2),_vm._v(" "),(_vm.isEditable)?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"6"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){return _vm.onAddMultiShopItemClick(destIndex)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                            ")])])])]):_vm._e()])])])])}),_vm._v(" "),(_vm.isEditable)?_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"text-align":"center"}},[_c('button',{staticClass:"btn btn-sm",staticStyle:{"background-color":"#FCB53B","color":"#fff"},attrs:{"type":"button","disabled":!_vm.originLocationId},on:{"click":_vm.onAddDestinationClick}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มสถานที่ปลายทาง\n                  ")]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.originLocationId)?_c('span',{staticClass:"text-warning"},[_vm._v("\n                    กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อน จึงจะสามารถเพิ่มสถานที่ปลายทางได้\n                  ")]):_vm._e()])]):_vm._e()],2)]):_vm._e(),_vm._v(" "),(!_vm.isEditable && _vm.isShowOnJobTypes(['TRANSFER_TO_MULTI_SHOP']))?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"kt-section__body"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('table',{staticClass:"table table-sm table-bordered"},[_vm._m(4),_vm._v(" "),(_vm.job.jobDestinations && _vm.job.jobDestinations.length > 0)?_c('tbody',[_vm._l((_vm.job.jobDestinations),function(dest,destIndex){return [(dest.items && dest.items.length > 0)?[_vm._l((dest.items),function(item,itemIndex){return _c('tr',{key:'dest-' + destIndex + '-item-' + itemIndex},[(itemIndex === 0)?_c('td',{staticClass:"text-center align-middle",attrs:{"rowspan":dest.items.length + 1}},[_vm._v("\n                              "+_vm._s(destIndex + 1)+"\n                            ")]):_vm._e(),_vm._v(" "),(itemIndex === 0)?_c('td',{staticClass:"align-middle",attrs:{"rowspan":dest.items.length}},[_vm._v("\n                              "+_vm._s(dest.destinationDisplayText || dest.destinationName)+"\n                            ")]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.materialName)+" ["+_vm._s(item.materialCode)+"]")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(item.quantity)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.unitName || '-'))])])}),_vm._v(" "),_c('tr',{key:'dest-' + destIndex + '-footer'},[_vm._m(5,true),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right font-weight-bold",staticStyle:{"color":"#2015AB"}},[_vm._v("\n                              "+_vm._s(_vm.formatNumber(dest.items.reduce(function (sum, i) { return sum + i.quantity; }, 0)))+"\n                            ")]),_vm._v(" "),_c('td')])]:[_c('tr',{key:'dest-' + destIndex + '-noitems'},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(destIndex + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dest.destinationName))]),_vm._v(" "),_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"3"}},[_vm._v("ไม่มีรายการสินค้า")])])]]})],2):_vm._e(),_vm._v(" "),(_vm.job.jobDestinations && _vm.job.jobDestinations.length > 0)?_c('tfoot',[_c('tr',{staticClass:"font-weight-bold"},[_vm._m(6),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"color":"#2015AB"}},[_vm._v("\n                          "+_vm._s(_vm.formatNumber(
                            _vm.job.jobDestinations.reduce(function (total, dest) { return total + (dest.items || []).reduce(function (sum, item) { return sum + item.quantity; }, 0); }, 0
                            )
                          ))+"\n                        ")]),_vm._v(" "),_c('td')])]):_c('tbody',[_vm._m(7)])])])])])]):_vm._e(),_vm._v(" "),(!_vm.isEditable && _vm.isShowOnJobTypes(['TRANSFER_TO_MULTI_SHOP']))?_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(8),_vm._v(" "),_c('tbody',[(_vm.job.items == null || _vm.job.items.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"6"}},[_vm._v("\n                          ไม่มีรายการสินค้า\n                        ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.job.items),function(item,i){return _c('tr',{key:'item-' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.materialName)+" ["+_vm._s(item.materialCode)+"]")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.description || '-'))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                          "+_vm._s(_vm.formatNumber(item.quantity))+"\n                          "),(item.checkedQuantity > 0)?_c('span',{staticClass:"text-info text-right",staticStyle:{"display":"block"}},[_c('i',{staticClass:"fa fa-qrcode"}),_vm._v("\n                            สแกนแล้ว "+_vm._s(item.checkedQuantity)+" บาร์โค้ด\n                          ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.baseUnit || '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(item.hasBarcode)?_c('button',{staticClass:"btn btn-sm btn-outline-info btn-icon",attrs:{"type":"button","title":"แสดงรายการบาร์โค้ด"},on:{"click":function($event){return _vm.onShowBarcodeClick(i, item)}}},[_c('i',{staticClass:"la la-list"})]):_vm._e()])])})],2),_vm._v(" "),(_vm.isEdit && (_vm.jobStatus == 'JOB_STATUS_WAITING' || _vm.jobStatus == 'JOB_STATUS_PENDING'))?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{attrs:{"colspan":"1"}},[_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group"},[_vm._m(9),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcodeForm.barcode),expression:"barcodeForm.barcode"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"กรอกบาร์โค้ด แล้ว Enter/คลิกปุ่มบันทึกบาร์โค้ด","rows":"3"},domProps:{"value":(_vm.barcodeForm.barcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.barcodeForm, "barcode", $event.target.value)}}})])])]),_vm._v(" "),_c('td',{attrs:{"colspan":"4"}},[_c('button',{staticClass:"btn btn-sm btn-warning",attrs:{"disabled":_vm.barcodeForm.isLoading || !_vm.barcodeForm.barcode,"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.submitBarcode($event)}}},[_c('i',{staticClass:"fa fa-barcode"}),_vm._v(" บันทึกบาร์โค้ด\n                          ")]),_vm._v(" "),(_vm.scanBarcodeMessage)?[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onShowScanModal($event)}}},[_c('i',{staticClass:"text-info la la-list"}),_vm._v(" "+_vm._s(_vm.scanBarcodeMessage))])]:_vm._e()],2)])]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(
              _vm.isShowOnJobTypes(['REPAIR_SUPPLIER', 'RETURN_SUPPLIER']) ||
                (_vm.$route.meta.jobType == 'DESTROY' && (_vm.jobStatus == 'JOB_STATUS_REQUEST_APPROVAL' || _vm.jobStatus == 'JOB_STATUS_SUCCESS'))
            )?_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("ไฟล์เอกสาร:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(10),_vm._v(" "),_c('tbody',[(_vm.uploadFiles == null || _vm.uploadFiles.length == 0)?_c('tr',[_vm._m(11)]):_vm._e(),_vm._v(" "),_vm._l((_vm.uploadFiles),function(file,i){return _c('tr',{key:'upload-item-' + i},[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(i + 1))])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(file.documentName),expression:"file.documentName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ชื่อเอกสาร","readonly":!_vm.isEditable},domProps:{"value":(file.documentName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(file, "documentName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(file.isPreview)?_c('a',{staticClass:"form-control form-control-plaintext",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.openPreview(file.fileURL)}}},[_vm._v(_vm._s(file.fileName))]):_c('a',{staticClass:"form-control form-control-plaintext",attrs:{"target":"blank","href":("/Api/File/FileDownloadByte?FileInfoId=" + (file.fileInfoId) + "&ContentType=" + (encodeURIComponent(file.contentType)) + "&FileName=" + (encodeURIComponent(file.fileName)))}},[_vm._v(_vm._s(file.fileName))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(file.contentType))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.isEditable || (_vm.$route.meta.jobType == 'DESTROY' && _vm.jobStatus == 'JOB_STATUS_REQUEST_APPROVAL'))?_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"ลบไฟล์"},on:{"click":function($event){return _vm.onRemoveUploadFileClick(i, file)}}},[_c('i',{staticClass:"text-danger la la-trash"})]):_vm._e()])])})],2),_vm._v(" "),(
                        (_vm.isEditable && _vm.$route.meta.jobType != 'RETRIEVE_ITEM') ||
                          (_vm.$route.meta.jobType == 'DESTROY' && _vm.jobStatus == 'JOB_STATUS_REQUEST_APPROVAL')
                      )?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"8"}},[_c('span',{ref:"uploadFileBtnContainer"},[_c('button',{ref:"uploadFileBtn",staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v(" อัพโหลดไฟล์เอกสาร\n                            ")])]),_vm._v(" "),(_vm.$route.meta.jobType == 'DESTROY')?_c('a',{staticClass:"btn btn-sm btn-info",attrs:{"type":"button","target":"_blank","href":'/Print/DestroyRequestForm/' + _vm.$route.params.id}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" พิมพ์ใบส่งรอทำลาย\n                          ")]):_vm._e()])])]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.isShowOnJobTypes(['TRANSFER_TO_AGENT', ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_AGENT']]))?_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("ใบส่งสินค้า (Delivery Order):")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(12),_vm._v(" "),_c('tbody',[(_vm.refDocuments == null || _vm.refDocuments.length == 0)?_c('tr',[_vm._m(13)]):_vm._e(),_vm._v(" "),_vm._l((_vm.refDocuments),function(item,i){return [(item.items.length > 0)?_vm._l((item.items),function(prod,j){return _c('job-ref-document-row',{key:prod.docNumber,ref:"jobRefDocuments",refInFor:true,attrs:{"rowIndex":i,"itemIndex":j,"showHeader":j == 0,"rootItems":_vm.refDocuments,"item":item,"isEditable":_vm.isEditable,"isEdit":_vm.isEdit,"jobType":_vm.$route.meta.jobType},on:{"removeItem":_vm.onRemoveRefDocumentClick}})}):[_c('job-ref-document-row',{key:item.id,ref:"jobRefDocuments",refInFor:true,attrs:{"rowIndex":i,"itemIndex":0,"rootItems":_vm.refDocuments,"item":item,"isEditable":_vm.isEditable,"isEdit":_vm.isEdit,"jobType":_vm.$route.meta.jobType,"showHeader":true},on:{"removeItem":_vm.onRemoveRefDocumentClick}})]]})],2),_vm._v(" "),(_vm.isEditable && _vm.$route.meta.jobType != 'RETRIEVE_ITEM')?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"8"}},[_c('span',{ref:"uploadDOBtnContainer"},[_c('button',{ref:"uploadDOBtn",staticClass:"btn btn-sm btn-brand",attrs:{"type":"button","disabled":!_vm.originLocationId}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v(" อัพโหลดใบส่งสินค้า (Delivery Order) ด้วยไฟล์ .xlsx\n                            ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-dark",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onCalculateItemClick($event)}}},[_c('i',{staticClass:"fa fa-calculator"}),_vm._v("\n                            คำนวณรายการสินค้า/ทรัพย์สิน\n                          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-warning"},[_vm._v("กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อน จึงจะสามารถอัพโหลดได้")])])])]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(
              _vm.isShowOnJobTypes(['TRANSFER_TO_SHOP', ['RETRIEVE_ITEM', 'JOB_TYPE_TRANSFER_TO_SHOP']]) &&
                (_vm.$route.meta.jobType == 'TRANSFER_TO_SHOP' &&
                  _vm.originData &&
                  _vm.originData.data.locationType == 'AGENT' &&
                  !_vm.originData.data.noSML &&
                  !_vm.noUseSML)
            )?_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("บิลขาย (Invoice):")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(14),_vm._v(" "),_c('tbody',[(_vm.refInvoices == null || _vm.refInvoices.length == 0)?_c('tr',[_vm._m(15)]):_vm._e(),_vm._v(" "),_vm._l((_vm.refInvoices),function(item,i){return [(item.items.length > 0)?_vm._l((item.items),function(prod,j){return _c('job-ref-invoice-row',{key:prod.docNumber,ref:"refInvoices",refInFor:true,attrs:{"rowIndex":i,"itemIndex":j,"showHeader":j == 0,"rootItems":_vm.refInvoices,"item":item,"isEditable":_vm.isEditable,"isEdit":_vm.isEdit,"jobType":_vm.$route.meta.jobType,"agentCode":_vm.originLocationId},on:{"removeItem":_vm.onRemoveRefInvoiceClick}})}):[_c('job-ref-invoice-row',{key:item.id,ref:"refInvoices",refInFor:true,attrs:{"rowIndex":i,"itemIndex":0,"rootItems":_vm.refInvoices,"item":item,"isEditable":_vm.isEditable,"isEdit":_vm.isEdit,"jobType":_vm.$route.meta.jobType,"agentCode":_vm.originLocationId,"showHeader":true},on:{"removeItem":_vm.onRemoveRefInvoiceClick}})]]})],2),_vm._v(" "),(_vm.isEditable && _vm.$route.meta.jobType != 'RETRIEVE_ITEM')?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"8"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button","disabled":!_vm.originLocationId},on:{"click":_vm.onAddRefInvoiceClick}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-dark",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onCalculateItemClick($event)}}},[_c('i',{staticClass:"fa fa-calculator"}),_vm._v("\n                            คำนวณรายการสินค้า/ทรัพย์สิน\n                          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-warning"},[_vm._v("กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อน จึงจะสามารถเพิ่มรายการใหม่ได้")])])])]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.showRefInvoices)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[(_vm.$route.meta.jobType == 'PICKUP')?[_vm._v("\n                ใบโอนสินค้า:\n              ")]:[_vm._v("\n                ใบเบิกสินค้า:\n              ")]],2),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(16),_vm._v(" "),_c('tbody',[(_vm.refInvoices == null || _vm.refInvoices.length == 0)?_c('tr',[_vm._m(17)]):_vm._e(),_vm._v(" "),_vm._l((_vm.refInvoices),function(item,i){return [(item.items.length > 0)?_vm._l((item.items),function(prod,j){return _c('job-ref-invoice-row',{key:prod.docNumber,ref:"refInvoices",refInFor:true,attrs:{"rowIndex":i,"itemIndex":j,"showHeader":j == 0,"rootItems":_vm.refInvoices,"item":item,"isEditable":_vm.isEditable,"isEdit":_vm.isEdit,"jobType":_vm.$route.meta.jobType,"agentCode":_vm.originLocationId,"apiUrl":_vm.$route.meta.jobType == 'PICKUP' ? '/Api/Sml/Transfer' : '/Api/Sml/Withdraw'},on:{"removeItem":_vm.onRemoveRefInvoiceClick}})}):[_c('job-ref-invoice-row',{key:item.id,ref:"refInvoices",refInFor:true,attrs:{"rowIndex":i,"itemIndex":0,"rootItems":_vm.refInvoices,"item":item,"isEditable":_vm.isEditable,"isEdit":_vm.isEdit,"jobType":_vm.$route.meta.jobType,"agentCode":_vm.originLocationId,"showHeader":true,"apiUrl":_vm.$route.meta.jobType == 'PICKUP' ? '/Api/Sml/Transfer' : '/Api/Sml/Withdraw'},on:{"removeItem":_vm.onRemoveRefInvoiceClick}})]]})],2),_vm._v(" "),(_vm.isEditable && _vm.$route.meta.jobType != 'RETRIEVE_ITEM')?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"8"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button","disabled":!_vm.originLocationId},on:{"click":_vm.onAddRefInvoiceClick}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-dark",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onCalculateItemClick($event)}}},[_c('i',{staticClass:"fa fa-calculator"}),_vm._v("\n                            คำนวณรายการสินค้า/ทรัพย์สิน\n                          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-warning"},[_vm._v("กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อน จึงจะสามารถเพิ่มรายการใหม่ได้")])])])]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.refJobs != null && _vm.refJobs.length > 0)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("ใบงานอ้างอิง:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(18),_vm._v(" "),_c('tbody',[_vm._l((_vm.refJobs),function(item,i){return [(item.items.length > 0)?_vm._l((item.items),function(prod,j){return _c('job-ref-job-row',{key:prod.jobItemId,ref:"refJobs",refInFor:true,attrs:{"rowIndex":i,"itemIndex":j,"showHeader":j == 0,"rootItems":_vm.refJobs,"item":item,"isEditable":_vm.isEditable,"isEdit":_vm.isEdit}})}):[_c('job-ref-job-row',{key:item.jobId,ref:"refJobs",refInFor:true,attrs:{"rowIndex":i,"itemIndex":0,"showHeader":true,"rootItems":_vm.refJobs,"item":item,"isEditable":_vm.isEditable,"isEdit":_vm.isEdit}})]]})],2),_vm._v(" "),(_vm.isEditable && _vm.$route.meta.jobType != 'RETRIEVE_ITEM')?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"8"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button","disabled":!_vm.originLocationId},on:{"click":_vm.onAddRefInvoiceClick}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-dark",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onCalculateItemClick($event)}}},[_c('i',{staticClass:"fa fa-calculator"}),_vm._v("\n                            คำนวณรายการสินค้า/ทรัพย์สิน\n                          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-warning"},[_vm._v("กรุณาเลือกสถานที่ต้นทาง (Origin) ก่อน จึงจะสามารถเพิ่มรายการใหม่ได้")])])])]):_vm._e()])])])])]):_vm._e(),_vm._v(" "),(_vm.productLoan)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("ใบเบิก/ยืม ทรัพย์สิน:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(19),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v("\n                          "+_vm._s(_vm.productLoan.requestDocNo)+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                          "+_vm._s(_vm.productLoan.requestDateFormat)+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                          "+_vm._s(_vm.productLoan.requestTypeName)+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                          "+_vm._s(_vm.productLoan.productGroupName)+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                          "+_vm._s(_vm._f("currency")(_vm.productLoan.amount,"", 2))+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                          "+_vm._s(_vm.productLoan.agentOrgName)+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                          "+_vm._s(_vm.productLoan.requestUser)+"\n                        ")])])])])])])])]):_vm._e(),_vm._v(" "),(
              _vm.showItems && _vm.$route.meta.jobType == 'AUDIT_STOCK' &&
                (_vm.isEdit || _vm.$route.meta.jobType != 'RETURN_ADHOC')
            )?_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(20),_vm._v(" "),_c('tbody',[(_vm.items == null || _vm.items.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"6"}},[_vm._v("\n                          คลิก + เพื่อเพิ่มรายการใหม่\n                        ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item,i){return [_c('job-item-row',{key:item.jobItemId,ref:"jobItems",refInFor:true,attrs:{"rowIndex":i,"item":item,"allItems":_vm.items,"isEditable":_vm.isEditable && !item.isDisabled,"isEdit":_vm.isEdit,"jobType":_vm.$route.meta.jobType,"originLocationId":_vm.originLocationId,"originData":_vm.originData,"noUseSML":_vm.noUseSML,"parentJobType":_vm.parentJobType},on:{"removeItem":_vm.onRemoveItemClick,"showBarcode":_vm.onShowBarcodeClick}})]})],2),_vm._v(" "),_c('tfoot',[(this.isBeerClaimAdmin)?_c('tr',[_c('td',{attrs:{"colspan":"2"}},[(
                              _vm.isEditable &&
                                (_vm.$route.meta.jobType != 'RETURN_ADHOC' ||
                                  _vm.$route.meta.jobType != 'BEER_CLAIM')
                            )?_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                          ")]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"colspan":"1"}},[(_vm.isEdit  && (_vm.jobStatus == 'JOB_STATUS_WAITING' || _vm.jobStatus == 'JOB_STATUS_PENDING'))?_c('div',{staticClass:"form-group mb-0"},[(!_vm.isShowOnJobTypes([ 'AUDIT_STOCK' ]) )?_c('div',{staticClass:"input-group"},[_vm._m(21),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcodeForm.barcode),expression:"barcodeForm.barcode"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"กรอกบาร์โค้ด แล้ว Enter/คลิกปุ่มบันทึกบาร์โค้ด","rows":"3"},domProps:{"value":(_vm.barcodeForm.barcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.barcodeForm, "barcode", $event.target.value)}}})]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[(_vm.isEdit && !_vm.isShowOnJobTypes([ 'AUDIT_STOCK' ]) && (_vm.jobStatus == 'JOB_STATUS_WAITING' || _vm.jobStatus == 'JOB_STATUS_PENDING'))?_c('button',{staticClass:"btn btn-sm btn-warning",attrs:{"disabled":_vm.barcodeForm.isLoading || !_vm.barcodeForm.barcode,"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.submitBarcode($event)}}},[_c('i',{staticClass:"fa fa-barcode"}),_vm._v(" บันทึกบาร์โค้ด\n                          ")]):_vm._e(),_vm._v(" "),(_vm.isEdit && _vm.$route.meta.jobType == 'HOLD_CHECKER')?_c('a',{staticClass:"btn btn-sm btn-info",attrs:{"type":"button","target":"_blank","href":'/Print/HoldCheckerForm/' + _vm.$route.params.id}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" พิมพ์ใบ Hold (รับคืน)\n                          ")]):_vm._e(),_vm._v(" "),(_vm.scanBarcodeMessage)?[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onShowScanModal($event)}}},[_c('i',{staticClass:"text-info la la-list"}),_vm._v(" "+_vm._s(_vm.scanBarcodeMessage))])]:_vm._e()],2)]):_vm._e()])])])])])]):_vm._e(),_vm._v(" "),(
              _vm.showItems && _vm.$route.meta.jobType != 'AUDIT_STOCK' && 
                (_vm.isEdit || _vm.$route.meta.jobType != 'RETURN_ADHOC') &&
                _vm.$route.meta.jobType != 'NEW_SHOP' &&
                _vm.$route.meta.jobType != 'PM_CHECK' &&
                _vm.$route.meta.jobType != 'EDIT_NFC' &&
                _vm.$route.meta.jobType != 'INSPECTIONS_AND_BORROW_PROPERTY' &&
                _vm.$route.meta.jobType != 'QI_NO_EQUIPMENT' &&
                _vm.$route.meta.jobType != 'TYPING_BARCODE' &&
                _vm.$route.meta.jobType != 'QI_LESS_THAN_61' &&
                _vm.$route.meta.jobType != 'EDIT_SHOP' &&
                _vm.$route.meta.jobType != 'TRANSFER_TO_MULTI_SHOP' 
            )?_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(22),_vm._v(" "),_c('tbody',[(_vm.items == null || _vm.items.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"6"}},[_vm._v("\n                          คลิก + เพื่อเพิ่มรายการใหม่\n                        ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item,i){return [_c('job-item-row',{key:item.jobItemId,ref:"jobItems",refInFor:true,attrs:{"rowIndex":i,"item":item,"isEditable":_vm.isEditable && !item.isDisabled,"isEdit":_vm.isEdit,"jobType":_vm.$route.meta.jobType,"originLocationId":_vm.originLocationId,"originData":_vm.originData,"noUseSML":_vm.noUseSML,"parentJobType":_vm.parentJobType},on:{"removeItem":_vm.onRemoveItemClick,"showBarcode":_vm.onShowBarcodeClick}})]})],2),_vm._v(" "),_c('tfoot',[(this.isBeerClaimAdmin)?_c('tr',[_c('td',{attrs:{"colspan":"2"}},[(
                              _vm.isEditable &&
                                (_vm.$route.meta.jobType != 'RETURN_ADHOC' ||
                                  _vm.$route.meta.jobType != 'BEER_CLAIM')
                            )?_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                          ")]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"colspan":"1"}},[(_vm.isEdit && (_vm.jobStatus == 'JOB_STATUS_WAITING' || _vm.jobStatus == 'JOB_STATUS_PENDING'))?_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group"},[_vm._m(23),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcodeForm.barcode),expression:"barcodeForm.barcode"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"กรอกบาร์โค้ด แล้ว Enter/คลิกปุ่มบันทึกบาร์โค้ด","rows":"3"},domProps:{"value":(_vm.barcodeForm.barcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.barcodeForm, "barcode", $event.target.value)}}})])]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[(_vm.isEdit && (_vm.jobStatus == 'JOB_STATUS_WAITING' || _vm.jobStatus == 'JOB_STATUS_PENDING'))?_c('button',{staticClass:"btn btn-sm btn-warning",attrs:{"disabled":_vm.barcodeForm.isLoading || !_vm.barcodeForm.barcode,"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.submitBarcode($event)}}},[_c('i',{staticClass:"fa fa-barcode"}),_vm._v(" บันทึกบาร์โค้ด\n                          ")]):_vm._e(),_vm._v(" "),(_vm.isEdit && _vm.$route.meta.jobType == 'HOLD_CHECKER')?_c('a',{staticClass:"btn btn-sm btn-info",attrs:{"type":"button","target":"_blank","href":'/Print/HoldCheckerForm/' + _vm.$route.params.id}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" พิมพ์ใบ Hold (รับคืน)\n                          ")]):_vm._e(),_vm._v(" "),(_vm.scanBarcodeMessage)?[_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onShowScanModal($event)}}},[_c('i',{staticClass:"text-info la la-list"}),_vm._v(" "+_vm._s(_vm.scanBarcodeMessage))])]:_vm._e()],2)]):_vm._e()])])])])])]):_vm._e(),_vm._v(" "),(_vm.ItemHistory && _vm.ItemHistory.length > 0)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้า/ทรัพย์สิน")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(24),_vm._v(" "),_c('tbody',_vm._l((_vm.ItemHistory),function(item,i){return _c('tr',{key:'shop-return-item-' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_vm._v(_vm._s(item.materialName)+" ["+_vm._s(item.materialCode)+"]")]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',{staticClass:"form-group text-right"},[_vm._v("\n                          "+_vm._s(_vm._f("currency")(item.quantity,"", 0))+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.baseUnit))])])}),0)])])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.shopItems),function(shop,i){return _c('div',{key:'shop-' + i,staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title text-success"},[_c('i',{staticClass:"la la-shopping-cart"}),_vm._v(" รายการสินค้า/ทรัพย์สิน ที่จำหน่ายให้แก่ร้านค้า "),_c('strong',[_vm._v(_vm._s(shop.shopName))]),_vm._v(":\n            ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSmlBillNumber),expression:"showSmlBillNumber"}],staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เลขที่บิลขาย:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(shop.smlBillNumber),expression:"shop.smlBillNumber"}],staticClass:"form-control sml-bill-number required",attrs:{"id":'smlBillNumber_' + i,"name":'smlBillNumber_' + i,"type":"text","placeholder":"กรุณากรอกเลขที่บิลขาย"},domProps:{"value":(shop.smlBillNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(shop, "smlBillNumber", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"form-text"},[_vm._v("กรุณาสร้างบิลขายภายในระบบ SML เพื่อบันทึกปิดใบงานเร่ขาย")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showSmlBillNumber),expression:"!showSmlBillNumber"}],staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ร้านค้าในระบบ:")]),_vm._v(" "),_c('select2',{ref:"shopCodes",refInFor:true,attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'shopCode_' + i,"name":'shopCode_' + i,"select2-options":_vm.shopCodeOptions},model:{value:(shop.shopCode),callback:function ($$v) {_vm.$set(shop, "shopCode", $$v)},expression:"shop.shopCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ลายเซ็นต์ผู้รับสินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"max-width":"300px"},attrs:{"src":shop.signatureFileUrl}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(25,true),_vm._v(" "),_c('tbody',_vm._l((shop.items),function(item,i){return _c('tr',{key:'shop-item-' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_vm._v(_vm._s(item.materialName)+" ["+_vm._s(item.materialCode)+"]")]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',{staticClass:"form-group text-right"},[_vm._v("\n                          "+_vm._s(_vm._f("currency")(item.quantity,"", 0))+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.baseUnit))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(!_vm.isEditable)?_c('button',{staticClass:"btn btn-outline-hover-info btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"แสดงรายการบาร์โค้ด"},on:{"click":function($event){$event.preventDefault();return _vm.onShowLocalBarcodeClick(item)}}},[_c('i',{staticClass:"text-info la la-list"})]):_vm._e()])])}),0)])])])])])}),_vm._v(" "),(_vm.pickupItems && _vm.pickupItems.length > 0)?_c('div',{staticClass:"kt-section kt-section--first"},[_vm._m(26),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(27),_vm._v(" "),_c('tbody',_vm._l((_vm.pickupItems),function(item,i){return _c('tr',{key:'pickup-item-' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_vm._v(_vm._s(item.materialName)+" ["+_vm._s(item.materialCode)+"]")]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',{staticClass:"form-group text-right"},[_vm._v("\n                          "+_vm._s(_vm._f("currency")(item.quantity,"", 0))+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.baseUnit))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(!_vm.isEditable)?_c('button',{staticClass:"btn btn-outline-hover-info btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"แสดงรายการบาร์โค้ด"},on:{"click":function($event){$event.preventDefault();return _vm.onShowLocalBarcodeClick(item)}}},[_c('i',{staticClass:"text-info la la-list"})]):_vm._e()])])}),0)])])])])]):_vm._e(),_vm._v(" "),(_vm.pickupReturnItems && _vm.pickupReturnItems.length > 0)?_c('div',{staticClass:"kt-section kt-section--first"},[_vm._m(28),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(29),_vm._v(" "),_c('tbody',_vm._l((_vm.pickupReturnItems),function(item,i){return _c('tr',{key:'pickup-return-item-' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_vm._v(_vm._s(item.materialName)+" ["+_vm._s(item.materialCode)+"]")]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',{staticClass:"form-group text-right"},[_vm._v("\n                          "+_vm._s(_vm._f("currency")(item.quantity,"", 0))+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.baseUnit))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(!_vm.isEditable)?_c('button',{staticClass:"btn btn-outline-hover-info btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"แสดงรายการบาร์โค้ด"},on:{"click":function($event){$event.preventDefault();return _vm.onShowLocalBarcodeClick(item)}}},[_c('i',{staticClass:"text-info la la-list"})]):_vm._e()])])}),0)])])])])]):_vm._e(),_vm._v(" "),(_vm.shopReturnItems && _vm.shopReturnItems.length > 0)?_c('div',{staticClass:"kt-section kt-section--first"},[_vm._m(30),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(31),_vm._v(" "),_c('tbody',_vm._l((_vm.shopReturnItems),function(item,i){return _c('tr',{key:'shop-return-item-' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_vm._v(_vm._s(item.materialName)+" ["+_vm._s(item.materialCode)+"]")]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',{staticClass:"form-group text-right"},[_vm._v("\n                          "+_vm._s(_vm._f("currency")(item.quantity,"", 0))+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.baseUnit))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(!_vm.isEditable)?_c('button',{staticClass:"btn btn-outline-hover-info btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"แสดงรายการบาร์โค้ด"},on:{"click":function($event){$event.preventDefault();return _vm.onShowLocalBarcodeClick(item)}}},[_c('i',{staticClass:"text-info la la-list"})]):_vm._e()])])}),0)])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมายเหตุ:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remark),expression:"remark"}],staticClass:"form-control",attrs:{"readonly":!_vm.isEditable,"placeholder":"หมายเหตุ","rows":"5","maxlength":"1000"},domProps:{"value":(_vm.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.remark=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text text-muted text-right"},[_vm._v(_vm._s((_vm.remark || '').length)+" / 1000 อักษร")])])])]),_vm._v(" "),(_vm.signatureFileUrl)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ลายเซ็นต์ผู้รับสินค้า/ทรัพย์สิน: ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"max-width":"300px"},attrs:{"src":_vm.signatureFileUrl}})])])]):_vm._e(),_vm._v(" "),(_vm.evidenceRequired && _vm.evidenceCanPickFromGallery)?_c('div',{staticClass:"row"},[_vm._m(32)]):_vm._e(),_vm._v(" "),(_vm.evidenceFileName && _vm.evidenceRefCode)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รูปภาพหลักฐานการส่งมอบ (ยังไม่บันทึก):")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"max-width":"600px"},attrs:{"src":'/Plupload/' + _vm.evidenceRefCode + '/' + encodeURIComponent(_vm.evidenceFileName)}})])])]):_vm._e(),_vm._v(" "),(_vm.evidenceFileUrl)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รูปภาพหลักฐานการส่งมอบ:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"max-width":"600px"},attrs:{"src":_vm.evidenceFileUrl}})])])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 kt-align-right"},[_c('button',{staticClass:"btn btn-sm btn-clean kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("กลับ")])]),_vm._v(" "),(_vm.isEditable)?_c('button',{staticClass:"btn btn-sm btn-primary kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("บันทึกข้อมูล")])]):_vm._e(),_vm._v(" "),(_vm.canCommit())?_c('button',{staticClass:"btn btn-sm btn-success kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.commit($event)}}},[_c('i',{staticClass:"fa fa-archive"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("ปิดใบงาน")])]):_vm._e(),_vm._v(" "),(_vm.hasApproveProcess)?_c('button',{staticClass:"btn btn-sm btn-success kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.approvalProcess(true)}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("อนุมัติ")])]):_vm._e(),_vm._v(" "),(_vm.hasApproveProcess)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.approvalProcess(false)}}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("ไม่อนุมัติ")])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{ref:"barcodeModal",staticClass:"modal fade",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(33),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('span',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.selectedItem.materialName)+" ["+_vm._s(_vm.selectedItem.materialCode)+"]")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{ref:"barcodeTableWrapper",staticClass:"form-group",staticStyle:{"display":"none"}},[_c('table',{ref:"barcodeTable",staticClass:"table-sm table-striped table-bordered table-hover"},[_vm._m(34)])]),_vm._v(" "),_c('div',{ref:"barcodeTable2Wrapper",staticClass:"form-group"},[_c('table',{ref:"barcodeTable2",staticClass:"table-sm table-striped table-bordered table-hover"},[_vm._m(35)])])])])])])])])])]),_vm._v(" "),_c('div',{ref:"barcodeLocalModal",staticClass:"modal fade",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(36),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('span',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.localMaterialName)+" ["+_vm._s(_vm.localMaterialCode)+"]")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('table',{ref:"barcodeLocalTable",staticClass:"table-sm table-striped table-bordered table-hover"},[_vm._m(37)])])])])])])])])])]),_vm._v(" "),_c('div',{ref:"barcodeScanModal",staticClass:"modal fade",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(38),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('table',{ref:"barcodeScanTable",staticClass:"table-sm table-striped table-bordered table-hover",attrs:{"id":"barcodeScanTable"}},[_vm._m(39)])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-priceTier flaticon2-writing"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"25%"}},[_vm._v("สินค้า/ทรัพย์สิน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"8%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"kt-section__title"},[_c('i',{staticClass:"la la-truck"}),_vm._v(" ใบส่งสินค้า:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center font-weight-bold",staticStyle:{"padding":"8px","vertical-align":"middle"},attrs:{"width":"8%","rowspan":"2"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center font-weight-bold",staticStyle:{"padding":"8px","vertical-align":"middle"},attrs:{"width":"30%","rowspan":"2"}},[_vm._v("ปลายทาง")]),_vm._v(" "),_c('th',{staticClass:"text-center font-weight-bold",staticStyle:{"padding":"8px"},attrs:{"colspan":"3"}},[_vm._v("รายการสินค้า")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-center font-weight-bold",staticStyle:{"padding":"8px"},attrs:{"width":"35%"}},[_vm._v("สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center font-weight-bold",staticStyle:{"padding":"8px"},attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center font-weight-bold",staticStyle:{"padding":"8px"},attrs:{"width":"12%"}},[_vm._v("หน่วย")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right font-weight-bold"},[_c('span',{staticStyle:{"color":"#2015AB"}},[_vm._v("รวม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right",staticStyle:{"text-align":"center"},attrs:{"colspan":"2"}},[_c('span',{staticStyle:{"color":"#2015AB"}},[_vm._v("รวมทั้งหมด")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"5"}},[_vm._v("ไม่มีข้อมูลใบส่งสินค้า")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("สินค้า/ทรัพย์สิน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"8%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-barcode"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"30%"}},[_vm._v("ชื่อเอกสาร")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"30%"}},[_vm._v("ชื่อไฟล์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ประเภทไฟล์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"6"}},[_vm._v("\n                          คลิก\n                          "),_c('i',{staticClass:"fa fa-upload"}),_vm._v(" เพื่ออัพโหลดไฟล์เอกสาร เช่น ใบเสนอราคา หรือ ใบวางบิล เป็นต้น\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center align-middle",attrs:{"width":"5%","rowspan":"2"}},[_vm._v("\n                          ลำดับ\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%","rowspan":"2"}},[_vm._v("\n                          เลขที่ใบส่งสินค้า\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%","rowspan":"2"}},[_vm._v("\n                          วันที่เอกสาร\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"20%","rowspan":"2"}},[_vm._v("\n                          ปลายทาง (Ship To)\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"3"}},[_vm._v("รายการสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"8%","rowspan":"2"}},[_vm._v("\n                          คำสั่ง\n                        ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("หน่วย")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"8"}},[_vm._v("\n                          คลิก\n                          "),_c('i',{staticClass:"fa fa-upload"}),_vm._v(" เพื่อนำเข้าใบส่งสินค้า (Delivery Order)\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center align-middle",attrs:{"width":"5%","rowspan":"2"}},[_vm._v("\n                          ลำดับ\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%","rowspan":"2"}},[_vm._v("\n                          เลขที่เอกสาร\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%","rowspan":"2"}},[_vm._v("\n                          วันที่เอกสาร\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"20%","rowspan":"2"}},[_vm._v("\n                          ปลายทาง (Ship To)\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"3"}},[_vm._v("รายการสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"8%","rowspan":"2"}},[_vm._v("\n                          คำสั่ง\n                        ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("หน่วย")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"8"}},[_vm._v("\n                          คลิก\n                          "),_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพื่อเพิ่มบิลใหม่\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center align-middle",attrs:{"width":"5%","rowspan":"2"}},[_vm._v("\n                          ลำดับ\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%","rowspan":"2"}},[_vm._v("\n                          เลขที่เอกสาร\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%","rowspan":"2"}},[_vm._v("\n                          วันที่เอกสาร\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"20%","rowspan":"2"}},[_vm._v("\n                          ปลายทาง (Ship To)\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"3"}},[_vm._v("รายการสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"8%","rowspan":"2"}},[_vm._v("\n                          คำสั่ง\n                        ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("หน่วย")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"8"}},[_vm._v("\n                          คลิก\n                          "),_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพื่อเพิ่มรายการใหม่\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center align-middle",attrs:{"width":"5%","rowspan":"2"}},[_vm._v("\n                          ลำดับ\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%","rowspan":"2"}},[_vm._v("\n                          เลขที่เอกสาร\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%","rowspan":"2"}},[_vm._v("\n                          วันที่เอกสาร\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"20%","rowspan":"2"}},[_vm._v("\n                          สถานที่ต้นทาง (Origin)\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"20%","rowspan":"2"}},[_vm._v("\n                          สถานที่ปลายทาง (Destination)\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"3"}},[_vm._v("รายการสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"8%","rowspan":"2"}},[_vm._v("\n                          คำสั่ง\n                        ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("หน่วย")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%"}},[_vm._v("\n                          เลขที่ใบคำร้อง\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%"}},[_vm._v("\n                          วันที่เอกสาร\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"20%"}},[_vm._v("\n                          ประเภทใบคำร้อง\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%"}},[_vm._v("\n                          หมวดหมู่\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%"}},[_vm._v("\n                          มูลค่ารวม\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"20%"}},[_vm._v("\n                          ตัวแทนจำหน่าย / หน่วยงาน\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"20%"}},[_vm._v("\n                          ผู้ขอเบิกยืม\n                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"25%"}},[_vm._v("สถานะ BARCODE")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"25%"}},[_vm._v("\n                          สินค้า/ทรัพย์สิน\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("หมายเหตุ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"8%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-barcode"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"25%"}},[_vm._v("\n                          สินค้า/ทรัพย์สิน\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"8%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-barcode"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"25%"}},[_vm._v("\n                          สินค้า/ทรัพย์สิน\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("หน่วย")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"25%"}},[_vm._v("\n                          สินค้า/ทรัพย์สิน\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"8%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"kt-section__title text-danger"},[_c('i',{staticClass:"la la-warning"}),_vm._v(" รายการสินค้า/ทรัพย์สิน นำออกจากคลัง (ยังไม่ได้ขาย):")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"25%"}},[_vm._v("\n                          สินค้า/ทรัพย์สิน\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"8%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"kt-section__title text-info"},[_c('i',{staticClass:"la la-check-square"}),_vm._v(" รายการสินค้า/ทรัพย์สิน นำออกจากคลัง (ยังไม่ได้ขาย) และนำกลับมาคืนแล้ว:\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"25%"}},[_vm._v("\n                          สินค้า/ทรัพย์สิน\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"8%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"kt-section__title text-info"},[_c('i',{staticClass:"la la-reply-all"}),_vm._v(" รายการสินค้า/ทรัพย์สิน ที่รับคืนจากร้านค้า:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"25%"}},[_vm._v("\n                          สินค้า/ทรัพย์สิน\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"8%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button","id":"uploader-evidence"}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v(" รูปภาพหลักฐาน\n              ")]),_vm._v(" "),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v(" (เลือกได้เฉพาะสกุลไฟล์ JPG, JPEG, PNG ขนาดไม่เกิน 10Mb.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("รายการบาร์โค้ด")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้ถือครองก่อนหน้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้ดูแล(ตัวแทนฯ)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะบาร์โค้ด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เวลาสแกน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("โดย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("คำสั่ง")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("รายการอะไหล่")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เวลาสแกน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("โดย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("คำสั่ง")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("รายการอะไหล่")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("รายการบาร์โค้ด")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เวลาสแกน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("โดย")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("รายการบาร์โค้ดที่เกิดข้อผิดพลาด")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")])])])}]


/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
        _vm.$route.path != '/Machine/ManageMachineTransaction/ImportMachine'
      ),expression:"\n        $route.path != '/Machine/ManageMachineTransaction/ImportMachine'\n      "}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MbKeyword),expression:"MbKeyword"}],staticClass:"form-control",attrs:{"id":"MbKeyword","name":"MbKeyword","type":"text","placeholder":"รหัสอ้างอิง ชื่อเฟส เลขล็อต รหัส BARCODE รหัสสินค้า รหัส RefCode เลขที่ PO"},domProps:{"value":(_vm.MbKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MbKeyword=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['ADMIN_EQUIPMENT_LEASING']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManageMachineTransaction/ImportMachine","tag":"button","title":"เพิ่มข้อมูล เครื่องเช่า(Excel)"}},[_c('i',{staticClass:"fas fa-file-import"}),_vm._v(" Import\n              ")]):_vm._e(),_vm._v(" "),(this.$root.canShow(['ADMIN_EQUIPMENT_LEASING']))?_c('button',{staticClass:"btn btn-outline-brand",attrs:{"tag":"button","title":"ดาวน์โหลด Template เครื่องเช่า"},on:{"click":_vm.downloadTemplate}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Template\n              ")]):_vm._e(),_vm._v(" "),(this.$root.canShow(['ADMIN_EQUIPMENT_LEASING']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManageMachineTransaction/Download","tag":"button","title":"ดาวน์โหลด เครื่องเช่า"}},[_c('i',{staticClass:"fas fa-file-export"}),_vm._v(" Download\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-barcode"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"machineTransactionTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("Phase")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("Lot")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวนงวด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เลขที่ PO")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ราคาของเครื่องประเภท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่ติดตั้ง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่เริ่มสัญญาเช่า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่หมดสัญญาเช่า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสอ้างอิง")])])])])])])}]


/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/ProduceProducts'),expression:"$route.path == '/Report/ProduceProducts'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"rePpJobDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"rePpJobDateStart","name":"rePpJobDateStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"rePpJobDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"rePpJobDateEnd","name":"rePpJobDateEnd"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่เอกสาร:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rePpJobNumber),expression:"rePpJobNumber"}],staticClass:"form-control",attrs:{"type":"text","rows":"1","placeholder":"ค้นหาจาก เลขที่เอกสาร"},domProps:{"value":(_vm.rePpJobNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rePpJobNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อายุน้ำเบียร์คงเหลือ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rePpRemainingDays),expression:"rePpRemainingDays"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุอายุน้ำเบียร์คงเหลือ"},domProps:{"value":(_vm.rePpRemainingDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rePpRemainingDays=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rePpBarcode),expression:"rePpBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.rePpBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rePpBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadrePpDepartmentMaterialCodeOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.rePpDepartmentMaterialCode),callback:function ($$v) {_vm.rePpDepartmentMaterialCode=$$v},expression:"rePpDepartmentMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมวดสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePpProductGroupOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePpProductGroup),callback:function ($$v) {_vm.rePpProductGroup=$$v},expression:"rePpProductGroup"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePpProductTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePpProductType),callback:function ($$v) {_vm.rePpProductType=$$v},expression:"rePpProductType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePpMaterialCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePpMaterialCode),callback:function ($$v) {_vm.rePpMaterialCode=$$v},expression:"rePpMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePpProductBrandOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePpProductBrand),callback:function ($$v) {_vm.rePpProductBrand=$$v},expression:"rePpProductBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ดำเนินการโดย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePpByUserOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePpByUser),callback:function ($$v) {_vm.rePpByUser=$$v},expression:"rePpByUser"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow([''])),expression:"this.$root.canShow([''])"}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("โรงงานที่ผลิต:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePpPlantOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePpPlant),callback:function ($$v) {_vm.rePpPlant=$$v},expression:"rePpPlant"}})],1)])]),_vm._v(" "),(this.$root.canShow(['BR_REPORT']))?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportProduceProducts}},[_vm._m(3)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"produceProductTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"18"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.rePpDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่เอกสาร")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่เอกสาร")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่สแกน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เดือน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ดำเนินการโดย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("โรงงานที่ผลิต")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("อายุน้ำเบียร์ (เดือน)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("อายุน้ำเบียร์คงเหลือ (วัน)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันหมดอายุน้ำเบียร์")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("หมวดหมู่สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์")])])}]


/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.CheckRoute()),expression:"CheckRoute()"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[(this.$root.canShow(['ADMIN_5S', 'MANAGER_5S']))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.melKeyword),expression:"melKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อหมวดหมู่"},domProps:{"value":(_vm.melKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.melKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"melInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'melInActiveStatus',"name":'melInActiveStatus',"select2-options":_vm.melInActiveStatusOptions},model:{value:(_vm.melInActiveStatus),callback:function ($$v) {_vm.melInActiveStatus=$$v},expression:"melInActiveStatus"}})],1)])]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.melKeyword),expression:"melKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อหมวดหมู่"},domProps:{"value":(_vm.melKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.melKeyword=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['ADMIN_5S', 'MANAGER_5S']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"E-Learning/AddFolder","tag":"button","title":"เพิ่ม"}},[_c('i',{staticClass:"fa fa-folder-plus"}),_vm._v(" เพิ่มหมวดหมู่\n              ")]):_vm._e()],1)])]),_vm._v(" "),(this.$root.canShow(['COMPANY_PROFILE_TYPE_AGENT']))?_c('div',{staticClass:"row"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(!this.$root.canShow(['COMPANY_PROFILE_TYPE_AGENT']))?_c('div',{staticClass:"row"},[_vm._m(2)]):_vm._e()])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"folderTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("หมวดหมู่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้บันทึก")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่บันทึกล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"folderTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("หมวดหมู่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้บันทึก")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่บันทึกล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])}]


/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('router-link',{staticClass:"btn btn-sm btn-clean btn-icon-sm",attrs:{"to":"/Monitoring/ScheduledJobs"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Scheduled Jobs\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 mb-4"},[_c('div',{staticClass:"kt-portlet kt-portlet--height-fluid",staticStyle:{"border":"1px solid #ebedf2"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-5 col-form-label"},[_vm._v("ตั้งแต่ (ปี / เดือน)")]),_vm._v(" "),_c('div',{staticClass:"col-7 d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.bf.fromYear),expression:"bf.fromYear",modifiers:{"number":true}}],staticClass:"form-control mr-2",attrs:{"type":"number","placeholder":"ปี"},domProps:{"value":(_vm.bf.fromYear)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bf, "fromYear", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.bf.fromMonth),expression:"bf.fromMonth",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"12","placeholder":"1-12"},domProps:{"value":(_vm.bf.fromMonth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bf, "fromMonth", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-5 col-form-label"},[_vm._v("ถึง (ปี / เดือน)")]),_vm._v(" "),_c('div',{staticClass:"col-7 d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.bf.toYear),expression:"bf.toYear",modifiers:{"number":true}}],staticClass:"form-control mr-2",attrs:{"type":"number","placeholder":"ปี"},domProps:{"value":(_vm.bf.toYear)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bf, "toYear", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.bf.toMonth),expression:"bf.toMonth",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"12","placeholder":"1-12"},domProps:{"value":(_vm.bf.toMonth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bf, "toMonth", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-5 col-form-label"},[_vm._v("force (re-close)")]),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('label',{staticClass:"kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bf.force),expression:"bf.force"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.bf.force)?_vm._i(_vm.bf.force,null)>-1:(_vm.bf.force)},on:{"change":function($event){var $$a=_vm.bf.force,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.bf, "force", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.bf, "force", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.bf, "force", $$c)}}}}),_vm._v(" ทับเดือนที่ปิดแล้ว "),_c('span')])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"disabled":_vm.bf.running},on:{"click":_vm.runBackfill}},[_c('i',{staticClass:"fa fa-play"}),_vm._v(" "+_vm._s(_vm.bf.running ? "กำลังรัน..." : "รัน Backfill")+"\n            ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted mt-2"},[_vm._v("\n              * ไม่ปิดเดือนปัจจุบัน/อนาคต (guard) · idempotent ถ้าไม่ติ๊ก force\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 mb-4"},[_c('div',{staticClass:"kt-portlet kt-portlet--height-fluid",staticStyle:{"border":"1px solid #ebedf2"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-5 col-form-label"},[_vm._v("ปี / เดือน")]),_vm._v(" "),_c('div',{staticClass:"col-7 d-flex"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.cp.year),expression:"cp.year",modifiers:{"number":true}}],staticClass:"form-control mr-2",attrs:{"type":"number","placeholder":"ปี"},domProps:{"value":(_vm.cp.year)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cp, "year", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.cp.month),expression:"cp.month",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"12","placeholder":"1-12"},domProps:{"value":(_vm.cp.month)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cp, "month", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-5 col-form-label"},[_vm._v("force (re-close)")]),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('label',{staticClass:"kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cp.force),expression:"cp.force"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.cp.force)?_vm._i(_vm.cp.force,null)>-1:(_vm.cp.force)},on:{"change":function($event){var $$a=_vm.cp.force,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.cp, "force", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.cp, "force", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.cp, "force", $$c)}}}}),_vm._v(" ทับถ้าปิดแล้ว "),_c('span')])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-block",attrs:{"disabled":_vm.cp.running},on:{"click":_vm.runClose}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" "+_vm._s(_vm.cp.running ? "กำลังรัน..." : "ปิดรอบเดือนนี้")+"\n            ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted mt-2"},[_vm._v("\n              * ปิดได้เฉพาะเดือนที่จบแล้ว (guard เดือนปัจจุบัน/อนาคต)\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet kt-portlet--height-fluid mt-2",staticStyle:{"border":"1px solid #ebedf2"}},[_c('div',{staticClass:"kt-portlet__head"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_c('i',{staticClass:"fa fa-table"}),_vm._v("  สถานะ Period ("+_vm._s(_vm.periods.length)+")")])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.periodYear),expression:"periodYear",modifiers:{"number":true}}],staticClass:"form-control form-control-sm mr-2",staticStyle:{"width":"110px","display":"inline-block"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.periodYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.loadPeriods]}},[_c('option',{domProps:{"value":0}},[_vm._v("ทุกปี")]),_vm._v(" "),_vm._l((_vm.yearOptions),function(y){return _c('option',{key:y,domProps:{"value":y}},[_vm._v(_vm._s(y))])})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-clean btn-icon-sm",attrs:{"disabled":_vm.loading},on:{"click":_vm.loadPeriods}},[_c('i',{staticClass:"fa fa-sync",class:{ 'fa-spin': _vm.loading }}),_vm._v(" รีเฟรช\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered"},[_vm._m(4),_vm._v(" "),_c('tbody',[(_vm.periods.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"5"}},[_vm._v("— ยังไม่มี period ที่ปิด —")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.periods),function(p){return _c('tr',{key:p.year + '-' + p.month},[_c('td',[_vm._v(_vm._s(p.year))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(p.month))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge",class:p.status === 'CLOSED' ? 'badge-success' : 'badge-secondary'},[_vm._v(_vm._s(p.status))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(p.snapshotRowCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.fmtDate(p.closedDate)))])])})],2)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n        Stock Cover Days — Monthly Snapshot (Manual Ops)\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-secondary",staticStyle:{"font-size":"13px"},attrs:{"role":"alert"}},[_c('b',[_vm._v("รันงาน Monthly Snapshot ด้วยตนเอง")]),_vm._v(" — สำหรับผู้ดูแล (MonitorEmail) เท่านั้น ·\n      "),_c('b',[_vm._v("Backfill")]),_vm._v(" = ปิดรอบย้อนหลังเป็นช่วง · "),_c('b',[_vm._v("Close Period")]),_vm._v(" = ปิดรอบทีละเดือน ·\n      "),_c('b',[_vm._v("force")]),_vm._v(" = re-close ทับเดือนที่ปิดแล้ว (คำนวณใหม่จาก Target/Jobs ปัจจุบัน · config ยัง frozen)\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_c('i',{staticClass:"fa fa-history text-primary"}),_vm._v("  Backfill (ช่วงเดือน)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_c('i',{staticClass:"fa fa-lock text-success"}),_vm._v("  Close Period (เดือนเดียว)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("ปี")]),_c('th',[_vm._v("เดือน")]),_c('th',[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("snapshot rows")]),_c('th',[_vm._v("ปิดเมื่อ")])])])}]


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"templateBarcodeModal","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อเจ้าของทรัพย์สิน:")]),_vm._v(" "),_c('select2',{ref:"tpbAssetOwnerSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'tpbAssetOwnerId',"name":'tpbAssetOwnerId',"select2-options":_vm.tpbAssetOwnerOptions},model:{value:(_vm.tpbAssetOwnerId),callback:function ($$v) {_vm.tpbAssetOwnerId=$$v},expression:"tpbAssetOwnerId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สินค้า:")]),_vm._v(" "),_c('select2',{ref:"tpbProductSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'tpbProductId',"name":'tpbProductId',"select2-options":_vm.tpbProductOptions},model:{value:(_vm.tpbProductId),callback:function ($$v) {_vm.tpbProductId=$$v},expression:"tpbProductId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Supplier:")]),_vm._v(" "),_c('select2',{ref:"tpbVendorIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'tpbVendorId',"name":'tpbVendorId',"select2-options":_vm.tpbVendorOptions},model:{value:(_vm.tpbVendorId),callback:function ($$v) {_vm.tpbVendorId=$$v},expression:"tpbVendorId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("จำนวน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qty),expression:"qty"}],staticClass:"form-control",attrs:{"id":"qty","name":"qty","type":"number","min":"1","maxlength":"256","placeholder":"จำนวน"},domProps:{"value":(_vm.qty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qty=$event.target.value}}})])])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" ดาวน์โหลด\n          ")])])}]


/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/ShopAssets'),expression:"$route.path == '/Report/ShopAssets'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"reSaAgentCode",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'reSaAgentCode',"name":'reSaAgentCode',"select2-options":_vm.reSaAgentCodeOptions},on:{"selectChange":_vm.OnChangeAgentCode},model:{value:(_vm.reSaAgentCode),callback:function ($$v) {_vm.reSaAgentCode=$$v},expression:"reSaAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['AGENT_REPORT', 'BR_REPORT'])),expression:"this.$root.canShow(['AGENT_REPORT', 'BR_REPORT'])"}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reSaShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reSaShopTypeId),callback:function ($$v) {_vm.reSaShopTypeId=$$v},expression:"reSaShopTypeId"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['AGENT_REPORT'])),expression:"this.$root.canShow(['AGENT_REPORT'])"}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('treeselect',{ref:"reSaShopName",attrs:{"multiple":true,"load-options":_vm.LoadreSaShopNameOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect,"open":_vm.reLoadSaShopNameOptions},model:{value:(_vm.reSaShopName),callback:function ($$v) {_vm.reSaShopName=$$v},expression:"reSaShopName"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reSaProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reSaProductTypeId),callback:function ($$v) {_vm.reSaProductTypeId=$$v},expression:"reSaProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reSaBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reSaBrandId),callback:function ($$v) {_vm.reSaBrandId=$$v},expression:"reSaBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reSaAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reSaAssetCode),callback:function ($$v) {_vm.reSaAssetCode=$$v},expression:"reSaAssetCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.ExportShopAssets($event)}}},[_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"shopAssetTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"12"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reSbsDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(2)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("หน่วยนับ")])])}]


/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PrintSummary/Barcodes/New'),expression:"$route.path == '/PrintSummary/Barcodes/New'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"kt-separator kt-separator--border-dashed kt-separator--space-sm"}),_vm._v(" "),_c('form',{ref:"filterForm",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1 label-required"},[_vm._v("\n                ชื่อตัวแทนจำหน่าย:\n                "),(_vm.agentCodeCount > 0)?_c('small',{staticClass:"text-muted"},[_vm._v("\n                  (เลือกแล้ว "+_vm._s(_vm.agentCodeCount)+" ราย)\n                ")]):_vm._e()]),_vm._v(" "),_c('treeselect',{ref:"reBHostAgentCode",attrs:{"multiple":true,"options":_vm.reBHostAgentCodeOptions,"disabled":_vm.isGroupSelected,"clear-on-select":true,"placeholder":"กรุณาเลือกผู้ดูแลร้านค้า(ตัวแทน)"},model:{value:(_vm.reBHostAgentCode),callback:function ($$v) {_vm.reBHostAgentCode=$$v},expression:"reBHostAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1 label-required"},[_vm._v("\n                ตัวแทนจำหน่าย (Group):\n                "),(_vm.groupCodeCount > 0)?_c('small',{staticClass:"text-muted"},[_vm._v("\n                  (เลือกแล้ว "+_vm._s(_vm.groupCodeCount)+" ราย)\n                ")]):_vm._e()]),_vm._v(" "),_c('treeselect',{ref:"HeadAgentCode",attrs:{"multiple":true,"options":_vm.HeadAgentCodeOptions,"disabled":_vm.isAgentSelected,"clear-on-select":true,"placeholder":"กรุณาเลือกสำนักงานใหญ่ (Group)"},model:{value:(_vm.HeadAgentCode),callback:function ($$v) {_vm.HeadAgentCode=$$v},expression:"HeadAgentCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('input',{attrs:{"type":"hidden","id":"fssCreate_requiredFilter","name":"fssCreate_requiredFilter"},domProps:{"value":_vm.requiredFilterValue}})])]),_vm._v(" "),_c('div',{staticClass:"kt-separator kt-separator--border-dashed kt-separator--space-sm"}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("เจ้าของทรัพย์สิน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.AssetOwnerOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.AssetOwnerId),callback:function ($$v) {_vm.AssetOwnerId=$$v},expression:"AssetOwnerId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("หมุนเวียน/ไม่หมุนเวียน:")]),_vm._v(" "),_c('treeselect',{ref:"Circulate",attrs:{"id":"Circulate","multiple":true,"options":_vm.CirculateOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.Circulate),callback:function ($$v) {_vm.Circulate=$$v},expression:"Circulate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ช่วงคงค้าง:")]),_vm._v(" "),_c('treeselect',{ref:"PeriodRange",attrs:{"id":"PeriodRange","multiple":true,"options":_vm.PeriodRangeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.PeriodRange),callback:function ($$v) {_vm.PeriodRange=$$v},expression:"PeriodRange"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ปี(สินค้า):")]),_vm._v(" "),_c('treeselect',{ref:"BarcodeYear",attrs:{"multiple":true,"load-options":_vm.LoadBarcodeYearOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadBarcodeYearOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.BarcodeYear),callback:function ($$v) {_vm.BarcodeYear=$$v},expression:"BarcodeYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ปีคงค้าง:")]),_vm._v(" "),_c('treeselect',{ref:"PeriodYear",attrs:{"id":"PeriodYear","multiple":true,"options":_vm.PeriodYearOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.PeriodYear),callback:function ($$v) {_vm.PeriodYear=$$v},expression:"PeriodYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBProductTypeId),callback:function ($$v) {_vm.reBProductTypeId=$$v},expression:"reBProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBAssetCode),callback:function ($$v) {_vm.reBAssetCode=$$v},expression:"reBAssetCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"kt-separator kt-separator--border-dashed kt-separator--space-sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-sm btn-clean kt-margin-r-10",attrs:{"type":"button"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("กลับ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n              ล้างข้อมูล\n            ")])]),_vm._v(" "),_vm._m(4)])])])]),_vm._v(" "),(_vm.isOnFilterStep)?_c('FormSummaryStockProgressModal',{ref:"progressModal",on:{"finished":_vm.onProcessFinished}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-file-alt"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          เพิ่มสรุปสินค้าคงค้าง\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"fss-stepper"},[_c('div',{staticClass:"fss-step fss-step--active"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("เลือก Filter")])]),_vm._v(" "),_c('div',{staticClass:"fss-connector"}),_vm._v(" "),_c('div',{staticClass:"fss-step"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("ตรวจสอบข้อมูล")])]),_vm._v(" "),_c('div',{staticClass:"fss-connector"}),_vm._v(" "),_c('div',{staticClass:"fss-step"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("บันทึก + พิมพ์")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"kt-font-bold kt-margin-b-10"},[_vm._v("\n              Filter บังคับ\n              "),_c('small',{staticClass:"text-muted"},[_vm._v("\n                (เลือกอย่างใดอย่างหนึ่งเท่านั้น · เลือกได้หลายตัวแทนจำหน่าย —\n                เลือก 2 รายขึ้นไป = สร้างเอกสารรวม)\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"kt-font-bold kt-margin-b-10"},[_vm._v("\n              Filter ไม่บังคับ\n              "),_c('small',{staticClass:"text-muted"},[_vm._v("\n                (เลือกได้มากกว่า 1 ค่า · ไม่เลือก = ไม่กรอง)\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n              ประมวลผล →\n            ")])])}]


/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/PMMonthly'),expression:"$route.path == '/PMReport/PMMonthly'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เดือน:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reMonthCode',"name":'reMonthCode',"select2-options":_vm.reMonthOptions},model:{value:(_vm.reMonthCode),callback:function ($$v) {_vm.reMonthCode=$$v},expression:"reMonthCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ปี :")]),_vm._v(" "),_c('select2',{ref:"reYear",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reYear',"name":'reYear',"select2-options":_vm.reYearOptions},model:{value:(_vm.reYear),callback:function ($$v) {_vm.reYear=$$v},expression:"reYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reDepartments',"name":'reDepartments',"select2-options":_vm.reDepartmentsOptions},on:{"selectChange":_vm.onDepartmentChange},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAgentCodes',"name":'reAgentCodes',"select2-options":_vm.reAgentCodesOptions},on:{"selectChange":function($event){return _vm.onReAgentCodesChange()}},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อช่างตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reUserId',"name":'reUserId',"select2-options":_vm.reUserIdOptions},model:{value:(_vm.reUserId),callback:function ($$v) {_vm.reUserId=$$v},expression:"reUserId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrSubAgentCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentCodes',"name":'pmrSubAgentCodes',"select2-options":_vm.pmrSubAgentCodeOptions,"multiple":""},on:{"selectChange":function($event){return _vm.onReSubAgentCodesChange()}},model:{value:(_vm.pmrSubAgentCodes),callback:function ($$v) {_vm.pmrSubAgentCodes=$$v},expression:"pmrSubAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อช่างตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reSubAgentUserId',"name":'reSubAgentUserId',"select2-options":_vm.reSubAgentUserIdOptions},model:{value:(_vm.reSubAgentUserId),callback:function ($$v) {_vm.reSubAgentUserId=$$v},expression:"reSubAgentUserId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"MonthlyTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"10"}},[_vm._v("ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq))])]),_vm._v(" "),_vm._m(1)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนครั้งที่ทำ PM ทั้งหมด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รวม Alert เกินกำหนด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รวม Alert ก่อนครบกำหนด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อช่าง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนครั้งที่ทำ PM รายช่าง")])])}]


/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ขอเบิก/ยืม:")]),_vm._v(" "),_c('select2',{ref:"cbpBorrowerSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'cbpBorrower',"name":'cbpBorrower',"select2-options":_vm.cbpBorrowerOptions,"data-msg-required":"กรุณาเลือกผู้ขอเบิก/ยืม"},on:{"selectChange":_vm.cbpBorrowerChange},model:{value:(_vm.cbpBorrower),callback:function ($$v) {_vm.cbpBorrower=$$v},expression:"cbpBorrower"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย/หน่วยงาน:")]),_vm._v(" "),_c('select2',{ref:"cbpAgentCode",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'cbpAgentCode',"name":'cbpAgentCode',"select2-options":_vm.cbpAgentCodeOptions,"data-msg-required":"กรุณาเลือกตัวแทนจำหน่าย/หน่วยงาน"},on:{"selectChange":_vm.onAgentCodeChange},model:{value:(_vm.cbpAgentCode),callback:function ($$v) {_vm.cbpAgentCode=$$v},expression:"cbpAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"cbpRequestDate",staticClass:"form-control",attrs:{"disabled":"true","type":"text","id":"cbpRequestDate","name":"cbpRequestDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้รับสินค้าแทน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cbpRecipientInsteadName),expression:"cbpRecipientInsteadName"}],staticClass:"form-control",attrs:{"id":"cbpRecipientInsteadName","name":"cbpRecipientInsteadName","type":"text","maxlength":"450","placeholder":"ชื่อ-สกุลผู้รับสินค้าแทน"},domProps:{"value":(_vm.cbpRecipientInsteadName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cbpRecipientInsteadName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทรผู้รับสินค้าแทน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cbpRecipientInsteadTel),expression:"cbpRecipientInsteadTel"}],staticClass:"form-control",attrs:{"id":"cbpRecipientInsteadTel","name":"cbpRecipientInsteadTel","type":"text","maxlength":"450","placeholder":"เบอร์โทรผู้รับสินค้าแทน"},domProps:{"value":(_vm.cbpRecipientInsteadTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cbpRecipientInsteadTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-3 col-form-label label-required"},[_vm._v("ประเภทใบคำร้องขอ:")]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"kt-checkbox-inline"},_vm._l((_vm.cbpRequestTypeOptions),function(plRequestTypeOption,pl){return _c('label',{key:pl,staticClass:"kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cbpRequestType),expression:"cbpRequestType"}],attrs:{"type":"checkbox","id":'cbpRequestType',"name":'cbpRequestType'},domProps:{"value":plRequestTypeOption.id,"checked":Array.isArray(_vm.cbpRequestType)?_vm._i(_vm.cbpRequestType,plRequestTypeOption.id)>-1:(_vm.cbpRequestType)},on:{"change":[function($event){var $$a=_vm.cbpRequestType,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=plRequestTypeOption.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cbpRequestType=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cbpRequestType=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cbpRequestType=$$c}},function($event){return _vm.onProductTypeChange($event)}]}}),_vm._v(" "),_c('span'),_vm._v("\n                      "+_vm._s(plRequestTypeOption.text)+"\n                    ")])}),0),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-3 col-form-label label-required"},[_vm._v("หมวดหมู่สินค้า:")]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"kt-radio-inline"},_vm._l((_vm.cbpProductGroupOptions),function(plProductGroupOption,pl){return _c('label',{key:pl,staticClass:"kt-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cbpProductGroupCode),expression:"cbpProductGroupCode"}],attrs:{"type":"radio","id":'cbpProductGroupCode',"name":'cbpProductGroupCode'},domProps:{"value":plProductGroupOption.id,"checked":_vm._q(_vm.cbpProductGroupCode,plProductGroupOption.id)},on:{"change":[function($event){_vm.cbpProductGroupCode=plProductGroupOption.id},function($event){return _vm.onProductGroupChange($event)}]}}),_vm._v(" "),_c('span'),_vm._v("\n                      "+_vm._s(plProductGroupOption.text)+"\n                    ")])}),0),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 table-responsive table-checkable",attrs:{"id":"Activity"}},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover",staticStyle:{"min-width":"2250px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"1%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"6%"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"8%"}},[_vm._v("\n                      ประเภทสินค้า\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"13%"}},[_vm._v("\n                      ชื่อสินค้า\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"6%"}},[_vm._v("\n                      รูปภาพ\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"6%"}},[_vm._v("\n                      โควต้า(แบรนด์)\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"5%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("\n                      ตัวแทนจำหน่าย\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"18%"}},[_vm._v("\n                      ชื่อร้านค้า/กิจกรรม\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%"}},[_vm._v("\n                        หมายเหตุกิจกรรม\n                        "),_c('i',{staticClass:"far fa-copy",staticStyle:{"cursor":"pointer","margin-left":"5px","transform":"scaleX(-1)","color":"#5867dd"},attrs:{"title":"คัดลอกข้อความ \"หมายเหตุกิจกรรม\" ของแถวที่1"},on:{"click":_vm.copyNote}})]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"160px !important"}},[_vm._v("\n                      วันที่กำหนดคืน\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"2%"}},[_vm._v("การจัดการ")])])]),_vm._v(" "),_c('tbody',[(_vm.plItems == null || _vm.plItems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"12"}},[_vm._v("\n                      คลิก + เพื่อเพิ่มรายการใหม่\n                    ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.plItems),function(item,i){return [_c('pl-item-row',{key:i,ref:"plItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticStyle:{"text-align":"right"},attrs:{"colspan":"5"}},[_vm._v("\n                      จำนวนรวมมูลค่าการเบิกยืม (บาท)\n                    ")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("\n                      "+_vm._s(_vm._f("currency")(_vm.totalCal,"฿", 2))+"\n                    ")])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"12"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                      ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมายเหตุ:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.cbpRemark),expression:"cbpRemark"}],staticClass:"form-control",attrs:{"placeholder":"หมายเหตุ","rows":"5"},domProps:{"value":(_vm.cbpRemark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cbpRemark=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_vm._m(2)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])}]


/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PM/PMRoutePlan'),expression:"$route.path == '/PM/PMRoutePlan'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pmrSearch),expression:"pmrSearch"}],staticClass:"form-control",attrs:{"id":"pmrSearch","name":"pmrSearch","type":"text","placeholder":"ค้นหาจากชื่อตัวแทนจำหน่าย หรือชื่อร้านค้า"},domProps:{"value":(_vm.pmrSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pmrSearch=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"pmrStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"pmrStartDate","name":"pmrStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"pmrEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"pmrEndDate","name":"pmrEndDate"}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ประเภท:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrTypeCode',"name":'pmrTypeCode',"select2-options":_vm.pmrTypeCodeOptions},model:{value:(_vm.pmrTypeCode),callback:function ($$v) {_vm.pmrTypeCode=$$v},expression:"pmrTypeCode"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.pmrAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.pmrAgentCodes),callback:function ($$v) {_vm.pmrAgentCodes=$$v},expression:"pmrAgentCodes"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrShopCodes',"name":'pmrShopCodes',"select2-options":_vm.pmrShopCodesOptions,"multiple":""},model:{value:(_vm.pmrShopCodes),callback:function ($$v) {_vm.pmrShopCodes=$$v},expression:"pmrShopCodes"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin', 'ADMIN_PM'])),expression:"this.$root.canShow(['super_admin', 'ADMIN_PM'])"}],staticClass:"text-danger"},[_vm._v("\n                  *ควรเลือกตัวแทนจำหน่ายด้วย\n                ")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrSubAgentCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentCodes',"name":'pmrSubAgentCodes',"select2-options":_vm.pmrSubAgentCodeOptions,"multiple":""},model:{value:(_vm.pmrSubAgentCodes),callback:function ($$v) {_vm.pmrSubAgentCodes=$$v},expression:"pmrSubAgentCodes"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentShopCodes',"name":'pmrSubAgentShopCodes',"select2-options":_vm.pmrSubAgentShopCodesOptions,"multiple":""},model:{value:(_vm.pmrSubAgentShopCodes),callback:function ($$v) {_vm.pmrSubAgentShopCodes=$$v},expression:"pmrSubAgentShopCodes"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin', 'ADMIN_PM'])),expression:"this.$root.canShow(['super_admin', 'ADMIN_PM'])"}],staticClass:"text-danger"},[_vm._v("\n                  *ควรเลือกตัวแทนจำหน่ายย่อยด้วย\n                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ชื่อรูท:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pmrRouteName),expression:"pmrRouteName"}],ref:"pmrRouteName",staticClass:"form-control",attrs:{"type":"text","placeholder":"ชื่อรูท","id":"pmrRouteName","name":"pmrRouteName"},domProps:{"value":(_vm.pmrRouteName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pmrRouteName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('select2',{ref:"pmrPmUserIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrPmUserId',"name":'pmrPmUserId',"select2-options":_vm.pmrPmUserIdOptions,"multiple":""},model:{value:(_vm.pmrPmUserId),callback:function ($$v) {_vm.pmrPmUserId=$$v},expression:"pmrPmUserId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label mb-1"},[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"pmrInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrInActiveStatus',"name":'pmrInActiveStatus',"select2-options":_vm.pmrInActiveStatusOptions},model:{value:(_vm.pmrInActiveStatus),callback:function ($$v) {_vm.pmrInActiveStatus=$$v},expression:"pmrInActiveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportRoutePlan}},[_vm._m(3)]),_vm._v(" "),(
                  this.$root.canShow([
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM',
                    'COOL_SERVICE_PM','SUB_AGENT_ADMIN_PM'
                  ])
                )?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"PMRoutePlan/Add","tag":"button","title":"เพิ่มข้อมูล"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูล\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(4)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-edit"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"routePlanTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("ประเภท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อรูท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อ-สกุล ผู้ดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อ-สกุล ผู้สร้าง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/ManageShop'),expression:"$route.path == '/Master/ManageShop'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.shmKeyword),expression:"shmKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก รหัส ชื่อร้านค้า ชื่อผู้ติดต่อ เจ้าหน้าที่ดูแล โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ชื่อร้านค้า 1, ชื่อร้านค้า 2"},domProps:{"value":(_vm.shmKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.shmKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"shmSubAgentSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'shmSubAgent',"name":'shmSubAgent',"select2-options":_vm.shmSubAgentOptions},model:{value:(_vm.shmSubAgent),callback:function ($$v) {_vm.shmSubAgent=$$v},expression:"shmSubAgent"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"shmInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'shmInActiveStatus',"name":'shmInActiveStatus',"select2-options":_vm.shmInActiveStatusOptions},model:{value:(_vm.shmInActiveStatus),callback:function ($$v) {_vm.shmInActiveStatus=$$v},expression:"shmInActiveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmShopTypeId),callback:function ($$v) {_vm.shmShopTypeId=$$v},expression:"shmShopTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmShopGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmShopGroupId),callback:function ($$v) {_vm.shmShopGroupId=$$v},expression:"shmShopGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"shmProvinceIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'shmProvinceId',"name":'shmProvinceId',"select2-options":_vm.shmProvinceIdOptions},on:{"selectChange":_vm.onAmpherIdChange},model:{value:(_vm.shmProvinceId),callback:function ($$v) {_vm.shmProvinceId=$$v},expression:"shmProvinceId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"shmAmpherIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'shmAmpherId',"name":'shmAmpherId',"select2-options":_vm.shmAmpherIdOptions},model:{value:(_vm.shmAmpherId),callback:function ($$v) {_vm.shmAmpherId=$$v},expression:"shmAmpherId"}})],1)]),_vm._v(" "),(this.$root.canShow(''))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"clear-on-select":true,"options":_vm.shmAgentCodeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmAgentCode),callback:function ($$v) {_vm.shmAgentCode=$$v},expression:"shmAgentCode"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportShop}},[_vm._m(1)]),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER', 'MANAGE_SHOP']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManageShop/Add","tag":"button","title":"เพิ่ม"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่ม\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(2)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("จัดการข้อมูลร้านค้า")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 "},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"shopTable"}},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้ดูแลร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ที่อยู่")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("อีเมล")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เบอร์โทร")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อผู้ติดต่อ")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("เจ้าหน้าที่ดูแล (ตัวแทน)")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("เจ้าหน้าที่ดูแล (boonrawd)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("อำเภอ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Latitude")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Longitude")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Machine/ListMachine'),expression:"$route.path == '/Machine/ListMachine'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lmReqSearch),expression:"lmReqSearch"}],staticClass:"form-control",attrs:{"id":"lmReqSearch","name":"lmReqSearch","type":"text","placeholder":"ค้นหาจาก เลขที่ PO, เลขที่ Invoice, ค่าเช่า, BARCODE, รหัสทรัพย์สิน(เบียร์สด) เช่น 1234,BARCODE123"},domProps:{"value":(_vm.lmReqSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lmReqSearch=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่ติดตั้ง(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"lmDateInstallStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"lmDateInstallStart","name":"lmDateInstallStart","readonly":"readonly"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ติดตั้ง(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"lmDateInstallEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"lmDateInstallEnd","name":"lmDateInstallEnd","readonly":"readonly"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่วางบิล(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"lmDateOfBillingDate_Start",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"lmDateOfBillingDate_Start","name":"lmDateOfBillingDate_Start","readonly":"readonly"}}),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่วางบิล(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"lmDateOfBillingDate_End",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"lmDateOfBillingDate_End","name":"lmDateOfBillingDate_End","readonly":"readonly"}}),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่หมดสัญญาเช่า(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"lmContractExpireDate_Start",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"lmContractExpireDate_Start","name":"lmContractExpireDate_Start","readonly":"readonly"}}),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่หมดสัญญาเช่า(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"lmContractExpireDate_End",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"lmContractExpireDate_End","name":"lmContractExpireDate_End","readonly":"readonly"}}),_vm._v(" "),_vm._m(6)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Supplier:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadlmSupplierIdOptions,"async":true,"placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.lmSupplierId),callback:function ($$v) {_vm.lmSupplierId=$$v},expression:"lmSupplierId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Phase:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.lmPhaseOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.lmPhase),callback:function ($$v) {_vm.lmPhase=$$v},expression:"lmPhase"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Lot:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.lmLotOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.lmLot),callback:function ($$v) {_vm.lmLot=$$v},expression:"lmLot"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.lmAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.lmAgentCode),callback:function ($$v) {_vm.lmAgentCode=$$v},expression:"lmAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.lmShopOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.lmShop),callback:function ($$v) {_vm.lmShop=$$v},expression:"lmShop"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.lmProductTypeCodeptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.lmProductTypeCode),callback:function ($$v) {_vm.lmProductTypeCode=$$v},expression:"lmProductTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.lmProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.lmProductCode),callback:function ($$v) {_vm.lmProductCode=$$v},expression:"lmProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์เครื่องเบียร์สด:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.lmMachineProductBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.lmMachineProductBrandId),callback:function ($$v) {_vm.lmMachineProductBrandId=$$v},expression:"lmMachineProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.lmShopProvinceIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.lmShopProvinceId),callback:function ($$v) {_vm.lmShopProvinceId=$$v},expression:"lmShopProvinceId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportListMachine}},[_vm._m(7)])])])]),_vm._v(" "),_vm._m(8)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"MachineDetailTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("Supplier")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Phase")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Lot")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("งวดที่ชำระล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วัน (ที่ติดตั้ง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เดือน (ที่ติดตั้ง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี (ที่ติดตั้ง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่วางบิล")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วัน (ที่หมดสัญญาเช่า)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เดือน (ที่หมดสัญญาเช่า)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี (ที่หมดสัญญาเช่า)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่ PO")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่ Invoice")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ค่าเช่าต่องวด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เอเย่นต์")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")])])])])])])}]


/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"productCode",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'productCode' + _vm._uid,"name":'productCode' + _vm._uid,"select2-options":_vm.productCodeOptions,"disabled":_vm.item.isDisableProduct,"data-msg-required":"กรุณาเลือกสินค้า"},model:{value:(_vm.item.productCode),callback:function ($$v) {_vm.$set(_vm.item, "productCode", $$v)},expression:"item.productCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: _vm.locale, currency: _vm.currency }),expression:"{ locale, currency }"}],staticClass:"form-control required text-right",attrs:{"id":'productCost' + _vm._uid,"name":'productCost' + _vm._uid,"auto-decimal-mode:true":"","placeholder":"ราคา","data-msg-required":"กรุณากรอกจำนวน"},model:{value:(_vm.item.productCost),callback:function ($$v) {_vm.$set(_vm.item, "productCost", $$v)},expression:"item.productCost"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_vm._l((12),function(monthIndex){return _vm._l((5),function(dataIndex){return _c('td',{key:monthIndex + '-' + dataIndex},[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({locale: 'th',currency: null,precision: dataIndex === 5 ? 2 : 0}),expression:"{locale: 'th',currency: null,precision: dataIndex === 5 ? 2 : 0}"}],staticClass:"form-control text-right",attrs:{"auto-decimal-mode:true":"","data-msg-required":"กรุณากรอกจำนวน","readonly":(dataIndex === 4 || dataIndex === 5) ||
                          (_vm.yearSelected == _vm.currentYear && monthIndex > _vm.currentMonth) ||
                          (_vm.item.isDisableRow)},on:{"keyup":function($event){return _vm.calculateTotalValue(_vm.item, monthIndex)}},model:{value:(_vm.item.data[monthIndex - 1]['data' + dataIndex]),callback:function ($$v) {_vm.$set(_vm.item.data[monthIndex - 1], 'data' + dataIndex, $$v)},expression:"item.data[monthIndex - 1]['data' + dataIndex]"}})],1)})}),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: 'th',currency: null,precision: 0 }),expression:"{ locale: 'th',currency: null,precision: 0 }"}],staticClass:"form-control  text-right",attrs:{"readonly":"","id":'totalData1' + _vm._uid,"name":'totalData1' + _vm._uid,"value":_vm.ChecktotalCostAll(_vm._uid,1),"auto-decimal-mode:true":""}})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: 'th',currency: null,precision: 0 }),expression:"{ locale: 'th',currency: null,precision: 0 }"}],staticClass:"form-control  text-right",attrs:{"readonly":"","id":'totalData2' + _vm._uid,"name":'totalData2' + _vm._uid,"value":_vm.ChecktotalCostAll(_vm._uid,2),"auto-decimal-mode:true":""}})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: 'th',currency: null,precision: 0 }),expression:"{ locale: 'th',currency: null,precision: 0 }"}],staticClass:"form-control  text-right",attrs:{"readonly":"","id":'totalData3' + _vm._uid,"name":'totalData3' + _vm._uid,"value":_vm.ChecktotalCostAll(_vm._uid,3),"auto-decimal-mode:true":""}})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: 'th',currency: null,precision: 0 }),expression:"{ locale: 'th',currency: null,precision: 0 }"}],staticClass:"form-control  text-right",attrs:{"readonly":"","id":'totalRemain' + _vm._uid,"name":'totalRemain' + _vm._uid,"value":(_vm.ChecktotalCostAll(_vm._uid, 1) + _vm.ChecktotalCostAll(_vm._uid, 2)) - _vm.ChecktotalCostAll(_vm._uid, 3),"auto-decimal-mode:true":""}})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: 'th',currency: null,precision: 2 }),expression:"{ locale: 'th',currency: null,precision: 2 }"}],staticClass:"form-control  text-right",attrs:{"readonly":"","id":'totalpercent' + _vm._uid,"name":'totalpercent' + _vm._uid,"value":_vm.calTotalPercent(_vm._uid) || 0.00,"auto-decimal-mode:true":""}})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('center',[(!_vm.item.isDisableProduct)?_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveItemClick($event)}}},[_c('i',{staticClass:"text-danger la la-trash"})]):_vm._e()])],1)],2)}
var staticRenderFns = []


/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"userCreateModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อผู้ใช้งาน (UserName):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],staticClass:"form-control",attrs:{"id":"userName","name":"userName","type":"text","maxlength":"256","placeholder":"ชื่อผู้ใช้งาน (UserName)"},domProps:{"value":(_vm.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"id":"email","name":"email","type":"email","maxlength":"256","placeholder":"อีเมล"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("โปรไฟล์บริษัท:")]),_vm._v(" "),_c('select2',{ref:"useraCompanyProfileSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"useraCompanyProfile","name":"useraCompanyProfile","select2-options":_vm.useraCompanyProfileOptions},on:{"selectChange":_vm.onCompanyProfileChange},model:{value:(_vm.useraCompanyProfile),callback:function ($$v) {_vm.useraCompanyProfile=$$v},expression:"useraCompanyProfile"}}),_vm._v(" "),_c('br'),_vm._v("ไม่พบข้อมูลโปรไฟล์บริษัทคลิกเพื่อสร้าง\n                      "),_c('a',{attrs:{"href":"javascript:void()"},on:{"click":_vm.showSubAgentProfileCreateForm}},[_vm._v("โปรไฟล์ตัวแทนฯย่อย")]),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสผ่าน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"id":"password","name":"password","type":"password","maxlength":"20","placeholder":"รหัสผ่าน"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-warning"},[_vm._v("ยืนยันรหัสผ่าน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"form-control",attrs:{"id":"confirmPassword","name":"confirmPassword","type":"password","maxlength":"20","placeholder":"ยืนยันรหัสผ่าน"},domProps:{"value":(_vm.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.givenName),expression:"givenName"}],staticClass:"form-control",attrs:{"id":"givenName","name":"givenName","type":"text","maxlength":"450","placeholder":"ชื่อ"},domProps:{"value":(_vm.givenName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.givenName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสกุล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.familyName),expression:"familyName"}],staticClass:"form-control",attrs:{"id":"familyName","name":"familyName","type":"text","maxlength":"450","placeholder":"ชื่อสกุล"},domProps:{"value":(_vm.familyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.familyName=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่ง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.position),expression:"position"}],staticClass:"form-control",attrs:{"id":"position","name":"position","type":"text","maxlength":"450","placeholder":"ตำแหน่ง"},domProps:{"value":(_vm.position)},on:{"input":function($event){if($event.target.composing){ return; }_vm.position=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"form-control",attrs:{"id":"phoneNumber","name":"phoneNumber","type":"text","maxlength":"450","placeholder":"เบอร์ติดต่อ"},domProps:{"value":(_vm.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}})])])]),_vm._v(" "),_c('user-sml-mapping',{attrs:{"selectedCompanyProfiles":_vm.selectedCompanyProfiles,"userSmlMappings":_vm.userSmlMappings},on:{"update:userSmlMappings":function($event){_vm.userSmlMappings=$event},"update:user-sml-mappings":function($event){_vm.userSmlMappings=$event}}})],1)])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('sub-agent-profile-create-form',{ref:"subAgentProfileCreateForm"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล")])])}]


/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path.toLowerCase() == '/report/stockbarcodesnapshot'),expression:"$route.path.toLowerCase() == '/report/stockbarcodesnapshot'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Snapshot Date:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reSnapshotDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reSnapshotDate","name":"reSnapshotDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBarcodes),expression:"reBarcodes"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reBarcodes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBarcodes=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                  Generate Report\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.resetForm}},[_vm._v("\n                  ล้างค่าทั้งหมด\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary pull-right",attrs:{"disabled":_vm.isInitial},on:{"click":function($event){$event.preventDefault();return _vm.exportExcel($event)}}},[_vm._m(2)])])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{ref:"dataTable",staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"snapshotTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":_vm.columnCount}},[_vm._v("\n                  ข้อมูล ณ วันที่ "+_vm._s(_vm.reSnapshotDateDisplay)+"\n                ")])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('tbody')])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-camera"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v(" Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เจ้าของทรัพย์สิน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี(สินค้า)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ราคา(สินค้า)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสทรัพย์สิน(บัญชี)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสแบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อแบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่ผลิตครั้งล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสผู้ถือครอง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้ถือครอง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้ถือครอง 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทผู้ถือครอง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย(ผู้ถือครอง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด(ผู้ถือครอง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย(Group)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย(Group)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย(ตัวแทนจำหน่าย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด(ตัวแทนจำหน่าย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัดตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่ทำรายการล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตรวจสอบครั้งล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทการตรวจสอบครั้งล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะการตรวจสอบ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ขนส่ง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ทะเบียนขนส่ง/ผู้ดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนวันคงค้าง")])])}]


/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []


/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/PMRoutePlan'),expression:"$route.path == '/PMReport/PMRoutePlan'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เดือน:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reMonthCode',"name":'reMonthCode',"select2-options":_vm.reMonthOptions},model:{value:(_vm.reMonthCode),callback:function ($$v) {_vm.reMonthCode=$$v},expression:"reMonthCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปี :")]),_vm._v(" "),_c('select2',{ref:"reYear",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reYear',"name":'reYear',"select2-options":_vm.reYearOptions},model:{value:(_vm.reYear),callback:function ($$v) {_vm.reYear=$$v},expression:"reYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reDepartment',"name":'reDepartment',"select2-options":_vm.reDepartmentOptions},on:{"selectChange":_vm.onDepartmentChange},model:{value:(_vm.reDepartment),callback:function ($$v) {_vm.reDepartment=$$v},expression:"reDepartment"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAgentCode',"name":'reAgentCode',"select2-options":_vm.reAgentCodeOptions},model:{value:(_vm.reAgentCode),callback:function ($$v) {_vm.reAgentCode=$$v},expression:"reAgentCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"PMRoutePlanTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"11"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.isShowFooter)?_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("ยอดรวม")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm._f("currency")(_vm.totalEstRoutePlan," ", 0))+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm._f("currency")(_vm.totalActRoutePlan," ", 0))+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm._f("currency")(_vm.totalPercentRoutePlan," ", 2))+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm._f("currency")(_vm.totalEstAdhoc," ", 0))+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm._f("currency")(_vm.totalActAdhoc," ", 0))+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm._f("currency")(_vm.totalPercentAdhoc," ", 2))+"\n                  ")])])]):_vm._e()])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เดือน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("กำหนดการวางแผน (ครั้ง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ดำเนินการได้ตามแผน (ครั้ง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("คิดเป็นเปอร์เซ็นต์ (%)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เยี่ยมนอกแผน (ครั้ง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("\n                    ดำเนินการได้ตามการเยี่ยมนอกแผน (ครั้ง)\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("\n                    คิดเป็นเปอร์เซ็นต์เยี่ยมนอกแผน (%)\n                  ")])])}]


/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทผู้ติดต่อ:")]),_vm._v(" "),_c('select2',{ref:"couContactTypeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'couContactType',"name":'couContactType',"select2-options":_vm.couContactTypeOptions},model:{value:(_vm.couContactType),callback:function ($$v) {_vm.couContactType=$$v},expression:"couContactType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.couContactType!='other'),expression:"couContactType!='other'"}],staticClass:"label-required"},[_vm._v("บริษัท:")]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.couContactType=='other'),expression:"couContactType=='other'"}]},[_vm._v("บริษัท:")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.couContactType=='agent'),expression:"couContactType=='agent'"}]},[_c('select2',{ref:"couAgentIdSelect2",class:'form-control',attrs:{"css-style":'width: 100%;',"id":'couAgentId',"name":'couAgentId',"select2-options":_vm.couAgentOptions},model:{value:(_vm.couAgentId),callback:function ($$v) {_vm.couAgentId=$$v},expression:"couAgentId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.couContactType=='vendor'),expression:"couContactType=='vendor'"}]},[_c('select2',{ref:"couVendorIdSelect2",class:'form-control',attrs:{"css-style":'width: 100%;',"id":'couVendorId',"name":'couVendorId',"select2-options":_vm.couVendorOptions},model:{value:(_vm.couVendorId),callback:function ($$v) {_vm.couVendorId=$$v},expression:"couVendorId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.couContactType=='plant'),expression:"couContactType=='plant'"}]},[_c('select2',{ref:"couPlantIdSelect2",class:'form-control',attrs:{"css-style":'width: 100%;',"id":'couPlantId',"name":'couPlantId',"select2-options":_vm.couPlantOptions},model:{value:(_vm.couPlantId),callback:function ($$v) {_vm.couPlantId=$$v},expression:"couPlantId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.couContactType=='other'),expression:"couContactType=='other'"}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couOtherId),expression:"couOtherId"}],staticClass:"form-control",attrs:{"id":"couOtherId","name":"couOtherId","type":"text","maxlength":"450","placeholder":"ชื่อบริษัท"},domProps:{"value":(_vm.couOtherId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.couOtherId=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.couContactType),expression:"!couContactType"}]},[_c('select2',{ref:"couCompanyIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'couCompanyId',"name":'couCompanyId',"select2-options":_vm.couCompanyIdOptions},model:{value:(_vm.couCompanyId),callback:function ($$v) {_vm.couCompanyId=$$v},expression:"couCompanyId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couContactName),expression:"couContactName"}],staticClass:"form-control",attrs:{"id":"couContactName","name":"couContactName","type":"text","maxlength":"450","placeholder":"ชื่อผู้ติดต่อ"},domProps:{"value":(_vm.couContactName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.couContactName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("นามสกุล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couContactLastName),expression:"couContactLastName"}],staticClass:"form-control",attrs:{"id":"couContactLastName","name":"couContactLastName","type":"text","maxlength":"450","placeholder":"นามสกุล"},domProps:{"value":(_vm.couContactLastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.couContactLastName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตำแหน่ง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couContactPositions),expression:"couContactPositions"}],staticClass:"form-control",attrs:{"id":"couContactPositions","name":"couContactPositions","type":"text","maxlength":"450","placeholder":"ตำแหน่ง"},domProps:{"value":(_vm.couContactPositions)},on:{"input":function($event){if($event.target.composing){ return; }_vm.couContactPositions=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อเล่น:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couContactNickName),expression:"couContactNickName"}],staticClass:"form-control",attrs:{"id":"couContactNickName","name":"couContactNickName","type":"text","maxlength":"450","placeholder":"ชื่อเล่น"},domProps:{"value":(_vm.couContactNickName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.couContactNickName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couContactTel),expression:"couContactTel"}],staticClass:"form-control",attrs:{"id":"couContactTel","name":"couContactTel","type":"text","maxlength":"450","placeholder":"เบอร์ติดต่อ"},domProps:{"value":(_vm.couContactTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.couContactTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("E-mail:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couContactEmail),expression:"couContactEmail"}],staticClass:"form-control",attrs:{"id":"couContactEmail","name":"couContactEmail","type":"email","maxlength":"450","placeholder":"E-mail"},domProps:{"value":(_vm.couContactEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.couContactEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couInActiveStatus),expression:"couInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"couInActiveStatus","id":"couInActiveStatus"},domProps:{"checked":Array.isArray(_vm.couInActiveStatus)?_vm._i(_vm.couInActiveStatus,null)>-1:(_vm.couInActiveStatus)},on:{"change":function($event){var $$a=_vm.couInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.couInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.couInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.couInActiveStatus=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                    เปิดใช้งาน\n                  ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])}]


/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_vm._m(1),_vm._v(" "),(_vm.loadError)?_c('div',{staticClass:"alert alert-danger",attrs:{"data-test":"fss-result-error"}},[_vm._v("\n      "+_vm._s(_vm.loadError)+"\n    ")]):[_c('div',{staticClass:"fss-result__summary"},[_c('div',{staticClass:"fss-result__headline",attrs:{"data-test":"fss-result-headline"}},[_vm._v("\n          ✔ "),_c('strong',[_vm._v("สร้างสำเร็จทั้งหมด\n          "),_c('span',{staticClass:"fss-result__count"},[_vm._v(_vm._s(_vm.documentCount))]),_vm._v("\n          เอกสารสรุปสินค้าคงค้าง")]),_vm._v(" — พร้อมดาวน์โหลด / พิมพ์\n        ")])]),_vm._v(" "),_c('div',{staticClass:"fss-result__filter",attrs:{"data-test":"fss-result-filter"}},[_c('h5',{staticClass:"kt-font-bold kt-margin-b-10"},[_vm._v("Filter ที่เลือก")]),_vm._v(" "),(_vm.filterLabels.length > 0)?_c('table',{staticClass:"table table-sm fss-filter-table"},[_c('tbody',_vm._l((_vm.filterLabels),function(item,index){return _c('tr',{key:index,attrs:{"data-test":"fss-result-filter-line"}},[_c('td',{staticClass:"fss-filter-table__label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.text))])])}),0)]):_c('div',{staticClass:"text-muted"},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"fss-result__bulk"},[_c('button',{staticClass:"btn btn-sm btn-success kt-margin-r-10",attrs:{"type":"button","data-test":"fss-result-zip-excel","disabled":_vm.documentCount === 0,"title":"ดาวน์โหลดไฟล์ ZIP รวม Excel ของทุกเอกสารในชุดนี้"},on:{"click":_vm.exportZipExcel}},[_c('i',{staticClass:"la la-file-excel-o"}),_vm._v(" "),_vm._v("\n          Export Excel "+_vm._s(_vm.documentCount)+" เอกสาร (รายละเอียดบาร์โค้ด)\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm fss-btn fss-btn--orange kt-margin-r-10",attrs:{"type":"button","data-test":"fss-result-zip-pdf","disabled":_vm.documentCount === 0,"title":"ดาวน์โหลดไฟล์ ZIP รวมฟอร์ม PDF ของทุกเอกสารในชุดนี้"},on:{"click":_vm.exportZipPdf}},[_c('i',{staticClass:"la la-print"}),_vm._v("\n          พิมพ์ PDF "+_vm._s(_vm.documentCount)+" เอกสาร\n        ")]),_vm._v(" "),_c('span',{staticClass:"fss-result__bulk-note"},[_vm._v("\n          ดาวน์โหลดทั้งชุดเป็นไฟล์ ZIP ครั้งเดียว —\n          หรือเปิดเอกสารทีละฉบับจากตารางด้านล่างก็ได้\n        ")])]),_vm._v(" "),_c('div',{staticClass:"fss-result__search"},[_c('div',{staticClass:"input-group input-group-sm fss-result__search-box"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agentKeyword),expression:"agentKeyword"}],staticClass:"form-control",attrs:{"type":"text","data-test":"fss-result-search","placeholder":"ค้นหารหัส/ชื่อตัวแทนจำหน่าย..."},domProps:{"value":(_vm.agentKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.agentKeyword=$event.target.value}}}),_vm._v(" "),(_vm.agentKeyword)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-test":"fss-result-search-clear","title":"ล้างคำค้น"},on:{"click":function($event){_vm.agentKeyword = ''}}},[_c('i',{staticClass:"la la-close"})])]):_vm._e()]),_vm._v(" "),(_vm.agentKeyword)?_c('span',{staticClass:"fss-result__search-count",attrs:{"data-test":"fss-result-search-count"}},[_vm._v("\n          แสดง "+_vm._s(_vm.filteredDocuments.length)+" จาก "+_vm._s(_vm.documents.length)+" รายการ\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered table-hover fss-result__table"},[_vm._m(3),_vm._v(" "),_c('tbody',[_vm._l((_vm.filteredDocuments),function(doc){return [_c('tr',{key:doc.id,attrs:{"data-test":"fss-result-row"}},[_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"type":"button","data-test":"fss-result-expand","title":_vm.isExpanded(doc.id) ? 'ซ่อนรายละเอียด' : 'แสดงรายละเอียด'},on:{"click":function($event){return _vm.toggleDetail(doc.id)}}},[_c('i',{class:_vm.isExpanded(doc.id) ? 'la la-angle-down' : 'la la-angle-right'})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(doc.seqNo))]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(_vm.agentLabel(doc))+"\n                  "),(doc.branchLine)?_c('div',{staticClass:"fss-branch-line",attrs:{"data-test":"fss-result-branch-line"}},[_vm._v("\n                    "+_vm._s(doc.branchLine)+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"fss-result__doc-link",attrs:{"href":_vm.documentUrl(doc),"data-test":"fss-result-doc-link","target":"_blank","rel":"noopener","title":"เปิดเอกสารในแถบใหม่"},on:{"click":function($event){$event.preventDefault();return _vm.viewDocument(doc)}}},[_vm._v(_vm._s(doc.documentNo))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatQty(doc.totalQty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatAmount(doc.totalAmount)))])]),_vm._v(" "),(_vm.isExpanded(doc.id))?_c('tr',{key:doc.id + '__detail',staticClass:"fss-detail-row",attrs:{"data-test":"fss-result-detail-row"}},[_c('td',{attrs:{"colspan":"6"}},[_c('div',{staticClass:"fss-detail"},[_c('div',{staticClass:"fss-detail__title"},[_vm._v("\n                      รายละเอียดสินค้าคงค้าง — "+_vm._s(doc.agentName || doc.agentCode)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered"},[_vm._m(4,true),_vm._v(" "),_c('tbody',_vm._l((doc.details || []),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.seqNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productTypeName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productName))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatQty(row.qty)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.unitName))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatAmount(row.amount)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"fss-total-row"},[_c('td',{staticClass:"text-right kt-font-bold",attrs:{"colspan":"4"}},[_vm._v("Grand Total")]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v(_vm._s(_vm.formatQty(doc.totalQty)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("—")]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v(_vm._s(_vm.formatAmount(doc.totalAmount)))])])])])])])])]):_vm._e()]}),_vm._v(" "),(_vm.filteredDocuments.length === 0)?_c('tr',{attrs:{"data-test":"fss-result-search-empty"}},[_c('td',{staticClass:"text-center fss-result__empty",attrs:{"colspan":"6"}},[_vm._v("\n                ไม่พบตัวแทนจำหน่ายที่ตรงกับ \""+_vm._s(_vm.agentKeyword)+"\"\n              ")])]):_vm._e()],2),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"fss-total-row",attrs:{"data-test":"fss-result-grand-total"}},[_c('td',{staticClass:"text-right kt-font-bold",attrs:{"colspan":"4"}},[_vm._v("\n                Grand Total (สร้างแล้ว "+_vm._s(_vm.documentCount)+" เอกสาร\n                จากทั้งหมด "+_vm._s(_vm.documentCount)+" ตัวแทนจำหน่าย)\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v(_vm._s(_vm.formatQty(_vm.totalQty)))]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v(_vm._s(_vm.formatAmount(_vm.totalAmount)))])])])])]),_vm._v(" "),_c('div',{staticClass:"fss-result__once",attrs:{"data-test":"fss-result-once-warning"}},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_vm._v(" "),_c('span',[_c('strong',[_vm._v("หน้าสรุปนี้แสดงเพียงครั้งเดียว")]),_vm._v(" —\n          "),_vm._v("\n          โปรดกด\n          "),_c('strong',[_vm._v("\"Export Excel "+_vm._s(_vm.documentCount)+" เอกสาร (รายละเอียดบาร์โค้ด)\"")]),_vm._v("\n          หรือ "),_c('strong',[_vm._v("\"พิมพ์ PDF "+_vm._s(_vm.documentCount)+" เอกสาร\"")]),_vm._v(" ก่อนออกจากหน้า\n          (เอกสารแต่ละฉบับยังคงเปิดดูได้จากเมนู "),_c('strong',[_vm._v("\"รายการเอกสาร\"")]),_vm._v(")\n        ")])]),_vm._v(" "),_c('div',{staticClass:"kt-separator kt-separator--border-dashed kt-separator--space-sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 text-left"},[_c('button',{staticClass:"btn btn-sm btn-clean",attrs:{"type":"button","data-test":"fss-result-goto-list"},on:{"click":_vm.leaveToList}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("กลับสู่หน้าค้นหา")])])])])],_vm._v(" "),_c('FormSummaryStockProgressModal',{ref:"progressModal",on:{"finished":_vm.onZipFinished}})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_c('i',{staticClass:"fas fa-clipboard-check"}),_vm._v("\n        สรุปผลการสร้างเอกสารรวม\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"fss-stepper",attrs:{"data-test":"fss-result-stepper"}},[_c('div',{staticClass:"fss-step fss-step--done"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("✓")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("เลือก Filter")])]),_vm._v(" "),_c('div',{staticClass:"fss-connector fss-connector--all-done"}),_vm._v(" "),_c('div',{staticClass:"fss-step fss-step--done"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("✓")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("ตรวจสอบข้อมูล")])]),_vm._v(" "),_c('div',{staticClass:"fss-connector fss-connector--all-done"}),_vm._v(" "),_c('div',{staticClass:"fss-step fss-step--done"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("✓")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("บันทึกแล้ว")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"5%"}}),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"7%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"14%"}},[_vm._v("เลขที่เอกสาร")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"13%"}},[_vm._v("จำนวนคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"18%"}},[_vm._v("ยอดรวม (ก่อน VAT)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"7%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"18%"}},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"27%"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%"}},[_vm._v("จำนวนคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"8%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"13%"}},[_vm._v("จำนวนเงิน (ก่อน VAT)")])])])}]


/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัส(Supplier) :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.suuNo))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ(Supplier) :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.suuName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เลขประจำตัวผู้เสียภาษี :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.suuTaxNo))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภท Supplier:")]),_vm._v(" "),_c('treeselect',{attrs:{"options":_vm.OwnerTypeCodeOption,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OwnerTypeCode),callback:function ($$v) {_vm.OwnerTypeCode=$$v},expression:"OwnerTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ที่อยู่ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.suuAddress))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("E-mail :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.suuEmail))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทร :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.suuTel))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่งที่ตั้ง:")]),_vm._v(" "),(_vm.suuLat === null)?_c('div',[_c('button',{staticClass:"btn m-btn--pill btn-info btn-block col-xl-2",attrs:{"type":"button"},on:{"click":_vm.getMap}},[_vm._v("\n                    ระบุข้อมูลตำแหน่งที่ตั้ง\n                  ")])]):_c('div',[_c('GmapMap',{staticStyle:{"width":"500px","height":"300px"},attrs:{"center":{ lat: _vm.suuLat, lng: _vm.suuLng },"zoom":15,"clickable":true},on:{"click":_vm.updateCoordinates}},_vm._l((_vm.suuMarkers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"draggable":true,"clickable":true},on:{"drag":_vm.updateCoordinates,"click":_vm.updateCoordinates}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.openMap()}}},[_c('i',{staticClass:"far fa-map"}),_vm._v(" Open GoogleMaps\n                    ")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block col-xl-2",attrs:{"type":"button"},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("รูป\n                ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-img"}},_vm._l((_vm.FileUpload),function(image,index){return _c('div',{key:index,staticClass:"col-md-4 m--margin-top-20 img-wrap"},[(image.isLoaded !== false)?_c('img',{staticClass:"img-plant img-thumbnail card-img-top",attrs:{"src":image.urlImg},on:{"error":function($event){return _vm.handleImageError(image)},"load":function($event){return _vm.handleImageLoad(image)}}}):_c('div',{staticClass:"img-placeholder"},[_vm._v("ไม่สามารถโหลดรูปภาพได้")]),_vm._v(" "),_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn close",staticStyle:{"position":"absolute","top":"10px","right":"20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeImage(image.pictureId)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.suuInActiveStatus),expression:"suuInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"suuInActiveStatus","id":"suuInActiveStatus"},domProps:{"checked":Array.isArray(_vm.suuInActiveStatus)?_vm._i(_vm.suuInActiveStatus,null)>-1:(_vm.suuInActiveStatus)},on:{"change":function($event){var $$a=_vm.suuInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.suuInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.suuInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.suuInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("รูปภาพ:"),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                    (เลือกได้เฉพาะสกุลไฟล์ JPG, JPEG,PNG ขนาดไม่เกิน\n                    10Mb.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])}]


/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MaintainReport/RepairSum'),expression:"$route.path == '/MaintainReport/RepairSum'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("ปี:")]),_vm._v(" "),_c('select2',{ref:"reYearStart",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reYearStart',"name":'reYearStart',"select2-options":_vm.reYearOptions},model:{value:(_vm.reYearStart),callback:function ($$v) {_vm.reYearStart=$$v},expression:"reYearStart"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),(this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN']))?_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.exportExcel}},[_vm._m(1)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped table-bordered table-hover table-checkable",attrs:{"id":"reportTable"}},[_c('thead',[_c('tr',[_c('td',{staticClass:"text-center font-weight-bold align-middle",staticStyle:{"background-color":"#fce4d6"},attrs:{"rowspan":"3"}},[_vm._v("ปี "+_vm._s(_vm.reYearStart))]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgPlant",attrs:{"colspan":"8"}},[_vm._v("ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgAgent",attrs:{"colspan":"7"}},[_vm._v("ซ่อมในตัวแทนจำหน่าย")])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_vm._m(4)])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center font-weight-bold bgPlant",attrs:{"colspan":"2"}},[_vm._v("ซ่อมเครื่อง")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgPlant",attrs:{"colspan":"2"}},[_vm._v("อะไหล่ซ่อมเครื่อง")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgPlant",attrs:{"colspan":"2"}},[_vm._v("ซ่อมอุปกรณ์")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgPlant",attrs:{"colspan":"2"}},[_vm._v("อะไหล่ซ่อมอุปกรณ์")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgAgent",attrs:{"colspan":"3"}},[_vm._v("ซ่อมเครื่อง")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgAgent",attrs:{"colspan":"2"}},[_vm._v("ซ่อมอุปกรณ์")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgAgent",attrs:{"colspan":"2"}},[_vm._v("อะไหล่ซ่อมเครื่องและอุปกรณ์")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center font-weight-bold bgPlant"},[_vm._v("จำนวนเครื่องรวม")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgPlant"},[_vm._v("มูลค่า(ค่าบริการ)")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgPlant"},[_vm._v("จำนวนอะไหล่/ชิ้น")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgPlant"},[_vm._v("มูลค่า")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgPlant"},[_vm._v("จำนวนอุปกรณ์/ชิ้น")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgPlant"},[_vm._v("มูลค่า(ค่าบริการ)")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgPlant"},[_vm._v("จำนวนอะไหล่/ชิ้น")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgPlant"},[_vm._v("มูลค่า")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgAgent"},[_vm._v("จำนวนตัวแทน"),_c('br'),_vm._v("(ซ่อมเครื่องและอุปกรณ์)")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgAgent"},[_vm._v("จำนวนเครื่อง")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgAgent"},[_vm._v("มูลค่า(ค่าบริการ)")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgAgent"},[_vm._v("จำนวนอุปกรณ์/ชิ้น")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgAgent"},[_vm._v("มูลค่า(ค่าบริการ)")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgAgent"},[_vm._v("จำนวนอะไหล่/ชิ้น")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold bgAgent"},[_vm._v("มูลค่า")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr',{staticStyle:{"background-color":"#fce4d6"}},[_c('th',[_vm._v("รวม")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-right",attrs:{"colspan":"15"}},[_vm._v("รวมมูลค่าค่าบริการ")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"id":"totalService"}})]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-right",attrs:{"colspan":"15"}},[_vm._v("รวมมูลค่าอะไหล่ที่ใช้")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"id":"totalParts"}})])])}]


/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"downloadPhaseModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสอ้างอิง:")]),_vm._v(" "),_c('select2',{ref:"DlbRefnoSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'DlbRefno',"name":'DlbRefno',"select2-options":_vm.DlbRefnoOptions,"multiple":true},model:{value:(_vm.DlbRefno),callback:function ($$v) {_vm.DlbRefno=$$v},expression:"DlbRefno"}})],1)])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" ดาวน์โหลด\n          ")])])}]


/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"addClaimItemModal","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{ref:"formItem",staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                    this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'
                  ),expression:"\n                    this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'\n                  "}]},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                    รายละเอียด การติดตั้งเครื่องเบียร์สด และการตั้งค่าต่างๆ:\n                  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชนิดเครื่อง:")]),_vm._v(" "),_c('select2',{ref:"bciMachineTypeCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"bciMachineTypeCode","name":"bciMachineTypeCode","select2-options":_vm.bciMachineTypeCodeOptions,"disabled":""},on:{"selectChange":_vm.onMachineTypeCodeChange},model:{value:(_vm.bciMachineTypeCode),callback:function ($$v) {_vm.bciMachineTypeCode=$$v},expression:"bciMachineTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("BARCODE (เครื่องเบียร์สด):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciMachineBarcode),expression:"bciMachineBarcode"}],staticClass:"form-control",attrs:{"id":"bciMachineBarcode","name":"bciMachineBarcode","type":"text","maxlength":"20","placeholder":"BARCODE (เครื่องเบียร์สด)","disabled":""},domProps:{"value":(_vm.bciMachineBarcode)},on:{"blur":function($event){return _vm.onBlurBarcode(true)},"input":function($event){if($event.target.composing){ return; }_vm.bciMachineBarcode=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทเครื่องเบียร์สด:")]),_vm._v(" "),_c('select2',{ref:"bciMachineCategorySelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"bciMachineCategory","name":"bciMachineCategory","select2-options":_vm.bciMachineCategoryOptions,"disabled":""},model:{value:(_vm.bciMachineCategory),callback:function ($$v) {_vm.bciMachineCategory=$$v},expression:"bciMachineCategory"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ปริมาณแรงดัน Co2 (PSI./BAR):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciPressure),expression:"bciPressure"}],staticClass:"form-control",attrs:{"id":"bciPressure","name":"bciPressure","type":"number","min":"0","placeholder":"ปริมาณแรงดัน Co2","disabled":""},domProps:{"value":(_vm.bciPressure)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciPressure=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อุณหภูมิน้ำในเครื่อง (องศาเซลเซียส):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciTemperature),expression:"bciTemperature"}],staticClass:"form-control",attrs:{"id":"bciTemperature","name":"bciTemperature","type":"number","min":"0","placeholder":"อุณหภูมิน้ำในเครื่อง","disabled":""},domProps:{"value":(_vm.bciTemperature)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciTemperature=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันล้างเครื่องล่าสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bciPMDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bciPMDate","name":"bciPMDate","disabled":""}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่จัมพ์ถัง:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bciJumpDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bciJumpDate","name":"bciJumpDate","disabled":""}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                    this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'
                  ),expression:"\n                    this.$parent.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'\n                  "}]},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                    รายละเอียด การใช้งาน และการบำรุงรักษา:\n                  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("มาตรฐานติดตั้ง:")]),_vm._v(" "),_c('select2',{ref:"bciStandardInstallCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"bciStandardInstallCode","name":"bciStandardInstallCode","select2-options":_vm.bciStandardInstallCodeOptions,"disabled":""},on:{"selectChange":_vm.onStandardInstallCodeChange},model:{value:(_vm.bciStandardInstallCode),callback:function ($$v) {_vm.bciStandardInstallCode=$$v},expression:"bciStandardInstallCode"}})],1)])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                    รายละเอียด สินค้าเบียร์สด:\n                  ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciProductBrand),expression:"bciProductBrand"}],staticClass:"form-control",attrs:{"id":"bciProductBrand","name":"bciProductBrand","type":"text","maxlength":"450","placeholder":"แบรนด์สินค้า","disabled":""},domProps:{"value":(_vm.bciProductBrand)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciProductBrand=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('select2',{ref:"bciMaterialCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"bciMaterialCode","name":"bciMaterialCode","select2-options":_vm.bciMaterialCodeOptions,"disabled":""},on:{"selectChange":_vm.onMaterialCodeChange},model:{value:(_vm.bciMaterialCode),callback:function ($$v) {_vm.bciMaterialCode=$$v},expression:"bciMaterialCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("BARCODE (ถัง):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciBarcode),expression:"bciBarcode"}],staticClass:"form-control",attrs:{"id":"bciBarcode","name":"bciBarcode","type":"text","maxlength":"20","placeholder":"BARCODE (ถัง)","disabled":""},domProps:{"value":(_vm.bciBarcode)},on:{"blur":function($event){return _vm.onBlurBarcode(false)},"input":function($event){if($event.target.composing){ return; }_vm.bciBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันผลิตข้างถัง:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bciManufacturingDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bciManufacturingDate","name":"bciManufacturingDate","disabled":""}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("น้ำหนักรวมถัง (กิโลกรัม):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciWeight),expression:"bciWeight"}],staticClass:"form-control",attrs:{"id":"bciWeight","name":"bciWeight","type":"number","min":"0","placeholder":"น้ำหนักรวมถัง","disabled":""},domProps:{"value":(_vm.bciWeight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciWeight=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เลขที่ Invoice :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciInvoice),expression:"bciInvoice"}],staticClass:"form-control",attrs:{"id":"bciInvoice","name":"bciInvoice","type":"text","maxlength":"450","placeholder":"เลขที่ Invoice","disabled":""},domProps:{"value":(_vm.bciInvoice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciInvoice=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่สินค้าเข้าตัวแทนจำหน่าย:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bciAgentReceivedDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bciAgentReceivedDate","name":"bciAgentReceivedDate","disabled":""}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                          this.$parent.abcClaimTypeCode ==
                            'BEER_CLAIM_TYPE_SHOP'
                        ),expression:"\n                          this.$parent.abcClaimTypeCode ==\n                            'BEER_CLAIM_TYPE_SHOP'\n                        "}],staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่สินค้าเข้าร้านค้า:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bciShopReceivedDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bciShopReceivedDate","name":"bciShopReceivedDate","disabled":""}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายละเอียด ปัญหาที่พบ:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ปัญหาที่พบ:")]),_vm._v(" "),_c('select2',{ref:"bciProblemTypeCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"bciProblemTypeCode","name":"bciProblemTypeCode","select2-options":_vm.bciProblemTypeCodeOptions,"disabled":""},on:{"selectChange":_vm.onProblemTypeCodeChange},model:{value:(_vm.bciProblemTypeCode),callback:function ($$v) {_vm.bciProblemTypeCode=$$v},expression:"bciProblemTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ข้อมูลรูปภาพ:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"p-1 d-flex flex-column justify-content-center align-items-center border-dashed",attrs:{"id":"container-img"}},[(_vm.uploadFiles[0])?_c('img',{staticStyle:{"object-fit":"contain","width":"100%","height":"100%"},attrs:{"src":_vm.uploadFiles[0].fileURL},on:{"click":function($event){return _vm.showModal(_vm.uploadFiles[0].fileURL)}}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"p-1 d-flex flex-column justify-content-center align-items-center border-dashed",attrs:{"id":"container-img2"}},[(_vm.uploadFiles[1])?_c('img',{staticStyle:{"object-fit":"contain","width":"100%","height":"100%"},attrs:{"src":_vm.uploadFiles[1].fileURL},on:{"click":function($event){return _vm.showModal(_vm.uploadFiles[1].fileURL)}}}):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"imageModal","tabindex":"-1","role":"dialog","aria-labelledby":"imageModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("รูปภาพ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticStyle:{"max-width":"90%","max-height":"90%","margin":"0 auto","display":"block"},attrs:{"src":_vm.modalImageURL}}),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_vm._m(5)])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รายละเอียดของปัญหา:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.bciProblemDesc),expression:"bciProblemDesc"}],staticClass:"form-control",attrs:{"placeholder":"รายละเอียดของปัญหา","id":"bciProblemDesc","name":"bciProblemDesc","rows":"5","disabled":""},domProps:{"value":(_vm.bciProblemDesc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bciProblemDesc=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])])])])]),_vm._v(" "),_vm._m(6)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"modal-title"},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n            ")])])}]


/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/QCReport/QCGroupByAgent'),expression:"$route.path == '/QCReport/QCGroupByAgent'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])]),_vm._v(" "),(_vm.reAverageScore !== null)?_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('span',{staticStyle:{"background-color":"#A6C9EC","padding":"6px 16px","border-radius":"4px 0 0 4px","font-weight":"bold","border-right":"1px solid #8BB8E0"}},[_vm._v("\n            ค่าเฉลี่ยคะแนน\n          ")]),_vm._v(" "),_c('span',{staticStyle:{"background-color":"#A6C9EC","padding":"6px 16px","border-radius":"0 4px 4px 0","font-weight":"bold"}},[_vm._v("\n            "+_vm._s(_vm.reAverageScore)+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อเจ้าหน้าที่:")]),_vm._v(" "),_c('treeselect',{ref:"reUserIds",attrs:{"multiple":true,"async":true,"cacheOptions":false,"load-options":_vm.LoadreUserIdsOptions,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก"},on:{"open":_vm.reLoadreUserIdsOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.reUserIds),callback:function ($$v) {_vm.reUserIds=$$v},expression:"reUserIds"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คะแนน QC:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reScoresOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reScores),callback:function ($$v) {_vm.reScores=$$v},expression:"reScores"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reDepartmentsOptions,"beforeClearAll":_vm.DepartmentClear,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.DepartmentSelect,"deselect":_vm.DepartmentDeselect},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"beforeClearAll":_vm.AgentClear,"placeholder":"กรุณาเลือก"},on:{"select":_vm.AgentSelect,"deselect":_vm.AgentDeselect},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reSubAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reSubAgentCodes),callback:function ($$v) {_vm.reSubAgentCodes=$$v},expression:"reSubAgentCodes"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportQIGroupByAgent}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"QIGroupByAgentTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"10"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อเจ้าหน้าที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทร้านค้า"),_c('br'),_vm._v("(ตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("คะแนน QC")])])}]


/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"agentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'agentCode',"name":'agentCode',"select2-options":_vm.agentCodeOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลปี :")]),_vm._v(" "),_c('select2',{ref:"year",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'year',"name":'year',"select2-options":_vm.yearOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)])]),_vm._v(" "),(_vm.year && _vm.canExportAllAgents && !_vm.isShow)?_c('div',{staticClass:"d-flex justify-content-end align-items-center mb-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n              "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.isShow == true)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              รายการจำนวนเครื่องเบียร์สดชำรุด :\n            ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingSelected},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelSelected($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)")+"\n                ")])]),_vm._v(" "),(_vm.canExportAllAgents)?_c('button',{staticClass:"btn btn-outline-primary ml-2",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"2500px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"3%"}},[_vm._v("\n                        ลำดับ\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"10%"}},[_vm._v("\n                        ประเภทสินค้า\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        ต้นทุนสินค้า(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"12","scope":"colgroup"}},[_vm._v("\n                        จำนวนเครื่องเบียร์สดชำรุด (จำนวน) ปี "+_vm._s(_vm.year)+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้ารวม(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้าเฉลี่ย(บาท/เดือน)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        จัดการ\n                      ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('tbody',{on:{"change":function($event){return _vm.changeTotal()}}},[(_vm.productitems == null || _vm.productitems.length == 0)?_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"18"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.productitems),function(item,i){return [_c('product-item-row',{key:i,ref:"Items",refInFor:true,attrs:{"rowIndex":i,"item":item,"kPIProductType":_vm.kPIProductType,"yearSelected":_vm.year},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"3%"}}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รวมเงิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_vm._l((12),function(index){return _c('th',{key:index,staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalMonth[index]," ", 0))+"\n                      ")])}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalPoductCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalProductCostOfMonth,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th')],2),_vm._v(" "),_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{attrs:{"colspan":"18"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[(_vm.isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand fas fa-unlink"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มกราคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กุมภาพันธ์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มีนาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("เมษายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤษภาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มิถุนายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กรกฎาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("สิงหาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กันยายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ตุลาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤศจิกายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ธันวาคม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])}]


/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"agentCreateExcelModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ยังไม่เปิดใช้งาน")])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n          ")])])}]


/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(_vm.isEditMode ? 'แก้ไขกลุ่มอนุมัติ' : 'สร้างกลุ่มอนุมัติใหม่')+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":'/BudgetPlan/ApproveGroup'}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"mainForm",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.submitForm($event)}}},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("ชื่อกลุ่ม :")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.groupName),expression:"formData.groupName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"พิมพ์ชื่อกลุ่มอนุมัติ","required":""},domProps:{"value":(_vm.formData.groupName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "groupName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.isActive),expression:"formData.isActive"}],attrs:{"type":"radio"},domProps:{"value":true,"checked":_vm._q(_vm.formData.isActive,true)},on:{"change":function($event){return _vm.$set(_vm.formData, "isActive", true)}}}),_vm._v("\n                        ใช้งาน\n                        "),_c('span')]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.isActive),expression:"formData.isActive"}],attrs:{"type":"radio"},domProps:{"value":false,"checked":_vm._q(_vm.formData.isActive,false)},on:{"change":function($event){return _vm.$set(_vm.formData, "isActive", false)}}}),_vm._v("\n                        ไม่ใช้งาน\n                        "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("แผนก :")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.formData.orgs.length === 0)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),_vm._l((_vm.formData.orgs),function(org,index){return _c('tr',{key:'org-' + org._uid},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_c('select2',{ref:'orgSelect_' + index,refInFor:true,attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'org_' + index,"name":'org_' + index,"select2-options":_vm.orgOptions,"required":true},on:{"input":function($event){return _vm.onOrgSelected($event, index)}},model:{value:(org.orgId),callback:function ($$v) {_vm.$set(org, "orgId", $$v)},expression:"org.orgId"}})],1),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-sm btn-icon",attrs:{"type":"button","title":"ลบ"},on:{"click":function($event){return _vm.removeOrg(index)}}},[_c('i',{staticClass:"la la-trash text-secondary"})])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.addOrg}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("ลำดับการอนุมัติ :")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered table-hover table-approvers"},[_vm._m(3),_vm._v(" "),_c('tbody',[(_vm.formData.approvers.length === 0)?_c('tr',[_vm._m(4)]):_vm._e(),_vm._v(" "),_vm._l((_vm.formData.approvers),function(approver,index){return _c('tr',{key:'approver-' + approver._uid},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_c('select2',{ref:'approverSelect_' + index,refInFor:true,attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'approver_' + index,"name":'approver_' + index,"select2-options":_vm.approverOptions,"required":true},model:{value:(approver.userId),callback:function ($$v) {_vm.$set(approver, "userId", $$v)},expression:"approver.userId"}})],1),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                        ลำดับ "+_vm._s(approver.approvalLevel)+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(approver.approverType),expression:"approver.approverType"}],staticClass:"form-control form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(approver, "approverType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onApproverTypeChanged(index)}]}},[_c('option',{attrs:{"value":"APPROVE"}},[_vm._v("ผู้อนุมัติ")]),_vm._v(" "),_c('option',{attrs:{"value":"CONFIRM"}},[_vm._v("ผู้ยืนยัน")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(approver.emailNotificationType),expression:"approver.emailNotificationType"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(approver, "emailNotificationType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"SEPARATE"}},[_vm._v("แยกใบงาน")]),_vm._v(" "),_c('option',{attrs:{"value":"COMBINED"}},[_vm._v("รวมใบงาน")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(approver.approverType === 'APPROVE')?_c('label',{staticClass:"kt-radio kt-radio--sm",staticStyle:{"margin-bottom":"0"}},[_c('input',{attrs:{"type":"radio","name":"signatureRequired"},domProps:{"value":index,"checked":approver.isSignatureRequired === true},on:{"change":function($event){return _vm.onSignatureChanged(index, true)}}}),_vm._v("\n                          บันทึก\n                          "),_c('span')]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-sm btn-icon",attrs:{"type":"button","title":"ลบ"},on:{"click":function($event){return _vm.removeApprover(index)}}},[_c('i',{staticClass:"la la-trash text-secondary"})])])])})],2)])]),_vm._v(" "),(_vm.formData.approvers.length >= 5)?_c('div',{staticClass:"alert alert-warning mt-3"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v("\n                สามารถเพิ่มผู้อนุมัติได้สูงสุด 5 ระดับเท่านั้น\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.formData.approvers.length >= 5},on:{"click":_vm.addApprover}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section"},[_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":'/BudgetPlan/ApproveGroup'}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n                  ")]),_vm._v(" "),_vm._m(5)],1)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-user-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"text-center"},[_c('th',{staticStyle:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticStyle:{"width":"80%"}},[_vm._v("แผนก")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"3"}},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v(" ยังไม่มีข้อมูลแผนก กรุณาเพิ่มแผนก\n                      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"text-center"},[_c('th',{staticStyle:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticStyle:{"width":"40%"}},[_vm._v("ชื่อพนักงาน")]),_vm._v(" "),_c('th',{staticStyle:{"width":"10%"}},[_vm._v("ลำดับอนุมัติ")]),_vm._v(" "),_c('th',{staticStyle:{"width":"12%"}},[_vm._v("ประเภท")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("รูปแบบอีเมลแจ้งเตือน")]),_vm._v(" "),_c('th',{staticStyle:{"width":"15%"}},[_vm._v("บันทึกลายเซ็นอนุมัติ")]),_vm._v(" "),_c('th',{staticStyle:{"width":"8%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v(" ยังไม่มีข้อมูลผู้อนุมัติ กรุณาเพิ่มผู้อนุมัติ\n                      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึก\n                  ")])}]


/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/AgentStockOverdue'),expression:"$route.path == '/AgentStockOverdue'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.agentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อตัวแทนจำหน่าย(Group):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.headAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.headAgentCode),callback:function ($$v) {_vm.headAgentCode=$$v},expression:"headAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทผู้ถือครอง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.ownerTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.ownerType),callback:function ($$v) {_vm.ownerType=$$v},expression:"ownerType"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.productTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.productType),callback:function ($$v) {_vm.productType=$$v},expression:"productType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.materialCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.materialCode),callback:function ($$v) {_vm.materialCode=$$v},expression:"materialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.brandOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.BrandIdClearAfterSelect,"deselect":_vm.BrandIdClearAfterDeSelect},model:{value:(_vm.brand),callback:function ($$v) {_vm.brand=$$v},expression:"brand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อแบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{ref:"ProductIdBrand",attrs:{"id":"ProductIdBrand","multiple":true,"options":_vm.filteredProductBrandOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.productBrand),callback:function ($$v) {_vm.productBrand=$$v},expression:"productBrand"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ช่วงคงค้าง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.retentionPeriodOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.retentionPeriod),callback:function ($$v) {_vm.retentionPeriod=$$v},expression:"retentionPeriod"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("สถานะ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.barcodeStatusCodeOptions,"clear-on-select":true,"placeholder":"ถังเต็ม"},model:{value:(_vm.barcodeStatusCode),callback:function ($$v) {_vm.barcodeStatusCode=$$v},expression:"barcodeStatusCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary mr-2",attrs:{"type":"button"},on:{"click":_vm.exportCompareReport}},[_vm._m(1)]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.exportReport}},[_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-0"},[(_vm.dataAsOfLabel)?_c('div',{staticClass:"col-xl-12 text-right"},[_c('span',[_vm._v(_vm._s(_vm.dataAsOfLabel))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mt-0"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{ref:"topScrollWrapper",staticStyle:{"overflow-x":"auto","overflow-y":"hidden","height":"20px"}},[_c('div',{ref:"topScrollContent",staticStyle:{"height":"1px"}})]),_vm._v(" "),_c('table',{ref:"stockOverdueTable",staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap hide-full-sub hide-empty-sub hide-transit-sub",staticStyle:{"width":"100%"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"rowspan":"2"}},[_vm._v("ประเภทผู้ถือครอง")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("รหัสแบรนด์สินค้า")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("ชื่อแบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center header-full",attrs:{"colspan":"4"}},[_vm._v("ถังเต็ม")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"cursor":"pointer"},attrs:{"rowspan":"2"},on:{"click":function($event){return _vm.toggleGroup('full')}}},[_vm._v("ถังเต็ม Total "),_c('i',{class:_vm.groupVisible.full ? 'fa fa-minus-square' : 'fa fa-plus-square',staticStyle:{"font-size":"0.8em"}})]),_vm._v(" "),_c('th',{staticClass:"text-center header-empty",attrs:{"colspan":"4"}},[_vm._v("ถังเปล่า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"cursor":"pointer"},attrs:{"rowspan":"2"},on:{"click":function($event){return _vm.toggleGroup('empty')}}},[_vm._v("ถังเปล่า Total "),_c('i',{class:_vm.groupVisible.empty ? 'fa fa-minus-square' : 'fa fa-plus-square',staticStyle:{"font-size":"0.8em"}})]),_vm._v(" "),_c('th',{staticClass:"text-center header-transit",attrs:{"colspan":"4"}},[_vm._v("ระหว่างนำส่ง")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"cursor":"pointer"},attrs:{"rowspan":"2"},on:{"click":function($event){return _vm.toggleGroup('transit')}}},[_vm._v("ระหว่างนำส่ง Total "),_c('i',{class:_vm.groupVisible.transit ? 'fa fa-minus-square' : 'fa fa-plus-square',staticStyle:{"font-size":"0.8em"}})]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2"}},[_vm._v("Grand Total")])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_vm._m(4)])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-chart-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel (สำหรับตรวจสอบข้อมูล)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel (สรุปข้อมูลจากรายงาน)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center sub-header sub-header-1 col-full-sub",staticStyle:{"background-color":"#CCFFCC"}},[_vm._v("ไม่เกิน 1 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center sub-header sub-header-2 col-full-sub",staticStyle:{"background-color":"#FFFDE1"}},[_vm._v("ไม่เกิน 3 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center sub-header sub-header-3 col-full-sub",staticStyle:{"background-color":"#FCE4D6"}},[_vm._v("ไม่เกิน 5 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center sub-header sub-header-4 col-full-sub",staticStyle:{"background-color":"#FFC7CE"}},[_vm._v("เกิน 5 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center sub-header sub-header-1 col-empty-sub",staticStyle:{"background-color":"#CCFFCC"}},[_vm._v("ไม่เกิน 1 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center sub-header sub-header-2 col-empty-sub",staticStyle:{"background-color":"#FFFDE1"}},[_vm._v("ไม่เกิน 3 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center sub-header sub-header-3 col-empty-sub",staticStyle:{"background-color":"#FCE4D6"}},[_vm._v("ไม่เกิน 5 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center sub-header sub-header-4 col-empty-sub",staticStyle:{"background-color":"#FFC7CE"}},[_vm._v("เกิน 5 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center sub-header sub-header-1 col-transit-sub",staticStyle:{"background-color":"#CCFFCC"}},[_vm._v("ไม่เกิน 1 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center sub-header sub-header-2 col-transit-sub",staticStyle:{"background-color":"#FFFDE1"}},[_vm._v("ไม่เกิน 3 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center sub-header sub-header-3 col-transit-sub",staticStyle:{"background-color":"#FCE4D6"}},[_vm._v("ไม่เกิน 5 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center sub-header sub-header-4 col-transit-sub",staticStyle:{"background-color":"#FFC7CE"}},[_vm._v("เกิน 5 เดือน")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr',[_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":"6"}},[_vm._v("Grand Total")]),_vm._v(" "),_c('th',{staticClass:"col-full-sub"}),_c('th',{staticClass:"col-full-sub"}),_c('th',{staticClass:"col-full-sub"}),_c('th',{staticClass:"col-full-sub"}),_c('th'),_vm._v(" "),_c('th',{staticClass:"col-empty-sub"}),_c('th',{staticClass:"col-empty-sub"}),_c('th',{staticClass:"col-empty-sub"}),_c('th',{staticClass:"col-empty-sub"}),_c('th'),_vm._v(" "),_c('th',{staticClass:"col-transit-sub"}),_c('th',{staticClass:"col-transit-sub"}),_c('th',{staticClass:"col-transit-sub"}),_c('th',{staticClass:"col-transit-sub"}),_c('th'),_vm._v(" "),_c('th')])])}]


/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"modalRoot",staticClass:"modal fade",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-l",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content sub-modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('table',{staticClass:"table table-bordered"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.masterProductSpareList),function(part,index){return _c('tr',{key:part.id},[_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(part.materialDesc_th)+" ["+_vm._s(part.materialCode)+"]")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(part.qty),expression:"part.qty",modifiers:{"number":true}}],staticStyle:{"width":"80px","text-align":"center"},attrs:{"type":"number","min":0,"step":"1","placeholder":"0"},domProps:{"value":(part.qty)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(part, "qty", _vm._n($event.target.value))},function($event){return _vm.validateUInt(part)}],"blur":function($event){return _vm.$forceUpdate()}}})])])}),0)])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_vm._m(2),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',[_vm._v("ระบุรายการอะไหล่ซัพพลายเออร์")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"50px !important","text-align":"center"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticStyle:{"width":"300px !important","text-align":"center"}},[_vm._v("ชื่ออะไหล่")]),_vm._v(" "),_c('th',{staticStyle:{"width":"80px !important","text-align":"center"}},[_vm._v("จำนวน")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ")])}]


/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{ref:"select",class:this.cssClass,style:(this.cssStyle),attrs:{"id":this.id,"name":this.name,"multiple":this.multiple}})}
var staticRenderFns = []


/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--last kt-portlet--head-lg kt-portlet--responsive-mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),(_vm.isEdit || _vm.isView)?_c('h3',{staticClass:"kt-portlet__head-title"},[_c('p',{staticClass:"mt-2 mb-0"},[(_vm.isView)?[_vm._v("ดูใบงาน")]:[_vm._v("แก้ไขใบงาน")],_vm._v(" "),_c('strong',[_vm._v("ประเภทตัดยอดคงค้าง")]),_vm._v("\n              เลขที่ "),_c('strong',[_vm._v(_vm._s(_vm.jobNumber))])],2)]):_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            เปิดใบงาน "),_c('strong',[_vm._v("ประเภทตัดยอดคงค้าง")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('button',{staticClass:"btn btn-sm btn-clean kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("กลับ")])]),_vm._v(" "),(_vm.canSave)?_c('button',{staticClass:"btn btn-sm btn-primary kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onSaveClick($event)}}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("บันทึกข้อมูล")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"writeOffStockJobForm",staticClass:"kt-form",attrs:{"autocomplete":"off","id":"writeOffStockJobForm"},on:{"submit":function($event){$event.preventDefault();return _vm.onSaveClick($event)}}},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("ข้อมูลพื้นฐาน:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่เอกสาร (วว/ดด/ปปปป):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"documentDate",staticClass:"form-control",attrs:{"disabled":!_vm.isEditable,"readonly":"","type":"text","placeholder":"วันที่เอกสาร (วว/ดด/ปปปป)","id":"documentDate","name":"documentDate"}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สถานที่ต้นทาง (ย้ายสต๊อกออก):")]),_vm._v(" "),_c('select2',{ref:"originLocationId",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control',"id":'originLocationId',"name":'originLocationId',"select2-options":_vm.originLocationIdOptions},on:{"selectChange":_vm.onOriginLocationChange},model:{value:(_vm.originLocationId),callback:function ($$v) {_vm.originLocationId=$$v},expression:"originLocationId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สถานที่ปลายทาง (ย้ายสต๊อกเข้า):")]),_vm._v(" "),_c('select2',{ref:"destinationLocationId",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control',"id":'destinationLocationId',"name":'destinationLocationId',"select2-options":_vm.destinationLocationIdOptions},on:{"selectChange":_vm.onDestinationLocationChange},model:{value:(_vm.destinationLocationId),callback:function ($$v) {_vm.destinationLocationId=$$v},expression:"destinationLocationId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้า/ทรัพย์สิน (มี BARCODE):")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.groupedItems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-right",attrs:{"colspan":"4"}},[_vm._v("\n                          สแกน BARCODE เพื่อเพิ่มรายการสินค้า\n                        ")]),_vm._v(" "),_c('td')]):_vm._e(),_vm._v(" "),_vm._l((_vm.groupedItems),function(group,gi){return _c('tr',{key:'grp-' + group.materialCode},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(gi + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(group.materialName)+" ["+_vm._s(group.materialCode)+"]")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(group.barcodes.length)))]),_vm._v(" "),_c('td',[_c('input',{staticClass:"form-control",attrs:{"type":"text","maxlength":"1000","placeholder":"หมายเหตุ","readonly":!_vm.isEditable},domProps:{"value":_vm.barcodeGroupRemarks[group.materialCode] || ''},on:{"input":function($event){return _vm.onBarcodeGroupRemarkInput(group.materialCode, $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-sm btn-outline-info btn-icon kt-margin-r-5",attrs:{"type":"button","title":"แสดงรายการ BARCODE"},on:{"click":function($event){$event.preventDefault();return _vm.onShowBarcodeList(group)}}},[_c('i',{staticClass:"la la-list"})]),_vm._v(" "),(_vm.isEditable)?_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"ลบรายการ (ลบ BARCODE ทั้งหมดของสินค้านี้)"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveGroup(group)}}},[_c('i',{staticClass:"text-danger la la-trash"})]):_vm._e()])])})],2),_vm._v(" "),(_vm.isEditable)?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('div',{staticClass:"form-group mb-0"},[_c('div',{staticClass:"input-group"},[_vm._m(3),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.scanForm.barcode),expression:"scanForm.barcode"}],ref:"scanInput",staticClass:"form-control form-control-sm",attrs:{"placeholder":"กรอก BARCODE หลายตัวคั่นด้วย , หรือ Enter ลงบรรทัด แล้วคลิกปุ่มบันทึกบาร์โค้ด","rows":"3"},domProps:{"value":(_vm.scanForm.barcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.scanForm, "barcode", $event.target.value)}}})])])]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[_c('button',{staticClass:"btn btn-sm btn-warning",attrs:{"type":"button","disabled":_vm.scanForm.isLoading || !_vm.scanForm.barcode},on:{"click":function($event){$event.preventDefault();return _vm.submitScan($event)}}},[_c('i',{staticClass:"fa fa-barcode"}),_vm._v(" บันทึกบาร์โค้ด\n                          ")]),_vm._v(" "),(_vm.scanMessage)?_c('span',{staticClass:"ml-3 text-info"},[_c('i',{staticClass:"la la-info-circle"}),_vm._v(" "+_vm._s(_vm.scanMessage)+"\n                          ")]):_vm._e()])])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(5),_vm._v(" "),_c('tbody',[(_vm.itemsWithoutBarcode.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"5"}},[_vm._v("\n                          ยังไม่มีรายการ — คลิก \"+ เพิ่มรายการใหม่\" เพื่อเพิ่มสินค้าที่ไม่มี BARCODE\n                        ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.itemsWithoutBarcode),function(nb,ni){return _c('tr',{key:'nb-' + nb._uid},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(ni + 1))]),_vm._v(" "),_c('td',[_c('treeselect',{attrs:{"disabled":!_vm.isEditable,"multiple":false,"options":_vm.nonBarcodeProductTreeOptions,"placeholder":"เลือกสินค้า/ทรัพย์สิน (ไม่มี BARCODE)","clearable":true},on:{"select":function (node) { return _vm.onNonBarcodeTreeSelect(nb, node); },"input":function (val) { return _vm.onNonBarcodeTreeInput(nb, val); }},model:{value:(nb.materialCode),callback:function ($$v) {_vm.$set(nb, "materialCode", $$v)},expression:"nb.materialCode"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(nb.quantity),expression:"nb.quantity",modifiers:{"number":true}}],staticClass:"form-control text-right",attrs:{"type":"number","min":"1","readonly":!_vm.isEditable},domProps:{"value":(nb.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(nb, "quantity", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(nb.remark),expression:"nb.remark"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"หมายเหตุ","readonly":!_vm.isEditable},domProps:{"value":(nb.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(nb, "remark", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.isEditable)?_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"ลบรายการนี้"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveNonBarcodeRow(ni)}}},[_c('i',{staticClass:"text-danger la la-trash"})]):_vm._e()])])})],2),_vm._v(" "),(_vm.isEditable)?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_c('button',{staticClass:"btn btn-sm btn-outline-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddNonBarcodeRow($event)}}},[_c('i',{staticClass:"la la-plus"}),_vm._v(" เพิ่มรายการใหม่\n                          ")])])])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[(_vm.isEditable)?_c('div',{staticClass:"mb-3"},[_c('input',{ref:"fileInputWriteOff",staticStyle:{"display":"none"},attrs:{"type":"file","accept":".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png","multiple":""},on:{"change":_vm.handleFileSelect}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.uploadingFile},on:{"click":function($event){return _vm.$refs.fileInputWriteOff.click()}}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v("\n                  "+_vm._s(_vm.uploadingFile ? 'กำลังอัพโหลด...' : 'เลือกไฟล์')+"\n                ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                  รองรับไฟล์: PDF, Word, Excel, รูปภาพ (สูงสุด 10 MB ต่อไฟล์)\n                ")])]):_vm._e(),_vm._v(" "),(_vm.uploadFiles && _vm.uploadFiles.length > 0)?_c('div',{staticClass:"mt-2"},[_c('draggable',{staticClass:"row",attrs:{"disabled":!_vm.isEditable,"handle":".drag-handle"},on:{"end":_vm.onFileDragEnd},model:{value:(_vm.uploadFiles),callback:function ($$v) {_vm.uploadFiles=$$v},expression:"uploadFiles"}},_vm._l((_vm.uploadFiles),function(file,index){return _c('div',{key:file.jobAttachmentId || file.reference || ('new-' + index),staticClass:"col-auto m--margin-top-20 img-wrap",staticStyle:{"position":"relative","width":"130px"}},[(_vm.isEditable)?_c('div',{staticClass:"drag-handle text-center",staticStyle:{"cursor":"move","padding":"2px 0"},attrs:{"title":"ลากเพื่อจัดลำดับ"}},[_c('i',{staticClass:"fas fa-grip-horizontal text-muted"})]):_vm._e(),_vm._v(" "),(_vm.isImageFile(file.fileName))?_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[(file.url || file.fileUrl)?_c('img',{staticClass:"img-thumbnail",staticStyle:{"width":"100px","height":"100px","object-fit":"cover"},attrs:{"src":file.url || file.fileUrl,"alt":file.fileName}}):_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","background":"#f8f9fa"}},[_c('i',{staticClass:"fas fa-spinner fa-spin text-muted"}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"font-size":"10px"}},[_vm._v("กำลังโหลด...")])])]):_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[_c('i',{class:_vm.getFileIcon(file.fileName),staticStyle:{"font-size":"28px"}}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0 text-truncate",staticStyle:{"max-width":"90px","font-size":"10px"},attrs:{"title":file.fileName}},[_vm._v(_vm._s(file.fileName))])]),_vm._v(" "),(_vm.isEditable)?_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","bottom":"22px","right":"10px","z-index":"10","transform":"scale(0.75)"},attrs:{"href":"javascript:;","title":"ลบไฟล์"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveAttachment(index)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-1 text-center"},[_c('p',{staticClass:"mb-0 text-truncate",staticStyle:{"max-width":"100px","font-size":"10px","font-weight":"bold"},attrs:{"title":file.fileName}},[_vm._v("\n                        "+_vm._s(file.fileName)+"\n                      ")])])])}),0)],1):_c('div',{staticClass:"text-center text-muted py-3 border rounded mt-2"},[_c('i',{staticClass:"fas fa-file-upload fa-2x mb-2"}),_vm._v(" "),_c('p',{staticClass:"mb-0 small"},[_vm._v("ยังไม่มีไฟล์แนบ กรุณาแนบไฟล์อย่างน้อย 1 ไฟล์")])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมายเหตุ:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remark),expression:"remark"}],staticClass:"form-control",attrs:{"readonly":!_vm.isEditable,"placeholder":"หมายเหตุ","rows":"5","maxlength":"1000"},domProps:{"value":(_vm.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.remark=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text text-muted text-right"},[_vm._v(_vm._s((_vm.remark || '').length)+" / 1000 อักษร")])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot kt-portlet__foot--md kt-margin-t-20"},[_c('div',{staticClass:"kt-form__actions text-right"},[_c('button',{staticClass:"btn btn-sm btn-clean kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("กลับ")])]),_vm._v(" "),(_vm.canSave)?_c('button',{staticClass:"btn btn-sm btn-primary kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onSaveClick($event)}}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("บันทึกข้อมูล")])]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{ref:"barcodeListModal",staticClass:"modal fade",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"barcodeListModalTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.modalGroup ? (_vm.modalGroup.materialName + ' [' + _vm.modalGroup.materialCode + ']') : ''}})]),_vm._v(" "),_c('div',{staticClass:"row align-items-center mb-2"},[_c('div',{staticClass:"col-sm-6"},[_c('span',{staticClass:"text-muted"},[_vm._v("\n                Showing "+_vm._s(_vm.modalShowingFrom)+" to "+_vm._s(_vm.modalShowingTo)+" of "+_vm._s(_vm.modalTotalEntries)+" entries\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-right"},[_c('div',{staticClass:"d-inline-flex align-items-center"},[_c('label',{staticClass:"mb-0 mr-2"},[_vm._v("Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.modalPageSize),expression:"modalPageSize",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",staticStyle:{"width":"auto"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.modalPageSize=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onModalPageSizeChange]}},[_c('option',{domProps:{"value":50}},[_vm._v("50")]),_vm._v(" "),_c('option',{domProps:{"value":100}},[_vm._v("100")]),_vm._v(" "),_c('option',{domProps:{"value":200}},[_vm._v("200")]),_vm._v(" "),_c('option',{domProps:{"value":500}},[_vm._v("500")])])]),_vm._v(" "),_c('nav',{staticClass:"d-inline-block ml-2"},[_c('ul',{staticClass:"pagination pagination-sm justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ disabled: _vm.modalCurrentPage === 1 || _vm.modalTotalPages === 0 }},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.modalPrev($event)}}},[_vm._v("Previous")])]),_vm._v(" "),_vm._l((_vm.modalTotalPages),function(p){return _c('li',{key:'mpg-top-' + p,staticClass:"page-item",class:{ active: p === _vm.modalCurrentPage }},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.modalGoToPage(p)}}},[_vm._v(_vm._s(p))])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ disabled: _vm.modalCurrentPage === _vm.modalTotalPages || _vm.modalTotalPages === 0 }},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.modalNext($event)}}},[_vm._v("Next")])])],2)])])]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-striped table-bordered"},[_vm._m(8),_vm._v(" "),_c('tbody',[(!_vm.modalGroup || _vm.modalGroup.barcodes.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"8"}},[_vm._v("ไม่มีข้อมูล")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.modalPagedBarcodes),function(bc,bi){return _c('tr',{key:'mbc-' + ((_vm.modalCurrentPage - 1) * _vm.modalPageSize + bi)},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s((_vm.modalCurrentPage - 1) * _vm.modalPageSize + bi + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(bc.barcodeNoOld || bc.barcodeNo))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(bc.departmentMaterialCode || '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(bc.barcodeYear || '-'))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(bc.unitPrice != null ? _vm.formatNumber(bc.unitPrice) : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatScanDate(bc.scanDate)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(bc.scannedByName || '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.isEditable)?_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"ลบ BARCODE นี้"},on:{"click":function($event){$event.preventDefault();_vm.onRemoveBarcode(_vm.modalGroup, (_vm.modalCurrentPage - 1) * _vm.modalPageSize + bi)}}},[_c('i',{staticClass:"text-danger la la-trash"})]):_vm._e()])])})],2)]),_vm._v(" "),_c('div',{staticClass:"row align-items-center mt-2"},[_c('div',{staticClass:"col-sm-6"},[_c('span',{staticClass:"text-muted"},[_vm._v("\n                Showing "+_vm._s(_vm.modalShowingFrom)+" to "+_vm._s(_vm.modalShowingTo)+" of "+_vm._s(_vm.modalTotalEntries)+" entries\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-right"},[_c('div',{staticClass:"d-inline-flex align-items-center"},[_c('label',{staticClass:"mb-0 mr-2"},[_vm._v("Display")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.modalPageSize),expression:"modalPageSize",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",staticStyle:{"width":"auto"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.modalPageSize=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onModalPageSizeChange]}},[_c('option',{domProps:{"value":50}},[_vm._v("50")]),_vm._v(" "),_c('option',{domProps:{"value":100}},[_vm._v("100")]),_vm._v(" "),_c('option',{domProps:{"value":200}},[_vm._v("200")]),_vm._v(" "),_c('option',{domProps:{"value":500}},[_vm._v("500")])])]),_vm._v(" "),_c('nav',{staticClass:"d-inline-block ml-2"},[_c('ul',{staticClass:"pagination pagination-sm justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ disabled: _vm.modalCurrentPage === 1 || _vm.modalTotalPages === 0 }},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.modalPrev($event)}}},[_vm._v("Previous")])]),_vm._v(" "),_vm._l((_vm.modalTotalPages),function(p){return _c('li',{key:'mpg-bot-' + p,staticClass:"page-item",class:{ active: p === _vm.modalCurrentPage }},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.modalGoToPage(p)}}},[_vm._v(_vm._s(p))])])}),_vm._v(" "),_c('li',{staticClass:"page-item",class:{ disabled: _vm.modalCurrentPage === _vm.modalTotalPages || _vm.modalTotalPages === 0 }},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.modalNext($event)}}},[_vm._v("Next")])])],2)])])])]),_vm._v(" "),_vm._m(9)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-priceTier flaticon2-writing"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"50%"}},[_vm._v("สินค้า/ทรัพย์สิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("หมายเหตุ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-barcode"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              รายการสินค้า/ทรัพย์สิน (ไม่มี BARCODE):\n              "),_c('small',{staticClass:"text-muted"},[_vm._v("(ตัดยอดคงค้างของสินค้า/ทรัพย์สินที่ไม่มี BARCODE)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"50%"}},[_vm._v("สินค้า/ทรัพย์สิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("หมายเหตุ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              ไฟล์เอกสารแนบ: "),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("(บังคับแนบอย่างน้อย 1 ไฟล์ — ลากเพื่อจัดลำดับ)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"barcodeListModalTitle"}},[_vm._v("\n            รายการบาร์โค้ด\n          ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"6%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ปี(สินค้า)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"12%"}},[_vm._v("ราคา(สินค้า)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("เวลาสแกน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"12%"}},[_vm._v("โดย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("ปิด")])])}]


/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เลขทะเบียน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trcCarReg),expression:"trcCarReg"}],staticClass:"form-control",attrs:{"id":"trcCarReg","name":"trcCarReg","type":"text","maxlength":"256","placeholder":"เลขทะเบียน"},domProps:{"value":(_vm.trcCarReg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trcCarReg=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทบริษัท:")]),_vm._v(" "),_c('select2',{ref:"trcCompanyTypeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'trcCompanyType',"name":'trcCompanyType',"select2-options":_vm.trcCompanyTypeOptions},model:{value:(_vm.trcCompanyType),callback:function ($$v) {_vm.trcCompanyType=$$v},expression:"trcCompanyType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("บริษัท:")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.trcCompanyType == 'agent'),expression:"trcCompanyType == 'agent'"}]},[_c('select2',{ref:"trcAgentIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'trcAgentId',"name":'trcAgentId',"select2-options":_vm.trcAgentOptions},model:{value:(_vm.trcAgentId),callback:function ($$v) {_vm.trcAgentId=$$v},expression:"trcAgentId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.trcCompanyType == 'vendor'),expression:"trcCompanyType == 'vendor'"}]},[_c('select2',{ref:"trcVendorIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'trcVendorId',"name":'trcVendorId',"select2-options":_vm.trcVendorOptions},on:{"selectChange":_vm.VenderChange},model:{value:(_vm.trcCompanyId),callback:function ($$v) {_vm.trcCompanyId=$$v},expression:"trcCompanyId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.trcCompanyType),expression:"!trcCompanyType"}]},[_c('select2',{ref:"trcCompanyIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'trcCompanyId',"name":'trcCompanyId',"select2-options":_vm.trcCompanyIdOptions},model:{value:(_vm.trcCompanyId),callback:function ($$v) {_vm.trcCompanyId=$$v},expression:"trcCompanyId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อคนขับ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trcDriverFirstName),expression:"trcDriverFirstName"}],staticClass:"form-control",attrs:{"id":"trcDriverFirstName","name":"trcDriverFirstName","type":"text","maxlength":"256","placeholder":"ชื่อ"},domProps:{"value":(_vm.trcDriverFirstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trcDriverFirstName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("นามสกุล")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trcDriverLastName),expression:"trcDriverLastName"}],staticClass:"form-control",attrs:{"id":"trcDriverLastName","name":"trcDriverLastName","type":"text","maxlength":"256","placeholder":"นามสกุล"},domProps:{"value":(_vm.trcDriverLastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trcDriverLastName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trcDriverTel),expression:"trcDriverTel"}],staticClass:"form-control",attrs:{"id":"trcDriverTel","name":"trcDriverTel","type":"text","maxlength":"256","placeholder":"เบอร์ติดต่อ"},domProps:{"value":(_vm.trcDriverTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trcDriverTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row col-xl-12 w3-container"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ประสานงาน(Boonrawd):")]),_vm._v(" "),_c('select2',{ref:"trcEmpIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'trcEmpId',"name":'trcEmpId',"select2-options":_vm.trcEmpIdOptions},on:{"selectChange":_vm.onTrcEmpIdChange},model:{value:(_vm.trcEmpId),callback:function ($$v) {_vm.trcEmpId=$$v},expression:"trcEmpId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trcEmpTel),expression:"trcEmpTel"}],staticClass:"form-control",attrs:{"id":"trcEmpTel","name":"trcEmpTel","type":"text","maxlength":"256","placeholder":"เบอร์ติดต่อ"},domProps:{"value":(_vm.trcEmpTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trcEmpTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trcEmpEmail),expression:"trcEmpEmail"}],staticClass:"form-control",attrs:{"id":"trcEmpEmail","name":"trcEmpEmail","type":"text","maxlength":"256","placeholder":"อีเมล"},domProps:{"value":(_vm.trcEmpEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trcEmpEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ตำแหน่ง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trcEmpPosition),expression:"trcEmpPosition"}],staticClass:"form-control",attrs:{"id":"trcEmpPosition","name":"trcEmpPosition","type":"text","maxlength":"256","placeholder":"ตำแหน่ง"},domProps:{"value":(_vm.trcEmpPosition)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trcEmpPosition=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row col-xl-12 w3-container"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ประสานงาน(ภายนอก):")]),_vm._v(" "),_c('select2',{ref:"trcTransitContactorIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'trcTransitContactorId',"name":'trcTransitContactorId',"select2-options":_vm.trcTransitContactorIdOptions},on:{"selectChange":_vm.onTrcTransitContactorIdChange},model:{value:(_vm.trcTransitContactorId),callback:function ($$v) {_vm.trcTransitContactorId=$$v},expression:"trcTransitContactorId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trcTransitContactorTel),expression:"trcTransitContactorTel"}],staticClass:"form-control",attrs:{"id":"trcTransitContactorTel","name":"trcTransitContactorTel","type":"text","maxlength":"256","placeholder":"เบอร์ติดต่อ"},domProps:{"value":(_vm.trcTransitContactorTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trcTransitContactorTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trcTransitContactorEmail),expression:"trcTransitContactorEmail"}],staticClass:"form-control",attrs:{"id":"trcTransitContactorEmail","name":"trcTransitContactorEmail","type":"text","maxlength":"256","placeholder":"อีเมล"},domProps:{"value":(_vm.trcTransitContactorEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trcTransitContactorEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ตำแหน่ง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trcTransitContactorPosition),expression:"trcTransitContactorPosition"}],staticClass:"form-control",attrs:{"id":"trcTransitContactorPosition","name":"trcTransitContactorPosition","type":"text","maxlength":"256","placeholder":"ตำแหน่ง"},domProps:{"value":(_vm.trcTransitContactorPosition)},on:{"input":function($event){if($event.target.composing){ return; }_vm.trcTransitContactorPosition=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.trcInActiveStatus),expression:"trcInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"trcInActiveStatus","id":"trcInActiveStatus"},domProps:{"checked":Array.isArray(_vm.trcInActiveStatus)?_vm._i(_vm.trcInActiveStatus,null)>-1:(_vm.trcInActiveStatus)},on:{"change":function($event){var $$a=_vm.trcInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.trcInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.trcInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.trcInActiveStatus=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                    เปิดใช้งาน\n                    "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("เพิ่มข้อมูลขนส่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])}]


/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"agentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'agentCode',"name":'agentCode',"select2-options":_vm.agentCodeOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลปี :")]),_vm._v(" "),_c('select2',{ref:"year",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'year',"name":'year',"select2-options":_vm.yearOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)])]),_vm._v(" "),(_vm.year && _vm.canExportAllAgents && !_vm.isShow)?_c('div',{staticClass:"d-flex justify-content-end align-items-center mb-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n              "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.isShow == true)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              รายการจำนวนเครื่องเบียร์สดสูญหาย :\n            ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingSelected},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelSelected($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)")+"\n                ")])]),_vm._v(" "),(_vm.canExportAllAgents)?_c('button',{staticClass:"btn btn-outline-primary ml-2",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"2500px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"3%"}},[_vm._v("\n                        ลำดับ\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"10%"}},[_vm._v("\n                        ประเภทสินค้า\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        ต้นทุนสินค้า(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"12","scope":"colgroup"}},[_vm._v("\n                        จำนวนเครื่องเบียร์สดสูญหาย (จำนวน) ปี "+_vm._s(_vm.year)+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้ารวม(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้าเฉลี่ย(บาท/เดือน)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        จัดการ\n                      ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('tbody',{on:{"change":function($event){return _vm.changeTotal()}}},[(_vm.productitems == null || _vm.productitems.length == 0)?_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"18"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.productitems),function(item,i){return [_c('product-item-row',{key:i,ref:"Items",refInFor:true,attrs:{"rowIndex":i,"item":item,"kPIProductType":_vm.kPIProductType,"yearSelected":_vm.year},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"3%"}}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รวมเงิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_vm._l((12),function(index){return _c('th',{key:index,staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalMonth[index]," ", 0))+"\n                      ")])}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalPoductCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalProductCostOfMonth,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th')],2),_vm._v(" "),_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{attrs:{"colspan":"18"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[(_vm.isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand fas fa-wrench"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มกราคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กุมภาพันธ์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มีนาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("เมษายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤษภาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มิถุนายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กรกฎาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("สิงหาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กันยายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ตุลาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤศจิกายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ธันวาคม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])}]


/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n                    "+_vm._s(this.$route.meta.breadcrumb)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"agentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'agentCode',"name":'agentCode',"select2-options":_vm.agentCodeOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลปี :")]),_vm._v(" "),_c('select2',{ref:"year",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'year',"name":'year',"select2-options":_vm.yearOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)])]),_vm._v(" "),(_vm.year && _vm.canExportAllAgents && !_vm.isShow)?_c('div',{staticClass:"d-flex justify-content-end align-items-center mb-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                            "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n                        ")])])]):_vm._e(),_vm._v(" "),(_vm.isShow == true)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                            รายการจำนวนสินค้าที่เคลื่อนไหวช้าจำแนกตามมูลค่าสินค้า :\n                        ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingSelected},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelSelected($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                                    "+_vm._s(_vm.isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)")+"\n                                ")])]),_vm._v(" "),(_vm.canExportAllAgents)?_c('button',{staticClass:"btn btn-outline-primary ml-2",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                                    "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n                                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"2500px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"3%"}},[_vm._v("\n                                                ลำดับ\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"10%"}},[_vm._v("\n                                                ประเภทสินค้า\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                                                ต้นทุนสินค้า(บาท)\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"12","scope":"colgroup"}},[_vm._v("\n                                                จำนวนสินค้าที่เคลื่อนไหวช้า (จำนวน) ปี "+_vm._s(_vm.year)+"\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                                                มูลค่าสินค้ารวม(บาท)\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                                                มูลค่าสินค้าเฉลี่ย(บาท/เดือน)\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                                                จัดการ\n                                            ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('tbody',{on:{"change":function($event){return _vm.changeTotal()}}},[(_vm.productitems == null || _vm.productitems.length == 0)?_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"18"}},[_vm._v("\n                                                คลิก + เพื่อเพิ่มรายการใหม่\n                                            ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.productitems),function(item,i){return [_c('product-item-row',{key:i,ref:"Items",refInFor:true,attrs:{"rowIndex":i,"item":item,"kPIProductType":_vm.kPIProductType,"yearSelected":_vm.year},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"3%"}}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รวมเงิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("\n                                                "+_vm._s(_vm._f("currency")(_vm.totalCost,"฿ ", 2))+"\n                                            ")]),_vm._v(" "),_vm._l((12),function(index){return _c('th',{key:index,staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                                                "+_vm._s(_vm._f("currency")(_vm.totalMonth[index]," ", 0))+"\n                                            ")])}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                                                "+_vm._s(_vm._f("currency")(_vm.totalPoductCost,"฿ ", 2))+"\n                                            ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                                                "+_vm._s(_vm._f("currency")(_vm.totalProductCostOfMonth,"฿ ", 2))+"\n                                            ")]),_vm._v(" "),_c('th')],2),_vm._v(" "),_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{attrs:{"colspan":"18"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                                                ")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[(_vm.isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n            ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มกราคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กุมภาพันธ์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มีนาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("เมษายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤษภาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มิถุนายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กรกฎาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("สิงหาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กันยายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ตุลาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤศจิกายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ธันวาคม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])}]


/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modalRoot",staticClass:"modal fade",attrs:{"id":"formSummaryStockAttachmentModal","tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{ref:"modalContent",staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_c('i',{staticClass:"fas fa-paperclip"}),_vm._v(" แนบไฟล์เอกสาร\n          "),(_vm.documentNo)?_c('small',{staticClass:"text-muted"},[_vm._v("\n            — เลขที่เอกสาร "+_vm._s(_vm.documentNo)+"\n          ")]):_vm._e()]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row align-items-center mb-3"},[_c('div',{staticClass:"col-sm-6"},[_c('span',{staticClass:"kt-font-bold fss-attach__counter"},[_vm._v("\n              "+_vm._s(_vm.fileCount)+" / "+_vm._s(_vm.maxFiles)+" ไฟล์\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-sm-right"},[(_vm.fileCount > 0)?_c('button',{staticClass:"fss-act-pill",attrs:{"type":"button","data-test":"fss-attach-download-all","disabled":_vm.downloadingAll},on:{"click":_vm.downloadAll}},[_c('i',{staticClass:"fas",class:_vm.downloadingAll ? 'fa-spinner fa-spin' : 'fa-arrow-circle-down'}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.downloadingAll ? "กำลังรวมไฟล์..." : "ดาวน์โหลดทั้งหมด"))])]):_vm._e(),_vm._v(" "),(_vm.isFull)?_c('span',{staticClass:"kt-font-danger d-block mt-1"},[_vm._v("\n              แนบครบแล้ว กรุณาลบไฟล์เดิมก่อนจึงจะแนบไฟล์ใหม่ได้\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-responsive mt-3"},[_c('table',{staticClass:"table table-sm table-bordered table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.fileCount === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"6"}},[_vm._v("\n                  ยังไม่มีไฟล์แนบในใบงานนี้\n                ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.files),function(file,index){return _c('tr',{key:file.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticClass:"text-left fss-attach__filename"},[_c('i',{class:_vm.typeIcon(file)}),_vm._v(" "+_vm._s(file.fileName)+"\n                  "),_vm._v(" "),(_vm.isDownloadOnly(file))?_c('div',{staticClass:"fss-attach__notice",attrs:{"data-test":"fss-attach-download-only-note"}},[_vm._v("\n                    Excel/Word ดูออนไลน์ไม่ได้ — ต้องดาวน์โหลดเปิดดูในเครื่อง\n                  ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.typeLabel(file)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(file.sizeText || "-"))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDate(file.uploadedAt)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"fss-act-group"},[(file.canPreview)?_c('a',{staticClass:"fss-act fss-act--sm fss-act--blue",attrs:{"href":"#","title":"ดูรายละเอียด","data-test":"fss-attach-view"},on:{"click":function($event){$event.preventDefault();return _vm.viewFile(file)}}},[_c('i',{staticClass:"fas fa-search"})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"fss-act fss-act--sm fss-act--green",class:{ 'fss-act--disabled': _vm.downloadingId === file.id },attrs:{"href":"#","title":"ดาวน์โหลด","data-test":"fss-attach-download"},on:{"click":function($event){$event.preventDefault();return _vm.downloadFile(file)}}},[_c('i',{staticClass:"fas",class:_vm.downloadingId === file.id ? 'fa-spinner fa-spin' : 'fa-arrow-circle-down'})]),_vm._v(" "),_c('a',{staticClass:"fss-act fss-act--sm fss-act--red",attrs:{"href":"#","title":"ลบไฟล์","data-test":"fss-attach-delete"},on:{"click":function($event){$event.preventDefault();return _vm.confirmDelete(file)}}},[_c('i',{staticClass:"fas fa-trash"})])])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"fss-attach__dropzone",class:{
            'fss-attach__dropzone--over': _vm.isDragOver,
            'fss-attach__dropzone--disabled': _vm.isFull || _vm.uploading,
          },on:{"click":_vm.pickFile,"dragover":function($event){$event.preventDefault();return _vm.onDragOver($event)},"dragenter":function($event){$event.preventDefault();return _vm.onDragOver($event)},"dragleave":function($event){$event.preventDefault();return _vm.onDragLeave($event)},"drop":function($event){$event.preventDefault();return _vm.onDrop($event)}}},[_c('i',{staticClass:"fas fa-cloud-upload-alt fss-attach__dropzone-icon"}),_vm._v(" "),_c('div',{staticClass:"fss-attach__dropzone-title"},[_vm._v("\n            คลิกเพื่อเลือกไฟล์ หรือลากไฟล์มาวางที่นี่\n          ")]),_vm._v(" "),_c('div',{staticClass:"fss-attach__dropzone-hint"},[_vm._v("\n            รองรับ PDF, Word (.doc/.docx), Excel (.xls/.xlsx) และรูปภาพ (.jpg/.png)\n            — ขนาดไม่เกิน 10 MB ต่อไฟล์ สูงสุด "+_vm._s(_vm.maxFiles)+" ไฟล์ต่อใบงาน\n          ")])]),_vm._v(" "),_c('input',{ref:"fileInput",staticClass:"fss-attach__input",attrs:{"type":"file","multiple":"","accept":_vm.acceptAttr},on:{"change":_vm.onFileChange}})]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"8%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-left",staticStyle:{"width":"36%"}},[_vm._v("ชื่อไฟล์")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%"}},[_vm._v("ชนิด")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%"}},[_vm._v("ขนาด")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"17%"}},[_vm._v("วันเวลาที่อัพโหลด")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n        ")])])}]


/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/TransferBarcodeMultiple'),expression:"$route.path == '/Report/TransferBarcodeMultiple'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"reTbOriginAgentCode",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reTbOriginAgentCode',"name":'reTbOriginAgentCode',"select2-options":_vm.reTbOriginAgentCodeOptions},on:{"selectChange":_vm.onOriginAgentCodeChange},model:{value:(_vm.reTbOriginAgentCode),callback:function ($$v) {_vm.reTbOriginAgentCode=$$v},expression:"reTbOriginAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('treeselect',{ref:"reTbDestinationShopCode",attrs:{"async":true,"multiple":true,"load-options":_vm.LoadreTbDestinationShopCodeOptions,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadTbDestinationShopCodeOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.reTbDestinationShopCode),callback:function ($$v) {_vm.reTbDestinationShopCode=$$v},expression:"reTbDestinationShopCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbAmpherIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbAmpherId),callback:function ($$v) {_vm.reTbAmpherId=$$v},expression:"reTbAmpherId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reTbBarcode),expression:"reTbBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reTbBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reTbBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreTbDepartmentMaterialCodeOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reTbDepartmentMaterialCode),callback:function ($$v) {_vm.reTbDepartmentMaterialCode=$$v},expression:"reTbDepartmentMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbProductTypeId),callback:function ($$v) {_vm.reTbProductTypeId=$$v},expression:"reTbProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbBrandId),callback:function ($$v) {_vm.reTbBrandId=$$v},expression:"reTbBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbAssetCode),callback:function ($$v) {_vm.reTbAssetCode=$$v},expression:"reTbAssetCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จำนวนวันคงค้าง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reTbOccupiedDays),expression:"reTbOccupiedDays"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุจำนวนวันคงค้าง"},domProps:{"value":(_vm.reTbOccupiedDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reTbOccupiedDays=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reTbReturnStatus',"name":'reTbReturnStatus',"select2-options":_vm.reTbReturnStatusOptions},model:{value:(_vm.reTbReturnStatus),callback:function ($$v) {_vm.reTbReturnStatus=$$v},expression:"reTbReturnStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[(
                  this.$root.canShow(['AGENT_REPORT', 'SUB_AGENT_REPORT'])
                )?_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportTransferBarcode}},[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('hr')])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"importBudgetPlanModal","tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{ref:"importForm"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('select2',{ref:"importYearSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'importYearSelect',"name":'importYearSelect',"select2-options":_vm.yearOptions},model:{value:(_vm.importYear),callback:function ($$v) {_vm.importYear=$$v},expression:"importYear"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{ref:"importFileInput",staticClass:"custom-file-input",attrs:{"type":"file","id":"importFile","accept":".xlsx"},on:{"change":_vm.onFileChange}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",attrs:{"for":"importFile"}},[_vm._v("\n                    "+_vm._s(_vm.importFileName || 'เลือกไฟล์...')+"\n                  ")])]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                  รองรับไฟล์ .xlsx เท่านั้น\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n              ยกเลิก\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.importYear || !_vm.importFile},on:{"click":_vm.submitImport}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v(" นำเข้าข้อมูล\n            ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/BudgetPlan/List'),expression:"$route.path == '/BudgetPlan/List'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(3),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("CCTR :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCCTR),expression:"searchCCTR"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"พิมพ์คำค้นหาจาก รหัส CCTR, ชื่อ CCTR สามารถคั่นระหว่างคำด้วย(ลูกน้ำ) เช่น 122570268,122570269"},domProps:{"value":(_vm.searchCCTR)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchCCTR=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปีงบประมาณ :")]),_vm._v(" "),_c('select2',{ref:"budgetList_yearKeySelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'budgetList_yearKey',"name":'budgetList_yearKey',"select2-options":_vm.searchYearOptions},model:{value:(_vm.searchYear),callback:function ($$v) {_vm.searchYear=$$v},expression:"searchYear"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"budgetList_statusKeySelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'budgetList_statusKey',"name":'budgetList_statusKey',"select2-options":_vm.statusOptions},model:{value:(_vm.searchStatus),callback:function ($$v) {_vm.searchStatus=$$v},expression:"searchStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                ค้นหา\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(_vm.canEdit)?_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":_vm.downloadTemplate}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Download Template\n              ")]):_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":_vm.showImportModal}},[_c('i',{staticClass:"fas fa-file-import"}),_vm._v(" Import แผนงบประมาณ\n              ")]):_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.goToCreate}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" เพิ่มแผนงบประมาณ\n              ")]):_vm._e()])])]),_vm._v(" "),_vm._m(4)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Import แผนงบประมาณ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("ปีงบประมาณ "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("ไฟล์ Excel (.xlsx) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-file-invoice-dollar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"budgetPlanTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-center",staticStyle:{"width":"15%"}},[_vm._v("รหัส CCTR")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"35%"}},[_vm._v("ชื่อ CCTR")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"15%"}},[_vm._v("ปีงบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"12%"}},[_vm._v("วันที่บันทึกล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"13%"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"10%"}},[_vm._v("คำสั่ง")])])])])])])}]


/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/FixedProducts'),expression:"$route.path == '/Report/FixedProducts'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reFrJobDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reFrJobDateStart","name":"reFrJobDateStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reFrJobDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reFrJobDateEnd","name":"reFrJobDateEnd"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reFrBarcode),expression:"reFrBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reFrBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reFrBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreFrDepartmentMaterialCodeOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reFrDepartmentMaterialCode),callback:function ($$v) {_vm.reFrDepartmentMaterialCode=$$v},expression:"reFrDepartmentMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่เอกสาร:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reFrJobNumber),expression:"reFrJobNumber"}],staticClass:"form-control",attrs:{"type":"text","rows":"1","placeholder":"ค้นหาจาก เลขที่เอกสาร"},domProps:{"value":(_vm.reFrJobNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reFrJobNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รายการอะไหล่:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reFrSparePartCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reFrSparePartCode),callback:function ($$v) {_vm.reFrSparePartCode=$$v},expression:"reFrSparePartCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ซ่อม:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reFrByUserOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reFrByUser),callback:function ($$v) {_vm.reFrByUser=$$v},expression:"reFrByUser"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมวดสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reFrProductGroupOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reFrProductGroup),callback:function ($$v) {_vm.reFrProductGroup=$$v},expression:"reFrProductGroup"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reFrProductTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reFrProductType),callback:function ($$v) {_vm.reFrProductType=$$v},expression:"reFrProductType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reFrMaterialCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reFrMaterialCode),callback:function ($$v) {_vm.reFrMaterialCode=$$v},expression:"reFrMaterialCode"}})],1)])]),_vm._v(" "),(this.$root.canShow(['BR_REPORT']))?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportFixedProducts}},[_vm._m(3)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"fixedProductTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"15"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reFrDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),(_vm.isShowFooter)?_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right",attrs:{"colspan":"14"}},[_vm._v("ราคารวม")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(this.$options.filters.currency(_vm.TotalAmount, "฿"))+"\n                  ")])])]):_vm._e()])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่เอกสาร")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เดือน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้ซ่อม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("หมวดสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รายการอะไหล่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ราคา")])])}]


/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MKTReport/EventAndFood'),expression:"$route.path == '/MKTReport/EventAndFood'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทงาน:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reObjectivesCode',"name":'reObjectivesCode',"select2-options":_vm.reObjectivesCodeOptions},model:{value:(_vm.reObjectivesCode),callback:function ($$v) {_vm.reObjectivesCode=$$v},expression:"reObjectivesCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่กิจกรรมเริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่กิจกรรมสิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อเจ้าหน้าที่:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reUserIds',"name":'reUserIds',"select2-options":_vm.reUserIdsOptions},model:{value:(_vm.reUserIds),callback:function ($$v) {_vm.reUserIds=$$v},expression:"reUserIds"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reStatus',"name":'reStatus',"select2-options":_vm.reStatusOptions},model:{value:(_vm.reStatus),callback:function ($$v) {_vm.reStatus=$$v},expression:"reStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportEventAndFoodTable}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"EventAndFoodTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"25"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อกิจกรรม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อผู้ใช้งาน (Username)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่เริ่มต้นกิจกรรม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่สิ้นสุดกิจกรรม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("PG เชียร์ขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนPG")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ยอดขาย(ถัง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนยอดขาย(ถัง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("การสนับสนุนงบฯ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผลิตภัณฑ์ที่เบิก")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนผลิตภัณฑ์ที่เบิก")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผลิตภัณฑ์ที่ยืม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนผลิตภัณฑ์ที่ยืม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("อุปกรณ์ที่เบิก")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนอุปกรณ์ที่เบิก")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("อุปกรณ์ที่ยืม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนอุปกรณ์ที่ยืม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("พรีเมี่ยมสื่อที่เบิก")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนพรีเมี่ยมสื่อที่เบิก")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("พรีเมี่ยมสื่อที่ยืม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนพรีเมี่ยมสื่อที่ยืม")])])}]


/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+" "),_c('strong',[_vm._v(_vm._s(_vm.qiJobNumber))])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext",domProps:{"innerHTML":_vm._s(_vm.qiStatusName)}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(2),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.createdDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("\n                  "+_vm._s(_vm.qiTypeCode === 'JOB_QI_TYPE_EVALUATE' ? 'วันที่ประเมินเสร็จสิ้น' : 
                    _vm.qiTypeCode === 'JOB_QI_TYPE_REPAIR' ? 'วันที่ซ่อมเสร็จสิ้น' : 
                    _vm.qiTypeCode === 'JOB_QI_TYPE_DRAWBACK' ? 'วันที่ช่างบันทึกข้อมูลเบิก/คืน' : 
                    'วันที่อัพเดทล่าสุด')+" :\n                ")])]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.finishedDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(3),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.createdUserName))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(4),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext",domProps:{"innerHTML":_vm._s(_vm.qiTypeName)}})])]),_vm._v(" "),(_vm.qiTypeCode !== 'JOB_QI_TYPE_DRAWBACK' && _vm.qiSubType == 1)?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(5),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.barcodeNoOld))])])]):_vm._e(),_vm._v(" "),(_vm.qiTypeCode !== 'JOB_QI_TYPE_DRAWBACK')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(6),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.materialNameShow))])])]):_vm._e(),_vm._v(" "),(_vm.qiTypeCode !== 'JOB_QI_TYPE_DRAWBACK')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(7),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n                "+_vm._s(_vm.amount)+"\n                "),(_vm.showBarcodeBtn)?_c('button',{staticClass:"btn btn-outline-hover-info btn-elevate btn-circle btn-icon ml-3",attrs:{"type":"button","title":"แสดงรายการ BARCODE"},on:{"click":function($event){$event.preventDefault();return _vm.showBarcodesModal(_vm.qiJobId)}}},[_c('i',{staticClass:"text-info la la-list"})]):_vm._e()])]),_vm._v(" "),_c('div',{ref:"barcodesModal",staticClass:"modal fade",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('table',{ref:"barcodeLocalTable",staticClass:"table-sm table-striped table-bordered table-hover"},[_vm._m(9)])])])])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.qiTypeCode == 'JOB_QI_TYPE_DRAWBACK')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_vm._m(10),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n              "+_vm._s(_vm.qiAreaPlant ? 'ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด' : 'ซ่อมในตัวแทนจำหน่าย')+"\n            ")])]):_vm._e(),_vm._v(" "),(_vm.qiTypeCode == 'JOB_QI_TYPE_DRAWBACK')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(11),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.confirmedDate))])])]):_vm._e(),_vm._v(" "),(_vm.qiTypeCode == 'JOB_QI_TYPE_DRAWBACK')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(12),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.confirmedUserName))])])]):_vm._e()]),_vm._v(" "),(_vm.showFormMachine)?_c('div',{staticClass:"kt-section kt-section--first",attrs:{"id":"FormMachine"}},[_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-checkable"},[_vm._m(13),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("ตัวเครื่องเก่าผุพังจนไม่สามารถนำมาซ่อมได้")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.evalData.evalMach1)?_c('span',[_vm._v("ใช่")]):_c('span',[_vm._v("ไม่ใช่")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("คอยล์น้ำยาหล่อเย็น ขาดรั่ว ซึม ชำรุดเสียหายจนไม่สามารถซ่อมได้")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.evalData.evalMach2)?_c('span',[_vm._v("ใช่")]):_c('span',[_vm._v("ไม่ใช่")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("ระบบไฟฟ้าในคอมเพรสเซอร์ชำรุดเสียหาย จนไม่สามารถซ่อมได้")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.evalData.evalMach3)?_c('span',[_vm._v("ใช่")]):_c('span',[_vm._v("ไม่ใช่")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("วอเตอร์บาศก์ชำรุดเสียหาย จนไม่สามารถซ่อมได้")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.evalData.evalMach4)?_c('span',[_vm._v("ใช่")]):_c('span',[_vm._v("ไม่ใช่")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("อุปกรณ์หลักของเครื่องมีไม่ครบ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.evalData.evalMach5)?_c('span',[_vm._v("ใช่")]):_c('span',[_vm._v("ไม่ใช่")])])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"2"}},[_vm._v("สรุปผลตรวจสภาพเบื้องต้นเครื่องเบียร์สด")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[(_vm.evalData.evalFlag === 1)?_c('span',{staticClass:"text-danger"},[_vm._v("ซ่อมไม่ได้")]):(_vm.evalData.evalFlag === 2)?_c('span',{staticClass:"text-success"},[_vm._v("ซ่อมได้")]):(_vm.evalData.evalFlag === 3)?_c('span',{staticClass:"text-warning"},[_vm._v("ไม่เสีย")]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('label',[_vm._v("อาการเสีย:")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"อาการเสีย","rows":"3","readonly":""}},[_vm._v(" "+_vm._s(_vm.evalData.evalRemark)+" ")]),_vm._v(" "),_c('span',{staticClass:"form-text mb-3"})])]),_vm._v(" "),(_vm.isUnrepair)?_c('div',{staticClass:"row"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_vm._m(15),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"สรุปอาการ และข้อเสนอแนะ","rows":"3","readonly":""}},[_vm._v(" "+_vm._s(_vm.UnrepairRemark)+" ")]),_vm._v(" "),_c('span',{staticClass:"form-text mb-3"})])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.showFormEquipment)?_c('div',{staticClass:"kt-section kt-section--first",attrs:{"id":"FormEquipment"}},[_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-checkable"},[_vm._m(16),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("อุปกรณ์เสริม มีส่วนประกอบหลักไม่ครบ เช่น แกนกลางอุปกรณ์,บอดี้หลัก")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.evalData.evalEqpt1)?_c('span',[_vm._v("ใช่")]):_c('span',[_vm._v("ไม่ใช่")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("อุปกรณ์เสริมมีการรั่วซึมภายในระบบชำรุดจนไม่สามารถนำมาซ่อมแซม")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.evalData.evalEqpt2)?_c('span',[_vm._v("ใช่")]):_c('span',[_vm._v("ไม่ใช่")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("อุปกรณ์เสริม ไม่สมบูรณ์ จนราคาประเมินซ่อมเกินกว่า 50% ของราคาสินค้า")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.evalData.evalEqpt3)?_c('span',[_vm._v("ใช่")]):_c('span',[_vm._v("ไม่ใช่")])])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"2"}},[_vm._v("สรุปผลตรวจสภาพเบื้องต้นอุปกรณ์เบียร์สด")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[(_vm.evalData.evalFlag === 1)?_c('span',{staticClass:"text-danger"},[_vm._v("ซ่อมไม่ได้")]):(_vm.evalData.evalFlag === 2)?_c('span',{staticClass:"text-success"},[_vm._v("ซ่อมได้")]):(_vm.evalData.evalFlag === 3)?_c('span',{staticClass:"text-warning"},[_vm._v("ไม่เสีย")]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('label',[_vm._v("อาการเสีย:")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"อาการเสีย","rows":"5","readonly":""}},[_vm._v(" "+_vm._s(_vm.evalData.evalRemark)+" ")]),_vm._v(" "),_c('span',{staticClass:"form-text mb-3"})])])])]):_vm._e(),_vm._v(" "),(_vm.showFormDrawback)?_c('div',{staticClass:"kt-section kt-section--first",attrs:{"id":"FormDrawback"}},[_c('div',{staticClass:"kt-section__body"},[_vm._m(17),_vm._v(" "),_c('span',{staticClass:"form-text mb-3"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-checkable"},[_c('thead',[_c('tr',{class:_vm.qiSubType === 1 ? 'table-warning' : 'table-info'},[_c('th',{staticClass:"text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รายการอุปกรณ์")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ราคา/หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("มูลค่ารวม")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("หมายเหตุ")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.qiJobItemId},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.materialNameShow))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(item.unitPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s((item.quantity * item.unitPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.remark))])])}),_vm._v(" "),_c('tr',[_vm._m(18),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('strong',[_vm._v(_vm._s(_vm.totalQuantity))])]),_vm._v(" "),_c('td',{staticClass:"text-center"}),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.totalValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))])])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-2 col-md-2 col-sm-2"},[_c('label',{staticClass:"label"},[(_vm.pictures.length && _vm.pictures[0].downloadUrl)?_c('strong',[_vm._v("รูปภาพอุปกรณ์ :")]):_c('strong',[_vm._v("รูปภาพอุปกรณ์ : ไม่มีภาพถ่าย")])]),_vm._v(" "),(_vm.pictures.length && _vm.pictures[0].downloadUrl)?_c('div',[_c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"p-1 d-flex flex-column justify-content-center align-items-center border-dashed"},[(_vm.pictures[0])?_c('img',{staticStyle:{"object-fit":"contain","width":"100%","height":"100%"},attrs:{"src":_vm.pictures[0].downloadUrl},on:{"click":function($event){return _vm.showModal(_vm.pictures[0].downloadUrl)}}}):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"imageModal","tabindex":"-1","role":"dialog","aria-labelledby":"imageModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("ภาพถ่าย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticStyle:{"max-width":"90%","max-height":"90%","margin":"0 auto","display":"block"},attrs:{"src":_vm.modalImageURL}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n                                        ")])])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.showFormRepair)?_c('div',{staticClass:"kt-section kt-section--first",attrs:{"id":"FormRepair"}},[_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[(!_vm.qiAreaPlant)?_c('div',{staticClass:"col-xl-6"},[_vm._m(19),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n                  "+_vm._s('ซ่อมในตัวแทนจำหน่าย')+" "),_c('strong',[_vm._v(_vm._s(_vm.agentCodeSap ? ' >> '+_vm.agentName+' ('+_vm.agentCodeSap+')' : ''))])])]):_c('div',{staticClass:"col-xl-3"},[_vm._m(20),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n                  "+_vm._s('ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด')+" \n                ")])]),_vm._v(" "),(_vm.qiAreaPlant && _vm.qiTypeCode == 'JOB_QI_TYPE_REPAIR')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(21),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.confirmedDate))])])]):_vm._e(),_vm._v(" "),(_vm.qiAreaPlant && _vm.qiTypeCode == 'JOB_QI_TYPE_REPAIR')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(22),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.confirmedUserName))])])]):_vm._e()]),_vm._v(" "),(!_vm.isUnrepair)?_c('div',[_c('label',{staticClass:"label"},[_c('strong',[_vm._v(_vm._s(_vm.tableName))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-checkable"},[_c('thead',[_c('tr',{class:_vm.qiSubType === 1 ? 'table-warning' : 'table-info'},[_c('th',{staticClass:"text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',[_vm._v("รายการ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ผลการตรวจสอบ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("หมายเหตุ(กรณีไม่ปกติ)")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.tableDataRepair),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.item))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.result === null ? '-' : (row.result ? 'ปกติ' : 'ไม่ปกติ')))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.remark || ''))])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),_vm._m(23),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped table-bordered table-checkable",staticStyle:{"width":"100%"}},[_c('tbody',_vm._l((_vm.tableFormData),function(item,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(item.variable)}})])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-2 col-md-2 col-sm-2"},[_c('label',{staticClass:"label"},[(_vm.pictures.length && _vm.pictures[0].downloadUrl)?_c('strong',[_vm._v("ภาพถ่าย :")]):_c('strong',[_vm._v("ภาพถ่าย : ไม่มีภาพถ่าย")])]),_vm._v(" "),(_vm.pictures.length && _vm.pictures[0].downloadUrl)?_c('div',[_c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"p-1 d-flex flex-column justify-content-center align-items-center border-dashed"},[(_vm.pictures[0])?_c('img',{staticStyle:{"object-fit":"contain","width":"100%","height":"100%"},attrs:{"src":_vm.pictures[0].downloadUrl},on:{"click":function($event){return _vm.showModal(_vm.pictures[0].downloadUrl)}}}):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"imageModal","tabindex":"-1","role":"dialog","aria-labelledby":"imageModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("ภาพถ่าย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticStyle:{"max-width":"90%","max-height":"90%","margin":"0 auto","display":"block"},attrs:{"src":_vm.modalImageURL}}),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_vm._m(24)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),_vm._m(25),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped table-bordered table-hover",staticStyle:{"width":"100%","table-layout":"fixed"}},[_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.qiJobItemId},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.materialNameShow))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.quantity.toLocaleString('en-US')))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(item.unitPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s((item.quantity * item.unitPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"2"}},[_vm._v("รวมจำนวน/ราคาอะไหล่ทั้งสิ้น")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('strong',[_vm._v(_vm._s(_vm.totalQuantity.toLocaleString('en-US')))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.totalValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))])])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),_vm._m(28),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped table-bordered table-hover",staticStyle:{"width":"100%","table-layout":"fixed"}},[_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_c('tbody',[_vm._l((_vm.services),function(item,index){return _c('tr',{key:item.qiJobServiceId},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.serviceName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.quantity.toLocaleString('en-US')))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(item.unitPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s((item.quantity * item.unitPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))])])}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"2"}},[_vm._v("รวมจำนวน/ราคาค่าบริการทั้งสิ้น")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('strong',[_vm._v(_vm._s(_vm.totalQuantityService.toLocaleString('en-US')))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.totalValueService.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))])])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_vm._m(31),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"สรุปอาการ และข้อเสนอแนะ","rows":"5","readonly":""}},[_vm._v(" "+_vm._s(_vm.remark)+" ")]),_vm._v(" "),_c('span',{staticClass:"form-text mb-3"})])])]):_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_vm._m(32),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"สรุปอาการ และข้อเสนอแนะ","rows":"5","readonly":""}},[_vm._v(" "+_vm._s(_vm.UnrepairRemark)+" ")]),_vm._v(" "),_c('span',{staticClass:"form-text mb-3"})]),_vm._v(" "),_vm._m(33)])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("สถานะการดำเนินการ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:" mb-0"},[_c('strong',[_vm._v("วันที่สร้าง :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ชื่อช่าง :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ประเภทใบงาน :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("BARCODE :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ชื่อสินค้า/อุปกรณ์ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("จำนวน :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("รายการ BARCODE")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("BARCODE")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("สถานที่ซ่อมอุปกรณ์:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("วันที่ยืนยันการตรวจสอบข้อมูล :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ผู้ยืนยันการตรวจสอบข้อมูล :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table-warning"},[_c('th',{attrs:{"colspan":"3"}},[_c('strong',[_vm._v("การตรวจสภาพอุปกรณ์หลักเบื้องต้น")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-check pl-0"},[_c('label',{staticClass:"form-check-label kt-checkbox text-danger"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","name":"isUnrepair","checked":"","disabled":""}}),_vm._v(" "),_c('span'),_vm._v(" "),_c('strong',[_vm._v("ประเมินสภาพเบื้องต้นผิดพลาด : ไม่สามารถซ่อมได้")])])]),_vm._v(" "),_c('span',{staticClass:"form-text"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_c('strong',[_vm._v("สรุปอาการ และข้อเสนอแนะ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table-info"},[_c('th',{attrs:{"colspan":"3"}},[_c('strong',[_vm._v("การตรวจสภาพอุปกรณ์เสริมเบื้องต้น")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ข้อมูลการเบิก/คืน อุปกรณ์เบียร์สด :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right",attrs:{"colspan":"2"}},[_c('strong',[_vm._v("จำนวนรวม/มูลค่ารวม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("สถานที่ซ่อมอุปกรณ์:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("สถานที่ซ่อมอุปกรณ์:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("วันที่รับเข้าคลังดี :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ผู้รับเข้าคลังดี :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_c('strong',[_vm._v("ขั้นตอนมาตรฐานการซ่อมอุปกรณ์ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"modal-title"},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_c('strong',[_vm._v("อะไหล่สำหรับซ่อม/ล้าง :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colgroup',[_c('col',{staticStyle:{"width":"10%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"40%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"10%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"20%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"20%"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',[_vm._v("รายการ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("ราคาต่อหน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("ราคาสุทธิ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_c('strong',[_vm._v("ค่าบริการ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colgroup',[_c('col',{staticStyle:{"width":"10%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"40%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"10%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"20%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"20%"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',[_vm._v("รายการ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("ราคาต่อหน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("ราคาสุทธิ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_c('strong',[_vm._v("สรุปอาการ และข้อเสนอแนะ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_c('strong',[_vm._v("สรุปอาการ และข้อเสนอแนะ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-check pl-0"},[_c('label',{staticClass:"form-check-label kt-checkbox text-danger"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","name":"isUnrepair","checked":"","disabled":""}}),_vm._v(" "),_c('span'),_vm._v(" "),_c('strong',[_vm._v("ประเมินสภาพเบื้องต้นผิดพลาด : ไม่สามารถซ่อมได้")])])]),_vm._v(" "),_c('span',{staticClass:"form-text mb-3"})])}]


/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal",staticClass:"modal fade",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่ใบงาน:")]),_vm._v(" "),_c('span',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.job.jobNumber))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภท:")]),_vm._v(" "),_c('span',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.job.jobTypeName))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ต้นทาง:")]),_vm._v(" "),_c('span',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.job.originName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปลายทาง:")]),_vm._v(" "),_c('span',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.job.destinationName))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('span',{ref:"uploadBtnContainer"},[_c('button',{ref:"uploadBtn",staticClass:"btn btn-sm btn-outline-brand"},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("\n                      อัพโหลดไฟล์ Export จาก Handheld\n                    ")])])])]),_vm._v(" "),(_vm.uploadErrors)?_c('div',{staticClass:"row mt-3"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover mt-3"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.uploadErrors),function(value,key){return _c('tr',{key:key},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value[0]))])])}),0)])])]):_vm._e()])])]),_vm._v(" "),_vm._m(3)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("อัพโหลดไฟล์ Export จาก Handheld")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('h4',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" รายละเอียดข้อผิดพลาด\n                  ")]),_vm._v(" "),_c('span',{staticClass:"text-mute"},[_vm._v("กรุณาตรวจสอบข้อมูลตามตารางข้างล่าง")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"160px"}},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ข้อผิดพลาด")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" ปิดหน้าต่าง\n          ")])])}]


/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/MTMonthly'),expression:"$route.path == '/PMReport/MTMonthly'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAgentCode',"name":'reAgentCode',"select2-options":_vm.reAgentCodeOptions},model:{value:(_vm.reAgentCode),callback:function ($$v) {_vm.reAgentCode=$$v},expression:"reAgentCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"MTMonthlyTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"14"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(3)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"min-width":"150px"}},[_vm._v("\n                    อาการเสีย\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"min-width":"150px"}},[_vm._v("\n                    อาการเสีย (อื่นๆ)\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"min-width":"150px"}},[_vm._v("\n                    สาเหตุของปัญหา\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"min-width":"150px"}},[_vm._v("\n                    วิธีการแก้ไข\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("\n                    รหัสบาร์โค้ด เครื่องเบียร์สด\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("\n                    รหัสบาร์โค้ดเก่า เครื่องเบียร์สด\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสบาร์โค้ด หัวจ่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสบาร์โค้ดเก่า หัวจ่าย")])])}]


/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสตัวแทนจำหน่าย:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agentCode),expression:"agentCode"}],staticClass:"form-control",attrs:{"id":"agentCode","name":"agentCode","type":"text","maxlength":"450","placeholder":"รหัสตัวแทนจำหน่าย"},domProps:{"value":(_vm.agentCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.agentCode=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อตัวแทนจำหน่าย:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.holdTime),expression:"holdTime"}],staticClass:"form-control",attrs:{"id":"agentName","name":"agentName","type":"text","maxlength":"450","placeholder":"ชื่อตัวแทนจำหน่าย"},domProps:{"value":(_vm.holdTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.holdTime=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ที่อยู่:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adress),expression:"adress"}],staticClass:"form-control",attrs:{"id":"adress","name":"adress","type":"text","maxlength":"450","placeholder":"ชื่อตัวแทนจำหน่าย"},domProps:{"value":(_vm.adress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adress=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tel),expression:"tel"}],staticClass:"form-control",attrs:{"id":"tel","name":"tel","type":"text","maxlength":"450","placeholder":"เบอร์โทร"},domProps:{"value":(_vm.tel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tel=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"id":"email","name":"email","type":"text","maxlength":"450","placeholder":"เบอร์โทร"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Latitude:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lat),expression:"lat"}],staticClass:"form-control",attrs:{"id":"lat","name":"lat","type":"text","maxlength":"450","placeholder":"Latitude"},domProps:{"value":(_vm.lat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lat=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Longitude:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lng),expression:"lng"}],staticClass:"form-control",attrs:{"id":"lng","name":"lng","type":"text","maxlength":"450","placeholder":"Longitude"},domProps:{"value":(_vm.lng)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lng=$event.target.value}}})])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_vm._m(3)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รูปภาพ:"),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                    (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)")])]),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2 col-lg-2 col-md-2 .col-sm-2 col-xs-2",attrs:{"type":"button","id":"uploader-btn"}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("รูป\n                ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","name":"status","id":"status","value":"checkedValue","checked":""}}),_vm._v("\n                    เปิดใช้งาน\n                  ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล")])])}]


/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เลขทะเบียน:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.treCarReg))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v("ประเภทบริษัท:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.treCompanyType))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("บริษัท:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.treCompanyName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อคนขับ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.treDriverFirstName),expression:"treDriverFirstName"}],staticClass:"form-control",attrs:{"id":"treDriverFirstName","name":"treDriverFirstName","type":"text","maxlength":"256","placeholder":"ชื่อ"},domProps:{"value":(_vm.treDriverFirstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.treDriverFirstName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("นามสกุล")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.treDriverLastName),expression:"treDriverLastName"}],staticClass:"form-control",attrs:{"id":"treDriverLastName","name":"treDriverLastName","type":"text","maxlength":"256","placeholder":"นามสกุล"},domProps:{"value":(_vm.treDriverLastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.treDriverLastName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.treDriverTel),expression:"treDriverTel"}],staticClass:"form-control",attrs:{"id":"treDriverTel","name":"treDriverTel","type":"text","maxlength":"256","placeholder":"เบอร์ติดต่อ"},domProps:{"value":(_vm.treDriverTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.treDriverTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row col-xl-12 w3-container"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ประสานงาน(Boonrawd):")]),_vm._v(" "),_c('select2',{ref:"treEmpIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'treEmpId',"name":'treEmpId',"select2-options":_vm.treEmpIdOptions},on:{"selectChange":_vm.onTreEmpIdChange},model:{value:(_vm.treEmpId),callback:function ($$v) {_vm.treEmpId=$$v},expression:"treEmpId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.treEmpTel),expression:"treEmpTel"}],staticClass:"form-control",attrs:{"id":"treEmpTel","name":"treEmpTel","type":"text","maxlength":"256","placeholder":"เบอร์ติดต่อ","readonly":""},domProps:{"value":(_vm.treEmpTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.treEmpTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.treEmpEmail),expression:"treEmpEmail"}],staticClass:"form-control",attrs:{"id":"treEmpEmail","name":"treEmpEmail","type":"text","maxlength":"256","placeholder":"อีเมล","readonly":""},domProps:{"value":(_vm.treEmpEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.treEmpEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ตำแหน่ง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.treEmpPosition),expression:"treEmpPosition"}],staticClass:"form-control",attrs:{"id":"treEmpPosition","name":"treEmpPosition","type":"text","maxlength":"256","placeholder":"ตำแหน่ง","readonly":""},domProps:{"value":(_vm.treEmpPosition)},on:{"input":function($event){if($event.target.composing){ return; }_vm.treEmpPosition=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row col-xl-12 w3-container"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ประสานงาน(ภายนอก):")]),_vm._v(" "),_c('select2',{ref:"treTransitContactorIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'treTransitContactorId',"name":'treTransitContactorId',"select2-options":_vm.treTransitContactorIdOptions},on:{"selectChange":_vm.onTreTransitContactorIdChange},model:{value:(_vm.treTransitContactorId),callback:function ($$v) {_vm.treTransitContactorId=$$v},expression:"treTransitContactorId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.treTransitContactorTel),expression:"treTransitContactorTel"}],staticClass:"form-control",attrs:{"id":"treTransitContactorTel","name":"treTransitContactorTel","type":"text","maxlength":"256","placeholder":"เบอร์ติดต่อ","readonly":""},domProps:{"value":(_vm.treTransitContactorTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.treTransitContactorTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.treTransitContactorEmail),expression:"treTransitContactorEmail"}],staticClass:"form-control",attrs:{"id":"treTransitContactorEmail","name":"treTransitContactorEmail","type":"text","maxlength":"256","placeholder":"อีเมล","readonly":""},domProps:{"value":(_vm.treTransitContactorEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.treTransitContactorEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ตำแหน่ง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.treTransitContactorPosition),expression:"treTransitContactorPosition"}],staticClass:"form-control",attrs:{"id":"treTransitContactorPosition","name":"treTransitContactorPosition","type":"text","maxlength":"256","placeholder":"ตำแหน่ง","readonly":""},domProps:{"value":(_vm.treTransitContactorPosition)},on:{"input":function($event){if($event.target.composing){ return; }_vm.treTransitContactorPosition=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.treInActiveStatus),expression:"treInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"treInActiveStatus","id":"treInActiveStatus"},domProps:{"checked":Array.isArray(_vm.treInActiveStatus)?_vm._i(_vm.treInActiveStatus,null)>-1:(_vm.treInActiveStatus)},on:{"change":function($event){var $$a=_vm.treInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.treInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.treInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.treInActiveStatus=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                    เปิดใช้งาน\n                  ")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"userChangePasswordModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อผู้ใช้งาน (Username):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],staticClass:"form-control",attrs:{"disabled":"","id":"userName","name":"userName","type":"text","maxlength":"20","placeholder":"ชื่อผู้ใช้งาน (Username)"},domProps:{"value":(_vm.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสผ่าน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"id":"password","name":"password","type":"password","maxlength":"20","placeholder":"รหัสผ่าน"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ยืนยันรหัสผ่าน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"form-control",attrs:{"id":"confirmPassword","name":"confirmPassword","type":"password","maxlength":"20","placeholder":"ยืนยันรหัสผ่าน"},domProps:{"value":(_vm.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}})])])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" แก้ไขรหัสผ่าน\n          ")])])}]


/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสสินค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.PrdMaterialCode))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.PrdProductDesc_th2))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.PrdProductBrandDesc))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("หมวดหมู่:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.PrdProductGroupDesc))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.PrdProductTypeDesc))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("หน่วยนับ:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.PrdBaseUnit))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ราคากลาง:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm._f("currency")(_vm.PrdInitialPrice,"฿", 2)))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ราคาเฉลี่ย:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm._f("currency")(_vm.PrdAvgPrice,"฿", 2)))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-img"}},_vm._l((_vm.imgDownload),function(element){return (element.isLoaded)?_c('div',{key:element.pictureId,staticClass:"col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap",attrs:{"id":element.pictureId}},[_c('img',{staticClass:"img-plant -avatar js-avatar-me img-thumbnail card-img-top",attrs:{"src":element.downloadUrl,"id":element.pictureId},on:{"error":function($event){return _vm.handleImageError(element)},"load":function($event){return _vm.handleImageLoad(element)}}})]):_vm._e()}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสบาร์โค้ด:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PrdHasBarcode),expression:"PrdHasBarcode"}],staticClass:"form-check-input",attrs:{"id":"PrdHasBarcode","name":"PrdHasBarcode","type":"checkbox","disabled":"disabled"},domProps:{"checked":Array.isArray(_vm.PrdHasBarcode)?_vm._i(_vm.PrdHasBarcode,null)>-1:(_vm.PrdHasBarcode)},on:{"change":function($event){var $$a=_vm.PrdHasBarcode,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.PrdHasBarcode=$$a.concat([$$v]))}else{$$i>-1&&(_vm.PrdHasBarcode=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.PrdHasBarcode=$$c}}}}),_vm._v("\n                    มีข้อมูล BARCODE\n                    "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้าสำหรับใบHold(รับคืน):")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PrdIsForJobHold),expression:"PrdIsForJobHold"}],staticClass:"form-check-input",attrs:{"id":"PrdIsForJobHold","name":"PrdIsForJobHold","type":"checkbox","disabled":"disabled"},domProps:{"checked":Array.isArray(_vm.PrdIsForJobHold)?_vm._i(_vm.PrdIsForJobHold,null)>-1:(_vm.PrdIsForJobHold)},on:{"change":function($event){var $$a=_vm.PrdIsForJobHold,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.PrdIsForJobHold=$$a.concat([$$v]))}else{$$i>-1&&(_vm.PrdIsForJobHold=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.PrdIsForJobHold=$$c}}}}),_vm._v("\n                    เปิดใช้งาน\n                    "),_c('span')])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หัวจ่าย:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PrdIsBarButler),expression:"PrdIsBarButler"}],staticClass:"form-check-input",attrs:{"id":"PrdIsBarButler","name":"PrdIsBarButler","type":"checkbox","disabled":"disabled"},domProps:{"checked":Array.isArray(_vm.PrdIsBarButler)?_vm._i(_vm.PrdIsBarButler,null)>-1:(_vm.PrdIsBarButler)},on:{"change":function($event){var $$a=_vm.PrdIsBarButler,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.PrdIsBarButler=$$a.concat([$$v]))}else{$$i>-1&&(_vm.PrdIsBarButler=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.PrdIsBarButler=$$c}}}}),_vm._v("\n                    มีหัวจ่ายในตัว\n                    "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จำนวนหัวจ่าย:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.PrdBarButlerQty))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทอะไหล่งาน PM:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.PrdPMSpare))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตั้งค่าสินค้าสำหรับใช้งานช่างซ่อมบำรุง:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isSpareOrMachine),expression:"isSpareOrMachine"}],staticClass:"form-check-input",attrs:{"id":"isSpareOrMachine","name":"isSpareOrMachine","type":"checkbox","disabled":"disabled"},domProps:{"checked":Array.isArray(_vm.isSpareOrMachine)?_vm._i(_vm.isSpareOrMachine,null)>-1:(_vm.isSpareOrMachine)},on:{"change":function($event){var $$a=_vm.isSpareOrMachine,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isSpareOrMachine=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isSpareOrMachine=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isSpareOrMachine=$$c}}}}),_vm._v("\n                        ประเภทเครื่องเบียร์สด/อุปกรณ์ ใช้สำหรับใบงานประเมินสภาพและใบงานซ่อมอุปกรณ์เบียร์สด\n                        "),_c('span')]),_vm._v(" "),_c('label',{staticClass:"text-danger",staticStyle:{"margin-left":"30px"}},[_vm._v("*การเลือกประเภทมีผลต่อการแสดงแบบฟอร์มในใบงาน")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext",staticStyle:{"margin-left":"30px"}},[_vm._v(_vm._s(_vm.QiSubProductTypeDesc))])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.IsQiSpare),expression:"IsQiSpare"}],staticClass:"form-check-input",attrs:{"id":"IsQiSpare","name":"IsQiSpare","type":"checkbox","disabled":"disabled"},domProps:{"checked":Array.isArray(_vm.IsQiSpare)?_vm._i(_vm.IsQiSpare,null)>-1:(_vm.IsQiSpare)},on:{"change":function($event){var $$a=_vm.IsQiSpare,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.IsQiSpare=$$a.concat([$$v]))}else{$$i>-1&&(_vm.IsQiSpare=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.IsQiSpare=$$c}}}}),_vm._v("\n                    อะไหล่ช่างซ่อมบำรุง\n                    "),_c('span')])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.IsSupplierSpare),expression:"IsSupplierSpare"}],staticClass:"form-check-input",attrs:{"id":"IsSupplierSpare","name":"IsSupplierSpare","type":"checkbox","disabled":"disabled"},domProps:{"checked":Array.isArray(_vm.IsSupplierSpare)?_vm._i(_vm.IsSupplierSpare,null)>-1:(_vm.IsSupplierSpare)},on:{"change":function($event){var $$a=_vm.IsSupplierSpare,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.IsSupplierSpare=$$a.concat([$$v]))}else{$$i>-1&&(_vm.IsSupplierSpare=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.IsSupplierSpare=$$c}}}}),_vm._v("\n                    อะไหล่ซัพพลายเออร์\n                    "),_c('span')])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PrdInActiveStatus),expression:"PrdInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"PrdInActiveStatus","name":"PrdInActiveStatus","type":"checkbox","disabled":"disabled"},domProps:{"checked":Array.isArray(_vm.PrdInActiveStatus)?_vm._i(_vm.PrdInActiveStatus,null)>-1:(_vm.PrdInActiveStatus)},on:{"change":function($event){var $$a=_vm.PrdInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.PrdInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.PrdInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.PrdInActiveStatus=$$c}}}}),_vm._v("\n                    เปิดใช้งาน\n                    "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-user-secret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("รูปภาพ:"),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                    (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน\n                    10Mb.)")])])}]


/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"downloadBarcodeModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทสินค้าการถือครอง (วัน):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.exholProductTypeIdOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.exholProductTypeId),callback:function ($$v) {_vm.exholProductTypeId=$$v},expression:"exholProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.exholAgentCodeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.exholAgentCode),callback:function ($$v) {_vm.exholAgentCode=$$v},expression:"exholAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.exholShopTypeIdOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.exholShopTypeId),callback:function ($$v) {_vm.exholShopTypeId=$$v},expression:"exholShopTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.exholProductBrandIdOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.exholProductBrandId),callback:function ($$v) {_vm.exholProductBrandId=$$v},expression:"exholProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ระยะเวลาการถือครอง :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.exholHolderTime),expression:"exholHolderTime"}],staticClass:"form-control",attrs:{"type":"number","id":"exholHolderTime","name":"exholHolderTime","min":"1","placeholder":""},domProps:{"value":(_vm.exholHolderTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.exholHolderTime=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"exholInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'exholInActiveStatus',"name":'exholInActiveStatus',"select2-options":_vm.exholInActiveStatusOptions},model:{value:(_vm.exholInActiveStatus),callback:function ($$v) {_vm.exholInActiveStatus=$$v},expression:"exholInActiveStatus"}})],1)])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" Export\n          ")])])}]


/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile",staticStyle:{"min-width":"2500px !important"}},[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปีงบประมาณ:")]),_vm._v(" "),_c('select2',{ref:"yearSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'searchYear',"name":'searchYear',"select2-options":_vm.yearOptions},model:{value:(_vm.searchYear),callback:function ($$v) {_vm.searchYear=$$v},expression:"searchYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.searchAgentOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.searchAgentCode),callback:function ($$v) {_vm.searchAgentCode=$$v},expression:"searchAgentCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12",staticStyle:{"max-height":"calc(100vh - 260px)","overflow":"auto"}},[_c('table',{staticClass:"table table-sm  table-bordered  ",attrs:{"id":"agentScore"}},[_vm._m(1),_vm._v(" "),_c('tbody',[_vm._l((_vm.dataSource),function(item,i){return [_c('tr',[_c('td',{staticClass:"text-center align-middle TITLE"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TITLE"},[_vm._v(_vm._s(item.year))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TITLE"},[_vm._v(_vm._s(item.agentCode))]),_vm._v(" "),_c('td',{staticClass:"text-left align-middle",staticStyle:{"min-width":"250px !important"}},[_vm._v(_vm._s(item.agentName))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_JAN_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,1,'MACHINE',item.maC_JAN,item.maC_JAN_Remark)}}},[_vm._v(_vm._s((item.maC_JAN !=null) ? item.maC_JAN : '-')+" ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_FEB_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,2,'MACHINE',item.maC_FEB,item.maC_FEB_Remark)}}},[_vm._v(_vm._s((item.maC_FEB !=null) ? item.maC_FEB  : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_MAR_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,3,'MACHINE',item.maC_MAR,item.maC_MAR_Remark)}}},[_vm._v(_vm._s((item.maC_MAR !=null) ?  item.maC_MAR : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_APR_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,4,'MACHINE',item.maC_APR,item.maC_APR_Remark)}}},[_vm._v(_vm._s((item.maC_APR !=null) ? item.maC_APR : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_MAY_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,5,'MACHINE',item.maC_MAR,item.maC_MAY_Remark)}}},[_vm._v(_vm._s((item.maC_MAY !=null) ? item.maC_MAY  : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_JUN_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,6,'MACHINE',item.maC_JUN,item.maC_JUN_Remark)}}},[_vm._v(_vm._s((item.maC_JUN !=null) ? item.maC_JUN : '-')+" ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_JUL_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,7,'MACHINE',item.maC_JUL,item.maC_JUL_Remark)}}},[_vm._v(_vm._s((item.maC_JUL !=null) ? item.maC_JUL : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_AUG_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,8,'MACHINE',item.maC_AUG,item.maC_AUG_Remark)}}},[_vm._v(_vm._s((item.maC_AUG !=null) ?  item.maC_AUG : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_SEP_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,9,'MACHINE',item.maC_SEP,item.maC_SEP_Remark)}}},[_vm._v(_vm._s((item.maC_SEP !=null) ? item.maC_SEP : '-')+" ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_OCT_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,10,'MACHINE',item.maC_OCT,item.maC_OCT_Remark)}}},[_vm._v(_vm._s((item.maC_OCT !=null) ? item.maC_OCT : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_NOV_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,11,'MACHINE',item.maC_NOV,item.maC_NOV_Remark)}}},[_vm._v(_vm._s((item.maC_NOV !=null) ? item.maC_NOV : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[(item.maC_DEC_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,12,'MACHINE',item.maC_DEC,item.maC_DEC_Remark)}}},[_vm._v(_vm._s((item.maC_DEC !=null) ? item.maC_DEC : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_JAN_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,1,'SYSTEM',item.syS_JAN,item.syS_JAN_Remark)}}},[_vm._v(_vm._s((item.syS_JAN !=null) ? item.syS_JAN : '-')+" ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_FEB_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,2,'SYSTEM',item.syS_FEB,item.syS_FEB_Remark)}}},[_vm._v(_vm._s((item.syS_FEB !=null) ? item.syS_FEB : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_MAR_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,3,'SYSTEM',item.syS_MAR,item.syS_MAR_Remark)}}},[_vm._v(_vm._s((item.syS_MAR !=null) ? item.syS_MAR: '-')+" ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_APR_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,4,'SYSTEM',item.syS_APR,item.syS_APR_Remark)}}},[_vm._v(_vm._s((item.syS_APR !=null) ? item.syS_APR: '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_MAY_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,5,'SYSTEM',item.syS_MAR,item.syS_MAY_Remark)}}},[_vm._v(_vm._s((item.syS_MAY !=null) ? item.syS_MAY: '-')+" ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_JUN_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,6,'SYSTEM',item.syS_JUN,item.syS_JUN_Remark)}}},[_vm._v(_vm._s((item.syS_JUN !=null) ? item.syS_JUN: '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_JUL_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,7,'SYSTEM',item.syS_JUL,item.syS_JUL_Remark)}}},[_vm._v(_vm._s((item.syS_JUL !=null) ? item.syS_JUL: '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_AUG_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,8,'SYSTEM',item.syS_AUG,item.syS_AUG_Remark)}}},[_vm._v(_vm._s((item.syS_AUG !=null) ?  item.syS_AUG: '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_SEP_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,9,'SYSTEM',item.syS_SEP,item.syS_SEP_Remark)}}},[_vm._v(_vm._s((item.syS_SEP !=null) ? item.syS_SEP: '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_OCT_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,10,'SYSTEM',item.syS_OCT,item.syS_OCT_Remark)}}},[_vm._v(_vm._s((item.syS_OCT !=null) ?  item.syS_OCT : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_NOV_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,11,'SYSTEM',item.syS_NOV,item.syS_NOV_Remark)}}},[_vm._v(_vm._s((item.syS_NOV !=null) ? item.syS_NOV : '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[(item.syS_DEC_STATUS === 'APPROVE')?_c('i',{staticClass:"fas fa-check-circle approved-icon",attrs:{"title":"อนุมัติแล้ว"}}):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"กดเพื่อแก้ไขข้อมูล"},on:{"click":function($event){$event.preventDefault();return _vm.showModal(item.evaluationId,12,'SYSTEM',item.syS_DEC,item.syS_DEC_Remark)}}},[_vm._v(_vm._s((item.syS_DEC !=null) ? item.syS_DEC: '-')+"  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_JAN != null) ? item.totaL_JAN : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_FEB != null) ? item.totaL_FEB : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_MAR != null) ? item.totaL_MAR : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_APR != null) ? item.totaL_APR : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_MAY != null) ? item.totaL_MAY : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_JUN != null) ? item.totaL_JUN : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_JUL != null) ? item.totaL_JUL : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_AUG != null) ? item.totaL_AUG : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_SEP != null) ? item.totaL_SEP : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_OCT != null) ? item.totaL_OCT : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_NOV != null) ? item.totaL_NOV : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_DEC != null) ? item.totaL_DEC : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s(item.grandTotal))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[(item.statusCode == 'SAVE')?_c('span',{staticClass:"text-warning"},[_c('i',{staticClass:"fa fa-check-fa fa-sync-alt"}),_vm._v(" "+_vm._s(item.statusText))]):_vm._e(),_vm._v(" "),(item.statusCode == 'APPROVE')?_c('span',{staticClass:"text-success"},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" "+_vm._s(item.statusText))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[(item.statusCode == 'SAVE')?_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"สถานะบันทึกรายการ"},on:{"click":function($event){$event.preventDefault();return _vm.ApproveJobAgentEvaluation(item.evaluationId,'APPROVE')}}},[_c('i',{staticClass:"fas fa-chart-line kt-font-warning"})]):_vm._e(),_vm._v(" "),(item.statusCode == 'APPROVE')?_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"สถานะแสดงผลที่ Dashboard"},on:{"click":function($event){$event.preventDefault();return _vm.ApproveJobAgentEvaluation(item.evaluationId,'APPROVE')}}},[_c('i',{staticClass:"fas fa-chart-line kt-font-success"})]):_vm._e()])])]})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.ApproveJobAgentEvaluationALL()}}},[_c('i',{staticClass:"fas fa-chart-line"}),_vm._v(" อนุมัติทั้งหมด\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"EditModal","tabindex":"-1","role":"dialog","aria-labelledby":"EditModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("แก้ไขคะแนน")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('form',{ref:"editForm",staticClass:"kt-form",attrs:{"autocomplete":"off","id":"editForm"},on:{"submit":_vm.formSubmit2}},[_c('div',[_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 col-md-3 col-xl-3"},[_c('div',{staticClass:"form-group mb-0"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentScore),expression:"currentScore"}],staticClass:"form-control",staticStyle:{"background-color":"#eeeeee !important"},attrs:{"readonly":"readonly","type":"number","placeholder":"คะแนน"},domProps:{"value":(_vm.currentScore)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentScore=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col-md-3 col-xl-3"},[_c('div',{staticClass:"form-group mb-0"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentScoreNew),expression:"currentScoreNew"}],staticClass:"form-control",attrs:{"id":"currentScoreNew","name":"currentScoreNew","type":"number","min":"0","placeholder":"คะแนน"},domProps:{"value":(_vm.currentScoreNew)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentScoreNew=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12 col-xl-12"},[_c('div',{staticClass:"form-group mb-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentMonth),expression:"currentMonth"}],staticClass:"form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.currentMonth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentMonth=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentTypeCode),expression:"currentTypeCode"}],staticClass:"form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.currentTypeCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentTypeCode=$event.target.value}}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentRemark),expression:"currentRemark"}],staticClass:"form-control",attrs:{"type":"text","id":"currentRemark","name":"currentRemark","placeholder":"หมายเหตุ"},domProps:{"value":(_vm.currentRemark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentRemark=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer border-0"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.SaveCommentEdit($event)}}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ยกเลิก\n              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 pt-0"},[_vm._m(5),_vm._v(" "),_c('table',{staticClass:"table table-sm  table-bordered  "},[_vm._m(6),_vm._v(" "),_c('tbody',[(_vm.dataSourceRemark==null || _vm.dataSourceRemark.length <= 0)?_c('tr',[_vm._m(7)]):_vm._e(),_vm._v(" "),_vm._l((_vm.dataSourceRemark),function(hist,i){return [_c('tr',[_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(hist.createdDateText))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(hist.oldScore))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(hist.newScore))]),_vm._v(" "),_c('td',{staticClass:"text-left align-middle"},[_vm._v(_vm._s(hist.remark))]),_vm._v(" "),_c('td',{staticClass:"text-left align-middle"},[_vm._v(_vm._s(hist.fullName))])])]})],2)])])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"TH",attrs:{"scope":"col","rowspan":"2"}},[_vm._v("NO")]),_vm._v(" "),_c('th',{staticClass:"TH",attrs:{"scope":"col","rowspan":"2"}},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"TH",attrs:{"scope":"col","rowspan":"2"}},[_vm._v("รหัส")]),_vm._v(" "),_c('th',{staticClass:"TH",attrs:{"scope":"col","rowspan":"2"}},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col","colspan":"12"}},[_vm._v("คะแนนถังคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col","colspan":"12"}},[_vm._v("คะแนนการทำระบบเบียร์สด")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col","colspan":"13"}},[_vm._v("รวมคะแนน")]),_vm._v(" "),_c('th',{staticClass:"TH",attrs:{"scope":"col","rowspan":"2"}},[_vm._v("สถานะรายการ")]),_vm._v(" "),_c('th',{staticClass:"TH",attrs:{"scope":"col","rowspan":"2"}},[_vm._v("คำสั่ง")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ม.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ก.พ.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("มี.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("เม.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("พ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("มิ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ก.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ส.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ก.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ต.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("พ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ธ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ม.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ก.พ.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("มี.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("เม.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("พ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("มิ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ก.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ส.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ก.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ต.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("พ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ธ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ม.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ก.พ.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("มี.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("เม.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("พ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("มิ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ก.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ส.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ก.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ต.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("พ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ธ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH",attrs:{"scope":"col"}},[_vm._v("Total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_vm._v("คะแนน (ปัจจุบัน) "),_c('em',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" :")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_vm._v("คะแนน (ที่ต้องการแก้ไข) "),_c('em',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" :")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_vm._v("หมายเหตุ "),_c('em',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" :")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("ประวัติการแก้ไข : ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("คะแนน(ก่อน)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("คะแนน (หลัง)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("หมายเหตุ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"scope":"col"}},[_vm._v("ผู้ดำเนินการ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('h6',[_vm._v("ไม่พบข้อมูลการแก้ไข")])])}]


/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"apUser",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'apUser' + _vm._uid,"name":'apUser' + _vm._uid,"select2-options":_vm.apUserOptions,"data-msg-required":"กรุณาเลือกพนักงาน"},on:{"selectChange":_vm.onUserChange},model:{value:(_vm.apUser),callback:function ($$v) {_vm.apUser=$$v},expression:"apUser"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"apLevel",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'apLevel' + _vm._uid,"name":'apLevel' + _vm._uid,"select2-options":_vm.apLevelOptions,"data-msg-required":"กรุณาเลือกลำดับอนุมัติ"},on:{"selectChange":_vm.onLevelChange},model:{value:(_vm.apLevel),callback:function ($$v) {_vm.apLevel=$$v},expression:"apLevel"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"apEdit",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'apEditId' + _vm._uid,"name":'apEdit' + _vm._uid,"select2-options":_vm.apEditOptions,"data-msg-required":"กรุณาเลือกเลือกสิทธิ์การแก้ไข"},on:{"selectChange":_vm.onEditChange},model:{value:(_vm.apEdit),callback:function ($$v) {_vm.apEdit=$$v},expression:"apEdit"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"apApprove",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'apApproveRow' + _vm._uid,"name":'apApproveRow' + _vm._uid,"select2-options":_vm.apApproveOptions,"data-msg-required":"กรุณาเลือกสิทธิ์การอนุมัติ"},on:{"selectChange":_vm.onApproveChange},model:{value:(_vm.apApproveRow),callback:function ($$v) {_vm.apApproveRow=$$v},expression:"apApproveRow"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('center',[_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"รายละเอียด"},on:{"click":function($event){$event.preventDefault();return _vm.detail($event)}}},[_c('i',{staticClass:"text-info far fa-file-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveAPItemClick($event)}}},[_c('i',{staticClass:"text-danger la la-trash"})])])],1)])}
var staticRenderFns = []


/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทตัวแทนจำหน่าย: ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.IS_RADIO_SHOW_AGENT),expression:"IS_RADIO_SHOW_AGENT"}],staticClass:"kt-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.epmrAgentTypeCode),expression:"epmrAgentTypeCode"}],ref:"epmrAgentTypeCode",attrs:{"type":"radio","id":"epmrAgentTypeCode","name":"AGENT_TYPE_CODE","value":"AGENT"},domProps:{"checked":_vm._q(_vm.epmrAgentTypeCode,"AGENT")},on:{"change":[function($event){_vm.epmrAgentTypeCode="AGENT"},function($event){return _vm.onEpmrAgentTypeCodeChange(this)}]}}),_vm._v(" "),_c('span'),_vm._v("\n                      ตัวแทนจำหน่าย\n                    ")]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.IS_RADIO_SHOW_SUB_AGENT),expression:"IS_RADIO_SHOW_SUB_AGENT"}],staticClass:"kt-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.epmrAgentTypeCode),expression:"epmrAgentTypeCode"}],ref:"epmrAgentTypeCode",attrs:{"type":"radio","id":"epmrAgentTypeCode","name":"AGENT_TYPE_CODE","value":"SUB_AGENT"},domProps:{"checked":_vm._q(_vm.epmrAgentTypeCode,"SUB_AGENT")},on:{"change":[function($event){_vm.epmrAgentTypeCode="SUB_AGENT"},function($event){return _vm.onEpmrAgentTypeCodeChange(this)}]}}),_vm._v(" "),_c('span'),_vm._v("\n                      ตัวแทนจำหน่ายย่อย\n                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภท:")]),_vm._v(" "),_c('select2',{ref:"epmrTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'epmrTypeCode',"name":'epmrTypeCode',"select2-options":_vm.epmrTypeCodeOptions},on:{"selectChange":_vm.onEpmrTypeCodeChange},model:{value:(_vm.epmrTypeCode),callback:function ($$v) {_vm.epmrTypeCode=$$v},expression:"epmrTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"epmrDate",staticClass:"form-control",attrs:{"readonly":"","disabled":_vm.isEdit,"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"epmrDate","name":"epmrDate"},on:{"click":_vm.onDateClick}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.epmrAgentTypeCode=='AGENT'),expression:"epmrAgentTypeCode=='AGENT'"}],staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"epmrAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'epmrAgentCode',"name":'epmrAgentCode',"select2-options":_vm.epmrAgentCodeOptions},on:{"selectChange":_vm.onEpmrAgentCodeChange},model:{value:(_vm.epmrAgentCode),callback:function ($$v) {_vm.epmrAgentCode=$$v},expression:"epmrAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"epmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'epmrShopCodes',"name":'epmrShopCodes',"select2-options":_vm.epmrShopCodesOptions,"multiple":""},model:{value:(_vm.epmrShopCodes),callback:function ($$v) {_vm.epmrShopCodes=$$v},expression:"epmrShopCodes"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.epmrAgentTypeCode=='SUB_AGENT'),expression:"epmrAgentTypeCode=='SUB_AGENT'"}],staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"epmrSubAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'epmrSubAgentCode',"name":'epmrSubAgentCode',"select2-options":_vm.epmrSubAgentCodeOptions},on:{"selectChange":_vm.onEpmrSubAgentCodeChange},model:{value:(_vm.epmrSubAgentCode),callback:function ($$v) {_vm.epmrSubAgentCode=$$v},expression:"epmrSubAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"epmrSubShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'epmrSubShopCodes',"name":'epmrSubShopCodes',"select2-options":_vm.epmrSubShopCodesOptions,"multiple":""},model:{value:(_vm.epmrSubShopCodes),callback:function ($$v) {_vm.epmrSubShopCodes=$$v},expression:"epmrSubShopCodes"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อรูท:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.epmrRouteName),expression:"epmrRouteName"}],ref:"epmrRouteName",staticClass:"form-control",attrs:{"type":"text","placeholder":"ชื่อรูท","id":"epmrRouteName","name":"epmrRouteName"},domProps:{"value":(_vm.epmrRouteName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.epmrRouteName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('select2',{ref:"epmrPmUserIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'epmrPmUserId',"name":'epmrPmUserId',"select2-options":_vm.epmrPmUserIdOptions},model:{value:(_vm.epmrPmUserId),callback:function ($$v) {_vm.epmrPmUserId=$$v},expression:"epmrPmUserId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.epmrInActiveStatus),expression:"epmrInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"epmrInActiveStatus","id":"epmrInActiveStatus"},domProps:{"checked":Array.isArray(_vm.epmrInActiveStatus)?_vm._i(_vm.epmrInActiveStatus,null)>-1:(_vm.epmrInActiveStatus)},on:{"change":function($event){var $$a=_vm.epmrInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.epmrInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.epmrInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.epmrInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล")])}]


/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"userUpdateModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อผู้ใช้งาน (UserName):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],staticClass:"form-control",attrs:{"disabled":"","id":"userName","name":"userName","type":"text","maxlength":"256","placeholder":"ชื่อผู้ใช้งาน (UserName)"},domProps:{"value":(_vm.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"disabled":"","id":"email","name":"email","type":"email","maxlength":"256","placeholder":"อีเมล"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("โปรไฟล์บริษัท:")]),_vm._v(" "),_c('select2',{ref:"useraCompanyProfileSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"useraCompanyProfile","name":"useraCompanyProfile","select2-options":_vm.useraCompanyProfileOptions},on:{"selectChange":_vm.onCompanyProfileChange},model:{value:(_vm.useraCompanyProfile),callback:function ($$v) {_vm.useraCompanyProfile=$$v},expression:"useraCompanyProfile"}}),_vm._v(" "),_c('br'),_vm._v("ไม่พบข้อมูลโปรไฟล์บริษัทคลิกเพื่อสร้าง\n                      "),_c('a',{attrs:{"href":"javascript:void()"},on:{"click":_vm.showSubAgentProfileCreateForm}},[_vm._v("โปรไฟล์ตัวแทนฯย่อย")]),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.givenName),expression:"givenName"}],staticClass:"form-control",attrs:{"id":"givenName","name":"givenName","type":"text","maxlength":"450","placeholder":"ชื่อ"},domProps:{"value":(_vm.givenName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.givenName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสกุล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.familyName),expression:"familyName"}],staticClass:"form-control",attrs:{"id":"familyName","name":"familyName","type":"text","maxlength":"450","placeholder":"ชื่อสกุล"},domProps:{"value":(_vm.familyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.familyName=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่ง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.position),expression:"position"}],staticClass:"form-control",attrs:{"id":"position","name":"position","type":"text","maxlength":"450","placeholder":"ตำแหน่ง"},domProps:{"value":(_vm.position)},on:{"input":function($event){if($event.target.composing){ return; }_vm.position=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"form-control",attrs:{"id":"phoneNumber","name":"phoneNumber","type":"text","maxlength":"450","placeholder":"เบอร์ติดต่อ"},domProps:{"value":(_vm.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่เข้าสู่ระบบล่าสุด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastLogOnDateTimeString),expression:"lastLogOnDateTimeString"}],staticClass:"form-control",attrs:{"disabled":"","name":"lastLogOnDateTimeString","type":"text"},domProps:{"value":(_vm.lastLogOnDateTimeString)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastLogOnDateTimeString=$event.target.value}}})])])]),_vm._v(" "),_c('user-sml-mapping',{attrs:{"selectedCompanyProfiles":_vm.selectedCompanyProfiles,"userSmlMappings":_vm.userSmlMappings},on:{"update:userSmlMappings":function($event){_vm.userSmlMappings=$event},"update:user-sml-mappings":function($event){_vm.userSmlMappings=$event}}})],1)])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('sub-agent-profile-create-form',{ref:"subAgentProfileCreateForm"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล")])])}]


/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MaintainReport/RepairUsage'),expression:"$route.path == '/MaintainReport/RepairUsage'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่ซ่อมเสร็จสิ้น(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateStart","name":"jobsDateStart","readonly":""}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ซ่อมเสร็จสิ้น(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateEnd","name":"jobsDateEnd","readonly":""}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qiOldBarcode),expression:"qiOldBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"BARCODE"},domProps:{"value":(_vm.qiOldBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qiOldBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่ใบงาน :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qiJobNumber),expression:"qiJobNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"เลขที่ใบงาน"},domProps:{"value":(_vm.qiJobNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qiJobNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"jobSubtype","multiple":true,"options":_vm.qiJobSubtype,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.jobSubtype),callback:function ($$v) {_vm.jobSubtype=$$v},expression:"jobSubtype"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductCode","multiple":true,"options":_vm.qiProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductCode),callback:function ($$v) {_vm.qiProductCode=$$v},expression:"qiProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เขต:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"jobArea","multiple":true,"options":_vm.qiJobAreaOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.jobArea),callback:function ($$v) {_vm.jobArea=$$v},expression:"jobArea"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อช่าง:")]),_vm._v(" "),_c('treeselect',{ref:"qiUserId",attrs:{"multiple":true,"load-options":_vm.LoadUsersIdOptions,"async":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadUsersIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.qiUserId),callback:function ($$v) {_vm.qiUserId=$$v},expression:"qiUserId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[(this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN']))?_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.exportExcel}},[_vm._m(3)]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]):_vm._e()])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []


/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/Contact'),expression:"$route.path == '/Master/Contact'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ค้นหา :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.colKeyword),expression:"colKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ประเภท-ชื่อผู้ติดต่อ ชื่อเล่น เบอร์โทร Email ตำแหน่ง บริษัท"},domProps:{"value":(_vm.colKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.colKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทผู้ติดต่อ :")]),_vm._v(" "),_c('select2',{ref:"colCompanyTypeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'colCompanyType',"name":'colCompanyType',"select2-options":_vm.colCompanyTypeOptions},model:{value:(_vm.colCompanyType),callback:function ($$v) {_vm.colCompanyType=$$v},expression:"colCompanyType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"colInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'colInActiveStatus',"name":'colInActiveStatus',"select2-options":_vm.colInActiveStatusOptions},model:{value:(_vm.colInActiveStatus),callback:function ($$v) {_vm.colInActiveStatus=$$v},expression:"colInActiveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['MANAGE_MASTER', 'MANAGE_CONTACT']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"Contact/Add","tag":"button","title":"เพิ่มข้อมูลการถือครอง"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูลผู้ติดต่อ\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-address-book"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"contactTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("วันที่สร้าง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทผู้ติดต่อ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("บริษัท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อผู้ติดต่อ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อเล่น")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เบอร์โทร")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("Email")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ตำแหน่ง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/Product'),expression:"$route.path == '/Master/Product'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PrlKeyword),expression:"PrlKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก รหัสสินค้า, ชื่อสินค้า โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ชื่อสินค้า1, ชื่อสินค้า2"},domProps:{"value":(_vm.PrlKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.PrlKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.PrlProductBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.PrlProductBrandId),callback:function ($$v) {_vm.PrlProductBrandId=$$v},expression:"PrlProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมวดหมู่สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.PrlProductGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.PrlProductGroupId),callback:function ($$v) {_vm.PrlProductGroupId=$$v},expression:"PrlProductGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.PrlProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.PrlProductTypeId),callback:function ($$v) {_vm.PrlProductTypeId=$$v},expression:"PrlProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้าสำหรับใบHold(รับคืน):")]),_vm._v(" "),_c('select2',{ref:"PrlIsForJobHoldSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'PrlIsForJobHold',"name":'PrlIsForJobHold',"select2-options":_vm.PrlIsForJobHoldOptions},model:{value:(_vm.PrlIsForJobHold),callback:function ($$v) {_vm.PrlIsForJobHold=$$v},expression:"PrlIsForJobHold"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("มีข้อมูลรหัสบาร์โค้ด:")]),_vm._v(" "),_c('select2',{ref:"PrlIsForJobHoldSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'PrlHasBarcode',"name":'PrlHasBarcode',"select2-options":_vm.PrlHasBarcodeOptions},model:{value:(_vm.PrlHasBarcode),callback:function ($$v) {_vm.PrlHasBarcode=$$v},expression:"PrlHasBarcode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทอะไหล่งาน PM:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.PrlPMSpareCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.PrlPMSpareCode),callback:function ($$v) {_vm.PrlPMSpareCode=$$v},expression:"PrlPMSpareCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"PrlStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'PrlStatus',"name":'PrlStatus',"select2-options":_vm.PrlStatusOptions},model:{value:(_vm.PrlStatus),callback:function ($$v) {_vm.PrlStatus=$$v},expression:"PrlStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-cubes"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"ProductTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("หมวดหมู่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("หน่วยนับ")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("สินค้าสำหรับใบHold(รับคืน)")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ประเภทอะไหล่งาน PM")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/ReturnProduct'),expression:"$route.path == '/Report/ReturnProduct'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBarcode),expression:"reBarcode"}],staticClass:"form-control",attrs:{"id":"reBarcode","type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reProductTypeId","multiple":true,"options":_vm.reProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reProductTypeId),callback:function ($$v) {_vm.reProductTypeId=$$v},expression:"reProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reProductCode","multiple":true,"options":_vm.reProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reProductCode),callback:function ($$v) {_vm.reProductCode=$$v},expression:"reProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reProductBrandId","multiple":true,"options":_vm.reProductBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reProductBrandId),callback:function ($$v) {_vm.reProductBrandId=$$v},expression:"reProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เลขที่เอกสาร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reJobNumber),expression:"reJobNumber"}],staticClass:"form-control",attrs:{"id":"reJobNumber","type":"text","placeholder":"กรุณาระบุเลขที่เอกสาร"},domProps:{"value":(_vm.reJobNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reJobNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("มุมมองผู้ใช้งาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reViewPermissionCode","multiple":false,"options":_vm.reViewPermissionOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"input":function($event){return _vm.ChangeOptions('View')}},model:{value:(_vm.reViewPermissionCode),callback:function ($$v) {_vm.reViewPermissionCode=$$v},expression:"reViewPermissionCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.reViewPermissionCode == 'BR_REPORT')?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อคลังสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"rePlantCode","multiple":true,"options":_vm.rePlantCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePlantCode),callback:function ($$v) {_vm.rePlantCode=$$v},expression:"rePlantCode"}})],1)]):_vm._e(),_vm._v(" "),(_vm.reViewPermissionCode == 'BR_REPORT' || _vm.reViewPermissionCode == 'AGENT_REPORT')?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reAgentCode","multiple":true,"options":_vm.reAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"input":function($event){return _vm.ChangeOptions('reAgentCode')}},model:{value:(_vm.reAgentCode),callback:function ($$v) {_vm.reAgentCode=$$v},expression:"reAgentCode"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('treeselect',{ref:"reShopCode",attrs:{"id":"reShopCode","multiple":true,"load-options":_vm.LoadreShopCodeOptions,"async":true,"cacheOptions":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก"},on:{"open":_vm.resLoadreShopCodeOptions},model:{value:(_vm.reShopCode),callback:function ($$v) {_vm.reShopCode=$$v},expression:"reShopCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reShopTypeId","multiple":true,"options":_vm.reShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reShopTypeId),callback:function ($$v) {_vm.reShopTypeId=$$v},expression:"reShopTypeId"}})],1)]),_vm._v(" "),(_vm.reViewPermissionCode == 'BR_REPORT')?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ขนส่ง:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reTransitId","multiple":true,"options":_vm.reTransitIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTransitId),callback:function ($$v) {_vm.reTransitId=$$v},expression:"reTransitId"}})],1)]):_vm._e(),_vm._v(" "),(_vm.reViewPermissionCode == 'BR_REPORT')?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สังกัด(ขนส่ง):")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reTransitType","multiple":true,"options":_vm.reTransitTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTransitType),callback:function ($$v) {_vm.reTransitType=$$v},expression:"reTransitType"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('treeselect',{ref:"reScanUserId",attrs:{"id":"reScanUserId","multiple":true,"load-options":_vm.LoadreScanUserIdOptions,"async":true,"clear-on-select":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadreScanUserIdOptions},model:{value:(_vm.reScanUserId),callback:function ($$v) {_vm.reScanUserId=$$v},expression:"reScanUserId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.ExportReturnProduct($event)}}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"ReturnProductTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"16"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reDateReq)+"\n                  ")])]),_vm._v(" "),(_vm.reViewPermissionCode == 'AGENT_REPORT')?_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้ดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"})]):_vm._e(),_vm._v(" "),(_vm.reViewPermissionCode == 'BR_REPORT')?_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสคลังสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อคลังสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ขนส่ง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สังกัด(ขนส่ง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้ดำเนินการ")])]):_vm._e()]),_vm._v(" "),_c('tfoot',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowFooter == true),expression:"isShowFooter == true"}]},[_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนรวม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v(_vm._s(_vm.reTotalBarcode))])])])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('form-summary-stock-attachment-modal',{ref:"attachmentModal",on:{"closed":function($event){return _vm.reloadDataTable()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PrintSummary/Barcodes'),expression:"$route.path == '/PrintSummary/Barcodes'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ค้นหาเลขเอกสาร :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchDocumentNo),expression:"searchDocumentNo"}],staticClass:"form-control",attrs:{"type":"text","id":"fssList_documentNo","name":"fssList_documentNo","placeholder":"เช่น DB2026-06001","autocomplete":"off"},domProps:{"value":(_vm.searchDocumentNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchDocumentNo=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"fssList_agentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'fssList_agentCode',"name":'fssList_agentCode',"select2-options":_vm.agentOptions},model:{value:(_vm.searchAgentCode),callback:function ($$v) {_vm.searchAgentCode=$$v},expression:"searchAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะแนบไฟล์เอกสาร :")]),_vm._v(" "),_c('select2',{ref:"fssList_attachmentStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'fssList_attachmentStatus',"name":'fssList_attachmentStatus',"select2-options":_vm.attachmentStatusOptions},model:{value:(_vm.searchAttachmentStatus),callback:function ($$v) {_vm.searchAttachmentStatus=$$v},expression:"searchAttachmentStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"fssList_dateFrom",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"fssList_dateFrom","name":"fssList_dateFrom","autocomplete":"off"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"fssList_dateTo",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"fssList_dateTo","name":"fssList_dateTo","autocomplete":"off"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อายุ Export Excel :")]),_vm._v(" "),_c('select2',{ref:"fssList_excelExpiryStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'fssList_excelExpiryStatus',"name":'fssList_excelExpiryStatus',"select2-options":_vm.excelExpiryStatusOptions},model:{value:(_vm.searchExcelExpiryStatus),callback:function ($$v) {_vm.searchExcelExpiryStatus=$$v},expression:"searchExcelExpiryStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-test":"fss-list-search"}},[_vm._v("\n                ค้นหา\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างข้อมูล\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(_vm.canEdit)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.goToCreate}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" เพิ่มสรุปสินค้าคงค้าง\n              ")]):_vm._e()])])]),_vm._v(" "),_vm._m(3)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-file-alt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"formSummaryStockTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-center",staticStyle:{"width":"12%"}},[_vm._v("เลขที่เอกสาร")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"13%"}},[_vm._v("วันที่บันทึก")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"38%"}},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"37%"}},[_vm._v("ผู้สร้าง")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"230px"}},[_vm._v("คำสั่ง")])])])])])])}]


/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('select2',{ref:"odMaterialCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"odMaterialCode","name":"odMaterialCode","select2-options":_vm.odMaterialCodeOptions},on:{"selectChange":_vm.onMaterialCodeChange},model:{value:(_vm.odMaterialCode),callback:function ($$v) {_vm.odMaterialCode=$$v},expression:"odMaterialCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เจ้าของทรัพย์สิน :")]),_vm._v(" "),_c('select2',{ref:"mbAssetOwnerIdSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"mbAssetOwnerId","name":"mbAssetOwnerId","select2-options":_vm.MbAssetOwnerOptions},on:{"selectChange":_vm.onMbAssetOwnerIdChange},model:{value:(_vm.mbAssetOwnerId),callback:function ($$v) {_vm.mbAssetOwnerId=$$v},expression:"mbAssetOwnerId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ปี(สินค้า) (ค.ศ.) :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"odYear",staticClass:"form-control",attrs:{"type":"text","placeholder":"(YYYY)","id":"odYear","name":"odYear","autocomplete":"off"}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odPrice),expression:"odPrice"}],staticClass:"form-control",attrs:{"id":"odPrice","name":"odPrice","type":"number","min":"0.00","placeholder":"บาท"},domProps:{"value":(_vm.odPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.odPrice=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่บันทึก :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"odEffectiveDateFrom",staticClass:"form-control",staticStyle:{"background-color":"#EEEEEE"},attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"odEffectiveDateFrom","name":"odEffectiveDateFrom"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odInActiveStatus),expression:"odInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"odInActiveStatus","name":"odInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.odInActiveStatus)?_vm._i(_vm.odInActiveStatus,null)>-1:(_vm.odInActiveStatus)},on:{"change":function($event){var $$a=_vm.odInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.odInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.odInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.odInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(3)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label-required"},[_vm._v("ราคาค่าถัง ("),_c('span',{staticClass:"text-danger"},[_vm._v("* ราคาใช้สำหรับรายงานคงค้างเกินกำหนด")]),_vm._v(") :")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MKTReport/NewShopOnOffPremise'),expression:"$route.path == '/MKTReport/NewShopOnOffPremise'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทงาน:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reObjectivesCode',"name":'reObjectivesCode',"select2-options":_vm.reObjectivesCodeOptions},model:{value:(_vm.reObjectivesCode),callback:function ($$v) {_vm.reObjectivesCode=$$v},expression:"reObjectivesCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อเจ้าหน้าที่:")]),_vm._v(" "),_c('treeselect',{ref:"reUserIds",attrs:{"multiple":true,"async":true,"load-options":_vm.LoadreUserIdsOptions,"cacheOptions":false,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก"},on:{"open":_vm.reLoadreUserIdsOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.reUserIds),callback:function ($$v) {_vm.reUserIds=$$v},expression:"reUserIds"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportQIGroupByAgent}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"NewShopOnOffPremiseTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"9"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อเจ้าหน้าที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์ที่จำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประมาณการยอดขาย")])])}]


/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่องบประมาณ :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buBudgetName),expression:"buBudgetName"}],staticClass:"form-control",attrs:{"id":"buBudgetName","name":"buBudgetName","type":"text","maxlength":"450"},domProps:{"value":(_vm.buBudgetName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.buBudgetName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทงบประมาณ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.buBudgetType))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("งบประมาณ :")]),_vm._v(" "),_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({locale: _vm.locale, currency: _vm.currency}),expression:"{locale, currency}"}],staticClass:"form-control",attrs:{"id":"buBudget","name":"buBudget","auto-decimal-mode:true":"","placeholder":"งบประมาณ"},model:{value:(_vm.buBudget),callback:function ($$v) {_vm.buBudget=$$v},expression:"buBudget"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ใช้ไป :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm._f("currency")(_vm.buUsed,'฿')))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("คงเหลือ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm._f("currency")(_vm.BuBalanceCal,'฿')))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ปี :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.buYear))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buStatus),expression:"buStatus"}],staticClass:"form-check-input",attrs:{"id":"buStatus","name":"buStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.buStatus)?_vm._i(_vm.buStatus,null)>-1:(_vm.buStatus)},on:{"change":function($event){var $$a=_vm.buStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.buStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.buStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.buStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('table',{staticClass:"table table-bordered table-stripped"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.userSmlMappings),function(map){return _c('tr',{key:map.agentCode},[_c('td',{staticClass:"text-center pt-4"},[_vm._v(_vm._s(map.mappingToAgentCode)+" "+_vm._s(map.mappingToAgentName))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(map.whCode),expression:"map.whCode"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"50","placeholder":"หากไม่ระบุจะใช้ DBS222"},domProps:{"value":(map.whCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(map, "whCode", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(map.location1Code),expression:"map.location1Code"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"50","placeholder":"หากไม่ระบุจะใช้ LC100"},domProps:{"value":(map.location1Code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(map, "location1Code", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(map.location2Code),expression:"map.location2Code"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"50","placeholder":"หากไม่ระบุจะใช้ LC300"},domProps:{"value":(map.location2Code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(map, "location2Code", $event.target.value)}}})])])}),_vm._v(" "),(_vm.userSmlMappings.length == 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("ไม่พบข้อมูลโปรไฟล์ประเภทตัวแทนจำหน่าย")])]):_vm._e()],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"40%"}},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"20%"}},[_vm._v("คลังอุปกรณ์เบียร์สด")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"20%"}},[_vm._v("พื้นที่เก็บ (คลังหลักพร้อมขาย)")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"20%"}},[_vm._v("พื้นที่เก็บ (คลังถังเบียร์สด)")])])])}]


/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"brandExportModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทงบประมาณ :")]),_vm._v(" "),_c('select2',{ref:"exBudgetTypeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'exBudgetType',"name":'exBudgetType',"select2-options":_vm.exBudgetTypeOptions},model:{value:(_vm.exBudgetType),callback:function ($$v) {_vm.exBudgetType=$$v},expression:"exBudgetType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปี(งบประมาณ) :")]),_vm._v(" "),_c('select2',{ref:"exYearSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'exYear',"name":'exYear',"select2-options":_vm.exYearOptions},model:{value:(_vm.exYear),callback:function ($$v) {_vm.exYear=$$v},expression:"exYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"exStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'exStatus',"name":'exStatus',"select2-options":_vm.exStatusOptions},model:{value:(_vm.exStatus),callback:function ($$v) {_vm.exStatus=$$v},expression:"exStatus"}})],1)])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" Export\n          ")])])}]


/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/AlertPM'),expression:"$route.path == '/PMReport/AlertPM'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body pt-2"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM',
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM',\n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAPMAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadreAPMAgentCodeOptions},model:{value:(_vm.reAPMAgentCode),callback:function ($$v) {_vm.reAPMAgentCode=$$v},expression:"reAPMAgentCode"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',\n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-6 col-lg-6 col-md-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrSubAgentCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentCodes',"name":'pmrSubAgentCodes',"select2-options":_vm.pmrSubAgentCodeOptions,"multiple":""},model:{value:(_vm.pmrSubAgentCodes),callback:function ($$v) {_vm.pmrSubAgentCodes=$$v},expression:"pmrSubAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAPMRegionOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAPMRegion),callback:function ($$v) {_vm.reAPMRegion=$$v},expression:"reAPMRegion"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("เดือน(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reAPMDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(ดด/ปปปป)","id":"reAPMDateStart","name":"reAPMDateStart","autocomplete":"off"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เดือน(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reAPMDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(ดด/ปปปป)","id":"reAPMDateEnd","name":"reAPMDateEnd","autocomplete":"off"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3",staticStyle:{"display":"none"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลือกครั้ง Alert:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAPMAlertCountOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAPMAlertCount),callback:function ($$v) {_vm.reAPMAlertCount=$$v},expression:"reAPMAlertCount"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("นับรอบ Alert ครั้งที่:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAPMAlertCycleOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAPMAlertCycle),callback:function ($$v) {_vm.reAPMAlertCycle=$$v},expression:"reAPMAlertCycle"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3",staticStyle:{"display":"none"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAPMTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAPMType),callback:function ($$v) {_vm.reAPMType=$$v},expression:"reAPMType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อผู้ใช้งาน:")]),_vm._v(" "),_c('treeselect',{ref:"reAPMCreatedUserId",attrs:{"multiple":true,"load-options":_vm.LoadreAPMCreatedUserIdOptions,"async":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadreAPMCreatedUserIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.reAPMCreatedUserId),callback:function ($$v) {_vm.reAPMCreatedUserId=$$v},expression:"reAPMCreatedUserId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreAPMShopIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"ค้นหาจาก ชื่อร้านค้า เช่น ชื่อร้านค้า1,ชื่อร้านค้า2","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reAPMShopId),callback:function ($$v) {_vm.reAPMShopId=$$v},expression:"reAPMShopId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE (เครื่องทำความเย็น/หัวจ่าย):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reAPMBarcodeNo),expression:"reAPMBarcodeNo"}],staticClass:"form-control",attrs:{"id":"reAPMBarcodeNo","name":"reAPMBarcodeNo","type":"text","placeholder":"กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reAPMBarcodeNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reAPMBarcodeNo=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะร้านค้า:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAPMStatus',"name":'reAPMStatus',"select2-options":_vm.reAPMStatusOptions},model:{value:(_vm.reAPMStatus),callback:function ($$v) {_vm.reAPMStatus=$$v},expression:"reAPMStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3",staticStyle:{"display":"none"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAPMBrandOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAPMBrand),callback:function ($$v) {_vm.reAPMBrand=$$v},expression:"reAPMBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3",staticStyle:{"display":"none"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMShopTypeId),callback:function ($$v) {_vm.rePMShopTypeId=$$v},expression:"rePMShopTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3",staticStyle:{"display":"none"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"rePMProvinceIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'rePMProvinceId',"name":'rePMProvinceId',"select2-options":_vm.rePMProvinceIdOptions},on:{"selectChange":_vm.onAmpherIdChange},model:{value:(_vm.rePMProvinceId),callback:function ($$v) {_vm.rePMProvinceId=$$v},expression:"rePMProvinceId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3",staticStyle:{"display":"none"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"rePMAmpherIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'rePMAmpherId',"name":'rePMAmpherId',"select2-options":_vm.rePMAmpherIdOptions},model:{value:(_vm.rePMAmpherId),callback:function ($$v) {_vm.rePMAmpherId=$$v},expression:"rePMAmpherId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3",staticStyle:{"display":"none"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภท เครื่อง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMMachineProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMMachineProductCode),callback:function ($$v) {_vm.rePMMachineProductCode=$$v},expression:"rePMMachineProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทการล้างเครื่อง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmShopPMTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmShopPMType),callback:function ($$v) {_vm.shmShopPMType=$$v},expression:"shmShopPMType"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":function($event){return _vm.formReset($event)}}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportAlertPM}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"alertPMTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"17"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย/รหัสตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย/ชื่อตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อผู้ใช้งาน (Username)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทการล้างเครื่อง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Type (ครื่องทำความเย็น/หัวจ่าย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE (เครื่องทำความเย็น/หัวจ่าย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภท (ครื่องทำความเย็น/หัวจ่าย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่ล้างล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่ alert ล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลือกครั้ง Alert")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("นับรอบ Alert ครั้งที่")])])}]


/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/ProductStocks'),expression:"$route.path == '/Report/ProductStocks'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมวดหมู่สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePsProductGroupOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePsProductGroup),callback:function ($$v) {_vm.rePsProductGroup=$$v},expression:"rePsProductGroup"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePsProductTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePsProductType),callback:function ($$v) {_vm.rePsProductType=$$v},expression:"rePsProductType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePsMaterialCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePsMaterialCode),callback:function ($$v) {_vm.rePsMaterialCode=$$v},expression:"rePsMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePsStatusOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePsStatus),callback:function ($$v) {_vm.rePsStatus=$$v},expression:"rePsStatus"}})],1)]),_vm._v(" "),(this.$root.canShow(['BR_REPORT']) && _vm.reViewPermissionCode == 'AGENT_REPORT')?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คลัง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePsPlantCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePsPlantCode),callback:function ($$v) {_vm.rePsPlantCode=$$v},expression:"rePsPlantCode"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT']) && _vm.reViewPermissionCode == 'AGENT_REPORT')?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePsAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePsAgentCode),callback:function ($$v) {_vm.rePsAgentCode=$$v},expression:"rePsAgentCode"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['BR_REPORT']) && _vm.reViewPermissionCode == 'AGENT_REPORT')?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("พนักงาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePsForUserIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePsForUserId),callback:function ($$v) {_vm.rePsForUserId=$$v},expression:"rePsForUserId"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reViewPermissionCode == 'SUB_AGENT_REPORT'),expression:"reViewPermissionCode == 'SUB_AGENT_REPORT'"}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('treeselect',{ref:"reShop",attrs:{"id":"reShop","async":true,"multiple":true,"load-options":_vm.LoadShopOptions,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadShopOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.reShop),callback:function ($$v) {_vm.reShop=$$v},expression:"reShop"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("มุมมองผู้ใช้งาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reViewPermissionCode","multiple":false,"options":_vm.reViewPermissionOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"input":function($event){return _vm.ChangeOptions('View')}},model:{value:(_vm.reViewPermissionCode),callback:function ($$v) {_vm.reViewPermissionCode=$$v},expression:"reViewPermissionCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportProductStock}},[_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive",staticStyle:{"min-width":"1200px"}},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display",staticStyle:{"width":"100%"},attrs:{"id":"productStockTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"15"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.rePsDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(2)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center",attrs:{"width":"15%"}},[_vm._v("สถานที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("หมวดหมู่สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"#FFD700","color":"#000000"}},[_vm._v("\n                    SINGHA\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"#D80505","color":"#000000"}},[_vm._v("\n                    LEO\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"#808080","color":"#000000"}},[_vm._v("\n                    ASAHI\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"#0E853B","color":"#000000"}},[_vm._v("\n                    CB\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"#8EA9DB","color":"#000000"}},[_vm._v("\n                    KB\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"#C65911","color":"#000000"}},[_vm._v("\n                    KOPPER\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"#FCE4D6","color":"#000000"}},[_vm._v("\n                    SNOWY\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"#E8AFFF","color":"#000000"}},[_vm._v("\n                    FULL MOON\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"#00B0F0","color":"#000000"}},[_vm._v("\n                    OTHER\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Grand Total")])])}]


/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทการตั้งค่าข้อมูลวัน Alert PM :")]),_vm._v(" "),_c('select2',{attrs:{"id":'reAlertConfigType',"name":'reAlertConfigType',"select2-options":_vm.reAlertConfigTypeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAlertConfigType),callback:function ($$v) {_vm.reAlertConfigType=$$v},expression:"reAlertConfigType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.reAlertConfigType=='AGENT' || _vm.reAlertConfigType=='SHOP')?_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"apmrAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrAgentCode',"name":'apmrAgentCode',"select2-options":_vm.apmrAgentCodeOptions},on:{"selectChange":_vm.AgentClearAfterselect},model:{value:(_vm.apmrAgentCode),callback:function ($$v) {_vm.apmrAgentCode=$$v},expression:"apmrAgentCode"}})],1)]):_vm._e(),_vm._v(" "),(_vm.reAlertConfigType=='SHOP')?_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่าย")]),_vm._v(" "),_c('select2',{ref:"apmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrShopCodes',"name":'apmrShopCodes',"select2-options":_vm.apmrShopCodesOptions},on:{"selectChange":_vm.ShopClearAfterselect},model:{value:(_vm.apmrShopCodes),callback:function ($$v) {_vm.apmrShopCodes=$$v},expression:"apmrShopCodes"}})],1)]):_vm._e(),_vm._v(" "),(_vm.reAlertConfigType=='SHOP')?_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"apmrSubAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrSubAgentCode',"name":'apmrSubAgentCode',"select2-options":_vm.apmrSubAgentCodeOptions},on:{"selectChange":_vm.SubAgentClearAfterselect},model:{value:(_vm.apmrSubAgentCode),callback:function ($$v) {_vm.apmrSubAgentCode=$$v},expression:"apmrSubAgentCode"}})],1)]):_vm._e(),_vm._v(" "),(_vm.reAlertConfigType=='SHOP')?_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"apmrSubShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrSubShopCodes',"name":'apmrSubShopCodes',"select2-options":_vm.apmrSubShopCodesOptions},model:{value:(_vm.apmrSubShopCodes),callback:function ($$v) {_vm.apmrSubShopCodes=$$v},expression:"apmrSubShopCodes"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),(_vm.reqBrand)?_c('div',{staticStyle:{"font-size":"80%","color":"#fd397a"}},[_vm._v(_vm._s(_vm.reqBrandMsg))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"1440px"}},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.brandsitems == null || _vm.brandsitems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.brandsitems),function(item,i){return [_c('item-rows',{ref:"brandItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveItemClick}})]})],2)]),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",staticStyle:{"visibility":"hidden"},attrs:{"type":"button","id":"btnupload"},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("ไฟล์\n                ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-file"}})])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("แบรนด์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวนวัน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ไฟล์อัพโหลด")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ชื่อไฟล์")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path != '/AlertReport/BeforeDue'),expression:"$route.path != '/AlertReport/BeforeDue'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[(this.$root.canShow(['super_admin']) && _vm.showDashboard)?_c('iframe',{staticStyle:{"height":"800px","width":"100%","border":"none","overflow":"hidden"},attrs:{"id":"ifdashboard"}}):_vm._e()])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title "},[_c('i',{staticClass:"text-danger",staticStyle:{"font-size":"0.8em"}},[_vm._v("* ข้อมูลที่แสดงผลเป็นรูปแบบย้อนหลัง 1 วัน ")])])])])}]


/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/BarcodeMapping'),expression:"$route.path == '/PMReport/BarcodeMapping'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จำนวนชุดอุปกรณ์ :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTotalSetOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTotalSet),callback:function ($$v) {_vm.reTotalSet=$$v},expression:"reTotalSet"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMBrandOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMBrand),callback:function ($$v) {_vm.rePMBrand=$$v},expression:"rePMBrand"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.pmrAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.pmrAgentCodes),callback:function ($$v) {_vm.pmrAgentCodes=$$v},expression:"pmrAgentCodes"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])"}],staticClass:"col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrShopCodes',"name":'pmrShopCodes',"select2-options":_vm.pmrShopCodesOptions,"multiple":""},model:{value:(_vm.pmrShopCodes),callback:function ($$v) {_vm.pmrShopCodes=$$v},expression:"pmrShopCodes"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrSubAgentCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentCodes',"name":'pmrSubAgentCodes',"select2-options":_vm.pmrSubAgentCodeOptions,"multiple":""},model:{value:(_vm.pmrSubAgentCodes),callback:function ($$v) {_vm.pmrSubAgentCodes=$$v},expression:"pmrSubAgentCodes"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])"}],staticClass:"col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentShopCodes',"name":'pmrSubAgentShopCodes',"select2-options":_vm.pmrSubAgentShopCodesOptions,"multiple":""},model:{value:(_vm.pmrSubAgentShopCodes),callback:function ($$v) {_vm.pmrSubAgentShopCodes=$$v},expression:"pmrSubAgentShopCodes"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportPM}},[_vm._m(1)]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":function($event){return _vm.formReset($event)}}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"})])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{key:_vm.$route.path}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$route.fullPath == '/Jobs'),expression:"this.$route.fullPath == '/Jobs'"}],staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--last kt-portlet--head-lg kt-portlet--responsive-mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",attrs:{"autocomplete":"off"},on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ค้นหาเลขที่ใบงาน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jobNumber),expression:"jobNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก เลขที่ใบงาน"},domProps:{"value":(_vm.jobNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.jobNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทใบงาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.jobTypeCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.jobTypeCode),callback:function ($$v) {_vm.jobTypeCode=$$v},expression:"jobTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.jobStatusCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.jobStatusCode),callback:function ($$v) {_vm.jobStatusCode=$$v},expression:"jobStatusCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก สถานที่ต้นทาง/ปลายทาง"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.productTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.productTypeId),callback:function ($$v) {_vm.productTypeId=$$v},expression:"productTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.assetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.assetCode),callback:function ($$v) {_vm.assetCode=$$v},expression:"assetCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานที่ต้นทาง (Origin):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadoriginLocationIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"เลือกสถานที่ต้นทาง (Origin) ที่ต้องการค้นหา","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.originLocationId),callback:function ($$v) {_vm.originLocationId=$$v},expression:"originLocationId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานที่ปลายทาง (Destination):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoaddestinationLocationIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"เลือกสถานที่ปลายทาง (Destination) ที่ต้องการค้นหา","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.destinationLocationId),callback:function ($$v) {_vm.destinationLocationId=$$v},expression:"destinationLocationId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('treeselect',{ref:"jobUsersId",attrs:{"multiple":true,"load-options":_vm.LoadjobUsersIdOptions,"async":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadjobUsersIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.jobUsersId),callback:function ($$v) {_vm.jobUsersId=$$v},expression:"jobUsersId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateStart","name":"jobsDateStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateEnd","name":"jobsDateEnd"}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-12"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                  ล้างข้อมูล\n                ")])])])]),_vm._v(" "),_c('table',{ref:"jobTable",staticClass:"table-sm table-striped table-bordered table-hover",attrs:{"id":"jobTable"}},[_vm._m(3)])])])])]),_vm._v(" "),_c('barcode-form',{ref:"barcodeForm"}),_vm._v(" "),_c('spare-product-list',{ref:"spareProductList"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon2-shield"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("ใบงาน")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ต้นทาง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ปลายทาง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวนบาร์โค้ด")]),_vm._v(" "),_c('th',{staticClass:"not-mobile"},[_vm._v("วันที่เคลื่อนไหวล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"not-mobile"},[_vm._v("ดำเนินการโดย")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ใช้งานแบบ Offline โดย")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("หมายเหตุ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("คำสั่ง")])])])}]


/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/TransferBarcode'),expression:"$route.path == '/Report/TransferBarcode'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"reTbOriginAgentCode",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reTbOriginAgentCode',"name":'reTbOriginAgentCode',"select2-options":_vm.reTbOriginAgentCodeOptions},on:{"selectChange":_vm.onOriginAgentCodeChange},model:{value:(_vm.reTbOriginAgentCode),callback:function ($$v) {_vm.reTbOriginAgentCode=$$v},expression:"reTbOriginAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reTbDestinationShopCode',"name":'reTbDestinationShopCode',"select2-options":_vm.reTbDestinationShopCodeOptions},model:{value:(_vm.reTbDestinationShopCode),callback:function ($$v) {_vm.reTbDestinationShopCode=$$v},expression:"reTbDestinationShopCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reTbBarcode),expression:"reTbBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reTbBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reTbBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreTbDepartmentMaterialCodeOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reTbDepartmentMaterialCode),callback:function ($$v) {_vm.reTbDepartmentMaterialCode=$$v},expression:"reTbDepartmentMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbProductTypeId),callback:function ($$v) {_vm.reTbProductTypeId=$$v},expression:"reTbProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbBrandId),callback:function ($$v) {_vm.reTbBrandId=$$v},expression:"reTbBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbAssetCode),callback:function ($$v) {_vm.reTbAssetCode=$$v},expression:"reTbAssetCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จำนวนวันคงค้าง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reTbOccupiedDays),expression:"reTbOccupiedDays"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุจำนวนวันคงค้าง"},domProps:{"value":(_vm.reTbOccupiedDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reTbOccupiedDays=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reTbReturnStatus',"name":'reTbReturnStatus',"select2-options":_vm.reTbReturnStatusOptions},model:{value:(_vm.reTbReturnStatus),callback:function ($$v) {_vm.reTbReturnStatus=$$v},expression:"reTbReturnStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(
                  this.$root.canShow(['AGENT_REPORT', 'SUB_AGENT_REPORT'])
                )?_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportTransferBarcode}},[_vm._m(1)]):_vm._e()])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.reTbIsShowDetail)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('label',[_vm._v("ชื่อตัวแทนจำหน่าย : ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reTbAgentName))])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('label',[_vm._v("ชื่อร้านค้า : ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reTbShopName))])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('label',[_vm._v("ประเภทร้านค้า : ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reTbShopTypeName))])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('label',[_vm._v("ที่อยู่ : ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reTbAdress)+" อำเภอ : "+_vm._s(_vm.reTbAmphur)+" จังหวัด :\n              "+_vm._s(_vm.reTbProvince))])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('label',[_vm._v("เบอร์โทร : ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reTbTel))])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('label',[_vm._v("ผู้ติดต่อ : ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reTbContact))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"stockCardTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"12"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reTbDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(2)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนวันคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่รับสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่คืน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะ")])])}]


/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"modal fade",attrs:{"id":"importStockCoverDaysModal","tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{ref:"importForm"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{ref:"importFileInput",staticClass:"custom-file-input",attrs:{"type":"file","id":"importFile","accept":".xlsx"},on:{"change":_vm.onFileChange}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",attrs:{"for":"importFile"}},[_vm._v("\n                    "+_vm._s(_vm.importFileName || 'เลือกไฟล์...')+"\n                  ")])]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("รองรับไฟล์ .xlsx เท่านั้น")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("ยกเลิก")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.importFile},on:{"click":_vm.submitImport}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v(" นำเข้าข้อมูล\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('button',{staticClass:"btn btn-info kt-margin-r-10",attrs:{"type":"button"},on:{"click":_vm.downloadTemplate}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Download Template\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":_vm.showImportModal}},[_c('i',{staticClass:"fas fa-file-import"}),_vm._v(" Import ข้อมูลตามเป้าหมาย\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"scvdForm",staticClass:"kt-form",attrs:{"id":"scvdCreateForm","autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"table-responsive",staticStyle:{"overflow-x":"auto"}},[_c('table',{staticClass:"table table-bordered table-sm table-hover scvd-flat-grid",staticStyle:{"table-layout":"fixed","min-width":"1555px"}},[_vm._m(3),_vm._v(" "),_c('tbody',[(_vm.rows.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"11"}},[_vm._v("\n                    ยังไม่มีรายการ คลิก \"เพิ่มข้อมูลตามเป้าหมาย\" เพื่อเพิ่ม\n                  ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.rows),function(row,i){return _c('tr',{key:'scvd-' + row._uid,class:{ 'table-danger': row._hasError }},[_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(row.month),expression:"row.month"}],staticClass:"form-control form-control-sm",attrs:{"name":'month_' + row._uid,"required":"","data-msg-required":"กรุณาเลือกเดือน"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(row, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- เลือก --")]),_vm._v(" "),_vm._l((_vm.monthOptions),function(m){return _c('option',{key:m.value,domProps:{"value":m.value}},[_vm._v("\n                        "+_vm._s(m.text)+"\n                      ")])})],2)]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(row.year),expression:"row.year",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"name":'year_' + row._uid,"required":"","data-msg-required":"กรุณาเลือกปี"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(row, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.yearOptions),function(y){return _c('option',{key:y,domProps:{"value":y}},[_vm._v(_vm._s(y))])}),0)]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.saleDays),expression:"row.saleDays"}],staticClass:"form-control form-control-sm text-right",attrs:{"type":"text","inputmode":"numeric","name":'saleDays_' + row._uid,"required":"","data-msg-required":"กรุณากรอกจำนวนวันขาย"},domProps:{"value":(row.saleDays)},on:{"keydown":function($event){return _vm.onIntKeydown($event)},"blur":function($event){return _vm.onSaleDaysBlur(row, $event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "saleDays", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control form-control-sm',"id":'plantSel_' + row._uid,"name":'plantSel_' + row._uid,"ref-obj":row._uid,"select2-options":_vm.plantOptions},on:{"selectChange":_vm.onPlantChange},model:{value:(row.plantCode),callback:function ($$v) {_vm.$set(row, "plantCode", $$v)},expression:"row.plantCode"}})],1),_vm._v(" "),_c('td',[_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control form-control-sm',"id":'prodSel_' + row._uid,"name":'prodSel_' + row._uid,"ref-obj":row._uid,"select2-options":_vm.productOptions},on:{"selectChange":_vm.onProductChange},model:{value:(row.productCode),callback:function ($$v) {_vm.$set(row, "productCode", $$v)},expression:"row.productCode"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.bgStockText),expression:"row.bgStockText"}],staticClass:"form-control form-control-sm text-right",attrs:{"type":"text","inputmode":"numeric","name":'bg_' + row._uid,"required":"","data-msg-required":"กรุณากรอกจำนวน BG Stock"},domProps:{"value":(row.bgStockText)},on:{"keydown":function($event){return _vm.onIntKeydown($event)},"focus":function($event){return _vm.onNumFocus(row, 'bgStock')},"blur":function($event){return _vm.onNumBlur(row, 'bgStock')},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "bgStockText", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.demandText),expression:"row.demandText"}],staticClass:"form-control form-control-sm text-right",attrs:{"type":"text","inputmode":"numeric","name":'demand_' + row._uid,"required":"","data-msg-required":"กรุณากรอกจำนวน Demand"},domProps:{"value":(row.demandText)},on:{"keydown":function($event){return _vm.onIntKeydown($event)},"focus":function($event){return _vm.onNumFocus(row, 'demand')},"blur":function($event){return _vm.onNumBlur(row, 'demand')},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "demandText", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.supplyText),expression:"row.supplyText"}],staticClass:"form-control form-control-sm text-right",attrs:{"type":"text","inputmode":"numeric","name":'supply_' + row._uid,"required":"","data-msg-required":"กรุณากรอกจำนวน Supply"},domProps:{"value":(row.supplyText)},on:{"keydown":function($event){return _vm.onIntKeydown($event)},"focus":function($event){return _vm.onNumFocus(row, 'supply')},"blur":function($event){return _vm.onNumBlur(row, 'supply')},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "supplyText", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"text-right align-middle font-weight-bold"},[_vm._v("\n                    "+_vm._s(_vm.formatScvd(row.scvd))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_c('button',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"type":"button","title":"ลบรายการ"},on:{"click":function($event){return _vm.removeRow(i)}}},[_c('i',{staticClass:"la la-trash text-danger"})])])])})],2)])]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("* SCVD คำนวณอัตโนมัติ (ปัดเศษ 2 ตำแหน่ง) — แสดง \"-\" เมื่อจำนวนวันขาย หรือ Demand เป็น 0")]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.addRow}},[_c('i',{staticClass:"la la-plus"}),_vm._v(" เพิ่มข้อมูลตามเป้าหมาย\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-12"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","disabled":_vm.isSaving}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "+_vm._s(_vm.isSaving ? 'กำลังบันทึก...' : 'บันทึก')+"\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Import ข้อมูลตามเป้าหมาย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("ไฟล์ Excel (.xlsx) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-plus-circle"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            เพิ่มข้อมูล Stock Cover Days\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"56px"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"115px"}},[_vm._v("เดือน "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"110px"}},[_vm._v("ปี "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"98px"}},[_vm._v("จำนวนวันขาย"),_c('br'),_vm._v("(วัน) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"350px"}},[_vm._v("ชื่อคลังสินค้า "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"350px"}},[_vm._v("ชื่อสินค้า "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"112px"}},[_vm._v("จำนวน BG Stock(ลิตร) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"112px"}},[_vm._v("จำนวน Demand(ลิตร) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"112px"}},[_vm._v("จำนวน Supply(ลิตร) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"70px"}},[_vm._v("SCVD")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"70px"}},[_vm._v("คำสั่ง")])])])}]


/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"Modal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสขนส่ง:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสคลังสินค้า:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อคลังสินค้า:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("User:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Password:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"password","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ที่อยู่:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อผู้ติดต่อ:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Lat:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Lng:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รูปภาพ:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"file","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผลิตภัณฑ์:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะคลัง:")]),_vm._v(" "),_c('select',{staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"statusStock"}},[_c('option',{attrs:{"value":""}},[_vm._v("-")]),_vm._v(" "),_c('option',{attrs:{"value":"open"}},[_vm._v("เปิด")]),_vm._v(" "),_c('option',{attrs:{"value":"close"}},[_vm._v("ปิด")])])])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n          ")])])}]


/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/AdminReport/MasterShopByBrand'),expression:"$route.path == '/AdminReport/MasterShopByBrand'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin', 'ADMIN_PM'])),expression:"this.$root.canShow(['super_admin', 'ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadreAgentCodesOptions},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reDepartmentsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reShopTypeId),callback:function ($$v) {_vm.reShopTypeId=$$v},expression:"reShopTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เดือน:")]),_vm._v(" "),_c('select2',{ref:"reMonthSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reMonth',"name":'reMonth',"select2-options":_vm.reMonthOptions},model:{value:(_vm.reMonth),callback:function ($$v) {_vm.reMonth=$$v},expression:"reMonth"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปี :")]),_vm._v(" "),_c('select2',{ref:"reYear",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reYear',"name":'reYear',"select2-options":_vm.reYearOptions},model:{value:(_vm.reYear),callback:function ($$v) {_vm.reYear=$$v},expression:"reYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"reShopStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reShopStatus',"name":'reShopStatus',"select2-options":_vm.reShopStatusOptions},model:{value:(_vm.reShopStatus),callback:function ($$v) {_vm.reShopStatus=$$v},expression:"reShopStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('select2',{ref:"reProductBrandIdSelect2",attrs:{"id":"reProductBrandId","name":"reProductBrandId","css-style":'width: 100%;',"css-class":'form-control m-select2',"select2-options":_vm.reProductBrandIdOptions},model:{value:(_vm.reProductBrandId),callback:function ($$v) {_vm.reProductBrandId=$$v},expression:"reProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"reProvinceIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reProvinceId',"name":'reProvinceId',"select2-options":_vm.reProvinceIdOptions},model:{value:(_vm.reProvinceId),callback:function ($$v) {_vm.reProvinceId=$$v},expression:"reProvinceId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"reAmpherIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAmpherId',"name":'reAmpherId',"select2-options":_vm.reAmpherIdOptions},model:{value:(_vm.reAmpherId),callback:function ($$v) {_vm.reAmpherId=$$v},expression:"reAmpherId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reIsTransaction),expression:"reIsTransaction"}],staticClass:"form-check-input",attrs:{"id":"reIsTransaction","name":"reIsTransaction","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.reIsTransaction)?_vm._i(_vm.reIsTransaction,null)>-1:(_vm.reIsTransaction)},on:{"change":function($event){var $$a=_vm.reIsTransaction,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.reIsTransaction=$$a.concat([$$v]))}else{$$i>-1&&(_vm.reIsTransaction=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.reIsTransaction=$$c}}}}),_vm._v("\n                    สถานะปัจจุบัน\n                    "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("ข้อมูลระหว่างวันที่(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ข้อมูลระหว่างวันที่(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportMasterShop}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"MasterShopTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"31"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ที่อยู่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตำบล")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("อำเภอ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสไปรษณีย์")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Module")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วัน เดือน ปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วัน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เดือน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Singha")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Leo")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Asahi")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Carlsberg")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Kopper")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Kronenbourg")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Snowy")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ANDAMAN")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BUSSABA")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("DH-Est.33")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Singha Light")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("U Korn Beer")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("CHALAWAN PALE ALE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("CHATRI IPA")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("HOF")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Other")])])}]


/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/ProductBrand'),expression:"$route.path == '/Master/ProductBrand'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pbSearch),expression:"pbSearch"}],staticClass:"form-control",attrs:{"id":"pbSearch","name":"pbSearch","type":"text","placeholder":"ค้นหาจากชื่อแบรนด์"},domProps:{"value":(_vm.pbSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pbSearch=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"pbInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pbInActiveStatus',"name":'pbInActiveStatus',"select2-options":_vm.pbInActiveStatusOptions},model:{value:(_vm.pbInActiveStatus),callback:function ($$v) {_vm.pbInActiveStatus=$$v},expression:"pbInActiveStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("กลุ่มแบรนด์ :")]),_vm._v(" "),_c('select2',{ref:"pbRivalStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pbRivalStatus',"name":'pbRivalStatus',"select2-options":_vm.pbRivalStatusOptions},model:{value:(_vm.pbRivalStatus),callback:function ($$v) {_vm.pbRivalStatus=$$v},expression:"pbRivalStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ (การทำ PM):")]),_vm._v(" "),_c('select2',{ref:"pbPMStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pbPMStatus',"name":'pbPMStatus',"select2-options":_vm.pbPMStatusOptions},model:{value:(_vm.pbPMStatus),callback:function ($$v) {_vm.pbPMStatus=$$v},expression:"pbPMStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("ล้างค่าทั้งหมด")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['MANAGE_MASTER', 'MANAGE_APPROVER']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ProductBrand/Add","tag":"button","title":"เพิ่ม"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มแบรนด์\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fab fa-product-hunt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"productBrandTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("ชื่อแบรนด์")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("กลุ่ม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ (การทำ PM)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/PMAlertSummary'),expression:"$route.path == '/PMReport/PMAlertSummary'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"rePmaDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"rePmaDateStart","name":"rePmaDateStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"rePmaDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"rePmaDateEnd","name":"rePmaDateEnd"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reDepartments',"name":'reDepartments',"select2-options":_vm.reDepartmentsOptions},on:{"selectChange":_vm.onDepartmentChange},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAgentCodes',"name":'reAgentCodes',"select2-options":_vm.reAgentCodesOptions},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportPMAlertSummary}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"MonthlyTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"9"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("\n                    จำนวนครั้งในการแจ้งเตือนการ PM\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("\n                    แจ้งเตือนเข้า PM ครั้งล่าสุด\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("\n                    จำนวนครั้งในการแจ้งเตือนการเปลี่ยนอะไหล่\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("\n                    แจ้งเตือนเปลี่ยนอะไหล่ครั้งล่าสุด\n                  ")])])}]


/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"blockUI blockOverlay",staticStyle:{"z-index":"10","border":"none","margin":"0px","padding":"0px","width":"100%","height":"100%","top":"0px","left":"0px","background-color":"rgb(0, 0, 0)","opacity":"0.03","cursor":"wait","position":"fixed"}}),_vm._v(" "),_c('div',{staticClass:"blockUI blockMsg blockPage",staticStyle:{"z-index":"1011","position":"fixed","padding":"0px","margin":"0px","width":"167px","top":"50%","left":"50%","text-align":"center","color":"rgb(0, 0, 0)","border":"0px","cursor":"wait"}},[_c('div',{staticClass:"blockui",staticStyle:{"margin-left":"-83.5px"}},[_c('span',[_vm._v("กำลังเข้าสู่ระบบ...")]),_vm._v(" "),_c('span',[_c('div',{staticClass:"kt-spinner kt-spinner--v2 kt-spinner--primary"})])])])])}]


/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.CheckRoute()),expression:"CheckRoute()"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mbpReqSearch),expression:"mbpReqSearch"}],staticClass:"form-control",attrs:{"id":"mbpReqSearch","name":"mbpReqSearch","type":"text","placeholder":"ค้นหาจาก ผู้ขอเบิก/ยืม, เลขที่ใบคำร้อง, หมายเหตุกิจกรรม เช่น สมชาย,สมจิตร"},domProps:{"value":(_vm.mbpReqSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mbpReqSearch=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย/หน่วยงาน:")]),_vm._v(" "),_c('select2',{ref:"mbpAgentSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'mbpAgent',"name":'mbpAgent',"select2-options":_vm.mbpAgentOptions},model:{value:(_vm.mbpAgent),callback:function ($$v) {_vm.mbpAgent=$$v},expression:"mbpAgent"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทใบคำร้อง:")]),_vm._v(" "),_c('select2',{ref:"mbpReqTypeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'mbpReqType',"name":'mbpReqType',"select2-options":_vm.mbpReqTypeOptions},model:{value:(_vm.mbpReqType),callback:function ($$v) {_vm.mbpReqType=$$v},expression:"mbpReqType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่เอกสาร :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"mbpReqDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"วันที่เอกสาร. (วว/ดด/ปปปป)","id":"mbpReqDate","name":"mbpReqDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"mbpReqStatusSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'mbpReqStatus',"name":'mbpReqStatus',"select2-options":_vm.mbpReqStatusOptions},model:{value:(_vm.mbpReqStatus),callback:function ($$v) {_vm.mbpReqStatus=$$v},expression:"mbpReqStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เปิดใบงาน :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.mbpOpenJopStatusCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.mbpOpenJopStatusCodes),callback:function ($$v) {_vm.mbpOpenJopStatusCodes=$$v},expression:"mbpOpenJopStatusCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมวดหมู่ :")]),_vm._v(" "),_c('select2',{class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'mbpProductGroupId',"name":'mbpProductGroupId',"select2-options":_vm.mbpProductGroupOptions},model:{value:(_vm.mbpProductGroupId),callback:function ($$v) {_vm.mbpProductGroupId=$$v},expression:"mbpProductGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.mbpProductIdsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.mbpProductIds),callback:function ($$v) {_vm.mbpProductIds=$$v},expression:"mbpProductIds"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(
                  this.$root.canShow([
                    'MANAGE_MASTER',
                    'JOB_ADMIN_BORROW',
                    'JOB_ADMIN_BORROW_PLANT' ])
                )?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"Borrow/Add","tag":"button","title":"เพิ่มข้อมูลเบิก/ยืม"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูลเบิก/ยืม\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(2)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-edit"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"table"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("วันที่เอกสาร")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เลขที่ใบคำร้อง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทใบคำร้อง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("หมวดหมู่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("มูลค่ารวม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ตัวแทนจำหน่าย/หน่วยงาน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้ขอเบิก/ยืม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("หมายเหตุกิจกรรม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เปิดใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select',{ref:"agentCode",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"agentCode","name":"agentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("สร้างโปรไฟล์ตัวแทนฯ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_vm._v("\n                  ระบบจะสร้างโปรไฟล์ตัวแทนฯให้ทั้งหมด 2 รายการ ดังนี้\n                  "),_c('br'),_vm._v("1) ชื่อตัวแทนฯ (ผู้ดูแลระบบ) "),_c('br'),_vm._v("2) ชื่อตัวแทนฯ\n                  (พนักงาน)\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" สร้างโปรไฟล์\n          ")])])}]


/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modalRoot",staticClass:"modal fade",attrs:{"id":"formSummaryStockProgressModal","tabindex":"-1","role":"dialog","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",class:{ 'fss-progress--error': _vm.isErrorMode }},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_c('i',{class:_vm.isErrorMode ? 'fas fa-exclamation-triangle' : 'fas fa-tasks'}),_vm._v("\n          "+_vm._s(_vm.displayTitle)+"\n        ")]),_vm._v(" "),(_vm.showTimer)?_c('span',{staticClass:"fss-progress__timer",attrs:{"data-test":"fss-progress-timer"}},[_vm._v(_vm._s(_vm.elapsedText))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"fss-progress__headline"},[_c('span',{staticClass:"fss-progress__counter",attrs:{"data-test":"fss-progress-counter"}},[_vm._v("\n            "+_vm._s(_vm.processedCount)+" / "+_vm._s(_vm.agentCount)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"fss-progress__percent",attrs:{"data-test":"fss-progress-percent"}},[_vm._v("\n            "+_vm._s(_vm.percent)+"%\n          ")])]),_vm._v(" "),_c('div',{staticClass:"progress fss-progress__bar"},[_c('div',{staticClass:"progress-bar",class:_vm.barClass,style:({ width: _vm.percent + '%' }),attrs:{"role":"progressbar","aria-valuenow":_vm.percent,"aria-valuemin":"0","aria-valuemax":"100"}})]),_vm._v(" "),(_vm.isRunning)?_c('div',{staticClass:"fss-progress__current",attrs:{"data-test":"fss-progress-current"}},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v("\n          กำลังทำ:\n          "),_c('strong',[_vm._v(_vm._s(_vm.currentLabel))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fss-progress__stats"},[_c('span',{staticClass:"fss-progress__stat fss-progress__stat--ok"},[_c('i',{staticClass:"fas fa-check-circle"}),_vm._v(" สำเร็จ "+_vm._s(_vm.createdCount)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"fss-progress__stat fss-progress__stat--skip"},[_c('i',{staticClass:"fas fa-minus-circle"}),_vm._v(" ข้าม "+_vm._s(_vm.skippedCount)+"\n          ")]),_vm._v(" "),(_vm.failedCount > 0)?_c('span',{staticClass:"fss-progress__stat fss-progress__stat--fail"},[_c('i',{staticClass:"fas fa-times-circle"}),_vm._v(" ไม่สำเร็จ "+_vm._s(_vm.failedCount)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fss-progress__log",attrs:{"data-test":"fss-progress-log"}},[_vm._l((_vm.displayItems),function(item){return _c('div',{key:item.key,staticClass:"fss-progress__row",class:'fss-progress__row--' + item.tone},[_c('span',{staticClass:"fss-progress__icon"},[_vm._v(_vm._s(item.icon))]),_vm._v(" "),_c('span',{staticClass:"fss-progress__seq"},[_vm._v(_vm._s(item.seqNo)+".")]),_vm._v(" "),_c('span',{staticClass:"fss-progress__name"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticClass:"fss-progress__note"},[_vm._v(_vm._s(item.note))])])}),_vm._v(" "),(_vm.displayItems.length === 0)?_c('div',{staticClass:"fss-progress__empty"},[_vm._v("\n            กำลังเริ่มต้น...\n          ")]):_vm._e()],2),_vm._v(" "),(_vm.isErrorMode)?_c('div',{staticClass:"fss-progress__error",attrs:{"data-test":"fss-progress-error"}},[_c('div',{staticClass:"fss-progress__error-stat",attrs:{"data-test":"fss-error-stats"}},[_c('i',{staticClass:"fas fa-check-circle"}),_vm._v("\n            ประมวลผลสำเร็จแล้ว "+_vm._s(_vm.successCount)+" จากทั้งหมด "+_vm._s(_vm.agentCount)+" "+_vm._s(_vm.unitLabel)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"fss-progress__error-agent",attrs:{"data-test":"fss-error-agent"}},[_c('i',{staticClass:"fas fa-times-circle"}),_vm._v("\n            ติดขัดที่: "+_vm._s(_vm.failedLabel)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"fss-progress__error-ref"},[_vm._v("\n            เลขอ้างอิง:\n            "),_c('code',{attrs:{"data-test":"fss-error-reference"}},[_vm._v(_vm._s(_vm.failedReference))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm fss-progress__error-detail-btn",attrs:{"type":"button","data-test":"fss-error-detail"},on:{"click":_vm.openErrorDetail}},[_c('i',{staticClass:"fas fa-search"}),_vm._v("\n            ตรวจสอบข้อมูลข้อความผิดพลาด (สำหรับส่งทีมดูแลระบบ SBP)\n          ")])]):_vm._e(),_vm._v(" "),(_vm.canChooseAfterFailure)?[_c('div',{staticClass:"fss-progress__error-choose"},[_vm._v("โปรดเลือกวิธีการดำเนินการต่อ:")]),_vm._v(" "),_c('button',{staticClass:"fss-error-action fss-error-action--resume",attrs:{"type":"button","data-test":"fss-error-resume","disabled":_vm.resuming || _vm.skipping},on:{"click":_vm.resumeFromFailure}},[_c('span',{staticClass:"fss-error-action__title"},[_c('i',{staticClass:"fas fa-redo"}),_vm._v("\n              "+_vm._s(_vm.resuming ? "กำลังเริ่มต่อ..." : "ประมวลผลใหม่เริ่มจากตัวแทนจำหน่ายที่ติดขัด")+"\n            ")]),_vm._v(" "),(_vm.isDocumentJob)?_c('span',{staticClass:"fss-error-action__desc",attrs:{"data-test":"fss-error-resume-desc"}},[_vm._v("\n              ระบบจะประมวลผลใหม่เริ่มจาก "),_c('strong',[_vm._v(_vm._s(_vm.failedLabel))]),_vm._v(" โดยไม่ต้องเริ่มใหม่ —\n              "),_c('strong',[_vm._v(_vm._s(_vm.createdCount)+" เอกสารที่สร้างสำเร็จแล้วจะคงอยู่")]),_vm._v("\n              ประมวลผลต่อจนครบ "+_vm._s(_vm.agentCount)+" เอกสาร\n            ")]):_c('span',{staticClass:"fss-error-action__desc",attrs:{"data-test":"fss-error-resume-desc"}},[_vm._v("\n              ระบบจะประมวลผลใหม่เริ่มจาก "),_c('strong',[_vm._v(_vm._s(_vm.failedLabel))]),_vm._v(" โดยไม่ต้องเริ่มใหม่ —\n              "),_c('strong',[_vm._v("ข้อมูล "+_vm._s(_vm.successCount)+" ตัวแทนจำหน่ายที่ประมวลผลสำเร็จแล้วจะคงอยู่")]),_vm._v("\n              ประมวลผลต่อจนครบ "+_vm._s(_vm.agentCount)+" ตัวแทนจำหน่าย\n            ")])]),_vm._v(" "),_c('button',{staticClass:"fss-error-action fss-error-action--skip",attrs:{"type":"button","data-test":"fss-error-skip","disabled":_vm.resuming || _vm.skipping},on:{"click":_vm.skipFailedAgent}},[_c('span',{staticClass:"fss-error-action__title"},[_c('i',{staticClass:"fas fa-forward"}),_vm._v("\n              "+_vm._s(_vm.skipping ? "กำลังข้าม..." : "ข้ามการประมวลผลตัวแทนจำหน่ายที่ติดขัด")+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"fss-error-action__desc",attrs:{"data-test":"fss-error-skip-desc"}},[_vm._v("\n              ระบบจะข้าม "),_c('strong',[_vm._v(_vm._s(_vm.failedLabel))]),_vm._v(" แล้ว"),_c('strong',[_vm._v("เริ่มประมวลผลตัวแทนจำหน่ายรายถัดไป")]),_vm._v(" —\n              ท่านต้องไปดำเนินการสร้างเอกสารเฉพาะตัวแทนจำหน่ายที่ติดขัดเอง\n              หลังประมวลผลเอกสารในรอบนี้เสร็จ\n              "),(!_vm.isDocumentJob)?[_vm._v("\n                (รายที่ข้ามจะแสดงท้ายตารางในขั้นตอน \"ตรวจสอบข้อมูล\" และไม่ถูกนำไปสร้างเอกสาร)\n              ")]:_vm._e()],2)])]:_vm._e(),_vm._v(" "),(!_vm.isRunning && !_vm.isErrorMode && _vm.finishedMessage)?_c('div',{staticClass:"alert fss-progress__result",class:_vm.resultAlertClass,attrs:{"data-test":"fss-progress-result"}},[_vm._v("\n          "+_vm._s(_vm.finishedMessage)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.cancelRequested && _vm.isRunning)?_c('div',{staticClass:"fss-progress__cancelling"},[_c('i',{staticClass:"fas fa-hourglass-half"}),_vm._v("\n          สั่งยกเลิกแล้ว — ระบบจะหยุดหลังจากเอกสารฉบับที่กำลังทำอยู่เสร็จ\n        ")]):_vm._e()],2),_vm._v(" "),(_vm.isRunning || !_vm.canChooseAfterFailure)?_c('div',{staticClass:"modal-footer"},[(_vm.isRunning)?_c('button',{staticClass:"btn btn-outline-danger",attrs:{"type":"button","data-test":"fss-progress-cancel","disabled":_vm.cancelRequested},on:{"click":_vm.requestCancel}},[_c('i',{staticClass:"fas fa-stop"}),_vm._v("\n          "+_vm._s(_vm.cancelRequested ? "กำลังหยุด..." : "ยกเลิก")+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isRunning && !_vm.canChooseAfterFailure)?[(_vm.hasResultFile)?_c('button',{staticClass:"btn btn-success kt-margin-r-10",attrs:{"type":"button","data-test":"fss-progress-download","disabled":_vm.downloading},on:{"click":_vm.downloadResult}},[_c('i',{staticClass:"fas fa-download"}),_vm._v("\n            "+_vm._s(_vm.downloading ? "กำลังดาวน์โหลด..." : "ดาวน์โหลดไฟล์")+"\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",class:_vm.hasResultFile ? 'btn-secondary' : 'btn-primary',attrs:{"type":"button","data-test":"fss-progress-close"},on:{"click":_vm.close}},[_vm._v("\n            ปิด\n          ")])]:_vm._e()],2):_vm._e()])])])}
var staticRenderFns = []


/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PM/PMSurveyCheckIn'),expression:"$route.path == '/PM/PMSurveyCheckIn'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chlKeyword),expression:"chlKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อ-สกุลผู้ Survey"},domProps:{"value":(_vm.chlKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chlKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่ Survey (เริ่มต้น) :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"chlCheckInDateFrom",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"วันที่ Survey (วว/ดด/ปปปป)","id":"chlCheckInDateFrom","name":"chlCheckInDateFrom"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่ Survey (สิ้นสุด) :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"chlCheckInDateTo",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"วันที่ Survey (วว/ดด/ปปปป)","id":"chlCheckInDateTo","name":"chlCheckInDateTo"}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.pmrAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.pmrAgentCodes),callback:function ($$v) {_vm.pmrAgentCodes=$$v},expression:"pmrAgentCodes"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrShopCodes',"name":'pmrShopCodes',"select2-options":_vm.pmrShopCodesOptions,"multiple":""},model:{value:(_vm.pmrShopCodes),callback:function ($$v) {_vm.pmrShopCodes=$$v},expression:"pmrShopCodes"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin', 'ADMIN_PM'])),expression:"this.$root.canShow(['super_admin', 'ADMIN_PM'])"}],staticClass:"text-danger"},[_vm._v("\n                  *ควรเลือกตัวแทนจำหน่ายด้วย\n                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrSubAgentCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentCodes',"name":'pmrSubAgentCodes',"select2-options":_vm.pmrSubAgentCodeOptions,"multiple":""},model:{value:(_vm.pmrSubAgentCodes),callback:function ($$v) {_vm.pmrSubAgentCodes=$$v},expression:"pmrSubAgentCodes"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentShopCodes',"name":'pmrSubAgentShopCodes',"select2-options":_vm.pmrSubAgentShopCodesOptions,"multiple":""},model:{value:(_vm.pmrSubAgentShopCodes),callback:function ($$v) {_vm.pmrSubAgentShopCodes=$$v},expression:"pmrSubAgentShopCodes"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin', 'ADMIN_PM'])),expression:"this.$root.canShow(['super_admin', 'ADMIN_PM'])"}],staticClass:"text-danger"},[_vm._v("\n                  *ควรเลือกตัวแทนจำหน่ายย่อยด้วย\n                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผลการดำเนินการ:")]),_vm._v(" "),_c('select2',{ref:"chlPMResultSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'chlPMResult',"name":'chlPMResult',"select2-options":_vm.chlPMResultOptions},model:{value:(_vm.chlPMResult),callback:function ($$v) {_vm.chlPMResult=$$v},expression:"chlPMResult"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","id":"btnSearch"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-2 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit","disabled":_vm.isExporting},on:{"click":_vm.exportData}},[_vm._m(3)])])])]),_vm._v(" "),_vm._m(4)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fas fa-search-location"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("ข้อมูลการ Survey PM")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"checkInTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("วันที่ Survey"),_c('br'),_vm._v("Check-in/out")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("ชื่อรูท")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"20%"}},[_vm._v("ตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"20%"}},[_vm._v("ประเภทตัวแทนจำหน่าย ")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"20%"}},[_vm._v("ชื่อ-สกุลผู้ Survey")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("ร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("ร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("ผลการดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"20%"}},[_vm._v("เหตุผล")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("บันทึก")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("รายละเอียดการจับชุดอุปกรณ์")])])])])])])}]


/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/BeerClaimReport/CostBeerClaim'),expression:"$route.path == '/BeerClaimReport/CostBeerClaim'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลปี :")]),_vm._v(" "),_c('select2',{ref:"year",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'year',"name":'year',"select2-options":_vm.yearOptions},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Generate Report")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("ล้างค่าทั้งหมด")])])])]),_vm._v(" "),(_vm.dataTable.length != 0)?_c('h3',{staticClass:"kt-section__title all text-center"},[_vm._v("ข้อมูลเบียร์เคลม ปี :"+_vm._s(_vm.year))]):_vm._e(),_vm._v(" "),(_vm.dataTable.length == 0)?_c('h3',{staticClass:"kt-section__title all text-center"},[_vm._v("ไม่พบข้อมูลเบียร์เคลม")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"}},[(_vm.dataTable.length != 0)?_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":_vm.brandHeader.length+_vm.brandHeader.length + _vm.brandItem.length+_vm.brandHeader.length+_vm.brandHeader.length + _vm.brandItem.length +10}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-center",staticStyle:{"width":"130px"},attrs:{"rowspan":5}},[_vm._v("เดือน")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(75,172,198,0.5)"},attrs:{"colspan":_vm.brandItem.length + 1}},[_vm._v("อนุมัติเคลมเบียร์")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144)"},attrs:{"colspan":_vm.brandHeader.length *2}},[_vm._v("สาเหตุที่เคลม")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144)"},attrs:{"colspan":_vm.brandItem.length + 1}},[_vm._v("ประเภทถัง (ราคารวม VAT)")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(247, 150, 70,0.6)"},attrs:{"colspan":_vm.brandHeader.length}},[_vm._v("ถังชำรุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(247, 150, 70,0.6)"},attrs:{"colspan":_vm.brandHeader.length}},[_vm._v("น้ำเบียร์ผิดปกติ")])]),_vm._v(" "),_c('tr',[_vm._l((_vm.brandHeader),function(header){return _c('th',{staticClass:"all text-center",attrs:{"colspan":_vm.brandItem.filter(function (o) { return o[0] == header; }).length}},[_vm._v(_vm._s(header)+" ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"50px","background-color":"rgba(144, 238, 144,0.6)"},attrs:{"rowspan":3}},[_vm._v("Total")]),_vm._v(" "),_vm._l((_vm.brandHeader),function(header){return _c('th',{staticClass:"all text-center",staticStyle:{"width":"60px"},attrs:{"rowspan":3}},[_vm._v(_vm._s(header))])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(header){return _c('th',{staticClass:"all text-center",staticStyle:{"width":"60px"},attrs:{"rowspan":3}},[_vm._v(_vm._s(header))])})],2),_vm._v(" "),_c('tr',_vm._l((_vm.brandItem),function(item){return _c('th',{staticClass:"all text-center",staticStyle:{"width":"60px"}},[_vm._v(_vm._s(item[1])+"L ")])}),0),_vm._v(" "),_c('tr',{staticStyle:{"background-color":"rgba(247, 150, 70,0.6)"}},_vm._l((_vm.brandItem),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v(_vm._s(item[2].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+" ")])}),0),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("January "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[0]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v(_vm._s(_vm.totalCost[0].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 1 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+" ")])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 1 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 1 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 1 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("February "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[1]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v(_vm._s(_vm.totalCost[1].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 2 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 2 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 2 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 2 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("March "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[2]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v("\n                    "+_vm._s(_vm.totalCost[2].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 3 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 3 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 3 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 3 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("April "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[3]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v(_vm._s(_vm.totalCost[3].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 4 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 4 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 4 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 4 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("May "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[4]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v(_vm._s(_vm.totalCost[4].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 5 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 5 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 5 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 5 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("June "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[5]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v(_vm._s(_vm.totalCost[5].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 6 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 6 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 6 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 6 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("July "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[6]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v(_vm._s(_vm.totalCost[6].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 7 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 7 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 7 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 7 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("August "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[7]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v(_vm._s(_vm.totalCost[7].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 8 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 8 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 8 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 8 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("September "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[8]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v(_vm._s(_vm.totalCost[8].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 9 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 9 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 9 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 9 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("October "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[9]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v(_vm._s(_vm.totalCost[9].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 10 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 10 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 10 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 10 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("November "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[10]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v(_vm._s(_vm.totalCost[10].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 11 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 11 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 11 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 11 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left"},[_vm._v("December "+_vm._s(_vm.year))]),_vm._v(" "),_vm._l((_vm.costMonthList[11]),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"}},[_vm._v(_vm._s(_vm.totalCost[11].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 12 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 12 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[_vm._l((_vm.totalCostBarnd.filter(function (o) { return o.Month == 12 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.totalCostBarnd.filter(function (o) { return o.Month == 12 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left",staticStyle:{"background-color":"rgba(255, 255, 0)"}},[_vm._v("รวม")]),_vm._v(" "),_vm._l((_vm.totalCostMonth),function(item){return _c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(255, 255, 0)"}},[_vm._v("\n                      "+_vm._s(item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                    ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(144, 238, 144,0.6)"},attrs:{"rowspan":2}},[_vm._v("\n                      "+_vm._s(_vm.sumTotal.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                    ")]),_vm._v(" "),_vm._l((_vm.brandHeader),function(item,key){return _c('td',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(255, 255, 0)"}},[_vm._v("\n                      "+_vm._s(_vm.sumPriceTotalbrandHeader[key].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                      ")])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item,key){return _c('td',{staticClass:"all text-center",staticStyle:{"background-color":"rgba(255, 255, 0)"}},[_vm._v("\n                      "+_vm._s(_vm.sumPriceTotalbrandHeader2[key].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n                      ")])})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-left",staticStyle:{"background-color":"rgba(255, 255, 0)"}},[_vm._v("รวมทั้งหมด")]),_vm._v(" "),_c('th',{staticClass:"all text-right",staticStyle:{"background-color":"rgba(255, 255, 0)"},attrs:{"colspan":_vm.brandItem.length}},[_vm._v(_vm._s(_vm.sumTotal.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticClass:"all text-right",attrs:{"colspan":_vm.brandHeader.length}},[_vm._l((_vm.sumType.filter(function (o) { return o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.sumType.filter(function (o) { return o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"all text-right",attrs:{"colspan":_vm.brandItem.length}},[_vm._l((_vm.sumType.filter(function (o) { return o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE'; })),function(data){return _c('span',[_vm._v(_vm._s(data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])}),_vm._v(" "),(_vm.sumType.filter(function (o) { return o.Type=='PROBLEM_TYPE_DAMAGED_TANK'; }).length == 0)?_c('span',[_vm._v("0.00")]):_vm._e()],2)]),_vm._v(" "),_c('tr',{staticStyle:{"background-color":"rgb(0, 255, 0)"}},[_c('th',{staticClass:"all text-left"},[_vm._v("จำนวนถัง")]),_vm._v(" "),_vm._l((_vm.numberOfTanks),function(item){return _c('th',{staticClass:"all text-center"},[_vm._v(_vm._s(item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])})],2)]):_vm._e()])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])}]


/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHubRoute),expression:"isHubRoute"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"row"},_vm._l((_vm.cards),function(card){return _c('div',{key:card.path,staticClass:"col-xl-3 col-md-6 mb-4"},[_c('router-link',{staticClass:"monitoring-card-link",attrs:{"to":card.path}},[_c('div',{staticClass:"kt-portlet kt-portlet--height-fluid monitoring-card"},[_c('div',{staticClass:"kt-portlet__body text-center"},[_c('div',{staticClass:"monitoring-card-icon mb-3"},[_c('i',{class:card.icon})]),_vm._v(" "),_c('h4',{staticClass:"monitoring-card-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('p',{staticClass:"monitoring-card-desc text-muted mb-0"},[_vm._v(_vm._s(card.description))])])])])],1)}),0)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-chart-line"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("Monitoring")])])])}]


/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-file-alt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v("\n          หน้านี้อยู่ระหว่างการพัฒนา - ใบงาน Budget (เบิก/ปรับ/โอน)\n        ")])])}]


/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"aAgent",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'aAgent' + _vm._uid,"name":'aAgent' + _vm._uid,"select2-options":_vm.aAgentOptions,"data-msg-required":"กรุณาเลือกตัวแทนจำหน่าย"},on:{"selectChange":_vm.onAgentChange},model:{value:(_vm.aAgent),callback:function ($$v) {_vm.aAgent=$$v},expression:"aAgent"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('center',[_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"รายละเอียด"},on:{"click":function($event){$event.preventDefault();return _vm.detail($event)}}},[_c('i',{staticClass:"text-info far fa-file-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveAItemClick($event)}}},[_c('i',{staticClass:"text-danger la la-trash"})])])],1)])}
var staticRenderFns = []


/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('a',{staticClass:"btn btn-sm btn-warning kt-margin-r-10",attrs:{"href":'/Print/ProductReturnForm/' + this.$route.params.id,"target":"_blank"}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("พิมพ์")])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v("วันที่เอกสาร :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.ubpReqDateString))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v("เลขที่เอกสาร:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.ubpDocNo))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v("ผู้ขอเบิก/ยืม:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.ubpBorrower))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v("ตัวแทนจำหน่าย/หน่วยงาน:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.ubpAgentCode))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-3 col-form-label "},[_vm._v("ประเภทใบคำร้องขอ:")]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"kt-checkbox-inline"},_vm._l((_vm.ubpRequestTypeOptions),function(ubpRequestTypeOption,ubp){return _c('label',{key:ubp,staticClass:"kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpRequestType),expression:"ubpRequestType"}],attrs:{"type":"checkbox","id":ubpRequestTypeOption.id,"checked":"","disabled":true},domProps:{"value":ubpRequestTypeOption.id,"checked":Array.isArray(_vm.ubpRequestType)?_vm._i(_vm.ubpRequestType,ubpRequestTypeOption.id)>-1:(_vm.ubpRequestType)},on:{"change":function($event){var $$a=_vm.ubpRequestType,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=ubpRequestTypeOption.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ubpRequestType=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ubpRequestType=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ubpRequestType=$$c}}}}),_vm._v("\n                      "+_vm._s(ubpRequestTypeOption.text)+"\n                      "),_c('span')])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-3 col-form-label "},[_vm._v("หมวดหมู่สินค้า:")]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"kt-radio-inline"},_vm._l((_vm.ubpProductGroupOptions),function(ubpProductGroupOption,index){return _c('label',{key:index,staticClass:"kt-radio rea"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpProductGroup),expression:"ubpProductGroup"}],attrs:{"type":"radio","id":ubpProductGroupOption.id,"disabled":true},domProps:{"value":ubpProductGroupOption.id,"checked":_vm._q(_vm.ubpProductGroup,ubpProductGroupOption.id)},on:{"change":[function($event){_vm.ubpProductGroup=ubpProductGroupOption.id},function($event){return _vm.onProductGroupChange($event)}]}}),_vm._v("\n                      "+_vm._s(ubpProductGroupOption.text)+"\n                      "),_c('span')])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 table-responsive",attrs:{"id":"Activity"}},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"2000px"}},[_vm._m(1),_vm._v(" "),_c('tbody',[_vm._l((_vm.plItems),function(item,i){return [_c('product-return-item-row',{key:i,ref:"plItems",refInFor:true,attrs:{"rowIndex":i,"item":item}})]})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมายเหตุ:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpRemark),expression:"ubpRemark"}],staticClass:"form-control",attrs:{"placeholder":"หมายเหตุ","rows":"3"},domProps:{"value":(_vm.ubpRemark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ubpRemark=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","disabled":_vm.isSubmitting}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "+_vm._s(_vm.isSubmitting ? 'กำลังบันทึกข้อมูล...' : 'บันทึกข้อมูล')+"\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"all text-center",staticStyle:{"width":"2%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"5%"}},[_vm._v("\n                      วันที่จ่ายสินค้า\n                    ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"5%"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"8%"}},[_vm._v("\n                      ประเภทสินค้า\n                    ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"10%"}},[_vm._v("\n                      ชื่อสินค้า\n                    ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"8%"}},[_vm._v("\n                      โควต้า(แบรนด์)\n                    ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"5%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"10%"}},[_vm._v("\n                      ตัวแทนจำหน่าย\n                    ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"10%"}},[_vm._v("\n                      ชื่อร้านค้า/กิจกรรม\n                    ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"10%"}},[_vm._v("\n                      หมายเหตุกิจกรรม\n                    ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"5%"}},[_vm._v("\n                      วันที่กำหนดคืน\n                    ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"5%"}},[_vm._v("\n                      จำนวนคงค้าง\n                    ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("คืน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชำรุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สูญหาย")])])])}]


/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$root.isAuthenticated)?_c('div',{attrs:{"id":"home"}},[_c('div',{on:{"mousemove":_vm.resetTimer,"keydown":_vm.resetTimer,"click":_vm.resetTimer}},[_c('div',{staticClass:"kt-header-mobile kt-header-mobile--fixed",attrs:{"id":"kt_header_mobile"}},[_c('div',{staticClass:"kt-header-mobile__logo"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(this.$root.siteConfig.SiteName))])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"kt-grid kt-grid--hor kt-grid--root"},[_c('div',{staticClass:"kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"kt-aside kt-aside--fixed kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop",attrs:{"id":"kt_aside"}},[_c('div',{staticClass:"kt-aside__brand kt-grid__item",attrs:{"id":"kt_aside_brand"}},[_c('div',{staticClass:"kt-aside__brand-logo"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n                "+_vm._s(this.$root.siteConfig.SiteName)+"\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"kt-aside__brand-tools"},[_c('button',{staticClass:"kt-aside__brand-aside-toggler",attrs:{"id":"kt_aside_toggler"}},[_c('span',[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('polygon',{attrs:{"id":"Shape","points":"0 0 24 0 24 24 0 24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z","id":"Path-94","fill":"#000000","fill-rule":"nonzero","transform":"translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) "}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z","id":"Path-94","fill":"#000000","fill-rule":"nonzero","opacity":"0.3","transform":"translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) "}})])])]),_vm._v(" "),_c('span',[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('polygon',{attrs:{"id":"Shape","points":"0 0 24 0 24 24 0 24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z","id":"Path-94","fill":"#000000","fill-rule":"nonzero"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z","id":"Path-94","fill":"#000000","fill-rule":"nonzero","opacity":"0.3","transform":"translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) "}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid",attrs:{"id":"kt_aside_menu_wrapper"}},[_c('div',{staticClass:"kt-aside-menu",attrs:{"id":"kt_aside_menu","data-ktmenu-vertical":"1","data-ktmenu-scroll":"1","data-ktmenu-dropdown-timeout":"500"}},[_c('ul',{staticClass:"kt-menu__nav"},[((this.$root.canShow(['AGENT_REPORT', 'BR_REPORT']) && !this.$root.hasBrProfile()) || this.$root.canShow(['BR_DASHBOARD_AUDIT_STOCK']))?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{ 'kt-menu__item--open': _vm.subIsActive('/AgentScoreDashboard') || _vm.subIsActive('/Dashboard') || _vm.subIsActive('/AgentStockOverdue') || _vm.$route.path === '/' },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[(this.$root.user.profile.role != 'QI_QIMAINTAIN'
                           && this.$root.user.profile.role != 'OFFICER_QIMAINTAIN'
                           && this.$root.user.profile.role != 'OFFICER_PLANT_QIMAINTAIN'
                           && this.$root.user.profile.role != 'LEAD_QIMAINTAIN'
                           && !this.$root.hasBudgetPlanProfile())?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/","tag":"li","exact":"","aria-haspopup":"true"}},[(this.$root.canShow(['super_admin']))?_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน Stock รายบาร์โค้ด")])]):_vm._e()]):_vm._e(),_vm._v(" "),(this.$root.canShowExSuperAdmin(['AGENT_REPORT',  'AGENT_SCORE_ADMIN']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/AgentScoreDashboard","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("คะแนนตัวแทนจำหน่าย")])])]):_vm._e(),_vm._v(" "),(this.$root.canShowExSuperAdmin(['AGENT_REPORT',  'AGENT_SCORE_ADMIN', 'BR_DASHBOARD_AUDIT_STOCK']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/AgentStockOverdue","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน STOCK ระบบเบียร์สด")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(this.$root.canShow([
                    'MASTER_USER',
                    'MANAGE_MASTER',
                    'MANAGE_COMPANY_PROFILE',
                    'MANAGE_SUB_AGENT_USER',
                    'MANAGE_PLANT',
                    'MASTER_AGENT',
                    'MANAGE_SHOP',
                    'MANAGE_SHOPPROFILE',
                    'ADMIN_MKT',
                    'MANAGER_MKT',
                    'USER_MKT',
                    'ADMIN_QI',
                    'MANAGER_QI',
                    'MANAGE_SHOP_SUB_AGENT',
                    'MANAGE_SUPPLIER',
                    'MANAGE_TRANSPORT',
                    'MANAGE_CONTACT',
                    'MANAGE_PRODUCT',
                    'MASTER_HOLDING',
                    'MANAGE_BRAND',
                    'MANAGE_BARCODE',
                    'MANAGE_BARCODE_AGENT',
                    'MANAGE_BARCODE_SUB_AGENT',
                    'MANAGE_ORDER',
                    'MANAGE_APPROVER',
                    'MANAGE_SETTING',
                    'MANAGE_PRODUCTBRAND',
                    'MANAGE_SALESAREA'
                  ]))?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(this.$root.canShow([
                    'MASTER_USER',
                    'MANAGE_MASTER',
                    'MANAGE_COMPANY_PROFILE',
                    'MANAGE_SUB_AGENT_USER',
                    'MANAGE_PLANT',
                    'MASTER_AGENT',
                    'MANAGE_SHOP',
                    'MANAGE_SHOPPROFILE',
                    'ADMIN_MKT',
                    'MANAGER_MKT',
                    'USER_MKT',
                    'ADMIN_QI',
                    'MANAGER_QI',
                    'MANAGE_SHOP_SUB_AGENT',
                    'MANAGE_SUPPLIER',
                    'MANAGE_TRANSPORT',
                    'MANAGE_CONTACT',
                    'MANAGE_PRODUCT',
                    'MASTER_HOLDING',
                    'MANAGE_BRAND',
                    'MANAGE_BARCODE',
                    'MANAGE_BARCODE_AGENT',
                    'MANAGE_BARCODE_SUB_AGENT',
                    'MANAGE_ORDER',
                    'MANAGE_APPROVER',
                    'MANAGE_SETTING',
                    'MANAGE_PRODUCTBRAND',
                    'MANAGE_SALESAREA'
                  ]))?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{ 'kt-menu__item--open': _vm.subIsActive('/Master') },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูลพื้นฐาน")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(3),_vm._v(" "),(this.$root.canShow(['MASTER_USER']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/Users","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการสมาชิก")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_COMPANY_PROFILE' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/CompanyProfile","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการโปรไฟล์บริษัท")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShowExSuperAdmin([
                          'MANAGE_SUB_AGENT_USER' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/AgentUsers","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลสมาชิกตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow(['MANAGE_MASTER', 'MANAGE_PLANT'])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/Plant","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลคลังสินค้า")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow(['MANAGE_MASTER', 'MASTER_AGENT'])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/Agents","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลตัวแทนจำหน่าย")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow(['MANAGE_MASTER', 'MANAGE_SHOP'])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/ManageShop","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลร้านค้า")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'MANAGE_MASTER',
                            'MANAGE_SHOPPROFILE',
                            'ADMIN_MKT',
                            'MANAGER_MKT',
                            'USER_MKT',
                            'ADMIN_QI',
                            'MANAGER_QI' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/ManageShopChangeRequest","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการขอแก้ไขข้อมูลร้านค้า")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'MANAGE_MASTER',
                            'MANAGE_SHOP_SUB_AGENT' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/ManageShopSubAgent","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลร้านค้าตัวแทนจำหน่ายย่อย")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SUPPLIER' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/Supplier","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูล Supplier")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'MANAGE_MASTER',
                            'MANAGE_TRANSPORT' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/ManageTransport","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลขนส่ง")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_CONTACT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/Contact","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลผู้ติดต่อ")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SETTING' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/AlertPMConfig","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลวัน Alert PM")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_PRODUCT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/Product","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลสินค้า")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MASTER_HOLDING' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/Holding","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ระยะเวลาถือครองสินค้า")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow(['MANAGE_MASTER', 'MANAGE_BRAND'])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/ManageBrand","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการงบประมาณ")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow(['MANAGE_MASTER'])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/ManageBarcode","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูล Barcode")])])]):_vm._e(),_vm._v(" "),(!this.$root.canShow(['super_admin']) && this.$root.canShow(['MANAGE_BARCODE_AGENT']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/ManageBarcode","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูล Barcode (ตัวแทน)")])])]):(!this.$root.canShow(['super_admin']) && this.$root.canShow(['MANAGE_BARCODE_SUB_AGENT']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/ManageBarcode","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูล Barcode (ตัวแทนจำหน่ายย่อย)")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow(['MANAGE_MASTER', 'MANAGE_ORDER'])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/Order","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลการสั่งซื้อ")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_APPROVER' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/Approver","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการผู้อนุมัติเบิก/ยืมทรัพย์สิน")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SETTING' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/Setting","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ตั้งค่าพื้นฐาน")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_PRODUCTBRAND' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/ProductBrand","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลแบรนด์")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SALESAREA' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/SalesArea","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลเขตการขาย")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SETTING' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/OverdueSetting","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ตั้งค่าการแจ้งเตือนคงค้างเกินกำหนดเวลา")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'MANAGE_MASTER',
                          'MANAGE_SETTING' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Master/MasterProductUnitPrice","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ตั้งค่าราคาค่าถัง")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(this.$root.canShow([
                    'JOB_ADMIN_IMPORT_NEW_ASSETS',
                    'JOB_ADMIN_PRODUCE',
                    'JOB_ADMIN_DESTROY',
                    'JOB_ADMIN_TRANSFER_TO_AGENT',
                    'JOB_ADMIN_REPAIR_SUPPLIER',
                    'JOB_ADMIN_RETURN_SUPPLIER',
                    'JOB_ADMIN_TRANSFER_TO_SHOP',
                    'JOB_ADMIN_PICKUP',
                    'JOB_ADMIN_RETURN',
                    'COMPANY_PROFILE_TYPE_AGENT',
                    'JOB_ADMIN_EXCHANGE',
                    'MANAGE_MASTER',
                    'JOB_ADMIN_BORROW',
                    'JOB_ADMIN_BORROW_PLANT',
                    'JOB_ADMIN_BORROW_APPROVE',
                    'JOB_ADMIN_BORROW_OPENJOB',
                    'JOB_ADMIN_WRITE_OFF_STOCK_PLANT',
                    'JOB_ADMIN_WRITE_OFF_STOCK_AGENT',
                    'JOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT',
                    'OFFICER_QIMAINTAIN',
                    'OFFICER_PLANT_QIMAINTAIN',
                    'LEAD_QIMAINTAIN'
                  ]) || this.$root.hasFormSummaryStockProfile())?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("ใบงาน (Job)")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(this.$root.canShow([
                    'JOB_ADMIN_IMPORT_NEW_ASSETS',
                    'JOB_ADMIN_PRODUCE',
                    'JOB_ADMIN_DESTROY',
                    'JOB_ADMIN_TRANSFER_TO_AGENT',
                    'JOB_ADMIN_REPAIR_SUPPLIER',
                    'JOB_ADMIN_RETURN_SUPPLIER',
                    'JOB_ADMIN_TRANSFER_TO_SHOP',
                    'JOB_ADMIN_PICKUP',
                    'JOB_ADMIN_RETURN',
                    'COMPANY_PROFILE_TYPE_AGENT',
                    'JOB_ADMIN_EXCHANGE',
                    'MANAGE_MASTER',
                    'JOB_ADMIN_BORROW',
                    'JOB_ADMIN_BORROW_PLANT',
                    'JOB_ADMIN_BORROW_APPROVE',
                    'JOB_ADMIN_BORROW_OPENJOB',
                    'JOB_ADMIN_WRITE_OFF_STOCK_PLANT',
                    'JOB_ADMIN_WRITE_OFF_STOCK_AGENT',
                    'JOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT',
                    'OFFICER_QIMAINTAIN',
                    'OFFICER_PLANT_QIMAINTAIN',
                    'LEAD_QIMAINTAIN'
                  ]))?_c('router-link',{staticClass:"kt-menu__item",class:{
                  'kt-menu__item--active': _vm.subIsActive('/Jobs/Edit'),
                  },attrs:{"to":"/Jobs","tag":"li","exact":"","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z","id":"Path-2","fill":"#000000","fill-rule":"nonzero","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z","id":"Path","fill":"#000000","fill-rule":"nonzero"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ค้นหาใบงาน")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow([
                    'JOB_ADMIN_IMPORT_NEW_ASSETS',
                    'JOB_ADMIN_PRODUCE',
                    'JOB_ADMIN_DESTROY',
                    'JOB_ADMIN_TRANSFER_TO_AGENT',
                    'JOB_ADMIN_REPAIR_SUPPLIER',
                    'JOB_ADMIN_RETURN_SUPPLIER',
                    'JOB_ADMIN_TRANSFER_TO_SHOP',
                    'JOB_ADMIN_PICKUP',
                    'JOB_ADMIN_RETURN',
                    'COMPANY_PROFILE_TYPE_AGENT',
                    'JOB_ADMIN_EXCHANGE',
                    'MANAGE_MASTER',
                    'JOB_ADMIN_BORROW',
                    'JOB_ADMIN_BORROW_PLANT',
                    'JOB_ADMIN_BORROW_APPROVE',
                    'JOB_ADMIN_BORROW_OPENJOB',
                    'JOB_ADMIN_WRITE_OFF_STOCK_PLANT' ]))?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/Jobs/Create'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เปิดใบงานใหม่")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(4),_vm._v(" "),(
                          this.$root.canShow(['JOB_ADMIN_IMPORT_NEW_ASSETS'])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/RETRIEVE_NEW_ITEM","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รับทรัพย์สินใหม่")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['JOB_ADMIN_PRODUCE']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/PRODUCE","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ผลิตเบียร์สด")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['JOB_ADMIN_DESTROY']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/DESTROY","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ทำลายทรัพย์สิน")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow(['JOB_ADMIN_TRANSFER_TO_AGENT'])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/TRANSFER_TO_AGENT","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ส่งสินค้าไปยังตัวแทน")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['JOB_ADMIN_REPAIR_SUPPLIER']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/REPAIR_SUPPLIER","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ส่งซ่อมซัพพลายเออร์")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['JOB_ADMIN_RETURN_SUPPLIER']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/RETURN_SUPPLIER","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รับคืนจากซัพพลายเออร์")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow(['JOB_ADMIN_TRANSFER_TO_SHOP'])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/TRANSFER_TO_SHOP","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['JOB_ADMIN_TRANSFER_TO_SHOP']))?_c('router-link',{staticClass:"kt-menu__item",staticStyle:{"margin-top":"10px"},attrs:{"to":"/Jobs/Create/TRANSFER_TO_MULTI_SHOP","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text",staticStyle:{"font-size":"14px"}},[_vm._v("ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า(หลายร้านค้า)")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['JOB_ADMIN_PICKUP']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/PICKUP","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("หยิบสินค้าขึ้นรถ (เร่ขาย)")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          ['JOB_ADMIN_RETURN', 'COMPANY_PROFILE_TYPE_AGENT'] ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/RETURN","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ส่งสินค้า/ทรัพย์สินคืนต้นทาง")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['JOB_ADMIN_EXCHANGE']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/EXCHANGE","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("โอนทรัพย์สิน")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['JOB_ADMIN_RETURN']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/RETURN_ADHOC","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รับคืนสินค้า/ทรัพย์สินจากลูกค้า")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['super_admin', 'BR_MANAGE_AUDIT_STOCK','MANAGE_AUDIT_STOCK']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/AUDIT_STOCK","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ตรวจสอบ STOCK")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Jobs/Create/WRITE_OFF_STOCK","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ตัดยอดคงค้าง")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'MANAGE_MASTER',
                    'JOB_ADMIN_BORROW',
                    'JOB_ADMIN_BORROW_PLANT',
                    'JOB_ADMIN_BORROW_APPROVE',
                    'JOB_ADMIN_BORROW_OPENJOB' ])
                )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Borrow","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z","fill":"#000000","fill-rule":"nonzero","transform":"translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) "}}),_vm._v(" "),_c('rect',{attrs:{"fill":"#000000","opacity":"0.3","x":"5","y":"20","width":"15","height":"2","rx":"1"}})])])]),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เบิก/ยืม ทรัพย์สิน")])])]):_vm._e(),_vm._v(" "),(this.$root.hasFormSummaryStockProfile())?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu fss-menu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/PrintSummary'),
                  },attrs:{"data-test":"fss-menu","aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(6),_vm._v(" "),_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/PrintSummary/Barcodes","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เอกสารสรุปสินค้าคงค้าง")])])])],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN','ADMIN_QI', 'MANAGER_QI','AGENT_REPORT','BR_MANAGE_AUDIT_STOCK','MANAGE_AUDIT_STOCK' ]) && this.$root.hasAnyCompanyProfile()
                )?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("\n                    ข้อมูลคะแนนตัวแทนจำหน่าย\n                  ")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(
                  this.$root.canShowExSuperAdmin(['ADMIN_QI', 'MANAGER_QI', 'AGENT_SCORE_ADMIN'])
                  && this.$root.hasAnyCompanyProfile()
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/Qi'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("บันทึกคะแนน")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(7),_vm._v(" "),(this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/AgentScore/JobAgentScore","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการคะแนนตัวแทนจำหน่าย")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  (this.$root.canShowExSuperAdmin(['ADMIN_QI', 'MANAGER_QI','AGENT_REPORT','BR_REPORT','BR_MANAGE_AUDIT_STOCK','MANAGE_AUDIT_STOCK','AGENT_SCORE_ADMIN']) || this.$root.hasAgentProfile())
                  && this.$root.hasAnyCompanyProfile()
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/Qi'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(8),_vm._v(" "),(this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN']) || this.$root.hasAgentProfile())?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/AgentScoreEvaluation","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v(" รายงานประเมินตัวแทนจำหน่ายเบียร์สด")])])]):_vm._e(),_vm._v(" "),_vm._m(9),_vm._v(" "),(this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN']) || this.$root.hasAgentProfile())?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/JobAgentScore","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("คะแนนการทำระบบเบียร์สด")])])]):_vm._e(),_vm._v(" "),(this.$root.canShowExSuperAdmin(['BR_MANAGE_AUDIT_STOCK','MANAGE_AUDIT_STOCK','AGENT_SCORE_ADMIN']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/JobAgentAuditStock","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานตรวจสอบ STOCK ตัวแทนจำหน่าย")])])]):_vm._e(),_vm._v(" "),(this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/KegRotationScore","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานคะแนนถังคงค้าง(ผู้ดูแลระบบ)")])])]):_vm._e(),_vm._v(" "),(this.$root.canShowExSuperAdmin(['AGENT_SCORE_ADMIN']) || this.$root.hasAgentProfile())?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/KegRotationScoreAgent","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานคะแนนถังคงค้าง(ตัวแทนจำหน่าย)")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(this.$root.user.profile.role != 'QI_QIMAINTAIN' && !this.$root.hasBudgetPlanProfile())?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("รายงาน (Report)")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(this.$root.canShow(['']) && !this.$root.hasBudgetPlanProfile())?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/AdminReport'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานแอดมิน")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(10),_vm._v(" "),(this.$root.canShow(['']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/AdminReport/MasterShopByBrand","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จำนวนร้านค้าแยกตามแบรนด์")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/AdminReport/JobIssue","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("การแจ้งปัญหา")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'AGENT_REPORT',
                    'SUB_AGENT_REPORT',
                    'BR_REPORT',
                    'OFFICER_QIMAINTAIN',
                    'OFFICER_PLANT_QIMAINTAIN',
                    'LEAD_QIMAINTAIN'
                  ]) && !this.$root.hasBudgetPlanProfile()
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/Report'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(11),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT', 'BR_REPORT']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/JobRetrieve","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รับคืนจากตัวแทนจำหน่าย")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['BR_REPORT']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/AssetProducts","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("มูลค่าทรัพย์สิน")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/Movement","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ความเคลื่อนไหว")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['BR_REPORT']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/FixedProducts","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ประวัติการซ่อมรายบาร์โค้ด")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['BR_REPORT']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/ProduceProducts","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ประวัติการผลิตรายบาร์โค้ด")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'BR_REPORT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/BrandCount","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ปิดใบงานตัวแทนและโรงงาน")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/AgentAssets","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Stock สินค้ารายตัวแทนจำหน่าย")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/ShopAssets","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Stock สินค้ารายร้านค้า")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT' ]))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/TransferBarcode","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Stock Card ระหว่างตัวแทนจำหน่ายกับร้านค้า")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/TransferBarcodeMultiple","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("\n                            Stock Card ระหว่างตัวแทนจำหน่ายกับร้านค้า(หลายร้าน)\n                          ")]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"})])]):_vm._e(),_vm._v(" "),( this.$root.canShow(['SUB_AGENT_REPORT' ]))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/TransferBarcodeSubAgent","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("\n                            Stock Card ระหว่างตัวแทนจำหน่ายย่อยกับร้านค้า\n                          ")]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"})])]):_vm._e(),_vm._v(" "),(this.$root.canShow([
                                   'BR_REPORT',
                                   'OFFICER_QIMAINTAIN',
                                   'OFFICER_PLANT_QIMAINTAIN',
                                   'LEAD_QIMAINTAIN'
                                   ]))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/TransferBarcodeSupplier","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ประวัติส่งซ่อม Supplier")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/Barcodes","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Stock รายบาร์โค้ด")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['BR_REPORT']) && false)?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/AverageBarcode","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ค่าเฉลี่ยกระบวนการภายในโรงงาน/คลังสินค้า")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/BarcodeStatus","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("สถานะ")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/ProductStocks","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Stock เบิกยืมรายโควตา")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/Borrow","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("การเบิกยืมและยอดคงค้าง Excel")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT',
                          'BR_REPORT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/PaymentProduct","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("การจ่ายสินค้า")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'BR_REPORT' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Report/ReturnProduct","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("การรับคืน")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(this.$root.canShow([
                    'AGENT_REPORT',
                    'BR_REPORT' ]) && !this.$root.hasBudgetPlanProfile())?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/AlertReport'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานการแจ้งเตือน")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(12),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT','BR_REPORT']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/AlertReport/BeforeDue","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("คงค้างก่อนครบกำหนดการคืน")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT','BR_REPORT']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/AlertReport/OverdueAll","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("คงค้างเลยกำหนดการคืน")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow(['ADMIN_QI', 'MANAGER_QI', 'USER_QI', 'AGENT_REPORT', 'SUB_AGENT_REPORT']) && !this.$root.hasBudgetPlanProfile()
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/QIReport'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน QC")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(13),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_QI',
                            'MANAGER_QI',
                            'USER_QI',
                            'AGENT_REPORT',
                            'SUB_AGENT_REPORT' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/QCReport/QCGroupByAgent","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("คะแนน QC Group by Agent")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_QI',
                            'MANAGER_QI',
                            'USER_QI' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/QCReport/QCGroupByOfficer","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("สรุปการเข้าทำ QC Group by เจ้าหน้าที่")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                    this.$root.canShow([
                      'ADMIN_PM',
                      'MANAGER_PM',
                      'AGENT_REPORT',
                      'COOL_SERVICE_PM',
                      'AGENT_ADMIN_PM',
                      'SUB_AGENT_ADMIN_PM' ]) && !this.$root.hasBudgetPlanProfile()
                  )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/PMReport'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน PM")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(14),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/PMReport/AlertPM","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Alert PM (เกินกำหนดการล้างเครื่อง)")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/PMReport/MasterShopOnOff","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูลร้านค้า")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM', 'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/PMReport/BarButlerByBrand","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูลหัวจ่าย")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/PMReport/PM","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูลการล้างเครื่องเบียร์สด (PM)")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM', 'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/PMReport/PMOperationReport","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน ปฏิทินบันทึกงาน PM")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/PMReport/BarcodeMapping","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานจำนวนชุดอุปกรณ์")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_PM',
                            'AGENT_ADMIN_PM',
                            'SUB_AGENT_ADMIN_PM',
                            'COOL_SERVICE_PM' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/PMReport/PMSurvey","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูลการ Survey PM")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow(['ADMIN_MKT', 'MANAGER_MKT', 'USER_MKT']) && !this.$root.hasBudgetPlanProfile()
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/MKTReport'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานการตลาด")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(15),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_MKT',
                            'MANAGER_MKT',
                            'USER_MKT' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MKTReport/EventAndFood","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Event/มหกรรมอาหาร")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_MKT',
                            'MANAGER_MKT',
                            'USER_MKT' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MKTReport/SurveyOnOffPremise","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ตรวจเยี่ยมร้าน On/Off-premise")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_MKT',
                            'MANAGER_MKT',
                            'USER_MKT' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MKTReport/NewShopOnOffPremise","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เปิดร้านค้าใหม่ On/Off-premise")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'ADMIN_5S',
                    'ADVISOR_5S',
                    'AGENT_REPORT',
                    'TEAM_5S' ]) && !this.$root.hasBudgetPlanProfile()
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/5SReport'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน S+")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(16),_vm._v(" "),(this.$root.canShow(['ADMIN_5S', 'TEAM_5S']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/5SReport/TransactionView5S","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จำนวนครั้งในการเข้าดูข้อมูลใน S+(E-Learning)")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_5S',
                            'ADVISOR_5S',
                            'AGENT_REPORT',
                            'TEAM_5S' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/5SReport/EvaluateView5S","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จำนวนการประเมินคะแนนประจำเดือน S+")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_5S',
                            'ADVISOR_5S',
                            'AGENT_REPORT',
                            'TEAM_5S' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/5SReport/WarehouseScore","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("คะแนนโครงการบริหารคลังสินค้าประจำเดือน")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_5S',
                            'ADVISOR_5S',
                            'AGENT_REPORT',
                            'TEAM_5S' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/5SReport/NotificationKPI","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานผลสรุปการแจ้งเตือนไม่ลงข้อมูล KPIs")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                    this.$root.canShow(['AGENT_REPORT', 'ADMIN_BEER_CLAIM','QI_OFFICER_BEER_CLAIM', 'PLANT_ACCOUNTANT_BEER_CLAIM', 'DB_OFFICER_BEER_CLAIM', 'LAB_BEER_CLAIM','ADMIN_PLANT_BEER_CLAIM','MANAGER_BEER_CLAIM']) && !this.$root.hasBudgetPlanProfile()
                  )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/BeerClaimReport'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานเบียร์เคลม")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(17),_vm._v(" "),(
                          this.$root.canShow([
                            'BR_REPORT',
                            'AGENT_REPORT',
                            'ADMIN_BEER_CLAIM',
                            'QI_OFFICER_BEER_CLAIM',
                            'PLANT_ACCOUNTANT_BEER_CLAIM',
                            'DB_OFFICER_BEER_CLAIM',
                            'LAB_BEER_CLAIM',
                            'ADMIN_PLANT_BEER_CLAIM',
                            'MANAGER_BEER_CLAIM'
                          ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/BeerClaimReport/AmountBeerClaim","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จำนวนการเคลมเบียร์ประจำเดือน")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'BR_REPORT',
                            'AGENT_REPORT',
                            'ADMIN_BEER_CLAIM',
                            'QI_OFFICER_BEER_CLAIM',
                            'PLANT_ACCOUNTANT_BEER_CLAIM',
                            'DB_OFFICER_BEER_CLAIM',
                            'LAB_BEER_CLAIM',
                            'ADMIN_PLANT_BEER_CLAIM',
                            'MANAGER_BEER_CLAIM'
                          ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/BeerClaimReport/StatusBeerClaimMonthly","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("สถานะการเคลมคงค้างในกระบวนการประจำเดือน")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['', 'ADMIN_BEER_CLAIM','MANAGER_BEER_CLAIM']))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/BeerClaimReport/CostBeerClaim","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายจ่ายในการเคลมเบียร์ (รายปี)")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'OFFICER_QIMAINTAIN',
                    'OFFICER_PLANT_QIMAINTAIN',
                    'CHECKER_QIMAINTAIN',
                    'LEAD_QIMAINTAIN' ]) && !this.$root.hasBudgetPlanProfile()
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/MaintainReport'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานช่างซ่อมบำรุง")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(18),_vm._v(" "),(
                        this.$root.canShow([
                          'OFFICER_QIMAINTAIN',
                          'OFFICER_PLANT_QIMAINTAIN',
                          'LEAD_QIMAINTAIN' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MaintainReport/StockPending","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text",staticStyle:{"font-size":"10pt"}},[_vm._v("Stock รอซ่อม/รอบำรุงรักษา/รอทำลาย/ส่งซ่อมซัพพลายเออร์")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'CHECKER_QIMAINTAIN',
                            'LEAD_QIMAINTAIN' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MaintainReport/Checker","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ส่งมอบหลังซ่อม")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MaintainReport/SparePartsUsed","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูลการใช้อะไหล่เครื่อง/อุปกรณ์")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MaintainReport/StockSpareParts","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Stock อะไหล่ทีมช่างซ่อมบำรุง")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MaintainReport/Drawback","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายละเอียด Stock คลังช่าง")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MaintainReport/RepairUsage","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จำนวนการซ่อมเครื่อง/อุปกรณ์")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MaintainReport/RepairSum","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("มูลค่าซ่อม")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'OFFICER_QIMAINTAIN',
                            'OFFICER_PLANT_QIMAINTAIN',
                            'LEAD_QIMAINTAIN' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MaintainReport/QISummary","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Summary")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'ADMIN_EQUIPMENT_LEASING',
                    'USER_EQUIPMENT_LEASING' ]) && !this.$root.hasBudgetPlanProfile()
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/MachineReport'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11,13 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,13 L15,13 C15.5522847,13 16,13.4477153 16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 L13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 L11,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L11,13 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานเครื่องเช่า")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(19),_vm._v(" "),(
                        this.$root.canShow([
                          'ADMIN_EQUIPMENT_LEASING',
                          'USER_EQUIPMENT_LEASING' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MachineReport/Invoice","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("การวางบิล / การจ่ายเงิน")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_EQUIPMENT_LEASING',
                            'USER_EQUIPMENT_LEASING' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MachineReport/LeaseMachine","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("สรุปจำนวนเครื่องเช่า")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_EQUIPMENT_LEASING',
                            'USER_EQUIPMENT_LEASING' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/MachineReport/MachineDetail","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายละเอียดเครื่องเช่า")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_MKT',
                    'MANAGER_MKT',
                    'USER_MKT' ])
                )?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("การตลาด (Marketing)")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_MKT',
                    'MANAGER_MKT',
                    'USER_MKT' ])
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/Marketing'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("การตลาด")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(20),_vm._v(" "),(
                          this.$root.canShow([
                            'super_admin',
                            'ADMIN_MKT',
                            'MANAGER_MKT',
                            'USER_MKT' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Marketing/MarketingList","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูลการตลาด")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'ADMIN_5S',
                    'ADVISOR_5S',
                    'AGENT_E-Learning',
                    'JOB_AGENT_KPI',
                    'TEAM_5S' ])
                )?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("\n                    การบริหารคลังสินค้า งาน S+\n                  ")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(
                    this.$root.canShow([
                      'ADMIN_5S',
                      'ADVISOR_5S',
                      'AGENT_E-Learning',
                      'JOB_AGENT_KPI',
                      'TEAM_5S' ])
                  )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
  'kt-menu__item--open': _vm.subIsActive('/5S'),
},attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("งาน S+")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(21),_vm._v(" "),(
                        this.$root.canShow([
                          'ADMIN_5S',
                          'ADVISOR_5S',
                          'AGENT_E-Learning',
                          'TEAM_5S' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/5S/E-Learning","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูลการเรียนรู้ (E-Learning)")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_5S',
                            'JOB_AGENT_KPI',
                            'ADVISOR_5S',
                            'TEAM_5S' ])
                        )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
  'kt-menu__item--open': _vm.subIsActive('/Kpi'),
},attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","width":"24.000000pt","height":"24.000000pt","viewBox":"0 0 24.000000 24.000000","preserveAspectRatio":"xMidYMid meet"}},[_c('g',{attrs:{"transform":"translate(0.000000,24.000000) scale(0.100000,-0.100000)","stroke":"none","stroke-width":"1"}},[_c('path',{attrs:{"d":"M25 228 c-3 -8 -4 -61 -3 -119 l3 -104 77 -3 c115 -4 118 -2 118 119\n                        0 71 -4 101 -12 104 -7 2 -50 6 -96 10 -65 5 -83 4 -87 -7z m175 -108 c0 -53\n                        -4 -90 -10 -90 -5 0 -10 8 -10 18 0 10 -5 23 -12 30 -9 9 -9 12 0 12 7 0 12 5\n                        12 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6\n                        -9 10 -20 10 -11 0 -20 5 -20 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 -13 10\n                        -30 10 -16 0 -30 5 -30 10 0 6 18 10 40 10 l40 0 0 -90z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูล KPI")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(22),_vm._v(" "),(
                              this.$root.canShow([
                                'ADMIN_5S',
                                'JOB_AGENT_KPI',
                                'ADVISOR_5S',
                                'TEAM_5S' ])
                            )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Kpi/ProductSlow","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("สินค้าเคลื่อนไหวช้า")])])]):_vm._e(),_vm._v(" "),(
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S' ])
                              )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Kpi/ProductExpire","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("สินค้าหมดอายุ")])])]):_vm._e(),_vm._v(" "),(
                              this.$root.canShow([
                                'ADMIN_5S',
                                'JOB_AGENT_KPI',
                                'ADVISOR_5S',
                                'TEAM_5S' ])
                            )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Kpi/ProductLost","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("สินค้าสูญหาย")])])]):_vm._e(),_vm._v(" "),(
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S' ])
                              )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Kpi/ProductDilapidated","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("สินค้าที่ชำรุดเสียหาย")])])]):_vm._e(),_vm._v(" "),(
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S' ])
                              )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Kpi/AccessoriesLost","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("อุปกรณ์ส่งเสริมสูญหาย")])])]):_vm._e(),_vm._v(" "),(
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S' ])
                              )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Kpi/ProductCycle","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ถังเปล่าหมุนเวียน")])])]):_vm._e(),_vm._v(" "),(
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S' ])
                              )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Kpi/DamageMach","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เครื่องเบียร์สดชำรุด")])])]):_vm._e(),_vm._v(" "),(
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S' ])
                              )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Kpi/LostMach","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เครื่องเบียร์สดสูญหาย")])])]):_vm._e(),_vm._v(" "),(
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S' ])
                              )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Kpi/AccessoriesDilapidated","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("อุปกรณ์เบียร์สดสูญหาย")])])]):_vm._e(),_vm._v(" "),(
                                this.$root.canShow([
                                  'ADMIN_5S',
                                  'JOB_AGENT_KPI',
                                  'ADVISOR_5S',
                                  'TEAM_5S' ])
                              )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Kpi/LostTank","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ถังเปล่า/Co2 สูญหาย")])])]):_vm._e()],1)])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM',
                    'SUB_AGENT_ADMIN_PM' ])
                )?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("\n                    งานล้างเครื่องเบียร์สด (PM)\n                  ")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM' ])
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/PM'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("PM")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(23),_vm._v(" "),(
                        this.$root.canShow([
                          'ADMIN_PM',
                          'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/PM/PMRoutePlan","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการ Route Plan/Adhoc")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'ADMIN_PM',
                          'AGENT_ADMIN_PM',,'SUB_AGENT_ADMIN_PM' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/PM/PMCheckIn","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูล Check-in/out PM")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'ADMIN_PM',
                          'AGENT_ADMIN_PM',,'SUB_AGENT_ADMIN_PM' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/PM/PMSurveyCheckIn","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูล Survey PM")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'ADMIN_BEER_CLAIM',
                    'QI_OFFICER_BEER_CLAIM',
                    'PLANT_ACCOUNTANT_BEER_CLAIM',
                    'LAB_BEER_CLAIM',
                    'AGENT_ADMIN_BEER_CLAIM',
                    'ADMIN_PLANT_BEER_CLAIM',
                    'MANAGER_BEER_CLAIM',
                    'DB_OFFICER_BEER_CLAIM'
                  ])
                )?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("เบียร์เคลม (BeerClaim)")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'ADMIN_BEER_CLAIM',
                    'MANAGER_BEER_CLAIM',
                    'QI_OFFICER_BEER_CLAIM',
                    'PLANT_ACCOUNTANT_BEER_CLAIM',
                    'LAB_BEER_CLAIM',
                    'AGENT_ADMIN_BEER_CLAIM',
                    'ADMIN_PLANT_BEER_CLAIM' ])
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/BeerClaim'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เบียร์เคลม")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(24),_vm._v(" "),(
                        this.$root.canShow([
                          'ADMIN_BEER_CLAIM',
                          'MANAGER_BEER_CLAIM',
                          'QI_OFFICER_BEER_CLAIM',
                          'PLANT_ACCOUNTANT_BEER_CLAIM',
                          'LAB_BEER_CLAIM',
                          'AGENT_ADMIN_BEER_CLAIM',
                          'ADMIN_PLANT_BEER_CLAIM' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/BeerClaim/Claim","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("แจ้งเคลมเบียร์")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'OFFICER_QIMAINTAIN', 
                    'OFFICER_PLANT_QIMAINTAIN', 
                    'LEAD_QIMAINTAIN', 
                    'QI_QIMAINTAIN'])
                )?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("งานช่างซ่อมบำรุง")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(this.$root.user.profile.role == 'QI_QIMAINTAIN')?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Maintain/Stock","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z","fill":"#000000","fill-rule":"nonzero","transform":"translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) "}}),_vm._v(" "),_c('rect',{attrs:{"fill":"#000000","opacity":"0.3","x":"5","y":"20","width":"15","height":"2","rx":"1"}})])])]),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("อะไหล่คงเหลือรายช่างซ่อม")])])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow(['OFFICER_QIMAINTAIN', 'OFFICER_PLANT_QIMAINTAIN', 'LEAD_QIMAINTAIN'])
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/Maintain'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("งานช่างซ่อมบำรุง")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(25),_vm._v(" "),(
                        this.$root.canShow([
                          'OFFICER_QIMAINTAIN', 'OFFICER_PLANT_QIMAINTAIN', 'LEAD_QIMAINTAIN'
                        ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Maintain/QIJob","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ใบงานช่างซ่อม")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'OFFICER_QIMAINTAIN', 'OFFICER_PLANT_QIMAINTAIN', 'LEAD_QIMAINTAIN'
                        ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Maintain/Recv","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รับเข้าอะไหล่")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'OFFICER_QIMAINTAIN', 'OFFICER_PLANT_QIMAINTAIN', 'LEAD_QIMAINTAIN'
                        ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Maintain/Stock","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("อะไหล่คงเหลือรายช่างซ่อม")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'ADMIN_EQUIPMENT_LEASING',
                    'USER_EQUIPMENT_LEASING' ])
                )?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("งานเครื่องเช่า")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow([
                    'ADMIN_EQUIPMENT_LEASING',
                    'USER_EQUIPMENT_LEASING' ])
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/Machin'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เครื่องเช่า")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(26),_vm._v(" "),(
                        this.$root.canShow([
                          'ADMIN_EQUIPMENT_LEASING',
                          'USER_EQUIPMENT_LEASING' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Machine/ListMachine","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูลเครื่องเช่า")])])]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'ADMIN_EQUIPMENT_LEASING',
                          'USER_EQUIPMENT_LEASING' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Machine/ManagePhase","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูล Phase")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_EQUIPMENT_LEASING',
                            'USER_EQUIPMENT_LEASING' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Machine/ManageMachineTransaction","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูล เครื่องเช่า")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_EQUIPMENT_LEASING',
                            'USER_EQUIPMENT_LEASING' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Machine/SaveBillingMachinePayment","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("บันทึกข้อมูลการวางบิล")])])]):_vm._e(),_vm._v(" "),(
                          this.$root.canShow([
                            'ADMIN_EQUIPMENT_LEASING',
                            'USER_EQUIPMENT_LEASING' ])
                        )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/Machine/PaymentMachinePayment","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("บันทึกชำระเงินเครื่องเช่า")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow(['ADMIN_QI', 'MANAGER_QI', 'USER_QI'])
                )?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("\n                    งานตรวจสอบคุณภาพเบียร์สด (QC)\n                  ")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(
                  this.$root.canShow(['ADMIN_QI', 'MANAGER_QI', 'USER_QI'])
                )?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{
                    'kt-menu__item--open': _vm.subIsActive('/Qi'),
                  },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z","id":"Combined-Shape","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z","id":"Combined-Shape","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("QC")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(27),_vm._v(" "),(
                        this.$root.canShow([
                          'ADMIN_QI',
                          'MANAGER_QI',
                          'USER_QI' ])
                      )?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/QC/QCCheckIn","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เช็คอินร้านค้า")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(this.$root.canShowExSuperAdmin([['BUDGET_PLAN_USER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']]))?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("งบประมาณ (Budget Approval)")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(this.$root.canShowExSuperAdmin([['BUDGET_PLAN_USER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']]))?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{ 'kt-menu__item--open': _vm.subIsActive('/BudgetPlan') },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2,6 L21,6 C21.5522847,6 22,6.44771525 22,7 L22,17 C22,17.5522847 21.5522847,18 21,18 L2,18 C1.44771525,18 1,17.5522847 1,17 L1,7 C1,6.44771525 1.44771525,6 2,6 Z M11.5,16 C13.709139,16 15.5,14.209139 15.5,12 C15.5,9.790861 13.709139,8 11.5,8 C9.290861,8 7.5,9.790861 7.5,12 C7.5,14.209139 9.290861,16 11.5,16 Z","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4,12 L3,12 C2.44771525,12 2,11.5522847 2,11 C2,10.4477153 2.44771525,10 3,10 L4,10 C4.55228475,10 5,10.4477153 5,11 C5,11.5522847 4.55228475,12 4,12 Z M20,12 L19,12 C18.4477153,12 18,11.5522847 18,11 C18,10.4477153 18.4477153,10 19,10 L20,10 C20.5522847,10 21,10.4477153 21,11 C21,11.5522847 20.5522847,12 20,12 Z","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Budget Approval")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(28),_vm._v(" "),(this.$root.canShowExSuperAdmin([['BUDGET_PLAN_USER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']]))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/BudgetPlan/Job","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ใบงาน Budget")])])]):_vm._e(),_vm._v(" "),(this.$root.canShowExSuperAdmin([['BUDGET_PLAN_USER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']]))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/BudgetPlan/List","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูล CCTR/IO/GL")])])]):_vm._e(),_vm._v(" "),(this.$root.canShowExSuperAdmin([['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']]))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/BudgetPlan/ApproveGroup","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูลผู้อนุมัติ")])])]):_vm._e(),_vm._v(" "),(this.$root.canShowExSuperAdmin([['BUDGET_PLAN_USER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_REVIEWER', 'COMPANY_PROFILE_TYPE_BUDGET'], ['BUDGET_PLAN_MANAGER', 'COMPANY_PROFILE_TYPE_BUDGET']]))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/BudgetPlan/Report/Vendor","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายละเอียดใช้งบประมาณตาม Vendor")])])]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),(this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile()))?_c('li',{staticClass:"kt-menu__section"},[_c('h4',{staticClass:"kt-menu__section-text"},[_vm._v("Stock Cover Days")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__section-icon flaticon-more-v2"})]):_vm._e(),_vm._v(" "),(this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile()))?_c('li',{staticClass:"kt-menu__item kt-menu__item--submenu",class:{ 'kt-menu__item--open': _vm.subIsActive('/StockCoverDays') },attrs:{"aria-haspopup":"true","data-ktmenu-submenu-toggle":"hover"}},[_c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('svg',{staticClass:"kt-svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"}},[_c('g',{attrs:{"stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"id":"bound","x":"0","y":"0","width":"24","height":"24"}}),_vm._v(" "),_c('path',{attrs:{"d":"M2,6 L21,6 C21.5522847,6 22,6.44771525 22,7 L22,17 C22,17.5522847 21.5522847,18 21,18 L2,18 C1.44771525,18 1,17.5522847 1,17 L1,7 C1,6.44771525 1.44771525,6 2,6 Z M11.5,16 C13.709139,16 15.5,14.209139 15.5,12 C15.5,9.790861 13.709139,8 11.5,8 C9.290861,8 7.5,9.790861 7.5,12 C7.5,14.209139 9.290861,16 11.5,16 Z","fill":"#000000","opacity":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4,12 L3,12 C2.44771525,12 2,11.5522847 2,11 C2,10.4477153 2.44771525,10 3,10 L4,10 C4.55228475,10 5,10.4477153 5,11 C5,11.5522847 4.55228475,12 4,12 Z M20,12 L19,12 C18.4477153,12 18,11.5522847 18,11 C18,10.4477153 18.4477153,10 19,10 L20,10 C20.5522847,10 21,10.4477153 21,11 C21,11.5522847 20.5522847,12 20,12 Z","fill":"#000000"}})])])]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Stock Cover Days")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"kt-menu__submenu"},[_c('span',{staticClass:"kt-menu__arrow"}),_vm._v(" "),_c('ul',{staticClass:"kt-menu__subnav"},[_vm._m(29),_vm._v(" "),(this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile()))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/StockCoverDays/List","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการข้อมูล Stock Cover Days")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile()))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/StockCoverDays/ReportAnalysis","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Report Analysis")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile()))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/StockCoverDays/Dashboard","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Dashboard")])])]):_vm._e(),_vm._v(" "),(this.$root.canShow([['SCVD_ADMIN', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_VIEWER', 'COMPANY_PROFILE_TYPE_SCVD'], ['SCVD_TEAM_EDIT', 'COMPANY_PROFILE_TYPE_SCVD']]) && this.$root.hasScvdProfile() && (this.$root.canShow(['super_admin']) || !this.$root.hasAgentProfile()))?_c('router-link',{staticClass:"kt-menu__item",attrs:{"to":"/StockCoverDays/Report","tag":"li","aria-haspopup":"true"}},[_c('a',{staticClass:"kt-menu__link"},[_c('i',{staticClass:"kt-menu__link-bullet kt-menu__link-bullet--dot"},[_c('span')]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Stock Cover Days Report")])])]):_vm._e()],1)])]):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper",attrs:{"id":"kt_wrapper"}},[_c('div',{staticClass:"kt-header kt-grid__item kt-header--fixed",attrs:{"id":"kt_header"}},[_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_c('div',{staticClass:"kt-header__topbar"},[(this.$root.user)?_c('div',{staticClass:"kt-header__topbar-item kt-header__topbar-item--user"},[_c('div',{staticClass:"kt-header__topbar-wrapper",attrs:{"data-toggle":"dropdown","data-offset":"0px,0px"}},[_c('div',{staticClass:"kt-header__topbar-user"},[_c('span',{staticClass:"kt-header__topbar-welcome kt-hidden-mobile"},[_vm._v("สวัสดี คุณ")]),_vm._v(" "),_c('span',{staticClass:"kt-header__topbar-username kt-hidden-mobile"},[_vm._v("\n                      "+_vm._s(this.$root.user.profile.name)+"\n                    ")]),_vm._v(" "),_c('span',{staticClass:"kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold"},[_vm._v("\n                      "+_vm._s(this.$root.user.profile.name.charAt(0).toUpperCase())+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl"},[_c('div',{staticClass:"kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x",staticStyle:{"background-image":"url(/themes/metronic/assets/media/misc/bg-1.jpg)"}},[_c('div',{staticClass:"kt-user-card__avatar"},[_c('img',{staticClass:"kt-hidden",attrs:{"alt":"Pic","src":"/themes/metronic/assets/media/users/300_25.jpg"}}),_vm._v(" "),_c('span',{staticClass:"kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success"},[_vm._v("\n                        "+_vm._s(this.$root.user.profile.name.charAt(0).toUpperCase())+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"kt-user-card__name"},[_vm._v("\n                      "+_vm._s(this.$root.user.profile.name)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"kt-notification"},[_c('div',{staticClass:"kt-notification__custom"},[_c('a',{staticClass:"btn btn-label-brand btn-sm btn-bold",attrs:{"href":"#","target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.signOut()}}},[_vm._v("ออกจากระบบ")])])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"},[_c('div',{staticClass:"kt-subheader kt-grid__item",attrs:{"id":"kt_subheader"}},[_c('div',{staticClass:"kt-subheader__main"},[_c('h3',{staticClass:"kt-subheader__title"},[_vm._v("\n                  "+_vm._s(this.$root.siteConfig.SiteName)+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"kt-subheader__separator kt-hidden"}),_vm._v(" "),((_vm.$route.path === '/' || _vm.$route.path === '/AgentScoreDashboard' || _vm.$route.path === '/AgentStockOverdue'))?[_c('div',{staticClass:"kt-subheader__breadcrumbs"},[[_c('router-link',{staticClass:"kt-subheader__breadcrumbs-home",attrs:{"to":"/"}},[_c('i',{staticClass:"flaticon2-shelter"})]),_vm._v(" "),_c('span',{staticClass:"kt-subheader__breadcrumbs-separator"}),_vm._v(" "),(this.$root.canShowExSuperAdmin(['super_admin']))?_c('router-link',{staticClass:"kt-subheader__breadcrumbs-link",style:(_vm.$route.path === '/' ? 'font-weight:bold;color:#5867dd' : ''),attrs:{"to":"/"}},[_vm._v("รายงาน Stock รายบาร์โค้ด")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"kt-subheader__breadcrumbs-separator"})],_vm._v(" "),(this.$root.canShowExSuperAdmin(['AGENT_REPORT',  'AGENT_SCORE_ADMIN']))?_c('router-link',{staticClass:"kt-subheader__breadcrumbs-link",style:(_vm.$route.path === '/AgentScoreDashboard' ? 'font-weight:bold;color:#5867dd' : ''),attrs:{"to":"/AgentScoreDashboard"}},[_c('i',{staticClass:"la la-trophy"}),_vm._v(" คะแนนตัวแทนจำหน่าย")]):_vm._e(),_vm._v(" "),(this.$root.canShowExSuperAdmin(['AGENT_REPORT',  'AGENT_SCORE_ADMIN', 'BR_DASHBOARD_AUDIT_STOCK']))?_c('router-link',{staticClass:"kt-subheader__breadcrumbs-link",style:(_vm.$route.path === '/AgentStockOverdue' ? 'font-weight:bold;color:#5867dd' : ''),attrs:{"to":"/AgentStockOverdue"}},[_c('i',{staticClass:"la la-table"}),_vm._v(" รายงาน STOCK ระบบเบียร์สด")]):_vm._e()],2)]:_c('breadcrumbs')],2)]),_vm._v(" "),_c('div',{staticClass:"kt-content kt-grid__item kt-grid__item--fluid",attrs:{"id":"kt_content"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[(_vm.ready)?_c('router-view'):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop"},[_c('div',{staticClass:"kt-footer__copyright"},[_vm._v("\n              2019 © "+_vm._s(this.$root.siteConfig.SiteName)+"\n            ")])])])])]),_vm._v(" "),_vm._m(32),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"checkTimeoutModal","tabindex":"-1","role":"dialog","aria-labelledby":"checkTimeoutModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body text-center"},[_c('h5',{staticClass:"mt-3 mb-5"},[_vm._v("เนื่องจากการตรวจสอบของระบบ ไม่พบการใช้งานเกิน 30 นาที กรุณา Login ใหม่อีกครั้ง")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"type":"button"},on:{"click":_vm.handleOkClick}},[_vm._v("ตกลง")])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-header-mobile__toolbar"},[_c('button',{staticClass:"kt-header-mobile__toggler kt-header-mobile__toggler--left",attrs:{"id":"kt_aside_mobile_toggler"}},[_c('span')]),_vm._v(" "),_c('button',{staticClass:"kt-header-mobile__toggler",attrs:{"id":"kt_header_mobile_toggler"}},[_c('span')]),_vm._v(" "),_c('button',{staticClass:"kt-header-mobile__topbar-toggler",attrs:{"id":"kt_header_mobile_topbar_toggler"}},[_c('i',{staticClass:"flaticon-more"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"kt-aside-close",attrs:{"id":"kt_aside_close_btn"}},[_c('i',{staticClass:"la la-close"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('i',{staticClass:"la la-trophy",staticStyle:{"font-size":"1.4rem"}})]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("แดชบอร์ด")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูลพื้นฐาน")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เปิดใบงานใหม่")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"kt-menu__link kt-menu__toggle",attrs:{"href":"javascript:;"}},[_c('span',{staticClass:"kt-menu__link-icon"},[_c('i',{staticClass:"la la-print",attrs:{"data-test":"fss-menu-icon"}})]),_vm._v(" "),_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("พิมพ์เอกสารสรุปข้อมูลทรัพย์สิน")]),_vm._v(" "),_c('i',{staticClass:"kt-menu__ver-arrow la la-angle-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent"},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("พิมพ์เอกสารสรุปข้อมูลทรัพย์สิน")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("จัดการคะแนนตัวแทนจำหน่าย")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานแอดมิน")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("คงค้างเกินกำหนดเวลา")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน QC")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน PM")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานการตลาด")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงาน S+")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานเบียร์เคลม")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานช่างซ่อมบำรุง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("รายงานเครื่องเช่า")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("การตลาด")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("งาน S+")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("ข้อมูล KPI")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("PM")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เบียร์เคลม")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("งานช่างซ่อมบำรุง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("เครื่องเช่า")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("QC")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Budget Approval")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"kt-menu__item kt-menu__item--parent",attrs:{"aria-haspopup":"true"}},[_c('span',{staticClass:"kt-menu__link"},[_c('span',{staticClass:"kt-menu__link-text"},[_vm._v("Stock Cover Days")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"kt-header-menu-wrapper-close",attrs:{"id":"kt_header_menu_mobile_close_btn"}},[_c('i',{staticClass:"la la-close"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-header-menu-wrapper",attrs:{"id":"kt_header_menu_wrapper"}},[_c('div',{staticClass:"kt-header-menu kt-header-menu-mobile kt-header-menu--layout-default",attrs:{"id":"kt_header_menu"}},[_c('ul',{staticClass:"kt-menu__nav"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-scrolltop",attrs:{"id":"kt_scrolltop"}},[_c('i',{staticClass:"fa fa-arrow-up"})])}]


/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",attrs:{"id":"StartDate","name":"StartDate","type":"text","maxlength":"450","placeholder":"วันที่เริ่มต้น"}})],1)]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)])])]),_vm._v(" "),_vm._m(9)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสบาร์โค้ด:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"Barcode","name":"Barcode","type":"text","maxlength":"450","placeholder":"รหัสบาร์โค้ด","value":"A000007"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสทรัพย์สิน(บัญชี):")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"AssetAudit","name":"AssetAudit","type":"text","maxlength":"450","placeholder":"รหัสทรัพย์สิน(บัญชี)","value":"ASAHI-30L 2015/01093"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"AssetOther","name":"AssetOther","type":"text","maxlength":"450","placeholder":"รหัสทรัพย์สิน(เบียร์สด)","value":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("NFC:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"NFC","name":"NFC","type":"text","maxlength":"450","placeholder":"NFC","value":"0800000000","readonly":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('select',{staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"ProductType","name":"ProductType"}},[_c('option',{attrs:{"value":"1","selected":""}},[_vm._v("ถังเบียร์สด")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('select',{staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"ProductName","name":"ProductName"}},[_c('option',{attrs:{"value":"1","selected":""}},[_vm._v("Asahi Beer 30L")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ระยะเวลาประกันถัง(วัน):")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"InsuranceDay","name":"InsuranceDay","type":"text","maxlength":"450","placeholder":"ระยะเวลาประกันถัง(วัน)","value":"365"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เจ้าของทรัพย์สิน:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"Owner","name":"Owner","type":"text","maxlength":"450","placeholder":"เจ้าของทรัพย์สิน","value":"โรงงานปทุมธานีฯ (คลังสินค้า)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])])}]


/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/KegRotationScore'),expression:"$route.path == '/Report/KegRotationScore'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n            "),_c('a',{staticClass:"ml-2",staticStyle:{"font-size":"0.8em","font-weight":"normal"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showCriteriaModal($event)}}},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" เงื่อนไขการคำนวณคะแนน\n            ")])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("เดือน/ปี:")]),_vm._v(" "),_c('input',{ref:"monthYearPicker",staticClass:"form-control",attrs:{"type":"text","placeholder":"เลือกเดือน/ปี","readonly":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.productTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.productType),callback:function ($$v) {_vm.productType=$$v},expression:"productType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("สถานะ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.barcodeStatusCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.barcodeStatusCode),callback:function ($$v) {_vm.barcodeStatusCode=$$v},expression:"barcodeStatusCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.agentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.materialCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.materialCode),callback:function ($$v) {_vm.materialCode=$$v},expression:"materialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ช่วงคงค้าง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.retentionPeriodOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.retentionPeriod),callback:function ($$v) {_vm.retentionPeriod=$$v},expression:"retentionPeriod"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อตัวแทนจำหน่าย(Group):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.headAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.headAgentCode),callback:function ($$v) {_vm.headAgentCode=$$v},expression:"headAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อแบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{ref:"ProductIdBrand",attrs:{"id":"ProductIdBrand","multiple":true,"options":_vm.filteredProductBrandOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.productBrand),callback:function ($$v) {_vm.productBrand=$$v},expression:"productBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("คะแนน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.scoreOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.score),callback:function ($$v) {_vm.score=$$v},expression:"score"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทผู้ถือครอง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.ownerTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.ownerType),callback:function ($$v) {_vm.ownerType=$$v},expression:"ownerType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.brandOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.BrandIdClearAfterSelect,"deselect":_vm.BrandIdClearAfterDeSelect},model:{value:(_vm.brand),callback:function ($$v) {_vm.brand=$$v},expression:"brand"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary mr-2",attrs:{"type":"button"},on:{"click":_vm.exportCompareReport}},[_vm._m(2)]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportMachineScore}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-0"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{ref:"topScrollWrapper",staticStyle:{"overflow-x":"auto","overflow-y":"hidden","height":"20px"}},[_c('div',{ref:"topScrollContent",staticStyle:{"height":"1px"}})]),_vm._v(" "),_c('table',{ref:"kegRotationTable",staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"}},[_c('thead',[(_vm.dataAsOfLabel)?_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"16"}},[_c('span',[_vm._v(_vm._s(_vm.dataAsOfLabel))])])]):_vm._e(),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_vm._m(6)])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-chart-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"criteriaModal","tabindex":"-1","role":"dialog","aria-labelledby":"criteriaModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"criteriaModalLabel"}},[_vm._v("เงื่อนไขการคำนวณคะแนนรายงานนี้")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"criteria-section"},[_c('p',{staticClass:"mb-2"},[_c('strong',[_vm._v("ประเภทสินค้า : ถัง/ท่อ")])]),_vm._v(" "),_c('div',{staticClass:"criteria-headers mb-3"},[_c('span',{staticClass:"col-label"},[_vm._v("เงื่อนไข")]),_vm._v(" "),_c('span',{staticClass:"col-label"},[_vm._v("เกณฑ์การให้คะแนน")])]),_vm._v(" "),_c('p',{staticClass:"product-title"},[_c('strong',[_vm._v("ถังเบียร์สด")])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"season-title high"},[_vm._v("High Season")]),_vm._v(" "),_c('div',{staticClass:"criteria-box"},[_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("<=3 Months")]),_c('span',[_vm._v("1 - 90 วัน")]),_c('span',[_vm._v("40 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("3-4 Months")]),_c('span',[_vm._v("91-120 วัน")]),_c('span',[_vm._v("20 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("4 Months")]),_c('span',[_vm._v("121 วัน ขึ้นไป")]),_c('span',[_vm._v("10 คะแนน")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"season-title low"},[_vm._v("Low Season")]),_vm._v(" "),_c('div',{staticClass:"criteria-box"},[_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("<=5 Months")]),_c('span',[_vm._v("1 - 150 วัน")]),_c('span',[_vm._v("40 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("5-6 Months")]),_c('span',[_vm._v("151-180 วัน")]),_c('span',[_vm._v("20 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("6 Months")]),_c('span',[_vm._v("181 วัน ขึ้นไป")]),_c('span',[_vm._v("10 คะแนน")])])])])]),_vm._v(" "),_c('p',{staticClass:"product-title"},[_c('strong',[_vm._v("ท่อ CO2")])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"season-title high"},[_vm._v("High Season")]),_vm._v(" "),_c('div',{staticClass:"criteria-box"},[_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("<=5 Months")]),_c('span',[_vm._v("1 - 150 วัน")]),_c('span',[_vm._v("40 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("5-6 Months")]),_c('span',[_vm._v("151-180 วัน")]),_c('span',[_vm._v("20 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("6 Months")]),_c('span',[_vm._v("181 วัน ขึ้นไป")]),_c('span',[_vm._v("10 คะแนน")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"season-title low"},[_vm._v("Low Season")]),_vm._v(" "),_c('div',{staticClass:"criteria-box"},[_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("<=5 Months")]),_c('span',[_vm._v("1 - 150 วัน")]),_c('span',[_vm._v("40 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("5-6 Months")]),_c('span',[_vm._v("151-180 วัน")]),_c('span',[_vm._v("20 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("6 Months")]),_c('span',[_vm._v("181 วัน ขึ้นไป")]),_c('span',[_vm._v("10 คะแนน")])])])])]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n                  ช่วง "),_c('strong',{staticStyle:{"color":"rgb(10, 187, 135)"}},[_vm._v("High Season")]),_vm._v(" มีจำนวน 6 เดือน [ เดือน ม.ค. , ก.พ. , มี.ค. , ต.ค. , พ.ย. , ธ.ค. ]\n                  "),_c('u',[_vm._v("ถังเบียร์สดทุกสินค้า คงค้างไม่เกิน 3 เดือน [ 90 วัน ]")])]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("\n                  ช่วง "),_c('strong',{staticStyle:{"color":"#C00000"}},[_vm._v("LOW Season")]),_vm._v(" มีจำนวน 6 เดือน [ เดือน เม.ย. , พ.ค. , มิ.ย. , ก.ค. , ส.ค. , ก.ย. ] ถัง / ท่อ เบียร์สดทุกสินค้า คงค้างไม่เกิน 5 เดือน [ 150 วัน ]\n                ")]),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_c('strong',[_vm._v("หมายเหตุสำคัญ :")])]),_vm._v(" "),_c('ul',{staticClass:"mb-0",staticStyle:{"padding-left":"20px"}},[_c('li',[_vm._v("วันคงค้าง เริ่มนับวัน ตั้งแต่วันที่รับสินค้าจากโรงงาน (วันที่รับ = วันที่ 0 วัน)")]),_vm._v(" "),_c('li',[_vm._v("สินค้าประเภทท่อเบียร์สด ช่วง "),_c('strong',[_vm._v("High Season")]),_vm._v(" และ "),_c('strong',[_vm._v("LOW Season")]),_vm._v(" คงค้างไม่เกิน 5 เดือน [ 150 วัน ] เท่ากัน จำนวนที่แสดงในรายงานจะรวมมาแสดงเฉพาะที่ช่วงคงค้าง Low Season เท่านั้นไม่ไปแสดงที่คอลัมน์ ช่วง "),_c('strong',[_vm._v("High Season")]),_vm._v(" เพื่อไม่เกิดความสับสนในการดูข้อมูล")]),_vm._v(" "),_c('li',[_vm._v("คะแนนระหว่างเดือนปัจจุบันจะแสดงค่าว่าง คะแนนจะแสดงต่อเมื่อคำนวณ Auto ณ วันที่สิ้นเดือนแล้วผ่านระบบ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("ปิด")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel (สำหรับตรวจสอบข้อมูล)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel (สรุปข้อมูลจากรายงาน)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"rowspan":"2"}},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#808080 !important","color":"#ffffff !important"},attrs:{"colspan":"3"}},[_vm._v("ช่วงคงค้าง High Season")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important"},attrs:{"rowspan":"2"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important"},attrs:{"rowspan":"2"}},[_vm._v("คะแนน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#808080 !important","color":"#63C8FF !important"},attrs:{"colspan":"3"}},[_vm._v("ช่วงคงค้าง Low Season")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important"},attrs:{"rowspan":"2"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important"},attrs:{"rowspan":"2"}},[_vm._v("คะแนน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important"},attrs:{"rowspan":"2"}},[_vm._v("Total จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","color":"#0033CC !important"},attrs:{"rowspan":"2"}},[_vm._v("สรุปผลคะแนน"),_c('br'),_vm._v("ประจำเดือน")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#ABE7B2 !important","color":"rgb(10, 187, 135) !important"}},[_vm._v("ไม่เกิน 3 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#FFFBB1 !important"}},[_vm._v("ไม่เกิน 4 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#F8CBAD !important","color":"#C00000 !important"}},[_vm._v("เกิน 4 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#ABE7B2 !important","color":"rgb(10, 187, 135) !important"}},[_vm._v("ไม่เกิน 5 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#FFFBB1 !important"}},[_vm._v("ไม่เกิน 6 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#F8CBAD !important","color":"#C00000 !important"}},[_vm._v("เกิน 6 เดือน")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr',[_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":"4"}},[_vm._v("Grand Total")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])])}]


/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อแบรนด์:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.proName),expression:"proName"}],staticClass:"form-control",attrs:{"id":"proName","name":"proName","type":"text","maxlength":"450","placeholder":"ชื่อแบรนด์"},domProps:{"value":(_vm.proName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.proName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("กลุ่มแบรนด์:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.proRival),expression:"proRival"}],staticClass:"form-check-input",attrs:{"id":"proRival","name":"proRival","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.proRival)?_vm._i(_vm.proRival,null)>-1:(_vm.proRival)},on:{"change":function($event){var $$a=_vm.proRival,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.proRival=$$a.concat([$$v]))}else{$$i>-1&&(_vm.proRival=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.proRival=$$c}}}}),_vm._v("\n                  แบรนด์คู่แข่ง\n                  "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.proStatus),expression:"proStatus"}],staticClass:"form-check-input",attrs:{"id":"proStatus","name":"proStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.proStatus)?_vm._i(_vm.proStatus,null)>-1:(_vm.proStatus)},on:{"change":function($event){var $$a=_vm.proStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.proStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.proStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.proStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะการทำ PM:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.proPMStatus),expression:"proPMStatus"}],staticClass:"form-check-input",attrs:{"id":"proPMStatus","name":"proPMStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.proPMStatus)?_vm._i(_vm.proPMStatus,null)>-1:(_vm.proPMStatus)},on:{"change":function($event){var $$a=_vm.proPMStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.proPMStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.proPMStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.proPMStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน (สถานะการทำ PM)\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path != '/Machine/SaveBillingMachinePayment/save'),expression:"$route.path != '/Machine/SaveBillingMachinePayment/save'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Phase:")]),_vm._v(" "),_c('select2',{ref:"svPhaseSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'svPhase',"name":'svPhase',"select2-options":_vm.svPhaseOptions},model:{value:(_vm.svPhase),callback:function ($$v) {_vm.svPhase=$$v},expression:"svPhase"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Lot:")]),_vm._v(" "),_c('select2',{ref:"svLotSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'svLot',"name":'svLot',"select2-options":_vm.svLotOptions},model:{value:(_vm.svLot),callback:function ($$v) {_vm.svLot=$$v},expression:"svLot"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("งวดที่ :")]),_vm._v(" "),_c('select2',{ref:"svTrancheSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'svTracheNo',"name":'svTracheNo',"select2-options":_vm.svTrancheOptions},model:{value:(_vm.svTracheNo),callback:function ($$v) {_vm.svTracheNo=$$v},expression:"svTracheNo"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{ref:"formSave",staticClass:"kt-form",on:{"submit":_vm.formSave}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่วางบิล:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"svBilling",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"svBilling","name":"svBilling","required":"","data-msg-required":"กรุณาเลือก วันที่วางบิล"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("กรอกยอดเงินสุทธิ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.svAmount),expression:"svAmount"},{name:"currency",rawName:"v-currency",value:({
                    locale: 'th',
                    currency: null,
                    precision: 0,
                  }),expression:"{\n                    locale: 'th',\n                    currency: null,\n                    precision: 0,\n                  }"}],staticClass:"form-control",attrs:{"placeholder":"กรุณาระบุ ยอดเงินรวม","required":"","data-msg-required":"กรุณาระบุ ยอดเงินรวม"},domProps:{"value":(_vm.svAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.svAmount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่ Invoice:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.svInvoice),expression:"svInvoice"}],staticClass:"form-control",attrs:{"placeholder":"กรุณาระบุ เลขที่ Invoice","type":"text","maxlength":"256","id":"svInvoice","name":"svInvoice","required":"","data-msg-required":"กรุณาระบุ เลขที่ Invoice"},domProps:{"value":(_vm.svInvoice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.svInvoice=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                บันทึกการวางบิล\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formSaveReset}},[_vm._v("\n                ล้างค่า\n              ")])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-barcode"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"machineTransactionTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("Supplier")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("Phase")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("Lot")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("งวด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวน")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])}]


/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อแบรนด์:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.proName),expression:"proName"}],staticClass:"form-control",attrs:{"id":"proName","name":"proName","type":"text","maxlength":"450","placeholder":"ชื่อแบรนด์"},domProps:{"value":(_vm.proName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.proName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("กลุ่มแบรนด์:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.proRival),expression:"proRival"}],staticClass:"form-check-input",attrs:{"id":"proRival","name":"proRival","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.proRival)?_vm._i(_vm.proRival,null)>-1:(_vm.proRival)},on:{"change":function($event){var $$a=_vm.proRival,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.proRival=$$a.concat([$$v]))}else{$$i>-1&&(_vm.proRival=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.proRival=$$c}}}}),_vm._v("\n                  แบรนด์คู่แข่ง\n                  "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.proStatus),expression:"proStatus"}],staticClass:"form-check-input",attrs:{"id":"proStatus","name":"proStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.proStatus)?_vm._i(_vm.proStatus,null)>-1:(_vm.proStatus)},on:{"change":function($event){var $$a=_vm.proStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.proStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.proStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.proStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะการทำ PM:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.proPMStatus),expression:"proPMStatus"}],staticClass:"form-check-input",attrs:{"id":"proPMStatus","name":"proPMStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.proPMStatus)?_vm._i(_vm.proPMStatus,null)>-1:(_vm.proPMStatus)},on:{"change":function($event){var $$a=_vm.proPMStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.proPMStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.proPMStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.proPMStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน (สถานะการทำ PM)\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MaintainReport/SparePartsUsed'),expression:"$route.path == '/MaintainReport/SparePartsUsed'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่ซ่อมเสร็จสิ้น(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateStart","name":"jobsDateStart","readonly":""}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ซ่อมเสร็จสิ้น(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateEnd","name":"jobsDateEnd","readonly":""}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"jobSubtype","multiple":true,"options":_vm.qiJobSubtype,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.jobSubtype),callback:function ($$v) {_vm.jobSubtype=$$v},expression:"jobSubtype"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่ออะไหล่:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductCode","multiple":true,"options":_vm.qiProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductCode),callback:function ($$v) {_vm.qiProductCode=$$v},expression:"qiProductCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[(this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN']))?_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.exportExcel}},[_vm._m(3)]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]):_vm._e()])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []


/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"downloadPhaseModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสอ้างอิง:")]),_vm._v(" "),_c('select2',{ref:"DlbRefnoSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'DlbRefno',"name":'DlbRefno',"select2-options":_vm.DlbRefnoOptions,"multiple":true},model:{value:(_vm.DlbRefno),callback:function ($$v) {_vm.DlbRefno=$$v},expression:"DlbRefno"}})],1)])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" ดาวน์โหลด\n          ")])])}]


/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"PictureModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-md",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first text-center"},[_c('img',{staticClass:"img-thumbnail mb-3",staticStyle:{"height":"auto","width":"auto"},attrs:{"src":'/Api/MasterFile/FromUrl?url=' +
                        encodeURIComponent(this.$route.params.url)}})])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")])])}]


/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path != '/Master/ManageBarcode/Import'),expression:"$route.path != '/Master/ManageBarcode/Import'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(_vm.pageTitle)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("BARCODE :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MbOldBarcode),expression:"MbOldBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"BARCODE"},domProps:{"value":(_vm.MbOldBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MbOldBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด) :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MbDepartmentMaterialCode),expression:"MbDepartmentMaterialCode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"รหัสทรัพย์สิน(เบียร์สด)"},domProps:{"value":(_vm.MbDepartmentMaterialCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MbDepartmentMaterialCode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("รหัสทรัพย์สิน(บัญชี) :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MbAccountMaterialCode),expression:"MbAccountMaterialCode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"รหัสทรัพย์สิน(บัญชี)"},domProps:{"value":(_vm.MbAccountMaterialCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MbAccountMaterialCode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("BARCODE COOLING :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MbBarcodeCooling),expression:"MbBarcodeCooling"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"BARCODE COOLING"},domProps:{"value":(_vm.MbBarcodeCooling)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MbBarcodeCooling=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ประเภทสินค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.MbProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbProductTypeId),callback:function ($$v) {_vm.MbProductTypeId=$$v},expression:"MbProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ชื่อสินค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.MbAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbAssetCode),callback:function ($$v) {_vm.MbAssetCode=$$v},expression:"MbAssetCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("แบรนด์สินค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.MbBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.BrandIdClearAfterSelect,"deselect":_vm.BrandIdClearAfterDeSelect},model:{value:(_vm.MbBrandId),callback:function ($$v) {_vm.MbBrandId=$$v},expression:"MbBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ชื่อแบรนด์สินค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.filteredProductIdBrandOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.ProductIdBrand),callback:function ($$v) {_vm.ProductIdBrand=$$v},expression:"ProductIdBrand"}})],1)]),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ชื่อตัวแทนจำหน่าย :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.MbHostAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.AgentCodeClearAfterSelect,"deselect":_vm.AgentCodeClearAfterDeSelect},model:{value:(_vm.MbHostAgentCode),callback:function ($$v) {_vm.MbHostAgentCode=$$v},expression:"MbHostAgentCode"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT','MANAGE_BARCODE_SUB_AGENT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ชื่อตัวแทนจำหน่ายย่อย :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.filteredSubAgentOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbHostSubAgentCode),callback:function ($$v) {_vm.MbHostSubAgentCode=$$v},expression:"MbHostSubAgentCode"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[(this.$root.canShow(['super_admin']))?_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("สถานะทรัพย์สินเช่า:")]),_vm._v(" "),_c('treeselect',{ref:"IsLeasedAssets",attrs:{"id":"IsLeasedAssets","options":_vm.LeasedAssetsOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.IsLeasedAssets),callback:function ($$v) {_vm.IsLeasedAssets=$$v},expression:"IsLeasedAssets"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[(_vm.showActiveStatusFilter)?_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("\n                  สถานะใช้งาน:\n                  "),_c('a',{ref:"ActiveStatusInfo",staticClass:"ml-1",attrs:{"href":"#","data-toggle":"popover","data-trigger":"focus","data-placement":"bottom","data-html":"true","data-content":_vm.ActiveStatusInfoText},on:{"click":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"fa fa-info-circle"})])]),_vm._v(" "),_c('treeselect',{ref:"ActiveStatus",attrs:{"id":"ActiveStatus","options":_vm.ActiveStatusOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.ActiveStatus),callback:function ($$v) {_vm.ActiveStatus=$$v},expression:"ActiveStatus"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("เจ้าของทรัพย์สิน :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.MbAssetOwnerOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbAssetOwnerId),callback:function ($$v) {_vm.MbAssetOwnerId=$$v},expression:"MbAssetOwnerId"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ประเภทผู้ถือครอง:")]),_vm._v(" "),_c('treeselect',{ref:"MbCurrentLocationType",attrs:{"id":"MbCurrentLocationType","options":_vm.MbCurrentLocationTypeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbCurrentLocationType),callback:function ($$v) {_vm.MbCurrentLocationType=$$v},expression:"MbCurrentLocationType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ปี(สินค้า):")]),_vm._v(" "),_c('treeselect',{ref:"MbBarcodeYear",attrs:{"multiple":true,"load-options":_vm.LoadBarcodeYearOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadBarcodeYearOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.MbBarcodeYear),callback:function ($$v) {_vm.MbBarcodeYear=$$v},expression:"MbBarcodeYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("สถานะ :  \n                  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MbIsShowCancel),expression:"MbIsShowCancel"}],attrs:{"type":"checkbox"},domProps:{"value":false,"checked":Array.isArray(_vm.MbIsShowCancel)?_vm._i(_vm.MbIsShowCancel,false)>-1:(_vm.MbIsShowCancel)},on:{"click":function($event){return _vm.clickcheckbox()},"change":function($event){var $$a=_vm.MbIsShowCancel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=false,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.MbIsShowCancel=$$a.concat([$$v]))}else{$$i>-1&&(_vm.MbIsShowCancel=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.MbIsShowCancel=$$c}}}}),_vm._v(" แสดงข้อมูลสถานะยกเลิก\n                ")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"MbBarcodeStautsId","disabled":_vm.MbBarcodeStautsDisabled,"multiple":true,"options":_vm.MbBarcodeStatusOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbBarcodeStautsId),callback:function ($$v) {_vm.MbBarcodeStautsId=$$v},expression:"MbBarcodeStautsId"}})],1)]),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("Supplier ที่ซื้อเข้า:")]),_vm._v(" "),_c('treeselect',{ref:"MbSupplierId",attrs:{"multiple":true,"load-options":_vm.LoadMbSupplierOptions,"async":true,"cacheOptions":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก"},on:{"open":_vm.reLoadMbSupplierOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.MbSupplierId),callback:function ($$v) {_vm.MbSupplierId=$$v},expression:"MbSupplierId"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("อายุของทรัพย์สิน(วัน) :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MbExprie),expression:"MbExprie"}],staticClass:"form-control",attrs:{"id":"MbExprie","name":"MbExprie","type":"text","placeholder":"กรุณาเลือก"},domProps:{"value":(_vm.MbExprie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MbExprie=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ระยะเวลาประกัน(วัน) :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MbWarrantyTime),expression:"MbWarrantyTime"}],staticClass:"form-control",attrs:{"id":"MbWarrantyTime","name":"MbWarrantyTime","type":"text","placeholder":"กรุณาเลือก"},domProps:{"value":(_vm.MbWarrantyTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MbWarrantyTime=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("รหัสอ้างอิง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadMbRefNoOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":true},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.MbRefNo),callback:function ($$v) {_vm.MbRefNo=$$v},expression:"MbRefNo"}})],1)]):_vm._e()]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[(this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT']))?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('treeselect',{ref:"MbAgentId",attrs:{"multiple":true,"css-style":'width: 100%;',"css-class":'form-control m-select2',"options":_vm.MbAgentOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbAgentId),callback:function ($$v) {_vm.MbAgentId=$$v},expression:"MbAgentId"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT']))?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ร้านค้า(ตัวแทน) :")]),_vm._v(" "),_c('treeselect',{ref:"MbShopId",attrs:{"id":"MbShopId","async":true,"multiple":true,"load-options":_vm.LoadMbShopOptions,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadMbShopOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.MbShopId),callback:function ($$v) {_vm.MbShopId=$$v},expression:"MbShopId"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT']))?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ร้านค้า2(ตัวแทน) :")]),_vm._v(" "),_c('treeselect',{ref:"MbShop2Id",attrs:{"id":"MbShop2Id","async":true,"multiple":true,"load-options":_vm.LoadMbShop2Options,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadMbShop2Options,"select":_vm.ClearAfterselect},model:{value:(_vm.MbShop2Id),callback:function ($$v) {_vm.MbShop2Id=$$v},expression:"MbShop2Id"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ร้านค้า(ตัวแทนจำหน่ายย่อย) :")]),_vm._v(" "),_c('treeselect',{ref:"MbSupShopId",attrs:{"multiple":true,"load-options":_vm.LoadMbSupShopOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadMbSupShopOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.MbSupShopId),callback:function ($$v) {_vm.MbSupShopId=$$v},expression:"MbSupShopId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ร้านค้า2(ตัวแทนจำหน่ายย่อย) :")]),_vm._v(" "),_c('treeselect',{ref:"MbSupShop2Id",attrs:{"multiple":true,"load-options":_vm.LoadMbSupShop2Options,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadMbSupShop2Options,"select":_vm.ClearAfterselect},model:{value:(_vm.MbSupShop2Id),callback:function ($$v) {_vm.MbSupShop2Id=$$v},expression:"MbSupShop2Id"}})],1)]),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER']))?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ผู้ดูแลทรัพย์สิน(ตัวแทน) :")]),_vm._v(" "),_c('treeselect',{ref:"MbIntendantId",attrs:{"id":"MbIntendantId","async":true,"multiple":true,"load-options":_vm.LoadMbIntendant,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadMbIntendant,"select":_vm.ClearAfterselect},model:{value:(_vm.MbIntendantId),callback:function ($$v) {_vm.MbIntendantId=$$v},expression:"MbIntendantId"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[(this.$root.canShow(['MANAGE_MASTER']))?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("ผู้ดูแลทรัพย์สิน(ตัวแทนจำหน่ายย่อย) :")]),_vm._v(" "),_c('treeselect',{ref:"MbIntendantSubShopId",attrs:{"id":"MbIntendantSubShopId","async":true,"multiple":true,"load-options":_vm.LoadMbIntendantSubShop,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadMbIntendantSubShop,"select":_vm.ClearAfterselect},scopedSlots:_vm._u([{key:"option-label",fn:function(ref){
var node = ref.node;
return _c('label',{},[_vm._v("\n                    "+_vm._s(node.label)+"\n                  ")])}}],null,false,2257607495),model:{value:(_vm.MbIntendantSubShopId),callback:function ($$v) {_vm.MbIntendantSubShopId=$$v},expression:"MbIntendantSubShopId"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER']))?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("คลัง :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.MbPlantOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbPlantId),callback:function ($$v) {_vm.MbPlantId=$$v},expression:"MbPlantId"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER']))?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label mb-1"},[_vm._v("Supplier:")]),_vm._v(" "),_c('treeselect',{ref:"MbCurrentSupplierId",attrs:{"multiple":true,"load-options":_vm.LoadMbCurrentSupplierOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadMbCurrentSupplierOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.MbCurrentSupplierId),callback:function ($$v) {_vm.MbCurrentSupplierId=$$v},expression:"MbCurrentSupplierId"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportBarcode}},[_vm._m(2)]),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManageBarcode/Import","tag":"button","title":"เพิ่มข้อมูล BARCODE(Excel)"}},[_c('i',{staticClass:"fas fa-file-import"}),_vm._v(" Import\n              ")]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManageBarcode/TemplateBarcode","tag":"button","title":"ดาวน์โหลด Template Barcode"}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Template\n              ")]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManageBarcode/DownloadBarcode","tag":"button","title":"ดาวน์โหลด BARCODE"}},[_c('i',{staticClass:"fas fa-file-export"}),_vm._v(" Download\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(3)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-barcode"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title"},[_vm._v("ค้นหาที่ตั้งปัจจุบัน")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"barcodeTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all",staticStyle:{"width":"10%"}},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสทรัพย์สิน(บัญชี)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("BARCODE COOLING")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสแบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อแบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้ถือครอง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้ดูแลทรัพย์สิน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทผู้ถือครอง")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("รหัสอ้างอิง")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("วันที่เริ่มต้น")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ระยะเวลาประกัน(วัน)")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("อายุของทรัพย์สิน(วัน)")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Supplier")]),_vm._v(" "),_c('th',{staticClass:"all",staticStyle:{"width":"120px","max-width":"120px","text-align":"center"}},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"agentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'agentCode',"name":'agentCode',"select2-options":_vm.agentCodeOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลปี :")]),_vm._v(" "),_c('select2',{ref:"year",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'year',"name":'year',"select2-options":_vm.yearOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)])]),_vm._v(" "),(_vm.year && _vm.canExportAllAgents && !_vm.isShow)?_c('div',{staticClass:"d-flex justify-content-end align-items-center mb-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n              "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.isShow == true)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              รายการจำนวนสินค้าที่หมดอายุจำแนกตามมูลค่าสินค้า :\n            ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingSelected},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelSelected($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)")+"\n                ")])]),_vm._v(" "),(_vm.canExportAllAgents)?_c('button',{staticClass:"btn btn-outline-primary ml-2",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"2500px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"3%"}},[_vm._v("\n                        ลำดับ\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"10%"}},[_vm._v("\n                        ประเภทสินค้า\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        ต้นทุนสินค้า(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"12","scope":"colgroup"}},[_vm._v("\n                        จำนวนสินค้าที่หมดอายุ (จำนวน) ปี "+_vm._s(_vm.year)+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้ารวม(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้าเฉลี่ย(บาท/เดือน)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        จัดการ\n                      ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('tbody',{on:{"change":function($event){return _vm.changeTotal()}}},[(_vm.productitems == null || _vm.productitems.length == 0)?_c('tr',[(
                          this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])
                        )?_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"18"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.productitems),function(item,i){return [_c('product-item-row',{key:i,ref:"Items",refInFor:true,attrs:{"rowIndex":i,"item":item,"kPIProductType":_vm.kPIProductType,"yearSelected":_vm.year},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"3%"}}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รวมเงิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_vm._l((12),function(index){return _c('th',{key:index,staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalMonth[index]," ", 0))+"\n                      ")])}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalPoductCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalProductCostOfMonth,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th')],2),_vm._v(" "),_c('tr',[(
                          this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])
                        )?_c('td',{attrs:{"colspan":"18"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[(
          _vm.isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])
        )?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand far fa-calendar-minus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มกราคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กุมภาพันธ์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มีนาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("เมษายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤษภาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มิถุนายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กรกฎาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("สิงหาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กันยายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ตุลาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤศจิกายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ธันวาคม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])}]


/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('select2',{ref:"odMaterialCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"odMaterialCode","name":"odMaterialCode","select2-options":_vm.odMaterialCodeOptions},on:{"selectChange":_vm.onMaterialCodeChange},model:{value:(_vm.odMaterialCode),callback:function ($$v) {_vm.odMaterialCode=$$v},expression:"odMaterialCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทของการกระจายสินค้า:")]),_vm._v(" "),_c('select2',{ref:"odTranTypeCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"odTranTypeCode","name":"odTranTypeCode","select2-options":_vm.odTranTypeCodeOptions},on:{"selectChange":_vm.odTranTypeCodeChange},model:{value:(_vm.odTranTypeCode),callback:function ($$v) {_vm.odTranTypeCode=$$v},expression:"odTranTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("จำนวนวันแจ้งเตือนก่อนครบกำหนด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odDayBeforeAlert),expression:"odDayBeforeAlert"}],staticClass:"form-control",attrs:{"id":"odDayBeforeAlert","name":"odDayBeforeAlert","type":"number","min":"0","placeholder":"จำนวนวัน"},domProps:{"value":(_vm.odDayBeforeAlert)},on:{"input":function($event){if($event.target.composing){ return; }_vm.odDayBeforeAlert=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("จำนวนวันครบกำหนด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odDayAlert),expression:"odDayAlert"}],staticClass:"form-control",attrs:{"id":"odDayAlert","name":"odDayAlert","type":"number","min":"0","placeholder":"จำนวนวัน"},domProps:{"value":(_vm.odDayAlert)},on:{"input":function($event){if($event.target.composing){ return; }_vm.odDayAlert=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่มีผล:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"odEffectiveDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"odEffectiveDate","name":"odEffectiveDate"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จำนวนเงินค่าเช่า กรณีเกินกำหนด (วันละ):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odRentalPrice),expression:"odRentalPrice"}],staticClass:"form-control",attrs:{"id":"odRentalPrice","name":"odRentalPrice","type":"number","min":"0.00","placeholder":"จำนวนเงินค่าเช่า(บาท)"},domProps:{"value":(_vm.odRentalPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.odRentalPrice=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odInActiveStatus),expression:"odInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"odInActiveStatus","name":"odInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.odInActiveStatus)?_vm._i(_vm.odInActiveStatus,null)>-1:(_vm.odInActiveStatus)},on:{"change":function($event){var $$a=_vm.odInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.odInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.odInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.odInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/PM'),expression:"$route.path == '/PMReport/PM'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n              "+_vm._s(this.$route.meta.breadcrumb)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM', 
                    'COOL_SERVICE_PM' ])
                ),expression:"\n                  this.$root.canShow([\n                    'super_admin',\n                    'ADMIN_PM',\n                    'AGENT_ADMIN_PM', \n                    'COOL_SERVICE_PM',\n                  ])\n                "}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMAgentCodeOptions,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadrePMAgentCodeOptions},model:{value:(_vm.rePMAgentCode),callback:function ($$v) {_vm.rePMAgentCode=$$v},expression:"rePMAgentCode"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                    'COOL_SERVICE_PM' ])
                ),expression:"\n                  this.$root.canShow([\n                    'super_admin',\n                    'ADMIN_PM',\n                    'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',\n                    'COOL_SERVICE_PM',\n                  ])\n                "}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMSubAgentCodeOptions,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadrePMSubAgentCodeOptions},model:{value:(_vm.rePMSubAgentCode),callback:function ($$v) {_vm.rePMSubAgentCode=$$v},expression:"rePMSubAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMRegionOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMRegion),callback:function ($$v) {_vm.rePMRegion=$$v},expression:"rePMRegion"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อผู้ใช้งาน:")]),_vm._v(" "),_c('select2',{ref:"rePMCreatedUserIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'rePMCreatedUserId',"name":'rePMCreatedUserId',"select2-options":_vm.pmrPmUserIdOptions,"multiple":""},model:{value:(_vm.rePMCreatedUserId),callback:function ($$v) {_vm.rePMCreatedUserId=$$v},expression:"rePMCreatedUserId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',[_vm._v("วันที่การล้างเครื่อง(PM)(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"rePMDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"rePMDateStart","name":"rePMDateStart"}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.rePMDateStartError)?_c('span',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.rePMDateStartError))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่การล้างเครื่อง(PM)(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"rePMDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"rePMDateEnd","name":"rePMDateEnd"}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),(_vm.rePMDateEndError)?_c('span',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.rePMDateEndError))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE (เครื่องทำความเย็น):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rePMBarcode),expression:"rePMBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.rePMBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rePMBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทเครื่อง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMMachineProductCodeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMMachineProductCode),callback:function ($$v) {_vm.rePMMachineProductCode=$$v},expression:"rePMMachineProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type(เครื่อง):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMMachineOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMMachineType),callback:function ($$v) {_vm.rePMMachineType=$$v},expression:"rePMMachineType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE (หัวจ่าย):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rePMDisBarcode),expression:"rePMDisBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.rePMDisBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rePMDisBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทหัวจ่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMDispenserProductCodeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMDispenserProductCode),callback:function ($$v) {_vm.rePMDispenserProductCode=$$v},expression:"rePMDispenserProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type(หัวจ่าย):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMDispenserOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMDispenserType),callback:function ($$v) {_vm.rePMDispenserType=$$v},expression:"rePMDispenserType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMBrandOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMBrand),callback:function ($$v) {_vm.rePMBrand=$$v},expression:"rePMBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หัวจ่ายที่ล้าง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMPMBrandOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMPMBrand),callback:function ($$v) {_vm.rePMPMBrand=$$v},expression:"rePMPMBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"rePMProvinceIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'rePMProvinceId',"name":'rePMProvinceId',"select2-options":_vm.rePMProvinceIdOptions},on:{"selectChange":_vm.onAmpherIdChange},model:{value:(_vm.rePMProvinceId),callback:function ($$v) {_vm.rePMProvinceId=$$v},expression:"rePMProvinceId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"rePMAmpherIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'rePMAmpherId',"name":'rePMAmpherId',"select2-options":_vm.rePMAmpherIdOptions},model:{value:(_vm.rePMAmpherId),callback:function ($$v) {_vm.rePMAmpherId=$$v},expression:"rePMAmpherId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rePMShopName),expression:"rePMShopName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อร้านค้า เช่น ชื่อร้านค้า1,ชื่อร้านค้า2"},domProps:{"value":(_vm.rePMShopName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rePMShopName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMShopTypeId),callback:function ($$v) {_vm.rePMShopTypeId=$$v},expression:"rePMShopTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmShopGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmShopGroupId),callback:function ($$v) {_vm.shmShopGroupId=$$v},expression:"shmShopGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทการล้างเครื่อง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmPMTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmPMTypeId),callback:function ($$v) {_vm.shmPMTypeId=$$v},expression:"shmPMTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'rePMStatus',"name":'rePMStatus',"select2-options":_vm.rePMStatusOptions},model:{value:(_vm.rePMStatus),callback:function ($$v) {_vm.rePMStatus=$$v},expression:"rePMStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" ")]),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"8px","display":"flex","align-items":"center","cursor":"pointer","font-weight":"500"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rePMShowImages),expression:"rePMShowImages"}],staticStyle:{"margin-right":"8px","transform":"scale(1.2)"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.rePMShowImages)?_vm._i(_vm.rePMShowImages,null)>-1:(_vm.rePMShowImages)},on:{"change":[function($event){var $$a=_vm.rePMShowImages,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rePMShowImages=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rePMShowImages=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rePMShowImages=$$c}},_vm.onShowImagesChange]}}),_vm._v("\n                    รูปแบบแสดงรูปภาพ\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                  Generate Report\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":function($event){return _vm.formReset($event)}}},[_vm._v("\n                  ล้างค่าทั้งหมด\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit","disabled":_vm.isExporting},on:{"click":_vm.exportPM}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"pmTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"27"}},[_vm._v("\n                      ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                    ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Route ID")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อรูท")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อผู้ใช้งาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทการล้างเครื่อง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE (เครื่องทำความเย็น)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทเครื่องทำความเย็น")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Type (เครื่องทำความเย็น)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE (หัวจ่าย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทหัวจ่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Type (หัวจ่าย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนหัวจ่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("หัวจ่ายที่ล้าง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนหัวจ่ายที่ล้าง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("มาตรฐานการล้าง(วัน)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่การล้างเครื่อง(PM)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่การล้างเครื่อง(PM) รอบถัดไป")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ดาวน์โหลด")])])}]


/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[(_vm.showHeader)?_c('td',{staticClass:"text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]):_vm._e(),_vm._v(" "),(_vm.item.isPreviousBalance == true)?_c('td',{staticClass:"form-group text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.documentNumber)+"\n  ")]):(_vm.showHeader)?_c('td',{staticClass:"form-group text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.documentNumber),expression:"item.documentNumber"}],staticClass:"form-control required",attrs:{"id":'documentNumber_' + _vm.rowIndex,"name":'documentNumber_' + _vm.rowIndex,"type":"text","placeholder":"เลขที่เอกสาร","readonly":!_vm.isEditable,"data-msg-required":"กรุณากรอกเลขที่เอกสาร"},domProps:{"value":(_vm.item.documentNumber)},on:{"blur":function($event){return _vm.onDocumentNumberBlur(false)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "documentNumber", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})]):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"form-group text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_vm._v("\n    "+_vm._s(_vm.item.documentDate)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"form-group align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_vm._v("\n    "+_vm._s(_vm.item.soldTo)+"\n    "+_vm._s(_vm.item.soldToName)+"\n    "),(_vm.item.shipToName && _vm.item.soldToName != _vm.item.shipToName)?[_vm._v("("+_vm._s(_vm.item.shipToName)+")")]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.item.items.length > 0)?[_c('td',{staticClass:"align-middle"},[_vm._v("\n      "+_vm._s(_vm.item.items[_vm.itemIndex].materialCode)+"\n      "+_vm._s(_vm.item.items[_vm.itemIndex].materialName)+"\n    ")]),_vm._v(" "),(_vm.item.items[_vm.itemIndex].reCalQuantity != null && _vm.item.items[_vm.itemIndex].reCalQuantity > 0)?_c('td',{staticClass:"text-right align-middle"},[_vm._v("\n      "+_vm._s(_vm.item.items[_vm.itemIndex].quantity)+"\n      ( "+_vm._s(_vm.item.items[_vm.itemIndex].reCalQuantity)+" )\n    ")]):_c('td',{staticClass:"text-right align-middle"},[_vm._v("\n      "+_vm._s(_vm.item.items[_vm.itemIndex].quantity)+"\n    ")]),_vm._v(" "),_c('td',{staticClass:"text-right align-middle"},[_vm._v("\n      "+_vm._s(_vm.item.items[_vm.itemIndex].salesUnit)+"\n    ")])]:[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])],_vm._v(" "),(_vm.showHeader && _vm.item.isPreviousBalance == false)?_c('td',{staticClass:"text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[(_vm.isEditable && _vm.jobType != 'RETRIEVE_ITEM')?_c('button',{staticClass:"btn btn-outline-hover-info btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"โหลดใหม่"},on:{"click":function($event){$event.preventDefault();return _vm.onDocumentNumberBlur(true)}}},[_c('i',{staticClass:"text-info la la-refresh"})]):_vm._e(),_vm._v(" "),(_vm.isEditable && _vm.jobType != 'RETRIEVE_ITEM')?_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"ลบรายการ"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveItemClick($event)}}},[_c('i',{staticClass:"text-danger la la-trash"})]):_vm._e()]):_c('td')],2)}
var staticRenderFns = []


/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/MasterShopOnOff'),expression:"$route.path == '/PMReport/MasterShopOnOff'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM', 
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM', \n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadreAgentCodesOptions,"select":_vm.SelectedAgentCodes,"input":_vm.updateValueAgentCodes},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.AgentCodesMessagesStatus == true),expression:"AgentCodesMessagesStatus == true"}],staticClass:"form-text",staticStyle:{"color":"#fd397a"}},[_vm._v(_vm._s(_vm.AgentCodesMessages))])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM', 
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM', \n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreShopCodesOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},model:{value:(_vm.reShopCodes),callback:function ($$v) {_vm.reShopCodes=$$v},expression:"reShopCodes"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',\n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrSubAgentCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentCodes',"name":'pmrSubAgentCodes',"select2-options":_vm.pmrSubAgentCodeOptions,"multiple":""},model:{value:(_vm.pmrSubAgentCodes),callback:function ($$v) {_vm.pmrSubAgentCodes=$$v},expression:"pmrSubAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentShopCodes',"name":'pmrSubAgentShopCodes',"select2-options":_vm.pmrSubAgentShopCodesOptions,"multiple":""},model:{value:(_vm.pmrSubAgentShopCodes),callback:function ($$v) {_vm.pmrSubAgentShopCodes=$$v},expression:"pmrSubAgentShopCodes"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin', 'ADMIN_PM'])),expression:"this.$root.canShow(['super_admin', 'ADMIN_PM'])"}],staticClass:"text-danger"},[_vm._v("\n                  *ควรเลือกตัวแทนจำหน่ายย่อยด้วย\n                ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reDepartmentsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.ClearAgentCodesOptions},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("ข้อมูลระหว่างวันที่(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ข้อมูลระหว่างวันที่(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"}),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reShopTypeIdOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reShopTypeId),callback:function ($$v) {_vm.reShopTypeId=$$v},expression:"reShopTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmShopGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmShopGroupId),callback:function ($$v) {_vm.shmShopGroupId=$$v},expression:"shmShopGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทการล้างเครื่อง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmShopPMTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmShopPMType),callback:function ($$v) {_vm.shmShopPMType=$$v},expression:"shmShopPMType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"reShopStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reShopStatus',"name":'reShopStatus',"select2-options":_vm.reShopStatusOptions},model:{value:(_vm.reShopStatus),callback:function ($$v) {_vm.reShopStatus=$$v},expression:"reShopStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เหตุผล:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reReasonOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reReason),callback:function ($$v) {_vm.reReason=$$v},expression:"reReason"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"reProvinceIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reProvinceId',"name":'reProvinceId',"select2-options":_vm.reProvinceIdOptions},model:{value:(_vm.reProvinceId),callback:function ($$v) {_vm.reProvinceId=$$v},expression:"reProvinceId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"reAmpherIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAmpherId',"name":'reAmpherId',"select2-options":_vm.reAmpherIdOptions},model:{value:(_vm.reAmpherId),callback:function ($$v) {_vm.reAmpherId=$$v},expression:"reAmpherId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reInActiveStatus),expression:"reInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"reInActiveStatus","name":"reInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.reInActiveStatus)?_vm._i(_vm.reInActiveStatus,null)>-1:(_vm.reInActiveStatus)},on:{"click":_vm.FncreInActiveStatus,"change":function($event){var $$a=_vm.reInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.reInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.reInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.reInActiveStatus=$$c}}}}),_vm._v("\n                    สถานะปัจจุบัน\n                    "),_c('span')])])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[(
                this.$root.canShow([
                  // 'AGENT_REPORT', 'SUB_AGENT_REPORT', 'BR_REPORT',
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                  'COOL_SERVICE_PM' ])
              )?_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportMasterShop}},[_vm._m(3)]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]):_vm._e()])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/5SReport/TransactionView5S'),expression:"$route.path == '/5SReport/TransactionView5S'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reDepartmentsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"5SByAgentTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"10"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_vm._l((_vm.headers),function(data){return _c('th',{staticClass:"all text-center",staticStyle:{"width":"10%"}},[_vm._v("\n                    "+_vm._s(data)+"\n                  ")])})],2),_vm._v(" "),_vm._l((_vm.database),function(item,index){return _c('tr',[_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(item.agentName))]),_vm._v(" "),_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(item.departments))]),_vm._v(" "),_vm._l((item.item),function(data){return _c('td',{staticClass:"all text-center",staticStyle:{"width":"6%"}},[_vm._v("\n                    "+_vm._s(data.count)+"\n                  ")])})],2)})],2),_vm._v(" "),_c('tbody',{directives:[{name:"show",rawName:"v-show",value:(_vm.database.length === 0),expression:"database.length === 0"}],attrs:{"id":"text1"}})])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])}]


/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[(_vm.canEdit)?_c('div',{staticClass:"modal fade",attrs:{"id":"importEditStockCoverDaysModal","tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{ref:"importEditForm"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{ref:"importEditFileInput",staticClass:"custom-file-input",attrs:{"type":"file","id":"importEditFile","accept":".xlsx"},on:{"change":_vm.onImportEditFileChange}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",attrs:{"for":"importEditFile"}},[_vm._v("\n                    "+_vm._s(_vm.importEditFileName || 'เลือกไฟล์...')+"\n                  ")])]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("รองรับไฟล์ .xlsx เท่านั้น (แก้ไขข้อมูลเดิม)")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("ยกเลิก")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.importEditFile},on:{"click":_vm.submitImportEdit}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v(" นำเข้าข้อมูล\n            ")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{class:_vm.isViewMode ? 'fas fa-search' : 'fas fa-edit'})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(_vm.isViewMode ? 'ดูรายละเอียด Stock Cover Days' : 'แก้ไข Stock Cover Days')+"\n            "),_vm._v(" "),(_vm.canEdit && _vm.detailData)?_c('span',{staticClass:"scd-hint"},[_c('i',{staticClass:"fas fa-info-circle text-primary kt-margin-l-5",staticStyle:{"cursor":"help","font-size":"1rem"}}),_vm._v(" "),_c('span',{staticClass:"scd-hint-text",domProps:{"innerHTML":_vm._s(_vm.editHintHtml)}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[(_vm.isLoading)?_c('div',{staticClass:"text-center py-5"},[_c('div',{staticClass:"kt-spinner kt-spinner--lg kt-spinner--brand"}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v("กำลังโหลดข้อมูล...")])]):(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_vm._v(" "+_vm._s(_vm.errorMessage)+"\n        ")]):(_vm.detailData)?_c('div',[_c('div',{staticClass:"row align-items-end mb-2"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("คลังสินค้า :")]),_vm._v(" "),_c('div',[_vm._v("["+_vm._s(_vm.detailData.plantCode)+"] "+_vm._s(_vm.detailData.plantName))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("ปี :")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.detailData.year))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[(!_vm.isViewMode)?_c('div',{staticClass:"text-muted"},[_vm._v("หน่วย : ลิตร")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row align-items-end mb-3"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("ชื่อสินค้า :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedProduct),expression:"selectedProduct"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedProduct=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("ทั้งหมด")]),_vm._v(" "),_vm._l((_vm.productFilterOptions),function(p){return _c('option',{key:p.code,domProps:{"value":p.code}},[_vm._v("\n                  "+_vm._s(p.name ? p.name + ' [' + p.code + ']' : p.code)+"\n                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("Version ข้อมูล :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedVersion),expression:"selectedVersion"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedVersion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("ทั้งหมด")]),_vm._v(" "),_vm._l((_vm.versionOptions),function(v){return _c('option',{key:v,domProps:{"value":String(v)}},[_vm._v("Version"+_vm._s(v))])})],2)]),_vm._v(" "),(_vm.isViewMode)?_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("หน่วย :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUnit),expression:"selectedUnit"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedUnit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"ลิตร"}},[_vm._v("ลิตร")]),_vm._v(" "),_c('option',{attrs:{"value":"ถัง"}},[_vm._v("ถัง")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row align-items-center mb-3"},[_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.applyFilters}},[_vm._v("\n                ค้นหา\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.clearFilters}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 text-right"},[_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button","disabled":_vm.isExporting},on:{"click":_vm.exportExcel}},[_c('i',{class:_vm.isExporting ? 'fas fa-spinner fa-spin' : 'fas fa-file-excel'}),_vm._v(" Export Excel\n              ")]),_vm._v(" "),(_vm.canEdit)?_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"type":"button"},on:{"click":_vm.showImportEditModal}},[_c('i',{staticClass:"fas fa-file-import"}),_vm._v(" Import ข้อมูลตามเป้าหมาย(แก้ไข)\n              ")]):_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('button',{staticClass:"btn btn-info btn-sm",attrs:{"type":"button","disabled":_vm.isExporting},on:{"click":_vm.downloadExport}},[_c('i',{class:_vm.isExporting ? 'fas fa-spinner fa-spin' : 'fas fa-download'}),_vm._v(" ดาวโหลด(แก้ไข)\n              ")]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.canEdit)?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":_vm.addNewCard}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" เพิ่มข้อมูลตามเป้าหมาย\n              ")])])]):_vm._e(),_vm._v(" "),(_vm.newCard)?_c('div',{staticClass:"card mb-4 border-primary"},[_c('div',{staticClass:"card-header bg-light d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('label',{staticClass:"font-weight-bold mb-0 mr-2"},[_vm._v("ชื่อสินค้า :")]),_vm._v(" "),_c('div',{staticStyle:{"min-width":"260px"}},[_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control form-control-sm',"id":'scdNewProductSelect',"name":'scdNewProductSelect',"select2-options":_vm.productOptions},on:{"selectChange":_vm.onNewProductChange},model:{value:(_vm.newCard.productCode),callback:function ($$v) {_vm.$set(_vm.newCard, "productCode", $$v)},expression:"newCard.productCode"}})],1),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button","title":"ยกเลิกการเพิ่ม"},on:{"click":_vm.removeNewCard}},[_c('i',{staticClass:"la la-trash"})])]),_vm._v(" "),_c('div',{staticClass:"card-body p-2"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-sm scd-matrix mb-0"},[_c('tbody',[_c('tr',[_c('th',{staticClass:"scd-label scd-row-saledays"},[_vm._v("จำนวนวันขาย")]),_vm._v(" "),_vm._l((_vm.newCard.cells),function(cell){return _c('td',{key:'ns-' + cell.month,staticClass:"scd-row-saledays"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(cell.saleDays),expression:"cell.saleDays"}],staticClass:"form-control form-control-sm text-center scd-input",attrs:{"type":"text"},domProps:{"value":(cell.saleDays)},on:{"keydown":_vm.onIntKeydown,"blur":function($event){return _vm.onSaleDaysBlur(cell)},"input":function($event){if($event.target.composing){ return; }_vm.$set(cell, "saleDays", $event.target.value)}}})])})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"scd-label scd-row-months"},[_vm._v("ข้อมูลตามเป้าหมาย")]),_vm._v(" "),_vm._l((_vm.newCard.cells),function(cell){return _c('td',{key:'nm-' + cell.month,staticClass:"scd-row-months text-center font-weight-bold"},[_vm._v("\n                        "+_vm._s(_vm.monthLabels[cell.month - 1])+"\n                      ")])})],2),_vm._v(" "),_vm._l((_vm.measureRows),function(row){return _c('tr',{key:'nr-' + row.key},[_c('th',{staticClass:"scd-label",class:row.cls},[_vm._v(_vm._s(row.label))]),_vm._v(" "),_vm._l((_vm.newCard.cells),function(cell){return _c('td',{key:'nrc-' + row.key + '-' + cell.month,class:row.cls},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(cell[row.key + 'Text']),expression:"cell[row.key + 'Text']"}],staticClass:"form-control form-control-sm text-center scd-input",attrs:{"type":"text"},domProps:{"value":(cell[row.key + 'Text'])},on:{"keydown":_vm.onIntKeydown,"focus":function($event){return _vm.onMeasureFocus(cell, row.key)},"blur":function($event){return _vm.onMeasureBlur(cell, row.key)},"input":function($event){if($event.target.composing){ return; }_vm.$set(cell, row.key + 'Text', $event.target.value)}}})])})],2)}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"scd-label scd-row-scvd"},[_vm._v("SCVD")]),_vm._v(" "),_vm._l((_vm.newCard.cells),function(cell){return _c('td',{key:'nv-' + cell.month,staticClass:"scd-row-scvd text-center"},[_vm._v("\n                        "+_vm._s(_vm.formatScvd(_vm.displayScvd(_vm.newCard, cell)))+"\n                      ")])})],2)],2)])]),_vm._v(" "),_c('div',{staticClass:"text-right mt-2"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button","disabled":_vm.isSaving},on:{"click":_vm.saveNewCard}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึก\n                ")])])])]):_vm._e(),_vm._v(" "),(_vm.visibleCards.length === 0 && !_vm.newCard)?_c('div',{staticClass:"text-center text-muted py-4"},[_vm._v("\n            ไม่มีข้อมูลตามเป้าหมาย\n          ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.visibleCards),function(card,ci){return _c('div',{key:card.productCode + '-' + card.version,staticClass:"card mb-4"},[_c('div',{staticClass:"card-header bg-light d-flex justify-content-between align-items-center"},[_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("ชื่อสินค้า : "+_vm._s(card.productName)+" ["+_vm._s(card.productCode)+"]")]),_vm._v(" "),_c('span',{staticClass:"ml-3 font-weight-bold"},[_vm._v("Version ข้อมูล : Version"+_vm._s(card.version))])]),_vm._v(" "),(_vm.canEdit)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button","title":"ลบ Version นี้"},on:{"click":function($event){return _vm.deleteCard(card)}}},[_c('i',{staticClass:"la la-trash"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-body p-2"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-sm scd-matrix mb-0"},[_c('tbody',[_c('tr',[_c('th',{staticClass:"scd-label scd-row-saledays"},[_vm._v("จำนวนวันขาย")]),_vm._v(" "),_vm._l((card.cells),function(cell){return _c('td',{key:'s-' + ci + '-' + cell.month,staticClass:"scd-row-saledays text-center"},[(_vm.cellEditable(card, cell))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(cell.saleDays),expression:"cell.saleDays"}],staticClass:"form-control form-control-sm text-center scd-input",attrs:{"type":"text"},domProps:{"value":(cell.saleDays)},on:{"keydown":_vm.onIntKeydown,"blur":function($event){return _vm.onSaleDaysBlur(cell)},"input":function($event){if($event.target.composing){ return; }_vm.$set(cell, "saleDays", $event.target.value)}}}):_c('span',[_vm._v(_vm._s(cell.exists ? cell.saleDays : ''))])])})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"scd-label scd-row-months"},[_vm._v("ข้อมูลตามเป้าหมาย")]),_vm._v(" "),_vm._l((card.cells),function(cell){return _c('td',{key:'m-' + ci + '-' + cell.month,staticClass:"scd-row-months text-center font-weight-bold"},[_vm._v("\n                        "+_vm._s(_vm.monthLabels[cell.month - 1])+"\n                      ")])})],2),_vm._v(" "),_vm._l((_vm.measureRows),function(row){return _c('tr',{key:'r-' + ci + '-' + row.key},[_c('th',{staticClass:"scd-label",class:row.cls},[_vm._v(_vm._s(row.label))]),_vm._v(" "),_vm._l((card.cells),function(cell){return _c('td',{key:'rc-' + ci + '-' + row.key + '-' + cell.month,staticClass:"text-center",class:row.cls},[(_vm.cellEditable(card, cell))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(cell[row.key + 'Text']),expression:"cell[row.key + 'Text']"}],staticClass:"form-control form-control-sm text-center scd-input",attrs:{"type":"text"},domProps:{"value":(cell[row.key + 'Text'])},on:{"keydown":_vm.onIntKeydown,"focus":function($event){return _vm.onMeasureFocus(cell, row.key)},"blur":function($event){return _vm.onMeasureBlur(cell, row.key)},"input":function($event){if($event.target.composing){ return; }_vm.$set(cell, row.key + 'Text', $event.target.value)}}}):_c('span',[_vm._v(_vm._s(cell.exists ? _vm.formatInt(_vm.displayMeasure(card, cell[row.key])) : ''))])])})],2)}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"scd-label scd-row-scvd"},[_vm._v("SCVD")]),_vm._v(" "),_vm._l((card.cells),function(cell){return _c('td',{key:'v-' + ci + '-' + cell.month,staticClass:"scd-row-scvd text-center"},[_vm._v("\n                        "+_vm._s(_vm.formatScvd(_vm.displayScvd(card, cell)))+"\n                      ")])})],2)],2)])])])])}),_vm._v(" "),(_vm.canEdit && _vm.visibleCards.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-right"},[_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.isSaving},on:{"click":_vm.saveUpdate}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "+_vm._s(_vm.isSaving ? 'กำลังบันทึก...' : 'บันทึก')+"\n              ")])])]):_vm._e()],2):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Import ข้อมูลตามเป้าหมาย(แก้ไข)")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("ไฟล์ Excel (.xlsx) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml-3 font-weight-bold"},[_vm._v("Version ข้อมูล : "),_c('span',{staticClass:"badge badge-info"},[_vm._v("Version ถัดไป (auto)")])])}]


/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/MasterProductUnitPrice'),expression:"$route.path == '/Master/MasterProductUnitPrice'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.MbSKUOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbSKUId),callback:function ($$v) {_vm.MbSKUId=$$v},expression:"MbSKUId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปี(สินค้า) (ค.ศ.) :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"odYear",staticClass:"form-control",attrs:{"type":"text","placeholder":"(YYYY)","id":"odYear","name":"odYear","autocomplete":"off"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"odInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'odInActiveStatus',"name":'odInActiveStatus',"select2-options":_vm.odInActiveStatusOptions},model:{value:(_vm.odInActiveStatus),callback:function ($$v) {_vm.odInActiveStatus=$$v},expression:"odInActiveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['MANAGE_MASTER', 'MANAGE_ORDER']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"MasterProductUnitPrice/Add","tag":"button","title":"เพิ่มข้อมูลการสั่งซื้อ "}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูล\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(2)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            ตั้งค่าราคาค่าถัง\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"BarcodeAlertConfigTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all",attrs:{"width":"8%"}},[_vm._v("รายการที่")]),_vm._v(" "),_c('th',{staticClass:"all center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all center"},[_vm._v("เจ้าของทรัพย์สิน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ปี(สินค้า)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ราคา")]),_vm._v(" "),_c('th',{staticClass:"all center",attrs:{"width":"10%"}},[_vm._v("วันที่บันทึก")]),_vm._v(" "),_c('th',{staticClass:"center",attrs:{"width":"10%"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/TransferBarcodeSupplier'),expression:"$route.path == '/Report/TransferBarcodeSupplier'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คลังสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbsOriginPlantCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbsOriginPlantCode),callback:function ($$v) {_vm.reTbsOriginPlantCode=$$v},expression:"reTbsOriginPlantCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Supplier:")]),_vm._v(" "),_c('treeselect',{ref:"reTbsDestinationVendorId",attrs:{"multiple":true,"load-options":_vm.LoadreTbsDestinationVendorIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadreTbsDestinationVendorIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.reTbsDestinationVendorId),callback:function ($$v) {_vm.reTbsDestinationVendorId=$$v},expression:"reTbsDestinationVendorId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่เอกสารส่งซ่อม Supplier:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreTbsTransferJobNumberOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reTbsTransferJobNumber),callback:function ($$v) {_vm.reTbsTransferJobNumber=$$v},expression:"reTbsTransferJobNumber"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่เอกสารรับคืนจาก Supplier:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreTbsReturnJobNumberOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reTbsReturnJobNumber),callback:function ($$v) {_vm.reTbsReturnJobNumber=$$v},expression:"reTbsReturnJobNumber"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('Collapsible',{staticClass:"product-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหาสินค้า\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-plus-square"}),_vm._v(" ค้นหาสินค้า\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"product"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reTbsBarcode),expression:"reTbsBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reTbsBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reTbsBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreTbsDepartmentMaterialCodeOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reTbsDepartmentMaterialCode),callback:function ($$v) {_vm.reTbsDepartmentMaterialCode=$$v},expression:"reTbsDepartmentMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมวดหมู่สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbsProductGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbsProductGroupId),callback:function ($$v) {_vm.reTbsProductGroupId=$$v},expression:"reTbsProductGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbsProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbsProductTypeId),callback:function ($$v) {_vm.reTbsProductTypeId=$$v},expression:"reTbsProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbsAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbsAssetCode),callback:function ($$v) {_vm.reTbsAssetCode=$$v},expression:"reTbsAssetCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbsBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbsBrandId),callback:function ($$v) {_vm.reTbsBrandId=$$v},expression:"reTbsBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รายการอะไหล่ที่ใช้:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.supplierSpareOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbsSupplierSpareId),callback:function ($$v) {_vm.reTbsSupplierSpareId=$$v},expression:"reTbsSupplierSpareId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะระบุอะไหล่:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.spareUsedStatusOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbsSpareUsedStatusId),callback:function ($$v) {_vm.reTbsSpareUsedStatusId=$$v},expression:"reTbsSpareUsedStatusId"}})],1)])])])])],1),_vm._v(" "),(this.$root.canShow([
                 'AGENT_REPORT',
                 'SUB_AGENT_REPORT',
                 'BR_REPORT',
                 'OFFICER_QIMAINTAIN',
                 'OFFICER_PLANT_QIMAINTAIN', 
                 'LEAD_QIMAINTAIN'
                 ]))?_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('Collapsible',{staticClass:"product-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหาข้อมูลส่ง-คืน\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la\tla-plus-square"}),_vm._v(" ค้นหาข้อมูลส่ง-คืน\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"product"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จำนวนวันคงค้าง(เริ่มต้น):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reTbsOccupiedDaysStart),expression:"reTbsOccupiedDaysStart"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุจำนวนวันคงค้าง(เริ่มต้น)"},domProps:{"value":(_vm.reTbsOccupiedDaysStart)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reTbsOccupiedDaysStart=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จำนวนวันคงค้าง(สิ้นสุด):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reTbsOccupiedDaysEnd),expression:"reTbsOccupiedDaysEnd"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุจำนวนวันคงค้าง(สิ้นสุด)"},domProps:{"value":(_vm.reTbsOccupiedDaysEnd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reTbsOccupiedDaysEnd=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่ส่งซ่อม(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reTbsTransactionDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reTbsTransactionDateStart","name":"reTbsTransactionDateStart"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่ส่งซ่อม(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reTbsTransactionDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reTbsTransactionDateEnd","name":"reTbsTransactionDateEnd"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับคืนจากการซ่อม(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reTbsReturnTransactionDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reTbsReturnTransactionDateStart","name":"reTbsReturnTransactionDateStart"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับคืนจากการซ่อม(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reTbsReturnTransactionDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reTbsReturnTransactionDateEnd","name":"reTbsReturnTransactionDateEnd"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reTbsReturnStatus',"name":'reTbsReturnStatus',"select2-options":_vm.reTbsReturnStatusOptions},model:{value:(_vm.reTbsReturnStatus),callback:function ($$v) {_vm.reTbsReturnStatus=$$v},expression:"reTbsReturnStatus"}})],1)])])])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[(
                this.$root.canShow([
                 'AGENT_REPORT',
                 'SUB_AGENT_REPORT',
                 'BR_REPORT',
                 'OFFICER_QIMAINTAIN',
                 'OFFICER_PLANT_QIMAINTAIN', 
                 'LEAD_QIMAINTAIN'
                ])
              )?_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportBarcodes}},[_vm._m(1)]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]):_vm._e()])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"createFolderELearningModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อหมวดหมู่")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cfelSubFolderName),expression:"cfelSubFolderName"}],staticClass:"form-control",attrs:{"type":"text","id":"cfelSubFolderName","name":"cfelSubFolderName"},domProps:{"value":(_vm.cfelSubFolderName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cfelSubFolderName=$event.target.value}}})])])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึก\n          ")])])}]


/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เลขที่เอกสาร:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.ubpDocNo))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ขอเบิก/ยืม:")]),_vm._v(" "),_c('select2',{ref:"ubpBorrowerSelect2",attrs:{"disabled":true,"css-style":'width: 100%;',"css-class":'form-control required',"id":'ubpBorrower',"name":'ubpBorrower',"select2-options":_vm.ubpBorrowerOptions,"data-msg-required":"กรุณาเลือกผู้ขอเบิก/ยืม"},on:{"selectChange":_vm.ubpBorrowerChange},model:{value:(_vm.ubpBorrower),callback:function ($$v) {_vm.ubpBorrower=$$v},expression:"ubpBorrower"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย/หน่วยงาน:")]),_vm._v(" "),_c('select2',{ref:"ubpAgentSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"disabled":true,"id":'ubpAgentCode',"name":'ubpAgentCode',"select2-options":_vm.ubpAgentOptions},on:{"selectChange":_vm.onAgentCodeChange},model:{value:(_vm.ubpAgentCode),callback:function ($$v) {_vm.ubpAgentCode=$$v},expression:"ubpAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้รับสินค้าแทน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpRepresentName),expression:"ubpRepresentName"}],staticClass:"form-control",attrs:{"disabled":true,"id":"ubpRepresentName","name":"ubpRepresentName","type":"text","maxlength":"450"},domProps:{"value":(_vm.ubpRepresentName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ubpRepresentName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทรผู้รับสินค้าแทน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpRepresentTel),expression:"ubpRepresentTel"}],staticClass:"form-control",attrs:{"disabled":true,"id":"ubpRepresentTel","name":"ubpRepresentTel","type":"text","maxlength":"450"},domProps:{"value":(_vm.ubpRepresentTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ubpRepresentTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่เอกสาร :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.ubpReqDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-3 col-form-label label-required"},[_vm._v("ประเภทใบคำร้องขอ:")]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"kt-checkbox-inline"},_vm._l((_vm.ubpRequestTypeOptions),function(ubpRequestTypeOption,ubp){return _c('label',{key:ubp,staticClass:"kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpRequestType),expression:"ubpRequestType"}],attrs:{"type":"checkbox","id":ubpRequestTypeOption.id,"checked":"","disabled":true},domProps:{"value":ubpRequestTypeOption.id,"checked":Array.isArray(_vm.ubpRequestType)?_vm._i(_vm.ubpRequestType,ubpRequestTypeOption.id)>-1:(_vm.ubpRequestType)},on:{"change":function($event){var $$a=_vm.ubpRequestType,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=ubpRequestTypeOption.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ubpRequestType=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ubpRequestType=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ubpRequestType=$$c}}}}),_vm._v("\n                      "+_vm._s(ubpRequestTypeOption.text)+"\n                      "),_c('span')])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-3 col-form-label label-required"},[_vm._v("หมวดหมู่สินค้า:")]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"kt-radio-inline"},_vm._l((_vm.ubpProductGroupOptions),function(ubpProductGroupOption,index){return _c('label',{key:index,staticClass:"kt-radio rea"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpProductGroup),expression:"ubpProductGroup"}],attrs:{"type":"radio","id":ubpProductGroupOption.id,"disabled":true},domProps:{"value":ubpProductGroupOption.id,"checked":_vm._q(_vm.ubpProductGroup,ubpProductGroupOption.id)},on:{"change":[function($event){_vm.ubpProductGroup=ubpProductGroupOption.id},function($event){return _vm.onProductGroupChange($event)}]}}),_vm._v("\n                      "+_vm._s(ubpProductGroupOption.text)+"\n                      "),_c('span')])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 table-responsive table-checkable",attrs:{"id":"Activity"}},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover",staticStyle:{"min-width":"2250px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"1%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"6%"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"8%"}},[_vm._v("\n                      ประเภทสินค้า\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"13%"}},[_vm._v("\n                      ชื่อสินค้า\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"6%"}},[_vm._v("\n                      รูปภาพ\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"6%"}},[_vm._v("\n                      โควต้า(แบรนด์)\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"5%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("\n                      ตัวแทนจำหน่าย\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"18%"}},[_vm._v("\n                      ชื่อร้านค้า/กิจกรรม\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%"}},[_vm._v("\n                        หมายเหตุกิจกรรม\n                        "),_c('i',{staticClass:"far fa-copy",staticStyle:{"cursor":"pointer","margin-left":"5px","transform":"scaleX(-1)","color":"#5867dd"},attrs:{"title":"คัดลอกข้อความ \"หมายเหตุกิจกรรม\" ของแถวที่1"},on:{"click":_vm.copyNote}})]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"160px !important"}},[_vm._v("\n                      วันที่กำหนดคืน\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"2%"}},[_vm._v("การจัดการ")])])]),_vm._v(" "),_c('tbody',[(_vm.plItems == null || _vm.plItems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"11"}},[_vm._v("\n                      คลิก + เพื่อเพิ่มรายการใหม่\n                    ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.plItems),function(item,i){return [_c('pl-item-row',{key:i,ref:"plItems",refInFor:true,attrs:{"rowIndex":i,"item":item,"isEditable":_vm.ubpIsEdit},on:{"removeItem":function($event){return _vm.onRemoveItemClick(i, item)}}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticStyle:{"text-align":"right"},attrs:{"colspan":"5"}},[_vm._v("\n                      จำนวนรวมมูลค่าการเบิกยืม (บาท)\n                    ")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("\n                      "+_vm._s(_vm._f("currency")(_vm.totalCal,"฿", 2))+"\n                    ")])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"11"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                      ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมายเหตุ:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpRemark),expression:"ubpRemark"}],staticClass:"form-control",attrs:{"placeholder":"หมายเหตุ","rows":"5"},domProps:{"value":(_vm.ubpRemark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ubpRemark=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.push({ path: "/Borrow" })}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),(_vm.ubpIsApprove === true)?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.onApprove($event)}}},[_c('i',{staticClass:"la la-check"}),_vm._v(" อนุมัติ\n        ")]):_vm._e(),_vm._v(" "),(_vm.ubpIsApprove === true)?_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.onReject($event)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ไม่อนุมัติ\n        ")]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('h4',{staticClass:"kt-section__title"},[_vm._v("ประวัติการอนุมัติ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"table-history"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("วันที่")]),_vm._v(" "),_c('th',[_vm._v("ผู้อนุมัติ")]),_vm._v(" "),_c('th',[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',[_vm._v("สถานะ")]),_vm._v(" "),_c('th',[_vm._v("หมายเหตุ")])])])])])])])])}]


/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('router-link',{staticClass:"btn btn-secondary btn-sm",attrs:{"to":"/BudgetPlan/Monitoring"}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" กลับ\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-3"},[_c('label',[_vm._v("MonthPeriod (yyyyMM):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterMonthPeriod),expression:"filterMonthPeriod"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"เช่น 202604","maxlength":"6"},domProps:{"value":(_vm.filterMonthPeriod)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filterMonthPeriod=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterStatus),expression:"filterStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("ทั้งหมด")]),_vm._v(" "),_c('option',{attrs:{"value":"RUNNING"}},[_vm._v("RUNNING")]),_vm._v(" "),_c('option',{attrs:{"value":"SUCCESS"}},[_vm._v("SUCCESS")]),_vm._v(" "),_c('option',{attrs:{"value":"FAILED"}},[_vm._v("FAILED")])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 d-flex align-items-end"},[_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"disabled":_vm.isLoading},on:{"click":_vm.loadLogs}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" "+_vm._s(_vm.isLoading ? 'กำลังโหลด...' : 'ค้นหา')+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning mr-2",attrs:{"disabled":_vm.isSendingNotify},on:{"click":_vm.sendNotifyEmail}},[_c('i',{staticClass:"fas fa-envelope"}),_vm._v(" "+_vm._s(_vm.isSendingNotify ? 'กำลังส่ง...' : 'Send Notify Email')+"\n        ")])])]),_vm._v(" "),(_vm.notifyResult)?_c('div',{staticClass:"alert",class:_vm.notifyAlertClass},[_c('strong',[_vm._v(_vm._s(_vm.notifyResult.message || _vm.notifyResult.Message))]),_vm._v(" "),(_vm.notifyResult.notificationSent || _vm.notifyResult.NotificationSent)?_c('div',{staticClass:"mt-2"},[_c('small',[_vm._v("\n          BatchId: "+_vm._s(_vm.notifyResult.batchId || _vm.notifyResult.BatchId)+" |\n          MonthPeriod: "+_vm._s(_vm.notifyResult.monthPeriod || _vm.notifyResult.MonthPeriod)+" |\n          FAILED: "+_vm._s(_vm.notifyResult.failedCount || _vm.notifyResult.FailedCount)+" / "+_vm._s(_vm.notifyResult.totalSources || _vm.notifyResult.TotalSources)+" sources |\n          Recipients: "+_vm._s((_vm.notifyResult.recipients || _vm.notifyResult.Recipients || []).join(', '))+"\n        ")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.logs.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"11"}},[_vm._v("ไม่พบข้อมูล")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.logs),function(log,index){return _c('tr',{key:log.logId},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(log.logId))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(log.monthPeriod))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.sourceName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDateTime(log.startTime)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDateTime(log.endTime)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(log.durationMs != null ? log.durationMs.toLocaleString() : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(log.rowCountSnap != null ? log.rowCountSnap.toLocaleString() : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge",class:{
                  'badge-warning': log.status === 'RUNNING',
                  'badge-success': log.status === 'SUCCESS',
                  'badge-danger': log.status === 'FAILED'
                }},[_vm._v("\n                "+_vm._s(log.status)+"\n              ")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(log.errorMessage))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(log.batchId))])])])})],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("BI SnapData — Monitoring")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("LogId")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("MonthPeriod")]),_vm._v(" "),_c('th',[_vm._v("SourceName")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("StartTime")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("EndTime")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Duration (ms)")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("RowCount")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',[_vm._v("ErrorMessage")]),_vm._v(" "),_c('th',[_vm._v("BatchId")])])])}]


/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.loadReport($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("คลังสินค้า:")]),_vm._v(" "),_c('select2',{ref:"rptPlantCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'rptPlantCodes',"name":'rptPlantCodes',"select2-options":_vm.plantOptions,"multiple":""},model:{value:(_vm.filterPlantCodes),callback:function ($$v) {_vm.filterPlantCodes=$$v},expression:"filterPlantCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('select2',{ref:"rptProductCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'rptProductCodes',"name":'rptProductCodes',"select2-options":_vm.productOptions,"multiple":""},model:{value:(_vm.filterProductCodes),callback:function ($$v) {_vm.filterProductCodes=$$v},expression:"filterProductCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('select2',{ref:"rptBrandIdsSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'rptBrandIds',"name":'rptBrandIds',"select2-options":_vm.brandOptions,"multiple":""},model:{value:(_vm.filterBrandIds),callback:function ($$v) {_vm.filterBrandIds=$$v},expression:"filterBrandIds"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เดือน:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filterMonth),expression:"filterMonth",modifiers:{"number":true}}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.filterMonth=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.monthLabels),function(lbl,i){return _c('option',{key:'m-' + i,domProps:{"value":i + 1}},[_vm._v(_vm._s(lbl))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ปี:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filterYear),expression:"filterYear",modifiers:{"number":true}}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.filterYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.yearOptions),function(y){return _c('option',{key:y,domProps:{"value":y}},[_vm._v(_vm._s(y))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หน่วย:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterUnit),expression:"filterUnit"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterUnit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"ลิตร"}},[_vm._v("ลิตร")]),_vm._v(" "),_c('option',{attrs:{"value":"ถัง"}},[_vm._v("ถัง")])])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 d-flex align-items-center"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary ml-2",attrs:{"type":"button"},on:{"click":_vm.resetFilter}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-auto",attrs:{"type":"button","disabled":_vm.isExporting || !_vm.report},on:{"click":_vm.exportExcel}},[_c('i',{class:_vm.isExporting ? 'fas fa-spinner fa-spin' : 'fas fa-file-excel'}),_vm._v("\n                "+_vm._s(_vm.isExporting ? 'กำลังดาวน์โหลด...' : 'Export Excel')+"\n              ")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"text-center py-5"},[_c('div',{staticClass:"kt-spinner kt-spinner--lg kt-spinner--brand"}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v("กำลังโหลดข้อมูล...")])]):(!_vm.report)?_c('div',{staticClass:"text-center text-muted py-4"},[_vm._v("\n          เลือกตัวกรอง แล้วกดปุ่ม \"ค้นหา\" เพื่อดูรายงาน\n        ")]):_c('div',[(_vm.report.isMtd)?_c('div',{staticClass:"alert alert-info py-2",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v("\n            เดือนปัจจุบัน = "),_c('strong',[_vm._v("MTD")]),_vm._v(" (Avg Sales/วัน ใช้จำนวนวันขายที่ผ่านมา ณ วันที่เรียกดู)\n          ")]):_vm._e(),_vm._v(" "),(_vm.report.isClosed)?_c('div',{staticClass:"alert py-2",staticStyle:{"background":"#e0e7ff","color":"#3730a3","border":"1px solid #c7d2fe"},attrs:{"role":"alert"}},[_vm._v("\n            🔒 "),_c('strong',[_vm._v("ปิดรอบเดือนข้อมูลแล้วไม่สามารถแก้ไขข้อมูลได้")]),_vm._v(" - การแก้ไข/ทดลองเกณฑ์จะไม่กระทบเปลี่ยนแปลงข้อมูลเดือนนี้\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-sm scd-report mb-0"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ปี")]),_vm._v(" "),_c('th',[_vm._v("คลังสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Stock คงเหลือ ("+_vm._s(_vm.report.unit || _vm.filterUnit)+")")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Avg Sales/วัน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Stock Cover Days")]),_vm._v(" "),_c('th',[_vm._v("สถานะสต็อก")]),_vm._v(" "),_c('th',[_vm._v("แนวทางแก้ไข")])])]),_vm._v(" "),(_vm.report.groups.length === 0)?_c('tbody',[_vm._m(2)]):_vm._e(),_vm._v(" "),_vm._l((_vm.report.groups),function(group,gi){return _c('tbody',{key:'g-' + gi},[_vm._l((group.rows),function(r,ri){return _c('tr',{key:'g-' + gi + '-r-' + ri},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(r.monthLabel))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(r.year))]),_vm._v(" "),_c('td',[_vm._v("["+_vm._s(r.plantCode)+"] "+_vm._s(r.plantName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(r.productCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.brandName))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNum(r.stockRemaining)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNum(r.avgSalesPerDay)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatScvd(r.scvd)))]),_vm._v(" "),_c('td',{staticClass:"text-center scd-status-cell",style:(_vm.statusStyle(r))},[_vm._v(_vm._s(r.status))]),_vm._v(" "),_c('td',{style:(_vm.actionStyle(r))},[_vm._v(_vm._s(r.actionText))])])}),_vm._v(" "),_c('tr',{staticClass:"scd-total-row"},[_c('td',{staticClass:"text-right",attrs:{"colspan":"6"}},[_vm._v("\n                    Total ["+_vm._s(group.plantCode)+"] "+_vm._s(group.plantName)+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNum(group.total.stockRemaining)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNum(group.total.avgSalesPerDay)))]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}})])],2)}),_vm._v(" "),(_vm.report.groups.length > 0)?_c('tfoot',[_c('tr',{staticClass:"scd-grand-total-row"},[_c('td',{staticClass:"text-right",attrs:{"colspan":"6"}},[_vm._v("Grand Total")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNum(_vm.report.grandTotal.stockRemaining)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNum(_vm.report.grandTotal.avgSalesPerDay)))]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}})])]):_vm._e()],2)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-clipboard-list"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            Stock Cover Days Report\n          ")])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" ค้นหา\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center text-muted py-3",attrs:{"colspan":"11"}},[_vm._v("\n                    ไม่พบข้อมูลตามเงื่อนไขที่เลือก\n                  ")])])}]


/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทกิจกรรม:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktaObjectives))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อกิจกรรม:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktaActivityName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ตัวเทนจำหน่าย:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktaAgentName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อร้านค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktaShopName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อร้านค้า 2:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktaShopName2))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktaProvinceName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktaShopType))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktaActivityDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktaActivityDateStart))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktaActivityDateEnd))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("พื้นที่กิจกรรม: ")]),_vm._v(" "),_c('GmapMap',{staticStyle:{"width":"500px","height":"300px"},attrs:{"center":{ lat: _vm.mktaNLat, lng: _vm.mktaNLng },"zoom":15,"clickable":true}},[_vm._l((_vm.mktaMarkers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.positionN,"draggable":false,"clickable":true,"icon":"http://maps.google.com/mapfiles/ms/icons/red-dot.png","title":"พื้นที่ใหม่"}})}),_vm._v(" "),_vm._l((_vm.mktaMarkers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.positionO,"draggable":false,"clickable":true,"icon":"http://maps.google.com/mapfiles/ms/icons/yellow-dot.png","title":"พื้นที่เดิม"}})})],2),_vm._v(" "),_vm._m(1)],1)])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),(_vm.mktaIsApprove === true)?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.onApprove($event)}}},[_c('i',{staticClass:"la la-check"}),_vm._v(" อนุมัติ\n        ")]):_vm._e(),_vm._v(" "),(_vm.mktaIsApprove === true)?_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.onReject($event)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ไม่อนุมัติ\n        ")]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_c('span',{staticStyle:{"color":"red"}},[_vm._v("สีแดง:พื้นที่ใหม่")]),_vm._v(" ,\n                  "),_c('span',{staticStyle:{"color":"#DAA520"}},[_vm._v("สีเหลือง:พื้นที่เดิม")])])}]


/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MaintainReport/Drawback'),expression:"$route.path == '/MaintainReport/Drawback'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เบิก/คืน/รับเข้า(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateStart","name":"jobsDateStart","readonly":""}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่เบิก/คืน/รับเข้า(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateEnd","name":"jobsDateEnd","readonly":""}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่ใบงาน :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qiJobNumber),expression:"qiJobNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"เลขที่ใบงาน"},domProps:{"value":(_vm.qiJobNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qiJobNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่ออะไหล่:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductCode","multiple":true,"options":_vm.qiProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductCode),callback:function ($$v) {_vm.qiProductCode=$$v},expression:"qiProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เขต:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"jobArea","multiple":true,"options":_vm.qiJobAreaOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.jobArea),callback:function ($$v) {_vm.jobArea=$$v},expression:"jobArea"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("สถานะ:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"jobStatus","multiple":true,"options":_vm.qiJobStatusOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.jobStatus),callback:function ($$v) {_vm.jobStatus=$$v},expression:"jobStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผู้ขอเบิก/คืน:")]),_vm._v(" "),_c('treeselect',{ref:"qiUserId",attrs:{"multiple":true,"load-options":_vm.LoadUsersIdOptions,"async":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadUsersIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.qiUserId),callback:function ($$v) {_vm.qiUserId=$$v},expression:"qiUserId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),(this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN']))?_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.exportExcel}},[_vm._m(3)])]):_vm._e()])]),_vm._v(" "),_vm._m(4)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"width":"100%"},attrs:{"id":"reportTable"}},[_c('thead',[_c('tr',[_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("วันที่เบิก/คืน/รับเข้า"),_c('br'),_vm._v("(ว/ด/ป)")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("Month")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("Year")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("เขต")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("สถานะ")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("จำนวน")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("ราคา:ชิ้น")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("มูลค่ารวม")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("ผู้ขอเบิก/คืน")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("ผู้ให้เบิก/คืน/รับเข้า")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("หมายเหตุ")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("เลขที่ใบเบิกสินค้า(รับเข้าอะไหล่)")])])])])])])}]


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHubRoute),expression:"isHubRoute"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"row"},_vm._l((_vm.cards),function(card){return _c('div',{key:card.path,staticClass:"col-xl-6 col-md-6 mb-4"},[_c('router-link',{staticClass:"monitoring-card-link",attrs:{"to":card.path}},[_c('div',{staticClass:"kt-portlet kt-portlet--height-fluid monitoring-card"},[_c('div',{staticClass:"kt-portlet__body text-center"},[_c('div',{staticClass:"monitoring-card-icon mb-3"},[_c('i',{class:card.icon})]),_vm._v(" "),_c('h4',{staticClass:"monitoring-card-title"},[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('p',{staticClass:"monitoring-card-desc text-muted mb-0"},[_vm._v(_vm._s(card.description))])])])])],1)}),0)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-chart-line"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("Monitoring")])])])}]


/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PM/PMCheckIn'),expression:"$route.path == '/PM/PMCheckIn'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chlKeyword),expression:"chlKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อ-สกุลผู้ Check-in"},domProps:{"value":(_vm.chlKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chlKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่ Check-in (เริ่มต้น) :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"chlCheckInDateFrom",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"วันที่ Check-in (วว/ดด/ปปปป)","id":"chlCheckInDateFrom","name":"chlCheckInDateFrom"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่ Check-in (สิ้นสุด) :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"chlCheckInDateTo",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"วันที่ Check-in (วว/ดด/ปปปป)","id":"chlCheckInDateTo","name":"chlCheckInDateTo"}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.pmrAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.pmrAgentCodes),callback:function ($$v) {_vm.pmrAgentCodes=$$v},expression:"pmrAgentCodes"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrShopCodes',"name":'pmrShopCodes',"select2-options":_vm.pmrShopCodesOptions,"multiple":""},model:{value:(_vm.pmrShopCodes),callback:function ($$v) {_vm.pmrShopCodes=$$v},expression:"pmrShopCodes"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin', 'ADMIN_PM'])),expression:"this.$root.canShow(['super_admin', 'ADMIN_PM'])"}],staticClass:"text-danger"},[_vm._v("\n                  *ควรเลือกตัวแทนจำหน่ายด้วย\n                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrSubAgentCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentCodes',"name":'pmrSubAgentCodes',"select2-options":_vm.pmrSubAgentCodeOptions,"multiple":""},model:{value:(_vm.pmrSubAgentCodes),callback:function ($$v) {_vm.pmrSubAgentCodes=$$v},expression:"pmrSubAgentCodes"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])),expression:"this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentShopCodes',"name":'pmrSubAgentShopCodes',"select2-options":_vm.pmrSubAgentShopCodesOptions,"multiple":""},model:{value:(_vm.pmrSubAgentShopCodes),callback:function ($$v) {_vm.pmrSubAgentShopCodes=$$v},expression:"pmrSubAgentShopCodes"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin', 'ADMIN_PM'])),expression:"this.$root.canShow(['super_admin', 'ADMIN_PM'])"}],staticClass:"text-danger"},[_vm._v("\n                  *ควรเลือกตัวแทนจำหน่ายย่อยด้วย\n                ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผลการดำเนินการ:")]),_vm._v(" "),_c('select2',{ref:"chlPMResultSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'chlPMResult',"name":'chlPMResult',"select2-options":_vm.chlPMResultOptions},model:{value:(_vm.chlPMResult),callback:function ($$v) {_vm.chlPMResult=$$v},expression:"chlPMResult"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","id":"btnSearch"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-2 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit","disabled":_vm.isExporting},on:{"click":_vm.exportData}},[_vm._m(3)])])])]),_vm._v(" "),_vm._m(4)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fas fa-search-location"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("ข้อมูล Check-in/out PM")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"checkInTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("วันที่"),_c('br'),_vm._v("Check-in/out")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("ชื่อรูท")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"20%"}},[_vm._v("ตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"20%"}},[_vm._v("ประเภทตัวแทนจำหน่าย ")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"20%"}},[_vm._v("ชื่อ-สกุลผู้ Check-in")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("ร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("ร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("ผลการดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"20%"}},[_vm._v("เหตุผล")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("บันทึก")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("รายละเอียดการจับชุดอุปกรณ์")])])])])])])}]


/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path != '/Machine/ManagePhase/Import'),expression:"$route.path != '/Machine/ManagePhase/Import'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MbKeyword),expression:"MbKeyword"}],staticClass:"form-control",attrs:{"id":"MbKeyword","name":"MbKeyword","type":"text","placeholder":"รหัสอ้างอิง เลขเฟส เลขล็อต รหัสสินค้า"},domProps:{"value":(_vm.MbKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MbKeyword=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['ADMIN_EQUIPMENT_LEASING']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManagePhase/Import","tag":"button","title":"เพิ่มข้อมูล Phase(Excel)"}},[_c('i',{staticClass:"fas fa-file-import"}),_vm._v(" Import\n              ")]):_vm._e(),_vm._v(" "),(this.$root.canShow(['ADMIN_EQUIPMENT_LEASING']))?_c('button',{staticClass:"btn btn-outline-brand",attrs:{"tag":"button","title":"ดาวน์โหลด Template Phase"},on:{"click":_vm.downloadTemplate}},[_c('i',{staticClass:"fas fa-download"}),_vm._v(" Template\n              ")]):_vm._e(),_vm._v(" "),(this.$root.canShow(['ADMIN_EQUIPMENT_LEASING']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManagePhase/DownloadPhase","tag":"button","title":"ดาวน์โหลด Phase"}},[_c('i',{staticClass:"fas fa-file-export"}),_vm._v(" Download\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-barcode"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"phaseTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("Phase")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("Lot")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("Material Code")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสอ้างอิง")])])])])])])}]


/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"agentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'agentCode',"name":'agentCode',"select2-options":_vm.agentCodeOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลปี :")]),_vm._v(" "),_c('select2',{ref:"year",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'year',"name":'year',"select2-options":_vm.yearOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)])]),_vm._v(" "),(_vm.year && _vm.canExportAllAgents && !_vm.isShow)?_c('div',{staticClass:"d-flex justify-content-end align-items-center mb-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n              "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.isShow == true)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              รายการจำนวนสินค้าที่ชำรุดเสียหายจำแนกตามมูลค่าสินค้า\n              :\n            ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingSelected},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelSelected($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)")+"\n                ")])]),_vm._v(" "),(_vm.canExportAllAgents)?_c('button',{staticClass:"btn btn-outline-primary ml-2",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"2500px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"3%"}},[_vm._v("\n                        ลำดับ\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"10%"}},[_vm._v("\n                        ประเภทสินค้า\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        ต้นทุนสินค้า(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"12","scope":"colgroup"}},[_vm._v("\n                        จำนวนสินค้าที่ชำรุดเสียหาย (จำนวน) ปี\n                        "+_vm._s(_vm.year)+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้ารวม(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้าเฉลี่ย(บาท/เดือน)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        จัดการ\n                      ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('tbody',{on:{"change":function($event){return _vm.changeTotal()}}},[(_vm.productitems == null || _vm.productitems.length == 0)?_c('tr',[(
                          this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])
                        )?_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"18"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.productitems),function(item,i){return [_c('product-item-row',{key:i,ref:"Items",refInFor:true,attrs:{"rowIndex":i,"item":item,"kPIProductType":_vm.kPIProductType,"yearSelected":_vm.year},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"3%"}}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รวมเงิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_vm._l((12),function(index){return _c('th',{key:index,staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalMonth[index]," ", 0))+"\n                      ")])}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalPoductCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalProductCostOfMonth,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th')],2),_vm._v(" "),_c('tr',[(
                          this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])
                        )?_c('td',{attrs:{"colspan":"18"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[(
          _vm.isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])
        )?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand fab fa-skyatlas"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มกราคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กุมภาพันธ์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มีนาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("เมษายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤษภาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มิถุนายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กรกฎาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("สิงหาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กันยายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ตุลาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤศจิกายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ธันวาคม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])}]


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.CheckRoute()),expression:"CheckRoute()"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n              "+_vm._s(this.$route.meta.breadcrumb)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.blKeyword),expression:"blKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจากชื่องบประมาณ โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ชื่องบประมาณ1, ชื่องบประมาณ2"},domProps:{"value":(_vm.blKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.blKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทงบประมาณ :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.blBudgetTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.blBudgetType),callback:function ($$v) {_vm.blBudgetType=$$v},expression:"blBudgetType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปี(งบประมาณ) :")]),_vm._v(" "),_c('select2',{ref:"BlYearSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'blYear',"name":'blYear',"select2-options":_vm.blYearOptions},model:{value:(_vm.blYear),callback:function ($$v) {_vm.blYear=$$v},expression:"blYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"BlStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'blStatus',"name":'blStatus',"select2-options":_vm.blStatusOptions},model:{value:(_vm.blStatus),callback:function ($$v) {_vm.blStatus=$$v},expression:"blStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                  ล้างค่าทั้งหมด\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['MANAGE_MASTER', 'MANAGE_BRAND']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManageBrand/Add","tag":"button","title":"เพิ่ม"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูลงบประมาณแบรนด์\n                ")]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER', 'MANAGE_BRAND']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManageBrand/Export","tag":"button","title":"Export"}},[_c('i',{staticClass:"fa fa-file-export"}),_vm._v(" Export\n                ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-money-check-alt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"brandTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("ชื่องบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทงบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ปี(งบประมาณ)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("งบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ใช้ไป")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("คงเหลือ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('select2',{ref:"odMaterialCodeSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"odMaterialCode","name":"odMaterialCode","select2-options":_vm.odMaterialCodeOptions},on:{"selectChange":_vm.onMaterialCodeChange},model:{value:(_vm.odMaterialCode),callback:function ($$v) {_vm.odMaterialCode=$$v},expression:"odMaterialCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เจ้าของทรัพย์สิน :")]),_vm._v(" "),_c('select2',{ref:"mbAssetOwnerIdSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"mbAssetOwnerId","name":"mbAssetOwnerId","select2-options":_vm.MbAssetOwnerOptions},on:{"selectChange":_vm.onMbAssetOwnerIdChange},model:{value:(_vm.mbAssetOwnerId),callback:function ($$v) {_vm.mbAssetOwnerId=$$v},expression:"mbAssetOwnerId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ปี(สินค้า) (ค.ศ.) :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"odYear",staticClass:"form-control",attrs:{"type":"text","placeholder":"(YYYY)","id":"odYear","name":"odYear","autocomplete":"off"}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odPrice),expression:"odPrice"}],staticClass:"form-control",attrs:{"id":"odPrice","name":"odPrice","type":"number","min":"0.00","placeholder":"บาท"},domProps:{"value":(_vm.odPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.odPrice=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่บันทึก:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"odEffectiveDateFrom",staticClass:"form-control",staticStyle:{"background-color":"#EEEEEE"},attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"odEffectiveDateFrom","name":"odEffectiveDateFrom"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.odInActiveStatus),expression:"odInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"odInActiveStatus","name":"odInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.odInActiveStatus)?_vm._i(_vm.odInActiveStatus,null)>-1:(_vm.odInActiveStatus)},on:{"change":function($event){var $$a=_vm.odInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.odInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.odInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.odInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(3)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label-required"},[_vm._v("ราคาค่าถัง ("),_c('span',{staticClass:"text-danger"},[_vm._v("* ราคาใช้สำหรับรายงานคงค้างเกินกำหนด")]),_vm._v(") :")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/CompanyProfile'),expression:"$route.path == '/Master/CompanyProfile'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cplKeyword),expression:"cplKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อโปรไฟล์ ชื่อคลัง ชื่อตัวแทนจำหน่าย ชื่อร้านค้า โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ"},domProps:{"value":(_vm.cplKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cplKeyword=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"cplAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'cplAgentCode',"name":'cplAgentCode',"select2-options":_vm.cplAgentCodeOptions},model:{value:(_vm.cplAgentCode),callback:function ($$v) {_vm.cplAgentCode=$$v},expression:"cplAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทโปรไฟล์บริษัท:")]),_vm._v(" "),_c('select2',{ref:"cplProfileTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'cplProfileTypeCode',"name":'cplProfileTypeCode',"select2-options":_vm.cplProfileTypeCodeOptions},model:{value:(_vm.cplProfileTypeCode),callback:function ($$v) {_vm.cplProfileTypeCode=$$v},expression:"cplProfileTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"cplInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'cplInActiveStatus',"name":'cplInActiveStatus',"select2-options":_vm.cplInActiveStatusOptions},model:{value:(_vm.cplInActiveStatus),callback:function ($$v) {_vm.cplInActiveStatus=$$v},expression:"cplInActiveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(
                  this.$root.canShow([
                    'MANAGE_MASTER',
                    'MANAGE_COMPANY_PROFILE' ])
                )?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"CompanyProfile/Add","tag":"button","title":"เพิ่มข้อมูลโปรไฟล์บริษัท"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูลโปรไฟล์บริษัท\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fab fa-product-hunt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"custProfileTable"}},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อโปรไฟล์บริษัท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทโปรไฟล์บริษัท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("บริษัท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scvd-dashboard"},[_c('div',{staticClass:"scvd-container"},[_c('div',{staticClass:"scvd-header"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"meta"},[_c('div',[_vm._v("อัปเดตล่าสุด: "+_vm._s(_vm.dashboard ? _vm.dashboard.currentDate : '—'))]),_vm._v(" "),(!(_vm.dashboard && _vm.dashboard.isClosed))?_c('div',{staticClass:"sync-status"},[_c('span',{staticClass:"sync-dot"}),_vm._v(" ข้อมูล ณ ปัจจุบัน")]):_c('div',{staticClass:"scvd-frozen-badge",staticStyle:{"display":"inline-block","background":"#e0e7ff","color":"#3730a3","border":"1px solid #c7d2fe","padding":"2px 10px","border-radius":"20px","font-size":"11.5px","font-weight":"700"}},[_vm._v("\n            🔒 ปิดรอบแล้ว — ข้อมูลถูกแช่แข็ง (frozen)\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"setup-collapsed"},[_c('div',{staticClass:"criteria-summary"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("⚙️ เกณฑ์:")]),_vm._v(" "),(_vm.criteriaLevels.length)?_vm._l((_vm.criteriaLevels),function(lv){return _c('span',{key:'crit-' + lv.order,staticClass:"criteria-badge",style:({ background: lv.colorHex, color: _vm.textColor(lv.colorHex) })},[_vm._v(_vm._s(_vm.badgeLabel(lv)))])}):_c('span',{staticClass:"text-muted",staticStyle:{"font-size":"12px"}},[_vm._v("กำลังโหลดเกณฑ์...")]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"12px","color":"#cbd5e1"}},[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"target-badge"},[_vm._v("🎯 Target SCVD (จำลอง): "+_vm._s(_vm.criteria ? _vm.criteria.targetScvd : '-')+" วัน")])],2),_vm._v(" "),_c('button',{staticClass:"btn-edit",on:{"click":_vm.openSetup}},[_vm._v("⚙️ แก้ไขเกณฑ์")])]),_vm._v(" "),_c('div',{staticClass:"filter-bar"},[_c('div',{staticClass:"filter-group"},[_c('label',[_vm._v("เดือน")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filterMonth),expression:"filterMonth",modifiers:{"number":true}}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.filterMonth=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.monthOptions),function(m){return _c('option',{key:'mo-' + m.value,domProps:{"value":m.value}},[_vm._v(_vm._s(m.text))])}),0)]),_vm._v(" "),_c('div',{staticClass:"filter-group"},[_c('label',[_vm._v("ปี")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filterYear),expression:"filterYear",modifiers:{"number":true}}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.filterYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.yearOptions),function(y){return _c('option',{key:'yr-' + y,domProps:{"value":y}},[_vm._v(_vm._s(y))])}),0)]),_vm._v(" "),_c('div',{staticClass:"filter-group",staticStyle:{"min-width":"190px"}},[_c('label',[_vm._v("คลัง")]),_vm._v(" "),_c('select2',{ref:"dbPlantCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'dbPlantCodes',"name":'dbPlantCodes',"select2-options":_vm.plantOptions,"multiple":""},model:{value:(_vm.filterPlantCodes),callback:function ($$v) {_vm.filterPlantCodes=$$v},expression:"filterPlantCodes"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-group",staticStyle:{"min-width":"210px"}},[_c('label',[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('select2',{ref:"dbProductCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'dbProductCodes',"name":'dbProductCodes',"select2-options":_vm.productOptions,"multiple":""},model:{value:(_vm.filterProductCodes),callback:function ($$v) {_vm.filterProductCodes=$$v},expression:"filterProductCodes"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-group",staticStyle:{"min-width":"170px"}},[_c('label',[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('select2',{ref:"dbBrandIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'dbBrandId',"name":'dbBrandId',"select2-options":_vm.brandOptions,"multiple":""},model:{value:(_vm.filterBrandIds),callback:function ($$v) {_vm.filterBrandIds=$$v},expression:"filterBrandIds"}})],1),_vm._v(" "),_c('button',{staticClass:"btn-formula",on:{"click":_vm.openFormula}},[_vm._v("📐 สูตรคำนวณ")])]),_vm._v(" "),_c('div',{staticClass:"active-filter-strip"},[_c('span',{staticClass:"filter-strip-label"},[_vm._v("🎯 กำลังดูข้อมูล:")]),_vm._v(" "),_c('span',{staticClass:"filter-chip"},[_vm._v("เดือน: "),_c('strong',[_vm._v(_vm._s(_vm.monthName)+" "+_vm._s(_vm.filterYear))])]),_vm._v(" "),_c('span',{staticClass:"filter-chip"},[_vm._v("\n          คลัง: "),_c('strong',[_vm._v(_vm._s(_vm.filterPlantCodes.length ? (_vm.filterPlantCodes.length + ' คลัง') : 'ทั้งหมด'))]),_vm._v(" "),(_vm.filterPlantCodes.length)?_c('span',{staticClass:"remove-chip",on:{"click":function($event){return _vm.removeFilter('plant')}}},[_vm._v("×")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"filter-chip"},[_vm._v("\n          สินค้า: "),_c('strong',[_vm._v(_vm._s(_vm.productChipText))]),_vm._v(" "),(_vm.filterProductCodes.length)?_c('span',{staticClass:"remove-chip",on:{"click":function($event){return _vm.removeFilter('product')}}},[_vm._v("×")]):_vm._e()]),_vm._v(" "),(_vm.filterBrandIds.length)?_c('span',{staticClass:"filter-chip"},[_vm._v("\n          แบรนด์: "),_c('strong',[_vm._v(_vm._s(_vm.filterBrandIds.length)+" แบรนด์")]),_vm._v(" "),_c('span',{staticClass:"remove-chip",on:{"click":function($event){return _vm.removeFilter('brand')}}},[_vm._v("×")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn-clear-filter",on:{"click":_vm.clearFilters}},[_vm._v("↺ ล้างตัวกรอง")])]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"scvd-loading"},[_c('div',{staticClass:"kt-spinner kt-spinner--lg kt-spinner--brand"}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v("กำลังโหลดข้อมูล...")])]):(_vm.dashboard)?_c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"row-2col"},[_c('div',{staticClass:"widget"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"alert-summary"},[_c('div',{staticClass:"alert-summary-item",style:({ background: _vm.tint(_vm.dashboard.urgent.tier1.colorHex, 0.9), borderLeft: '3px solid ' + _vm.dashboard.urgent.tier1.colorHex })},[_c('div',{staticClass:"alert-summary-top"},[_c('div',[_c('div',{staticClass:"alert-summary-count-row"},[_c('span',{staticClass:"alert-summary-count"},[_vm._v(_vm._s(_vm.dashboard.urgent.tier1Count))]),_vm._v(" "),_c('span',{staticClass:"alert-summary-unit"},[_vm._v("SKU")])]),_vm._v(" "),_c('div',{staticClass:"alert-summary-desc"},[_vm._v("ต้องผลิตด่วนที่สุด")])]),_vm._v(" "),_c('div',{staticClass:"alert-summary-label"},[_c('span',{staticClass:"status-swatch",style:({ background: _vm.dashboard.urgent.tier1.colorHex })}),_vm._v(_vm._s(_vm.dashboard.urgent.tier1.name)),_c('br'),_vm._v("("+_vm._s(_vm.rangeForOrder(_vm.dashboard.urgent.tier1.order))+")\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"alert-summary-guidance",style:({ color: _vm.darken(_vm.dashboard.urgent.tier1.colorHex, 0.5) })},[_vm._v("\n                  ⚠️ "+_vm._s(_vm.dashboard.urgent.tier1.actionText)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"alert-summary-item",style:({ background: _vm.tint(_vm.dashboard.urgent.tier2.colorHex, 0.9), borderLeft: '3px solid ' + _vm.dashboard.urgent.tier2.colorHex })},[_c('div',{staticClass:"alert-summary-top"},[_c('div',[_c('div',{staticClass:"alert-summary-count-row"},[_c('span',{staticClass:"alert-summary-count"},[_vm._v(_vm._s(_vm.dashboard.urgent.tier2Count))]),_vm._v(" "),_c('span',{staticClass:"alert-summary-unit"},[_vm._v("SKU")])]),_vm._v(" "),_c('div',{staticClass:"alert-summary-desc"},[_vm._v("ควรวางแผนผลิต")])]),_vm._v(" "),_c('div',{staticClass:"alert-summary-label"},[_c('span',{staticClass:"status-swatch",style:({ background: _vm.dashboard.urgent.tier2.colorHex })}),_vm._v(_vm._s(_vm.dashboard.urgent.tier2.name)),_c('br'),_vm._v("("+_vm._s(_vm.rangeForOrder(_vm.dashboard.urgent.tier2.order))+")\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"alert-summary-guidance",style:({ color: _vm.darken(_vm.dashboard.urgent.tier2.colorHex, 0.5) })},[_vm._v("\n                  📦 "+_vm._s(_vm.dashboard.urgent.tier2.actionText)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"alert-grid"},[_c('div',{staticClass:"alert-column"},[(_vm.dashboard.urgent.tier1.cards.length)?_vm._l((_vm.dashboard.urgent.tier1.cards),function(card,ci){return _c('div',{key:'t1-' + ci,staticClass:"alert-card",style:({ borderLeftColor: card.colorHex }),on:{"click":function($event){return _vm.cardClick(card)}}},[_c('div',{staticClass:"alert-card-top"},[_c('span',{staticClass:"alert-top-left"},[_c('span',{staticClass:"alert-status",style:({ background: _vm.tint(card.colorHex, 0.8), color: _vm.darken(card.colorHex, 0.35) })},[_c('span',{staticClass:"status-swatch",style:({ background: card.colorHex })}),_vm._v(_vm._s(_vm.dashboard.urgent.tier1.name))])]),_vm._v(" "),_c('span',{staticClass:"alert-trend",class:_vm.trendInfo(card).cls},[_vm._v(_vm._s(_vm.trendInfo(card).text))])]),_vm._v(" "),_c('div',{staticClass:"alert-sku"},[_vm._v("🍺 "+_vm._s(card.productName))]),_vm._v(" "),_c('div',{staticClass:"alert-warehouse"},[_vm._v("🏭 "+_vm._s(card.plantName))]),_vm._v(" "),_c('div',{staticClass:"alert-metric-row"},[_c('div',{staticClass:"alert-metric-left"},[_c('span',{staticClass:"alert-value",style:({ color: _vm.darken(card.colorHex, 0.35) })},[_vm._v(_vm._s(_vm.scvdDisplay(card.scvd)))]),_vm._v(" "),_c('span',{staticClass:"alert-unit"},[_vm._v("วัน")]),_vm._v(" "),_c('span',{staticClass:"alert-metric-label"},[_vm._v("SCVD ปัจจุบัน")])]),_vm._v(" "),_c('div',{staticClass:"alert-target"},[_c('span',{staticClass:"alert-target-src"},[_vm._v("— จากข้อมูลตามหน้างานจริง —")]),_c('br'),_vm._v("\n                        Demand "+_vm._s(_vm.fmt(card.demandPerDayLitre))+" L ("+_vm._s(_vm.fmt(card.demandPerDayKeg))+" ถัง)/วัน"),_c('br'),_vm._v("\n                        Supply "+_vm._s(_vm.fmt(card.supplyPerDayLitre))+" L ("+_vm._s(_vm.fmt(card.supplyPerDayKeg))+" ถัง)/วัน\n                      ")])])])}):_c('div',{staticClass:"alert-empty-state"},[_c('span',{staticClass:"empty-emoji"},[_vm._v("✅")]),_vm._v(" "),_c('span',[_vm._v("ไม่มีสินค้าในสถานะนี้")])])],2),_vm._v(" "),_c('div',{staticClass:"alert-column"},[(_vm.dashboard.urgent.tier2.cards.length)?_vm._l((_vm.dashboard.urgent.tier2.cards),function(card,ci){return _c('div',{key:'t2-' + ci,staticClass:"alert-card",style:({ borderLeftColor: card.colorHex }),on:{"click":function($event){return _vm.cardClick(card)}}},[_c('div',{staticClass:"alert-card-top"},[_c('span',{staticClass:"alert-status",style:({ background: _vm.tint(card.colorHex, 0.8), color: _vm.darken(card.colorHex, 0.35) })},[_c('span',{staticClass:"status-swatch",style:({ background: card.colorHex })}),_vm._v(_vm._s(_vm.dashboard.urgent.tier2.name))]),_vm._v(" "),_c('span',{staticClass:"alert-trend",class:_vm.trendInfo(card).cls},[_vm._v(_vm._s(_vm.trendInfo(card).text))])]),_vm._v(" "),_c('div',{staticClass:"alert-sku"},[_vm._v("🍺 "+_vm._s(card.productName))]),_vm._v(" "),_c('div',{staticClass:"alert-warehouse"},[_vm._v("🏭 "+_vm._s(card.plantName))]),_vm._v(" "),_c('div',{staticClass:"alert-metric-row"},[_c('div',{staticClass:"alert-metric-left"},[_c('span',{staticClass:"alert-value",style:({ color: _vm.darken(card.colorHex, 0.35) })},[_vm._v(_vm._s(_vm.scvdDisplay(card.scvd)))]),_vm._v(" "),_c('span',{staticClass:"alert-unit"},[_vm._v("วัน")]),_vm._v(" "),_c('span',{staticClass:"alert-metric-label"},[_vm._v("SCVD ปัจจุบัน")])]),_vm._v(" "),_c('div',{staticClass:"alert-target"},[_c('span',{staticClass:"alert-target-src"},[_vm._v("— จากข้อมูลตามหน้างานจริง —")]),_c('br'),_vm._v("\n                        Demand "+_vm._s(_vm.fmt(card.demandPerDayLitre))+" L ("+_vm._s(_vm.fmt(card.demandPerDayKeg))+" ถัง)/วัน"),_c('br'),_vm._v("\n                        Supply "+_vm._s(_vm.fmt(card.supplyPerDayLitre))+" L ("+_vm._s(_vm.fmt(card.supplyPerDayKeg))+" ถัง)/วัน\n                      ")])])])}):_c('div',{staticClass:"alert-empty-state"},[_c('span',{staticClass:"empty-emoji"},[_vm._v("✅")]),_vm._v(" "),_c('span',[_vm._v("ไม่มีสินค้าในสถานะนี้")])])],2)])]),_vm._v(" "),_c('div',{staticClass:"widget"},[_c('div',{staticClass:"widget-header"},[_c('div',{staticClass:"widget-title"},[_vm._v("🥧 สัดส่วนสถานะสต็อก "+_vm._s(_vm.dashboard.pie.slices.length)+" ระดับ")]),_vm._v(" "),_c('div',{staticClass:"widget-hint"},[_vm._v("💡 คลิกวง → เจาะลึก สถานะ → คลัง → สินค้า")])]),_vm._v(" "),_c('div',{staticClass:"pie-drill-bar"},[_c('span',{staticClass:"pie-crumbs"},[_vm._l((_vm.pieBreadcrumb),function(c,ci){return [_c('span',{key:'crumb-' + ci,staticClass:"pie-crumb",class:{ active: ci === _vm.pieBreadcrumb.length - 1 },on:{"click":function($event){return _vm.drillToLevel(c.level)}}},[_vm._v(_vm._s(c.label))]),(ci < _vm.pieBreadcrumb.length - 1)?_c('span',{key:'sep-' + ci,staticClass:"pie-crumb-sep"},[_vm._v("›")]):_vm._e()]})],2),_vm._v(" "),(_vm.pieDrill.level > 1)?_c('button',{staticClass:"pie-back-btn",on:{"click":_vm.drillUp}},[_vm._v("↩ ย้อนกลับ")]):_vm._e()]),_vm._v(" "),(_vm.pieDrill.level < 3)?_c('div',{staticClass:"pie-container"},[_c('svg',{staticClass:"pie-svg",attrs:{"width":"600","height":"600","viewBox":"-12 -8 68 60","preserveAspectRatio":"xMidYMid meet"}},[_c('circle',{style:({ cursor: _vm.pieDrill.level > 1 ? 'pointer' : 'default' }),attrs:{"cx":"21","cy":"21","r":"15.915","fill":"#ffffff"},on:{"click":_vm.drillUp}}),_vm._v(" "),_vm._l((_vm.pieSegments),function(seg,si){return _c('g',{key:'seg-' + si,staticClass:"pie-slice-clickable",style:({ cursor: seg.drillable ? 'pointer' : 'default' }),on:{"click":function($event){return _vm.drillInto(seg.index)}}},[_c('circle',{attrs:{"cx":"21","cy":"21","r":"15.915","fill":"transparent","stroke":seg.colorHex,"stroke-width":"10","stroke-dasharray":seg.dash,"stroke-dashoffset":seg.offset,"transform":"rotate(-90 21 21)","pointer-events":"visibleStroke"}}),_vm._v(" "),(seg.showLabel)?_c('line',{attrs:{"x1":seg.lineX1,"y1":seg.lineY1,"x2":seg.lineX2,"y2":seg.lineY2,"stroke":seg.labelColor,"stroke-width":"0.4","pointer-events":"none"}}):_vm._e(),_vm._v(" "),(seg.showLabel)?_c('text',{attrs:{"x":seg.lx,"y":seg.ly,"font-size":"3.2","font-weight":"bold","fill":seg.labelColor,"text-anchor":seg.anchor,"dominant-baseline":"middle","pointer-events":"none"}},[_vm._v(_vm._s(seg.pct)+"%")]):_vm._e(),_vm._v(" "),(seg.showLabel)?_c('text',{attrs:{"x":seg.lx,"y":seg.nameY,"font-size":"1.6","font-weight":"600","fill":seg.labelColor,"text-anchor":seg.anchor,"pointer-events":"none"}},[_vm._v(_vm._s(seg.name))]):_vm._e()])})],2),_vm._v(" "),_c('div',{staticClass:"pie-legend"},_vm._l((_vm.pieViewSlices),function(sl,li){return _c('div',{key:'leg-' + li,staticClass:"pie-legend-item",class:{ clickable: sl.drillable },on:{"click":function($event){return _vm.drillInto(li)}}},[_c('span',{staticClass:"pie-color-box",style:({ background: sl.colorHex })}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.formatPct(sl.percent))+"%")]),_vm._v(" "),_c('span',{staticClass:"pie-legend-item-desc"},[_vm._v(_vm._s(sl.name)+" · "+_vm._s(sl.count)+" SKU"),(sl.drillable)?_c('span',{staticClass:"pie-legend-drill"},[_vm._v(" ▸")]):_vm._e()])])}),0),_vm._v(" "),(_vm.pieDrill.level === 1 && _vm.dashboard.pie.noDataSku > 0)?_c('div',{staticClass:"pie-nodata-note"},[_vm._v("\n                * "+_vm._s(_vm.dashboard.pie.noDataSku)+" SKU ไม่มีข้อมูล (ไม่นับเข้าสัดส่วน)\n              ")]):_vm._e()]):_c('div',{staticClass:"pie-l3",staticStyle:{"padding":"6px 2px 2px"}},[_c('div',{staticStyle:{"font-size":"12px","color":"#374151","margin-bottom":"6px"}},[_vm._v("\n                🎯 "),_c('b',[_vm._v(_vm._s(_vm.pieDrillStatusName))]),_vm._v(" · 📍 "),_c('b',[_vm._v(_vm._s(_vm.pieDrillPlantName))]),_vm._v(" · "),_c('b',[_vm._v(_vm._s(_vm.pieLevel3Rows.length)+" SKU")])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%","border-collapse":"collapse","font-size":"12px"}},[_vm._m(2),_vm._v(" "),_c('tbody',[(!_vm.pieLevel3Rows.length)?_c('tr',[_c('td',{staticStyle:{"text-align":"center","color":"#9ca3af","padding":"20px"},attrs:{"colspan":"2"}},[_vm._v("ไม่มีสินค้าในสถานะนี้")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.pieLevel3Rows),function(row,ri){return _c('tr',{key:'l3-' + ri,staticStyle:{"border-bottom":"1px solid #f3f4f6"}},[_c('td',{staticStyle:{"padding":"6px 4px"}},[_vm._v("🍺 "+_vm._s(row.name))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"6px 4px","text-align":"right","font-weight":"700"},style:({ color: _vm.pieDrillStatusColor })},[_vm._v(_vm._s(_vm.pieScvdText(row.scvd)))])])})],2)]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"11px","color":"#9ca3af","margin-top":"6px"}},[_vm._v("📊 เรียง SCVD น้อย → มาก (วิกฤตสุดขึ้นก่อน)")])])])]),_vm._v(" "),_c('div',{staticClass:"widget"},[_c('div',{staticClass:"widget-header bullet-header-wrap"},[_c('div',{staticClass:"widget-title"},[_vm._v("📊 การเทียบข้อมูลตามหน้างานจริง vs ข้อมูลตามเป้าหมาย vs Target SCVD (จำลอง)")]),_vm._v(" "),_c('div',{staticClass:"bullet-toolbar"},[_c('span',{staticClass:"widget-hint"},[_vm._v("💡 คลิกแถว → กรองข้อมูลทั้งหน้าเป็น SKU นั้น")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bulletPlant),expression:"bulletPlant"}],staticClass:"form-control form-control-sm bullet-sort",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.bulletPlant=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.loadDashboard]}},[_c('option',{attrs:{"value":""}},[_vm._v("คลัง: ทั้งหมด")]),_vm._v(" "),_vm._l((_vm.bulletPlantOptions),function(bp){return _c('option',{key:'bp-' + bp.code,domProps:{"value":bp.code}},[_vm._v("คลัง: "+_vm._s(bp.name))])})],2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bulletSort),expression:"bulletSort"}],staticClass:"form-control form-control-sm bullet-sort",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.bulletSort=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.loadDashboard]}},[_c('option',{attrs:{"value":"asc"}},[_vm._v("เรียง: วิกฤตสุด → ล้นสุด")]),_vm._v(" "),_c('option',{attrs:{"value":"desc"}},[_vm._v("เรียง: ล้นสุด → วิกฤตสุด")])])])]),_vm._v(" "),(!_vm.dashboard.bullet.length)?_c('div',{staticClass:"scvd-empty-block"},[_vm._v("ไม่พบข้อมูลสำหรับกราฟเทียบเป้าหมาย")]):_vm._e(),_vm._v(" "),_vm._l((_vm.bulletByPlant),function(grp,gi){return _c('div',{key:'bwh-' + gi,staticClass:"bullet-warehouse"},[_c('div',{staticClass:"bullet-warehouse-title"},[_c('span',[_vm._v("🏭 "+_vm._s(grp.plantName)+" — "+_vm._s(_vm.monthName)+" "+_vm._s(_vm.filterYear))])]),_vm._v(" "),_vm._l((grp.items),function(item,ii){return _c('div',{key:'brow-' + gi + '-' + ii,staticClass:"bullet-row",on:{"click":function($event){return _vm.cardClick(item)}}},[_c('div',{staticClass:"bullet-header"},[_c('div',{staticClass:"bullet-sku-info"},[_c('span',{staticClass:"bullet-sku"},[_vm._v("🍺 "+_vm._s(item.productName))]),_vm._v(" "),_c('span',{staticClass:"bullet-badge",style:({ background: _vm.tint(item.colorHex, 0.8), color: _vm.darken(item.colorHex, 0.35) })},[_c('span',{staticClass:"status-swatch",style:({ background: item.colorHex })}),_vm._v(_vm._s(_vm.tierName(item.actualScvd)))])]),_vm._v(" "),_c('div',{staticClass:"bullet-demand"},[_vm._v("\n                  Demand: "),_c('strong',[_vm._v(_vm._s(_vm.fmt(item.demandPerDayLitre))+" L ("+_vm._s(_vm.fmt(item.demandPerDayKeg))+" ถัง)/วัน")]),_vm._v(" "),(_vm.stockText(item))?_c('span',[_vm._v(" · Stock ปัจจุบัน: "),_c('strong',[_vm._v(_vm._s(_vm.stockText(item)))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"bullet-chart-wrapper"},[_c('div',{staticClass:"bullet-chart"},[_vm._l((_vm.bulletZones),function(z,zi){return _c('div',{key:'z-' + gi + '-' + ii + '-' + zi,staticClass:"bullet-zone",style:({ width: z.widthPct + '%', background: _vm.tint(z.colorHex, 0.55) })},[_vm._v(_vm._s(z.label))])}),_vm._v(" "),(_vm.bulletPos(item.actualScvd) !== null)?[_c('div',{staticClass:"bullet-actual",style:({ width: _vm.bulletPos(item.actualScvd) + '%' })}),_vm._v(" "),_c('div',{staticClass:"bullet-marker-label actual",style:({ left: _vm.bulletPos(item.actualScvd) + '%' })},[_vm._v("▼ ตามหน้างานจริง "+_vm._s(_vm.scvdDisplay(item.actualScvd))+" วัน")])]:_vm._e(),_vm._v(" "),(_vm.bulletPos(item.targetScvd) !== null)?[_c('div',{staticClass:"bullet-marker target-master",style:({ left: _vm.bulletPos(item.targetScvd) + '%' })}),_vm._v(" "),_c('div',{staticClass:"bullet-marker-label target-master",style:({ left: _vm.bulletPos(item.targetScvd) + '%' })},[_vm._v("▼ ตามเป้าหมาย "+_vm._s(_vm.scvdDisplay(item.targetScvd))+" วัน")])]:_vm._e(),_vm._v(" "),(_vm.bulletPos(item.targetSimScvd) !== null)?[_c('div',{staticClass:"bullet-marker target-scvd",style:({ left: _vm.bulletPos(item.targetSimScvd) + '%' })}),_vm._v(" "),_c('div',{staticClass:"bullet-marker-label target-scvd",style:({ left: _vm.bulletPos(item.targetSimScvd) + '%' })},[_vm._v("▼ Target SCVD (จำลอง) "+_vm._s(_vm.scvdDisplay(item.targetSimScvd))+" วัน")])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"bullet-gap-box",style:({ borderLeftColor: item.colorHex, background: _vm.tint(item.colorHex, 0.94) })},[_vm._m(3,true),_vm._v(" "),_vm._l((_vm.gapRows(item)),function(row){return _c('div',{key:'gap-' + gi + '-' + ii + '-' + row.num,staticClass:"bullet-gap-row"},[_c('span',{staticClass:"bullet-gap-label"},[_c('span',{staticClass:"gap-num"},[_vm._v(_vm._s(row.num))]),_vm._v(" "),_c('span',{class:row.fromCls},[_vm._v(_vm._s(row.fromText))]),_vm._v(" →\n                    "),_c('span',{class:row.toCls},[_vm._v(_vm._s(row.toText))])]),_vm._v(" "),_c('span',{staticClass:"bullet-gap-value",class:row.gap.cls},[_vm._v(_vm._s(row.gap.text))])])})],2)])})],2)})],2),_vm._v(" "),_c('div',{staticClass:"widget"},[_vm._m(4),_vm._v(" "),(!_vm.dashboard.heatmap.length)?_c('div',{staticClass:"scvd-empty-block"},[_vm._v("ไม่พบข้อมูล heatmap")]):_vm._e(),_vm._v(" "),_vm._l((_vm.dashboard.heatmap),function(plant,pi){return _c('div',{key:'hm-' + pi,staticClass:"heatmap-warehouse"},[_c('div',{staticClass:"heatmap-warehouse-title"},[_c('span',[_vm._v("🏭 "+_vm._s(plant.plantName))]),_vm._v(" "),_c('span',{staticClass:"heatmap-warehouse-meta"},[_vm._v("\n                "+_vm._s(plant.rows.length)+" SKU ·\n                Demand รวม "+_vm._s(_vm.fmt(plant.demandTotalLitre))+" L ("+_vm._s(_vm.fmt(plant.demandTotalKeg))+" ถัง)/วัน ·\n                Supply รวม "+_vm._s(_vm.fmt(plant.supplyTotalLitre))+" L ("+_vm._s(_vm.fmt(plant.supplyTotalKeg))+" ถัง)/วัน\n              ")])]),_vm._v(" "),_c('div',{staticClass:"heatmap-scroll"},[_c('table',{staticClass:"heatmap-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"sku-header"},[_vm._v("SKU")]),_vm._v(" "),_vm._l((_vm.monthShort),function(mlbl,mi){return _c('th',{key:'hmh-' + pi + '-' + mi,class:{ 'current-month': mi === _vm.currentMonthIndex }},[_vm._v(_vm._s(mlbl))])})],2)]),_vm._v(" "),_c('tbody',_vm._l((plant.rows),function(row,ri){return _c('tr',{key:'hmr-' + pi + '-' + ri},[_c('td',{staticClass:"heatmap-sku-cell"},[_vm._v("🍺 "+_vm._s(row.productName))]),_vm._v(" "),_vm._l((row.months),function(cell,mi){return _c('td',{key:'hmc-' + pi + '-' + ri + '-' + mi,staticClass:"heatmap-cell",class:{ 'current-col': cell.isCurrentMonth },style:(_vm.cellStyle(cell)),on:{"click":function($event){return _vm.cellClick(row, cell)}}},[_vm._v(_vm._s(_vm.scvdDisplay(cell.scvd)))])})],2)}),0)])])])}),_vm._v(" "),_c('div',{staticClass:"heatmap-legend"},[_vm._l((_vm.criteriaLevels),function(lv){return _c('div',{key:'hleg-' + lv.order,staticClass:"heatmap-legend-item"},[_c('span',{staticClass:"heatmap-legend-swatch",style:({ background: lv.colorHex })}),_vm._v(_vm._s(_vm.badgeLabel(lv))+" วัน\n            ")])}),_vm._v(" "),_vm._m(5)],2)],2)]):_c('div',{staticClass:"scvd-empty-block",staticStyle:{"margin":"30px"}},[_vm._v("ไม่พบข้อมูล — กรุณาปรับตัวกรอง")]),_vm._v(" "),(_vm.showFormulaModal)?_c('div',{staticClass:"scvd-modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.showFormulaModal = false}}},[_c('div',{staticClass:"scvd-modal"},[_c('div',{staticClass:"scvd-modal-header"},[_vm._m(6),_vm._v(" "),_c('button',{staticClass:"scvd-modal-close",on:{"click":function($event){_vm.showFormulaModal = false}}},[_vm._v("✕")])]),_vm._v(" "),_c('div',{staticClass:"scvd-modal-body"},[_c('div',{staticClass:"modal-toc"},[_c('div',{staticClass:"modal-toc-title"},[_vm._v("📌 สารบัญ (คลิกเพื่อกระโดดไปยังหัวข้อ)")]),_vm._v(" "),_c('div',{staticClass:"modal-toc-list"},[_c('a',{staticClass:"modal-toc-item",attrs:{"href":"#widget-alert"},on:{"click":function($event){$event.preventDefault();return _vm.scrollToWidget('widget-alert')}}},[_vm._v("🚨 สินค้าที่ต้องดำเนินการเร่งด่วน")]),_vm._v(" "),_c('a',{staticClass:"modal-toc-item",attrs:{"href":"#widget-pie"},on:{"click":function($event){$event.preventDefault();return _vm.scrollToWidget('widget-pie')}}},[_vm._v("🥧 สัดส่วนสถานะสต็อก 5 ระดับ")]),_vm._v(" "),_c('a',{staticClass:"modal-toc-item",attrs:{"href":"#widget-bullet"},on:{"click":function($event){$event.preventDefault();return _vm.scrollToWidget('widget-bullet')}}},[_vm._v("📊 การเทียบข้อมูล... (Bullet Chart)")]),_vm._v(" "),_c('a',{staticClass:"modal-toc-item",attrs:{"href":"#widget-heatmap"},on:{"click":function($event){$event.preventDefault();return _vm.scrollToWidget('widget-heatmap')}}},[_vm._v("🌡️ ตารางสถานะสต๊อก 12 เดือน")]),_vm._v(" "),_c('a',{staticClass:"modal-toc-item",staticStyle:{"grid-column":"1/-1"},attrs:{"href":"#widget-common"},on:{"click":function($event){$event.preventDefault();return _vm.scrollToWidget('widget-common')}}},[_vm._v("⚙️ หลักการคำนวณกลาง (ใช้ทุกกล่อง)")])])]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)])])]):_vm._e(),_vm._v(" "),(_vm.showSetupModal)?_c('div',{staticClass:"scvd-modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.showSetupModal = false}}},[_c('div',{staticClass:"scvd-modal"},[_c('div',{staticClass:"scvd-modal-header"},[_vm._m(12),_vm._v(" "),_c('button',{staticClass:"scvd-modal-close",on:{"click":function($event){_vm.showSetupModal = false}}},[_vm._v("✕")])]),_vm._v(" "),_c('div',{staticClass:"setup-modal-body"},[_c('div',{staticClass:"setup-info-bar"},[_vm._v("💡 เกณฑ์นี้กำหนดสีของสถานะสต็อกในทุกกราฟและตาราง — กำหนดได้ 3-6 ระดับ")]),_vm._v(" "),_c('div',{staticClass:"setup-warning-bar"},[_vm._v("⚠️ \"บันทึกตั้งเป็นค่าเริ่มต้น 🔒\" มีผลกับผู้ใช้ทุกคนในบริษัท (เฉพาะแอดมิน Stock Cover Days เท่านั้น)")]),_vm._v(" "),(_vm.editLoading)?_c('div',{staticClass:"text-center",staticStyle:{"padding":"40px"}},[_c('div',{staticClass:"kt-spinner kt-spinner--lg kt-spinner--brand"})]):_c('div',{staticClass:"setup-section"},[_c('div',{staticClass:"setup-section-title"},[_vm._v("📊 กำหนดระดับสถานะและแนวทางแก้ไข")]),_vm._v(" "),_c('table',{staticClass:"threshold"},[_vm._m(13),_vm._v(" "),_c('tbody',_vm._l((_vm.editLevels),function(lv,i){return _c('tr',{key:'edit-' + i},[_c('td',[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',[(i === 0)?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(lv.fromDay),expression:"lv.fromDay",modifiers:{"number":true}}],staticStyle:{"background":"#f0f0f0","color":"#999"},attrs:{"type":"number","min":"0","step":"1","readonly":""},domProps:{"value":(lv.fromDay)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(lv, "fromDay", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}):_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(lv.fromDay),expression:"lv.fromDay",modifiers:{"number":true}}],attrs:{"type":"number","min":"0","step":"1"},domProps:{"value":(lv.fromDay)},on:{"keydown":_vm.blockIntKeys,"input":function($event){if($event.target.composing){ return; }_vm.$set(lv, "fromDay", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[(i === _vm.editLevels.length - 1)?_c('input',{staticStyle:{"background":"#f0f0f0","color":"#999"},attrs:{"type":"text","value":"∞","readonly":""}}):_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(lv.toDay),expression:"lv.toDay",modifiers:{"number":true}}],attrs:{"type":"number","min":"0","step":"1"},domProps:{"value":(lv.toDay)},on:{"keydown":_vm.blockIntKeys,"input":function($event){if($event.target.composing){ return; }_vm.$set(lv, "toDay", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(lv.name),expression:"lv.name"}],attrs:{"type":"text","maxlength":"100"},domProps:{"value":(lv.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(lv, "name", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(lv.actionText),expression:"lv.actionText"}],attrs:{"maxlength":"500"},domProps:{"value":(lv.actionText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(lv, "actionText", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(lv.colorHex),expression:"lv.colorHex"}],staticClass:"color-picker",attrs:{"type":"color"},domProps:{"value":(lv.colorHex)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(lv, "colorHex", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn-tdelete",attrs:{"disabled":_vm.editLevels.length <= 3},on:{"click":function($event){return _vm.deleteLevel(i)}}},[_vm._v("🗑️")])])])}),0)]),_vm._v(" "),_c('button',{staticClass:"btn-tadd",attrs:{"disabled":_vm.editLevels.length >= 6},on:{"click":_vm.addLevel}},[_vm._v("+ เพิ่มระดับใหม่")]),_vm._v(" "),_c('div',{staticClass:"note-below"},[_vm._v("📌 \"แนวทางแก้ไข\" ใช้แสดงในรายงานทั้งหมด (Stock Cover Days Report + Dashboard: กล่อง \"สินค้าที่ต้องดำเนินการเร่งด่วน\")")])]),_vm._v(" "),(!_vm.editLoading)?_c('div',{staticClass:"setup-section"},[_c('div',{staticClass:"setup-section-title"},[_vm._v("🎯 ระบุ Target SCVD (จำลอง)")]),_vm._v(" "),_c('div',{staticClass:"target-row"},[_c('span',[_vm._v("Target SCVD (จำลอง):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.editTargetScvd),expression:"editTargetScvd",modifiers:{"number":true}}],staticClass:"target-input",attrs:{"type":"number"},domProps:{"value":(_vm.editTargetScvd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editTargetScvd=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('span',[_vm._v("วัน")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"setup-footer"},[_c('button',{staticClass:"btn-sf btn-sf-primary",attrs:{"disabled":_vm.editSaving},on:{"click":_vm.saveOnce}},[_vm._v("บันทึกครั้งเดียว")]),_vm._v(" "),(_vm.adminCanSaveDefault)?_c('button',{staticClass:"btn-sf btn-sf-warning",attrs:{"disabled":_vm.editSaving},on:{"click":_vm.saveDefault}},[_vm._v("\n              บันทึกตั้งเป็นค่าเริ่มต้น "),_c('span',{staticClass:"badge-lock"},[_vm._v("🔒")])]):_vm._e()])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Stock Cover Days Dashboard")]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("แดชบอร์ดจำนวนวันคงคลัง — สินค้าประเภทน้ำเบียร์สด")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-header"},[_c('div',{staticClass:"widget-title"},[_vm._v("🚨 สินค้าที่ต้องดำเนินการเร่งด่วน"),_c('span',{staticClass:"info-tooltip",attrs:{"data-tip":"คอลัมน์ซ้าย/ขวา = สถานะลำดับที่ 1 และ 2 จากหน้ากำหนดเกณฑ์ (ถ้าสลับลำดับใน \"แผงตั้งค่าเกณฑ์\" การจัดคอลัมน์จะสลับตาม)"}},[_vm._v("i")])]),_vm._v(" "),_c('div',{staticClass:"widget-hint"},[_vm._v("💡 คลิกที่การ์ด → ตัวกรองทั้งหน้าจะเปลี่ยนเป็นสินค้านั้น")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"border-bottom":"2px solid #e5e7eb"}},[_c('th',{staticStyle:{"width":"70%","text-align":"left","padding":"6px 4px","color":"#6b7280","font-weight":"600"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticStyle:{"width":"30%","text-align":"right","padding":"6px 4px","color":"#6b7280","font-weight":"600"}},[_vm._v("SCVD ปัจจุบัน (วัน)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bullet-gap-title"},[_vm._v("📦 ส่วนต่างการวิเคราะห์ (3 รูปแบบ) "),_c('span',{staticClass:"bullet-gap-subnote"},[_vm._v("— BRD §4.4.6 · % วัดจาก Supply")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-header"},[_c('div',{staticClass:"widget-title"},[_vm._v("🌡️ ตารางสถานะสต๊อก — ณ วันสิ้นเดือน (12 เดือน)")]),_vm._v(" "),_c('div',{staticClass:"widget-hint"},[_vm._v("💡 คลิกช่อง → กรองข้อมูลเดือน + SKU")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heatmap-legend-item",staticStyle:{"margin-left":"16px"}},[_c('span',{staticClass:"heatmap-legend-swatch",staticStyle:{"background":"#FFDB00"}}),_vm._v("เดือนปัจจุบัน\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("📐 สูตรคำนวณที่ใช้ใน Dashboard")]),_vm._v(" "),_c('div',{staticClass:"modal-subtitle"},[_vm._v("อธิบายที่มาของทุกตัวเลข — ใช้ตอบคำถามลูกค้าและทีม Support")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-group",attrs:{"id":"widget-alert"}},[_c('div',{staticClass:"widget-group-title"},[_vm._v("🚨 กล่อง \"สินค้าที่ต้องดำเนินการเร่งด่วน\"")]),_vm._v(" "),_c('div',{staticClass:"widget-group-body"},[_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("1")]),_vm._v("SCVD (ตามหน้างานจริง) ปัจจุบัน — ตัวเลขใหญ่")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" ตัวเลขใหญ่ทางซ้ายในแต่ละการ์ด")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริงจากหน้าจอ (เบียร์สดสิงห์ 15L โรงงานปทุมธานี)")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup",staticStyle:{"max-width":"340px"}},[_c('div',{staticStyle:{"font-size":"9px","background":"#fde6e6","color":"#b04747","padding":"2px 6px","border-radius":"3px","display":"inline-block","font-weight":"700"}},[_vm._v("🟥 ขาดสต๊อก")]),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"700","margin-top":"4px"}},[_vm._v("🍺 เบียร์สดสิงห์ 15 ลิตร")]),_vm._v(" "),_c('div',{staticStyle:{"color":"#6b7280","font-size":"10px"}},[_vm._v("🏭 โรงงานปทุมธานี")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"6px","display":"flex","align-items":"baseline","gap":"4px"}},[_c('span',{staticClass:"visual-highlight",staticStyle:{"font-size":"22px"}},[_vm._v("2")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#6b7280","font-size":"11px"}},[_vm._v("วัน")]),_vm._v(" "),_c('span',{staticClass:"visual-arrow"},[_vm._v("← ตัวเลขนี้")])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"9px","color":"#9ca3af","font-style":"italic"}},[_vm._v("SCVD ปัจจุบัน")])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("SCVD (ตามหน้างานจริง) = BG Stock (ตามหน้างานจริง) ÷ Demand (ตามหน้างานจริง) เฉลี่ย/วัน\n\nโดย:\n  BG Stock (ตามหน้างานจริง) = BG Stock ต้นเดือน (ตามหน้างานจริง)\n                            + Supply (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน\n                            − Demand (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน\n\n  Demand (ตามหน้างานจริง) เฉลี่ย/วัน = Demand (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน\n                                      ÷ จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา\n\n  จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา = จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน\n                                       × (วันปฏิทินผ่านมา ÷ วันปฏิทินเต็มเดือน)")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่างการคำนวณ (เบียร์สดสิงห์ 15L, วันที่ 15 ก.ค. 2026, ขนาดถัง 15 L):")]),_c('br'),_vm._v("\n                    Step 1: จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา = 26 × (15÷31) = 12.58 ≈ "),_c('b',[_vm._v("13 วัน")]),_c('br'),_vm._v("\n                    Step 2: Demand (ตามหน้างานจริง) เฉลี่ย/วัน = 845 L ÷ 13 = "),_c('b',[_vm._v("65 L/วัน")]),_c('br'),_vm._v("\n                    Step 3: BG Stock (ตามหน้างานจริง) = 750 + 195 − 845 = "),_c('b',[_vm._v("100 L")]),_c('br'),_vm._v("\n                    Step 4: SCVD (ตามหน้างานจริง) = 100 ÷ 65 = 1.54 ≈ "),_c('b',[_vm._v("2 วัน")]),_vm._v(" (ปัดขึ้นเพราะ 0.54 ≥ 0.5)")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มาของข้อมูล:")]),_c('br'),_vm._v("\n                    • BG Stock ต้นเดือน (ตามหน้างานจริง) = ค่าคงเหลือ ณ วันสุดท้ายของเดือนก่อน"),_c('br'),_vm._v("\n                    • Supply (ตามหน้างานจริง) สะสม = ผลรวมใบงาน \"ผลิตเบียร์สด\" (#02) ที่ปิดเสร็จตั้งแต่วันที่ 1 ของเดือน"),_c('br'),_vm._v("\n                    • Demand (ตามหน้างานจริง) สะสม = ผลรวมใบงาน \"ส่งสินค้าไปยังตัวแทน\" (#04) ที่ปิดเสร็จตั้งแต่วันที่ 1 ของเดือน"),_c('br'),_vm._v("\n                    • จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน = ทีมกลยุทธ์กรอกในหน้า \"จัดการข้อมูล Stock Cover Days\"")])]),_vm._v(" "),_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("2")]),_vm._v("Demand (ตามหน้างานจริง) เฉลี่ย/วัน — บรรทัด \"Demand\"")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" บรรทัด \"Demand\" ทางขวาของการ์ด")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริง")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"text-align":"right","font-size":"10.5px","color":"#6b7280"}},[_vm._v("— จากข้อมูลตามหน้างานจริง —"),_c('br'),_vm._v("\n                        Demand "),_c('span',{staticClass:"visual-highlight"},[_vm._v("65 L (4 ถัง)")]),_vm._v("/วัน "),_c('span',{staticClass:"visual-arrow"},[_vm._v("← ตัวเลขนี้")])])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("Demand (ตามหน้างานจริง) เฉลี่ย/วัน = Demand (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน\n                                    ÷ จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา\n\nโดย:\n  จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา = จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน\n                                       × (วันปฏิทินผ่านมา ÷ วันปฏิทินเต็มเดือน)")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่างการคำนวณ (เบียร์สดสิงห์ 15L, วันที่ 15 ก.ค. 2026):")]),_c('br'),_vm._v("\n                    Step 1: จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน = 26 วัน (ทีมกลยุทธ์กรอก)"),_c('br'),_vm._v("\n                    Step 2: จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา = 26 × (15÷31) = 12.58 ≈ "),_c('b',[_vm._v("13 วัน")]),_c('br'),_vm._v("\n                    Step 3: Demand (ตามหน้างานจริง) สะสม 1-15 ก.ค. = "),_c('b',[_vm._v("845 L")]),_c('br'),_vm._v("\n                    Step 4: Demand (ตามหน้างานจริง) เฉลี่ย/วัน = 845 ÷ 13 = "),_c('b',[_vm._v("65 L/วัน")]),_c('br'),_vm._v("\n                    Step 5: แปลงเป็นถัง = 65 ÷ 15 (ขนาดถังสิงห์ 15L) = 4.33 ≈ "),_c('b',[_vm._v("4 ถัง/วัน")]),_vm._v(" (ปัดลง 0.33 < 0.5)")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มาของข้อมูล:")]),_c('br'),_vm._v("\n                    • Demand (ตามหน้างานจริง) สะสม = ผลรวมใบงาน \"ส่งสินค้าไปยังตัวแทน\" (#04) ที่ปิดเสร็จตั้งแต่วันที่ 1 ของเดือน"),_c('br'),_vm._v("\n                    • จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน = ทีมกลยุทธ์กรอกในหน้า \"จัดการข้อมูล Stock Cover Days\"")])]),_vm._v(" "),_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("3")]),_vm._v("Supply (ตามหน้างานจริง) เฉลี่ย/วัน — บรรทัด \"Supply\"")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" บรรทัด \"Supply\" ทางขวาของการ์ด")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริง")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"text-align":"right","font-size":"10.5px","color":"#6b7280"}},[_vm._v("Demand 65 L (4 ถัง)/วัน"),_c('br'),_vm._v("\n                        Supply "),_c('span',{staticClass:"visual-highlight"},[_vm._v("15 L (1 ถัง)")]),_vm._v("/วัน "),_c('span',{staticClass:"visual-arrow"},[_vm._v("← ตัวเลขนี้")])])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("Supply (ตามหน้างานจริง) เฉลี่ย/วัน = Supply (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน\n                                    ÷ จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา\n\nโดย:\n  จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา = จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน\n                                       × (วันปฏิทินผ่านมา ÷ วันปฏิทินเต็มเดือน)")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่างการคำนวณ (เบียร์สดสิงห์ 15L, วันที่ 15 ก.ค. 2026):")]),_c('br'),_vm._v("\n                    Step 1: จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา = 26 × (15÷31) = 12.58 ≈ "),_c('b',[_vm._v("13 วัน")]),_c('br'),_vm._v("\n                    Step 2: Supply (ตามหน้างานจริง) สะสม 1-15 ก.ค. = "),_c('b',[_vm._v("195 L")]),_c('br'),_vm._v("\n                    Step 3: Supply (ตามหน้างานจริง) เฉลี่ย/วัน = 195 ÷ 13 = "),_c('b',[_vm._v("15 L/วัน")]),_c('br'),_vm._v("\n                    Step 4: แปลงเป็นถัง = 15 ÷ 15 (ขนาดถังสิงห์ 15L) = "),_c('b',[_vm._v("1 ถัง/วัน")])]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มาของข้อมูล:")]),_c('br'),_vm._v("\n                    • Supply (ตามหน้างานจริง) สะสม = ผลรวมใบงาน \"ผลิตเบียร์สด\" (#02) ที่ปิดเสร็จตั้งแต่วันที่ 1 ของเดือน"),_c('br'),_vm._v("\n                    • จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน = ทีมกลยุทธ์กรอกในหน้า \"จัดการข้อมูล Stock Cover Days\"")])]),_vm._v(" "),_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("4")]),_vm._v("แนวโน้มเทียบเดือนก่อน (▼ ▲ ━)")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" มุมขวาบนของแต่ละการ์ด")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริง")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup",staticStyle:{"max-width":"340px"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","font-size":"10px"}},[_c('span',{staticStyle:{"background":"#fde6e6","color":"#b04747","padding":"2px 6px","border-radius":"3px","font-weight":"700"}},[_vm._v("🟥 ขาดสต๊อก")]),_vm._v(" "),_c('span',{staticClass:"visual-highlight",staticStyle:{"font-size":"11px","color":"#b04747"}},[_vm._v("▼ 5 วัน จากเดือนก่อน")]),_vm._v(" "),_c('span',{staticClass:"visual-arrow",staticStyle:{"margin-left":"0"}},[_vm._v("← ตัวเลขนี้")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"4px","font-weight":"700","font-size":"11px"}},[_vm._v("🍺 เบียร์สดสิงห์ 15 ลิตร")])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("แนวโน้ม = SCVD (ตามหน้างานจริง) เดือนนี้\n        − SCVD (ตามหน้างานจริง) เดือนที่แล้ว\n\n(ใช้ค่า SCVD ณ วันสุดท้ายของเดือน)")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่างการคำนวณ (เบียร์สดสิงห์ 15L, เทียบ ก.ค. vs มิ.ย. 2026):")]),_c('br'),_vm._v("\n                    Step 1: SCVD (ตามหน้างานจริง) มิ.ย. 2026 ณ วันสิ้นเดือน = "),_c('b',[_vm._v("7 วัน")]),_c('br'),_vm._v("\n                    Step 2: SCVD (ตามหน้างานจริง) ก.ค. 2026 ปัจจุบัน = "),_c('b',[_vm._v("2 วัน")]),_c('br'),_vm._v("\n                    Step 3: แนวโน้ม = 2 − 7 = "),_c('b',[_vm._v("−5")]),_vm._v(" → แสดง "),_c('b',[_vm._v("▼ 5 วัน จากเดือนก่อน")]),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("สัญลักษณ์:")]),_c('br'),_vm._v("\n                    • "),_c('b',[_vm._v("▼ ลดลง")]),_vm._v(" = สต๊อกลดลง (แย่ลง — ต้องผลิตเพิ่ม)"),_c('br'),_vm._v("\n                    • "),_c('b',[_vm._v("▲ เพิ่มขึ้น")]),_vm._v(" = สต๊อกเพิ่มขึ้น (ดีขึ้น)"),_c('br'),_vm._v("\n                    • "),_c('b',[_vm._v("━ คงที่")]),_vm._v(" = ไม่เปลี่ยนแปลง")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มา:")]),_vm._v(" SCVD (ตามหน้างานจริง) เดือนก่อน = คำนวณจาก BG Stock/Supply/Demand ณ วันสุดท้ายของเดือนก่อน (สูตรเดียวกับข้อ (1) SCVD ปัจจุบัน แต่ใช้ข้อมูลปิดเดือน)")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-group",attrs:{"id":"widget-pie"}},[_c('div',{staticClass:"widget-group-title"},[_vm._v("🥧 กล่อง \"สัดส่วนสถานะสต็อก 5 ระดับ\"")]),_vm._v(" "),_c('div',{staticClass:"widget-group-body"},[_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("1")]),_vm._v("% และจำนวน SKU ในแต่ละสถานะ")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" ในแผนภูมิพายและ Legend ด้านล่าง")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริง")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"font-size":"11px","line-height":"1.7"}},[_vm._v("\n                        🟥 "),_c('span',{staticClass:"visual-highlight"},[_vm._v("30%")]),_vm._v(" ขาดสต๊อก · "),_c('span',{staticClass:"visual-highlight"},[_vm._v("15 SKU")]),_c('br'),_vm._v("\n                        🟧 20% สต็อกใกล้หมด · 10 SKU"),_c('br'),_vm._v("\n                        🟩 35% บริหารดี · 18 SKU"),_c('br'),_vm._v("\n                        🟨 10% สต็อกเริ่มสูง · 5 SKU"),_c('br'),_vm._v("\n                        🟪 5% สต็อกล้น · 2 SKU\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("% = จำนวน SKU ที่มี SCVD (ตามหน้างานจริง) อยู่ในสถานะนั้น\n    ÷ จำนวน SKU รวมทั้งหมดในระบบ\n    × 100\n\nโดย: สถานะของ SKU ถูกจัดตามค่า SCVD (ตามหน้างานจริง) ปัจจุบัน เทียบกับเกณฑ์ 5 ระดับ")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่างการคำนวณ:")]),_c('br'),_vm._v("\n                    Step 1: นับจำนวน SKU ที่มี SCVD (ตามหน้างานจริง) อยู่ในช่วง 0-3 วัน = "),_c('b',[_vm._v("15 SKU")]),_vm._v(" (สถานะ \"ขาดสต๊อก\")"),_c('br'),_vm._v("\n                    Step 2: จำนวน SKU รวมทั้งหมดในระบบ = "),_c('b',[_vm._v("50 SKU")]),_c('br'),_vm._v("\n                    Step 3: % = 15 ÷ 50 × 100 = "),_c('b',[_vm._v("30%")])]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มาของข้อมูล:")]),_c('br'),_vm._v("\n                    • SCVD (ตามหน้างานจริง) ของแต่ละ SKU = คำนวณจากสูตรใน Widget 1 หัวข้อ (1) — real-time"),_c('br'),_vm._v("\n                    • เกณฑ์ 5 ระดับ = ตั้งค่าในหน้าจอ \"แผงตั้งค่าเกณฑ์การแสดงผล\" (Setup Panel) — แอดมิน Stock Cover Days ปรับได้"),_c('br'),_vm._v("\n                    • จำนวน SKU รวมทั้งหมด = จำนวนช่อง (SKU × คลัง) ที่แสดงในตาราง — จะแสดงเมื่อ"),_c('b',[_vm._v("ทั้ง \"คลัง\" และ \"สินค้า\"")]),_vm._v("นั้นเปิดใช้งาน \"ใช้งาน Stock Cover Days\" (ดูรายละเอียดที่หน้า \"จัดการข้อมูลคลังสินค้า\" + \"จัดการข้อมูลสินค้า\")")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-group",attrs:{"id":"widget-bullet"}},[_c('div',{staticClass:"widget-group-title"},[_vm._v("📊 กล่อง \"การเทียบข้อมูลตามหน้างานจริง vs ข้อมูลตามเป้าหมาย vs Target SCVD (จำลอง)\"")]),_vm._v(" "),_c('div',{staticClass:"widget-group-body"},[_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("1")]),_vm._v("BG Stock (ตามหน้างานจริง) ปัจจุบัน — บรรทัด \"Stock ปัจจุบัน\"")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" บรรทัด \"Stock ปัจจุบัน:\" ทางขวาบนของแต่ละ SKU")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริง (เบียร์สดสิงห์ 15L โรงงานปทุมธานี)")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"font-size":"11px"}},[_vm._v("🍺 "),_c('b',[_vm._v("เบียร์สดสิงห์ 15 ลิตร")]),_vm._v(" 🟥 ขาดสต๊อก")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"10.5px","color":"#6b7280","margin-top":"4px"}},[_vm._v("Demand: 65 L (4 ถัง)/วัน · Stock ปัจจุบัน: "),_c('span',{staticClass:"visual-highlight"},[_vm._v("100 L (7 ถัง)")]),_vm._v(" "),_c('span',{staticClass:"visual-arrow"},[_vm._v("← ตัวเลขนี้")])])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("BG Stock (ตามหน้างานจริง) ปัจจุบัน = BG Stock ต้นเดือน (ตามหน้างานจริง)\n                                    + Supply (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน\n                                    − Demand (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่างการคำนวณ (เบียร์สดสิงห์ 15L, วันที่ 15 ก.ค. 2026, ขนาดถัง 15 L):")]),_c('br'),_vm._v("\n                    Step 1: BG Stock ต้นเดือน (ตามหน้างานจริง) ณ 1 ก.ค. = "),_c('b',[_vm._v("750 L")]),_c('br'),_vm._v("\n                    Step 2: Supply (ตามหน้างานจริง) สะสม 1-15 ก.ค. = "),_c('b',[_vm._v("195 L")]),_c('br'),_vm._v("\n                    Step 3: Demand (ตามหน้างานจริง) สะสม 1-15 ก.ค. = "),_c('b',[_vm._v("845 L")]),_c('br'),_vm._v("\n                    Step 4: BG Stock (ตามหน้างานจริง) ปัจจุบัน = 750 + 195 − 845 = "),_c('b',[_vm._v("100 L")]),_c('br'),_vm._v("\n                    Step 5: แปลงเป็นถัง = 100 ÷ 15 (ขนาดถัง) = 6.67 ≈ "),_c('b',[_vm._v("7 ถัง")]),_vm._v(" (ปัดขึ้นเพราะ 0.67 ≥ 0.5)")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มาของข้อมูล:")]),_c('br'),_vm._v("\n                    • BG Stock ต้นเดือน (ตามหน้างานจริง) = ค่า BG Stock (ตามหน้างานจริง) ณ วันสุดท้ายของเดือนก่อน (คำนวณต่อเนื่อง)"),_c('br'),_vm._v("\n                    • Supply (ตามหน้างานจริง) สะสม = ผลรวมใบงาน \"ผลิตเบียร์สด\" (#02) ที่ปิดเสร็จตั้งแต่วันที่ 1 ของเดือน"),_c('br'),_vm._v("\n                    • Demand (ตามหน้างานจริง) สะสม = ผลรวมใบงาน \"ส่งสินค้าไปยังตัวแทน\" (#04) ที่ปิดเสร็จตั้งแต่วันที่ 1 ของเดือน"),_c('br'),_vm._v("\n                    • คำนวณ real-time (อัปเดตภายใน 5 วินาที เมื่อมีใบงาน #02 หรือ #04 ปิดเพิ่ม)")])]),_vm._v(" "),_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("2")]),_vm._v("Demand (ตามหน้างานจริง) เฉลี่ย/วัน — บรรทัด \"Demand\"")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" บรรทัด \"Demand:\" ทางขวาบนของแต่ละ SKU")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริง")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"font-size":"10.5px","color":"#6b7280"}},[_vm._v("Demand: "),_c('span',{staticClass:"visual-highlight"},[_vm._v("65 L (4 ถัง)")]),_vm._v("/วัน "),_c('span',{staticClass:"visual-arrow"},[_vm._v("← ตัวเลขนี้")]),_vm._v(" · Stock ปัจจุบัน: 100 L (7 ถัง)")])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("Demand (ตามหน้างานจริง) เฉลี่ย/วัน = Demand (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน\n                                    ÷ จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา\n\nโดย:\n  จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา = จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน\n                                       × (วันปฏิทินผ่านมา ÷ วันปฏิทินเต็มเดือน)")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่างการคำนวณ (เบียร์สดสิงห์ 15L, วันที่ 15 ก.ค. 2026):")]),_c('br'),_vm._v("\n                    Step 1: จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน = 26 วัน"),_c('br'),_vm._v("\n                    Step 2: จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา = 26 × (15÷31) = 12.58 ≈ "),_c('b',[_vm._v("13 วัน")]),_c('br'),_vm._v("\n                    Step 3: Demand (ตามหน้างานจริง) สะสม 1-15 ก.ค. = "),_c('b',[_vm._v("845 L")]),_c('br'),_vm._v("\n                    Step 4: Demand (ตามหน้างานจริง) เฉลี่ย/วัน = 845 ÷ 13 = "),_c('b',[_vm._v("65 L/วัน")]),_c('br'),_vm._v("\n                    Step 5: แปลงเป็นถัง = 65 ÷ 15 = 4.33 ≈ "),_c('b',[_vm._v("4 ถัง/วัน")]),_vm._v(" (ปัดลง 0.33 < 0.5)")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มาของข้อมูล:")]),_c('br'),_vm._v("\n                    • Demand (ตามหน้างานจริง) สะสม = ผลรวมใบงาน \"ส่งสินค้าไปยังตัวแทน\" (#04) ที่ปิดเสร็จตั้งแต่วันที่ 1 ของเดือน"),_c('br'),_vm._v("\n                    • จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน = ทีมกลยุทธ์กรอกในหน้า \"จัดการข้อมูล Stock Cover Days\"")])]),_vm._v(" "),_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("3")]),_vm._v("ป้ายเป้าหมาย 2 จุดบนกราฟ")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" เส้น marker ตั้งฉากบนกราฟแท่ง")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริง")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"font-size":"11px","line-height":"2"}},[_c('span',{staticStyle:{"background":"#1d4ed8","color":"white","padding":"3px 8px","border-radius":"3px","font-size":"10px","font-weight":"700"}},[_vm._v("▼ SCVD (ตามเป้าหมาย) 14")]),_vm._v(" = ค่าเป้าที่กำหนดในเดือน"),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"background":"#7e22ce","color":"white","padding":"3px 8px","border-radius":"3px","font-size":"10px","font-weight":"700"}},[_vm._v("▼ Target SCVD (จำลอง) 18")]),_vm._v(" = ค่าจำลองจาก Setup Panel\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("SCVD (ตามเป้าหมาย) = ค่าที่ทีมกลยุทธ์กำหนดล่วงหน้าต่อเดือน\n                                (ไม่ใช่สูตรคำนวณ — เป็นค่าที่กรอกเข้าระบบโดยตรง)\n\nTarget SCVD (จำลอง)   = ค่าเป้าหมายที่แอดมิน Stock Cover Days ตั้งเพื่อจำลอง scenario\n                                (ไม่ใช่สูตรคำนวณ — เป็นค่าที่ตั้งใน Setup Panel)")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่าง (เบียร์สดสิงห์ 15L, ก.ค. 2026):")]),_c('br'),_vm._v("\n                    • SCVD (ตามเป้าหมาย) ก.ค. 2026 = "),_c('b',[_vm._v("14 วัน")]),_vm._v(" (ทีมกลยุทธ์ตั้งไว้ตอนต้นปี)"),_c('br'),_vm._v("\n                    • Target SCVD (จำลอง) = "),_c('b',[_vm._v("18 วัน")]),_vm._v(" (แอดมินตั้งเพื่อจำลอง \"ถ้าเราต้องการปลอดภัยกว่านี้\")")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มาของข้อมูล:")]),_c('br'),_vm._v("\n                    • SCVD (ตามเป้าหมาย): กรอกโดยทีมกลยุทธ์ในหน้า \"จัดการข้อมูล Stock Cover Days\" (คอลัมน์ SCVD ในแต่ละเดือน × คลัง × สินค้า)"),_c('br'),_vm._v("\n                    • Target SCVD (จำลอง): ตั้งค่าจากหน้า Setup Panel — เข้าจากปุ่ม \"⚙️ แก้ไขเกณฑ์\" ในแถบเกณฑ์ (เฉพาะแอดมิน Stock Cover Days เท่านั้นที่บันทึกตั้งเป็นค่าเริ่มต้นได้ 🔒)")])]),_vm._v(" "),_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("4")]),_vm._v("ส่วนต่างการวิเคราะห์ (3 รูปแบบ)")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" กล่อง \"🚨 ส่วนต่างการวิเคราะห์ (3 รูปแบบ)\" ใต้แต่ละ SKU")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริง (เบียร์สดสิงห์ 15L)")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"background":"#fef2f2","padding":"8px","border-left":"3px solid #FF6B6B","border-radius":"4px","font-size":"10.5px","line-height":"1.7"}},[_c('b',[_vm._v("🚨 ส่วนต่างการวิเคราะห์ (3 รูปแบบ)")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"gap-num"},[_vm._v("1")]),_vm._v(" ตามหน้างานจริง → ตามเป้าหมาย: "),_c('span',{staticClass:"visual-highlight"},[_vm._v("🔻 ห่างจากเป้าหมาย 86.1% — ต้องผลิตเพิ่ม 1,205 L (80 ถัง)")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"gap-num"},[_vm._v("2")]),_vm._v(" ตามหน้างานจริง → Target SCVD (จำลอง): 🔻 ห่างจากเป้าหมาย 88.9% — ต้องผลิตเพิ่ม 800 L (53 ถัง)"),_c('br'),_vm._v(" "),_c('span',{staticClass:"gap-num"},[_vm._v("3")]),_vm._v(" ตามเป้าหมาย → Target SCVD (จำลอง): 🔻 ห่างจากเป้าหมาย 22.2% — ต้องปรับเพิ่มแผนผลิต 200 L (13 ถัง)\n                      ")])])]),_vm._v(" "),_c('div',{staticStyle:{"background":"#fefce8","border-left":"3px solid #eab308","padding":"8px 12px","border-radius":"5px","margin":"8px 0","font-size":"11.5px","color":"#78350f"}},[_vm._v("\n                    💼 "),_c('b',[_vm._v("ข้อมูลตั้งต้นสำหรับตัวอย่างทั้ง 3 รูปแบบ")]),_vm._v(" — เบียร์สดสิงห์ 15L (ขนาดถัง 15 L), วันที่ 15 ก.ค. 2026"),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"display":"inline-block","margin-top":"4px","padding-left":"14px"}},[_vm._v("\n                      • "),_c('b',[_vm._v("ตามหน้างานจริง:")]),_vm._v(" BG Stock ปัจจุบัน = 100 L · Demand สะสม = 845 L · Supply สะสม = 195 L"),_c('br'),_vm._v("\n                      • "),_c('b',[_vm._v("ตามเป้าหมาย:")]),_vm._v(" Demand เต็มเดือน = 1,300 L · Supply เต็มเดือน = 1,400 L · BG Stock ต้นเดือน = 700 L"),_c('br'),_vm._v("\n                      • "),_c('b',[_vm._v("Target SCVD (จำลอง)")]),_vm._v(" = 18 วัน · "),_c('b',[_vm._v("จำนวนวันขาย (ตามเป้าหมาย)")]),_vm._v(" = 26 วัน\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"gap-forms-container"},[_c('div',{staticClass:"gap-form-card gap-form-1"},[_c('div',{staticClass:"gap-form-header"},[_vm._v("🔴 รูปแบบ 1 "),_c('span',{staticClass:"gap-form-badge"},[_vm._v("ตามหน้างานจริง → ตามเป้าหมาย")])]),_vm._v(" "),_c('div',{staticClass:"gap-form-question"},[_vm._v("💬 \"เดือนนี้ต้องเร่งอีกเท่าไหร่ ถึงจะทันแผนทีมกลยุทธ์\"")]),_vm._v(" "),_c('div',{staticClass:"gap-form-formula"},[_vm._v("ส่วนต่าง Demand = Demand (ตามเป้าหมาย) เต็มเดือน\n                − Demand (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน\n\nส่วนต่าง Supply = Supply (ตามเป้าหมาย) เต็มเดือน\n                − Supply (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน\n\n%             = ส่วนต่าง Supply ÷ Supply (ตามเป้าหมาย) เต็มเดือน × 100")]),_vm._v(" "),_c('div',{staticClass:"gap-form-example"},[_vm._v("\n                        🎯 "),_c('b',[_vm._v("ตัวอย่างการคำนวณ:")]),_c('br'),_vm._v("\n                           "),_c('b',[_vm._v("ส่วนต่าง Demand")]),_vm._v(" = 1,300 − 845 = "),_c('b',[_vm._v("455 L")]),_vm._v(" → ÷15 = "),_c('b',[_vm._v("30 ถัง")]),_c('br'),_vm._v("\n                           "),_c('i',{staticStyle:{"color":"#6b7280","font-size":"11px"}},[_vm._v("(ตลาดยังจะสั่งอีก 30 ถัง ก่อนสิ้นเดือน)")]),_c('br'),_vm._v("\n                           "),_c('b',[_vm._v("ส่วนต่าง Supply")]),_vm._v(" ⭐ = 1,400 − 195 = "),_c('b',[_vm._v("1,205 L")]),_vm._v(" → ÷15 = "),_c('b',[_vm._v("80 ถัง")]),_c('br'),_vm._v("\n                           "),_c('i',{staticStyle:{"color":"#6b7280","font-size":"11px"}},[_vm._v("(ต้องผลิตเพิ่ม 80 ถัง เพื่อทันแผน)")]),_c('br'),_vm._v("\n                           "),_c('b',[_vm._v("%")]),_vm._v(" = 1,205 ÷ 1,400 × 100 = "),_c('b',[_vm._v("86.1%")])]),_vm._v(" "),_c('div',{staticStyle:{"background":"#fef3c7","border-left":"3px solid #f59e0b","padding":"9px 12px","margin-top":"10px","border-radius":"4px","font-size":"11px","color":"#78350f","line-height":"1.6"}},[_vm._v("\n                        💡 "),_c('b',[_vm._v("ทำไม % เทียบจาก Supply ไม่ใช่ Demand:")]),_vm._v(" เพราะเราควบคุมการผลิต (Supply) ได้ แต่ควบคุมความต้องการตลาด (Demand) ไม่ได้ — Supply คือ "),_c('b',[_vm._v("action number")]),_vm._v(" ที่ทีมโรงงานลงมือทำได้จริง / Demand เป็น "),_c('b',[_vm._v("ข้อมูลประกอบ")]),_vm._v(" ให้เห็นแนวโน้มตลาด\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"gap-form-card gap-form-2"},[_c('div',{staticClass:"gap-form-header"},[_vm._v("🟣 รูปแบบ 2 "),_c('span',{staticClass:"gap-form-badge"},[_vm._v("ตามหน้างานจริง → Target SCVD (จำลอง)")])]),_vm._v(" "),_c('div',{staticClass:"gap-form-question"},[_vm._v("💬 \"อยากได้ SCVD = Target ต้องเร่งผลิต Supply เพิ่มอีกเท่าไหร่\"")]),_vm._v(" "),_c('div',{staticClass:"gap-form-formula"},[_vm._v("BG Stock ที่ต้องมี = Target SCVD × Demand (ตามเป้าหมาย) เต็มเดือน\n                   ÷ จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน\n\nSupply ต้องเร่ง   = BG Stock ที่ต้องมี\n                   − BG Stock (ตามหน้างานจริง) ปัจจุบัน\n\n%                = Supply ต้องเร่ง ÷ BG Stock ที่ต้องมี × 100\n\n(ไม่แสดง Demand — ควบคุมความต้องการตลาดไม่ได้)")]),_vm._v(" "),_c('div',{staticClass:"gap-form-example"},[_vm._v("\n                        🎯 "),_c('b',[_vm._v("ตัวอย่างการคำนวณ:")]),_c('br'),_vm._v("\n                           BG Stock ที่ต้องมี = 18 × 1,300 ÷ 26 = "),_c('b',[_vm._v("900 L")]),_c('br'),_vm._v("\n                           Supply ต้องเร่ง = 900 − 100 = "),_c('b',[_vm._v("800 L")]),_vm._v(" → ÷15 = "),_c('b',[_vm._v("53 ถัง")]),_vm._v(" (53.33 ปัดลง)"),_c('br'),_vm._v("\n                           % = 800 ÷ 900 × 100 = "),_c('b',[_vm._v("88.9%")])])]),_vm._v(" "),_c('div',{staticClass:"gap-form-card gap-form-3"},[_c('div',{staticClass:"gap-form-header"},[_vm._v("🔵 รูปแบบ 3 "),_c('span',{staticClass:"gap-form-badge"},[_vm._v("ตามเป้าหมาย → Target SCVD (จำลอง)")])]),_vm._v(" "),_c('div',{staticClass:"gap-form-question"},[_vm._v("💬 \"ทีมกลยุทธ์ต้องปรับ Supply ในแผนอีกเท่าไหร่ ถึงจะเข้า Target\"")]),_vm._v(" "),_c('div',{staticClass:"gap-form-formula"},[_vm._v("BG Stock ที่ต้องมี = Target SCVD × Demand (ตามเป้าหมาย) เต็มเดือน\n                   ÷ จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน\n\nSupply ต้องปรับ  = BG Stock ที่ต้องมี\n                   − BG Stock ต้นเดือน (ตามเป้าหมาย)\n\n%                = Supply ต้องปรับ ÷ BG Stock ที่ต้องมี × 100")]),_vm._v(" "),_c('div',{staticClass:"gap-form-example"},[_vm._v("\n                        🎯 "),_c('b',[_vm._v("ตัวอย่างการคำนวณ:")]),_c('br'),_vm._v("\n                           BG Stock ที่ต้องมี = 18 × 1,300 ÷ 26 = "),_c('b',[_vm._v("900 L")]),_c('br'),_vm._v("\n                           Supply ต้องปรับ = 900 − 700 = "),_c('b',[_vm._v("200 L")]),_vm._v(" → ÷15 = "),_c('b',[_vm._v("13 ถัง")]),_vm._v(" (13.33 ปัดลง)"),_c('br'),_vm._v("\n                           % = 200 ÷ 900 × 100 = "),_c('b',[_vm._v("22.2%")])])])]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มาของข้อมูล:")]),_c('br'),_vm._v("\n                    • Demand/Supply (ตามเป้าหมาย) เต็มเดือน = ทีมกลยุทธ์กรอกล่วงหน้าในหน้า \"จัดการข้อมูล Stock Cover Days\""),_c('br'),_vm._v("\n                    • BG Stock ต้นเดือน (ตามเป้าหมาย) = ทีมกลยุทธ์กำหนดค่าเริ่มต้นในหน้า \"จัดการข้อมูล Stock Cover Days\""),_c('br'),_vm._v("\n                    • Demand/Supply (ตามหน้างานจริง) สะสม = ผลรวมใบงาน #04 / #02 ที่ปิดเสร็จ"),_c('br'),_vm._v("\n                    • BG Stock (ตามหน้างานจริง) ปัจจุบัน = ดูสูตรใน หัวข้อ (1) BG Stock ปัจจุบัน"),_c('br'),_vm._v("\n                    • Target SCVD (จำลอง) = ตั้งค่าใน Setup Panel"),_c('br'),_vm._v("\n                    • จำนวนวันขาย (ตามเป้าหมาย) = ทีมกลยุทธ์กรอกในหน้า \"จัดการข้อมูล Stock Cover Days\"")]),_vm._v(" "),_c('div',{staticClass:"formula-important"},[_vm._v("⚠️ "),_c('b',[_vm._v("Note ทางธุรกิจ:")]),_vm._v(" \"ส่วนต่าง Supply\" แต่ละรูปแบบมีความหมายต่างกัน — ห้ามใช้สลับกัน"),_c('br'),_vm._v("\n                    • รูปแบบ 1 = \"ยังต้องผลิตอีกเท่าไหร่ ให้ทันแผนที่ทีมกลยุทธ์ตั้ง\""),_c('br'),_vm._v("\n                    • รูปแบบ 2 = \"ยังต้องเร่งผลิตเพิ่มเท่าไหร่ ให้ SCVD ปัจจุบัน = Target ที่ตั้งจำลอง\""),_c('br'),_vm._v("\n                    • รูปแบบ 3 = \"แผนของทีมกลยุทธ์ห่างจาก Target เท่าไหร่ (ต้องปรับแผนล่วงหน้า)\"")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-group",attrs:{"id":"widget-heatmap"}},[_c('div',{staticClass:"widget-group-title"},[_vm._v("🌡️ กล่อง \"ตารางสถานะสต๊อก — ณ วันสิ้นเดือน (12 เดือน)\"")]),_vm._v(" "),_c('div',{staticClass:"widget-group-body"},[_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("1")]),_vm._v("SCVD (ตามหน้างานจริง) ในแต่ละช่องของตาราง")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" ทุกช่องในตาราง (12 เดือน × จำนวน SKU)")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริง")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"display":"grid","grid-template-columns":"100px repeat(3,50px)","gap":"3px","font-size":"10.5px","align-items":"center"}},[_c('div',{staticStyle:{"font-weight":"600"}},[_vm._v("🍺 สิงห์ 15L")]),_vm._v(" "),_c('div',{staticStyle:{"background":"#90D8B2","padding":"6px","border-radius":"3px","text-align":"center","font-weight":"700"}},[_vm._v("10")]),_vm._v(" "),_c('div',{staticStyle:{"background":"#FF6B6B","color":"white","padding":"6px","border-radius":"3px","text-align":"center","font-weight":"700"}},[_vm._v("2")]),_vm._v(" "),_c('div',{staticStyle:{"background":"#FFB080","padding":"6px","border-radius":"3px","text-align":"center","font-weight":"700"}},[_vm._v("5")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"6px","font-size":"10.5px","color":"#dc2626","font-style":"italic"}},[_vm._v("← ตัวเลขในทุกช่องคือ SCVD (ตามหน้างานจริง) ณ วันสิ้นเดือน")])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("SCVD (ตามหน้างานจริง) ในช่องตาราง = BG Stock (ตามหน้างานจริง) ÷ Demand (ตามหน้างานจริง) เฉลี่ย/วัน\n\nโดย:\n  • เดือนที่ผ่านมา   → ใช้ค่า SCVD (ตามหน้างานจริง) ณ วันสุดท้ายของเดือนนั้น (ค่านิ่ง)\n  • เดือนปัจจุบัน   → ใช้ค่า SCVD (ตามหน้างานจริง) ปัจจุบัน (real-time)\n  • เดือนล่วงหน้า   → ไม่แสดงตัวเลข (ยังไม่มีข้อมูล)\n\n  BG Stock (ตามหน้างานจริง) = BG Stock ต้นเดือน (ตามหน้างานจริง)\n                            + Supply (ตามหน้างานจริง) สะสมในเดือนนั้น\n                            − Demand (ตามหน้างานจริง) สะสมในเดือนนั้น\n\n  Demand (ตามหน้างานจริง) เฉลี่ย/วัน = Demand (ตามหน้างานจริง) สะสมในเดือนนั้น\n                                      ÷ จำนวนวันขาย (ตามเป้าหมาย) ในเดือนนั้น")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่าง (สิงห์ 15L โรงงานปทุมธานี, เดือน มิ.ย. 2026 ปิดเดือนแล้ว):")]),_c('br'),_vm._v("\n                    Step 1: BG Stock ต้นเดือน (ตามหน้างานจริง) มิ.ย. = 900 L"),_c('br'),_vm._v("\n                    Step 2: Supply (ตามหน้างานจริง) มิ.ย. ทั้งเดือน = 1,400 L"),_c('br'),_vm._v("\n                    Step 3: Demand (ตามหน้างานจริง) มิ.ย. ทั้งเดือน = 1,350 L"),_c('br'),_vm._v("\n                    Step 4: BG Stock (ตามหน้างานจริง) ณ 30 มิ.ย. = 900 + 1,400 − 1,350 = "),_c('b',[_vm._v("950 L")]),_c('br'),_vm._v("\n                    Step 5: จำนวนวันขาย (ตามเป้าหมาย) มิ.ย. = 25 วัน"),_c('br'),_vm._v("\n                    Step 6: Demand เฉลี่ย/วัน = 1,350 ÷ 25 = "),_c('b',[_vm._v("54 L/วัน")]),_c('br'),_vm._v("\n                    Step 7: SCVD = 950 ÷ 54 = 17.6 ≈ "),_c('b',[_vm._v("18 วัน")]),_vm._v(" (ปัดขึ้น 0.6 ≥ 0.5)")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มา:")]),_vm._v(" ทุกตัวแปรใช้แหล่งเดียวกับหัวข้อ (1) SCVD ปัจจุบัน ในกล่อง \"สินค้าที่ต้องดำเนินการเร่งด่วน\""),_c('br'),_vm._v(" "),_c('b',[_vm._v("สีของช่อง:")]),_vm._v(" ยึดตามเกณฑ์ 5 ระดับ (ตั้งใน Setup Panel) — เหมือน Pie Chart")])]),_vm._v(" "),_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("2")]),_vm._v("Demand (ตามหน้างานจริง) รวมของคลัง — ต่อวัน")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" ข้อมูลข้างชื่อคลัง (ทางขวาของ 🏭)")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริง")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","padding-bottom":"6px","border-bottom":"2px solid #FFDB00","font-size":"11px"}},[_c('span',[_vm._v("🏭 "),_c('b',[_vm._v("โรงงานปทุมธานี")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#6b7280"}},[_vm._v("8 SKU · Demand รวม "),_c('span',{staticClass:"visual-highlight"},[_vm._v("320 L (13 ถัง)")]),_vm._v("/วัน · Supply รวม 220 L (9 ถัง)/วัน")])])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("Demand (ตามหน้างานจริง) รวม/วัน (ลิตร) = Σ  Demand (ตามหน้างานจริง) เฉลี่ย/วัน ของทุก SKU ในคลัง\n\nDemand (ตามหน้างานจริง) รวม/วัน (ถัง) = Σ  ( Demand (ตามหน้างานจริง) เฉลี่ย/วัน ของ SKU\n                                            ÷ ขนาดถังของ SKU นั้น )\n\nโดย:\n  Demand (ตามหน้างานจริง) เฉลี่ย/วัน ของแต่ละ SKU\n       = Demand (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน ของ SKU นั้น\n         ÷ จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา\n\n  จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา\n       = จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน × (วันปฏิทินผ่านมา ÷ วันปฏิทินเต็มเดือน)")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่าง (โรงงานปทุมธานี, 3 SKU, วันที่ 15 ก.ค. 2026):")]),_c('br'),_vm._v("\n                    สิงห์ 15L: Demand เฉลี่ย 45 L/วัน → 45÷15 = 3 ถัง"),_c('br'),_vm._v("\n                    สิงห์ 30L: Demand เฉลี่ย 150 L/วัน → 150÷30 = 5 ถัง"),_c('br'),_vm._v("\n                    สิงห์ 50L: Demand เฉลี่ย 125 L/วัน → 125÷50 = 2.5 ≈ 3 ถัง (ปัดขึ้น)"),_c('br'),_vm._v(" "),_c('b',[_vm._v("รวม (ลิตร)")]),_vm._v(" = 45 + 150 + 125 = "),_c('b',[_vm._v("320 L/วัน")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("รวม (ถัง)")]),_vm._v(" = 3 + 5 + 3 = "),_c('b',[_vm._v("13 ถัง/วัน")]),_vm._v(" (แปลงต่อ SKU แล้วรวม)")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มาของข้อมูล:")]),_c('br'),_vm._v("\n                    • Demand (ตามหน้างานจริง) สะสมของแต่ละ SKU = ใบงาน \"ส่งสินค้าไปยังตัวแทน\" (#04) ที่ปิดเสร็จ"),_c('br'),_vm._v("\n                    • จำนวนวันขาย (ตามเป้าหมาย) = ทีมกลยุทธ์กรอกในหน้า \"จัดการข้อมูล Stock Cover Days\""),_c('br'),_vm._v("\n                    • ขนาดถังของแต่ละ SKU = ดึงจากตาราง Master_Product ช่อง NETVOLUME")]),_vm._v(" "),_c('div',{staticClass:"formula-important"},[_vm._v("⚠️ "),_c('b',[_vm._v("ห้าม")]),_vm._v(" คำนวณ \"ถังรวม\" โดยเอา \"ลิตรรวม\" หารด้วย 30 ก้อนใหญ่ — เบียร์แต่ละขนาดถังต่างกัน (15/20/22.7/22.9/25/30/50 L) จะคลาดเคลื่อน 20-40% "),_c('b',[_vm._v("ต้องแปลงทีละสินค้าก่อนแล้วค่อยรวม")])])]),_vm._v(" "),_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("3")]),_vm._v("Supply (ตามหน้างานจริง) รวมของคลัง — ต่อวัน")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" ข้อมูลข้างชื่อคลัง (บรรทัดเดียวกับ Demand รวม)")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจริง")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","padding-bottom":"6px","border-bottom":"2px solid #FFDB00","font-size":"11px"}},[_c('span',[_vm._v("🏭 "),_c('b',[_vm._v("โรงงานปทุมธานี")])]),_vm._v(" "),_c('span',{staticStyle:{"color":"#6b7280"}},[_vm._v("Demand รวม 320 L (13 ถัง)/วัน · Supply รวม "),_c('span',{staticClass:"visual-highlight"},[_vm._v("220 L (9 ถัง)")]),_vm._v("/วัน "),_c('span',{staticClass:"visual-arrow"},[_vm._v("← ตัวเลขนี้")])])])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("Supply (ตามหน้างานจริง) รวม/วัน (ลิตร) = Σ  Supply (ตามหน้างานจริง) เฉลี่ย/วัน ของทุก SKU ในคลัง\n\nSupply (ตามหน้างานจริง) รวม/วัน (ถัง) = Σ  ( Supply (ตามหน้างานจริง) เฉลี่ย/วัน ของ SKU\n                                             ÷ ขนาดถังของ SKU นั้น )\n\nโดย:\n  Supply (ตามหน้างานจริง) เฉลี่ย/วัน ของแต่ละ SKU\n       = Supply (ตามหน้างานจริง) สะสมตั้งแต่ต้นเดือน ของ SKU นั้น\n         ÷ จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา\n\n  จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา\n       = จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน × (วันปฏิทินผ่านมา ÷ วันปฏิทินเต็มเดือน)")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่าง (โรงงานปทุมธานี, 3 SKU, วันที่ 15 ก.ค. 2026):")]),_c('br'),_vm._v("\n                    สิงห์ 15L: Supply เฉลี่ย 30 L/วัน → 30÷15 = 2 ถัง"),_c('br'),_vm._v("\n                    สิงห์ 30L: Supply เฉลี่ย 100 L/วัน → 100÷30 = 3.33 ≈ 3 ถัง (ปัดลง)"),_c('br'),_vm._v("\n                    สิงห์ 50L: Supply เฉลี่ย 90 L/วัน → 90÷50 = 1.8 ≈ 2 ถัง (ปัดขึ้น)"),_c('br'),_vm._v(" "),_c('b',[_vm._v("ลบ:")]),_vm._v(" ยอดเฉพาะ SKU 3 ตัวนี้ = "),_c('b',[_vm._v("220 L (7-9 ถัง แล้วแต่ SKU)")]),_vm._v(" — ตัวอย่างจำลอง"),_c('br'),_vm._v(" "),_c('b',[_vm._v("รวม (ลิตร)")]),_vm._v(" = 30 + 100 + 90 = "),_c('b',[_vm._v("220 L/วัน")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("รวม (ถัง)")]),_vm._v(" = 2 + 3 + 2 = "),_c('b',[_vm._v("7 ถัง/วัน")]),_vm._v(" — ตัวเลขจริงในหน้าจอต้องรวมทั้ง 8 SKU ในคลัง = 9 ถัง")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มาของข้อมูล:")]),_c('br'),_vm._v("\n                    • Supply (ตามหน้างานจริง) สะสมของแต่ละ SKU = ใบงาน \"ผลิตเบียร์สด\" (#02) ที่ปิดเสร็จ"),_c('br'),_vm._v("\n                    • จำนวนวันขาย (ตามเป้าหมาย) = ทีมกลยุทธ์กรอกในหน้า \"จัดการข้อมูล Stock Cover Days\""),_c('br'),_vm._v("\n                    • ขนาดถังของแต่ละ SKU = ดึงจากตาราง Master_Product ช่อง NETVOLUME")]),_vm._v(" "),_c('div',{staticClass:"formula-important"},[_vm._v("⚠️ "),_c('b',[_vm._v("ห้าม")]),_vm._v(" คำนวณ \"ถังรวม\" โดยเอา \"ลิตรรวม\" หารด้วย 30 ก้อนใหญ่ — เบียร์แต่ละขนาดถังต่างกัน จะคลาดเคลื่อน 20-40% "),_c('b',[_vm._v("ต้องแปลงทีละสินค้าก่อนแล้วค่อยรวม")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-group",attrs:{"id":"widget-common"}},[_c('div',{staticClass:"widget-group-title"},[_vm._v("⚙️ หลักการคำนวณกลาง (ใช้ทุกกล่อง)")]),_vm._v(" "),_c('div',{staticClass:"widget-group-body"},[_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("1")]),_vm._v("จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา — สำหรับเดือนปัจจุบัน")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("ไม่แสดงตรง ๆ ในหน้าจอ")]),_vm._v(" — เป็นค่ากลางที่ใช้คำนวณ Demand เฉลี่ย และ Supply เฉลี่ย")]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("Concept")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"font-size":"11px","line-height":"1.7"}},[_vm._v("\n                        📅 "),_c('b',[_vm._v("วันนี้ 15/07/2026")]),_vm._v(" — ก.ค. มี 31 วันปฏิทิน"),_c('br'),_vm._v("\n                        📅 ทีมกลยุทธ์กรอก: "),_c('b',[_vm._v("จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน = 26 วัน")]),_vm._v(" (มีวันหยุด)"),_c('br'),_vm._v("\n                        ⏳ วันปฏิทินผ่านมา: "),_c('b',[_vm._v("15 วัน")]),_c('br'),_vm._v("\n                        ✅ ผลลัพธ์: 26 × (15/31) = 12.58 → "),_c('span',{staticClass:"visual-highlight"},[_vm._v("13 วัน")])])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา = จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน\n                                    × (วันปฏิทินผ่านมา ÷ วันปฏิทินเต็มเดือน)")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่างการคำนวณ (วันที่ 15 ก.ค. 2026):")]),_c('br'),_vm._v("\n                    Step 1: จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน ก.ค. = "),_c('b',[_vm._v("26 วัน")]),_vm._v(" (ทีมกลยุทธ์กรอก)"),_c('br'),_vm._v("\n                    Step 2: วันปฏิทินผ่านมา = "),_c('b',[_vm._v("15 วัน")]),_vm._v(" · วันปฏิทินเต็มเดือน ก.ค. = "),_c('b',[_vm._v("31 วัน")]),_c('br'),_vm._v("\n                    Step 3: จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา = 26 × (15÷31) = 12.58 ≈ "),_c('b',[_vm._v("13 วัน")]),_vm._v(" (ปัดขึ้น 0.58 ≥ 0.5)")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มาของข้อมูล:")]),_c('br'),_vm._v("\n                    • จำนวนวันขาย (ตามเป้าหมาย) ทั้งเดือน = ทีมกลยุทธ์กรอกในหน้า \"จัดการข้อมูล Stock Cover Days\" (คอลัมน์ \"จำนวนวันขาย\")"),_c('br'),_vm._v("\n                    • วันปฏิทินผ่านมา = นับจากวันที่ 1 ถึงวันนี้"),_c('br'),_vm._v("\n                    • วันปฏิทินเต็มเดือน = จำนวนวันในเดือนนั้น (28/30/31)")]),_vm._v(" "),_c('div',{staticClass:"formula-important"},[_vm._v("⚠️ "),_c('b',[_vm._v("ห้าม")]),_vm._v(" หารด้วยวันปฏิทินตรง ๆ (เช่น หาร 31 หรือ 15) เพราะไม่สะท้อนวันขายจริง — บริษัทมีวันหยุด")])]),_vm._v(" "),_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("2")]),_vm._v("การแปลงหน่วย ลิตร → ถัง (Per-SKU)")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("อยู่ที่:")]),_vm._v(" ทุกจุดในหน้าจอที่ตัวเลขอยู่ในรูปแบบ "),_c('b',[_vm._v("\"X L (Y ถัง)\"")])]),_vm._v(" "),_c('div',{staticClass:"formula-visual"},[_c('div',{staticClass:"formula-visual-label"},[_vm._v("ตัวอย่างจุดที่มีการแปลงหน่วย")]),_vm._v(" "),_c('div',{staticClass:"visual-mockup"},[_c('div',{staticStyle:{"font-size":"11px","line-height":"1.8"}},[_vm._v("\n                        Demand: "),_c('span',{staticClass:"visual-highlight"},[_vm._v("65 L (4 ถัง)")]),_vm._v("/วัน"),_c('br'),_vm._v("\n                        Stock ปัจจุบัน: "),_c('span',{staticClass:"visual-highlight"},[_vm._v("100 L (7 ถัง)")]),_c('br'),_vm._v("\n                        ต้องผลิตเพิ่ม "),_c('span',{staticClass:"visual-highlight"},[_vm._v("1,205 L (80 ถัง)")])])])]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("ถัง = ลิตร ÷ ขนาดถังของสินค้า (Per-SKU)\n\nขนาดถังที่รองรับในระบบ: 15 / 20 / 22.7 / 22.9 / 25 / 30 / 50 ลิตร\n(จากตาราง Master_Product ช่อง NETVOLUME — ทีมพัฒนา verify ก่อน implement)")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่างการคำนวณ (เบียร์สดสิงห์ 15L, ขนาดถัง 15 L):")]),_c('br'),_vm._v("\n                    • 65 L (Demand เฉลี่ย/วัน) ÷ 15 = 4.33 ≈ "),_c('b',[_vm._v("4 ถัง/วัน")]),_vm._v(" (ปัดลง 0.33 < 0.5)"),_c('br'),_vm._v("\n                    • 100 L (BG Stock ปัจจุบัน) ÷ 15 = 6.67 ≈ "),_c('b',[_vm._v("7 ถัง")]),_vm._v(" (ปัดขึ้น 0.67 ≥ 0.5)"),_c('br'),_vm._v("\n                    • 1,205 L (ต้องผลิตเพิ่ม) ÷ 15 = 80.33 ≈ "),_c('b',[_vm._v("80 ถัง")]),_vm._v(" (ปัดลง 0.33 < 0.5)")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ที่มา:")]),_vm._v(" ขนาดถังของแต่ละ SKU ดึงจากตาราง Master_Product ช่อง NETVOLUME (ปริมาตรสุทธิ)"),_c('br'),_vm._v(" "),_c('b',[_vm._v("ถ้าไม่มีข้อมูลขนาดถังของสินค้าใด:")]),_vm._v(" ระบบใช้ค่าเริ่มต้น 30 ลิตร (ตาม BRD)")]),_vm._v(" "),_c('div',{staticClass:"formula-important"},[_vm._v("⚠️ "),_c('b',[_vm._v("ทำทีละสินค้าเสมอ")]),_vm._v(" — ห้ามเอายอดรวมหลาย SKU หารด้วย 30 ก้อนใหญ่ (คลาดเคลื่อน 20-40% เพราะเบียร์แต่ละขนาดถังต่างกัน)")])]),_vm._v(" "),_c('div',{staticClass:"formula-section"},[_c('div',{staticClass:"formula-title"},[_c('span',{staticClass:"formula-number"},[_vm._v("3")]),_vm._v("การปัดเศษจำนวนถัง (round half up)")]),_vm._v(" "),_c('div',{staticClass:"formula-location"},[_vm._v("📍 "),_c('b',[_vm._v("ใช้ทุกที่")]),_vm._v(" ที่ต้องแปลง ลิตร → ถัง")]),_vm._v(" "),_c('div',{staticClass:"formula-code"},[_vm._v("ทศนิยม < 0.5   →  ปัดลง\nทศนิยม ≥ 0.5   →  ปัดขึ้น")]),_vm._v(" "),_c('div',{staticClass:"formula-example"},[_c('b',[_vm._v("ตัวอย่าง:")]),_c('br'),_vm._v("\n                    • 3.33 ถัง → "),_c('b',[_vm._v("3 ถัง")]),_vm._v("  (0.33 < 0.5 → ปัดลง)"),_c('br'),_vm._v("\n                    • 6.67 ถัง → "),_c('b',[_vm._v("7 ถัง")]),_vm._v("  (0.67 ≥ 0.5 → ปัดขึ้น)"),_c('br'),_vm._v("\n                    • 1.50 ถัง → "),_c('b',[_vm._v("2 ถัง")]),_vm._v("  (0.50 ≥ 0.5 → ปัดขึ้น)"),_c('br'),_vm._v("\n                    • 13.10 ถัง → "),_c('b',[_vm._v("13 ถัง")]),_vm._v("  (0.10 < 0.5 → ปัดลง)"),_c('br'),_vm._v("\n                    • 12.58 วัน → "),_c('b',[_vm._v("13 วัน")]),_vm._v("  (0.58 ≥ 0.5 → ปัดขึ้น) — ใช้กับ \"จำนวนวันขายที่ผ่านมา\" ด้วย")]),_vm._v(" "),_c('div',{staticClass:"formula-source"},[_vm._v("🗂️ "),_c('b',[_vm._v("ใช้ที่ไหนบ้าง:")]),_c('br'),_vm._v("\n                    • ทุกจุดที่แปลง ลิตร → ถัง (Alert Board, Bullet Chart, Heatmap)"),_c('br'),_vm._v("\n                    • จำนวนวันขาย (ตามเป้าหมาย) ที่ผ่านมา (Common หัวข้อ 1)"),_c('br'),_vm._v("\n                    • ตัวเลข SCVD ทุกจุด (เมื่อเป็นเลขทศนิยม)")]),_vm._v(" "),_c('div',{staticClass:"formula-important"},[_vm._v("⚠️ "),_c('b',[_vm._v("ห้าม")]),_vm._v(" ใช้ปัดขึ้นเสมอ หรือปัดลงเสมอ เพราะจะทำให้ตัวเลขเบี้ยว (เกิดผลกระทบสะสมกับ Demand/Supply รวมทั้งคลัง)")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("⚙️ แผงตั้งค่าเกณฑ์การแสดงผลจำนวน Stock Cover Days")]),_vm._v(" "),_c('div',{staticClass:"modal-subtitle"},[_vm._v("กำหนดเกณฑ์สถานะ (3-6 ระดับ) พร้อมสี แนวทางแก้ไข และ Target SCVD (จำลอง)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"52px"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticStyle:{"width":"72px"}},[_vm._v("จากวัน")]),_vm._v(" "),_c('th',{staticStyle:{"width":"72px"}},[_vm._v("ถึงวัน")]),_vm._v(" "),_c('th',{staticStyle:{"width":"150px"}},[_vm._v("ชื่อสถานะ")]),_vm._v(" "),_c('th',[_vm._v("แนวทางแก้ไข")]),_vm._v(" "),_c('th',{staticStyle:{"width":"64px"}},[_vm._v("สี")]),_vm._v(" "),_c('th',{staticStyle:{"width":"54px"}},[_vm._v("ลบ")])])])}]


/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/BeerClaimReport/StatusBeerClaimMonthly'),expression:"$route.path == '/BeerClaimReport/StatusBeerClaimMonthly'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reSalesAreaOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reSalesArea),callback:function ($$v) {_vm.reSalesArea=$$v},expression:"reSalesArea"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadreAgentCodesOptions},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะการเคลม:")]),_vm._v(" "),_c('select2',{ref:"bcClaimStatusCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'bcClaimStatusCode',"name":'bcClaimStatusCode',"select2-options":_vm.bcClaimStatusCodeOptions},model:{value:(_vm.bcClaimStatusCode),callback:function ($$v) {_vm.bcClaimStatusCode=$$v},expression:"bcClaimStatusCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"StatusTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"15"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(3)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่ใบเคลม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้อนุมัติการเคลม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("น้ำหนัก")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปัญหาที่พบ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รายละเอียดของปัญหาที่พบ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะการเคลม")])])}]


/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/BarButlerByBrand'),expression:"$route.path == '/PMReport/BarButlerByBrand'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM', 
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM', \n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadreAgentCodesOptions,"deselect":_vm.AgentClearAfterselect},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',\n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrSubAgentCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentCodes',"name":'pmrSubAgentCodes',"select2-options":_vm.pmrSubAgentCodeOptions,"multiple":""},model:{value:(_vm.pmrSubAgentCodes),callback:function ($$v) {_vm.pmrSubAgentCodes=$$v},expression:"pmrSubAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reDepartmentsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE (เครื่องทำความเย็น):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBarcodeMachine),expression:"reBarcodeMachine"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reBarcodeMachine)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBarcodeMachine=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทเครื่อง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reMachineTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reMachineType),callback:function ($$v) {_vm.reMachineType=$$v},expression:"reMachineType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type(เครื่อง):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMMachineOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMMachineType),callback:function ($$v) {_vm.rePMMachineType=$$v},expression:"rePMMachineType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE (หัวจ่าย):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBarcodeBarbutler),expression:"reBarcodeBarbutler"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reBarcodeBarbutler)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBarcodeBarbutler=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทหัวจ่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBarbutlerTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBarbutlerType),callback:function ($$v) {_vm.reBarbutlerType=$$v},expression:"reBarbutlerType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Type(หัวจ่าย):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMDispenserOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMDispenserType),callback:function ($$v) {_vm.rePMDispenserType=$$v},expression:"rePMDispenserType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{ref:"reProductBrandIdSelect2",attrs:{"multiple":true,"options":_vm.rePMPMBrandOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reProductBrandId),callback:function ($$v) {_vm.reProductBrandId=$$v},expression:"reProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"reProvinceIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reProvinceId',"name":'reProvinceId',"select2-options":_vm.reProvinceIdOptions},model:{value:(_vm.reProvinceId),callback:function ($$v) {_vm.reProvinceId=$$v},expression:"reProvinceId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"reAmpherIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAmpherId',"name":'reAmpherId',"select2-options":_vm.reAmpherIdOptions},model:{value:(_vm.reAmpherId),callback:function ($$v) {_vm.reAmpherId=$$v},expression:"reAmpherId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMShopTypeId),callback:function ($$v) {_vm.rePMShopTypeId=$$v},expression:"rePMShopTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmShopGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmShopGroupId),callback:function ($$v) {_vm.shmShopGroupId=$$v},expression:"shmShopGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทการล้างเครื่อง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmPMTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmPMTypeId),callback:function ($$v) {_vm.shmPMTypeId=$$v},expression:"shmPMTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"reShopStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reShopStatus',"name":'reShopStatus',"select2-options":_vm.reShopStatusOptions},model:{value:(_vm.reShopStatus),callback:function ($$v) {_vm.reShopStatus=$$v},expression:"reShopStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("ข้อมูลระหว่างวันที่(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ข้อมูลระหว่างวันที่(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4",staticStyle:{"display":"none"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reIsTransaction),expression:"reIsTransaction"}],staticClass:"form-check-input",attrs:{"id":"reIsTransaction","name":"reIsTransaction","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.reIsTransaction)?_vm._i(_vm.reIsTransaction,null)>-1:(_vm.reIsTransaction)},on:{"change":function($event){var $$a=_vm.reIsTransaction,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.reIsTransaction=$$a.concat([$$v]))}else{$$i>-1&&(_vm.reIsTransaction=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.reIsTransaction=$$c}}}}),_vm._v("\n                    สถานะปัจจุบัน\n                    "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":function($event){return _vm.formReset($event)}}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportMasterShop}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"BarbutlerTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"33"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทการล้างเครื่อง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Module")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่บันทึกข้อมูลอุปกรณ์")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วัน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เดือน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE (เครื่องทำความเย็น)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทเครื่องทำความเย็น")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Type (เครื่องทำความเย็น)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Type (หัวจ่าย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE (หัวจ่าย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทหัวจ่าย")])])}]


/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทการเคลม:")]),_vm._v(" "),_c('select2',{ref:"abcClaimTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'abcClaimTypeCode',"name":'abcClaimTypeCode',"select2-options":_vm.abcClaimTypeCodeOptions,"disabled":""},on:{"selectChange":_vm.onClaimTypeCodeChange},model:{value:(_vm.abcClaimTypeCode),callback:function ($$v) {_vm.abcClaimTypeCode=$$v},expression:"abcClaimTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'"}],staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"abcAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcAgentCode',"name":'abcAgentCode',"select2-options":_vm.abcAgentCodeOptions},on:{"selectChange":_vm.onAgentCodeChange},model:{value:(_vm.abcAgentCode),callback:function ($$v) {_vm.abcAgentCode=$$v},expression:"abcAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"}],staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"abcShopCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcShopCode',"name":'abcShopCode',"select2-options":_vm.abcShopCodeOptions},on:{"selectChange":_vm.onShopCodeChange},model:{value:(_vm.abcShopCode),callback:function ($$v) {_vm.abcShopCode=$$v},expression:"abcShopCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อำเภอ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcAmpher),expression:"abcAmpher"}],staticClass:"form-control",attrs:{"id":"abcAmpher","name":"abcAmpher","type":"text","maxlength":"450","placeholder":"อำเภอ","disabled":""},domProps:{"value":(_vm.abcAmpher)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcAmpher=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcProvince),expression:"abcProvince"}],staticClass:"form-control",attrs:{"id":"abcProvince","name":"abcProvince","type":"text","maxlength":"450","placeholder":"จังหวัด","disabled":""},domProps:{"value":(_vm.abcProvince)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcProvince=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcPhone),expression:"abcPhone"}],staticClass:"form-control",attrs:{"id":"abcPhone","name":"abcPhone","type":"text","maxlength":"450","placeholder":"เบอร์โทร","disabled":""},domProps:{"value":(_vm.abcPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcPhone=$event.target.value}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.abcClaimTypeCode != null &&
              (_vm.abcAgentCode != null || _vm.abcShopCode != null)
          ),expression:"\n            abcClaimTypeCode != null &&\n              (abcAgentCode != null || abcShopCode != null)\n          "}],staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้าเคลม:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(
                        _vm.abcClaimItems == null || _vm.abcClaimItems.length == 0
                      )?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.abcClaimItems),function(item,i){return [_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.productBrand))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.material))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.barcodeOld))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.depCode))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.problemType))]),_vm._v(" "),_c('td',[_c('center',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(
                                !item.claimItemId ||
                                  (!!item.claimItemId && item.claimStatusCode == 'CLAIM_STATUS_SUBMIT') ||
                                  (!!item.claimItemId && item.isBeerClaimAdmin)
                              ),expression:"\n                                !item.claimItemId ||\n                                  (!!item.claimItemId && item.claimStatusCode == 'CLAIM_STATUS_SUBMIT') ||\n                                  (!!item.claimItemId && item.isBeerClaimAdmin)\n                              "}],staticClass:"btn btn-outline-hover-warning btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onEditItemClick(i)}}},[_c('i',{staticClass:"text-warning la la-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(
                                !item.claimItemId ||
                                  (!!item.claimItemId &&
                                    item.claimStatusCode ==
                                      'CLAIM_STATUS_SUBMIT')
                              ),expression:"\n                                !item.claimItemId ||\n                                  (!!item.claimItemId &&\n                                    item.claimStatusCode ==\n                                      'CLAIM_STATUS_SUBMIT')\n                              "}],staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveItemClick(i)}}},[_c('i',{staticClass:"text-danger la la-trash"})])])],1)])]})],2),_vm._v(" "),(_vm.abcClaimItems == null || _vm.abcClaimItems.length == 0)?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"9"}},[(
                            this.$root.canShow([
                              'ADMIN_BEER_CLAIM',
                              'AGENT_ADMIN_BEER_CLAIM' ])
                          )?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":this.$route.params.id + '/AddItem/add_' + _vm.index,"tag":"button","title":"เพิ่ม Claim Item"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่ม Claim Item\n                        ")]):_vm._e()],1)])]):_vm._e()])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ปัญหาที่พบ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/AlertReport/OverdueAll'),expression:"$route.path == '/AlertReport/OverdueAll'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+" "),_c('br'),_vm._v(" "),_c('i',{staticClass:"text-danger",staticStyle:{"font-size":"0.8em"}},[_vm._v("* รายงานแจ้งเตือนคงค้างเลยกำหนดการคืนโรงงาน")])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[(this.$root.canShow(['super_admin']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ต้นทาง(โรงงาน/คลังสินค้า):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.OdCurrentLocationPlantOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OdCurrentLocationPlant),callback:function ($$v) {_vm.OdCurrentLocationPlant=$$v},expression:"OdCurrentLocationPlant"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับเข้าจากโรงงาน(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"StartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"StartDate","name":"StartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับเข้าจากโรงงาน(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"EndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"EndDate","name":"EndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.OdBarcode),expression:"OdBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.OdBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.OdBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.OdProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OdProductTypeId),callback:function ($$v) {_vm.OdProductTypeId=$$v},expression:"OdProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.OdAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OdAssetCode),callback:function ($$v) {_vm.OdAssetCode=$$v},expression:"OdAssetCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.OdBrandIdOptions,"placeholder":"กรุณาเลือก"},on:{"select":_vm.OdBrandIdClearAfterselect,"deselect":_vm.OdBrandIdDeSelect},model:{value:(_vm.OdBrandId),callback:function ($$v) {_vm.OdBrandId=$$v},expression:"OdBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อแบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{ref:"OdFinishProductId",attrs:{"id":"OdFinishProductId","multiple":true,"load-options":_vm.LoadOdFinishProductIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadOdFinishProductIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.OdFinishProductId),callback:function ($$v) {_vm.OdFinishProductId=$$v},expression:"OdFinishProductId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("เดือน(คงค้าง):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"OdOverMonth",staticClass:"form-control",attrs:{"type":"text","placeholder":"(ดด/ปปปป)","id":"OdOverMonth","name":"OdOverMonth","autocomplete":"off"}}),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ช่วงเวลา:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"OdPeriodRange","multiple":false,"options":_vm.OdPeriodRangeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OdPeriodRange),callback:function ($$v) {_vm.OdPeriodRange=$$v},expression:"OdPeriodRange"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.OdScanByUserOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OdScanByUser),callback:function ($$v) {_vm.OdScanByUser=$$v},expression:"OdScanByUser"}})],1)]),_vm._v(" "),(this.$root.canShow(['super_admin']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("มุมมองผู้ใช้งาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"ViewPermissionCode","multiple":false,"options":_vm.OdViewPermissionOptions,"placeholder":"กรุณาเลือก","clearable":false,"clear-on-select":false},on:{"input":function($event){return _vm.ChangeOptions('View')}},model:{value:(_vm.ViewPermissionCode),callback:function ($$v) {_vm.ViewPermissionCode=$$v},expression:"ViewPermissionCode"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('Collapsible',{staticClass:"product-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหาผู้ถือครอง\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la\tla-plus-square"}),_vm._v(" ค้นหาผู้ถือครอง\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"product"}},[_c('div',{staticClass:"row"},[(this.$root.canShow(['BR_REPORT','AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ถือครอง(ตัวแทนจำหน่าย):")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"OdCurrentLocationAgent","multiple":true,"options":_vm.OdCurrentLocationAgentOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.AgentClearAfterselect,"deselect":_vm.AgentClearAfterselect},model:{value:(_vm.OdCurrentLocationAgent),callback:function ($$v) {_vm.OdCurrentLocationAgent=$$v},expression:"OdCurrentLocationAgent"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT','SUB_AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ถือครอง(ตัวแทนจำหน่ายย่อย):")]),_vm._v(" "),_c('treeselect',{ref:"OdCurrentLocationSubAgent",attrs:{"id":"OdCurrentLocationSubAgent","multiple":true,"load-options":_vm.LoadOdCurrentLocationSubAgentOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadOdCurrentLocationSubAgentOptions,"select":_vm.SubAgentClearAfterselect},model:{value:(_vm.OdCurrentLocationSubAgent),callback:function ($$v) {_vm.OdCurrentLocationSubAgent=$$v},expression:"OdCurrentLocationSubAgent"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ถือครอง(ร้านค้าตัวแทน):")]),_vm._v(" "),_c('treeselect',{ref:"OdCurrentLocationShop",attrs:{"id":"OdCurrentLocationShop","multiple":true,"load-options":_vm.LoadOdCurrentLocationShopOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadOdCurrentLocationShopOptions,"select":_vm.ShopClearAfterselect},model:{value:(_vm.OdCurrentLocationShop),callback:function ($$v) {_vm.OdCurrentLocationShop=$$v},expression:"OdCurrentLocationShop"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT','SUB_AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ถือครอง(ร้านค้าตัวแทนจำหน่ายย่อย):")]),_vm._v(" "),_c('treeselect',{ref:"OdCurrentLocationSubShop",attrs:{"id":"OdCurrentLocationSubShop","multiple":true,"load-options":_vm.LoadOdCurrentLocationSubShopOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadOdCurrentLocationSubShopOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.OdCurrentLocationSubShop),callback:function ($$v) {_vm.OdCurrentLocationSubShop=$$v},expression:"OdCurrentLocationSubShop"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['BR_REPORT']) && _vm.ViewPermissionCode != 'AGENT_REPORT' && false)?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ถือครอง(ซัพพลายเออร์):")]),_vm._v(" "),_c('treeselect',{ref:"OdCurrentLocationVendor",attrs:{"multiple":true,"load-options":_vm.LoadOdCurrentLocationVendorOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadOdCurrentLocationVendorOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.OdCurrentLocationVendor),callback:function ($$v) {_vm.OdCurrentLocationVendor=$$v},expression:"OdCurrentLocationVendor"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['BR_REPORT']) && _vm.ViewPermissionCode != 'AGENT_REPORT' && false)?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("พนักงาน :")]),_vm._v(" "),_c('treeselect',{ref:"OdEmpId",attrs:{"multiple":true,"load-options":_vm.LoadOdEmpIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadOdEmpIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.OdEmpId),callback:function ($$v) {_vm.OdEmpId=$$v},expression:"OdEmpId"}})],1)]):_vm._e()])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[(this.$root.canShow(['AGENT_REPORT','SUB_AGENT_REPORT','BR_REPORT' ]))?_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportOverdueAll}},[_vm._m(4)]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]):_vm._e()])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/ManageTransport'),expression:"$route.path == '/Master/ManageTransport'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MtsKeyword),expression:"MtsKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ระบุคำค้นหา โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ทะเบียนรถ1, บริษัท1"},domProps:{"value":(_vm.MtsKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MtsKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"MtsStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'MtsStatus',"name":'MtsStatus',"select2-options":_vm.MtsStatusOptions},model:{value:(_vm.MtsStatus),callback:function ($$v) {_vm.MtsStatus=$$v},expression:"MtsStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(
                  this.$root.canShow(['MANAGE_MASTER', 'MANAGE_TRANSPORT'])
                )?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"ManageTransport/Add","tag":"button","title":"เพิ่ม"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่ม\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-truck"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("จัดการข้อมูลขนส่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"transportTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("ทะเบียนรถ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("บริษัท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อคนขับ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เบอร์ติดต่อ")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ผู้ประสานงาน")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("เบอร์ติดต่อผู้ประสานงาน")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("อีเมล")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MaintainReport/QISummary'),expression:"$route.path == '/MaintainReport/QISummary'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("ปี:")]),_vm._v(" "),_c('select2',{ref:"reYearStart",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reYearStart',"name":'reYearStart',"select2-options":_vm.reYearOptions},model:{value:(_vm.reYearStart),callback:function ($$v) {_vm.reYearStart=$$v},expression:"reYearStart"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('label',{staticClass:"label"},[_vm._v("สรุปข้อมูลงานช่างซ่อมบำรุง:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"6%"}},[_c('strong',[_vm._v("Y"+_vm._s(_vm.reYearStart))])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('th',{staticClass:"text-center"})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.months),function(month,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control-plaintext"},[_c('strong',[_vm._v(_vm._s(month))])])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.tableData[index].fixCost),expression:"tableData[index].fixCost",modifiers:{"number":true}}],staticClass:"form-control text-right",attrs:{"type":"number","step":"0.01","placeholder":"กรอก Fix Cost"},domProps:{"value":(_vm.tableData[index].fixCost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tableData[index], "fixCost", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n                            "+_vm._s(_vm.tableData[index].variableCost)+"\n                          ")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n                            "+_vm._s(_vm.calculateTotalCost(_vm.tableData[index].fixCost, _vm.tableData[index].variableCost))+"\n                          ")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n                            "+_vm._s(_vm.tableData[index].repairCost)+"\n                          ")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n                            "+_vm._s(_vm.calculateCostReduction(_vm.calculateTotalCost(_vm.tableData[index].fixCost, _vm.tableData[index].variableCost), _vm.tableData[index].repairCost))+"\n                          ")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n                            "+_vm._s(_vm.calculatePercentage(_vm.calculateCostReduction(_vm.calculateTotalCost(_vm.tableData[index].fixCost, _vm.tableData[index].variableCost), _vm.tableData[index].repairCost), _vm.tableData[index].repairCost))+"\n                          ")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.tableData[index].uplift),expression:"tableData[index].uplift",modifiers:{"number":true}}],staticClass:"form-control text-right",attrs:{"type":"number","step":"0.01","placeholder":"กรอก % Uplift"},domProps:{"value":(_vm.tableData[index].uplift)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tableData[index], "uplift", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control-plaintext d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-primary btn-sm btn-brand p-1 mr-1",attrs:{"type":"button"},on:{"click":function($event){return _vm.Recalculate(index)}}},[_vm._v("\n                              คำนวณใหม่\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm btn-brand p-1",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveSummary(index)}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v("บันทึก\n                            ")])])])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_vm._m(8),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.sumColumn('fixCost')))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.sumColumn('variableCost')))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.sumTotalCost()))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.sumColumn('repairCost')))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.sumCostReduction()))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.sumPercentage()))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.sumColumnUplift()))])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[(this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN']))?_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.exportExcel}},[_vm._m(9)])]):_vm._e()])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_c('strong',[_vm._v("Fix Cost")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_c('strong',[_vm._v("Variable Cost")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_c('strong',[_vm._v("Total Maintenance Cost")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_c('strong',[_vm._v("Repair Cost")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_c('strong',[_vm._v("Cost Reduction")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_c('strong',[_vm._v("Percentage")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_c('strong',[_vm._v("% Uplift")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center"},[_c('strong',[_vm._v("รวม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]),_vm._v(" "),(_vm.jobType == 'AUDIT_STOCK')?_c('td',{staticClass:"form-group"},[_c('div',{staticClass:"form-group kt-margin-0"},[_c('select2',{ref:"barcodeStatus",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control select-barcode-status required',"id":'barcodeStatus' + _vm._uid,"name":'barcodeStatus' + _vm._uid,"select2-options":_vm.MbBarcodeStatusOptions,"data-msg-required":"กรุณาเลือก"},on:{"selectChange":_vm.onBarcodeStatusChange},model:{value:(_vm.item.barcodeStatus),callback:function ($$v) {_vm.$set(_vm.item, "barcodeStatus", $$v)},expression:"item.barcodeStatus"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('span',{staticClass:"form-text"})]):_vm._e(),_vm._v(" "),_c('td',[_c('div',{staticClass:"form-group kt-margin-0"},[_c('select2',{ref:"materialCode",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control required',"id":'materialCode' + _vm._uid,"name":'materialCode' + _vm._uid,"select2-options":_vm.materialCodeOptions,"data-msg-required":"กรุณาเลือกสินค้า/ทรัพย์สิน"},on:{"selectChange":_vm.onMaterialCodeChange},model:{value:(_vm.item.materialCode),callback:function ($$v) {_vm.$set(_vm.item, "materialCode", $$v)},expression:"item.materialCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),(
        (_vm.item.selectedMaterialCodeData && !_vm.item.selectedMaterialCodeData.data.hasBarcode) && _vm.jobType != 'AUDIT_STOCK' 
      )?_c('span',{staticClass:"text-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v("\n      ไม่สามารถสแกนบาร์โค้ดบน Handheld ได้\n    ")]):_vm._e(),_vm._v(" "),(
        _vm.item.selectedMaterialCodeData &&
          !_vm.item.selectedMaterialCodeData.data.hasBarcode &&
          (_vm.jobType == 'BORROW' || _vm.jobType == 'DESTROY')
      )?_c('div',{staticClass:"form-group kt-margin-0"},[_c('label',[_vm._v("โควต้าสำหรับอัพเดทสต็อก")]),_vm._v(" "),_c('select2',{ref:"quotaOptions",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control required',"id":'quota' + _vm._uid,"name":'quota' + _vm._uid,"select2-options":_vm.quotaOptions,"data-msg-required":"กรุณาเลือกโควต้าสำหรับอัพเดทสต็อก"},on:{"select2mounted":_vm.onQuotaMounted},model:{value:(_vm.item.quotaId),callback:function ($$v) {_vm.$set(_vm.item, "quotaId", $$v)},expression:"item.quotaId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1):_vm._e()]),_vm._v(" "),(_vm.jobType != 'AUDIT_STOCK')?_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.description),expression:"item.description"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"รายละเอียด","readonly":!_vm.isEditable},domProps:{"value":(_vm.item.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "description", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.quantity),expression:"item.quantity"}],staticClass:"form-control required min text-right",attrs:{"type":"number","min":"1","placeholder":"จำนวน","readonly":!_vm.isEditable && !_vm.isEdit,"id":'quantity' + _vm._uid,"name":'quantity' + _vm._uid,"data-msg-required":"กรุณากรอกจำนวน","data-msg-min":"ต้องมีจำนวนอย่างน้อย 1 ชิ้น"},domProps:{"value":(_vm.item.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "quantity", $event.target.value)}}}),_vm._v(" "),(_vm.item.checkedQuantity > 0)?_c('span',{staticClass:"text-info text-right",staticStyle:{"display":"block"}},[_c('i',{staticClass:"fa fa-qrcode"}),_vm._v("\n      สแกนแล้ว "+_vm._s(_vm.item.checkedQuantity)+" บาร์โค้ด\n    ")]):_vm._e(),_vm._v(" "),(_vm.jobType == 'RETRIEVE_ITEM' && _vm.item.productLoanReturn)?_c('span',{staticClass:"text-warning",staticStyle:{"display":"block"}},[_vm._v("\n      ส่งคืน "+_vm._s(_vm.item.productLoanReturn.return)+" "+_vm._s(_vm.item.unitName)),_c('br'),_vm._v("\n      ชำรุด "+_vm._s(_vm.item.productLoanReturn.damaged)+" "+_vm._s(_vm.item.unitName)),_c('br'),_vm._v("\n      สูญหาย "+_vm._s(_vm.item.productLoanReturn.lost)+" "+_vm._s(_vm.item.unitName)+"\n    ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"form-text"})]),_vm._v(" "),(_vm.jobType == 'AUDIT_STOCK')?_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.description),expression:"item.description"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"รายละเอียด","readonly":!_vm.isEditable},domProps:{"value":(_vm.item.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "description", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})]):_vm._e(),_vm._v(" "),(_vm.jobType != 'AUDIT_STOCK')?_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.item.unitName))])]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.jobType == 'AUDIT_STOCK')?_c('span'):_vm._e(),_vm._v(" "),(!_vm.isEditable && _vm.jobType != 'AUDIT_STOCK')?_c('button',{staticClass:"btn btn-outline-hover-info btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"แสดงรายการบาร์โค้ด"},on:{"click":function($event){$event.preventDefault();return _vm.onShowBarcodeClick($event)}}},[_c('i',{staticClass:"text-info la la-list"})]):_vm._e(),_vm._v(" "),(_vm.isEditable && (_vm.jobType != 'PICKUP' || (_vm.jobType == 'PICKUP' && _vm.item.checkedQuantity == 0)))?_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"ลบรายการ"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveItemClick($event)}}},[_c('i',{staticClass:"text-danger la la-trash"})]):_vm._e()])])}
var staticRenderFns = []


/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"agentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'agentCode',"name":'agentCode',"select2-options":_vm.agentCodeOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลปี :")]),_vm._v(" "),_c('select2',{ref:"year",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'year',"name":'year',"select2-options":_vm.yearOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)])]),_vm._v(" "),(_vm.year && _vm.canExportAllAgents && !_vm.isShow)?_c('div',{staticClass:"d-flex justify-content-end align-items-center mb-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n              "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.isShow == true)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              รายการจำนวนสินค้าที่สูญหายจำแนกตามมูลค่าสินค้า:\n            ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingSelected},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelSelected($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)")+"\n                ")])]),_vm._v(" "),(_vm.canExportAllAgents)?_c('button',{staticClass:"btn btn-outline-primary ml-2",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"2500px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"3%"}},[_vm._v("\n                        ลำดับ\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"10%"}},[_vm._v("\n                        ประเภทสินค้า\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        ต้นทุนสินค้า(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"12","scope":"colgroup"}},[_vm._v("\n                        จำนวนสินค้าที่สูญหาย (จำนวน) ปี "+_vm._s(_vm.year)+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้ารวม(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้าเฉลี่ย(บาท/เดือน)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        จัดการ\n                      ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('tbody',{on:{"change":function($event){return _vm.changeTotal()}}},[(_vm.productitems == null || _vm.productitems.length == 0)?_c('tr',[(
                          this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])
                        )?_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"18"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.productitems),function(item,i){return [_c('product-item-row',{key:i,ref:"Items",refInFor:true,attrs:{"rowIndex":i,"item":item,"kPIProductType":_vm.kPIProductType,"yearSelected":_vm.year},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"3%"}}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รวมเงิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_vm._l((12),function(index){return _c('th',{key:index,staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalMonth[index]," ", 0))+"\n                      ")])}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalPoductCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalProductCostOfMonth,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th')],2),_vm._v(" "),_c('tr',[(
                          this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])
                        )?_c('td',{attrs:{"colspan":"18"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[(
          _vm.isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])
        )?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand fas fa-book-open"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มกราคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กุมภาพันธ์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มีนาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("เมษายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤษภาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มิถุนายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กรกฎาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("สิงหาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กันยายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ตุลาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤศจิกายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ธันวาคม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])}]


/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+" "),_c('strong',[_vm._v(_vm._s(_vm.qiJobNumber))])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext",domProps:{"innerHTML":_vm._s(_vm.qiStatusName)}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(2),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.createdDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(3),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.finishedDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(4),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.createdUserName))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(5),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext",domProps:{"innerHTML":_vm._s(_vm.qiTypeName)}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_vm._m(6),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n                        "+_vm._s(_vm.qiAreaPlant ? 'ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด' : 'ซ่อมในตัวแทนจำหน่าย')+"\n                    ")])]),_vm._v(" "),(_vm.qiTypeCode == 'JOB_QI_TYPE_DRAWBACK')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(7),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.confirmedDate))])])]):_vm._e(),_vm._v(" "),(_vm.qiTypeCode == 'JOB_QI_TYPE_DRAWBACK')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(8),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.confirmedUserName))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first",attrs:{"id":"FormDrawback"}},[_c('div',{staticClass:"kt-section__body"},[_vm._m(9),_vm._v(" "),_c('span',{staticClass:"form-text mb-3"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-checkable"},[_c('thead',[_c('tr',{class:_vm.qiSubType === 1 ? 'table-warning' : 'table-info'},[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"30%"}},[_vm._v("รายการอุปกรณ์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ราคา/หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("มูลค่ารวม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"30%"}},[_vm._v("หมายเหตุ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("คำสั่ง")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,i){return _c('tr',{key:item.qiJobItemId},[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(i + 1))])]),_vm._v(" "),_c('td',[_c('select2',{ref:("materialSelect2-" + i),refInFor:true,staticClass:"form-control text-right",attrs:{"select2-options":_vm.getMaterialCodeOptions(i),"disabled":!_vm.isDisable},on:{"selectChange":function($event){return _vm.onMaterialCodeChange(i)}},model:{value:(item.materialCode),callback:function ($$v) {_vm.$set(item, "materialCode", $$v)},expression:"item.materialCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text text-danger"},[_vm._v(_vm._s(_vm.errors[i] && _vm.errors[i].materialCode ? _vm.errors[i].materialCode : ''))])],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.quantity),expression:"item.quantity",modifiers:{"number":true}}],ref:("quantity-" + i),refInFor:true,staticClass:"form-control text-right",attrs:{"type":"number","disabled":!_vm.isDisable},domProps:{"value":(item.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{staticClass:"form-text text-danger"},[_vm._v(_vm._s(_vm.errors[i] && _vm.errors[i].quantity ? _vm.errors[i].quantity : ''))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.unitPrice),expression:"item.unitPrice",modifiers:{"number":true}}],ref:("unitPrice-" + i),refInFor:true,staticClass:"form-control text-right",attrs:{"type":"number","step":"0.01"},domProps:{"value":(item.unitPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "unitPrice", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{staticClass:"form-text text-danger"},[_vm._v(_vm._s(_vm.errors[i] && _vm.errors[i].unitPrice ? _vm.errors[i].unitPrice : ''))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v("\n                                                "+_vm._s((item.quantity * item.unitPrice || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))+"\n                                            ")])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.remark),expression:"item.remark"}],staticClass:"form-control",attrs:{"type":"text","disabled":!_vm.isDisable},domProps:{"value":(item.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "remark", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(_vm.isDisable)?_c('span',[_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){return _vm.onRemoveItemClick(i)}}},[_c('i',{staticClass:"text-danger la la-trash"})])]):_vm._e()])])}),_vm._v(" "),_c('tr',[_vm._m(10),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_c('strong',[_vm._v(_vm._s(_vm.totalQuantity))])])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_c('strong',[_vm._v(_vm._s(_vm.totalValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))])])]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}})])],2),_vm._v(" "),(_vm.isDisable)?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"7"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                                            ")])])])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-2 col-md-2 col-sm-2"},[_c('label',{staticClass:"label"},[(_vm.pictures.length && _vm.pictures[0].downloadUrl)?_c('strong',[_vm._v("รูปภาพอุปกรณ์ :")]):_c('strong',[_vm._v("รูปภาพอุปกรณ์ : ไม่มีภาพถ่าย")])]),_vm._v(" "),(_vm.pictures.length && _vm.pictures[0].downloadUrl)?_c('div',[_c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"p-1 d-flex flex-column justify-content-center align-items-center border-dashed"},[(_vm.pictures[0])?_c('img',{staticStyle:{"object-fit":"contain","width":"100%","height":"100%"},attrs:{"src":_vm.pictures[0].downloadUrl},on:{"click":function($event){return _vm.showModal(_vm.pictures[0].downloadUrl)}}}):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"imageModal","tabindex":"-1","role":"dialog","aria-labelledby":"imageModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("ภาพถ่าย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticStyle:{"max-width":"90%","max-height":"90%","margin":"0 auto","display":"block"},attrs:{"src":_vm.modalImageURL}}),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_vm._m(11)])])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "+_vm._s(_vm.qiStatusCode == "JOB_QI_STATUS_SUCCESS" ? 'บันทึกข้อมูล' : 'ยืนยันข้อมูล')+"\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("สถานะการดำเนินการ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("วันที่สร้าง :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("วันที่ช่างบันทึกข้อมูลเบิก/คืน :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ชื่อช่าง :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ประเภทใบงาน :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("สถานที่ซ่อมอุปกรณ์:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("วันที่ยืนยันการตรวจสอบข้อมูล :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ผู้ยืนยันการตรวจสอบข้อมูล :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ข้อมูลการเบิก/คืน อุปกรณ์เบียร์สด :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right p-3",attrs:{"colspan":"2"}},[_c('strong',[_vm._v("รวมจำนวน/มูลค่ารวม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"modal-title"},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง")])}]


/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"SearchDetailModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสพนักงาน :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.aeEmployeeNO))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อพนักงาน :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.aeEmployeeName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เบอร์โทร :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.aeTel != null ? _vm.aeTel : "-"))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.aeEmail))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่ง :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.aePosition != null ? _vm.aePosition : "-"))])])])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")])])}]


/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.plReqDateString)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.plStatus)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.plProductType)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.plProductName)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.plQuota)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.plQty)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.plAgent)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.plShopActivityName)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.plActivityRemark)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.plReturnDate)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.plOutstanding)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.plReturn),expression:"item.plReturn"}],staticClass:"form-control text-center",attrs:{"disabled":_vm.item.IsDisabled,"type":"number","min":"0","id":'plReturn' + _vm._uid,"name":'plReturn' + _vm._uid},domProps:{"value":(_vm.item.plReturn)},on:{"keydown":_vm.preventInvalidChars,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "plReturn", $event.target.value)},function($event){return _vm.checkTotal(1)}]}}),_vm._v(" "),_c('span',{staticClass:"form-text"})]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.plDamaged),expression:"item.plDamaged"}],staticClass:"form-control text-center",attrs:{"disabled":_vm.item.plIsHide || _vm.item.IsDisabled,"type":"number","min":"0","id":'plDamaged' + _vm._uid,"name":'plDamaged' + _vm._uid},domProps:{"value":(_vm.item.plDamaged)},on:{"keydown":_vm.preventInvalidChars,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "plDamaged", $event.target.value)},function($event){return _vm.checkTotal(2)}]}}),_vm._v(" "),_c('span',{staticClass:"form-text"})]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.plLost),expression:"item.plLost"}],staticClass:"form-control text-center",attrs:{"disabled":_vm.item.IsDisabled,"type":"number","min":"0","id":'plLost' + _vm._uid,"name":'plLost' + _vm._uid},domProps:{"value":(_vm.item.plLost)},on:{"keydown":_vm.preventInvalidChars,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "plLost", $event.target.value)},function($event){return _vm.checkTotal(3)}]}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])}
var staticRenderFns = []


/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทการเคลม:")]),_vm._v(" "),_c('select2',{ref:"abcClaimTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'abcClaimTypeCode',"name":'abcClaimTypeCode',"select2-options":_vm.abcClaimTypeCodeOptions,"disabled":""},on:{"selectChange":_vm.onClaimTypeCodeChange},model:{value:(_vm.abcClaimTypeCode),callback:function ($$v) {_vm.abcClaimTypeCode=$$v},expression:"abcClaimTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'"}],staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"abcAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcAgentCode',"name":'abcAgentCode',"select2-options":_vm.abcAgentCodeOptions,"disabled":""},on:{"selectChange":_vm.onAgentCodeChange},model:{value:(_vm.abcAgentCode),callback:function ($$v) {_vm.abcAgentCode=$$v},expression:"abcAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"}],staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"abcShopCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcShopCode',"name":'abcShopCode',"select2-options":_vm.abcShopCodeOptions,"disabled":""},on:{"selectChange":_vm.onShopCodeChange},model:{value:(_vm.abcShopCode),callback:function ($$v) {_vm.abcShopCode=$$v},expression:"abcShopCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อำเภอ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcAmpher),expression:"abcAmpher"}],staticClass:"form-control",attrs:{"id":"abcAmpher","name":"abcAmpher","type":"text","maxlength":"450","placeholder":"อำเภอ","disabled":""},domProps:{"value":(_vm.abcAmpher)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcAmpher=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcProvince),expression:"abcProvince"}],staticClass:"form-control",attrs:{"id":"abcProvince","name":"abcProvince","type":"text","maxlength":"450","placeholder":"จังหวัด","disabled":""},domProps:{"value":(_vm.abcProvince)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcProvince=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcPhone),expression:"abcPhone"}],staticClass:"form-control",attrs:{"id":"abcPhone","name":"abcPhone","type":"text","maxlength":"450","placeholder":"เบอร์โทร","disabled":""},domProps:{"value":(_vm.abcPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcPhone=$event.target.value}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.abcClaimTypeCode != null &&
              (_vm.abcAgentCode != null || _vm.abcShopCode != null)
          ),expression:"\n            abcClaimTypeCode != null &&\n              (abcAgentCode != null || abcShopCode != null)\n          "}],staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้าเคลม:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(
                        _vm.abcClaimItems == null || _vm.abcClaimItems.length == 0
                      )?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.abcClaimItems),function(item,i){return [_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.productBrand))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.material))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.barcodeOld))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.depCode))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.problemType))]),_vm._v(" "),_c('td',[_c('center',[_c('button',{staticClass:"btn btn-outline-hover-warning btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onDetailItemClick(i)}}},[_c('i',{staticClass:"text-warning la la-file-text"})])])],1)])]})],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ปัญหาที่พบ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("คำสั่ง")])])])}]


/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MKTReport/SurveyOnOffPremise'),expression:"$route.path == '/MKTReport/SurveyOnOffPremise'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทงาน:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reObjectivesCode',"name":'reObjectivesCode',"select2-options":_vm.reObjectivesCodeOptions},model:{value:(_vm.reObjectivesCode),callback:function ($$v) {_vm.reObjectivesCode=$$v},expression:"reObjectivesCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เช็คอินเริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่เช็คอินสิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อเจ้าหน้าที่:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reUserIds',"name":'reUserIds',"select2-options":_vm.reUserIdsOptions},model:{value:(_vm.reUserIds),callback:function ($$v) {_vm.reUserIds=$$v},expression:"reUserIds"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportSurveyOnOffPremise}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"SurveyOnOffPremiseTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"26"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อเจ้าหน้าที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่เช็คอิน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ระยะเวลาที่เข้าทำงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("PG เชียร์ขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนPG เชียร์ขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ยอดขาย(ถัง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนถัง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("หัวจ่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนหัวจ่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ทาวเวอร์")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนทาวเวอร์")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เหยือก")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนเหยือก")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แก้ว")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนแก้ว")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("โต๊ะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนโต๊ะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เก้าอี้")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนเก้าอี้")])])}]


/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MaintainReport/StockPending'),expression:"$route.path == '/MaintainReport/StockPending'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่ประเมิน(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateStart","name":"jobsDateStart","readonly":""}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ประเมิน(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateEnd","name":"jobsDateEnd","readonly":""}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qiOldBarcode),expression:"qiOldBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"BARCODE"},domProps:{"value":(_vm.qiOldBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qiOldBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่ใบงาน :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qiJobNumber),expression:"qiJobNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"เลขที่ใบงาน"},domProps:{"value":(_vm.qiJobNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qiJobNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductCode","multiple":true,"options":_vm.qiProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductCode),callback:function ($$v) {_vm.qiProductCode=$$v},expression:"qiProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductType","multiple":true,"options":_vm.qiProductTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductType),callback:function ($$v) {_vm.qiProductType=$$v},expression:"qiProductType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductBrand","multiple":true,"options":_vm.qiProductBrandOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductBrand),callback:function ($$v) {_vm.qiProductBrand=$$v},expression:"qiProductBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("สถานะ:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiEvalStatus","multiple":true,"options":_vm.qiEvalStatusOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiEvalStatus),callback:function ($$v) {_vm.qiEvalStatus=$$v},expression:"qiEvalStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),(this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN']))?_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.exportExcel}},[_vm._m(3)])]):_vm._e()])]),_vm._v(" "),_vm._m(4)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"width":"100%"},attrs:{"id":"reportTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("แบรนด์")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ซ่อมเสร็จ/ทำลาย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("คงเหลือ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่ประเมิน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("อาการเสีย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")])])])])])])}]


/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทกิจกรรม:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktObjectives))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อกิจกรรม:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktActivityName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ตัวเทนจำหน่าย:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktAgentName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อร้านค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktShopName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อร้านค้า 2:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktShopName2))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktProvinceName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktShopType))])])]),_vm._v(" "),(
                _vm.mktObjectivesCode == 'MKT_ACTIVITY_TYPE_SURVEY_OFF_PREMISE' ||
                  _vm.mktObjectivesCode == 'MKT_ACTIVITY_TYPE_SURVEY_ON_PREMISE'
              )?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ตรวจเยี่ยมร้านค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktActivityDate))])])]):_vm._e(),_vm._v(" "),(
                _vm.mktObjectivesCode == 'MKT_ACTIVITY_TYPE_NEWSHOP_ON_PREMISE' ||
                  _vm.mktObjectivesCode == 'MKT_ACTIVITY_TYPE_NEWSHOP_OFF_PREMISE'
              )?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่เปิดร้านค้าใหม่:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktActivityDate))])])]):_vm._e(),_vm._v(" "),(_vm.mktObjectivesCode == 'MKT_ACTIVITY_TYPE_FOOD_FESTIVAL')?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น กิจกรรมมหกรรมอาหาร:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktActivityDateStart))])])]):_vm._e(),_vm._v(" "),(_vm.mktObjectivesCode == 'MKT_ACTIVITY_TYPE_EVENT')?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น กิจกรรม Event:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktActivityDateStart))])])]):_vm._e(),_vm._v(" "),(_vm.mktObjectivesCode == 'MKT_ACTIVITY_TYPE_FOOD_FESTIVAL')?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด กิจกรรมมหกรรมอาหาร:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktActivityDateEnd))])])]):_vm._e(),_vm._v(" "),(_vm.mktObjectivesCode == 'MKT_ACTIVITY_TYPE_EVENT')?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด กิจกรรม Event:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mktActivityDateEnd))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("PG เชียร์ขาย: ")]),_vm._v(" "),_c('ul',{attrs:{"id":"example-1"}},[_vm._l((_vm.mktSaleItemPG),function(item){return _c('li',{key:item.brandId},[_vm._v("\n                    "+_vm._s(item.brandName)+" จำนวน "+_vm._s(item.qty)+"\n                  ")])}),_vm._v(" "),(_vm.mktSaleItemPG.length == 0)?_c('span',[_vm._v("\n                    -\n                  ")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ยอดขาย(ถัง): ")]),_vm._v(" "),_c('ul',{attrs:{"id":"example-1"}},[_vm._l((_vm.mktSaleItem),function(item){return _c('li',{key:item.brandId},[_vm._v("\n                    "+_vm._s(item.brandName)+" จำนวน "+_vm._s(item.qty)+"\n                  ")])}),_vm._v(" "),(_vm.mktSaleItem.length == 0)?_c('span',[_vm._v("\n                    -\n                  ")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("การสนับสนุน: ")]),_vm._v(" "),_c('ul',{attrs:{"id":"example-1"}},[(_vm.mktBuget != 0)?_c('li',[_vm._v("\n                    งบประมาณ จำนวน "+_vm._s(_vm.mktBuget)+" บาท\n                  ")]):_vm._e()]),_vm._v(" "),_c('ul',{attrs:{"id":"example-1"}},[_vm._l((_vm.mktItem),function(item){return _c('li',{key:item.brandId},[_vm._v("\n                    "+_vm._s(item.itemTypeCodeName != null
                        ? item.itemTypeCodeName
                        : item.productBrandName != null
                        ? item.productBrandName
                        : item.productGroupName != null
                        ? item.productGroupName
                        : item.productTypeName != null
                        ? item.productTypeName
                        : null)+"\n                    "+_vm._s(item.productName != null ? item.productName : "")+"\n                    จำนวน "+_vm._s(item.qty)+"\n                    "),_c('ul',_vm._l((item.brandItems),function(itemB){return _c('li',{key:itemB.index},[_vm._v("\n                        "+_vm._s(itemB.productBrand)+"\n                      ")])}),0)])}),_vm._v(" "),(_vm.mktItem.length == 0)?_c('span',[_vm._v("\n                    -\n                  ")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("หมายเหตุ: ")]),_vm._v(" "),_c('ul',{attrs:{"id":"example-1"}},[_c('span',[_vm._v("\n                    "+_vm._s(_vm.mktRemark)+"\n                  ")]),_vm._v(" "),(!_vm.mktRemark)?_c('span',[_vm._v("\n                    -\n                  ")]):_vm._e()])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])}]


/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/PMSpare'),expression:"$route.path == '/PMReport/PMSpare'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reDepartment',"name":'reDepartment',"select2-options":_vm.reDepartmentOptions},on:{"selectChange":_vm.onDepartmentChange},model:{value:(_vm.reDepartment),callback:function ($$v) {_vm.reDepartment=$$v},expression:"reDepartment"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAgentCode',"name":'reAgentCode',"select2-options":_vm.reAgentCodeOptions},on:{"selectChange":function($event){return _vm.onReAgentCodesChange()}},model:{value:(_vm.reAgentCode),callback:function ($$v) {_vm.reAgentCode=$$v},expression:"reAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อช่าง:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reUserId',"name":'reUserId',"select2-options":_vm.reUserIdOptions},model:{value:(_vm.reUserId),callback:function ($$v) {_vm.reUserId=$$v},expression:"reUserId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportExcel}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"PMSpareTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"8"}},[_vm._v("ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq))])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เดือน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รายการอะไหล่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("\n                    จำนวนอะไหล่ที่ใช้ในการซ่อมบำรุง\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อช่าง")])])}]


/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/AdminReport/Survey'),expression:"$route.path == '/AdminReport/Survey'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin', 'ADMIN_PM'])),expression:"this.$root.canShow(['super_admin', 'ADMIN_PM'])"}],staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadreAgentCodesOptions},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reDepartmentsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทกิจกรรม:")]),_vm._v(" "),_c('select2',{ref:"reTypeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reType',"name":'reType',"select2-options":_vm.reTypeOptions},model:{value:(_vm.reType),callback:function ($$v) {_vm.reType=$$v},expression:"reType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เดือน:")]),_vm._v(" "),_c('select2',{ref:"reMonthSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reMonth',"name":'reMonth',"select2-options":_vm.reMonthOptions},model:{value:(_vm.reMonth),callback:function ($$v) {_vm.reMonth=$$v},expression:"reMonth"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปี :")]),_vm._v(" "),_c('select2',{ref:"reYear",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reYear',"name":'reYear',"select2-options":_vm.reYearOptions},model:{value:(_vm.reYear),callback:function ($$v) {_vm.reYear=$$v},expression:"reYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"reShopStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reShopStatus',"name":'reShopStatus',"select2-options":_vm.reShopStatusOptions},model:{value:(_vm.reShopStatus),callback:function ($$v) {_vm.reShopStatus=$$v},expression:"reShopStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('select2',{ref:"reProductBrandIdSelect2",attrs:{"id":"reProductBrandId","name":"reProductBrandId","css-style":'width: 100%;',"css-class":'form-control m-select2',"select2-options":_vm.reProductBrandIdOptions},model:{value:(_vm.reProductBrandId),callback:function ($$v) {_vm.reProductBrandId=$$v},expression:"reProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reUserIdsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reUserIds),callback:function ($$v) {_vm.reUserIds=$$v},expression:"reUserIds"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะผู้ดำเนินการ:")]),_vm._v(" "),_c('select2',{ref:"reUserStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reUserStatus',"name":'reUserStatus',"select2-options":_vm.reUserStatusOptions},model:{value:(_vm.reUserStatus),callback:function ($$v) {_vm.reUserStatus=$$v},expression:"reUserStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":function($event){return _vm.formReset($event)}}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportMasterShop}},[_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"SurveyTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"46"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(2)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ที่อยู่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตำบล")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("อำเภอ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสไปรษณีย์")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เดือน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้ดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D01")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D02")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D03")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D04")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D05")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D06")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D07")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D08")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D09")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D10")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D11")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D12")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D13")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D14")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D15")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D16")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D17")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D18")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D19")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D20")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D21")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D22")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D23")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D24")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D25")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D26")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D27")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D28")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D29")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D30")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D31")])])}]


/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",class:this.cssClass,style:(this.cssStyle),attrs:{"type":"text","id":this.id,"name":this.name}})}
var staticRenderFns = []


/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('button',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"type":"button","disabled":_vm.isExporting},on:{"click":_vm.exportExcel}},[_c('i',{class:_vm.isExporting ? 'fas fa-spinner fa-spin' : 'fas fa-file-excel'}),_vm._v("\n            "+_vm._s(_vm.isExporting ? 'กำลังดาวน์โหลด...' : 'Export Excel')+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.loadReport($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คลังสินค้า:")]),_vm._v(" "),_c('select2',{ref:"raPlantCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'raPlantCodes',"name":'raPlantCodes',"select2-options":_vm.plantOptions,"multiple":""},model:{value:(_vm.filterPlantCodes),callback:function ($$v) {_vm.filterPlantCodes=$$v},expression:"filterPlantCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('select2',{ref:"raProductCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'raProductCodes',"name":'raProductCodes',"select2-options":_vm.productOptions,"multiple":""},model:{value:(_vm.filterProductCodes),callback:function ($$v) {_vm.filterProductCodes=$$v},expression:"filterProductCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('select2',{ref:"raBrandIdsSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'raBrandIds',"name":'raBrandIds',"select2-options":_vm.brandOptions,"multiple":""},model:{value:(_vm.filterBrandIds),callback:function ($$v) {_vm.filterBrandIds=$$v},expression:"filterBrandIds"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ปี:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filterYear),expression:"filterYear",modifiers:{"number":true}}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.filterYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.yearOptions),function(y){return _c('option',{key:y,domProps:{"value":y}},[_vm._v(_vm._s(y))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Version ข้อมูล:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterVersion),expression:"filterVersion"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterVersion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("ล่าสุด")]),_vm._v(" "),_vm._l((_vm.versionOptions),function(v){return _c('option',{key:v,domProps:{"value":String(v)}},[_vm._v("Version"+_vm._s(v))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("หน่วย:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterUnit),expression:"filterUnit"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterUnit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"ลิตร"}},[_vm._v("ลิตร")]),_vm._v(" "),_c('option',{attrs:{"value":"ถัง"}},[_vm._v("ถัง")])])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.resetFilter}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"text-center py-5"},[_c('div',{staticClass:"kt-spinner kt-spinner--lg kt-spinner--brand"}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v("กำลังโหลดข้อมูล...")])]):(!_vm.report)?_c('div',{staticClass:"text-center text-muted py-4"},[_vm._v("\n          กดปุ่ม \"แสดงข้อมูล\" เพื่อดูรายงาน\n        ")]):_c('div',[_c('div',{staticClass:"mb-3 scd-summary"},[_c('div',{staticClass:"scd-summary-col"},[_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("คลังสินค้า :")]),_vm._v(" "+_vm._s(_vm.plantSummary))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("ชื่อสินค้า :")]),_vm._v(" "+_vm._s(_vm.productSummary))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("แบรนด์สินค้า :")]),_vm._v(" "+_vm._s(_vm.brandSummary))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("ปี :")]),_vm._v(" "+_vm._s(_vm.report.year))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Version ข้อมูล :")]),_vm._v(" "+_vm._s(_vm.versionLabel))])]),_vm._v(" "),_c('div',{staticClass:"scd-summary-col d-flex flex-column"},[_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Current Date :")]),_vm._v(" "+_vm._s(_vm.currentDateDisplay))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Day of week :")]),_vm._v(" "+_vm._s(_vm.dayOfWeekDisplay))]),_vm._v(" "),_c('div',{staticClass:"text-right mt-auto"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("หน่วย :")]),_vm._v(" "+_vm._s(_vm.report.unit))])])]),_vm._v(" "),(_vm.report.targetRows.length === 0)?_c('div',{staticClass:"text-center text-muted py-3"},[_vm._v("\n            ไม่พบข้อมูลตามเป้าหมายตามเงื่อนไขที่เลือก\n          ")]):_c('div',{staticClass:"table-responsive mb-4"},[_c('table',{staticClass:"table table-bordered table-sm scd-matrix mb-0"},[_c('colgroup',[_c('col',{staticClass:"scd-col-label"}),_vm._v(" "),_vm._l((_vm.monthLabels),function(lbl,i){return _c('col',{key:'tcol-' + i,staticClass:"scd-col-month"})}),_vm._v(" "),_c('col',{staticClass:"scd-col-total"})],2),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{staticClass:"scd-label scd-row-saledays"},[_vm._v("จำนวนวันขาย")]),_vm._v(" "),_vm._l((_vm.report.saleDaysByMonth),function(sd,i){return _c('td',{key:'t-sd-' + i,staticClass:"scd-row-saledays text-center"},[_vm._v(_vm._s(sd))])}),_vm._v(" "),_c('th',{staticClass:"scd-col-total-cell text-center"},[_vm._v("Total")])],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"scd-label scd-row-months"},[_vm._v(_vm._s(_vm.targetTitle))]),_vm._v(" "),_vm._l((_vm.monthLabels),function(lbl,i){return _c('td',{key:'t-ml-' + i,staticClass:"scd-row-months text-center font-weight-bold"},[_vm._v(_vm._s(lbl))])}),_vm._v(" "),_c('th',{staticClass:"scd-col-total-cell"})],2),_vm._v(" "),_vm._l((_vm.measureRows),function(mrow){return _c('tr',{key:'t-' + mrow.key},[_c('th',{staticClass:"scd-label",class:mrow.cls},[_vm._v(_vm._s(mrow.label))]),_vm._v(" "),_vm._l((_vm.totalMonths(_vm.report.targetTotal)),function(cell){return _c('td',{key:'t-c-' + mrow.key + '-' + cell.month,staticClass:"text-center",class:mrow.cls},[(!cell.hasData)?_c('span'):(mrow.key === 'scvd')?_c('span',[_vm._v(_vm._s(_vm.formatScvd(cell.scvd)))]):_c('span',[_vm._v(_vm._s(_vm.formatNum(cell[mrow.key])))])])}),_vm._v(" "),_c('td',{staticClass:"scd-col-total-cell text-center"},[(mrow.key === 'demand' || mrow.key === 'supply')?_c('span',[_vm._v(_vm._s(_vm.formatNum(_vm.measureTotal(_vm.report.targetTotal, mrow.key))))]):_vm._e()])],2)})],2)])]),_vm._v(" "),(_vm.report.actualBlocked || _vm.report.actualRows.length === 0)?_c('div',{staticClass:"text-center text-muted py-3"},[_vm._v("\n            ไม่พบข้อมูลตามหน้างานจริงตามเงื่อนไขที่เลือก\n          ")]):_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-sm scd-matrix mb-0"},[_c('colgroup',[_c('col',{staticClass:"scd-col-label"}),_vm._v(" "),_vm._l((_vm.monthLabels),function(lbl,i){return _c('col',{key:'acol-' + i,staticClass:"scd-col-month"})}),_vm._v(" "),_c('col',{staticClass:"scd-col-total"})],2),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{staticClass:"scd-label scd-row-months"},[_vm._v("ข้อมูลตามหน้างานจริง")]),_vm._v(" "),_vm._l((_vm.monthLabels),function(lbl,i){return _c('td',{key:'a-ml-' + i,staticClass:"scd-row-months text-center font-weight-bold"},[_vm._v(_vm._s(lbl))])}),_vm._v(" "),_c('th',{staticClass:"scd-col-total-cell"})],2),_vm._v(" "),_vm._l((_vm.measureRows),function(mrow){return _c('tr',{key:'a-' + mrow.key},[_c('th',{staticClass:"scd-label",class:mrow.cls},[_vm._v(_vm._s(mrow.label))]),_vm._v(" "),_vm._l((_vm.totalMonths(_vm.report.actualTotal)),function(cell){return _c('td',{key:'a-c-' + mrow.key + '-' + cell.month,staticClass:"text-center",class:mrow.cls},[(!cell.hasData)?_c('span'):(mrow.key === 'scvd')?_c('span',[_vm._v(_vm._s(_vm.formatScvd(cell.scvd)))]):_c('span',[_vm._v(_vm._s(_vm.formatNum(cell[mrow.key])))])])}),_vm._v(" "),_c('td',{staticClass:"scd-col-total-cell text-center"},[(mrow.key === 'demand' || mrow.key === 'supply')?_c('span',[_vm._v(_vm._s(_vm.formatNum(_vm.measureTotal(_vm.report.actualTotal, mrow.key))))]):_vm._e()])],2)})],2)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-chart-bar"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            Stock Cover Days — Report Analysis\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" แสดงข้อมูล\n              ")])}]


/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/Agents'),expression:"$route.path == '/Master/Agents'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.aglKeyword),expression:"aglKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก รหัสตัวแทนจำหน่าย ชื่อตัวแทนจำหน่าย อีเมล ที่อยู่ ชื่อผู้ติดต่อ เบอร์โทรผู้ติดต่อ"},domProps:{"value":(_vm.aglKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.aglKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"agentList_activeStatusKeySelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'agentList_activeStatusKey',"name":'agentList_activeStatusKey',"select2-options":_vm.agentList_activeStatusKeyOptions},model:{value:(_vm.agentList_activeStatusKey),callback:function ($$v) {_vm.agentList_activeStatusKey=$$v},expression:"agentList_activeStatusKey"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('label',[_vm._v("เขตการขาย(เบียร์สด) :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.alAreaNewOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.alAreaNew),callback:function ($$v) {_vm.alAreaNew=$$v},expression:"alAreaNew"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.agentListProvinceKeyOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.agentListProvinceKey),callback:function ($$v) {_vm.agentListProvinceKey=$$v},expression:"agentListProvinceKey"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"clear-on-select":true,"options":_vm.agentListAgentKeyOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.agentListAgentKey),callback:function ($$v) {_vm.agentListAgentKey=$$v},expression:"agentListAgentKey"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-4"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-8 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportAgent}},[_vm._m(1)])])])]),_vm._v(" "),_vm._m(2)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-user-tie"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"agentTable"}},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ที่อยู่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เขตการขาย(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("เบอร์โทร")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Email")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ชื่อผู้ติดต่อ")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("เบอร์โทรผู้ติดต่อ")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Lat")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Lng")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อบทบาท คำอธิบาย"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("ล้างค่าทั้งหมด")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['MANAGE_MASTER', 'MASTER_ROLE']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"Roles/Add","tag":"button","title":"เพิ่มข้อมูลบทบาท"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูลบทบาท\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon2-shield"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("บทบาท")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"roleTable"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("ชื่อบทบาท")]),_vm._v(" "),_c('th',[_vm._v("คำอธิบาย")]),_vm._v(" "),_c('th',[_vm._v("จำนวนสมาชิก")]),_vm._v(" "),_c('th',[_vm._v("คำสั่ง")])])])])])])}]


/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"custom-file-input",attrs:{"type":"file","id":"importProductHolding","lang":"es"},on:{"change":function($event){return _vm.chooseFile($event)}}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",attrs:{"for":"importProductHolding"}},[_vm._v("\n                "+_vm._s(_vm.Flie)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":function($event){return _vm.DownLoadTemplate()}}},[_c('i',{staticClass:"la la-save"}),_vm._v(" DownLoad Template\n            ")])])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"reset"},on:{"click":_vm.resetFile}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ล้างค่า\n      ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.submitBtn),expression:"submitBtn"}],staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",staticStyle:{"width":"100%"},attrs:{"id":"PreviewTable"}})])])}]


/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"SearchDetailModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสตัวแทนจำหน่าย :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.apAgentCode))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อตัวแทนจำหน่าย :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.apAgentName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ที่อยู่ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.apAdress))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.apArea))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.apProvince))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เบอร์โทร :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.apTel))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.apEmail))])])])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")])])}]


/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []


/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/Movement'),expression:"$route.path == '/Report/Movement'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reMmBarcode),expression:"reMmBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reMmBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reMmBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสทรัพย์สิน(เบียร์สด) :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreMmDepartmentMaterialCodeOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reMmDepartmentMaterialCode),callback:function ($$v) {_vm.reMmDepartmentMaterialCode=$$v},expression:"reMmDepartmentMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-xs-4"}),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-xs-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reMmTransactionDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reMmTransactionDateStart","name":"reMmTransactionDateStart","disabled":_vm.IsShowDatePicker,"readonly":""}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reMmTransactionDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reMmTransactionDateEnd","name":"reMmTransactionDateEnd","disabled":_vm.IsShowDatePicker,"readonly":""}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportMovement}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"movementTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"16"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reMmDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ต้นทาง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปลายทาง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ขนส่ง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ทะเบียนขนส่ง")])])}]


/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/Approver'),expression:"$route.path == '/Master/Approver'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.aplSearch),expression:"aplSearch"}],staticClass:"form-control",attrs:{"id":"aplSearch","name":"aplSearch","type":"text","placeholder":"ค้นหาจากรัหส กลุ่มการอนุมัติเบิกยืม"},domProps:{"value":(_vm.aplSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.aplSearch=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.aplAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.aplAgentCode),callback:function ($$v) {_vm.aplAgentCode=$$v},expression:"aplAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("พนักงาน :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadaplEmpIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.aplEmpId),callback:function ($$v) {_vm.aplEmpId=$$v},expression:"aplEmpId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้อนุมัติ :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.aplApproverOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.aplApprover),callback:function ($$v) {_vm.aplApprover=$$v},expression:"aplApprover"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"aplInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'aplInActiveStatus',"name":'aplInActiveStatus',"select2-options":_vm.aplInActiveStatusOptions},model:{value:(_vm.aplInActiveStatus),callback:function ($$v) {_vm.aplInActiveStatus=$$v},expression:"aplInActiveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(
                  this.$root.canShow(['MANAGE_MASTER', 'MANAGE_APPROVER'])
                )?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"Approver/Add","tag":"button","title":"เพิ่ม"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่ม\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-user-shield"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"approverTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("รหัสกลุ่มการอนุมัติเบิกยืม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("กลุ่มการอนุมัติเบิกยืม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.CheckRoute()),expression:"CheckRoute()"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n              "+_vm._s(this.$route.meta.breadcrumb)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])),expression:"this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])"}],staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.pmrAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.AgentClearAfterselect,"deselect":_vm.AgentClearAfterselect},model:{value:(_vm.pmrAgentCodes),callback:function ($$v) {_vm.pmrAgentCodes=$$v},expression:"pmrAgentCodes"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])),expression:"this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])"}],staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrShopCodes',"name":'pmrShopCodes',"select2-options":_vm.pmrShopCodesOptions,"multiple":""},on:{"selectChange":_vm.ShopClearAfterselect},model:{value:(_vm.pmrShopCodes),callback:function ($$v) {_vm.pmrShopCodes=$$v},expression:"pmrShopCodes"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin', 'ADMIN_PM'])),expression:"this.$root.canShow(['super_admin', 'ADMIN_PM'])"}],staticClass:"text-danger"})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])),expression:"this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])"}],staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrSubAgentCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentCodes',"name":'pmrSubAgentCodes',"select2-options":_vm.pmrSubAgentCodeOptions,"multiple":""},on:{"selectChange":_vm.SubAgentClearAfterselect},model:{value:(_vm.pmrSubAgentCodes),callback:function ($$v) {_vm.pmrSubAgentCodes=$$v},expression:"pmrSubAgentCodes"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])),expression:"this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])"}],staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentShopCodes',"name":'pmrSubAgentShopCodes',"select2-options":_vm.pmrSubAgentShopCodesOptions,"multiple":""},model:{value:(_vm.pmrSubAgentShopCodes),callback:function ($$v) {_vm.pmrSubAgentShopCodes=$$v},expression:"pmrSubAgentShopCodes"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])),expression:"this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])"}],staticClass:"text-danger"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์งาน PM:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMBrandOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMBrand),callback:function ($$v) {_vm.rePMBrand=$$v},expression:"rePMBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทการตั้งค่า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAlertConfigTypeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAlertConfigType),callback:function ($$v) {_vm.reAlertConfigType=$$v},expression:"reAlertConfigType"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                  ล้างค่าทั้งหมด\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"AlertPMConfig/Add","tag":"button","title":"เพิ่ม"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่ม \n                ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-money-check-alt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"brandTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทการตั้งค่า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.barcodeNoOld)),_c('br'),_vm._v("("+_vm._s(_vm.item.departmentMaterialCode)+")\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.materialCode)),_c('br'),_vm._v(_vm._s(_vm.item.materialName)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle",staticStyle:{"background-color":"#FB4B6B"}},[_c('select2',{ref:"originPlantCode2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'originPlantCode2' + _vm._uid,"name":'originPlantCode2' + _vm._uid,"select2-options":_vm.originPlantOptions},on:{"selectChange":_vm.onOriginPlantChange},model:{value:(_vm.item.originPlantCode2),callback:function ($$v) {_vm.$set(_vm.item, "originPlantCode2", $$v)},expression:"item.originPlantCode2"}})],1),_vm._v(" "),(_vm.item.destinationAgentCode != null)?_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.destinationAgentCode)),_c('br'),_vm._v(_vm._s(_vm.item.destinationAgentName)+"\n  ")]):_c('td',{staticClass:"text-center align-middle",staticStyle:{"background-color":"#FB4B6B"}}),_vm._v(" "),(_vm.item.cnStatusCode == 'CN_STATUS_BY_OTHER')?_c('td',{staticClass:"text-center align-middle",staticStyle:{"color":"#EB355E"}},[_vm._v("\n    "+_vm._s(_vm.item.cnStatusName)+"\n  ")]):_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(_vm.item.cnStatusName))]),_vm._v(" "),(_vm.item.cnToAgentCode != null)?_c('td',{staticClass:"text-center align-middle"},[_vm._v("\n    "+_vm._s(_vm.item.cnToAgentCode)),_c('br'),_vm._v(_vm._s(_vm.item.cnToAgentName)+"\n  ")]):_c('td',{staticClass:"text-center align-middle",staticStyle:{"background-color":"#FB4B6B"}}),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_c('select2',{ref:"cnToAgentCode2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'cnToAgentCode2' + _vm._uid,"name":'cnToAgentCode2' + _vm._uid,"select2-options":_vm.cnToAgentOptions},on:{"selectChange":_vm.onCnToAgentCode2Change},model:{value:(_vm.item.cnToAgentCode2),callback:function ($$v) {_vm.$set(_vm.item, "cnToAgentCode2", $$v)},expression:"item.cnToAgentCode2"}})],1)])}
var staticRenderFns = []


/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทผู้ติดต่อ:")]),_vm._v(" "),_c('select2',{ref:"cocContactTypeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'cocContactType',"name":'cocContactType',"select2-options":_vm.cocContactTypeOptions},model:{value:(_vm.cocContactType),callback:function ($$v) {_vm.cocContactType=$$v},expression:"cocContactType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.cocContactType != 'other'),expression:"cocContactType != 'other'"}],staticClass:"label-required"},[_vm._v("บริษัท:")]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.cocContactType == 'other'),expression:"cocContactType == 'other'"}]},[_vm._v("บริษัท:")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cocContactType == 'agent'),expression:"cocContactType == 'agent'"}]},[_c('select2',{ref:"cocAgentIdSelect2",class:'form-control',attrs:{"css-style":'width: 100%;',"id":'cocAgentId',"name":'cocAgentId',"select2-options":_vm.cocAgentOptions},model:{value:(_vm.cocAgentId),callback:function ($$v) {_vm.cocAgentId=$$v},expression:"cocAgentId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cocContactType == 'vendor'),expression:"cocContactType == 'vendor'"}]},[_c('select2',{ref:"cocVendorIdSelect2",class:'form-control',attrs:{"css-style":'width: 100%;',"id":'cocVendorId',"name":'cocVendorId',"select2-options":_vm.cocVendorOptions},model:{value:(_vm.cocVendorId),callback:function ($$v) {_vm.cocVendorId=$$v},expression:"cocVendorId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cocContactType == 'plant'),expression:"cocContactType == 'plant'"}]},[_c('select2',{ref:"cocPlantIdSelect2",class:'form-control',attrs:{"css-style":'width: 100%;',"id":'cocPlantId',"name":'cocPlantId',"select2-options":_vm.cocPlantOptions},model:{value:(_vm.cocPlantId),callback:function ($$v) {_vm.cocPlantId=$$v},expression:"cocPlantId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cocContactType == 'other'),expression:"cocContactType == 'other'"}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cocOtherId),expression:"cocOtherId"}],staticClass:"form-control",attrs:{"id":"cocOtherId","name":"cocOtherId","type":"text","maxlength":"450","placeholder":"ชื่อบริษัท"},domProps:{"value":(_vm.cocOtherId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cocOtherId=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.cocContactType),expression:"!cocContactType"}]},[_c('select2',{ref:"cocCompanyIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'cocCompanyId',"name":'cocCompanyId',"select2-options":_vm.cocCompanyIdOptions},model:{value:(_vm.cocCompanyId),callback:function ($$v) {_vm.cocCompanyId=$$v},expression:"cocCompanyId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cocContactName),expression:"cocContactName"}],staticClass:"form-control",attrs:{"id":"cocContactName","name":"cocContactName","type":"text","maxlength":"450","placeholder":"ชื่อผู้ติดต่อ"},domProps:{"value":(_vm.cocContactName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cocContactName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("นามสกุล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cocContactLastName),expression:"cocContactLastName"}],staticClass:"form-control",attrs:{"id":"cocContactLastName","name":"cocContactLastName","type":"text","maxlength":"450","placeholder":"นามสกุล"},domProps:{"value":(_vm.cocContactLastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cocContactLastName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตำแหน่ง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cocContactPositions),expression:"cocContactPositions"}],staticClass:"form-control",attrs:{"id":"cocContactPositions","name":"cocContactPositions","type":"text","maxlength":"450","placeholder":"ตำแหน่ง"},domProps:{"value":(_vm.cocContactPositions)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cocContactPositions=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อเล่น:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cocContactNickName),expression:"cocContactNickName"}],staticClass:"form-control",attrs:{"id":"cocContactNickName","name":"cocContactNickName","type":"text","maxlength":"450","placeholder":"ชื่อเล่น"},domProps:{"value":(_vm.cocContactNickName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cocContactNickName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cocContactTel),expression:"cocContactTel"}],staticClass:"form-control",attrs:{"id":"cocContactTel","name":"cocContactTel","type":"text","maxlength":"450","placeholder":"เบอร์ติดต่อ"},domProps:{"value":(_vm.cocContactTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cocContactTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("E-mail:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cocContactEmail),expression:"cocContactEmail"}],staticClass:"form-control",attrs:{"id":"cocContactEmail","name":"cocContactEmail","type":"text","maxlength":"450","placeholder":"E-mail"},domProps:{"value":(_vm.cocContactEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cocContactEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cocInActiveStatus),expression:"cocInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"cocInActiveStatus","id":"cocInActiveStatus"},domProps:{"checked":Array.isArray(_vm.cocInActiveStatus)?_vm._i(_vm.cocInActiveStatus,null)>-1:(_vm.cocInActiveStatus)},on:{"change":function($event){var $$a=_vm.cocInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cocInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cocInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cocInActiveStatus=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                    เปิดใช้งาน\n                    "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])}]


/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('router-link',{staticClass:"btn btn-secondary btn-sm",attrs:{"to":"/Monitoring/ScheduledJobs"}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" กลับ\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"card mb-3"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-4 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่ของข้อมูล (Period):")]),_vm._v(" "),_c('datepicker',{attrs:{"format":_vm.datePickerFormat,"name":"dataPeriodPicker","input-class":"form-control","disabled-dates":_vm.disabledDates},model:{value:(_vm.periodDate),callback:function ($$v) {_vm.periodDate=$$v},expression:"periodDate"}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                จะแปลงเป็น "),_c('code',[_vm._v(_vm._s(_vm.periodYmd || '-'))]),_vm._v(" (yyyyMMdd)\n              ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-4 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("โหมด:")]),_vm._v(" "),_c('div',[_c('label',{staticClass:"radio-inline mr-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendMode),expression:"sendMode"}],attrs:{"type":"radio","value":"all"},domProps:{"checked":_vm._q(_vm.sendMode,"all")},on:{"change":function($event){_vm.sendMode="all"}}}),_vm._v(" ส่งทุก Agent\n                ")]),_vm._v(" "),_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendMode),expression:"sendMode"}],attrs:{"type":"radio","value":"single"},domProps:{"checked":_vm._q(_vm.sendMode,"single")},on:{"change":function($event){_vm.sendMode="single"}}}),_vm._v(" เลือก 1 Agent\n                ")])])])]),_vm._v(" "),(_vm.sendMode === 'single')?_c('div',{staticClass:"col-xl-4 col-md-6 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Agent:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAgent),expression:"selectedAgent"}],staticClass:"form-control",attrs:{"disabled":_vm.isLoadingAgents},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedAgent=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("-- เลือก agent --")]),_vm._v(" "),_vm._l((_vm.agents),function(a){return _c('option',{key:a.code,domProps:{"value":a.code}},[_vm._v("\n                  ["+_vm._s(a.code)+"] "+_vm._s(a.name)+"\n                ")])})],2),_vm._v(" "),(_vm.isLoadingAgents)?_c('small',{staticClass:"form-text text-muted"},[_vm._v("โหลด agent...")]):_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.agents.length)+" agents ที่ active + IsSendReport")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.canSend || _vm.isSending},on:{"click":_vm.onSend}},[_c('i',{staticClass:"fas fa-paper-plane"}),_vm._v("\n              "+_vm._s(_vm.isSending ? 'กำลังส่ง...' : 'ส่งเมล์')+"\n            ")]),_vm._v(" "),(!_vm.periodYmd)?_c('small',{staticClass:"text-muted ml-2"},[_vm._v("เลือกวันที่ก่อน")]):(_vm.sendMode === 'single' && !_vm.selectedAgent)?_c('small',{staticClass:"text-muted ml-2"},[_vm._v("เลือก agent ก่อน")]):_vm._e()])]),_vm._v(" "),(_vm.sendResult)?_c('div',{staticClass:"alert mt-3",class:_vm.sendResultClass},[_c('strong',[_vm._v(_vm._s(_vm.sendResultLabel))]),_vm._v(" "),_c('div',{staticClass:"mt-1"},[_c('small',[_vm._v(_vm._s(_vm.sendResultMessage))])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card mb-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between align-items-center"},[_c('strong',[_vm._v("History — รายการรอบส่งล่าสุด (Batch level)")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"disabled":_vm.isLoadingBatch},on:{"click":_vm.loadBatchHistory}},[_c('i',{staticClass:"fas fa-sync-alt"}),_vm._v(" Refresh\n        ")])]),_vm._v(" "),_c('div',{staticClass:"card-body p-0"},[_c('table',{staticClass:"table table-sm table-striped mb-0"},[_vm._m(2),_vm._v(" "),_c('tbody',[(!_vm.batchHistory.length)?_c('tr',[_c('td',{staticClass:"text-center text-muted py-3",attrs:{"colspan":"9"}},[_vm._v("ไม่มีประวัติ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.batchHistory),function(h,i){return _c('tr',{key:h.logId},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDateTime(h.startTime)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDateTime(h.endTime)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(h.durationMs != null ? (h.durationMs / 1000).toFixed(1) : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge",class:_vm.statusBadgeClass(h.status)},[_vm._v(_vm._s(h.status))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(h.totalItems != null)?_c('span',[_vm._v("\n                  "+_vm._s(h.successItems || 0)+" / "+_vm._s(h.failedItems || 0)+" / "+_vm._s(h.skippedItems || 0)+" / "+_vm._s(h.totalItems)+"\n                ")]):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(h.triggerSource))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(h.metadata || '-'))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(h.errorMessage))])])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header d-flex justify-content-between align-items-center"},[_c('strong',[_vm._v("Per-agent log (EmailReportLog)")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.perAgentFilter),expression:"perAgentFilter"}],staticClass:"form-control form-control-sm d-inline-block",staticStyle:{"width":"180px"},attrs:{"type":"text","placeholder":"filter yyyyMMdd"},domProps:{"value":(_vm.perAgentFilter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.perAgentFilter=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-secondary ml-2",attrs:{"disabled":_vm.isLoadingPerAgent},on:{"click":_vm.loadPerAgent}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" Search\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"card-body p-0"},[_c('table',{staticClass:"table table-sm table-striped mb-0"},[_vm._m(3),_vm._v(" "),_c('tbody',[(!_vm.perAgentRows.length)?_c('tr',[_c('td',{staticClass:"text-center text-muted py-3",attrs:{"colspan":"7"}},[_vm._v("ไม่มีข้อมูล")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.perAgentRows),function(r,i){return _c('tr',{key:r.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDateTime(r.startTime)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDateTime(r.endTime)))]),_vm._v(" "),_c('td',[_vm._v("["+_vm._s(r.agentCodeSAP)+"] "+_vm._s(r.agentName))]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(r.email))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge",class:r.isSuccess ? 'badge-success' : 'badge-danger'},[_vm._v("\n                  "+_vm._s(r.isSuccess ? 'YES' : 'NO')+"\n                ")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(r.errorMessage))])])])})],2)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("SendEmailReportAgent — Manage")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('strong',[_vm._v("ส่งใหม่ (Resend)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("StartTime")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("EndTime")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Duration(s)")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Items (S/F/Skip/Total)")]),_vm._v(" "),_c('th',[_vm._v("Trigger")]),_vm._v(" "),_c('th',[_vm._v("Metadata")]),_vm._v(" "),_c('th',[_vm._v("Error")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("StartTime")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("EndTime")]),_vm._v(" "),_c('th',[_vm._v("Agent")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("IsSuccess")]),_vm._v(" "),_c('th',[_vm._v("Error")])])])}]


/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทการตั้งค่าข้อมูลวัน Alert PM :")]),_vm._v(" "),_c('select2',{ref:"reAlertConfigType",attrs:{"id":'reAlertConfigType',"name":'reAlertConfigType',"select2-options":_vm.reAlertConfigTypeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAlertConfigType),callback:function ($$v) {_vm.reAlertConfigType=$$v},expression:"reAlertConfigType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.reAlertConfigType=='AGENT' || _vm.reAlertConfigType=='SHOP')?_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"apmrAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrAgentCode',"name":'apmrAgentCode',"select2-options":_vm.apmrAgentCodeOptions},on:{"selectChange":_vm.AgentClearAfterselect},model:{value:(_vm.apmrAgentCode),callback:function ($$v) {_vm.apmrAgentCode=$$v},expression:"apmrAgentCode"}})],1)]):_vm._e(),_vm._v(" "),(_vm.reAlertConfigType=='SHOP')?_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่าย")]),_vm._v(" "),_c('select2',{ref:"apmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrShopCodes',"name":'apmrShopCodes',"select2-options":_vm.apmrShopCodesOptions},on:{"selectChange":_vm.ShopClearAfterselect},model:{value:(_vm.apmrShopCodes),callback:function ($$v) {_vm.apmrShopCodes=$$v},expression:"apmrShopCodes"}})],1)]):_vm._e(),_vm._v(" "),(_vm.reAlertConfigType=='SHOP')?_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"apmrSubAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrSubAgentCode',"name":'apmrSubAgentCode',"select2-options":_vm.apmrSubAgentCodeOptions},on:{"selectChange":_vm.SubAgentClearAfterselect},model:{value:(_vm.apmrSubAgentCode),callback:function ($$v) {_vm.apmrSubAgentCode=$$v},expression:"apmrSubAgentCode"}})],1)]):_vm._e(),_vm._v(" "),(_vm.reAlertConfigType=='SHOP')?_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"apmrSubShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrSubShopCodes',"name":'apmrSubShopCodes',"select2-options":_vm.apmrSubShopCodesOptions},model:{value:(_vm.apmrSubShopCodes),callback:function ($$v) {_vm.apmrSubShopCodes=$$v},expression:"apmrSubShopCodes"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),(_vm.reqBrand)?_c('div',{staticStyle:{"font-size":"80%","color":"#fd397a"}},[_vm._v(_vm._s(_vm.reqBrandMsg))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"1440px"}},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.brandsitems == null || _vm.brandsitems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.brandsitems),function(item,i){return [_c('item-rows',{ref:"brandItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveItemClick}})]})],2)]),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",staticStyle:{"visibility":"hidden"},attrs:{"type":"button","id":"btnupload"},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("ไฟล์\n                ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-file"}})])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("แบรนด์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวนวัน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ไฟล์อัพโหลด")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ชื่อไฟล์")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[(_vm.showHeader)?_c('td',{staticClass:"text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]):_vm._e(),_vm._v(" "),(_vm.showHeader && _vm.item.activityRemark != null)?_c('td',{staticClass:"form-group text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_vm._v("\n    "+_vm._s(_vm.item.shopActivityName)),_c('br'),_vm._v("("+_vm._s(_vm.item.activityRemark)+")\n  ")]):_vm._e(),_vm._v(" "),(_vm.showHeader && _vm.item.activityRemark == null)?_c('td',{staticClass:"form-group text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_vm._v("\n    "+_vm._s(_vm.item.shopActivityName)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"form-group text-center ",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[(
        !_vm.item.isSixActivity || (!_vm.item.borrowerIsAgent && !_vm.item.shopActivityId)
      )?_c('div',{staticClass:"kt-checkbox-inline"},[_c('label',{staticClass:"kt-checkbox"},[_c('input',{attrs:{"type":"checkbox","id":'isPickUp' + _vm.rowIndex,"disabled":""},domProps:{"value":'isPickUp' + _vm.rowIndex,"checked":_vm.item.isPickUp},on:{"change":_vm.updatePickUpStatus}}),_vm._v(" "),_c('span')])]):_c('div',{staticClass:"kt-checkbox-inline"},[_c('label',{staticClass:"kt-checkbox"},[_c('input',{attrs:{"type":"checkbox","id":'isPickUp' + _vm.rowIndex},domProps:{"value":'isPickUp' + _vm.rowIndex,"checked":_vm.item.isPickUp},on:{"change":_vm.updatePickUpStatus}}),_vm._v(" "),_c('span')])])]):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"form-group align-middle",attrs:{"width":"20%","rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'plProductType' + _vm._uid,"name":'plProductType' + _vm._uid,"select2-options":_vm.jobBTransitOptions,"data-msg-required":"กรุณาเลือกประเภทสินค้า"},on:{"selectChange":_vm.onjobBTransitChange},model:{value:(_vm.itemjobBTransit),callback:function ($$v) {_vm.itemjobBTransit=$$v},expression:"itemjobBTransit"}})],1):_vm._e(),_vm._v(" "),(_vm.item.items.length > 0)?[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.item.items[_vm.itemIndex].quotaName))]),_vm._v(" "),_c('td',{staticClass:"align-middle"},[_vm._v("\n      "+_vm._s(_vm.item.items[_vm.itemIndex].materialCode)+"\n      "+_vm._s(_vm.item.items[_vm.itemIndex].productName)+"\n    ")]),_vm._v(" "),_c('td',{staticClass:"text-right align-middle"},[_vm._v(_vm._s(_vm.item.items[_vm.itemIndex].qty))]),_vm._v(" "),_c('td',{staticClass:"text-right align-middle"},[_vm._v("\n      "+_vm._s(_vm.item.items[_vm.itemIndex].baseUnit)+"\n    ")])]:[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])]],2)}
var staticRenderFns = []


/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/TransferBarcodeSubAgent'),expression:"$route.path == '/Report/TransferBarcodeSubAgent'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"reTbOriginSubAgentCode",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reTbOriginSubAgentCode',"name":'reTbOriginSubAgentCode',"select2-options":_vm.reTbOriginSubAgentCodeOptions},on:{"selectChange":_vm.onOriginSubAgentCodeChange},model:{value:(_vm.reTbOriginSubAgentCode),callback:function ($$v) {_vm.reTbOriginSubAgentCode=$$v},expression:"reTbOriginSubAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('treeselect',{ref:"reTbDestinationShopCode",attrs:{"async":true,"multiple":true,"load-options":_vm.LoadreTbDestinationShopCodeOptions,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadTbDestinationShopCodeOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.reTbDestinationShopCode),callback:function ($$v) {_vm.reTbDestinationShopCode=$$v},expression:"reTbDestinationShopCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbAmpherIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbAmpherId),callback:function ($$v) {_vm.reTbAmpherId=$$v},expression:"reTbAmpherId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reTbBarcode),expression:"reTbBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reTbBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reTbBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreTbDepartmentMaterialCodeOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reTbDepartmentMaterialCode),callback:function ($$v) {_vm.reTbDepartmentMaterialCode=$$v},expression:"reTbDepartmentMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbProductTypeId),callback:function ($$v) {_vm.reTbProductTypeId=$$v},expression:"reTbProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbBrandId),callback:function ($$v) {_vm.reTbBrandId=$$v},expression:"reTbBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reTbAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTbAssetCode),callback:function ($$v) {_vm.reTbAssetCode=$$v},expression:"reTbAssetCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จำนวนวันคงค้าง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reTbOccupiedDays),expression:"reTbOccupiedDays"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุจำนวนวันคงค้าง"},domProps:{"value":(_vm.reTbOccupiedDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reTbOccupiedDays=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reTbReturnStatus',"name":'reTbReturnStatus',"select2-options":_vm.reTbReturnStatusOptions},model:{value:(_vm.reTbReturnStatus),callback:function ($$v) {_vm.reTbReturnStatus=$$v},expression:"reTbReturnStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[(this.$root.canShow(['SUB_AGENT_REPORT']))?_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportTransferBarcode}},[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('hr')])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/Plant'),expression:"$route.path == '/Master/Plant'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก รหัสคลังสินค้า, ชื่อคลังสินค้า โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น รหัสคลังสินค้า1, ชื่อคลังสินค้า2"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"activeStatusKeySelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'activeStatusKey',"name":'activeStatusKey',"select2-options":_vm.activeStatusKeyOptions},model:{value:(_vm.activeStatusKey),callback:function ($$v) {_vm.activeStatusKey=$$v},expression:"activeStatusKey"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("ล้างค่าทั้งหมด")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"})])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store-alt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"plantTable"}},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสคลังสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อคลังสินค้า")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ที่อยู่")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("อีเมล")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เบอร์โทร")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อผู้ติดต่อ")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Latitude")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Longitude")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ผลิตภัณฑ์")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('datepicker',{staticClass:"form-control",attrs:{"id":"StartDate","name":"StartDate","type":"text","placeholder":"วันที่เริ่มต้น"}})],1)]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)])])]),_vm._v(" "),_vm._m(9)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสบาร์โค้ด:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"Barcode","name":"Barcode","type":"text","maxlength":"450","placeholder":"รหัสบาร์โค้ด"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสทรัพย์สิน(บัญชี):")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"AssetAudit","name":"AssetAudit","type":"text","maxlength":"450","placeholder":"รหัสทรัพย์สิน(บัญชี)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"AssetOther","name":"AssetOther","type":"text","maxlength":"450","placeholder":"รหัสทรัพย์สิน(เบียร์สด)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("NFC:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"NFC","name":"NFC","type":"text","maxlength":"450","placeholder":"NFC"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('select',{staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"ProductType","name":"ProductType"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('select',{staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"ProductName","name":"ProductName"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ระยะเวลาประกันถัง(วัน):")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"InsuranceDay","name":"InsuranceDay","type":"text","maxlength":"450","placeholder":"ระยะเวลาประกันถัง(วัน)"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เจ้าของทรัพย์สิน:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"Owner","name":"Owner","type":"text","maxlength":"450","placeholder":"เจ้าของทรัพย์สิน"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])])}]


/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"agentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'agentCode',"name":'agentCode',"select2-options":_vm.agentCodeOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลปี :")]),_vm._v(" "),_c('select2',{ref:"year",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'year',"name":'year',"select2-options":_vm.yearOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)])]),_vm._v(" "),(_vm.year && _vm.canExportAllAgents && !_vm.isShow)?_c('div',{staticClass:"d-flex justify-content-end align-items-center mb-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n              "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.isShow == true)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              รายการจำนวนอุปกรณ์ส่งเสริมสูญหาย :\n            ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingSelected},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelSelected($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)")+"\n                ")])]),_vm._v(" "),(_vm.canExportAllAgents)?_c('button',{staticClass:"btn btn-outline-primary ml-2",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"2500px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"3%"}},[_vm._v("\n                        ลำดับ\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"10%"}},[_vm._v("\n                        ประเภทสินค้า\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        ต้นทุนสินค้า(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"12","scope":"colgroup"}},[_vm._v("\n                        จำนวนอุปกรณ์ส่งเสริมสูญหาย (จำนวน) ปี "+_vm._s(_vm.year)+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้ารวม(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้าเฉลี่ย(บาท/เดือน)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        จัดการ\n                      ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('tbody',{on:{"change":function($event){return _vm.changeTotal()}}},[(_vm.productitems == null || _vm.productitems.length == 0)?_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"18"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.productitems),function(item,i){return [_c('product-item-row',{key:i,ref:"Items",refInFor:true,attrs:{"rowIndex":i,"item":item,"kPIProductType":_vm.kPIProductType,"yearSelected":_vm.year},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"3%"}}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รวมเงิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_vm._l((12),function(index){return _c('th',{key:index,staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalMonth[index]," ", 0))+"\n                      ")])}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalPoductCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalProductCostOfMonth,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th')],2),_vm._v(" "),_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{attrs:{"colspan":"18"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[(_vm.isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand far fa-sticky-note"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มกราคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กุมภาพันธ์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มีนาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("เมษายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤษภาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มิถุนายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กรกฎาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("สิงหาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กันยายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ตุลาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤศจิกายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ธันวาคม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])}]


/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทการเคลม:")]),_vm._v(" "),_c('select2',{ref:"abcClaimTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'abcClaimTypeCode',"name":'abcClaimTypeCode',"select2-options":_vm.abcClaimTypeCodeOptions,"disabled":""},model:{value:(_vm.abcClaimTypeCode),callback:function ($$v) {_vm.abcClaimTypeCode=$$v},expression:"abcClaimTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'"}],staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"abcAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcAgentCode',"name":'abcAgentCode',"select2-options":_vm.abcAgentCodeOptions,"disabled":""},model:{value:(_vm.abcAgentCode),callback:function ($$v) {_vm.abcAgentCode=$$v},expression:"abcAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"}],staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"abcShopCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcShopCode',"name":'abcShopCode',"select2-options":_vm.abcShopCodeOptions,"disabled":""},model:{value:(_vm.abcShopCode),callback:function ($$v) {_vm.abcShopCode=$$v},expression:"abcShopCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อำเภอ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcAmpher),expression:"abcAmpher"}],staticClass:"form-control",attrs:{"id":"abcAmpher","name":"abcAmpher","type":"text","maxlength":"450","placeholder":"อำเภอ","disabled":""},domProps:{"value":(_vm.abcAmpher)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcAmpher=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcProvince),expression:"abcProvince"}],staticClass:"form-control",attrs:{"id":"abcProvince","name":"abcProvince","type":"text","maxlength":"450","placeholder":"จังหวัด","disabled":""},domProps:{"value":(_vm.abcProvince)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcProvince=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcPhone),expression:"abcPhone"}],staticClass:"form-control",attrs:{"id":"abcPhone","name":"abcPhone","type":"text","maxlength":"450","placeholder":"เบอร์โทร","disabled":""},domProps:{"value":(_vm.abcPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcPhone=$event.target.value}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.abcClaimTypeCode != null &&
              (_vm.abcAgentCode != null || _vm.abcShopCode != null)
          ),expression:"\n            abcClaimTypeCode != null &&\n              (abcAgentCode != null || abcShopCode != null)\n          "}],staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้าเคลม:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"12%"}},[_vm._v("ปัญหาที่พบ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_c('input',{attrs:{"type":"checkbox","id":"myCheck"},on:{"click":function($event){return _vm.SelectClaimItems('All')}}}),_vm._v("\n                        อนุมัติการเคลม\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("\n                        สาเหตุที่ไม่อนุมัติการเคลม\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                        สาเหตุที่อนุมัติ/ไม่อนุมัติ (อื่นๆ)\n                      ")])])]),_vm._v(" "),_c('tbody',[(
                        _vm.abcClaimItems == null || _vm.abcClaimItems.length == 0
                      )?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.abcClaimItems),function(item,i){return [_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.productBrand))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.material))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.barcodeOld))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.departmentMaterialCode))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.problemType))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.IsSelectApprove),expression:"item.IsSelectApprove"}],attrs:{"type":"radio","id":"one","value":"true"},domProps:{"checked":_vm._q(item.IsSelectApprove,"true")},on:{"click":function($event){return _vm.SelectClaimItems(item.claimItemId, true)},"change":function($event){return _vm.$set(item, "IsSelectApprove", "true")}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"Green"}},[_vm._v("อนุมัติการเคลม")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.IsSelectApprove),expression:"item.IsSelectApprove"}],attrs:{"type":"radio","id":"two","value":"false"},domProps:{"checked":_vm._q(item.IsSelectApprove,"false")},on:{"click":function($event){return _vm.SelectClaimItems(item.claimItemId, false)},"change":function($event){return _vm.$set(item, "IsSelectApprove", "false")}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"Red"}},[_vm._v("ไม่อนุมัติการเคลม")])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"rejectedReasonCodeSelect2",refInFor:true,attrs:{"disabled":!item.showRejectedReasonCode,"css-style":'width: 100%;',"css-class":'form-control',"id":'rejectedReasonCode' + i,"name":'rejectedReasonCode' + i,"select2-options":_vm.abcRejectedReasonOptions,"required":"","data-msg-required":"กรุณาเลือกสาเหตุที่ไม่อนุมัติการเคลม"},on:{"selectChange":_vm.onRejectedReasonCodeChange},model:{value:(item.rejectedReasonCode),callback:function ($$v) {_vm.$set(item, "rejectedReasonCode", $$v)},expression:"item.rejectedReasonCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.reasonOther),expression:"item.reasonOther"}],staticClass:"form-control",class:{ required: _vm.requiredReasonOther },attrs:{"type":"text","id":'reasonOther' + i,"name":'reasonOther' + i,"data-msg-required":"กรุณากรอกสาเหตุที่อนุมัติ/ไม่อนุมัติ (อื่นๆ)","maxlength":_vm.maxLength},domProps:{"value":(item.reasonOther)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "reasonOther", $event.target.value)}}}),_vm._v(" "),(item.reasonOther)?_c('span',{staticStyle:{"float":"right","color":"#6c7293"}},[_vm._v(_vm._s(item.reasonOther.length)+" / "+_vm._s(_vm.maxLength))]):_vm._e(),_vm._v(" "),(!item.reasonOther || item.reasonOther=='')?_c('span',{staticStyle:{"float":"right","color":"#6c7293"}},[_vm._v("0 / "+_vm._s(_vm.maxLength))]):_vm._e()])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(
                          item.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'
                        ),expression:"\n                          item.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'\n                        "}]},[_c('td',{attrs:{"colspan":"9"}})]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(
                          item.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'
                        ),expression:"\n                          item.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'\n                        "}]},[_vm._m(1,true),_vm._v(" "),_c('td',{staticClass:"text-left",attrs:{"colspan":"7"}},[_vm._v("\n                          "+_vm._s(item.labResult)+"\n                        ")])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(
                          item.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'
                        ),expression:"\n                          item.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'\n                        "}]},[_vm._m(2,true),_vm._v(" "),_c('td',{staticClass:"text-left",attrs:{"colspan":"7"}},[_vm._v("\n                          "+_vm._s(item.causedByExternalFactor)+"\n                        ")])]),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(
                          item.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'
                        ),expression:"\n                          item.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'\n                        "}]},[_vm._m(3,true),_vm._v(" "),_c('td',{staticClass:"text-left",attrs:{"colspan":"7"}},[_vm._v("\n                          "+_vm._s(item.causedByInternalFactor)+"\n                        ")])])]})],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(4)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('b',[_vm._v("ผล Lab")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('b',[_vm._v("ปัจจัยภายนอก")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('b',[_vm._v("ปัจจัยภายใน")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/JobRetrieve'),expression:"$route.path == '/Report/JobRetrieve'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reJrLastActivityDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reJrLastActivityDateStart","name":"reJrLastActivityDateStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reJrLastActivityDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reJrLastActivityDateEnd","name":"reJrLastActivityDateEnd"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJrProductBrandOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJrProductBrand),callback:function ($$v) {_vm.reJrProductBrand=$$v},expression:"reJrProductBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJrReturnStatusOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJrReturnStatus),callback:function ($$v) {_vm.reJrReturnStatus=$$v},expression:"reJrReturnStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่เอกสารรับคืน:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reJrRetrieveJob),expression:"reJrRetrieveJob"}],staticClass:"form-control",attrs:{"type":"text","rows":"1","placeholder":"ค้นหาจาก เลขที่เอกสารรับคืน"},domProps:{"value":(_vm.reJrRetrieveJob)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reJrRetrieveJob=$event.target.value}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reViewPermissionCode == 'AGENT_REPORT'),expression:"reViewPermissionCode == 'AGENT_REPORT'"}],staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ขนส่ง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreJrTransitOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reJrTransit),callback:function ($$v) {_vm.reJrTransit=$$v},expression:"reJrTransit"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reViewPermissionCode == 'AGENT_REPORT'),expression:"reViewPermissionCode == 'AGENT_REPORT'"}],staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่เอกสารส่งคืน:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reJrReturnJob),expression:"reJrReturnJob"}],staticClass:"form-control",attrs:{"type":"text","rows":"1","placeholder":"ค้นหาจาก เลขที่เอกสารส่งคืน"},domProps:{"value":(_vm.reJrReturnJob)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reJrReturnJob=$event.target.value}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reViewPermissionCode == 'AGENT_REPORT'),expression:"reViewPermissionCode == 'AGENT_REPORT'"}],staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ต้นทาง (ตัวแทน):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJrOriginAgentOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJrOriginAgent),callback:function ($$v) {_vm.reJrOriginAgent=$$v},expression:"reJrOriginAgent"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJrProductTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJrProductType),callback:function ($$v) {_vm.reJrProductType=$$v},expression:"reJrProductType"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reViewPermissionCode == 'AGENT_REPORT'),expression:"reViewPermissionCode == 'AGENT_REPORT'"}],staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปลายทาง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJrDestinationPlantOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJrDestinationPlant),callback:function ($$v) {_vm.reJrDestinationPlant=$$v},expression:"reJrDestinationPlant"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reApMaterialCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reApMaterialCode),callback:function ($$v) {_vm.reApMaterialCode=$$v},expression:"reApMaterialCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportJobRetrieve}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isJobRetrieveTable == true),expression:"isJobRetrieveTable == true"}],staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"jobRetrieveTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"15"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reJrDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('tfoot',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowFooter),expression:"isShowFooter"}]},[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("จำนวนรวม")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.TotalAmount))])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isJobRetrieveSubAgentTable == true),expression:"isJobRetrieveSubAgentTable == true"}],staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"jobRetrieveSubAgentTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"13"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reJrDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('tfoot',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowFooter),expression:"isShowFooter"}]},[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("จำนวนรวม")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.TotalAmount))])])])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่เคลื่อนไหวล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่เอกสารรับคืน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่เอกสารส่งคืน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่เอกสารอ้างอิง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ขนส่งคืน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ขนส่งรับคืน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสต้นทาง (ตัวแทน)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ต้นทาง (ตัวแทน)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปลายทาง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่เคลื่อนไหวล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่เอกสารรับคืน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสต้นทาง (ตัวแทนจำหน่ายย่อย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ต้นทาง (ตัวแทนจำหน่ายย่อย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปลาย (ตัวแทน)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะ")])])}]


/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.CheckRoute()),expression:"CheckRoute()"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้าการถือครอง (วัน):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.holProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.holProductTypeId),callback:function ($$v) {_vm.holProductTypeId=$$v},expression:"holProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.holAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"input":_vm.onHolAgentCodeChange},model:{value:(_vm.holAgentCode),callback:function ($$v) {_vm.holAgentCode=$$v},expression:"holAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.holShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.holShopTypeId),callback:function ($$v) {_vm.holShopTypeId=$$v},expression:"holShopTypeId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.holProductBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.holProductBrandId),callback:function ($$v) {_vm.holProductBrandId=$$v},expression:"holProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ระยะเวลาการถือครอง :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.holHolderTime),expression:"holHolderTime"}],staticClass:"form-control",attrs:{"type":"number","id":"holHolderTime","name":"holHolderTime","min":"1","placeholder":""},domProps:{"value":(_vm.holHolderTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.holHolderTime=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"holInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'holInActiveStatus',"name":'holInActiveStatus',"select2-options":_vm.holInActiveStatusOptions},model:{value:(_vm.holInActiveStatus),callback:function ($$v) {_vm.holInActiveStatus=$$v},expression:"holInActiveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['MANAGE_MASTER', 'MASTER_HOLDING']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"Holding/Add","tag":"button","title":"เพิ่มข้อมูลการถือครอง"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูลการถือครอง\n              ")]):_vm._e(),_vm._v(" "),(this.$root.canShow('MASTER_HOLDING_CREATE'))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"Holding/Import","tag":"button","title":"Import"}},[_c('i',{staticClass:"fa fa-file-import"}),_vm._v(" Import\n              ")]):_vm._e(),_vm._v(" "),(this.$root.canShow(['MANAGE_MASTER', 'MASTER_HOLDING']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"Holding/Export","tag":"button","title":"Export"}},[_c('i',{staticClass:"fa fa-file-export"}),_vm._v(" Export\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-edit"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"holdTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("ประเภทสินค้าถือครอง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ระยะเวลาการถือครอง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('button',{staticClass:"btn btn-secondary btn-sm mr-2",on:{"click":function($event){return _vm.$router.push('/Monitoring/ScheduledJobs')}}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" กลับ\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"disabled":_vm.isLoading},on:{"click":_vm.loadStatus}},[_c('i',{staticClass:"fas fa-sync-alt"}),_vm._v(" "+_vm._s(_vm.isLoading ? "กำลังโหลด..." : "Refresh")+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_vm._m(1),_vm._v(" "),(_vm.isFirstRun)?_c('div',{staticClass:"alert alert-danger"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)]):(_vm.soakDays !== null && _vm.soakDays < _vm.SOAK_MIN_DAYS && _vm.pendingCount > 0)?_c('div',{staticClass:"alert alert-warning"},[_vm._m(5),_vm._v(" — คิวเก่าสุดถูก mark มา "),_c('b',[_vm._v(_vm._s(_vm.soakDays))]),_vm._v(" วัน (แนะนำอย่างน้อย "+_vm._s(_vm.SOAK_MIN_DAYS)+" วัน)\n      "),_c('br'),_vm._m(6)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-7"},[_c('div',{staticClass:"card mb-3"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"card-body p-0"},[_c('table',{staticClass:"table table-sm table-bordered mb-0"},[_c('tbody',[_c('tr',[_c('th',{staticClass:"bg-light",staticStyle:{"width":"190px"}},[_vm._v("IsEnabled")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge",class:_vm.config.isEnabled ? 'badge-success' : 'badge-secondary'},[_vm._v("\n                      "+_vm._s(_vm.config.isEnabled ? "ENABLED" : "DISABLED")+"\n                    ")]),_vm._v(" "),_vm._m(8)])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("KeepRounds")]),_c('td',[_c('b',[_vm._v(_vm._s(_vm.config.keepRounds))]),_vm._v(" รอบล่าสุด (ต่อร้าน + เครื่อง)")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("MaxObjectsPerRun")]),_c('td',[_vm._v(_vm._s(_vm.fmt(_vm.config.maxObjectsPerRun)))])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("DeleteConcurrency")]),_c('td',[_vm._v(_vm._s(_vm.config.deleteConcurrency))])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("MachineProductTypeId")]),_c('td',[_vm._v(_vm._s(_vm.config.machineProductTypeId)+" "),_c('small',{staticClass:"text-muted"},[_vm._v("(3 = เครื่องทำความเย็น)")])])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("MaxAgeYears")]),_c('td',[_vm._v(_vm._s(_vm.config.maxAgeYears == null ? "— (ไม่ใช้)" : _vm.config.maxAgeYears))])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("LogRetentionMonths")]),_c('td',[_vm._v(_vm._s(_vm.config.logRetentionMonths == null ? "— (เก็บตลอด)" : _vm.config.logRetentionMonths))])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("PathWhitelist")]),_c('td',[_c('code',[_vm._v(_vm._s(_vm.config.pathWhitelist))])])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("PathBlacklist")]),_c('td',[_c('code',[_vm._v(_vm._s(_vm.config.pathBlacklist))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-5"},[_c('div',{staticClass:"card mb-3"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"card-body p-0"},[_c('table',{staticClass:"table table-sm table-bordered mb-0"},[_vm._m(10),_vm._v(" "),_c('tbody',[(_vm.queue.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"2"}},[_vm._v("ยังไม่มีข้อมูล")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.queue),function(q){return _c('tr',{key:q.status},[_c('td',[_c('span',{staticClass:"badge",class:_vm.queueBadgeClass(q.status)},[_vm._v(_vm._s(q.status))]),_vm._v(" "),_c('small',{staticClass:"text-muted ml-1"},[_vm._v(_vm._s(_vm.queueHint(q.status)))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.fmt(q.count)))])])})],2),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"bg-light"},[_c('th',[_vm._v("รูปที่ถูกซ่อนแล้ว (PMCleanUp)")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.fmt(_vm.purgedRows))+" / "+_vm._s(_vm.fmt(_vm.cloudRows)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mb-3"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"card-body py-2"},[(!_vm.lastRun)?_c('div',{staticClass:"text-muted"},[_vm._v("ยังไม่เคยรัน")]):_c('div',[_c('code',[_vm._v(_vm._s(_vm.lastJobName))]),_c('br'),_vm._v("\n              "+_vm._s(_vm.formatDateTime(_vm.lastRun))+"\n              "),_c('span',{staticClass:"badge ml-2",class:_vm.lastStatus === 'SUCCESS' ? 'badge-success' : 'badge-danger'},[_vm._v(_vm._s(_vm.lastStatus))])])])])])]),_vm._v(" "),_c('div',{staticClass:"card mb-3"},[_c('div',{staticClass:"card-header py-2 d-flex align-items-center",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.showTestTools = !_vm.showTestTools}}},[_c('b',[_vm._v("🧪 เครื่องมือทดสอบ (DEV / SIT)")]),_vm._v(" "),_c('small',{staticClass:"text-muted ml-2"},[_vm._v("อัปโหลดรูปเข้า GCS เพื่อใช้ seed ข้อมูลทดสอบ")]),_vm._v(" "),_c('i',{staticClass:"fas ml-auto",class:_vm.showTestTools ? 'fa-chevron-up' : 'fa-chevron-down'})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTestTools),expression:"showTestTools"}],staticClass:"card-body"},[_c('div',{staticClass:"alert alert-warning py-2 mb-3"},[_c('b',[_vm._v("ใช้ตอน PoC เท่านั้น")]),_vm._v(" — ไฟล์จะถูกตั้งชื่อขึ้นต้นด้วย "),_c('code',[_vm._v("CRTEST_")]),_vm._v(" เสมอ เพื่อให้แยกจากรูปงานจริงได้\n          "),_c('br'),_vm._v("path ที่ได้เป็นรูปแบบเดียวกับรูป PM จริง ("),_c('code',[_vm._v(_vm._s('{yyyy}')+"/PMJobPicture/"+_vm._s('{MM}')+"/…_<guid>.png")]),_vm._v(") จึงผ่าน guard #2 เหมือนกัน\n        ")]),_vm._v(" "),_c('div',{staticClass:"form-inline mb-2"},[_c('input',{ref:"testFiles",staticClass:"form-control-file mr-3",attrs:{"type":"file","accept":".jpg,.jpeg,.png","multiple":""},on:{"change":_vm.onPickFiles}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"disabled":_vm.uploading || _vm.pickedCount === 0},on:{"click":_vm.uploadTestFiles}},[(_vm.uploading)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('i',{staticClass:"fas fa-upload"}),_vm._v("\n            "+_vm._s(_vm.uploading ? "กำลังอัปโหลด..." : "อัปโหลด " + _vm.pickedCount + " ไฟล์")+"\n          ")])]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("รับ .jpg / .jpeg / .png · ไม่เกิน 5 MB ต่อไฟล์ · แนะนำ 3–6 ใบ")]),_vm._v(" "),(_vm.uploaded.length)?_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"d-flex align-items-center mb-1"},[_c('b',[_vm._v("ผลอัปโหลด ("+_vm._s(_vm.uploaded.length)+")")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-secondary ml-auto",on:{"click":_vm.copyPaths}},[_c('i',{staticClass:"fas fa-copy"}),_vm._v(" คัดลอก path ทั้งหมด\n            ")])]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-bordered mb-0"},[_vm._m(12),_vm._v(" "),_c('tbody',_vm._l((_vm.uploaded),function(u,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge",class:u.ok ? 'badge-success' : 'badge-danger'},[_vm._v(_vm._s(u.ok ? "OK" : "FAIL"))])]),_vm._v(" "),_c('td',[_c('small',[_c('code',[_vm._v(_vm._s(u.path || u.message))])])])])}),0)]),_vm._v(" "),_c('textarea',{ref:"pathBox",staticClass:"form-control mt-2",attrs:{"rows":"4","readonly":""},domProps:{"value":_vm.pathList}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card mb-3"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-inline mb-3"},[_c('label',{staticClass:"mr-2"},[_vm._v("MaxObjects (override, ว่าง = ใช้ค่า config):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.maxObjects),expression:"maxObjects",modifiers:{"number":true}}],staticClass:"form-control form-control-sm mr-3",staticStyle:{"width":"130px"},attrs:{"type":"number","min":"1","placeholder":"เช่น 10"},domProps:{"value":(_vm.maxObjects)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxObjects=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('label',{staticClass:"mr-2"},[_vm._v("SampleSize:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.sampleSize),expression:"sampleSize",modifiers:{"number":true}}],staticClass:"form-control form-control-sm mr-3",staticStyle:{"width":"100px"},attrs:{"type":"number","min":"1","max":"500"},domProps:{"value":(_vm.sampleSize)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sampleSize=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('label',{staticClass:"kt-checkbox kt-checkbox--brand mb-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.persist),expression:"persist"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.persist)?_vm._i(_vm.persist,null)>-1:(_vm.persist)},on:{"change":function($event){var $$a=_vm.persist,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.persist=$$a.concat([$$v]))}else{$$i>-1&&(_vm.persist=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.persist=$$c}}}}),_vm._v(" เขียนแถว DRYRUN ลง log (Preview)\n            "),_c('span')])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.actions),function(a){return _c('div',{key:a.mode,staticClass:"col-xl-3 col-md-6 mb-2"},[_c('div',{staticClass:"trigger-card",class:a.tone},[_c('div',{staticClass:"tc-head"},[_c('i',{class:a.icon}),_vm._v(" "),_c('span',{staticClass:"tc-name"},[_vm._v(_vm._s(a.title))]),_vm._v(" "),_c('span',{staticClass:"badge badge-light ml-auto"},[_vm._v(_vm._s(a.phase))])]),_vm._v(" "),_c('p',{staticClass:"tc-desc"},[_vm._v(_vm._s(a.desc))]),_vm._v(" "),_c('div',{staticClass:"tc-risk",class:a.tone},[_vm._v(_vm._s(a.risk))]),_vm._v(" "),(_vm.isBlocked(a))?_c('div',{staticClass:"tc-blocked"},[_vm._v("\n                🔒 ปิดไว้เพราะเป็น first run — ใช้ "),_c('b',[_vm._v("Mark")]),_vm._v(" ก่อน\n              ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-block",class:a.btn,attrs:{"disabled":_vm.running !== null || _vm.isBlocked(a)},on:{"click":function($event){return _vm.trigger(a)}}},[(_vm.running === a.mode)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('i',{staticClass:"fas fa-play"}),_vm._v("\n                "+_vm._s(_vm.running === a.mode ? "กำลังรัน..." : "เรียก " + a.endpoint)+"\n              ")])])])}),0)])]),_vm._v(" "),(_vm.result)?_c('div',{staticClass:"card mb-3"},[_c('div',{staticClass:"card-header py-2 d-flex align-items-center"},[_c('b',[_vm._v("ผลลัพธ์ — "+_vm._s(_vm.result.mode))]),_vm._v(" "),_c('span',{staticClass:"badge ml-2",class:_vm.resultOk ? 'badge-success' : 'badge-danger'},[_vm._v("\n          "+_vm._s(_vm.resultOk ? "SUCCESS" : "FAILED")+"\n        ")]),_vm._v(" "),(_vm.result.skipped)?_c('span',{staticClass:"badge badge-warning ml-2"},[_vm._v("SKIPPED")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-secondary ml-auto",on:{"click":function($event){_vm.showRaw = !_vm.showRaw}}},[_vm._v("\n          "+_vm._s(_vm.showRaw ? "ซ่อน" : "ดู")+" JSON\n        ")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger mb-3"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),(_vm.result.skipReason)?_c('div',{staticClass:"alert alert-warning mb-3"},[_vm._v(_vm._s(_vm.result.skipReason))]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-sm table-bordered"},[_c('tbody',[_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("BatchId")]),_c('td',{attrs:{"colspan":"3"}},[_c('code',[_vm._v(_vm._s(_vm.result.batchId))])])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light",staticStyle:{"width":"180px"}},[_vm._v("Candidate")]),_c('td',[_vm._v(_vm._s(_vm.fmt(_vm.result.candidateCount)))]),_vm._v(" "),_c('th',{staticClass:"bg-light",staticStyle:{"width":"180px"}},[_vm._v("Marked")]),_c('td',[_vm._v(_vm._s(_vm.fmt(_vm.result.markedCount)))])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("Deleted")]),_c('td',{staticClass:"text-danger"},[_c('b',[_vm._v(_vm._s(_vm.fmt(_vm.result.deletedCount)))])]),_vm._v(" "),_c('th',{staticClass:"bg-light"},[_vm._v("NotFound")]),_c('td',[_vm._v(_vm._s(_vm.fmt(_vm.result.notFoundCount)))])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("Failed")]),_c('td',[_vm._v(_vm._s(_vm.fmt(_vm.result.failedCount)))]),_vm._v(" "),_c('th',{staticClass:"bg-light"},[_vm._v("Pending คงเหลือ")]),_c('td',[_vm._v(_vm._s(_vm.fmt(_vm.result.pendingRemaining)))])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("Skipped (shared)")]),_c('td',[_vm._v(_vm._s(_vm.fmt(_vm.result.skippedSharedCount)))]),_vm._v(" "),_c('th',{staticClass:"bg-light"},[_vm._v("Skipped (path)")]),_c('td',[_vm._v(_vm._s(_vm.fmt(_vm.result.skippedPathCount)))])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"bg-light"},[_vm._v("ไม่มี barcode เครื่อง")]),_c('td',[_vm._v(_vm._s(_vm.fmt(_vm.result.noBarcodeImageCount)))]),_vm._v(" "),_c('th',{staticClass:"bg-light"},[_vm._v("Duration")]),_c('td',[_vm._v(_vm._s(_vm.fmt(_vm.result.durationMs))+" ms")])])])]),_vm._v(" "),(_vm.result.samples && _vm.result.samples.length)?_c('div',{staticClass:"table-responsive"},[_c('h6',{staticClass:"mt-3"},[_vm._v("ตัวอย่างรูปที่เข้าเงื่อนไข ("+_vm._s(_vm.result.samples.length)+" แถวแรก)")]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-striped table-bordered"},[_vm._m(14),_vm._v(" "),_c('tbody',_vm._l((_vm.result.samples),function(s,i){return _c('tr',{key:s.cleanUpId},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(s.cleanUpId))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(s.shopId))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(s.subAgentShopId || "-"))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(s.barcodeId))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge badge-dark"},[_vm._v(_vm._s(s.roundRank))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDate(s.roundDate)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('small',[_vm._v(_vm._s(s.cleanUpChoiceCode))])]),_vm._v(" "),_c('td',[_c('small',[_c('code',[_vm._v(_vm._s(s.objectName))])])])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.showRaw)?_c('pre',{staticClass:"raw-json"},[_vm._v(_vm._s(_vm.rawJson))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.pending)?_c('div',{staticClass:"modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.pending = null}}},[_c('div',{staticClass:"modal-box confirm-box"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"text-danger mb-0"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" ยืนยันการรัน "+_vm._s(_vm.pending.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.pending = null}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.isBlocked(_vm.pending))?_c('div',{staticClass:"alert alert-danger"},[_c('b',[_vm._v("🔒 ถูกบล็อก — ระบบนี้ยังไม่เคยทำงาน (first run)")]),_c('br'),_vm._v(" "),_c('code',[_vm._v("Purge")]),_vm._v(" ทำ Mark + Sweep ในรอบเดียว ⇒ รูปถูกลบทันทีโดยไม่มีช่วงให้ตรวจสอบ"),_c('br'),_vm._v("\n            ให้ใช้ "),_c('b',[_vm._v("Mark")]),_vm._v(" → soak 1–2 สัปดาห์ → "),_c('b',[_vm._v("Sweep")]),_vm._v(" แทน\n          ")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.pending.confirmText))]),_vm._v(" "),(_vm.pending.needPhrase)?_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n            การกระทำนี้ "),_c('b',[_vm._v("ลบไฟล์บน GCS จริงและกู้คืนไม่ได้")]),_c('br'),_vm._v("\n            พิมพ์ "),_c('code',[_vm._v(_vm._s(_vm.CONFIRM_PHRASE))]),_vm._v(" เพื่อยืนยัน\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmInput),expression:"confirmInput"}],staticClass:"form-control mt-2",attrs:{"type":"text","placeholder":_vm.CONFIRM_PHRASE},domProps:{"value":(_vm.confirmInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmInput=$event.target.value}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.pending = null}}},[_vm._v("ยกเลิก")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"disabled":_vm.isBlocked(_vm.pending) || (_vm.pending.needPhrase && _vm.confirmInput !== _vm.CONFIRM_PHRASE)},on:{"click":function($event){return _vm.run(_vm.pending)}}},[_vm._v("\n            ยืนยันรัน\n          ")])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n        Clear PM Image — Retention Job\n        "),_c('small',{staticClass:"text-muted ml-2"},[_vm._v("จำลอง cronjob · /Api/PMImageRetention")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning"},[_c('strong',[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" อ่านก่อนกด")]),_vm._v(" "),_c('ul',{staticClass:"mb-0 mt-2"},[_c('li',[_c('b',[_vm._v("Preview")]),_vm._v(" — dry-run นับอย่างเดียว ปลอดภัย 100% กดได้ตลอด")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Mark")]),_vm._v(" — ซ่อนรูปในหน้า "),_c('code',[_vm._v("/PMReport/PM")]),_vm._v(" ทันที · "),_c('u',[_vm._v("ยังไม่ลบไฟล์")]),_vm._v(" · rollback ได้ 100%")]),_vm._v(" "),_c('li',{staticClass:"text-danger"},[_c('b',[_vm._v("Sweep / Purge")]),_vm._v(" — "),_c('b',[_vm._v("ลบไฟล์บน GCS จริง กู้คืนไม่ได้")]),_vm._v(" (bucket ไม่มี versioning)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"mb-2"},[_c('i',{staticClass:"fas fa-shield-alt"}),_vm._v(" ระบบนี้ยังไม่เคยทำงาน — นี่คือ "),_c('b',[_vm._v("first run")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-2"},[_vm._v("🔴 "),_c('b',[_vm._v("ห้ามใช้ "),_c('code',[_vm._v("Purge")])]),_vm._v(" เพราะมันทำ "),_c('b',[_vm._v("Mark + Sweep ในรอบเดียว")]),_vm._v(" ⇒ รูปถูกลบทันทีโดยไม่มีช่วงให้ตรวจสอบ · "),_c('b',[_vm._v("ลบแล้วกู้ไม่ได้")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-3"},[_c('b',[_vm._v("ลำดับที่ถูกต้อง:")]),_vm._v(" "),_c('ol',{staticClass:"mb-0"},[_c('li',[_c('code',[_vm._v("Preview")]),_vm._v(" → เอาตัวเลขไปทวนกับ user/BA ก่อน")]),_vm._v(" "),_c('li',[_c('code',[_vm._v("Mark")]),_vm._v(" → ตรวจหน้า "),_c('code',[_vm._v("/PMReport/PM")]),_vm._v(" (ยังย้อนกลับได้ 100%)")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("soak 1–2 สัปดาห์")]),_vm._v(" — ปล่อยให้ผู้ใช้ใช้งานจริง 🔴 ตัดขั้นนี้ไม่ได้")]),_vm._v(" "),_c('li',[_c('code',[_vm._v("Sweep")]),_vm._v(" ทีละ batch → จุดที่ย้อนไม่ได้")]),_vm._v(" "),_c('li',[_vm._v("เปิด "),_c('code',[_vm._v("IsEnabled = 1")]),_vm._v(" + cron → "),_c('code',[_vm._v("Purge")]),_vm._v(" เริ่มใช้ได้ตั้งแต่ตรงนี้")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('i',{staticClass:"fas fa-hourglass-half"}),_vm._v(" ยังไม่ครบ soak period")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_vm._v("กด "),_c('code',[_vm._v("Sweep")]),_vm._v(" ได้ถ้าเป็นการทดสอบ batch เล็ก แต่อย่าเพิ่งกวาดทั้งก้อน")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header py-2"},[_c('b',[_vm._v("Config")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("(PMImageRetentionConfig — แก้ได้ด้วย SQL ไม่ต้อง deploy)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"text-muted ml-2"},[_vm._v("\n                      มีผลกับ "),_c('code',[_vm._v("Purge")]),_vm._v(" (cron) เท่านั้น — Preview/Mark/Sweep เรียกได้เสมอ\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header py-2"},[_c('b',[_vm._v("คิวและผลลัพธ์สะสม")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("(PMImagePurgeLog)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("DeleteStatus")]),_c('th',{staticClass:"text-right",staticStyle:{"width":"110px"}},[_vm._v("จำนวน")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header py-2"},[_c('b',[_vm._v("รันล่าสุด")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"40px"}},[_vm._v("#")]),_c('th',{staticStyle:{"width":"90px"}},[_vm._v("ผล")]),_c('th',[_vm._v("ObjectName (FileInfoId)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header py-2"},[_c('b',[_vm._v("จำลอง Cronjob — Manual Trigger")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("CleanUpId")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ShopId")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("SubAgent")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("BarcodeId")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Rank")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("วันที่ล้าง")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ประเภทรูป")]),_vm._v(" "),_c('th',[_vm._v("ObjectName")])])])}]


/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MaintainReport/StockSpareParts'),expression:"$route.path == '/MaintainReport/StockSpareParts'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เบิก/คืน/รับเข้า(เริ่มต้น):x")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateStart","name":"jobsDateStart","readonly":""}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่เบิก/คืน/รับเข้า(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateEnd","name":"jobsDateEnd","readonly":""}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่ออะไหล่:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductCode","multiple":true,"options":_vm.qiProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductCode),callback:function ($$v) {_vm.qiProductCode=$$v},expression:"qiProductCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),(this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN']))?_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.exportExcel}},[_vm._m(3)])]):_vm._e()])]),_vm._v(" "),_vm._m(4)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"width":"100%"},attrs:{"id":"reportTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("รหัสอะไหล่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รายการอะไหล่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ยอดยกมา")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รับเข้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รวม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จ่ายออก")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("คืน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("คงเหลือ")])])])])])])}]


/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ระยะ Check-In/Check-Out (เมตร) :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.msCheckInRange),expression:"msCheckInRange",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"id":"msCheckInRange","name":"msCheckInRange","type":"number","min":"1","max":"10000","step":"1","placeholder":"M"},domProps:{"value":(_vm.msCheckInRange)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.msCheckInRange=_vm._n($event.target.value)},_vm.checkMsCheckInRangeMax],"change":_vm.checkMsCheckInRangeMax,"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.msCheckInRangeMaxError)?_c('span',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.msCheckInRangeMaxError))]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                                การบันทึกจะอัพเดตระยะให้ทุก Master (ตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อยและร้านค้าตัวแทนจำหน่าย/ร้านค้าตัวแทนจำหน่ายย่อย) ที่ตั้งเป็น \"ใช้ตามตั้งค่าพื้นฐาน\"\n                            ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n            ")]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n            ")])}]


/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modalRoot",staticClass:"modal fade",attrs:{"id":"formSummaryStockSignatureModal","tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header fss-sig__header"},[_c('h5',{staticClass:"modal-title"},[_c('i',{staticClass:"fas fa-signature"}),_vm._v(" จัดการลายเซ็นผู้จัดทำ\n          "),(_vm.documentNo)?_c('small',{staticClass:"fss-sig__header-doc"},[_vm._v("\n            — เลขที่เอกสาร "+_vm._s(_vm.documentNo)+"\n          ")]):_vm._e()]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.isMissingDefault)?_c('div',{staticClass:"alert alert-warning fss-sig__alert",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v("\n          ระบบยังไม่มีลายเซ็นค่าเริ่มต้น เอกสารที่บันทึกตอนนี้จะพิมพ์ออกมาโดยไม่มีภาพลายเซ็น\n          กรุณาตั้งค่าที่แถบ "),_c('strong',[_vm._v("จัดการลายเซ็นค่าเริ่มต้นระบบ")]),_vm._v(" ก่อน\n        ")]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs fss-sig__tabs",attrs:{"role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.activeTab === 'document' },attrs:{"href":"javascript:;","data-test":"fss-sig-tab-document"},on:{"click":function($event){_vm.activeTab = 'document'}}},[_vm._v("\n              ใช้กับเอกสารนี้เท่านั้น\n            ")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: _vm.activeTab === 'default' },attrs:{"href":"javascript:;","data-test":"fss-sig-tab-default"},on:{"click":function($event){_vm.activeTab = 'default'}}},[_vm._v("\n              จัดการลายเซ็นค่าเริ่มต้นระบบ\n              "),_vm._v(" "),_c('span',{staticClass:"badge badge-danger fss-sig__tab-badge"},[_vm._v("\n                กระทบทั้งระบบ\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-content fss-sig__content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'document'),expression:"activeTab === 'document'"}],attrs:{"data-test":"fss-sig-pane-document"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-7"},[_c('div',{staticClass:"fss-sig__frame-caption"},[_vm._v("\n                  กรอบลายเซ็นในฟอร์ม PDF\n                  "),(_vm.documentImageUrl)?_c('span',{staticClass:"fss-sig__zoom-note"},[_vm._v("\n                    (คลิกภาพเพื่อขยายดูใหญ่)\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fss-sig__preview",attrs:{"data-test":"fss-sig-preview-document"}},[_c('FormSummaryStockSignaturePdfPreview',{attrs:{"src":_vm.documentPreviewUrl,"alt":"ลายเซ็นของเอกสารฉบับนี้","empty-text":"ยังไม่มีภาพลายเซ็น","test-id":"fss-pdfsig-document"},on:{"load":function($event){return _vm.onImageLoad('document', $event)},"zoom":function($event){return _vm.zoom(_vm.documentPreviewUrl)}}})],1),_vm._v(" "),(_vm.hasStagedDocument)?_c('div',{staticClass:"alert alert-warning fss-sig__staged",attrs:{"data-test":"fss-sig-staged-document"}},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" "),_vm._m(2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-5"},[_c('div',{staticClass:"fss-sig__filecard"},[_c('div',{staticClass:"fss-sig__filecard-title"},[_vm._v("\n                    "+_vm._s(_vm.hasStagedDocument ? "ไฟล์ที่เลือกใหม่" : "ไฟล์ปัจจุบัน")+"\n                  ")]),_vm._v(" "),(_vm.hasStagedDocument)?_c('div',{staticClass:"fss-sig__meta fss-sig__filename"},[_c('i',{staticClass:"fas fa-file-image"}),_vm._v(" "+_vm._s(_vm.stagedFileName)+"\n                  ")]):(_vm.documentFileName)?_c('div',{staticClass:"fss-sig__meta fss-sig__filename"},[_c('i',{staticClass:"fas fa-file-image"}),_vm._v(" "+_vm._s(_vm.documentFileName)+"\n                  ")]):_c('div',{staticClass:"fss-sig__meta text-muted"},[_vm._v("\n                    ยังไม่มีไฟล์ลายเซ็น\n                  ")]),_vm._v(" "),(_vm.hasStagedDocument)?_c('div',{staticClass:"fss-sig__meta text-muted"},[_vm._v("\n                    ขนาดไฟล์ "+_vm._s(_vm.stagedSizeText)+"\n                  ")]):(_vm.documentSizeText)?_c('div',{staticClass:"fss-sig__meta text-muted"},[_vm._v("\n                    ขนาดไฟล์ "+_vm._s(_vm.documentSizeText)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.documentDimensionText)?_c('div',{staticClass:"fss-sig__meta text-muted"},[_vm._v("\n                    ขนาดภาพ "+_vm._s(_vm.documentDimensionText)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.canManage && !_vm.isDocumentLocked && (_vm.hasDocumentOverride || _vm.hasStagedDocument))?_c('div',{staticClass:"fss-sig__delete-row"},[_c('button',{staticClass:"fss-act fss-act--md fss-act--red",attrs:{"type":"button","data-test":"fss-sig-delete-document","title":_vm.hasStagedDocument
                        ? _vm.STAGED_DISCARD_TITLE
                        : 'ลบภาพ (ถ้าลบจะกลับไปใช้ค่าเริ่มต้นระบบ)',"disabled":_vm.uploading},on:{"click":_vm.removeOrDiscardDocument}},[_c('i',{staticClass:"la la-trash"})]),_vm._v(" "),_c('span',{staticClass:"fss-sig__delete-label text-muted"},[_vm._v("\n                      "+_vm._s(_vm.hasStagedDocument ? "ยกเลิกภาพที่เลือก" : "ลบภาพเฉพาะเอกสารนี้")+"\n                    ")])]):_vm._e()])])]),_vm._v(" "),(_vm.isDocumentLocked)?_c('div',{staticClass:"fss-sig__readonly text-muted",attrs:{"data-test":"fss-sig-locked"}},[_c('i',{staticClass:"fas fa-lock"}),_vm._v("\n              ลายเซ็นของเอกสารฉบับนี้ถูกตรึงไว้ตั้งแต่วันที่บันทึก เปลี่ยนไม่ได้อีก\n              หากต้องการใช้ลายเซ็นอื่น ต้องสร้างเอกสารใหม่\n            ")]):_vm._e(),_vm._v(" "),(_vm.canManage && !_vm.isDocumentLocked)?_c('div',{staticClass:"fss-sig__dropzone",class:{
                'fss-sig__dropzone--over': _vm.dragScope === 'document',
                'fss-sig__dropzone--disabled': _vm.uploading,
              },on:{"click":function($event){return _vm.pickFile('document')},"dragover":function($event){$event.preventDefault();return _vm.onDragOver('document')},"dragenter":function($event){$event.preventDefault();return _vm.onDragOver('document')},"dragleave":function($event){$event.preventDefault();return _vm.onDragLeave($event)},"drop":function($event){$event.preventDefault();return _vm.onDrop('document', $event)}}},[_c('i',{staticClass:"fas fa-cloud-upload-alt fss-sig__dropzone-icon"}),_vm._v(" "),_c('div',{staticClass:"fss-sig__dropzone-title"},[_vm._v("\n                ลากไฟล์ภาพลายเซ็นมาวางที่นี่ หรือคลิกเพื่อเลือกไฟล์\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-brand btn-sm fss-sig__dropzone-button",attrs:{"type":"button","data-test":"fss-sig-upload-document","disabled":_vm.uploading},on:{"click":function($event){$event.stopPropagation();return _vm.pickFile('document')}}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v(" เลือกภาพลายเซ็น\n              ")])]):_vm._e(),_vm._v(" "),(_vm.canManage && !_vm.isDocumentLocked)?_c('div',{staticClass:"fss-sig__rules text-muted"},[_vm._v("\n              รองรับไฟล์ PNG และ JPG ขนาดไม่เกิน 10 MB —\n              แนะนำ PNG พื้นหลังโปร่งใส ขนาดประมาณ 800 x 400 px\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === 'default'),expression:"activeTab === 'default'"}],attrs:{"data-test":"fss-sig-pane-default"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-7"},[_c('div',{staticClass:"fss-sig__frame-caption"},[_vm._v("\n                  กรอบลายเซ็นในฟอร์ม PDF\n                  "),(_vm.defaultImageUrl)?_c('span',{staticClass:"fss-sig__zoom-note"},[_vm._v("\n                    (คลิกภาพเพื่อขยายดูใหญ่)\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"fss-sig__preview",attrs:{"data-test":"fss-sig-preview-default"}},[_c('FormSummaryStockSignaturePdfPreview',{attrs:{"src":_vm.defaultPreviewUrl,"alt":"ลายเซ็นค่าเริ่มต้นของระบบ","empty-text":"ระบบยังไม่มีลายเซ็นค่าเริ่มต้น","test-id":"fss-pdfsig-default"},on:{"load":function($event){return _vm.onImageLoad('default', $event)},"zoom":function($event){return _vm.zoom(_vm.defaultPreviewUrl)}}})],1),_vm._v(" "),(_vm.hasStagedDefault)?_c('div',{staticClass:"alert alert-warning fss-sig__staged",attrs:{"data-test":"fss-sig-staged-default"}},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" "),_vm._m(4)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-5"},[_c('div',{staticClass:"fss-sig__filecard"},[_c('div',{staticClass:"fss-sig__filecard-title"},[_vm._v("\n                    "+_vm._s(_vm.hasStagedDefault ? "ไฟล์ที่เลือกใหม่" : "ไฟล์ปัจจุบัน")+"\n                  ")]),_vm._v(" "),(_vm.hasStagedDefault)?_c('div',{staticClass:"fss-sig__meta fss-sig__filename"},[_c('i',{staticClass:"fas fa-file-image"}),_vm._v(" "+_vm._s(_vm.stagedFileName)+"\n                  ")]):(_vm.defaultFileName)?_c('div',{staticClass:"fss-sig__meta fss-sig__filename"},[_c('i',{staticClass:"fas fa-file-image"}),_vm._v(" "+_vm._s(_vm.defaultFileName)+"\n                  ")]):_c('div',{staticClass:"fss-sig__meta text-muted"},[_vm._v("\n                    ยังไม่มีไฟล์ลายเซ็น\n                  ")]),_vm._v(" "),(_vm.hasStagedDefault)?_c('div',{staticClass:"fss-sig__meta text-muted"},[_vm._v("\n                    ขนาดไฟล์ "+_vm._s(_vm.stagedSizeText)+"\n                  ")]):(_vm.defaultSizeText)?_c('div',{staticClass:"fss-sig__meta text-muted"},[_vm._v("\n                    ขนาดไฟล์ "+_vm._s(_vm.defaultSizeText)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.defaultDimensionText)?_c('div',{staticClass:"fss-sig__meta text-muted"},[_vm._v("\n                    ขนาดภาพ "+_vm._s(_vm.defaultDimensionText)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.defaultUpdatedAtText)?_c('div',{staticClass:"fss-sig__meta text-muted"},[_vm._v("\n                    แก้ไขล่าสุด "+_vm._s(_vm.defaultUpdatedAtText)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.canManage && _vm.hasStagedDefault)?_c('div',{staticClass:"fss-sig__delete-row"},[_c('button',{staticClass:"fss-act fss-act--md fss-act--red",attrs:{"type":"button","data-test":"fss-sig-discard-default","title":_vm.STAGED_DISCARD_TITLE,"disabled":_vm.uploading},on:{"click":_vm.discardStagedFile}},[_c('i',{staticClass:"la la-trash"})]),_vm._v(" "),_c('span',{staticClass:"fss-sig__delete-label text-muted"},[_vm._v("ยกเลิกภาพที่เลือก")])]):_vm._e()])])]),_vm._v(" "),(_vm.canManage)?_c('div',{staticClass:"fss-sig__dropzone fss-sig__dropzone--danger",class:{
                'fss-sig__dropzone--over': _vm.dragScope === 'default',
                'fss-sig__dropzone--disabled': _vm.uploading,
              },on:{"click":function($event){return _vm.pickFile('default')},"dragover":function($event){$event.preventDefault();return _vm.onDragOver('default')},"dragenter":function($event){$event.preventDefault();return _vm.onDragOver('default')},"dragleave":function($event){$event.preventDefault();return _vm.onDragLeave($event)},"drop":function($event){$event.preventDefault();return _vm.onDrop('default', $event)}}},[_c('i',{staticClass:"fas fa-cloud-upload-alt fss-sig__dropzone-icon"}),_vm._v(" "),_c('div',{staticClass:"fss-sig__dropzone-title"},[_vm._v("\n                ลากไฟล์ภาพลายเซ็นมาวางที่นี่ หรือคลิกเพื่อเลือกไฟล์\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm fss-sig__dropzone-button",attrs:{"type":"button","data-test":"fss-sig-upload-default","disabled":_vm.uploading},on:{"click":function($event){$event.stopPropagation();return _vm.pickFile('default')}}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v(" อัพโหลดทับค่าเริ่มต้นระบบ\n              ")])]):_vm._e(),_vm._v(" "),(_vm.canManage)?_c('div',{staticClass:"fss-sig__rules text-muted"},[_vm._v("\n              รองรับไฟล์ PNG และ JPG ขนาดไม่เกิน 10 MB —\n              แนะนำ PNG พื้นหลังโปร่งใส ขนาดประมาณ 800 x 400 px\n            ")]):_vm._e()])]),_vm._v(" "),_vm._m(5),_vm._v(" "),(!_vm.canManage)?_c('div',{staticClass:"fss-sig__readonly text-muted"},[_c('i',{staticClass:"fas fa-lock"}),_vm._v("\n          ดูได้อย่างเดียว — การจัดการลายเซ็นผู้จัดทำสงวนไว้สำหรับแอดมินทีมเบียร์สด\n        ")]):_vm._e(),_vm._v(" "),_c('input',{ref:"fileInput",staticClass:"fss-sig__file",attrs:{"type":"file","accept":".png,.jpg,.jpeg"},on:{"change":_vm.onFileChosen}}),_vm._v(" "),(_vm.zoomImageUrl)?_c('div',{staticClass:"fss-sig__zoom",on:{"click":_vm.closeZoom}},[_c('img',{staticClass:"fss-sig__zoom-image",attrs:{"src":_vm.zoomImageUrl,"alt":"ภาพลายเซ็นขยาย"}}),_vm._v(" "),_c('div',{staticClass:"fss-sig__zoom-close"},[_vm._v("คลิกที่ใดก็ได้เพื่อปิด")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n          "+_vm._s(_vm.isDocumentLocked ? "ปิด" : "ยกเลิก")+"\n        ")]),_vm._v(" "),(_vm.showApplyButton)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-test":"fss-sig-apply-document","disabled":_vm.uploading},on:{"click":_vm.applySelection}},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" ใช้กับเอกสารนี้เท่านั้น\n        ")]):_vm._e(),_vm._v(" "),(_vm.showSaveDefaultButton)?_c('button',{staticClass:"btn fss-sig__save-default",attrs:{"type":"button","data-test":"fss-sig-save-default","disabled":_vm.uploading || !_vm.hasStagedDefault},on:{"click":_vm.saveAsSystemDefault}},[_vm._v("\n          บันทึกเป็นค่าเริ่มต้นระบบ "),_c('i',{staticClass:"fas fa-arrow-right"})]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info fss-sig__notice"},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v("\n              ภาพที่เลือกในแถบนี้ใช้กับ"),_c('strong',[_vm._v("เอกสารฉบับนี้เท่านั้น")]),_vm._v(" "),_c('strong',[_vm._v("ไม่กระทบ")]),_vm._v("ลายเซ็นค่าเริ่มต้นของระบบและเอกสารฉบับอื่น\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n                    นี่คือภาพใหม่ที่เลือกไว้ — "),_c('strong',[_vm._v("ยังไม่ได้บันทึก")]),_vm._v("\n                    กดปุ่ม \"ใช้กับเอกสารนี้เท่านั้น\" ด้านล่างเพื่อยืนยัน\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger fss-sig__notice"},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_vm._v("\n              ภาพนี้ใช้กับ"),_c('strong',[_vm._v("ทุกเอกสาร")]),_vm._v("ที่บันทึกหลังจากนี้ทั้งระบบ\n              เอกสารที่บันทึกไปแล้วจะไม่เปลี่ยนตาม\n              และแถบนี้"),_c('strong',[_vm._v("ไม่มีปุ่มถอดภาพ")]),_vm._v(" เปลี่ยนได้ด้วยการอัพโหลดทับเท่านั้น\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n                    นี่คือภาพใหม่ที่เลือกไว้ — "),_c('strong',[_vm._v("ยังไม่ได้บันทึก")]),_vm._v("\n                    ตรวจดูให้เรียบร้อยแล้วกด \"บันทึกเป็นค่าเริ่มต้นระบบ\" ด้านล่าง\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning fss-sig__lock-note",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" "),_c('strong',[_vm._v("ข้อสำคัญ")]),_vm._v(" — ลายเซ็นจะถูกตรึงไว้กับเอกสาร ณ วันที่กดบันทึก\n          เอกสารที่บันทึกไปแล้วจะไม่เปลี่ยนตามแม้ภายหลังจะเปลี่ยนค่าเริ่มต้นของระบบ\n          และเอกสารทุกฉบับที่สร้างพร้อมกันในชุดเดียวจะใช้ภาพลายเซ็นเดียวกันทั้งหมด\n        ")])}]


/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []


/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อหมวดหมู่ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.delFolderName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผู้สร้าง :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.delCreateBy))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สร้าง :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.delCreateDate))])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delStatus),expression:"delStatus"}],staticClass:"form-check-input",attrs:{"id":"buStatus","name":"buStatus","type":"checkbox","disabled":""},domProps:{"checked":Array.isArray(_vm.delStatus)?_vm._i(_vm.delStatus,null)>-1:(_vm.delStatus)},on:{"change":function($event){var $$a=_vm.delStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.delStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.delStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.delStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-12"},[_c('button',{staticClass:"btn btn-outline-brand btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.AddSub($event)}}},[_c('i',{staticClass:"fa fa-plus-circle"},[_vm._v("เพิ่มหมวดหมู่ย่อย")])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการ:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.delItems),function(row,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center "},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),(row.isItemFile === false)?_c('td',{},[_c('router-link',{attrs:{"to":("/5S/E-Learning/Detials/" + (row.folderAndFileId))},nativeOn:{"click":function($event){return _vm.$router.go()}}},[_vm._v(_vm._s(row.folderAndFileName))])],1):_c('td',[_vm._v("No I'm Folder")]),_vm._v(" "),_c('td',{staticClass:"text-center "},[_vm._v(_vm._s(row.createdDateFormat))]),_vm._v(" "),_c('td',{staticClass:"text-center "},[_vm._v(_vm._s(row.quotaName))])])}),0)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("ชื่อ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("วันที่สร้าง")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("การจัดการ")])])])}]


/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:(_vm.item.isDuplicated || _vm.item.isOptionRequired)?'bg-danger-duplicated':''},[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.item.isDuplicated),expression:"item.isDuplicated"}],staticClass:"text-danger"},[_vm._v("* รายการซ้ำ")])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"odcAgentCode",attrs:{"disabled":!_vm.item.isAgentEditable,"css-style":'width: 100%;',"css-class":'form-control',"id":'odcAgentCode' + _vm._uid,"name":'odcAgentCode' + _vm._uid,"select2-options":_vm.OdcAgentOptions},on:{"selectChange":_vm.onAgentChange},model:{value:(_vm.item.odcAgentCode),callback:function ($$v) {_vm.$set(_vm.item, "odcAgentCode", $$v)},expression:"item.odcAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"odcSubAgentCode",attrs:{"disabled":!_vm.item.isSubAgentEditable,"css-style":'width: 100%;',"css-class":'form-control',"id":'odcSubAgentCode' + _vm._uid,"name":'odcSubAgentCode' + _vm._uid,"select2-options":_vm.OdcSubAgentOptions},on:{"selectChange":_vm.onSubAgentChange},model:{value:(_vm.item.odcSubAgentCode),callback:function ($$v) {_vm.$set(_vm.item, "odcSubAgentCode", $$v)},expression:"item.odcSubAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.item.isOptionRequired),expression:"item.isOptionRequired"}],staticClass:"text-danger"},[_vm._v("* กรุณาเลือก")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.item.HideGroupOdcRouteAgentOptionShow),expression:"!item.HideGroupOdcRouteAgentOptionShow"}],staticClass:"kt-radio-inline",attrs:{"id":'gOdcRouteAgentOption'+ _vm._uid}},[_vm._l((_vm.RouteAgentOptions),function(plRouteAgentOption,pl){return _c('label',{key:pl,staticClass:"kt-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.odcRouteAgentOption),expression:"item.odcRouteAgentOption"}],attrs:{"type":"radio","id":'odcRouteAgentOptionId'+ _vm._uid,"name":'odcRouteAgentOption'+ _vm._uid},domProps:{"value":plRouteAgentOption.id,"checked":_vm._q(_vm.item.odcRouteAgentOption,plRouteAgentOption.id)},on:{"change":[function($event){return _vm.$set(_vm.item, "odcRouteAgentOption", plRouteAgentOption.id)},_vm.onRouteAgentOptionGroupChange]}}),_vm._v(" "),_c('span'),_vm._v("\n        "+_vm._s(plRouteAgentOption.text)+"\n      ")])}),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"id":'cOdcRouteAgentOption'+ _vm._uid,"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('odcRouteAgentOption' + _vm._uid )}}},[_c('i',{staticClass:"fa fa-times-circle"})])],2),_vm._v(" "),_c('span',{staticClass:"form-text"})]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('center',[_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveItemClick($event)}}},[_c('i',{staticClass:"text-danger la la-trash"})])])],1)])}
var staticRenderFns = []


/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/AgentAssets'),expression:"$route.path == '/Report/AgentAssets'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAaDepartmentOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAaDepartment),callback:function ($$v) {_vm.reAaDepartment=$$v},expression:"reAaDepartment"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAaProvinceOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAaProvince),callback:function ($$v) {_vm.reAaProvince=$$v},expression:"reAaProvince"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAaAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAaAgentCode),callback:function ($$v) {_vm.reAaAgentCode=$$v},expression:"reAaAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAaStatus',"name":'reAaStatus',"select2-options":_vm.reAaStatusOptions},model:{value:(_vm.reAaStatus),callback:function ($$v) {_vm.reAaStatus=$$v},expression:"reAaStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAaProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAaProductTypeId),callback:function ($$v) {_vm.reAaProductTypeId=$$v},expression:"reAaProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAaProductBrandOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAaProductBrand),callback:function ($$v) {_vm.reAaProductBrand=$$v},expression:"reAaProductBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAaAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAaAssetCode),callback:function ($$v) {_vm.reAaAssetCode=$$v},expression:"reAaAssetCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.ExportAgentAssets($event)}}},[_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"stockByAgentTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"13"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(2)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน (ตัวแทน)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน (ร้านค้า)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("หน่วยนับ")])])}]


/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/SalesArea'),expression:"$route.path == '/Master/SalesArea'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อเขตการขาย โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น เขตการขาย1, เขตการขาย2"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"activeStatusKeySelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'activeStatusKey',"name":'activeStatusKey',"select2-options":_vm.activeStatusKeyOptions},model:{value:(_vm.activeStatusKey),callback:function ($$v) {_vm.activeStatusKey=$$v},expression:"activeStatusKey"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(
                  this.$root.canShow(['MANAGE_MASTER', 'MANAGE_SALESAREA'])
                )?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"SalesArea/Add","tag":"button","title":"เพิ่ม"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่ม\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store-alt"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"salesAreaTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"}),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อเขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/BudgetPlan/ApproveGroup'),expression:"$route.path == '/BudgetPlan/ApproveGroup'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อกลุ่มอนุมัติ :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchGroupName),expression:"searchGroupName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"พิมพ์ชื่อกลุ่มอนุมัติที่ต้องการค้นหา"},domProps:{"value":(_vm.searchGroupName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchGroupName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"approveGroup_statusKeySelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'approveGroup_statusKey',"name":'approveGroup_statusKey',"select2-options":_vm.statusOptions},model:{value:(_vm.searchStatus),callback:function ($$v) {_vm.searchStatus=$$v},expression:"searchStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                ค้นหา\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.goToCreate}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" เพิ่มกลุ่มอนุมัติ\n              ")])])])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-users-cog"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"approveGroupTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-center",staticStyle:{"width":"8%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"35%"}},[_vm._v("ชื่อกลุ่มอนุมัติ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"12%"}},[_vm._v("จำนวนแผนก")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"12%"}},[_vm._v("จำนวนผู้อนุมัติ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"13%"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"10%"}},[_vm._v("คำสั่ง")])])])])])])}]


/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/Barcodes'),expression:"$route.path == '/Report/Barcodes'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBBarcode),expression:"reBBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reBBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreBDepartmentMaterialCodeOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reBDepartmentMaterialCode),callback:function ($$v) {_vm.reBDepartmentMaterialCode=$$v},expression:"reBDepartmentMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("สถานะ:\n                   "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MbIsShowCancel),expression:"MbIsShowCancel"}],attrs:{"type":"checkbox"},domProps:{"value":false,"checked":Array.isArray(_vm.MbIsShowCancel)?_vm._i(_vm.MbIsShowCancel,false)>-1:(_vm.MbIsShowCancel)},on:{"click":function($event){return _vm.clickcheckbox()},"change":function($event){var $$a=_vm.MbIsShowCancel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=false,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.MbIsShowCancel=$$a.concat([$$v]))}else{$$i>-1&&(_vm.MbIsShowCancel=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.MbIsShowCancel=$$c}}}}),_vm._v(" แสดงข้อมูลสถานะยกเลิก\n                ")]),_vm._v(" "),_c('treeselect',{attrs:{"disabled":_vm.MbBarcodeStautsDisabled,"multiple":true,"options":_vm.reBBarcodeStatusCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBBarcodeStatusCode),callback:function ($$v) {_vm.reBBarcodeStatusCode=$$v},expression:"reBBarcodeStatusCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ขนส่ง:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reBTransitId',"name":'reBTransitId',"select2-options":_vm.reBTransitIdOptions},model:{value:(_vm.reBTransitId),callback:function ($$v) {_vm.reBTransitId=$$v},expression:"reBTransitId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("จำนวนวันคงค้าง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBOnHoldDays),expression:"reBOnHoldDays"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุจำนวนวันคงค้าง"},domProps:{"value":(_vm.reBOnHoldDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBOnHoldDays=$event.target.value}}})])]),_vm._v(" "),(_vm.showDDLAgentName)?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBHostAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือกผู้ดูแลร้านค้า(ตัวแทน)"},model:{value:(_vm.reBHostAgentCode),callback:function ($$v) {_vm.reBHostAgentCode=$$v},expression:"reBHostAgentCode"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('treeselect',{ref:"UsersId",attrs:{"multiple":true,"load-options":_vm.LoadUsersIdOptions,"async":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadUsersIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.UsersId),callback:function ($$v) {_vm.UsersId=$$v},expression:"UsersId"}})],1)]),_vm._v(" "),(_vm.showActiveStatusFilter)?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("\n                  สถานะใช้งาน:\n                  "),_c('a',{ref:"ActiveStatusInfo",staticClass:"ml-1",attrs:{"href":"#","data-toggle":"popover","data-trigger":"focus","data-placement":"bottom","data-html":"true","data-content":_vm.ActiveStatusInfoText},on:{"click":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"fa fa-info-circle"})])]),_vm._v(" "),_c('treeselect',{ref:"ActiveStatus",attrs:{"id":"ActiveStatus","options":_vm.ActiveStatusOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.ActiveStatus),callback:function ($$v) {_vm.ActiveStatus=$$v},expression:"ActiveStatus"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['super_admin']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("สถานะทรัพย์สินเช่า:")]),_vm._v(" "),_c('treeselect',{ref:"IsLeasedAssets",attrs:{"id":"IsLeasedAssets","options":_vm.LeasedAssetsOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.IsLeasedAssets),callback:function ($$v) {_vm.IsLeasedAssets=$$v},expression:"IsLeasedAssets"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12 mt-3"},[_c('Collapsible',{staticClass:"product-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหาสินค้า\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-plus-square"}),_vm._v(" ค้นหาสินค้า\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"product"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBProductTypeId),callback:function ($$v) {_vm.reBProductTypeId=$$v},expression:"reBProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBAssetCode),callback:function ($$v) {_vm.reBAssetCode=$$v},expression:"reBAssetCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.BrandIdClearAfterSelect,"deselect":_vm.BrandIdClearAfterDeSelect},model:{value:(_vm.reBBrandId),callback:function ($$v) {_vm.reBBrandId=$$v},expression:"reBBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อแบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{ref:"ProductIdBrand",attrs:{"id":"ProductIdBrand","multiple":true,"options":_vm.filteredProductIdBrandOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.ProductIdBrand),callback:function ($$v) {_vm.ProductIdBrand=$$v},expression:"ProductIdBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ปี(สินค้า):")]),_vm._v(" "),_c('treeselect',{ref:"BarcodeYear",attrs:{"multiple":true,"load-options":_vm.LoadBarcodeYearOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadBarcodeYearOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.BarcodeYear),callback:function ($$v) {_vm.BarcodeYear=$$v},expression:"BarcodeYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ราคา(สินค้า):")]),_vm._v(" "),_c('treeselect',{ref:"UnitPrice",attrs:{"id":"UnitPrice","multiple":true,"options":_vm.UnitPriceOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.UnitPrice),callback:function ($$v) {_vm.UnitPrice=$$v},expression:"UnitPrice"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ช่วงคงค้าง:")]),_vm._v(" "),_c('treeselect',{ref:"PeriodRange",attrs:{"id":"PeriodRange","multiple":true,"options":_vm.PeriodRangeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.PeriodRange),callback:function ($$v) {_vm.PeriodRange=$$v},expression:"PeriodRange"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ปีคงค้าง:")]),_vm._v(" "),_c('treeselect',{ref:"PeriodYear",attrs:{"id":"PeriodYear","multiple":true,"options":_vm.PeriodYearOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.PeriodYear),callback:function ($$v) {_vm.PeriodYear=$$v},expression:"PeriodYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("หมุนเวียน/ไม่หมุนเวียน:")]),_vm._v(" "),_c('treeselect',{ref:"Circulate",attrs:{"id":"Circulate","multiple":true,"options":_vm.CirculateOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.Circulate),callback:function ($$v) {_vm.Circulate=$$v},expression:"Circulate"}})],1)])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12 mt-3"},[_c('Collapsible',{staticClass:"product-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหาผู้ถือครอง\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la\tla-plus-square"}),_vm._v(" ค้นหาผู้ถือครอง\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"product"}},[_c('div',{staticClass:"row"},[(this.$root.canShow(['BR_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("เจ้าของทรัพย์สิน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.AssetOwnerOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.AssetOwnerId),callback:function ($$v) {_vm.AssetOwnerId=$$v},expression:"AssetOwnerId"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทคงค้าง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.OwnerTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OwnerType),callback:function ($$v) {_vm.OwnerType=$$v},expression:"OwnerType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ตัวแทนจำหน่าย(Group):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.HeadAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.HeadAgentCode),callback:function ($$v) {_vm.HeadAgentCode=$$v},expression:"HeadAgentCode"}})],1)]),_vm._v(" "),(!this.$root.canShow(['super_admin']) && this.$root.canShow(['AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBShopTypeId),callback:function ($$v) {_vm.reBShopTypeId=$$v},expression:"reBShopTypeId"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[(this.$root.canShow(['BR_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ผู้ถือครอง(คลังสินค้า):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBCurrentLocationPlantOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBCurrentLocationPlant),callback:function ($$v) {_vm.reBCurrentLocationPlant=$$v},expression:"reBCurrentLocationPlant"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ผู้ถือครอง(ตัวแทนจำหน่าย):")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reBCurrentLocationAgent","multiple":true,"options":_vm.reBCurrentLocationAgentOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.AgentClearAfterselect,"deselect":_vm.AgentClearAfterselect},model:{value:(_vm.reBCurrentLocationAgent),callback:function ($$v) {_vm.reBCurrentLocationAgent=$$v},expression:"reBCurrentLocationAgent"}})],1)]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT' ])
                      )?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ผู้ถือครอง(ตัวแทนจำหน่ายย่อย):")]),_vm._v(" "),_c('treeselect',{ref:"reBCurrentLocationSubAgent",attrs:{"id":"reBCurrentLocationSubAgent","multiple":true,"load-options":_vm.LoadreBCurrentLocationSubAgentOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadreBCurrentLocationSubAgentOptions,"select":_vm.SubAgentClearAfterselect},model:{value:(_vm.reBCurrentLocationSubAgent),callback:function ($$v) {_vm.reBCurrentLocationSubAgent=$$v},expression:"reBCurrentLocationSubAgent"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ผู้ถือครอง(ร้านค้า):")]),_vm._v(" "),_c('treeselect',{ref:"reBCurrentLocationShop",attrs:{"id":"reBCurrentLocationShop","multiple":true,"load-options":_vm.LoadreBCurrentLocationShopOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadreBCurrentLocationShopOptions,"select":_vm.ShopClearAfterselect},model:{value:(_vm.reBCurrentLocationShop),callback:function ($$v) {_vm.reBCurrentLocationShop=$$v},expression:"reBCurrentLocationShop"}})],1)]):_vm._e(),_vm._v(" "),(
                        this.$root.canShow([
                          'AGENT_REPORT',
                          'SUB_AGENT_REPORT' ])
                      )?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ผู้ถือครอง(ร้านค้าตัวแทนย่อย):")]),_vm._v(" "),_c('treeselect',{ref:"reBCurrentLocationSubShop",attrs:{"id":"reBCurrentLocationSubShop","multiple":true,"load-options":_vm.LoadreBCurrentLocationSubShopOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadreBCurrentLocationSubShopOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.reBCurrentLocationSubShop),callback:function ($$v) {_vm.reBCurrentLocationSubShop=$$v},expression:"reBCurrentLocationSubShop"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['BR_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ผู้ถือครอง(ซัพพลายเออร์):")]),_vm._v(" "),_c('treeselect',{ref:"reBCurrentLocationVendor",attrs:{"multiple":true,"load-options":_vm.LoadreBCurrentLocationVendorOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadreBCurrentLocationVendorOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.reBCurrentLocationVendor),callback:function ($$v) {_vm.reBCurrentLocationVendor=$$v},expression:"reBCurrentLocationVendor"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทผู้ถือครอง:")]),_vm._v(" "),_c('treeselect',{ref:"reBCurrentLocationType",attrs:{"id":"reBCurrentLocationType","options":_vm.reBCurrentLocationTypeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBCurrentLocationType),callback:function ($$v) {_vm.reBCurrentLocationType=$$v},expression:"reBCurrentLocationType"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"}):_vm._e(),_vm._v(" "),(this.$root.canShow(['']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("เขตการขาย(ผู้ถือครอง):")]),_vm._v(" "),_c('treeselect',{ref:"reBDepartment",attrs:{"id":"reBDepartment","multiple":true,"options":_vm.reBDepartmentOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBDepartment),callback:function ($$v) {_vm.reBDepartment=$$v},expression:"reBDepartment"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("จังหวัด(ผู้ถือครอง):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBProvinceOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBProvince),callback:function ($$v) {_vm.reBProvince=$$v},expression:"reBProvince"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['BR_REPORT','SUB_AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBShopTypeId),callback:function ($$v) {_vm.reBShopTypeId=$$v},expression:"reBShopTypeId"}})],1)]):_vm._e()])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-3 mt-3"},[(
                this.$root.canShow([
                  'AGENT_REPORT',
                  'SUB_AGENT_REPORT',
                  'BR_REPORT' ])
              )?_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportBarcodes}},[_vm._m(1)]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]):_vm._e()])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/AgentScoreEvaluation'),expression:"$route.path == '/Report/AgentScoreEvaluation'"}],staticClass:"kt-portlet kt-portlet--mobile",staticStyle:{"min-width":"2500px !important"}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปีงบประมาณ:")]),_vm._v(" "),_c('select2',{ref:"yearSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'searchYear',"name":'searchYear',"select2-options":_vm.yearOptions},model:{value:(_vm.searchYear),callback:function ($$v) {_vm.searchYear=$$v},expression:"searchYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.searchAgentOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.searchAgentCode),callback:function ($$v) {_vm.searchAgentCode=$$v},expression:"searchAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 col-lg-8 col-md-8 col-sm-6 col-xs-12 d-flex align-items-end"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-outline-primary ml-2",attrs:{"type":"button"},on:{"click":_vm.exportData}},[_c('i',{staticClass:"fas fa-file-export"}),_vm._v(" Export Excel\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12",staticStyle:{"max-height":"calc(100vh - 260px)","overflow":"auto"}},[_c('table',{staticClass:"table table-sm table-bordered",attrs:{"id":"agentScoreReport"}},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.dataSource.length === 0)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),_vm._l((_vm.dataSource),function(item,i){return [_c('tr',[_c('td',{staticClass:"text-center align-middle TITLE"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TITLE"},[_vm._v(_vm._s(item.year))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TITLE"},[_vm._v(_vm._s(item.agentCode))]),_vm._v(" "),_c('td',{staticClass:"text-left align-middle",staticStyle:{"min-width":"250px !important"}},[_vm._v(_vm._s(item.agentName))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_JAN != null) ? item.maC_JAN : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_FEB != null) ? item.maC_FEB : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_MAR != null) ? item.maC_MAR : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_APR != null) ? item.maC_APR : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_MAY != null) ? item.maC_MAY : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_JUN != null) ? item.maC_JUN : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_JUL != null) ? item.maC_JUL : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_AUG != null) ? item.maC_AUG : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_SEP != null) ? item.maC_SEP : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_OCT != null) ? item.maC_OCT : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_NOV != null) ? item.maC_NOV : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle MAC"},[_vm._v(_vm._s((item.maC_DEC != null) ? item.maC_DEC : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_JAN != null) ? item.syS_JAN : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_FEB != null) ? item.syS_FEB : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_MAR != null) ? item.syS_MAR : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_APR != null) ? item.syS_APR : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_MAY != null) ? item.syS_MAY : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_JUN != null) ? item.syS_JUN : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_JUL != null) ? item.syS_JUL : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_AUG != null) ? item.syS_AUG : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_SEP != null) ? item.syS_SEP : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_OCT != null) ? item.syS_OCT : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_NOV != null) ? item.syS_NOV : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle SYS"},[_vm._v(_vm._s((item.syS_DEC != null) ? item.syS_DEC : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_JAN != null) ? item.totaL_JAN : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_FEB != null) ? item.totaL_FEB : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_MAR != null) ? item.totaL_MAR : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_APR != null) ? item.totaL_APR : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_MAY != null) ? item.totaL_MAY : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_JUN != null) ? item.totaL_JUN : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_JUL != null) ? item.totaL_JUL : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_AUG != null) ? item.totaL_AUG : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_SEP != null) ? item.totaL_SEP : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_OCT != null) ? item.totaL_OCT : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_NOV != null) ? item.totaL_NOV : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s((item.totaL_DEC != null) ? item.totaL_DEC : '-'))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle TOT"},[_vm._v(_vm._s(item.grandTotal))])])]})],2)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"TH",attrs:{"scope":"col","rowspan":"2"}},[_vm._v("NO")]),_vm._v(" "),_c('th',{staticClass:"TH",attrs:{"scope":"col","rowspan":"2"}},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"TH",attrs:{"scope":"col","rowspan":"2"}},[_vm._v("รหัส")]),_vm._v(" "),_c('th',{staticClass:"TH",attrs:{"scope":"col","rowspan":"2"}},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col","colspan":"12"}},[_vm._v("คะแนนถังคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col","colspan":"12"}},[_vm._v("คะแนนการทำระบบเบียร์สด")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col","colspan":"13"}},[_vm._v("รวมคะแนน")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ม.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ก.พ.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("มี.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("เม.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("พ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("มิ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ก.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ส.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ก.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ต.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("พ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THMAC",attrs:{"scope":"col"}},[_vm._v("ธ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ม.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ก.พ.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("มี.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("เม.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("พ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("มิ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ก.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ส.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ก.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ต.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("พ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THSYS",attrs:{"scope":"col"}},[_vm._v("ธ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ม.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ก.พ.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("มี.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("เม.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("พ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("มิ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ก.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ส.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ก.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ต.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("พ.ย.")]),_vm._v(" "),_c('th',{staticClass:"TH THTOT",attrs:{"scope":"col"}},[_vm._v("ธ.ค.")]),_vm._v(" "),_c('th',{staticClass:"TH",attrs:{"scope":"col"}},[_vm._v("Total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"41"}},[_c('h6',[_vm._v("ไม่พบข้อมูลที่อนุมัติแล้ว")])])}]


/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"kt-font-bold kt-margin-b-10"},[_vm._v("Filter ที่เลือก")]),_vm._v(" "),(_vm.filterText)?_c('div',{staticClass:"fss-filter-text"},[_vm._v("\n          "+_vm._s(_vm.filterText)+"\n          ")]):(_vm.filterLabels.length > 0)?_c('table',{staticClass:"table table-sm fss-filter-table"},[_c('tbody',_vm._l((_vm.filterLabels),function(item,index){return _c('tr',{key:index},[_c('td',{staticClass:"fss-filter-table__label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(item.text)+"\n              ")])])}),0)]):_c('div',{staticClass:"text-muted"},[_vm._v("-")])])]),_vm._v(" "),_c('div',{staticClass:"kt-separator kt-separator--border-dashed kt-separator--space-sm"}),_vm._v(" "),(_vm.isNoData)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-secondary text-center",attrs:{"role":"alert"}},[_c('div',{staticClass:"kt-font-bold"},[_vm._v("ไม่พบข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.noDataMessage))])])])]):_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered fss-agent-table",attrs:{"data-test":"fss-preview-agent-table"}},[_vm._m(3),_vm._v(" "),_c('tbody',[_c('tr',{attrs:{"data-test":"fss-preview-agent-row"}},[_c('td',{staticClass:"text-center"},[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(_vm.agentLabel)+"\n                  "),(_vm.branchLine)?_c('div',{staticClass:"fss-branch-line",attrs:{"data-test":"fss-preview-branch-line"}},[_vm._v("\n                    "+_vm._s(_vm.branchLine)+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatQty(_vm.totalQty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatAmount(_vm.totalAmount)))])]),_vm._v(" "),_c('tr',{staticClass:"fss-detail-row",attrs:{"data-test":"fss-preview-detail-row"}},[_c('td',{attrs:{"colspan":"4"}},[_c('div',{staticClass:"fss-detail"},[_c('div',{staticClass:"fss-detail__title",attrs:{"data-test":"fss-preview-detail-title"}},[_vm._v("\n                      รายละเอียดสินค้าคงค้าง — "+_vm._s(_vm.agentNameOnly)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.details),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.seqNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productTypeName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productName))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatQty(row.qty)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.unitName))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatAmount(row.amount)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"fss-total-row"},[_c('td',{staticClass:"text-right kt-font-bold",attrs:{"colspan":"4"}},[_vm._v("Grand Total")]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v(_vm._s(_vm.formatQty(_vm.totalQty)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("—")]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v("\n                              "+_vm._s(_vm.formatAmount(_vm.totalAmount))+"\n                            ")])])])])])])])])])])])])]),_vm._v(" "),(!_vm.isNoData)?_c('div',{staticClass:"fss-post-save-note",attrs:{"data-test":"fss-preview-post-save-note"}},[_c('i',{staticClass:"la la-info-circle"}),_vm._v("\n      หลังบันทึกข้อมูลแล้ว จะสามารถพิมพ์ PDF หรือ Export Excel (รายละเอียดบาร์โค้ด) ได้\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kt-separator kt-separator--border-dashed kt-separator--space-sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-auto"},[_c('button',{staticClass:"btn btn-sm btn-clean kt-margin-r-10",attrs:{"type":"button"},on:{"click":_vm.goBackToFilter}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("แก้ไข Filter")])])]),_vm._v(" "),_c('div',{staticClass:"col-xl text-right"},[_c('div',{staticClass:"fss-action-group"},[(_vm.canManageSignature)?_c('button',{staticClass:"btn btn-sm kt-margin-r-10 fss-signature-btn",class:_vm.hasSignature ? 'btn-success' : 'btn-clean',attrs:{"type":"button","data-test":"fss-open-signature"},on:{"click":_vm.openSignature}},[_c('i',{class:_vm.hasSignature ? 'la la-check' : 'la la-pencil'}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v(_vm._s(_vm.signatureButtonText))]),_vm._v(" "),(_vm.signatureImageUrl)?_c('img',{staticClass:"fss-signature-thumb",attrs:{"src":_vm.signatureImageUrl,"alt":"ลายเซ็นผู้จัดทำ","data-test":"fss-signature-thumb"}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary kt-margin-r-10",attrs:{"type":"button","disabled":_vm.isNoData},on:{"click":_vm.saveDocument}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("บันทึกข้อมูล")])])])])]),_vm._v(" "),_c('FormSummaryStockSignatureModal',{ref:"signatureModal",on:{"selected":_vm.onSignatureSelected,"changed":_vm.loadDefaultSignature}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-file-alt"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n        ตรวจสอบข้อมูลก่อนบันทึก\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"fss-stepper"},[_c('div',{staticClass:"fss-step fss-step--done"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("✓")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("เลือก Filter")])]),_vm._v(" "),_c('div',{staticClass:"fss-connector fss-connector--done"}),_vm._v(" "),_c('div',{staticClass:"fss-step fss-step--active"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("ตรวจสอบข้อมูล")])]),_vm._v(" "),_c('div',{staticClass:"fss-connector"}),_vm._v(" "),_c('div',{staticClass:"fss-step"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("บันทึก + พิมพ์")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('strong',[_vm._v("ยังไม่บันทึก")]),_vm._v(" —\n          ตรวจสอบข้อมูลแล้วกด \"บันทึกข้อมูล\" เพื่อล็อค snapshot + ออกเลขที่เอกสาร\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"8%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"16%"}},[_vm._v("จำนวนคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"22%"}},[_vm._v("ยอดรวม (ก่อน VAT)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"7%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"18%"}},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"27%"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%"}},[_vm._v("จำนวนคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"8%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"13%"}},[_vm._v("\n                              จำนวนเงิน (ก่อน VAT)\n                            ")])])])}]


/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"productCode",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'productCode' + _vm._uid,"name":'productCode' + _vm._uid,"select2-options":_vm.productCodeOptions,"disabled":_vm.item.isDisableProduct,"data-msg-required":"กรุณาเลือกสินค้า"},model:{value:(_vm.item.productCode),callback:function ($$v) {_vm.$set(_vm.item, "productCode", $$v)},expression:"item.productCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: _vm.locale, currency: _vm.currency }),expression:"{ locale, currency }"}],staticClass:"form-control required text-right",attrs:{"id":'productCost' + _vm._uid,"name":'productCost' + _vm._uid,"auto-decimal-mode:true":"","placeholder":"ราคา","data-msg-required":"กรุณากรอกจำนวน"},on:{"keyup":function($event){return _vm.changeProductCost($event, _vm._uid)}},model:{value:(_vm.item.productCost),callback:function ($$v) {_vm.$set(_vm.item, "productCost", $$v)},expression:"item.productCost"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_vm._l((12),function(index){return _c('td',{key:index,staticClass:"form-group"},[(_vm.item.isDisableMonth[index])?_c('input',{directives:[{name:"currency",rawName:"v-currency",value:({
        locale: 'th',
        currency: null,
        precision: 0,
      }),expression:"{\n        locale: 'th',\n        currency: null,\n        precision: 0,\n      }"}],staticClass:"form-control text-right",attrs:{"readonly":"","id":'isMonth' + index + _vm._uid,"name":'isMonth' + index + _vm._uid},domProps:{"value":_vm.item.isMonth[index]},on:{"keyup":function($event){return _vm.changeMonth($event, index, _vm._uid)}}}):_vm._e(),_vm._v(" "),(!_vm.item.isDisableMonth[index])?_c('input',{directives:[{name:"currency",rawName:"v-currency",value:({
        locale: 'th',
        currency: null,
        precision: 0,
      }),expression:"{\n        locale: 'th',\n        currency: null,\n        precision: 0,\n      }"}],staticClass:"form-control text-right",attrs:{"id":'isMonth' + index + _vm._uid,"name":'isMonth' + index + _vm._uid,"readonly":(_vm.yearSelected == _vm.currentYear && index > _vm.currentMonth)},domProps:{"value":_vm.item.isMonth[index]},on:{"keyup":function($event){return _vm.changeMonth($event, index, _vm._uid)}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"form-text"})])}),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: _vm.locale, currency: _vm.currency }),expression:"{ locale, currency }"}],staticClass:"form-control  text-right",attrs:{"readonly":"","id":'totalCost' + _vm._uid,"name":'totalCost' + _vm._uid,"value":_vm.ChecktotalCostAll(_vm._uid),"auto-decimal-mode:true":""}})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: _vm.locale, currency: _vm.currency }),expression:"{ locale, currency }"}],staticClass:"form-control  text-right",attrs:{"readonly":"","id":'totalCalOfmonth' + _vm._uid,"name":'totalCalOfmonth' + _vm._uid,"value":_vm.totalCalOfmonthAll,"auto-decimal-mode:true":""}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('center',[(!_vm.item.isDisableProduct)?_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveItemClick($event)}}},[_c('i',{staticClass:"text-danger la la-trash"})]):_vm._e()])],1)],2)}
var staticRenderFns = []


/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/AssetProducts'),expression:"$route.path == '/Report/AssetProducts'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เจ้าของทรัพย์สิน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reApAssetOwnerOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reApAssetOwner),callback:function ($$v) {_vm.reApAssetOwner=$$v},expression:"reApAssetOwner"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Book Value:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reApBookValue),expression:"reApBookValue"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุ Book Value"},domProps:{"value":(_vm.reApBookValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reApBookValue=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้จำหน่าย(Supplier):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreApVendorOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reApVendor),callback:function ($$v) {_vm.reApVendor=$$v},expression:"reApVendor"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reApBarcodeStatusCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reApBarcodeStatusCode),callback:function ($$v) {_vm.reApBarcodeStatusCode=$$v},expression:"reApBarcodeStatusCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เคลื่อนไหวล่าสุด(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reApLastActivityDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reApLastActivityDateStart","name":"reApLastActivityDateStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เคลื่อนไหวล่าสุด(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reApLastActivityDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reApLastActivityDateEnd","name":"reApLastActivityDateEnd"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับเข้า(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reApRetrieveDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reApRetrieveDateStart","name":"reApRetrieveDateStart"}}),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับเข้า(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reApRetrieveDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reApRetrieveDateEnd","name":"reApRetrieveDateEnd"}}),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('Collapsible',{staticClass:"product-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหาสินค้า\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-plus-square"}),_vm._v(" ค้นหาสินค้า\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"product"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมวดหมู่สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reApProductGroupOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reApProductGroup),callback:function ($$v) {_vm.reApProductGroup=$$v},expression:"reApProductGroup"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reApProductTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reApProductType),callback:function ($$v) {_vm.reApProductType=$$v},expression:"reApProductType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reApMaterialCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reApMaterialCode),callback:function ($$v) {_vm.reApMaterialCode=$$v},expression:"reApMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reApProductBrandOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reApProductBrand),callback:function ($$v) {_vm.reApProductBrand=$$v},expression:"reApProductBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อายุสินค้า(วัน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reApAssetLifeTime),expression:"reApAssetLifeTime"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุอายุสินค้า(วัน)"},domProps:{"value":(_vm.reApAssetLifeTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reApAssetLifeTime=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันหมดอายุสินค้า(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reApEndOfLifeDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reApEndOfLifeDateStart","name":"reApEndOfLifeDateStart"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันหมดอายุสินค้า(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reApEndOfLifeDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reApEndOfLifeDateEnd","name":"reApEndOfLifeDateEnd"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ราคา/หน่วย:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reApPricing),expression:"reApPricing"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุราคา/หน่วย"},domProps:{"value":(_vm.reApPricing)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reApPricing=$event.target.value}}})])])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('Collapsible',{staticClass:"code-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหารหัส\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-plus-square"}),_vm._v(" ค้นหารหัส\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"code"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reApBarcodeNoOld),expression:"reApBarcodeNoOld"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reApBarcodeNoOld)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reApBarcodeNoOld=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreApDepartmentMaterialOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reApDepartmentMaterial),callback:function ($$v) {_vm.reApDepartmentMaterial=$$v},expression:"reApDepartmentMaterial"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสทรัพย์สิน(บัญชี):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreApAccountMaterialOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reApAccountMaterial),callback:function ($$v) {_vm.reApAccountMaterial=$$v},expression:"reApAccountMaterial"}})],1)])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('Collapsible',{staticClass:"warranty-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหาประกัน\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-plus-square"}),_vm._v(" ค้นหาประกัน\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"warranty"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จำนวนวันที่รับประกัน (วัน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reApWarrantyTime),expression:"reApWarrantyTime"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุจำนวนวันที่รับประกัน (วัน)"},domProps:{"value":(_vm.reApWarrantyTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reApWarrantyTime=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันสิ้นสุดการรับประกัน(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reApWarrantyEndDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reApWarrantyEndDateStart","name":"reApWarrantyEndDateStart"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันสิ้นสุดการรับประกัน(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reApWarrantyEndDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reApWarrantyEndDateEnd","name":"reApWarrantyEndDateEnd"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะการประกัน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reApWarrantyStatusOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reApWarrantyStatus),callback:function ($$v) {_vm.reApWarrantyStatus=$$v},expression:"reApWarrantyStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับประกัน(หลังการซ่อม)(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reApRepairWarrantyDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reApRepairWarrantyDateStart","name":"reApRepairWarrantyDateStart"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับประกัน(หลังการซ่อม)(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reApRepairWarrantyDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reApRepairWarrantyDateEnd","name":"reApRepairWarrantyDateEnd"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])])])])])],1)]),_vm._v(" "),(this.$root.canShow(['BR_REPORT', 'SUB_AGENT_REPORT']))?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportAssetProduct}},[_vm._m(5)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"assetProductTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"26"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reApDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(6)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เจ้าของทรัพย์สิน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("หมวดหมู่สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสทรัพย์สิน(บัญชี)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ราคา/หน่วย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ราคารวม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่รับเข้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนวันที่รับประกัน (วัน)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันสิ้นสุดการรับประกัน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะการประกัน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("\n                    วันที่รับประกัน(หลังการซ่อม)\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("อายุสินค้า (วัน)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันหมดอายุสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Book Value")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้จำหน่าย (Supplier)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่เคลื่อนไหวล่าสุด")])])}]


/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"agentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'agentCode',"name":'agentCode',"select2-options":_vm.agentCodeOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลปี :")]),_vm._v(" "),_c('select2',{ref:"year",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'year',"name":'year',"select2-options":_vm.yearOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)])]),_vm._v(" "),(_vm.year && _vm.canExportAllAgents && !_vm.isShow)?_c('div',{staticClass:"d-flex justify-content-end align-items-center mb-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n              "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.isShow == true)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              รายการจำนวนอุปกรณ์เบียร์สดสูญหาย :\n            ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingSelected},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelSelected($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)")+"\n                ")])]),_vm._v(" "),(_vm.canExportAllAgents)?_c('button',{staticClass:"btn btn-outline-primary ml-2",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"2500px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"3%"}},[_vm._v("\n                        ลำดับ\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"10%"}},[_vm._v("\n                        ประเภทสินค้า\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        ต้นทุนสินค้า(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"12","scope":"colgroup"}},[_vm._v("\n                        จำนวนอุปกรณ์เบียร์สดสูญหาย (จำนวน) ปี "+_vm._s(_vm.year)+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้ารวม(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้าเฉลี่ย(บาท/เดือน)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        จัดการ\n                      ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('tbody',{on:{"change":function($event){return _vm.changeTotal()}}},[(_vm.productitems == null || _vm.productitems.length == 0)?_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"18"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.productitems),function(item,i){return [_c('product-item-row',{key:i,ref:"Items",refInFor:true,attrs:{"rowIndex":i,"item":item,"kPIProductType":_vm.kPIProductType,"yearSelected":_vm.year},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"3%"}}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รวมเงิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_vm._l((12),function(index){return _c('th',{key:index,staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalMonth[index]," ", 0))+"\n                      ")])}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalPoductCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalProductCostOfMonth,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th')],2),_vm._v(" "),_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{attrs:{"colspan":"18"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[(_vm.isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand fas fa-sitemap"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มกราคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กุมภาพันธ์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มีนาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("เมษายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤษภาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มิถุนายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กรกฎาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("สิงหาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กันยายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ตุลาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤศจิกายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ธันวาคม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])}]


/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/5SReport/NotificationKPI'),expression:"$route.path == '/5SReport/NotificationKPI'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reDepartmentsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"5SByAgentTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"7"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(3)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนวันในการไม่กรอก KPIs")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แจ้งเตือนครั้งล่าสุด")])])}]


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MachineReport/Invoice'),expression:"$route.path == '/MachineReport/Invoice'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reInvDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reInvDateStart","name":"reInvDateStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reInvDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reInvDateEnd","name":"reInvDateEnd"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Phase:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reInvPhase',"name":'reInvPhase',"select2-options":_vm.reInvPhaseOptions},model:{value:(_vm.reInvPhase),callback:function ($$v) {_vm.reInvPhase=$$v},expression:"reInvPhase"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Lot:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reInvLot',"name":'reInvLot',"select2-options":_vm.reInvLotOptions},model:{value:(_vm.reInvLot),callback:function ($$v) {_vm.reInvLot=$$v},expression:"reInvLot"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์เครื่องเบียร์สด:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reInvBrand',"name":'reInvBrand',"select2-options":_vm.reInvBrandOptions},model:{value:(_vm.reInvBrand),callback:function ($$v) {_vm.reInvBrand=$$v},expression:"reInvBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reInvStatus',"name":'reInvStatus',"select2-options":_vm.reInvStatusOptions},model:{value:(_vm.reInvStatus),callback:function ($$v) {_vm.reInvStatus=$$v},expression:"reInvStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่ Invoice:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reInvInvoice),expression:"reInvInvoice"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุ เลขที่ Invoice"},domProps:{"value":(_vm.reInvInvoice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reInvInvoice=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reInvProductTypeId',"name":'reInvProductTypeId',"select2-options":_vm.reInvProductTypeIdOptions},model:{value:(_vm.reInvProductTypeId),callback:function ($$v) {_vm.reInvProductTypeId=$$v},expression:"reInvProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ราคาค่าเช่า(เริ่มต้น):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reInvPriceStart),expression:"reInvPriceStart"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุ ราคาค่าเช่า(เริ่มต้น)"},domProps:{"value":(_vm.reInvPriceStart)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reInvPriceStart=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ราคาค่าเช่า(สิ้นสุด):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reInvPriceEnd),expression:"reInvPriceEnd"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุ ราคาค่าเช่า(สิ้นสุด)"},domProps:{"value":(_vm.reInvPriceEnd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reInvPriceEnd=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Supplier:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reInvSupplier',"name":'reInvSupplier',"select2-options":_vm.reInvSupplierOptions},model:{value:(_vm.reInvSupplier),callback:function ($$v) {_vm.reInvSupplier=$$v},expression:"reInvSupplier"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportInvoice}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"InvoiceTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"15"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"9"}},[_vm._v("รวม")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm._f("currency")(_vm.reInvLastQty," ", 0))+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm._f("currency")(_vm.reInvLastPrice," ", 0))+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm._f("currency")(_vm.reInvLastPriceTotal," ", 0))+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(_vm._f("currency")(_vm.reInvLastGrandPriceTotal," ", 0))+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"2"}})])])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("วันที่รับวางบิล")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("Invoice")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("Phase")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("Lot")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("งวด")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("Supplier")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("\n                    แบรนด์\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("\n                    ราคาเช่า/เครื่อง\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("รวมเงิน")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"rowspan":"2"}},[_vm._v("\n                    ยอดเงินสุทธิในใบวางบิล\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"colspan":"2"}},[_vm._v("สถานะ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("วางบิลเสร็จสิ้น")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชำระแล้ว")])])}]


/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสคลังสินค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.StePlantId))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อคลังสินค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.StePlantName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SteEmail),expression:"SteEmail"}],staticClass:"form-control",attrs:{"id":"SteEmail","name":"SteEmail","type":"text"},domProps:{"value":(_vm.SteEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.SteEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทคลังสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"options":_vm.OwnerTypeCodeOption,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OwnerTypeCode),callback:function ($$v) {_vm.OwnerTypeCode=$$v},expression:"OwnerTypeCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ที่อยู่:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SteAddress),expression:"SteAddress"}],staticClass:"form-control",attrs:{"id":"SteAddress","name":"SteAddress","type":"text"},domProps:{"value":(_vm.SteAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.SteAddress=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"steProvinceIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'steProvinceId',"name":'steProvinceId',"select2-options":_vm.steProvinceIdOptions},on:{"selectChange":_vm.onProvinceChange},model:{value:(_vm.steProvinceId),callback:function ($$v) {_vm.steProvinceId=$$v},expression:"steProvinceId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"steAmphurIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'steAmphurId',"name":'steAmphurId',"select2-options":_vm.steAmphurIdOptions},on:{"selectChange":_vm.onAmphurChange},model:{value:(_vm.steAmphurId),callback:function ($$v) {_vm.steAmphurId=$$v},expression:"steAmphurId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตำบล:")]),_vm._v(" "),_c('select2',{ref:"steTumbolIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'steTumbolId',"name":'steTumbolId',"select2-options":_vm.steTumbolIdOptions},model:{value:(_vm.steTumbolId),callback:function ($$v) {_vm.steTumbolId=$$v},expression:"steTumbolId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อผู้ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SteContactName),expression:"SteContactName"}],staticClass:"form-control",attrs:{"id":"SteContactName","name":"SteContactName","type":"text"},domProps:{"value":(_vm.SteContactName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.SteContactName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SteTel),expression:"SteTel"}],staticClass:"form-control",attrs:{"id":"SteTel","name":"SteTel","type":"text"},domProps:{"value":(_vm.SteTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.SteTel=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผลิตสินค้า:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SteManufacture),expression:"SteManufacture"}],staticClass:"form-check-input",attrs:{"id":"SteManufacture","name":"SteManufacture","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.SteManufacture)?_vm._i(_vm.SteManufacture,null)>-1:(_vm.SteManufacture)},on:{"change":function($event){var $$a=_vm.SteManufacture,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.SteManufacture=$$a.concat([$$v]))}else{$$i>-1&&(_vm.SteManufacture=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.SteManufacture=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ใช้งาน Stock Cover Days:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SteUseStockCoverDays),expression:"SteUseStockCoverDays"}],staticClass:"form-check-input",attrs:{"id":"SteUseStockCoverDays","name":"SteUseStockCoverDays","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.SteUseStockCoverDays)?_vm._i(_vm.SteUseStockCoverDays,null)>-1:(_vm.SteUseStockCoverDays)},on:{"change":function($event){var $$a=_vm.SteUseStockCoverDays,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.SteUseStockCoverDays=$$a.concat([$$v]))}else{$$i>-1&&(_vm.SteUseStockCoverDays=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.SteUseStockCoverDays=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผลิตภัณฑ์:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.SteProductOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.SteProduct),callback:function ($$v) {_vm.SteProduct=$$v},expression:"SteProduct"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ตำแหน่งที่ตั้ง:")]),_vm._v(" "),(_vm.SteLat === null)?_c('div',[_c('button',{staticClass:"btn m-btn--pill btn-info btn-block col-xl-2",attrs:{"type":"button"},on:{"click":_vm.getMap}},[_vm._v("\n                  ระบุข้อมูลตำแหน่งที่ตั้ง\n                ")])]):_c('div',[_c('GmapMap',{staticStyle:{"width":"500px","height":"300px"},attrs:{"center":{ lat: _vm.SteLat, lng: _vm.SteLng },"zoom":15,"clickable":true},on:{"click":_vm.updateCoordinates}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"draggable":true,"clickable":true},on:{"drag":_vm.updateCoordinates,"click":_vm.updateCoordinates}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.openMap()}}},[_c('i',{staticClass:"far fa-map"}),_vm._v(" Open GoogleMaps\n                  ")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button"},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("รูป\n              ")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"2%"},attrs:{"id":"container-img"}},_vm._l((_vm.FileUpload),function(image){return (image.isLoaded)?_c('div',{key:image.pictureId,staticClass:"col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap",attrs:{"id":image.pictureId}},[_c('img',{staticClass:"img-plant -avatar js-avatar-me img-thumbnail card-img-top",attrs:{"src":image.urlImg},on:{"error":function($event){return _vm.handleImageError(image)},"load":function($event){return _vm.handleImageLoad(image)}}}),_vm._v(" "),_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","top":"10px","right":"20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeImage(image.pictureId)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})])]):_vm._e()}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SteInActiveStatus),expression:"SteInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"SteInActiveStatus","name":"SteInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.SteInActiveStatus)?_vm._i(_vm.SteInActiveStatus,null)>-1:(_vm.SteInActiveStatus)},on:{"change":function($event){var $$a=_vm.SteInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.SteInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.SteInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.SteInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_vm._v("รูปภาพ:"),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                  (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MachineReport/MachineDetail'),expression:"$route.path == '/MachineReport/MachineDetail'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่ติดตั้ง(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"remdDateInstallStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"remdDateInstallStart","name":"remdDateInstallStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ติดตั้ง(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"remdDateInstallEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"remdDateInstallEnd","name":"remdDateInstallEnd"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มสัญญาเช่า(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"remdContractStartDate_Start",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"remdContractStartDate_Start","name":"remdContractStartDate_Start"}}),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มสัญญาเช่า(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"remdContractStartDate_End",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"remdContractStartDate_End","name":"remdContractStartDate_End"}}),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่หมดสัญญาเช่า(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"remdContractExpireDate_Start",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"remdContractExpireDate_Start","name":"remdContractExpireDate_Start"}}),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่หมดสัญญาเช่า(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"remdContractExpireDate_End",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"remdContractExpireDate_End","name":"remdContractExpireDate_End"}}),_vm._v(" "),_vm._m(6)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.remdAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.remdAgentCode),callback:function ($$v) {_vm.remdAgentCode=$$v},expression:"remdAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Phase:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.remdPhaseOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.remdPhase),callback:function ($$v) {_vm.remdPhase=$$v},expression:"remdPhase"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Lot:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.remdLotOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.remdLot),callback:function ($$v) {_vm.remdLot=$$v},expression:"remdLot"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทเครื่อง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.remdMachineProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.remdMachineProductCode),callback:function ($$v) {_vm.remdMachineProductCode=$$v},expression:"remdMachineProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทหัวจ่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.remdDispenserProductCodeptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.remdDispenserProductCode),callback:function ($$v) {_vm.remdDispenserProductCode=$$v},expression:"remdDispenserProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์เครื่องเบียร์สด:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.remdMachineProductBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.remdMachineProductBrandId),callback:function ($$v) {_vm.remdMachineProductBrandId=$$v},expression:"remdMachineProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์หัวจ่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.remdDispenserProductBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.remdDispenserProductBrandId),callback:function ($$v) {_vm.remdDispenserProductBrandId=$$v},expression:"remdDispenserProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Supplier:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadremdSupplierIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.remdSupplierId),callback:function ($$v) {_vm.remdSupplierId=$$v},expression:"remdSupplierId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.remdShopProvinceIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.remdShopProvinceId),callback:function ($$v) {_vm.remdShopProvinceId=$$v},expression:"remdShopProvinceId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportMachineDetail}},[_vm._m(7)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"MachineDetailTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"29"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(8)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Phase")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Lot")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Supplier")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทเครื่อง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน coil")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE (เครื่องเบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์เครื่องเบียร์สด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทหัวจ่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE (หัวจ่าย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์หัวจ่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วัน (ที่ติดตั้ง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เดือน (ที่ติดตั้ง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี (ที่ติดตั้ง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่เริ่มสัญญาเช่า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่หมดสัญญาเช่า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("การชำระค่างวด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ที่อยู่ร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แขวง/ตำบล")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("โทรศัพท์")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Latitude")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Longtitude")])])}]


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เลขที่ใบเบิกสินค้า :")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.refCode),expression:"refCode"}],staticClass:"form-control",attrs:{"id":"refCode","name":"refCode","type":"text","maxlength":"20","placeholder":"เลขที่ใบเบิกสินค้า","disabled":_vm.isReferenceCodeLocked},domProps:{"value":(_vm.refCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.refCode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-sm btn-dark mt-1",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.isReferenceCodeLocked ? _vm.editReferenceCode() : _vm.getMaterial()}}},[_c('i',{class:_vm.isReferenceCodeLocked ? 'fa fa-edit' : 'fa fa-plus-circle'}),_vm._v("\n                    "+_vm._s(_vm.isReferenceCodeLocked ? 'เปลี่ยนเลขที่ใบเบิกสินค้า' : 'ดึงรายการอะไหล่')+"\n                  ")])])]),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการอะไหล่รับเข้า:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.recvitems == null || _vm.recvitems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        กรุณาดึงข้อมูลรายการอะไหล่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.recvitems),function(item,i){return _c('tr',{key:item.QiJobItemId},[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(i + 1))])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:("materialSelect2-" + i),refInFor:true,staticClass:"form-control text-right",attrs:{"select2-options":_vm.getMaterialCodeOptions(i)},on:{"selectChange":function($event){return _vm.onMaterialCodeChange(i)}},model:{value:(item.MaterialCode),callback:function ($$v) {_vm.$set(item, "MaterialCode", $$v)},expression:"item.MaterialCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text text-danger"},[_vm._v(_vm._s(_vm.errors[i] && _vm.errors[i].materialCode ? _vm.errors[i].materialCode : ''))])],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Quantity),expression:"item.Quantity"}],ref:("quantity-" + i),refInFor:true,staticClass:"form-control text-right",attrs:{"type":"number","min":"0","placeholder":"จำนวน"},domProps:{"value":(item.Quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "Quantity", $event.target.value)},function($event){return _vm.onInputChange(i, 'quantity')}]}}),_vm._v(" "),_c('span',{staticClass:"form-text text-danger"},[_vm._v(_vm._s(_vm.errors[i] && _vm.errors[i].quantity ? _vm.errors[i].quantity : ''))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.UnitName),expression:"item.UnitName"}],staticClass:"form-control text-center",attrs:{"type":"text","placeholder":"หน่วย","readonly":""},domProps:{"value":(item.UnitName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "UnitName", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Remark),expression:"item.Remark"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"หมายเหตุ"},domProps:{"value":(item.Remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "Remark", $event.target.value)}}})])])})],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"30%"}},[_vm._v("รายการอะไหล่")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"35%"}},[_vm._v("หมายเหตุ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"JobBorrowProductModal","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผู้ขอเบิกยืม: "+_vm._s(_vm.jobsBorrowName))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.jobsBorrow),function(item,i){return [(item.items.length > 0)?_vm._l((item.items),function(prod,j){return _c('job-borrow-product-row',{key:prod.shopActivityId,ref:"jobsBorrowItem",refInFor:true,attrs:{"rowIndex":i,"itemIndex":j,"showHeader":j == 0,"rootItems":_vm.jobsBorrow,"item":item}})}):[_c('job-borrow-product-row',{key:item.id,ref:"jobsBorrowItem",refInFor:true,attrs:{"rowIndex":i,"itemIndex":0,"rootItems":_vm.jobsBorrow,"item":item,"showHeader":true}})]]})],2)])])])])])])]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center align-middle",attrs:{"width":"5%","rowspan":"2"}},[_vm._v("\n                            ลำดับ\n                          ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"15%","rowspan":"2"}},[_vm._v("\n                            ร้านค้า/กิจกรรม"),_c('br'),_vm._v("(หมายเหตุกิจกรรม)\n                          ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%","rowspan":"2"}},[_vm._v("\n                            มารับสินค้าเอง\n                          ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",staticStyle:{"width":"150px"},attrs:{"width":"20%","rowspan":"2"}},[_vm._v("\n                            รถขนส่ง\n                          ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("\n                            รายการสินค้า\n                          ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("โควต้า(แบรนด์)")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("หน่วย")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" ยืนยัน\n          ")])])}]


/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{ref:"select",staticClass:"form-control m-select2 gl-type-select",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.disabled}})}
var staticRenderFns = []


/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/BudgetPlan/Job'),expression:"$route.path == '/BudgetPlan/Job'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปีงบประมาณ:")]),_vm._v(" "),_c('select2',{ref:"yearSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'searchYear',"name":'searchYear',"select2-options":_vm.yearOptions},model:{value:(_vm.searchYear),callback:function ($$v) {_vm.searchYear=$$v},expression:"searchYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("CCTR:")]),_vm._v(" "),_c('select2',{ref:"cctrSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'searchCCTR',"name":'searchCCTR',"select2-options":_vm.cctrOptions},model:{value:(_vm.searchCCTR),callback:function ($$v) {_vm.searchCCTR=$$v},expression:"searchCCTR"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("IO:")]),_vm._v(" "),_c('select2',{ref:"ioSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'searchIO',"name":'searchIO',"select2-options":_vm.ioOptions},model:{value:(_vm.searchIO),callback:function ($$v) {_vm.searchIO=$$v},expression:"searchIO"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("GL:")]),_vm._v(" "),_c('select2',{ref:"glSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'searchGL',"name":'searchGL',"select2-options":_vm.glOptions},model:{value:(_vm.searchGL),callback:function ($$v) {_vm.searchGL=$$v},expression:"searchGL"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แผนก:")]),_vm._v(" "),_c('select2',{ref:"orgSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'searchOrgCode',"name":'searchOrgCode',"select2-options":_vm.orgOptions},model:{value:(_vm.searchOrgCode),callback:function ($$v) {_vm.searchOrgCode=$$v},expression:"searchOrgCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทใบงาน:")]),_vm._v(" "),_c('select2',{ref:"searchJobTypeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'searchJobType',"name":'searchJobType',"select2-options":_vm.jobTypeOptions},model:{value:(_vm.searchJobType),callback:function ($$v) {_vm.searchJobType=$$v},expression:"searchJobType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะใบงาน:")]),_vm._v(" "),_c('select2',{ref:"searchStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'searchStatus',"name":'searchStatus',"select2-options":_vm.statusOptions},model:{value:(_vm.searchStatus),callback:function ($$v) {_vm.searchStatus=$$v},expression:"searchStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่ใบงาน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchJobNumber),expression:"searchJobNumber"}],staticClass:"form-control",attrs:{"type":"text","id":"searchJobNumber","name":"searchJobNumber","placeholder":"ค้นหาเลขที่ใบงาน"},domProps:{"value":(_vm.searchJobNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchJobNumber=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Vendor:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchVendor),expression:"searchVendor"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุชื่อหรือรหัส Vendor (คั่น,(ลูกน้ำ)ได้)"},domProps:{"value":(_vm.searchVendor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchVendor=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchProductName),expression:"searchProductName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุชื่อรายการ (คั่น,(ลูกน้ำ)ได้)"},domProps:{"value":(_vm.searchProductName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchProductName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobDateFrom",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"วว/ดด/ปปปป","id":"jobDateFrom","name":"jobDateFrom"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobDateTo",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"วว/ดด/ปปปป","id":"jobDateTo","name":"jobDateTo"}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_vm._m(3),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.formReset}},[_c('i',{staticClass:"fas fa-times"}),_vm._v(" ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(_vm.isApprover)?_c('router-link',{staticClass:"btn btn-success",attrs:{"to":"/BudgetPlan/Job/GroupApprove"}},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" ตรวจสอบใบงานที่ต้องอนุมัติ\n              ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",attrs:{"type":"button"},on:{"click":_vm.goToCreate}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" สร้างใบงานงบประมาณ\n              ")])],1)])]),_vm._v(" "),_vm._m(4)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-file-invoice-dollar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" ค้นหา\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"budgetPlanJobTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-center",staticStyle:{"width":"12%"}},[_vm._v("IO")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"8%"}},[_vm._v("GL")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"8%"}},[_vm._v("แผนก")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"15%"}},[_vm._v("รายการสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"8%"}},[_vm._v("จำนวนเงิน")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"12%"}},[_vm._v("Vendor")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"10%"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"5%"}},[_vm._v("คำสั่ง")])])])])])])}]


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่เช็คอิน :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.chdCheckInDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้เช็คอิน :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.chdFullname))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ร้านค้า :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.chdShopName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ร้านค้า 2 :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.chdShopName2))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("คะแนนรวม :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.chdTotalScore))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.chdCheckInBarcodes!=null && _vm.chdCheckInBarcodes.length > 0),expression:"chdCheckInBarcodes!=null && chdCheckInBarcodes.length > 0"}],staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการ Barcode ที่เช็คอิน:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.chdCheckInBarcodes),function(row,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(row.barcodeNo)+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(row.barcodeNoOld)+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(_vm.showDispenserProductBrands(
                            row.dispenserProductBrands
                          ))+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[(row.fileUrl != null)?_c('a',{attrs:{"href":"#","title":"รูปภาพ"},on:{"click":function($event){$event.preventDefault();return _vm.pictureModal(row.fileUrl)}}},[_vm._v("Link")]):_vm._e()])])}),0)])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("แบบสอบถาม:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"40%"}},[_vm._v("หัวข้อ")]),_vm._v(" "),_vm._l((_vm.chdChoices),function(row,i){return _c('th',{key:i,staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("\n                        "+_vm._s(row.text)+" "),_c('br'),_vm._v("\n                        ("+_vm._s(row.point.text)+")\n                      ")])})],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.chdQuestions),function(row,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"stock-item-td"},[_vm._v("\n                        "+_vm._s(row.text)+"\n                      ")]),_vm._v(" "),_vm._l((row.choices),function(choice,j){return _c('td',{key:j,staticClass:"text-center stock-item-td"},_vm._l((_vm.chdSurveys),function(survey,k){return _c('span',{key:k},[(row.code == survey.questionCode)?_c('span',[(choice.code == survey.answerCode)?_c('span',[_vm._v("\n                              X  \n                              "),_vm._v(" "),(choice.isRequiredPicture && (survey.fileUrl != null && !survey.isImgCloud))?_c('a',{attrs:{"href":"#","title":"รูปภาพ"},on:{"click":function($event){$event.preventDefault();return _vm.pictureModal(survey.fileUrl)}}},[_vm._v("Link  ")]):_vm._e(),_vm._v(" "),(choice.isRequiredPicture && (survey.fileUrl != null && survey.isImgCloud) )?_c('a',{attrs:{"href":"javascript:void(0);","title":"รูปภาพ"},on:{"click":function($event){return _vm.showModal(survey.fileUrl)}}},[_vm._v("Link ")]):_vm._e()]):_vm._e()]):_vm._e()])}),0)})],2)}),_vm._v(" "),_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"2"}},[_vm._v("คะแนนรวม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("\n                        "+_vm._s(_vm.chdTotalScore)+"\n                      ")])])],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"imageModal","tabindex":"-1","role":"dialog","aria-labelledby":"imageModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("ภาพถ่าย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticClass:"img-thumbnail mb-3",staticStyle:{"height":"auto","width":"auto"},attrs:{"src":_vm.modalImageURL}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"25%"}},[_vm._v("รหัส Barcode")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("\n                        รหัสบาร์โค้ดเก่า\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("\n                        แบรนด์ของหัวจ่าย\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("รูปภาพ")])])])}]


/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อโปรไฟล์บริษัท:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cucProfileName),expression:"cucProfileName"}],staticClass:"form-control",attrs:{"id":"cucProfileName","name":"cucProfileName","type":"text","maxlength":"256","placeholder":"ชื่อโปรไฟล์บริษัท"},domProps:{"value":(_vm.cucProfileName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cucProfileName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทโปรไฟล์บริษัท:")]),_vm._v(" "),_c('select2',{ref:"cucProfileTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'cucProfileTypeCode',"name":'cucProfileTypeCode',"select2-options":_vm.cucProfileTypeCodeOptions},on:{"selectChange":_vm.onCucProfileTypeCodeChange},model:{value:(_vm.cucProfileTypeCode),callback:function ($$v) {_vm.cucProfileTypeCode=$$v},expression:"cucProfileTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.onShowCompanySelect2()),expression:"onShowCompanySelect2()"}],staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("บริษัท:")]),_vm._v(" "),_c('select2',{ref:"cucCompanyCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'cucCompanyCode',"name":'cucCompanyCode',"select2-options":_vm.cucCompanyCodeOptions},model:{value:(_vm.cucCompanyCode),callback:function ($$v) {_vm.cucCompanyCode=$$v},expression:"cucCompanyCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ShowAgentMappingSelect2),expression:"ShowAgentMappingSelect2"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย: \n                    ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_QI'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_QI'"}]},[_c('input',{attrs:{"type":"checkbox","name":"cucIsAllAgent","id":"cucIsAllAgent"},on:{"change":function($event){return _vm.SelectAllAgent($event)}}}),_vm._v(" เลือกทั้งหมด")]),_vm._v(" "),_c('treeselect',{attrs:{"id":'cucAgenCodeMapping',"name":'cucAgenCodeMapping',"multiple":true,"options":_vm.cucAgenCodeMappingOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก","required":""},model:{value:(_vm.cucAgenCodeMapping),callback:function ($$v) {_vm.cucAgenCodeMapping=$$v},expression:"cucAgenCodeMapping"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ShowPhaseSelect2),expression:"ShowPhaseSelect2"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Phase:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":'cucPhases',"name":'cucPhases',"multiple":true,"options":_vm.cucPhaseOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก Phase","required":""},model:{value:(_vm.cucPhases),callback:function ($$v) {_vm.cucPhases=$$v},expression:"cucPhases"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_BR'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_BR'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูลสมาชิก")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(2),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MASTER_USER')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ใบงานตรวจสอบ STOCK")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(3),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('BR_MANAGE_AUDIT_STOCK')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("แสดงผล (Dashboard รายงาน STOCK ระบบเบียร์สด)*มองเห็นทุกตัวแทนจำหน่าย")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(4),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('BR_DASHBOARD_AUDIT_STOCK')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับทรัพย์สินใหม่")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETRIEVE_NEW_ITEM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ผลิตเบียร์สด")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_PRODUCE')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ทำลายทรัพย์สิน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_DESTROY')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("อนุมัติทำลายทรัพย์สิน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(11),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_APPROVER_DESTROY')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ส่งสินค้าไปยังตัวแทน ฯ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_TRANSFER_TO_AGENT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับสินค้า/ทรัพย์สิน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(14),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETRIEVE_ITEM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ส่งซ่อมภายในคลัง")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_REPAIR')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ส่งซ่อมซัพพลายเออร์")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_REPAIR_SUPPLIER')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับคืนจากซัพพลายเออร์")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETURN_SUPPLIER')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("แลกเปลี่ยนสินค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_EXCHANGE')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("เบิก/ยืม")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_BORROW')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("เบิก/ยืม (คลัง)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(25),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_BORROW_PLANT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("เบิก/ยืม (จัดการใบงาน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(26),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_BORROW_OPENJOB')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับคืนสินค้า/ทรัพย์สินจากลูกค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETURN_ADHOC')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ตรวจสอบใบ Hold")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(29),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_HOLD_CHECKER')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ใบงานตัดยอดคงค้าง")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(30),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_WRITE_OFF_STOCK_PLANT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูลรายงาน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(31),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('BR_REPORT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("Beer Claim (เจ้าหน้าที่ทรัพย์สินเบียร์สด BRT)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(32),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('DB_OFFICER_BEER_CLAIM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("Beer Claim (ผจก.ฝ่ายผลิต)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(33),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('ADMIN_PLANT_BEER_CLAIM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ใบงานตรวจสอบ STOCK")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(34),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_AUDIT_STOCK')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูลร้านค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(35),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_SHOP')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูลสมาชิกตัวแทน/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(36),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_SUB_AGENT_USER')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับสินค้า/ทรัพย์สิน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(37),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETRIEVE_ITEM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(38),_vm._v(" "),_vm._m(39),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_TRANSFER_TO_SHOP')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("หยิบสินค้าขึ้นรถ (เร่ขาย)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(40),_vm._v(" "),_vm._m(41),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_PICKUP')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("แลกเปลี่ยนสินค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(42),_vm._v(" "),_vm._m(43),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_EXCHANGE')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("เบิก/ยืม")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(44),_vm._v(" "),_vm._m(45),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_BORROW')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับคืนสินค้า/ทรัพย์สินจากลูกค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(46),_vm._v(" "),_vm._m(47),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETURN_ADHOC')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ใบงานตัดยอดคงค้าง")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(48),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_WRITE_OFF_STOCK')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูลรายงาน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(49),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('AGENT_REPORT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูลการเรียนรู้ (E-Learning)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(50),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('AGENT_E-Learning')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูล KPI")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(51),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_AGENT_KPI')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("งานล้างเครื่องเบียร์สด (จัดการใบงาน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(52),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_ADMIN_PM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("งานล้างเครื่องเบียร์สด  (ตัวแทน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(53),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('AGENT_ADMIN_PM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("งานล้างเครื่องเบียร์สด (ตัวแทนจำหน่ายย่อย)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(54),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('SUB_AGENT_ADMIN_PM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("สร้างร้านค้าใหม่ (จัดการใบงาน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(55),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_NEW_SHOP')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("Beer Claim")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(56),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('AGENT_ADMIN_BEER_CLAIM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล BARCODE (ตัวแทน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(57),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_BARCODE_AGENT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("งานตรวจสอบคุณภาพเบียร์สด (จัดการใบงาน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(58),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_QI')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_SUB_AGENT'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_SUB_AGENT'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูลร้านค้าตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(59),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_SHOP_SUB_AGENT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับสินค้า/ทรัพย์สิน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(60),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETRIEVE_ITEM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(61),_vm._v(" "),_vm._m(62),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_TRANSFER_TO_SHOP')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับคืนสินค้า/ทรัพย์สินจากลูกค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(63),_vm._v(" "),_vm._m(64),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETURN_ADHOC')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูลรายงาน (ตัวแทนจำหน่ายย่อย)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(65),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('SUB_AGENT_REPORT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล BARCODE (ตัวแทนจำหน่ายย่อย)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(66),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_BARCODE_SUB_AGENT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("งานล้างเครื่องเบียร์สด (ตัวแทนจำหน่ายย่อย)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(67),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('SUB_AGENT_ADMIN_PM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ใบงานตัดยอดคงค้าง")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(68),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_WRITE_OFF_STOCK_SUB_AGENT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_PM'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_PM'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"pmADMIN_PM","name":"MANAGE_COMPANYPROFILE_PM","value":"ADMIN_PM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"pmUSER_PM","name":"MANAGE_COMPANYPROFILE_PM","value":"USER_PM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      พนักงาน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"pmCOOL_SERVICE_PM","name":"MANAGE_COMPANYPROFILE_PM","value":"COOL_SERVICE_PM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      Cooling\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_PM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_PM' && _vm.ShowRoleOptionUserAndCoolService ),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_PM' && ShowRoleOptionUserAndCoolService "}],staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการเข้าทำ PM  "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showPmExampleModal($event)}}},[_vm._m(69)]),_vm._v(" :")]),_vm._v(" "),_vm._m(70),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"1440px"}},[_vm._m(71),_vm._v(" "),_c('tbody',[(_vm.odcitems == null || _vm.odcitems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.odcitems),function(item,i){return [_c('order-item-row',{key:item.ucode,ref:"jobItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"9"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])])])])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_BEER_CLAIM'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_BEER_CLAIM'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"ADMIN_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"MANAGER_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"MANAGER_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้จัดการ\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"QI_OFFICER_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"QI_OFFICER_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เจ้าหน้าที่ทีม QC\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"PLANT_ACCOUNTANT_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"PLANT_ACCOUNTANT_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เจ้าหน้าที่บัญชีคลังสินค้า\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"LAB_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"LAB_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      LAB\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_PLANT_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"ADMIN_PLANT_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้จัดการฝ่ายผลิต\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"DB_OFFICER_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"DB_OFFICER_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เจ้าหน้าที่ทรัพย์สินเบียร์สด\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_BEER_CLAIM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_QI'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_QI'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_QI","name":"MANAGE_COMPANYPROFILE_QI","value":"ADMIN_QI"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"MANAGER_QI","name":"MANAGE_COMPANYPROFILE_QI","value":"MANAGER_QI"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้จัดการ\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"USER_QI","name":"MANAGE_COMPANYPROFILE_QI","value":"USER_QI"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      พนักงาน\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_QI')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูล Dashboard")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(72),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioValQI()}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_MKT'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_MKT'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_MKT","name":"MANAGE_COMPANYPROFILE_MKT","value":"ADMIN_MKT"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"MANAGER_MKT","name":"MANAGE_COMPANYPROFILE_MKT","value":"MANAGER_MKT"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้จัดการ\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"USER_MKT","name":"MANAGE_COMPANYPROFILE_MKT","value":"USER_MKT"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      พนักงาน\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_MKT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_5S'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_5S'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_5S","name":"MANAGE_COMPANYPROFILE_5S","value":"ADMIN_5S"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADVISOR_5S","Advisor":"","name":"MANAGE_COMPANYPROFILE_5S","value":"ADVISOR_5S"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ที่ปรึกษา\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"TEAM_5S","Advisor":"","name":"MANAGE_COMPANYPROFILE_5S","value":"TEAM_5S"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ทีมงาน\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_5S')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
              _vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING'
            ),expression:"\n              cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING'\n            "}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_EQUIPMENT_LEASING","name":"MANAGE_COMPANYPROFILE_EQUIPMENT_LEASING","value":"ADMIN_EQUIPMENT_LEASING"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"USER_EQUIPMENT_LEASING","name":"MANAGE_COMPANYPROFILE_EQUIPMENT_LEASING","value":"USER_EQUIPMENT_LEASING"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      พนักงาน\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal(
                          'MANAGE_COMPANYPROFILE_EQUIPMENT_LEASING'
                        )}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_QIMAINTAIN'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_QIMAINTAIN'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"OFFICER_QIMAINTAIN","name":"MANAGE_COMPANYPROFILE_QIMAINTAIN","value":"OFFICER_QIMAINTAIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ธุรการช่างซ่อมบำรุง\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"OFFICER_PLANT_QIMAINTAIN","name":"MANAGE_COMPANYPROFILE_QIMAINTAIN","value":"OFFICER_PLANT_QIMAINTAIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ธุรการคลังเบียร์สด\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"QI_QIMAINTAIN","name":"MANAGE_COMPANYPROFILE_QIMAINTAIN","value":"QI_QIMAINTAIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ช่างซ่อมบำรุง\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"CHECKER_QIMAINTAIN","name":"MANAGE_COMPANYPROFILE_QIMAINTAIN","value":"CHECKER_QIMAINTAIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      Checker\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"LEAD_QIMAINTAIN","name":"MANAGE_COMPANYPROFILE_QIMAINTAIN","value":"LEAD_QIMAINTAIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      หัวหน้าช่างซ่อมบำรุง\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_QIMAINTAIN')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_BUDGET'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_BUDGET'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล Budget Approval")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"BUDGET_PLAN_USER","name":"MANAGE_COMPANYPROFILE_BUDGET","value":"BUDGET_PLAN_USER"},on:{"change":function($event){return _vm.OnBudgetPlanRoleChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"BUDGET_PLAN_REVIEWER","name":"MANAGE_COMPANYPROFILE_BUDGET","value":"BUDGET_PLAN_REVIEWER"},on:{"change":function($event){return _vm.OnBudgetPlanRoleChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ตรวจสอบ\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"BUDGET_PLAN_MANAGER","name":"MANAGE_COMPANYPROFILE_BUDGET","value":"BUDGET_PLAN_MANAGER"},on:{"change":function($event){return _vm.OnBudgetPlanRoleChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้จัดการฝ่าย\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_BUDGET')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT_SCORE'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT_SCORE'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูลคะแนนตัวแทนจำหน่าย")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(73),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_AGENT_SCORE')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_SCVD'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_SCVD'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล Stock Cover Days")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"SCVD_ADMIN","name":"MANAGE_COMPANYPROFILE_SCVD","value":"SCVD_ADMIN"},on:{"change":function($event){_vm.scvdRole = 'SCVD_ADMIN'}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"SCVD_VIEWER","name":"MANAGE_COMPANYPROFILE_SCVD","value":"SCVD_VIEWER"},on:{"change":function($event){_vm.scvdRole = 'SCVD_VIEWER'}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"SCVD_TEAM_EDIT","name":"MANAGE_COMPANYPROFILE_SCVD","value":"SCVD_TEAM_EDIT"},on:{"change":function($event){_vm.scvdRole = 'SCVD_TEAM_EDIT'}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ทีมสร้าง/แก้ไขข้อมูลตามเป้าหมาย\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_SCVD')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox",attrs:{"data-test":"fss-profile-role-title"}},[_vm._v("เอกสารสรุปสินค้าคงค้าง")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"FORM_SUMMARY_STOCK_ADMIN","name":"MANAGE_COMPANYPROFILE_FORM_SUMMARY_STOCK","value":"FORM_SUMMARY_STOCK_ADMIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมินทีมเบียร์สด\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"FORM_SUMMARY_STOCK_AGENT","name":"MANAGE_COMPANYPROFILE_FORM_SUMMARY_STOCK","value":"FORM_SUMMARY_STOCK_AGENT"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน (ตัวแทนจำหน่าย)\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal(
                          'MANAGE_COMPANYPROFILE_FORM_SUMMARY_STOCK'
                        )}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ShowBudgetOrgSelect2),expression:"ShowBudgetOrgSelect2"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("แผนก:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":'cucBudgetOrgIds',"name":'cucBudgetOrgIds',"multiple":true,"options":_vm.cucBudgetOrgOptions,"clear-on-select":true,"placeholder":"กรุณาเลือกแผนก","required":""},model:{value:(_vm.cucBudgetOrgIds),callback:function ($$v) {_vm.cucBudgetOrgIds=$$v},expression:"cucBudgetOrgIds"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cucInActiveStatus),expression:"cucInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"cucInActiveStatus","id":"cucInActiveStatus"},domProps:{"checked":Array.isArray(_vm.cucInActiveStatus)?_vm._i(_vm.cucInActiveStatus,null)>-1:(_vm.cucInActiveStatus)},on:{"change":function($event){var $$a=_vm.cucInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cucInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cucInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cucInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ShowEmailAlertPM == true),expression:"ShowEmailAlertPM == true"}],staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email Alert PM:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.EmailAlertPM),expression:"EmailAlertPM"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"EmailAlertPM","id":"EmailAlertPM"},domProps:{"checked":Array.isArray(_vm.EmailAlertPM)?_vm._i(_vm.EmailAlertPM,null)>-1:(_vm.EmailAlertPM)},on:{"change":function($event){var $$a=_vm.EmailAlertPM,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.EmailAlertPM=$$a.concat([$$v]))}else{$$i>-1&&(_vm.EmailAlertPM=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.EmailAlertPM=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT'),expression:"cucProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT'"}],staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แจ้งเตือนคงค้างเกินกำหนดเวลา (Website): ")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.EmailWebAlertOverdue),expression:"EmailWebAlertOverdue"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"EmailWebAlertOverdue","id":"EmailWebAlertOverdue"},domProps:{"checked":Array.isArray(_vm.EmailWebAlertOverdue)?_vm._i(_vm.EmailWebAlertOverdue,null)>-1:(_vm.EmailWebAlertOverdue)},on:{"change":function($event){var $$a=_vm.EmailWebAlertOverdue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.EmailWebAlertOverdue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.EmailWebAlertOverdue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.EmailWebAlertOverdue=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(74)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("บทบาท:")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brMASTER_USER","name":"MASTER_USER","value":"MASTER_USER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brBR_MANAGE_AUDIT_STOCK","name":"BR_MANAGE_AUDIT_STOCK","value":"BR_MANAGE_AUDIT_STOCK"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brBR_DASHBOARD_AUDIT_STOCK","name":"BR_DASHBOARD_AUDIT_STOCK","value":"BR_DASHBOARD_AUDIT_STOCK"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_IMPORT_NEW_ASSETS","name":"JOB_TYPE_RETRIEVE_NEW_ITEM","value":"JOB_ADMIN_IMPORT_NEW_ASSETS"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_IMPORT_NEW_ASSETS","name":"JOB_TYPE_RETRIEVE_NEW_ITEM","value":"JOB_IMPORT_NEW_ASSETS"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_PRODUCE","name":"JOB_TYPE_PRODUCE","value":"JOB_ADMIN_PRODUCE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_PRODUCE","name":"JOB_TYPE_PRODUCE","value":"JOB_PRODUCE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_DESTROY","name":"JOB_TYPE_DESTROY","value":"JOB_ADMIN_DESTROY"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_DESTROY","name":"JOB_TYPE_DESTROY","value":"JOB_DESTROY"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_APPROVER_DESTROY","name":"JOB_APPROVER_DESTROY","value":"JOB_APPROVER_DESTROY"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้อนุมัติ\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_TRANSFER_TO_AGENT","name":"JOB_TYPE_TRANSFER_TO_AGENT","value":"JOB_ADMIN_TRANSFER_TO_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_TRANSFER_TO_AGENT","name":"JOB_TYPE_TRANSFER_TO_AGENT","value":"JOB_TRANSFER_TO_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_RETRIEVE_ITEM","name":"JOB_TYPE_RETRIEVE_ITEM","value":"JOB_RETRIEVE_ITEM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_REPAIR","name":"JOB_TYPE_REPAIR","value":"JOB_ADMIN_REPAIR"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_REPAIR","name":"JOB_TYPE_REPAIR","value":"JOB_REPAIR"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_REPAIR_SUPPLIER","name":"JOB_TYPE_REPAIR_SUPPLIER","value":"JOB_ADMIN_REPAIR_SUPPLIER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_REPAIR_SUPPLIER","name":"JOB_TYPE_REPAIR_SUPPLIER","value":"JOB_REPAIR_SUPPLIER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_RETURN_SUPPLIER","name":"JOB_TYPE_RETURN_SUPPLIER","value":"JOB_ADMIN_RETURN_SUPPLIER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_RETURN_SUPPLIER","name":"JOB_TYPE_RETURN_SUPPLIER","value":"JOB_RETURN_SUPPLIER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_EXCHANGE","name":"JOB_TYPE_EXCHANGE","value":"JOB_ADMIN_EXCHANGE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_EXCHANGE","name":"JOB_TYPE_EXCHANGE","value":"JOB_EXCHANGE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_BORROW","name":"JOB_TYPE_BORROW","value":"JOB_ADMIN_BORROW"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_BORROW","name":"JOB_TYPE_BORROW","value":"JOB_BORROW"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_BORROW_PLANT","name":"JOB_TYPE_BORROW_PLANT","value":"JOB_ADMIN_BORROW_PLANT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_BORROW_OPENJOB","name":"JOB_TYPE_BORROW_OPENJOB","value":"JOB_ADMIN_BORROW_OPENJOB"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_ADMIN_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_HOLD_CHECKER","name":"JOB_TYPE_HOLD_CHECKER","value":"JOB_ADMIN_HOLD_CHECKER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_WRITE_OFF_STOCK_PLANT","name":"JOB_TYPE_WRITE_OFF_STOCK_PLANT","value":"JOB_ADMIN_WRITE_OFF_STOCK_PLANT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brBR_REPORT","name":"BR_REPORT","value":"BR_REPORT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brDB_OFFICER_BEER_CLAIM","name":"DB_OFFICER_BEER_CLAIM","value":"DB_OFFICER_BEER_CLAIM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brADMIN_PLANT_BEER_CLAIM","name":"ADMIN_PLANT_BEER_CLAIM","value":"ADMIN_PLANT_BEER_CLAIM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aMANAGE_AUDIT_STOCK","name":"MANAGE_AUDIT_STOCK","value":"MANAGE_AUDIT_STOCK"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aMANAGE_SHOP","name":"MANAGE_SHOP","value":"MANAGE_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aMANAGE_SUB_AGENT_USER","name":"MANAGE_SUB_AGENT_USER","value":"MANAGE_SUB_AGENT_USER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_RETRIEVE_ITEM","name":"JOB_TYPE_RETRIEVE_ITEM","value":"JOB_RETRIEVE_ITEM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_TRANSFER_TO_SHOP","name":"JOB_TYPE_TRANSFER_TO_SHOP","value":"JOB_ADMIN_TRANSFER_TO_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_TRANSFER_TO_SHOP","name":"JOB_TYPE_TRANSFER_TO_SHOP","value":"JOB_TRANSFER_TO_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_PICKUP","name":"JOB_TYPE_PICKUP","value":"JOB_ADMIN_PICKUP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_PICKUP","name":"JOB_TYPE_PICKUP","value":"JOB_PICKUP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_EXCHANGE","name":"JOB_TYPE_EXCHANGE","value":"JOB_ADMIN_EXCHANGE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_EXCHANGE","name":"JOB_TYPE_EXCHANGE","value":"JOB_EXCHANGE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_BORROW","name":"JOB_TYPE_BORROW","value":"JOB_ADMIN_BORROW"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_BORROW","name":"JOB_TYPE_BORROW","value":"JOB_BORROW"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_ADMIN_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_WRITE_OFF_STOCK_AGENT","name":"JOB_TYPE_WRITE_OFF_STOCK","value":"JOB_ADMIN_WRITE_OFF_STOCK_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aAGENT_REPORT","name":"AGENT_REPORT","value":"AGENT_REPORT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aAGENT_E-Learning","name":"AGENT_E-Learning","value":"AGENT_E-Learning"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_AGENT_KPI","name":"JOB_AGENT_KPI","value":"JOB_AGENT_KPI"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_PM","name":"JOB_ADMIN_PM","value":"JOB_ADMIN_PM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aAGENT_ADMIN_PM","name":"AGENT_ADMIN_PM","value":"AGENT_ADMIN_PM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aSUB_AGENT_ADMIN_PM","name":"SUB_AGENT_ADMIN_PM","value":"SUB_AGENT_ADMIN_PM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aADMIN_NEW_SHOP","name":"JOB_TYPE_NEW_SHOP","value":"ADMIN_NEW_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aAGENT_ADMIN_BEER_CLAIM","name":"AGENT_ADMIN_BEER_CLAIM","value":"AGENT_ADMIN_BEER_CLAIM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aMANAGE_BARCODE_AGENT","name":"MANAGE_BARCODE_AGENT","value":"MANAGE_BARCODE_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_QI","name":"JOB_TYPE_QI","value":"JOB_ADMIN_QI"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sMANAGE_SHOP_SUB_AGENT","name":"MANAGE_SHOP_SUB_AGENT","value":"MANAGE_SHOP_SUB_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_RETRIEVE_ITEM","name":"JOB_TYPE_RETRIEVE_ITEM","value":"JOB_RETRIEVE_ITEM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_ADMIN_TRANSFER_TO_SHOP","name":"JOB_TYPE_TRANSFER_TO_SHOP","value":"JOB_ADMIN_TRANSFER_TO_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_TRANSFER_TO_SHOP","name":"JOB_TYPE_TRANSFER_TO_SHOP","value":"JOB_TRANSFER_TO_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_ADMIN_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_ADMIN_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sSUB_AGENT_REPORT","name":"SUB_AGENT_REPORT","value":"SUB_AGENT_REPORT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aMANAGE_BARCODE_SUB_AGENT","name":"MANAGE_BARCODE_SUB_AGENT","value":"MANAGE_BARCODE_SUB_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aSUB_AGENT_ADMIN_PM","name":"SUB_AGENT_ADMIN_PM","value":"SUB_AGENT_ADMIN_PM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT","name":"JOB_TYPE_WRITE_OFF_STOCK_SUB_AGENT","value":"JOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u',[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" กดเพื่อดูตัวอย่างการตั้งค่า")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"pmExampleModal","tabindex":"-1","role":"dialog","aria-labelledby":"pmExampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"pmExampleModalLabel"}},[_vm._v("\n                    ตัวอย่างการตั้งค่า\n                  ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body text-center"},[_c('img',{staticClass:"img-fluid",staticStyle:{"max-width":"100%"},attrs:{"src":"/images/company-profile-pm-example.jpg","alt":"ตัวอย่างการตั้งค่า"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"80px"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"350px"}},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"350px"}},[_vm._v("บทบาท")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"USER_DASHBOARD","name":"USER_DASHBOARD","value":"USER_DASHBOARD"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"AGENT_SCORE_ADMIN","name":"MANAGE_COMPANYPROFILE_AGENT_SCORE","value":"AGENT_SCORE_ADMIN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล \n      ")])}]


/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[(_vm.showHeader)?_c('td',{staticClass:"text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"form-group text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_vm._v("\n    "+_vm._s(_vm.item.documentNumber)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"form-group text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_vm._v(_vm._s(_vm.item.documentDate))]):_vm._e(),_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"form-group align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[_vm._v("\n    "+_vm._s(_vm.item.shipToName)+"\n    ("+_vm._s(_vm.item.shipTo)+")\n  ")]):_vm._e(),_vm._v(" "),(_vm.item.items.length > 0)?[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(_vm.item.items[_vm.itemIndex].materialCode)+" "+_vm._s(_vm.item.items[_vm.itemIndex].materialName))]),_vm._v(" "),_c('td',{staticClass:"text-right align-middle"},[_vm._v(_vm._s(_vm.item.items[_vm.itemIndex].quantity))]),_vm._v(" "),_c('td',{staticClass:"text-right align-middle"},[_vm._v(_vm._s(_vm.item.items[_vm.itemIndex].salesUnit))])]:[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])],_vm._v(" "),(_vm.showHeader)?_c('td',{staticClass:"text-center align-middle",attrs:{"rowspan":_vm.item.items.length > 1 ? _vm.item.items.length : 1}},[(_vm.isEditable && _vm.jobType != 'RETRIEVE_ITEM')?_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button","title":"ลบรายการ"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveItemClick($event)}}},[_c('i',{staticClass:"text-danger la la-trash"})]):_vm._e()]):_vm._e()],2)}
var staticRenderFns = []


/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/AverageBarcode'),expression:"$route.path == '/Report/AverageBarcode'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รอบข้อมูล:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAprDateCycle',"name":'reAprDateCycle',"select2-options":_vm.reAprDateCycleOptions},model:{value:(_vm.reAprDateCycle),callback:function ($$v) {_vm.reAprDateCycle=$$v},expression:"reAprDateCycle"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รายการ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAprJobTypeCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAprJobTypeCode),callback:function ($$v) {_vm.reAprJobTypeCode=$$v},expression:"reAprJobTypeCode"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow([''])),expression:"this.$root.canShow([''])"}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("โรงงาน / คลังสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAprPlantCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAprPlantCode),callback:function ($$v) {_vm.reAprPlantCode=$$v},expression:"reAprPlantCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมวดหมู่สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAprProductGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAprProductGroupId),callback:function ($$v) {_vm.reAprProductGroupId=$$v},expression:"reAprProductGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAprProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAprProductTypeId),callback:function ($$v) {_vm.reAprProductTypeId=$$v},expression:"reAprProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAprProductBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAprProductBrandId),callback:function ($$v) {_vm.reAprProductBrandId=$$v},expression:"reAprProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAprAssetProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAprAssetProductCode),callback:function ($$v) {_vm.reAprAssetProductCode=$$v},expression:"reAprAssetProductCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.ExportAverageBarcode($event)}}},[_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"AverageBarcodeTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"13"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAprDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(2)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("รอบข้อมูล")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รายการ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("โรงงาน / คลังสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("หมวดหมู่สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนรวมครั้งต่อปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนบาร์โค้ด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รอบเฉลี่ยต่อปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รอบสูงสุดต่อปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รอบต่ำสุดต่อปี")])])}]


/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Invoice No :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oruInvoiceNo),expression:"oruInvoiceNo"}],staticClass:"form-control",attrs:{"id":"oruInvoiceNo","name":"oruInvoiceNo","type":"text","maxlength":"450","placeholder":"Invoice No."},domProps:{"value":(_vm.oruInvoiceNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.oruInvoiceNo=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Invoice Date :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"oruInvoiceDate",staticClass:"form-control",attrs:{"type":"text","id":"oruInvoiceDate","name":"oruInvoiceDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Supplier :")]),_vm._v(" "),_c('select2',{ref:"oruSupplierSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'oruSupplier',"name":'oruSupplier',"select2-options":_vm.oruSupplierOptions},model:{value:(_vm.oruSupplier),callback:function ($$v) {_vm.oruSupplier=$$v},expression:"oruSupplier"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แนบไฟล์:")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.oruDownloadUrl != null),expression:"oruDownloadUrl != null"}]},[_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.oruFileName))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.oruDownloadUrl,"target":"_blank"}},[_vm._v("Download")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button","id":"uploader-order","data-ref":_vm.uuid}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("ไฟล์\n              ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-file"}})])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"1440px"}},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.oruItems == null || _vm.oruItems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.oruItems),function(item,i){return [_c('order-item-row',{key:i,ref:"orderItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"9"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])])])])])])])])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(4)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("รหัส/ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ราคา")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("รวม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("งบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("โควต้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.BrandName),expression:"item.BrandName"}],staticClass:"form-control readonly",staticStyle:{"background-color":"#f7f7f7"},attrs:{"readonly":""},domProps:{"value":(_vm.item.BrandName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "BrandName", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.Days),expression:"item.Days"}],staticClass:"form-control required text-center",attrs:{"type":"number","min":"1","placeholder":"จำนวน","id":'days' + _vm._uid,"name":'days' + _vm._uid,"data-msg-required":"กรุณากรอกจำนวนวัน"},domProps:{"value":(_vm.item.Days)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "Days", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-12",attrs:{"type":"button","id":'f' + _vm.rowIndex},on:{"click":function($event){return _vm.doUpload(_vm.item,_vm.rowIndex)}}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("ไฟล์\n    ")])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('a',{attrs:{"href":_vm.item.DownloadFileUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.item.FileName))]),_vm._v(" "),(_vm.item.FileName)?_c('button',{staticClass:"btn btn-sm btn-danger ml-2",attrs:{"type":"button"},on:{"click":_vm.removeFile}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})]):_vm._e()])])}
var staticRenderFns = []


/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('router-link',{staticClass:"btn btn-secondary btn-sm",attrs:{"to":"/BudgetPlan/Job"}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" กลับ\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('button',{staticClass:"btn btn-success mr-2",attrs:{"disabled":_vm.selectedJobs.length === 0 || _vm.isProcessing},on:{"click":_vm.bulkApprove}},[(_vm.isProcessing)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('i',{staticClass:"fas fa-check"}),_vm._v("\n            อนุมัติ/ยืนยัน รายการที่เลือก\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"disabled":_vm.selectedJobs.length === 0 || _vm.isProcessing},on:{"click":_vm.bulkReject}},[(_vm.isProcessing)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_c('i',{staticClass:"fas fa-times"}),_vm._v("\n            ไม่อนุมัติ/ส่งกลับแก้ไข รายการที่เลือก\n          ")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"3%","font-weight":"bold"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"5%","font-weight":"bold"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,null)>-1:(_vm.selectAll)},on:{"change":[function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}},_vm.toggleSelectAll]}}),_vm._v(" เลือกใบงานทั้งหมด\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%","font-weight":"bold"}},[_vm._v("แผนก")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"25%","font-weight":"bold"}},[_vm._v("รายการสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%","font-weight":"bold"}},[_vm._v("จำนวนเงิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%","font-weight":"bold"}},[_vm._v("Vendor")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%","font-weight":"bold"}},[_vm._v("หมายเหตุ/เหตุผล")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%","font-weight":"bold"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"5%","font-weight":"bold"}},[_vm._v("คำสั่ง")])])]),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):(_vm.jobs.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"9"}},[_vm._v("ไม่มีใบงานที่รออนุมัติ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.jobs),function(job,index){return _c('tr',{key:job.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedJobs),expression:"selectedJobs"}],attrs:{"type":"checkbox"},domProps:{"value":job.id,"checked":Array.isArray(_vm.selectedJobs)?_vm._i(_vm.selectedJobs,job.id)>-1:(_vm.selectedJobs)},on:{"change":function($event){var $$a=_vm.selectedJobs,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=job.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedJobs=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedJobs=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedJobs=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v("["+_vm._s(job.orgCode)+"] "+_vm._s(job.orgName))]),_vm._v(" "),_c('td',_vm._l((job.items),function(item,idx){return _c('div',{key:idx},[(item.itemNo != null)?_c('span',[_vm._v(_vm._s(item.itemNo)+". "+_vm._s(item.description))]):_c('span',{staticStyle:{"padding-left":"1.5em"}},[_vm._v(_vm._s(item.description))])])}),0),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(job.totalAmount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(job.vendorDisplay))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(job.remark),expression:"job.remark"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"หมายเหตุ"},domProps:{"value":(job.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(job, "remark", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"text-center",staticStyle:{"vertical-align":"middle"}},[_c('span',{staticClass:"badge",class:job.approverType === 'CONFIRM' ? 'badge-primary' : 'badge-warning'},[_vm._v("\n                    "+_vm._s(job.approverType === 'CONFIRM' ? 'รอยืนยัน' : 'รออนุมัติ ลำดับที่ ' + job.currentApprovalLevel)+"\n                  ")])]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":'/BudgetPlan/Job/View/' + job.id,"target":"_blank","title":"ดูรายละเอียดใบงานงบประมาณ"}},[_c('i',{staticClass:"fas fa-search"})])])])})],2)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("ตรวจสอบใบงานที่ต้องอนุมัติ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert mb-3",staticStyle:{"background-color":"#FFFBE6","border":"1px solid #FFE58F","color":"#856404","margin-left":"0","padding":"0.375rem 0.75rem","display":"flex","align-items":"center","min-height":"42px","font-size":"1rem","line-height":"1.5"}},[_c('i',{staticClass:"fas fa-exclamation-triangle",staticStyle:{"color":"#856404","margin-right":"6px"}}),_vm._v(" "),_c('span',[_vm._v("*สถานะดำเนินการจะเป็นสถานะส่งกลับแก้ไขได้ต่อเมื่อใบงานเป็นสถานะรออนุมัติลำดับ 1, รออนุมัติลำดับ 2 เท่านั้น รออนุมัติลำดับอื่นๆสถานะจะเป็นไม่อนุมัติ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"9"}},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" กำลังโหลด...\n                ")])}]


/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/AlertReport/BeforeDue'),expression:"$route.path == '/AlertReport/BeforeDue'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+" "),_c('br'),_vm._v(" "),_c('i',{staticClass:"text-danger",staticStyle:{"font-size":"0.8em"}},[_vm._v("* รายงานแจ้งเตือนคงค้างก่อนครบกำหนดการคืนโรงงาน")])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[(this.$root.canShow(['super_admin']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ต้นทาง(โรงงาน/คลังสินค้า):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.OdCurrentLocationPlantOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OdCurrentLocationPlant),callback:function ($$v) {_vm.OdCurrentLocationPlant=$$v},expression:"OdCurrentLocationPlant"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับเข้าจากโรงงาน(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"StartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"StartDate","name":"StartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับเข้าจากโรงงาน(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"EndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"EndDate","name":"EndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Barcode:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.OdBarcode),expression:"OdBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.OdBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.OdBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.OdProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OdProductTypeId),callback:function ($$v) {_vm.OdProductTypeId=$$v},expression:"OdProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.OdAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OdAssetCode),callback:function ($$v) {_vm.OdAssetCode=$$v},expression:"OdAssetCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.OdBrandIdOptions,"placeholder":"กรุณาเลือก"},on:{"select":_vm.OdBrandIdClearAfterselect,"deselect":_vm.OdBrandIdDeSelect},model:{value:(_vm.OdBrandId),callback:function ($$v) {_vm.OdBrandId=$$v},expression:"OdBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อแบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{ref:"OdFinishProductId",attrs:{"id":"OdFinishProductId","multiple":true,"load-options":_vm.LoadOdFinishProductIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadOdFinishProductIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.OdFinishProductId),callback:function ($$v) {_vm.OdFinishProductId=$$v},expression:"OdFinishProductId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("เดือน(คงค้าง):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"OdOverMonth",staticClass:"form-control",attrs:{"type":"text","placeholder":"(ดด/ปปปป)","id":"OdOverMonth","name":"OdOverMonth","autocomplete":"off"}}),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ช่วงเวลา:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"OdPeriodRange","multiple":false,"options":_vm.OdPeriodRangeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OdPeriodRange),callback:function ($$v) {_vm.OdPeriodRange=$$v},expression:"OdPeriodRange"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.OdScanByUserOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OdScanByUser),callback:function ($$v) {_vm.OdScanByUser=$$v},expression:"OdScanByUser"}})],1)]),_vm._v(" "),(this.$root.canShow(['super_admin']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("มุมมองผู้ใช้งาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"ViewPermissionCode","multiple":false,"options":_vm.OdViewPermissionOptions,"placeholder":"กรุณาเลือก","clearable":false,"clear-on-select":false},on:{"input":function($event){return _vm.ChangeOptions('View')}},model:{value:(_vm.ViewPermissionCode),callback:function ($$v) {_vm.ViewPermissionCode=$$v},expression:"ViewPermissionCode"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('Collapsible',{staticClass:"product-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหาผู้ถือครอง\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la\tla-plus-square"}),_vm._v(" ค้นหาผู้ถือครอง\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"product"}},[_c('div',{staticClass:"row"},[(this.$root.canShow(['BR_REPORT','AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ถือครอง(ตัวแทนจำหน่าย):")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"OdCurrentLocationAgent","multiple":true,"options":_vm.OdCurrentLocationAgentOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.AgentClearAfterselect,"deselect":_vm.AgentClearAfterselect},model:{value:(_vm.OdCurrentLocationAgent),callback:function ($$v) {_vm.OdCurrentLocationAgent=$$v},expression:"OdCurrentLocationAgent"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT','SUB_AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ถือครอง(ตัวแทนจำหน่ายย่อย):")]),_vm._v(" "),_c('treeselect',{ref:"OdCurrentLocationSubAgent",attrs:{"id":"OdCurrentLocationSubAgent","multiple":true,"load-options":_vm.LoadOdCurrentLocationSubAgentOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadOdCurrentLocationSubAgentOptions,"select":_vm.SubAgentClearAfterselect},model:{value:(_vm.OdCurrentLocationSubAgent),callback:function ($$v) {_vm.OdCurrentLocationSubAgent=$$v},expression:"OdCurrentLocationSubAgent"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ถือครอง(ร้านค้าตัวแทน):")]),_vm._v(" "),_c('treeselect',{ref:"OdCurrentLocationShop",attrs:{"id":"OdCurrentLocationShop","multiple":true,"load-options":_vm.LoadOdCurrentLocationShopOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadOdCurrentLocationShopOptions,"select":_vm.ShopClearAfterselect},model:{value:(_vm.OdCurrentLocationShop),callback:function ($$v) {_vm.OdCurrentLocationShop=$$v},expression:"OdCurrentLocationShop"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['AGENT_REPORT','SUB_AGENT_REPORT']))?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ถือครอง(ร้านค้าตัวแทนจำหน่ายย่อย):")]),_vm._v(" "),_c('treeselect',{ref:"OdCurrentLocationSubShop",attrs:{"id":"OdCurrentLocationSubShop","multiple":true,"load-options":_vm.LoadOdCurrentLocationSubShopOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadOdCurrentLocationSubShopOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.OdCurrentLocationSubShop),callback:function ($$v) {_vm.OdCurrentLocationSubShop=$$v},expression:"OdCurrentLocationSubShop"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['BR_REPORT']) && _vm.ViewPermissionCode != 'AGENT_REPORT' && false)?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ถือครอง(ซัพพลายเออร์):")]),_vm._v(" "),_c('treeselect',{ref:"OdCurrentLocationVendor",attrs:{"multiple":true,"load-options":_vm.LoadOdCurrentLocationVendorOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadOdCurrentLocationVendorOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.OdCurrentLocationVendor),callback:function ($$v) {_vm.OdCurrentLocationVendor=$$v},expression:"OdCurrentLocationVendor"}})],1)]):_vm._e(),_vm._v(" "),(this.$root.canShow(['BR_REPORT']) && _vm.ViewPermissionCode != 'AGENT_REPORT' && false)?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("พนักงาน :")]),_vm._v(" "),_c('treeselect',{ref:"OdEmpId",attrs:{"multiple":true,"load-options":_vm.LoadOdEmpIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadOdEmpIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.OdEmpId),callback:function ($$v) {_vm.OdEmpId=$$v},expression:"OdEmpId"}})],1)]):_vm._e()])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[(this.$root.canShow(['AGENT_REPORT','SUB_AGENT_REPORT','BR_REPORT' ]))?_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportOverdueAll}},[_vm._m(4)]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]):_vm._e()])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"roleFormModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tabRoleInformation","role":"tabpanel"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อบทบาท:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.roleName),expression:"roleName"}],staticClass:"form-control",attrs:{"disabled":_vm.isEdit,"id":"roleName","name":"roleName","type":"text","maxlength":"256","placeholder":"ชื่อบทบาท"},domProps:{"value":(_vm.roleName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.roleName=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("คำอธิบาย:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"id":"description","name":"description","type":"description","maxlength":"450","placeholder":"คำอธิบาย"},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabRolePermissions","role":"tabpanel"}},[_c('v-jstree',{ref:"roleClaims",attrs:{"data":_vm.roleClaims,"show-checkbox":"","multiple":"","allow-batch":"","whole-row":""},on:{"item-click":_vm.claimClick}})],1)])])]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head"},[_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('ul',{staticClass:"nav nav-tabs nav-tabs-line nav-tabs-line-info nav-tabs-line-2x",attrs:{"role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"data-toggle":"tab","href":"#tabRoleInformation","role":"tab"}},[_c('i',{staticClass:"la la-cog"}),_vm._v(" ข้อมูลพื้นฐาน\n                  ")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"data-toggle":"tab","href":"#tabRolePermissions","role":"tab"}},[_c('i',{staticClass:"la la-briefcase"}),_vm._v(" การเข้าถึงหน้าจอ\n                  ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n          ")])])}]


/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"agentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'agentCode',"name":'agentCode',"select2-options":_vm.agentCodeOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลปี :")]),_vm._v(" "),_c('select2',{ref:"year",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'year',"name":'year',"select2-options":_vm.yearOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)])]),_vm._v(" "),(_vm.year && _vm.canExportAllAgents && !_vm.isShow)?_c('div',{staticClass:"d-flex justify-content-end align-items-center mb-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n              "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.isShow == true)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              รายการถังเปล่าหมุนเวียน :\n            ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingSelected},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelSelected($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)")+"\n                ")])]),_vm._v(" "),(_vm.canExportAllAgents)?_c('button',{staticClass:"btn btn-outline-primary ml-2",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"7800px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"rowspan":"3","scope":"rowgroup","width":"1%"}},[_vm._v("\n                        ลำดับ\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"3","scope":"rowgroup","width":"4%"}},[_vm._v("\n                        ประเภทสินค้า\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"3","scope":"rowgroup","width":"2%"}},[_vm._v("\n                        ต้นทุนสินค้า(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"60","scope":"colgroup"}},[_vm._v("\n                        จำนวนถังเปล่าหมุนเวียน (จำนวน) ปี "+_vm._s(_vm.year)+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","colspan":"4","scope":"rowgroup","width":"6%"}},[_vm._v("\n                        รวม\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"3","scope":"rowgroup","width":"2%"}},[_vm._v("\n                        % ถังหมุนเวียน\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"3","scope":"rowgroup","width":"1%"}},[_vm._v("\n                        จัดการ\n                      ")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('tr',[_vm._l((12),function(index){return [_c('th',{staticClass:"text-center"},[_vm._v("ยอดยกมา")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รับเข้า")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ส่งคืน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("คงเหลือ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("% ถังหมุนเวียน")])]}),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ยอดยกมา")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รับเข้า")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ส่งคืน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("คงเหลือ")])],2)]),_vm._v(" "),_c('tbody',{on:{"change":function($event){return _vm.changeTotal()}}},[(_vm.productitems == null || _vm.productitems.length == 0)?_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"69"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.productitems),function(item,i){return [_c('product-item-cal-row',{key:i,ref:"Items",refInFor:true,attrs:{"rowIndex":i,"item":item,"kPIProductType":_vm.kPIProductType,"yearSelected":_vm.year},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center"}),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รวมเงิน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_vm._l((12),function(monthIndex){return _vm._l((5),function(dataIndex){return _c('th',{key:monthIndex + '-' + dataIndex,staticClass:"text-center"},[_vm._v("\n                          "+_vm._s(_vm.calculateMonthTotal(monthIndex, dataIndex))+"\n                        ")])})}),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                        "+_vm._s(_vm.calculateTotalData(1))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                        "+_vm._s(_vm.calculateTotalData(2))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                        "+_vm._s(_vm.calculateTotalData(3))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                        "+_vm._s(_vm.calculateTotalData(4))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                        "+_vm._s(_vm.calculateTotalPercent())+"\n                      ")]),_vm._v(" "),_c('th')],2),_vm._v(" "),_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{attrs:{"colspan":"69"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[(_vm.isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand fas fa-unlink"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("มกราคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("กุมภาพันธ์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("มีนาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("เมษายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("พฤษภาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("มิถุนายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("กรกฎาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("สิงหาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("กันยายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("ตุลาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("พฤศจิกายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"5","width":"7%"}},[_vm._v("ธันวาคม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])}]


/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"disabled":_vm.isLoading},on:{"click":_vm.loadStatus}},[_c('i',{staticClass:"fas fa-sync-alt"}),_vm._v(" "+_vm._s(_vm.isLoading ? "กำลังโหลด..." : "Refresh")+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card text-white bg-success"},[_c('div',{staticClass:"card-body p-2 text-center"},[_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.summary.ok || 0))]),_vm._v(" "),_c('small',[_vm._v("OK")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"card text-white bg-warning"},[_c('div',{staticClass:"card-body p-2 text-center"},[_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.summary.stale || 0))]),_vm._v(" "),_c('small',[_vm._v("STALE")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"card text-white bg-danger"},[_c('div',{staticClass:"card-body p-2 text-center"},[_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.summary.failed || 0))]),_vm._v(" "),_c('small',[_vm._v("FAILED")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"card text-white bg-dark"},[_c('div',{staticClass:"card-body p-2 text-center"},[_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.summary.stuck || 0))]),_vm._v(" "),_c('small',[_vm._v("STUCK")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"card text-white bg-secondary"},[_c('div',{staticClass:"card-body p-2 text-center"},[_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.summary.neverRan || 0))]),_vm._v(" "),_c('small',[_vm._v("NEVER_RAN")])])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"card text-white bg-info"},[_c('div',{staticClass:"card-body p-2 text-center"},[_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.summary.total || 0))]),_vm._v(" "),_c('small',[_vm._v("Total")])])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-3"},[_c('label',[_vm._v("กลุ่ม (JobGroup):")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterGroup),expression:"filterGroup"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterGroup=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.loadStatus]}},[_c('option',{attrs:{"value":""}},[_vm._v("ทั้งหมด")]),_vm._v(" "),_vm._l((_vm.availableGroups),function(g){return _c('option',{key:g,domProps:{"value":g}},[_vm._v(_vm._s(g))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('label',[_vm._v("Issue:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterIssue),expression:"filterIssue"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterIssue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("ทั้งหมด")]),_vm._v(" "),_c('option',{attrs:{"value":"OK"}},[_vm._v("OK")]),_vm._v(" "),_c('option',{attrs:{"value":"STALE"}},[_vm._v("STALE")]),_vm._v(" "),_c('option',{attrs:{"value":"FAILED"}},[_vm._v("FAILED")]),_vm._v(" "),_c('option',{attrs:{"value":"STUCK"}},[_vm._v("STUCK")]),_vm._v(" "),_c('option',{attrs:{"value":"NEVER_RAN"}},[_vm._v("NEVER_RAN")])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('label',[_vm._v("สถานะการทำงาน:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterActive),expression:"filterActive"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterActive=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.loadStatus]}},[_c('option',{attrs:{"value":"active"}},[_vm._v("เปิดใช้งาน (Active)")]),_vm._v(" "),_c('option',{attrs:{"value":"inactive"}},[_vm._v("ปิดอยู่ (Inactive)")]),_vm._v(" "),_c('option',{attrs:{"value":"all"}},[_vm._v("ทั้งหมด")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.filteredItems.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"13"}},[_vm._v("ไม่พบข้อมูล")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredItems),function(it,index){return _c('tr',{key:it.jobName,class:{ 'row-clickable': _vm.isManageable(it.jobName) },on:{"click":function($event){return _vm.onRowClick(it)}}},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticClass:"col-jobname"},[_c('strong',[_vm._v(_vm._s(it.jobName))]),_vm._v(" "),(_vm.isManageable(it.jobName))?_c('i',{staticClass:"fas fa-cog text-info ml-1",attrs:{"title":"Manage"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(it.description))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge badge-light"},[_vm._v(_vm._s(it.jobGroup))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('small',[_vm._v(_vm._s(it.triggerSource))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',[_vm._v(_vm._s(it.scheduleDesc || _vm.formatCron(it.expectedCron)))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('code',[_vm._v(_vm._s(it.expectedCron || "-"))])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDateTime(it.lastStartTime)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(it.hoursSinceLastRun != null ? it.hoursSinceLastRun : "-"))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(it.maxAllowedGapHours))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge",class:_vm.statusBadgeClass(it.lastStatus)},[_vm._v("\n                "+_vm._s(it.lastStatus || "-")+"\n              ")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge",class:_vm.issueBadgeClass(it.issue)},[_vm._v("\n                "+_vm._s(it.issue)+"\n              ")])]),_vm._v(" "),_c('td',{staticClass:"text-center",on:{"click":function($event){$event.stopPropagation();}}},[_c('label',{staticClass:"switch mb-0",attrs:{"title":it.isActive ? 'job ทำงานอยู่' : 'job ถูกปิด — endpoint จะ skip'}},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.togglingActive[it.jobName]},domProps:{"checked":it.isActive},on:{"change":function($event){return _vm.toggleActive(it, $event)}}}),_vm._v(" "),_c('span',{staticClass:"slider"})])]),_vm._v(" "),_c('td',{staticClass:"text-center",on:{"click":function($event){$event.stopPropagation();}}},[_c('label',{staticClass:"switch mb-0",attrs:{"title":"ส่ง/ไม่ส่งอีเมลแจ้งเตือนเมื่อ job ล้มเหลว"}},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.togglingJobs[it.jobName]},domProps:{"checked":it.isNotify},on:{"change":function($event){return _vm.toggleNotify(it, $event)}}}),_vm._v(" "),_c('span',{staticClass:"slider"})])]),_vm._v(" "),_c('td',{staticClass:"text-center",on:{"click":function($event){$event.stopPropagation();}}},[_c('button',{staticClass:"btn btn-sm btn-outline-info",on:{"click":function($event){return _vm.openHistory(it)}}},[_c('i',{staticClass:"fas fa-history"})])])])})],2)])]),_vm._v(" "),(_vm.historyJob)?_c('div',{staticClass:"modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.historyJob = null}}},[_c('div',{staticClass:"modal-box"},[_c('div',{staticClass:"modal-header"},[_c('h5',[_vm._v("History — "+_vm._s(_vm.historyJob))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.historyJob = null}}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.isLoadingHistory)?_c('div',{staticClass:"text-center p-3"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" Loading...\n          ")]):_c('table',{staticClass:"table table-sm table-striped"},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.history.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"7"}},[_vm._v("ไม่มีประวัติ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.history),function(h,i){return _c('tr',{key:h.logId},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDateTime(h.startTime)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDateTime(h.endTime)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(h.durationMs != null ? h.durationMs.toLocaleString() : "-"))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge",class:_vm.statusBadgeClass(h.status)},[_vm._v(_vm._s(h.status))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(h.rowCountSnap != null)?_c('span',[_vm._v(_vm._s(h.rowCountSnap.toLocaleString()))]):(h.totalItems != null)?_c('span',[_vm._v("\n                    "+_vm._s(h.successItems || 0)+"/"+_vm._s(h.totalItems)+"\n                    "),(h.failedItems)?_c('span',[_vm._v(" (fail "+_vm._s(h.failedItems)+")")]):_vm._e()]):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(h.errorMessage))])])])})],2)])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("Scheduled Jobs — Monitoring")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"col-jobname"},[_vm._v("JobName")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Group")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Trigger")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Cron")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Last Run")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Hrs Since")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("MaxGap")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Last Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Issue")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Active")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("IsNotify")]),_vm._v(" "),_c('th',{staticClass:"text-center"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("StartTime")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("EndTime")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Duration(ms)")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Rows/Items")]),_vm._v(" "),_c('th',[_vm._v("Error")])])])}]


/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทสินค้าถือครอง:")]),_vm._v(" "),_c('select2',{ref:"houProductTypeIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'houProductTypeId',"name":'houProductTypeId',"select2-options":_vm.houProductTypeIdOptions},model:{value:(_vm.houProductTypeId),callback:function ($$v) {_vm.houProductTypeId=$$v},expression:"houProductTypeId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ระยะเวลาการถือครอง (วัน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.houHolderTime),expression:"houHolderTime"}],staticClass:"form-control",attrs:{"id":"houHolderTime","name":"houHolderTime","type":"number","min":"1","maxlength":"450","placeholder":"ระยะเวลาการถือครอง"},domProps:{"value":(_vm.houHolderTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.houHolderTime=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"houAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'houAgentCode',"name":'houAgentCode',"select2-options":_vm.houAgentCodeOptions},on:{"selectChange":_vm.onHouAgentCodeChange},model:{value:(_vm.houAgentCode),callback:function ($$v) {_vm.houAgentCode=$$v},expression:"houAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"houShopTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'houShopTypeCode',"name":'houShopTypeCode',"select2-options":_vm.houShopTypeCodeOptions},model:{value:(_vm.houShopTypeCode),callback:function ($$v) {_vm.houShopTypeCode=$$v},expression:"houShopTypeCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('select2',{ref:"houProductBrandIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'houProductBrandId',"name":'houProductBrandId',"select2-options":_vm.houProductBrandIdOptions},model:{value:(_vm.houProductBrandId),callback:function ($$v) {_vm.houProductBrandId=$$v},expression:"houProductBrandId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.houInActiveStatus),expression:"houInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"houInActiveStatus","id":"houInActiveStatus"},domProps:{"checked":Array.isArray(_vm.houInActiveStatus)?_vm._i(_vm.houInActiveStatus,null)>-1:(_vm.houInActiveStatus)},on:{"change":function($event){var $$a=_vm.houInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.houInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.houInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.houInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MachineReport/LeaseMachine'),expression:"$route.path == '/MachineReport/LeaseMachine'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Phase:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'relmPhase',"name":'relmPhase',"select2-options":_vm.relmPhaseOptions},model:{value:(_vm.relmPhase),callback:function ($$v) {_vm.relmPhase=$$v},expression:"relmPhase"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Lot:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'relmLot',"name":'relmLot',"select2-options":_vm.relmLotOptions},model:{value:(_vm.relmLot),callback:function ($$v) {_vm.relmLot=$$v},expression:"relmLot"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์เครื่องเบียร์สด:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'relmProductBrandId',"name":'relmProductBrandId',"select2-options":_vm.relmProductBrandIdOptions},model:{value:(_vm.relmProductBrandId),callback:function ($$v) {_vm.relmProductBrandId=$$v},expression:"relmProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'relmProductTypeId',"name":'relmProductTypeId',"select2-options":_vm.relmProductTypeIdOptions},model:{value:(_vm.relmProductTypeId),callback:function ($$v) {_vm.relmProductTypeId=$$v},expression:"relmProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'relmCurrentAgentCode',"name":'relmCurrentAgentCode',"select2-options":_vm.relmCurrentAgentCodeOptions},model:{value:(_vm.relmCurrentAgentCode),callback:function ($$v) {_vm.relmCurrentAgentCode=$$v},expression:"relmCurrentAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Supplier:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'relmCurrentVendorId',"name":'relmCurrentVendorId',"select2-options":_vm.relmCurrentVendorIdOptions},model:{value:(_vm.relmCurrentVendorId),callback:function ($$v) {_vm.relmCurrentVendorId=$$v},expression:"relmCurrentVendorId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportLeaseMachine}},[_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"datatable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"13"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_vm._l((_vm.headers),function(data){return _c('th',{staticClass:"all text-center",staticStyle:{"width":"6%"}},[_vm._v("\n                    "+_vm._s(data)+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("Grand Total")])],2),_vm._v(" "),_vm._l((_vm.database),function(item){return _c('tr',[_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(item.agentName))]),_vm._v(" "),_vm._l((_vm.headers),function(data){return _c('td',{staticClass:"all text-center",staticStyle:{"width":"6%"}},[_vm._v("\n                    "+_vm._s(item.phase.filter(function (o) { return o.phase == data; })[0] ==
                      undefined
                        ? null
                        : item.phase.filter(function (o) { return o.phase == data; })[0].total)+"\n                  ")])}),_vm._v(" "),_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(item.total))])],2)})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-right"},[_vm._v("Grand Total")]),_vm._v(" "),_vm._l((_vm.totalPhase),function(data){return _c('th',{staticClass:"text-center"},[_vm._v("\n                    "+_vm._s(data[1])+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.GrandTotal))])],2)]),_vm._v(" "),_c('tbody',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"text1"}})])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ Check-in :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.checkInDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ Check-out :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.checkOutDate || ''))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้ Check-in :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.checkInByUserFullName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ร้านค้า :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.shopName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ร้านค้า 2 :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.shopName2))])])])]),_vm._v(" "),_vm._l((_vm.barcodeShopMappings),function(b,i){return _c('div',{key:i,staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 text-left"},[(!b.isDelete)?_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                "+_vm._s(b.indexDisplay)+"\n              ")]):_vm._e(),_vm._v(" "),(b.isDelete)?_c('h3',{staticClass:"kt-section__title text-danger"},[_vm._m(1,true),_vm._v("\n                "+_vm._s(b.indexDisplay)+" (ชุดอุปกรณ์ที่ถูกลบ)\n              ")]):_vm._e(),_vm._v(" "),(b.isDelete)?_c('p',[_vm._v("สาเหตุที่ลบ : "+_vm._s(b.deleteReason))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(b.isPM == true)?_c('button',{staticClass:"btn btn-outline-brand",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.detailPM(b.barcodeShopMappingId)}}},[_c('i',{staticClass:"la la-file-text"}),_vm._v(" รายละเอียด PM\n              ")]):_vm._e(),_vm._v(" "),(b.isMT == true)?_c('button',{staticClass:"btn btn-outline-brand",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.detailMT(b.barcodeShopMappingId)}}},[_c('i',{staticClass:"la la-file-text"}),_vm._v(" รายละเอียด MT\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(2,true),_vm._v(" "),_c('tbody',_vm._l((b.barcodeSets),function(row,j){return _c('tr',{key:j},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(_vm.barcodeTypeText(row.barcodeType,row.barcodeSubTypeName))+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-center"},[_vm._v("\n                        "+_vm._s(row.productName)+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(row.barcodeNoOld)+" \n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(row.brand)+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[(row.fileUrl != null && !row.isImgCloud)?_c('a',{attrs:{"href":"#","title":"รูปภาพ"},on:{"click":function($event){$event.preventDefault();return _vm.pictureModal(row.fileUrl)}}},[_vm._v("Link  ")]):_vm._e(),_vm._v(" "),(row.fileUrl != null && row.isImgCloud)?_c('a',{attrs:{"href":"javascript:void(0);","title":"รูปภาพ"},on:{"click":function($event){return _vm.showModal(row.fileUrl)}}},[_vm._v("Link ")]):_vm._e()])])}),0)])])]),_vm._v(" "),(b.showRemark)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('strong',[_c('u',[_vm._v("หมายเหตุ")]),_vm._v(" : "+_vm._s(b.remark))])])]):_vm._e()])])})],2)]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"imageModal","tabindex":"-1","role":"dialog","aria-labelledby":"imageModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("ภาพถ่าย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticClass:"img-thumbnail mb-3",staticStyle:{"height":"auto","width":"auto"},attrs:{"src":_vm.modalImageURL}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-section__title-icon"},[_c('i',{staticClass:"fa fa-times-circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ประเภท")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("ชื่อ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("\n                        BARCODE\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("แบรนด์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("รูปภาพ")])])])}]


/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"PictureModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-md",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first text-center"},[_c('img',{staticClass:"img-thumbnail mb-3",staticStyle:{"height":"auto","width":"auto"},attrs:{"src":'/Api/MasterFile/FromUrl?url=' +
                        encodeURIComponent(this.$route.params.url)}})])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")])])}]


/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปี :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"odYear",staticClass:"form-control",attrs:{"type":"text","placeholder":"(YYYY)","autocomplete":"off"}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เดือน :")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMonth),expression:"selectedMonth"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedMonth=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.monthsTH_Full),function(m,idx){return _c('option',{key:idx,domProps:{"value":idx + 1}},[_vm._v(_vm._s(m))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 col-lg-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อตัวแทนจำหน่าย :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.agentOptions,"clear-on-select":true,"placeholder":"กรุณาเลือกตัวแทน"},model:{value:(_vm.selectedAgents),callback:function ($$v) {_vm.selectedAgents=$$v},expression:"selectedAgents"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-1 col-lg-1 d-flex align-items-end"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.clearSelectedAgents}},[_vm._v("ล้างข้อมูล")])])])])])])])]),_vm._v(" "),_vm._l((_vm.chartAgents),function(agent,agentIdx){return [_c('div',{key:'header-'+agentIdx,staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3 px-1"},[_c('h5',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.getAgentLabel(agent)))]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("ข้อมูล ณ เดือน : "+_vm._s(_vm.displayThaiMonth))])])])]),_vm._v(" "),_c('div',{key:'charts-'+agentIdx,staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('canvas',{attrs:{"id":'kegChart-'+agentIdx}})]),_vm._v(" "),_c('div',{staticClass:"col-3 d-flex flex-column align-items-center justify-content-center"},[_c('div',{staticClass:"score-box",class:_vm.getScoreBoxValue(agent, 'MAC') >= 40 ? 'score-box--green' : 'score-box--red'},[_c('span',{staticClass:"score-value",style:({ color: _vm.getScoreBoxValue(agent, 'MAC') >= 40 ? '#0abb87' : '#fd397a' })},[_vm._v(_vm._s(_vm.getScoreBoxValue(agent, 'MAC')))])]),_vm._v(" "),_c('small',{staticClass:"text-muted mt-2"},[_vm._v("คะแนนเต็ม 40")])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive mt-3"},[_c('table',{staticClass:"table table-sm table-borderless text-center mb-0"},[_c('tr',[_c('td',{staticClass:"text-left font-weight-bold",staticStyle:{"white-space":"nowrap"}},[_vm._v("คะแนน")]),_vm._v(" "),_vm._l((_vm.getAgentScores(agent, 'MAC')),function(score,idx){return _c('td',{key:'ks'+agentIdx+'-'+idx,style:({ color: score === null ? 'inherit' : (score >= 40 ? '#0abb87' : '#fd397a'), fontWeight: 'bold' })},[_vm._v("\n                    "+_vm._s(score !== null ? score : '-')+"\n                  ")])})],2),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left font-weight-bold",staticStyle:{"white-space":"nowrap"}},[_vm._v("เดือน")]),_vm._v(" "),_vm._l((_vm.monthsEN),function(m,idx){return _c('td',{key:'km'+agentIdx+'-'+idx,style:({ color: _vm.getAgentScores(agent, 'MAC')[idx] === null ? 'inherit' : (_vm.getAgentScores(agent, 'MAC')[idx] >= 40 ? '#0abb87' : '#fd397a'), fontWeight: _vm.getAgentScores(agent, 'MAC')[idx] !== null ? 'bold' : 'normal' })},[_vm._v(_vm._s(m))])})],2),_vm._v(" "),(_vm.hasRemarks(agent, 'MAC'))?_c('tr',[_c('td',{staticClass:"text-left font-weight-bold",staticStyle:{"white-space":"nowrap"}},[_vm._v("หมายเหตุ")]),_vm._v(" "),_vm._l((_vm.getAgentRemarks(agent, 'MAC')),function(remark,idx){return _c('td',{key:'mkr'+agentIdx+'-'+idx},[(remark)?_c('a',{staticClass:"text-primary",staticStyle:{"cursor":"pointer"},attrs:{"href":"javascript:void(0)","title":"อ่านหมายเหตุ"},on:{"click":function($event){return _vm.openRemarkModal(agent, 'MAC', idx)}}},[_c('i',{staticClass:"la la-comment"})]):_c('span',{staticClass:"text-muted"},[_vm._v("-")])])})],2):_vm._e()])]),_vm._v(" "),_vm._m(2,true)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('canvas',{attrs:{"id":'recordingChart-'+agentIdx}})]),_vm._v(" "),_c('div',{staticClass:"col-3 d-flex flex-column align-items-center justify-content-center"},[_c('div',{staticClass:"score-box",class:_vm.getScoreBoxValue(agent, 'SYS') >= 40 ? 'score-box--green' : 'score-box--red'},[_c('span',{staticClass:"score-value",style:({ color: _vm.getScoreBoxValue(agent, 'SYS') >= 40 ? '#0abb87' : '#fd397a' })},[_vm._v(_vm._s(_vm.getScoreBoxValue(agent, 'SYS')))])]),_vm._v(" "),_c('small',{staticClass:"text-muted mt-2"},[_vm._v("คะแนนเต็ม 40")])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive mt-3"},[_c('table',{staticClass:"table table-sm table-borderless text-center mb-0"},[_c('tr',[_c('td',{staticClass:"text-left font-weight-bold",staticStyle:{"white-space":"nowrap"}},[_vm._v("คะแนน")]),_vm._v(" "),_vm._l((_vm.getAgentScores(agent, 'SYS')),function(score,idx){return _c('td',{key:'rs'+agentIdx+'-'+idx,style:({ color: score === null ? 'inherit' : (score >= 40 ? '#0abb87' : '#fd397a'), fontWeight: 'bold' })},[_vm._v("\n                    "+_vm._s(score !== null ? score : '-')+"\n                  ")])})],2),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-left font-weight-bold",staticStyle:{"white-space":"nowrap"}},[_vm._v("เดือน")]),_vm._v(" "),_vm._l((_vm.monthsEN),function(m,idx){return _c('td',{key:'rm'+agentIdx+'-'+idx,style:({ color: _vm.getAgentScores(agent, 'SYS')[idx] === null ? 'inherit' : (_vm.getAgentScores(agent, 'SYS')[idx] >= 40 ? '#0abb87' : '#fd397a'), fontWeight: _vm.getAgentScores(agent, 'SYS')[idx] !== null ? 'bold' : 'normal' })},[_vm._v(_vm._s(m))])})],2),_vm._v(" "),(_vm.hasRemarks(agent, 'SYS'))?_c('tr',[_c('td',{staticClass:"text-left font-weight-bold",staticStyle:{"white-space":"nowrap"}},[_vm._v("หมายเหตุ")]),_vm._v(" "),_vm._l((_vm.getAgentRemarks(agent, 'SYS')),function(remark,idx){return _c('td',{key:'skr'+agentIdx+'-'+idx},[(remark)?_c('a',{staticClass:"text-primary",staticStyle:{"cursor":"pointer"},attrs:{"href":"javascript:void(0)","title":"อ่านหมายเหตุ"},on:{"click":function($event){return _vm.openRemarkModal(agent, 'SYS', idx)}}},[_c('i',{staticClass:"la la-comment"})]):_c('span',{staticClass:"text-muted"},[_vm._v("-")])])})],2):_vm._e()])]),_vm._v(" "),_vm._m(4,true)])])])])]}),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"remarkModal","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("หมายเหตุ — "+_vm._s(_vm.remarkModal.monthName))]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.remarkModal.text || '-'))])]),_vm._v(" "),_vm._m(6)])])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"flaticon-truck kt-font-success"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(" คะแนนถังคงค้าง\n                "),_c('span',{staticClass:"info-hint",attrs:{"data-tooltip":"กรณีเป็นสำนักงานใหญ่ (คะแนนนี้คำนวณจากสาขาที่ได้คะแนนน้อยที่สุด)"}},[_vm._v("i")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('a',{staticClass:"text-primary",attrs:{"href":"/Report/KegRotationScoreAgent","target":"_blank"}},[_c('i',{staticClass:"la la-link"}),_vm._v(" Link : รายงานคะแนนถังคงค้าง(ตัวแทนจำหน่าย)\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"flaticon-graph kt-font-brand"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("คะแนนการทำระบบเบียร์สด\n                "),_c('span',{staticClass:"info-hint",attrs:{"data-tooltip":"แสดงคะแนนแยกตามรายสาขาตามจริง (ไม่มีการคำนวณจากสาขาที่ได้คะแนนน้อยที่สุด)"}},[_vm._v("i")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('a',{staticClass:"text-primary",attrs:{"href":"/Report/JobAgentScore","target":"_blank"}},[_c('i',{staticClass:"la la-link"}),_vm._v(" Link : รายงานคะแนนการทำระบบเบียร์สด\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_c('span',[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("ปิด")])])}]


/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทการเคลม:")]),_vm._v(" "),_c('select2',{ref:"abcClaimTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'abcClaimTypeCode',"name":'abcClaimTypeCode',"select2-options":_vm.abcClaimTypeCodeOptions,"disabled":""},model:{value:(_vm.abcClaimTypeCode),callback:function ($$v) {_vm.abcClaimTypeCode=$$v},expression:"abcClaimTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'"}],staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"abcAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcAgentCode',"name":'abcAgentCode',"select2-options":_vm.abcAgentCodeOptions,"disabled":""},model:{value:(_vm.abcAgentCode),callback:function ($$v) {_vm.abcAgentCode=$$v},expression:"abcAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"}],staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"abcShopCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcShopCode',"name":'abcShopCode',"select2-options":_vm.abcShopCodeOptions,"disabled":""},model:{value:(_vm.abcShopCode),callback:function ($$v) {_vm.abcShopCode=$$v},expression:"abcShopCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อำเภอ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcAmpher),expression:"abcAmpher"}],staticClass:"form-control",attrs:{"id":"abcAmpher","name":"abcAmpher","type":"text","maxlength":"450","placeholder":"อำเภอ","disabled":""},domProps:{"value":(_vm.abcAmpher)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcAmpher=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcProvince),expression:"abcProvince"}],staticClass:"form-control",attrs:{"id":"abcProvince","name":"abcProvince","type":"text","maxlength":"450","placeholder":"จังหวัด","disabled":""},domProps:{"value":(_vm.abcProvince)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcProvince=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcPhone),expression:"abcPhone"}],staticClass:"form-control",attrs:{"id":"abcPhone","name":"abcPhone","type":"text","maxlength":"450","placeholder":"เบอร์โทร","disabled":""},domProps:{"value":(_vm.abcPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcPhone=$event.target.value}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.abcClaimTypeCode != null &&
              (_vm.abcAgentCode != null || _vm.abcShopCode != null)
          ),expression:"\n            abcClaimTypeCode != null &&\n              (abcAgentCode != null || abcShopCode != null)\n          "}],staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้าเคลม:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ปัญหาที่พบ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_c('input',{attrs:{"type":"checkbox","id":"myCheck"},on:{"click":function($event){return _vm.SelectClaimItems('All')}}}),_vm._v("\n                        ส่งเคลม\n                      ")])])]),_vm._v(" "),_c('tbody',[(
                        _vm.abcClaimItems == null || _vm.abcClaimItems.length == 0
                      )?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.abcClaimItems),function(item,i){return [_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.productBrand))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.material))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.barcodeOld))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.departmentMaterialCode))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.problemType))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.IsSelectCommit),expression:"item.IsSelectCommit"}],attrs:{"type":"radio","id":"one","value":"true"},domProps:{"checked":_vm._q(item.IsSelectCommit,"true")},on:{"click":function($event){return _vm.SelectClaimItems(item.claimItemId)},"change":function($event){return _vm.$set(item, "IsSelectCommit", "true")}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"Green"}},[_vm._v("สามารถส่งเคลมได้")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.IsSelectCommit),expression:"item.IsSelectCommit"}],attrs:{"type":"radio","id":"two","value":"false"},domProps:{"checked":_vm._q(item.IsSelectCommit,"false")},on:{"click":function($event){return _vm.SelectClaimItems(item.claimItemId)},"change":function($event){return _vm.$set(item, "IsSelectCommit", "false")}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"Red"}},[_vm._v("ไม่สามารถส่งเคลมได้")])])])]})],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสตัวแทนจำหน่าย :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.agentCode))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อตัวแทนจำหน่าย :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.agentName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ที่อยู่ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.adress))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"options":_vm.OwnerTypeCodeOption,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.OwnerTypeCode),callback:function ($$v) {_vm.OwnerTypeCode=$$v},expression:"OwnerTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.Area))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย(เบียร์สด) :")]),_vm._v(" "),_c('select2',{ref:"auAreaNewSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'auAreaNew',"name":'auAreaNew',"select2-options":_vm.auAreaNewOptions},model:{value:(_vm.auAreaNew),callback:function ($$v) {_vm.auAreaNew=$$v},expression:"auAreaNew"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.Province))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อเจ้าของ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.agentOnwer))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เบอร์โทร :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.tel))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"id":"email","name":"email","type":"text","maxlength":"450","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อผู้ติดต่อ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.agentContact))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เบอร์โทรผู้ติดต่อ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.agentContactTel))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตั้งค่าระยะ Check-In/Check-Out:")]),_vm._v(" "),_c('small',{staticClass:"text-danger ml-2"},[_vm._v("*ทำไว้เผื่ออนาคตมีการทำงานที่ต้องเข้า Check-In ที่ตัวแทนจำหน่าย")]),_vm._v(" "),_c('div',[_c('label',{staticClass:"kt-radio kt-radio--bold kt-radio--brand",staticStyle:{"margin-right":"30px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.useSettingCheckinRange),expression:"useSettingCheckinRange"}],attrs:{"type":"radio"},domProps:{"value":true,"checked":_vm._q(_vm.useSettingCheckinRange,true)},on:{"change":function($event){_vm.useSettingCheckinRange=true}}}),_vm._v(" กำหนดตามตั้งค่าพื้นฐาน\n                    "),_c('span')]),_vm._v(" "),_c('label',{staticClass:"kt-radio kt-radio--bold kt-radio--brand"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.useSettingCheckinRange),expression:"useSettingCheckinRange"}],attrs:{"type":"radio"},domProps:{"value":false,"checked":_vm._q(_vm.useSettingCheckinRange,false)},on:{"change":function($event){_vm.useSettingCheckinRange=false}}}),_vm._v(" กำหนดเอง\n                    "),_c('span')]),_vm._v(" "),(!_vm.useSettingCheckinRange)?_c('button',{staticClass:"btn btn-sm btn-clean btn-icon",attrs:{"type":"button","title":"ใช้ค่า default"},on:{"click":_vm.resetCheckinRange}},[_c('i',{staticClass:"la la-times"})]):_vm._e()]),_vm._v(" "),(_vm.useSettingCheckinRange && _vm.apiLoadedCheckInRange === null)?_c('div',{staticClass:"alert alert-warning mt-2",staticStyle:{"max-width":"500px"}},[_c('i',{staticClass:"la la-exclamation-triangle"}),_vm._v(" ให้ไป apply ค่าที่หน้า ตั้งค่าพื้นฐาน\n                ")]):_vm._e(),_vm._v(" "),(!_vm.useSettingCheckinRange)?_c('div',{staticClass:"mt-2",staticStyle:{"max-width":"300px"}},[_c('label',{staticClass:"label-required"},[_vm._v("ระยะ (เมตร):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.customCheckInRange),expression:"customCheckInRange",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"10000","placeholder":"ระบุระยะ (เมตร)","name":"customCheckInRange"},domProps:{"value":(_vm.customCheckInRange)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.customCheckInRange=_vm._n($event.target.value)},_vm.checkCustomCheckInRangeMax],"change":_vm.checkCustomCheckInRangeMax,"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.customCheckInRangeMaxError)?_c('span',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.customCheckInRangeMaxError))]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่งที่ตั้ง:")]),_vm._v(" "),(_vm.lat === null)?_c('div',[_c('button',{staticClass:"btn m-btn--pill btn-info btn-block col-xl-4 col-lg-4 col-md-4 col-sm-4",attrs:{"type":"button"},on:{"click":_vm.getMap}},[_vm._v("\n                    ระบุข้อมูลตำแหน่งที่ตั้ง\n                  ")])]):_c('div',[_c('GmapMap',{staticStyle:{"width":"500px","height":"300px"},attrs:{"center":{ lat: _vm.lat, lng: _vm.lng },"zoom":15,"clickable":true},on:{"click":_vm.updateCoordinates}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"draggable":true,"clickable":true},on:{"drag":_vm.updateCoordinates,"click":_vm.updateCoordinates}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.openMap()}}},[_c('i',{staticClass:"far fa-map"}),_vm._v(" Open GoogleMaps")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แจ้งเตือน Email คงค้างถัง,ท่อ (รายงาน Stock รายบาร์โค้ด):")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.IsSendReport),expression:"IsSendReport"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"IsSendReport","id":"IsSendReport"},domProps:{"checked":Array.isArray(_vm.IsSendReport)?_vm._i(_vm.IsSendReport,null)>-1:(_vm.IsSendReport)},on:{"change":function($event){var $$a=_vm.IsSendReport,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.IsSendReport=$$a.concat([$$v]))}else{$$i>-1&&(_vm.IsSendReport=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.IsSendReport=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                    เปิดใช้งานแจ้งเตือน Email คงค้างถัง,ท่อ (รายงาน Stock รายบาร์โค้ด)\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-4 col-lg-4 col-md-4 col-sm-4",attrs:{"type":"button"},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("รูป\n              ")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"2%"},attrs:{"id":"container-img"}},_vm._l((_vm.FileUpload),function(image){return (image.isLoaded)?_c('div',{key:image.pictureId,staticClass:"col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap",attrs:{"id":image.pictureId}},[_c('img',{staticClass:"img-agent -avatar js-avatar-me img-thumbnail card-img-top",attrs:{"src":image.urlImg},on:{"error":function($event){return _vm.handleImageError(image)},"load":function($event){return _vm.handleImageLoad(image)}}}),_vm._v(" "),_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-agent close",staticStyle:{"position":"absolute","top":"10px","right":"20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeImage(image.pictureId)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})])]):_vm._e()}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แสดงข้อมูลตัวแทนจำหน่ายในรายงาน (Module ข้อมูลคะแนนตัวแทนจำหน่าย):")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isShowInAgentScoreReport),expression:"isShowInAgentScoreReport"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"isShowInAgentScoreReport","id":"isShowInAgentScoreReport"},domProps:{"checked":Array.isArray(_vm.isShowInAgentScoreReport)?_vm._i(_vm.isShowInAgentScoreReport,null)>-1:(_vm.isShowInAgentScoreReport)},on:{"change":function($event){var $$a=_vm.isShowInAgentScoreReport,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isShowInAgentScoreReport=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isShowInAgentScoreReport=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isShowInAgentScoreReport=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เปิดใช้งาน\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("[PM] ตั้งค่าใช้ PM (รูปแบบพิเศษ):")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.IsSpecialPM),expression:"IsSpecialPM"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"IsSpecialPM","id":"IsSpecialPM"},domProps:{"checked":Array.isArray(_vm.IsSpecialPM)?_vm._i(_vm.IsSpecialPM,null)>-1:(_vm.IsSpecialPM)},on:{"change":function($event){var $$a=_vm.IsSpecialPM,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.IsSpecialPM=$$a.concat([$$v]))}else{$$i>-1&&(_vm.IsSpecialPM=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.IsSpecialPM=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                    เปิดใช้งาน PM (รูปแบบพิเศษ)\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะตัวแทนจำหน่าย:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agentStatus),expression:"agentStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"agentStatus","id":"agentStatus","disabled":""},domProps:{"checked":Array.isArray(_vm.agentStatus)?_vm._i(_vm.agentStatus,null)>-1:(_vm.agentStatus)},on:{"change":function($event){var $$a=_vm.agentStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.agentStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.agentStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.agentStatus=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                  ยุติการเป็นผู้แทนจำหน่าย\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"status","id":"status"},domProps:{"checked":Array.isArray(_vm.status)?_vm._i(_vm.status,null)>-1:(_vm.status)},on:{"change":function($event){var $$a=_vm.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.status=$$a.concat([$$v]))}else{$$i>-1&&(_vm.status=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.status=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                  เปิดใช้งาน\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทน (สำนักงานใหญ่):")]),_vm._v(" "),_c('select2',{ref:"mappingToAgentCode",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'mappingToAgentCode',"name":'mappingToAgentCode',"select2-options":_vm.mappingToAgentCodeOptions},model:{value:(_vm.smlMapping.mappingToAgentCode),callback:function ($$v) {_vm.$set(_vm.smlMapping, "mappingToAgentCode", $$v)},expression:"smlMapping.mappingToAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ใช้งาน SML:")]),_vm._v(" "),_c('div',{staticClass:"form-check mt-3 pl-0"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smlMapping.useMappingDocSML),expression:"smlMapping.useMappingDocSML"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"status","id":"status"},domProps:{"checked":Array.isArray(_vm.smlMapping.useMappingDocSML)?_vm._i(_vm.smlMapping.useMappingDocSML,null)>-1:(_vm.smlMapping.useMappingDocSML)},on:{"change":function($event){var $$a=_vm.smlMapping.useMappingDocSML,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.smlMapping, "useMappingDocSML", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.smlMapping, "useMappingDocSML", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.smlMapping, "useMappingDocSML", $$c)}}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เปิดอ้างอิงข้อมูลเอกสารจากระบบ SML\n                    ")]),_vm._v(" "),_c('label',{staticClass:"form-check-label kt-checkbox ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smlMapping.useMappingShopSML),expression:"smlMapping.useMappingShopSML"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"status","id":"status"},domProps:{"checked":Array.isArray(_vm.smlMapping.useMappingShopSML)?_vm._i(_vm.smlMapping.useMappingShopSML,null)>-1:(_vm.smlMapping.useMappingShopSML)},on:{"change":function($event){var $$a=_vm.smlMapping.useMappingShopSML,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.smlMapping, "useMappingShopSML", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.smlMapping, "useMappingShopSML", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.smlMapping, "useMappingShopSML", $$c)}}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เปิดส่งข้อมูลร้านค้าจากระบบ SML\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("คลังอุปกรณ์เบียร์สด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smlMapping.whCode),expression:"smlMapping.whCode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"หากไม่ระบุจะใช้ DBS222"},domProps:{"value":(_vm.smlMapping.whCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.smlMapping, "whCode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("พื้นที่เก็บ (คลังหลักพร้อมขาย):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smlMapping.location1Code),expression:"smlMapping.location1Code"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"หากไม่ระบุจะใช้ LC100"},domProps:{"value":(_vm.smlMapping.location1Code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.smlMapping, "location1Code", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("พื้นที่เก็บ (คลังถังเบียร์สด):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smlMapping.location2Code),expression:"smlMapping.location2Code"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"หากไม่ระบุจะใช้ LC300"},domProps:{"value":(_vm.smlMapping.location2Code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.smlMapping, "location2Code", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ยกยอดสินค้าในใบงานเร่ขายไปวันถัดไป:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isPreviousBalance),expression:"isPreviousBalance"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"isPreviousBalance","id":"isPreviousBalance"},domProps:{"checked":Array.isArray(_vm.isPreviousBalance)?_vm._i(_vm.isPreviousBalance,null)>-1:(_vm.isPreviousBalance)},on:{"change":function($event){var $$a=_vm.isPreviousBalance,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isPreviousBalance=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isPreviousBalance=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isPreviousBalance=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เปิดใช้งาน\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ใบงาน รับสินค้า/ทรัพย์สินจากลูกค้า และ เร่ขาย ไม่คืนคลังหลักพร้อมขายอัตโนมัติ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isNotReturnPlant),expression:"isNotReturnPlant"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"isNotReturnPlant","id":"isNotReturnPlant"},domProps:{"checked":Array.isArray(_vm.isNotReturnPlant)?_vm._i(_vm.isNotReturnPlant,null)>-1:(_vm.isNotReturnPlant)},on:{"change":function($event){var $$a=_vm.isNotReturnPlant,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isNotReturnPlant=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isNotReturnPlant=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isNotReturnPlant=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เปิดใช้งาน\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ใบงานเร่ขาย กรณีส่งสินค้า โอนคืนคลังหลักพร้อมขายอัตโนมัติ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isReturnSaleProduct),expression:"isReturnSaleProduct"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"isReturnSaleProduct","id":"isReturnSaleProduct"},domProps:{"checked":Array.isArray(_vm.isReturnSaleProduct)?_vm._i(_vm.isReturnSaleProduct,null)>-1:(_vm.isReturnSaleProduct)},on:{"change":function($event){var $$a=_vm.isReturnSaleProduct,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isReturnSaleProduct=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isReturnSaleProduct=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isReturnSaleProduct=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เปิดใช้งาน\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"})])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ")]),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("รูปภาพ:"),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                  (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล")])}]


/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"odcMaterialCode",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'odcMaterialCode' + _vm._uid,"name":'odcMaterialCode' + _vm._uid,"select2-options":_vm.odcMaterialCodeOptions,"data-msg-required":"กรุณาเลือกสินค้า"},model:{value:(_vm.item.odcMaterialCode),callback:function ($$v) {_vm.$set(_vm.item, "odcMaterialCode", $$v)},expression:"item.odcMaterialCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.odcQuantity),expression:"item.odcQuantity"}],staticClass:"form-control required text-right",attrs:{"type":"number","min":"0","placeholder":"จำนวน","id":'odcQuantity' + _vm._uid,"name":'odcQuantity' + _vm._uid,"data-msg-required":"กรุณากรอกจำนวน"},domProps:{"value":(_vm.item.odcQuantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "odcQuantity", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.odcPrice),expression:"item.odcPrice"}],staticClass:"form-control required text-right",attrs:{"type":"number","min":"0","placeholder":"ราคา","id":'odcPrice' + _vm._uid,"name":'odcPrice' + _vm._uid,"data-msg-required":"กรุณากรอกราคา"},domProps:{"value":(_vm.item.odcPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "odcPrice", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalCal),expression:"totalCal"}],staticClass:"form-control required text-right",attrs:{"type":"number","min":"0","id":'odcTotal' + _vm._uid,"name":'odcTotal' + _vm._uid,"readonly":""},domProps:{"value":(_vm.totalCal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.totalCal=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"odcBudgetId",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'odcBudgetId' + _vm._uid,"name":'odcBudgetId' + _vm._uid,"select2-options":_vm.odcBudgetIdOptions,"data-msg-required":"กรุณาเลือกงบประมาณ"},model:{value:(_vm.item.odcBudgetId),callback:function ($$v) {_vm.$set(_vm.item, "odcBudgetId", $$v)},expression:"item.odcBudgetId"}})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"odcQuotaId",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'odcQuotaId' + _vm._uid,"name":'odcQuotaId' + _vm._uid,"select2-options":_vm.odcQuotaIdOptions,"data-msg-required":"กรุณาเลือกโควต้า"},model:{value:(_vm.item.odcQuotaId),callback:function ($$v) {_vm.$set(_vm.item, "odcQuotaId", $$v)},expression:"item.odcQuotaId"}})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('center',[_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveItemClick($event)}}},[_c('i',{staticClass:"text-danger la la-trash"})])])],1)])}
var staticRenderFns = []


/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--last kt-portlet--head-lg kt-portlet--responsive-mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_c('p',{staticClass:"mt-2 mb-0"},[_vm._v("\n              ข้อมูล CN ของใบงาน ประเภทรับคืนสินค้า/ทรัพย์สินจากลูกค้า เลขที่\n              "),_c('strong',[_vm._v(_vm._s(_vm.jobNumber))])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('button',{staticClass:"btn btn-sm btn-clean kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("กลับ")])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"jobForm",staticClass:"kt-form",attrs:{"autocomplete":"off","id":"jobForm"},on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4 col-md-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("BARCODE/รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cnFormBarcode),expression:"cnFormBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก BARCODE, รหัสทรัพย์สิน(เบียร์สด)"},domProps:{"value":(_vm.cnFormBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cnFormBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("สินค้า:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'cnFormMaterialCode',"name":'cnFormMaterialCode',"select2-options":_vm.cnFormMaterialCodeOptions,"multiple":""},model:{value:(_vm.cnFormMaterialCode),callback:function ($$v) {_vm.cnFormMaterialCode=$$v},expression:"cnFormMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("คลังสินค้าที่จ่ายออก:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'cnFormOriginPlant',"name":'cnFormOriginPlant',"select2-options":_vm.cnFormOriginPlantOptions,"multiple":""},model:{value:(_vm.cnFormOriginPlant),callback:function ($$v) {_vm.cnFormOriginPlant=$$v},expression:"cnFormOriginPlant"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ตัวแทนฯที่ได้รับจากคลังสินค้า:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'cnFormDestinationAgent',"name":'cnFormDestinationAgent',"select2-options":_vm.cnFormDestinationAgentOptions,"multiple":""},model:{value:(_vm.cnFormDestinationAgent),callback:function ($$v) {_vm.cnFormDestinationAgent=$$v},expression:"cnFormDestinationAgent"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("การคืน:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'cnFormCNStatus',"name":'cnFormCNStatus',"select2-options":_vm.cnFormCNStatusOptions,"multiple":""},model:{value:(_vm.cnFormCNStatus),callback:function ($$v) {_vm.cnFormCNStatus=$$v},expression:"cnFormCNStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ระบบ CN ให้(ตัวแทนฯ):")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'cnFormCNToAgent',"name":'cnFormCNToAgent',"select2-options":_vm.cnFormCNToAgentOptions,"multiple":""},model:{value:(_vm.cnFormCNToAgent),callback:function ($$v) {_vm.cnFormCNToAgent=$$v},expression:"cnFormCNToAgent"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":_vm.getJobCN}},[_c('span',[_vm._v("ค้นหา")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.getJobCNReset}},[_vm._v("\n                    ล้างค่าทั้งหมด\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการ:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center align-middle",attrs:{"width":"5%"}},[_vm._v("\n                          ลำดับ\n                        ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"15%"}},[_vm._v("\n                          รหัสคลัง"),_c('br'),_vm._v("คลังสินค้าที่จ่ายออก\n                          "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md text-warning",attrs:{"href":"#","title":"คัดลอกรหัสคลังทั้งหมด ตามข้อมูลแถวที่ 1"},on:{"click":function($event){$event.preventDefault();return _vm.confirmCopyOriginPlant($event)}}},[_c('i',{staticClass:"la la-copy"})])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"8%"}},[_vm._v("\n                          การคืน\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",attrs:{"width":"15%"}},[_vm._v("\n                          ระบบ CN ให้(ตัวแทนฯ)\n                        ")]),_vm._v(" "),_c('th',{staticClass:"text-center align-middle",staticStyle:{"color":"#0277bd"},attrs:{"width":"15%"}},[_vm._v("\n                          แก้ไข CN ให้(ตัวแทนฯ)\n                          "),(this.$root.canShow(['super_admin']))?_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md text-warning",attrs:{"href":"#","title":"คัดลอกแก้ไข CN ให้(ตัวแทนฯ) ทั้งหมด ตามข้อมูลแถวที่ 1"},on:{"click":function($event){$event.preventDefault();return _vm.confirmCopyCnToAgentCode($event)}}},[_c('i',{staticClass:"la la-copy"})]):_vm._e()])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.jobCNItems),function(item,i){return [_c('job-cn-item-row',{key:i,ref:"jobCNItems",refInFor:true,attrs:{"rowIndex":i,"item":item}})]})],2),_vm._v(" "),_c('tfoot')]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมายเหตุ:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.cnRemark),expression:"cnRemark"}],staticClass:"form-control",attrs:{"placeholder":"หมายเหตุ","rows":"5","maxlength":_vm.maxLength},domProps:{"value":(_vm.cnRemark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cnRemark=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"}),_vm._v(" "),(_vm.cnRemark)?_c('span',{staticStyle:{"float":"right"}},[_vm._v(_vm._s(_vm.cnRemark.length)+" / "+_vm._s(_vm.maxLength))]):_vm._e(),_vm._v(" "),(!_vm.cnRemark || _vm.cnRemark == '')?_c('span',{staticStyle:{"float":"right"}},[_vm._v("0 / "+_vm._s(_vm.maxLength))]):_vm._e()])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 kt-align-right"},[_c('button',{staticClass:"btn btn-sm btn-clean kt-margin-r-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("กลับ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary kt-margin-r-10",attrs:{"type":"button"},on:{"click":_vm.formSubmit}},[_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("บันทึกข้อมูล")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm kt-margin-r-10",staticStyle:{"background-color":"#7700cf","color":"#FFFFFF"},attrs:{"type":"button"},on:{"click":function($event){return _vm.formSubmitConfirm()}}},[_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("ยืนยันข้อมูล CN")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-priceTier flaticon2-writing"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center align-middle",attrs:{"width":"15%"}},[_vm._v("\n                          BARCODE"),_c('br'),_vm._v("(รหัสทรัพย์สิน(เบียร์สด))\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center align-middle",attrs:{"width":"15%"}},[_vm._v("\n                          รหัสสินค้า"),_c('br'),_vm._v("ชื่อสินค้า\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center align-middle",attrs:{"width":"10%"}},[_vm._v("\n                          รหัสตัวแทนฯ "),_c('br'),_vm._v("\n                          ตัวแทนฯที่ได้รับจากคลังสินค้า\n                        ")])}]


/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),(_vm.loadError)?_c('div',{staticClass:"kt-portlet__body",attrs:{"data-test":"fss-detail-notfound"}},[_c('div',{staticClass:"fss-detail__notfound"},[_c('i',{staticClass:"fas fa-file-excel fss-detail__notfound-icon"}),_vm._v(" "),_c('div',{staticClass:"fss-detail__notfound-title"},[_vm._v("ไม่พบเอกสารที่ต้องการ")]),_vm._v(" "),_c('div',{staticClass:"fss-detail__notfound-text"},[_vm._v(_vm._s(_vm.loadError))]),_vm._v(" "),(_vm.requestedDocumentNo)?_c('div',{staticClass:"fss-detail__notfound-doc"},[_vm._v("\n        เลขที่ที่เรียก: "+_vm._s(_vm.requestedDocumentNo)+"\n      ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary kt-margin-t-20",attrs:{"type":"button","data-test":"fss-detail-notfound-back"},on:{"click":_vm.goBackToList}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" กลับไปที่รายการเอกสาร\n      ")])])]):_c('div',{staticClass:"kt-portlet__body"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6 col-sm-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("เลขที่เอกสาร:")]),_vm._v(" "),_c('div',{staticClass:"fss-readonly kt-font-bold"},[_vm._v(_vm._s(_vm.documentNo || "-"))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6 col-sm-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("วันที่บันทึก:")]),_vm._v(" "),_c('div',{staticClass:"fss-readonly"},[_vm._v(_vm._s(_vm.snapshotDateText))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",attrs:{"data-test":"fss-detail-filter"}},[_c('h5',{staticClass:"kt-font-bold kt-margin-b-10"},[_vm._v("Filter ที่เลือก")]),_vm._v(" "),(_vm.filterItems.length > 0)?_c('table',{staticClass:"table table-sm fss-filter-table"},[_c('tbody',_vm._l((_vm.filterItems),function(item,index){return _c('tr',{key:index,attrs:{"data-test":"fss-detail-filter-line"}},[_c('td',{staticClass:"fss-filter-table__label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.text))])])}),0)]):(_vm.filterText)?_c('div',{staticClass:"fss-filter-text"},[_vm._v(_vm._s(_vm.filterText))]):_c('div',{staticClass:"text-muted"},[_vm._v("-")])])]),_vm._v(" "),_c('div',{staticClass:"kt-separator kt-separator--border-dashed kt-separator--space-sm"}),_vm._v(" "),(_vm.isNoData)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-secondary text-center",attrs:{"role":"alert"}},[_c('div',{staticClass:"kt-font-bold"},[_vm._v("ไม่พบข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.noDataMessage))])])])]):_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered fss-agent-table",attrs:{"data-test":"fss-detail-agent-table"}},[_vm._m(3),_vm._v(" "),_c('tbody',[_c('tr',{attrs:{"data-test":"fss-detail-agent-row"}},[_c('td',{staticClass:"text-center"},[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(_vm.agentLabel)+"\n                  "),(_vm.branchLine)?_c('div',{staticClass:"fss-branch-line",attrs:{"data-test":"fss-detail-branch-line"}},[_vm._v("\n                    "+_vm._s(_vm.branchLine)+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatQty(_vm.totalQty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatAmount(_vm.totalAmount)))])]),_vm._v(" "),_c('tr',{staticClass:"fss-detail-row",attrs:{"data-test":"fss-detail-detail-row"}},[_c('td',{attrs:{"colspan":"4"}},[_c('div',{staticClass:"fss-detail-box"},[_c('div',{staticClass:"fss-detail-box__title",attrs:{"data-test":"fss-detail-detail-title"}},[_vm._v("\n                      รายละเอียดสินค้าคงค้าง — "+_vm._s(_vm.agentNameOnly)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.details),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.seqNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productTypeName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productName))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatQty(row.qty)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.unitName))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatAmount(row.amount)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"fss-total-row"},[_c('td',{staticClass:"text-right kt-font-bold",attrs:{"colspan":"4"}},[_vm._v("Grand Total")]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v(_vm._s(_vm.formatQty(_vm.totalQty)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("—")]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v("\n                              "+_vm._s(_vm.formatAmount(_vm.totalAmount))+"\n                            ")])])])])])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-separator kt-separator--border-dashed kt-separator--space-sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('button',{staticClass:"btn btn-sm btn-clean kt-margin-r-10",attrs:{"type":"button","data-test":"fss-detail-back"},on:{"click":_vm.goBackToList}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("กลับไปที่รายการเอกสาร")])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-9 text-right"},[_c('button',{staticClass:"btn btn-sm fss-btn fss-btn--orange kt-margin-r-10",attrs:{"type":"button","data-test":"fss-detail-pdf"},on:{"click":_vm.exportPdf}},[_c('i',{staticClass:"la la-print"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("พิมพ์ PDF")])]),_vm._v(" "),_c('span',{staticClass:"fss-detail__excel-group kt-margin-r-10"},[_c('button',{staticClass:"btn btn-sm fss-btn",class:_vm.excelAvailable ? 'fss-btn--green' : 'fss-btn--disabled',attrs:{"type":"button","aria-disabled":_vm.excelAvailable ? 'false' : 'true',"title":_vm.excelTitle,"data-test":"fss-detail-excel"},on:{"click":_vm.exportExcel}},[_c('i',{staticClass:"la la-file-excel-o"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("Export Excel (รายละเอียดบาร์โค้ด)")])]),_vm._v(" "),(_vm.excelExpireDateText)?_c('span',{staticClass:"fss-expire-line fss-detail__expire-under",attrs:{"data-test":"fss-detail-expire-line"}},[_c('span',{staticClass:"fss-expire-warn"},[_vm._v("⚠ หมดอายุ Export Excel")]),_vm._v(" "),_c('span',{staticClass:"fss-expire-date"},[_vm._v(_vm._s(_vm.excelExpireDateText))])]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm fss-btn kt-margin-r-10",class:_vm.hasAttachment ? 'fss-btn--green fss-attach-has' : 'fss-btn--red',attrs:{"type":"button","data-test":"fss-detail-attachment"},on:{"click":_vm.openAttachment}},[_c('i',{staticClass:"la la-paperclip"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("\n            แนบไฟล์เอกสาร ("+_vm._s(_vm.attachmentCount)+")\n          ")])])])])]),_vm._v(" "),_c('form-summary-stock-attachment-modal',{ref:"attachmentModal",on:{"closed":_vm.loadDocument}}),_vm._v(" "),_c('FormSummaryStockSignatureModal',{ref:"signatureModal"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-file-alt"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n        เอกสารสรุปสินค้าคงค้าง\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"fss-stepper"},[_c('div',{staticClass:"fss-step fss-step--done"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("✓")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("เลือก Filter")])]),_vm._v(" "),_c('div',{staticClass:"fss-connector fss-connector--all-done"}),_vm._v(" "),_c('div',{staticClass:"fss-step fss-step--done"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("✓")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("ตรวจสอบข้อมูล")])]),_vm._v(" "),_c('div',{staticClass:"fss-connector fss-connector--all-done"}),_vm._v(" "),_c('div',{staticClass:"fss-step fss-step--done"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("✓")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("บันทึกแล้ว")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n          บันทึกข้อมูลแล้ว — ข้อมูลในเอกสารนี้ถูกล็อคเป็น snapshot ณ วันที่บันทึก\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"8%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"16%"}},[_vm._v("จำนวนคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"22%"}},[_vm._v("ยอดรวม (ก่อน VAT)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"7%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"18%"}},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"27%"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%"}},[_vm._v("จำนวนคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"8%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"13%"}},[_vm._v("\n                              จำนวนเงิน (ก่อน VAT)\n                            ")])])])}]


/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(_vm.pageTitle)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n          ")])])]),_vm._v(" "),_c('div',{ref:"formContent",staticClass:"kt-portlet__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6"},[_c('div',{staticClass:"card mb-3"},[_c('div',{staticClass:"card-header bg-primary text-white"},[_c('h5',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-filter"}),_vm._v("\n                  "+_vm._s(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' ? 'เลือกงบประมาณต้นทาง' : 'เลือกงบประมาณ')+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(!_vm.dropdownsLoaded)?_c('div',{staticClass:"text-center py-4"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-2x"}),_vm._v(" "),_c('p',{staticClass:"mt-2 mb-0"},[_vm._v("กำลังโหลดข้อมูล...")])]):_vm._e(),_vm._v(" "),(_vm.dropdownsLoaded)?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('select2',{ref:"budgetYearSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'budgetYearSelect',"name":'budgetYearSelect',"select2-options":_vm.budgetYearOptions,"disabled":!_vm.canEdit},model:{value:(_vm.selectedBudgetYear),callback:function ($$v) {_vm.selectedBudgetYear=$$v},expression:"selectedBudgetYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('select2',{ref:"jobTypeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'jobTypeSelect',"name":'jobTypeSelect',"select2-options":_vm.jobTypeOptions,"disabled":!_vm.canEdit},model:{value:(_vm.selectedJobType),callback:function ($$v) {_vm.selectedJobType=$$v},expression:"selectedJobType"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('select2',{ref:"cctrSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'cctrSelect',"name":'cctrSelect',"select2-options":_vm.cctrOptions,"disabled":!_vm.canEdit},model:{value:(_vm.selectedCCTR),callback:function ($$v) {_vm.selectedCCTR=$$v},expression:"selectedCCTR"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('select2',{ref:"ioSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'ioSelect',"name":'ioSelect',"select2-options":_vm.ioOptions,"disabled":!_vm.canEdit},model:{value:(_vm.selectedIO),callback:function ($$v) {_vm.selectedIO=$$v},expression:"selectedIO"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('select2',{ref:"glSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'glSelect',"name":'glSelect',"select2-options":_vm.glOptions,"disabled":!_vm.canEdit},model:{value:(_vm.selectedGL),callback:function ($$v) {_vm.selectedGL=$$v},expression:"selectedGL"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('select2',{ref:"orgSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'orgSelect',"name":'orgSelect',"select2-options":_vm.orgOptions,"disabled":!_vm.canEdit},model:{value:(_vm.selectedOrg),callback:function ($$v) {_vm.selectedOrg=$$v},expression:"selectedOrg"}})],1)])]),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_CREATE')?_c('div',{staticClass:"card mb-3"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"card-body py-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group mb-0"},[_vm._m(8),_vm._v(" "),(_vm.canEdit)?_c('select',{ref:"vendorSelect2",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"vendorSelect"}}):_c('div',{staticClass:"form-control bg-light"},[_vm._v("\n                              "+_vm._s(_vm.vendorDisplayName || '-')+"\n                            ")])])])]),_vm._v(" "),(_vm.vendorId === 'OTHER')?_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group mb-0"},[_vm._m(9),_vm._v(" "),(_vm.canEdit)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otherVendorName),expression:"otherVendorName"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"50","placeholder":"กรุณาระบุชื่อ Vendor","required":""},domProps:{"value":(_vm.otherVendorName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.otherVendorName=$event.target.value}}}):_c('div',{staticClass:"form-control bg-light"},[_vm._v("\n                              "+_vm._s(_vm.otherVendorName || '-')+"\n                            ")])])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_vm._m(10),_vm._v(" "),_c('select2',{ref:"sourceJobSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'sourceJobSelect',"name":'sourceJobSelect',"select2-options":_vm.sourceJobOptions,"disabled":!_vm.canEdit},model:{value:(_vm.selectedSourceJobId),callback:function ($$v) {_vm.selectedSourceJobId=$$v},expression:"selectedSourceJobId"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.clearAllFilters}},[_vm._v("\n                        ล้างค่าทั้งหมด\n                      ")])])]):_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('br'):_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6"},[_c('div',{staticClass:"card mb-3"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('h5',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER' ? 'ข้อมูลงบประมาณต้นทาง' : 'ข้อมูลงบประมาณ')+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row mb-3 align-items-center"},[(_vm.budgetInfo && _vm.selectedJobType === 'BUDGET_JOB_TYPE_CREATE')?_c('div',{staticClass:"col-auto"},[_c('span',{staticClass:"mr-2"},[_vm._v("ครั้งที่")]),_vm._v(" "),_c('span',{staticClass:"badge badge-primary badge-lg"},[_vm._v(_vm._s(_vm.sequenceNo))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_vm._m(11),_vm._v(" "),(!_vm.isViewMode && _vm.canEdit)?[_c('div',{staticClass:"input-group date d-inline-flex",staticStyle:{"width":"160px"}},[_c('input',{ref:"jobDatePicker",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"วว/ดด/ปปปป"}}),_vm._v(" "),_vm._m(12)])]:[_c('strong',[_vm._v(_vm._s(_vm.formatDateThai(_vm.jobDate)))])]],2)])]),_vm._v(" "),(_vm.budgetInfo)?_c('div',{staticClass:"card-body pt-0"},[(_vm.jobData)?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 text-center"},[_c('span',{staticClass:"mr-2"},[_vm._v("สถานะ:")]),_vm._v(" "),_c('span',{staticClass:"badge badge-lg",class:{
                        'badge-secondary': _vm.jobData.status === 0 || _vm.jobData.status === 7,
                        'badge-warning': _vm.jobData.status === 1 || _vm.jobData.status === 5,
                        'badge-info': _vm.jobData.status === 2,
                        'badge-success': _vm.jobData.status === 3 || _vm.jobData.status === 6,
                        'badge-danger': _vm.jobData.status === 4
                      }},[_vm._v("\n                      "+_vm._s(_vm.jobData.statusName)+"\n                    ")]),_vm._v(" "),(_vm.isEditMode && _vm.jobData.status !== 0 && _vm.jobData.status !== 5)?_c('div',{staticClass:"alert alert-warning mt-2 mb-0"},[_c('i',{staticClass:"fas fa-exclamation-triangle"}),_vm._v(" ไม่สามารถแก้ไขได้ เนื่องจากสถานะไม่ใช่ \"บันทึก\" หรือ \"รอแก้ไข\"\n                    ")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-sm mb-3"},[_c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("งบฯ ตั้งต้น")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("งบฯ ยกมา")]),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK')?_c('th',{staticClass:"text-center"},[_vm._v("เบิก")]):_vm._e(),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK')?_c('th',{staticClass:"text-center"},[_vm._v("คืน")]):_vm._e(),_vm._v(" "),(_vm.selectedJobType !== 'BUDGET_JOB_TYPE_ADJUST_SENDBACK')?_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.getBudgetTableHeader()))]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("คงเหลือ")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(_vm.budgetInfo.initialBudgetAmount || 0)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(_vm.carryForwardBudget)))]),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK')?_c('td',{staticClass:"text-right text-danger"},[_vm._v("\n                        "+_vm._s(_vm.formatNumber(_vm.sourceJobData ? _vm.sourceJobData.totalAmount : 0))+"\n                      ")]):_vm._e(),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK')?_c('td',{staticClass:"text-right text-success"},[_vm._v("\n                        "+_vm._s(_vm.formatNumber(_vm.totalItemsAmount))+"\n                      ")]):_vm._e(),_vm._v(" "),(_vm.selectedJobType !== 'BUDGET_JOB_TYPE_ADJUST_SENDBACK')?_c('td',{staticClass:"text-right",class:_vm.getBudgetAmountClass()},[_vm._v("\n                        "+_vm._s(_vm.formatNumber(_vm.getBudgetAmountForDisplay()))+"\n                      ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-right",class:{ 'text-danger font-weight-bold': _vm.remainingAfterUse < 0 }},[_vm._v("\n                        "+_vm._s(_vm.formatNumber(_vm.remainingAfterUse))+"\n                      ")])])])]),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' && _vm.budgetInfo && _vm.budgetInfo.recentSendbackJobs && _vm.budgetInfo.recentSendbackJobs.length > 0)?_c('div',{staticClass:"card mt-3"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"card-body p-0"},[_c('div',{staticStyle:{"max-height":"200px","overflow-y":"auto"}},[_c('table',{staticClass:"table table-bordered table-sm mb-0"},[_vm._m(14),_vm._v(" "),_c('tbody',_vm._l((_vm.budgetInfo.recentSendbackJobs),function(job){return _c('tr',{key:job.jobId},[_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"text-primary",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.viewJobDetail(job.jobId)}}},[_vm._v("\n                                "+_vm._s(job.jobNumber)+"\n                              ")])]),_vm._v(" "),_c('td',{staticClass:"text-right text-success font-weight-bold"},[_vm._v("+"+_vm._s(_vm.formatNumber(job.totalAmount)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDateFromISO(job.jobDate)))])])}),0)])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-sm mb-0"},[_c('tfoot',{staticClass:"bg-light"},[_c('tr',{staticClass:"font-weight-bold"},[_c('td',{staticClass:"text-right",staticStyle:{"width":"30%"}},[_vm._v("รวมคืนเงิน")]),_vm._v(" "),_c('td',{staticClass:"text-right text-success",staticStyle:{"width":"30%"}},[_vm._v("+"+_vm._s(_vm.formatNumber(_vm.totalRecentSendbackAmount)))]),_vm._v(" "),_c('td',{staticStyle:{"width":"40%"}})])])])])]):_vm._e(),_vm._v(" "),( false)?_c('div',{staticClass:"mt-3"},[_c('h6',{staticClass:"font-weight-bold mb-2"},[_c('i',{staticClass:"fas fa-list"}),_vm._v(" รายการใบเพิ่มเงิน\n                    "),_c('button',{staticClass:"btn btn-sm btn-secondary ml-2",attrs:{"type":"button"},on:{"click":function($event){_vm.showAddJobsTable = false}}},[_c('i',{staticClass:"fas fa-times"}),_vm._v(" ปิด\n                    ")])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-sm table-hover"},[_vm._m(15),_vm._v(" "),_c('tbody',[(_vm.loadingAddJobs)?_c('tr',[_vm._m(16)]):(!_vm.addJobsList || _vm.addJobsList.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted py-3",attrs:{"colspan":"3"}},[_vm._v("\n                          ไม่พบรายการ\n                        ")])]):_vm._l((_vm.addJobsList),function(job){return _c('tr',{key:job.jobNumber},[_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"text-primary",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.viewJobDetail(job.id)}}},[_vm._v("\n                            "+_vm._s(job.jobNumber)+"\n                          ")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(job.amount)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDate(job.createdDate)))])])}),_vm._v(" "),(_vm.addJobsList && _vm.addJobsList.length > 0)?_c('tr',{staticClass:"font-weight-bold bg-light"},[_c('td',{staticClass:"text-right"},[_vm._v("รวม")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(_vm.totalAddJobsAmount)))]),_vm._v(" "),_c('td')]):_vm._e()],2)])]):_vm._e(),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER')?_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group mb-2"},[_vm._m(17),_vm._v(" "),(_vm.canEdit)?_c('input',{staticClass:"form-control text-right",attrs:{"type":"text","placeholder":"0.00"},domProps:{"value":_vm.directAmountEditing ? _vm.directAmount : _vm.formatNumber(_vm.directAmount)},on:{"focus":function($event){return _vm.onDirectAmountFocus($event)},"blur":function($event){return _vm.onDirectAmountBlur($event)},"keydown":function($event){return _vm.preventNegativeInput($event)},"input":function($event){return _vm.sanitizeNumberInput($event)}}}):_c('div',{staticClass:"form-control bg-light"},[_vm._v("\n                          "+_vm._s(_vm.formatNumber(_vm.directAmount))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"text-danger font-weight-bold p-0 pt-1",staticStyle:{"font-size":"0.8rem"}},[_vm._v("* ไม่รวมภาษีมูลค่าเพิ่ม 7 %")])])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.budgetInfo)?_c('div',{staticClass:"card-body pt-0"},[_vm._m(18)]):_vm._e()])])]),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_ADD')?_c('div',{staticClass:"card mb-3"},[_vm._m(19),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(20),_vm._v(" "),(_vm.canEdit)?_c('input',{staticClass:"form-control text-right",attrs:{"type":"text","placeholder":"0.00"},domProps:{"value":_vm.directAmountEditing ? _vm.directAmount : _vm.formatNumber(_vm.directAmount)},on:{"focus":function($event){return _vm.onDirectAmountFocus($event)},"blur":function($event){return _vm.onDirectAmountBlur($event)},"keydown":function($event){return _vm.preventNegativeInput($event)},"input":function($event){return _vm.sanitizeNumberInput($event)}}}):_c('div',{staticClass:"form-control bg-light"},[_vm._v("\n                    "+_vm._s(_vm.formatNumber(_vm.directAmount))+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"text-danger font-weight-bold p-0 pt-1",staticStyle:{"font-size":"0.8rem"}},[_vm._v("* ไม่รวมภาษีมูลค่าเพิ่ม 7 %")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เหตุผลในการเพิ่มเงิน")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remark),expression:"remark"}],staticClass:"form-control",attrs:{"rows":"3","disabled":!_vm.canEdit,"placeholder":"กรุณาระบุเหตุผลในการเพิ่มเงิน..."},domProps:{"value":(_vm.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.remark=$event.target.value}}})])])]),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._m(21),_vm._v(" "),(_vm.canEdit)?_c('div',{staticClass:"mb-3"},[_c('input',{ref:"fileInputAdd",staticStyle:{"display":"none"},attrs:{"type":"file","accept":".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png","multiple":""},on:{"change":_vm.handleFileSelect}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.uploadingFile},on:{"click":function($event){return _vm.$refs.fileInputAdd.click()}}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v("\n                    "+_vm._s(_vm.uploadingFile ? 'กำลังอัพโหลด...' : 'เลือกไฟล์')+"\n                  ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                    รองรับไฟล์: PDF, Word, Excel, รูปภาพ (สูงสุด 10 MB ต่อไฟล์)\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.attachments && _vm.attachments.length > 0)?_c('div',{staticClass:"mt-3"},[_c('draggable',{staticClass:"row",attrs:{"disabled":!_vm.canEdit,"handle":".drag-handle"},on:{"end":_vm.onFileDragEnd},model:{value:(_vm.attachments),callback:function ($$v) {_vm.attachments=$$v},expression:"attachments"}},_vm._l((_vm.attachments),function(file,index){return _c('div',{key:file.fileInfoId || index,staticClass:"col-auto m--margin-top-20 img-wrap",staticStyle:{"position":"relative","width":"130px"}},[(_vm.canEdit)?_c('div',{staticClass:"drag-handle text-center",staticStyle:{"cursor":"move","padding":"2px 0"},attrs:{"title":"ลากเพื่อจัดลำดับ"}},[_c('i',{staticClass:"fas fa-grip-horizontal text-muted"})]):_vm._e(),_vm._v(" "),(_vm.isImageFile(file.fileName))?_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[(!file.url && !file.isNew)?_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","background":"#f8f9fa"}},[_c('i',{staticClass:"fas fa-spinner fa-spin text-muted"}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"font-size":"10px"}},[_vm._v("กำลังโหลด...")])]):_c('img',{staticClass:"img-thumbnail",staticStyle:{"width":"100px","height":"100px","object-fit":"cover","cursor":"pointer"},attrs:{"src":file.url,"alt":file.fileName}})]):_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[_c('i',{class:_vm.getFileIcon(file.fileName),staticStyle:{"font-size":"28px"}}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0 text-truncate",staticStyle:{"max-width":"90px","font-size":"10px"},attrs:{"title":file.fileName}},[_vm._v(_vm._s(file.fileName))])]),_vm._v(" "),(_vm.canEdit)?_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","bottom":"22px","right":"10px","z-index":"10","transform":"scale(0.75)"},attrs:{"href":"javascript:;","title":"ลบไฟล์"},on:{"click":function($event){$event.stopPropagation();return _vm.removeAttachment(index)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-1 text-center"},[_c('p',{staticClass:"mb-0 text-truncate",staticStyle:{"max-width":"100px","font-size":"10px","font-weight":"bold"},attrs:{"title":file.fileName}},[_vm._v(_vm._s(file.fileName))])])])}),0)],1):_c('div',{staticClass:"text-center text-muted py-3 border rounded mt-3"},[_c('i',{staticClass:"fas fa-file-upload fa-2x mb-2"}),_vm._v(" "),_c('p',{staticClass:"mb-0 small"},[_vm._v("ยังไม่มีไฟล์แนบ กรุณาแนบไฟล์อย่างน้อย 1 ไฟล์")])])])])])]):_vm._e(),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_REDUCE')?_c('div',{staticClass:"card mb-3"},[_vm._m(22),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(23),_vm._v(" "),(_vm.canEdit)?_c('input',{staticClass:"form-control text-right",attrs:{"type":"text","placeholder":"0.00"},domProps:{"value":_vm.directAmountEditing ? _vm.directAmount : _vm.formatNumber(_vm.directAmount)},on:{"focus":function($event){return _vm.onDirectAmountFocus($event)},"blur":function($event){return _vm.onDirectAmountBlur($event)},"keydown":function($event){return _vm.preventNegativeInput($event)},"input":function($event){return _vm.sanitizeNumberInput($event)}}}):_c('div',{staticClass:"form-control bg-light"},[_vm._v("\n                    "+_vm._s(_vm.formatNumber(_vm.directAmount))+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"text-danger font-weight-bold p-0 pt-1",staticStyle:{"font-size":"0.8rem"}},[_vm._v("* ไม่รวมภาษีมูลค่าเพิ่ม 7 %")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เหตุผลในการลดงบประมาณ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remark),expression:"remark"}],staticClass:"form-control",attrs:{"rows":"3","disabled":!_vm.canEdit,"placeholder":"กรุณาระบุเหตุผลในการลดงบประมาณ..."},domProps:{"value":(_vm.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.remark=$event.target.value}}})])])]),_vm._v(" "),_c('hr',{staticClass:"my-3"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._m(24),_vm._v(" "),(_vm.canEdit)?_c('div',{staticClass:"mb-3"},[_c('input',{ref:"fileInputReduce",staticStyle:{"display":"none"},attrs:{"type":"file","accept":".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png","multiple":""},on:{"change":_vm.handleFileSelect}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.uploadingFile},on:{"click":function($event){return _vm.$refs.fileInputReduce.click()}}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v("\n                    "+_vm._s(_vm.uploadingFile ? 'กำลังอัพโหลด...' : 'เลือกไฟล์')+"\n                  ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                    รองรับไฟล์: PDF, Word, Excel, รูปภาพ (สูงสุด 10 MB ต่อไฟล์)\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.attachments && _vm.attachments.length > 0)?_c('div',{staticClass:"mt-3"},[_c('draggable',{staticClass:"row",attrs:{"disabled":!_vm.canEdit,"handle":".drag-handle"},on:{"end":_vm.onFileDragEnd},model:{value:(_vm.attachments),callback:function ($$v) {_vm.attachments=$$v},expression:"attachments"}},_vm._l((_vm.attachments),function(file,index){return _c('div',{key:file.fileInfoId || index,staticClass:"col-auto m--margin-top-20 img-wrap",staticStyle:{"position":"relative","width":"130px"}},[(_vm.canEdit)?_c('div',{staticClass:"drag-handle text-center",staticStyle:{"cursor":"move","padding":"2px 0"},attrs:{"title":"ลากเพื่อจัดลำดับ"}},[_c('i',{staticClass:"fas fa-grip-horizontal text-muted"})]):_vm._e(),_vm._v(" "),(_vm.isImageFile(file.fileName))?_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[(!file.url && !file.isNew)?_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","background":"#f8f9fa"}},[_c('i',{staticClass:"fas fa-spinner fa-spin text-muted"}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"font-size":"10px"}},[_vm._v("กำลังโหลด...")])]):_c('img',{staticClass:"img-thumbnail",staticStyle:{"width":"100px","height":"100px","object-fit":"cover","cursor":"pointer"},attrs:{"src":file.url,"alt":file.fileName}})]):_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[_c('i',{class:_vm.getFileIcon(file.fileName),staticStyle:{"font-size":"28px"}}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0 text-truncate",staticStyle:{"max-width":"90px","font-size":"10px"},attrs:{"title":file.fileName}},[_vm._v(_vm._s(file.fileName))])]),_vm._v(" "),(_vm.canEdit)?_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","bottom":"22px","right":"10px","z-index":"10","transform":"scale(0.75)"},attrs:{"href":"javascript:;","title":"ลบไฟล์"},on:{"click":function($event){$event.stopPropagation();return _vm.removeAttachment(index)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-1 text-center"},[_c('p',{staticClass:"mb-0 text-truncate",staticStyle:{"max-width":"100px","font-size":"10px","font-weight":"bold"},attrs:{"title":file.fileName}},[_vm._v(_vm._s(file.fileName))])])])}),0)],1):_c('div',{staticClass:"text-center text-muted py-3 border rounded mt-3"},[_c('i',{staticClass:"fas fa-file-upload fa-2x mb-2"}),_vm._v(" "),_c('p',{staticClass:"mb-0 small"},[_vm._v("ยังไม่มีไฟล์แนบ กรุณาแนบไฟล์อย่างน้อย 1 ไฟล์")])])])])])]):_vm._e(),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_TRANSFER')?_c('div',[_c('hr',{staticClass:"my-4",staticStyle:{"border-top":"1px solid #e0e0e0"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6"},[_c('div',{staticClass:"card mb-3"},[_vm._m(25),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปีงบประมาณ")]),_vm._v(" "),_c('input',{staticClass:"form-control bg-light",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.selectedBudgetYear}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("ใช้ปีเดียวกับต้นทาง")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("CCTR")]),_vm._v(" "),_c('input',{staticClass:"form-control bg-light",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.selectedCCTRDisplay}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("ใช้ CCTR เดียวกับต้นทาง")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(26),_vm._v(" "),_c('select2',{ref:"targetIOSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'targetIOSelect',"name":'targetIOSelect',"select2-options":_vm.targetIOOptions,"disabled":!_vm.canEdit},on:{"input":_vm.onTargetSelectionChange},model:{value:(_vm.selectedTargetIO),callback:function ($$v) {_vm.selectedTargetIO=$$v},expression:"selectedTargetIO"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(27),_vm._v(" "),_c('select2',{ref:"targetGLSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'targetGLSelect',"name":'targetGLSelect',"select2-options":_vm.targetGLOptions,"disabled":!_vm.canEdit},on:{"input":_vm.onTargetSelectionChange},model:{value:(_vm.selectedTargetGL),callback:function ($$v) {_vm.selectedTargetGL=$$v},expression:"selectedTargetGL"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(28),_vm._v(" "),_c('select2',{ref:"targetOrgSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'targetOrgSelect',"name":'targetOrgSelect',"select2-options":_vm.targetOrgOptions,"disabled":!_vm.canEdit},on:{"input":_vm.onTargetSelectionChange},model:{value:(_vm.selectedTargetOrg),callback:function ($$v) {_vm.selectedTargetOrg=$$v},expression:"selectedTargetOrg"}})],1)])]),_vm._v(" "),(_vm.canEdit)?_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.clearTargetFilters}},[_vm._v("\n                        ล้างค่าทั้งหมด\n                      ")])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6"},[_c('div',{staticClass:"card mb-3"},[_vm._m(29),_vm._v(" "),(_vm.targetBudgetInfo)?_c('div',{staticClass:"card-body"},[_c('table',{staticClass:"table table-bordered table-sm mb-0"},[_vm._m(30),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(_vm.targetBudgetInfo.initialBudgetAmount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(_vm.targetCarryForwardBudget)))]),_vm._v(" "),_c('td',{staticClass:"text-right text-success font-weight-bold"},[_vm._v("\n                          "+_vm._s(_vm.formatNumber(_vm.directAmount || 0))+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"text-right text-primary font-weight-bold"},[_vm._v("\n                          "+_vm._s(_vm.formatNumber(_vm.targetRemainingAfterTransfer))+"\n                        ")])])])])]):_c('div',{staticClass:"card-body"},[_vm._m(31)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เหตุผลในการโยกงบ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remark),expression:"remark"}],staticClass:"form-control",attrs:{"rows":"3","disabled":!_vm.canEdit,"placeholder":"ระบุเหตุผลการโอนงบประมาณ (ถ้ามี)"},domProps:{"value":(_vm.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.remark=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card mb-3"},[_vm._m(32),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.canEdit)?_c('div',{staticClass:"mb-3"},[_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png","multiple":""},on:{"change":_vm.handleFileSelect}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.uploadingFile},on:{"click":function($event){return _vm.$refs.fileInput.click()}}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v("\n                      "+_vm._s(_vm.uploadingFile ? 'กำลังอัพโหลด...' : 'เลือกไฟล์')+"\n                    ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                      รองรับไฟล์: PDF, Word, Excel, รูปภาพ (สูงสุด 10 MB ต่อไฟล์)\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.attachments && _vm.attachments.length > 0)?_c('div',{staticClass:"mt-3"},[_c('draggable',{staticClass:"row",attrs:{"disabled":!_vm.canEdit,"handle":".drag-handle"},on:{"end":_vm.onFileDragEnd},model:{value:(_vm.attachments),callback:function ($$v) {_vm.attachments=$$v},expression:"attachments"}},_vm._l((_vm.attachments),function(file,index){return _c('div',{key:file.fileInfoId || index,staticClass:"col-auto m--margin-top-20 img-wrap",staticStyle:{"position":"relative","width":"130px"}},[(_vm.canEdit)?_c('div',{staticClass:"drag-handle text-center",staticStyle:{"cursor":"move","padding":"2px 0"},attrs:{"title":"ลากเพื่อจัดลำดับ"}},[_c('i',{staticClass:"fas fa-grip-horizontal text-muted"})]):_vm._e(),_vm._v(" "),(_vm.isImageFile(file.fileName))?_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[(!file.url && !file.isNew)?_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","background":"#f8f9fa"}},[_c('i',{staticClass:"fas fa-spinner fa-spin text-muted"}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"font-size":"10px"}},[_vm._v("กำลังโหลด...")])]):_c('img',{staticClass:"img-thumbnail",staticStyle:{"width":"100px","height":"100px","object-fit":"cover","cursor":"pointer"},attrs:{"src":file.url,"alt":file.fileName}})]):_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[_c('i',{class:_vm.getFileIcon(file.fileName),staticStyle:{"font-size":"28px"}}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0 text-truncate",staticStyle:{"max-width":"90px","font-size":"10px"},attrs:{"title":file.fileName}},[_vm._v(_vm._s(file.fileName))])]),_vm._v(" "),(_vm.canEdit)?_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","bottom":"22px","right":"10px","z-index":"10","transform":"scale(0.75)"},attrs:{"href":"javascript:;","title":"ลบไฟล์"},on:{"click":function($event){$event.stopPropagation();return _vm.removeAttachment(index)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-1 text-center"},[_c('p',{staticClass:"mb-0 text-truncate",staticStyle:{"max-width":"100px","font-size":"10px","font-weight":"bold"},attrs:{"title":file.fileName}},[_vm._v(_vm._s(file.fileName))])])])}),0)],1):_c('div',{staticClass:"text-center text-muted py-3 border rounded mt-3"},[_c('i',{staticClass:"fas fa-file-upload fa-2x mb-2"}),_vm._v(" "),_c('p',{staticClass:"mb-0 small"},[_vm._v("ยังไม่มีไฟล์แนบ กรุณาแนบไฟล์อย่างน้อย 1 ไฟล์")])])])])])])]):_vm._e(),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' || _vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK')?_c('div',{staticClass:"card mb-3"},[_c('div',{staticClass:"card-header bg-success text-white d-flex justify-content-between align-items-center"},[_vm._m(33),_vm._v(" "),_c('button',{staticClass:"btn btn-light btn-sm",attrs:{"type":"button","disabled":!_vm.canEdit},on:{"click":_vm.addItem}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" คลิกเพื่อเพิ่มรายการ\n            ")])]),_vm._v(" "),_c('div',{staticClass:"card-body p-0"},[_c('table',{staticClass:"table table-bordered table-hover mb-0",attrs:{"id":"itemsTable"}},[_vm._m(34),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.itemNo),expression:"item.itemNo"}],staticClass:"form-control form-control-sm text-center",attrs:{"type":"text","disabled":!_vm.canEdit},domProps:{"value":(item.itemNo)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "itemNo", $event.target.value)},function($event){return _vm.onItemNoInput(item)}]}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.materialNumber),expression:"item.materialNumber"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":!_vm.canEdit},domProps:{"value":(item.materialNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "materialNumber", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.description),expression:"item.description"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":!_vm.canEdit},domProps:{"value":(item.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "description", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.quantity),expression:"item.quantity",modifiers:{"number":true}}],staticClass:"form-control form-control-sm text-right",attrs:{"type":"number","min":"0","disabled":!_vm.canEdit},domProps:{"value":(item.quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", _vm._n($event.target.value))},function($event){return _vm.calculateItemAmount(item)}],"blur":[function($event){return _vm.validateItemQuantity(item)},function($event){return _vm.$forceUpdate()}],"keydown":function($event){return _vm.preventNegativeInput($event)}}})]),_vm._v(" "),_c('td',[(_vm.canEdit)?_c('input',{staticClass:"form-control form-control-sm text-right",attrs:{"type":"text"},domProps:{"value":item._editingUnitPrice ? item.unitPrice : _vm.formatNumber(item.unitPrice)},on:{"focus":function($event){return _vm.onItemUnitPriceFocus($event, item)},"blur":function($event){return _vm.onItemUnitPriceBlur($event, item)},"keydown":function($event){return _vm.preventNegativeInput($event)},"input":function($event){return _vm.sanitizeNumberInput($event)}}}):_c('div',{staticClass:"text-right py-1"},[_vm._v("\n                      "+_vm._s(_vm.formatNumber(item.unitPrice))+"\n                    ")])]),_vm._v(" "),_c('td',[(_vm.canEdit)?_c('input',{staticClass:"form-control form-control-sm text-right",attrs:{"type":"text"},domProps:{"value":item._editingAmount ? item.amount : _vm.formatNumber(item.amount)},on:{"focus":function($event){return _vm.onItemAmountFocus($event, item)},"blur":function($event){return _vm.onItemAmountBlur($event, item)},"keydown":function($event){return _vm.preventNegativeInput($event)},"input":function($event){return _vm.sanitizeNumberInput($event)}}}):_c('div',{staticClass:"text-right py-1"},[_vm._v("\n                      "+_vm._s(_vm.formatNumber(item.amount))+"\n                    ")])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.remark),expression:"item.remark"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":!_vm.canEdit},domProps:{"value":(item.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "remark", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-sm btn-danger btn-icon",attrs:{"type":"button","title":"ลบรายการ","disabled":!_vm.canEdit},on:{"click":function($event){return _vm.removeItem(index)}}},[_c('i',{staticClass:"fas fa-trash"})])])])}),_vm._v(" "),(_vm.items.length === 0)?_c('tr',[_vm._m(35)]):_vm._e()],2),_vm._v(" "),_c('tfoot',{staticClass:"bg-light"},[_c('tr',[_vm._m(36),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('strong',[_vm._v(_vm._s(_vm.totalAmountText))])]),_vm._v(" "),_c('td',{staticClass:"text-right",attrs:{"colspan":"2"}},[_c('strong',[_vm._v(_vm._s(_vm.formatNumber(_vm.totalAmount)))])]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}})]),_vm._v(" "),_vm._m(37)])])])]):_vm._e(),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_CREATE' || _vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมายเหตุ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remark),expression:"remark"}],staticClass:"form-control",attrs:{"rows":"2","placeholder":"หมายเหตุเพิ่มเติม (ถ้ามี)","disabled":!_vm.canEdit},domProps:{"value":(_vm.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.remark=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_CREATE')?_c('div',{staticClass:"card mb-3"},[_vm._m(38),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.canEdit)?_c('div',{staticClass:"mb-3"},[_c('input',{ref:"fileInputCreate",staticStyle:{"display":"none"},attrs:{"type":"file","accept":".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png","multiple":""},on:{"change":_vm.handleFileSelect}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.uploadingFile},on:{"click":function($event){return _vm.$refs.fileInputCreate.click()}}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v("\n                "+_vm._s(_vm.uploadingFile ? 'กำลังอัพโหลด...' : 'เลือกไฟล์')+"\n              ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                รองรับไฟล์: PDF, Word, Excel, รูปภาพ (สูงสุด 10 MB ต่อไฟล์)\n              ")])]):_vm._e(),_vm._v(" "),(_vm.attachments && _vm.attachments.length > 0)?_c('div',{staticClass:"mt-3"},[_c('draggable',{staticClass:"row",attrs:{"disabled":!_vm.canEdit,"handle":".drag-handle"},on:{"end":_vm.onFileDragEnd},model:{value:(_vm.attachments),callback:function ($$v) {_vm.attachments=$$v},expression:"attachments"}},_vm._l((_vm.attachments),function(file,index){return _c('div',{key:file.fileInfoId || index,staticClass:"col-auto m--margin-top-20 img-wrap",staticStyle:{"position":"relative","width":"130px"}},[(_vm.canEdit)?_c('div',{staticClass:"drag-handle text-center",staticStyle:{"cursor":"move","padding":"2px 0"},attrs:{"title":"ลากเพื่อจัดลำดับ"}},[_c('i',{staticClass:"fas fa-grip-horizontal text-muted"})]):_vm._e(),_vm._v(" "),(_vm.isImageFile(file.fileName))?_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[(!file.url && !file.isNew)?_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","background":"#f8f9fa"}},[_c('i',{staticClass:"fas fa-spinner fa-spin text-muted"}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"font-size":"10px"}},[_vm._v("กำลังโหลด...")])]):_c('img',{staticClass:"img-thumbnail",staticStyle:{"width":"100px","height":"100px","object-fit":"cover","cursor":"pointer"},attrs:{"src":file.url,"alt":file.fileName}})]):_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[_c('i',{class:_vm.getFileIcon(file.fileName),staticStyle:{"font-size":"28px"}}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0 text-truncate",staticStyle:{"max-width":"90px","font-size":"10px"},attrs:{"title":file.fileName}},[_vm._v(_vm._s(file.fileName))])]),_vm._v(" "),(_vm.canEdit)?_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","bottom":"22px","right":"10px","z-index":"10","transform":"scale(0.75)"},attrs:{"href":"javascript:;","title":"ลบไฟล์"},on:{"click":function($event){$event.stopPropagation();return _vm.removeAttachment(index)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-1 text-center"},[_c('p',{staticClass:"mb-0 text-truncate",staticStyle:{"max-width":"100px","font-size":"10px","font-weight":"bold"},attrs:{"title":file.fileName}},[_vm._v(_vm._s(file.fileName))])])])}),0)],1):_c('div',{staticClass:"text-center text-muted py-3 border rounded mt-3"},[_c('i',{staticClass:"fas fa-file-upload fa-2x mb-2"}),_vm._v(" "),_c('p',{staticClass:"mb-0 small"},[_vm._v("ยังไม่มีไฟล์แนบ กรุณาแนบไฟล์อย่างน้อย 1 ไฟล์")])])])]):_vm._e(),_vm._v(" "),(_vm.selectedJobType === 'BUDGET_JOB_TYPE_ADJUST_SENDBACK')?_c('div',{staticClass:"card mb-3"},[_vm._m(39),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.canEdit)?_c('div',{staticClass:"mb-3"},[_c('input',{ref:"fileInputSendback",staticStyle:{"display":"none"},attrs:{"type":"file","accept":".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png","multiple":""},on:{"change":_vm.handleFileSelect}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.uploadingFile},on:{"click":function($event){return _vm.$refs.fileInputSendback.click()}}},[_c('i',{staticClass:"fas fa-upload"}),_vm._v("\n                "+_vm._s(_vm.uploadingFile ? 'กำลังอัพโหลด...' : 'เลือกไฟล์')+"\n              ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                รองรับไฟล์: PDF, Word, Excel, รูปภาพ (สูงสุด 10 MB ต่อไฟล์)\n              ")])]):_vm._e(),_vm._v(" "),(_vm.attachments && _vm.attachments.length > 0)?_c('div',{staticClass:"mt-3"},[_c('draggable',{staticClass:"row",attrs:{"disabled":!_vm.canEdit,"handle":".drag-handle"},on:{"end":_vm.onFileDragEnd},model:{value:(_vm.attachments),callback:function ($$v) {_vm.attachments=$$v},expression:"attachments"}},_vm._l((_vm.attachments),function(file,index){return _c('div',{key:file.fileInfoId || index,staticClass:"col-auto m--margin-top-20 img-wrap",staticStyle:{"position":"relative","width":"130px"}},[(_vm.canEdit)?_c('div',{staticClass:"drag-handle text-center",staticStyle:{"cursor":"move","padding":"2px 0"},attrs:{"title":"ลากเพื่อจัดลำดับ"}},[_c('i',{staticClass:"fas fa-grip-horizontal text-muted"})]):_vm._e(),_vm._v(" "),(_vm.isImageFile(file.fileName))?_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[(!file.url && !file.isNew)?_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","background":"#f8f9fa"}},[_c('i',{staticClass:"fas fa-spinner fa-spin text-muted"}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"font-size":"10px"}},[_vm._v("กำลังโหลด...")])]):_c('img',{staticClass:"img-thumbnail",staticStyle:{"width":"100px","height":"100px","object-fit":"cover","cursor":"pointer"},attrs:{"src":file.url,"alt":file.fileName}})]):_c('div',{staticClass:"text-center border rounded p-2",staticStyle:{"height":"100px","width":"100px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","cursor":"pointer"},on:{"click":function($event){return _vm.openFileInNewTab(file)}}},[_c('i',{class:_vm.getFileIcon(file.fileName),staticStyle:{"font-size":"28px"}}),_vm._v(" "),_c('p',{staticClass:"mt-1 mb-0 text-truncate",staticStyle:{"max-width":"90px","font-size":"10px"},attrs:{"title":file.fileName}},[_vm._v(_vm._s(file.fileName))])]),_vm._v(" "),(_vm.canEdit)?_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","bottom":"22px","right":"10px","z-index":"10","transform":"scale(0.75)"},attrs:{"href":"javascript:;","title":"ลบไฟล์"},on:{"click":function($event){$event.stopPropagation();return _vm.removeAttachment(index)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-1 text-center"},[_c('p',{staticClass:"mb-0 text-truncate",staticStyle:{"max-width":"100px","font-size":"10px","font-weight":"bold"},attrs:{"title":file.fileName}},[_vm._v(_vm._s(file.fileName))])])])}),0)],1):_c('div',{staticClass:"text-center text-muted py-3 border rounded mt-3"},[_c('i',{staticClass:"fas fa-file-upload fa-2x mb-2"}),_vm._v(" "),_c('p',{staticClass:"mb-0 small"},[_vm._v("ยังไม่มีไฟล์แนบ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"text-muted mb-0"},[_c('i',{staticClass:"fas fa-user"}),_vm._v(" จัดทำโดย: "),_c('strong',[_vm._v(_vm._s(_vm.createdByName))])])])]),_vm._v(" "),(_vm.approvalHistory && _vm.approvalHistory.length > 0)?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"mb-3"},[_vm._v("ประวัติการอนุมัติ")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-hover"},[_vm._m(40),_vm._v(" "),_c('tbody',_vm._l((_vm.sortedApprovalHistory),function(history){return _c('tr',{key:history.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatDateTime(history.approveDate)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(history.approverName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(history.approvalLevel === 0)?_c('span',[_vm._v("ส่งอนุมัติ")]):_c('span',[_vm._v("ลำดับที่ "+_vm._s(history.approvalLevel))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(history.approveAction === 'SUBMITTED')?_c('span',{staticClass:"badge badge-secondary"},[_c('i',{staticClass:"fas fa-paper-plane"}),_vm._v(" ส่งอนุมัติ\n                      ")]):(history.approveAction === 'APPROVED')?_c('span',{staticClass:"badge badge-success"},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" อนุมัติ\n                      ")]):(history.approveAction === 'REJECTED')?_c('span',{staticClass:"badge badge-danger"},[_c('i',{staticClass:"fas fa-times"}),_vm._v(" ไม่อนุมัติ\n                      ")]):(history.approveAction === 'RETURNED')?_c('span',{staticClass:"badge badge-warning"},[_c('i',{staticClass:"fas fa-undo"}),_vm._v(" ส่งกลับแก้ไข\n                      ")]):(history.approveAction === 'CONFIRMED' && _vm.jobData && history.approvalLevel < _vm.jobData.maxApprovalLevel)?_c('span',{staticClass:"badge badge-info"},[_c('i',{staticClass:"fas fa-check"}),_vm._v(" ยืนยัน\n                      ")]):(history.approveAction === 'CONFIRMED')?_c('span',{staticClass:"badge badge-primary"},[_c('i',{staticClass:"fas fa-check-double"}),_vm._v(" ดำเนินการเรียบร้อย\n                      ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(history.remark || '-'))])])}),0)])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n            ")]),_vm._v(" "),(_vm.canEdit && !_vm.isViewMode)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.canSave},on:{"click":_vm.saveJob}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึก\n            ")]):_vm._e(),_vm._v(" "),(_vm.canEdit && !_vm.isViewMode && (_vm.jobStatus === 0 || _vm.jobStatus === 5 || !_vm.jobId) && _vm.isApprovalRequired)?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":!_vm.canSave || _vm.isSubmitting},on:{"click":_vm.submitForApproval}},[_c('i',{staticClass:"la la-send"}),_vm._v(" บันทึกและส่งอนุมัติ\n            ")]):_vm._e(),_vm._v(" "),(_vm.canApprove && _vm.showApproveButtons && _vm.showReturnButton)?_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.rejectJob('return')}}},[_c('i',{staticClass:"la la-undo"}),_vm._v(" ส่งกลับแก้ไข\n            ")]):_vm._e(),_vm._v(" "),(_vm.canApprove && _vm.showApproveButtons && _vm.showRejectButton)?_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.rejectJob('reject')}}},[_c('i',{staticClass:"la la-times"}),_vm._v(" ไม่อนุมัติ\n            ")]):_vm._e(),_vm._v(" "),(_vm.canApprove && _vm.showApproveButtons)?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":_vm.approveJob}},[_c('i',{staticClass:"la la-check"}),_vm._v(" "+_vm._s(_vm.approveButtonText)+"\n            ")]):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-file-invoice-dollar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("ปีงบประมาณ "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("ประเภทใบงาน "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("CCTR "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("IO "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("GL "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("แผนก "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-primary text-white py-2"},[_c('h6',{staticClass:"mb-0"},[_c('i',{staticClass:"fa fa-truck fa-flip-horizontal",attrs:{"aria-hidden":"true"}}),_vm._v("\n                        เลือก Vendor\n                      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Vendor "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("กรุณาระบุข้อมูล Vendor "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("เลือกครั้งที่ "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-2"},[_vm._v("วันที่เอกสาร (วว/ดด/ปปปป) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white py-2"},[_c('h6',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v(" รายการคืนเงินใบแจ้งรายละเอียดงบประมาณเบียร์สดก่อนหน้า")]),_vm._v(" "),_c('small',{staticClass:"text-danger",staticStyle:{"font-size":"12px","color":"#FFE082 !important"}},[_vm._v("*แสดงเฉพาะในใบแจ้งรายละเอียดงบประมาณเบียร์สด ใบถัดไป 1 ใบ หลังจากมีการคืนเงินเท่านั้น")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light",staticStyle:{"position":"sticky","top":"0","z-index":"1"}},[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"30%"}},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"text-right",staticStyle:{"width":"30%"}},[_vm._v("จำนวนเงินคืน (บาท)")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"40%"}},[_vm._v("วันที่")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"30%"}},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"text-right",staticStyle:{"width":"30%"}},[_vm._v("จำนวนเงิน (บาท)")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"40%"}},[_vm._v("วันที่สร้าง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center text-muted py-3",attrs:{"colspan":"3"}},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" กำลังโหลดข้อมูล...\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"font-weight-bold"},[_vm._v("จำนวนเงินที่โยกงบออก (บาท) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center text-muted py-4"},[_c('i',{staticClass:"fas fa-info-circle fa-2x mb-2"}),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("กรุณาเลือก CCTR, IO, GL, แผนก เพื่อดูข้อมูลงบประมาณ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-success text-white"},[_c('h5',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-plus-circle"}),_vm._v(" รายละเอียดการเพิ่มเงิน")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("จำนวนเงินที่เพิ่ม (บาท) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"font-weight-bold mb-3"},[_c('i',{staticClass:"fas fa-paperclip"}),_vm._v(" แนบไฟล์เอกสาร\n                  "),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("(บังคับแนบอย่างน้อย 1 ไฟล์)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-danger text-white"},[_c('h5',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-minus-circle"}),_vm._v(" รายละเอียดการลดงบประมาณ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("จำนวนเงินที่ลด (บาท) "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"font-weight-bold mb-3"},[_c('i',{staticClass:"fas fa-paperclip"}),_vm._v(" แนบไฟล์เอกสาร\n                  "),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("(บังคับแนบอย่างน้อย 1 ไฟล์)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-warning text-dark"},[_c('h5',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-filter"}),_vm._v(" เลือกงบประมาณปลายทาง")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("IO "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("GL "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("แผนก "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-success text-white"},[_c('h5',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v(" ข้อมูลงบประมาณปลายทาง")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("งบฯ ตั้งต้น")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("งบฯ ยกมา")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("โยกงบเข้า")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("คงเหลือหลังโยกงบเข้า")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center text-muted py-4"},[_c('i',{staticClass:"fas fa-info-circle fa-2x mb-2"}),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("กรุณาเลือกงบปลายทางให้ครบถ้วน")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-primary text-white"},[_c('h5',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-paperclip"}),_vm._v(" แนบไฟล์เอกสาร\n                    "),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('small',{staticClass:"ml-2"},[_vm._v("(บังคับแนบอย่างน้อย 1 ไฟล์)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-list"}),_vm._v(" รายการ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%"}},[_vm._v("Material No.")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"25%"}},[_vm._v("รายการ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%"}},[_vm._v("ราคาต่อหน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%"}},[_vm._v("รวม")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"16%"}},[_vm._v("หมายเหตุ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"5%"}},[_vm._v("ลบ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center text-muted py-4",attrs:{"colspan":"8"}},[_c('i',{staticClass:"fas fa-info-circle"}),_vm._v(" คลิก \"คลิกเพื่อเพิ่มรายการ\" เพื่อเพิ่มรายการใหม่\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('strong',[_vm._v("รวมเป็นเงินทั้งสิ้น")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"border-0 p-0",attrs:{"colspan":"4"}}),_vm._v(" "),_c('td',{staticClass:"border-0 p-0 pt-1 text-right",attrs:{"colspan":"2"}},[_c('span',{staticClass:"text-danger font-weight-bold",staticStyle:{"font-size":"0.8rem"}},[_vm._v("* ไม่รวมภาษีมูลค่าเพิ่ม 7 %")])]),_vm._v(" "),_c('td',{staticClass:"border-0 p-0",attrs:{"colspan":"2"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-primary text-white"},[_c('h5',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-paperclip"}),_vm._v(" แนบไฟล์เอกสาร\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('small',{staticClass:"ml-2"},[_vm._v("(บังคับแนบอย่างน้อย 1 ไฟล์)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-primary text-white"},[_c('h5',{staticClass:"mb-0"},[_c('i',{staticClass:"fas fa-paperclip"}),_vm._v(" แนบไฟล์เอกสาร\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" "),_c('small',{staticClass:"ml-2"},[_vm._v("(บังคับแนบอย่างน้อย 1 ไฟล์)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"30%"}},[_vm._v("ผู้อนุมัติ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"30%"}},[_vm._v("หมายเหตุ")])])])}]


/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/OverdueSetting'),expression:"$route.path == '/Master/OverdueSetting'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.MbSKUOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbSKUId),callback:function ($$v) {_vm.MbSKUId=$$v},expression:"MbSKUId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทของการกระจายสินค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.MbSKUTransTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbSKUTransTypeId),callback:function ($$v) {_vm.MbSKUTransTypeId=$$v},expression:"MbSKUTransTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"odInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'odInActiveStatus',"name":'odInActiveStatus',"select2-options":_vm.odInActiveStatusOptions},model:{value:(_vm.odInActiveStatus),callback:function ($$v) {_vm.odInActiveStatus=$$v},expression:"odInActiveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['MANAGE_MASTER', 'MANAGE_ORDER']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"OverdueSetting/Add","tag":"button","title":"เพิ่มข้อมูลการสั่งซื้อ "}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูล\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            ตั้งค่าการแจ้งเตือนคงค้างเกินกำหนดเวลา\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"BarcodeAlertConfigTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("รายการที่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวนวันแจ้งเตือนก่อนครบกำหนด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวนวันครบกำหนด")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("ค่าเช่าวันละ")]),_vm._v(" "),_c('th',{staticClass:"center",attrs:{"width":"10%"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/Order'),expression:"$route.path == '/Master/Order'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orlKeyword),expression:"orlKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก Invoice NO. งบประมาณ เช่น 700096, 700097"},domProps:{"value":(_vm.orlKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orlKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Invoice Date. :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"orlInvDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"Invoice Date. (วว/ดด/ปปปป)","id":"orlInvDate","name":"orlInvDate"}}),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Supplier:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadaOrlVendorIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.orlVendorId),callback:function ($$v) {_vm.orlVendorId=$$v},expression:"orlVendorId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Quota:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.orlQuotaIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.orlQuotaId),callback:function ($$v) {_vm.orlQuotaId=$$v},expression:"orlQuotaId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Product:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.orlProductIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.orlProductId),callback:function ($$v) {_vm.orlProductId=$$v},expression:"orlProductId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow(['MANAGE_MASTER', 'MANAGE_ORDER']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"Order/Add","tag":"button","title":"เพิ่มข้อมูลการสั่งซื้อ "}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูลการสั่งซื้อ\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(2)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-shopping-cart"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            จัดการข้อมูลการสั่งซื้อ (Order)\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"orderTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("Invoice NO.")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("Invoice Date.")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("Vendor")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("รวมราคาสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อเขตการขาย:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sacName),expression:"sacName"}],staticClass:"form-control",attrs:{"id":"sacName","name":"sacName","type":"text","maxlength":"256","placeholder":"ชื่อเขตการขาย"},domProps:{"value":(_vm.sacName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sacName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"}),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"sacProvinceSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'sacProvince',"name":'sacProvince',"select2-options":_vm.sacProvinceOptions,"multiple":""},model:{value:(_vm.sacProvince),callback:function ($$v) {_vm.sacProvince=$$v},expression:"sacProvince"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sacInActiveStatus),expression:"sacInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"sacInActiveStatus","name":"sacInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.sacInActiveStatus)?_vm._i(_vm.sacInActiveStatus,null)>-1:(_vm.sacInActiveStatus)},on:{"change":function($event){var $$a=_vm.sacInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.sacInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.sacInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.sacInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อผู้ใช้งาน ชื่อบัญชี อีเมล เบอร์โทรศัพท์"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("บทบาท:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rolesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.roles),callback:function ($$v) {_vm.roles=$$v},expression:"roles"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"inActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'inActiveStatus',"name":'inActiveStatus',"select2-options":_vm.inActiveStatusOptions},model:{value:(_vm.inActiveStatus),callback:function ($$v) {_vm.inActiveStatus=$$v},expression:"inActiveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow('MASTER_USER'))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"Users/Add","tag":"button","title":"เพิ่มข้อมูลสมาชิก"}},[_c('i',{staticClass:"fa fa-user-plus"}),_vm._v(" เพิ่มข้อมูลสมาชิก\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-users"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("สมาชิก")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"userTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("ชื่อผู้ใช้งาน (Username)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("อีเมล")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("บทบาท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อ - ชื่อสกุล")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("โทรศัพท์")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ตำแหน่ง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("โปรไฟล์บริษัท")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่เข้าใช้งานล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("คำสั่ง")])])])])])])}]


/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+" "),_c('strong',[_vm._v(_vm._s(_vm.qiJobNumber))])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext",domProps:{"innerHTML":_vm._s(_vm.qiStatusName)}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(2),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.createdDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(3),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.finishedDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(4),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.createdUserName))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(5),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext",domProps:{"innerHTML":_vm._s(_vm.qiTypeName)}})])]),_vm._v(" "),(_vm.qiSubType == 1)?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(6),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.barcodeNoOld))])])]):_vm._e(),_vm._v(" "),(_vm.qiTypeCode !== 'JOB_QI_TYPE_DRAWBACK')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(7),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.materialNameShow))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(8),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n                "+_vm._s(_vm.amount)+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.qiAreaPlant)?_c('div',{staticClass:"col-xl-6"},[_vm._m(9),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n              "+_vm._s('ซ่อมในตัวแทนจำหน่าย')+" "),_c('strong',[_vm._v(_vm._s(_vm.agentCodeSap ? ' >> '+_vm.agentName+' ('+_vm.agentCodeSap+')' : ''))])])]):_c('div',{staticClass:"col-xl-3"},[_vm._m(10),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v("\n              "+_vm._s('ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด')+" \n            ")])]),_vm._v(" "),(_vm.qiAreaPlant && _vm.qiTypeCode == 'JOB_QI_TYPE_REPAIR')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(11),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.confirmedDate))])])]):_vm._e(),_vm._v(" "),(_vm.qiAreaPlant && _vm.qiTypeCode == 'JOB_QI_TYPE_REPAIR')?_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(12),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.confirmedUserName))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"kt-section__body"},[_vm._m(13),_vm._v(" "),_c('span',{staticClass:"form-text mb-3"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-checkable"},[_c('thead',[_c('tr',{class:_vm.qiSubType === 1 ? 'table-warning' : 'table-info'},[_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"30%"}},[_vm._v("รายการ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("ราคา/หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("มูลค่ารวม")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,i){return _c('tr',{key:item.qiJobItemId},[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(i + 1))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.materialNameShow),expression:"item.materialNameShow"}],staticClass:"form-control",attrs:{"type":"text","disabled":!_vm.isDisable},domProps:{"value":(item.materialNameShow)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "materialNameShow", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.quantity),expression:"item.quantity",modifiers:{"number":true}}],ref:("quantity-" + i),refInFor:true,staticClass:"form-control text-right",attrs:{"type":"number","disabled":!_vm.isDisable},domProps:{"value":(item.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.unitPrice),expression:"item.unitPrice",modifiers:{"number":true}}],ref:("unitPrice-" + i),refInFor:true,staticClass:"form-control text-right",attrs:{"type":"number"},domProps:{"value":(item.unitPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "unitPrice", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{staticClass:"form-text text-danger"},[_vm._v(_vm._s(_vm.errors.items[i] && _vm.errors.items[i].unitPrice ? _vm.errors.items[i].unitPrice : ''))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v("\n                          "+_vm._s((item.quantity * item.unitPrice || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))+"\n                        ")])])])}),_vm._v(" "),_c('tr',[_vm._m(14),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_c('strong',[_vm._v(_vm._s(_vm.totalQuantity.toLocaleString('en-US')))])])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_c('strong',[_vm._v(_vm._s(_vm.totalValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))])])])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('span',{staticClass:"form-text mb-3"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-checkable"},[_c('thead',[_c('tr',{class:_vm.qiSubType === 1 ? 'table-warning' : 'table-info'},[_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"30%"}},[_vm._v("รายการ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("ราคา/หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("มูลค่ารวม")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.services),function(item,i){return _c('tr',{key:item.qiJobServiceId},[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(i + 1))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.serviceName),expression:"item.serviceName"}],staticClass:"form-control",attrs:{"type":"text","disabled":!_vm.isDisable},domProps:{"value":(item.serviceName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "serviceName", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.quantity),expression:"item.quantity",modifiers:{"number":true}}],ref:("quantity-" + i),refInFor:true,staticClass:"form-control text-right",attrs:{"type":"number","disabled":!_vm.isDisable},domProps:{"value":(item.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "quantity", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(item.unitPrice),expression:"item.unitPrice",modifiers:{"number":true}}],ref:("unitPriceService-" + i),refInFor:true,staticClass:"form-control text-right",attrs:{"type":"number"},domProps:{"value":(item.unitPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "unitPrice", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('span',{staticClass:"form-text text-danger"},[_vm._v(_vm._s(_vm.errors.services[i] && _vm.errors.services[i].unitPrice ? _vm.errors.services[i].unitPrice : ''))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v("\n                          "+_vm._s((item.quantity * item.unitPrice || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))+"\n                        ")])])])}),_vm._v(" "),_c('tr',[_vm._m(16),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_c('strong',[_vm._v(_vm._s(_vm.totalQuantityService.toLocaleString('en-US')))])])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_c('strong',[_vm._v(_vm._s(_vm.totalValueService.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })))])])])])],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(17)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("สถานะการดำเนินการ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("วันที่สร้าง :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("วันที่ซ่อมเสร็จสิ้น")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ชื่อช่าง :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ประเภทใบงาน :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("BARCODE :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ชื่อสินค้า/อุปกรณ์ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("จำนวน :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("สถานที่ซ่อมอุปกรณ์:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("สถานที่ซ่อมอุปกรณ์:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("วันที่รับเข้าคลังดี :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ผู้รับเข้าคลังดี :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("อะไหล่สำหรับซ่อม/ล้าง :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right p-3",attrs:{"colspan":"2"}},[_c('strong',[_vm._v("รวมจำนวน/มูลค่ารวม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ค่าบริการ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right p-3",attrs:{"colspan":"2"}},[_c('strong',[_vm._v("รวมจำนวน/มูลค่ารวม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทตัวแทนจำหน่าย:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.IS_RADIO_SHOW_AGENT),expression:"IS_RADIO_SHOW_AGENT"}],staticClass:"kt-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apmrAgentTypeCode),expression:"apmrAgentTypeCode"}],ref:"apmrAgentTypeCode",attrs:{"type":"radio","id":"apmrAgentTypeCode","name":"AGENT_TYPE_CODE","value":"AGENT"},domProps:{"checked":_vm._q(_vm.apmrAgentTypeCode,"AGENT")},on:{"change":[function($event){_vm.apmrAgentTypeCode="AGENT"},function($event){return _vm.onApmrAgentTypeCodeChange(this)}]}}),_vm._v(" "),_c('span'),_vm._v("\n                      ตัวแทนจำหน่าย \n                    ")]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.IS_RADIO_SHOW_SUB_AGENT),expression:"IS_RADIO_SHOW_SUB_AGENT"}],staticClass:"kt-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apmrAgentTypeCode),expression:"apmrAgentTypeCode"}],ref:"apmrAgentTypeCode",attrs:{"type":"radio","id":"apmrAgentTypeCode","name":"AGENT_TYPE_CODE","value":"SUB_AGENT"},domProps:{"checked":_vm._q(_vm.apmrAgentTypeCode,"SUB_AGENT")},on:{"change":[function($event){_vm.apmrAgentTypeCode="SUB_AGENT"},function($event){return _vm.onApmrAgentTypeCodeChange(this)}]}}),_vm._v(" "),_c('span'),_vm._v("\n                      ตัวแทนจำหน่ายย่อย\n                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภท:")]),_vm._v(" "),_c('select2',{ref:"apmrTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'apmrTypeCode',"name":'apmrTypeCode',"select2-options":_vm.apmrTypeCodeOptions},on:{"selectChange":_vm.onApmrTypeCodeChange},model:{value:(_vm.apmrTypeCode),callback:function ($$v) {_vm.apmrTypeCode=$$v},expression:"apmrTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"apmrDate",staticClass:"form-control",attrs:{"readonly":"","disabled":_vm.isEdit,"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"apmrDate","name":"apmrDate"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',{staticClass:"form-text"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.apmrAgentTypeCode=='AGENT'),expression:"apmrAgentTypeCode=='AGENT'"}],staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"apmrAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrAgentCode',"name":'apmrAgentCode',"select2-options":_vm.apmrAgentCodeOptions},on:{"selectChange":_vm.onApmrAgentCodeChange},model:{value:(_vm.apmrAgentCode),callback:function ($$v) {_vm.apmrAgentCode=$$v},expression:"apmrAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"apmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrShopCodes',"name":'apmrShopCodes',"select2-options":_vm.apmrShopCodesOptions,"multiple":""},model:{value:(_vm.apmrShopCodes),callback:function ($$v) {_vm.apmrShopCodes=$$v},expression:"apmrShopCodes"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.apmrAgentTypeCode=='SUB_AGENT'),expression:"apmrAgentTypeCode=='SUB_AGENT'"}],staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"apmrSubAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrSubAgentCode',"name":'apmrSubAgentCode',"select2-options":_vm.apmrSubAgentCodeOptions},on:{"selectChange":_vm.onApmrSubAgentCodeChange},model:{value:(_vm.apmrSubAgentCode),callback:function ($$v) {_vm.apmrSubAgentCode=$$v},expression:"apmrSubAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"apmrSubShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrSubShopCodes',"name":'apmrSubShopCodes',"select2-options":_vm.apmrSubShopCodesOptions,"multiple":""},model:{value:(_vm.apmrSubShopCodes),callback:function ($$v) {_vm.apmrSubShopCodes=$$v},expression:"apmrSubShopCodes"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อรูท:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apmrRouteName),expression:"apmrRouteName"}],ref:"apmrRouteName",staticClass:"form-control",attrs:{"type":"text","placeholder":"ชื่อรูท","id":"apmrRouteName","name":"apmrRouteName"},domProps:{"value":(_vm.apmrRouteName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.apmrRouteName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('select2',{ref:"apmrPmUserIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'apmrPmUserId',"name":'apmrPmUserId',"select2-options":_vm.apmrPmUserIdOptions},model:{value:(_vm.apmrPmUserId),callback:function ($$v) {_vm.apmrPmUserId=$$v},expression:"apmrPmUserId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apmrInActiveStatus),expression:"apmrInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"apmrInActiveStatus","id":"apmrInActiveStatus"},domProps:{"checked":Array.isArray(_vm.apmrInActiveStatus)?_vm._i(_vm.apmrInActiveStatus,null)>-1:(_vm.apmrInActiveStatus)},on:{"change":function($event){var $$a=_vm.apmrInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.apmrInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.apmrInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.apmrInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล")])}]


/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่ส่ง(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reBcTransferJobCommitDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reBcTransferJobCommitDateStart","name":"reBcTransferJobCommitDateStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ส่ง(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reBcTransferJobCommitDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reBcTransferJobCommitDateEnd","name":"reBcTransferJobCommitDateEnd"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับ(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reBcRetrieveJobCommitDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reBcRetrieveJobCommitDateStart","name":"reBcRetrieveJobCommitDateStart"}}),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับ(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reBcRetrieveJobCommitDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reBcRetrieveJobCommitDateEnd","name":"reBcRetrieveJobCommitDateEnd"}}),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่เอกสารใบงานต้นทาง:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBcTransferJobNumber),expression:"reBcTransferJobNumber"}],staticClass:"form-control",attrs:{"type":"text","rows":"1","placeholder":"ค้นหาจาก เลขที่เอกสารใบงานต้นทาง"},domProps:{"value":(_vm.reBcTransferJobNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBcTransferJobNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่เอกสารใบงานปลายทาง:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBcChildJobs),expression:"reBcChildJobs"}],staticClass:"form-control",attrs:{"type":"text","rows":"1","placeholder":"ค้นหาจาก เลขที่เอกสารใบงานปลายทาง"},domProps:{"value":(_vm.reBcChildJobs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBcChildJobs=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทเอกสาร:")]),_vm._v(" "),_c('select2',{ref:"reBcTransferJobTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reBcTransferJobTypeCode',"name":'reBcTransferJobTypeCode',"select2-options":_vm.reBcTransferJobTypeCodeOptions},model:{value:(_vm.reBcTransferJobTypeCode),callback:function ($$v) {_vm.reBcTransferJobTypeCode=$$v},expression:"reBcTransferJobTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ต้นทาง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBcOriginOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBcOrigin),callback:function ($$v) {_vm.reBcOrigin=$$v},expression:"reBcOrigin"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปลายทาง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBcDestinationOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBcDestination),callback:function ($$v) {_vm.reBcDestination=$$v},expression:"reBcDestination"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รถขนส่ง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreBcTransitIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reBcTransitId),callback:function ($$v) {_vm.reBcTransitId=$$v},expression:"reBcTransitId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อผู้ติดต่อ:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBcTransitContact),expression:"reBcTransitContact"}],staticClass:"form-control",attrs:{"type":"text","rows":"1","placeholder":"ค้นหาจาก ชื่อผู้ติดต่อ"},domProps:{"value":(_vm.reBcTransitContact)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBcTransitContact=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBcTransitContactTel),expression:"reBcTransitContactTel"}],staticClass:"form-control",attrs:{"type":"text","rows":"1","placeholder":"ค้นหาจาก เบอร์โทร"},domProps:{"value":(_vm.reBcTransitContactTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBcTransitContactTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะต้นทาง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBcTransferJobStatusCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBcTransferJobStatusCode),callback:function ($$v) {_vm.reBcTransferJobStatusCode=$$v},expression:"reBcTransferJobStatusCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะปลายทาง:")]),_vm._v(" "),_c('select2',{ref:"reBcCompletedJobSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reBcCompletedJob',"name":'reBcCompletedJob',"select2-options":_vm.reBcCompletedJobOptions},model:{value:(_vm.reBcCompletedJob),callback:function ($$v) {_vm.reBcCompletedJob=$$v},expression:"reBcCompletedJob"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผลการส่ง:")]),_vm._v(" "),_c('select2',{ref:"reBcResultSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reBcResult',"name":'reBcResult',"select2-options":_vm.reBcResultOptions},model:{value:(_vm.reBcResult),callback:function ($$v) {_vm.reBcResult=$$v},expression:"reBcResult"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.ExportBrandCount($event)}}},[_vm._m(5)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"brandCountTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"28"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reBcDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),(_vm.isShowFooter)?_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"10"}}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("รวมทั้งหมด")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    "+_vm._s(_vm.reBcTotalDestSingha)+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    "+_vm._s(_vm.reBcTotalDestLeo)+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    "+_vm._s(_vm.reBcTotalDestAsahi)+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    "+_vm._s(_vm.reBcTotalDestCarlsberg)+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    "+_vm._s(_vm.reBcTotalDestKronenbourg)+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    "+_vm._s(_vm.reBcTotalDestSnowy)+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    "+_vm._s(_vm.reBcTotalDestKopper)+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    "+_vm._s(_vm.reBcTotalDestOther)+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v("\n                    "+_vm._s(_vm.reBcTotalDestCo2)+"\n                  ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"1"}},[_vm._v(_vm._s(_vm.reBcTotalDest))]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"7"}})])]):_vm._e()])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่ส่ง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่รับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ระยะเวลาขนส่ง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่เอกสารใบงานต้นทาง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่เอกสารใบงานปลายทาง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทเอกสาร")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสต้นทาง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อต้นทาง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสปลายทาง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อปลายทาง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("SINGHA")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("LEO")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ASAHI")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("CARLSBERG")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("KRONENBOURG")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("SNOWY")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("KOPPER")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("OTHERS")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ท่อ CO2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รวม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รถขนส่ง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อผู้ติดต่อ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เบอร์โทร")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะต้นทาง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะปลายทาง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผลการส่ง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนขาดส่ง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"})])}]


/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสร้านค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.eShCustomerCode))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อร้านค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShCustomerName),expression:"eShCustomerName"}],staticClass:"form-control",attrs:{"disabled":!_vm.canEdit,"id":"eShCustomerName","name":"eShCustomerName","type":"text","maxlength":"256","placeholder":"ชื่อร้านค้า"},domProps:{"value":(_vm.eShCustomerName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eShCustomerName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อร้านค้า 2:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShName2),expression:"eShName2"}],staticClass:"form-control",attrs:{"disabled":!_vm.canEdit,"id":"eShName2","name":"eShName2","type":"text","maxlength":"256","placeholder":"ชื่อร้านค้า 2"},domProps:{"value":(_vm.eShName2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eShName2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"eShShopTypeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"disabled":!_vm.canEdit,"id":'eShShopType',"name":'eShShopType',"select2-options":_vm.eShShopTypeOptions},model:{value:(_vm.eShShopType),callback:function ($$v) {_vm.eShShopType=$$v},expression:"eShShopType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทการล้างเครื่อง:  ")]),_vm._v(" "),_c('select2',{ref:"eShShopPMTypeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'eShShopPMType',"name":'eShShopPMType',"select2-options":_vm.eShShopPMTypeOptions},model:{value:(_vm.eShShopPMType),callback:function ($$v) {_vm.eShShopPMType=$$v},expression:"eShShopPMType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สถานะประเภทร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"eShShopGroupSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"disabled":!_vm.canEdit,"id":'eShShopGroup',"name":'eShShopGroup',"select2-options":_vm.eShShopGroupOptions},model:{value:(_vm.eShShopGroup),callback:function ($$v) {_vm.eShShopGroup=$$v},expression:"eShShopGroup"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ที่อยู่:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShAddress),expression:"eShAddress"}],staticClass:"form-control",attrs:{"disabled":!_vm.canEdit,"id":"eShAddress","name":"eShAddress","type":"text","maxlength":"256","placeholder":"ที่อยู่"},domProps:{"value":(_vm.eShAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eShAddress=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"eShProvinceIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"disabled":!_vm.canEdit,"id":'eShProvinceId',"name":'eShProvinceId',"select2-options":_vm.eShProvinceIdOptions},model:{value:(_vm.eShProvinceId),callback:function ($$v) {_vm.eShProvinceId=$$v},expression:"eShProvinceId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"eShAmphurIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"disabled":!_vm.canEdit,"id":'eShAmphurId',"name":'eShAmphurId',"select2-options":_vm.eShAmphurIdOptions},model:{value:(_vm.eShAmphurId),callback:function ($$v) {_vm.eShAmphurId=$$v},expression:"eShAmphurId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตำบล:")]),_vm._v(" "),_c('select2',{ref:"eShTumbolIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"disabled":!_vm.canEdit,"id":'eShTumbolId',"name":'eShTumbolId',"select2-options":_vm.eShTumbolIdOptions},model:{value:(_vm.eShTumbolId),callback:function ($$v) {_vm.eShTumbolId=$$v},expression:"eShTumbolId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShSubAgent),expression:"eShSubAgent"}],staticClass:"form-check-input",attrs:{"disabled":!_vm.canEdit,"id":"eShSubAgent","name":"eShSubAgent","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.eShSubAgent)?_vm._i(_vm.eShSubAgent,null)>-1:(_vm.eShSubAgent)},on:{"change":function($event){var $$a=_vm.eShSubAgent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.eShSubAgent=$$a.concat([$$v]))}else{$$i>-1&&(_vm.eShSubAgent=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.eShSubAgent=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                                เปิดใช้งาน\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShContactFullName),expression:"eShContactFullName"}],staticClass:"form-control",attrs:{"disabled":!_vm.canEdit,"id":"eShContactFullName","name":"eShContactFullName","type":"text","maxlength":"256","placeholder":"ชื่อ-สกุลผู้ติดต่อ"},domProps:{"value":(_vm.eShContactFullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eShContactFullName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShEmail),expression:"eShEmail"}],staticClass:"form-control",attrs:{"disabled":!_vm.canEdit,"id":"eShEmail","name":"eShEmail","type":"text","maxlength":"400","placeholder":"อีเมล"},domProps:{"value":(_vm.eShEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eShEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShTel),expression:"eShTel"}],staticClass:"form-control",attrs:{"disabled":!_vm.canEdit,"id":"eShTel","name":"eShTel","type":"text","maxlength":"256","placeholder":"เบอร์โทร"},domProps:{"value":(_vm.eShTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eShTel=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ดูแลร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"eShAgentCodeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"disabled":!_vm.canEdit,"id":'eShAgentCode',"name":'eShAgentCode',"select2-options":_vm.eShAgentCodeOptions},model:{value:(_vm.eShAgentCode),callback:function ($$v) {_vm.eShAgentCode=$$v},expression:"eShAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อเจ้าหน้าที่ดูแล (ตัวแทน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShContactAgentName),expression:"eShContactAgentName"}],staticClass:"form-control",attrs:{"disabled":!_vm.canEdit,"id":"eShContactAgentName","name":"eShContactAgentName","type":"text"},domProps:{"value":(_vm.eShContactAgentName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eShContactAgentName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("นามสกุลเจ้าหน้าที่ดูแล (ตัวแทน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShContactAgentLName),expression:"eShContactAgentLName"}],staticClass:"form-control",attrs:{"disabled":!_vm.canEdit,"id":"eShContactAgentLName","name":"eShContactAgentLName","type":"text"},domProps:{"value":(_vm.eShContactAgentLName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eShContactAgentLName=$event.target.value}}})])]),_vm._v(" "),(_vm.$root.canShow('super_admin'))?_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เจ้าหน้าที่ดูแล (Boonrawd)")]),_vm._v(" "),_c('select2',{ref:"eShEmpSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"disabled":!_vm.canEdit,"id":'eShEmp',"name":'eShEmp',"select2-options":_vm.eShEmpOptions},model:{value:(_vm.eShEmp),callback:function ($$v) {_vm.eShEmp=$$v},expression:"eShEmp"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตั้งค่าระยะ Check-In/Check-Out:")]),_vm._v(" "),_c('div',[_c('label',{staticClass:"kt-radio kt-radio--bold kt-radio--brand",staticStyle:{"margin-right":"30px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.useSettingCheckinRange),expression:"useSettingCheckinRange"}],attrs:{"type":"radio","disabled":!_vm.canEdit},domProps:{"value":true,"checked":_vm._q(_vm.useSettingCheckinRange,true)},on:{"change":function($event){_vm.useSettingCheckinRange=true}}}),_vm._v(" กำหนดตามตั้งค่าพื้นฐาน\n                      "),_c('span')]),_vm._v(" "),_c('label',{staticClass:"kt-radio kt-radio--bold kt-radio--brand"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.useSettingCheckinRange),expression:"useSettingCheckinRange"}],attrs:{"type":"radio","disabled":!_vm.canEdit},domProps:{"value":false,"checked":_vm._q(_vm.useSettingCheckinRange,false)},on:{"change":function($event){_vm.useSettingCheckinRange=false}}}),_vm._v(" กำหนดเอง\n                      "),_c('span')]),_vm._v(" "),(!_vm.useSettingCheckinRange)?_c('button',{staticClass:"btn btn-sm btn-clean btn-icon",attrs:{"type":"button","disabled":!_vm.canEdit,"title":"ใช้ค่า default"},on:{"click":_vm.resetCheckinRange}},[_c('i',{staticClass:"la la-times"})]):_vm._e()]),_vm._v(" "),(_vm.useSettingCheckinRange && _vm.apiLoadedCheckInRange === null)?_c('div',{staticClass:"alert alert-warning mt-2",staticStyle:{"max-width":"500px"}},[_c('i',{staticClass:"la la-exclamation-triangle"}),_vm._v(" ให้ไป apply ค่าที่หน้า ตั้งค่าพื้นฐาน\n                  ")]):_vm._e(),_vm._v(" "),(!_vm.useSettingCheckinRange)?_c('div',{staticClass:"mt-2",staticStyle:{"max-width":"300px"}},[_c('label',{staticClass:"label-required"},[_vm._v("ระยะ (เมตร):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.customCheckInRange),expression:"customCheckInRange",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"10000","disabled":!_vm.canEdit,"placeholder":"ระบุระยะ (เมตร)","name":"customCheckInRange"},domProps:{"value":(_vm.customCheckInRange)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.customCheckInRange=_vm._n($event.target.value)},_vm.checkCustomCheckInRangeMax],"change":_vm.checkCustomCheckInRangeMax,"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.customCheckInRangeMaxError)?_c('span',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.customCheckInRangeMaxError))]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่งที่ตั้ง:")]),_vm._v(" "),(_vm.eShLat===null)?_c('div',[_c('button',{staticClass:"btn m-btn--pill btn-info btn-block col-xl-2",attrs:{"disabled":!_vm.canEdit,"type":"button"},on:{"click":_vm.getMap}},[_vm._v("\n                                ระบุข้อมูลตำแหน่งที่ตั้ง\n                            ")])]):_c('div',[_c('GmapMap',{staticStyle:{"width":"500px","height":"300px"},attrs:{"center":{lat:_vm.eShLat, lng: _vm.eShLng},"zoom":15,"clickable":true},on:{"click":_vm.updateCoordinates}},_vm._l((_vm.eShmarkers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"draggable":true,"clickable":true},on:{"drag":_vm.updateCoordinates,"click":_vm.updateCoordinates}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"disabled":!_vm.canEdit,"type":"button"},on:{"click":function($event){return _vm.openMap()}}},[_c('i',{staticClass:"far fa-map"}),_vm._v(" Open GoogleMaps\n                                ")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button","disabled":!_vm.canEdit},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("รูป\n                        ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-img"}},_vm._l((_vm.FileUpload),function(image){return (image.isLoaded)?_c('div',{key:image.pictureId,staticClass:"col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap",attrs:{"id":image.pictureId}},[_c('img',{staticClass:"img-plant -avatar js-avatar-me img-thumbnail card-img-top",attrs:{"src":image.urlImg},on:{"error":function($event){return _vm.handleImageError(image)},"load":function($event){return _vm.handleImageLoad(image)}}}),_vm._v(" "),_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","top":"10px","right":"20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeImage(image.pictureId)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})])]):_vm._e()}),0)])])]),_vm._v(" "),(_vm.eshIfChk == 'STATUS_SHOP_INACTIVE_STOP')?_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("*ปิดกิจการถาวร และคุณไม่ได้รับอนุญาตให้เปลี่ยนสถานะร้านที่ปิดกิจการถาวร")]):_vm._e(),_vm._v(" "),(_vm.eshIfChk == 'STATUS_SHOP_INACTIVE_DUPLICATE')?_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("*ร้านค้าซ้ำในระบบ")]):_vm._e(),_vm._v(" "),((_vm.eshIfChk != 'STATUS_SHOP_INACTIVE_STOP' || _vm.$root.canShow('super_admin')) && _vm.eshIfChk != 'STATUS_SHOP_INACTIVE_DUPLICATE')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShInActiveStatus),expression:"eShInActiveStatus"}],staticClass:"form-check-input",attrs:{"disabled":!_vm.canEdit,"id":"eShInActiveStatus","name":"eShInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.eShInActiveStatus)?_vm._i(_vm.eShInActiveStatus,null)>-1:(_vm.eShInActiveStatus)},on:{"click":_vm.chkStatus,"change":function($event){var $$a=_vm.eShInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.eShInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.eShInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.eShInActiveStatus=$$c}}}}),_vm._v("\n                                เปิดใช้งาน\n                                "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[(_vm.eShInActiveStatus)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เหตุผล:")]),_vm._v(" "),_vm._l((_vm.eShActive),function(data){return _c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShStatus),expression:"eShStatus"}],staticClass:"form-check-input",attrs:{"id":"statusCode","name":"statusCode","type":"radio"},domProps:{"value":data.statusCode,"checked":_vm._q(_vm.eShStatus,data.statusCode)},on:{"change":function($event){_vm.eShStatus=data.statusCode}}}),_vm._v("\n                                "+_vm._s(data.statusName)+"\n                                "),_c('span')]),_vm._v(" "),_c('br')])})],2):_vm._e(),_vm._v(" "),(!_vm.eShInActiveStatus)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เหตุผล:")]),_vm._v(" "),_vm._l((_vm.eShInActive),function(data){return _c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.InActiveStatus),expression:"InActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"statusCode","name":"statusCode","type":"radio"},domProps:{"value":data.statusCode,"checked":_vm._q(_vm.InActiveStatus,data.statusCode)},on:{"change":function($event){_vm.InActiveStatus=data.statusCode}}}),_vm._v("\n                                "+_vm._s(data.statusName)+"\n                                "),_c('span')]),_vm._v(" "),_c('br')])})],2):_vm._e()]),_vm._v(" "),(this.$root.canShow(['']))?_c('div',{staticClass:"col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("[PM] ปลด validate การตรวจสอบหน้าข้อมูลร้านค้า")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShIgnoreBarcodeValidation),expression:"eShIgnoreBarcodeValidation"}],staticClass:"form-check-input",attrs:{"disabled":!_vm.canEdit,"id":"eShIgnoreBarcodeValidation","name":"eShIgnoreBarcodeValidation","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.eShIgnoreBarcodeValidation)?_vm._i(_vm.eShIgnoreBarcodeValidation,null)>-1:(_vm.eShIgnoreBarcodeValidation)},on:{"change":function($event){var $$a=_vm.eShIgnoreBarcodeValidation,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.eShIgnoreBarcodeValidation=$$a.concat([$$v]))}else{$$i>-1&&(_vm.eShIgnoreBarcodeValidation=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.eShIgnoreBarcodeValidation=$$c}}}}),_vm._v("\n                                เปิดใช้งาน\n                                "),_c('span')])])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['']))?_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("[PM] ตั้งค่าใช้ PM (รูปแบบพิเศษ)")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShIsSpecialPM),expression:"eShIsSpecialPM"}],staticClass:"form-check-input",attrs:{"id":"eShIsSpecialPM","name":"eShIsSpecialPM","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.eShIsSpecialPM)?_vm._i(_vm.eShIsSpecialPM,null)>-1:(_vm.eShIsSpecialPM)},on:{"change":function($event){var $$a=_vm.eShIsSpecialPM,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.eShIsSpecialPM=$$a.concat([$$v]))}else{$$i>-1&&(_vm.eShIsSpecialPM=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.eShIsSpecialPM=$$c}}}}),_vm._v("\n                      เปิดใช้งาน PM (รูปแบบพิเศษ)\n                      "),_c('span')])])])]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),(_vm.canEdit)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("แก้ไขข้อมูลร้านค้า")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("\n                            รูปภาพ:"),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                                (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน\n                                10Mb.)\n                            ")])])}]


/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/BeerClaimReport/AmountBeerClaim'),expression:"$route.path == '/BeerClaimReport/AmountBeerClaim'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reSalesAreaOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reSalesArea),callback:function ($$v) {_vm.reSalesArea=$$v},expression:"reSalesArea"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadreAgentCodesOptions},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"4000px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":_vm.brandItem.length +
                        _vm.brandItem.length +
                        _vm.brandItem.length +
                        _vm.brandItem.length +
                        _vm.brandItem.length +
                        _vm.brandItem.length +
                        12}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-center",staticStyle:{"width":"50px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    ลำดับ\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"100px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    วันที่ทำเคลม\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"100px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    เขต\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"250px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    ตัวแทนจำหน่าย\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"150px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    ชื่อร้านค้า\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"150px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    ชื่อร้านค้า 2\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"150px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    BARCODE\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"150px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    รหัสทรัพย์สิน(เบียร์สด)\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"150px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    เลขที่ใบแคลม\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"100px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    ผู้อนุมติการเคลม\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"LightSkyBlue"},attrs:{"colspan":_vm.brandHeader.length +
                        _vm.brandHeader.length +
                        _vm.brandItem.length}},[_vm._v("\n                    อนุมัติเคลม\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"100px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    รายละเอียดของปัญหา\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"background-color":"LightPink"},attrs:{"colspan":_vm.brandHeader.length +
                        _vm.brandHeader.length +
                        _vm.brandItem.length}},[_vm._v("\n                    ไม่อนุมัติเคลม\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"100px"},attrs:{"rowspan":"4"}},[_vm._v("\n                    รายละเอียดของปัญหา\n                  ")])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"all text-center",attrs:{"colspan":_vm.brandItem.length}},[_vm._v("\n                    ประเภทถัง (ราคารวม VAT)\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"colspan":_vm.brandHeader.length + _vm.brandHeader.length}},[_vm._v("\n                    สาเหตุที่เคลม\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"colspan":_vm.brandItem.length}},[_vm._v("\n                    ประเภทถัง (ราคารวม VAT)\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"colspan":_vm.brandHeader.length + _vm.brandHeader.length}},[_vm._v("\n                    สาเหตุที่เคลม\n                  ")])]),_vm._v(" "),_c('tr',[_vm._l((_vm.brandHeader),function(header){return _c('th',{staticClass:"all text-center",attrs:{"colspan":_vm.brandItem.filter(function (o) { return o[0] == header; }).length}},[_vm._v("\n                    "+_vm._s(header)+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"colspan":_vm.brandHeader.length}},[_vm._v("\n                    ถังชำรุด\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"colspan":_vm.brandHeader.length}},[_vm._v("\n                    น้ำเบียร์ผิดปกติ\n                  ")]),_vm._v(" "),_vm._l((_vm.brandHeader),function(header){return _c('th',{staticClass:"all text-center",attrs:{"colspan":_vm.brandItem.filter(function (o) { return o[0] == header; }).length}},[_vm._v("\n                    "+_vm._s(header)+"\n                  ")])}),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"colspan":_vm.brandHeader.length}},[_vm._v("\n                    ถังชำรุด\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",attrs:{"colspan":_vm.brandHeader.length}},[_vm._v("\n                    น้ำเบียร์ผิดปกติ\n                  ")])],2),_vm._v(" "),_c('tr',[_vm._l((_vm.brandItem),function(item){return _c('th',{staticClass:"all text-center",staticStyle:{"width":"50px"}},[_vm._v("\n                    "+_vm._s(item[1])+"L\n                  ")])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(header){return _c('th',{staticClass:"all text-center",staticStyle:{"width":"80px"}},[_vm._v("\n                    "+_vm._s(header)+"\n                  ")])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(header){return _c('th',{staticClass:"all text-center",staticStyle:{"width":"80px"}},[_vm._v("\n                    "+_vm._s(header)+"\n                  ")])}),_vm._v(" "),_vm._l((_vm.brandItem),function(item){return _c('th',{staticClass:"all text-center",staticStyle:{"width":"50px"}},[_vm._v("\n                    "+_vm._s(item[1])+"L\n                  ")])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(header){return _c('th',{staticClass:"all text-center",staticStyle:{"width":"80px"}},[_vm._v("\n                    "+_vm._s(header)+"\n                  ")])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(header){return _c('th',{staticClass:"all text-center",staticStyle:{"width":"80px"}},[_vm._v("\n                    "+_vm._s(header)+"\n                  ")])})],2)]),_vm._v(" "),_vm._l((_vm.dataTable),function(data,index){return _c('tr',[[_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(data.claimDateString))]),_vm._v(" "),_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(data.salesAreaName))]),_vm._v(" "),_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(data.agentName))]),_vm._v(" "),_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(data.shopName))]),_vm._v(" "),_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(data.shopName2))]),_vm._v(" "),_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(data.barCodeNoOld))]),_vm._v(" "),_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(data.departmentMaterialCode))]),_vm._v(" "),_c('td',{staticClass:"all text-center"},[_vm._v(_vm._s(data.claimNumber))]),_vm._v(" "),_c('td',{staticClass:"all text-center"}),_vm._v(" "),_vm._l((_vm.brandItem),function(item){return _c('td',{staticClass:"all text-center"},[(
                        data.productBrandName == item[0] &&
                          data.volume == item[1] &&
                          data.claimStatusCode ==
                            'CLAIM_STATUS_CONCLUDE_APPROVE'
                      )?_c('span',[_vm._v(_vm._s(data.price
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[(
                        data.productBrandName == item &&
                          data.claimStatusCode ==
                            'CLAIM_STATUS_CONCLUDE_APPROVE' &&
                          data.problemTypeCode == 'PROBLEM_TYPE_DAMAGED_TANK'
                      )?_c('span',[_vm._v(_vm._s(data.price
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[(
                        data.productBrandName == item &&
                          data.claimStatusCode ==
                            'CLAIM_STATUS_CONCLUDE_APPROVE' &&
                          data.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'
                      )?_c('span',[_vm._v(_vm._s(data.price
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]):_vm._e()])}),_vm._v(" "),(
                      data.claimStatusCode == 'CLAIM_STATUS_CONCLUDE_APPROVE'
                    )?_c('td',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(data.problemDesc)+"\n                  ")]):_vm._e(),_vm._v(" "),(
                      data.claimStatusCode == 'CLAIM_STATUS_CONCLUDE_REJECT'
                    )?_c('td',{staticClass:"all text-center"}):_vm._e(),_vm._v(" "),_vm._l((_vm.brandItem),function(item){return _c('td',{staticClass:"all text-center"},[(
                        data.productBrandName == item[0] &&
                          data.claimStatusCode ==
                            'CLAIM_STATUS_CONCLUDE_REJECT'
                      )?_c('span',[_vm._v(_vm._s(data.price
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[(
                        data.productBrandName == item &&
                          data.claimStatusCode ==
                            'CLAIM_STATUS_CONCLUDE_REJECT' &&
                          data.problemTypeCode == 'PROBLEM_TYPE_DAMAGED_TANK'
                      )?_c('span',[_vm._v(_vm._s(data.price
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(item){return _c('td',{staticClass:"all text-center"},[(
                        data.productBrandName == item &&
                          data.claimStatusCode ==
                            'CLAIM_STATUS_CONCLUDE_REJECT' &&
                          data.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'
                      )?_c('span',[_vm._v(_vm._s(data.price
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]):_vm._e()])}),_vm._v(" "),(
                      data.claimStatusCode == 'CLAIM_STATUS_CONCLUDE_REJECT'
                    )?_c('td',{staticClass:"all text-center"},[_vm._v("\n                    "+_vm._s(data.problemDesc)+"\n                  ")]):_vm._e(),_vm._v(" "),(
                      data.claimStatusCode == 'CLAIM_STATUS_CONCLUDE_APPROVE'
                    )?_c('td',{staticClass:"all text-center"}):_vm._e()]],2)}),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"all text-center",attrs:{"colspan":2}},[_vm._v("Total")]),_vm._v(" "),_vm._l((_vm.brandItem),function(data){return _c('td',{staticClass:"all text-center"},[_c('span',[_vm._v("\n                      "+_vm._s(_vm.sumTotal(
                          _vm.dataTable.filter(
                            function (o) { return o.productBrandName == data[0] &&
                              o.volume == data[1] &&
                              o.price > 0 &&
                              o.claimStatusCode ==
                                "CLAIM_STATUS_CONCLUDE_APPROVE"; }
                          )
                        ))+"\n                    ")])])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(data){return _c('td',{staticClass:"all text-center"},[_c('span',[_vm._v("\n                      "+_vm._s(_vm.sumTotal(
                          _vm.dataTable.filter(
                            function (o) { return o.productBrandName == data &&
                              o.problemTypeCode ==
                                "PROBLEM_TYPE_DAMAGED_TANK" &&
                              o.claimStatusCode ==
                                "CLAIM_STATUS_CONCLUDE_APPROVE"; }
                          )
                        ))+"\n                    ")])])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(data){return _c('td',{staticClass:"all text-center"},[_c('span',[_vm._v("\n                      "+_vm._s(_vm.sumTotal(
                          _vm.dataTable.filter(
                            function (o) { return o.productBrandName == data &&
                              o.problemTypeCode ==
                                "PROBLEM_TYPE_UNUSUAL_TASTE" &&
                              o.claimStatusCode ==
                                "CLAIM_STATUS_CONCLUDE_APPROVE"; }
                          )
                        ))+"\n                    ")])])}),_vm._v(" "),_c('td'),_vm._v(" "),_vm._l((_vm.brandItem),function(data){return _c('td',{staticClass:"all text-center"},[_c('span',[_vm._v("\n                      "+_vm._s(_vm.sumTotal(
                          _vm.dataTable.filter(
                            function (o) { return o.productBrandName == data[0] &&
                              o.volume == data[1] &&
                              o.claimStatusCode ==
                                "CLAIM_STATUS_CONCLUDE_REJECT"; }
                          )
                        ))+"\n                    ")])])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(data){return _c('td',{staticClass:"all text-center"},[_c('span',[_vm._v("\n                      "+_vm._s(_vm.sumTotal(
                          _vm.dataTable.filter(
                            function (o) { return o.productBrandName == data &&
                              o.problemTypeCode ==
                                "PROBLEM_TYPE_DAMAGED_TANK" &&
                              o.claimStatusCode ==
                                "CLAIM_STATUS_CONCLUDE_REJECT"; }
                          )
                        ))+"\n                    ")])])}),_vm._v(" "),_vm._l((_vm.brandHeader),function(data){return _c('td',{staticClass:"all text-center"},[_c('span',[_vm._v("\n                      "+_vm._s(_vm.sumTotal(
                          _vm.dataTable.filter(
                            function (o) { return o.productBrandName == data &&
                              o.problemTypeCode ==
                                "PROBLEM_TYPE_UNUSUAL_TASTE" &&
                              o.claimStatusCode ==
                                "CLAIM_STATUS_CONCLUDE_REJECT"; }
                          )
                        ))+"\n                    ")])])}),_vm._v(" "),_c('td')],2)])],2)])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])}]


/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วัน-เวลาทำ MT :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.mtDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้ทำ MT :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.createUser))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รูปลายเซ็นต์ :")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.signatureFileUrl )?_c('a',{attrs:{"href":"#","title":"รูปภาพ"},on:{"click":function($event){$event.preventDefault();return _vm.pictureModal(_vm.signatureFileUrl)}}},[_vm._v("Link")]):_vm._e()])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.failureMachineCodes.length > 0)?_c('div',[_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              อาการเสีย:\n            ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.failureMachineCodes),function(fmc,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                          "+_vm._s(i + 1)+"\n                        ")]),_vm._v(" "),(
                            fmc.failureMachineCode != 'FAILURE_MACHINE_OTHER'
                          )?_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                          "+_vm._s(fmc.failureMachineName)+"\n                        ")]):_vm._e(),_vm._v(" "),(
                            fmc.failureMachineCode == 'FAILURE_MACHINE_OTHER'
                          )?_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                          "+_vm._s(fmc.failureMachineName)+"   ("+_vm._s(_vm.failureMachineOther)+")\n                        ")]):_vm._e()])}),0)])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n            สาเหตุของอาการเสีย:\n          ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(2),_vm._v(" "),(_vm.failureMachineReasonCodes.length > 0)?_c('tbody',_vm._l((_vm.failureMachineReasonCodes),function(fmrc,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(i + 1)+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                        "+_vm._s(fmrc.failureMachineReasonName)+"\n                      ")])])}),0):_vm._e(),_vm._v(" "),(_vm.failureMachineReasonOther)?_c('tbody',[_c('tr',[(_vm.failureMachineReasonCodes.length == 0)?_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        1\n                      ")]):_vm._e(),_vm._v(" "),(_vm.failureMachineReasonCodes.length > 0)?_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(_vm.failureMachineReasonCodes.length + 1)+"\n                      ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                        "+_vm._s(_vm.failureMachineReasonOther)+"\n                      ")])])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วิธีการแก้ปัญหา :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.resolve))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"imageModal","tabindex":"-1","role":"dialog","aria-labelledby":"imageModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("ภาพถ่าย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticClass:"img-thumbnail mb-3",staticStyle:{"height":"auto","width":"auto"},attrs:{"src":_vm.modalImageURL}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("อาการเสีย")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("\n                        สาเหตุของอาการเสีย\n                      ")])])])}]


/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"userUpdateModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อผู้ใช้งาน (UserName):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],staticClass:"form-control",attrs:{"disabled":"","id":"userName","name":"userName","type":"text","maxlength":"256","placeholder":"ชื่อผู้ใช้งาน (UserName)"},domProps:{"value":(_vm.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"id":"email","name":"email","type":"email","maxlength":"256","placeholder":"อีเมล"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("บทบาท:")]),_vm._v(" "),(this.$root.canShow(''))?_c('treeselect',{attrs:{"id":"roleName","multiple":true,"options":_vm.roleNameOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.roleName),callback:function ($$v) {_vm.roleName=$$v},expression:"roleName"}}):_c('treeselect',{attrs:{"id":"roleName","options":_vm.roleNameOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.roleName),callback:function ($$v) {_vm.roleName=$$v},expression:"roleName"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("โปรไฟล์บริษัท:")]),_vm._v(" "),(this.$root.canShow(''))?_c('treeselect',{attrs:{"id":"companyProfile","multiple":true,"options":_vm.companyProfileOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.companyProfile),callback:function ($$v) {_vm.companyProfile=$$v},expression:"companyProfile"}}):_c('treeselect',{attrs:{"id":"companyProfile","options":_vm.companyProfileOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.companyProfile),callback:function ($$v) {_vm.companyProfile=$$v},expression:"companyProfile"}}),_vm._v(" "),_c('br'),_vm._v("ไม่พบข้อมูลโปรไฟล์บริษัท? คลิกเพื่อสร้าง\n                      "),_c('a',{attrs:{"href":"javascript:void()"},on:{"click":_vm.showAgentProfileCreateForm}},[_vm._v("โปรไฟล์ตัวแทนฯ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.givenName),expression:"givenName"}],staticClass:"form-control",attrs:{"id":"givenName","name":"givenName","type":"text","maxlength":"450","placeholder":"ชื่อ"},domProps:{"value":(_vm.givenName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.givenName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสกุล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.familyName),expression:"familyName"}],staticClass:"form-control",attrs:{"id":"familyName","name":"familyName","type":"text","maxlength":"450","placeholder":"ชื่อสกุล"},domProps:{"value":(_vm.familyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.familyName=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่ง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.position),expression:"position"}],staticClass:"form-control",attrs:{"id":"position","name":"position","type":"text","maxlength":"450","placeholder":"ตำแหน่ง"},domProps:{"value":(_vm.position)},on:{"input":function($event){if($event.target.composing){ return; }_vm.position=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"form-control",attrs:{"id":"phoneNumber","name":"phoneNumber","type":"text","maxlength":"450","placeholder":"เบอร์ติดต่อ"},domProps:{"value":(_vm.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่เข้าสู่ระบบล่าสุด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastLogOnDateTimeString),expression:"lastLogOnDateTimeString"}],staticClass:"form-control",attrs:{"disabled":"","name":"lastLogOnDateTimeString","type":"text"},domProps:{"value":(_vm.lastLogOnDateTimeString)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastLogOnDateTimeString=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button"},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("รูป\n                      ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-img"}},[(_vm.FileUpload && _vm.FileUpload.isLoaded)?_c('div',{staticClass:"col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap",attrs:{"id":_vm.FileUpload.pictureId}},[_c('img',{staticClass:"img-plant -avatar js-avatar-me img-thumbnail card-img-top",attrs:{"src":_vm.FileUpload.urlImg},on:{"error":function($event){return _vm.handleImageError(_vm.FileUpload)},"load":function($event){return _vm.handleImageLoad(_vm.FileUpload)}}}),_vm._v(" "),_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","top":"10px","right":"20px"},attrs:{"href":"javascript:;"},on:{"click":_vm.removeImage}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inActiveStatus),expression:"inActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"inActiveStatus","id":"inActiveStatus"},domProps:{"checked":Array.isArray(_vm.inActiveStatus)?_vm._i(_vm.inActiveStatus,null)>-1:(_vm.inActiveStatus)},on:{"change":function($event){var $$a=_vm.inActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inActiveStatus=$$c}}}}),_vm._v("\n                          เปิดใช้งาน\n                          "),_c('span')])])])])]),_vm._v(" "),_c('user-sml-mapping',{attrs:{"selectedCompanyProfiles":_vm.selectedCompanyProfiles,"userSmlMappings":_vm.userSmlMappings},on:{"update:userSmlMappings":function($event){_vm.userSmlMappings=$event},"update:user-sml-mappings":function($event){_vm.userSmlMappings=$event}}})],1)])]),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('agent-profile-create-form',{ref:"agentProfileCreateForm"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("รูปลายเซ็นต์:\n                        "),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                          (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb. Size แนะนำ 200*30 Pixel.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล")])])}]


/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group text-left"},[_c('label',{staticClass:"label-required"},[_vm._v("ผล LAB:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.labResult),expression:"labResult"}],ref:"labResult",staticClass:"form-control",attrs:{"placeholder":"ผล LAB","id":"labResult","name":"labResult","disabled":!_vm.isEdit,"rows":"7","maxlength":_vm.maxLength},domProps:{"value":(_vm.labResult)},on:{"input":function($event){if($event.target.composing){ return; }_vm.labResult=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"}),_vm._v(" "),(_vm.labResult)?_c('span',{staticStyle:{"float":"right"}},[_vm._v(_vm._s(_vm.labResult.length)+" / "+_vm._s(_vm.maxLength))]):_vm._e(),_vm._v(" "),(!_vm.labResult || _vm.labResult=='')?_c('span',{staticStyle:{"float":"right"}},[_vm._v("0 / "+_vm._s(_vm.maxLength))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group text-left"},[_c('label',[_vm._v("ไฟล์:")]),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-4",attrs:{"type":"button","id":'uploader-order' + _vm._uid,"data-ref":_vm._uid}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("เลือกไฟล์\n                    ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":'container-file' + _vm._uid}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.formReset()}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "+_vm._s(_vm.bnt)+"\n          ")])])])])])])}
var staticRenderFns = []


/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{ref:"form",staticClass:"kt-form"},[_c('form',{staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('input',{staticClass:"custom-file-input",attrs:{"type":"file","id":"importFilePhase","lang":"es"}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",attrs:{"for":"importFilePhase"}},[_vm._v(_vm._s(_vm.Flie))])])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"reset"},on:{"click":_vm.resetFile}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ล้างค่า\n        ")]),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",staticStyle:{"width":"100%"},attrs:{"id":"PreviewTable"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])}]


/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/JobAgentScore'),expression:"$route.path == '/Report/JobAgentScore'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปี :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"odYear",staticClass:"form-control",attrs:{"type":"text","placeholder":"(YYYY)","id":"odYear","name":"odYear","autocomplete":"off"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เดือน :")]),_vm._v(" "),_c('select2',{key:'odMonth-' + _vm.odMonthKey,ref:"odMonthSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'odMonth',"name":'odMonth',"select2-options":_vm.odMonthOptions},model:{value:(_vm.odMonth),callback:function ($$v) {_vm.odMonth=$$v},expression:"odMonth"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reCommitDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reCommitDateStart","name":"reCommitDateStart"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reCommitDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reCommitDateEnd","name":"reCommitDateEnd"}}),_vm._v(" "),_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAaAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAaAgentCode),callback:function ($$v) {_vm.reAaAgentCode=$$v},expression:"reAaAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทใบงาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJobGroupTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJobGroupType),callback:function ($$v) {_vm.reJobGroupType=$$v},expression:"reJobGroupType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.MbSKUOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.MbSKUId),callback:function ($$v) {_vm.MbSKUId=$$v},expression:"MbSKUId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportData}},[_vm._m(4)])])])]),_vm._v(" "),_vm._m(5)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"reportTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v(" ปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v(" เดือน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v(" วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v(" โรงงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v(" รหัสตัวแทนฯ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v(" ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v(" ประเภทใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v(" จำนวนใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v(" ชื่อสินค้า /จำนวนสินค้า")])])])])])])}]


/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"brtEmployee",attrs:{"css-style":'width: 100%;',"css-class":'form-control required',"id":'brtEmployee' + _vm._uid,"name":'brtEmployee' + _vm._uid,"select2-options":_vm.brtEmployeeOptions,"data-msg-required":"กรุณาเลือกพนักงาน"},on:{"selectChange":_vm.onEmployeeChange},model:{value:(_vm.brtEmployee),callback:function ($$v) {_vm.brtEmployee=$$v},expression:"brtEmployee"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('center',[_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"รายละเอียด"},on:{"click":function($event){$event.preventDefault();return _vm.detail($event)}}},[_c('i',{staticClass:"text-info far fa-file-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveBRTItemClick($event)}}},[_c('i',{staticClass:"text-danger la la-trash"})])])],1)])}
var staticRenderFns = []


/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสร้านค้า (ตัวแทนจำหน่ายย่อย):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cssaShopSubAgentCode),expression:"cssaShopSubAgentCode"}],staticClass:"form-control",attrs:{"id":"cssaShopSubAgentCode","name":"cssaShopSubAgentCode","type":"text","maxlength":"50","placeholder":"รหัสร้านค้า (ตัวแทนจำหน่ายย่อย)"},domProps:{"value":(_vm.cssaShopSubAgentCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssaShopSubAgentCode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อร้านค้า (ตัวแทนจำหน่ายย่อย):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cssaShopSubAgentName),expression:"cssaShopSubAgentName"}],staticClass:"form-control",attrs:{"id":"cssaShopSubAgentName","name":"cssaShopSubAgentName","type":"text","maxlength":"256","placeholder":"ชื่อร้านค้า (ตัวแทนจำหน่ายย่อย)"},domProps:{"value":(_vm.cssaShopSubAgentName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssaShopSubAgentName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cssaShopSubAgentName2),expression:"cssaShopSubAgentName2"}],staticClass:"form-control",attrs:{"id":"cssaShopSubAgentName2","name":"cssaShopSubAgentName2","type":"text","maxlength":"256","placeholder":"ชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย)"},domProps:{"value":(_vm.cssaShopSubAgentName2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssaShopSubAgentName2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"cssaShopTypeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cssaShopType',"name":'cssaShopType',"select2-options":_vm.cssaShopTypeOptions},model:{value:(_vm.cssaShopType),callback:function ($$v) {_vm.cssaShopType=$$v},expression:"cssaShopType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทการล้างเครื่อง:")]),_vm._v(" "),_c('select2',{ref:"cssaShopPMTypeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cssaShopPMType',"name":'cssaShopPMType',"select2-options":_vm.cssaShopPMTypeOptions},model:{value:(_vm.cssaShopPMType),callback:function ($$v) {_vm.cssaShopPMType=$$v},expression:"cssaShopPMType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สถานะประเภทร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"cshShopGroupSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cshShopGroup',"name":'cshShopGroup',"select2-options":_vm.cshShopGroupOptions},model:{value:(_vm.cshShopGroup),callback:function ($$v) {_vm.cshShopGroup=$$v},expression:"cshShopGroup"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ที่อยู่:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cssaAddress),expression:"cssaAddress"}],staticClass:"form-control",attrs:{"id":"cssaAddress","name":"cssaAddress","type":"text","maxlength":"256","placeholder":"ที่อยู่"},domProps:{"value":(_vm.cssaAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssaAddress=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"cssaProvinceIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cssaProvinceId',"name":'cssaProvinceId',"select2-options":_vm.cssaProvinceIdOptions},model:{value:(_vm.cssaProvinceId),callback:function ($$v) {_vm.cssaProvinceId=$$v},expression:"cssaProvinceId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"cssaAmphurIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cssaAmphurId',"name":'cssaAmphurId',"select2-options":_vm.cssaAmphurIdOptions},model:{value:(_vm.cssaAmphurId),callback:function ($$v) {_vm.cssaAmphurId=$$v},expression:"cssaAmphurId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำบล:")]),_vm._v(" "),_c('select2',{ref:"cssaTumbolIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cssaTumbolId',"name":'cssaTumbolId',"select2-options":_vm.cssaTumbolIdOptions},model:{value:(_vm.cssaTumbolId),callback:function ($$v) {_vm.cssaTumbolId=$$v},expression:"cssaTumbolId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cssaContactFullName),expression:"cssaContactFullName"}],staticClass:"form-control",attrs:{"id":"cssaContactFullName","name":"cssaContactFullName","type":"text","maxlength":"256","placeholder":"ชื่อ-สกุลผู้ติดต่อ"},domProps:{"value":(_vm.cssaContactFullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssaContactFullName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cssaEmail),expression:"cssaEmail"}],staticClass:"form-control",attrs:{"id":"cssaEmail","name":"cssaEmail","type":"text","maxlength":"256","placeholder":"อีเมล"},domProps:{"value":(_vm.cssaEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssaEmail=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cssaTel),expression:"cssaTel"}],staticClass:"form-control",attrs:{"id":"cssaTel","name":"cssaTel","type":"text","maxlength":"256","placeholder":"เบอร์โทร"},domProps:{"value":(_vm.cssaTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssaTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ดูแลร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"cssaShopCodeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cssaShopCode',"name":'cssaShopCode',"select2-options":_vm.cssaShopCodeOptions},on:{"selectChange":_vm.onShopCodeChange},model:{value:(_vm.cssaShopCode),callback:function ($$v) {_vm.cssaShopCode=$$v},expression:"cssaShopCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อเจ้าหน้าที่ดูแล (ร้านค้า):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cssaContactShopName),expression:"cssaContactShopName"}],staticClass:"form-control",attrs:{"id":"cssaContactShopName","name":"cssaContactShopName","type":"text","maxlength":"256","placeholder":"ชื่อเจ้าหน้าที่ดูแล (ร้านค้า)"},domProps:{"value":(_vm.cssaContactShopName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssaContactShopName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("นามสกุลเจ้าหน้าที่ดูแล (ร้านค้า):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cssaContactShopLName),expression:"cssaContactShopLName"}],staticClass:"form-control",attrs:{"id":"cssaContactShopLName","name":"cssaContactShopLName","type":"text","maxlength":"256","placeholder":"นามสกุลเจ้าหน้าที่ดูแล (ร้านค้า)"},domProps:{"value":(_vm.cssaContactShopLName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssaContactShopLName=$event.target.value}}})])]),_vm._v(" "),(_vm.$root.canShow('super_admin'))?_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เจ้าหน้าที่ดูแล (Boonrawd)")]),_vm._v(" "),_c('select2',{ref:"cssaEmpIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cssaEmpId',"name":'cssaEmpId',"select2-options":_vm.cssaEmpIdOptions},model:{value:(_vm.cssaEmpId),callback:function ($$v) {_vm.cssaEmpId=$$v},expression:"cssaEmpId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตั้งค่าระยะ Check-In/Check-Out:")]),_vm._v(" "),_c('div',[_c('label',{staticClass:"kt-radio kt-radio--bold kt-radio--brand",staticStyle:{"margin-right":"30px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.useSettingCheckinRange),expression:"useSettingCheckinRange"}],attrs:{"type":"radio"},domProps:{"value":true,"checked":_vm._q(_vm.useSettingCheckinRange,true)},on:{"change":function($event){_vm.useSettingCheckinRange=true}}}),_vm._v(" กำหนดตามตั้งค่าพื้นฐาน\n                  "),_c('span')]),_vm._v(" "),_c('label',{staticClass:"kt-radio kt-radio--bold kt-radio--brand"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.useSettingCheckinRange),expression:"useSettingCheckinRange"}],attrs:{"type":"radio"},domProps:{"value":false,"checked":_vm._q(_vm.useSettingCheckinRange,false)},on:{"change":function($event){_vm.useSettingCheckinRange=false}}}),_vm._v(" กำหนดเอง\n                  "),_c('span')]),_vm._v(" "),(!_vm.useSettingCheckinRange)?_c('button',{staticClass:"btn btn-sm btn-clean btn-icon",attrs:{"type":"button","title":"ใช้ค่า default"},on:{"click":_vm.resetCheckinRange}},[_c('i',{staticClass:"la la-times"})]):_vm._e()]),_vm._v(" "),(!_vm.useSettingCheckinRange)?_c('div',{staticClass:"mt-2",staticStyle:{"max-width":"300px"}},[_c('label',{staticClass:"label-required"},[_vm._v("ระยะ (เมตร):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.customCheckInRange),expression:"customCheckInRange",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"10000","placeholder":"ระบุระยะ (เมตร)","name":"customCheckInRange"},domProps:{"value":(_vm.customCheckInRange)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.customCheckInRange=_vm._n($event.target.value)},_vm.checkCustomCheckInRangeMax],"change":_vm.checkCustomCheckInRangeMax,"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.customCheckInRangeMaxError)?_c('span',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.customCheckInRangeMaxError))]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่งที่ตั้ง:")]),_vm._v(" "),(_vm.cshLat === null)?_c('div',[_c('button',{staticClass:"btn m-btn--pill btn-info btn-block col-xl-2",attrs:{"type":"button"},on:{"click":_vm.getMap}},[_vm._v("\n                  ระบุข้อมูลตำแหน่งที่ตั้ง\n                ")])]):_c('div',[_c('GmapMap',{staticStyle:{"width":"500px","height":"300px"},attrs:{"center":{ lat: _vm.cshLat, lng: _vm.cshLng },"zoom":15,"clickable":true},on:{"click":_vm.updateCoordinates}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"draggable":true,"clickable":true},on:{"drag":_vm.updateCoordinates,"click":_vm.updateCoordinates}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.openMap()}}},[_c('i',{staticClass:"far fa-map"}),_vm._v(" Open GoogleMaps\n                  ")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button"},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("รูป\n              ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-img"}},_vm._l((_vm.FileUpload),function(image,index){return _c('div',{key:index,staticClass:"col-md-4 m--margin-top-20 img-wrap"},[(image.isLoaded !== false)?_c('img',{staticClass:"img-plant img-thumbnail card-img-top",attrs:{"src":image.urlImg},on:{"error":function($event){return _vm.handleImageError(image)},"load":function($event){return _vm.handleImageLoad(image)}}}):_c('div',{staticClass:"img-placeholder"},[_vm._v("ไม่สามารถโหลดรูปภาพได้")]),_vm._v(" "),_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn close",staticStyle:{"position":"absolute","top":"10px","right":"20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeImage(image.pictureId)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cssaInActiveStatus),expression:"cssaInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"cssaInActiveStatus","name":"cssaInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.cssaInActiveStatus)?_vm._i(_vm.cssaInActiveStatus,null)>-1:(_vm.cssaInActiveStatus)},on:{"change":function($event){var $$a=_vm.cssaInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cssaInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cssaInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cssaInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])]),_vm._v(" "),(this.$root.canShow(['']))?_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("[PM] ตั้งค่าใช้ PM (รูปแบบพิเศษ)")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cShIsSpecialPM),expression:"cShIsSpecialPM"}],staticClass:"form-check-input",attrs:{"id":"cShIsSpecialPM","name":"cShIsSpecialPM","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.cShIsSpecialPM)?_vm._i(_vm.cShIsSpecialPM,null)>-1:(_vm.cShIsSpecialPM)},on:{"change":function($event){var $$a=_vm.cShIsSpecialPM,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cShIsSpecialPM=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cShIsSpecialPM=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cShIsSpecialPM=$$c}}}}),_vm._v("\n                  เปิดใช้งาน PM (รูปแบบพิเศษ)\n                  "),_c('span')])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("รูปภาพ:"),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                  (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"SearchDetailModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสพนักงาน :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.auUserNO != null ? _vm.auUserNO : "-"))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อพนักงาน :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.auUserName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เบอร์โทร :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.auTel != null ? _vm.auTel : "-"))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.auEmail))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่ง :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.auPosition != null ? _vm.auPosition : "-"))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("บริษัท :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.auCompany != null ? _vm.auCompany : "-"))])])])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")])])}]


/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Collapsible"},[_c('button',{class:{
      Collapsible__trigger: true,
      'Collapsible__trigger--open': !_vm.transitioning && _vm.open,
      'Collapsible__trigger--closed': !_vm.transitioning && !_vm.open,
      'Collapsible__trigger--transitioning': _vm.transitioning,
    },on:{"click":_vm.handleClick}},[(_vm.open)?_vm._t("trigger",[_c('span',{staticClass:"Collapsible__triggerLabel"},[_vm._v("\n        "+_vm._s(!_vm.open ? _vm.closedLabel : _vm.openLabel)+"\n      ")])]):_vm._e(),_vm._v(" "),(!_vm.open)?_vm._t("closedTrigger",[_vm._t("trigger",[_c('span',{staticClass:"Collapsible__triggerLabel"},[_vm._v(_vm._s(!_vm.open ? _vm.closedLabel : _vm.openLabel))])])]):_vm._e()],2),_vm._v(" "),_c('div',{class:{
      Collapsible__content: true,
      'Collapsible__content--open': !_vm.transitioning && _vm.open,
      'Collapsible__content--closed': !_vm.transitioning && !_vm.open,
      'Collapsible__content--transitioning': _vm.transitioning,
    },style:({
      height: _vm.height,
      overflow: _vm.overflow,
      transitionProperty: 'height',
      transitionDuration: _vm.transitionDuration,
      transitionTimingFunction: _vm.transitionTimingFunction,
      transitionDelay: _vm.transitionDelay,
    }),on:{"transitionend":_vm.handleEnd}},[_c('div',{ref:"inner",staticClass:"Collapsible__contentInner"},[_vm._t("default")],2)])])}
var staticRenderFns = []


/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"userCreateModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อผู้ใช้งาน (UserName):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],staticClass:"form-control",attrs:{"id":"userName","name":"userName","type":"text","maxlength":"256","placeholder":"ชื่อผู้ใช้งาน (UserName)"},domProps:{"value":(_vm.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"id":"email","name":"email","type":"email","maxlength":"256","placeholder":"อีเมล"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("บทบาท:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.roleNameOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.roleName),callback:function ($$v) {_vm.roleName=$$v},expression:"roleName"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("โปรไฟล์บริษัท:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.usercCompanyProfilesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.usercCompanyProfiles),callback:function ($$v) {_vm.usercCompanyProfiles=$$v},expression:"usercCompanyProfiles"}}),_vm._v(" "),_c('br'),_vm._v("ไม่พบข้อมูลโปรไฟล์บริษัท? คลิกเพื่อสร้าง\n                      "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.showAgentProfileCreateForm}},[_vm._v("โปรไฟล์ตัวแทนฯ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสผ่าน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"id":"password","name":"password","type":"password","maxlength":"20","placeholder":"รหัสผ่าน"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-warning"},[_vm._v("ยืนยันรหัสผ่าน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"form-control",attrs:{"id":"confirmPassword","name":"confirmPassword","type":"password","maxlength":"20","placeholder":"ยืนยันรหัสผ่าน"},domProps:{"value":(_vm.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.givenName),expression:"givenName"}],staticClass:"form-control",attrs:{"id":"givenName","name":"givenName","type":"text","maxlength":"450","placeholder":"ชื่อ"},domProps:{"value":(_vm.givenName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.givenName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสกุล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.familyName),expression:"familyName"}],staticClass:"form-control",attrs:{"id":"familyName","name":"familyName","type":"text","maxlength":"450","placeholder":"ชื่อสกุล"},domProps:{"value":(_vm.familyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.familyName=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่ง:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.position),expression:"position"}],staticClass:"form-control",attrs:{"id":"position","name":"position","type":"text","maxlength":"450","placeholder":"ตำแหน่ง"},domProps:{"value":(_vm.position)},on:{"input":function($event){if($event.target.composing){ return; }_vm.position=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เบอร์ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phoneNumber),expression:"phoneNumber"}],staticClass:"form-control",attrs:{"id":"phoneNumber","name":"phoneNumber","type":"text","maxlength":"450","placeholder":"เบอร์ติดต่อ"},domProps:{"value":(_vm.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phoneNumber=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button"},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("รูป\n                      ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-img"}},[(_vm.FileUpload && _vm.FileUpload.isLoaded)?_c('div',{staticClass:"col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap",attrs:{"id":_vm.FileUpload.pictureId}},[_c('img',{staticClass:"img-plant -avatar js-avatar-me img-thumbnail card-img-top",attrs:{"src":_vm.FileUpload.urlImg},on:{"error":function($event){return _vm.handleImageError(_vm.FileUpload)},"load":function($event){return _vm.handleImageLoad(_vm.FileUpload)}}}),_vm._v(" "),_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","top":"10px","right":"20px"},attrs:{"href":"javascript:;"},on:{"click":_vm.removeImage}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inActiveStatus),expression:"inActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"inActiveStatus","id":"inActiveStatus"},domProps:{"checked":Array.isArray(_vm.inActiveStatus)?_vm._i(_vm.inActiveStatus,null)>-1:(_vm.inActiveStatus)},on:{"change":function($event){var $$a=_vm.inActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inActiveStatus=$$c}}}}),_vm._v("\n                          เปิดใช้งาน\n                          "),_c('span')])])])])]),_vm._v(" "),_c('user-sml-mapping',{attrs:{"selectedCompanyProfiles":_vm.selectedCompanyProfiles,"userSmlMappings":_vm.userSmlMappings},on:{"update:userSmlMappings":function($event){_vm.userSmlMappings=$event},"update:user-sml-mappings":function($event){_vm.userSmlMappings=$event}}})],1)])]),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('agent-profile-create-form',{ref:"agentProfileCreateForm"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("รูปลายเซ็นต์:\n                        "),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                          (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล")])])}]


/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อโปรไฟล์บริษัท:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cuuProfileName),expression:"cuuProfileName"}],staticClass:"form-control",attrs:{"id":"cuuProfileName","name":"cuuProfileName","type":"text","maxlength":"256","placeholder":"ชื่อโปรไฟล์บริษัท"},domProps:{"value":(_vm.cuuProfileName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cuuProfileName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทโปรไฟล์บริษัท:")]),_vm._v(" "),_c('select2',{ref:"cuuProfileTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'cuuProfileTypeCode',"name":'cuuProfileTypeCode',"select2-options":_vm.cuuProfileTypeCodeOptions},on:{"selectChange":_vm.cuuProfileTypeChange},model:{value:(_vm.cuuProfileTypeCode),callback:function ($$v) {_vm.cuuProfileTypeCode=$$v},expression:"cuuProfileTypeCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.onShowCompanySelect2()),expression:"onShowCompanySelect2()"}],staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("บริษัท:")]),_vm._v(" "),_c('select2',{ref:"cuuCompanyCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'cuuCompanyCode',"name":'cuuCompanyCode',"select2-options":_vm.cuuCompanyCodeOptions},model:{value:(_vm.cuuCompanyCode),callback:function ($$v) {_vm.cuuCompanyCode=$$v},expression:"cuuCompanyCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ShowAgentMappingSelect2),expression:"ShowAgentMappingSelect2"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_QI'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_QI'"}]},[_c('input',{attrs:{"type":"checkbox","name":"cuuIsAllAgent","id":"cuuIsAllAgent"},on:{"change":function($event){return _vm.SelectAllAgent($event)}}}),_vm._v(" เลือกทั้งหมด")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.cuuAgenCodeMappingOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก","required":""},model:{value:(_vm.cuuAgenCodeMapping),callback:function ($$v) {_vm.cuuAgenCodeMapping=$$v},expression:"cuuAgenCodeMapping"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ShowPhaseSelect2),expression:"ShowPhaseSelect2"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Phase:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.cuuPhaseOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก","required":""},model:{value:(_vm.cuuPhases),callback:function ($$v) {_vm.cuuPhases=$$v},expression:"cuuPhases"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_BR'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_BR'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูลสมาชิก")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(2),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MASTER_USER')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ใบงานตรวจสอบ STOCK")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(3),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('BR_MANAGE_AUDIT_STOCK')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("แสดงผล (Dashboard รายงาน STOCK ระบบเบียร์สด)*มองเห็นทุกตัวแทนจำหน่าย")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(4),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('BR_DASHBOARD_AUDIT_STOCK')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับทรัพย์สินใหม่")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETRIEVE_NEW_ITEM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ผลิตเบียร์สด")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_PRODUCE')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ทำลายทรัพย์สิน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_DESTROY')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("อนุมัติทำลายทรัพย์สิน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(11),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_APPROVER_DESTROY')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ส่งสินค้าไปยังตัวแทน ฯ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_TRANSFER_TO_AGENT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับสินค้า/ทรัพย์สิน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(14),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETRIEVE_ITEM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ส่งซ่อมภายในคลัง")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_REPAIR')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ส่งซ่อมซัพพลายเออร์")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_REPAIR_SUPPLIER')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับคืนจากซัพพลายเออร์")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETURN_SUPPLIER')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("แลกเปลี่ยนสินค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_EXCHANGE')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("เบิก/ยืม")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_BORROW')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("เบิก/ยืม (คลัง)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(25),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_BORROW_PLANT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("เบิก/ยืม (จัดการใบงาน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(26),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_BORROW_OPENJOB')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับคืนสินค้า/ทรัพย์สินจากลูกค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETURN_ADHOC')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ตรวจสอบใบ Hold")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(29),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_HOLD_CHECKER')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ใบงานตัดยอดคงค้าง")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(30),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_WRITE_OFF_STOCK_PLANT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูลรายงาน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(31),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('BR_REPORT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("Beer Claim (เจ้าหน้าที่ทรัพย์สินเบียร์สด BRT)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(32),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('DB_OFFICER_BEER_CLAIM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("Beer Claim (ผจก.ฝ่ายผลิต)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(33),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('ADMIN_PLANT_BEER_CLAIM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ใบงานตรวจสอบ STOCK")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(34),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_AUDIT_STOCK')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูลร้านค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(35),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_SHOP')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูลสมาชิกตัวแทน/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(36),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_SUB_AGENT_USER')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับสินค้า/ทรัพย์สิน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(37),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETRIEVE_ITEM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(38),_vm._v(" "),_vm._m(39),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_TRANSFER_TO_SHOP')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("หยิบสินค้าขึ้นรถ (เร่ขาย)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(40),_vm._v(" "),_vm._m(41),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_PICKUP')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("แลกเปลี่ยนสินค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(42),_vm._v(" "),_vm._m(43),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_EXCHANGE')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("เบิก/ยืม")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(44),_vm._v(" "),_vm._m(45),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_BORROW')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับคืนสินค้า/ทรัพย์สินจากลูกค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(46),_vm._v(" "),_vm._m(47),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETURN_ADHOC')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ใบงานตัดยอดคงค้าง")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(48),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_WRITE_OFF_STOCK')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูลรายงาน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(49),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('AGENT_REPORT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูลการเรียนรู้ (E-Learning)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(50),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('AGENT_E-Learning')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูล KPI")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(51),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_AGENT_KPI')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("งานล้างเครื่องเบียร์สด (จัดการใบงาน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(52),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_ADMIN_PM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("งานล้างเครื่องเบียร์สด  (ตัวแทน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(53),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('AGENT_ADMIN_PM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("งานล้างเครื่องเบียร์สด (ตัวแทนจำหน่ายย่อย) ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(54),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('SUB_AGENT_ADMIN_PM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("สร้างร้านค้าใหม่ (จัดการใบงาน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(55),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_NEW_SHOP')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("Beer Claim")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(56),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('AGENT_ADMIN_BEER_CLAIM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล BARCODE (ตัวแทน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(57),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_BARCODE_AGENT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("งานตรวจสอบคุณภาพเบียร์สด (จัดการใบงาน)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(58),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_QI')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_SUB_AGENT'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_SUB_AGENT'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูลร้านค้าตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(59),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_SHOP_SUB_AGENT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับสินค้า/ทรัพย์สิน")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(60),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETRIEVE_ITEM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(61),_vm._v(" "),_vm._m(62),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_TRANSFER_TO_SHOP')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("รับคืนสินค้า/ทรัพย์สินจากลูกค้า")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(63),_vm._v(" "),_vm._m(64),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_RETURN_ADHOC')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูลรายงาน (ตัวแทนจำหน่ายย่อย)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(65),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('SUB_AGENT_REPORT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล BARCODE (ตัวแทนจำหน่ายย่อย)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(66),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_BARCODE_SUB_AGENT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v(" งานล้างเครื่องเบียร์สด (ตัวแทนจำหน่ายย่อย)")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(67),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('SUB_AGENT_ADMIN_PM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ใบงานตัดยอดคงค้าง")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(68),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('JOB_TYPE_WRITE_OFF_STOCK_SUB_AGENT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_PM'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_PM'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_PM","name":"MANAGE_COMPANYPROFILE_PM","value":"ADMIN_PM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"USER_PM","name":"MANAGE_COMPANYPROFILE_PM","value":"USER_PM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      พนักงาน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"COOL_SERVICE_PM","name":"MANAGE_COMPANYPROFILE_PM","value":"COOL_SERVICE_PM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      Cooling\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_PM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_PM' && _vm.ShowRoleOptionUserAndCoolService ),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_PM' && ShowRoleOptionUserAndCoolService "}],staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการเข้าทำ PM  "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showPmExampleModal($event)}}},[_vm._m(69)]),_vm._v(" : ")]),_vm._v(" "),_vm._m(70),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"1440px"}},[_vm._m(71),_vm._v(" "),_c('tbody',[(_vm.odcitems == null || _vm.odcitems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.odcitems),function(item,i){return [_c('order-item-row',{key:item.ucode,ref:"pmRoleItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"9"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])])])])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_BEER_CLAIM'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_BEER_CLAIM'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"ADMIN_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"MANAGER_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"MANAGER_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้จัดการ\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"QI_OFFICER_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"QI_OFFICER_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เจ้าหน้าที่ทีม QC\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"PLANT_ACCOUNTANT_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"PLANT_ACCOUNTANT_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เจ้าหน้าที่บัญชีคลังสินค้า\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"LAB_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"LAB_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      LAB\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_PLANT_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"ADMIN_PLANT_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้จัดการฝ่ายผลิต\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"DB_OFFICER_BEER_CLAIM","name":"MANAGE_COMPANYPROFILE_BEER_CLAIM","value":"DB_OFFICER_BEER_CLAIM"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      เจ้าหน้าที่ทรัพย์สินเบียร์สด\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_BEER_CLAIM')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_QI'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_QI'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_QI","name":"MANAGE_COMPANYPROFILE_QI","value":"ADMIN_QI"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"MANAGER_QI","name":"MANAGE_COMPANYPROFILE_QI","value":"MANAGER_QI"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้จัดการ\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"USER_QI","name":"MANAGE_COMPANYPROFILE_QI","value":"USER_QI"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      พนักงาน\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_QI')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("ข้อมูล Dashboard")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(72),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioValQI()}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_MKT'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_MKT'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_MKT","name":"MANAGE_COMPANYPROFILE_MKT","value":"ADMIN_MKT"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"MANAGER_MKT","name":"MANAGE_COMPANYPROFILE_MKT","value":"MANAGER_MKT"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้จัดการ\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"USER_MKT","name":"MANAGE_COMPANYPROFILE_MKT","value":"USER_MKT"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      พนักงาน\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_MKT')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_5S'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_5S'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_5S","name":"MANAGE_COMPANYPROFILE_5S","value":"ADMIN_5S"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADVISOR_5S","name":"MANAGE_COMPANYPROFILE_5S","value":"ADVISOR_5S"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ที่ปรึกษา\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"TEAM_5S","name":"MANAGE_COMPANYPROFILE_5S","value":"TEAM_5S"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ทีมงาน\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_5S')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
              _vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING'
            ),expression:"\n              cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_EQUIPMENT_LEASING'\n            "}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"ADMIN_EQUIPMENT_LEASING","name":"MANAGE_COMPANYPROFILE_EQUIPMENT_LEASING","value":"ADMIN_EQUIPMENT_LEASING"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"USER_EQUIPMENT_LEASING","name":"MANAGE_COMPANYPROFILE_EQUIPMENT_LEASING","value":"USER_EQUIPMENT_LEASING"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      พนักงาน\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal(
                          'MANAGE_COMPANYPROFILE_EQUIPMENT_LEASING'
                        )}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_QIMAINTAIN'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_QIMAINTAIN'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"OFFICER_QIMAINTAIN","name":"MANAGE_COMPANYPROFILE_QIMAINTAIN","value":"OFFICER_QIMAINTAIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ธุรการช่างซ่อมบำรุง\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"OFFICER_PLANT_QIMAINTAIN","name":"MANAGE_COMPANYPROFILE_QIMAINTAIN","value":"OFFICER_PLANT_QIMAINTAIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ธุรการคลังเบียร์สด\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"QI_QIMAINTAIN","name":"MANAGE_COMPANYPROFILE_QIMAINTAIN","value":"QI_QIMAINTAIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ช่างซ่อมบำรุง\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"CHECKER_QIMAINTAIN","name":"MANAGE_COMPANYPROFILE_QIMAINTAIN","value":"CHECKER_QIMAINTAIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      Checker\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"LEAD_QIMAINTAIN","name":"MANAGE_COMPANYPROFILE_QIMAINTAIN","value":"LEAD_QIMAINTAIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      หัวหน้าช่างซ่อมบำรุง\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_QIMAINTAIN')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_BUDGET'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_BUDGET'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล Budget Approval")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"BUDGET_PLAN_USER","name":"MANAGE_COMPANYPROFILE_BUDGET","value":"BUDGET_PLAN_USER"},on:{"change":function($event){return _vm.OnBudgetPlanRoleChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"BUDGET_PLAN_REVIEWER","name":"MANAGE_COMPANYPROFILE_BUDGET","value":"BUDGET_PLAN_REVIEWER"},on:{"change":function($event){return _vm.OnBudgetPlanRoleChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ตรวจสอบ\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"BUDGET_PLAN_MANAGER","name":"MANAGE_COMPANYPROFILE_BUDGET","value":"BUDGET_PLAN_MANAGER"},on:{"change":function($event){return _vm.OnBudgetPlanRoleChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้จัดการฝ่าย\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_BUDGET')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT_SCORE'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT_SCORE'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูลคะแนนตัวแทนจำหน่าย")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_vm._m(73),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_AGENT_SCORE')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_SCVD'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_SCVD'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox"},[_vm._v("จัดการข้อมูล Stock Cover Days")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"SCVD_ADMIN","name":"MANAGE_COMPANYPROFILE_SCVD","value":"SCVD_ADMIN"},on:{"change":function($event){_vm.scvdRole = 'SCVD_ADMIN'}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"SCVD_VIEWER","name":"MANAGE_COMPANYPROFILE_SCVD","value":"SCVD_VIEWER"},on:{"change":function($event){_vm.scvdRole = 'SCVD_VIEWER'}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"SCVD_TEAM_EDIT","name":"MANAGE_COMPANYPROFILE_SCVD","value":"SCVD_TEAM_EDIT"},on:{"change":function($event){_vm.scvdRole = 'SCVD_TEAM_EDIT'}}}),_vm._v(" "),_c('span'),_vm._v("\n                      ทีมสร้าง/แก้ไขข้อมูลตามเป้าหมาย\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal('MANAGE_COMPANYPROFILE_SCVD')}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK'"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"kt-checkbox",attrs:{"data-test":"fss-profile-role-title"}},[_vm._v("เอกสารสรุปสินค้าคงค้าง")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"}),_vm._v(" "),_c('div',{staticClass:"col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"},[_c('div',{staticClass:"kt-radio-inline"},[_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"FORM_SUMMARY_STOCK_ADMIN","name":"MANAGE_COMPANYPROFILE_FORM_SUMMARY_STOCK","value":"FORM_SUMMARY_STOCK_ADMIN"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมินทีมเบียร์สด\n                    ")]),_vm._v(" "),_c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"FORM_SUMMARY_STOCK_AGENT","name":"MANAGE_COMPANYPROFILE_FORM_SUMMARY_STOCK","value":"FORM_SUMMARY_STOCK_AGENT"},on:{"change":function($event){return _vm.OnRadioBtnChange($event)}}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน (ตัวแทนจำหน่าย)\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"#","title":"reset"},on:{"click":function($event){$event.preventDefault();return _vm.onClearRadioVal(
                          'MANAGE_COMPANYPROFILE_FORM_SUMMARY_STOCK'
                        )}}},[_c('i',{staticClass:"fa fa-times-circle"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ShowBudgetOrgSelect2),expression:"ShowBudgetOrgSelect2"}],staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("แผนก:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":'cuuBudgetOrgIds',"name":'cuuBudgetOrgIds',"multiple":true,"options":_vm.cuuBudgetOrgOptions,"clear-on-select":true,"placeholder":"กรุณาเลือกแผนก","required":""},model:{value:(_vm.cuuBudgetOrgIds),callback:function ($$v) {_vm.cuuBudgetOrgIds=$$v},expression:"cuuBudgetOrgIds"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cuuInActiveStatus),expression:"cuuInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"cuuInActiveStatus","id":"cuuInActiveStatus"},domProps:{"checked":Array.isArray(_vm.cuuInActiveStatus)?_vm._i(_vm.cuuInActiveStatus,null)>-1:(_vm.cuuInActiveStatus)},on:{"change":function($event){var $$a=_vm.cuuInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cuuInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cuuInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cuuInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน  \n                  "),_c('span')])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ShowEmailAlertPM == true),expression:"ShowEmailAlertPM == true"}],staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email Alert PM:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.EmailAlertPM),expression:"EmailAlertPM"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"EmailAlertPM","id":"EmailAlertPM"},domProps:{"checked":Array.isArray(_vm.EmailAlertPM)?_vm._i(_vm.EmailAlertPM,null)>-1:(_vm.EmailAlertPM)},on:{"change":function($event){var $$a=_vm.EmailAlertPM,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.EmailAlertPM=$$a.concat([$$v]))}else{$$i>-1&&(_vm.EmailAlertPM=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.EmailAlertPM=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT'),expression:"cuuProfileTypeCode == 'COMPANY_PROFILE_TYPE_AGENT'"}],staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แจ้งเตือนคงค้างเกินกำหนดเวลา (Website) :")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.EmailWebAlertOverdue),expression:"EmailWebAlertOverdue"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"EmailWebAlertOverdue","id":"EmailWebAlertOverdue"},domProps:{"checked":Array.isArray(_vm.EmailWebAlertOverdue)?_vm._i(_vm.EmailWebAlertOverdue,null)>-1:(_vm.EmailWebAlertOverdue)},on:{"change":function($event){var $$a=_vm.EmailWebAlertOverdue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.EmailWebAlertOverdue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.EmailWebAlertOverdue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.EmailWebAlertOverdue=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(74)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("บทบาท:")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brMASTER_USER","name":"MASTER_USER","value":"MASTER_USER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brBR_MANAGE_AUDIT_STOCK","name":"BR_MANAGE_AUDIT_STOCK","value":"BR_MANAGE_AUDIT_STOCK"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brBR_DASHBOARD_AUDIT_STOCK","name":"BR_DASHBOARD_AUDIT_STOCK","value":"BR_DASHBOARD_AUDIT_STOCK"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_IMPORT_NEW_ASSETS","name":"JOB_TYPE_RETRIEVE_NEW_ITEM","value":"JOB_ADMIN_IMPORT_NEW_ASSETS"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_IMPORT_NEW_ASSETS","name":"JOB_TYPE_RETRIEVE_NEW_ITEM","value":"JOB_IMPORT_NEW_ASSETS"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_PRODUCE","name":"JOB_TYPE_PRODUCE","value":"JOB_ADMIN_PRODUCE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_PRODUCE","name":"JOB_TYPE_PRODUCE","value":"JOB_PRODUCE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_DESTROY","name":"JOB_TYPE_DESTROY","value":"JOB_ADMIN_DESTROY"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_DESTROY","name":"JOB_TYPE_DESTROY","value":"JOB_DESTROY"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_APPROVER_DESTROY","name":"JOB_APPROVER_DESTROY","value":"JOB_APPROVER_DESTROY"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้อนุมัติ\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_TRANSFER_TO_AGENT","name":"JOB_TYPE_TRANSFER_TO_AGENT","value":"JOB_ADMIN_TRANSFER_TO_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_TRANSFER_TO_AGENT","name":"JOB_TYPE_TRANSFER_TO_AGENT","value":"JOB_TRANSFER_TO_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_RETRIEVE_ITEM","name":"JOB_TYPE_RETRIEVE_ITEM","value":"JOB_RETRIEVE_ITEM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_REPAIR","name":"JOB_TYPE_REPAIR","value":"JOB_ADMIN_REPAIR"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_REPAIR","name":"JOB_TYPE_REPAIR","value":"JOB_REPAIR"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_REPAIR_SUPPLIER","name":"JOB_TYPE_REPAIR_SUPPLIER","value":"JOB_ADMIN_REPAIR_SUPPLIER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_REPAIR_SUPPLIER","name":"JOB_TYPE_REPAIR_SUPPLIER","value":"JOB_REPAIR_SUPPLIER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_RETURN_SUPPLIER","name":"JOB_TYPE_RETURN_SUPPLIER","value":"JOB_ADMIN_RETURN_SUPPLIER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_RETURN_SUPPLIER","name":"JOB_TYPE_RETURN_SUPPLIER","value":"JOB_RETURN_SUPPLIER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_EXCHANGE","name":"JOB_TYPE_EXCHANGE","value":"JOB_ADMIN_EXCHANGE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_EXCHANGE","name":"JOB_TYPE_EXCHANGE","value":"JOB_EXCHANGE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_BORROW","name":"JOB_TYPE_BORROW","value":"JOB_ADMIN_BORROW"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_BORROW","name":"JOB_TYPE_BORROW","value":"JOB_BORROW"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_BORROW_PLANT","name":"JOB_TYPE_BORROW_PLANT","value":"JOB_ADMIN_BORROW_PLANT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_BORROW_OPENJOB","name":"JOB_TYPE_BORROW_OPENJOB","value":"JOB_ADMIN_BORROW_OPENJOB"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_ADMIN_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_HOLD_CHECKER","name":"JOB_TYPE_HOLD_CHECKER","value":"JOB_ADMIN_HOLD_CHECKER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brJOB_ADMIN_WRITE_OFF_STOCK_PLANT","name":"JOB_TYPE_WRITE_OFF_STOCK_PLANT","value":"JOB_ADMIN_WRITE_OFF_STOCK_PLANT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brBR_REPORT","name":"BR_REPORT","value":"BR_REPORT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brDB_OFFICER_BEER_CLAIM","name":"DB_OFFICER_BEER_CLAIM","value":"DB_OFFICER_BEER_CLAIM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"brADMIN_PLANT_BEER_CLAIM","name":"ADMIN_PLANT_BEER_CLAIM","value":"ADMIN_PLANT_BEER_CLAIM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aMANAGE_AUDIT_STOCK","name":"MANAGE_AUDIT_STOCK","value":"MANAGE_AUDIT_STOCK"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aMANAGE_SHOP","name":"MANAGE_SHOP","value":"MANAGE_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aMANAGE_SUB_AGENT_USER","name":"MANAGE_SUB_AGENT_USER","value":"MANAGE_SUB_AGENT_USER"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_RETRIEVE_ITEM","name":"JOB_TYPE_RETRIEVE_ITEM","value":"JOB_RETRIEVE_ITEM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_TRANSFER_TO_SHOP","name":"JOB_TYPE_TRANSFER_TO_SHOP","value":"JOB_ADMIN_TRANSFER_TO_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_TRANSFER_TO_SHOP","name":"JOB_TYPE_TRANSFER_TO_SHOP","value":"JOB_TRANSFER_TO_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_PICKUP","name":"JOB_TYPE_PICKUP","value":"JOB_ADMIN_PICKUP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_PICKUP","name":"JOB_TYPE_PICKUP","value":"JOB_PICKUP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_EXCHANGE","name":"JOB_TYPE_EXCHANGE","value":"JOB_ADMIN_EXCHANGE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_EXCHANGE","name":"JOB_TYPE_EXCHANGE","value":"JOB_EXCHANGE"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_BORROW","name":"JOB_TYPE_BORROW","value":"JOB_ADMIN_BORROW"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_BORROW","name":"JOB_TYPE_BORROW","value":"JOB_BORROW"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_ADMIN_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_WRITE_OFF_STOCK_AGENT","name":"JOB_TYPE_WRITE_OFF_STOCK","value":"JOB_ADMIN_WRITE_OFF_STOCK_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aAGENT_REPORT","name":"AGENT_REPORT","value":"AGENT_REPORT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aAGENT_E-Learning","name":"AGENT_E-Learning","value":"AGENT_E-Learning"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_AGENT_KPI","name":"JOB_AGENT_KPI","value":"JOB_AGENT_KPI"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_PM","name":"JOB_ADMIN_PM","value":"JOB_ADMIN_PM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aAGENT_ADMIN_PM","name":"AGENT_ADMIN_PM","value":"AGENT_ADMIN_PM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aSUB_AGENT_ADMIN_PM","name":"SUB_AGENT_ADMIN_PM","value":"SUB_AGENT_ADMIN_PM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aADMIN_NEW_SHOP","name":"JOB_TYPE_NEW_SHOP","value":"ADMIN_NEW_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aAGENT_ADMIN_BEER_CLAIM","name":"AGENT_ADMIN_BEER_CLAIM","value":"AGENT_ADMIN_BEER_CLAIM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aMANAGE_BARCODE_AGENT","name":"MANAGE_BARCODE_AGENT","value":"MANAGE_BARCODE_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"aJOB_ADMIN_QI","name":"JOB_TYPE_QI","value":"JOB_ADMIN_QI"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sMANAGE_SHOP_SUB_AGENT","name":"MANAGE_SHOP_SUB_AGENT","value":"MANAGE_SHOP_SUB_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_RETRIEVE_ITEM","name":"JOB_TYPE_RETRIEVE_ITEM","value":"JOB_RETRIEVE_ITEM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_ADMIN_TRANSFER_TO_SHOP","name":"JOB_TYPE_TRANSFER_TO_SHOP","value":"JOB_ADMIN_TRANSFER_TO_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_TRANSFER_TO_SHOP","name":"JOB_TYPE_TRANSFER_TO_SHOP","value":"JOB_TRANSFER_TO_SHOP"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_ADMIN_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_ADMIN_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_RETURN","name":"JOB_TYPE_RETURN_ADHOC","value":"JOB_RETURN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sSUB_AGENT_REPORT","name":"SUB_AGENT_REPORT","value":"SUB_AGENT_REPORT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sMANAGE_BARCODE_SUB_AGENT","name":"MANAGE_BARCODE_SUB_AGENT","value":"MANAGE_BARCODE_SUB_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sSUB_AGENT_ADMIN_PM","name":"SUB_AGENT_ADMIN_PM","value":"SUB_AGENT_ADMIN_PM"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"sJOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT","name":"JOB_TYPE_WRITE_OFF_STOCK_SUB_AGENT","value":"JOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u',[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" กดเพื่อดูตัวอย่างการตั้งค่า")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"pmExampleModal","tabindex":"-1","role":"dialog","aria-labelledby":"pmExampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"pmExampleModalLabel"}},[_vm._v("\n                    ตัวอย่างการตั้งค่า\n                  ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body text-center"},[_c('img',{staticClass:"img-fluid",staticStyle:{"max-width":"100%"},attrs:{"src":"/images/company-profile-pm-example.jpg","alt":"ตัวอย่างการตั้งค่า"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"80px"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"350px"}},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"350px"}},[_vm._v("บทบาท")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"USER_DASHBOARD","name":"USER_DASHBOARD","value":"USER_DASHBOARD"}}),_vm._v(" "),_c('span'),_vm._v("\n                      ผู้ใช้งาน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"kt-radio"},[_c('input',{attrs:{"type":"radio","id":"AGENT_SCORE_ADMIN","name":"MANAGE_COMPANYPROFILE_AGENT_SCORE","value":"AGENT_SCORE_ADMIN"}}),_vm._v(" "),_c('span'),_vm._v("\n                      แอดมิน\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/MaintainReport/Checker'),expression:"$route.path == '/MaintainReport/Checker'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับเข้าคลังดี(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateStart","name":"jobsDateStart","readonly":""}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่รับเข้าคลังดี(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateEnd","name":"jobsDateEnd","readonly":""}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qiOldBarcode),expression:"qiOldBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"BARCODE"},domProps:{"value":(_vm.qiOldBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qiOldBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่ใบงาน :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qiJobNumber),expression:"qiJobNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"เลขที่ใบงาน"},domProps:{"value":(_vm.qiJobNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qiJobNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่ซ่อมเสร็จ(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"finishedDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"finishedDateStart","name":"finishedDateStart","readonly":""}}),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ซ่อมเสร็จ(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"finishedDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"finishedDateEnd","name":"finishedDateEnd","readonly":""}}),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductCode","multiple":true,"options":_vm.qiProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductCode),callback:function ($$v) {_vm.qiProductCode=$$v},expression:"qiProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductType","multiple":true,"options":_vm.qiProductTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductType),callback:function ($$v) {_vm.qiProductType=$$v},expression:"qiProductType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อช่าง:")]),_vm._v(" "),_c('treeselect',{ref:"qiUserId",attrs:{"multiple":true,"load-options":_vm.LoadUsersIdOptions,"async":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadUsersIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.qiUserId),callback:function ($$v) {_vm.qiUserId=$$v},expression:"qiUserId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("สถานะการรับเข้าคลังดี:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"checkerStatus","multiple":true,"options":_vm.qiCheckerStatusOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.checkerStatus),callback:function ($$v) {_vm.checkerStatus=$$v},expression:"checkerStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),(this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','CHECKER_QIMAINTAIN','LEAD_QIMAINTAIN']))?_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.exportExcel}},[_vm._m(5)])]):_vm._e()])]),_vm._v(" "),_vm._m(6)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"width":"100%"},attrs:{"id":"reportTable"}},[_c('thead',[_c('tr',[_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("วันที่ส่งมอบหลังซ่อม"),_c('br'),_vm._v("(รับเข้าคลังดี ว/ด/ป)")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("Month")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("Year")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("จำนวน")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("BARCODE")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("ชื่อช่าง")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("รับประกันการซ่อม ว/ด/ป")]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v("วันที่ซ่อมเสร็จ ว/ด/ป")])])])])])])}]


/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เลขที่เอกสาร:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.ubpDocNo))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ขอเบิก/ยืม:")]),_vm._v(" "),_c('select2',{ref:"ubpBorrowerSelect2",attrs:{"disabled":!_vm.ubpIsEdit,"css-style":'width: 100%;',"css-class":'form-control required',"id":'ubpBorrower',"name":'ubpBorrower',"select2-options":_vm.ubpBorrowerOptions,"data-msg-required":"กรุณาเลือกผู้ขอเบิก/ยืม"},on:{"selectChange":_vm.ubpBorrowerChange},model:{value:(_vm.ubpBorrower),callback:function ($$v) {_vm.ubpBorrower=$$v},expression:"ubpBorrower"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย/หน่วยงาน:")]),_vm._v(" "),_c('select2',{ref:"ubpAgentSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"disabled":!_vm.ubpIsEdit,"id":'ubpAgentCode',"name":'ubpAgentCode',"select2-options":_vm.ubpAgentOptions},on:{"selectChange":_vm.onAgentCodeChange},model:{value:(_vm.ubpAgentCode),callback:function ($$v) {_vm.ubpAgentCode=$$v},expression:"ubpAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้รับสินค้าแทน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpRepresentName),expression:"ubpRepresentName"}],staticClass:"form-control",attrs:{"disabled":!_vm.ubpIsEdit,"id":"ubpRepresentName","name":"ubpRepresentName","type":"text","maxlength":"450"},domProps:{"value":(_vm.ubpRepresentName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ubpRepresentName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทรผู้รับสินค้าแทน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpRepresentTel),expression:"ubpRepresentTel"}],staticClass:"form-control",attrs:{"disabled":!_vm.ubpIsEdit,"id":"ubpRepresentTel","name":"ubpRepresentTel","type":"text","maxlength":"450","placeholder":"เบอร์โทรผู้รับสินค้าแทน"},domProps:{"value":(_vm.ubpRepresentTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ubpRepresentTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่เอกสาร :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"ubpReqDate",staticClass:"form-control",attrs:{"disabled":"true","type":"text","placeholder":"วันที่เอกสาร. (วว/ดด/ปปปป)","id":"ubpReqDate","name":"ubpReqDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-3 col-form-label label-required"},[_vm._v("ประเภทใบคำร้องขอ:")]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"kt-checkbox-inline"},_vm._l((_vm.ubpRequestTypeOptions),function(ubpRequestTypeOption,ubp){return _c('label',{key:ubp,staticClass:"kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpRequestType),expression:"ubpRequestType"}],attrs:{"type":"checkbox","id":ubpRequestTypeOption.id,"checked":"","disabled":true},domProps:{"value":ubpRequestTypeOption.id,"checked":Array.isArray(_vm.ubpRequestType)?_vm._i(_vm.ubpRequestType,ubpRequestTypeOption.id)>-1:(_vm.ubpRequestType)},on:{"change":function($event){var $$a=_vm.ubpRequestType,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=ubpRequestTypeOption.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ubpRequestType=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ubpRequestType=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ubpRequestType=$$c}}}}),_vm._v("\n                      "+_vm._s(ubpRequestTypeOption.text)+"\n                      "),_c('span')])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-3 col-form-label label-required"},[_vm._v("หมวดหมู่สินค้า:")]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"kt-radio-inline"},_vm._l((_vm.ubpProductGroupOptions),function(ubpProductGroupOption,index){return _c('label',{key:index,staticClass:"kt-radio rea"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpProductGroup),expression:"ubpProductGroup"}],attrs:{"type":"radio","id":ubpProductGroupOption.id,"disabled":true},domProps:{"value":ubpProductGroupOption.id,"checked":_vm._q(_vm.ubpProductGroup,ubpProductGroupOption.id)},on:{"change":[function($event){_vm.ubpProductGroup=ubpProductGroupOption.id},function($event){return _vm.onProductGroupChange($event)}]}}),_vm._v("\n                      "+_vm._s(ubpProductGroupOption.text)+"\n                      "),_c('span')])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 table-responsive table-checkable",attrs:{"id":"Activity"}},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover",staticStyle:{"min-width":"2250px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"1%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"6%"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"8%"}},[_vm._v("\n                      ประเภทสินค้า\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"13%"}},[_vm._v("\n                      ชื่อสินค้า\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"6%"}},[_vm._v("\n                      รูปภาพ\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"6%"}},[_vm._v("\n                      โควต้า(แบรนด์)\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"5%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("\n                      ตัวแทนจำหน่าย\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"18%"}},[_vm._v("\n                      ชื่อร้านค้า/กิจกรรม\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%"}},[_vm._v("\n                        หมายเหตุกิจกรรม\n                        "),_c('i',{staticClass:"far fa-copy",staticStyle:{"cursor":"pointer","margin-left":"5px","transform":"scaleX(-1)","color":"#5867dd"},attrs:{"title":"คัดลอกข้อความ \"หมายเหตุกิจกรรม\" ของแถวที่1"},on:{"click":_vm.copyNote}})]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"160px !important"}},[_vm._v("\n                      วันที่กำหนดคืน\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"2%"}},[_vm._v("การจัดการ")])])]),_vm._v(" "),_c('tbody',[(_vm.plItems == null || _vm.plItems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"12"}},[_vm._v("\n                      คลิก + เพื่อเพิ่มรายการใหม่\n                    ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.plItems),function(item,i){return [_c('pl-item-row',{key:i,ref:"plItems",refInFor:true,attrs:{"rowIndex":i,"item":item,"isEditable":_vm.ubpIsEdit},on:{"removeItem":function($event){return _vm.onRemoveItemClick(i, item)}}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticStyle:{"text-align":"right"},attrs:{"colspan":"5"}},[_vm._v("\n                      จำนวนรวมมูลค่าการเบิกยืม (บาท)\n                    ")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("\n                      "+_vm._s(_vm._f("currency")(_vm.totalCal,"฿", 2))+"\n                    ")])]),_vm._v(" "),(_vm.ubpIsEdit)?_c('tr',[_c('td',{attrs:{"colspan":"12"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                      ")])])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมายเหตุ:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.ubpRemark),expression:"ubpRemark"}],staticClass:"form-control",attrs:{"disabled":!_vm.ubpIsEdit,"placeholder":"หมายเหตุ","rows":"5"},domProps:{"value":(_vm.ubpRemark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ubpRemark=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),(_vm.ubpStatusCode !== 'PRODUCT_LOAN_STATUS_SAVED')?_c('div',{staticClass:"row"},[_vm._m(2)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),(_vm.ubpIsEdit)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")]):_vm._e(),_vm._v(" "),(_vm.ubpStatusCode === 'PRODUCT_LOAN_STATUS_SAVED')?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.onSendForApprove()}}},[_c('i',{staticClass:"flaticon-paper-plane-1"}),_vm._v(" ส่งขออนุมัติ\n        ")]):_vm._e()])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('h4',{staticClass:"kt-section__title"},[_vm._v("ประวัติการอนุมัติ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"table-history"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("วันที่")]),_vm._v(" "),_c('th',[_vm._v("ผู้อนุมัติ")]),_vm._v(" "),_c('th',[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',[_vm._v("สถานะ")]),_vm._v(" "),_c('th',[_vm._v("หมายเหตุ")])])])])])])])}]


/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทสินค้าถือครอง:")]),_vm._v(" "),_c('select2',{ref:"hocProductTypeIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'hocProductTypeId',"name":'hocProductTypeId',"select2-options":_vm.hocProductTypeIdOptions},model:{value:(_vm.hocProductTypeId),callback:function ($$v) {_vm.hocProductTypeId=$$v},expression:"hocProductTypeId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ระยะเวลาการถือครอง (วัน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hocHolderTime),expression:"hocHolderTime"}],staticClass:"form-control",attrs:{"id":"hocHolderTime","name":"hocHolderTime","type":"number","min":"1","maxlength":"450","placeholder":"ระยะเวลาการถือครอง"},domProps:{"value":(_vm.hocHolderTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hocHolderTime=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"hocAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'hocAgentCode',"name":'hocAgentCode',"select2-options":_vm.hocAgentCodeOptions},on:{"selectChange":_vm.onHocAgentCodeChange},model:{value:(_vm.hocAgentCode),callback:function ($$v) {_vm.hocAgentCode=$$v},expression:"hocAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"hocShopTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'hocShopTypeCode',"name":'hocShopTypeCode',"select2-options":_vm.hocShopTypeCodeOptions},model:{value:(_vm.hocShopTypeCode),callback:function ($$v) {_vm.hocShopTypeCode=$$v},expression:"hocShopTypeCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('select2',{ref:"hocProductBrandIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'hocProductBrandId',"name":'hocProductBrandId',"select2-options":_vm.hocProductBrandIdOptions},model:{value:(_vm.hocProductBrandId),callback:function ($$v) {_vm.hocProductBrandId=$$v},expression:"hocProductBrandId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hocInActiveStatus),expression:"hocInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"hocInActiveStatus","id":"hocInActiveStatus"},domProps:{"checked":Array.isArray(_vm.hocInActiveStatus)?_vm._i(_vm.hocInActiveStatus,null)>-1:(_vm.hocInActiveStatus)},on:{"change":function($event){var $$a=_vm.hocInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.hocInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.hocInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.hocInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Marketing/MarketingList'),expression:"$route.path == '/Marketing/MarketingList'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keySearch),expression:"keySearch"}],staticClass:"form-control",attrs:{"id":"keySearch","name":"keySearch","type":"text","placeholder":"ค้นหาจากชื่อกิจกรรม หรือชื่อร้านค้า"},domProps:{"value":(_vm.keySearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keySearch=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทกิจกรรม :")]),_vm._v(" "),_c('select2',{ref:"objectivesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'objectives',"name":'objectives',"select2-options":_vm.objectivesOptions},model:{value:(_vm.objectives),callback:function ($$v) {_vm.objectives=$$v},expression:"objectives"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"mktStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'mktStatus',"name":'mktStatus',"select2-options":_vm.mktStatusOptions},model:{value:(_vm.mktStatus),callback:function ($$v) {_vm.mktStatus=$$v},expression:"mktStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-poll"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"marketingTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("ประเภทกิจกรรม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อกิจกรรม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ตัวเทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่เริ่มต้น")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่สิ้นสุด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่สร้าง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จัดการ")])])])])])])}]


/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Maintain/Recv'),expression:"$route.path == '/Maintain/Recv'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ค้นหาเลขที่ใบงาน/เลขที่ใบเบิกสินค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qiKeyword),expression:"qiKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก เลขที่ใบงาน"},domProps:{"value":(_vm.qiKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qiKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่สร้าง(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateStart","name":"jobsDateStart","readonly":""}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สร้าง(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateEnd","name":"jobsDateEnd","readonly":""}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่ออะไหล่:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductCode","multiple":true,"options":_vm.qiProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductCode),callback:function ($$v) {_vm.qiProductCode=$$v},expression:"qiProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('treeselect',{ref:"qiUserId",attrs:{"multiple":true,"load-options":_vm.LoadUsersIdOptions,"async":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadUsersIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.qiUserId),callback:function ($$v) {_vm.qiUserId=$$v},expression:"qiUserId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShow('OFFICER_QIMAINTAIN'))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"Recv/Add","tag":"button","title":"เพิ่มการรับเข้าอะไหล่"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูลรับเข้าอะไหล่\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(3)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fas fa-wrench"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("ค้นหาการรับเข้าอะไหล่")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"width":"100%"},attrs:{"id":"qiRecvTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เลขที่ใบเบิกสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่ออะไหล่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะการดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่สร้าง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้ดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("คำสั่ง")])])])])])])}]


/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Maintain/QIJob'),expression:"$route.path == '/Maintain/QIJob'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ค้นหาเลขที่ใบงาน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qiKeyword),expression:"qiKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก เลขที่ใบงาน"},domProps:{"value":(_vm.qiKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qiKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่สร้าง(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateStart","name":"jobsDateStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สร้าง(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateEnd","name":"jobsDateEnd"}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะใบงาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.qiStatusCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiStatusCode),callback:function ($$v) {_vm.qiStatusCode=$$v},expression:"qiStatusCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทใบงาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.qiTypeCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiTypeCode),callback:function ($$v) {_vm.qiTypeCode=$$v},expression:"qiTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อช่าง:")]),_vm._v(" "),_c('treeselect',{ref:"qiUserId",attrs:{"multiple":true,"load-options":_vm.LoadUsersIdOptions,"async":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadUsersIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.qiUserId),callback:function ($$v) {_vm.qiUserId=$$v},expression:"qiUserId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qiOldBarcode),expression:"qiOldBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"BARCODE"},domProps:{"value":(_vm.qiOldBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qiOldBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductCode","multiple":true,"options":_vm.qiProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductCode),callback:function ($$v) {_vm.qiProductCode=$$v},expression:"qiProductCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                      ล้างค่าทั้งหมด\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.exportExcel}},[_vm._m(3)])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{ref:"barcodesModal",staticClass:"modal fade",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('table',{ref:"barcodeLocalTable",staticClass:"table-sm table-striped table-bordered table-hover"},[_vm._m(6)])])])])])])])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fas fa-wrench"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("ค้นหาใบงานช่างซ่อม")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"width":"100%"},attrs:{"id":"qiJobsTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อสินค้า/อุปกรณ์")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะการดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่สร้าง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อช่าง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ผู้ตรวจสอบยืนยัน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("คำสั่ง")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("รายการ BARCODE")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("BARCODE")])])])}]


/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ Check-in :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.checkInDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่ Check-out :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.checkOutDate || ''))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้ Check-in :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.checkInByUserFullName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ร้านค้า :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.shopName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ร้านค้า 2 :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.shopName2))])])])]),_vm._v(" "),_vm._l((_vm.barcodeShopMappings),function(b,i){return _c('div',{key:i,staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 text-left"},[(!b.isDelete)?_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                "+_vm._s(b.groupName)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1,true),_vm._v(" "),_c('tbody',_vm._l((b.barcodeSets),function(row,j){return _c('tr',{key:j},[_c('td',{staticClass:"stock-item-td text-center"},[_vm._v("\n                        "+_vm._s(row.productName)+"\n                      ")]),_vm._v(" "),(
                          row.barcodeNoOld == null
                        )?_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(row.barcodeNo)+"\n                      ")]):_vm._e(),_vm._v(" "),(
                          row.barcodeNoOld != null
                        )?_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(row.barcodeNoOld)+"\n                      ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[(row.fileUrl != null && !row.isImgCloud)?_c('a',{attrs:{"href":"#","title":"รูปภาพ"},on:{"click":function($event){$event.preventDefault();return _vm.pictureModal(row.fileUrl)}}},[_vm._v("Link  ")]):_vm._e(),_vm._v(" "),(row.fileUrl != null && row.isImgCloud)?_c('a',{attrs:{"href":"javascript:void(0);","title":"รูปภาพ"},on:{"click":function($event){return _vm.showModal(row.fileUrl)}}},[_vm._v("Link ")]):_vm._e()])])}),0)])])])])])}),_vm._v(" "),_vm._l((_vm.barcodeShopMappingsOther),function(b,i){return _c('div',{key:i,staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 text-left"},[(!b.isDelete)?_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                "+_vm._s(b.groupName)+"\n              ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(2,true),_vm._v(" "),_c('tbody',_vm._l((b.barcodeSets),function(row,j){return _c('tr',{key:j},[(
                          row.barcodeNoOld == null
                        )?_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(row.barcodeNo)+"\n                      ")]):_vm._e(),_vm._v(" "),(
                          row.barcodeNoOld != null
                        )?_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(row.barcodeNoOld)+"\n                      ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[(row.fileUrl != null && !row.isImgCloud)?_c('a',{attrs:{"href":"#","title":"รูปภาพ"},on:{"click":function($event){$event.preventDefault();return _vm.pictureModal(row.fileUrl)}}},[_vm._v("Link  ")]):_vm._e(),_vm._v(" "),(row.fileUrl != null && row.isImgCloud)?_c('a',{attrs:{"href":"javascript:void(0);","title":"รูปภาพ"},on:{"click":function($event){return _vm.showModal(row.fileUrl)}}},[_vm._v("Link ")]):_vm._e()])])}),0)])])])])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 text-left"},[(_vm.barcodeBrands!=null && _vm.barcodeBrands.length > 0)?_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                แบรนด์ \n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 text-right"},[(_vm.isPM)?_c('button',{staticClass:"btn btn-outline-brand",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.detailPM(_vm.checkInId,_vm.pmSurveyCheckInId)}}},[_c('i',{staticClass:"la la-file-text"}),_vm._v(" รายละเอียด PM\n              ")]):_vm._e()])]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable w-50"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.barcodeBrands),function(br,k){return _c('tr',{key:k},[_c('td',{staticClass:"stock-item-td text-center"},[_vm._v("\n                        "+_vm._s(br.brandName)+"  \n                      ")])])}),0)])],2)]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"imageModal","tabindex":"-1","role":"dialog","aria-labelledby":"imageModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("ภาพถ่าย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticClass:"img-thumbnail mb-3",staticStyle:{"height":"auto","width":"auto"},attrs:{"src":_vm.modalImageURL}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("ชื่อ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("BARCODE ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("รูปภาพ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"80%"}},[_vm._v("BARCODE ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("รูปภาพ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("ชื่อ")])])])}]


/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อหมวดหมู่ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.delFolderName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผู้สร้าง :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.delCreateBy))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ลำดับหมวดหมู่ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"}),_vm._v(" "),_vm._l((_vm.delParentLink),function(item){return [(item.folderElearningId != _vm.id)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.GotoParent(item.folderElearningId)}}},[_vm._v(_vm._s(item.folderName)+" >\n                ")]):_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.GotoParent(item.folderElearningId)}}},[_vm._v(_vm._s(item.folderName))])]})],2)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สร้าง :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.delCreateDate))])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.delStatus),expression:"delStatus"}],staticClass:"form-check-input",attrs:{"id":"buStatus","name":"buStatus","type":"checkbox","disabled":""},domProps:{"checked":Array.isArray(_vm.delStatus)?_vm._i(_vm.delStatus,null)>-1:(_vm.delStatus)},on:{"change":function($event){var $$a=_vm.delStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.delStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.delStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.delStatus=$$c}}}}),_vm._v("\n                เปิดใช้งาน\n                "),_c('span')])])])]),_vm._v(" "),(this.$root.canShow(['ADMIN_5S', 'MANAGER_5S']))?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ไฟล์:")]),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button","id":"uploader-order","data-ref":_vm.uuid}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("เลือกไฟล์\n              ")]),_vm._v(" "),(_vm.IsShowUploadBtn)?_c('button',{staticClass:"btn btn-success m-btn--pill btn-block col-xl-2",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.UploadFile($event)}}},[_c('i',{staticClass:"fas fa-cloud-upload-alt"}),_vm._v("อัพโหลดไฟล์\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-file"}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-12 text-right"},[(
                this.$root.canShow(['ADMIN_5S', 'MANAGER_5S']) &&
                  _vm.delFolderLevel < 5
              )?_c('button',{staticClass:"btn btn-outline-info",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.AddSub($event)}}},[_c('i',{staticClass:"fa fa-folder-plus"}),_vm._v("เพิ่มหมวดหมู่ย่อย\n            ")]):_vm._e()])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){$event.preventDefault();return _vm.Goback($event)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการ:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"folderDetilsTable","refs":"folderDetilsTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"20%"}},[_vm._v("ชื่อ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("วันที่บันทึกล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("จำนวนการเข้าดู")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("การจัดการ")])])])])])])])])}]


/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อผู้ใช้งาน ชื่อบัญชี อีเมล เบอร์โทรศัพท์"},domProps:{"value":(_vm.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("โปรไฟล์บริษัท:")]),_vm._v(" "),_c('select',{ref:"companyProfileId",staticClass:"form-control m-select2",staticStyle:{"width":"100%"}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("ล้างค่าทั้งหมด")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(this.$root.canShowExSuperAdmin('MANAGE_SUB_AGENT_USER'))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"AgentUsers/Add","tag":"button","title":"เพิ่มข้อมูลสมาชิก"}},[_c('i',{staticClass:"fa fa-user-plus"}),_vm._v(" เพิ่มข้อมูลสมาชิก\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-users"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("จัดการข้อมูลสมาชิกตัวแทน/ตัวแทนจำหน่ายย่อย")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"userTable"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("ชื่อผู้ใช้งาน (Username)")]),_vm._v(" "),_c('th',[_vm._v("อีเมล")]),_vm._v(" "),_c('th',[_vm._v("ชื่อ - ชื่อสกุล")]),_vm._v(" "),_c('th',[_vm._v("โทรศัพท์")]),_vm._v(" "),_c('th',[_vm._v("ตำแหน่ง")]),_vm._v(" "),_c('th',[_vm._v("โปรไฟล์บริษัท")]),_vm._v(" "),_c('th',[_vm._v("วันที่เข้าใช้งานล่าสุด")]),_vm._v(" "),_c('th',[_vm._v("คำสั่ง")])])])])])])}]


/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนฯย่อย:")]),_vm._v(" "),_c('select',{ref:"customerCode",staticClass:"form-control m-select2",staticStyle:{"width":"100%"},attrs:{"id":"customerCode","name":"customerCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("สร้างโปรไฟล์ตัวแทนฯย่อย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_vm._v("\n                  ระบบจะสร้างโปรไฟล์ตัวแทนฯย่อยให้ทั้งหมด 1 รายการ ดังนี้\n                  "),_c('br'),_vm._v("1) ชื่อตัวแทนฯย่อย (พนักงาน)\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" สร้างโปรไฟล์\n          ")])])}]


/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อเขตการขาย:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sauName),expression:"sauName"}],staticClass:"form-control",attrs:{"id":"sauName","name":"sauName","type":"text","maxlength":"256","placeholder":"ชื่อเขตการขาย"},domProps:{"value":(_vm.sauName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sauName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"sauProvinceSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'sauProvince',"name":'sauProvince',"multiple":true,"select2-options":_vm.sauProvinceOptions},model:{value:(_vm.sauProvince),callback:function ($$v) {_vm.sauProvince=$$v},expression:"sauProvince"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sauInActiveStatus),expression:"sauInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"sauInActiveStatus","name":"sauInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.sauInActiveStatus)?_vm._i(_vm.sauInActiveStatus,null)>-1:(_vm.sauInActiveStatus)},on:{"change":function($event){var $$a=_vm.sauInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.sauInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.sauInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.sauInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{class:_vm.pageIcon})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(_vm.pageTitle)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[(_vm.isLoading && (_vm.isEditMode || _vm.isViewMode))?_c('div',{staticClass:"text-center py-5"},[_c('div',{staticClass:"kt-spinner kt-spinner--lg kt-spinner--brand"}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_vm._v("กำลังโหลดข้อมูล...")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading || (!_vm.isEditMode && !_vm.isViewMode)),expression:"!isLoading || (!isEditMode && !isViewMode)"}]},[(_vm.isEditMode || _vm.isViewMode)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("IO :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.ioTreeOptions,"clear-on-select":true,"placeholder":"ทั้งหมด (เลือกได้หลายรายการ)"},on:{"input":_vm.onFilterChanged},model:{value:(_vm.searchIOCodes),callback:function ($$v) {_vm.searchIOCodes=$$v},expression:"searchIOCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("GL :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.glTreeOptions,"clear-on-select":true,"placeholder":"ทั้งหมด (เลือกได้หลายรายการ)"},on:{"input":_vm.onFilterChanged},model:{value:(_vm.searchGLCodes),callback:function ($$v) {_vm.searchGLCodes=$$v},expression:"searchGLCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แผนก :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.orgFilterTreeOptions,"clear-on-select":true,"placeholder":"ทั้งหมด (เลือกได้หลายแผนก)"},on:{"input":_vm.onFilterChanged},model:{value:(_vm.searchOrgCodes),callback:function ($$v) {_vm.searchOrgCodes=$$v},expression:"searchOrgCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมวดหมู่ :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.glTypeTreeOptions,"clear-on-select":true,"placeholder":"ทั้งหมด (เลือกได้หลายรายการ)"},on:{"input":_vm.onFilterChanged},model:{value:(_vm.searchGLTypeNames),callback:function ($$v) {_vm.searchGLTypeNames=$$v},expression:"searchGLTypeNames"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.searchBudgetPlan}},[_vm._v("\n                ค้นหา\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.clearSearch}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":_vm.isExporting},on:{"click":_vm.exportBudgetHistory}},[_c('i',{class:_vm.isExporting ? 'fas fa-spinner fa-spin' : 'fas fa-file-excel'}),_vm._v("\n                "+_vm._s(_vm.isExporting ? 'กำลัง Export...' : 'Export ข้อมูลงบประมาณ')+"\n              ")])])]),_vm._v(" "),_c('hr')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card mb-3 border-primary"},[_c('div',{staticClass:"card-header bg-primary text-white",staticStyle:{"cursor":"pointer"},on:{"click":_vm.toggleLevel1}},[_c('h5',{staticClass:"mb-0"},[_c('i',{class:_vm.level1Collapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-down'}),_vm._v("\n              ข้อมูล CCTR"),(_vm.formData.cctrCode)?_c('span',[_vm._v(" - ["+_vm._s(_vm.formData.cctrCode)+"] "+_vm._s(_vm.formData.cctrName))]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.level1Collapsed),expression:"!level1Collapsed"}],staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.cctrCode),expression:"formData.cctrCode"}],staticClass:"form-control",class:{ 'readonly-field': _vm.isCCTRCodeReadOnly() },attrs:{"type":"text","placeholder":"รหัส CCTR","maxlength":"20","readonly":_vm.isCCTRCodeReadOnly()},domProps:{"value":(_vm.formData.cctrCode)},on:{"blur":_vm.onCCTRBlur,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "cctrCode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.cctrName),expression:"formData.cctrName"}],staticClass:"form-control",class:{ 'readonly-field': _vm.isViewMode },attrs:{"type":"text","placeholder":"ชื่อ CCTR","readonly":_vm.isViewMode},domProps:{"value":(_vm.formData.cctrName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "cctrName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('select2',{ref:"budgetYearSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'budgetYearSelect',"name":'budgetYearSelect',"select2-options":_vm.yearOptions,"disabled":_vm.isViewMode || _vm.isEditMode},model:{value:(_vm.formData.year),callback:function ($$v) {_vm.$set(_vm.formData, "year", $$v)},expression:"formData.year"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่บันทึกล่าสุด :")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.currentDate}})])])]),_vm._v(" "),(!_vm.isViewMode)?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-warning text-white btn-sm",attrs:{"type":"button"},on:{"click":_vm.addIO}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" เพิ่ม IO\n                ")])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.formData.ioList),function(io,ioIndex){return _c('div',{key:'io-' + ioIndex,staticClass:"card mb-3 border-info ml-3"},[_c('div',{staticClass:"card-header bg-info text-white d-flex justify-content-between align-items-center",staticStyle:{"cursor":"pointer"}},[_c('h6',{staticClass:"mb-0",on:{"click":function($event){return _vm.toggleIO(ioIndex)}}},[_c('i',{class:io.collapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-down'}),_vm._v("\n                  ข้อมูล IO"),(io.ioCode)?_c('span',[_vm._v(" - ["+_vm._s(io.ioCode)+"] "+_vm._s(io.ioName))]):_vm._e()]),_vm._v(" "),(!_vm.isViewMode && _vm.canDeleteIO(io) && _vm.formData.ioList.length > 1)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button","title":"ลบ IO"},on:{"click":function($event){$event.stopPropagation();return _vm.removeIO(ioIndex)}}},[_c('i',{staticClass:"la la-trash"})]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!io.collapsed),expression:"!io.collapsed"}],staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(3,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(io.ioCode),expression:"io.ioCode"}],staticClass:"form-control",class:{ 'readonly-field': _vm.isIOCodeReadOnly(ioIndex) },attrs:{"type":"text","placeholder":"รหัส IO","maxlength":"20","readonly":_vm.isIOCodeReadOnly(ioIndex)},domProps:{"value":(io.ioCode)},on:{"blur":function($event){return _vm.onIOBlur(ioIndex)},"input":function($event){if($event.target.composing){ return; }_vm.$set(io, "ioCode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อ IO :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(io.ioName),expression:"io.ioName"}],staticClass:"form-control",class:{ 'readonly-field': _vm.isViewMode },attrs:{"type":"text","placeholder":"ชื่อ IO","readonly":_vm.isViewMode},domProps:{"value":(io.ioName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(io, "ioName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"summary-box bg-light border rounded p-2"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('span',[_vm._v("IO รวมงบประมาณ :")]),_vm._v(" "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.calculateIOBudgetTotal(io))))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('span',[_vm._v("IO รวมงบประมาณคงเหลือ :")]),_vm._v(" "),_c('span',{staticClass:"font-weight-bold text-primary"},[_vm._v(_vm._s(_vm.formatNumber(_vm.calculateIOTotal(io, 'remainingAmount'))))])])])])]),_vm._v(" "),(!_vm.isViewMode)?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-warning text-white btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.addGL(ioIndex)}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" เพิ่ม GL\n                    ")])])]):_vm._e(),_vm._v(" "),_vm._l((io.glList),function(gl,glIndex){return _c('div',{key:'gl-' + ioIndex + '-' + glIndex,staticClass:"card mb-3 border-success ml-3"},[_c('div',{staticClass:"card-header bg-success text-white d-flex justify-content-between align-items-center",staticStyle:{"cursor":"pointer"}},[_c('h6',{staticClass:"mb-0",on:{"click":function($event){return _vm.toggleGL(ioIndex, glIndex)}}},[_c('i',{class:gl.collapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-down'}),_vm._v("\n                      ข้อมูล GL"),(gl.glCode)?_c('span',[_vm._v(" - ["+_vm._s(gl.glCode)+"] "+_vm._s(gl.glName))]):_vm._e()]),_vm._v(" "),(!_vm.isViewMode && _vm.canDeleteGL(gl) && io.glList.length > 1)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button","title":"ลบ GL"},on:{"click":function($event){$event.stopPropagation();return _vm.removeGL(ioIndex, glIndex)}}},[_c('i',{staticClass:"la la-trash"})]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!gl.collapsed),expression:"!gl.collapsed"}],staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(4,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(gl.glCode),expression:"gl.glCode"}],staticClass:"form-control",class:{ 'readonly-field': _vm.isGLCodeReadOnly(ioIndex, glIndex) },attrs:{"type":"text","placeholder":"รหัส GL","maxlength":"20","readonly":_vm.isGLCodeReadOnly(ioIndex, glIndex)},domProps:{"value":(gl.glCode)},on:{"blur":function($event){return _vm.onGLBlur(ioIndex, glIndex)},"input":function($event){if($event.target.composing){ return; }_vm.$set(gl, "glCode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อ GL :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(gl.glName),expression:"gl.glName"}],staticClass:"form-control",class:{ 'readonly-field': _vm.isViewMode },attrs:{"type":"text","placeholder":"ชื่อ GL","readonly":_vm.isViewMode},domProps:{"value":(gl.glName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(gl, "glName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมวดหมู่ :")]),_vm._v(" "),_c('gl-type-select',{attrs:{"options":_vm.glTypeNameOptions,"disabled":_vm.isViewMode,"placeholder":"เช่น Asset, A&P"},model:{value:(gl.glTypeName),callback:function ($$v) {_vm.$set(gl, "glTypeName", $$v)},expression:"gl.glTypeName"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"summary-box bg-light border rounded p-2"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('span',[_vm._v("GL รวมงบประมาณ :")]),_vm._v(" "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.calculateGLBudgetTotal(gl))))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('span',[_vm._v("GL รวมงบประมาณคงเหลือ :")]),_vm._v(" "),_c('span',{staticClass:"font-weight-bold text-success"},[_vm._v(_vm._s(_vm.formatNumber(_vm.calculateGLTotal(gl, 'remainingAmount'))))])])])])]),_vm._v(" "),_c('label',{staticClass:"font-weight-bold"},[_vm._v("แผนก :")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-sm"},[_vm._m(5,true),_vm._v(" "),_c('tbody',[_vm._l((gl.orgList),function(org,orgIndex){return _c('tr',{key:'org-' + (org._uid || orgIndex)},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(orgIndex + 1))]),_vm._v(" "),_c('td',[_c('treeselect',{attrs:{"options":_vm.orgTreeOptions,"clearable":true,"disabled":_vm.isViewMode || org.isReadOnly,"placeholder":"กรุณาเลือกแผนก"},on:{"input":function($event){return _vm.onOrgChange(ioIndex, glIndex, orgIndex)}},model:{value:(org.orgCode),callback:function ($$v) {_vm.$set(org, "orgCode", $$v)},expression:"org.orgCode"}})],1),_vm._v(" "),_c('td',[(_vm.isViewMode || org.isReadOnly)?_c('span',{staticClass:"d-block text-right"},[_vm._v("\n                                "+_vm._s(_vm.formatNumber(org.budgetAmount))+"\n                              ")]):_c('input',{staticClass:"form-control form-control-sm text-right",attrs:{"type":"text"},domProps:{"value":org._isEditing ? org.budgetAmount : _vm.formatNumber(org.budgetAmount)},on:{"focus":function($event){return _vm.onBudgetFocus($event, org)},"blur":function($event){return _vm.onBudgetBlur($event, ioIndex, glIndex, orgIndex)},"keydown":function($event){return _vm.preventNegativeInput($event)}}})]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(org.usedAmount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber((org.addedAmount || 0) + (org.sendbackAmount || 0))))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(org.reducedAmount)))]),_vm._v(" "),_c('td',{staticClass:"text-right font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(org.remainingAmount)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(!_vm.isViewMode && !org.isReadOnly)?_c('a',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"href":"javascript:;","title":"ลบรายการ"},on:{"click":function($event){return _vm.removeOrgRow(ioIndex, glIndex, orgIndex)}}},[_c('i',{staticClass:"la la-trash"})]):_vm._e(),_vm._v(" "),(org.isReadOnly && org.budgetPlanId)?_c('router-link',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"to":'/BudgetPlan/Detail/' + org.budgetPlanId,"title":"ดูรายละเอียด"}},[_c('i',{staticClass:"fa fa-search"})]):_vm._e(),_vm._v(" "),(org.isReadOnly && !org.budgetPlanId)?_c('span',{staticClass:"badge badge-secondary"},[_c('i',{staticClass:"fas fa-lock"}),_vm._v(" ใช้แล้ว\n                              ")]):_vm._e()],1)])}),_vm._v(" "),(gl.orgList.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"8"}},[_vm._v("\n                              ยังไม่มีข้อมูลแผนก คลิก \"เพิ่มรายการ\" เพื่อเพิ่ม\n                            ")])]):_vm._e()],2),_vm._v(" "),_c('tfoot',{staticClass:"bg-light"},[_c('tr',[_c('td',{staticClass:"text-right font-weight-bold",attrs:{"colspan":"2"}},[_vm._v("รวม:")]),_vm._v(" "),_c('td',{staticClass:"text-right font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.calculateGLTotal(gl, 'budgetAmount'))))]),_vm._v(" "),_c('td',{staticClass:"text-right font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.calculateGLTotal(gl, 'usedAmount'))))]),_vm._v(" "),_c('td',{staticClass:"text-right font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.calculateGLTotal(gl, 'addedAmount') + _vm.calculateGLTotal(gl, 'sendbackAmount'))))]),_vm._v(" "),_c('td',{staticClass:"text-right font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.calculateGLTotal(gl, 'reducedAmount'))))]),_vm._v(" "),_c('td',{staticClass:"text-right font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.calculateGLTotal(gl, 'remainingAmount'))))]),_vm._v(" "),_c('td')]),_vm._v(" "),_vm._m(6,true)])])]),_vm._v(" "),(!_vm.isViewMode)?_c('div',{staticClass:"mt-2"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.addOrgRow(ioIndex, glIndex)}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" เพิ่มรายการ\n                      ")])]):_vm._e()])])})],2)])})],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n            ")]),_vm._v(" "),(!_vm.isViewMode)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.isSaving},on:{"click":_vm.saveBudgetPlan}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "+_vm._s(_vm.isSaving ? 'กำลังบันทึก...' : 'บันทึก')+"\n            ")]):_vm._e()])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("รหัส CCTR : "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("ชื่อ CCTR : "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("ปีงบประมาณ : "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("รหัส IO : "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("รหัส GL : "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"25%"}},[_vm._v("ชื่อแผนก "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("งบประมาณตั้งต้น "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ใช้ไป")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รวมปรับเพิ่มงบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รวมปรับลดงบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("คงเหลืองบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-danger text-right font-weight-bold border-0 p-0 pt-1",staticStyle:{"font-size":"0.8rem"},attrs:{"colspan":"2"}},[_vm._v("* ไม่รวมภาษีมูลค่าเพิ่ม 7 %")]),_vm._v(" "),_c('td',{staticClass:"border-0",attrs:{"colspan":"6"}})])}]


/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"downloadBarcodeModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"label"},[_vm._v("BARCODE :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.DlbOldBarcode),expression:"DlbOldBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"BARCODE"},domProps:{"value":(_vm.DlbOldBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.DlbOldBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสอ้างอิง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadDlbRefnoOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},model:{value:(_vm.DlbRefno),callback:function ($$v) {_vm.DlbRefno=$$v},expression:"DlbRefno"}})],1)])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" ดาวน์โหลด\n          ")])])}]


/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสร้านค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshCustomerCode),expression:"cshCustomerCode"}],staticClass:"form-control",attrs:{"id":"cshCustomerCode","name":"cshCustomerCode","type":"text","maxlength":"256","placeholder":"รหัสร้านค้า"},domProps:{"value":(_vm.cshCustomerCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cshCustomerCode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อร้านค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshCustomerName),expression:"cshCustomerName"}],staticClass:"form-control",attrs:{"id":"cshCustomerName","name":"cshCustomerName","type":"text","maxlength":"256","placeholder":"ชื่อร้านค้า"},domProps:{"value":(_vm.cshCustomerName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cshCustomerName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อร้านค้า 2:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshName2),expression:"cshName2"}],staticClass:"form-control",attrs:{"id":"cshName2","name":"cshName2","type":"text","maxlength":"256","placeholder":"ชื่อร้านค้า 2"},domProps:{"value":(_vm.cshName2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cshName2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"cshShopTypeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cshShopType',"name":'cshShopType',"select2-options":_vm.cshShopTypeOptions},model:{value:(_vm.cshShopType),callback:function ($$v) {_vm.cshShopType=$$v},expression:"cshShopType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทการล้างเครื่อง:")]),_vm._v(" "),_c('select2',{ref:"cshShopPMTypeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cshShopPMType',"name":'cshShopPMType',"select2-options":_vm.cshShopPMTypeOptions},model:{value:(_vm.cshShopPMType),callback:function ($$v) {_vm.cshShopPMType=$$v},expression:"cshShopPMType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สถานะประเภทร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"cshShopGroupSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cshShopGroup',"name":'cshShopGroup',"select2-options":_vm.cshShopGroupOptions},model:{value:(_vm.cshShopGroup),callback:function ($$v) {_vm.cshShopGroup=$$v},expression:"cshShopGroup"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ที่อยู่:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshAddress),expression:"cshAddress"}],staticClass:"form-control",attrs:{"id":"cshAddress","name":"cshAddress","type":"text","maxlength":"256","placeholder":"ที่อยู่"},domProps:{"value":(_vm.cshAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cshAddress=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"cshProvinceIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cshProvinceId',"name":'cshProvinceId',"select2-options":_vm.cshProvinceIdOptions},model:{value:(_vm.cshProvinceId),callback:function ($$v) {_vm.cshProvinceId=$$v},expression:"cshProvinceId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"cshAmphurIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cshAmphurId',"name":'cshAmphurId',"select2-options":_vm.cshAmphurIdOptions},model:{value:(_vm.cshAmphurId),callback:function ($$v) {_vm.cshAmphurId=$$v},expression:"cshAmphurId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตำบล:")]),_vm._v(" "),_c('select2',{ref:"cshTumbolIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cshTumbolId',"name":'cshTumbolId',"select2-options":_vm.cshTumbolIdOptions},model:{value:(_vm.cshTumbolId),callback:function ($$v) {_vm.cshTumbolId=$$v},expression:"cshTumbolId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshSubAgent),expression:"cshSubAgent"}],staticClass:"form-check-input",attrs:{"id":"cshSubAgent","name":"cshSubAgent","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.cshSubAgent)?_vm._i(_vm.cshSubAgent,null)>-1:(_vm.cshSubAgent)},on:{"change":function($event){var $$a=_vm.cshSubAgent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cshSubAgent=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cshSubAgent=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cshSubAgent=$$c}}}}),_vm._v(" "),_c('span'),_vm._v("\n                  เปิดใช้งาน\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshContactFullName),expression:"cshContactFullName"}],staticClass:"form-control",attrs:{"id":"cshContactFullName","name":"cshContactFullName","type":"text","maxlength":"256","placeholder":"ชื่อ-สกุลผู้ติดต่อ"},domProps:{"value":(_vm.cshContactFullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cshContactFullName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshEmail),expression:"cshEmail"}],staticClass:"form-control",attrs:{"id":"cshEmail","name":"cshEmail","type":"text","maxlength":"400","placeholder":"อีเมล"},domProps:{"value":(_vm.cshEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cshEmail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshTel),expression:"cshTel"}],staticClass:"form-control",attrs:{"id":"cshTel","name":"cshTel","type":"text","maxlength":"256","placeholder":"เบอร์โทร"},domProps:{"value":(_vm.cshTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cshTel=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ดูแลร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"cshAgentCodeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cshAgentCode',"name":'cshAgentCode',"select2-options":_vm.cshAgentCodeOptions},model:{value:(_vm.cshAgentCode),callback:function ($$v) {_vm.cshAgentCode=$$v},expression:"cshAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อเจ้าหน้าที่ดูแล (ตัวแทน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshContactAgentName),expression:"cshContactAgentName"}],staticClass:"form-control",attrs:{"id":"cshContactAgentName","name":"cshContactAgentName","type":"text","maxlength":"256","placeholder":"ชื่อเจ้าหน้าที่ดูแล (ตัวแทน)"},domProps:{"value":(_vm.cshContactAgentName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cshContactAgentName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("นามสกุลเจ้าหน้าที่ดูแล (ตัวแทน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshContactAgentLName),expression:"cshContactAgentLName"}],staticClass:"form-control",attrs:{"id":"cshContactAgentLName","name":"cshContactAgentLName","type":"text","maxlength":"256","placeholder":"นามสกุลเจ้าหน้าที่ดูแล (ตัวแทน)"},domProps:{"value":(_vm.cshContactAgentLName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cshContactAgentLName=$event.target.value}}})])]),_vm._v(" "),(_vm.$root.canShow('super_admin'))?_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เจ้าหน้าที่ดูแล (Boonrawd)")]),_vm._v(" "),_c('select2',{ref:"cshEmpIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'cshEmpId',"name":'cshEmpId',"select2-options":_vm.cshEmpIdOptions},model:{value:(_vm.cshEmpId),callback:function ($$v) {_vm.cshEmpId=$$v},expression:"cshEmpId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตั้งค่าระยะ Check-In/Check-Out:")]),_vm._v(" "),_c('div',[_c('label',{staticClass:"kt-radio kt-radio--bold kt-radio--brand",staticStyle:{"margin-right":"30px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.useSettingCheckinRange),expression:"useSettingCheckinRange"}],attrs:{"type":"radio"},domProps:{"value":true,"checked":_vm._q(_vm.useSettingCheckinRange,true)},on:{"change":function($event){_vm.useSettingCheckinRange=true}}}),_vm._v(" กำหนดตามตั้งค่าพื้นฐาน\n                  "),_c('span')]),_vm._v(" "),_c('label',{staticClass:"kt-radio kt-radio--bold kt-radio--brand"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.useSettingCheckinRange),expression:"useSettingCheckinRange"}],attrs:{"type":"radio"},domProps:{"value":false,"checked":_vm._q(_vm.useSettingCheckinRange,false)},on:{"change":function($event){_vm.useSettingCheckinRange=false}}}),_vm._v(" กำหนดเอง\n                  "),_c('span')]),_vm._v(" "),(!_vm.useSettingCheckinRange)?_c('button',{staticClass:"btn btn-sm btn-clean btn-icon",attrs:{"type":"button","title":"ใช้ค่า default"},on:{"click":_vm.resetCheckinRange}},[_c('i',{staticClass:"la la-times"})]):_vm._e()]),_vm._v(" "),(!_vm.useSettingCheckinRange)?_c('div',{staticClass:"mt-2",staticStyle:{"max-width":"300px"}},[_c('label',{staticClass:"label-required"},[_vm._v("ระยะ (เมตร):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.customCheckInRange),expression:"customCheckInRange",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"10000","placeholder":"ระบุระยะ (เมตร)","name":"customCheckInRange"},domProps:{"value":(_vm.customCheckInRange)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.customCheckInRange=_vm._n($event.target.value)},_vm.checkCustomCheckInRangeMax],"change":_vm.checkCustomCheckInRangeMax,"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.customCheckInRangeMaxError)?_c('span',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.customCheckInRangeMaxError))]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่งที่ตั้ง:")]),_vm._v(" "),(_vm.cshLat === null)?_c('div',[_c('button',{staticClass:"btn m-btn--pill btn-info btn-block col-xl-2",attrs:{"type":"button"},on:{"click":_vm.getMap}},[_vm._v("\n                  ระบุข้อมูลตำแหน่งที่ตั้ง\n                ")])]):_c('div',[_c('GmapMap',{staticStyle:{"width":"500px","height":"300px"},attrs:{"center":{ lat: _vm.cshLat, lng: _vm.cshLng },"zoom":15,"clickable":true},on:{"click":_vm.updateCoordinates}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"draggable":true,"clickable":true},on:{"drag":_vm.updateCoordinates,"click":_vm.updateCoordinates}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.openMap()}}},[_c('i',{staticClass:"far fa-map"}),_vm._v(" Open GoogleMaps\n                  ")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button"},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("รูป\n                    ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-img"}},_vm._l((_vm.FileUpload),function(image){return (image.isLoaded)?_c('div',{key:image.pictureId,staticClass:"col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap",attrs:{"id":image.pictureId}},[_c('img',{staticClass:"img-plant -avatar js-avatar-me img-thumbnail card-img-top",attrs:{"src":image.urlImg},on:{"error":function($event){return _vm.handleImageError(image)},"load":function($event){return _vm.handleImageLoad(image)}}}),_vm._v(" "),_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn btm-remove-img-plant close",staticStyle:{"position":"absolute","top":"10px","right":"20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeImage(image.pictureId)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})])]):_vm._e()}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshInActiveStatus),expression:"cshInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"cshInActiveStatus","name":"cshInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.cshInActiveStatus)?_vm._i(_vm.cshInActiveStatus,null)>-1:(_vm.cshInActiveStatus)},on:{"change":function($event){var $$a=_vm.cshInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cshInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cshInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cshInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12"},[(_vm.cshInActiveStatus)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เหตุผล:")]),_vm._v(" "),_vm._l((_vm.cshActive),function(data){return _c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cshStatus),expression:"cshStatus"}],staticClass:"form-check-input",attrs:{"id":"statusCode","name":"statusCode","type":"radio"},domProps:{"value":data.statusCode,"checked":_vm._q(_vm.cshStatus,data.statusCode)},on:{"change":function($event){_vm.cshStatus=data.statusCode}}}),_vm._v("\n                  "+_vm._s(data.statusName)+"\n                  "),_c('span')]),_vm._v(" "),_c('br')])})],2):_vm._e(),_vm._v(" "),(!_vm.cshInActiveStatus)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เหตุผล:")]),_vm._v(" "),_vm._l((_vm.cshInActive),function(data){return _c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.InActiveStatus),expression:"InActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"statusCode","name":"statusCode","type":"radio"},domProps:{"value":data.statusCode,"checked":_vm._q(_vm.InActiveStatus,data.statusCode)},on:{"change":function($event){_vm.InActiveStatus=data.statusCode}}}),_vm._v("\n                  "+_vm._s(data.statusName)+"\n                  "),_c('span')]),_vm._v(" "),_c('br')])})],2):_vm._e()]),_vm._v(" "),(this.$root.canShow(['']))?_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("[PM] ปลด validate การตรวจสอบหน้าข้อมูลร้านค้า")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cShIgnoreBarcodeValidation),expression:"cShIgnoreBarcodeValidation"}],staticClass:"form-check-input",attrs:{"id":"cShIgnoreBarcodeValidation","name":"cShIgnoreBarcodeValidation","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.cShIgnoreBarcodeValidation)?_vm._i(_vm.cShIgnoreBarcodeValidation,null)>-1:(_vm.cShIgnoreBarcodeValidation)},on:{"change":function($event){var $$a=_vm.cShIgnoreBarcodeValidation,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cShIgnoreBarcodeValidation=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cShIgnoreBarcodeValidation=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cShIgnoreBarcodeValidation=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])]):_vm._e(),_vm._v(" "),(this.$root.canShow(['']))?_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("[PM] ตั้งค่าใช้ PM (รูปแบบพิเศษ)")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cShIsSpecialPM),expression:"cShIsSpecialPM"}],staticClass:"form-check-input",attrs:{"id":"cShIsSpecialPM","name":"cShIsSpecialPM","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.cShIsSpecialPM)?_vm._i(_vm.cShIsSpecialPM,null)>-1:(_vm.cShIsSpecialPM)},on:{"change":function($event){var $$a=_vm.cShIsSpecialPM,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.cShIsSpecialPM=$$a.concat([$$v]))}else{$$i>-1&&(_vm.cShIsSpecialPM=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.cShIsSpecialPM=$$c}}}}),_vm._v("\n                  เปิดใช้งาน PM (รูปแบบพิเศษ)\n                  "),_c('span')])])])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("เพิ่มข้อมูลร้านค้า")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("\n                        รูปภาพ:"),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                            (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน\n                            10Mb.)\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/5SReport/WarehouseScore'),expression:"$route.path == '/5SReport/WarehouseScore'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reKeyword),expression:"reKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อผู้จัดทำ"},domProps:{"value":(_vm.reKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reDepartmentsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เกรด:")]),_vm._v(" "),_c('select2',{ref:"reGradeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reGrade',"name":'reGrade',"select2-options":_vm.reGradeOptions},model:{value:(_vm.reGrade),callback:function ($$v) {_vm.reGrade=$$v},expression:"reGrade"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ระดับผู้สำรวจ:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reRole',"name":'reRole',"select2-options":_vm.reRoleOptions},model:{value:(_vm.reRole),callback:function ($$v) {_vm.reRole=$$v},expression:"reRole"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportWarehouseScore}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"WarehouseScoreTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"10"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("การบริหารคลังสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("S+")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("คะแนนรวม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เกรด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้สำรวจ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ระดับผู้สำรวจ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")])])}]


/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย :")]),_vm._v(" "),_c('select2',{ref:"agentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'agentCode',"name":'agentCode',"select2-options":_vm.agentCodeOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ข้อมูลปี :")]),_vm._v(" "),_c('select2',{ref:"year",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'year',"name":'year',"select2-options":_vm.yearOptions},on:{"selectChange":_vm.agentCodeChange},model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1)])]),_vm._v(" "),(_vm.year && _vm.canExportAllAgents && !_vm.isShow)?_c('div',{staticClass:"d-flex justify-content-end align-items-center mb-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n              "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.isShow == true)?_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n              รายการจำนวนถังเปล่า/Co2 สูญหาย :\n            ")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button","disabled":_vm.isExportingSelected},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelSelected($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)")+"\n                ")])]),_vm._v(" "),(_vm.canExportAllAgents)?_c('button',{staticClass:"btn btn-outline-primary ml-2",attrs:{"type":"button","disabled":_vm.isExportingAll},on:{"click":function($event){$event.preventDefault();return _vm.exportExcelAllAgents($event)}}},[_c('span',[_c('i',{staticClass:"fas fa-file-export"}),_vm._v("\n                  "+_vm._s(_vm.isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)")+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"min-width":"2500px"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"3%"}},[_vm._v("\n                        ลำดับ\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"10%"}},[_vm._v("\n                        ประเภทสินค้า\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        ต้นทุนสินค้า(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"12","scope":"colgroup"}},[_vm._v("\n                        จำนวนถังเปล่า/Co2 สูญหาย (จำนวน) ปี "+_vm._s(_vm.year)+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้ารวม(บาท)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        มูลค่าสินค้าเฉลี่ย(บาท/เดือน)\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2","scope":"rowgroup","width":"7%"}},[_vm._v("\n                        จัดการ\n                      ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('tbody',{on:{"change":function($event){return _vm.changeTotal()}}},[(_vm.productitems == null || _vm.productitems.length == 0)?_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"18"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.productitems),function(item,i){return [_c('product-item-row',{key:i,ref:"Items",refInFor:true,attrs:{"rowIndex":i,"item":item,"kPIProductType":_vm.kPIProductType,"yearSelected":_vm.year},on:{"removeItem":_vm.onRemoveItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"3%"}}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รวมเงิน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_vm._l((12),function(index){return _c('th',{key:index,staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalMonth[index]," ", 0))+"\n                      ")])}),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalPoductCost,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.totalProductCostOfMonth,"฿ ", 2))+"\n                      ")]),_vm._v(" "),_c('th')],2),_vm._v(" "),_c('tr',[(this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('td',{attrs:{"colspan":"18"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                        ")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[(_vm.isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI']))?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand fas fa-window-close"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มกราคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กุมภาพันธ์")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มีนาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("เมษายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤษภาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("มิถุนายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กรกฎาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("สิงหาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("กันยายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ตุลาคม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("พฤศจิกายน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ธันวาคม")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('label',{staticClass:"kt-button"})])}]


/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("PHASE:")]),_vm._v(" "),_c('select2',{ref:"imPhaseSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'imPhase',"name":'imPhase',"select2-options":_vm.imPhaseOptions,"data-msg-required":"กรุณาเลือก Phase","required":""},model:{value:(_vm.imPhaseModel),callback:function ($$v) {_vm.imPhaseModel=$$v},expression:"imPhaseModel"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Lot:")]),_vm._v(" "),_c('select2',{ref:"imLotSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'imLot',"name":'imLot',"select2-options":_vm.imLotOptions,"required":"","data-msg-required":"กรุณาเลือก Lot"},model:{value:(_vm.imLotModel),callback:function ($$v) {_vm.imLotModel=$$v},expression:"imLotModel"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("จำนวนงวด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.imInstallmentModel),expression:"imInstallmentModel"}],staticClass:"form-control",attrs:{"id":"imInstallmentModel","name":"imInstallmentModel","type":"number","min":"0","data-msg-required":"กรุณากรอก จำนวนงวด","placeholder":"จำนวนงวด"},domProps:{"value":(_vm.imInstallmentModel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.imInstallmentModel=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("PO:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.imPOModel),expression:"imPOModel"}],staticClass:"form-control",attrs:{"id":"imPOModel","name":"imPOModel","type":"text","maxlength":"256","data-msg-required":"กรุณากรอก PO","placeholder":"PO"},domProps:{"value":(_vm.imPOModel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.imPOModel=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่เริ่มสัญญา:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"imStartDateModel",staticClass:"form-control",attrs:{"type":"text","id":"imStartDateModel","name":"imStartDateModel","data-msg-required":"กรุณาเลือก วันที่เริ่มสัญญา","required":"","placeholder":"วันที่เริ่มสัญญา"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ค่าเช่าต่องวด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.imPriceModel),expression:"imPriceModel"}],staticClass:"form-control",attrs:{"id":"imPriceModel","name":"imPriceModel","type":"number","min":"0","data-msg-required":"กรุณากรอก ค่าเช่าต่องวด","placeholder":"ค่าเช่าต่องวด"},domProps:{"value":(_vm.imPriceModel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.imPriceModel=$event.target.value}}})]),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"custom-file-input",attrs:{"type":"file","id":"importFile","lang":"es"}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",attrs:{"for":"importFile"}},[_vm._v(_vm._s(_vm.Flie))])])])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"reset"},on:{"click":_vm.resetFile}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ล้างค่า\n        ")]),_vm._v(" "),_vm._m(3)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",staticStyle:{"width":"100%"},attrs:{"id":"PreviewTable"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])}]


/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/StockCoverDays/List'),expression:"$route.path == '/StockCoverDays/List'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คลังสินค้า :")]),_vm._v(" "),_c('select2',{ref:"scvdList_plantKeySelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'scvdList_plantKey',"name":'scvdList_plantKey',"select2-options":_vm.plantOptions},model:{value:(_vm.searchPlant),callback:function ($$v) {_vm.searchPlant=$$v},expression:"searchPlant"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปี :")]),_vm._v(" "),_c('select2',{ref:"scvdList_yearKeySelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'scvdList_yearKey',"name":'scvdList_yearKey',"select2-options":_vm.searchYearOptions},model:{value:(_vm.searchYear),callback:function ($$v) {_vm.searchYear=$$v},expression:"searchYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ :")]),_vm._v(" "),_c('select2',{ref:"scvdList_statusKeySelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'scvdList_statusKey',"name":'scvdList_statusKey',"select2-options":_vm.statusOptions},model:{value:(_vm.searchStatus),callback:function ($$v) {_vm.searchStatus=$$v},expression:"searchStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                ค้นหา\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(_vm.canEdit)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.goToCreate}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" เพิ่มข้อมูลตามเป้าหมาย\n              ")]):_vm._e()])])]),_vm._v(" "),_vm._m(1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-boxes"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"stockCoverDaysTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-center",staticStyle:{"width":"15%"}},[_vm._v("คลังสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"30%"}},[_vm._v("ชื่อสินค้า (ข้อมูลตามเป้าหมาย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"10%"}},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"15%"}},[_vm._v("วันที่บันทึกล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"15%"}},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"width":"15%"}},[_vm._v("คำสั่ง")])])])])])])}]


/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/5SReport/EvaluateView5S'),expression:"$route.path == '/5SReport/EvaluateView5S'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("ไตรมาส:")]),_vm._v(" "),_c('treeselect',{ref:"reQuarterSelect",attrs:{"id":"reQuarter","options":_vm.reQuarterOptions,"multiple":false,"placeholder":"กรุณาเลือกไตรมาส"},model:{value:(_vm.reQuarter),callback:function ($$v) {_vm.reQuarter=$$v},expression:"reQuarter"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ปี:")]),_vm._v(" "),_c('treeselect',{ref:"reYear",attrs:{"id":"reYear","multiple":false,"clearable":false,"options":_vm.reYearOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reYear),callback:function ($$v) {_vm.reYear=$$v},expression:"reYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reDepartmentsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"5SByAgentTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"5"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(1)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ที่ปรึกษา")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ทีมงาน")])])}]


/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทการเคลม:")]),_vm._v(" "),_c('select2',{ref:"abcClaimTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'abcClaimTypeCode',"name":'abcClaimTypeCode',"select2-options":_vm.abcClaimTypeCodeOptions,"disabled":""},model:{value:(_vm.abcClaimTypeCode),callback:function ($$v) {_vm.abcClaimTypeCode=$$v},expression:"abcClaimTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'"}],staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"abcAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcAgentCode',"name":'abcAgentCode',"select2-options":_vm.abcAgentCodeOptions,"disabled":""},model:{value:(_vm.abcAgentCode),callback:function ($$v) {_vm.abcAgentCode=$$v},expression:"abcAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"}],staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"abcShopCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcShopCode',"name":'abcShopCode',"select2-options":_vm.abcShopCodeOptions,"disabled":""},model:{value:(_vm.abcShopCode),callback:function ($$v) {_vm.abcShopCode=$$v},expression:"abcShopCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อำเภอ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcAmpher),expression:"abcAmpher"}],staticClass:"form-control",attrs:{"id":"abcAmpher","name":"abcAmpher","type":"text","maxlength":"450","placeholder":"อำเภอ","disabled":""},domProps:{"value":(_vm.abcAmpher)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcAmpher=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcProvince),expression:"abcProvince"}],staticClass:"form-control",attrs:{"id":"abcProvince","name":"abcProvince","type":"text","maxlength":"450","placeholder":"จังหวัด","disabled":""},domProps:{"value":(_vm.abcProvince)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcProvince=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcPhone),expression:"abcPhone"}],staticClass:"form-control",attrs:{"id":"abcPhone","name":"abcPhone","type":"text","maxlength":"450","placeholder":"เบอร์โทร","disabled":""},domProps:{"value":(_vm.abcPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcPhone=$event.target.value}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.abcClaimTypeCode != null &&
              (_vm.abcAgentCode != null || _vm.abcShopCode != null)
          ),expression:"\n            abcClaimTypeCode != null &&\n              (abcAgentCode != null || abcShopCode != null)\n          "}],staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้าเคลม:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(
                        _vm.abcClaimItems == null || _vm.abcClaimItems.length == 0
                      )?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.abcClaimItems),function(item,i){return [_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.productBrand))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.material))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.barcodeOld))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.departmentMaterialCode))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.problemType))]),_vm._v(" "),(item.approveStatus)?_c('td',{staticClass:"text-center",staticStyle:{"color":"green"}},[_vm._v("\n                          อนุมัติ\n                        ")]):(item.approveStatus == false)?_c('td',{staticClass:"text-center",staticStyle:{"color":"red"}},[_vm._v("\n                          ไม่อนุมัติ\n                        ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.reason))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.IsSelectApprove),expression:"item.IsSelectApprove"}],attrs:{"type":"radio","id":"one","value":"true","disabled":""},domProps:{"checked":_vm._q(item.IsSelectApprove,"true")},on:{"change":function($event){return _vm.$set(item, "IsSelectApprove", "true")}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"Green"}},[_vm._v("สรุปผลการอนุมัติและชดเชย")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.IsSelectApprove),expression:"item.IsSelectApprove"}],attrs:{"type":"radio","id":"two","value":"false","disabled":""},domProps:{"checked":_vm._q(item.IsSelectApprove,"false")},on:{"change":function($event){return _vm.$set(item, "IsSelectApprove", "false")}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"Red"}},[_vm._v("สรุปผลไม่อนุมัติการเคลม")])]),_vm._v(" "),(
                            item.claimStatusCode == 'CLAIM_STATUS_APPROVE'
                          )?_c('td',[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: _vm.locale, currency: _vm.currency }),expression:"{ locale, currency }"}],staticClass:"form-control required",attrs:{"id":'claimPrice' + i,"name":'claimPrice' + i,"auto-decimal-mode:true":"","placeholder":"จำนวนเงิน","data-msg-required":"กรุณากรอกจำนวนเงิน"},model:{value:(item.claimPrice),callback:function ($$v) {_vm.$set(item, "claimPrice", $$v)},expression:"item.claimPrice"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1):_vm._e(),_vm._v(" "),(item.claimStatusCode == 'CLAIM_STATUS_REJECT')?_c('td'):_vm._e()])]})],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ปัญหาที่พบ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("\n                        ผลการอนุมัติ\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("\n                        สาเหตุที่อนุมัติ/ไม่อนุมัติ\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("\n                        สรุปผลการอนุมัติและชดเชย\n                      ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("\n                        จำนวนเงิน\n                      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/PMSurvey'),expression:"$route.path == '/PMReport/PMSurvey'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM', 
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM', \n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMAgentCodeOptions,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadrePMAgentCodeOptions},model:{value:(_vm.rePMAgentCode),callback:function ($$v) {_vm.rePMAgentCode=$$v},expression:"rePMAgentCode"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',\n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMSubAgentCodeOptions,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadrePMSubAgentCodeOptions},model:{value:(_vm.rePMSubAgentCode),callback:function ($$v) {_vm.rePMSubAgentCode=$$v},expression:"rePMSubAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทตัวแทนจำหน่าย :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMAgentTypeCodeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMAgentTypeCode),callback:function ($$v) {_vm.rePMAgentTypeCode=$$v},expression:"rePMAgentTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMRegionOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMRegion),callback:function ($$v) {_vm.rePMRegion=$$v},expression:"rePMRegion"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่บันทึก Survey (เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"rePMDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"rePMDateStart","name":"rePMDateStart"}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.rePMDateStartError)?_c('span',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.rePMDateStartError))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่บันทึก Survey (สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"rePMDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"rePMDateEnd","name":"rePMDateEnd"}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),(_vm.rePMDateEndError)?_c('span',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.rePMDateEndError))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rePMShopName),expression:"rePMShopName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อร้านค้า เช่น ชื่อร้านค้า1,ชื่อร้านค้า2"},domProps:{"value":(_vm.rePMShopName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rePMShopName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("BARCODE (เครื่องทำความเย็น/หัวจ่าย) :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rePMBarcode),expression:"rePMBarcode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก BARCODE (เครื่องทำความเย็น/หัวจ่าย) "},domProps:{"value":(_vm.rePMBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rePMBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า(เครื่อง/หัวจ่าย) :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMMachineProductCodeOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMMachineProductCode),callback:function ($$v) {_vm.rePMMachineProductCode=$$v},expression:"rePMMachineProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMBrandOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMBrand),callback:function ($$v) {_vm.rePMBrand=$$v},expression:"rePMBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จำนวนหัวจ่ายที่ล้าง :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMTotDispenserOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMTotDispenser),callback:function ($$v) {_vm.rePMTotDispenser=$$v},expression:"rePMTotDispenser"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อ-สกุลผู้ Survey :")]),_vm._v(" "),_c('select2',{ref:"rePMCreatedUserIdSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'rePMCreatedUserId',"name":'rePMCreatedUserId',"select2-options":_vm.LoadrePMCreatedUserIdOptions,"multiple":""},model:{value:(_vm.rePMCreatedUserId),callback:function ($$v) {_vm.rePMCreatedUserId=$$v},expression:"rePMCreatedUserId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผลการดำเนินการ :")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMSurveyStatusOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMSurveyStatus),callback:function ($$v) {_vm.rePMSurveyStatus=$$v},expression:"rePMSurveyStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" ")]),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"8px","display":"flex","align-items":"center","cursor":"pointer","font-weight":"500"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rePMShowImages),expression:"rePMShowImages"}],staticStyle:{"margin-right":"8px","transform":"scale(1.2)"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.rePMShowImages)?_vm._i(_vm.rePMShowImages,null)>-1:(_vm.rePMShowImages)},on:{"change":[function($event){var $$a=_vm.rePMShowImages,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rePMShowImages=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rePMShowImages=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rePMShowImages=$$c}},_vm.onShowImagesChange]}}),_vm._v("\n                  รูปแบบแสดงรูปภาพ\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":function($event){return _vm.formReset($event)}}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit","disabled":_vm.isExporting},on:{"click":_vm.exportPM}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"pmTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"19"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่บันทึก Survey")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อรูท")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อ-สกุลผู้ Survey")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสร้านค้า\t")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า\t")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2\t")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE (เครื่องทำความเย็น)\t")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า (เครื่องทำความเย็น)\t")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE (หัวจ่าย)\t")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า (หัวจ่าย)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE (อื่นๆ)\t")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า\t")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนหัวจ่ายที่ล้าง\t")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผลการดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ดาวน์โหลด")])])}]


/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Master/Supplier'),expression:"$route.path == '/Master/Supplier'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"searchForm",staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sulKeyword),expression:"sulKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก รหัส(Supplier) ชื่อ(Supplier) เลขประจำตัวผู้เสียภาษี อีเมล เบอร์โทร ที่อยู่"},domProps:{"value":(_vm.sulKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sulKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{ref:"sulInActiveStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'sulInActiveStatus',"name":'sulInActiveStatus',"select2-options":_vm.sulInActiveStatusOptions},model:{value:(_vm.sulInActiveStatus),callback:function ($$v) {_vm.sulInActiveStatus=$$v},expression:"sulInActiveStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("ล้างค่าทั้งหมด")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportSuplier}},[_vm._m(1)])])])]),_vm._v(" "),_vm._m(2)])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-user-tie"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("จัดการข้อมูล Supplier")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"supplierTable"}},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัส(Supplier)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อ(Supplier)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เลขประจำตัวผู้เสียภาษี")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("E-mail")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เบอร์โทร")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("ที่อยู่")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Latitude")]),_vm._v(" "),_c('th',{staticClass:"none"},[_vm._v("Longitude")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"EditBarcodeModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ebBarcodeOld),expression:"ebBarcodeOld"}],ref:"ebBarcodeOld",staticClass:"form-control",attrs:{"type":"text","name":"ebBarcodeOld","placeholder":"BARCODE"},domProps:{"value":(_vm.ebBarcodeOld)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ebBarcodeOld=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสทรัพย์สิน(เบียร์สด):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ebDepartmentMaterialCode),expression:"ebDepartmentMaterialCode"}],ref:"ebDepartmentMaterialCode",staticClass:"form-control",attrs:{"type":"text","placeholder":"รหัสทรัพย์สิน(เบียร์สด)"},domProps:{"value":(_vm.ebDepartmentMaterialCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ebDepartmentMaterialCode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ปี(สินค้า):")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ebBarcodeYear),expression:"ebBarcodeYear"}],staticClass:"form-control",attrs:{"type":"text","name":"ebBarcodeYear","maxlength":"4","placeholder":"ปี(สินค้า)"},domProps:{"value":(_vm.ebBarcodeYear)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.ebBarcodeYear=$event.target.value},_vm.validateYearInput]}})])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("รหัสทรัพย์สิน(บัญชี):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ebAccountMaterialCode),expression:"ebAccountMaterialCode"}],ref:"ebAccountMaterialCode",staticClass:"form-control",attrs:{"type":"text","placeholder":"รหัสทรัพย์สิน(บัญชี)"},domProps:{"value":(_vm.ebAccountMaterialCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ebAccountMaterialCode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("BARCODE COOLING:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ebBarcodeCL),expression:"ebBarcodeCL"}],ref:"ebBarcodeCL",staticClass:"form-control",attrs:{"type":"text","placeholder":"BARCODE COOLING","maxlength":"20"},domProps:{"value":(_vm.ebBarcodeCL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ebBarcodeCL=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{ref:"ebAssetCode",class:{ 'invalid-treeselect': !_vm.ebAssetCode },attrs:{"options":_vm.ebAssetCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.ebAssetCode),callback:function ($$v) {_vm.ebAssetCode=$$v},expression:"ebAssetCode"}}),_vm._v(" "),(!_vm.ebAssetCode)?_c('span',{staticClass:"form-text text-danger",staticStyle:{"font-size":"80%"}},[_vm._v("กรุณาเลือก ชื่อสินค้า")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เจ้าของทรัพย์สิน:")]),_vm._v(" "),_c('treeselect',{class:{ 'invalid-treeselect': !_vm.ebAssetOwnerId },attrs:{"options":_vm.ebAssetOwnerOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.ebAssetOwnerId),callback:function ($$v) {_vm.ebAssetOwnerId=$$v},expression:"ebAssetOwnerId"}}),_vm._v(" "),(!_vm.ebAssetOwnerId)?_c('span',{staticClass:"form-text text-danger",staticStyle:{"font-size":"80%"}},[_vm._v("กรุณาเลือก เจ้าของทรัพย์สิน")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("Supplier:")]),_vm._v(" "),_c('treeselect',{class:{ 'invalid-treeselect': !_vm.ebSupplierId },attrs:{"options":_vm.ebSupplierOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.ebSupplierId),callback:function ($$v) {_vm.ebSupplierId=$$v},expression:"ebSupplierId"}}),_vm._v(" "),(!_vm.ebSupplierId)?_c('span',{staticClass:"form-text text-danger",staticStyle:{"font-size":"80%"}},[_vm._v("กรุณาเลือก Supplier")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"ebWarrantyStartDate",staticClass:"form-control",attrs:{"type":"text","placeholder":"วันที่เริ่มต้น (วว/ดด/ปปปป)","name":"ebWarrantyStartDate"}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ระยะเวลาประกัน(วัน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ebWarrantyTime),expression:"ebWarrantyTime"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":"ระยะเวลาประกัน(วัน)","name":"ebWarrantyTime"},domProps:{"value":(_vm.ebWarrantyTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ebWarrantyTime=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("อายุของทรัพย์สิน(วัน):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ebExprie),expression:"ebExprie"}],staticClass:"form-control",attrs:{"type":"number","min":"0","placeholder":"อายุของทรัพย์สิน(วัน)","name":"ebExprie"},domProps:{"value":(_vm.ebExprie)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ebExprie=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สถานะทรัพย์สินเช่า:")]),_vm._v(" "),_c('treeselect',{ref:"ebIsLeasedAssets",class:{ 'invalid-treeselect': _vm.ebIsLeasedAssets === null || _vm.ebIsLeasedAssets === undefined },attrs:{"name":"ebIsLeasedAssets","options":_vm.ebIsLeasedAssetsOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.ebIsLeasedAssets),callback:function ($$v) {_vm.ebIsLeasedAssets=$$v},expression:"ebIsLeasedAssets"}}),_vm._v(" "),(_vm.ebIsLeasedAssets === null || _vm.ebIsLeasedAssets === undefined)?_c('span',{staticClass:"form-text text-danger",staticStyle:{"font-size":"80%"}},[_vm._v("กรุณาเลือก สถานะทรัพย์สินเช่า")]):_vm._e()],1)]),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_vm._m(3)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("แก้ไขข้อมูล BARCODE")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12",staticStyle:{"display":"none"}},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"auditLogTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all",staticStyle:{"width":"25%"}},[_vm._v("วันที่แก้ไข")]),_vm._v(" "),_c('th',{staticClass:"all",staticStyle:{"width":"25%"}},[_vm._v("แก้ไขโดย")]),_vm._v(" "),_c('th',{staticClass:"all",staticStyle:{"width":"25%"}},[_vm._v("รหัสบาร์โค้ด")]),_vm._v(" "),_c('th',{staticClass:"all",staticStyle:{"width":"25%"}},[_vm._v("รหัสบาร์โค้ด (เก่า)")]),_vm._v(" "),_c('th',{staticClass:"all",staticStyle:{"width":"25%"}},[_vm._v("รหัสบาร์โค้ดเก่า")]),_vm._v(" "),_c('th',{staticClass:"all",staticStyle:{"width":"25%"}},[_vm._v("รหัสบาร์โค้ดเก่า (เก่า)")]),_vm._v(" "),_c('th',{staticClass:"all",staticStyle:{"width":"25%"}},[_vm._v("Material")]),_vm._v(" "),_c('th',{staticClass:"all",staticStyle:{"width":"25%"}},[_vm._v("Material (เก่า)")]),_vm._v(" "),_c('th',{staticClass:"all",staticStyle:{"width":"25%"}},[_vm._v("รหัสทรัย์สินเบียร์สด")]),_vm._v(" "),_c('th',{staticClass:"all",staticStyle:{"width":"25%"}},[_vm._v("รหัสทรัย์สินเบียร์สด (เก่า)")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n          ")])])}]


/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/QCReport/QCGroupByOfficer'),expression:"$route.path == '/QCReport/QCGroupByOfficer'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n                        "+_vm._s(this.$route.meta.breadcrumb)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reDepartmentsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อเจ้าหน้าที่:")]),_vm._v(" "),_c('treeselect',{ref:"reUserIds",attrs:{"multiple":true,"async":true,"cacheOptions":false,"load-options":_vm.LoadreUserIdsOptions,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก"},on:{"open":_vm.reLoadreUserIdsOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.reUserIds),callback:function ($$v) {_vm.reUserIds=$$v},expression:"reUserIds"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmShopGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmShopGroupId),callback:function ($$v) {_vm.shmShopGroupId=$$v},expression:"shmShopGroupId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                                Generate Report\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                                ล้างค่าทั้งหมด\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportQIGroupByOfficer}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"QIGroupByOfficerTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"6"}},[_vm._v("\n                                        ข้อมูล ณ วันที่ "+_vm._s(_vm.reAaDateReq)+"\n                                    ")])]),_vm._v(" "),_vm._m(4)])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อเจ้าหน้าที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนร้านค้าที่สำรวจ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวนร้านค้าที่ไม่ได้สำรวจ")])])}]


/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path != '/Machine/PaymentMachinePayment/save'),expression:"$route.path != '/Machine/PaymentMachinePayment/save'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Supplier:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmSupplier',"name":'pmSupplier',"select2-options":_vm.pmSupplierOptions},model:{value:(_vm.pmSupplier),callback:function ($$v) {_vm.pmSupplier=$$v},expression:"pmSupplier"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Phase:")]),_vm._v(" "),_c('select2',{ref:"pmPhaseSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'pmPhase',"name":'pmPhase',"select2-options":_vm.pmPhaseOptions},model:{value:(_vm.pmPhase),callback:function ($$v) {_vm.pmPhase=$$v},expression:"pmPhase"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Lot:")]),_vm._v(" "),_c('select2',{ref:"pmLotSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'pmLot',"name":'pmLot',"select2-options":_vm.pmLotOptions},model:{value:(_vm.pmLot),callback:function ($$v) {_vm.pmLot=$$v},expression:"pmLot"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("งวดที่ :")]),_vm._v(" "),_c('select2',{ref:"pmTracheNoSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'pmTracheNo',"name":'pmTracheNo',"select2-options":_vm.pmTracheNoOptions},model:{value:(_vm.pmTracheNo),callback:function ($$v) {_vm.pmTracheNo=$$v},expression:"pmTracheNo"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่ PO:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pmPO),expression:"pmPO"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุ เลขที่ PO"},domProps:{"value":(_vm.pmPO)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pmPO=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่ Invoice:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pmInvoice),expression:"pmInvoice"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุ เลขที่ Invoice"},domProps:{"value":(_vm.pmInvoice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pmInvoice=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"machineTransactionTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("วันที่รับวางบิล")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("Supplier")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("Phase")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("Lot")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("งวด")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ยอดเงินสุทธิ")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("PO")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("Invoice")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะการวางบิล")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_c('input',{attrs:{"type":"checkbox","id":"selectAll"},on:{"click":function($event){return _vm.saveSummit('All')}}}),_vm._v("\n                    ชำระเสร็จสิ้น\n                  ")])])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{ref:"formSave",staticClass:"kt-form",on:{"submit":_vm.formSave}},[_vm._m(1)])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-barcode"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                บันทึกการชำระเงิน\n              ")])])])}]


/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[(_vm.isLoading)?_c('div',{staticClass:"text-center py-5"},[_c('i',{staticClass:"fas fa-spinner fa-spin fa-2x"}),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_vm._v("กำลังโหลดข้อมูล...")])]):(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_vm._v(" "+_vm._s(_vm.errorMessage)+"\n        ")]):(_vm.detailData)?_c('div',[_c('div',{staticClass:"card mb-4"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("ปีงบประมาณ :")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.detailData.year))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("รหัส CCTR :")]),_vm._v(" "),_c('p',[_vm._v("["+_vm._s(_vm.detailData.cctrCode)+"] "+_vm._s(_vm.detailData.cctrName))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("รหัส IO :")]),_vm._v(" "),_c('p',[_vm._v("["+_vm._s(_vm.detailData.ioCode)+"] "+_vm._s(_vm.detailData.ioName))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("รหัส GL :")]),_vm._v(" "),_c('p',[_vm._v("["+_vm._s(_vm.detailData.glCode)+"] "+_vm._s(_vm.detailData.glName))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("แผนก :")]),_vm._v(" "),_c('p',[_vm._v("["+_vm._s(_vm.detailData.orgCode)+"] "+_vm._s(_vm.detailData.orgName))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("งบประมาณรวม :")]),_vm._v(" "),_c('p',{staticClass:"text-success font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.budgetTotal)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("คงเหลืองบประมาณ :")]),_vm._v(" "),_c('p',{staticClass:"text-info font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.budgetRemaining)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("งบตั้งต้น :")]),_vm._v(" "),_c('p',{staticClass:"text-primary font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.detailData.initialBudgetAmount)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("ใช้ไป :")]),_vm._v(" "),_c('p',{staticClass:"text-danger font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.totalUsedAmount)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("รวมปรับเพิ่มงบประมาณ :")]),_vm._v(" "),_c('p',{staticClass:"text-success font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.totalAddedAmount)))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("รวมปรับลดงบประมาณ :")]),_vm._v(" "),_c('p',{staticClass:"text-warning font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(_vm.totalReducedAmount)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(3),_vm._v(" "),_c('tbody',[_vm._l((_vm.detailData.jobHistory),function(job){return _c('tr',{key:job.jobId},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(job.rowNo))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{attrs:{"href":'/BudgetPlan/Job/View/' + job.jobId,"target":"_blank"}},[_vm._v("\n                          "+_vm._s(job.jobNumber)+"\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(job.jobTypeName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge",class:{
                            'badge-secondary': job.status === 0,
                            'badge-warning': job.status === 1 || job.status === 5,
                            'badge-info': job.status === 2,
                            'badge-success': job.status === 3 || job.status === 6,
                            'badge-danger': job.status === 4 || job.status === 7
                          }},[_vm._v("\n                          "+_vm._s(job.statusName)+"\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(job.jobDate))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(job.usedAmount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(job.addedAmount)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatNumber(job.reducedAmount)))]),_vm._v(" "),_c('td',{staticClass:"text-right font-weight-bold"},[_vm._v(_vm._s(_vm.formatNumber(job.remainingAmount)))])])}),_vm._v(" "),(!_vm.detailData.jobHistory || _vm.detailData.jobHistory.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"9"}},[_vm._v("\n                        ไม่มีประวัติการใช้งบประมาณ\n                      ")])]):_vm._e()],2)])])])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-search"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            รายละเอียดการใช้งบประมาณ\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-primary text-white"},[_c('h5',{staticClass:"mb-0"},[_vm._v("ข้อมูลงบประมาณ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('h5',{staticClass:"mb-0"},[_vm._v("ประวัติการใช้งบประมาณ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"4%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ประเภทใบงาน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("สถานะใบงาน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("วันที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"12%"}},[_vm._v("ใช้ไป")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"12%"}},[_vm._v("ปรับเพิ่มงบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"12%"}},[_vm._v("ปรับลดงบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"14%"}},[_vm._v("คงเหลืองบประมาณ")])])])}]


/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/Borrow'),expression:"$route.path == '/Report/Borrow'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('Collapsible',{staticClass:"requestDoc-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหาเอกสารใบคำร้อง\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-plus-square"}),_vm._v(" ค้นหาเอกสารใบคำร้อง\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"requestDoc"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("มุมมองผู้ใช้งาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reViewPermissionCode","multiple":false,"options":_vm.reViewPermissionOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"input":function($event){return _vm.ChangeOptions('View')}},model:{value:(_vm.reViewPermissionCode),callback:function ($$v) {_vm.reViewPermissionCode=$$v},expression:"reViewPermissionCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่เอกสารใบคำร้องขอ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreBrwRequestDocNoOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reBrwRequestDocNo),callback:function ($$v) {_vm.reBrwRequestDocNo=$$v},expression:"reBrwRequestDocNo"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่อนุมัติ(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reBrwLastApproveDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reBrwLastApproveDateStart","name":"reBrwLastApproveDateStart"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่อนุมัติ(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reBrwLastApproveDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reBrwLastApproveDateEnd","name":"reBrwLastApproveDateEnd"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เดือน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBrwLastApproveMonthOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBrwLastApproveMonth),callback:function ($$v) {_vm.reBrwLastApproveMonth=$$v},expression:"reBrwLastApproveMonth"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ปี:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBrwLastApproveYearOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBrwLastApproveYear),callback:function ($$v) {_vm.reBrwLastApproveYear=$$v},expression:"reBrwLastApproveYear"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทใบคำร้องขอ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBrwRequestTypeCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBrwRequestTypeCodes),callback:function ($$v) {_vm.reBrwRequestTypeCodes=$$v},expression:"reBrwRequestTypeCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" ผู้ขอเบิก/ยืม:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBrwBorrowerIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBrwBorrowerId),callback:function ($$v) {_vm.reBrwBorrowerId=$$v},expression:"reBrwBorrowerId"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reViewPermissionCode == 'AGENT_REPORT'),expression:"reViewPermissionCode == 'AGENT_REPORT'"}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" ตัวแทนจำหน่าย/หน่วยงาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBrwBorrowerAgentOrgOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBrwBorrowerAgentOrg),callback:function ($$v) {_vm.reBrwBorrowerAgentOrg=$$v},expression:"reBrwBorrowerAgentOrg"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reViewPermissionCode == 'AGENT_REPORT'),expression:"reViewPermissionCode == 'AGENT_REPORT'"}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"async":true,"load-options":_vm.LoadreBrwAgentCodeOptions,"defaultOptions":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก"},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reBrwAgentCode),callback:function ($$v) {_vm.reBrwAgentCode=$$v},expression:"reBrwAgentCode"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reViewPermissionCode == 'AGENT_REPORT'),expression:"reViewPermissionCode == 'AGENT_REPORT'"}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" ร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"load-options":_vm.LoadreBrwShopIdOptions,"async":true,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"select":_vm.ClearAfterselect},model:{value:(_vm.reBrwShopId),callback:function ($$v) {_vm.reBrwShopId=$$v},expression:"reBrwShopId"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reViewPermissionCode == 'SUB_AGENT_REPORT'),expression:"reViewPermissionCode == 'SUB_AGENT_REPORT'"}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('treeselect',{ref:"reShop",attrs:{"id":"reShop","async":true,"multiple":true,"load-options":_vm.LoadShopOptions,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก","cacheOptions":false},on:{"open":_vm.reLoadShopOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.reShop),callback:function ($$v) {_vm.reShop=$$v},expression:"reShop"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(" ชื่องานกิจกรรม:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBrwActivityIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBrwActivityId),callback:function ($$v) {_vm.reBrwActivityId=$$v},expression:"reBrwActivityId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมายเหตุกิจกรรม:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBrwActivityRemark),expression:"reBrwActivityRemark"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุ หมายเหตุกิจกรรม กรณีมีหลาย หมายเหตุกิจกรรม เช่น 12345,54321"},domProps:{"value":(_vm.reBrwActivityRemark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBrwActivityRemark=$event.target.value}}})])])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('Collapsible',{staticClass:"return-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหาข้อมูลส่ง-คืน\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la\tla-plus-square"}),_vm._v(" ค้นหาข้อมูลส่ง-คืน\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"return"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่เอกสารใบเบิกยืม:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBrwJobNumberOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBrwJobNumber),callback:function ($$v) {_vm.reBrwJobNumber=$$v},expression:"reBrwJobNumber"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่ส่งสินค้า(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reBrwJobDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reBrwJobDateStart","name":"reBrwJobDateStart"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่ส่งสินค้า(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reBrwJobDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reBrwJobDateEnd","name":"reBrwJobDateEnd"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่กำหนดคืนสินค้า(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reBrwReturnDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reBrwReturnDateStart","name":"reBrwReturnDateStart"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่กำหนดคืนสินค้า(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reBrwReturnDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reBrwReturnDateEnd","name":"reBrwReturnDateEnd"}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เกินกำหนดการคืน(เริ่มต้น):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBrwOverDaysStart),expression:"reBrwOverDaysStart"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุจำนวนวันคงค้าง(เริ่มต้น)"},domProps:{"value":(_vm.reBrwOverDaysStart)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBrwOverDaysStart=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เกินกำหนดการคืน(สิ้นสุด):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBrwOverDaysEnd),expression:"reBrwOverDaysEnd"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุจำนวนวันคงค้าง(สิ้นสุด)"},domProps:{"value":(_vm.reBrwOverDaysEnd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBrwOverDaysEnd=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คงค้าง(เริ่มต้น):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBrwRemainingStart),expression:"reBrwRemainingStart"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุจำนวนวันคงค้าง(เริ่มต้น)"},domProps:{"value":(_vm.reBrwRemainingStart)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBrwRemainingStart=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คงค้าง(สิ้นสุด):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBrwRemainingEnd),expression:"reBrwRemainingEnd"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"กรุณาระบุจำนวนวันคงค้าง(สิ้นสุด)"},domProps:{"value":(_vm.reBrwRemainingEnd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBrwRemainingEnd=$event.target.value}}})])])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12"},[_c('Collapsible',{staticClass:"return-collapsible"},[_c('div',{attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la la-minus-square"}),_vm._v(" ค้นหาสินค้า โควตา\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"closedTrigger"},slot:"closedTrigger"},[_c('div',{staticClass:"customTrigger"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('h5',{staticClass:"kt-portlet__head-title text-primary"},[_c('i',{staticClass:"la\tla-plus-square"}),_vm._v(" ค้นหาสินค้า โควตา\n                      ")])])])]),_vm._v(" "),_c('div',{attrs:{"id":"return"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมวดหมู่สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBrwProductGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBrwProductGroupId),callback:function ($$v) {_vm.reBrwProductGroupId=$$v},expression:"reBrwProductGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBrwProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBrwProductTypeId),callback:function ($$v) {_vm.reBrwProductTypeId=$$v},expression:"reBrwProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBrwProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBrwProductCode),callback:function ($$v) {_vm.reBrwProductCode=$$v},expression:"reBrwProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("โควตา (แบรนด์):")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reBrwQuotaId',"name":'reBrwQuotaId',"select2-options":_vm.reBrwQuotaIdOptions,"multiple":""},model:{value:(_vm.reBrwQuotaId),callback:function ($$v) {_vm.reBrwQuotaId=$$v},expression:"reBrwQuotaId"}})],1)])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[(
                this.$root.canShow([
                  'AGENT_REPORT',
                  'SUB_AGENT_REPORT',
                  'BR_REPORT' ])
              )?_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportBarcodes}},[_vm._m(1)]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]):_vm._e()])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/PMReport/PMOperationReport'),expression:"$route.path == '/PMReport/PMOperationReport'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM', 
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM', \n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAgentCodesOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"open":_vm.LoadreAgentCodesOptions,"input":_vm.updateValueAgentCodes},model:{value:(_vm.reAgentCodes),callback:function ($$v) {_vm.reAgentCodes=$$v},expression:"reAgentCodes"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.AgentCodesMessagesStatus == true),expression:"AgentCodesMessagesStatus == true"}],staticClass:"form-text",staticStyle:{"color":"#fd397a"}},[_vm._v(_vm._s(_vm.AgentCodesMessages))])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM', 
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM', \n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"reShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reShopCodes',"name":'reShopCodes',"select2-options":_vm.pmrShopCodesOptions,"multiple":""},model:{value:(_vm.reShopCodes),callback:function ($$v) {_vm.reShopCodes=$$v},expression:"reShopCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reDepartmentsOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.ClearAgentCodesOptions},model:{value:(_vm.reDepartments),callback:function ($$v) {_vm.reDepartments=$$v},expression:"reDepartments"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทกิจกรรม:")]),_vm._v(" "),_c('select2',{ref:"reActivityTypeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reActivityType',"name":'reActivityType',"select2-options":_vm.reActivityTypeOptions},model:{value:(_vm.reActivityType),callback:function ($$v) {_vm.reActivityType=$$v},expression:"reActivityType"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                this.$root.canShow([
                  'super_admin',
                  'ADMIN_PM',
                  'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                  'COOL_SERVICE_PM' ])
              ),expression:"\n                this.$root.canShow([\n                  'super_admin',\n                  'ADMIN_PM',\n                  'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',\n                  'COOL_SERVICE_PM',\n                ])\n              "}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrSubAgentCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentCodes',"name":'pmrSubAgentCodes',"select2-options":_vm.pmrSubAgentCodeOptions,"multiple":""},model:{value:(_vm.pmrSubAgentCodes),callback:function ($$v) {_vm.pmrSubAgentCodes=$$v},expression:"pmrSubAgentCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"pmrShopCodesSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'pmrSubAgentShopCodes',"name":'pmrSubAgentShopCodes',"select2-options":_vm.pmrSubAgentShopCodesOptions,"multiple":""},model:{value:(_vm.pmrSubAgentShopCodes),callback:function ($$v) {_vm.pmrSubAgentShopCodes=$$v},expression:"pmrSubAgentShopCodes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("เดือน:")]),_vm._v(" "),_c('select2',{ref:"reMonthSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reMonth',"name":'reMonth',"select2-options":_vm.reMonthOptions},model:{value:(_vm.reMonth),callback:function ($$v) {_vm.reMonth=$$v},expression:"reMonth"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ปี :")]),_vm._v(" "),_c('select2',{ref:"reYear",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reYear',"name":'reYear',"select2-options":_vm.reYearOptions},model:{value:(_vm.reYear),callback:function ($$v) {_vm.reYear=$$v},expression:"reYear"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์ที่ล้าง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.rePMBrandOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePMBrand),callback:function ($$v) {_vm.rePMBrand=$$v},expression:"rePMBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"reShopStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reShopStatus',"name":'reShopStatus',"select2-options":_vm.reShopStatusOptions},model:{value:(_vm.reShopStatus),callback:function ($$v) {_vm.reShopStatus=$$v},expression:"reShopStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmShopGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmShopGroupId),callback:function ($$v) {_vm.shmShopGroupId=$$v},expression:"shmShopGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทการล้างเครื่อง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.shmShopPMTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.shmShopPMType),callback:function ($$v) {_vm.shmShopPMType=$$v},expression:"shmShopPMType"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('treeselect',{ref:"rePMCreatedUserId",attrs:{"multiple":true,"load-options":_vm.LoadreAPMCreatedUserIdOptions,"async":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadreAPMCreatedUserIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.rePMCreatedUserId),callback:function ($$v) {_vm.rePMCreatedUserId=$$v},expression:"rePMCreatedUserId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะผู้ดำเนินการ:")]),_vm._v(" "),_c('select2',{ref:"reUserStatusSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reUserStatus',"name":'reUserStatus',"select2-options":_vm.reUserStatusOptions},model:{value:(_vm.reUserStatus),callback:function ($$v) {_vm.reUserStatus=$$v},expression:"reUserStatus"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":function($event){return _vm.formReset($event)}}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportMasterShop}},[_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-6 text-left"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"submit"},on:{"click":_vm.PrevMonthClick}},[_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"submit"},on:{"click":_vm.NextMonthClick}},[_vm._m(3)])])]),_vm._v(" "),_vm._m(4)])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-arrow-left"}),_c('span',[_vm._v("เดือนก่อนหน้า ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._v("เดือนถัดไป")]),_vm._v(" "),_c('i',{staticClass:"fas fa-arrow-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"SurveyTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เขตการขาย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สถานะประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทการล้างเครื่อง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ที่อยู่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ตำบล")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("อำเภอ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสไปรษณีย์")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่ (เปิด/ปิด ร้านค้า)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เดือน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์ที่จับคู่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์ที่ล้าง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้ดำเนินการ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน PM")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D01")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D02")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D03")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D04")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D05")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D06")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D07")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D08")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D09")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D10")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D11")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D12")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D13")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D14")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D15")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D16")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D17")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D18")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D19")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D20")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D21")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D22")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D23")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D24")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D25")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D26")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D27")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D28")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D29")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D30")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("D31")])])])])}]


/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Maintain/Stock'),expression:"$route.path == '/Maintain/Stock'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่สร้าง(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateStart",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateStart","name":"jobsDateStart","readonly":""}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สร้าง(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"jobsDateEnd",staticClass:"form-control",attrs:{"type":"text","placeholder":"(วว/ดด/ปปปป)","id":"jobsDateEnd","name":"jobsDateEnd","readonly":""}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่ออะไหล่:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"qiProductCode","multiple":true,"options":_vm.qiProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.qiProductCode),callback:function ($$v) {_vm.qiProductCode=$$v},expression:"qiProductCode"}})],1)]),_vm._v(" "),(this.$root.user.profile.role != 'QI_QIMAINTAIN')?_c('div',{staticClass:"col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อช่าง:")]),_vm._v(" "),_c('treeselect',{ref:"qiUserId",attrs:{"multiple":true,"load-options":_vm.LoadUsersIdOptions,"async":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadUsersIdOptions,"select":_vm.ClearAfterselect},model:{value:(_vm.qiUserId),callback:function ($$v) {_vm.qiUserId=$$v},expression:"qiUserId"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.exportExcel}},[_vm._m(3)])])])]),_vm._v(" "),_vm._m(4)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fas fa-wrench"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("อะไหล่คงเหลือรายช่างซ่อม")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped table-bordered table-hover table-checkable",staticStyle:{"width":"100%"},attrs:{"id":"qiStockTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("รายการอะไหล่")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ชื่อช่าง")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวนที่เบิก")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวนที่ใช้งานแล้ว")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวนที่คืนแล้ว")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("จำนวนคงเหลือ"),_c('br'),_vm._v("(พร้อมใช้งานทั้งหมด)")])])])])])])}]


/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วัน-เวลาเริ่มทำ PM :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.pmStartDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วัน-เวลาสิ้นสุดการทำ PM :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.pmEndDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ระยะเวลาในการทำ PM (นาที) :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.diffMins))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้ทำ PM :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.createUser))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รูปลายเซ็นต์ :")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.signatureFileUrl && !_vm.isImgCloud)?_c('a',{attrs:{"href":"#","title":"รูปภาพ"},on:{"click":function($event){$event.preventDefault();return _vm.pictureModal(_vm.signatureFileUrl)}}},[_vm._v("Link")]):_vm._e(),_vm._v(" "),(_vm.signatureFileUrl != null && _vm.isImgCloud)?_c('a',{attrs:{"href":"javascript:void(0);","title":"รูปภาพ"},on:{"click":function($event){return _vm.showModal(_vm.signatureFileUrl)}}},[_vm._v("Link ")]):_vm._e()])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.machineSpares.length > 0)?_c('div',_vm._l((_vm.machineSpares),function(ms,i){return _c('div',{key:i,staticClass:"kt-section kt-section--first"},[(ms.surveys.length > 0)?_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                การเปลี่ยนอะไหล่ เครื่องทำความเย็น:\n              ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1,true),_vm._v(" "),_c('tbody',_vm._l((ms.surveys),function(msur,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(i + 1)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                            "+_vm._s(msur.questionText)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(msur.answerText)+"\n                          ")])])}),0)])])])])]):_vm._e(),_vm._v(" "),(ms.spares.length > 0)?_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                รายการอะไหล่ เครื่องทำความเย็น:\n              ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(2,true),_vm._v(" "),_c('tbody',_vm._l((ms.spares),function(msp,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(i + 1)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                            "+_vm._s(msp.materialName)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(msp.amount)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(msp.changeDate)+"\n                          ")])])}),0)])])])])]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(_vm.dispensers.length > 0)?_c('div',_vm._l((_vm.dispensers),function(d,i){return _c('div',{key:i,staticClass:"kt-section kt-section--first"},[_c('hr'),_vm._v(" "),(d.cleanUps.length > 0)?_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                การทำความสะอาด เฉพาะหัวจ่ายนี้ ("+_vm._s(d.productBrandName)+"):\n              ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(3,true),_vm._v(" "),_c('tbody',_vm._l((d.cleanUps),function(dc,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(i + 1)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                            "+_vm._s(dc.cleanUpChoiceName)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[(dc.fileUrl && !dc.isImgCloud)?_c('a',{attrs:{"href":"#","title":"รูปภาพ"},on:{"click":function($event){$event.preventDefault();return _vm.pictureModal(dc.fileUrl)}}},[_vm._v("Link")]):_vm._e(),_vm._v(" "),(dc.fileUrl != null && dc.isImgCloud)?_c('a',{attrs:{"href":"javascript:void(0);","title":"รูปภาพ"},on:{"click":function($event){return _vm.showModal(dc.fileUrl)}}},[_vm._v("Link ")]):_vm._e()])])}),0)])])])])]):_vm._e(),_vm._v(" "),(d.surveys.length > 0)?_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                การเปลี่ยนอะไหล่ เฉพาะหัวจ่ายนี้ ("+_vm._s(d.productBrandName)+"):\n              ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(4,true),_vm._v(" "),_c('tbody',_vm._l((d.surveys),function(dsur,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(i + 1)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                            "+_vm._s(dsur.questionText)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(dsur.answerText)+"\n                          ")])])}),0)])])])])]):_vm._e(),_vm._v(" "),(d.spares.length > 0)?_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                รายการอะไหล่ เฉพาะหัวจ่ายนี้ ("+_vm._s(d.productBrandName)+"):\n              ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(5,true),_vm._v(" "),_c('tbody',_vm._l((d.spares),function(dsp,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(i + 1)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                            "+_vm._s(dsp.materialName)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(dsp.amount)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(dsp.changeDate)+"\n                          ")])])}),0)])])])])]):_vm._e()])}),0):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"imageModal","tabindex":"-1","role":"dialog","aria-labelledby":"imageModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("ภาพถ่าย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticClass:"img-thumbnail mb-3",staticStyle:{"height":"auto","width":"auto"},attrs:{"src":_vm.modalImageURL}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"45%"}},[_vm._v("หัวข้อ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"40%"}},[_vm._v("คำตอบ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"55%"}},[_vm._v("ชื่ออะไหล่")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("\n                            วันที่เปลี่ยน\n                          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"70%"}},[_vm._v("หัวข้อ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("รูป")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"45%"}},[_vm._v("หัวข้อ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"40%"}},[_vm._v("คำตอบ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"55%"}},[_vm._v("ชื่ออะไหล่")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("\n                            วันที่เปลี่ยน\n                          ")])])])}]


/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รหัสร้านค้า:  ")]),_vm._v(" "),(_vm.AgentType=='AGENT')?_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.dtsCustCode))]):_vm._e(),_vm._v(" "),(_vm.AgentType=='SUB_AGENT')?_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.dtsSubAgentCode))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อร้านค้า:")]),_vm._v(" "),(_vm.AgentType=='AGENT')?_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.dtsCustomerName))]):_vm._e(),_vm._v(" "),(_vm.AgentType=='SUB_AGENT')?_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.dtsSubAgentCustomerName))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อร้านค้า 2:")]),_vm._v(" "),(_vm.AgentType=='AGENT')?_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.dtsCustomerName2))]):_vm._e(),_vm._v(" "),(_vm.AgentType=='SUB_AGENT')?_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.dtsSubAgentCustomerName2))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.dtsCustomerType))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ผู้ร้องขอแก้ไข:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.dtsUserName))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อำเภอ:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.dtsAmpher))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.dtsProvince))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สถานะ:")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.dtsStatus))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("พื้นที่กิจกรรม: ")]),_vm._v(" "),_c('GmapMap',{staticStyle:{"width":"500px","height":"300px"},attrs:{"center":{ lat: _vm.dtsNLat, lng: _vm.dtsNLng },"zoom":12,"clickable":true}},[_vm._l((_vm.dtsMarkers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.positionN,"draggable":false,"clickable":true,"icon":"http://maps.google.com/mapfiles/ms/icons/red-dot.png","title":"พื้นที่ใหม่"}})}),_vm._v(" "),_vm._l((_vm.dtsMarkers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.positionO,"draggable":false,"clickable":true,"icon":"http://maps.google.com/mapfiles/ms/icons/yellow-dot.png","title":"พื้นที่เดิม"}})})],2),_vm._v(" "),_vm._m(1)],1)])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),(_vm.dtsIsApprove === false)?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.onApprove($event)}}},[_c('i',{staticClass:"la la-check"}),_vm._v(" อนุมัติ\n        ")]):_vm._e(),_vm._v(" "),(_vm.dtsIsApprove === false)?_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.onReject($event)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ไม่อนุมัติ\n        ")]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_c('span',{staticStyle:{"color":"red"}},[_vm._v("สีแดง:พื้นที่ใหม่")]),_vm._v(" ,\n                  "),_c('span',{staticStyle:{"color":"#DAA520"}},[_vm._v("สีเหลือง:พื้นที่เดิม")])])}]


/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่องบประมาณ :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bcBudgetName),expression:"bcBudgetName"}],staticClass:"form-control",attrs:{"id":"bcBudgetName","name":"bcBudgetName","type":"text","maxlength":"450","placeholder":"ชื่องบประมาณ"},domProps:{"value":(_vm.bcBudgetName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bcBudgetName=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทงบประมาณ :")]),_vm._v(" "),_c('select2',{ref:"BcBudgetTypeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'bcBudgetType',"name":'bcBudgetType',"select2-options":_vm.bcBudgetTypeOptions},model:{value:(_vm.bcBudgetType),callback:function ($$v) {_vm.bcBudgetType=$$v},expression:"bcBudgetType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("งบประมาณ :")]),_vm._v(" "),_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({locale: _vm.locale, currency: _vm.currency}),expression:"{locale, currency}"}],staticClass:"form-control",attrs:{"id":"bcBudget","name":"bcBudget","auto-decimal-mode:true":"","placeholder":"งบประมาณ"},model:{value:(_vm.bcBudget),callback:function ($$v) {_vm.bcBudget=$$v},expression:"bcBudget"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ใช้ไป :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm._f("currency")(_vm.bcUsed,'฿')))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("คงเหลือ :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm._f("currency")(_vm.BcBalanceCal,'฿')))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ปี :")]),_vm._v(" "),_c('datepicker',{attrs:{"format":_vm.DatePickerFormat,"minimum-view":"year","name":"bcYear","id":"bcYear","input-class":"form-control"},model:{value:(_vm.bcYear),callback:function ($$v) {_vm.bcYear=$$v},expression:"bcYear"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bcStatus),expression:"bcStatus"}],staticClass:"form-check-input",attrs:{"id":"bcStatus","name":"bcStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.bcStatus)?_vm._i(_vm.bcStatus,null)>-1:(_vm.bcStatus)},on:{"change":function($event){var $$a=_vm.bcStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.bcStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.bcStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.bcStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วัน-เวลาเริ่มทำ PM :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.pmStartDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วัน-เวลาสิ้นสุดการทำ PM :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.pmEndDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ระยะเวลาในการทำ PM (นาที) :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.diffMins))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้ทำ PM :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.createUser))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("รูปลายเซ็นต์ :")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.signatureFileUrl && !_vm.isImgCloud)?_c('a',{attrs:{"href":"#","title":"รูปภาพ"},on:{"click":function($event){$event.preventDefault();return _vm.pictureModal(_vm.signatureFileUrl,_vm.signatureFileInfo)}}},[_vm._v("Link")]):_vm._e(),_vm._v(" "),(_vm.signatureFileUrl != null && _vm.isImgCloud)?_c('a',{attrs:{"href":"javascript:void(0);","title":"รูปภาพ"},on:{"click":function($event){return _vm.showModal(_vm.signatureFileUrl,_vm.signatureFileInfo)}}},[_vm._v("Link ")]):_vm._e()])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.machineSpares.length > 0)?_c('div',_vm._l((_vm.machineSpares),function(ms,i){return _c('div',{key:i,staticClass:"kt-section kt-section--first"},[(ms.surveys.length > 0)?_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                การเปลี่ยนอะไหล่ เครื่องทำความเย็น:\n              ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1,true),_vm._v(" "),_c('tbody',_vm._l((ms.surveys),function(msur,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(i + 1)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                            "+_vm._s(msur.questionText)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(msur.answerText)+"\n                          ")])])}),0)])])])])]):_vm._e(),_vm._v(" "),(ms.spares.length > 0)?_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                รายการอะไหล่ เครื่องทำความเย็น:\n              ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(2,true),_vm._v(" "),_c('tbody',_vm._l((ms.spares),function(msp,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(i + 1)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                            "+_vm._s(msp.materialName)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(msp.amount)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(msp.changeDate)+"\n                          ")])])}),0)])])])])]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(_vm.dispensers.length > 0)?_c('div',_vm._l((_vm.dispensers),function(d,i){return _c('div',{key:i,staticClass:"kt-section kt-section--first"},[_c('hr'),_vm._v(" "),(d.cleanUps.length > 0)?_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                การทำความสะอาด เฉพาะหัวจ่ายนี้ ("+_vm._s(d.productBrandName)+"):\n              ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(3,true),_vm._v(" "),_c('tbody',_vm._l((d.cleanUps),function(dc,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(i + 1)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                            "+_vm._s(dc.cleanUpChoiceName)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[(dc.fileUrl && !dc.isImgCloud)?_c('a',{attrs:{"href":"#","title":"รูปภาพ"},on:{"click":function($event){$event.preventDefault();return _vm.pictureModal(dc.fileUrl,dc.fileInfoId)}}},[_vm._v("Link")]):_vm._e(),_vm._v(" "),(dc.fileUrl != null && dc.isImgCloud)?_c('a',{attrs:{"href":"javascript:void(0);","title":"รูปภาพ"},on:{"click":function($event){return _vm.showModal(dc.fileUrl,dc.fileInfoId)}}},[_vm._v("Link ")]):_vm._e()])])}),0)])])])])]):_vm._e(),_vm._v(" "),(d.surveys.length > 0)?_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                การเปลี่ยนอะไหล่ เฉพาะหัวจ่ายนี้ ("+_vm._s(d.productBrandName)+"):\n              ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(4,true),_vm._v(" "),_c('tbody',_vm._l((d.surveys),function(dsur,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(i + 1)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                            "+_vm._s(dsur.questionText)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(dsur.answerText)+"\n                          ")])])}),0)])])])])]):_vm._e(),_vm._v(" "),(d.spares.length > 0)?_c('div',[_c('h3',{staticClass:"kt-section__title"},[_vm._v("\n                รายการอะไหล่ เฉพาะหัวจ่ายนี้ ("+_vm._s(d.productBrandName)+"):\n              ")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(5,true),_vm._v(" "),_c('tbody',_vm._l((d.spares),function(dsp,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(i + 1)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td text-left"},[_vm._v("\n                            "+_vm._s(dsp.materialName)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(dsp.amount)+"\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                            "+_vm._s(dsp.changeDate)+"\n                          ")])])}),0)])])])])]):_vm._e()])}),0):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"imageModal","tabindex":"-1","role":"dialog","aria-labelledby":"imageModalLabel","aria-hidden":"true","data-backdrop":"static","data-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content mr-4"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("ภาพถ่าย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('img',{staticClass:"img-thumbnail mb-3",staticStyle:{"height":"auto","width":"auto"},attrs:{"src":_vm.modalImageURL}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('a',{staticClass:"btn btn-secondary",attrs:{"target":"blank","href":("/Api/File/DownloadImage?FileInfoId=" + _vm.modalImageFileInFo)}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" ดาวน์โหลดรูปภาพ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("หัวข้อ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("คำตอบ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ชื่ออะไหล่")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("\n                            วันที่เปลี่ยน\n                          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("หัวข้อ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("รูป")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("หัวข้อ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("คำตอบ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ชื่ออะไหล่")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("\n                            วันที่เปลี่ยน\n                          ")])])])}]


/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/JobAgentAuditStock'),expression:"$route.path == '/Report/JobAgentAuditStock'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reJrLastActivityDateStart",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reJrLastActivityDateStart","name":"reJrLastActivityDateStart"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reJrLastActivityDateEnd",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reJrLastActivityDateEnd","name":"reJrLastActivityDateEnd"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Week:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reWeek',"name":'reWeek',"select2-options":_vm.reWeekOptions},model:{value:(_vm.reWeek),callback:function ($$v) {_vm.reWeek=$$v},expression:"reWeek"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reAaAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reAaAgentCode),callback:function ($$v) {_vm.reAaAgentCode=$$v},expression:"reAaAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJrProductTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJrProductType),callback:function ($$v) {_vm.reJrProductType=$$v},expression:"reJrProductType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reJrProductBrandOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reJrProductBrand),callback:function ($$v) {_vm.reJrProductBrand=$$v},expression:"reJrProductBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reApMaterialCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reApMaterialCode),callback:function ($$v) {_vm.reApMaterialCode=$$v},expression:"reApMaterialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'reAaStatus',"name":'reAaStatus',"select2-options":_vm.reAaStatusOptions},model:{value:(_vm.reAaStatus),callback:function ($$v) {_vm.reAaStatus=$$v},expression:"reAaStatus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลขที่ใบงาน:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jobNumber),expression:"jobNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก เลขที่ใบงาน"},domProps:{"value":(_vm.jobNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.jobNumber=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportJobStock}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('div',{ref:"topScrollWrapper",staticStyle:{"overflow-x":"auto","overflow-y":"hidden","height":"20px"}},[_c('div',{ref:"topScrollContent",staticStyle:{"height":"1px"}})]),_vm._v(" "),_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"jobStockTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"14"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reJrDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_vm._m(5)])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticStyle:{"background":"#f2f2f2"}},[_c('th',{staticClass:"text-center"},[_vm._v("ปี")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("วัน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Week")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("วันที่เคลื่อนไหวล่าสุด")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"color":"#63A361 !important","background-color":"#E2EFDA !important"}},[_vm._v("ถังเต็ม")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"color":"#BF124D !important","background-color":"#F9DFDF !important"}},[_vm._v("ถังเปล่า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"background-color":"#D9D9D9 !important"}},[_vm._v("ระหว่างใช้งาน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("หมายเหตุ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr',{staticStyle:{"background-color":"#ddd !important"}},[_c('th',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("Grand Total ")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])])}]


/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"PictureModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first text-center"},[_c('img',{staticClass:"img-thumbnail mb-3",staticStyle:{"width":"100%"},attrs:{"src":decodeURIComponent(this.$route.params.url)}})])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")])])}]


/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("รหัสร้านค้า (ตัวแทนจำหน่ายย่อย):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.essaShopSubAgentCode),expression:"essaShopSubAgentCode"}],staticClass:"form-control",attrs:{"id":"essaShopSubAgentCode","name":"essaShopSubAgentCode","type":"text","maxlength":"50","placeholder":"ชื่อร้านค้า (ตัวแทนจำหน่ายย่อย)"},domProps:{"value":(_vm.essaShopSubAgentCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.essaShopSubAgentCode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อร้านค้า (ตัวแทนจำหน่ายย่อย):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.essaShopSubAgentName),expression:"essaShopSubAgentName"}],staticClass:"form-control",attrs:{"id":"essaShopSubAgentName","name":"essaShopSubAgentName","type":"text","maxlength":"256","placeholder":"ชื่อร้านค้า (ตัวแทนจำหน่ายย่อย)"},domProps:{"value":(_vm.essaShopSubAgentName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.essaShopSubAgentName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.essaShopSubAgentName2),expression:"essaShopSubAgentName2"}],staticClass:"form-control",attrs:{"id":"essaShopSubAgentName2","name":"essaShopSubAgentName2","type":"text","maxlength":"256","placeholder":"ชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย)"},domProps:{"value":(_vm.essaShopSubAgentName2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.essaShopSubAgentName2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"essaShopTypeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'essaShopType',"name":'essaShopType',"select2-options":_vm.essaShopTypeOptions},model:{value:(_vm.essaShopType),callback:function ($$v) {_vm.essaShopType=$$v},expression:"essaShopType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทการล้างเครื่อง:  ")]),_vm._v(" "),_c('select2',{ref:"essaShopPMTypeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'essaShopPMType',"name":'essaShopPMType',"select2-options":_vm.essaShopPMTypeOptions},model:{value:(_vm.essaShopPMType),callback:function ($$v) {_vm.essaShopPMType=$$v},expression:"essaShopPMType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("สถานะประเภทร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"eShShopGroupSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'eShShopGroup',"name":'eShShopGroup',"select2-options":_vm.eShShopGroupOptions},model:{value:(_vm.eShShopGroup),callback:function ($$v) {_vm.eShShopGroup=$$v},expression:"eShShopGroup"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ที่อยู่:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.essaAddress),expression:"essaAddress"}],staticClass:"form-control",attrs:{"id":"essaAddress","name":"essaAddress","type":"text","maxlength":"256","placeholder":"ที่อยู่"},domProps:{"value":(_vm.essaAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.essaAddress=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('select2',{ref:"essaProvinceIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'essaProvinceId',"name":'essaProvinceId',"select2-options":_vm.essaProvinceIdOptions},on:{"selectChange":_vm.onProvinceIdChange},model:{value:(_vm.essaProvinceId),callback:function ($$v) {_vm.essaProvinceId=$$v},expression:"essaProvinceId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("อำเภอ:")]),_vm._v(" "),_c('select2',{ref:"essaAmphurIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'essaAmphurId',"name":'essaAmphurId',"select2-options":_vm.essaAmphurIdOptions},on:{"selectChange":_vm.onAmphurIdChange},model:{value:(_vm.essaAmphurId),callback:function ($$v) {_vm.essaAmphurId=$$v},expression:"essaAmphurId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำบล:")]),_vm._v(" "),_c('select2',{ref:"essaTumbolIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'essaTumbolId',"name":'essaTumbolId',"select2-options":_vm.essaTumbolIdOptions},model:{value:(_vm.essaTumbolId),callback:function ($$v) {_vm.essaTumbolId=$$v},expression:"essaTumbolId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อ-สกุลผู้ติดต่อ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.essaContactFullName),expression:"essaContactFullName"}],staticClass:"form-control",attrs:{"id":"essaContactFullName","name":"essaContactFullName","type":"text","maxlength":"256","placeholder":"ชื่อ-สกุลผู้ติดต่อ"},domProps:{"value":(_vm.essaContactFullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.essaContactFullName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อีเมล:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.essaEmail),expression:"essaEmail"}],staticClass:"form-control",attrs:{"id":"essaEmail","name":"essaEmail","type":"text","maxlength":"256","placeholder":"อีเมล"},domProps:{"value":(_vm.essaEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.essaEmail=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.essaTel),expression:"essaTel"}],staticClass:"form-control",attrs:{"id":"essaTel","name":"essaTel","type":"text","maxlength":"256","placeholder":"เบอร์โทร"},domProps:{"value":(_vm.essaTel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.essaTel=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ผู้ดูแลร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"essaShopCodeSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'essaShopCode',"name":'essaShopCode',"select2-options":_vm.essaShopCodeOptions},model:{value:(_vm.essaShopCode),callback:function ($$v) {_vm.essaShopCode=$$v},expression:"essaShopCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อเจ้าหน้าที่ดูแล (ร้านค้า):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.essaContactShopName),expression:"essaContactShopName"}],staticClass:"form-control",attrs:{"id":"essaContactShopName","name":"essaContactShopName","type":"text","maxlength":"256","placeholder":"ชื่อเจ้าหน้าที่ดูแล (ร้านค้า)"},domProps:{"value":(_vm.essaContactShopName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.essaContactShopName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("นามสกุลเจ้าหน้าที่ดูแล (ร้านค้า):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.essaContactShopLName),expression:"essaContactShopLName"}],staticClass:"form-control",attrs:{"id":"essaContactShopLName","name":"essaContactShopLName","type":"text","maxlength":"256","placeholder":"นามสกุลเจ้าหน้าที่ดูแล (ร้านค้า)"},domProps:{"value":(_vm.essaContactShopLName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.essaContactShopLName=$event.target.value}}})])]),_vm._v(" "),(_vm.$root.canShow('super_admin'))?_c('div',{staticClass:"col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เจ้าหน้าที่ดูแล (Boonrawd)")]),_vm._v(" "),_c('select2',{ref:"essaEmpIdSelect2",class:'form-control m-select2',style:('width: 100%;'),attrs:{"id":'essaEmpId',"name":'essaEmpId',"select2-options":_vm.essaEmpIdOptions},model:{value:(_vm.essaEmpId),callback:function ($$v) {_vm.essaEmpId=$$v},expression:"essaEmpId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตั้งค่าระยะ Check-In/Check-Out:")]),_vm._v(" "),_c('div',[_c('label',{staticClass:"kt-radio kt-radio--bold kt-radio--brand",staticStyle:{"margin-right":"30px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.useSettingCheckinRange),expression:"useSettingCheckinRange"}],attrs:{"type":"radio"},domProps:{"value":true,"checked":_vm._q(_vm.useSettingCheckinRange,true)},on:{"change":function($event){_vm.useSettingCheckinRange=true}}}),_vm._v(" กำหนดตามตั้งค่าพื้นฐาน\n                  "),_c('span')]),_vm._v(" "),_c('label',{staticClass:"kt-radio kt-radio--bold kt-radio--brand"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.useSettingCheckinRange),expression:"useSettingCheckinRange"}],attrs:{"type":"radio"},domProps:{"value":false,"checked":_vm._q(_vm.useSettingCheckinRange,false)},on:{"change":function($event){_vm.useSettingCheckinRange=false}}}),_vm._v(" กำหนดเอง\n                  "),_c('span')]),_vm._v(" "),(!_vm.useSettingCheckinRange)?_c('button',{staticClass:"btn btn-sm btn-clean btn-icon",attrs:{"type":"button","title":"ใช้ค่า default"},on:{"click":_vm.resetCheckinRange}},[_c('i',{staticClass:"la la-times"})]):_vm._e()]),_vm._v(" "),(_vm.useSettingCheckinRange && _vm.apiLoadedCheckInRange === null)?_c('div',{staticClass:"alert alert-warning mt-2",staticStyle:{"max-width":"500px"}},[_c('i',{staticClass:"la la-exclamation-triangle"}),_vm._v(" ให้ไป apply ค่าที่หน้า ตั้งค่าพื้นฐาน\n              ")]):_vm._e(),_vm._v(" "),(!_vm.useSettingCheckinRange)?_c('div',{staticClass:"mt-2",staticStyle:{"max-width":"300px"}},[_c('label',{staticClass:"label-required"},[_vm._v("ระยะ (เมตร):")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.customCheckInRange),expression:"customCheckInRange",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1","max":"10000","placeholder":"ระบุระยะ (เมตร)","name":"customCheckInRange"},domProps:{"value":(_vm.customCheckInRange)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.customCheckInRange=_vm._n($event.target.value)},_vm.checkCustomCheckInRangeMax],"change":_vm.checkCustomCheckInRangeMax,"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.customCheckInRangeMaxError)?_c('span',{staticClass:"text-danger small"},[_vm._v(_vm._s(_vm.customCheckInRangeMaxError))]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตำแหน่งที่ตั้ง:")]),_vm._v(" "),(_vm.essaLat === null)?_c('div',[_c('button',{staticClass:"btn m-btn--pill btn-info btn-block col-xl-2",attrs:{"type":"button"},on:{"click":_vm.getMap}},[_vm._v("\n                  ระบุข้อมูลตำแหน่งที่ตั้ง\n                ")])]):_c('div',[_c('GmapMap',{staticStyle:{"width":"500px","height":"300px"},attrs:{"center":{ lat: _vm.essaLat, lng: _vm.essaLng },"zoom":15,"clickable":true},on:{"click":_vm.updateCoordinates}},_vm._l((_vm.essaMarkers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"draggable":true,"clickable":true},on:{"drag":_vm.updateCoordinates,"click":_vm.updateCoordinates}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.openMap()}}},[_c('i',{staticClass:"far fa-map"}),_vm._v(" Open GoogleMaps\n                  ")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn m-btn--pill btn-info btn-block uploader-btn col-xl-2",attrs:{"type":"button"},on:{"click":_vm.uploadFile}},[_c('i',{staticClass:"flaticon-upload-1"}),_vm._v("รูป\n              ")]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"container-img"}},_vm._l((_vm.FileUpload),function(image,index){return _c('div',{key:index,staticClass:"col-md-4 m--margin-top-20 img-wrap"},[(image.isLoaded !== false)?_c('img',{staticClass:"img-plant img-thumbnail card-img-top",attrs:{"src":image.urlImg},on:{"error":function($event){return _vm.handleImageError(image)},"load":function($event){return _vm.handleImageLoad(image)}}}):_c('div',{staticClass:"img-placeholder"},[_vm._v("ไม่สามารถโหลดรูปภาพได้")]),_vm._v(" "),_c('a',{staticClass:"btn m-btn--pill btn-danger m-btn close",staticStyle:{"position":"absolute","top":"10px","right":"20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeImage(image.pictureId)}}},[_c('span',{staticClass:"m--font-inverse-danger la la-trash"})])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.essaInActiveStatus),expression:"essaInActiveStatus"}],staticClass:"form-check-input",attrs:{"id":"essaInActiveStatus","name":"essaInActiveStatus","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.essaInActiveStatus)?_vm._i(_vm.essaInActiveStatus,null)>-1:(_vm.essaInActiveStatus)},on:{"change":function($event){var $$a=_vm.essaInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.essaInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.essaInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.essaInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])]),_vm._v(" "),(this.$root.canShow(['']))?_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("[PM] ตั้งค่าใช้ PM (รูปแบบพิเศษ)")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eShIsSpecialPM),expression:"eShIsSpecialPM"}],staticClass:"form-check-input",attrs:{"id":"eShIsSpecialPM","name":"eShIsSpecialPM","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.eShIsSpecialPM)?_vm._i(_vm.eShIsSpecialPM,null)>-1:(_vm.eShIsSpecialPM)},on:{"change":function($event){var $$a=_vm.eShIsSpecialPM,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.eShIsSpecialPM=$$a.concat([$$v]))}else{$$i>-1&&(_vm.eShIsSpecialPM=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.eShIsSpecialPM=$$c}}}}),_vm._v("\n                เปิดใช้งาน PM (รูปแบบพิเศษ)\n                "),_c('span')])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("รูปภาพ:"),_c('span',{staticClass:"text-sm text-danger",staticStyle:{"font-size":"small"}},[_vm._v("\n                  (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"brandCountBarcodeModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-md",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(row,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.barcodeNoOld))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.departmentMaterialCode))])])}),0)])])])])])])]),_vm._v(" "),_vm._m(1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")])])}]


/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/PaymentProduct'),expression:"$route.path == '/Report/PaymentProduct'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reStartDate","name":"reStartDate"}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._l((_vm.errors),function(error){return (error.name == 'reStartDate')?_c('span',{staticClass:"form-text",staticStyle:{"color":"#fd397a"}},[_vm._v(_vm._s(error.text))]):_vm._e()})],2)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"reEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"reEndDate","name":"reEndDate"}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_vm._l((_vm.errors),function(error){return (error.name == 'reEndDate')?_c('span',{staticClass:"form-text",staticStyle:{"color":"#fd397a"}},[_vm._v(_vm._s(error.text))]):_vm._e()})],2)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("BARCODE:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reBarcode),expression:"reBarcode"}],staticClass:"form-control",attrs:{"id":"reBarcode","type":"text","placeholder":"กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"},domProps:{"value":(_vm.reBarcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reBarcode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reProductTypeId","multiple":true,"options":_vm.reProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reProductTypeId),callback:function ($$v) {_vm.reProductTypeId=$$v},expression:"reProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reProductCode","multiple":true,"options":_vm.reProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reProductCode),callback:function ($$v) {_vm.reProductCode=$$v},expression:"reProductCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reProductBrandId","multiple":true,"options":_vm.reProductBrandIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reProductBrandId),callback:function ($$v) {_vm.reProductBrandId=$$v},expression:"reProductBrandId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("มุมมองผู้ใช้งาน:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reViewPermissionCode","multiple":false,"options":_vm.reViewPermissionOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"input":function($event){return _vm.ChangeOptions('View')}},model:{value:(_vm.reViewPermissionCode),callback:function ($$v) {_vm.reViewPermissionCode=$$v},expression:"reViewPermissionCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.reViewPermissionCode == 'BR_REPORT')?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อคลังสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"rePlantCode","multiple":true,"options":_vm.rePlantCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.rePlantCode),callback:function ($$v) {_vm.rePlantCode=$$v},expression:"rePlantCode"}})],1)]):_vm._e(),_vm._v(" "),(_vm.reViewPermissionCode == 'AGENT_REPORT')?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reAgentCode","multiple":true,"options":_vm.reAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"input":function($event){return _vm.ChangeOptions('reAgentCode')}},model:{value:(_vm.reAgentCode),callback:function ($$v) {_vm.reAgentCode=$$v},expression:"reAgentCode"}})],1)]):_vm._e(),_vm._v(" "),(_vm.reViewPermissionCode == 'SUB_AGENT_REPORT')?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reSubAgentCode","multiple":true,"options":_vm.reSubAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"input":function($event){return _vm.ChangeOptions('reSubAgentCode')}},model:{value:(_vm.reSubAgentCode),callback:function ($$v) {_vm.reSubAgentCode=$$v},expression:"reSubAgentCode"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('treeselect',{ref:"reShopCode",attrs:{"id":"reShopCode","multiple":true,"load-options":_vm.LoadreShopCodeOptions,"async":true,"cacheOptions":false,"searchPromptText":"กรุณาพิมพ์คำที่ต้องการค้นหา","placeholder":"กรุณาเลือก"},on:{"open":_vm.resLoadreShopCodeOptions},model:{value:(_vm.reShopCode),callback:function ($$v) {_vm.reShopCode=$$v},expression:"reShopCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทร้านค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reShopTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reShopTypeId),callback:function ($$v) {_vm.reShopTypeId=$$v},expression:"reShopTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เขตการขาย:")]),_vm._v(" "),_c('treeselect',{ref:"reSalesAreaId",attrs:{"id":"reSalesAreaId","multiple":true,"options":_vm.reSalesAreaIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก","id":'reSalesAreaId',"name":'reSalesAreaId'},on:{"input":function($event){return _vm.ChangeOptions('reSalesAreaId')}},model:{value:(_vm.reSalesAreaId),callback:function ($$v) {_vm.reSalesAreaId=$$v},expression:"reSalesAreaId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("จังหวัด:")]),_vm._v(" "),_c('treeselect',{ref:"reProvinceId",attrs:{"id":"reProvinceId","multiple":true,"options":_vm.reProvinceIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก","id":'reProvinceId',"name":'reProvinceId'},model:{value:(_vm.reProvinceId),callback:function ($$v) {_vm.reProvinceId=$$v},expression:"reProvinceId"}})],1)]),_vm._v(" "),(_vm.reViewPermissionCode == 'BR_REPORT')?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ขนส่ง:")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reTransitId","multiple":true,"options":_vm.reTransitIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTransitId),callback:function ($$v) {_vm.reTransitId=$$v},expression:"reTransitId"}})],1)]):_vm._e(),_vm._v(" "),(_vm.reViewPermissionCode == 'BR_REPORT')?_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สังกัด(ขนส่ง):")]),_vm._v(" "),_c('treeselect',{attrs:{"id":"reTransitType","multiple":true,"options":_vm.reTransitTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reTransitType),callback:function ($$v) {_vm.reTransitType=$$v},expression:"reTransitType"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ผู้ดำเนินการ:")]),_vm._v(" "),_c('treeselect',{ref:"reScanUserId",attrs:{"id":"reScanUserId","multiple":true,"load-options":_vm.LoadreScanUserIdOptions,"async":true,"clear-on-select":true,"placeholder":"กรุณาเลือก","cacheOptions":true},on:{"open":_vm.reLoadreScanUserIdOptions},model:{value:(_vm.reScanUserId),callback:function ($$v) {_vm.reScanUserId=$$v},expression:"reScanUserId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.ExportPaymentProduct($event)}}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"PaymentProductTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"19"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reDateReq)+"\n                  ")])]),_vm._v(" "),(_vm.reViewPermissionCode == 'AGENT_REPORT')?_c('tr',[_c('th',{staticClass:"all text-center"}),_vm._v(" "),_c('th',{staticClass:"all text-center"}),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้ดำเนินการ")])]):_vm._e(),_vm._v(" "),(_vm.reViewPermissionCode == 'SUB_AGENT_REPORT')?_c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่ายย่อย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้ดำเนินการ")])]):_vm._e(),_vm._v(" "),(_vm.reViewPermissionCode == 'BR_REPORT')?_c('tr',[_c('th',{staticClass:"all text-center"}),_vm._v(" "),_c('th',{staticClass:"all text-center"}),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสคลังสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อคลังสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เลขที่ใบงาน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ขนส่ง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("สังกัด(ขนส่ง)")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("วันที่")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ผู้ดำเนินการ")])]):_vm._e()]),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"colspan":"14"}}),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("จำนวนรวม")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.reTotalBarcode))]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"colspan":"2"}})])])])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])}]


/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+" "),_c('strong',[_vm._v(_vm._s(_vm.qiJobNumber))])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext",domProps:{"innerHTML":_vm._s(_vm.qiStatusName)}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(2),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext",domProps:{"innerHTML":_vm._s(_vm.refCode)}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(3),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.createdDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-md-6"},[_c('div',{staticClass:"form-group mb-3"},[_vm._m(4),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.createdUserName))])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"kt-section__body"},[_vm._m(5),_vm._v(" "),_c('span',{staticClass:"form-text mb-3"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-checkable"},[_vm._m(6),_vm._v(" "),_c('tbody',[(_vm.items.length === 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("ไม่พบข้อมูลรายการอะไหล่")])]):_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.qiJobItemId},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.materialNameShow))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatNumber(item.quantity)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.baseUnit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.remark))])])}),_vm._v(" "),_c('tr',[_vm._m(7),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('strong',[_vm._v(_vm._s(_vm.formatNumber(_vm.totalQuantity)))])])])],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("สถานะการดำเนินการ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("เลขที่ใบเบิกสินค้า :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:" mb-0"},[_c('strong',[_vm._v("วันที่สร้าง :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ผู้ดำเนินการ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label mb-0"},[_c('strong',[_vm._v("ข้อมูลรับเข้าอะไหล่ :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table-warning"},[_c('th',{staticClass:"text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("รายการอะไหล่")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("หมายเหตุ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right",attrs:{"colspan":"2"}},[_c('strong',[_vm._v("จำนวนรวม")])])}]


/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-form"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อกลุ่ม:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.uaApproveGroup),expression:"uaApproveGroup"}],staticClass:"form-control",attrs:{"id":"uaApproveGroup","name":"uaApproveGroup","type":"text","maxlength":"450","placeholder":"ชื่อกลุ่มอนุมัติ"},domProps:{"value":(_vm.uaApproveGroup)},on:{"input":function($event){if($event.target.composing){ return; }_vm.uaApproveGroup=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 table-responsive",attrs:{"id":"AddAgent"}},[_c('label',[_vm._v("ตัวแทนจำหน่าย (Agent)")]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.aItems == null || _vm.aItems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"4"}},[_vm._v("คลิก + เพื่อเพิ่มรายการใหม่")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.aItems),function(item,i){return [_c('a-item-row',{key:i,ref:"aItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveAItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddAItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                      ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 table-responsive",attrs:{"id":"AddAgent"}},[_c('label',[_vm._v("พนักงาน (BRT)")]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.brtItems == null || _vm.brtItems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"4"}},[_vm._v("คลิก + เพื่อเพิ่มรายการใหม่")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.brtItems),function(item,i){return [_c('brt-item-row',{key:i,ref:"brtItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveBRTItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddBrtItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                      ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 table-responsive",attrs:{"id":"AddAgent"}},[_c('label',[_vm._v("ลำดับการอนุมัติ")]),_vm._v(" "),_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(3),_vm._v(" "),_c('tbody',[(_vm.apItems == null || _vm.apItems.length == 0)?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"7"}},[_vm._v("คลิก + เพื่อเพิ่มรายการใหม่")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.apItems),function(item,i){return [_c('ap-item-row',{key:i,ref:"apItems",refInFor:true,attrs:{"rowIndex":i,"item":item},on:{"removeItem":_vm.onRemoveAPItemClick}})]})],2),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"7"}},[_c('button',{staticClass:"btn btn-sm btn-brand",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onAddapItemClick($event)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่มรายการใหม่\n                      ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("หมายเหตุ:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.uaRemark),expression:"uaRemark"}],staticClass:"form-control",attrs:{"placeholder":"หมายเหตุ","rows":"5"},domProps:{"value":(_vm.uaRemark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.uaRemark=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label kt-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.uaInActiveStatus),expression:"uaInActiveStatus"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":"uaInActiveStatus","id":"uaInActiveStatus"},domProps:{"checked":Array.isArray(_vm.uaInActiveStatus)?_vm._i(_vm.uaInActiveStatus,null)>-1:(_vm.uaInActiveStatus)},on:{"change":function($event){var $$a=_vm.uaInActiveStatus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.uaInActiveStatus=$$a.concat([$$v]))}else{$$i>-1&&(_vm.uaInActiveStatus=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.uaInActiveStatus=$$c}}}}),_vm._v("\n                  เปิดใช้งาน\n                  "),_c('span')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_vm._m(4)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"2%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("ตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%"}},[_vm._v("เครื่องมือ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"2%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("พนักงาน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%"}},[_vm._v("เครื่องมือ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"2%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("พนักงาน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"5%"}},[_vm._v("ลำดับอนุมัติ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%"}},[_vm._v("สิทธิ์การแก้ไข")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10%"}},[_vm._v("มีสิทธิ์การอนุมัติ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"5%"}},[_vm._v("เครื่องมือ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])}]


/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__head-toolbar"},[_c('router-link',{staticClass:"btn btn-secondary btn-sm",attrs:{"to":"/BudgetPlan/Monitoring"}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" กลับ\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-3"},[_c('label',[_vm._v("วันที่:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterDate),expression:"filterDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.filterDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filterDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xl-3"},[_c('label',[_vm._v("สถานะ:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterStatus),expression:"filterStatus"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterStatus=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("ทั้งหมด")]),_vm._v(" "),_c('option',{attrs:{"value":"PENDING"}},[_vm._v("PENDING")]),_vm._v(" "),_c('option',{attrs:{"value":"SUCCESS"}},[_vm._v("SUCCESS")]),_vm._v(" "),_c('option',{attrs:{"value":"FAILED"}},[_vm._v("FAILED")])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 d-flex align-items-end"},[_c('button',{staticClass:"btn btn-primary mr-2",on:{"click":_vm.loadLogs}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" ค้นหา\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success mr-2",attrs:{"disabled":_vm.isSending},on:{"click":_vm.triggerSend}},[_c('i',{staticClass:"fas fa-paper-plane"}),_vm._v(" "+_vm._s(_vm.isSending ? 'กำลังส่ง...' : 'Send Approval Group')+"\n        ")])])]),_vm._v(" "),(_vm.sendResult)?_c('div',{staticClass:"alert",class:_vm.sendResult.success ? 'alert-success' : 'alert-danger'},[_c('strong',[_vm._v("ส่งอีเมลแจ้งเตือน "+_vm._s(_vm.sendResult.successCount)+" ฉบับ")]),_vm._v("\n      (ผู้รับ "+_vm._s(_vm.sendResult.successCount + _vm.sendResult.failedCount)+" คน, สำเร็จ "+_vm._s(_vm.sendResult.successCount)+", ล้มเหลว "+_vm._s(_vm.sendResult.failedCount)+")\n      "),_c('br'),_vm._v(" "),_c('small',[_vm._v("BatchCode: "+_vm._s(_vm.sendResult.batchCode))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.logs.length === 0)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":"13"}},[_vm._v("ไม่พบข้อมูล")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.logs),function(log,index){return _c('tr',{key:log.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('small',[_vm._v(_vm._s(log.batchCode))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.recipientName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.recipientEmail))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(log.approvalLevel))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(log.jobCount))]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(log.jobIds))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge",class:log.emailType === 'COMBINED' ? 'badge-primary' : 'badge-secondary'},[_vm._v("\n                "+_vm._s(log.emailType === 'COMBINED' ? 'รวมใบงาน' : 'แยกใบงาน')+"\n              ")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge",class:{
                  'badge-warning': log.sendStatus === 'PENDING',
                  'badge-success': log.sendStatus === 'SUCCESS',
                  'badge-danger': log.sendStatus === 'FAILED'
                }},[_vm._v("\n                "+_vm._s(log.sendStatus)+"\n              ")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(log.sendDate ? _vm.formatDate(log.sendDate) : '-'))]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(log.errorMessage))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(log.retryCount))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(log.sendStatus === 'FAILED')?_c('button',{staticClass:"btn btn-sm btn-outline-warning",attrs:{"title":"Retry"},on:{"click":function($event){return _vm.retryEmail(log.id)}}},[_c('i',{staticClass:"fas fa-redo"})]):_vm._e()])])})],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("Budget Plan — Email Monitoring")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("BatchCode")]),_vm._v(" "),_c('th',[_vm._v("ผู้รับ")]),_vm._v(" "),_c('th',[_vm._v("อีเมล")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("จำนวนใบงาน")]),_vm._v(" "),_c('th',[_vm._v("JobIds")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ประเภท")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("วันที่ส่ง")]),_vm._v(" "),_c('th',[_vm._v("Error")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Retry")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("คำสั่ง")])])])}]


/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []


/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"SurveyPictureModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-md",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first text-center"},[_c('img',{staticClass:"img-thumbnail mb-3",staticStyle:{"height":"auto","width":"auto"},attrs:{"src":'/Api/MasterFile/FromUrl?url=' +
                        encodeURIComponent(this.$route.params.url)}})])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")])])}]


/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fss-pdfsig",attrs:{"data-test":_vm.testId}},[_c('div',{staticClass:"fss-pdfsig__sign"},[(_vm.src)?_c('img',{staticClass:"fss-pdfsig__image",attrs:{"src":_vm.src,"alt":_vm.alt,"data-test":"fss-pdfsig-image"},on:{"load":function($event){return _vm.$emit('load', $event)},"click":function($event){return _vm.$emit('zoom')}}}):_c('span',{staticClass:"fss-pdfsig__empty",attrs:{"data-test":"fss-pdfsig-empty"}},[_vm._v(_vm._s(_vm.emptyText))])]),_vm._v(" "),_c('img',{staticClass:"fss-pdfsig__barcode",attrs:{"src":"/images/fss-signature-qr-box.png","alt":"QR ระบบเบียร์สด https://dbs.boonrawd.co.th","data-test":"fss-pdfsig-barcode"}}),_vm._v(" "),_c('div',{staticClass:"fss-pdfsig__text fss-pdfsig__dots",attrs:{"data-test":"fss-pdfsig-dots"}},[_vm._v(_vm._s(_vm.dots))]),_vm._v(" "),_c('div',{staticClass:"fss-pdfsig__text fss-pdfsig__by",attrs:{"data-test":"fss-pdfsig-by"}},[_vm._v("( จัดทำโดย )")])])}
var staticRenderFns = []


/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('form',{ref:"form",staticClass:"kt-form"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Invoice No :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.ordInvoiceNo))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Invoice Date :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.ordInvoiceDate))])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Supplier :")]),_vm._v(" "),_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.ordSupplier))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("แนบไฟล์:")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ordDownloadUrl != null),expression:"ordDownloadUrl != null"}]},[_c('span',{staticClass:"form-control-plaintext"},[_vm._v(_vm._s(_vm.ordFileName))]),_vm._v(" "),_c('a',{attrs:{"href":_vm.ordDownloadUrl,"target":"_blank"}},[_vm._v("Download")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('div',{staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้า/ทรัพย์สิน:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1),_vm._v(" "),_c('tbody',[_vm._l((_vm.ordStocks),function(row,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-center stock-item-td"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"stock-item-td"},[_vm._v(_vm._s(row.materialName))]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v(_vm._s(row.qty))]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(row.price,"฿", 2))+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-center stock-item-td"},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(row.summaryItem,"฿", 2))+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"stock-item-td"},[_vm._v(_vm._s(row.budgetName))]),_vm._v(" "),_c('td',{staticClass:"stock-item-td"},[_vm._v(_vm._s(row.quotaName))])])}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_vm._v("Total")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.oddTotalQty,"", 0))+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.oddTotalPrice,"฿", 2))+"\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                        "+_vm._s(_vm._f("currency")(_vm.oddTotalSum,"฿", 2))+"\n                      ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("รหัส/ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"7%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ราคา")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"13%"}},[_vm._v("รวม")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("งบประมาณ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("โควต้า")])])])}]


/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ประเภทการเคลม:")]),_vm._v(" "),_c('select2',{ref:"apmrTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'abcClaimTypeCode',"name":'abcClaimTypeCode',"select2-options":_vm.abcClaimTypeCodeOptions},on:{"selectChange":_vm.onClaimTypeCodeChange},model:{value:(_vm.abcClaimTypeCode),callback:function ($$v) {_vm.abcClaimTypeCode=$$v},expression:"abcClaimTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'"}],staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"abcAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcAgentCode',"name":'abcAgentCode',"select2-options":_vm.abcAgentCodeOptions},on:{"selectChange":_vm.onAgentCodeChange},model:{value:(_vm.abcAgentCode),callback:function ($$v) {_vm.abcAgentCode=$$v},expression:"abcAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"}],staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"abcShopCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcShopCode',"name":'abcShopCode',"select2-options":_vm.abcShopCodeOptions},on:{"selectChange":_vm.onShopCodeChange},model:{value:(_vm.abcShopCode),callback:function ($$v) {_vm.abcShopCode=$$v},expression:"abcShopCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อำเภอ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcAmpher),expression:"abcAmpher"}],staticClass:"form-control",attrs:{"id":"abcAmpher","name":"abcAmpher","type":"text","maxlength":"450","placeholder":"อำเภอ","disabled":""},domProps:{"value":(_vm.abcAmpher)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcAmpher=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcProvince),expression:"abcProvince"}],staticClass:"form-control",attrs:{"id":"abcProvince","name":"abcProvince","type":"text","maxlength":"450","placeholder":"จังหวัด","disabled":""},domProps:{"value":(_vm.abcProvince)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcProvince=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcPhone),expression:"abcPhone"}],staticClass:"form-control",attrs:{"id":"abcPhone","name":"abcPhone","type":"text","maxlength":"450","placeholder":"เบอร์โทร","disabled":""},domProps:{"value":(_vm.abcPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcPhone=$event.target.value}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode != null && (_vm.abcAgentCode != null || _vm.abcShopCode != null) && (_vm.abcAgentCode != '' || _vm.abcShopCode != '')),expression:"abcClaimTypeCode != null && (abcAgentCode != null || abcShopCode != null) && (abcAgentCode != '' || abcShopCode != '')"}],staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้าเคลม:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(
                        _vm.abcClaimItems == null || _vm.abcClaimItems.length == 0
                      )?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.abcClaimItems),function(item,i){return [_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.productBrand))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.material))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.barcodeOld))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.depCode))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.problemType))]),_vm._v(" "),_c('td',[_c('center',[_c('button',{staticClass:"btn btn-outline-hover-warning btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onEditItemClick(i)}}},[_c('i',{staticClass:"text-warning la la-edit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveItemClick(i)}}},[_c('i',{staticClass:"text-danger la la-trash"})])])],1)])]})],2),_vm._v(" "),(_vm.abcClaimItems == null || _vm.abcClaimItems.length == 0)?_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"9"}},[(this.$root.canShow(['ADMIN_BEER_CLAIM', 'AGENT_ADMIN_BEER_CLAIM']))?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":'Add/AddItem/add_' + _vm.index,"tag":"button","title":"เพิ่ม Claim Item"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" เพิ่ม Claim Item\n                        ")]):_vm._e()],1)])]):_vm._e()])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),_vm._m(2)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ปัญหาที่พบ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("คำสั่ง")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")])}]


/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"createFolderELearningModal","tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(this.$route.meta.breadcrumb))]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-required"},[_vm._v("ชื่อหมวดหมู่")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cfelFolderName),expression:"cfelFolderName"}],staticClass:"form-control",attrs:{"type":"text","id":"cfelFolderName","name":"cfelFolderName"},domProps:{"value":(_vm.cfelFolderName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cfelFolderName=$event.target.value}}})])])])])])]),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึก\n          ")])])}]


/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/KegRotationScoreAgent'),expression:"$route.path == '/Report/KegRotationScoreAgent'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n            ")])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("เดือน/ปี:")]),_vm._v(" "),_c('input',{ref:"monthYearPicker",staticClass:"form-control",attrs:{"type":"text","placeholder":"เลือกเดือน/ปี","readonly":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.productTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.productType),callback:function ($$v) {_vm.productType=$$v},expression:"productType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("สถานะ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.barcodeStatusCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.barcodeStatusCode),callback:function ($$v) {_vm.barcodeStatusCode=$$v},expression:"barcodeStatusCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อตัวแทนจำหน่าย:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.agentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.agentCode),callback:function ($$v) {_vm.agentCode=$$v},expression:"agentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.materialCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.materialCode),callback:function ($$v) {_vm.materialCode=$$v},expression:"materialCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ช่วงคงค้าง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.retentionPeriodOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.retentionPeriod),callback:function ($$v) {_vm.retentionPeriod=$$v},expression:"retentionPeriod"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อตัวแทนจำหน่าย(Group):")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.headAgentCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.headAgentCode),callback:function ($$v) {_vm.headAgentCode=$$v},expression:"headAgentCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ชื่อแบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{ref:"ProductIdBrand",attrs:{"id":"ProductIdBrand","multiple":true,"options":_vm.filteredProductBrandOptions,"placeholder":"กรุณาเลือก"},model:{value:(_vm.productBrand),callback:function ($$v) {_vm.productBrand=$$v},expression:"productBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("ประเภทผู้ถือครอง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.ownerTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.ownerType),callback:function ($$v) {_vm.ownerType=$$v},expression:"ownerType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group mb-3"},[_c('label',{staticClass:"mb-1"},[_vm._v("แบรนด์สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.brandOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},on:{"select":_vm.BrandIdClearAfterSelect,"deselect":_vm.BrandIdClearAfterDeSelect},model:{value:(_vm.brand),callback:function ($$v) {_vm.brand=$$v},expression:"brand"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary mr-2",attrs:{"type":"button"},on:{"click":_vm.exportCompareReport}},[_vm._m(2)]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":_vm.exportMachineScore}},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-0"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{ref:"topScrollWrapper",staticStyle:{"overflow-x":"auto","overflow-y":"hidden","height":"20px"}},[_c('div',{ref:"topScrollContent",staticStyle:{"height":"1px"}})]),_vm._v(" "),_c('table',{ref:"kegRotationTable",staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"}},[_c('thead',[(_vm.dataAsOfLabel)?_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"13"}},[_c('span',[_vm._v(_vm._s(_vm.dataAsOfLabel))])])]):_vm._e(),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_vm._m(6)])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-chart-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"criteriaModal","tabindex":"-1","role":"dialog","aria-labelledby":"criteriaModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"criteriaModalLabel"}},[_vm._v("เงื่อนไขการคำนวณคะแนนรายงานนี้")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"criteria-section"},[_c('p',{staticClass:"mb-2"},[_c('strong',[_vm._v("ประเภทสินค้า : ถัง/ท่อ")])]),_vm._v(" "),_c('div',{staticClass:"criteria-headers mb-3"},[_c('span',{staticClass:"col-label"},[_vm._v("เงื่อนไข")]),_vm._v(" "),_c('span',{staticClass:"col-label"},[_vm._v("เกณฑ์การให้คะแนน")])]),_vm._v(" "),_c('p',{staticClass:"product-title"},[_c('strong',[_vm._v("ถังเบียร์สด")])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"season-title high"},[_vm._v("High Season")]),_vm._v(" "),_c('div',{staticClass:"criteria-box"},[_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("<=3 Months")]),_c('span',[_vm._v("1 - 90 วัน")]),_c('span',[_vm._v("40 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("3-4 Months")]),_c('span',[_vm._v("91-120 วัน")]),_c('span',[_vm._v("20 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("4 Months")]),_c('span',[_vm._v("121 วัน ขึ้นไป")]),_c('span',[_vm._v("10 คะแนน")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"season-title low"},[_vm._v("Low Season")]),_vm._v(" "),_c('div',{staticClass:"criteria-box"},[_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("<=5 Months")]),_c('span',[_vm._v("1 - 150 วัน")]),_c('span',[_vm._v("40 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("5-6 Months")]),_c('span',[_vm._v("151-180 วัน")]),_c('span',[_vm._v("20 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("6 Months")]),_c('span',[_vm._v("181 วัน ขึ้นไป")]),_c('span',[_vm._v("10 คะแนน")])])])])]),_vm._v(" "),_c('p',{staticClass:"product-title"},[_c('strong',[_vm._v("ท่อ CO2")])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"season-title high"},[_vm._v("High Season")]),_vm._v(" "),_c('div',{staticClass:"criteria-box"},[_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("<=5 Months")]),_c('span',[_vm._v("1 - 150 วัน")]),_c('span',[_vm._v("40 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("5-6 Months")]),_c('span',[_vm._v("151-180 วัน")]),_c('span',[_vm._v("20 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("6 Months")]),_c('span',[_vm._v("181 วัน ขึ้นไป")]),_c('span',[_vm._v("10 คะแนน")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"season-title low"},[_vm._v("Low Season")]),_vm._v(" "),_c('div',{staticClass:"criteria-box"},[_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("<=5 Months")]),_c('span',[_vm._v("1 - 150 วัน")]),_c('span',[_vm._v("40 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("5-6 Months")]),_c('span',[_vm._v("151-180 วัน")]),_c('span',[_vm._v("20 คะแนน")])]),_vm._v(" "),_c('div',{staticClass:"criteria-row"},[_c('span',[_vm._v("6 Months")]),_c('span',[_vm._v("181 วัน ขึ้นไป")]),_c('span',[_vm._v("10 คะแนน")])])])])]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("\n                  ช่วง "),_c('strong',{staticStyle:{"color":"rgb(10, 187, 135)"}},[_vm._v("High Season")]),_vm._v(" มีจำนวน 6 เดือน [ เดือน ม.ค. , ก.พ. , มี.ค. , ต.ค. , พ.ย. , ธ.ค. ]\n                  "),_c('u',[_vm._v("ถังเบียร์สดทุกสินค้า คงค้างไม่เกิน 3 เดือน [ 90 วัน ]")])]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v("\n                  ช่วง "),_c('strong',{staticStyle:{"color":"#C00000"}},[_vm._v("LOW Season")]),_vm._v(" มีจำนวน 6 เดือน [ เดือน เม.ย. , พ.ค. , มิ.ย. , ก.ค. , ส.ค. , ก.ย. ] ถัง / ท่อ เบียร์สดทุกสินค้า คงค้างไม่เกิน 5 เดือน [ 150 วัน ] เท่ากัน\n                ")]),_vm._v(" "),_c('p',{staticClass:"mb-1"},[_c('strong',[_vm._v("หมายเหตุสำคัญ :")])]),_vm._v(" "),_c('ul',{staticClass:"mb-0",staticStyle:{"padding-left":"20px"}},[_c('li',[_vm._v("วันคงค้าง เริ่มนับวัน ตั้งแต่วันที่รับสินค้าจากโรงงาน (วันที่รับ = วันที่ 0 วัน)")]),_vm._v(" "),_c('li',[_vm._v("สินค้าประเภทท่อเบียร์สด ช่วง "),_c('strong',[_vm._v("High Season")]),_vm._v(" และ "),_c('strong',[_vm._v("LOW Season")]),_vm._v(" คงค้างไม่เกิน 5 เดือน [ 150 วัน ] เท่ากัน จำนวนที่แสดงในรายงานจะรวมมาแสดงเฉพาะที่ช่วงคงค้าง Low Season เท่านั้นไม่ไปแสดงที่คอลัมน์ ช่วง "),_c('strong',[_vm._v("High Season")]),_vm._v(" เพื่อไม่เกิดความสับสนในการดูข้อมูล")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("ปิด")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel (สำหรับตรวจสอบข้อมูล)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel (สรุปข้อมูลจากรายงาน)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"rowspan":"2"}},[_vm._v("รหัสตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#808080 !important","color":"#ffffff !important"},attrs:{"colspan":"3"}},[_vm._v("ช่วงคงค้าง High Season")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important"},attrs:{"rowspan":"2"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#808080 !important","color":"#63C8FF !important"},attrs:{"colspan":"3"}},[_vm._v("ช่วงคงค้าง Low Season")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important"},attrs:{"rowspan":"2"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important"},attrs:{"rowspan":"2"}},[_vm._v("Total จำนวน")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#ABE7B2 !important","color":"rgb(10, 187, 135) !important"}},[_vm._v("ไม่เกิน 3 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#FFFBB1 !important"}},[_vm._v("ไม่เกิน 4 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#F8CBAD !important","color":"#C00000 !important"}},[_vm._v("เกิน 4 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#ABE7B2 !important","color":"rgb(10, 187, 135) !important"}},[_vm._v("ไม่เกิน 5 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#FFFBB1 !important"}},[_vm._v("ไม่เกิน 6 เดือน")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"font-size":"0.9em !important","background-color":"#F8CBAD !important","color":"#C00000 !important"}},[_vm._v("เกิน 6 เดือน")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr',[_c('th',{staticStyle:{"text-align":"center"},attrs:{"colspan":"4"}},[_vm._v("Grand Total")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])])}]


/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/BeerClaim/Claim'),expression:"$route.path == '/BeerClaim/Claim'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bcSearch),expression:"bcSearch"}],staticClass:"form-control",attrs:{"id":"bcSearch","name":"bcSearch","type":"text","placeholder":"ค้นหาจากเลขที่เคลม เลขที่ Invoice หรือ หมายเลข BARCODE"},domProps:{"value":(_vm.bcSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bcSearch=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group "},[_c('label',{staticClass:"label"},[_vm._v("วันที่เริ่มต้น:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bcStartDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bcStartDate","name":"bcStartDate"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("วันที่สิ้นสุด:")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"bcEndDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"(วว/ดด/ปปปป)","id":"bcEndDate","name":"bcEndDate"}}),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทการเคลม:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'bcClaimTypeCode',"name":'bcClaimTypeCode',"select2-options":_vm.bcClaimTypeCodeOptions},model:{value:(_vm.bcClaimTypeCode),callback:function ($$v) {_vm.bcClaimTypeCode=$$v},expression:"bcClaimTypeCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("สถานะการเคลม:")]),_vm._v(" "),_c('select2',{ref:"bcClaimStatusCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'bcClaimStatusCode',"name":'bcClaimStatusCode',"select2-options":_vm.bcClaimStatusCodeOptions},model:{value:(_vm.bcClaimStatusCode),callback:function ($$v) {_vm.bcClaimStatusCode=$$v},expression:"bcClaimStatusCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"}),_vm._v(" "),(this.$root.canShow(['ADMIN_BEER_CLAIM','MANAGER_BEER_CLAIM']))?_c('label',{staticClass:"kt-checkbox kt-checkbox--brand"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bcClaimStatusCancel),expression:"bcClaimStatusCancel"}],attrs:{"type":"checkbox"},domProps:{"value":false,"checked":Array.isArray(_vm.bcClaimStatusCancel)?_vm._i(_vm.bcClaimStatusCancel,false)>-1:(_vm.bcClaimStatusCancel)},on:{"change":function($event){var $$a=_vm.bcClaimStatusCancel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=false,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.bcClaimStatusCancel=$$a.concat([$$v]))}else{$$i>-1&&(_vm.bcClaimStatusCancel=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.bcClaimStatusCancel=$$c}}}}),_vm._v("\n                  แสดงใบคำร้องขอเคลมเบียร์สด สถานะยกเลิกแจ้งเคลม\n                  "),_c('span')]):_vm._e()],1)]),_vm._v(" "),(this.$root.canShow(['LAB_BEER_CLAIM', 'ADMIN_PLANT_BEER_CLAIM', 'MANAGER_BEER_CLAIM', 'ADMIN_BEER_CLAIM', 'PLANT_ACCOUNTANT_BEER_CLAIM']))?_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("เลือกตรวจสอบใบเคลม/เลือกปริ้นใบ CCR:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":false,"options":_vm.bcClaimShowDocCCROptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.bcClaimShowDocCCR),callback:function ($$v) {_vm.bcClaimShowDocCCR=$$v},expression:"bcClaimShowDocCCR"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[(
                  this.$root.canShow([
                    // 'ADMIN_BEER_CLAIM',
                    'AGENT_ADMIN_BEER_CLAIM' ])
                )?_c('router-link',{staticClass:"btn btn-outline-brand",attrs:{"to":"Claim/Add","tag":"button","title":"เพิ่มข้อมูล"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" เพิ่มข้อมูล\n              ")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(3)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-edit"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"claimTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all"},[_vm._v("เลขที่เคลม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("ประเภทการเคลม")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อผู้เคลม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เลขที่ Invoice")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("สถานะการเคลม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("วันที่เคลม")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("เอกสาร")]),_vm._v(" "),_c('th',{staticClass:"all"},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),(_vm.branchLine)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"fss-branch-line",attrs:{"data-test":"fss-group-branch-line"}},[_vm._v("\n            "+_vm._s(_vm.branchLine)+"\n          ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h5',{staticClass:"kt-font-bold kt-margin-b-10"},[_vm._v("Filter ที่เลือก")]),_vm._v(" "),(_vm.filterText)?_c('div',{staticClass:"fss-filter-text"},[_vm._v("\n            "+_vm._s(_vm.filterText)+"\n          ")]):(_vm.filterLabels.length > 0)?_c('table',{staticClass:"table table-sm fss-filter-table"},[_c('tbody',_vm._l((_vm.filterLabels),function(item,index){return _c('tr',{key:index},[_c('td',{staticClass:"fss-filter-table__label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.text))])])}),0)]):_c('div',{staticClass:"text-muted"},[_vm._v("-")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"fss-export-box"},[_c('button',{staticClass:"btn btn-sm btn-success",attrs:{"type":"button","disabled":_vm.isNoData || _vm.isExporting,"data-test":"fss-group-export"},on:{"click":_vm.exportExcel}},[_c('i',{staticClass:"la la-file-excel-o"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("Export Excel ตรวจรายละเอียด")])]),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"kt-separator kt-separator--border-dashed kt-separator--space-sm"}),_vm._v(" "),(_vm.isNoData)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-secondary text-center",attrs:{"role":"alert"}},[_c('div',{staticClass:"kt-font-bold"},[_vm._v("ไม่พบข้อมูล")]),_vm._v(" "),_c('div',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.noDataMessage))])])])]):_vm._e(),_vm._v(" "),(!_vm.isNoData)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 fss-preview__search"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agentKeyword),expression:"agentKeyword"}],staticClass:"form-control",attrs:{"type":"text","data-test":"fss-preview-search","placeholder":"ค้นหารหัส/ชื่อตัวแทนจำหน่าย..."},domProps:{"value":(_vm.agentKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.agentKeyword=$event.target.value}}}),_vm._v(" "),(_vm.agentKeyword)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-test":"fss-preview-search-clear","title":"ล้างคำค้น"},on:{"click":function($event){_vm.agentKeyword = ''}}},[_c('i',{staticClass:"la la-close"})])]):_vm._e()]),_vm._v(" "),(_vm.agentKeyword)?_c('div',{staticClass:"fss-preview__search-count",attrs:{"data-test":"fss-preview-search-count"}},[_vm._v("\n            แสดง "+_vm._s(_vm.agentsWithData.length + _vm.agentsWithoutData.length + _vm.failedAgents.length)+" จาก\n            "+_vm._s(_vm.agentCount)+" รายการ\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.isNoData || _vm.allFailedAgents.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered table-hover"},[_vm._m(5),_vm._v(" "),_c('tbody',[_vm._l((_vm.agentsWithData),function(agent){return [_c('tr',{key:agent.agentCode,attrs:{"data-test":"fss-group-agent-row"}},[_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md",attrs:{"type":"button","title":_vm.isExpanded(agent.agentCode) ? 'ซ่อนรายละเอียด' : 'แสดงรายละเอียด'},on:{"click":function($event){return _vm.toggleDetail(agent.agentCode)}}},[_c('i',{class:_vm.isExpanded(agent.agentCode)
                            ? 'la la-angle-down'
                            : 'la la-angle-right'})])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(agent.seqNo))]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(_vm.agentLabel(agent))+"\n                    "),_vm._v(" "),(agent.branchLine)?_c('div',{staticClass:"fss-branch-line",attrs:{"data-test":"fss-group-agent-branch-line"}},[_vm._v("\n                      "+_vm._s(agent.branchLine)+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatQty(agent.totalQty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatAmount(agent.totalAmount)))])]),_vm._v(" "),(_vm.isExpanded(agent.agentCode))?_c('tr',{key:agent.agentCode + '__detail',staticClass:"fss-detail-row"},[_c('td',{attrs:{"colspan":"5"}},[_c('div',{staticClass:"fss-detail"},[_c('div',{staticClass:"fss-detail__title"},[_vm._v("\n                        รายละเอียดสินค้าคงค้าง — "+_vm._s(_vm.agentNameOnly(agent))+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered"},[_vm._m(6,true),_vm._v(" "),_c('tbody',_vm._l((agent.details),function(row,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.seqNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productTypeName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.productName))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatQty(row.qty)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.unitName))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.formatAmount(row.amount)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"fss-total-row"},[_c('td',{staticClass:"text-right kt-font-bold",attrs:{"colspan":"4"}},[_vm._v("\n                                Grand Total\n                              ")]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v("\n                                "+_vm._s(_vm.formatQty(agent.totalQty))+"\n                              ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("—")]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v("\n                                "+_vm._s(_vm.formatAmount(agent.totalAmount))+"\n                              ")])])])])])])])]):_vm._e()]}),_vm._v(" "),(_vm.agentsWithoutData.length > 0)?_c('tr',{staticClass:"fss-skip-sep"},[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("\n                  — ตัวแทนจำหน่ายที่ไม่มีข้อมูลคงค้าง\n                  ("+_vm._s(_vm.agentsWithoutData.length)+" ราย · ระบบจะข้ามไม่สร้างเอกสาร) —\n                ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.agentsWithoutData),function(agent){return _c('tr',{key:agent.agentCode,staticClass:"fss-skip-row"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(agent.seqNo))]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(_vm.agentLabel(agent))+"\n                  "),_vm._v(" "),(agent.branchLine)?_c('div',{staticClass:"fss-branch-line",attrs:{"data-test":"fss-group-agent-branch-line"}},[_vm._v("\n                    "+_vm._s(agent.branchLine)+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("—")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("—")])])}),_vm._v(" "),(_vm.failedAgents.length > 0)?_c('tr',{staticClass:"fss-skip-sep fss-failed-sep",attrs:{"data-test":"fss-group-failed-sep"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("\n                  — ตัวแทนจำหน่ายที่ติดขัด ไม่สามารถเรียกข้อมูลได้\n                  ("+_vm._s(_vm.failedAgents.length)+" ราย · ไม่ถูกนำไปสร้างเอกสารในรอบนี้\n                  ต้องสร้างเอกสารของรายนี้ภายหลัง) —\n                ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.failedAgents),function(agent){return _c('tr',{key:'failed-' + agent.agentCode,staticClass:"fss-skip-row fss-failed-row",attrs:{"data-test":"fss-group-failed-row"}},[_c('td'),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(agent.seqNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.agentLabel(agent)))]),_vm._v(" "),_c('td',{staticClass:"text-center fss-failed-note",attrs:{"colspan":"2"}},[_vm._v("\n                  "+_vm._s(agent.message || "ติดขัด ไม่สามารถเรียกข้อมูลได้")+"\n                  "),(agent.errorReference)?_c('span',{staticClass:"fss-failed-ref"},[_vm._v("\n                    (เลขอ้างอิง "+_vm._s(agent.errorReference)+")\n                  ")]):_vm._e()])])})],2),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"fss-total-row"},[_c('td',{staticClass:"text-right kt-font-bold",attrs:{"colspan":"3"}},[_vm._v("\n                  Grand Total (จะสร้างเอกสาร "+_vm._s(_vm.documentCount)+" เอกสาร\n                  จากทั้งหมด "+_vm._s(_vm.agentCount)+" ตัวแทนจำหน่าย)\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v(_vm._s(_vm.formatQty(_vm.totalQty)))]),_vm._v(" "),_c('td',{staticClass:"text-right kt-font-bold"},[_vm._v("\n                  "+_vm._s(_vm.formatAmount(_vm.totalAmount))+"\n                ")])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kt-separator kt-separator--border-dashed kt-separator--space-sm"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-auto"},[_c('button',{staticClass:"btn btn-sm btn-clean kt-margin-r-10",attrs:{"type":"button"},on:{"click":_vm.goBackToFilter}},[_c('i',{staticClass:"la la-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v("แก้ไข Filter")])])]),_vm._v(" "),_c('div',{staticClass:"col-xl text-right"},[_c('div',{staticClass:"fss-action-group"},[(_vm.canManageSignature)?_c('button',{staticClass:"btn btn-sm kt-margin-r-10 fss-signature-btn",class:_vm.hasSignature ? 'btn-success' : 'btn-clean',attrs:{"type":"button","title":'ลายเซ็นที่จะใช้กับทั้ง ' + _vm.documentCount +
              ' เอกสารในชุดนี้ — คลิกเพื่อเปลี่ยน (เฉพาะแอดมินทีมเบียร์สด)',"data-test":"fss-group-open-signature"},on:{"click":_vm.openSignature}},[_c('i',{class:_vm.hasSignature ? 'la la-check' : 'la la-pencil'}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v(_vm._s(_vm.signatureButtonText))]),_vm._v(" "),(_vm.signatureImageUrl)?_c('img',{staticClass:"fss-signature-thumb",attrs:{"src":_vm.signatureImageUrl,"alt":"ลายเซ็นผู้จัดทำ","data-test":"fss-group-signature-thumb"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"fss-signature-scope",attrs:{"data-test":"fss-group-signature-scope"}},[_vm._v("\n              ใช้กับทั้ง "+_vm._s(_vm.documentCount)+" เอกสาร\n            ")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary kt-margin-r-10",attrs:{"type":"button","disabled":_vm.isNoData,"data-test":"fss-group-save"},on:{"click":_vm.saveDocuments}},[_c('i',{staticClass:"la la-save"}),_vm._v(" "),_c('span',{staticClass:"kt-hidden-mobile"},[_vm._v(_vm._s(_vm.saveButtonText))])])])])])]),_vm._v(" "),_c('FormSummaryStockProgressModal',{ref:"progressModal",on:{"finished":_vm.onBatchFinished,"closed":_vm.onBatchClosed}}),_vm._v(" "),_c('FormSummaryStockSignatureModal',{ref:"signatureModal",on:{"selected":_vm.onSignatureSelected,"changed":_vm.loadDefaultSignature}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fas fa-file-alt"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          ตรวจสอบข้อมูลก่อนสร้างเอกสารรวม\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"fss-stepper"},[_c('div',{staticClass:"fss-step fss-step--done"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("✓")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("เลือก Filter")])]),_vm._v(" "),_c('div',{staticClass:"fss-connector fss-connector--done"}),_vm._v(" "),_c('div',{staticClass:"fss-step fss-step--active"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("ตรวจสอบข้อมูล")])]),_vm._v(" "),_c('div',{staticClass:"fss-connector"}),_vm._v(" "),_c('div',{staticClass:"fss-step"},[_c('div',{staticClass:"fss-step__badge"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"fss-step__title"},[_vm._v("บันทึก + สร้างเอกสาร")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('strong',[_vm._v("ยังไม่บันทึก")]),_vm._v(" —\n            ตรวจสอบข้อมูลด้านล่างให้ครบถ้วน จากนั้นกด \"บันทึกข้อมูล\"\n            เพื่อสร้างเอกสารทีละฉบับให้ตัวแทนจำหน่ายที่มีข้อมูล\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fss-export-box__note text-muted",attrs:{"data-test":"fss-group-export-note"}},[_vm._v("\n              ไฟล์นี้เป็น "),_c('strong',[_vm._v("ไฟล์ชั่วคราวสำหรับตรวจ")]),_vm._v(" —\n              ระบบไม่บันทึกไว้ในระบบ\n              (หลังกดบันทึกข้อมูล เอกสารแต่ละฉบับจะมี Excel ของตัวเอง)\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"5%"}}),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"8%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("ชื่อตัวแทนจำหน่าย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"16%"}},[_vm._v("จำนวนคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"22%"}},[_vm._v("ยอดรวม (ก่อน VAT)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"7%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"18%"}},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"15%"}},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"27%"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12%"}},[_vm._v("จำนวนคงค้าง")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"8%"}},[_vm._v("หน่วย")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"13%"}},[_vm._v("\n                                จำนวนเงิน (ก่อน VAT)\n                              ")])])])}]


/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/QC/QCCheckIn'),expression:"$route.path == '/QC/QCCheckIn'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":_vm.formSubmit}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("คำค้นหา:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chlKeyword),expression:"chlKeyword"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ค้นหาจาก ชื่อ-สกุลผู้เช็คอิน คะแนนรวม"},domProps:{"value":(_vm.chlKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chlKeyword=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่เช็คอิน :")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"chlCheckInDate",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"วันที่เช็คอิน (วว/ดด/ปปปป)","id":"chlCheckInDate","name":"chlCheckInDate"}}),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"chlShopIdsSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'chlShopIds',"name":'chlShopIds',"select2-options":_vm.chlShopIdsOptions,"multiple":""},model:{value:(_vm.chlShopIds),callback:function ($$v) {_vm.chlShopIds=$$v},expression:"chlShopIds"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้าตัวแทนจำหน่ายย่อย:")]),_vm._v(" "),_c('select2',{ref:"chlSubShopIdsSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'chlSubShopIds',"name":'chlSubShopIds',"select2-options":_vm.chlSubShopIdsOptions,"multiple":""},model:{value:(_vm.chlSubShopIds),callback:function ($$v) {_vm.chlSubShopIds=$$v},expression:"chlSubShopIds"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("ค้นหา")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":_vm.formReset}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])])])]),_vm._v(" "),_vm._m(2)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fas fa-search-location"})]),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("เช็คอินร้านค้า")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",attrs:{"id":"checkInTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("วันที่เช็คอิน")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("ชื่อ-สกุลผู้เช็คอิน")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"10%"}},[_vm._v("คะแนนรวม")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("ประเภทร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("ร้านค้า")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("ร้านค้า 2")]),_vm._v(" "),_c('th',{staticClass:"all",attrs:{"width":"15%"}},[_vm._v("การจัดการ")])])])])])])}]


/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.search($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("CCTR:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'venCCTR',"name":'venCCTR',"select2-options":_vm.cctrOptions},model:{value:(_vm.searchCCTR),callback:function ($$v) {_vm.searchCCTR=$$v},expression:"searchCCTR"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("IO:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'venIO',"name":'venIO',"select2-options":_vm.ioOptions},model:{value:(_vm.searchIO),callback:function ($$v) {_vm.searchIO=$$v},expression:"searchIO"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("GL:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'venGL',"name":'venGL',"select2-options":_vm.glOptions},model:{value:(_vm.searchGL),callback:function ($$v) {_vm.searchGL=$$v},expression:"searchGL"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("แผนก:")]),_vm._v(" "),_c('select2',{attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'venOrg',"name":'venOrg',"multiple":true,"select2-options":_vm.orgOptions},model:{value:(_vm.searchOrgCodes),callback:function ($$v) {_vm.searchOrgCodes=$$v},expression:"searchOrgCodes"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Vendor:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchVendor),expression:"searchVendor"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุชื่อหรือรหัส Vendor (คั่น,(ลูกน้ำ)ได้)","maxlength":"200"},domProps:{"value":(_vm.searchVendor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchVendor=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchProductName),expression:"searchProductName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"กรุณาระบุรายการสินค้า (คั่น,(ลูกน้ำ)ได้)","maxlength":"200"},domProps:{"value":(_vm.searchProductName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchProductName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่(เริ่มต้น):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"venDateFrom",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"วว/ดด/ปปปป","id":"venDateFrom","name":"venDateFrom"}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("วันที่(สิ้นสุด):")]),_vm._v(" "),_c('div',{staticClass:"input-group date"},[_c('input',{ref:"venDateTo",staticClass:"form-control",attrs:{"readonly":"","type":"text","placeholder":"วว/ดด/ปปปป","id":"venDateTo","name":"venDateTo"}}),_vm._v(" "),_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary mr-2",attrs:{"type":"submit","disabled":_vm.isLoading}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.isLoading ? "กำลังค้นหา..." : "ค้นหา")+"\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary mr-2",attrs:{"type":"button"},on:{"click":_vm.resetForm}},[_c('i',{staticClass:"fa fa-undo"}),_vm._v(" ล้างค่าทั้งหมด\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success float-right",attrs:{"type":"button","disabled":_vm.isExporting},on:{"click":_vm.exportExcel}},[_c('i',{staticClass:"fa fa-file-excel"}),_vm._v("\n                "+_vm._s(_vm.isExporting ? "กำลัง Export..." : "Export")+"\n              ")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.hasSearched)?_c('div',{staticClass:"alert alert-secondary"},[_vm._v("\n          กดปุ่ม "),_c('strong',[_vm._v("\"ค้นหา\"")]),_vm._v(" เพื่อแสดงข้อมูล\n        ")]):(_vm.rows.length === 0)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          ไม่พบข้อมูลตามเงื่อนไขที่ระบุ\n        ")]):[_c('div',{staticClass:"table-responsive vendor-usage-scroll"},[_c('table',{staticClass:"table table-sm vendor-usage-table"},[_vm._m(3),_vm._v(" "),_c('thead',[_c('tr',[_c('th',{staticClass:"text-center sortable-th",attrs:{"title":"เรียงตาม Vendor"},on:{"click":_vm.toggleVendorSort}},[_vm._v("\n                    "+_vm._s(_vm.headers[0] || "Vendor")+"\n                    "),_c('span',{staticClass:"sort-icon"},[_c('span',{class:{ active: _vm.vendorSortDir === 'asc' }},[_vm._v("↑")]),_c('span',{class:{ active: _vm.vendorSortDir === 'desc' }},[_vm._v("↓")])])]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.headers[1] || "รายการสินค้า"))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.headers[2] || "จำนวน"))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.headers[3] || "ราคาต่อหน่วย"))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.headers[4] || "รวม"))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.headers[5] || "เลขที่ใบงาน"))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.displayRows),function(r,i){return _c('tr',{key:'r' + i,class:{ 'block-start': r.showItemName, 'vendor-start': r.showVendor }},[_c('td',[_vm._v(_vm._s(r.showVendor ? r.vendor : ""))]),_vm._v(" "),_c('td',{staticClass:"pre-line"},[_vm._v(_vm._s(r.showItemName ? r.itemName : ""))]),_vm._v(" "),_c('td',{staticClass:"text-right",class:{ 'text-danger': _vm.isNegativeRow(r) }},[_vm._v(_vm._s(_vm.fmtQuantity(r.quantity)))]),_vm._v(" "),_c('td',{staticClass:"text-right",class:{ 'text-danger': _vm.isNegativeRow(r) }},[_vm._v(_vm._s(r.showUnitPrice ? _vm.fmtAccounting(r.unitPrice) : ""))]),_vm._v(" "),_c('td',{staticClass:"text-right",class:{ 'text-danger': _vm.isNegativeRow(r) }},[_vm._v(_vm._s(_vm.fmtAccounting(r.amount)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(r.jobs && r.jobs.length)?_vm._l((r.jobs),function(j,k){return _c('span',{key:'j' + i + '-' + j.jobId},[_c('a',{attrs:{"href":'/BudgetPlan/Job/View/' + j.jobId,"target":"_blank"}},[_vm._v(_vm._s(j.jobNumber))]),(k < r.jobs.length - 1)?[_vm._v(","),_c('br')]:_vm._e()],2)}):(r.jobNumber)?_c('a',{attrs:{"href":'/BudgetPlan/Job/View/' + r.jobId,"target":"_blank"}},[_vm._v(_vm._s(r.jobNumber))]):_vm._e()],2)])}),_vm._v(" "),_c('tr',{staticClass:"grand-total-row"},[_c('td'),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(_vm.grandTotalLabel))])]),_vm._v(" "),_c('td',{staticClass:"text-right",class:{ 'text-danger': _vm.isNegative(_vm.grandTotalQuantity) }},[_c('strong',[_vm._v(_vm._s(_vm.fmtQuantity(_vm.grandTotalQuantity)))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-right",class:{ 'text-danger': _vm.isNegative(_vm.grandTotalAmount) }},[_c('strong',[_vm._v(_vm._s(_vm.fmtAccounting(_vm.grandTotalAmount)))])]),_vm._v(" "),_c('td')])],2)])])]],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon2-line-chart"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colgroup',[_c('col',{staticStyle:{"width":"31%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"27%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"9%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"11%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"11%"}}),_vm._v(" "),_c('col',{staticStyle:{"width":"11%"}})])}]


/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('router-view'),_vm._v(" "),_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n          "+_vm._s(this.$route.meta.breadcrumb)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ประเภทการเคลม:")]),_vm._v(" "),_c('select2',{ref:"abcClaimTypeCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control',"id":'abcClaimTypeCode',"name":'abcClaimTypeCode',"select2-options":_vm.abcClaimTypeCodeOptions,"disabled":""},model:{value:(_vm.abcClaimTypeCode),callback:function ($$v) {_vm.abcClaimTypeCode=$$v},expression:"abcClaimTypeCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'"}],staticClass:"form-group"},[_c('label',[_vm._v("ตัวแทนจำหน่าย:")]),_vm._v(" "),_c('select2',{ref:"abcAgentCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcAgentCode',"name":'abcAgentCode',"select2-options":_vm.abcAgentCodeOptions,"disabled":""},model:{value:(_vm.abcAgentCode),callback:function ($$v) {_vm.abcAgentCode=$$v},expression:"abcAgentCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'),expression:"abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"}],staticClass:"form-group"},[_c('label',[_vm._v("ร้านค้า:")]),_vm._v(" "),_c('select2',{ref:"abcShopCodeSelect2",attrs:{"css-style":'width: 100%;',"css-class":'form-control m-select2',"id":'abcShopCode',"name":'abcShopCode',"select2-options":_vm.abcShopCodeOptions,"disabled":""},model:{value:(_vm.abcShopCode),callback:function ($$v) {_vm.abcShopCode=$$v},expression:"abcShopCode"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("อำเภอ:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcAmpher),expression:"abcAmpher"}],staticClass:"form-control",attrs:{"id":"abcAmpher","name":"abcAmpher","type":"text","maxlength":"450","placeholder":"อำเภอ","disabled":""},domProps:{"value":(_vm.abcAmpher)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcAmpher=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcProvince),expression:"abcProvince"}],staticClass:"form-control",attrs:{"id":"abcProvince","name":"abcProvince","type":"text","maxlength":"450","placeholder":"จังหวัด","disabled":""},domProps:{"value":(_vm.abcProvince)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcProvince=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เบอร์โทร:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abcPhone),expression:"abcPhone"}],staticClass:"form-control",attrs:{"id":"abcPhone","name":"abcPhone","type":"text","maxlength":"450","placeholder":"เบอร์โทร","disabled":""},domProps:{"value":(_vm.abcPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abcPhone=$event.target.value}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.abcClaimTypeCode != null &&
              (_vm.abcAgentCode != null || _vm.abcShopCode != null)
          ),expression:"\n            abcClaimTypeCode != null &&\n              (abcAgentCode != null || abcShopCode != null)\n          "}],staticClass:"kt-section kt-section--first"},[_c('h3',{staticClass:"kt-section__title"},[_vm._v("รายการสินค้าเคลม:")]),_vm._v(" "),_c('div',{staticClass:"kt-section__body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 table-responsive"},[_c('table',{staticClass:"table table-sm table-striped table-bordered table-hover table-checkable"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",attrs:{"width":"5%"}},[_vm._v("ลำดับ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("แบรนด์สินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"15%"}},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("BARCODE")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("รหัสทรัพย์สิน(เบียร์สด)")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("ปัญหาที่พบ")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("สถานะการเคลม")]),_vm._v(" "),(this.$root.canShow(['ADMIN_BEER_CLAIM']) && this.isApprove)?_c('th',{staticClass:"text-center",attrs:{"width":"10%"}},[_vm._v("\n                        จำนวนเงิน\n                      ")]):_vm._e()])]),_vm._v(" "),_c('tbody',[(
                        _vm.abcClaimItems == null || _vm.abcClaimItems.length == 0
                      )?_c('tr',[_c('td',{staticClass:"text-muted text-center",attrs:{"colspan":"9"}},[_vm._v("\n                        คลิก + เพื่อเพิ่มรายการใหม่\n                      ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.abcClaimItems),function(item,i){return [_c('tr',[_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(item.productBrand))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(item.material))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(item.barcodeOld))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(item.depCode))]),_vm._v(" "),_c('td',{staticClass:"text-center align-middle"},[_vm._v(_vm._s(item.problemType))]),_vm._v(" "),(
                            item.claimStatusCode ==
                              'CLAIM_STATUS_CONCLUDE_APPROVE'
                          )?_c('td',{staticClass:"text-center align-middle",staticStyle:{"color":"Green"}},[_vm._v("\n                          "+_vm._s(item.claimStatusName)+"\n                        ")]):(
                            item.claimStatusCode == 'CLAIM_STATUS_REVOKE'
                          )?_c('td',{staticClass:"text-center",staticStyle:{"color":"Red"}},[_vm._v("\n                          "+_vm._s(item.claimStatusName)+"\n                        ")]):(
                            item.claimStatusCode ==
                              'CLAIM_STATUS_CONCLUDE_REJECT'
                          )?_c('td',{staticClass:"text-center",staticStyle:{"color":"Red"}},[_vm._v("\n                          "+_vm._s(item.claimStatusName)+"\n                        ")]):_c('td'),_vm._v(" "),(item.isBeerclaimAdmin &&
                            item.claimStatusCode == 'CLAIM_STATUS_CONCLUDE_APPROVE'
                          )?_c('td',[_c('currency-input',{directives:[{name:"currency",rawName:"v-currency",value:({ locale: _vm.locale, currency: _vm.currency }),expression:"{ locale, currency }"}],staticClass:"form-control required",attrs:{"id":'claimPrice' + i,"name":'claimPrice' + i,"auto-decimal-mode:true":"","placeholder":"จำนวนเงิน","data-msg-required":"กรุณากรอกจำนวนเงิน"},model:{value:(item.claimPrice),callback:function ($$v) {_vm.$set(item, "claimPrice", $$v)},expression:"item.claimPrice"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1):_vm._e()])]})],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n      ")]),_vm._v(" "),(this.$root.canShow(['ADMIN_BEER_CLAIM']) && this.isApprove)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n      ")]):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])}]


/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path == '/Report/BarcodeStatus'),expression:"$route.path == '/Report/BarcodeStatus'"}],staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('form',{ref:"form",staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("สถานะ:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBsBarcodeStatusCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBsBarcodeStatusCode),callback:function ($$v) {_vm.reBsBarcodeStatusCode=$$v},expression:"reBsBarcodeStatusCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("เจ้าของทรัพย์สิน:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBsAssetOwnerIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBsAssetOwnerId),callback:function ($$v) {_vm.reBsAssetOwnerId=$$v},expression:"reBsAssetOwnerId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("จังหวัด:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBsProvinceIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBsProvinceId),callback:function ($$v) {_vm.reBsProvinceId=$$v},expression:"reBsProvinceId"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$root.canShow([''])),expression:"this.$root.canShow([''])"}],staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทผู้ถือครอง:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBsAssetHolderTypeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBsAssetHolderType),callback:function ($$v) {_vm.reBsAssetHolderType=$$v},expression:"reBsAssetHolderType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("หมวดหมู่สินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBsProductGroupIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBsProductGroupId),callback:function ($$v) {_vm.reBsProductGroupId=$$v},expression:"reBsProductGroupId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("ประเภทสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBsProductTypeIdOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBsProductTypeId),callback:function ($$v) {_vm.reBsProductTypeId=$$v},expression:"reBsProductTypeId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ชื่อสินค้า:")]),_vm._v(" "),_c('treeselect',{attrs:{"multiple":true,"options":_vm.reBsProductCodeOptions,"clear-on-select":true,"placeholder":"กรุณาเลือก"},model:{value:(_vm.reBsProductCode),callback:function ($$v) {_vm.reBsProductCode=$$v},expression:"reBsProductCode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                Generate Report\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"reset"},on:{"click":function($event){return _vm.formReset($event)}}},[_vm._v("\n                ล้างค่าทั้งหมด\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-6 text-right"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.ExportBarcodeStatus($event)}}},[_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable display nowrap",staticStyle:{"width":"100%"},attrs:{"id":"barcodeStatusTable"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"all text-right",attrs:{"colspan":"10"}},[_vm._v("\n                    ข้อมูล ณ วันที่ "+_vm._s(_vm.reBsDateReq)+"\n                  ")])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),(_vm.isShowFooter)?_c('tfoot',[_c('tr',{staticStyle:{"background-color":"#cdcde4"}},[_c('th',{staticClass:"all text-center",attrs:{"colspan":"7"}}),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"color":"#778ad4"}},[_vm._v("\n                    จำนวนรวมทั้งหมด\n                  ")]),_vm._v(" "),_c('th',{staticClass:"all text-center",staticStyle:{"color":"#778ad4"}},[_vm._v("\n                    "+_vm._s(_vm.TotalAmount)+"\n                  ")])])]):_vm._e()])])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"fa fa-store"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-export"}),_c('span',[_vm._v("Export Excel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"all text-center"},[_vm._v("สถานะ")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("เจ้าของทรัพย์สิน")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("จังหวัด")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทผู้ถือครอง")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("หมวดหมู่สินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ประเภทสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("รหัสสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-center"},[_vm._v("ชื่อสินค้า")]),_vm._v(" "),_c('th',{staticClass:"all text-right"},[_vm._v("จำนวน")])])}]


/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--mobile"},[_c('div',{ref:"form",staticClass:"kt-form"},[_c('form',{staticClass:"kt-form",on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('div',{staticClass:"kt-portlet__head kt-portlet__head--lg"},[_c('div',{staticClass:"kt-portlet__head-label"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v("\n            "+_vm._s(this.$route.meta.breadcrumb)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__body"},[_c('div',{staticClass:"kt-section kt-section--first"},[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-6"},[_c('input',{staticClass:"custom-file-input",attrs:{"type":"file","id":"importFileBarcode","lang":"es"}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",attrs:{"for":"importFileBarcode"}},[_vm._v(_vm._s(_vm.Flie))])])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"kt-portlet__foot"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ย้อนกลับ\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"reset"},on:{"click":_vm.resetFile}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ล้างค่า\n        ")]),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kt-portlet__head-icon"},[_c('i',{staticClass:"kt-font-brand flaticon-home"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 table-responsive"},[_c('table',{staticClass:"table-sm table-striped- table-bordered table-hover table-checkable",staticStyle:{"width":"100%"},attrs:{"id":"PreviewTable"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"la la-save"}),_vm._v(" บันทึกข้อมูล\n        ")])}]


/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"form-control form-control-plaintext"},[_vm._v(_vm._s(_vm.rowIndex + 1))])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"plStatus",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control required',"id":'plStatus' + _vm._uid,"name":'plStatus' + _vm._uid,"select2-options":_vm.plStatusOptions,"data-msg-required":"กรุณาเลือกสถานะ"},on:{"selectChange":_vm.onStatusChange},model:{value:(_vm.itemStatus),callback:function ($$v) {_vm.itemStatus=$$v},expression:"itemStatus"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"plProductType",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control required',"id":'plProductType' + _vm._uid,"name":'plProductType' + _vm._uid,"select2-options":_vm.plProductTypeOptions,"data-msg-required":"กรุณาเลือกประเภทสินค้า"},on:{"selectChange":_vm.onProductTypeChange},model:{value:(_vm.itemProductType),callback:function ($$v) {_vm.itemProductType=$$v},expression:"itemProductType"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"plProductId",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control required',"id":'plProductId' + _vm._uid,"name":'plProductId' + _vm._uid,"select2-options":_vm.plProductIdOptions,"data-msg-required":"กรุณาเลือกสินค้า"},on:{"selectChange":_vm.onProductChange},model:{value:(_vm.itemProductId),callback:function ($$v) {_vm.itemProductId=$$v},expression:"itemProductId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group text-center"},[(_vm.itemImage)?_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.itemImage,"width":"100"},on:{"click":function($event){return _vm.pictureModal(_vm.itemImage, _vm.rowIndex)}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":'PictureModal' + _vm.rowIndex,"tabindex":"-1","role":"dialog","aria-labelledby":"modelSingle"}},[_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('form',{staticClass:"kt-form"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body text-center"},[(_vm.modalImage)?_c('img',{staticClass:"img-thumbnail mb-3",staticStyle:{"width":"100%"},attrs:{"src":_vm.modalImage,"alt":"Product Image"}}):_c('p',[_vm._v("ไม่พบรูปภาพ")])]),_vm._v(" "),_vm._m(1)])])])])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"plQuota",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control required',"id":'plQuota' + _vm._uid,"name":'plQuota' + _vm._uid,"select2-options":_vm.plQuotaOptions,"data-msg-required":"กรุณาเลือกแบรนด์สินค้า"},on:{"selectChange":_vm.onQuotaChange},model:{value:(_vm.itemQuota),callback:function ($$v) {_vm.itemQuota=$$v},expression:"itemQuota"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.plQty),expression:"item.plQty"}],staticClass:"form-control required text-right",attrs:{"disabled":!_vm.isEditable,"type":"number","min":"0","placeholder":"จำนวน","id":'plQty' + _vm._uid,"name":'plQty' + _vm._uid,"data-msg-required":"กรุณากรอกจำนวน"},domProps:{"value":(_vm.item.plQty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "plQty", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"form-text"},[_vm._v(_vm._s(_vm.CheckStockAnswer))])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"plAgent",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control required',"id":'plAgent' + _vm._uid,"name":'plAgent' + _vm._uid,"select2-options":_vm.plAgentOptions,"data-msg-required":"กรุณาเลือกตัวแทนจำหน่าย"},on:{"selectChange":_vm.onAgentChange},model:{value:(_vm.itemAgent),callback:function ($$v) {_vm.itemAgent=$$v},expression:"itemAgent"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('select2',{ref:"plShopActivityId",attrs:{"disabled":!_vm.isEditable,"css-style":'width: 100%;',"css-class":'form-control required',"id":'plShopActivityId' + _vm._uid,"name":'plShopActivityId' + _vm._uid,"select2-options":_vm.plShopIdOptions,"data-msg-required":"กรุณาเลือกร้านค้า/กิจกรรม"},on:{"selectChange":_vm.onShopIdChange},model:{value:(_vm.itemShopActivityId),callback:function ($$v) {_vm.itemShopActivityId=$$v},expression:"itemShopActivityId"}}),_vm._v(" "),_c('span',{staticClass:"form-text"})],1),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.plActivityRemark),expression:"item.plActivityRemark"}],staticClass:"form-control",class:{ required: _vm.requiredRemark },attrs:{"disabled":!_vm.isEditable,"type":"text","placeholder":"หมายเหตุ","id":'Remark' + _vm._uid,"name":'Remark' + _vm._uid,"data-msg-required":"กรุณากรอกหมายเหตุ"},domProps:{"value":(_vm.item.plActivityRemark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "plActivityRemark", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"form-text"})]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('div',{staticClass:"input-group date"},[_c('input',{ref:"plReturnDate",staticClass:"form-control",class:{ required: _vm.requiredDate },attrs:{"disabled":!_vm.isEditable,"readonly":"","type":"text","id":'plReturnDate' + _vm._uid,"name":'plReturnDate' + _vm._uid,"placeholder":"วันคืนสินค้า","data-msg-required":"กรุณาเลือกวันคืนสินค้า"},on:{"click":_vm.onReturnDateClick}}),_vm._v(" "),_c('span',{staticClass:"form-text"}),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('td',{staticClass:"form-group"},[_c('center',[(_vm.isEditable)?_c('button',{staticClass:"btn btn-outline-hover-danger btn-elevate btn-circle btn-icon",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onRemoveItemClick($event)}}},[_c('i',{staticClass:"text-danger la la-trash"})]):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("รูปภาพ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"la la-close"}),_vm._v(" ปิดหน้าต่าง\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"la la-calendar-check-o"})])])}]


/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const LoadScript = {
  install: function (Vue) {
    Vue.loadScript = Vue.prototype.$loadScript = function (src) { // eslint-disable-line no-param-reassign
      return new Promise(function (resolve, reject) {
        if (document.querySelector('script[src="' + src + '"]')) {
          resolve();

          return;
        }

        const el = document.createElement('script');

        el.type = 'text/javascript';
        el.async = true;
        el.src = src;

        el.addEventListener('load', resolve);
        el.addEventListener('error', reject);
        el.addEventListener('abort', reject);

        document.head.appendChild(el);
      });
    };

    Vue.unloadScript = Vue.prototype.$unloadScript = function (src) { // eslint-disable-line no-param-reassign
      return new Promise(function (resolve, reject) {
        const el = document.querySelector('script[src="' + src + '"]');

        if (!el) {
          reject();

          return;
        }

        document.head.removeChild(el);

        resolve();
      });
    };
  },
};

/* harmony default export */ __webpack_exports__["a"] = (LoadScript);


/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.0.7
  * (c) 2019 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if ("sit" !== 'production' && !condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode && parent.$vnode.data;
      if (vnodeData) {
        if (vnodeData.routerView) {
          depth++;
        }
        if (vnodeData.keepAlive && parent._inactive) {
          inactive = true;
        }
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (true) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "sit" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
      ? 'router-link-active'
      : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
      ? 'router-link-exact-active'
      : globalExactActiveClass;
    var activeClass = this.activeClass == null
      ? activeClassFallback
      : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
      ? exactActiveClassFallback
      : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
}

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    if (params.pathMatch) { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (true) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (true) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (true) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if ("sit" !== 'production' && !matchAs) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (true) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    return extend({}, raw)
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (true) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (true) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (true) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (true) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (true) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  window.history.replaceState({ key: getStateKey() }, '', absolutePath);
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (true) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(router, to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (true) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "sit" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
      next(cb);
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (
    instances[key] &&
    !instances[key]._isBeingDestroyed // do not reuse being destroyed instance
  ) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = decodeURI(window.location.pathname);
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);
  // decode the hash but not the search or hash
  // as search(query) is already decoded
  // https://github.com/vuejs/vue-router/issues/2708
  var searchIndex = href.indexOf('?');
  if (searchIndex < 0) {
    var hashIndex = href.indexOf('#');
    if (hashIndex > -1) { href = decodeURI(href.slice(0, hashIndex)) + href.slice(hashIndex); }
    else { href = decodeURI(href); }
  } else {
    if (searchIndex > -1) { href = decodeURI(href.slice(0, searchIndex)) + href.slice(searchIndex); }
  }

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */



var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (true) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "sit" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(
    to,
    current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.7';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(868);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("47e06723", content, true, {});

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(869);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("36764399", content, true, {});

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(870);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4a071b7e", content, true, {});

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(871);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0f9632be", content, true, {});

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(872);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4cd8cdee", content, true, {});

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(873);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3906de12", content, true, {});

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(874);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("2495f99f", content, true, {});

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(875);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("d5376e1a", content, true, {});

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(876);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3b403637", content, true, {});

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(877);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("76430a0e", content, true, {});

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(878);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("bac6d4a0", content, true, {});

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(879);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6c4c1208", content, true, {});

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(880);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("86d80636", content, true, {});

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(881);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("abeef43e", content, true, {});

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(882);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("590a2ed7", content, true, {});

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(883);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("36e62edf", content, true, {});

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(884);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0852e8f6", content, true, {});

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(885);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("9ba9f8dc", content, true, {});

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(886);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3f687022", content, true, {});

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(887);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("136e174a", content, true, {});

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(888);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1499f4d7", content, true, {});

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(889);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("352e63bb", content, true, {});

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(890);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7130cfce", content, true, {});

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(891);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("a0bce2b2", content, true, {});

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(892);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6bee50c6", content, true, {});

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(893);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("582bbc2b", content, true, {});

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(894);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("310fd18c", content, true, {});

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(895);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("c894191a", content, true, {});

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(896);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4244530e", content, true, {});

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(897);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("590e5580", content, true, {});

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(898);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("515ecee4", content, true, {});

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(899);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("165c6572", content, true, {});

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(900);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("9645e292", content, true, {});

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(901);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4f43b764", content, true, {});

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(902);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4950d281", content, true, {});

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(903);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4f551bae", content, true, {});

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(904);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("d2e0ca26", content, true, {});

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(905);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("9511da16", content, true, {});

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(906);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("9eb60498", content, true, {});

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(907);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("270c0d3c", content, true, {});

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(908);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4d5d8fcd", content, true, {});

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(909);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("eb81eaec", content, true, {});

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(910);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("063173b8", content, true, {});

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(911);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("2f62c422", content, true, {});

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(912);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("eaad489a", content, true, {});

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(913);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("f0ca8080", content, true, {});

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(914);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1153a5c4", content, true, {});

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(915);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("07ac5841", content, true, {});

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(916);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3794de6e", content, true, {});

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(917);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("47468821", content, true, {});

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(918);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("fd6c8ad4", content, true, {});

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(919);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1836795f", content, true, {});

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(920);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4d1ff308", content, true, {});

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(921);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("48063f76", content, true, {});

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(922);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("dc2f16d0", content, true, {});

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(923);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("61e9f66b", content, true, {});

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(924);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6caa6cfd", content, true, {});

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(925);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0bd6e549", content, true, {});

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(926);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("00d6bbaf", content, true, {});

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(927);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4c20c4d3", content, true, {});

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(928);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("14913c47", content, true, {});

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(929);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("805b4a2c", content, true, {});

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(930);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6ab6fa41", content, true, {});

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(931);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("680c9146", content, true, {});

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(932);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("365e9a30", content, true, {});

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(933);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("c429bd8a", content, true, {});

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(934);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("15faa9fa", content, true, {});

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(935);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("90a9c3a4", content, true, {});

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(936);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0f1dbecf", content, true, {});

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(937);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0140f8c0", content, true, {});

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(938);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("d8a9682a", content, true, {});

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(939);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("20650738", content, true, {});

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(940);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6e47a639", content, true, {});

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(941);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("18e4b1e3", content, true, {});

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(942);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("61805548", content, true, {});

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(943);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("641452e7", content, true, {});

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(944);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("609cbc4f", content, true, {});

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(945);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("fcba5a56", content, true, {});

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(946);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("47bd0375", content, true, {});

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(947);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("fa0d1066", content, true, {});

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(948);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("eb962340", content, true, {});

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(949);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("346dd7e2", content, true, {});

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(950);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1253dac6", content, true, {});

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(951);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1c4670fc", content, true, {});

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(952);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("71ea3ac0", content, true, {});

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(953);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("945aac96", content, true, {});

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(954);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0e617fe4", content, true, {});

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(955);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("ca19e59e", content, true, {});

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(956);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("483a1d52", content, true, {});

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(957);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("5b7c0188", content, true, {});

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(958);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("665d0030", content, true, {});

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(959);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("5f4eb3e3", content, true, {});

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(960);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("450e4f40", content, true, {});

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(961);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("a8e86658", content, true, {});

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(962);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("516aa45a", content, true, {});

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(963);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("5ef78790", content, true, {});

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(964);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("05b39a7b", content, true, {});

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(965);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4ba1eb36", content, true, {});

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(966);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("740ff8b4", content, true, {});

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(967);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("2875996e", content, true, {});

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(968);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("5a06581a", content, true, {});

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(969);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6eb15aed", content, true, {});

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(970);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("a05a49f6", content, true, {});

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(971);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1cceb7af", content, true, {});

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(972);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3a1b0bed", content, true, {});

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(973);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("079fe38d", content, true, {});

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(974);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("27e5c6f2", content, true, {});

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(975);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1324d596", content, true, {});

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(976);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("5b06387e", content, true, {});

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(977);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("353cb736", content, true, {});

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(978);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3c7b55ee", content, true, {});

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(979);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("25f89e38", content, true, {});

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(980);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("bdffa394", content, true, {});

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(981);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("31ae4df2", content, true, {});

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(982);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("ce98a8d8", content, true, {});

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(983);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("837b3204", content, true, {});

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(984);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7dbe7dd1", content, true, {});

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(985);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("cfb68258", content, true, {});

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(986);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("5dc450c9", content, true, {});

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(987);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("346b3220", content, true, {});

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(988);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("da096a70", content, true, {});

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(989);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4277cced", content, true, {});

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(990);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4fa113a8", content, true, {});

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(991);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("734dd127", content, true, {});

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(992);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("ba1354a6", content, true, {});

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(993);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("8b02c7c2", content, true, {});

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(994);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4b0f7b54", content, true, {});

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(995);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("ea07ccca", content, true, {});

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(996);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("9cd50e80", content, true, {});

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(997);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6b89825e", content, true, {});

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(998);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("51a5faa1", content, true, {});

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(999);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0dab0710", content, true, {});

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1000);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7ce41f28", content, true, {});

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1001);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3d3882f3", content, true, {});

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1002);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("18d4a8ea", content, true, {});

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1003);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7bebee8e", content, true, {});

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1004);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6afb16d4", content, true, {});

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1005);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("20225a6e", content, true, {});

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1006);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6c6fe000", content, true, {});

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1007);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("209ec34b", content, true, {});

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1008);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7abfd004", content, true, {});

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1009);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0fe2ede6", content, true, {});

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1010);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("69dcf186", content, true, {});

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1011);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("76486029", content, true, {});

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1012);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3aa584b3", content, true, {});

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1013);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("44f231f0", content, true, {});

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1014);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("f12b7e56", content, true, {});

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1015);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4f7ccf2f", content, true, {});

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1016);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("46fd3f3e", content, true, {});

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1017);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("e359a194", content, true, {});

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1018);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("438f2d1d", content, true, {});

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1019);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("44c49778", content, true, {});

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1020);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4a227fd8", content, true, {});

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1021);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("75f31022", content, true, {});

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1022);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7484d850", content, true, {});

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1023);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1a9fe32d", content, true, {});

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1024);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("9e0ea736", content, true, {});

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1025);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("5afecd04", content, true, {});

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1026);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("321ee9c4", content, true, {});

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1027);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6eead229", content, true, {});

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1028);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("24cd898e", content, true, {});

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1029);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("768d5c04", content, true, {});

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1030);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("07d42e7b", content, true, {});

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1031);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("63600f44", content, true, {});

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1032);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("c6950eca", content, true, {});

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1033);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("836a1a62", content, true, {});

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1034);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("90d8b7c4", content, true, {});

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1035);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("2fcb7478", content, true, {});

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1036);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7af382ab", content, true, {});

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1037);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("03482998", content, true, {});

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1038);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("10df6459", content, true, {});

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1039);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("205a72d2", content, true, {});

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1040);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0c2fea0d", content, true, {});

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1041);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("aadb6a14", content, true, {});

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1042);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("d8b92aaa", content, true, {});

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1043);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("cd563f62", content, true, {});

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1044);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4a8cd30a", content, true, {});

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1045);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("609a107a", content, true, {});

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1046);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("503976c0", content, true, {});

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1047);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7384006b", content, true, {});

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1048);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("a2a9c4c8", content, true, {});

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1049);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3665e672", content, true, {});

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1050);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("ab81c0d2", content, true, {});

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1051);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("180561b1", content, true, {});

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1052);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1caed2af", content, true, {});

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1053);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("37d24ec9", content, true, {});

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1054);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6ddf0c24", content, true, {});

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1055);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("62ab8434", content, true, {});

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1056);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4516a6e4", content, true, {});

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1057);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3aea3515", content, true, {});

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1058);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3bdc6471", content, true, {});

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1059);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("b0a2f970", content, true, {});

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1060);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("ba25c3b8", content, true, {});

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1061);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1e1bfd45", content, true, {});

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1062);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("4e6ffc6c", content, true, {});

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1063);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("11d52664", content, true, {});

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1064);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("1efa41f9", content, true, {});

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1065);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("06ae3785", content, true, {});

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1066);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("418c5155", content, true, {});

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1067);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("556438da", content, true, {});

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1068);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("79af5976", content, true, {});

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1069);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("16715862", content, true, {});

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1070);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("80bb1fca", content, true, {});

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1071);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("6644a6d9", content, true, {});

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1072);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("46453b96", content, true, {});

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1073);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("d8ff2184", content, true, {});

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1074);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0ee2117e", content, true, {});

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1075);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("b1c52e6c", content, true, {});

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1076);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3a36f18a", content, true, {});

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1077);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("ba7bc1a2", content, true, {});

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1078);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("121a9469", content, true, {});

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1079);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("aa6b85a2", content, true, {});

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1080);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("9dd46b50", content, true, {});

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1081);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("05f38a50", content, true, {});

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1082);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("712bfd6c", content, true, {});

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1083);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("35bab120", content, true, {});

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1084);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("8f2ae884", content, true, {});

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1085);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("82532378", content, true, {});

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1086);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("c6d69ab6", content, true, {});

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1087);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("026146d4", content, true, {});

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1088);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3127c036", content, true, {});

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1089);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("28a6fe73", content, true, {});

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1090);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("51304b60", content, true, {});

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1091);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7b0bb542", content, true, {});

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1092);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("d8f9da84", content, true, {});

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1093);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("315a5eee", content, true, {});

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1094);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("72151806", content, true, {});

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1095);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("10b5818c", content, true, {});

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1096);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("97312048", content, true, {});

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1097);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("ebecc65c", content, true, {});

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1098);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7890f402", content, true, {});

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1099);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3bda14f8", content, true, {});

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1100);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3c45732f", content, true, {});

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1101);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("ac5669ca", content, true, {});

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1102);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("a4310de2", content, true, {});

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1103);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("99e928bc", content, true, {});

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1104);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("a6ba412c", content, true, {});

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1105);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7ef22dec", content, true, {});

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1106);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("2f6d56ca", content, true, {});

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1107);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("3302534a", content, true, {});

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1108);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("42f4ceca", content, true, {});

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1109);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("0feee31c", content, true, {});

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1110);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("37991ccc", content, true, {});

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1111);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("b70c1eb0", content, true, {});

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1112);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("2304d140", content, true, {});

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1113);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("16f67af3", content, true, {});

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1114);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("a50fb486", content, true, {});

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1115);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("71185433", content, true, {});

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1116);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("24b60ef3", content, true, {});

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1117);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("7c62b1ca", content, true, {});

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1118);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("77faffe4", content, true, {});

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1119);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(3).default
var update = add("694a292c", content, true, {});

/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listToStyles;
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export uuid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v1__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v5__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v5__);
/*!
 * vue-uuid v1.1.1
 * (c) 2017-present Vitor Luiz Cavalcanti
 * Released under the MIT License.
 */




/**
 * @typedef {{ v1: typeof v1, v4: typeof v4, v5: typeof v5 }} UUID
 */

/**
 * An object with uuid's v1, v4 and v5 functions.
 * @type {UUI}
 */

var uuid = {
  v1: __WEBPACK_IMPORTED_MODULE_0_uuid_v1___default.a,
  v4: __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default.a,
  v5: __WEBPACK_IMPORTED_MODULE_2_uuid_v5___default.a
};
/**
 * Installs UUID on Vue instance. It creates a property on Vue instance to
 * expose an object with uuid's v1, v4 and v5 functions.
 * @example ```js
 * import Vue from 'vue';
 * import VueUUID from 'vue-uuid';
 *
 * Vue.use(VueUUID);
 *
 * new Vue({
 *   mounted () {
 *     console.log(this.$uuid.v1());
 *   }
 * });
 * ```
 * @param {import('vue').default} Vue Vue constructor.
 */

function install(Vue) {
  Vue.prototype.$uuid = uuid;
}

/* harmony default export */ __webpack_exports__["a"] = (install);



/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindProps = __webpack_require__(91);

var _simulateArrowDown = __webpack_require__(631);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

var _mapElementFactory = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mappedProps = {
  bounds: {
    type: Object
  },
  componentRestrictions: {
    type: Object,
    // Do not bind -- must check for undefined
    // in the property
    noBind: true
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  }
};

var props = {
  selectFirstOnEnter: {
    required: false,
    type: Boolean,
    default: false
  },
  options: {
    type: Object
  }
};

exports.default = {
  mounted: function mounted() {
    var _this = this;

    this.$gmapApiPromiseLazy().then(function () {
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      /* eslint-disable no-unused-vars */
      var finalOptions = _extends({}, (0, _bindProps.getPropsValues)(_this, mappedProps), _this.options);

      _this.$autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, finalOptions);
      (0, _bindProps.bindProps)(_this, _this.$autocomplete, mappedProps);

      _this.$watch('componentRestrictions', function (v) {
        if (v !== undefined) {
          _this.$autocomplete.setComponentRestrictions(v);
        }
      });

      // Not using `bindEvents` because we also want
      // to return the result of `getPlace()`
      _this.$autocomplete.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.$autocomplete.getPlace());
      });
    });
  },

  props: _extends({}, (0, _mapElementFactory.mappedPropsToVueProps)(mappedProps), props)
};

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(59);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    type: Object,
    twoWay: true,
    required: true
  },
  radius: {
    type: Number,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'circle',
  ctr: function ctr() {
    return google.maps.Circle;
  },
  events: events
});

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(59);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  options: {
    type: Object,
    required: false,
    default: function _default() {
      return {};
    }
  },
  position: {
    type: Object,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  }
};

var events = ['domready', 'closeclick', 'content_changed'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'infoWindow',
  ctr: function ctr() {
    return google.maps.InfoWindow;
  },
  props: {
    opened: {
      type: Boolean,
      default: true
    }
  },

  inject: {
    '$markerPromise': {
      default: null
    }
  },

  mounted: function mounted() {
    var el = this.$refs.flyaway;
    el.parentNode.removeChild(el);
  },
  beforeCreate: function beforeCreate(options) {
    var _this = this;

    options.content = this.$refs.flyaway;

    if (this.$markerPromise) {
      delete options.position;
      return this.$markerPromise.then(function (mo) {
        _this.$markerObject = mo;
        return mo;
      });
    }
  },


  methods: {
    _openInfoWindow: function _openInfoWindow() {
      if (this.opened) {
        if (this.$markerObject !== null) {
          this.$infoWindowObject.open(this.$map, this.$markerObject);
        } else {
          this.$infoWindowObject.open(this.$map);
        }
      } else {
        this.$infoWindowObject.close();
      }
    }
  },

  afterCreate: function afterCreate() {
    var _this2 = this;

    this._openInfoWindow();
    this.$watch('opened', function () {
      _this2._openInfoWindow();
    });
  }
});

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(139);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(91);

var _mountableMixin = __webpack_require__(140);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(630);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(138);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    required: true,
    twoWay: true,
    type: Object,
    noBind: true
  },
  zoom: {
    required: false,
    twoWay: true,
    type: Number,
    noBind: true
  },
  heading: {
    type: Number,
    twoWay: true
  },
  mapTypeId: {
    twoWay: true,
    type: String
  },
  tilt: {
    twoWay: true,
    type: Number
  },
  options: {
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['bounds_changed', 'click', 'dblclick', 'drag', 'dragend', 'dragstart', 'idle', 'mousemove', 'mouseout', 'mouseover', 'resize', 'rightclick', 'tilesloaded'];

// Plain Google Maps methods exposed here for convenience
var linkedMethods = ['panBy', 'panTo', 'panToBounds', 'fitBounds'].reduce(function (all, methodName) {
  all[methodName] = function () {
    if (this.$mapObject) {
      this.$mapObject[methodName].apply(this.$mapObject, arguments);
    }
  };
  return all;
}, {});

// Other convenience methods exposed by Vue Google Maps
var customMethods = {
  resize: function resize() {
    if (this.$mapObject) {
      google.maps.event.trigger(this.$mapObject, 'resize');
    }
  },
  resizePreserveCenter: function resizePreserveCenter() {
    if (!this.$mapObject) {
      return;
    }

    var oldCenter = this.$mapObject.getCenter();
    google.maps.event.trigger(this.$mapObject, 'resize');
    this.$mapObject.setCenter(oldCenter);
  },


  /// Override mountableMixin::_resizeCallback
  /// because resizePreserveCenter is usually the
  /// expected behaviour
  _resizeCallback: function _resizeCallback() {
    this.resizePreserveCenter();
  }
};

exports.default = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),

  provide: function provide() {
    var _this = this;

    this.$mapPromise = new Promise(function (resolve, reject) {
      _this.$mapPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$mapPromise': this.$mapPromise
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.center && typeof this.center.lat === 'function' ? this.center.lat() : this.center.lat;
    },
    finalLng: function finalLng() {
      return this.center && typeof this.center.lng === 'function' ? this.center.lng() : this.center.lng;
    },
    finalLatLng: function finalLatLng() {
      return { lat: this.finalLat, lng: this.finalLng };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$mapObject) {
        this.$mapObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-map'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;
      _this2.$mapObject = new google.maps.Map(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$mapObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$mapObject, events);

      // manually trigger center and zoom
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        _this2.$mapObject.addListener('center_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('center_changed', _this2.$mapObject.getCenter());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$mapObject.setCenter(_this2.finalLatLng);
        });
      });
      _this2.$mapObject.addListener('zoom_changed', function () {
        _this2.$emit('zoom_changed', _this2.$mapObject.getZoom());
      });
      _this2.$mapObject.addListener('bounds_changed', function () {
        _this2.$emit('bounds_changed', _this2.$mapObject.getBounds());
      });

      _this2.$mapPromiseDeferred.resolve(_this2.$mapObject);

      return _this2.$mapObject;
    }).catch(function (error) {
      throw error;
    });
  },

  methods: _extends({}, customMethods, linkedMethods)
};

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(59);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  animation: {
    twoWay: true,
    type: Number
  },
  attribution: {
    type: Object
  },
  clickable: {
    type: Boolean,
    twoWay: true,
    default: true
  },
  cursor: {
    type: String,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    twoWay: true,
    default: false
  },
  icon: {
    twoWay: true
  },
  label: {},
  opacity: {
    type: Number,
    default: 1
  },
  options: {
    type: Object
  },
  place: {
    type: Object
  },
  position: {
    type: Object,
    twoWay: true
  },
  shape: {
    type: Object,
    twoWay: true
  },
  title: {
    type: String,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  },
  visible: {
    twoWay: true,
    default: true
  }
};

var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];

/**
 * @class Marker
 *
 * Marker class with extra support for
 *
 * - Embedded info windows
 * - Clustered markers
 *
 * Support for clustered markers is for backward-compatability
 * reasons. Otherwise we should use a cluster-marker mixin or
 * subclass.
 */
exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'marker',
  ctr: function ctr() {
    return google.maps.Marker;
  },

  inject: {
    '$clusterPromise': {
      default: null
    }
  },

  render: function render(h) {
    if (!this.$slots.default || this.$slots.default.length === 0) {
      return '';
    } else if (this.$slots.default.length === 1) {
      // So that infowindows can have a marker parent
      return this.$slots.default[0];
    } else {
      return h('div', this.$slots.default);
    }
  },
  destroyed: function destroyed() {
    if (!this.$markerObject) {
      return;
    }

    if (this.$clusterObject) {
      // Repaint will be performed in `updated()` of cluster
      this.$clusterObject.removeMarker(this.$markerObject, true);
    } else {
      this.$markerObject.setMap(null);
    }
  },
  beforeCreate: function beforeCreate(options) {
    if (this.$clusterPromise) {
      options.map = null;
    }

    return this.$clusterPromise;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    if (this.$clusterPromise) {
      this.$clusterPromise.then(function (co) {
        co.addMarker(inst);
        _this.$clusterObject = co;
      });
    }
  }
});

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(59);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    type: Object
  },
  path: {
    type: Array,
    twoWay: true,
    noBind: true
  },
  paths: {
    type: Array,
    twoWay: true,
    noBind: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,
  mappedProps: props,
  name: 'polygon',
  ctr: function ctr() {
    return google.maps.Polygon;
  },

  beforeCreate: function beforeCreate(options) {
    if (!options.path) delete options.path;
    if (!options.paths) delete options.paths;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    var clearEvents = function () {};

    // Watch paths, on our own, because we do not want to set either when it is
    // empty
    this.$watch('paths', function (paths) {
      if (paths) {
        clearEvents();

        inst.setPaths(paths);

        var updatePaths = function () {
          _this.$emit('paths_changed', inst.getPaths());
        };
        var eventListeners = [];

        var mvcArray = inst.getPaths();
        for (var i = 0; i < mvcArray.getLength(); i++) {
          var mvcPath = mvcArray.getAt(i);
          eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);
        }
        eventListeners.push([mvcArray, mvcArray.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        inst.setPaths(path);

        var mvcPath = inst.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', inst.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                obj = _ref4[0],
                listenerHandle = _ref4[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(59);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    twoWay: false,
    type: Object
  },
  path: {
    type: Array,
    twoWay: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,

  name: 'polyline',
  ctr: function ctr() {
    return google.maps.Polyline;
  },

  afterCreate: function afterCreate() {
    var _this = this;

    var clearEvents = function () {};

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        _this.$polylineObject.setPath(path);

        var mvcPath = _this.$polylineObject.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', _this.$polylineObject.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(59);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  bounds: {
    type: Object,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'rectangle',
  ctr: function ctr() {
    return google.maps.Rectangle;
  },
  events: events
});

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(139);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(91);

var _mountableMixin = __webpack_require__(140);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(630);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(138);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  zoom: {
    twoWay: true,
    type: Number
  },
  pov: {
    twoWay: true,
    type: Object,
    trackProperties: ['pitch', 'heading']
  },
  position: {
    twoWay: true,
    type: Object,
    noBind: true
  },
  pano: {
    twoWay: true,
    type: String
  },
  motionTracking: {
    twoWay: false,
    type: Boolean
  },
  visible: {
    twoWay: true,
    type: Boolean,
    default: true
  },
  options: {
    twoWay: false,
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['closeclick', 'status_changed'];

exports.default = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),
  replace: false, // necessary for css styles
  methods: {
    resize: function resize() {
      if (this.$panoObject) {
        google.maps.event.trigger(this.$panoObject, 'resize');
      }
    }
  },

  provide: function provide() {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _this.$panoPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$panoPromise': promise,
      '$mapPromise': promise // so that we can use it with markers
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.position && typeof this.position.lat === 'function' ? this.position.lat() : this.position.lat;
    },
    finalLng: function finalLng() {
      return this.position && typeof this.position.lng === 'function' ? this.position.lng() : this.position.lng;
    },
    finalLatLng: function finalLatLng() {
      return {
        lat: this.finalLat,
        lng: this.finalLng
      };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$panoObject) {
        this.$panoObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-street-view-pano'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;

      _this2.$panoObject = new google.maps.StreetViewPanorama(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$panoObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$panoObject, events);

      // manually trigger position
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        // Panos take a while to load
        increment();

        _this2.$panoObject.addListener('position_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('position_changed', _this2.$panoObject.getPosition());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$panoObject.setPosition(_this2.finalLatLng);
        });
      });

      _this2.$panoPromiseDeferred.resolve(_this2.$panoObject);

      return _this2.$panoPromise;
    }).catch(function (error) {
      throw error;
    });
  }
};

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isApiSetUp = false;

/**
 * @param apiKey    API Key, or object with the URL parameters. For example
 *                  to use Google Maps Premium API, pass
 *                    `{ client: <YOUR-CLIENT-ID> }`.
 *                  You may pass the libraries and/or version (as `v`) parameter into
 *                  this parameter and skip the next two parameters
 * @param version   Google Maps version
 * @param libraries Libraries to load (@see
 *                  https://developers.google.com/maps/documentation/javascript/libraries)
 * @param loadCn    Boolean. If set to true, the map will be loaded from google maps China
 *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
 *
 * Example:
 * ```
 *      import {load} from 'vue-google-maps'
 *
 *      load(<YOUR-API-KEY>)
 *
 *      load({
 *              key: <YOUR-API-KEY>,
 *      })
 *
 *      load({
 *              client: <YOUR-CLIENT-ID>,
 *              channel: <YOUR CHANNEL>
 *      })
 * ```
 */
var loadGmapApi = exports.loadGmapApi = function (options, loadCn) {
  if (typeof document === 'undefined') {
    // Do nothing if run from server-side
    return;
  }
  if (!isApiSetUp) {
    isApiSetUp = true;

    var googleMapScript = document.createElement('SCRIPT');

    // Allow options to be an object.
    // This is to support more esoteric means of loading Google Maps,
    // such as Google for business
    // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      throw new Error('options should  be an object');
    }

    // libraries
    if (Array.prototype.isPrototypeOf(options.libraries)) {
      options.libraries = options.libraries.join(',');
    }
    options['callback'] = 'vueGoogleMapsInit';

    var baseUrl = 'https://maps.googleapis.com/';

    if (typeof loadCn === 'boolean' && loadCn === true) {
      baseUrl = 'https://maps.google.cn/';
    }

    var url = baseUrl + 'maps/api/js?' + Object.keys(options).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(options[key]);
    }).join('&');

    googleMapScript.setAttribute('src', url);
    googleMapScript.setAttribute('async', '');
    googleMapScript.setAttribute('defer', '');
    document.head.appendChild(googleMapScript);
  } else {
    throw new Error('You already started the loading of google maps');
  }
};

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by sindresorhus and can be seen here
// https://github.com/sindresorhus/lazy-value/blob/master/index.js

exports.default = function (fn) {
  var called = false;
  var ret = void 0;

  return function () {
    if (!called) {
      called = true;
      ret = fn();
    }

    return ret;
  };
};

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = (function (element, listener) {
	var expand = document.createElement('_');
	var shrink = expand.appendChild(document.createElement('_'));
	var expandChild = expand.appendChild(document.createElement('_'));
	var shrinkChild = shrink.appendChild(document.createElement('_'));

	var lastWidth = void 0,
	    lastHeight = void 0;

	shrink.style.cssText = expand.style.cssText = 'height:100%;left:0;opacity:0;overflow:hidden;pointer-events:none;position:absolute;top:0;transition:0s;width:100%;z-index:-1';
	shrinkChild.style.cssText = expandChild.style.cssText = 'display:block;height:100%;transition:0s;width:100%';
	shrinkChild.style.width = shrinkChild.style.height = '200%';

	element.appendChild(expand);

	test();

	return stop;

	function test() {
		unbind();

		var width = element.offsetWidth;
		var height = element.offsetHeight;

		if (width !== lastWidth || height !== lastHeight) {
			lastWidth = width;
			lastHeight = height;

			expandChild.style.width = width * 2 + 'px';
			expandChild.style.height = height * 2 + 'px';

			expand.scrollLeft = expand.scrollWidth;
			expand.scrollTop = expand.scrollHeight;
			shrink.scrollLeft = shrink.scrollWidth;
			shrink.scrollTop = shrink.scrollHeight;

			listener({ width: width, height: height });
		}

		shrink.addEventListener('scroll', test);
		expand.addEventListener('scroll', test);
	}

	function unbind() {
		shrink.removeEventListener('scroll', test);
		expand.removeEventListener('scroll', test);
	}

	function stop() {
		unbind();

		element.removeChild(expand);
	}
});

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(635);
module.exports = __webpack_require__(634);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js